
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired102"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired102"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6JwYZ", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $4e7087b41df6f188$export$ffb0004e005737fa; }, function (v) { return $4e7087b41df6f188$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $4e7087b41df6f188$export$34b9dba7ce09269b; }, function (v) { return $4e7087b41df6f188$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $4e7087b41df6f188$export$25062201e9e25d76; }, function (v) { return $4e7087b41df6f188$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4e7087b41df6f188$export$ffb0004e005737fa;
var $4e7087b41df6f188$export$34b9dba7ce09269b;
var $4e7087b41df6f188$export$25062201e9e25d76;
"use strict";

var $fgmOP = parcelRequire("fgmOP");
var $4e7087b41df6f188$var$k = Symbol.for("react.element"), $4e7087b41df6f188$var$l = Symbol.for("react.fragment"), $4e7087b41df6f188$var$m = Object.prototype.hasOwnProperty, $4e7087b41df6f188$var$n = $fgmOP.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $4e7087b41df6f188$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $4e7087b41df6f188$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$4e7087b41df6f188$var$m.call(a, b) && !$4e7087b41df6f188$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $4e7087b41df6f188$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $4e7087b41df6f188$var$n.current
    };
}
$4e7087b41df6f188$export$ffb0004e005737fa = $4e7087b41df6f188$var$l;
$4e7087b41df6f188$export$34b9dba7ce09269b = $4e7087b41df6f188$var$q;
$4e7087b41df6f188$export$25062201e9e25d76 = $4e7087b41df6f188$var$q;

});
parcelRegister("fgmOP", function(module, exports) {
"use strict";

module.exports = (parcelRequire("G6AQ3"));

});
parcelRegister("G6AQ3", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $07e909a006f05606$export$dca3b0875bd9a954; }, function (v) { return $07e909a006f05606$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $07e909a006f05606$export$16fa2f45be04daa8; }, function (v) { return $07e909a006f05606$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $07e909a006f05606$export$ffb0004e005737fa; }, function (v) { return $07e909a006f05606$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $07e909a006f05606$export$e2c29f18771995cb; }, function (v) { return $07e909a006f05606$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $07e909a006f05606$export$221d75b3f55bb0bd; }, function (v) { return $07e909a006f05606$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $07e909a006f05606$export$5f8d39834fd61797; }, function (v) { return $07e909a006f05606$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $07e909a006f05606$export$74bf444e3cd11ea5; }, function (v) { return $07e909a006f05606$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $07e909a006f05606$export$ae55be85d98224ed; }, function (v) { return $07e909a006f05606$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $07e909a006f05606$export$e530037191fcd5d7; }, function (v) { return $07e909a006f05606$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $07e909a006f05606$export$fd42f52fd3ae1109; }, function (v) { return $07e909a006f05606$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $07e909a006f05606$export$c8a8987d4410bf2d; }, function (v) { return $07e909a006f05606$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $07e909a006f05606$export$d38cd72104c1f0e9; }, function (v) { return $07e909a006f05606$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $07e909a006f05606$export$7d1e3a5e95ceca43; }, function (v) { return $07e909a006f05606$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $07e909a006f05606$export$257a8862b851cb5b; }, function (v) { return $07e909a006f05606$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $07e909a006f05606$export$a8257692ac88316c; }, function (v) { return $07e909a006f05606$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $07e909a006f05606$export$488013bae63b21da; }, function (v) { return $07e909a006f05606$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $07e909a006f05606$export$7c73462e0d25e514; }, function (v) { return $07e909a006f05606$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $07e909a006f05606$export$7568632d0d33d16d; }, function (v) { return $07e909a006f05606$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $07e909a006f05606$export$88948ce120ea2619; }, function (v) { return $07e909a006f05606$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $07e909a006f05606$export$35808ee640e87ca7; }, function (v) { return $07e909a006f05606$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $07e909a006f05606$export$fae74005e78b1a27; }, function (v) { return $07e909a006f05606$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $07e909a006f05606$export$dc8fbce3eb94dc1e; }, function (v) { return $07e909a006f05606$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $07e909a006f05606$export$6a7bc4e911dc01cf; }, function (v) { return $07e909a006f05606$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $07e909a006f05606$export$6d9c69b0de29b591; }, function (v) { return $07e909a006f05606$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $07e909a006f05606$export$f680877a34711e37; }, function (v) { return $07e909a006f05606$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $07e909a006f05606$export$d5a552a76deda3c2; }, function (v) { return $07e909a006f05606$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $07e909a006f05606$export$aaabe4eda9ed9969; }, function (v) { return $07e909a006f05606$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $07e909a006f05606$export$e5c5a5f917a5871c; }, function (v) { return $07e909a006f05606$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $07e909a006f05606$export$1538c33de8887b59; }, function (v) { return $07e909a006f05606$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $07e909a006f05606$export$13e3392192263954; }, function (v) { return $07e909a006f05606$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $07e909a006f05606$export$b8f5890fc79d6aca; }, function (v) { return $07e909a006f05606$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $07e909a006f05606$export$60241385465d0a34; }, function (v) { return $07e909a006f05606$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $07e909a006f05606$export$306c0aa65ff9ec16; }, function (v) { return $07e909a006f05606$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $07e909a006f05606$export$7b286972b8d8ccbf; }, function (v) { return $07e909a006f05606$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $07e909a006f05606$export$83d89fbfd8236492; }, function (v) { return $07e909a006f05606$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $07e909a006f05606$export$dca3b0875bd9a954;
var $07e909a006f05606$export$16fa2f45be04daa8;
var $07e909a006f05606$export$ffb0004e005737fa;
var $07e909a006f05606$export$e2c29f18771995cb;
var $07e909a006f05606$export$221d75b3f55bb0bd;
var $07e909a006f05606$export$5f8d39834fd61797;
var $07e909a006f05606$export$74bf444e3cd11ea5;
var $07e909a006f05606$export$ae55be85d98224ed;
var $07e909a006f05606$export$e530037191fcd5d7;
var $07e909a006f05606$export$fd42f52fd3ae1109;
var $07e909a006f05606$export$c8a8987d4410bf2d;
var $07e909a006f05606$export$d38cd72104c1f0e9;
var $07e909a006f05606$export$7d1e3a5e95ceca43;
var $07e909a006f05606$export$257a8862b851cb5b;
var $07e909a006f05606$export$a8257692ac88316c;
var $07e909a006f05606$export$488013bae63b21da;
var $07e909a006f05606$export$7c73462e0d25e514;
var $07e909a006f05606$export$7568632d0d33d16d;
var $07e909a006f05606$export$88948ce120ea2619;
var $07e909a006f05606$export$35808ee640e87ca7;
var $07e909a006f05606$export$fae74005e78b1a27;
var $07e909a006f05606$export$dc8fbce3eb94dc1e;
var $07e909a006f05606$export$6a7bc4e911dc01cf;
var $07e909a006f05606$export$6d9c69b0de29b591;
var $07e909a006f05606$export$f680877a34711e37;
var $07e909a006f05606$export$d5a552a76deda3c2;
var $07e909a006f05606$export$aaabe4eda9ed9969;
var $07e909a006f05606$export$e5c5a5f917a5871c;
var $07e909a006f05606$export$1538c33de8887b59;
var $07e909a006f05606$export$13e3392192263954;
var $07e909a006f05606$export$b8f5890fc79d6aca;
var $07e909a006f05606$export$60241385465d0a34;
var $07e909a006f05606$export$306c0aa65ff9ec16;
var $07e909a006f05606$export$7b286972b8d8ccbf;
var $07e909a006f05606$export$83d89fbfd8236492;
"use strict";
var $07e909a006f05606$var$l = Symbol.for("react.element"), $07e909a006f05606$var$n = Symbol.for("react.portal"), $07e909a006f05606$var$p = Symbol.for("react.fragment"), $07e909a006f05606$var$q = Symbol.for("react.strict_mode"), $07e909a006f05606$var$r = Symbol.for("react.profiler"), $07e909a006f05606$var$t = Symbol.for("react.provider"), $07e909a006f05606$var$u = Symbol.for("react.context"), $07e909a006f05606$var$v = Symbol.for("react.forward_ref"), $07e909a006f05606$var$w = Symbol.for("react.suspense"), $07e909a006f05606$var$x = Symbol.for("react.memo"), $07e909a006f05606$var$y = Symbol.for("react.lazy"), $07e909a006f05606$var$z = Symbol.iterator;
function $07e909a006f05606$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $07e909a006f05606$var$z && a[$07e909a006f05606$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $07e909a006f05606$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $07e909a006f05606$var$C = Object.assign, $07e909a006f05606$var$D = {};
function $07e909a006f05606$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $07e909a006f05606$var$D;
    this.updater = e || $07e909a006f05606$var$B;
}
$07e909a006f05606$var$E.prototype.isReactComponent = {};
$07e909a006f05606$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$07e909a006f05606$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $07e909a006f05606$var$F() {}
$07e909a006f05606$var$F.prototype = $07e909a006f05606$var$E.prototype;
function $07e909a006f05606$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $07e909a006f05606$var$D;
    this.updater = e || $07e909a006f05606$var$B;
}
var $07e909a006f05606$var$H = $07e909a006f05606$var$G.prototype = new $07e909a006f05606$var$F;
$07e909a006f05606$var$H.constructor = $07e909a006f05606$var$G;
$07e909a006f05606$var$C($07e909a006f05606$var$H, $07e909a006f05606$var$E.prototype);
$07e909a006f05606$var$H.isPureReactComponent = !0;
var $07e909a006f05606$var$I = Array.isArray, $07e909a006f05606$var$J = Object.prototype.hasOwnProperty, $07e909a006f05606$var$K = {
    current: null
}, $07e909a006f05606$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $07e909a006f05606$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$07e909a006f05606$var$J.call(b, d) && !$07e909a006f05606$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $07e909a006f05606$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $07e909a006f05606$var$K.current
    };
}
function $07e909a006f05606$var$N(a, b) {
    return {
        $$typeof: $07e909a006f05606$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $07e909a006f05606$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $07e909a006f05606$var$l;
}
function $07e909a006f05606$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $07e909a006f05606$var$P = /\/+/g;
function $07e909a006f05606$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $07e909a006f05606$var$escape("" + a.key) : b.toString(36);
}
function $07e909a006f05606$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $07e909a006f05606$var$l:
                case $07e909a006f05606$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $07e909a006f05606$var$Q(h, 0) : d, $07e909a006f05606$var$I(c) ? (e = "", null != a && (e = a.replace($07e909a006f05606$var$P, "$&/") + "/"), $07e909a006f05606$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($07e909a006f05606$var$O(c) && (c = $07e909a006f05606$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($07e909a006f05606$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($07e909a006f05606$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $07e909a006f05606$var$Q(k, g);
        h += $07e909a006f05606$var$R(k, b, e, f, c);
    }
    else if (f = $07e909a006f05606$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $07e909a006f05606$var$Q(k, g++), h += $07e909a006f05606$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $07e909a006f05606$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $07e909a006f05606$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $07e909a006f05606$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $07e909a006f05606$var$U = {
    current: null
}, $07e909a006f05606$var$V = {
    transition: null
}, $07e909a006f05606$var$W = {
    ReactCurrentDispatcher: $07e909a006f05606$var$U,
    ReactCurrentBatchConfig: $07e909a006f05606$var$V,
    ReactCurrentOwner: $07e909a006f05606$var$K
};
$07e909a006f05606$export$dca3b0875bd9a954 = {
    map: $07e909a006f05606$var$S,
    forEach: function(a, b, e) {
        $07e909a006f05606$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $07e909a006f05606$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $07e909a006f05606$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$07e909a006f05606$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$07e909a006f05606$export$16fa2f45be04daa8 = $07e909a006f05606$var$E;
$07e909a006f05606$export$ffb0004e005737fa = $07e909a006f05606$var$p;
$07e909a006f05606$export$e2c29f18771995cb = $07e909a006f05606$var$r;
$07e909a006f05606$export$221d75b3f55bb0bd = $07e909a006f05606$var$G;
$07e909a006f05606$export$5f8d39834fd61797 = $07e909a006f05606$var$q;
$07e909a006f05606$export$74bf444e3cd11ea5 = $07e909a006f05606$var$w;
$07e909a006f05606$export$ae55be85d98224ed = $07e909a006f05606$var$W;
$07e909a006f05606$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $07e909a006f05606$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $07e909a006f05606$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$07e909a006f05606$var$J.call(b, f) && !$07e909a006f05606$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $07e909a006f05606$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$07e909a006f05606$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $07e909a006f05606$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $07e909a006f05606$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$07e909a006f05606$export$c8a8987d4410bf2d = $07e909a006f05606$var$M;
$07e909a006f05606$export$d38cd72104c1f0e9 = function(a) {
    var b = $07e909a006f05606$var$M.bind(null, a);
    b.type = a;
    return b;
};
$07e909a006f05606$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$07e909a006f05606$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $07e909a006f05606$var$v,
        render: a
    };
};
$07e909a006f05606$export$a8257692ac88316c = $07e909a006f05606$var$O;
$07e909a006f05606$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $07e909a006f05606$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $07e909a006f05606$var$T
    };
};
$07e909a006f05606$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $07e909a006f05606$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$07e909a006f05606$export$7568632d0d33d16d = function(a) {
    var b = $07e909a006f05606$var$V.transition;
    $07e909a006f05606$var$V.transition = {};
    try {
        a();
    } finally{
        $07e909a006f05606$var$V.transition = b;
    }
};
$07e909a006f05606$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$07e909a006f05606$export$35808ee640e87ca7 = function(a, b) {
    return $07e909a006f05606$var$U.current.useCallback(a, b);
};
$07e909a006f05606$export$fae74005e78b1a27 = function(a) {
    return $07e909a006f05606$var$U.current.useContext(a);
};
$07e909a006f05606$export$dc8fbce3eb94dc1e = function() {};
$07e909a006f05606$export$6a7bc4e911dc01cf = function(a) {
    return $07e909a006f05606$var$U.current.useDeferredValue(a);
};
$07e909a006f05606$export$6d9c69b0de29b591 = function(a, b) {
    return $07e909a006f05606$var$U.current.useEffect(a, b);
};
$07e909a006f05606$export$f680877a34711e37 = function() {
    return $07e909a006f05606$var$U.current.useId();
};
$07e909a006f05606$export$d5a552a76deda3c2 = function(a, b, e) {
    return $07e909a006f05606$var$U.current.useImperativeHandle(a, b, e);
};
$07e909a006f05606$export$aaabe4eda9ed9969 = function(a, b) {
    return $07e909a006f05606$var$U.current.useInsertionEffect(a, b);
};
$07e909a006f05606$export$e5c5a5f917a5871c = function(a, b) {
    return $07e909a006f05606$var$U.current.useLayoutEffect(a, b);
};
$07e909a006f05606$export$1538c33de8887b59 = function(a, b) {
    return $07e909a006f05606$var$U.current.useMemo(a, b);
};
$07e909a006f05606$export$13e3392192263954 = function(a, b, e) {
    return $07e909a006f05606$var$U.current.useReducer(a, b, e);
};
$07e909a006f05606$export$b8f5890fc79d6aca = function(a) {
    return $07e909a006f05606$var$U.current.useRef(a);
};
$07e909a006f05606$export$60241385465d0a34 = function(a) {
    return $07e909a006f05606$var$U.current.useState(a);
};
$07e909a006f05606$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $07e909a006f05606$var$U.current.useSyncExternalStore(a, b, e);
};
$07e909a006f05606$export$7b286972b8d8ccbf = function() {
    return $07e909a006f05606$var$U.current.useTransition();
};
$07e909a006f05606$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("7XNLQ", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $5cc4a686f46e8a12$export$ae55be85d98224ed; }, function (v) { return $5cc4a686f46e8a12$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $5cc4a686f46e8a12$export$d39a5bbd09211389; }, function (v) { return $5cc4a686f46e8a12$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $5cc4a686f46e8a12$export$882461b6382ed46c; }, function (v) { return $5cc4a686f46e8a12$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $5cc4a686f46e8a12$export$466bfc07425424d5; }, function (v) { return $5cc4a686f46e8a12$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $5cc4a686f46e8a12$export$cd75ccfd720a3cd4; }, function (v) { return $5cc4a686f46e8a12$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $5cc4a686f46e8a12$export$fa8d919ba61d84db; }, function (v) { return $5cc4a686f46e8a12$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $5cc4a686f46e8a12$export$757ceba2d55c277e; }, function (v) { return $5cc4a686f46e8a12$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $5cc4a686f46e8a12$export$b3890eb0ae9dca99; }, function (v) { return $5cc4a686f46e8a12$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $5cc4a686f46e8a12$export$502457920280e6be; }, function (v) { return $5cc4a686f46e8a12$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $5cc4a686f46e8a12$export$c78a37762a8d58e1; }, function (v) { return $5cc4a686f46e8a12$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $5cc4a686f46e8a12$export$dc54d992c10e8a18; }, function (v) { return $5cc4a686f46e8a12$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $5cc4a686f46e8a12$export$83d89fbfd8236492; }, function (v) { return $5cc4a686f46e8a12$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $5cc4a686f46e8a12$export$ae55be85d98224ed;
var $5cc4a686f46e8a12$export$d39a5bbd09211389;
var $5cc4a686f46e8a12$export$882461b6382ed46c;
var $5cc4a686f46e8a12$export$466bfc07425424d5;
var $5cc4a686f46e8a12$export$cd75ccfd720a3cd4;
var $5cc4a686f46e8a12$export$fa8d919ba61d84db;
var $5cc4a686f46e8a12$export$757ceba2d55c277e;
var $5cc4a686f46e8a12$export$b3890eb0ae9dca99;
var $5cc4a686f46e8a12$export$502457920280e6be;
var $5cc4a686f46e8a12$export$c78a37762a8d58e1;
var $5cc4a686f46e8a12$export$dc54d992c10e8a18;
var $5cc4a686f46e8a12$export$83d89fbfd8236492;
"use strict";

var $fgmOP = parcelRequire("fgmOP");

var $1oHYN = parcelRequire("1oHYN");
function $5cc4a686f46e8a12$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $5cc4a686f46e8a12$var$da = new Set, $5cc4a686f46e8a12$var$ea = {};
function $5cc4a686f46e8a12$var$fa(a, b) {
    $5cc4a686f46e8a12$var$ha(a, b);
    $5cc4a686f46e8a12$var$ha(a + "Capture", b);
}
function $5cc4a686f46e8a12$var$ha(a, b) {
    $5cc4a686f46e8a12$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$5cc4a686f46e8a12$var$da.add(b[a]);
}
var $5cc4a686f46e8a12$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $5cc4a686f46e8a12$var$ja = Object.prototype.hasOwnProperty, $5cc4a686f46e8a12$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $5cc4a686f46e8a12$var$la = {}, $5cc4a686f46e8a12$var$ma = {};
function $5cc4a686f46e8a12$var$oa(a) {
    if ($5cc4a686f46e8a12$var$ja.call($5cc4a686f46e8a12$var$ma, a)) return !0;
    if ($5cc4a686f46e8a12$var$ja.call($5cc4a686f46e8a12$var$la, a)) return !1;
    if ($5cc4a686f46e8a12$var$ka.test(a)) return $5cc4a686f46e8a12$var$ma[a] = !0;
    $5cc4a686f46e8a12$var$la[a] = !0;
    return !1;
}
function $5cc4a686f46e8a12$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $5cc4a686f46e8a12$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $5cc4a686f46e8a12$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $5cc4a686f46e8a12$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $5cc4a686f46e8a12$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $5cc4a686f46e8a12$var$z[a] = new $5cc4a686f46e8a12$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $5cc4a686f46e8a12$var$z[b] = new $5cc4a686f46e8a12$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $5cc4a686f46e8a12$var$z[a] = new $5cc4a686f46e8a12$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $5cc4a686f46e8a12$var$z[a] = new $5cc4a686f46e8a12$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $5cc4a686f46e8a12$var$z[a] = new $5cc4a686f46e8a12$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $5cc4a686f46e8a12$var$z[a] = new $5cc4a686f46e8a12$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $5cc4a686f46e8a12$var$z[a] = new $5cc4a686f46e8a12$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $5cc4a686f46e8a12$var$z[a] = new $5cc4a686f46e8a12$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $5cc4a686f46e8a12$var$z[a] = new $5cc4a686f46e8a12$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $5cc4a686f46e8a12$var$ra = /[\-:]([a-z])/g;
function $5cc4a686f46e8a12$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($5cc4a686f46e8a12$var$ra, $5cc4a686f46e8a12$var$sa);
    $5cc4a686f46e8a12$var$z[b] = new $5cc4a686f46e8a12$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($5cc4a686f46e8a12$var$ra, $5cc4a686f46e8a12$var$sa);
    $5cc4a686f46e8a12$var$z[b] = new $5cc4a686f46e8a12$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($5cc4a686f46e8a12$var$ra, $5cc4a686f46e8a12$var$sa);
    $5cc4a686f46e8a12$var$z[b] = new $5cc4a686f46e8a12$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $5cc4a686f46e8a12$var$z[a] = new $5cc4a686f46e8a12$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$5cc4a686f46e8a12$var$z.xlinkHref = new $5cc4a686f46e8a12$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $5cc4a686f46e8a12$var$z[a] = new $5cc4a686f46e8a12$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $5cc4a686f46e8a12$var$ta(a, b, c, d) {
    var e = $5cc4a686f46e8a12$var$z.hasOwnProperty(b) ? $5cc4a686f46e8a12$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $5cc4a686f46e8a12$var$qa(b, c, e, d) && (c = null), d || null === e ? $5cc4a686f46e8a12$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $5cc4a686f46e8a12$var$ua = $fgmOP.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $5cc4a686f46e8a12$var$va = Symbol.for("react.element"), $5cc4a686f46e8a12$var$wa = Symbol.for("react.portal"), $5cc4a686f46e8a12$var$ya = Symbol.for("react.fragment"), $5cc4a686f46e8a12$var$za = Symbol.for("react.strict_mode"), $5cc4a686f46e8a12$var$Aa = Symbol.for("react.profiler"), $5cc4a686f46e8a12$var$Ba = Symbol.for("react.provider"), $5cc4a686f46e8a12$var$Ca = Symbol.for("react.context"), $5cc4a686f46e8a12$var$Da = Symbol.for("react.forward_ref"), $5cc4a686f46e8a12$var$Ea = Symbol.for("react.suspense"), $5cc4a686f46e8a12$var$Fa = Symbol.for("react.suspense_list"), $5cc4a686f46e8a12$var$Ga = Symbol.for("react.memo"), $5cc4a686f46e8a12$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $5cc4a686f46e8a12$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $5cc4a686f46e8a12$var$Ja = Symbol.iterator;
function $5cc4a686f46e8a12$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $5cc4a686f46e8a12$var$Ja && a[$5cc4a686f46e8a12$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $5cc4a686f46e8a12$var$A = Object.assign, $5cc4a686f46e8a12$var$La;
function $5cc4a686f46e8a12$var$Ma(a) {
    if (void 0 === $5cc4a686f46e8a12$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $5cc4a686f46e8a12$var$La = b && b[1] || "";
    }
    return "\n" + $5cc4a686f46e8a12$var$La + a;
}
var $5cc4a686f46e8a12$var$Na = !1;
function $5cc4a686f46e8a12$var$Oa(a, b) {
    if (!a || $5cc4a686f46e8a12$var$Na) return "";
    $5cc4a686f46e8a12$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $5cc4a686f46e8a12$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $5cc4a686f46e8a12$var$Ma(a) : "";
}
function $5cc4a686f46e8a12$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $5cc4a686f46e8a12$var$Ma(a.type);
        case 16:
            return $5cc4a686f46e8a12$var$Ma("Lazy");
        case 13:
            return $5cc4a686f46e8a12$var$Ma("Suspense");
        case 19:
            return $5cc4a686f46e8a12$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $5cc4a686f46e8a12$var$Oa(a.type, !1), a;
        case 11:
            return a = $5cc4a686f46e8a12$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $5cc4a686f46e8a12$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $5cc4a686f46e8a12$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $5cc4a686f46e8a12$var$ya:
            return "Fragment";
        case $5cc4a686f46e8a12$var$wa:
            return "Portal";
        case $5cc4a686f46e8a12$var$Aa:
            return "Profiler";
        case $5cc4a686f46e8a12$var$za:
            return "StrictMode";
        case $5cc4a686f46e8a12$var$Ea:
            return "Suspense";
        case $5cc4a686f46e8a12$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $5cc4a686f46e8a12$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $5cc4a686f46e8a12$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $5cc4a686f46e8a12$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $5cc4a686f46e8a12$var$Ga:
            return b = a.displayName || null, null !== b ? b : $5cc4a686f46e8a12$var$Qa(a.type) || "Memo";
        case $5cc4a686f46e8a12$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $5cc4a686f46e8a12$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $5cc4a686f46e8a12$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $5cc4a686f46e8a12$var$Qa(b);
        case 8:
            return b === $5cc4a686f46e8a12$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $5cc4a686f46e8a12$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $5cc4a686f46e8a12$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $5cc4a686f46e8a12$var$Ua(a) {
    var b = $5cc4a686f46e8a12$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $5cc4a686f46e8a12$var$Va(a) {
    a._valueTracker || (a._valueTracker = $5cc4a686f46e8a12$var$Ua(a));
}
function $5cc4a686f46e8a12$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $5cc4a686f46e8a12$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $5cc4a686f46e8a12$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $5cc4a686f46e8a12$var$Ya(a, b) {
    var c = b.checked;
    return $5cc4a686f46e8a12$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $5cc4a686f46e8a12$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $5cc4a686f46e8a12$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $5cc4a686f46e8a12$var$ab(a, b) {
    b = b.checked;
    null != b && $5cc4a686f46e8a12$var$ta(a, "checked", b, !1);
}
function $5cc4a686f46e8a12$var$bb(a, b) {
    $5cc4a686f46e8a12$var$ab(a, b);
    var c = $5cc4a686f46e8a12$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $5cc4a686f46e8a12$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $5cc4a686f46e8a12$var$cb(a, b.type, $5cc4a686f46e8a12$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $5cc4a686f46e8a12$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $5cc4a686f46e8a12$var$cb(a, b, c) {
    if ("number" !== b || $5cc4a686f46e8a12$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $5cc4a686f46e8a12$var$eb = Array.isArray;
function $5cc4a686f46e8a12$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $5cc4a686f46e8a12$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $5cc4a686f46e8a12$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($5cc4a686f46e8a12$var$p(91));
    return $5cc4a686f46e8a12$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $5cc4a686f46e8a12$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($5cc4a686f46e8a12$var$p(92));
            if ($5cc4a686f46e8a12$var$eb(c)) {
                if (1 < c.length) throw Error($5cc4a686f46e8a12$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $5cc4a686f46e8a12$var$Sa(c)
    };
}
function $5cc4a686f46e8a12$var$ib(a, b) {
    var c = $5cc4a686f46e8a12$var$Sa(b.value), d = $5cc4a686f46e8a12$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $5cc4a686f46e8a12$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $5cc4a686f46e8a12$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $5cc4a686f46e8a12$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $5cc4a686f46e8a12$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $5cc4a686f46e8a12$var$mb, $5cc4a686f46e8a12$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $5cc4a686f46e8a12$var$mb = $5cc4a686f46e8a12$var$mb || document.createElement("div");
        $5cc4a686f46e8a12$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $5cc4a686f46e8a12$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $5cc4a686f46e8a12$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $5cc4a686f46e8a12$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $5cc4a686f46e8a12$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($5cc4a686f46e8a12$var$pb).forEach(function(a) {
    $5cc4a686f46e8a12$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $5cc4a686f46e8a12$var$pb[b] = $5cc4a686f46e8a12$var$pb[a];
    });
});
function $5cc4a686f46e8a12$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $5cc4a686f46e8a12$var$pb.hasOwnProperty(a) && $5cc4a686f46e8a12$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $5cc4a686f46e8a12$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $5cc4a686f46e8a12$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $5cc4a686f46e8a12$var$tb = $5cc4a686f46e8a12$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $5cc4a686f46e8a12$var$ub(a, b) {
    if (b) {
        if ($5cc4a686f46e8a12$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($5cc4a686f46e8a12$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($5cc4a686f46e8a12$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($5cc4a686f46e8a12$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($5cc4a686f46e8a12$var$p(62));
    }
}
function $5cc4a686f46e8a12$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $5cc4a686f46e8a12$var$wb = null;
function $5cc4a686f46e8a12$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $5cc4a686f46e8a12$var$yb = null, $5cc4a686f46e8a12$var$zb = null, $5cc4a686f46e8a12$var$Ab = null;
function $5cc4a686f46e8a12$var$Bb(a) {
    if (a = $5cc4a686f46e8a12$var$Cb(a)) {
        if ("function" !== typeof $5cc4a686f46e8a12$var$yb) throw Error($5cc4a686f46e8a12$var$p(280));
        var b = a.stateNode;
        b && (b = $5cc4a686f46e8a12$var$Db(b), $5cc4a686f46e8a12$var$yb(a.stateNode, a.type, b));
    }
}
function $5cc4a686f46e8a12$var$Eb(a) {
    $5cc4a686f46e8a12$var$zb ? $5cc4a686f46e8a12$var$Ab ? $5cc4a686f46e8a12$var$Ab.push(a) : $5cc4a686f46e8a12$var$Ab = [
        a
    ] : $5cc4a686f46e8a12$var$zb = a;
}
function $5cc4a686f46e8a12$var$Fb() {
    if ($5cc4a686f46e8a12$var$zb) {
        var a = $5cc4a686f46e8a12$var$zb, b = $5cc4a686f46e8a12$var$Ab;
        $5cc4a686f46e8a12$var$Ab = $5cc4a686f46e8a12$var$zb = null;
        $5cc4a686f46e8a12$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$5cc4a686f46e8a12$var$Bb(b[a]);
    }
}
function $5cc4a686f46e8a12$var$Gb(a, b) {
    return a(b);
}
function $5cc4a686f46e8a12$var$Hb() {}
var $5cc4a686f46e8a12$var$Ib = !1;
function $5cc4a686f46e8a12$var$Jb(a, b, c) {
    if ($5cc4a686f46e8a12$var$Ib) return a(b, c);
    $5cc4a686f46e8a12$var$Ib = !0;
    try {
        return $5cc4a686f46e8a12$var$Gb(a, b, c);
    } finally{
        if ($5cc4a686f46e8a12$var$Ib = !1, null !== $5cc4a686f46e8a12$var$zb || null !== $5cc4a686f46e8a12$var$Ab) $5cc4a686f46e8a12$var$Hb(), $5cc4a686f46e8a12$var$Fb();
    }
}
function $5cc4a686f46e8a12$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $5cc4a686f46e8a12$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($5cc4a686f46e8a12$var$p(231, b, typeof c));
    return c;
}
var $5cc4a686f46e8a12$var$Lb = !1;
if ($5cc4a686f46e8a12$var$ia) try {
    var $5cc4a686f46e8a12$var$Mb = {};
    Object.defineProperty($5cc4a686f46e8a12$var$Mb, "passive", {
        get: function() {
            $5cc4a686f46e8a12$var$Lb = !0;
        }
    });
    window.addEventListener("test", $5cc4a686f46e8a12$var$Mb, $5cc4a686f46e8a12$var$Mb);
    window.removeEventListener("test", $5cc4a686f46e8a12$var$Mb, $5cc4a686f46e8a12$var$Mb);
} catch (a) {
    $5cc4a686f46e8a12$var$Lb = !1;
}
function $5cc4a686f46e8a12$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $5cc4a686f46e8a12$var$Ob = !1, $5cc4a686f46e8a12$var$Pb = null, $5cc4a686f46e8a12$var$Qb = !1, $5cc4a686f46e8a12$var$Rb = null, $5cc4a686f46e8a12$var$Sb = {
    onError: function(a) {
        $5cc4a686f46e8a12$var$Ob = !0;
        $5cc4a686f46e8a12$var$Pb = a;
    }
};
function $5cc4a686f46e8a12$var$Tb(a, b, c, d, e, f, g, h, k) {
    $5cc4a686f46e8a12$var$Ob = !1;
    $5cc4a686f46e8a12$var$Pb = null;
    $5cc4a686f46e8a12$var$Nb.apply($5cc4a686f46e8a12$var$Sb, arguments);
}
function $5cc4a686f46e8a12$var$Ub(a, b, c, d, e, f, g, h, k) {
    $5cc4a686f46e8a12$var$Tb.apply(this, arguments);
    if ($5cc4a686f46e8a12$var$Ob) {
        if ($5cc4a686f46e8a12$var$Ob) {
            var l = $5cc4a686f46e8a12$var$Pb;
            $5cc4a686f46e8a12$var$Ob = !1;
            $5cc4a686f46e8a12$var$Pb = null;
        } else throw Error($5cc4a686f46e8a12$var$p(198));
        $5cc4a686f46e8a12$var$Qb || ($5cc4a686f46e8a12$var$Qb = !0, $5cc4a686f46e8a12$var$Rb = l);
    }
}
function $5cc4a686f46e8a12$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $5cc4a686f46e8a12$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $5cc4a686f46e8a12$var$Xb(a) {
    if ($5cc4a686f46e8a12$var$Vb(a) !== a) throw Error($5cc4a686f46e8a12$var$p(188));
}
function $5cc4a686f46e8a12$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $5cc4a686f46e8a12$var$Vb(a);
        if (null === b) throw Error($5cc4a686f46e8a12$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $5cc4a686f46e8a12$var$Xb(e), a;
                if (f === d) return $5cc4a686f46e8a12$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($5cc4a686f46e8a12$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($5cc4a686f46e8a12$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($5cc4a686f46e8a12$var$p(190));
    }
    if (3 !== c.tag) throw Error($5cc4a686f46e8a12$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $5cc4a686f46e8a12$var$Zb(a) {
    a = $5cc4a686f46e8a12$var$Yb(a);
    return null !== a ? $5cc4a686f46e8a12$var$$b(a) : null;
}
function $5cc4a686f46e8a12$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $5cc4a686f46e8a12$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $5cc4a686f46e8a12$var$ac = $1oHYN.unstable_scheduleCallback, $5cc4a686f46e8a12$var$bc = $1oHYN.unstable_cancelCallback, $5cc4a686f46e8a12$var$cc = $1oHYN.unstable_shouldYield, $5cc4a686f46e8a12$var$dc = $1oHYN.unstable_requestPaint, $5cc4a686f46e8a12$var$B = $1oHYN.unstable_now, $5cc4a686f46e8a12$var$ec = $1oHYN.unstable_getCurrentPriorityLevel, $5cc4a686f46e8a12$var$fc = $1oHYN.unstable_ImmediatePriority, $5cc4a686f46e8a12$var$gc = $1oHYN.unstable_UserBlockingPriority, $5cc4a686f46e8a12$var$hc = $1oHYN.unstable_NormalPriority, $5cc4a686f46e8a12$var$ic = $1oHYN.unstable_LowPriority, $5cc4a686f46e8a12$var$jc = $1oHYN.unstable_IdlePriority, $5cc4a686f46e8a12$var$kc = null, $5cc4a686f46e8a12$var$lc = null;
function $5cc4a686f46e8a12$var$mc(a) {
    if ($5cc4a686f46e8a12$var$lc && "function" === typeof $5cc4a686f46e8a12$var$lc.onCommitFiberRoot) try {
        $5cc4a686f46e8a12$var$lc.onCommitFiberRoot($5cc4a686f46e8a12$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $5cc4a686f46e8a12$var$oc = Math.clz32 ? Math.clz32 : $5cc4a686f46e8a12$var$nc, $5cc4a686f46e8a12$var$pc = Math.log, $5cc4a686f46e8a12$var$qc = Math.LN2;
function $5cc4a686f46e8a12$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($5cc4a686f46e8a12$var$pc(a) / $5cc4a686f46e8a12$var$qc | 0) | 0;
}
var $5cc4a686f46e8a12$var$rc = 64, $5cc4a686f46e8a12$var$sc = 4194304;
function $5cc4a686f46e8a12$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $5cc4a686f46e8a12$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $5cc4a686f46e8a12$var$tc(h) : (f &= g, 0 !== f && (d = $5cc4a686f46e8a12$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $5cc4a686f46e8a12$var$tc(g) : 0 !== f && (d = $5cc4a686f46e8a12$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $5cc4a686f46e8a12$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $5cc4a686f46e8a12$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $5cc4a686f46e8a12$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $5cc4a686f46e8a12$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $5cc4a686f46e8a12$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $5cc4a686f46e8a12$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $5cc4a686f46e8a12$var$yc() {
    var a = $5cc4a686f46e8a12$var$rc;
    $5cc4a686f46e8a12$var$rc <<= 1;
    0 === ($5cc4a686f46e8a12$var$rc & 4194240) && ($5cc4a686f46e8a12$var$rc = 64);
    return a;
}
function $5cc4a686f46e8a12$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $5cc4a686f46e8a12$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $5cc4a686f46e8a12$var$oc(b);
    a[b] = c;
}
function $5cc4a686f46e8a12$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $5cc4a686f46e8a12$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $5cc4a686f46e8a12$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $5cc4a686f46e8a12$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $5cc4a686f46e8a12$var$C = 0;
function $5cc4a686f46e8a12$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $5cc4a686f46e8a12$var$Ec, $5cc4a686f46e8a12$var$Fc, $5cc4a686f46e8a12$var$Gc, $5cc4a686f46e8a12$var$Hc, $5cc4a686f46e8a12$var$Ic, $5cc4a686f46e8a12$var$Jc = !1, $5cc4a686f46e8a12$var$Kc = [], $5cc4a686f46e8a12$var$Lc = null, $5cc4a686f46e8a12$var$Mc = null, $5cc4a686f46e8a12$var$Nc = null, $5cc4a686f46e8a12$var$Oc = new Map, $5cc4a686f46e8a12$var$Pc = new Map, $5cc4a686f46e8a12$var$Qc = [], $5cc4a686f46e8a12$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $5cc4a686f46e8a12$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $5cc4a686f46e8a12$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $5cc4a686f46e8a12$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $5cc4a686f46e8a12$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $5cc4a686f46e8a12$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $5cc4a686f46e8a12$var$Pc.delete(b.pointerId);
    }
}
function $5cc4a686f46e8a12$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $5cc4a686f46e8a12$var$Cb(b), null !== b && $5cc4a686f46e8a12$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $5cc4a686f46e8a12$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $5cc4a686f46e8a12$var$Lc = $5cc4a686f46e8a12$var$Tc($5cc4a686f46e8a12$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $5cc4a686f46e8a12$var$Mc = $5cc4a686f46e8a12$var$Tc($5cc4a686f46e8a12$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $5cc4a686f46e8a12$var$Nc = $5cc4a686f46e8a12$var$Tc($5cc4a686f46e8a12$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $5cc4a686f46e8a12$var$Oc.set(f, $5cc4a686f46e8a12$var$Tc($5cc4a686f46e8a12$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $5cc4a686f46e8a12$var$Pc.set(f, $5cc4a686f46e8a12$var$Tc($5cc4a686f46e8a12$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $5cc4a686f46e8a12$var$Vc(a) {
    var b = $5cc4a686f46e8a12$var$Wc(a.target);
    if (null !== b) {
        var c = $5cc4a686f46e8a12$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $5cc4a686f46e8a12$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $5cc4a686f46e8a12$var$Ic(a.priority, function() {
                        $5cc4a686f46e8a12$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $5cc4a686f46e8a12$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $5cc4a686f46e8a12$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $5cc4a686f46e8a12$var$wb = d;
            c.target.dispatchEvent(d);
            $5cc4a686f46e8a12$var$wb = null;
        } else return b = $5cc4a686f46e8a12$var$Cb(c), null !== b && $5cc4a686f46e8a12$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $5cc4a686f46e8a12$var$Zc(a, b, c) {
    $5cc4a686f46e8a12$var$Xc(a) && c.delete(b);
}
function $5cc4a686f46e8a12$var$$c() {
    $5cc4a686f46e8a12$var$Jc = !1;
    null !== $5cc4a686f46e8a12$var$Lc && $5cc4a686f46e8a12$var$Xc($5cc4a686f46e8a12$var$Lc) && ($5cc4a686f46e8a12$var$Lc = null);
    null !== $5cc4a686f46e8a12$var$Mc && $5cc4a686f46e8a12$var$Xc($5cc4a686f46e8a12$var$Mc) && ($5cc4a686f46e8a12$var$Mc = null);
    null !== $5cc4a686f46e8a12$var$Nc && $5cc4a686f46e8a12$var$Xc($5cc4a686f46e8a12$var$Nc) && ($5cc4a686f46e8a12$var$Nc = null);
    $5cc4a686f46e8a12$var$Oc.forEach($5cc4a686f46e8a12$var$Zc);
    $5cc4a686f46e8a12$var$Pc.forEach($5cc4a686f46e8a12$var$Zc);
}
function $5cc4a686f46e8a12$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $5cc4a686f46e8a12$var$Jc || ($5cc4a686f46e8a12$var$Jc = !0, $1oHYN.unstable_scheduleCallback($1oHYN.unstable_NormalPriority, $5cc4a686f46e8a12$var$$c)));
}
function $5cc4a686f46e8a12$var$bd(a) {
    function b(b) {
        return $5cc4a686f46e8a12$var$ad(b, a);
    }
    if (0 < $5cc4a686f46e8a12$var$Kc.length) {
        $5cc4a686f46e8a12$var$ad($5cc4a686f46e8a12$var$Kc[0], a);
        for(var c = 1; c < $5cc4a686f46e8a12$var$Kc.length; c++){
            var d = $5cc4a686f46e8a12$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $5cc4a686f46e8a12$var$Lc && $5cc4a686f46e8a12$var$ad($5cc4a686f46e8a12$var$Lc, a);
    null !== $5cc4a686f46e8a12$var$Mc && $5cc4a686f46e8a12$var$ad($5cc4a686f46e8a12$var$Mc, a);
    null !== $5cc4a686f46e8a12$var$Nc && $5cc4a686f46e8a12$var$ad($5cc4a686f46e8a12$var$Nc, a);
    $5cc4a686f46e8a12$var$Oc.forEach(b);
    $5cc4a686f46e8a12$var$Pc.forEach(b);
    for(c = 0; c < $5cc4a686f46e8a12$var$Qc.length; c++)d = $5cc4a686f46e8a12$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $5cc4a686f46e8a12$var$Qc.length && (c = $5cc4a686f46e8a12$var$Qc[0], null === c.blockedOn);)$5cc4a686f46e8a12$var$Vc(c), null === c.blockedOn && $5cc4a686f46e8a12$var$Qc.shift();
}
var $5cc4a686f46e8a12$var$cd = $5cc4a686f46e8a12$var$ua.ReactCurrentBatchConfig, $5cc4a686f46e8a12$var$dd = !0;
function $5cc4a686f46e8a12$var$ed(a, b, c, d) {
    var e = $5cc4a686f46e8a12$var$C, f = $5cc4a686f46e8a12$var$cd.transition;
    $5cc4a686f46e8a12$var$cd.transition = null;
    try {
        $5cc4a686f46e8a12$var$C = 1, $5cc4a686f46e8a12$var$fd(a, b, c, d);
    } finally{
        $5cc4a686f46e8a12$var$C = e, $5cc4a686f46e8a12$var$cd.transition = f;
    }
}
function $5cc4a686f46e8a12$var$gd(a, b, c, d) {
    var e = $5cc4a686f46e8a12$var$C, f = $5cc4a686f46e8a12$var$cd.transition;
    $5cc4a686f46e8a12$var$cd.transition = null;
    try {
        $5cc4a686f46e8a12$var$C = 4, $5cc4a686f46e8a12$var$fd(a, b, c, d);
    } finally{
        $5cc4a686f46e8a12$var$C = e, $5cc4a686f46e8a12$var$cd.transition = f;
    }
}
function $5cc4a686f46e8a12$var$fd(a, b, c, d) {
    if ($5cc4a686f46e8a12$var$dd) {
        var e = $5cc4a686f46e8a12$var$Yc(a, b, c, d);
        if (null === e) $5cc4a686f46e8a12$var$hd(a, b, d, $5cc4a686f46e8a12$var$id, c), $5cc4a686f46e8a12$var$Sc(a, d);
        else if ($5cc4a686f46e8a12$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($5cc4a686f46e8a12$var$Sc(a, d), b & 4 && -1 < $5cc4a686f46e8a12$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $5cc4a686f46e8a12$var$Cb(e);
                null !== f && $5cc4a686f46e8a12$var$Ec(f);
                f = $5cc4a686f46e8a12$var$Yc(a, b, c, d);
                null === f && $5cc4a686f46e8a12$var$hd(a, b, d, $5cc4a686f46e8a12$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $5cc4a686f46e8a12$var$hd(a, b, d, null, c);
    }
}
var $5cc4a686f46e8a12$var$id = null;
function $5cc4a686f46e8a12$var$Yc(a, b, c, d) {
    $5cc4a686f46e8a12$var$id = null;
    a = $5cc4a686f46e8a12$var$xb(d);
    a = $5cc4a686f46e8a12$var$Wc(a);
    if (null !== a) {
        if (b = $5cc4a686f46e8a12$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $5cc4a686f46e8a12$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $5cc4a686f46e8a12$var$id = a;
    return null;
}
function $5cc4a686f46e8a12$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($5cc4a686f46e8a12$var$ec()){
                case $5cc4a686f46e8a12$var$fc:
                    return 1;
                case $5cc4a686f46e8a12$var$gc:
                    return 4;
                case $5cc4a686f46e8a12$var$hc:
                case $5cc4a686f46e8a12$var$ic:
                    return 16;
                case $5cc4a686f46e8a12$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $5cc4a686f46e8a12$var$kd = null, $5cc4a686f46e8a12$var$ld = null, $5cc4a686f46e8a12$var$md = null;
function $5cc4a686f46e8a12$var$nd() {
    if ($5cc4a686f46e8a12$var$md) return $5cc4a686f46e8a12$var$md;
    var a, b = $5cc4a686f46e8a12$var$ld, c = b.length, d, e = "value" in $5cc4a686f46e8a12$var$kd ? $5cc4a686f46e8a12$var$kd.value : $5cc4a686f46e8a12$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $5cc4a686f46e8a12$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $5cc4a686f46e8a12$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $5cc4a686f46e8a12$var$pd() {
    return !0;
}
function $5cc4a686f46e8a12$var$qd() {
    return !1;
}
function $5cc4a686f46e8a12$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $5cc4a686f46e8a12$var$pd : $5cc4a686f46e8a12$var$qd;
        this.isPropagationStopped = $5cc4a686f46e8a12$var$qd;
        return this;
    }
    $5cc4a686f46e8a12$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $5cc4a686f46e8a12$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $5cc4a686f46e8a12$var$pd);
        },
        persist: function() {},
        isPersistent: $5cc4a686f46e8a12$var$pd
    });
    return b;
}
var $5cc4a686f46e8a12$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $5cc4a686f46e8a12$var$td = $5cc4a686f46e8a12$var$rd($5cc4a686f46e8a12$var$sd), $5cc4a686f46e8a12$var$ud = $5cc4a686f46e8a12$var$A({}, $5cc4a686f46e8a12$var$sd, {
    view: 0,
    detail: 0
}), $5cc4a686f46e8a12$var$vd = $5cc4a686f46e8a12$var$rd($5cc4a686f46e8a12$var$ud), $5cc4a686f46e8a12$var$wd, $5cc4a686f46e8a12$var$xd, $5cc4a686f46e8a12$var$yd, $5cc4a686f46e8a12$var$Ad = $5cc4a686f46e8a12$var$A({}, $5cc4a686f46e8a12$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $5cc4a686f46e8a12$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $5cc4a686f46e8a12$var$yd && ($5cc4a686f46e8a12$var$yd && "mousemove" === a.type ? ($5cc4a686f46e8a12$var$wd = a.screenX - $5cc4a686f46e8a12$var$yd.screenX, $5cc4a686f46e8a12$var$xd = a.screenY - $5cc4a686f46e8a12$var$yd.screenY) : $5cc4a686f46e8a12$var$xd = $5cc4a686f46e8a12$var$wd = 0, $5cc4a686f46e8a12$var$yd = a);
        return $5cc4a686f46e8a12$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $5cc4a686f46e8a12$var$xd;
    }
}), $5cc4a686f46e8a12$var$Bd = $5cc4a686f46e8a12$var$rd($5cc4a686f46e8a12$var$Ad), $5cc4a686f46e8a12$var$Cd = $5cc4a686f46e8a12$var$A({}, $5cc4a686f46e8a12$var$Ad, {
    dataTransfer: 0
}), $5cc4a686f46e8a12$var$Dd = $5cc4a686f46e8a12$var$rd($5cc4a686f46e8a12$var$Cd), $5cc4a686f46e8a12$var$Ed = $5cc4a686f46e8a12$var$A({}, $5cc4a686f46e8a12$var$ud, {
    relatedTarget: 0
}), $5cc4a686f46e8a12$var$Fd = $5cc4a686f46e8a12$var$rd($5cc4a686f46e8a12$var$Ed), $5cc4a686f46e8a12$var$Gd = $5cc4a686f46e8a12$var$A({}, $5cc4a686f46e8a12$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $5cc4a686f46e8a12$var$Hd = $5cc4a686f46e8a12$var$rd($5cc4a686f46e8a12$var$Gd), $5cc4a686f46e8a12$var$Id = $5cc4a686f46e8a12$var$A({}, $5cc4a686f46e8a12$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $5cc4a686f46e8a12$var$Jd = $5cc4a686f46e8a12$var$rd($5cc4a686f46e8a12$var$Id), $5cc4a686f46e8a12$var$Kd = $5cc4a686f46e8a12$var$A({}, $5cc4a686f46e8a12$var$sd, {
    data: 0
}), $5cc4a686f46e8a12$var$Ld = $5cc4a686f46e8a12$var$rd($5cc4a686f46e8a12$var$Kd), $5cc4a686f46e8a12$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $5cc4a686f46e8a12$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $5cc4a686f46e8a12$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $5cc4a686f46e8a12$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $5cc4a686f46e8a12$var$Od[a]) ? !!b[a] : !1;
}
function $5cc4a686f46e8a12$var$zd() {
    return $5cc4a686f46e8a12$var$Pd;
}
var $5cc4a686f46e8a12$var$Qd = $5cc4a686f46e8a12$var$A({}, $5cc4a686f46e8a12$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $5cc4a686f46e8a12$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $5cc4a686f46e8a12$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $5cc4a686f46e8a12$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $5cc4a686f46e8a12$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $5cc4a686f46e8a12$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $5cc4a686f46e8a12$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $5cc4a686f46e8a12$var$Rd = $5cc4a686f46e8a12$var$rd($5cc4a686f46e8a12$var$Qd), $5cc4a686f46e8a12$var$Sd = $5cc4a686f46e8a12$var$A({}, $5cc4a686f46e8a12$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $5cc4a686f46e8a12$var$Td = $5cc4a686f46e8a12$var$rd($5cc4a686f46e8a12$var$Sd), $5cc4a686f46e8a12$var$Ud = $5cc4a686f46e8a12$var$A({}, $5cc4a686f46e8a12$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $5cc4a686f46e8a12$var$zd
}), $5cc4a686f46e8a12$var$Vd = $5cc4a686f46e8a12$var$rd($5cc4a686f46e8a12$var$Ud), $5cc4a686f46e8a12$var$Wd = $5cc4a686f46e8a12$var$A({}, $5cc4a686f46e8a12$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $5cc4a686f46e8a12$var$Xd = $5cc4a686f46e8a12$var$rd($5cc4a686f46e8a12$var$Wd), $5cc4a686f46e8a12$var$Yd = $5cc4a686f46e8a12$var$A({}, $5cc4a686f46e8a12$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $5cc4a686f46e8a12$var$Zd = $5cc4a686f46e8a12$var$rd($5cc4a686f46e8a12$var$Yd), $5cc4a686f46e8a12$var$$d = [
    9,
    13,
    27,
    32
], $5cc4a686f46e8a12$var$ae = $5cc4a686f46e8a12$var$ia && "CompositionEvent" in window, $5cc4a686f46e8a12$var$be = null;
$5cc4a686f46e8a12$var$ia && "documentMode" in document && ($5cc4a686f46e8a12$var$be = document.documentMode);
var $5cc4a686f46e8a12$var$ce = $5cc4a686f46e8a12$var$ia && "TextEvent" in window && !$5cc4a686f46e8a12$var$be, $5cc4a686f46e8a12$var$de = $5cc4a686f46e8a12$var$ia && (!$5cc4a686f46e8a12$var$ae || $5cc4a686f46e8a12$var$be && 8 < $5cc4a686f46e8a12$var$be && 11 >= $5cc4a686f46e8a12$var$be), $5cc4a686f46e8a12$var$ee = String.fromCharCode(32), $5cc4a686f46e8a12$var$fe = !1;
function $5cc4a686f46e8a12$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $5cc4a686f46e8a12$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $5cc4a686f46e8a12$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $5cc4a686f46e8a12$var$ie = !1;
function $5cc4a686f46e8a12$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $5cc4a686f46e8a12$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $5cc4a686f46e8a12$var$fe = !0;
            return $5cc4a686f46e8a12$var$ee;
        case "textInput":
            return a = b.data, a === $5cc4a686f46e8a12$var$ee && $5cc4a686f46e8a12$var$fe ? null : a;
        default:
            return null;
    }
}
function $5cc4a686f46e8a12$var$ke(a, b) {
    if ($5cc4a686f46e8a12$var$ie) return "compositionend" === a || !$5cc4a686f46e8a12$var$ae && $5cc4a686f46e8a12$var$ge(a, b) ? (a = $5cc4a686f46e8a12$var$nd(), $5cc4a686f46e8a12$var$md = $5cc4a686f46e8a12$var$ld = $5cc4a686f46e8a12$var$kd = null, $5cc4a686f46e8a12$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $5cc4a686f46e8a12$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $5cc4a686f46e8a12$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $5cc4a686f46e8a12$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$5cc4a686f46e8a12$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $5cc4a686f46e8a12$var$ne(a, b, c, d) {
    $5cc4a686f46e8a12$var$Eb(d);
    b = $5cc4a686f46e8a12$var$oe(b, "onChange");
    0 < b.length && (c = new $5cc4a686f46e8a12$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $5cc4a686f46e8a12$var$pe = null, $5cc4a686f46e8a12$var$qe = null;
function $5cc4a686f46e8a12$var$re(a) {
    $5cc4a686f46e8a12$var$se(a, 0);
}
function $5cc4a686f46e8a12$var$te(a) {
    var b = $5cc4a686f46e8a12$var$ue(a);
    if ($5cc4a686f46e8a12$var$Wa(b)) return a;
}
function $5cc4a686f46e8a12$var$ve(a, b) {
    if ("change" === a) return b;
}
var $5cc4a686f46e8a12$var$we = !1;
if ($5cc4a686f46e8a12$var$ia) {
    var $5cc4a686f46e8a12$var$xe;
    if ($5cc4a686f46e8a12$var$ia) {
        var $5cc4a686f46e8a12$var$ye = "oninput" in document;
        if (!$5cc4a686f46e8a12$var$ye) {
            var $5cc4a686f46e8a12$var$ze = document.createElement("div");
            $5cc4a686f46e8a12$var$ze.setAttribute("oninput", "return;");
            $5cc4a686f46e8a12$var$ye = "function" === typeof $5cc4a686f46e8a12$var$ze.oninput;
        }
        $5cc4a686f46e8a12$var$xe = $5cc4a686f46e8a12$var$ye;
    } else $5cc4a686f46e8a12$var$xe = !1;
    $5cc4a686f46e8a12$var$we = $5cc4a686f46e8a12$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $5cc4a686f46e8a12$var$Ae() {
    $5cc4a686f46e8a12$var$pe && ($5cc4a686f46e8a12$var$pe.detachEvent("onpropertychange", $5cc4a686f46e8a12$var$Be), $5cc4a686f46e8a12$var$qe = $5cc4a686f46e8a12$var$pe = null);
}
function $5cc4a686f46e8a12$var$Be(a) {
    if ("value" === a.propertyName && $5cc4a686f46e8a12$var$te($5cc4a686f46e8a12$var$qe)) {
        var b = [];
        $5cc4a686f46e8a12$var$ne(b, $5cc4a686f46e8a12$var$qe, a, $5cc4a686f46e8a12$var$xb(a));
        $5cc4a686f46e8a12$var$Jb($5cc4a686f46e8a12$var$re, b);
    }
}
function $5cc4a686f46e8a12$var$Ce(a, b, c) {
    "focusin" === a ? ($5cc4a686f46e8a12$var$Ae(), $5cc4a686f46e8a12$var$pe = b, $5cc4a686f46e8a12$var$qe = c, $5cc4a686f46e8a12$var$pe.attachEvent("onpropertychange", $5cc4a686f46e8a12$var$Be)) : "focusout" === a && $5cc4a686f46e8a12$var$Ae();
}
function $5cc4a686f46e8a12$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $5cc4a686f46e8a12$var$te($5cc4a686f46e8a12$var$qe);
}
function $5cc4a686f46e8a12$var$Ee(a, b) {
    if ("click" === a) return $5cc4a686f46e8a12$var$te(b);
}
function $5cc4a686f46e8a12$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $5cc4a686f46e8a12$var$te(b);
}
function $5cc4a686f46e8a12$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $5cc4a686f46e8a12$var$He = "function" === typeof Object.is ? Object.is : $5cc4a686f46e8a12$var$Ge;
function $5cc4a686f46e8a12$var$Ie(a, b) {
    if ($5cc4a686f46e8a12$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$5cc4a686f46e8a12$var$ja.call(b, e) || !$5cc4a686f46e8a12$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $5cc4a686f46e8a12$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $5cc4a686f46e8a12$var$Ke(a, b) {
    var c = $5cc4a686f46e8a12$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $5cc4a686f46e8a12$var$Je(c);
    }
}
function $5cc4a686f46e8a12$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $5cc4a686f46e8a12$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $5cc4a686f46e8a12$var$Me() {
    for(var a = window, b = $5cc4a686f46e8a12$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $5cc4a686f46e8a12$var$Xa(a.document);
    }
    return b;
}
function $5cc4a686f46e8a12$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $5cc4a686f46e8a12$var$Oe(a) {
    var b = $5cc4a686f46e8a12$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $5cc4a686f46e8a12$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $5cc4a686f46e8a12$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $5cc4a686f46e8a12$var$Ke(c, f);
                var g = $5cc4a686f46e8a12$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $5cc4a686f46e8a12$var$Pe = $5cc4a686f46e8a12$var$ia && "documentMode" in document && 11 >= document.documentMode, $5cc4a686f46e8a12$var$Qe = null, $5cc4a686f46e8a12$var$Re = null, $5cc4a686f46e8a12$var$Se = null, $5cc4a686f46e8a12$var$Te = !1;
function $5cc4a686f46e8a12$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $5cc4a686f46e8a12$var$Te || null == $5cc4a686f46e8a12$var$Qe || $5cc4a686f46e8a12$var$Qe !== $5cc4a686f46e8a12$var$Xa(d) || (d = $5cc4a686f46e8a12$var$Qe, "selectionStart" in d && $5cc4a686f46e8a12$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $5cc4a686f46e8a12$var$Se && $5cc4a686f46e8a12$var$Ie($5cc4a686f46e8a12$var$Se, d) || ($5cc4a686f46e8a12$var$Se = d, d = $5cc4a686f46e8a12$var$oe($5cc4a686f46e8a12$var$Re, "onSelect"), 0 < d.length && (b = new $5cc4a686f46e8a12$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $5cc4a686f46e8a12$var$Qe)));
}
function $5cc4a686f46e8a12$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $5cc4a686f46e8a12$var$We = {
    animationend: $5cc4a686f46e8a12$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $5cc4a686f46e8a12$var$Ve("Animation", "AnimationIteration"),
    animationstart: $5cc4a686f46e8a12$var$Ve("Animation", "AnimationStart"),
    transitionend: $5cc4a686f46e8a12$var$Ve("Transition", "TransitionEnd")
}, $5cc4a686f46e8a12$var$Xe = {}, $5cc4a686f46e8a12$var$Ye = {};
$5cc4a686f46e8a12$var$ia && ($5cc4a686f46e8a12$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $5cc4a686f46e8a12$var$We.animationend.animation, delete $5cc4a686f46e8a12$var$We.animationiteration.animation, delete $5cc4a686f46e8a12$var$We.animationstart.animation), "TransitionEvent" in window || delete $5cc4a686f46e8a12$var$We.transitionend.transition);
function $5cc4a686f46e8a12$var$Ze(a) {
    if ($5cc4a686f46e8a12$var$Xe[a]) return $5cc4a686f46e8a12$var$Xe[a];
    if (!$5cc4a686f46e8a12$var$We[a]) return a;
    var b = $5cc4a686f46e8a12$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $5cc4a686f46e8a12$var$Ye) return $5cc4a686f46e8a12$var$Xe[a] = b[c];
    return a;
}
var $5cc4a686f46e8a12$var$$e = $5cc4a686f46e8a12$var$Ze("animationend"), $5cc4a686f46e8a12$var$af = $5cc4a686f46e8a12$var$Ze("animationiteration"), $5cc4a686f46e8a12$var$bf = $5cc4a686f46e8a12$var$Ze("animationstart"), $5cc4a686f46e8a12$var$cf = $5cc4a686f46e8a12$var$Ze("transitionend"), $5cc4a686f46e8a12$var$df = new Map, $5cc4a686f46e8a12$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $5cc4a686f46e8a12$var$ff(a, b) {
    $5cc4a686f46e8a12$var$df.set(a, b);
    $5cc4a686f46e8a12$var$fa(b, [
        a
    ]);
}
for(var $5cc4a686f46e8a12$var$gf = 0; $5cc4a686f46e8a12$var$gf < $5cc4a686f46e8a12$var$ef.length; $5cc4a686f46e8a12$var$gf++){
    var $5cc4a686f46e8a12$var$hf = $5cc4a686f46e8a12$var$ef[$5cc4a686f46e8a12$var$gf], $5cc4a686f46e8a12$var$jf = $5cc4a686f46e8a12$var$hf.toLowerCase(), $5cc4a686f46e8a12$var$kf = $5cc4a686f46e8a12$var$hf[0].toUpperCase() + $5cc4a686f46e8a12$var$hf.slice(1);
    $5cc4a686f46e8a12$var$ff($5cc4a686f46e8a12$var$jf, "on" + $5cc4a686f46e8a12$var$kf);
}
$5cc4a686f46e8a12$var$ff($5cc4a686f46e8a12$var$$e, "onAnimationEnd");
$5cc4a686f46e8a12$var$ff($5cc4a686f46e8a12$var$af, "onAnimationIteration");
$5cc4a686f46e8a12$var$ff($5cc4a686f46e8a12$var$bf, "onAnimationStart");
$5cc4a686f46e8a12$var$ff("dblclick", "onDoubleClick");
$5cc4a686f46e8a12$var$ff("focusin", "onFocus");
$5cc4a686f46e8a12$var$ff("focusout", "onBlur");
$5cc4a686f46e8a12$var$ff($5cc4a686f46e8a12$var$cf, "onTransitionEnd");
$5cc4a686f46e8a12$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$5cc4a686f46e8a12$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$5cc4a686f46e8a12$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$5cc4a686f46e8a12$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$5cc4a686f46e8a12$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$5cc4a686f46e8a12$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$5cc4a686f46e8a12$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$5cc4a686f46e8a12$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$5cc4a686f46e8a12$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$5cc4a686f46e8a12$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $5cc4a686f46e8a12$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $5cc4a686f46e8a12$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($5cc4a686f46e8a12$var$lf));
function $5cc4a686f46e8a12$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $5cc4a686f46e8a12$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $5cc4a686f46e8a12$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $5cc4a686f46e8a12$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $5cc4a686f46e8a12$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($5cc4a686f46e8a12$var$Qb) throw a = $5cc4a686f46e8a12$var$Rb, $5cc4a686f46e8a12$var$Qb = !1, $5cc4a686f46e8a12$var$Rb = null, a;
}
function $5cc4a686f46e8a12$var$D(a, b) {
    var c = b[$5cc4a686f46e8a12$var$of];
    void 0 === c && (c = b[$5cc4a686f46e8a12$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($5cc4a686f46e8a12$var$pf(b, a, 2, !1), c.add(d));
}
function $5cc4a686f46e8a12$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $5cc4a686f46e8a12$var$pf(c, a, d, b);
}
var $5cc4a686f46e8a12$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $5cc4a686f46e8a12$var$sf(a) {
    if (!a[$5cc4a686f46e8a12$var$rf]) {
        a[$5cc4a686f46e8a12$var$rf] = !0;
        $5cc4a686f46e8a12$var$da.forEach(function(b) {
            "selectionchange" !== b && ($5cc4a686f46e8a12$var$mf.has(b) || $5cc4a686f46e8a12$var$qf(b, !1, a), $5cc4a686f46e8a12$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$5cc4a686f46e8a12$var$rf] || (b[$5cc4a686f46e8a12$var$rf] = !0, $5cc4a686f46e8a12$var$qf("selectionchange", !1, b));
    }
}
function $5cc4a686f46e8a12$var$pf(a, b, c, d) {
    switch($5cc4a686f46e8a12$var$jd(b)){
        case 1:
            var e = $5cc4a686f46e8a12$var$ed;
            break;
        case 4:
            e = $5cc4a686f46e8a12$var$gd;
            break;
        default:
            e = $5cc4a686f46e8a12$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$5cc4a686f46e8a12$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $5cc4a686f46e8a12$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $5cc4a686f46e8a12$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $5cc4a686f46e8a12$var$Jb(function() {
        var d = f, e = $5cc4a686f46e8a12$var$xb(c), g = [];
        a: {
            var h = $5cc4a686f46e8a12$var$df.get(a);
            if (void 0 !== h) {
                var k = $5cc4a686f46e8a12$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $5cc4a686f46e8a12$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $5cc4a686f46e8a12$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $5cc4a686f46e8a12$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $5cc4a686f46e8a12$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $5cc4a686f46e8a12$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $5cc4a686f46e8a12$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $5cc4a686f46e8a12$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $5cc4a686f46e8a12$var$Vd;
                        break;
                    case $5cc4a686f46e8a12$var$$e:
                    case $5cc4a686f46e8a12$var$af:
                    case $5cc4a686f46e8a12$var$bf:
                        k = $5cc4a686f46e8a12$var$Hd;
                        break;
                    case $5cc4a686f46e8a12$var$cf:
                        k = $5cc4a686f46e8a12$var$Xd;
                        break;
                    case "scroll":
                        k = $5cc4a686f46e8a12$var$vd;
                        break;
                    case "wheel":
                        k = $5cc4a686f46e8a12$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $5cc4a686f46e8a12$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $5cc4a686f46e8a12$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $5cc4a686f46e8a12$var$Kb(w, x), null != F && t.push($5cc4a686f46e8a12$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $5cc4a686f46e8a12$var$wb && (n = c.relatedTarget || c.fromElement) && ($5cc4a686f46e8a12$var$Wc(n) || n[$5cc4a686f46e8a12$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $5cc4a686f46e8a12$var$Wc(n) : null, null !== n && (J = $5cc4a686f46e8a12$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $5cc4a686f46e8a12$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $5cc4a686f46e8a12$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $5cc4a686f46e8a12$var$ue(k);
                        u = null == n ? h : $5cc4a686f46e8a12$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $5cc4a686f46e8a12$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $5cc4a686f46e8a12$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $5cc4a686f46e8a12$var$vf(F))u++;
                            for(; 0 < w - u;)t = $5cc4a686f46e8a12$var$vf(t), w--;
                            for(; 0 < u - w;)x = $5cc4a686f46e8a12$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $5cc4a686f46e8a12$var$vf(t);
                                x = $5cc4a686f46e8a12$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $5cc4a686f46e8a12$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $5cc4a686f46e8a12$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $5cc4a686f46e8a12$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $5cc4a686f46e8a12$var$ve;
                else if ($5cc4a686f46e8a12$var$me(h)) {
                    if ($5cc4a686f46e8a12$var$we) na = $5cc4a686f46e8a12$var$Fe;
                    else {
                        na = $5cc4a686f46e8a12$var$De;
                        var xa = $5cc4a686f46e8a12$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $5cc4a686f46e8a12$var$Ee);
                if (na && (na = na(a, d))) {
                    $5cc4a686f46e8a12$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $5cc4a686f46e8a12$var$cb(h, "number", h.value);
            }
            xa = d ? $5cc4a686f46e8a12$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($5cc4a686f46e8a12$var$me(xa) || "true" === xa.contentEditable) $5cc4a686f46e8a12$var$Qe = xa, $5cc4a686f46e8a12$var$Re = d, $5cc4a686f46e8a12$var$Se = null;
                    break;
                case "focusout":
                    $5cc4a686f46e8a12$var$Se = $5cc4a686f46e8a12$var$Re = $5cc4a686f46e8a12$var$Qe = null;
                    break;
                case "mousedown":
                    $5cc4a686f46e8a12$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $5cc4a686f46e8a12$var$Te = !1;
                    $5cc4a686f46e8a12$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($5cc4a686f46e8a12$var$Pe) break;
                case "keydown":
                case "keyup":
                    $5cc4a686f46e8a12$var$Ue(g, c, e);
            }
            var $a;
            if ($5cc4a686f46e8a12$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $5cc4a686f46e8a12$var$ie ? $5cc4a686f46e8a12$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($5cc4a686f46e8a12$var$de && "ko" !== c.locale && ($5cc4a686f46e8a12$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $5cc4a686f46e8a12$var$ie && ($a = $5cc4a686f46e8a12$var$nd()) : ($5cc4a686f46e8a12$var$kd = e, $5cc4a686f46e8a12$var$ld = "value" in $5cc4a686f46e8a12$var$kd ? $5cc4a686f46e8a12$var$kd.value : $5cc4a686f46e8a12$var$kd.textContent, $5cc4a686f46e8a12$var$ie = !0)), xa = $5cc4a686f46e8a12$var$oe(d, ba), 0 < xa.length && (ba = new $5cc4a686f46e8a12$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $5cc4a686f46e8a12$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $5cc4a686f46e8a12$var$ce ? $5cc4a686f46e8a12$var$je(a, c) : $5cc4a686f46e8a12$var$ke(a, c)) d = $5cc4a686f46e8a12$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $5cc4a686f46e8a12$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $5cc4a686f46e8a12$var$se(g, b);
    });
}
function $5cc4a686f46e8a12$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $5cc4a686f46e8a12$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $5cc4a686f46e8a12$var$Kb(a, c), null != f && d.unshift($5cc4a686f46e8a12$var$tf(a, f, e)), f = $5cc4a686f46e8a12$var$Kb(a, b), null != f && d.push($5cc4a686f46e8a12$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $5cc4a686f46e8a12$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $5cc4a686f46e8a12$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $5cc4a686f46e8a12$var$Kb(c, f), null != k && g.unshift($5cc4a686f46e8a12$var$tf(c, k, h))) : e || (k = $5cc4a686f46e8a12$var$Kb(c, f), null != k && g.push($5cc4a686f46e8a12$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $5cc4a686f46e8a12$var$xf = /\r\n?/g, $5cc4a686f46e8a12$var$yf = /\u0000|\uFFFD/g;
function $5cc4a686f46e8a12$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($5cc4a686f46e8a12$var$xf, "\n").replace($5cc4a686f46e8a12$var$yf, "");
}
function $5cc4a686f46e8a12$var$Af(a, b, c) {
    b = $5cc4a686f46e8a12$var$zf(b);
    if ($5cc4a686f46e8a12$var$zf(a) !== b && c) throw Error($5cc4a686f46e8a12$var$p(425));
}
function $5cc4a686f46e8a12$var$Bf() {}
var $5cc4a686f46e8a12$var$Cf = null, $5cc4a686f46e8a12$var$Df = null;
function $5cc4a686f46e8a12$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $5cc4a686f46e8a12$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $5cc4a686f46e8a12$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $5cc4a686f46e8a12$var$Hf = "function" === typeof Promise ? Promise : void 0, $5cc4a686f46e8a12$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $5cc4a686f46e8a12$var$Hf ? function(a) {
    return $5cc4a686f46e8a12$var$Hf.resolve(null).then(a).catch($5cc4a686f46e8a12$var$If);
} : $5cc4a686f46e8a12$var$Ff;
function $5cc4a686f46e8a12$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $5cc4a686f46e8a12$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $5cc4a686f46e8a12$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $5cc4a686f46e8a12$var$bd(b);
}
function $5cc4a686f46e8a12$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $5cc4a686f46e8a12$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $5cc4a686f46e8a12$var$Nf = Math.random().toString(36).slice(2), $5cc4a686f46e8a12$var$Of = "__reactFiber$" + $5cc4a686f46e8a12$var$Nf, $5cc4a686f46e8a12$var$Pf = "__reactProps$" + $5cc4a686f46e8a12$var$Nf, $5cc4a686f46e8a12$var$uf = "__reactContainer$" + $5cc4a686f46e8a12$var$Nf, $5cc4a686f46e8a12$var$of = "__reactEvents$" + $5cc4a686f46e8a12$var$Nf, $5cc4a686f46e8a12$var$Qf = "__reactListeners$" + $5cc4a686f46e8a12$var$Nf, $5cc4a686f46e8a12$var$Rf = "__reactHandles$" + $5cc4a686f46e8a12$var$Nf;
function $5cc4a686f46e8a12$var$Wc(a) {
    var b = a[$5cc4a686f46e8a12$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$5cc4a686f46e8a12$var$uf] || c[$5cc4a686f46e8a12$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $5cc4a686f46e8a12$var$Mf(a); null !== a;){
                if (c = a[$5cc4a686f46e8a12$var$Of]) return c;
                a = $5cc4a686f46e8a12$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $5cc4a686f46e8a12$var$Cb(a) {
    a = a[$5cc4a686f46e8a12$var$Of] || a[$5cc4a686f46e8a12$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $5cc4a686f46e8a12$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($5cc4a686f46e8a12$var$p(33));
}
function $5cc4a686f46e8a12$var$Db(a) {
    return a[$5cc4a686f46e8a12$var$Pf] || null;
}
var $5cc4a686f46e8a12$var$Sf = [], $5cc4a686f46e8a12$var$Tf = -1;
function $5cc4a686f46e8a12$var$Uf(a) {
    return {
        current: a
    };
}
function $5cc4a686f46e8a12$var$E(a) {
    0 > $5cc4a686f46e8a12$var$Tf || (a.current = $5cc4a686f46e8a12$var$Sf[$5cc4a686f46e8a12$var$Tf], $5cc4a686f46e8a12$var$Sf[$5cc4a686f46e8a12$var$Tf] = null, $5cc4a686f46e8a12$var$Tf--);
}
function $5cc4a686f46e8a12$var$G(a, b) {
    $5cc4a686f46e8a12$var$Tf++;
    $5cc4a686f46e8a12$var$Sf[$5cc4a686f46e8a12$var$Tf] = a.current;
    a.current = b;
}
var $5cc4a686f46e8a12$var$Vf = {}, $5cc4a686f46e8a12$var$H = $5cc4a686f46e8a12$var$Uf($5cc4a686f46e8a12$var$Vf), $5cc4a686f46e8a12$var$Wf = $5cc4a686f46e8a12$var$Uf(!1), $5cc4a686f46e8a12$var$Xf = $5cc4a686f46e8a12$var$Vf;
function $5cc4a686f46e8a12$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $5cc4a686f46e8a12$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $5cc4a686f46e8a12$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $5cc4a686f46e8a12$var$$f() {
    $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$Wf);
    $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$H);
}
function $5cc4a686f46e8a12$var$ag(a, b, c) {
    if ($5cc4a686f46e8a12$var$H.current !== $5cc4a686f46e8a12$var$Vf) throw Error($5cc4a686f46e8a12$var$p(168));
    $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$H, b);
    $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$Wf, c);
}
function $5cc4a686f46e8a12$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($5cc4a686f46e8a12$var$p(108, $5cc4a686f46e8a12$var$Ra(a) || "Unknown", e));
    return $5cc4a686f46e8a12$var$A({}, c, d);
}
function $5cc4a686f46e8a12$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $5cc4a686f46e8a12$var$Vf;
    $5cc4a686f46e8a12$var$Xf = $5cc4a686f46e8a12$var$H.current;
    $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$H, a);
    $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$Wf, $5cc4a686f46e8a12$var$Wf.current);
    return !0;
}
function $5cc4a686f46e8a12$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($5cc4a686f46e8a12$var$p(169));
    c ? (a = $5cc4a686f46e8a12$var$bg(a, b, $5cc4a686f46e8a12$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$Wf), $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$H), $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$H, a)) : $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$Wf);
    $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$Wf, c);
}
var $5cc4a686f46e8a12$var$eg = null, $5cc4a686f46e8a12$var$fg = !1, $5cc4a686f46e8a12$var$gg = !1;
function $5cc4a686f46e8a12$var$hg(a) {
    null === $5cc4a686f46e8a12$var$eg ? $5cc4a686f46e8a12$var$eg = [
        a
    ] : $5cc4a686f46e8a12$var$eg.push(a);
}
function $5cc4a686f46e8a12$var$ig(a) {
    $5cc4a686f46e8a12$var$fg = !0;
    $5cc4a686f46e8a12$var$hg(a);
}
function $5cc4a686f46e8a12$var$jg() {
    if (!$5cc4a686f46e8a12$var$gg && null !== $5cc4a686f46e8a12$var$eg) {
        $5cc4a686f46e8a12$var$gg = !0;
        var a = 0, b = $5cc4a686f46e8a12$var$C;
        try {
            var c = $5cc4a686f46e8a12$var$eg;
            for($5cc4a686f46e8a12$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $5cc4a686f46e8a12$var$eg = null;
            $5cc4a686f46e8a12$var$fg = !1;
        } catch (e) {
            throw null !== $5cc4a686f46e8a12$var$eg && ($5cc4a686f46e8a12$var$eg = $5cc4a686f46e8a12$var$eg.slice(a + 1)), $5cc4a686f46e8a12$var$ac($5cc4a686f46e8a12$var$fc, $5cc4a686f46e8a12$var$jg), e;
        } finally{
            $5cc4a686f46e8a12$var$C = b, $5cc4a686f46e8a12$var$gg = !1;
        }
    }
    return null;
}
var $5cc4a686f46e8a12$var$kg = [], $5cc4a686f46e8a12$var$lg = 0, $5cc4a686f46e8a12$var$mg = null, $5cc4a686f46e8a12$var$ng = 0, $5cc4a686f46e8a12$var$og = [], $5cc4a686f46e8a12$var$pg = 0, $5cc4a686f46e8a12$var$qg = null, $5cc4a686f46e8a12$var$rg = 1, $5cc4a686f46e8a12$var$sg = "";
function $5cc4a686f46e8a12$var$tg(a, b) {
    $5cc4a686f46e8a12$var$kg[$5cc4a686f46e8a12$var$lg++] = $5cc4a686f46e8a12$var$ng;
    $5cc4a686f46e8a12$var$kg[$5cc4a686f46e8a12$var$lg++] = $5cc4a686f46e8a12$var$mg;
    $5cc4a686f46e8a12$var$mg = a;
    $5cc4a686f46e8a12$var$ng = b;
}
function $5cc4a686f46e8a12$var$ug(a, b, c) {
    $5cc4a686f46e8a12$var$og[$5cc4a686f46e8a12$var$pg++] = $5cc4a686f46e8a12$var$rg;
    $5cc4a686f46e8a12$var$og[$5cc4a686f46e8a12$var$pg++] = $5cc4a686f46e8a12$var$sg;
    $5cc4a686f46e8a12$var$og[$5cc4a686f46e8a12$var$pg++] = $5cc4a686f46e8a12$var$qg;
    $5cc4a686f46e8a12$var$qg = a;
    var d = $5cc4a686f46e8a12$var$rg;
    a = $5cc4a686f46e8a12$var$sg;
    var e = 32 - $5cc4a686f46e8a12$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $5cc4a686f46e8a12$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $5cc4a686f46e8a12$var$rg = 1 << 32 - $5cc4a686f46e8a12$var$oc(b) + e | c << e | d;
        $5cc4a686f46e8a12$var$sg = f + a;
    } else $5cc4a686f46e8a12$var$rg = 1 << f | c << e | d, $5cc4a686f46e8a12$var$sg = a;
}
function $5cc4a686f46e8a12$var$vg(a) {
    null !== a.return && ($5cc4a686f46e8a12$var$tg(a, 1), $5cc4a686f46e8a12$var$ug(a, 1, 0));
}
function $5cc4a686f46e8a12$var$wg(a) {
    for(; a === $5cc4a686f46e8a12$var$mg;)$5cc4a686f46e8a12$var$mg = $5cc4a686f46e8a12$var$kg[--$5cc4a686f46e8a12$var$lg], $5cc4a686f46e8a12$var$kg[$5cc4a686f46e8a12$var$lg] = null, $5cc4a686f46e8a12$var$ng = $5cc4a686f46e8a12$var$kg[--$5cc4a686f46e8a12$var$lg], $5cc4a686f46e8a12$var$kg[$5cc4a686f46e8a12$var$lg] = null;
    for(; a === $5cc4a686f46e8a12$var$qg;)$5cc4a686f46e8a12$var$qg = $5cc4a686f46e8a12$var$og[--$5cc4a686f46e8a12$var$pg], $5cc4a686f46e8a12$var$og[$5cc4a686f46e8a12$var$pg] = null, $5cc4a686f46e8a12$var$sg = $5cc4a686f46e8a12$var$og[--$5cc4a686f46e8a12$var$pg], $5cc4a686f46e8a12$var$og[$5cc4a686f46e8a12$var$pg] = null, $5cc4a686f46e8a12$var$rg = $5cc4a686f46e8a12$var$og[--$5cc4a686f46e8a12$var$pg], $5cc4a686f46e8a12$var$og[$5cc4a686f46e8a12$var$pg] = null;
}
var $5cc4a686f46e8a12$var$xg = null, $5cc4a686f46e8a12$var$yg = null, $5cc4a686f46e8a12$var$I = !1, $5cc4a686f46e8a12$var$zg = null;
function $5cc4a686f46e8a12$var$Ag(a, b) {
    var c = $5cc4a686f46e8a12$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $5cc4a686f46e8a12$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $5cc4a686f46e8a12$var$xg = a, $5cc4a686f46e8a12$var$yg = $5cc4a686f46e8a12$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $5cc4a686f46e8a12$var$xg = a, $5cc4a686f46e8a12$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $5cc4a686f46e8a12$var$qg ? {
                id: $5cc4a686f46e8a12$var$rg,
                overflow: $5cc4a686f46e8a12$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $5cc4a686f46e8a12$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $5cc4a686f46e8a12$var$xg = a, $5cc4a686f46e8a12$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $5cc4a686f46e8a12$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $5cc4a686f46e8a12$var$Eg(a) {
    if ($5cc4a686f46e8a12$var$I) {
        var b = $5cc4a686f46e8a12$var$yg;
        if (b) {
            var c = b;
            if (!$5cc4a686f46e8a12$var$Cg(a, b)) {
                if ($5cc4a686f46e8a12$var$Dg(a)) throw Error($5cc4a686f46e8a12$var$p(418));
                b = $5cc4a686f46e8a12$var$Lf(c.nextSibling);
                var d = $5cc4a686f46e8a12$var$xg;
                b && $5cc4a686f46e8a12$var$Cg(a, b) ? $5cc4a686f46e8a12$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $5cc4a686f46e8a12$var$I = !1, $5cc4a686f46e8a12$var$xg = a);
            }
        } else {
            if ($5cc4a686f46e8a12$var$Dg(a)) throw Error($5cc4a686f46e8a12$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $5cc4a686f46e8a12$var$I = !1;
            $5cc4a686f46e8a12$var$xg = a;
        }
    }
}
function $5cc4a686f46e8a12$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $5cc4a686f46e8a12$var$xg = a;
}
function $5cc4a686f46e8a12$var$Gg(a) {
    if (a !== $5cc4a686f46e8a12$var$xg) return !1;
    if (!$5cc4a686f46e8a12$var$I) return $5cc4a686f46e8a12$var$Fg(a), $5cc4a686f46e8a12$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$5cc4a686f46e8a12$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $5cc4a686f46e8a12$var$yg)) {
        if ($5cc4a686f46e8a12$var$Dg(a)) throw $5cc4a686f46e8a12$var$Hg(), Error($5cc4a686f46e8a12$var$p(418));
        for(; b;)$5cc4a686f46e8a12$var$Ag(a, b), b = $5cc4a686f46e8a12$var$Lf(b.nextSibling);
    }
    $5cc4a686f46e8a12$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($5cc4a686f46e8a12$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $5cc4a686f46e8a12$var$yg = $5cc4a686f46e8a12$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $5cc4a686f46e8a12$var$yg = null;
        }
    } else $5cc4a686f46e8a12$var$yg = $5cc4a686f46e8a12$var$xg ? $5cc4a686f46e8a12$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $5cc4a686f46e8a12$var$Hg() {
    for(var a = $5cc4a686f46e8a12$var$yg; a;)a = $5cc4a686f46e8a12$var$Lf(a.nextSibling);
}
function $5cc4a686f46e8a12$var$Ig() {
    $5cc4a686f46e8a12$var$yg = $5cc4a686f46e8a12$var$xg = null;
    $5cc4a686f46e8a12$var$I = !1;
}
function $5cc4a686f46e8a12$var$Jg(a) {
    null === $5cc4a686f46e8a12$var$zg ? $5cc4a686f46e8a12$var$zg = [
        a
    ] : $5cc4a686f46e8a12$var$zg.push(a);
}
var $5cc4a686f46e8a12$var$Kg = $5cc4a686f46e8a12$var$ua.ReactCurrentBatchConfig;
function $5cc4a686f46e8a12$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $5cc4a686f46e8a12$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $5cc4a686f46e8a12$var$Mg = $5cc4a686f46e8a12$var$Uf(null), $5cc4a686f46e8a12$var$Ng = null, $5cc4a686f46e8a12$var$Og = null, $5cc4a686f46e8a12$var$Pg = null;
function $5cc4a686f46e8a12$var$Qg() {
    $5cc4a686f46e8a12$var$Pg = $5cc4a686f46e8a12$var$Og = $5cc4a686f46e8a12$var$Ng = null;
}
function $5cc4a686f46e8a12$var$Rg(a) {
    var b = $5cc4a686f46e8a12$var$Mg.current;
    $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$Mg);
    a._currentValue = b;
}
function $5cc4a686f46e8a12$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $5cc4a686f46e8a12$var$Tg(a, b) {
    $5cc4a686f46e8a12$var$Ng = a;
    $5cc4a686f46e8a12$var$Pg = $5cc4a686f46e8a12$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($5cc4a686f46e8a12$var$Ug = !0), a.firstContext = null);
}
function $5cc4a686f46e8a12$var$Vg(a) {
    var b = a._currentValue;
    if ($5cc4a686f46e8a12$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $5cc4a686f46e8a12$var$Og) {
            if (null === $5cc4a686f46e8a12$var$Ng) throw Error($5cc4a686f46e8a12$var$p(308));
            $5cc4a686f46e8a12$var$Og = a;
            $5cc4a686f46e8a12$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $5cc4a686f46e8a12$var$Og = $5cc4a686f46e8a12$var$Og.next = a;
    }
    return b;
}
var $5cc4a686f46e8a12$var$Wg = null;
function $5cc4a686f46e8a12$var$Xg(a) {
    null === $5cc4a686f46e8a12$var$Wg ? $5cc4a686f46e8a12$var$Wg = [
        a
    ] : $5cc4a686f46e8a12$var$Wg.push(a);
}
function $5cc4a686f46e8a12$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $5cc4a686f46e8a12$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $5cc4a686f46e8a12$var$Zg(a, d);
}
function $5cc4a686f46e8a12$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $5cc4a686f46e8a12$var$$g = !1;
function $5cc4a686f46e8a12$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $5cc4a686f46e8a12$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $5cc4a686f46e8a12$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $5cc4a686f46e8a12$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($5cc4a686f46e8a12$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $5cc4a686f46e8a12$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $5cc4a686f46e8a12$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $5cc4a686f46e8a12$var$Zg(a, c);
}
function $5cc4a686f46e8a12$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $5cc4a686f46e8a12$var$Cc(a, c);
    }
}
function $5cc4a686f46e8a12$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $5cc4a686f46e8a12$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $5cc4a686f46e8a12$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $5cc4a686f46e8a12$var$A({}, q, r);
                            break a;
                        case 2:
                            $5cc4a686f46e8a12$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $5cc4a686f46e8a12$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $5cc4a686f46e8a12$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($5cc4a686f46e8a12$var$p(191, e));
            e.call(d);
        }
    }
}
var $5cc4a686f46e8a12$var$jh = (new $fgmOP.Component).refs;
function $5cc4a686f46e8a12$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $5cc4a686f46e8a12$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $5cc4a686f46e8a12$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $5cc4a686f46e8a12$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $5cc4a686f46e8a12$var$L(), e = $5cc4a686f46e8a12$var$lh(a), f = $5cc4a686f46e8a12$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $5cc4a686f46e8a12$var$dh(a, f, e);
        null !== b && ($5cc4a686f46e8a12$var$mh(b, a, e, d), $5cc4a686f46e8a12$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $5cc4a686f46e8a12$var$L(), e = $5cc4a686f46e8a12$var$lh(a), f = $5cc4a686f46e8a12$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $5cc4a686f46e8a12$var$dh(a, f, e);
        null !== b && ($5cc4a686f46e8a12$var$mh(b, a, e, d), $5cc4a686f46e8a12$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $5cc4a686f46e8a12$var$L(), d = $5cc4a686f46e8a12$var$lh(a), e = $5cc4a686f46e8a12$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $5cc4a686f46e8a12$var$dh(a, e, d);
        null !== b && ($5cc4a686f46e8a12$var$mh(b, a, d, c), $5cc4a686f46e8a12$var$eh(b, a, d));
    }
};
function $5cc4a686f46e8a12$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$5cc4a686f46e8a12$var$Ie(c, d) || !$5cc4a686f46e8a12$var$Ie(e, f) : !0;
}
function $5cc4a686f46e8a12$var$ph(a, b, c) {
    var d = !1, e = $5cc4a686f46e8a12$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $5cc4a686f46e8a12$var$Vg(f) : (e = $5cc4a686f46e8a12$var$Zf(b) ? $5cc4a686f46e8a12$var$Xf : $5cc4a686f46e8a12$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $5cc4a686f46e8a12$var$Yf(a, e) : $5cc4a686f46e8a12$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $5cc4a686f46e8a12$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $5cc4a686f46e8a12$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $5cc4a686f46e8a12$var$nh.enqueueReplaceState(b, b.state, null);
}
function $5cc4a686f46e8a12$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $5cc4a686f46e8a12$var$jh;
    $5cc4a686f46e8a12$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $5cc4a686f46e8a12$var$Vg(f) : (f = $5cc4a686f46e8a12$var$Zf(b) ? $5cc4a686f46e8a12$var$Xf : $5cc4a686f46e8a12$var$H.current, e.context = $5cc4a686f46e8a12$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($5cc4a686f46e8a12$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $5cc4a686f46e8a12$var$nh.enqueueReplaceState(e, e.state, null), $5cc4a686f46e8a12$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $5cc4a686f46e8a12$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($5cc4a686f46e8a12$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($5cc4a686f46e8a12$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $5cc4a686f46e8a12$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($5cc4a686f46e8a12$var$p(284));
        if (!c._owner) throw Error($5cc4a686f46e8a12$var$p(290, a));
    }
    return a;
}
function $5cc4a686f46e8a12$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($5cc4a686f46e8a12$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $5cc4a686f46e8a12$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $5cc4a686f46e8a12$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $5cc4a686f46e8a12$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $5cc4a686f46e8a12$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $5cc4a686f46e8a12$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $5cc4a686f46e8a12$var$Ha && $5cc4a686f46e8a12$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $5cc4a686f46e8a12$var$sh(a, b, c), d.return = a, d;
        d = $5cc4a686f46e8a12$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $5cc4a686f46e8a12$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $5cc4a686f46e8a12$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $5cc4a686f46e8a12$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $5cc4a686f46e8a12$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $5cc4a686f46e8a12$var$va:
                    return c = $5cc4a686f46e8a12$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $5cc4a686f46e8a12$var$sh(a, null, b), c.return = a, c;
                case $5cc4a686f46e8a12$var$wa:
                    return b = $5cc4a686f46e8a12$var$zh(b, a.mode, c), b.return = a, b;
                case $5cc4a686f46e8a12$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($5cc4a686f46e8a12$var$eb(b) || $5cc4a686f46e8a12$var$Ka(b)) return b = $5cc4a686f46e8a12$var$Ah(b, a.mode, c, null), b.return = a, b;
            $5cc4a686f46e8a12$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $5cc4a686f46e8a12$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $5cc4a686f46e8a12$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $5cc4a686f46e8a12$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($5cc4a686f46e8a12$var$eb(c) || $5cc4a686f46e8a12$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $5cc4a686f46e8a12$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $5cc4a686f46e8a12$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $5cc4a686f46e8a12$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $5cc4a686f46e8a12$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($5cc4a686f46e8a12$var$eb(d) || $5cc4a686f46e8a12$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $5cc4a686f46e8a12$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $5cc4a686f46e8a12$var$I && $5cc4a686f46e8a12$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $5cc4a686f46e8a12$var$I && $5cc4a686f46e8a12$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $5cc4a686f46e8a12$var$I && $5cc4a686f46e8a12$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $5cc4a686f46e8a12$var$Ka(h);
        if ("function" !== typeof l) throw Error($5cc4a686f46e8a12$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($5cc4a686f46e8a12$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $5cc4a686f46e8a12$var$I && $5cc4a686f46e8a12$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $5cc4a686f46e8a12$var$I && $5cc4a686f46e8a12$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $5cc4a686f46e8a12$var$I && $5cc4a686f46e8a12$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $5cc4a686f46e8a12$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $5cc4a686f46e8a12$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $5cc4a686f46e8a12$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $5cc4a686f46e8a12$var$Ha && $5cc4a686f46e8a12$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $5cc4a686f46e8a12$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $5cc4a686f46e8a12$var$ya ? (d = $5cc4a686f46e8a12$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $5cc4a686f46e8a12$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $5cc4a686f46e8a12$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $5cc4a686f46e8a12$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $5cc4a686f46e8a12$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $5cc4a686f46e8a12$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($5cc4a686f46e8a12$var$eb(f)) return n(a, d, f, h);
            if ($5cc4a686f46e8a12$var$Ka(f)) return t(a, d, f, h);
            $5cc4a686f46e8a12$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $5cc4a686f46e8a12$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $5cc4a686f46e8a12$var$Bh = $5cc4a686f46e8a12$var$vh(!0), $5cc4a686f46e8a12$var$Ch = $5cc4a686f46e8a12$var$vh(!1), $5cc4a686f46e8a12$var$Dh = {}, $5cc4a686f46e8a12$var$Eh = $5cc4a686f46e8a12$var$Uf($5cc4a686f46e8a12$var$Dh), $5cc4a686f46e8a12$var$Fh = $5cc4a686f46e8a12$var$Uf($5cc4a686f46e8a12$var$Dh), $5cc4a686f46e8a12$var$Gh = $5cc4a686f46e8a12$var$Uf($5cc4a686f46e8a12$var$Dh);
function $5cc4a686f46e8a12$var$Hh(a) {
    if (a === $5cc4a686f46e8a12$var$Dh) throw Error($5cc4a686f46e8a12$var$p(174));
    return a;
}
function $5cc4a686f46e8a12$var$Ih(a, b) {
    $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$Gh, b);
    $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$Fh, a);
    $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$Eh, $5cc4a686f46e8a12$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $5cc4a686f46e8a12$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $5cc4a686f46e8a12$var$lb(b, a);
    }
    $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$Eh);
    $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$Eh, b);
}
function $5cc4a686f46e8a12$var$Jh() {
    $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$Eh);
    $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$Fh);
    $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$Gh);
}
function $5cc4a686f46e8a12$var$Kh(a) {
    $5cc4a686f46e8a12$var$Hh($5cc4a686f46e8a12$var$Gh.current);
    var b = $5cc4a686f46e8a12$var$Hh($5cc4a686f46e8a12$var$Eh.current);
    var c = $5cc4a686f46e8a12$var$lb(b, a.type);
    b !== c && ($5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$Fh, a), $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$Eh, c));
}
function $5cc4a686f46e8a12$var$Lh(a) {
    $5cc4a686f46e8a12$var$Fh.current === a && ($5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$Eh), $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$Fh));
}
var $5cc4a686f46e8a12$var$M = $5cc4a686f46e8a12$var$Uf(0);
function $5cc4a686f46e8a12$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $5cc4a686f46e8a12$var$Nh = [];
function $5cc4a686f46e8a12$var$Oh() {
    for(var a = 0; a < $5cc4a686f46e8a12$var$Nh.length; a++)$5cc4a686f46e8a12$var$Nh[a]._workInProgressVersionPrimary = null;
    $5cc4a686f46e8a12$var$Nh.length = 0;
}
var $5cc4a686f46e8a12$var$Ph = $5cc4a686f46e8a12$var$ua.ReactCurrentDispatcher, $5cc4a686f46e8a12$var$Qh = $5cc4a686f46e8a12$var$ua.ReactCurrentBatchConfig, $5cc4a686f46e8a12$var$Rh = 0, $5cc4a686f46e8a12$var$N = null, $5cc4a686f46e8a12$var$O = null, $5cc4a686f46e8a12$var$P = null, $5cc4a686f46e8a12$var$Sh = !1, $5cc4a686f46e8a12$var$Th = !1, $5cc4a686f46e8a12$var$Uh = 0, $5cc4a686f46e8a12$var$Vh = 0;
function $5cc4a686f46e8a12$var$Q() {
    throw Error($5cc4a686f46e8a12$var$p(321));
}
function $5cc4a686f46e8a12$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$5cc4a686f46e8a12$var$He(a[c], b[c])) return !1;
    return !0;
}
function $5cc4a686f46e8a12$var$Xh(a, b, c, d, e, f) {
    $5cc4a686f46e8a12$var$Rh = f;
    $5cc4a686f46e8a12$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $5cc4a686f46e8a12$var$Ph.current = null === a || null === a.memoizedState ? $5cc4a686f46e8a12$var$Yh : $5cc4a686f46e8a12$var$Zh;
    a = c(d, e);
    if ($5cc4a686f46e8a12$var$Th) {
        f = 0;
        do {
            $5cc4a686f46e8a12$var$Th = !1;
            $5cc4a686f46e8a12$var$Uh = 0;
            if (25 <= f) throw Error($5cc4a686f46e8a12$var$p(301));
            f += 1;
            $5cc4a686f46e8a12$var$P = $5cc4a686f46e8a12$var$O = null;
            b.updateQueue = null;
            $5cc4a686f46e8a12$var$Ph.current = $5cc4a686f46e8a12$var$$h;
            a = c(d, e);
        }while ($5cc4a686f46e8a12$var$Th);
    }
    $5cc4a686f46e8a12$var$Ph.current = $5cc4a686f46e8a12$var$ai;
    b = null !== $5cc4a686f46e8a12$var$O && null !== $5cc4a686f46e8a12$var$O.next;
    $5cc4a686f46e8a12$var$Rh = 0;
    $5cc4a686f46e8a12$var$P = $5cc4a686f46e8a12$var$O = $5cc4a686f46e8a12$var$N = null;
    $5cc4a686f46e8a12$var$Sh = !1;
    if (b) throw Error($5cc4a686f46e8a12$var$p(300));
    return a;
}
function $5cc4a686f46e8a12$var$bi() {
    var a = 0 !== $5cc4a686f46e8a12$var$Uh;
    $5cc4a686f46e8a12$var$Uh = 0;
    return a;
}
function $5cc4a686f46e8a12$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $5cc4a686f46e8a12$var$P ? $5cc4a686f46e8a12$var$N.memoizedState = $5cc4a686f46e8a12$var$P = a : $5cc4a686f46e8a12$var$P = $5cc4a686f46e8a12$var$P.next = a;
    return $5cc4a686f46e8a12$var$P;
}
function $5cc4a686f46e8a12$var$di() {
    if (null === $5cc4a686f46e8a12$var$O) {
        var a = $5cc4a686f46e8a12$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $5cc4a686f46e8a12$var$O.next;
    var b = null === $5cc4a686f46e8a12$var$P ? $5cc4a686f46e8a12$var$N.memoizedState : $5cc4a686f46e8a12$var$P.next;
    if (null !== b) $5cc4a686f46e8a12$var$P = b, $5cc4a686f46e8a12$var$O = a;
    else {
        if (null === a) throw Error($5cc4a686f46e8a12$var$p(310));
        $5cc4a686f46e8a12$var$O = a;
        a = {
            memoizedState: $5cc4a686f46e8a12$var$O.memoizedState,
            baseState: $5cc4a686f46e8a12$var$O.baseState,
            baseQueue: $5cc4a686f46e8a12$var$O.baseQueue,
            queue: $5cc4a686f46e8a12$var$O.queue,
            next: null
        };
        null === $5cc4a686f46e8a12$var$P ? $5cc4a686f46e8a12$var$N.memoizedState = $5cc4a686f46e8a12$var$P = a : $5cc4a686f46e8a12$var$P = $5cc4a686f46e8a12$var$P.next = a;
    }
    return $5cc4a686f46e8a12$var$P;
}
function $5cc4a686f46e8a12$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $5cc4a686f46e8a12$var$fi(a) {
    var b = $5cc4a686f46e8a12$var$di(), c = b.queue;
    if (null === c) throw Error($5cc4a686f46e8a12$var$p(311));
    c.lastRenderedReducer = a;
    var d = $5cc4a686f46e8a12$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($5cc4a686f46e8a12$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $5cc4a686f46e8a12$var$N.lanes |= m;
                $5cc4a686f46e8a12$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $5cc4a686f46e8a12$var$He(d, b.memoizedState) || ($5cc4a686f46e8a12$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $5cc4a686f46e8a12$var$N.lanes |= f, $5cc4a686f46e8a12$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $5cc4a686f46e8a12$var$gi(a) {
    var b = $5cc4a686f46e8a12$var$di(), c = b.queue;
    if (null === c) throw Error($5cc4a686f46e8a12$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $5cc4a686f46e8a12$var$He(f, b.memoizedState) || ($5cc4a686f46e8a12$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $5cc4a686f46e8a12$var$hi() {}
function $5cc4a686f46e8a12$var$ii(a, b) {
    var c = $5cc4a686f46e8a12$var$N, d = $5cc4a686f46e8a12$var$di(), e = b(), f = !$5cc4a686f46e8a12$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $5cc4a686f46e8a12$var$Ug = !0);
    d = d.queue;
    $5cc4a686f46e8a12$var$ji($5cc4a686f46e8a12$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $5cc4a686f46e8a12$var$P && $5cc4a686f46e8a12$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $5cc4a686f46e8a12$var$li(9, $5cc4a686f46e8a12$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $5cc4a686f46e8a12$var$R) throw Error($5cc4a686f46e8a12$var$p(349));
        0 !== ($5cc4a686f46e8a12$var$Rh & 30) || $5cc4a686f46e8a12$var$ni(c, b, e);
    }
    return e;
}
function $5cc4a686f46e8a12$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $5cc4a686f46e8a12$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $5cc4a686f46e8a12$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $5cc4a686f46e8a12$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $5cc4a686f46e8a12$var$oi(b) && $5cc4a686f46e8a12$var$pi(a);
}
function $5cc4a686f46e8a12$var$ki(a, b, c) {
    return c(function() {
        $5cc4a686f46e8a12$var$oi(b) && $5cc4a686f46e8a12$var$pi(a);
    });
}
function $5cc4a686f46e8a12$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$5cc4a686f46e8a12$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $5cc4a686f46e8a12$var$pi(a) {
    var b = $5cc4a686f46e8a12$var$Zg(a, 1);
    null !== b && $5cc4a686f46e8a12$var$mh(b, a, 1, -1);
}
function $5cc4a686f46e8a12$var$qi(a) {
    var b = $5cc4a686f46e8a12$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $5cc4a686f46e8a12$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $5cc4a686f46e8a12$var$ri.bind(null, $5cc4a686f46e8a12$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $5cc4a686f46e8a12$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $5cc4a686f46e8a12$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $5cc4a686f46e8a12$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $5cc4a686f46e8a12$var$si() {
    return $5cc4a686f46e8a12$var$di().memoizedState;
}
function $5cc4a686f46e8a12$var$ti(a, b, c, d) {
    var e = $5cc4a686f46e8a12$var$ci();
    $5cc4a686f46e8a12$var$N.flags |= a;
    e.memoizedState = $5cc4a686f46e8a12$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $5cc4a686f46e8a12$var$ui(a, b, c, d) {
    var e = $5cc4a686f46e8a12$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $5cc4a686f46e8a12$var$O) {
        var g = $5cc4a686f46e8a12$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $5cc4a686f46e8a12$var$Wh(d, g.deps)) {
            e.memoizedState = $5cc4a686f46e8a12$var$li(b, c, f, d);
            return;
        }
    }
    $5cc4a686f46e8a12$var$N.flags |= a;
    e.memoizedState = $5cc4a686f46e8a12$var$li(1 | b, c, f, d);
}
function $5cc4a686f46e8a12$var$vi(a, b) {
    return $5cc4a686f46e8a12$var$ti(8390656, 8, a, b);
}
function $5cc4a686f46e8a12$var$ji(a, b) {
    return $5cc4a686f46e8a12$var$ui(2048, 8, a, b);
}
function $5cc4a686f46e8a12$var$wi(a, b) {
    return $5cc4a686f46e8a12$var$ui(4, 2, a, b);
}
function $5cc4a686f46e8a12$var$xi(a, b) {
    return $5cc4a686f46e8a12$var$ui(4, 4, a, b);
}
function $5cc4a686f46e8a12$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $5cc4a686f46e8a12$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $5cc4a686f46e8a12$var$ui(4, 4, $5cc4a686f46e8a12$var$yi.bind(null, b, a), c);
}
function $5cc4a686f46e8a12$var$Ai() {}
function $5cc4a686f46e8a12$var$Bi(a, b) {
    var c = $5cc4a686f46e8a12$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $5cc4a686f46e8a12$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $5cc4a686f46e8a12$var$Ci(a, b) {
    var c = $5cc4a686f46e8a12$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $5cc4a686f46e8a12$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $5cc4a686f46e8a12$var$Di(a, b, c) {
    if (0 === ($5cc4a686f46e8a12$var$Rh & 21)) return a.baseState && (a.baseState = !1, $5cc4a686f46e8a12$var$Ug = !0), a.memoizedState = c;
    $5cc4a686f46e8a12$var$He(c, b) || (c = $5cc4a686f46e8a12$var$yc(), $5cc4a686f46e8a12$var$N.lanes |= c, $5cc4a686f46e8a12$var$hh |= c, a.baseState = !0);
    return b;
}
function $5cc4a686f46e8a12$var$Ei(a, b) {
    var c = $5cc4a686f46e8a12$var$C;
    $5cc4a686f46e8a12$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $5cc4a686f46e8a12$var$Qh.transition;
    $5cc4a686f46e8a12$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $5cc4a686f46e8a12$var$C = c, $5cc4a686f46e8a12$var$Qh.transition = d;
    }
}
function $5cc4a686f46e8a12$var$Fi() {
    return $5cc4a686f46e8a12$var$di().memoizedState;
}
function $5cc4a686f46e8a12$var$Gi(a, b, c) {
    var d = $5cc4a686f46e8a12$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($5cc4a686f46e8a12$var$Hi(a)) $5cc4a686f46e8a12$var$Ii(b, c);
    else if (c = $5cc4a686f46e8a12$var$Yg(a, b, c, d), null !== c) {
        var e = $5cc4a686f46e8a12$var$L();
        $5cc4a686f46e8a12$var$mh(c, a, d, e);
        $5cc4a686f46e8a12$var$Ji(c, b, d);
    }
}
function $5cc4a686f46e8a12$var$ri(a, b, c) {
    var d = $5cc4a686f46e8a12$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($5cc4a686f46e8a12$var$Hi(a)) $5cc4a686f46e8a12$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($5cc4a686f46e8a12$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $5cc4a686f46e8a12$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $5cc4a686f46e8a12$var$Yg(a, b, e, d);
        null !== c && (e = $5cc4a686f46e8a12$var$L(), $5cc4a686f46e8a12$var$mh(c, a, d, e), $5cc4a686f46e8a12$var$Ji(c, b, d));
    }
}
function $5cc4a686f46e8a12$var$Hi(a) {
    var b = a.alternate;
    return a === $5cc4a686f46e8a12$var$N || null !== b && b === $5cc4a686f46e8a12$var$N;
}
function $5cc4a686f46e8a12$var$Ii(a, b) {
    $5cc4a686f46e8a12$var$Th = $5cc4a686f46e8a12$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $5cc4a686f46e8a12$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $5cc4a686f46e8a12$var$Cc(a, c);
    }
}
var $5cc4a686f46e8a12$var$ai = {
    readContext: $5cc4a686f46e8a12$var$Vg,
    useCallback: $5cc4a686f46e8a12$var$Q,
    useContext: $5cc4a686f46e8a12$var$Q,
    useEffect: $5cc4a686f46e8a12$var$Q,
    useImperativeHandle: $5cc4a686f46e8a12$var$Q,
    useInsertionEffect: $5cc4a686f46e8a12$var$Q,
    useLayoutEffect: $5cc4a686f46e8a12$var$Q,
    useMemo: $5cc4a686f46e8a12$var$Q,
    useReducer: $5cc4a686f46e8a12$var$Q,
    useRef: $5cc4a686f46e8a12$var$Q,
    useState: $5cc4a686f46e8a12$var$Q,
    useDebugValue: $5cc4a686f46e8a12$var$Q,
    useDeferredValue: $5cc4a686f46e8a12$var$Q,
    useTransition: $5cc4a686f46e8a12$var$Q,
    useMutableSource: $5cc4a686f46e8a12$var$Q,
    useSyncExternalStore: $5cc4a686f46e8a12$var$Q,
    useId: $5cc4a686f46e8a12$var$Q,
    unstable_isNewReconciler: !1
}, $5cc4a686f46e8a12$var$Yh = {
    readContext: $5cc4a686f46e8a12$var$Vg,
    useCallback: function(a, b) {
        $5cc4a686f46e8a12$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $5cc4a686f46e8a12$var$Vg,
    useEffect: $5cc4a686f46e8a12$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $5cc4a686f46e8a12$var$ti(4194308, 4, $5cc4a686f46e8a12$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $5cc4a686f46e8a12$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $5cc4a686f46e8a12$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $5cc4a686f46e8a12$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $5cc4a686f46e8a12$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $5cc4a686f46e8a12$var$Gi.bind(null, $5cc4a686f46e8a12$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $5cc4a686f46e8a12$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $5cc4a686f46e8a12$var$qi,
    useDebugValue: $5cc4a686f46e8a12$var$Ai,
    useDeferredValue: function(a) {
        return $5cc4a686f46e8a12$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $5cc4a686f46e8a12$var$qi(!1), b = a[0];
        a = $5cc4a686f46e8a12$var$Ei.bind(null, a[1]);
        $5cc4a686f46e8a12$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $5cc4a686f46e8a12$var$N, e = $5cc4a686f46e8a12$var$ci();
        if ($5cc4a686f46e8a12$var$I) {
            if (void 0 === c) throw Error($5cc4a686f46e8a12$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $5cc4a686f46e8a12$var$R) throw Error($5cc4a686f46e8a12$var$p(349));
            0 !== ($5cc4a686f46e8a12$var$Rh & 30) || $5cc4a686f46e8a12$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $5cc4a686f46e8a12$var$vi($5cc4a686f46e8a12$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $5cc4a686f46e8a12$var$li(9, $5cc4a686f46e8a12$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $5cc4a686f46e8a12$var$ci(), b = $5cc4a686f46e8a12$var$R.identifierPrefix;
        if ($5cc4a686f46e8a12$var$I) {
            var c = $5cc4a686f46e8a12$var$sg;
            var d = $5cc4a686f46e8a12$var$rg;
            c = (d & ~(1 << 32 - $5cc4a686f46e8a12$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $5cc4a686f46e8a12$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $5cc4a686f46e8a12$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $5cc4a686f46e8a12$var$Zh = {
    readContext: $5cc4a686f46e8a12$var$Vg,
    useCallback: $5cc4a686f46e8a12$var$Bi,
    useContext: $5cc4a686f46e8a12$var$Vg,
    useEffect: $5cc4a686f46e8a12$var$ji,
    useImperativeHandle: $5cc4a686f46e8a12$var$zi,
    useInsertionEffect: $5cc4a686f46e8a12$var$wi,
    useLayoutEffect: $5cc4a686f46e8a12$var$xi,
    useMemo: $5cc4a686f46e8a12$var$Ci,
    useReducer: $5cc4a686f46e8a12$var$fi,
    useRef: $5cc4a686f46e8a12$var$si,
    useState: function() {
        return $5cc4a686f46e8a12$var$fi($5cc4a686f46e8a12$var$ei);
    },
    useDebugValue: $5cc4a686f46e8a12$var$Ai,
    useDeferredValue: function(a) {
        var b = $5cc4a686f46e8a12$var$di();
        return $5cc4a686f46e8a12$var$Di(b, $5cc4a686f46e8a12$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $5cc4a686f46e8a12$var$fi($5cc4a686f46e8a12$var$ei)[0], b = $5cc4a686f46e8a12$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $5cc4a686f46e8a12$var$hi,
    useSyncExternalStore: $5cc4a686f46e8a12$var$ii,
    useId: $5cc4a686f46e8a12$var$Fi,
    unstable_isNewReconciler: !1
}, $5cc4a686f46e8a12$var$$h = {
    readContext: $5cc4a686f46e8a12$var$Vg,
    useCallback: $5cc4a686f46e8a12$var$Bi,
    useContext: $5cc4a686f46e8a12$var$Vg,
    useEffect: $5cc4a686f46e8a12$var$ji,
    useImperativeHandle: $5cc4a686f46e8a12$var$zi,
    useInsertionEffect: $5cc4a686f46e8a12$var$wi,
    useLayoutEffect: $5cc4a686f46e8a12$var$xi,
    useMemo: $5cc4a686f46e8a12$var$Ci,
    useReducer: $5cc4a686f46e8a12$var$gi,
    useRef: $5cc4a686f46e8a12$var$si,
    useState: function() {
        return $5cc4a686f46e8a12$var$gi($5cc4a686f46e8a12$var$ei);
    },
    useDebugValue: $5cc4a686f46e8a12$var$Ai,
    useDeferredValue: function(a) {
        var b = $5cc4a686f46e8a12$var$di();
        return null === $5cc4a686f46e8a12$var$O ? b.memoizedState = a : $5cc4a686f46e8a12$var$Di(b, $5cc4a686f46e8a12$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $5cc4a686f46e8a12$var$gi($5cc4a686f46e8a12$var$ei)[0], b = $5cc4a686f46e8a12$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $5cc4a686f46e8a12$var$hi,
    useSyncExternalStore: $5cc4a686f46e8a12$var$ii,
    useId: $5cc4a686f46e8a12$var$Fi,
    unstable_isNewReconciler: !1
};
function $5cc4a686f46e8a12$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $5cc4a686f46e8a12$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $5cc4a686f46e8a12$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $5cc4a686f46e8a12$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $5cc4a686f46e8a12$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $5cc4a686f46e8a12$var$Oi(a, b, c) {
    c = $5cc4a686f46e8a12$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $5cc4a686f46e8a12$var$Pi || ($5cc4a686f46e8a12$var$Pi = !0, $5cc4a686f46e8a12$var$Qi = d);
        $5cc4a686f46e8a12$var$Mi(a, b);
    };
    return c;
}
function $5cc4a686f46e8a12$var$Ri(a, b, c) {
    c = $5cc4a686f46e8a12$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $5cc4a686f46e8a12$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $5cc4a686f46e8a12$var$Mi(a, b);
        "function" !== typeof d && (null === $5cc4a686f46e8a12$var$Si ? $5cc4a686f46e8a12$var$Si = new Set([
            this
        ]) : $5cc4a686f46e8a12$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $5cc4a686f46e8a12$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $5cc4a686f46e8a12$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $5cc4a686f46e8a12$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $5cc4a686f46e8a12$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $5cc4a686f46e8a12$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $5cc4a686f46e8a12$var$ch(-1, 1), b.tag = 2, $5cc4a686f46e8a12$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $5cc4a686f46e8a12$var$Xi = $5cc4a686f46e8a12$var$ua.ReactCurrentOwner, $5cc4a686f46e8a12$var$Ug = !1;
function $5cc4a686f46e8a12$var$Yi(a, b, c, d) {
    b.child = null === a ? $5cc4a686f46e8a12$var$Ch(b, null, c, d) : $5cc4a686f46e8a12$var$Bh(b, a.child, c, d);
}
function $5cc4a686f46e8a12$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $5cc4a686f46e8a12$var$Tg(b, e);
    d = $5cc4a686f46e8a12$var$Xh(a, b, c, d, f, e);
    c = $5cc4a686f46e8a12$var$bi();
    if (null !== a && !$5cc4a686f46e8a12$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $5cc4a686f46e8a12$var$$i(a, b, e);
    $5cc4a686f46e8a12$var$I && c && $5cc4a686f46e8a12$var$vg(b);
    b.flags |= 1;
    $5cc4a686f46e8a12$var$Yi(a, b, d, e);
    return b.child;
}
function $5cc4a686f46e8a12$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$5cc4a686f46e8a12$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $5cc4a686f46e8a12$var$cj(a, b, f, d, e);
        a = $5cc4a686f46e8a12$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $5cc4a686f46e8a12$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $5cc4a686f46e8a12$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $5cc4a686f46e8a12$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $5cc4a686f46e8a12$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($5cc4a686f46e8a12$var$Ie(f, d) && a.ref === b.ref) {
            if ($5cc4a686f46e8a12$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($5cc4a686f46e8a12$var$Ug = !0);
            else return b.lanes = a.lanes, $5cc4a686f46e8a12$var$$i(a, b, e);
        }
    }
    return $5cc4a686f46e8a12$var$dj(a, b, c, d, e);
}
function $5cc4a686f46e8a12$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$fj, $5cc4a686f46e8a12$var$gj), $5cc4a686f46e8a12$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$fj, $5cc4a686f46e8a12$var$gj), $5cc4a686f46e8a12$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$fj, $5cc4a686f46e8a12$var$gj);
            $5cc4a686f46e8a12$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$fj, $5cc4a686f46e8a12$var$gj), $5cc4a686f46e8a12$var$gj |= d;
    $5cc4a686f46e8a12$var$Yi(a, b, e, c);
    return b.child;
}
function $5cc4a686f46e8a12$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $5cc4a686f46e8a12$var$dj(a, b, c, d, e) {
    var f = $5cc4a686f46e8a12$var$Zf(c) ? $5cc4a686f46e8a12$var$Xf : $5cc4a686f46e8a12$var$H.current;
    f = $5cc4a686f46e8a12$var$Yf(b, f);
    $5cc4a686f46e8a12$var$Tg(b, e);
    c = $5cc4a686f46e8a12$var$Xh(a, b, c, d, f, e);
    d = $5cc4a686f46e8a12$var$bi();
    if (null !== a && !$5cc4a686f46e8a12$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $5cc4a686f46e8a12$var$$i(a, b, e);
    $5cc4a686f46e8a12$var$I && d && $5cc4a686f46e8a12$var$vg(b);
    b.flags |= 1;
    $5cc4a686f46e8a12$var$Yi(a, b, c, e);
    return b.child;
}
function $5cc4a686f46e8a12$var$ij(a, b, c, d, e) {
    if ($5cc4a686f46e8a12$var$Zf(c)) {
        var f = !0;
        $5cc4a686f46e8a12$var$cg(b);
    } else f = !1;
    $5cc4a686f46e8a12$var$Tg(b, e);
    if (null === b.stateNode) $5cc4a686f46e8a12$var$jj(a, b), $5cc4a686f46e8a12$var$ph(b, c, d), $5cc4a686f46e8a12$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $5cc4a686f46e8a12$var$Vg(l) : (l = $5cc4a686f46e8a12$var$Zf(c) ? $5cc4a686f46e8a12$var$Xf : $5cc4a686f46e8a12$var$H.current, l = $5cc4a686f46e8a12$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $5cc4a686f46e8a12$var$qh(b, g, d, l);
        $5cc4a686f46e8a12$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $5cc4a686f46e8a12$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $5cc4a686f46e8a12$var$Wf.current || $5cc4a686f46e8a12$var$$g ? ("function" === typeof m && ($5cc4a686f46e8a12$var$kh(b, c, m, d), k = b.memoizedState), (h = $5cc4a686f46e8a12$var$$g || $5cc4a686f46e8a12$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $5cc4a686f46e8a12$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $5cc4a686f46e8a12$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $5cc4a686f46e8a12$var$Vg(k) : (k = $5cc4a686f46e8a12$var$Zf(c) ? $5cc4a686f46e8a12$var$Xf : $5cc4a686f46e8a12$var$H.current, k = $5cc4a686f46e8a12$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $5cc4a686f46e8a12$var$qh(b, g, d, k);
        $5cc4a686f46e8a12$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $5cc4a686f46e8a12$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $5cc4a686f46e8a12$var$Wf.current || $5cc4a686f46e8a12$var$$g ? ("function" === typeof y && ($5cc4a686f46e8a12$var$kh(b, c, y, d), n = b.memoizedState), (l = $5cc4a686f46e8a12$var$$g || $5cc4a686f46e8a12$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $5cc4a686f46e8a12$var$kj(a, b, c, d, f, e);
}
function $5cc4a686f46e8a12$var$kj(a, b, c, d, e, f) {
    $5cc4a686f46e8a12$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $5cc4a686f46e8a12$var$dg(b, c, !1), $5cc4a686f46e8a12$var$$i(a, b, f);
    d = b.stateNode;
    $5cc4a686f46e8a12$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $5cc4a686f46e8a12$var$Bh(b, a.child, null, f), b.child = $5cc4a686f46e8a12$var$Bh(b, null, h, f)) : $5cc4a686f46e8a12$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $5cc4a686f46e8a12$var$dg(b, c, !0);
    return b.child;
}
function $5cc4a686f46e8a12$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $5cc4a686f46e8a12$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $5cc4a686f46e8a12$var$ag(a, b.context, !1);
    $5cc4a686f46e8a12$var$Ih(a, b.containerInfo);
}
function $5cc4a686f46e8a12$var$mj(a, b, c, d, e) {
    $5cc4a686f46e8a12$var$Ig();
    $5cc4a686f46e8a12$var$Jg(e);
    b.flags |= 256;
    $5cc4a686f46e8a12$var$Yi(a, b, c, d);
    return b.child;
}
var $5cc4a686f46e8a12$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $5cc4a686f46e8a12$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $5cc4a686f46e8a12$var$pj(a, b, c) {
    var d = b.pendingProps, e = $5cc4a686f46e8a12$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$M, e & 1);
    if (null === a) {
        $5cc4a686f46e8a12$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $5cc4a686f46e8a12$var$qj(g, d, 0, null), a = $5cc4a686f46e8a12$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $5cc4a686f46e8a12$var$oj(c), b.memoizedState = $5cc4a686f46e8a12$var$nj, a) : $5cc4a686f46e8a12$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $5cc4a686f46e8a12$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $5cc4a686f46e8a12$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $5cc4a686f46e8a12$var$wh(h, f) : (f = $5cc4a686f46e8a12$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $5cc4a686f46e8a12$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $5cc4a686f46e8a12$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $5cc4a686f46e8a12$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $5cc4a686f46e8a12$var$rj(a, b) {
    b = $5cc4a686f46e8a12$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $5cc4a686f46e8a12$var$tj(a, b, c, d) {
    null !== d && $5cc4a686f46e8a12$var$Jg(d);
    $5cc4a686f46e8a12$var$Bh(b, a.child, null, c);
    a = $5cc4a686f46e8a12$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $5cc4a686f46e8a12$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $5cc4a686f46e8a12$var$Li(Error($5cc4a686f46e8a12$var$p(422))), $5cc4a686f46e8a12$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $5cc4a686f46e8a12$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $5cc4a686f46e8a12$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $5cc4a686f46e8a12$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $5cc4a686f46e8a12$var$oj(g);
        b.memoizedState = $5cc4a686f46e8a12$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $5cc4a686f46e8a12$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($5cc4a686f46e8a12$var$p(419));
        d = $5cc4a686f46e8a12$var$Li(f, d, void 0);
        return $5cc4a686f46e8a12$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($5cc4a686f46e8a12$var$Ug || h) {
        d = $5cc4a686f46e8a12$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $5cc4a686f46e8a12$var$Zg(a, e), $5cc4a686f46e8a12$var$mh(d, a, e, -1));
        }
        $5cc4a686f46e8a12$var$uj();
        d = $5cc4a686f46e8a12$var$Li(Error($5cc4a686f46e8a12$var$p(421)));
        return $5cc4a686f46e8a12$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $5cc4a686f46e8a12$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $5cc4a686f46e8a12$var$yg = $5cc4a686f46e8a12$var$Lf(e.nextSibling);
    $5cc4a686f46e8a12$var$xg = b;
    $5cc4a686f46e8a12$var$I = !0;
    $5cc4a686f46e8a12$var$zg = null;
    null !== a && ($5cc4a686f46e8a12$var$og[$5cc4a686f46e8a12$var$pg++] = $5cc4a686f46e8a12$var$rg, $5cc4a686f46e8a12$var$og[$5cc4a686f46e8a12$var$pg++] = $5cc4a686f46e8a12$var$sg, $5cc4a686f46e8a12$var$og[$5cc4a686f46e8a12$var$pg++] = $5cc4a686f46e8a12$var$qg, $5cc4a686f46e8a12$var$rg = a.id, $5cc4a686f46e8a12$var$sg = a.overflow, $5cc4a686f46e8a12$var$qg = b);
    b = $5cc4a686f46e8a12$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $5cc4a686f46e8a12$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $5cc4a686f46e8a12$var$Sg(a.return, b, c);
}
function $5cc4a686f46e8a12$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $5cc4a686f46e8a12$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $5cc4a686f46e8a12$var$Yi(a, b, d.children, c);
    d = $5cc4a686f46e8a12$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $5cc4a686f46e8a12$var$wj(a, c, b);
            else if (19 === a.tag) $5cc4a686f46e8a12$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $5cc4a686f46e8a12$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $5cc4a686f46e8a12$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $5cc4a686f46e8a12$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $5cc4a686f46e8a12$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $5cc4a686f46e8a12$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $5cc4a686f46e8a12$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $5cc4a686f46e8a12$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $5cc4a686f46e8a12$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($5cc4a686f46e8a12$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $5cc4a686f46e8a12$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $5cc4a686f46e8a12$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $5cc4a686f46e8a12$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $5cc4a686f46e8a12$var$lj(b);
            $5cc4a686f46e8a12$var$Ig();
            break;
        case 5:
            $5cc4a686f46e8a12$var$Kh(b);
            break;
        case 1:
            $5cc4a686f46e8a12$var$Zf(b.type) && $5cc4a686f46e8a12$var$cg(b);
            break;
        case 4:
            $5cc4a686f46e8a12$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$M, $5cc4a686f46e8a12$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $5cc4a686f46e8a12$var$pj(a, b, c);
                $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$M, $5cc4a686f46e8a12$var$M.current & 1);
                a = $5cc4a686f46e8a12$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$M, $5cc4a686f46e8a12$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $5cc4a686f46e8a12$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$M, $5cc4a686f46e8a12$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $5cc4a686f46e8a12$var$ej(a, b, c);
    }
    return $5cc4a686f46e8a12$var$$i(a, b, c);
}
var $5cc4a686f46e8a12$var$Aj, $5cc4a686f46e8a12$var$Bj, $5cc4a686f46e8a12$var$Cj, $5cc4a686f46e8a12$var$Dj;
$5cc4a686f46e8a12$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$5cc4a686f46e8a12$var$Bj = function() {};
$5cc4a686f46e8a12$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $5cc4a686f46e8a12$var$Hh($5cc4a686f46e8a12$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $5cc4a686f46e8a12$var$Ya(a, e);
                d = $5cc4a686f46e8a12$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $5cc4a686f46e8a12$var$A({}, e, {
                    value: void 0
                });
                d = $5cc4a686f46e8a12$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $5cc4a686f46e8a12$var$gb(a, e);
                d = $5cc4a686f46e8a12$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $5cc4a686f46e8a12$var$Bf);
        }
        $5cc4a686f46e8a12$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($5cc4a686f46e8a12$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($5cc4a686f46e8a12$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $5cc4a686f46e8a12$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$5cc4a686f46e8a12$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $5cc4a686f46e8a12$var$Ej(a, b) {
    if (!$5cc4a686f46e8a12$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $5cc4a686f46e8a12$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $5cc4a686f46e8a12$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $5cc4a686f46e8a12$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $5cc4a686f46e8a12$var$S(b), null;
        case 1:
            return $5cc4a686f46e8a12$var$Zf(b.type) && $5cc4a686f46e8a12$var$$f(), $5cc4a686f46e8a12$var$S(b), null;
        case 3:
            d = b.stateNode;
            $5cc4a686f46e8a12$var$Jh();
            $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$Wf);
            $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$H);
            $5cc4a686f46e8a12$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $5cc4a686f46e8a12$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $5cc4a686f46e8a12$var$zg && ($5cc4a686f46e8a12$var$Gj($5cc4a686f46e8a12$var$zg), $5cc4a686f46e8a12$var$zg = null));
            $5cc4a686f46e8a12$var$Bj(a, b);
            $5cc4a686f46e8a12$var$S(b);
            return null;
        case 5:
            $5cc4a686f46e8a12$var$Lh(b);
            var e = $5cc4a686f46e8a12$var$Hh($5cc4a686f46e8a12$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $5cc4a686f46e8a12$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($5cc4a686f46e8a12$var$p(166));
                    $5cc4a686f46e8a12$var$S(b);
                    return null;
                }
                a = $5cc4a686f46e8a12$var$Hh($5cc4a686f46e8a12$var$Eh.current);
                if ($5cc4a686f46e8a12$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$5cc4a686f46e8a12$var$Of] = b;
                    d[$5cc4a686f46e8a12$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $5cc4a686f46e8a12$var$D("cancel", d);
                            $5cc4a686f46e8a12$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $5cc4a686f46e8a12$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $5cc4a686f46e8a12$var$lf.length; e++)$5cc4a686f46e8a12$var$D($5cc4a686f46e8a12$var$lf[e], d);
                            break;
                        case "source":
                            $5cc4a686f46e8a12$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $5cc4a686f46e8a12$var$D("error", d);
                            $5cc4a686f46e8a12$var$D("load", d);
                            break;
                        case "details":
                            $5cc4a686f46e8a12$var$D("toggle", d);
                            break;
                        case "input":
                            $5cc4a686f46e8a12$var$Za(d, f);
                            $5cc4a686f46e8a12$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $5cc4a686f46e8a12$var$D("invalid", d);
                            break;
                        case "textarea":
                            $5cc4a686f46e8a12$var$hb(d, f), $5cc4a686f46e8a12$var$D("invalid", d);
                    }
                    $5cc4a686f46e8a12$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $5cc4a686f46e8a12$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $5cc4a686f46e8a12$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $5cc4a686f46e8a12$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $5cc4a686f46e8a12$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $5cc4a686f46e8a12$var$Va(d);
                            $5cc4a686f46e8a12$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $5cc4a686f46e8a12$var$Va(d);
                            $5cc4a686f46e8a12$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $5cc4a686f46e8a12$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $5cc4a686f46e8a12$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$5cc4a686f46e8a12$var$Of] = b;
                    a[$5cc4a686f46e8a12$var$Pf] = d;
                    $5cc4a686f46e8a12$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $5cc4a686f46e8a12$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $5cc4a686f46e8a12$var$D("cancel", a);
                                $5cc4a686f46e8a12$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $5cc4a686f46e8a12$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $5cc4a686f46e8a12$var$lf.length; e++)$5cc4a686f46e8a12$var$D($5cc4a686f46e8a12$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $5cc4a686f46e8a12$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $5cc4a686f46e8a12$var$D("error", a);
                                $5cc4a686f46e8a12$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $5cc4a686f46e8a12$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $5cc4a686f46e8a12$var$Za(a, d);
                                e = $5cc4a686f46e8a12$var$Ya(a, d);
                                $5cc4a686f46e8a12$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $5cc4a686f46e8a12$var$A({}, d, {
                                    value: void 0
                                });
                                $5cc4a686f46e8a12$var$D("invalid", a);
                                break;
                            case "textarea":
                                $5cc4a686f46e8a12$var$hb(a, d);
                                e = $5cc4a686f46e8a12$var$gb(a, d);
                                $5cc4a686f46e8a12$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $5cc4a686f46e8a12$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $5cc4a686f46e8a12$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $5cc4a686f46e8a12$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $5cc4a686f46e8a12$var$ob(a, k) : "number" === typeof k && $5cc4a686f46e8a12$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($5cc4a686f46e8a12$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $5cc4a686f46e8a12$var$D("scroll", a) : null != k && $5cc4a686f46e8a12$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $5cc4a686f46e8a12$var$Va(a);
                                $5cc4a686f46e8a12$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $5cc4a686f46e8a12$var$Va(a);
                                $5cc4a686f46e8a12$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $5cc4a686f46e8a12$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $5cc4a686f46e8a12$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $5cc4a686f46e8a12$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $5cc4a686f46e8a12$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $5cc4a686f46e8a12$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $5cc4a686f46e8a12$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($5cc4a686f46e8a12$var$p(166));
                c = $5cc4a686f46e8a12$var$Hh($5cc4a686f46e8a12$var$Gh.current);
                $5cc4a686f46e8a12$var$Hh($5cc4a686f46e8a12$var$Eh.current);
                if ($5cc4a686f46e8a12$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$5cc4a686f46e8a12$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $5cc4a686f46e8a12$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $5cc4a686f46e8a12$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $5cc4a686f46e8a12$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$5cc4a686f46e8a12$var$Of] = b, b.stateNode = d;
            }
            $5cc4a686f46e8a12$var$S(b);
            return null;
        case 13:
            $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($5cc4a686f46e8a12$var$I && null !== $5cc4a686f46e8a12$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $5cc4a686f46e8a12$var$Hg(), $5cc4a686f46e8a12$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $5cc4a686f46e8a12$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($5cc4a686f46e8a12$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($5cc4a686f46e8a12$var$p(317));
                        f[$5cc4a686f46e8a12$var$Of] = b;
                    } else $5cc4a686f46e8a12$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $5cc4a686f46e8a12$var$S(b);
                    f = !1;
                } else null !== $5cc4a686f46e8a12$var$zg && ($5cc4a686f46e8a12$var$Gj($5cc4a686f46e8a12$var$zg), $5cc4a686f46e8a12$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($5cc4a686f46e8a12$var$M.current & 1) ? 0 === $5cc4a686f46e8a12$var$T && ($5cc4a686f46e8a12$var$T = 3) : $5cc4a686f46e8a12$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $5cc4a686f46e8a12$var$S(b);
            return null;
        case 4:
            return $5cc4a686f46e8a12$var$Jh(), $5cc4a686f46e8a12$var$Bj(a, b), null === a && $5cc4a686f46e8a12$var$sf(b.stateNode.containerInfo), $5cc4a686f46e8a12$var$S(b), null;
        case 10:
            return $5cc4a686f46e8a12$var$Rg(b.type._context), $5cc4a686f46e8a12$var$S(b), null;
        case 17:
            return $5cc4a686f46e8a12$var$Zf(b.type) && $5cc4a686f46e8a12$var$$f(), $5cc4a686f46e8a12$var$S(b), null;
        case 19:
            $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$M);
            f = b.memoizedState;
            if (null === f) return $5cc4a686f46e8a12$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $5cc4a686f46e8a12$var$Ej(f, !1);
                else {
                    if (0 !== $5cc4a686f46e8a12$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $5cc4a686f46e8a12$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $5cc4a686f46e8a12$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$M, $5cc4a686f46e8a12$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $5cc4a686f46e8a12$var$B() > $5cc4a686f46e8a12$var$Hj && (b.flags |= 128, d = !0, $5cc4a686f46e8a12$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $5cc4a686f46e8a12$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $5cc4a686f46e8a12$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$5cc4a686f46e8a12$var$I) return $5cc4a686f46e8a12$var$S(b), null;
                    } else 2 * $5cc4a686f46e8a12$var$B() - f.renderingStartTime > $5cc4a686f46e8a12$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $5cc4a686f46e8a12$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $5cc4a686f46e8a12$var$B(), b.sibling = null, c = $5cc4a686f46e8a12$var$M.current, $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$M, d ? c & 1 | 2 : c & 1), b;
            $5cc4a686f46e8a12$var$S(b);
            return null;
        case 22:
        case 23:
            return $5cc4a686f46e8a12$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($5cc4a686f46e8a12$var$gj & 1073741824) && ($5cc4a686f46e8a12$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $5cc4a686f46e8a12$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($5cc4a686f46e8a12$var$p(156, b.tag));
}
function $5cc4a686f46e8a12$var$Jj(a, b) {
    $5cc4a686f46e8a12$var$wg(b);
    switch(b.tag){
        case 1:
            return $5cc4a686f46e8a12$var$Zf(b.type) && $5cc4a686f46e8a12$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $5cc4a686f46e8a12$var$Jh(), $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$Wf), $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$H), $5cc4a686f46e8a12$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $5cc4a686f46e8a12$var$Lh(b), null;
        case 13:
            $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($5cc4a686f46e8a12$var$p(340));
                $5cc4a686f46e8a12$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$M), null;
        case 4:
            return $5cc4a686f46e8a12$var$Jh(), null;
        case 10:
            return $5cc4a686f46e8a12$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $5cc4a686f46e8a12$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $5cc4a686f46e8a12$var$Kj = !1, $5cc4a686f46e8a12$var$U = !1, $5cc4a686f46e8a12$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $5cc4a686f46e8a12$var$V = null;
function $5cc4a686f46e8a12$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $5cc4a686f46e8a12$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $5cc4a686f46e8a12$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $5cc4a686f46e8a12$var$W(a, b, d);
    }
}
var $5cc4a686f46e8a12$var$Oj = !1;
function $5cc4a686f46e8a12$var$Pj(a, b) {
    $5cc4a686f46e8a12$var$Cf = $5cc4a686f46e8a12$var$dd;
    a = $5cc4a686f46e8a12$var$Me();
    if ($5cc4a686f46e8a12$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $5cc4a686f46e8a12$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $5cc4a686f46e8a12$var$dd = !1;
    for($5cc4a686f46e8a12$var$V = b; null !== $5cc4a686f46e8a12$var$V;)if (b = $5cc4a686f46e8a12$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $5cc4a686f46e8a12$var$V = a;
    else for(; null !== $5cc4a686f46e8a12$var$V;){
        b = $5cc4a686f46e8a12$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $5cc4a686f46e8a12$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($5cc4a686f46e8a12$var$p(163));
            }
        } catch (F) {
            $5cc4a686f46e8a12$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $5cc4a686f46e8a12$var$V = a;
            break;
        }
        $5cc4a686f46e8a12$var$V = b.return;
    }
    n = $5cc4a686f46e8a12$var$Oj;
    $5cc4a686f46e8a12$var$Oj = !1;
    return n;
}
function $5cc4a686f46e8a12$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $5cc4a686f46e8a12$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $5cc4a686f46e8a12$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $5cc4a686f46e8a12$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $5cc4a686f46e8a12$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $5cc4a686f46e8a12$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$5cc4a686f46e8a12$var$Of], delete b[$5cc4a686f46e8a12$var$Pf], delete b[$5cc4a686f46e8a12$var$of], delete b[$5cc4a686f46e8a12$var$Qf], delete b[$5cc4a686f46e8a12$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $5cc4a686f46e8a12$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $5cc4a686f46e8a12$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $5cc4a686f46e8a12$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $5cc4a686f46e8a12$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $5cc4a686f46e8a12$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($5cc4a686f46e8a12$var$Wj(a, b, c), a = a.sibling; null !== a;)$5cc4a686f46e8a12$var$Wj(a, b, c), a = a.sibling;
}
function $5cc4a686f46e8a12$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($5cc4a686f46e8a12$var$Xj(a, b, c), a = a.sibling; null !== a;)$5cc4a686f46e8a12$var$Xj(a, b, c), a = a.sibling;
}
var $5cc4a686f46e8a12$var$X = null, $5cc4a686f46e8a12$var$Yj = !1;
function $5cc4a686f46e8a12$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$5cc4a686f46e8a12$var$ak(a, b, c), c = c.sibling;
}
function $5cc4a686f46e8a12$var$ak(a, b, c) {
    if ($5cc4a686f46e8a12$var$lc && "function" === typeof $5cc4a686f46e8a12$var$lc.onCommitFiberUnmount) try {
        $5cc4a686f46e8a12$var$lc.onCommitFiberUnmount($5cc4a686f46e8a12$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $5cc4a686f46e8a12$var$U || $5cc4a686f46e8a12$var$Mj(c, b);
        case 6:
            var d = $5cc4a686f46e8a12$var$X, e = $5cc4a686f46e8a12$var$Yj;
            $5cc4a686f46e8a12$var$X = null;
            $5cc4a686f46e8a12$var$Zj(a, b, c);
            $5cc4a686f46e8a12$var$X = d;
            $5cc4a686f46e8a12$var$Yj = e;
            null !== $5cc4a686f46e8a12$var$X && ($5cc4a686f46e8a12$var$Yj ? (a = $5cc4a686f46e8a12$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $5cc4a686f46e8a12$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $5cc4a686f46e8a12$var$X && ($5cc4a686f46e8a12$var$Yj ? (a = $5cc4a686f46e8a12$var$X, c = c.stateNode, 8 === a.nodeType ? $5cc4a686f46e8a12$var$Kf(a.parentNode, c) : 1 === a.nodeType && $5cc4a686f46e8a12$var$Kf(a, c), $5cc4a686f46e8a12$var$bd(a)) : $5cc4a686f46e8a12$var$Kf($5cc4a686f46e8a12$var$X, c.stateNode));
            break;
        case 4:
            d = $5cc4a686f46e8a12$var$X;
            e = $5cc4a686f46e8a12$var$Yj;
            $5cc4a686f46e8a12$var$X = c.stateNode.containerInfo;
            $5cc4a686f46e8a12$var$Yj = !0;
            $5cc4a686f46e8a12$var$Zj(a, b, c);
            $5cc4a686f46e8a12$var$X = d;
            $5cc4a686f46e8a12$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$5cc4a686f46e8a12$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $5cc4a686f46e8a12$var$Nj(c, b, g) : 0 !== (f & 4) && $5cc4a686f46e8a12$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $5cc4a686f46e8a12$var$Zj(a, b, c);
            break;
        case 1:
            if (!$5cc4a686f46e8a12$var$U && ($5cc4a686f46e8a12$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $5cc4a686f46e8a12$var$W(c, b, h);
            }
            $5cc4a686f46e8a12$var$Zj(a, b, c);
            break;
        case 21:
            $5cc4a686f46e8a12$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($5cc4a686f46e8a12$var$U = (d = $5cc4a686f46e8a12$var$U) || null !== c.memoizedState, $5cc4a686f46e8a12$var$Zj(a, b, c), $5cc4a686f46e8a12$var$U = d) : $5cc4a686f46e8a12$var$Zj(a, b, c);
            break;
        default:
            $5cc4a686f46e8a12$var$Zj(a, b, c);
    }
}
function $5cc4a686f46e8a12$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $5cc4a686f46e8a12$var$Lj);
        b.forEach(function(b) {
            var d = $5cc4a686f46e8a12$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $5cc4a686f46e8a12$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $5cc4a686f46e8a12$var$X = h.stateNode;
                        $5cc4a686f46e8a12$var$Yj = !1;
                        break a;
                    case 3:
                        $5cc4a686f46e8a12$var$X = h.stateNode.containerInfo;
                        $5cc4a686f46e8a12$var$Yj = !0;
                        break a;
                    case 4:
                        $5cc4a686f46e8a12$var$X = h.stateNode.containerInfo;
                        $5cc4a686f46e8a12$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $5cc4a686f46e8a12$var$X) throw Error($5cc4a686f46e8a12$var$p(160));
            $5cc4a686f46e8a12$var$ak(f, g, e);
            $5cc4a686f46e8a12$var$X = null;
            $5cc4a686f46e8a12$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $5cc4a686f46e8a12$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$5cc4a686f46e8a12$var$ek(b, a), b = b.sibling;
}
function $5cc4a686f46e8a12$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $5cc4a686f46e8a12$var$dk(b, a);
            $5cc4a686f46e8a12$var$fk(a);
            if (d & 4) {
                try {
                    $5cc4a686f46e8a12$var$Qj(3, a, a.return), $5cc4a686f46e8a12$var$Rj(3, a);
                } catch (t) {
                    $5cc4a686f46e8a12$var$W(a, a.return, t);
                }
                try {
                    $5cc4a686f46e8a12$var$Qj(5, a, a.return);
                } catch (t) {
                    $5cc4a686f46e8a12$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $5cc4a686f46e8a12$var$dk(b, a);
            $5cc4a686f46e8a12$var$fk(a);
            d & 512 && null !== c && $5cc4a686f46e8a12$var$Mj(c, c.return);
            break;
        case 5:
            $5cc4a686f46e8a12$var$dk(b, a);
            $5cc4a686f46e8a12$var$fk(a);
            d & 512 && null !== c && $5cc4a686f46e8a12$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $5cc4a686f46e8a12$var$ob(e, "");
                } catch (t) {
                    $5cc4a686f46e8a12$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $5cc4a686f46e8a12$var$ab(e, f);
                    $5cc4a686f46e8a12$var$vb(h, g);
                    var l = $5cc4a686f46e8a12$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $5cc4a686f46e8a12$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $5cc4a686f46e8a12$var$nb(e, q) : "children" === m ? $5cc4a686f46e8a12$var$ob(e, q) : $5cc4a686f46e8a12$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $5cc4a686f46e8a12$var$bb(e, f);
                            break;
                        case "textarea":
                            $5cc4a686f46e8a12$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $5cc4a686f46e8a12$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $5cc4a686f46e8a12$var$fb(e, !!f.multiple, f.defaultValue, !0) : $5cc4a686f46e8a12$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$5cc4a686f46e8a12$var$Pf] = f;
                } catch (t) {
                    $5cc4a686f46e8a12$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $5cc4a686f46e8a12$var$dk(b, a);
            $5cc4a686f46e8a12$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($5cc4a686f46e8a12$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $5cc4a686f46e8a12$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $5cc4a686f46e8a12$var$dk(b, a);
            $5cc4a686f46e8a12$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $5cc4a686f46e8a12$var$bd(b.containerInfo);
            } catch (t) {
                $5cc4a686f46e8a12$var$W(a, a.return, t);
            }
            break;
        case 4:
            $5cc4a686f46e8a12$var$dk(b, a);
            $5cc4a686f46e8a12$var$fk(a);
            break;
        case 13:
            $5cc4a686f46e8a12$var$dk(b, a);
            $5cc4a686f46e8a12$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($5cc4a686f46e8a12$var$gk = $5cc4a686f46e8a12$var$B()));
            d & 4 && $5cc4a686f46e8a12$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($5cc4a686f46e8a12$var$U = (l = $5cc4a686f46e8a12$var$U) || m, $5cc4a686f46e8a12$var$dk(b, a), $5cc4a686f46e8a12$var$U = l) : $5cc4a686f46e8a12$var$dk(b, a);
            $5cc4a686f46e8a12$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($5cc4a686f46e8a12$var$V = a, m = a.child; null !== m;){
                    for(q = $5cc4a686f46e8a12$var$V = m; null !== $5cc4a686f46e8a12$var$V;){
                        r = $5cc4a686f46e8a12$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $5cc4a686f46e8a12$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $5cc4a686f46e8a12$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $5cc4a686f46e8a12$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $5cc4a686f46e8a12$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $5cc4a686f46e8a12$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $5cc4a686f46e8a12$var$V = y) : $5cc4a686f46e8a12$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $5cc4a686f46e8a12$var$rb("display", g));
                            } catch (t) {
                                $5cc4a686f46e8a12$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $5cc4a686f46e8a12$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $5cc4a686f46e8a12$var$dk(b, a);
            $5cc4a686f46e8a12$var$fk(a);
            d & 4 && $5cc4a686f46e8a12$var$bk(a);
            break;
        case 21:
            break;
        default:
            $5cc4a686f46e8a12$var$dk(b, a), $5cc4a686f46e8a12$var$fk(a);
    }
}
function $5cc4a686f46e8a12$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($5cc4a686f46e8a12$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($5cc4a686f46e8a12$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($5cc4a686f46e8a12$var$ob(e, ""), d.flags &= -33);
                    var f = $5cc4a686f46e8a12$var$Vj(a);
                    $5cc4a686f46e8a12$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $5cc4a686f46e8a12$var$Vj(a);
                    $5cc4a686f46e8a12$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($5cc4a686f46e8a12$var$p(161));
            }
        } catch (k) {
            $5cc4a686f46e8a12$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $5cc4a686f46e8a12$var$ik(a, b, c) {
    $5cc4a686f46e8a12$var$V = a;
    $5cc4a686f46e8a12$var$jk(a, b, c);
}
function $5cc4a686f46e8a12$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $5cc4a686f46e8a12$var$V;){
        var e = $5cc4a686f46e8a12$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $5cc4a686f46e8a12$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $5cc4a686f46e8a12$var$U;
                h = $5cc4a686f46e8a12$var$Kj;
                var l = $5cc4a686f46e8a12$var$U;
                $5cc4a686f46e8a12$var$Kj = g;
                if (($5cc4a686f46e8a12$var$U = k) && !l) for($5cc4a686f46e8a12$var$V = e; null !== $5cc4a686f46e8a12$var$V;)g = $5cc4a686f46e8a12$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $5cc4a686f46e8a12$var$kk(e) : null !== k ? (k.return = g, $5cc4a686f46e8a12$var$V = k) : $5cc4a686f46e8a12$var$kk(e);
                for(; null !== f;)$5cc4a686f46e8a12$var$V = f, $5cc4a686f46e8a12$var$jk(f, b, c), f = f.sibling;
                $5cc4a686f46e8a12$var$V = e;
                $5cc4a686f46e8a12$var$Kj = h;
                $5cc4a686f46e8a12$var$U = l;
            }
            $5cc4a686f46e8a12$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $5cc4a686f46e8a12$var$V = f) : $5cc4a686f46e8a12$var$lk(a, b, c);
    }
}
function $5cc4a686f46e8a12$var$lk(a) {
    for(; null !== $5cc4a686f46e8a12$var$V;){
        var b = $5cc4a686f46e8a12$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $5cc4a686f46e8a12$var$U || $5cc4a686f46e8a12$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$5cc4a686f46e8a12$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $5cc4a686f46e8a12$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $5cc4a686f46e8a12$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $5cc4a686f46e8a12$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $5cc4a686f46e8a12$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($5cc4a686f46e8a12$var$p(163));
                }
                $5cc4a686f46e8a12$var$U || b.flags & 512 && $5cc4a686f46e8a12$var$Sj(b);
            } catch (r) {
                $5cc4a686f46e8a12$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $5cc4a686f46e8a12$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $5cc4a686f46e8a12$var$V = c;
            break;
        }
        $5cc4a686f46e8a12$var$V = b.return;
    }
}
function $5cc4a686f46e8a12$var$hk(a) {
    for(; null !== $5cc4a686f46e8a12$var$V;){
        var b = $5cc4a686f46e8a12$var$V;
        if (b === a) {
            $5cc4a686f46e8a12$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $5cc4a686f46e8a12$var$V = c;
            break;
        }
        $5cc4a686f46e8a12$var$V = b.return;
    }
}
function $5cc4a686f46e8a12$var$kk(a) {
    for(; null !== $5cc4a686f46e8a12$var$V;){
        var b = $5cc4a686f46e8a12$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $5cc4a686f46e8a12$var$Rj(4, b);
                    } catch (k) {
                        $5cc4a686f46e8a12$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $5cc4a686f46e8a12$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $5cc4a686f46e8a12$var$Sj(b);
                    } catch (k) {
                        $5cc4a686f46e8a12$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $5cc4a686f46e8a12$var$Sj(b);
                    } catch (k) {
                        $5cc4a686f46e8a12$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $5cc4a686f46e8a12$var$W(b, b.return, k);
        }
        if (b === a) {
            $5cc4a686f46e8a12$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $5cc4a686f46e8a12$var$V = h;
            break;
        }
        $5cc4a686f46e8a12$var$V = b.return;
    }
}
var $5cc4a686f46e8a12$var$mk = Math.ceil, $5cc4a686f46e8a12$var$nk = $5cc4a686f46e8a12$var$ua.ReactCurrentDispatcher, $5cc4a686f46e8a12$var$ok = $5cc4a686f46e8a12$var$ua.ReactCurrentOwner, $5cc4a686f46e8a12$var$pk = $5cc4a686f46e8a12$var$ua.ReactCurrentBatchConfig, $5cc4a686f46e8a12$var$K = 0, $5cc4a686f46e8a12$var$R = null, $5cc4a686f46e8a12$var$Y = null, $5cc4a686f46e8a12$var$Z = 0, $5cc4a686f46e8a12$var$gj = 0, $5cc4a686f46e8a12$var$fj = $5cc4a686f46e8a12$var$Uf(0), $5cc4a686f46e8a12$var$T = 0, $5cc4a686f46e8a12$var$qk = null, $5cc4a686f46e8a12$var$hh = 0, $5cc4a686f46e8a12$var$rk = 0, $5cc4a686f46e8a12$var$sk = 0, $5cc4a686f46e8a12$var$tk = null, $5cc4a686f46e8a12$var$uk = null, $5cc4a686f46e8a12$var$gk = 0, $5cc4a686f46e8a12$var$Hj = Infinity, $5cc4a686f46e8a12$var$vk = null, $5cc4a686f46e8a12$var$Pi = !1, $5cc4a686f46e8a12$var$Qi = null, $5cc4a686f46e8a12$var$Si = null, $5cc4a686f46e8a12$var$wk = !1, $5cc4a686f46e8a12$var$xk = null, $5cc4a686f46e8a12$var$yk = 0, $5cc4a686f46e8a12$var$zk = 0, $5cc4a686f46e8a12$var$Ak = null, $5cc4a686f46e8a12$var$Bk = -1, $5cc4a686f46e8a12$var$Ck = 0;
function $5cc4a686f46e8a12$var$L() {
    return 0 !== ($5cc4a686f46e8a12$var$K & 6) ? $5cc4a686f46e8a12$var$B() : -1 !== $5cc4a686f46e8a12$var$Bk ? $5cc4a686f46e8a12$var$Bk : $5cc4a686f46e8a12$var$Bk = $5cc4a686f46e8a12$var$B();
}
function $5cc4a686f46e8a12$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($5cc4a686f46e8a12$var$K & 2) && 0 !== $5cc4a686f46e8a12$var$Z) return $5cc4a686f46e8a12$var$Z & -$5cc4a686f46e8a12$var$Z;
    if (null !== $5cc4a686f46e8a12$var$Kg.transition) return 0 === $5cc4a686f46e8a12$var$Ck && ($5cc4a686f46e8a12$var$Ck = $5cc4a686f46e8a12$var$yc()), $5cc4a686f46e8a12$var$Ck;
    a = $5cc4a686f46e8a12$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $5cc4a686f46e8a12$var$jd(a.type);
    return a;
}
function $5cc4a686f46e8a12$var$mh(a, b, c, d) {
    if (50 < $5cc4a686f46e8a12$var$zk) throw $5cc4a686f46e8a12$var$zk = 0, $5cc4a686f46e8a12$var$Ak = null, Error($5cc4a686f46e8a12$var$p(185));
    $5cc4a686f46e8a12$var$Ac(a, c, d);
    if (0 === ($5cc4a686f46e8a12$var$K & 2) || a !== $5cc4a686f46e8a12$var$R) a === $5cc4a686f46e8a12$var$R && (0 === ($5cc4a686f46e8a12$var$K & 2) && ($5cc4a686f46e8a12$var$rk |= c), 4 === $5cc4a686f46e8a12$var$T && $5cc4a686f46e8a12$var$Dk(a, $5cc4a686f46e8a12$var$Z)), $5cc4a686f46e8a12$var$Ek(a, d), 1 === c && 0 === $5cc4a686f46e8a12$var$K && 0 === (b.mode & 1) && ($5cc4a686f46e8a12$var$Hj = $5cc4a686f46e8a12$var$B() + 500, $5cc4a686f46e8a12$var$fg && $5cc4a686f46e8a12$var$jg());
}
function $5cc4a686f46e8a12$var$Ek(a, b) {
    var c = a.callbackNode;
    $5cc4a686f46e8a12$var$wc(a, b);
    var d = $5cc4a686f46e8a12$var$uc(a, a === $5cc4a686f46e8a12$var$R ? $5cc4a686f46e8a12$var$Z : 0);
    if (0 === d) null !== c && $5cc4a686f46e8a12$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $5cc4a686f46e8a12$var$bc(c);
        if (1 === b) 0 === a.tag ? $5cc4a686f46e8a12$var$ig($5cc4a686f46e8a12$var$Fk.bind(null, a)) : $5cc4a686f46e8a12$var$hg($5cc4a686f46e8a12$var$Fk.bind(null, a)), $5cc4a686f46e8a12$var$Jf(function() {
            0 === ($5cc4a686f46e8a12$var$K & 6) && $5cc4a686f46e8a12$var$jg();
        }), c = null;
        else {
            switch($5cc4a686f46e8a12$var$Dc(d)){
                case 1:
                    c = $5cc4a686f46e8a12$var$fc;
                    break;
                case 4:
                    c = $5cc4a686f46e8a12$var$gc;
                    break;
                case 16:
                    c = $5cc4a686f46e8a12$var$hc;
                    break;
                case 536870912:
                    c = $5cc4a686f46e8a12$var$jc;
                    break;
                default:
                    c = $5cc4a686f46e8a12$var$hc;
            }
            c = $5cc4a686f46e8a12$var$Gk(c, $5cc4a686f46e8a12$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $5cc4a686f46e8a12$var$Hk(a, b) {
    $5cc4a686f46e8a12$var$Bk = -1;
    $5cc4a686f46e8a12$var$Ck = 0;
    if (0 !== ($5cc4a686f46e8a12$var$K & 6)) throw Error($5cc4a686f46e8a12$var$p(327));
    var c = a.callbackNode;
    if ($5cc4a686f46e8a12$var$Ik() && a.callbackNode !== c) return null;
    var d = $5cc4a686f46e8a12$var$uc(a, a === $5cc4a686f46e8a12$var$R ? $5cc4a686f46e8a12$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $5cc4a686f46e8a12$var$Jk(a, d);
    else {
        b = d;
        var e = $5cc4a686f46e8a12$var$K;
        $5cc4a686f46e8a12$var$K |= 2;
        var f = $5cc4a686f46e8a12$var$Kk();
        if ($5cc4a686f46e8a12$var$R !== a || $5cc4a686f46e8a12$var$Z !== b) $5cc4a686f46e8a12$var$vk = null, $5cc4a686f46e8a12$var$Hj = $5cc4a686f46e8a12$var$B() + 500, $5cc4a686f46e8a12$var$Lk(a, b);
        for(;;)try {
            $5cc4a686f46e8a12$var$Mk();
            break;
        } catch (h) {
            $5cc4a686f46e8a12$var$Nk(a, h);
        }
        $5cc4a686f46e8a12$var$Qg();
        $5cc4a686f46e8a12$var$nk.current = f;
        $5cc4a686f46e8a12$var$K = e;
        null !== $5cc4a686f46e8a12$var$Y ? b = 0 : ($5cc4a686f46e8a12$var$R = null, $5cc4a686f46e8a12$var$Z = 0, b = $5cc4a686f46e8a12$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $5cc4a686f46e8a12$var$xc(a), 0 !== e && (d = e, b = $5cc4a686f46e8a12$var$Ok(a, e)));
        if (1 === b) throw c = $5cc4a686f46e8a12$var$qk, $5cc4a686f46e8a12$var$Lk(a, 0), $5cc4a686f46e8a12$var$Dk(a, d), $5cc4a686f46e8a12$var$Ek(a, $5cc4a686f46e8a12$var$B()), c;
        if (6 === b) $5cc4a686f46e8a12$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$5cc4a686f46e8a12$var$Pk(e) && (b = $5cc4a686f46e8a12$var$Jk(a, d), 2 === b && (f = $5cc4a686f46e8a12$var$xc(a), 0 !== f && (d = f, b = $5cc4a686f46e8a12$var$Ok(a, f))), 1 === b)) throw c = $5cc4a686f46e8a12$var$qk, $5cc4a686f46e8a12$var$Lk(a, 0), $5cc4a686f46e8a12$var$Dk(a, d), $5cc4a686f46e8a12$var$Ek(a, $5cc4a686f46e8a12$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($5cc4a686f46e8a12$var$p(345));
                case 2:
                    $5cc4a686f46e8a12$var$Qk(a, $5cc4a686f46e8a12$var$uk, $5cc4a686f46e8a12$var$vk);
                    break;
                case 3:
                    $5cc4a686f46e8a12$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $5cc4a686f46e8a12$var$gk + 500 - $5cc4a686f46e8a12$var$B(), 10 < b)) {
                        if (0 !== $5cc4a686f46e8a12$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $5cc4a686f46e8a12$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $5cc4a686f46e8a12$var$Ff($5cc4a686f46e8a12$var$Qk.bind(null, a, $5cc4a686f46e8a12$var$uk, $5cc4a686f46e8a12$var$vk), b);
                        break;
                    }
                    $5cc4a686f46e8a12$var$Qk(a, $5cc4a686f46e8a12$var$uk, $5cc4a686f46e8a12$var$vk);
                    break;
                case 4:
                    $5cc4a686f46e8a12$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $5cc4a686f46e8a12$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $5cc4a686f46e8a12$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $5cc4a686f46e8a12$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $5cc4a686f46e8a12$var$Ff($5cc4a686f46e8a12$var$Qk.bind(null, a, $5cc4a686f46e8a12$var$uk, $5cc4a686f46e8a12$var$vk), d);
                        break;
                    }
                    $5cc4a686f46e8a12$var$Qk(a, $5cc4a686f46e8a12$var$uk, $5cc4a686f46e8a12$var$vk);
                    break;
                case 5:
                    $5cc4a686f46e8a12$var$Qk(a, $5cc4a686f46e8a12$var$uk, $5cc4a686f46e8a12$var$vk);
                    break;
                default:
                    throw Error($5cc4a686f46e8a12$var$p(329));
            }
        }
    }
    $5cc4a686f46e8a12$var$Ek(a, $5cc4a686f46e8a12$var$B());
    return a.callbackNode === c ? $5cc4a686f46e8a12$var$Hk.bind(null, a) : null;
}
function $5cc4a686f46e8a12$var$Ok(a, b) {
    var c = $5cc4a686f46e8a12$var$tk;
    a.current.memoizedState.isDehydrated && ($5cc4a686f46e8a12$var$Lk(a, b).flags |= 256);
    a = $5cc4a686f46e8a12$var$Jk(a, b);
    2 !== a && (b = $5cc4a686f46e8a12$var$uk, $5cc4a686f46e8a12$var$uk = c, null !== b && $5cc4a686f46e8a12$var$Gj(b));
    return a;
}
function $5cc4a686f46e8a12$var$Gj(a) {
    null === $5cc4a686f46e8a12$var$uk ? $5cc4a686f46e8a12$var$uk = a : $5cc4a686f46e8a12$var$uk.push.apply($5cc4a686f46e8a12$var$uk, a);
}
function $5cc4a686f46e8a12$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$5cc4a686f46e8a12$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $5cc4a686f46e8a12$var$Dk(a, b) {
    b &= ~$5cc4a686f46e8a12$var$sk;
    b &= ~$5cc4a686f46e8a12$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $5cc4a686f46e8a12$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $5cc4a686f46e8a12$var$Fk(a) {
    if (0 !== ($5cc4a686f46e8a12$var$K & 6)) throw Error($5cc4a686f46e8a12$var$p(327));
    $5cc4a686f46e8a12$var$Ik();
    var b = $5cc4a686f46e8a12$var$uc(a, 0);
    if (0 === (b & 1)) return $5cc4a686f46e8a12$var$Ek(a, $5cc4a686f46e8a12$var$B()), null;
    var c = $5cc4a686f46e8a12$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $5cc4a686f46e8a12$var$xc(a);
        0 !== d && (b = d, c = $5cc4a686f46e8a12$var$Ok(a, d));
    }
    if (1 === c) throw c = $5cc4a686f46e8a12$var$qk, $5cc4a686f46e8a12$var$Lk(a, 0), $5cc4a686f46e8a12$var$Dk(a, b), $5cc4a686f46e8a12$var$Ek(a, $5cc4a686f46e8a12$var$B()), c;
    if (6 === c) throw Error($5cc4a686f46e8a12$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $5cc4a686f46e8a12$var$Qk(a, $5cc4a686f46e8a12$var$uk, $5cc4a686f46e8a12$var$vk);
    $5cc4a686f46e8a12$var$Ek(a, $5cc4a686f46e8a12$var$B());
    return null;
}
function $5cc4a686f46e8a12$var$Rk(a, b) {
    var c = $5cc4a686f46e8a12$var$K;
    $5cc4a686f46e8a12$var$K |= 1;
    try {
        return a(b);
    } finally{
        $5cc4a686f46e8a12$var$K = c, 0 === $5cc4a686f46e8a12$var$K && ($5cc4a686f46e8a12$var$Hj = $5cc4a686f46e8a12$var$B() + 500, $5cc4a686f46e8a12$var$fg && $5cc4a686f46e8a12$var$jg());
    }
}
function $5cc4a686f46e8a12$var$Sk(a) {
    null !== $5cc4a686f46e8a12$var$xk && 0 === $5cc4a686f46e8a12$var$xk.tag && 0 === ($5cc4a686f46e8a12$var$K & 6) && $5cc4a686f46e8a12$var$Ik();
    var b = $5cc4a686f46e8a12$var$K;
    $5cc4a686f46e8a12$var$K |= 1;
    var c = $5cc4a686f46e8a12$var$pk.transition, d = $5cc4a686f46e8a12$var$C;
    try {
        if ($5cc4a686f46e8a12$var$pk.transition = null, $5cc4a686f46e8a12$var$C = 1, a) return a();
    } finally{
        $5cc4a686f46e8a12$var$C = d, $5cc4a686f46e8a12$var$pk.transition = c, $5cc4a686f46e8a12$var$K = b, 0 === ($5cc4a686f46e8a12$var$K & 6) && $5cc4a686f46e8a12$var$jg();
    }
}
function $5cc4a686f46e8a12$var$Ij() {
    $5cc4a686f46e8a12$var$gj = $5cc4a686f46e8a12$var$fj.current;
    $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$fj);
}
function $5cc4a686f46e8a12$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $5cc4a686f46e8a12$var$Gf(c));
    if (null !== $5cc4a686f46e8a12$var$Y) for(c = $5cc4a686f46e8a12$var$Y.return; null !== c;){
        var d = c;
        $5cc4a686f46e8a12$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $5cc4a686f46e8a12$var$$f();
                break;
            case 3:
                $5cc4a686f46e8a12$var$Jh();
                $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$Wf);
                $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$H);
                $5cc4a686f46e8a12$var$Oh();
                break;
            case 5:
                $5cc4a686f46e8a12$var$Lh(d);
                break;
            case 4:
                $5cc4a686f46e8a12$var$Jh();
                break;
            case 13:
                $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$M);
                break;
            case 19:
                $5cc4a686f46e8a12$var$E($5cc4a686f46e8a12$var$M);
                break;
            case 10:
                $5cc4a686f46e8a12$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $5cc4a686f46e8a12$var$Ij();
        }
        c = c.return;
    }
    $5cc4a686f46e8a12$var$R = a;
    $5cc4a686f46e8a12$var$Y = a = $5cc4a686f46e8a12$var$wh(a.current, null);
    $5cc4a686f46e8a12$var$Z = $5cc4a686f46e8a12$var$gj = b;
    $5cc4a686f46e8a12$var$T = 0;
    $5cc4a686f46e8a12$var$qk = null;
    $5cc4a686f46e8a12$var$sk = $5cc4a686f46e8a12$var$rk = $5cc4a686f46e8a12$var$hh = 0;
    $5cc4a686f46e8a12$var$uk = $5cc4a686f46e8a12$var$tk = null;
    if (null !== $5cc4a686f46e8a12$var$Wg) {
        for(b = 0; b < $5cc4a686f46e8a12$var$Wg.length; b++)if (c = $5cc4a686f46e8a12$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $5cc4a686f46e8a12$var$Wg = null;
    }
    return a;
}
function $5cc4a686f46e8a12$var$Nk(a, b) {
    do {
        var c = $5cc4a686f46e8a12$var$Y;
        try {
            $5cc4a686f46e8a12$var$Qg();
            $5cc4a686f46e8a12$var$Ph.current = $5cc4a686f46e8a12$var$ai;
            if ($5cc4a686f46e8a12$var$Sh) {
                for(var d = $5cc4a686f46e8a12$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $5cc4a686f46e8a12$var$Sh = !1;
            }
            $5cc4a686f46e8a12$var$Rh = 0;
            $5cc4a686f46e8a12$var$P = $5cc4a686f46e8a12$var$O = $5cc4a686f46e8a12$var$N = null;
            $5cc4a686f46e8a12$var$Th = !1;
            $5cc4a686f46e8a12$var$Uh = 0;
            $5cc4a686f46e8a12$var$ok.current = null;
            if (null === c || null === c.return) {
                $5cc4a686f46e8a12$var$T = 1;
                $5cc4a686f46e8a12$var$qk = b;
                $5cc4a686f46e8a12$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $5cc4a686f46e8a12$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $5cc4a686f46e8a12$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $5cc4a686f46e8a12$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $5cc4a686f46e8a12$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $5cc4a686f46e8a12$var$Ti(f, l, b);
                            $5cc4a686f46e8a12$var$uj();
                            break a;
                        }
                        k = Error($5cc4a686f46e8a12$var$p(426));
                    }
                } else if ($5cc4a686f46e8a12$var$I && h.mode & 1) {
                    var J = $5cc4a686f46e8a12$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $5cc4a686f46e8a12$var$Wi(J, g, h, f, b);
                        $5cc4a686f46e8a12$var$Jg($5cc4a686f46e8a12$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $5cc4a686f46e8a12$var$Ki(k, h);
                4 !== $5cc4a686f46e8a12$var$T && ($5cc4a686f46e8a12$var$T = 2);
                null === $5cc4a686f46e8a12$var$tk ? $5cc4a686f46e8a12$var$tk = [
                    f
                ] : $5cc4a686f46e8a12$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $5cc4a686f46e8a12$var$Oi(f, k, b);
                            $5cc4a686f46e8a12$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $5cc4a686f46e8a12$var$Si || !$5cc4a686f46e8a12$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $5cc4a686f46e8a12$var$Ri(f, h, b);
                                $5cc4a686f46e8a12$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $5cc4a686f46e8a12$var$Tk(c);
        } catch (na) {
            b = na;
            $5cc4a686f46e8a12$var$Y === c && null !== c && ($5cc4a686f46e8a12$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $5cc4a686f46e8a12$var$Kk() {
    var a = $5cc4a686f46e8a12$var$nk.current;
    $5cc4a686f46e8a12$var$nk.current = $5cc4a686f46e8a12$var$ai;
    return null === a ? $5cc4a686f46e8a12$var$ai : a;
}
function $5cc4a686f46e8a12$var$uj() {
    if (0 === $5cc4a686f46e8a12$var$T || 3 === $5cc4a686f46e8a12$var$T || 2 === $5cc4a686f46e8a12$var$T) $5cc4a686f46e8a12$var$T = 4;
    null === $5cc4a686f46e8a12$var$R || 0 === ($5cc4a686f46e8a12$var$hh & 268435455) && 0 === ($5cc4a686f46e8a12$var$rk & 268435455) || $5cc4a686f46e8a12$var$Dk($5cc4a686f46e8a12$var$R, $5cc4a686f46e8a12$var$Z);
}
function $5cc4a686f46e8a12$var$Jk(a, b) {
    var c = $5cc4a686f46e8a12$var$K;
    $5cc4a686f46e8a12$var$K |= 2;
    var d = $5cc4a686f46e8a12$var$Kk();
    if ($5cc4a686f46e8a12$var$R !== a || $5cc4a686f46e8a12$var$Z !== b) $5cc4a686f46e8a12$var$vk = null, $5cc4a686f46e8a12$var$Lk(a, b);
    for(;;)try {
        $5cc4a686f46e8a12$var$Uk();
        break;
    } catch (e) {
        $5cc4a686f46e8a12$var$Nk(a, e);
    }
    $5cc4a686f46e8a12$var$Qg();
    $5cc4a686f46e8a12$var$K = c;
    $5cc4a686f46e8a12$var$nk.current = d;
    if (null !== $5cc4a686f46e8a12$var$Y) throw Error($5cc4a686f46e8a12$var$p(261));
    $5cc4a686f46e8a12$var$R = null;
    $5cc4a686f46e8a12$var$Z = 0;
    return $5cc4a686f46e8a12$var$T;
}
function $5cc4a686f46e8a12$var$Uk() {
    for(; null !== $5cc4a686f46e8a12$var$Y;)$5cc4a686f46e8a12$var$Vk($5cc4a686f46e8a12$var$Y);
}
function $5cc4a686f46e8a12$var$Mk() {
    for(; null !== $5cc4a686f46e8a12$var$Y && !$5cc4a686f46e8a12$var$cc();)$5cc4a686f46e8a12$var$Vk($5cc4a686f46e8a12$var$Y);
}
function $5cc4a686f46e8a12$var$Vk(a) {
    var b = $5cc4a686f46e8a12$var$Wk(a.alternate, a, $5cc4a686f46e8a12$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $5cc4a686f46e8a12$var$Tk(a) : $5cc4a686f46e8a12$var$Y = b;
    $5cc4a686f46e8a12$var$ok.current = null;
}
function $5cc4a686f46e8a12$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $5cc4a686f46e8a12$var$Fj(c, b, $5cc4a686f46e8a12$var$gj), null !== c) {
                $5cc4a686f46e8a12$var$Y = c;
                return;
            }
        } else {
            c = $5cc4a686f46e8a12$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $5cc4a686f46e8a12$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $5cc4a686f46e8a12$var$T = 6;
                $5cc4a686f46e8a12$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $5cc4a686f46e8a12$var$Y = b;
            return;
        }
        $5cc4a686f46e8a12$var$Y = b = a;
    }while (null !== b);
    0 === $5cc4a686f46e8a12$var$T && ($5cc4a686f46e8a12$var$T = 5);
}
function $5cc4a686f46e8a12$var$Qk(a, b, c) {
    var d = $5cc4a686f46e8a12$var$C, e = $5cc4a686f46e8a12$var$pk.transition;
    try {
        $5cc4a686f46e8a12$var$pk.transition = null, $5cc4a686f46e8a12$var$C = 1, $5cc4a686f46e8a12$var$Xk(a, b, c, d);
    } finally{
        $5cc4a686f46e8a12$var$pk.transition = e, $5cc4a686f46e8a12$var$C = d;
    }
    return null;
}
function $5cc4a686f46e8a12$var$Xk(a, b, c, d) {
    do $5cc4a686f46e8a12$var$Ik();
    while (null !== $5cc4a686f46e8a12$var$xk);
    if (0 !== ($5cc4a686f46e8a12$var$K & 6)) throw Error($5cc4a686f46e8a12$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($5cc4a686f46e8a12$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $5cc4a686f46e8a12$var$Bc(a, f);
    a === $5cc4a686f46e8a12$var$R && ($5cc4a686f46e8a12$var$Y = $5cc4a686f46e8a12$var$R = null, $5cc4a686f46e8a12$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $5cc4a686f46e8a12$var$wk || ($5cc4a686f46e8a12$var$wk = !0, $5cc4a686f46e8a12$var$Gk($5cc4a686f46e8a12$var$hc, function() {
        $5cc4a686f46e8a12$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $5cc4a686f46e8a12$var$pk.transition;
        $5cc4a686f46e8a12$var$pk.transition = null;
        var g = $5cc4a686f46e8a12$var$C;
        $5cc4a686f46e8a12$var$C = 1;
        var h = $5cc4a686f46e8a12$var$K;
        $5cc4a686f46e8a12$var$K |= 4;
        $5cc4a686f46e8a12$var$ok.current = null;
        $5cc4a686f46e8a12$var$Pj(a, c);
        $5cc4a686f46e8a12$var$ek(c, a);
        $5cc4a686f46e8a12$var$Oe($5cc4a686f46e8a12$var$Df);
        $5cc4a686f46e8a12$var$dd = !!$5cc4a686f46e8a12$var$Cf;
        $5cc4a686f46e8a12$var$Df = $5cc4a686f46e8a12$var$Cf = null;
        a.current = c;
        $5cc4a686f46e8a12$var$ik(c, a, e);
        $5cc4a686f46e8a12$var$dc();
        $5cc4a686f46e8a12$var$K = h;
        $5cc4a686f46e8a12$var$C = g;
        $5cc4a686f46e8a12$var$pk.transition = f;
    } else a.current = c;
    $5cc4a686f46e8a12$var$wk && ($5cc4a686f46e8a12$var$wk = !1, $5cc4a686f46e8a12$var$xk = a, $5cc4a686f46e8a12$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($5cc4a686f46e8a12$var$Si = null);
    $5cc4a686f46e8a12$var$mc(c.stateNode, d);
    $5cc4a686f46e8a12$var$Ek(a, $5cc4a686f46e8a12$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($5cc4a686f46e8a12$var$Pi) throw $5cc4a686f46e8a12$var$Pi = !1, a = $5cc4a686f46e8a12$var$Qi, $5cc4a686f46e8a12$var$Qi = null, a;
    0 !== ($5cc4a686f46e8a12$var$yk & 1) && 0 !== a.tag && $5cc4a686f46e8a12$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $5cc4a686f46e8a12$var$Ak ? $5cc4a686f46e8a12$var$zk++ : ($5cc4a686f46e8a12$var$zk = 0, $5cc4a686f46e8a12$var$Ak = a) : $5cc4a686f46e8a12$var$zk = 0;
    $5cc4a686f46e8a12$var$jg();
    return null;
}
function $5cc4a686f46e8a12$var$Ik() {
    if (null !== $5cc4a686f46e8a12$var$xk) {
        var a = $5cc4a686f46e8a12$var$Dc($5cc4a686f46e8a12$var$yk), b = $5cc4a686f46e8a12$var$pk.transition, c = $5cc4a686f46e8a12$var$C;
        try {
            $5cc4a686f46e8a12$var$pk.transition = null;
            $5cc4a686f46e8a12$var$C = 16 > a ? 16 : a;
            if (null === $5cc4a686f46e8a12$var$xk) var d = !1;
            else {
                a = $5cc4a686f46e8a12$var$xk;
                $5cc4a686f46e8a12$var$xk = null;
                $5cc4a686f46e8a12$var$yk = 0;
                if (0 !== ($5cc4a686f46e8a12$var$K & 6)) throw Error($5cc4a686f46e8a12$var$p(331));
                var e = $5cc4a686f46e8a12$var$K;
                $5cc4a686f46e8a12$var$K |= 4;
                for($5cc4a686f46e8a12$var$V = a.current; null !== $5cc4a686f46e8a12$var$V;){
                    var f = $5cc4a686f46e8a12$var$V, g = f.child;
                    if (0 !== ($5cc4a686f46e8a12$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($5cc4a686f46e8a12$var$V = l; null !== $5cc4a686f46e8a12$var$V;){
                                    var m = $5cc4a686f46e8a12$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $5cc4a686f46e8a12$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $5cc4a686f46e8a12$var$V = q;
                                    else for(; null !== $5cc4a686f46e8a12$var$V;){
                                        m = $5cc4a686f46e8a12$var$V;
                                        var r = m.sibling, y = m.return;
                                        $5cc4a686f46e8a12$var$Tj(m);
                                        if (m === l) {
                                            $5cc4a686f46e8a12$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $5cc4a686f46e8a12$var$V = r;
                                            break;
                                        }
                                        $5cc4a686f46e8a12$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $5cc4a686f46e8a12$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $5cc4a686f46e8a12$var$V = g;
                    else b: for(; null !== $5cc4a686f46e8a12$var$V;){
                        f = $5cc4a686f46e8a12$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $5cc4a686f46e8a12$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $5cc4a686f46e8a12$var$V = x;
                            break b;
                        }
                        $5cc4a686f46e8a12$var$V = f.return;
                    }
                }
                var w = a.current;
                for($5cc4a686f46e8a12$var$V = w; null !== $5cc4a686f46e8a12$var$V;){
                    g = $5cc4a686f46e8a12$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $5cc4a686f46e8a12$var$V = u;
                    else b: for(g = w; null !== $5cc4a686f46e8a12$var$V;){
                        h = $5cc4a686f46e8a12$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $5cc4a686f46e8a12$var$Rj(9, h);
                            }
                        } catch (na) {
                            $5cc4a686f46e8a12$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $5cc4a686f46e8a12$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $5cc4a686f46e8a12$var$V = F;
                            break b;
                        }
                        $5cc4a686f46e8a12$var$V = h.return;
                    }
                }
                $5cc4a686f46e8a12$var$K = e;
                $5cc4a686f46e8a12$var$jg();
                if ($5cc4a686f46e8a12$var$lc && "function" === typeof $5cc4a686f46e8a12$var$lc.onPostCommitFiberRoot) try {
                    $5cc4a686f46e8a12$var$lc.onPostCommitFiberRoot($5cc4a686f46e8a12$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $5cc4a686f46e8a12$var$C = c, $5cc4a686f46e8a12$var$pk.transition = b;
        }
    }
    return !1;
}
function $5cc4a686f46e8a12$var$Yk(a, b, c) {
    b = $5cc4a686f46e8a12$var$Ki(c, b);
    b = $5cc4a686f46e8a12$var$Oi(a, b, 1);
    a = $5cc4a686f46e8a12$var$dh(a, b, 1);
    b = $5cc4a686f46e8a12$var$L();
    null !== a && ($5cc4a686f46e8a12$var$Ac(a, 1, b), $5cc4a686f46e8a12$var$Ek(a, b));
}
function $5cc4a686f46e8a12$var$W(a, b, c) {
    if (3 === a.tag) $5cc4a686f46e8a12$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $5cc4a686f46e8a12$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $5cc4a686f46e8a12$var$Si || !$5cc4a686f46e8a12$var$Si.has(d))) {
                a = $5cc4a686f46e8a12$var$Ki(c, a);
                a = $5cc4a686f46e8a12$var$Ri(b, a, 1);
                b = $5cc4a686f46e8a12$var$dh(b, a, 1);
                a = $5cc4a686f46e8a12$var$L();
                null !== b && ($5cc4a686f46e8a12$var$Ac(b, 1, a), $5cc4a686f46e8a12$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $5cc4a686f46e8a12$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $5cc4a686f46e8a12$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $5cc4a686f46e8a12$var$R === a && ($5cc4a686f46e8a12$var$Z & c) === c && (4 === $5cc4a686f46e8a12$var$T || 3 === $5cc4a686f46e8a12$var$T && ($5cc4a686f46e8a12$var$Z & 130023424) === $5cc4a686f46e8a12$var$Z && 500 > $5cc4a686f46e8a12$var$B() - $5cc4a686f46e8a12$var$gk ? $5cc4a686f46e8a12$var$Lk(a, 0) : $5cc4a686f46e8a12$var$sk |= c);
    $5cc4a686f46e8a12$var$Ek(a, b);
}
function $5cc4a686f46e8a12$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $5cc4a686f46e8a12$var$sc, $5cc4a686f46e8a12$var$sc <<= 1, 0 === ($5cc4a686f46e8a12$var$sc & 130023424) && ($5cc4a686f46e8a12$var$sc = 4194304)));
    var c = $5cc4a686f46e8a12$var$L();
    a = $5cc4a686f46e8a12$var$Zg(a, b);
    null !== a && ($5cc4a686f46e8a12$var$Ac(a, b, c), $5cc4a686f46e8a12$var$Ek(a, c));
}
function $5cc4a686f46e8a12$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $5cc4a686f46e8a12$var$Zk(a, c);
}
function $5cc4a686f46e8a12$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($5cc4a686f46e8a12$var$p(314));
    }
    null !== d && d.delete(b);
    $5cc4a686f46e8a12$var$Zk(a, c);
}
var $5cc4a686f46e8a12$var$Wk;
$5cc4a686f46e8a12$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $5cc4a686f46e8a12$var$Wf.current) $5cc4a686f46e8a12$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $5cc4a686f46e8a12$var$Ug = !1, $5cc4a686f46e8a12$var$zj(a, b, c);
            $5cc4a686f46e8a12$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $5cc4a686f46e8a12$var$Ug = !1, $5cc4a686f46e8a12$var$I && 0 !== (b.flags & 1048576) && $5cc4a686f46e8a12$var$ug(b, $5cc4a686f46e8a12$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $5cc4a686f46e8a12$var$jj(a, b);
            a = b.pendingProps;
            var e = $5cc4a686f46e8a12$var$Yf(b, $5cc4a686f46e8a12$var$H.current);
            $5cc4a686f46e8a12$var$Tg(b, c);
            e = $5cc4a686f46e8a12$var$Xh(null, b, d, a, e, c);
            var f = $5cc4a686f46e8a12$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $5cc4a686f46e8a12$var$Zf(d) ? (f = !0, $5cc4a686f46e8a12$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $5cc4a686f46e8a12$var$ah(b), e.updater = $5cc4a686f46e8a12$var$nh, b.stateNode = e, e._reactInternals = b, $5cc4a686f46e8a12$var$rh(b, d, a, c), b = $5cc4a686f46e8a12$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $5cc4a686f46e8a12$var$I && f && $5cc4a686f46e8a12$var$vg(b), $5cc4a686f46e8a12$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $5cc4a686f46e8a12$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $5cc4a686f46e8a12$var$$k(d);
                a = $5cc4a686f46e8a12$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $5cc4a686f46e8a12$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $5cc4a686f46e8a12$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $5cc4a686f46e8a12$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $5cc4a686f46e8a12$var$aj(null, b, d, $5cc4a686f46e8a12$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($5cc4a686f46e8a12$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5cc4a686f46e8a12$var$Lg(d, e), $5cc4a686f46e8a12$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5cc4a686f46e8a12$var$Lg(d, e), $5cc4a686f46e8a12$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $5cc4a686f46e8a12$var$lj(b);
                if (null === a) throw Error($5cc4a686f46e8a12$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $5cc4a686f46e8a12$var$bh(a, b);
                $5cc4a686f46e8a12$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $5cc4a686f46e8a12$var$Ki(Error($5cc4a686f46e8a12$var$p(423)), b);
                        b = $5cc4a686f46e8a12$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $5cc4a686f46e8a12$var$Ki(Error($5cc4a686f46e8a12$var$p(424)), b);
                        b = $5cc4a686f46e8a12$var$mj(a, b, d, c, e);
                        break a;
                    } else for($5cc4a686f46e8a12$var$yg = $5cc4a686f46e8a12$var$Lf(b.stateNode.containerInfo.firstChild), $5cc4a686f46e8a12$var$xg = b, $5cc4a686f46e8a12$var$I = !0, $5cc4a686f46e8a12$var$zg = null, c = $5cc4a686f46e8a12$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $5cc4a686f46e8a12$var$Ig();
                    if (d === e) {
                        b = $5cc4a686f46e8a12$var$$i(a, b, c);
                        break a;
                    }
                    $5cc4a686f46e8a12$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $5cc4a686f46e8a12$var$Kh(b), null === a && $5cc4a686f46e8a12$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $5cc4a686f46e8a12$var$Ef(d, e) ? g = null : null !== f && $5cc4a686f46e8a12$var$Ef(d, f) && (b.flags |= 32), $5cc4a686f46e8a12$var$hj(a, b), $5cc4a686f46e8a12$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $5cc4a686f46e8a12$var$Eg(b), null;
        case 13:
            return $5cc4a686f46e8a12$var$pj(a, b, c);
        case 4:
            return $5cc4a686f46e8a12$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $5cc4a686f46e8a12$var$Bh(b, null, d, c) : $5cc4a686f46e8a12$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5cc4a686f46e8a12$var$Lg(d, e), $5cc4a686f46e8a12$var$Zi(a, b, d, e, c);
        case 7:
            return $5cc4a686f46e8a12$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $5cc4a686f46e8a12$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $5cc4a686f46e8a12$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $5cc4a686f46e8a12$var$G($5cc4a686f46e8a12$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($5cc4a686f46e8a12$var$He(f.value, g)) {
                        if (f.children === e.children && !$5cc4a686f46e8a12$var$Wf.current) {
                            b = $5cc4a686f46e8a12$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $5cc4a686f46e8a12$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $5cc4a686f46e8a12$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($5cc4a686f46e8a12$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $5cc4a686f46e8a12$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $5cc4a686f46e8a12$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $5cc4a686f46e8a12$var$Tg(b, c), e = $5cc4a686f46e8a12$var$Vg(e), d = d(e), b.flags |= 1, $5cc4a686f46e8a12$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $5cc4a686f46e8a12$var$Lg(d, b.pendingProps), e = $5cc4a686f46e8a12$var$Lg(d.type, e), $5cc4a686f46e8a12$var$aj(a, b, d, e, c);
        case 15:
            return $5cc4a686f46e8a12$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $5cc4a686f46e8a12$var$Lg(d, e), $5cc4a686f46e8a12$var$jj(a, b), b.tag = 1, $5cc4a686f46e8a12$var$Zf(d) ? (a = !0, $5cc4a686f46e8a12$var$cg(b)) : a = !1, $5cc4a686f46e8a12$var$Tg(b, c), $5cc4a686f46e8a12$var$ph(b, d, e), $5cc4a686f46e8a12$var$rh(b, d, e, c), $5cc4a686f46e8a12$var$kj(null, b, d, !0, a, c);
        case 19:
            return $5cc4a686f46e8a12$var$yj(a, b, c);
        case 22:
            return $5cc4a686f46e8a12$var$ej(a, b, c);
    }
    throw Error($5cc4a686f46e8a12$var$p(156, b.tag));
};
function $5cc4a686f46e8a12$var$Gk(a, b) {
    return $5cc4a686f46e8a12$var$ac(a, b);
}
function $5cc4a686f46e8a12$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $5cc4a686f46e8a12$var$Bg(a, b, c, d) {
    return new $5cc4a686f46e8a12$var$al(a, b, c, d);
}
function $5cc4a686f46e8a12$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $5cc4a686f46e8a12$var$$k(a) {
    if ("function" === typeof a) return $5cc4a686f46e8a12$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $5cc4a686f46e8a12$var$Da) return 11;
        if (a === $5cc4a686f46e8a12$var$Ga) return 14;
    }
    return 2;
}
function $5cc4a686f46e8a12$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $5cc4a686f46e8a12$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $5cc4a686f46e8a12$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $5cc4a686f46e8a12$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $5cc4a686f46e8a12$var$ya:
            return $5cc4a686f46e8a12$var$Ah(c.children, e, f, b);
        case $5cc4a686f46e8a12$var$za:
            g = 8;
            e |= 8;
            break;
        case $5cc4a686f46e8a12$var$Aa:
            return a = $5cc4a686f46e8a12$var$Bg(12, c, b, e | 2), a.elementType = $5cc4a686f46e8a12$var$Aa, a.lanes = f, a;
        case $5cc4a686f46e8a12$var$Ea:
            return a = $5cc4a686f46e8a12$var$Bg(13, c, b, e), a.elementType = $5cc4a686f46e8a12$var$Ea, a.lanes = f, a;
        case $5cc4a686f46e8a12$var$Fa:
            return a = $5cc4a686f46e8a12$var$Bg(19, c, b, e), a.elementType = $5cc4a686f46e8a12$var$Fa, a.lanes = f, a;
        case $5cc4a686f46e8a12$var$Ia:
            return $5cc4a686f46e8a12$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $5cc4a686f46e8a12$var$Ba:
                    g = 10;
                    break a;
                case $5cc4a686f46e8a12$var$Ca:
                    g = 9;
                    break a;
                case $5cc4a686f46e8a12$var$Da:
                    g = 11;
                    break a;
                case $5cc4a686f46e8a12$var$Ga:
                    g = 14;
                    break a;
                case $5cc4a686f46e8a12$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($5cc4a686f46e8a12$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $5cc4a686f46e8a12$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $5cc4a686f46e8a12$var$Ah(a, b, c, d) {
    a = $5cc4a686f46e8a12$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $5cc4a686f46e8a12$var$qj(a, b, c, d) {
    a = $5cc4a686f46e8a12$var$Bg(22, a, d, b);
    a.elementType = $5cc4a686f46e8a12$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $5cc4a686f46e8a12$var$xh(a, b, c) {
    a = $5cc4a686f46e8a12$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $5cc4a686f46e8a12$var$zh(a, b, c) {
    b = $5cc4a686f46e8a12$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $5cc4a686f46e8a12$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $5cc4a686f46e8a12$var$zc(0);
    this.expirationTimes = $5cc4a686f46e8a12$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $5cc4a686f46e8a12$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $5cc4a686f46e8a12$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $5cc4a686f46e8a12$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $5cc4a686f46e8a12$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $5cc4a686f46e8a12$var$ah(f);
    return a;
}
function $5cc4a686f46e8a12$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $5cc4a686f46e8a12$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $5cc4a686f46e8a12$var$el(a) {
    if (!a) return $5cc4a686f46e8a12$var$Vf;
    a = a._reactInternals;
    a: {
        if ($5cc4a686f46e8a12$var$Vb(a) !== a || 1 !== a.tag) throw Error($5cc4a686f46e8a12$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($5cc4a686f46e8a12$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($5cc4a686f46e8a12$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($5cc4a686f46e8a12$var$Zf(c)) return $5cc4a686f46e8a12$var$bg(a, c, b);
    }
    return b;
}
function $5cc4a686f46e8a12$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $5cc4a686f46e8a12$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $5cc4a686f46e8a12$var$el(null);
    c = a.current;
    d = $5cc4a686f46e8a12$var$L();
    e = $5cc4a686f46e8a12$var$lh(c);
    f = $5cc4a686f46e8a12$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $5cc4a686f46e8a12$var$dh(c, f, e);
    a.current.lanes = e;
    $5cc4a686f46e8a12$var$Ac(a, e, d);
    $5cc4a686f46e8a12$var$Ek(a, d);
    return a;
}
function $5cc4a686f46e8a12$var$gl(a, b, c, d) {
    var e = b.current, f = $5cc4a686f46e8a12$var$L(), g = $5cc4a686f46e8a12$var$lh(e);
    c = $5cc4a686f46e8a12$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $5cc4a686f46e8a12$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $5cc4a686f46e8a12$var$dh(e, b, g);
    null !== a && ($5cc4a686f46e8a12$var$mh(a, e, g, f), $5cc4a686f46e8a12$var$eh(a, e, g));
    return g;
}
function $5cc4a686f46e8a12$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $5cc4a686f46e8a12$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $5cc4a686f46e8a12$var$jl(a, b) {
    $5cc4a686f46e8a12$var$il(a, b);
    (a = a.alternate) && $5cc4a686f46e8a12$var$il(a, b);
}
function $5cc4a686f46e8a12$var$kl() {
    return null;
}
var $5cc4a686f46e8a12$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $5cc4a686f46e8a12$var$ml(a) {
    this._internalRoot = a;
}
$5cc4a686f46e8a12$var$nl.prototype.render = $5cc4a686f46e8a12$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($5cc4a686f46e8a12$var$p(409));
    $5cc4a686f46e8a12$var$gl(a, b, null, null);
};
$5cc4a686f46e8a12$var$nl.prototype.unmount = $5cc4a686f46e8a12$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $5cc4a686f46e8a12$var$Sk(function() {
            $5cc4a686f46e8a12$var$gl(null, a, null, null);
        });
        b[$5cc4a686f46e8a12$var$uf] = null;
    }
};
function $5cc4a686f46e8a12$var$nl(a) {
    this._internalRoot = a;
}
$5cc4a686f46e8a12$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $5cc4a686f46e8a12$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $5cc4a686f46e8a12$var$Qc.length && 0 !== b && b < $5cc4a686f46e8a12$var$Qc[c].priority; c++);
        $5cc4a686f46e8a12$var$Qc.splice(c, 0, a);
        0 === c && $5cc4a686f46e8a12$var$Vc(a);
    }
};
function $5cc4a686f46e8a12$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $5cc4a686f46e8a12$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $5cc4a686f46e8a12$var$ql() {}
function $5cc4a686f46e8a12$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $5cc4a686f46e8a12$var$hl(g);
                f.call(a);
            };
        }
        var g = $5cc4a686f46e8a12$var$fl(b, d, a, 0, null, !1, !1, "", $5cc4a686f46e8a12$var$ql);
        a._reactRootContainer = g;
        a[$5cc4a686f46e8a12$var$uf] = g.current;
        $5cc4a686f46e8a12$var$sf(8 === a.nodeType ? a.parentNode : a);
        $5cc4a686f46e8a12$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $5cc4a686f46e8a12$var$hl(k);
            h.call(a);
        };
    }
    var k = $5cc4a686f46e8a12$var$cl(a, 0, !1, null, null, !1, !1, "", $5cc4a686f46e8a12$var$ql);
    a._reactRootContainer = k;
    a[$5cc4a686f46e8a12$var$uf] = k.current;
    $5cc4a686f46e8a12$var$sf(8 === a.nodeType ? a.parentNode : a);
    $5cc4a686f46e8a12$var$Sk(function() {
        $5cc4a686f46e8a12$var$gl(b, k, c, d);
    });
    return k;
}
function $5cc4a686f46e8a12$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $5cc4a686f46e8a12$var$hl(g);
                h.call(a);
            };
        }
        $5cc4a686f46e8a12$var$gl(b, g, a, e);
    } else g = $5cc4a686f46e8a12$var$rl(c, b, a, e, d);
    return $5cc4a686f46e8a12$var$hl(g);
}
$5cc4a686f46e8a12$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $5cc4a686f46e8a12$var$tc(b.pendingLanes);
                0 !== c && ($5cc4a686f46e8a12$var$Cc(b, c | 1), $5cc4a686f46e8a12$var$Ek(b, $5cc4a686f46e8a12$var$B()), 0 === ($5cc4a686f46e8a12$var$K & 6) && ($5cc4a686f46e8a12$var$Hj = $5cc4a686f46e8a12$var$B() + 500, $5cc4a686f46e8a12$var$jg()));
            }
            break;
        case 13:
            $5cc4a686f46e8a12$var$Sk(function() {
                var b = $5cc4a686f46e8a12$var$Zg(a, 1);
                if (null !== b) {
                    var c = $5cc4a686f46e8a12$var$L();
                    $5cc4a686f46e8a12$var$mh(b, a, 1, c);
                }
            }), $5cc4a686f46e8a12$var$jl(a, 1);
    }
};
$5cc4a686f46e8a12$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $5cc4a686f46e8a12$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $5cc4a686f46e8a12$var$L();
            $5cc4a686f46e8a12$var$mh(b, a, 134217728, c);
        }
        $5cc4a686f46e8a12$var$jl(a, 134217728);
    }
};
$5cc4a686f46e8a12$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $5cc4a686f46e8a12$var$lh(a), c = $5cc4a686f46e8a12$var$Zg(a, b);
        if (null !== c) {
            var d = $5cc4a686f46e8a12$var$L();
            $5cc4a686f46e8a12$var$mh(c, a, b, d);
        }
        $5cc4a686f46e8a12$var$jl(a, b);
    }
};
$5cc4a686f46e8a12$var$Hc = function() {
    return $5cc4a686f46e8a12$var$C;
};
$5cc4a686f46e8a12$var$Ic = function(a, b) {
    var c = $5cc4a686f46e8a12$var$C;
    try {
        return $5cc4a686f46e8a12$var$C = a, b();
    } finally{
        $5cc4a686f46e8a12$var$C = c;
    }
};
$5cc4a686f46e8a12$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $5cc4a686f46e8a12$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $5cc4a686f46e8a12$var$Db(d);
                        if (!e) throw Error($5cc4a686f46e8a12$var$p(90));
                        $5cc4a686f46e8a12$var$Wa(d);
                        $5cc4a686f46e8a12$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $5cc4a686f46e8a12$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $5cc4a686f46e8a12$var$fb(a, !!c.multiple, b, !1);
    }
};
$5cc4a686f46e8a12$var$Gb = $5cc4a686f46e8a12$var$Rk;
$5cc4a686f46e8a12$var$Hb = $5cc4a686f46e8a12$var$Sk;
var $5cc4a686f46e8a12$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $5cc4a686f46e8a12$var$Cb,
        $5cc4a686f46e8a12$var$ue,
        $5cc4a686f46e8a12$var$Db,
        $5cc4a686f46e8a12$var$Eb,
        $5cc4a686f46e8a12$var$Fb,
        $5cc4a686f46e8a12$var$Rk
    ]
}, $5cc4a686f46e8a12$var$ul = {
    findFiberByHostInstance: $5cc4a686f46e8a12$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $5cc4a686f46e8a12$var$vl = {
    bundleType: $5cc4a686f46e8a12$var$ul.bundleType,
    version: $5cc4a686f46e8a12$var$ul.version,
    rendererPackageName: $5cc4a686f46e8a12$var$ul.rendererPackageName,
    rendererConfig: $5cc4a686f46e8a12$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $5cc4a686f46e8a12$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $5cc4a686f46e8a12$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $5cc4a686f46e8a12$var$ul.findFiberByHostInstance || $5cc4a686f46e8a12$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $5cc4a686f46e8a12$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$5cc4a686f46e8a12$var$wl.isDisabled && $5cc4a686f46e8a12$var$wl.supportsFiber) try {
        $5cc4a686f46e8a12$var$kc = $5cc4a686f46e8a12$var$wl.inject($5cc4a686f46e8a12$var$vl), $5cc4a686f46e8a12$var$lc = $5cc4a686f46e8a12$var$wl;
    } catch (a) {}
}
$5cc4a686f46e8a12$export$ae55be85d98224ed = $5cc4a686f46e8a12$var$tl;
$5cc4a686f46e8a12$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$5cc4a686f46e8a12$var$ol(b)) throw Error($5cc4a686f46e8a12$var$p(200));
    return $5cc4a686f46e8a12$var$dl(a, b, null, c);
};
$5cc4a686f46e8a12$export$882461b6382ed46c = function(a, b) {
    if (!$5cc4a686f46e8a12$var$ol(a)) throw Error($5cc4a686f46e8a12$var$p(299));
    var c = !1, d = "", e = $5cc4a686f46e8a12$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $5cc4a686f46e8a12$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$5cc4a686f46e8a12$var$uf] = b.current;
    $5cc4a686f46e8a12$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $5cc4a686f46e8a12$var$ml(b);
};
$5cc4a686f46e8a12$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($5cc4a686f46e8a12$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($5cc4a686f46e8a12$var$p(268, a));
    }
    a = $5cc4a686f46e8a12$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$5cc4a686f46e8a12$export$cd75ccfd720a3cd4 = function(a) {
    return $5cc4a686f46e8a12$var$Sk(a);
};
$5cc4a686f46e8a12$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$5cc4a686f46e8a12$var$pl(b)) throw Error($5cc4a686f46e8a12$var$p(200));
    return $5cc4a686f46e8a12$var$sl(null, a, b, !0, c);
};
$5cc4a686f46e8a12$export$757ceba2d55c277e = function(a, b, c) {
    if (!$5cc4a686f46e8a12$var$ol(a)) throw Error($5cc4a686f46e8a12$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $5cc4a686f46e8a12$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $5cc4a686f46e8a12$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$5cc4a686f46e8a12$var$uf] = b.current;
    $5cc4a686f46e8a12$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $5cc4a686f46e8a12$var$nl(b);
};
$5cc4a686f46e8a12$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$5cc4a686f46e8a12$var$pl(b)) throw Error($5cc4a686f46e8a12$var$p(200));
    return $5cc4a686f46e8a12$var$sl(null, a, b, !1, c);
};
$5cc4a686f46e8a12$export$502457920280e6be = function(a) {
    if (!$5cc4a686f46e8a12$var$pl(a)) throw Error($5cc4a686f46e8a12$var$p(40));
    return a._reactRootContainer ? ($5cc4a686f46e8a12$var$Sk(function() {
        $5cc4a686f46e8a12$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$5cc4a686f46e8a12$var$uf] = null;
        });
    }), !0) : !1;
};
$5cc4a686f46e8a12$export$c78a37762a8d58e1 = $5cc4a686f46e8a12$var$Rk;
$5cc4a686f46e8a12$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$5cc4a686f46e8a12$var$pl(c)) throw Error($5cc4a686f46e8a12$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($5cc4a686f46e8a12$var$p(38));
    return $5cc4a686f46e8a12$var$sl(a, b, c, !1, d);
};
$5cc4a686f46e8a12$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("1oHYN", function(module, exports) {
"use strict";

module.exports = (parcelRequire("e8jJM"));

});
parcelRegister("e8jJM", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $a4a11f7973070a30$export$c4744153514ff05d; }, function (v) { return $a4a11f7973070a30$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $a4a11f7973070a30$export$3e506c1ccc9cc1a7; }, function (v) { return $a4a11f7973070a30$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $a4a11f7973070a30$export$e26fe2ed2fa76875; }, function (v) { return $a4a11f7973070a30$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $a4a11f7973070a30$export$502329bbf4b505b1; }, function (v) { return $a4a11f7973070a30$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $a4a11f7973070a30$export$6e3807111c4874c4; }, function (v) { return $a4a11f7973070a30$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $a4a11f7973070a30$export$c27134553091fb3a; }, function (v) { return $a4a11f7973070a30$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $a4a11f7973070a30$export$33ee1acdc04fd2a2; }, function (v) { return $a4a11f7973070a30$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $a4a11f7973070a30$export$b00a404bbd5edef2; }, function (v) { return $a4a11f7973070a30$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $a4a11f7973070a30$export$8352ce38b91d0c62; }, function (v) { return $a4a11f7973070a30$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $a4a11f7973070a30$export$d66a1c1c77bd778b; }, function (v) { return $a4a11f7973070a30$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $a4a11f7973070a30$export$d3dfb8e4810cb555; }, function (v) { return $a4a11f7973070a30$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $a4a11f7973070a30$export$839f9183b0465a69; }, function (v) { return $a4a11f7973070a30$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $a4a11f7973070a30$export$72fdf0e06517287b; }, function (v) { return $a4a11f7973070a30$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $a4a11f7973070a30$export$4b844e58a3e414b4; }, function (v) { return $a4a11f7973070a30$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $a4a11f7973070a30$export$816d2913ae6b83b1; }, function (v) { return $a4a11f7973070a30$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $a4a11f7973070a30$export$61bcfe829111a1d0; }, function (v) { return $a4a11f7973070a30$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $a4a11f7973070a30$export$7ee8c9beb337bc3f; }, function (v) { return $a4a11f7973070a30$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $a4a11f7973070a30$export$b5836b71941fa3ed; }, function (v) { return $a4a11f7973070a30$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $a4a11f7973070a30$export$cf845f2c119da08a; }, function (v) { return $a4a11f7973070a30$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a4a11f7973070a30$export$c4744153514ff05d;
var $a4a11f7973070a30$export$3e506c1ccc9cc1a7;
var $a4a11f7973070a30$export$e26fe2ed2fa76875;
var $a4a11f7973070a30$export$502329bbf4b505b1;
var $a4a11f7973070a30$export$6e3807111c4874c4;
var $a4a11f7973070a30$export$c27134553091fb3a;
var $a4a11f7973070a30$export$33ee1acdc04fd2a2;
var $a4a11f7973070a30$export$b00a404bbd5edef2;
var $a4a11f7973070a30$export$8352ce38b91d0c62;
var $a4a11f7973070a30$export$d66a1c1c77bd778b;
var $a4a11f7973070a30$export$d3dfb8e4810cb555;
var $a4a11f7973070a30$export$839f9183b0465a69;
var $a4a11f7973070a30$export$72fdf0e06517287b;
var $a4a11f7973070a30$export$4b844e58a3e414b4;
var $a4a11f7973070a30$export$816d2913ae6b83b1;
var $a4a11f7973070a30$export$61bcfe829111a1d0;
var $a4a11f7973070a30$export$7ee8c9beb337bc3f;
var $a4a11f7973070a30$export$b5836b71941fa3ed;
var $a4a11f7973070a30$export$cf845f2c119da08a;
"use strict";
function $a4a11f7973070a30$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $a4a11f7973070a30$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $a4a11f7973070a30$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $a4a11f7973070a30$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $a4a11f7973070a30$var$g(C, c)) n < e && 0 > $a4a11f7973070a30$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $a4a11f7973070a30$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $a4a11f7973070a30$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $a4a11f7973070a30$var$l = performance;
    $a4a11f7973070a30$export$c4744153514ff05d = function() {
        return $a4a11f7973070a30$var$l.now();
    };
} else {
    var $a4a11f7973070a30$var$p = Date, $a4a11f7973070a30$var$q = $a4a11f7973070a30$var$p.now();
    $a4a11f7973070a30$export$c4744153514ff05d = function() {
        return $a4a11f7973070a30$var$p.now() - $a4a11f7973070a30$var$q;
    };
}
var $a4a11f7973070a30$var$r = [], $a4a11f7973070a30$var$t = [], $a4a11f7973070a30$var$u = 1, $a4a11f7973070a30$var$v = null, $a4a11f7973070a30$var$y = 3, $a4a11f7973070a30$var$z = !1, $a4a11f7973070a30$var$A = !1, $a4a11f7973070a30$var$B = !1, $a4a11f7973070a30$var$D = "function" === typeof setTimeout ? setTimeout : null, $a4a11f7973070a30$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $a4a11f7973070a30$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $a4a11f7973070a30$var$G(a) {
    for(var b = $a4a11f7973070a30$var$h($a4a11f7973070a30$var$t); null !== b;){
        if (null === b.callback) $a4a11f7973070a30$var$k($a4a11f7973070a30$var$t);
        else if (b.startTime <= a) $a4a11f7973070a30$var$k($a4a11f7973070a30$var$t), b.sortIndex = b.expirationTime, $a4a11f7973070a30$var$f($a4a11f7973070a30$var$r, b);
        else break;
        b = $a4a11f7973070a30$var$h($a4a11f7973070a30$var$t);
    }
}
function $a4a11f7973070a30$var$H(a) {
    $a4a11f7973070a30$var$B = !1;
    $a4a11f7973070a30$var$G(a);
    if (!$a4a11f7973070a30$var$A) {
        if (null !== $a4a11f7973070a30$var$h($a4a11f7973070a30$var$r)) $a4a11f7973070a30$var$A = !0, $a4a11f7973070a30$var$I($a4a11f7973070a30$var$J);
        else {
            var b = $a4a11f7973070a30$var$h($a4a11f7973070a30$var$t);
            null !== b && $a4a11f7973070a30$var$K($a4a11f7973070a30$var$H, b.startTime - a);
        }
    }
}
function $a4a11f7973070a30$var$J(a, b) {
    $a4a11f7973070a30$var$A = !1;
    $a4a11f7973070a30$var$B && ($a4a11f7973070a30$var$B = !1, $a4a11f7973070a30$var$E($a4a11f7973070a30$var$L), $a4a11f7973070a30$var$L = -1);
    $a4a11f7973070a30$var$z = !0;
    var c = $a4a11f7973070a30$var$y;
    try {
        $a4a11f7973070a30$var$G(b);
        for($a4a11f7973070a30$var$v = $a4a11f7973070a30$var$h($a4a11f7973070a30$var$r); null !== $a4a11f7973070a30$var$v && (!($a4a11f7973070a30$var$v.expirationTime > b) || a && !$a4a11f7973070a30$var$M());){
            var d = $a4a11f7973070a30$var$v.callback;
            if ("function" === typeof d) {
                $a4a11f7973070a30$var$v.callback = null;
                $a4a11f7973070a30$var$y = $a4a11f7973070a30$var$v.priorityLevel;
                var e = d($a4a11f7973070a30$var$v.expirationTime <= b);
                b = $a4a11f7973070a30$export$c4744153514ff05d();
                "function" === typeof e ? $a4a11f7973070a30$var$v.callback = e : $a4a11f7973070a30$var$v === $a4a11f7973070a30$var$h($a4a11f7973070a30$var$r) && $a4a11f7973070a30$var$k($a4a11f7973070a30$var$r);
                $a4a11f7973070a30$var$G(b);
            } else $a4a11f7973070a30$var$k($a4a11f7973070a30$var$r);
            $a4a11f7973070a30$var$v = $a4a11f7973070a30$var$h($a4a11f7973070a30$var$r);
        }
        if (null !== $a4a11f7973070a30$var$v) var w = !0;
        else {
            var m = $a4a11f7973070a30$var$h($a4a11f7973070a30$var$t);
            null !== m && $a4a11f7973070a30$var$K($a4a11f7973070a30$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $a4a11f7973070a30$var$v = null, $a4a11f7973070a30$var$y = c, $a4a11f7973070a30$var$z = !1;
    }
}
var $a4a11f7973070a30$var$N = !1, $a4a11f7973070a30$var$O = null, $a4a11f7973070a30$var$L = -1, $a4a11f7973070a30$var$P = 5, $a4a11f7973070a30$var$Q = -1;
function $a4a11f7973070a30$var$M() {
    return $a4a11f7973070a30$export$c4744153514ff05d() - $a4a11f7973070a30$var$Q < $a4a11f7973070a30$var$P ? !1 : !0;
}
function $a4a11f7973070a30$var$R() {
    if (null !== $a4a11f7973070a30$var$O) {
        var a = $a4a11f7973070a30$export$c4744153514ff05d();
        $a4a11f7973070a30$var$Q = a;
        var b = !0;
        try {
            b = $a4a11f7973070a30$var$O(!0, a);
        } finally{
            b ? $a4a11f7973070a30$var$S() : ($a4a11f7973070a30$var$N = !1, $a4a11f7973070a30$var$O = null);
        }
    } else $a4a11f7973070a30$var$N = !1;
}
var $a4a11f7973070a30$var$S;
if ("function" === typeof $a4a11f7973070a30$var$F) $a4a11f7973070a30$var$S = function() {
    $a4a11f7973070a30$var$F($a4a11f7973070a30$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $a4a11f7973070a30$var$T = new MessageChannel, $a4a11f7973070a30$var$U = $a4a11f7973070a30$var$T.port2;
    $a4a11f7973070a30$var$T.port1.onmessage = $a4a11f7973070a30$var$R;
    $a4a11f7973070a30$var$S = function() {
        $a4a11f7973070a30$var$U.postMessage(null);
    };
} else $a4a11f7973070a30$var$S = function() {
    $a4a11f7973070a30$var$D($a4a11f7973070a30$var$R, 0);
};
function $a4a11f7973070a30$var$I(a) {
    $a4a11f7973070a30$var$O = a;
    $a4a11f7973070a30$var$N || ($a4a11f7973070a30$var$N = !0, $a4a11f7973070a30$var$S());
}
function $a4a11f7973070a30$var$K(a, b) {
    $a4a11f7973070a30$var$L = $a4a11f7973070a30$var$D(function() {
        a($a4a11f7973070a30$export$c4744153514ff05d());
    }, b);
}
$a4a11f7973070a30$export$3e506c1ccc9cc1a7 = 5;
$a4a11f7973070a30$export$e26fe2ed2fa76875 = 1;
$a4a11f7973070a30$export$502329bbf4b505b1 = 4;
$a4a11f7973070a30$export$6e3807111c4874c4 = 3;
$a4a11f7973070a30$export$c27134553091fb3a = null;
$a4a11f7973070a30$export$33ee1acdc04fd2a2 = 2;
$a4a11f7973070a30$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$a4a11f7973070a30$export$8352ce38b91d0c62 = function() {
    $a4a11f7973070a30$var$A || $a4a11f7973070a30$var$z || ($a4a11f7973070a30$var$A = !0, $a4a11f7973070a30$var$I($a4a11f7973070a30$var$J));
};
$a4a11f7973070a30$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $a4a11f7973070a30$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$a4a11f7973070a30$export$d3dfb8e4810cb555 = function() {
    return $a4a11f7973070a30$var$y;
};
$a4a11f7973070a30$export$839f9183b0465a69 = function() {
    return $a4a11f7973070a30$var$h($a4a11f7973070a30$var$r);
};
$a4a11f7973070a30$export$72fdf0e06517287b = function(a) {
    switch($a4a11f7973070a30$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $a4a11f7973070a30$var$y;
    }
    var c = $a4a11f7973070a30$var$y;
    $a4a11f7973070a30$var$y = b;
    try {
        return a();
    } finally{
        $a4a11f7973070a30$var$y = c;
    }
};
$a4a11f7973070a30$export$4b844e58a3e414b4 = function() {};
$a4a11f7973070a30$export$816d2913ae6b83b1 = function() {};
$a4a11f7973070a30$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $a4a11f7973070a30$var$y;
    $a4a11f7973070a30$var$y = a;
    try {
        return b();
    } finally{
        $a4a11f7973070a30$var$y = c;
    }
};
$a4a11f7973070a30$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $a4a11f7973070a30$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $a4a11f7973070a30$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $a4a11f7973070a30$var$f($a4a11f7973070a30$var$t, a), null === $a4a11f7973070a30$var$h($a4a11f7973070a30$var$r) && a === $a4a11f7973070a30$var$h($a4a11f7973070a30$var$t) && ($a4a11f7973070a30$var$B ? ($a4a11f7973070a30$var$E($a4a11f7973070a30$var$L), $a4a11f7973070a30$var$L = -1) : $a4a11f7973070a30$var$B = !0, $a4a11f7973070a30$var$K($a4a11f7973070a30$var$H, c - d))) : (a.sortIndex = e, $a4a11f7973070a30$var$f($a4a11f7973070a30$var$r, a), $a4a11f7973070a30$var$A || $a4a11f7973070a30$var$z || ($a4a11f7973070a30$var$A = !0, $a4a11f7973070a30$var$I($a4a11f7973070a30$var$J)));
    return a;
};
$a4a11f7973070a30$export$b5836b71941fa3ed = $a4a11f7973070a30$var$M;
$a4a11f7973070a30$export$cf845f2c119da08a = function(a) {
    var b = $a4a11f7973070a30$var$y;
    return function() {
        var c = $a4a11f7973070a30$var$y;
        $a4a11f7973070a30$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $a4a11f7973070a30$var$y = c;
        }
    };
};

});



parcelRegister("jPPOv", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e70af8d7d2c90f14$var$ReactIs, $e70af8d7d2c90f14$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("alZyo"))();

});
parcelRegister("alZyo", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $Vsruk = parcelRequire("Vsruk");
function $789b9cd674f6331e$var$emptyFunction() {}
function $789b9cd674f6331e$var$emptyFunctionWithReset() {}
$789b9cd674f6331e$var$emptyFunctionWithReset.resetWarningCache = $789b9cd674f6331e$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $Vsruk) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $789b9cd674f6331e$var$emptyFunctionWithReset,
        resetWarningCache: $789b9cd674f6331e$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("Vsruk", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $0acb630bb97deae7$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $0acb630bb97deae7$var$ReactPropTypesSecret;

});



parcelRegister("6N8I1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.GRACE_PERIOD = module.exports.PRODUCT_OVERVIEW_TYPE_GENERIC = module.exports.PRODUCT_OVERVIEW_TYPE_RBM = module.exports.PRODUCT_OVERVIEW_TYPE_RESERVED_OA = module.exports.PRODUCT_OVERVIEW_TYPE_ACCESS_NUMBER_RANGE = module.exports.PRODUCT_OVERVIEW_TYPE_ACCESS_NUMBER = module.exports.FEE_TYPE_MONTHLY = module.exports.FEE_TYPE_ESTABLISHMENT = module.exports.chargeTypes = module.exports.CHARGE_TYPE_POSTPAID = module.exports.CHARGE_TYPE_PREPAID = module.exports.balanceTypes = module.exports.BALANCE_TYPE_CREDIT = module.exports.BALANCE_TYPE_DEBIT = module.exports.PRODUCT_TYPE_MO_SERVICE = module.exports.PRODUCT_TYPE_EVENT = module.exports.PRODUCT_TYPE_RESERVED_OA = module.exports.PRODUCT_TYPE_POSITIONING = module.exports.PRODUCT_TYPE_MO_DIRECT_CHARGE_RANGE = module.exports.PRODUCT_TYPE_MO_CUSTOMER_NUMBER = module.exports.PRODUCT_TYPE_MO_LONG_NUMBER_RANGE = module.exports.PRODUCT_TYPE_MO_LONG_NUMBER = module.exports.PRODUCT_TYPE_SMS_BULK = module.exports.contractTypeName = module.exports.contractTypes = module.exports.INTERNAL_CONTRACT_TYPE = module.exports.EXTERNAL_CONTRACT_TYPE = module.exports.ALL = void 0;
module.exports.ALL = "ALL";
module.exports.EXTERNAL_CONTRACT_TYPE = "EXTERNAL";
module.exports.INTERNAL_CONTRACT_TYPE = "INTERNAL";
module.exports.contractTypes = [
    {
        id: module.exports.EXTERNAL_CONTRACT_TYPE,
        name: "External"
    },
    {
        id: module.exports.INTERNAL_CONTRACT_TYPE,
        name: "Internal"
    }
];
const $4f1e131dd931ffe4$var$contractTypeName = (id)=>{
    var _a;
    return ((_a = module.exports.contractTypes.find((ct)=>ct.id.equalsIgnoreCase(id))) === null || _a === void 0 ? void 0 : _a.name) || id;
};
module.exports.contractTypeName = $4f1e131dd931ffe4$var$contractTypeName;
module.exports.PRODUCT_TYPE_SMS_BULK = "SMS_BULK";
module.exports.PRODUCT_TYPE_MO_LONG_NUMBER = "MO_LONG_NUMBER";
module.exports.PRODUCT_TYPE_MO_LONG_NUMBER_RANGE = "MO_LONG_NUMBER_RANGE";
module.exports.PRODUCT_TYPE_MO_CUSTOMER_NUMBER = "MO_CUSTOMER_NUMBER";
module.exports.PRODUCT_TYPE_MO_DIRECT_CHARGE_RANGE = "MO_DIRECT_CHARGE_RANGE";
module.exports.PRODUCT_TYPE_POSITIONING = "POSITIONING";
module.exports.PRODUCT_TYPE_RESERVED_OA = "RESERVED_OA";
module.exports.PRODUCT_TYPE_EVENT = "SMS_EVENT";
module.exports.PRODUCT_TYPE_MO_SERVICE = "MO_SERVICE";
module.exports.BALANCE_TYPE_DEBIT = "DEBIT";
module.exports.BALANCE_TYPE_CREDIT = "CREDIT";
module.exports.balanceTypes = [
    {
        id: module.exports.BALANCE_TYPE_DEBIT,
        name: "Debit"
    },
    {
        id: module.exports.BALANCE_TYPE_CREDIT,
        name: "Credit"
    }
];
module.exports.CHARGE_TYPE_PREPAID = "PREPAID";
module.exports.CHARGE_TYPE_POSTPAID = "POSTPAID";
module.exports.chargeTypes = [
    {
        id: module.exports.CHARGE_TYPE_PREPAID,
        name: "Prepaid"
    },
    {
        id: module.exports.CHARGE_TYPE_POSTPAID,
        name: "Postpaid"
    }
];
module.exports.FEE_TYPE_ESTABLISHMENT = "ESTABLISHMENT";
module.exports.FEE_TYPE_MONTHLY = "MONTHLY";
module.exports.PRODUCT_OVERVIEW_TYPE_ACCESS_NUMBER = "accessNumber";
module.exports.PRODUCT_OVERVIEW_TYPE_ACCESS_NUMBER_RANGE = "accessNumberRange";
module.exports.PRODUCT_OVERVIEW_TYPE_RESERVED_OA = "reservedOa";
module.exports.PRODUCT_OVERVIEW_TYPE_RBM = "rbm";
module.exports.PRODUCT_OVERVIEW_TYPE_GENERIC = "generic";
module.exports.GRACE_PERIOD = 14; // days

});

parcelRegister("4119J", function(module, exports) {
"use strict";
var $2ec826fc9459e01c$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isTodayOrFuture = module.exports.formatGroupPeriodDate = module.exports.nextMonthMm = module.exports.isValidDuration = module.exports.dateOfLastDayOfPreviousMonth = module.exports.settlementPeriodFromHuman = module.exports.settlementPeriod = module.exports.settlementPeriodMonth = module.exports.settlementPeriodYear = module.exports.monthMm = module.exports.yearsFrom = module.exports.years = module.exports.monthOptionValues = module.exports.monthNames = void 0;

var $4QBiq = parcelRequire("4QBiq");

const $2ec826fc9459e01c$var$moment_1 = $2ec826fc9459e01c$var$__importDefault((parcelRequire("c30H9")));

var $l8GLF = parcelRequire("l8GLF");
parcelRequire("g6Bzp");
module.exports.monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
module.exports.monthOptionValues = module.exports.monthNames.map((monthName, i)=>({
        id: `${i + 1}`.padStart(2, "0"),
        name: monthName
    }));
module.exports.years = Array.range(2018, new Date().getFullYear());
const $2ec826fc9459e01c$var$yearsFrom = (startYear)=>Array.range(startYear, new Date().getFullYear());
module.exports.yearsFrom = $2ec826fc9459e01c$var$yearsFrom;
const $2ec826fc9459e01c$var$monthMm = (month)=>{
    let monthNumber;
    if (typeof month === "number") monthNumber = month;
    else if (month instanceof Date) monthNumber = month.getMonth() + 1;
    else {
        monthNumber = parseInt(month);
        if (isNaN(monthNumber)) monthNumber = $4QBiq.i18n.monthNames.indexOf(month) % 12 + 1;
    }
    return monthNumber.toString().padStart(2, "0");
};
module.exports.monthMm = $2ec826fc9459e01c$var$monthMm;
const $2ec826fc9459e01c$var$settlementPeriodYear = (yyyyMm)=>yyyyMm.toString().substring(0, 4);
module.exports.settlementPeriodYear = $2ec826fc9459e01c$var$settlementPeriodYear;
const $2ec826fc9459e01c$var$settlementPeriodMonth = (yyyyMm)=>yyyyMm.toString().substring(4, 6);
module.exports.settlementPeriodMonth = $2ec826fc9459e01c$var$settlementPeriodMonth;
const $2ec826fc9459e01c$var$settlementPeriod = (year, month)=>`${year}${(0, module.exports.monthMm)(month)}`;
module.exports.settlementPeriod = $2ec826fc9459e01c$var$settlementPeriod;
const $2ec826fc9459e01c$var$settlementPeriodFromHuman = (humanMonthYear)=>{
    const [monthName, year] = humanMonthYear.split(" ");
    const mm = monthName !== undefined ? (0, module.exports.monthMm)(monthName) : "00";
    const yyyy = year !== undefined ? year : "0000";
    return (0, module.exports.settlementPeriod)(yyyy, mm);
};
module.exports.settlementPeriodFromHuman = $2ec826fc9459e01c$var$settlementPeriodFromHuman;
const $2ec826fc9459e01c$var$dateOfLastDayOfPreviousMonth = ()=>{
    const date = new Date(); //  today
    date.setDate(0); //  last day of previous month;
    return date;
};
module.exports.dateOfLastDayOfPreviousMonth = $2ec826fc9459e01c$var$dateOfLastDayOfPreviousMonth;
const $2ec826fc9459e01c$var$iso8601DurationRegex = /^(-?)P(?=\d|T\d)(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)([DW]))?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:[.,]\d+)?)S)?)?$/;
const $2ec826fc9459e01c$var$isValidDuration = (duration)=>!!duration.match($2ec826fc9459e01c$var$iso8601DurationRegex);
module.exports.isValidDuration = $2ec826fc9459e01c$var$isValidDuration;
const $2ec826fc9459e01c$var$nextMonthMm = (mm)=>{
    const monthIndex = parseInt(mm.toString());
    const nextMonthIndex = monthIndex === 12 ? 1 : monthIndex + 1;
    return nextMonthIndex.toString().padStart(2, "0");
};
module.exports.nextMonthMm = $2ec826fc9459e01c$var$nextMonthMm;
/**
 * Assumes the startDate is already set to the start of the group period in yyyy-mm-dd format,
 * and returns a readable string representing the group period with the given start date.
 *
 * @param {string} startDate - The start date in yyyy-mm-dd format.
 * @param {GroupPeriod} [groupPeriod] - The group period (e.g., QUARTER, MONTH, WEEK, DAY).
 * @returns {string} A human-readable representation of the group period.
 */ const $2ec826fc9459e01c$var$formatGroupPeriodDate = (startDate, groupPeriod)=>{
    switch(groupPeriod){
        case $l8GLF.GroupPeriod.QUARTER:
            return `${startDate.substring(0, 7)} - ${(0, $2ec826fc9459e01c$var$moment_1.default)(startDate).add(2, "months").format("YYYY-MM")}`;
        case $l8GLF.GroupPeriod.MONTH:
            return startDate.substring(0, 7); // yyyy-mm-dd -> yyyy-mm
        case $l8GLF.GroupPeriod.WEEK:
            return `${(0, $2ec826fc9459e01c$var$moment_1.default)(startDate).format("YYYY-MM-DD")} - ${(0, $2ec826fc9459e01c$var$moment_1.default)(startDate).add(6, "days").format("YYYY-MM-DD")}`;
        case $l8GLF.GroupPeriod.DAY:
        default:
            return (0, $2ec826fc9459e01c$var$moment_1.default)(startDate).format("YYYY-MM-DD");
    }
};
module.exports.formatGroupPeriodDate = $2ec826fc9459e01c$var$formatGroupPeriodDate;
const $2ec826fc9459e01c$var$isTodayOrFuture = (date)=>{
    return (0, $2ec826fc9459e01c$var$moment_1.default)(date).isSameOrAfter((0, $2ec826fc9459e01c$var$moment_1.default)(), "day");
};
module.exports.isTodayOrFuture = $2ec826fc9459e01c$var$isTodayOrFuture;

});
parcelRegister("4QBiq", function(module, exports) {
/*
 * Date Format 1.2.3
 * (c) 2007-2009 Steven Levithan <stevenlevithan.com>
 * MIT license
 *
 * Includes enhancements by Scott Trenda <scott.trenda.net>
 * and Kris Kowal <cixar.com/~kris.kowal/>
 *
 * Accepts a date, a mask, or a date and a mask.
 * Returns a formatted version of the given date.
 * The date defaults to the current date/time.
 * The mask defaults to dateFormat.masks.default.
 */ (function(global) {
    "use strict";
    var dateFormat = function() {
        var token = /d{1,4}|m{1,4}|yy(?:yy)?|([HhMsTt])\1?|[LloSZWN]|'[^']*'|'[^']*'/g;
        var timezone = /\b(?:[PMCEA][SDP]T|(?:Pacific|Mountain|Central|Eastern|Atlantic) (?:Standard|Daylight|Prevailing) Time|(?:GMT|UTC)(?:[-+]\d{4})?)\b/g;
        var timezoneClip = /[^-+\dA-Z]/g;
        // Regexes and supporting functions are cached through closure
        return function(date, mask, utc, gmt) {
            // You can't provide utc if you skip other args (use the 'UTC:' mask prefix)
            if (arguments.length === 1 && kindOf(date) === "string" && !/\d/.test(date)) {
                mask = date;
                date = undefined;
            }
            date = date || new Date;
            if (!(date instanceof Date)) date = new Date(date);
            if (isNaN(date)) throw TypeError("Invalid date");
            mask = String(dateFormat.masks[mask] || mask || dateFormat.masks["default"]);
            // Allow setting the utc/gmt argument via the mask
            var maskSlice = mask.slice(0, 4);
            if (maskSlice === "UTC:" || maskSlice === "GMT:") {
                mask = mask.slice(4);
                utc = true;
                if (maskSlice === "GMT:") gmt = true;
            }
            var _ = utc ? "getUTC" : "get";
            var d = date[_ + "Date"]();
            var D = date[_ + "Day"]();
            var m = date[_ + "Month"]();
            var y = date[_ + "FullYear"]();
            var H = date[_ + "Hours"]();
            var M = date[_ + "Minutes"]();
            var s = date[_ + "Seconds"]();
            var L = date[_ + "Milliseconds"]();
            var o = utc ? 0 : date.getTimezoneOffset();
            var W = getWeek(date);
            var N = getDayOfWeek(date);
            var flags = {
                d: d,
                dd: pad(d),
                ddd: dateFormat.i18n.dayNames[D],
                dddd: dateFormat.i18n.dayNames[D + 7],
                m: m + 1,
                mm: pad(m + 1),
                mmm: dateFormat.i18n.monthNames[m],
                mmmm: dateFormat.i18n.monthNames[m + 12],
                yy: String(y).slice(2),
                yyyy: y,
                h: H % 12 || 12,
                hh: pad(H % 12 || 12),
                H: H,
                HH: pad(H),
                M: M,
                MM: pad(M),
                s: s,
                ss: pad(s),
                l: pad(L, 3),
                L: pad(Math.round(L / 10)),
                t: H < 12 ? dateFormat.i18n.timeNames[0] : dateFormat.i18n.timeNames[1],
                tt: H < 12 ? dateFormat.i18n.timeNames[2] : dateFormat.i18n.timeNames[3],
                T: H < 12 ? dateFormat.i18n.timeNames[4] : dateFormat.i18n.timeNames[5],
                TT: H < 12 ? dateFormat.i18n.timeNames[6] : dateFormat.i18n.timeNames[7],
                Z: gmt ? "GMT" : utc ? "UTC" : (String(date).match(timezone) || [
                    ""
                ]).pop().replace(timezoneClip, ""),
                o: (o > 0 ? "-" : "+") + pad(Math.floor(Math.abs(o) / 60) * 100 + Math.abs(o) % 60, 4),
                S: [
                    "th",
                    "st",
                    "nd",
                    "rd"
                ][d % 10 > 3 ? 0 : (d % 100 - d % 10 != 10) * d % 10],
                W: W,
                N: N
            };
            return mask.replace(token, function(match) {
                if (match in flags) return flags[match];
                return match.slice(1, match.length - 1);
            });
        };
    }();
    dateFormat.masks = {
        "default": "ddd mmm dd yyyy HH:MM:ss",
        "shortDate": "m/d/yy",
        "mediumDate": "mmm d, yyyy",
        "longDate": "mmmm d, yyyy",
        "fullDate": "dddd, mmmm d, yyyy",
        "shortTime": "h:MM TT",
        "mediumTime": "h:MM:ss TT",
        "longTime": "h:MM:ss TT Z",
        "isoDate": "yyyy-mm-dd",
        "isoTime": "HH:MM:ss",
        "isoDateTime": "yyyy-mm-dd'T'HH:MM:sso",
        "isoUtcDateTime": "UTC:yyyy-mm-dd'T'HH:MM:ss'Z'",
        "expiresHeaderFormat": "ddd, dd mmm yyyy HH:MM:ss Z"
    };
    // Internationalization strings
    dateFormat.i18n = {
        dayNames: [
            "Sun",
            "Mon",
            "Tue",
            "Wed",
            "Thu",
            "Fri",
            "Sat",
            "Sunday",
            "Monday",
            "Tuesday",
            "Wednesday",
            "Thursday",
            "Friday",
            "Saturday"
        ],
        monthNames: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "Sep",
            "Oct",
            "Nov",
            "Dec",
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ],
        timeNames: [
            "a",
            "p",
            "am",
            "pm",
            "A",
            "P",
            "AM",
            "PM"
        ]
    };
    function pad(val, len) {
        val = String(val);
        len = len || 2;
        while(val.length < len)val = "0" + val;
        return val;
    }
    /**
 * Get the ISO 8601 week number
 * Based on comments from
 * http://techblog.procurios.nl/k/n618/news/view/33796/14863/Calculate-ISO-8601-week-and-year-in-javascript.html
 *
 * @param  {Object} `date`
 * @return {Number}
 */ function getWeek(date) {
        // Remove time components of date
        var targetThursday = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        // Change date to Thursday same week
        targetThursday.setDate(targetThursday.getDate() - (targetThursday.getDay() + 6) % 7 + 3);
        // Take January 4th as it is always in week 1 (see ISO 8601)
        var firstThursday = new Date(targetThursday.getFullYear(), 0, 4);
        // Change date to Thursday same week
        firstThursday.setDate(firstThursday.getDate() - (firstThursday.getDay() + 6) % 7 + 3);
        // Check if daylight-saving-time-switch occurred and correct for it
        var ds = targetThursday.getTimezoneOffset() - firstThursday.getTimezoneOffset();
        targetThursday.setHours(targetThursday.getHours() - ds);
        // Number of weeks between target Thursday and first Thursday
        var weekDiff = (targetThursday - firstThursday) / 604800000;
        return 1 + Math.floor(weekDiff);
    }
    /**
 * Get ISO-8601 numeric representation of the day of the week
 * 1 (for Monday) through 7 (for Sunday)
 * 
 * @param  {Object} `date`
 * @return {Number}
 */ function getDayOfWeek(date) {
        var dow = date.getDay();
        if (dow === 0) dow = 7;
        return dow;
    }
    /**
 * kind-of shortcut
 * @param  {*} val
 * @return {String}
 */ function kindOf(val) {
        if (val === null) return "null";
        if (val === undefined) return "undefined";
        if (typeof val !== "object") return typeof val;
        if (Array.isArray(val)) return "array";
        return ({}).toString.call(val).slice(8, -1).toLowerCase();
    }
    if (typeof define === "function" && define.amd) define(function() {
        return dateFormat;
    });
    else module.exports = dateFormat;
})(module.exports);

});

parcelRegister("c30H9", function(module, exports) {
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    "use strict";
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === "[object Array]";
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === "[object Object]";
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === "number" || Object.prototype.toString.call(input) === "[object Number]";
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === "[object Date]";
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, "toString")) a.toString = b.toString;
        if (hasOwnProp(b, "valueOf")) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== "undefined" && console.warn) console.warn("Deprecation warning: " + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = "";
                    if (typeof arguments[i] === "object") {
                        arg += "\n[" + i + "] ";
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ": " + arguments[0][key] + ", ";
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + "\nArguments: " + Array.prototype.slice.call(args).join("") + "\n" + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== "undefined" && input instanceof Function || Object.prototype.toString.call(input) === "[object Function]";
    }
    function set(config) {
        var prop, i;
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this["_" + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + "|" + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: "[Today at] LT",
        nextDay: "[Tomorrow at] LT",
        nextWeek: "dddd [at] LT",
        lastDay: "[Yesterday at] LT",
        lastWeek: "[Last] dddd [at] LT",
        sameElse: "L"
    };
    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar["sameElse"];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = "" + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? "+" : "" : "-") + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === "string") func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, "");
        return input.replace(/\\/g, "");
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = "", i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
        return formatFunctions[format](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var defaultLongDateFormat = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
        if (format || !formatUpper) return format;
        this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === "MMMM" || tok === "MM" || tok === "DD" || tok === "dddd") return tok.slice(1);
            return tok;
        }).join("");
        return this._longDateFormat[key];
    }
    var defaultInvalidDate = "Invalid date";
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = "%d", defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace("%d", number);
    }
    var defaultRelativeTime = {
        future: "in %s",
        past: "%s ago",
        s: "a few seconds",
        ss: "%d seconds",
        m: "a minute",
        mm: "%d minutes",
        h: "an hour",
        hh: "%d hours",
        d: "a day",
        dd: "%d days",
        w: "a week",
        ww: "%d weeks",
        M: "a month",
        MM: "%d months",
        y: "a year",
        yy: "%d years"
    };
    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? "future" : "past"];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    var aliases = {
        D: "date",
        dates: "date",
        date: "date",
        d: "day",
        days: "day",
        day: "day",
        e: "weekday",
        weekdays: "weekday",
        weekday: "weekday",
        E: "isoWeekday",
        isoweekdays: "isoWeekday",
        isoweekday: "isoWeekday",
        DDD: "dayOfYear",
        dayofyears: "dayOfYear",
        dayofyear: "dayOfYear",
        h: "hour",
        hours: "hour",
        hour: "hour",
        ms: "millisecond",
        milliseconds: "millisecond",
        millisecond: "millisecond",
        m: "minute",
        minutes: "minute",
        minute: "minute",
        M: "month",
        months: "month",
        month: "month",
        Q: "quarter",
        quarters: "quarter",
        quarter: "quarter",
        s: "second",
        seconds: "second",
        second: "second",
        gg: "weekYear",
        weekyears: "weekYear",
        weekyear: "weekYear",
        GG: "isoWeekYear",
        isoweekyears: "isoWeekYear",
        isoweekyear: "isoWeekYear",
        w: "week",
        weeks: "week",
        week: "week",
        W: "isoWeek",
        isoweeks: "isoWeek",
        isoweek: "isoWeek",
        y: "year",
        years: "year",
        year: "year"
    };
    function normalizeUnits(units) {
        return typeof units === "string" ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace("\\", "").replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === "string") token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken("Y", 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : "+" + y;
    });
    addFormatToken(0, [
        "YY",
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        "YYYY",
        4
    ], 0, "year");
    addFormatToken(0, [
        "YYYYY",
        5
    ], 0, "year");
    addFormatToken(0, [
        "YYYYYY",
        6,
        true
    ], 0, "year");
    // PARSING
    addRegexToken("Y", matchSigned);
    addRegexToken("YY", match1to2, match2);
    addRegexToken("YYYY", match1to4, match4);
    addRegexToken("YYYYY", match1to6, match6);
    addRegexToken("YYYYYY", match1to6, match6);
    addParseToken([
        "YYYYY",
        "YYYYYY"
    ], YEAR);
    addParseToken("YYYY", function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken("YY", function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken("Y", function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet("FullYear", true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get(this, unit);
        };
    }
    function get(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case "Seconds":
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case "Minutes":
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case "Hours":
                return isUTC ? d.getUTCHours() : d.getHours();
            case "Date":
                return isUTC ? d.getUTCDate() : d.getDate();
            case "Day":
                return isUTC ? d.getUTCDay() : d.getDay();
            case "Month":
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case "FullYear":
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case "Milliseconds":
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case "Seconds":
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case "Minutes":
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case "Hours":
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case "Date":
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case "FullYear":
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === "object") {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken("M", [
        "MM",
        2
    ], "Mo", function() {
        return this.month() + 1;
    });
    addFormatToken("MMM", 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken("MMMM", 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken("M", match1to2, match1to2NoLeadingZero);
    addRegexToken("MM", match1to2, match2);
    addRegexToken("MMM", function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken("MMMM", function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        "M",
        "MM"
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        "MMM",
        "MMMM"
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), defaultLocaleMonthsShort = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months["standalone"];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? "format" : "standalone"][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort["standalone"];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? "format" : "standalone"][m.month()];
    }
    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, "").toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "MMM") {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === "MMM") {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp("^" + this.months(mom, "").replace(".", "") + "$", "i");
                this._shortMonthsParse[i] = new RegExp("^" + this.monthsShort(mom, "").replace(".", "") + "$", "i");
            }
            if (!strict && !this._monthsParse[i]) {
                regex = "^" + this.months(mom, "") + "|^" + this.monthsShort(mom, "");
                this._monthsParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "MMMM" && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === "MMM" && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === "string") {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get(this, "Month");
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, "_monthsShortRegex")) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, "_monthsRegex")) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, "_monthsRegex")) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ""));
            longP = regexEscape(this.months(mom, ""));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._monthsShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken("w", [
        "ww",
        2
    ], "wo", "week");
    addFormatToken("W", [
        "WW",
        2
    ], "Wo", "isoWeek");
    // PARSING
    addRegexToken("w", match1to2, match1to2NoLeadingZero);
    addRegexToken("ww", match1to2, match2);
    addRegexToken("W", match1to2, match1to2NoLeadingZero);
    addRegexToken("WW", match1to2, match2);
    addWeekParseToken([
        "w",
        "ww",
        "W",
        "WW"
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, "d");
    }
    // FORMATTING
    addFormatToken("d", 0, "do", "day");
    addFormatToken("dd", 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken("ddd", 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken("dddd", 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken("e", 0, 0, "weekday");
    addFormatToken("E", 0, 0, "isoWeekday");
    // PARSING
    addRegexToken("d", match1to2);
    addRegexToken("e", match1to2);
    addRegexToken("E", match1to2);
    addRegexToken("dd", function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken("ddd", function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken("dddd", function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        "dd",
        "ddd",
        "dddd"
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        "d",
        "e",
        "E"
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== "string") return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === "number") return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === "string") return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), defaultLocaleWeekdaysShort = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"), defaultLocaleWeekdaysMin = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? "format" : "standalone"];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, "").toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, "").toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, "").toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === "dddd") {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === "ddd") {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp("^" + this.weekdays(mom, "").replace(".", "\\.?") + "$", "i");
                this._shortWeekdaysParse[i] = new RegExp("^" + this.weekdaysShort(mom, "").replace(".", "\\.?") + "$", "i");
                this._minWeekdaysParse[i] = new RegExp("^" + this.weekdaysMin(mom, "").replace(".", "\\.?") + "$", "i");
            }
            if (!this._weekdaysParse[i]) {
                regex = "^" + this.weekdays(mom, "") + "|^" + this.weekdaysShort(mom, "") + "|^" + this.weekdaysMin(mom, "");
                this._weekdaysParse[i] = new RegExp(regex.replace(".", ""), "i");
            }
            // test the regex
            if (strict && format === "dddd" && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "ddd" && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === "dd" && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get(this, "Day");
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, "d");
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, "d");
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysRegex")) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysShortRegex")) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, "_weekdaysRegex")) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, "_weekdaysMinRegex")) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ""));
            shortp = regexEscape(this.weekdaysShort(mom, ""));
            longp = regexEscape(this.weekdays(mom, ""));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp("^(" + longPieces.join("|") + ")", "i");
        this._weekdaysShortStrictRegex = new RegExp("^(" + shortPieces.join("|") + ")", "i");
        this._weekdaysMinStrictRegex = new RegExp("^(" + minPieces.join("|") + ")", "i");
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken("H", [
        "HH",
        2
    ], 0, "hour");
    addFormatToken("h", [
        "hh",
        2
    ], 0, hFormat);
    addFormatToken("k", [
        "kk",
        2
    ], 0, kFormat);
    addFormatToken("hmm", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken("hmmss", 0, 0, function() {
        return "" + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken("Hmm", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken("Hmmss", 0, 0, function() {
        return "" + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem("a", true);
    meridiem("A", false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken("a", matchMeridiem);
    addRegexToken("A", matchMeridiem);
    addRegexToken("H", match1to2, match1to2HasZero);
    addRegexToken("h", match1to2, match1to2NoLeadingZero);
    addRegexToken("k", match1to2, match1to2NoLeadingZero);
    addRegexToken("HH", match1to2, match2);
    addRegexToken("hh", match1to2, match2);
    addRegexToken("kk", match1to2, match2);
    addRegexToken("hmm", match3to4);
    addRegexToken("hmmss", match5to6);
    addRegexToken("Hmm", match3to4);
    addRegexToken("Hmmss", match5to6);
    addParseToken([
        "H",
        "HH"
    ], HOUR);
    addParseToken([
        "k",
        "kk"
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        "a",
        "A"
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        "h",
        "hh"
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken("Hmm", function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken("Hmmss", function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + "").toLowerCase().charAt(0) === "p";
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet("Hours", true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? "pm" : "PM";
        else return isLower ? "am" : "AM";
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace("_", "-") : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split("-");
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split("-") : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join("-"));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match("^[^/\\\\]*$"));
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire("./locale/" + name);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[name] = null; // null means not found
        }
        return locales[name];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== "undefined" && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn("Locale " + key + " not found. Did you forget to load it?");
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple("defineLocaleOverride", "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            "YYYYYY-MM-DD",
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            "YYYY-MM-DD",
            /\d{4}-\d\d-\d\d/
        ],
        [
            "GGGG-[W]WW-E",
            /\d{4}-W\d\d-\d/
        ],
        [
            "GGGG-[W]WW",
            /\d{4}-W\d\d/,
            false
        ],
        [
            "YYYY-DDD",
            /\d{4}-\d{3}/
        ],
        [
            "YYYY-MM",
            /\d{4}-\d\d/,
            false
        ],
        [
            "YYYYYYMMDD",
            /[+-]\d{10}/
        ],
        [
            "YYYYMMDD",
            /\d{8}/
        ],
        [
            "GGGG[W]WWE",
            /\d{4}W\d{3}/
        ],
        [
            "GGGG[W]WW",
            /\d{4}W\d{2}/,
            false
        ],
        [
            "YYYYDDD",
            /\d{7}/
        ],
        [
            "YYYYMM",
            /\d{6}/,
            false
        ],
        [
            "YYYY",
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            "HH:mm:ss.SSSS",
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            "HH:mm:ss,SSSS",
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            "HH:mm:ss",
            /\d\d:\d\d:\d\d/
        ],
        [
            "HH:mm",
            /\d\d:\d\d/
        ],
        [
            "HHmmss.SSSS",
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            "HHmmss,SSSS",
            /\d\d\d\d\d\d,\d+/
        ],
        [
            "HHmmss",
            /\d\d\d\d\d\d/
        ],
        [
            "HHmm",
            /\d\d\d\d/
        ],
        [
            "HH",
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || " ") + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = "Z";
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || "") + (tzFormat || "");
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "");
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? " UTC" : ""));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;
        if (config._d) return;
        currentDate = currentDateArray(config);
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== "undefined" && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYear(createLocal(), dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = "" + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, "d");
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === "") return createInvalid({
            nullInput: true
        });
        if (typeof input === "string") config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === "string") configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate("moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid();
    }), prototypeMax = deprecate("moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/", function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        res = moments[0];
        for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isBefore", args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy("isAfter", args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        "year",
        "quarter",
        "month",
        "week",
        "day",
        "hour",
        "minute",
        "second",
        "millisecond"
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid$1() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = "+";
            if (offset < 0) {
                offset = -offset;
                sign = "-";
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset("Z", ":");
    offset("ZZ", "");
    // PARSING
    addRegexToken("Z", matchShortOffset);
    addRegexToken("ZZ", matchShortOffset);
    addParseToken([
        "Z",
        "ZZ"
    ], function(input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || "").match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + "").match(chunkOffset) || [
            "-",
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        return minutes === 0 ? 0 : parts[0] === "+" ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === "string") {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, "m");
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, "m"), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== "string") input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), "m");
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === "string") {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === "-" ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === "object" && ("from" in duration || "to" in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, "_locale")) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, "_isValid")) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(",", "."));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, "M").isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, "M");
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, "moment()." + name + "(period, number) is deprecated. Please use moment()." + name + "(number, period). " + "See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.");
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }
    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get(mom, "Month") + months * isAdding);
        if (days) set$1(mom, "Date", get(mom, "Date") + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add = createAdder(1, "add"), subtract = createAdder(-1, "subtract");
    function isString(input) {
        return typeof input === "string" || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "years",
            "year",
            "y",
            "months",
            "month",
            "M",
            "days",
            "day",
            "d",
            "dates",
            "date",
            "D",
            "hours",
            "hour",
            "h",
            "minutes",
            "minute",
            "m",
            "seconds",
            "second",
            "s",
            "milliseconds",
            "millisecond",
            "ms"
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            "sameDay",
            "nextDay",
            "lastDay",
            "nextWeek",
            "lastWeek",
            "sameElse"
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, "days", true);
        return diff < -6 ? "sameElse" : diff < -1 ? "lastWeek" : diff < 0 ? "lastDay" : diff < 1 ? "sameDay" : diff < 2 ? "nextDay" : diff < 7 ? "nextWeek" : "sameElse";
    }
    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf("day"), format = hooks.calendarFormat(this, sod) || "sameElse", output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || "()";
        return (inclusivity[0] === "(" ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ")" ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || "millisecond";
        if (units === "millisecond") return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case "year":
                output = monthDiff(this, that) / 12;
                break;
            case "month":
                output = monthDiff(this, that);
                break;
            case "quarter":
                output = monthDiff(this, that) / 3;
                break;
            case "second":
                output = (this - that) / 1e3;
                break; // 1000
            case "minute":
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case "hour":
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case "day":
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case "week":
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, "months"), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, "months");
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ";
    hooks.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]";
    function toString() {
        return this.clone().locale("en").format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
    }
    function toISOString(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ");
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace("Z", formatMoment(m, "Z"));
        }
        return formatMoment(m, utc ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]" : "YYYY-MM-DD[T]HH:mm:ss.SSSZ");
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
        var func = "moment", zone = "", prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? "moment.utc" : "moment.parseZone";
            zone = "Z";
        }
        prefix = "[" + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY";
        datetime = "-MM-DD[T]HH:mm:ss.SSS";
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate("moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.", function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year(), 0, 1);
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case "month":
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case "hour":
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case "minute":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case "second":
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === "millisecond" || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case "year":
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case "quarter":
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case "month":
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case "week":
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case "isoWeek":
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case "day":
            case "date":
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case "hour":
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case "minute":
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case "second":
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid$2() {
        return isValid(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken("N", 0, 0, "eraAbbr");
    addFormatToken("NN", 0, 0, "eraAbbr");
    addFormatToken("NNN", 0, 0, "eraAbbr");
    addFormatToken("NNNN", 0, 0, "eraName");
    addFormatToken("NNNNN", 0, 0, "eraNarrow");
    addFormatToken("y", [
        "y",
        1
    ], "yo", "eraYear");
    addFormatToken("y", [
        "yy",
        2
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyy",
        3
    ], 0, "eraYear");
    addFormatToken("y", [
        "yyyy",
        4
    ], 0, "eraYear");
    addRegexToken("N", matchEraAbbr);
    addRegexToken("NN", matchEraAbbr);
    addRegexToken("NNN", matchEraAbbr);
    addRegexToken("NNNN", matchEraName);
    addRegexToken("NNNNN", matchEraNarrow);
    addParseToken([
        "N",
        "NN",
        "NNN",
        "NNNN",
        "NNNNN"
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken("y", matchUnsigned);
    addRegexToken("yy", matchUnsigned);
    addRegexToken("yyy", matchUnsigned);
    addRegexToken("yyyy", matchUnsigned);
    addRegexToken("yo", matchEraYearOrdinal);
    addParseToken([
        "y",
        "yy",
        "yyy",
        "yyyy"
    ], YEAR);
    addParseToken([
        "yo"
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale("en")._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case "string":
                    // truncate time
                    date = hooks(eras[i].since).startOf("day");
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case "undefined":
                    eras[i].until = Infinity;
                    break;
                case "string":
                    // truncate time
                    date = hooks(eras[i].until).startOf("day").valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case "N":
                case "NN":
                case "NNN":
                    if (abbr === eraName) return eras[i];
                    break;
                case "NNNN":
                    if (name === eraName) return eras[i];
                    break;
                case "NNNNN":
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return "";
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return "";
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return "";
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf("day").valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNameRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, "_erasAbbrRegex")) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, "_erasNarrowRegex")) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp("^(" + mixedPieces.join("|") + ")", "i");
        this._erasNameRegex = new RegExp("^(" + namePieces.join("|") + ")", "i");
        this._erasAbbrRegex = new RegExp("^(" + abbrPieces.join("|") + ")", "i");
        this._erasNarrowRegex = new RegExp("^(" + narrowPieces.join("|") + ")", "i");
    }
    // FORMATTING
    addFormatToken(0, [
        "gg",
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        "GG",
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken("gggg", "weekYear");
    addWeekYearFormatToken("ggggg", "weekYear");
    addWeekYearFormatToken("GGGG", "isoWeekYear");
    addWeekYearFormatToken("GGGGG", "isoWeekYear");
    // ALIASES
    // PARSING
    addRegexToken("G", matchSigned);
    addRegexToken("g", matchSigned);
    addRegexToken("GG", match1to2, match2);
    addRegexToken("gg", match1to2, match2);
    addRegexToken("GGGG", match1to4, match4);
    addRegexToken("gggg", match1to4, match4);
    addRegexToken("GGGGG", match1to6, match6);
    addRegexToken("ggggg", match1to6, match6);
    addWeekParseToken([
        "gggg",
        "ggggg",
        "GGGG",
        "GGGGG"
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        "gg",
        "GG"
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken("Q", 0, "Qo", "quarter");
    // PARSING
    addRegexToken("Q", match1);
    addParseToken("Q", function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken("D", [
        "DD",
        2
    ], "Do", "date");
    // PARSING
    addRegexToken("D", match1to2, match1to2NoLeadingZero);
    addRegexToken("DD", match1to2, match2);
    addRegexToken("Do", function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        "D",
        "DD"
    ], DATE);
    addParseToken("Do", function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet("Date", true);
    // FORMATTING
    addFormatToken("DDD", [
        "DDDD",
        3
    ], "DDDo", "dayOfYear");
    // PARSING
    addRegexToken("DDD", match1to3);
    addRegexToken("DDDD", match3);
    addParseToken([
        "DDD",
        "DDDD"
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf("day") - this.clone().startOf("year")) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, "d");
    }
    // FORMATTING
    addFormatToken("m", [
        "mm",
        2
    ], 0, "minute");
    // PARSING
    addRegexToken("m", match1to2, match1to2HasZero);
    addRegexToken("mm", match1to2, match2);
    addParseToken([
        "m",
        "mm"
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet("Minutes", false);
    // FORMATTING
    addFormatToken("s", [
        "ss",
        2
    ], 0, "second");
    // PARSING
    addRegexToken("s", match1to2, match1to2HasZero);
    addRegexToken("ss", match1to2, match2);
    addParseToken([
        "s",
        "ss"
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet("Seconds", false);
    // FORMATTING
    addFormatToken("S", 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        "SS",
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        "SSS",
        3
    ], 0, "millisecond");
    addFormatToken(0, [
        "SSSS",
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        "SSSSS",
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        "SSSSSS",
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        "SSSSSSS",
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        "SSSSSSSS",
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        "SSSSSSSSS",
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken("S", match1to3, match1);
    addRegexToken("SS", match1to3, match2);
    addRegexToken("SSS", match1to3, match3);
    var token, getSetMillisecond;
    for(token = "SSSS"; token.length <= 9; token += "S")addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(("0." + input) * 1000);
    }
    for(token = "S"; token.length <= 9; token += "S")addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet("Milliseconds", false);
    // FORMATTING
    addFormatToken("z", 0, 0, "zoneAbbr");
    addFormatToken("zz", 0, 0, "zoneName");
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? "UTC" : "";
    }
    function getZoneName() {
        return this._isUTC ? "Coordinated Universal Time" : "";
    }
    var proto = Moment.prototype;
    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== "undefined" && Symbol.for != null) proto[Symbol.for("nodejs.util.inspect.custom")] = function() {
        return "Moment<" + this.format() + ">";
    };
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate("dates accessor is deprecated. Use date instead.", getSetDayOfMonth);
    proto.months = deprecate("months accessor is deprecated. Use month instead", getSetMonth);
    proto.years = deprecate("years accessor is deprecated. Use year instead", getSetYear);
    proto.zone = deprecate("moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/", getSetZone);
    proto.isDSTShifted = deprecate("isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information", isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || "";
        if (index != null) return get$1(format, index, field, "month");
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, "month");
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === "boolean") {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || "";
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, "day");
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, "day");
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, "months");
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, "monthsShort");
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdays");
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysShort");
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, "weekdaysMin");
    }
    getSetGlobalLocale("en", {
        eras: [
            {
                since: "0001-01-01",
                until: Infinity,
                offset: 1,
                name: "Anno Domini",
                narrow: "AD",
                abbr: "AD"
            },
            {
                since: "0000-12-31",
                until: -Infinity,
                offset: 1,
                name: "Before Christ",
                narrow: "BC",
                abbr: "BC"
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate("moment.lang is deprecated. Use moment.locale instead.", getSetGlobalLocale);
    hooks.langData = deprecate("moment.langData is deprecated. Use moment.localeData instead.", getLocale);
    var mathAbs = Math.abs;
    function abs() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === "month" || units === "quarter" || units === "year") {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case "month":
                    return months;
                case "quarter":
                    return months / 3;
                case "year":
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case "week":
                    return days / 7 + milliseconds / 6048e5;
                case "day":
                    return days + milliseconds / 864e5;
                case "hour":
                    return days * 24 + milliseconds / 36e5;
                case "minute":
                    return days * 1440 + milliseconds / 6e4;
                case "second":
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case "millisecond":
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error("Unknown unit " + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs("ms"), asSeconds = makeAs("s"), asMinutes = makeAs("m"), asHours = makeAs("h"), asDays = makeAs("d"), asWeeks = makeAs("w"), asMonths = makeAs("M"), asQuarters = makeAs("Q"), asYears = makeAs("y"), valueOf$1 = asMilliseconds;
    function clone$1() {
        return createDuration(this);
    }
    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + "s"]() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter("milliseconds"), seconds = makeGetter("seconds"), minutes = makeGetter("minutes"), hours = makeGetter("hours"), days = makeGetter("days"), months = makeGetter("months"), years = makeGetter("years");
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as("s")), minutes = round(duration.as("m")), hours = round(duration.as("h")), days = round(duration.as("d")), months = round(duration.as("M")), weeks = round(duration.as("w")), years = round(duration.as("y")), a = seconds <= thresholds.ss && [
            "s",
            seconds
        ] || seconds < thresholds.s && [
            "ss",
            seconds
        ] || minutes <= 1 && [
            "m"
        ] || minutes < thresholds.m && [
            "mm",
            minutes
        ] || hours <= 1 && [
            "h"
        ] || hours < thresholds.h && [
            "hh",
            hours
        ] || days <= 1 && [
            "d"
        ] || days < thresholds.d && [
            "dd",
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            "w"
        ] || weeks < thresholds.w && [
            "ww",
            weeks
        ];
        a = a || months <= 1 && [
            "M"
        ] || months < thresholds.M && [
            "MM",
            months
        ] || years <= 1 && [
            "y"
        ] || [
            "yy",
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === "function") {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === "s") thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === "object") {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === "boolean") withSuffix = argWithSuffix;
        if (typeof argThresholds === "object") {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);
        if (withSuffix) output = locale.pastFuture(+this, output);
        return locale.postformat(output);
    }
    var abs$1 = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return "P0D";
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, "") : "";
        totalSign = total < 0 ? "-" : "";
        ymSign = sign(this._months) !== sign(total) ? "-" : "";
        daysSign = sign(this._days) !== sign(total) ? "-" : "";
        hmsSign = sign(this._milliseconds) !== sign(total) ? "-" : "";
        return totalSign + "P" + (years ? ymSign + years + "Y" : "") + (months ? ymSign + months + "M" : "") + (days ? daysSign + days + "D" : "") + (hours || minutes || seconds ? "T" : "") + (hours ? hmsSign + hours + "H" : "") + (minutes ? hmsSign + minutes + "M" : "") + (seconds ? hmsSign + s + "S" : "");
    }
    var proto$2 = Duration.prototype;
    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.toIsoString = deprecate("toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)", toISOString$1);
    proto$2.lang = lang;
    // FORMATTING
    addFormatToken("X", 0, 0, "unix");
    addFormatToken("x", 0, 0, "valueOf");
    // PARSING
    addRegexToken("x", matchSigned);
    addRegexToken("X", matchTimestamp);
    addParseToken("X", function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken("x", function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = "2.30.1";
    setHookCallback(createLocal);
    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
        DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
        DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
        DATE: "YYYY-MM-DD",
        TIME: "HH:mm",
        TIME_SECONDS: "HH:mm:ss",
        TIME_MS: "HH:mm:ss.SSS",
        WEEK: "GGGG-[W]WW",
        MONTH: "YYYY-MM"
    };
    return hooks;
});

});

parcelRegister("l8GLF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MfaConfig = module.exports.resolutions = module.exports.ResolutionId = module.exports.TrafficFeeType = module.exports.hasMessage = module.exports.hasName = module.exports.TRANSCEIVER = module.exports.RECEIVER = module.exports.TRANSMITTER = module.exports.GroupPeriod = module.exports.DefaultCharset = module.exports.endpointProtocolOptions = module.exports.EndpointProtocol = module.exports.hasFeeModels = module.exports.addressTypeOptions = module.exports.OriginatorAddressType = module.exports.UserAccessStatusType = module.exports.allCountries = module.exports.SE = module.exports.NO = module.exports.LT = module.exports.FI = module.exports.EE = module.exports.DK = module.exports.TELIA_NO = module.exports.UserType = module.exports.isWithId = module.exports.isID = void 0;
function $f63b8523577fac3e$var$isID(id) {
    return !!id && typeof id === "string";
}
module.exports.isID = $f63b8523577fac3e$var$isID;
function $f63b8523577fac3e$var$isWithId(a) {
    return !!a && typeof a === "object" && $f63b8523577fac3e$var$isID(a.id);
}
module.exports.isWithId = $f63b8523577fac3e$var$isWithId;
var $f63b8523577fac3e$var$UserType;
(function(UserType) {
    UserType["TELIA"] = "TELIA";
    UserType["CUSTOMER"] = "CUSTOMER";
})($f63b8523577fac3e$var$UserType = module.exports.UserType || (module.exports.UserType = {}));
module.exports.TELIA_NO = "TELIA_NO";
module.exports.DK = {
    id: "DK",
    countryCode: "45",
    name: "Denmark"
};
module.exports.EE = {
    id: "EE",
    countryCode: "372",
    name: "Estonia"
};
module.exports.FI = {
    id: "FI",
    countryCode: "358",
    name: "Finland"
};
module.exports.LT = {
    id: "LT",
    countryCode: "370",
    name: "Lithuania"
};
module.exports.NO = {
    id: "NO",
    countryCode: "47",
    name: "Norway"
};
module.exports.SE = {
    id: "SE",
    countryCode: "46",
    name: "Sweden"
};
module.exports.allCountries = {
    DK: module.exports.DK,
    EE: module.exports.EE,
    FI: module.exports.FI,
    LT: module.exports.LT,
    NO: module.exports.NO,
    SE: module.exports.SE
};
var $f63b8523577fac3e$var$UserAccessStatusType;
(function(UserAccessStatusType) {
    UserAccessStatusType["APPLYING"] = "APPLYING";
    UserAccessStatusType["PENDING"] = "PENDING";
    UserAccessStatusType["GRANTED"] = "GRANTED";
    UserAccessStatusType["REJECTED"] = "REJECTED";
})($f63b8523577fac3e$var$UserAccessStatusType = module.exports.UserAccessStatusType || (module.exports.UserAccessStatusType = {}));
var $f63b8523577fac3e$var$OriginatorAddressType;
(function(OriginatorAddressType) {
    OriginatorAddressType["ALL"] = "ALL";
    OriginatorAddressType["ACCESS_NUMBER_ON_PRODUCT"] = "ACCESS_NUMBER_ON_PRODUCT";
    OriginatorAddressType["ANY_ACCESS_NUMBER"] = "ANY_ACCESS_NUMBER";
    OriginatorAddressType["ANY_ALPHANUMERIC"] = "ANY_ALPHANUMERIC";
    OriginatorAddressType["ANY_NUMBERS"] = "ANY_NUMBERS";
    OriginatorAddressType["ANY_MO_LONG_NUMBER"] = "ANY_MO_LONG_NUMBER";
    OriginatorAddressType["WHITELISTED_SENDER_IDS"] = "WHITELISTED_SENDER_IDS";
})($f63b8523577fac3e$var$OriginatorAddressType = module.exports.OriginatorAddressType || (module.exports.OriginatorAddressType = {}));
module.exports.addressTypeOptions = [
    {
        id: $f63b8523577fac3e$var$OriginatorAddressType.ALL,
        name: "All",
        description: "The SMS sender may be overwritten with anything"
    },
    {
        id: $f63b8523577fac3e$var$OriginatorAddressType.ACCESS_NUMBER_ON_PRODUCT,
        name: "Access Number on Product",
        description: "The SMS sender may only be the product's short number"
    },
    {
        id: $f63b8523577fac3e$var$OriginatorAddressType.ANY_ALPHANUMERIC,
        name: "Any Alphanumeric",
        description: "The SMS sender may be overwritten by an alphanumeric text"
    },
    {
        id: $f63b8523577fac3e$var$OriginatorAddressType.ANY_NUMBERS,
        name: "Any Number",
        description: "The SMS sender may be overwritten by any number"
    },
    {
        id: $f63b8523577fac3e$var$OriginatorAddressType.WHITELISTED_SENDER_IDS,
        name: "Whitelisted Sender IDs",
        description: "The SMS sender may be overwritten by a whitelisted sender ID that allows this access number as a sender"
    },
    {
        id: $f63b8523577fac3e$var$OriginatorAddressType.ANY_ACCESS_NUMBER,
        name: "Any Access Number",
        description: "The SMS sender may be overwritten by any provisioned access number"
    },
    {
        id: $f63b8523577fac3e$var$OriginatorAddressType.ANY_MO_LONG_NUMBER,
        name: "Any MO Long Number",
        description: "The SMS sender may be overwritten by any MO long number"
    }
];
function $f63b8523577fac3e$var$hasFeeModels(obj) {
    return !!(obj === null || obj === void 0 ? void 0 : obj.feeModels);
}
module.exports.hasFeeModels = $f63b8523577fac3e$var$hasFeeModels;
var $f63b8523577fac3e$var$EndpointProtocol;
(function(EndpointProtocol) {
    EndpointProtocol["SOAP"] = "SOAP";
    EndpointProtocol["REST"] = "REST";
    EndpointProtocol["REST_V2"] = "REST_V2";
    EndpointProtocol["SMPP"] = "SMPP";
})($f63b8523577fac3e$var$EndpointProtocol = module.exports.EndpointProtocol || (module.exports.EndpointProtocol = {}));
module.exports.endpointProtocolOptions = [
    {
        id: $f63b8523577fac3e$var$EndpointProtocol.SOAP,
        name: "SOAP"
    },
    {
        id: $f63b8523577fac3e$var$EndpointProtocol.REST,
        name: "REST"
    },
    {
        id: $f63b8523577fac3e$var$EndpointProtocol.REST_V2,
        name: "REST v2"
    },
    {
        id: $f63b8523577fac3e$var$EndpointProtocol.SMPP,
        name: "SMPP"
    }
];
var $f63b8523577fac3e$var$DefaultCharset;
(function(DefaultCharset) {
    DefaultCharset["GSM8"] = "GSM8";
    DefaultCharset["GSM7"] = "GSM7";
    DefaultCharset["ISO_8859_1"] = "ISO_8859_1";
    DefaultCharset["ISO_8859_15"] = "ISO_8859_15";
})($f63b8523577fac3e$var$DefaultCharset = module.exports.DefaultCharset || (module.exports.DefaultCharset = {}));
var $f63b8523577fac3e$var$GroupPeriod;
(function(GroupPeriod) {
    GroupPeriod["DAY"] = "DAY";
    GroupPeriod["WEEK"] = "WEEK";
    GroupPeriod["MONTH"] = "MONTH";
    GroupPeriod["QUARTER"] = "QUARTER";
})($f63b8523577fac3e$var$GroupPeriod = module.exports.GroupPeriod || (module.exports.GroupPeriod = {}));
module.exports.TRANSMITTER = "TRANSMITTER";
module.exports.RECEIVER = "RECEIVER";
module.exports.TRANSCEIVER = "TRANSCEIVER";
function $f63b8523577fac3e$var$hasName(obj) {
    return !!obj.name;
}
module.exports.hasName = $f63b8523577fac3e$var$hasName;
function $f63b8523577fac3e$var$hasMessage(obj) {
    return !!obj.message;
}
module.exports.hasMessage = $f63b8523577fac3e$var$hasMessage;
var $f63b8523577fac3e$var$TrafficFeeType;
(function(TrafficFeeType) {
    TrafficFeeType["HOME"] = "HOME";
    TrafficFeeType["DOMESTIC"] = "DOMESTIC";
    TrafficFeeType["FOREIGN"] = "FOREIGN";
})($f63b8523577fac3e$var$TrafficFeeType = module.exports.TrafficFeeType || (module.exports.TrafficFeeType = {}));
var $f63b8523577fac3e$var$ResolutionId;
(function(ResolutionId) {
    ResolutionId["Delivered"] = "DELIVERED";
    ResolutionId["Expired"] = "EXPIRED";
    ResolutionId["Rejected"] = "REJECTED";
})($f63b8523577fac3e$var$ResolutionId = module.exports.ResolutionId || (module.exports.ResolutionId = {}));
module.exports.resolutions = [
    {
        id: $f63b8523577fac3e$var$ResolutionId.Delivered,
        name: "Delivered"
    },
    {
        id: $f63b8523577fac3e$var$ResolutionId.Rejected,
        name: "Rejected"
    },
    {
        id: $f63b8523577fac3e$var$ResolutionId.Expired,
        name: "Expired"
    }
];
var $f63b8523577fac3e$var$MfaConfig;
(function(MfaConfig) {
    MfaConfig["ON"] = "ON";
    MfaConfig["OPTIONAL"] = "OPTIONAL";
    MfaConfig["OFF"] = "OFF";
})($f63b8523577fac3e$var$MfaConfig = module.exports.MfaConfig || (module.exports.MfaConfig = {}));

});

parcelRegister("g6Bzp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getIsProtocolCredentialsRequired = module.exports.cloneObjectDeepness = module.exports.cloneObjectWithoutNullProperties = module.exports.objectProperty = void 0;

var $l8GLF = parcelRequire("l8GLF");
String.prototype.isEmpty = function() {
    return !this.length;
};
String.prototype.capitalize = function() {
    return this[0] !== undefined ? this[0].toUpperCase() + this.slice(1) : this;
};
String.prototype.equalsIgnoreCase = function(other) {
    return !!other && other.toUpperCase && this.toUpperCase() === other.toUpperCase();
};
String.prototype.before = function(search) {
    const index = this.indexOf(search);
    return index < 0 ? this : this.substring(0, index);
};
Array.prototype.isEmpty = function() {
    return !this.length;
};
Array.prototype.includes = function(arg) {
    return this.indexOf(arg) > -1;
};
Array.prototype.clone = function() {
    return this.slice();
};
Array.prototype.removeIndex = function(index) {
    this.splice(index, 1);
    return this;
};
Array.prototype.remove = function(item) {
    const i = this.indexOf(item);
    if (i !== -1) this.removeIndex(i);
    return this;
};
Array.prototype.cloneExcluding = function(...items) {
    const clone = this.clone();
    items.forEach((item)=>clone.remove(item));
    return clone;
};
Array.prototype.cloneIncluding = function(...items) {
    const clone = this.clone();
    items.forEach((item)=>clone.includes(item) || clone.push(item));
    return clone;
};
Array.prototype.cloneAfter = function(item) {
    const i = this.indexOf(item);
    return i === -1 ? [] : this.clone().splice(i + 1, this.length);
};
Array.prototype.cloneToggle = function(item) {
    let clone = this.slice();
    clone.includes(item) ? clone.remove(item) : clone.push(item);
    return clone;
};
Array.prototype.flatMap = function(lambda) {
    return [].concat.apply([], this.map(lambda));
};
Array.prototype.head = function() {
    return this[0];
};
Array.range = (start, end)=>Array.from({
        length: end - start + 1
    }, (v, k)=>k + start);
function $bb9a597fd59c2bb6$var$objectProperty(obj, key) {
    return obj[key];
}
module.exports.objectProperty = $bb9a597fd59c2bb6$var$objectProperty;
function $bb9a597fd59c2bb6$var$cloneObjectWithoutNullProperties(obj) {
    if (obj === null || obj === undefined) return {};
    const keysOfObject = Object.keys(obj);
    let clone = keysOfObject.reduce((clone, key)=>{
        const prop = $bb9a597fd59c2bb6$var$objectProperty(obj, key);
        if (prop !== null && prop !== undefined) clone[key] = obj[key];
        return clone;
    }, {});
    return clone;
}
module.exports.cloneObjectWithoutNullProperties = $bb9a597fd59c2bb6$var$cloneObjectWithoutNullProperties;
function $bb9a597fd59c2bb6$var$cloneObjectDeepness(obj, deepness) {
    if (obj === null || obj === undefined || typeof obj === "string" || typeof obj === "number") return obj;
    if (obj instanceof Function) return "Function";
    if (Array.isArray(obj)) return "Array";
    //  last recursion deepness
    if (deepness === 0) {
        if (obj instanceof Error) return "Error: " + obj.message;
        return "Object";
    }
    let clone = Object.keys(obj).reduce((clone, key)=>{
        clone[key] = $bb9a597fd59c2bb6$var$cloneObjectDeepness(obj[key], deepness && deepness - 1);
        return clone;
    }, {});
    return clone;
}
module.exports.cloneObjectDeepness = $bb9a597fd59c2bb6$var$cloneObjectDeepness;
function $bb9a597fd59c2bb6$var$getIsProtocolCredentialsRequired(protocol) {
    return !(protocol === $l8GLF.EndpointProtocol.SMPP || !protocol);
}
module.exports.getIsProtocolCredentialsRequired = $bb9a597fd59c2bb6$var$getIsProtocolCredentialsRequired;

});


parcelRegister("2Ef1X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PRE_PROD = module.exports.PROD = module.exports.STAGE = module.exports.LOCALHOST = void 0;
module.exports.LOCALHOST = "localhost";
module.exports.STAGE = "stage";
module.exports.PROD = "prod";
module.exports.PRE_PROD = "pre-prod";

});

parcelRegister("01pTR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEventTypeName = module.exports.mtStatusEventTypes = module.exports.messageEventTypes = module.exports.eventTypes = void 0;
module.exports.eventTypes = [
    {
        id: "BULK_SMS_SENT",
        name: "MT Sent"
    },
    {
        id: "BULK_SMS_DELIVERED",
        name: "MT Delivered Status"
    },
    {
        id: "BULK_SMS_EXPIRED",
        name: "MT Expired Status"
    },
    {
        id: "BULK_SMS_REJECTED",
        name: "MT Rejected Status"
    },
    {
        id: "BULK_SMS_RECEIVED",
        name: "MO Received"
    },
    {
        id: "MO_LONG_NUMBER_SMS_RECEIVED",
        name: "MO Long Nr. Received"
    }
];
module.exports.messageEventTypes = [
    {
        id: "BULK_SMS_SENT",
        name: "MT Sent"
    },
    {
        id: "BULK_SMS_RECEIVED",
        name: "MO Received"
    },
    {
        id: "MO_LONG_NUMBER_SMS_RECEIVED",
        name: "MO Long Nr. Received"
    }
];
module.exports.mtStatusEventTypes = [
    {
        id: "BULK_SMS_DELIVERED",
        name: "MT Delivered Status"
    },
    {
        id: "BULK_SMS_EXPIRED",
        name: "MT Expired Status"
    },
    {
        id: "BULK_SMS_REJECTED",
        name: "MT Rejected Status"
    }
];
const $00442f4fb0658849$var$getEventTypeName = (id)=>{
    var _a;
    return ((_a = module.exports.eventTypes.find((event)=>event.id === id)) === null || _a === void 0 ? void 0 : _a.name) || id || "Invalid event";
};
module.exports.getEventTypeName = $00442f4fb0658849$var$getEventTypeName;

});

parcelRegister("4hQuU", function(module, exports) {
"use strict";
var $31f178e3e8728635$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $31f178e3e8728635$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $31f178e3e8728635$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $31f178e3e8728635$var$__createBinding(result, mod, k);
    }
    $31f178e3e8728635$var$__setModuleDefault(result, mod);
    return result;
};
var $31f178e3e8728635$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.contractDisplayName = module.exports.possessiveForm = module.exports.hasDecimals = module.exports.currency = module.exports.durationCompact = module.exports.duration = module.exports.integer = module.exports.decimal = module.exports.yearMonth = module.exports.monthName = module.exports.month = module.exports.monthMm = module.exports.dateTimeMs = module.exports.dateTime = module.exports.date = void 0;

const $31f178e3e8728635$var$dateformat_1 = $31f178e3e8728635$var$__importStar((parcelRequire("4QBiq")));

const $31f178e3e8728635$var$moment_1 = $31f178e3e8728635$var$__importDefault((parcelRequire("c30H9")));

const $31f178e3e8728635$var$moment_duration_format_1 = $31f178e3e8728635$var$__importDefault((parcelRequire("ksWM4")));

const $31f178e3e8728635$var$numeral_1 = $31f178e3e8728635$var$__importDefault((parcelRequire("87bf0")));

var $4119J = parcelRequire("4119J");
// @ts-ignore
(0, $31f178e3e8728635$var$moment_duration_format_1.default)($31f178e3e8728635$var$moment_1.default); // configure the duration formatter plugin
const $31f178e3e8728635$var$DATE_FORMAT = "yyyy-mm-dd";
const $31f178e3e8728635$var$DATE_TIME_FORMAT = "yyyy-mm-dd HH:MM:ss";
const $31f178e3e8728635$var$DATE_TIME_MS_FORMAT = "yyyy-mm-dd HH:MM:ss.l";
const $31f178e3e8728635$var$dateFormat = (date, format, useUTC)=>{
    try {
        if (!date) throw new Error("Empty date");
        return (0, $31f178e3e8728635$var$dateformat_1.default)(date, format, useUTC);
    } catch (e) {
        return "Invalid date";
    }
};
const $31f178e3e8728635$var$date = (date)=>$31f178e3e8728635$var$dateFormat(date, $31f178e3e8728635$var$DATE_FORMAT);
module.exports.date = $31f178e3e8728635$var$date;
const $31f178e3e8728635$var$dateTime = (date, useUTC)=>$31f178e3e8728635$var$dateFormat(date, $31f178e3e8728635$var$DATE_TIME_FORMAT, useUTC);
module.exports.dateTime = $31f178e3e8728635$var$dateTime;
const $31f178e3e8728635$var$dateTimeMs = (date, useUTC)=>$31f178e3e8728635$var$dateFormat(date, $31f178e3e8728635$var$DATE_TIME_MS_FORMAT, useUTC);
module.exports.dateTimeMs = $31f178e3e8728635$var$dateTimeMs;
const $31f178e3e8728635$var$monthMm = (date)=>(0, $31f178e3e8728635$var$dateformat_1.default)(date, "mm");
module.exports.monthMm = $31f178e3e8728635$var$monthMm;
const $31f178e3e8728635$var$month = (date)=>(0, $31f178e3e8728635$var$dateformat_1.default)(date, "mmmm");
module.exports.month = $31f178e3e8728635$var$month;
const $31f178e3e8728635$var$monthName = (mm)=>$31f178e3e8728635$var$dateformat_1.i18n.monthNames[Number(mm) - 1] || "Invalid Month: " + mm;
module.exports.monthName = $31f178e3e8728635$var$monthName;
const $31f178e3e8728635$var$yearMonth = (yyyymm)=>(0, module.exports.monthName)(yyyymm.toString().substring(4, 6)) + " " + yyyymm.toString().substring(0, 4);
module.exports.yearMonth = $31f178e3e8728635$var$yearMonth;
const $31f178e3e8728635$var$decimal = (number, hasTrailingZeros = true)=>{
    if (number !== undefined && (hasTrailingZeros || (0, module.exports.hasDecimals)(number))) return (0, $31f178e3e8728635$var$numeral_1.default)(number).format("0,0.00").replace(/,/g, " ").replace(".", ",");
    else return (0, module.exports.integer)(number);
};
module.exports.decimal = $31f178e3e8728635$var$decimal;
const $31f178e3e8728635$var$integer = (number)=>number === undefined ? "" : (0, $31f178e3e8728635$var$numeral_1.default)(number).format("0,0").replace(/,/g, " ");
module.exports.integer = $31f178e3e8728635$var$integer;
const $31f178e3e8728635$var$duration = (duration)=>$31f178e3e8728635$var$isString(duration) && !(0, $4119J.isValidDuration)(duration) ? "Invalid duration" : $31f178e3e8728635$var$moment_1.default.duration(duration).format("y [y] w [w] d [d] h [h] m [m] s [s] S [ms]", {
        trim: "both"
    });
module.exports.duration = $31f178e3e8728635$var$duration;
const $31f178e3e8728635$var$durationCompact = (value, maxUnits = 2)=>{
    const fullDuration = (0, module.exports.duration)(value);
    const splitDuration = fullDuration.split(" ");
    const maxSpaces = maxUnits * 2 - 1;
    return fullDuration === "Invalid duration" ? "Invalid" : splitDuration.length > maxSpaces + 1 ? splitDuration.filter((_, i)=>i <= maxSpaces).join(" ").concat("...") : fullDuration;
};
module.exports.durationCompact = $31f178e3e8728635$var$durationCompact;
const $31f178e3e8728635$var$integerWithDash = (number, hasTrailingDash)=>hasTrailingDash ? (0, module.exports.integer)(number) + ",-" : (0, module.exports.integer)(number);
const $31f178e3e8728635$var$currency = (number, symbol = "\u20AC$\xa3", showDecimals, hasTrailingDash)=>{
    const value = (showDecimals !== undefined ? showDecimals : (0, module.exports.hasDecimals)(number)) && (!hasTrailingDash || (0, module.exports.hasDecimals)(number)) ? (0, module.exports.decimal)(number) : $31f178e3e8728635$var$integerWithDash(number, hasTrailingDash);
    return `${symbol} ${value}`;
};
module.exports.currency = $31f178e3e8728635$var$currency;
const $31f178e3e8728635$var$hasDecimals = (number)=>number !== undefined && number % 1 !== 0;
module.exports.hasDecimals = $31f178e3e8728635$var$hasDecimals;
const $31f178e3e8728635$var$possessiveForm = (str)=>{
    return str && ((str === null || str === void 0 ? void 0 : str.slice(-1).toLowerCase()) === "s" ? str + "'" : str + "'s");
};
module.exports.possessiveForm = $31f178e3e8728635$var$possessiveForm;
const $31f178e3e8728635$var$format = {
    date: module.exports.date,
    dateTime: module.exports.dateTime,
    dateTimeMs: module.exports.dateTimeMs,
    month: module.exports.month,
    monthMm: module.exports.monthMm,
    monthName: module.exports.monthName,
    yearMonth: module.exports.yearMonth,
    decimal: module.exports.decimal,
    integer: module.exports.integer,
    duration: module.exports.duration,
    durationCompact: module.exports.durationCompact,
    hasDecimals: module.exports.hasDecimals,
    currency: module.exports.currency,
    possessiveForm: module.exports.possessiveForm
};
module.exports.default = $31f178e3e8728635$var$format;
const $31f178e3e8728635$var$contractDisplayName = (c)=>`${c.id} ${c.name ? `- ${c.name}` : ""}`;
module.exports.contractDisplayName = $31f178e3e8728635$var$contractDisplayName;
function $31f178e3e8728635$var$isString(value) {
    return typeof value === "string" || value instanceof String;
}

});
parcelRegister("ksWM4", function(module, exports) {

/*! Moment Duration Format v2.2.2
 *  https://github.com/jsmreese/moment-duration-format
 *  Date: 2018-02-16
 *
 *  Duration format plugin function for the Moment.js library
 *  http://momentjs.com/
 *
 *  Copyright 2018 John Madhavan-Reese
 *  Released under the MIT license
 */ (function(root, factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "moment"
    ], factory);
    else // Node. Does not work with strict CommonJS, but only CommonJS-like
    // enviroments that support module.exports, like Node.
    try {
        module.exports = factory((parcelRequire("c30H9")));
    } catch (e) {
        // If moment is not available, leave the setup up to the user.
        // Like when using moment-timezone or similar moment-based package.
        module.exports = factory;
    }
    if (root) // Globals.
    root.momentDurationFormatSetup = root.moment ? factory(root.moment) : factory;
})(module.exports, function(moment) {
    // `Number#tolocaleString` is tested on plugin initialization.
    // If the feature test passes, `toLocaleStringWorks` will be set to `true` and the
    // native function will be used to generate formatted output. If the feature
    // test fails, the fallback format function internal to this plugin will be
    // used.
    var toLocaleStringWorks = false;
    // `Number#toLocaleString` rounds incorrectly for select numbers in Microsoft
    // environments (Edge, IE11, Windows Phone) and possibly other environments.
    // If the rounding test fails and `toLocaleString` will be used for formatting,
    // the plugin will "pre-round" number values using the fallback number format
    // function before passing them to `toLocaleString` for final formatting.
    var toLocaleStringRoundingWorks = false;
    // `Intl.NumberFormat#format` is tested on plugin initialization.
    // If the feature test passes, `intlNumberFormatRoundingWorks` will be set to
    // `true` and the native function will be used to generate formatted output.
    // If the feature test fails, either `Number#tolocaleString` (if
    // `toLocaleStringWorks` is `true`), or the fallback format function internal
    //  to this plugin will be used.
    var intlNumberFormatWorks = false;
    // `Intl.NumberFormat#format` rounds incorrectly for select numbers in Microsoft
    // environments (Edge, IE11, Windows Phone) and possibly other environments.
    // If the rounding test fails and `Intl.NumberFormat#format` will be used for
    // formatting, the plugin will "pre-round" number values using the fallback number
    // format function before passing them to `Intl.NumberFormat#format` for final
    // formatting.
    var intlNumberFormatRoundingWorks = false;
    // Token type names in order of descending magnitude.
    var types = "escape years months weeks days hours minutes seconds milliseconds general".split(" ");
    var bubbles = [
        {
            type: "seconds",
            targets: [
                {
                    type: "minutes",
                    value: 60
                },
                {
                    type: "hours",
                    value: 3600
                },
                {
                    type: "days",
                    value: 86400
                },
                {
                    type: "weeks",
                    value: 604800
                },
                {
                    type: "months",
                    value: 2678400
                },
                {
                    type: "years",
                    value: 31536000
                }
            ]
        },
        {
            type: "minutes",
            targets: [
                {
                    type: "hours",
                    value: 60
                },
                {
                    type: "days",
                    value: 1440
                },
                {
                    type: "weeks",
                    value: 10080
                },
                {
                    type: "months",
                    value: 44640
                },
                {
                    type: "years",
                    value: 525600
                }
            ]
        },
        {
            type: "hours",
            targets: [
                {
                    type: "days",
                    value: 24
                },
                {
                    type: "weeks",
                    value: 168
                },
                {
                    type: "months",
                    value: 744
                },
                {
                    type: "years",
                    value: 8760
                }
            ]
        },
        {
            type: "days",
            targets: [
                {
                    type: "weeks",
                    value: 7
                },
                {
                    type: "months",
                    value: 31
                },
                {
                    type: "years",
                    value: 365
                }
            ]
        },
        {
            type: "months",
            targets: [
                {
                    type: "years",
                    value: 12
                }
            ]
        }
    ];
    // stringIncludes
    function stringIncludes(str, search) {
        if (search.length > str.length) return false;
        return str.indexOf(search) !== -1;
    }
    // repeatZero(qty)
    // Returns "0" repeated `qty` times.
    // `qty` must be a integer >= 0.
    function repeatZero(qty) {
        var result = "";
        while(qty){
            result += "0";
            qty -= 1;
        }
        return result;
    }
    function stringRound(digits) {
        var digitsArray = digits.split("").reverse();
        var i = 0;
        var carry = true;
        while(carry && i < digitsArray.length){
            if (i) {
                if (digitsArray[i] === "9") digitsArray[i] = "0";
                else {
                    digitsArray[i] = (parseInt(digitsArray[i], 10) + 1).toString();
                    carry = false;
                }
            } else {
                if (parseInt(digitsArray[i], 10) < 5) carry = false;
                digitsArray[i] = "0";
            }
            i += 1;
        }
        if (carry) digitsArray.push("1");
        return digitsArray.reverse().join("");
    }
    // cachedNumberFormat
    // Returns an `Intl.NumberFormat` instance for the given locale and configuration.
    // On first use of a particular configuration, the instance is cached for fast
    // repeat access.
    function cachedNumberFormat(locale, options) {
        // Create a sorted, stringified version of `options`
        // for use as part of the cache key
        var optionsString = map(keys(options).sort(), function(key) {
            return key + ":" + options[key];
        }).join(",");
        // Set our cache key
        var cacheKey = locale + "+" + optionsString;
        // If we don't have this configuration cached, configure and cache it
        if (!cachedNumberFormat.cache[cacheKey]) cachedNumberFormat.cache[cacheKey] = Intl.NumberFormat(locale, options);
        // Return the cached version of this configuration
        return cachedNumberFormat.cache[cacheKey];
    }
    cachedNumberFormat.cache = {};
    // formatNumber
    // Formats any number greater than or equal to zero using these options:
    // - userLocale
    // - useToLocaleString
    // - useGrouping
    // - grouping
    // - maximumSignificantDigits
    // - minimumIntegerDigits
    // - fractionDigits
    // - groupingSeparator
    // - decimalSeparator
    //
    // `useToLocaleString` will use `Intl.NumberFormat` or `toLocaleString` for formatting.
    // `userLocale` option is passed through to the formatting function.
    // `fractionDigits` is passed through to `maximumFractionDigits` and `minimumFractionDigits`
    // Using `maximumSignificantDigits` will override `minimumIntegerDigits` and `fractionDigits`.
    function formatNumber(number, options, userLocale) {
        var useToLocaleString = options.useToLocaleString;
        var useGrouping = options.useGrouping;
        var grouping = useGrouping && options.grouping.slice();
        var maximumSignificantDigits = options.maximumSignificantDigits;
        var minimumIntegerDigits = options.minimumIntegerDigits || 1;
        var fractionDigits = options.fractionDigits || 0;
        var groupingSeparator = options.groupingSeparator;
        var decimalSeparator = options.decimalSeparator;
        if (useToLocaleString && userLocale) {
            var localeStringOptions = {
                minimumIntegerDigits: minimumIntegerDigits,
                useGrouping: useGrouping
            };
            if (fractionDigits) {
                localeStringOptions.maximumFractionDigits = fractionDigits;
                localeStringOptions.minimumFractionDigits = fractionDigits;
            }
            // toLocaleString output is "0.0" instead of "0" for HTC browsers
            // when maximumSignificantDigits is set. See #96.
            if (maximumSignificantDigits && number > 0) localeStringOptions.maximumSignificantDigits = maximumSignificantDigits;
            if (intlNumberFormatWorks) {
                if (!intlNumberFormatRoundingWorks) {
                    var roundingOptions = extend({}, options);
                    roundingOptions.useGrouping = false;
                    roundingOptions.decimalSeparator = ".";
                    number = parseFloat(formatNumber(number, roundingOptions), 10);
                }
                return cachedNumberFormat(userLocale, localeStringOptions).format(number);
            } else {
                if (!toLocaleStringRoundingWorks) {
                    var roundingOptions = extend({}, options);
                    roundingOptions.useGrouping = false;
                    roundingOptions.decimalSeparator = ".";
                    number = parseFloat(formatNumber(number, roundingOptions), 10);
                }
                return number.toLocaleString(userLocale, localeStringOptions);
            }
        }
        var numberString;
        // Add 1 to digit output length for floating point errors workaround. See below.
        if (maximumSignificantDigits) numberString = number.toPrecision(maximumSignificantDigits + 1);
        else numberString = number.toFixed(fractionDigits + 1);
        var integerString;
        var fractionString;
        var exponentString;
        var temp = numberString.split("e");
        exponentString = temp[1] || "";
        temp = temp[0].split(".");
        fractionString = temp[1] || "";
        integerString = temp[0] || "";
        // Workaround for floating point errors in `toFixed` and `toPrecision`.
        // (3.55).toFixed(1); --> "3.5"
        // (123.55 - 120).toPrecision(2); --> "3.5"
        // (123.55 - 120); --> 3.549999999999997
        // (123.55 - 120).toFixed(2); --> "3.55"
        // Round by examing the string output of the next digit.
        // *************** Implement String Rounding here ***********************
        // Check integerString + fractionString length of toPrecision before rounding.
        // Check length of fractionString from toFixed output before rounding.
        var integerLength = integerString.length;
        var fractionLength = fractionString.length;
        var digitCount = integerLength + fractionLength;
        var digits = integerString + fractionString;
        if (maximumSignificantDigits && digitCount === maximumSignificantDigits + 1 || !maximumSignificantDigits && fractionLength === fractionDigits + 1) {
            // Round digits.
            digits = stringRound(digits);
            if (digits.length === digitCount + 1) integerLength = integerLength + 1;
            // Discard final fractionDigit.
            if (fractionLength) digits = digits.slice(0, -1);
            // Separate integer and fraction.
            integerString = digits.slice(0, integerLength);
            fractionString = digits.slice(integerLength);
        }
        // Trim trailing zeroes from fractionString because toPrecision outputs
        // precision, not significant digits.
        if (maximumSignificantDigits) fractionString = fractionString.replace(/0*$/, "");
        // Handle exponent.
        var exponent = parseInt(exponentString, 10);
        if (exponent > 0) {
            if (fractionString.length <= exponent) {
                fractionString = fractionString + repeatZero(exponent - fractionString.length);
                integerString = integerString + fractionString;
                fractionString = "";
            } else {
                integerString = integerString + fractionString.slice(0, exponent);
                fractionString = fractionString.slice(exponent);
            }
        } else if (exponent < 0) {
            fractionString = repeatZero(Math.abs(exponent) - integerString.length) + integerString + fractionString;
            integerString = "0";
        }
        if (!maximumSignificantDigits) {
            // Trim or pad fraction when not using maximumSignificantDigits.
            fractionString = fractionString.slice(0, fractionDigits);
            if (fractionString.length < fractionDigits) fractionString = fractionString + repeatZero(fractionDigits - fractionString.length);
            // Pad integer when using minimumIntegerDigits
            // and not using maximumSignificantDigits.
            if (integerString.length < minimumIntegerDigits) integerString = repeatZero(minimumIntegerDigits - integerString.length) + integerString;
        }
        var formattedString = "";
        // Handle grouping.
        if (useGrouping) {
            temp = integerString;
            var group;
            while(temp.length){
                if (grouping.length) group = grouping.shift();
                if (formattedString) formattedString = groupingSeparator + formattedString;
                formattedString = temp.slice(-group) + formattedString;
                temp = temp.slice(0, -group);
            }
        } else formattedString = integerString;
        // Add decimalSeparator and fraction.
        if (fractionString) formattedString = formattedString + decimalSeparator + fractionString;
        return formattedString;
    }
    // durationLabelCompare
    function durationLabelCompare(a, b) {
        if (a.label.length > b.label.length) return -1;
        if (a.label.length < b.label.length) return 1;
        // a must be equal to b
        return 0;
    }
    // durationGetLabels
    function durationGetLabels(token, localeData) {
        var labels = [];
        each(keys(localeData), function(localeDataKey) {
            if (localeDataKey.slice(0, 15) !== "_durationLabels") return;
            var labelType = localeDataKey.slice(15).toLowerCase();
            each(keys(localeData[localeDataKey]), function(labelKey) {
                if (labelKey.slice(0, 1) === token) labels.push({
                    type: labelType,
                    key: labelKey,
                    label: localeData[localeDataKey][labelKey]
                });
            });
        });
        return labels;
    }
    // durationPluralKey
    function durationPluralKey(token, integerValue, decimalValue) {
        // Singular for a value of `1`, but not for `1.0`.
        if (integerValue === 1 && decimalValue === null) return token;
        return token + token;
    }
    var engLocale = {
        durationLabelsStandard: {
            S: "millisecond",
            SS: "milliseconds",
            s: "second",
            ss: "seconds",
            m: "minute",
            mm: "minutes",
            h: "hour",
            hh: "hours",
            d: "day",
            dd: "days",
            w: "week",
            ww: "weeks",
            M: "month",
            MM: "months",
            y: "year",
            yy: "years"
        },
        durationLabelsShort: {
            S: "msec",
            SS: "msecs",
            s: "sec",
            ss: "secs",
            m: "min",
            mm: "mins",
            h: "hr",
            hh: "hrs",
            d: "dy",
            dd: "dys",
            w: "wk",
            ww: "wks",
            M: "mo",
            MM: "mos",
            y: "yr",
            yy: "yrs"
        },
        durationTimeTemplates: {
            HMS: "h:mm:ss",
            HM: "h:mm",
            MS: "m:ss"
        },
        durationLabelTypes: [
            {
                type: "standard",
                string: "__"
            },
            {
                type: "short",
                string: "_"
            }
        ],
        durationPluralKey: durationPluralKey
    };
    // isArray
    function isArray(array) {
        return Object.prototype.toString.call(array) === "[object Array]";
    }
    // isObject
    function isObject(obj) {
        return Object.prototype.toString.call(obj) === "[object Object]";
    }
    // findLast
    function findLast(array, callback) {
        var index = array.length;
        while(index -= 1){
            if (callback(array[index])) return array[index];
        }
    }
    // find
    function find(array, callback) {
        var index = 0;
        var max = array && array.length || 0;
        var match;
        if (typeof callback !== "function") {
            match = callback;
            callback = function(item) {
                return item === match;
            };
        }
        while(index < max){
            if (callback(array[index])) return array[index];
            index += 1;
        }
    }
    // each
    function each(array, callback) {
        var index = 0, max = array.length;
        if (!array || !max) return;
        while(index < max){
            if (callback(array[index], index) === false) return;
            index += 1;
        }
    }
    // map
    function map(array, callback) {
        var index = 0, max = array.length, ret = [];
        if (!array || !max) return ret;
        while(index < max){
            ret[index] = callback(array[index], index);
            index += 1;
        }
        return ret;
    }
    // pluck
    function pluck(array, prop) {
        return map(array, function(item) {
            return item[prop];
        });
    }
    // compact
    function compact(array) {
        var ret = [];
        each(array, function(item) {
            if (item) ret.push(item);
        });
        return ret;
    }
    // unique
    function unique(array) {
        var ret = [];
        each(array, function(_a) {
            if (!find(ret, _a)) ret.push(_a);
        });
        return ret;
    }
    // intersection
    function intersection(a, b) {
        var ret = [];
        each(a, function(_a) {
            each(b, function(_b) {
                if (_a === _b) ret.push(_a);
            });
        });
        return unique(ret);
    }
    // rest
    function rest(array, callback) {
        var ret = [];
        each(array, function(item, index) {
            if (!callback(item)) {
                ret = array.slice(index);
                return false;
            }
        });
        return ret;
    }
    // initial
    function initial(array, callback) {
        var reversed = array.slice().reverse();
        return rest(reversed, callback).reverse();
    }
    // extend
    function extend(a, b) {
        for(var key in b)if (b.hasOwnProperty(key)) a[key] = b[key];
        return a;
    }
    // keys
    function keys(a) {
        var ret = [];
        for(var key in a)if (a.hasOwnProperty(key)) ret.push(key);
        return ret;
    }
    // any
    function any(array, callback) {
        var index = 0, max = array.length;
        if (!array || !max) return false;
        while(index < max){
            if (callback(array[index], index) === true) return true;
            index += 1;
        }
        return false;
    }
    // flatten
    function flatten(array) {
        var ret = [];
        each(array, function(child) {
            ret = ret.concat(child);
        });
        return ret;
    }
    function toLocaleStringSupportsLocales() {
        var number = 0;
        try {
            number.toLocaleString("i");
        } catch (e) {
            return e.name === "RangeError";
        }
        return false;
    }
    function featureTestFormatterRounding(formatter) {
        return formatter(3.55, "en", {
            useGrouping: false,
            minimumIntegerDigits: 1,
            minimumFractionDigits: 1,
            maximumFractionDigits: 1
        }) === "3.6";
    }
    function featureTestFormatter(formatter) {
        var passed = true;
        // Test minimumIntegerDigits.
        passed = passed && formatter(1, "en", {
            minimumIntegerDigits: 1
        }) === "1";
        passed = passed && formatter(1, "en", {
            minimumIntegerDigits: 2
        }) === "01";
        passed = passed && formatter(1, "en", {
            minimumIntegerDigits: 3
        }) === "001";
        if (!passed) return false;
        // Test maximumFractionDigits and minimumFractionDigits.
        passed = passed && formatter(99.99, "en", {
            maximumFractionDigits: 0,
            minimumFractionDigits: 0
        }) === "100";
        passed = passed && formatter(99.99, "en", {
            maximumFractionDigits: 1,
            minimumFractionDigits: 1
        }) === "100.0";
        passed = passed && formatter(99.99, "en", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2
        }) === "99.99";
        passed = passed && formatter(99.99, "en", {
            maximumFractionDigits: 3,
            minimumFractionDigits: 3
        }) === "99.990";
        if (!passed) return false;
        // Test maximumSignificantDigits.
        passed = passed && formatter(99.99, "en", {
            maximumSignificantDigits: 1
        }) === "100";
        passed = passed && formatter(99.99, "en", {
            maximumSignificantDigits: 2
        }) === "100";
        passed = passed && formatter(99.99, "en", {
            maximumSignificantDigits: 3
        }) === "100";
        passed = passed && formatter(99.99, "en", {
            maximumSignificantDigits: 4
        }) === "99.99";
        passed = passed && formatter(99.99, "en", {
            maximumSignificantDigits: 5
        }) === "99.99";
        if (!passed) return false;
        // Test grouping.
        passed = passed && formatter(1000, "en", {
            useGrouping: true
        }) === "1,000";
        passed = passed && formatter(1000, "en", {
            useGrouping: false
        }) === "1000";
        if (!passed) return false;
        return true;
    }
    // durationsFormat(durations [, template] [, precision] [, settings])
    function durationsFormat() {
        var args = [].slice.call(arguments);
        var settings = {};
        var durations;
        // Parse arguments.
        each(args, function(arg, index) {
            if (!index) {
                if (!isArray(arg)) throw "Expected array as the first argument to durationsFormat.";
                durations = arg;
            }
            if (typeof arg === "string" || typeof arg === "function") {
                settings.template = arg;
                return;
            }
            if (typeof arg === "number") {
                settings.precision = arg;
                return;
            }
            if (isObject(arg)) extend(settings, arg);
        });
        if (!durations || !durations.length) return [];
        settings.returnMomentTypes = true;
        var formattedDurations = map(durations, function(dur) {
            return dur.format(settings);
        });
        // Merge token types from all durations.
        var outputTypes = intersection(types, unique(pluck(flatten(formattedDurations), "type")));
        var largest = settings.largest;
        if (largest) outputTypes = outputTypes.slice(0, largest);
        settings.returnMomentTypes = false;
        settings.outputTypes = outputTypes;
        return map(durations, function(dur) {
            return dur.format(settings);
        });
    }
    // durationFormat([template] [, precision] [, settings])
    function durationFormat() {
        var args = [].slice.call(arguments);
        var settings = extend({}, this.format.defaults);
        // Keep a shadow copy of this moment for calculating remainders.
        // Perform all calculations on positive duration value, handle negative
        // sign at the very end.
        var asMilliseconds = this.asMilliseconds();
        var asMonths = this.asMonths();
        // Treat invalid durations as having a value of 0 milliseconds.
        if (typeof this.isValid === "function" && this.isValid() === false) {
            asMilliseconds = 0;
            asMonths = 0;
        }
        var isNegative = asMilliseconds < 0;
        // Two shadow copies are needed because of the way moment.js handles
        // duration arithmetic for years/months and for weeks/days/hours/minutes/seconds.
        var remainder = moment.duration(Math.abs(asMilliseconds), "milliseconds");
        var remainderMonths = moment.duration(Math.abs(asMonths), "months");
        // Parse arguments.
        each(args, function(arg) {
            if (typeof arg === "string" || typeof arg === "function") {
                settings.template = arg;
                return;
            }
            if (typeof arg === "number") {
                settings.precision = arg;
                return;
            }
            if (isObject(arg)) extend(settings, arg);
        });
        var momentTokens = {
            years: "y",
            months: "M",
            weeks: "w",
            days: "d",
            hours: "h",
            minutes: "m",
            seconds: "s",
            milliseconds: "S"
        };
        var tokenDefs = {
            escape: /\[(.+?)\]/,
            years: /\*?[Yy]+/,
            months: /\*?M+/,
            weeks: /\*?[Ww]+/,
            days: /\*?[Dd]+/,
            hours: /\*?[Hh]+/,
            minutes: /\*?m+/,
            seconds: /\*?s+/,
            milliseconds: /\*?S+/,
            general: /.+?/
        };
        // Types array is available in the template function.
        settings.types = types;
        var typeMap = function(token) {
            return find(types, function(type) {
                return tokenDefs[type].test(token);
            });
        };
        var tokenizer = new RegExp(map(types, function(type) {
            return tokenDefs[type].source;
        }).join("|"), "g");
        // Current duration object is available in the template function.
        settings.duration = this;
        // Eval template function and cache template string.
        var template = typeof settings.template === "function" ? settings.template.apply(settings) : settings.template;
        // outputTypes and returnMomentTypes are settings to support durationsFormat().
        // outputTypes is an array of moment token types that determines
        // the tokens returned in formatted output. This option overrides
        // trim, largest, stopTrim, etc.
        var outputTypes = settings.outputTypes;
        // returnMomentTypes is a boolean that sets durationFormat to return
        // the processed momentTypes instead of formatted output.
        var returnMomentTypes = settings.returnMomentTypes;
        var largest = settings.largest;
        // Setup stopTrim array of token types.
        var stopTrim = [];
        if (!outputTypes) {
            if (isArray(settings.stopTrim)) settings.stopTrim = settings.stopTrim.join("");
            // Parse stopTrim string to create token types array.
            if (settings.stopTrim) each(settings.stopTrim.match(tokenizer), function(token) {
                var type = typeMap(token);
                if (type === "escape" || type === "general") return;
                stopTrim.push(type);
            });
        }
        // Cache moment's locale data.
        var localeData = moment.localeData();
        if (!localeData) localeData = {};
        // Fall back to this plugin's `eng` extension.
        each(keys(engLocale), function(key) {
            if (typeof engLocale[key] === "function") {
                if (!localeData[key]) localeData[key] = engLocale[key];
                return;
            }
            if (!localeData["_" + key]) localeData["_" + key] = engLocale[key];
        });
        // Replace Duration Time Template strings.
        // For locale `eng`: `_HMS_`, `_HM_`, and `_MS_`.
        each(keys(localeData._durationTimeTemplates), function(item) {
            template = template.replace("_" + item + "_", localeData._durationTimeTemplates[item]);
        });
        // Determine user's locale.
        var userLocale = settings.userLocale || moment.locale();
        var useLeftUnits = settings.useLeftUnits;
        var usePlural = settings.usePlural;
        var precision = settings.precision;
        var forceLength = settings.forceLength;
        var useGrouping = settings.useGrouping;
        var trunc = settings.trunc;
        // Use significant digits only when precision is greater than 0.
        var useSignificantDigits = settings.useSignificantDigits && precision > 0;
        var significantDigits = useSignificantDigits ? settings.precision : 0;
        var significantDigitsCache = significantDigits;
        var minValue = settings.minValue;
        var isMinValue = false;
        var maxValue = settings.maxValue;
        var isMaxValue = false;
        // formatNumber fallback options.
        var useToLocaleString = settings.useToLocaleString;
        var groupingSeparator = settings.groupingSeparator;
        var decimalSeparator = settings.decimalSeparator;
        var grouping = settings.grouping;
        useToLocaleString = useToLocaleString && (toLocaleStringWorks || intlNumberFormatWorks);
        // Trim options.
        var trim = settings.trim;
        if (isArray(trim)) trim = trim.join(" ");
        if (trim === null && (largest || maxValue || useSignificantDigits)) trim = "all";
        if (trim === null || trim === true || trim === "left" || trim === "right") trim = "large";
        if (trim === false) trim = "";
        var trimIncludes = function(item) {
            return item.test(trim);
        };
        var rLarge = /large/;
        var rSmall = /small/;
        var rBoth = /both/;
        var rMid = /mid/;
        var rAll = /^all|[^sm]all/;
        var rFinal = /final/;
        var trimLarge = largest > 0 || any([
            rLarge,
            rBoth,
            rAll
        ], trimIncludes);
        var trimSmall = any([
            rSmall,
            rBoth,
            rAll
        ], trimIncludes);
        var trimMid = any([
            rMid,
            rAll
        ], trimIncludes);
        var trimFinal = any([
            rFinal,
            rAll
        ], trimIncludes);
        // Parse format string to create raw tokens array.
        var rawTokens = map(template.match(tokenizer), function(token, index) {
            var type = typeMap(token);
            if (token.slice(0, 1) === "*") {
                token = token.slice(1);
                if (type !== "escape" && type !== "general") stopTrim.push(type);
            }
            return {
                index: index,
                length: token.length,
                text: "",
                // Replace escaped tokens with the non-escaped token text.
                token: type === "escape" ? token.replace(tokenDefs.escape, "$1") : token,
                // Ignore type on non-moment tokens.
                type: type === "escape" || type === "general" ? null : type
            };
        });
        // Associate text tokens with moment tokens.
        var currentToken = {
            index: 0,
            length: 0,
            token: "",
            text: "",
            type: null
        };
        var tokens = [];
        if (useLeftUnits) rawTokens.reverse();
        each(rawTokens, function(token) {
            if (token.type) {
                if (currentToken.type || currentToken.text) tokens.push(currentToken);
                currentToken = token;
                return;
            }
            if (useLeftUnits) currentToken.text = token.token + currentToken.text;
            else currentToken.text += token.token;
        });
        if (currentToken.type || currentToken.text) tokens.push(currentToken);
        if (useLeftUnits) tokens.reverse();
        // Find unique moment token types in the template in order of
        // descending magnitude.
        var momentTypes = intersection(types, unique(compact(pluck(tokens, "type"))));
        // Exit early if there are no moment token types.
        if (!momentTypes.length) return pluck(tokens, "text").join("");
        // Calculate values for each moment type in the template.
        // For processing the settings, values are associated with moment types.
        // Values will be assigned to tokens at the last step in order to
        // assume nothing about frequency or order of tokens in the template.
        momentTypes = map(momentTypes, function(momentType, index) {
            // Is this the least-magnitude moment token found?
            var isSmallest = index + 1 === momentTypes.length;
            // Is this the greatest-magnitude moment token found?
            var isLargest = !index;
            // Get the raw value in the current units.
            var rawValue;
            if (momentType === "years" || momentType === "months") rawValue = remainderMonths.as(momentType);
            else rawValue = remainder.as(momentType);
            var wholeValue = Math.floor(rawValue);
            var decimalValue = rawValue - wholeValue;
            var token = find(tokens, function(token) {
                return momentType === token.type;
            });
            if (isLargest && maxValue && rawValue > maxValue) isMaxValue = true;
            if (isSmallest && minValue && Math.abs(settings.duration.as(momentType)) < minValue) isMinValue = true;
            // Note the length of the largest-magnitude moment token:
            // if it is greater than one and forceLength is not set,
            // then default forceLength to `true`.
            //
            // Rationale is this: If the template is "h:mm:ss" and the
            // moment value is 5 minutes, the user-friendly output is
            // "5:00", not "05:00". We shouldn't pad the `minutes` token
            // even though it has length of two if the template is "h:mm:ss";
            //
            // If the minutes output should always include the leading zero
            // even when the hour is trimmed then set `{ forceLength: true }`
            // to output "05:00". If the template is "hh:mm:ss", the user
            // clearly wanted everything padded so we should output "05:00";
            //
            // If the user wants the full padded output, they can use
            // template "hh:mm:ss" and set `{ trim: false }` to output
            // "00:05:00".
            if (isLargest && forceLength === null && token.length > 1) forceLength = true;
            // Update remainder.
            remainder.subtract(wholeValue, momentType);
            remainderMonths.subtract(wholeValue, momentType);
            return {
                rawValue: rawValue,
                wholeValue: wholeValue,
                // Decimal value is only retained for the least-magnitude
                // moment type in the format template.
                decimalValue: isSmallest ? decimalValue : 0,
                isSmallest: isSmallest,
                isLargest: isLargest,
                type: momentType,
                // Tokens can appear multiple times in a template string,
                // but all instances must share the same length.
                tokenLength: token.length
            };
        });
        var truncMethod = trunc ? Math.floor : Math.round;
        var truncate = function(value, places) {
            var factor = Math.pow(10, places);
            return truncMethod(value * factor) / factor;
        };
        var foundFirst = false;
        var bubbled = false;
        var formatValue = function(momentType, index) {
            var formatOptions = {
                useGrouping: useGrouping,
                groupingSeparator: groupingSeparator,
                decimalSeparator: decimalSeparator,
                grouping: grouping,
                useToLocaleString: useToLocaleString
            };
            if (useSignificantDigits) {
                if (significantDigits <= 0) {
                    momentType.rawValue = 0;
                    momentType.wholeValue = 0;
                    momentType.decimalValue = 0;
                } else {
                    formatOptions.maximumSignificantDigits = significantDigits;
                    momentType.significantDigits = significantDigits;
                }
            }
            if (isMaxValue && !bubbled) {
                if (momentType.isLargest) {
                    momentType.wholeValue = maxValue;
                    momentType.decimalValue = 0;
                } else {
                    momentType.wholeValue = 0;
                    momentType.decimalValue = 0;
                }
            }
            if (isMinValue && !bubbled) {
                if (momentType.isSmallest) {
                    momentType.wholeValue = minValue;
                    momentType.decimalValue = 0;
                } else {
                    momentType.wholeValue = 0;
                    momentType.decimalValue = 0;
                }
            }
            if (momentType.isSmallest || momentType.significantDigits && momentType.significantDigits - momentType.wholeValue.toString().length <= 0) {
                // Apply precision to least significant token value.
                if (precision < 0) momentType.value = truncate(momentType.wholeValue, precision);
                else if (precision === 0) momentType.value = truncMethod(momentType.wholeValue + momentType.decimalValue);
                else if (useSignificantDigits) {
                    if (trunc) momentType.value = truncate(momentType.rawValue, significantDigits - momentType.wholeValue.toString().length);
                    else momentType.value = momentType.rawValue;
                    if (momentType.wholeValue) significantDigits -= momentType.wholeValue.toString().length;
                } else {
                    formatOptions.fractionDigits = precision;
                    if (trunc) momentType.value = momentType.wholeValue + truncate(momentType.decimalValue, precision);
                    else momentType.value = momentType.wholeValue + momentType.decimalValue;
                }
            } else if (useSignificantDigits && momentType.wholeValue) {
                // Outer Math.round required here to handle floating point errors.
                momentType.value = Math.round(truncate(momentType.wholeValue, momentType.significantDigits - momentType.wholeValue.toString().length));
                significantDigits -= momentType.wholeValue.toString().length;
            } else momentType.value = momentType.wholeValue;
            if (momentType.tokenLength > 1 && (forceLength || foundFirst)) {
                formatOptions.minimumIntegerDigits = momentType.tokenLength;
                if (bubbled && formatOptions.maximumSignificantDigits < momentType.tokenLength) delete formatOptions.maximumSignificantDigits;
            }
            if (!foundFirst && (momentType.value > 0 || trim === "" /* trim: false */  || find(stopTrim, momentType.type) || find(outputTypes, momentType.type))) foundFirst = true;
            momentType.formattedValue = formatNumber(momentType.value, formatOptions, userLocale);
            formatOptions.useGrouping = false;
            formatOptions.decimalSeparator = ".";
            momentType.formattedValueEn = formatNumber(momentType.value, formatOptions, "en");
            if (momentType.tokenLength === 2 && momentType.type === "milliseconds") momentType.formattedValueMS = formatNumber(momentType.value, {
                minimumIntegerDigits: 3,
                useGrouping: false
            }, "en").slice(0, 2);
            return momentType;
        };
        // Calculate formatted values.
        momentTypes = map(momentTypes, formatValue);
        momentTypes = compact(momentTypes);
        // Bubble rounded values.
        if (momentTypes.length > 1) {
            var findType = function(type) {
                return find(momentTypes, function(momentType) {
                    return momentType.type === type;
                });
            };
            var bubbleTypes = function(bubble) {
                var bubbleMomentType = findType(bubble.type);
                if (!bubbleMomentType) return;
                each(bubble.targets, function(target) {
                    var targetMomentType = findType(target.type);
                    if (!targetMomentType) return;
                    if (parseInt(bubbleMomentType.formattedValueEn, 10) === target.value) {
                        bubbleMomentType.rawValue = 0;
                        bubbleMomentType.wholeValue = 0;
                        bubbleMomentType.decimalValue = 0;
                        targetMomentType.rawValue += 1;
                        targetMomentType.wholeValue += 1;
                        targetMomentType.decimalValue = 0;
                        targetMomentType.formattedValueEn = targetMomentType.wholeValue.toString();
                        bubbled = true;
                    }
                });
            };
            each(bubbles, bubbleTypes);
        }
        // Recalculate formatted values.
        if (bubbled) {
            foundFirst = false;
            significantDigits = significantDigitsCache;
            momentTypes = map(momentTypes, formatValue);
            momentTypes = compact(momentTypes);
        }
        if (outputTypes && !(isMaxValue && !settings.trim)) {
            momentTypes = map(momentTypes, function(momentType) {
                if (find(outputTypes, function(outputType) {
                    return momentType.type === outputType;
                })) return momentType;
                return null;
            });
            momentTypes = compact(momentTypes);
        } else {
            // Trim Large.
            if (trimLarge) momentTypes = rest(momentTypes, function(momentType) {
                // Stop trimming on:
                // - the smallest moment type
                // - a type marked for stopTrim
                // - a type that has a whole value
                return !momentType.isSmallest && !momentType.wholeValue && !find(stopTrim, momentType.type);
            });
            // Largest.
            if (largest && momentTypes.length) momentTypes = momentTypes.slice(0, largest);
            // Trim Small.
            if (trimSmall && momentTypes.length > 1) momentTypes = initial(momentTypes, function(momentType) {
                // Stop trimming on:
                // - a type marked for stopTrim
                // - a type that has a whole value
                // - the largest momentType
                return !momentType.wholeValue && !find(stopTrim, momentType.type) && !momentType.isLargest;
            });
            // Trim Mid.
            if (trimMid) {
                momentTypes = map(momentTypes, function(momentType, index) {
                    if (index > 0 && index < momentTypes.length - 1 && !momentType.wholeValue) return null;
                    return momentType;
                });
                momentTypes = compact(momentTypes);
            }
            // Trim Final.
            if (trimFinal && momentTypes.length === 1 && !momentTypes[0].wholeValue && !(!trunc && momentTypes[0].isSmallest && momentTypes[0].rawValue < minValue)) momentTypes = [];
        }
        if (returnMomentTypes) return momentTypes;
        // Localize and pluralize unit labels.
        each(tokens, function(token) {
            var key = momentTokens[token.type];
            var momentType = find(momentTypes, function(momentType) {
                return momentType.type === token.type;
            });
            if (!key || !momentType) return;
            var values = momentType.formattedValueEn.split(".");
            values[0] = parseInt(values[0], 10);
            if (values[1]) values[1] = parseFloat("0." + values[1], 10);
            else values[1] = null;
            var pluralKey = localeData.durationPluralKey(key, values[0], values[1]);
            var labels = durationGetLabels(key, localeData);
            var autoLocalized = false;
            var pluralizedLabels = {};
            // Auto-Localized unit labels.
            each(localeData._durationLabelTypes, function(labelType) {
                var label = find(labels, function(label) {
                    return label.type === labelType.type && label.key === pluralKey;
                });
                if (label) {
                    pluralizedLabels[label.type] = label.label;
                    if (stringIncludes(token.text, labelType.string)) {
                        token.text = token.text.replace(labelType.string, label.label);
                        autoLocalized = true;
                    }
                }
            });
            // Auto-pluralized unit labels.
            if (usePlural && !autoLocalized) {
                labels.sort(durationLabelCompare);
                each(labels, function(label) {
                    if (pluralizedLabels[label.type] === label.label) {
                        if (stringIncludes(token.text, label.label)) // Stop checking this token if its label is already
                        // correctly pluralized.
                        return false;
                        // Skip this label if it is correct, but not present in
                        // the token's text.
                        return;
                    }
                    if (stringIncludes(token.text, label.label)) {
                        // Replece this token's label and stop checking.
                        token.text = token.text.replace(label.label, pluralizedLabels[label.type]);
                        return false;
                    }
                });
            }
        });
        // Build ouptut.
        tokens = map(tokens, function(token) {
            if (!token.type) return token.text;
            var momentType = find(momentTypes, function(momentType) {
                return momentType.type === token.type;
            });
            if (!momentType) return "";
            var out = "";
            if (useLeftUnits) out += token.text;
            if (isNegative && isMaxValue || !isNegative && isMinValue) {
                out += "< ";
                isMaxValue = false;
                isMinValue = false;
            }
            if (isNegative && isMinValue || !isNegative && isMaxValue) {
                out += "> ";
                isMaxValue = false;
                isMinValue = false;
            }
            if (isNegative && (momentType.value > 0 || trim === "" || find(stopTrim, momentType.type) || find(outputTypes, momentType.type))) {
                out += "-";
                isNegative = false;
            }
            if (token.type === "milliseconds" && momentType.formattedValueMS) out += momentType.formattedValueMS;
            else out += momentType.formattedValue;
            if (!useLeftUnits) out += token.text;
            return out;
        });
        // Trim leading and trailing comma, space, colon, and dot.
        return tokens.join("").replace(/(,| |:|\.)*$/, "").replace(/^(,| |:|\.)*/, "");
    }
    // defaultFormatTemplate
    function defaultFormatTemplate() {
        var dur = this.duration;
        var findType = function findType(type) {
            return dur._data[type];
        };
        var firstType = find(this.types, findType);
        var lastType = findLast(this.types, findType);
        // Default template strings for each duration dimension type.
        switch(firstType){
            case "milliseconds":
                return "S __";
            case "seconds":
            case "minutes":
                return "*_MS_";
            case "hours":
                return "_HMS_";
            case "days":
                if (firstType === lastType) return "d __";
            case "weeks":
                if (firstType === lastType) return "w __";
                if (this.trim === null) this.trim = "both";
                return "w __, d __, h __";
            case "months":
                if (firstType === lastType) return "M __";
            case "years":
                if (firstType === lastType) return "y __";
                if (this.trim === null) this.trim = "both";
                return "y __, M __, d __";
            default:
                if (this.trim === null) this.trim = "both";
                return "y __, d __, h __, m __, s __";
        }
    }
    // init
    function init(context) {
        if (!context) throw "Moment Duration Format init cannot find moment instance.";
        context.duration.format = durationsFormat;
        context.duration.fn.format = durationFormat;
        context.duration.fn.format.defaults = {
            // Many options are defaulted to `null` to distinguish between
            // 'not set' and 'set to `false`'
            // trim
            // Can be a string, a delimited list of strings, an array of strings,
            // or a boolean.
            // "large" - will trim largest-magnitude zero-value tokens until
            // finding a token with a value, a token identified as 'stopTrim', or
            // the final token of the format string.
            // "small" - will trim smallest-magnitude zero-value tokens until
            // finding a token with a value, a token identified as 'stopTrim', or
            // the final token of the format string.
            // "both" - will execute "large" trim then "small" trim.
            // "mid" - will trim any zero-value tokens that are not the first or
            // last tokens. Usually used in conjunction with "large" or "both".
            // e.g. "large mid" or "both mid".
            // "final" - will trim the final token if it is zero-value. Use this
            // option with "large" or "both" to output an empty string when
            // formatting a zero-value duration. e.g. "large final" or "both final".
            // "all" - Will trim all zero-value tokens. Shorthand for "both mid final".
            // "left" - maps to "large" to support plugin's version 1 API.
            // "right" - maps to "large" to support plugin's version 1 API.
            // `false` - template tokens are not trimmed.
            // `true` - treated as "large".
            // `null` - treated as "large".
            trim: null,
            // stopTrim
            // A moment token string, a delimited set of moment token strings,
            // or an array of moment token strings. Trimming will stop when a token
            // listed in this option is reached. A "*" character in the format
            // template string will also mark a moment token as stopTrim.
            // e.g. "d [days] *h:mm:ss" will always stop trimming at the 'hours' token.
            stopTrim: null,
            // largest
            // Set to a positive integer to output only the "n" largest-magnitude
            // moment tokens that have a value. All lesser-magnitude moment tokens
            // will be ignored. This option takes effect even if `trim` is set
            // to `false`.
            largest: null,
            // maxValue
            // Use `maxValue` to render generalized output for large duration values,
            // e.g. `"> 60 days"`. `maxValue` must be a positive integer and is
            /// applied to the greatest-magnitude moment token in the format template.
            maxValue: null,
            // minValue
            // Use `minValue` to render generalized output for small duration values,
            // e.g. `"< 5 minutes"`. `minValue` must be a positive integer and is
            // applied to the least-magnitude moment token in the format template.
            minValue: null,
            // precision
            // If a positive integer, number of decimal fraction digits to render.
            // If a negative integer, number of integer place digits to truncate to 0.
            // If `useSignificantDigits` is set to `true` and `precision` is a positive
            // integer, sets the maximum number of significant digits used in the
            // formatted output.
            precision: 0,
            // trunc
            // Default behavior rounds final token value. Set to `true` to
            // truncate final token value, which was the default behavior in
            // version 1 of this plugin.
            trunc: false,
            // forceLength
            // Force first moment token with a value to render at full length
            // even when template is trimmed and first moment token has length of 1.
            forceLength: null,
            // userLocale
            // Formatted numerical output is rendered using `toLocaleString`
            // and the locale of the user's environment. Set this option to render
            // numerical output using a different locale. Unit names are rendered
            // and detected using the locale set in moment.js, which can be different
            // from the locale of user's environment.
            userLocale: null,
            // usePlural
            // Will automatically singularize or pluralize unit names when they
            // appear in the text associated with each moment token. Standard and
            // short unit labels are singularized and pluralized, based on locale.
            // e.g. in english, "1 second" or "1 sec" would be rendered instead
            // of "1 seconds" or "1 secs". The default pluralization function
            // renders a plural label for a value with decimal precision.
            // e.g. "1.0 seconds" is never rendered as "1.0 second".
            // Label types and pluralization function are configurable in the
            // localeData extensions.
            usePlural: true,
            // useLeftUnits
            // The text to the right of each moment token in a format string
            // is treated as that token's units for the purposes of trimming,
            // singularizing, and auto-localizing.
            // e.g. "h [hours], m [minutes], s [seconds]".
            // To properly singularize or localize a format string such as
            // "[hours] h, [minutes] m, [seconds] s", where the units appear
            // to the left of each moment token, set useLeftUnits to `true`.
            // This plugin is not tested in the context of rtl text.
            useLeftUnits: false,
            // useGrouping
            // Enables locale-based digit grouping in the formatted output. See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
            useGrouping: true,
            // useSignificantDigits
            // Treat the `precision` option as the maximum significant digits
            // to be rendered. Precision must be a positive integer. Significant
            // digits extend across unit types,
            // e.g. "6 hours 37.5 minutes" represents 4 significant digits.
            // Enabling this option causes token length to be ignored. See  https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/toLocaleString
            useSignificantDigits: false,
            // template
            // The template string used to format the duration. May be a function
            // or a string. Template functions are executed with the `this` binding
            // of the settings object so that template strings may be dynamically
            // generated based on the duration object (accessible via `this.duration`)
            // or any of the other settings. Leading and trailing space, comma,
            // period, and colon characters are trimmed from the resulting string.
            template: defaultFormatTemplate,
            // useToLocaleString
            // Set this option to `false` to ignore the `toLocaleString` feature
            // test and force the use of the `formatNumber` fallback function
            // included in this plugin.
            useToLocaleString: true,
            // formatNumber fallback options.
            // When `toLocaleString` is detected and passes the feature test, the
            // following options will have no effect: `toLocaleString` will be used
            // for formatting and the grouping separator, decimal separator, and
            // integer digit grouping will be determined by the user locale.
            // groupingSeparator
            // The integer digit grouping separator used when using the fallback
            // formatNumber function.
            groupingSeparator: ",",
            // decimalSeparator
            // The decimal separator used when using the fallback formatNumber
            // function.
            decimalSeparator: ".",
            // grouping
            // The integer digit grouping used when using the fallback formatNumber
            // function. Must be an array. The default value of `[3]` gives the
            // standard 3-digit thousand/million/billion digit groupings for the
            // "en" locale. Setting this option to `[3, 2]` would generate the
            // thousand/lakh/crore digit groupings used in the "en-IN" locale.
            grouping: [
                3
            ]
        };
        context.updateLocale("en", engLocale);
    }
    // Run feature tests for `Number#toLocaleString`.
    var toLocaleStringFormatter = function(number, locale, options) {
        return number.toLocaleString(locale, options);
    };
    toLocaleStringWorks = toLocaleStringSupportsLocales() && featureTestFormatter(toLocaleStringFormatter);
    toLocaleStringRoundingWorks = toLocaleStringWorks && featureTestFormatterRounding(toLocaleStringFormatter);
    // Run feature tests for `Intl.NumberFormat#format`.
    var intlNumberFormatFormatter = function(number, locale, options) {
        if (typeof window !== "undefined" && window && window.Intl && window.Intl.NumberFormat) return window.Intl.NumberFormat(locale, options).format(number);
    };
    intlNumberFormatWorks = featureTestFormatter(intlNumberFormatFormatter);
    intlNumberFormatRoundingWorks = intlNumberFormatWorks && featureTestFormatterRounding(intlNumberFormatFormatter);
    // Initialize duration format on the global moment instance.
    init(moment);
    // Return the init function so that duration format can be
    // initialized on other moment instances.
    return init;
});

});

parcelRegister("87bf0", function(module, exports) {
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */ (function(global, factory) {
    if (typeof define === "function" && define.amd) define(factory);
    else if (0, module.exports) module.exports = factory();
    else global.numeral = factory();
})(module.exports, function() {
    /************************************
        Variables
    ************************************/ var numeral, _, VERSION = "2.0.6", formats = {}, locales = {}, defaults = {
        currentLocale: "en",
        zeroFormat: null,
        nullFormat: null,
        defaultFormat: "0,0",
        scalePercentBy100: true
    }, options = {
        currentLocale: defaults.currentLocale,
        zeroFormat: defaults.zeroFormat,
        nullFormat: defaults.nullFormat,
        defaultFormat: defaults.defaultFormat,
        scalePercentBy100: defaults.scalePercentBy100
    };
    /************************************
        Constructors
    ************************************/ // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;
        this._value = number;
    }
    numeral = function(input) {
        var value, kind, unformatFunction, regexp;
        if (numeral.isNumeral(input)) value = input.value();
        else if (input === 0 || typeof input === "undefined") value = 0;
        else if (input === null || _.isNaN(input)) value = null;
        else if (typeof input === "string") {
            if (options.zeroFormat && input === options.zeroFormat) value = 0;
            else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, "").length) value = null;
            else {
                for(kind in formats){
                    regexp = typeof formats[kind].regexps.unformat === "function" ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;
                        break;
                    }
                }
                unformatFunction = unformatFunction || numeral._.stringToNumber;
                value = unformatFunction(input);
            }
        } else value = Number(input) || null;
        return new Numeral(input, value);
    };
    // version number
    numeral.version = VERSION;
    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };
    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale], negP = false, optDec = false, leadingCount = 0, abbr = "", trillion = 1000000000000, billion = 1000000000, million = 1000000, thousand = 1000, decimal = "", neg = false, abbrForce, abs, min, max, power, int, precision, signed, thousands, output;
            // make sure we never format a null value
            value = value || 0;
            abs = Math.abs(value);
            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, "(")) {
                negP = true;
                format = format.replace(/[\(|\)]/g, "");
            } else if (numeral._.includes(format, "+") || numeral._.includes(format, "-")) {
                signed = numeral._.includes(format, "+") ? format.indexOf("+") : value < 0 ? format.indexOf("-") : -1;
                format = format.replace(/[\+|\-]/g, "");
            }
            // see if abbreviation is wanted
            if (numeral._.includes(format, "a")) {
                abbrForce = format.match(/a(k|m|b|t)?/);
                abbrForce = abbrForce ? abbrForce[1] : false;
                // check for space before abbreviation
                if (numeral._.includes(format, " a")) abbr = " ";
                format = format.replace(new RegExp(abbr + "a[kmbt]?"), "");
                if (abs >= trillion && !abbrForce || abbrForce === "t") {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === "b") {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === "m") {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === "k") {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }
            // check for optional decimals
            if (numeral._.includes(format, "[.]")) {
                optDec = true;
                format = format.replace("[.]", ".");
            }
            // break number and format
            int = value.toString().split(".")[0];
            precision = format.split(".")[1];
            thousands = format.indexOf(",");
            leadingCount = (format.split(".")[0].split(",")[0].match(/0/g) || []).length;
            if (precision) {
                if (numeral._.includes(precision, "[")) {
                    precision = precision.replace("]", "");
                    precision = precision.split("[");
                    decimal = numeral._.toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
                } else decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                int = decimal.split(".")[0];
                if (numeral._.includes(decimal, ".")) decimal = locale.delimiters.decimal + decimal.split(".")[1];
                else decimal = "";
                if (optDec && Number(decimal.slice(1)) === 0) decimal = "";
            } else int = numeral._.toFixed(value, 0, roundingFunction);
            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);
                switch(abbr){
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }
            // format number
            if (numeral._.includes(int, "-")) {
                int = int.slice(1);
                neg = true;
            }
            if (int.length < leadingCount) for(var i = leadingCount - int.length; i > 0; i--)int = "0" + int;
            if (thousands > -1) int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1" + locale.delimiters.thousands);
            if (format.indexOf(".") === 0) int = "";
            output = int + decimal + (abbr ? abbr : "");
            if (negP) output = (negP && neg ? "(" : "") + output + (negP && neg ? ")" : "");
            else {
                if (signed >= 0) output = signed === 0 ? (neg ? "-" : "+") + output : output + (neg ? "-" : "+");
                else if (neg) output = "-" + output;
            }
            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale], stringOriginal = string, abbreviations = {
                thousand: 3,
                million: 6,
                billion: 9,
                trillion: 12
            }, abbreviation, value, i, regexp;
            if (options.zeroFormat && string === options.zeroFormat) value = 0;
            else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, "").length) value = null;
            else {
                value = 1;
                if (locale.delimiters.decimal !== ".") string = string.replace(/\./g, "").replace(locale.delimiters.decimal, ".");
                for(abbreviation in abbreviations){
                    regexp = new RegExp("[^a-zA-Z]" + locale.abbreviations[abbreviation] + "(?:\\)|(\\" + locale.currency.symbol + ")?(?:\\))?)?$");
                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }
                // check for negative number
                value *= (string.split("-").length + Math.min(string.split("(").length - 1, string.split(")").length - 1)) % 2 ? 1 : -1;
                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, "");
                value *= Number(string);
            }
            return value;
        },
        isNaN: function(value) {
            return typeof value === "number" && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/ ) {
            if (this === null) throw new TypeError("Array.prototype.reduce called on null or undefined");
            if (typeof callback !== "function") throw new TypeError(callback + " is not a function");
            var t = Object(array), len = t.length >>> 0, k = 0, value;
            if (arguments.length === 3) value = arguments[2];
            else {
                while(k < len && !(k in t))k++;
                if (k >= len) throw new TypeError("Reduce of empty array with no initial value");
                value = t[k++];
            }
            for(; k < len; k++)if (k in t) value = callback(value, t[k], k, t);
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */ multiplier: function(x) {
            var parts = x.toString().split(".");
            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */ correctionFactor: function() {
            var args = Array.prototype.slice.call(arguments);
            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */ toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split("."), minDecimals = maxDecimals - (optionals || 0), boundedPrecision, optionalsRegExp, power, output;
            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            else boundedPrecision = minDecimals;
            power = Math.pow(10, boundedPrecision);
            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + "e+" + boundedPrecision) / power).toFixed(boundedPrecision);
            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp("\\.?0{1," + (optionals - (maxDecimals - boundedPrecision)) + "}$");
                output = output.replace(optionalsRegExp, "");
            }
            return output;
        }
    };
    // avaliable options
    numeral.options = options;
    // avaliable formats
    numeral.formats = formats;
    // avaliable formats
    numeral.locales = locales;
    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) options.currentLocale = key.toLowerCase();
        return options.currentLocale;
    };
    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) return locales[options.currentLocale];
        key = key.toLowerCase();
        if (!locales[key]) throw new Error("Unknown locale : " + key);
        return locales[key];
    };
    numeral.reset = function() {
        for(var property in defaults)options[property] = defaults[property];
    };
    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof format === "string" ? format : null;
    };
    numeral.nullFormat = function(format) {
        options.nullFormat = typeof format === "string" ? format : null;
    };
    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof format === "string" ? format : "0.0";
    };
    numeral.register = function(type, name, format) {
        name = name.toLowerCase();
        if (this[type + "s"][name]) throw new TypeError(name + " " + type + " already registered.");
        this[type + "s"][name] = format;
        return format;
    };
    numeral.validate = function(val, culture) {
        var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, localeData, temp;
        //coerce val to string
        if (typeof val !== "string") {
            val += "";
            if (console.warn) console.warn("Numeral.js: Value is not string. It has been co-erced to: ", val);
        }
        //trim whitespaces from either sides
        val = val.trim();
        //if val is just digits return true
        if (!!val.match(/^\d+$/)) return true;
        //if val is empty return false
        if (val === "") return false;
        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }
        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === ".") _thousandSep = "\\.";
        else _thousandSep = localeData.delimiters.thousands;
        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) return false;
        }
        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) return false;
        }
        _thousandRegEx = new RegExp(_thousandSep + "{2}");
        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) return false;
            else {
                if (_valArray.length < 2) return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
                else {
                    if (_valArray[0].length === 1) return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                    else return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                }
            }
        }
        return false;
    };
    /************************************
        Numeral Prototype
    ************************************/ numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value, format = inputString || options.defaultFormat, kind, output, formatFunction;
            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;
            // format based on value
            if (value === 0 && options.zeroFormat !== null) output = options.zeroFormat;
            else if (value === null && options.nullFormat !== null) output = options.nullFormat;
            else {
                for(kind in formats)if (format.match(formats[kind].regexps.format)) {
                    formatFunction = formats[kind].format;
                    break;
                }
                formatFunction = formatFunction || numeral._.numberToFormat;
                output = formatFunction(value, format, roundingFunction);
            }
            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);
            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 0) / corrFactor;
            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                value
            ], cback, Math.round(this._value * corrFactor)) / corrFactor;
            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 1);
            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback);
            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };
    /************************************
        Default Locale && Format
    ************************************/ numeral.register("locale", "en", {
        delimiters: {
            thousands: ",",
            decimal: "."
        },
        abbreviations: {
            thousand: "k",
            million: "m",
            billion: "b",
            trillion: "t"
        },
        ordinal: function(number) {
            var b = number % 10;
            return ~~(number % 100 / 10) === 1 ? "th" : b === 1 ? "st" : b === 2 ? "nd" : b === 3 ? "rd" : "th";
        },
        currency: {
            symbol: "$"
        }
    });
    (function() {
        numeral.register("format", "bps", {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, " BPS") ? " " : "", output;
                value = value * 10000;
                // check for space before BPS
                format = format.replace(/\s?BPS/, "");
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ")")) {
                    output = output.split("");
                    output.splice(-1, 0, space + "BPS");
                    output = output.join("");
                } else output = output + space + "BPS";
                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
    })();
    (function() {
        var decimal = {
            base: 1000,
            suffixes: [
                "B",
                "KB",
                "MB",
                "GB",
                "TB",
                "PB",
                "EB",
                "ZB",
                "YB"
            ]
        }, binary = {
            base: 1024,
            suffixes: [
                "B",
                "KiB",
                "MiB",
                "GiB",
                "TiB",
                "PiB",
                "EiB",
                "ZiB",
                "YiB"
            ]
        };
        var allSuffixes = decimal.suffixes.concat(binary.suffixes.filter(function(item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join("|");
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = "(" + unformatRegex.replace("B", "B(?!PS)") + ")";
        numeral.register("format", "bytes", {
            regexps: {
                format: /([0\s]i?b)/,
                unformat: new RegExp(unformatRegex)
            },
            format: function(value, format, roundingFunction) {
                var output, bytes = numeral._.includes(format, "ib") ? binary : decimal, suffix = numeral._.includes(format, " b") || numeral._.includes(format, " ib") ? " " : "", power, min, max;
                // check for space before
                format = format.replace(/\s?i?b/, "");
                for(power = 0; power <= bytes.suffixes.length; power++){
                    min = Math.pow(bytes.base, power);
                    max = Math.pow(bytes.base, power + 1);
                    if (value === null || value === 0 || value >= min && value < max) {
                        suffix += bytes.suffixes[power];
                        if (min > 0) value = value / min;
                        break;
                    }
                }
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + suffix;
            },
            unformat: function(string) {
                var value = numeral._.stringToNumber(string), power, bytesMultiplier;
                if (value) {
                    for(power = decimal.suffixes.length - 1; power >= 0; power--){
                        if (numeral._.includes(string, decimal.suffixes[power])) {
                            bytesMultiplier = Math.pow(decimal.base, power);
                            break;
                        }
                        if (numeral._.includes(string, binary.suffixes[power])) {
                            bytesMultiplier = Math.pow(binary.base, power);
                            break;
                        }
                    }
                    value *= bytesMultiplier || 1;
                }
                return value;
            }
        });
    })();
    (function() {
        numeral.register("format", "currency", {
            regexps: {
                format: /(\$)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                }, output, symbol, i;
                // strip format of spaces and $
                format = format.replace(/\s?\$\s?/, "");
                // format the number
                output = numeral._.numberToFormat(value, format, roundingFunction);
                // update the before and after based on value
                if (value >= 0) {
                    symbols.before = symbols.before.replace(/[\-\(]/, "");
                    symbols.after = symbols.after.replace(/[\-\)]/, "");
                } else if (value < 0 && !numeral._.includes(symbols.before, "-") && !numeral._.includes(symbols.before, "(")) symbols.before = "-" + symbols.before;
                // loop through each before symbol
                for(i = 0; i < symbols.before.length; i++){
                    symbol = symbols.before[i];
                    switch(symbol){
                        case "$":
                            output = numeral._.insert(output, locale.currency.symbol, i);
                            break;
                        case " ":
                            output = numeral._.insert(output, " ", i + locale.currency.symbol.length - 1);
                            break;
                    }
                }
                // loop through each after symbol
                for(i = symbols.after.length - 1; i >= 0; i--){
                    symbol = symbols.after[i];
                    switch(symbol){
                        case "$":
                            output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                            break;
                        case " ":
                            output = i === symbols.after.length - 1 ? output + " " : numeral._.insert(output, " ", -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                            break;
                    }
                }
                return output;
            }
        });
    })();
    (function() {
        numeral.register("format", "exponential", {
            regexps: {
                format: /(e\+|e-)/,
                unformat: /(e\+|e-)/
            },
            format: function(value, format, roundingFunction) {
                var output, exponential = typeof value === "number" && !numeral._.isNaN(value) ? value.toExponential() : "0e+0", parts = exponential.split("e");
                format = format.replace(/e[\+|\-]{1}0/, "");
                output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
                return output + "e" + parts[1];
            },
            unformat: function(string) {
                var parts = numeral._.includes(string, "e+") ? string.split("e+") : string.split("e-"), value = Number(parts[0]), power = Number(parts[1]);
                power = numeral._.includes(string, "e-") ? power *= -1 : power;
                function cback(accum, curr, currI, O) {
                    var corrFactor = numeral._.correctionFactor(accum, curr), num = accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
                    return num;
                }
                return numeral._.reduce([
                    value,
                    Math.pow(10, power)
                ], cback, 1);
            }
        });
    })();
    (function() {
        numeral.register("format", "ordinal", {
            regexps: {
                format: /(o)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], output, ordinal = numeral._.includes(format, " o") ? " " : "";
                // check for space before
                format = format.replace(/\s?o/, "");
                ordinal += locale.ordinal(value);
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + ordinal;
            }
        });
    })();
    (function() {
        numeral.register("format", "percentage", {
            regexps: {
                format: /(%)/,
                unformat: /(%)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, " %") ? " " : "", output;
                if (numeral.options.scalePercentBy100) value = value * 100;
                // check for space before %
                format = format.replace(/\s?\%/, "");
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ")")) {
                    output = output.split("");
                    output.splice(-1, 0, space + "%");
                    output = output.join("");
                } else output = output + space + "%";
                return output;
            },
            unformat: function(string) {
                var number = numeral._.stringToNumber(string);
                if (numeral.options.scalePercentBy100) return number * 0.01;
                return number;
            }
        });
    })();
    (function() {
        numeral.register("format", "time", {
            regexps: {
                format: /(:)/,
                unformat: /(:)/
            },
            format: function(value, format, roundingFunction) {
                var hours = Math.floor(value / 60 / 60), minutes = Math.floor((value - hours * 3600) / 60), seconds = Math.round(value - hours * 3600 - minutes * 60);
                return hours + ":" + (minutes < 10 ? "0" + minutes : minutes) + ":" + (seconds < 10 ? "0" + seconds : seconds);
            },
            unformat: function(string) {
                var timeArray = string.split(":"), seconds = 0;
                // turn hours and minutes into seconds and add them all up
                if (timeArray.length === 3) {
                    // hours
                    seconds = seconds + Number(timeArray[0]) * 3600;
                    // minutes
                    seconds = seconds + Number(timeArray[1]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[2]);
                } else if (timeArray.length === 2) {
                    // minutes
                    seconds = seconds + Number(timeArray[0]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[1]);
                }
                return Number(seconds);
            }
        });
    })();
    return numeral;
});

});


parcelRegister("aOoAs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PRE_PROD_BUCKET = module.exports.PROD_BUCKET = module.exports.STAGE_BUCKET = module.exports.LOCALHOST_BUCKET = module.exports.PRE_PROD_HOSTS = module.exports.PRE_PROD_HOST = module.exports.PRE_PROD_HOST_LEGACY = module.exports.PROD_HOSTS = module.exports.PROD_HOST = module.exports.PROD_HOST_LEGACY = module.exports.STAGE_HOSTS = module.exports.STAGE_HOST = module.exports.STAGE_HOST_LEGACY = module.exports.LOCALHOST_HOSTS = module.exports.LOCALHOST_IP = module.exports.LOCALHOST_DEFAULT = module.exports.LOCALHOST_HOST = void 0;
// LOCAL hosts
module.exports.LOCALHOST_HOST = "localhost";
module.exports.LOCALHOST_DEFAULT = "0.0.0.0";
module.exports.LOCALHOST_IP = "127.0.0.1";
module.exports.LOCALHOST_HOSTS = [
    module.exports.LOCALHOST_HOST,
    module.exports.LOCALHOST_DEFAULT,
    module.exports.LOCALHOST_IP
];
// STAGE hosts
module.exports.STAGE_HOST_LEGACY = "https://cpa.purplegears.net";
module.exports.STAGE_HOST = "https://test.messaging.teliacompany.com";
module.exports.STAGE_HOSTS = [
    module.exports.STAGE_HOST_LEGACY,
    module.exports.STAGE_HOST
];
// PROD hosts
module.exports.PROD_HOST_LEGACY = "https://messaging.telia.no";
module.exports.PROD_HOST = "https://messaging.teliacompany.com";
module.exports.PROD_HOSTS = [
    module.exports.PROD_HOST_LEGACY,
    module.exports.PROD_HOST
];
// PRE_PROD hosts
module.exports.PRE_PROD_HOST_LEGACY = "https://pre-prod.messaging.telia.no";
module.exports.PRE_PROD_HOST = "https://pre-prod.messaging.teliacompany.com";
module.exports.PRE_PROD_HOSTS = [
    module.exports.PRE_PROD_HOST_LEGACY,
    module.exports.PRE_PROD_HOST
];
module.exports.LOCALHOST_BUCKET = "cpa-stage-customer-documents";
module.exports.STAGE_BUCKET = "cpa-stage-customer-documents";
module.exports.PROD_BUCKET = "cpa-prod-customer-documents";
module.exports.PRE_PROD_BUCKET = "cpa-pre-prod-customer-documents";

});

parcelRegister("gExGH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isValidAddress = module.exports.isV4CidrAddress = module.exports.isV4IpAddress = void 0;

var $8bIny = parcelRequire("8bIny");
const $c1fa8377edc578da$var$isV4IpAddress = (address)=>{
    return $8bIny.Address4.isValid(address) && address.split(".").every((section)=>+section < 256);
};
module.exports.isV4IpAddress = $c1fa8377edc578da$var$isV4IpAddress;
const $c1fa8377edc578da$var$isV4CidrAddress = (address)=>{
    const [ip, subnet] = address.split(/\/(.*)/s);
    if (ip && subnet) return (0, module.exports.isV4IpAddress)(ip) && /^([0-9]|[1-2][0-9]|3[0-2])?$/.test(subnet);
    else return false;
};
module.exports.isV4CidrAddress = $c1fa8377edc578da$var$isV4CidrAddress;
const $c1fa8377edc578da$var$isValidAddress = (address)=>!!address && ((0, module.exports.isV4IpAddress)(address) || (0, module.exports.isV4CidrAddress)(address));
module.exports.isValidAddress = $c1fa8377edc578da$var$isValidAddress;

});
parcelRegister("8bIny", function(module, exports) {
"use strict";
var $5f61c68fd7418034$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $5f61c68fd7418034$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $5f61c68fd7418034$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5f61c68fd7418034$var$__createBinding(result, mod, k);
    }
    $5f61c68fd7418034$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.v6 = module.exports.AddressError = module.exports.Address6 = module.exports.Address4 = void 0;

var $37Fnt = parcelRequire("37Fnt");
Object.defineProperty(module.exports, "Address4", {
    enumerable: true,
    get: function() {
        return $37Fnt.Address4;
    }
});

var $esQsa = parcelRequire("esQsa");
Object.defineProperty(module.exports, "Address6", {
    enumerable: true,
    get: function() {
        return $esQsa.Address6;
    }
});

var $kxYqo = parcelRequire("kxYqo");
Object.defineProperty(module.exports, "AddressError", {
    enumerable: true,
    get: function() {
        return $kxYqo.AddressError;
    }
});

const $5f61c68fd7418034$var$helpers = $5f61c68fd7418034$var$__importStar((parcelRequire("f7yJc")));
module.exports.v6 = {
    helpers: $5f61c68fd7418034$var$helpers
};

});
parcelRegister("37Fnt", function(module, exports) {
"use strict";
/* eslint-disable no-param-reassign */ var $24621f47853f39ed$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $24621f47853f39ed$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $24621f47853f39ed$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $24621f47853f39ed$var$__createBinding(result, mod, k);
    }
    $24621f47853f39ed$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Address4 = void 0;

const $24621f47853f39ed$var$common = $24621f47853f39ed$var$__importStar((parcelRequire("3iKdL")));

const $24621f47853f39ed$var$constants = $24621f47853f39ed$var$__importStar((parcelRequire("1TywH")));

var $kxYqo = parcelRequire("kxYqo");
/**
 * Represents an IPv4 address
 * @class Address4
 * @param {string} address - An IPv4 address string
 */ class $24621f47853f39ed$var$Address4 {
    constructor(address){
        this.groups = $24621f47853f39ed$var$constants.GROUPS;
        this.parsedAddress = [];
        this.parsedSubnet = "";
        this.subnet = "/32";
        this.subnetMask = 32;
        this.v4 = true;
        /**
         * Returns true if the address is correct, false otherwise
         * @memberof Address4
         * @instance
         * @returns {Boolean}
         */ this.isCorrect = $24621f47853f39ed$var$common.isCorrect($24621f47853f39ed$var$constants.BITS);
        /**
         * Returns true if the given address is in the subnet of the current address
         * @memberof Address4
         * @instance
         * @returns {boolean}
         */ this.isInSubnet = $24621f47853f39ed$var$common.isInSubnet;
        this.address = address;
        const subnet = $24621f47853f39ed$var$constants.RE_SUBNET_STRING.exec(address);
        if (subnet) {
            this.parsedSubnet = subnet[0].replace("/", "");
            this.subnetMask = parseInt(this.parsedSubnet, 10);
            this.subnet = `/${this.subnetMask}`;
            if (this.subnetMask < 0 || this.subnetMask > $24621f47853f39ed$var$constants.BITS) throw new $kxYqo.AddressError("Invalid subnet mask.");
            address = address.replace($24621f47853f39ed$var$constants.RE_SUBNET_STRING, "");
        }
        this.addressMinusSuffix = address;
        this.parsedAddress = this.parse(address);
    }
    static isValid(address) {
        try {
            // eslint-disable-next-line no-new
            new $24621f47853f39ed$var$Address4(address);
            return true;
        } catch (e) {
            return false;
        }
    }
    /*
     * Parses a v4 address
     */ parse(address) {
        const groups = address.split(".");
        if (!address.match($24621f47853f39ed$var$constants.RE_ADDRESS)) throw new $kxYqo.AddressError("Invalid IPv4 address.");
        return groups;
    }
    /**
     * Returns the correct form of an address
     * @memberof Address4
     * @instance
     * @returns {String}
     */ correctForm() {
        return this.parsedAddress.map((part)=>parseInt(part, 10)).join(".");
    }
    /**
     * Converts a hex string to an IPv4 address object
     * @memberof Address4
     * @static
     * @param {string} hex - a hex string to convert
     * @returns {Address4}
     */ static fromHex(hex) {
        const padded = hex.replace(/:/g, "").padStart(8, "0");
        const groups = [];
        let i;
        for(i = 0; i < 8; i += 2){
            const h = padded.slice(i, i + 2);
            groups.push(parseInt(h, 16));
        }
        return new $24621f47853f39ed$var$Address4(groups.join("."));
    }
    /**
     * Converts an integer into a IPv4 address object
     * @memberof Address4
     * @static
     * @param {integer} integer - a number to convert
     * @returns {Address4}
     */ static fromInteger(integer) {
        return $24621f47853f39ed$var$Address4.fromHex(integer.toString(16));
    }
    /**
     * Return an address from in-addr.arpa form
     * @memberof Address4
     * @static
     * @param {string} arpaFormAddress - an 'in-addr.arpa' form ipv4 address
     * @returns {Adress4}
     * @example
     * var address = Address4.fromArpa(42.2.0.192.in-addr.arpa.)
     * address.correctForm(); // '192.0.2.42'
     */ static fromArpa(arpaFormAddress) {
        // remove ending ".in-addr.arpa." or just "."
        const leader = arpaFormAddress.replace(/(\.in-addr\.arpa)?\.$/, "");
        const address = leader.split(".").reverse().join(".");
        return new $24621f47853f39ed$var$Address4(address);
    }
    /**
     * Converts an IPv4 address object to a hex string
     * @memberof Address4
     * @instance
     * @returns {String}
     */ toHex() {
        return this.parsedAddress.map((part)=>$24621f47853f39ed$var$common.stringToPaddedHex(part)).join(":");
    }
    /**
     * Converts an IPv4 address object to an array of bytes
     * @memberof Address4
     * @instance
     * @returns {Array}
     */ toArray() {
        return this.parsedAddress.map((part)=>parseInt(part, 10));
    }
    /**
     * Converts an IPv4 address object to an IPv6 address group
     * @memberof Address4
     * @instance
     * @returns {String}
     */ toGroup6() {
        const output = [];
        let i;
        for(i = 0; i < $24621f47853f39ed$var$constants.GROUPS; i += 2)output.push(`${$24621f47853f39ed$var$common.stringToPaddedHex(this.parsedAddress[i])}${$24621f47853f39ed$var$common.stringToPaddedHex(this.parsedAddress[i + 1])}`);
        return output.join(":");
    }
    /**
     * Returns the address as a `bigint`
     * @memberof Address4
     * @instance
     * @returns {bigint}
     */ bigInt() {
        return BigInt(`0x${this.parsedAddress.map((n)=>$24621f47853f39ed$var$common.stringToPaddedHex(n)).join("")}`);
    }
    /**
     * Helper function getting start address.
     * @memberof Address4
     * @instance
     * @returns {bigint}
     */ _startAddress() {
        return BigInt(`0b${this.mask() + "0".repeat($24621f47853f39ed$var$constants.BITS - this.subnetMask)}`);
    }
    /**
     * The first address in the range given by this address' subnet.
     * Often referred to as the Network Address.
     * @memberof Address4
     * @instance
     * @returns {Address4}
     */ startAddress() {
        return $24621f47853f39ed$var$Address4.fromBigInt(this._startAddress());
    }
    /**
     * The first host address in the range given by this address's subnet ie
     * the first address after the Network Address
     * @memberof Address4
     * @instance
     * @returns {Address4}
     */ startAddressExclusive() {
        const adjust = BigInt("1");
        return $24621f47853f39ed$var$Address4.fromBigInt(this._startAddress() + adjust);
    }
    /**
     * Helper function getting end address.
     * @memberof Address4
     * @instance
     * @returns {bigint}
     */ _endAddress() {
        return BigInt(`0b${this.mask() + "1".repeat($24621f47853f39ed$var$constants.BITS - this.subnetMask)}`);
    }
    /**
     * The last address in the range given by this address' subnet
     * Often referred to as the Broadcast
     * @memberof Address4
     * @instance
     * @returns {Address4}
     */ endAddress() {
        return $24621f47853f39ed$var$Address4.fromBigInt(this._endAddress());
    }
    /**
     * The last host address in the range given by this address's subnet ie
     * the last address prior to the Broadcast Address
     * @memberof Address4
     * @instance
     * @returns {Address4}
     */ endAddressExclusive() {
        const adjust = BigInt("1");
        return $24621f47853f39ed$var$Address4.fromBigInt(this._endAddress() - adjust);
    }
    /**
     * Converts a BigInt to a v4 address object
     * @memberof Address4
     * @static
     * @param {bigint} bigInt - a BigInt to convert
     * @returns {Address4}
     */ static fromBigInt(bigInt) {
        return $24621f47853f39ed$var$Address4.fromHex(bigInt.toString(16));
    }
    /**
     * Returns the first n bits of the address, defaulting to the
     * subnet mask
     * @memberof Address4
     * @instance
     * @returns {String}
     */ mask(mask) {
        if (mask === undefined) mask = this.subnetMask;
        return this.getBitsBase2(0, mask);
    }
    /**
     * Returns the bits in the given range as a base-2 string
     * @memberof Address4
     * @instance
     * @returns {string}
     */ getBitsBase2(start, end) {
        return this.binaryZeroPad().slice(start, end);
    }
    /**
     * Return the reversed ip6.arpa form of the address
     * @memberof Address4
     * @param {Object} options
     * @param {boolean} options.omitSuffix - omit the "in-addr.arpa" suffix
     * @instance
     * @returns {String}
     */ reverseForm(options) {
        if (!options) options = {};
        const reversed = this.correctForm().split(".").reverse().join(".");
        if (options.omitSuffix) return reversed;
        return `${reversed}.in-addr.arpa.`;
    }
    /**
     * Returns true if the given address is a multicast address
     * @memberof Address4
     * @instance
     * @returns {boolean}
     */ isMulticast() {
        return this.isInSubnet(new $24621f47853f39ed$var$Address4("224.0.0.0/4"));
    }
    /**
     * Returns a zero-padded base-2 string representation of the address
     * @memberof Address4
     * @instance
     * @returns {string}
     */ binaryZeroPad() {
        return this.bigInt().toString(2).padStart($24621f47853f39ed$var$constants.BITS, "0");
    }
    /**
     * Groups an IPv4 address for inclusion at the end of an IPv6 address
     * @returns {String}
     */ groupForV6() {
        const segments = this.parsedAddress;
        return this.address.replace($24621f47853f39ed$var$constants.RE_ADDRESS, `<span class="hover-group group-v4 group-6">${segments.slice(0, 2).join(".")}</span>.<span class="hover-group group-v4 group-7">${segments.slice(2, 4).join(".")}</span>`);
    }
}
module.exports.Address4 = $24621f47853f39ed$var$Address4;

});
parcelRegister("3iKdL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isInSubnet = $2676e8159c8d62fd$var$isInSubnet;
module.exports.isCorrect = $2676e8159c8d62fd$var$isCorrect;
module.exports.numberToPaddedHex = $2676e8159c8d62fd$var$numberToPaddedHex;
module.exports.stringToPaddedHex = $2676e8159c8d62fd$var$stringToPaddedHex;
module.exports.testBit = $2676e8159c8d62fd$var$testBit;
function $2676e8159c8d62fd$var$isInSubnet(address) {
    if (this.subnetMask < address.subnetMask) return false;
    if (this.mask(address.subnetMask) === address.mask()) return true;
    return false;
}
function $2676e8159c8d62fd$var$isCorrect(defaultBits) {
    return function() {
        if (this.addressMinusSuffix !== this.correctForm()) return false;
        if (this.subnetMask === defaultBits && !this.parsedSubnet) return true;
        return this.parsedSubnet === String(this.subnetMask);
    };
}
function $2676e8159c8d62fd$var$numberToPaddedHex(number) {
    return number.toString(16).padStart(2, "0");
}
function $2676e8159c8d62fd$var$stringToPaddedHex(numberString) {
    return $2676e8159c8d62fd$var$numberToPaddedHex(parseInt(numberString, 10));
}
/**
 * @param binaryValue Binary representation of a value (e.g. `10`)
 * @param position Byte position, where 0 is the least significant bit
 */ function $2676e8159c8d62fd$var$testBit(binaryValue, position) {
    const { length: length } = binaryValue;
    if (position > length) return false;
    const positionInString = length - position;
    return binaryValue.substring(positionInString, positionInString + 1) === "1";
}

});

parcelRegister("1TywH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RE_SUBNET_STRING = module.exports.RE_ADDRESS = module.exports.GROUPS = module.exports.BITS = void 0;
module.exports.BITS = 32;
module.exports.GROUPS = 4;
module.exports.RE_ADDRESS = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/g;
module.exports.RE_SUBNET_STRING = /\/\d{1,2}$/;

});

parcelRegister("kxYqo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AddressError = void 0;
class $ef55c2d29a96dbba$var$AddressError extends Error {
    constructor(message, parseMessage){
        super(message);
        this.name = "AddressError";
        this.parseMessage = parseMessage;
    }
}
module.exports.AddressError = $ef55c2d29a96dbba$var$AddressError;

});


parcelRegister("esQsa", function(module, exports) {
"use strict";
/* eslint-disable prefer-destructuring */ /* eslint-disable no-param-reassign */ var $a87c5e532014813e$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $a87c5e532014813e$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $a87c5e532014813e$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $a87c5e532014813e$var$__createBinding(result, mod, k);
    }
    $a87c5e532014813e$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Address6 = void 0;

const $a87c5e532014813e$var$common = $a87c5e532014813e$var$__importStar((parcelRequire("3iKdL")));

const $a87c5e532014813e$var$constants4 = $a87c5e532014813e$var$__importStar((parcelRequire("1TywH")));

const $a87c5e532014813e$var$constants6 = $a87c5e532014813e$var$__importStar((parcelRequire("6eDib")));

const $a87c5e532014813e$var$helpers = $a87c5e532014813e$var$__importStar((parcelRequire("f7yJc")));

var $37Fnt = parcelRequire("37Fnt");

var $8wyMl = parcelRequire("8wyMl");

var $kxYqo = parcelRequire("kxYqo");

function $a87c5e532014813e$var$assert(condition) {
    if (!condition) throw new Error("Assertion failed.");
}
function $a87c5e532014813e$var$addCommas(number) {
    const r = /(\d+)(\d{3})/;
    while(r.test(number))number = number.replace(r, "$1,$2");
    return number;
}
function $a87c5e532014813e$var$spanLeadingZeroes4(n) {
    n = n.replace(/^(0{1,})([1-9]+)$/, '<span class="parse-error">$1</span>$2');
    n = n.replace(/^(0{1,})(0)$/, '<span class="parse-error">$1</span>$2');
    return n;
}
/*
 * A helper function to compact an array
 */ function $a87c5e532014813e$var$compact(address, slice) {
    const s1 = [];
    const s2 = [];
    let i;
    for(i = 0; i < address.length; i++){
        if (i < slice[0]) s1.push(address[i]);
        else if (i > slice[1]) s2.push(address[i]);
    }
    return s1.concat([
        "compact"
    ]).concat(s2);
}
function $a87c5e532014813e$var$paddedHex(octet) {
    return parseInt(octet, 16).toString(16).padStart(4, "0");
}
function $a87c5e532014813e$var$unsignByte(b) {
    // eslint-disable-next-line no-bitwise
    return b & 0xff;
}
/**
 * Represents an IPv6 address
 * @class Address6
 * @param {string} address - An IPv6 address string
 * @param {number} [groups=8] - How many octets to parse
 * @example
 * var address = new Address6('2001::/32');
 */ class $a87c5e532014813e$var$Address6 {
    constructor(address, optionalGroups){
        this.addressMinusSuffix = "";
        this.parsedSubnet = "";
        this.subnet = "/128";
        this.subnetMask = 128;
        this.v4 = false;
        this.zone = "";
        // #region Attributes
        /**
         * Returns true if the given address is in the subnet of the current address
         * @memberof Address6
         * @instance
         * @returns {boolean}
         */ this.isInSubnet = $a87c5e532014813e$var$common.isInSubnet;
        /**
         * Returns true if the address is correct, false otherwise
         * @memberof Address6
         * @instance
         * @returns {boolean}
         */ this.isCorrect = $a87c5e532014813e$var$common.isCorrect($a87c5e532014813e$var$constants6.BITS);
        if (optionalGroups === undefined) this.groups = $a87c5e532014813e$var$constants6.GROUPS;
        else this.groups = optionalGroups;
        this.address = address;
        const subnet = $a87c5e532014813e$var$constants6.RE_SUBNET_STRING.exec(address);
        if (subnet) {
            this.parsedSubnet = subnet[0].replace("/", "");
            this.subnetMask = parseInt(this.parsedSubnet, 10);
            this.subnet = `/${this.subnetMask}`;
            if (Number.isNaN(this.subnetMask) || this.subnetMask < 0 || this.subnetMask > $a87c5e532014813e$var$constants6.BITS) throw new $kxYqo.AddressError("Invalid subnet mask.");
            address = address.replace($a87c5e532014813e$var$constants6.RE_SUBNET_STRING, "");
        } else if (/\//.test(address)) throw new $kxYqo.AddressError("Invalid subnet mask.");
        const zone = $a87c5e532014813e$var$constants6.RE_ZONE_STRING.exec(address);
        if (zone) {
            this.zone = zone[0];
            address = address.replace($a87c5e532014813e$var$constants6.RE_ZONE_STRING, "");
        }
        this.addressMinusSuffix = address;
        this.parsedAddress = this.parse(this.addressMinusSuffix);
    }
    static isValid(address) {
        try {
            // eslint-disable-next-line no-new
            new $a87c5e532014813e$var$Address6(address);
            return true;
        } catch (e) {
            return false;
        }
    }
    /**
     * Convert a BigInt to a v6 address object
     * @memberof Address6
     * @static
     * @param {bigint} bigInt - a BigInt to convert
     * @returns {Address6}
     * @example
     * var bigInt = BigInt('1000000000000');
     * var address = Address6.fromBigInt(bigInt);
     * address.correctForm(); // '::e8:d4a5:1000'
     */ static fromBigInt(bigInt) {
        const hex = bigInt.toString(16).padStart(32, "0");
        const groups = [];
        let i;
        for(i = 0; i < $a87c5e532014813e$var$constants6.GROUPS; i++)groups.push(hex.slice(i * 4, (i + 1) * 4));
        return new $a87c5e532014813e$var$Address6(groups.join(":"));
    }
    /**
     * Convert a URL (with optional port number) to an address object
     * @memberof Address6
     * @static
     * @param {string} url - a URL with optional port number
     * @example
     * var addressAndPort = Address6.fromURL('http://[ffff::]:8080/foo/');
     * addressAndPort.address.correctForm(); // 'ffff::'
     * addressAndPort.port; // 8080
     */ static fromURL(url) {
        let host;
        let port = null;
        let result;
        // If we have brackets parse them and find a port
        if (url.indexOf("[") !== -1 && url.indexOf("]:") !== -1) {
            result = $a87c5e532014813e$var$constants6.RE_URL_WITH_PORT.exec(url);
            if (result === null) return {
                error: "failed to parse address with port",
                address: null,
                port: null
            };
            host = result[1];
            port = result[2];
        // If there's a URL extract the address
        } else if (url.indexOf("/") !== -1) {
            // Remove the protocol prefix
            url = url.replace(/^[a-z0-9]+:\/\//, "");
            // Parse the address
            result = $a87c5e532014813e$var$constants6.RE_URL.exec(url);
            if (result === null) return {
                error: "failed to parse address from URL",
                address: null,
                port: null
            };
            host = result[1];
        // Otherwise just assign the URL to the host and let the library parse it
        } else host = url;
        // If there's a port convert it to an integer
        if (port) {
            port = parseInt(port, 10);
            // squelch out of range ports
            if (port < 0 || port > 65536) port = null;
        } else // Standardize `undefined` to `null`
        port = null;
        return {
            address: new $a87c5e532014813e$var$Address6(host),
            port: port
        };
    }
    /**
     * Create an IPv6-mapped address given an IPv4 address
     * @memberof Address6
     * @static
     * @param {string} address - An IPv4 address string
     * @returns {Address6}
     * @example
     * var address = Address6.fromAddress4('192.168.0.1');
     * address.correctForm(); // '::ffff:c0a8:1'
     * address.to4in6(); // '::ffff:192.168.0.1'
     */ static fromAddress4(address) {
        const address4 = new $37Fnt.Address4(address);
        const mask6 = $a87c5e532014813e$var$constants6.BITS - ($a87c5e532014813e$var$constants4.BITS - address4.subnetMask);
        return new $a87c5e532014813e$var$Address6(`::ffff:${address4.correctForm()}/${mask6}`);
    }
    /**
     * Return an address from ip6.arpa form
     * @memberof Address6
     * @static
     * @param {string} arpaFormAddress - an 'ip6.arpa' form address
     * @returns {Adress6}
     * @example
     * var address = Address6.fromArpa(e.f.f.f.3.c.2.6.f.f.f.e.6.6.8.e.1.0.6.7.9.4.e.c.0.0.0.0.1.0.0.2.ip6.arpa.)
     * address.correctForm(); // '2001:0:ce49:7601:e866:efff:62c3:fffe'
     */ static fromArpa(arpaFormAddress) {
        // remove ending ".ip6.arpa." or just "."
        let address = arpaFormAddress.replace(/(\.ip6\.arpa)?\.$/, "");
        const semicolonAmount = 7;
        // correct ip6.arpa form with ending removed will be 63 characters
        if (address.length !== 63) throw new $kxYqo.AddressError("Invalid 'ip6.arpa' form.");
        const parts = address.split(".").reverse();
        for(let i = semicolonAmount; i > 0; i--){
            const insertIndex = i * 4;
            parts.splice(insertIndex, 0, ":");
        }
        address = parts.join("");
        return new $a87c5e532014813e$var$Address6(address);
    }
    /**
     * Return the Microsoft UNC transcription of the address
     * @memberof Address6
     * @instance
     * @returns {String} the Microsoft UNC transcription of the address
     */ microsoftTranscription() {
        return `${this.correctForm().replace(/:/g, "-")}.ipv6-literal.net`;
    }
    /**
     * Return the first n bits of the address, defaulting to the subnet mask
     * @memberof Address6
     * @instance
     * @param {number} [mask=subnet] - the number of bits to mask
     * @returns {String} the first n bits of the address as a string
     */ mask(mask = this.subnetMask) {
        return this.getBitsBase2(0, mask);
    }
    /**
     * Return the number of possible subnets of a given size in the address
     * @memberof Address6
     * @instance
     * @param {number} [subnetSize=128] - the subnet size
     * @returns {String}
     */ // TODO: probably useful to have a numeric version of this too
    possibleSubnets(subnetSize = 128) {
        const availableBits = $a87c5e532014813e$var$constants6.BITS - this.subnetMask;
        const subnetBits = Math.abs(subnetSize - $a87c5e532014813e$var$constants6.BITS);
        const subnetPowers = availableBits - subnetBits;
        if (subnetPowers < 0) return "0";
        return $a87c5e532014813e$var$addCommas((BigInt("2") ** BigInt(subnetPowers)).toString(10));
    }
    /**
     * Helper function getting start address.
     * @memberof Address6
     * @instance
     * @returns {bigint}
     */ _startAddress() {
        return BigInt(`0b${this.mask() + "0".repeat($a87c5e532014813e$var$constants6.BITS - this.subnetMask)}`);
    }
    /**
     * The first address in the range given by this address' subnet
     * Often referred to as the Network Address.
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ startAddress() {
        return $a87c5e532014813e$var$Address6.fromBigInt(this._startAddress());
    }
    /**
     * The first host address in the range given by this address's subnet ie
     * the first address after the Network Address
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ startAddressExclusive() {
        const adjust = BigInt("1");
        return $a87c5e532014813e$var$Address6.fromBigInt(this._startAddress() + adjust);
    }
    /**
     * Helper function getting end address.
     * @memberof Address6
     * @instance
     * @returns {bigint}
     */ _endAddress() {
        return BigInt(`0b${this.mask() + "1".repeat($a87c5e532014813e$var$constants6.BITS - this.subnetMask)}`);
    }
    /**
     * The last address in the range given by this address' subnet
     * Often referred to as the Broadcast
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ endAddress() {
        return $a87c5e532014813e$var$Address6.fromBigInt(this._endAddress());
    }
    /**
     * The last host address in the range given by this address's subnet ie
     * the last address prior to the Broadcast Address
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ endAddressExclusive() {
        const adjust = BigInt("1");
        return $a87c5e532014813e$var$Address6.fromBigInt(this._endAddress() - adjust);
    }
    /**
     * Return the scope of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getScope() {
        let scope = $a87c5e532014813e$var$constants6.SCOPES[parseInt(this.getBits(12, 16).toString(10), 10)];
        if (this.getType() === "Global unicast" && scope !== "Link local") scope = "Global";
        return scope || "Unknown";
    }
    /**
     * Return the type of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getType() {
        for (const subnet of Object.keys($a87c5e532014813e$var$constants6.TYPES)){
            if (this.isInSubnet(new $a87c5e532014813e$var$Address6(subnet))) return $a87c5e532014813e$var$constants6.TYPES[subnet];
        }
        return "Global unicast";
    }
    /**
     * Return the bits in the given range as a BigInt
     * @memberof Address6
     * @instance
     * @returns {bigint}
     */ getBits(start, end) {
        return BigInt(`0b${this.getBitsBase2(start, end)}`);
    }
    /**
     * Return the bits in the given range as a base-2 string
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getBitsBase2(start, end) {
        return this.binaryZeroPad().slice(start, end);
    }
    /**
     * Return the bits in the given range as a base-16 string
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getBitsBase16(start, end) {
        const length = end - start;
        if (length % 4 !== 0) throw new Error("Length of bits to retrieve must be divisible by four");
        return this.getBits(start, end).toString(16).padStart(length / 4, "0");
    }
    /**
     * Return the bits that are set past the subnet mask length
     * @memberof Address6
     * @instance
     * @returns {String}
     */ getBitsPastSubnet() {
        return this.getBitsBase2(this.subnetMask, $a87c5e532014813e$var$constants6.BITS);
    }
    /**
     * Return the reversed ip6.arpa form of the address
     * @memberof Address6
     * @param {Object} options
     * @param {boolean} options.omitSuffix - omit the "ip6.arpa" suffix
     * @instance
     * @returns {String}
     */ reverseForm(options) {
        if (!options) options = {};
        const characters = Math.floor(this.subnetMask / 4);
        const reversed = this.canonicalForm().replace(/:/g, "").split("").slice(0, characters).reverse().join(".");
        if (characters > 0) {
            if (options.omitSuffix) return reversed;
            return `${reversed}.ip6.arpa.`;
        }
        if (options.omitSuffix) return "";
        return "ip6.arpa.";
    }
    /**
     * Return the correct form of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ correctForm() {
        let i;
        let groups = [];
        let zeroCounter = 0;
        const zeroes = [];
        for(i = 0; i < this.parsedAddress.length; i++){
            const value = parseInt(this.parsedAddress[i], 16);
            if (value === 0) zeroCounter++;
            if (value !== 0 && zeroCounter > 0) {
                if (zeroCounter > 1) zeroes.push([
                    i - zeroCounter,
                    i - 1
                ]);
                zeroCounter = 0;
            }
        }
        // Do we end with a string of zeroes?
        if (zeroCounter > 1) zeroes.push([
            this.parsedAddress.length - zeroCounter,
            this.parsedAddress.length - 1
        ]);
        const zeroLengths = zeroes.map((n)=>n[1] - n[0] + 1);
        if (zeroes.length > 0) {
            const index = zeroLengths.indexOf(Math.max(...zeroLengths));
            groups = $a87c5e532014813e$var$compact(this.parsedAddress, zeroes[index]);
        } else groups = this.parsedAddress;
        for(i = 0; i < groups.length; i++)if (groups[i] !== "compact") groups[i] = parseInt(groups[i], 16).toString(16);
        let correct = groups.join(":");
        correct = correct.replace(/^compact$/, "::");
        correct = correct.replace(/(^compact)|(compact$)/, ":");
        correct = correct.replace(/compact/, "");
        return correct;
    }
    /**
     * Return a zero-padded base-2 string representation of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     * @example
     * var address = new Address6('2001:4860:4001:803::1011');
     * address.binaryZeroPad();
     * // '0010000000000001010010000110000001000000000000010000100000000011
     * //  0000000000000000000000000000000000000000000000000001000000010001'
     */ binaryZeroPad() {
        return this.bigInt().toString(2).padStart($a87c5e532014813e$var$constants6.BITS, "0");
    }
    // TODO: Improve the semantics of this helper function
    parse4in6(address) {
        const groups = address.split(":");
        const lastGroup = groups.slice(-1)[0];
        const address4 = lastGroup.match($a87c5e532014813e$var$constants4.RE_ADDRESS);
        if (address4) {
            this.parsedAddress4 = address4[0];
            this.address4 = new $37Fnt.Address4(this.parsedAddress4);
            for(let i = 0; i < this.address4.groups; i++){
                if (/^0[0-9]+/.test(this.address4.parsedAddress[i])) throw new $kxYqo.AddressError("IPv4 addresses can't have leading zeroes.", address.replace($a87c5e532014813e$var$constants4.RE_ADDRESS, this.address4.parsedAddress.map($a87c5e532014813e$var$spanLeadingZeroes4).join(".")));
            }
            this.v4 = true;
            groups[groups.length - 1] = this.address4.toGroup6();
            address = groups.join(":");
        }
        return address;
    }
    // TODO: Make private?
    parse(address) {
        address = this.parse4in6(address);
        const badCharacters = address.match($a87c5e532014813e$var$constants6.RE_BAD_CHARACTERS);
        if (badCharacters) throw new $kxYqo.AddressError(`Bad character${badCharacters.length > 1 ? "s" : ""} detected in address: ${badCharacters.join("")}`, address.replace($a87c5e532014813e$var$constants6.RE_BAD_CHARACTERS, '<span class="parse-error">$1</span>'));
        const badAddress = address.match($a87c5e532014813e$var$constants6.RE_BAD_ADDRESS);
        if (badAddress) throw new $kxYqo.AddressError(`Address failed regex: ${badAddress.join("")}`, address.replace($a87c5e532014813e$var$constants6.RE_BAD_ADDRESS, '<span class="parse-error">$1</span>'));
        let groups = [];
        const halves = address.split("::");
        if (halves.length === 2) {
            let first = halves[0].split(":");
            let last = halves[1].split(":");
            if (first.length === 1 && first[0] === "") first = [];
            if (last.length === 1 && last[0] === "") last = [];
            const remaining = this.groups - (first.length + last.length);
            if (!remaining) throw new $kxYqo.AddressError("Error parsing groups");
            this.elidedGroups = remaining;
            this.elisionBegin = first.length;
            this.elisionEnd = first.length + this.elidedGroups;
            groups = groups.concat(first);
            for(let i = 0; i < remaining; i++)groups.push("0");
            groups = groups.concat(last);
        } else if (halves.length === 1) {
            groups = address.split(":");
            this.elidedGroups = 0;
        } else throw new $kxYqo.AddressError("Too many :: groups found");
        groups = groups.map((group)=>parseInt(group, 16).toString(16));
        if (groups.length !== this.groups) throw new $kxYqo.AddressError("Incorrect number of groups found");
        return groups;
    }
    /**
     * Return the canonical form of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ canonicalForm() {
        return this.parsedAddress.map($a87c5e532014813e$var$paddedHex).join(":");
    }
    /**
     * Return the decimal form of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ decimal() {
        return this.parsedAddress.map((n)=>parseInt(n, 16).toString(10).padStart(5, "0")).join(":");
    }
    /**
     * Return the address as a BigInt
     * @memberof Address6
     * @instance
     * @returns {bigint}
     */ bigInt() {
        return BigInt(`0x${this.parsedAddress.map($a87c5e532014813e$var$paddedHex).join("")}`);
    }
    /**
     * Return the last two groups of this address as an IPv4 address string
     * @memberof Address6
     * @instance
     * @returns {Address4}
     * @example
     * var address = new Address6('2001:4860:4001::1825:bf11');
     * address.to4().correctForm(); // '24.37.191.17'
     */ to4() {
        const binary = this.binaryZeroPad().split("");
        return $37Fnt.Address4.fromHex(BigInt(`0b${binary.slice(96, 128).join("")}`).toString(16));
    }
    /**
     * Return the v4-in-v6 form of the address
     * @memberof Address6
     * @instance
     * @returns {String}
     */ to4in6() {
        const address4 = this.to4();
        const address6 = new $a87c5e532014813e$var$Address6(this.parsedAddress.slice(0, 6).join(":"), 6);
        const correct = address6.correctForm();
        let infix = "";
        if (!/:$/.test(correct)) infix = ":";
        return correct + infix + address4.address;
    }
    /**
     * Return an object containing the Teredo properties of the address
     * @memberof Address6
     * @instance
     * @returns {Object}
     */ inspectTeredo() {
        /*
        - Bits 0 to 31 are set to the Teredo prefix (normally 2001:0000::/32).
        - Bits 32 to 63 embed the primary IPv4 address of the Teredo server that
          is used.
        - Bits 64 to 79 can be used to define some flags. Currently only the
          higher order bit is used; it is set to 1 if the Teredo client is
          located behind a cone NAT, 0 otherwise. For Microsoft's Windows Vista
          and Windows Server 2008 implementations, more bits are used. In those
          implementations, the format for these 16 bits is "CRAAAAUG AAAAAAAA",
          where "C" remains the "Cone" flag. The "R" bit is reserved for future
          use. The "U" bit is for the Universal/Local flag (set to 0). The "G" bit
          is Individual/Group flag (set to 0). The A bits are set to a 12-bit
          randomly generated number chosen by the Teredo client to introduce
          additional protection for the Teredo node against IPv6-based scanning
          attacks.
        - Bits 80 to 95 contains the obfuscated UDP port number. This is the
          port number that is mapped by the NAT to the Teredo client with all
          bits inverted.
        - Bits 96 to 127 contains the obfuscated IPv4 address. This is the
          public IPv4 address of the NAT with all bits inverted.
        */ const prefix = this.getBitsBase16(0, 32);
        const bitsForUdpPort = this.getBits(80, 96);
        // eslint-disable-next-line no-bitwise
        const udpPort = (bitsForUdpPort ^ BigInt("0xffff")).toString();
        const server4 = $37Fnt.Address4.fromHex(this.getBitsBase16(32, 64));
        const bitsForClient4 = this.getBits(96, 128);
        // eslint-disable-next-line no-bitwise
        const client4 = $37Fnt.Address4.fromHex((bitsForClient4 ^ BigInt("0xffffffff")).toString(16));
        const flagsBase2 = this.getBitsBase2(64, 80);
        const coneNat = (0, (parcelRequire("3iKdL")).testBit)(flagsBase2, 15);
        const reserved = (0, (parcelRequire("3iKdL")).testBit)(flagsBase2, 14);
        const groupIndividual = (0, (parcelRequire("3iKdL")).testBit)(flagsBase2, 8);
        const universalLocal = (0, (parcelRequire("3iKdL")).testBit)(flagsBase2, 9);
        const nonce = BigInt(`0b${flagsBase2.slice(2, 6) + flagsBase2.slice(8, 16)}`).toString(10);
        return {
            prefix: `${prefix.slice(0, 4)}:${prefix.slice(4, 8)}`,
            server4: server4.address,
            client4: client4.address,
            flags: flagsBase2,
            coneNat: coneNat,
            microsoft: {
                reserved: reserved,
                universalLocal: universalLocal,
                groupIndividual: groupIndividual,
                nonce: nonce
            },
            udpPort: udpPort
        };
    }
    /**
     * Return an object containing the 6to4 properties of the address
     * @memberof Address6
     * @instance
     * @returns {Object}
     */ inspect6to4() {
        /*
        - Bits 0 to 15 are set to the 6to4 prefix (2002::/16).
        - Bits 16 to 48 embed the IPv4 address of the 6to4 gateway that is used.
        */ const prefix = this.getBitsBase16(0, 16);
        const gateway = $37Fnt.Address4.fromHex(this.getBitsBase16(16, 48));
        return {
            prefix: prefix.slice(0, 4),
            gateway: gateway.address
        };
    }
    /**
     * Return a v6 6to4 address from a v6 v4inv6 address
     * @memberof Address6
     * @instance
     * @returns {Address6}
     */ to6to4() {
        if (!this.is4()) return null;
        const addr6to4 = [
            "2002",
            this.getBitsBase16(96, 112),
            this.getBitsBase16(112, 128),
            "",
            "/16"
        ].join(":");
        return new $a87c5e532014813e$var$Address6(addr6to4);
    }
    /**
     * Return a byte array
     * @memberof Address6
     * @instance
     * @returns {Array}
     */ toByteArray() {
        const valueWithoutPadding = this.bigInt().toString(16);
        const leadingPad = "0".repeat(valueWithoutPadding.length % 2);
        const value = `${leadingPad}${valueWithoutPadding}`;
        const bytes = [];
        for(let i = 0, length = value.length; i < length; i += 2)bytes.push(parseInt(value.substring(i, i + 2), 16));
        return bytes;
    }
    /**
     * Return an unsigned byte array
     * @memberof Address6
     * @instance
     * @returns {Array}
     */ toUnsignedByteArray() {
        return this.toByteArray().map($a87c5e532014813e$var$unsignByte);
    }
    /**
     * Convert a byte array to an Address6 object
     * @memberof Address6
     * @static
     * @returns {Address6}
     */ static fromByteArray(bytes) {
        return this.fromUnsignedByteArray(bytes.map($a87c5e532014813e$var$unsignByte));
    }
    /**
     * Convert an unsigned byte array to an Address6 object
     * @memberof Address6
     * @static
     * @returns {Address6}
     */ static fromUnsignedByteArray(bytes) {
        const BYTE_MAX = BigInt("256");
        let result = BigInt("0");
        let multiplier = BigInt("1");
        for(let i = bytes.length - 1; i >= 0; i--){
            result += multiplier * BigInt(bytes[i].toString(10));
            multiplier *= BYTE_MAX;
        }
        return $a87c5e532014813e$var$Address6.fromBigInt(result);
    }
    /**
     * Returns true if the address is in the canonical form, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isCanonical() {
        return this.addressMinusSuffix === this.canonicalForm();
    }
    /**
     * Returns true if the address is a link local address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isLinkLocal() {
        // Zeroes are required, i.e. we can't check isInSubnet with 'fe80::/10'
        if (this.getBitsBase2(0, 64) === "1111111010000000000000000000000000000000000000000000000000000000") return true;
        return false;
    }
    /**
     * Returns true if the address is a multicast address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isMulticast() {
        return this.getType() === "Multicast";
    }
    /**
     * Returns true if the address is a v4-in-v6 address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ is4() {
        return this.v4;
    }
    /**
     * Returns true if the address is a Teredo address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isTeredo() {
        return this.isInSubnet(new $a87c5e532014813e$var$Address6("2001::/32"));
    }
    /**
     * Returns true if the address is a 6to4 address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ is6to4() {
        return this.isInSubnet(new $a87c5e532014813e$var$Address6("2002::/16"));
    }
    /**
     * Returns true if the address is a loopback address, false otherwise
     * @memberof Address6
     * @instance
     * @returns {boolean}
     */ isLoopback() {
        return this.getType() === "Loopback";
    }
    // #endregion
    // #region HTML
    /**
     * @returns {String} the address in link form with a default port of 80
     */ href(optionalPort) {
        if (optionalPort === undefined) optionalPort = "";
        else optionalPort = `:${optionalPort}`;
        return `http://[${this.correctForm()}]${optionalPort}/`;
    }
    /**
     * @returns {String} a link suitable for conveying the address via a URL hash
     */ link(options) {
        if (!options) options = {};
        if (options.className === undefined) options.className = "";
        if (options.prefix === undefined) options.prefix = "/#address=";
        if (options.v4 === undefined) options.v4 = false;
        let formFunction = this.correctForm;
        if (options.v4) formFunction = this.to4in6;
        const form = formFunction.call(this);
        if (options.className) return `<a href="${options.prefix}${form}" class="${options.className}">${form}</a>`;
        return `<a href="${options.prefix}${form}">${form}</a>`;
    }
    /**
     * Groups an address
     * @returns {String}
     */ group() {
        if (this.elidedGroups === 0) // The simple case
        return $a87c5e532014813e$var$helpers.simpleGroup(this.address).join(":");
        $a87c5e532014813e$var$assert(typeof this.elidedGroups === "number");
        $a87c5e532014813e$var$assert(typeof this.elisionBegin === "number");
        // The elided case
        const output = [];
        const [left, right] = this.address.split("::");
        if (left.length) output.push(...$a87c5e532014813e$var$helpers.simpleGroup(left));
        else output.push("");
        const classes = [
            "hover-group"
        ];
        for(let i = this.elisionBegin; i < this.elisionBegin + this.elidedGroups; i++)classes.push(`group-${i}`);
        output.push(`<span class="${classes.join(" ")}"></span>`);
        if (right.length) output.push(...$a87c5e532014813e$var$helpers.simpleGroup(right, this.elisionEnd));
        else output.push("");
        if (this.is4()) {
            $a87c5e532014813e$var$assert(this.address4 instanceof $37Fnt.Address4);
            output.pop();
            output.push(this.address4.groupForV6());
        }
        return output.join(":");
    }
    // #endregion
    // #region Regular expressions
    /**
     * Generate a regular expression string that can be used to find or validate
     * all variations of this address
     * @memberof Address6
     * @instance
     * @param {boolean} substringSearch
     * @returns {string}
     */ regularExpressionString(substringSearch = false) {
        let output = [];
        // TODO: revisit why this is necessary
        const address6 = new $a87c5e532014813e$var$Address6(this.correctForm());
        if (address6.elidedGroups === 0) // The simple case
        output.push((0, $8wyMl.simpleRegularExpression)(address6.parsedAddress));
        else if (address6.elidedGroups === $a87c5e532014813e$var$constants6.GROUPS) // A completely elided address
        output.push((0, $8wyMl.possibleElisions)($a87c5e532014813e$var$constants6.GROUPS));
        else {
            // A partially elided address
            const halves = address6.address.split("::");
            if (halves[0].length) output.push((0, $8wyMl.simpleRegularExpression)(halves[0].split(":")));
            $a87c5e532014813e$var$assert(typeof address6.elidedGroups === "number");
            output.push((0, $8wyMl.possibleElisions)(address6.elidedGroups, halves[0].length !== 0, halves[1].length !== 0));
            if (halves[1].length) output.push((0, $8wyMl.simpleRegularExpression)(halves[1].split(":")));
            output = [
                output.join(":")
            ];
        }
        if (!substringSearch) output = [
            "(?=^|",
            $8wyMl.ADDRESS_BOUNDARY,
            "|[^\\w\\:])(",
            ...output,
            ")(?=[^\\w\\:]|",
            $8wyMl.ADDRESS_BOUNDARY,
            "|$)"
        ];
        return output.join("");
    }
    /**
     * Generate a regular expression that can be used to find or validate all
     * variations of this address.
     * @memberof Address6
     * @instance
     * @param {boolean} substringSearch
     * @returns {RegExp}
     */ regularExpression(substringSearch = false) {
        return new RegExp(this.regularExpressionString(substringSearch), "i");
    }
}
module.exports.Address6 = $a87c5e532014813e$var$Address6;

});
parcelRegister("6eDib", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.RE_URL_WITH_PORT = module.exports.RE_URL = module.exports.RE_ZONE_STRING = module.exports.RE_SUBNET_STRING = module.exports.RE_BAD_ADDRESS = module.exports.RE_BAD_CHARACTERS = module.exports.TYPES = module.exports.SCOPES = module.exports.GROUPS = module.exports.BITS = void 0;
module.exports.BITS = 128;
module.exports.GROUPS = 8;
/**
 * Represents IPv6 address scopes
 * @memberof Address6
 * @static
 */ module.exports.SCOPES = {
    0: "Reserved",
    1: "Interface local",
    2: "Link local",
    4: "Admin local",
    5: "Site local",
    8: "Organization local",
    14: "Global",
    15: "Reserved"
};
/**
 * Represents IPv6 address types
 * @memberof Address6
 * @static
 */ module.exports.TYPES = {
    "ff01::1/128": "Multicast (All nodes on this interface)",
    "ff01::2/128": "Multicast (All routers on this interface)",
    "ff02::1/128": "Multicast (All nodes on this link)",
    "ff02::2/128": "Multicast (All routers on this link)",
    "ff05::2/128": "Multicast (All routers in this site)",
    "ff02::5/128": "Multicast (OSPFv3 AllSPF routers)",
    "ff02::6/128": "Multicast (OSPFv3 AllDR routers)",
    "ff02::9/128": "Multicast (RIP routers)",
    "ff02::a/128": "Multicast (EIGRP routers)",
    "ff02::d/128": "Multicast (PIM routers)",
    "ff02::16/128": "Multicast (MLDv2 reports)",
    "ff01::fb/128": "Multicast (mDNSv6)",
    "ff02::fb/128": "Multicast (mDNSv6)",
    "ff05::fb/128": "Multicast (mDNSv6)",
    "ff02::1:2/128": "Multicast (All DHCP servers and relay agents on this link)",
    "ff05::1:2/128": "Multicast (All DHCP servers and relay agents in this site)",
    "ff02::1:3/128": "Multicast (All DHCP servers on this link)",
    "ff05::1:3/128": "Multicast (All DHCP servers in this site)",
    "::/128": "Unspecified",
    "::1/128": "Loopback",
    "ff00::/8": "Multicast",
    "fe80::/10": "Link-local unicast"
};
/**
 * A regular expression that matches bad characters in an IPv6 address
 * @memberof Address6
 * @static
 */ module.exports.RE_BAD_CHARACTERS = /([^0-9a-f:/%])/gi;
/**
 * A regular expression that matches an incorrect IPv6 address
 * @memberof Address6
 * @static
 */ module.exports.RE_BAD_ADDRESS = /([0-9a-f]{5,}|:{3,}|[^:]:$|^:[^:]|\/$)/gi;
/**
 * A regular expression that matches an IPv6 subnet
 * @memberof Address6
 * @static
 */ module.exports.RE_SUBNET_STRING = /\/\d{1,3}(?=%|$)/;
/**
 * A regular expression that matches an IPv6 zone
 * @memberof Address6
 * @static
 */ module.exports.RE_ZONE_STRING = /%.*$/;
module.exports.RE_URL = /^\[{0,1}([0-9a-f:]+)\]{0,1}/;
module.exports.RE_URL_WITH_PORT = /\[([0-9a-f:]+)\]:([0-9]{1,5})/;

});

parcelRegister("f7yJc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.spanAllZeroes = $b02272b88db5d256$var$spanAllZeroes;
module.exports.spanAll = $b02272b88db5d256$var$spanAll;
module.exports.spanLeadingZeroes = $b02272b88db5d256$var$spanLeadingZeroes;
module.exports.simpleGroup = $b02272b88db5d256$var$simpleGroup;
/**
 * @returns {String} the string with all zeroes contained in a <span>
 */ function $b02272b88db5d256$var$spanAllZeroes(s) {
    return s.replace(/(0+)/g, '<span class="zero">$1</span>');
}
/**
 * @returns {String} the string with each character contained in a <span>
 */ function $b02272b88db5d256$var$spanAll(s, offset = 0) {
    const letters = s.split("");
    return letters.map((n, i)=>`<span class="digit value-${n} position-${i + offset}">${$b02272b88db5d256$var$spanAllZeroes(n)}</span>`).join("");
}
function $b02272b88db5d256$var$spanLeadingZeroesSimple(group) {
    return group.replace(/^(0+)/, '<span class="zero">$1</span>');
}
/**
 * @returns {String} the string with leading zeroes contained in a <span>
 */ function $b02272b88db5d256$var$spanLeadingZeroes(address) {
    const groups = address.split(":");
    return groups.map((g)=>$b02272b88db5d256$var$spanLeadingZeroesSimple(g)).join(":");
}
/**
 * Groups an address
 * @returns {String} a grouped address
 */ function $b02272b88db5d256$var$simpleGroup(addressString, offset = 0) {
    const groups = addressString.split(":");
    return groups.map((g, i)=>{
        if (/group-v4/.test(g)) return g;
        return `<span class="hover-group group-${i + offset}">${$b02272b88db5d256$var$spanLeadingZeroesSimple(g)}</span>`;
    });
}

});

parcelRegister("8wyMl", function(module, exports) {
"use strict";
var $634c4a3e5af96e0a$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $634c4a3e5af96e0a$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $634c4a3e5af96e0a$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $634c4a3e5af96e0a$var$__createBinding(result, mod, k);
    }
    $634c4a3e5af96e0a$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ADDRESS_BOUNDARY = void 0;
module.exports.groupPossibilities = $634c4a3e5af96e0a$var$groupPossibilities;
module.exports.padGroup = $634c4a3e5af96e0a$var$padGroup;
module.exports.simpleRegularExpression = $634c4a3e5af96e0a$var$simpleRegularExpression;
module.exports.possibleElisions = $634c4a3e5af96e0a$var$possibleElisions;

const $634c4a3e5af96e0a$var$v6 = $634c4a3e5af96e0a$var$__importStar((parcelRequire("6eDib")));
function $634c4a3e5af96e0a$var$groupPossibilities(possibilities) {
    return `(${possibilities.join("|")})`;
}
function $634c4a3e5af96e0a$var$padGroup(group) {
    if (group.length < 4) return `0{0,${4 - group.length}}${group}`;
    return group;
}
module.exports.ADDRESS_BOUNDARY = "[^A-Fa-f0-9:]";
function $634c4a3e5af96e0a$var$simpleRegularExpression(groups) {
    const zeroIndexes = [];
    groups.forEach((group, i)=>{
        const groupInteger = parseInt(group, 16);
        if (groupInteger === 0) zeroIndexes.push(i);
    });
    // You can technically elide a single 0, this creates the regular expressions
    // to match that eventuality
    const possibilities = zeroIndexes.map((zeroIndex)=>groups.map((group, i)=>{
            if (i === zeroIndex) {
                const elision = i === 0 || i === $634c4a3e5af96e0a$var$v6.GROUPS - 1 ? ":" : "";
                return $634c4a3e5af96e0a$var$groupPossibilities([
                    $634c4a3e5af96e0a$var$padGroup(group),
                    elision
                ]);
            }
            return $634c4a3e5af96e0a$var$padGroup(group);
        }).join(":"));
    // The simplest case
    possibilities.push(groups.map($634c4a3e5af96e0a$var$padGroup).join(":"));
    return $634c4a3e5af96e0a$var$groupPossibilities(possibilities);
}
function $634c4a3e5af96e0a$var$possibleElisions(elidedGroups, moreLeft, moreRight) {
    const left = moreLeft ? "" : ":";
    const right = moreRight ? "" : ":";
    const possibilities = [];
    // 1. elision of everything (::)
    if (!moreLeft && !moreRight) possibilities.push("::");
    // 2. complete elision of the middle
    if (moreLeft && moreRight) possibilities.push("");
    if (moreRight && !moreLeft || !moreRight && moreLeft) // 3. complete elision of one side
    possibilities.push(":");
    // 4. elision from the left side
    possibilities.push(`${left}(:0{1,4}){1,${elidedGroups - 1}}`);
    // 5. elision from the right side
    possibilities.push(`(0{1,4}:){1,${elidedGroups - 1}}${right}`);
    // 6. no elision
    possibilities.push(`(0{1,4}:){${elidedGroups - 1}}0{1,4}`);
    // 7. elision (including sloppy elision) from the middle
    for(let groups = 1; groups < elidedGroups - 1; groups++)for(let position = 1; position < elidedGroups - groups; position++)possibilities.push(`(0{1,4}:){${position}}:(0{1,4}:){${elidedGroups - position - groups - 1}}0{1,4}`);
    return $634c4a3e5af96e0a$var$groupPossibilities(possibilities);
}

});




parcelRegister("8stA2", function(module, exports) {
"use strict";
var $6287e24171925301$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.role = module.exports.brand = module.exports.customerOverview = module.exports.customer = module.exports.user = module.exports.feeTypes = module.exports.settlementTotals = module.exports.settlementsPending = module.exports.settlementsReady = module.exports.serviceCategories = module.exports.operators = module.exports.customerOverviews = module.exports.users = module.exports.roles = module.exports.productTypes = module.exports.permissions = module.exports.countries = module.exports.channels = module.exports.brands = void 0;

const $6287e24171925301$var$brands_1 = $6287e24171925301$var$__importDefault((parcelRequire("6pnc4")));
module.exports.brands = $6287e24171925301$var$brands_1.default;

const $6287e24171925301$var$channels_1 = $6287e24171925301$var$__importDefault((parcelRequire("fx7oo")));
module.exports.channels = $6287e24171925301$var$channels_1.default;

const $6287e24171925301$var$countries_1 = $6287e24171925301$var$__importDefault((parcelRequire("9bZfx")));
module.exports.countries = $6287e24171925301$var$countries_1.default;

const $6287e24171925301$var$customerOverviews_1 = $6287e24171925301$var$__importDefault((parcelRequire("awK0O")));
module.exports.customerOverviews = $6287e24171925301$var$customerOverviews_1.default;

const $6287e24171925301$var$customers_1 = $6287e24171925301$var$__importDefault((parcelRequire("5M0IH")));

const $6287e24171925301$var$feeTypes_1 = $6287e24171925301$var$__importDefault((parcelRequire("jxTlk")));
module.exports.feeTypes = $6287e24171925301$var$feeTypes_1.default;

const $6287e24171925301$var$operators_1 = $6287e24171925301$var$__importDefault((parcelRequire("10G57")));
module.exports.operators = $6287e24171925301$var$operators_1.default;

const $6287e24171925301$var$permissions_1 = $6287e24171925301$var$__importDefault((parcelRequire("abm0u")));
module.exports.permissions = $6287e24171925301$var$permissions_1.default;

const $6287e24171925301$var$productTypes_1 = $6287e24171925301$var$__importDefault((parcelRequire("g4JFl")));
module.exports.productTypes = $6287e24171925301$var$productTypes_1.default;

const $6287e24171925301$var$roles_1 = $6287e24171925301$var$__importDefault((parcelRequire("18Yn6")));
module.exports.roles = $6287e24171925301$var$roles_1.default;

const $6287e24171925301$var$serviceCategories_1 = $6287e24171925301$var$__importDefault((parcelRequire("9xVGO")));
module.exports.serviceCategories = $6287e24171925301$var$serviceCategories_1.default;

const $6287e24171925301$var$settlementTotals_1 = $6287e24171925301$var$__importDefault((parcelRequire("k0jpl")));
module.exports.settlementTotals = $6287e24171925301$var$settlementTotals_1.default;

const $6287e24171925301$var$settlementsPending_1 = $6287e24171925301$var$__importDefault((parcelRequire("7stlI")));
module.exports.settlementsPending = $6287e24171925301$var$settlementsPending_1.default;

const $6287e24171925301$var$settlementsReady_1 = $6287e24171925301$var$__importDefault((parcelRequire("hEJgC")));
module.exports.settlementsReady = $6287e24171925301$var$settlementsReady_1.default;

const $6287e24171925301$var$users_1 = $6287e24171925301$var$__importDefault((parcelRequire("lSJPF")));
module.exports.users = $6287e24171925301$var$users_1.default;
const $6287e24171925301$var$user = (userId)=>$6287e24171925301$var$users_1.default.find((user)=>user.id === userId);
module.exports.user = $6287e24171925301$var$user;
const $6287e24171925301$var$customer = (customerId)=>$6287e24171925301$var$customers_1.default.find((customer)=>customer.id === customerId);
module.exports.customer = $6287e24171925301$var$customer;
const $6287e24171925301$var$customerOverview = (customerId)=>$6287e24171925301$var$customerOverviews_1.default.find((customerOverview)=>customerOverview.id === customerId);
module.exports.customerOverview = $6287e24171925301$var$customerOverview;
const $6287e24171925301$var$brand = (brandId)=>$6287e24171925301$var$brands_1.default.find((brand)=>brand.id === brandId);
module.exports.brand = $6287e24171925301$var$brand;
const $6287e24171925301$var$role = (id)=>$6287e24171925301$var$roles_1.default.find((role)=>role.id === id);
module.exports.role = $6287e24171925301$var$role;

});
parcelRegister("6pnc4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Brands = void 0;
var $4aa711ad4c48010b$var$Brands;
(function(Brands) {
    Brands["TELIA_NO"] = "TELIA_NO";
    Brands["TELIA_SE"] = "TELIA_SE";
})($4aa711ad4c48010b$var$Brands = module.exports.Brands || (module.exports.Brands = {}));
const $4aa711ad4c48010b$var$brands = [
    {
        id: $4aa711ad4c48010b$var$Brands.TELIA_NO,
        name: "Telia (NO)",
        organizationNumber: "981929055",
        countryId: "NO",
        currencyCode: "NOK"
    },
    {
        id: $4aa711ad4c48010b$var$Brands.TELIA_SE,
        name: "Telia (SE)",
        organizationNumber: "556430-0142",
        countryId: "SE",
        currencyCode: "SEK"
    }
];
module.exports.default = $4aa711ad4c48010b$var$brands;

});

parcelRegister("fx7oo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $b4efac0ae0ed8c2f$var$channels = [
    {
        id: "COMMERCIAL",
        name: "Commercial",
        description: "Channel for commercial notifications"
    },
    {
        id: "SUPPORT",
        name: "Support",
        description: "Channel for support related notifications"
    },
    {
        id: "TECHNICAL",
        name: "Technical",
        description: "Channel for technical announcements"
    },
    {
        id: "OPERATIONS",
        name: "Operations",
        description: "Channel for operation announcements"
    }
];
module.exports.default = $b4efac0ae0ed8c2f$var$channels;

});

parcelRegister("9bZfx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $6b14a703ad6fe649$var$countries = [
    {
        id: "SE",
        countryCode: "46",
        name: "Sweden"
    },
    {
        id: "NO",
        countryCode: "47",
        name: "Norway"
    }
];
module.exports.default = $6b14a703ad6fe649$var$countries;

});

parcelRegister("awK0O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $7aa0959b3d73dd83$var$customerOverviews = [
    {
        id: "10001",
        countryId: "NO",
        brandId: "TELIA_NO",
        name: "Mock Customer",
        productOverviews: [
            {
                productOverviewType: "generic",
                productTypeId: "POSITIONING",
                customerId: "10502",
                contractId: "10503",
                productId: "10504",
                state: "ACTIVE"
            },
            {
                productOverviewType: "rbm",
                productTypeId: "RBM_TELIA_NO",
                customerId: "10302",
                contractId: "10303",
                productId: "10304",
                state: "ACTIVE",
                rbmAgentOwner: "mock"
            },
            {
                productOverviewType: "reservedOa",
                productTypeId: "RESERVED_OA",
                customerId: "10402",
                contractId: "10403",
                productId: "10404",
                state: "ACTIVE",
                reservedOas: [
                    "mock1",
                    "mock2"
                ]
            },
            {
                productOverviewType: "accessNumberRange",
                productTypeId: "MO_LONG_NUMBER_RANGE",
                customerId: "10202",
                contractId: "10203",
                productId: "10204",
                state: "ACTIVE",
                accessNumberRange: {
                    from: "11112",
                    to: "11115"
                }
            },
            {
                productOverviewType: "accessNumber",
                productTypeId: "SMS_BULK",
                customerId: "10102",
                contractId: "10103",
                productId: "10104",
                state: "ACTIVE",
                accessNumber: "11111"
            }
        ]
    }
];
module.exports.default = $7aa0959b3d73dd83$var$customerOverviews;

});

parcelRegister("5M0IH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $4341fe65b79eb91b$var$customers = [
    {
        id: "123",
        countryId: "NO",
        brandId: "TELIA_NO",
        company: {
            id: "10101",
            brandId: "TELIA_NO",
            countryId: "NO",
            organizationNumber: "123456789",
            name: "Test AB",
            businessAddress: {
                streetAddress: "Testv\xe4gen 1",
                postCode: "12345",
                city: "Test",
                country: "Norway"
            },
            differentBillingAddress: false
        }
    }
];
module.exports.default = $4341fe65b79eb91b$var$customers;

});

parcelRegister("jxTlk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $e3ac0755d215a222$var$feeTypes = [
    {
        id: "RECEIVE_ON_LONG_NUMBER_MONTHLY",
        name: "Monthly fee \xb7 Receive on Long Number",
        feeCategory: "MONTHLY_FEE",
        description: "Monthly fee for receive on long number feature",
        overridable: true
    },
    {
        id: "RECEIVE_ON_LONG_NUMBER_ESTABLISHMENT",
        name: "Establishment fee \xb7 Receive on Long Number",
        feeCategory: "ESTABLISHMENT_FEE",
        description: "Establishment fee for receive on long number feature",
        overridable: true
    },
    {
        id: "RBM_BASIC_MESSAGE",
        name: "RBM basic message",
        feeCategory: "TRAFFIC_FEE",
        description: "RBM basic message traffic fee",
        overridable: false
    },
    {
        id: "ESTABLISHMENT",
        name: "Establishment fee",
        feeCategory: "ESTABLISHMENT_FEE",
        description: "Product establishment fee",
        overridable: true
    },
    {
        id: "MONTHLY",
        name: "Monthly fee",
        feeCategory: "MONTHLY_FEE",
        description: "Product monthly fee",
        overridable: true
    },
    {
        id: "RBM_A2P_CONVERSATION",
        name: "RBM A2P conversation",
        feeCategory: "TRAFFIC_FEE",
        description: "RBM conversation traffic fee",
        overridable: false
    },
    {
        id: "DOMESTIC",
        name: "Off net domestic",
        feeCategory: "TRAFFIC_FEE",
        description: "SMS domestic net traffic fee",
        overridable: false
    },
    {
        id: "FOREIGN",
        name: "Off net foreign",
        feeCategory: "TRAFFIC_FEE",
        description: "SMS foreign net traffic fee",
        overridable: false
    },
    {
        id: "HOME",
        name: "On net",
        feeCategory: "TRAFFIC_FEE",
        description: "SMS home net traffic fee",
        overridable: false
    },
    {
        id: "BLOCKED",
        name: "Blocked",
        feeCategory: "TRAFFIC_FEE",
        description: "SMS fee for blocked traffic",
        overridable: false
    },
    {
        id: "RECEIVE_ON_SHORT_NUMBER_MONTHLY",
        name: "Monthly fee \xb7 Receive on Short Number",
        feeCategory: "MONTHLY_FEE",
        description: "Monthly fee for receive on short number feature",
        overridable: true
    },
    {
        id: "RBM_SINGLE_MESSAGE",
        name: "RBM single message",
        feeCategory: "TRAFFIC_FEE",
        description: "RBM single message traffic fee",
        overridable: false
    },
    {
        id: "RBM_AGENT",
        name: "RBM agent",
        feeCategory: "MONTHLY_FEE",
        description: "RBM active agent monthly fee",
        overridable: false
    },
    {
        id: "RECEIVE_ON_SHORT_NUMBER_ESTABLISHMENT",
        name: "Establishment fee \xb7 Receive on Short Number",
        feeCategory: "ESTABLISHMENT_FEE",
        description: "Establishment fee for receive on short number feature",
        overridable: true
    }
];
module.exports.default = $e3ac0755d215a222$var$feeTypes;

});

parcelRegister("10G57", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $0bc66f1187137605$var$operators = [
    {
        id: "some-operator",
        codes: [
            100,
            101,
            102
        ]
    },
    {
        id: "tts",
        codes: [
            704,
            757,
            869,
            842,
            892
        ]
    },
    {
        id: "mycall",
        codes: [
            734
        ]
    },
    {
        id: "phonero",
        codes: [
            707,
            708
        ]
    },
    {
        id: "onecall",
        codes: [
            848
        ]
    },
    {
        id: "telia",
        codes: [
            702,
            703,
            721,
            722,
            725,
            736,
            749,
            755,
            809,
            815,
            817,
            879,
            885,
            886,
            896,
            898
        ]
    }
];
module.exports.default = $0bc66f1187137605$var$operators;

});

parcelRegister("abm0u", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $769c008f2d4a5ea2$var$permissions = [
    {
        id: "ALL_CUSTOMERS_MANAGE",
        category: "TELIA",
        name: "Manage customers",
        description: "Allows managing customers"
    },
    {
        id: "ALL_CUSTOMERS_READ",
        category: "TELIA",
        name: "See customers",
        description: "Provides read access to customers list"
    },
    {
        id: "CUSTOMER_COMPANY_MANAGE",
        category: "CUSTOMER",
        name: "Edit organization info",
        description: "Allows managing the customers company information"
    },
    {
        id: "CUSTOMER_CONTRACTS_MANAGE",
        category: "CUSTOMER",
        name: "Manage contracts",
        description: "Allows creating customer contracts"
    },
    {
        id: "CUSTOMER_PRODUCTS_MANAGE",
        category: "CUSTOMER",
        name: "Manage products of a contract",
        description: "Allows managing customers products"
    },
    {
        id: "CUSTOMER_SETTLEMENTS_READ",
        category: "CUSTOMER",
        name: "Read settlements",
        description: "Provides read access to the own customer settlements"
    },
    {
        id: "CUSTOMER_TECHNICAL_MANAGE",
        category: "CUSTOMER",
        name: "Technical configuration",
        description: "Allows managing customers technical configuration"
    },
    {
        id: "CUSTOMER_USERS_MANAGE",
        category: "CUSTOMER",
        name: "Manage users",
        description: "Allows managing the customers users"
    },
    {
        id: "PERMISSIONS_MANAGE",
        category: "AUTH",
        name: "Manage authZ permissions",
        description: "Allows managing the Permission definitions"
    },
    {
        id: "ROLES_ASSUME",
        category: "TELIA",
        name: "Impersonate user",
        description: "Allows user to simulate having other roles"
    },
    {
        id: "ROLES_MANAGE",
        category: "AUTH",
        name: "Manage authZ roles",
        description: "Allows adding permissions to roles"
    },
    {
        id: "SETTLEMENTS_ADJUST",
        category: "SETTLEMENT",
        name: "Adjust settlements",
        description: "Allows adjusting all customers settlements and pre-approving them"
    },
    {
        id: "SETTLEMENTS_APPROVE",
        category: "SETTLEMENT",
        name: "Approve & invoice settlement",
        description: "Permission needed for the final approval of settlements"
    },
    {
        id: "TELIA_USERS_MANAGE",
        category: "TELIA",
        name: "Manage Telia users",
        description: "Allows managing Telia users, who are not limited to any specific customer"
    }
];
module.exports.default = $769c008f2d4a5ea2$var$permissions;

});

parcelRegister("g4JFl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $bb407156b6cf3d60$var$productTypes = [
    {
        id: "POSITIONING",
        name: "Positioning",
        countryId: "NO",
        brandId: "TELIA_NO",
        canSend: false,
        description: "description",
        feeModels: [
            {
                description: "Fee model for SMS_BULK",
                startDate: "2022-09-01",
                fees: [
                    {
                        feeTypeId: "MONTHLY",
                        description: "Monthly fee",
                        fixedAmount: 100,
                        steps: []
                    },
                    {
                        feeTypeId: "ESTABLISHMENT",
                        description: "Establishment Fee",
                        fixedAmount: 50,
                        steps: []
                    }
                ]
            }
        ]
    },
    {
        id: "SMS_BULK",
        countryId: "NO",
        brandId: "TELIA_NO",
        canSend: true,
        feeModels: [
            {
                description: "Fee model for SMS_BULK",
                startDate: "2022-09-01",
                fees: [
                    {
                        feeTypeId: "MONTHLY",
                        description: "Monthly fee",
                        fixedAmount: 1000,
                        steps: []
                    },
                    {
                        feeTypeId: "ESTABLISHMENT",
                        description: "Establishment Fee",
                        fixedAmount: 500,
                        steps: []
                    }
                ]
            }
        ]
    },
    {
        id: "SMS_BULK_TELIA_SE",
        countryId: "SE",
        brandId: "TELIA_SE",
        canSend: true,
        feeModels: [
            {
                description: "Fee model for SMS_BULK",
                startDate: "2022-09-01",
                fees: [
                    {
                        feeTypeId: "MONTHLY",
                        description: "Monthly fee",
                        fixedAmount: 1000,
                        steps: []
                    },
                    {
                        feeTypeId: "ESTABLISHMENT",
                        description: "Establishment Fee",
                        fixedAmount: 500,
                        steps: []
                    }
                ]
            }
        ]
    },
    {
        id: "MO_LONG_NUMBER",
        countryId: "NO",
        brandId: "TELIA_NO",
        name: "SMS Long Number",
        description: "Receive MO SMS via Long Numbers",
        feeModels: [
            {
                description: "Fee model for MO_LONG_NUMBER",
                startDate: "2022-09-01",
                fees: [
                    {
                        feeTypeId: "MONTHLY",
                        description: "Monthly fee",
                        fixedAmount: 0,
                        steps: []
                    },
                    {
                        feeTypeId: "ESTABLISHMENT",
                        description: "Establishment Fee",
                        fixedAmount: 0,
                        steps: []
                    }
                ]
            }
        ]
    }
];
module.exports.default = $bb407156b6cf3d60$var$productTypes;

});

parcelRegister("18Yn6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l8GLF = parcelRequire("l8GLF");
const $0d555e53239f2603$var$roles = [
    {
        id: "CUSTOMER_FINANCIAL",
        userType: $l8GLF.UserType.CUSTOMER,
        name: "Financial",
        description: "Role for customers side financial reports",
        permissions: [
            "CUSTOMER_SETTLEMENTS_READ",
            "CUSTOMER_STATISTICS_REPORT"
        ]
    },
    {
        id: "CUSTOMER_USER",
        userType: $l8GLF.UserType.CUSTOMER,
        name: "User",
        description: "Role for reading customer info",
        permissions: [
            "CUSTOMER_STATISTICS_REPORT"
        ]
    },
    {
        id: "CUSTOMER_ADMIN",
        userType: $l8GLF.UserType.CUSTOMER,
        name: "Administrator",
        description: "Role for managing customer options",
        permissions: [
            "CUSTOMER_SETTLEMENTS_READ",
            "CUSTOMER_USERS_MANAGE",
            "CUSTOMER_STATISTICS_REPORT"
        ]
    },
    {
        id: "CUSTOMER_TECHNICAL",
        userType: $l8GLF.UserType.CUSTOMER,
        name: "Technical",
        description: "Role for customers side technical configuration",
        permissions: [
            "CUSTOMER_TECHNICAL_MANAGE",
            "CUSTOMER_STATISTICS_REPORT"
        ]
    },
    {
        id: "TELIA_ADMIN",
        userType: $l8GLF.UserType.TELIA,
        name: "Administrator",
        description: "Role for managing all customers and Telia configurations",
        permissions: [
            "ALL_CUSTOMERS_READ",
            "ALL_CUSTOMERS_MANAGE",
            "ROLES_ASSUME",
            "CUSTOMER_COMPANY_MANAGE",
            "CUSTOMER_CONTRACTS_MANAGE",
            "CUSTOMER_PRODUCTS_MANAGE",
            "CUSTOMER_SETTLEMENTS_READ",
            "CUSTOMER_TECHNICAL_MANAGE",
            "CUSTOMER_USERS_MANAGE",
            "CUSTOMER_STATISTICS_REPORT",
            "TELIA_USERS_MANAGE",
            "ACCESS_NUMBERS_MANAGE",
            "MESSAGE_CHANNELS_MANAGE",
            "RESERVED_OA_MANAGE"
        ]
    },
    {
        id: "TELIA_USER",
        userType: $l8GLF.UserType.TELIA,
        name: "User",
        description: "Role for managing all customers",
        permissions: [
            "ALL_CUSTOMERS_READ",
            "CUSTOMER_COMPANY_MANAGE",
            "CUSTOMER_PRODUCTS_MANAGE",
            "CUSTOMER_SETTLEMENTS_READ",
            "CUSTOMER_USERS_MANAGE",
            "CUSTOMER_STATISTICS_REPORT",
            "ROLES_ASSUME",
            "CUSTOMER_CONTRACTS_MANAGE",
            "ACCESS_NUMBERS_MANAGE",
            "ALL_CUSTOMERS_MANAGE"
        ]
    },
    {
        id: "TELIA_APPROVER",
        userType: $l8GLF.UserType.TELIA,
        name: "Settlement approver",
        description: "Role for approving or rejecting settlements",
        permissions: [
            "SETTLEMENTS_APPROVE"
        ]
    },
    {
        id: "TELIA_ADJUSTER",
        userType: $l8GLF.UserType.TELIA,
        name: "Settlement adjuster",
        description: "Role for adjusting and pre-approving settlements",
        permissions: [
            "SETTLEMENTS_ADJUST"
        ]
    }
];
module.exports.default = $0d555e53239f2603$var$roles;

});

parcelRegister("9xVGO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $6f33f20f284555b2$var$serviceCategories = [
    {
        id: "00",
        name: "Unspecified",
        types: [
            {
                id: "00000",
                typeId: "000",
                name: "Unspecified by merchant",
                invoiceText: "Uspesifisert"
            }
        ]
    }
];
module.exports.default = $6f33f20f284555b2$var$serviceCategories;

});

parcelRegister("k0jpl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $e902dcba75284559$var$settlementTotals = [
    {
        period: "202201",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 356108,
                INTERNAL: 116009
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 40000,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 65000,
                INTERNAL: 0
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 1497,
                INTERNAL: 10998
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 1500,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 248111,
                INTERNAL: 105011
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202101",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202202",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 331149,
                INTERNAL: 136019.5
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 40000,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 40000,
                INTERNAL: 0
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 1497,
                INTERNAL: 10998
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 1500,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 248111,
                INTERNAL: 125021.5
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202102",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 250997,
                INTERNAL: 120794.6
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 1497,
                INTERNAL: 10998
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 249500,
                INTERNAL: 109796.6
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202203",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 331108,
                INTERNAL: 128105.07999999999
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 40000,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 40000,
                INTERNAL: 0
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 1497,
                INTERNAL: 10998
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 1500,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 248111,
                INTERNAL: 117107.07999999999
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202103",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 250997,
                INTERNAL: 495317.6
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 1497,
                INTERNAL: 10998
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 249500,
                INTERNAL: 484319.6
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202204",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 331108,
                INTERNAL: 1073106.1600000001
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 40000,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 40000,
                INTERNAL: 0
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 1497,
                INTERNAL: 10998
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 1500,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 248111,
                INTERNAL: 1062108.1600000001
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202104",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202205",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 330316,
                INTERNAL: 155404.96
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 52037.020000000004
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 5000,
                INTERNAL: 12500
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 0,
                INTERNAL: 10998
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 211000,
                INTERNAL: 76214.94
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202105",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 299608,
                INTERNAL: 113498
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 45000,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 1497,
                INTERNAL: 10998
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 2500,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 249500,
                INTERNAL: 102500
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202206",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 226000,
                INTERNAL: 182620.74
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 10000,
                INTERNAL: 32500
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 51000
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 5000,
                INTERNAL: 2500
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 0,
                INTERNAL: 10998
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 211000,
                INTERNAL: 85622.74
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202106",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 269997,
                INTERNAL: 557200.4
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 20000,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 1497,
                INTERNAL: 10998
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 1500,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 247000,
                INTERNAL: 546202.4
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202207",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 226500,
                INTERNAL: 153724.65
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 0,
                INTERNAL: 45000
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 10000,
                INTERNAL: 15000
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 1000,
                INTERNAL: 1000
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 5000,
                INTERNAL: 2500
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 0,
                INTERNAL: 10998
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 0,
                INTERNAL: 1500
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 208500,
                INTERNAL: 77726.65000000001
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202107",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 271108,
                INTERNAL: 123500.4
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 20000,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 1497,
                INTERNAL: 10998
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 1500,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 247000,
                INTERNAL: 112502.4
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202208",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 294037.02,
                INTERNAL: 127502.74
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 0,
                INTERNAL: 20000
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 24537.02,
                INTERNAL: 15000
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 1000,
                INTERNAL: 1000
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 35000,
                INTERNAL: 2500
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 0,
                INTERNAL: 10998
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 0,
                INTERNAL: 500
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 233500,
                INTERNAL: 77504.74
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202108",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 399715,
                INTERNAL: 116124.82
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 110000,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 1497,
                INTERNAL: 10998
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 1500,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 285611,
                INTERNAL: 40005.82
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202209",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 302000,
                INTERNAL: 157554.08
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 0,
                INTERNAL: 20000
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 10000,
                INTERNAL: 7500
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 1000,
                INTERNAL: 1000
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 25000,
                INTERNAL: 40000
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 0,
                INTERNAL: 10998
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 0,
                INTERNAL: 500
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 266000,
                INTERNAL: 77556.08
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202109",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 298608,
                INTERNAL: 116000.4
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 40000,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 1497,
                INTERNAL: 10998
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 1500,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 255611,
                INTERNAL: 105002.4
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202210",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 264498,
                INTERNAL: 125030.04000000001
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 0,
                INTERNAL: 20000
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 7500,
                INTERNAL: 7500
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 1000,
                INTERNAL: 1000
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 30000,
                INTERNAL: 7500
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 2498,
                INTERNAL: 10998
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 0,
                INTERNAL: 500
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 223500,
                INTERNAL: 77532.04000000001
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202110",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 291108,
                INTERNAL: 130281.09
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 40000,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 1497,
                INTERNAL: 10998
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 1500,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 248111,
                INTERNAL: 119283.09
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202211",
        isComplete: true,
        isApproved: true,
        products: []
    },
    {
        period: "202111",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 291108,
                INTERNAL: 116033.64
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 40000,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 1497,
                INTERNAL: 10998
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 1500,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 248111,
                INTERNAL: 105035.64
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    },
    {
        period: "202212",
        isComplete: false,
        isApproved: false,
        products: []
    },
    {
        period: "202112",
        isComplete: true,
        isApproved: true,
        products: [
            {
                productId: "ALL",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_AT",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "POSITIONING",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA_AT_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_EVENT_TELIA_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RESERVED_OA",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_DIRECT_CHARGE_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "RBM_TELIA_SE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "MO_LONG_NUMBER_RANGE",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK",
                EXTERNAL: 0,
                INTERNAL: 0
            },
            {
                productId: "SMS_BULK_TELIA_AT_NO",
                EXTERNAL: 0,
                INTERNAL: 0
            }
        ]
    }
];
module.exports.default = $e902dcba75284559$var$settlementTotals;

});

parcelRegister("7stlI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $56e1ea100510a281$var$settlements = [
    {
        id: "11111",
        date: new Date("2023-02-08T13:17:36.064Z"),
        state: "PENDING",
        isComplete: true,
        yearMonth: "202301",
        currencyCode: "NOK",
        customer: {
            id: "22222",
            countryId: "NO",
            brandId: "TELIA_NO",
            company: {
                id: "22222",
                name: "test company 1",
                organizationNumber: "33333",
                countryId: "NO",
                brandId: "TELIA_NO"
            }
        },
        contract: {
            id: "44444",
            name: "test contract 1",
            type: "EXTERNAL",
            invoiceIncludeVat: true,
            invoiceReference: "test invoiceReference",
            invoiceAccountId: "test invoiceAccountId",
            comment: "test comment 1"
        },
        summary: {
            settlementTotal: 12500,
            adjustmentTotal: 100,
            totalExclVat: 12600,
            vat: 3125,
            vatPercentage: 25,
            totalInclVat: 15725
        },
        adjustments: [],
        stateAction: {
            action: "REJECT",
            comment: "charge some fee"
        },
        productTypeSummaries: [
            {
                productTypeId: "SMS_BULK",
                fees: [
                    {
                        feeId: "MONTHLY",
                        type: "MONTHLY",
                        quantity: 5,
                        fee: 2500,
                        total: 12500
                    }
                ],
                total: 12500
            }
        ],
        productDetails: [
            {
                productDetailId: "004",
                productId: "20064",
                productTypeId: "SMS_BULK",
                total: 2500,
                fees: [
                    {
                        feeId: "MONTHLY",
                        type: "MONTHLY",
                        quantity: 1,
                        fee: 2500,
                        total: 2500
                    }
                ]
            },
            {
                productDetailId: "200",
                productId: "20062",
                productTypeId: "SMS_BULK",
                total: 2500,
                fees: [
                    {
                        feeId: "MONTHLY",
                        type: "MONTHLY",
                        quantity: 1,
                        fee: 2500,
                        total: 2500
                    }
                ]
            },
            {
                productDetailId: "206",
                productId: "20067",
                productTypeId: "SMS_BULK",
                total: 2500,
                fees: [
                    {
                        feeId: "MONTHLY",
                        type: "MONTHLY",
                        quantity: 1,
                        fee: 2500,
                        total: 2500
                    }
                ]
            },
            {
                productDetailId: "203",
                productId: "20065",
                productTypeId: "SMS_BULK",
                total: 2500,
                fees: [
                    {
                        feeId: "MONTHLY",
                        type: "MONTHLY",
                        quantity: 1,
                        fee: 2500,
                        total: 2500
                    }
                ]
            },
            {
                productDetailId: "205",
                productId: "20066",
                productTypeId: "SMS_BULK",
                total: 2500,
                fees: [
                    {
                        feeId: "MONTHLY",
                        type: "MONTHLY",
                        quantity: 1,
                        fee: 2500,
                        total: 2500
                    }
                ]
            }
        ]
    },
    {
        id: "00000",
        date: new Date("2023-02-08T13:17:38.522Z"),
        state: "PENDING",
        stateAction: undefined,
        yearMonth: "202301",
        currencyCode: "NOK",
        isComplete: true,
        customer: {
            id: "99999",
            countryId: "NO",
            brandId: "TELIA_NO",
            company: {
                id: "99999",
                name: "test company 2",
                organizationNumber: "88888",
                countryId: "NO",
                brandId: "TELIA_NO"
            }
        },
        contract: {
            id: "77777",
            name: "test contract 2",
            type: "EXTERNAL",
            invoiceIncludeVat: false,
            invoiceReference: "test invoiceReference 2",
            invoiceAccountId: "test invoiceAccountId 2",
            comment: "test comment 2"
        },
        summary: {
            settlementTotal: 2500,
            adjustmentTotal: 0,
            totalExclVat: 2500,
            vat: 0,
            vatPercentage: 0,
            totalInclVat: 2500
        },
        productTypeSummaries: [
            {
                productTypeId: "SMS_BULK",
                fees: [
                    {
                        feeId: "MONTHLY",
                        type: "MONTHLY",
                        quantity: 1,
                        fee: 2500,
                        total: 2500
                    }
                ],
                total: 2500
            }
        ],
        adjustments: [],
        productDetails: [
            {
                productDetailId: "26185",
                productId: "2777",
                productTypeId: "SMS_BULK",
                total: 2500,
                fees: [
                    {
                        feeId: "MONTHLY",
                        type: "MONTHLY",
                        quantity: 1,
                        fee: 2500,
                        total: 2500
                    }
                ]
            }
        ]
    }
];
module.exports.default = $56e1ea100510a281$var$settlements;

});

parcelRegister("hEJgC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $cda949365d0a7d99$var$settlements = [
    {
        id: "11111",
        date: new Date("2023-02-08T13:17:36.064Z"),
        state: "READY_FOR_APPROVAL",
        isComplete: true,
        yearMonth: "202301",
        currencyCode: "NOK",
        customer: {
            id: "22222",
            countryId: "NO",
            brandId: "TELIA_NO",
            company: {
                id: "22222",
                name: "test company 1",
                organizationNumber: "33333",
                countryId: "NO",
                brandId: "TELIA_NO"
            }
        },
        contract: {
            id: "44444",
            name: "test contract 1",
            type: "EXTERNAL",
            invoiceIncludeVat: true,
            invoiceReference: "test invoiceReference",
            invoiceAccountId: "test invoiceAccountId",
            comment: "test comment 1"
        },
        summary: {
            settlementTotal: 12500,
            adjustmentTotal: 100,
            totalExclVat: 12600,
            vat: 3125,
            vatPercentage: 25,
            totalInclVat: 15725
        },
        adjustments: [],
        stateAction: {
            action: "REJECT",
            comment: "charge some fee"
        },
        productTypeSummaries: [
            {
                productTypeId: "SMS_BULK",
                fees: [
                    {
                        feeId: "MONTHLY",
                        type: "MONTHLY",
                        quantity: 5,
                        fee: 2500,
                        total: 12500
                    }
                ],
                total: 12500
            }
        ],
        productDetails: [
            {
                productDetailId: "004",
                productId: "20064",
                productTypeId: "SMS_BULK",
                total: 2500,
                fees: [
                    {
                        feeId: "MONTHLY",
                        type: "MONTHLY",
                        quantity: 1,
                        fee: 2500,
                        total: 2500
                    }
                ]
            },
            {
                productDetailId: "200",
                productId: "20062",
                productTypeId: "SMS_BULK",
                total: 2500,
                fees: [
                    {
                        feeId: "MONTHLY",
                        type: "MONTHLY",
                        quantity: 1,
                        fee: 2500,
                        total: 2500
                    }
                ]
            },
            {
                productDetailId: "206",
                productId: "20067",
                productTypeId: "SMS_BULK",
                total: 2500,
                fees: [
                    {
                        feeId: "MONTHLY",
                        type: "MONTHLY",
                        quantity: 1,
                        fee: 2500,
                        total: 2500
                    }
                ]
            },
            {
                productDetailId: "203",
                productId: "20065",
                productTypeId: "SMS_BULK",
                total: 2500,
                fees: [
                    {
                        feeId: "MONTHLY",
                        type: "MONTHLY",
                        quantity: 1,
                        fee: 2500,
                        total: 2500
                    }
                ]
            },
            {
                productDetailId: "205",
                productId: "20066",
                productTypeId: "SMS_BULK",
                total: 2500,
                fees: [
                    {
                        feeId: "MONTHLY",
                        type: "MONTHLY",
                        quantity: 1,
                        fee: 2500,
                        total: 2500
                    }
                ]
            }
        ]
    },
    {
        id: "00000",
        date: new Date("2023-02-08T13:17:38.522Z"),
        state: "READY_FOR_APPROVAL",
        stateAction: undefined,
        yearMonth: "202301",
        currencyCode: "NOK",
        isComplete: true,
        customer: {
            id: "99999",
            countryId: "NO",
            brandId: "TELIA_NO",
            company: {
                id: "99999",
                name: "test company 2",
                organizationNumber: "88888",
                countryId: "NO",
                brandId: "TELIA_NO"
            }
        },
        contract: {
            id: "77777",
            name: "test contract 2",
            type: "EXTERNAL",
            invoiceIncludeVat: false,
            invoiceReference: "test invoiceReference 2",
            invoiceAccountId: "test invoiceAccountId 2",
            comment: "test comment 2"
        },
        summary: {
            settlementTotal: 2500,
            adjustmentTotal: 0,
            totalExclVat: 2500,
            vat: 0,
            vatPercentage: 0,
            totalInclVat: 2500
        },
        productTypeSummaries: [
            {
                productTypeId: "SMS_BULK",
                fees: [
                    {
                        feeId: "MONTHLY",
                        type: "MONTHLY",
                        quantity: 1,
                        fee: 2500,
                        total: 2500
                    }
                ],
                total: 2500
            }
        ],
        adjustments: [],
        productDetails: [
            {
                productDetailId: "26185",
                productId: "2777",
                productTypeId: "SMS_BULK",
                total: 2500,
                fees: [
                    {
                        feeId: "MONTHLY",
                        type: "MONTHLY",
                        quantity: 1,
                        fee: 2500,
                        total: 2500
                    }
                ]
            }
        ]
    }
];
module.exports.default = $cda949365d0a7d99$var$settlements;

});

parcelRegister("lSJPF", function(module, exports) {
"use strict";
var $fee2317c939f62ab$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
var $fee2317c939f62ab$var$_a, $fee2317c939f62ab$var$_b, $fee2317c939f62ab$var$_c, $fee2317c939f62ab$var$_d, $fee2317c939f62ab$var$_e, $fee2317c939f62ab$var$_f, $fee2317c939f62ab$var$_g, $fee2317c939f62ab$var$_h, $fee2317c939f62ab$var$_j, $fee2317c939f62ab$var$_k;
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l8GLF = parcelRequire("l8GLF");

var $2MPlc = parcelRequire("2MPlc");

var $6pnc4 = parcelRequire("6pnc4");

const $fee2317c939f62ab$var$roles_1 = $fee2317c939f62ab$var$__importDefault((parcelRequire("18Yn6")));
const $fee2317c939f62ab$var$users = [
    {
        id: "customerUser",
        type: $l8GLF.UserType.CUSTOMER,
        email: "user@customer.com",
        firstName: "Customer",
        lastName: "User",
        rolesMap: [
            {
                resource: `${$2MPlc.RESOURCE_CUSTOMER_PREFIX}10001`,
                roles: [
                    "CUSTOMER_USER"
                ],
                permissions: ($fee2317c939f62ab$var$_a = $fee2317c939f62ab$var$roles_1.default.find((role)=>role.id === "CUSTOMER_USER")) === null || $fee2317c939f62ab$var$_a === void 0 ? void 0 : $fee2317c939f62ab$var$_a.permissions
            }
        ]
    },
    {
        id: "customerAdmin",
        type: $l8GLF.UserType.CUSTOMER,
        email: "admin@customer.com",
        firstName: "Customer",
        lastName: "Admin",
        rolesMap: [
            {
                resource: `${$2MPlc.RESOURCE_CUSTOMER_PREFIX}10002`,
                roles: [
                    "CUSTOMER_ADMIN"
                ],
                permissions: ($fee2317c939f62ab$var$_b = $fee2317c939f62ab$var$roles_1.default.find((role)=>role.id === "CUSTOMER_ADMIN")) === null || $fee2317c939f62ab$var$_b === void 0 ? void 0 : $fee2317c939f62ab$var$_b.permissions
            }
        ]
    },
    {
        id: "teliaUser",
        type: $l8GLF.UserType.TELIA,
        email: "user@telia.com",
        firstName: "User",
        lastName: "Telia",
        rolesMap: [
            {
                resource: `${$2MPlc.RESOURCE_BRAND_PREFIX}${$6pnc4.Brands.TELIA_NO}`,
                roles: [
                    "TELIA_USER"
                ],
                permissions: ($fee2317c939f62ab$var$_c = $fee2317c939f62ab$var$roles_1.default.find((role)=>role.id === "TELIA_USER")) === null || $fee2317c939f62ab$var$_c === void 0 ? void 0 : $fee2317c939f62ab$var$_c.permissions
            },
            {
                resource: `${$2MPlc.RESOURCE_BRAND_PREFIX}${$6pnc4.Brands.TELIA_SE}`,
                roles: [
                    "TELIA_USER"
                ],
                permissions: ($fee2317c939f62ab$var$_d = $fee2317c939f62ab$var$roles_1.default.find((role)=>role.id === "TELIA_USER")) === null || $fee2317c939f62ab$var$_d === void 0 ? void 0 : $fee2317c939f62ab$var$_d.permissions
            }
        ]
    },
    {
        id: "teliaAdmin",
        type: $l8GLF.UserType.TELIA,
        email: "admin@telia.com",
        firstName: "Admin",
        lastName: "Telia",
        rolesMap: [
            {
                resource: `${$2MPlc.RESOURCE_BRAND_PREFIX}${$2MPlc.RESOURCE_WILDCARD}`,
                roles: [
                    "TELIA_USER"
                ],
                permissions: ($fee2317c939f62ab$var$_e = $fee2317c939f62ab$var$roles_1.default.find((role)=>role.id === "TELIA_USER")) === null || $fee2317c939f62ab$var$_e === void 0 ? void 0 : $fee2317c939f62ab$var$_e.permissions
            },
            {
                resource: `${$2MPlc.RESOURCE_BRAND_PREFIX}${$6pnc4.Brands.TELIA_NO}`,
                roles: [
                    "TELIA_ADMIN"
                ],
                permissions: ($fee2317c939f62ab$var$_f = $fee2317c939f62ab$var$roles_1.default.find((role)=>role.id === "TELIA_ADMIN")) === null || $fee2317c939f62ab$var$_f === void 0 ? void 0 : $fee2317c939f62ab$var$_f.permissions
            }
        ]
    },
    {
        id: "allBrandAdmin",
        type: $l8GLF.UserType.TELIA,
        email: "admin@telia.com",
        firstName: "Admin",
        lastName: "Telia",
        rolesMap: [
            {
                resource: `${$2MPlc.RESOURCE_BRAND_PREFIX}${$2MPlc.RESOURCE_WILDCARD}`,
                roles: [
                    "TELIA_ADMIN"
                ],
                permissions: ($fee2317c939f62ab$var$_g = $fee2317c939f62ab$var$roles_1.default.find((role)=>role.id === "TELIA_ADMIN")) === null || $fee2317c939f62ab$var$_g === void 0 ? void 0 : $fee2317c939f62ab$var$_g.permissions
            },
            {
                resource: `${$2MPlc.RESOURCE_BRAND_PREFIX}${$6pnc4.Brands.TELIA_NO}`,
                roles: [
                    "TELIA_ADMIN"
                ],
                permissions: ($fee2317c939f62ab$var$_h = $fee2317c939f62ab$var$roles_1.default.find((role)=>role.id === "TELIA_USER")) === null || $fee2317c939f62ab$var$_h === void 0 ? void 0 : $fee2317c939f62ab$var$_h.permissions
            }
        ]
    },
    {
        id: "allBrandAdjuster",
        type: $l8GLF.UserType.TELIA,
        email: "adjuster@telia.com",
        firstName: "Adjuster",
        lastName: "Telia",
        rolesMap: [
            {
                resource: `${$2MPlc.RESOURCE_BRAND_PREFIX}${$2MPlc.RESOURCE_WILDCARD}`,
                roles: [
                    "TELIA_ADJUSTER"
                ],
                permissions: ($fee2317c939f62ab$var$_j = $fee2317c939f62ab$var$roles_1.default.find((role)=>role.id === "TELIA_ADJUSTER")) === null || $fee2317c939f62ab$var$_j === void 0 ? void 0 : $fee2317c939f62ab$var$_j.permissions
            }
        ]
    },
    {
        id: "allBrandApprover",
        type: $l8GLF.UserType.TELIA,
        email: "approver@telia.com",
        firstName: "Approver",
        lastName: "Telia",
        rolesMap: [
            {
                resource: `${$2MPlc.RESOURCE_BRAND_PREFIX}${$2MPlc.RESOURCE_WILDCARD}`,
                roles: [
                    "TELIA_APPROVER"
                ],
                permissions: ($fee2317c939f62ab$var$_k = $fee2317c939f62ab$var$roles_1.default.find((role)=>role.id === "TELIA_APPROVER")) === null || $fee2317c939f62ab$var$_k === void 0 ? void 0 : $fee2317c939f62ab$var$_k.permissions
            }
        ]
    }
];
module.exports.default = $fee2317c939f62ab$var$users;

});
parcelRegister("2MPlc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getUpdatedRolesMapResources = module.exports.hasUserCustomerPermission = module.exports.hasUserBrandPermission = module.exports.getUserPermissions = module.exports.getCustomerPermissionsFromRolesMap = module.exports.getBrandPermissionsFromRolesMap = module.exports.getCustomerId = module.exports.getBrandId = module.exports.RESOURCE_CUSTOMER_DEF = module.exports.RESOURCE_CUSTOMER_PARAM = module.exports.RESOURCE_CUSTOMER_PREFIX = module.exports.RESOURCE_BRAND_DEF = module.exports.RESOURCE_BRAND_PARAM = module.exports.RESOURCE_BRAND_PREFIX = module.exports.RESOURCE_WILDCARD = void 0;

var $l8GLF = parcelRequire("l8GLF");

var $96eCA = parcelRequire("96eCA");
module.exports.RESOURCE_WILDCARD = "*";
module.exports.RESOURCE_BRAND_PREFIX = "/brands/";
module.exports.RESOURCE_BRAND_PARAM = "brandId";
module.exports.RESOURCE_BRAND_DEF = module.exports.RESOURCE_BRAND_PREFIX + ":" + module.exports.RESOURCE_BRAND_PARAM;
module.exports.RESOURCE_CUSTOMER_PREFIX = "/customers/";
module.exports.RESOURCE_CUSTOMER_PARAM = "customerId";
module.exports.RESOURCE_CUSTOMER_DEF = module.exports.RESOURCE_CUSTOMER_PREFIX + ":" + module.exports.RESOURCE_CUSTOMER_PARAM;
const $2077e3b01460c26d$var$getBrandId = (resource)=>(0, $96eCA.createParamExtractor)(module.exports.RESOURCE_BRAND_DEF)(module.exports.RESOURCE_BRAND_PARAM, resource);
module.exports.getBrandId = $2077e3b01460c26d$var$getBrandId;
const $2077e3b01460c26d$var$getCustomerId = (resource)=>(0, $96eCA.createParamExtractor)(module.exports.RESOURCE_CUSTOMER_DEF)(module.exports.RESOURCE_CUSTOMER_PARAM, resource);
module.exports.getCustomerId = $2077e3b01460c26d$var$getCustomerId;
const $2077e3b01460c26d$var$getBrandPermissionsFromRolesMap = (rolesMap, brandId, exact = false)=>{
    const groupedPermissions = rolesMap ? rolesMap.filter((map)=>(0, module.exports.getBrandId)(map.resource) === brandId || !exact && (0, module.exports.getBrandId)(map.resource) === module.exports.RESOURCE_WILDCARD).flatMap((filteredMap)=>filteredMap.permissions) : [];
    return groupedPermissions.filter((permission, index)=>groupedPermissions.indexOf(permission) === index);
};
module.exports.getBrandPermissionsFromRolesMap = $2077e3b01460c26d$var$getBrandPermissionsFromRolesMap;
const $2077e3b01460c26d$var$getCustomerPermissionsFromRolesMap = (rolesMap, customerId, exact = false)=>{
    if (!rolesMap) return [];
    const groupedPermissions = rolesMap.filter(({ resource: resource })=>(0, module.exports.getCustomerId)(resource) === customerId).flatMap(({ permissions: permissions })=>permissions);
    return groupedPermissions.filter((permission, index)=>groupedPermissions.indexOf(permission) === index);
};
module.exports.getCustomerPermissionsFromRolesMap = $2077e3b01460c26d$var$getCustomerPermissionsFromRolesMap;
const $2077e3b01460c26d$var$getUserPermissions = (user, brandId)=>{
    switch(user === null || user === void 0 ? void 0 : user.type){
        case $l8GLF.UserType.TELIA:
            return (0, module.exports.getBrandPermissionsFromRolesMap)(user.rolesMap, brandId);
        case $l8GLF.UserType.CUSTOMER:
            return (0, module.exports.getCustomerPermissionsFromRolesMap)(user.rolesMap);
        default:
            return [];
    }
};
module.exports.getUserPermissions = $2077e3b01460c26d$var$getUserPermissions;
const $2077e3b01460c26d$var$hasUserBrandPermission = (permission, user, brandId)=>(0, module.exports.getUserPermissions)(user, brandId).includes(permission);
module.exports.hasUserBrandPermission = $2077e3b01460c26d$var$hasUserBrandPermission;
const $2077e3b01460c26d$var$hasUserCustomerPermission = (permission, user, customerId)=>(0, module.exports.getCustomerPermissionsFromRolesMap)(user.rolesMap, customerId).includes(permission);
module.exports.hasUserCustomerPermission = $2077e3b01460c26d$var$hasUserCustomerPermission;
const $2077e3b01460c26d$var$getUpdatedRolesMapResources = (prev, updated)=>{
    // If no previous rolesMap is given, all resources in new has been added
    if (!prev) return (updated === null || updated === void 0 ? void 0 : updated.map(({ resource: resource })=>resource)) || [];
    else if (!updated) return prev.map(({ resource: resource })=>resource) || [];
    // Find entries in rolesMap that has been updated
    const updatedResources = updated.reduce((updatedResources, resourceRoles)=>{
        var _a;
        // Find corresponding resource in previous rolesMap
        const prevResourceRoles = ((_a = prev === null || prev === void 0 ? void 0 : prev.find(({ resource: resource })=>resource === resourceRoles.resource)) === null || _a === void 0 ? void 0 : _a.roles) || [];
        // If length of roles lists are not matching or content are not matching, roles list has been changed
        if (prevResourceRoles.length !== resourceRoles.roles.length || resourceRoles.roles.some((role)=>!prevResourceRoles.includes(role))) return [
            ...updatedResources,
            resourceRoles.resource
        ];
        else return updatedResources;
    }, []);
    // Find entries in rolesMap that has been deleted from prev
    const deletedResources = prev.reduce((deletedResources, { resource: resource })=>{
        // If there is no resource in updatedRoles map that matches the one in prev,
        // it has been deleted, include in updated resources list
        if (!updated.some((resourceRoles)=>resource === resourceRoles.resource)) return [
            ...deletedResources,
            resource
        ];
        else return deletedResources;
    }, []);
    return [
        ...updatedResources,
        ...deletedResources
    ];
};
module.exports.getUpdatedRolesMapResources = $2077e3b01460c26d$var$getUpdatedRolesMapResources;

});
parcelRegister("96eCA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createParamExtractor = void 0;

var $i1fKd = parcelRequire("i1fKd");
function $6a000414229898d2$var$isKey(token) {
    return !!token.name;
}
const $6a000414229898d2$var$getParamIndex = (key, dict)=>{
    return dict[key];
};
const $6a000414229898d2$var$createParamExtractor = (pathDef)=>{
    const tokens = (0, $i1fKd.parse)(pathDef);
    const paramIndexDict = tokens.filter($6a000414229898d2$var$isKey).reduce((paramsMap, { name: name }, index, e)=>{
        return Object.assign(Object.assign({}, paramsMap), {
            [`${name}`]: index + 1
        });
    }, {});
    return (paramName, pathValue)=>{
        const pathRegExp = (0, $i1fKd.pathToRegexp)(pathDef);
        const pathMatches = pathRegExp.exec(pathValue);
        const paramIndex = $6a000414229898d2$var$getParamIndex(paramName, paramIndexDict);
        return pathMatches === null || paramIndex === undefined || pathMatches[paramIndex] === undefined ? null : pathMatches[paramIndex];
    };
};
module.exports.createParamExtractor = $6a000414229898d2$var$createParamExtractor;

});
parcelRegister("i1fKd", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $d1e4887f0b5b2804$export$98e6a39c04603d36; });
$parcel$export(module.exports, "pathToRegexp", function () { return $d1e4887f0b5b2804$export$71304158c7e35877; });
/**
 * Tokenize input string.
 */ function $d1e4887f0b5b2804$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError('Pattern cannot start with "?" at '.concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $d1e4887f0b5b2804$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $d1e4887f0b5b2804$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError('Must have text between two parameters, missing text after "'.concat(prev.name, '"'));
        if (!prevText || isSafe(prevText)) return "[^".concat($d1e4887f0b5b2804$var$escapeString(delimiter), "]+?");
        return "(?:(?!".concat($d1e4887f0b5b2804$var$escapeString(prevText), ")[^").concat($d1e4887f0b5b2804$var$escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $d1e4887f0b5b2804$export$ef7acd7185315e22(str, options) {
    return $d1e4887f0b5b2804$export$5b9bad9e403cf3d9($d1e4887f0b5b2804$export$98e6a39c04603d36(str, options), options);
}
function $d1e4887f0b5b2804$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $d1e4887f0b5b2804$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError('Expected "'.concat(token.name, '" to not repeat, but got an array'));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError('Expected "'.concat(token.name, '" to not be empty'));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError('Expected all "'.concat(token.name, '" to match "').concat(token.pattern, '", but got "').concat(segment, '"'));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError('Expected "'.concat(token.name, '" to match "').concat(token.pattern, '", but got "').concat(segment, '"'));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError('Expected "'.concat(token.name, '" to be ').concat(typeOfMessage));
        }
        return path;
    };
}
function $d1e4887f0b5b2804$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $d1e4887f0b5b2804$export$71304158c7e35877(str, keys, options);
    return $d1e4887f0b5b2804$export$968e97c88708237a(re, keys, options);
}
function $d1e4887f0b5b2804$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $d1e4887f0b5b2804$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $d1e4887f0b5b2804$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $d1e4887f0b5b2804$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $d1e4887f0b5b2804$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $d1e4887f0b5b2804$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $d1e4887f0b5b2804$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $d1e4887f0b5b2804$var$stringToRegexp(path, keys, options) {
    return $d1e4887f0b5b2804$export$9a9303716def6456($d1e4887f0b5b2804$export$98e6a39c04603d36(path, options), keys, options);
}
function $d1e4887f0b5b2804$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($d1e4887f0b5b2804$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($d1e4887f0b5b2804$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $d1e4887f0b5b2804$var$escapeString(encode(token));
        else {
            var prefix = $d1e4887f0b5b2804$var$escapeString(encode(token.prefix));
            var suffix = $d1e4887f0b5b2804$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError('Can not repeat "'.concat(token.name, '" without a prefix and suffix'));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $d1e4887f0b5b2804$var$flags(options));
}
function $d1e4887f0b5b2804$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $d1e4887f0b5b2804$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $d1e4887f0b5b2804$var$arrayToRegexp(path, keys, options);
    return $d1e4887f0b5b2804$var$stringToRegexp(path, keys, options);
}

});





parcelRegister("iEMYl", function(module, exports) {
"use strict";
var $d951f34aac72ee7e$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isWithinMonths = module.exports.overlap = module.exports.activeStatus = module.exports.ACTIVE_GRACE_PERIOD = module.exports.FUTURE = module.exports.ACTIVE = module.exports.EXPIRED = module.exports.INVALID = module.exports.isFutureAt = module.exports.isExpiredAt = module.exports.isActiveAt = module.exports.isGracePeriod = module.exports.isFuture = module.exports.isExpired = module.exports.isActive = module.exports.isValid = void 0;

const $d951f34aac72ee7e$var$moment_1 = $d951f34aac72ee7e$var$__importDefault((parcelRequire("c30H9")));

var $6N8I1 = parcelRequire("6N8I1");

const $d951f34aac72ee7e$var$format_1 = $d951f34aac72ee7e$var$__importDefault((parcelRequire("4hQuU")));
const $d951f34aac72ee7e$var$isValid = (period)=>{
    const { startDate: startDate = null, startTime: startTime = null, endDate: endDate = null, endTime: endTime = null } = period || {};
    return startDate === endDate && startTime && endTime ? startTime <= endTime : true === (startDate && (!endDate || startDate <= endDate));
};
module.exports.isValid = $d951f34aac72ee7e$var$isValid;
const $d951f34aac72ee7e$var$isActive = (period)=>{
    return (0, module.exports.isActiveAt)(period, $d951f34aac72ee7e$var$format_1.default.date(Date.now()));
};
module.exports.isActive = $d951f34aac72ee7e$var$isActive;
const $d951f34aac72ee7e$var$isExpired = (period)=>{
    return (0, module.exports.isExpiredAt)(period, $d951f34aac72ee7e$var$format_1.default.date(Date.now()));
};
module.exports.isExpired = $d951f34aac72ee7e$var$isExpired;
const $d951f34aac72ee7e$var$isFuture = (period)=>{
    return (0, module.exports.isFutureAt)(period, $d951f34aac72ee7e$var$format_1.default.date(Date.now()));
};
module.exports.isFuture = $d951f34aac72ee7e$var$isFuture;
const $d951f34aac72ee7e$var$isGracePeriod = (period)=>{
    const { startDate: startDate } = period;
    const gracePeriodEnd = (0, $d951f34aac72ee7e$var$moment_1.default)(startDate).subtract($6N8I1.GRACE_PERIOD, "days").format("YYYY-MM-DD");
    return !(0, module.exports.isActive)(period) && (0, module.exports.isActiveAt)(Object.assign(Object.assign({}, period), {
        startDate: startDate ? gracePeriodEnd : startDate
    }), $d951f34aac72ee7e$var$format_1.default.date(Date.now()));
};
module.exports.isGracePeriod = $d951f34aac72ee7e$var$isGracePeriod;
// export const isActiveAt: (period: PeriodI, atDate?: string) => boolean = (period, atDate = null) => {
const $d951f34aac72ee7e$var$isActiveAt = (period, atDate)=>{
    if (!(0, module.exports.isValid)(period) || !atDate) return false;
    const { startDate: startDate = null, endDate: endDate = null } = period || {};
    if (!startDate || startDate > atDate) return false;
    return !endDate || endDate >= atDate;
};
module.exports.isActiveAt = $d951f34aac72ee7e$var$isActiveAt;
const $d951f34aac72ee7e$var$isExpiredAt = (period, atDate)=>{
    if (!(0, module.exports.isValid)(period) || !atDate) return false;
    const { startDate: startDate, endDate: endDate } = period;
    return !!atDate && !!startDate && startDate < atDate && !!endDate && endDate < atDate;
};
module.exports.isExpiredAt = $d951f34aac72ee7e$var$isExpiredAt;
const $d951f34aac72ee7e$var$isFutureAt = (period, atDate)=>{
    if (!(0, module.exports.isValid)(period) || !atDate) return false;
    const { startDate: startDate = null } = period || {};
    return !!startDate && !!atDate && startDate > atDate;
};
module.exports.isFutureAt = $d951f34aac72ee7e$var$isFutureAt;
module.exports.INVALID = "INVALID";
module.exports.EXPIRED = "EXPIRED";
module.exports.ACTIVE = "ACTIVE";
module.exports.FUTURE = "FUTURE";
module.exports.ACTIVE_GRACE_PERIOD = "ACTIVE (Grace period)";
const $d951f34aac72ee7e$var$activeStatus = (period)=>{
    if (!period || !(0, module.exports.isValid)(period)) return module.exports.INVALID;
    if ((0, module.exports.isExpired)(period)) return module.exports.EXPIRED;
    if (period.gracePeriodStartDate && (0, module.exports.isGracePeriod)(period)) return module.exports.ACTIVE_GRACE_PERIOD;
    if ((0, module.exports.isFuture)(period)) return module.exports.FUTURE;
    return module.exports.ACTIVE;
};
module.exports.activeStatus = $d951f34aac72ee7e$var$activeStatus;
const $d951f34aac72ee7e$var$overlap = (a, b)=>{
    return !!a && !!b && (0, module.exports.isValid)(a) && (0, module.exports.isValid)(b) && ((0, module.exports.isActiveAt)(a, b.startDate) || (0, module.exports.isActiveAt)(b, a.startDate));
};
module.exports.overlap = $d951f34aac72ee7e$var$overlap;
const $d951f34aac72ee7e$var$isWithinMonths = (startDate, months)=>{
    const date = new Date();
    date.setMonth(date.getMonth() - months);
    return (0, module.exports.isFutureAt)({
        startDate: startDate
    }, $d951f34aac72ee7e$var$format_1.default.date(date));
};
module.exports.isWithinMonths = $d951f34aac72ee7e$var$isWithinMonths;

});

parcelRegister("6Cqb9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rangeTo = module.exports.rangesOverlap = module.exports.rangeIncludes = module.exports.rangeValues = module.exports.isValid = void 0;
parcelRequire("g6Bzp");
const $4d1a99488c2520e5$var$digitsReg = new RegExp("^\\d+$");
const $4d1a99488c2520e5$var$isValid = ({ from: from, to: to })=>{
    return from <= to && from.length === to.length && $4d1a99488c2520e5$var$digitsReg.test(from) && $4d1a99488c2520e5$var$digitsReg.test(to);
};
module.exports.isValid = $4d1a99488c2520e5$var$isValid;
const $4d1a99488c2520e5$var$rangeValues = (range)=>{
    if (!(0, module.exports.isValid)(range)) throw new Error("Invalid access number range: " + JSON.stringify(range));
    const { from: from, to: to } = range;
    const { length: length } = from;
    return Array.range(parseInt(from), parseInt(to)).map((i)=>i.toString().padStart(length, "0"));
};
module.exports.rangeValues = $4d1a99488c2520e5$var$rangeValues;
const $4d1a99488c2520e5$var$rangeIncludes = (range, accessNumber)=>{
    if (!(0, module.exports.isValid)(range)) // throw new Error('Invalid range range: ' + JSON.stringify(range));
    return false;
    if (!accessNumber || !$4d1a99488c2520e5$var$digitsReg.test(accessNumber)) // throw new Error('Invalid access number: ' + accessNumber);
    return false;
    const { from: from, to: to } = range;
    return from.length === accessNumber.length && from <= accessNumber && to >= accessNumber;
};
module.exports.rangeIncludes = $4d1a99488c2520e5$var$rangeIncludes;
const $4d1a99488c2520e5$var$rangesOverlap = (a, b)=>{
    if (!(0, module.exports.isValid)(a) || !(0, module.exports.isValid)(b)) // throw new Error('Invalid series range: ' + JSON.stringify(series));
    return false;
    return a.from.length === b.from.length && (a.from <= b.to && a.to >= b.from || b.from <= a.to && b.to >= a.from);
};
module.exports.rangesOverlap = $4d1a99488c2520e5$var$rangesOverlap;
const $4d1a99488c2520e5$var$rangeTo = (from, count)=>{
    if (!count || count < 0) throw new Error("Invalid count: " + count);
    if (!from || !$4d1a99488c2520e5$var$digitsReg.test(from)) throw new Error("Invalid from: " + count);
    return (parseInt(from) + count - 1).toString().padStart(from.length, "0");
};
module.exports.rangeTo = $4d1a99488c2520e5$var$rangeTo;

});

parcelRegister("ff9mn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.userComparator = module.exports.rbmOverviewsComparator = module.exports.reservedOaOverviewsComparator = module.exports.productOverviewsComparator = module.exports.sortedProductOverviewTypes = module.exports.sortByProductFeeIdComparator = module.exports.sortedProductFeeIds = module.exports.sortByProductTypeIdComparator = module.exports.sortedProductTypeIds = module.exports.sortByIdComparator = module.exports.sortByNameComparator = module.exports.accessNumbersSortComparator = module.exports.withAccessNumbersSortComparator = module.exports.productAccessNumberCompare = void 0;

var $6N8I1 = parcelRequire("6N8I1");
const $b18f846b2576a826$var$productAccessNumberCompare = (a, b)=>{
    var _a, _b;
    return (0, module.exports.accessNumbersSortComparator)(a.accessNumber || ((_a = a.accessNumberRange) === null || _a === void 0 ? void 0 : _a.from), b.accessNumber || ((_b = b.accessNumberRange) === null || _b === void 0 ? void 0 : _b.from));
};
module.exports.productAccessNumberCompare = $b18f846b2576a826$var$productAccessNumberCompare;
const $b18f846b2576a826$var$withAccessNumbersSortComparator = (a, b)=>(0, module.exports.accessNumbersSortComparator)(a.accessNumber, b.accessNumber);
module.exports.withAccessNumbersSortComparator = $b18f846b2576a826$var$withAccessNumbersSortComparator;
const $b18f846b2576a826$var$accessNumbersSortComparator = (a, b)=>a === undefined || b === undefined ? a === undefined && b === undefined ? 0 : a === undefined ? -1 : 1 : a.length !== b.length ? a.length - b.length : a.localeCompare(b);
module.exports.accessNumbersSortComparator = $b18f846b2576a826$var$accessNumbersSortComparator;
const $b18f846b2576a826$var$sortByNameComparator = (a, b)=>{
    if (!a || !a.name) return -1;
    if (!b || !b.name) return 1;
    return a.name.localeCompare(b.name);
};
module.exports.sortByNameComparator = $b18f846b2576a826$var$sortByNameComparator;
const $b18f846b2576a826$var$sortByIdComparator = (a, b)=>{
    if (!a || !a.id) return -1;
    if (!b || !b.id) return 1;
    return a.id.localeCompare(b.id);
};
module.exports.sortByIdComparator = $b18f846b2576a826$var$sortByIdComparator;
module.exports.sortedProductTypeIds = [
    "SMS_BULK",
    "MO_LONG_NUMBER",
    "MO_LONG_NUMBER_RANGE",
    "MO_DIRECT_CHARGE_RANGE",
    "POSITIONING",
    "SMS_EVENT",
    "RESERVED_OA",
    "RBM"
];
const $b18f846b2576a826$var$findSortedProductTypeIndex = (productTypeId)=>{
    const index = module.exports.sortedProductTypeIds.findIndex((sortedProductTypeId)=>productTypeId.startsWith(sortedProductTypeId));
    return index >= 0 ? index : module.exports.sortedProductTypeIds.length; // If index is not found in the sorted IDs list, place at end
};
const $b18f846b2576a826$var$sortByProductTypeIdComparator = (a, b)=>{
    // If indexes are identical, use localCompare for sorting on suffix (..._NO, ..._SE, etc)
    return $b18f846b2576a826$var$findSortedProductTypeIndex(a.productTypeId) - $b18f846b2576a826$var$findSortedProductTypeIndex(b.productTypeId) || a.productTypeId.localeCompare(b.productTypeId);
};
module.exports.sortByProductTypeIdComparator = $b18f846b2576a826$var$sortByProductTypeIdComparator;
module.exports.sortedProductFeeIds = [
    "HOME",
    "DOMESTIC",
    "FOREIGN",
    "BLOCKED",
    "RBM_BASIC_MESSAGE",
    "RBM_SINGLE_MESSAGE",
    "RBM_A2P_CONVERSATION",
    "RBM_AGENT",
    "MONTHLY",
    "ESTABLISHMENT"
];
const $b18f846b2576a826$var$findSortedProductFeeIdIndex = (productFeeId)=>{
    return module.exports.sortedProductFeeIds.findIndex((sortedProductFeeId)=>sortedProductFeeId === productFeeId);
};
const $b18f846b2576a826$var$sortByProductFeeIdComparator = (a, b)=>{
    return $b18f846b2576a826$var$findSortedProductFeeIdIndex(a.feeId) - $b18f846b2576a826$var$findSortedProductFeeIdIndex(b.feeId);
};
module.exports.sortByProductFeeIdComparator = $b18f846b2576a826$var$sortByProductFeeIdComparator;
module.exports.sortedProductOverviewTypes = [
    $6N8I1.PRODUCT_OVERVIEW_TYPE_ACCESS_NUMBER,
    $6N8I1.PRODUCT_OVERVIEW_TYPE_ACCESS_NUMBER_RANGE,
    $6N8I1.PRODUCT_OVERVIEW_TYPE_RESERVED_OA,
    $6N8I1.PRODUCT_OVERVIEW_TYPE_RBM,
    $6N8I1.PRODUCT_OVERVIEW_TYPE_GENERIC
];
const $b18f846b2576a826$var$findSortedProductOverviewTypeIndex = (overviewType)=>{
    return module.exports.sortedProductOverviewTypes.findIndex((sortedOverviewType)=>sortedOverviewType === overviewType);
};
const $b18f846b2576a826$var$productOverviewsComparator = (a, b)=>{
    return $b18f846b2576a826$var$findSortedProductOverviewTypeIndex(a.productOverviewType) - $b18f846b2576a826$var$findSortedProductOverviewTypeIndex(b.productOverviewType);
};
module.exports.productOverviewsComparator = $b18f846b2576a826$var$productOverviewsComparator;
const $b18f846b2576a826$var$reservedOaOverviewsComparator = (a, b)=>{
    var _a, _b, _c;
    return !a.reservedOas || !a.reservedOas.length || !b.reservedOas || !b.reservedOas.length ? !((_a = a.reservedOas) === null || _a === void 0 ? void 0 : _a.length) && !((_b = b.reservedOas) === null || _b === void 0 ? void 0 : _b.length) ? 0 : ((_c = a.reservedOas) === null || _c === void 0 ? void 0 : _c.length) ? -1 : 1 : a.reservedOas[0].localeCompare(b.reservedOas[0]);
};
module.exports.reservedOaOverviewsComparator = $b18f846b2576a826$var$reservedOaOverviewsComparator;
const $b18f846b2576a826$var$rbmOverviewsComparator = (a, b)=>{
    return a.rbmAgentOwner.localeCompare(b.rbmAgentOwner);
};
module.exports.rbmOverviewsComparator = $b18f846b2576a826$var$rbmOverviewsComparator;
const $b18f846b2576a826$var$userComparator = (a, b)=>{
    return a.firstName.localeCompare(b.firstName) || (a.lastName && b.lastName ? a.lastName.localeCompare(b.lastName) : a.lastName ? 1 : b.lastName ? -1 : 0);
};
module.exports.userComparator = $b18f846b2576a826$var$userComparator;

});

parcelRegister("daG5e", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PROMETHEUS_METRICS = module.exports.ONECALL_MYCALL_OLD_CPA = module.exports.CHECK = module.exports.CONFIG = module.exports.ENV_CONFIG = module.exports.CHANGE_PASSWORD = module.exports.LOGOUT = module.exports.LOGIN = module.exports.HEALTH = module.exports.GRAPHQL = module.exports.AUTH = module.exports.HOME = void 0;
module.exports.HOME = "/";
module.exports.AUTH = "/auth";
module.exports.GRAPHQL = "/graphql";
module.exports.HEALTH = "/health";
module.exports.LOGIN = "/login";
module.exports.LOGOUT = "/logout";
module.exports.CHANGE_PASSWORD = "/changePassword";
module.exports.ENV_CONFIG = "/envConfig";
module.exports.CONFIG = "/config";
module.exports.CHECK = "/check";
module.exports.ONECALL_MYCALL_OLD_CPA = "/web";
module.exports.PROMETHEUS_METRICS = "/metrics";

});

parcelRegister("emBdm", function(module, exports) {
"use strict";

var $a5n6m = parcelRequire("a5n6m");

var $kKGfz = parcelRequire("kKGfz");

var $9rcLO = parcelRequire("9rcLO");

var $026v5 = parcelRequire("026v5");
var $a74ffccfc760ca15$var$$WeakMap = $a5n6m("%WeakMap%", true);
var $a74ffccfc760ca15$var$$Map = $a5n6m("%Map%", true);
var $a74ffccfc760ca15$var$$weakMapGet = $kKGfz("WeakMap.prototype.get", true);
var $a74ffccfc760ca15$var$$weakMapSet = $kKGfz("WeakMap.prototype.set", true);
var $a74ffccfc760ca15$var$$weakMapHas = $kKGfz("WeakMap.prototype.has", true);
var $a74ffccfc760ca15$var$$mapGet = $kKGfz("Map.prototype.get", true);
var $a74ffccfc760ca15$var$$mapSet = $kKGfz("Map.prototype.set", true);
var $a74ffccfc760ca15$var$$mapHas = $kKGfz("Map.prototype.has", true);
/*
* This function traverses the list returning the node corresponding to the given key.
*
* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list. By doing so, all the recently used nodes can be accessed relatively quickly.
*/ /** @type {import('.').listGetNode} */ var $a74ffccfc760ca15$var$listGetNode = function(list, key) {
    /** @type {typeof list | NonNullable<(typeof list)['next']>} */ var prev = list;
    /** @type {(typeof list)['next']} */ var curr;
    for(; (curr = prev.next) !== null; prev = curr)if (curr.key === key) {
        prev.next = curr.next;
        // eslint-disable-next-line no-extra-parens
        curr.next = /** @type {NonNullable<typeof list.next>} */ list.next;
        list.next = curr; // eslint-disable-line no-param-reassign
        return curr;
    }
};
/** @type {import('.').listGet} */ var $a74ffccfc760ca15$var$listGet = function(objects, key) {
    var node = $a74ffccfc760ca15$var$listGetNode(objects, key);
    return node && node.value;
};
/** @type {import('.').listSet} */ var $a74ffccfc760ca15$var$listSet = function(objects, key, value) {
    var node = $a74ffccfc760ca15$var$listGetNode(objects, key);
    if (node) node.value = value;
    else // Prepend the new node to the beginning of the list
    objects.next = /** @type {import('.').ListNode<typeof value>} */ {
        key: key,
        next: objects.next,
        value: value
    };
};
/** @type {import('.').listHas} */ var $a74ffccfc760ca15$var$listHas = function(objects, key) {
    return !!$a74ffccfc760ca15$var$listGetNode(objects, key);
};
/** @type {import('.')} */ module.exports = function getSideChannel() {
    /** @type {WeakMap<object, unknown>} */ var $wm;
    /** @type {Map<object, unknown>} */ var $m;
    /** @type {import('.').RootNode<unknown>} */ var $o;
    /** @type {import('.').Channel} */ var channel = {
        assert: function(key) {
            if (!channel.has(key)) throw new $026v5("Side channel does not contain " + $9rcLO(key));
        },
        get: function(key) {
            if ($a74ffccfc760ca15$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $a74ffccfc760ca15$var$$weakMapGet($wm, key);
            } else if ($a74ffccfc760ca15$var$$Map) {
                if ($m) return $a74ffccfc760ca15$var$$mapGet($m, key);
            } else {
                if ($o) return $a74ffccfc760ca15$var$listGet($o, key);
            }
        },
        has: function(key) {
            if ($a74ffccfc760ca15$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if ($wm) return $a74ffccfc760ca15$var$$weakMapHas($wm, key);
            } else if ($a74ffccfc760ca15$var$$Map) {
                if ($m) return $a74ffccfc760ca15$var$$mapHas($m, key);
            } else {
                if ($o) return $a74ffccfc760ca15$var$listHas($o, key);
            }
            return false;
        },
        set: function(key, value) {
            if ($a74ffccfc760ca15$var$$WeakMap && key && (typeof key === "object" || typeof key === "function")) {
                if (!$wm) $wm = new $a74ffccfc760ca15$var$$WeakMap();
                $a74ffccfc760ca15$var$$weakMapSet($wm, key, value);
            } else if ($a74ffccfc760ca15$var$$Map) {
                if (!$m) $m = new $a74ffccfc760ca15$var$$Map();
                $a74ffccfc760ca15$var$$mapSet($m, key, value);
            } else {
                if (!$o) // Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
                $o = {
                    key: {},
                    next: null
                };
                $a74ffccfc760ca15$var$listSet($o, key, value);
            }
        }
    };
    return channel;
};

});
parcelRegister("a5n6m", function(module, exports) {
"use strict";
var $757c4a83c3defa39$var$undefined1;

var $1pSrK = parcelRequire("1pSrK");

var $bSLej = parcelRequire("bSLej");

var $kUiu6 = parcelRequire("kUiu6");

var $alJxI = parcelRequire("alJxI");

var $bqlx5 = parcelRequire("bqlx5");

var $026v5 = parcelRequire("026v5");

var $76C2Q = parcelRequire("76C2Q");
var $757c4a83c3defa39$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $757c4a83c3defa39$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $757c4a83c3defa39$var$$Function('"use strict"; return (' + expressionSyntax + ").constructor;")();
    } catch (e) {}
};
var $757c4a83c3defa39$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($757c4a83c3defa39$var$$gOPD) try {
    $757c4a83c3defa39$var$$gOPD({}, "");
} catch (e) {
    $757c4a83c3defa39$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $757c4a83c3defa39$var$throwTypeError = function() {
    throw new $026v5();
};
var $757c4a83c3defa39$var$ThrowTypeError = $757c4a83c3defa39$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $757c4a83c3defa39$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $757c4a83c3defa39$var$$gOPD(arguments, "callee").get;
        } catch (gOPDthrows) {
            return $757c4a83c3defa39$var$throwTypeError;
        }
    }
}() : $757c4a83c3defa39$var$throwTypeError;

var $757c4a83c3defa39$var$hasSymbols = (parcelRequire("lQzMC"))();

var $757c4a83c3defa39$var$hasProto = (parcelRequire("bSjoV"))();
var $757c4a83c3defa39$var$getProto = Object.getPrototypeOf || ($757c4a83c3defa39$var$hasProto ? function(x) {
    return x.__proto__;
} // eslint-disable-line no-proto
 : null);
var $757c4a83c3defa39$var$needsEval = {};
var $757c4a83c3defa39$var$TypedArray = typeof Uint8Array === "undefined" || !$757c4a83c3defa39$var$getProto ? undefined : $757c4a83c3defa39$var$getProto(Uint8Array);
var $757c4a83c3defa39$var$INTRINSICS = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError === "undefined" ? undefined : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer === "undefined" ? undefined : ArrayBuffer,
    "%ArrayIteratorPrototype%": $757c4a83c3defa39$var$hasSymbols && $757c4a83c3defa39$var$getProto ? $757c4a83c3defa39$var$getProto([][Symbol.iterator]()) : undefined,
    "%AsyncFromSyncIteratorPrototype%": undefined,
    "%AsyncFunction%": $757c4a83c3defa39$var$needsEval,
    "%AsyncGenerator%": $757c4a83c3defa39$var$needsEval,
    "%AsyncGeneratorFunction%": $757c4a83c3defa39$var$needsEval,
    "%AsyncIteratorPrototype%": $757c4a83c3defa39$var$needsEval,
    "%Atomics%": typeof Atomics === "undefined" ? undefined : Atomics,
    "%BigInt%": typeof BigInt === "undefined" ? undefined : BigInt,
    "%BigInt64Array%": typeof BigInt64Array === "undefined" ? undefined : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array === "undefined" ? undefined : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView === "undefined" ? undefined : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": $1pSrK,
    "%eval%": eval,
    "%EvalError%": $bSLej,
    "%Float32Array%": typeof Float32Array === "undefined" ? undefined : Float32Array,
    "%Float64Array%": typeof Float64Array === "undefined" ? undefined : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry === "undefined" ? undefined : FinalizationRegistry,
    "%Function%": $757c4a83c3defa39$var$$Function,
    "%GeneratorFunction%": $757c4a83c3defa39$var$needsEval,
    "%Int8Array%": typeof Int8Array === "undefined" ? undefined : Int8Array,
    "%Int16Array%": typeof Int16Array === "undefined" ? undefined : Int16Array,
    "%Int32Array%": typeof Int32Array === "undefined" ? undefined : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": $757c4a83c3defa39$var$hasSymbols && $757c4a83c3defa39$var$getProto ? $757c4a83c3defa39$var$getProto($757c4a83c3defa39$var$getProto([][Symbol.iterator]())) : undefined,
    "%JSON%": typeof JSON === "object" ? JSON : undefined,
    "%Map%": typeof Map === "undefined" ? undefined : Map,
    "%MapIteratorPrototype%": typeof Map === "undefined" || !$757c4a83c3defa39$var$hasSymbols || !$757c4a83c3defa39$var$getProto ? undefined : $757c4a83c3defa39$var$getProto(new Map()[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise === "undefined" ? undefined : Promise,
    "%Proxy%": typeof Proxy === "undefined" ? undefined : Proxy,
    "%RangeError%": $kUiu6,
    "%ReferenceError%": $alJxI,
    "%Reflect%": typeof Reflect === "undefined" ? undefined : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set === "undefined" ? undefined : Set,
    "%SetIteratorPrototype%": typeof Set === "undefined" || !$757c4a83c3defa39$var$hasSymbols || !$757c4a83c3defa39$var$getProto ? undefined : $757c4a83c3defa39$var$getProto(new Set()[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer === "undefined" ? undefined : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": $757c4a83c3defa39$var$hasSymbols && $757c4a83c3defa39$var$getProto ? $757c4a83c3defa39$var$getProto(""[Symbol.iterator]()) : undefined,
    "%Symbol%": $757c4a83c3defa39$var$hasSymbols ? Symbol : undefined,
    "%SyntaxError%": $bqlx5,
    "%ThrowTypeError%": $757c4a83c3defa39$var$ThrowTypeError,
    "%TypedArray%": $757c4a83c3defa39$var$TypedArray,
    "%TypeError%": $026v5,
    "%Uint8Array%": typeof Uint8Array === "undefined" ? undefined : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray === "undefined" ? undefined : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array === "undefined" ? undefined : Uint16Array,
    "%Uint32Array%": typeof Uint32Array === "undefined" ? undefined : Uint32Array,
    "%URIError%": $76C2Q,
    "%WeakMap%": typeof WeakMap === "undefined" ? undefined : WeakMap,
    "%WeakRef%": typeof WeakRef === "undefined" ? undefined : WeakRef,
    "%WeakSet%": typeof WeakSet === "undefined" ? undefined : WeakSet
};
if ($757c4a83c3defa39$var$getProto) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $757c4a83c3defa39$var$errorProto = $757c4a83c3defa39$var$getProto($757c4a83c3defa39$var$getProto(e));
    $757c4a83c3defa39$var$INTRINSICS["%Error.prototype%"] = $757c4a83c3defa39$var$errorProto;
}
var $757c4a83c3defa39$var$doEval = function doEval(name) {
    var value;
    if (name === "%AsyncFunction%") value = $757c4a83c3defa39$var$getEvalledConstructor("async function () {}");
    else if (name === "%GeneratorFunction%") value = $757c4a83c3defa39$var$getEvalledConstructor("function* () {}");
    else if (name === "%AsyncGeneratorFunction%") value = $757c4a83c3defa39$var$getEvalledConstructor("async function* () {}");
    else if (name === "%AsyncGenerator%") {
        var fn = doEval("%AsyncGeneratorFunction%");
        if (fn) value = fn.prototype;
    } else if (name === "%AsyncIteratorPrototype%") {
        var gen = doEval("%AsyncGenerator%");
        if (gen && $757c4a83c3defa39$var$getProto) value = $757c4a83c3defa39$var$getProto(gen.prototype);
    }
    $757c4a83c3defa39$var$INTRINSICS[name] = value;
    return value;
};
var $757c4a83c3defa39$var$LEGACY_ALIASES = {
    __proto__: null,
    "%ArrayBufferPrototype%": [
        "ArrayBuffer",
        "prototype"
    ],
    "%ArrayPrototype%": [
        "Array",
        "prototype"
    ],
    "%ArrayProto_entries%": [
        "Array",
        "prototype",
        "entries"
    ],
    "%ArrayProto_forEach%": [
        "Array",
        "prototype",
        "forEach"
    ],
    "%ArrayProto_keys%": [
        "Array",
        "prototype",
        "keys"
    ],
    "%ArrayProto_values%": [
        "Array",
        "prototype",
        "values"
    ],
    "%AsyncFunctionPrototype%": [
        "AsyncFunction",
        "prototype"
    ],
    "%AsyncGenerator%": [
        "AsyncGeneratorFunction",
        "prototype"
    ],
    "%AsyncGeneratorPrototype%": [
        "AsyncGeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%BooleanPrototype%": [
        "Boolean",
        "prototype"
    ],
    "%DataViewPrototype%": [
        "DataView",
        "prototype"
    ],
    "%DatePrototype%": [
        "Date",
        "prototype"
    ],
    "%ErrorPrototype%": [
        "Error",
        "prototype"
    ],
    "%EvalErrorPrototype%": [
        "EvalError",
        "prototype"
    ],
    "%Float32ArrayPrototype%": [
        "Float32Array",
        "prototype"
    ],
    "%Float64ArrayPrototype%": [
        "Float64Array",
        "prototype"
    ],
    "%FunctionPrototype%": [
        "Function",
        "prototype"
    ],
    "%Generator%": [
        "GeneratorFunction",
        "prototype"
    ],
    "%GeneratorPrototype%": [
        "GeneratorFunction",
        "prototype",
        "prototype"
    ],
    "%Int8ArrayPrototype%": [
        "Int8Array",
        "prototype"
    ],
    "%Int16ArrayPrototype%": [
        "Int16Array",
        "prototype"
    ],
    "%Int32ArrayPrototype%": [
        "Int32Array",
        "prototype"
    ],
    "%JSONParse%": [
        "JSON",
        "parse"
    ],
    "%JSONStringify%": [
        "JSON",
        "stringify"
    ],
    "%MapPrototype%": [
        "Map",
        "prototype"
    ],
    "%NumberPrototype%": [
        "Number",
        "prototype"
    ],
    "%ObjectPrototype%": [
        "Object",
        "prototype"
    ],
    "%ObjProto_toString%": [
        "Object",
        "prototype",
        "toString"
    ],
    "%ObjProto_valueOf%": [
        "Object",
        "prototype",
        "valueOf"
    ],
    "%PromisePrototype%": [
        "Promise",
        "prototype"
    ],
    "%PromiseProto_then%": [
        "Promise",
        "prototype",
        "then"
    ],
    "%Promise_all%": [
        "Promise",
        "all"
    ],
    "%Promise_reject%": [
        "Promise",
        "reject"
    ],
    "%Promise_resolve%": [
        "Promise",
        "resolve"
    ],
    "%RangeErrorPrototype%": [
        "RangeError",
        "prototype"
    ],
    "%ReferenceErrorPrototype%": [
        "ReferenceError",
        "prototype"
    ],
    "%RegExpPrototype%": [
        "RegExp",
        "prototype"
    ],
    "%SetPrototype%": [
        "Set",
        "prototype"
    ],
    "%SharedArrayBufferPrototype%": [
        "SharedArrayBuffer",
        "prototype"
    ],
    "%StringPrototype%": [
        "String",
        "prototype"
    ],
    "%SymbolPrototype%": [
        "Symbol",
        "prototype"
    ],
    "%SyntaxErrorPrototype%": [
        "SyntaxError",
        "prototype"
    ],
    "%TypedArrayPrototype%": [
        "TypedArray",
        "prototype"
    ],
    "%TypeErrorPrototype%": [
        "TypeError",
        "prototype"
    ],
    "%Uint8ArrayPrototype%": [
        "Uint8Array",
        "prototype"
    ],
    "%Uint8ClampedArrayPrototype%": [
        "Uint8ClampedArray",
        "prototype"
    ],
    "%Uint16ArrayPrototype%": [
        "Uint16Array",
        "prototype"
    ],
    "%Uint32ArrayPrototype%": [
        "Uint32Array",
        "prototype"
    ],
    "%URIErrorPrototype%": [
        "URIError",
        "prototype"
    ],
    "%WeakMapPrototype%": [
        "WeakMap",
        "prototype"
    ],
    "%WeakSetPrototype%": [
        "WeakSet",
        "prototype"
    ]
};

var $gp6Md = parcelRequire("gp6Md");

var $hAbsx = parcelRequire("hAbsx");
var $757c4a83c3defa39$var$$concat = $gp6Md.call(Function.call, Array.prototype.concat);
var $757c4a83c3defa39$var$$spliceApply = $gp6Md.call(Function.apply, Array.prototype.splice);
var $757c4a83c3defa39$var$$replace = $gp6Md.call(Function.call, String.prototype.replace);
var $757c4a83c3defa39$var$$strSlice = $gp6Md.call(Function.call, String.prototype.slice);
var $757c4a83c3defa39$var$$exec = $gp6Md.call(Function.call, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $757c4a83c3defa39$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $757c4a83c3defa39$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $757c4a83c3defa39$var$stringToPath = function stringToPath(string) {
    var first = $757c4a83c3defa39$var$$strSlice(string, 0, 1);
    var last = $757c4a83c3defa39$var$$strSlice(string, -1);
    if (first === "%" && last !== "%") throw new $bqlx5("invalid intrinsic syntax, expected closing `%`");
    else if (last === "%" && first !== "%") throw new $bqlx5("invalid intrinsic syntax, expected opening `%`");
    var result = [];
    $757c4a83c3defa39$var$$replace(string, $757c4a83c3defa39$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $757c4a83c3defa39$var$$replace(subString, $757c4a83c3defa39$var$reEscapeChar, "$1") : number || match;
    });
    return result;
};
/* end adaptation */ var $757c4a83c3defa39$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($hAbsx($757c4a83c3defa39$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $757c4a83c3defa39$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = "%" + alias[0] + "%";
    }
    if ($hAbsx($757c4a83c3defa39$var$INTRINSICS, intrinsicName)) {
        var value = $757c4a83c3defa39$var$INTRINSICS[intrinsicName];
        if (value === $757c4a83c3defa39$var$needsEval) value = $757c4a83c3defa39$var$doEval(intrinsicName);
        if (typeof value === "undefined" && !allowMissing) throw new $026v5("intrinsic " + name + " exists, but is not available. Please file an issue!");
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $bqlx5("intrinsic " + name + " does not exist!");
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== "string" || name.length === 0) throw new $026v5("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof allowMissing !== "boolean") throw new $026v5('"allowMissing" argument must be a boolean');
    if ($757c4a83c3defa39$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $bqlx5("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var parts = $757c4a83c3defa39$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : "";
    var intrinsic = $757c4a83c3defa39$var$getBaseIntrinsic("%" + intrinsicBaseName + "%", allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $757c4a83c3defa39$var$$spliceApply(parts, $757c4a83c3defa39$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $757c4a83c3defa39$var$$strSlice(part, 0, 1);
        var last = $757c4a83c3defa39$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === "`" || last === '"' || last === "'" || last === "`") && first !== last) throw new $bqlx5("property names with quotes must have matching quotes");
        if (part === "constructor" || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += "." + part;
        intrinsicRealName = "%" + intrinsicBaseName + "%";
        if ($hAbsx($757c4a83c3defa39$var$INTRINSICS, intrinsicRealName)) value = $757c4a83c3defa39$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $026v5("base intrinsic for " + name + " exists, but the property is not available.");
                return void 0;
            }
            if ($757c4a83c3defa39$var$$gOPD && i + 1 >= parts.length) {
                var desc = $757c4a83c3defa39$var$$gOPD(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && "get" in desc && !("originalValue" in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $hAbsx(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $757c4a83c3defa39$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("1pSrK", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("bSLej", function(module, exports) {
"use strict";
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("kUiu6", function(module, exports) {
"use strict";
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("alJxI", function(module, exports) {
"use strict";
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("bqlx5", function(module, exports) {
"use strict";
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("026v5", function(module, exports) {
"use strict";
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("76C2Q", function(module, exports) {
"use strict";
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("lQzMC", function(module, exports) {
"use strict";
var $fe7a361221d0a778$var$origSymbol = typeof Symbol !== "undefined" && Symbol;

var $7hv1u = parcelRequire("7hv1u");
module.exports = function hasNativeSymbols() {
    if (typeof $fe7a361221d0a778$var$origSymbol !== "function") return false;
    if (typeof Symbol !== "function") return false;
    if (typeof $fe7a361221d0a778$var$origSymbol("foo") !== "symbol") return false;
    if (typeof Symbol("bar") !== "symbol") return false;
    return $7hv1u();
};

});
parcelRegister("7hv1u", function(module, exports) {
"use strict";
/* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== "function" || typeof Object.getOwnPropertySymbols !== "function") return false;
    if (typeof Symbol.iterator === "symbol") return true;
    var obj = {};
    var sym = Symbol("test");
    var symObj = Object(sym);
    if (typeof sym === "string") return false;
    if (Object.prototype.toString.call(sym) !== "[object Symbol]") return false;
    if (Object.prototype.toString.call(symObj) !== "[object Symbol]") return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === "function" && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === "function" && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === "function") {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("bSjoV", function(module, exports) {
"use strict";
var $8a53c97cbe1093ef$var$test = {
    __proto__: null,
    foo: {}
};
var $8a53c97cbe1093ef$var$$Object = Object;
/** @type {import('.')} */ module.exports = function hasProto() {
    // @ts-expect-error: TS errors on an inherited property for some reason
    return ({
        __proto__: $8a53c97cbe1093ef$var$test
    }).foo === $8a53c97cbe1093ef$var$test.foo && !($8a53c97cbe1093ef$var$test instanceof $8a53c97cbe1093ef$var$$Object);
};

});

parcelRegister("gp6Md", function(module, exports) {
"use strict";

var $deccf = parcelRequire("deccf");
module.exports = Function.prototype.bind || $deccf;

});
parcelRegister("deccf", function(module, exports) {
"use strict";
/* eslint no-invalid-this: 1 */ var $9a160b217144f5c7$var$ERROR_MESSAGE = "Function.prototype.bind called on incompatible ";
var $9a160b217144f5c7$var$toStr = Object.prototype.toString;
var $9a160b217144f5c7$var$max = Math.max;
var $9a160b217144f5c7$var$funcType = "[object Function]";
var $9a160b217144f5c7$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $9a160b217144f5c7$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $9a160b217144f5c7$var$joiny = function(arr, joiner) {
    var str = "";
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== "function" || $9a160b217144f5c7$var$toStr.apply(target) !== $9a160b217144f5c7$var$funcType) throw new TypeError($9a160b217144f5c7$var$ERROR_MESSAGE + target);
    var args = $9a160b217144f5c7$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $9a160b217144f5c7$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $9a160b217144f5c7$var$concatty(args, arguments));
    };
    var boundLength = $9a160b217144f5c7$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = "$" + i;
    bound = Function("binder", "return function (" + $9a160b217144f5c7$var$joiny(boundArgs, ",") + "){ return binder.apply(this,arguments); }")(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("hAbsx", function(module, exports) {
"use strict";
var $ccceb00f50cb028c$var$call = Function.prototype.call;
var $ccceb00f50cb028c$var$$hasOwn = Object.prototype.hasOwnProperty;

var $gp6Md = parcelRequire("gp6Md");
/** @type {import('.')} */ module.exports = $gp6Md.call($ccceb00f50cb028c$var$call, $ccceb00f50cb028c$var$$hasOwn);

});


parcelRegister("kKGfz", function(module, exports) {
"use strict";

var $a5n6m = parcelRequire("a5n6m");

var $6smyX = parcelRequire("6smyX");
var $f1b8e087f7d18a93$var$$indexOf = $6smyX($a5n6m("String.prototype.indexOf"));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $a5n6m(name, !!allowMissing);
    if (typeof intrinsic === "function" && $f1b8e087f7d18a93$var$$indexOf(name, ".prototype.") > -1) return $6smyX(intrinsic);
    return intrinsic;
};

});
parcelRegister("6smyX", function(module, exports) {
"use strict";

var $gp6Md = parcelRequire("gp6Md");

var $a5n6m = parcelRequire("a5n6m");

var $cjVNf = parcelRequire("cjVNf");

var $026v5 = parcelRequire("026v5");
var $4b36dc1f6fa12fd8$var$$apply = $a5n6m("%Function.prototype.apply%");
var $4b36dc1f6fa12fd8$var$$call = $a5n6m("%Function.prototype.call%");
var $4b36dc1f6fa12fd8$var$$reflectApply = $a5n6m("%Reflect.apply%", true) || $gp6Md.call($4b36dc1f6fa12fd8$var$$call, $4b36dc1f6fa12fd8$var$$apply);

var $7areF = parcelRequire("7areF");
var $4b36dc1f6fa12fd8$var$$max = $a5n6m("%Math.max%");
module.exports = function callBind(originalFunction) {
    if (typeof originalFunction !== "function") throw new $026v5("a function is required");
    var func = $4b36dc1f6fa12fd8$var$$reflectApply($gp6Md, $4b36dc1f6fa12fd8$var$$call, arguments);
    return $cjVNf(func, 1 + $4b36dc1f6fa12fd8$var$$max(0, originalFunction.length - (arguments.length - 1)), true);
};
var $4b36dc1f6fa12fd8$var$applyBind = function applyBind() {
    return $4b36dc1f6fa12fd8$var$$reflectApply($gp6Md, $4b36dc1f6fa12fd8$var$$apply, arguments);
};
if ($7areF) $7areF(module.exports, "apply", {
    value: $4b36dc1f6fa12fd8$var$applyBind
});
else module.exports.apply = $4b36dc1f6fa12fd8$var$applyBind;

});
parcelRegister("cjVNf", function(module, exports) {
"use strict";

var $a5n6m = parcelRequire("a5n6m");

var $hb7F2 = parcelRequire("hb7F2");

var $8f8416f0236d3ccb$var$hasDescriptors = (parcelRequire("fyUVU"))();

var $4dUzo = parcelRequire("4dUzo");

var $026v5 = parcelRequire("026v5");
var $8f8416f0236d3ccb$var$$floor = $a5n6m("%Math.floor%");
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== "function") throw new $026v5("`fn` is not a function");
    if (typeof length !== "number" || length < 0 || length > 0xFFFFFFFF || $8f8416f0236d3ccb$var$$floor(length) !== length) throw new $026v5("`length` must be a positive 32-bit integer");
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ("length" in fn && $4dUzo) {
        var desc = $4dUzo(fn, "length");
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($8f8416f0236d3ccb$var$hasDescriptors) $hb7F2(/** @type {Parameters<define>[0]} */ fn, "length", length, true, true);
        else $hb7F2(/** @type {Parameters<define>[0]} */ fn, "length", length);
    }
    return fn;
};

});
parcelRegister("hb7F2", function(module, exports) {
"use strict";

var $7areF = parcelRequire("7areF");

var $bqlx5 = parcelRequire("bqlx5");

var $026v5 = parcelRequire("026v5");

var $4dUzo = parcelRequire("4dUzo");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== "object" && typeof obj !== "function") throw new $026v5("`obj` must be an object or a function`");
    if (typeof property !== "string" && typeof property !== "symbol") throw new $026v5("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] !== "boolean" && arguments[3] !== null) throw new $026v5("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] !== "boolean" && arguments[4] !== null) throw new $026v5("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] !== "boolean" && arguments[5] !== null) throw new $026v5("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] !== "boolean") throw new $026v5("`loose`, if provided, must be a boolean");
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$4dUzo && $4dUzo(obj, property);
    if ($7areF) $7areF(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $bqlx5("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
};

});
parcelRegister("7areF", function(module, exports) {
"use strict";

var $a5n6m = parcelRequire("a5n6m");
/** @type {import('.')} */ var $537e97fa37d58bec$var$$defineProperty = $a5n6m("%Object.defineProperty%", true) || false;
if ($537e97fa37d58bec$var$$defineProperty) try {
    $537e97fa37d58bec$var$$defineProperty({}, "a", {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $537e97fa37d58bec$var$$defineProperty = false;
}
module.exports = $537e97fa37d58bec$var$$defineProperty;

});

parcelRegister("4dUzo", function(module, exports) {
"use strict";

var $a5n6m = parcelRequire("a5n6m");
var $313441efb54739f6$var$$gOPD = $a5n6m("%Object.getOwnPropertyDescriptor%", true);
if ($313441efb54739f6$var$$gOPD) try {
    $313441efb54739f6$var$$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $313441efb54739f6$var$$gOPD = null;
}
module.exports = $313441efb54739f6$var$$gOPD;

});


parcelRegister("fyUVU", function(module, exports) {
"use strict";

var $7areF = parcelRequire("7areF");
var $b54631b3d44dc8a5$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$7areF;
};
$b54631b3d44dc8a5$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$7areF) return null;
    try {
        return $7areF([], "length", {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $b54631b3d44dc8a5$var$hasPropertyDescriptors;

});




parcelRegister("9rcLO", function(module, exports) {
var $6df08a95fa43bae0$var$hasMap = typeof Map === "function" && Map.prototype;
var $6df08a95fa43bae0$var$mapSizeDescriptor = Object.getOwnPropertyDescriptor && $6df08a95fa43bae0$var$hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, "size") : null;
var $6df08a95fa43bae0$var$mapSize = $6df08a95fa43bae0$var$hasMap && $6df08a95fa43bae0$var$mapSizeDescriptor && typeof $6df08a95fa43bae0$var$mapSizeDescriptor.get === "function" ? $6df08a95fa43bae0$var$mapSizeDescriptor.get : null;
var $6df08a95fa43bae0$var$mapForEach = $6df08a95fa43bae0$var$hasMap && Map.prototype.forEach;
var $6df08a95fa43bae0$var$hasSet = typeof Set === "function" && Set.prototype;
var $6df08a95fa43bae0$var$setSizeDescriptor = Object.getOwnPropertyDescriptor && $6df08a95fa43bae0$var$hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, "size") : null;
var $6df08a95fa43bae0$var$setSize = $6df08a95fa43bae0$var$hasSet && $6df08a95fa43bae0$var$setSizeDescriptor && typeof $6df08a95fa43bae0$var$setSizeDescriptor.get === "function" ? $6df08a95fa43bae0$var$setSizeDescriptor.get : null;
var $6df08a95fa43bae0$var$setForEach = $6df08a95fa43bae0$var$hasSet && Set.prototype.forEach;
var $6df08a95fa43bae0$var$hasWeakMap = typeof WeakMap === "function" && WeakMap.prototype;
var $6df08a95fa43bae0$var$weakMapHas = $6df08a95fa43bae0$var$hasWeakMap ? WeakMap.prototype.has : null;
var $6df08a95fa43bae0$var$hasWeakSet = typeof WeakSet === "function" && WeakSet.prototype;
var $6df08a95fa43bae0$var$weakSetHas = $6df08a95fa43bae0$var$hasWeakSet ? WeakSet.prototype.has : null;
var $6df08a95fa43bae0$var$hasWeakRef = typeof WeakRef === "function" && WeakRef.prototype;
var $6df08a95fa43bae0$var$weakRefDeref = $6df08a95fa43bae0$var$hasWeakRef ? WeakRef.prototype.deref : null;
var $6df08a95fa43bae0$var$booleanValueOf = Boolean.prototype.valueOf;
var $6df08a95fa43bae0$var$objectToString = Object.prototype.toString;
var $6df08a95fa43bae0$var$functionToString = Function.prototype.toString;
var $6df08a95fa43bae0$var$$match = String.prototype.match;
var $6df08a95fa43bae0$var$$slice = String.prototype.slice;
var $6df08a95fa43bae0$var$$replace = String.prototype.replace;
var $6df08a95fa43bae0$var$$toUpperCase = String.prototype.toUpperCase;
var $6df08a95fa43bae0$var$$toLowerCase = String.prototype.toLowerCase;
var $6df08a95fa43bae0$var$$test = RegExp.prototype.test;
var $6df08a95fa43bae0$var$$concat = Array.prototype.concat;
var $6df08a95fa43bae0$var$$join = Array.prototype.join;
var $6df08a95fa43bae0$var$$arrSlice = Array.prototype.slice;
var $6df08a95fa43bae0$var$$floor = Math.floor;
var $6df08a95fa43bae0$var$bigIntValueOf = typeof BigInt === "function" ? BigInt.prototype.valueOf : null;
var $6df08a95fa43bae0$var$gOPS = Object.getOwnPropertySymbols;
var $6df08a95fa43bae0$var$symToString = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? Symbol.prototype.toString : null;
var $6df08a95fa43bae0$var$hasShammedSymbols = typeof Symbol === "function" && typeof Symbol.iterator === "object";
// ie, `has-tostringtag/shams
var $6df08a95fa43bae0$var$toStringTag = typeof Symbol === "function" && Symbol.toStringTag && (typeof Symbol.toStringTag === $6df08a95fa43bae0$var$hasShammedSymbols ? "object" : "symbol") ? Symbol.toStringTag : null;
var $6df08a95fa43bae0$var$isEnumerable = Object.prototype.propertyIsEnumerable;
var $6df08a95fa43bae0$var$gPO = (typeof Reflect === "function" ? Reflect.getPrototypeOf : Object.getPrototypeOf) || ([].__proto__ === Array.prototype // eslint-disable-line no-proto
 ? function(O) {
    return O.__proto__; // eslint-disable-line no-proto
} : null);
function $6df08a95fa43bae0$var$addNumericSeparator(num, str) {
    if (num === Infinity || num === -Infinity || num !== num || num && num > -1000 && num < 1000 || $6df08a95fa43bae0$var$$test.call(/e/, str)) return str;
    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
    if (typeof num === "number") {
        var int = num < 0 ? -$6df08a95fa43bae0$var$$floor(-num) : $6df08a95fa43bae0$var$$floor(num); // trunc(num)
        if (int !== num) {
            var intStr = String(int);
            var dec = $6df08a95fa43bae0$var$$slice.call(str, intStr.length + 1);
            return $6df08a95fa43bae0$var$$replace.call(intStr, sepRegex, "$&_") + "." + $6df08a95fa43bae0$var$$replace.call($6df08a95fa43bae0$var$$replace.call(dec, /([0-9]{3})/g, "$&_"), /_$/, "");
        }
    }
    return $6df08a95fa43bae0$var$$replace.call(str, sepRegex, "$&_");
}

var $ls837 = parcelRequire("ls837");
var $6df08a95fa43bae0$var$inspectCustom = $ls837.custom;
var $6df08a95fa43bae0$var$inspectSymbol = $6df08a95fa43bae0$var$isSymbol($6df08a95fa43bae0$var$inspectCustom) ? $6df08a95fa43bae0$var$inspectCustom : null;
module.exports = function inspect_(obj, options, depth, seen) {
    var opts = options || {};
    if ($6df08a95fa43bae0$var$has(opts, "quoteStyle") && opts.quoteStyle !== "single" && opts.quoteStyle !== "double") throw new TypeError('option "quoteStyle" must be "single" or "double"');
    if ($6df08a95fa43bae0$var$has(opts, "maxStringLength") && (typeof opts.maxStringLength === "number" ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity : opts.maxStringLength !== null)) throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
    var customInspect = $6df08a95fa43bae0$var$has(opts, "customInspect") ? opts.customInspect : true;
    if (typeof customInspect !== "boolean" && customInspect !== "symbol") throw new TypeError("option \"customInspect\", if provided, must be `true`, `false`, or `'symbol'`");
    if ($6df08a95fa43bae0$var$has(opts, "indent") && opts.indent !== null && opts.indent !== "	" && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)) throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
    if ($6df08a95fa43bae0$var$has(opts, "numericSeparator") && typeof opts.numericSeparator !== "boolean") throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
    var numericSeparator = opts.numericSeparator;
    if (typeof obj === "undefined") return "undefined";
    if (obj === null) return "null";
    if (typeof obj === "boolean") return obj ? "true" : "false";
    if (typeof obj === "string") return $6df08a95fa43bae0$var$inspectString(obj, opts);
    if (typeof obj === "number") {
        if (obj === 0) return Infinity / obj > 0 ? "0" : "-0";
        var str = String(obj);
        return numericSeparator ? $6df08a95fa43bae0$var$addNumericSeparator(obj, str) : str;
    }
    if (typeof obj === "bigint") {
        var bigIntStr = String(obj) + "n";
        return numericSeparator ? $6df08a95fa43bae0$var$addNumericSeparator(obj, bigIntStr) : bigIntStr;
    }
    var maxDepth = typeof opts.depth === "undefined" ? 5 : opts.depth;
    if (typeof depth === "undefined") depth = 0;
    if (depth >= maxDepth && maxDepth > 0 && typeof obj === "object") return $6df08a95fa43bae0$var$isArray(obj) ? "[Array]" : "[Object]";
    var indent = $6df08a95fa43bae0$var$getIndent(opts, depth);
    if (typeof seen === "undefined") seen = [];
    else if ($6df08a95fa43bae0$var$indexOf(seen, obj) >= 0) return "[Circular]";
    function inspect(value, from, noIndent) {
        if (from) {
            seen = $6df08a95fa43bae0$var$$arrSlice.call(seen);
            seen.push(from);
        }
        if (noIndent) {
            var newOpts = {
                depth: opts.depth
            };
            if ($6df08a95fa43bae0$var$has(opts, "quoteStyle")) newOpts.quoteStyle = opts.quoteStyle;
            return inspect_(value, newOpts, depth + 1, seen);
        }
        return inspect_(value, opts, depth + 1, seen);
    }
    if (typeof obj === "function" && !$6df08a95fa43bae0$var$isRegExp(obj)) {
        var name = $6df08a95fa43bae0$var$nameOf(obj);
        var keys = $6df08a95fa43bae0$var$arrObjKeys(obj, inspect);
        return "[Function" + (name ? ": " + name : " (anonymous)") + "]" + (keys.length > 0 ? " { " + $6df08a95fa43bae0$var$$join.call(keys, ", ") + " }" : "");
    }
    if ($6df08a95fa43bae0$var$isSymbol(obj)) {
        var symString = $6df08a95fa43bae0$var$hasShammedSymbols ? $6df08a95fa43bae0$var$$replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, "$1") : $6df08a95fa43bae0$var$symToString.call(obj);
        return typeof obj === "object" && !$6df08a95fa43bae0$var$hasShammedSymbols ? $6df08a95fa43bae0$var$markBoxed(symString) : symString;
    }
    if ($6df08a95fa43bae0$var$isElement(obj)) {
        var s = "<" + $6df08a95fa43bae0$var$$toLowerCase.call(String(obj.nodeName));
        var attrs = obj.attributes || [];
        for(var i = 0; i < attrs.length; i++)s += " " + attrs[i].name + "=" + $6df08a95fa43bae0$var$wrapQuotes($6df08a95fa43bae0$var$quote(attrs[i].value), "double", opts);
        s += ">";
        if (obj.childNodes && obj.childNodes.length) s += "...";
        s += "</" + $6df08a95fa43bae0$var$$toLowerCase.call(String(obj.nodeName)) + ">";
        return s;
    }
    if ($6df08a95fa43bae0$var$isArray(obj)) {
        if (obj.length === 0) return "[]";
        var xs = $6df08a95fa43bae0$var$arrObjKeys(obj, inspect);
        if (indent && !$6df08a95fa43bae0$var$singleLineValues(xs)) return "[" + $6df08a95fa43bae0$var$indentedJoin(xs, indent) + "]";
        return "[ " + $6df08a95fa43bae0$var$$join.call(xs, ", ") + " ]";
    }
    if ($6df08a95fa43bae0$var$isError(obj)) {
        var parts = $6df08a95fa43bae0$var$arrObjKeys(obj, inspect);
        if (!("cause" in Error.prototype) && "cause" in obj && !$6df08a95fa43bae0$var$isEnumerable.call(obj, "cause")) return "{ [" + String(obj) + "] " + $6df08a95fa43bae0$var$$join.call($6df08a95fa43bae0$var$$concat.call("[cause]: " + inspect(obj.cause), parts), ", ") + " }";
        if (parts.length === 0) return "[" + String(obj) + "]";
        return "{ [" + String(obj) + "] " + $6df08a95fa43bae0$var$$join.call(parts, ", ") + " }";
    }
    if (typeof obj === "object" && customInspect) {
        if ($6df08a95fa43bae0$var$inspectSymbol && typeof obj[$6df08a95fa43bae0$var$inspectSymbol] === "function" && $ls837) return $ls837(obj, {
            depth: maxDepth - depth
        });
        else if (customInspect !== "symbol" && typeof obj.inspect === "function") return obj.inspect();
    }
    if ($6df08a95fa43bae0$var$isMap(obj)) {
        var mapParts = [];
        if ($6df08a95fa43bae0$var$mapForEach) $6df08a95fa43bae0$var$mapForEach.call(obj, function(value, key) {
            mapParts.push(inspect(key, obj, true) + " => " + inspect(value, obj));
        });
        return $6df08a95fa43bae0$var$collectionOf("Map", $6df08a95fa43bae0$var$mapSize.call(obj), mapParts, indent);
    }
    if ($6df08a95fa43bae0$var$isSet(obj)) {
        var setParts = [];
        if ($6df08a95fa43bae0$var$setForEach) $6df08a95fa43bae0$var$setForEach.call(obj, function(value) {
            setParts.push(inspect(value, obj));
        });
        return $6df08a95fa43bae0$var$collectionOf("Set", $6df08a95fa43bae0$var$setSize.call(obj), setParts, indent);
    }
    if ($6df08a95fa43bae0$var$isWeakMap(obj)) return $6df08a95fa43bae0$var$weakCollectionOf("WeakMap");
    if ($6df08a95fa43bae0$var$isWeakSet(obj)) return $6df08a95fa43bae0$var$weakCollectionOf("WeakSet");
    if ($6df08a95fa43bae0$var$isWeakRef(obj)) return $6df08a95fa43bae0$var$weakCollectionOf("WeakRef");
    if ($6df08a95fa43bae0$var$isNumber(obj)) return $6df08a95fa43bae0$var$markBoxed(inspect(Number(obj)));
    if ($6df08a95fa43bae0$var$isBigInt(obj)) return $6df08a95fa43bae0$var$markBoxed(inspect($6df08a95fa43bae0$var$bigIntValueOf.call(obj)));
    if ($6df08a95fa43bae0$var$isBoolean(obj)) return $6df08a95fa43bae0$var$markBoxed($6df08a95fa43bae0$var$booleanValueOf.call(obj));
    if ($6df08a95fa43bae0$var$isString(obj)) return $6df08a95fa43bae0$var$markBoxed(inspect(String(obj)));
    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
    /* eslint-env browser */ if (typeof window !== "undefined" && obj === window) return "{ [object Window] }";
    if (obj === $parcel$global) return "{ [object globalThis] }";
    if (!$6df08a95fa43bae0$var$isDate(obj) && !$6df08a95fa43bae0$var$isRegExp(obj)) {
        var ys = $6df08a95fa43bae0$var$arrObjKeys(obj, inspect);
        var isPlainObject = $6df08a95fa43bae0$var$gPO ? $6df08a95fa43bae0$var$gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
        var protoTag = obj instanceof Object ? "" : "null prototype";
        var stringTag = !isPlainObject && $6df08a95fa43bae0$var$toStringTag && Object(obj) === obj && $6df08a95fa43bae0$var$toStringTag in obj ? $6df08a95fa43bae0$var$$slice.call($6df08a95fa43bae0$var$toStr(obj), 8, -1) : protoTag ? "Object" : "";
        var constructorTag = isPlainObject || typeof obj.constructor !== "function" ? "" : obj.constructor.name ? obj.constructor.name + " " : "";
        var tag = constructorTag + (stringTag || protoTag ? "[" + $6df08a95fa43bae0$var$$join.call($6df08a95fa43bae0$var$$concat.call([], stringTag || [], protoTag || []), ": ") + "] " : "");
        if (ys.length === 0) return tag + "{}";
        if (indent) return tag + "{" + $6df08a95fa43bae0$var$indentedJoin(ys, indent) + "}";
        return tag + "{ " + $6df08a95fa43bae0$var$$join.call(ys, ", ") + " }";
    }
    return String(obj);
};
function $6df08a95fa43bae0$var$wrapQuotes(s, defaultStyle, opts) {
    var quoteChar = (opts.quoteStyle || defaultStyle) === "double" ? '"' : "'";
    return quoteChar + s + quoteChar;
}
function $6df08a95fa43bae0$var$quote(s) {
    return $6df08a95fa43bae0$var$$replace.call(String(s), /"/g, "&quot;");
}
function $6df08a95fa43bae0$var$isArray(obj) {
    return $6df08a95fa43bae0$var$toStr(obj) === "[object Array]" && (!$6df08a95fa43bae0$var$toStringTag || !(typeof obj === "object" && $6df08a95fa43bae0$var$toStringTag in obj));
}
function $6df08a95fa43bae0$var$isDate(obj) {
    return $6df08a95fa43bae0$var$toStr(obj) === "[object Date]" && (!$6df08a95fa43bae0$var$toStringTag || !(typeof obj === "object" && $6df08a95fa43bae0$var$toStringTag in obj));
}
function $6df08a95fa43bae0$var$isRegExp(obj) {
    return $6df08a95fa43bae0$var$toStr(obj) === "[object RegExp]" && (!$6df08a95fa43bae0$var$toStringTag || !(typeof obj === "object" && $6df08a95fa43bae0$var$toStringTag in obj));
}
function $6df08a95fa43bae0$var$isError(obj) {
    return $6df08a95fa43bae0$var$toStr(obj) === "[object Error]" && (!$6df08a95fa43bae0$var$toStringTag || !(typeof obj === "object" && $6df08a95fa43bae0$var$toStringTag in obj));
}
function $6df08a95fa43bae0$var$isString(obj) {
    return $6df08a95fa43bae0$var$toStr(obj) === "[object String]" && (!$6df08a95fa43bae0$var$toStringTag || !(typeof obj === "object" && $6df08a95fa43bae0$var$toStringTag in obj));
}
function $6df08a95fa43bae0$var$isNumber(obj) {
    return $6df08a95fa43bae0$var$toStr(obj) === "[object Number]" && (!$6df08a95fa43bae0$var$toStringTag || !(typeof obj === "object" && $6df08a95fa43bae0$var$toStringTag in obj));
}
function $6df08a95fa43bae0$var$isBoolean(obj) {
    return $6df08a95fa43bae0$var$toStr(obj) === "[object Boolean]" && (!$6df08a95fa43bae0$var$toStringTag || !(typeof obj === "object" && $6df08a95fa43bae0$var$toStringTag in obj));
}
// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
function $6df08a95fa43bae0$var$isSymbol(obj) {
    if ($6df08a95fa43bae0$var$hasShammedSymbols) return obj && typeof obj === "object" && obj instanceof Symbol;
    if (typeof obj === "symbol") return true;
    if (!obj || typeof obj !== "object" || !$6df08a95fa43bae0$var$symToString) return false;
    try {
        $6df08a95fa43bae0$var$symToString.call(obj);
        return true;
    } catch (e) {}
    return false;
}
function $6df08a95fa43bae0$var$isBigInt(obj) {
    if (!obj || typeof obj !== "object" || !$6df08a95fa43bae0$var$bigIntValueOf) return false;
    try {
        $6df08a95fa43bae0$var$bigIntValueOf.call(obj);
        return true;
    } catch (e) {}
    return false;
}
var $6df08a95fa43bae0$var$hasOwn = Object.prototype.hasOwnProperty || function(key) {
    return key in this;
};
function $6df08a95fa43bae0$var$has(obj, key) {
    return $6df08a95fa43bae0$var$hasOwn.call(obj, key);
}
function $6df08a95fa43bae0$var$toStr(obj) {
    return $6df08a95fa43bae0$var$objectToString.call(obj);
}
function $6df08a95fa43bae0$var$nameOf(f) {
    if (f.name) return f.name;
    var m = $6df08a95fa43bae0$var$$match.call($6df08a95fa43bae0$var$functionToString.call(f), /^function\s*([\w$]+)/);
    if (m) return m[1];
    return null;
}
function $6df08a95fa43bae0$var$indexOf(xs, x) {
    if (xs.indexOf) return xs.indexOf(x);
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
function $6df08a95fa43bae0$var$isMap(x) {
    if (!$6df08a95fa43bae0$var$mapSize || !x || typeof x !== "object") return false;
    try {
        $6df08a95fa43bae0$var$mapSize.call(x);
        try {
            $6df08a95fa43bae0$var$setSize.call(x);
        } catch (s) {
            return true;
        }
        return x instanceof Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $6df08a95fa43bae0$var$isWeakMap(x) {
    if (!$6df08a95fa43bae0$var$weakMapHas || !x || typeof x !== "object") return false;
    try {
        $6df08a95fa43bae0$var$weakMapHas.call(x, $6df08a95fa43bae0$var$weakMapHas);
        try {
            $6df08a95fa43bae0$var$weakSetHas.call(x, $6df08a95fa43bae0$var$weakSetHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $6df08a95fa43bae0$var$isWeakRef(x) {
    if (!$6df08a95fa43bae0$var$weakRefDeref || !x || typeof x !== "object") return false;
    try {
        $6df08a95fa43bae0$var$weakRefDeref.call(x);
        return true;
    } catch (e) {}
    return false;
}
function $6df08a95fa43bae0$var$isSet(x) {
    if (!$6df08a95fa43bae0$var$setSize || !x || typeof x !== "object") return false;
    try {
        $6df08a95fa43bae0$var$setSize.call(x);
        try {
            $6df08a95fa43bae0$var$mapSize.call(x);
        } catch (m) {
            return true;
        }
        return x instanceof Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $6df08a95fa43bae0$var$isWeakSet(x) {
    if (!$6df08a95fa43bae0$var$weakSetHas || !x || typeof x !== "object") return false;
    try {
        $6df08a95fa43bae0$var$weakSetHas.call(x, $6df08a95fa43bae0$var$weakSetHas);
        try {
            $6df08a95fa43bae0$var$weakMapHas.call(x, $6df08a95fa43bae0$var$weakMapHas);
        } catch (s) {
            return true;
        }
        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
}
function $6df08a95fa43bae0$var$isElement(x) {
    if (!x || typeof x !== "object") return false;
    if (typeof HTMLElement !== "undefined" && x instanceof HTMLElement) return true;
    return typeof x.nodeName === "string" && typeof x.getAttribute === "function";
}
function $6df08a95fa43bae0$var$inspectString(str, opts) {
    if (str.length > opts.maxStringLength) {
        var remaining = str.length - opts.maxStringLength;
        var trailer = "... " + remaining + " more character" + (remaining > 1 ? "s" : "");
        return $6df08a95fa43bae0$var$inspectString($6df08a95fa43bae0$var$$slice.call(str, 0, opts.maxStringLength), opts) + trailer;
    }
    // eslint-disable-next-line no-control-regex
    var s = $6df08a95fa43bae0$var$$replace.call($6df08a95fa43bae0$var$$replace.call(str, /(['\\])/g, "\\$1"), /[\x00-\x1f]/g, $6df08a95fa43bae0$var$lowbyte);
    return $6df08a95fa43bae0$var$wrapQuotes(s, "single", opts);
}
function $6df08a95fa43bae0$var$lowbyte(c) {
    var n = c.charCodeAt(0);
    var x = {
        8: "b",
        9: "t",
        10: "n",
        12: "f",
        13: "r"
    }[n];
    if (x) return "\\" + x;
    return "\\x" + (n < 0x10 ? "0" : "") + $6df08a95fa43bae0$var$$toUpperCase.call(n.toString(16));
}
function $6df08a95fa43bae0$var$markBoxed(str) {
    return "Object(" + str + ")";
}
function $6df08a95fa43bae0$var$weakCollectionOf(type) {
    return type + " { ? }";
}
function $6df08a95fa43bae0$var$collectionOf(type, size, entries, indent) {
    var joinedEntries = indent ? $6df08a95fa43bae0$var$indentedJoin(entries, indent) : $6df08a95fa43bae0$var$$join.call(entries, ", ");
    return type + " (" + size + ") {" + joinedEntries + "}";
}
function $6df08a95fa43bae0$var$singleLineValues(xs) {
    for(var i = 0; i < xs.length; i++){
        if ($6df08a95fa43bae0$var$indexOf(xs[i], "\n") >= 0) return false;
    }
    return true;
}
function $6df08a95fa43bae0$var$getIndent(opts, depth) {
    var baseIndent;
    if (opts.indent === "	") baseIndent = "	";
    else if (typeof opts.indent === "number" && opts.indent > 0) baseIndent = $6df08a95fa43bae0$var$$join.call(Array(opts.indent + 1), " ");
    else return null;
    return {
        base: baseIndent,
        prev: $6df08a95fa43bae0$var$$join.call(Array(depth + 1), baseIndent)
    };
}
function $6df08a95fa43bae0$var$indentedJoin(xs, indent) {
    if (xs.length === 0) return "";
    var lineJoiner = "\n" + indent.prev + indent.base;
    return lineJoiner + $6df08a95fa43bae0$var$$join.call(xs, "," + lineJoiner) + "\n" + indent.prev;
}
function $6df08a95fa43bae0$var$arrObjKeys(obj, inspect) {
    var isArr = $6df08a95fa43bae0$var$isArray(obj);
    var xs = [];
    if (isArr) {
        xs.length = obj.length;
        for(var i = 0; i < obj.length; i++)xs[i] = $6df08a95fa43bae0$var$has(obj, i) ? inspect(obj[i], obj) : "";
    }
    var syms = typeof $6df08a95fa43bae0$var$gOPS === "function" ? $6df08a95fa43bae0$var$gOPS(obj) : [];
    var symMap;
    if ($6df08a95fa43bae0$var$hasShammedSymbols) {
        symMap = {};
        for(var k = 0; k < syms.length; k++)symMap["$" + syms[k]] = syms[k];
    }
    for(var key in obj){
        if (!$6df08a95fa43bae0$var$has(obj, key)) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if (isArr && String(Number(key)) === key && key < obj.length) continue;
         // eslint-disable-line no-restricted-syntax, no-continue
        if ($6df08a95fa43bae0$var$hasShammedSymbols && symMap["$" + key] instanceof Symbol) continue; // eslint-disable-line no-restricted-syntax, no-continue
        else if ($6df08a95fa43bae0$var$$test.call(/[^\w$]/, key)) xs.push(inspect(key, obj) + ": " + inspect(obj[key], obj));
        else xs.push(key + ": " + inspect(obj[key], obj));
    }
    if (typeof $6df08a95fa43bae0$var$gOPS === "function") {
        for(var j = 0; j < syms.length; j++)if ($6df08a95fa43bae0$var$isEnumerable.call(obj, syms[j])) xs.push("[" + inspect(syms[j]) + "]: " + inspect(obj[syms[j]], obj));
    }
    return xs;
}

});
parcelRegister("ls837", function(module, exports) {
"use strict";

});



parcelRegister("hxqGH", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", function () { return isNodeEnv; }, function (v) { return isNodeEnv = v; });
$parcel$export(module.exports, "dynamicRequire", function () { return dynamicRequire; }, function (v) { return dynamicRequire = v; });

var $jNciV = parcelRequire("jNciV");

var $hKTDd = parcelRequire("hKTDd");

var $33y03 = parcelRequire("33y03");
function isNodeEnv() {
    return Object.prototype.toString.call(typeof $33y03 !== "undefined" ? $33y03 : 0) === "[object process]";
}
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/** Default request keys that'll be used to extract data from the request */ var DEFAULT_REQUEST_KEYS = [
    "cookies",
    "data",
    "headers",
    "method",
    "query_string",
    "url"
];
function extractNodeRequestData(req, keys) {
    if (keys === void 0) keys = DEFAULT_REQUEST_KEYS;
    // make sure we can safely use dynamicRequire below
    if (!isNodeEnv()) throw new Error("Can't get node request data outside of a node environment");
    var requestData = {};
    // headers:
    //   node, express: req.headers
    //   koa: req.header
    var headers = req.headers || req.header || {};
    // method:
    //   node, express, koa: req.method
    var method = req.method;
    // host:
    //   express: req.hostname in > 4 and req.host in < 4
    //   koa: req.host
    //   node: req.headers.host
    var host = req.hostname || req.host || headers.host || "<no host>";
    // protocol:
    //   node: <n/a>
    //   express, koa: req.protocol
    var protocol = req.protocol === "https" || req.secure || (req.socket || {}).encrypted ? "https" : "http";
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa: req.url
    var originalUrl = req.originalUrl || req.url || "";
    // absolute url
    var absoluteUrl = protocol + "://" + host + originalUrl;
    keys.forEach(function(key) {
        switch(key){
            case "headers":
                requestData.headers = headers;
                break;
            case "method":
                requestData.method = method;
                break;
            case "url":
                requestData.url = absoluteUrl;
                break;
            case "cookies":
                // cookies:
                //   node, express, koa: req.headers.cookie
                //   vercel, sails.js, express (w/ cookie middleware): req.cookies
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.cookies = req.cookies || dynamicRequire(module, "cookie").parse(headers.cookie || "");
                break;
            case "query_string":
                // query string:
                //   node: req.url (raw)
                //   express, koa: req.query
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.query_string = dynamicRequire(module, "url").parse(originalUrl || "", false).query;
                break;
            case "data":
                if (method === "GET" || method === "HEAD") break;
                // body data:
                //   node, express, koa: req.body
                if (req.body !== undefined) requestData.data = (0, $jNciV.isString)(req.body) ? req.body : JSON.stringify((0, $hKTDd.normalize)(req.body));
                break;
            default:
                if (({}).hasOwnProperty.call(req, key)) requestData[key] = req[key];
        }
    });
    return requestData;
}

});
parcelRegister("jNciV", function(module, exports) {

$parcel$export(module.exports, "isError", function () { return $e68c23511f7249ac$export$e6127cc7fe7395c3; });
$parcel$export(module.exports, "isInstanceOf", function () { return $e68c23511f7249ac$export$49034edbe6b62415; });
$parcel$export(module.exports, "isErrorEvent", function () { return $e68c23511f7249ac$export$9f9636d330b71954; });
$parcel$export(module.exports, "isDOMError", function () { return $e68c23511f7249ac$export$ef9e2056653f0c8e; });
$parcel$export(module.exports, "isDOMException", function () { return $e68c23511f7249ac$export$12e869b2a583f783; });
$parcel$export(module.exports, "isString", function () { return $e68c23511f7249ac$export$844ec244b1367d54; });
$parcel$export(module.exports, "isPrimitive", function () { return $e68c23511f7249ac$export$c3825b437cbdea5c; });
$parcel$export(module.exports, "isPlainObject", function () { return $e68c23511f7249ac$export$53b83ca8eaab0383; });
$parcel$export(module.exports, "isEvent", function () { return $e68c23511f7249ac$export$9671ea99bd126ace; });
$parcel$export(module.exports, "isElement", function () { return $e68c23511f7249ac$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isRegExp", function () { return $e68c23511f7249ac$export$49841c62b9eff15; });
$parcel$export(module.exports, "isThenable", function () { return $e68c23511f7249ac$export$f5b060c2914b97c8; });
$parcel$export(module.exports, "isSyntheticEvent", function () { return $e68c23511f7249ac$export$bc2894c7158efbac; });
/* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $e68c23511f7249ac$export$e6127cc7fe7395c3(wat) {
    switch(Object.prototype.toString.call(wat)){
        case "[object Error]":
            return true;
        case "[object Exception]":
            return true;
        case "[object DOMException]":
            return true;
        default:
            return $e68c23511f7249ac$export$49034edbe6b62415(wat, Error);
    }
}
function $e68c23511f7249ac$export$9f9636d330b71954(wat) {
    return Object.prototype.toString.call(wat) === "[object ErrorEvent]";
}
function $e68c23511f7249ac$export$ef9e2056653f0c8e(wat) {
    return Object.prototype.toString.call(wat) === "[object DOMError]";
}
function $e68c23511f7249ac$export$12e869b2a583f783(wat) {
    return Object.prototype.toString.call(wat) === "[object DOMException]";
}
function $e68c23511f7249ac$export$844ec244b1367d54(wat) {
    return Object.prototype.toString.call(wat) === "[object String]";
}
function $e68c23511f7249ac$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== "object" && typeof wat !== "function";
}
function $e68c23511f7249ac$export$53b83ca8eaab0383(wat) {
    return Object.prototype.toString.call(wat) === "[object Object]";
}
function $e68c23511f7249ac$export$9671ea99bd126ace(wat) {
    return typeof Event !== "undefined" && $e68c23511f7249ac$export$49034edbe6b62415(wat, Event);
}
function $e68c23511f7249ac$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== "undefined" && $e68c23511f7249ac$export$49034edbe6b62415(wat, Element);
}
function $e68c23511f7249ac$export$49841c62b9eff15(wat) {
    return Object.prototype.toString.call(wat) === "[object RegExp]";
}
function $e68c23511f7249ac$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === "function");
}
function $e68c23511f7249ac$export$bc2894c7158efbac(wat) {
    return $e68c23511f7249ac$export$53b83ca8eaab0383(wat) && "nativeEvent" in wat && "preventDefault" in wat && "stopPropagation" in wat;
}
function $e68c23511f7249ac$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("hKTDd", function(module, exports) {

$parcel$export(module.exports, "fill", function () { return $ced1e2cd8877b76f$export$9563e054e6f787fb; });
$parcel$export(module.exports, "urlEncode", function () { return $ced1e2cd8877b76f$export$9ef804feabbcbaf1; });
$parcel$export(module.exports, "normalizeToSize", function () { return $ced1e2cd8877b76f$export$23fbbb20bed71033; });
$parcel$export(module.exports, "normalize", function () { return $ced1e2cd8877b76f$export$a3295358bff77e; });
$parcel$export(module.exports, "extractExceptionKeysForMessage", function () { return $ced1e2cd8877b76f$export$b0244d5063c0b61b; });
$parcel$export(module.exports, "dropUndefinedKeys", function () { return $ced1e2cd8877b76f$export$d25f2688db1bb433; });

var $aDdG9 = parcelRequire("aDdG9");

var $gwbjx = parcelRequire("gwbjx");

var $jNciV = parcelRequire("jNciV");

var $6OyCc = parcelRequire("6OyCc");

var $eHZGJ = parcelRequire("eHZGJ");

var $aVWL9 = parcelRequire("aVWL9");
function $ced1e2cd8877b76f$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === "function") try {
        wrapped.prototype = wrapped.prototype || {};
        Object.defineProperties(wrapped, {
            __sentry_original__: {
                enumerable: false,
                value: original
            }
        });
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
function $ced1e2cd8877b76f$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map(function(key) {
        return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]);
    }).join("&");
}
/**
 * Transforms any object into an object literal with all its attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 */ function $ced1e2cd8877b76f$var$getWalkSource(value) {
    if ((0, $jNciV.isError)(value)) {
        var error = value;
        var err = {
            message: error.message,
            name: error.name,
            stack: error.stack
        };
        for(var i in error)if (Object.prototype.hasOwnProperty.call(error, i)) err[i] = error[i];
        return err;
    }
    if ((0, $jNciV.isEvent)(value)) {
        var event_1 = value;
        var source = {};
        source.type = event_1.type;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            source.target = (0, $jNciV.isElement)(event_1.target) ? (0, $gwbjx.htmlTreeAsString)(event_1.target) : Object.prototype.toString.call(event_1.target);
        } catch (_oO) {
            source.target = "<unknown>";
        }
        try {
            source.currentTarget = (0, $jNciV.isElement)(event_1.currentTarget) ? (0, $gwbjx.htmlTreeAsString)(event_1.currentTarget) : Object.prototype.toString.call(event_1.currentTarget);
        } catch (_oO) {
            source.currentTarget = "<unknown>";
        }
        if (typeof CustomEvent !== "undefined" && (0, $jNciV.isInstanceOf)(value, CustomEvent)) source.detail = event_1.detail;
        for(var i in event_1)if (Object.prototype.hasOwnProperty.call(event_1, i)) source[i] = event_1;
        return source;
    }
    return value;
}
/** Calculates bytes size of input string */ function $ced1e2cd8877b76f$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ function $ced1e2cd8877b76f$var$jsonSize(value) {
    return $ced1e2cd8877b76f$var$utf8Length(JSON.stringify(value));
}
function $ced1e2cd8877b76f$export$23fbbb20bed71033(object, // Default Node.js REPL depth
depth, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) depth = 3;
    if (maxSize === void 0) maxSize = 102400;
    var serialized = $ced1e2cd8877b76f$export$a3295358bff77e(object, depth);
    if ($ced1e2cd8877b76f$var$jsonSize(serialized) > maxSize) return $ced1e2cd8877b76f$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return serialized;
}
/**
 * Transform any non-primitive, BigInt, or Symbol-type value into a string. Acts as a no-op on strings, numbers,
 * booleans, null, and undefined.
 *
 * @param value The value to stringify
 * @returns For non-primitive, BigInt, and Symbol-type values, a string denoting the value's type, type and value, or
 *  type and `description` property, respectively. For non-BigInt, non-Symbol primitives, returns the original value,
 *  unchanged.
 */ function $ced1e2cd8877b76f$var$serializeValue(value) {
    var type = Object.prototype.toString.call(value);
    // Node.js REPL notation
    if (typeof value === "string") return value;
    if (type === "[object Object]") return "[Object]";
    if (type === "[object Array]") return "[Array]";
    var normalized = $ced1e2cd8877b76f$var$normalizeValue(value);
    return (0, $jNciV.isPrimitive)(normalized) ? normalized : type;
}
/**
 * normalizeValue()
 *
 * Takes unserializable input and make it serializable friendly
 *
 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * - serializes Error objects
 * - filter global objects
 */ function $ced1e2cd8877b76f$var$normalizeValue(value, key) {
    if (key === "domain" && value && typeof value === "object" && value._events) return "[Domain]";
    if (key === "domainEmitter") return "[DomainEmitter]";
    if (typeof $parcel$global !== "undefined" && value === $parcel$global) return "[Global]";
    if (typeof window !== "undefined" && value === window) return "[Window]";
    if (typeof document !== "undefined" && value === document) return "[Document]";
    // React's SyntheticEvent thingy
    if ((0, $jNciV.isSyntheticEvent)(value)) return "[SyntheticEvent]";
    if (typeof value === "number" && value !== value) return "[NaN]";
    if (value === void 0) return "[undefined]";
    if (typeof value === "function") return "[Function: " + (0, $eHZGJ.getFunctionName)(value) + "]";
    // symbols and bigints are considered primitives by TS, but aren't natively JSON-serilaizable
    if (typeof value === "symbol") return "[" + String(value) + "]";
    if (typeof value === "bigint") return "[BigInt: " + String(value) + "]";
    return value;
}
function $ced1e2cd8877b76f$export$588732934346abbf(key, value, depth, memo) {
    if (depth === void 0) depth = Infinity;
    if (memo === void 0) memo = new (0, $6OyCc.Memo)();
    // If we reach the maximum depth, serialize whatever has left
    if (depth === 0) return $ced1e2cd8877b76f$var$serializeValue(value);
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // If value implements `toJSON` method, call it and return early
    if (value !== null && value !== undefined && typeof value.toJSON === "function") return value.toJSON();
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ // If normalized value is a primitive, there are no branches left to walk, so we can just bail out, as theres no point in going down that branch any further
    var normalized = $ced1e2cd8877b76f$var$normalizeValue(value, key);
    if ((0, $jNciV.isPrimitive)(normalized)) return normalized;
    // Create source that we will use for next itterations, either objectified error object (Error type with extracted keys:value pairs) or the input itself
    var source = $ced1e2cd8877b76f$var$getWalkSource(value);
    // Create an accumulator that will act as a parent for all future itterations of that branch
    var acc = Array.isArray(value) ? [] : {};
    // If we already walked that branch, bail out, as it's circular reference
    if (memo.memoize(value)) return "[Circular ~]";
    // Walk all keys of the source
    for(var innerKey in source){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) continue;
        // Recursively walk through all the child nodes
        acc[innerKey] = $ced1e2cd8877b76f$export$588732934346abbf(innerKey, source[innerKey], depth - 1, memo);
    }
    // Once walked through all the branches, remove the parent from memo storage
    memo.unmemoize(value);
    // Return accumulated values
    return acc;
}
function $ced1e2cd8877b76f$export$a3295358bff77e(input, depth) {
    try {
        return JSON.parse(JSON.stringify(input, function(key, value) {
            return $ced1e2cd8877b76f$export$588732934346abbf(key, value, depth);
        }));
    } catch (_oO) {
        return "**non-serializable**";
    }
}
function $ced1e2cd8877b76f$export$b0244d5063c0b61b(exception, maxLength) {
    if (maxLength === void 0) maxLength = 40;
    var keys = Object.keys($ced1e2cd8877b76f$var$getWalkSource(exception));
    keys.sort();
    if (!keys.length) return "[object has no keys]";
    if (keys[0].length >= maxLength) return (0, $aVWL9.truncate)(keys[0], maxLength);
    for(var includedKeys = keys.length; includedKeys > 0; includedKeys--){
        var serialized = keys.slice(0, includedKeys).join(", ");
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $aVWL9.truncate)(serialized, maxLength);
    }
    return "";
}
function $ced1e2cd8877b76f$export$d25f2688db1bb433(val) {
    var e_1, _a;
    if ((0, $jNciV.isPlainObject)(val)) {
        var obj = val;
        var rv = {};
        try {
            for(var _b = (0, $aDdG9.__values)(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()){
                var key = _c.value;
                if (typeof obj[key] !== "undefined") rv[key] = $ced1e2cd8877b76f$export$d25f2688db1bb433(obj[key]);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        return rv;
    }
    if (Array.isArray(val)) return val.map($ced1e2cd8877b76f$export$d25f2688db1bb433);
    return val;
}

});
parcelRegister("aDdG9", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $7bd8283ac66cc0cf$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $7bd8283ac66cc0cf$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__values", function () { return $7bd8283ac66cc0cf$export$19a8beecd37a4c45; });
$parcel$export(module.exports, "__read", function () { return $7bd8283ac66cc0cf$export$8d051b38c9118094; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $7bd8283ac66cc0cf$var$extendStatics = function(d, b) {
    $7bd8283ac66cc0cf$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $7bd8283ac66cc0cf$var$extendStatics(d, b);
};
function $7bd8283ac66cc0cf$export$a8ba968b8961cb8a(d, b) {
    $7bd8283ac66cc0cf$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $7bd8283ac66cc0cf$export$18ce0697a983be9b = function() {
    $7bd8283ac66cc0cf$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7bd8283ac66cc0cf$export$18ce0697a983be9b.apply(this, arguments);
};
function $7bd8283ac66cc0cf$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $7bd8283ac66cc0cf$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $7bd8283ac66cc0cf$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $7bd8283ac66cc0cf$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $7bd8283ac66cc0cf$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $7bd8283ac66cc0cf$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $7bd8283ac66cc0cf$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $7bd8283ac66cc0cf$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $7bd8283ac66cc0cf$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $7bd8283ac66cc0cf$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $7bd8283ac66cc0cf$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($7bd8283ac66cc0cf$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $7bd8283ac66cc0cf$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $7bd8283ac66cc0cf$export$10c90e4f7922046c(v) {
    return this instanceof $7bd8283ac66cc0cf$export$10c90e4f7922046c ? (this.v = v, this) : new $7bd8283ac66cc0cf$export$10c90e4f7922046c(v);
}
function $7bd8283ac66cc0cf$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $7bd8283ac66cc0cf$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $7bd8283ac66cc0cf$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $7bd8283ac66cc0cf$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $7bd8283ac66cc0cf$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $7bd8283ac66cc0cf$export$19a8beecd37a4c45 === "function" ? $7bd8283ac66cc0cf$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $7bd8283ac66cc0cf$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $7bd8283ac66cc0cf$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $7bd8283ac66cc0cf$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $7bd8283ac66cc0cf$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $7bd8283ac66cc0cf$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("gwbjx", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", function () { return $c06869467be4bfa7$export$5647df6b7814ac86; });

var $jNciV = parcelRequire("jNciV");
function $c06869467be4bfa7$export$5647df6b7814ac86(elem) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = " > ";
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $c06869467be4bfa7$var$_htmlElementAsString(currentElem);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === "html" || height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return "<unknown>";
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $c06869467be4bfa7$var$_htmlElementAsString(el) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) return "";
    out.push(elem.tagName.toLowerCase());
    if (elem.id) out.push("#" + elem.id);
    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && (0, $jNciV.isString)(className)) {
        classes = className.split(/\s+/);
        for(i = 0; i < classes.length; i++)out.push("." + classes[i]);
    }
    var allowedAttrs = [
        "type",
        "name",
        "title",
        "alt"
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push("[" + key + '="' + attr + '"]');
    }
    return out.join("");
}

});

parcelRegister("6OyCc", function(module, exports) {

$parcel$export(module.exports, "Memo", function () { return $4f624374a03de068$export$7897aa7841a5380c; });
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /**
 * Memo class used for decycle json objects. Uses WeakSet if available otherwise array.
 */ var $4f624374a03de068$export$7897aa7841a5380c = /** @class */ function() {
    function Memo() {
        this._hasWeakSet = typeof WeakSet === "function";
        this._inner = this._hasWeakSet ? new WeakSet() : [];
    }
    /**
     * Sets obj to remember.
     * @param obj Object to remember
     */ Memo.prototype.memoize = function(obj) {
        if (this._hasWeakSet) {
            if (this._inner.has(obj)) return true;
            this._inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var i = 0; i < this._inner.length; i++){
            var value = this._inner[i];
            if (value === obj) return true;
        }
        this._inner.push(obj);
        return false;
    };
    /**
     * Removes object from internal storage.
     * @param obj Object to forget
     */ Memo.prototype.unmemoize = function(obj) {
        if (this._hasWeakSet) this._inner.delete(obj);
        else {
            for(var i = 0; i < this._inner.length; i++)if (this._inner[i] === obj) {
                this._inner.splice(i, 1);
                break;
            }
        }
    };
    return Memo;
}();

});

parcelRegister("eHZGJ", function(module, exports) {

$parcel$export(module.exports, "getFunctionName", function () { return $ab54eed8259c2f11$export$aad197c7121a6651; });
var $ab54eed8259c2f11$var$defaultFunctionName = "<anonymous>";
function $ab54eed8259c2f11$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== "function") return $ab54eed8259c2f11$var$defaultFunctionName;
        return fn.name || $ab54eed8259c2f11$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $ab54eed8259c2f11$var$defaultFunctionName;
    }
}

});

parcelRegister("aVWL9", function(module, exports) {

$parcel$export(module.exports, "truncate", function () { return $7f5cceadcaa0c9a6$export$6a506b36fdea397d; });
$parcel$export(module.exports, "snipLine", function () { return $7f5cceadcaa0c9a6$export$4215662d762d6f9d; });
$parcel$export(module.exports, "safeJoin", function () { return $7f5cceadcaa0c9a6$export$465e9d514283d4fd; });
$parcel$export(module.exports, "isMatchingPattern", function () { return $7f5cceadcaa0c9a6$export$cdded5b28a5f8c6d; });

var $jNciV = parcelRequire("jNciV");
function $7f5cceadcaa0c9a6$export$6a506b36fdea397d(str, max) {
    if (max === void 0) max = 0;
    if (typeof str !== "string" || max === 0) return str;
    return str.length <= max ? str : str.substr(0, max) + "...";
}
function $7f5cceadcaa0c9a6$export$4215662d762d6f9d(line, colno) {
    var newLine = line;
    var ll = newLine.length;
    if (ll <= 150) return newLine;
    if (colno > ll) // eslint-disable-next-line no-param-reassign
    colno = ll;
    var start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    var end = Math.min(start + 140, ll);
    if (end > ll - 5) end = ll;
    if (end === ll) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = "'{snip} " + newLine;
    if (end < ll) newLine += " {snip}";
    return newLine;
}
function $7f5cceadcaa0c9a6$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return "";
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(var i = 0; i < input.length; i++){
        var value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push("[value cannot be serialized]");
        }
    }
    return output.join(delimiter);
}
function $7f5cceadcaa0c9a6$export$cdded5b28a5f8c6d(value, pattern) {
    if (!(0, $jNciV.isString)(value)) return false;
    if ((0, $jNciV.isRegExp)(pattern)) return pattern.test(value);
    if (typeof pattern === "string") return value.indexOf(pattern) !== -1;
    return false;
}

});


parcelRegister("33y03", function(module, exports) {
// shim for using process in browser
var $239c0697ab971951$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $239c0697ab971951$var$cachedSetTimeout;
var $239c0697ab971951$var$cachedClearTimeout;
function $239c0697ab971951$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $239c0697ab971951$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $239c0697ab971951$var$cachedSetTimeout = setTimeout;
        else $239c0697ab971951$var$cachedSetTimeout = $239c0697ab971951$var$defaultSetTimout;
    } catch (e) {
        $239c0697ab971951$var$cachedSetTimeout = $239c0697ab971951$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $239c0697ab971951$var$cachedClearTimeout = clearTimeout;
        else $239c0697ab971951$var$cachedClearTimeout = $239c0697ab971951$var$defaultClearTimeout;
    } catch (e) {
        $239c0697ab971951$var$cachedClearTimeout = $239c0697ab971951$var$defaultClearTimeout;
    }
})();
function $239c0697ab971951$var$runTimeout(fun) {
    if ($239c0697ab971951$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($239c0697ab971951$var$cachedSetTimeout === $239c0697ab971951$var$defaultSetTimout || !$239c0697ab971951$var$cachedSetTimeout) && setTimeout) {
        $239c0697ab971951$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $239c0697ab971951$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $239c0697ab971951$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $239c0697ab971951$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $239c0697ab971951$var$runClearTimeout(marker) {
    if ($239c0697ab971951$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($239c0697ab971951$var$cachedClearTimeout === $239c0697ab971951$var$defaultClearTimeout || !$239c0697ab971951$var$cachedClearTimeout) && clearTimeout) {
        $239c0697ab971951$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $239c0697ab971951$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $239c0697ab971951$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $239c0697ab971951$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $239c0697ab971951$var$queue = [];
var $239c0697ab971951$var$draining = false;
var $239c0697ab971951$var$currentQueue;
var $239c0697ab971951$var$queueIndex = -1;
function $239c0697ab971951$var$cleanUpNextTick() {
    if (!$239c0697ab971951$var$draining || !$239c0697ab971951$var$currentQueue) return;
    $239c0697ab971951$var$draining = false;
    if ($239c0697ab971951$var$currentQueue.length) $239c0697ab971951$var$queue = $239c0697ab971951$var$currentQueue.concat($239c0697ab971951$var$queue);
    else $239c0697ab971951$var$queueIndex = -1;
    if ($239c0697ab971951$var$queue.length) $239c0697ab971951$var$drainQueue();
}
function $239c0697ab971951$var$drainQueue() {
    if ($239c0697ab971951$var$draining) return;
    var timeout = $239c0697ab971951$var$runTimeout($239c0697ab971951$var$cleanUpNextTick);
    $239c0697ab971951$var$draining = true;
    var len = $239c0697ab971951$var$queue.length;
    while(len){
        $239c0697ab971951$var$currentQueue = $239c0697ab971951$var$queue;
        $239c0697ab971951$var$queue = [];
        while(++$239c0697ab971951$var$queueIndex < len)if ($239c0697ab971951$var$currentQueue) $239c0697ab971951$var$currentQueue[$239c0697ab971951$var$queueIndex].run();
        $239c0697ab971951$var$queueIndex = -1;
        len = $239c0697ab971951$var$queue.length;
    }
    $239c0697ab971951$var$currentQueue = null;
    $239c0697ab971951$var$draining = false;
    $239c0697ab971951$var$runClearTimeout(timeout);
}
$239c0697ab971951$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $239c0697ab971951$var$queue.push(new $239c0697ab971951$var$Item(fun, args));
    if ($239c0697ab971951$var$queue.length === 1 && !$239c0697ab971951$var$draining) $239c0697ab971951$var$runTimeout($239c0697ab971951$var$drainQueue);
};
// v8 likes predictible objects
function $239c0697ab971951$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$239c0697ab971951$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$239c0697ab971951$var$process.title = "browser";
$239c0697ab971951$var$process.browser = true;
$239c0697ab971951$var$process.env = {};
$239c0697ab971951$var$process.argv = [];
$239c0697ab971951$var$process.version = ""; // empty string to avoid regexp issues
$239c0697ab971951$var$process.versions = {};
function $239c0697ab971951$var$noop() {}
$239c0697ab971951$var$process.on = $239c0697ab971951$var$noop;
$239c0697ab971951$var$process.addListener = $239c0697ab971951$var$noop;
$239c0697ab971951$var$process.once = $239c0697ab971951$var$noop;
$239c0697ab971951$var$process.off = $239c0697ab971951$var$noop;
$239c0697ab971951$var$process.removeListener = $239c0697ab971951$var$noop;
$239c0697ab971951$var$process.removeAllListeners = $239c0697ab971951$var$noop;
$239c0697ab971951$var$process.emit = $239c0697ab971951$var$noop;
$239c0697ab971951$var$process.prependListener = $239c0697ab971951$var$noop;
$239c0697ab971951$var$process.prependOnceListener = $239c0697ab971951$var$noop;
$239c0697ab971951$var$process.listeners = function(name) {
    return [];
};
$239c0697ab971951$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$239c0697ab971951$var$process.cwd = function() {
    return "/";
};
$239c0697ab971951$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$239c0697ab971951$var$process.umask = function() {
    return 0;
};

});


parcelRegister("gJrrM", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", function () { return dateTimestampInSeconds; }, function (v) { return dateTimestampInSeconds = v; });

var $byuqS = parcelRequire("byuqS");

var $hxqGH = parcelRequire("hxqGH");
/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ var dateTimestampSource = {
    nowSeconds: function() {
        return Date.now() / 1000;
    }
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    var performance = (0, $byuqS.getGlobalObject)().performance;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function() {
            return performance.now();
        },
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        var perfHooks = (0, $hxqGH.dynamicRequire)(module, "perf_hooks");
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ var platformPerformance = (0, $hxqGH.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: function() {
        return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000;
    }
};
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
var timestampWithMs = timestampInSeconds;
var usingPerformanceAPI = platformPerformance !== undefined;
var browserPerformanceTimeOrigin = function() {
    var performance = (0, $byuqS.getGlobalObject)().performance;
    if (!performance) return undefined;
    if (performance.timeOrigin) return performance.timeOrigin;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    return performance.timing && performance.timing.navigationStart || Date.now();
}();

});
parcelRegister("byuqS", function(module, exports) {

$parcel$export(module.exports, "getGlobalObject", function () { return $869a79f5fad4d332$export$256479dc0cea61c4; });
$parcel$export(module.exports, "uuid4", function () { return $869a79f5fad4d332$export$19f53698e68b2496; });
$parcel$export(module.exports, "parseUrl", function () { return $869a79f5fad4d332$export$7a5253c0f62e0150; });
$parcel$export(module.exports, "getEventDescription", function () { return $869a79f5fad4d332$export$4157119e2b157127; });
$parcel$export(module.exports, "consoleSandbox", function () { return $869a79f5fad4d332$export$cda52e2a8927a2ca; });
$parcel$export(module.exports, "addExceptionTypeValue", function () { return $869a79f5fad4d332$export$f26508487bf83ee7; });
$parcel$export(module.exports, "addExceptionMechanism", function () { return $869a79f5fad4d332$export$c69a9a0313b03bb1; });
$parcel$export(module.exports, "getLocationHref", function () { return $869a79f5fad4d332$export$1cfafeee2987818b; });
$parcel$export(module.exports, "parseRetryAfterHeader", function () { return $869a79f5fad4d332$export$615352e17ed7741; });

var $hxqGH = parcelRequire("hxqGH");

var $aVWL9 = parcelRequire("aVWL9");
var $869a79f5fad4d332$var$fallbackGlobalObject = {};
function $869a79f5fad4d332$export$256479dc0cea61c4() {
    return (0, $hxqGH.isNodeEnv)() ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : $869a79f5fad4d332$var$fallbackGlobalObject;
}
function $869a79f5fad4d332$export$19f53698e68b2496() {
    var global1 = $869a79f5fad4d332$export$256479dc0cea61c4();
    var crypto = global1.crypto || global1.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = arr[3] & 0xfff | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = arr[4] & 0x3fff | 0x8000;
        var pad = function(num) {
            var v = num.toString(16);
            while(v.length < 4)v = "0" + v;
            return v;
        };
        return pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]);
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return "xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx".replace(/[xy]/g, function(c) {
        // eslint-disable-next-line no-bitwise
        var r = Math.random() * 16 | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === "x" ? r : r & 0x3 | 0x8;
        return v.toString(16);
    });
}
function $869a79f5fad4d332$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || "";
    var fragment = match[8] || "";
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment
    };
}
function $869a79f5fad4d332$export$4157119e2b157127(event) {
    if (event.message) return event.message;
    if (event.exception && event.exception.values && event.exception.values[0]) {
        var exception = event.exception.values[0];
        if (exception.type && exception.value) return exception.type + ": " + exception.value;
        return exception.type || exception.value || event.event_id || "<unknown>";
    }
    return event.event_id || "<unknown>";
}
function $869a79f5fad4d332$export$cda52e2a8927a2ca(callback) {
    var global1 = $869a79f5fad4d332$export$256479dc0cea61c4();
    var levels = [
        "debug",
        "info",
        "warn",
        "error",
        "log",
        "assert"
    ];
    if (!("console" in global1)) return callback();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var originalConsole = global1.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    levels.forEach(function(level) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (level in global1.console && originalConsole[level].__sentry_original__) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalConsole[level].__sentry_original__;
        }
    });
    // Perform callback manipulations
    var result = callback();
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(function(level) {
        originalConsole[level] = wrappedLevels[level];
    });
    return result;
}
function $869a79f5fad4d332$export$f26508487bf83ee7(event, value, type) {
    event.exception = event.exception || {};
    event.exception.values = event.exception.values || [];
    event.exception.values[0] = event.exception.values[0] || {};
    event.exception.values[0].value = event.exception.values[0].value || value || "";
    event.exception.values[0].type = event.exception.values[0].type || type || "Error";
}
function $869a79f5fad4d332$export$c69a9a0313b03bb1(event, mechanism) {
    if (mechanism === void 0) mechanism = {};
    // TODO: Use real type with `keyof Mechanism` thingy and maybe make it better?
    try {
        // @ts-ignore Type 'Mechanism | {}' is not assignable to type 'Mechanism | undefined'
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values[0].mechanism = event.exception.values[0].mechanism || {};
        Object.keys(mechanism).forEach(function(key) {
            // @ts-ignore Mechanism has no index signature
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            event.exception.values[0].mechanism[key] = mechanism[key];
        });
    } catch (_oO) {
    // no-empty
    }
}
function $869a79f5fad4d332$export$1cfafeee2987818b() {
    try {
        return document.location.href;
    } catch (oO) {
        return "";
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
var $869a79f5fad4d332$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
function $869a79f5fad4d332$export$d364f2020ab30578(input) {
    var match = input.match($869a79f5fad4d332$var$SEMVER_REGEXP) || [];
    var major = parseInt(match[1], 10);
    var minor = parseInt(match[2], 10);
    var patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
var $869a79f5fad4d332$var$defaultRetryAfter = 60000; // 60 seconds
function $869a79f5fad4d332$export$615352e17ed7741(now, header) {
    if (!header) return $869a79f5fad4d332$var$defaultRetryAfter;
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) return headerDate - now;
    return $869a79f5fad4d332$var$defaultRetryAfter;
}
function $869a79f5fad4d332$export$ec2291bfc64632f0(lines, frame, linesOfContext) {
    if (linesOfContext === void 0) linesOfContext = 5;
    var lineno = frame.lineno || 0;
    var maxLines = lines.length;
    var sourceLine = Math.max(Math.min(maxLines, lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map(function(line) {
        return (0, $aVWL9.snipLine)(line, 0);
    });
    frame.context_line = (0, $aVWL9.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map(function(line) {
        return (0, $aVWL9.snipLine)(line, 0);
    });
}
function $869a79f5fad4d332$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}

});


parcelRegister("boCnF", function(module, exports) {
"use strict";
var $84bfb538df819247$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $84bfb538df819247$var$toStr.call(value);
    var isArgs = str === "[object Arguments]";
    if (!isArgs) isArgs = str !== "[object Array]" && value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $84bfb538df819247$var$toStr.call(value.callee) === "[object Function]";
    return isArgs;
};

});

parcelRegister("lxArP", function(module, exports) {
"use strict";
var $fae8f3cf973381e3$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $fae8f3cf973381e3$var$has = Object.prototype.hasOwnProperty;
    var $fae8f3cf973381e3$var$toStr = Object.prototype.toString;
    var $fae8f3cf973381e3$var$isArgs = (parcelRequire("boCnF")); // eslint-disable-line global-require
    var $fae8f3cf973381e3$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $fae8f3cf973381e3$var$hasDontEnumBug = !$fae8f3cf973381e3$var$isEnumerable.call({
        toString: null
    }, "toString");
    var $fae8f3cf973381e3$var$hasProtoEnumBug = $fae8f3cf973381e3$var$isEnumerable.call(function() {}, "prototype");
    var $fae8f3cf973381e3$var$dontEnums = [
        "toString",
        "toLocaleString",
        "valueOf",
        "hasOwnProperty",
        "isPrototypeOf",
        "propertyIsEnumerable",
        "constructor"
    ];
    var $fae8f3cf973381e3$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $fae8f3cf973381e3$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $fae8f3cf973381e3$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === "undefined") return false;
        for(var k in window)try {
            if (!$fae8f3cf973381e3$var$excludedKeys["$" + k] && $fae8f3cf973381e3$var$has.call(window, k) && window[k] !== null && typeof window[k] === "object") try {
                $fae8f3cf973381e3$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $fae8f3cf973381e3$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === "undefined" || !$fae8f3cf973381e3$var$hasAutomationEqualityBug) return $fae8f3cf973381e3$var$equalsConstructorPrototype(o);
        try {
            return $fae8f3cf973381e3$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $fae8f3cf973381e3$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === "object";
        var isFunction = $fae8f3cf973381e3$var$toStr.call(object) === "[object Function]";
        var isArguments = $fae8f3cf973381e3$var$isArgs(object);
        var isString = isObject && $fae8f3cf973381e3$var$toStr.call(object) === "[object String]";
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError("Object.keys called on a non-object");
        var skipProto = $fae8f3cf973381e3$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$fae8f3cf973381e3$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === "prototype") && $fae8f3cf973381e3$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($fae8f3cf973381e3$var$hasDontEnumBug) {
            var skipConstructor = $fae8f3cf973381e3$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $fae8f3cf973381e3$var$dontEnums.length; ++k)if (!(skipConstructor && $fae8f3cf973381e3$var$dontEnums[k] === "constructor") && $fae8f3cf973381e3$var$has.call(object, $fae8f3cf973381e3$var$dontEnums[k])) theKeys.push($fae8f3cf973381e3$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $fae8f3cf973381e3$var$keysShim;

});

parcelRegister("a8J51", function(module, exports) {
"use strict";
var $761d9eb501117a17$var$functionsHaveNames = function functionsHaveNames() {
    return typeof (function f() {}).name === "string";
};
var $761d9eb501117a17$var$gOPD = Object.getOwnPropertyDescriptor;
if ($761d9eb501117a17$var$gOPD) try {
    $761d9eb501117a17$var$gOPD([], "length");
} catch (e) {
    // IE 8 has a broken gOPD
    $761d9eb501117a17$var$gOPD = null;
}
$761d9eb501117a17$var$functionsHaveNames.functionsHaveConfigurableNames = function functionsHaveConfigurableNames() {
    if (!$761d9eb501117a17$var$functionsHaveNames() || !$761d9eb501117a17$var$gOPD) return false;
    var desc = $761d9eb501117a17$var$gOPD(function() {}, "name");
    return !!desc && !!desc.configurable;
};
var $761d9eb501117a17$var$$bind = Function.prototype.bind;
$761d9eb501117a17$var$functionsHaveNames.boundFunctionsHaveNames = function boundFunctionsHaveNames() {
    return $761d9eb501117a17$var$functionsHaveNames() && typeof $761d9eb501117a17$var$$bind === "function" && (function f() {}).bind().name !== "";
};
module.exports = $761d9eb501117a17$var$functionsHaveNames;

});

parcelRegister("7kFju", function(module, exports) {
"use strict";

var $7hv1u = parcelRequire("7hv1u");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $7hv1u() && !!Symbol.toStringTag;
};

});

parcelRegister("a6yWc", function(module, exports) {
var $75b590cd97e0605d$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $75b590cd97e0605d$var$toString.call(arr) == "[object Array]";
};

});

parcelRegister("5oIKp", function(module, exports) {
"use strict";
var $3ee1e78ddca684e4$var$strValue = String.prototype.valueOf;
var $3ee1e78ddca684e4$var$tryStringObject = function tryStringObject(value) {
    try {
        $3ee1e78ddca684e4$var$strValue.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $3ee1e78ddca684e4$var$toStr = Object.prototype.toString;
var $3ee1e78ddca684e4$var$strClass = "[object String]";

var $3ee1e78ddca684e4$var$hasToStringTag = (parcelRequire("7kFju"))();
module.exports = function isString(value) {
    if (typeof value === "string") return true;
    if (typeof value !== "object") return false;
    return $3ee1e78ddca684e4$var$hasToStringTag ? $3ee1e78ddca684e4$var$tryStringObject(value) : $3ee1e78ddca684e4$var$toStr.call(value) === $3ee1e78ddca684e4$var$strClass;
};

});

parcelRegister("hnMH2", function(module, exports) {
"use strict";
/** @const */ var $ca7a5b14cdbc628b$var$$Map = typeof Map === "function" && Map.prototype ? Map : null;
var $ca7a5b14cdbc628b$var$$Set = typeof Set === "function" && Set.prototype ? Set : null;
var $ca7a5b14cdbc628b$var$exported;
if (!$ca7a5b14cdbc628b$var$$Map) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
$ca7a5b14cdbc628b$var$exported = function isMap(x) {
    // `Map` is not present in this environment.
    return false;
};
var $ca7a5b14cdbc628b$var$$mapHas = $ca7a5b14cdbc628b$var$$Map ? Map.prototype.has : null;
var $ca7a5b14cdbc628b$var$$setHas = $ca7a5b14cdbc628b$var$$Set ? Set.prototype.has : null;
if (!$ca7a5b14cdbc628b$var$exported && !$ca7a5b14cdbc628b$var$$mapHas) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
$ca7a5b14cdbc628b$var$exported = function isMap(x) {
    // `Map` does not have a `has` method
    return false;
};
/** @type {import('.')} */ module.exports = $ca7a5b14cdbc628b$var$exported || function isMap(x) {
    if (!x || typeof x !== "object") return false;
    try {
        $ca7a5b14cdbc628b$var$$mapHas.call(x);
        if ($ca7a5b14cdbc628b$var$$setHas) try {
            $ca7a5b14cdbc628b$var$$setHas.call(x);
        } catch (e) {
            return true;
        }
        // @ts-expect-error TS can't figure out that $Map is always truthy here
        return x instanceof $ca7a5b14cdbc628b$var$$Map; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
};

});

parcelRegister("2ZpS0", function(module, exports) {
"use strict";
var $22d55886b1d668a8$var$$Map = typeof Map === "function" && Map.prototype ? Map : null;
var $22d55886b1d668a8$var$$Set = typeof Set === "function" && Set.prototype ? Set : null;
var $22d55886b1d668a8$var$exported;
if (!$22d55886b1d668a8$var$$Set) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
$22d55886b1d668a8$var$exported = function isSet(x) {
    // `Set` is not present in this environment.
    return false;
};
var $22d55886b1d668a8$var$$mapHas = $22d55886b1d668a8$var$$Map ? Map.prototype.has : null;
var $22d55886b1d668a8$var$$setHas = $22d55886b1d668a8$var$$Set ? Set.prototype.has : null;
if (!$22d55886b1d668a8$var$exported && !$22d55886b1d668a8$var$$setHas) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
$22d55886b1d668a8$var$exported = function isSet(x) {
    // `Set` does not have a `has` method
    return false;
};
/** @type {import('.')} */ module.exports = $22d55886b1d668a8$var$exported || function isSet(x) {
    if (!x || typeof x !== "object") return false;
    try {
        $22d55886b1d668a8$var$$setHas.call(x);
        if ($22d55886b1d668a8$var$$mapHas) try {
            $22d55886b1d668a8$var$$mapHas.call(x);
        } catch (e) {
            return true;
        }
        // @ts-expect-error TS can't figure out that $Set is always truthy here
        return x instanceof $22d55886b1d668a8$var$$Set; // core-js workaround, pre-v2.5.0
    } catch (e) {}
    return false;
};

});

parcelRegister("1bCpl", function(module, exports) {
"use strict";
var $0dd49c8830d27ea1$var$$BigInt = typeof BigInt !== "undefined" && BigInt;
module.exports = function hasNativeBigInts() {
    return typeof $0dd49c8830d27ea1$var$$BigInt === "function" && typeof BigInt === "function" && typeof $0dd49c8830d27ea1$var$$BigInt(42) === "bigint" // eslint-disable-line no-magic-numbers
     && typeof BigInt(42) === "bigint"; // eslint-disable-line no-magic-numbers
};

});

parcelRegister("j7Rq5", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
"use strict";

var $eUexM = parcelRequire("eUexM");

var $5L0JO = parcelRequire("5L0JO");

var $4L6DV = parcelRequire("4L6DV");

var $lLKSK = parcelRequire("lLKSK");
function $dec81bd07493bb1b$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $dec81bd07493bb1b$var$BigIntSupported = typeof BigInt !== "undefined";
var $dec81bd07493bb1b$var$SymbolSupported = typeof Symbol !== "undefined";
var $dec81bd07493bb1b$var$ObjectToString = $dec81bd07493bb1b$var$uncurryThis(Object.prototype.toString);
var $dec81bd07493bb1b$var$numberValue = $dec81bd07493bb1b$var$uncurryThis(Number.prototype.valueOf);
var $dec81bd07493bb1b$var$stringValue = $dec81bd07493bb1b$var$uncurryThis(String.prototype.valueOf);
var $dec81bd07493bb1b$var$booleanValue = $dec81bd07493bb1b$var$uncurryThis(Boolean.prototype.valueOf);
if ($dec81bd07493bb1b$var$BigIntSupported) var $dec81bd07493bb1b$var$bigIntValue = $dec81bd07493bb1b$var$uncurryThis(BigInt.prototype.valueOf);
if ($dec81bd07493bb1b$var$SymbolSupported) var $dec81bd07493bb1b$var$symbolValue = $dec81bd07493bb1b$var$uncurryThis(Symbol.prototype.valueOf);
function $dec81bd07493bb1b$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== "object") return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $eUexM;
module.exports.isGeneratorFunction = $5L0JO;
module.exports.isTypedArray = $lLKSK;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $dec81bd07493bb1b$var$isPromise(input) {
    return typeof Promise !== "undefined" && input instanceof Promise || input !== null && typeof input === "object" && typeof input.then === "function" && typeof input.catch === "function";
}
module.exports.isPromise = $dec81bd07493bb1b$var$isPromise;
function $dec81bd07493bb1b$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $lLKSK(value) || $dec81bd07493bb1b$var$isDataView(value);
}
module.exports.isArrayBufferView = $dec81bd07493bb1b$var$isArrayBufferView;
function $dec81bd07493bb1b$var$isUint8Array(value) {
    return $4L6DV(value) === "Uint8Array";
}
module.exports.isUint8Array = $dec81bd07493bb1b$var$isUint8Array;
function $dec81bd07493bb1b$var$isUint8ClampedArray(value) {
    return $4L6DV(value) === "Uint8ClampedArray";
}
module.exports.isUint8ClampedArray = $dec81bd07493bb1b$var$isUint8ClampedArray;
function $dec81bd07493bb1b$var$isUint16Array(value) {
    return $4L6DV(value) === "Uint16Array";
}
module.exports.isUint16Array = $dec81bd07493bb1b$var$isUint16Array;
function $dec81bd07493bb1b$var$isUint32Array(value) {
    return $4L6DV(value) === "Uint32Array";
}
module.exports.isUint32Array = $dec81bd07493bb1b$var$isUint32Array;
function $dec81bd07493bb1b$var$isInt8Array(value) {
    return $4L6DV(value) === "Int8Array";
}
module.exports.isInt8Array = $dec81bd07493bb1b$var$isInt8Array;
function $dec81bd07493bb1b$var$isInt16Array(value) {
    return $4L6DV(value) === "Int16Array";
}
module.exports.isInt16Array = $dec81bd07493bb1b$var$isInt16Array;
function $dec81bd07493bb1b$var$isInt32Array(value) {
    return $4L6DV(value) === "Int32Array";
}
module.exports.isInt32Array = $dec81bd07493bb1b$var$isInt32Array;
function $dec81bd07493bb1b$var$isFloat32Array(value) {
    return $4L6DV(value) === "Float32Array";
}
module.exports.isFloat32Array = $dec81bd07493bb1b$var$isFloat32Array;
function $dec81bd07493bb1b$var$isFloat64Array(value) {
    return $4L6DV(value) === "Float64Array";
}
module.exports.isFloat64Array = $dec81bd07493bb1b$var$isFloat64Array;
function $dec81bd07493bb1b$var$isBigInt64Array(value) {
    return $4L6DV(value) === "BigInt64Array";
}
module.exports.isBigInt64Array = $dec81bd07493bb1b$var$isBigInt64Array;
function $dec81bd07493bb1b$var$isBigUint64Array(value) {
    return $4L6DV(value) === "BigUint64Array";
}
module.exports.isBigUint64Array = $dec81bd07493bb1b$var$isBigUint64Array;
function $dec81bd07493bb1b$var$isMapToString(value) {
    return $dec81bd07493bb1b$var$ObjectToString(value) === "[object Map]";
}
$dec81bd07493bb1b$var$isMapToString.working = typeof Map !== "undefined" && $dec81bd07493bb1b$var$isMapToString(new Map());
function $dec81bd07493bb1b$var$isMap(value) {
    if (typeof Map === "undefined") return false;
    return $dec81bd07493bb1b$var$isMapToString.working ? $dec81bd07493bb1b$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $dec81bd07493bb1b$var$isMap;
function $dec81bd07493bb1b$var$isSetToString(value) {
    return $dec81bd07493bb1b$var$ObjectToString(value) === "[object Set]";
}
$dec81bd07493bb1b$var$isSetToString.working = typeof Set !== "undefined" && $dec81bd07493bb1b$var$isSetToString(new Set());
function $dec81bd07493bb1b$var$isSet(value) {
    if (typeof Set === "undefined") return false;
    return $dec81bd07493bb1b$var$isSetToString.working ? $dec81bd07493bb1b$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $dec81bd07493bb1b$var$isSet;
function $dec81bd07493bb1b$var$isWeakMapToString(value) {
    return $dec81bd07493bb1b$var$ObjectToString(value) === "[object WeakMap]";
}
$dec81bd07493bb1b$var$isWeakMapToString.working = typeof WeakMap !== "undefined" && $dec81bd07493bb1b$var$isWeakMapToString(new WeakMap());
function $dec81bd07493bb1b$var$isWeakMap(value) {
    if (typeof WeakMap === "undefined") return false;
    return $dec81bd07493bb1b$var$isWeakMapToString.working ? $dec81bd07493bb1b$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $dec81bd07493bb1b$var$isWeakMap;
function $dec81bd07493bb1b$var$isWeakSetToString(value) {
    return $dec81bd07493bb1b$var$ObjectToString(value) === "[object WeakSet]";
}
$dec81bd07493bb1b$var$isWeakSetToString.working = typeof WeakSet !== "undefined" && $dec81bd07493bb1b$var$isWeakSetToString(new WeakSet());
function $dec81bd07493bb1b$var$isWeakSet(value) {
    return $dec81bd07493bb1b$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $dec81bd07493bb1b$var$isWeakSet;
function $dec81bd07493bb1b$var$isArrayBufferToString(value) {
    return $dec81bd07493bb1b$var$ObjectToString(value) === "[object ArrayBuffer]";
}
$dec81bd07493bb1b$var$isArrayBufferToString.working = typeof ArrayBuffer !== "undefined" && $dec81bd07493bb1b$var$isArrayBufferToString(new ArrayBuffer());
function $dec81bd07493bb1b$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === "undefined") return false;
    return $dec81bd07493bb1b$var$isArrayBufferToString.working ? $dec81bd07493bb1b$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $dec81bd07493bb1b$var$isArrayBuffer;
function $dec81bd07493bb1b$var$isDataViewToString(value) {
    return $dec81bd07493bb1b$var$ObjectToString(value) === "[object DataView]";
}
$dec81bd07493bb1b$var$isDataViewToString.working = typeof ArrayBuffer !== "undefined" && typeof DataView !== "undefined" && $dec81bd07493bb1b$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $dec81bd07493bb1b$var$isDataView(value) {
    if (typeof DataView === "undefined") return false;
    return $dec81bd07493bb1b$var$isDataViewToString.working ? $dec81bd07493bb1b$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $dec81bd07493bb1b$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $dec81bd07493bb1b$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== "undefined" ? SharedArrayBuffer : undefined;
function $dec81bd07493bb1b$var$isSharedArrayBufferToString(value) {
    return $dec81bd07493bb1b$var$ObjectToString(value) === "[object SharedArrayBuffer]";
}
function $dec81bd07493bb1b$var$isSharedArrayBuffer(value) {
    if (typeof $dec81bd07493bb1b$var$SharedArrayBufferCopy === "undefined") return false;
    if (typeof $dec81bd07493bb1b$var$isSharedArrayBufferToString.working === "undefined") $dec81bd07493bb1b$var$isSharedArrayBufferToString.working = $dec81bd07493bb1b$var$isSharedArrayBufferToString(new $dec81bd07493bb1b$var$SharedArrayBufferCopy());
    return $dec81bd07493bb1b$var$isSharedArrayBufferToString.working ? $dec81bd07493bb1b$var$isSharedArrayBufferToString(value) : value instanceof $dec81bd07493bb1b$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $dec81bd07493bb1b$var$isSharedArrayBuffer;
function $dec81bd07493bb1b$var$isAsyncFunction(value) {
    return $dec81bd07493bb1b$var$ObjectToString(value) === "[object AsyncFunction]";
}
module.exports.isAsyncFunction = $dec81bd07493bb1b$var$isAsyncFunction;
function $dec81bd07493bb1b$var$isMapIterator(value) {
    return $dec81bd07493bb1b$var$ObjectToString(value) === "[object Map Iterator]";
}
module.exports.isMapIterator = $dec81bd07493bb1b$var$isMapIterator;
function $dec81bd07493bb1b$var$isSetIterator(value) {
    return $dec81bd07493bb1b$var$ObjectToString(value) === "[object Set Iterator]";
}
module.exports.isSetIterator = $dec81bd07493bb1b$var$isSetIterator;
function $dec81bd07493bb1b$var$isGeneratorObject(value) {
    return $dec81bd07493bb1b$var$ObjectToString(value) === "[object Generator]";
}
module.exports.isGeneratorObject = $dec81bd07493bb1b$var$isGeneratorObject;
function $dec81bd07493bb1b$var$isWebAssemblyCompiledModule(value) {
    return $dec81bd07493bb1b$var$ObjectToString(value) === "[object WebAssembly.Module]";
}
module.exports.isWebAssemblyCompiledModule = $dec81bd07493bb1b$var$isWebAssemblyCompiledModule;
function $dec81bd07493bb1b$var$isNumberObject(value) {
    return $dec81bd07493bb1b$var$checkBoxedPrimitive(value, $dec81bd07493bb1b$var$numberValue);
}
module.exports.isNumberObject = $dec81bd07493bb1b$var$isNumberObject;
function $dec81bd07493bb1b$var$isStringObject(value) {
    return $dec81bd07493bb1b$var$checkBoxedPrimitive(value, $dec81bd07493bb1b$var$stringValue);
}
module.exports.isStringObject = $dec81bd07493bb1b$var$isStringObject;
function $dec81bd07493bb1b$var$isBooleanObject(value) {
    return $dec81bd07493bb1b$var$checkBoxedPrimitive(value, $dec81bd07493bb1b$var$booleanValue);
}
module.exports.isBooleanObject = $dec81bd07493bb1b$var$isBooleanObject;
function $dec81bd07493bb1b$var$isBigIntObject(value) {
    return $dec81bd07493bb1b$var$BigIntSupported && $dec81bd07493bb1b$var$checkBoxedPrimitive(value, $dec81bd07493bb1b$var$bigIntValue);
}
module.exports.isBigIntObject = $dec81bd07493bb1b$var$isBigIntObject;
function $dec81bd07493bb1b$var$isSymbolObject(value) {
    return $dec81bd07493bb1b$var$SymbolSupported && $dec81bd07493bb1b$var$checkBoxedPrimitive(value, $dec81bd07493bb1b$var$symbolValue);
}
module.exports.isSymbolObject = $dec81bd07493bb1b$var$isSymbolObject;
function $dec81bd07493bb1b$var$isBoxedPrimitive(value) {
    return $dec81bd07493bb1b$var$isNumberObject(value) || $dec81bd07493bb1b$var$isStringObject(value) || $dec81bd07493bb1b$var$isBooleanObject(value) || $dec81bd07493bb1b$var$isBigIntObject(value) || $dec81bd07493bb1b$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $dec81bd07493bb1b$var$isBoxedPrimitive;
function $dec81bd07493bb1b$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== "undefined" && ($dec81bd07493bb1b$var$isArrayBuffer(value) || $dec81bd07493bb1b$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $dec81bd07493bb1b$var$isAnyArrayBuffer;
[
    "isProxy",
    "isExternal",
    "isModuleNamespaceObject"
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + " is not supported in userland");
        }
    });
});

});
parcelRegister("eUexM", function(module, exports) {
"use strict";

var $ada193bced9d68eb$var$hasToStringTag = (parcelRequire("7kFju"))();

var $kKGfz = parcelRequire("kKGfz");
var $ada193bced9d68eb$var$$toString = $kKGfz("Object.prototype.toString");
var $ada193bced9d68eb$var$isStandardArguments = function isArguments(value) {
    if ($ada193bced9d68eb$var$hasToStringTag && value && typeof value === "object" && Symbol.toStringTag in value) return false;
    return $ada193bced9d68eb$var$$toString(value) === "[object Arguments]";
};
var $ada193bced9d68eb$var$isLegacyArguments = function isArguments(value) {
    if ($ada193bced9d68eb$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === "object" && typeof value.length === "number" && value.length >= 0 && $ada193bced9d68eb$var$$toString(value) !== "[object Array]" && $ada193bced9d68eb$var$$toString(value.callee) === "[object Function]";
};
var $ada193bced9d68eb$var$supportsStandardArguments = function() {
    return $ada193bced9d68eb$var$isStandardArguments(arguments);
}();
$ada193bced9d68eb$var$isStandardArguments.isLegacyArguments = $ada193bced9d68eb$var$isLegacyArguments; // for tests
module.exports = $ada193bced9d68eb$var$supportsStandardArguments ? $ada193bced9d68eb$var$isStandardArguments : $ada193bced9d68eb$var$isLegacyArguments;

});

parcelRegister("5L0JO", function(module, exports) {
"use strict";
var $4311ea174f61e773$var$toStr = Object.prototype.toString;
var $4311ea174f61e773$var$fnToStr = Function.prototype.toString;
var $4311ea174f61e773$var$isFnRegex = /^\s*(?:function)?\*/;

var $4311ea174f61e773$var$hasToStringTag = (parcelRequire("7kFju"))();
var $4311ea174f61e773$var$getProto = Object.getPrototypeOf;
var $4311ea174f61e773$var$getGeneratorFunc = function() {
    if (!$4311ea174f61e773$var$hasToStringTag) return false;
    try {
        return Function("return function*() {}")();
    } catch (e) {}
};
var $4311ea174f61e773$var$GeneratorFunction;
module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== "function") return false;
    if ($4311ea174f61e773$var$isFnRegex.test($4311ea174f61e773$var$fnToStr.call(fn))) return true;
    if (!$4311ea174f61e773$var$hasToStringTag) {
        var str = $4311ea174f61e773$var$toStr.call(fn);
        return str === "[object GeneratorFunction]";
    }
    if (!$4311ea174f61e773$var$getProto) return false;
    if (typeof $4311ea174f61e773$var$GeneratorFunction === "undefined") {
        var generatorFunc = $4311ea174f61e773$var$getGeneratorFunc();
        $4311ea174f61e773$var$GeneratorFunction = generatorFunc ? $4311ea174f61e773$var$getProto(generatorFunc) : false;
    }
    return $4311ea174f61e773$var$getProto(fn) === $4311ea174f61e773$var$GeneratorFunction;
};

});

parcelRegister("4L6DV", function(module, exports) {
"use strict";

var $aHlUe = parcelRequire("aHlUe");

var $3A2mt = parcelRequire("3A2mt");

var $6smyX = parcelRequire("6smyX");

var $kKGfz = parcelRequire("kKGfz");

var $4dUzo = parcelRequire("4dUzo");
/** @type {(O: object) => string} */ var $3770b45e3baf0556$var$$toString = $kKGfz("Object.prototype.toString");

var $3770b45e3baf0556$var$hasToStringTag = (parcelRequire("7kFju"))();
var $3770b45e3baf0556$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
var $3770b45e3baf0556$var$typedArrays = $3A2mt();
var $3770b45e3baf0556$var$$slice = $kKGfz("String.prototype.slice");
var $3770b45e3baf0556$var$getPrototypeOf = Object.getPrototypeOf; // require('getprototypeof');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $3770b45e3baf0556$var$$indexOf = $kKGfz("Array.prototype.indexOf", true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {(receiver: import('.').TypedArray) => string | typeof Uint8Array.prototype.slice.call | typeof Uint8Array.prototype.set.call} Getter */ /** @type {{ [k in `\$${import('.').TypedArrayName}`]?: Getter } & { __proto__: null }} */ var $3770b45e3baf0556$var$cache = {
    __proto__: null
};
if ($3770b45e3baf0556$var$hasToStringTag && $4dUzo && $3770b45e3baf0556$var$getPrototypeOf) $aHlUe($3770b45e3baf0556$var$typedArrays, function(typedArray) {
    var arr = new $3770b45e3baf0556$var$g[typedArray]();
    if (Symbol.toStringTag in arr) {
        var proto = $3770b45e3baf0556$var$getPrototypeOf(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $4dUzo(proto, Symbol.toStringTag);
        if (!descriptor) {
            var superProto = $3770b45e3baf0556$var$getPrototypeOf(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $4dUzo(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $3770b45e3baf0556$var$cache["$" + typedArray] = $6smyX(descriptor.get);
    }
});
else $aHlUe($3770b45e3baf0556$var$typedArrays, function(typedArray) {
    var arr = new $3770b45e3baf0556$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) // @ts-expect-error TODO: fix
    $3770b45e3baf0556$var$cache["$" + typedArray] = $6smyX(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $3770b45e3baf0556$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $aHlUe(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $3770b45e3baf0556$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            if ("$" + getter(value) === typedArray) found = $3770b45e3baf0556$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $3770b45e3baf0556$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $aHlUe(// eslint-disable-next-line no-extra-parens
    /** @type {Record<`\$${TypedArrayName}`, Getter>} */ /** @type {any} */ $3770b45e3baf0556$var$cache, /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error TODO: fix
            getter(value);
            found = $3770b45e3baf0556$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== "object") return false;
    if (!$3770b45e3baf0556$var$hasToStringTag) {
        /** @type {string} */ var tag = $3770b45e3baf0556$var$$slice($3770b45e3baf0556$var$$toString(value), 8, -1);
        if ($3770b45e3baf0556$var$$indexOf($3770b45e3baf0556$var$typedArrays, tag) > -1) return tag;
        if (tag !== "Object") return false;
        // node < 0.6 hits here on real Typed Arrays
        return $3770b45e3baf0556$var$trySlices(value);
    }
    if (!$4dUzo) return null;
     // unknown engine
    return $3770b45e3baf0556$var$tryTypedArrays(value);
};

});
parcelRegister("aHlUe", function(module, exports) {
"use strict";

var $iG4Kq = parcelRequire("iG4Kq");
var $7c9ee99fb691c988$var$toStr = Object.prototype.toString;
var $7c9ee99fb691c988$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $7c9ee99fb691c988$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($7c9ee99fb691c988$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
var $7c9ee99fb691c988$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
var $7c9ee99fb691c988$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($7c9ee99fb691c988$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
var $7c9ee99fb691c988$var$forEach = function forEach(list, iterator, thisArg) {
    if (!$iG4Kq(iterator)) throw new TypeError("iterator must be a function");
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($7c9ee99fb691c988$var$toStr.call(list) === "[object Array]") $7c9ee99fb691c988$var$forEachArray(list, iterator, receiver);
    else if (typeof list === "string") $7c9ee99fb691c988$var$forEachString(list, iterator, receiver);
    else $7c9ee99fb691c988$var$forEachObject(list, iterator, receiver);
};
module.exports = $7c9ee99fb691c988$var$forEach;

});
parcelRegister("iG4Kq", function(module, exports) {
"use strict";
var $d98fd511e5c4d6d5$var$fnToStr = Function.prototype.toString;
var $d98fd511e5c4d6d5$var$reflectApply = typeof Reflect === "object" && Reflect !== null && Reflect.apply;
var $d98fd511e5c4d6d5$var$badArrayLike;
var $d98fd511e5c4d6d5$var$isCallableMarker;
if (typeof $d98fd511e5c4d6d5$var$reflectApply === "function" && typeof Object.defineProperty === "function") try {
    $d98fd511e5c4d6d5$var$badArrayLike = Object.defineProperty({}, "length", {
        get: function() {
            throw $d98fd511e5c4d6d5$var$isCallableMarker;
        }
    });
    $d98fd511e5c4d6d5$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $d98fd511e5c4d6d5$var$reflectApply(function() {
        throw 42;
    }, null, $d98fd511e5c4d6d5$var$badArrayLike);
} catch (_) {
    if (_ !== $d98fd511e5c4d6d5$var$isCallableMarker) $d98fd511e5c4d6d5$var$reflectApply = null;
}
else $d98fd511e5c4d6d5$var$reflectApply = null;
var $d98fd511e5c4d6d5$var$constructorRegex = /^\s*class\b/;
var $d98fd511e5c4d6d5$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $d98fd511e5c4d6d5$var$fnToStr.call(value);
        return $d98fd511e5c4d6d5$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $d98fd511e5c4d6d5$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($d98fd511e5c4d6d5$var$isES6ClassFn(value)) return false;
        $d98fd511e5c4d6d5$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $d98fd511e5c4d6d5$var$toStr = Object.prototype.toString;
var $d98fd511e5c4d6d5$var$objectClass = "[object Object]";
var $d98fd511e5c4d6d5$var$fnClass = "[object Function]";
var $d98fd511e5c4d6d5$var$genClass = "[object GeneratorFunction]";
var $d98fd511e5c4d6d5$var$ddaClass = "[object HTMLAllCollection]"; // IE 11
var $d98fd511e5c4d6d5$var$ddaClass2 = "[object HTML document.all class]";
var $d98fd511e5c4d6d5$var$ddaClass3 = "[object HTMLCollection]"; // IE 9-10
var $d98fd511e5c4d6d5$var$hasToStringTag = typeof Symbol === "function" && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $d98fd511e5c4d6d5$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $d98fd511e5c4d6d5$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === "object") {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $d98fd511e5c4d6d5$var$all = document.all;
    if ($d98fd511e5c4d6d5$var$toStr.call($d98fd511e5c4d6d5$var$all) === $d98fd511e5c4d6d5$var$toStr.call(document.all)) $d98fd511e5c4d6d5$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($d98fd511e5c4d6d5$var$isIE68 || !value) && (typeof value === "undefined" || typeof value === "object")) try {
            var str = $d98fd511e5c4d6d5$var$toStr.call(value);
            return (str === $d98fd511e5c4d6d5$var$ddaClass || str === $d98fd511e5c4d6d5$var$ddaClass2 || str === $d98fd511e5c4d6d5$var$ddaClass3 // opera 12.16
             || str === $d98fd511e5c4d6d5$var$objectClass // IE 6-8
            ) && value("") == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $d98fd511e5c4d6d5$var$reflectApply ? function isCallable(value) {
    if ($d98fd511e5c4d6d5$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    try {
        $d98fd511e5c4d6d5$var$reflectApply(value, null, $d98fd511e5c4d6d5$var$badArrayLike);
    } catch (e) {
        if (e !== $d98fd511e5c4d6d5$var$isCallableMarker) return false;
    }
    return !$d98fd511e5c4d6d5$var$isES6ClassFn(value) && $d98fd511e5c4d6d5$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($d98fd511e5c4d6d5$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== "function" && typeof value !== "object") return false;
    if ($d98fd511e5c4d6d5$var$hasToStringTag) return $d98fd511e5c4d6d5$var$tryFunctionObject(value);
    if ($d98fd511e5c4d6d5$var$isES6ClassFn(value)) return false;
    var strClass = $d98fd511e5c4d6d5$var$toStr.call(value);
    if (strClass !== $d98fd511e5c4d6d5$var$fnClass && strClass !== $d98fd511e5c4d6d5$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $d98fd511e5c4d6d5$var$tryFunctionObject(value);
};

});


parcelRegister("3A2mt", function(module, exports) {
"use strict";

var $5h9Dd = parcelRequire("5h9Dd");
var $29b690d7e64e7da6$var$g = typeof globalThis === "undefined" ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $5h9Dd.length; i++)if (typeof $29b690d7e64e7da6$var$g[$5h9Dd[i]] === "function") // @ts-expect-error
    out[out.length] = $5h9Dd[i];
    return out;
};

});
parcelRegister("5h9Dd", function(module, exports) {
"use strict";
/** @type {import('.')} */ module.exports = [
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
];

});



parcelRegister("lLKSK", function(module, exports) {
"use strict";

var $4L6DV = parcelRequire("4L6DV");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$4L6DV(value);
};

});


parcelRegister("casFQ", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === "object" && typeof arg.copy === "function" && typeof arg.fill === "function" && typeof arg.readUInt8 === "function";
};

});

parcelRegister("kaPX0", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("9qR8M", function(module, exports) {
"use strict";
var timeago = function() {
    var o = {
        second: 1000,
        minute: 60000,
        hour: 3600000,
        day: 86400000,
        week: 604800000,
        month: 2592000000,
        year: 31536000000
    };
    var obj = {};
    obj.ago = function(nd, s) {
        var r = Math.round, dir = " ago", pl = function(v, n) {
            return s === undefined ? n + " " + v + (n > 1 ? "s" : "") + dir : n + v.substring(0, 1);
        }, ts = Date.now() - new Date(nd).getTime(), ii;
        if (ts < 0) {
            ts *= -1;
            dir = " from now";
        }
        for(var i in o){
            if (r(ts) < o[i]) return pl(ii || "m", r(ts / (o[ii] || 1)));
            ii = i;
        }
        return pl(i, r(ts / o[i]));
    };
    obj.today = function() {
        var now = new Date();
        var Weekday = new Array("Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday");
        var Month = new Array("January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December");
        return Weekday[now.getDay()] + ", " + Month[now.getMonth()] + " " + now.getDate() + ", " + now.getFullYear();
    };
    obj.timefriendly = function(s) {
        var t = s.match(/(\d).([a-z]*?)s?$/);
        return t[1] * eval(o[t[2]]);
    };
    obj.mintoread = function(text, altcmt, wpm) {
        var m = Math.round(text.split(" ").length / (wpm || 200));
        return (m || "< 1") + (altcmt || " min to read");
    };
    return obj;
};
if (0, module.exports) module.exports = timeago();

});

parcelRegister("3pSlN", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $27cdddce13775aa1$export$2b8d127b894957b9; }, function (v) { return $27cdddce13775aa1$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $27cdddce13775aa1$export$cea3a54a6425200c; }, function (v) { return $27cdddce13775aa1$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $27cdddce13775aa1$export$a7c73072b1a182ae; }, function (v) { return $27cdddce13775aa1$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $27cdddce13775aa1$export$9f27bc3417b4524d; }, function (v) { return $27cdddce13775aa1$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $27cdddce13775aa1$export$db77ccec0bb4ccac; }, function (v) { return $27cdddce13775aa1$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $27cdddce13775aa1$export$8392c0c9d3dcbd35; }, function (v) { return $27cdddce13775aa1$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $27cdddce13775aa1$export$ffb0004e005737fa; }, function (v) { return $27cdddce13775aa1$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $27cdddce13775aa1$export$b624eff549462981; }, function (v) { return $27cdddce13775aa1$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $27cdddce13775aa1$export$7897aa7841a5380c; }, function (v) { return $27cdddce13775aa1$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $27cdddce13775aa1$export$602eac185826482c; }, function (v) { return $27cdddce13775aa1$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $27cdddce13775aa1$export$e2c29f18771995cb; }, function (v) { return $27cdddce13775aa1$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $27cdddce13775aa1$export$5f8d39834fd61797; }, function (v) { return $27cdddce13775aa1$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $27cdddce13775aa1$export$74bf444e3cd11ea5; }, function (v) { return $27cdddce13775aa1$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $27cdddce13775aa1$export$92387174baf9b227; }, function (v) { return $27cdddce13775aa1$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $27cdddce13775aa1$export$ec112efeb987d9c6; }, function (v) { return $27cdddce13775aa1$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $27cdddce13775aa1$export$b706b080d889d2c9; }, function (v) { return $27cdddce13775aa1$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $27cdddce13775aa1$export$5be5a87408f70ddc; }, function (v) { return $27cdddce13775aa1$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $27cdddce13775aa1$export$45a5e7f76e0caa8d; }, function (v) { return $27cdddce13775aa1$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $27cdddce13775aa1$export$455c2e768291efa6; }, function (v) { return $27cdddce13775aa1$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $27cdddce13775aa1$export$9522e17588c12572; }, function (v) { return $27cdddce13775aa1$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $27cdddce13775aa1$export$2110ac352bb060b9; }, function (v) { return $27cdddce13775aa1$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $27cdddce13775aa1$export$56885ab8b9c456ab; }, function (v) { return $27cdddce13775aa1$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $27cdddce13775aa1$export$d927fcb6adf8f9de; }, function (v) { return $27cdddce13775aa1$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $27cdddce13775aa1$export$b82d16f27459e05a; }, function (v) { return $27cdddce13775aa1$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $27cdddce13775aa1$export$522c17b4f5e123e8; }, function (v) { return $27cdddce13775aa1$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $27cdddce13775aa1$export$1aabd8a0274ecfd6; }, function (v) { return $27cdddce13775aa1$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $27cdddce13775aa1$export$9b621391a187a31a; }, function (v) { return $27cdddce13775aa1$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $27cdddce13775aa1$export$f5bbd400c2f4426f; }, function (v) { return $27cdddce13775aa1$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $27cdddce13775aa1$export$2b8d127b894957b9;
var $27cdddce13775aa1$export$cea3a54a6425200c;
var $27cdddce13775aa1$export$a7c73072b1a182ae;
var $27cdddce13775aa1$export$9f27bc3417b4524d;
var $27cdddce13775aa1$export$db77ccec0bb4ccac;
var $27cdddce13775aa1$export$8392c0c9d3dcbd35;
var $27cdddce13775aa1$export$ffb0004e005737fa;
var $27cdddce13775aa1$export$b624eff549462981;
var $27cdddce13775aa1$export$7897aa7841a5380c;
var $27cdddce13775aa1$export$602eac185826482c;
var $27cdddce13775aa1$export$e2c29f18771995cb;
var $27cdddce13775aa1$export$5f8d39834fd61797;
var $27cdddce13775aa1$export$74bf444e3cd11ea5;
var $27cdddce13775aa1$export$92387174baf9b227;
var $27cdddce13775aa1$export$ec112efeb987d9c6;
var $27cdddce13775aa1$export$b706b080d889d2c9;
var $27cdddce13775aa1$export$5be5a87408f70ddc;
var $27cdddce13775aa1$export$45a5e7f76e0caa8d;
var $27cdddce13775aa1$export$455c2e768291efa6;
var $27cdddce13775aa1$export$9522e17588c12572;
var $27cdddce13775aa1$export$2110ac352bb060b9;
var $27cdddce13775aa1$export$56885ab8b9c456ab;
var $27cdddce13775aa1$export$d927fcb6adf8f9de;
var $27cdddce13775aa1$export$b82d16f27459e05a;
var $27cdddce13775aa1$export$522c17b4f5e123e8;
var $27cdddce13775aa1$export$1aabd8a0274ecfd6;
var $27cdddce13775aa1$export$9b621391a187a31a;
var $27cdddce13775aa1$export$f5bbd400c2f4426f;
"use strict";
var $27cdddce13775aa1$var$b = "function" === typeof Symbol && Symbol.for, $27cdddce13775aa1$var$c = $27cdddce13775aa1$var$b ? Symbol.for("react.element") : 60103, $27cdddce13775aa1$var$d = $27cdddce13775aa1$var$b ? Symbol.for("react.portal") : 60106, $27cdddce13775aa1$var$e = $27cdddce13775aa1$var$b ? Symbol.for("react.fragment") : 60107, $27cdddce13775aa1$var$f = $27cdddce13775aa1$var$b ? Symbol.for("react.strict_mode") : 60108, $27cdddce13775aa1$var$g = $27cdddce13775aa1$var$b ? Symbol.for("react.profiler") : 60114, $27cdddce13775aa1$var$h = $27cdddce13775aa1$var$b ? Symbol.for("react.provider") : 60109, $27cdddce13775aa1$var$k = $27cdddce13775aa1$var$b ? Symbol.for("react.context") : 60110, $27cdddce13775aa1$var$l = $27cdddce13775aa1$var$b ? Symbol.for("react.async_mode") : 60111, $27cdddce13775aa1$var$m = $27cdddce13775aa1$var$b ? Symbol.for("react.concurrent_mode") : 60111, $27cdddce13775aa1$var$n = $27cdddce13775aa1$var$b ? Symbol.for("react.forward_ref") : 60112, $27cdddce13775aa1$var$p = $27cdddce13775aa1$var$b ? Symbol.for("react.suspense") : 60113, $27cdddce13775aa1$var$q = $27cdddce13775aa1$var$b ? Symbol.for("react.suspense_list") : 60120, $27cdddce13775aa1$var$r = $27cdddce13775aa1$var$b ? Symbol.for("react.memo") : 60115, $27cdddce13775aa1$var$t = $27cdddce13775aa1$var$b ? Symbol.for("react.lazy") : 60116, $27cdddce13775aa1$var$v = $27cdddce13775aa1$var$b ? Symbol.for("react.block") : 60121, $27cdddce13775aa1$var$w = $27cdddce13775aa1$var$b ? Symbol.for("react.fundamental") : 60117, $27cdddce13775aa1$var$x = $27cdddce13775aa1$var$b ? Symbol.for("react.responder") : 60118, $27cdddce13775aa1$var$y = $27cdddce13775aa1$var$b ? Symbol.for("react.scope") : 60119;
function $27cdddce13775aa1$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $27cdddce13775aa1$var$c:
                switch(a = a.type, a){
                    case $27cdddce13775aa1$var$l:
                    case $27cdddce13775aa1$var$m:
                    case $27cdddce13775aa1$var$e:
                    case $27cdddce13775aa1$var$g:
                    case $27cdddce13775aa1$var$f:
                    case $27cdddce13775aa1$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $27cdddce13775aa1$var$k:
                            case $27cdddce13775aa1$var$n:
                            case $27cdddce13775aa1$var$t:
                            case $27cdddce13775aa1$var$r:
                            case $27cdddce13775aa1$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $27cdddce13775aa1$var$d:
                return u;
        }
    }
}
function $27cdddce13775aa1$var$A(a) {
    return $27cdddce13775aa1$var$z(a) === $27cdddce13775aa1$var$m;
}
$27cdddce13775aa1$export$2b8d127b894957b9 = $27cdddce13775aa1$var$l;
$27cdddce13775aa1$export$cea3a54a6425200c = $27cdddce13775aa1$var$m;
$27cdddce13775aa1$export$a7c73072b1a182ae = $27cdddce13775aa1$var$k;
$27cdddce13775aa1$export$9f27bc3417b4524d = $27cdddce13775aa1$var$h;
$27cdddce13775aa1$export$db77ccec0bb4ccac = $27cdddce13775aa1$var$c;
$27cdddce13775aa1$export$8392c0c9d3dcbd35 = $27cdddce13775aa1$var$n;
$27cdddce13775aa1$export$ffb0004e005737fa = $27cdddce13775aa1$var$e;
$27cdddce13775aa1$export$b624eff549462981 = $27cdddce13775aa1$var$t;
$27cdddce13775aa1$export$7897aa7841a5380c = $27cdddce13775aa1$var$r;
$27cdddce13775aa1$export$602eac185826482c = $27cdddce13775aa1$var$d;
$27cdddce13775aa1$export$e2c29f18771995cb = $27cdddce13775aa1$var$g;
$27cdddce13775aa1$export$5f8d39834fd61797 = $27cdddce13775aa1$var$f;
$27cdddce13775aa1$export$74bf444e3cd11ea5 = $27cdddce13775aa1$var$p;
$27cdddce13775aa1$export$92387174baf9b227 = function(a) {
    return $27cdddce13775aa1$var$A(a) || $27cdddce13775aa1$var$z(a) === $27cdddce13775aa1$var$l;
};
$27cdddce13775aa1$export$ec112efeb987d9c6 = $27cdddce13775aa1$var$A;
$27cdddce13775aa1$export$b706b080d889d2c9 = function(a) {
    return $27cdddce13775aa1$var$z(a) === $27cdddce13775aa1$var$k;
};
$27cdddce13775aa1$export$5be5a87408f70ddc = function(a) {
    return $27cdddce13775aa1$var$z(a) === $27cdddce13775aa1$var$h;
};
$27cdddce13775aa1$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $27cdddce13775aa1$var$c;
};
$27cdddce13775aa1$export$455c2e768291efa6 = function(a) {
    return $27cdddce13775aa1$var$z(a) === $27cdddce13775aa1$var$n;
};
$27cdddce13775aa1$export$9522e17588c12572 = function(a) {
    return $27cdddce13775aa1$var$z(a) === $27cdddce13775aa1$var$e;
};
$27cdddce13775aa1$export$2110ac352bb060b9 = function(a) {
    return $27cdddce13775aa1$var$z(a) === $27cdddce13775aa1$var$t;
};
$27cdddce13775aa1$export$56885ab8b9c456ab = function(a) {
    return $27cdddce13775aa1$var$z(a) === $27cdddce13775aa1$var$r;
};
$27cdddce13775aa1$export$d927fcb6adf8f9de = function(a) {
    return $27cdddce13775aa1$var$z(a) === $27cdddce13775aa1$var$d;
};
$27cdddce13775aa1$export$b82d16f27459e05a = function(a) {
    return $27cdddce13775aa1$var$z(a) === $27cdddce13775aa1$var$g;
};
$27cdddce13775aa1$export$522c17b4f5e123e8 = function(a) {
    return $27cdddce13775aa1$var$z(a) === $27cdddce13775aa1$var$f;
};
$27cdddce13775aa1$export$1aabd8a0274ecfd6 = function(a) {
    return $27cdddce13775aa1$var$z(a) === $27cdddce13775aa1$var$p;
};
$27cdddce13775aa1$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $27cdddce13775aa1$var$e || a === $27cdddce13775aa1$var$m || a === $27cdddce13775aa1$var$g || a === $27cdddce13775aa1$var$f || a === $27cdddce13775aa1$var$p || a === $27cdddce13775aa1$var$q || "object" === typeof a && null !== a && (a.$$typeof === $27cdddce13775aa1$var$t || a.$$typeof === $27cdddce13775aa1$var$r || a.$$typeof === $27cdddce13775aa1$var$h || a.$$typeof === $27cdddce13775aa1$var$k || a.$$typeof === $27cdddce13775aa1$var$n || a.$$typeof === $27cdddce13775aa1$var$w || a.$$typeof === $27cdddce13775aa1$var$x || a.$$typeof === $27cdddce13775aa1$var$y || a.$$typeof === $27cdddce13775aa1$var$v);
};
$27cdddce13775aa1$export$f5bbd400c2f4426f = $27cdddce13775aa1$var$z;

});

parcelRegister("jKc4S", function(module, exports) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`

module.exports = (parcelRequire("dLb7w"));

});
parcelRegister("dLb7w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_band.default;
    }
});
Object.defineProperty(module.exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_diverging.divergingLog;
    }
});
Object.defineProperty(module.exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_diverging.divergingPow;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_diverging.divergingSqrt;
    }
});
Object.defineProperty(module.exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_diverging.divergingSymlog;
    }
});
Object.defineProperty(module.exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_identity.default;
    }
});
Object.defineProperty(module.exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_ordinal.implicit;
    }
});
Object.defineProperty(module.exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_log.default;
    }
});
Object.defineProperty(module.exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_ordinal.default;
    }
});
Object.defineProperty(module.exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_band.point;
    }
});
Object.defineProperty(module.exports, "scalePow", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_pow.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_quantize.default;
    }
});
Object.defineProperty(module.exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_radial.default;
    }
});
Object.defineProperty(module.exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_sequential.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_sequential.sequentialLog;
    }
});
Object.defineProperty(module.exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_sequential.sequentialPow;
    }
});
Object.defineProperty(module.exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_sequentialQuantile.default;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_sequential.sequentialSqrt;
    }
});
Object.defineProperty(module.exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_sequential.sequentialSymlog;
    }
});
Object.defineProperty(module.exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_pow.sqrt;
    }
});
Object.defineProperty(module.exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_symlog.default;
    }
});
Object.defineProperty(module.exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_threshold.default;
    }
});
Object.defineProperty(module.exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_time.default;
    }
});
Object.defineProperty(module.exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_utcTime.default;
    }
});
Object.defineProperty(module.exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return $a0484a6bbb99ceb4$var$_tickFormat.default;
    }
});

var $a0484a6bbb99ceb4$var$_band = $a0484a6bbb99ceb4$var$_interopRequireWildcard((parcelRequire("2gQ1i")));

var $a0484a6bbb99ceb4$var$_identity = $a0484a6bbb99ceb4$var$_interopRequireDefault((parcelRequire("dZtYm")));

var $a0484a6bbb99ceb4$var$_linear = $a0484a6bbb99ceb4$var$_interopRequireDefault((parcelRequire("ilLMd")));

var $a0484a6bbb99ceb4$var$_log = $a0484a6bbb99ceb4$var$_interopRequireDefault((parcelRequire("2kaib")));

var $a0484a6bbb99ceb4$var$_symlog = $a0484a6bbb99ceb4$var$_interopRequireDefault((parcelRequire("61Ei9")));

var $a0484a6bbb99ceb4$var$_ordinal = $a0484a6bbb99ceb4$var$_interopRequireWildcard((parcelRequire("4lmwm")));

var $a0484a6bbb99ceb4$var$_pow = $a0484a6bbb99ceb4$var$_interopRequireWildcard((parcelRequire("fBfC8")));

var $a0484a6bbb99ceb4$var$_radial = $a0484a6bbb99ceb4$var$_interopRequireDefault((parcelRequire("gvxWP")));

var $a0484a6bbb99ceb4$var$_quantile = $a0484a6bbb99ceb4$var$_interopRequireDefault((parcelRequire("fesZO")));

var $a0484a6bbb99ceb4$var$_quantize = $a0484a6bbb99ceb4$var$_interopRequireDefault((parcelRequire("2uUvL")));

var $a0484a6bbb99ceb4$var$_threshold = $a0484a6bbb99ceb4$var$_interopRequireDefault((parcelRequire("iTlTl")));

var $a0484a6bbb99ceb4$var$_time = $a0484a6bbb99ceb4$var$_interopRequireDefault((parcelRequire("homkz")));

var $a0484a6bbb99ceb4$var$_utcTime = $a0484a6bbb99ceb4$var$_interopRequireDefault((parcelRequire("8yK0I")));

var $a0484a6bbb99ceb4$var$_sequential = $a0484a6bbb99ceb4$var$_interopRequireWildcard((parcelRequire("4NPLE")));

var $a0484a6bbb99ceb4$var$_sequentialQuantile = $a0484a6bbb99ceb4$var$_interopRequireDefault((parcelRequire("iz6Gb")));

var $a0484a6bbb99ceb4$var$_diverging = $a0484a6bbb99ceb4$var$_interopRequireWildcard((parcelRequire("fM0bR")));

var $a0484a6bbb99ceb4$var$_tickFormat = $a0484a6bbb99ceb4$var$_interopRequireDefault((parcelRequire("bRHl9")));
function $a0484a6bbb99ceb4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a0484a6bbb99ceb4$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a0484a6bbb99ceb4$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a0484a6bbb99ceb4$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a0484a6bbb99ceb4$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("2gQ1i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1a756d735551c119$var$band;
module.exports.point = $1a756d735551c119$var$point;

var $7oz1V = parcelRequire("7oz1V");

var $cnxlJ = parcelRequire("cnxlJ");

var $1a756d735551c119$var$_ordinal = $1a756d735551c119$var$_interopRequireDefault((parcelRequire("4lmwm")));
function $1a756d735551c119$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1a756d735551c119$var$band() {
    var scale = (0, $1a756d735551c119$var$_ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $7oz1V.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $1a756d735551c119$var$band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return $cnxlJ.initRange.apply(rescale(), arguments);
}
function $1a756d735551c119$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $1a756d735551c119$var$pointish(copy());
    };
    return scale;
}
function $1a756d735551c119$var$point() {
    return $1a756d735551c119$var$pointish($1a756d735551c119$var$band.apply(null, arguments).paddingInner(1));
}

});
parcelRegister("7oz1V", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Adder", {
    enumerable: true,
    get: function() {
        return $hHjv2.Adder;
    }
});
Object.defineProperty(module.exports, "InternMap", {
    enumerable: true,
    get: function() {
        return $bIdoG.InternMap;
    }
});
Object.defineProperty(module.exports, "InternSet", {
    enumerable: true,
    get: function() {
        return $bIdoG.InternSet;
    }
});
Object.defineProperty(module.exports, "ascending", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "bin", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "bisect", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_bisect.default;
    }
});
Object.defineProperty(module.exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_bisect.bisectCenter;
    }
});
Object.defineProperty(module.exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_bisect.bisectLeft;
    }
});
Object.defineProperty(module.exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_bisect.bisectRight;
    }
});
Object.defineProperty(module.exports, "bisector", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_bisector.default;
    }
});
Object.defineProperty(module.exports, "count", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_count.default;
    }
});
Object.defineProperty(module.exports, "cross", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "cumsum", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_cumsum.default;
    }
});
Object.defineProperty(module.exports, "descending", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "deviation", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_deviation.default;
    }
});
Object.defineProperty(module.exports, "difference", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_difference.default;
    }
});
Object.defineProperty(module.exports, "disjoint", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_disjoint.default;
    }
});
Object.defineProperty(module.exports, "every", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_every.default;
    }
});
Object.defineProperty(module.exports, "extent", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_extent.default;
    }
});
Object.defineProperty(module.exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return $hHjv2.fcumsum;
    }
});
Object.defineProperty(module.exports, "filter", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_filter.default;
    }
});
Object.defineProperty(module.exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_group.flatGroup;
    }
});
Object.defineProperty(module.exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_group.flatRollup;
    }
});
Object.defineProperty(module.exports, "fsum", {
    enumerable: true,
    get: function() {
        return $hHjv2.fsum;
    }
});
Object.defineProperty(module.exports, "greatest", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_greatest.default;
    }
});
Object.defineProperty(module.exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_greatestIndex.default;
    }
});
Object.defineProperty(module.exports, "group", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_group.default;
    }
});
Object.defineProperty(module.exports, "groupSort", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_groupSort.default;
    }
});
Object.defineProperty(module.exports, "groups", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_group.groups;
    }
});
Object.defineProperty(module.exports, "histogram", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_bin.default;
    }
});
Object.defineProperty(module.exports, "index", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_group.index;
    }
});
Object.defineProperty(module.exports, "indexes", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_group.indexes;
    }
});
Object.defineProperty(module.exports, "intersection", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_intersection.default;
    }
});
Object.defineProperty(module.exports, "least", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_least.default;
    }
});
Object.defineProperty(module.exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_leastIndex.default;
    }
});
Object.defineProperty(module.exports, "map", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_map.default;
    }
});
Object.defineProperty(module.exports, "max", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_max.default;
    }
});
Object.defineProperty(module.exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_maxIndex.default;
    }
});
Object.defineProperty(module.exports, "mean", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_mean.default;
    }
});
Object.defineProperty(module.exports, "median", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_median.default;
    }
});
Object.defineProperty(module.exports, "merge", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_merge.default;
    }
});
Object.defineProperty(module.exports, "min", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_min.default;
    }
});
Object.defineProperty(module.exports, "minIndex", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_minIndex.default;
    }
});
Object.defineProperty(module.exports, "mode", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_mode.default;
    }
});
Object.defineProperty(module.exports, "nice", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_nice.default;
    }
});
Object.defineProperty(module.exports, "pairs", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_pairs.default;
    }
});
Object.defineProperty(module.exports, "permute", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_permute.default;
    }
});
Object.defineProperty(module.exports, "quantile", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_quantile.default;
    }
});
Object.defineProperty(module.exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_quantile.quantileSorted;
    }
});
Object.defineProperty(module.exports, "quickselect", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_quickselect.default;
    }
});
Object.defineProperty(module.exports, "range", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_range.default;
    }
});
Object.defineProperty(module.exports, "rank", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_rank.default;
    }
});
Object.defineProperty(module.exports, "reduce", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_reduce.default;
    }
});
Object.defineProperty(module.exports, "reverse", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "rollup", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_group.rollup;
    }
});
Object.defineProperty(module.exports, "rollups", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_group.rollups;
    }
});
Object.defineProperty(module.exports, "scan", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_scan.default;
    }
});
Object.defineProperty(module.exports, "shuffle", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_shuffle.default;
    }
});
Object.defineProperty(module.exports, "shuffler", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_shuffle.shuffler;
    }
});
Object.defineProperty(module.exports, "some", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_some.default;
    }
});
Object.defineProperty(module.exports, "sort", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_sort.default;
    }
});
Object.defineProperty(module.exports, "subset", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_subset.default;
    }
});
Object.defineProperty(module.exports, "sum", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_sum.default;
    }
});
Object.defineProperty(module.exports, "superset", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_superset.default;
    }
});
Object.defineProperty(module.exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_freedmanDiaconis.default;
    }
});
Object.defineProperty(module.exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_scott.default;
    }
});
Object.defineProperty(module.exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_sturges.default;
    }
});
Object.defineProperty(module.exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_ticks.tickIncrement;
    }
});
Object.defineProperty(module.exports, "tickStep", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_ticks.tickStep;
    }
});
Object.defineProperty(module.exports, "ticks", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_ticks.default;
    }
});
Object.defineProperty(module.exports, "transpose", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_transpose.default;
    }
});
Object.defineProperty(module.exports, "union", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_union.default;
    }
});
Object.defineProperty(module.exports, "variance", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_variance.default;
    }
});
Object.defineProperty(module.exports, "zip", {
    enumerable: true,
    get: function() {
        return $5625f283c48ae225$var$_zip.default;
    }
});

var $5625f283c48ae225$var$_bisect = $5625f283c48ae225$var$_interopRequireWildcard((parcelRequire("74Pvt")));

var $5625f283c48ae225$var$_ascending = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("41UsN")));

var $5625f283c48ae225$var$_bisector = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("jK0Qo")));

var $5625f283c48ae225$var$_count = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("gK2PS")));

var $5625f283c48ae225$var$_cross = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("6AlUY")));

var $5625f283c48ae225$var$_cumsum = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("3tkZR")));

var $5625f283c48ae225$var$_descending = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("7saQg")));

var $5625f283c48ae225$var$_deviation = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("hkeTX")));

var $5625f283c48ae225$var$_extent = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("hK8cL")));

var $hHjv2 = parcelRequire("hHjv2");

var $5625f283c48ae225$var$_group = $5625f283c48ae225$var$_interopRequireWildcard((parcelRequire("46EQZ")));

var $5625f283c48ae225$var$_groupSort = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("2otYx")));

var $5625f283c48ae225$var$_bin = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("emOTT")));

var $5625f283c48ae225$var$_freedmanDiaconis = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("4ad5l")));

var $5625f283c48ae225$var$_scott = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("jCMnU")));

var $5625f283c48ae225$var$_sturges = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("bWR6B")));

var $5625f283c48ae225$var$_max = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("crOXk")));

var $5625f283c48ae225$var$_maxIndex = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("j2RKx")));

var $5625f283c48ae225$var$_mean = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("4PtdG")));

var $5625f283c48ae225$var$_median = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("guIWe")));

var $5625f283c48ae225$var$_merge = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("iaelO")));

var $5625f283c48ae225$var$_min = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("8TS4y")));

var $5625f283c48ae225$var$_minIndex = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("2PHl2")));

var $5625f283c48ae225$var$_mode = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("2OLMC")));

var $5625f283c48ae225$var$_nice = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("8VcvD")));

var $5625f283c48ae225$var$_pairs = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("3yZzP")));

var $5625f283c48ae225$var$_permute = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("X5Fqy")));

var $5625f283c48ae225$var$_quantile = $5625f283c48ae225$var$_interopRequireWildcard((parcelRequire("j5CGU")));

var $5625f283c48ae225$var$_quickselect = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("fY8Xm")));

var $5625f283c48ae225$var$_range = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("bIdSV")));

var $5625f283c48ae225$var$_rank = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("kqB6b")));

var $5625f283c48ae225$var$_least = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("cJKEz")));

var $5625f283c48ae225$var$_leastIndex = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("28Fjr")));

var $5625f283c48ae225$var$_greatest = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("BBrtf")));

var $5625f283c48ae225$var$_greatestIndex = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("9tqYc")));

var $5625f283c48ae225$var$_scan = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("1elLF")));

var $5625f283c48ae225$var$_shuffle = $5625f283c48ae225$var$_interopRequireWildcard((parcelRequire("btFPA")));

var $5625f283c48ae225$var$_sum = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("eVqKs")));

var $5625f283c48ae225$var$_ticks = $5625f283c48ae225$var$_interopRequireWildcard((parcelRequire("hdyih")));

var $5625f283c48ae225$var$_transpose = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("cxQ76")));

var $5625f283c48ae225$var$_variance = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("iQznV")));

var $5625f283c48ae225$var$_zip = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("6sgzw")));

var $5625f283c48ae225$var$_every = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("dhxmm")));

var $5625f283c48ae225$var$_some = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("TNYYF")));

var $5625f283c48ae225$var$_filter = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("k1viL")));

var $5625f283c48ae225$var$_map = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("26fg9")));

var $5625f283c48ae225$var$_reduce = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("1QNBF")));

var $5625f283c48ae225$var$_reverse = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("eC7df")));

var $5625f283c48ae225$var$_sort = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("1s6rO")));

var $5625f283c48ae225$var$_difference = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("7Dz3y")));

var $5625f283c48ae225$var$_disjoint = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("jhTZq")));

var $5625f283c48ae225$var$_intersection = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("iMwmy")));

var $5625f283c48ae225$var$_subset = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("1MQcZ")));

var $5625f283c48ae225$var$_superset = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("hxjsp")));

var $5625f283c48ae225$var$_union = $5625f283c48ae225$var$_interopRequireDefault((parcelRequire("ipuGy")));

var $bIdoG = parcelRequire("bIdoG");
function $5625f283c48ae225$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5625f283c48ae225$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($5625f283c48ae225$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $5625f283c48ae225$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $5625f283c48ae225$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("74Pvt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.bisectRight = module.exports.bisectLeft = module.exports.bisectCenter = void 0;

var $5270dc425288d310$var$_ascending = $5270dc425288d310$var$_interopRequireDefault((parcelRequire("41UsN")));

var $5270dc425288d310$var$_bisector = $5270dc425288d310$var$_interopRequireDefault((parcelRequire("jK0Qo")));

var $5270dc425288d310$var$_number = $5270dc425288d310$var$_interopRequireDefault((parcelRequire("cSTO8")));
function $5270dc425288d310$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $5270dc425288d310$var$ascendingBisect = (0, $5270dc425288d310$var$_bisector.default)($5270dc425288d310$var$_ascending.default);
const $5270dc425288d310$var$bisectRight = $5270dc425288d310$var$ascendingBisect.right;
module.exports.bisectRight = $5270dc425288d310$var$bisectRight;
const $5270dc425288d310$var$bisectLeft = $5270dc425288d310$var$ascendingBisect.left;
module.exports.bisectLeft = $5270dc425288d310$var$bisectLeft;
const $5270dc425288d310$var$bisectCenter = (0, $5270dc425288d310$var$_bisector.default)($5270dc425288d310$var$_number.default).center;
module.exports.bisectCenter = $5270dc425288d310$var$bisectCenter;
var $5270dc425288d310$var$_default = $5270dc425288d310$var$bisectRight;
module.exports.default = $5270dc425288d310$var$_default;

});
parcelRegister("41UsN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2ef30de2df5d78c0$var$ascending;
function $2ef30de2df5d78c0$var$ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

});

parcelRegister("jK0Qo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e5f2f7c99def5d70$var$bisector;

var $e5f2f7c99def5d70$var$_ascending = $e5f2f7c99def5d70$var$_interopRequireDefault((parcelRequire("41UsN")));

var $e5f2f7c99def5d70$var$_descending = $e5f2f7c99def5d70$var$_interopRequireDefault((parcelRequire("7saQg")));
function $e5f2f7c99def5d70$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e5f2f7c99def5d70$var$bisector(f) {
    let compare1, compare2, delta; // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = $e5f2f7c99def5d70$var$_ascending.default;
        compare2 = (d, x)=>(0, $e5f2f7c99def5d70$var$_ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === $e5f2f7c99def5d70$var$_ascending.default || f === $e5f2f7c99def5d70$var$_descending.default ? f : $e5f2f7c99def5d70$var$zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $e5f2f7c99def5d70$var$zero() {
    return 0;
}

});
parcelRegister("7saQg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $56d38ee9e569a05d$var$descending;
function $56d38ee9e569a05d$var$descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});


parcelRegister("cSTO8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9615d1674cb86a4a$var$number;
module.exports.numbers = $9615d1674cb86a4a$var$numbers;
function $9615d1674cb86a4a$var$number(x) {
    return x === null ? NaN : +x;
}
function* $9615d1674cb86a4a$var$numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

});


parcelRegister("gK2PS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c30324555e3f80ef$var$count;
function $c30324555e3f80ef$var$count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

});

parcelRegister("6AlUY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4cb71b4c54d01996$var$cross;
function $4cb71b4c54d01996$var$length(array) {
    return array.length | 0;
}
function $4cb71b4c54d01996$var$empty(length) {
    return !(length > 0);
}
function $4cb71b4c54d01996$var$arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function $4cb71b4c54d01996$var$reducer(reduce) {
    return (values)=>reduce(...values);
}
function $4cb71b4c54d01996$var$cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && $4cb71b4c54d01996$var$reducer(values.pop());
    values = values.map($4cb71b4c54d01996$var$arrayify);
    const lengths = values.map($4cb71b4c54d01996$var$length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some($4cb71b4c54d01996$var$empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

});

parcelRegister("3tkZR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $28745e0d0dc1e859$var$cumsum;
function $28745e0d0dc1e859$var$cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

});

parcelRegister("hkeTX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c9cfdd0bbf953d7c$var$deviation;

var $c9cfdd0bbf953d7c$var$_variance = $c9cfdd0bbf953d7c$var$_interopRequireDefault((parcelRequire("iQznV")));
function $c9cfdd0bbf953d7c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c9cfdd0bbf953d7c$var$deviation(values, valueof) {
    const v = (0, $c9cfdd0bbf953d7c$var$_variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

});
parcelRegister("iQznV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $db888806f021e1fd$var$variance;
function $db888806f021e1fd$var$variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

});


parcelRegister("hK8cL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cead18def33153ab$var$extent;
function $cead18def33153ab$var$extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

});

parcelRegister("hHjv2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Adder = void 0;
module.exports.fcumsum = $ce2594054ed3349e$var$fcumsum;
module.exports.fsum = $ce2594054ed3349e$var$fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class $ce2594054ed3349e$var$Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
module.exports.Adder = $ce2594054ed3349e$var$Adder;
function $ce2594054ed3349e$var$fsum(values, valueof) {
    const adder = new $ce2594054ed3349e$var$Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function $ce2594054ed3349e$var$fcumsum(values, valueof) {
    const adder = new $ce2594054ed3349e$var$Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

});

parcelRegister("46EQZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2fd769ac16ed0332$var$group;
module.exports.flatGroup = $2fd769ac16ed0332$var$flatGroup;
module.exports.flatRollup = $2fd769ac16ed0332$var$flatRollup;
module.exports.groups = $2fd769ac16ed0332$var$groups;
module.exports.index = $2fd769ac16ed0332$var$index;
module.exports.indexes = $2fd769ac16ed0332$var$indexes;
module.exports.rollup = $2fd769ac16ed0332$var$rollup;
module.exports.rollups = $2fd769ac16ed0332$var$rollups;

var $bIdoG = parcelRequire("bIdoG");

var $2fd769ac16ed0332$var$_identity = $2fd769ac16ed0332$var$_interopRequireDefault((parcelRequire("ftPet")));
function $2fd769ac16ed0332$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2fd769ac16ed0332$var$group(values, ...keys) {
    return $2fd769ac16ed0332$var$nest(values, $2fd769ac16ed0332$var$_identity.default, $2fd769ac16ed0332$var$_identity.default, keys);
}
function $2fd769ac16ed0332$var$groups(values, ...keys) {
    return $2fd769ac16ed0332$var$nest(values, Array.from, $2fd769ac16ed0332$var$_identity.default, keys);
}
function $2fd769ac16ed0332$var$flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function $2fd769ac16ed0332$var$flatGroup(values, ...keys) {
    return $2fd769ac16ed0332$var$flatten($2fd769ac16ed0332$var$groups(values, ...keys), keys);
}
function $2fd769ac16ed0332$var$flatRollup(values, reduce, ...keys) {
    return $2fd769ac16ed0332$var$flatten($2fd769ac16ed0332$var$rollups(values, reduce, ...keys), keys);
}
function $2fd769ac16ed0332$var$rollup(values, reduce, ...keys) {
    return $2fd769ac16ed0332$var$nest(values, $2fd769ac16ed0332$var$_identity.default, reduce, keys);
}
function $2fd769ac16ed0332$var$rollups(values, reduce, ...keys) {
    return $2fd769ac16ed0332$var$nest(values, Array.from, reduce, keys);
}
function $2fd769ac16ed0332$var$index(values, ...keys) {
    return $2fd769ac16ed0332$var$nest(values, $2fd769ac16ed0332$var$_identity.default, $2fd769ac16ed0332$var$unique, keys);
}
function $2fd769ac16ed0332$var$indexes(values, ...keys) {
    return $2fd769ac16ed0332$var$nest(values, Array.from, $2fd769ac16ed0332$var$unique, keys);
}
function $2fd769ac16ed0332$var$unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function $2fd769ac16ed0332$var$nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new $bIdoG.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

});
parcelRegister("bIdoG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.InternSet = module.exports.InternMap = void 0;
class $886e322763a07591$var$InternMap extends Map {
    constructor(entries, key = $886e322763a07591$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($886e322763a07591$var$intern_get(this, key));
    }
    has(key) {
        return super.has($886e322763a07591$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($886e322763a07591$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($886e322763a07591$var$intern_delete(this, key));
    }
}
module.exports.InternMap = $886e322763a07591$var$InternMap;
class $886e322763a07591$var$InternSet extends Set {
    constructor(values, key = $886e322763a07591$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($886e322763a07591$var$intern_get(this, value));
    }
    add(value) {
        return super.add($886e322763a07591$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($886e322763a07591$var$intern_delete(this, value));
    }
}
module.exports.InternSet = $886e322763a07591$var$InternSet;
function $886e322763a07591$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $886e322763a07591$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $886e322763a07591$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function $886e322763a07591$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});

parcelRegister("ftPet", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b4514e1f7d90de2d$var$identity;
function $b4514e1f7d90de2d$var$identity(x) {
    return x;
}

});


parcelRegister("2otYx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1be5132d3211ec20$var$groupSort;

var $1be5132d3211ec20$var$_ascending = $1be5132d3211ec20$var$_interopRequireDefault((parcelRequire("41UsN")));

var $1be5132d3211ec20$var$_group = $1be5132d3211ec20$var$_interopRequireWildcard((parcelRequire("46EQZ")));

var $1be5132d3211ec20$var$_sort = $1be5132d3211ec20$var$_interopRequireDefault((parcelRequire("1s6rO")));
function $1be5132d3211ec20$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1be5132d3211ec20$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1be5132d3211ec20$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1be5132d3211ec20$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $1be5132d3211ec20$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1be5132d3211ec20$var$groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, $1be5132d3211ec20$var$_sort.default)((0, $1be5132d3211ec20$var$_group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, $1be5132d3211ec20$var$_ascending.default)(av, bv) || (0, $1be5132d3211ec20$var$_ascending.default)(ak, bk)) : (0, $1be5132d3211ec20$var$_sort.default)((0, $1be5132d3211ec20$var$_group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, $1be5132d3211ec20$var$_ascending.default)(ak, bk))).map(([key])=>key);
}

});
parcelRegister("1s6rO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ascendingDefined = $10ed684dfa7f440c$var$ascendingDefined;
module.exports.compareDefined = $10ed684dfa7f440c$var$compareDefined;
module.exports.default = $10ed684dfa7f440c$var$sort;

var $10ed684dfa7f440c$var$_ascending = $10ed684dfa7f440c$var$_interopRequireDefault((parcelRequire("41UsN")));

var $10ed684dfa7f440c$var$_permute = $10ed684dfa7f440c$var$_interopRequireDefault((parcelRequire("X5Fqy")));
function $10ed684dfa7f440c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $10ed684dfa7f440c$var$sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = $10ed684dfa7f440c$var$ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>$10ed684dfa7f440c$var$ascendingDefined(f[i], f[j]));
        }
        return (0, $10ed684dfa7f440c$var$_permute.default)(values, index);
    }
    return values.sort($10ed684dfa7f440c$var$compareDefined(f));
}
function $10ed684dfa7f440c$var$compareDefined(compare = $10ed684dfa7f440c$var$_ascending.default) {
    if (compare === $10ed684dfa7f440c$var$_ascending.default) return $10ed684dfa7f440c$var$ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function $10ed684dfa7f440c$var$ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

});
parcelRegister("X5Fqy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0b19e82ffd390c2c$var$permute;
function $0b19e82ffd390c2c$var$permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

});



parcelRegister("emOTT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a75a9a888098defa$var$bin;

var $bfzTJ = parcelRequire("bfzTJ");

var $a75a9a888098defa$var$_bisect = $a75a9a888098defa$var$_interopRequireDefault((parcelRequire("74Pvt")));

var $a75a9a888098defa$var$_constant = $a75a9a888098defa$var$_interopRequireDefault((parcelRequire("cXdww")));

var $a75a9a888098defa$var$_extent = $a75a9a888098defa$var$_interopRequireDefault((parcelRequire("hK8cL")));

var $a75a9a888098defa$var$_identity = $a75a9a888098defa$var$_interopRequireDefault((parcelRequire("ftPet")));

var $a75a9a888098defa$var$_nice = $a75a9a888098defa$var$_interopRequireDefault((parcelRequire("8VcvD")));

var $a75a9a888098defa$var$_ticks = $a75a9a888098defa$var$_interopRequireWildcard((parcelRequire("hdyih")));

var $a75a9a888098defa$var$_sturges = $a75a9a888098defa$var$_interopRequireDefault((parcelRequire("bWR6B")));
function $a75a9a888098defa$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($a75a9a888098defa$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $a75a9a888098defa$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $a75a9a888098defa$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $a75a9a888098defa$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a75a9a888098defa$var$bin() {
    var value = $a75a9a888098defa$var$_identity.default, domain = $a75a9a888098defa$var$_extent.default, threshold = $a75a9a888098defa$var$_sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1); // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === $a75a9a888098defa$var$_extent.default) [x0, x1] = (0, $a75a9a888098defa$var$_nice.default)(x0, x1, tn);
            tz = (0, $a75a9a888098defa$var$_ticks.default)(x0, x1, tn); // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, $a75a9a888098defa$var$_ticks.tickIncrement)(x0, x1, tn); // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === $a75a9a888098defa$var$_extent.default) {
                    const step = (0, $a75a9a888098defa$var$_ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        } // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin; // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        } // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, $a75a9a888098defa$var$_bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $a75a9a888098defa$var$_constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, $a75a9a888098defa$var$_constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, $a75a9a888098defa$var$_constant.default)($bfzTJ.slice.call(_)) : (0, $a75a9a888098defa$var$_constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

});
parcelRegister("bfzTJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.slice = module.exports.map = void 0;
var $830cf0fb45a463b0$var$array = Array.prototype;
var $830cf0fb45a463b0$var$slice = $830cf0fb45a463b0$var$array.slice;
module.exports.slice = $830cf0fb45a463b0$var$slice;
var $830cf0fb45a463b0$var$map = $830cf0fb45a463b0$var$array.map;
module.exports.map = $830cf0fb45a463b0$var$map;

});

parcelRegister("cXdww", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $96e57c3764bdd6c9$var$constant;
function $96e57c3764bdd6c9$var$constant(x) {
    return ()=>x;
}

});

parcelRegister("8VcvD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $67ed59ad76b8c33e$var$nice;

var $hdyih = parcelRequire("hdyih");
function $67ed59ad76b8c33e$var$nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, $hdyih.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

});
parcelRegister("hdyih", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c88e40a02258b594$var$ticks;
module.exports.tickIncrement = $c88e40a02258b594$var$tickIncrement;
module.exports.tickStep = $c88e40a02258b594$var$tickStep;
var $c88e40a02258b594$var$e10 = Math.sqrt(50), $c88e40a02258b594$var$e5 = Math.sqrt(10), $c88e40a02258b594$var$e2 = Math.sqrt(2);
function $c88e40a02258b594$var$ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $c88e40a02258b594$var$tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $c88e40a02258b594$var$tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $c88e40a02258b594$var$e10 ? 10 : error >= $c88e40a02258b594$var$e5 ? 5 : error >= $c88e40a02258b594$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $c88e40a02258b594$var$e10 ? 10 : error >= $c88e40a02258b594$var$e5 ? 5 : error >= $c88e40a02258b594$var$e2 ? 2 : 1);
}
function $c88e40a02258b594$var$tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $c88e40a02258b594$var$e10) step1 *= 10;
    else if (error >= $c88e40a02258b594$var$e5) step1 *= 5;
    else if (error >= $c88e40a02258b594$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

});


parcelRegister("bWR6B", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8b2e4e26407731ba$var$thresholdSturges;

var $8b2e4e26407731ba$var$_count = $8b2e4e26407731ba$var$_interopRequireDefault((parcelRequire("gK2PS")));
function $8b2e4e26407731ba$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8b2e4e26407731ba$var$thresholdSturges(values) {
    return Math.ceil(Math.log((0, $8b2e4e26407731ba$var$_count.default)(values)) / Math.LN2) + 1;
}

});


parcelRegister("4ad5l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $30823f0cca2b7527$var$thresholdFreedmanDiaconis;

var $30823f0cca2b7527$var$_count = $30823f0cca2b7527$var$_interopRequireDefault((parcelRequire("gK2PS")));

var $30823f0cca2b7527$var$_quantile = $30823f0cca2b7527$var$_interopRequireDefault((parcelRequire("j5CGU")));
function $30823f0cca2b7527$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $30823f0cca2b7527$var$thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, $30823f0cca2b7527$var$_quantile.default)(values, 0.75) - (0, $30823f0cca2b7527$var$_quantile.default)(values, 0.25)) * Math.pow((0, $30823f0cca2b7527$var$_count.default)(values), -1 / 3)));
}

});
parcelRegister("j5CGU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $de5c7f32718c22dd$var$quantile;
module.exports.quantileSorted = $de5c7f32718c22dd$var$quantileSorted;

var $de5c7f32718c22dd$var$_max = $de5c7f32718c22dd$var$_interopRequireDefault((parcelRequire("crOXk")));

var $de5c7f32718c22dd$var$_min = $de5c7f32718c22dd$var$_interopRequireDefault((parcelRequire("8TS4y")));

var $de5c7f32718c22dd$var$_quickselect = $de5c7f32718c22dd$var$_interopRequireDefault((parcelRequire("fY8Xm")));

var $de5c7f32718c22dd$var$_number = $de5c7f32718c22dd$var$_interopRequireWildcard((parcelRequire("cSTO8")));
function $de5c7f32718c22dd$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($de5c7f32718c22dd$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $de5c7f32718c22dd$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $de5c7f32718c22dd$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $de5c7f32718c22dd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $de5c7f32718c22dd$var$quantile(values, p, valueof) {
    values = Float64Array.from((0, $de5c7f32718c22dd$var$_number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $de5c7f32718c22dd$var$_min.default)(values);
    if (p >= 1) return (0, $de5c7f32718c22dd$var$_max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $de5c7f32718c22dd$var$_max.default)((0, $de5c7f32718c22dd$var$_quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, $de5c7f32718c22dd$var$_min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $de5c7f32718c22dd$var$quantileSorted(values, p, valueof = $de5c7f32718c22dd$var$_number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

});
parcelRegister("crOXk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $90ff8875c4fb1882$var$max;
function $90ff8875c4fb1882$var$max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

});

parcelRegister("8TS4y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $67ad67710a7ea2cf$var$min;
function $67ad67710a7ea2cf$var$min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

});

parcelRegister("fY8Xm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ba036831f6198340$var$quickselect;

var $1s6rO = parcelRequire("1s6rO");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function $ba036831f6198340$var$quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? $1s6rO.ascendingDefined : (0, $1s6rO.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $ba036831f6198340$var$quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $ba036831f6198340$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $ba036831f6198340$var$swap(array, left, right);
        while(i < j){
            $ba036831f6198340$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $ba036831f6198340$var$swap(array, left, j);
        else ++j, $ba036831f6198340$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $ba036831f6198340$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

});



parcelRegister("jCMnU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e4971918f03a697a$var$thresholdScott;

var $e4971918f03a697a$var$_count = $e4971918f03a697a$var$_interopRequireDefault((parcelRequire("gK2PS")));

var $e4971918f03a697a$var$_deviation = $e4971918f03a697a$var$_interopRequireDefault((parcelRequire("hkeTX")));
function $e4971918f03a697a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e4971918f03a697a$var$thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, $e4971918f03a697a$var$_count.default)(values)) / (3.49 * (0, $e4971918f03a697a$var$_deviation.default)(values)));
}

});

parcelRegister("j2RKx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ddd7e5c6f5f6e6f4$var$maxIndex;
function $ddd7e5c6f5f6e6f4$var$maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

});

parcelRegister("4PtdG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3842974583757204$var$mean;
function $3842974583757204$var$mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

});

parcelRegister("guIWe", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c0224e75d0b8dee1$var$median;

var $c0224e75d0b8dee1$var$_quantile = $c0224e75d0b8dee1$var$_interopRequireDefault((parcelRequire("j5CGU")));
function $c0224e75d0b8dee1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c0224e75d0b8dee1$var$median(values, valueof) {
    return (0, $c0224e75d0b8dee1$var$_quantile.default)(values, 0.5, valueof);
}

});

parcelRegister("iaelO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d3944af3422abb9c$var$merge;
function* $d3944af3422abb9c$var$flatten(arrays) {
    for (const array of arrays)yield* array;
}
function $d3944af3422abb9c$var$merge(arrays) {
    return Array.from($d3944af3422abb9c$var$flatten(arrays));
}

});

parcelRegister("2PHl2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2101f6473a918a98$var$minIndex;
function $2101f6473a918a98$var$minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

});

parcelRegister("2OLMC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $20d5510c9442113e$var$mode;

var $bIdoG = parcelRequire("bIdoG");
function $20d5510c9442113e$var$mode(values, valueof) {
    const counts = new $bIdoG.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

});

parcelRegister("3yZzP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $29844ffbefa71a26$var$pairs;
module.exports.pair = $29844ffbefa71a26$var$pair;
function $29844ffbefa71a26$var$pairs(values, pairof = $29844ffbefa71a26$var$pair) {
    const pairs = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs;
}
function $29844ffbefa71a26$var$pair(a, b) {
    return [
        a,
        b
    ];
}

});

parcelRegister("bIdSV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $886e9304092f22bc$var$range;
function $886e9304092f22bc$var$range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

});

parcelRegister("kqB6b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $edf303687a7b6bde$var$rank;

var $edf303687a7b6bde$var$_ascending = $edf303687a7b6bde$var$_interopRequireDefault((parcelRequire("41UsN")));

var $1s6rO = parcelRequire("1s6rO");
function $edf303687a7b6bde$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $edf303687a7b6bde$var$rank(values, valueof = $edf303687a7b6bde$var$_ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = $edf303687a7b6bde$var$_ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === $edf303687a7b6bde$var$_ascending.default ? (i, j)=>(0, $1s6rO.ascendingDefined)(V[i], V[j]) : (0, $1s6rO.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

});

parcelRegister("cJKEz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $945de0689a579d3d$var$least;

var $945de0689a579d3d$var$_ascending = $945de0689a579d3d$var$_interopRequireDefault((parcelRequire("41UsN")));
function $945de0689a579d3d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $945de0689a579d3d$var$least(values, compare = $945de0689a579d3d$var$_ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $945de0689a579d3d$var$_ascending.default)(value, minValue) < 0 : (0, $945de0689a579d3d$var$_ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

});

parcelRegister("28Fjr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $18ec5ff06540aa05$var$leastIndex;

var $18ec5ff06540aa05$var$_ascending = $18ec5ff06540aa05$var$_interopRequireDefault((parcelRequire("41UsN")));

var $18ec5ff06540aa05$var$_minIndex = $18ec5ff06540aa05$var$_interopRequireDefault((parcelRequire("2PHl2")));
function $18ec5ff06540aa05$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $18ec5ff06540aa05$var$leastIndex(values, compare = $18ec5ff06540aa05$var$_ascending.default) {
    if (compare.length === 1) return (0, $18ec5ff06540aa05$var$_minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

});

parcelRegister("BBrtf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0710800851eb5f63$var$greatest;

var $0710800851eb5f63$var$_ascending = $0710800851eb5f63$var$_interopRequireDefault((parcelRequire("41UsN")));
function $0710800851eb5f63$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0710800851eb5f63$var$greatest(values, compare = $0710800851eb5f63$var$_ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, $0710800851eb5f63$var$_ascending.default)(value, maxValue) > 0 : (0, $0710800851eb5f63$var$_ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

});

parcelRegister("9tqYc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6e5bbe2b5c720f01$var$greatestIndex;

var $6e5bbe2b5c720f01$var$_ascending = $6e5bbe2b5c720f01$var$_interopRequireDefault((parcelRequire("41UsN")));

var $6e5bbe2b5c720f01$var$_maxIndex = $6e5bbe2b5c720f01$var$_interopRequireDefault((parcelRequire("j2RKx")));
function $6e5bbe2b5c720f01$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6e5bbe2b5c720f01$var$greatestIndex(values, compare = $6e5bbe2b5c720f01$var$_ascending.default) {
    if (compare.length === 1) return (0, $6e5bbe2b5c720f01$var$_maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

});

parcelRegister("1elLF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0e57fbde29376f77$var$scan;

var $0e57fbde29376f77$var$_leastIndex = $0e57fbde29376f77$var$_interopRequireDefault((parcelRequire("28Fjr")));
function $0e57fbde29376f77$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0e57fbde29376f77$var$scan(values, compare) {
    const index = (0, $0e57fbde29376f77$var$_leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

});

parcelRegister("btFPA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
module.exports.shuffler = $85b2d9eac36a9b68$var$shuffler;
var $85b2d9eac36a9b68$var$_default = $85b2d9eac36a9b68$var$shuffler(Math.random);
module.exports.default = $85b2d9eac36a9b68$var$_default;
function $85b2d9eac36a9b68$var$shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

});

parcelRegister("eVqKs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $addb233c30902f47$var$sum;
function $addb233c30902f47$var$sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

});

parcelRegister("cxQ76", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9220fdbfc59223ad$var$transpose;

var $9220fdbfc59223ad$var$_min = $9220fdbfc59223ad$var$_interopRequireDefault((parcelRequire("8TS4y")));
function $9220fdbfc59223ad$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $9220fdbfc59223ad$var$transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, $9220fdbfc59223ad$var$_min.default)(matrix, $9220fdbfc59223ad$var$length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function $9220fdbfc59223ad$var$length(d) {
    return d.length;
}

});

parcelRegister("6sgzw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4b323670c9cd0416$var$zip;

var $4b323670c9cd0416$var$_transpose = $4b323670c9cd0416$var$_interopRequireDefault((parcelRequire("cxQ76")));
function $4b323670c9cd0416$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4b323670c9cd0416$var$zip() {
    return (0, $4b323670c9cd0416$var$_transpose.default)(arguments);
}

});

parcelRegister("dhxmm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9ab6bd72ad2ec25f$var$every;
function $9ab6bd72ad2ec25f$var$every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

});

parcelRegister("TNYYF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0a7be8a76c899c36$var$some;
function $0a7be8a76c899c36$var$some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

});

parcelRegister("k1viL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e93c2e8055507afb$var$filter;
function $e93c2e8055507afb$var$filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

});

parcelRegister("26fg9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1877fa81c7c054ce$var$map;
function $1877fa81c7c054ce$var$map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

});

parcelRegister("1QNBF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $15912099fdb05764$var$reduce;
function $15912099fdb05764$var$reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done: done, value: value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done: done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

});

parcelRegister("eC7df", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $aa3a359114e89a87$var$reverse;
function $aa3a359114e89a87$var$reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

});

parcelRegister("7Dz3y", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $58f75e5c60d37522$var$difference;

var $bIdoG = parcelRequire("bIdoG");
function $58f75e5c60d37522$var$difference(values, ...others) {
    values = new $bIdoG.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

});

parcelRegister("jhTZq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e0ab09388d60e901$var$disjoint;

var $bIdoG = parcelRequire("bIdoG");
function $e0ab09388d60e901$var$disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new $bIdoG.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

});

parcelRegister("iMwmy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dac5d0412b5914b9$var$intersection;

var $bIdoG = parcelRequire("bIdoG");
function $dac5d0412b5914b9$var$intersection(values, ...others) {
    values = new $bIdoG.InternSet(values);
    others = others.map($dac5d0412b5914b9$var$set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function $dac5d0412b5914b9$var$set(values) {
    return values instanceof $bIdoG.InternSet ? values : new $bIdoG.InternSet(values);
}

});

parcelRegister("1MQcZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $14d2c5afdb2ee61c$var$subset;

var $14d2c5afdb2ee61c$var$_superset = $14d2c5afdb2ee61c$var$_interopRequireDefault((parcelRequire("hxjsp")));
function $14d2c5afdb2ee61c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $14d2c5afdb2ee61c$var$subset(values, other) {
    return (0, $14d2c5afdb2ee61c$var$_superset.default)(other, values);
}

});
parcelRegister("hxjsp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cc449c885ee5effe$var$superset;
function $cc449c885ee5effe$var$superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = $cc449c885ee5effe$var$intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value: value, done: done } = iterator.next()){
            if (done) return false;
            const ivalue = $cc449c885ee5effe$var$intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function $cc449c885ee5effe$var$intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

});


parcelRegister("ipuGy", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d6725d4a55b521a6$var$union;

var $bIdoG = parcelRequire("bIdoG");
function $d6725d4a55b521a6$var$union(...others) {
    const set = new $bIdoG.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

});


parcelRegister("cnxlJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initInterpolator = $9031808894480981$var$initInterpolator;
module.exports.initRange = $9031808894480981$var$initRange;
function $9031808894480981$var$initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $9031808894480981$var$initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

});

parcelRegister("4lmwm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $329a97c4a3cbb22e$var$ordinal;
module.exports.implicit = void 0;

var $7oz1V = parcelRequire("7oz1V");

var $cnxlJ = parcelRequire("cnxlJ");
const $329a97c4a3cbb22e$var$implicit = Symbol("implicit");
module.exports.implicit = $329a97c4a3cbb22e$var$implicit;
function $329a97c4a3cbb22e$var$ordinal() {
    var index = new $7oz1V.InternMap(), domain = [], range = [], unknown = $329a97c4a3cbb22e$var$implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $329a97c4a3cbb22e$var$implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new $7oz1V.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $329a97c4a3cbb22e$var$ordinal(domain, range).unknown(unknown);
    };
    $cnxlJ.initRange.apply(scale, arguments);
    return scale;
}

});


parcelRegister("dZtYm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a2f838cd37d1be34$var$identity;

var $ilLMd = parcelRequire("ilLMd");

var $a2f838cd37d1be34$var$_number = $a2f838cd37d1be34$var$_interopRequireDefault((parcelRequire("kICmR")));
function $a2f838cd37d1be34$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a2f838cd37d1be34$var$identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, $a2f838cd37d1be34$var$_number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $a2f838cd37d1be34$var$identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, $a2f838cd37d1be34$var$_number.default) : [
        0,
        1
    ];
    return (0, $ilLMd.linearish)(scale);
}

});
parcelRegister("ilLMd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d5bf3f960ece6e28$var$linear;
module.exports.linearish = $d5bf3f960ece6e28$var$linearish;

var $7oz1V = parcelRequire("7oz1V");

var $d5bf3f960ece6e28$var$_continuous = $d5bf3f960ece6e28$var$_interopRequireWildcard((parcelRequire("1r8KC")));

var $cnxlJ = parcelRequire("cnxlJ");

var $d5bf3f960ece6e28$var$_tickFormat = $d5bf3f960ece6e28$var$_interopRequireDefault((parcelRequire("bRHl9")));
function $d5bf3f960ece6e28$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d5bf3f960ece6e28$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($d5bf3f960ece6e28$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $d5bf3f960ece6e28$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $d5bf3f960ece6e28$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $d5bf3f960ece6e28$var$linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $7oz1V.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $d5bf3f960ece6e28$var$_tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $7oz1V.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $d5bf3f960ece6e28$var$linear() {
    var scale = (0, $d5bf3f960ece6e28$var$_continuous.default)();
    scale.copy = function() {
        return (0, $d5bf3f960ece6e28$var$_continuous.copy)(scale, $d5bf3f960ece6e28$var$linear());
    };
    $cnxlJ.initRange.apply(scale, arguments);
    return $d5bf3f960ece6e28$var$linearish(scale);
}

});
parcelRegister("1r8KC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $10bf19c981068ef5$var$copy;
module.exports.default = $10bf19c981068ef5$var$continuous;
module.exports.identity = $10bf19c981068ef5$var$identity;
module.exports.transformer = $10bf19c981068ef5$var$transformer;

var $7oz1V = parcelRequire("7oz1V");

var $l4R94 = parcelRequire("l4R94");

var $10bf19c981068ef5$var$_constant = $10bf19c981068ef5$var$_interopRequireDefault((parcelRequire("eRYM3")));

var $10bf19c981068ef5$var$_number = $10bf19c981068ef5$var$_interopRequireDefault((parcelRequire("kICmR")));
function $10bf19c981068ef5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $10bf19c981068ef5$var$unit = [
    0,
    1
];
function $10bf19c981068ef5$var$identity(x) {
    return x;
}
function $10bf19c981068ef5$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $10bf19c981068ef5$var$_constant.default)(isNaN(b) ? NaN : 0.5);
}
function $10bf19c981068ef5$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
} // normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $10bf19c981068ef5$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $10bf19c981068ef5$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $10bf19c981068ef5$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $10bf19c981068ef5$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1; // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $10bf19c981068ef5$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $7oz1V.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $10bf19c981068ef5$var$copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $10bf19c981068ef5$var$transformer() {
    var domain = $10bf19c981068ef5$var$unit, range = $10bf19c981068ef5$var$unit, interpolate = $l4R94.interpolate, transform, untransform, unknown, clamp = $10bf19c981068ef5$var$identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $10bf19c981068ef5$var$identity) clamp = $10bf19c981068ef5$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $10bf19c981068ef5$var$polymap : $10bf19c981068ef5$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), $l4R94.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, $10bf19c981068ef5$var$_number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = $l4R94.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $10bf19c981068ef5$var$identity, rescale()) : clamp !== $10bf19c981068ef5$var$identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $10bf19c981068ef5$var$continuous() {
    return $10bf19c981068ef5$var$transformer()($10bf19c981068ef5$var$identity, $10bf19c981068ef5$var$identity);
}

});
parcelRegister("l4R94", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "interpolate", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_value.default;
    }
});
Object.defineProperty(module.exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_array.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_cubehelix.cubehelixLong;
    }
});
Object.defineProperty(module.exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_date.default;
    }
});
Object.defineProperty(module.exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_discrete.default;
    }
});
Object.defineProperty(module.exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_hcl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_hcl.hclLong;
    }
});
Object.defineProperty(module.exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_hsl.default;
    }
});
Object.defineProperty(module.exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_hsl.hslLong;
    }
});
Object.defineProperty(module.exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_hue.default;
    }
});
Object.defineProperty(module.exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_number.default;
    }
});
Object.defineProperty(module.exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_numberArray.default;
    }
});
Object.defineProperty(module.exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_object.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_rgb.default;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_rgb.rgbBasis;
    }
});
Object.defineProperty(module.exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_rgb.rgbBasisClosed;
    }
});
Object.defineProperty(module.exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_round.default;
    }
});
Object.defineProperty(module.exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_string.default;
    }
});
Object.defineProperty(module.exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return $idlhg.interpolateTransformCss;
    }
});
Object.defineProperty(module.exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return $idlhg.interpolateTransformSvg;
    }
});
Object.defineProperty(module.exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_zoom.default;
    }
});
Object.defineProperty(module.exports, "piecewise", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_piecewise.default;
    }
});
Object.defineProperty(module.exports, "quantize", {
    enumerable: true,
    get: function() {
        return $f583323ee8d07848$var$_quantize.default;
    }
});

var $f583323ee8d07848$var$_value = $f583323ee8d07848$var$_interopRequireDefault((parcelRequire("guRiR")));

var $f583323ee8d07848$var$_array = $f583323ee8d07848$var$_interopRequireDefault((parcelRequire("7eXOh")));

var $f583323ee8d07848$var$_basis = $f583323ee8d07848$var$_interopRequireDefault((parcelRequire("7DT76")));

var $f583323ee8d07848$var$_basisClosed = $f583323ee8d07848$var$_interopRequireDefault((parcelRequire("4C8LP")));

var $f583323ee8d07848$var$_date = $f583323ee8d07848$var$_interopRequireDefault((parcelRequire("wi0yT")));

var $f583323ee8d07848$var$_discrete = $f583323ee8d07848$var$_interopRequireDefault((parcelRequire("9KV8H")));

var $f583323ee8d07848$var$_hue = $f583323ee8d07848$var$_interopRequireDefault((parcelRequire("j56Gc")));

var $f583323ee8d07848$var$_number = $f583323ee8d07848$var$_interopRequireDefault((parcelRequire("3Ican")));

var $f583323ee8d07848$var$_numberArray = $f583323ee8d07848$var$_interopRequireDefault((parcelRequire("h7lbR")));

var $f583323ee8d07848$var$_object = $f583323ee8d07848$var$_interopRequireDefault((parcelRequire("5aOgQ")));

var $f583323ee8d07848$var$_round = $f583323ee8d07848$var$_interopRequireDefault((parcelRequire("dNUag")));

var $f583323ee8d07848$var$_string = $f583323ee8d07848$var$_interopRequireDefault((parcelRequire("9tqi5")));

var $idlhg = parcelRequire("idlhg");

var $f583323ee8d07848$var$_zoom = $f583323ee8d07848$var$_interopRequireDefault((parcelRequire("3Ttqv")));

var $f583323ee8d07848$var$_rgb = $f583323ee8d07848$var$_interopRequireWildcard((parcelRequire("cgQQv")));

var $f583323ee8d07848$var$_hsl = $f583323ee8d07848$var$_interopRequireWildcard((parcelRequire("iXaMb")));

var $f583323ee8d07848$var$_lab = $f583323ee8d07848$var$_interopRequireDefault((parcelRequire("i5kz9")));

var $f583323ee8d07848$var$_hcl = $f583323ee8d07848$var$_interopRequireWildcard((parcelRequire("4HHTk")));

var $f583323ee8d07848$var$_cubehelix = $f583323ee8d07848$var$_interopRequireWildcard((parcelRequire("466mx")));

var $f583323ee8d07848$var$_piecewise = $f583323ee8d07848$var$_interopRequireDefault((parcelRequire("1OHaD")));

var $f583323ee8d07848$var$_quantize = $f583323ee8d07848$var$_interopRequireDefault((parcelRequire("jCA9K")));
function $f583323ee8d07848$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($f583323ee8d07848$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $f583323ee8d07848$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $f583323ee8d07848$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $f583323ee8d07848$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("guRiR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c028cb9161fbaa13$var$_default;

var $5Ltu5 = parcelRequire("5Ltu5");

var $c028cb9161fbaa13$var$_rgb = $c028cb9161fbaa13$var$_interopRequireDefault((parcelRequire("cgQQv")));

var $7eXOh = parcelRequire("7eXOh");

var $c028cb9161fbaa13$var$_date = $c028cb9161fbaa13$var$_interopRequireDefault((parcelRequire("wi0yT")));

var $c028cb9161fbaa13$var$_number = $c028cb9161fbaa13$var$_interopRequireDefault((parcelRequire("3Ican")));

var $c028cb9161fbaa13$var$_object = $c028cb9161fbaa13$var$_interopRequireDefault((parcelRequire("5aOgQ")));

var $c028cb9161fbaa13$var$_string = $c028cb9161fbaa13$var$_interopRequireDefault((parcelRequire("9tqi5")));

var $c028cb9161fbaa13$var$_constant = $c028cb9161fbaa13$var$_interopRequireDefault((parcelRequire("6UUn3")));

var $c028cb9161fbaa13$var$_numberArray = $c028cb9161fbaa13$var$_interopRequireWildcard((parcelRequire("h7lbR")));
function $c028cb9161fbaa13$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c028cb9161fbaa13$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c028cb9161fbaa13$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c028cb9161fbaa13$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c028cb9161fbaa13$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c028cb9161fbaa13$var$_default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $c028cb9161fbaa13$var$_constant.default)(b) : (t === "number" ? $c028cb9161fbaa13$var$_number.default : t === "string" ? (c = (0, $5Ltu5.color)(b)) ? (b = c, $c028cb9161fbaa13$var$_rgb.default) : $c028cb9161fbaa13$var$_string.default : b instanceof $5Ltu5.color ? $c028cb9161fbaa13$var$_rgb.default : b instanceof Date ? $c028cb9161fbaa13$var$_date.default : (0, $c028cb9161fbaa13$var$_numberArray.isNumberArray)(b) ? $c028cb9161fbaa13$var$_numberArray.default : Array.isArray(b) ? $7eXOh.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? $c028cb9161fbaa13$var$_object.default : $c028cb9161fbaa13$var$_number.default)(a, b);
}

});
parcelRegister("5Ltu5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "color", {
    enumerable: true,
    get: function() {
        return $4328367f5fd9131c$var$_color.default;
    }
});
Object.defineProperty(module.exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return $4328367f5fd9131c$var$_cubehelix.default;
    }
});
Object.defineProperty(module.exports, "gray", {
    enumerable: true,
    get: function() {
        return $4328367f5fd9131c$var$_lab.gray;
    }
});
Object.defineProperty(module.exports, "hcl", {
    enumerable: true,
    get: function() {
        return $4328367f5fd9131c$var$_lab.hcl;
    }
});
Object.defineProperty(module.exports, "hsl", {
    enumerable: true,
    get: function() {
        return $4328367f5fd9131c$var$_color.hsl;
    }
});
Object.defineProperty(module.exports, "lab", {
    enumerable: true,
    get: function() {
        return $4328367f5fd9131c$var$_lab.default;
    }
});
Object.defineProperty(module.exports, "lch", {
    enumerable: true,
    get: function() {
        return $4328367f5fd9131c$var$_lab.lch;
    }
});
Object.defineProperty(module.exports, "rgb", {
    enumerable: true,
    get: function() {
        return $4328367f5fd9131c$var$_color.rgb;
    }
});

var $4328367f5fd9131c$var$_color = $4328367f5fd9131c$var$_interopRequireWildcard((parcelRequire("6J176")));

var $4328367f5fd9131c$var$_lab = $4328367f5fd9131c$var$_interopRequireWildcard((parcelRequire("5goBc")));

var $4328367f5fd9131c$var$_cubehelix = $4328367f5fd9131c$var$_interopRequireDefault((parcelRequire("3YROY")));
function $4328367f5fd9131c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4328367f5fd9131c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($4328367f5fd9131c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $4328367f5fd9131c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $4328367f5fd9131c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("6J176", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;

var _define = _interopRequireWildcard((parcelRequire("9SB1p")));
function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function Color() {}
var darker = 0.7;
exports.darker = darker;
var brighter = 1 / darker;
exports.brighter = brighter;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

});
parcelRegister("9SB1p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $7315dff7f9d4afab$var$_default;
module.exports.extend = $7315dff7f9d4afab$var$extend;
function $7315dff7f9d4afab$var$_default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $7315dff7f9d4afab$var$extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

});


parcelRegister("5goBc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hcl = $3d51873a7ae6c861$var$Hcl;
module.exports.Lab = $3d51873a7ae6c861$var$Lab;
module.exports.default = $3d51873a7ae6c861$var$lab;
module.exports.gray = $3d51873a7ae6c861$var$gray;
module.exports.hcl = $3d51873a7ae6c861$var$hcl;
module.exports.lch = $3d51873a7ae6c861$var$lch;

var $3d51873a7ae6c861$var$_define = $3d51873a7ae6c861$var$_interopRequireWildcard((parcelRequire("9SB1p")));

var $6J176 = parcelRequire("6J176");

var $cl2wc = parcelRequire("cl2wc");
function $3d51873a7ae6c861$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3d51873a7ae6c861$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3d51873a7ae6c861$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3d51873a7ae6c861$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const $3d51873a7ae6c861$var$K = 18, $3d51873a7ae6c861$var$Xn = 0.96422, $3d51873a7ae6c861$var$Yn = 1, $3d51873a7ae6c861$var$Zn = 0.82521, $3d51873a7ae6c861$var$t0 = 4 / 29, $3d51873a7ae6c861$var$t1 = 6 / 29, $3d51873a7ae6c861$var$t2 = 3 * $3d51873a7ae6c861$var$t1 * $3d51873a7ae6c861$var$t1, $3d51873a7ae6c861$var$t3 = $3d51873a7ae6c861$var$t1 * $3d51873a7ae6c861$var$t1 * $3d51873a7ae6c861$var$t1;
function $3d51873a7ae6c861$var$labConvert(o) {
    if (o instanceof $3d51873a7ae6c861$var$Lab) return new $3d51873a7ae6c861$var$Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof $3d51873a7ae6c861$var$Hcl) return $3d51873a7ae6c861$var$hcl2lab(o);
    if (!(o instanceof $6J176.Rgb)) o = (0, $6J176.rgbConvert)(o);
    var r = $3d51873a7ae6c861$var$rgb2lrgb(o.r), g = $3d51873a7ae6c861$var$rgb2lrgb(o.g), b = $3d51873a7ae6c861$var$rgb2lrgb(o.b), y = $3d51873a7ae6c861$var$xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / $3d51873a7ae6c861$var$Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = $3d51873a7ae6c861$var$xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / $3d51873a7ae6c861$var$Xn);
        z = $3d51873a7ae6c861$var$xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / $3d51873a7ae6c861$var$Zn);
    }
    return new $3d51873a7ae6c861$var$Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function $3d51873a7ae6c861$var$gray(l, opacity) {
    return new $3d51873a7ae6c861$var$Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function $3d51873a7ae6c861$var$lab(l, a, b, opacity) {
    return arguments.length === 1 ? $3d51873a7ae6c861$var$labConvert(l) : new $3d51873a7ae6c861$var$Lab(l, a, b, opacity == null ? 1 : opacity);
}
function $3d51873a7ae6c861$var$Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $3d51873a7ae6c861$var$_define.default)($3d51873a7ae6c861$var$Lab, $3d51873a7ae6c861$var$lab, (0, $3d51873a7ae6c861$var$_define.extend)($6J176.Color, {
    brighter (k) {
        return new $3d51873a7ae6c861$var$Lab(this.l + $3d51873a7ae6c861$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new $3d51873a7ae6c861$var$Lab(this.l - $3d51873a7ae6c861$var$K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = $3d51873a7ae6c861$var$Xn * $3d51873a7ae6c861$var$lab2xyz(x);
        y = $3d51873a7ae6c861$var$Yn * $3d51873a7ae6c861$var$lab2xyz(y);
        z = $3d51873a7ae6c861$var$Zn * $3d51873a7ae6c861$var$lab2xyz(z);
        return new $6J176.Rgb($3d51873a7ae6c861$var$lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), $3d51873a7ae6c861$var$lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), $3d51873a7ae6c861$var$lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function $3d51873a7ae6c861$var$xyz2lab(t) {
    return t > $3d51873a7ae6c861$var$t3 ? Math.pow(t, 1 / 3) : t / $3d51873a7ae6c861$var$t2 + $3d51873a7ae6c861$var$t0;
}
function $3d51873a7ae6c861$var$lab2xyz(t) {
    return t > $3d51873a7ae6c861$var$t1 ? t * t * t : $3d51873a7ae6c861$var$t2 * (t - $3d51873a7ae6c861$var$t0);
}
function $3d51873a7ae6c861$var$lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function $3d51873a7ae6c861$var$rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function $3d51873a7ae6c861$var$hclConvert(o) {
    if (o instanceof $3d51873a7ae6c861$var$Hcl) return new $3d51873a7ae6c861$var$Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof $3d51873a7ae6c861$var$Lab)) o = $3d51873a7ae6c861$var$labConvert(o);
    if (o.a === 0 && o.b === 0) return new $3d51873a7ae6c861$var$Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * $cl2wc.degrees;
    return new $3d51873a7ae6c861$var$Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function $3d51873a7ae6c861$var$lch(l, c, h, opacity) {
    return arguments.length === 1 ? $3d51873a7ae6c861$var$hclConvert(l) : new $3d51873a7ae6c861$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $3d51873a7ae6c861$var$hcl(h, c, l, opacity) {
    return arguments.length === 1 ? $3d51873a7ae6c861$var$hclConvert(h) : new $3d51873a7ae6c861$var$Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function $3d51873a7ae6c861$var$Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function $3d51873a7ae6c861$var$hcl2lab(o) {
    if (isNaN(o.h)) return new $3d51873a7ae6c861$var$Lab(o.l, 0, 0, o.opacity);
    var h = o.h * $cl2wc.radians;
    return new $3d51873a7ae6c861$var$Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, $3d51873a7ae6c861$var$_define.default)($3d51873a7ae6c861$var$Hcl, $3d51873a7ae6c861$var$hcl, (0, $3d51873a7ae6c861$var$_define.extend)($6J176.Color, {
    brighter (k) {
        return new $3d51873a7ae6c861$var$Hcl(this.h, this.c, this.l + $3d51873a7ae6c861$var$K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new $3d51873a7ae6c861$var$Hcl(this.h, this.c, this.l - $3d51873a7ae6c861$var$K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return $3d51873a7ae6c861$var$hcl2lab(this).rgb();
    }
}));

});
parcelRegister("cl2wc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.radians = module.exports.degrees = void 0;
const $8fb966467d524cc1$var$radians = Math.PI / 180;
module.exports.radians = $8fb966467d524cc1$var$radians;
const $8fb966467d524cc1$var$degrees = 180 / Math.PI;
module.exports.degrees = $8fb966467d524cc1$var$degrees;

});


parcelRegister("3YROY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cubehelix = $2e60b96f59575eba$var$Cubehelix;
module.exports.default = $2e60b96f59575eba$var$cubehelix;

var $2e60b96f59575eba$var$_define = $2e60b96f59575eba$var$_interopRequireWildcard((parcelRequire("9SB1p")));

var $6J176 = parcelRequire("6J176");

var $cl2wc = parcelRequire("cl2wc");
function $2e60b96f59575eba$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($2e60b96f59575eba$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $2e60b96f59575eba$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $2e60b96f59575eba$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $2e60b96f59575eba$var$A = -0.14861, $2e60b96f59575eba$var$B = 1.78277, $2e60b96f59575eba$var$C = -0.29227, $2e60b96f59575eba$var$D = -0.90649, $2e60b96f59575eba$var$E = 1.97294, $2e60b96f59575eba$var$ED = $2e60b96f59575eba$var$E * $2e60b96f59575eba$var$D, $2e60b96f59575eba$var$EB = $2e60b96f59575eba$var$E * $2e60b96f59575eba$var$B, $2e60b96f59575eba$var$BC_DA = $2e60b96f59575eba$var$B * $2e60b96f59575eba$var$C - $2e60b96f59575eba$var$D * $2e60b96f59575eba$var$A;
function $2e60b96f59575eba$var$cubehelixConvert(o) {
    if (o instanceof $2e60b96f59575eba$var$Cubehelix) return new $2e60b96f59575eba$var$Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $6J176.Rgb)) o = (0, $6J176.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = ($2e60b96f59575eba$var$BC_DA * b + $2e60b96f59575eba$var$ED * r - $2e60b96f59575eba$var$EB * g) / ($2e60b96f59575eba$var$BC_DA + $2e60b96f59575eba$var$ED - $2e60b96f59575eba$var$EB), bl = b - l, k = ($2e60b96f59575eba$var$E * (g - l) - $2e60b96f59575eba$var$C * bl) / $2e60b96f59575eba$var$D, s = Math.sqrt(k * k + bl * bl) / ($2e60b96f59575eba$var$E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * $cl2wc.degrees - 120 : NaN;
    return new $2e60b96f59575eba$var$Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function $2e60b96f59575eba$var$cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? $2e60b96f59575eba$var$cubehelixConvert(h) : new $2e60b96f59575eba$var$Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function $2e60b96f59575eba$var$Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $2e60b96f59575eba$var$_define.default)($2e60b96f59575eba$var$Cubehelix, $2e60b96f59575eba$var$cubehelix, (0, $2e60b96f59575eba$var$_define.extend)($6J176.Color, {
    brighter (k) {
        k = k == null ? $6J176.brighter : Math.pow($6J176.brighter, k);
        return new $2e60b96f59575eba$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? $6J176.darker : Math.pow($6J176.darker, k);
        return new $2e60b96f59575eba$var$Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * $cl2wc.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new $6J176.Rgb(255 * (l + a * ($2e60b96f59575eba$var$A * cosh + $2e60b96f59575eba$var$B * sinh)), 255 * (l + a * ($2e60b96f59575eba$var$C * cosh + $2e60b96f59575eba$var$D * sinh)), 255 * (l + a * ($2e60b96f59575eba$var$E * cosh)), this.opacity);
    }
}));

});


parcelRegister("cgQQv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.rgbBasisClosed = module.exports.rgbBasis = module.exports.default = void 0;

var $5Ltu5 = parcelRequire("5Ltu5");

var $8eeff8bf46a8b0ac$var$_basis = $8eeff8bf46a8b0ac$var$_interopRequireDefault((parcelRequire("7DT76")));

var $8eeff8bf46a8b0ac$var$_basisClosed = $8eeff8bf46a8b0ac$var$_interopRequireDefault((parcelRequire("4C8LP")));

var $8eeff8bf46a8b0ac$var$_color = $8eeff8bf46a8b0ac$var$_interopRequireWildcard((parcelRequire("563Ly")));
function $8eeff8bf46a8b0ac$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($8eeff8bf46a8b0ac$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $8eeff8bf46a8b0ac$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $8eeff8bf46a8b0ac$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $8eeff8bf46a8b0ac$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $8eeff8bf46a8b0ac$var$_default = function rgbGamma(y) {
    var color = (0, $8eeff8bf46a8b0ac$var$_color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, $5Ltu5.rgb)(start)).r, (end = (0, $5Ltu5.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $8eeff8bf46a8b0ac$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
module.exports.default = $8eeff8bf46a8b0ac$var$_default;
function $8eeff8bf46a8b0ac$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $5Ltu5.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $8eeff8bf46a8b0ac$var$rgbBasis = $8eeff8bf46a8b0ac$var$rgbSpline($8eeff8bf46a8b0ac$var$_basis.default);
module.exports.rgbBasis = $8eeff8bf46a8b0ac$var$rgbBasis;
var $8eeff8bf46a8b0ac$var$rgbBasisClosed = $8eeff8bf46a8b0ac$var$rgbSpline($8eeff8bf46a8b0ac$var$_basisClosed.default);
module.exports.rgbBasisClosed = $8eeff8bf46a8b0ac$var$rgbBasisClosed;

});
parcelRegister("7DT76", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.basis = $5906ed518e746543$var$basis;
module.exports.default = $5906ed518e746543$var$_default;
function $5906ed518e746543$var$basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $5906ed518e746543$var$_default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $5906ed518e746543$var$basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("4C8LP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $35c183aa25aaa775$var$_default;

var $7DT76 = parcelRequire("7DT76");
function $35c183aa25aaa775$var$_default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $7DT76.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

});

parcelRegister("563Ly", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3b606f22170ad045$var$nogamma;
module.exports.gamma = $3b606f22170ad045$var$gamma;
module.exports.hue = $3b606f22170ad045$var$hue;

var $3b606f22170ad045$var$_constant = $3b606f22170ad045$var$_interopRequireDefault((parcelRequire("6UUn3")));
function $3b606f22170ad045$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3b606f22170ad045$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $3b606f22170ad045$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $3b606f22170ad045$var$hue(a, b) {
    var d = b - a;
    return d ? $3b606f22170ad045$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $3b606f22170ad045$var$_constant.default)(isNaN(a) ? b : a);
}
function $3b606f22170ad045$var$gamma(y) {
    return (y = +y) === 1 ? $3b606f22170ad045$var$nogamma : function(a, b) {
        return b - a ? $3b606f22170ad045$var$exponential(a, b, y) : (0, $3b606f22170ad045$var$_constant.default)(isNaN(a) ? b : a);
    };
}
function $3b606f22170ad045$var$nogamma(a, b) {
    var d = b - a;
    return d ? $3b606f22170ad045$var$linear(a, d) : (0, $3b606f22170ad045$var$_constant.default)(isNaN(a) ? b : a);
}

});
parcelRegister("6UUn3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $5093b32184ca55c2$var$_default = (x)=>()=>x;
module.exports.default = $5093b32184ca55c2$var$_default;

});



parcelRegister("7eXOh", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $54583c376034172e$var$_default;
module.exports.genericArray = $54583c376034172e$var$genericArray;

var $54583c376034172e$var$_value = $54583c376034172e$var$_interopRequireDefault((parcelRequire("guRiR")));

var $54583c376034172e$var$_numberArray = $54583c376034172e$var$_interopRequireWildcard((parcelRequire("h7lbR")));
function $54583c376034172e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($54583c376034172e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $54583c376034172e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $54583c376034172e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $54583c376034172e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $54583c376034172e$var$_default(a, b) {
    return ((0, $54583c376034172e$var$_numberArray.isNumberArray)(b) ? $54583c376034172e$var$_numberArray.default : $54583c376034172e$var$genericArray)(a, b);
}
function $54583c376034172e$var$genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $54583c376034172e$var$_value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

});
parcelRegister("h7lbR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c7638710b13f33e5$var$_default;
module.exports.isNumberArray = $c7638710b13f33e5$var$isNumberArray;
function $c7638710b13f33e5$var$_default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $c7638710b13f33e5$var$isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

});


parcelRegister("wi0yT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0610f54cb5792e1a$var$_default;
function $0610f54cb5792e1a$var$_default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

});

parcelRegister("3Ican", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2b3eeb2bd0e0bead$var$_default;
function $2b3eeb2bd0e0bead$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

});

parcelRegister("5aOgQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3c44e19ec005e23a$var$_default;

var $3c44e19ec005e23a$var$_value = $3c44e19ec005e23a$var$_interopRequireDefault((parcelRequire("guRiR")));
function $3c44e19ec005e23a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3c44e19ec005e23a$var$_default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $3c44e19ec005e23a$var$_value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

});

parcelRegister("9tqi5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6e5b37429dea32e5$var$_default;

var $6e5b37429dea32e5$var$_number = $6e5b37429dea32e5$var$_interopRequireDefault((parcelRequire("3Ican")));
function $6e5b37429dea32e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6e5b37429dea32e5$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $6e5b37429dea32e5$var$reB = new RegExp($6e5b37429dea32e5$var$reA.source, "g");
function $6e5b37429dea32e5$var$zero(b) {
    return function() {
        return b;
    };
}
function $6e5b37429dea32e5$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $6e5b37429dea32e5$var$_default(a, b) {
    var bi = $6e5b37429dea32e5$var$reA.lastIndex = $6e5b37429dea32e5$var$reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + ""; // Interpolate pairs of numbers in a & b.
    while((am = $6e5b37429dea32e5$var$reA.exec(a)) && (bm = $6e5b37429dea32e5$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $6e5b37429dea32e5$var$_number.default)(am, bm)
            });
        }
        bi = $6e5b37429dea32e5$var$reB.lastIndex;
    } // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    } // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $6e5b37429dea32e5$var$one(q[0].x) : $6e5b37429dea32e5$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

});


parcelRegister("9KV8H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $71a4bb9db7933f25$var$_default;
function $71a4bb9db7933f25$var$_default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

});

parcelRegister("j56Gc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $de43aa66529e99d7$var$_default;

var $563Ly = parcelRequire("563Ly");
function $de43aa66529e99d7$var$_default(a, b) {
    var i = (0, $563Ly.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

});

parcelRegister("dNUag", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a0cb6b123a1655d7$var$_default;
function $a0cb6b123a1655d7$var$_default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

});

parcelRegister("idlhg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.interpolateTransformSvg = module.exports.interpolateTransformCss = void 0;

var $d429f22574112bcd$var$_number = $d429f22574112bcd$var$_interopRequireDefault((parcelRequire("3Ican")));

var $51qxr = parcelRequire("51qxr");
function $d429f22574112bcd$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d429f22574112bcd$var$interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, $d429f22574112bcd$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $d429f22574112bcd$var$_number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, $d429f22574112bcd$var$_number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, $d429f22574112bcd$var$_number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, $d429f22574112bcd$var$_number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, $d429f22574112bcd$var$_number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var $d429f22574112bcd$var$interpolateTransformCss = $d429f22574112bcd$var$interpolateTransform($51qxr.parseCss, "px, ", "px)", "deg)");
module.exports.interpolateTransformCss = $d429f22574112bcd$var$interpolateTransformCss;
var $d429f22574112bcd$var$interpolateTransformSvg = $d429f22574112bcd$var$interpolateTransform($51qxr.parseSvg, ", ", ")", ")");
module.exports.interpolateTransformSvg = $d429f22574112bcd$var$interpolateTransformSvg;

});
parcelRegister("51qxr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseCss = $3a81a1b6715142ec$var$parseCss;
module.exports.parseSvg = $3a81a1b6715142ec$var$parseSvg;

var $3a81a1b6715142ec$var$_decompose = $3a81a1b6715142ec$var$_interopRequireWildcard((parcelRequire("dJmb8")));
function $3a81a1b6715142ec$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($3a81a1b6715142ec$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $3a81a1b6715142ec$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $3a81a1b6715142ec$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
var $3a81a1b6715142ec$var$svgNode;
/* eslint-disable no-undef */ function $3a81a1b6715142ec$var$parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? $3a81a1b6715142ec$var$_decompose.identity : (0, $3a81a1b6715142ec$var$_decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function $3a81a1b6715142ec$var$parseSvg(value) {
    if (value == null) return $3a81a1b6715142ec$var$_decompose.identity;
    if (!$3a81a1b6715142ec$var$svgNode) $3a81a1b6715142ec$var$svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    $3a81a1b6715142ec$var$svgNode.setAttribute("transform", value);
    if (!(value = $3a81a1b6715142ec$var$svgNode.transform.baseVal.consolidate())) return $3a81a1b6715142ec$var$_decompose.identity;
    value = value.matrix;
    return (0, $3a81a1b6715142ec$var$_decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

});
parcelRegister("dJmb8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9ff0ae8f9622838e$var$_default;
module.exports.identity = void 0;
var $9ff0ae8f9622838e$var$degrees = 180 / Math.PI;
var $9ff0ae8f9622838e$var$identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
module.exports.identity = $9ff0ae8f9622838e$var$identity;
function $9ff0ae8f9622838e$var$_default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * $9ff0ae8f9622838e$var$degrees,
        skewX: Math.atan(skewX) * $9ff0ae8f9622838e$var$degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

});



parcelRegister("3Ttqv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $2d5d55ab62a0f026$var$epsilon2 = 1e-12;
function $2d5d55ab62a0f026$var$cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function $2d5d55ab62a0f026$var$sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function $2d5d55ab62a0f026$var$tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var $2d5d55ab62a0f026$var$_default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S; // Special case for u0 ≅ u1.
        if (d2 < $2d5d55ab62a0f026$var$epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = $2d5d55ab62a0f026$var$cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * $2d5d55ab62a0f026$var$tanh(rho * s + r0) - $2d5d55ab62a0f026$var$sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / $2d5d55ab62a0f026$var$cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);
module.exports.default = $2d5d55ab62a0f026$var$_default;

});

parcelRegister("iXaMb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hslLong = module.exports.default = void 0;

var $5Ltu5 = parcelRequire("5Ltu5");

var $dcc6189e06dbb3eb$var$_color = $dcc6189e06dbb3eb$var$_interopRequireWildcard((parcelRequire("563Ly")));
function $dcc6189e06dbb3eb$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($dcc6189e06dbb3eb$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $dcc6189e06dbb3eb$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $dcc6189e06dbb3eb$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $dcc6189e06dbb3eb$var$hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $5Ltu5.hsl)(start)).h, (end = (0, $5Ltu5.hsl)(end)).h), s = (0, $dcc6189e06dbb3eb$var$_color.default)(start.s, end.s), l = (0, $dcc6189e06dbb3eb$var$_color.default)(start.l, end.l), opacity = (0, $dcc6189e06dbb3eb$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $dcc6189e06dbb3eb$var$_default = $dcc6189e06dbb3eb$var$hsl($dcc6189e06dbb3eb$var$_color.hue);
module.exports.default = $dcc6189e06dbb3eb$var$_default;
var $dcc6189e06dbb3eb$var$hslLong = $dcc6189e06dbb3eb$var$hsl($dcc6189e06dbb3eb$var$_color.default);
module.exports.hslLong = $dcc6189e06dbb3eb$var$hslLong;

});

parcelRegister("i5kz9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d2a8a5979f3da365$var$lab;

var $5Ltu5 = parcelRequire("5Ltu5");

var $d2a8a5979f3da365$var$_color = $d2a8a5979f3da365$var$_interopRequireDefault((parcelRequire("563Ly")));
function $d2a8a5979f3da365$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d2a8a5979f3da365$var$lab(start, end) {
    var l = (0, $d2a8a5979f3da365$var$_color.default)((start = (0, $5Ltu5.lab)(start)).l, (end = (0, $5Ltu5.lab)(end)).l), a = (0, $d2a8a5979f3da365$var$_color.default)(start.a, end.a), b = (0, $d2a8a5979f3da365$var$_color.default)(start.b, end.b), opacity = (0, $d2a8a5979f3da365$var$_color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

});

parcelRegister("4HHTk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hclLong = module.exports.default = void 0;

var $5Ltu5 = parcelRequire("5Ltu5");

var $36cd397bad6fd011$var$_color = $36cd397bad6fd011$var$_interopRequireWildcard((parcelRequire("563Ly")));
function $36cd397bad6fd011$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($36cd397bad6fd011$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $36cd397bad6fd011$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $36cd397bad6fd011$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $36cd397bad6fd011$var$hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, $5Ltu5.hcl)(start)).h, (end = (0, $5Ltu5.hcl)(end)).h), c = (0, $36cd397bad6fd011$var$_color.default)(start.c, end.c), l = (0, $36cd397bad6fd011$var$_color.default)(start.l, end.l), opacity = (0, $36cd397bad6fd011$var$_color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var $36cd397bad6fd011$var$_default = $36cd397bad6fd011$var$hcl($36cd397bad6fd011$var$_color.hue);
module.exports.default = $36cd397bad6fd011$var$_default;
var $36cd397bad6fd011$var$hclLong = $36cd397bad6fd011$var$hcl($36cd397bad6fd011$var$_color.default);
module.exports.hclLong = $36cd397bad6fd011$var$hclLong;

});

parcelRegister("466mx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.cubehelixLong = void 0;

var $5Ltu5 = parcelRequire("5Ltu5");

var $2fbca871b2f21b1d$var$_color = $2fbca871b2f21b1d$var$_interopRequireWildcard((parcelRequire("563Ly")));
function $2fbca871b2f21b1d$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($2fbca871b2f21b1d$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $2fbca871b2f21b1d$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $2fbca871b2f21b1d$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $2fbca871b2f21b1d$var$cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, $5Ltu5.cubehelix)(start)).h, (end = (0, $5Ltu5.cubehelix)(end)).h), s = (0, $2fbca871b2f21b1d$var$_color.default)(start.s, end.s), l = (0, $2fbca871b2f21b1d$var$_color.default)(start.l, end.l), opacity = (0, $2fbca871b2f21b1d$var$_color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var $2fbca871b2f21b1d$var$_default = $2fbca871b2f21b1d$var$cubehelix($2fbca871b2f21b1d$var$_color.hue);
module.exports.default = $2fbca871b2f21b1d$var$_default;
var $2fbca871b2f21b1d$var$cubehelixLong = $2fbca871b2f21b1d$var$cubehelix($2fbca871b2f21b1d$var$_color.default);
module.exports.cubehelixLong = $2fbca871b2f21b1d$var$cubehelixLong;

});

parcelRegister("1OHaD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $152bf2b6556d5579$var$piecewise;

var $152bf2b6556d5579$var$_value = $152bf2b6556d5579$var$_interopRequireDefault((parcelRequire("guRiR")));
function $152bf2b6556d5579$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $152bf2b6556d5579$var$piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = $152bf2b6556d5579$var$_value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

});

parcelRegister("jCA9K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e48d9cc8cc5b04a3$var$_default;
function $e48d9cc8cc5b04a3$var$_default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

});


parcelRegister("eRYM3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ad3528680a81c238$var$constants;
function $ad3528680a81c238$var$constants(x) {
    return function() {
        return x;
    };
}

});

parcelRegister("kICmR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f155adb702bcc2e0$var$number;
function $f155adb702bcc2e0$var$number(x) {
    return +x;
}

});


parcelRegister("bRHl9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8a36435f4a31a4f3$var$tickFormat;

var $7oz1V = parcelRequire("7oz1V");

var $1Lw1k = parcelRequire("1Lw1k");
function $8a36435f4a31a4f3$var$tickFormat(start, stop, count, specifier) {
    var step = (0, $7oz1V.tickStep)(start, stop, count), precision;
    specifier = (0, $1Lw1k.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $1Lw1k.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, $1Lw1k.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $1Lw1k.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $1Lw1k.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $1Lw1k.format)(specifier);
}

});
parcelRegister("1Lw1k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return $149304cdacfaa688$var$_formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(module.exports, "format", {
    enumerable: true,
    get: function() {
        return $149304cdacfaa688$var$_defaultLocale.format;
    }
});
Object.defineProperty(module.exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $149304cdacfaa688$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return $149304cdacfaa688$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return $149304cdacfaa688$var$_defaultLocale.formatPrefix;
    }
});
Object.defineProperty(module.exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return $149304cdacfaa688$var$_formatSpecifier.default;
    }
});
Object.defineProperty(module.exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return $149304cdacfaa688$var$_precisionFixed.default;
    }
});
Object.defineProperty(module.exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return $149304cdacfaa688$var$_precisionPrefix.default;
    }
});
Object.defineProperty(module.exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return $149304cdacfaa688$var$_precisionRound.default;
    }
});

var $149304cdacfaa688$var$_defaultLocale = $149304cdacfaa688$var$_interopRequireWildcard((parcelRequire("JBqWj")));

var $149304cdacfaa688$var$_locale = $149304cdacfaa688$var$_interopRequireDefault((parcelRequire("iR7KA")));

var $149304cdacfaa688$var$_formatSpecifier = $149304cdacfaa688$var$_interopRequireWildcard((parcelRequire("i8HAB")));

var $149304cdacfaa688$var$_precisionFixed = $149304cdacfaa688$var$_interopRequireDefault((parcelRequire("4DGPc")));

var $149304cdacfaa688$var$_precisionPrefix = $149304cdacfaa688$var$_interopRequireDefault((parcelRequire("5pKOt")));

var $149304cdacfaa688$var$_precisionRound = $149304cdacfaa688$var$_interopRequireDefault((parcelRequire("UQNFS")));
function $149304cdacfaa688$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $149304cdacfaa688$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($149304cdacfaa688$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $149304cdacfaa688$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $149304cdacfaa688$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("JBqWj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $08913d996ae6dc80$var$defaultLocale;
module.exports.formatPrefix = module.exports.format = void 0;

var $08913d996ae6dc80$var$_locale = $08913d996ae6dc80$var$_interopRequireDefault((parcelRequire("iR7KA")));
function $08913d996ae6dc80$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $08913d996ae6dc80$var$locale;
var $08913d996ae6dc80$var$format;
module.exports.format = $08913d996ae6dc80$var$format;
var $08913d996ae6dc80$var$formatPrefix;
module.exports.formatPrefix = $08913d996ae6dc80$var$formatPrefix;
$08913d996ae6dc80$var$defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $08913d996ae6dc80$var$defaultLocale(definition) {
    $08913d996ae6dc80$var$locale = (0, $08913d996ae6dc80$var$_locale.default)(definition);
    module.exports.format = $08913d996ae6dc80$var$format = $08913d996ae6dc80$var$locale.format;
    module.exports.formatPrefix = $08913d996ae6dc80$var$formatPrefix = $08913d996ae6dc80$var$locale.formatPrefix;
    return $08913d996ae6dc80$var$locale;
}

});
parcelRegister("iR7KA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dba3304f8b218603$var$_default;

var $dba3304f8b218603$var$_exponent = $dba3304f8b218603$var$_interopRequireDefault((parcelRequire("9S7vN")));

var $dba3304f8b218603$var$_formatGroup = $dba3304f8b218603$var$_interopRequireDefault((parcelRequire("3EMaL")));

var $dba3304f8b218603$var$_formatNumerals = $dba3304f8b218603$var$_interopRequireDefault((parcelRequire("qp6Ob")));

var $dba3304f8b218603$var$_formatSpecifier = $dba3304f8b218603$var$_interopRequireDefault((parcelRequire("i8HAB")));

var $dba3304f8b218603$var$_formatTrim = $dba3304f8b218603$var$_interopRequireDefault((parcelRequire("lG7YH")));

var $dba3304f8b218603$var$_formatTypes = $dba3304f8b218603$var$_interopRequireDefault((parcelRequire("hF57X")));

var $kzaH8 = parcelRequire("kzaH8");

var $dba3304f8b218603$var$_identity = $dba3304f8b218603$var$_interopRequireDefault((parcelRequire("isC41")));
function $dba3304f8b218603$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $dba3304f8b218603$var$map = Array.prototype.map, $dba3304f8b218603$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $dba3304f8b218603$var$_default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? $dba3304f8b218603$var$_identity.default : (0, $dba3304f8b218603$var$_formatGroup.default)($dba3304f8b218603$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? $dba3304f8b218603$var$_identity.default : (0, $dba3304f8b218603$var$_formatNumerals.default)($dba3304f8b218603$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $dba3304f8b218603$var$_formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type; // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g"; // The "" type, and any invalid type, is an alias for ".12~g".
        else if (!$dba3304f8b218603$var$_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g"; // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "="; // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : ""; // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = $dba3304f8b218603$var$_formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type); // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value; // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0; // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision); // Trim insignificant zeros.
                if (trim) value = (0, $dba3304f8b218603$var$_formatTrim.default)(value); // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false; // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $dba3304f8b218603$var$prefixes[8 + $kzaH8.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : ""); // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            } // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity); // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : ""; // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = ""; // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $dba3304f8b218603$var$_formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $dba3304f8b218603$var$_exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $dba3304f8b218603$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

});
parcelRegister("9S7vN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $01dad283c5be72cb$var$_default;

var $1yaZR = parcelRequire("1yaZR");
function $01dad283c5be72cb$var$_default(x) {
    return x = (0, $1yaZR.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

});
parcelRegister("1yaZR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $12117f1fcd360ec5$var$_default;
module.exports.formatDecimalParts = $12117f1fcd360ec5$var$formatDecimalParts;
function $12117f1fcd360ec5$var$_default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
} // Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function $12117f1fcd360ec5$var$formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i); // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

});


parcelRegister("3EMaL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a9a79976e346ddf$var$_default;
function $2a9a79976e346ddf$var$_default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

});

parcelRegister("qp6Ob", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $04f5e7e8fe1bf878$var$_default;
function $04f5e7e8fe1bf878$var$_default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

});

parcelRegister("i8HAB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.FormatSpecifier = $d34ac94a2d0b3a26$var$FormatSpecifier;
module.exports.default = $d34ac94a2d0b3a26$var$formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $d34ac94a2d0b3a26$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $d34ac94a2d0b3a26$var$formatSpecifier(specifier) {
    if (!(match = $d34ac94a2d0b3a26$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $d34ac94a2d0b3a26$var$FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$d34ac94a2d0b3a26$var$formatSpecifier.prototype = $d34ac94a2d0b3a26$var$FormatSpecifier.prototype; // instanceof
function $d34ac94a2d0b3a26$var$FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$d34ac94a2d0b3a26$var$FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

});

parcelRegister("lG7YH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $fc83b5807a5a8d52$var$_default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $fc83b5807a5a8d52$var$_default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

});

parcelRegister("hF57X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cdba3e322ec85f05$var$_formatDecimal = $cdba3e322ec85f05$var$_interopRequireDefault((parcelRequire("1yaZR")));

var $cdba3e322ec85f05$var$_formatPrefixAuto = $cdba3e322ec85f05$var$_interopRequireDefault((parcelRequire("kzaH8")));

var $cdba3e322ec85f05$var$_formatRounded = $cdba3e322ec85f05$var$_interopRequireDefault((parcelRequire("9ayzO")));
function $cdba3e322ec85f05$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $cdba3e322ec85f05$var$_default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": $cdba3e322ec85f05$var$_formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $cdba3e322ec85f05$var$_formatRounded.default)(x * 100, p),
    "r": $cdba3e322ec85f05$var$_formatRounded.default,
    "s": $cdba3e322ec85f05$var$_formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};
module.exports.default = $cdba3e322ec85f05$var$_default;

});
parcelRegister("kzaH8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ef8f5f4c6759144c$var$_default;
module.exports.prefixExponent = void 0;

var $1yaZR = parcelRequire("1yaZR");
var $ef8f5f4c6759144c$var$prefixExponent;
module.exports.prefixExponent = $ef8f5f4c6759144c$var$prefixExponent;
function $ef8f5f4c6759144c$var$_default(x, p) {
    var d = (0, $1yaZR.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (module.exports.prefixExponent = $ef8f5f4c6759144c$var$prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $1yaZR.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

});

parcelRegister("9ayzO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6acfde7282630536$var$_default;

var $1yaZR = parcelRequire("1yaZR");
function $6acfde7282630536$var$_default(x, p) {
    var d = (0, $1yaZR.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

});


parcelRegister("isC41", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d7085e32be950cc3$var$_default;
function $d7085e32be950cc3$var$_default(x) {
    return x;
}

});



parcelRegister("4DGPc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $360c060c92099d86$var$_default;

var $360c060c92099d86$var$_exponent = $360c060c92099d86$var$_interopRequireDefault((parcelRequire("9S7vN")));
function $360c060c92099d86$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $360c060c92099d86$var$_default(step) {
    return Math.max(0, -(0, $360c060c92099d86$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("5pKOt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f1399abff716b26$var$_default;

var $3f1399abff716b26$var$_exponent = $3f1399abff716b26$var$_interopRequireDefault((parcelRequire("9S7vN")));
function $3f1399abff716b26$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3f1399abff716b26$var$_default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $3f1399abff716b26$var$_exponent.default)(value) / 3))) * 3 - (0, $3f1399abff716b26$var$_exponent.default)(Math.abs(step)));
}

});

parcelRegister("UQNFS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $0aae3018e215c083$var$_default;

var $0aae3018e215c083$var$_exponent = $0aae3018e215c083$var$_interopRequireDefault((parcelRequire("9S7vN")));
function $0aae3018e215c083$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $0aae3018e215c083$var$_default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $0aae3018e215c083$var$_exponent.default)(max) - (0, $0aae3018e215c083$var$_exponent.default)(step)) + 1;
}

});





parcelRegister("2kaib", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1b156ed6a0e33dc2$var$log;
module.exports.loggish = $1b156ed6a0e33dc2$var$loggish;

var $7oz1V = parcelRequire("7oz1V");

var $1Lw1k = parcelRequire("1Lw1k");

var $1b156ed6a0e33dc2$var$_nice = $1b156ed6a0e33dc2$var$_interopRequireDefault((parcelRequire("dgM3O")));

var $1r8KC = parcelRequire("1r8KC");

var $cnxlJ = parcelRequire("cnxlJ");
function $1b156ed6a0e33dc2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1b156ed6a0e33dc2$var$transformLog(x) {
    return Math.log(x);
}
function $1b156ed6a0e33dc2$var$transformExp(x) {
    return Math.exp(x);
}
function $1b156ed6a0e33dc2$var$transformLogn(x) {
    return -Math.log(-x);
}
function $1b156ed6a0e33dc2$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $1b156ed6a0e33dc2$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $1b156ed6a0e33dc2$var$powp(base) {
    return base === 10 ? $1b156ed6a0e33dc2$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $1b156ed6a0e33dc2$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $1b156ed6a0e33dc2$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $1b156ed6a0e33dc2$var$loggish(transform) {
    const scale = transform($1b156ed6a0e33dc2$var$transformLog, $1b156ed6a0e33dc2$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $1b156ed6a0e33dc2$var$logp(base), pows = $1b156ed6a0e33dc2$var$powp(base);
        if (domain()[0] < 0) {
            logs = $1b156ed6a0e33dc2$var$reflect(logs), pows = $1b156ed6a0e33dc2$var$reflect(pows);
            transform($1b156ed6a0e33dc2$var$transformLogn, $1b156ed6a0e33dc2$var$transformExpn);
        } else transform($1b156ed6a0e33dc2$var$transformLog, $1b156ed6a0e33dc2$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $7oz1V.ticks)(u, v, n);
        } else z = (0, $7oz1V.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $1Lw1k.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $1Lw1k.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $1b156ed6a0e33dc2$var$_nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $1b156ed6a0e33dc2$var$log() {
    const scale = $1b156ed6a0e33dc2$var$loggish((0, $1r8KC.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $1r8KC.copy)(scale, $1b156ed6a0e33dc2$var$log()).base(scale.base());
    $cnxlJ.initRange.apply(scale, arguments);
    return scale;
}

});
parcelRegister("dgM3O", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9a920cce93b13867$var$nice;
function $9a920cce93b13867$var$nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

});


parcelRegister("61Ei9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4632172ed08e6e2e$var$symlog;
module.exports.symlogish = $4632172ed08e6e2e$var$symlogish;

var $ilLMd = parcelRequire("ilLMd");

var $1r8KC = parcelRequire("1r8KC");

var $cnxlJ = parcelRequire("cnxlJ");
function $4632172ed08e6e2e$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $4632172ed08e6e2e$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $4632172ed08e6e2e$var$symlogish(transform) {
    var c = 1, scale = transform($4632172ed08e6e2e$var$transformSymlog(c), $4632172ed08e6e2e$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($4632172ed08e6e2e$var$transformSymlog(c = +_), $4632172ed08e6e2e$var$transformSymexp(c)) : c;
    };
    return (0, $ilLMd.linearish)(scale);
}
function $4632172ed08e6e2e$var$symlog() {
    var scale = $4632172ed08e6e2e$var$symlogish((0, $1r8KC.transformer)());
    scale.copy = function() {
        return (0, $1r8KC.copy)(scale, $4632172ed08e6e2e$var$symlog()).constant(scale.constant());
    };
    return $cnxlJ.initRange.apply(scale, arguments);
}

});

parcelRegister("fBfC8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b5b66c5d87c43aa1$var$pow;
module.exports.powish = $b5b66c5d87c43aa1$var$powish;
module.exports.sqrt = $b5b66c5d87c43aa1$var$sqrt;

var $ilLMd = parcelRequire("ilLMd");

var $1r8KC = parcelRequire("1r8KC");

var $cnxlJ = parcelRequire("cnxlJ");
function $b5b66c5d87c43aa1$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $b5b66c5d87c43aa1$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $b5b66c5d87c43aa1$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $b5b66c5d87c43aa1$var$powish(transform) {
    var scale = transform($1r8KC.identity, $1r8KC.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform($1r8KC.identity, $1r8KC.identity) : exponent === 0.5 ? transform($b5b66c5d87c43aa1$var$transformSqrt, $b5b66c5d87c43aa1$var$transformSquare) : transform($b5b66c5d87c43aa1$var$transformPow(exponent), $b5b66c5d87c43aa1$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $ilLMd.linearish)(scale);
}
function $b5b66c5d87c43aa1$var$pow() {
    var scale = $b5b66c5d87c43aa1$var$powish((0, $1r8KC.transformer)());
    scale.copy = function() {
        return (0, $1r8KC.copy)(scale, $b5b66c5d87c43aa1$var$pow()).exponent(scale.exponent());
    };
    $cnxlJ.initRange.apply(scale, arguments);
    return scale;
}
function $b5b66c5d87c43aa1$var$sqrt() {
    return $b5b66c5d87c43aa1$var$pow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("gvxWP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c049dff035cee486$var$radial;

var $c049dff035cee486$var$_continuous = $c049dff035cee486$var$_interopRequireDefault((parcelRequire("1r8KC")));

var $cnxlJ = parcelRequire("cnxlJ");

var $ilLMd = parcelRequire("ilLMd");

var $c049dff035cee486$var$_number = $c049dff035cee486$var$_interopRequireDefault((parcelRequire("kICmR")));
function $c049dff035cee486$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c049dff035cee486$var$square(x) {
    return Math.sign(x) * x * x;
}
function $c049dff035cee486$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $c049dff035cee486$var$radial() {
    var squared = (0, $c049dff035cee486$var$_continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $c049dff035cee486$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($c049dff035cee486$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, $c049dff035cee486$var$_number.default)).map($c049dff035cee486$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $c049dff035cee486$var$radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    $cnxlJ.initRange.apply(scale, arguments);
    return (0, $ilLMd.linearish)(scale);
}

});

parcelRegister("fesZO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b16ea7d55f28fc86$var$quantile;

var $7oz1V = parcelRequire("7oz1V");

var $cnxlJ = parcelRequire("cnxlJ");
function $b16ea7d55f28fc86$var$quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $7oz1V.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $7oz1V.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($7oz1V.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $b16ea7d55f28fc86$var$quantile().domain(domain).range(range).unknown(unknown);
    };
    return $cnxlJ.initRange.apply(scale, arguments);
}

});

parcelRegister("2uUvL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1d1a38194109c610$var$quantize;

var $7oz1V = parcelRequire("7oz1V");

var $ilLMd = parcelRequire("ilLMd");

var $cnxlJ = parcelRequire("cnxlJ");
function $1d1a38194109c610$var$quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $7oz1V.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $1d1a38194109c610$var$quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return $cnxlJ.initRange.apply((0, $ilLMd.linearish)(scale), arguments);
}

});

parcelRegister("iTlTl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $dc0e5846a07fce29$var$threshold;

var $7oz1V = parcelRequire("7oz1V");

var $cnxlJ = parcelRequire("cnxlJ");
function $dc0e5846a07fce29$var$threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $7oz1V.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $dc0e5846a07fce29$var$threshold().domain(domain).range(range).unknown(unknown);
    };
    return $cnxlJ.initRange.apply(scale, arguments);
}

});

parcelRegister("homkz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.calendar = $ca960000bfebe317$var$calendar;
module.exports.default = $ca960000bfebe317$var$time;

var $cG9Fg = parcelRequire("cG9Fg");

var $gEGZa = parcelRequire("gEGZa");

var $ca960000bfebe317$var$_continuous = $ca960000bfebe317$var$_interopRequireWildcard((parcelRequire("1r8KC")));

var $cnxlJ = parcelRequire("cnxlJ");

var $ca960000bfebe317$var$_nice = $ca960000bfebe317$var$_interopRequireDefault((parcelRequire("dgM3O")));
function $ca960000bfebe317$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ca960000bfebe317$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ca960000bfebe317$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ca960000bfebe317$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ca960000bfebe317$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ca960000bfebe317$var$date(t) {
    return new Date(t);
}
function $ca960000bfebe317$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $ca960000bfebe317$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $ca960000bfebe317$var$_continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $ca960000bfebe317$var$number)) : domain().map($ca960000bfebe317$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $ca960000bfebe317$var$_nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $ca960000bfebe317$var$_continuous.copy)(scale, $ca960000bfebe317$var$calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $ca960000bfebe317$var$time() {
    return $cnxlJ.initRange.apply($ca960000bfebe317$var$calendar($cG9Fg.timeTicks, $cG9Fg.timeTickInterval, $cG9Fg.timeYear, $cG9Fg.timeMonth, $cG9Fg.timeWeek, $cG9Fg.timeDay, $cG9Fg.timeHour, $cG9Fg.timeMinute, $cG9Fg.timeSecond, $gEGZa.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

});
parcelRegister("cG9Fg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "timeDay", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_day.default;
    }
});
Object.defineProperty(module.exports, "timeDays", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_day.days;
    }
});
Object.defineProperty(module.exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return $d4Cuo.friday;
    }
});
Object.defineProperty(module.exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return $d4Cuo.fridays;
    }
});
Object.defineProperty(module.exports, "timeHour", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_hour.default;
    }
});
Object.defineProperty(module.exports, "timeHours", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_hour.hours;
    }
});
Object.defineProperty(module.exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_interval.default;
    }
});
Object.defineProperty(module.exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_minute.default;
    }
});
Object.defineProperty(module.exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_minute.minutes;
    }
});
Object.defineProperty(module.exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return $d4Cuo.monday;
    }
});
Object.defineProperty(module.exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return $d4Cuo.mondays;
    }
});
Object.defineProperty(module.exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_month.default;
    }
});
Object.defineProperty(module.exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_month.months;
    }
});
Object.defineProperty(module.exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return $d4Cuo.saturday;
    }
});
Object.defineProperty(module.exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return $d4Cuo.saturdays;
    }
});
Object.defineProperty(module.exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_second.default;
    }
});
Object.defineProperty(module.exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return $d4Cuo.sunday;
    }
});
Object.defineProperty(module.exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return $d4Cuo.sundays;
    }
});
Object.defineProperty(module.exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return $d4Cuo.thursday;
    }
});
Object.defineProperty(module.exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return $d4Cuo.thursdays;
    }
});
Object.defineProperty(module.exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return $84704.timeTickInterval;
    }
});
Object.defineProperty(module.exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return $84704.timeTicks;
    }
});
Object.defineProperty(module.exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return $d4Cuo.tuesday;
    }
});
Object.defineProperty(module.exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return $d4Cuo.tuesdays;
    }
});
Object.defineProperty(module.exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return $d4Cuo.wednesday;
    }
});
Object.defineProperty(module.exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return $d4Cuo.wednesdays;
    }
});
Object.defineProperty(module.exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return $d4Cuo.sunday;
    }
});
Object.defineProperty(module.exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return $d4Cuo.sundays;
    }
});
Object.defineProperty(module.exports, "timeYear", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_year.default;
    }
});
Object.defineProperty(module.exports, "timeYears", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_year.years;
    }
});
Object.defineProperty(module.exports, "utcDay", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_utcDay.default;
    }
});
Object.defineProperty(module.exports, "utcDays", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_utcDay.utcDays;
    }
});
Object.defineProperty(module.exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return $7OOhA.utcFriday;
    }
});
Object.defineProperty(module.exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return $7OOhA.utcFridays;
    }
});
Object.defineProperty(module.exports, "utcHour", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_utcHour.default;
    }
});
Object.defineProperty(module.exports, "utcHours", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_utcHour.utcHours;
    }
});
Object.defineProperty(module.exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_millisecond.default;
    }
});
Object.defineProperty(module.exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_millisecond.milliseconds;
    }
});
Object.defineProperty(module.exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_utcMinute.default;
    }
});
Object.defineProperty(module.exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_utcMinute.utcMinutes;
    }
});
Object.defineProperty(module.exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return $7OOhA.utcMonday;
    }
});
Object.defineProperty(module.exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return $7OOhA.utcMondays;
    }
});
Object.defineProperty(module.exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_utcMonth.default;
    }
});
Object.defineProperty(module.exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_utcMonth.utcMonths;
    }
});
Object.defineProperty(module.exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return $7OOhA.utcSaturday;
    }
});
Object.defineProperty(module.exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return $7OOhA.utcSaturdays;
    }
});
Object.defineProperty(module.exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_second.default;
    }
});
Object.defineProperty(module.exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_second.seconds;
    }
});
Object.defineProperty(module.exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return $7OOhA.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return $7OOhA.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return $7OOhA.utcThursday;
    }
});
Object.defineProperty(module.exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return $7OOhA.utcThursdays;
    }
});
Object.defineProperty(module.exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return $84704.utcTickInterval;
    }
});
Object.defineProperty(module.exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return $84704.utcTicks;
    }
});
Object.defineProperty(module.exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return $7OOhA.utcTuesday;
    }
});
Object.defineProperty(module.exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return $7OOhA.utcTuesdays;
    }
});
Object.defineProperty(module.exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return $7OOhA.utcWednesday;
    }
});
Object.defineProperty(module.exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return $7OOhA.utcWednesdays;
    }
});
Object.defineProperty(module.exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return $7OOhA.utcSunday;
    }
});
Object.defineProperty(module.exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return $7OOhA.utcSundays;
    }
});
Object.defineProperty(module.exports, "utcYear", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_utcYear.default;
    }
});
Object.defineProperty(module.exports, "utcYears", {
    enumerable: true,
    get: function() {
        return $93b0e7742e8878c3$var$_utcYear.utcYears;
    }
});

var $93b0e7742e8878c3$var$_interval = $93b0e7742e8878c3$var$_interopRequireDefault((parcelRequire("dByFA")));

var $93b0e7742e8878c3$var$_millisecond = $93b0e7742e8878c3$var$_interopRequireWildcard((parcelRequire("jadwW")));

var $93b0e7742e8878c3$var$_second = $93b0e7742e8878c3$var$_interopRequireWildcard((parcelRequire("3kbfV")));

var $93b0e7742e8878c3$var$_minute = $93b0e7742e8878c3$var$_interopRequireWildcard((parcelRequire("7msfi")));

var $93b0e7742e8878c3$var$_hour = $93b0e7742e8878c3$var$_interopRequireWildcard((parcelRequire("fCtms")));

var $93b0e7742e8878c3$var$_day = $93b0e7742e8878c3$var$_interopRequireWildcard((parcelRequire("aviTW")));

var $d4Cuo = parcelRequire("d4Cuo");

var $93b0e7742e8878c3$var$_month = $93b0e7742e8878c3$var$_interopRequireWildcard((parcelRequire("8ErR7")));

var $93b0e7742e8878c3$var$_year = $93b0e7742e8878c3$var$_interopRequireWildcard((parcelRequire("9UYHo")));

var $93b0e7742e8878c3$var$_utcMinute = $93b0e7742e8878c3$var$_interopRequireWildcard((parcelRequire("cJWQO")));

var $93b0e7742e8878c3$var$_utcHour = $93b0e7742e8878c3$var$_interopRequireWildcard((parcelRequire("ibP3m")));

var $93b0e7742e8878c3$var$_utcDay = $93b0e7742e8878c3$var$_interopRequireWildcard((parcelRequire("jN3ww")));

var $7OOhA = parcelRequire("7OOhA");

var $93b0e7742e8878c3$var$_utcMonth = $93b0e7742e8878c3$var$_interopRequireWildcard((parcelRequire("a6JsZ")));

var $93b0e7742e8878c3$var$_utcYear = $93b0e7742e8878c3$var$_interopRequireWildcard((parcelRequire("fmerI")));

var $84704 = parcelRequire("84704");
function $93b0e7742e8878c3$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($93b0e7742e8878c3$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $93b0e7742e8878c3$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $93b0e7742e8878c3$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $93b0e7742e8878c3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("dByFA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $9e799fc59a783888$var$newInterval;
var $9e799fc59a783888$var$t0 = new Date(), $9e799fc59a783888$var$t1 = new Date();
function $9e799fc59a783888$var$newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $9e799fc59a783888$var$newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $9e799fc59a783888$var$t0.setTime(+start), $9e799fc59a783888$var$t1.setTime(+end);
            floori($9e799fc59a783888$var$t0), floori($9e799fc59a783888$var$t1);
            return Math.floor(count($9e799fc59a783888$var$t0, $9e799fc59a783888$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

});

parcelRegister("jadwW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.milliseconds = module.exports.default = void 0;

var $df397257495de6ae$var$_interval = $df397257495de6ae$var$_interopRequireDefault((parcelRequire("dByFA")));
function $df397257495de6ae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $df397257495de6ae$var$millisecond = (0, $df397257495de6ae$var$_interval.default)(function() {}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
}); // An optimized implementation for this simple case.
$df397257495de6ae$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $df397257495de6ae$var$millisecond;
    return (0, $df397257495de6ae$var$_interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $df397257495de6ae$var$_default = $df397257495de6ae$var$millisecond;
module.exports.default = $df397257495de6ae$var$_default;
var $df397257495de6ae$var$milliseconds = $df397257495de6ae$var$millisecond.range;
module.exports.milliseconds = $df397257495de6ae$var$milliseconds;

});

parcelRegister("3kbfV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.seconds = module.exports.default = void 0;

var $26bbf88c76de8662$var$_interval = $26bbf88c76de8662$var$_interopRequireDefault((parcelRequire("dByFA")));

var $9T2Qx = parcelRequire("9T2Qx");
function $26bbf88c76de8662$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $26bbf88c76de8662$var$second = (0, $26bbf88c76de8662$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * $9T2Qx.durationSecond);
}, function(start, end) {
    return (end - start) / $9T2Qx.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var $26bbf88c76de8662$var$_default = $26bbf88c76de8662$var$second;
module.exports.default = $26bbf88c76de8662$var$_default;
var $26bbf88c76de8662$var$seconds = $26bbf88c76de8662$var$second.range;
module.exports.seconds = $26bbf88c76de8662$var$seconds;

});
parcelRegister("9T2Qx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.durationYear = module.exports.durationWeek = module.exports.durationSecond = module.exports.durationMonth = module.exports.durationMinute = module.exports.durationHour = module.exports.durationDay = void 0;
const $732b755d0ffb8714$var$durationSecond = 1000;
module.exports.durationSecond = $732b755d0ffb8714$var$durationSecond;
const $732b755d0ffb8714$var$durationMinute = $732b755d0ffb8714$var$durationSecond * 60;
module.exports.durationMinute = $732b755d0ffb8714$var$durationMinute;
const $732b755d0ffb8714$var$durationHour = $732b755d0ffb8714$var$durationMinute * 60;
module.exports.durationHour = $732b755d0ffb8714$var$durationHour;
const $732b755d0ffb8714$var$durationDay = $732b755d0ffb8714$var$durationHour * 24;
module.exports.durationDay = $732b755d0ffb8714$var$durationDay;
const $732b755d0ffb8714$var$durationWeek = $732b755d0ffb8714$var$durationDay * 7;
module.exports.durationWeek = $732b755d0ffb8714$var$durationWeek;
const $732b755d0ffb8714$var$durationMonth = $732b755d0ffb8714$var$durationDay * 30;
module.exports.durationMonth = $732b755d0ffb8714$var$durationMonth;
const $732b755d0ffb8714$var$durationYear = $732b755d0ffb8714$var$durationDay * 365;
module.exports.durationYear = $732b755d0ffb8714$var$durationYear;

});


parcelRegister("7msfi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.minutes = module.exports.default = void 0;

var $55c07f7d1e74336a$var$_interval = $55c07f7d1e74336a$var$_interopRequireDefault((parcelRequire("dByFA")));

var $9T2Qx = parcelRequire("9T2Qx");
function $55c07f7d1e74336a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $55c07f7d1e74336a$var$minute = (0, $55c07f7d1e74336a$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $9T2Qx.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * $9T2Qx.durationMinute);
}, function(start, end) {
    return (end - start) / $9T2Qx.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var $55c07f7d1e74336a$var$_default = $55c07f7d1e74336a$var$minute;
module.exports.default = $55c07f7d1e74336a$var$_default;
var $55c07f7d1e74336a$var$minutes = $55c07f7d1e74336a$var$minute.range;
module.exports.minutes = $55c07f7d1e74336a$var$minutes;

});

parcelRegister("fCtms", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hours = module.exports.default = void 0;

var $b5f12e276e00808e$var$_interval = $b5f12e276e00808e$var$_interopRequireDefault((parcelRequire("dByFA")));

var $9T2Qx = parcelRequire("9T2Qx");
function $b5f12e276e00808e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b5f12e276e00808e$var$hour = (0, $b5f12e276e00808e$var$_interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * $9T2Qx.durationSecond - date.getMinutes() * $9T2Qx.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * $9T2Qx.durationHour);
}, function(start, end) {
    return (end - start) / $9T2Qx.durationHour;
}, function(date) {
    return date.getHours();
});
var $b5f12e276e00808e$var$_default = $b5f12e276e00808e$var$hour;
module.exports.default = $b5f12e276e00808e$var$_default;
var $b5f12e276e00808e$var$hours = $b5f12e276e00808e$var$hour.range;
module.exports.hours = $b5f12e276e00808e$var$hours;

});

parcelRegister("aviTW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.days = void 0;

var $7a5b760d5275f916$var$_interval = $7a5b760d5275f916$var$_interopRequireDefault((parcelRequire("dByFA")));

var $9T2Qx = parcelRequire("9T2Qx");
function $7a5b760d5275f916$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $7a5b760d5275f916$var$day = (0, $7a5b760d5275f916$var$_interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $9T2Qx.durationMinute) / $9T2Qx.durationDay, (date)=>date.getDate() - 1);
var $7a5b760d5275f916$var$_default = $7a5b760d5275f916$var$day;
module.exports.default = $7a5b760d5275f916$var$_default;
var $7a5b760d5275f916$var$days = $7a5b760d5275f916$var$day.range;
module.exports.days = $7a5b760d5275f916$var$days;

});

parcelRegister("d4Cuo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.wednesdays = module.exports.wednesday = module.exports.tuesdays = module.exports.tuesday = module.exports.thursdays = module.exports.thursday = module.exports.sundays = module.exports.sunday = module.exports.saturdays = module.exports.saturday = module.exports.mondays = module.exports.monday = module.exports.fridays = module.exports.friday = void 0;

var $98498137b5387618$var$_interval = $98498137b5387618$var$_interopRequireDefault((parcelRequire("dByFA")));

var $9T2Qx = parcelRequire("9T2Qx");
function $98498137b5387618$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $98498137b5387618$var$weekday(i) {
    return (0, $98498137b5387618$var$_interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * $9T2Qx.durationMinute) / $9T2Qx.durationWeek;
    });
}
var $98498137b5387618$var$sunday = $98498137b5387618$var$weekday(0);
module.exports.sunday = $98498137b5387618$var$sunday;
var $98498137b5387618$var$monday = $98498137b5387618$var$weekday(1);
module.exports.monday = $98498137b5387618$var$monday;
var $98498137b5387618$var$tuesday = $98498137b5387618$var$weekday(2);
module.exports.tuesday = $98498137b5387618$var$tuesday;
var $98498137b5387618$var$wednesday = $98498137b5387618$var$weekday(3);
module.exports.wednesday = $98498137b5387618$var$wednesday;
var $98498137b5387618$var$thursday = $98498137b5387618$var$weekday(4);
module.exports.thursday = $98498137b5387618$var$thursday;
var $98498137b5387618$var$friday = $98498137b5387618$var$weekday(5);
module.exports.friday = $98498137b5387618$var$friday;
var $98498137b5387618$var$saturday = $98498137b5387618$var$weekday(6);
module.exports.saturday = $98498137b5387618$var$saturday;
var $98498137b5387618$var$sundays = $98498137b5387618$var$sunday.range;
module.exports.sundays = $98498137b5387618$var$sundays;
var $98498137b5387618$var$mondays = $98498137b5387618$var$monday.range;
module.exports.mondays = $98498137b5387618$var$mondays;
var $98498137b5387618$var$tuesdays = $98498137b5387618$var$tuesday.range;
module.exports.tuesdays = $98498137b5387618$var$tuesdays;
var $98498137b5387618$var$wednesdays = $98498137b5387618$var$wednesday.range;
module.exports.wednesdays = $98498137b5387618$var$wednesdays;
var $98498137b5387618$var$thursdays = $98498137b5387618$var$thursday.range;
module.exports.thursdays = $98498137b5387618$var$thursdays;
var $98498137b5387618$var$fridays = $98498137b5387618$var$friday.range;
module.exports.fridays = $98498137b5387618$var$fridays;
var $98498137b5387618$var$saturdays = $98498137b5387618$var$saturday.range;
module.exports.saturdays = $98498137b5387618$var$saturdays;

});

parcelRegister("8ErR7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.months = module.exports.default = void 0;

var $64c7aabf94dcd06a$var$_interval = $64c7aabf94dcd06a$var$_interopRequireDefault((parcelRequire("dByFA")));
function $64c7aabf94dcd06a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $64c7aabf94dcd06a$var$month = (0, $64c7aabf94dcd06a$var$_interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $64c7aabf94dcd06a$var$_default = $64c7aabf94dcd06a$var$month;
module.exports.default = $64c7aabf94dcd06a$var$_default;
var $64c7aabf94dcd06a$var$months = $64c7aabf94dcd06a$var$month.range;
module.exports.months = $64c7aabf94dcd06a$var$months;

});

parcelRegister("9UYHo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.years = module.exports.default = void 0;

var $73886d87fa32caa9$var$_interval = $73886d87fa32caa9$var$_interopRequireDefault((parcelRequire("dByFA")));
function $73886d87fa32caa9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $73886d87fa32caa9$var$year = (0, $73886d87fa32caa9$var$_interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
}); // An optimized implementation for this simple case.
$73886d87fa32caa9$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $73886d87fa32caa9$var$_interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $73886d87fa32caa9$var$_default = $73886d87fa32caa9$var$year;
module.exports.default = $73886d87fa32caa9$var$_default;
var $73886d87fa32caa9$var$years = $73886d87fa32caa9$var$year.range;
module.exports.years = $73886d87fa32caa9$var$years;

});

parcelRegister("cJWQO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMinutes = module.exports.default = void 0;

var $9467568aca2f14c0$var$_interval = $9467568aca2f14c0$var$_interopRequireDefault((parcelRequire("dByFA")));

var $9T2Qx = parcelRequire("9T2Qx");
function $9467568aca2f14c0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9467568aca2f14c0$var$utcMinute = (0, $9467568aca2f14c0$var$_interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * $9T2Qx.durationMinute);
}, function(start, end) {
    return (end - start) / $9T2Qx.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var $9467568aca2f14c0$var$_default = $9467568aca2f14c0$var$utcMinute;
module.exports.default = $9467568aca2f14c0$var$_default;
var $9467568aca2f14c0$var$utcMinutes = $9467568aca2f14c0$var$utcMinute.range;
module.exports.utcMinutes = $9467568aca2f14c0$var$utcMinutes;

});

parcelRegister("ibP3m", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcHours = module.exports.default = void 0;

var $d3e0db305e90727d$var$_interval = $d3e0db305e90727d$var$_interopRequireDefault((parcelRequire("dByFA")));

var $9T2Qx = parcelRequire("9T2Qx");
function $d3e0db305e90727d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $d3e0db305e90727d$var$utcHour = (0, $d3e0db305e90727d$var$_interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * $9T2Qx.durationHour);
}, function(start, end) {
    return (end - start) / $9T2Qx.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var $d3e0db305e90727d$var$_default = $d3e0db305e90727d$var$utcHour;
module.exports.default = $d3e0db305e90727d$var$_default;
var $d3e0db305e90727d$var$utcHours = $d3e0db305e90727d$var$utcHour.range;
module.exports.utcHours = $d3e0db305e90727d$var$utcHours;

});

parcelRegister("jN3ww", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcDays = module.exports.default = void 0;

var $e685539f4c0b1e4a$var$_interval = $e685539f4c0b1e4a$var$_interopRequireDefault((parcelRequire("dByFA")));

var $9T2Qx = parcelRequire("9T2Qx");
function $e685539f4c0b1e4a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $e685539f4c0b1e4a$var$utcDay = (0, $e685539f4c0b1e4a$var$_interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / $9T2Qx.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var $e685539f4c0b1e4a$var$_default = $e685539f4c0b1e4a$var$utcDay;
module.exports.default = $e685539f4c0b1e4a$var$_default;
var $e685539f4c0b1e4a$var$utcDays = $e685539f4c0b1e4a$var$utcDay.range;
module.exports.utcDays = $e685539f4c0b1e4a$var$utcDays;

});

parcelRegister("7OOhA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcWednesdays = module.exports.utcWednesday = module.exports.utcTuesdays = module.exports.utcTuesday = module.exports.utcThursdays = module.exports.utcThursday = module.exports.utcSundays = module.exports.utcSunday = module.exports.utcSaturdays = module.exports.utcSaturday = module.exports.utcMondays = module.exports.utcMonday = module.exports.utcFridays = module.exports.utcFriday = void 0;

var $5b143503ff33da00$var$_interval = $5b143503ff33da00$var$_interopRequireDefault((parcelRequire("dByFA")));

var $9T2Qx = parcelRequire("9T2Qx");
function $5b143503ff33da00$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5b143503ff33da00$var$utcWeekday(i) {
    return (0, $5b143503ff33da00$var$_interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / $9T2Qx.durationWeek;
    });
}
var $5b143503ff33da00$var$utcSunday = $5b143503ff33da00$var$utcWeekday(0);
module.exports.utcSunday = $5b143503ff33da00$var$utcSunday;
var $5b143503ff33da00$var$utcMonday = $5b143503ff33da00$var$utcWeekday(1);
module.exports.utcMonday = $5b143503ff33da00$var$utcMonday;
var $5b143503ff33da00$var$utcTuesday = $5b143503ff33da00$var$utcWeekday(2);
module.exports.utcTuesday = $5b143503ff33da00$var$utcTuesday;
var $5b143503ff33da00$var$utcWednesday = $5b143503ff33da00$var$utcWeekday(3);
module.exports.utcWednesday = $5b143503ff33da00$var$utcWednesday;
var $5b143503ff33da00$var$utcThursday = $5b143503ff33da00$var$utcWeekday(4);
module.exports.utcThursday = $5b143503ff33da00$var$utcThursday;
var $5b143503ff33da00$var$utcFriday = $5b143503ff33da00$var$utcWeekday(5);
module.exports.utcFriday = $5b143503ff33da00$var$utcFriday;
var $5b143503ff33da00$var$utcSaturday = $5b143503ff33da00$var$utcWeekday(6);
module.exports.utcSaturday = $5b143503ff33da00$var$utcSaturday;
var $5b143503ff33da00$var$utcSundays = $5b143503ff33da00$var$utcSunday.range;
module.exports.utcSundays = $5b143503ff33da00$var$utcSundays;
var $5b143503ff33da00$var$utcMondays = $5b143503ff33da00$var$utcMonday.range;
module.exports.utcMondays = $5b143503ff33da00$var$utcMondays;
var $5b143503ff33da00$var$utcTuesdays = $5b143503ff33da00$var$utcTuesday.range;
module.exports.utcTuesdays = $5b143503ff33da00$var$utcTuesdays;
var $5b143503ff33da00$var$utcWednesdays = $5b143503ff33da00$var$utcWednesday.range;
module.exports.utcWednesdays = $5b143503ff33da00$var$utcWednesdays;
var $5b143503ff33da00$var$utcThursdays = $5b143503ff33da00$var$utcThursday.range;
module.exports.utcThursdays = $5b143503ff33da00$var$utcThursdays;
var $5b143503ff33da00$var$utcFridays = $5b143503ff33da00$var$utcFriday.range;
module.exports.utcFridays = $5b143503ff33da00$var$utcFridays;
var $5b143503ff33da00$var$utcSaturdays = $5b143503ff33da00$var$utcSaturday.range;
module.exports.utcSaturdays = $5b143503ff33da00$var$utcSaturdays;

});

parcelRegister("a6JsZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcMonths = module.exports.default = void 0;

var $75bdbba0e7d29402$var$_interval = $75bdbba0e7d29402$var$_interopRequireDefault((parcelRequire("dByFA")));
function $75bdbba0e7d29402$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $75bdbba0e7d29402$var$utcMonth = (0, $75bdbba0e7d29402$var$_interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $75bdbba0e7d29402$var$_default = $75bdbba0e7d29402$var$utcMonth;
module.exports.default = $75bdbba0e7d29402$var$_default;
var $75bdbba0e7d29402$var$utcMonths = $75bdbba0e7d29402$var$utcMonth.range;
module.exports.utcMonths = $75bdbba0e7d29402$var$utcMonths;

});

parcelRegister("fmerI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcYears = module.exports.default = void 0;

var $b2e41dc33bef5d13$var$_interval = $b2e41dc33bef5d13$var$_interopRequireDefault((parcelRequire("dByFA")));
function $b2e41dc33bef5d13$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b2e41dc33bef5d13$var$utcYear = (0, $b2e41dc33bef5d13$var$_interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
}); // An optimized implementation for this simple case.
$b2e41dc33bef5d13$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $b2e41dc33bef5d13$var$_interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $b2e41dc33bef5d13$var$_default = $b2e41dc33bef5d13$var$utcYear;
module.exports.default = $b2e41dc33bef5d13$var$_default;
var $b2e41dc33bef5d13$var$utcYears = $b2e41dc33bef5d13$var$utcYear.range;
module.exports.utcYears = $b2e41dc33bef5d13$var$utcYears;

});

parcelRegister("84704", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.utcTicks = module.exports.utcTickInterval = module.exports.timeTicks = module.exports.timeTickInterval = void 0;

var $7oz1V = parcelRequire("7oz1V");

var $9T2Qx = parcelRequire("9T2Qx");

var $5df4208b08da79c0$var$_millisecond = $5df4208b08da79c0$var$_interopRequireDefault((parcelRequire("jadwW")));

var $5df4208b08da79c0$var$_second = $5df4208b08da79c0$var$_interopRequireDefault((parcelRequire("3kbfV")));

var $5df4208b08da79c0$var$_minute = $5df4208b08da79c0$var$_interopRequireDefault((parcelRequire("7msfi")));

var $5df4208b08da79c0$var$_hour = $5df4208b08da79c0$var$_interopRequireDefault((parcelRequire("fCtms")));

var $5df4208b08da79c0$var$_day = $5df4208b08da79c0$var$_interopRequireDefault((parcelRequire("aviTW")));

var $d4Cuo = parcelRequire("d4Cuo");

var $5df4208b08da79c0$var$_month = $5df4208b08da79c0$var$_interopRequireDefault((parcelRequire("8ErR7")));

var $5df4208b08da79c0$var$_year = $5df4208b08da79c0$var$_interopRequireDefault((parcelRequire("9UYHo")));

var $5df4208b08da79c0$var$_utcMinute = $5df4208b08da79c0$var$_interopRequireDefault((parcelRequire("cJWQO")));

var $5df4208b08da79c0$var$_utcHour = $5df4208b08da79c0$var$_interopRequireDefault((parcelRequire("ibP3m")));

var $5df4208b08da79c0$var$_utcDay = $5df4208b08da79c0$var$_interopRequireDefault((parcelRequire("jN3ww")));

var $7OOhA = parcelRequire("7OOhA");

var $5df4208b08da79c0$var$_utcMonth = $5df4208b08da79c0$var$_interopRequireDefault((parcelRequire("a6JsZ")));

var $5df4208b08da79c0$var$_utcYear = $5df4208b08da79c0$var$_interopRequireDefault((parcelRequire("fmerI")));
function $5df4208b08da79c0$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $5df4208b08da79c0$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            $5df4208b08da79c0$var$_second.default,
            1,
            $9T2Qx.durationSecond
        ],
        [
            $5df4208b08da79c0$var$_second.default,
            5,
            5 * $9T2Qx.durationSecond
        ],
        [
            $5df4208b08da79c0$var$_second.default,
            15,
            15 * $9T2Qx.durationSecond
        ],
        [
            $5df4208b08da79c0$var$_second.default,
            30,
            30 * $9T2Qx.durationSecond
        ],
        [
            minute,
            1,
            $9T2Qx.durationMinute
        ],
        [
            minute,
            5,
            5 * $9T2Qx.durationMinute
        ],
        [
            minute,
            15,
            15 * $9T2Qx.durationMinute
        ],
        [
            minute,
            30,
            30 * $9T2Qx.durationMinute
        ],
        [
            hour,
            1,
            $9T2Qx.durationHour
        ],
        [
            hour,
            3,
            3 * $9T2Qx.durationHour
        ],
        [
            hour,
            6,
            6 * $9T2Qx.durationHour
        ],
        [
            hour,
            12,
            12 * $9T2Qx.durationHour
        ],
        [
            day,
            1,
            $9T2Qx.durationDay
        ],
        [
            day,
            2,
            2 * $9T2Qx.durationDay
        ],
        [
            week,
            1,
            $9T2Qx.durationWeek
        ],
        [
            month,
            1,
            $9T2Qx.durationMonth
        ],
        [
            month,
            3,
            3 * $9T2Qx.durationMonth
        ],
        [
            year,
            1,
            $9T2Qx.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $7oz1V.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $7oz1V.tickStep)(start / $9T2Qx.durationYear, stop / $9T2Qx.durationYear, count));
        if (i === 0) return $5df4208b08da79c0$var$_millisecond.default.every(Math.max((0, $7oz1V.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$5df4208b08da79c0$var$utcTicks, $5df4208b08da79c0$var$utcTickInterval] = $5df4208b08da79c0$var$ticker($5df4208b08da79c0$var$_utcYear.default, $5df4208b08da79c0$var$_utcMonth.default, $7OOhA.utcSunday, $5df4208b08da79c0$var$_utcDay.default, $5df4208b08da79c0$var$_utcHour.default, $5df4208b08da79c0$var$_utcMinute.default);
module.exports.utcTickInterval = $5df4208b08da79c0$var$utcTickInterval;
module.exports.utcTicks = $5df4208b08da79c0$var$utcTicks;
const [$5df4208b08da79c0$var$timeTicks, $5df4208b08da79c0$var$timeTickInterval] = $5df4208b08da79c0$var$ticker($5df4208b08da79c0$var$_year.default, $5df4208b08da79c0$var$_month.default, $d4Cuo.sunday, $5df4208b08da79c0$var$_day.default, $5df4208b08da79c0$var$_hour.default, $5df4208b08da79c0$var$_minute.default);
module.exports.timeTickInterval = $5df4208b08da79c0$var$timeTickInterval;
module.exports.timeTicks = $5df4208b08da79c0$var$timeTicks;

});


parcelRegister("gEGZa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return $c201b9cf733c250e$var$_isoFormat.default;
    }
});
Object.defineProperty(module.exports, "isoParse", {
    enumerable: true,
    get: function() {
        return $c201b9cf733c250e$var$_isoParse.default;
    }
});
Object.defineProperty(module.exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return $c201b9cf733c250e$var$_defaultLocale.timeFormat;
    }
});
Object.defineProperty(module.exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return $c201b9cf733c250e$var$_defaultLocale.default;
    }
});
Object.defineProperty(module.exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return $c201b9cf733c250e$var$_locale.default;
    }
});
Object.defineProperty(module.exports, "timeParse", {
    enumerable: true,
    get: function() {
        return $c201b9cf733c250e$var$_defaultLocale.timeParse;
    }
});
Object.defineProperty(module.exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return $c201b9cf733c250e$var$_defaultLocale.utcFormat;
    }
});
Object.defineProperty(module.exports, "utcParse", {
    enumerable: true,
    get: function() {
        return $c201b9cf733c250e$var$_defaultLocale.utcParse;
    }
});

var $c201b9cf733c250e$var$_defaultLocale = $c201b9cf733c250e$var$_interopRequireWildcard((parcelRequire("5qJWf")));

var $c201b9cf733c250e$var$_locale = $c201b9cf733c250e$var$_interopRequireDefault((parcelRequire("jqC3T")));

var $c201b9cf733c250e$var$_isoFormat = $c201b9cf733c250e$var$_interopRequireDefault((parcelRequire("2JVK7")));

var $c201b9cf733c250e$var$_isoParse = $c201b9cf733c250e$var$_interopRequireDefault((parcelRequire("gcSOZ")));
function $c201b9cf733c250e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c201b9cf733c250e$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c201b9cf733c250e$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c201b9cf733c250e$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c201b9cf733c250e$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}

});
parcelRegister("5qJWf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3f4303de28a7f3a7$var$defaultLocale;
module.exports.utcParse = module.exports.utcFormat = module.exports.timeParse = module.exports.timeFormat = void 0;

var $3f4303de28a7f3a7$var$_locale = $3f4303de28a7f3a7$var$_interopRequireDefault((parcelRequire("jqC3T")));
function $3f4303de28a7f3a7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $3f4303de28a7f3a7$var$locale;
var $3f4303de28a7f3a7$var$timeFormat;
module.exports.timeFormat = $3f4303de28a7f3a7$var$timeFormat;
var $3f4303de28a7f3a7$var$timeParse;
module.exports.timeParse = $3f4303de28a7f3a7$var$timeParse;
var $3f4303de28a7f3a7$var$utcFormat;
module.exports.utcFormat = $3f4303de28a7f3a7$var$utcFormat;
var $3f4303de28a7f3a7$var$utcParse;
module.exports.utcParse = $3f4303de28a7f3a7$var$utcParse;
$3f4303de28a7f3a7$var$defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $3f4303de28a7f3a7$var$defaultLocale(definition) {
    $3f4303de28a7f3a7$var$locale = (0, $3f4303de28a7f3a7$var$_locale.default)(definition);
    module.exports.timeFormat = $3f4303de28a7f3a7$var$timeFormat = $3f4303de28a7f3a7$var$locale.format;
    module.exports.timeParse = $3f4303de28a7f3a7$var$timeParse = $3f4303de28a7f3a7$var$locale.parse;
    module.exports.utcFormat = $3f4303de28a7f3a7$var$utcFormat = $3f4303de28a7f3a7$var$locale.utcFormat;
    module.exports.utcParse = $3f4303de28a7f3a7$var$utcParse = $3f4303de28a7f3a7$var$locale.utcParse;
    return $3f4303de28a7f3a7$var$locale;
}

});
parcelRegister("jqC3T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e24df8495f9f296c$var$formatLocale;

var $cG9Fg = parcelRequire("cG9Fg");
function $e24df8495f9f296c$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $e24df8495f9f296c$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $e24df8495f9f296c$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $e24df8495f9f296c$var$formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $e24df8495f9f296c$var$formatRe(locale_periods), periodLookup = $e24df8495f9f296c$var$formatLookup(locale_periods), weekdayRe = $e24df8495f9f296c$var$formatRe(locale_weekdays), weekdayLookup = $e24df8495f9f296c$var$formatLookup(locale_weekdays), shortWeekdayRe = $e24df8495f9f296c$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $e24df8495f9f296c$var$formatLookup(locale_shortWeekdays), monthRe = $e24df8495f9f296c$var$formatRe(locale_months), monthLookup = $e24df8495f9f296c$var$formatLookup(locale_months), shortMonthRe = $e24df8495f9f296c$var$formatRe(locale_shortMonths), shortMonthLookup = $e24df8495f9f296c$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $e24df8495f9f296c$var$formatDayOfMonth,
        "e": $e24df8495f9f296c$var$formatDayOfMonth,
        "f": $e24df8495f9f296c$var$formatMicroseconds,
        "g": $e24df8495f9f296c$var$formatYearISO,
        "G": $e24df8495f9f296c$var$formatFullYearISO,
        "H": $e24df8495f9f296c$var$formatHour24,
        "I": $e24df8495f9f296c$var$formatHour12,
        "j": $e24df8495f9f296c$var$formatDayOfYear,
        "L": $e24df8495f9f296c$var$formatMilliseconds,
        "m": $e24df8495f9f296c$var$formatMonthNumber,
        "M": $e24df8495f9f296c$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $e24df8495f9f296c$var$formatUnixTimestamp,
        "s": $e24df8495f9f296c$var$formatUnixTimestampSeconds,
        "S": $e24df8495f9f296c$var$formatSeconds,
        "u": $e24df8495f9f296c$var$formatWeekdayNumberMonday,
        "U": $e24df8495f9f296c$var$formatWeekNumberSunday,
        "V": $e24df8495f9f296c$var$formatWeekNumberISO,
        "w": $e24df8495f9f296c$var$formatWeekdayNumberSunday,
        "W": $e24df8495f9f296c$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $e24df8495f9f296c$var$formatYear,
        "Y": $e24df8495f9f296c$var$formatFullYear,
        "Z": $e24df8495f9f296c$var$formatZone,
        "%": $e24df8495f9f296c$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $e24df8495f9f296c$var$formatUTCDayOfMonth,
        "e": $e24df8495f9f296c$var$formatUTCDayOfMonth,
        "f": $e24df8495f9f296c$var$formatUTCMicroseconds,
        "g": $e24df8495f9f296c$var$formatUTCYearISO,
        "G": $e24df8495f9f296c$var$formatUTCFullYearISO,
        "H": $e24df8495f9f296c$var$formatUTCHour24,
        "I": $e24df8495f9f296c$var$formatUTCHour12,
        "j": $e24df8495f9f296c$var$formatUTCDayOfYear,
        "L": $e24df8495f9f296c$var$formatUTCMilliseconds,
        "m": $e24df8495f9f296c$var$formatUTCMonthNumber,
        "M": $e24df8495f9f296c$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $e24df8495f9f296c$var$formatUnixTimestamp,
        "s": $e24df8495f9f296c$var$formatUnixTimestampSeconds,
        "S": $e24df8495f9f296c$var$formatUTCSeconds,
        "u": $e24df8495f9f296c$var$formatUTCWeekdayNumberMonday,
        "U": $e24df8495f9f296c$var$formatUTCWeekNumberSunday,
        "V": $e24df8495f9f296c$var$formatUTCWeekNumberISO,
        "w": $e24df8495f9f296c$var$formatUTCWeekdayNumberSunday,
        "W": $e24df8495f9f296c$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $e24df8495f9f296c$var$formatUTCYear,
        "Y": $e24df8495f9f296c$var$formatUTCFullYear,
        "Z": $e24df8495f9f296c$var$formatUTCZone,
        "%": $e24df8495f9f296c$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $e24df8495f9f296c$var$parseDayOfMonth,
        "e": $e24df8495f9f296c$var$parseDayOfMonth,
        "f": $e24df8495f9f296c$var$parseMicroseconds,
        "g": $e24df8495f9f296c$var$parseYear,
        "G": $e24df8495f9f296c$var$parseFullYear,
        "H": $e24df8495f9f296c$var$parseHour24,
        "I": $e24df8495f9f296c$var$parseHour24,
        "j": $e24df8495f9f296c$var$parseDayOfYear,
        "L": $e24df8495f9f296c$var$parseMilliseconds,
        "m": $e24df8495f9f296c$var$parseMonthNumber,
        "M": $e24df8495f9f296c$var$parseMinutes,
        "p": parsePeriod,
        "q": $e24df8495f9f296c$var$parseQuarter,
        "Q": $e24df8495f9f296c$var$parseUnixTimestamp,
        "s": $e24df8495f9f296c$var$parseUnixTimestampSeconds,
        "S": $e24df8495f9f296c$var$parseSeconds,
        "u": $e24df8495f9f296c$var$parseWeekdayNumberMonday,
        "U": $e24df8495f9f296c$var$parseWeekNumberSunday,
        "V": $e24df8495f9f296c$var$parseWeekNumberISO,
        "w": $e24df8495f9f296c$var$parseWeekdayNumberSunday,
        "W": $e24df8495f9f296c$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $e24df8495f9f296c$var$parseYear,
        "Y": $e24df8495f9f296c$var$parseFullYear,
        "Z": $e24df8495f9f296c$var$parseZone,
        "%": $e24df8495f9f296c$var$parseLiteralPercent
    }; // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $e24df8495f9f296c$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $e24df8495f9f296c$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null; // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0)); // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0; // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12; // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0; // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $e24df8495f9f296c$var$utcDate($e24df8495f9f296c$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? $cG9Fg.utcMonday.ceil(week) : (0, $cG9Fg.utcMonday)(week);
                    week = $cG9Fg.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $e24df8495f9f296c$var$localDate($e24df8495f9f296c$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? $cG9Fg.timeMonday.ceil(week) : (0, $cG9Fg.timeMonday)(week);
                    week = $cG9Fg.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $e24df8495f9f296c$var$utcDate($e24df8495f9f296c$var$newDate(d.y, 0, 1)).getUTCDay() : $e24df8495f9f296c$var$localDate($e24df8495f9f296c$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            } // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $e24df8495f9f296c$var$utcDate(d);
            } // Otherwise, all fields are in local time.
            return $e24df8495f9f296c$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $e24df8495f9f296c$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $e24df8495f9f296c$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $e24df8495f9f296c$var$numberRe = /^\s*\d+/, // note: ignores next directive
$e24df8495f9f296c$var$percentRe = /^%/, $e24df8495f9f296c$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $e24df8495f9f296c$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $e24df8495f9f296c$var$requote(s) {
    return s.replace($e24df8495f9f296c$var$requoteRe, "\\$&");
}
function $e24df8495f9f296c$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($e24df8495f9f296c$var$requote).join("|") + ")", "i");
}
function $e24df8495f9f296c$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $e24df8495f9f296c$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $e24df8495f9f296c$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $e24df8495f9f296c$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $e24df8495f9f296c$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $e24df8495f9f296c$var$parseWeekNumberSunday(d, string, i) {
    var n = $e24df8495f9f296c$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $e24df8495f9f296c$var$parseWeekNumberISO(d, string, i) {
    var n = $e24df8495f9f296c$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $e24df8495f9f296c$var$parseWeekNumberMonday(d, string, i) {
    var n = $e24df8495f9f296c$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $e24df8495f9f296c$var$parseFullYear(d, string, i) {
    var n = $e24df8495f9f296c$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $e24df8495f9f296c$var$parseYear(d, string, i) {
    var n = $e24df8495f9f296c$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $e24df8495f9f296c$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $e24df8495f9f296c$var$parseQuarter(d, string, i) {
    var n = $e24df8495f9f296c$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $e24df8495f9f296c$var$parseMonthNumber(d, string, i) {
    var n = $e24df8495f9f296c$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $e24df8495f9f296c$var$parseDayOfMonth(d, string, i) {
    var n = $e24df8495f9f296c$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $e24df8495f9f296c$var$parseDayOfYear(d, string, i) {
    var n = $e24df8495f9f296c$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $e24df8495f9f296c$var$parseHour24(d, string, i) {
    var n = $e24df8495f9f296c$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $e24df8495f9f296c$var$parseMinutes(d, string, i) {
    var n = $e24df8495f9f296c$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $e24df8495f9f296c$var$parseSeconds(d, string, i) {
    var n = $e24df8495f9f296c$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $e24df8495f9f296c$var$parseMilliseconds(d, string, i) {
    var n = $e24df8495f9f296c$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $e24df8495f9f296c$var$parseMicroseconds(d, string, i) {
    var n = $e24df8495f9f296c$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $e24df8495f9f296c$var$parseLiteralPercent(d, string, i) {
    var n = $e24df8495f9f296c$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $e24df8495f9f296c$var$parseUnixTimestamp(d, string, i) {
    var n = $e24df8495f9f296c$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $e24df8495f9f296c$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $e24df8495f9f296c$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $e24df8495f9f296c$var$formatDayOfMonth(d, p) {
    return $e24df8495f9f296c$var$pad(d.getDate(), p, 2);
}
function $e24df8495f9f296c$var$formatHour24(d, p) {
    return $e24df8495f9f296c$var$pad(d.getHours(), p, 2);
}
function $e24df8495f9f296c$var$formatHour12(d, p) {
    return $e24df8495f9f296c$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $e24df8495f9f296c$var$formatDayOfYear(d, p) {
    return $e24df8495f9f296c$var$pad(1 + $cG9Fg.timeDay.count((0, $cG9Fg.timeYear)(d), d), p, 3);
}
function $e24df8495f9f296c$var$formatMilliseconds(d, p) {
    return $e24df8495f9f296c$var$pad(d.getMilliseconds(), p, 3);
}
function $e24df8495f9f296c$var$formatMicroseconds(d, p) {
    return $e24df8495f9f296c$var$formatMilliseconds(d, p) + "000";
}
function $e24df8495f9f296c$var$formatMonthNumber(d, p) {
    return $e24df8495f9f296c$var$pad(d.getMonth() + 1, p, 2);
}
function $e24df8495f9f296c$var$formatMinutes(d, p) {
    return $e24df8495f9f296c$var$pad(d.getMinutes(), p, 2);
}
function $e24df8495f9f296c$var$formatSeconds(d, p) {
    return $e24df8495f9f296c$var$pad(d.getSeconds(), p, 2);
}
function $e24df8495f9f296c$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $e24df8495f9f296c$var$formatWeekNumberSunday(d, p) {
    return $e24df8495f9f296c$var$pad($cG9Fg.timeSunday.count((0, $cG9Fg.timeYear)(d) - 1, d), p, 2);
}
function $e24df8495f9f296c$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $cG9Fg.timeThursday)(d) : $cG9Fg.timeThursday.ceil(d);
}
function $e24df8495f9f296c$var$formatWeekNumberISO(d, p) {
    d = $e24df8495f9f296c$var$dISO(d);
    return $e24df8495f9f296c$var$pad($cG9Fg.timeThursday.count((0, $cG9Fg.timeYear)(d), d) + ((0, $cG9Fg.timeYear)(d).getDay() === 4), p, 2);
}
function $e24df8495f9f296c$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $e24df8495f9f296c$var$formatWeekNumberMonday(d, p) {
    return $e24df8495f9f296c$var$pad($cG9Fg.timeMonday.count((0, $cG9Fg.timeYear)(d) - 1, d), p, 2);
}
function $e24df8495f9f296c$var$formatYear(d, p) {
    return $e24df8495f9f296c$var$pad(d.getFullYear() % 100, p, 2);
}
function $e24df8495f9f296c$var$formatYearISO(d, p) {
    d = $e24df8495f9f296c$var$dISO(d);
    return $e24df8495f9f296c$var$pad(d.getFullYear() % 100, p, 2);
}
function $e24df8495f9f296c$var$formatFullYear(d, p) {
    return $e24df8495f9f296c$var$pad(d.getFullYear() % 10000, p, 4);
}
function $e24df8495f9f296c$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $cG9Fg.timeThursday)(d) : $cG9Fg.timeThursday.ceil(d);
    return $e24df8495f9f296c$var$pad(d.getFullYear() % 10000, p, 4);
}
function $e24df8495f9f296c$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $e24df8495f9f296c$var$pad(z / 60 | 0, "0", 2) + $e24df8495f9f296c$var$pad(z % 60, "0", 2);
}
function $e24df8495f9f296c$var$formatUTCDayOfMonth(d, p) {
    return $e24df8495f9f296c$var$pad(d.getUTCDate(), p, 2);
}
function $e24df8495f9f296c$var$formatUTCHour24(d, p) {
    return $e24df8495f9f296c$var$pad(d.getUTCHours(), p, 2);
}
function $e24df8495f9f296c$var$formatUTCHour12(d, p) {
    return $e24df8495f9f296c$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $e24df8495f9f296c$var$formatUTCDayOfYear(d, p) {
    return $e24df8495f9f296c$var$pad(1 + $cG9Fg.utcDay.count((0, $cG9Fg.utcYear)(d), d), p, 3);
}
function $e24df8495f9f296c$var$formatUTCMilliseconds(d, p) {
    return $e24df8495f9f296c$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $e24df8495f9f296c$var$formatUTCMicroseconds(d, p) {
    return $e24df8495f9f296c$var$formatUTCMilliseconds(d, p) + "000";
}
function $e24df8495f9f296c$var$formatUTCMonthNumber(d, p) {
    return $e24df8495f9f296c$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $e24df8495f9f296c$var$formatUTCMinutes(d, p) {
    return $e24df8495f9f296c$var$pad(d.getUTCMinutes(), p, 2);
}
function $e24df8495f9f296c$var$formatUTCSeconds(d, p) {
    return $e24df8495f9f296c$var$pad(d.getUTCSeconds(), p, 2);
}
function $e24df8495f9f296c$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $e24df8495f9f296c$var$formatUTCWeekNumberSunday(d, p) {
    return $e24df8495f9f296c$var$pad($cG9Fg.utcSunday.count((0, $cG9Fg.utcYear)(d) - 1, d), p, 2);
}
function $e24df8495f9f296c$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $cG9Fg.utcThursday)(d) : $cG9Fg.utcThursday.ceil(d);
}
function $e24df8495f9f296c$var$formatUTCWeekNumberISO(d, p) {
    d = $e24df8495f9f296c$var$UTCdISO(d);
    return $e24df8495f9f296c$var$pad($cG9Fg.utcThursday.count((0, $cG9Fg.utcYear)(d), d) + ((0, $cG9Fg.utcYear)(d).getUTCDay() === 4), p, 2);
}
function $e24df8495f9f296c$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $e24df8495f9f296c$var$formatUTCWeekNumberMonday(d, p) {
    return $e24df8495f9f296c$var$pad($cG9Fg.utcMonday.count((0, $cG9Fg.utcYear)(d) - 1, d), p, 2);
}
function $e24df8495f9f296c$var$formatUTCYear(d, p) {
    return $e24df8495f9f296c$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $e24df8495f9f296c$var$formatUTCYearISO(d, p) {
    d = $e24df8495f9f296c$var$UTCdISO(d);
    return $e24df8495f9f296c$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $e24df8495f9f296c$var$formatUTCFullYear(d, p) {
    return $e24df8495f9f296c$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $e24df8495f9f296c$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $cG9Fg.utcThursday)(d) : $cG9Fg.utcThursday.ceil(d);
    return $e24df8495f9f296c$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $e24df8495f9f296c$var$formatUTCZone() {
    return "+0000";
}
function $e24df8495f9f296c$var$formatLiteralPercent() {
    return "%";
}
function $e24df8495f9f296c$var$formatUnixTimestamp(d) {
    return +d;
}
function $e24df8495f9f296c$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

});


parcelRegister("2JVK7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isoSpecifier = module.exports.default = void 0;

var $5qJWf = parcelRequire("5qJWf");
var $1fec93437e38ae55$var$isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
module.exports.isoSpecifier = $1fec93437e38ae55$var$isoSpecifier;
function $1fec93437e38ae55$var$formatIsoNative(date) {
    return date.toISOString();
}
var $1fec93437e38ae55$var$formatIso = Date.prototype.toISOString ? $1fec93437e38ae55$var$formatIsoNative : (0, $5qJWf.utcFormat)($1fec93437e38ae55$var$isoSpecifier);
var $1fec93437e38ae55$var$_default = $1fec93437e38ae55$var$formatIso;
module.exports.default = $1fec93437e38ae55$var$_default;

});

parcelRegister("gcSOZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2JVK7 = parcelRequire("2JVK7");

var $5qJWf = parcelRequire("5qJWf");
function $bcc84ab676ca07e2$var$parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var $bcc84ab676ca07e2$var$parseIso = +new Date("2000-01-01T00:00:00.000Z") ? $bcc84ab676ca07e2$var$parseIsoNative : (0, $5qJWf.utcParse)($2JVK7.isoSpecifier);
var $bcc84ab676ca07e2$var$_default = $bcc84ab676ca07e2$var$parseIso;
module.exports.default = $bcc84ab676ca07e2$var$_default;

});



parcelRegister("8yK0I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $63b5306c52accd88$var$utcTime;

var $cG9Fg = parcelRequire("cG9Fg");

var $gEGZa = parcelRequire("gEGZa");

var $homkz = parcelRequire("homkz");

var $cnxlJ = parcelRequire("cnxlJ");
function $63b5306c52accd88$var$utcTime() {
    return $cnxlJ.initRange.apply((0, $homkz.calendar)($cG9Fg.utcTicks, $cG9Fg.utcTickInterval, $cG9Fg.utcYear, $cG9Fg.utcMonth, $cG9Fg.utcWeek, $cG9Fg.utcDay, $cG9Fg.utcHour, $cG9Fg.utcMinute, $cG9Fg.utcSecond, $gEGZa.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

});

parcelRegister("4NPLE", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.copy = $37f3e4f8a1420789$var$copy;
module.exports.default = $37f3e4f8a1420789$var$sequential;
module.exports.sequentialLog = $37f3e4f8a1420789$var$sequentialLog;
module.exports.sequentialPow = $37f3e4f8a1420789$var$sequentialPow;
module.exports.sequentialSqrt = $37f3e4f8a1420789$var$sequentialSqrt;
module.exports.sequentialSymlog = $37f3e4f8a1420789$var$sequentialSymlog;

var $l4R94 = parcelRequire("l4R94");

var $1r8KC = parcelRequire("1r8KC");

var $cnxlJ = parcelRequire("cnxlJ");

var $ilLMd = parcelRequire("ilLMd");

var $2kaib = parcelRequire("2kaib");

var $61Ei9 = parcelRequire("61Ei9");

var $fBfC8 = parcelRequire("fBfC8");
function $37f3e4f8a1420789$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = $1r8KC.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range($l4R94.interpolate);
    scale.rangeRound = range($l4R94.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $37f3e4f8a1420789$var$copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $37f3e4f8a1420789$var$sequential() {
    var scale = (0, $ilLMd.linearish)($37f3e4f8a1420789$var$transformer()($1r8KC.identity));
    scale.copy = function() {
        return $37f3e4f8a1420789$var$copy(scale, $37f3e4f8a1420789$var$sequential());
    };
    return $cnxlJ.initInterpolator.apply(scale, arguments);
}
function $37f3e4f8a1420789$var$sequentialLog() {
    var scale = (0, $2kaib.loggish)($37f3e4f8a1420789$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $37f3e4f8a1420789$var$copy(scale, $37f3e4f8a1420789$var$sequentialLog()).base(scale.base());
    };
    return $cnxlJ.initInterpolator.apply(scale, arguments);
}
function $37f3e4f8a1420789$var$sequentialSymlog() {
    var scale = (0, $61Ei9.symlogish)($37f3e4f8a1420789$var$transformer());
    scale.copy = function() {
        return $37f3e4f8a1420789$var$copy(scale, $37f3e4f8a1420789$var$sequentialSymlog()).constant(scale.constant());
    };
    return $cnxlJ.initInterpolator.apply(scale, arguments);
}
function $37f3e4f8a1420789$var$sequentialPow() {
    var scale = (0, $fBfC8.powish)($37f3e4f8a1420789$var$transformer());
    scale.copy = function() {
        return $37f3e4f8a1420789$var$copy(scale, $37f3e4f8a1420789$var$sequentialPow()).exponent(scale.exponent());
    };
    return $cnxlJ.initInterpolator.apply(scale, arguments);
}
function $37f3e4f8a1420789$var$sequentialSqrt() {
    return $37f3e4f8a1420789$var$sequentialPow.apply(null, arguments).exponent(0.5);
}

});

parcelRegister("iz6Gb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $d840ad487ca819e1$var$sequentialQuantile;

var $7oz1V = parcelRequire("7oz1V");

var $1r8KC = parcelRequire("1r8KC");

var $cnxlJ = parcelRequire("cnxlJ");
function $d840ad487ca819e1$var$sequentialQuantile() {
    var domain = [], interpolator = $1r8KC.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $7oz1V.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort($7oz1V.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $7oz1V.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return $d840ad487ca819e1$var$sequentialQuantile(interpolator).domain(domain);
    };
    return $cnxlJ.initInterpolator.apply(scale, arguments);
}

});

parcelRegister("fM0bR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b7bb7c7bd58ce533$var$diverging;
module.exports.divergingLog = $b7bb7c7bd58ce533$var$divergingLog;
module.exports.divergingPow = $b7bb7c7bd58ce533$var$divergingPow;
module.exports.divergingSqrt = $b7bb7c7bd58ce533$var$divergingSqrt;
module.exports.divergingSymlog = $b7bb7c7bd58ce533$var$divergingSymlog;

var $l4R94 = parcelRequire("l4R94");

var $1r8KC = parcelRequire("1r8KC");

var $cnxlJ = parcelRequire("cnxlJ");

var $ilLMd = parcelRequire("ilLMd");

var $2kaib = parcelRequire("2kaib");

var $4NPLE = parcelRequire("4NPLE");

var $61Ei9 = parcelRequire("61Ei9");

var $fBfC8 = parcelRequire("fBfC8");
function $b7bb7c7bd58ce533$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = $1r8KC.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $l4R94.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range($l4R94.interpolate);
    scale.rangeRound = range($l4R94.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $b7bb7c7bd58ce533$var$diverging() {
    var scale = (0, $ilLMd.linearish)($b7bb7c7bd58ce533$var$transformer()($1r8KC.identity));
    scale.copy = function() {
        return (0, $4NPLE.copy)(scale, $b7bb7c7bd58ce533$var$diverging());
    };
    return $cnxlJ.initInterpolator.apply(scale, arguments);
}
function $b7bb7c7bd58ce533$var$divergingLog() {
    var scale = (0, $2kaib.loggish)($b7bb7c7bd58ce533$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $4NPLE.copy)(scale, $b7bb7c7bd58ce533$var$divergingLog()).base(scale.base());
    };
    return $cnxlJ.initInterpolator.apply(scale, arguments);
}
function $b7bb7c7bd58ce533$var$divergingSymlog() {
    var scale = (0, $61Ei9.symlogish)($b7bb7c7bd58ce533$var$transformer());
    scale.copy = function() {
        return (0, $4NPLE.copy)(scale, $b7bb7c7bd58ce533$var$divergingSymlog()).constant(scale.constant());
    };
    return $cnxlJ.initInterpolator.apply(scale, arguments);
}
function $b7bb7c7bd58ce533$var$divergingPow() {
    var scale = (0, $fBfC8.powish)($b7bb7c7bd58ce533$var$transformer());
    scale.copy = function() {
        return (0, $4NPLE.copy)(scale, $b7bb7c7bd58ce533$var$divergingPow()).exponent(scale.exponent());
    };
    return $cnxlJ.initInterpolator.apply(scale, arguments);
}
function $b7bb7c7bd58ce533$var$divergingSqrt() {
    return $b7bb7c7bd58ce533$var$divergingPow.apply(null, arguments).exponent(0.5);
}

});



parcelRegister("9gQ5u", function(module, exports) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`

module.exports = (parcelRequire("glIUp"));

});
parcelRegister("glIUp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "arc", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_arc.default;
    }
});
Object.defineProperty(module.exports, "area", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_area.default;
    }
});
Object.defineProperty(module.exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_basis.default;
    }
});
Object.defineProperty(module.exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_basisClosed.default;
    }
});
Object.defineProperty(module.exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_basisOpen.default;
    }
});
Object.defineProperty(module.exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return $egTfv.bumpX;
    }
});
Object.defineProperty(module.exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return $egTfv.bumpY;
    }
});
Object.defineProperty(module.exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_bundle.default;
    }
});
Object.defineProperty(module.exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_cardinal.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_cardinalClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_cardinalOpen.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_catmullRom.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_catmullRomClosed.default;
    }
});
Object.defineProperty(module.exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_catmullRomOpen.default;
    }
});
Object.defineProperty(module.exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_linear.default;
    }
});
Object.defineProperty(module.exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_linearClosed.default;
    }
});
Object.defineProperty(module.exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return $3AoEL.monotoneX;
    }
});
Object.defineProperty(module.exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return $3AoEL.monotoneY;
    }
});
Object.defineProperty(module.exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_natural.default;
    }
});
Object.defineProperty(module.exports, "curveStep", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_step.default;
    }
});
Object.defineProperty(module.exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_step.stepAfter;
    }
});
Object.defineProperty(module.exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_step.stepBefore;
    }
});
Object.defineProperty(module.exports, "line", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_line.default;
    }
});
Object.defineProperty(module.exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "link", {
    enumerable: true,
    get: function() {
        return $eQZCT.link;
    }
});
Object.defineProperty(module.exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return $eQZCT.linkHorizontal;
    }
});
Object.defineProperty(module.exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return $eQZCT.linkRadial;
    }
});
Object.defineProperty(module.exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return $eQZCT.linkVertical;
    }
});
Object.defineProperty(module.exports, "pie", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_pie.default;
    }
});
Object.defineProperty(module.exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_pointRadial.default;
    }
});
Object.defineProperty(module.exports, "radialArea", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_areaRadial.default;
    }
});
Object.defineProperty(module.exports, "radialLine", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_lineRadial.default;
    }
});
Object.defineProperty(module.exports, "stack", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_stack.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_diverging.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_expand.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_none.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_silhouette.default;
    }
});
Object.defineProperty(module.exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_wiggle.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_appearance.default;
    }
});
Object.defineProperty(module.exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_ascending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_descending.default;
    }
});
Object.defineProperty(module.exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_insideOut.default;
    }
});
Object.defineProperty(module.exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_none2.default;
    }
});
Object.defineProperty(module.exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_reverse.default;
    }
});
Object.defineProperty(module.exports, "symbol", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_symbol.default;
    }
});
Object.defineProperty(module.exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_asterisk.default;
    }
});
Object.defineProperty(module.exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_circle.default;
    }
});
Object.defineProperty(module.exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_cross.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_diamond.default;
    }
});
Object.defineProperty(module.exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_diamond2.default;
    }
});
Object.defineProperty(module.exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_plus.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_square.default;
    }
});
Object.defineProperty(module.exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_square2.default;
    }
});
Object.defineProperty(module.exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_star.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_triangle.default;
    }
});
Object.defineProperty(module.exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_triangle2.default;
    }
});
Object.defineProperty(module.exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_wye.default;
    }
});
Object.defineProperty(module.exports, "symbolX", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_x.default;
    }
});
Object.defineProperty(module.exports, "symbols", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_symbol.symbolsFill;
    }
});
Object.defineProperty(module.exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return $be71717772be5077$var$_symbol.symbolsStroke;
    }
});

var $be71717772be5077$var$_arc = $be71717772be5077$var$_interopRequireDefault((parcelRequire("4LVgs")));

var $be71717772be5077$var$_area = $be71717772be5077$var$_interopRequireDefault((parcelRequire("jGJmF")));

var $be71717772be5077$var$_line = $be71717772be5077$var$_interopRequireDefault((parcelRequire("fDRrB")));

var $be71717772be5077$var$_pie = $be71717772be5077$var$_interopRequireDefault((parcelRequire("6wwBA")));

var $be71717772be5077$var$_areaRadial = $be71717772be5077$var$_interopRequireDefault((parcelRequire("2Ey3I")));

var $be71717772be5077$var$_lineRadial = $be71717772be5077$var$_interopRequireDefault((parcelRequire("hG4jk")));

var $be71717772be5077$var$_pointRadial = $be71717772be5077$var$_interopRequireDefault((parcelRequire("jgyB7")));

var $eQZCT = parcelRequire("eQZCT");

var $be71717772be5077$var$_symbol = $be71717772be5077$var$_interopRequireWildcard((parcelRequire("7xgxt")));

var $be71717772be5077$var$_asterisk = $be71717772be5077$var$_interopRequireDefault((parcelRequire("jRdv1")));

var $be71717772be5077$var$_circle = $be71717772be5077$var$_interopRequireDefault((parcelRequire("l37A6")));

var $be71717772be5077$var$_cross = $be71717772be5077$var$_interopRequireDefault((parcelRequire("5Dm0p")));

var $be71717772be5077$var$_diamond = $be71717772be5077$var$_interopRequireDefault((parcelRequire("lRWXg")));

var $be71717772be5077$var$_diamond2 = $be71717772be5077$var$_interopRequireDefault((parcelRequire("4CGNx")));

var $be71717772be5077$var$_plus = $be71717772be5077$var$_interopRequireDefault((parcelRequire("4jvEH")));

var $be71717772be5077$var$_square = $be71717772be5077$var$_interopRequireDefault((parcelRequire("8TJlG")));

var $be71717772be5077$var$_square2 = $be71717772be5077$var$_interopRequireDefault((parcelRequire("klSdz")));

var $be71717772be5077$var$_star = $be71717772be5077$var$_interopRequireDefault((parcelRequire("ajHqS")));

var $be71717772be5077$var$_triangle = $be71717772be5077$var$_interopRequireDefault((parcelRequire("8FPIT")));

var $be71717772be5077$var$_triangle2 = $be71717772be5077$var$_interopRequireDefault((parcelRequire("2IW6k")));

var $be71717772be5077$var$_wye = $be71717772be5077$var$_interopRequireDefault((parcelRequire("apdcI")));

var $be71717772be5077$var$_x = $be71717772be5077$var$_interopRequireDefault((parcelRequire("f61PF")));

var $be71717772be5077$var$_basisClosed = $be71717772be5077$var$_interopRequireDefault((parcelRequire("3G3L1")));

var $be71717772be5077$var$_basisOpen = $be71717772be5077$var$_interopRequireDefault((parcelRequire("3DIUN")));

var $be71717772be5077$var$_basis = $be71717772be5077$var$_interopRequireDefault((parcelRequire("cIyrO")));

var $egTfv = parcelRequire("egTfv");

var $be71717772be5077$var$_bundle = $be71717772be5077$var$_interopRequireDefault((parcelRequire("kEF43")));

var $be71717772be5077$var$_cardinalClosed = $be71717772be5077$var$_interopRequireDefault((parcelRequire("hmBmP")));

var $be71717772be5077$var$_cardinalOpen = $be71717772be5077$var$_interopRequireDefault((parcelRequire("juaVp")));

var $be71717772be5077$var$_cardinal = $be71717772be5077$var$_interopRequireDefault((parcelRequire("li6bm")));

var $be71717772be5077$var$_catmullRomClosed = $be71717772be5077$var$_interopRequireDefault((parcelRequire("erhKv")));

var $be71717772be5077$var$_catmullRomOpen = $be71717772be5077$var$_interopRequireDefault((parcelRequire("kvuJI")));

var $be71717772be5077$var$_catmullRom = $be71717772be5077$var$_interopRequireDefault((parcelRequire("aIMmt")));

var $be71717772be5077$var$_linearClosed = $be71717772be5077$var$_interopRequireDefault((parcelRequire("4fMoA")));

var $be71717772be5077$var$_linear = $be71717772be5077$var$_interopRequireDefault((parcelRequire("gDD8Z")));

var $3AoEL = parcelRequire("3AoEL");

var $be71717772be5077$var$_natural = $be71717772be5077$var$_interopRequireDefault((parcelRequire("eajCr")));

var $be71717772be5077$var$_step = $be71717772be5077$var$_interopRequireWildcard((parcelRequire("kjkb7")));

var $be71717772be5077$var$_stack = $be71717772be5077$var$_interopRequireDefault((parcelRequire("fIEUP")));

var $be71717772be5077$var$_expand = $be71717772be5077$var$_interopRequireDefault((parcelRequire("hcCuQ")));

var $be71717772be5077$var$_diverging = $be71717772be5077$var$_interopRequireDefault((parcelRequire("yz6WP")));

var $be71717772be5077$var$_none = $be71717772be5077$var$_interopRequireDefault((parcelRequire("eUvdQ")));

var $be71717772be5077$var$_silhouette = $be71717772be5077$var$_interopRequireDefault((parcelRequire("c6evC")));

var $be71717772be5077$var$_wiggle = $be71717772be5077$var$_interopRequireDefault((parcelRequire("7dGWK")));

var $be71717772be5077$var$_appearance = $be71717772be5077$var$_interopRequireDefault((parcelRequire("34SOV")));

var $be71717772be5077$var$_ascending = $be71717772be5077$var$_interopRequireDefault((parcelRequire("2h66Z")));

var $be71717772be5077$var$_descending = $be71717772be5077$var$_interopRequireDefault((parcelRequire("l6ybI")));

var $be71717772be5077$var$_insideOut = $be71717772be5077$var$_interopRequireDefault((parcelRequire("hdLxD")));

var $be71717772be5077$var$_none2 = $be71717772be5077$var$_interopRequireDefault((parcelRequire("8wW3N")));

var $be71717772be5077$var$_reverse = $be71717772be5077$var$_interopRequireDefault((parcelRequire("9ciyJ")));
function $be71717772be5077$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($be71717772be5077$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $be71717772be5077$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $be71717772be5077$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $be71717772be5077$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("4LVgs", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $3797f8bcb32456ae$var$_default;

var $49nWa = parcelRequire("49nWa");

var $3797f8bcb32456ae$var$_constant = $3797f8bcb32456ae$var$_interopRequireDefault((parcelRequire("3Fk9S")));

var $eG4Si = parcelRequire("eG4Si");
function $3797f8bcb32456ae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $3797f8bcb32456ae$var$arcInnerRadius(d) {
    return d.innerRadius;
}
function $3797f8bcb32456ae$var$arcOuterRadius(d) {
    return d.outerRadius;
}
function $3797f8bcb32456ae$var$arcStartAngle(d) {
    return d.startAngle;
}
function $3797f8bcb32456ae$var$arcEndAngle(d) {
    return d.endAngle;
}
function $3797f8bcb32456ae$var$arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function $3797f8bcb32456ae$var$intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < $eG4Si.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
} // Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function $3797f8bcb32456ae$var$cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, $eG4Si.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, $eG4Si.sqrt)((0, $eG4Si.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00; // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function $3797f8bcb32456ae$var$_default() {
    var innerRadius = $3797f8bcb32456ae$var$arcInnerRadius, outerRadius = $3797f8bcb32456ae$var$arcOuterRadius, cornerRadius = (0, $3797f8bcb32456ae$var$_constant.default)(0), padRadius = null, startAngle = $3797f8bcb32456ae$var$arcStartAngle, endAngle = $3797f8bcb32456ae$var$arcEndAngle, padAngle = $3797f8bcb32456ae$var$arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - $eG4Si.halfPi, a1 = endAngle.apply(this, arguments) - $eG4Si.halfPi, da = (0, $eG4Si.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, $49nWa.path)(); // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r; // Is it a point?
        if (!(r1 > $eG4Si.epsilon)) context.moveTo(0, 0); // Or is it a circle or annulus?
        else if (da > $eG4Si.tau - $eG4Si.epsilon) {
            context.moveTo(r1 * (0, $eG4Si.cos)(a0), r1 * (0, $eG4Si.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > $eG4Si.epsilon) {
                context.moveTo(r0 * (0, $eG4Si.cos)(a1), r0 * (0, $eG4Si.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > $eG4Si.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, $eG4Si.sqrt)(r0 * r0 + r1 * r1)), rc = (0, $eG4Si.min)((0, $eG4Si.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1; // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > $eG4Si.epsilon) {
                var p0 = (0, $eG4Si.asin)(rp / r0 * (0, $eG4Si.sin)(ap)), p1 = (0, $eG4Si.asin)(rp / r1 * (0, $eG4Si.sin)(ap));
                if ((da0 -= p0 * 2) > $eG4Si.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > $eG4Si.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, $eG4Si.cos)(a01), y01 = r1 * (0, $eG4Si.sin)(a01), x10 = r0 * (0, $eG4Si.cos)(a10), y10 = r0 * (0, $eG4Si.sin)(a10); // Apply rounded corners?
            if (rc > $eG4Si.epsilon) {
                var x11 = r1 * (0, $eG4Si.cos)(a11), y11 = r1 * (0, $eG4Si.sin)(a11), x00 = r0 * (0, $eG4Si.cos)(a00), y00 = r0 * (0, $eG4Si.sin)(a00), oc; // Restrict the corner radius according to the sector angle.
                if (da < $eG4Si.pi && (oc = $3797f8bcb32456ae$var$intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, $eG4Si.sin)((0, $eG4Si.acos)((ax * bx + ay * by) / ((0, $eG4Si.sqrt)(ax * ax + ay * ay) * (0, $eG4Si.sqrt)(bx * bx + by * by))) / 2), lc = (0, $eG4Si.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, $eG4Si.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, $eG4Si.min)(rc, (r1 - lc) / (kc + 1));
                }
            } // Is the sector collapsed to a line?
            if (!(da1 > $eG4Si.epsilon)) context.moveTo(x01, y01); // Does the sector’s outer ring have rounded corners?
            else if (rc1 > $eG4Si.epsilon) {
                t0 = $3797f8bcb32456ae$var$cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = $3797f8bcb32456ae$var$cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, $eG4Si.atan2)(t0.y01, t0.x01), (0, $eG4Si.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, $eG4Si.atan2)(t0.y01, t0.x01), (0, $eG4Si.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, $eG4Si.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $eG4Si.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, $eG4Si.atan2)(t1.y11, t1.x11), (0, $eG4Si.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw); // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > $eG4Si.epsilon) || !(da0 > $eG4Si.epsilon)) context.lineTo(x10, y10); // Does the sector’s inner ring (or point) have rounded corners?
            else if (rc0 > $eG4Si.epsilon) {
                t0 = $3797f8bcb32456ae$var$cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = $3797f8bcb32456ae$var$cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01); // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, $eG4Si.atan2)(t0.y01, t0.x01), (0, $eG4Si.atan2)(t1.y01, t1.x01), !cw); // Otherwise, draw the two corners and the ring.
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, $eG4Si.atan2)(t0.y01, t0.x01), (0, $eG4Si.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, $eG4Si.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, $eG4Si.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, $eG4Si.atan2)(t1.y11, t1.x11), (0, $eG4Si.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - $eG4Si.pi / 2;
        return [
            (0, $eG4Si.cos)(a) * r,
            (0, $eG4Si.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, $3797f8bcb32456ae$var$_constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, $3797f8bcb32456ae$var$_constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, $3797f8bcb32456ae$var$_constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, $3797f8bcb32456ae$var$_constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $3797f8bcb32456ae$var$_constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $3797f8bcb32456ae$var$_constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $3797f8bcb32456ae$var$_constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

});
parcelRegister("49nWa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "path", {
    enumerable: true,
    get: function() {
        return $305a921cadacc8d9$var$_path.default;
    }
});

var $305a921cadacc8d9$var$_path = $305a921cadacc8d9$var$_interopRequireDefault((parcelRequire("hJNYg")));
function $305a921cadacc8d9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("hJNYg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
const $ce9d66dcd9fac214$var$pi = Math.PI, $ce9d66dcd9fac214$var$tau = 2 * $ce9d66dcd9fac214$var$pi, $ce9d66dcd9fac214$var$epsilon = 1e-6, $ce9d66dcd9fac214$var$tauEpsilon = $ce9d66dcd9fac214$var$tau - $ce9d66dcd9fac214$var$epsilon;
function $ce9d66dcd9fac214$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $ce9d66dcd9fac214$var$path() {
    return new $ce9d66dcd9fac214$var$Path();
}
$ce9d66dcd9fac214$var$Path.prototype = $ce9d66dcd9fac214$var$path.prototype = {
    constructor: $ce9d66dcd9fac214$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $ce9d66dcd9fac214$var$epsilon)) ; // Or, are (x0,y0), (x1,y1) and (x2,y2) collinear?
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $ce9d66dcd9fac214$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($ce9d66dcd9fac214$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21; // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $ce9d66dcd9fac214$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0; // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r); // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $ce9d66dcd9fac214$var$epsilon || Math.abs(this._y1 - y0) > $ce9d66dcd9fac214$var$epsilon) this._ += "L" + x0 + "," + y0;
         // Is this arc empty? We’re done.
        if (!r) return; // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $ce9d66dcd9fac214$var$tau + $ce9d66dcd9fac214$var$tau; // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $ce9d66dcd9fac214$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $ce9d66dcd9fac214$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $ce9d66dcd9fac214$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $ce9d66dcd9fac214$var$_default = $ce9d66dcd9fac214$var$path;
module.exports.default = $ce9d66dcd9fac214$var$_default;

});


parcelRegister("3Fk9S", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2ab4d67735e7b222$var$_default;
function $2ab4d67735e7b222$var$_default(x) {
    return function constant() {
        return x;
    };
}

});

parcelRegister("eG4Si", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.abs = void 0;
module.exports.acos = $aaf8c4f8c9e03476$var$acos;
module.exports.asin = $aaf8c4f8c9e03476$var$asin;
module.exports.tau = module.exports.sqrt = module.exports.sin = module.exports.pi = module.exports.min = module.exports.max = module.exports.halfPi = module.exports.epsilon = module.exports.cos = module.exports.atan2 = void 0;
const $aaf8c4f8c9e03476$var$abs = Math.abs;
module.exports.abs = $aaf8c4f8c9e03476$var$abs;
const $aaf8c4f8c9e03476$var$atan2 = Math.atan2;
module.exports.atan2 = $aaf8c4f8c9e03476$var$atan2;
const $aaf8c4f8c9e03476$var$cos = Math.cos;
module.exports.cos = $aaf8c4f8c9e03476$var$cos;
const $aaf8c4f8c9e03476$var$max = Math.max;
module.exports.max = $aaf8c4f8c9e03476$var$max;
const $aaf8c4f8c9e03476$var$min = Math.min;
module.exports.min = $aaf8c4f8c9e03476$var$min;
const $aaf8c4f8c9e03476$var$sin = Math.sin;
module.exports.sin = $aaf8c4f8c9e03476$var$sin;
const $aaf8c4f8c9e03476$var$sqrt = Math.sqrt;
module.exports.sqrt = $aaf8c4f8c9e03476$var$sqrt;
const $aaf8c4f8c9e03476$var$epsilon = 1e-12;
module.exports.epsilon = $aaf8c4f8c9e03476$var$epsilon;
const $aaf8c4f8c9e03476$var$pi = Math.PI;
module.exports.pi = $aaf8c4f8c9e03476$var$pi;
const $aaf8c4f8c9e03476$var$halfPi = $aaf8c4f8c9e03476$var$pi / 2;
module.exports.halfPi = $aaf8c4f8c9e03476$var$halfPi;
const $aaf8c4f8c9e03476$var$tau = 2 * $aaf8c4f8c9e03476$var$pi;
module.exports.tau = $aaf8c4f8c9e03476$var$tau;
function $aaf8c4f8c9e03476$var$acos(x) {
    return x > 1 ? 0 : x < -1 ? $aaf8c4f8c9e03476$var$pi : Math.acos(x);
}
function $aaf8c4f8c9e03476$var$asin(x) {
    return x >= 1 ? $aaf8c4f8c9e03476$var$halfPi : x <= -1 ? -$aaf8c4f8c9e03476$var$halfPi : Math.asin(x);
}

});


parcelRegister("jGJmF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e555210892573226$var$_default;

var $49nWa = parcelRequire("49nWa");

var $e555210892573226$var$_array = $e555210892573226$var$_interopRequireDefault((parcelRequire("7sroj")));

var $e555210892573226$var$_constant = $e555210892573226$var$_interopRequireDefault((parcelRequire("3Fk9S")));

var $e555210892573226$var$_linear = $e555210892573226$var$_interopRequireDefault((parcelRequire("gDD8Z")));

var $e555210892573226$var$_line = $e555210892573226$var$_interopRequireDefault((parcelRequire("fDRrB")));

var $gGwfH = parcelRequire("gGwfH");
function $e555210892573226$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e555210892573226$var$_default(x0, y0, y1) {
    var x1 = null, defined = (0, $e555210892573226$var$_constant.default)(true), context = null, curve = $e555210892573226$var$_linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? $gGwfH.x : (0, $e555210892573226$var$_constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $e555210892573226$var$_constant.default)(0) : (0, $e555210892573226$var$_constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? $gGwfH.y : (0, $e555210892573226$var$_constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $e555210892573226$var$_array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $49nWa.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $e555210892573226$var$_line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $e555210892573226$var$_constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $e555210892573226$var$_constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $e555210892573226$var$_constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $e555210892573226$var$_constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $e555210892573226$var$_constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $e555210892573226$var$_constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $e555210892573226$var$_constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

});
parcelRegister("7sroj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $56e06541a8bee17b$var$_default;
module.exports.slice = void 0;
var $56e06541a8bee17b$var$slice = Array.prototype.slice;
module.exports.slice = $56e06541a8bee17b$var$slice;
function $56e06541a8bee17b$var$_default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

});

parcelRegister("gDD8Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c1cea7050b22f74c$var$_default;
function $c1cea7050b22f74c$var$Linear(context) {
    this._context = context;
}
$c1cea7050b22f74c$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $c1cea7050b22f74c$var$_default(context) {
    return new $c1cea7050b22f74c$var$Linear(context);
}

});

parcelRegister("fDRrB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b633f46b198cd600$var$_default;

var $49nWa = parcelRequire("49nWa");

var $b633f46b198cd600$var$_array = $b633f46b198cd600$var$_interopRequireDefault((parcelRequire("7sroj")));

var $b633f46b198cd600$var$_constant = $b633f46b198cd600$var$_interopRequireDefault((parcelRequire("3Fk9S")));

var $b633f46b198cd600$var$_linear = $b633f46b198cd600$var$_interopRequireDefault((parcelRequire("gDD8Z")));

var $gGwfH = parcelRequire("gGwfH");
function $b633f46b198cd600$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b633f46b198cd600$var$_default(x, y) {
    var defined = (0, $b633f46b198cd600$var$_constant.default)(true), context = null, curve = $b633f46b198cd600$var$_linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? $gGwfH.x : (0, $b633f46b198cd600$var$_constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? $gGwfH.y : (0, $b633f46b198cd600$var$_constant.default)(y);
    function line(data) {
        var i, n = (data = (0, $b633f46b198cd600$var$_array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $49nWa.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $b633f46b198cd600$var$_constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $b633f46b198cd600$var$_constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $b633f46b198cd600$var$_constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

});
parcelRegister("gGwfH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.x = $c259963042610997$var$x;
module.exports.y = $c259963042610997$var$y;
function $c259963042610997$var$x(p) {
    return p[0];
}
function $c259963042610997$var$y(p) {
    return p[1];
}

});



parcelRegister("6wwBA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $4bff05f680124077$var$_default;

var $4bff05f680124077$var$_array = $4bff05f680124077$var$_interopRequireDefault((parcelRequire("7sroj")));

var $4bff05f680124077$var$_constant = $4bff05f680124077$var$_interopRequireDefault((parcelRequire("3Fk9S")));

var $4bff05f680124077$var$_descending = $4bff05f680124077$var$_interopRequireDefault((parcelRequire("h5KAl")));

var $4bff05f680124077$var$_identity = $4bff05f680124077$var$_interopRequireDefault((parcelRequire("f5ENN")));

var $eG4Si = parcelRequire("eG4Si");
function $4bff05f680124077$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $4bff05f680124077$var$_default() {
    var value = $4bff05f680124077$var$_identity.default, sortValues = $4bff05f680124077$var$_descending.default, sort = null, startAngle = (0, $4bff05f680124077$var$_constant.default)(0), endAngle = (0, $4bff05f680124077$var$_constant.default)($eG4Si.tau), padAngle = (0, $4bff05f680124077$var$_constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, $4bff05f680124077$var$_array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min($eG4Si.tau, Math.max(-$eG4Si.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
         // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        }); // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $4bff05f680124077$var$_constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, $4bff05f680124077$var$_constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, $4bff05f680124077$var$_constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, $4bff05f680124077$var$_constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

});
parcelRegister("h5KAl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c7170a27e67a5ac1$var$_default;
function $c7170a27e67a5ac1$var$_default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

});

parcelRegister("f5ENN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $afc6f914462df6b8$var$_default;
function $afc6f914462df6b8$var$_default(d) {
    return d;
}

});


parcelRegister("2Ey3I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1ee9bc9cfeba2938$var$_default;

var $1ee9bc9cfeba2938$var$_radial = $1ee9bc9cfeba2938$var$_interopRequireWildcard((parcelRequire("6U2c6")));

var $1ee9bc9cfeba2938$var$_area = $1ee9bc9cfeba2938$var$_interopRequireDefault((parcelRequire("jGJmF")));

var $hG4jk = parcelRequire("hG4jk");
function $1ee9bc9cfeba2938$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1ee9bc9cfeba2938$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($1ee9bc9cfeba2938$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $1ee9bc9cfeba2938$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $1ee9bc9cfeba2938$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $1ee9bc9cfeba2938$var$_default() {
    var a = (0, $1ee9bc9cfeba2938$var$_area.default)().curve($1ee9bc9cfeba2938$var$_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, $hG4jk.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, $hG4jk.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, $hG4jk.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, $hG4jk.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, $1ee9bc9cfeba2938$var$_radial.default)(_)) : c()._curve;
    };
    return a;
}

});
parcelRegister("6U2c6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.curveRadialLinear = void 0;
module.exports.default = $5069acc9aa0b34c2$var$curveRadial;

var $5069acc9aa0b34c2$var$_linear = $5069acc9aa0b34c2$var$_interopRequireDefault((parcelRequire("gDD8Z")));
function $5069acc9aa0b34c2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $5069acc9aa0b34c2$var$curveRadialLinear = $5069acc9aa0b34c2$var$curveRadial($5069acc9aa0b34c2$var$_linear.default);
module.exports.curveRadialLinear = $5069acc9aa0b34c2$var$curveRadialLinear;
function $5069acc9aa0b34c2$var$Radial(curve) {
    this._curve = curve;
}
$5069acc9aa0b34c2$var$Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function $5069acc9aa0b34c2$var$curveRadial(curve) {
    function radial(context) {
        return new $5069acc9aa0b34c2$var$Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

});

parcelRegister("hG4jk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $cde9b3e98ed5e10c$var$_default;
module.exports.lineRadial = $cde9b3e98ed5e10c$var$lineRadial;

var $cde9b3e98ed5e10c$var$_radial = $cde9b3e98ed5e10c$var$_interopRequireWildcard((parcelRequire("6U2c6")));

var $cde9b3e98ed5e10c$var$_line = $cde9b3e98ed5e10c$var$_interopRequireDefault((parcelRequire("fDRrB")));
function $cde9b3e98ed5e10c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $cde9b3e98ed5e10c$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($cde9b3e98ed5e10c$var$_getRequireWildcardCache = function(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $cde9b3e98ed5e10c$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $cde9b3e98ed5e10c$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $cde9b3e98ed5e10c$var$lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, $cde9b3e98ed5e10c$var$_radial.default)(_)) : c()._curve;
    };
    return l;
}
function $cde9b3e98ed5e10c$var$_default() {
    return $cde9b3e98ed5e10c$var$lineRadial((0, $cde9b3e98ed5e10c$var$_line.default)().curve($cde9b3e98ed5e10c$var$_radial.curveRadialLinear));
}

});


parcelRegister("jgyB7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $e06a59502a663bd3$var$_default;
function $e06a59502a663bd3$var$_default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

});

parcelRegister("eQZCT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.link = $ad05b9b9e029a25d$var$link;
module.exports.linkHorizontal = $ad05b9b9e029a25d$var$linkHorizontal;
module.exports.linkRadial = $ad05b9b9e029a25d$var$linkRadial;
module.exports.linkVertical = $ad05b9b9e029a25d$var$linkVertical;

var $49nWa = parcelRequire("49nWa");

var $7sroj = parcelRequire("7sroj");

var $ad05b9b9e029a25d$var$_constant = $ad05b9b9e029a25d$var$_interopRequireDefault((parcelRequire("3Fk9S")));

var $egTfv = parcelRequire("egTfv");

var $gGwfH = parcelRequire("gGwfH");
function $ad05b9b9e029a25d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ad05b9b9e029a25d$var$linkSource(d) {
    return d.source;
}
function $ad05b9b9e029a25d$var$linkTarget(d) {
    return d.target;
}
function $ad05b9b9e029a25d$var$link(curve) {
    let source = $ad05b9b9e029a25d$var$linkSource;
    let target = $ad05b9b9e029a25d$var$linkTarget;
    let x = $gGwfH.x;
    let y = $gGwfH.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = $7sroj.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, $49nWa.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $ad05b9b9e029a25d$var$_constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $ad05b9b9e029a25d$var$_constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function $ad05b9b9e029a25d$var$linkHorizontal() {
    return $ad05b9b9e029a25d$var$link($egTfv.bumpX);
}
function $ad05b9b9e029a25d$var$linkVertical() {
    return $ad05b9b9e029a25d$var$link($egTfv.bumpY);
}
function $ad05b9b9e029a25d$var$linkRadial() {
    const l = $ad05b9b9e029a25d$var$link($egTfv.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

});
parcelRegister("egTfv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bumpRadial = $a63d6aa36d7e7a5d$var$bumpRadial;
module.exports.bumpX = $a63d6aa36d7e7a5d$var$bumpX;
module.exports.bumpY = $a63d6aa36d7e7a5d$var$bumpY;

var $a63d6aa36d7e7a5d$var$_pointRadial = $a63d6aa36d7e7a5d$var$_interopRequireDefault((parcelRequire("jgyB7")));
function $a63d6aa36d7e7a5d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class $a63d6aa36d7e7a5d$var$Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class $a63d6aa36d7e7a5d$var$BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, $a63d6aa36d7e7a5d$var$_pointRadial.default)(this._x0, this._y0);
            const p1 = (0, $a63d6aa36d7e7a5d$var$_pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, $a63d6aa36d7e7a5d$var$_pointRadial.default)(x, this._y0);
            const p3 = (0, $a63d6aa36d7e7a5d$var$_pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function $a63d6aa36d7e7a5d$var$bumpX(context) {
    return new $a63d6aa36d7e7a5d$var$Bump(context, true);
}
function $a63d6aa36d7e7a5d$var$bumpY(context) {
    return new $a63d6aa36d7e7a5d$var$Bump(context, false);
}
function $a63d6aa36d7e7a5d$var$bumpRadial(context) {
    return new $a63d6aa36d7e7a5d$var$BumpRadial(context);
}

});


parcelRegister("7xgxt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $57c871bd9f27a32c$var$Symbol;
module.exports.symbolsStroke = module.exports.symbolsFill = void 0;

var $49nWa = parcelRequire("49nWa");

var $57c871bd9f27a32c$var$_constant = $57c871bd9f27a32c$var$_interopRequireDefault((parcelRequire("3Fk9S")));

var $57c871bd9f27a32c$var$_asterisk = $57c871bd9f27a32c$var$_interopRequireDefault((parcelRequire("jRdv1")));

var $57c871bd9f27a32c$var$_circle = $57c871bd9f27a32c$var$_interopRequireDefault((parcelRequire("l37A6")));

var $57c871bd9f27a32c$var$_cross = $57c871bd9f27a32c$var$_interopRequireDefault((parcelRequire("5Dm0p")));

var $57c871bd9f27a32c$var$_diamond = $57c871bd9f27a32c$var$_interopRequireDefault((parcelRequire("lRWXg")));

var $57c871bd9f27a32c$var$_diamond2 = $57c871bd9f27a32c$var$_interopRequireDefault((parcelRequire("4CGNx")));

var $57c871bd9f27a32c$var$_plus = $57c871bd9f27a32c$var$_interopRequireDefault((parcelRequire("4jvEH")));

var $57c871bd9f27a32c$var$_square = $57c871bd9f27a32c$var$_interopRequireDefault((parcelRequire("8TJlG")));

var $57c871bd9f27a32c$var$_square2 = $57c871bd9f27a32c$var$_interopRequireDefault((parcelRequire("klSdz")));

var $57c871bd9f27a32c$var$_star = $57c871bd9f27a32c$var$_interopRequireDefault((parcelRequire("ajHqS")));

var $57c871bd9f27a32c$var$_triangle = $57c871bd9f27a32c$var$_interopRequireDefault((parcelRequire("8FPIT")));

var $57c871bd9f27a32c$var$_triangle2 = $57c871bd9f27a32c$var$_interopRequireDefault((parcelRequire("2IW6k")));

var $57c871bd9f27a32c$var$_wye = $57c871bd9f27a32c$var$_interopRequireDefault((parcelRequire("apdcI")));

var $57c871bd9f27a32c$var$_x = $57c871bd9f27a32c$var$_interopRequireDefault((parcelRequire("f61PF")));
function $57c871bd9f27a32c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const $57c871bd9f27a32c$var$symbolsFill = [
    $57c871bd9f27a32c$var$_circle.default,
    $57c871bd9f27a32c$var$_cross.default,
    $57c871bd9f27a32c$var$_diamond.default,
    $57c871bd9f27a32c$var$_square.default,
    $57c871bd9f27a32c$var$_star.default,
    $57c871bd9f27a32c$var$_triangle.default,
    $57c871bd9f27a32c$var$_wye.default
]; // These symbols are designed to be stroked (with a width of 1.5px and round caps).
module.exports.symbolsFill = $57c871bd9f27a32c$var$symbolsFill;
const $57c871bd9f27a32c$var$symbolsStroke = [
    $57c871bd9f27a32c$var$_circle.default,
    $57c871bd9f27a32c$var$_plus.default,
    $57c871bd9f27a32c$var$_x.default,
    $57c871bd9f27a32c$var$_triangle2.default,
    $57c871bd9f27a32c$var$_asterisk.default,
    $57c871bd9f27a32c$var$_square2.default,
    $57c871bd9f27a32c$var$_diamond2.default
];
module.exports.symbolsStroke = $57c871bd9f27a32c$var$symbolsStroke;
function $57c871bd9f27a32c$var$Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $57c871bd9f27a32c$var$_constant.default)(type || $57c871bd9f27a32c$var$_circle.default);
    size = typeof size === "function" ? size : (0, $57c871bd9f27a32c$var$_constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $49nWa.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $57c871bd9f27a32c$var$_constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $57c871bd9f27a32c$var$_constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

});
parcelRegister("jRdv1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eG4Si = parcelRequire("eG4Si");
const $e74d703e0c3556ce$var$sqrt3 = (0, $eG4Si.sqrt)(3);
var $e74d703e0c3556ce$var$_default = {
    draw (context, size) {
        const r = (0, $eG4Si.sqrt)(size + (0, $eG4Si.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $e74d703e0c3556ce$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};
module.exports.default = $e74d703e0c3556ce$var$_default;

});

parcelRegister("l37A6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eG4Si = parcelRequire("eG4Si");
var $f52fc24c44534c55$var$_default = {
    draw (context, size) {
        const r = (0, $eG4Si.sqrt)(size / $eG4Si.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, $eG4Si.tau);
    }
};
module.exports.default = $f52fc24c44534c55$var$_default;

});

parcelRegister("5Dm0p", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eG4Si = parcelRequire("eG4Si");
var $41a1aa209b179515$var$_default = {
    draw (context, size) {
        const r = (0, $eG4Si.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};
module.exports.default = $41a1aa209b179515$var$_default;

});

parcelRegister("lRWXg", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eG4Si = parcelRequire("eG4Si");
const $febc476ce91140e5$var$tan30 = (0, $eG4Si.sqrt)(1 / 3);
const $febc476ce91140e5$var$tan30_2 = $febc476ce91140e5$var$tan30 * 2;
var $febc476ce91140e5$var$_default = {
    draw (context, size) {
        const y = (0, $eG4Si.sqrt)(size / $febc476ce91140e5$var$tan30_2);
        const x = y * $febc476ce91140e5$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};
module.exports.default = $febc476ce91140e5$var$_default;

});

parcelRegister("4CGNx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eG4Si = parcelRequire("eG4Si");
var $35dbe8cd451ba4f8$var$_default = {
    draw (context, size) {
        const r = (0, $eG4Si.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};
module.exports.default = $35dbe8cd451ba4f8$var$_default;

});

parcelRegister("4jvEH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eG4Si = parcelRequire("eG4Si");
var $32417de70735aeb6$var$_default = {
    draw (context, size) {
        const r = (0, $eG4Si.sqrt)(size - (0, $eG4Si.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};
module.exports.default = $32417de70735aeb6$var$_default;

});

parcelRegister("8TJlG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eG4Si = parcelRequire("eG4Si");
var $67a6a31dd9b31ebc$var$_default = {
    draw (context, size) {
        const w = (0, $eG4Si.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};
module.exports.default = $67a6a31dd9b31ebc$var$_default;

});

parcelRegister("klSdz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eG4Si = parcelRequire("eG4Si");
var $ed0fd35fe9817818$var$_default = {
    draw (context, size) {
        const r = (0, $eG4Si.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};
module.exports.default = $ed0fd35fe9817818$var$_default;

});

parcelRegister("ajHqS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eG4Si = parcelRequire("eG4Si");
const $782d5e890a703f96$var$ka = 0.89081309152928522810;
const $782d5e890a703f96$var$kr = (0, $eG4Si.sin)($eG4Si.pi / 10) / (0, $eG4Si.sin)(7 * $eG4Si.pi / 10);
const $782d5e890a703f96$var$kx = (0, $eG4Si.sin)($eG4Si.tau / 10) * $782d5e890a703f96$var$kr;
const $782d5e890a703f96$var$ky = -(0, $eG4Si.cos)($eG4Si.tau / 10) * $782d5e890a703f96$var$kr;
var $782d5e890a703f96$var$_default = {
    draw (context, size) {
        const r = (0, $eG4Si.sqrt)(size * $782d5e890a703f96$var$ka);
        const x = $782d5e890a703f96$var$kx * r;
        const y = $782d5e890a703f96$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = $eG4Si.tau * i / 5;
            const c = (0, $eG4Si.cos)(a);
            const s = (0, $eG4Si.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};
module.exports.default = $782d5e890a703f96$var$_default;

});

parcelRegister("8FPIT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eG4Si = parcelRequire("eG4Si");
const $650a462adabc067a$var$sqrt3 = (0, $eG4Si.sqrt)(3);
var $650a462adabc067a$var$_default = {
    draw (context, size) {
        const y = -(0, $eG4Si.sqrt)(size / ($650a462adabc067a$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$650a462adabc067a$var$sqrt3 * y, -y);
        context.lineTo($650a462adabc067a$var$sqrt3 * y, -y);
        context.closePath();
    }
};
module.exports.default = $650a462adabc067a$var$_default;

});

parcelRegister("2IW6k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eG4Si = parcelRequire("eG4Si");
const $1fbcc281fd6f2520$var$sqrt3 = (0, $eG4Si.sqrt)(3);
var $1fbcc281fd6f2520$var$_default = {
    draw (context, size) {
        const s = (0, $eG4Si.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * $1fbcc281fd6f2520$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};
module.exports.default = $1fbcc281fd6f2520$var$_default;

});

parcelRegister("apdcI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eG4Si = parcelRequire("eG4Si");
const $79367b3b488bb24e$var$c = -0.5;
const $79367b3b488bb24e$var$s = (0, $eG4Si.sqrt)(3) / 2;
const $79367b3b488bb24e$var$k = 1 / (0, $eG4Si.sqrt)(12);
const $79367b3b488bb24e$var$a = ($79367b3b488bb24e$var$k / 2 + 1) * 3;
var $79367b3b488bb24e$var$_default = {
    draw (context, size) {
        const r = (0, $eG4Si.sqrt)(size / $79367b3b488bb24e$var$a);
        const x0 = r / 2, y0 = r * $79367b3b488bb24e$var$k;
        const x1 = x0, y1 = r * $79367b3b488bb24e$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($79367b3b488bb24e$var$c * x0 - $79367b3b488bb24e$var$s * y0, $79367b3b488bb24e$var$s * x0 + $79367b3b488bb24e$var$c * y0);
        context.lineTo($79367b3b488bb24e$var$c * x1 - $79367b3b488bb24e$var$s * y1, $79367b3b488bb24e$var$s * x1 + $79367b3b488bb24e$var$c * y1);
        context.lineTo($79367b3b488bb24e$var$c * x2 - $79367b3b488bb24e$var$s * y2, $79367b3b488bb24e$var$s * x2 + $79367b3b488bb24e$var$c * y2);
        context.lineTo($79367b3b488bb24e$var$c * x0 + $79367b3b488bb24e$var$s * y0, $79367b3b488bb24e$var$c * y0 - $79367b3b488bb24e$var$s * x0);
        context.lineTo($79367b3b488bb24e$var$c * x1 + $79367b3b488bb24e$var$s * y1, $79367b3b488bb24e$var$c * y1 - $79367b3b488bb24e$var$s * x1);
        context.lineTo($79367b3b488bb24e$var$c * x2 + $79367b3b488bb24e$var$s * y2, $79367b3b488bb24e$var$c * y2 - $79367b3b488bb24e$var$s * x2);
        context.closePath();
    }
};
module.exports.default = $79367b3b488bb24e$var$_default;

});

parcelRegister("f61PF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eG4Si = parcelRequire("eG4Si");
var $afd8d66d911a7b71$var$_default = {
    draw (context, size) {
        const r = (0, $eG4Si.sqrt)(size - (0, $eG4Si.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};
module.exports.default = $afd8d66d911a7b71$var$_default;

});


parcelRegister("3G3L1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2ad8357e6fcef364$var$_default;

var $2ad8357e6fcef364$var$_noop = $2ad8357e6fcef364$var$_interopRequireDefault((parcelRequire("dUmQd")));

var $cIyrO = parcelRequire("cIyrO");
function $2ad8357e6fcef364$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $2ad8357e6fcef364$var$BasisClosed(context) {
    this._context = context;
}
$2ad8357e6fcef364$var$BasisClosed.prototype = {
    areaStart: $2ad8357e6fcef364$var$_noop.default,
    areaEnd: $2ad8357e6fcef364$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $cIyrO.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $2ad8357e6fcef364$var$_default(context) {
    return new $2ad8357e6fcef364$var$BasisClosed(context);
}

});
parcelRegister("dUmQd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a202391fe9af8597$var$_default;
function $a202391fe9af8597$var$_default() {}

});

parcelRegister("cIyrO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Basis = $942450a59565ba88$var$Basis;
module.exports.default = $942450a59565ba88$var$_default;
module.exports.point = $942450a59565ba88$var$point;
function $942450a59565ba88$var$point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $942450a59565ba88$var$Basis(context) {
    this._context = context;
}
$942450a59565ba88$var$Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $942450a59565ba88$var$point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                $942450a59565ba88$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $942450a59565ba88$var$_default(context) {
    return new $942450a59565ba88$var$Basis(context);
}

});


parcelRegister("3DIUN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $2a67dad637dfc629$var$_default;

var $cIyrO = parcelRequire("cIyrO");
function $2a67dad637dfc629$var$BasisOpen(context) {
    this._context = context;
}
$2a67dad637dfc629$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $cIyrO.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $2a67dad637dfc629$var$_default(context) {
    return new $2a67dad637dfc629$var$BasisOpen(context);
}

});

parcelRegister("kEF43", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cIyrO = parcelRequire("cIyrO");
function $f0976597d0475b22$var$Bundle(context, beta) {
    this._basis = new $cIyrO.Basis(context);
    this._beta = beta;
}
$f0976597d0475b22$var$Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var $f0976597d0475b22$var$_default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new $cIyrO.Basis(context) : new $f0976597d0475b22$var$Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);
module.exports.default = $f0976597d0475b22$var$_default;

});

parcelRegister("hmBmP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalClosed = $ca417a1b3af976e2$var$CardinalClosed;
module.exports.default = void 0;

var $ca417a1b3af976e2$var$_noop = $ca417a1b3af976e2$var$_interopRequireDefault((parcelRequire("dUmQd")));

var $li6bm = parcelRequire("li6bm");
function $ca417a1b3af976e2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ca417a1b3af976e2$var$CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$ca417a1b3af976e2$var$CardinalClosed.prototype = {
    areaStart: $ca417a1b3af976e2$var$_noop.default,
    areaEnd: $ca417a1b3af976e2$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $li6bm.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $ca417a1b3af976e2$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $ca417a1b3af976e2$var$CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $ca417a1b3af976e2$var$_default;

});
parcelRegister("li6bm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Cardinal = $f800130da9dbbc90$var$Cardinal;
module.exports.default = void 0;
module.exports.point = $f800130da9dbbc90$var$point;
function $f800130da9dbbc90$var$point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function $f800130da9dbbc90$var$Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$f800130da9dbbc90$var$Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                $f800130da9dbbc90$var$point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                $f800130da9dbbc90$var$point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $f800130da9dbbc90$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $f800130da9dbbc90$var$Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $f800130da9dbbc90$var$_default;

});


parcelRegister("juaVp", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CardinalOpen = $e2f94b1df7eddc3c$var$CardinalOpen;
module.exports.default = void 0;

var $li6bm = parcelRequire("li6bm");
function $e2f94b1df7eddc3c$var$CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
$e2f94b1df7eddc3c$var$CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $li6bm.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $e2f94b1df7eddc3c$var$_default = function custom(tension) {
    function cardinal(context) {
        return new $e2f94b1df7eddc3c$var$CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);
module.exports.default = $e2f94b1df7eddc3c$var$_default;

});

parcelRegister("erhKv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $hmBmP = parcelRequire("hmBmP");

var $a8315ae638049564$var$_noop = $a8315ae638049564$var$_interopRequireDefault((parcelRequire("dUmQd")));

var $aIMmt = parcelRequire("aIMmt");
function $a8315ae638049564$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a8315ae638049564$var$CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$a8315ae638049564$var$CatmullRomClosed.prototype = {
    areaStart: $a8315ae638049564$var$_noop.default,
    areaEnd: $a8315ae638049564$var$_noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, $aIMmt.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $a8315ae638049564$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $a8315ae638049564$var$CatmullRomClosed(context, alpha) : new $hmBmP.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $a8315ae638049564$var$_default;

});
parcelRegister("aIMmt", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;

var $eG4Si = parcelRequire("eG4Si");

var $li6bm = parcelRequire("li6bm");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > $eG4Si.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > $eG4Si.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new $li6bm.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
exports.default = _default;

});


parcelRegister("kvuJI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $juaVp = parcelRequire("juaVp");

var $aIMmt = parcelRequire("aIMmt");
function $eede8b7afd29656b$var$CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
$eede8b7afd29656b$var$CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, $aIMmt.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var $eede8b7afd29656b$var$_default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new $eede8b7afd29656b$var$CatmullRomOpen(context, alpha) : new $juaVp.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);
module.exports.default = $eede8b7afd29656b$var$_default;

});

parcelRegister("4fMoA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $318e1a7c27366450$var$_default;

var $318e1a7c27366450$var$_noop = $318e1a7c27366450$var$_interopRequireDefault((parcelRequire("dUmQd")));
function $318e1a7c27366450$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $318e1a7c27366450$var$LinearClosed(context) {
    this._context = context;
}
$318e1a7c27366450$var$LinearClosed.prototype = {
    areaStart: $318e1a7c27366450$var$_noop.default,
    areaEnd: $318e1a7c27366450$var$_noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $318e1a7c27366450$var$_default(context) {
    return new $318e1a7c27366450$var$LinearClosed(context);
}

});

parcelRegister("3AoEL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.monotoneX = $29c7dc2d200a17fc$var$monotoneX;
module.exports.monotoneY = $29c7dc2d200a17fc$var$monotoneY;
function $29c7dc2d200a17fc$var$sign(x) {
    return x < 0 ? -1 : 1;
} // Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $29c7dc2d200a17fc$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($29c7dc2d200a17fc$var$sign(s0) + $29c7dc2d200a17fc$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
} // Calculate a one-sided slope.
function $29c7dc2d200a17fc$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
} // According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $29c7dc2d200a17fc$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $29c7dc2d200a17fc$var$MonotoneX(context) {
    this._context = context;
}
$29c7dc2d200a17fc$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $29c7dc2d200a17fc$var$point(this, this._t0, $29c7dc2d200a17fc$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $29c7dc2d200a17fc$var$point(this, $29c7dc2d200a17fc$var$slope2(this, t1 = $29c7dc2d200a17fc$var$slope3(this, x, y)), t1);
                break;
            default:
                $29c7dc2d200a17fc$var$point(this, this._t0, t1 = $29c7dc2d200a17fc$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $29c7dc2d200a17fc$var$MonotoneY(context) {
    this._context = new $29c7dc2d200a17fc$var$ReflectContext(context);
}
($29c7dc2d200a17fc$var$MonotoneY.prototype = Object.create($29c7dc2d200a17fc$var$MonotoneX.prototype)).point = function(x, y) {
    $29c7dc2d200a17fc$var$MonotoneX.prototype.point.call(this, y, x);
};
function $29c7dc2d200a17fc$var$ReflectContext(context) {
    this._context = context;
}
$29c7dc2d200a17fc$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $29c7dc2d200a17fc$var$monotoneX(context) {
    return new $29c7dc2d200a17fc$var$MonotoneX(context);
}
function $29c7dc2d200a17fc$var$monotoneY(context) {
    return new $29c7dc2d200a17fc$var$MonotoneY(context);
}

});

parcelRegister("eajCr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $a50137cc5cf6343e$var$_default;
function $a50137cc5cf6343e$var$Natural(context) {
    this._context = context;
}
$a50137cc5cf6343e$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $a50137cc5cf6343e$var$controlPoints(x), py = $a50137cc5cf6343e$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
}; // See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $a50137cc5cf6343e$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $a50137cc5cf6343e$var$_default(context) {
    return new $a50137cc5cf6343e$var$Natural(context);
}

});

parcelRegister("kjkb7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $ec953c0004f434a0$var$_default;
module.exports.stepAfter = $ec953c0004f434a0$var$stepAfter;
module.exports.stepBefore = $ec953c0004f434a0$var$stepBefore;
function $ec953c0004f434a0$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$ec953c0004f434a0$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $ec953c0004f434a0$var$_default(context) {
    return new $ec953c0004f434a0$var$Step(context, 0.5);
}
function $ec953c0004f434a0$var$stepBefore(context) {
    return new $ec953c0004f434a0$var$Step(context, 0);
}
function $ec953c0004f434a0$var$stepAfter(context) {
    return new $ec953c0004f434a0$var$Step(context, 1);
}

});

parcelRegister("fIEUP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $b71ab40b5a17c8f8$var$_default;

var $b71ab40b5a17c8f8$var$_array = $b71ab40b5a17c8f8$var$_interopRequireDefault((parcelRequire("7sroj")));

var $b71ab40b5a17c8f8$var$_constant = $b71ab40b5a17c8f8$var$_interopRequireDefault((parcelRequire("3Fk9S")));

var $b71ab40b5a17c8f8$var$_none = $b71ab40b5a17c8f8$var$_interopRequireDefault((parcelRequire("eUvdQ")));

var $b71ab40b5a17c8f8$var$_none2 = $b71ab40b5a17c8f8$var$_interopRequireDefault((parcelRequire("8wW3N")));
function $b71ab40b5a17c8f8$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $b71ab40b5a17c8f8$var$stackValue(d, key) {
    return d[key];
}
function $b71ab40b5a17c8f8$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $b71ab40b5a17c8f8$var$_default() {
    var keys = (0, $b71ab40b5a17c8f8$var$_constant.default)([]), order = $b71ab40b5a17c8f8$var$_none2.default, offset = $b71ab40b5a17c8f8$var$_none.default, value = $b71ab40b5a17c8f8$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $b71ab40b5a17c8f8$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $b71ab40b5a17c8f8$var$_array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $b71ab40b5a17c8f8$var$_constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $b71ab40b5a17c8f8$var$_constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? $b71ab40b5a17c8f8$var$_none2.default : typeof _ === "function" ? _ : (0, $b71ab40b5a17c8f8$var$_constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? $b71ab40b5a17c8f8$var$_none.default : _, stack) : offset;
    };
    return stack;
}

});
parcelRegister("eUvdQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $adae83c2f1b49167$var$_default;
function $adae83c2f1b49167$var$_default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

});

parcelRegister("8wW3N", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $635e597106583c50$var$_default;
function $635e597106583c50$var$_default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

});


parcelRegister("hcCuQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c8616b3d6ea9b470$var$_default;

var $c8616b3d6ea9b470$var$_none = $c8616b3d6ea9b470$var$_interopRequireDefault((parcelRequire("eUvdQ")));
function $c8616b3d6ea9b470$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c8616b3d6ea9b470$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $c8616b3d6ea9b470$var$_none.default)(series, order);
}

});

parcelRegister("yz6WP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $067e696a8042d82c$var$_default;
function $067e696a8042d82c$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

});

parcelRegister("c6evC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $8cf14cbc3bb1754a$var$_default;

var $8cf14cbc3bb1754a$var$_none = $8cf14cbc3bb1754a$var$_interopRequireDefault((parcelRequire("eUvdQ")));
function $8cf14cbc3bb1754a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $8cf14cbc3bb1754a$var$_default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $8cf14cbc3bb1754a$var$_none.default)(series, order);
}

});

parcelRegister("7dGWK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $541b0f94c6c93daf$var$_default;

var $541b0f94c6c93daf$var$_none = $541b0f94c6c93daf$var$_interopRequireDefault((parcelRequire("eUvdQ")));
function $541b0f94c6c93daf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $541b0f94c6c93daf$var$_default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $541b0f94c6c93daf$var$_none.default)(series, order);
}

});

parcelRegister("34SOV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $23dc45016a65b34a$var$_default;

var $23dc45016a65b34a$var$_none = $23dc45016a65b34a$var$_interopRequireDefault((parcelRequire("8wW3N")));
function $23dc45016a65b34a$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $23dc45016a65b34a$var$_default(series) {
    var peaks = series.map($23dc45016a65b34a$var$peak);
    return (0, $23dc45016a65b34a$var$_none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function $23dc45016a65b34a$var$peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

});

parcelRegister("2h66Z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $1a81e8f75b569285$var$_default;
module.exports.sum = $1a81e8f75b569285$var$sum;

var $1a81e8f75b569285$var$_none = $1a81e8f75b569285$var$_interopRequireDefault((parcelRequire("8wW3N")));
function $1a81e8f75b569285$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1a81e8f75b569285$var$_default(series) {
    var sums = series.map($1a81e8f75b569285$var$sum);
    return (0, $1a81e8f75b569285$var$_none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function $1a81e8f75b569285$var$sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

});

parcelRegister("l6ybI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f5d4ad823f2dd450$var$_default;

var $f5d4ad823f2dd450$var$_ascending = $f5d4ad823f2dd450$var$_interopRequireDefault((parcelRequire("2h66Z")));
function $f5d4ad823f2dd450$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f5d4ad823f2dd450$var$_default(series) {
    return (0, $f5d4ad823f2dd450$var$_ascending.default)(series).reverse();
}

});

parcelRegister("hdLxD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $c898874eca1b3161$var$_default;

var $c898874eca1b3161$var$_appearance = $c898874eca1b3161$var$_interopRequireDefault((parcelRequire("34SOV")));

var $2h66Z = parcelRequire("2h66Z");
function $c898874eca1b3161$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c898874eca1b3161$var$_default(series) {
    var n = series.length, i, j, sums = series.map($2h66Z.sum), order = (0, $c898874eca1b3161$var$_appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

});

parcelRegister("9ciyJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $6b23a17e9b773412$var$_default;

var $6b23a17e9b773412$var$_none = $6b23a17e9b773412$var$_interopRequireDefault((parcelRequire("8wW3N")));
function $6b23a17e9b773412$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $6b23a17e9b773412$var$_default(series) {
    return (0, $6b23a17e9b773412$var$_none.default)(series).reverse();
}

});



parcelRegister("gtbqy", function(module, exports) {

var $eHWnd = parcelRequire("eHWnd");

var $5glgQ = parcelRequire("5glgQ");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $eHWnd.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $5glgQ;
module.exports = isBuffer;

});
parcelRegister("eHWnd", function(module, exports) {

var $b8tqU = parcelRequire("b8tqU");
/** Detect free variable `self`. */ var $ab525c948eb17b8e$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $ab525c948eb17b8e$var$root = $b8tqU || $ab525c948eb17b8e$var$freeSelf || Function("return this")();
module.exports = $ab525c948eb17b8e$var$root;

});
parcelRegister("b8tqU", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $81b745d78ea37b78$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $81b745d78ea37b78$var$freeGlobal;

});


parcelRegister("5glgQ", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $3d4ef24d5bc4dc86$var$stubFalse() {
    return false;
}
module.exports = $3d4ef24d5bc4dc86$var$stubFalse;

});


parcelRegister("ipkSi", function(module, exports) {

var $b8tqU = parcelRequire("b8tqU");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $b8tqU.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRegister("iQvaa", function(module, exports) {
/* global window */ 
var $1nu6F = parcelRequire("1nu6F");
var root;
if (typeof self !== "undefined") root = self;
else if (typeof window !== "undefined") root = window;
else if (typeof $parcel$global !== "undefined") root = $parcel$global;
else root = module;
var result = (0, $1nu6F.default)(root);
var $db8541ab2a0412ad$export$2e2bcd8739ae039 = result;

});
parcelRegister("1nu6F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $100f4afa944d80a8$export$2e2bcd8739ae039; });
function $100f4afa944d80a8$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === "function") {
        if (Symbol.observable) result = Symbol.observable;
        else {
            if (typeof Symbol.for === "function") // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for("https://github.com/benlesh/symbol-observable");
            else // Symbol.for didn't exist! The best we can do at this point is a totally 
            // unique symbol. Note that the string argument here is a descriptor, not
            // an identifier. This symbol is unique.
            result = Symbol("https://github.com/benlesh/symbol-observable");
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = "@@observable";
    return result;
}

});


"use strict";
var $e1ff03c6fa941474$exports = {};
"use strict";
var $e1ff03c6fa941474$var$check = function(it) {
    return it && it.Math === Math && it;
};
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
$e1ff03c6fa941474$exports = // eslint-disable-next-line es/no-global-this -- safe
$e1ff03c6fa941474$var$check(typeof globalThis == "object" && globalThis) || $e1ff03c6fa941474$var$check(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
$e1ff03c6fa941474$var$check(typeof self == "object" && self) || $e1ff03c6fa941474$var$check(typeof $parcel$global == "object" && $parcel$global) || $e1ff03c6fa941474$var$check(typeof $e1ff03c6fa941474$exports == "object" && $e1ff03c6fa941474$exports) || // eslint-disable-next-line no-new-func -- fallback
function() {
    return this;
}() || Function("return this")();


var $2c83071379303a9f$exports = {};
"use strict";
var $76bcff007c0cf27f$exports = {};
"use strict";
$76bcff007c0cf27f$exports = function(exec) {
    try {
        return !!exec();
    } catch (error) {
        return true;
    }
};


// Detect IE8's incomplete defineProperty implementation
$2c83071379303a9f$exports = !$76bcff007c0cf27f$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty({}, 1, {
        get: function() {
            return 7;
        }
    })[1] !== 7;
});


var $3797c5fdbd33f20c$exports = {};
"use strict";
var $6d241c82552a4b25$exports = {};
"use strict";
var $723fda74cdbf59ed$exports = {};
"use strict";
var $e05c8f1ae7606982$exports = {};
"use strict";

$e05c8f1ae7606982$exports = !$76bcff007c0cf27f$exports(function() {
    // eslint-disable-next-line es/no-function-prototype-bind -- safe
    var test = (function() {}).bind();
    // eslint-disable-next-line no-prototype-builtins -- safe
    return typeof test != "function" || test.hasOwnProperty("prototype");
});


var $723fda74cdbf59ed$var$FunctionPrototype = Function.prototype;
var $723fda74cdbf59ed$var$call = $723fda74cdbf59ed$var$FunctionPrototype.call;
var $723fda74cdbf59ed$var$uncurryThisWithBind = $e05c8f1ae7606982$exports && $723fda74cdbf59ed$var$FunctionPrototype.bind.bind($723fda74cdbf59ed$var$call, $723fda74cdbf59ed$var$call);
$723fda74cdbf59ed$exports = $e05c8f1ae7606982$exports ? $723fda74cdbf59ed$var$uncurryThisWithBind : function(fn) {
    return function() {
        return $723fda74cdbf59ed$var$call.apply(fn, arguments);
    };
};



var $9b61b9b0573b17f7$exports = {};
"use strict";
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
var $9b61b9b0573b17f7$var$documentAll = typeof document == "object" && document.all;
// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
$9b61b9b0573b17f7$exports = typeof $9b61b9b0573b17f7$var$documentAll == "undefined" && $9b61b9b0573b17f7$var$documentAll !== undefined ? function(argument) {
    return typeof argument == "function" || argument === $9b61b9b0573b17f7$var$documentAll;
} : function(argument) {
    return typeof argument == "function";
};


var $004b9e41461fbb75$exports = {};
"use strict";

var $70f36121d3af18ea$exports = {};
"use strict";
var $304f0191f62b181f$exports = {};
"use strict";
var $eb0d61fec8917d97$exports = {};
"use strict";
// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
$eb0d61fec8917d97$exports = function(it) {
    return it === null || it === undefined;
};


var $304f0191f62b181f$var$$TypeError = TypeError;
// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
$304f0191f62b181f$exports = function(it) {
    if ($eb0d61fec8917d97$exports(it)) throw new $304f0191f62b181f$var$$TypeError("Can't call method on " + it);
    return it;
};


var $70f36121d3af18ea$var$$Object = Object;
// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
$70f36121d3af18ea$exports = function(argument) {
    return $70f36121d3af18ea$var$$Object($304f0191f62b181f$exports(argument));
};


var $004b9e41461fbb75$var$hasOwnProperty = $723fda74cdbf59ed$exports({}.hasOwnProperty);
// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
$004b9e41461fbb75$exports = Object.hasOwn || function hasOwn(it, key) {
    return $004b9e41461fbb75$var$hasOwnProperty($70f36121d3af18ea$exports(it), key);
};



var $6df6f099f158f618$exports = {};
"use strict";


var $6df6f099f158f618$var$FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $6df6f099f158f618$var$getDescriptor = $2c83071379303a9f$exports && Object.getOwnPropertyDescriptor;
var $6df6f099f158f618$var$EXISTS = $004b9e41461fbb75$exports($6df6f099f158f618$var$FunctionPrototype, "name");
// additional protection from minified / mangled / dropped function names
var $6df6f099f158f618$var$PROPER = $6df6f099f158f618$var$EXISTS && (function something() {}).name === "something";
var $6df6f099f158f618$var$CONFIGURABLE = $6df6f099f158f618$var$EXISTS && (!$2c83071379303a9f$exports || $2c83071379303a9f$exports && $6df6f099f158f618$var$getDescriptor($6df6f099f158f618$var$FunctionPrototype, "name").configurable);
$6df6f099f158f618$exports = {
    EXISTS: $6df6f099f158f618$var$EXISTS,
    PROPER: $6df6f099f158f618$var$PROPER,
    CONFIGURABLE: $6df6f099f158f618$var$CONFIGURABLE
};


var $6d241c82552a4b25$require$CONFIGURABLE_FUNCTION_NAME = $6df6f099f158f618$exports.CONFIGURABLE;
var $4b6728e533030a0e$exports = {};
"use strict";


var $a404859400982ae1$exports = {};
"use strict";
var $601fd703db8ccfaf$exports = {};
"use strict";
$601fd703db8ccfaf$exports = false;



var $1d43b83fad5a0875$exports = {};
"use strict";

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $1d43b83fad5a0875$var$defineProperty = Object.defineProperty;
$1d43b83fad5a0875$exports = function(key, value) {
    try {
        $1d43b83fad5a0875$var$defineProperty($e1ff03c6fa941474$exports, key, {
            value: value,
            configurable: true,
            writable: true
        });
    } catch (error) {
        $e1ff03c6fa941474$exports[key] = value;
    }
    return value;
};


var $a404859400982ae1$var$SHARED = "__core-js_shared__";
var $a404859400982ae1$var$store = $a404859400982ae1$exports = $e1ff03c6fa941474$exports[$a404859400982ae1$var$SHARED] || $1d43b83fad5a0875$exports($a404859400982ae1$var$SHARED, {});
($a404859400982ae1$var$store.versions || ($a404859400982ae1$var$store.versions = [])).push({
    version: "3.37.0",
    mode: $601fd703db8ccfaf$exports ? "pure" : "global",
    copyright: "\xa9 2014-2024 Denis Pushkarev (zloirock.ru)",
    license: "https://github.com/zloirock/core-js/blob/v3.37.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
});


var $4b6728e533030a0e$var$functionToString = $723fda74cdbf59ed$exports(Function.toString);
// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!$9b61b9b0573b17f7$exports($a404859400982ae1$exports.inspectSource)) $a404859400982ae1$exports.inspectSource = function(it) {
    return $4b6728e533030a0e$var$functionToString(it);
};
$4b6728e533030a0e$exports = $a404859400982ae1$exports.inspectSource;


var $e4c18f9df98cbb78$exports = {};
"use strict";
var $3cb9b42f58538e96$exports = {};
"use strict";


var $3cb9b42f58538e96$var$WeakMap = $e1ff03c6fa941474$exports.WeakMap;
$3cb9b42f58538e96$exports = $9b61b9b0573b17f7$exports($3cb9b42f58538e96$var$WeakMap) && /native code/.test(String($3cb9b42f58538e96$var$WeakMap));



var $c07ec4a60e179c63$exports = {};
"use strict";

$c07ec4a60e179c63$exports = function(it) {
    return typeof it == "object" ? it !== null : $9b61b9b0573b17f7$exports(it);
};


var $706328f2b8cfdcc8$exports = {};
"use strict";

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var $79a74eae6ff4ffba$export$2d1720544b23b823;
"use strict";

var $6da06ad05f8a0c25$exports = {};
"use strict";


var $da3614cb53cb7d1a$exports = {};
"use strict";


var $da3614cb53cb7d1a$var$document = $e1ff03c6fa941474$exports.document;
// typeof document.createElement is 'object' in old IE
var $da3614cb53cb7d1a$var$EXISTS = $c07ec4a60e179c63$exports($da3614cb53cb7d1a$var$document) && $c07ec4a60e179c63$exports($da3614cb53cb7d1a$var$document.createElement);
$da3614cb53cb7d1a$exports = function(it) {
    return $da3614cb53cb7d1a$var$EXISTS ? $da3614cb53cb7d1a$var$document.createElement(it) : {};
};


// Thanks to IE8 for its funny defineProperty
$6da06ad05f8a0c25$exports = !$2c83071379303a9f$exports && !$76bcff007c0cf27f$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty($da3614cb53cb7d1a$exports("div"), "a", {
        get: function() {
            return 7;
        }
    }).a !== 7;
});


var $217aa1749faefbbb$exports = {};
"use strict";


// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
$217aa1749faefbbb$exports = $2c83071379303a9f$exports && $76bcff007c0cf27f$exports(function() {
    // eslint-disable-next-line es/no-object-defineproperty -- required for testing
    return Object.defineProperty(function() {}, "prototype", {
        value: 42,
        writable: false
    }).prototype !== 42;
});


var $e883a42dd12c4838$exports = {};
"use strict";

var $e883a42dd12c4838$var$$String = String;
var $e883a42dd12c4838$var$$TypeError = TypeError;
// `Assert: Type(argument) is Object`
$e883a42dd12c4838$exports = function(argument) {
    if ($c07ec4a60e179c63$exports(argument)) return argument;
    throw new $e883a42dd12c4838$var$$TypeError($e883a42dd12c4838$var$$String(argument) + " is not an object");
};


var $6a68cf0b56404b3a$exports = {};
"use strict";
var $562ad62be0666d8e$exports = {};
"use strict";
var $0fd3071b38319e18$exports = {};
"use strict";

var $0fd3071b38319e18$var$call = Function.prototype.call;
$0fd3071b38319e18$exports = $e05c8f1ae7606982$exports ? $0fd3071b38319e18$var$call.bind($0fd3071b38319e18$var$call) : function() {
    return $0fd3071b38319e18$var$call.apply($0fd3071b38319e18$var$call, arguments);
};



var $33ce01088d1bda9e$exports = {};
"use strict";
var $1b1dbd8f49b582e1$exports = {};
"use strict";


var $1b1dbd8f49b582e1$var$aFunction = function(argument) {
    return $9b61b9b0573b17f7$exports(argument) ? argument : undefined;
};
$1b1dbd8f49b582e1$exports = function(namespace, method) {
    return arguments.length < 2 ? $1b1dbd8f49b582e1$var$aFunction($e1ff03c6fa941474$exports[namespace]) : $e1ff03c6fa941474$exports[namespace] && $e1ff03c6fa941474$exports[namespace][method];
};



var $c4c5f16903e9d1a1$exports = {};
"use strict";

$c4c5f16903e9d1a1$exports = $723fda74cdbf59ed$exports({}.isPrototypeOf);


var $1999e5df9c3bf219$exports = {};
"use strict";
var $46e40837dd33e05e$exports = {};
"use strict";
var $e43fcedc213afff0$exports = {};
"use strict";

var $8bc8c5b62b36a538$exports = {};
"use strict";
$8bc8c5b62b36a538$exports = typeof navigator != "undefined" && String(navigator.userAgent) || "";


var $e43fcedc213afff0$var$process = $e1ff03c6fa941474$exports.process;
var $e43fcedc213afff0$var$Deno = $e1ff03c6fa941474$exports.Deno;
var $e43fcedc213afff0$var$versions = $e43fcedc213afff0$var$process && $e43fcedc213afff0$var$process.versions || $e43fcedc213afff0$var$Deno && $e43fcedc213afff0$var$Deno.version;
var $e43fcedc213afff0$var$v8 = $e43fcedc213afff0$var$versions && $e43fcedc213afff0$var$versions.v8;
var $e43fcedc213afff0$var$match, $e43fcedc213afff0$var$version;
if ($e43fcedc213afff0$var$v8) {
    $e43fcedc213afff0$var$match = $e43fcedc213afff0$var$v8.split(".");
    // in old Chrome, versions of V8 isn't V8 = Chrome / 10
    // but their correct versions are not interesting for us
    $e43fcedc213afff0$var$version = $e43fcedc213afff0$var$match[0] > 0 && $e43fcedc213afff0$var$match[0] < 4 ? 1 : +($e43fcedc213afff0$var$match[0] + $e43fcedc213afff0$var$match[1]);
}
// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!$e43fcedc213afff0$var$version && $8bc8c5b62b36a538$exports) {
    $e43fcedc213afff0$var$match = $8bc8c5b62b36a538$exports.match(/Edge\/(\d+)/);
    if (!$e43fcedc213afff0$var$match || $e43fcedc213afff0$var$match[1] >= 74) {
        $e43fcedc213afff0$var$match = $8bc8c5b62b36a538$exports.match(/Chrome\/(\d+)/);
        if ($e43fcedc213afff0$var$match) $e43fcedc213afff0$var$version = +$e43fcedc213afff0$var$match[1];
    }
}
$e43fcedc213afff0$exports = $e43fcedc213afff0$var$version;




var $46e40837dd33e05e$var$$String = $e1ff03c6fa941474$exports.String;
// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
$46e40837dd33e05e$exports = !!Object.getOwnPropertySymbols && !$76bcff007c0cf27f$exports(function() {
    var symbol = Symbol("symbol detection");
    // Chrome 38 Symbol has incorrect toString conversion
    // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
    // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
    // of course, fail.
    return !$46e40837dd33e05e$var$$String(symbol) || !(Object(symbol) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && $e43fcedc213afff0$exports && $e43fcedc213afff0$exports < 41;
});


$1999e5df9c3bf219$exports = $46e40837dd33e05e$exports && !Symbol.sham && typeof Symbol.iterator == "symbol";


var $33ce01088d1bda9e$var$$Object = Object;
$33ce01088d1bda9e$exports = $1999e5df9c3bf219$exports ? function(it) {
    return typeof it == "symbol";
} : function(it) {
    var $Symbol = $1b1dbd8f49b582e1$exports("Symbol");
    return $9b61b9b0573b17f7$exports($Symbol) && $c4c5f16903e9d1a1$exports($Symbol.prototype, $33ce01088d1bda9e$var$$Object(it));
};


var $dba0f0316a1990af$exports = {};
"use strict";
var $5d76c1e8ae0615ec$exports = {};
"use strict";

var $3b12be5dcb442e49$exports = {};
"use strict";
var $3b12be5dcb442e49$var$$String = String;
$3b12be5dcb442e49$exports = function(argument) {
    try {
        return $3b12be5dcb442e49$var$$String(argument);
    } catch (error) {
        return "Object";
    }
};


var $5d76c1e8ae0615ec$var$$TypeError = TypeError;
// `Assert: IsCallable(argument) is true`
$5d76c1e8ae0615ec$exports = function(argument) {
    if ($9b61b9b0573b17f7$exports(argument)) return argument;
    throw new $5d76c1e8ae0615ec$var$$TypeError($3b12be5dcb442e49$exports(argument) + " is not a function");
};



// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
$dba0f0316a1990af$exports = function(V, P) {
    var func = V[P];
    return $eb0d61fec8917d97$exports(func) ? undefined : $5d76c1e8ae0615ec$exports(func);
};


var $e7f3376d0148dd77$exports = {};
"use strict";



var $e7f3376d0148dd77$var$$TypeError = TypeError;
// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
$e7f3376d0148dd77$exports = function(input, pref) {
    var fn, val;
    if (pref === "string" && $9b61b9b0573b17f7$exports(fn = input.toString) && !$c07ec4a60e179c63$exports(val = $0fd3071b38319e18$exports(fn, input))) return val;
    if ($9b61b9b0573b17f7$exports(fn = input.valueOf) && !$c07ec4a60e179c63$exports(val = $0fd3071b38319e18$exports(fn, input))) return val;
    if (pref !== "string" && $9b61b9b0573b17f7$exports(fn = input.toString) && !$c07ec4a60e179c63$exports(val = $0fd3071b38319e18$exports(fn, input))) return val;
    throw new $e7f3376d0148dd77$var$$TypeError("Can't convert object to primitive value");
};


var $a1484a06bf9b96e4$exports = {};
"use strict";

var $19c901c2826d8245$exports = {};
"use strict";

$19c901c2826d8245$exports = function(key, value) {
    return $a404859400982ae1$exports[key] || ($a404859400982ae1$exports[key] = value || {});
};



var $eb4edc7169047324$exports = {};
"use strict";

var $eb4edc7169047324$var$id = 0;
var $eb4edc7169047324$var$postfix = Math.random();
var $eb4edc7169047324$var$toString = $723fda74cdbf59ed$exports(1.0.toString);
$eb4edc7169047324$exports = function(key) {
    return "Symbol(" + (key === undefined ? "" : key) + ")_" + $eb4edc7169047324$var$toString(++$eb4edc7169047324$var$id + $eb4edc7169047324$var$postfix, 36);
};




var $a1484a06bf9b96e4$var$Symbol = $e1ff03c6fa941474$exports.Symbol;
var $a1484a06bf9b96e4$var$WellKnownSymbolsStore = $19c901c2826d8245$exports("wks");
var $a1484a06bf9b96e4$var$createWellKnownSymbol = $1999e5df9c3bf219$exports ? $a1484a06bf9b96e4$var$Symbol["for"] || $a1484a06bf9b96e4$var$Symbol : $a1484a06bf9b96e4$var$Symbol && $a1484a06bf9b96e4$var$Symbol.withoutSetter || $eb4edc7169047324$exports;
$a1484a06bf9b96e4$exports = function(name) {
    if (!$004b9e41461fbb75$exports($a1484a06bf9b96e4$var$WellKnownSymbolsStore, name)) $a1484a06bf9b96e4$var$WellKnownSymbolsStore[name] = $46e40837dd33e05e$exports && $004b9e41461fbb75$exports($a1484a06bf9b96e4$var$Symbol, name) ? $a1484a06bf9b96e4$var$Symbol[name] : $a1484a06bf9b96e4$var$createWellKnownSymbol("Symbol." + name);
    return $a1484a06bf9b96e4$var$WellKnownSymbolsStore[name];
};


var $562ad62be0666d8e$var$$TypeError = TypeError;
var $562ad62be0666d8e$var$TO_PRIMITIVE = $a1484a06bf9b96e4$exports("toPrimitive");
// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
$562ad62be0666d8e$exports = function(input, pref) {
    if (!$c07ec4a60e179c63$exports(input) || $33ce01088d1bda9e$exports(input)) return input;
    var exoticToPrim = $dba0f0316a1990af$exports(input, $562ad62be0666d8e$var$TO_PRIMITIVE);
    var result;
    if (exoticToPrim) {
        if (pref === undefined) pref = "default";
        result = $0fd3071b38319e18$exports(exoticToPrim, input, pref);
        if (!$c07ec4a60e179c63$exports(result) || $33ce01088d1bda9e$exports(result)) return result;
        throw new $562ad62be0666d8e$var$$TypeError("Can't convert object to primitive value");
    }
    if (pref === undefined) pref = "number";
    return $e7f3376d0148dd77$exports(input, pref);
};



// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
$6a68cf0b56404b3a$exports = function(argument) {
    var key = $562ad62be0666d8e$exports(argument, "string");
    return $33ce01088d1bda9e$exports(key) ? key : key + "";
};


var $79a74eae6ff4ffba$var$$TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $79a74eae6ff4ffba$var$$defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $79a74eae6ff4ffba$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $79a74eae6ff4ffba$var$ENUMERABLE = "enumerable";
var $79a74eae6ff4ffba$var$CONFIGURABLE = "configurable";
var $79a74eae6ff4ffba$var$WRITABLE = "writable";
$79a74eae6ff4ffba$export$2d1720544b23b823 = $2c83071379303a9f$exports ? $217aa1749faefbbb$exports ? function defineProperty(O, P, Attributes) {
    $e883a42dd12c4838$exports(O);
    P = $6a68cf0b56404b3a$exports(P);
    $e883a42dd12c4838$exports(Attributes);
    if (typeof O === "function" && P === "prototype" && "value" in Attributes && $79a74eae6ff4ffba$var$WRITABLE in Attributes && !Attributes[$79a74eae6ff4ffba$var$WRITABLE]) {
        var current = $79a74eae6ff4ffba$var$$getOwnPropertyDescriptor(O, P);
        if (current && current[$79a74eae6ff4ffba$var$WRITABLE]) {
            O[P] = Attributes.value;
            Attributes = {
                configurable: $79a74eae6ff4ffba$var$CONFIGURABLE in Attributes ? Attributes[$79a74eae6ff4ffba$var$CONFIGURABLE] : current[$79a74eae6ff4ffba$var$CONFIGURABLE],
                enumerable: $79a74eae6ff4ffba$var$ENUMERABLE in Attributes ? Attributes[$79a74eae6ff4ffba$var$ENUMERABLE] : current[$79a74eae6ff4ffba$var$ENUMERABLE],
                writable: false
            };
        }
    }
    return $79a74eae6ff4ffba$var$$defineProperty(O, P, Attributes);
} : $79a74eae6ff4ffba$var$$defineProperty : function defineProperty(O, P, Attributes) {
    $e883a42dd12c4838$exports(O);
    P = $6a68cf0b56404b3a$exports(P);
    $e883a42dd12c4838$exports(Attributes);
    if ($6da06ad05f8a0c25$exports) try {
        return $79a74eae6ff4ffba$var$$defineProperty(O, P, Attributes);
    } catch (error) {}
    if ("get" in Attributes || "set" in Attributes) throw new $79a74eae6ff4ffba$var$$TypeError("Accessors not supported");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};


var $6046129531914f03$exports = {};
"use strict";
$6046129531914f03$exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};


$706328f2b8cfdcc8$exports = $2c83071379303a9f$exports ? function(object, key, value) {
    return $79a74eae6ff4ffba$export$2d1720544b23b823(object, key, $6046129531914f03$exports(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};




var $0e34baf82d26a97d$exports = {};
"use strict";


var $0e34baf82d26a97d$var$keys = $19c901c2826d8245$exports("keys");
$0e34baf82d26a97d$exports = function(key) {
    return $0e34baf82d26a97d$var$keys[key] || ($0e34baf82d26a97d$var$keys[key] = $eb4edc7169047324$exports(key));
};


var $14d40d35f2c0beb2$exports = {};
"use strict";
$14d40d35f2c0beb2$exports = {};


var $e4c18f9df98cbb78$var$OBJECT_ALREADY_INITIALIZED = "Object already initialized";
var $e4c18f9df98cbb78$var$TypeError = $e1ff03c6fa941474$exports.TypeError;
var $e4c18f9df98cbb78$var$WeakMap = $e1ff03c6fa941474$exports.WeakMap;
var $e4c18f9df98cbb78$var$set, $e4c18f9df98cbb78$var$get, $e4c18f9df98cbb78$var$has;
var $e4c18f9df98cbb78$var$enforce = function(it) {
    return $e4c18f9df98cbb78$var$has(it) ? $e4c18f9df98cbb78$var$get(it) : $e4c18f9df98cbb78$var$set(it, {});
};
var $e4c18f9df98cbb78$var$getterFor = function(TYPE) {
    return function(it) {
        var state;
        if (!$c07ec4a60e179c63$exports(it) || (state = $e4c18f9df98cbb78$var$get(it)).type !== TYPE) throw new $e4c18f9df98cbb78$var$TypeError("Incompatible receiver, " + TYPE + " required");
        return state;
    };
};
if ($3cb9b42f58538e96$exports || $a404859400982ae1$exports.state) {
    var $e4c18f9df98cbb78$var$store = $a404859400982ae1$exports.state || ($a404859400982ae1$exports.state = new $e4c18f9df98cbb78$var$WeakMap());
    /* eslint-disable no-self-assign -- prototype methods protection */ $e4c18f9df98cbb78$var$store.get = $e4c18f9df98cbb78$var$store.get;
    $e4c18f9df98cbb78$var$store.has = $e4c18f9df98cbb78$var$store.has;
    $e4c18f9df98cbb78$var$store.set = $e4c18f9df98cbb78$var$store.set;
    /* eslint-enable no-self-assign -- prototype methods protection */ $e4c18f9df98cbb78$var$set = function(it, metadata) {
        if ($e4c18f9df98cbb78$var$store.has(it)) throw new $e4c18f9df98cbb78$var$TypeError($e4c18f9df98cbb78$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $e4c18f9df98cbb78$var$store.set(it, metadata);
        return metadata;
    };
    $e4c18f9df98cbb78$var$get = function(it) {
        return $e4c18f9df98cbb78$var$store.get(it) || {};
    };
    $e4c18f9df98cbb78$var$has = function(it) {
        return $e4c18f9df98cbb78$var$store.has(it);
    };
} else {
    var $e4c18f9df98cbb78$var$STATE = $0e34baf82d26a97d$exports("state");
    $14d40d35f2c0beb2$exports[$e4c18f9df98cbb78$var$STATE] = true;
    $e4c18f9df98cbb78$var$set = function(it, metadata) {
        if ($004b9e41461fbb75$exports(it, $e4c18f9df98cbb78$var$STATE)) throw new $e4c18f9df98cbb78$var$TypeError($e4c18f9df98cbb78$var$OBJECT_ALREADY_INITIALIZED);
        metadata.facade = it;
        $706328f2b8cfdcc8$exports(it, $e4c18f9df98cbb78$var$STATE, metadata);
        return metadata;
    };
    $e4c18f9df98cbb78$var$get = function(it) {
        return $004b9e41461fbb75$exports(it, $e4c18f9df98cbb78$var$STATE) ? it[$e4c18f9df98cbb78$var$STATE] : {};
    };
    $e4c18f9df98cbb78$var$has = function(it) {
        return $004b9e41461fbb75$exports(it, $e4c18f9df98cbb78$var$STATE);
    };
}
$e4c18f9df98cbb78$exports = {
    set: $e4c18f9df98cbb78$var$set,
    get: $e4c18f9df98cbb78$var$get,
    has: $e4c18f9df98cbb78$var$has,
    enforce: $e4c18f9df98cbb78$var$enforce,
    getterFor: $e4c18f9df98cbb78$var$getterFor
};


var $6d241c82552a4b25$var$enforceInternalState = $e4c18f9df98cbb78$exports.enforce;
var $6d241c82552a4b25$var$getInternalState = $e4c18f9df98cbb78$exports.get;
var $6d241c82552a4b25$var$$String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $6d241c82552a4b25$var$defineProperty = Object.defineProperty;
var $6d241c82552a4b25$var$stringSlice = $723fda74cdbf59ed$exports("".slice);
var $6d241c82552a4b25$var$replace = $723fda74cdbf59ed$exports("".replace);
var $6d241c82552a4b25$var$join = $723fda74cdbf59ed$exports([].join);
var $6d241c82552a4b25$var$CONFIGURABLE_LENGTH = $2c83071379303a9f$exports && !$76bcff007c0cf27f$exports(function() {
    return $6d241c82552a4b25$var$defineProperty(function() {}, "length", {
        value: 8
    }).length !== 8;
});
var $6d241c82552a4b25$var$TEMPLATE = String(String).split("String");
var $6d241c82552a4b25$var$makeBuiltIn = $6d241c82552a4b25$exports = function(value, name, options) {
    if ($6d241c82552a4b25$var$stringSlice($6d241c82552a4b25$var$$String(name), 0, 7) === "Symbol(") name = "[" + $6d241c82552a4b25$var$replace($6d241c82552a4b25$var$$String(name), /^Symbol\(([^)]*)\).*$/, "$1") + "]";
    if (options && options.getter) name = "get " + name;
    if (options && options.setter) name = "set " + name;
    if (!$004b9e41461fbb75$exports(value, "name") || $6d241c82552a4b25$require$CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
        if ($2c83071379303a9f$exports) $6d241c82552a4b25$var$defineProperty(value, "name", {
            value: name,
            configurable: true
        });
        else value.name = name;
    }
    if ($6d241c82552a4b25$var$CONFIGURABLE_LENGTH && options && $004b9e41461fbb75$exports(options, "arity") && value.length !== options.arity) $6d241c82552a4b25$var$defineProperty(value, "length", {
        value: options.arity
    });
    try {
        if (options && $004b9e41461fbb75$exports(options, "constructor") && options.constructor) {
            if ($2c83071379303a9f$exports) $6d241c82552a4b25$var$defineProperty(value, "prototype", {
                writable: false
            });
        } else if (value.prototype) value.prototype = undefined;
    } catch (error) {}
    var state = $6d241c82552a4b25$var$enforceInternalState(value);
    if (!$004b9e41461fbb75$exports(state, "source")) state.source = $6d241c82552a4b25$var$join($6d241c82552a4b25$var$TEMPLATE, typeof name == "string" ? name : "");
    return value;
};
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = $6d241c82552a4b25$var$makeBuiltIn(function toString() {
    return $9b61b9b0573b17f7$exports(this) && $6d241c82552a4b25$var$getInternalState(this).source || $4b6728e533030a0e$exports(this);
}, "toString");



$3797c5fdbd33f20c$exports = function(target, name, descriptor) {
    if (descriptor.get) $6d241c82552a4b25$exports(descriptor.get, name, {
        getter: true
    });
    if (descriptor.set) $6d241c82552a4b25$exports(descriptor.set, name, {
        setter: true
    });
    return $79a74eae6ff4ffba$export$2d1720544b23b823(target, name, descriptor);
};


var $7f0ac49ae29588b5$exports = {};
"use strict";

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
$7f0ac49ae29588b5$exports = function() {
    var that = $e883a42dd12c4838$exports(this);
    var result = "";
    if (that.hasIndices) result += "d";
    if (that.global) result += "g";
    if (that.ignoreCase) result += "i";
    if (that.multiline) result += "m";
    if (that.dotAll) result += "s";
    if (that.unicode) result += "u";
    if (that.unicodeSets) result += "v";
    if (that.sticky) result += "y";
    return result;
};



// babel-minify and Closure Compiler transpiles RegExp('.', 'd') -> /./d and it causes SyntaxError
var $e56d5e8571529913$var$RegExp = $e1ff03c6fa941474$exports.RegExp;
var $e56d5e8571529913$var$RegExpPrototype = $e56d5e8571529913$var$RegExp.prototype;
var $e56d5e8571529913$var$FORCED = $2c83071379303a9f$exports && $76bcff007c0cf27f$exports(function() {
    var INDICES_SUPPORT = true;
    try {
        $e56d5e8571529913$var$RegExp(".", "d");
    } catch (error) {
        INDICES_SUPPORT = false;
    }
    var O = {};
    // modern V8 bug
    var calls = "";
    var expected = INDICES_SUPPORT ? "dgimsy" : "gimsy";
    var addGetter = function(key, chr) {
        // eslint-disable-next-line es/no-object-defineproperty -- safe
        Object.defineProperty(O, key, {
            get: function() {
                calls += chr;
                return true;
            }
        });
    };
    var pairs = {
        dotAll: "s",
        global: "g",
        ignoreCase: "i",
        multiline: "m",
        sticky: "y"
    };
    if (INDICES_SUPPORT) pairs.hasIndices = "d";
    for(var key in pairs)addGetter(key, pairs[key]);
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    var result = Object.getOwnPropertyDescriptor($e56d5e8571529913$var$RegExpPrototype, "flags").get.call(O);
    return result !== expected || calls !== expected;
});
// `RegExp.prototype.flags` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
if ($e56d5e8571529913$var$FORCED) $3797c5fdbd33f20c$exports($e56d5e8571529913$var$RegExpPrototype, "flags", {
    configurable: true,
    get: $7f0ac49ae29588b5$exports
});


"use strict";
"use strict";
var $f14b58df6ac82177$exports = {};
"use strict";

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var $de16ec10287f79ac$export$2d1720544b23b823;
"use strict";


// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var $fa97cd646a7a143d$export$2d1720544b23b823;
"use strict";
var $fa97cd646a7a143d$var$$propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $fa97cd646a7a143d$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
// Nashorn ~ JDK8 bug
var $fa97cd646a7a143d$var$NASHORN_BUG = $fa97cd646a7a143d$var$getOwnPropertyDescriptor && !$fa97cd646a7a143d$var$$propertyIsEnumerable.call({
    1: 2
}, 1);
$fa97cd646a7a143d$export$2d1720544b23b823 = $fa97cd646a7a143d$var$NASHORN_BUG ? function propertyIsEnumerable(V) {
    var descriptor = $fa97cd646a7a143d$var$getOwnPropertyDescriptor(this, V);
    return !!descriptor && descriptor.enumerable;
} : $fa97cd646a7a143d$var$$propertyIsEnumerable;



var $cdcc34a999dfffef$exports = {};
"use strict";
var $33320b1e6da73f3f$exports = {};
"use strict";


var $89bf669d1dfb6667$exports = {};
"use strict";

var $89bf669d1dfb6667$var$toString = $723fda74cdbf59ed$exports({}.toString);
var $89bf669d1dfb6667$var$stringSlice = $723fda74cdbf59ed$exports("".slice);
$89bf669d1dfb6667$exports = function(it) {
    return $89bf669d1dfb6667$var$stringSlice($89bf669d1dfb6667$var$toString(it), 8, -1);
};


var $33320b1e6da73f3f$var$$Object = Object;
var $33320b1e6da73f3f$var$split = $723fda74cdbf59ed$exports("".split);
// fallback for non-array-like ES3 and non-enumerable old V8 strings
$33320b1e6da73f3f$exports = $76bcff007c0cf27f$exports(function() {
    // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
    // eslint-disable-next-line no-prototype-builtins -- safe
    return !$33320b1e6da73f3f$var$$Object("z").propertyIsEnumerable(0);
}) ? function(it) {
    return $89bf669d1dfb6667$exports(it) === "String" ? $33320b1e6da73f3f$var$split(it, "") : $33320b1e6da73f3f$var$$Object(it);
} : $33320b1e6da73f3f$var$$Object;



$cdcc34a999dfffef$exports = function(it) {
    return $33320b1e6da73f3f$exports($304f0191f62b181f$exports(it));
};





// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $de16ec10287f79ac$var$$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
$de16ec10287f79ac$export$2d1720544b23b823 = $2c83071379303a9f$exports ? $de16ec10287f79ac$var$$getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
    O = $cdcc34a999dfffef$exports(O);
    P = $6a68cf0b56404b3a$exports(P);
    if ($6da06ad05f8a0c25$exports) try {
        return $de16ec10287f79ac$var$$getOwnPropertyDescriptor(O, P);
    } catch (error) {}
    if ($004b9e41461fbb75$exports(O, P)) return $6046129531914f03$exports(!$0fd3071b38319e18$exports($fa97cd646a7a143d$export$2d1720544b23b823, O, P), O[P]);
};


var $f14b58df6ac82177$require$getOwnPropertyDescriptor = $de16ec10287f79ac$export$2d1720544b23b823;

var $3f7d34c549adf346$exports = {};
"use strict";




$3f7d34c549adf346$exports = function(O, key, value, options) {
    if (!options) options = {};
    var simple = options.enumerable;
    var name = options.name !== undefined ? options.name : key;
    if ($9b61b9b0573b17f7$exports(value)) $6d241c82552a4b25$exports(value, name, options);
    if (options.global) {
        if (simple) O[key] = value;
        else $1d43b83fad5a0875$exports(key, value);
    } else {
        try {
            if (!options.unsafe) delete O[key];
            else if (O[key]) simple = true;
        } catch (error) {}
        if (simple) O[key] = value;
        else $79a74eae6ff4ffba$export$2d1720544b23b823(O, key, {
            value: value,
            enumerable: false,
            configurable: !options.nonConfigurable,
            writable: !options.nonWritable
        });
    }
    return O;
};



var $816310588e7b9406$exports = {};
"use strict";

var $38008a5a870d37db$exports = {};
"use strict";


// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var $b3b957b7d2365f6d$export$2d1720544b23b823;
"use strict";
var $1a4fc7f21dbc1dd5$exports = {};
"use strict";



var $6d6960beeda8ce8b$exports = {};
"use strict";

var $7eaed3c233519efd$exports = {};
"use strict";
var $a4ff0d40b957508f$exports = {};
"use strict";
var $9806ad5f31e6a734$exports = {};
"use strict";
var $9806ad5f31e6a734$var$ceil = Math.ceil;
var $9806ad5f31e6a734$var$floor = Math.floor;
// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
$9806ad5f31e6a734$exports = Math.trunc || function trunc(x) {
    var n = +x;
    return (n > 0 ? $9806ad5f31e6a734$var$floor : $9806ad5f31e6a734$var$ceil)(n);
};


// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
$a4ff0d40b957508f$exports = function(argument) {
    var number = +argument;
    // eslint-disable-next-line no-self-compare -- NaN check
    return number !== number || number === 0 ? 0 : $9806ad5f31e6a734$exports(number);
};


var $7eaed3c233519efd$var$max = Math.max;
var $7eaed3c233519efd$var$min = Math.min;
// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
$7eaed3c233519efd$exports = function(index, length) {
    var integer = $a4ff0d40b957508f$exports(index);
    return integer < 0 ? $7eaed3c233519efd$var$max(integer + length, 0) : $7eaed3c233519efd$var$min(integer, length);
};


var $67e3caeb1725456a$exports = {};
"use strict";
var $98a03685d3e4d55c$exports = {};
"use strict";

var $98a03685d3e4d55c$var$min = Math.min;
// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
$98a03685d3e4d55c$exports = function(argument) {
    var len = $a4ff0d40b957508f$exports(argument);
    return len > 0 ? $98a03685d3e4d55c$var$min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
$67e3caeb1725456a$exports = function(obj) {
    return $98a03685d3e4d55c$exports(obj.length);
};


// `Array.prototype.{ indexOf, includes }` methods implementation
var $6d6960beeda8ce8b$var$createMethod = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $cdcc34a999dfffef$exports($this);
        var length = $67e3caeb1725456a$exports(O);
        if (length === 0) return !IS_INCLUDES && -1;
        var index = $7eaed3c233519efd$exports(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare -- NaN check
        if (IS_INCLUDES && el !== el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare -- NaN check
            if (value !== value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++){
            if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};
$6d6960beeda8ce8b$exports = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: $6d6960beeda8ce8b$var$createMethod(true),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: $6d6960beeda8ce8b$var$createMethod(false)
};


var $1a4fc7f21dbc1dd5$require$indexOf = $6d6960beeda8ce8b$exports.indexOf;

var $1a4fc7f21dbc1dd5$var$push = $723fda74cdbf59ed$exports([].push);
$1a4fc7f21dbc1dd5$exports = function(object, names) {
    var O = $cdcc34a999dfffef$exports(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)!$004b9e41461fbb75$exports($14d40d35f2c0beb2$exports, key) && $004b9e41461fbb75$exports(O, key) && $1a4fc7f21dbc1dd5$var$push(result, key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($004b9e41461fbb75$exports(O, key = names[i++])) ~$1a4fc7f21dbc1dd5$require$indexOf(result, key) || $1a4fc7f21dbc1dd5$var$push(result, key);
    return result;
};


var $467a9c173af6a6ce$exports = {};
"use strict";
// IE8- don't enum bug keys
$467a9c173af6a6ce$exports = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
];


var $b3b957b7d2365f6d$var$hiddenKeys = $467a9c173af6a6ce$exports.concat("length", "prototype");
$b3b957b7d2365f6d$export$2d1720544b23b823 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
    return $1a4fc7f21dbc1dd5$exports(O, $b3b957b7d2365f6d$var$hiddenKeys);
};


// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var $4b33ca3d75a0827e$export$2d1720544b23b823;
"use strict";
$4b33ca3d75a0827e$export$2d1720544b23b823 = Object.getOwnPropertySymbols;



var $38008a5a870d37db$var$concat = $723fda74cdbf59ed$exports([].concat);
// all object keys, includes non-enumerable and symbols
$38008a5a870d37db$exports = $1b1dbd8f49b582e1$exports("Reflect", "ownKeys") || function ownKeys(it) {
    var keys = $b3b957b7d2365f6d$export$2d1720544b23b823($e883a42dd12c4838$exports(it));
    var getOwnPropertySymbols = $4b33ca3d75a0827e$export$2d1720544b23b823;
    return getOwnPropertySymbols ? $38008a5a870d37db$var$concat(keys, getOwnPropertySymbols(it)) : keys;
};




$816310588e7b9406$exports = function(target, source, exceptions) {
    var keys = $38008a5a870d37db$exports(source);
    var defineProperty = $79a74eae6ff4ffba$export$2d1720544b23b823;
    var getOwnPropertyDescriptor = $de16ec10287f79ac$export$2d1720544b23b823;
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        if (!$004b9e41461fbb75$exports(target, key) && !(exceptions && $004b9e41461fbb75$exports(exceptions, key))) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
};


var $0820dd7485663a4c$exports = {};
"use strict";


var $0820dd7485663a4c$var$replacement = /#|\.prototype\./;
var $0820dd7485663a4c$var$isForced = function(feature, detection) {
    var value = $0820dd7485663a4c$var$data[$0820dd7485663a4c$var$normalize(feature)];
    return value === $0820dd7485663a4c$var$POLYFILL ? true : value === $0820dd7485663a4c$var$NATIVE ? false : $9b61b9b0573b17f7$exports(detection) ? $76bcff007c0cf27f$exports(detection) : !!detection;
};
var $0820dd7485663a4c$var$normalize = $0820dd7485663a4c$var$isForced.normalize = function(string) {
    return String(string).replace($0820dd7485663a4c$var$replacement, ".").toLowerCase();
};
var $0820dd7485663a4c$var$data = $0820dd7485663a4c$var$isForced.data = {};
var $0820dd7485663a4c$var$NATIVE = $0820dd7485663a4c$var$isForced.NATIVE = "N";
var $0820dd7485663a4c$var$POLYFILL = $0820dd7485663a4c$var$isForced.POLYFILL = "P";
$0820dd7485663a4c$exports = $0820dd7485663a4c$var$isForced;


/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/ $f14b58df6ac82177$exports = function(options, source) {
    var TARGET = options.target;
    var GLOBAL = options.global;
    var STATIC = options.stat;
    var FORCED, target, key, targetProperty, sourceProperty, descriptor;
    if (GLOBAL) target = $e1ff03c6fa941474$exports;
    else if (STATIC) target = $e1ff03c6fa941474$exports[TARGET] || $1d43b83fad5a0875$exports(TARGET, {});
    else target = $e1ff03c6fa941474$exports[TARGET] && $e1ff03c6fa941474$exports[TARGET].prototype;
    if (target) for(key in source){
        sourceProperty = source[key];
        if (options.dontCallGetSet) {
            descriptor = $f14b58df6ac82177$require$getOwnPropertyDescriptor(target, key);
            targetProperty = descriptor && descriptor.value;
        } else targetProperty = target[key];
        FORCED = $0820dd7485663a4c$exports(GLOBAL ? key : TARGET + (STATIC ? "." : "#") + key, options.forced);
        // contained in target
        if (!FORCED && targetProperty !== undefined) {
            if (typeof sourceProperty == typeof targetProperty) continue;
            $816310588e7b9406$exports(sourceProperty, targetProperty);
        }
        // add a flag to not completely full polyfills
        if (options.sham || targetProperty && targetProperty.sham) $706328f2b8cfdcc8$exports(sourceProperty, "sham", true);
        $3f7d34c549adf346$exports(target, key, sourceProperty, options);
    }
};



var $68aa1d4e4481a5a7$exports = {};
"use strict";

var $b13825c107086a4e$exports = {};
"use strict";

var $b13825c107086a4e$var$FunctionPrototype = Function.prototype;
var $b13825c107086a4e$var$apply = $b13825c107086a4e$var$FunctionPrototype.apply;
var $b13825c107086a4e$var$call = $b13825c107086a4e$var$FunctionPrototype.call;
// eslint-disable-next-line es/no-reflect -- safe
$b13825c107086a4e$exports = typeof Reflect == "object" && Reflect.apply || ($e05c8f1ae7606982$exports ? $b13825c107086a4e$var$call.bind($b13825c107086a4e$var$apply) : function() {
    return $b13825c107086a4e$var$call.apply($b13825c107086a4e$var$apply, arguments);
});


var $841574820d1439fe$exports = {};
"use strict";
var $e04351a3d7851fbc$exports = {};
"use strict";


$e04351a3d7851fbc$exports = function(fn) {
    // Nashorn bug:
    //   https://github.com/zloirock/core-js/issues/1128
    //   https://github.com/zloirock/core-js/issues/1130
    if ($89bf669d1dfb6667$exports(fn) === "Function") return $723fda74cdbf59ed$exports(fn);
};




var $841574820d1439fe$var$bind = $e04351a3d7851fbc$exports($e04351a3d7851fbc$exports.bind);
// optional / simple context binding
$841574820d1439fe$exports = function(fn, that) {
    $5d76c1e8ae0615ec$exports(fn);
    return that === undefined ? fn : $e05c8f1ae7606982$exports ? $841574820d1439fe$var$bind(fn, that) : function() {
        return fn.apply(that, arguments);
    };
};





var $072e54ef96989b13$exports = {};
"use strict";

$072e54ef96989b13$exports = $1b1dbd8f49b582e1$exports("document", "documentElement");


var $82ccf5ceb9ffbd83$exports = {};
"use strict";

$82ccf5ceb9ffbd83$exports = $723fda74cdbf59ed$exports([].slice);



var $028abf92d13b5721$exports = {};
"use strict";
var $028abf92d13b5721$var$$TypeError = TypeError;
$028abf92d13b5721$exports = function(passed, required) {
    if (passed < required) throw new $028abf92d13b5721$var$$TypeError("Not enough arguments");
    return passed;
};


var $4732463bdf542553$exports = {};
"use strict";

// eslint-disable-next-line redos/no-vulnerable -- safe
$4732463bdf542553$exports = /(?:ipad|iphone|ipod).*applewebkit/i.test($8bc8c5b62b36a538$exports);


var $95374a5f6a03ab9e$exports = {};
"use strict";


$95374a5f6a03ab9e$exports = $89bf669d1dfb6667$exports($e1ff03c6fa941474$exports.process) === "process";


var $68aa1d4e4481a5a7$var$set = $e1ff03c6fa941474$exports.setImmediate;
var $68aa1d4e4481a5a7$var$clear = $e1ff03c6fa941474$exports.clearImmediate;
var $68aa1d4e4481a5a7$var$process = $e1ff03c6fa941474$exports.process;
var $68aa1d4e4481a5a7$var$Dispatch = $e1ff03c6fa941474$exports.Dispatch;
var $68aa1d4e4481a5a7$var$Function = $e1ff03c6fa941474$exports.Function;
var $68aa1d4e4481a5a7$var$MessageChannel = $e1ff03c6fa941474$exports.MessageChannel;
var $68aa1d4e4481a5a7$var$String = $e1ff03c6fa941474$exports.String;
var $68aa1d4e4481a5a7$var$counter = 0;
var $68aa1d4e4481a5a7$var$queue = {};
var $68aa1d4e4481a5a7$var$ONREADYSTATECHANGE = "onreadystatechange";
var $68aa1d4e4481a5a7$var$$location, $68aa1d4e4481a5a7$var$defer, $68aa1d4e4481a5a7$var$channel, $68aa1d4e4481a5a7$var$port;
$76bcff007c0cf27f$exports(function() {
    // Deno throws a ReferenceError on `location` access without `--location` flag
    $68aa1d4e4481a5a7$var$$location = $e1ff03c6fa941474$exports.location;
});
var $68aa1d4e4481a5a7$var$run = function(id) {
    if ($004b9e41461fbb75$exports($68aa1d4e4481a5a7$var$queue, id)) {
        var fn = $68aa1d4e4481a5a7$var$queue[id];
        delete $68aa1d4e4481a5a7$var$queue[id];
        fn();
    }
};
var $68aa1d4e4481a5a7$var$runner = function(id) {
    return function() {
        $68aa1d4e4481a5a7$var$run(id);
    };
};
var $68aa1d4e4481a5a7$var$eventListener = function(event) {
    $68aa1d4e4481a5a7$var$run(event.data);
};
var $68aa1d4e4481a5a7$var$globalPostMessageDefer = function(id) {
    // old engines have not location.origin
    $e1ff03c6fa941474$exports.postMessage($68aa1d4e4481a5a7$var$String(id), $68aa1d4e4481a5a7$var$$location.protocol + "//" + $68aa1d4e4481a5a7$var$$location.host);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!$68aa1d4e4481a5a7$var$set || !$68aa1d4e4481a5a7$var$clear) {
    $68aa1d4e4481a5a7$var$set = function setImmediate(handler) {
        $028abf92d13b5721$exports(arguments.length, 1);
        var fn = $9b61b9b0573b17f7$exports(handler) ? handler : $68aa1d4e4481a5a7$var$Function(handler);
        var args = $82ccf5ceb9ffbd83$exports(arguments, 1);
        $68aa1d4e4481a5a7$var$queue[++$68aa1d4e4481a5a7$var$counter] = function() {
            $b13825c107086a4e$exports(fn, undefined, args);
        };
        $68aa1d4e4481a5a7$var$defer($68aa1d4e4481a5a7$var$counter);
        return $68aa1d4e4481a5a7$var$counter;
    };
    $68aa1d4e4481a5a7$var$clear = function clearImmediate(id) {
        delete $68aa1d4e4481a5a7$var$queue[id];
    };
    // Node.js 0.8-
    if ($95374a5f6a03ab9e$exports) $68aa1d4e4481a5a7$var$defer = function(id) {
        $68aa1d4e4481a5a7$var$process.nextTick($68aa1d4e4481a5a7$var$runner(id));
    };
    else if ($68aa1d4e4481a5a7$var$Dispatch && $68aa1d4e4481a5a7$var$Dispatch.now) $68aa1d4e4481a5a7$var$defer = function(id) {
        $68aa1d4e4481a5a7$var$Dispatch.now($68aa1d4e4481a5a7$var$runner(id));
    };
    else if ($68aa1d4e4481a5a7$var$MessageChannel && !$4732463bdf542553$exports) {
        $68aa1d4e4481a5a7$var$channel = new $68aa1d4e4481a5a7$var$MessageChannel();
        $68aa1d4e4481a5a7$var$port = $68aa1d4e4481a5a7$var$channel.port2;
        $68aa1d4e4481a5a7$var$channel.port1.onmessage = $68aa1d4e4481a5a7$var$eventListener;
        $68aa1d4e4481a5a7$var$defer = $841574820d1439fe$exports($68aa1d4e4481a5a7$var$port.postMessage, $68aa1d4e4481a5a7$var$port);
    // Browsers with postMessage, skip WebWorkers
    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
    } else if ($e1ff03c6fa941474$exports.addEventListener && $9b61b9b0573b17f7$exports($e1ff03c6fa941474$exports.postMessage) && !$e1ff03c6fa941474$exports.importScripts && $68aa1d4e4481a5a7$var$$location && $68aa1d4e4481a5a7$var$$location.protocol !== "file:" && !$76bcff007c0cf27f$exports($68aa1d4e4481a5a7$var$globalPostMessageDefer)) {
        $68aa1d4e4481a5a7$var$defer = $68aa1d4e4481a5a7$var$globalPostMessageDefer;
        $e1ff03c6fa941474$exports.addEventListener("message", $68aa1d4e4481a5a7$var$eventListener, false);
    // IE8-
    } else if ($68aa1d4e4481a5a7$var$ONREADYSTATECHANGE in $da3614cb53cb7d1a$exports("script")) $68aa1d4e4481a5a7$var$defer = function(id) {
        $072e54ef96989b13$exports.appendChild($da3614cb53cb7d1a$exports("script"))[$68aa1d4e4481a5a7$var$ONREADYSTATECHANGE] = function() {
            $072e54ef96989b13$exports.removeChild(this);
            $68aa1d4e4481a5a7$var$run(id);
        };
    };
    else $68aa1d4e4481a5a7$var$defer = function(id) {
        setTimeout($68aa1d4e4481a5a7$var$runner(id), 0);
    };
}
$68aa1d4e4481a5a7$exports = {
    set: $68aa1d4e4481a5a7$var$set,
    clear: $68aa1d4e4481a5a7$var$clear
};


var $c11286f57942b02e$require$clearImmediate = $68aa1d4e4481a5a7$exports.clear;
// `clearImmediate` method
// http://w3c.github.io/setImmediate/#si-clearImmediate
$f14b58df6ac82177$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $e1ff03c6fa941474$exports.clearImmediate !== $c11286f57942b02e$require$clearImmediate
}, {
    clearImmediate: $c11286f57942b02e$require$clearImmediate
});


"use strict";



var $11090601d2e7fdcb$require$setTask = $68aa1d4e4481a5a7$exports.set;
var $f403c376fbe2f491$exports = {};
"use strict";



var $2015439661fea47a$exports = {};
"use strict";
/* global Bun -- Bun case */ $2015439661fea47a$exports = typeof Bun == "function" && Bun && typeof Bun.version == "string";





var $f403c376fbe2f491$var$Function = $e1ff03c6fa941474$exports.Function;
// dirty IE9- and Bun 0.3.0- checks
var $f403c376fbe2f491$var$WRAP = /MSIE .\./.test($8bc8c5b62b36a538$exports) || $2015439661fea47a$exports && function() {
    var version = $e1ff03c6fa941474$exports.Bun.version.split(".");
    return version.length < 3 || version[0] === "0" && (version[1] < 3 || version[1] === "3" && version[2] === "0");
}();
// IE9- / Bun 0.3.0- setTimeout / setInterval / setImmediate additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
// https://github.com/oven-sh/bun/issues/1633
$f403c376fbe2f491$exports = function(scheduler, hasTimeArg) {
    var firstParamIndex = hasTimeArg ? 2 : 1;
    return $f403c376fbe2f491$var$WRAP ? function(handler, timeout /* , ...arguments */ ) {
        var boundArgs = $028abf92d13b5721$exports(arguments.length, 1) > firstParamIndex;
        var fn = $9b61b9b0573b17f7$exports(handler) ? handler : $f403c376fbe2f491$var$Function(handler);
        var params = boundArgs ? $82ccf5ceb9ffbd83$exports(arguments, firstParamIndex) : [];
        var callback = boundArgs ? function() {
            $b13825c107086a4e$exports(fn, this, params);
        } : fn;
        return hasTimeArg ? scheduler(callback, timeout) : scheduler(callback);
    } : scheduler;
};


// https://github.com/oven-sh/bun/issues/1633
var $11090601d2e7fdcb$var$setImmediate = $e1ff03c6fa941474$exports.setImmediate ? $f403c376fbe2f491$exports($11090601d2e7fdcb$require$setTask, false) : $11090601d2e7fdcb$require$setTask;
// `setImmediate` method
// http://w3c.github.io/setImmediate/#si-setImmediate
$f14b58df6ac82177$exports({
    global: true,
    bind: true,
    enumerable: true,
    forced: $e1ff03c6fa941474$exports.setImmediate !== $11090601d2e7fdcb$var$setImmediate
}, {
    setImmediate: $11090601d2e7fdcb$var$setImmediate
});




var $ba93bb4fdbad5ba0$exports = {};
"use strict";

$ba93bb4fdbad5ba0$exports = (parcelRequire("6JwYZ"));


var $6207c3e06a50ee5c$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6207c3e06a50ee5c$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $6207c3e06a50ee5c$exports));
try {
    regeneratorRuntime = $6207c3e06a50ee5c$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $6207c3e06a50ee5c$var$runtime;
    else Function("r", "regeneratorRuntime = r")($6207c3e06a50ee5c$var$runtime);
}


parcelRequire("fgmOP");

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $e2e041e4a1657497$var$extendStatics = function(d, b) {
    $e2e041e4a1657497$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $e2e041e4a1657497$var$extendStatics(d, b);
};
function $e2e041e4a1657497$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $e2e041e4a1657497$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e2e041e4a1657497$export$18ce0697a983be9b = function() {
    $e2e041e4a1657497$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e2e041e4a1657497$export$18ce0697a983be9b.apply(this, arguments);
};
function $e2e041e4a1657497$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e2e041e4a1657497$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e2e041e4a1657497$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e2e041e4a1657497$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $e2e041e4a1657497$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $e2e041e4a1657497$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $e2e041e4a1657497$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $e2e041e4a1657497$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e2e041e4a1657497$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e2e041e4a1657497$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $e2e041e4a1657497$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $e2e041e4a1657497$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $e2e041e4a1657497$export$45d3717a4c69092e(o, m, p);
}
function $e2e041e4a1657497$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e2e041e4a1657497$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e2e041e4a1657497$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e2e041e4a1657497$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e2e041e4a1657497$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e2e041e4a1657497$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $e2e041e4a1657497$export$10c90e4f7922046c(v) {
    return this instanceof $e2e041e4a1657497$export$10c90e4f7922046c ? (this.v = v, this) : new $e2e041e4a1657497$export$10c90e4f7922046c(v);
}
function $e2e041e4a1657497$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e2e041e4a1657497$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e2e041e4a1657497$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e2e041e4a1657497$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $e2e041e4a1657497$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e2e041e4a1657497$export$19a8beecd37a4c45 === "function" ? $e2e041e4a1657497$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e2e041e4a1657497$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $e2e041e4a1657497$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $e2e041e4a1657497$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $e2e041e4a1657497$export$45d3717a4c69092e(result, mod, k);
    }
    $e2e041e4a1657497$var$__setModuleDefault(result, mod);
    return result;
}
function $e2e041e4a1657497$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e2e041e4a1657497$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $e2e041e4a1657497$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $e2e041e4a1657497$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $e2e041e4a1657497$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $e2e041e4a1657497$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $e2e041e4a1657497$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $e2e041e4a1657497$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $e2e041e4a1657497$export$2e2bcd8739ae039 = {
    __extends: $e2e041e4a1657497$export$a8ba968b8961cb8a,
    __assign: $e2e041e4a1657497$export$18ce0697a983be9b,
    __rest: $e2e041e4a1657497$export$3c9a16f847548506,
    __decorate: $e2e041e4a1657497$export$29e00dfd3077644b,
    __param: $e2e041e4a1657497$export$d5ad3fd78186038f,
    __metadata: $e2e041e4a1657497$export$f1db080c865becb9,
    __awaiter: $e2e041e4a1657497$export$1050f835b63b671e,
    __generator: $e2e041e4a1657497$export$67ebef60e6f28a6,
    __createBinding: $e2e041e4a1657497$export$45d3717a4c69092e,
    __exportStar: $e2e041e4a1657497$export$f33643c0debef087,
    __values: $e2e041e4a1657497$export$19a8beecd37a4c45,
    __read: $e2e041e4a1657497$export$8d051b38c9118094,
    __spread: $e2e041e4a1657497$export$afc72e2116322959,
    __spreadArrays: $e2e041e4a1657497$export$6388937ca91ccae8,
    __spreadArray: $e2e041e4a1657497$export$1216008129fb82ed,
    __await: $e2e041e4a1657497$export$10c90e4f7922046c,
    __asyncGenerator: $e2e041e4a1657497$export$e427f37a30a4de9b,
    __asyncDelegator: $e2e041e4a1657497$export$bbd80228419bb833,
    __asyncValues: $e2e041e4a1657497$export$e3b29a3d6162315f,
    __makeTemplateObject: $e2e041e4a1657497$export$4fb47efe1390b86f,
    __importStar: $e2e041e4a1657497$export$c21735bcef00d192,
    __importDefault: $e2e041e4a1657497$export$da59b14a69baef04,
    __classPrivateFieldGet: $e2e041e4a1657497$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $e2e041e4a1657497$export$d40a35129aaff81f,
    __classPrivateFieldIn: $e2e041e4a1657497$export$81fdc39f203e4e04,
    __addDisposableResource: $e2e041e4a1657497$export$88ac25d8e944e405,
    __disposeResources: $e2e041e4a1657497$export$8f076105dc360e92
};



var $7c09975dc2fc0234$var$genericMessage = "Invariant Violation";
var $7c09975dc2fc0234$var$_a = Object.setPrototypeOf, $7c09975dc2fc0234$var$setPrototypeOf = $7c09975dc2fc0234$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $7c09975dc2fc0234$var$_a;
var $7c09975dc2fc0234$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $e2e041e4a1657497$export$a8ba968b8961cb8a)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $7c09975dc2fc0234$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $7c09975dc2fc0234$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $7c09975dc2fc0234$var$genericMessage;
        $7c09975dc2fc0234$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $7c09975dc2fc0234$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $7c09975dc2fc0234$export$cea12affaee22fe8(message);
}
var $7c09975dc2fc0234$var$verbosityLevels = [
    "debug",
    "log",
    "warn",
    "error",
    "silent"
];
var $7c09975dc2fc0234$var$verbosityLevel = $7c09975dc2fc0234$var$verbosityLevels.indexOf("log");
function $7c09975dc2fc0234$var$wrapConsoleMethod(name) {
    return function() {
        if ($7c09975dc2fc0234$var$verbosityLevels.indexOf(name) >= $7c09975dc2fc0234$var$verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function(invariant) {
    invariant.debug = $7c09975dc2fc0234$var$wrapConsoleMethod("debug");
    invariant.log = $7c09975dc2fc0234$var$wrapConsoleMethod("log");
    invariant.warn = $7c09975dc2fc0234$var$wrapConsoleMethod("warn");
    invariant.error = $7c09975dc2fc0234$var$wrapConsoleMethod("error");
})($7c09975dc2fc0234$export$f5708dca728d7177 || ($7c09975dc2fc0234$export$f5708dca728d7177 = {}));
function $7c09975dc2fc0234$export$a80e09f2cd325fb8(level) {
    var old = $7c09975dc2fc0234$var$verbosityLevels[$7c09975dc2fc0234$var$verbosityLevel];
    $7c09975dc2fc0234$var$verbosityLevel = Math.max(0, $7c09975dc2fc0234$var$verbosityLevels.indexOf(level));
    return old;
}
var $7c09975dc2fc0234$export$2e2bcd8739ae039 = $7c09975dc2fc0234$export$f5708dca728d7177;


var $5fbd9c7a509ff0a3$export$83d89fbfd8236492 = "3.9.11";


function $dd134a40a587301b$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}


var $040d8b3cb21a952a$export$2e2bcd8739ae039 = (0, $dd134a40a587301b$export$f8b8b9ce72e9ccbf)(function() {
    return globalThis;
}) || (0, $dd134a40a587301b$export$f8b8b9ce72e9ccbf)(function() {
    return window;
}) || (0, $dd134a40a587301b$export$f8b8b9ce72e9ccbf)(function() {
    return self;
}) || (0, $dd134a40a587301b$export$f8b8b9ce72e9ccbf)(function() {
    return $parcel$global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
(0, $dd134a40a587301b$export$f8b8b9ce72e9ccbf)(function() {
    return (0, $dd134a40a587301b$export$f8b8b9ce72e9ccbf).constructor("return this")();
});


var $57915ec4a20ed3d0$var$prefixCounts = new Map();
function $57915ec4a20ed3d0$export$d0c8ec0fe1b18b70(prefix) {
    var count = $57915ec4a20ed3d0$var$prefixCounts.get(prefix) || 1;
    $57915ec4a20ed3d0$var$prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}


function $c638aef376fe9021$export$f341b4883239463f(value, space) {
    if (space === void 0) space = 0;
    var undefId = (0, $57915ec4a20ed3d0$export$d0c8ec0fe1b18b70)("stringifyForDisplay");
    return JSON.stringify(value, function(key, value) {
        return value === void 0 ? undefId : value;
    }, space).split(JSON.stringify(undefId)).join("<undefined>");
}


function $57583217334b5278$var$wrap(fn) {
    return function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (typeof message === "number") {
            var arg0 = message;
            message = $57583217334b5278$var$getHandledErrorMsg(arg0);
            if (!message) {
                message = $57583217334b5278$var$getFallbackErrorMsg(arg0, args);
                args = [];
            }
        }
        fn.apply(void 0, [
            message
        ].concat(args));
    };
}
var $57583217334b5278$export$f5708dca728d7177 = Object.assign(function invariant(condition, message) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (!condition) (0, $7c09975dc2fc0234$export$f5708dca728d7177)(condition, $57583217334b5278$var$getHandledErrorMsg(message, args) || $57583217334b5278$var$getFallbackErrorMsg(message, args));
}, {
    debug: $57583217334b5278$var$wrap((0, $7c09975dc2fc0234$export$f5708dca728d7177).debug),
    log: $57583217334b5278$var$wrap((0, $7c09975dc2fc0234$export$f5708dca728d7177).log),
    warn: $57583217334b5278$var$wrap((0, $7c09975dc2fc0234$export$f5708dca728d7177).warn),
    error: $57583217334b5278$var$wrap((0, $7c09975dc2fc0234$export$f5708dca728d7177).error)
});
/**
 * Returns an InvariantError.
 *
 * `message` can only be a string, a concatenation of strings, or a ternary statement
 * that results in a string. This will be enforced on build, where the message will
 * be replaced with a message number.
 * String substitutions with %s are supported and will also return
 * pretty-stringified objects.
 * Excess `optionalParams` will be swallowed.
 */ function $57583217334b5278$export$3991762405098ea(message) {
    var optionalParams = [];
    for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
    return new (0, $7c09975dc2fc0234$export$cea12affaee22fe8)($57583217334b5278$var$getHandledErrorMsg(message, optionalParams) || $57583217334b5278$var$getFallbackErrorMsg(message, optionalParams));
}
var $57583217334b5278$export$b8ca975fa04efdf3 = Symbol.for("ApolloErrorMessageHandler_" + (0, $5fbd9c7a509ff0a3$export$83d89fbfd8236492));
function $57583217334b5278$var$stringify(arg) {
    return typeof arg == "string" ? arg : (0, $c638aef376fe9021$export$f341b4883239463f)(arg, 2).slice(0, 1000);
}
function $57583217334b5278$var$getHandledErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return (0, $040d8b3cb21a952a$export$2e2bcd8739ae039)[$57583217334b5278$export$b8ca975fa04efdf3] && (0, $040d8b3cb21a952a$export$2e2bcd8739ae039)[$57583217334b5278$export$b8ca975fa04efdf3](message, messageArgs.map($57583217334b5278$var$stringify));
}
function $57583217334b5278$var$getFallbackErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: (0, $5fbd9c7a509ff0a3$export$83d89fbfd8236492),
        message: message,
        args: messageArgs.map($57583217334b5278$var$stringify)
    })));
}




var $939adff59452c7aa$export$404582bc18fe4d9e = globalThis.__DEV__ !== false;


var $6a3c74d1b5373fb5$exports = {};
"use strict";

$6a3c74d1b5373fb5$exports = (parcelRequire("fgmOP"));




var $9865fa0c1163b711$export$772fbc04a0ad4ce9 = typeof WeakMap === "function" && !(0, $dd134a40a587301b$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.product == "ReactNative" && !$parcel$global.HermesInternal;
});
var $9865fa0c1163b711$export$7293b8a0b474028d = typeof WeakSet === "function";
var $9865fa0c1163b711$export$23ba675b4b838b92 = typeof Symbol === "function" && typeof Symbol.for === "function";
var $9865fa0c1163b711$export$c34f882e9f1c1637 = $9865fa0c1163b711$export$23ba675b4b838b92 && Symbol.asyncIterator;
var $9865fa0c1163b711$export$71594e8a50f746f4 = typeof (0, $dd134a40a587301b$export$f8b8b9ce72e9ccbf)(function() {
    return window.document.createElement;
}) === "function";
var $9865fa0c1163b711$var$usingJSDOM = // Following advice found in this comment from @domenic (maintainer of jsdom):
// https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
//
// Since we control the version of Jest and jsdom used when running Apollo
// Client tests, and that version is recent enought to include " jsdom/x.y.z"
// at the end of the user agent string, I believe this case is all we need to
// check. Testing for "Node.js" was recommended for backwards compatibility
// with older version of jsdom, but we don't have that problem.
(0, $dd134a40a587301b$export$f8b8b9ce72e9ccbf)(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
}) || false;
var $9865fa0c1163b711$export$4001f6cd4a62405b = $9865fa0c1163b711$export$71594e8a50f746f4 && !$9865fa0c1163b711$var$usingJSDOM;



// To make sure Apollo Client doesn't create more than one React context
// (which can lead to problems like having an Apollo Client instance added
// in one context, then attempting to retrieve it from another different
// context), a single Apollo context is created and tracked in global state.
var $9056696600b1719a$var$contextKey = (0, $9865fa0c1163b711$export$23ba675b4b838b92) ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function $9056696600b1719a$export$a47505d961ee3a1() {
    (0, $57583217334b5278$export$f5708dca728d7177)("createContext" in $6a3c74d1b5373fb5$exports, 45);
    var context = $6a3c74d1b5373fb5$exports.createContext[$9056696600b1719a$var$contextKey];
    if (!context) {
        Object.defineProperty($6a3c74d1b5373fb5$exports.createContext, $9056696600b1719a$var$contextKey, {
            value: context = $6a3c74d1b5373fb5$exports.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true
        });
        context.displayName = "ApolloContext";
    }
    return context;
}
var $9056696600b1719a$export$c2ee824bcc89ca6a = $9056696600b1719a$export$a47505d961ee3a1;


var $5cd6b9f7c34c2e6c$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0, $9056696600b1719a$export$a47505d961ee3a1)();
    var parentContext = $6a3c74d1b5373fb5$exports.useContext(ApolloContext);
    var context = $6a3c74d1b5373fb5$exports.useMemo(function() {
        return (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, parentContext), {
            client: client || parentContext.client
        });
    }, [
        parentContext,
        client
    ]);
    (0, $57583217334b5278$export$f5708dca728d7177)(context.client, 46);
    return $6a3c74d1b5373fb5$exports.createElement(ApolloContext.Provider, {
        value: context
    }, children);
};



var $fgmOP = parcelRequire("fgmOP");
function $08c2f3412ed8b9d6$var$_slicedToArray(arr, i) {
    return $08c2f3412ed8b9d6$var$_arrayWithHoles(arr) || $08c2f3412ed8b9d6$var$_iterableToArrayLimit(arr, i) || $08c2f3412ed8b9d6$var$_unsupportedIterableToArray(arr, i) || $08c2f3412ed8b9d6$var$_nonIterableRest();
}
function $08c2f3412ed8b9d6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $08c2f3412ed8b9d6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $08c2f3412ed8b9d6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $08c2f3412ed8b9d6$var$_arrayLikeToArray(o, minLen);
}
function $08c2f3412ed8b9d6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $08c2f3412ed8b9d6$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $08c2f3412ed8b9d6$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $08c2f3412ed8b9d6$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createContext();
function $08c2f3412ed8b9d6$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children;
    var modalRef = (0, $fgmOP.useRef)();
    var _useState = (0, $fgmOP.useState)(), _useState2 = $08c2f3412ed8b9d6$var$_slicedToArray(_useState, 2), context = _useState2[0], setContext = _useState2[1];
    (0, $fgmOP.useEffect)(function() {
        setContext(modalRef.current);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($08c2f3412ed8b9d6$export$841858b892ce1f4c.Provider, {
        value: context
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        ref: modalRef
    }));
}


parcelRequire("fgmOP");
/**
 * React Router DOM v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $fgmOP = parcelRequire("fgmOP");
var $91d813eb41c8c85f$exports = {};
"use strict";
function $91d813eb41c8c85f$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($91d813eb41c8c85f$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$91d813eb41c8c85f$var$checkDCE();

$91d813eb41c8c85f$exports = (parcelRequire("7XNLQ"));


/**
 * @remix-run/router v1.15.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $8776d7b69d623a41$var$_extends() {
    $8776d7b69d623a41$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8776d7b69d623a41$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $8776d7b69d623a41$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($8776d7b69d623a41$export$e19cd5f9376f8cee || ($8776d7b69d623a41$export$e19cd5f9376f8cee = {}));
const $8776d7b69d623a41$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $8776d7b69d623a41$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $8776d7b69d623a41$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $8776d7b69d623a41$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $8776d7b69d623a41$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $8776d7b69d623a41$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $8776d7b69d623a41$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $8776d7b69d623a41$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $8776d7b69d623a41$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $8776d7b69d623a41$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $8776d7b69d623a41$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $8776d7b69d623a41$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $8776d7b69d623a41$export$fe53371bee54353d(to);
    }
    return $8776d7b69d623a41$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $8776d7b69d623a41$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $8776d7b69d623a41$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $8776d7b69d623a41$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $8776d7b69d623a41$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $8776d7b69d623a41$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $8776d7b69d623a41$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $8776d7b69d623a41$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $8776d7b69d623a41$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $8776d7b69d623a41$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $8776d7b69d623a41$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $8776d7b69d623a41$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $8776d7b69d623a41$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $8776d7b69d623a41$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $8776d7b69d623a41$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $8776d7b69d623a41$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $8776d7b69d623a41$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $8776d7b69d623a41$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $8776d7b69d623a41$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($8776d7b69d623a41$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $8776d7b69d623a41$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $8776d7b69d623a41$export$e19cd5f9376f8cee.Push;
        let location = $8776d7b69d623a41$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $8776d7b69d623a41$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $8776d7b69d623a41$export$e19cd5f9376f8cee.Replace;
        let location = $8776d7b69d623a41$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $8776d7b69d623a41$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $8776d7b69d623a41$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $8776d7b69d623a41$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($8776d7b69d623a41$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($8776d7b69d623a41$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $8776d7b69d623a41$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($8776d7b69d623a41$var$ResultType || ($8776d7b69d623a41$var$ResultType = {}));
const $8776d7b69d623a41$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $8776d7b69d623a41$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $8776d7b69d623a41$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $8776d7b69d623a41$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $8776d7b69d623a41$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($8776d7b69d623a41$var$isIndexRoute(route)) {
            let indexRoute = $8776d7b69d623a41$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $8776d7b69d623a41$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $8776d7b69d623a41$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $8776d7b69d623a41$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $8776d7b69d623a41$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $8776d7b69d623a41$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $8776d7b69d623a41$var$flattenRoutes(routes);
    $8776d7b69d623a41$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $8776d7b69d623a41$var$decodePath(pathname);
        matches = $8776d7b69d623a41$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $8776d7b69d623a41$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $8776d7b69d623a41$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $8776d7b69d623a41$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $8776d7b69d623a41$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $8776d7b69d623a41$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $8776d7b69d623a41$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $8776d7b69d623a41$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $8776d7b69d623a41$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $8776d7b69d623a41$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $8776d7b69d623a41$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $8776d7b69d623a41$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $8776d7b69d623a41$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $8776d7b69d623a41$var$paramRe = /^:[\w-]+$/;
const $8776d7b69d623a41$var$dynamicSegmentValue = 3;
const $8776d7b69d623a41$var$indexRouteValue = 2;
const $8776d7b69d623a41$var$emptySegmentValue = 1;
const $8776d7b69d623a41$var$staticSegmentValue = 10;
const $8776d7b69d623a41$var$splatPenalty = -2;
const $8776d7b69d623a41$var$isSplat = (s)=>s === "*";
function $8776d7b69d623a41$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($8776d7b69d623a41$var$isSplat)) initialScore += $8776d7b69d623a41$var$splatPenalty;
    if (index) initialScore += $8776d7b69d623a41$var$indexRouteValue;
    return segments.filter((s)=>!$8776d7b69d623a41$var$isSplat(s)).reduce((score, segment)=>score + ($8776d7b69d623a41$var$paramRe.test(segment) ? $8776d7b69d623a41$var$dynamicSegmentValue : segment === "" ? $8776d7b69d623a41$var$emptySegmentValue : $8776d7b69d623a41$var$staticSegmentValue), initialScore);
}
function $8776d7b69d623a41$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $8776d7b69d623a41$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $8776d7b69d623a41$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $8776d7b69d623a41$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $8776d7b69d623a41$export$a5c6d149b50c1d86($8776d7b69d623a41$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $8776d7b69d623a41$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $8776d7b69d623a41$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $8776d7b69d623a41$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $8776d7b69d623a41$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $8776d7b69d623a41$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $8776d7b69d623a41$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $8776d7b69d623a41$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $8776d7b69d623a41$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $8776d7b69d623a41$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $8776d7b69d623a41$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $8776d7b69d623a41$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $8776d7b69d623a41$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $8776d7b69d623a41$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $8776d7b69d623a41$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $8776d7b69d623a41$var$normalizeSearch(search),
        hash: $8776d7b69d623a41$var$normalizeHash(hash)
    };
}
function $8776d7b69d623a41$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $8776d7b69d623a41$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $8776d7b69d623a41$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $8776d7b69d623a41$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $8776d7b69d623a41$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $8776d7b69d623a41$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $8776d7b69d623a41$export$8ccf933b0513f8d0(toArg);
    else {
        to = $8776d7b69d623a41$var$_extends({}, toArg);
        $8776d7b69d623a41$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $8776d7b69d623a41$var$getInvalidPathError("?", "pathname", "search", to));
        $8776d7b69d623a41$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $8776d7b69d623a41$var$getInvalidPathError("#", "pathname", "hash", to));
        $8776d7b69d623a41$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $8776d7b69d623a41$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $8776d7b69d623a41$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $8776d7b69d623a41$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $8776d7b69d623a41$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $8776d7b69d623a41$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $8776d7b69d623a41$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $8776d7b69d623a41$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $8776d7b69d623a41$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $8776d7b69d623a41$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $8776d7b69d623a41$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $8776d7b69d623a41$export$42a99a7a4bc0e76a extends Error {
}
class $8776d7b69d623a41$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $8776d7b69d623a41$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $8776d7b69d623a41$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $8776d7b69d623a41$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $8776d7b69d623a41$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $8776d7b69d623a41$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $8776d7b69d623a41$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $8776d7b69d623a41$var$unwrapTrackedPromise(value) {
    if (!$8776d7b69d623a41$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $8776d7b69d623a41$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $8776d7b69d623a41$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $8776d7b69d623a41$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $8776d7b69d623a41$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $8776d7b69d623a41$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $8776d7b69d623a41$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $8776d7b69d623a41$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $8776d7b69d623a41$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $8776d7b69d623a41$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $8776d7b69d623a41$var$validMutationMethods = new Set($8776d7b69d623a41$var$validMutationMethodsArr);
const $8776d7b69d623a41$var$validRequestMethodsArr = [
    "get",
    ...$8776d7b69d623a41$var$validMutationMethodsArr
];
const $8776d7b69d623a41$var$validRequestMethods = new Set($8776d7b69d623a41$var$validRequestMethodsArr);
const $8776d7b69d623a41$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $8776d7b69d623a41$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $8776d7b69d623a41$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $8776d7b69d623a41$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $8776d7b69d623a41$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $8776d7b69d623a41$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $8776d7b69d623a41$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $8776d7b69d623a41$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $8776d7b69d623a41$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $8776d7b69d623a41$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $8776d7b69d623a41$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $8776d7b69d623a41$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $8776d7b69d623a41$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $8776d7b69d623a41$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $8776d7b69d623a41$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $8776d7b69d623a41$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $8776d7b69d623a41$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $8776d7b69d623a41$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $8776d7b69d623a41$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $8776d7b69d623a41$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $8776d7b69d623a41$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$8776d7b69d623a41$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($8776d7b69d623a41$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $8776d7b69d623a41$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $8776d7b69d623a41$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $8776d7b69d623a41$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $8776d7b69d623a41$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $8776d7b69d623a41$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $8776d7b69d623a41$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $8776d7b69d623a41$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $8776d7b69d623a41$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $8776d7b69d623a41$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($8776d7b69d623a41$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $8776d7b69d623a41$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $8776d7b69d623a41$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $8776d7b69d623a41$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $8776d7b69d623a41$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $8776d7b69d623a41$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $8776d7b69d623a41$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $8776d7b69d623a41$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $8776d7b69d623a41$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $8776d7b69d623a41$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $8776d7b69d623a41$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $8776d7b69d623a41$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $8776d7b69d623a41$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $8776d7b69d623a41$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $8776d7b69d623a41$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $8776d7b69d623a41$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $8776d7b69d623a41$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $8776d7b69d623a41$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$8776d7b69d623a41$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $8776d7b69d623a41$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $8776d7b69d623a41$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $8776d7b69d623a41$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $8776d7b69d623a41$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $8776d7b69d623a41$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $8776d7b69d623a41$var$ResultType.error,
            error: $8776d7b69d623a41$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $8776d7b69d623a41$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($8776d7b69d623a41$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($8776d7b69d623a41$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $8776d7b69d623a41$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $8776d7b69d623a41$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($8776d7b69d623a41$var$isDeferredResult(result)) throw $8776d7b69d623a41$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $8776d7b69d623a41$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $8776d7b69d623a41$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $8776d7b69d623a41$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $8776d7b69d623a41$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $8776d7b69d623a41$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($8776d7b69d623a41$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $8776d7b69d623a41$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $8776d7b69d623a41$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $8776d7b69d623a41$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $8776d7b69d623a41$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $8776d7b69d623a41$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $8776d7b69d623a41$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $8776d7b69d623a41$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $8776d7b69d623a41$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $8776d7b69d623a41$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $8776d7b69d623a41$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $8776d7b69d623a41$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $8776d7b69d623a41$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $8776d7b69d623a41$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($8776d7b69d623a41$var$isRedirectResult(actionResult) || $8776d7b69d623a41$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $8776d7b69d623a41$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($8776d7b69d623a41$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $8776d7b69d623a41$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $8776d7b69d623a41$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($8776d7b69d623a41$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($8776d7b69d623a41$var$isDeferredResult(actionResult)) throw $8776d7b69d623a41$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $8776d7b69d623a41$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $8776d7b69d623a41$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $8776d7b69d623a41$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $8776d7b69d623a41$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $8776d7b69d623a41$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $8776d7b69d623a41$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $8776d7b69d623a41$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $8776d7b69d623a41$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $8776d7b69d623a41$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $8776d7b69d623a41$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $8776d7b69d623a41$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $8776d7b69d623a41$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $8776d7b69d623a41$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $8776d7b69d623a41$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($8776d7b69d623a41$var$isDeferredResult(result)) result = await $8776d7b69d623a41$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $8776d7b69d623a41$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($8776d7b69d623a41$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $8776d7b69d623a41$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($8776d7b69d623a41$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $8776d7b69d623a41$export$3e9cee6b33872309(!$8776d7b69d623a41$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $8776d7b69d623a41$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $8776d7b69d623a41$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $8776d7b69d623a41$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($8776d7b69d623a41$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $8776d7b69d623a41$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $8776d7b69d623a41$export$e19cd5f9376f8cee.Replace : $8776d7b69d623a41$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $8776d7b69d623a41$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($8776d7b69d623a41$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $8776d7b69d623a41$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $8776d7b69d623a41$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $8776d7b69d623a41$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$8776d7b69d623a41$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $8776d7b69d623a41$var$callLoaderOrAction("loader", $8776d7b69d623a41$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $8776d7b69d623a41$var$ResultType.error,
                        error: $8776d7b69d623a41$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $8776d7b69d623a41$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $8776d7b69d623a41$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $8776d7b69d623a41$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $8776d7b69d623a41$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $8776d7b69d623a41$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $8776d7b69d623a41$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $8776d7b69d623a41$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $8776d7b69d623a41$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $8776d7b69d623a41$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $8776d7b69d623a41$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $8776d7b69d623a41$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $8776d7b69d623a41$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $8776d7b69d623a41$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$8776d7b69d623a41$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $8776d7b69d623a41$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $8776d7b69d623a41$export$4d0306f8f6a4585b = Symbol("deferred");
function $8776d7b69d623a41$export$3336b097a6fbc59a(routes, opts) {
    $8776d7b69d623a41$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $8776d7b69d623a41$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $8776d7b69d623a41$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $8776d7b69d623a41$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $8776d7b69d623a41$var$createLocation("", $8776d7b69d623a41$export$fe53371bee54353d(url), null, "default");
        let matches = $8776d7b69d623a41$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$8776d7b69d623a41$var$isValidMethod(method) && method !== "HEAD") {
            let error = $8776d7b69d623a41$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $8776d7b69d623a41$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $8776d7b69d623a41$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $8776d7b69d623a41$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($8776d7b69d623a41$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $8776d7b69d623a41$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $8776d7b69d623a41$var$createLocation("", $8776d7b69d623a41$export$fe53371bee54353d(url), null, "default");
        let matches = $8776d7b69d623a41$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$8776d7b69d623a41$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $8776d7b69d623a41$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $8776d7b69d623a41$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $8776d7b69d623a41$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $8776d7b69d623a41$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $8776d7b69d623a41$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($8776d7b69d623a41$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$8776d7b69d623a41$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $8776d7b69d623a41$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($8776d7b69d623a41$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $8776d7b69d623a41$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $8776d7b69d623a41$var$isResponse(result) ? result : $8776d7b69d623a41$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($8776d7b69d623a41$var$isQueryRouteResponse(e)) {
                if (e.type === $8776d7b69d623a41$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($8776d7b69d623a41$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $8776d7b69d623a41$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $8776d7b69d623a41$var$ResultType.error,
                error: error
            };
        } else {
            result = await $8776d7b69d623a41$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $8776d7b69d623a41$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($8776d7b69d623a41$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($8776d7b69d623a41$var$isDeferredResult(result)) {
            let error = $8776d7b69d623a41$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $8776d7b69d623a41$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($8776d7b69d623a41$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($8776d7b69d623a41$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $8776d7b69d623a41$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $8776d7b69d623a41$var$_extends({}, context, {
                statusCode: $8776d7b69d623a41$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $8776d7b69d623a41$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $8776d7b69d623a41$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $8776d7b69d623a41$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $8776d7b69d623a41$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $8776d7b69d623a41$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$8776d7b69d623a41$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $8776d7b69d623a41$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $8776d7b69d623a41$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $8776d7b69d623a41$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $8776d7b69d623a41$export$fec11da027c70692(routes, context, error) {
    let newContext = $8776d7b69d623a41$var$_extends({}, context, {
        statusCode: $8776d7b69d623a41$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $8776d7b69d623a41$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $8776d7b69d623a41$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $8776d7b69d623a41$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $8776d7b69d623a41$export$cae722b0cc860f13(to ? to : ".", $8776d7b69d623a41$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $8776d7b69d623a41$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$8776d7b69d623a41$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $8776d7b69d623a41$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $8776d7b69d623a41$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $8776d7b69d623a41$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$8776d7b69d623a41$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$8776d7b69d623a41$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $8776d7b69d623a41$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $8776d7b69d623a41$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $8776d7b69d623a41$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$8776d7b69d623a41$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$8776d7b69d623a41$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $8776d7b69d623a41$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $8776d7b69d623a41$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $8776d7b69d623a41$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $8776d7b69d623a41$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $8776d7b69d623a41$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($8776d7b69d623a41$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $8776d7b69d623a41$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $8776d7b69d623a41$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $8776d7b69d623a41$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $8776d7b69d623a41$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $8776d7b69d623a41$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $8776d7b69d623a41$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($8776d7b69d623a41$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $8776d7b69d623a41$var$shouldRevalidateLoader(match, $8776d7b69d623a41$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $8776d7b69d623a41$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $8776d7b69d623a41$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $8776d7b69d623a41$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $8776d7b69d623a41$var$shouldRevalidateLoader(fetcherMatch, $8776d7b69d623a41$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $8776d7b69d623a41$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $8776d7b69d623a41$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $8776d7b69d623a41$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $8776d7b69d623a41$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $8776d7b69d623a41$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $8776d7b69d623a41$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$8776d7b69d623a41$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $8776d7b69d623a41$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $8776d7b69d623a41$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $8776d7b69d623a41$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $8776d7b69d623a41$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $8776d7b69d623a41$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $8776d7b69d623a41$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $8776d7b69d623a41$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $8776d7b69d623a41$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $8776d7b69d623a41$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($8776d7b69d623a41$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($8776d7b69d623a41$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $8776d7b69d623a41$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$8776d7b69d623a41$var$ABSOLUTE_URL_REGEX.test(location)) location = $8776d7b69d623a41$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $8776d7b69d623a41$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $8776d7b69d623a41$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $8776d7b69d623a41$var$ResultType.error ? $8776d7b69d623a41$var$ResultType.error : $8776d7b69d623a41$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $8776d7b69d623a41$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $8776d7b69d623a41$var$ResultType.error) return {
            type: resultType,
            error: new $8776d7b69d623a41$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $8776d7b69d623a41$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $8776d7b69d623a41$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($8776d7b69d623a41$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $8776d7b69d623a41$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $8776d7b69d623a41$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $8776d7b69d623a41$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($8776d7b69d623a41$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $8776d7b69d623a41$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $8776d7b69d623a41$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $8776d7b69d623a41$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $8776d7b69d623a41$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $8776d7b69d623a41$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $8776d7b69d623a41$export$3e9cee6b33872309(!$8776d7b69d623a41$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($8776d7b69d623a41$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $8776d7b69d623a41$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $8776d7b69d623a41$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($8776d7b69d623a41$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $8776d7b69d623a41$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $8776d7b69d623a41$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $8776d7b69d623a41$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($8776d7b69d623a41$var$isErrorResult(result)) {
            let boundaryMatch = $8776d7b69d623a41$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $8776d7b69d623a41$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($8776d7b69d623a41$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $8776d7b69d623a41$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($8776d7b69d623a41$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $8776d7b69d623a41$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $8776d7b69d623a41$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $8776d7b69d623a41$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $8776d7b69d623a41$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $8776d7b69d623a41$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $8776d7b69d623a41$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $8776d7b69d623a41$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $8776d7b69d623a41$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $8776d7b69d623a41$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($8776d7b69d623a41$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $8776d7b69d623a41$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $8776d7b69d623a41$export$8ccf933b0513f8d0(path) : path;
    return $8776d7b69d623a41$export$fe53371bee54353d($8776d7b69d623a41$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $8776d7b69d623a41$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $8776d7b69d623a41$var$isDeferredResult(result) {
    return result.type === $8776d7b69d623a41$var$ResultType.deferred;
}
function $8776d7b69d623a41$var$isErrorResult(result) {
    return result.type === $8776d7b69d623a41$var$ResultType.error;
}
function $8776d7b69d623a41$var$isRedirectResult(result) {
    return (result && result.type) === $8776d7b69d623a41$var$ResultType.redirect;
}
function $8776d7b69d623a41$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $8776d7b69d623a41$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $8776d7b69d623a41$var$isRedirectResponse(result) {
    if (!$8776d7b69d623a41$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $8776d7b69d623a41$var$isQueryRouteResponse(obj) {
    return obj && $8776d7b69d623a41$var$isResponse(obj.response) && (obj.type === $8776d7b69d623a41$var$ResultType.data || obj.type === $8776d7b69d623a41$var$ResultType.error);
}
function $8776d7b69d623a41$var$isValidMethod(method) {
    return $8776d7b69d623a41$var$validRequestMethods.has(method.toLowerCase());
}
function $8776d7b69d623a41$var$isMutationMethod(method) {
    return $8776d7b69d623a41$var$validMutationMethods.has(method.toLowerCase());
}
async function $8776d7b69d623a41$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$8776d7b69d623a41$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($8776d7b69d623a41$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $8776d7b69d623a41$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $8776d7b69d623a41$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $8776d7b69d623a41$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $8776d7b69d623a41$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $8776d7b69d623a41$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $8776d7b69d623a41$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $8776d7b69d623a41$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $8776d7b69d623a41$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $8776d7b69d623a41$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $8776d7b69d623a41$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $8776d7b69d623a41$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $8776d7b69d623a41$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $8776d7b69d623a41$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $8776d7b69d623a41$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $8776d7b69d623a41$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $8776d7b69d623a41$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $8776d7b69d623a41$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $8776d7b69d623a41$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($8776d7b69d623a41$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $8776d7b69d623a41$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($8776d7b69d623a41$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $8776d7b69d623a41$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $fgmOP = parcelRequire("fgmOP");

function $dfdceb7c36fce96f$var$_extends() {
    $dfdceb7c36fce96f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dfdceb7c36fce96f$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $dfdceb7c36fce96f$export$3add0d5dce533e2e = /*#__PURE__*/ $fgmOP.createContext(null);
const $dfdceb7c36fce96f$export$145dfa71566a64dc = /*#__PURE__*/ $fgmOP.createContext(null);
const $dfdceb7c36fce96f$var$AwaitContext = /*#__PURE__*/ $fgmOP.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $dfdceb7c36fce96f$export$26749e8557646306 = /*#__PURE__*/ $fgmOP.createContext(null);
const $dfdceb7c36fce96f$export$c7914228fb69b0f5 = /*#__PURE__*/ $fgmOP.createContext(null);
const $dfdceb7c36fce96f$export$9072aa6dd1f93057 = /*#__PURE__*/ $fgmOP.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $dfdceb7c36fce96f$var$RouteErrorContext = /*#__PURE__*/ $fgmOP.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $dfdceb7c36fce96f$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$dfdceb7c36fce96f$export$9c954a9d03d32f4a() && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $fgmOP.useContext($dfdceb7c36fce96f$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $dfdceb7c36fce96f$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $8776d7b69d623a41$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $dfdceb7c36fce96f$export$9c954a9d03d32f4a() {
    return $fgmOP.useContext($dfdceb7c36fce96f$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $dfdceb7c36fce96f$export$45d76561a5302f2b() {
    !$dfdceb7c36fce96f$export$9c954a9d03d32f4a() && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
    return $fgmOP.useContext($dfdceb7c36fce96f$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $dfdceb7c36fce96f$export$1b3f31771c5d07c() {
    return $fgmOP.useContext($dfdceb7c36fce96f$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $dfdceb7c36fce96f$export$6c330e8992e8a295(pattern) {
    !$dfdceb7c36fce96f$export$9c954a9d03d32f4a() && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $dfdceb7c36fce96f$export$45d76561a5302f2b();
    return $fgmOP.useMemo(()=>(0, $8776d7b69d623a41$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $dfdceb7c36fce96f$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $dfdceb7c36fce96f$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $fgmOP.useContext($dfdceb7c36fce96f$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $fgmOP.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $dfdceb7c36fce96f$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $fgmOP.useContext($dfdceb7c36fce96f$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $dfdceb7c36fce96f$var$useNavigateStable() : $dfdceb7c36fce96f$var$useNavigateUnstable();
}
function $dfdceb7c36fce96f$var$useNavigateUnstable() {
    !$dfdceb7c36fce96f$export$9c954a9d03d32f4a() && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
    let dataRouterContext = $fgmOP.useContext($dfdceb7c36fce96f$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $fgmOP.useContext($dfdceb7c36fce96f$export$26749e8557646306);
    let { matches: matches } = $fgmOP.useContext($dfdceb7c36fce96f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $dfdceb7c36fce96f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $8776d7b69d623a41$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $fgmOP.useRef(false);
    $dfdceb7c36fce96f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $fgmOP.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $8776d7b69d623a41$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $8776d7b69d623a41$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $dfdceb7c36fce96f$var$OutletContext = /*#__PURE__*/ $fgmOP.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $dfdceb7c36fce96f$export$4138103a3ae699cc() {
    return $fgmOP.useContext($dfdceb7c36fce96f$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $dfdceb7c36fce96f$export$a3be3530d8e40d0b(context) {
    let outlet = $fgmOP.useContext($dfdceb7c36fce96f$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $fgmOP.createElement($dfdceb7c36fce96f$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $dfdceb7c36fce96f$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $fgmOP.useContext($dfdceb7c36fce96f$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $dfdceb7c36fce96f$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $fgmOP.useContext($dfdceb7c36fce96f$export$26749e8557646306);
    let { matches: matches } = $fgmOP.useContext($dfdceb7c36fce96f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $dfdceb7c36fce96f$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $8776d7b69d623a41$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $fgmOP.useMemo(()=>(0, $8776d7b69d623a41$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $dfdceb7c36fce96f$export$5d3fca4a98652595(routes, locationArg) {
    return $dfdceb7c36fce96f$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $dfdceb7c36fce96f$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$dfdceb7c36fce96f$export$9c954a9d03d32f4a() && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $fgmOP.useContext($dfdceb7c36fce96f$export$26749e8557646306);
    let { matches: parentMatches } = $fgmOP.useContext($dfdceb7c36fce96f$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $dfdceb7c36fce96f$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $8776d7b69d623a41$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $8776d7b69d623a41$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $dfdceb7c36fce96f$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $8776d7b69d623a41$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $8776d7b69d623a41$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $fgmOP.createElement($dfdceb7c36fce96f$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $dfdceb7c36fce96f$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $8776d7b69d623a41$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $dfdceb7c36fce96f$var$DefaultErrorComponent() {
    let error = $dfdceb7c36fce96f$export$ed527bf60f6e05f2();
    let message = (0, $8776d7b69d623a41$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $fgmOP.createElement($fgmOP.Fragment, null, /*#__PURE__*/ $fgmOP.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $fgmOP.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $fgmOP.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $dfdceb7c36fce96f$var$defaultErrorElement = /*#__PURE__*/ $fgmOP.createElement($dfdceb7c36fce96f$var$DefaultErrorComponent, null);
class $dfdceb7c36fce96f$var$RenderErrorBoundary extends $fgmOP.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $fgmOP.createElement($dfdceb7c36fce96f$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $fgmOP.createElement($dfdceb7c36fce96f$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $dfdceb7c36fce96f$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $fgmOP.useContext($dfdceb7c36fce96f$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $fgmOP.createElement($dfdceb7c36fce96f$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $dfdceb7c36fce96f$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $dfdceb7c36fce96f$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $dfdceb7c36fce96f$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $fgmOP.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $fgmOP.createElement($dfdceb7c36fce96f$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $fgmOP.createElement($dfdceb7c36fce96f$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $dfdceb7c36fce96f$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($dfdceb7c36fce96f$var$DataRouterHook || {});
var $dfdceb7c36fce96f$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($dfdceb7c36fce96f$var$DataRouterStateHook || {});
function $dfdceb7c36fce96f$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $dfdceb7c36fce96f$var$useDataRouterContext(hookName) {
    let ctx = $fgmOP.useContext($dfdceb7c36fce96f$export$3add0d5dce533e2e);
    !ctx && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
    return ctx;
}
function $dfdceb7c36fce96f$var$useDataRouterState(hookName) {
    let state = $fgmOP.useContext($dfdceb7c36fce96f$export$145dfa71566a64dc);
    !state && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
    return state;
}
function $dfdceb7c36fce96f$var$useRouteContext(hookName) {
    let route = $fgmOP.useContext($dfdceb7c36fce96f$export$9072aa6dd1f93057);
    !route && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $dfdceb7c36fce96f$var$useCurrentRouteId(hookName) {
    let route = $dfdceb7c36fce96f$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $dfdceb7c36fce96f$export$5fc8298006ad9e58() {
    return $dfdceb7c36fce96f$var$useCurrentRouteId($dfdceb7c36fce96f$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $dfdceb7c36fce96f$export$d0fd4b7106de2769() {
    let state = $dfdceb7c36fce96f$var$useDataRouterState($dfdceb7c36fce96f$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $dfdceb7c36fce96f$export$600dc272ed516c15() {
    let dataRouterContext = $dfdceb7c36fce96f$var$useDataRouterContext($dfdceb7c36fce96f$var$DataRouterHook.UseRevalidator);
    let state = $dfdceb7c36fce96f$var$useDataRouterState($dfdceb7c36fce96f$var$DataRouterStateHook.UseRevalidator);
    return $fgmOP.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $dfdceb7c36fce96f$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $dfdceb7c36fce96f$var$useDataRouterState($dfdceb7c36fce96f$var$DataRouterStateHook.UseMatches);
    return $fgmOP.useMemo(()=>matches.map((m)=>(0, $8776d7b69d623a41$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $dfdceb7c36fce96f$export$1448a5050d252c4d() {
    let state = $dfdceb7c36fce96f$var$useDataRouterState($dfdceb7c36fce96f$var$DataRouterStateHook.UseLoaderData);
    let routeId = $dfdceb7c36fce96f$var$useCurrentRouteId($dfdceb7c36fce96f$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $dfdceb7c36fce96f$export$fd5d37484eab868d(routeId) {
    let state = $dfdceb7c36fce96f$var$useDataRouterState($dfdceb7c36fce96f$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $dfdceb7c36fce96f$export$fdc00f3f26066d5e() {
    let state = $dfdceb7c36fce96f$var$useDataRouterState($dfdceb7c36fce96f$var$DataRouterStateHook.UseActionData);
    let routeId = $dfdceb7c36fce96f$var$useCurrentRouteId($dfdceb7c36fce96f$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $dfdceb7c36fce96f$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $fgmOP.useContext($dfdceb7c36fce96f$var$RouteErrorContext);
    let state = $dfdceb7c36fce96f$var$useDataRouterState($dfdceb7c36fce96f$var$DataRouterStateHook.UseRouteError);
    let routeId = $dfdceb7c36fce96f$var$useCurrentRouteId($dfdceb7c36fce96f$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $dfdceb7c36fce96f$export$78a72ddb39bdd145() {
    let value = $fgmOP.useContext($dfdceb7c36fce96f$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $dfdceb7c36fce96f$export$17f53340677d5831() {
    let value = $fgmOP.useContext($dfdceb7c36fce96f$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $dfdceb7c36fce96f$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $dfdceb7c36fce96f$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $dfdceb7c36fce96f$var$useDataRouterContext($dfdceb7c36fce96f$var$DataRouterHook.UseBlocker);
    let state = $dfdceb7c36fce96f$var$useDataRouterState($dfdceb7c36fce96f$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $fgmOP.useState("");
    let blockerFunction = $fgmOP.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $dfdceb7c36fce96f$var$_extends({}, currentLocation, {
                pathname: (0, $8776d7b69d623a41$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $dfdceb7c36fce96f$var$_extends({}, nextLocation, {
                pathname: (0, $8776d7b69d623a41$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $fgmOP.useEffect(()=>{
        let key = String(++$dfdceb7c36fce96f$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $fgmOP.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $8776d7b69d623a41$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $dfdceb7c36fce96f$var$useNavigateStable() {
    let { router: router } = $dfdceb7c36fce96f$var$useDataRouterContext($dfdceb7c36fce96f$var$DataRouterHook.UseNavigateStable);
    let id = $dfdceb7c36fce96f$var$useCurrentRouteId($dfdceb7c36fce96f$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $fgmOP.useRef(false);
    $dfdceb7c36fce96f$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $fgmOP.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $dfdceb7c36fce96f$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $dfdceb7c36fce96f$var$alreadyWarned = {};
function $dfdceb7c36fce96f$var$warningOnce(key, cond, message) {
    if (!cond && !$dfdceb7c36fce96f$var$alreadyWarned[key]) $dfdceb7c36fce96f$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $dfdceb7c36fce96f$var$START_TRANSITION = "startTransition";
const $dfdceb7c36fce96f$var$startTransitionImpl = $fgmOP[$dfdceb7c36fce96f$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $dfdceb7c36fce96f$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $fgmOP.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $fgmOP.useCallback((newState)=>{
        if (v7_startTransition && $dfdceb7c36fce96f$var$startTransitionImpl) $dfdceb7c36fce96f$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $fgmOP.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $fgmOP.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $fgmOP.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $fgmOP.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $fgmOP.createElement($fgmOP.Fragment, null, /*#__PURE__*/ $fgmOP.createElement($dfdceb7c36fce96f$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $fgmOP.createElement($dfdceb7c36fce96f$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $fgmOP.createElement($dfdceb7c36fce96f$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $fgmOP.createElement($dfdceb7c36fce96f$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $dfdceb7c36fce96f$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $dfdceb7c36fce96f$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $dfdceb7c36fce96f$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $fgmOP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $8776d7b69d623a41$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $fgmOP.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $fgmOP.useCallback((newState)=>{
        v7_startTransition && $dfdceb7c36fce96f$var$startTransitionImpl ? $dfdceb7c36fce96f$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $fgmOP.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $fgmOP.createElement($dfdceb7c36fce96f$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $dfdceb7c36fce96f$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$dfdceb7c36fce96f$export$9c954a9d03d32f4a() && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $fgmOP.useContext($dfdceb7c36fce96f$export$26749e8557646306);
    let { matches: matches } = $fgmOP.useContext($dfdceb7c36fce96f$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $dfdceb7c36fce96f$export$45d76561a5302f2b();
    let navigate = $dfdceb7c36fce96f$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $8776d7b69d623a41$export$cae722b0cc860f13)(to, (0, $8776d7b69d623a41$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $fgmOP.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $dfdceb7c36fce96f$export$910ae8079b2c2852(props) {
    return $dfdceb7c36fce96f$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $dfdceb7c36fce96f$export$e7b0ac011bb776c6(_props) {
    (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $dfdceb7c36fce96f$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $8776d7b69d623a41$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$dfdceb7c36fce96f$export$9c954a9d03d32f4a() && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $fgmOP.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $dfdceb7c36fce96f$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $8776d7b69d623a41$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $fgmOP.useMemo(()=>{
        let trailingPathname = (0, $8776d7b69d623a41$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $fgmOP.createElement($dfdceb7c36fce96f$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $fgmOP.createElement($dfdceb7c36fce96f$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $dfdceb7c36fce96f$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $dfdceb7c36fce96f$export$5d3fca4a98652595($dfdceb7c36fce96f$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $dfdceb7c36fce96f$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $fgmOP.createElement($dfdceb7c36fce96f$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $fgmOP.createElement($dfdceb7c36fce96f$var$ResolveAwait, null, children));
}
var $dfdceb7c36fce96f$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($dfdceb7c36fce96f$var$AwaitRenderStatus || {});
const $dfdceb7c36fce96f$var$neverSettledPromise = new Promise(()=>{});
class $dfdceb7c36fce96f$var$AwaitErrorBoundary extends $fgmOP.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $dfdceb7c36fce96f$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $dfdceb7c36fce96f$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $dfdceb7c36fce96f$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $dfdceb7c36fce96f$var$AwaitRenderStatus.error : promise._data !== undefined ? $dfdceb7c36fce96f$var$AwaitRenderStatus.success : $dfdceb7c36fce96f$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $dfdceb7c36fce96f$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $dfdceb7c36fce96f$var$AwaitRenderStatus.error && promise._error instanceof (0, $8776d7b69d623a41$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $dfdceb7c36fce96f$var$neverSettledPromise;
        if (status === $dfdceb7c36fce96f$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $dfdceb7c36fce96f$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $fgmOP.createElement($dfdceb7c36fce96f$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $dfdceb7c36fce96f$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $fgmOP.createElement($dfdceb7c36fce96f$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $dfdceb7c36fce96f$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $dfdceb7c36fce96f$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $fgmOP.createElement($fgmOP.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $dfdceb7c36fce96f$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $fgmOP.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $fgmOP.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $fgmOP.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $dfdceb7c36fce96f$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $dfdceb7c36fce96f$export$e7b0ac011bb776c6) && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $dfdceb7c36fce96f$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $dfdceb7c36fce96f$export$daf73786167a7f72(matches) {
    return $dfdceb7c36fce96f$var$_renderMatches(matches);
}
function $dfdceb7c36fce96f$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $fgmOP.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $fgmOP.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $fgmOP.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $dfdceb7c36fce96f$export$f30f7e456d254e83(routes, opts) {
    return (0, $8776d7b69d623a41$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $dfdceb7c36fce96f$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $8776d7b69d623a41$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $dfdceb7c36fce96f$export$52b333d321859367
    }).initialize();
}



function $9fb784f5d8b1fb75$var$_extends() {
    $9fb784f5d8b1fb75$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9fb784f5d8b1fb75$var$_extends.apply(this, arguments);
}
function $9fb784f5d8b1fb75$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $9fb784f5d8b1fb75$var$defaultMethod = "get";
const $9fb784f5d8b1fb75$var$defaultEncType = "application/x-www-form-urlencoded";
function $9fb784f5d8b1fb75$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $9fb784f5d8b1fb75$var$isButtonElement(object) {
    return $9fb784f5d8b1fb75$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $9fb784f5d8b1fb75$var$isFormElement(object) {
    return $9fb784f5d8b1fb75$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $9fb784f5d8b1fb75$var$isInputElement(object) {
    return $9fb784f5d8b1fb75$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $9fb784f5d8b1fb75$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $9fb784f5d8b1fb75$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$9fb784f5d8b1fb75$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $9fb784f5d8b1fb75$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $9fb784f5d8b1fb75$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $9fb784f5d8b1fb75$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $9fb784f5d8b1fb75$var$_formDataSupportsSubmitter = null;
function $9fb784f5d8b1fb75$var$isFormDataSubmitterSupported() {
    if ($9fb784f5d8b1fb75$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $9fb784f5d8b1fb75$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $9fb784f5d8b1fb75$var$_formDataSupportsSubmitter = true;
    }
    return $9fb784f5d8b1fb75$var$_formDataSupportsSubmitter;
}
const $9fb784f5d8b1fb75$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $9fb784f5d8b1fb75$var$getFormEncType(encType) {
    if (encType != null && !$9fb784f5d8b1fb75$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $9fb784f5d8b1fb75$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($9fb784f5d8b1fb75$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $8776d7b69d623a41$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $9fb784f5d8b1fb75$var$defaultMethod;
        encType = $9fb784f5d8b1fb75$var$getFormEncType(target.getAttribute("enctype")) || $9fb784f5d8b1fb75$var$defaultEncType;
        formData = new FormData(target);
    } else if ($9fb784f5d8b1fb75$var$isButtonElement(target) || $9fb784f5d8b1fb75$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $8776d7b69d623a41$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $9fb784f5d8b1fb75$var$defaultMethod;
        encType = $9fb784f5d8b1fb75$var$getFormEncType(target.getAttribute("formenctype")) || $9fb784f5d8b1fb75$var$getFormEncType(form.getAttribute("enctype")) || $9fb784f5d8b1fb75$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$9fb784f5d8b1fb75$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($9fb784f5d8b1fb75$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $9fb784f5d8b1fb75$var$defaultMethod;
        action = null;
        encType = $9fb784f5d8b1fb75$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $9fb784f5d8b1fb75$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $9fb784f5d8b1fb75$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $9fb784f5d8b1fb75$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $9fb784f5d8b1fb75$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $9fb784f5d8b1fb75$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $9fb784f5d8b1fb75$export$1f3f55432a00e06d(routes, opts) {
    return (0, $8776d7b69d623a41$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $9fb784f5d8b1fb75$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $8776d7b69d623a41$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $9fb784f5d8b1fb75$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $dfdceb7c36fce96f$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $9fb784f5d8b1fb75$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $8776d7b69d623a41$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $9fb784f5d8b1fb75$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $8776d7b69d623a41$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $9fb784f5d8b1fb75$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $dfdceb7c36fce96f$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $9fb784f5d8b1fb75$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $9fb784f5d8b1fb75$var$_extends({}, state, {
        errors: $9fb784f5d8b1fb75$var$deserializeErrors(state.errors)
    });
    return state;
}
function $9fb784f5d8b1fb75$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $8776d7b69d623a41$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $9fb784f5d8b1fb75$export$7ad602f0e94e62d1 = /*#__PURE__*/ $fgmOP.createContext({
    isTransitioning: false
});
const $9fb784f5d8b1fb75$export$148fd98d095596d4 = /*#__PURE__*/ $fgmOP.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $9fb784f5d8b1fb75$var$START_TRANSITION = "startTransition";
const $9fb784f5d8b1fb75$var$startTransitionImpl = $fgmOP[$9fb784f5d8b1fb75$var$START_TRANSITION];
const $9fb784f5d8b1fb75$var$FLUSH_SYNC = "flushSync";
const $9fb784f5d8b1fb75$var$flushSyncImpl = $91d813eb41c8c85f$exports[$9fb784f5d8b1fb75$var$FLUSH_SYNC];
const $9fb784f5d8b1fb75$var$USE_ID = "useId";
const $9fb784f5d8b1fb75$var$useIdImpl = $fgmOP[$9fb784f5d8b1fb75$var$USE_ID];
function $9fb784f5d8b1fb75$var$startTransitionSafe(cb) {
    if ($9fb784f5d8b1fb75$var$startTransitionImpl) $9fb784f5d8b1fb75$var$startTransitionImpl(cb);
    else cb();
}
function $9fb784f5d8b1fb75$var$flushSyncSafe(cb) {
    if ($9fb784f5d8b1fb75$var$flushSyncImpl) $9fb784f5d8b1fb75$var$flushSyncImpl(cb);
    else cb();
}
class $9fb784f5d8b1fb75$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $9fb784f5d8b1fb75$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $fgmOP.useState(router.state);
    let [pendingState, setPendingState] = $fgmOP.useState();
    let [vtContext, setVtContext] = $fgmOP.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $fgmOP.useState();
    let [transition, setTransition] = $fgmOP.useState();
    let [interruption, setInterruption] = $fgmOP.useState();
    let fetcherData = $fgmOP.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $fgmOP.useCallback((cb)=>{
        if (v7_startTransition) $9fb784f5d8b1fb75$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $fgmOP.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $9fb784f5d8b1fb75$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $9fb784f5d8b1fb75$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $9fb784f5d8b1fb75$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $9fb784f5d8b1fb75$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $9fb784f5d8b1fb75$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $fgmOP.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $fgmOP.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $9fb784f5d8b1fb75$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $fgmOP.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $fgmOP.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $fgmOP.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $fgmOP.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $fgmOP.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $fgmOP.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $fgmOP.createElement($fgmOP.Fragment, null, /*#__PURE__*/ $fgmOP.createElement((0, $dfdceb7c36fce96f$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $fgmOP.createElement((0, $dfdceb7c36fce96f$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $fgmOP.createElement($9fb784f5d8b1fb75$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $fgmOP.createElement($9fb784f5d8b1fb75$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $fgmOP.createElement((0, $dfdceb7c36fce96f$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $fgmOP.createElement($9fb784f5d8b1fb75$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $9fb784f5d8b1fb75$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $dfdceb7c36fce96f$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $9fb784f5d8b1fb75$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $fgmOP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $8776d7b69d623a41$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $fgmOP.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $fgmOP.useCallback((newState)=>{
        v7_startTransition && $9fb784f5d8b1fb75$var$startTransitionImpl ? $9fb784f5d8b1fb75$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $fgmOP.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $fgmOP.createElement((0, $dfdceb7c36fce96f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $9fb784f5d8b1fb75$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $fgmOP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $8776d7b69d623a41$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $fgmOP.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $fgmOP.useCallback((newState)=>{
        v7_startTransition && $9fb784f5d8b1fb75$var$startTransitionImpl ? $9fb784f5d8b1fb75$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $fgmOP.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $fgmOP.createElement((0, $dfdceb7c36fce96f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $9fb784f5d8b1fb75$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $fgmOP.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $fgmOP.useCallback((newState)=>{
        v7_startTransition && $9fb784f5d8b1fb75$var$startTransitionImpl ? $9fb784f5d8b1fb75$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $fgmOP.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $fgmOP.createElement((0, $dfdceb7c36fce96f$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $9fb784f5d8b1fb75$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $9fb784f5d8b1fb75$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a = /*#__PURE__*/ $fgmOP.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $9fb784f5d8b1fb75$var$_objectWithoutPropertiesLoose(_ref7, $9fb784f5d8b1fb75$var$_excluded);
    let { basename: basename } = $fgmOP.useContext((0, $dfdceb7c36fce96f$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $9fb784f5d8b1fb75$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($9fb784f5d8b1fb75$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $8776d7b69d623a41$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $dfdceb7c36fce96f$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $9fb784f5d8b1fb75$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $fgmOP.createElement("a", $9fb784f5d8b1fb75$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $9fb784f5d8b1fb75$export$b0d92dbee9b5b60d = /*#__PURE__*/ $fgmOP.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $9fb784f5d8b1fb75$var$_objectWithoutPropertiesLoose(_ref8, $9fb784f5d8b1fb75$var$_excluded2);
    let path = (0, $dfdceb7c36fce96f$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $dfdceb7c36fce96f$export$45d76561a5302f2b)();
    let routerState = $fgmOP.useContext((0, $dfdceb7c36fce96f$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $fgmOP.useContext((0, $dfdceb7c36fce96f$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $9fb784f5d8b1fb75$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $8776d7b69d623a41$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $fgmOP.createElement($9fb784f5d8b1fb75$export$a6c7ac8248d6e38a, $9fb784f5d8b1fb75$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $9fb784f5d8b1fb75$export$a7fed597f4b8afd8 = /*#__PURE__*/ $fgmOP.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $9fb784f5d8b1fb75$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $9fb784f5d8b1fb75$var$_objectWithoutPropertiesLoose(_ref9, $9fb784f5d8b1fb75$var$_excluded3);
    let submit = $9fb784f5d8b1fb75$export$47c85c6e3a081d3();
    let formAction = $9fb784f5d8b1fb75$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $fgmOP.createElement("form", $9fb784f5d8b1fb75$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $9fb784f5d8b1fb75$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $9fb784f5d8b1fb75$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $9fb784f5d8b1fb75$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($9fb784f5d8b1fb75$var$DataRouterHook || ($9fb784f5d8b1fb75$var$DataRouterHook = {}));
var $9fb784f5d8b1fb75$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($9fb784f5d8b1fb75$var$DataRouterStateHook || ($9fb784f5d8b1fb75$var$DataRouterStateHook = {}));
// Internal hooks
function $9fb784f5d8b1fb75$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $9fb784f5d8b1fb75$var$useDataRouterContext(hookName) {
    let ctx = $fgmOP.useContext((0, $dfdceb7c36fce96f$export$3add0d5dce533e2e));
    !ctx && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
    return ctx;
}
function $9fb784f5d8b1fb75$var$useDataRouterState(hookName) {
    let state = $fgmOP.useContext((0, $dfdceb7c36fce96f$export$145dfa71566a64dc));
    !state && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $9fb784f5d8b1fb75$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    let location = (0, $dfdceb7c36fce96f$export$45d76561a5302f2b)();
    let path = (0, $dfdceb7c36fce96f$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $fgmOP.useCallback((event)=>{
        if ($9fb784f5d8b1fb75$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $8776d7b69d623a41$export$fe53371bee54353d)(location) === (0, $8776d7b69d623a41$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $9fb784f5d8b1fb75$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $fgmOP.useRef($9fb784f5d8b1fb75$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $fgmOP.useRef(false);
    let location = (0, $dfdceb7c36fce96f$export$45d76561a5302f2b)();
    let searchParams = $fgmOP.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $9fb784f5d8b1fb75$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    let setSearchParams = $fgmOP.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $9fb784f5d8b1fb75$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $9fb784f5d8b1fb75$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $9fb784f5d8b1fb75$var$fetcherId = 0;
let $9fb784f5d8b1fb75$var$getUniqueFetcherId = ()=>"__" + String(++$9fb784f5d8b1fb75$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $9fb784f5d8b1fb75$export$47c85c6e3a081d3() {
    let { router: router } = $9fb784f5d8b1fb75$var$useDataRouterContext($9fb784f5d8b1fb75$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $fgmOP.useContext((0, $dfdceb7c36fce96f$export$26749e8557646306));
    let currentRouteId = (0, $dfdceb7c36fce96f$export$5fc8298006ad9e58)();
    return $fgmOP.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $9fb784f5d8b1fb75$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $9fb784f5d8b1fb75$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $9fb784f5d8b1fb75$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $9fb784f5d8b1fb75$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $fgmOP.useContext((0, $dfdceb7c36fce96f$export$26749e8557646306));
    let routeContext = $fgmOP.useContext((0, $dfdceb7c36fce96f$export$9072aa6dd1f93057));
    !routeContext && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $9fb784f5d8b1fb75$var$_extends({}, (0, $dfdceb7c36fce96f$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $dfdceb7c36fce96f$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $8776d7b69d623a41$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $8776d7b69d623a41$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $9fb784f5d8b1fb75$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $9fb784f5d8b1fb75$var$useDataRouterContext($9fb784f5d8b1fb75$var$DataRouterHook.UseFetcher);
    let state = $9fb784f5d8b1fb75$var$useDataRouterState($9fb784f5d8b1fb75$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $fgmOP.useContext($9fb784f5d8b1fb75$export$148fd98d095596d4);
    let route = $fgmOP.useContext((0, $dfdceb7c36fce96f$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
    !route && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $9fb784f5d8b1fb75$var$useIdImpl ? $9fb784f5d8b1fb75$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $fgmOP.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($9fb784f5d8b1fb75$var$getUniqueFetcherId());
    // Registration/cleanup
    $fgmOP.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $fgmOP.useCallback((href, opts)=>{
        !routeId && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $9fb784f5d8b1fb75$export$47c85c6e3a081d3();
    let submit = $fgmOP.useCallback((target, opts)=>{
        submitImpl(target, $9fb784f5d8b1fb75$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $fgmOP.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $fgmOP.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $fgmOP.createElement($9fb784f5d8b1fb75$export$a7fed597f4b8afd8, $9fb784f5d8b1fb75$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $8776d7b69d623a41$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $fgmOP.useMemo(()=>$9fb784f5d8b1fb75$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $9fb784f5d8b1fb75$export$fa996778a3a31087() {
    let state = $9fb784f5d8b1fb75$var$useDataRouterState($9fb784f5d8b1fb75$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $9fb784f5d8b1fb75$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $9fb784f5d8b1fb75$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $9fb784f5d8b1fb75$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $9fb784f5d8b1fb75$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $9fb784f5d8b1fb75$var$useDataRouterContext($9fb784f5d8b1fb75$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $9fb784f5d8b1fb75$var$useDataRouterState($9fb784f5d8b1fb75$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $fgmOP.useContext((0, $dfdceb7c36fce96f$export$26749e8557646306));
    let location = (0, $dfdceb7c36fce96f$export$45d76561a5302f2b)();
    let matches = (0, $dfdceb7c36fce96f$export$2378eb7f5ff86053)();
    let navigation = (0, $dfdceb7c36fce96f$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $fgmOP.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $9fb784f5d8b1fb75$var$usePageHide($fgmOP.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $9fb784f5d8b1fb75$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $9fb784f5d8b1fb75$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($9fb784f5d8b1fb75$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $fgmOP.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $9fb784f5d8b1fb75$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $9fb784f5d8b1fb75$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $fgmOP.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($9fb784f5d8b1fb75$var$_extends({}, location, {
                    pathname: (0, $8776d7b69d623a41$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($9fb784f5d8b1fb75$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $fgmOP.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $9fb784f5d8b1fb75$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $fgmOP.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $9fb784f5d8b1fb75$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $fgmOP.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $9fb784f5d8b1fb75$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $dfdceb7c36fce96f$export$b273b3273281a049)(when);
    $fgmOP.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $fgmOP.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $9fb784f5d8b1fb75$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $fgmOP.useContext($9fb784f5d8b1fb75$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $8776d7b69d623a41$export$3e9cee6b33872309)(false);
    let { basename: basename } = $9fb784f5d8b1fb75$var$useDataRouterContext($9fb784f5d8b1fb75$var$DataRouterHook.useViewTransitionState);
    let path = (0, $dfdceb7c36fce96f$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $8776d7b69d623a41$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $8776d7b69d623a41$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $8776d7b69d623a41$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $8776d7b69d623a41$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $fgmOP = parcelRequire("fgmOP");
function $69596327011c9ad6$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $a2091d21f9de8bce$export$2e2bcd8739ae039(t, e) {
    return $a2091d21f9de8bce$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $a2091d21f9de8bce$export$2e2bcd8739ae039(t, e);
}


function $93570c1e6b118a09$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $a2091d21f9de8bce$export$2e2bcd8739ae039)(t, o);
}




var $fgmOP = parcelRequire("fgmOP");

var $c11d28d0edcfd067$export$2e2bcd8739ae039 = {
    disabled: false
};




var $fgmOP = parcelRequire("fgmOP");
var $ad8be1c743ab13a5$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createContext(null);


var $f02b3361c196639e$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $ed222bb70e4be31d$export$bb38bb9a1161268 = "unmounted";
var $ed222bb70e4be31d$export$84cbff306f539230 = "exited";
var $ed222bb70e4be31d$export$df38205c966be359 = "entering";
var $ed222bb70e4be31d$export$78e9e6e3e014d60a = "entered";
var $ed222bb70e4be31d$export$4aacc83d4d59139f = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $ed222bb70e4be31d$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $93570c1e6b118a09$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $ed222bb70e4be31d$export$84cbff306f539230;
                _this.appearStatus = $ed222bb70e4be31d$export$df38205c966be359;
            } else initialStatus = $ed222bb70e4be31d$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $ed222bb70e4be31d$export$bb38bb9a1161268;
        else initialStatus = $ed222bb70e4be31d$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $ed222bb70e4be31d$export$bb38bb9a1161268) return {
            status: $ed222bb70e4be31d$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $ed222bb70e4be31d$export$df38205c966be359 && status !== $ed222bb70e4be31d$export$78e9e6e3e014d60a) nextStatus = $ed222bb70e4be31d$export$df38205c966be359;
            } else if (status === $ed222bb70e4be31d$export$df38205c966be359 || status === $ed222bb70e4be31d$export$78e9e6e3e014d60a) nextStatus = $ed222bb70e4be31d$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $ed222bb70e4be31d$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($91d813eb41c8c85f$exports))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $f02b3361c196639e$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $ed222bb70e4be31d$export$84cbff306f539230) this.setState({
            status: $ed222bb70e4be31d$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($91d813eb41c8c85f$exports))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $c11d28d0edcfd067$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $ed222bb70e4be31d$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $ed222bb70e4be31d$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $ed222bb70e4be31d$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($91d813eb41c8c85f$exports))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $c11d28d0edcfd067$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $ed222bb70e4be31d$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $ed222bb70e4be31d$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $ed222bb70e4be31d$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($91d813eb41c8c85f$exports))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $ed222bb70e4be31d$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $69596327011c9ad6$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $ad8be1c743ab13a5$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === "function" ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Component);
$ed222bb70e4be31d$var$Transition.contextType = (0, $ad8be1c743ab13a5$export$2e2bcd8739ae039);
$ed222bb70e4be31d$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $ed222bb70e4be31d$var$noop() {}
$ed222bb70e4be31d$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $ed222bb70e4be31d$var$noop,
    onEntering: $ed222bb70e4be31d$var$noop,
    onEntered: $ed222bb70e4be31d$var$noop,
    onExit: $ed222bb70e4be31d$var$noop,
    onExiting: $ed222bb70e4be31d$var$noop,
    onExited: $ed222bb70e4be31d$var$noop
};
$ed222bb70e4be31d$var$Transition.UNMOUNTED = $ed222bb70e4be31d$export$bb38bb9a1161268;
$ed222bb70e4be31d$var$Transition.EXITED = $ed222bb70e4be31d$export$84cbff306f539230;
$ed222bb70e4be31d$var$Transition.ENTERING = $ed222bb70e4be31d$export$df38205c966be359;
$ed222bb70e4be31d$var$Transition.ENTERED = $ed222bb70e4be31d$export$78e9e6e3e014d60a;
$ed222bb70e4be31d$var$Transition.EXITING = $ed222bb70e4be31d$export$4aacc83d4d59139f;
var $ed222bb70e4be31d$export$2e2bcd8739ae039 = $ed222bb70e4be31d$var$Transition;


function $c65a4c058153566e$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) for(t = 0; t < e.length; t++)e[t] && (f = $c65a4c058153566e$var$r(e[t])) && (n && (n += " "), n += f);
        else for(t in e)e[t] && (n && (n += " "), n += t);
    }
    return n;
}
function $c65a4c058153566e$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = ""; f < arguments.length;)(e = arguments[f++]) && (t = $c65a4c058153566e$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $c65a4c058153566e$export$2e2bcd8739ae039 = $c65a4c058153566e$export$4f5d2d50c9deca37;




function $4983ed7d9d06375d$var$_extends() {
    $4983ed7d9d06375d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4983ed7d9d06375d$var$_extends.apply(this, arguments);
}
function $4983ed7d9d06375d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4983ed7d9d06375d$var$isNum(v) {
    return typeof v === "number" && !isNaN(v);
}
function $4983ed7d9d06375d$var$isBool(v) {
    return typeof v === "boolean";
}
function $4983ed7d9d06375d$var$isStr(v) {
    return typeof v === "string";
}
function $4983ed7d9d06375d$var$isFn(v) {
    return typeof v === "function";
}
function $4983ed7d9d06375d$var$parseClassName(v) {
    return $4983ed7d9d06375d$var$isStr(v) || $4983ed7d9d06375d$var$isFn(v) ? v : null;
}
function $4983ed7d9d06375d$var$objectValues(obj) {
    return Object.keys(obj).map(function(key) {
        return obj[key];
    });
}
function $4983ed7d9d06375d$var$hasToastId(toastId) {
    return toastId === 0 || toastId;
}
function $4983ed7d9d06375d$var$getAutoCloseDelay(toastAutoClose, containerAutoClose) {
    return toastAutoClose === false || $4983ed7d9d06375d$var$isNum(toastAutoClose) && toastAutoClose > 0 ? toastAutoClose : containerAutoClose;
}
var $4983ed7d9d06375d$var$canUseDom = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $4983ed7d9d06375d$var$canBeRendered(content) {
    return (0, $fgmOP.isValidElement)(content) || $4983ed7d9d06375d$var$isStr(content) || $4983ed7d9d06375d$var$isFn(content) || $4983ed7d9d06375d$var$isNum(content);
}
var $4983ed7d9d06375d$var$POSITION = {
    TOP_LEFT: "top-left",
    TOP_RIGHT: "top-right",
    TOP_CENTER: "top-center",
    BOTTOM_LEFT: "bottom-left",
    BOTTOM_RIGHT: "bottom-right",
    BOTTOM_CENTER: "bottom-center"
};
var $4983ed7d9d06375d$var$TYPE = {
    INFO: "info",
    SUCCESS: "success",
    WARNING: "warning",
    ERROR: "error",
    DEFAULT: "default",
    DARK: "dark"
};
/**
 * Used to collapse toast after exit animation
 */ function $4983ed7d9d06375d$export$184cca501f1aed7f(node, done, duration) {
    if (duration === void 0) duration = 300;
    var height = node.scrollHeight;
    var style = node.style;
    requestAnimationFrame(function() {
        style.minHeight = "initial";
        style.height = height + "px";
        style.transition = "all " + duration + "ms";
        requestAnimationFrame(function() {
            style.height = "0";
            style.padding = "0";
            style.margin = "0";
            setTimeout(function() {
                return done();
            }, duration);
        });
    });
}
function $4983ed7d9d06375d$export$3ff7dc44d332d222(_ref) {
    var enter = _ref.enter, exit = _ref.exit, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? 750 : _ref$duration, _ref$appendPosition = _ref.appendPosition, appendPosition = _ref$appendPosition === void 0 ? false : _ref$appendPosition, _ref$collapse = _ref.collapse, collapse = _ref$collapse === void 0 ? true : _ref$collapse, _ref$collapseDuration = _ref.collapseDuration, collapseDuration = _ref$collapseDuration === void 0 ? 300 : _ref$collapseDuration;
    var enterDuration, exitDuration;
    if (Array.isArray(duration) && duration.length === 2) {
        enterDuration = duration[0];
        exitDuration = duration[1];
    } else enterDuration = exitDuration = duration;
    return function ToastTransition(_ref2) {
        var children = _ref2.children, position = _ref2.position, preventExitTransition = _ref2.preventExitTransition, done = _ref2.done, props = $4983ed7d9d06375d$var$_objectWithoutPropertiesLoose(_ref2, [
            "children",
            "position",
            "preventExitTransition",
            "done"
        ]);
        var enterClassName = appendPosition ? enter + "--" + position : enter;
        var exitClassName = appendPosition ? exit + "--" + position : exit;
        var onEnter = function onEnter() {
            var node = props.nodeRef.current;
            if (node) {
                node.classList.add(enterClassName);
                node.style.animationFillMode = "forwards";
                node.style.animationDuration = enterDuration + "ms";
            }
        };
        var onEntered = function onEntered() {
            var node = props.nodeRef.current;
            if (node) {
                node.classList.remove(enterClassName);
                node.style.removeProperty("animationFillMode");
                node.style.removeProperty("animationDuration");
            }
        };
        var onExited = function onExited() {
            var node = props.nodeRef.current;
            if (node) {
                node.removeEventListener("animationend", onExited);
                collapse ? $4983ed7d9d06375d$export$184cca501f1aed7f(node, done, collapseDuration) : done();
            }
        };
        var onExit = function onExit() {
            var node = props.nodeRef.current;
            if (node) {
                node.classList.add(exitClassName);
                node.style.animationFillMode = "forwards";
                node.style.animationDuration = exitDuration + "ms";
                node.addEventListener("animationend", onExited);
            }
        };
        return (0, $fgmOP.createElement)((0, $ed222bb70e4be31d$export$2e2bcd8739ae039), Object.assign({}, props, {
            timeout: preventExitTransition ? collapse ? collapseDuration : 50 : {
                enter: enterDuration,
                exit: collapse ? exitDuration + collapseDuration : exitDuration + 50
            },
            onEnter: onEnter,
            onEntered: onEntered,
            onExit: preventExitTransition ? onExited : onExit,
            unmountOnExit: true
        }), children);
    };
}
var $4983ed7d9d06375d$var$eventManager = {
    list: /*#__PURE__*/ new Map(),
    emitQueue: /*#__PURE__*/ new Map(),
    on: function on(event, callback) {
        this.list.has(event) || this.list.set(event, []);
        this.list.get(event).push(callback);
        return this;
    },
    off: function off(event, callback) {
        if (callback) {
            var cb = this.list.get(event).filter(function(cb) {
                return cb !== callback;
            });
            this.list.set(event, cb);
            return this;
        }
        this.list["delete"](event);
        return this;
    },
    cancelEmit: function cancelEmit(event) {
        var timers = this.emitQueue.get(event);
        if (timers) {
            timers.forEach(function(timer) {
                return clearTimeout(timer);
            });
            this.emitQueue["delete"](event);
        }
        return this;
    },
    /**
   * Enqueue the event at the end of the call stack
   * Doing so let the user call toast as follow:
   * toast('1')
   * toast('2')
   * toast('3')
   * Without setTimemout the code above will not work
   */ emit: function emit(event) {
        var _this = this;
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        this.list.has(event) && this.list.get(event).forEach(function(callback) {
            var timer = setTimeout(function() {
                // @ts-ignore
                callback.apply(void 0, args);
            }, 0);
            _this.emitQueue.has(event) || _this.emitQueue.set(event, []);
            _this.emitQueue.get(event).push(timer);
        });
    }
};
/**
 * `useKeeper` is a helper around `useRef`.
 *
 * You don't need to access the `.current`property to get the value
 * If refresh is set to true. The ref will be updated every render
 */ function $4983ed7d9d06375d$var$useKeeper(arg, refresh) {
    if (refresh === void 0) refresh = false;
    var ref = (0, $fgmOP.useRef)(arg);
    (0, $fgmOP.useEffect)(function() {
        if (refresh) ref.current = arg;
    });
    return ref.current;
}
function $4983ed7d9d06375d$var$reducer(state, action) {
    switch(action.type){
        case "ADD":
            return [].concat(state, [
                action.toastId
            ]).filter(function(id) {
                return id !== action.staleId;
            });
        case "REMOVE":
            return $4983ed7d9d06375d$var$hasToastId(action.toastId) ? state.filter(function(id) {
                return id !== action.toastId;
            }) : [];
    }
}
function $4983ed7d9d06375d$export$b262e13ca2dd2381(props) {
    var _useReducer = (0, $fgmOP.useReducer)(function(x) {
        return x + 1;
    }, 0), forceUpdate = _useReducer[1];
    var _useReducer2 = (0, $fgmOP.useReducer)($4983ed7d9d06375d$var$reducer, []), toast = _useReducer2[0], dispatch = _useReducer2[1];
    var containerRef = (0, $fgmOP.useRef)(null);
    var toastCount = $4983ed7d9d06375d$var$useKeeper(0);
    var queue = $4983ed7d9d06375d$var$useKeeper([]);
    var collection = $4983ed7d9d06375d$var$useKeeper({});
    var instance = $4983ed7d9d06375d$var$useKeeper({
        toastKey: 1,
        displayedToast: 0,
        props: props,
        containerId: null,
        isToastActive: isToastActive,
        getToast: function getToast(id) {
            return collection[id] || null;
        }
    });
    (0, $fgmOP.useEffect)(function() {
        instance.containerId = props.containerId;
        $4983ed7d9d06375d$var$eventManager.cancelEmit(3).on(0, buildToast).on(1, function(toastId) {
            return containerRef.current && removeToast(toastId);
        }).on(5, clearWaitingQueue).emit(2, instance);
        return function() {
            return $4983ed7d9d06375d$var$eventManager.emit(3, instance);
        };
    }, []);
    (0, $fgmOP.useEffect)(function() {
        instance.isToastActive = isToastActive;
        instance.displayedToast = toast.length;
        $4983ed7d9d06375d$var$eventManager.emit(4, toast.length, props.containerId);
    }, [
        toast
    ]);
    (0, $fgmOP.useEffect)(function() {
        instance.props = props;
    });
    function isToastActive(id) {
        return toast.indexOf(id) !== -1;
    }
    function clearWaitingQueue(_ref) {
        var containerId = _ref.containerId;
        var _instance$props = instance.props, limit = _instance$props.limit, enableMultiContainer = _instance$props.enableMultiContainer;
        if (limit && (!containerId || instance.containerId === containerId && enableMultiContainer)) {
            toastCount -= queue.length;
            queue = [];
        }
    }
    function removeToast(toastId) {
        var queueLen = queue.length;
        toastCount = $4983ed7d9d06375d$var$hasToastId(toastId) ? toastCount - 1 : toastCount - instance.displayedToast;
        if (toastCount < 0) toastCount = 0;
        if (queueLen > 0) {
            var freeSlot = $4983ed7d9d06375d$var$hasToastId(toastId) ? 1 : instance.props.limit;
            if (queueLen === 1 || freeSlot === 1) {
                instance.displayedToast++;
                dequeueToast();
            } else {
                var toDequeue = freeSlot > queueLen ? queueLen : freeSlot;
                instance.displayedToast = toDequeue;
                for(var i = 0; i < toDequeue; i++)dequeueToast();
            }
        }
        dispatch({
            type: "REMOVE",
            toastId: toastId
        });
    }
    function dequeueToast() {
        var _queue$shift = queue.shift(), toastContent = _queue$shift.toastContent, toastProps = _queue$shift.toastProps, staleId = _queue$shift.staleId; // ensure that exit transition has been completed, hence the timeout
        setTimeout(function() {
            appendToast(toastContent, toastProps, staleId);
        }, 500);
    }
    /**
   * check if a container is attached to the dom
   * check for multi-container, build only if associated
   * check for duplicate toastId if no update
   */ function isNotValid(_ref2) {
        var containerId = _ref2.containerId, toastId = _ref2.toastId, updateId = _ref2.updateId;
        return !containerRef.current || instance.props.enableMultiContainer && containerId !== instance.props.containerId || instance.isToastActive(toastId) && updateId == null ? true : false;
    } // this function and all the function called inside needs to rely on ref(`useKeeper`)
    function buildToast(content, _ref3) {
        var delay = _ref3.delay, staleId = _ref3.staleId, options = $4983ed7d9d06375d$var$_objectWithoutPropertiesLoose(_ref3, [
            "delay",
            "staleId"
        ]);
        if (!$4983ed7d9d06375d$var$canBeRendered(content) || isNotValid(options)) return;
        var toastId = options.toastId, updateId = options.updateId;
        var props = instance.props, isToastActive = instance.isToastActive;
        var closeToast = function closeToast() {
            return removeToast(toastId);
        };
        var isNotAnUpdate = !isToastActive(toastId);
        if (isNotAnUpdate) toastCount++;
        var toastProps = {
            toastId: toastId,
            updateId: updateId,
            key: options.key || instance.toastKey++,
            type: options.type,
            closeToast: closeToast,
            closeButton: options.closeButton,
            rtl: props.rtl,
            position: options.position || props.position,
            transition: options.transition || props.transition,
            className: $4983ed7d9d06375d$var$parseClassName(options.className || props.toastClassName),
            bodyClassName: $4983ed7d9d06375d$var$parseClassName(options.bodyClassName || props.bodyClassName),
            style: options.style || props.toastStyle,
            bodyStyle: options.bodyStyle || props.bodyStyle,
            onClick: options.onClick || props.onClick,
            pauseOnHover: $4983ed7d9d06375d$var$isBool(options.pauseOnHover) ? options.pauseOnHover : props.pauseOnHover,
            pauseOnFocusLoss: $4983ed7d9d06375d$var$isBool(options.pauseOnFocusLoss) ? options.pauseOnFocusLoss : props.pauseOnFocusLoss,
            draggable: $4983ed7d9d06375d$var$isBool(options.draggable) ? options.draggable : props.draggable,
            draggablePercent: $4983ed7d9d06375d$var$isNum(options.draggablePercent) ? options.draggablePercent : props.draggablePercent,
            closeOnClick: $4983ed7d9d06375d$var$isBool(options.closeOnClick) ? options.closeOnClick : props.closeOnClick,
            progressClassName: $4983ed7d9d06375d$var$parseClassName(options.progressClassName || props.progressClassName),
            progressStyle: options.progressStyle || props.progressStyle,
            autoClose: $4983ed7d9d06375d$var$getAutoCloseDelay(options.autoClose, props.autoClose),
            hideProgressBar: $4983ed7d9d06375d$var$isBool(options.hideProgressBar) ? options.hideProgressBar : props.hideProgressBar,
            progress: options.progress,
            role: $4983ed7d9d06375d$var$isStr(options.role) ? options.role : props.role,
            deleteToast: function deleteToast() {
                removeFromCollection(toastId);
            }
        };
        if ($4983ed7d9d06375d$var$isFn(options.onOpen)) toastProps.onOpen = options.onOpen;
        if ($4983ed7d9d06375d$var$isFn(options.onClose)) toastProps.onClose = options.onClose;
        var closeButton = props.closeButton;
        if (options.closeButton === false || $4983ed7d9d06375d$var$canBeRendered(options.closeButton)) closeButton = options.closeButton;
        else if (options.closeButton === true) closeButton = $4983ed7d9d06375d$var$canBeRendered(props.closeButton) ? props.closeButton : true;
        toastProps.closeButton = closeButton;
        var toastContent = content;
        if ((0, $fgmOP.isValidElement)(content) && !$4983ed7d9d06375d$var$isStr(content.type)) toastContent = (0, $fgmOP.cloneElement)(content, {
            closeToast: closeToast,
            toastProps: toastProps
        });
        else if ($4983ed7d9d06375d$var$isFn(content)) toastContent = content({
            closeToast: closeToast,
            toastProps: toastProps
        });
         // not handling limit + delay by design. Waiting for user feedback first
        if (props.limit && props.limit > 0 && toastCount > props.limit && isNotAnUpdate) queue.push({
            toastContent: toastContent,
            toastProps: toastProps,
            staleId: staleId
        });
        else if ($4983ed7d9d06375d$var$isNum(delay) && delay > 0) setTimeout(function() {
            appendToast(toastContent, toastProps, staleId);
        }, delay);
        else appendToast(toastContent, toastProps, staleId);
    }
    function appendToast(content, toastProps, staleId) {
        var toastId = toastProps.toastId;
        collection[toastId] = {
            content: content,
            props: toastProps
        };
        dispatch({
            type: "ADD",
            toastId: toastId,
            staleId: staleId
        });
    }
    function removeFromCollection(toastId) {
        delete collection[toastId];
        forceUpdate();
    }
    function getToastToRender(cb) {
        var toastToRender = {};
        var toastList = props.newestOnTop ? Object.keys(collection).reverse() : Object.keys(collection);
        for(var i = 0; i < toastList.length; i++){
            var _toast = collection[toastList[i]];
            var position = _toast.props.position;
            toastToRender[position] || (toastToRender[position] = []);
            toastToRender[position].push(_toast);
        }
        return Object.keys(toastToRender).map(function(p) {
            return cb(p, toastToRender[p]);
        });
    }
    return {
        getToastToRender: getToastToRender,
        collection: collection,
        containerRef: containerRef,
        isToastActive: isToastActive
    };
}
function $4983ed7d9d06375d$var$getX(e) {
    return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientX : e.clientX;
}
function $4983ed7d9d06375d$var$getY(e) {
    return e.targetTouches && e.targetTouches.length >= 1 ? e.targetTouches[0].clientY : e.clientY;
}
function $4983ed7d9d06375d$export$a407b657d3044108(props) {
    var _useState = (0, $fgmOP.useState)(true), isRunning = _useState[0], setIsRunning = _useState[1];
    var _useState2 = (0, $fgmOP.useState)(false), preventExitTransition = _useState2[0], setPreventExitTransition = _useState2[1];
    var toastRef = (0, $fgmOP.useRef)(null);
    var drag = $4983ed7d9d06375d$var$useKeeper({
        start: 0,
        x: 0,
        y: 0,
        deltaX: 0,
        removalDistance: 0,
        canCloseOnClick: true,
        canDrag: false,
        boundingRect: null
    });
    var syncProps = $4983ed7d9d06375d$var$useKeeper(props, true);
    var autoClose = props.autoClose, pauseOnHover = props.pauseOnHover, closeToast = props.closeToast, onClick = props.onClick, closeOnClick = props.closeOnClick;
    (0, $fgmOP.useEffect)(function() {
        if ($4983ed7d9d06375d$var$isFn(props.onOpen)) props.onOpen((0, $fgmOP.isValidElement)(props.children) && props.children.props);
        return function() {
            if ($4983ed7d9d06375d$var$isFn(syncProps.onClose)) syncProps.onClose((0, $fgmOP.isValidElement)(syncProps.children) && syncProps.children.props);
        };
    }, []);
    (0, $fgmOP.useEffect)(function() {
        props.draggable && bindDragEvents();
        return function() {
            props.draggable && unbindDragEvents();
        };
    }, [
        props.draggable
    ]);
    (0, $fgmOP.useEffect)(function() {
        props.pauseOnFocusLoss && bindFocusEvents();
        return function() {
            props.pauseOnFocusLoss && unbindFocusEvents();
        };
    }, [
        props.pauseOnFocusLoss
    ]);
    function onDragStart(e) {
        var toast = toastRef.current;
        drag.canCloseOnClick = true;
        drag.canDrag = true;
        drag.boundingRect = toast.getBoundingClientRect();
        toast.style.transition = "";
        drag.start = drag.x = $4983ed7d9d06375d$var$getX(e.nativeEvent);
        drag.removalDistance = toast.offsetWidth * (props.draggablePercent / 100);
    }
    function onDragTransitionEnd() {
        if (drag.boundingRect) {
            var _drag$boundingRect = drag.boundingRect, top = _drag$boundingRect.top, bottom = _drag$boundingRect.bottom, left = _drag$boundingRect.left, right = _drag$boundingRect.right;
            if (props.pauseOnHover && drag.x >= left && drag.x <= right && drag.y >= top && drag.y <= bottom) pauseToast();
            else playToast();
        }
    }
    function playToast() {
        setIsRunning(true);
    }
    function pauseToast() {
        setIsRunning(false);
    }
    function bindFocusEvents() {
        window.addEventListener("focus", playToast);
        window.addEventListener("blur", pauseToast);
    }
    function unbindFocusEvents() {
        window.removeEventListener("focus", playToast);
        window.removeEventListener("blur", pauseToast);
    }
    function bindDragEvents() {
        document.addEventListener("mousemove", onDragMove);
        document.addEventListener("mouseup", onDragEnd);
        document.addEventListener("touchmove", onDragMove);
        document.addEventListener("touchend", onDragEnd);
    }
    function unbindDragEvents() {
        document.removeEventListener("mousemove", onDragMove);
        document.removeEventListener("mouseup", onDragEnd);
        document.removeEventListener("touchmove", onDragMove);
        document.removeEventListener("touchend", onDragEnd);
    }
    function onDragMove(e) {
        e.preventDefault();
        var toast = toastRef.current;
        if (drag.canDrag) {
            if (isRunning) pauseToast();
            drag.x = $4983ed7d9d06375d$var$getX(e);
            drag.deltaX = drag.x - drag.start;
            drag.y = $4983ed7d9d06375d$var$getY(e); // prevent false positif during a toast click
            if (drag.start !== drag.x) drag.canCloseOnClick = false;
            toast.style.transform = "translateX(" + drag.deltaX + "px)";
            toast.style.opacity = "" + (1 - Math.abs(drag.deltaX / drag.removalDistance));
        }
    }
    function onDragEnd() {
        var toast = toastRef.current;
        if (drag.canDrag) {
            drag.canDrag = false;
            if (Math.abs(drag.deltaX) > drag.removalDistance) {
                setPreventExitTransition(true);
                props.closeToast();
                return;
            }
            toast.style.transition = "transform 0.2s, opacity 0.2s";
            toast.style.transform = "translateX(0)";
            toast.style.opacity = "1";
        }
    }
    var eventHandlers = {
        onMouseDown: onDragStart,
        onTouchStart: onDragStart,
        onMouseUp: onDragTransitionEnd,
        onTouchEnd: onDragTransitionEnd
    };
    if (autoClose && pauseOnHover) {
        eventHandlers.onMouseEnter = pauseToast;
        eventHandlers.onMouseLeave = playToast;
    } // prevent toast from closing when user drags the toast
    if (closeOnClick) eventHandlers.onClick = function(e) {
        onClick && onClick(e);
        drag.canCloseOnClick && closeToast();
    };
    return {
        playToast: playToast,
        pauseToast: pauseToast,
        isRunning: isRunning,
        preventExitTransition: preventExitTransition,
        toastRef: toastRef,
        eventHandlers: eventHandlers
    };
}
function $4983ed7d9d06375d$var$CloseButton(_ref) {
    var closeToast = _ref.closeToast, type = _ref.type, _ref$ariaLabel = _ref.ariaLabel, ariaLabel = _ref$ariaLabel === void 0 ? "close" : _ref$ariaLabel;
    return (0, $fgmOP.createElement)("button", {
        className: "Toastify__close-button Toastify__close-button--" + type,
        type: "button",
        onClick: function onClick(e) {
            e.stopPropagation();
            closeToast(e);
        },
        "aria-label": ariaLabel
    }, (0, $fgmOP.createElement)("svg", {
        "aria-hidden": "true",
        viewBox: "0 0 14 16"
    }, (0, $fgmOP.createElement)("path", {
        fillRule: "evenodd",
        d: "M7.71 8.23l3.75 3.75-1.48 1.48-3.75-3.75-3.75 3.75L1 11.98l3.75-3.75L1 4.48 2.48 3l3.75 3.75L9.98 3l1.48 1.48-3.75 3.75z"
    })));
}
function $4983ed7d9d06375d$var$ProgressBar(_ref) {
    var _ref2, _animationEvent;
    var delay = _ref.delay, isRunning = _ref.isRunning, closeToast = _ref.closeToast, type = _ref.type, hide = _ref.hide, className = _ref.className, userStyle = _ref.style, controlledProgress = _ref.controlledProgress, progress = _ref.progress, rtl = _ref.rtl, isIn = _ref.isIn;
    var style = $4983ed7d9d06375d$var$_extends({}, userStyle, {
        animationDuration: delay + "ms",
        animationPlayState: isRunning ? "running" : "paused",
        opacity: hide ? 0 : 1
    });
    if (controlledProgress) style.transform = "scaleX(" + progress + ")";
    var defaultClassArr = [
        "Toastify__progress-bar",
        controlledProgress ? "Toastify__progress-bar--controlled" : "Toastify__progress-bar--animated",
        "Toastify__progress-bar--" + type,
        (_ref2 = {}, _ref2["Toastify__progress-bar--rtl"] = rtl, _ref2)
    ];
    var classNames = $4983ed7d9d06375d$var$isFn(className) ? className({
        rtl: rtl,
        type: type,
        defaultClassName: (0, $c65a4c058153566e$export$2e2bcd8739ae039).apply(void 0, defaultClassArr)
    }) : (0, $c65a4c058153566e$export$2e2bcd8739ae039).apply(void 0, [].concat(defaultClassArr, [
        className
    ])); // 🧐 controlledProgress is derived from progress
    // so if controlledProgress is set
    // it means that this is also the case for progress
    var animationEvent = (_animationEvent = {}, _animationEvent[controlledProgress && progress >= 1 ? "onTransitionEnd" : "onAnimationEnd"] = controlledProgress && progress < 1 ? null : function() {
        isIn && closeToast();
    }, _animationEvent);
    return (0, $fgmOP.createElement)("div", Object.assign({
        className: classNames,
        style: style
    }, animationEvent));
}
$4983ed7d9d06375d$var$ProgressBar.defaultProps = {
    type: $4983ed7d9d06375d$var$TYPE.DEFAULT,
    hide: false
};
var $4983ed7d9d06375d$var$Toast = function Toast(props) {
    var _ref;
    var _useToast = $4983ed7d9d06375d$export$a407b657d3044108(props), isRunning = _useToast.isRunning, preventExitTransition = _useToast.preventExitTransition, toastRef = _useToast.toastRef, eventHandlers = _useToast.eventHandlers;
    var closeButton = props.closeButton, children = props.children, autoClose = props.autoClose, onClick = props.onClick, type = props.type, hideProgressBar = props.hideProgressBar, closeToast = props.closeToast, Transition = props.transition, position = props.position, className = props.className, style = props.style, bodyClassName = props.bodyClassName, bodyStyle = props.bodyStyle, progressClassName = props.progressClassName, progressStyle = props.progressStyle, updateId = props.updateId, role = props.role, progress = props.progress, rtl = props.rtl, toastId = props.toastId, deleteToast = props.deleteToast;
    var defaultClassArr = [
        "Toastify__toast",
        "Toastify__toast--" + type,
        (_ref = {}, _ref["Toastify__toast--rtl"] = rtl, _ref)
    ];
    var cssClasses = $4983ed7d9d06375d$var$isFn(className) ? className({
        rtl: rtl,
        position: position,
        type: type,
        defaultClassName: (0, $c65a4c058153566e$export$2e2bcd8739ae039).apply(void 0, defaultClassArr)
    }) : (0, $c65a4c058153566e$export$2e2bcd8739ae039).apply(void 0, [].concat(defaultClassArr, [
        className
    ]));
    var controlledProgress = !!progress;
    function renderCloseButton(closeButton) {
        if (!closeButton) return;
        var props = {
            closeToast: closeToast,
            type: type
        };
        if ($4983ed7d9d06375d$var$isFn(closeButton)) return closeButton(props);
        if ((0, $fgmOP.isValidElement)(closeButton)) return (0, $fgmOP.cloneElement)(closeButton, props);
    }
    return (0, $fgmOP.createElement)(Transition, {
        "in": props["in"],
        appear: true,
        done: deleteToast,
        position: position,
        preventExitTransition: preventExitTransition,
        nodeRef: toastRef
    }, (0, $fgmOP.createElement)("div", Object.assign({
        id: toastId,
        onClick: onClick,
        className: cssClasses || undefined
    }, eventHandlers, {
        style: style,
        ref: toastRef
    }), (0, $fgmOP.createElement)("div", Object.assign({}, props["in"] && {
        role: role
    }, {
        className: $4983ed7d9d06375d$var$isFn(bodyClassName) ? bodyClassName({
            type: type
        }) : (0, $c65a4c058153566e$export$2e2bcd8739ae039)("Toastify__toast-body", bodyClassName),
        style: bodyStyle
    }), children), renderCloseButton(closeButton), (autoClose || controlledProgress) && (0, $fgmOP.createElement)($4983ed7d9d06375d$var$ProgressBar, Object.assign({}, updateId && !controlledProgress ? {
        key: "pb-" + updateId
    } : {}, {
        rtl: rtl,
        delay: autoClose,
        isRunning: isRunning,
        isIn: props["in"],
        closeToast: closeToast,
        hide: hideProgressBar,
        type: type,
        style: progressStyle,
        className: progressClassName,
        controlledProgress: controlledProgress,
        progress: progress
    }))));
};
var $4983ed7d9d06375d$export$d20e79fdc3899e95 = /*#__PURE__*/ $4983ed7d9d06375d$export$3ff7dc44d332d222({
    enter: "Toastify__bounce-enter",
    exit: "Toastify__bounce-exit",
    appendPosition: true
});
var $4983ed7d9d06375d$export$d8dc01b5c85a37b9 = /*#__PURE__*/ $4983ed7d9d06375d$export$3ff7dc44d332d222({
    enter: "Toastify__slide-enter",
    exit: "Toastify__slide-exit",
    duration: [
        450,
        750
    ],
    appendPosition: true
});
var $4983ed7d9d06375d$export$65cfd44a2050f99 = /*#__PURE__*/ $4983ed7d9d06375d$export$3ff7dc44d332d222({
    enter: "Toastify__zoom-enter",
    exit: "Toastify__zoom-exit"
});
var $4983ed7d9d06375d$export$4d2fae537bd90431 = /*#__PURE__*/ $4983ed7d9d06375d$export$3ff7dc44d332d222({
    enter: "Toastify__flip-enter",
    exit: "Toastify__flip-exit"
});
var $4983ed7d9d06375d$var$ToastPositioner = function ToastPositioner(_ref) {
    var children = _ref.children, className = _ref.className, style = _ref.style, rest = $4983ed7d9d06375d$var$_objectWithoutPropertiesLoose(_ref, [
        "children",
        "className",
        "style"
    ]);
    // Monkey patch react-transition-group
    // As exit transition is broken with strict mode
    delete rest["in"];
    return (0, $fgmOP.createElement)("div", {
        className: className,
        style: style
    }, (0, $fgmOP.Children).map(children, function(child) {
        return (0, $fgmOP.cloneElement)(child, rest);
    }));
};
var $4983ed7d9d06375d$export$f2815235e76a62b9 = function ToastContainer(props) {
    var _useToastContainer = $4983ed7d9d06375d$export$b262e13ca2dd2381(props), getToastToRender = _useToastContainer.getToastToRender, containerRef = _useToastContainer.containerRef, isToastActive = _useToastContainer.isToastActive;
    var className = props.className, style = props.style, rtl = props.rtl, containerId = props.containerId;
    return (0, $fgmOP.createElement)("div", {
        ref: containerRef,
        className: "Toastify",
        id: containerId
    }, getToastToRender(function(position, toastList) {
        var _cx, _cx2;
        var swag = {
            className: $4983ed7d9d06375d$var$isFn(className) ? className({
                position: position,
                rtl: rtl,
                defaultClassName: (0, $c65a4c058153566e$export$2e2bcd8739ae039)("Toastify__toast-container", "Toastify__toast-container--" + position, (_cx = {}, _cx["Toastify__toast-container--rtl"] = rtl, _cx))
            }) : (0, $c65a4c058153566e$export$2e2bcd8739ae039)("Toastify__toast-container", "Toastify__toast-container--" + position, (_cx2 = {}, _cx2["Toastify__toast-container--rtl"] = rtl, _cx2), $4983ed7d9d06375d$var$parseClassName(className)),
            style: toastList.length === 0 ? $4983ed7d9d06375d$var$_extends({}, style, {
                pointerEvents: "none"
            }) : $4983ed7d9d06375d$var$_extends({}, style)
        };
        return (0, $fgmOP.createElement)($4983ed7d9d06375d$var$ToastPositioner, Object.assign({}, swag, {
            key: "container-" + position
        }), toastList.map(function(_ref) {
            var content = _ref.content, toastProps = _ref.props;
            return (0, $fgmOP.createElement)($4983ed7d9d06375d$var$Toast, Object.assign({}, toastProps, {
                "in": isToastActive(toastProps.toastId),
                key: "toast-" + toastProps.key,
                closeButton: toastProps.closeButton === true ? $4983ed7d9d06375d$var$CloseButton : toastProps.closeButton
            }), content);
        }));
    }));
};
$4983ed7d9d06375d$export$f2815235e76a62b9.defaultProps = {
    position: $4983ed7d9d06375d$var$POSITION.TOP_RIGHT,
    transition: $4983ed7d9d06375d$export$d20e79fdc3899e95,
    rtl: false,
    autoClose: 5000,
    hideProgressBar: false,
    closeButton: $4983ed7d9d06375d$var$CloseButton,
    pauseOnHover: true,
    pauseOnFocusLoss: true,
    closeOnClick: true,
    newestOnTop: false,
    draggable: true,
    draggablePercent: 80,
    role: "alert"
};
var $4983ed7d9d06375d$var$containers = /*#__PURE__*/ new Map();
var $4983ed7d9d06375d$var$latestInstance;
var $4983ed7d9d06375d$var$containerDomNode;
var $4983ed7d9d06375d$var$containerConfig;
var $4983ed7d9d06375d$var$queue = [];
var $4983ed7d9d06375d$var$lazy = false;
/**
 * Check whether any container is currently mounted in the DOM
 */ function $4983ed7d9d06375d$var$isAnyContainerMounted() {
    return $4983ed7d9d06375d$var$containers.size > 0;
}
/**
 * Get the container by id. Returns the last container declared when no id is given.
 */ function $4983ed7d9d06375d$var$getContainer(containerId) {
    if (!$4983ed7d9d06375d$var$isAnyContainerMounted()) return null;
    return $4983ed7d9d06375d$var$containers.get(!containerId ? $4983ed7d9d06375d$var$latestInstance : containerId);
}
/**
 * Get the toast by id, given it's in the DOM, otherwise returns null
 */ function $4983ed7d9d06375d$var$getToast(toastId, _ref) {
    var containerId = _ref.containerId;
    var container = $4983ed7d9d06375d$var$getContainer(containerId);
    if (!container) return null;
    return container.getToast(toastId);
}
/**
 * Generate a random toastId
 */ function $4983ed7d9d06375d$var$generateToastId() {
    return (Math.random().toString(36) + Date.now().toString(36)).substr(2, 10);
}
/**
 * Generate a toastId or use the one provided
 */ function $4983ed7d9d06375d$var$getToastId(options) {
    if (options && ($4983ed7d9d06375d$var$isStr(options.toastId) || $4983ed7d9d06375d$var$isNum(options.toastId))) return options.toastId;
    return $4983ed7d9d06375d$var$generateToastId();
}
/**
 * If the container is not mounted, the toast is enqueued and
 * the container lazy mounted
 */ function $4983ed7d9d06375d$var$dispatchToast(content, options) {
    if ($4983ed7d9d06375d$var$isAnyContainerMounted()) $4983ed7d9d06375d$var$eventManager.emit(0, content, options);
    else {
        $4983ed7d9d06375d$var$queue.push({
            content: content,
            options: options
        });
        if ($4983ed7d9d06375d$var$lazy && $4983ed7d9d06375d$var$canUseDom) {
            $4983ed7d9d06375d$var$lazy = false;
            $4983ed7d9d06375d$var$containerDomNode = document.createElement("div");
            document.body.appendChild($4983ed7d9d06375d$var$containerDomNode);
            (0, $91d813eb41c8c85f$exports.render)((0, $fgmOP.createElement)($4983ed7d9d06375d$export$f2815235e76a62b9, Object.assign({}, $4983ed7d9d06375d$var$containerConfig)), $4983ed7d9d06375d$var$containerDomNode);
        }
    }
    return options.toastId;
}
/**
 * Merge provided options with the defaults settings and generate the toastId
 */ function $4983ed7d9d06375d$var$mergeOptions(type, options) {
    return $4983ed7d9d06375d$var$_extends({}, options, {
        type: options && options.type || type,
        toastId: $4983ed7d9d06375d$var$getToastId(options)
    });
}
var $4983ed7d9d06375d$export$b410431fab84fa58 = function toast(content, options) {
    return $4983ed7d9d06375d$var$dispatchToast(content, $4983ed7d9d06375d$var$mergeOptions($4983ed7d9d06375d$var$TYPE.DEFAULT, options));
};
$4983ed7d9d06375d$export$b410431fab84fa58.success = function(content, options) {
    return $4983ed7d9d06375d$var$dispatchToast(content, $4983ed7d9d06375d$var$mergeOptions($4983ed7d9d06375d$var$TYPE.SUCCESS, options));
};
$4983ed7d9d06375d$export$b410431fab84fa58.info = function(content, options) {
    return $4983ed7d9d06375d$var$dispatchToast(content, $4983ed7d9d06375d$var$mergeOptions($4983ed7d9d06375d$var$TYPE.INFO, options));
};
$4983ed7d9d06375d$export$b410431fab84fa58.error = function(content, options) {
    return $4983ed7d9d06375d$var$dispatchToast(content, $4983ed7d9d06375d$var$mergeOptions($4983ed7d9d06375d$var$TYPE.ERROR, options));
};
$4983ed7d9d06375d$export$b410431fab84fa58.warning = function(content, options) {
    return $4983ed7d9d06375d$var$dispatchToast(content, $4983ed7d9d06375d$var$mergeOptions($4983ed7d9d06375d$var$TYPE.WARNING, options));
};
$4983ed7d9d06375d$export$b410431fab84fa58.dark = function(content, options) {
    return $4983ed7d9d06375d$var$dispatchToast(content, $4983ed7d9d06375d$var$mergeOptions($4983ed7d9d06375d$var$TYPE.DARK, options));
};
/**
 * Maybe I should remove warning in favor of warn, I don't know
 */ $4983ed7d9d06375d$export$b410431fab84fa58.warn = $4983ed7d9d06375d$export$b410431fab84fa58.warning;
/**
 * Remove toast programmaticaly
 */ $4983ed7d9d06375d$export$b410431fab84fa58.dismiss = function(id) {
    return $4983ed7d9d06375d$var$isAnyContainerMounted() && $4983ed7d9d06375d$var$eventManager.emit(1, id);
};
/**
 * Clear waiting queue when limit is used
 */ $4983ed7d9d06375d$export$b410431fab84fa58.clearWaitingQueue = function(params) {
    if (params === void 0) params = {};
    return $4983ed7d9d06375d$var$isAnyContainerMounted() && $4983ed7d9d06375d$var$eventManager.emit(5, params);
};
/**
 * return true if one container is displaying the toast
 */ $4983ed7d9d06375d$export$b410431fab84fa58.isActive = function(id) {
    var isToastActive = false;
    $4983ed7d9d06375d$var$containers.forEach(function(container) {
        if (container.isToastActive && container.isToastActive(id)) isToastActive = true;
    });
    return isToastActive;
};
$4983ed7d9d06375d$export$b410431fab84fa58.update = function(toastId, options) {
    if (options === void 0) options = {};
    // if you call toast and toast.update directly nothing will be displayed
    // this is why I defered the update
    setTimeout(function() {
        var toast = $4983ed7d9d06375d$var$getToast(toastId, options);
        if (toast) {
            var oldOptions = toast.props, oldContent = toast.content;
            var nextOptions = $4983ed7d9d06375d$var$_extends({}, oldOptions, options, {
                toastId: options.toastId || toastId,
                updateId: $4983ed7d9d06375d$var$generateToastId()
            });
            if (nextOptions.toastId !== toastId) nextOptions.staleId = toastId;
            var content = typeof nextOptions.render !== "undefined" ? nextOptions.render : oldContent;
            delete nextOptions.render;
            $4983ed7d9d06375d$var$dispatchToast(content, nextOptions);
        }
    }, 0);
};
/**
 * Used for controlled progress bar.
 */ $4983ed7d9d06375d$export$b410431fab84fa58.done = function(id) {
    $4983ed7d9d06375d$export$b410431fab84fa58.update(id, {
        progress: 1
    });
};
/**
 * Track changes. The callback get the number of toast displayed
 *
 */ $4983ed7d9d06375d$export$b410431fab84fa58.onChange = function(callback) {
    if ($4983ed7d9d06375d$var$isFn(callback)) $4983ed7d9d06375d$var$eventManager.on(4, callback);
    return function() {
        $4983ed7d9d06375d$var$isFn(callback) && $4983ed7d9d06375d$var$eventManager.off(4, callback);
    };
};
/**
 * Configure the ToastContainer when lazy mounted
 */ $4983ed7d9d06375d$export$b410431fab84fa58.configure = function(config) {
    if (config === void 0) config = {};
    $4983ed7d9d06375d$var$lazy = true;
    $4983ed7d9d06375d$var$containerConfig = config;
};
$4983ed7d9d06375d$export$b410431fab84fa58.POSITION = $4983ed7d9d06375d$var$POSITION;
$4983ed7d9d06375d$export$b410431fab84fa58.TYPE = $4983ed7d9d06375d$var$TYPE;
/**
 * Wait until the ToastContainer is mounted to dispatch the toast
 * and attach isActive method
 */ $4983ed7d9d06375d$var$eventManager.on(2, function(containerInstance) {
    $4983ed7d9d06375d$var$latestInstance = containerInstance.containerId || containerInstance;
    $4983ed7d9d06375d$var$containers.set($4983ed7d9d06375d$var$latestInstance, containerInstance);
    $4983ed7d9d06375d$var$queue.forEach(function(item) {
        $4983ed7d9d06375d$var$eventManager.emit(0, item.content, item.options);
    });
    $4983ed7d9d06375d$var$queue = [];
}).on(3, function(containerInstance) {
    $4983ed7d9d06375d$var$containers["delete"](containerInstance.containerId || containerInstance);
    if ($4983ed7d9d06375d$var$containers.size === 0) $4983ed7d9d06375d$var$eventManager.off(0).off(1).off(5);
    if ($4983ed7d9d06375d$var$canUseDom && $4983ed7d9d06375d$var$containerDomNode) document.body.removeChild($4983ed7d9d06375d$var$containerDomNode);
});





var $f5d0c2a7498ff49b$exports = {};
"use strict";
var $f5d0c2a7498ff49b$var$__createBinding = $f5d0c2a7498ff49b$exports && $f5d0c2a7498ff49b$exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $f5d0c2a7498ff49b$var$__setModuleDefault = $f5d0c2a7498ff49b$exports && $f5d0c2a7498ff49b$exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $f5d0c2a7498ff49b$var$__importStar = $f5d0c2a7498ff49b$exports && $f5d0c2a7498ff49b$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f5d0c2a7498ff49b$var$__createBinding(result, mod, k);
    }
    $f5d0c2a7498ff49b$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty($f5d0c2a7498ff49b$exports, "__esModule", {
    value: true
});
$f5d0c2a7498ff49b$exports.environments = $f5d0c2a7498ff49b$exports.hosts = $f5d0c2a7498ff49b$exports.ipAddresses = $f5d0c2a7498ff49b$exports.pathParams = $f5d0c2a7498ff49b$exports.mockData = $f5d0c2a7498ff49b$exports.range = $f5d0c2a7498ff49b$exports.permissions = $f5d0c2a7498ff49b$exports.sort = $f5d0c2a7498ff49b$exports.utils = $f5d0c2a7498ff49b$exports.urlPaths = $f5d0c2a7498ff49b$exports.period = $f5d0c2a7498ff49b$exports.format = $f5d0c2a7498ff49b$exports.eventTypes = $f5d0c2a7498ff49b$exports.dates = $f5d0c2a7498ff49b$exports.constants = $f5d0c2a7498ff49b$exports.model = void 0;

const $f5d0c2a7498ff49b$var$constants = $f5d0c2a7498ff49b$var$__importStar((parcelRequire("6N8I1")));
$f5d0c2a7498ff49b$exports.constants = $f5d0c2a7498ff49b$var$constants;

const $f5d0c2a7498ff49b$var$dates = $f5d0c2a7498ff49b$var$__importStar((parcelRequire("4119J")));
$f5d0c2a7498ff49b$exports.dates = $f5d0c2a7498ff49b$var$dates;

const $f5d0c2a7498ff49b$var$environments = $f5d0c2a7498ff49b$var$__importStar((parcelRequire("2Ef1X")));
$f5d0c2a7498ff49b$exports.environments = $f5d0c2a7498ff49b$var$environments;

const $f5d0c2a7498ff49b$var$eventTypes = $f5d0c2a7498ff49b$var$__importStar((parcelRequire("01pTR")));
$f5d0c2a7498ff49b$exports.eventTypes = $f5d0c2a7498ff49b$var$eventTypes;

const $f5d0c2a7498ff49b$var$format = $f5d0c2a7498ff49b$var$__importStar((parcelRequire("4hQuU")));
$f5d0c2a7498ff49b$exports.format = $f5d0c2a7498ff49b$var$format;

const $f5d0c2a7498ff49b$var$hosts = $f5d0c2a7498ff49b$var$__importStar((parcelRequire("aOoAs")));
$f5d0c2a7498ff49b$exports.hosts = $f5d0c2a7498ff49b$var$hosts;

const $f5d0c2a7498ff49b$var$ipAddresses = $f5d0c2a7498ff49b$var$__importStar((parcelRequire("gExGH")));
$f5d0c2a7498ff49b$exports.ipAddresses = $f5d0c2a7498ff49b$var$ipAddresses;

const $f5d0c2a7498ff49b$var$mockData = $f5d0c2a7498ff49b$var$__importStar((parcelRequire("8stA2")));
$f5d0c2a7498ff49b$exports.mockData = $f5d0c2a7498ff49b$var$mockData;

const $f5d0c2a7498ff49b$var$model = $f5d0c2a7498ff49b$var$__importStar((parcelRequire("l8GLF")));
$f5d0c2a7498ff49b$exports.model = $f5d0c2a7498ff49b$var$model;

const $f5d0c2a7498ff49b$var$pathParams = $f5d0c2a7498ff49b$var$__importStar((parcelRequire("96eCA")));
$f5d0c2a7498ff49b$exports.pathParams = $f5d0c2a7498ff49b$var$pathParams;

const $f5d0c2a7498ff49b$var$period = $f5d0c2a7498ff49b$var$__importStar((parcelRequire("iEMYl")));
$f5d0c2a7498ff49b$exports.period = $f5d0c2a7498ff49b$var$period;

const $f5d0c2a7498ff49b$var$permissions = $f5d0c2a7498ff49b$var$__importStar((parcelRequire("2MPlc")));
$f5d0c2a7498ff49b$exports.permissions = $f5d0c2a7498ff49b$var$permissions;

const $f5d0c2a7498ff49b$var$range = $f5d0c2a7498ff49b$var$__importStar((parcelRequire("6Cqb9")));
$f5d0c2a7498ff49b$exports.range = $f5d0c2a7498ff49b$var$range;

const $f5d0c2a7498ff49b$var$sort = $f5d0c2a7498ff49b$var$__importStar((parcelRequire("ff9mn")));
$f5d0c2a7498ff49b$exports.sort = $f5d0c2a7498ff49b$var$sort;

const $f5d0c2a7498ff49b$var$urlPaths = $f5d0c2a7498ff49b$var$__importStar((parcelRequire("daG5e")));
$f5d0c2a7498ff49b$exports.urlPaths = $f5d0c2a7498ff49b$var$urlPaths;

const $f5d0c2a7498ff49b$var$utils = $f5d0c2a7498ff49b$var$__importStar((parcelRequire("g6Bzp")));
$f5d0c2a7498ff49b$exports.utils = $f5d0c2a7498ff49b$var$utils;



var $fgmOP = parcelRequire("fgmOP");

var $jPPOv = parcelRequire("jPPOv");
var $da078a8a2d208f2b$exports = {};
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(" ");
    }
    if (0, $da078a8a2d208f2b$exports) {
        classNames.default = classNames;
        $da078a8a2d208f2b$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


var $557d7e86a7a00a80$var$_excluded = [
    "children",
    "className",
    "size",
    "noMargin",
    "noPadding",
    "noPaddingTop",
    "extraPaddingTop",
    "extraMarginBottom",
    "whiteBg",
    "overlappingFullWidthImage"
];
function $557d7e86a7a00a80$var$_extends() {
    $557d7e86a7a00a80$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $557d7e86a7a00a80$var$_extends.apply(this, arguments);
}
function $557d7e86a7a00a80$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $557d7e86a7a00a80$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $557d7e86a7a00a80$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $557d7e86a7a00a80$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Status: *in progress*
 * Category: Misc
 *
 * There are three main container widths: small, medium and large. Body text should be in a small container to reduce line width and make reading easier.
 */ var $557d7e86a7a00a80$var$Container = function Container(_ref) {
    var _classnames;
    var children = _ref.children, className = _ref.className, size = _ref.size, noMargin = _ref.noMargin, noPadding = _ref.noPadding, noPaddingTop = _ref.noPaddingTop, extraPaddingTop = _ref.extraPaddingTop, extraMarginBottom = _ref.extraMarginBottom, whiteBg = _ref.whiteBg, overlappingFullWidthImage = _ref.overlappingFullWidthImage, rest = $557d7e86a7a00a80$var$_objectWithoutProperties(_ref, $557d7e86a7a00a80$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", $557d7e86a7a00a80$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("container", className, (_classnames = {}, $557d7e86a7a00a80$var$_defineProperty(_classnames, "container--".concat(size), size), $557d7e86a7a00a80$var$_defineProperty(_classnames, "container--no-margin", noMargin), $557d7e86a7a00a80$var$_defineProperty(_classnames, "container--no-padding", noPadding), $557d7e86a7a00a80$var$_defineProperty(_classnames, "container--no-padding-top", noPaddingTop), $557d7e86a7a00a80$var$_defineProperty(_classnames, "container--extra-padding-top", extraPaddingTop), $557d7e86a7a00a80$var$_defineProperty(_classnames, "container--extra-margin-bottom", extraMarginBottom), $557d7e86a7a00a80$var$_defineProperty(_classnames, "container--white-bg", whiteBg), $557d7e86a7a00a80$var$_defineProperty(_classnames, "container--overlapping-full-width-image", overlappingFullWidthImage), _classnames))
    }, rest), children);
};
$557d7e86a7a00a80$var$Container.propTypes = {
    size: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).oneOf([
        "small",
        "medium",
        "large"
    ]),
    noMargin: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    noPadding: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    noPaddingTop: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    extraPaddingTop: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    extraMarginBottom: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    whiteBg: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    overlappingFullWidthImage: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool
};
var $557d7e86a7a00a80$export$2e2bcd8739ae039 = $557d7e86a7a00a80$var$Container;



var $fgmOP = parcelRequire("fgmOP");
var $0dc584b94bbc2102$var$allIconsHtml = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="display:none">\n        <symbol viewBox="0 0 64 64" id="add-circle"><path d="M32 6a26 26 0 0 1 26 26c0 14.36-11.64 26-26 26S6 46.36 6 32 17.64 6 32 6zm0 4c-12.15 0-22 9.85-22 22s9.85 22 22 22 22-9.85 22-22-9.85-22-22-22zm0 10a2 2 0 0 1 2 2v8h8a2 2 0 1 1 0 4h-8v8a2 2 0 1 1-4 0v-8h-8a2 2 0 1 1 0-4h8v-8a2 2 0 0 1 2-2z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="add"><path d="M31.85 8.005L32 8a2 2 0 0 1 1.995 1.85L34 10v20h20a2 2 0 0 1 1.995 1.85L56 32a2 2 0 0 1-1.85 1.995L54 34H34v20a2 2 0 0 1-1.85 1.995L32 56a2 2 0 0 1-1.995-1.85L30 54V34H10a2 2 0 0 1-1.995-1.85L8 32a2 2 0 0 1 1.85-1.995L10 30h20V10a2 2 0 0 1 1.85-1.995L32 8l-.15.005z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="alarm-off"><path d="M42.419 54.049a2 2 0 0 1-.166 3.491A22.09 22.09 0 0 1 32.033 60a22.09 22.09 0 0 1-10.22-2.51 2 2 0 0 1 1.86-3.49 18.09 18.09 0 0 0 8.36 2 17.85 17.85 0 0 0 8.36-2 2 2 0 0 1 2.026.049zM7.323 8.65l10.63 8.92 3 2.56L48.263 43l7.29 6.13 3.77 3.16a2 2 0 0 1 .24 2.81l-.15.17a2 2 0 0 1-2.67.08L52.693 52l-4.77-4-29-24.36-3.19-2.67-11-9.2a2.027 2.027 0 0 1 2.59-3.12zm7.56 14.26l3.44 2.88a9.46 9.46 0 0 0-.06 1.07c0 8.94-1.28 14.76-4.79 21.14h31.34l4.77 4h-38.39a2.68 2.68 0 0 1-2.35-1.38 2.59 2.59 0 0 1 0-2.62c4-6.54 5.42-12.07 5.42-21.14a13 13 0 0 1 .62-3.95zM35.569 5.127a6 6 0 0 1 2.244 6.623c6.45 2.57 12 8.12 12 15.06-.04 7.53.94 12.62 3.57 17.88l-6.26-5.24a49.26 49.26 0 0 1-1.35-12.64c0-5.75-5.4-10-10.57-11.72a18.16 18.16 0 0 0-1.8-.52 38.7 38.7 0 0 0 .59-4 3.43 3.43 0 0 0 0-.41 1.56 1.56 0 0 0 0-.2 2 2 0 1 0-4 0 1.56 1.56 0 0 0 0 .2 3.43 3.43 0 0 0 0 .41 38.7 38.7 0 0 0 .59 4 18.16 18.16 0 0 0-1.8.52 19.61 19.61 0 0 0-6.44 3.62l-3.01-2.59a22.38 22.38 0 0 1 7-4.37 6 6 0 0 1 9.236-6.623z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="alarm"><path d="M42.386 54.049a2 2 0 0 1-.166 3.491A22.09 22.09 0 0 1 32 60a22.09 22.09 0 0 1-10.22-2.51A2 2 0 0 1 23.64 54 18.09 18.09 0 0 0 32 56a17.85 17.85 0 0 0 8.36-2 2 2 0 0 1 2.026.049zM28.504 5.177A6 6 0 0 1 37.74 11.8c6.45 2.57 12 8.12 12 15.06 0 9.07 1.42 14.6 5.42 21.14a2.59 2.59 0 0 1 .03 2.62A2.68 2.68 0 0 1 52.84 52H11.16a2.68 2.68 0 0 1-2.32-1.38 2.59 2.59 0 0 1 0-2.62c4-6.54 5.42-12.07 5.42-21.14 0-6.94 5.55-12.49 12-15.06a6 6 0 0 1 2.244-6.623zM32.04 8.01a2 2 0 0 0-2 2 1.56 1.56 0 0 0 0 .2 3.43 3.43 0 0 0 0 .41 38.7 38.7 0 0 0 .59 4 18.16 18.16 0 0 0-1.8.52c-5.17 1.72-10.57 5.97-10.57 11.72 0 8.94-1.28 14.76-4.79 21.14h37.14c-3.51-6.38-4.79-12.2-4.79-21.14 0-5.72-5.4-9.97-10.57-11.72a18.16 18.16 0 0 0-1.8-.52 38.7 38.7 0 0 0 .59-4 3.43 3.43 0 0 0 0-.41 1.56 1.56 0 0 0 0-.2 2 2 0 0 0-2-2z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="alert"><path d="M53.133 45.803L36.82 13.215c-2.653-4.287-6.99-4.287-9.636 0L10.87 45.803C8.614 50.31 10.896 54 15.938 54h32.128c5.035 0 7.317-3.69 5.067-8.197zM33.33 15.18l16.224 32.41c.922 1.847.575 2.41-1.488 2.41H15.938c-2.068 0-2.415-.56-1.49-2.406l16.226-32.416c1.004-1.57 1.648-1.571 2.656.002zM32 25c1.105 0 2 1.096 2 2.451V38.55C34 39.904 33.105 41 32 41s-2-1.096-2-2.451V27.45c0-1.355.895-2.451 2-2.451zm2 20a1.999 1.999 0 1 1-4 0 1.999 1.999 0 1 1 4 0z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="arrow-down"><path d="M31.147 44.903L11.554 20.74a2 2 0 0 0-3.107 2.52l21.083 26a2 2 0 0 0 3.054.063l22.916-26a2 2 0 1 0-3-2.645L31.147 44.903z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="arrow-large-down"><path d="M12.662 32.513a2 2 0 0 1 2.704.026l.12.123L30 48.788 30 10a2 2 0 0 1 1.85-1.995L32 8a2 2 0 0 1 1.995 1.85L34 10v38.789l14.513-16.127a2 2 0 0 1 2.692-.259l.133.11a2 2 0 0 1 .259 2.692l-.11.133-18.008 20.008-.141.14-.075.065-.085.065-.129.087-.206.111-.166.068-.19.058-.192.038-.131.015-.165.007-.162-.007-.166-.02-.105-.02-.167-.045-.15-.054-.154-.07-.144-.08-.164-.114-.133-.111-.168-.172-17.973-19.97a2 2 0 0 1 .15-2.824z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="arrow-large-left"><path d="M31.487 12.662a2 2 0 0 1-.026 2.704l-.123.12L15.212 30 54 30a2 2 0 0 1 1.995 1.85L56 32a2 2 0 0 1-1.85 1.995L54 34H15.211l16.127 14.513a2 2 0 0 1 .259 2.692l-.11.133a2 2 0 0 1-2.692.259l-.133-.11L8.654 33.479l-.14-.141-.065-.075-.065-.085-.087-.129-.111-.206-.068-.166-.058-.19-.038-.192-.015-.131L8 31.999l.007-.162.02-.166.02-.105.045-.167.054-.15.07-.154.08-.144.114-.164.111-.133.172-.168 19.97-17.973a2 2 0 0 1 2.824.15z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="arrow-large-right"><path d="M32.513 51.338a2 2 0 0 1 .026-2.704l.123-.12L48.788 34 10 34a2 2 0 0 1-1.995-1.85L8 32a2 2 0 0 1 1.85-1.995L10 30h38.789L32.662 15.487a2 2 0 0 1-.259-2.692l.11-.133a2 2 0 0 1 2.692-.259l.133.11 20.008 18.008.14.141.065.075.065.085.087.129.111.206.068.166.058.19.038.192.015.131.007.165-.007.162-.02.166-.02.105-.045.167-.054.15-.07.154-.08.144-.114.164-.111.133-.172.168-19.97 17.973a2 2 0 0 1-2.824-.15z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="arrow-large-up"><path d="M51.338 31.487a2 2 0 0 1-2.704-.026l-.12-.123L34 15.212 34 54a2 2 0 0 1-1.85 1.995L32 56a2 2 0 0 1-1.995-1.85L30 54V15.211L15.487 31.338a2 2 0 0 1-2.692.259l-.133-.11a2 2 0 0 1-.259-2.692l.11-.133L30.521 8.654l.141-.14.075-.065.085-.065.129-.087.206-.111.166-.068.19-.058.192-.038.131-.015.165-.007.162.007.166.02.105.02.167.045.15.054.154.07.144.08.164.114.133.111.168.172 17.973 19.97a2 2 0 0 1-.15 2.824z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="arrow-left"><path d="M19.097 31.147L43.26 11.553a2 2 0 0 0-2.52-3.106l-26 21.083a2 2 0 0 0-.063 3.054l26 22.916a2 2 0 1 0 2.645-3L19.097 31.147z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="arrow-right-purple"><path d="M44.903 32.853L20.74 52.447a2 2 0 0 0 2.52 3.106l26-21.083a2 2 0 0 0 .062-3.054l-26-22.916a2 2 0 1 0-2.644 3l24.225 21.353z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="arrow-right-white"><path d="M44.903 32.853L20.74 52.447a2 2 0 0 0 2.52 3.106l26-21.083a2 2 0 0 0 .062-3.054l-26-22.916a2 2 0 1 0-2.644 3l24.225 21.353z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="arrow-right"><path d="M44.903 32.853L20.74 52.447a2 2 0 0 0 2.52 3.106l26-21.083a2 2 0 0 0 .062-3.054l-26-22.916a2 2 0 1 0-2.644 3l24.225 21.353z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="arrow-small-down"><path transform="rotate(180 32 34)" d="M33.386 22.714L47.728 43.55c.502.73.289 1.71-.477 2.19-.27.169-.586.259-.91.259H17.658C16.743 46 16 45.292 16 44.419c0-.309.095-.61.272-.868l14.341-20.837c.503-.73 1.531-.934 2.297-.455"/></symbol>\n        <symbol viewBox="0 0 64 64" id="arrow-small-left"><path transform="rotate(-90 30 32)" d="M31.386 20.714L45.728 41.55c.502.73.289 1.71-.477 2.19-.27.169-.586.259-.91.259H15.658C14.743 44 14 43.292 14 42.419c0-.309.095-.61.272-.868l14.341-20.837c.503-.73 1.531-.934 2.297-.455"/></symbol>\n        <symbol viewBox="0 0 64 64" id="arrow-small-right"><path transform="rotate(90 34 32)" d="M35.386 20.714L49.728 41.55c.502.73.289 1.71-.477 2.19-.27.169-.586.259-.91.259H19.658C18.743 44 18 43.292 18 42.419c0-.309.095-.61.272-.868l14.341-20.837c.503-.73 1.531-.934 2.297-.455"/></symbol>\n        <symbol viewBox="0 0 64 64" id="arrow-small-up"><path d="M33.386 18.714L47.728 39.55c.502.73.289 1.71-.477 2.19-.27.169-.586.259-.91.259H17.658C16.743 42 16 41.292 16 40.419c0-.309.095-.61.272-.868l14.341-20.837c.503-.73 1.531-.934 2.297-.455"/></symbol>\n        <symbol viewBox="0 0 64 64" id="arrow-subdirectory"><path d="M51.41 35.41l-12 12a2 2 0 0 1-2.82-2.82L45.17 36H20a8 8 0 0 1-8-8V18a2 2 0 1 1 4 0v10a4 4 0 0 0 4 4h25.17l-8.58-8.59a2 2 0 0 1 2.82-2.82l12 12a2 2 0 0 1 0 2.82z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="arrow-up"><path d="M32.853 19.097L52.447 43.26a2 2 0 0 0 3.106-2.52l-21.083-26a2 2 0 0 0-3.054-.062l-22.916 26a2 2 0 1 0 3 2.644l21.353-24.225z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="attach"><path d="M53.77 27.82L45.64 36 36 45.55l-5.21 5.25c-5.293 5.146-13.737 5.087-18.957-.133-5.22-5.22-5.279-13.664-.133-18.957l15.56-15.56A2.008 2.008 0 0 1 30.09 19L14.53 34.54A9.521 9.521 0 1 0 28 48l5.31-5.3L51 25a6 6 0 0 0-4.3-10.25 6 6 0 0 0-4.24 1.75l-3.13 3.13v.06L24.78 34.18 23 36a2.5 2.5 0 0 0 0 3.53 2.56 2.56 0 0 0 3.54 0l16.27-16.31a2.001 2.001 0 0 1 2.83 2.83L29.38 42.31a6.5 6.5 0 1 1-9.19-9.19l19.44-19.44a10 10 0 0 1 14.14 14.14z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="battery"><path d="M48 16a8 8 0 0 1 7.75 6H56c2.24 0 4 2.05 4 4.67v10.66C60 40 58.24 42 56 42h-.25A8 8 0 0 1 48 48H12a8 8 0 0 1-8-8V24a8 8 0 0 1 8-8zm0 4H12a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h36a4 4 0 0 0 4-4v-2h3.83c.118-.203.176-.435.17-.67V26.67a1.275 1.275 0 0 0-.17-.67H52v-2a4 4 0 0 0-4-4zm-32.374 3.997l.194.003H26a2 2 0 0 1 1.41.59l12 12a2 2 0 0 1 .44 2.18A2 2 0 0 1 38 40H15.82A3.67 3.67 0 0 1 12 36.5v-9a3.67 3.67 0 0 1 3.82-3.5zM25.17 28H16v8h17.17l-8-8z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="best-in-test"><path d="M48 4a4 4 0 0 1 4 4v4h3.83a4 4 0 0 1 3.95 4.64A16.12 16.12 0 0 1 49.48 29 20.2 20.2 0 0 1 38 39v3c.005.09.005.18 0 .27.005.09.005.18 0 .27a18.88 18.88 0 0 1 11.38 12.34 3.94 3.94 0 0 1-.63 3.51A4 4 0 0 1 45.54 60H18.46a4 4 0 0 1-3.84-5.13A18.92 18.92 0 0 1 26 42.53a1.64 1.64 0 0 1 0-.23V39a20.41 20.41 0 0 1-11.5-10A16.1 16.1 0 0 1 4.22 16.66 4 4 0 0 1 8.17 12H12V8a4 4 0 0 1 4-4zM34 39.89a17.45 17.45 0 0 1-4 0V42c.005.09.005.18 0 .27.005.09.005.18 0 .27a4 4 0 0 1-2.63 3.74A14.87 14.87 0 0 0 18.45 56h27.09a14.83 14.83 0 0 0-8.91-9.71A4 4 0 0 1 34 42.54a2.48 2.48 0 0 1 0-.27 2.48 2.48 0 0 1 0-.27zM48 8H16v11.131c.004.505.02.999.1 1.519.02.18.08.35.08.53.06.46.13.92.23 1.37.03.17.12.33.12.5.109.486.242.967.4 1.44.04.11.11.22.11.33.2.56.43 1.12.68 1.66A15.93 15.93 0 0 0 32 36a15.87 15.87 0 0 0 14.26-9.46 18.28 18.28 0 0 0 1.74-7.8V8zm-14.12 3.55c.75 0 1.12.31 1.12 1v16.31a3.9 3.9 0 0 1-.63 2.14 1.77 1.77 0 0 1-1.38 1c-.5 0-.98-.37-1.5-1.12A2.39 2.39 0 0 1 31 29.7V16.32l-3.4 1.56a1.09 1.09 0 0 1-.46.12c-.48 0-.94-.36-1.38-1a2.27 2.27 0 0 1-.43-1.08c0-.53.45-1.01 1.35-1.43l5.93-2.68a3.24 3.24 0 0 1 1.27-.26zM12 16H8.17a12 12 0 0 0 4.26 7.33v-.17c-.02-.12-.07-.24-.07-.37-.11-.6-.2-1.21-.26-1.83v-.17c-.1-.68-.1-1.36-.1-2.05V16zm43.77 0h-3.83v4.35c-.02.26-.07.52-.07.78l-.06.5-.09.67c-.03.18-.1.35-.1.53l-.09.5A12 12 0 0 0 55.77 16z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="business-intelligence"><path d="M35 4c12.703 0 23 10.297 23 23a24.08 24.08 0 0 1-8 17.91V56a4 4 0 0 1-4 4H30a4 4 0 0 1-4-4v-2a4 4 0 0 0-4-4h-6a4 4 0 0 1-4-4v-8h-1.54a4 4 0 0 1-3-6.66L12 26.22C12.42 13.823 22.596 3.993 35 4zm0 4c-10.493 0-19 8.507-19 19v.76L10.45 34H16v12h6a8 8 0 0 1 8 8v2h16V44.9a4 4 0 0 1 1.4-3A20.27 20.27 0 0 0 54 27c0-10.493-8.507-19-19-19zm1 5a2 2 0 0 1 2 2v1.2a10.09 10.09 0 0 1 3.51 1.46l1.08-1.07a2 2 0 0 1 2.82 2.82l-1.07 1.08A10.09 10.09 0 0 1 45.8 24H47a2 2 0 1 1 0 4h-1.2a10.09 10.09 0 0 1-1.46 3.51l1.07 1.08a2 2 0 0 1-2.82 2.82l-1.08-1.07A10.09 10.09 0 0 1 38 35.8V37a2 2 0 1 1-4 0v-1.2a10.09 10.09 0 0 1-3.51-1.46l-1.08 1.07a2 2 0 1 1-2.82-2.82l1.07-1.08A10.09 10.09 0 0 1 26.2 28H25a2 2 0 1 1 0-4h1.2a10.09 10.09 0 0 1 1.46-3.51l-1.07-1.08a2 2 0 0 1 2.82-2.82l1.08 1.07A10.09 10.09 0 0 1 34 16.2V15a2 2 0 0 1 2-2zm0 7a6 6 0 1 0 0 12 6 6 0 0 0 0-12z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="business"><path d="M38 8a6 6 0 0 1 6 6v2h10a6 6 0 0 1 6 6v28a6 6 0 0 1-6 6H10a6 6 0 0 1-6-6V22a6 6 0 0 1 6-6h10v-2a6 6 0 0 1 6-6zm18 33.65a5.8 5.8 0 0 1-2 .35H10a5.8 5.8 0 0 1-2-.35V50a2 2 0 0 0 2 2h44a2 2 0 0 0 2-2zM54 20H10a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h44a2 2 0 0 0 2-2V22a2 2 0 0 0-2-2zM32 32a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm6-20H26a2 2 0 0 0-2 2v2h16v-2a2 2 0 0 0-2-2z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="calendar"><path d="M24 4a4 4 0 0 1 4 4v4h8V8a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v4h4a4 4 0 0 1 4 4v32a8 8 0 0 1-8 8H16a8 8 0 0 1-8-8V16a4 4 0 0 1 4-4h4V8a4 4 0 0 1 4-4zm-8 12h-4v32a4 4 0 0 0 4 4h32a4 4 0 0 0 4-4V16h-4a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4h-8a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4zm26.88 9.76c.75 0 1.12.34 1.12 1.03v16.32a4 4 0 0 1-.63 2.13 1.75 1.75 0 0 1-1.38 1c-.5 0-.98-.37-1.5-1.12a2.39 2.39 0 0 1-.49-1.18V30.56l-3.4 1.51a1.09 1.09 0 0 1-.46.12c-.48 0-.94-.31-1.38-1a2.25 2.25 0 0 1-.43-1.06c0-.54.45-1.02 1.35-1.44l5.93-2.68a3.232 3.232 0 0 1 1.27-.25zm-17.49-.36a7 7 0 0 1 3.21.74 5.84 5.84 0 0 1 2.23 1.95 4.65 4.65 0 0 1 .8 2.63 4.56 4.56 0 0 1-.63 2.34 5.5 5.5 0 0 1-1.89 1.87 5.93 5.93 0 0 1 2.45 2.03 4.82 4.82 0 0 1 .9 2.81 5.46 5.46 0 0 1-1.09 3.29 7.37 7.37 0 0 1-2.79 2.33 8.66 8.66 0 0 1-7.66-.15 6.22 6.22 0 0 1-2.68-2.56 2.2 2.2 0 0 1-.23-.77c0-.4.28-.78.83-1.14a3.17 3.17 0 0 1 1.76-.54 1 1 0 0 1 .89.4 5.11 5.11 0 0 0 1.63 1.49 4 4 0 0 0 2 .47 3.66 3.66 0 0 0 3-1.33 1.93 1.93 0 0 0 .39-.89 2.47 2.47 0 0 0-.94-2.62 4.38 4.38 0 0 0-2.67-.74h-1.31c-.38 0-.77-.28-1.17-.85a1.83 1.83 0 0 1-.37-.92c0-.37.24-.69.72-1a2.73 2.73 0 0 1 1.48-.45 4.32 4.32 0 0 0 2.61-.7 2.21 2.21 0 0 0 .95-1.87 2 2 0 0 0-.81-1.58 3.23 3.23 0 0 0-2-.64 5.45 5.45 0 0 0-3.85 2.05 1.18 1.18 0 0 1-.77.4 1.73 1.73 0 0 1-1.37-1 1.93 1.93 0 0 1-.4-1 1.09 1.09 0 0 1 .17-.54 7.5 7.5 0 0 1 2.82-2.51 8.06 8.06 0 0 1 3.79-1zM44 8h-4v8h4V8zM24 8h-4v8h4V8z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="camera"><path d="M37.53 6C39.94 6 42 7.79 43 10.68L45.44 18H50a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H14a8 8 0 0 1-8-8V26a8 8 0 0 1 8-8h4.56L21 10.68C22 7.79 24.06 6 26.47 6zM50 22H14a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h36a4 4 0 0 0 4-4V26a4 4 0 0 0-4-4zm-18 4c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12zm0 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zm5.53-20H26.47c-.47 0-1.25.67-1.68 1.94L22.77 18h18.44l-2-6.06c-.43-1.27-1.17-1.94-1.68-1.94z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="card-view"><path d="M52 34a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4V38a4 4 0 0 1 4-4h40zm-30 4H12v14h10V38zm30 0H26v14h26V38zm0-30a4 4 0 0 1 4 4v14a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4V12a4 4 0 0 1 4-4h40zm-30 4H12v14h10V12zm30 0H26v14h26V12z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="chat"><path d="M52 10H24a8 8 0 0 0-8 8v8h-4a8 8 0 0 0-8 8v12a8 8 0 0 0 8 8h7.17l5.71 5.71a3 3 0 0 0 2.12.88 3 3 0 0 0 3-3V54h10a8 8 0 0 0 8-8v-8h4a8 8 0 0 0 8-8V18a8 8 0 0 0-8-8zm-8 36a4 4 0 0 1-4 4H26v5.17L20.83 50H12a4 4 0 0 1-4-4V34a4 4 0 0 1 4-4h4a8 8 0 0 0 8 8h6v3.59a3 3 0 0 0 5.12 2.12L40.83 38H44v8zm12-16a4 4 0 0 1-4 4H39.17L34 39.17V34H24a4 4 0 0 1-4-4V18a4 4 0 0 1 4-4h28a4 4 0 0 1 4 4v12z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="check-mark"><path d="M11.365 34.538a2 2 0 1 0-2.73 2.924l15 14a2 2 0 0 0 2.847-.119l29-32a2 2 0 1 0-2.964-2.686L24.881 47.153 11.365 34.538z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="child-boy"><path d="M13.87 12.13c5.94-6.68 17.83-9.02 26.68-5.3a13.16 13.16 0 0 1 10.54 5.76c2.47 3.76 2.8 8.76.91 13.76v1.43l.33.09v.02a7.82 7.82 0 0 1 0 15l-.76.21a20 20 0 0 1-39.14 0l-.81-.23a7.82 7.82 0 0 1 0-15l.44-.12c-2.8-5.51-2.19-11.14 1.81-15.62zM40 21.78a40.17 40.17 0 0 1-24 9V39c0 8.837 7.163 16 16 16s16-7.163 16-16V27.66c-3.3-.88-5.92-3.35-8-5.88zm-2.965 22.76a2 2 0 0 1 1.785 2.97v.06a7.8 7.8 0 0 1-6.537 4.01l-.283.005a7.8 7.8 0 0 1-6.82-4.015 2.011 2.011 0 0 1 3.49-2 3.8 3.8 0 0 0 6.65 0 2 2 0 0 1 1.715-1.03zM12 32a3.81 3.81 0 0 0 0 6.75zm40 0v6.7a3.82 3.82 0 0 0 0-6.7zm-22.27 3.33c.17.386.21.797.136 1.183a1.997 1.997 0 0 1-3.796.457 2.06 2.06 0 0 0-1.85-.8 2.1 2.1 0 0 0-1.86.8 2 2 0 0 1-3.872-.714 2 2 0 0 1 .212-.926 5.92 5.92 0 0 1 5.52-3.2 5.84 5.84 0 0 1 5.51 3.2zm16 0c.17.386.21.797.136 1.183a1.997 1.997 0 0 1-3.796.457 2.06 2.06 0 0 0-1.85-.8 2.1 2.1 0 0 0-1.838.772l.008-.012a2.01 2.01 0 0 1-.186.302A2.002 2.002 0 0 1 34.7 35.37c.19-.368.415-.71.67-1.024a5.915 5.915 0 0 1 4.85-2.216 5.84 5.84 0 0 1 5.51 3.2zm-6.838-24.909C31.547 7.38 21.722 9.267 16.86 14.74c-2.15 2.44-4.03 6.49-.78 12a35.77 35.77 0 0 0 22.91-9.34 2 2 0 0 1 2.94.3c2.47 3.35 4.65 5.29 6.74 6a10.69 10.69 0 0 0-.98-8.96 9.15 9.15 0 0 0-7.64-4h-.06a1.6 1.6 0 0 1-.39-.05l-.36-.12z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="child-girl"><path d="M21.57 7.82a23.25 23.25 0 0 1 24-.61A24.2 24.2 0 0 1 58 29.08v1.49a7.72 7.72 0 0 1 0 7.53v5c0 9.498 1.71 12.14 1.979 12.511l.021.029-.06-.04a2 2 0 0 1-.66 3.4c-.26.09-2.7.87-8.09.87a33.18 33.18 0 0 1-12.63-2.7l-.47.13a20 20 0 0 1-11-.23l-.581.249A33.27 33.27 0 0 1 14.24 59.87c-5.4 0-7.84-.78-8.1-.87a2 2 0 0 1-1.29-1.55 2 2 0 0 1 .67-1.79c.22-.24 2-2.74 2-12.54v-5.89a7.63 7.63 0 0 1 0-5.69c-.02-.8-.08-1.61-.08-2.43-.07-1.86-.16-11.43 5.26-17.2a12.82 12.82 0 0 1 8.87-4.09zM54 41.66a5.3 5.3 0 0 1-.67.23l-.76.21a20 20 0 0 1-8.75 12.73 26.09 26.09 0 0 0 7.39 1.1v-.02a38.91 38.91 0 0 0 4.33-.22C54.72 53.4 54 49.56 54 43.1zm-42.56-.21v1.65c0 6.46-.71 10.3-1.54 12.59a39 39 0 0 0 4.34.22A26.55 26.55 0 0 0 22 54.7a20 20 0 0 1-8.58-12.58l-.81-.23a7.19 7.19 0 0 1-1.17-.44zM25 20.8c-2.11 2.53-4.73 5-8 5.88V38c.002 8.312 6.368 15.239 14.65 15.94.44.04.89.06 1.35.06h.8c8.523-.427 15.21-7.467 15.2-16v-8.2a40.17 40.17 0 0 1-24-9zm13.035 22.74a2 2 0 0 1 1.785 2.97v.06a7.8 7.8 0 0 1-6.537 4.01l-.283.005a7.8 7.8 0 0 1-6.82-4.015 2.011 2.011 0 0 1 3.49-2 3.8 3.8 0 0 0 6.65 0 2 2 0 0 1 1.715-1.03zM52.78 30.92v6.91l.22-.1a3.71 3.71 0 0 0 1-.8 3.77 3.77 0 0 0 1-2.55 3.81 3.81 0 0 0-1-2.58 3.71 3.71 0 0 0-1-.8 1.51 1.51 0 0 0-.22-.08zm-39.61-.01A.56.56 0 0 0 13 31a3.67 3.67 0 0 0-1.47 1.41 3.73 3.73 0 0 0-.56 1.94 3.82 3.82 0 0 0 .55 2 3.7 3.7 0 0 0 1.48 1.4l.17.07zm12.297.253l.245.003a5.84 5.84 0 0 1 5.018 3.204 2 2 0 0 1-1.665 2.792l-.165.008a2 2 0 0 1-1.83-1.2 2.06 2.06 0 0 0-1.85-.8l-.165-.01-.164.004a2.1 2.1 0 0 0-1.531.806 2 2 0 0 1-1.615 1.28l-.169.015h-.168A2 2 0 0 1 19.7 34.37a5.92 5.92 0 0 1 5.273-3.206l.247.006.247-.007zm16 0l.245.003a5.84 5.84 0 0 1 5.018 3.204 2 2 0 0 1-1.665 2.792l-.165.008a2 2 0 0 1-1.83-1.2 2.06 2.06 0 0 0-1.85-.8l-.165-.01-.164.004a2.1 2.1 0 0 0-1.531.806 2 2 0 0 1-1.69 1.101l-.15.002a2 2 0 0 1-1.82-2.703 5.92 5.92 0 0 1 5.273-3.206l.247.006.247-.007zM43.62 10.79a19.34 19.34 0 0 0-20.24.69l-.11.07a2.32 2.32 0 0 1-.53.25h-.55a8.91 8.91 0 0 0-6.57 2.84c-3.09 3.36-4.07 8.94-4.19 12.68a8.1 8.1 0 0 1 1.19-.45l.38-.11V25a2 2 0 0 1 1.85-2c2.55-.17 5.16-2.17 8.21-6.27a2 2 0 0 1 2.94-.3 35.83 35.83 0 0 0 24.64 9.38H51a2 2 0 0 1 1.46.58c.085.084.159.178.22.28l.69.2c.214.058.424.128.63.21a20.18 20.18 0 0 0-10.38-16.29z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="close"><path d="M12.469 12.713l.117-.127a2 2 0 0 1 2.701-.117l.127.117L32 29.17l16.586-16.585a2 2 0 0 1 2.701-.117l.127.117a2 2 0 0 1 .117 2.701l-.117.127L34.83 32l16.585 16.586a2 2 0 0 1 .117 2.701l-.117.127a2 2 0 0 1-2.701.117l-.127-.117L32 34.83 15.414 51.414a2 2 0 0 1-2.701.117l-.127-.117a2 2 0 0 1-.117-2.701l.117-.127L29.17 32 12.586 15.414a2 2 0 0 1-.117-2.701l.117-.127-.117.127z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="cloud"><path d="M50 50H16a12 12 0 0 1-1.88-23.85 14 14 0 0 1 26.58-4.06c.43-.06.865-.09 1.3-.09a10 10 0 0 1 9.83 8.17A10 10 0 0 1 50 50zM16 30a8 8 0 1 0 0 16h34a6 6 0 1 0 0-12h-2v-2a6 6 0 0 0-7.91-5.68l-1.93.68-.61-2A10 10 0 0 0 18 28v2h-2z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="company"><path d="M42 6a8 8 0 0 1 8 8v44H36v-6a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v6H14V14a8 8 0 0 1 8-8zm0 4H22a4 4 0 0 0-4 4v40h6v-2a6 6 0 0 1 5.775-5.996L30 46h4a6 6 0 0 1 6 6v2h6V14a4 4 0 0 0-4-4zM26 38v4h-4v-4h4zm8 0v4h-4v-4h4zm8 0v4h-4v-4h4zm-16-8v4h-4v-4h4zm8 0v4h-4v-4h4zm8 0v4h-4v-4h4zm-16-8v4h-4v-4h4zm8 0v4h-4v-4h4zm8 0v4h-4v-4h4zm-16-8v4h-4v-4h4zm8 0v4h-4v-4h4zm8 0v4h-4v-4h4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="contact"><path d="M54 12a6 6 0 0 1 6 6v28a6 6 0 0 1-6 6H10a6 6 0 0 1-6-6V18a6 6 0 0 1 6-6h44zm0 4H10a2 2 0 0 0-1.995 1.85L8 18v28a2 2 0 0 0 1.85 1.995L10 48h44a2 2 0 0 0 1.995-1.85L56 46V18a2 2 0 0 0-2-2zm-29.5 4c3.945 0 7.143 3.168 7.143 7.077a6.932 6.932 0 0 1-1.067 3.698c3.74.758 6.425 4.02 6.424 7.802v.885C37 41.416 35.401 43 33.429 43H15.57C13.6 43 12 41.416 12 39.462v-.885c-.001-3.783 2.684-7.044 6.424-7.802a6.932 6.932 0 0 1-1.067-3.698c0-3.909 3.198-7.077 7.143-7.077zm3.712 13c-2.128 1.581-5.31 1.581-7.438 0-2.666.084-4.776 1.94-4.774 4.2v.6c0 .663.634 1.2 1.417 1.2h14.166c.783 0 1.417-.537 1.417-1.2v-.6c.002-2.265-2.117-4.122-4.788-4.2zM50 28a2 2 0 1 1 0 4H39a2 2 0 1 1 0-4h11zm-25.5-4a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7zM50 21a2 2 0 1 1 0 4H39a2 2 0 1 1 0-4h11z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="customer-dialogue"><path d="M54.6 13.92a2.27 2.27 0 01-2.26 2.26H36.52c-1.24 0-2.26-1.02-2.26-2.26s1.02-2.26 2.26-2.26h15.82a2.27 2.27 0 012.26 2.26zm-9.04 4.52h-9.04c-1.24 0-2.26 1.02-2.26 2.26s1.02 2.26 2.26 2.26h9.04c1.24 0 2.26-1.02 2.26-2.26s-1.02-2.26-2.26-2.26zm18.08-6.78v11.3c0 5-4.04 9.04-9.04 9.04h-1.33l-6.45 6.45c-.96.96-2.44 1.27-3.71.72-1.27-.51-2.08-1.75-2.08-3.13V32h-4.52c0 2.65-.78 5.24-2.23 7.44A15.835 15.835 0 0145.55 54.6c0 3.74-3.04 6.78-6.78 6.78H7.14C3.4 61.38.36 58.34.36 54.6c0-6.99 4.58-13.14 11.27-15.16a13.518 13.518 0 01-.09-14.89c2.95-4.52 8.32-6.87 13.65-5.94v-6.96c0-5 4.04-9.04 9.04-9.04h20.34c5 0 9.04 4.04 9.04 9.04h.03zM13.92 32c0 5 4.04 9.04 9.04 9.04S32 37 32 32s-4.04-9.04-9.04-9.04S13.92 27 13.92 32zm16.45 11.33a13.468 13.468 0 01-14.86 0C9.54 43.66 4.87 48.6 4.84 54.6a2.27 2.27 0 002.26 2.26h31.67a2.27 2.27 0 002.26-2.26c0-6-4.67-10.91-10.67-11.27zm28.75-31.67c0-2.5-2.02-4.52-4.52-4.52H34.26c-2.5 0-4.52 2.02-4.52 4.52v8.62c2.77 1.63 4.91 4.16 6 7.2h9.82v5.85l5.85-5.85h3.19c2.5 0 4.52-2.02 4.52-4.52v-11.3z"/></symbol>\n        <symbol viewBox="0 0 48 54" id="delete"><path d="M42 16a2 2 0 00-2 2v28a4 4 0 01-4 4H12a4 4 0 01-4-4V18a2 2 0 00-4 0v28a8 8 0 008 8h24a8 8 0 008-8V18a2 2 0 00-2-2zM46 8H36V4a4 4 0 00-4-4H16a4 4 0 00-4 4v4H2a2 2 0 000 4h44a2 2 0 000-4zM16 4h16v4H16z"/><path d="M20 42V22a2 2 0 00-4 0v20a2 2 0 004 0zM32 42V22a2 2 0 00-4 0v20a2 2 0 004 0z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="delivery"><path d="M59.54 31.72l-10-12A2 2 0 0 0 48 19h-4v-2a6 6 0 0 0-6-6H10a6 6 0 0 0-6 6v24a6 6 0 0 0 6 6h.08a7 7 0 0 0 13.84 0h12.16a7 7 0 0 0 13.84 0H58a2 2 0 0 0 2-2V33a2 2 0 0 0-.46-1.28zM19.82 47a3 3 0 0 1-5.64 0 2.771 2.771 0 0 1-.18-1 3 3 0 0 1 6 0c.002.342-.059.68-.18 1zm16.86-4H23.32a7 7 0 0 0-12.64 0H10a2 2 0 0 1-2-2V17a2 2 0 0 1 2-2h28a2 2 0 0 1 2 2v22.68A7 7 0 0 0 36.68 43zm9.14 4A3 3 0 0 1 40 46a3.19 3.19 0 0 1 0-.54 3 3 0 0 1 2-2.27 2.77 2.77 0 0 1 1.63-.12A3 3 0 0 1 45.82 45a2.87 2.87 0 0 1 0 2zM56 43h-6.68A7 7 0 0 0 44 39.08V23h3.06L56 33.72V43z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="devices"><path d="M50 4a8 8 0 0 1 8 8v34a8 8 0 0 1-8 8H31.74A8 8 0 0 1 24 60H14a8 8 0 0 1-8-8V24a8 8 0 0 1 8-8h8v-4a8 8 0 0 1 8-8zM28 48H10v4a4 4 0 0 0 4 4h10a4 4 0 0 0 4-4v-4zm-8.99 2.01a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM54 42H32v8h18a4 4 0 0 0 4-4v-4zm-13.99 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM24 20H14a4 4 0 0 0-4 4v20h18V24a4 4 0 0 0-4-4zM50 8H30a4 4 0 0 0-4 4v4.27A8 8 0 0 1 32 24v14h22V12a4 4 0 0 0-4-4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="document-doc"><path d="M50 4H18a8 8 0 0 0-8 8v44a4 4 0 0 0 4 4h32a8 8 0 0 0 8-8V8a4 4 0 0 0-4-4zm0 48a4 4 0 0 1-4 4H14V12a4 4 0 0 1 4-4h32v44zM32.366 40.42c1.596 0 3.012.912 3.744 2.244.372.66.552 1.38.552 2.136 0 1.632-.9 3.06-2.196 3.816a4.207 4.207 0 0 1-2.1.564c-1.596 0-3.012-.912-3.744-2.244a4.295 4.295 0 0 1-.552-2.136c0-1.632.9-3.06 2.208-3.816a4.13 4.13 0 0 1 2.088-.564zm9.456 0c.828 0 1.584.204 2.244.624.12.072.18.192.18.36 0 .588-.384 1.2-.756 1.2a.594.594 0 0 1-.288-.084c-.492-.252-.96-.372-1.416-.372-1.008 0-1.836.516-2.256 1.32a2.816 2.816 0 0 0-.324 1.344c0 1.02.492 1.872 1.248 2.304.372.228.792.336 1.248.336.453 0 .896-.088 1.339-.257l.221-.091c.276-.12.492-.18.66-.18.288 0 .432.144.432.42 0 .42-.192.864-.468 1.104-.516.432-1.452.732-2.304.732-1.572 0-2.904-.876-3.6-2.184a4.41 4.41 0 0 1-.528-2.112c0-1.668.9-3.12 2.232-3.888a4.197 4.197 0 0 1 2.136-.576zm-18.624.18c1.584 0 2.892.804 3.576 2.04.336.612.504 1.296.504 2.028 0 1.764-.756 3.108-2.016 3.804-.636.348-1.356.528-2.184.528H20.99c-.42 0-.828-.732-.828-.96v-6.66c0-.384.612-.78 1.2-.78zm9.168 1.524c-.96 0-1.8.552-2.232 1.368-.228.408-.336.84-.336 1.308 0 1.008.54 1.872 1.32 2.328.384.228.804.348 1.248.348.96 0 1.8-.552 2.244-1.368.216-.408.324-.84.324-1.308 0-1.008-.54-1.884-1.308-2.34a2.48 2.48 0 0 0-1.26-.336zm-9.084.108H21.83v5.136h1.344c1.5 0 2.388-.984 2.388-2.652 0-1.488-.924-2.484-2.28-2.484zM42 26a2 2 0 1 1 0 4H30a2 2 0 1 1 0-4zm-20 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm20-8a2 2 0 1 1 0 4H30a2 2 0 1 1 0-4zm-20 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="document-edit"><path d="M50 4a4 4 0 0 1 4 4v22.15a2 2 0 1 1-4 0V8H17.87a4 4 0 0 0-4 4v44h15.56a2 2 0 1 1 0 4H13.87a4 4 0 0 1-4-4V12a8 8 0 0 1 8-8H50zm-.03 30.89c1.61-1.61 4.33-.97 6.94 1.64 2.6 2.6 3.24 5.32 1.63 6.93L44.21 57.84c-.39.38-1.3 1.28-8.39 2h-.2a2 2 0 0 1-2-2.2c.7-7.1 1.61-8.01 2-8.39zM38.24 53.53c-.12.58-.23 1.28-.33 2l-.02.01c.73-.1 1.42-.21 2.03-.32a22.31 22.31 0 0 0-1.68-1.69zm14.17-15.4l-12 12a20.52 20.52 0 0 1 2.91 2.91L55.34 41a7.7 7.7 0 0 0-2.93-2.87zM21.97 26.06a2.05 2.05 0 1 1 0 4.1 2.05 2.05 0 0 1 0-4.1zm20.03.09a2 2 0 1 1 0 4H30a2 2 0 1 1 0-4h12zm-20.03-8.09a2.05 2.05 0 1 1 0 4.1 2.05 2.05 0 0 1 0-4.1zm20.03.09a2 2 0 1 1 0 4H30a2 2 0 1 1 0-4h12z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="document-pdf"><path d="M50 4a4 4 0 0 1 4 4v44a8 8 0 0 1-8 8H14a4 4 0 0 1-4-4V12a8 8 0 0 1 8-8zm0 4H18a4 4 0 0 0-4 4v44h32a4 4 0 0 0 4-4V8zM25.094 40.6c1.104 0 1.992.528 2.448 1.356.228.42.336.888.336 1.404 0 .768-.372 1.488-.924 1.98s-1.236.768-1.92.768h-1.44v1.656c0 .66-.42 1.308-.84 1.308s-.828-.756-.828-.96V41.38c0-.384.612-.78 1.2-.78zm17.208 0c.3 0 .444.144.444.42 0 .432-.192.864-.432 1.092-.132.108-.252.168-.372.168h-3.048v1.752h2.652c.276 0 .42.132.42.396 0 .588-.372 1.164-.756 1.164h-2.316v2.172c0 .66-.42 1.308-.84 1.308s-.828-.732-.828-.96V41.38c0-.384.612-.78 1.2-.78h3.876zm-10.368 0c1.584 0 2.892.804 3.576 2.04.336.612.504 1.296.504 2.028 0 1.764-.756 3.108-2.016 3.804-.636.348-1.356.528-2.184.528h-2.088c-.42 0-.828-.732-.828-.96v-6.66c0-.384.612-.78 1.2-.78zm.084 1.632h-1.452v5.136h1.344c1.5 0 2.388-.984 2.388-2.652 0-1.488-.924-2.484-2.28-2.484zm-6.972-.072h-1.452v2.388h1.452c.684 0 1.212-.516 1.212-1.188 0-.708-.504-1.2-1.212-1.2zM41 26c1.657 0 3 .895 3 2s-1.343 2-3 2H23c-1.657 0-3-.895-3-2s1.343-2 3-2zm0-8c1.657 0 3 .895 3 2s-1.343 2-3 2H23c-1.657 0-3-.895-3-2s1.343-2 3-2z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="document-ppt"><path d="M50 4H18a8 8 0 0 0-8 8v44a4 4 0 0 0 4 4h32a8 8 0 0 0 8-8V8a4 4 0 0 0-4-4zm0 48a4 4 0 0 1-4 4H14V12a4 4 0 0 1 4-4h32v44zM25.58 40.6c1.104 0 1.992.528 2.448 1.356.228.42.336.888.336 1.404 0 .768-.372 1.488-.924 1.98s-1.236.768-1.92.768h-1.44v1.656c0 .66-.42 1.308-.84 1.308s-.828-.756-.828-.96V41.38c0-.384.612-.78 1.2-.78zm6.972 0c1.104 0 1.992.528 2.448 1.356.228.42.336.888.336 1.404 0 .768-.372 1.488-.924 1.98s-1.236.768-1.92.768h-1.44v1.656c0 .66-.42 1.308-.84 1.308s-.828-.756-.828-.96V41.38c0-.384.612-.78 1.2-.78zm9.24 0c.312 0 .468.144.468.432 0 .66-.42 1.308-.84 1.308h-1.596v5.424c0 .66-.42 1.308-.84 1.308s-.828-.732-.828-.96V42.34h-1.644c-.42 0-.828-.732-.828-.96 0-.384.612-.78 1.2-.78h4.908zm-16.26 1.56H24.08v2.388h1.452c.684 0 1.212-.516 1.212-1.188 0-.708-.504-1.2-1.212-1.2zm6.972 0h-1.452v2.388h1.452c.684 0 1.212-.516 1.212-1.188 0-.708-.504-1.2-1.212-1.2zM42 26a2 2 0 1 1 0 4H30a2 2 0 1 1 0-4zm-20 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm19-8c1.657 0 3 .895 3 2s-1.343 2-3 2H23c-1.657 0-3-.895-3-2s1.343-2 3-2z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="document-xls"><path d="M50 4H18a8 8 0 0 0-8 8v44a4 4 0 0 0 4 4h32a8 8 0 0 0 8-8V8a4 4 0 0 0-4-4zm0 48a4 4 0 0 1-4 4H14V12a4 4 0 0 1 4-4h32v44zM38.96 40.42c.804 0 1.608.252 2.232.684.12.084.18.192.18.348 0 .576-.36 1.14-.732 1.14a.49.49 0 0 1-.214-.06l-.086-.048c-.528-.312-1.008-.468-1.44-.468-.684 0-1.176.3-1.176.732 0 .295.119.47.52.68l.128.064c.22.116.57.259 1.047.445l.213.083c1.536.576 2.22 1.38 2.22 2.628 0 .972-.588 1.788-1.488 2.208a3.419 3.419 0 0 1-1.488.324c-.816 0-1.668-.312-2.292-.768-.312-.228-.552-.48-.708-.756-.096-.156-.144-.288-.144-.384 0-.348.552-.708 1.092-.708a.46.46 0 0 1 .348.132c.54.612 1.044.852 1.704.852.78 0 1.296-.348 1.296-.888 0-.276-.12-.516-.36-.708-.24-.192-.672-.408-1.308-.636-1.776-.66-2.46-1.344-2.46-2.532 0-.9.6-1.668 1.476-2.064.444-.204.924-.3 1.44-.3zm-10.56.108c.348 0 .516.156.516.468 0 .408-.144.804-.42 1.176l-1.788 2.4 2.232 2.892a.518.518 0 0 1 .108.312c0 .66-.408 1.296-.828 1.296-.18 0-.348-.096-.504-.3l-2.172-2.94-1.932 2.784c-.216.3-.432.456-.648.456-.432 0-.912-.792-.912-1.068 0-.108.036-.204.108-.3l2.388-3.18-2.052-2.676c-.168-.228-.252-.42-.252-.564 0-.372.6-.756 1.188-.756.18 0 .324.06.42.192l1.848 2.532 1.464-2.148c.228-.324.756-.576 1.236-.576zm2.94 0c.312 0 .468.144.468.432v6.36h3.12c.3 0 .444.144.444.42 0 .432-.192.864-.432 1.092-.132.108-.252.168-.372.168h-3.6c-.42 0-.828-.732-.828-.96v-6.732c0-.384.612-.78 1.2-.78zM25 26a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm8 0a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm8 0a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm-16-8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm8 0a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1zm8 0a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="document"><path d="M50 4a4 4 0 0 1 4 4v44a8 8 0 0 1-8 8H14a4 4 0 0 1-4-4V12a8 8 0 0 1 8-8zm0 4H18a4 4 0 0 0-4 4v44h32a4 4 0 0 0 4-4V8zm-8 18a2 2 0 1 1 0 4H30a2 2 0 1 1 0-4zm-20 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm20-8a2 2 0 1 1 0 4H30a2 2 0 1 1 0-4zm-20 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="download"><path d="M56 30a2 2 0 0 1 2 2v18a8 8 0 0 1-8 8H14a8 8 0 0 1-8-8V32a2 2 0 1 1 4 0v18a4 4 0 0 0 4 4h36a4 4 0 0 0 4-4V32a2 2 0 0 1 2-2zM32 10a2 2 0 0 1 2 2v27.17l8.59-8.58a2 2 0 0 1 2.82 2.82l-11.29 11.3a3 3 0 0 1-4.24 0l-11.29-11.3a2 2 0 0 1 2.82-2.82L30 39.17V12a2 2 0 0 1 2-2z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="email"><path d="M52 12H12a8 8 0 0 0-8 8v24a8 8 0 0 0 8 8h40a8 8 0 0 0 8-8V20a8 8 0 0 0-8-8zm0 4a3.81 3.81 0 0 1 1 .15L39.17 30H24.83L11 16.15a3.81 3.81 0 0 1 1-.15h40zm4 28a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4V20a3.81 3.81 0 0 1 .15-1L22 32.83A4 4 0 0 0 24.83 34h14.34A4 4 0 0 0 42 32.83L55.85 19c.094.325.145.661.15 1v24z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="entertainment"><path d="M57 21v29.69a6.6 6.6 0 0 1-.26 1.84A6.72 6.72 0 1 1 44.11 48 6.68 6.68 0 0 1 50 44c.09-.01.18-.01.27 0a6.75 6.75 0 0 1 2.73.54V33.1H34v17.59a6.6 6.6 0 0 1-.22 1.84A6.72 6.72 0 1 1 26.62 44h-.04c.093-.01.187-.013.28-.01l.125.009L27 44l.103-.009c.07-.003.138 0 .207.009.23-.015.46-.015.69 0a6.76 6.76 0 0 1 2 .54V27.05l.001-.107-.001.107v-.95h.08l.027-.164A6.082 6.082 0 0 1 36.09 21H57zm-6.73 27H50a2.73 2.73 0 1 0 2.32 4.53h-.04a2.68 2.68 0 0 0 .72-1.84A2.73 2.73 0 0 0 50.27 48zm-22.8-.01h-.04l-.16.01H26.83a2.73 2.73 0 1 0 2.49 4.53 2.68 2.68 0 0 0 .68-1.84A2.73 2.73 0 0 0 27.75 48h.005-.445l.016-.001-.016.001a2.59 2.59 0 0 1 .16-.01zM47 6a8 8 0 0 1 8 8v4h-4v-4a4 4 0 0 0-4-4H15a4 4 0 0 0-4 4v26a4 4 0 0 0 4 4h5.29A9.58 9.58 0 0 0 18 48h-3a8 8 0 0 1-8-8V14a8 8 0 0 1 8-8zM21 34v6h-6v-6h6zm0-10v6h-6v-6h6zm32 1H36.09a2 2 0 0 0-1.85 1.1c-.16.29-.244.618-.24.95v2.05h19V25zM21 14v6h-6v-6h6zm26 0v4h-6v-4h6z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="facebook"><path d="M37.268 60h-11.47V32H20.07v-9.654h5.73v-5.79C25.798 8.681 29.03 4 38.222 4h7.662v9.654h-4.786c-3.578 0-3.82 1.356-3.82 3.864l-.01 4.828h8.673L44.93 32h-7.65v28h-.012z"/></symbol>\n        <symbol viewBox="0 0 37.84 37.84" id="facebook_icon"><path d="M26.55 18.92h-5.23v18.92h-7.93V18.92H9.46v-6.74h3.77V7.82a10.86 10.86 0 0 1 .33-2.54 6.94 6.94 0 0 1 1.24-2.53A6.44 6.44 0 0 1 17.28.81a8.61 8.61 0 0 1 4-.81h6.31v6.31c-.81.05-1.51.05-2.16.05h-2.6a1.9 1.9 0 0 0-1.13.38c-.38.21-.54.75-.54 1.45v4h6z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="filter"><g><path d="M24 14c3.728 0 6.86 2.55 7.748 6H54a2 2 0 1 1 0 4H31.748a8.003 8.003 0 0 1-15.496 0H10a2 2 0 1 1 0-4h6.252c.888-3.45 4.02-6 7.748-6zm0 4a4 4 0 1 0 0 8 4 4 0 0 0 0-8zM40 34a8.003 8.003 0 0 0-7.748 6H10a2 2 0 1 0 0 4h22.252a8.003 8.003 0 0 0 15.496 0H54a2 2 0 1 0 0-4h-6.252c-.888-3.45-4.02-6-7.748-6zm0 4a4 4 0 1 1 0 8 4 4 0 0 1 0-8z"/></g></symbol>\n        <symbol viewBox="0 0 64 64" id="five-g"><path d="M32.5 30.2c-.7 1.1-1 2.3-1 3.6 0 1.2.3 2.3.8 3.3s1.3 1.8 2.3 2.5c1 .6 2.1.9 3.3.9.7 0 1.4-.1 2-.3.6-.2 1.2-.5 1.7-.8.8-.6 1.3-1.4 1.3-2.5v-3.3c0-.4-.2-.6-.7-.6H40c-.4 0-.8.1-1.2.4-.4.2-.6.5-.6.8 0 .1.1.4.3.7.3.4.6.7.9.7h1v1.8c-.7.4-1.4.6-2.2.6-.7 0-1.4-.2-2-.5-.6-.3-1.1-.8-1.4-1.5-.4-.6-.5-1.4-.5-2.2 0-1.2.4-2.2 1.2-3 .8-.8 1.8-1.2 3-1.2.4 0 .7 0 1 .1.3.1.7.2 1.1.4.2.1.3.1.4.1.2 0 .3-.1.5-.3.2-.2.3-.4.4-.7.1-.3.2-.6.2-.9 0-.3-.1-.4-.3-.6-1-.6-2.2-1-3.5-1-1.2 0-2.3.3-3.4.9s-1.7 1.5-2.4 2.6zM25.6 38c-.5 0-.9-.1-1.3-.3-.4-.2-.7-.5-1-.9-.1-.2-.3-.3-.6-.3-.4 0-.8.1-1.2.4-.4.2-.5.5-.5.7 0 .1.1.3.1.5.4.7 1 1.3 1.7 1.7.8.4 1.7.6 2.6.6.9 0 1.7-.2 2.4-.6.7-.4 1.3-.9 1.8-1.6.5-.7.7-1.4.7-2.3 0-.7-.2-1.4-.6-2.1a4.63 4.63 0 00-3.9-2.1c-.3 0-.7 0-1.1.1-.4.1-.7.2-1.1.3l.1-2.8h4.7c.3 0 .6-.2.8-.6.2-.4.4-.8.4-1.2 0-.4-.2-.6-.7-.6h-5.8c-.4 0-.8.1-1.1.3-.4.2-.5.5-.6.8l-.2 5.3c0 .2.1.4.3.7.3.4.5.6.9.6.1 0 .2 0 .4-.1.4-.2.8-.4 1.3-.5.4-.1.9-.2 1.2-.2.7 0 1.2.2 1.7.6.4.4.7.8.7 1.4 0 .6-.2 1.1-.7 1.4-.2.6-.8.8-1.4.8z"/><path d="M53.7 23.2c-.4-1-1.6-1.6-2.6-1.1-.5.2-.9.6-1.1 1.1-.2.5-.2 1 0 1.5 3.3 7.7 1.4 16.7-4.9 22.4-7.1 6.4-18 6.7-25.4.8-4.5-3.6-7.1-8.6-7.4-14.3-.3-5.6 1.8-11.1 5.7-15 3.8-3.8 8.9-5.8 14.3-5.7.6 0 1-.2 1.4-.5.4-.4.6-.9.6-1.4 0-1.1-.9-2-2-2-7.2-.1-14.1 3-18.7 8.6-6.9 8.4-7.1 20.9-.1 29.6 4.3 5.4 10.4 8.5 17.2 8.9H32c6.3 0 12.3-2.5 16.7-6.9 6.9-6.9 8.8-17.1 5-26z"/><path d="M41.3 22.6c.4.4.9.6 1.4.6h.1c.6 0 1.1-.3 1.4-.7l9.4-11.2c.7-.8.6-2.1-.2-2.8-.8-.7-2.1-.6-2.8.2l-8 9.6-3.4-3.4c-.8-.8-2-.8-2.8 0-.8.8-.8 2 0 2.8l4.9 4.9z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="folder-new"><path d="M48 32a2 2 0 0 1 2 2v8h8a2 2 0 1 1 0 4h-8v8a2 2 0 1 1-4 0v-8h-8a2 2 0 1 1 0-4h8v-8a2 2 0 0 1 2-2zm8-8a4 4 0 0 0-3.8-3.995L52 20H32v-2a2 2 0 0 0-2-2H10a2 2 0 0 0-1.995 1.85L8 18v28a4 4 0 0 0 3.8 3.995L12 50h34-10a2 2 0 1 1 0 4h-2l-.046-.002L12 54a8 8 0 0 1-7.996-7.75L4 46V18a6 6 0 0 1 5.775-5.996L10 12h20a6 6 0 0 1 5.574 3.77l.086.23H52a8 8 0 0 1 7.996 7.75L60 24v8a2 2 0 1 1-4 0v-8zm-8 2a2 2 0 1 1 0 4H16a2 2 0 1 1 0-4h32z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="folder"><path d="M30 12a6 6 0 0 1 5.66 4H52a8 8 0 0 1 8 8v22a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8V18a6 6 0 0 1 6-6zm0 4H10a2 2 0 0 0-2 2v28a4 4 0 0 0 4 4h40a4 4 0 0 0 4-4V24a4 4 0 0 0-4-4H32v-2a2 2 0 0 0-2-2zm18 10a2 2 0 1 1 0 4H16a2 2 0 1 1 0-4h32z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="food"><path d="M49.73 4.47a2 2 0 0 1 2 2v46.4A6.67 6.67 0 0 1 45 59.53a6.67 6.67 0 0 1-6.66-6.66v-.1L39.22 37a5.2 5.2 0 0 1-2-1.39 7.8 7.8 0 0 1-1.62-5.4V14.45a8.32 8.32 0 0 1 2.5-6.16c4-3.9 11.32-3.83 11.63-3.82zm-20.282.238A2 2 0 0 1 30.5 6.41l.56 18.47c.16 2.54-.12 5.92-3.95 7.12l1.07 20.49a6.64 6.64 0 0 1-6.45 6.64h-.4a6.65 6.65 0 0 1-6.46-6.64v-.11L16 32c-3.83-1.16-4.12-4.55-3.95-7.15l.56-18.4a2 2 0 1 1 4 .12L16 25c-.19 3 .38 3.17 2.22 3.34l1.92.18-1.27 24a2.66 2.66 0 0 0 5.31 0l-1.26-24 1.91-.18c1.85-.17 2.42-.37 2.23-3.27L26.5 6.53a2 2 0 0 1 2.948-1.822zM47.66 8.58c-2.15.25-5.14.93-6.81 2.57a4.41 4.41 0 0 0-1.32 3.3v15.86c.005.06.005.12 0 .18a3.94 3.94 0 0 0 .65 2.51 1.48 1.48 0 0 0 1.17.44 2 2 0 0 1 1.95 2.1l-.96 17.38a2.66 2.66 0 1 0 5.32-.05V8.58zM21.53 4.47a2 2 0 0 1 2 2v16.72a2 2 0 1 1-4 0V6.47a2 2 0 0 1 2-2z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="fraud"><path d="M18 9.19A20.07 20.07 0 0 1 40.72 7.5c6.12-.14 10.78 3.07 12 8.27V16c.65 6 .28 10.13-1.19 12.82A7.14 7.14 0 0 1 55 35a7 7 0 0 1-4.49 6.53c-4.94 10.79-10.51 16.38-17 17-.58.08-1.17.08-1.75 0-6.49-.59-12.07-6.18-17-17A7 7 0 0 1 10.25 35a7.2 7.2 0 0 1 3.94-6.43C9.64 19.1 13.63 12.85 18 9.19zm-1.35 22.57a3.4 3.4 0 0 0-2.44 3.18 3 3 0 0 0 2.42 3A2 2 0 0 1 18 39.08c4.5 10.08 9.41 15.31 14.61 15.54 5.22-.24 10.12-5.47 14.58-15.54a2 2 0 0 1 1.37-1.14h.02A3 3 0 0 0 51 35a3.23 3.23 0 0 0-1.88-2.98c-1.42 6.68-4.33 10.25-8.67 10.68h-.51c-3.49 0-5.65-2.45-7-5.18-1.39 2.73-3.53 5.18-7 5.18h-.5c-4.46-.44-7.4-4.11-8.79-10.94zm4.2.38c1.01 4.16 2.67 6.37 4.94 6.6h.16c1.82 0 3.33-1.94 4.47-5.94h.02c-3.18-.06-6.36-.28-9.59-.66zM45 32.07c-3.2.393-6.403.633-9.61.72 1.18 4.07 2.71 6.07 4.71 5.94 2.22-.22 3.9-2.46 4.9-6.66zm-6.67-12.3c-2.33 1.84-5.54 2.41-9.33 2.9-6.17.89-8.54 2.58-9.54 5.25h-.01A97 97 0 0 0 45.6 28c-.6-.82-1.6-1.74-2.27-2.45a32 32 0 0 1-5-5.78zm.452-8.726A16.05 16.05 0 0 0 20.46 12.31c-4.04 3.38-5.27 7.31-3.64 12.06 2.05-3.12 5.74-4.87 11.67-5.73 5.67-.73 7.56-1.49 8.56-3.49a1.52 1.52 0 0 1 .28-.4.35.35 0 0 1 .1-.11 1.53 1.53 0 0 1 .41-.31l.19-.1.2-.08a.8.8 0 0 1 .15 0h.19c.12-.02.24-.02.36 0a.76.76 0 0 1 .26 0 1.8 1.8 0 0 1 .55.19 1 1 0 0 1 .26.16c.222.154.406.356.54.59a1.3 1.3 0 0 1 .08.17.85.85 0 0 1 .09.22v.06c.87 2.68 3.26 5.04 5.38 7.11a35.14 35.14 0 0 1 2.5 2.62 26.19 26.19 0 0 0 .15-8.7c-.84-3.38-4.08-5.32-8.45-5.06a1.57 1.57 0 0 1-.93-.13l-.26-.14z"/></symbol>\n        <symbol viewBox="0 0 1417 152" id="full-screen-image-mask"><path d="M1416.281-.014v151.336H-.288C935.129 111.722 1401.807 3.39 1416.282-.014z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="games"><path d="M46 4a2 2 0 0 1 2 2v4a8 8 0 0 1-8 8 4 4 0 0 0-4 4v2h7.6c8.662-.133 15.892 6.581 16.4 15.23a16 16 0 0 1-25.66 13.52 4 4 0 0 0-2.41-.75h-.22a3.46 3.46 0 0 0-2.05.75A15.82 15.82 0 0 1 20 56 16 16 0 0 1 4 39.23c.508-8.649 7.738-15.363 16.4-15.23H32v-2a8 8 0 0 1 8-8 4 4 0 0 0 4-4V6a2 2 0 0 1 2-2zm-2.095 23.998L43.6 28H20.4C13.876 27.875 8.41 32.908 8 39.42a12 12 0 0 0 19.24 10.14A7.38 7.38 0 0 1 31.71 48h.22a8 8 0 0 1 4.83 1.56 12 12 0 0 0 15.92-1.28A11.91 11.91 0 0 0 56 39.42c-.41-6.512-5.876-11.545-12.4-11.42zM20 34a2 2 0 0 1 2 2v2h2a2 2 0 1 1 0 4h-2v2a2 2 0 1 1-4 0v-2h-2a2 2 0 1 1 0-4h2v-2a2 2 0 0 1 2-2zm22 6a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm6-4a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="gift"><path d="M56 16h-8.06c.04-.332.06-.666.06-1a9 9 0 0 0-16-5.64A9 9 0 0 0 16 15c0 .334.02.668.06 1H8a3.84 3.84 0 0 0-4 3.67v6.66A3.84 3.84 0 0 0 8 30v18a8 8 0 0 0 8 8h32a8 8 0 0 0 8-8V30a3.84 3.84 0 0 0 4-3.67v-6.66A3.84 3.84 0 0 0 56 16zm-17-6a5 5 0 0 1 5 5 4.79 4.79 0 0 1-.11 1h-9.78a4.79 4.79 0 0 1-.11-1 5 5 0 0 1 5-5zm-19 5a5 5 0 0 1 10 0 4.79 4.79 0 0 1-.11 1h-9.78a4.79 4.79 0 0 1-.11-1zm10 5v6H8v-6h22zM12 48V30h18v22H16a4 4 0 0 1-4-4zm40 0a4 4 0 0 1-4 4H34V30h18v18zm0-22H34v-6h22v6h-4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="graph"><path d="M10 8a2 2 0 0 1 2 2v38a4 4 0 0 0 4 4h38a2 2 0 1 1 0 4H16a8 8 0 0 1-8-8V10a2 2 0 0 1 2-2zm40 10a4 4 0 0 1 4 4v8a2 2 0 1 1-4 0v-5.18L37.41 37.41a2 2 0 0 1-2.82 0L28 30.83l-8.59 8.58a2 2 0 0 1-2.82-2.82l10-10a2 2 0 0 1 2.82 0L36 33.17 47.18 22H42a2 2 0 1 1 0-4h8z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="grid-view"><path d="M28 34a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V36a2 2 0 0 1 2-2h18zm26 0a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H36a2 2 0 0 1-2-2V36a2 2 0 0 1 2-2h18zm-28 4H12v14h14V38zm26 0H38v14h14V38zM28 8a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h18zm26 0a2 2 0 0 1 2 2v18a2 2 0 0 1-2 2H36a2 2 0 0 1-2-2V10a2 2 0 0 1 2-2h18zm-28 4H12v14h14V12zm26 0H38v14h14V12z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="group"><path d="M21.47 18.538A12 12 0 0 1 35 23.54l.224.358A11.82 11.82 0 0 1 36.63 27.4a10.7 10.7 0 0 1 .3 2.21 4.7 4.7 0 0 1 0 .53 12.39 12.39 0 0 1-.36 2.94 11.36 11.36 0 0 1-1.11 2.8A17.5 17.5 0 0 1 38.27 37a14.91 14.91 0 0 1 3.14 2.12 12.89 12.89 0 0 1 2.15 2.46 14 14 0 0 1 .87 1.54 11.5 11.5 0 0 1 .09 9.98 5.18 5.18 0 0 1-4.52 3H9.74a5.18 5.18 0 0 1-4.52-3 11.7 11.7 0 0 1 1-11.52A13.63 13.63 0 0 1 11.51 37a19.9 19.9 0 0 1 2.86-1.12 11.84 11.84 0 0 1-1.1-2.79 12.39 12.39 0 0 1-.36-2.94 12 12 0 0 1 8.56-11.612zM32.69 39.32a12 12 0 0 1-7.8 2.88h-.42a11.92 11.92 0 0 1-7.38-2.87 14.39 14.39 0 0 0-3.27 1 9.73 9.73 0 0 0-4.27 3.47 7.71 7.71 0 0 0-.8 7.41c.24.45.63.92 1 .92H40c.37 0 .76-.47 1-.92a7.65 7.65 0 0 0-.78-7.42 8 8 0 0 0-.51-.68 9.79 9.79 0 0 0-3.76-2.79 15 15 0 0 0-3.26-1zm17.302-26.708a11.17 11.17 0 0 1 .928 11.758 13.32 13.32 0 0 1 7.28 5.21 10.75 10.75 0 0 1 .9 10.68 4.92 4.92 0 0 1-4.29 2.86h-7.14a15.8 15.8 0 0 0-2.2-4h9.34c.22 0 .52-.3.76-.75a6.83 6.83 0 0 0-.72-6.59 10.08 10.08 0 0 0-6.68-4A11.09 11.09 0 0 1 41 30.39c-.36 0-.71 0-1.06-.05v-.19a14.34 14.34 0 0 0-.25-2.72c-.07-.42-.17-.83-.27-1.23a6.39 6.39 0 0 0 1.58.19 7.16 7.16 0 0 0 5.74-2.88 7.09 7.09 0 0 0 1.43-4.29 7.16 7.16 0 0 0-14.24-1.09 14.67 14.67 0 0 0-3.66-2 11.17 11.17 0 0 1 19.722-3.518zM24.89 22.12v.01a8 8 0 0 0-6.38 12.94c.258.326.535.637.83.93A8 8 0 0 0 22 37.65a8 8 0 0 0 4.2.43 8.09 8.09 0 0 0 4.16-2.09 9.05 9.05 0 0 0 .83-.93 7.93 7.93 0 0 0 1.41-2.85 8.07 8.07 0 0 0 0-4.14 7.88 7.88 0 0 0-2-3.55 8 8 0 0 0-5.71-2.4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="heart-filled"><path d="M53.82 12.35a14.08 14.08 0 0 0-20.35 0L32 13.87l-1.47-1.52a14.08 14.08 0 0 0-20.35 0c-5.562 5.833-5.562 15.007 0 20.84l19 19.59a4 4 0 0 0 5.74 0l19-19.59c5.534-5.86 5.49-15.033-.1-20.84z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="heart"><path d="M53.82 12.35a14.08 14.08 0 0 0-20.35 0L32 13.87l-1.47-1.52a14.08 14.08 0 0 0-20.35 0c-5.562 5.833-5.562 15.007 0 20.84l19 19.59a4 4 0 0 0 5.74 0l19-19.59c5.534-5.86 5.49-15.033-.1-20.84zm-2.88 18.06L32 50 13.06 30.41a11.07 11.07 0 0 1 0-15.28 10.07 10.07 0 0 1 14.59 0l2.91 3c.8.783 2.08.783 2.88 0l2.91-3a10.07 10.07 0 0 1 14.59 0 11.07 11.07 0 0 1 0 15.28z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="home"><path d="M27.76 7.35a6 6 0 0 1 8.48 0l21.83 21.82A4 4 0 0 1 55.24 36H52v18a4 4 0 0 1-4 4H16a4 4 0 0 1-4-4V36H8.76a4 4 0 0 1-2.83-6.83zm5.65 2.83a2 2 0 0 0-2.82 0L8.76 32H16v22h32V32h7.24zM40 36a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4h-6a4 4 0 0 1-4-4v-6a4 4 0 0 1 4-4zm0 4h-6v6h6v-6z"/></symbol>\n        <symbol viewBox="0 0 15 15" id="ico_add"><path d="M13.175 5.675H9.322V1.822a1.822 1.822 0 1 0-3.644 0v3.853H1.822a1.822 1.822 0 0 0 0 3.647h3.853v3.853a1.822 1.822 0 1 0 3.644 0V9.322h3.853A1.822 1.822 0 0 0 14.994 7.5a1.818 1.818 0 0 0-1.819-1.825z"/></symbol>\n        <symbol viewBox="0 0 15 15" id="ico_add_purple"><path d="M13.175 5.675H9.322V1.822a1.822 1.822 0 1 0-3.644 0v3.853H1.822a1.822 1.822 0 0 0 0 3.647h3.853v3.853a1.822 1.822 0 1 0 3.644 0V9.322h3.853A1.822 1.822 0 0 0 14.994 7.5a1.818 1.818 0 0 0-1.819-1.825z"/></symbol>\n        <symbol viewBox="0 0 15 15" id="ico_add_white"><path d="M13.175 5.675H9.322V1.822a1.822 1.822 0 1 0-3.644 0v3.853H1.822a1.822 1.822 0 0 0 0 3.647h3.853v3.853a1.822 1.822 0 1 0 3.644 0V9.322h3.853A1.822 1.822 0 0 0 14.994 7.5a1.818 1.818 0 0 0-1.819-1.825z"/></symbol>\n        <symbol viewBox="0 0 9 13" id="ico_backarrow"><path d="M2.3 9.5l2.9 2.9c.8.8 2 .8 2.8 0 .8-.8.8-2 0-2.8L5.1 6.7 8 3.8c.8-.8.8-2 0-2.8-.8-.7-2-.7-2.7 0l-3 3L1 5.3c-.8.8-.8 2.1 0 2.8l1.3 1.4z"/></symbol>\n        <symbol viewBox="0 0 9 13" id="ico_backarrow_purple"><path d="M2.3 9.5l2.9 2.9c.8.8 2 .8 2.8 0 .8-.8.8-2 0-2.8L5.1 6.7 8 3.8c.8-.8.8-2 0-2.8-.8-.7-2-.7-2.7 0l-3 3L1 5.3c-.8.8-.8 2.1 0 2.8l1.3 1.4z"/></symbol>\n        <symbol viewBox="0 0 9 13" id="ico_backarrow_white"><path d="M2.3 9.5l2.9 2.9c.8.8 2 .8 2.8 0 .8-.8.8-2 0-2.8L5.1 6.7 8 3.8c.8-.8.8-2 0-2.8-.8-.7-2-.7-2.7 0l-3 3L1 5.3c-.8.8-.8 2.1 0 2.8l1.3 1.4z"/></symbol>\n        <symbol viewBox="0 0 17 18" id="ico_buy"><path d="M16.114 13.781H4.82l.549-1.753 9.966-2.045a.887.887 0 0 0 .693-.707l.95-5.143a.883.883 0 0 0-.87-1.045H4.665l-.17-1.54A.884.884 0 0 0 3.616.76H.884a.884.884 0 0 0 0 1.768h1.94l.952 8.65-1.005 3.224a.884.884 0 0 0 .845 1.148h1.22a1.234 1.234 0 0 0 .77 2.203 1.234 1.234 0 1 0 .77-2.203h7.37a1.234 1.234 0 0 0 .77 2.203 1.234 1.234 0 1 0 .77-2.203h.828a.884.884 0 0 0 0-1.768zM9.423 9.388l-1.115.228-.524-4.76h1.141l.498 4.532zm1.28-4.532h1.141l.435 3.947-1.115.228-.461-4.175zm3.694 3.512l-.377.078-.396-3.59h1.421l-.648 3.512zM6 4.856l.563 5.117-1.114.229-.59-5.348H6v.002z"/></symbol>\n        <symbol viewBox="0 0 14 11" id="ico_check"><path d="M5.6 5.3L4 3.47c-.7-.8-1.93-.9-2.75-.2C.43 3.97.33 5.2 1.03 6L4 9.46l.05.06c0 .03.02.04.03.05l.07.07c.36.36.83.54 1.3.55.46 0 .94-.15 1.32-.47l.04-.04c.04 0 .05 0 .06-.03l.08-.1 5.94-6.12c.75-.76.73-2-.04-2.75-.78-.74-2-.73-2.76.05L5.6 5.3z"/></symbol>\n        <symbol viewBox="0 0 60 48" id="ico_check_sharp"><path d="M53.2031 0.949219C53.4609 0.691406 53.7188 0.5625 54.2344 0.5625C54.6211 0.5625 55.0078 0.691406 55.3945 0.949219L59.0039 4.6875C59.2617 4.94531 59.5195 5.33203 59.5195 5.71875C59.5195 6.23438 59.2617 6.62109 59.0039 6.87891L20.332 45.5508C20.0742 45.8086 19.6875 45.9375 19.3008 45.9375C18.7852 45.9375 18.3984 45.8086 18.1406 45.5508L0.996094 28.2773C0.609375 28.0195 0.480469 27.7617 0.480469 27.2461C0.480469 26.8594 0.609375 26.4727 0.996094 26.0859L4.60547 22.4766C4.86328 22.2188 5.25 21.9609 5.76562 21.9609C6.15234 21.9609 6.53906 22.2188 6.79688 22.4766L19.3008 34.9805L53.2031 0.949219Z"/></symbol>\n        <symbol viewBox="0 0 21 16" id="ico_checkmark_green"><path d="M17.705.592L7.644 11.124l-4.35-4.551a1.87 1.87 0 0 0-2.729 0 2.087 2.087 0 0 0 0 2.856l5.714 5.98A1.89 1.89 0 0 0 7.644 16c.511 0 1.002-.213 1.364-.592l11.427-11.96c.487-.51.678-1.254.5-1.951A1.977 1.977 0 0 0 19.57.069a1.872 1.872 0 0 0-1.864.523z"/></symbol>\n        <symbol viewBox="0 0 512 512" id="ico_code-2"><path d="M222.012 293.484v25.212L132.4 279.849v-21.556l89.612-38.838v25.388l-62.439 24.058 62.439 24.583zm55.413-74.565l-24.95 102.713c-.83 3.38-1.554 6.056-2.178 8.018-.624 1.961-1.569 3.495-2.847 4.581-1.277 1.102-3.133 1.649-5.572 1.649-6.05 0-9.083-2.62-9.083-7.835 0-1.368.593-4.783 1.78-10.245l24.854-102.713c1.308-5.461 2.555-9.204 3.742-11.22 1.187-2.019 3.5-3.03 6.95-3.03 2.968 0 5.241.714 6.81 2.14 1.574 1.426 2.364 3.387 2.364 5.879.001 1.841-.628 5.195-1.87 10.063zm102.174 60.93l-89.611 39.022v-25.212l62.625-24.583-62.625-24.234v-25.031l89.611 38.658v21.38z"/><path d="M437.281 74.719H74.719C61.069 74.719 50 85.791 50 99.441v313.121c0 13.645 11.069 24.72 24.719 24.72h362.563c13.654 0 24.719-11.075 24.719-24.72V99.441c-.001-13.655-11.066-24.722-24.72-24.722zm-61.8 16.481c9.082 0 16.48 7.39 16.48 16.481 0 9.088-7.398 16.479-16.48 16.479-9.089 0-16.481-7.391-16.481-16.479 0-9.09 7.392-16.481 16.481-16.481zm-45.319 0c9.083 0 16.476 7.39 16.476 16.481 0 9.088-7.393 16.479-16.476 16.479-9.088 0-16.481-7.391-16.481-16.479-.001-9.09 7.393-16.481 16.481-16.481zm107.119 321.362H74.719V140.641h362.563v271.921zM420.8 124.16c-9.083 0-16.48-7.391-16.48-16.479 0-9.091 7.397-16.481 16.48-16.481s16.481 7.39 16.481 16.481c0 9.088-7.398 16.479-16.481 16.479z"/></symbol>\n        <symbol viewBox="0 0 543.232 543.232" id="ico_code"><path d="M85.972 416.447c5.838 9.139 15.716 14.133 25.814 14.133a30.432 30.432 0 0 0 16.444-4.816c14.241-9.102 18.409-28.023 9.309-42.26L66.915 272.953l70.631-110.54c9.1-14.241 4.933-33.158-9.309-42.258-14.248-9.095-33.158-4.933-42.259 9.309L4.815 256.478a30.593 30.593 0 0 0 0 32.95l81.157 127.019zm329.03 9.309a30.426 30.426 0 0 0 16.444 4.816c10.092 0 19.976-4.986 25.813-14.131l81.158-127.014a30.593 30.593 0 0 0 0-32.95l-81.151-127.014c-9.095-14.248-28.03-18.416-42.259-9.309-14.241 9.1-18.409 28.023-9.309 42.258l70.631 110.54-70.637 110.545c-9.099 14.235-4.931 33.159 9.31 42.259zM165.667 492.6a30.558 30.558 0 0 0 13.213 3.018c11.401 0 22.35-6.402 27.613-17.375L391.979 91.452c7.307-15.239.881-33.519-14.357-40.82-15.245-7.307-33.52-.881-40.821 14.357l-185.492 386.79c-7.307 15.239-.881 33.52 14.358 40.821z"/></symbol>\n        <symbol viewBox="0 0 567.01 536.01" id="ico_contacts"><path d="M440.67 157.71a157.46 157.46 0 0 1-67.95 129.56c180 39.29 190.52 138.93 193.09 198.23.54 12.67-8.79 27.8-21 31-31 8.13-93.57 19.5-261.83 19.5s-230.8-11.36-261.85-19.5c-12.28-3.22-21.6-18.34-21.06-31 2.56-59.3 13.12-158.94 193.1-198.23a157.69 157.69 0 1 1 247.5-129.56z"/></symbol>\n        <symbol viewBox="0 0 17 17" id="ico_content"><g><path d="M12.27 2.977c.2.202.465.311.75.311h2.21L11.958 0v2.227c0 .284.112.551.311.75z"/><path d="M17 8.206v1.698c0 .415-.16.828-.447 1.158a1.773 1.773 0 0 1-1.066.612l-.257.046v3.51c0 .585-.479 1.063-1.064 1.063h-1.071a3.874 3.874 0 0 1-1.567.646 4.03 4.03 0 0 1-.701.061c-.843 0-1.596-.265-2.155-.71H4.25a1.067 1.067 0 0 1-1.064-1.063V12.69A5.51 5.51 0 0 1 0 7.703a5.507 5.507 0 0 1 3.186-4.985V1.064C3.186.478 3.665 0 4.25 0h6.645v2.227a2.124 2.124 0 0 0 2.122 2.125h2.21v2.276c.06-.008.12-.015.177-.015A1.598 1.598 0 0 1 17 8.206zm-1.593-.532l-.095.008-2.615.463a.532.532 0 0 0-.44.525v3.885a2.595 2.595 0 0 0-1.018-.198c-.167 0-.34.014-.514.046-1.254.22-2.13 1.18-1.96 2.144.145.828 1.02 1.39 2.06 1.39.17 0 .342-.015.516-.047 1.081-.192 1.883-.935 1.97-1.753l.007-.221v-2.939l1.992-.352a.728.728 0 0 0 .434-.255c.122-.14.19-.31.19-.469V8.204a.521.521 0 0 0-.19-.406.517.517 0 0 0-.337-.124zM5.503 3.262a4.442 4.442 0 1 0 0 8.884 4.442 4.442 0 0 0 0-8.884z"/><path d="M8.522 7.359L4.129 4.72c-.285-.163-.515.003-.515.364v5.236c0 .362.23.525.515.365L8.524 8.05c.27-.192.27-.503-.002-.692z"/></g></symbol>\n        <symbol viewBox="0 0 303.25 332.98" id="ico_customer_service"><path d="M199.48 200.32a84.14 84.14 0 0 0 36.32-68.64v-.78a83.67 83.67 0 0 0-24.69-59.52 85.19 85.19 0 0 0-19.43-14.52 83.68 83.68 0 0 0-31.47-9.73 83.08 83.08 0 0 0-23.91 1h-1.68c-2.66.56-5.33 1.26-7.92 2a84.14 84.14 0 0 0-59.32 80.77 85.62 85.62 0 0 0 1.73 16.9 73.75 73.75 0 0 0 2 7.86 84.12 84.12 0 0 0 61.14 56.65 42.76 42.76 0 0 1 62.05 38.28v4.42a42.77 42.77 0 0 1-72 26.92 154.27 154.27 0 0 1-79.79-42.07c-3-3-5.89-6.24-8.7-9.53-29.8 24.54-32.6 55-33.79 75.93a17.31 17.31 0 0 0 11.57 16.27c16.54 4.35 50 10.45 140.23 10.45s123.29-6.1 140.21-10.45a17.32 17.32 0 0 0 11.22-16.55c-1.33-31.76-7-85-103.21-105.94"/><path d="M151.52 0A130.92 130.92 0 0 0 34.21 73 31.05 31.05 0 0 0 5.05 97a147.14 147.14 0 0 0 0 67.94 31.06 31.06 0 0 0 29.16 24 130.91 130.91 0 0 0 100.48 71.8 19.44 19.44 0 1 0 2.95-23.14 107.65 107.65 0 0 1-81.53-56.84 111.64 111.64 0 0 1-4.79-10.63l-.84-2.31c-1.05-3-2-6-2.87-9a13.67 13.67 0 0 0-.84-3.22c-.71-2.95-1.27-6-1.69-9a27.1 27.1 0 0 0-.49-3.3 99.11 99.11 0 0 1 0-24.82 7.7 7.7 0 0 1 .49-3.29c.42-3 1-6 1.69-9a14.61 14.61 0 0 1 .84-3.22c.84-3.09 1.75-6.1 2.87-9.05l.84-2.24a107.56 107.56 0 0 1 208.11 39.19 11.71 11.71 0 0 0 23.42 0 131 131 0 0 0-131-131h-.35"/></symbol>\n        <symbol viewBox="0 0 313.77 217.3" id="ico_data_freedom"><defs><clipPath transform="translate(-295 -340.11)"><path fill="none" d="M376.99 340.11h150.28v217.28H376.99z"/></clipPath></defs><g><path d="M232.27 13.17v191a13.19 13.19 0 0 1-13.15 13.18h-124A13.19 13.19 0 0 1 82 204.13v-191A13.19 13.19 0 0 1 95.16-.04h124a13.19 13.19 0 0 1 13.15 13.17M209.92 165.7V24.42a1.79 1.79 0 0 0-1.79-1.79h-102a1.79 1.79 0 0 0-1.76 1.81V165.7a1.79 1.79 0 0 0 1.79 1.79h102a1.79 1.79 0 0 0 1.77-1.79m-53 15.37a11.32 11.32 0 1 0 11.32 11.32 11.31 11.31 0 0 0-11.32-11.32"/></g><path d="M77.4 51.78c-20.73-17-71-36.35-76.6-21.53-4 10.59 7.76 22.75 18.76 28.94 0 0-9.67-1-9.84 7.76 0 6.78 3.41 13.32 15.57 19.92 0 0-7.06 0-7.41 5.79s5.21 12.16 16.38 16.61c0 0-7.52-1.5-5.27 6.43 2.73 9.84 29.71 19.86 49.68 12.85a34.19 34.19 0 0 0 4.22-1.82V57.24a53.39 53.39 0 0 0-5.49-5.46zm158.98 0c20.73-17 71-36.35 76.6-21.53 4 10.59-7.76 22.75-18.76 28.94 0 0 9.67-1 9.84 7.76 0 6.78-3.41 13.32-15.57 19.92 0 0 7.06 0 7.41 5.79s-5.21 12.16-16.39 16.61c0 0 7.53-1.5 5.27 6.43-2.72 9.84-29.7 19.86-49.67 12.85a33.55 33.55 0 0 1-4.22-1.82V57.24a52.41 52.41 0 0 1 5.49-5.46z"/></symbol>\n        <symbol viewBox="0 0 459.8 463.27" id="ico_databoost"><path d="M96.23 383.28l-91.9 79.68c-1.76 1.39-5.43-2.32-4-4.07l80.77-90.93c2.25-2.54 7.27-1.45 11.06 2.38l1.83 1.85c3.78 3.83 4.8 8.87 2.24 11.09zm-73.6-4.09l82.63-70.56c2.31-2 1.07-6.79-2.71-10.62l-1.84-1.86c-3.78-3.83-8.6-5.12-10.59-2.84l-71.5 81.82c-1.25 1.57 2.42 5.29 4.01 4.06zm166.93-37.15c-3.79-3.83-9.15-4.57-11.81-1.64L82.29 445.84c-1.68 2 2 5.73 4 4.07l106.61-94.18c3-2.62 2.29-8-1.5-11.83zm143.35-71l-.69-.18a141.48 141.48 0 0 1-41.51 96.63l-55.67-55.68a62.18 62.18 0 0 1-81.58 1.92l-37.87 32.9c-1.77 1.39-5.44-2.32-4-4.07l33.25-37.43a62.19 62.19 0 0 1 2.35-81.06L90.03 166.9a141.44 141.44 0 0 1 100-41.55c12.43-15.63 115.75-139 268.54-124 15.99 163-125.67 269.73-125.67 269.73zm33.62-134a43.76 43.76 0 1 0-43.76 43.75 43.76 43.76 0 0 0 43.76-43.76z"/></symbol>\n        <symbol viewBox="0 0 670.83 670.83" id="ico_default_doc"><path d="M495.84 627.09a43.87 43.87 0 0 1-43.75 43.75H43.75A43.87 43.87 0 0 1 0 627.09V43.75A43.88 43.88 0 0 1 43.75 0h273.64v91.69a87.5 87.5 0 0 0 87.47 87.49h91v447.91z"/><path d="M373.92 122.62a43.46 43.46 0 0 0 30.9 12.8h91L361.14 0v91.69a43.61 43.61 0 0 0 12.78 30.93z"/></symbol>\n        <symbol viewBox="0 0 21 21" id="ico_delete"><path d="M13.773 10.502l6.546 6.546c.907.907.912 2.366.005 3.273a2.318 2.318 0 0 1-3.278 0L10.5 13.775l-6.546 6.546a2.318 2.318 0 0 1-3.278 0 2.313 2.313 0 0 1 .005-3.273l6.546-6.546L.68 3.956A2.309 2.309 0 0 1 .676.682a2.314 2.314 0 0 1 3.278 0L10.5 7.23 17.046.682A2.309 2.309 0 0 1 20.32.678a2.318 2.318 0 0 1 0 3.278l-6.546 6.546z"/></symbol>\n        <symbol viewBox="0 0 48 43" id="ico_desktop"><path d="M43.3125 0.25C44.3789 0.25 45.2812 0.660156 46.1016 1.39844C46.8398 2.21875 47.25 3.12109 47.25 4.1875V27.8125C47.25 28.9609 46.8398 29.8633 46.1016 30.6016C45.2812 31.4219 44.3789 31.75 43.3125 31.75H27.5625L29.5312 39.625H35.4375C35.7656 39.625 36.0938 39.7891 36.3398 40.0352C36.5859 40.2812 36.75 40.6094 36.75 40.9375C36.75 41.3477 36.5859 41.6758 36.3398 41.9219C36.0938 42.168 35.7656 42.25 35.4375 42.25H11.8125C11.4023 42.25 11.0742 42.168 10.8281 41.9219C10.582 41.6758 10.5 41.3477 10.5 40.9375C10.5 40.6094 10.582 40.2812 10.8281 40.0352C11.0742 39.7891 11.4023 39.625 11.8125 39.625H17.7188L19.6875 31.75H3.9375C2.78906 31.75 1.88672 31.4219 1.14844 30.6016C0.328125 29.8633 0 28.9609 0 27.8125V4.1875C0 3.12109 0.328125 2.21875 1.14844 1.39844C1.88672 0.660156 2.78906 0.25 3.9375 0.25H43.3125ZM20.4258 39.625H26.8242L25.5117 34.375H21.7383L20.4258 39.625ZM44.625 27.8125V23.875H2.625V27.8125C2.625 28.2227 2.70703 28.5508 2.95312 28.7969C3.19922 29.043 3.52734 29.125 3.9375 29.125H43.3125C43.6406 29.125 43.9688 29.043 44.2148 28.7969C44.4609 28.5508 44.625 28.2227 44.625 27.8125ZM44.625 21.25V4.1875C44.625 3.85938 44.4609 3.53125 44.2148 3.28516C43.9688 3.03906 43.6406 2.875 43.3125 2.875H3.9375C3.52734 2.875 3.19922 3.03906 2.95312 3.28516C2.70703 3.53125 2.625 3.85938 2.625 4.1875V21.25H44.625Z"/></symbol>\n        <symbol viewBox="0 0 17 18" id="ico_download"><g><path d="M8.098 10.269c.22.307.574.307.79 0l3.01-5.013c.185-.324-.003-.587-.416-.587h-1.98V1.011a1.012 1.012 0 0 0-2.025 0v3.66H5.499c-.413 0-.601.264-.416.588l3.015 5.01z"/><path d="M14.762 8.488H12.98a1.012 1.012 0 1 0 0 2.022h.771c.666 0 1.212.545 1.212 1.21v2.224c0 .664-.546 1.21-1.212 1.21H3.234a1.216 1.216 0 0 1-1.212-1.21V11.72c0-.668.546-1.21 1.212-1.21h.77a1.012 1.012 0 1 0 0-2.022h-1.78A2.226 2.226 0 0 0 0 10.71v4.243c0 1.224.998 2.218 2.224 2.218h12.538a2.226 2.226 0 0 0 2.225-2.221v-4.24a2.226 2.226 0 0 0-2.225-2.22z"/></g></symbol>\n        <symbol viewBox="0 0 15 10" id="ico_dropArrow"><path d="M.975.67a1.408 1.408 0 0 1 2.073 0l4.496 4.761 4.51-4.777a1.408 1.408 0 0 1 2.073 0 1.62 1.62 0 0 1 0 2.196L8.581 8.725c-.573.607-1.5.607-2.074 0L.975 2.866a1.597 1.597 0 0 1-.429-1.098C.546 1.37.69.973.976.67z"/></symbol>\n        <symbol viewBox="0 0 15 10" id="ico_dropArrow_grey"><path d="M.975.67a1.408 1.408 0 0 1 2.073 0l4.496 4.761 4.51-4.777a1.408 1.408 0 0 1 2.073 0 1.62 1.62 0 0 1 0 2.196L8.581 8.725c-.573.607-1.5.607-2.074 0L.975 2.866a1.597 1.597 0 0 1-.429-1.098C.546 1.37.69.973.976.67z"/></symbol>\n        <symbol viewBox="0 0 15 10" id="ico_dropArrow_purple"><path d="M.975.67a1.408 1.408 0 0 1 2.073 0l4.496 4.761 4.51-4.777a1.408 1.408 0 0 1 2.073 0 1.62 1.62 0 0 1 0 2.196L8.581 8.725c-.573.607-1.5.607-2.074 0L.975 2.866a1.597 1.597 0 0 1-.429-1.098C.546 1.37.69.973.976.67z"/></symbol>\n        <symbol viewBox="8 0 25 35" id="ico_edit"><path d="M30.833 20l.745-.667c1.225-1.083 1.704-2.666 1.258-4.15-.446-1.483-1.75-2.642-3.42-3.038-1.67-.396-3.452.031-4.67 1.12l-.746.662L30.833 20zM28 23.243L21.755 17l-7.312 7.31v.005a4.36 4.36 0 0 0-1.22 2.36l-1.196 4.769c-.157.908.379 1.556 1.218 1.556.104-.001.209-.01.312-.028l4.77-1.194a4.393 4.393 0 0 0 2.367-1.22l.682-.682L28 23.243z"/></symbol>\n        <symbol viewBox="0 0 16 18" id="ico_edit_document"><g><path d="M9.976 3.278c.221.22.514.34.823.34h2.425L9.634.017v2.44c0 .308.123.601.342.822z"/><path d="M12.838 15.6l-.24.237a2.697 2.697 0 0 1-.733.513.586.586 0 0 1-.392.154h-.002c-.094.03-.187.059-.285.078l-1.642.41-.042.01-.043.008a1.754 1.754 0 0 1-.31.027c-.468 0-.902-.195-1.2-.533H1.76a.583.583 0 1 1 0-1.165h5.8c.004-.07.004-.141.014-.213l.008-.042.01-.043.403-1.602H1.761a.583.583 0 1 1 0-1.165h6.752c.032-.04.059-.085.093-.123l.014-.023.133-.134 1.62-1.617H1.761a.583.583 0 1 1 0-1.166h9.715c.019 0 .037.003.059.006l.858-.857c.245-.245.527-.434.834-.567V4.784h-2.425c-.645 0-1.226-.26-1.647-.681a2.32 2.32 0 0 1-.682-1.647V.016H1.178A1.17 1.17 0 0 0 .01 1.179v15.52a1.17 1.17 0 0 0 1.167 1.165h10.879c.642 0 1.164-.524 1.164-1.165v-1.485l-.383.386zM1.76 6.152h9.715a.583.583 0 1 1 0 1.165H1.761a.583.583 0 1 1 0-1.165z"/><path d="M15.172 11.622l.24-.242a1.55 1.55 0 0 0 0-2.195 1.555 1.555 0 0 0-2.2 0l-.241.24 2.2 2.197zm-.824.825l-2.198-2.198-2.574 2.57v.003a1.528 1.528 0 0 0-.429.83l-.42 1.676c-.057.32.133.548.428.548a.524.524 0 0 0 .11-.01l1.678-.42a1.54 1.54 0 0 0 .831-.429l.24-.24 2.334-2.33z"/></g></symbol>\n        <symbol viewBox="0 0 616 557.15" id="ico_end_user"><path d="M308 72.92a126.11 126.11 0 0 1 71.85 229.81c144 31.44 161.18 93.64 163.23 141.09.43 10.14-7 22.25-16.83 24.8-24.84 6.49-83.63 15.62-218.25 15.62s-193.38-9.12-218.22-15.66c-9.81-2.56-17.28-14.67-16.85-24.8 2.05-47.45 19.24-109.66 163.22-141.09A126.1 126.1 0 0 1 308 72.92M308 0C198.21 0 108.88 89.31 108.88 199.09a198.65 198.65 0 0 0 11.24 65.83C43 302.63 3.55 360.71.09 440.68c-1.89 45.07 28.74 87.4 71.26 98.51 45.62 11.92 125.24 18 236.64 18s191.06-6 236.69-18c42.51-11.12 73.14-53.44 71.24-98.43-3.45-80.03-42.92-138.18-120.06-175.84a198.45 198.45 0 0 0 11.24-65.83C507.1 89.31 417.78 0 308 0z"/></symbol>\n        <symbol viewBox="0 0 14 14" id="ico_favourites"><path d="M10.752 13.084l-3.773-2.4L3.217 13.1c-.473.305-.744.11-.602-.436l1.123-4.317L.27 5.527c-.436-.354-.333-.67.23-.703l4.465-.27 1.62-4.16c.202-.524.536-.526.744-.002l1.635 4.152 4.469.25c.562.03.665.347.23.703l-3.455 2.836 1.143 4.313c.145.545-.123.74-.6.438z"/></symbol>\n        <symbol viewBox="0 0 592.48 592.48" id="ico_five"><path d="M521.63 0H70.85A71.06 71.06 0 0 0 0 70.85v450.78a71.06 71.06 0 0 0 70.85 70.85h450.78a71.06 71.06 0 0 0 70.85-70.85V70.85A71.06 71.06 0 0 0 521.63 0zM153.52 520.32a58.86 58.86 0 1 1 58.86-58.86 58.86 58.86 0 0 1-58.86 58.86zm0-330.45A58.86 58.86 0 1 1 212.38 131a58.86 58.86 0 0 1-58.86 58.86zM296.24 355.1a58.86 58.86 0 1 1 58.86-58.86 58.86 58.86 0 0 1-58.86 58.86zM439 520.32a58.86 58.86 0 1 1 58.86-58.86A58.86 58.86 0 0 1 439 520.32zm0-330.45A58.86 58.86 0 1 1 497.82 131 58.86 58.86 0 0 1 439 189.87z"/></symbol>\n        <symbol viewBox="0 0 534 623.76" id="ico_gift"><path d="M43 601.32c0 13.53 13.81 22.44 27.34 22.44H243v-280H43zm476.3-403.56h-175A98.49 98.49 0 0 0 443 98.98C443 44.24 397.9.14 343.16.14a101 101 0 0 0-75.94 34.68A99.39 99.39 0 0 0 191.71 0c-54.75 0-99.54 44.23-99.54 99s44.54 98.76 99.29 98.76h-175C7.57 197.76 0 205.68 0 214.55v68.8c0 8.87 7.57 17.41 16.43 17.41H243v-103h48v103h228.3c8.87 0 14.7-8.54 14.7-17.41v-68.8c0-8.87-5.83-16.79-14.7-16.79zm-276.3-43h-51.54c-29.53 0-54.1-24.89-54.1-54.41s23.57-54.45 53.1-54.45S243 69.96 243 99.48zm48-55.28a53.09 53.09 0 0 1 53.41-53.07c29.52 0 53.35 24.42 53.35 53.94s-23.96 54.41-53.48 54.41H291zm198.28 244.28H291v280h174.4c13.53 0 25.6-8.91 25.6-22.44v-258c0-.35-1.38.44-1.72.44z"/></symbol>\n        <symbol viewBox="0 0 512 512" id="ico_group"><path d="M7.7 278.7v6.6c0 14.6 11.9 26.5 26.5 26.5h82.1c.9-4.5 2.1-8.9 3.6-13.2H34.3c-7.3 0-13.3-5.9-13.3-13.2v-6.6c0-25 19.9-45.3 44.7-46.2 9.3 8.2 21.5 13.1 34.9 13.1s25.6-5 34.9-13.1c11.5.4 21.9 5.1 29.8 12.3 4.1-2.3 8.4-4.2 12.8-5.9-8.4-9.3-19.6-15.9-32.3-18.5 5-8.1 7.9-17.5 7.9-27.7 0-29.2-23.8-52.9-53.1-52.9s-53.1 23.7-53.1 52.9c0 10.2 2.9 19.6 7.9 27.7-27.1 5.4-47.7 29.4-47.7 58.2m53.1-86.1c0-21.9 17.9-39.7 39.8-39.7 22 0 39.8 17.8 39.8 39.7s-17.9 39.7-39.8 39.7c-21.9.1-39.8-17.7-39.8-39.7"/><path d="M319.7 248.4c7-11.3 11.1-24.6 11.1-38.9 0-41-33.5-74.4-74.6-74.4s-74.6 33.4-74.6 74.4c0 14.3 4.1 27.6 11.1 38.9-38.2 7.8-67.1 41.6-67.1 82v9.3c0 20.5 16.7 37.2 37.3 37.2h186.5c20.6 0 37.3-16.7 37.3-37.2v-9.3c0-40.5-28.8-74.3-67-82zm-63.5-94.8c30.8 0 55.9 25 55.9 55.8s-25.1 55.8-55.9 55.8-55.9-25-55.9-55.8 25.1-55.8 55.9-55.8zm111.9 186c0 10.3-8.4 18.6-18.6 18.6H163c-10.3 0-18.6-8.3-18.6-18.6v-9.3c0-35.1 28-63.7 62.9-65 13.1 11.5 30.3 18.5 49 18.5 18.8 0 35.9-7 49-18.5 34.9 1.3 62.9 29.9 62.9 65l-.1 9.3z"/><path d="M456.7 220.4c5-8.1 7.9-17.5 7.9-27.7 0-29.2-23.8-52.9-53.1-52.9s-53.1 23.7-53.1 52.9c0 10.2 2.9 19.6 7.9 27.7-12.7 2.6-23.9 9.3-32.3 18.5 4.4 1.7 8.7 3.7 12.8 5.9 7.9-7.3 18.3-11.9 29.8-12.3 9.3 8.2 21.5 13.1 34.9 13.1s25.6-5 34.9-13.1c24.8.9 44.7 21.3 44.7 46.2v6.6c0 7.3-6 13.2-13.3 13.2h-85.7c1.5 4.3 2.7 8.7 3.6 13.2h82.1c14.6 0 26.5-11.9 26.5-26.5v-6.6c.2-28.7-20.4-52.7-47.6-58.2m-45.1 12c-22 0-39.8-17.8-39.8-39.7s17.9-39.7 39.8-39.7c22 0 39.8 17.8 39.8 39.7s-17.9 39.7-39.8 39.7"/></symbol>\n        <symbol viewBox="0 0 43 38" id="ico_headset"><path d="M21.0764 0.875C24.8498 0.875 28.3771 1.85938 31.5764 3.74609C34.7756 5.63281 37.3186 8.17578 39.2053 11.375C41.092 14.5742 42.0764 18.1016 42.0764 21.875V26.0586C42.0764 26.6328 41.8303 27.043 41.4201 27.207L39.4514 28.3555V28.4375C39.4514 30.0781 39.0412 31.6367 38.2209 33.0312C37.4006 34.5078 36.2521 35.5742 34.8576 36.3945C33.3811 37.2148 31.9045 37.625 30.2639 37.625H28.2951C27.7209 37.625 27.2287 37.4609 26.9006 37.0508C26.4904 36.7227 26.3264 36.2305 26.3264 35.6562V21.2188C26.3264 20.7266 26.4904 20.2344 26.9006 19.8242C27.2287 19.4961 27.7209 19.25 28.2951 19.25H30.2639C32.2326 19.25 34.0373 19.9062 35.6779 21.0547C37.2365 22.2031 38.3029 23.7617 38.9592 25.5664L39.4514 25.3203V21.875C39.4514 18.5938 38.6311 15.4766 36.9904 12.6875C35.3498 9.89844 33.0529 7.60156 30.2639 5.96094C27.4748 4.32031 24.3576 3.5 21.0764 3.5C17.7131 3.5 14.5959 4.32031 11.8068 5.96094C9.01777 7.60156 6.80293 9.89844 5.1623 12.6875C3.52168 15.4766 2.70136 18.5938 2.70136 21.875V25.3203L3.19355 25.5664C3.76777 23.7617 4.83418 22.2031 6.4748 21.0547C8.0334 19.9062 9.83808 19.25 11.8889 19.25H13.8576C14.3498 19.25 14.842 19.4961 15.2521 19.8242C15.5803 20.2344 15.8264 20.7266 15.8264 21.2188V35.6562C15.8264 36.2305 15.5803 36.7227 15.2521 37.0508C14.842 37.4609 14.3498 37.625 13.8576 37.625H11.8889C10.2482 37.625 8.68965 37.2148 7.29511 36.3945C5.81855 35.5742 4.75215 34.5078 3.93183 33.0312C3.11152 31.6367 2.70136 30.0781 2.70136 28.4375V28.3555L0.732615 27.207C0.240427 27.043 0.0763645 26.6328 0.0763645 26.0586V21.875C0.0763645 18.1016 0.978708 14.5742 2.86543 11.375C4.75215 8.17578 7.29511 5.63281 10.4943 3.74609C13.6936 1.85938 17.2209 0.875 21.0764 0.875ZM11.8889 21.875C10.0842 21.875 8.52558 22.5312 7.21308 23.8438C5.90058 25.1562 5.32636 26.6328 5.32636 28.4375C5.32636 30.2422 5.90058 31.8008 7.21308 33.1133C8.52558 34.4258 10.0842 35 11.8889 35H13.2014V21.875H11.8889ZM30.2639 35C32.0686 35 33.5451 34.4258 34.8576 33.1133C36.1701 31.8008 36.8264 30.2422 36.8264 28.4375C36.8264 26.6328 36.1701 25.1562 34.8576 23.8438C33.5451 22.5312 32.0686 21.875 30.2639 21.875H28.9514V35H30.2639Z"/></symbol>\n        <symbol viewBox="0 0 51 45" id="ico_heart"><path d="M35.408.78c-5.137 0-8.379 4.564-10.26 6.824C23.266 5.344 20.024.78 14.885.78 6.14.78.264 8.882.264 16.45c0 11.015 21.16 25.779 23.573 27.426a2.32 2.32 0 0 0 2.621 0c2.413-1.647 23.572-16.41 23.572-27.427C50.03 8.882 44.155.78 35.408.78"/></symbol>\n        <symbol viewBox="0 0 591.91 591.7" id="ico_home"><path d="M549.42 246.77l-234-234a43.85 43.85 0 0 0-61.87 0l-223 223-11 11c-34 34-22.5 61.87 25.62 61.87h8.22V591.7h145.84v-181a21.88 21.88 0 0 1 21.88-21.85h126.75a21.88 21.88 0 0 1 21.88 21.88v181h145.82v-283.1h8.22c48.12 0 59.7-27.84 25.64-61.86z"/></symbol>\n        <symbol viewBox="0 0 670.83 495.83" id="ico_image_placeholder"><path d="M627.09 0H43.75A43.88 43.88 0 0 0 0 43.75v408.34a43.88 43.88 0 0 0 43.75 43.75h583.34a43.87 43.87 0 0 0 43.75-43.75V43.75A43.88 43.88 0 0 0 627.09 0zm0 280.93l-60-60-24.97-25.01a22 22 0 0 0-30.93 0l-78.31 78.31-132.1 132.14a21.87 21.87 0 0 1-30.93 0l-82.89-82.89a22 22 0 0 0-30.93 0L43.75 435.75v-61.83l81.33-81.33a65.74 65.74 0 0 1 92.8 0l67.43 67.42 106.85-106.88a117.61 117.61 0 1 1 191.18-91.71 121 121 0 0 1-.77 13.12l44.52 44.53z"/></symbol>\n        <symbol viewBox="0 0 670.83 495.83" id="ico_image_placeholder_white"><path d="M636.55 0H53.21A43.88 43.88 0 0 0 9.46 43.75v408.34a43.88 43.88 0 0 0 43.75 43.75h583.34a43.87 43.87 0 0 0 43.75-43.75V43.75A43.88 43.88 0 0 0 636.55 0zm0 280.93l-60-60-24.97-25.01a22 22 0 0 0-30.93 0l-78.31 78.31-132.1 132.14a21.87 21.87 0 0 1-30.93 0l-82.89-82.89a22 22 0 0 0-30.93 0L53.21 435.75v-61.83l81.33-81.33a65.74 65.74 0 0 1 92.8 0l67.43 67.42 106.85-106.88a117.61 117.61 0 1 1 191.18-91.71 121 121 0 0 1-.77 13.12l44.52 44.53z"/></symbol>\n        <symbol viewBox="0 0 88 43" id="ico_infinity"><g transform="translate(-144.000000, -153.000000)"><path d="M211.885395,153 C199.400833,153 191.138714,163.269668 183.849609,172.332319 C177.621972,180.074205 171.741129,187.384677 164.578557,187.384677 C157.133629,187.384677 152.562634,179.686404 152.562634,174.167599 C152.562634,169.05074 157.577079,161.614734 165.436167,161.614734 C173.062108,161.614734 177.035001,167.755318 177.235345,168.070038 C178.470796,170.081538 181.094007,170.714515 183.1033,169.481565 C185.122551,168.243901 185.762245,165.593531 184.531479,163.561993 C184.270213,163.131757 177.989855,153.000589 165.436167,153.000589 C152.803983,153.000589 144,164.157251 144,174.168188 C144,184.494435 152.451332,196 164.577971,196 C175.824739,196 183.288413,186.72341 190.504879,177.751521 C197.180652,169.454454 203.486785,161.615323 211.885395,161.615323 C216.882267,161.615323 220.165674,163.320943 221.92073,166.825302 C223.441465,169.86642 223.440294,173.307717 223.439122,174.5 C223.439122,175.183662 223.080027,178.612582 221.417528,181.70026 C219.52188,185.217585 216.830716,186.854838 212.941592,186.854838 C205.110036,186.854838 200.878805,181.733265 199.28543,179.804276 C198.87127,179.302138 198.573098,178.940858 198.174754,178.597848 C196.381035,177.051946 193.676984,177.259402 192.137502,179.066393 C190.653086,180.809142 190.796021,183.399986 192.417515,184.968284 C192.49484,185.056689 192.587982,185.172793 192.698699,185.307758 C194.775358,187.821985 201.089693,195.468394 212.939835,195.468394 C227.342306,195.468394 231.999999,181.33957 231.999999,174.441064 C232.00117,170.047355 231.183394,166.182305 229.566587,162.950822 C227.296613,158.412719 222.385269,153 211.885395,153 Z"/></g></symbol>\n        <symbol viewBox="0 0 17 17" id="ico_info"><path d="M14.49 14.488a8.488 8.488 0 0 1-12.005 0c-3.313-3.316-3.313-8.69 0-12.003a8.493 8.493 0 0 1 12.006 0c3.313 3.316 3.313 8.69 0 12.003zm-4.72-1.145v-5.81a1.282 1.282 0 1 0-2.567 0v5.81a1.282 1.282 0 1 0 2.567 0zM8.486 4.95a1.282 1.282 0 1 0 .002-2.565 1.282 1.282 0 0 0-.002 2.565z"/></symbol>\n        <symbol viewBox="0 0 38.04 35.1" id="ico_interest_free_down_payment_icon"><defs><clipPath><path fill="none" d="M0 0h38.05v35.22H0z"/></clipPath></defs><g data-name="Layer 2"><g clip-path="url(#a)" data-name="Layer 1"><path d="M7.77 0a7.28 7.28 0 0 0-5.68 2.29A9 9 0 0 0 0 8.6v.95a9 9 0 0 0 2.07 6.31 7.28 7.28 0 0 0 5.67 2.3 7.28 7.28 0 0 0 5.68-2.29 9 9 0 0 0 2.09-6.31v-.94a9 9 0 0 0-2.07-6.32A7.28 7.28 0 0 0 7.77 0m2.92 9.32q0 4.3-2.94 4.3T4.83 9.31v-.47q0-4.3 2.94-4.3t2.93 4.31zM36 18.69a7.28 7.28 0 0 0-5.67-2.3 7.28 7.28 0 0 0-5.68 2.29A9 9 0 0 0 22.53 25v.95a9 9 0 0 0 2.07 6.31 7.27 7.27 0 0 0 5.67 2.3 7.28 7.28 0 0 0 5.73-2.3A9.05 9.05 0 0 0 38 26v-1a9.05 9.05 0 0 0-2-6.31m-2.75 7q0 4.3-2.94 4.3t-2.95-4.29v-.47q0-4.3 2.94-4.3t2.93 4.31z"/><path d="M1.19 34a.9.9 0 0 0 1.11 1.09l11.32-2.83c.72-.2.83-.83.24-1.42l-2.79-2.79L33.6 5.52a2.015 2.015 0 0 0-2.85-2.85L8.22 25.2l-2.78-2.78c-.58-.58-1.22-.47-1.42.24z"/></g></g></symbol>\n        <symbol viewBox="0 0 512 512" id="ico_klikk-og-hent"><path d="M397.751 495H114.249a34.073 34.073 0 0 1-24.95-10.912 34.083 34.083 0 0 1-8.929-25.725l22.738-290.251c1.38-17.568 16.261-31.329 33.879-31.329h238.027c17.623 0 32.504 13.762 33.879 31.331l22.738 290.248a34.087 34.087 0 0 1-8.929 25.727A34.08 34.08 0 0 1 397.751 495zM136.987 165.203c-2.884 0-5.321 2.253-5.546 5.131l-22.738 290.25a5.514 5.514 0 0 0 1.461 4.211c.618.666 1.968 1.786 4.085 1.786h283.502a5.514 5.514 0 0 0 4.085-1.786 5.506 5.506 0 0 0 1.461-4.211l-22.738-290.251c-.225-2.878-2.662-5.129-5.546-5.129H136.987z"/><path d="M329.414 336.337l-97.51-73.828c-6.823-5.166-16.611-.299-16.611 8.258v118.87c0 8.96 10.606 13.694 17.276 7.71l24.543-22.019 27.256 55.768c4.311 8.82 14.955 12.475 23.775 8.164 8.828-4.315 12.481-14.975 8.153-23.797l-27.018-55.08 35.484-5.555c9.031-1.412 11.939-12.974 4.652-18.491zm-134.306-74.718a5.924 5.924 0 0 1-8.091 2.168l-20.492-11.831a5.924 5.924 0 0 1 5.923-10.259l20.492 11.831a5.923 5.923 0 0 1 2.168 8.091zm15.252-16.492a5.922 5.922 0 0 1-7.999-2.484l-11.017-20.942a5.922 5.922 0 1 1 10.483-5.515l11.017 20.942a5.923 5.923 0 0 1-2.484 7.999zM255.999 17c-43.983 0-79.768 35.785-79.768 79.776v82c0 7.303 5.941 13.244 13.244 13.244s13.244-5.941 13.244-13.244v-82c0-29.385 23.903-53.288 53.28-53.288s53.28 23.903 53.28 53.288v83.354c0 7.303 5.941 13.244 13.244 13.244s13.244-5.941 13.244-13.244V96.776c0-43.991-35.785-79.776-79.768-79.776zm-24.976 223.331a5.923 5.923 0 0 1-5.069-6.668l3.195-23.446a5.923 5.923 0 0 1 11.737 1.599l-3.195 23.446a5.921 5.921 0 0 1-6.668 5.069z"/></symbol>\n        <symbol viewBox="0 0 512 512" id="ico_kr"><path d="M60.655 461.676c-8.858 0-18.476-7.307-28.868-21.939-6.162-10.003-9.237-17.51-9.237-22.516V86.411c0-8.462 5.863-16.545 17.608-24.248 11.737-7.694 24.339-11.547 37.816-11.547 14.235 0 21.361 6.55 21.361 19.63v202.065l92.374-88.331c5.385-4.998 12.502-9.238 21.36-12.702 8.85-3.464 17.122-5.195 24.825-5.195 14.235 0 21.361 6.549 21.361 19.629 0 9.625-2.021 19.441-6.062 29.444-4.041 10.013-9.337 17.896-15.876 23.67l-71.013 65.816 93.528 89.486c3.463 3.464 5.195 8.083 5.195 13.855 0 13.478-3.662 25.791-10.969 36.949-7.315 11.168-15.398 16.742-24.249 16.742-3.084 0-6.061-.865-8.948-2.598-2.887-1.731-6.838-5.097-11.835-10.103L99.336 338.704v62.353c0 10.392-2.02 20.405-6.062 30.021-4.041 9.625-9.048 17.13-15.01 22.516-5.972 5.385-11.835 8.082-17.609 8.082zm390.854-219.385c-2.697 0-5.396-.189-8.083-.578-2.697-.379-5.773-.577-9.237-.577-18.862 0-34.261 5.007-46.186 15.011v144.91c0 10.392-2.021 20.405-6.062 30.021-4.042 9.625-9.049 17.13-15.011 22.516-5.972 5.386-11.836 8.082-17.609 8.082-8.857 0-18.474-7.307-28.866-21.939-6.161-10.003-9.236-17.51-9.236-22.516V201.877c0-8.461 5.862-16.544 17.607-24.247 11.736-7.695 24.339-11.547 37.815-11.547 14.235 0 21.361 6.549 21.361 19.629v13.857c7.307-10.393 17.509-19.143 30.599-26.269 13.08-7.118 25.592-10.681 37.526-10.681 21.551 0 32.331 7.704 32.331 23.093 0 13.857-3.852 26.756-11.547 38.682-7.703 11.934-16.165 17.897-25.402 17.897z" class="st0"/></symbol>\n        <symbol viewBox="0 0 13 13" id="ico_linkarrow"><path d="M7.005 3.95L4.091 1.037a1.949 1.949 0 1 0-2.758 2.758l2.915 2.914-2.915 2.915a1.949 1.949 0 1 0 2.758 2.757l2.914-2.914L8.351 8.12c.78-.78.772-2.05 0-2.822L7.005 3.951z"/></symbol>\n        <symbol viewBox="0 0 9 13" id="ico_linkarrow_purple"><path d="M7.005 3.95L4.091 1.037a1.949 1.949 0 1 0-2.758 2.758l2.915 2.914-2.915 2.915a1.949 1.949 0 1 0 2.758 2.757l2.914-2.914L8.351 8.12c.78-.78.772-2.05 0-2.822L7.005 3.951z"/></symbol>\n        <symbol viewBox="0 0 9 13" id="ico_linkarrow_white"><path d="M7.005 3.95L4.091 1.037a1.949 1.949 0 1 0-2.758 2.758l2.915 2.914-2.915 2.915a1.949 1.949 0 1 0 2.758 2.757l2.914-2.914L8.351 8.12c.78-.78.772-2.05 0-2.822L7.005 3.951z"/></symbol>\n        <symbol viewBox="0 0 565.8 536" id="ico_login"><path d="M419.1 184.2c0 44.6-21.9 86.5-58.7 111.8C515.9 329.9 525 416 527.2 467.2c.5 10.9-7.6 24-18.2 26.7-26.7 7.1-80.8 16.9-226.1 16.9S83.5 501 56.8 494c-10.6-2.8-18.6-15.8-18.2-26.7 2.2-51.2 11.3-137.3 166.7-171.2-61.9-42.8-77.2-127.7-34.4-189.5s127.7-77.2 189.5-34.4c36.7 25.4 58.7 67.3 58.7 112z"/></symbol>\n        <symbol viewBox="0 0 32 32" id="ico_map"><path d="M6 12.427c0-5.523 4.477-10 10-10s10 4.477 10 10c0 7.383-10 17.147-10 17.147S6 19.811 6 12.427zm10-5c-2.762 0-5 2.238-5 5s2.238 5 5 5 5-2.238 5-5-2.238-5-5-5z"/></symbol>\n        <symbol viewBox="0 0 14 12" id="ico_menu"><path d="M12.821 9.326H1.167a1.165 1.165 0 1 0 0 2.331h11.654a1.166 1.166 0 1 0 0-2.331zm0-4.664H1.167a1.167 1.167 0 0 0 0 2.334h11.654a1.167 1.167 0 0 0 0-2.334zM1.167 2.33h11.654a1.166 1.166 0 1 0 0-2.33H1.167a1.165 1.165 0 1 0 0 2.33z"/></symbol>\n        <symbol viewBox="0 0 17 16" id="ico_menu_logged_in"><path d="M3.85 9.326H1.167c-1.554 0-1.554 2.331 0 2.331H3.85c1.6.047 1.6-2.378 0-2.331zm2.99-4.664H1.167c-1.556 0-1.556 2.334 0 2.334H6.84c1.556 0 1.556-2.334 0-2.334zM1.167 2.33h10.932c1.62.067 1.62-2.397 0-2.33H1.167c-1.553 0-1.553 2.33 0 2.33z"/><path d="M14.491 7.681a2.677 2.677 0 0 1-1.155 2.203c3.06.668 3.24 2.361 3.283 3.37.009.215-.15.472-.357.526-.527.139-1.59.332-4.451.332s-3.924-.193-4.452-.332c-.209-.054-.367-.311-.358-.527.044-1.008.223-2.701 3.283-3.37a2.68 2.68 0 1 1 4.207-2.202z"/></symbol>\n        <symbol viewBox="0 0 565.8 536" id="ico_menu_mobile"><path d="M480.2 122.5H87.5h392.7zm-1.9 154H85.6h392.7zm0 151H85.6h392.7z"/></symbol>\n        <symbol viewBox="0 0 16 4" id="ico_minus"><path d="M2.265 0a1.822 1.822 0 0 0 0 3.647h11.35a1.822 1.822 0 0 0 1.822-1.822A1.818 1.818 0 0 0 13.617 0H2.266z"/></symbol>\n        <symbol viewBox="0 0 16 4" id="ico_minus_purple"><path d="M2.265 0a1.822 1.822 0 0 0 0 3.647h11.35a1.822 1.822 0 0 0 1.822-1.822A1.818 1.818 0 0 0 13.617 0H2.266z"/></symbol>\n        <symbol viewBox="0 0 13 18" id="ico_mobile"><path d="M12.448 1.09v15.817a1.092 1.092 0 0 1-1.09 1.09H1.09A1.09 1.09 0 0 1 0 16.91V1.09A1.094 1.094 0 0 1 1.09 0h10.27a1.09 1.09 0 0 1 1.088 1.09zm-1.851 12.636V2.024a.15.15 0 0 0-.15-.15H1.999a.149.149 0 0 0-.147.15v11.702c0 .083.067.147.15.147h8.45a.143.143 0 0 0 .146-.147zM6.21 15a.939.939 0 1 0 0 1.878.939.939 0 0 0 0-1.878z"/></symbol>\n        <symbol viewBox="0 0 27 43" id="ico_mobile_o"><path d="M15.75 34.375C15.75 33.7188 15.4219 33.0625 14.9297 32.5703C14.4375 32.0781 13.7812 31.75 13.125 31.75C12.3867 31.75 11.7305 32.0781 11.2383 32.5703C10.7461 33.0625 10.5 33.7188 10.5 34.375C10.5 35.1133 10.7461 35.7695 11.2383 36.2617C11.7305 36.7539 12.3867 37 13.125 37C13.7812 37 14.4375 36.7539 14.9297 36.2617C15.4219 35.7695 15.75 35.1133 15.75 34.375ZM26.25 4.1875C26.25 3.12109 25.8398 2.21875 25.1016 1.39844C24.2812 0.660156 23.3789 0.25 22.3125 0.25H3.9375C2.78906 0.25 1.88672 0.660156 1.14844 1.39844C0.328125 2.21875 0 3.12109 0 4.1875V38.3125C0 39.4609 0.328125 40.3633 1.14844 41.1016C1.88672 41.9219 2.78906 42.25 3.9375 42.25H22.3125C23.3789 42.25 24.2812 41.9219 25.1016 41.1016C25.8398 40.3633 26.25 39.4609 26.25 38.3125V4.1875ZM23.625 4.1875V38.3125C23.625 38.7227 23.4609 39.0508 23.2148 39.2969C22.9688 39.543 22.6406 39.625 22.3125 39.625H3.9375C3.52734 39.625 3.19922 39.543 2.95312 39.2969C2.70703 39.0508 2.625 38.7227 2.625 38.3125V4.1875C2.625 3.85938 2.70703 3.53125 2.95312 3.28516C3.19922 3.03906 3.52734 2.875 3.9375 2.875H22.3125C22.6406 2.875 22.9688 3.03906 23.2148 3.28516C23.4609 3.53125 23.625 3.85938 23.625 4.1875Z"/></symbol>\n        <symbol viewBox="0 0 555.73 635.32" id="ico_money"><path d="M181.35 140.16c100.16 0 181.35-18.24 181.35-40.73v-58.7C362.7 18.23 281.51 0 181.35 0S0 18.24 0 40.73v58.7c0 22.5 81.19 40.73 181.35 40.73zm0 158.23C81.19 298.39 0 280.15 0 257.66v58.7c0 19.92 63.7 36.5 147.83 40a234.19 234.19 0 0 1 34.36-58zM362.7 152.38c0 22.5-81.19 40.73-181.35 40.73S0 174.88 0 152.38v58.7c0 22.5 81.19 40.73 181.35 40.73 18.63 0 36.59-.63 53.51-1.8a233.67 233.67 0 0 1 127.84-39.7zM133.39 407.31C56.52 402.59 0 386.79 0 368v58.7c0 18.6 55.37 34.3 131 39.16-.6-7.22-.9-14.51-.84-21.84a238.57 238.57 0 0 1 3.23-36.71zM0 474.57v58.7c0 21.48 74 39.06 167.9 40.61a231.91 231.91 0 0 1-27.7-59.64C59.85 510.05 0 493.89 0 474.57zm366.85-218.4h-1c-104 0-188.78 84-189.68 188.24-.91 105 83.56 190.32 189.06 190.91h1.08c104.08 0 188.94-84.18 189.42-188.19.45-105.47-83.52-190.4-188.88-190.96zm7.44 257.38q-4.13 6.3-9.11 6.29a6.46 6.46 0 0 1-3.37-1 26.41 26.41 0 0 1-4.44-3.81l-41.26-41.37v23.44a28.9 28.9 0 0 1-2.26 11.25 23.32 23.32 0 0 1-5.64 8.46q-3.37 3-6.61 3-5 0-10.86-8.24c-2.31-3.76-3.48-6.59-3.48-8.47V378.78q0-4.77 6.62-9.11a25.46 25.46 0 0 1 14.21-4.35q8 0 8 7.38v76l34.76-33.24a25.37 25.37 0 0 1 8-4.77 25.73 25.73 0 0 1 9.33-2q8 0 8 7.38a29.47 29.47 0 0 1-2.28 11.07 23.07 23.07 0 0 1-6 8.89l-26.69 24.74 35.24 33.64a7.06 7.06 0 0 1 2 5.21 24.79 24.79 0 0 1-4.13 13.89zm83.76-82.89q-4.34 6.73-9.55 6.73a21.73 21.73 0 0 1-3-.22 25 25 0 0 0-3.5-.17q-10.63 0-17.36 5.64v54.48a28.9 28.9 0 0 1-2.28 11.29 23.32 23.32 0 0 1-5.64 8.46c-2.24 2-4.44 3-6.62 3q-5 0-10.85-8.24-3.48-5.64-3.48-8.47v-80.97q0-4.77 6.62-9.12a25.45 25.45 0 0 1 14.21-4.33q8 0 8 7.38v5.2a33.08 33.08 0 0 1 11.51-9.88 29.58 29.58 0 0 1 14.1-4q12.15 0 12.16 8.69a26.29 26.29 0 0 1-4.32 14.53z"/></symbol>\n        <symbol viewBox="0 0 16 17" id="ico_music"><path d="M14.365 11.04a3.395 3.395 0 0 0-1.89-.19c-1.546.273-2.629 1.458-2.419 2.648.21 1.187 1.631 1.93 3.178 1.658 1.334-.237 2.324-1.151 2.435-2.165l.009-.272V3.508l-.003-.549V.657a.657.657 0 0 0-.77-.645L4.874 1.781a.656.656 0 0 0-.543.645V12.81a3.395 3.395 0 0 0-1.888-.188c-1.545.27-2.627 1.454-2.417 2.644.21 1.187 1.631 1.93 3.178 1.658 1.334-.237 2.324-1.151 2.432-2.165 0 0 .012-.246.009-.273v-9.21l8.716-1.538.003 7.3z"/></symbol>\n        <symbol viewBox="0 0 57.09 41.76" id="ico_music_freedom"><g data-name="Layer 2"><path d="M56.93 1C55.84-1.87 46 2 42 5.24a10.25 10.25 0 0 0-1.2 1.15V3.71a1.53 1.53 0 0 0-1.8-1.5L15.63 6.33a1.53 1.53 0 0 0-1.26 1.51v2.1a9 9 0 0 0-1-1C9.79 6 1.1 2.66.14 5.22c-.69 1.83 1.34 3.93 3.24 5 0 0-1.67-.17-1.7 1.34 0 1.17.59 2.3 2.69 3.44 0 0-1.22 0-1.28 1s.9 2.1 2.83 2.87c0 0-1.3-.26-.91 1.11.47 1.7 5.13 3.43 8.58 2.22a5.85 5.85 0 0 0 .8-.35V32a7.87 7.87 0 0 0-4.4-.44c-3.6.63-6.13 3.4-5.64 6.17s3.8 4.5 7.41 3.87c3.11-.55 5.41-2.69 5.67-5V14.48l20.31-3.58v17a7.87 7.87 0 0 0-4.4-.44c-3.6.63-6.13 3.4-5.64 6.17s3.8 4.5 7.41 3.87c3.11-.55 5.42-2.69 5.67-5V19.89a6.62 6.62 0 0 0 .91.4c3.91 1.36 9.18-.6 9.72-2.52.43-1.56-1-1.26-1-1.26 2.19-.87 3.28-2 3.2-3.25s-1.45-1.18-1.45-1.18c2.39-1.3 3.08-2.57 3.05-3.9 0-1.71-1.93-1.52-1.93-1.52C55.41 5.48 57.72 3.1 56.93 1z" data-name="Layer 1"/></g></symbol>\n        <symbol viewBox="0 0 18 15" id="ico_premisesdatacenter"><path d="M0 14.984V1.8A1.8 1.8 0 0 1 1.8 0h14.384a1.8 1.8 0 0 1 1.8 1.8v13.184h-3.448v-2.696a.902.902 0 0 0-.9-.9h-1.8a.902.902 0 0 0-.9.9v2.696H0zm7.229-8.13a.902.902 0 0 0-.637-.262H3.896a.902.902 0 0 0-.9.9v1.2a.902.902 0 0 0 .9.9h2.696a.902.902 0 0 0 .9-.9v-1.2a.91.91 0 0 0-.263-.637zm7.492 0a.902.902 0 0 0-.637-.262h-2.696a.902.902 0 0 0-.9.9v1.2a.902.902 0 0 0 .9.9h2.696a.902.902 0 0 0 .9-.9v-1.2a.927.927 0 0 0-.263-.637zm-7.492-4.79a.902.902 0 0 0-.637-.263H3.896a.902.902 0 0 0-.9.9v1.2a.902.902 0 0 0 .9.9h2.696a.902.902 0 0 0 .9-.9V2.696a.893.893 0 0 0-.263-.633zm7.492 0a.902.902 0 0 0-.637-.263h-2.696a.902.902 0 0 0-.9.9v1.2a.902.902 0 0 0 .9.9h2.696a.902.902 0 0 0 .9-.9V2.696a.91.91 0 0 0-.263-.633z"/></symbol>\n        <symbol viewBox="0 0 30 27" id="ico_quote-left"><path d="M27.1875 13.75C27.9492 13.75 28.5938 14.043 29.1797 14.5703C29.707 15.1562 30 15.8008 30 16.5625V24.0625C30 24.8828 29.707 25.5273 29.1797 26.0547C28.5938 26.6406 27.9492 26.875 27.1875 26.875H19.6875C18.8672 26.875 18.2227 26.6406 17.6953 26.0547C17.1094 25.5273 16.875 24.8828 16.875 24.0625V10C16.875 8.35938 17.2852 6.77734 18.1055 5.3125C18.9258 3.90625 20.0977 2.73438 21.5625 1.91406C22.9688 1.09375 24.5508 0.625 26.25 0.625H26.7188C27.0703 0.625 27.4219 0.800781 27.7148 1.03516C27.9492 1.32812 28.125 1.67969 28.125 2.03125V4.84375C28.125 5.25391 27.9492 5.60547 27.7148 5.83984C27.4219 6.13281 27.0703 6.25 26.7188 6.25H26.25C25.1953 6.25 24.3164 6.66016 23.6133 7.36328C22.8516 8.125 22.5 9.00391 22.5 10V13.75H27.1875ZM10.3125 13.75C11.0742 13.75 11.7188 14.043 12.3047 14.5703C12.832 15.1562 13.125 15.8008 13.125 16.5625V24.0625C13.125 24.8828 12.832 25.5273 12.3047 26.0547C11.7188 26.6406 11.0742 26.875 10.3125 26.875H2.8125C1.99219 26.875 1.34766 26.6406 0.820312 26.0547C0.234375 25.5273 0 24.8828 0 24.0625V10C0 8.35938 0.410156 6.77734 1.23047 5.3125C2.05078 3.90625 3.22266 2.73438 4.6875 1.91406C6.09375 1.09375 7.67578 0.625 9.375 0.625H9.84375C10.1953 0.625 10.5469 0.800781 10.8398 1.03516C11.0742 1.32812 11.25 1.67969 11.25 2.03125V4.84375C11.25 5.25391 11.0742 5.60547 10.8398 5.83984C10.5469 6.13281 10.1953 6.25 9.84375 6.25H9.375C8.32031 6.25 7.44141 6.66016 6.73828 7.36328C5.97656 8.125 5.625 9.00391 5.625 10V13.75H10.3125Z"/></symbol>\n        <symbol viewBox="0 0 16 14" id="ico_quote"><path d="M15.641 5.766c0 4.035-2.63 6.75-6.339 7.484l-.698-1.502c1.713-.647 2.816-2.74 2.816-4.304H9.784c-.566 0-1.026-.46-1.026-1.027V1.565c0-.568.46-1.027 1.026-1.027h4.833c.565 0 1.024.459 1.024 1.027v4.2zm-8.603 0c0 4.035-2.631 6.75-6.34 7.484L0 11.748c1.714-.647 2.817-2.74 2.817-4.304H1.18c-.566 0-1.025-.46-1.025-1.027V1.565C.155.997.615.538 1.18.538h4.834c.564 0 1.024.459 1.024 1.027v4.2z"/></symbol>\n        <symbol viewBox="0 0 21 30" id="ico_refill"><path d="M20.727 1.813v26.334a1.82 1.82 0 0 1-1.814 1.813h-17.1A1.82 1.82 0 0 1 0 28.147V1.813A1.82 1.82 0 0 1 1.813 0h17.1c1 .004 1.81.813 1.814 1.813m-3.087 21.04V3.367a.247.247 0 0 0-.247-.247H3.333a.247.247 0 0 0-.24.247v19.486c0 .137.11.247.247.247H17.4c.136 0 .247-.11.247-.247m-7.334 2.12a1.56 1.56 0 1 0 0 3.12 1.56 1.56 0 0 0 0-3.12"/><path d="M14.573 11.72h-2.86V8.867a1.353 1.353 0 1 0-2.706 0v2.86H6.153a1.353 1.353 0 1 0 0 2.706h2.86v2.86a1.353 1.353 0 1 0 2.707 0v-2.866h2.86a1.353 1.353 0 0 0 0-2.707"/></symbol>\n        <symbol viewBox="0 0 28 25" id="ico_router_refill"><g><path d="M11.699 5.2H8.647V2.153a1.444 1.444 0 0 0-2.889 0v3.053H2.713a1.444 1.444 0 0 0 0 2.888h3.052v3.052a1.444 1.444 0 1 0 2.889 0V8.088h3.052a1.444 1.444 0 0 0 0-2.889m3.18-.695a.977.977 0 0 1-.08-1.38l.001-.001a9.11 9.11 0 0 1 12.861-.766.977.977 0 1 1-1.297 1.462 7.156 7.156 0 0 0-10.101.6l-.004.005a.977.977 0 0 1-1.38.08"/><path d="M17.81 7.097a.977.977 0 0 1-.08-1.379 5.204 5.204 0 0 1 7.345-.438.977.977 0 0 1-1.297 1.462 3.25 3.25 0 0 0-4.586.272l-.003.003a.977.977 0 0 1-1.379.08m3.461 14.193a1.253 1.253 0 1 1 0-2.506 1.253 1.253 0 0 1 0 2.505zm-5.01 0a1.253 1.253 0 1 1 0-2.506 1.253 1.253 0 0 1 0 2.505zm-5.01-.152H4.987a1.25 1.25 0 1 1 0-2.499h6.262a1.25 1.25 0 1 1 0 2.499zm11.336-6.293h-.097V9.061a1.25 1.25 0 1 0-2.499 0v5.784H4.901C2.134 14.845 0 17.056 0 19.823v.039c0 2.767 2.134 5.07 4.901 5.07h17.686c2.767 0 4.901-2.303 4.901-5.07v-.039c0-2.767-2.134-4.978-4.901-4.978z"/></g></symbol>\n        <symbol viewBox="0 0 565.8 536" id="ico_search-menu"><path fill="none" stroke="#000" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="60" d="M479.8 501.7l-118.3-124 118.3 124z"/><path fill="#FFF" stroke="#000" stroke-miterlimit="10" stroke-width="38" d="M235.4 53.6c-48-.1-94 18.9-127.8 53-70.4 70.5-70.4 185.1 0 255.6 70.6 70.6 185 70.6 255.6 0h0c70.4-70.5 70.4-185.1 0-255.6-33.8-34.1-79.8-53.1-127.8-53"/></symbol>\n        <symbol viewBox="0 0 17 17" id="ico_search"><path d="M16.536 16.51a1.541 1.541 0 0 1-2.18 0l-2.369-2.368a7.692 7.692 0 0 1-4.253 1.276 7.698 7.698 0 0 1-5.453-2.257 7.713 7.713 0 0 1 10.91-10.904 7.715 7.715 0 0 1 .977 9.704l2.368 2.368a1.541 1.541 0 0 1 0 2.181zm-8.8-14.583a5.749 5.749 0 0 0-4.088 1.694 5.791 5.791 0 0 0 0 8.176 5.749 5.749 0 0 0 4.089 1.694 5.749 5.749 0 0 0 4.09-1.694 5.786 5.786 0 0 0 0-8.176 5.753 5.753 0 0 0-4.09-1.694z"/></symbol>\n        <symbol viewBox="0 0 12 15" id="ico_share"><path d="M8.144 10.42L4.436 8.28a2.25 2.25 0 0 0-.02-.963L8.412 5.01a2.239 2.239 0 1 0-.922-1.476L3.37 5.913a2.239 2.239 0 1 0 .09 3.811l4.004 2.312a2.239 2.239 0 1 0 .681-1.616z"/></symbol>\n        <symbol viewBox="0 0 38.27 38.27" id="ico_six"><defs><clipPath><path fill="none" d="M0 0h38.27v38.27H0z"/></clipPath></defs><g data-name="Layer 2"><g clip-path="url(#a)" data-name="Layer 1"><path d="M33.7 0H4.58A4.59 4.59 0 0 0 0 4.58V33.7a4.59 4.59 0 0 0 4.58 4.58H33.7a4.59 4.59 0 0 0 4.58-4.58V4.58A4.59 4.59 0 0 0 33.7 0M9.92 33.61a3.8 3.8 0 1 1 3.8-3.8 3.8 3.8 0 0 1-3.8 3.8m0-10.67a3.8 3.8 0 1 1 3.8-3.8 3.8 3.8 0 0 1-3.8 3.8m0-10.67a3.8 3.8 0 1 1 3.8-3.8 3.8 3.8 0 0 1-3.8 3.8m18.44 21.34a3.8 3.8 0 1 1 3.8-3.8 3.8 3.8 0 0 1-3.8 3.8m0-10.67a3.8 3.8 0 1 1 3.8-3.8 3.8 3.8 0 0 1-3.8 3.8m0-10.67a3.8 3.8 0 1 1 3.8-3.8 3.8 3.8 0 0 1-3.8 3.8"/></g></g></symbol>\n        <symbol viewBox="0 0 670.83 670.83" id="ico_statistics"><path d="M597.92 36.42A36.45 36.45 0 0 0 561.42 0h-72.88a36.46 36.46 0 0 0-36.46 36.42v546.92h145.84zM408.33 255.21a36.45 36.45 0 0 0-36.46-36.46h-72.91a36.45 36.45 0 0 0-36.46 36.46v328.13h145.83zM218.75 473.96a36.46 36.46 0 0 0-36.46-36.46h-72.87a36.46 36.46 0 0 0-36.5 36.46v109.38h145.83zm428.21 153.13H21.88a21.875 21.875 0 1 0 0 43.75h625.08a21.88 21.88 0 1 0 0-43.75z"/></symbol>\n        <symbol viewBox="0 0 700 700" id="ico_subscription"><path d="M463.21 14.61H145.85a43.87 43.87 0 0 0-43.74 43.75v583.28a43.87 43.87 0 0 0 43.74 43.75h408.3a43.87 43.87 0 0 0 43.74-43.75V150zm-244.45 576a21.87 21.87 0 1 1-43.74 0V558.5a21.87 21.87 0 0 1 43.74 0zm0-108.65A21.87 21.87 0 0 1 175 482v-32.1a21.87 21.87 0 0 1 43.74 0zm0-108.65a21.87 21.87 0 0 1-43.74 0V341.2a21.87 21.87 0 0 1 43.74 0zm93 239.18h-38.32a21.88 21.88 0 0 1 0-43.75h38.28a21.88 21.88 0 1 1 0 43.75zm0-249.41h-38.32a21.87 21.87 0 0 1 0-43.74h38.28a21.87 21.87 0 1 1 0 43.74zm114.8 249.4h-38.28a21.88 21.88 0 1 1 0-43.75h38.28a21.88 21.88 0 0 1 0 43.75zm0-249.41h-38.28a21.87 21.87 0 1 1 0-43.74h38.28a21.87 21.87 0 0 1 0 43.74zM525 590.6a21.87 21.87 0 1 1-43.74 0v-32.1a21.87 21.87 0 0 1 43.74 0zm0-108.6a21.87 21.87 0 0 1-43.74 0v-32.1a21.87 21.87 0 0 1 43.74 0zm0-108.65a21.87 21.87 0 0 1-43.74 0V341.2a21.87 21.87 0 0 1 43.74 0z"/></symbol>\n        <symbol viewBox="10 0 20 35" id="ico_trash"><path d="M16.252 15H29.75c.69 0 1.25-.448 1.25-1s-.56-1-1.25-1H25.5c0-.552-.56-1-1.25-1h-2.5c-.69 0-1.25.448-1.25 1h-4.25c-.69 0-1.25.448-1.25 1s.56 1 1.25 1h.002z"/><path d="M29.878 15.023a1.202 1.202 0 0 0-.916.289c-.257.22-.42.54-.455.888l-.105 1.08H17.6l-.105-1.08a1.317 1.317 0 0 0-.73-1.083 1.196 1.196 0 0 0-1.252.137 1.35 1.35 0 0 0-.505 1.216l1.5 15.347c.066.672.603 1.183 1.244 1.183H28.25c.641 0 1.178-.51 1.243-1.183l1.5-15.347a1.37 1.37 0 0 0-.273-.967 1.232 1.232 0 0 0-.842-.48z"/></symbol>\n        <symbol viewBox="0 0 256 256" id="ico_truck"><path d="M59.008 187.137h-9.856c-5.44 0-9.856-4.416-9.856-9.856v-19.712h118.273V68.863h45.998c11.009 0 15.77 5.677 19.081 10.911 5.855 9.265 15.139 23.97 20.787 33.294a19.771 19.771 0 0 1 2.838 10.201v44.155c0 11.049-7.175 19.712-19.712 19.712h-9.856c0 16.322-13.246 29.568-29.568 29.568s-29.568-13.246-29.568-29.568h-39.424c0 16.322-13.247 29.568-29.568 29.568-16.323.001-29.569-13.246-29.569-29.567zm29.568-11.828c6.525 0 11.827 5.303 11.827 11.827 0 6.525-5.303 11.827-11.827 11.827-6.525 0-11.827-5.303-11.827-11.827-.001-6.524 5.302-11.827 11.827-11.827zm98.56 0c6.525 0 11.827 5.303 11.827 11.827 0 6.525-5.303 11.827-11.827 11.827-6.525 0-11.827-5.303-11.827-11.827s5.302-11.827 11.827-11.827zm-98.56-86.733H19.583c-5.443 0-9.856-4.413-9.856-9.856s4.413-9.856 9.856-9.856h68.992v-9.856h-49.28v-9.856c0-5.443 4.413-9.856 9.856-9.856h88.705c5.443 0 9.856 4.413 9.856 9.856v98.561H39.295v-29.568h-9.856c-5.443 0-9.856-4.413-9.856-9.856s4.413-9.856 9.856-9.856h59.137v-9.857zm88.704 0v29.568h46.471s-9.255-16.184-14.064-24.601a9.842 9.842 0 0 0-8.555-4.967H177.28z"/></symbol>\n        <symbol viewBox="0 0 69 69" id="ico_video_play"><path d="M34.1273 68.6562C27.9749 68.6562 22.3695 67.1523 17.1741 64.1445C11.9788 61.1367 7.74055 56.8984 4.73274 51.7031C1.72493 46.5078 0.221024 40.9023 0.221024 34.75C0.221024 28.7344 1.72493 22.9922 4.73274 17.7969C7.74055 12.6016 11.9788 8.5 17.1741 5.49219C22.3695 2.48438 27.9749 0.84375 34.1273 0.84375C40.1429 0.84375 45.8851 2.48438 51.0804 5.49219C56.2757 8.5 60.3773 12.6016 63.3851 17.7969C66.3929 22.9922 68.0335 28.7344 68.0335 34.75C68.0335 40.9023 66.3929 46.5078 63.3851 51.7031C60.3773 56.8984 56.2757 61.1367 51.0804 64.1445C45.8851 67.1523 40.1429 68.6562 34.1273 68.6562ZM4.59602 34.75C4.59602 40.2188 5.82649 45.1406 8.56087 49.6523C11.1585 54.1641 14.7132 57.7188 19.3616 60.3164C23.8734 63.0508 28.7952 64.2812 34.1273 64.2812C39.4593 64.2812 44.3812 63.0508 48.8929 60.3164C53.4046 57.7188 56.9593 54.1641 59.6937 49.5156C62.2913 45.0039 63.6585 40.082 63.6585 34.75C63.6585 29.418 62.2913 24.4961 59.6937 19.9844C56.9593 15.4727 53.4046 11.918 48.8929 9.18359C44.2445 6.58594 39.3226 5.21875 33.9906 5.21875C28.6585 5.21875 23.7366 6.58594 19.2249 9.18359C14.7132 11.918 11.1585 15.4727 8.56087 19.9844C5.82649 24.6328 4.59602 29.5547 4.59602 34.75ZM49.9866 32.2891C51.0804 32.9727 51.6273 33.9297 51.6273 35.1602C51.6273 36.5273 51.0804 37.4844 49.9866 38.0312L25.9241 51.8398C24.8304 52.5234 23.7366 52.5234 22.6429 51.8398C21.5491 51.293 21.0023 50.3359 21.0023 48.9688V20.5312C21.0023 19.3008 21.5491 18.3438 22.6429 17.6602C23.7366 17.1133 24.8304 17.1133 25.9241 17.6602L49.9866 32.2891ZM25.3773 45.6875C25.3773 45.9609 25.514 46.2344 25.7874 46.3711C26.0609 46.6445 26.3343 46.6445 26.6077 46.3711L45.0648 35.8438C45.2015 35.707 45.3382 35.4336 45.3382 35.1602C45.3382 34.8867 45.3382 34.6133 45.0648 34.3398L26.6077 23.2656C26.3343 23.1289 26.0609 23.1289 25.7874 23.2656C25.514 23.4023 25.3773 23.6758 25.3773 23.9492V45.6875Z"/></symbol>\n        <symbol viewBox="0 0 53 38" id="ico_wifi"><path d="M26.25 24.5C28.0547 24.5 29.5312 25.1562 30.8438 26.4688C32.1562 27.7812 32.8125 29.2578 32.8125 31.0625C32.8125 32.8672 32.1562 34.4258 30.8438 35.7383C29.5312 37.0508 28.0547 37.625 26.25 37.625C24.4453 37.625 22.8867 37.0508 21.5742 35.7383C20.2617 34.4258 19.6875 32.8672 19.6875 31.0625C19.6875 29.2578 20.2617 27.7812 21.5742 26.4688C22.8867 25.1562 24.4453 24.5 26.25 24.5ZM26.25 35C27.3164 35 28.2188 34.6719 29.0391 33.8516C29.7773 33.1133 30.1875 32.2109 30.1875 31.0625C30.1875 29.9961 29.7773 29.0938 29.0391 28.2734C28.2188 27.5352 27.3164 27.125 26.25 27.125C25.1016 27.125 24.1992 27.5352 23.4609 28.2734C22.6406 29.0938 22.3125 29.9961 22.3125 31.0625C22.3125 32.2109 22.6406 33.1133 23.4609 33.8516C24.1992 34.6719 25.1016 35 26.25 35ZM43.2305 21.875C43.3945 21.7109 43.4766 21.4648 43.4766 21.1367C43.4766 20.8906 43.3125 20.6445 43.1484 20.3984C39.9492 17.6094 36.3398 15.7227 32.3203 14.7383C28.2188 13.7539 24.1992 13.7539 20.1797 14.7383C16.0781 15.7227 12.4688 17.6094 9.35156 20.3984C9.10547 20.6445 9.02344 20.8906 9.02344 21.1367C9.02344 21.4648 9.10547 21.7109 9.26953 21.875L9.76172 22.2852C9.92578 22.5312 10.0898 22.6133 10.418 22.6133C10.6641 22.6133 10.9102 22.5312 11.1562 22.3672C13.9453 19.9062 17.1445 18.1836 20.7539 17.2812C24.3633 16.4609 28.0547 16.4609 31.6641 17.2812C35.2734 18.1836 38.5547 19.9062 41.3438 22.3672C41.5078 22.5312 41.7539 22.6133 42.082 22.6133C42.3281 22.6133 42.5742 22.5312 42.7383 22.2852L43.2305 21.875ZM51.5977 13.0156L52.0898 12.6055C52.2539 12.4414 52.3359 12.1953 52.3359 11.8672C52.3359 11.6211 52.1719 11.375 52.0078 11.1289C47.25 6.69922 41.7539 3.66406 35.4375 2.02344C29.2852 0.546875 23.1328 0.546875 17.0625 2.02344C10.6641 3.66406 5.16797 6.69922 0.492188 11.1289C0.246094 11.375 0.164062 11.6211 0.164062 11.8672C0.164062 12.1953 0.246094 12.4414 0.410156 12.6055L0.902344 13.0156C1.06641 13.2617 1.23047 13.3438 1.55859 13.3438C1.80469 13.3438 2.05078 13.2617 2.29688 13.0156C6.64453 8.91406 11.8125 6.04297 17.7188 4.56641C23.3789 3.17188 29.1211 3.17188 34.8633 4.56641C40.6875 6.04297 45.7734 8.91406 50.2031 13.0156C50.3672 13.2617 50.6133 13.3438 50.9414 13.3438C51.1875 13.3438 51.4336 13.2617 51.5977 13.0156Z"/></symbol>\n        <symbol viewBox="0 0 16 13" id="ico_wireless"><g><path d="M7.987 9.585c-.833 0-1.507.694-1.507 1.553 0 .858.674 1.552 1.507 1.552.834 0 1.508-.694 1.508-1.552 0-.855-.674-1.553-1.508-1.553zm0-4.805A6.069 6.069 0 0 0 3.62 6.642a1.224 1.224 0 0 0 0 1.69 1.14 1.14 0 0 0 1.641 0 3.787 3.787 0 0 1 2.73-1.162c.989 0 1.968.386 2.726 1.163a1.137 1.137 0 0 0 1.64 0 1.22 1.22 0 0 0 0-1.69 6.068 6.068 0 0 0-4.37-1.865z"/><path d="M15.634 3.263C13.525 1.09 10.751 0 7.99 0 5.223 0 2.45 1.09.34 3.263a1.224 1.224 0 0 0 0 1.69 1.14 1.14 0 0 0 1.642 0A8.353 8.353 0 0 1 7.99 2.388c2.176 0 4.342.852 6.006 2.565a1.137 1.137 0 0 0 1.641 0 1.227 1.227 0 0 0-.003-1.69z"/></g></symbol>\n        <symbol viewBox="0 0 64 64" id="image"><path d="M54 12a6 6 0 0 1 6 6v28a5.92 5.92 0 0 1-1.15 3.53A6 6 0 0 1 54 52H10a6 6 0 0 1-6-6V18a6 6 0 0 1 6-6zM22.41 30.1a2 2 0 0 0-2.82 0L8 41.68V46a2 2 0 0 0 2 2h30.32l-4.82-4.81zm23 6a2 2 0 0 0-2.82 0l-4.26 4.26 6.83 6.83c.25.246.475.518.67.81H54a2 2 0 0 0 1.91-1.41zM54 16H10a2 2 0 0 0-2 2v18l8.76-8.73a6 6 0 0 1 8.48 0L35.5 37.53l4.26-4.26a6 6 0 0 1 8.48 0L56 41V18a2 2 0 0 0-2-2zm-7 7a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="infinite"><path d="M46.211 41.522c-1.058 0-3.494-.586-7.923-4.513a52.984 52.984 0 0 1-3.728-3.676 52.953 52.953 0 0 1 3.694-3.646c4.45-3.952 6.895-4.542 7.957-4.542 4.687 0 8.5 3.673 8.5 8.188 0 4.515-3.813 8.189-8.5 8.189m-20.5-4.513c-4.428 3.927-6.864 4.513-7.922 4.513-4.687 0-8.5-3.674-8.5-8.189 0-4.515 3.813-8.188 8.5-8.188 1.058 0 3.494.586 7.923 4.512a52.996 52.996 0 0 1 3.728 3.676 52.977 52.977 0 0 1-3.728 3.676m20.5-15.676c-2.913 0-6.492 1.868-10.64 5.552A56.002 56.002 0 0 0 32 30.374a56.002 56.002 0 0 0-3.573-3.489c-4.147-3.684-7.726-5.552-10.638-5.552-6.868 0-12.456 5.384-12.456 12 0 6.617 5.588 12 12.456 12 2.912 0 6.491-1.868 10.638-5.552A56.003 56.003 0 0 0 32 36.293a56.003 56.003 0 0 0 3.573 3.488c4.147 3.684 7.726 5.552 10.638 5.552 6.868 0 12.456-5.383 12.456-12 0-6.616-5.588-12-12.456-12"/></symbol>\n        <symbol viewBox="0 0 64 64" id="info"><path d="M32 6a26 26 0 0 1 26 26c0 14.36-11.64 26-26 26S6 46.36 6 32 17.64 6 32 6zm0 4c-12.15 0-22 9.85-22 22s9.85 22 22 22a22 22 0 0 0 22-22c0-12.15-9.85-22-22-22zm.89 16c.74 0 1.11.333 1.11 1v15.84a4 4 0 0 1-.3 1.56 3.2 3.2 0 0 1-.78 1.18A1.38 1.38 0 0 1 32 46c-.513 0-1.03-.38-1.55-1.14a2.25 2.25 0 0 1-.48-1.18V27.86c0-.44.31-.86.92-1.26a3.531 3.531 0 0 1 2-.6zm.11-8c.827 0 1.233.38 1.22 1.14a4.41 4.41 0 0 1-.34 1.73 3.59 3.59 0 0 1-.88 1.31 1.58 1.58 0 0 1-1.01.48c-.52 0-1.06-.41-1.62-1.23a2.81 2.81 0 0 1-.57-1.35 1.81 1.81 0 0 1 1-1.42A4 4 0 0 1 33 18z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="insurance"><path d="M40 4a8 8 0 0 1 8 8v40a8 8 0 0 1-8 8H24a8 8 0 0 1-8-8V12a8 8 0 0 1 8-8zm4 44H20v4a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4v-4zm-12 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm8-42H24a4 4 0 0 0-4 4v13.32l4.16-4.13a2 2 0 0 1 3.06.28l3.06 4.45 3.31-3.3a2 2 0 0 1 2.82 2.82l-5 5a2 2 0 0 1-1.59.58 2 2 0 0 1-1.47-.86l-3.06-4.44L20 31v13h24V12a4 4 0 0 0-4-4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="internet"><path d="M58 32C58 17.68 46.42 6.055 32.1 6h-.2C17.54 6.028 5.922 17.69 5.95 32.05 5.978 46.41 17.64 58.028 32 58a26 26 0 0 0 26-26zm-6.36 9.89a45.32 45.32 0 0 0-8.19-2.64c.365-2.4.549-4.823.55-7.25a48.21 48.21 0 0 0-.55-7.24 46.49 46.49 0 0 0 8.2-2.64 21.92 21.92 0 0 1 0 19.77h-.01zM32 53.7c-2.91-1.89-5.29-6-6.67-11.24a48.59 48.59 0 0 1 13.34 0c-1.38 5.22-3.76 9.35-6.67 11.24zM32 38a54.35 54.35 0 0 0-7.49.53 42.06 42.06 0 0 1 0-13.06A54.35 54.35 0 0 0 32 26a54.2 54.2 0 0 0 7.48-.53A41.93 41.93 0 0 1 40 32c0 2.187-.17 4.37-.51 6.53A54.35 54.35 0 0 0 32 38zm0-27.7c2.91 1.89 5.29 6 6.67 11.24A48.68 48.68 0 0 1 32 22a50.36 50.36 0 0 1-6.67-.46c1.38-5.22 3.76-9.35 6.67-11.24zm17.5 8.39a42 42 0 0 1-6.85 2.14 29.19 29.19 0 0 0-4.42-9.93 22 22 0 0 1 11.27 7.79zM25.77 10.9a29.39 29.39 0 0 0-4.42 9.93 42 42 0 0 1-6.85-2.14 22.06 22.06 0 0 1 11.27-7.79zM12.36 22.11a44.54 44.54 0 0 0 8.19 2.64 48.06 48.06 0 0 0 0 14.5 45.32 45.32 0 0 0-8.19 2.64 21.9 21.9 0 0 1 0-19.78zm2.14 23.2a42 42 0 0 1 6.85-2.14 29.39 29.39 0 0 0 4.42 9.93 22.06 22.06 0 0 1-11.27-7.79zm23.73 7.79a29.39 29.39 0 0 0 4.42-9.93 42 42 0 0 1 6.85 2.14 22.06 22.06 0 0 1-11.27 7.79z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="kontantkort"><path d="M54 12a6 6 0 0 1 6 6v28a6 6 0 0 1-6 6H10a6 6 0 0 1-6-6V18a6 6 0 0 1 6-6zm0 4H10a2 2 0 0 0-2 2v28a2 2 0 0 0 2 2h44a2 2 0 0 0 2-2V18a2 2 0 0 0-2-2zM28 26.61a3.33 3.33 0 0 1 1.29 1.29 3.61 3.61 0 0 1 .46 1.83 3.17 3.17 0 0 1-.5 1.7 4 4 0 0 1-1.4 1.33l1.85 2.64a.66.66 0 0 1 .13.4 2 2 0 0 1-.33 1.09c-.22.33-.45.5-.69.5a.92.92 0 0 1-.7-.48l-2.52-3.59h-1.42v2.33a2.19 2.19 0 0 1-.35 1.2 1 1 0 0 1-.77.54c-.28 0-.55-.21-.83-.62a1.54 1.54 0 0 1-.27-.66v-8.94a.89.89 0 0 1 .5-.71 2 2 0 0 1 1.09-.33H26a3.91 3.91 0 0 1 2 .48zM19.81 26c.43 0 .64.2.64.58a2.36 2.36 0 0 1-.18.89 2 2 0 0 1-.51.73l-3.33 3.08 4.1 4a.52.52 0 0 1 .14.4 2.11 2.11 0 0 1-.31 1.13.85.85 0 0 1-.69.51A1 1 0 0 1 19 37l-4.44-4.47v3.12a2.11 2.11 0 0 1-.35 1.2 1 1 0 0 1-.76.54c-.28 0-.56-.21-.83-.62a1.45 1.45 0 0 1-.27-.66v-9a.89.89 0 0 1 .5-.71 1.94 1.94 0 0 1 1.09-.4c.42 0 .62.2.62.58v3.56l3.88-3.59a1.83 1.83 0 0 1 .64-.4 1.91 1.91 0 0 1 .73-.15zm6.1 2.24h-1.74v3.08h1.74a1.61 1.61 0 0 0 1.14-.45 1.42 1.42 0 0 0 .47-1.08 1.45 1.45 0 0 0-.46-1.11 1.6 1.6 0 0 0-1.15-.44z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="laptop"><path d="M58.34 46.21L56 41.53V16a4 4 0 0 0-4-4H12a4 4 0 0 0-4 4v25.53l-2.34 4.68A4 4 0 0 0 9.24 52h45.52a4 4 0 0 0 3.58-5.79zM12 16h40v24H12V16zM9.24 48l2-4h41.52l2 4H9.24z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="lightbulb"><path d="M35 54a2 2 0 1 1 0 4h-6a2 2 0 1 1 0-4h6zm1-5a2 2 0 1 1 0 4h-8a2 2 0 1 1 0-4h8zm-4-32c7.732 0 14 6.268 14 14 0 4.953-2.596 9.445-6.713 11.957l-.648 3.415A2 2 0 0 1 36.674 48h-9.382a2 2 0 0 1-1.967-1.637l-.631-3.418-.284-.179A13.993 13.993 0 0 1 18 31c0-7.732 6.268-14 14-14zm0 4c-5.523 0-10 4.477-10 10a9.998 9.998 0 0 0 5.41 8.888 2 2 0 0 1 1.048 1.413L28.956 44h6.062l.512-2.701a2 2 0 0 1 1.048-1.405A9.998 9.998 0 0 0 42 31c0-5.523-4.477-10-10-10zm-20 9a2 2 0 1 1 0 4H6a2 2 0 1 1 0-4h6zm46 0a2 2 0 1 1 0 4h-6a2 2 0 1 1 0-4h6zm-6.465-17.918a2 2 0 0 1 0 2.828l-4.242 4.243a2 2 0 1 1-2.829-2.828l4.243-4.243a2 2 0 0 1 2.828 0zm-36.087-.066l4.243 4.243a2 2 0 1 1-2.829 2.828l-4.242-4.243a2 2 0 0 1 2.828-2.828zM32 4a2 2 0 0 1 2 2v6a2 2 0 1 1-4 0V6a2 2 0 0 1 2-2z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="like"><path d="M54.64 34.52a8 8 0 0 0 .76-8A8.25 8.25 0 0 0 48 22h-5.15a25 25 0 0 0 1.2-4.89 14.07 14.07 0 0 0-1.72-8c-1.21-2.06-4.56-3-7-2.78a4.74 4.74 0 0 0-4.24 3.18c-.23.7-.45 1.42-.66 2.12-.63 2.07-1.27 4.2-2 5.17l-.09.13C26.91 19 22.2 25 20.66 26h-2.2A6 6 0 0 0 8 30v20a6 6 0 0 0 10.46 4h1.79c2.502.1 4.964.662 7.26 1.66a70.51 70.51 0 0 0 15.39 2.4c.454.01.908-.01 1.36-.06 3.45-.46 7.2-3.09 7.7-9.08a9.71 9.71 0 0 0 2.12-7.6 9.09 9.09 0 0 0 .56-6.8zM12 50V30a2 2 0 1 1 4 0v20a2 2 0 1 1-4 0zm38.85-17a2 2 0 0 0-.3 1.93 5.33 5.33 0 0 1-.26 5 2 2 0 0 0-.29 1.39 5.85 5.85 0 0 1-1.5 5.42A2 2 0 0 0 48 48c-.13 3.47-1.69 5.65-4.27 6-2.58.35-12.65-1.31-14.88-2.13a23.93 23.93 0 0 0-8.6-1.87H20V30h1c3.17 0 10-9.88 10.62-10.82 1.21-1.56 1.92-3.93 2.68-6.43.2-.667.41-1.333.63-2 0-.09.1-.31.71-.42a4.54 4.54 0 0 1 3.25.82 10 10 0 0 1 1.17 5.65 34.14 34.14 0 0 1-1.91 6.51 2 2 0 0 0 .2 1.86A2 2 0 0 0 40 26h8a4.24 4.24 0 0 1 3.85 2.23c.63 1.39.29 3.07-1 4.77z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="link"><path d="M24.33 28.89c1.418 0 2.824.272 4.14.8l.2.08-3.21 3.21a7.08 7.08 0 0 0-1.13-.09 7 7 0 0 0-5 2l-5.56 5.56a7 7 0 1 0 9.9 9.9l5.56-5.56a7 7 0 0 0 1.92-6.28l3.17-3.17a11 11 0 0 1-2.21 12.36l-5.56 5.56a11 11 0 0 1-7.78 3.22 11.21 11.21 0 0 1-4.14-.8 11 11 0 0 1-3.64-18l5.57-5.57a10.93 10.93 0 0 1 7.77-3.22zm14.092-4.4a2 2 0 0 1 .648 3.27L27.76 39.07a2 2 0 1 1-2.83-2.83l11.31-11.31a2 2 0 0 1 2.182-.44zM45.15 7.71c1.418 0 2.824.272 4.14.8a11 11 0 0 1 3.64 2.42 11 11 0 0 1 0 15.6l-5.44 5.44a11 11 0 0 1-7.78 3.22 11.13 11.13 0 0 1-4.14-.8l-.18-.08 3.21-3.21a7 7 0 0 0 6.06-2l5.39-5.44a7 7 0 0 0-9.9-9.9l-5.44 5.44a7 7 0 0 0-2 4.95 6.72 6.72 0 0 0 .13 1.35l-3.17 3.17a11 11 0 0 1 2.26-12.3l5.44-5.44a11 11 0 0 1 7.78-3.22z"/></symbol>\n        <symbol viewBox="0 0 38.08 38.08" id="linkedin_icon"><path d="M35.26 0H2.81A2.78 2.78 0 0 0 0 2.74v32.59a2.78 2.78 0 0 0 2.81 2.75h32.45a2.79 2.79 0 0 0 2.82-2.75V2.74A2.79 2.79 0 0 0 35.26 0m-24 32.44H5.64V14.27h5.65zM8.47 11.79a3.27 3.27 0 1 1 3.27-3.28 3.27 3.27 0 0 1-3.27 3.28m24 20.65H26.8v-8.83c0-2.11 0-4.82-2.93-4.82s-3.39 2.3-3.39 4.67v9h-5.64V14.27h5.41v2.48h.08a5.93 5.93 0 0 1 5.34-2.93c5.71 0 6.77 3.76 6.77 8.66z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="list-view"><path d="M11 43a3 3 0 0 1 3 3l-.005.176A3 3 0 1 1 11 43zm42.965 1l.152.005c1.053.077 1.883.942 1.883 1.996C56 47.105 55.087 48 53.962 48H20.035c-1.124 0-2.034-.894-2.035-1.999 0-1.105.91-2.001 2.035-2.001h33.93zM11 29a3 3 0 0 1 3 3l-.005.176A3 3 0 1 1 11 29zm42.963 1c1.12 0 2.037.895 2.037 2 0 1.104-.912 2-2.037 2H20.037C18.912 34 18 33.104 18 32s.912-2 2.037-2zM11 15c1.657 0 3 1.347 3 3a3 3 0 1 1-3.01-3zm9.032 1l.152.005H54.11c1.008.072 1.81.86 1.884 1.85.081 1.102-.762 2.06-1.884 2.14H20.184a2.097 2.097 0 0 1-.295 0c-1.122-.08-1.965-1.038-1.884-2.14.082-1.102 1.058-1.93 2.179-1.85z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="lock-locked"><path d="M32 6c7.732 0 14 6.268 14 14v6a6 6 0 0 1 2.34.47l.227.102A6 6 0 0 1 52 32v6a19.81 19.81 0 0 1-.49 4.38c-2.24 9.936-11.59 16.6-21.714 15.478C19.673 56.736 12.01 48.185 12 38v-6a6 6 0 0 1 3.67-5.53l.28-.11A6 6 0 0 1 18 26v-6c0-7.732 6.268-14 14-14zm14 24H18a2 2 0 0 0-.79.2h-.1A2 2 0 0 0 16 32v6c-.001 1.174.13 2.345.39 3.49 1.788 7.95 9.266 13.287 17.366 12.392C41.856 52.988 47.989 46.15 48 38v-6a2 2 0 0 0-1.12-1.84h-.09A2 2 0 0 0 46 30zm-13.303 4.057A4 4 0 0 1 34 41.46V48a2 2 0 1 1-4 0v-6.54a4 4 0 0 1 2.697-7.403zM32 10c-5.523 0-10 4.477-10 10v6h20v-6c0-5.523-4.477-10-10-10z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="lock-unlocked"><path d="M28.14 5.3a14.08 14.08 0 0 1 10.45 2.27 13.41 13.41 0 0 1 5.68 8.85l.73 4.24a2.029 2.029 0 0 1-4 .68l-.72-4.24a9.44 9.44 0 0 0-4-6.24 10.12 10.12 0 0 0-7.47-1.62c-5.364.831-9.047 5.842-8.24 11.21L21.69 27H46a6 6 0 0 1 2.34.47l.227.102A6 6 0 0 1 52 33v6a19.81 19.81 0 0 1-.49 4.38c-2.24 9.936-11.59 16.6-21.714 15.478C19.673 57.736 12.01 49.185 12 39v-6a6 6 0 0 1 3.63-5.53l.274-.108a5.79 5.79 0 0 1 1.726-.342l-1-5.9C15.45 13.575 20.598 6.498 28.14 5.3zM46 31H18a2 2 0 0 0-.79.2h-.1A2 2 0 0 0 16 33v6c-.001 1.174.13 2.345.39 3.49 1.788 7.95 9.266 13.287 17.366 12.392C41.856 53.988 47.989 47.15 48 39v-6a2 2 0 0 0-1.12-1.84h-.09A2 2 0 0 0 46 31zm-13.303 4.057A4 4 0 0 1 34 42.46V49a2 2 0 1 1-4 0v-6.54a4 4 0 0 1 2.697-7.403z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="login"><path d="M31.998 8a2 2 0 1 0 0 4h18a4 4 0 0 1 4 4v32a4 4 0 0 1-4 4h-18a2 2 0 1 0 0 4h18a8 8 0 0 0 8-8V16a8 8 0 0 0-8-8zm-3.303 10.685a2 2 0 0 0-.105 2.715l8.58 8.6H10a2 2 0 1 0 0 4h27.17l-8.58 8.59a2 2 0 1 0 2.82 2.82l12-12a1.79 1.79 0 0 0 .25-.3.55.55 0 0 0 .08-.15c.043-.063.08-.13.11-.2l.06-.2a.84.84 0 0 0 .05-.17 2 2 0 0 0 0-.78.84.84 0 0 0-.05-.17l-.06-.2a1.28 1.28 0 0 0-.11-.2.55.55 0 0 0-.08-.15 1.79 1.79 0 0 0-.25-.31l-12-12a2 2 0 0 0-2.715.105z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="logout"><path d="M34 8a2 2 0 1 1 0 4H16a4 4 0 0 0-4 4v32a4 4 0 0 0 4 4h18a2 2 0 1 1 0 4H16a8 8 0 0 1-8-8V16a8 8 0 0 1 8-8zm8.695 10.685a2 2 0 0 1 2.715-.105l12 12c.095.094.178.198.25.31a.55.55 0 0 1 .08.15c.043.063.08.13.11.2l.06.2a.84.84 0 0 1 .05.17 2 2 0 0 1 0 .78.84.84 0 0 1-.05.17l-.06.2a1.28 1.28 0 0 1-.11.2.55.55 0 0 1-.08.15 1.79 1.79 0 0 1-.25.3l-12 12a2 2 0 1 1-2.82-2.82L51.17 34H24a2 2 0 1 1 0-4h27.17l-8.58-8.6a2 2 0 0 1 .105-2.715z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="map"><path d="M32 4c11.355 0 20.56 9.205 20.56 20.56 0 15.44-18.36 34.06-19.14 34.85a2.002 2.002 0 0 1-2.84 0C29.8 58.62 11.44 40 11.44 24.56 11.44 13.205 20.645 4 32 4zm0 4c-9.141.011-16.549 7.419-16.56 16.56C15.44 36 27.75 50.45 32 55.08 36.25 50.45 48.56 36 48.56 24.56 48.549 15.419 41.141 8.011 32 8zm0 6a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10zm0 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="menu"><path d="M50 44a2 2 0 1 1 0 4H14a2 2 0 1 1 0-4zm0-14a2 2 0 1 1 0 4H14a2 2 0 1 1 0-4zm0-14a2 2 0 1 1 0 4H14a2 2 0 1 1 0-4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="microphone"><path d="M46 24a2 2 0 0 1 2 2v10c-.002 8.062-6.002 14.862-14 15.87a.57.57 0 0 1 0 .13v4h8a2 2 0 1 1 0 4H22a2 2 0 1 1 0-4h8v-4a.57.57 0 0 1 0-.13C22.002 50.862 16.002 44.062 16 36V26a2 2 0 1 1 4 0v10c0 6.627 5.373 12 12 12s12-5.373 12-12V26a2 2 0 0 1 2-2zM32 4a8 8 0 0 1 8 8v24a8 8 0 1 1-16 0V12a8 8 0 0 1 8-8zm0 4a4 4 0 0 0-4 4v24a4 4 0 1 0 8 0V12a4 4 0 0 0-4-4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="minus"><path d="M17.333 35h29.334c.736 0 1.333-.895 1.333-2s-.597-2-1.333-2H17.333c-.736 0-1.333.895-1.333 2s.597 2 1.333 2z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="mms"><path d="M50.07 10a9.75 9.75 0 0 1 9.81 9.74v16.8a9.67 9.67 0 0 1-1.22 4.72 10 10 0 0 1-2.62 3 9.68 9.68 0 0 1-5.89 2h-16l-2.22 2.23L27 53.41a2 2 0 0 1-2.22.44A2 2 0 0 1 23.54 52v-5.74h-9.61a9.76 9.76 0 0 1-9.73-9.74V19.74c.005-5.373 4.357-9.729 9.73-9.74zM19.85 25.998a2 2 0 0 0-1.42.592L8.21 36.82a5.73 5.73 0 0 0 5.72 5.44h11.61a2 2 0 0 1 2 2v2.91l4.34-4.33c.14-.142.302-.26.48-.35a2 2 0 0 1 .92-.23H37l-5.48-5.42-10.25-10.25a2 2 0 0 0-1.42-.592zm23 6a2 2 0 0 0-1.42.592l-4.25 4.26 5.41 5.41h7.48a5.68 5.68 0 0 0 3.01-.86l-8.81-8.81a2 2 0 0 0-1.42-.592zM50.07 14H13.93a5.74 5.74 0 0 0-5.73 5.74v11.43l7.4-7.41a6 6 0 0 1 8.49 0L34.35 34l4.25-4.24a6 6 0 0 1 8.49 0l8.45 8.45a5.53 5.53 0 0 0 .26-1.69V19.74A5.75 5.75 0 0 0 50.07 14zm-4.22 5.49a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="mobile"><path d="M40 4a8 8 0 0 1 8 8v40a8 8 0 0 1-8 8H24a8 8 0 0 1-8-8V12a8 8 0 0 1 8-8zm4 44H20v4a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4v-4zm-12 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm8-42H24a4 4 0 0 0-4 4v32h24V12a4 4 0 0 0-4-4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="money-euro"><path d="M21.11 14.05A21 21 0 0 1 60 25a21.001 21.001 0 0 1-10 17.89 21 21 0 0 1-7 7A21.09 21.09 0 0 1 25 60a21 21 0 0 1-10.99-38.95 21 21 0 0 1 7-7zM11.21 29A17 17 0 0 0 25 56a17.06 17.06 0 0 0 9.91-3.21A21.67 21.67 0 0 1 32 53c-11.598 0-21-9.402-21-21a22.29 22.29 0 0 1 .21-3zm7.03-7A17 17 0 0 0 32 49a16.9 16.9 0 0 0 10-3.24A20.84 20.84 0 0 1 18.24 22zM39 8c-9.389 0-17 7.611-17 17s7.611 17 17 17a17 17 0 0 0 17-17c0-9.389-7.611-17-17-17zm1.56 5.47A9.38 9.38 0 0 1 45.72 15a1 1 0 0 1 .47.85 3.5 3.5 0 0 1-1 2.5 1.28 1.28 0 0 1-.88.41 1.37 1.37 0 0 1-.6-.19 6.58 6.58 0 0 0-3.22-1A5.45 5.45 0 0 0 35.4 21H43c.53 0 .78.25.78.72 0 1.11-.75 2.28-1.42 2.28h-7.78a8.55 8.55 0 0 0 0 1.06 6.54 6.54 0 0 0 0 .94h7.35c.54 0 .79.25.79.72 0 1.11-.72 2.28-1.42 2.28h-6a5.21 5.21 0 0 0 5.09 3.53 10.54 10.54 0 0 0 2.9-.56 7.24 7.24 0 0 1 1.71-.35c.73 0 1.11.35 1.11 1a3.47 3.47 0 0 1-1.45 2.94 9.7 9.7 0 0 1-4.55 1c-4.67 0-8.17-2.81-9.53-7.58h-1.27a.68.68 0 0 1-.45-.19 2.32 2.32 0 0 1-1-1.48c0-.64 1.08-1.33 2.06-1.33h.28a4.92 4.92 0 0 1 0-.94 6.42 6.42 0 0 1 0-1.06h-.47a.68.68 0 0 1-.45-.19 2.32 2.32 0 0 1-1-1.48c0-.64 1.08-1.33 2.05-1.33h.45c1.64-4.64 5.4-7.51 9.78-7.51z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="money"><path d="M21.11 14.05A21 21 0 0 1 60 25a21.001 21.001 0 0 1-10 17.89 21 21 0 0 1-7 7A21.09 21.09 0 0 1 25 60a21 21 0 0 1-10.99-38.95 21 21 0 0 1 7-7zM11.21 29A17 17 0 0 0 25 56a17.06 17.06 0 0 0 9.91-3.21A21.67 21.67 0 0 1 32 53c-11.598 0-21-9.402-21-21a22.29 22.29 0 0 1 .21-3zm7.03-7A17 17 0 0 0 32 49a16.9 16.9 0 0 0 10-3.24A20.84 20.84 0 0 1 18.24 22zM39 8c-9.389 0-17 7.611-17 17s7.611 17 17 17a17 17 0 0 0 17-17c0-9.389-7.611-17-17-17zm-1.28 9.88c.54 0 .8.24.8.72 0 .74-.32 1.56-.86 2.04l-4.18 3.86 5.14 5.06c.12.12.18.28.18.5 0 1.04-.62 2.06-1.26 2.06-.26 0-.56-.16-.86-.5l-5.54-5.6v3.92c0 1.1-.7 2.18-1.4 2.18s-1.38-1.22-1.38-1.6V19.18c0-.64 1.02-1.3 2-1.3.52 0 .78.24.78.72v4.46l4.86-4.5c.46-.42 1.1-.68 1.72-.68zm7.72.12c1.84 0 3.32.86 4.08 2.22.38.68.56 1.44.56 2.3 0 1.5-.88 2.92-2.38 3.8l2.42 3.3c.1.16.16.32.16.5 0 .98-.66 2-1.28 2-.3 0-.58-.2-.88-.6l-3.16-4.5h-1.78v2.92c0 1.1-.7 2.18-1.4 2.18s-1.38-1.26-1.38-1.6V19.3c0-.64 1.02-1.3 2-1.3zm-.08 2.6h-2.18v3.86h2.18c1.12 0 2.02-.86 2.02-1.92 0-1.12-.84-1.94-2.02-1.94z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="more-low"><path d="M43 42c0 2.75 2.25 5 5 5s5-2.25 5-5-2.25-5-5-5-5 2.25-5 5zm-6 0c0-2.75-2.25-5-5-5s-5 2.25-5 5 2.25 5 5 5 5-2.25 5-5zm-16 0c0-2.75-2.25-5-5-5s-5 2.25-5 5 2.25 5 5 5 5-2.25 5-5z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="more"><path transform="rotate(90 32 32)" d="M32 21c2.75 0 5-2.25 5-5s-2.25-5-5-5-5 2.25-5 5 2.25 5 5 5zm0 6c-2.75 0-5 2.25-5 5s2.25 5 5 5 5-2.25 5-5-2.25-5-5-5zm0 16c-2.75 0-5 2.25-5 5s2.25 5 5 5 5-2.25 5-5-2.25-5-5-5z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="music"><path d="M28 6a8 8 0 0 0-8 8v27.52A9 9 0 1 0 24 49V22h30v19.52A9 9 0 1 0 58 49V6H28zM15 54a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm34 0a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM24 18v-4a4 4 0 0 1 4-4h26v8H24z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="open"><path d="M28 8a2 2 0 1 1 0 4H15.63A3.63 3.63 0 0 0 12 15.66v32.75A3.64 3.64 0 0 0 15.63 52H48.3a3.64 3.64 0 0 0 3.63-3.63V36a2 2 0 1 1 4 0v12.41A7.64 7.64 0 0 1 48.3 56H15.63A7.64 7.64 0 0 1 8 48.41V15.66A7.63 7.63 0 0 1 15.63 8H28zm28.28-4a3.65 3.65 0 0 1 3.64 3.63v14.8a2 2 0 1 1-4 0V10.69L34.79 31.83a2 2 0 0 1-1.42.58 2 2 0 0 1-1.37-.58A2 2 0 0 1 32 29L53 8H41.48a2 2 0 1 1 0-4h14.8z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="org-chart"><path d="M32 8c5.523 0 10 4.477 10 10 0 4.838-3.435 8.873-7.999 9.8L34 33h13a4 4 0 0 1 3.995 3.8L51 37l.001 5.29a7 7 0 1 1-4.001 0V37H34l.001 5.29a7 7 0 1 1-4.001 0V37H17l.001 5.29a7 7 0 1 1-4.001 0V37a4 4 0 0 1 3.8-3.995L17 33h13v-5.2c-4.564-.927-8-4.962-8-9.8 0-5.523 4.477-10 10-10zM15 46a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm17 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm17 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM32 12a6 6 0 1 0 0 12 6 6 0 0 0 0-12z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="payment"><path d="M44 8a8 8 0 0 1 7.93 6.91c.044.362.067.726.07 1.09a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8V14a6 6 0 0 1 6-6zM8 19.65V48a4 4 0 0 0 4 4h40a4 4 0 0 0 4-4v-4H46a8 8 0 1 1 0-16h10v-4a4 4 0 0 0-4-4H10a5.8 5.8 0 0 1-2-.35zM56 32H46a4 4 0 1 0 0 8h10v-8zm-10 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm-2-22H10a2 2 0 0 0 0 4h38a3.882 3.882 0 0 0-.18-1.19l-.067-.198A4 4 0 0 0 44 12z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="pen"><path d="M51.12 12.88c-4.3-4.29-8.58-5.56-10.92-3.22L12.07 37.8l-.16.15a2.26 2.26 0 0 0-.28.35c-1.54 2.22-2.55 9.29-3.12 15a2 2 0 0 0 2 2.2h.2c5.71-.57 12.78-1.58 15-3.12a2.26 2.26 0 0 0 .35-.28l28.28-28.29c2.34-2.35 1.07-6.63-3.22-10.93zM12.76 51.24a71.59 71.59 0 0 1 1.69-9.62 35.94 35.94 0 0 1 7.93 7.93 71.59 71.59 0 0 1-9.62 1.69zM51.51 21l-26 26a32.82 32.82 0 0 0-3.93-4.56A32.12 32.12 0 0 0 17 38.51l26-26c.45-.17 2.61.51 5.3 3.2 2.69 2.69 3.36 4.85 3.21 5.29z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="phone"><path d="M56.426 41.187l-6.605-6.612c-2.1-2.1-5.53-2.1-7.628 0l-2.76 2.76a1.407 1.407 0 0 1-1.971 0L26.669 26.542a1.406 1.406 0 0 1 0-1.97l2.76-2.76a5.406 5.406 0 0 0 0-7.626l-6.613-6.613a5.407 5.407 0 0 0-7.627 0l-1.25 1.265c-8.796 8.795-5.729 19.983 7.608 33.309l.36.344.698.69c13 12.71 23.952 15.507 32.588 6.873l1.235-1.243a5.406 5.406 0 0 0-.002-7.625zm-2.833 4.803l-1.233 1.24c-6.678 6.678-15.32 4.47-26.95-6.9l-.718-.709-.352-.336c-11.826-11.817-14.33-20.632-7.767-27.42l1.453-1.471c.528-.528 1.425-.528 1.962.009l6.613 6.612a1.406 1.406 0 0 1 0 1.97l-2.76 2.76a5.406 5.406 0 0 0 0 7.627l10.792 10.79a5.407 5.407 0 0 0 7.628 0l2.76-2.759a1.407 1.407 0 0 1 1.97 0l6.606 6.612c.501.502.535 1.316.1 1.859l-.104.116z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="pie-chart"><path d="M28.62 14.25a2 2 0 0 1 2 2v18.13h18.13a2 2 0 0 1 2 2c-.011 12.216-9.914 22.114-22.13 22.12-12.036-.256-21.66-10.086-21.66-22.125s9.624-21.87 21.66-22.125zm-2 4.11c-9.444 1.037-16.486 9.188-16.14 18.682.346 9.495 7.963 17.112 17.458 17.458 9.494.346 17.645-6.696 18.682-16.14h-18a2 2 0 0 1-2-2v-18zM36.38 6.5c12.21.017 22.103 9.91 22.12 22.12a2 2 0 0 1-2 2H36.38a2 2 0 0 1-2-2V8.5a2 2 0 0 1 2-2zm2 4.12v16h16a18.18 18.18 0 0 0-16-16z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="place"><path d="M32 4a20 20 0 0 1 20 20c0 12.49-13.63 28.11-17.81 32.55a3 3 0 0 1-2.19 1l-.207-.007a3 3 0 0 1-1.983-.943C25.63 52.11 12 36.49 12 24c0-11.046 8.954-20 20-20zm0 4c-8.837 0-16 7.163-16 16 0 10.53 12.07 24.73 16 29.07C35.93 48.73 48 34.53 48 24c0-8.837-7.163-16-16-16zm0 6a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10zm0 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="play"><path d="M18 54.75a6.09 6.09 0 0 1-2.9-.75 5.93 5.93 0 0 1-3.1-5.26V15.26a6 6 0 0 1 9.16-5.11l29.91 16.78a6 6 0 0 1 0 10.14l-.09.06-29.82 16.72c-.95.588-2.043.9-3.16.9zm0-41.5a2.11 2.11 0 0 0-1 .26 2 2 0 0 0-1 1.75v33.48a2 2 0 0 0 3.07 1.69h.09L49 33.67a2 2 0 0 0 0-3.34L19.07 13.57a2 2 0 0 0-1.07-.32z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="police"><path d="M48.43 7.59l5 5a2 2 0 0 1 0 2.85c-2.27 2.18-1.7 5.54-.59 10.84A42.42 42.42 0 0 1 54 35c0 8.56-8.08 19.11-21.59 22a1.84 1.84 0 0 1-.41 0 1.84 1.84 0 0 1-.41 0C18.08 54.11 10 43.56 10 35a42.42 42.42 0 0 1 1.2-8.72c1.11-5.3 1.68-8.66-.59-10.84a2 2 0 0 1 0-2.85l5-5a2 2 0 0 1 2.35-.36 13.21 13.21 0 0 0 13.13 0 2 2 0 0 1 1.86 0 13.21 13.21 0 0 0 13.13 0 2 2 0 0 1 2.35.36zM32 11.23a16.89 16.89 0 0 1-14.59.19l-2.72 2.71c2.38 3.67 1.39 8.39.43 13A39.37 39.37 0 0 0 14 35c0 6.73 6.87 15.43 18 18 11.13-2.52 18-11.22 18-18a39.37 39.37 0 0 0-1.12-7.9l-.157-.724c-.939-4.35-1.715-8.77.587-12.276l-2.72-2.71A16.89 16.89 0 0 1 32 11.23zm-.04 6.992a2 2 0 0 1 1.79 1.108l2.72 5.5 6.06.88a2 2 0 0 1 1.11 3.41l-4.35 4.28 1 6a2 2 0 0 1-2 2.34l.07.04a2.1 2.1 0 0 1-.94-.23L32 38.7l-5.42 2.85a2 2 0 0 1-2.11-.15 2 2 0 0 1-.8-2l1-6-4.39-4.28a2 2 0 0 1 1.11-3.41l6.06-.88 2.72-5.5a2 2 0 0 1 1.79-1.108zM32 24.74l-1.38 2.8a2 2 0 0 1-1.51 1.1l-3.1.45 2.24 2.18a2 2 0 0 1 .58 1.73l-.53 3.08 2.77-1.45c.29-.14.609-.206.93-.19a1.91 1.91 0 0 1 .93.23l2.77 1.45-.53-3.12a2 2 0 0 1 .58-1.77L38 29.09l-3.1-.45a2 2 0 0 1-1.51-1.1L32 24.74z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="position"><path d="M4.683 29.9L53.21 8.149a2 2 0 0 1 2.643 2.643L34.1 59.317a2 2 0 0 1-3.722-.186L24 40 4.869 33.623a2 2 0 0 1-.186-3.722zm6.32 1.551l14.262 4.754a4 4 0 0 1 2.53 2.53l4.754 14.262 17.506-39.052-39.052 17.506z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="product-bedrift-click"><path d="M31.44 7.86a2 2 0 0 1 0 4h-8.87A3.58 3.58 0 0 0 19 15.44V45h22V21.49a2 2 0 1 1 4 0V52.6a7.58 7.58 0 0 1-7.54 7.57H22.57A7.57 7.57 0 0 1 15 52.6V15.44a7.58 7.58 0 0 1 7.59-7.58zM41 49H19v3.6a3.57 3.57 0 0 0 3.59 3.57h14.87A3.57 3.57 0 0 0 41 52.6V49zm-10.98 1.74a1.86 1.86 0 1 1 0 3.72 1.86 1.86 0 0 1 0-3.72zm13.62-47.1A1.28 1.28 0 0 1 45.05 5v2.93h2.663a1.27 1.27 0 0 1 1.207 1.31c0 1.24-.82 2.62-1.92 2.62h-2v1.7c0 1.31-.86 2.77-2 2.77-1.14 0-2-1.49-2-2.23v-2.24h-2.24c-1.05 0-1.9-1.51-1.9-2.1a2 2 0 0 1 1.43-1.64 3 3 0 0 1 1.08-.19h1.66V5.64c0-1.11 1.43-2 2.61-2z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="product-bedriftsnett"><path d="M33.88 8.38L53.82 18.7A4.14 4.14 0 0 1 56 22.35V52a4.13 4.13 0 0 1-4.1 4.1h-18a4.13 4.13 0 0 1-4.13-4.1v-7.65a2.025 2.025 0 0 1 4.05 0V52a.07.07 0 0 0 .08.08h18A.07.07 0 0 0 52 52V22.35L32 12h-.13L12 22.3v29.63a.07.07 0 0 0 .07.08h10.2a2.025 2.025 0 0 1 0 4.05H12.1A4.13 4.13 0 0 1 8 51.93V22.35a4.11 4.11 0 0 1 2.17-3.63L30 8.38a4.1 4.1 0 0 1 3.88 0zm9.62 15.04a14.27 14.27 0 0 1 0 20.2 2 2 0 0 1-2.83-2.83 10.26 10.26 0 0 0 0-14.54 2.001 2.001 0 0 1 2.83-2.83zm-21.32-.636A2 2 0 0 1 23 26.25a10.28 10.28 0 0 0 0 14.54 2 2 0 0 1-1.249 3.414l-.156.006-.17-.008a2 2 0 0 1-1.235-.582 14.27 14.27 0 0 1 0-20.2 2 2 0 0 1 1.99-.636zm16.23 4.366a9 9 0 0 1 0 12.75 2 2 0 0 1-1.41.58 2 2 0 0 1-1.41-3.41 5 5 0 0 0 0-7.09 2 2 0 1 1 2.82-2.83zm-11.198-.513A2.008 2.008 0 0 1 28.1 30a5 5 0 0 0 0 7.09 2 2 0 0 1 0 2.83 2 2 0 0 1-1.41.56 2 2 0 0 1-1.42-.58 9 9 0 0 1 0-12.75 2.008 2.008 0 0 1 1.942-.513zm4.578 4.843a2.04 2.04 0 1 1 0 4.08 2.04 2.04 0 0 1 0-4.08z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="product-data-boost"><path d="M25.71 17.47c9.56-8.22 21.14-6.79 25.33-5.89a4 4 0 0 1 3.16 3.69c.2 4.32-.21 15.95-9.8 24.12a17.54 17.54 0 0 1-3 12.07l.03-.03a4 4 0 0 1-6.75-.39l-2.9-5.19c-.58.18-1.09.31-1.67.45a4 4 0 0 1-4-1.3l-8.8-10.27a4 4 0 0 1-.68-4.16c.25-.57.47-1.05.71-1.57l-4.69-3.71a3.35 3.35 0 0 1-.58-.55 4 4 0 0 1 1.27-6.15 17.53 17.53 0 0 1 12.37-1.12zm-3.168 27.554l.176.007a2 2 0 0 1 1.362.699 2 2 0 0 1-.23 2.78l-3 2.59a2 2 0 1 1-2.59-3l3-2.6a2 2 0 0 1 1.458-.47zM18.65 40.46l.176.006a2 2 0 0 1 1.364.694A2 2 0 0 1 20 44l-6.13 5.13a2 2 0 1 1-2.59-3l6.09-5.19a2 2 0 0 1 1.456-.474zm21.92 1.76a33.07 33.07 0 0 1-4.91 2.36l2.56 4.58a13 13 0 0 0 2.35-6.94zm9.75-26.7C45.4 14.47 28.6 12.58 20.4 32.11l8.8 10.32.01.02c20.58-5.01 21.36-21.93 21.11-26.93zM14.752 35.894l.176.007a2 2 0 0 1 1.362.699 2 2 0 0 1-.29 2.81L13 42a2 2 0 0 1-2.53-3.03l3-2.6a2 2 0 0 1 1.458-.47zm19.79-14.872a6 6 0 1 1 7.78 9.137 6 6 0 0 1-7.78-9.137zm5.417 3.28a2 2 0 0 0-3.049 2.588h.02a2 2 0 0 0 2.8.23 2 2 0 0 0 .23-2.819zM22.36 20.91a12.82 12.82 0 0 0-7.16 1.25l4.03 3.19a35.16 35.16 0 0 1 3.13-4.44z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="product-data-rollover"><path d="M31.18 8.39A23.49 23.49 0 0 1 51.3 17.9l.36-2.18a1.81 1.81 0 0 1 .74-1.19 1.78 1.78 0 0 1 1.36-.32A1.83 1.83 0 0 1 55 15c.238.392.323.859.24 1.31l-1.06 6.5a2.3 2.3 0 0 1-1 1.52 2.22 2.22 0 0 1-1.25.38 2.73 2.73 0 0 1-.54-.07L45 23.07a1.84 1.84 0 0 1-1.2-2.51 1.89 1.89 0 0 1 2.2-1.03l1.87.47a19.68 19.68 0 1 0 2.74 19.25 2 2 0 0 1 3.7 1.48 23.62 23.62 0 0 1-39.21 7.42 23.44 23.44 0 0 1-6.34-17.76c.924-11.906 10.498-21.301 22.42-22zM29.7 27.32c.26 0 .42.09.48.29L32.82 35a.71.71 0 0 1 0 .26 1.82 1.82 0 0 1-.29 1 .77.77 0 0 1-.63.44c-.233 0-.463-.17-.69-.51a1.92 1.92 0 0 1-.19-.38l-.31-1.07H27l-.4 1.12a1.5 1.5 0 0 1-.34.56.64.64 0 0 1-.46.22c-.23 0-.46-.17-.68-.51a1.18 1.18 0 0 1-.23-.54 1 1 0 0 1 .05-.23L27.59 28a.85.85 0 0 1 .27-.34 1.57 1.57 0 0 1 .48-.25c.17-.059.35-.09.53-.09h.83zm14.41 0c.26 0 .42.09.48.29L47.24 35a.71.71 0 0 1 0 .26 1.82 1.82 0 0 1-.29 1 .77.77 0 0 1-.63.44c-.227 0-.457-.17-.69-.51a1.92 1.92 0 0 1-.19-.38l-.31-1.07h-3.76L41 35.86a1.5 1.5 0 0 1-.34.56.64.64 0 0 1-.46.22c-.23 0-.46-.17-.68-.51a1.18 1.18 0 0 1-.23-.54.7.7 0 0 1 .06-.23L42 28a.85.85 0 0 1 .27-.34 1.57 1.57 0 0 1 .48-.25c.17-.059.35-.09.53-.09h.83zm-4.89.04c.35 0 .52.15.52.47a1.82 1.82 0 0 1-.29 1 .82.82 0 0 1-.63.44h-1.75v5.95a1.82 1.82 0 0 1-.29 1 .8.8 0 0 1-.64.44c-.22 0-.45-.17-.68-.51a1.13 1.13 0 0 1-.22-.54v-6.35h-1.81c-.22 0-.45-.17-.68-.51a1.17 1.17 0 0 1-.22-.54.72.72 0 0 1 .41-.58c.267-.176.58-.27.9-.27h5.38zm-19.19 0a4.45 4.45 0 0 1 2.33.61A4.31 4.31 0 0 1 24 29.59c.377.682.57 1.45.56 2.23a5.21 5.21 0 0 1-.58 2.52A4 4 0 0 1 22.3 36a4.89 4.89 0 0 1-2.39.58l-2.29-.01c-.23 0-.46-.17-.69-.52a1.21 1.21 0 0 1-.22-.54v-7.3c0-.21.14-.4.42-.58a1.59 1.59 0 0 1 .9-.27h2zm.1 1.76h-1.59v5.63l1.46.03a2.46 2.46 0 0 0 1.94-.78 3.11 3.11 0 0 0 .69-2.14 2.81 2.81 0 0 0-.69-2 2.33 2.33 0 0 0-1.81-.74zm8.73.24l-1.35 3.8h2.66l-1.31-3.8zm14.42 0l-1.35 3.8h2.66l-1.31-3.8z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="product-data-sharing"><path d="M31.18 8.39A23.49 23.49 0 0 1 51.3 17.9l.36-2.18a1.81 1.81 0 0 1 .74-1.19 1.78 1.78 0 0 1 1.36-.32A1.83 1.83 0 0 1 55 15c.238.392.323.859.24 1.31l-1.06 6.5a2.3 2.3 0 0 1-1 1.52 2.22 2.22 0 0 1-1.25.38 2.73 2.73 0 0 1-.54-.07L45 23.07a1.84 1.84 0 0 1-1.2-2.51 1.89 1.89 0 0 1 2.2-1.03l1.87.47a19.68 19.68 0 1 0 2.74 19.25 2 2 0 0 1 3.7 1.48 23.62 23.62 0 0 1-39.21 7.42 23.44 23.44 0 0 1-6.34-17.76c.924-11.906 10.498-21.301 22.42-22zm3.61 11.84a2 2 0 1 1 2.82 2.82l-1.86 1.86h2.84a4 4 0 0 1 4 4V41a4 4 0 0 1-4 4H26.11a4 4 0 0 1-4-4V28.91a4 4 0 0 1 4-4H29l-1.92-1.86a2 2 0 1 1 2.83-2.82l2.44 2.43zm-4.44 16.68h-4.24V41h4.24v-4.09zm8.24-.03h-4.24V41h4.24v-4.12zm-8.24-7.97h-4.24v4h4.24v-4zm8.24-.04h-4.24v4h4.24v-4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="product-extra-datasim"><path d="M31.4 10.52a7.2 7.2 0 0 1 5.15 2.13l9.16 9.19A7.2 7.2 0 0 1 47.84 27v25.88a7.3 7.3 0 0 1-7.29 7.29h-21a7.3 7.3 0 0 1-7.29-7.29V17.81a7.3 7.3 0 0 1 7.29-7.29zm0 4.05H19.59a3.24 3.24 0 0 0-3.23 3.24v35.07a3.24 3.24 0 0 0 3.23 3.24h21a3.24 3.24 0 0 0 3.24-3.24V27a3.21 3.21 0 0 0-.95-2.28l-9.2-9.2a3.21 3.21 0 0 0-2.28-.95zm5.69 20.5a3.79 3.79 0 0 1 3.78 3.78v10.53a3.79 3.79 0 0 1-3.78 3.78h-14a3.79 3.79 0 0 1-3.79-3.78V38.85a3.79 3.79 0 0 1 3.79-3.78zm-.29 11h-4.7v3h4.7v-3zm-8.77-7h-4.7v10h4.7v-10zm8.77 0h-4.71v3h4.71v-3zM46.3 4.1a2 2 0 0 1 2 2v2h2a2 2 0 1 1 0 4h-2v2a2 2 0 1 1-4 0v-2h-2a2 2 0 1 1 0-4h2v-2a2 2 0 0 1 2-2z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="product-ladeavtale"><path d="M27.41 25.29a2 2 0 0 0-1.41-.58H15.82a3.67 3.67 0 0 0-3.82 3.5v9a3.68 3.68 0 0 0 3.82 3.5H38a2 2 0 0 0 1.41-3.42l-12-12zM16 36.7v-8h9.17l8 8H16zm40-14h-.25a8 8 0 0 0-7.75-6H12a8 8 0 0 0-8 8v16a8 8 0 0 0 8 8h36a8 8 0 0 0 7.75-6H56c2.24 0 4-2.05 4-4.67V27.37c0-2.61-1.76-4.66-4-4.66v-.01zM56 38c.01.235-.05.468-.17.67H52v2a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4v-16a4 4 0 0 1 4-4h36a4 4 0 0 1 4 4v2h3.83c.12.199.179.428.17.66V38z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="product-mobilpant"><path d="M36.92 4a8 8 0 0 1 8 8v13.12l2.74-2.74a2 2 0 1 1 2.83 2.83l-5.54 5.54a2.89 2.89 0 0 1-4.05 0l-5.54-5.54a2.001 2.001 0 0 1 2.83-2.83l2.73 2.74V12a4 4 0 0 0-4-4h-16a4 4 0 0 0-4 4v32h24v-7.36a2 2 0 1 1 4 0V52a8 8 0 0 1-8 8h-16a8 8 0 0 1-8-8V12a8 8 0 0 1 8-8zm4 44h-24v4a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4v-4zm-12 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="product-music-freedom"><path d="M56.06 16a1.68 1.68 0 0 0-.09-.32 2.88 2.88 0 0 0-2-1.76c-2.23-.61-6 .86-8.59 2.34a3.56 3.56 0 0 0-1-1.31 3.71 3.71 0 0 0-3.15-.72l-18.89 4.31a3.69 3.69 0 0 0-2.88 3.62v.11C17 21 13.81 19.91 11.89 20.43a2.82 2.82 0 0 0-2 1.73c-.04.104-.07.21-.09.32-.46 2.33-.26 7 3.64 8.29a4.37 4.37 0 0 0 1 3.32 6.62 6.62 0 0 0 5 2.17v2.33a8.64 8.64 0 0 0-4-1c-4.41 0-8 3.2-8 7.14 0 3.94 3.59 7.13 8 7.13s8-3.2 8-7.13V22.38l18.26-4.21v15.28a8.76 8.76 0 0 0-4-1c-4.41 0-8 3.2-8 7.13 0 3.93 3.58 7.13 8 7.13s8-3.2 8-7.13v-9h.16a7 7 0 0 0 5.23-2.29 4.5 4.5 0 0 0 1-3.56c4.24-1.34 4.46-6.29 3.97-8.73zM15.47 47.91c-2.21 0-4-1.41-4-3.14 0-1.73 1.79-3.14 4-3.14s4 1.41 4 3.14c0 1.73-1.8 3.14-4 3.14zm4-15.64a2.72 2.72 0 0 1-1.91-.71c-.09-.1-.27-.33.11-1l.06-.11c.1-.154.174-.323.22-.5a2 2 0 0 0-1.42-2.45l-1.61-.43c-1.1-.29-1.28-1.7-1.27-2.71A16.22 16.22 0 0 1 19.46 27l.01 5.27zm18.27 10.5c-2.21 0-4-1.41-4-3.14 0-1.73 1.79-3.14 4-3.14s4 1.41 4 3.14c0 1.73-1.81 3.14-4.01 3.14h.01zM50.77 21l-1.77.44a2 2 0 0 0-1.42 2.45c.046.177.12.346.22.5l.06.1c.47.85.23 1.15.12 1.28a3 3 0 0 1-2.29.81v-5.85a17.49 17.49 0 0 1 6.5-3c.09 1.18-.08 2.89-1.42 3.27z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="product-roam-like-home"><path d="M47 19c7.18 0 13 5.82 13 13s-5.82 13-13 13H17C9.82 45 4 39.18 4 32s5.82-13 13-13h30zm0 4H17a9 9 0 0 0 0 18h30a9 9 0 0 0 0-18zm-2 2a7 7 0 1 1 0 14 7 7 0 0 1 0-14zm0 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="product-skjermforsikring"><path d="M28.82 7a2 2 0 1 1 0 4h-7.06A3.78 3.78 0 0 0 18 14.78v29.73h22.93V34a2 2 0 0 1 2-2 2 2 0 0 1 2.02 2v18.29a7.78 7.78 0 0 1-7.77 7.77h-15.4A7.79 7.79 0 0 1 14 52.29V14.78A7.79 7.79 0 0 1 21.76 7zM41 48.51H18v3.78A3.77 3.77 0 0 0 21.76 56h15.4v.06A3.77 3.77 0 0 0 41 52.29v-3.78zm-11.54 1.84a1.93 1.93 0 1 1 0 3.86 1.93 1.93 0 0 1 0-3.86zm15.895-21.975A2.002 2.002 0 0 1 47.83 27l4.68 1.36v-.02a2 2 0 0 1-.55 3.93 2.09 2.09 0 0 1-.55-.08l-4.68-1.34a2.002 2.002 0 0 1-1.375-2.475zm-10.482-24a2 2 0 0 1 2.037-.325l3.82 1.28a7.77 7.77 0 0 1 4.87 9.86l-3.82 11.24a2 2 0 0 1-1.89 1.36 2.05 2.05 0 0 1-.64-.11A2 2 0 0 1 38 25.15l3.76-11.25a3.78 3.78 0 0 0-2.36-4.79l-3.78-1.28a2 2 0 0 1-.747-3.455zM51.08 18.66A2 2 0 0 1 53 22.17l-4.85 2.67a2.1 2.1 0 0 1-1 .24l.024-.001-.125-.003a2 2 0 0 1-1.756-1.327l-.048-.153a2 2 0 0 1 .965-2.266z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="product-svitsj"><path d="M46 27.64a2 2 0 0 1 2 2V52a8 8 0 0 1-8 8H24a8 8 0 0 1-8-8V36.81l-1.78 1.78a2 2 0 1 1-2.83-2.82l4.68-4.68a2.81 2.81 0 0 1 .79-.55 2 2 0 0 1 2.28 0c.293.137.56.323.79.55l4.68 4.68a2 2 0 0 1-1.41 3.41 2 2 0 0 1-1.42-.59L20 36.81V44h24V29.64a2 2 0 0 1 2-2zM44 48H20v4a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4v-4zm-12 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm8-46a8 8 0 0 1 8 8v6.07l1.78-1.78a2 2 0 1 1 2.83 2.83l-4.68 4.68a2.73 2.73 0 0 1-3.86 0l-4.68-4.68a2.001 2.001 0 0 1 2.83-2.83L44 18.07V12a4 4 0 0 0-4-4H24a4 4 0 0 0-4 4v12.77a2 2 0 1 1-4 0V12a8 8 0 0 1 8-8z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="product-telia-startup"><path d="M57.52 12.9a4 4 0 0 0-3.25-1.13c-5.11.55-17.48 2.62-21.85 9.89-1.89 3.14-2 6.75-.45 10.73a9.62 9.62 0 0 0 1.08 1.93 8.87 8.87 0 0 0-1 2.09A14.1 14.1 0 0 0 29.53 35a8.34 8.34 0 0 0-.85-5.21c-3.95-7.39-15.39-6.11-20.12-5.22a4 4 0 0 0-2.73 6c1.75 3 7.59 12 15 12a9.33 9.33 0 0 0 2.67-.39 8.4 8.4 0 0 0 4.52-3.36c1.39.68 2.76 1.69 2.84 2.68v.11a57.62 57.62 0 0 0-.27 8.83 2 2 0 0 0 2 1.92h.1a2 2 0 0 0 1.91-2.11c-.19-4.08.15-10.6 1.41-13.06a10.57 10.57 0 0 0 5.48 1.59 7.94 7.94 0 0 0 1-.05c9.28-.94 15.26-12.31 16.17-22.52a4 4 0 0 0-1.14-3.31zM22.39 38.21c-4.67 1.38-9.82-4.13-13.08-9.74a34 34 0 0 1 6.21-.61c4.26 0 8.13 1 9.61 3.78a4.78 4.78 0 0 1-2.74 6.57zm19.74-3.59a6.61 6.61 0 0 1-5.36-2.1 5.14 5.14 0 0 1-1.06-1.63c-1.12-2.79-1.06-5.13.16-7.16 2.38-4 9.43-6.94 18.82-8-.78 8.74-5.69 18.19-12.56 18.89z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="pulse"><path d="M17.252 21.029c.818-1.472 2.951-1.324 3.587.183l.058.156 4.562 13.685 2.793-5.024a2 2 0 0 1 1.582-1.022L30 29h24a2 2 0 0 1 .15 3.995L54 33H31.176l-4.428 7.971c-.818 1.472-2.951 1.324-3.587-.183l-.058-.156-4.563-13.686-2.792 5.025a2 2 0 0 1-1.582 1.022L14 33h-4a2 2 0 0 1-.15-3.995L10 29h2.822l4.43-7.971z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="question"><path d="M31.912 40.408l6.592-7.04.64-.697c4.558-5.023 6.08-8.118 6.08-11.975 0-2.112-.512-4.096-1.6-5.824-2.112-3.456-6.144-5.632-11.2-5.632-5.32 0-10.516 2.753-13.616 7.183l-.208.305c-.448.64-.64 1.216-.64 1.664 0 1.088 1.856 4.544 3.904 4.544.384 0 .768-.128 1.152-.384.32-.256.832-.768 1.536-1.536 2.752-3.072 4.608-4.224 7.104-4.224 2.88 0 4.992 1.92 4.992 4.48 0 2.24-1.216 4.352-4.096 7.488l-6.208 6.592c-.448.576-.704 1.088-.704 1.6s.32 1.344.96 2.432c.96 1.472 1.984 2.24 3.072 2.24.704 0 1.408-.384 2.24-1.216zm-1.6 14.976c-2.496 0-4.864-4.16-4.864-5.76 0-2.24 3.648-4.608 7.168-4.608 1.856 0 2.816.832 2.816 2.56 0 2.624-1.216 5.312-2.752 6.72-.768.704-1.536 1.088-2.368 1.088z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="recycle"><path d="M48.434 32.187l5.09 8.82a6 6 0 0 1-5.2 9h-10.08l.83.83a2 2 0 1 1-2.82 2.83l-3.83-3.82a2.61 2.61 0 0 1 0-3.68l3.83-3.83a2 2 0 0 1 2.82 2.83l-.84.84h10.09a2 2 0 0 0 1.73-3l-5.09-8.82a2.003 2.003 0 1 1 3.47-2zm-27.55-4.61a2.61 2.61 0 0 1 1.22 1.58l1.39 5.23a2 2 0 0 1-1.93 2.52 2 2 0 0 1-1.93-1.49l-.3-1.13-5 8.72a2 2 0 0 0 1.73 3h10.1a2 2 0 1 1 0 4h-10.16a6 6 0 0 1-5.2-9l5-8.73-1.14.31a2 2 0 1 1-1-3.86l5.22-1.4a2.56 2.56 0 0 1 2 .25zM32.164 10a6 6 0 0 1 5.2 3.007l5 8.73.3-1.14a2 2 0 0 1 3.87 1l.04.04-1.41 5.22a2.6 2.6 0 0 1-3.19 1.84l-5.22-1.4a2 2 0 0 1 1-3.86l1.14.31-5-8.74a2 2 0 0 0-3.46 0l-5.1 8.82a2 2 0 1 1-3.46-2l5.09-8.82a6 6 0 0 1 5.2-3.007z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="refill"><path d="M33.49 4a8 8 0 0 1 5.7 2.36L49.72 16.9A7.68 7.68 0 0 1 52 22.39V52a8 8 0 0 1-8 8H20a8 8 0 0 1-8-8V12a8 8 0 0 1 8-8zm0 4H20a4 4 0 0 0-4 4v40a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4V22.39a3.73 3.73 0 0 0-1.1-2.66L36.36 9.19A4.07 4.07 0 0 0 33.49 8zm-.08 12.61L38.84 26a2.85 2.85 0 0 1 0 4l-5.43 5.43a2 2 0 0 1-2.82-2.83l2.58-2.59A7.49 7.49 0 0 0 32 30a8 8 0 1 0 8 8 2 2 0 1 1 4 0 12 12 0 1 1-10.79-11.94l-2.62-2.62a2 2 0 0 1 2.82-2.83z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="refresh"><path d="M53 38.6c-3.385 10.765-14.367 17.223-25.42 14.949-11.054-2.275-18.594-12.544-17.454-23.77C11.266 18.55 20.716 10.006 32 9.998a21.761 21.761 0 0 1 16.37 7.311l.63-4.26a2.02 2.02 0 0 1 4 .57L51.73 22a3 3 0 0 1-3 2.51 3.11 3.11 0 0 1-.43 0l-9-1.28a2.02 2.02 0 1 1 .57-4l5.54.79A17.78 17.78 0 0 0 32 14c-9.233.005-16.966 6.995-17.899 16.181-.933 9.186 5.236 17.588 14.28 19.45C37.425 51.49 46.41 46.208 49.18 37.4A2.002 2.002 0 1 1 53 38.6z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="replace"><path d="M22.68 30.66a2.001 2.001 0 0 1 0 2.83l-8.21 8.21H54a2 2 0 1 1 0 4H14.47l8.21 8.21a2 2 0 0 1-2.83 2.83L9.39 46.27a3.64 3.64 0 0 1 0-5.15l10.46-10.46a2.001 2.001 0 0 1 2.83 0zm21.47-23l10.46 10.46a3.65 3.65 0 0 1 .01 5.15L44.15 33.74a2 2 0 1 1-2.83-2.83l8.21-8.21H10a2 2 0 1 1 0-4h39.53l-8.21-8.22a2 2 0 0 1 2.83-2.82z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="return"><path d="M60 28v12a8 8 0 0 1-8 8H10.44l8.29 8.29a2 2 0 1 1-2.83 2.83L5.44 48.65a3.65 3.65 0 0 1 0-5.15L15.9 33a2 2 0 1 1 2.83 2.82L10.6 44H52a4 4 0 0 0 4-4V28a4 4 0 0 0-4-4h-9.18a2 2 0 1 1 0-4H52a8 8 0 0 1 8 8z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="robot"><path d="M42 3.986a4 4 0 0 1 2 7.464V16h2a8 8 0 0 1 8 8v6a4 4 0 1 1 0 8v12a8 8 0 0 1-8 8H18a8 8 0 0 1-8-8V38a4 4 0 1 1 0-8v-6a8 8 0 0 1 8-8h2v-4.55a4 4 0 1 1 4 0V16h16v-4.55a4 4 0 0 1 2-7.464zM46 20H18a4 4 0 0 0-4 4v26a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4V24a4 4 0 0 0-4-4zm-5.13 22.35a2 2 0 1 1 2.26 3.3C40.9 47.17 36.95 48 32 48c-4.95 0-8.9-.83-11.13-2.35a2 2 0 1 1 2.26-3.3C23.7 42.73 26 44 32 44c6 0 8.3-1.27 8.87-1.65zM24 26a6 6 0 1 1 0 12 6 6 0 0 1 0-12zm16 0a6 6 0 1 1 0 12 6 6 0 0 1 0-12zm-16 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm16 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="router"><path d="M52 32a8 8 0 0 1 8 8v6a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8v-6a8 8 0 0 1 8-8zm0 4H12a4 4 0 0 0-4 4v6a4 4 0 0 0 4 4h40a4 4 0 0 0 4-4v-6a4 4 0 0 0-4-4zm-24 5a2 2 0 1 1 0 4H16a2 2 0 1 1 0-4zm12 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm8 0a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM32 18a11.9 11.9 0 0 1 8.42 3.49A2 2 0 0 1 39 24.9a2 2 0 0 1-1.41-.59 7.92 7.92 0 0 0-11.18 0 2 2 0 1 1-2.83-2.82A11.9 11.9 0 0 1 32 18zm-16.24-4c9.333-8.042 23.147-8.042 32.48 0a2 2 0 0 1-1.3 3.54 1.94 1.94 0 0 1-1.3-.48c-7.841-6.749-19.439-6.749-27.28 0V17a2 2 0 1 1-2.6-3z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="search"><path d="M55.41 54.59L45.19 44.36c7.134-8.645 6.222-21.369-2.073-28.907-8.294-7.539-21.047-7.235-28.973.691-7.926 7.926-8.23 20.679-.691 28.973 7.538 8.295 20.262 9.207 28.907 2.073l10.23 10.22a2 2 0 0 0 2.82-2.82zM12 31c0-9.389 7.611-17 17-17s17 7.611 17 17-7.611 17-17 17-17-7.611-17-17z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="security"><path d="M33.15 7.36a68.33 68.33 0 0 0 19.42 9.72A2 2 0 0 1 54 19c0 18.88-7.08 32.26-21 39.76a2 2 0 0 1-1 .24 2 2 0 0 1-.95-.24c-14-7.5-21-20.88-21-39.76a2 2 0 0 1 1.43-1.92 68.33 68.33 0 0 0 19.37-9.72 2 2 0 0 1 2.3 0zM32 11.46a72.4 72.4 0 0 1-18 9c.34 16.31 6.24 27.54 18 34.25C43.76 48 49.66 36.77 50 20.46a72.4 72.4 0 0 1-18-9zm7.488 12.877A2 2 0 0 1 40.53 27.8l-9.43 11a2 2 0 0 1-1.44.7h-.02a2 2 0 0 1-1.41-.59l-4.72-4.71a2.001 2.001 0 0 1 2.83-2.83l3.19 3.19 8-9.36a2 2 0 0 1 1.958-.863z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="server"><path d="M46 6a8 8 0 0 1 8 8v36a8 8 0 0 1-8 8H18a8 8 0 0 1-8-8V14a8 8 0 0 1 8-8zm4 36H14v8a4 4 0 0 0 4 4h28a4 4 0 0 0 4-4v-8zm-24 4a2 2 0 1 1 0 4h-6a2 2 0 1 1 0-4zm24-20H14v12h36V26zm-24 4a2 2 0 1 1 0 4h-6a2 2 0 1 1 0-4zm20-20H18a4 4 0 0 0-4 4v8h36v-8a4 4 0 0 0-4-4zm-20 4a2 2 0 1 1 0 4h-6a2 2 0 1 1 0-4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="services"><path d="M13 46a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm20 0a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm18 0a5 5 0 1 1 0 10 5 5 0 0 1 0-10zM13 27a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm19 0a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm19 0a5 5 0 1 1 0 10 5 5 0 0 1 0-10zM13 8a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm19 0a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm19 0a5 5 0 1 1 0 10 5 5 0 0 1 0-10z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="settings"><path d="M36 4a4 4 0 0 1 4 4v3.5a21.59 21.59 0 0 1 5.78 3.34l3.05-1.77a4 4 0 0 1 5.48 1.48c.69 1.26 1.75 3.05 2.69 4.66l1.26 2.26a4 4 0 0 1-1.47 5.46l-3 1.76a21.2 21.2 0 0 1 0 6.62l3 1.76a4 4 0 0 1 1.86 2.44 3.94 3.94 0 0 1-.41 3.04c-.78 1.3-1.83 3.15-2.78 4.81l-1.21 2.11a4 4 0 0 1-5.46 1.46l-3.06-1.77A21.87 21.87 0 0 1 40 52.5V56a4 4 0 0 1-1.18 2.84A4 4 0 0 1 36 60h-8a4 4 0 0 1-4-4v-3.5a21.83 21.83 0 0 1-5.77-3.33l-3 1.76a4 4 0 0 1-5.48-1.48C9 48.16 8 46.32 7 44.68l-1.21-2.15a4 4 0 0 1 1.47-5.46l3-1.75A22.15 22.15 0 0 1 10 32a21.91 21.91 0 0 1 .26-3.31l-3.05-1.76a4 4 0 0 1-1.45-5.48l2.65-4.58 1.34-2.34a4 4 0 0 1 5.46-1.46l3.06 1.77A21.59 21.59 0 0 1 24 11.5V8a4 4 0 0 1 1.16-2.84A3.82 3.82 0 0 1 28 4zm0 4h-8v6.38l-1.4.44a17.72 17.72 0 0 0-6.75 3.92l-1.08 1-5.56-3.2-1.34 2.32c-.92 1.61-1.93 3.37-2.66 4.61l5.54 3.19-.31 1.44a17.55 17.55 0 0 0 0 7.81l.31 1.43-5.53 3.2 1.23 2.12a751.25 751.25 0 0 1 2.375 4.108l.395.692 5.55-3.21 1.08 1a17.72 17.72 0 0 0 6.75 3.92l1.4.44V56h8.01v-6.38l1.4-.44a17.72 17.72 0 0 0 6.75-3.92l1.08-1 5.56 3.2 1.2-2.1c1-1.66 2-3.53 2.79-4.85l-.018.03-5.522-3.19.31-1.43a17.59 17.59 0 0 0 0-7.82l-.31-1.43 5.53-3.2-1.3-2.24-2.7-4.69-5.55 3.21-1.08-1a17.72 17.72 0 0 0-6.75-3.92l-1.4-.44V8zm-4 14a10 10 0 0 1 10 10c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10zm0 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="shopping"><path d="M55.33 49.19l-3.15-29.61a4 4 0 0 0-4-3.58H44c0-6.627-5.373-12-12-12S20 9.373 20 16h-4.2a4 4 0 0 0-4 3.58L8.67 49.2a8 8 0 0 0 8 8.8h30.7a8 8 0 0 0 8-8.81h-.04zM32 8a8 8 0 0 1 8 8H24a8 8 0 0 1 8-8zm18.34 44.68a4 4 0 0 1-3 1.32H16.63a4 4 0 0 1-4-4.38L15.8 20H20v8a2 2 0 1 0 4 0v-8h16v8a2 2 0 1 0 4 0v-8h4.2l3.15 29.6a4 4 0 0 1-1.01 3.08z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="shoppingcart"><path d="M47.44 44a6 6 0 0 0 5.82-4.54L57.88 21A4 4 0 0 0 54 16H17.24l-1-4.78A4 4 0 0 0 12.36 8H6a2 2 0 1 0 0 4h6.36l7.3 36.48a6 6 0 1 0 8 7.52h14.7a6 6 0 1 0 0-4H27.65a6 6 0 0 0-4-3.75L22.84 44h24.6zM54 20l-4.62 18.49A2 2 0 0 1 47.44 40H22l-4-20h36zM22 56a2 2 0 1 1 0-4 2 2 0 1 1 0 4zm26-4a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="shuffle"><path d="M7.32 18.28c11 0 16.4 4.27 20.86 9 .45.48.9 1 1.35 1.47.29.33.58.67.88 1 .6.67 1.19 1.34 1.8 2 .45.49.91 1 1.38 1.45 3.93 4 8.71 7.17 17.91 7.54l-2.15-2.15-.51-.59a2.001 2.001 0 0 1 2.83-2.83l5.68 5.68a2.89 2.89 0 0 1 0 4.15l-5.68 5.69a2 2 0 0 1-1.42.58 2 2 0 0 1-1.41-.58 2 2 0 0 1 0-2.83l3.08-3.08c-10.78-.32-16.58-4.22-21-8.57-.48-.48-.94-1-1.39-1.44-.74-.79-1.43-1.58-2.12-2.35l-.58-.65c-.45-.51-.89-1-1.34-1.49-4.15-4.48-8.56-8-18.17-8a2 2 0 1 1 0-4zm18.2 14.95l.43.48.9 1c.44.53.89 1.02 1.36 1.52-4.45 4.76-9.84 9-20.85 9a2 2 0 1 1 0-4c9.6 0 14-3.52 18.16-8zm26.14-20.39l5.68 5.68a2.89 2.89 0 0 1 .01 4.09l-5.68 5.69a2 2 0 0 1-1.42.58 2 2 0 0 1-1.41-.58 2 2 0 0 1 0-2.83l2.71-2.71c-9.21.37-14 3.57-17.92 7.54-.45-.48-.89-1-1.34-1.48l-.35-.4-1-1.11c4.38-4.35 10.17-8.25 20.95-8.57L50 16.84l-1.17-1.17a2.001 2.001 0 0 1 2.83-2.83z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="signal"><path d="M32 32a2 2 0 0 1 2 2v22a2 2 0 1 1-4 0V34a2 2 0 0 1 2-2zM43.9 9.27a2.001 2.001 0 0 1 2.83 0 18 18 0 0 1 0 25.46 2 2 0 1 1-2.83-2.83 14 14 0 0 0 0-19.8 2.001 2.001 0 0 1 0-2.83zm-26.63 0a2.001 2.001 0 1 1 2.83 2.83A13.92 13.92 0 0 0 16 22a13.92 13.92 0 0 0 4.1 9.9 2.001 2.001 0 0 1-2.83 2.83 18 18 0 0 1 0-25.46zm7.075 5.073a2 2 0 0 1 1.415 3.417 6 6 0 0 0 0 8.48 2 2 0 1 1-2.83 2.83c-3.904-3.905-3.904-10.235 0-14.14a2 2 0 0 1 1.415-.587zm14.792.07a2.001 2.001 0 0 1 1.933.517c3.904 3.905 3.904 10.235 0 14.14a2.001 2.001 0 0 1-2.83-2.83 6 6 0 0 0 0-8.48 2.001 2.001 0 0 1 .897-3.348zM32 19a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"/></symbol>\n        <symbol viewBox="0 0 652.25 534.69" id="silent_icon"><path d="M336.69 9.51L192 152.36a74.73 74.73 0 0 0-6.38 6.51 97.76 97.76 0 0 0-11.72-.51h-77A96.69 96.69 0 0 0 0 255.21v24.29a96.69 96.69 0 0 0 96.91 96.86h77a98.22 98.22 0 0 0 12.43-.63 36.64 36.64 0 0 0 4.73 5.82l144.62 142.67C358.5 546.7 397 530.58 397 498.55V36.17c0-31.37-37.14-47.81-60.31-26.66zm250.09 257.85l57.61-57.61a26.87 26.87 0 1 0-38-38l-57.6 57.61-57.61-57.61a26.87 26.87 0 1 0-38 38l57.63 57.61-57.61 57.61a26.87 26.87 0 0 0 38 38l57.59-57.61 57.61 57.61a26.87 26.87 0 1 0 38-38z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="sim-card"><path d="M33.51 4a8 8 0 0 1 5.66 2.34l10.49 10.49A8 8 0 0 1 52 22.49V52a8 8 0 0 1-8 8H20a8 8 0 0 1-8-8V12a8 8 0 0 1 8-8zm0 4H20a4 4 0 0 0-4 4v40a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4V22.49a4 4 0 0 0-1.17-2.83L36.34 9.17A4 4 0 0 0 33.51 8zM40 32a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H24a4 4 0 0 1-4-4V36a4 4 0 0 1 4-4zm-10 4h-6v12h6V36zm10 8h-6v4h6v-4zm0-8h-6v4h6v-4z"/></symbol>\n        <symbol viewBox="-2 -12 24 24" id="sortable"><defs><path id="a" fill-rule="evenodd" d="M.975.67a1.408 1.408 0 0 1 2.073 0l4.496 4.761 4.51-4.777a1.408 1.408 0 0 1 2.073 0 1.62 1.62 0 0 1 0 2.196L8.581 8.725c-.573.607-1.5.607-2.074 0L.975 2.866a1.597 1.597 0 0 1-.429-1.098C.546 1.37.69.973.976.67z"/></defs><use transform="matrix(1 0 0 -1 0 -2)" xlink:href="#a"/><use transform="translate(0 2)" xlink:href="#a"/></symbol>\n        <symbol viewBox="0 0 18 14" id="sorted_asc"><path d="M.975 7.33a1.408 1.408 0 0 0 2.073 0l4.496-4.761 4.51 4.777a1.408 1.408 0 0 0 2.073 0 1.62 1.62 0 0 0 0-2.196L8.581-.725a1.409 1.409 0 0 0-2.074 0L.975 5.134a1.597 1.597 0 0 0-.429 1.098c0 .398.144.795.43 1.098z"/></symbol>\n        <symbol viewBox="0 0 18 14" id="sorted_desc"><path d="M.975 6.67a1.408 1.408 0 0 1 2.073 0l4.496 4.761 4.51-4.777a1.408 1.408 0 0 1 2.073 0 1.62 1.62 0 0 1 0 2.196l-5.546 5.875c-.573.607-1.5.607-2.074 0L.975 8.866a1.597 1.597 0 0 1-.429-1.098c0-.398.144-.795.43-1.098z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="speedometer-max"><path d="M61.38 48.92H32.46c-1.45 0-2.62-1.17-2.62-2.62s1.17-2.62 2.62-2.62h28.92c1.45 0 2.62 1.17 2.62 2.62s-1.17 2.62-2.62 2.62z"/><path d="M2.69 50.49c-1.36 0-2.51-1.05-2.61-2.43v-.11C.02 47.23 0 46.52 0 45.82c0-17.06 13.88-30.94 30.94-30.94 13.48 0 25.32 8.61 29.45 21.44a2.61 2.61 0 01-1.69 3.29 2.61 2.61 0 01-3.29-1.69c-3.43-10.65-13.27-17.81-24.47-17.81-14.17 0-25.7 11.53-25.7 25.7 0 .59.02 1.18.06 1.77v.1c.11 1.44-.98 2.69-2.42 2.8h-.19z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="speedometer-normal"><path d="M2.67 50.52c-1.34 0-2.48-1.03-2.58-2.39-.06-.79-.09-1.6-.09-2.39 0-4.06.78-8.01 2.33-11.73A2.593 2.593 0 117.12 36a25.345 25.345 0 00-1.85 11.74c.11 1.43-.96 2.67-2.38 2.78h-.2zM58.59 50.55h-.22a2.59 2.59 0 01-2.37-2.8c.06-.69.09-1.4.09-2.11 0-14.04-11.42-25.46-25.46-25.46-4.81 0-9.49 1.35-13.54 3.9a2.59 2.59 0 01-2.76-4.38 30.55 30.55 0 0116.3-4.69c16.89 0 30.64 13.74 30.64 30.64 0 .85-.04 1.7-.1 2.53a2.598 2.598 0 01-2.58 2.38zM30.96 48.8c-.6 0-1.2-.21-1.69-.62L5.77 28.04a2.585 2.585 0 01-.28-3.65 2.585 2.585 0 013.65-.28l23.5 20.14c1.09.93 1.21 2.57.28 3.65-.51.6-1.24.91-1.97.91z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="speedometer-rask"><path d="M2.78 50.55c-1.35 0-2.49-1.04-2.59-2.4-.06-.8-.09-1.6-.09-2.39C.1 28.79 13.9 15 30.85 15c2.89 0 5.75.4 8.5 1.19.98.28 1.96.62 2.92 1 1.33.53 1.98 2.05 1.45 3.38s-2.05 1.98-3.38 1.45a25.453 25.453 0 00-9.48-1.82c-14.09 0-25.55 11.46-25.55 25.55 0 .66.03 1.33.08 2 .11 1.43-.96 2.68-2.39 2.79h-.2zM58.91 50.61h-.21a2.607 2.607 0 01-2.39-2.8c.05-.68.08-1.37.08-2.05 0-4.84-1.36-9.55-3.93-13.62-.77-1.21-.4-2.82.81-3.59s2.82-.4 3.59.81c3.1 4.9 4.73 10.57 4.73 16.4 0 .82-.03 1.65-.1 2.47a2.602 2.602 0 01-2.59 2.39zM30.13 48.83c-.59 0-1.19-.2-1.67-.61a2.612 2.612 0 01-.32-3.67L48 20.95c.93-1.1 2.57-1.24 3.67-.32a2.6 2.6 0 01.32 3.66l-19.86 23.6c-.51.61-1.25.93-1.99.93z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="speedometer"><path d="M60 32c0 7.827-3.211 14.904-8.389 19.985l-2.828-2.83A23.928 23.928 0 0 0 56 32c0-4.204-1.08-8.156-2.98-11.592l2.927-2.927A27.87 27.87 0 0 1 60 32zM32 4a27.87 27.87 0 0 1 14.519 4.053l-2.927 2.927A23.892 23.892 0 0 0 32 8C18.745 8 8 18.745 8 32a23.928 23.928 0 0 0 7.217 17.156l-2.83 2.828C7.212 46.903 4 39.826 4 32 4 16.536 16.536 4 32 4zm1.414 29.414l20-20a2 2 0 0 0-2.828-2.828l-20 20a2 2 0 0 0 2.828 2.828z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="star-filled"><path d="M55.4 28.49l-10.25 10 2.42 14.1a2 2 0 0 1-2 2.34 1.913 1.913 0 0 1-.93-.23L32 48l-12.67 6.69a2 2 0 0 1-2.1-.15 2 2 0 0 1-.8-2l2.42-14.1L8.6 28.49a2 2 0 0 1 1.11-3.41L23.87 23l6.34-12.83a2 2 0 0 1 3.58 0L40.13 23l14.16 2.06a2 2 0 0 1 1.11 3.41v.02z"/></symbol>\n        <symbol viewBox="0 0 16 16" id="star-half"><path d="M5.354 5.119L7.538.792A.516.516 0 018 .5c.183 0 .366.097.465.292l2.184 4.327 4.898.696A.537.537 0 0116 6.32a.548.548 0 01-.17.445l-3.523 3.356.83 4.73c.078.443-.36.79-.746.592L8 13.187l-4.389 2.256a.52.52 0 01-.146.05c-.342.06-.668-.254-.6-.642l.83-4.73L.173 6.765a.55.55 0 01-.172-.403.58.58 0 01.085-.302.513.513 0 01.37-.245l4.898-.696zM8 12.027a.5.5 0 01.232.056l3.686 1.894-.694-3.957a.565.565 0 01.162-.505l2.907-2.77-4.052-.576a.525.525 0 01-.393-.288L8.001 2.223 8 2.226v9.8z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="star"><path d="M45.6 54.92a1.911 1.911 0 0 1-.93-.23L32 48l-12.67 6.69a2 2 0 0 1-2.1-.15 2 2 0 0 1-.8-2l2.42-14.1L8.6 28.49a2 2 0 0 1 1.11-3.41L23.87 23l6.34-12.83a2 2 0 0 1 3.58 0L40.13 23l14.16 2.06a2 2 0 0 1 1.11 3.41l-10.25 10 2.42 14.1a2 2 0 0 1-2 2.34l.03.01zM32 43.78a2 2 0 0 1 .93.22l10 5.27L41 38.12a2 2 0 0 1 .57-1.77l8.1-7.89-11.16-1.63A2 2 0 0 1 37 25.74L32 15.6l-5 10.14a2 2 0 0 1-1.5 1.09l-11.2 1.63 8.1 7.89a2 2 0 0 1 .6 1.77l-1.94 11.15 10-5.27a2 2 0 0 1 .94-.22z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="statistics"><path d="M58 52h-6V12a4 4 0 0 0-4-4h-8a4 4 0 0 0-4 4v12h-8a4 4 0 0 0-4 4v4h-8a4 4 0 0 0-4 4v16H6a2 2 0 1 0 0 4h52a2 2 0 1 0 0-4zm-42 0V36h8v16h-8zm12 0V28h8v24h-8zm12 0V12h8v40h-8z"/></symbol>\n        <symbol viewBox="0 0 66 72" id="step-by-step-pebble"><path d="M65.259 17.572c-.033-.575-.058-1.15-.105-1.726a23.573 23.573 0 0 0-.265-2.062l-.016-.008a18.79 18.79 0 0 0-.464-2.118l-.021-.008a16.77 16.77 0 0 0-.896-2.43l-.001-.018c-.29-.63-.625-1.237-1.001-1.819l-.023-.031-.15-.236h-.007a13.303 13.303 0 0 0-1.199-1.54l-.008.001c-.368-.41-.762-.796-1.18-1.155h-.01a13.278 13.278 0 0 0-1.679-1.254l-.012.001c-.467-.29-.948-.553-1.443-.79l-.02-.023a17.511 17.511 0 0 0-3.084-1.12l-.064-.033a22.443 22.443 0 0 0-3.46-.619l-.015.012a29.229 29.229 0 0 0-4.64-.09c-.263.013-.53.026-.792.047a52.03 52.03 0 0 0-5.67.793s0 0 0 0c-1.289.251-2.577.55-3.864.894l-.04.004c-.179.048-.36.1-.538.149a62.577 62.577 0 0 0-6.214 2.081l-.03.013c-6.142 2.42-11.927 5.803-16.633 9.825-.09.076-.176.154-.265.23l-.16.137c-.135.119-.27.238-.404.359l-.037.033a41.13 41.13 0 0 0-3.642 3.7l-.027.037c-.95 1.1-1.829 2.26-2.63 3.474-.11.16-.208.32-.31.48l-.05.077v.009c-.506.81-.971 1.645-1.392 2.504a23.602 23.602 0 0 0-1.157 2.79h-.008c-.329.954-.59 1.931-.778 2.923l.004.05c-.18.976-.287 1.966-.316 2.96v.015a17.436 17.436 0 0 0 .043 2.023c.089.995.257 1.98.503 2.949.126.516.277 1.042.445 1.574.365 1.18.798 2.337 1.297 3.466a44.224 44.224 0 0 0 1.828 3.602l.013.013c.245.429.499.86.76 1.292l.046.074.174.285c.384.615.785 1.23 1.203 1.843.051.078.105.154.159.235l.075.111c.153.222.309.445.465.666l.001.007a60.483 60.483 0 0 0 1.546 2.067l.029.038c.09.116.18.233.273.349l.008.006a63.49 63.49 0 0 0 2.696 3.192l.018.012c.437.484.878.963 1.328 1.432l.018.01c.424.442.854.876 1.291 1.304l.362.342.052.052c.374.36.75.716 1.132 1.062l.037.023c.819.746 1.651 1.46 2.497 2.142l.015.008c.184.148.37.295.555.441l.176.135a45.645 45.645 0 0 0 2.172 1.586v.006c.485.332.971.648 1.457.95.98.63 1.99 1.21 3.028 1.737v.01a27.1 27.1 0 0 0 3.179 1.343h.012a20.3 20.3 0 0 0 2.476.69.03.03 0 0 1 0 .01c1.368.304 2.772.408 4.168.31 5.44-.443 11.687-4.668 17.015-11.58l.05-.056a53.28 53.28 0 0 0 4.396-6.768v-.007c.44-.799.866-1.618 1.279-2.458a61.654 61.654 0 0 0 2.51-5.91l-.011.01.301-.824s.005-.013.009-.018a65.13 65.13 0 0 0 1.26-3.98l-.002-.008c.2-.705.387-1.418.563-2.138v-.006c.228-.97.44-1.951.634-2.942l.024-.067c.154-.788.298-1.582.42-2.388l-.011-.007c.15-.95.282-1.91.393-2.882-.002-.013.008-.026.012-.04.083-.728.156-1.461.218-2.2l-.008-.005a64.67 64.67 0 0 0 .18-2.812l-.008-.007a74.95 74.95 0 0 0 .052-2.009 65.7 65.7 0 0 0-.037-3.545l-.011-.006a70.25 70.25 0 0 0-.062-1.25.036.036 0 0 1 .013-.012z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="stop"><path d="M32 4a28 28 0 0 1 28 28c0 15.464-12.536 28-28 28S4 47.464 4 32 16.536 4 32 4zm0 4C18.745 8 8 18.745 8 32s10.745 24 24 24 24-10.745 24-24S45.255 8 32 8zm12 22a2 2 0 1 1 0 4H20a2 2 0 1 1 0-4h24z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="store"><path d="M52 8a8 8 0 0 1 6 2.69A8 8 0 0 1 60 16v32a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8V16a8 8 0 0 1 8-8zm-6 28h-4a2 2 0 0 0-2 2v14h8V38a2 2 0 0 0-2-2zm10-10.54a6 6 0 0 1-8 0 6 6 0 0 1-8 0 6 6 0 0 1-8 0 6 6 0 0 1-8 0 6 6 0 0 1-8 0 6 6 0 0 1-8 0V48a4 4 0 0 0 4 4h24V38a6 6 0 0 1 6-6h4a6 6 0 0 1 6 6v14a4 4 0 0 0 4-4zM26 32a6 6 0 0 1 6 6v4a6 6 0 0 1-6 6h-8a6 6 0 0 1-6-6v-4a6 6 0 0 1 6-6zm0 4h-8a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm28-23h-4v8a2 2 0 1 0 4 0v-8zm-8 0h-4v8a2 2 0 1 0 4 0v-8zm-8 0h-4v8a2 2 0 1 0 4 0v-8zm-8 0h-4v8a2 2 0 1 0 4 0v-8zm-8 0h-4v8a2 2 0 1 0 4 0v-8zm-8 0h-4v8a2 2 0 1 0 4 0v-8z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="support"><path d="M45.61 30.36A15.78 15.78 0 0 0 48 22a16 16 0 1 0-5.48 12c7.528.28 13.485 6.467 13.48 14v2a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4v-2a14 14 0 0 1 4.76-10.52 26.11 26.11 0 0 0 15.65 8.26 4 4 0 1 0 .29-4 22.11 22.11 0 0 1-14.57-8.9A21.83 21.83 0 0 1 10 20a2 2 0 1 0-4 0 25.74 25.74 0 0 0 4.32 14.31A18.06 18.06 0 0 0 4 48v2a8 8 0 0 0 8 8h40a8 8 0 0 0 8-8v-2a18 18 0 0 0-14.39-17.64zM32 34c-6.627 0-12-5.373-12-12s5.373-12 12-12 12 5.373 12 12a12 12 0 0 1-12 12z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="sync"><path d="M12.4 35.4a20.54 20.54 0 0 0 37.8 7.68 22.59 22.59 0 0 0 1.16-2.17l-4.13 1a2.014 2.014 0 1 1-.97-3.91l8.12-1.94a2.95 2.95 0 0 1 3.53 2.17l1.93 8.12a2 2 0 0 1-1.48 2.45c-.15.04-.305.06-.46.06a2 2 0 0 1-1.9-1.54l-1.08-4.54a24.61 24.61 0 0 1-22.3 14.11C20.496 56.863 10.207 47.989 8.4 36a2.022 2.022 0 1 1 4-.6zM35.379 8.217A24.54 24.54 0 0 1 56.19 27.53a2 2 0 0 1-3.057 2.077 2 2 0 0 1-.863-1.267A20.54 20.54 0 0 0 15 21.28a18.77 18.77 0 0 0-1.21 2.13l4.15-.87a2.001 2.001 0 0 1 .81 3.92l-8.17 1.7a2.48 2.48 0 0 1-.61.07 2.94 2.94 0 0 1-2.87-2.34l-1.7-8.17a2.001 2.001 0 1 1 3.92-.81l.95 4.56A24.54 24.54 0 0 1 35.379 8.217z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="table-view"><path d="M10.958 56C9.877 56 9 55.105 9 54c0-.078.004-.156.013-.232A3.377 3.377 0 0 1 9 53.474V10.526C9 9.131 9.895 8 11 8c.152 0 .3.021.443.062.15-.04.31-.062.474-.062h42.166C55.142 8 56 8.895 56 10c0 .08-.004.158-.013.235.009.095.013.192.013.291l-.001 3.449L56 14v.025l-.001 19.95L56 34v19.474c0 .1-.005.198-.014.295.01.075.014.153.014.231 0 1.105-.877 2-1.958 2zM52 52V36H34v16h17.999zM30 36H13v16h17V36zm21.999-4V16H34v16h17.999zM30 16H13v16h17V16z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="tablet"><path d="M44 4a8 8 0 0 1 8 8v40a8 8 0 0 1-8 8H20a8 8 0 0 1-8-8V12a8 8 0 0 1 8-8zm4 44H16v4a4 4 0 0 0 4 4h24a4 4 0 0 0 4-4v-4zm-16 2a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM44 8H20a4 4 0 0 0-4 4v32h32V12a4 4 0 0 0-4-4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="tags"><path d="M54.625 34.54a3.948 3.948 0 0 0-.496-.611l-23.077-23.07C29.546 9.355 26.569 8.07 24.434 8H11.758A3.617 3.617 0 0 0 8 11.555v12.876c.072 2.135 1.356 5.112 2.862 6.618L33.94 54.128c.186.186.39.354.602.496 2.534 1.976 6.21 1.825 8.531-.496l11.056-11.065c2.265-2.248 2.462-5.786.655-8.309l-.16-.214zM12.002 11.998h12.35c1.134.06 3.098.916 3.871 1.69l23.066 23.06.09.135.091.117c.766.982.693 2.378-.16 3.224L40.244 51.3c-.858.858-2.262.932-3.241.169l-.117-.092-.117-.078L13.692 28.22c-.731-.73-1.535-2.523-1.673-3.675l-.017-.196V11.998zM20.996 24A2.996 2.996 0 0 1 18 21.004 3.005 3.005 0 0 1 21.004 18 2.996 2.996 0 0 1 24 20.996 2.995 2.995 0 0 1 20.996 24z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="time-waiting"><path d="M32 54a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm18-7a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm-36 0a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm18-24a2 2 0 0 1 2 2v7h12a2 2 0 1 1 0 4H32a2 2 0 0 1-2-2v-9a2 2 0 0 1 2-2zM7 29a3 3 0 1 1 0 6 3 3 0 0 1 0-6zM32 4c8.505 0 15.35 2.522 20.414 7.586C57.478 16.65 60 23.496 60 32a2 2 0 1 1-4 0c0-7.495-2.145-13.316-6.414-17.586C45.316 10.144 39.496 8 32 8a2 2 0 1 1 0-4zm-18 7a3 3 0 1 1 0 6 3 3 0 0 1 0-6z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="time"><path d="M32 4c15.464 0 28 12.536 28 28S47.464 60 32 60 4 47.464 4 32 16.536 4 32 4zm0 4C18.745 8 8 18.745 8 32s10.745 24 24 24 24-10.745 24-24S45.255 8 32 8zm0 8a2 2 0 0 1 2 2v16a2 2 0 0 1-.481 1.302l-6 7a2 2 0 1 1-3.038-2.604L30 33.26V18a2 2 0 0 1 2-2z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="trash"><path d="M38 4a6 6 0 0 1 6 6v2h12a2 2 0 1 1 0 4h-4v38a6 6 0 0 1-6 6H18a6 6 0 0 1-6-6V16H8a2 2 0 1 1 0-4h12v-2a6 6 0 0 1 6-6zm10 12H16v38a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V16zm-24 6a2 2 0 0 1 2 2v24a2 2 0 1 1-4 0V24a2 2 0 0 1 2-2zm8 0a2 2 0 0 1 2 2v24a2 2 0 1 1-4 0V24a2 2 0 0 1 2-2zm8 0a2 2 0 0 1 2 2v24a2 2 0 1 1-4 0V24a2 2 0 0 1 2-2zM38 8H26a2 2 0 0 0-2 2v2h16v-2a2 2 0 0 0-2-2z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="tv"><path d="M42 52a2 2 0 1 1 0 4H22a2 2 0 1 1 0-4zm10-40a8 8 0 0 1 8 8v22a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8V20a8 8 0 0 1 8-8zm0 4H12a4 4 0 0 0-4 4v22a4 4 0 0 0 4 4h40a4 4 0 0 0 4-4V20a4 4 0 0 0-4-4zm-22.12 5c.75 0 1.12.33 1.12 1a3.61 3.61 0 0 1-.62 2.06A1.75 1.75 0 0 1 29 25h-4v13a3.61 3.61 0 0 1-.62 2.06A1.75 1.75 0 0 1 23 41c-.507 0-1.01-.36-1.51-1.08a2.33 2.33 0 0 1-.49-1.13V25h-4c-.507 0-1.02-.36-1.54-1.08a2.33 2.33 0 0 1-.49-1.13c0-.44.3-.85.91-1.22a3.62 3.62 0 0 1 2-.57zm5.78 0a.93.93 0 0 1 1 .67L41 36l4.33-13.5a2 2 0 0 1 1-1.05A3.3 3.3 0 0 1 48 21c.65 0 1 .32 1 1 0 .419-.07.835-.21 1.23l-5.53 15.94a3.84 3.84 0 0 1-.79 1.31 1.38 1.38 0 0 1-1 .48h-.78c-.46 0-.98-.31-1.46-1a3.51 3.51 0 0 1-.41-.78l-5.66-15.83a1.76 1.76 0 0 1-.16-.61 1.49 1.49 0 0 1 .83-1.19 3.25 3.25 0 0 1 1.83-.55z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="twitter"><path d="M60 15.443a22.752 22.752 0 0 1-6.595 1.833 11.627 11.627 0 0 0 5.05-6.427 22.758 22.758 0 0 1-7.29 2.817A11.437 11.437 0 0 0 42.778 10c-6.35 0-11.49 5.194-11.49 11.61 0 .906.102 1.8.303 2.648-9.551-.486-18.017-5.103-23.683-12.13a11.71 11.71 0 0 0-1.556 5.839c0 4.028 2.026 7.581 5.106 9.664a11.328 11.328 0 0 1-5.207-1.449v.147c0 5.624 3.964 10.32 9.216 11.384-.964.26-1.982.408-3.024.408-.739 0-1.456-.068-2.161-.204 1.467 4.617 5.7 7.966 10.727 8.057a22.892 22.892 0 0 1-14.266 4.968c-.929 0-1.836-.057-2.743-.159C9.084 54.076 15.12 56 21.603 56c21.13 0 32.686-17.687 32.686-33.032 0-.498-.011-1.007-.033-1.505 2.261-1.64 4.199-3.689 5.744-6.02z"/></symbol>\n        <symbol viewBox="0 0 48.04 39.04" id="twitter_icon"><path d="M48 4.62a19.69 19.69 0 0 1-5.66 1.55A9.89 9.89 0 0 0 46.71.72a19.72 19.72 0 0 1-6.26 2.39 9.86 9.86 0 0 0-17 6.74 9.94 9.94 0 0 0 .25 2.25A28 28 0 0 1 3.34 1.8 9.87 9.87 0 0 0 6.39 15a9.82 9.82 0 0 1-4.46-1.23v.12a9.86 9.86 0 0 0 7.91 9.66 9.87 9.87 0 0 1-4.45.17 9.87 9.87 0 0 0 9.21 6.85 19.78 19.78 0 0 1-12.25 4.18A20.05 20.05 0 0 1 0 34.61 27.9 27.9 0 0 0 15.11 39c18.13 0 28-15 28-28V9.73A20 20 0 0 0 48 4.62"/></symbol>\n        <symbol viewBox="0 0 64 64" id="undo"><path d="M56.461 34.915c.002 12.437-9.3 22.908-21.65 24.373-12.35 1.464-23.842-6.54-26.75-18.633a2 2 0 1 1 3.89-.93c2.51 10.416 12.601 17.153 23.182 15.478C45.714 53.527 53.231 44 52.398 33.319c-.832-10.68-9.734-18.927-20.447-18.944a20 20 0 0 0-2.45.15l3 3a2 2 0 0 1-2.82 2.83l-5.91-5.91a2.9 2.9 0 0 1-.86-2.07 2.94 2.94 0 0 1 .86-2.07l5.91-5.9a2 2 0 0 1 2.78 2.83l-3.29 3.29a25 25 0 0 1 2.74-.15c13.55.011 24.534 10.99 24.55 24.54z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="upload"><path d="M9.846 36C8.826 36 8 35.105 8 34V16c0-4.418 3.306-8 7.385-8h33.23C52.694 8 56 11.582 56 16v18c0 1.105-.827 2-1.846 2-1.02 0-1.846-.895-1.846-2V16c0-2.21-1.653-4-3.693-4h-33.23c-2.04 0-3.693 1.79-3.693 4v18c0 1.105-.826 2-1.846 2zM32 56a2 2 0 0 1-2-2V26.83l-8.59 8.58a2 2 0 0 1-2.82-2.82l11.29-11.3a3 3 0 0 1 4.24 0l11.29 11.3a2 2 0 0 1-2.82 2.82L34 26.83V54a2 2 0 0 1-2 2z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="user-admin"><path d="M47 34a2 2 0 0 1 2 2v1.2a10.09 10.09 0 0 1 3.51 1.46l1.08-1.07a2 2 0 0 1 2.82 2.82l-1.07 1.08A10.09 10.09 0 0 1 56.8 45H58a2 2 0 1 1 0 4h-1.2a10.09 10.09 0 0 1-1.46 3.51l1.07 1.08a2 2 0 0 1-2.82 2.82l-1.08-1.07A10.09 10.09 0 0 1 49 56.8V58a2 2 0 1 1-4 0v-1.2a10.09 10.09 0 0 1-3.51-1.46l-1.08 1.07a2 2 0 1 1-2.82-2.82l1.07-1.08A10.09 10.09 0 0 1 37.2 49H36a2 2 0 1 1 0-4h1.2a10.09 10.09 0 0 1 1.46-3.51l-1.07-1.08a2 2 0 0 1 2.82-2.82l1.08 1.07A10.09 10.09 0 0 1 45 37.2V36a2 2 0 0 1 2-2zM32 6c8.837 0 16 7.163 16 16s-7.163 16-16 16a15.94 15.94 0 0 1-10.65-4.059c-.146.048-.3.08-.461.092a14.1 14.1 0 0 0-7.693 3.071c-1.556 1.26-2.86 2.908-3.852 4.874-.447.887-.869 2.098-1.095 3.286-.075.393-.12.763-.156 1.31l-.03.516-.031.719-.038 1.076c-.022.937.007 1.502.108 2l.042.157.11.34c.16.494.414.899.885 1.425.22.247.39.384.72.58.463.273.94.467 1.379.543l.074.011.19.023.646.054.334.004 1.221-.024 1.003-.008 1.788.006L31.999 54A2 2 0 0 1 32 58H20.073l-4.978-.01-1.023.003-1.647.03c-.184 0-.344-.003-.497-.01l-.301-.02-.604-.057-.238-.03-.227-.035c-.97-.167-1.883-.538-2.733-1.04a6.595 6.595 0 0 1-1.667-1.357c-.815-.91-1.359-1.776-1.71-2.857l-.12-.374a6.608 6.608 0 0 1-.093-.33l-.053-.231c-.153-.755-.205-1.457-.195-2.448L4 48.602l.047-1.249c.057-1.338.114-2.004.272-2.837.298-1.565.843-3.129 1.454-4.34 1.241-2.46 2.9-4.557 4.906-6.18a18.122 18.122 0 0 1 7.678-3.633A15.923 15.923 0 0 1 16 22c0-8.837 7.163-16 16-16zm15 35a6 6 0 1 0 0 12 6 6 0 0 0 0-12zM32 10c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="user-new"><path d="M32 6c8.837 0 16 7.163 16 16s-7.163 16-16 16a15.94 15.94 0 0 1-10.65-4.06c-.146.05-.3.08-.461.093a14.1 14.1 0 0 0-7.693 3.071c-1.556 1.26-2.86 2.908-3.852 4.874-.447.887-.869 2.098-1.095 3.286a9.372 9.372 0 0 0-.137 1.05l-.02.26-.029.516-.031.719-.038 1.076c-.02.843.002 1.385.08 1.848l.028.152.042.157.11.34c.16.494.414.899.885 1.425.22.247.39.384.72.58.463.273.94.467 1.379.543l.036.006.038.005.19.023.646.054.334.004 1.221-.024 1.003-.008 1.788.006L31.999 54a2 2 0 0 1 .151 3.994l-.149.006H20.073l-4.978-.01-1.023.003-1.647.03c-.122 0-.234-.001-.34-.004l-.157-.006-.301-.02-.604-.057-.238-.03-.227-.035c-.97-.167-1.883-.538-2.733-1.04a6.595 6.595 0 0 1-1.667-1.357c-.734-.82-1.247-1.602-1.598-2.539l-.112-.318-.12-.374-.05-.167-.043-.164-.053-.23c-.134-.66-.19-1.28-.196-2.089v-.359L4 48.602l.047-1.249c.057-1.338.114-2.004.272-2.837.298-1.565.843-3.129 1.454-4.34 1.241-2.46 2.9-4.557 4.906-6.18a18.122 18.122 0 0 1 7.678-3.633A15.923 15.923 0 0 1 16 22c0-8.837 7.163-16 16-16zm16 28a2 2 0 0 1 2 2v8h8a2 2 0 1 1 0 4h-8v8a2 2 0 1 1-4 0v-8h-8a2 2 0 1 1 0-4h8v-8a2 2 0 0 1 2-2zM32 10c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="user"><path d="M45.61 30.36A15.78 15.78 0 0 0 48 22c0-8.837-7.163-16-16-16s-16 7.163-16 16a15.78 15.78 0 0 0 2.39 8.36A18 18 0 0 0 4 48v2a8 8 0 0 0 8 8h40a8 8 0 0 0 8-8v-2a18 18 0 0 0-14.39-17.64zM32 10c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12zm24 40a4 4 0 0 1-4 4H12a4 4 0 0 1-4-4v-2c-.005-7.533 5.952-13.72 13.48-14a15.92 15.92 0 0 0 21 0c7.544.259 13.524 6.452 13.52 14v2z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="video"><path d="M52 12a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H12a8 8 0 0 1-8-8V20a8 8 0 0 1 8-8zm0 4H12a4 4 0 0 0-4 4v24a4 4 0 0 0 4 4h40a4 4 0 0 0 4-4V20a4 4 0 0 0-4-4zm-25.938 6.113a4 4 0 0 1 4.058.107l10.23 6.39a4 4 0 0 1 0 6.78l-10.23 6.39a4 4 0 0 1-4.06.11 4 4 0 0 1-2.06-3.5V25.61a4 4 0 0 1 2.062-3.497zM28 25.61v12.78L38.23 32 28 25.61z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="visibility-filled"><path d="M32 12c15.464 0 28 14 28 20S47.464 52 32 52 4 38 4 32s12.536-20 28-20zm0 8c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 4.8a7.2 7.2 0 1 1 0 14.4 7.2 7.2 0 0 1 0-14.4z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="visibility"><path d="M32 12c15.464 0 28 14 28 20S47.464 52 32 52 4 38 4 32s12.536-20 28-20zm0 4c-6.046 0-12.167 2.57-17.228 6.815-2.16 1.811-3.978 3.823-5.229 5.725C8.511 30.111 8 31.423 8 32s.511 1.889 1.543 3.46c1.25 1.902 3.069 3.914 5.229 5.725C19.832 45.431 25.954 48 32 48c6.046 0 12.167-2.57 17.228-6.815 2.16-1.811 3.978-3.823 5.229-5.725C55.489 33.889 56 32.577 56 32s-.511-1.889-1.543-3.46c-1.25-1.902-3.069-3.914-5.229-5.725C44.168 18.569 38.046 16 32 16zm0 6c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10zm0 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="voicemail"><path d="M48 21a12 12 0 0 0-9 20H25a12 12 0 1 0-9 4h32c6.627 0 12-5.373 12-12s-5.373-12-12-12zM16 41a8 8 0 1 1 0-16 8 8 0 0 1 0 16zm32 0a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="volume"><path d="M29.17 12A4 4 0 0 1 36 14.83v34.34a4 4 0 0 1-2.47 3.7 4.12 4.12 0 0 1-1.53.3A4 4 0 0 1 29.17 52l-10-10H16a8 8 0 0 1-8-8v-4a8 8 0 0 1 8-8h3.17zm17.7.674a2 2 0 0 1 2.65.026C53.64 17.51 56 24.54 56 32c0 7.46-2.36 14.49-6.52 19.3a2 2 0 0 1-3-2.6C50 44.6 52 38.52 52 32s-2-12.6-5.48-16.7a2 2 0 0 1 .35-2.626zM32 14.83L20.83 26H16a4 4 0 0 0-4 4v4a4 4 0 0 0 4 4h4.83L32 49.17V14.83zm8.87 3.844a2 2 0 0 1 2.65.026A20.6 20.6 0 0 1 48 32a20.6 20.6 0 0 1-4.52 13.3 2 2 0 0 1-3-2.6A16.58 16.58 0 0 0 44 32a16.58 16.58 0 0 0-3.48-10.7 2 2 0 0 1 .35-2.626z"/></symbol>\n        <symbol viewBox="0 0 652.25 527.37" id="volume_icon"><path d="M332.29 9.38L189.47 150.3a57.55 57.55 0 0 0-7.64 7.78 108.53 108.53 0 0 0-22.3-2.41h-52C48 155.67 0 204.04 0 263.58v.15c0 59.53 48 107.94 107.55 107.94h52a108.19 108.19 0 0 0 23.16-2.6 35.3 35.3 0 0 0 5.74 7.34L331.3 517.06c22.5 22.17 60.7 6.21 60.7-25.39v-456c0-30.94-36.87-47.15-59.71-26.29zm109.39 334.07A26.49 26.49 0 0 1 423 298.23a48.83 48.83 0 0 0 0-69.11 26.49 26.49 0 0 1 37.41-37.45 101.81 101.81 0 0 1 0 144 26.41 26.41 0 0 1-18.73 7.78z"/><path d="M493.64 414.8a26.49 26.49 0 0 1-18.73-45.22c58.39-58.39 58.39-153.41 0-211.8a26.49 26.49 0 1 1 37.46-37.46 202.64 202.64 0 0 1 0 286.72 26.41 26.41 0 0 1-18.73 7.76z"/><path d="M552.05 467.97a26.49 26.49 0 0 1-18.73-45.22 224.82 224.82 0 0 0 0-318.14 26.49 26.49 0 1 1 37.46-37.46 277.8 277.8 0 0 1 0 393.07 26.41 26.41 0 0 1-18.73 7.75z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="warning"><path d="M27.256 39.192c.064 1.344.768 1.984 2.112 1.984 2.752 0 5.44-1.792 5.504-3.584l1.024-25.216c0-1.728-.896-2.56-2.752-2.56-3.52 0-7.168 2.368-7.168 4.608l1.28 24.768zm3.648 16.192c-2.496 0-4.864-4.16-4.864-5.76 0-2.24 3.648-4.608 7.168-4.608 1.856 0 2.816.832 2.816 2.56 0 2.624-1.216 5.312-2.752 6.72-.768.704-1.536 1.088-2.368 1.088z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="weather"><path d="M43 18a9 9 0 0 1 2.933 17.511A9.467 9.467 0 0 1 49 42.5c0 .494-.038.98-.11 1.453A6.5 6.5 0 0 1 46 55.981V56H12v-.014A8.5 8.5 0 0 1 4 47.5c0-4.545 3.882-8.618 8.083-8.523A13.05 13.05 0 0 1 12 37.5C12 30.044 18.268 24 26 24c2.983 0 5.748.9 8.019 2.433A8.998 8.998 0 0 1 43 18zM26 28c-5.555 0-10 4.286-10 9.5 0 .346.02.688.058 1.024l.518 4.555-4.583-.103C10.1 42.933 8 45.143 8 47.5a4.5 4.5 0 0 0 4.232 4.492l.133.008H45.6l.098-.007a2.5 2.5 0 0 0 1.104-4.628l-2.269-1.39.404-2.629c.042-.277.064-.56.064-.846 0-3.038-2.462-5.5-5.439-5.5l-3.135.048-.977-2.668C34.069 30.609 30.309 28 26 28zm26.99 9.962l1.438 1.39a2 2 0 1 1-2.778 2.877l-1.439-1.39a2 2 0 1 1 2.779-2.877zM43 22a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm15 5a2 2 0 1 1 0 4h-2a2 2 0 1 1 0-4h2zM30.181 15.644l1.439 1.39a2 2 0 0 1-2.779 2.876l-1.438-1.389a2 2 0 0 1 2.778-2.877zm25.696-1.033a2 2 0 0 1-.049 2.828l-1.439 1.389a2 2 0 0 1-2.778-2.877l1.438-1.39a2 2 0 0 1 2.828.05zm-14.96-4.484a2 2 0 0 1 2 2v2a2 2 0 1 1-4 0v-2a2 2 0 0 1 2-2z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="wireless-off"><path d="M48.586 12.586a2 2 0 0 1 2.828 2.828l-36 36a2 2 0 0 1-2.828-2.828zM32 45a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm4.377-10.307a11.032 11.032 0 0 1 4.004 2.6 2.14 2.14 0 0 1 0 3.015 2.102 2.102 0 0 1-1.489.618 2.102 2.102 0 0 1-1.457-.629 6.851 6.851 0 0 0-4.63-2.032zm7.61-7.61c1.153.664 2.25 1.43 3.279 2.292.667.56.908 1.47.604 2.279A2.095 2.095 0 0 1 45.903 33c-.5 0-.983-.175-1.362-.494a18.635 18.635 0 0 0-3.589-2.387zM32.404 24c.174 0 .348.002.522.005l-4.493 4.492a18.665 18.665 0 0 0-8.167 4.009c-.879.58-2.06.425-2.753-.361a2.032 2.032 0 0 1 .028-2.729A23.093 23.093 0 0 1 32.403 24zm19.758-5.09c.682.44 1.352.904 2.009 1.393a2.023 2.023 0 0 1 .391 2.89c-.713.904-2.045 1.074-2.975.38a32.382 32.382 0 0 0-2.438-1.65zm-42.33 1.393c9.487-7.062 21.655-9.002 32.616-5.82l-3.392 3.39c-9.094-1.982-18.885-.082-26.641 5.7-.93.694-2.262.524-2.975-.38a2.023 2.023 0 0 1 .391-2.89z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="wireless"><path d="M32 45a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm.557-11a10.994 10.994 0 0 1 7.824 3.292 2.14 2.14 0 0 1 0 3.016 2.102 2.102 0 0 1-1.489.618 2.102 2.102 0 0 1-1.457-.629 6.86 6.86 0 0 0-9.756 0 2.1 2.1 0 0 1-2.077.64 2.121 2.121 0 0 1-1.538-1.547c-.19-.762.05-1.569.627-2.098A10.994 10.994 0 0 1 32.557 34zm-.154-10a23.095 23.095 0 0 1 14.863 5.375c.667.56.908 1.47.604 2.279A2.095 2.095 0 0 1 45.903 33c-.5 0-.983-.175-1.362-.494-6.976-5.905-17.3-5.905-24.276 0-.879.58-2.06.425-2.753-.361a2.032 2.032 0 0 1 .028-2.729A23.093 23.093 0 0 1 32.403 24zM9.83 20.303c13.081-9.737 31.259-9.737 44.34 0a2.023 2.023 0 0 1 .391 2.89c-.713.904-2.045 1.074-2.975.38-11.553-8.612-27.62-8.612-39.172 0-.93.694-2.262.524-2.975-.38a2.023 2.023 0 0 1 .391-2.89z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="world-alert"><path d="M36.497 26.338c1.925-3.117 5.08-3.117 7.009 0l11.863 23.7C57.006 53.316 55.346 56 51.684 56H28.318c-3.666 0-5.326-2.684-3.684-5.962zM32 6a26 26 0 0 1 26 26c0 3.66-.756 7.144-2.122 10.304l-2.516-5.024A22.05 22.05 0 0 0 54 32a21.761 21.761 0 0 0-2-9.17l-2 2V30c0 .157-.018.31-.052.457l-3.707-7.401a2 2 0 0 1 .349-.466l3.33-3.33A22.07 22.07 0 0 0 38 10.84V16a2 2 0 0 1-.59 1.41L34 20.83V22h.289l-1.844 3.687a4.002 4.002 0 0 1-2.44-3.487L30 22v-1.17A4 4 0 0 1 31.17 18L34 15.17v-5.08c-.66-.09-1.33-.09-2-.09a21.84 21.84 0 0 0-10 2.41v9.95a4 4 0 0 1-3.22 3.96L10.38 28l-.1.566A21.53 21.53 0 0 0 10 32c0 7.74 3.997 14.547 10.04 18.468l-1.169 2.335a9.114 9.114 0 0 0-.54 1.318C10.93 49.538 6 41.345 6 32 6 17.64 17.64 6 32 6zm8.959 21.852c-.727-1.136-1.191-1.136-1.914-.002L27.349 51.262C26.683 52.596 26.932 53 28.423 53H51.58c1.487 0 1.738-.406 1.073-1.74zM40.5 48a1.5 1.5 0 1 1 0 3 1.5 1.5 0 1 1 0-3zM27.282 36l-2.003 4H22v2h2.278l-2.002 4H22a4 4 0 0 1-3.995-3.8L18 42v-2a4 4 0 0 1 4-4h5.282zM40.5 35c.83 0 1.5.754 1.5 1.685v7.63c0 .931-.67 1.685-1.5 1.685s-1.5-.754-1.5-1.685v-7.63c0-.931.67-1.685 1.5-1.685zM18 15a22.19 22.19 0 0 0-6.34 8.59L18 22.32z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="world-off"><path d="M53.577 17.494A26 26 0 0 1 58 32c0 14.36-11.64 26-26 26a25.88 25.88 0 0 1-14.508-4.42l2.892-2.893A21.897 21.897 0 0 0 32 54c12.15 0 22-9.85 22-22a21.761 21.761 0 0 0-2-9.17l-2 2V30a2 2 0 0 1-2 2h-6a2 2 0 0 1-1.802-1.128l3.149-3.149.093.277H46v-2.93zm-.991-8.908a2 2 0 0 1 2.828 2.828l-44 44a2 2 0 0 1-2.828-2.828zm-17.63 27.529A4.002 4.002 0 0 1 38 40v6a4 4 0 0 1-4 4h-3.17A4 4 0 0 1 28 48.83L25.17 46h-.1l2.879-2.879.051.049L30.83 46H34v-6h-2.93zM32 6a26 26 0 0 1 14.506 4.423l-2.902 2.902A22.067 22.067 0 0 0 38 10.84V16a2 2 0 0 1-.59 1.41L34 20.83V22h.928l-3.253 3.255a3.995 3.995 0 0 1-1.67-3.055L30 22v-1.17A4 4 0 0 1 31.17 18L34 15.17v-5.08c-.66-.09-1.33-.09-2-.09a21.84 21.84 0 0 0-10 2.41v9.95a4 4 0 0 1-3.22 3.96L10.38 28l-.1.566A21.53 21.53 0 0 0 10 32c0 4.264 1.213 8.245 3.313 11.616l-2.892 2.892A25.88 25.88 0 0 1 6 32C6 17.64 17.64 6 32 6zM18.21 38.718a4.01 4.01 0 0 1 2.508-2.508zM18 15a22.19 22.19 0 0 0-6.34 8.59L18 22.32z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="world-question"><path d="M41 26c8.837 0 16 7.163 16 16s-7.163 16-16 16-16-7.163-16-16 7.163-16 16-16zM32 6a26 26 0 0 1 25.994 25.45 20.113 20.113 0 0 0-4.777-5.286 21.59 21.59 0 0 0-.976-2.791L52 22.83l-1.542 1.543a19.872 19.872 0 0 0-4.011-1.622l.024-.032.119-.129 3.33-3.33a22.07 22.07 0 0 0-11.47-8.287L38 10.84V16a2 2 0 0 1-.47 1.28l-.12.13L34 20.83V22h4.56c.253 0 .501.024.743.07-3 .253-5.81 1.167-8.285 2.595a3.977 3.977 0 0 1-1.011-2.43L30 22v-1.17a4 4 0 0 1 1.014-2.665L31.17 18 34 15.17v-5.08c-.66-.09-1.33-.09-2-.09a21.84 21.84 0 0 0-9.533 2.178L22 12.41v9.95a4 4 0 0 1-3.02 3.915l-.2.045-8.4 1.68a21.53 21.53 0 0 0-.38 4c0 9.315 5.79 17.279 13.967 20.487a20.1 20.1 0 0 0 4.765 5.31C15.915 56.189 6 45.253 6 32 6 17.64 17.64 6 32 6zm9 23c-7.18 0-13 5.82-13 13s5.82 13 13 13 13-5.82 13-13-5.82-13-13-13zm.58 17.18c.58 0 .88.26.88.8 0 .82-.38 1.66-.86 2.1-.24.22-.48.34-.74.34-.78 0-1.52-1.3-1.52-1.8 0-.7 1.14-1.44 2.24-1.44zM41.52 35c1.58 0 2.84.68 3.5 1.76.34.54.5 1.16.5 1.82 0 1.082-.383 1.972-1.492 3.278l-.203.235-.405.447-2.06 2.2c-.26.26-.48.38-.7.38-.34 0-.66-.24-.96-.7-.2-.34-.3-.6-.3-.76 0-.128.051-.256.143-.394l.077-.106 1.94-2.06c.9-.98 1.28-1.64 1.28-2.34 0-.8-.66-1.4-1.56-1.4-.728 0-1.282.314-2.052 1.136l-.168.184-.105.113c-.167.178-.292.3-.375.367-.12.08-.24.12-.36.12-.64 0-1.22-1.08-1.22-1.42 0-.14.06-.32.2-.52.96-1.44 2.62-2.34 4.32-2.34zM18 15a22.19 22.19 0 0 0-6.147 8.137l-.193.453L18 22.32V15z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="world"><path d="M32 6a26 26 0 0 1 26 26c0 14.36-11.64 26-26 26S6 46.36 6 32 17.64 6 32 6zm0 4a21.84 21.84 0 0 0-10 2.41v9.95a4 4 0 0 1-3.22 3.96L10.38 28l-.1.566A21.53 21.53 0 0 0 10 32c0 12.15 9.85 22 22 22s22-9.85 22-22a21.761 21.761 0 0 0-2-9.17l-2 2V30a2 2 0 0 1-2 2h-6a2 2 0 0 1-1.9-1.37L38.56 26H34a4 4 0 0 1-4-4v-1.17A4 4 0 0 1 31.17 18L34 15.17v-5.08c-.66-.09-1.33-.09-2-.09zm2 26a4 4 0 0 1 4 4v6a4 4 0 0 1-4 4h-3.17A4 4 0 0 1 28 48.83L25.17 46H22a4 4 0 0 1-4-4v-2a4 4 0 0 1 4-4zm0 4H22v2h3.17A4 4 0 0 1 28 43.17L30.83 46H34v-6zm16-3v5h-8v-5h8zM38 10.84V16a2 2 0 0 1-.59 1.41L34 20.83V22h4.56a4 4 0 0 1 3.79 2.73L43.44 28H46v-4a2 2 0 0 1 .59-1.41l3.33-3.33A22.07 22.07 0 0 0 38 10.84zM18 15a22.19 22.19 0 0 0-6.34 8.59L18 22.32z"/></symbol>\n        <symbol viewBox="0 0 64 64" id="wrench"><path d="M32.543 8.896A16 16 0 0 1 48 4.5a3.93 3.93 0 0 1 2.77 2.8 4 4 0 0 1-1 3.9l-7.1 7.1a2.19 2.19 0 0 0-.41 2.75 2 2 0 0 0 3.13.29L52.74 14a4 4 0 0 1 6.69 1.75 16 16 0 0 1-19.94 19.59L17 57.76A7.68 7.68 0 0 1 11.6 60h-.36a7.71 7.71 0 0 1-5.55-2.79 7.85 7.85 0 0 1 .68-10.45L28.7 24.5a16 16 0 0 1 3.843-15.604zM44 8a12 12 0 0 0-11.18 16.32l.47 1.22-24.1 24.05a3.82 3.82 0 0 0-.41 5.07A3.64 3.64 0 0 0 11.43 56a3.69 3.69 0 0 0 2.76-1.07l24.27-24.22 1.22.47a12 12 0 0 0 16.18-9.32 12.08 12.08 0 0 0-.28-5.06l-7.35 7.37a6 6 0 0 1-9.23-.82 6.15 6.15 0 0 1 .84-7.88l7.1-7.1A11.563 11.563 0 0 0 44 8zM12 50a2 2 0 1 1 0 4 2 2 0 0 1 0-4z"/></symbol>\n    </svg>';
var $0dc584b94bbc2102$var$AllIcons = function AllIcons() {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        style: {
            display: "none"
        },
        dangerouslySetInnerHTML: {
            __html: $0dc584b94bbc2102$var$allIconsHtml
        }
    });
};
var $0dc584b94bbc2102$export$2e2bcd8739ae039 = $0dc584b94bbc2102$var$AllIcons;



var $fgmOP = parcelRequire("fgmOP");

var $3f999be1dfb2831f$exports = {};
"use strict";
var $c4e00cfde18754db$exports = {};
"use strict";

var $emBdm = parcelRequire("emBdm");
var $c85add9d1ad9ea0b$exports = {};
"use strict";
var $1765bc49cc17c719$exports = {};
"use strict";
var $1765bc49cc17c719$var$replace = String.prototype.replace;
var $1765bc49cc17c719$var$percentTwenties = /%20/g;
var $1765bc49cc17c719$var$Format = {
    RFC1738: "RFC1738",
    RFC3986: "RFC3986"
};
$1765bc49cc17c719$exports = {
    "default": $1765bc49cc17c719$var$Format.RFC3986,
    formatters: {
        RFC1738: function(value) {
            return $1765bc49cc17c719$var$replace.call(value, $1765bc49cc17c719$var$percentTwenties, "+");
        },
        RFC3986: function(value) {
            return String(value);
        }
    },
    RFC1738: $1765bc49cc17c719$var$Format.RFC1738,
    RFC3986: $1765bc49cc17c719$var$Format.RFC3986
};


var $c85add9d1ad9ea0b$var$has = Object.prototype.hasOwnProperty;
var $c85add9d1ad9ea0b$var$isArray = Array.isArray;
var $c85add9d1ad9ea0b$var$hexTable = function() {
    var array = [];
    for(var i = 0; i < 256; ++i)array.push("%" + ((i < 16 ? "0" : "") + i.toString(16)).toUpperCase());
    return array;
}();
var $c85add9d1ad9ea0b$var$compactQueue = function compactQueue(queue) {
    while(queue.length > 1){
        var item = queue.pop();
        var obj = item.obj[item.prop];
        if ($c85add9d1ad9ea0b$var$isArray(obj)) {
            var compacted = [];
            for(var j = 0; j < obj.length; ++j)if (typeof obj[j] !== "undefined") compacted.push(obj[j]);
            item.obj[item.prop] = compacted;
        }
    }
};
var $c85add9d1ad9ea0b$var$arrayToObject = function arrayToObject(source, options) {
    var obj = options && options.plainObjects ? Object.create(null) : {};
    for(var i = 0; i < source.length; ++i)if (typeof source[i] !== "undefined") obj[i] = source[i];
    return obj;
};
var $c85add9d1ad9ea0b$var$merge = function merge(target, source, options) {
    /* eslint no-param-reassign: 0 */ if (!source) return target;
    if (typeof source !== "object") {
        if ($c85add9d1ad9ea0b$var$isArray(target)) target.push(source);
        else if (target && typeof target === "object") {
            if (options && (options.plainObjects || options.allowPrototypes) || !$c85add9d1ad9ea0b$var$has.call(Object.prototype, source)) target[source] = true;
        } else return [
            target,
            source
        ];
        return target;
    }
    if (!target || typeof target !== "object") return [
        target
    ].concat(source);
    var mergeTarget = target;
    if ($c85add9d1ad9ea0b$var$isArray(target) && !$c85add9d1ad9ea0b$var$isArray(source)) mergeTarget = $c85add9d1ad9ea0b$var$arrayToObject(target, options);
    if ($c85add9d1ad9ea0b$var$isArray(target) && $c85add9d1ad9ea0b$var$isArray(source)) {
        source.forEach(function(item, i) {
            if ($c85add9d1ad9ea0b$var$has.call(target, i)) {
                var targetItem = target[i];
                if (targetItem && typeof targetItem === "object" && item && typeof item === "object") target[i] = merge(targetItem, item, options);
                else target.push(item);
            } else target[i] = item;
        });
        return target;
    }
    return Object.keys(source).reduce(function(acc, key) {
        var value = source[key];
        if ($c85add9d1ad9ea0b$var$has.call(acc, key)) acc[key] = merge(acc[key], value, options);
        else acc[key] = value;
        return acc;
    }, mergeTarget);
};
var $c85add9d1ad9ea0b$var$assign = function assignSingleSource(target, source) {
    return Object.keys(source).reduce(function(acc, key) {
        acc[key] = source[key];
        return acc;
    }, target);
};
var $c85add9d1ad9ea0b$var$decode = function(str, decoder, charset) {
    var strWithoutPlus = str.replace(/\+/g, " ");
    if (charset === "iso-8859-1") // unescape never throws, no try...catch needed:
    return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
    // utf-8
    try {
        return decodeURIComponent(strWithoutPlus);
    } catch (e) {
        return strWithoutPlus;
    }
};
var $c85add9d1ad9ea0b$var$limit = 1024;
/* eslint operator-linebreak: [2, "before"] */ var $c85add9d1ad9ea0b$var$encode = function encode(str, defaultEncoder, charset, kind, format) {
    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
    // It has been adapted here for stricter adherence to RFC 3986
    if (str.length === 0) return str;
    var string = str;
    if (typeof str === "symbol") string = Symbol.prototype.toString.call(str);
    else if (typeof str !== "string") string = String(str);
    if (charset === "iso-8859-1") return escape(string).replace(/%u[0-9a-f]{4}/gi, function($0) {
        return "%26%23" + parseInt($0.slice(2), 16) + "%3B";
    });
    var out = "";
    for(var j = 0; j < string.length; j += $c85add9d1ad9ea0b$var$limit){
        var segment = string.length >= $c85add9d1ad9ea0b$var$limit ? string.slice(j, j + $c85add9d1ad9ea0b$var$limit) : string;
        var arr = [];
        for(var i = 0; i < segment.length; ++i){
            var c = segment.charCodeAt(i);
            if (c === 0x2D // -
             || c === 0x2E // .
             || c === 0x5F // _
             || c === 0x7E // ~
             || c >= 0x30 && c <= 0x39 // 0-9
             || c >= 0x41 && c <= 0x5A // a-z
             || c >= 0x61 && c <= 0x7A // A-Z
             || format === $1765bc49cc17c719$exports.RFC1738 && (c === 0x28 || c === 0x29) // ( )
            ) {
                arr[arr.length] = segment.charAt(i);
                continue;
            }
            if (c < 0x80) {
                arr[arr.length] = $c85add9d1ad9ea0b$var$hexTable[c];
                continue;
            }
            if (c < 0x800) {
                arr[arr.length] = $c85add9d1ad9ea0b$var$hexTable[0xC0 | c >> 6] + $c85add9d1ad9ea0b$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            if (c < 0xD800 || c >= 0xE000) {
                arr[arr.length] = $c85add9d1ad9ea0b$var$hexTable[0xE0 | c >> 12] + $c85add9d1ad9ea0b$var$hexTable[0x80 | c >> 6 & 0x3F] + $c85add9d1ad9ea0b$var$hexTable[0x80 | c & 0x3F];
                continue;
            }
            i += 1;
            c = 0x10000 + ((c & 0x3FF) << 10 | segment.charCodeAt(i) & 0x3FF);
            arr[arr.length] = $c85add9d1ad9ea0b$var$hexTable[0xF0 | c >> 18] + $c85add9d1ad9ea0b$var$hexTable[0x80 | c >> 12 & 0x3F] + $c85add9d1ad9ea0b$var$hexTable[0x80 | c >> 6 & 0x3F] + $c85add9d1ad9ea0b$var$hexTable[0x80 | c & 0x3F];
        }
        out += arr.join("");
    }
    return out;
};
var $c85add9d1ad9ea0b$var$compact = function compact(value) {
    var queue = [
        {
            obj: {
                o: value
            },
            prop: "o"
        }
    ];
    var refs = [];
    for(var i = 0; i < queue.length; ++i){
        var item = queue[i];
        var obj = item.obj[item.prop];
        var keys = Object.keys(obj);
        for(var j = 0; j < keys.length; ++j){
            var key = keys[j];
            var val = obj[key];
            if (typeof val === "object" && val !== null && refs.indexOf(val) === -1) {
                queue.push({
                    obj: obj,
                    prop: key
                });
                refs.push(val);
            }
        }
    }
    $c85add9d1ad9ea0b$var$compactQueue(queue);
    return value;
};
var $c85add9d1ad9ea0b$var$isRegExp = function isRegExp(obj) {
    return Object.prototype.toString.call(obj) === "[object RegExp]";
};
var $c85add9d1ad9ea0b$var$isBuffer = function isBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    return !!(obj.constructor && obj.constructor.isBuffer && obj.constructor.isBuffer(obj));
};
var $c85add9d1ad9ea0b$var$combine = function combine(a, b) {
    return [].concat(a, b);
};
var $c85add9d1ad9ea0b$var$maybeMap = function maybeMap(val, fn) {
    if ($c85add9d1ad9ea0b$var$isArray(val)) {
        var mapped = [];
        for(var i = 0; i < val.length; i += 1)mapped.push(fn(val[i]));
        return mapped;
    }
    return fn(val);
};
$c85add9d1ad9ea0b$exports = {
    arrayToObject: $c85add9d1ad9ea0b$var$arrayToObject,
    assign: $c85add9d1ad9ea0b$var$assign,
    combine: $c85add9d1ad9ea0b$var$combine,
    compact: $c85add9d1ad9ea0b$var$compact,
    decode: $c85add9d1ad9ea0b$var$decode,
    encode: $c85add9d1ad9ea0b$var$encode,
    isBuffer: $c85add9d1ad9ea0b$var$isBuffer,
    isRegExp: $c85add9d1ad9ea0b$var$isRegExp,
    maybeMap: $c85add9d1ad9ea0b$var$maybeMap,
    merge: $c85add9d1ad9ea0b$var$merge
};



var $c4e00cfde18754db$var$has = Object.prototype.hasOwnProperty;
var $c4e00cfde18754db$var$arrayPrefixGenerators = {
    brackets: function brackets(prefix) {
        return prefix + "[]";
    },
    comma: "comma",
    indices: function indices(prefix, key) {
        return prefix + "[" + key + "]";
    },
    repeat: function repeat(prefix) {
        return prefix;
    }
};
var $c4e00cfde18754db$var$isArray = Array.isArray;
var $c4e00cfde18754db$var$push = Array.prototype.push;
var $c4e00cfde18754db$var$pushToArray = function(arr, valueOrArray) {
    $c4e00cfde18754db$var$push.apply(arr, $c4e00cfde18754db$var$isArray(valueOrArray) ? valueOrArray : [
        valueOrArray
    ]);
};
var $c4e00cfde18754db$var$toISO = Date.prototype.toISOString;
var $c4e00cfde18754db$var$defaultFormat = $1765bc49cc17c719$exports.default;
var $c4e00cfde18754db$var$defaults = {
    addQueryPrefix: false,
    allowDots: false,
    allowEmptyArrays: false,
    arrayFormat: "indices",
    charset: "utf-8",
    charsetSentinel: false,
    delimiter: "&",
    encode: true,
    encodeDotInKeys: false,
    encoder: $c85add9d1ad9ea0b$exports.encode,
    encodeValuesOnly: false,
    format: $c4e00cfde18754db$var$defaultFormat,
    formatter: $1765bc49cc17c719$exports.formatters[$c4e00cfde18754db$var$defaultFormat],
    // deprecated
    indices: false,
    serializeDate: function serializeDate(date) {
        return $c4e00cfde18754db$var$toISO.call(date);
    },
    skipNulls: false,
    strictNullHandling: false
};
var $c4e00cfde18754db$var$isNonNullishPrimitive = function isNonNullishPrimitive(v) {
    return typeof v === "string" || typeof v === "number" || typeof v === "boolean" || typeof v === "symbol" || typeof v === "bigint";
};
var $c4e00cfde18754db$var$sentinel = {};
var $c4e00cfde18754db$var$stringify = function stringify(object, prefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, sideChannel) {
    var obj = object;
    var tmpSc = sideChannel;
    var step = 0;
    var findFlag = false;
    while((tmpSc = tmpSc.get($c4e00cfde18754db$var$sentinel)) !== void 0 && !findFlag){
        // Where object last appeared in the ref tree
        var pos = tmpSc.get(object);
        step += 1;
        if (typeof pos !== "undefined") {
            if (pos === step) throw new RangeError("Cyclic object value");
            else findFlag = true; // Break while
        }
        if (typeof tmpSc.get($c4e00cfde18754db$var$sentinel) === "undefined") step = 0;
    }
    if (typeof filter === "function") obj = filter(prefix, obj);
    else if (obj instanceof Date) obj = serializeDate(obj);
    else if (generateArrayPrefix === "comma" && $c4e00cfde18754db$var$isArray(obj)) obj = $c85add9d1ad9ea0b$exports.maybeMap(obj, function(value) {
        if (value instanceof Date) return serializeDate(value);
        return value;
    });
    if (obj === null) {
        if (strictNullHandling) return encoder && !encodeValuesOnly ? encoder(prefix, $c4e00cfde18754db$var$defaults.encoder, charset, "key", format) : prefix;
        obj = "";
    }
    if ($c4e00cfde18754db$var$isNonNullishPrimitive(obj) || $c85add9d1ad9ea0b$exports.isBuffer(obj)) {
        if (encoder) {
            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, $c4e00cfde18754db$var$defaults.encoder, charset, "key", format);
            return [
                formatter(keyValue) + "=" + formatter(encoder(obj, $c4e00cfde18754db$var$defaults.encoder, charset, "value", format))
            ];
        }
        return [
            formatter(prefix) + "=" + formatter(String(obj))
        ];
    }
    var values = [];
    if (typeof obj === "undefined") return values;
    var objKeys;
    if (generateArrayPrefix === "comma" && $c4e00cfde18754db$var$isArray(obj)) {
        // we need to join elements in
        if (encodeValuesOnly && encoder) obj = $c85add9d1ad9ea0b$exports.maybeMap(obj, encoder);
        objKeys = [
            {
                value: obj.length > 0 ? obj.join(",") || null : void 0
            }
        ];
    } else if ($c4e00cfde18754db$var$isArray(filter)) objKeys = filter;
    else {
        var keys = Object.keys(obj);
        objKeys = sort ? keys.sort(sort) : keys;
    }
    var encodedPrefix = encodeDotInKeys ? prefix.replace(/\./g, "%2E") : prefix;
    var adjustedPrefix = commaRoundTrip && $c4e00cfde18754db$var$isArray(obj) && obj.length === 1 ? encodedPrefix + "[]" : encodedPrefix;
    if (allowEmptyArrays && $c4e00cfde18754db$var$isArray(obj) && obj.length === 0) return adjustedPrefix + "[]";
    for(var j = 0; j < objKeys.length; ++j){
        var key = objKeys[j];
        var value = typeof key === "object" && typeof key.value !== "undefined" ? key.value : obj[key];
        if (skipNulls && value === null) continue;
        var encodedKey = allowDots && encodeDotInKeys ? key.replace(/\./g, "%2E") : key;
        var keyPrefix = $c4e00cfde18754db$var$isArray(obj) ? typeof generateArrayPrefix === "function" ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix : adjustedPrefix + (allowDots ? "." + encodedKey : "[" + encodedKey + "]");
        sideChannel.set(object, step);
        var valueSideChannel = $emBdm();
        valueSideChannel.set($c4e00cfde18754db$var$sentinel, sideChannel);
        $c4e00cfde18754db$var$pushToArray(values, stringify(value, keyPrefix, generateArrayPrefix, commaRoundTrip, allowEmptyArrays, strictNullHandling, skipNulls, encodeDotInKeys, generateArrayPrefix === "comma" && encodeValuesOnly && $c4e00cfde18754db$var$isArray(obj) ? null : encoder, filter, sort, allowDots, serializeDate, format, formatter, encodeValuesOnly, charset, valueSideChannel));
    }
    return values;
};
var $c4e00cfde18754db$var$normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
    if (!opts) return $c4e00cfde18754db$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.encodeDotInKeys !== "undefined" && typeof opts.encodeDotInKeys !== "boolean") throw new TypeError("`encodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.encoder !== null && typeof opts.encoder !== "undefined" && typeof opts.encoder !== "function") throw new TypeError("Encoder has to be a function.");
    var charset = opts.charset || $c4e00cfde18754db$var$defaults.charset;
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var format = $1765bc49cc17c719$exports.default;
    if (typeof opts.format !== "undefined") {
        if (!$c4e00cfde18754db$var$has.call($1765bc49cc17c719$exports.formatters, opts.format)) throw new TypeError("Unknown format option provided.");
        format = opts.format;
    }
    var formatter = $1765bc49cc17c719$exports.formatters[format];
    var filter = $c4e00cfde18754db$var$defaults.filter;
    if (typeof opts.filter === "function" || $c4e00cfde18754db$var$isArray(opts.filter)) filter = opts.filter;
    var arrayFormat;
    if (opts.arrayFormat in $c4e00cfde18754db$var$arrayPrefixGenerators) arrayFormat = opts.arrayFormat;
    else if ("indices" in opts) arrayFormat = opts.indices ? "indices" : "repeat";
    else arrayFormat = $c4e00cfde18754db$var$defaults.arrayFormat;
    if ("commaRoundTrip" in opts && typeof opts.commaRoundTrip !== "boolean") throw new TypeError("`commaRoundTrip` must be a boolean, or absent");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.encodeDotInKeys === true ? true : $c4e00cfde18754db$var$defaults.allowDots : !!opts.allowDots;
    return {
        addQueryPrefix: typeof opts.addQueryPrefix === "boolean" ? opts.addQueryPrefix : $c4e00cfde18754db$var$defaults.addQueryPrefix,
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $c4e00cfde18754db$var$defaults.allowEmptyArrays,
        arrayFormat: arrayFormat,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $c4e00cfde18754db$var$defaults.charsetSentinel,
        commaRoundTrip: opts.commaRoundTrip,
        delimiter: typeof opts.delimiter === "undefined" ? $c4e00cfde18754db$var$defaults.delimiter : opts.delimiter,
        encode: typeof opts.encode === "boolean" ? opts.encode : $c4e00cfde18754db$var$defaults.encode,
        encodeDotInKeys: typeof opts.encodeDotInKeys === "boolean" ? opts.encodeDotInKeys : $c4e00cfde18754db$var$defaults.encodeDotInKeys,
        encoder: typeof opts.encoder === "function" ? opts.encoder : $c4e00cfde18754db$var$defaults.encoder,
        encodeValuesOnly: typeof opts.encodeValuesOnly === "boolean" ? opts.encodeValuesOnly : $c4e00cfde18754db$var$defaults.encodeValuesOnly,
        filter: filter,
        format: format,
        formatter: formatter,
        serializeDate: typeof opts.serializeDate === "function" ? opts.serializeDate : $c4e00cfde18754db$var$defaults.serializeDate,
        skipNulls: typeof opts.skipNulls === "boolean" ? opts.skipNulls : $c4e00cfde18754db$var$defaults.skipNulls,
        sort: typeof opts.sort === "function" ? opts.sort : null,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $c4e00cfde18754db$var$defaults.strictNullHandling
    };
};
$c4e00cfde18754db$exports = function(object, opts) {
    var obj = object;
    var options = $c4e00cfde18754db$var$normalizeStringifyOptions(opts);
    var objKeys;
    var filter;
    if (typeof options.filter === "function") {
        filter = options.filter;
        obj = filter("", obj);
    } else if ($c4e00cfde18754db$var$isArray(options.filter)) {
        filter = options.filter;
        objKeys = filter;
    }
    var keys = [];
    if (typeof obj !== "object" || obj === null) return "";
    var generateArrayPrefix = $c4e00cfde18754db$var$arrayPrefixGenerators[options.arrayFormat];
    var commaRoundTrip = generateArrayPrefix === "comma" && options.commaRoundTrip;
    if (!objKeys) objKeys = Object.keys(obj);
    if (options.sort) objKeys.sort(options.sort);
    var sideChannel = $emBdm();
    for(var i = 0; i < objKeys.length; ++i){
        var key = objKeys[i];
        if (options.skipNulls && obj[key] === null) continue;
        $c4e00cfde18754db$var$pushToArray(keys, $c4e00cfde18754db$var$stringify(obj[key], key, generateArrayPrefix, commaRoundTrip, options.allowEmptyArrays, options.strictNullHandling, options.skipNulls, options.encodeDotInKeys, options.encode ? options.encoder : null, options.filter, options.sort, options.allowDots, options.serializeDate, options.format, options.formatter, options.encodeValuesOnly, options.charset, sideChannel));
    }
    var joined = keys.join(options.delimiter);
    var prefix = options.addQueryPrefix === true ? "?" : "";
    if (options.charsetSentinel) {
        if (options.charset === "iso-8859-1") // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
        prefix += "utf8=%26%2310003%3B&";
        else // encodeURIComponent('✓')
        prefix += "utf8=%E2%9C%93&";
    }
    return joined.length > 0 ? prefix + joined : "";
};


var $475262b20b182e8a$exports = {};
"use strict";

var $475262b20b182e8a$var$has = Object.prototype.hasOwnProperty;
var $475262b20b182e8a$var$isArray = Array.isArray;
var $475262b20b182e8a$var$defaults = {
    allowDots: false,
    allowEmptyArrays: false,
    allowPrototypes: false,
    allowSparse: false,
    arrayLimit: 20,
    charset: "utf-8",
    charsetSentinel: false,
    comma: false,
    decodeDotInKeys: false,
    decoder: $c85add9d1ad9ea0b$exports.decode,
    delimiter: "&",
    depth: 5,
    duplicates: "combine",
    ignoreQueryPrefix: false,
    interpretNumericEntities: false,
    parameterLimit: 1000,
    parseArrays: true,
    plainObjects: false,
    strictDepth: false,
    strictNullHandling: false
};
var $475262b20b182e8a$var$interpretNumericEntities = function(str) {
    return str.replace(/&#(\d+);/g, function($0, numberStr) {
        return String.fromCharCode(parseInt(numberStr, 10));
    });
};
var $475262b20b182e8a$var$parseArrayValue = function(val, options) {
    if (val && typeof val === "string" && options.comma && val.indexOf(",") > -1) return val.split(",");
    return val;
};
// This is what browsers will submit when the ✓ character occurs in an
// application/x-www-form-urlencoded body and the encoding of the page containing
// the form is iso-8859-1, or when the submitted form has an accept-charset
// attribute of iso-8859-1. Presumably also with other charsets that do not contain
// the ✓ character, such as us-ascii.
var $475262b20b182e8a$var$isoSentinel = "utf8=%26%2310003%3B"; // encodeURIComponent('&#10003;')
// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
var $475262b20b182e8a$var$charsetSentinel = "utf8=%E2%9C%93"; // encodeURIComponent('✓')
var $475262b20b182e8a$var$parseValues = function parseQueryStringValues(str, options) {
    var obj = {
        __proto__: null
    };
    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, "") : str;
    cleanStr = cleanStr.replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    var limit = options.parameterLimit === Infinity ? undefined : options.parameterLimit;
    var parts = cleanStr.split(options.delimiter, limit);
    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
    var i;
    var charset = options.charset;
    if (options.charsetSentinel) {
        for(i = 0; i < parts.length; ++i)if (parts[i].indexOf("utf8=") === 0) {
            if (parts[i] === $475262b20b182e8a$var$charsetSentinel) charset = "utf-8";
            else if (parts[i] === $475262b20b182e8a$var$isoSentinel) charset = "iso-8859-1";
            skipIndex = i;
            i = parts.length; // The eslint settings do not allow break;
        }
    }
    for(i = 0; i < parts.length; ++i){
        if (i === skipIndex) continue;
        var part = parts[i];
        var bracketEqualsPos = part.indexOf("]=");
        var pos = bracketEqualsPos === -1 ? part.indexOf("=") : bracketEqualsPos + 1;
        var key, val;
        if (pos === -1) {
            key = options.decoder(part, $475262b20b182e8a$var$defaults.decoder, charset, "key");
            val = options.strictNullHandling ? null : "";
        } else {
            key = options.decoder(part.slice(0, pos), $475262b20b182e8a$var$defaults.decoder, charset, "key");
            val = $c85add9d1ad9ea0b$exports.maybeMap($475262b20b182e8a$var$parseArrayValue(part.slice(pos + 1), options), function(encodedVal) {
                return options.decoder(encodedVal, $475262b20b182e8a$var$defaults.decoder, charset, "value");
            });
        }
        if (val && options.interpretNumericEntities && charset === "iso-8859-1") val = $475262b20b182e8a$var$interpretNumericEntities(val);
        if (part.indexOf("[]=") > -1) val = $475262b20b182e8a$var$isArray(val) ? [
            val
        ] : val;
        var existing = $475262b20b182e8a$var$has.call(obj, key);
        if (existing && options.duplicates === "combine") obj[key] = $c85add9d1ad9ea0b$exports.combine(obj[key], val);
        else if (!existing || options.duplicates === "last") obj[key] = val;
    }
    return obj;
};
var $475262b20b182e8a$var$parseObject = function(chain, val, options, valuesParsed) {
    var leaf = valuesParsed ? val : $475262b20b182e8a$var$parseArrayValue(val, options);
    for(var i = chain.length - 1; i >= 0; --i){
        var obj;
        var root = chain[i];
        if (root === "[]" && options.parseArrays) obj = options.allowEmptyArrays && (leaf === "" || options.strictNullHandling && leaf === null) ? [] : [].concat(leaf);
        else {
            obj = options.plainObjects ? Object.create(null) : {};
            var cleanRoot = root.charAt(0) === "[" && root.charAt(root.length - 1) === "]" ? root.slice(1, -1) : root;
            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, ".") : cleanRoot;
            var index = parseInt(decodedRoot, 10);
            if (!options.parseArrays && decodedRoot === "") obj = {
                0: leaf
            };
            else if (!isNaN(index) && root !== decodedRoot && String(index) === decodedRoot && index >= 0 && options.parseArrays && index <= options.arrayLimit) {
                obj = [];
                obj[index] = leaf;
            } else if (decodedRoot !== "__proto__") obj[decodedRoot] = leaf;
        }
        leaf = obj;
    }
    return leaf;
};
var $475262b20b182e8a$var$parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
    if (!givenKey) return;
    // Transform dot notation to bracket notation
    var key = options.allowDots ? givenKey.replace(/\.([^.[]+)/g, "[$1]") : givenKey;
    // The regex chunks
    var brackets = /(\[[^[\]]*])/;
    var child = /(\[[^[\]]*])/g;
    // Get the parent
    var segment = options.depth > 0 && brackets.exec(key);
    var parent = segment ? key.slice(0, segment.index) : key;
    // Stash the parent if it exists
    var keys = [];
    if (parent) {
        // If we aren't using plain objects, optionally prefix keys that would overwrite object prototype properties
        if (!options.plainObjects && $475262b20b182e8a$var$has.call(Object.prototype, parent)) {
            if (!options.allowPrototypes) return;
        }
        keys.push(parent);
    }
    // Loop through children appending to the array until we hit depth
    var i = 0;
    while(options.depth > 0 && (segment = child.exec(key)) !== null && i < options.depth){
        i += 1;
        if (!options.plainObjects && $475262b20b182e8a$var$has.call(Object.prototype, segment[1].slice(1, -1))) {
            if (!options.allowPrototypes) return;
        }
        keys.push(segment[1]);
    }
    // If there's a remainder, check strictDepth option for throw, else just add whatever is left
    if (segment) {
        if (options.strictDepth === true) throw new RangeError("Input depth exceeded depth option of " + options.depth + " and strictDepth is true");
        keys.push("[" + key.slice(segment.index) + "]");
    }
    return $475262b20b182e8a$var$parseObject(keys, val, options, valuesParsed);
};
var $475262b20b182e8a$var$normalizeParseOptions = function normalizeParseOptions(opts) {
    if (!opts) return $475262b20b182e8a$var$defaults;
    if (typeof opts.allowEmptyArrays !== "undefined" && typeof opts.allowEmptyArrays !== "boolean") throw new TypeError("`allowEmptyArrays` option can only be `true` or `false`, when provided");
    if (typeof opts.decodeDotInKeys !== "undefined" && typeof opts.decodeDotInKeys !== "boolean") throw new TypeError("`decodeDotInKeys` option can only be `true` or `false`, when provided");
    if (opts.decoder !== null && typeof opts.decoder !== "undefined" && typeof opts.decoder !== "function") throw new TypeError("Decoder has to be a function.");
    if (typeof opts.charset !== "undefined" && opts.charset !== "utf-8" && opts.charset !== "iso-8859-1") throw new TypeError("The charset option must be either utf-8, iso-8859-1, or undefined");
    var charset = typeof opts.charset === "undefined" ? $475262b20b182e8a$var$defaults.charset : opts.charset;
    var duplicates = typeof opts.duplicates === "undefined" ? $475262b20b182e8a$var$defaults.duplicates : opts.duplicates;
    if (duplicates !== "combine" && duplicates !== "first" && duplicates !== "last") throw new TypeError("The duplicates option must be either combine, first, or last");
    var allowDots = typeof opts.allowDots === "undefined" ? opts.decodeDotInKeys === true ? true : $475262b20b182e8a$var$defaults.allowDots : !!opts.allowDots;
    return {
        allowDots: allowDots,
        allowEmptyArrays: typeof opts.allowEmptyArrays === "boolean" ? !!opts.allowEmptyArrays : $475262b20b182e8a$var$defaults.allowEmptyArrays,
        allowPrototypes: typeof opts.allowPrototypes === "boolean" ? opts.allowPrototypes : $475262b20b182e8a$var$defaults.allowPrototypes,
        allowSparse: typeof opts.allowSparse === "boolean" ? opts.allowSparse : $475262b20b182e8a$var$defaults.allowSparse,
        arrayLimit: typeof opts.arrayLimit === "number" ? opts.arrayLimit : $475262b20b182e8a$var$defaults.arrayLimit,
        charset: charset,
        charsetSentinel: typeof opts.charsetSentinel === "boolean" ? opts.charsetSentinel : $475262b20b182e8a$var$defaults.charsetSentinel,
        comma: typeof opts.comma === "boolean" ? opts.comma : $475262b20b182e8a$var$defaults.comma,
        decodeDotInKeys: typeof opts.decodeDotInKeys === "boolean" ? opts.decodeDotInKeys : $475262b20b182e8a$var$defaults.decodeDotInKeys,
        decoder: typeof opts.decoder === "function" ? opts.decoder : $475262b20b182e8a$var$defaults.decoder,
        delimiter: typeof opts.delimiter === "string" || $c85add9d1ad9ea0b$exports.isRegExp(opts.delimiter) ? opts.delimiter : $475262b20b182e8a$var$defaults.delimiter,
        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
        depth: typeof opts.depth === "number" || opts.depth === false ? +opts.depth : $475262b20b182e8a$var$defaults.depth,
        duplicates: duplicates,
        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
        interpretNumericEntities: typeof opts.interpretNumericEntities === "boolean" ? opts.interpretNumericEntities : $475262b20b182e8a$var$defaults.interpretNumericEntities,
        parameterLimit: typeof opts.parameterLimit === "number" ? opts.parameterLimit : $475262b20b182e8a$var$defaults.parameterLimit,
        parseArrays: opts.parseArrays !== false,
        plainObjects: typeof opts.plainObjects === "boolean" ? opts.plainObjects : $475262b20b182e8a$var$defaults.plainObjects,
        strictDepth: typeof opts.strictDepth === "boolean" ? !!opts.strictDepth : $475262b20b182e8a$var$defaults.strictDepth,
        strictNullHandling: typeof opts.strictNullHandling === "boolean" ? opts.strictNullHandling : $475262b20b182e8a$var$defaults.strictNullHandling
    };
};
$475262b20b182e8a$exports = function(str, opts) {
    var options = $475262b20b182e8a$var$normalizeParseOptions(opts);
    if (str === "" || str === null || typeof str === "undefined") return options.plainObjects ? Object.create(null) : {};
    var tempObj = typeof str === "string" ? $475262b20b182e8a$var$parseValues(str, options) : str;
    var obj = options.plainObjects ? Object.create(null) : {};
    // Iterate over the keys and setup the new object
    var keys = Object.keys(tempObj);
    for(var i = 0; i < keys.length; ++i){
        var key = keys[i];
        var newObj = $475262b20b182e8a$var$parseKeys(key, tempObj[key], options, typeof str === "string");
        obj = $c85add9d1ad9ea0b$exports.merge(obj, newObj, options);
    }
    if (options.allowSparse === true) return obj;
    return $c85add9d1ad9ea0b$exports.compact(obj);
};



$3f999be1dfb2831f$exports = {
    formats: $1765bc49cc17c719$exports,
    parse: $475262b20b182e8a$exports,
    stringify: $c4e00cfde18754db$exports
};



var $fgmOP = parcelRequire("fgmOP");

var $2Ef1X = parcelRequire("2Ef1X");
var $80c508e558e7700f$exports = {};
/*
* loglevel - https://github.com/pimterry/loglevel
*
* Copyright (c) 2013 Tim Perry
* Licensed under the MIT license.
*/ (function(root, definition) {
    "use strict";
    if (typeof define === "function" && define.amd) define(definition);
    else if (0, $80c508e558e7700f$exports) $80c508e558e7700f$exports = definition();
    else root.log = definition();
})($80c508e558e7700f$exports, function() {
    "use strict";
    // Slightly dubious tricks to cut down minimized file size
    var noop = function() {};
    var undefinedType = "undefined";
    var isIE = typeof window !== undefinedType && typeof window.navigator !== undefinedType && /Trident\/|MSIE /.test(window.navigator.userAgent);
    var logMethods = [
        "trace",
        "debug",
        "info",
        "warn",
        "error"
    ];
    var _loggersByName = {};
    var defaultLogger = null;
    // Cross-browser bind equivalent that works at least back to IE6
    function bindMethod(obj, methodName) {
        var method = obj[methodName];
        if (typeof method.bind === "function") return method.bind(obj);
        else try {
            return Function.prototype.bind.call(method, obj);
        } catch (e) {
            // Missing bind shim or IE8 + Modernizr, fallback to wrapping
            return function() {
                return Function.prototype.apply.apply(method, [
                    obj,
                    arguments
                ]);
            };
        }
    }
    // Trace() doesn't print the message in IE, so for that case we need to wrap it
    function traceForIE() {
        if (console.log) {
            if (console.log.apply) console.log.apply(console, arguments);
            else // In old IE, native console methods themselves don't have apply().
            Function.prototype.apply.apply(console.log, [
                console,
                arguments
            ]);
        }
        if (console.trace) console.trace();
    }
    // Build the best logging method possible for this env
    // Wherever possible we want to bind, not wrap, to preserve stack traces
    function realMethod(methodName) {
        if (methodName === "debug") methodName = "log";
        if (typeof console === undefinedType) return false; // No method possible, for now - fixed later by enableLoggingWhenConsoleArrives
        else if (methodName === "trace" && isIE) return traceForIE;
        else if (console[methodName] !== undefined) return bindMethod(console, methodName);
        else if (console.log !== undefined) return bindMethod(console, "log");
        else return noop;
    }
    // These private functions always need `this` to be set properly
    function replaceLoggingMethods() {
        /*jshint validthis:true */ var level = this.getLevel();
        // Replace the actual methods.
        for(var i = 0; i < logMethods.length; i++){
            var methodName = logMethods[i];
            this[methodName] = i < level ? noop : this.methodFactory(methodName, level, this.name);
        }
        // Define log.log as an alias for log.debug
        this.log = this.debug;
        // Return any important warnings.
        if (typeof console === undefinedType && level < this.levels.SILENT) return "No console available for logging";
    }
    // In old IE versions, the console isn't present until you first open it.
    // We build realMethod() replacements here that regenerate logging methods
    function enableLoggingWhenConsoleArrives(methodName) {
        return function() {
            if (typeof console !== undefinedType) {
                replaceLoggingMethods.call(this);
                this[methodName].apply(this, arguments);
            }
        };
    }
    // By default, we use closely bound real methods wherever possible, and
    // otherwise we wait for a console to appear, and then try again.
    function defaultMethodFactory(methodName, _level, _loggerName) {
        /*jshint validthis:true */ return realMethod(methodName) || enableLoggingWhenConsoleArrives.apply(this, arguments);
    }
    function Logger(name, factory) {
        // Private instance variables.
        var self = this;
        /**
       * The level inherited from a parent logger (or a global default). We
       * cache this here rather than delegating to the parent so that it stays
       * in sync with the actual logging methods that we have installed (the
       * parent could change levels but we might not have rebuilt the loggers
       * in this child yet).
       * @type {number}
       */ var inheritedLevel;
        /**
       * The default level for this logger, if any. If set, this overrides
       * `inheritedLevel`.
       * @type {number|null}
       */ var defaultLevel;
        /**
       * A user-specific level for this logger. If set, this overrides
       * `defaultLevel`.
       * @type {number|null}
       */ var userLevel;
        var storageKey = "loglevel";
        if (typeof name === "string") storageKey += ":" + name;
        else if (typeof name === "symbol") storageKey = undefined;
        function persistLevelIfPossible(levelNum) {
            var levelName = (logMethods[levelNum] || "silent").toUpperCase();
            if (typeof window === undefinedType || !storageKey) return;
            // Use localStorage if available
            try {
                window.localStorage[storageKey] = levelName;
                return;
            } catch (ignore) {}
            // Use session cookie as fallback
            try {
                window.document.cookie = encodeURIComponent(storageKey) + "=" + levelName + ";";
            } catch (ignore) {}
        }
        function getPersistedLevel() {
            var storedLevel;
            if (typeof window === undefinedType || !storageKey) return;
            try {
                storedLevel = window.localStorage[storageKey];
            } catch (ignore) {}
            // Fallback to cookies if local storage gives us nothing
            if (typeof storedLevel === undefinedType) try {
                var cookie = window.document.cookie;
                var cookieName = encodeURIComponent(storageKey);
                var location = cookie.indexOf(cookieName + "=");
                if (location !== -1) storedLevel = /^([^;]+)/.exec(cookie.slice(location + cookieName.length + 1))[1];
            } catch (ignore) {}
            // If the stored level is not valid, treat it as if nothing was stored.
            if (self.levels[storedLevel] === undefined) storedLevel = undefined;
            return storedLevel;
        }
        function clearPersistedLevel() {
            if (typeof window === undefinedType || !storageKey) return;
            // Use localStorage if available
            try {
                window.localStorage.removeItem(storageKey);
            } catch (ignore) {}
            // Use session cookie as fallback
            try {
                window.document.cookie = encodeURIComponent(storageKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC";
            } catch (ignore) {}
        }
        function normalizeLevel(input) {
            var level = input;
            if (typeof level === "string" && self.levels[level.toUpperCase()] !== undefined) level = self.levels[level.toUpperCase()];
            if (typeof level === "number" && level >= 0 && level <= self.levels.SILENT) return level;
            else throw new TypeError("log.setLevel() called with invalid level: " + input);
        }
        /*
       *
       * Public logger API - see https://github.com/pimterry/loglevel for details
       *
       */ self.name = name;
        self.levels = {
            "TRACE": 0,
            "DEBUG": 1,
            "INFO": 2,
            "WARN": 3,
            "ERROR": 4,
            "SILENT": 5
        };
        self.methodFactory = factory || defaultMethodFactory;
        self.getLevel = function() {
            if (userLevel != null) return userLevel;
            else if (defaultLevel != null) return defaultLevel;
            else return inheritedLevel;
        };
        self.setLevel = function(level, persist) {
            userLevel = normalizeLevel(level);
            if (persist !== false) persistLevelIfPossible(userLevel);
            // NOTE: in v2, this should call rebuild(), which updates children.
            return replaceLoggingMethods.call(self);
        };
        self.setDefaultLevel = function(level) {
            defaultLevel = normalizeLevel(level);
            if (!getPersistedLevel()) self.setLevel(level, false);
        };
        self.resetLevel = function() {
            userLevel = null;
            clearPersistedLevel();
            replaceLoggingMethods.call(self);
        };
        self.enableAll = function(persist) {
            self.setLevel(self.levels.TRACE, persist);
        };
        self.disableAll = function(persist) {
            self.setLevel(self.levels.SILENT, persist);
        };
        self.rebuild = function() {
            if (defaultLogger !== self) inheritedLevel = normalizeLevel(defaultLogger.getLevel());
            replaceLoggingMethods.call(self);
            if (defaultLogger === self) for(var childName in _loggersByName)_loggersByName[childName].rebuild();
        };
        // Initialize all the internal levels.
        inheritedLevel = normalizeLevel(defaultLogger ? defaultLogger.getLevel() : "WARN");
        var initialLevel = getPersistedLevel();
        if (initialLevel != null) userLevel = normalizeLevel(initialLevel);
        replaceLoggingMethods.call(self);
    }
    /*
     *
     * Top-level API
     *
     */ defaultLogger = new Logger();
    defaultLogger.getLogger = function getLogger(name) {
        if (typeof name !== "symbol" && typeof name !== "string" || name === "") throw new TypeError("You must supply a name when creating a logger.");
        var logger = _loggersByName[name];
        if (!logger) logger = _loggersByName[name] = new Logger(name, defaultLogger.methodFactory);
        return logger;
    };
    // Grab the current global log variable in case of overwrite
    var _log = typeof window !== undefinedType ? window.log : undefined;
    defaultLogger.noConflict = function() {
        if (typeof window !== undefinedType && window.log === defaultLogger) window.log = _log;
        return defaultLogger;
    };
    defaultLogger.getLoggers = function getLoggers() {
        return _loggersByName;
    };
    // ES6 default export, for compatibility
    defaultLogger["default"] = defaultLogger;
    return defaultLogger;
});


var $9ba563f072652073$exports = {};
(function(root, factory) {
    if (typeof define === "function" && define.amd) define(factory);
    else if (0, $9ba563f072652073$exports) $9ba563f072652073$exports = factory();
    else root.prefix = factory(root);
})($9ba563f072652073$exports, function(root) {
    "use strict";
    var merge = function(target) {
        var i = 1;
        var length = arguments.length;
        var key;
        for(; i < length; i++){
            for(key in arguments[i])if (Object.prototype.hasOwnProperty.call(arguments[i], key)) target[key] = arguments[i][key];
        }
        return target;
    };
    var defaults = {
        template: "[%t] %l:",
        levelFormatter: function(level) {
            return level.toUpperCase();
        },
        nameFormatter: function(name) {
            return name || "root";
        },
        timestampFormatter: function(date) {
            return date.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, "$1");
        },
        format: undefined
    };
    var loglevel;
    var configs = {};
    var reg = function(rootLogger) {
        if (!rootLogger || !rootLogger.getLogger) throw new TypeError("Argument is not a root logger");
        loglevel = rootLogger;
    };
    var apply = function(logger, config) {
        if (!logger || !logger.setLevel) throw new TypeError("Argument is not a logger");
        /* eslint-disable vars-on-top */ var originalFactory = logger.methodFactory;
        var name = logger.name || "";
        var parent = configs[name] || configs[""] || defaults;
        /* eslint-enable vars-on-top */ function methodFactory(methodName, logLevel, loggerName) {
            var originalMethod = originalFactory(methodName, logLevel, loggerName);
            var options = configs[loggerName] || configs[""];
            var hasTimestamp = options.template.indexOf("%t") !== -1;
            var hasLevel = options.template.indexOf("%l") !== -1;
            var hasName = options.template.indexOf("%n") !== -1;
            return function() {
                var content = "";
                var length = arguments.length;
                var args = Array(length);
                var key = 0;
                for(; key < length; key++)args[key] = arguments[key];
                // skip the root method for child loggers to prevent duplicate logic
                if (name || !configs[loggerName]) {
                    /* eslint-disable vars-on-top */ var timestamp = options.timestampFormatter(new Date());
                    var level = options.levelFormatter(methodName);
                    var lname = options.nameFormatter(loggerName);
                    /* eslint-enable vars-on-top */ if (options.format) content += options.format(level, lname, timestamp);
                    else {
                        content += options.template;
                        if (hasTimestamp) content = content.replace(/%t/, timestamp);
                        if (hasLevel) content = content.replace(/%l/, level);
                        if (hasName) content = content.replace(/%n/, lname);
                    }
                    if (args.length && typeof args[0] === "string") // concat prefix with first argument to support string substitutions
                    args[0] = content + " " + args[0];
                    else args.unshift(content);
                }
                originalMethod.apply(undefined, args);
            };
        }
        if (!configs[name]) logger.methodFactory = methodFactory;
        // for remove inherited format option if template option preset
        config = config || {};
        if (config.template) config.format = undefined;
        configs[name] = merge({}, parent, config);
        logger.setLevel(logger.getLevel());
        if (!loglevel) logger.warn("It is necessary to call the function reg() of loglevel-plugin-prefix before calling apply. From the next release, it will throw an error. See more: https://github.com/kutuluk/loglevel-plugin-prefix/blob/master/README.md");
        return logger;
    };
    var api = {
        reg: reg,
        apply: apply
    };
    var save;
    if (root) {
        save = root.prefix;
        api.noConflict = function() {
            if (root.prefix === api) root.prefix = save;
            return api;
        };
    }
    return api;
});


var $fa137ffb757be904$exports = {};

$parcel$export($fa137ffb757be904$exports, "Integrations", function () { return $fa137ffb757be904$export$99d02219d259eb94; });
$parcel$export($fa137ffb757be904$exports, "Transports", function () { return $7d1d902002dd1b2c$exports; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $90104860b1e5ba1f$var$extendStatics = function(d, b) {
    $90104860b1e5ba1f$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $90104860b1e5ba1f$var$extendStatics(d, b);
};
function $90104860b1e5ba1f$export$a8ba968b8961cb8a(d, b) {
    $90104860b1e5ba1f$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $90104860b1e5ba1f$export$18ce0697a983be9b = function() {
    $90104860b1e5ba1f$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $90104860b1e5ba1f$export$18ce0697a983be9b.apply(this, arguments);
};
function $90104860b1e5ba1f$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $90104860b1e5ba1f$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $90104860b1e5ba1f$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $90104860b1e5ba1f$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $90104860b1e5ba1f$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $90104860b1e5ba1f$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $90104860b1e5ba1f$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $90104860b1e5ba1f$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $90104860b1e5ba1f$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $90104860b1e5ba1f$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $90104860b1e5ba1f$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($90104860b1e5ba1f$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $90104860b1e5ba1f$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $90104860b1e5ba1f$export$10c90e4f7922046c(v) {
    return this instanceof $90104860b1e5ba1f$export$10c90e4f7922046c ? (this.v = v, this) : new $90104860b1e5ba1f$export$10c90e4f7922046c(v);
}
function $90104860b1e5ba1f$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $90104860b1e5ba1f$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $90104860b1e5ba1f$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $90104860b1e5ba1f$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $90104860b1e5ba1f$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $90104860b1e5ba1f$export$19a8beecd37a4c45 === "function" ? $90104860b1e5ba1f$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $90104860b1e5ba1f$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $90104860b1e5ba1f$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $90104860b1e5ba1f$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $90104860b1e5ba1f$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $90104860b1e5ba1f$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $e73707d0761886f3$exports = {};

$parcel$export($e73707d0761886f3$exports, "Severity", function () { return $e91087a6ec178c2a$export$918a9776c0a3cf27; });
$parcel$export($e73707d0761886f3$exports, "Status", function () { return $d7c1b2ac3680a75d$export$96e9906d6d93a972; });
$parcel$export($e73707d0761886f3$exports, "addGlobalEventProcessor", function () { return $3024fb3366777167$export$8e4e25f54d456511; });
$parcel$export($e73707d0761886f3$exports, "addBreadcrumb", function () { return $3ae32034d8d01628$export$efda9a273d7a036d; });
$parcel$export($e73707d0761886f3$exports, "captureException", function () { return $3ae32034d8d01628$export$f5282963edea4a68; });
$parcel$export($e73707d0761886f3$exports, "captureEvent", function () { return $3ae32034d8d01628$export$1462b974fdcf6ba2; });
$parcel$export($e73707d0761886f3$exports, "captureMessage", function () { return $3ae32034d8d01628$export$45654777c133ae80; });
$parcel$export($e73707d0761886f3$exports, "configureScope", function () { return $3ae32034d8d01628$export$99d44f04437e9cb8; });
$parcel$export($e73707d0761886f3$exports, "getHubFromCarrier", function () { return $03b756c195b1c14e$export$bfa8a924a84a76b7; });
$parcel$export($e73707d0761886f3$exports, "getCurrentHub", function () { return $03b756c195b1c14e$export$a07cdf6544bbd7c; });
$parcel$export($e73707d0761886f3$exports, "Hub", function () { return $03b756c195b1c14e$export$8c41bb232f1008b1; });
$parcel$export($e73707d0761886f3$exports, "makeMain", function () { return $03b756c195b1c14e$export$4188a14ad302d1bc; });
$parcel$export($e73707d0761886f3$exports, "Scope", function () { return $3024fb3366777167$export$775b6bb06e53a214; });
$parcel$export($e73707d0761886f3$exports, "startTransaction", function () { return $3ae32034d8d01628$export$e262da7ae6480481; });
$parcel$export($e73707d0761886f3$exports, "setContext", function () { return $3ae32034d8d01628$export$2f04de43fe27971a; });
$parcel$export($e73707d0761886f3$exports, "setExtra", function () { return $3ae32034d8d01628$export$8e8e7789d42ed61d; });
$parcel$export($e73707d0761886f3$exports, "setExtras", function () { return $3ae32034d8d01628$export$bb4922da0dd51b92; });
$parcel$export($e73707d0761886f3$exports, "setTag", function () { return $3ae32034d8d01628$export$a37d07ee78eb4569; });
$parcel$export($e73707d0761886f3$exports, "setTags", function () { return $3ae32034d8d01628$export$74a8fb34822092e6; });
$parcel$export($e73707d0761886f3$exports, "setUser", function () { return $3ae32034d8d01628$export$8b6bb3dd62a01be2; });
$parcel$export($e73707d0761886f3$exports, "withScope", function () { return $3ae32034d8d01628$export$ec58d9285c204497; });
$parcel$export($e73707d0761886f3$exports, "BrowserClient", function () { return $ca591ad9be1bc3ce$export$1df9218a526d318d; });
$parcel$export($e73707d0761886f3$exports, "injectReportDialog", function () { return $0e46104ae750e47a$export$deb9aac8ea0b576c; });
$parcel$export($e73707d0761886f3$exports, "eventFromException", function () { return $c8e7e65862700028$export$ea3ec7e569b823fc; });
$parcel$export($e73707d0761886f3$exports, "eventFromMessage", function () { return $c8e7e65862700028$export$5425b53185d13d6c; });
$parcel$export($e73707d0761886f3$exports, "defaultIntegrations", function () { return $36e1c11cb61404a3$export$5ef831fccfce35e5; });
$parcel$export($e73707d0761886f3$exports, "forceLoad", function () { return $36e1c11cb61404a3$export$a3f323d81eede727; });
$parcel$export($e73707d0761886f3$exports, "init", function () { return $36e1c11cb61404a3$export$2cd8252107eb640b; });
$parcel$export($e73707d0761886f3$exports, "lastEventId", function () { return $36e1c11cb61404a3$export$5d4e9fd7fac8e617; });
$parcel$export($e73707d0761886f3$exports, "onLoad", function () { return $36e1c11cb61404a3$export$4e4d8b287d028b6b; });
$parcel$export($e73707d0761886f3$exports, "showReportDialog", function () { return $36e1c11cb61404a3$export$3a8fd680da42627b; });
$parcel$export($e73707d0761886f3$exports, "flush", function () { return $36e1c11cb61404a3$export$4909b86c8034bf73; });
$parcel$export($e73707d0761886f3$exports, "close", function () { return $36e1c11cb61404a3$export$8360e631d277ea4d; });
$parcel$export($e73707d0761886f3$exports, "wrap", function () { return $36e1c11cb61404a3$export$4997ffc0176396a6; });
$parcel$export($e73707d0761886f3$exports, "SDK_NAME", function () { return $a676a26e652fd720$export$ca61d37259221480; });
$parcel$export($e73707d0761886f3$exports, "SDK_VERSION", function () { return $a676a26e652fd720$export$31499a9cd224b78c; });
/** JSDoc */ // eslint-disable-next-line import/export
var $e91087a6ec178c2a$export$918a9776c0a3cf27;
(function(Severity) {
    /** JSDoc */ Severity["Fatal"] = "fatal";
    /** JSDoc */ Severity["Error"] = "error";
    /** JSDoc */ Severity["Warning"] = "warning";
    /** JSDoc */ Severity["Log"] = "log";
    /** JSDoc */ Severity["Info"] = "info";
    /** JSDoc */ Severity["Debug"] = "debug";
    /** JSDoc */ Severity["Critical"] = "critical";
})($e91087a6ec178c2a$export$918a9776c0a3cf27 || ($e91087a6ec178c2a$export$918a9776c0a3cf27 = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
(function(Severity) {
    /**
     * Converts a string-based level into a {@link Severity}.
     *
     * @param level string representation of Severity
     * @returns Severity
     */ function fromString(level) {
        switch(level){
            case "debug":
                return Severity.Debug;
            case "info":
                return Severity.Info;
            case "warn":
            case "warning":
                return Severity.Warning;
            case "error":
                return Severity.Error;
            case "fatal":
                return Severity.Fatal;
            case "critical":
                return Severity.Critical;
            case "log":
            default:
                return Severity.Log;
        }
    }
    Severity.fromString = fromString;
})($e91087a6ec178c2a$export$918a9776c0a3cf27 || ($e91087a6ec178c2a$export$918a9776c0a3cf27 = {}));

/** The status of an event. */ // eslint-disable-next-line import/export
var $d7c1b2ac3680a75d$export$96e9906d6d93a972;
(function(Status) {
    /** The status could not be determined. */ Status["Unknown"] = "unknown";
    /** The event was skipped due to configuration or callbacks. */ Status["Skipped"] = "skipped";
    /** The event was sent to Sentry successfully. */ Status["Success"] = "success";
    /** The client is currently rate limited and will try again later. */ Status["RateLimit"] = "rate_limit";
    /** The event could not be processed. */ Status["Invalid"] = "invalid";
    /** A server-side error ocurred during submission. */ Status["Failed"] = "failed";
})($d7c1b2ac3680a75d$export$96e9906d6d93a972 || ($d7c1b2ac3680a75d$export$96e9906d6d93a972 = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace, import/export
(function(Status) {
    /**
     * Converts a HTTP status code into a {@link Status}.
     *
     * @param code The HTTP response status code.
     * @returns The send status or {@link Status.Unknown}.
     */ function fromHttpCode(code) {
        if (code >= 200 && code < 300) return Status.Success;
        if (code === 429) return Status.RateLimit;
        if (code >= 400 && code < 500) return Status.Invalid;
        if (code >= 500) return Status.Failed;
        return Status.Unknown;
    }
    Status.fromHttpCode = fromHttpCode;
})($d7c1b2ac3680a75d$export$96e9906d6d93a972 || ($d7c1b2ac3680a75d$export$96e9906d6d93a972 = {}));


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $e05aea38cf8cebea$var$extendStatics = function(d, b) {
    $e05aea38cf8cebea$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $e05aea38cf8cebea$var$extendStatics(d, b);
};
function $e05aea38cf8cebea$export$a8ba968b8961cb8a(d, b) {
    $e05aea38cf8cebea$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $e05aea38cf8cebea$export$18ce0697a983be9b = function() {
    $e05aea38cf8cebea$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e05aea38cf8cebea$export$18ce0697a983be9b.apply(this, arguments);
};
function $e05aea38cf8cebea$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $e05aea38cf8cebea$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $e05aea38cf8cebea$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $e05aea38cf8cebea$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $e05aea38cf8cebea$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $e05aea38cf8cebea$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $e05aea38cf8cebea$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $e05aea38cf8cebea$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $e05aea38cf8cebea$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $e05aea38cf8cebea$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $e05aea38cf8cebea$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($e05aea38cf8cebea$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $e05aea38cf8cebea$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $e05aea38cf8cebea$export$10c90e4f7922046c(v) {
    return this instanceof $e05aea38cf8cebea$export$10c90e4f7922046c ? (this.v = v, this) : new $e05aea38cf8cebea$export$10c90e4f7922046c(v);
}
function $e05aea38cf8cebea$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $e05aea38cf8cebea$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $e05aea38cf8cebea$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $e05aea38cf8cebea$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $e05aea38cf8cebea$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $e05aea38cf8cebea$export$19a8beecd37a4c45 === "function" ? $e05aea38cf8cebea$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $e05aea38cf8cebea$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $e05aea38cf8cebea$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $e05aea38cf8cebea$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $e05aea38cf8cebea$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $e05aea38cf8cebea$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $779119c643ee07b9$var$extendStatics = function(d, b) {
    $779119c643ee07b9$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $779119c643ee07b9$var$extendStatics(d, b);
};
function $779119c643ee07b9$export$a8ba968b8961cb8a(d, b) {
    $779119c643ee07b9$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $779119c643ee07b9$export$18ce0697a983be9b = function() {
    $779119c643ee07b9$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $779119c643ee07b9$export$18ce0697a983be9b.apply(this, arguments);
};
function $779119c643ee07b9$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $779119c643ee07b9$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $779119c643ee07b9$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $779119c643ee07b9$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $779119c643ee07b9$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $779119c643ee07b9$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $779119c643ee07b9$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $779119c643ee07b9$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $779119c643ee07b9$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $779119c643ee07b9$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $779119c643ee07b9$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($779119c643ee07b9$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $779119c643ee07b9$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $779119c643ee07b9$export$10c90e4f7922046c(v) {
    return this instanceof $779119c643ee07b9$export$10c90e4f7922046c ? (this.v = v, this) : new $779119c643ee07b9$export$10c90e4f7922046c(v);
}
function $779119c643ee07b9$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $779119c643ee07b9$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $779119c643ee07b9$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $779119c643ee07b9$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $779119c643ee07b9$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $779119c643ee07b9$export$19a8beecd37a4c45 === "function" ? $779119c643ee07b9$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $779119c643ee07b9$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $779119c643ee07b9$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $779119c643ee07b9$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $779119c643ee07b9$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $779119c643ee07b9$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}


var $0380f4dfca04813d$exports = {};
$parcel$export($0380f4dfca04813d$exports, "htmlTreeAsString", function () { return (parcelRequire("gwbjx")).htmlTreeAsString; });
$parcel$export($0380f4dfca04813d$exports, "Dsn", function () { return $197b30967960013f$export$aff37ac2a8ccf4dc; });
$parcel$export($0380f4dfca04813d$exports, "SentryError", function () { return $4e775f3b83c72383$export$5949942ba2a7c0e2; });
$parcel$export($0380f4dfca04813d$exports, "addInstrumentationHandler", function () { return $3e55b6c60c4dfa3b$export$285b9172a3741fb7; });
$parcel$export($0380f4dfca04813d$exports, "isDOMError", function () { return (parcelRequire("jNciV")).isDOMError; });
$parcel$export($0380f4dfca04813d$exports, "isDOMException", function () { return (parcelRequire("jNciV")).isDOMException; });
$parcel$export($0380f4dfca04813d$exports, "isError", function () { return (parcelRequire("jNciV")).isError; });
$parcel$export($0380f4dfca04813d$exports, "isErrorEvent", function () { return (parcelRequire("jNciV")).isErrorEvent; });
$parcel$export($0380f4dfca04813d$exports, "isEvent", function () { return (parcelRequire("jNciV")).isEvent; });
$parcel$export($0380f4dfca04813d$exports, "isInstanceOf", function () { return (parcelRequire("jNciV")).isInstanceOf; });
$parcel$export($0380f4dfca04813d$exports, "isPlainObject", function () { return (parcelRequire("jNciV")).isPlainObject; });
$parcel$export($0380f4dfca04813d$exports, "isPrimitive", function () { return (parcelRequire("jNciV")).isPrimitive; });
$parcel$export($0380f4dfca04813d$exports, "isString", function () { return (parcelRequire("jNciV")).isString; });
$parcel$export($0380f4dfca04813d$exports, "isThenable", function () { return (parcelRequire("jNciV")).isThenable; });
$parcel$export($0380f4dfca04813d$exports, "logger", function () { return $ac919b34c52e6588$export$af88d00dbe7f521; });
$parcel$export($0380f4dfca04813d$exports, "addExceptionMechanism", function () { return (parcelRequire("byuqS")).addExceptionMechanism; });
$parcel$export($0380f4dfca04813d$exports, "addExceptionTypeValue", function () { return (parcelRequire("byuqS")).addExceptionTypeValue; });
$parcel$export($0380f4dfca04813d$exports, "consoleSandbox", function () { return (parcelRequire("byuqS")).consoleSandbox; });
$parcel$export($0380f4dfca04813d$exports, "getEventDescription", function () { return (parcelRequire("byuqS")).getEventDescription; });
$parcel$export($0380f4dfca04813d$exports, "getGlobalObject", function () { return (parcelRequire("byuqS")).getGlobalObject; });
$parcel$export($0380f4dfca04813d$exports, "getLocationHref", function () { return (parcelRequire("byuqS")).getLocationHref; });
$parcel$export($0380f4dfca04813d$exports, "parseRetryAfterHeader", function () { return (parcelRequire("byuqS")).parseRetryAfterHeader; });
$parcel$export($0380f4dfca04813d$exports, "parseUrl", function () { return (parcelRequire("byuqS")).parseUrl; });
$parcel$export($0380f4dfca04813d$exports, "uuid4", function () { return (parcelRequire("byuqS")).uuid4; });
$parcel$export($0380f4dfca04813d$exports, "dropUndefinedKeys", function () { return (parcelRequire("hKTDd")).dropUndefinedKeys; });
$parcel$export($0380f4dfca04813d$exports, "extractExceptionKeysForMessage", function () { return (parcelRequire("hKTDd")).extractExceptionKeysForMessage; });
$parcel$export($0380f4dfca04813d$exports, "fill", function () { return (parcelRequire("hKTDd")).fill; });
$parcel$export($0380f4dfca04813d$exports, "normalize", function () { return (parcelRequire("hKTDd")).normalize; });
$parcel$export($0380f4dfca04813d$exports, "normalizeToSize", function () { return (parcelRequire("hKTDd")).normalizeToSize; });
$parcel$export($0380f4dfca04813d$exports, "urlEncode", function () { return (parcelRequire("hKTDd")).urlEncode; });
$parcel$export($0380f4dfca04813d$exports, "PromiseBuffer", function () { return $a0901ab61ea7e06d$export$9a81892395957e9f; });
$parcel$export($0380f4dfca04813d$exports, "getFunctionName", function () { return (parcelRequire("eHZGJ")).getFunctionName; });
$parcel$export($0380f4dfca04813d$exports, "isMatchingPattern", function () { return (parcelRequire("aVWL9")).isMatchingPattern; });
$parcel$export($0380f4dfca04813d$exports, "safeJoin", function () { return (parcelRequire("aVWL9")).safeJoin; });
$parcel$export($0380f4dfca04813d$exports, "truncate", function () { return (parcelRequire("aVWL9")).truncate; });
$parcel$export($0380f4dfca04813d$exports, "supportsFetch", function () { return $d3659c5e6757ce18$export$edf3cb81fd7d2a3e; });
$parcel$export($0380f4dfca04813d$exports, "supportsReferrerPolicy", function () { return $d3659c5e6757ce18$export$2d308b428295192f; });
$parcel$export($0380f4dfca04813d$exports, "SyncPromise", function () { return $6e504369e1fed547$export$6f292d4960313241; });

parcelRequire("gwbjx");

var $aDdG9 = parcelRequire("aDdG9");

var $aDdG9 = parcelRequire("aDdG9");
var $4da9fed56ccafaf1$export$1cb0d91350beb6cc = Object.setPrototypeOf || (({
    __proto__: []
}) instanceof Array ? $4da9fed56ccafaf1$var$setProtoOf : $4da9fed56ccafaf1$var$mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $4da9fed56ccafaf1$var$setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $4da9fed56ccafaf1$var$mixinProperties(obj, proto) {
    for(var prop in proto)// eslint-disable-next-line no-prototype-builtins
    if (!obj.hasOwnProperty(prop)) // @ts-ignore typescript complains about indexing so we remove
    obj[prop] = proto[prop];
    return obj;
}


/** An error emitted by Sentry SDKs and related utilities. */ var $4e775f3b83c72383$export$5949942ba2a7c0e2 = /** @class */ function(_super) {
    (0, $aDdG9.__extends)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        (0, $4da9fed56ccafaf1$export$1cb0d91350beb6cc)(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error);


/** Regular expression used to parse a Dsn. */ var $197b30967960013f$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
/** Error message */ var $197b30967960013f$var$ERROR_MESSAGE = "Invalid Dsn";
/** The Sentry Dsn, identifying a Sentry instance and project. */ var $197b30967960013f$export$aff37ac2a8ccf4dc = /** @class */ function() {
    /** Creates a new Dsn component */ function Dsn(from) {
        if (typeof from === "string") this._fromString(from);
        else this._fromComponents(from);
        this._validate();
    }
    /**
     * Renders the string representation of this Dsn.
     *
     * By default, this will render the public representation without the password
     * component. To get the deprecated private representation, set `withPassword`
     * to true.
     *
     * @param withPassword When set to true, the password will be included.
     */ Dsn.prototype.toString = function(withPassword) {
        if (withPassword === void 0) withPassword = false;
        var _a = this, host = _a.host, path = _a.path, pass = _a.pass, port = _a.port, projectId = _a.projectId, protocol = _a.protocol, user = _a.user;
        return protocol + "://" + user + (withPassword && pass ? ":" + pass : "") + ("@" + host + (port ? ":" + port : "") + "/" + (path ? path + "/" : path) + projectId);
    };
    /** Parses a string into this Dsn. */ Dsn.prototype._fromString = function(str) {
        var match = $197b30967960013f$var$DSN_REGEX.exec(str);
        if (!match) throw new (0, $4e775f3b83c72383$export$5949942ba2a7c0e2)($197b30967960013f$var$ERROR_MESSAGE);
        var _a = (0, $aDdG9.__read)(match.slice(1), 6), protocol = _a[0], user = _a[1], _b = _a[2], pass = _b === void 0 ? "" : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? "" : _c, lastPath = _a[5];
        var path = "";
        var projectId = lastPath;
        var split = projectId.split("/");
        if (split.length > 1) {
            path = split.slice(0, -1).join("/");
            projectId = split.pop();
        }
        if (projectId) {
            var projectMatch = projectId.match(/^\d+/);
            if (projectMatch) projectId = projectMatch[0];
        }
        this._fromComponents({
            host: host,
            pass: pass,
            path: path,
            projectId: projectId,
            port: port,
            protocol: protocol,
            user: user
        });
    };
    /** Maps Dsn components into this instance. */ Dsn.prototype._fromComponents = function(components) {
        this.protocol = components.protocol;
        this.user = components.user;
        this.pass = components.pass || "";
        this.host = components.host;
        this.port = components.port || "";
        this.path = components.path || "";
        this.projectId = components.projectId;
    };
    /** Validates this Dsn and throws on error. */ Dsn.prototype._validate = function() {
        var _this = this;
        [
            "protocol",
            "user",
            "host",
            "projectId"
        ].forEach(function(component) {
            if (!_this[component]) throw new (0, $4e775f3b83c72383$export$5949942ba2a7c0e2)($197b30967960013f$var$ERROR_MESSAGE + ": " + component + " missing");
        });
        if (!this.projectId.match(/^\d+$/)) throw new (0, $4e775f3b83c72383$export$5949942ba2a7c0e2)($197b30967960013f$var$ERROR_MESSAGE + ": Invalid projectId " + this.projectId);
        if (this.protocol !== "http" && this.protocol !== "https") throw new (0, $4e775f3b83c72383$export$5949942ba2a7c0e2)($197b30967960013f$var$ERROR_MESSAGE + ": Invalid protocol " + this.protocol);
        if (this.port && isNaN(parseInt(this.port, 10))) throw new (0, $4e775f3b83c72383$export$5949942ba2a7c0e2)($197b30967960013f$var$ERROR_MESSAGE + ": Invalid port " + this.port);
    };
    return Dsn;
}();




var $aDdG9 = parcelRequire("aDdG9");

var $jNciV = parcelRequire("jNciV");
/* eslint-disable @typescript-eslint/no-explicit-any */ 
var $byuqS = parcelRequire("byuqS");
// TODO: Implement different loggers for different environments
var $ac919b34c52e6588$var$global = (0, $byuqS.getGlobalObject)();
/** Prefix for logging strings */ var $ac919b34c52e6588$var$PREFIX = "Sentry Logger ";
/** JSDoc */ var $ac919b34c52e6588$var$Logger = /** @class */ function() {
    /** JSDoc */ function Logger() {
        this._enabled = false;
    }
    /** JSDoc */ Logger.prototype.disable = function() {
        this._enabled = false;
    };
    /** JSDoc */ Logger.prototype.enable = function() {
        this._enabled = true;
    };
    /** JSDoc */ Logger.prototype.log = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!this._enabled) return;
        (0, $byuqS.consoleSandbox)(function() {
            $ac919b34c52e6588$var$global.console.log($ac919b34c52e6588$var$PREFIX + "[Log]: " + args.join(" "));
        });
    };
    /** JSDoc */ Logger.prototype.warn = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!this._enabled) return;
        (0, $byuqS.consoleSandbox)(function() {
            $ac919b34c52e6588$var$global.console.warn($ac919b34c52e6588$var$PREFIX + "[Warn]: " + args.join(" "));
        });
    };
    /** JSDoc */ Logger.prototype.error = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        if (!this._enabled) return;
        (0, $byuqS.consoleSandbox)(function() {
            $ac919b34c52e6588$var$global.console.error($ac919b34c52e6588$var$PREFIX + "[Error]: " + args.join(" "));
        });
    };
    return Logger;
}();
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
$ac919b34c52e6588$var$global.__SENTRY__ = $ac919b34c52e6588$var$global.__SENTRY__ || {};
var $ac919b34c52e6588$export$af88d00dbe7f521 = $ac919b34c52e6588$var$global.__SENTRY__.logger || ($ac919b34c52e6588$var$global.__SENTRY__.logger = new $ac919b34c52e6588$var$Logger());



var $byuqS = parcelRequire("byuqS");

var $hKTDd = parcelRequire("hKTDd");

var $eHZGJ = parcelRequire("eHZGJ");


var $byuqS = parcelRequire("byuqS");
function $d3659c5e6757ce18$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent("");
        return true;
    } catch (e) {
        return false;
    }
}
function $d3659c5e6757ce18$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError("");
        return true;
    } catch (e) {
        return false;
    }
}
function $d3659c5e6757ce18$export$ab12a5d056f1d3a() {
    try {
        new DOMException("");
        return true;
    } catch (e) {
        return false;
    }
}
function $d3659c5e6757ce18$export$edf3cb81fd7d2a3e() {
    if (!("fetch" in (0, $byuqS.getGlobalObject)())) return false;
    try {
        new Headers();
        new Request("");
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $d3659c5e6757ce18$var$isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
function $d3659c5e6757ce18$export$c82d238e23c40b21() {
    if (!$d3659c5e6757ce18$export$edf3cb81fd7d2a3e()) return false;
    var global = (0, $byuqS.getGlobalObject)();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($d3659c5e6757ce18$var$isNativeFetch(global.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") try {
        var sandbox = doc.createElement("iframe");
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $d3659c5e6757ce18$var$isNativeFetch(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $ac919b34c52e6588$export$af88d00dbe7f521).warn("Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ", err);
    }
    return result;
}
function $d3659c5e6757ce18$export$531055a6c684a70a() {
    return "ReportingObserver" in (0, $byuqS.getGlobalObject)();
}
function $d3659c5e6757ce18$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
    // https://caniuse.com/#feat=referrer-policy
    // It doesn't. And it throw exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$d3659c5e6757ce18$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request("_", {
            referrerPolicy: "origin"
        });
        return true;
    } catch (e) {
        return false;
    }
}
function $d3659c5e6757ce18$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = (0, $byuqS.getGlobalObject)();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ var hasHistoryApi = "history" in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}


var $3e55b6c60c4dfa3b$var$global = (0, $byuqS.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ var $3e55b6c60c4dfa3b$var$handlers = {};
var $3e55b6c60c4dfa3b$var$instrumented = {};
/** Instruments given API */ function $3e55b6c60c4dfa3b$var$instrument(type) {
    if ($3e55b6c60c4dfa3b$var$instrumented[type]) return;
    $3e55b6c60c4dfa3b$var$instrumented[type] = true;
    switch(type){
        case "console":
            $3e55b6c60c4dfa3b$var$instrumentConsole();
            break;
        case "dom":
            $3e55b6c60c4dfa3b$var$instrumentDOM();
            break;
        case "xhr":
            $3e55b6c60c4dfa3b$var$instrumentXHR();
            break;
        case "fetch":
            $3e55b6c60c4dfa3b$var$instrumentFetch();
            break;
        case "history":
            $3e55b6c60c4dfa3b$var$instrumentHistory();
            break;
        case "error":
            $3e55b6c60c4dfa3b$var$instrumentError();
            break;
        case "unhandledrejection":
            $3e55b6c60c4dfa3b$var$instrumentUnhandledRejection();
            break;
        default:
            (0, $ac919b34c52e6588$export$af88d00dbe7f521).warn("unknown instrumentation type:", type);
    }
}
function $3e55b6c60c4dfa3b$export$285b9172a3741fb7(handler) {
    if (!handler || typeof handler.type !== "string" || typeof handler.callback !== "function") return;
    $3e55b6c60c4dfa3b$var$handlers[handler.type] = $3e55b6c60c4dfa3b$var$handlers[handler.type] || [];
    $3e55b6c60c4dfa3b$var$handlers[handler.type].push(handler.callback);
    $3e55b6c60c4dfa3b$var$instrument(handler.type);
}
/** JSDoc */ function $3e55b6c60c4dfa3b$var$triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !$3e55b6c60c4dfa3b$var$handlers[type]) return;
    try {
        for(var _b = (0, $aDdG9.__values)($3e55b6c60c4dfa3b$var$handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()){
            var handler = _c.value;
            try {
                handler(data);
            } catch (e) {
                (0, $ac919b34c52e6588$export$af88d00dbe7f521).error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + (0, $eHZGJ.getFunctionName)(handler) + "\nError: " + e);
            }
        }
    } catch (e_1_1) {
        e_1 = {
            error: e_1_1
        };
    } finally{
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        } finally{
            if (e_1) throw e_1.error;
        }
    }
}
/** JSDoc */ function $3e55b6c60c4dfa3b$var$instrumentConsole() {
    if (!("console" in $3e55b6c60c4dfa3b$var$global)) return;
    [
        "debug",
        "info",
        "warn",
        "error",
        "log",
        "assert"
    ].forEach(function(level) {
        if (!(level in $3e55b6c60c4dfa3b$var$global.console)) return;
        (0, $hKTDd.fill)($3e55b6c60c4dfa3b$var$global.console, level, function(originalConsoleLevel) {
            return function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                $3e55b6c60c4dfa3b$var$triggerHandlers("console", {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleLevel) Function.prototype.apply.call(originalConsoleLevel, $3e55b6c60c4dfa3b$var$global.console, args);
            };
        });
    });
}
/** JSDoc */ function $3e55b6c60c4dfa3b$var$instrumentFetch() {
    if (!(0, $d3659c5e6757ce18$export$c82d238e23c40b21)()) return;
    (0, $hKTDd.fill)($3e55b6c60c4dfa3b$var$global, "fetch", function(originalFetch) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var handlerData = {
                args: args,
                fetchData: {
                    method: $3e55b6c60c4dfa3b$var$getFetchMethod(args),
                    url: $3e55b6c60c4dfa3b$var$getFetchUrl(args)
                },
                startTimestamp: Date.now()
            };
            $3e55b6c60c4dfa3b$var$triggerHandlers("fetch", (0, $aDdG9.__assign)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($3e55b6c60c4dfa3b$var$global, args).then(function(response) {
                $3e55b6c60c4dfa3b$var$triggerHandlers("fetch", (0, $aDdG9.__assign)((0, $aDdG9.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    response: response
                }));
                return response;
            }, function(error) {
                $3e55b6c60c4dfa3b$var$triggerHandlers("fetch", (0, $aDdG9.__assign)((0, $aDdG9.__assign)({}, handlerData), {
                    endTimestamp: Date.now(),
                    error: error
                }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /** Extract `method` from fetch call arguments */ function $3e55b6c60c4dfa3b$var$getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if ("Request" in $3e55b6c60c4dfa3b$var$global && (0, $jNciV.isInstanceOf)(fetchArgs[0], Request) && fetchArgs[0].method) return String(fetchArgs[0].method).toUpperCase();
    if (fetchArgs[1] && fetchArgs[1].method) return String(fetchArgs[1].method).toUpperCase();
    return "GET";
}
/** Extract `url` from fetch call arguments */ function $3e55b6c60c4dfa3b$var$getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) fetchArgs = [];
    if (typeof fetchArgs[0] === "string") return fetchArgs[0];
    if ("Request" in $3e55b6c60c4dfa3b$var$global && (0, $jNciV.isInstanceOf)(fetchArgs[0], Request)) return fetchArgs[0].url;
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */ /** JSDoc */ function $3e55b6c60c4dfa3b$var$instrumentXHR() {
    if (!("XMLHttpRequest" in $3e55b6c60c4dfa3b$var$global)) return;
    // Poor man's implementation of ES6 `Map`, tracking and keeping in sync key and value separately.
    var requestKeys = [];
    var requestValues = [];
    var xhrproto = XMLHttpRequest.prototype;
    (0, $hKTDd.fill)(xhrproto, "open", function(originalOpen) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $jNciV.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1]
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $jNciV.isString)(url) && xhr.__sentry_xhr__.method === "POST" && url.match(/sentry_key/)) xhr.__sentry_own_request__ = true;
            var onreadystatechangeHandler = function() {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        if (xhr.__sentry_xhr__) xhr.__sentry_xhr__.status_code = xhr.status;
                    } catch (e) {
                    /* do nothing */ }
                    try {
                        var requestPos = requestKeys.indexOf(xhr);
                        if (requestPos !== -1) {
                            // Make sure to pop both key and value to keep it in sync.
                            requestKeys.splice(requestPos);
                            var args_1 = requestValues.splice(requestPos)[0];
                            if (xhr.__sentry_xhr__ && args_1[0] !== undefined) xhr.__sentry_xhr__.body = args_1[0];
                        }
                    } catch (e) {
                    /* do nothing */ }
                    $3e55b6c60c4dfa3b$var$triggerHandlers("xhr", {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr
                    });
                }
            };
            if ("onreadystatechange" in xhr && typeof xhr.onreadystatechange === "function") (0, $hKTDd.fill)(xhr, "onreadystatechange", function(original) {
                return function() {
                    var readyStateArgs = [];
                    for(var _i = 0; _i < arguments.length; _i++)readyStateArgs[_i] = arguments[_i];
                    onreadystatechangeHandler();
                    return original.apply(xhr, readyStateArgs);
                };
            });
            else xhr.addEventListener("readystatechange", onreadystatechangeHandler);
            return originalOpen.apply(xhr, args);
        };
    });
    (0, $hKTDd.fill)(xhrproto, "send", function(originalSend) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            requestKeys.push(this);
            requestValues.push(args);
            $3e55b6c60c4dfa3b$var$triggerHandlers("xhr", {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
var $3e55b6c60c4dfa3b$var$lastHref;
/** JSDoc */ function $3e55b6c60c4dfa3b$var$instrumentHistory() {
    if (!(0, $d3659c5e6757ce18$export$67fc34576016d6ec)()) return;
    var oldOnPopState = $3e55b6c60c4dfa3b$var$global.onpopstate;
    $3e55b6c60c4dfa3b$var$global.onpopstate = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var to = $3e55b6c60c4dfa3b$var$global.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = $3e55b6c60c4dfa3b$var$lastHref;
        $3e55b6c60c4dfa3b$var$lastHref = to;
        $3e55b6c60c4dfa3b$var$triggerHandlers("history", {
            from: from,
            to: to
        });
        if (oldOnPopState) return oldOnPopState.apply(this, args);
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = $3e55b6c60c4dfa3b$var$lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $3e55b6c60c4dfa3b$var$lastHref = to;
                $3e55b6c60c4dfa3b$var$triggerHandlers("history", {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $hKTDd.fill)($3e55b6c60c4dfa3b$var$global.history, "pushState", historyReplacementFunction);
    (0, $hKTDd.fill)($3e55b6c60c4dfa3b$var$global.history, "replaceState", historyReplacementFunction);
}
/** JSDoc */ function $3e55b6c60c4dfa3b$var$instrumentDOM() {
    if (!("document" in $3e55b6c60c4dfa3b$var$global)) return;
    // Capture breadcrumbs from any click that is unhandled / bubbled up all the way
    // to the document. Do this before we instrument addEventListener.
    $3e55b6c60c4dfa3b$var$global.document.addEventListener("click", $3e55b6c60c4dfa3b$var$domEventHandler("click", $3e55b6c60c4dfa3b$var$triggerHandlers.bind(null, "dom")), false);
    $3e55b6c60c4dfa3b$var$global.document.addEventListener("keypress", $3e55b6c60c4dfa3b$var$keypressEventHandler($3e55b6c60c4dfa3b$var$triggerHandlers.bind(null, "dom")), false);
    // After hooking into document bubbled up click and keypresses events, we also hook into user handled click & keypresses.
    [
        "EventTarget",
        "Node"
    ].forEach(function(target) {
        /* eslint-disable @typescript-eslint/no-unsafe-member-access */ var proto = $3e55b6c60c4dfa3b$var$global[target] && $3e55b6c60c4dfa3b$var$global[target].prototype;
        // eslint-disable-next-line no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        /* eslint-enable @typescript-eslint/no-unsafe-member-access */ (0, $hKTDd.fill)(proto, "addEventListener", function(original) {
            return function(eventName, fn, options) {
                if (fn && fn.handleEvent) {
                    if (eventName === "click") (0, $hKTDd.fill)(fn, "handleEvent", function(innerOriginal) {
                        return function(event) {
                            $3e55b6c60c4dfa3b$var$domEventHandler("click", $3e55b6c60c4dfa3b$var$triggerHandlers.bind(null, "dom"))(event);
                            return innerOriginal.call(this, event);
                        };
                    });
                    if (eventName === "keypress") (0, $hKTDd.fill)(fn, "handleEvent", function(innerOriginal) {
                        return function(event) {
                            $3e55b6c60c4dfa3b$var$keypressEventHandler($3e55b6c60c4dfa3b$var$triggerHandlers.bind(null, "dom"))(event);
                            return innerOriginal.call(this, event);
                        };
                    });
                } else {
                    if (eventName === "click") $3e55b6c60c4dfa3b$var$domEventHandler("click", $3e55b6c60c4dfa3b$var$triggerHandlers.bind(null, "dom"), true)(this);
                    if (eventName === "keypress") $3e55b6c60c4dfa3b$var$keypressEventHandler($3e55b6c60c4dfa3b$var$triggerHandlers.bind(null, "dom"))(this);
                }
                return original.call(this, eventName, fn, options);
            };
        });
        (0, $hKTDd.fill)(proto, "removeEventListener", function(original) {
            return function(eventName, fn, options) {
                try {
                    original.call(this, eventName, fn.__sentry_wrapped__, options);
                } catch (e) {
                // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return original.call(this, eventName, fn, options);
            };
        });
    });
}
var $3e55b6c60c4dfa3b$var$debounceDuration = 1000;
var $3e55b6c60c4dfa3b$var$debounceTimer = 0;
var $3e55b6c60c4dfa3b$var$keypressTimeout;
var $3e55b6c60c4dfa3b$var$lastCapturedEvent;
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param name the event name (e.g. "click")
 * @param handler function that will be triggered
 * @param debounce decides whether it should wait till another event loop
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $3e55b6c60c4dfa3b$var$domEventHandler(name, handler, debounce) {
    if (debounce === void 0) debounce = false;
    return function(event) {
        // reset keypress timeout; e.g. triggering a 'click' after
        // a 'keypress' will reset the keypress debounce so that a new
        // set of keypresses can be recorded
        $3e55b6c60c4dfa3b$var$keypressTimeout = undefined;
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors). Ignore if we've
        // already captured the event.
        if (!event || $3e55b6c60c4dfa3b$var$lastCapturedEvent === event) return;
        $3e55b6c60c4dfa3b$var$lastCapturedEvent = event;
        if ($3e55b6c60c4dfa3b$var$debounceTimer) clearTimeout($3e55b6c60c4dfa3b$var$debounceTimer);
        if (debounce) $3e55b6c60c4dfa3b$var$debounceTimer = setTimeout(function() {
            handler({
                event: event,
                name: name
            });
        });
        else handler({
            event: event,
            name: name
        });
    };
}
/**
 * Wraps addEventListener to capture keypress UI events
 * @param handler function that will be triggered
 * @returns wrapped keypress events handler
 * @hidden
 */ function $3e55b6c60c4dfa3b$var$keypressEventHandler(handler) {
    // TODO: if somehow user switches keypress target before
    //       debounce timeout is triggered, we will only capture
    //       a single breadcrumb from the FIRST target (acceptable?)
    return function(event) {
        var target;
        try {
            target = event.target;
        } catch (e) {
            // just accessing event properties can throw an exception in some rare circumstances
            // see: https://github.com/getsentry/raven-js/issues/838
            return;
        }
        var tagName = target && target.tagName;
        // only consider keypress events on actual input elements
        // this will disregard keypresses targeting body (e.g. tabbing
        // through elements, hotkeys, etc)
        if (!tagName || tagName !== "INPUT" && tagName !== "TEXTAREA" && !target.isContentEditable) return;
        // record first keypress in a series, but ignore subsequent
        // keypresses until debounce clears
        if (!$3e55b6c60c4dfa3b$var$keypressTimeout) $3e55b6c60c4dfa3b$var$domEventHandler("input", handler)(event);
        clearTimeout($3e55b6c60c4dfa3b$var$keypressTimeout);
        $3e55b6c60c4dfa3b$var$keypressTimeout = setTimeout(function() {
            $3e55b6c60c4dfa3b$var$keypressTimeout = undefined;
        }, $3e55b6c60c4dfa3b$var$debounceDuration);
    };
}
var $3e55b6c60c4dfa3b$var$_oldOnErrorHandler = null;
/** JSDoc */ function $3e55b6c60c4dfa3b$var$instrumentError() {
    $3e55b6c60c4dfa3b$var$_oldOnErrorHandler = $3e55b6c60c4dfa3b$var$global.onerror;
    $3e55b6c60c4dfa3b$var$global.onerror = function(msg, url, line, column, error) {
        $3e55b6c60c4dfa3b$var$triggerHandlers("error", {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($3e55b6c60c4dfa3b$var$_oldOnErrorHandler) // eslint-disable-next-line prefer-rest-params
        return $3e55b6c60c4dfa3b$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
}
var $3e55b6c60c4dfa3b$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $3e55b6c60c4dfa3b$var$instrumentUnhandledRejection() {
    $3e55b6c60c4dfa3b$var$_oldOnUnhandledRejectionHandler = $3e55b6c60c4dfa3b$var$global.onunhandledrejection;
    $3e55b6c60c4dfa3b$var$global.onunhandledrejection = function(e) {
        $3e55b6c60c4dfa3b$var$triggerHandlers("unhandledrejection", e);
        if ($3e55b6c60c4dfa3b$var$_oldOnUnhandledRejectionHandler) // eslint-disable-next-line prefer-rest-params
        return $3e55b6c60c4dfa3b$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
}


parcelRequire("jNciV");


parcelRequire("byuqS");

var $hxqGH = parcelRequire("hxqGH");
parcelRequire("hKTDd");


/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/typedef */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ /* eslint-disable @typescript-eslint/no-explicit-any */ 
var $jNciV = parcelRequire("jNciV");
/** SyncPromise internal states */ var $6e504369e1fed547$var$States;
(function(States) {
    /** Pending */ States["PENDING"] = "PENDING";
    /** Resolved / OK */ States["RESOLVED"] = "RESOLVED";
    /** Rejected / Error */ States["REJECTED"] = "REJECTED";
})($6e504369e1fed547$var$States || ($6e504369e1fed547$var$States = {}));
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ var $6e504369e1fed547$export$6f292d4960313241 = /** @class */ function() {
    function SyncPromise(executor) {
        var _this = this;
        this._state = $6e504369e1fed547$var$States.PENDING;
        this._handlers = [];
        /** JSDoc */ this._resolve = function(value) {
            _this._setResult($6e504369e1fed547$var$States.RESOLVED, value);
        };
        /** JSDoc */ this._reject = function(reason) {
            _this._setResult($6e504369e1fed547$var$States.REJECTED, reason);
        };
        /** JSDoc */ this._setResult = function(state, value) {
            if (_this._state !== $6e504369e1fed547$var$States.PENDING) return;
            if ((0, $jNciV.isThenable)(value)) {
                value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        // TODO: FIXME
        /** JSDoc */ this._attachHandler = function(handler) {
            _this._handlers = _this._handlers.concat(handler);
            _this._executeHandlers();
        };
        /** JSDoc */ this._executeHandlers = function() {
            if (_this._state === $6e504369e1fed547$var$States.PENDING) return;
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function(handler) {
                if (handler.done) return;
                if (_this._state === $6e504369e1fed547$var$States.RESOLVED) {
                    if (handler.onfulfilled) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    handler.onfulfilled(_this._value);
                }
                if (_this._state === $6e504369e1fed547$var$States.REJECTED) {
                    if (handler.onrejected) handler.onrejected(_this._value);
                }
                handler.done = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ SyncPromise.resolve = function(value) {
        return new SyncPromise(function(resolve) {
            resolve(value);
        });
    };
    /** JSDoc */ SyncPromise.reject = function(reason) {
        return new SyncPromise(function(_, reject) {
            reject(reason);
        });
    };
    /** JSDoc */ SyncPromise.all = function(collection) {
        return new SyncPromise(function(resolve, reject) {
            if (!Array.isArray(collection)) {
                reject(new TypeError("Promise.all requires an array as input."));
                return;
            }
            if (collection.length === 0) {
                resolve([]);
                return;
            }
            var counter = collection.length;
            var resolvedCollection = [];
            collection.forEach(function(item, index) {
                SyncPromise.resolve(item).then(function(value) {
                    resolvedCollection[index] = value;
                    counter -= 1;
                    if (counter !== 0) return;
                    resolve(resolvedCollection);
                }).then(null, reject);
            });
        });
    };
    /** JSDoc */ SyncPromise.prototype.then = function(onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            _this._attachHandler({
                done: false,
                onfulfilled: function(result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                        return;
                    }
                    try {
                        resolve(onfulfilled(result));
                        return;
                    } catch (e) {
                        reject(e);
                        return;
                    }
                },
                onrejected: function(reason) {
                    if (!onrejected) {
                        reject(reason);
                        return;
                    }
                    try {
                        resolve(onrejected(reason));
                        return;
                    } catch (e) {
                        reject(e);
                        return;
                    }
                }
            });
        });
    };
    /** JSDoc */ SyncPromise.prototype.catch = function(onrejected) {
        return this.then(function(val) {
            return val;
        }, onrejected);
    };
    /** JSDoc */ SyncPromise.prototype.finally = function(onfinally) {
        var _this = this;
        return new SyncPromise(function(resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function(value) {
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, function(reason) {
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(function() {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    /** JSDoc */ SyncPromise.prototype.toString = function() {
        return "[object SyncPromise]";
    };
    return SyncPromise;
}();


/** A simple queue that holds promises. */ var $a0901ab61ea7e06d$export$9a81892395957e9f = /** @class */ function() {
    function PromiseBuffer(_limit) {
        this._limit = _limit;
        /** Internal set of queued Promises */ this._buffer = [];
    }
    /**
     * Says if the buffer is ready to take more requests
     */ PromiseBuffer.prototype.isReady = function() {
        return this._limit === undefined || this.length() < this._limit;
    };
    /**
     * Add a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns The original promise.
     */ PromiseBuffer.prototype.add = function(task) {
        var _this = this;
        if (!this.isReady()) return (0, $6e504369e1fed547$export$6f292d4960313241).reject(new (0, $4e775f3b83c72383$export$5949942ba2a7c0e2)("Not adding Promise due to buffer limit reached."));
        if (this._buffer.indexOf(task) === -1) this._buffer.push(task);
        task.then(function() {
            return _this.remove(task);
        }).then(null, function() {
            return _this.remove(task).then(null, function() {
            // We have to add this catch here otherwise we have an unhandledPromiseRejection
            // because it's a new Promise chain.
            });
        });
        return task;
    };
    /**
     * Remove a promise to the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */ PromiseBuffer.prototype.remove = function(task) {
        var removedTask = this._buffer.splice(this._buffer.indexOf(task), 1)[0];
        return removedTask;
    };
    /**
     * This function returns the number of unresolved promises in the queue.
     */ PromiseBuffer.prototype.length = function() {
        return this._buffer.length;
    };
    /**
     * This will drain the whole queue, returns true if queue is empty or drained.
     * If timeout is provided and the queue takes longer to drain, the promise still resolves but with false.
     *
     * @param timeout Number in ms to wait until it resolves with false.
     */ PromiseBuffer.prototype.drain = function(timeout) {
        var _this = this;
        return new (0, $6e504369e1fed547$export$6f292d4960313241)(function(resolve) {
            var capturedSetTimeout = setTimeout(function() {
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            (0, $6e504369e1fed547$export$6f292d4960313241).all(_this._buffer).then(function() {
                clearTimeout(capturedSetTimeout);
                resolve(true);
            }).then(null, function() {
                resolve(true);
            });
        });
    };
    return PromiseBuffer;
}();


parcelRequire("eHZGJ");
parcelRequire("aVWL9");



var $gJrrM = parcelRequire("gJrrM");
$parcel$exportWildcard($0380f4dfca04813d$exports, $hxqGH);
$parcel$exportWildcard($0380f4dfca04813d$exports, $gJrrM);


var $byuqS = parcelRequire("byuqS");
var $gJrrM = parcelRequire("gJrrM");
var $hxqGH = parcelRequire("hxqGH");


var $gJrrM = parcelRequire("gJrrM");
var $byuqS = parcelRequire("byuqS");
var $jNciV = parcelRequire("jNciV");
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ var $3024fb3366777167$export$775b6bb06e53a214 = /** @class */ function() {
    function Scope() {
        /** Flag if notifiying is happening. */ this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */ this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */ this._eventProcessors = [];
        /** Array of breadcrumbs. */ this._breadcrumbs = [];
        /** User */ this._user = {};
        /** Tags */ this._tags = {};
        /** Extra */ this._extra = {};
        /** Contexts */ this._contexts = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */ Scope.clone = function(scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0, $779119c643ee07b9$export$afc72e2116322959)(scope._breadcrumbs);
            newScope._tags = (0, $779119c643ee07b9$export$18ce0697a983be9b)({}, scope._tags);
            newScope._extra = (0, $779119c643ee07b9$export$18ce0697a983be9b)({}, scope._extra);
            newScope._contexts = (0, $779119c643ee07b9$export$18ce0697a983be9b)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0, $779119c643ee07b9$export$afc72e2116322959)(scope._eventProcessors);
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */ Scope.prototype.addScopeListener = function(callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addEventProcessor = function(callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setUser = function(user) {
        this._user = user || {};
        if (this._session) this._session.update({
            user: user
        });
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getUser = function() {
        return this._user;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTags = function(tags) {
        this._tags = (0, $779119c643ee07b9$export$18ce0697a983be9b)((0, $779119c643ee07b9$export$18ce0697a983be9b)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTag = function(key, value) {
        var _a;
        this._tags = (0, $779119c643ee07b9$export$18ce0697a983be9b)((0, $779119c643ee07b9$export$18ce0697a983be9b)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtras = function(extras) {
        this._extra = (0, $779119c643ee07b9$export$18ce0697a983be9b)((0, $779119c643ee07b9$export$18ce0697a983be9b)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setExtra = function(key, extra) {
        var _a;
        this._extra = (0, $779119c643ee07b9$export$18ce0697a983be9b)((0, $779119c643ee07b9$export$18ce0697a983be9b)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setFingerprint = function(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setLevel = function(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setTransactionName = function(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */ Scope.prototype.setTransaction = function(name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setContext = function(key, context) {
        var _a;
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts = (0, $779119c643ee07b9$export$18ce0697a983be9b)((0, $779119c643ee07b9$export$18ce0697a983be9b)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSpan = function(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSpan = function() {
        return this._span;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getTransaction = function() {
        var _a, _b, _c, _d;
        // often, this span will be a transaction, but it's not guaranteed to be
        var span = this.getSpan();
        // try it the new way first
        if ((_a = span) === null || _a === void 0 ? void 0 : _a.transaction) return (_b = span) === null || _b === void 0 ? void 0 : _b.transaction;
        // fallback to the old way (known bug: this only finds transactions with sampled = true)
        if ((_d = (_c = span) === null || _c === void 0 ? void 0 : _c.spanRecorder) === null || _d === void 0 ? void 0 : _d.spans[0]) return span.spanRecorder.spans[0];
        // neither way found a transaction
        return undefined;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.setSession = function(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.getSession = function() {
        return this._session;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.update = function(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === "function") {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0, $779119c643ee07b9$export$18ce0697a983be9b)((0, $779119c643ee07b9$export$18ce0697a983be9b)({}, this._tags), captureContext._tags);
            this._extra = (0, $779119c643ee07b9$export$18ce0697a983be9b)((0, $779119c643ee07b9$export$18ce0697a983be9b)({}, this._extra), captureContext._extra);
            this._contexts = (0, $779119c643ee07b9$export$18ce0697a983be9b)((0, $779119c643ee07b9$export$18ce0697a983be9b)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
        } else if ((0, $jNciV.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = (0, $779119c643ee07b9$export$18ce0697a983be9b)((0, $779119c643ee07b9$export$18ce0697a983be9b)({}, this._tags), captureContext.tags);
            this._extra = (0, $779119c643ee07b9$export$18ce0697a983be9b)((0, $779119c643ee07b9$export$18ce0697a983be9b)({}, this._extra), captureContext.extra);
            this._contexts = (0, $779119c643ee07b9$export$18ce0697a983be9b)((0, $779119c643ee07b9$export$18ce0697a983be9b)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
        }
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clear = function() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.addBreadcrumb = function(breadcrumb, maxBreadcrumbs) {
        var mergedBreadcrumb = (0, $779119c643ee07b9$export$18ce0697a983be9b)({
            timestamp: (0, $gJrrM.dateTimestampInSeconds)()
        }, breadcrumb);
        this._breadcrumbs = maxBreadcrumbs !== undefined && maxBreadcrumbs >= 0 ? (0, $779119c643ee07b9$export$afc72e2116322959)(this._breadcrumbs, [
            mergedBreadcrumb
        ]).slice(-maxBreadcrumbs) : (0, $779119c643ee07b9$export$afc72e2116322959)(this._breadcrumbs, [
            mergedBreadcrumb
        ]);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */ Scope.prototype.clearBreadcrumbs = function() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional informartion about the original exception.
     * @hidden
     */ Scope.prototype.applyToEvent = function(event, hint) {
        var _a;
        if (this._extra && Object.keys(this._extra).length) event.extra = (0, $779119c643ee07b9$export$18ce0697a983be9b)((0, $779119c643ee07b9$export$18ce0697a983be9b)({}, this._extra), event.extra);
        if (this._tags && Object.keys(this._tags).length) event.tags = (0, $779119c643ee07b9$export$18ce0697a983be9b)((0, $779119c643ee07b9$export$18ce0697a983be9b)({}, this._tags), event.tags);
        if (this._user && Object.keys(this._user).length) event.user = (0, $779119c643ee07b9$export$18ce0697a983be9b)((0, $779119c643ee07b9$export$18ce0697a983be9b)({}, this._user), event.user);
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = (0, $779119c643ee07b9$export$18ce0697a983be9b)((0, $779119c643ee07b9$export$18ce0697a983be9b)({}, this._contexts), event.contexts);
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relys on that.
        if (this._span) {
            event.contexts = (0, $779119c643ee07b9$export$18ce0697a983be9b)({
                trace: this._span.getTraceContext()
            }, event.contexts);
            var transactionName = (_a = this._span.transaction) === null || _a === void 0 ? void 0 : _a.name;
            if (transactionName) event.tags = (0, $779119c643ee07b9$export$18ce0697a983be9b)({
                transaction: transactionName
            }, event.tags);
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0, $779119c643ee07b9$export$afc72e2116322959)(event.breadcrumbs || [], this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        return this._notifyEventProcessors((0, $779119c643ee07b9$export$afc72e2116322959)($3024fb3366777167$var$getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */ Scope.prototype._notifyEventProcessors = function(processors, event, hint, index) {
        var _this = this;
        if (index === void 0) index = 0;
        return new (0, $6e504369e1fed547$export$6f292d4960313241)(function(resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== "function") resolve(event);
            else {
                var result = processor((0, $779119c643ee07b9$export$18ce0697a983be9b)({}, event), hint);
                if ((0, $jNciV.isThenable)(result)) result.then(function(final) {
                    return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve);
                }).then(null, reject);
                else _this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    };
    /**
     * This will be called on every set call.
     */ Scope.prototype._notifyScopeListeners = function() {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function(callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */ Scope.prototype._applyFingerprint = function(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? Array.isArray(event.fingerprint) ? event.fingerprint : [
            event.fingerprint
        ] : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    };
    return Scope;
}();
/**
 * Retruns the global event processors.
 */ function $3024fb3366777167$var$getGlobalEventProcessors() {
    /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access  */ var global = (0, $byuqS.getGlobalObject)();
    global.__SENTRY__ = global.__SENTRY__ || {};
    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
    return global.__SENTRY__.globalEventProcessors;
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ }
function $3024fb3366777167$export$8e4e25f54d456511(callback) {
    $3024fb3366777167$var$getGlobalEventProcessors().push(callback);
}


/**
 * Session Status
 */ var $d1294679e014ca13$export$5749bf3f1d0fd21b;
(function(SessionStatus) {
    /** JSDoc */ SessionStatus["Ok"] = "ok";
    /** JSDoc */ SessionStatus["Exited"] = "exited";
    /** JSDoc */ SessionStatus["Crashed"] = "crashed";
    /** JSDoc */ SessionStatus["Abnormal"] = "abnormal";
})($d1294679e014ca13$export$5749bf3f1d0fd21b || ($d1294679e014ca13$export$5749bf3f1d0fd21b = {}));



var $hKTDd = parcelRequire("hKTDd");
var $byuqS = parcelRequire("byuqS");
/**
 * @inheritdoc
 */ var $b5b7ab025f69b09a$export$1fb4852a55678982 = /** @class */ function() {
    function Session(context) {
        this.errors = 0;
        this.sid = (0, $byuqS.uuid4)();
        this.timestamp = Date.now();
        this.started = Date.now();
        this.duration = 0;
        this.status = (0, $d1294679e014ca13$export$5749bf3f1d0fd21b).Ok;
        if (context) this.update(context);
    }
    /** JSDoc */ // eslint-disable-next-line complexity
    Session.prototype.update = function(context) {
        if (context === void 0) context = {};
        if (context.user) {
            if (context.user.ip_address) this.ipAddress = context.user.ip_address;
            if (!context.did) this.did = context.user.id || context.user.email || context.user.username;
        }
        this.timestamp = context.timestamp || Date.now();
        if (context.sid) // Good enough uuid validation. — Kamil
        this.sid = context.sid.length === 32 ? context.sid : (0, $byuqS.uuid4)();
        if (context.did) this.did = "" + context.did;
        if (typeof context.started === "number") this.started = context.started;
        if (typeof context.duration === "number") this.duration = context.duration;
        else this.duration = this.timestamp - this.started;
        if (context.release) this.release = context.release;
        if (context.environment) this.environment = context.environment;
        if (context.ipAddress) this.ipAddress = context.ipAddress;
        if (context.userAgent) this.userAgent = context.userAgent;
        if (typeof context.errors === "number") this.errors = context.errors;
        if (context.status) this.status = context.status;
    };
    /** JSDoc */ Session.prototype.close = function(status) {
        if (status) this.update({
            status: status
        });
        else if (this.status === (0, $d1294679e014ca13$export$5749bf3f1d0fd21b).Ok) this.update({
            status: (0, $d1294679e014ca13$export$5749bf3f1d0fd21b).Exited
        });
        else this.update();
    };
    /** JSDoc */ Session.prototype.toJSON = function() {
        return (0, $hKTDd.dropUndefinedKeys)({
            sid: "" + this.sid,
            init: true,
            started: new Date(this.started).toISOString(),
            timestamp: new Date(this.timestamp).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === "number" || typeof this.did === "string" ? "" + this.did : undefined,
            duration: this.duration,
            attrs: (0, $hKTDd.dropUndefinedKeys)({
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent
            })
        });
    };
    return Session;
}();


var $03b756c195b1c14e$export$24a86ef7798177e4 = 3;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ var $03b756c195b1c14e$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Absolute maximum number of breadcrumbs added to an event. The
 * `maxBreadcrumbs` option cannot be higher than this value.
 */ var $03b756c195b1c14e$var$MAX_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */ var $03b756c195b1c14e$export$8c41bb232f1008b1 = /** @class */ function() {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */ function Hub(client, scope, _version) {
        if (scope === void 0) scope = new (0, $3024fb3366777167$export$775b6bb06e53a214)();
        if (_version === void 0) _version = $03b756c195b1c14e$export$24a86ef7798177e4;
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */ this._stack = [
            {}
        ];
        this.getStackTop().scope = scope;
        this.bindClient(client);
    }
    /**
     * @inheritDoc
     */ Hub.prototype.isOlderThan = function(version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.bindClient = function(client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.pushScope = function() {
        // We want to clone the content of prev scope
        var scope = (0, $3024fb3366777167$export$775b6bb06e53a214).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.popScope = function() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */ Hub.prototype.withScope = function(callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getClient = function() {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */ Hub.prototype.getScope = function() {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */ Hub.prototype.getStack = function() {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */ Hub.prototype.getStackTop = function() {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function(exception, hint) {
        var eventId = this._lastEventId = (0, $byuqS.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error("Sentry syntheticException");
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException
            };
        }
        this._invokeClient("captureException", exception, (0, $779119c643ee07b9$export$18ce0697a983be9b)((0, $779119c643ee07b9$export$18ce0697a983be9b)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureMessage = function(message, level, hint) {
        var eventId = this._lastEventId = (0, $byuqS.uuid4)();
        var finalHint = hint;
        // If there's no explicit hint provided, mimick the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            } catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException
            };
        }
        this._invokeClient("captureMessage", message, level, (0, $779119c643ee07b9$export$18ce0697a983be9b)((0, $779119c643ee07b9$export$18ce0697a983be9b)({}, finalHint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.captureEvent = function(event, hint) {
        var eventId = this._lastEventId = (0, $byuqS.uuid4)();
        this._invokeClient("captureEvent", event, (0, $779119c643ee07b9$export$18ce0697a983be9b)((0, $779119c643ee07b9$export$18ce0697a983be9b)({}, hint), {
            event_id: eventId
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.lastEventId = function() {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.addBreadcrumb = function(breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client) return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = client.getOptions && client.getOptions() || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? $03b756c195b1c14e$var$DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0) return;
        var timestamp = (0, $gJrrM.dateTimestampInSeconds)();
        var mergedBreadcrumb = (0, $779119c643ee07b9$export$18ce0697a983be9b)({
            timestamp: timestamp
        }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb ? (0, $byuqS.consoleSandbox)(function() {
            return beforeBreadcrumb(mergedBreadcrumb, hint);
        }) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        scope.addBreadcrumb(finalBreadcrumb, Math.min(maxBreadcrumbs, $03b756c195b1c14e$var$MAX_BREADCRUMBS));
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setUser = function(user) {
        var scope = this.getScope();
        if (scope) scope.setUser(user);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTags = function(tags) {
        var scope = this.getScope();
        if (scope) scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtras = function(extras) {
        var scope = this.getScope();
        if (scope) scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setTag = function(key, value) {
        var scope = this.getScope();
        if (scope) scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.setExtra = function(key, extra) {
        var scope = this.getScope();
        if (scope) scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function(name, context) {
        var scope = this.getScope();
        if (scope) scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.configureScope = function(callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) callback(scope);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.run = function(callback) {
        var oldHub = $03b756c195b1c14e$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $03b756c195b1c14e$export$4188a14ad302d1bc(oldHub);
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.getIntegration = function(integration) {
        var client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $ac919b34c52e6588$export$af88d00dbe7f521).warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSpan = function(context) {
        return this._callExtensionMethod("startSpan", context);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startTransaction = function(context, customSamplingContext) {
        return this._callExtensionMethod("startTransaction", context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */ Hub.prototype.traceHeaders = function() {
        return this._callExtensionMethod("traceHeaders");
    };
    /**
     * @inheritDoc
     */ Hub.prototype.startSession = function(context) {
        // End existing session if there's one
        this.endSession();
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = client && client.getOptions() || {}, release = _b.release, environment = _b.environment;
        var session = new (0, $b5b7ab025f69b09a$export$1fb4852a55678982)((0, $779119c643ee07b9$export$18ce0697a983be9b)((0, $779119c643ee07b9$export$18ce0697a983be9b)({
            release: release,
            environment: environment
        }, scope && {
            user: scope.getUser()
        }), context));
        if (scope) scope.setSession(session);
        return session;
    };
    /**
     * @inheritDoc
     */ Hub.prototype.endSession = function() {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope) return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            session.close();
            if (client && client.captureSession) client.captureSession(session);
            scope.setSession();
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function(method) {
        var _a;
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        (_a = client)[method].apply(_a, (0, $779119c643ee07b9$export$afc72e2116322959)(args, [
            scope
        ]));
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function(method) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        var carrier = $03b756c195b1c14e$export$19eade501500c6c1();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === "function") return sentry.extensions[method].apply(this, args);
        (0, $ac919b34c52e6588$export$af88d00dbe7f521).warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}();
function $03b756c195b1c14e$export$19eade501500c6c1() {
    var carrier = (0, $byuqS.getGlobalObject)();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return carrier;
}
function $03b756c195b1c14e$export$4188a14ad302d1bc(hub) {
    var registry = $03b756c195b1c14e$export$19eade501500c6c1();
    var oldHub = $03b756c195b1c14e$export$bfa8a924a84a76b7(registry);
    $03b756c195b1c14e$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
function $03b756c195b1c14e$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    var registry = $03b756c195b1c14e$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$03b756c195b1c14e$var$hasHubOnCarrier(registry) || $03b756c195b1c14e$export$bfa8a924a84a76b7(registry).isOlderThan($03b756c195b1c14e$export$24a86ef7798177e4)) $03b756c195b1c14e$export$849f05434e95d2f2(registry, new $03b756c195b1c14e$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $hxqGH.isNodeEnv)()) return $03b756c195b1c14e$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $03b756c195b1c14e$export$bfa8a924a84a76b7(registry);
}
function $03b756c195b1c14e$export$1c4d656130202699() {
    var sentry = $03b756c195b1c14e$export$19eade501500c6c1().__SENTRY__;
    return sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $03b756c195b1c14e$var$getHubFromActiveDomain(registry) {
    try {
        var activeDomain = $03b756c195b1c14e$export$1c4d656130202699();
        // If there's no active domain, just return global hub
        if (!activeDomain) return $03b756c195b1c14e$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$03b756c195b1c14e$var$hasHubOnCarrier(activeDomain) || $03b756c195b1c14e$export$bfa8a924a84a76b7(activeDomain).isOlderThan($03b756c195b1c14e$export$24a86ef7798177e4)) {
            var registryHubTopStack = $03b756c195b1c14e$export$bfa8a924a84a76b7(registry).getStackTop();
            $03b756c195b1c14e$export$849f05434e95d2f2(activeDomain, new $03b756c195b1c14e$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $3024fb3366777167$export$775b6bb06e53a214).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $03b756c195b1c14e$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $03b756c195b1c14e$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $03b756c195b1c14e$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
function $03b756c195b1c14e$export$bfa8a924a84a76b7(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub) return carrier.__SENTRY__.hub;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = new $03b756c195b1c14e$export$8c41bb232f1008b1();
    return carrier.__SENTRY__.hub;
}
function $03b756c195b1c14e$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = hub;
    return true;
}


/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $3ae32034d8d01628$var$callOnHub(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    var hub = (0, $03b756c195b1c14e$export$a07cdf6544bbd7c)();
    if (hub && hub[method]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return hub[method].apply(hub, (0, $e05aea38cf8cebea$export$afc72e2116322959)(args));
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
function $3ae32034d8d01628$export$f5282963edea4a68(exception, captureContext) {
    var syntheticException;
    try {
        throw new Error("Sentry syntheticException");
    } catch (exception) {
        syntheticException = exception;
    }
    return $3ae32034d8d01628$var$callOnHub("captureException", exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException
    });
}
function $3ae32034d8d01628$export$45654777c133ae80(message, captureContext) {
    var syntheticException;
    try {
        throw new Error(message);
    } catch (exception) {
        syntheticException = exception;
    }
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    var level = typeof captureContext === "string" ? captureContext : undefined;
    var context = typeof captureContext !== "string" ? {
        captureContext: captureContext
    } : undefined;
    return $3ae32034d8d01628$var$callOnHub("captureMessage", message, level, (0, $e05aea38cf8cebea$export$18ce0697a983be9b)({
        originalException: message,
        syntheticException: syntheticException
    }, context));
}
function $3ae32034d8d01628$export$1462b974fdcf6ba2(event) {
    return $3ae32034d8d01628$var$callOnHub("captureEvent", event);
}
function $3ae32034d8d01628$export$99d44f04437e9cb8(callback) {
    $3ae32034d8d01628$var$callOnHub("configureScope", callback);
}
function $3ae32034d8d01628$export$efda9a273d7a036d(breadcrumb) {
    $3ae32034d8d01628$var$callOnHub("addBreadcrumb", breadcrumb);
}
function $3ae32034d8d01628$export$2f04de43fe27971a(name, context) {
    $3ae32034d8d01628$var$callOnHub("setContext", name, context);
}
function $3ae32034d8d01628$export$bb4922da0dd51b92(extras) {
    $3ae32034d8d01628$var$callOnHub("setExtras", extras);
}
function $3ae32034d8d01628$export$74a8fb34822092e6(tags) {
    $3ae32034d8d01628$var$callOnHub("setTags", tags);
}
function $3ae32034d8d01628$export$8e8e7789d42ed61d(key, extra) {
    $3ae32034d8d01628$var$callOnHub("setExtra", key, extra);
}
function $3ae32034d8d01628$export$a37d07ee78eb4569(key, value) {
    $3ae32034d8d01628$var$callOnHub("setTag", key, value);
}
function $3ae32034d8d01628$export$8b6bb3dd62a01be2(user) {
    $3ae32034d8d01628$var$callOnHub("setUser", user);
}
function $3ae32034d8d01628$export$ec58d9285c204497(callback) {
    $3ae32034d8d01628$var$callOnHub("withScope", callback);
}
function $3ae32034d8d01628$export$5b9bc6fc91daaf9f(method) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    $3ae32034d8d01628$var$callOnHub.apply(void 0, (0, $e05aea38cf8cebea$export$afc72e2116322959)([
        "_invokeClient",
        method
    ], args));
}
function $3ae32034d8d01628$export$e262da7ae6480481(context, customSamplingContext) {
    return $3ae32034d8d01628$var$callOnHub("startTransaction", (0, $e05aea38cf8cebea$export$18ce0697a983be9b)({}, context), customSamplingContext);
}



/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $b6a38a095f2aae4e$var$extendStatics = function(d, b) {
    $b6a38a095f2aae4e$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $b6a38a095f2aae4e$var$extendStatics(d, b);
};
function $b6a38a095f2aae4e$export$a8ba968b8961cb8a(d, b) {
    $b6a38a095f2aae4e$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $b6a38a095f2aae4e$export$18ce0697a983be9b = function() {
    $b6a38a095f2aae4e$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $b6a38a095f2aae4e$export$18ce0697a983be9b.apply(this, arguments);
};
function $b6a38a095f2aae4e$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $b6a38a095f2aae4e$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $b6a38a095f2aae4e$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $b6a38a095f2aae4e$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $b6a38a095f2aae4e$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $b6a38a095f2aae4e$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $b6a38a095f2aae4e$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $b6a38a095f2aae4e$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $b6a38a095f2aae4e$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $b6a38a095f2aae4e$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $b6a38a095f2aae4e$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($b6a38a095f2aae4e$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $b6a38a095f2aae4e$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $b6a38a095f2aae4e$export$10c90e4f7922046c(v) {
    return this instanceof $b6a38a095f2aae4e$export$10c90e4f7922046c ? (this.v = v, this) : new $b6a38a095f2aae4e$export$10c90e4f7922046c(v);
}
function $b6a38a095f2aae4e$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $b6a38a095f2aae4e$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $b6a38a095f2aae4e$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $b6a38a095f2aae4e$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $b6a38a095f2aae4e$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $b6a38a095f2aae4e$export$19a8beecd37a4c45 === "function" ? $b6a38a095f2aae4e$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $b6a38a095f2aae4e$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $b6a38a095f2aae4e$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $b6a38a095f2aae4e$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $b6a38a095f2aae4e$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $b6a38a095f2aae4e$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}





var $gJrrM = parcelRequire("gJrrM");
var $jNciV = parcelRequire("jNciV");
var $hKTDd = parcelRequire("hKTDd");
var $aVWL9 = parcelRequire("aVWL9");
var $byuqS = parcelRequire("byuqS");



var $d5db86af17fd9458$export$b14a8888f80a0b3e = [];
function $d5db86af17fd9458$export$68bc4c01ab8ae766(options) {
    var defaultIntegrations = options.defaultIntegrations && (0, $b6a38a095f2aae4e$export$afc72e2116322959)(options.defaultIntegrations) || [];
    var userIntegrations = options.integrations;
    var integrations = [];
    if (Array.isArray(userIntegrations)) {
        var userIntegrationsNames_1 = userIntegrations.map(function(i) {
            return i.name;
        });
        var pickedIntegrationsNames_1 = [];
        // Leave only unique default integrations, that were not overridden with provided user integrations
        defaultIntegrations.forEach(function(defaultIntegration) {
            if (userIntegrationsNames_1.indexOf(defaultIntegration.name) === -1 && pickedIntegrationsNames_1.indexOf(defaultIntegration.name) === -1) {
                integrations.push(defaultIntegration);
                pickedIntegrationsNames_1.push(defaultIntegration.name);
            }
        });
        // Don't add same user integration twice
        userIntegrations.forEach(function(userIntegration) {
            if (pickedIntegrationsNames_1.indexOf(userIntegration.name) === -1) {
                integrations.push(userIntegration);
                pickedIntegrationsNames_1.push(userIntegration.name);
            }
        });
    } else if (typeof userIntegrations === "function") {
        integrations = userIntegrations(defaultIntegrations);
        integrations = Array.isArray(integrations) ? integrations : [
            integrations
        ];
    } else integrations = (0, $b6a38a095f2aae4e$export$afc72e2116322959)(defaultIntegrations);
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function(i) {
        return i.name;
    });
    var alwaysLastToRun = "Debug";
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) integrations.push.apply(integrations, (0, $b6a38a095f2aae4e$export$afc72e2116322959)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    return integrations;
}
function $d5db86af17fd9458$export$e7390a03b70a6f2f(integration) {
    if ($d5db86af17fd9458$export$b14a8888f80a0b3e.indexOf(integration.name) !== -1) return;
    integration.setupOnce((0, $3024fb3366777167$export$8e4e25f54d456511), (0, $03b756c195b1c14e$export$a07cdf6544bbd7c));
    $d5db86af17fd9458$export$b14a8888f80a0b3e.push(integration.name);
    (0, $ac919b34c52e6588$export$af88d00dbe7f521).log("Integration installed: " + integration.name);
}
function $d5db86af17fd9458$export$51abed9797baa598(options) {
    var integrations = {};
    $d5db86af17fd9458$export$68bc4c01ab8ae766(options).forEach(function(integration) {
        integrations[integration.name] = integration;
        $d5db86af17fd9458$export$e7390a03b70a6f2f(integration);
    });
    return integrations;
}


/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient.prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */ var $1f14ff2acf2fa3fa$export$4f22f74eddb7716a = /** @class */ function() {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */ function BaseClient(backendClass, options) {
        /** Array of used integrations. */ this._integrations = {};
        /** Number of call being processed */ this._processing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) this._dsn = new (0, $197b30967960013f$export$aff37ac2a8ccf4dc)(options.dsn);
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function(exception, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        this._process(this._getBackend().eventFromException(exception, hint).then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureMessage = function(message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = (0, $jNciV.isPrimitive)(message) ? this._getBackend().eventFromMessage(String(message), level, hint) : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent.then(function(event) {
            return _this._captureEvent(event, hint, scope);
        }).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureEvent = function(event, hint, scope) {
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function(result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.captureSession = function(session) {
        if (!session.release) (0, $ac919b34c52e6588$export$af88d00dbe7f521).warn("Discarded session because of missing release");
        else this._sendSession(session);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getDsn = function() {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getOptions = function() {
        return this._options;
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.flush = function(timeout) {
        var _this = this;
        return this._isClientProcessing(timeout).then(function(ready) {
            return _this._getBackend().getTransport().close(timeout).then(function(transportFlushed) {
                return ready && transportFlushed;
            });
        });
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.close = function(timeout) {
        var _this = this;
        return this.flush(timeout).then(function(result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */ BaseClient.prototype.setupIntegrations = function() {
        if (this._isEnabled()) this._integrations = (0, $d5db86af17fd9458$export$51abed9797baa598)(this._options);
    };
    /**
     * @inheritDoc
     */ BaseClient.prototype.getIntegration = function(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $ac919b34c52e6588$export$af88d00dbe7f521).warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */ BaseClient.prototype._updateSessionFromEvent = function(session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var userAgent;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for(var exceptions_1 = (0, $b6a38a095f2aae4e$export$19a8beecd37a4c45)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()){
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
        }
        var user = event.user;
        if (!session.userAgent) {
            var headers = event.request ? event.request.headers : {};
            for(var key in headers)if (key.toLowerCase() === "user-agent") {
                userAgent = headers[key];
                break;
            }
        }
        session.update((0, $b6a38a095f2aae4e$export$18ce0697a983be9b)((0, $b6a38a095f2aae4e$export$18ce0697a983be9b)({}, crashed && {
            status: (0, $d1294679e014ca13$export$5749bf3f1d0fd21b).Crashed
        }), {
            user: user,
            userAgent: userAgent,
            errors: session.errors + Number(errored || crashed)
        }));
    };
    /** Deliver captured session to Sentry */ BaseClient.prototype._sendSession = function(session) {
        this._getBackend().sendSession(session);
    };
    /** Waits for the client to be done with processing. */ BaseClient.prototype._isClientProcessing = function(timeout) {
        var _this = this;
        return new (0, $6e504369e1fed547$export$6f292d4960313241)(function(resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function() {
                if (_this._processing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */ BaseClient.prototype._getBackend = function() {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */ BaseClient.prototype._isEnabled = function() {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */ BaseClient.prototype._prepareEvent = function(event, scope, hint) {
        var _this = this;
        var _a = this.getOptions().normalizeDepth, normalizeDepth = _a === void 0 ? 3 : _a;
        var prepared = (0, $b6a38a095f2aae4e$export$18ce0697a983be9b)((0, $b6a38a095f2aae4e$export$18ce0697a983be9b)({}, event), {
            event_id: event.event_id || (hint && hint.event_id ? hint.event_id : (0, $byuqS.uuid4)()),
            timestamp: event.timestamp || (0, $gJrrM.dateTimestampInSeconds)()
        });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) finalScope = (0, $3024fb3366777167$export$775b6bb06e53a214).clone(finalScope).update(hint.captureContext);
        // We prepare the result here with a resolved Event.
        var result = (0, $6e504369e1fed547$export$6f292d4960313241).resolve(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) // In case we have a hub we reassign it.
        result = finalScope.applyToEvent(prepared, hint);
        return result.then(function(evt) {
            if (typeof normalizeDepth === "number" && normalizeDepth > 0) return _this._normalizeEvent(evt, normalizeDepth);
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */ BaseClient.prototype._normalizeEvent = function(event, depth) {
        if (!event) return null;
        var normalized = (0, $b6a38a095f2aae4e$export$18ce0697a983be9b)((0, $b6a38a095f2aae4e$export$18ce0697a983be9b)((0, $b6a38a095f2aae4e$export$18ce0697a983be9b)((0, $b6a38a095f2aae4e$export$18ce0697a983be9b)((0, $b6a38a095f2aae4e$export$18ce0697a983be9b)({}, event), event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function(b) {
                return (0, $b6a38a095f2aae4e$export$18ce0697a983be9b)((0, $b6a38a095f2aae4e$export$18ce0697a983be9b)({}, b), b.data && {
                    data: (0, $hKTDd.normalize)(b.data, depth)
                });
            })
        }), event.user && {
            user: (0, $hKTDd.normalize)(event.user, depth)
        }), event.contexts && {
            contexts: (0, $hKTDd.normalize)(event.contexts, depth)
        }), event.extra && {
            extra: (0, $hKTDd.normalize)(event.extra, depth)
        });
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        normalized.contexts.trace = event.contexts.trace;
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */ BaseClient.prototype._applyClientOptions = function(event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!("environment" in event)) event.environment = "environment" in options ? environment : "production";
        if (event.release === undefined && release !== undefined) event.release = release;
        if (event.dist === undefined && dist !== undefined) event.dist = dist;
        if (event.message) event.message = (0, $aVWL9.truncate)(event.message, maxValueLength);
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) exception.value = (0, $aVWL9.truncate)(exception.value, maxValueLength);
        var request = event.request;
        if (request && request.url) request.url = (0, $aVWL9.truncate)(request.url, maxValueLength);
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param sdkInfo The sdkInfo of the event that will be filled with all integrations.
     */ BaseClient.prototype._applyIntegrationsMetadata = function(event) {
        var sdkInfo = event.sdk;
        var integrationsArray = Object.keys(this._integrations);
        if (sdkInfo && integrationsArray.length > 0) sdkInfo.integrations = integrationsArray;
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */ BaseClient.prototype._sendEvent = function(event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */ BaseClient.prototype._captureEvent = function(event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function(finalEvent) {
            return finalEvent.event_id;
        }, function(reason) {
            (0, $ac919b34c52e6588$export$af88d00dbe7f521).error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */ BaseClient.prototype._processEvent = function(event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        if (!this._isEnabled()) return (0, $6e504369e1fed547$export$6f292d4960313241).reject(new (0, $4e775f3b83c72383$export$5949942ba2a7c0e2)("SDK not enabled, will not send event."));
        var isTransaction = event.type === "transaction";
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === "number" && Math.random() > sampleRate) return (0, $6e504369e1fed547$export$6f292d4960313241).reject(new (0, $4e775f3b83c72383$export$5949942ba2a7c0e2)("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        return this._prepareEvent(event, scope, hint).then(function(prepared) {
            if (prepared === null) throw new (0, $4e775f3b83c72383$export$5949942ba2a7c0e2)("An event processor returned null, will not send event.");
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) return prepared;
            var beforeSendResult = beforeSend(prepared, hint);
            if (typeof beforeSendResult === "undefined") throw new (0, $4e775f3b83c72383$export$5949942ba2a7c0e2)("`beforeSend` method has to return `null` or a valid event.");
            else if ((0, $jNciV.isThenable)(beforeSendResult)) return beforeSendResult.then(function(event) {
                return event;
            }, function(e) {
                throw new (0, $4e775f3b83c72383$export$5949942ba2a7c0e2)("beforeSend rejected with " + e);
            });
            return beforeSendResult;
        }).then(function(processedEvent) {
            if (processedEvent === null) throw new (0, $4e775f3b83c72383$export$5949942ba2a7c0e2)("`beforeSend` returned `null`, will not send event.");
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) _this._updateSessionFromEvent(session, processedEvent);
            _this._sendEvent(processedEvent);
            return processedEvent;
        }).then(null, function(reason) {
            if (reason instanceof (0, $4e775f3b83c72383$export$5949942ba2a7c0e2)) throw reason;
            _this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $4e775f3b83c72383$export$5949942ba2a7c0e2)("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */ BaseClient.prototype._process = function(promise) {
        var _this = this;
        this._processing += 1;
        promise.then(function(value) {
            _this._processing -= 1;
            return value;
        }, function(reason) {
            _this._processing -= 1;
            return reason;
        });
    };
    return BaseClient;
}();



var $byuqS = parcelRequire("byuqS");




/** Noop transport */ var $1b763c740cd00321$export$6f2767450ea1346c = /** @class */ function() {
    function NoopTransport() {}
    /**
     * @inheritDoc
     */ NoopTransport.prototype.sendEvent = function(_) {
        return (0, $6e504369e1fed547$export$6f292d4960313241).resolve({
            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
            status: (0, $d7c1b2ac3680a75d$export$96e9906d6d93a972).Skipped
        });
    };
    /**
     * @inheritDoc
     */ NoopTransport.prototype.close = function(_) {
        return (0, $6e504369e1fed547$export$6f292d4960313241).resolve(true);
    };
    return NoopTransport;
}();


/**
 * This is the base implemention of a Backend.
 * @hidden
 */ var $1e00dee6ab67074b$export$8f43a53a38d7e95f = /** @class */ function() {
    /** Creates a new backend instance. */ function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) (0, $ac919b34c52e6588$export$af88d00dbe7f521).warn("No DSN provided, backend will not do anything.");
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function(_exception, _hint) {
        throw new (0, $4e775f3b83c72383$export$5949942ba2a7c0e2)("Backend has to implement `eventFromException` method");
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.eventFromMessage = function(_message, _level, _hint) {
        throw new (0, $4e775f3b83c72383$export$5949942ba2a7c0e2)("Backend has to implement `eventFromMessage` method");
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendEvent = function(event) {
        this._transport.sendEvent(event).then(null, function(reason) {
            (0, $ac919b34c52e6588$export$af88d00dbe7f521).error("Error while sending event: " + reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.sendSession = function(session) {
        if (!this._transport.sendSession) {
            (0, $ac919b34c52e6588$export$af88d00dbe7f521).warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        this._transport.sendSession(session).then(null, function(reason) {
            (0, $ac919b34c52e6588$export$af88d00dbe7f521).error("Error while sending session: " + reason);
        });
    };
    /**
     * @inheritDoc
     */ BaseBackend.prototype.getTransport = function() {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */ BaseBackend.prototype._setupTransport = function() {
        return new (0, $1b763c740cd00321$export$6f2767450ea1346c)();
    };
    return BaseBackend;
}();







var $byuqS = parcelRequire("byuqS");
var $jNciV = parcelRequire("jNciV");

var $hKTDd = parcelRequire("hKTDd");
var $jNciV = parcelRequire("jNciV");
/**
 * This was originally forked from https://github.com/occ/TraceKit, but has since been
 * largely modified and is now maintained as part of Sentry JS SDK.
 */ 
// global reference to slice
var $612c1fd465869f05$var$UNKNOWN_FUNCTION = "?";
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var $612c1fd465869f05$var$chrome = /^\s*at (?:(.*?) ?\()?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var $612c1fd465869f05$var$gecko = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var $612c1fd465869f05$var$winjs = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var $612c1fd465869f05$var$geckoEval = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var $612c1fd465869f05$var$chromeEval = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var $612c1fd465869f05$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $612c1fd465869f05$export$81296eded4f2ac09(ex) {
    var stack = null;
    var popSize = 0;
    if (ex) {
        if (typeof ex.framesToPop === "number") popSize = ex.framesToPop;
        else if ($612c1fd465869f05$var$reactMinifiedRegexp.test(ex.message)) popSize = 1;
    }
    try {
        // This must be tried first because Opera 10 *destroys*
        // its stacktrace property if you try to access the stack
        // property first!!
        stack = $612c1fd465869f05$var$computeStackTraceFromStacktraceProp(ex);
        if (stack) return $612c1fd465869f05$var$popFrames(stack, popSize);
    } catch (e) {
    // no-empty
    }
    try {
        stack = $612c1fd465869f05$var$computeStackTraceFromStackProp(ex);
        if (stack) return $612c1fd465869f05$var$popFrames(stack, popSize);
    } catch (e) {
    // no-empty
    }
    return {
        message: $612c1fd465869f05$var$extractMessage(ex),
        name: ex && ex.name,
        stack: [],
        failed: true
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, complexity
function $612c1fd465869f05$var$computeStackTraceFromStackProp(ex) {
    if (!ex || !ex.stack) return null;
    var stack = [];
    var lines = ex.stack.split("\n");
    var isEval;
    var submatch;
    var parts;
    var element;
    for(var i = 0; i < lines.length; ++i){
        if (parts = $612c1fd465869f05$var$chrome.exec(lines[i])) {
            var isNative = parts[2] && parts[2].indexOf("native") === 0; // start of line
            isEval = parts[2] && parts[2].indexOf("eval") === 0; // start of line
            if (isEval && (submatch = $612c1fd465869f05$var$chromeEval.exec(parts[2]))) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = submatch[1]; // url
                parts[3] = submatch[2]; // line
                parts[4] = submatch[3]; // column
            }
            element = {
                // working with the regexp above is super painful. it is quite a hack, but just stripping the `address at `
                // prefix here seems like the quickest solution for now.
                url: parts[2] && parts[2].indexOf("address at ") === 0 ? parts[2].substr(11) : parts[2],
                func: parts[1] || $612c1fd465869f05$var$UNKNOWN_FUNCTION,
                args: isNative ? [
                    parts[2]
                ] : [],
                line: parts[3] ? +parts[3] : null,
                column: parts[4] ? +parts[4] : null
            };
        } else if (parts = $612c1fd465869f05$var$winjs.exec(lines[i])) element = {
            url: parts[2],
            func: parts[1] || $612c1fd465869f05$var$UNKNOWN_FUNCTION,
            args: [],
            line: +parts[3],
            column: parts[4] ? +parts[4] : null
        };
        else if (parts = $612c1fd465869f05$var$gecko.exec(lines[i])) {
            isEval = parts[3] && parts[3].indexOf(" > eval") > -1;
            if (isEval && (submatch = $612c1fd465869f05$var$geckoEval.exec(parts[3]))) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = submatch[1];
                parts[4] = submatch[2];
                parts[5] = ""; // no column when eval
            } else if (i === 0 && !parts[5] && ex.columnNumber !== void 0) // FireFox uses this awesome columnNumber property for its top frame
            // Also note, Firefox's column number is 0-based and everything else expects 1-based,
            // so adding 1
            // NOTE: this hack doesn't work if top-most frame is eval
            stack[0].column = ex.columnNumber + 1;
            element = {
                url: parts[3],
                func: parts[1] || $612c1fd465869f05$var$UNKNOWN_FUNCTION,
                args: parts[2] ? parts[2].split(",") : [],
                line: parts[4] ? +parts[4] : null,
                column: parts[5] ? +parts[5] : null
            };
        } else continue;
        if (!element.func && element.line) element.func = $612c1fd465869f05$var$UNKNOWN_FUNCTION;
        stack.push(element);
    }
    if (!stack.length) return null;
    return {
        message: $612c1fd465869f05$var$extractMessage(ex),
        name: ex.name,
        stack: stack
    };
}
/** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $612c1fd465869f05$var$computeStackTraceFromStacktraceProp(ex) {
    if (!ex || !ex.stacktrace) return null;
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace;
    var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
    var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\((.*)\))? in (.*):\s*$/i;
    var lines = stacktrace.split("\n");
    var stack = [];
    var parts;
    for(var line = 0; line < lines.length; line += 2){
        var element = null;
        if (parts = opera10Regex.exec(lines[line])) element = {
            url: parts[2],
            func: parts[3],
            args: [],
            line: +parts[1],
            column: null
        };
        else if (parts = opera11Regex.exec(lines[line])) element = {
            url: parts[6],
            func: parts[3] || parts[4],
            args: parts[5] ? parts[5].split(",") : [],
            line: +parts[1],
            column: +parts[2]
        };
        if (element) {
            if (!element.func && element.line) element.func = $612c1fd465869f05$var$UNKNOWN_FUNCTION;
            stack.push(element);
        }
    }
    if (!stack.length) return null;
    return {
        message: $612c1fd465869f05$var$extractMessage(ex),
        name: ex.name,
        stack: stack
    };
}
/** Remove N number of frames from the stack */ function $612c1fd465869f05$var$popFrames(stacktrace, popSize) {
    try {
        return (0, $90104860b1e5ba1f$export$18ce0697a983be9b)((0, $90104860b1e5ba1f$export$18ce0697a983be9b)({}, stacktrace), {
            stack: stacktrace.stack.slice(popSize)
        });
    } catch (e) {
        return stacktrace;
    }
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $612c1fd465869f05$var$extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) return "No error message";
    if (message.error && typeof message.error.message === "string") return message.error.message;
    return message;
}


var $de34cb4710a33f17$var$STACKTRACE_LIMIT = 50;
function $de34cb4710a33f17$export$cff07df76f81a017(stacktrace) {
    var frames = $de34cb4710a33f17$export$37bf8aee02016425(stacktrace.stack);
    var exception = {
        type: stacktrace.name,
        value: stacktrace.message
    };
    if (frames && frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === "") exception.value = "Unrecoverable error caught";
    return exception;
}
function $de34cb4710a33f17$export$a6a5dd73e489caf(exception, syntheticException, rejection) {
    var event = {
        exception: {
            values: [
                {
                    type: (0, $jNciV.isEvent)(exception) ? exception.constructor.name : rejection ? "UnhandledRejection" : "Error",
                    value: "Non-Error " + (rejection ? "promise rejection" : "exception") + " captured with keys: " + (0, $hKTDd.extractExceptionKeysForMessage)(exception)
                }
            ]
        },
        extra: {
            __serialized__: (0, $hKTDd.normalizeToSize)(exception)
        }
    };
    if (syntheticException) {
        var stacktrace = (0, $612c1fd465869f05$export$81296eded4f2ac09)(syntheticException);
        var frames_1 = $de34cb4710a33f17$export$37bf8aee02016425(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}
function $de34cb4710a33f17$export$7c1af3e1a12b045e(stacktrace) {
    var exception = $de34cb4710a33f17$export$cff07df76f81a017(stacktrace);
    return {
        exception: {
            values: [
                exception
            ]
        }
    };
}
function $de34cb4710a33f17$export$37bf8aee02016425(stack) {
    if (!stack || !stack.length) return [];
    var localStack = stack;
    var firstFrameFunction = localStack[0].func || "";
    var lastFrameFunction = localStack[localStack.length - 1].func || "";
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf("captureMessage") !== -1 || firstFrameFunction.indexOf("captureException") !== -1) localStack = localStack.slice(1);
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf("sentryWrapped") !== -1) localStack = localStack.slice(0, -1);
    // The frame where the crash happened, should be the last entry in the array
    return localStack.slice(0, $de34cb4710a33f17$var$STACKTRACE_LIMIT).map(function(frame) {
        return {
            colno: frame.column === null ? undefined : frame.column,
            filename: frame.url || localStack[0].url,
            function: frame.func || "?",
            in_app: true,
            lineno: frame.line === null ? undefined : frame.line
        };
    }).reverse();
}



function $c8e7e65862700028$export$ea3ec7e569b823fc(options, exception, hint) {
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $c8e7e65862700028$export$9dd56ed1ef0c3420(exception, syntheticException, {
        attachStacktrace: options.attachStacktrace
    });
    (0, $byuqS.addExceptionMechanism)(event, {
        handled: true,
        type: "generic"
    });
    event.level = (0, $e91087a6ec178c2a$export$918a9776c0a3cf27).Error;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $6e504369e1fed547$export$6f292d4960313241).resolve(event);
}
function $c8e7e65862700028$export$5425b53185d13d6c(options, message, level, hint) {
    if (level === void 0) level = (0, $e91087a6ec178c2a$export$918a9776c0a3cf27).Info;
    var syntheticException = hint && hint.syntheticException || undefined;
    var event = $c8e7e65862700028$export$47d86ae4b3c9994(message, syntheticException, {
        attachStacktrace: options.attachStacktrace
    });
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $6e504369e1fed547$export$6f292d4960313241).resolve(event);
}
function $c8e7e65862700028$export$9dd56ed1ef0c3420(exception, syntheticException, options) {
    if (options === void 0) options = {};
    var event;
    if ((0, $jNciV.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        // eslint-disable-next-line no-param-reassign
        exception = errorEvent.error;
        event = (0, $de34cb4710a33f17$export$7c1af3e1a12b045e)((0, $612c1fd465869f05$export$81296eded4f2ac09)(exception));
        return event;
    }
    if ((0, $jNciV.isDOMError)(exception) || (0, $jNciV.isDOMException)(exception)) {
        // If it is a DOMError or DOMException (which are legacy APIs, but still supported in some browsers)
        // then we just extract the name, code, and message, as they don't provide anything else
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
        // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
        var domException = exception;
        var name_1 = domException.name || ((0, $jNciV.isDOMError)(domException) ? "DOMError" : "DOMException");
        var message = domException.message ? name_1 + ": " + domException.message : name_1;
        event = $c8e7e65862700028$export$47d86ae4b3c9994(message, syntheticException, options);
        (0, $byuqS.addExceptionTypeValue)(event, message);
        if ("code" in domException) event.tags = (0, $90104860b1e5ba1f$export$18ce0697a983be9b)((0, $90104860b1e5ba1f$export$18ce0697a983be9b)({}, event.tags), {
            "DOMException.code": "" + domException.code
        });
        return event;
    }
    if ((0, $jNciV.isError)(exception)) {
        // we have a real Error object, do nothing
        event = (0, $de34cb4710a33f17$export$7c1af3e1a12b045e)((0, $612c1fd465869f05$export$81296eded4f2ac09)(exception));
        return event;
    }
    if ((0, $jNciV.isPlainObject)(exception) || (0, $jNciV.isEvent)(exception)) {
        // If it is plain Object or Event, serialize it manually and extract options
        // This will allow us to group events based on top-level keys
        // which is much better than creating new group when any key/value change
        var objectException = exception;
        event = (0, $de34cb4710a33f17$export$a6a5dd73e489caf)(objectException, syntheticException, options.rejection);
        (0, $byuqS.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $c8e7e65862700028$export$47d86ae4b3c9994(exception, syntheticException, options);
    (0, $byuqS.addExceptionTypeValue)(event, "" + exception, undefined);
    (0, $byuqS.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
function $c8e7e65862700028$export$47d86ae4b3c9994(input, syntheticException, options) {
    if (options === void 0) options = {};
    var event = {
        message: input
    };
    if (options.attachStacktrace && syntheticException) {
        var stacktrace = (0, $612c1fd465869f05$export$81296eded4f2ac09)(syntheticException);
        var frames_1 = (0, $de34cb4710a33f17$export$37bf8aee02016425)(stacktrace.stack);
        event.stacktrace = {
            frames: frames_1
        };
    }
    return event;
}




function $506a4164fe36069f$export$977ee6eda1884ec3(session, api) {
    var envelopeHeaders = JSON.stringify({
        sent_at: new Date().toISOString()
    });
    var itemHeaders = JSON.stringify({
        type: "session"
    });
    return {
        body: envelopeHeaders + "\n" + itemHeaders + "\n" + JSON.stringify(session),
        type: "session",
        url: api.getEnvelopeEndpointWithUrlEncodedAuth()
    };
}
function $506a4164fe36069f$export$2006389de558b996(event, api) {
    // since JS has no Object.prototype.pop()
    var _a = event.tags || {}, samplingMethod = _a.__sentry_samplingMethod, sampleRate = _a.__sentry_sampleRate, otherTags = (0, $b6a38a095f2aae4e$export$3c9a16f847548506)(_a, [
        "__sentry_samplingMethod",
        "__sentry_sampleRate"
    ]);
    event.tags = otherTags;
    var useEnvelope = event.type === "transaction";
    var req = {
        body: JSON.stringify(event),
        type: event.type || "event",
        url: useEnvelope ? api.getEnvelopeEndpointWithUrlEncodedAuth() : api.getStoreEndpointWithUrlEncodedAuth()
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = JSON.stringify({
            event_id: event.event_id,
            sent_at: new Date().toISOString()
        });
        var itemHeaders = JSON.stringify({
            type: event.type,
            // TODO: Right now, sampleRate may or may not be defined (it won't be in the cases of inheritance and
            // explicitly-set sampling decisions). Are we good with that?
            sample_rates: [
                {
                    id: samplingMethod,
                    rate: sampleRate
                }
            ]
        });
        // The trailing newline is optional. We intentionally don't send it to avoid
        // sending unnecessary bytes.
        //
        // const envelope = `${envelopeHeaders}\n${itemHeaders}\n${req.body}\n`;
        var envelope = envelopeHeaders + "\n" + itemHeaders + "\n" + req.body;
        req.body = envelope;
    }
    return req;
}



var $byuqS = parcelRequire("byuqS");


var $hKTDd = parcelRequire("hKTDd");
var $39f9f6580b14b664$var$SENTRY_API_VERSION = "7";
/** Helper class to provide urls to different Sentry endpoints. */ var $39f9f6580b14b664$export$2c4e825dc9120f87 = /** @class */ function() {
    /** Create a new instance of API */ function API(dsn) {
        this.dsn = dsn;
        this._dsnObject = new (0, $197b30967960013f$export$aff37ac2a8ccf4dc)(dsn);
    }
    /** Returns the Dsn object. */ API.prototype.getDsn = function() {
        return this._dsnObject;
    };
    /** Returns the prefix to construct Sentry ingestion API endpoints. */ API.prototype.getBaseApiEndpoint = function() {
        var dsn = this._dsnObject;
        var protocol = dsn.protocol ? dsn.protocol + ":" : "";
        var port = dsn.port ? ":" + dsn.port : "";
        return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : "") + "/api/";
    };
    /** Returns the store endpoint URL. */ API.prototype.getStoreEndpoint = function() {
        return this._getIngestEndpoint("store");
    };
    /**
     * Returns the store endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getStoreEndpointWithUrlEncodedAuth = function() {
        return this.getStoreEndpoint() + "?" + this._encodedAuth();
    };
    /**
     * Returns the envelope endpoint URL with auth in the query string.
     *
     * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
     */ API.prototype.getEnvelopeEndpointWithUrlEncodedAuth = function() {
        return this._getEnvelopeEndpoint() + "?" + this._encodedAuth();
    };
    /** Returns only the path component for the store endpoint. */ API.prototype.getStoreEndpointPath = function() {
        var dsn = this._dsnObject;
        return (dsn.path ? "/" + dsn.path : "") + "/api/" + dsn.projectId + "/store/";
    };
    /**
     * Returns an object that can be used in request headers.
     * This is needed for node and the old /store endpoint in sentry
     */ API.prototype.getRequestHeaders = function(clientName, clientVersion) {
        var dsn = this._dsnObject;
        var header = [
            "Sentry sentry_version=" + $39f9f6580b14b664$var$SENTRY_API_VERSION
        ];
        header.push("sentry_client=" + clientName + "/" + clientVersion);
        header.push("sentry_key=" + dsn.user);
        if (dsn.pass) header.push("sentry_secret=" + dsn.pass);
        return {
            "Content-Type": "application/json",
            "X-Sentry-Auth": header.join(", ")
        };
    };
    /** Returns the url to the report dialog endpoint. */ API.prototype.getReportDialogEndpoint = function(dialogOptions) {
        if (dialogOptions === void 0) dialogOptions = {};
        var dsn = this._dsnObject;
        var endpoint = this.getBaseApiEndpoint() + "embed/error-page/";
        var encodedOptions = [];
        encodedOptions.push("dsn=" + dsn.toString());
        for(var key in dialogOptions){
            if (key === "dsn") continue;
            if (key === "user") {
                if (!dialogOptions.user) continue;
                if (dialogOptions.user.name) encodedOptions.push("name=" + encodeURIComponent(dialogOptions.user.name));
                if (dialogOptions.user.email) encodedOptions.push("email=" + encodeURIComponent(dialogOptions.user.email));
            } else encodedOptions.push(encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]));
        }
        if (encodedOptions.length) return endpoint + "?" + encodedOptions.join("&");
        return endpoint;
    };
    /** Returns the envelope endpoint URL. */ API.prototype._getEnvelopeEndpoint = function() {
        return this._getIngestEndpoint("envelope");
    };
    /** Returns the ingest API endpoint for target. */ API.prototype._getIngestEndpoint = function(target) {
        var base = this.getBaseApiEndpoint();
        var dsn = this._dsnObject;
        return "" + base + dsn.projectId + "/" + target + "/";
    };
    /** Returns a URL-encoded string with auth config suitable for a query string. */ API.prototype._encodedAuth = function() {
        var dsn = this._dsnObject;
        var auth = {
            // We send only the minimum set of required information. See
            // https://github.com/getsentry/sentry-javascript/issues/2572.
            sentry_key: dsn.user,
            sentry_version: $39f9f6580b14b664$var$SENTRY_API_VERSION
        };
        return (0, $hKTDd.urlEncode)(auth);
    };
    return API;
}();




var $byuqS = parcelRequire("byuqS");
/** Base Transport class implementation */ var $ee7d6b37fb56964c$export$74b99d619e90f481 = /** @class */ function() {
    function BaseTransport(options) {
        this.options = options;
        /** A simple buffer holding all requests. */ this._buffer = new (0, $a0901ab61ea7e06d$export$9a81892395957e9f)(30);
        /** Locks transport after receiving rate limits in a response */ this._rateLimits = {};
        this._api = new (0, $39f9f6580b14b664$export$2c4e825dc9120f87)(this.options.dsn);
        // eslint-disable-next-line deprecation/deprecation
        this.url = this._api.getStoreEndpointWithUrlEncodedAuth();
    }
    /**
     * @inheritDoc
     */ BaseTransport.prototype.sendEvent = function(_) {
        throw new (0, $4e775f3b83c72383$export$5949942ba2a7c0e2)("Transport Class has to implement `sendEvent` method");
    };
    /**
     * @inheritDoc
     */ BaseTransport.prototype.close = function(timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */ BaseTransport.prototype._handleResponse = function(_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = (0, $d7c1b2ac3680a75d$export$96e9906d6d93a972).fromHttpCode(response.status);
        /**
         * "The name is case-insensitive."
         * https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
         */ var limited = this._handleRateLimit(headers);
        if (limited) (0, $ac919b34c52e6588$export$af88d00dbe7f521).warn("Too many requests, backing off until: " + this._disabledUntil(requestType));
        if (status === (0, $d7c1b2ac3680a75d$export$96e9906d6d93a972).Success) {
            resolve({
                status: status
            });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     */ BaseTransport.prototype._disabledUntil = function(category) {
        return this._rateLimits[category] || this._rateLimits.all;
    };
    /**
     * Checks if a category is rate limited
     */ BaseTransport.prototype._isRateLimited = function(category) {
        return this._disabledUntil(category) > new Date(Date.now());
    };
    /**
     * Sets internal _rateLimits from incoming headers. Returns true if headers contains a non-empty rate limiting header.
     */ BaseTransport.prototype._handleRateLimit = function(headers) {
        var e_1, _a, e_2, _b;
        var now = Date.now();
        var rlHeader = headers["x-sentry-rate-limits"];
        var raHeader = headers["retry-after"];
        if (rlHeader) {
            try {
                // rate limit headers are of the form
                //     <header>,<header>,..
                // where each <header> is of the form
                //     <retry_after>: <categories>: <scope>: <reason_code>
                // where
                //     <retry_after> is a delay in ms
                //     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
                //         <category>;<category>;...
                //     <scope> is what's being limited (org, project, or key) - ignored by SDK
                //     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
                for(var _c = (0, $90104860b1e5ba1f$export$19a8beecd37a4c45)(rlHeader.trim().split(",")), _d = _c.next(); !_d.done; _d = _c.next()){
                    var limit = _d.value;
                    var parameters = limit.split(":", 2);
                    var headerDelay = parseInt(parameters[0], 10);
                    var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
                    try {
                        for(var _e = (e_2 = void 0, (0, $90104860b1e5ba1f$export$19a8beecd37a4c45)(parameters[1].split(";"))), _f = _e.next(); !_f.done; _f = _e.next()){
                            var category = _f.value;
                            this._rateLimits[category || "all"] = new Date(now + delay);
                        }
                    } catch (e_2_1) {
                        e_2 = {
                            error: e_2_1
                        };
                    } finally{
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        } finally{
                            if (e_2) throw e_2.error;
                        }
                    }
                }
            } catch (e_1_1) {
                e_1 = {
                    error: e_1_1
                };
            } finally{
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                } finally{
                    if (e_1) throw e_1.error;
                }
            }
            return true;
        } else if (raHeader) {
            this._rateLimits.all = new Date(now + (0, $byuqS.parseRetryAfterHeader)(now, raHeader));
            return true;
        }
        return false;
    };
    return BaseTransport;
}();


var $f8f431ae760f1577$var$global = (0, $byuqS.getGlobalObject)();
/** `fetch` based transport */ var $f8f431ae760f1577$export$2bdee3f9b92f4e82 = /** @class */ function(_super) {
    (0, $90104860b1e5ba1f$export$a8ba968b8961cb8a)(FetchTransport, _super);
    function FetchTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ FetchTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $506a4164fe36069f$export$2006389de558b996)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ FetchTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $506a4164fe36069f$export$977ee6eda1884ec3)(session, this._api), session);
    };
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ FetchTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        if (this._isRateLimited(sentryRequest.type)) return Promise.reject({
            event: originalPayload,
            type: sentryRequest.type,
            reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
            status: 429
        });
        var options = {
            body: sentryRequest.body,
            method: "POST",
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default
            // https://caniuse.com/#feat=referrer-policy
            // It doesn't. And it throw exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (0, $d3659c5e6757ce18$export$2d308b428295192f)() ? "origin" : ""
        };
        if (this.options.fetchParameters !== undefined) Object.assign(options, this.options.fetchParameters);
        if (this.options.headers !== undefined) options.headers = this.options.headers;
        return this._buffer.add(new (0, $6e504369e1fed547$export$6f292d4960313241)(function(resolve, reject) {
            $f8f431ae760f1577$var$global.fetch(sentryRequest.url, options).then(function(response) {
                var headers = {
                    "x-sentry-rate-limits": response.headers.get("X-Sentry-Rate-Limits"),
                    "retry-after": response.headers.get("Retry-After")
                };
                _this._handleResponse({
                    requestType: sentryRequest.type,
                    response: response,
                    headers: headers,
                    resolve: resolve,
                    reject: reject
                });
            }).catch(reject);
        }));
    };
    return FetchTransport;
}((0, $ee7d6b37fb56964c$export$74b99d619e90f481));





/** `XHR` based transport */ var $8587fb0ea2174ad4$export$874a283af77e8e62 = /** @class */ function(_super) {
    (0, $90104860b1e5ba1f$export$a8ba968b8961cb8a)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ XHRTransport.prototype.sendEvent = function(event) {
        return this._sendRequest((0, $506a4164fe36069f$export$2006389de558b996)(event, this._api), event);
    };
    /**
     * @inheritDoc
     */ XHRTransport.prototype.sendSession = function(session) {
        return this._sendRequest((0, $506a4164fe36069f$export$977ee6eda1884ec3)(session, this._api), session);
    };
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */ XHRTransport.prototype._sendRequest = function(sentryRequest, originalPayload) {
        var _this = this;
        if (this._isRateLimited(sentryRequest.type)) return Promise.reject({
            event: originalPayload,
            type: sentryRequest.type,
            reason: "Transport locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
            status: 429
        });
        return this._buffer.add(new (0, $6e504369e1fed547$export$6f292d4960313241)(function(resolve, reject) {
            var request = new XMLHttpRequest();
            request.onreadystatechange = function() {
                if (request.readyState === 4) {
                    var headers = {
                        "x-sentry-rate-limits": request.getResponseHeader("X-Sentry-Rate-Limits"),
                        "retry-after": request.getResponseHeader("Retry-After")
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: request,
                        headers: headers,
                        resolve: resolve,
                        reject: reject
                    });
                }
            };
            request.open("POST", sentryRequest.url);
            for(var header in _this.options.headers)if (_this.options.headers.hasOwnProperty(header)) request.setRequestHeader(header, _this.options.headers[header]);
            request.send(sentryRequest.body);
        }));
    };
    return XHRTransport;
}((0, $ee7d6b37fb56964c$export$74b99d619e90f481));


/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */ var $d95affeacbf42995$export$2526e21aec9d0ce7 = /** @class */ function(_super) {
    (0, $90104860b1e5ba1f$export$a8ba968b8961cb8a)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromException = function(exception, hint) {
        return (0, $c8e7e65862700028$export$ea3ec7e569b823fc)(this._options, exception, hint);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype.eventFromMessage = function(message, level, hint) {
        if (level === void 0) level = (0, $e91087a6ec178c2a$export$918a9776c0a3cf27).Info;
        return (0, $c8e7e65862700028$export$5425b53185d13d6c)(this._options, message, level, hint);
    };
    /**
     * @inheritDoc
     */ BrowserBackend.prototype._setupTransport = function() {
        if (!this._options.dsn) // We return the noop transport here in case there is no Dsn.
        return _super.prototype._setupTransport.call(this);
        var transportOptions = (0, $90104860b1e5ba1f$export$18ce0697a983be9b)((0, $90104860b1e5ba1f$export$18ce0697a983be9b)({}, this._options.transportOptions), {
            dsn: this._options.dsn
        });
        if (this._options.transport) return new this._options.transport(transportOptions);
        if ((0, $d3659c5e6757ce18$export$edf3cb81fd7d2a3e)()) return new (0, $f8f431ae760f1577$export$2bdee3f9b92f4e82)(transportOptions);
        return new (0, $8587fb0ea2174ad4$export$874a283af77e8e62)(transportOptions);
    };
    return BrowserBackend;
}((0, $1e00dee6ab67074b$export$8f43a53a38d7e95f));





var $byuqS = parcelRequire("byuqS");
var $0e46104ae750e47a$var$ignoreOnError = 0;
function $0e46104ae750e47a$export$b79738ab10c590b2() {
    return $0e46104ae750e47a$var$ignoreOnError > 0;
}
function $0e46104ae750e47a$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $0e46104ae750e47a$var$ignoreOnError += 1;
    setTimeout(function() {
        $0e46104ae750e47a$var$ignoreOnError -= 1;
    });
}
function $0e46104ae750e47a$export$4997ffc0176396a6(fn, options, before) {
    if (options === void 0) options = {};
    if (typeof fn !== "function") return fn;
    try {
        // We don't wanna wrap it twice
        if (fn.__sentry__) return fn;
        // If this has already been wrapped in the past, return that wrapped function
        if (fn.__sentry_wrapped__) return fn.__sentry_wrapped__;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function() {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === "function") before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function(arg) {
                return $0e46104ae750e47a$export$4997ffc0176396a6(arg, options);
            });
            if (fn.handleEvent) // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return fn.handleEvent.apply(this, wrappedArguments);
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $0e46104ae750e47a$export$1265a142ff5ba165();
            (0, $3ae32034d8d01628$export$ec58d9285c204497)(function(scope) {
                scope.addEventProcessor(function(event) {
                    var processedEvent = (0, $90104860b1e5ba1f$export$18ce0697a983be9b)({}, event);
                    if (options.mechanism) {
                        (0, $byuqS.addExceptionTypeValue)(processedEvent, undefined, undefined);
                        (0, $byuqS.addExceptionMechanism)(processedEvent, options.mechanism);
                    }
                    processedEvent.extra = (0, $90104860b1e5ba1f$export$18ce0697a983be9b)((0, $90104860b1e5ba1f$export$18ce0697a983be9b)({}, processedEvent.extra), {
                        arguments: args
                    });
                    return processedEvent;
                });
                (0, $3ae32034d8d01628$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(var property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    fn.prototype = fn.prototype || {};
    sentryWrapped.prototype = fn.prototype;
    Object.defineProperty(fn, "__sentry_wrapped__", {
        enumerable: false,
        value: sentryWrapped
    });
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    Object.defineProperties(sentryWrapped, {
        __sentry__: {
            enumerable: false,
            value: true
        },
        __sentry_original__: {
            enumerable: false,
            value: fn
        }
    });
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, "name");
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, "name", {
            get: function() {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}
function $0e46104ae750e47a$export$deb9aac8ea0b576c(options) {
    if (options === void 0) options = {};
    if (!options.eventId) {
        (0, $ac919b34c52e6588$export$af88d00dbe7f521).error("Missing eventId option in showReportDialog call");
        return;
    }
    if (!options.dsn) {
        (0, $ac919b34c52e6588$export$af88d00dbe7f521).error("Missing dsn option in showReportDialog call");
        return;
    }
    var script = document.createElement("script");
    script.async = true;
    script.src = new (0, $39f9f6580b14b664$export$2c4e825dc9120f87)(options.dsn).getReportDialogEndpoint(options);
    if (options.onLoad) // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
    (document.head || document.body).appendChild(script);
}






var $byuqS = parcelRequire("byuqS");
var $gwbjx = parcelRequire("gwbjx");
var $aVWL9 = parcelRequire("aVWL9");
/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */ var $40537263cee926f6$export$2dc68d50d56fbbd = /** @class */ function() {
    /**
     * @inheritDoc
     */ function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */ this.name = Breadcrumbs.id;
        this._options = (0, $90104860b1e5ba1f$export$18ce0697a983be9b)({
            console: true,
            dom: true,
            fetch: true,
            history: true,
            sentry: true,
            xhr: true
        }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */ Breadcrumbs.prototype.addSentryBreadcrumb = function(event) {
        if (!this._options.sentry) return;
        (0, $03b756c195b1c14e$export$a07cdf6544bbd7c)().addBreadcrumb({
            category: "sentry." + (event.type === "transaction" ? "transaction" : "event"),
            event_id: event.event_id,
            level: event.level,
            message: (0, $byuqS.getEventDescription)(event)
        }, {
            event: event
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */ Breadcrumbs.prototype.setupOnce = function() {
        var _this = this;
        if (this._options.console) (0, $3e55b6c60c4dfa3b$export$285b9172a3741fb7)({
            callback: function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                _this._consoleBreadcrumb.apply(_this, (0, $90104860b1e5ba1f$export$afc72e2116322959)(args));
            },
            type: "console"
        });
        if (this._options.dom) (0, $3e55b6c60c4dfa3b$export$285b9172a3741fb7)({
            callback: function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                _this._domBreadcrumb.apply(_this, (0, $90104860b1e5ba1f$export$afc72e2116322959)(args));
            },
            type: "dom"
        });
        if (this._options.xhr) (0, $3e55b6c60c4dfa3b$export$285b9172a3741fb7)({
            callback: function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                _this._xhrBreadcrumb.apply(_this, (0, $90104860b1e5ba1f$export$afc72e2116322959)(args));
            },
            type: "xhr"
        });
        if (this._options.fetch) (0, $3e55b6c60c4dfa3b$export$285b9172a3741fb7)({
            callback: function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                _this._fetchBreadcrumb.apply(_this, (0, $90104860b1e5ba1f$export$afc72e2116322959)(args));
            },
            type: "fetch"
        });
        if (this._options.history) (0, $3e55b6c60c4dfa3b$export$285b9172a3741fb7)({
            callback: function() {
                var args = [];
                for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                _this._historyBreadcrumb.apply(_this, (0, $90104860b1e5ba1f$export$afc72e2116322959)(args));
            },
            type: "history"
        });
    };
    /**
     * Creates breadcrumbs from console API calls
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._consoleBreadcrumb = function(handlerData) {
        var breadcrumb = {
            category: "console",
            data: {
                arguments: handlerData.args,
                logger: "console"
            },
            level: (0, $e91087a6ec178c2a$export$918a9776c0a3cf27).fromString(handlerData.level),
            message: (0, $aVWL9.safeJoin)(handlerData.args, " ")
        };
        if (handlerData.level === "assert") {
            if (handlerData.args[0] === false) {
                breadcrumb.message = "Assertion failed: " + ((0, $aVWL9.safeJoin)(handlerData.args.slice(1), " ") || "console.assert");
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $03b756c195b1c14e$export$a07cdf6544bbd7c)().addBreadcrumb(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
    /**
     * Creates breadcrumbs from DOM API calls
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._domBreadcrumb = function(handlerData) {
        var target;
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target ? (0, $gwbjx.htmlTreeAsString)(handlerData.event.target) : (0, $gwbjx.htmlTreeAsString)(handlerData.event);
        } catch (e) {
            target = "<unknown>";
        }
        if (target.length === 0) return;
        (0, $03b756c195b1c14e$export$a07cdf6544bbd7c)().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target
        }, {
            event: handlerData.event,
            name: handlerData.name
        });
    };
    /**
     * Creates breadcrumbs from XHR API calls
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._xhrBreadcrumb = function(handlerData) {
        if (handlerData.endTimestamp) {
            // We only capture complete, non-sentry requests
            if (handlerData.xhr.__sentry_own_request__) return;
            var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
            (0, $03b756c195b1c14e$export$a07cdf6544bbd7c)().addBreadcrumb({
                category: "xhr",
                data: {
                    method: method,
                    url: url,
                    status_code: status_code
                },
                type: "http"
            }, {
                xhr: handlerData.xhr,
                input: body
            });
            return;
        }
    };
    /**
     * Creates breadcrumbs from fetch API calls
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._fetchBreadcrumb = function(handlerData) {
        // We only capture complete fetch requests
        if (!handlerData.endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === "POST") // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) (0, $03b756c195b1c14e$export$a07cdf6544bbd7c)().addBreadcrumb({
            category: "fetch",
            data: handlerData.fetchData,
            level: (0, $e91087a6ec178c2a$export$918a9776c0a3cf27).Error,
            type: "http"
        }, {
            data: handlerData.error,
            input: handlerData.args
        });
        else (0, $03b756c195b1c14e$export$a07cdf6544bbd7c)().addBreadcrumb({
            category: "fetch",
            data: (0, $90104860b1e5ba1f$export$18ce0697a983be9b)((0, $90104860b1e5ba1f$export$18ce0697a983be9b)({}, handlerData.fetchData), {
                status_code: handlerData.response.status
            }),
            type: "http"
        }, {
            input: handlerData.args,
            response: handlerData.response
        });
    };
    /**
     * Creates breadcrumbs from history API calls
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Breadcrumbs.prototype._historyBreadcrumb = function(handlerData) {
        var global = (0, $byuqS.getGlobalObject)();
        var from = handlerData.from;
        var to = handlerData.to;
        var parsedLoc = (0, $byuqS.parseUrl)(global.location.href);
        var parsedFrom = (0, $byuqS.parseUrl)(from);
        var parsedTo = (0, $byuqS.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $03b756c195b1c14e$export$a07cdf6544bbd7c)().addBreadcrumb({
            category: "navigation",
            data: {
                from: from,
                to: to
            }
        });
    };
    /**
     * @inheritDoc
     */ Breadcrumbs.id = "Breadcrumbs";
    return Breadcrumbs;
}();


var $a676a26e652fd720$export$ca61d37259221480 = "sentry.javascript.browser";
var $a676a26e652fd720$export$31499a9cd224b78c = "5.30.0";


/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ var $ca591ad9be1bc3ce$export$1df9218a526d318d = /** @class */ function(_super) {
    (0, $90104860b1e5ba1f$export$a8ba968b8961cb8a)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */ function BrowserClient(options) {
        if (options === void 0) options = {};
        return _super.call(this, (0, $d95affeacbf42995$export$2526e21aec9d0ce7), options) || this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */ BrowserClient.prototype.showReportDialog = function(options) {
        if (options === void 0) options = {};
        // doesn't work without a document (React Native)
        var document = (0, $byuqS.getGlobalObject)().document;
        if (!document) return;
        if (!this._isEnabled()) {
            (0, $ac919b34c52e6588$export$af88d00dbe7f521).error("Trying to call showReportDialog with Sentry Client disabled");
            return;
        }
        (0, $0e46104ae750e47a$export$deb9aac8ea0b576c)((0, $90104860b1e5ba1f$export$18ce0697a983be9b)((0, $90104860b1e5ba1f$export$18ce0697a983be9b)({}, options), {
            dsn: options.dsn || this.getDsn()
        }));
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._prepareEvent = function(event, scope, hint) {
        event.platform = event.platform || "javascript";
        event.sdk = (0, $90104860b1e5ba1f$export$18ce0697a983be9b)((0, $90104860b1e5ba1f$export$18ce0697a983be9b)({}, event.sdk), {
            name: (0, $a676a26e652fd720$export$ca61d37259221480),
            packages: (0, $90104860b1e5ba1f$export$afc72e2116322959)(event.sdk && event.sdk.packages || [], [
                {
                    name: "npm:@sentry/browser",
                    version: (0, $a676a26e652fd720$export$31499a9cd224b78c)
                }
            ]),
            version: (0, $a676a26e652fd720$export$31499a9cd224b78c)
        });
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */ BrowserClient.prototype._sendEvent = function(event) {
        var integration = this.getIntegration((0, $40537263cee926f6$export$2dc68d50d56fbbd));
        if (integration) integration.addSentryBreadcrumb(event);
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}((0, $1f14ff2acf2fa3fa$export$4f22f74eddb7716a));






function $64a1e7372262c48f$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) (0, $ac919b34c52e6588$export$af88d00dbe7f521).enable();
    var hub = (0, $03b756c195b1c14e$export$a07cdf6544bbd7c)();
    var client = new clientClass(options);
    hub.bindClient(client);
}

var $096e85a37773d599$exports = {};

$parcel$export($096e85a37773d599$exports, "FunctionToString", function () { return $c548dcfad51c7f57$export$da4704525c20ae79; });
$parcel$export($096e85a37773d599$exports, "InboundFilters", function () { return $30fb7ee7c2692dfb$export$2ffbb5359dcc6be4; });
var $c548dcfad51c7f57$var$originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */ var $c548dcfad51c7f57$export$da4704525c20ae79 = /** @class */ function() {
    function FunctionToString() {
        /**
         * @inheritDoc
         */ this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */ FunctionToString.prototype.setupOnce = function() {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        $c548dcfad51c7f57$var$originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var context = this.__sentry_original__ || this;
            return $c548dcfad51c7f57$var$originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */ FunctionToString.id = "FunctionToString";
    return FunctionToString;
}();





var $byuqS = parcelRequire("byuqS");
var $aVWL9 = parcelRequire("aVWL9");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var $30fb7ee7c2692dfb$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/
];
/** Inbound filters configurable by the user */ var $30fb7ee7c2692dfb$export$2ffbb5359dcc6be4 = /** @class */ function() {
    function InboundFilters(_options) {
        if (_options === void 0) _options = {};
        this._options = _options;
        /**
         * @inheritDoc
         */ this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */ InboundFilters.prototype.setupOnce = function() {
        (0, $3024fb3366777167$export$8e4e25f54d456511)(function(event) {
            var hub = (0, $03b756c195b1c14e$export$a07cdf6544bbd7c)();
            if (!hub) return event;
            var self = hub.getIntegration(InboundFilters);
            if (self) {
                var client = hub.getClient();
                var clientOptions = client ? client.getOptions() : {};
                var options = self._mergeOptions(clientOptions);
                if (self._shouldDropEvent(event, options)) return null;
            }
            return event;
        });
    };
    /** JSDoc */ InboundFilters.prototype._shouldDropEvent = function(event, options) {
        if (this._isSentryError(event, options)) {
            (0, $ac919b34c52e6588$export$af88d00dbe7f521).warn("Event dropped due to being internal Sentry Error.\nEvent: " + (0, $byuqS.getEventDescription)(event));
            return true;
        }
        if (this._isIgnoredError(event, options)) {
            (0, $ac919b34c52e6588$export$af88d00dbe7f521).warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + (0, $byuqS.getEventDescription)(event));
            return true;
        }
        if (this._isDeniedUrl(event, options)) {
            (0, $ac919b34c52e6588$export$af88d00dbe7f521).warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + (0, $byuqS.getEventDescription)(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        if (!this._isAllowedUrl(event, options)) {
            (0, $ac919b34c52e6588$export$af88d00dbe7f521).warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + (0, $byuqS.getEventDescription)(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            return true;
        }
        return false;
    };
    /** JSDoc */ InboundFilters.prototype._isSentryError = function(event, options) {
        if (!options.ignoreInternal) return false;
        try {
            return event && event.exception && event.exception.values && event.exception.values[0] && event.exception.values[0].type === "SentryError" || false;
        } catch (_oO) {
            return false;
        }
    };
    /** JSDoc */ InboundFilters.prototype._isIgnoredError = function(event, options) {
        if (!options.ignoreErrors || !options.ignoreErrors.length) return false;
        return this._getPossibleEventMessages(event).some(function(message) {
            // Not sure why TypeScript complains here...
            return options.ignoreErrors.some(function(pattern) {
                return (0, $aVWL9.isMatchingPattern)(message, pattern);
            });
        });
    };
    /** JSDoc */ InboundFilters.prototype._isDeniedUrl = function(event, options) {
        // TODO: Use Glob instead?
        if (!options.denyUrls || !options.denyUrls.length) return false;
        var url = this._getEventFilterUrl(event);
        return !url ? false : options.denyUrls.some(function(pattern) {
            return (0, $aVWL9.isMatchingPattern)(url, pattern);
        });
    };
    /** JSDoc */ InboundFilters.prototype._isAllowedUrl = function(event, options) {
        // TODO: Use Glob instead?
        if (!options.allowUrls || !options.allowUrls.length) return true;
        var url = this._getEventFilterUrl(event);
        return !url ? true : options.allowUrls.some(function(pattern) {
            return (0, $aVWL9.isMatchingPattern)(url, pattern);
        });
    };
    /** JSDoc */ InboundFilters.prototype._mergeOptions = function(clientOptions) {
        if (clientOptions === void 0) clientOptions = {};
        return {
            allowUrls: (0, $b6a38a095f2aae4e$export$afc72e2116322959)(this._options.whitelistUrls || [], this._options.allowUrls || [], clientOptions.whitelistUrls || [], clientOptions.allowUrls || []),
            denyUrls: (0, $b6a38a095f2aae4e$export$afc72e2116322959)(this._options.blacklistUrls || [], this._options.denyUrls || [], clientOptions.blacklistUrls || [], clientOptions.denyUrls || []),
            ignoreErrors: (0, $b6a38a095f2aae4e$export$afc72e2116322959)(this._options.ignoreErrors || [], clientOptions.ignoreErrors || [], $30fb7ee7c2692dfb$var$DEFAULT_IGNORE_ERRORS),
            ignoreInternal: typeof this._options.ignoreInternal !== "undefined" ? this._options.ignoreInternal : true
        };
    };
    /** JSDoc */ InboundFilters.prototype._getPossibleEventMessages = function(event) {
        if (event.message) return [
            event.message
        ];
        if (event.exception) try {
            var _a = event.exception.values && event.exception.values[0] || {}, _b = _a.type, type = _b === void 0 ? "" : _b, _c = _a.value, value = _c === void 0 ? "" : _c;
            return [
                "" + value,
                type + ": " + value
            ];
        } catch (oO) {
            (0, $ac919b34c52e6588$export$af88d00dbe7f521).error("Cannot extract message for event " + (0, $byuqS.getEventDescription)(event));
            return [];
        }
        return [];
    };
    /** JSDoc */ InboundFilters.prototype._getEventFilterUrl = function(event) {
        try {
            if (event.stacktrace) {
                var frames_1 = event.stacktrace.frames;
                return frames_1 && frames_1[frames_1.length - 1].filename || null;
            }
            if (event.exception) {
                var frames_2 = event.exception.values && event.exception.values[0].stacktrace && event.exception.values[0].stacktrace.frames;
                return frames_2 && frames_2[frames_2.length - 1].filename || null;
            }
            return null;
        } catch (oO) {
            (0, $ac919b34c52e6588$export$af88d00dbe7f521).error("Cannot extract url for event " + (0, $byuqS.getEventDescription)(event));
            return null;
        }
    };
    /**
     * @inheritDoc
     */ InboundFilters.id = "InboundFilters";
    return InboundFilters;
}();





var $byuqS = parcelRequire("byuqS");






var $byuqS = parcelRequire("byuqS");
var $jNciV = parcelRequire("jNciV");


/** Global handlers */ var $a5cc53f2ae4b6b9c$export$204155decbc90e5a = /** @class */ function() {
    /** JSDoc */ function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */ this.name = GlobalHandlers.id;
        /** JSDoc */ this._onErrorHandlerInstalled = false;
        /** JSDoc */ this._onUnhandledRejectionHandlerInstalled = false;
        this._options = (0, $90104860b1e5ba1f$export$18ce0697a983be9b)({
            onerror: true,
            onunhandledrejection: true
        }, options);
    }
    /**
     * @inheritDoc
     */ GlobalHandlers.prototype.setupOnce = function() {
        Error.stackTraceLimit = 50;
        if (this._options.onerror) {
            (0, $ac919b34c52e6588$export$af88d00dbe7f521).log("Global Handler attached: onerror");
            this._installGlobalOnErrorHandler();
        }
        if (this._options.onunhandledrejection) {
            (0, $ac919b34c52e6588$export$af88d00dbe7f521).log("Global Handler attached: onunhandledrejection");
            this._installGlobalOnUnhandledRejectionHandler();
        }
    };
    /** JSDoc */ GlobalHandlers.prototype._installGlobalOnErrorHandler = function() {
        var _this = this;
        if (this._onErrorHandlerInstalled) return;
        (0, $3e55b6c60c4dfa3b$export$285b9172a3741fb7)({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            callback: function(data) {
                var error = data.error;
                var currentHub = (0, $03b756c195b1c14e$export$a07cdf6544bbd7c)();
                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
                if (!hasIntegration || (0, $0e46104ae750e47a$export$b79738ab10c590b2)() || isFailedOwnDelivery) return;
                var client = currentHub.getClient();
                var event = (0, $jNciV.isPrimitive)(error) ? _this._eventFromIncompleteOnError(data.msg, data.url, data.line, data.column) : _this._enhanceEventWithInitialFrame((0, $c8e7e65862700028$export$9dd56ed1ef0c3420)(error, undefined, {
                    attachStacktrace: client && client.getOptions().attachStacktrace,
                    rejection: false
                }), data.url, data.line, data.column);
                (0, $byuqS.addExceptionMechanism)(event, {
                    handled: false,
                    type: "onerror"
                });
                currentHub.captureEvent(event, {
                    originalException: error
                });
            },
            type: "error"
        });
        this._onErrorHandlerInstalled = true;
    };
    /** JSDoc */ GlobalHandlers.prototype._installGlobalOnUnhandledRejectionHandler = function() {
        var _this = this;
        if (this._onUnhandledRejectionHandlerInstalled) return;
        (0, $3e55b6c60c4dfa3b$export$285b9172a3741fb7)({
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            callback: function(e) {
                var error = e;
                // dig the object of the rejection out of known event types
                try {
                    // PromiseRejectionEvents store the object of the rejection under 'reason'
                    // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
                    if ("reason" in e) error = e.reason;
                    else if ("detail" in e && "reason" in e.detail) error = e.detail.reason;
                } catch (_oO) {
                // no-empty
                }
                var currentHub = (0, $03b756c195b1c14e$export$a07cdf6544bbd7c)();
                var hasIntegration = currentHub.getIntegration(GlobalHandlers);
                var isFailedOwnDelivery = error && error.__sentry_own_request__ === true;
                if (!hasIntegration || (0, $0e46104ae750e47a$export$b79738ab10c590b2)() || isFailedOwnDelivery) return true;
                var client = currentHub.getClient();
                var event = (0, $jNciV.isPrimitive)(error) ? _this._eventFromRejectionWithPrimitive(error) : (0, $c8e7e65862700028$export$9dd56ed1ef0c3420)(error, undefined, {
                    attachStacktrace: client && client.getOptions().attachStacktrace,
                    rejection: true
                });
                event.level = (0, $e91087a6ec178c2a$export$918a9776c0a3cf27).Error;
                (0, $byuqS.addExceptionMechanism)(event, {
                    handled: false,
                    type: "onunhandledrejection"
                });
                currentHub.captureEvent(event, {
                    originalException: error
                });
                return;
            },
            type: "unhandledrejection"
        });
        this._onUnhandledRejectionHandlerInstalled = true;
    };
    /**
     * This function creates a stack from an old, error-less onerror handler.
     */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalHandlers.prototype._eventFromIncompleteOnError = function(msg, url, line, column) {
        var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
        // If 'message' is ErrorEvent, get real message from inside
        var message = (0, $jNciV.isErrorEvent)(msg) ? msg.message : msg;
        var name;
        if ((0, $jNciV.isString)(message)) {
            var groups = message.match(ERROR_TYPES_RE);
            if (groups) {
                name = groups[1];
                message = groups[2];
            }
        }
        var event = {
            exception: {
                values: [
                    {
                        type: name || "Error",
                        value: message
                    }
                ]
            }
        };
        return this._enhanceEventWithInitialFrame(event, url, line, column);
    };
    /**
     * Create an event from a promise rejection where the `reason` is a primitive.
     *
     * @param reason: The `reason` property of the promise rejection
     * @returns An Event object with an appropriate `exception` value
     */ GlobalHandlers.prototype._eventFromRejectionWithPrimitive = function(reason) {
        return {
            exception: {
                values: [
                    {
                        type: "UnhandledRejection",
                        // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                        value: "Non-Error promise rejection captured with value: " + String(reason)
                    }
                ]
            }
        };
    };
    /** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    GlobalHandlers.prototype._enhanceEventWithInitialFrame = function(event, url, line, column) {
        event.exception = event.exception || {};
        event.exception.values = event.exception.values || [];
        event.exception.values[0] = event.exception.values[0] || {};
        event.exception.values[0].stacktrace = event.exception.values[0].stacktrace || {};
        event.exception.values[0].stacktrace.frames = event.exception.values[0].stacktrace.frames || [];
        var colno = isNaN(parseInt(column, 10)) ? undefined : column;
        var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
        var filename = (0, $jNciV.isString)(url) && url.length > 0 ? url : (0, $byuqS.getLocationHref)();
        if (event.exception.values[0].stacktrace.frames.length === 0) event.exception.values[0].stacktrace.frames.push({
            colno: colno,
            filename: filename,
            function: "?",
            in_app: true,
            lineno: lineno
        });
        return event;
    };
    /**
     * @inheritDoc
     */ GlobalHandlers.id = "GlobalHandlers";
    return GlobalHandlers;
}();




var $jNciV = parcelRequire("jNciV");


var $019d5e9c9790b4b9$var$DEFAULT_KEY = "cause";
var $019d5e9c9790b4b9$var$DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */ var $019d5e9c9790b4b9$export$8d1e60aaf616fb4f = /** @class */ function() {
    /**
     * @inheritDoc
     */ function LinkedErrors(options) {
        if (options === void 0) options = {};
        /**
         * @inheritDoc
         */ this.name = LinkedErrors.id;
        this._key = options.key || $019d5e9c9790b4b9$var$DEFAULT_KEY;
        this._limit = options.limit || $019d5e9c9790b4b9$var$DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */ LinkedErrors.prototype.setupOnce = function() {
        (0, $3024fb3366777167$export$8e4e25f54d456511)(function(event, hint) {
            var self = (0, $03b756c195b1c14e$export$a07cdf6544bbd7c)().getIntegration(LinkedErrors);
            if (self) return self._handler(event, hint);
            return event;
        });
    };
    /**
     * @inheritDoc
     */ LinkedErrors.prototype._handler = function(event, hint) {
        if (!event.exception || !event.exception.values || !hint || !(0, $jNciV.isInstanceOf)(hint.originalException, Error)) return event;
        var linkedErrors = this._walkErrorTree(hint.originalException, this._key);
        event.exception.values = (0, $90104860b1e5ba1f$export$afc72e2116322959)(linkedErrors, event.exception.values);
        return event;
    };
    /**
     * @inheritDoc
     */ LinkedErrors.prototype._walkErrorTree = function(error, key, stack) {
        if (stack === void 0) stack = [];
        if (!(0, $jNciV.isInstanceOf)(error[key], Error) || stack.length + 1 >= this._limit) return stack;
        var stacktrace = (0, $612c1fd465869f05$export$81296eded4f2ac09)(error[key]);
        var exception = (0, $de34cb4710a33f17$export$cff07df76f81a017)(stacktrace);
        return this._walkErrorTree(error[key], key, (0, $90104860b1e5ba1f$export$afc72e2116322959)([
            exception
        ], stack));
    };
    /**
     * @inheritDoc
     */ LinkedErrors.id = "LinkedErrors";
    return LinkedErrors;
}();



var $hKTDd = parcelRequire("hKTDd");
var $eHZGJ = parcelRequire("eHZGJ");
var $byuqS = parcelRequire("byuqS");

var $22cd1a6b685e708d$var$DEFAULT_EVENT_TARGET = [
    "EventTarget",
    "Window",
    "Node",
    "ApplicationCache",
    "AudioTrackList",
    "ChannelMergerNode",
    "CryptoOperation",
    "EventSource",
    "FileReader",
    "HTMLUnknownElement",
    "IDBDatabase",
    "IDBRequest",
    "IDBTransaction",
    "KeyOperation",
    "MediaController",
    "MessagePort",
    "ModalWindow",
    "Notification",
    "SVGElementInstance",
    "Screen",
    "TextTrack",
    "TextTrackCue",
    "TextTrackList",
    "WebSocket",
    "WebSocketWorker",
    "Worker",
    "XMLHttpRequest",
    "XMLHttpRequestEventTarget",
    "XMLHttpRequestUpload"
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */ var $22cd1a6b685e708d$export$f1a018517668e6d3 = /** @class */ function() {
    /**
     * @inheritDoc
     */ function TryCatch(options) {
        /**
         * @inheritDoc
         */ this.name = TryCatch.id;
        this._options = (0, $90104860b1e5ba1f$export$18ce0697a983be9b)({
            XMLHttpRequest: true,
            eventTarget: true,
            requestAnimationFrame: true,
            setInterval: true,
            setTimeout: true
        }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */ TryCatch.prototype.setupOnce = function() {
        var global = (0, $byuqS.getGlobalObject)();
        if (this._options.setTimeout) (0, $hKTDd.fill)(global, "setTimeout", this._wrapTimeFunction.bind(this));
        if (this._options.setInterval) (0, $hKTDd.fill)(global, "setInterval", this._wrapTimeFunction.bind(this));
        if (this._options.requestAnimationFrame) (0, $hKTDd.fill)(global, "requestAnimationFrame", this._wrapRAF.bind(this));
        if (this._options.XMLHttpRequest && "XMLHttpRequest" in global) (0, $hKTDd.fill)(XMLHttpRequest.prototype, "send", this._wrapXHR.bind(this));
        if (this._options.eventTarget) {
            var eventTarget = Array.isArray(this._options.eventTarget) ? this._options.eventTarget : $22cd1a6b685e708d$var$DEFAULT_EVENT_TARGET;
            eventTarget.forEach(this._wrapEventTarget.bind(this));
        }
    };
    /** JSDoc */ TryCatch.prototype._wrapTimeFunction = function(original) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            var originalCallback = args[0];
            args[0] = (0, $0e46104ae750e47a$export$4997ffc0176396a6)(originalCallback, {
                mechanism: {
                    data: {
                        function: (0, $eHZGJ.getFunctionName)(original)
                    },
                    handled: true,
                    type: "instrument"
                }
            });
            return original.apply(this, args);
        };
    };
    /** JSDoc */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    TryCatch.prototype._wrapRAF = function(original) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function(callback) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return original.call(this, (0, $0e46104ae750e47a$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: "requestAnimationFrame",
                        handler: (0, $eHZGJ.getFunctionName)(original)
                    },
                    handled: true,
                    type: "instrument"
                }
            }));
        };
    };
    /** JSDoc */ TryCatch.prototype._wrapEventTarget = function(target) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var global = (0, $byuqS.getGlobalObject)();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = global[target] && global[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty("addEventListener")) return;
        (0, $hKTDd.fill)(proto, "addEventListener", function(original) {
            return function(eventName, fn, options) {
                try {
                    if (typeof fn.handleEvent === "function") fn.handleEvent = (0, $0e46104ae750e47a$export$4997ffc0176396a6)(fn.handleEvent.bind(fn), {
                        mechanism: {
                            data: {
                                function: "handleEvent",
                                handler: (0, $eHZGJ.getFunctionName)(fn),
                                target: target
                            },
                            handled: true,
                            type: "instrument"
                        }
                    });
                } catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
                }
                return original.call(this, eventName, // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $0e46104ae750e47a$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: "addEventListener",
                            handler: (0, $eHZGJ.getFunctionName)(fn),
                            target: target
                        },
                        handled: true,
                        type: "instrument"
                    }
                }), options);
            };
        });
        (0, $hKTDd.fill)(proto, "removeEventListener", function(originalRemoveEventListener) {
            return function(eventName, fn, options) {
                var _a;
                /**
                 * There are 2 possible scenarios here:
                 *
                 * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
                 * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
                 * as a pass-through, and call original `removeEventListener` with it.
                 *
                 * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
                 * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
                 * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
                 * in order for us to make a distinction between wrapped/non-wrapped functions possible.
                 * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
                 *
                 * When someone adds a handler prior to initialization, and then do it again, but after,
                 * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
                 * to get rid of the initial handler and it'd stick there forever.
                 */ var wrappedEventHandler = fn;
                try {
                    var originalEventHandler = (_a = wrappedEventHandler) === null || _a === void 0 ? void 0 : _a.__sentry_wrapped__;
                    if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                } catch (e) {
                // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
                }
                return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
            };
        });
    };
    /** JSDoc */ TryCatch.prototype._wrapXHR = function(originalSend) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var xmlHttpRequestProps = [
                "onload",
                "onerror",
                "onprogress",
                "onreadystatechange"
            ];
            xmlHttpRequestProps.forEach(function(prop) {
                if (prop in xhr && typeof xhr[prop] === "function") // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $hKTDd.fill)(xhr, prop, function(original) {
                    var wrapOptions = {
                        mechanism: {
                            data: {
                                function: prop,
                                handler: (0, $eHZGJ.getFunctionName)(original)
                            },
                            handled: true,
                            type: "instrument"
                        }
                    };
                    // If Instrument integration has been called before TryCatch, get the name of original function
                    if (original.__sentry_original__) wrapOptions.mechanism.data.handler = (0, $eHZGJ.getFunctionName)(original.__sentry_original__);
                    // Otherwise wrap directly
                    return (0, $0e46104ae750e47a$export$4997ffc0176396a6)(original, wrapOptions);
                });
            });
            return originalSend.apply(this, args);
        };
    };
    /**
     * @inheritDoc
     */ TryCatch.id = "TryCatch";
    return TryCatch;
}();




var $byuqS = parcelRequire("byuqS");
var $e80b20c276314db6$var$global = (0, $byuqS.getGlobalObject)();
/** UserAgent */ var $e80b20c276314db6$export$5fba5e10934a4faf = /** @class */ function() {
    function UserAgent() {
        /**
         * @inheritDoc
         */ this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */ UserAgent.prototype.setupOnce = function() {
        (0, $3024fb3366777167$export$8e4e25f54d456511)(function(event) {
            var _a, _b, _c;
            if ((0, $03b756c195b1c14e$export$a07cdf6544bbd7c)().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!$e80b20c276314db6$var$global.navigator && !$e80b20c276314db6$var$global.location && !$e80b20c276314db6$var$global.document) return event;
                // grab as much info as exists and add it to the event
                var url = ((_a = event.request) === null || _a === void 0 ? void 0 : _a.url) || ((_b = $e80b20c276314db6$var$global.location) === null || _b === void 0 ? void 0 : _b.href);
                var referrer = ($e80b20c276314db6$var$global.document || {}).referrer;
                var userAgent = ($e80b20c276314db6$var$global.navigator || {}).userAgent;
                var headers = (0, $90104860b1e5ba1f$export$18ce0697a983be9b)((0, $90104860b1e5ba1f$export$18ce0697a983be9b)((0, $90104860b1e5ba1f$export$18ce0697a983be9b)({}, (_c = event.request) === null || _c === void 0 ? void 0 : _c.headers), referrer && {
                    Referer: referrer
                }), userAgent && {
                    "User-Agent": userAgent
                });
                var request = (0, $90104860b1e5ba1f$export$18ce0697a983be9b)((0, $90104860b1e5ba1f$export$18ce0697a983be9b)({}, url && {
                    url: url
                }), {
                    headers: headers
                });
                return (0, $90104860b1e5ba1f$export$18ce0697a983be9b)((0, $90104860b1e5ba1f$export$18ce0697a983be9b)({}, event), {
                    request: request
                });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */ UserAgent.id = "UserAgent";
    return UserAgent;
}();


var $36e1c11cb61404a3$export$5ef831fccfce35e5 = [
    new (0, $096e85a37773d599$exports).InboundFilters(),
    new (0, $096e85a37773d599$exports).FunctionToString(),
    new (0, $22cd1a6b685e708d$export$f1a018517668e6d3)(),
    new (0, $40537263cee926f6$export$2dc68d50d56fbbd)(),
    new (0, $a5cc53f2ae4b6b9c$export$204155decbc90e5a)(),
    new (0, $019d5e9c9790b4b9$export$8d1e60aaf616fb4f)(),
    new (0, $e80b20c276314db6$export$5fba5e10934a4faf)()
];
function $36e1c11cb61404a3$export$2cd8252107eb640b(options) {
    if (options === void 0) options = {};
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $36e1c11cb61404a3$export$5ef831fccfce35e5;
    if (options.release === undefined) {
        var window_1 = (0, $byuqS.getGlobalObject)();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) options.release = window_1.SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = false;
    (0, $64a1e7372262c48f$export$5333c3f1c58d9bc1)((0, $ca591ad9be1bc3ce$export$1df9218a526d318d), options);
    if (options.autoSessionTracking) $36e1c11cb61404a3$var$startSessionTracking();
}
function $36e1c11cb61404a3$export$3a8fd680da42627b(options) {
    if (options === void 0) options = {};
    if (!options.eventId) options.eventId = (0, $03b756c195b1c14e$export$a07cdf6544bbd7c)().lastEventId();
    var client = (0, $03b756c195b1c14e$export$a07cdf6544bbd7c)().getClient();
    if (client) client.showReportDialog(options);
}
function $36e1c11cb61404a3$export$5d4e9fd7fac8e617() {
    return (0, $03b756c195b1c14e$export$a07cdf6544bbd7c)().lastEventId();
}
function $36e1c11cb61404a3$export$a3f323d81eede727() {
// Noop
}
function $36e1c11cb61404a3$export$4e4d8b287d028b6b(callback) {
    callback();
}
function $36e1c11cb61404a3$export$4909b86c8034bf73(timeout) {
    var client = (0, $03b756c195b1c14e$export$a07cdf6544bbd7c)().getClient();
    if (client) return client.flush(timeout);
    return (0, $6e504369e1fed547$export$6f292d4960313241).reject(false);
}
function $36e1c11cb61404a3$export$8360e631d277ea4d(timeout) {
    var client = (0, $03b756c195b1c14e$export$a07cdf6544bbd7c)().getClient();
    if (client) return client.close(timeout);
    return (0, $6e504369e1fed547$export$6f292d4960313241).reject(false);
}
function $36e1c11cb61404a3$export$4997ffc0176396a6(fn) {
    return (0, $0e46104ae750e47a$export$4997ffc0176396a6)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $36e1c11cb61404a3$var$startSessionTracking() {
    var window = (0, $byuqS.getGlobalObject)();
    var hub = (0, $03b756c195b1c14e$export$a07cdf6544bbd7c)();
    /**
     * We should be using `Promise.all([windowLoaded, firstContentfulPaint])` here,
     * but, as always, it's not available in the IE10-11. Thanks IE.
     */ var loadResolved = document.readyState === "complete";
    var fcpResolved = false;
    var possiblyEndSession = function() {
        if (fcpResolved && loadResolved) hub.endSession();
    };
    var resolveWindowLoaded = function() {
        loadResolved = true;
        possiblyEndSession();
        window.removeEventListener("load", resolveWindowLoaded);
    };
    hub.startSession();
    if (!loadResolved) // IE doesn't support `{ once: true }` for event listeners, so we have to manually
    // attach and then detach it once completed.
    window.addEventListener("load", resolveWindowLoaded);
    try {
        var po = new PerformanceObserver(function(entryList, po) {
            entryList.getEntries().forEach(function(entry) {
                if (entry.name === "first-contentful-paint" && entry.startTime < firstHiddenTime_1) {
                    po.disconnect();
                    fcpResolved = true;
                    possiblyEndSession();
                }
            });
        });
        // There's no need to even attach this listener if `PerformanceObserver` constructor will fail,
        // so we do it below here.
        var firstHiddenTime_1 = document.visibilityState === "hidden" ? 0 : Infinity;
        document.addEventListener("visibilitychange", function(event) {
            firstHiddenTime_1 = Math.min(firstHiddenTime_1, event.timeStamp);
        }, {
            once: true
        });
        po.observe({
            type: "paint",
            buffered: true
        });
    } catch (e) {
        fcpResolved = true;
        possiblyEndSession();
    }
}







var $byuqS = parcelRequire("byuqS");
var $ead0b529a718f160$exports = {};

$parcel$export($ead0b529a718f160$exports, "GlobalHandlers", function () { return $a5cc53f2ae4b6b9c$export$204155decbc90e5a; });
$parcel$export($ead0b529a718f160$exports, "TryCatch", function () { return $22cd1a6b685e708d$export$f1a018517668e6d3; });
$parcel$export($ead0b529a718f160$exports, "Breadcrumbs", function () { return $40537263cee926f6$export$2dc68d50d56fbbd; });
$parcel$export($ead0b529a718f160$exports, "LinkedErrors", function () { return $019d5e9c9790b4b9$export$8d1e60aaf616fb4f; });
$parcel$export($ead0b529a718f160$exports, "UserAgent", function () { return $e80b20c276314db6$export$5fba5e10934a4faf; });







var $7d1d902002dd1b2c$exports = {};

$parcel$export($7d1d902002dd1b2c$exports, "BaseTransport", function () { return $ee7d6b37fb56964c$export$74b99d619e90f481; });
$parcel$export($7d1d902002dd1b2c$exports, "FetchTransport", function () { return $f8f431ae760f1577$export$2bdee3f9b92f4e82; });
$parcel$export($7d1d902002dd1b2c$exports, "XHRTransport", function () { return $8587fb0ea2174ad4$export$874a283af77e8e62; });





var $fa137ffb757be904$var$windowIntegrations = {};
// This block is needed to add compatibility with the integrations packages when used with a CDN
var $fa137ffb757be904$var$_window = (0, $byuqS.getGlobalObject)();
if ($fa137ffb757be904$var$_window.Sentry && $fa137ffb757be904$var$_window.Sentry.Integrations) $fa137ffb757be904$var$windowIntegrations = $fa137ffb757be904$var$_window.Sentry.Integrations;
var $fa137ffb757be904$export$99d02219d259eb94 = (0, $90104860b1e5ba1f$export$18ce0697a983be9b)((0, $90104860b1e5ba1f$export$18ce0697a983be9b)((0, $90104860b1e5ba1f$export$18ce0697a983be9b)({}, $fa137ffb757be904$var$windowIntegrations), (0, $096e85a37773d599$exports)), $ead0b529a718f160$exports);
$parcel$exportWildcard($fa137ffb757be904$exports, $e73707d0761886f3$exports);



var $2Ef1X = parcelRequire("2Ef1X");
var $23ce4363775f3dc0$exports = {};
$23ce4363775f3dc0$exports = JSON.parse('{"name":"@telia/cpa-web","version":"1.51.5","description":"Content Provider Access - Frontend","main":"index.js","license":"MIT","private":true,"workspaces":["packages/*"],"scripts":{"auth":"aws codeartifact login --tool npm --repository cpa-libs --domain cpa --duration-seconds 43200 && echo \\"always-auth=true\\" >> ~/.npmrc","build":"run-s versions build:common build:client build:server","build:client":"cd packages/client && npm run build","build:common":"cd packages/common && npm run build","build:server":"cd packages/server && npm run build","codeMetrics":"ts-node scripts/code_metrics.ts","deepClean":"run-s deepClean:common deepClean:client deepClean:server deepClean:root","deepClean:client":"cd packages/client && npm run deepClean","deepClean:common":"cd packages/common && npm run deepClean","deepClean:server":"cd packages/server && npm run deepClean","deepClean:root":"rimraf ./node_modules","dev:test":"run-p test:watch dev","dev":"run-p dev:common dev:client dev:server","dev:client":"cd packages/client && npm run dev","dev:common":"cd packages/common && npm run dev","dev:server":"cd packages/server && npm run dev","postinstall----skip":"npm run build","prettier":"prettier --write \\"**/*\\"","start":"cd packages/server && npm run start","test:watch":"run-p test:client test:common test:server","test:client":"npm run test:watch --workspace=@telia/cpa-web-client","test:common":"npm run test:watch --workspace=@telia/cpa-web-common","test:server":"npm run test:watch --workspace=@telia/cpa-web-server","versionBump":"node src/versionBump.js","versions":"node -v && npm -v"},"devDependencies":{"@parcel/transformer-sass":"^2.9.2","@trivago/prettier-plugin-sort-imports":"^4.1.1","buffer":"^6.0.3","husky":"^4.2.3","npm-run-all2":"^7.0.2","os-browserify":"^0.3.0","prettier":"^2.0.5","pretty-quick":"^2.0.1","run-s":"^0.0.0","semantic-release":"^24.2.3","typescript":"^4.7.4","vm-browserify":"^1.1.2"},"resolutions":{},"husky":{"hooks":{"pre-commit":"pretty-quick --staged"}},"engines":{"node":">=20"}}');



var $2Ef1X = parcelRequire("2Ef1X");

var $aOoAs = parcelRequire("aOoAs");
const $ce151254b700f66a$var$getOrigin = ()=>window.location.origin;
const $ce151254b700f66a$var$isOriginInHosts = (hosts)=>hosts.some((host)=>$ce151254b700f66a$var$getOrigin().includes(host));
const $ce151254b700f66a$export$ec8a6426516240fc = ()=>$ce151254b700f66a$var$isOriginInHosts((0, $aOoAs.LOCALHOST_HOSTS));
const $ce151254b700f66a$export$8346aa6aeb0ceb51 = ()=>$ce151254b700f66a$var$isOriginInHosts((0, $aOoAs.STAGE_HOSTS));
const $ce151254b700f66a$export$f590c65b1d2881ef = ()=>$ce151254b700f66a$var$isOriginInHosts((0, $aOoAs.PRE_PROD_HOSTS));
const $ce151254b700f66a$export$1cfdf9a01e3f7773 = ()=>$ce151254b700f66a$var$isOriginInHosts((0, $aOoAs.PROD_HOSTS));
const $ce151254b700f66a$export$d8292f95ffcfb18f = ()=>$ce151254b700f66a$export$ec8a6426516240fc() ? (0, $aOoAs.STAGE_HOST) : $ce151254b700f66a$var$getOrigin();
const $ce151254b700f66a$export$23dc01e5cb551e17 = ()=>$ce151254b700f66a$export$ec8a6426516240fc() ? (0, $2Ef1X.LOCALHOST) : $ce151254b700f66a$export$8346aa6aeb0ceb51() ? (0, $2Ef1X.STAGE) : $ce151254b700f66a$export$f590c65b1d2881ef() ? (0, $2Ef1X.PRE_PROD) : $ce151254b700f66a$export$1cfdf9a01e3f7773() ? (0, $2Ef1X.PROD) : window.location.hostname;
const $ce151254b700f66a$export$880b260d7239d413 = ()=>$ce151254b700f66a$export$ec8a6426516240fc() ? (0, $aOoAs.LOCALHOST_BUCKET) : $ce151254b700f66a$export$8346aa6aeb0ceb51() ? (0, $aOoAs.STAGE_BUCKET) : $ce151254b700f66a$export$f590c65b1d2881ef() ? (0, $aOoAs.PRE_PROD_BUCKET) : $ce151254b700f66a$export$1cfdf9a01e3f7773() ? (0, $aOoAs.PROD_BUCKET) : "";


const { Severity: $f6a2cb476a1b1720$export$918a9776c0a3cf27 } = $fa137ffb757be904$exports;
const $f6a2cb476a1b1720$var$environment = (0, $ce151254b700f66a$export$23dc01e5cb551e17)();
const $f6a2cb476a1b1720$var$skipSentry = $f6a2cb476a1b1720$var$environment === (0, $2Ef1X.LOCALHOST);
const $f6a2cb476a1b1720$var$sentryConfig = {
    dsn: "https://21fc29c8881f4da485dd06d7a95d3f08@o47373.ingest.sentry.io/5312382",
    environment: $f6a2cb476a1b1720$var$environment,
    release: (0, $23ce4363775f3dc0$exports.version)
};
const $f6a2cb476a1b1720$export$f5ae3c4820871661 = ()=>{
    if ($f6a2cb476a1b1720$var$skipSentry) return false;
    else {
        $fa137ffb757be904$exports.init($f6a2cb476a1b1720$var$sentryConfig);
        $fa137ffb757be904$exports.configureScope((scope)=>{
            scope.setTag("hostname", window.location.hostname);
        });
        return $f6a2cb476a1b1720$var$sentryConfig;
    }
};
const $f6a2cb476a1b1720$export$5ceec5c8be62fa1b = (user)=>{
    $fa137ffb757be904$exports.configureScope((scope)=>{
        scope.setUser(user);
    });
    user && $f6a2cb476a1b1720$export$1829411d6079acc0({
        message: "Logged user",
        data: user,
        level: "INFO"
    });
};
const $f6a2cb476a1b1720$export$efda9a273d7a036d = ({ category: category, type: type, message: message, data: data, level: level })=>{
    $fa137ffb757be904$exports.addBreadcrumb({
        category: category,
        type: type,
        message: message,
        data: data,
        level: level
    });
};
const $f6a2cb476a1b1720$export$1829411d6079acc0 = ({ message: message, error: error, data: data, level: level })=>{
    $fa137ffb757be904$exports.withScope(function(scope) {
        scope.setLevel($fa137ffb757be904$exports.Severity.fromString(level));
        message && scope.setTag("message", message);
        data && (Array.isArray(data) ? data : [
            data
        ]).forEach((data, i)=>{
            scope.setExtra("extra_data_" + (i + 1), data);
        });
        if (error) $fa137ffb757be904$exports.captureException(error);
        else $fa137ffb757be904$exports.captureMessage(!!message ? message : "No message");
    });
};


//  Logging format
(0, (/*@__PURE__*/$parcel$interopDefault($9ba563f072652073$exports))).reg((0, (/*@__PURE__*/$parcel$interopDefault($80c508e558e7700f$exports))));
(0, (/*@__PURE__*/$parcel$interopDefault($9ba563f072652073$exports))).apply((0, (/*@__PURE__*/$parcel$interopDefault($80c508e558e7700f$exports))), {
    nameFormatter (name) {
        return name || "";
    },
    format (level, name, timestamp) {
        return `[${level}]${name && name !== "" ? ` (${name})` : ""}`;
    //return `${chalk.gray(`[${timestamp}]`)} ${colors[level.toUpperCase()](level)} ${chalk.green(`${name}:`)}`;
    }
});
const $899042a575f441f5$var$MIN_LOG_LEVEL = "production" !== (0, $2Ef1X.PROD) ? (0, (/*@__PURE__*/$parcel$interopDefault($80c508e558e7700f$exports))).levels.DEBUG : (0, (/*@__PURE__*/$parcel$interopDefault($80c508e558e7700f$exports))).levels.WARN;
const $899042a575f441f5$var$DEFAULT_LOG_LEVEL = "production" !== (0, $2Ef1X.PROD) ? (0, (/*@__PURE__*/$parcel$interopDefault($80c508e558e7700f$exports))).levels.INFO : (0, (/*@__PURE__*/$parcel$interopDefault($80c508e558e7700f$exports))).levels.WARN;
(0, (/*@__PURE__*/$parcel$interopDefault($80c508e558e7700f$exports))).setLevel($899042a575f441f5$var$MIN_LOG_LEVEL);
const $899042a575f441f5$export$29ce6c7518aa120 = (name, level)=>{
    const logger = (0, (/*@__PURE__*/$parcel$interopDefault($80c508e558e7700f$exports))).getLogger(name);
    const desiredLevel = level ? (0, (/*@__PURE__*/$parcel$interopDefault($80c508e558e7700f$exports))).levels[level.toUpperCase()] : $899042a575f441f5$var$DEFAULT_LOG_LEVEL;
    const maxLevel = desiredLevel > $899042a575f441f5$var$MIN_LOG_LEVEL ? desiredLevel : $899042a575f441f5$var$MIN_LOG_LEVEL;
    logger.setDefaultLevel(maxLevel);
    return logger;
};
//  Send ERROR level logs to Sentry
const $899042a575f441f5$var$originalFactory = (0, (/*@__PURE__*/$parcel$interopDefault($80c508e558e7700f$exports))).methodFactory;
const $899042a575f441f5$export$502bd5395f43ca61 = (...message)=>{
    const composedMessage = message.reduce((composed, obj)=>composed + (composed.length > 0 ? " " : "") + (obj instanceof Error ? obj.message : obj instanceof Object ? JSON.stringify(obj) : obj), "");
    const error = message.find((e)=>e instanceof Error);
    const data = message.filter((m)=>m instanceof Object);
    return {
        message: composedMessage,
        error: error,
        data: data.length > 0 ? data : undefined
    };
};
// for reporting to sentry
(0, (/*@__PURE__*/$parcel$interopDefault($80c508e558e7700f$exports))).methodFactory = (methodName, logLevel, loggerName)=>{
    const originalMethod = $899042a575f441f5$var$originalFactory(methodName, logLevel, loggerName);
    return (...message)=>{
        originalMethod(...message);
        if (logLevel >= (0, (/*@__PURE__*/$parcel$interopDefault($80c508e558e7700f$exports))).levels.WARN) {
            const wrappedMessage = $899042a575f441f5$export$502bd5395f43ca61(...message);
            (0, $f6a2cb476a1b1720$export$1829411d6079acc0)({
                ...wrappedMessage,
                level: methodName
            });
        }
    };
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
$parcel$global.log = (0, (/*@__PURE__*/$parcel$interopDefault($80c508e558e7700f$exports)));


const $316b346137ed644b$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("cachedLocalStorage");
const $316b346137ed644b$export$88ddfc12b1bd970 = "x-token";
const $316b346137ed644b$export$a28fbb7250b97688 = "brandId";
const $316b346137ed644b$var$cookies = (()=>{
    const c = document.cookie.split("; ");
    let cookies = {};
    for(let i = c.length - 1; i >= 0; i--){
        const C = c[i].split("=");
        cookies[C[0]] = C[1];
    }
    $316b346137ed644b$var$log.debug(`Read cookies`);
    return cookies;
})();
const $316b346137ed644b$var$removeCookie = function(name) {
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;";
    // cookies.remove(name);
    delete $316b346137ed644b$var$cookies[name];
};
const $316b346137ed644b$var$formatLogValue = (value)=>{
    return value && value.length > 300 ? `${value.substring(0, 40)}...` : value;
};
const $316b346137ed644b$var$cache = {};
const $316b346137ed644b$var$cachedKeys = [
    $316b346137ed644b$export$88ddfc12b1bd970,
    $316b346137ed644b$export$a28fbb7250b97688
];
const $316b346137ed644b$var$_set = (key, value)=>{
    $316b346137ed644b$var$cache[key] = value;
};
const $316b346137ed644b$var$_get = (key)=>{
    return $316b346137ed644b$var$cache[key];
};
const $316b346137ed644b$var$_initKey = (key)=>{
    const cookieValue = $316b346137ed644b$var$cookies[key];
    if (cookieValue) {
        localStorage.setItem(key, cookieValue);
        $316b346137ed644b$var$removeCookie(key);
        $316b346137ed644b$var$log.debug(`Moved cookie '${key}' to localStorage`);
    }
    const value = localStorage.getItem(key);
    $316b346137ed644b$var$_set(key, value); //  TODO: JSON parse string?
    $316b346137ed644b$var$log.debug(`Initialized key '${key}' with localStorage value '${$316b346137ed644b$var$formatLogValue(value)}'`);
};
const $316b346137ed644b$var$keys = ()=>$316b346137ed644b$var$cachedKeys;
const $316b346137ed644b$var$init = ()=>{
    $316b346137ed644b$var$cachedKeys.forEach((key)=>$316b346137ed644b$var$_initKey(key));
    $316b346137ed644b$var$log.info(`Initialized cache from localStore`);
};
// TODO: any
const $316b346137ed644b$var$get = (key)=>{
    const value = $316b346137ed644b$var$_get(key);
    // log.debug(`Get item with key '${key}' and value '${formatLogValue(value)}'`);
    return value;
};
const $316b346137ed644b$var$set = (key, value)=>{
    $316b346137ed644b$var$_set(key, value);
    localStorage.setItem(key, value); //  TODO: JSON stringify?
    $316b346137ed644b$var$log.debug(`Set item with key '${key}' to value '${$316b346137ed644b$var$formatLogValue(value)}`);
};
const $316b346137ed644b$var$remove = (key)=>{
    $316b346137ed644b$var$_set(key, null);
    localStorage.removeItem(key);
    $316b346137ed644b$var$log.debug(`Remove item with key '${key}'`);
};
const $316b346137ed644b$export$9280a247c7e168bf = {
    keys: $316b346137ed644b$var$keys,
    init: $316b346137ed644b$var$init,
    get: $316b346137ed644b$var$get,
    set: $316b346137ed644b$var$set,
    remove: $316b346137ed644b$var$remove
};



const $7059d4d5f1933e7a$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("usePreferences", "INFO");
const $7059d4d5f1933e7a$export$bbd7d970555e2952 = (preferenceKeys = [])=>{
    const getPreference = (key)=>{
        if (preferenceKeys.includes(key)) {
            const serializedValue = localStorage.getItem(key); //  returns null if not found
            const value = serializedValue && JSON.parse(serializedValue);
            $7059d4d5f1933e7a$var$log.debug("getPreference", key, value);
            return value;
        } else {
            $7059d4d5f1933e7a$var$log.debug("skip getPreference", key);
            return undefined;
        }
    };
    const [preferences, setPreferences] = (0, $fgmOP.useState)(preferenceKeys.reduce((preferences, key)=>{
        const preference = getPreference(key);
        if (preference !== null) preferences[`${key}`] = preference;
        return preferences;
    }, {}));
    const setPreference = (key, value)=>{
        if (preferenceKeys.includes(key)) {
            $7059d4d5f1933e7a$var$log.debug("setPreference", key, value);
            // Check for any keys that needs to also be stored in cachedLocalStorage
            if ((0, $316b346137ed644b$export$9280a247c7e168bf).keys().includes(key)) value ? (0, $316b346137ed644b$export$9280a247c7e168bf).set(key, JSON.stringify(value)) : (0, $316b346137ed644b$export$9280a247c7e168bf).remove(key);
            else value ? localStorage.setItem(key, JSON.stringify(value)) : localStorage.removeItem(key);
            setPreferences((prevPreferences)=>({
                    ...prevPreferences,
                    [`${key}`]: value
                }));
        } else $7059d4d5f1933e7a$var$log.debug("skip setPreference", key, value);
    };
    $7059d4d5f1933e7a$var$log.debug({
        preferenceKeys: preferenceKeys,
        preferences: preferences
    });
    return {
        preferences: preferences,
        getPreference: getPreference,
        setPreference: setPreference
    };
};



const $e9a95c61c800ecd2$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("routes", "INFO");
const $e9a95c61c800ecd2$export$15f47a32373730e5 = "_create_";
const $e9a95c61c800ecd2$export$5d82aa6adfda83a = "_";
const $e9a95c61c800ecd2$export$a9d18bec1ad505bc = "redirectPath";
const $e9a95c61c800ecd2$export$aca1887b2f6340cd = "/printable/customer/:customerId/settlement/:settlementId";
const $e9a95c61c800ecd2$export$a7c5707626fc90f = "/";
const $e9a95c61c800ecd2$export$eed606b4351295d7 = "/login";
const $e9a95c61c800ecd2$export$718572e48ef3feb2 = "/welcome";
const $e9a95c61c800ecd2$export$ff09b90989b21a8 = "/user";
const $e9a95c61c800ecd2$export$c71c29f33fa7576a = "/brand/:brandId";
const $e9a95c61c800ecd2$export$212905122e5ccd9e = "/usercustomer/:customerId";
const $e9a95c61c800ecd2$export$ebba33cd31d6b30c = `${$e9a95c61c800ecd2$export$c71c29f33fa7576a}/provisioning`;
const $e9a95c61c800ecd2$export$5410ffbe3babddcb = `${$e9a95c61c800ecd2$export$ebba33cd31d6b30c}/list`;
const $e9a95c61c800ecd2$export$c7f5b57db55f4f0a = `${$e9a95c61c800ecd2$export$ebba33cd31d6b30c}/customer`;
const $e9a95c61c800ecd2$export$80abc9f9ce9de04c = `${$e9a95c61c800ecd2$export$c7f5b57db55f4f0a}/:customerId`;
const $e9a95c61c800ecd2$export$bd177ac5e923b770 = `${$e9a95c61c800ecd2$export$80abc9f9ce9de04c}/overview`;
const $e9a95c61c800ecd2$export$725b0abc5ad90944 = `${$e9a95c61c800ecd2$export$80abc9f9ce9de04c}/company`;
const $e9a95c61c800ecd2$export$f9e6c07fc68d7984 = `${$e9a95c61c800ecd2$export$80abc9f9ce9de04c}/users`;
const $e9a95c61c800ecd2$export$cf0ddd3620037cd5 = `${$e9a95c61c800ecd2$export$f9e6c07fc68d7984}/:userId`;
const $e9a95c61c800ecd2$export$1638451563de5f57 = `${$e9a95c61c800ecd2$export$f9e6c07fc68d7984}/${$e9a95c61c800ecd2$export$15f47a32373730e5}`;
const $e9a95c61c800ecd2$export$a4009a798127382a = `${$e9a95c61c800ecd2$export$80abc9f9ce9de04c}/contracts`;
const $e9a95c61c800ecd2$export$57a19d7397b7cbfa = `${$e9a95c61c800ecd2$export$a4009a798127382a}/:contractId`;
const $e9a95c61c800ecd2$export$e66d5a68f99a70f0 = `${$e9a95c61c800ecd2$export$a4009a798127382a}/${$e9a95c61c800ecd2$export$15f47a32373730e5}`;
const $e9a95c61c800ecd2$export$e50d1075c5756827 = `${$e9a95c61c800ecd2$export$80abc9f9ce9de04c}/products`;
const $e9a95c61c800ecd2$export$1208ff990906387d = `${$e9a95c61c800ecd2$export$80abc9f9ce9de04c}/services`;
const $e9a95c61c800ecd2$export$1c1df467d8f9dd85 = `${$e9a95c61c800ecd2$export$57a19d7397b7cbfa}/products/:productId`;
const $e9a95c61c800ecd2$export$dc7ad6b828d74f36 = `${$e9a95c61c800ecd2$export$57a19d7397b7cbfa}/services/:productId`;
const $e9a95c61c800ecd2$export$2a4a027f8fef3234 = `${$e9a95c61c800ecd2$export$57a19d7397b7cbfa}/services/${$e9a95c61c800ecd2$export$15f47a32373730e5}`;
const $e9a95c61c800ecd2$export$6d02b57a0acc5177 = `${$e9a95c61c800ecd2$export$80abc9f9ce9de04c}/contacts`;
const $e9a95c61c800ecd2$export$ddfcfcdd7c33e729 = `${$e9a95c61c800ecd2$export$6d02b57a0acc5177}/:contactId`;
const $e9a95c61c800ecd2$export$a91491caafc6bee3 = `${$e9a95c61c800ecd2$export$80abc9f9ce9de04c}/settlements`;
const $e9a95c61c800ecd2$export$369b0d9ad9b3e58 = `${$e9a95c61c800ecd2$export$80abc9f9ce9de04c}/acl`;
const $e9a95c61c800ecd2$export$da866688141ddd00 = `${$e9a95c61c800ecd2$export$80abc9f9ce9de04c}/documents`;
const $e9a95c61c800ecd2$export$f862805185457fce = `${$e9a95c61c800ecd2$export$da866688141ddd00}/:documentId`;
const $e9a95c61c800ecd2$export$1cd2c36c01be113e = `${$e9a95c61c800ecd2$export$da866688141ddd00}/${$e9a95c61c800ecd2$export$15f47a32373730e5}`;
const $e9a95c61c800ecd2$export$185e199732aa14cd = `${$e9a95c61c800ecd2$export$80abc9f9ce9de04c}/smppConnections`;
const $e9a95c61c800ecd2$export$a08784a3004fa57e = `${$e9a95c61c800ecd2$export$ebba33cd31d6b30c}/product/:productId`;
const $e9a95c61c800ecd2$export$844e157d47c2ab60 = `${$e9a95c61c800ecd2$export$ebba33cd31d6b30c}/service/:productId`;
const $e9a95c61c800ecd2$export$257fa15708996d38 = `${$e9a95c61c800ecd2$export$c71c29f33fa7576a}/settlement`;
const $e9a95c61c800ecd2$export$463ad4d82c57d375 = `${$e9a95c61c800ecd2$export$257fa15708996d38}/overview`;
const $e9a95c61c800ecd2$export$ce951e24bd42e768 = `${$e9a95c61c800ecd2$export$257fa15708996d38}/pendingList`;
const $e9a95c61c800ecd2$export$54f17f3347a024b8 = `${$e9a95c61c800ecd2$export$257fa15708996d38}/readyForApprovalList`;
const $e9a95c61c800ecd2$export$f5e02ad8ed696b30 = `${$e9a95c61c800ecd2$export$257fa15708996d38}/summary`;
const $e9a95c61c800ecd2$export$8bd7b6bbd6bc0d7 = `${$e9a95c61c800ecd2$export$257fa15708996d38}/monthly`;
const $e9a95c61c800ecd2$export$daea0807b252124c = `${$e9a95c61c800ecd2$export$257fa15708996d38}/archive`;
const $e9a95c61c800ecd2$export$771b78d26c6d9748 = `${$e9a95c61c800ecd2$export$257fa15708996d38}/search`;
const $e9a95c61c800ecd2$export$8184fd48ec411db6 = `${$e9a95c61c800ecd2$export$771b78d26c6d9748}/:settlementId`;
const $e9a95c61c800ecd2$export$22573d2b1a349f14 = `${$e9a95c61c800ecd2$export$257fa15708996d38}/customerList`;
const $e9a95c61c800ecd2$export$ce26b76326b8998e = `${$e9a95c61c800ecd2$export$257fa15708996d38}/customer`;
const $e9a95c61c800ecd2$export$e11f923614d2bdee = `${$e9a95c61c800ecd2$export$ce26b76326b8998e}/:customerId`;
const $e9a95c61c800ecd2$export$23500bb7aec434e7 = `${$e9a95c61c800ecd2$export$e11f923614d2bdee}/overview`;
const $e9a95c61c800ecd2$export$9b55d9e87b669c1f = `${$e9a95c61c800ecd2$export$e11f923614d2bdee}/pendent`;
const $e9a95c61c800ecd2$export$76904fca0d1b4ff3 = `${$e9a95c61c800ecd2$export$e11f923614d2bdee}/approved`;
const $e9a95c61c800ecd2$export$2793f93164573ad = `${$e9a95c61c800ecd2$export$c71c29f33fa7576a}/management`;
const $e9a95c61c800ecd2$export$dced3bc93f3aa4f2 = `${$e9a95c61c800ecd2$export$2793f93164573ad}/overview`;
const $e9a95c61c800ecd2$export$9bd348b6232639d7 = `${$e9a95c61c800ecd2$export$2793f93164573ad}/users`;
const $e9a95c61c800ecd2$export$eaa88fbc12af3f84 = `${$e9a95c61c800ecd2$export$9bd348b6232639d7}/:userId`;
const $e9a95c61c800ecd2$export$d1f77cc09c8f389e = `${$e9a95c61c800ecd2$export$9bd348b6232639d7}/${$e9a95c61c800ecd2$export$15f47a32373730e5}`;
const $e9a95c61c800ecd2$export$84e81f0486c8c4ce = `${$e9a95c61c800ecd2$export$2793f93164573ad}/pendingUsers`;
const $e9a95c61c800ecd2$export$80c5118692739077 = `${$e9a95c61c800ecd2$export$84e81f0486c8c4ce}/:userId`;
const $e9a95c61c800ecd2$export$569ed52e5b30464 = `${$e9a95c61c800ecd2$export$2793f93164573ad}/notifications`;
const $e9a95c61c800ecd2$export$64c513f4bd4de646 = `${$e9a95c61c800ecd2$export$2793f93164573ad}/permissions`;
const $e9a95c61c800ecd2$export$eb03b2a2e7303d43 = `${$e9a95c61c800ecd2$export$2793f93164573ad}/serviceCategories`;
const $e9a95c61c800ecd2$export$949c5bd8f8d67240 = `${$e9a95c61c800ecd2$export$2793f93164573ad}/messageChannels`;
const $e9a95c61c800ecd2$export$c8919aa069f267a = `${$e9a95c61c800ecd2$export$949c5bd8f8d67240}/:messageChannel`;
const $e9a95c61c800ecd2$export$524b16a9ead1cc8f = `${$e9a95c61c800ecd2$export$2793f93164573ad}/smscs`;
const $e9a95c61c800ecd2$export$3448398040c65777 = `${$e9a95c61c800ecd2$export$524b16a9ead1cc8f}/:smsc`;
const $e9a95c61c800ecd2$export$b9e9de52d0e57205 = `${$e9a95c61c800ecd2$export$2793f93164573ad}/smppConnections`;
const $e9a95c61c800ecd2$export$9b5625cb178fcc5d = "/requestAccess";
const $e9a95c61c800ecd2$export$e3d31417f21c1ce7 = `${$e9a95c61c800ecd2$export$c71c29f33fa7576a}/report`;
const $e9a95c61c800ecd2$export$d6a5a8cee06963f7 = `${$e9a95c61c800ecd2$export$e3d31417f21c1ce7}/overview`;
const $e9a95c61c800ecd2$export$3e394bc3bb4fc12b = `${$e9a95c61c800ecd2$export$e3d31417f21c1ce7}/monthly`;
const $e9a95c61c800ecd2$export$1e42e92685e98be9 = `${$e9a95c61c800ecd2$export$e3d31417f21c1ce7}/statistics`;
const $e9a95c61c800ecd2$export$2661b74b9fa118a = `${$e9a95c61c800ecd2$export$e3d31417f21c1ce7}/senderIds`;
const $e9a95c61c800ecd2$export$af0ee86b91bc7146 = `${$e9a95c61c800ecd2$export$2661b74b9fa118a}/used`;
const $e9a95c61c800ecd2$export$92f2be0243b986ba = `${$e9a95c61c800ecd2$export$2661b74b9fa118a}/blocked`;
const $e9a95c61c800ecd2$export$7c824b2ea5505a8e = `${$e9a95c61c800ecd2$export$e3d31417f21c1ce7}/messages`;
const $e9a95c61c800ecd2$export$164d2bdecc76515 = `${$e9a95c61c800ecd2$export$7c824b2ea5505a8e}/:messageId`;
const $e9a95c61c800ecd2$export$f4198c574b87b640 = `${$e9a95c61c800ecd2$export$e3d31417f21c1ce7}/dcb`;
const $e9a95c61c800ecd2$export$7724472b45e16f3c = `${$e9a95c61c800ecd2$export$e3d31417f21c1ce7}/accessNumbersHistory`;
const $e9a95c61c800ecd2$export$cf334011f04d66bd = `${$e9a95c61c800ecd2$export$e3d31417f21c1ce7}/reservedSenderIds`;
const $e9a95c61c800ecd2$export$6b504632b4cea2e8 = "/documentation";
const $e9a95c61c800ecd2$export$b637f01461133315 = `${$e9a95c61c800ecd2$export$6b504632b4cea2e8}/technical`;
const $e9a95c61c800ecd2$export$7a2a39ee24a1b093 = `${$e9a95c61c800ecd2$export$6b504632b4cea2e8}/commercial`;
const $e9a95c61c800ecd2$export$8446dfcdf93bf41b = `${$e9a95c61c800ecd2$export$6b504632b4cea2e8}/productChanges`;
const $e9a95c61c800ecd2$export$b2e11634d600f33e = "/support";
const $e9a95c61c800ecd2$export$972a8c628b02b444 = [
    $e9a95c61c800ecd2$export$6b504632b4cea2e8,
    $e9a95c61c800ecd2$export$b2e11634d600f33e
];
const $e9a95c61c800ecd2$export$e8c60b88aa54a6db = (parentPath)=>(absolutePath)=>absolutePath.replace(parentPath, "");
const $e9a95c61c800ecd2$var$pathParameterRegExp = new RegExp(/(:\w+)/);
const $e9a95c61c800ecd2$var$pathParameterReplaceReducer = (partialFormattedRoute, routeParam)=>partialFormattedRoute.replace($e9a95c61c800ecd2$var$pathParameterRegExp, routeParam);
const $e9a95c61c800ecd2$export$d9468344d3651243 = (routePattern, ...routeParams)=>{
    return routeParams.reduce($e9a95c61c800ecd2$var$pathParameterReplaceReducer, routePattern);
};
const $e9a95c61c800ecd2$export$680db29e9b4883e6 = ()=>{
    const { getPreference: getPreference } = (0, $7059d4d5f1933e7a$export$bbd7d970555e2952)([
        "brandId"
    ]);
    const formatWithBrand = (routePattern, ...routeParams)=>{
        const brandId = getPreference("brandId");
        return brandId ? $e9a95c61c800ecd2$export$d9468344d3651243(routePattern, ...[
            brandId.toLowerCase(),
            ...routeParams
        ]) : $e9a95c61c800ecd2$export$d9468344d3651243(routePattern, ...routeParams);
    };
    return {
        formatWithBrand: formatWithBrand
    };
};
const $e9a95c61c800ecd2$export$3da6096fbfb33018 = (route, { ...state } = {}, alwaysIncludeFields)=>{
    if (state === null) return route;
    const cleanState = Object.keys(state).filter((key)=>alwaysIncludeFields && alwaysIncludeFields.includes(key) || state[key] && (state[key] === true || Array.isArray(state[key]) && state[key].length > 0 || state[key].trim && state[key].trim().length > 0)).sort().reduce((partial, key)=>{
        partial[key] = Array.isArray(state[key]) ? state[key].slice().sort() : state[key];
        return partial;
    }, {});
    const querystring = (0, (/*@__PURE__*/$parcel$interopDefault($3f999be1dfb2831f$exports))).stringify(cleanState, {
        arrayFormat: "brackets"
    });
    $e9a95c61c800ecd2$var$log.debug("appendQuerystring", {
        alwaysIncludeFields: alwaysIncludeFields,
        cleanState: cleanState,
        qs: querystring
    });
    return querystring.length === 0 ? route : route + "?" + querystring;
};
const $e9a95c61c800ecd2$export$311753dab4f1804e = (querystring)=>{
    let qsParams = {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($3f999be1dfb2831f$exports))).parse(querystring && querystring.substring(querystring.indexOf("?") + 1))
    };
    if (!qsParams) return undefined;
    let params = {};
    Object.keys(qsParams).forEach((key)=>{
        let value = qsParams[key];
        if (value === "true") value = true;
        else if (value === "false") value = false;
        params[key] = value;
    });
    $e9a95c61c800ecd2$var$log.debug("parseQuerystring", params);
    return params;
};
const $e9a95c61c800ecd2$export$f7e2c8231c57a8bd = (...paths)=>paths.join("/");
const $e9a95c61c800ecd2$export$e28dc6ad0b4f847f = (path)=>[
        $e9a95c61c800ecd2$export$a7c5707626fc90f,
        $e9a95c61c800ecd2$export$6b504632b4cea2e8
    ].includes(path);
const $e9a95c61c800ecd2$export$3b2141b862a8a681 = "/test";
const $e9a95c61c800ecd2$export$4800d91d4cc47d64 = `${$e9a95c61c800ecd2$export$3b2141b862a8a681}/:a/xxx/:b`;
const $e9a95c61c800ecd2$export$80ac71d1d841e478 = `${$e9a95c61c800ecd2$export$3b2141b862a8a681}/subTest`;




var $fgmOP = parcelRequire("fgmOP");

parcelRequire("fgmOP");

const $25d390e04dd0ffc0$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Error", "INFO");
const $25d390e04dd0ffc0$export$227a06967716b74 = (props)=>{
    $25d390e04dd0ffc0$var$log.debug("render", props);
    const { error: error, text: text, children: children } = props;
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
        className: "pop-up-line pop-up-line--error",
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
            className: "pop-up-line__container container container--small",
            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "pop-up-line__description",
                children: [
                    error && error.graphQLErrors && error.graphQLErrors.map((error, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                            children: error.message
                        }, i)),
                    text || children
                ]
            })
        })
    });
};
var $25d390e04dd0ffc0$export$2e2bcd8739ae039 = $25d390e04dd0ffc0$export$227a06967716b74;



const $b60bd97a1f982072$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ErrorBoundary");
class $b60bd97a1f982072$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError(error) {
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $25d390e04dd0ffc0$export$2e2bcd8739ae039), {
            text: "Error in component"
        });
        return this.props.children;
    }
}




var $fgmOP = parcelRequire("fgmOP");

var $jPPOv = parcelRequire("jPPOv");


var $fgmOP = parcelRequire("fgmOP");

var $jPPOv = parcelRequire("jPPOv");

/* !!! */ /* grey OUTDATED, do not use */ /* purple OUTDATED, do not use */ /* green OUTDATED, do not use */ var $b01bae4466898562$export$88bbe6beac980300 = [
    "black",
    "core-purple",
    "light-grey",
    "white",
    "black-purple",
    "dark-blue",
    "dark-core-purple",
    "dark-green",
    "dark-grey",
    "dark-pink",
    "dark-purple",
    "dark-red",
    "dark-teal",
    "deep-purple",
    "light-core-purple",
    "light-green",
    "orange",
    "pink",
    "red",
    "darkest-grey",
    "border-grey",
    "grey",
    "purple",
    "green",
    "none"
];


var $058eda357a1eb9d2$var$_excluded = [
    "iconName",
    "color",
    "className",
    "title"
];
function $058eda357a1eb9d2$var$_extends() {
    $058eda357a1eb9d2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $058eda357a1eb9d2$var$_extends.apply(this, arguments);
}
function $058eda357a1eb9d2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $058eda357a1eb9d2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $058eda357a1eb9d2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $058eda357a1eb9d2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Status: *In progress*.
 * Category: Style
 *
 * A component that is used to create external reference to svg icons from the icon assets.
 * To show an icon, give the name of the icon (without file ending) and the desired color (defaults to black).
 */ var $058eda357a1eb9d2$var$SvgIcon = function SvgIcon(_ref) {
    var _classnames;
    var iconName = _ref.iconName, color = _ref.color, className = _ref.className, title = _ref.title, rest = $058eda357a1eb9d2$var$_objectWithoutProperties(_ref, $058eda357a1eb9d2$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("svg", $058eda357a1eb9d2$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("svg-icon", (_classnames = {}, $058eda357a1eb9d2$var$_defineProperty(_classnames, className, className), $058eda357a1eb9d2$var$_defineProperty(_classnames, "svg-icon--".concat(color || "black"), color), _classnames)),
        "aria-hidden": title ? undefined : true
    }, rest), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("use", {
        xlinkHref: "#".concat(iconName)
    }));
};
$058eda357a1eb9d2$var$SvgIcon.propTypes = {
    /** The name of the icon*/ iconName: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    /** The color of the icon (white, black, ... Se Color Palette)*/ color: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).oneOf((0, $b01bae4466898562$export$88bbe6beac980300)),
    /** Other class names*/ className: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
};
var $058eda357a1eb9d2$export$2e2bcd8739ae039 = $058eda357a1eb9d2$var$SvgIcon;


var $3b8522ff8ac59784$var$_excluded = [
    "className",
    "text",
    "children",
    "href",
    "icon",
    "iconPosition",
    "target"
], $3b8522ff8ac59784$var$_excluded2 = [
    "children",
    "className",
    "wrapByThree",
    "wrapByFour",
    "black"
], $3b8522ff8ac59784$var$_excluded3 = [
    "children"
], $3b8522ff8ac59784$var$_excluded4 = [
    "children",
    "className"
], $3b8522ff8ac59784$var$_excluded5 = [
    "children",
    "iconName"
];
function $3b8522ff8ac59784$var$_extends() {
    $3b8522ff8ac59784$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3b8522ff8ac59784$var$_extends.apply(this, arguments);
}
function $3b8522ff8ac59784$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3b8522ff8ac59784$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3b8522ff8ac59784$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3b8522ff8ac59784$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $3b8522ff8ac59784$export$a6c7ac8248d6e38a = function Link(_ref) {
    var _classnames;
    var className = _ref.className, text = _ref.text, children = _ref.children, href = _ref.href, icon = _ref.icon, iconPosition = _ref.iconPosition, _ref$target = _ref.target, target = _ref$target === void 0 ? "_self" : _ref$target, rest = $3b8522ff8ac59784$var$_objectWithoutProperties(_ref, $3b8522ff8ac59784$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("a", $3b8522ff8ac59784$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("link", (_classnames = {}, $3b8522ff8ac59784$var$_defineProperty(_classnames, "link--with-icon link--".concat(icon), icon), $3b8522ff8ac59784$var$_defineProperty(_classnames, "link--icon-".concat(iconPosition), icon && iconPosition), $3b8522ff8ac59784$var$_defineProperty(_classnames, className, className), _classnames)),
        href: href,
        target: target
    }, rest), text, children);
};
var $3b8522ff8ac59784$var$List = function List(_ref2) {
    var _classnames2;
    var children = _ref2.children, className = _ref2.className, wrapByThree = _ref2.wrapByThree, wrapByFour = _ref2.wrapByFour, black = _ref2.black, rest = $3b8522ff8ac59784$var$_objectWithoutProperties(_ref2, $3b8522ff8ac59784$var$_excluded2);
    // Determine css classes to use based on the children.
    var childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Children.toArray(children);
    var hasBubbleLinks = childrenArray.find(function(it) {
        return it.type === List.Item && it.props.children.type === List.BubbleLink;
    });
    var hasLinks = !hasBubbleLinks && childrenArray.find(function(it) {
        return it.type === List.Item && it.props.children.type === List.Link;
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("ul", $3b8522ff8ac59784$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("list", (_classnames2 = {}, $3b8522ff8ac59784$var$_defineProperty(_classnames2, className, className), $3b8522ff8ac59784$var$_defineProperty(_classnames2, "list--icon-text-links", hasBubbleLinks), $3b8522ff8ac59784$var$_defineProperty(_classnames2, "list--links", hasLinks), $3b8522ff8ac59784$var$_defineProperty(_classnames2, "list--black", black), $3b8522ff8ac59784$var$_defineProperty(_classnames2, "list--wrap list--wrap-by-three", wrapByThree), $3b8522ff8ac59784$var$_defineProperty(_classnames2, "list--wrap list--wrap-by-four", wrapByFour), _classnames2))
    }, rest), children);
};
$3b8522ff8ac59784$var$List.propTypes = {
    /** Additional classes. */ className: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    /** Whenever this should wrap children by 3 per column. */ wrapByThree: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    /** Whenever this should wrap children by 4 per column. */ wrapByFour: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    /** Whenever should children be black. */ black: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).node
};
var $3b8522ff8ac59784$var$Item = function Item(_ref3) {
    var children = _ref3.children, rest = $3b8522ff8ac59784$var$_objectWithoutProperties(_ref3, $3b8522ff8ac59784$var$_excluded3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("li", $3b8522ff8ac59784$var$_extends({
        className: "list__item"
    }, rest), children);
};
$3b8522ff8ac59784$var$List.Item = $3b8522ff8ac59784$var$Item;
var $3b8522ff8ac59784$var$ListLink = function ListLink(_ref4) {
    var children = _ref4.children, className = _ref4.className, rest = $3b8522ff8ac59784$var$_objectWithoutProperties(_ref4, $3b8522ff8ac59784$var$_excluded4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($3b8522ff8ac59784$export$a6c7ac8248d6e38a, $3b8522ff8ac59784$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("list__link", $3b8522ff8ac59784$var$_defineProperty({}, className, className))
    }, rest, {
        text: children
    }));
};
$3b8522ff8ac59784$var$List.Link = $3b8522ff8ac59784$var$ListLink;
var $3b8522ff8ac59784$var$BubbleLink = function BubbleLink(_ref5) {
    var children = _ref5.children, iconName = _ref5.iconName, rest = $3b8522ff8ac59784$var$_objectWithoutProperties(_ref5, $3b8522ff8ac59784$var$_excluded5);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($3b8522ff8ac59784$var$List.Link, rest, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: "list__link-bubble"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $058eda357a1eb9d2$export$2e2bcd8739ae039), {
        iconName: iconName,
        color: "white",
        className: "list__link-icon"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: "list__link-text"
    }, children));
};
$3b8522ff8ac59784$var$List.BubbleLink = $3b8522ff8ac59784$var$BubbleLink;
$3b8522ff8ac59784$var$List.BubbleLink.propTypes = {
    /** Url of an icon to use. */ iconSvg: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).node
};
var $3b8522ff8ac59784$export$2e2bcd8739ae039 = $3b8522ff8ac59784$var$List;


parcelRequire("fgmOP");



/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */ function $c1a8fd65ae6bd73a$export$c10d0b04eaa80a43(value) {
    return typeof value == "object" && value !== null;
}


function $ad9211c29dcf0202$export$f5708dca728d7177(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message != null ? message : "Unexpected invariant triggered.");
}


const $4267d2d052abdbf4$var$LineRegExp = /\r\n|[\n\r]/g;
function $4267d2d052abdbf4$export$e7fd20fad3cf4b5f(source, position) {
    let lastLineStart = 0;
    let line = 1;
    for (const match of source.body.matchAll($4267d2d052abdbf4$var$LineRegExp)){
        typeof match.index === "number" || (0, $ad9211c29dcf0202$export$f5708dca728d7177)(false);
        if (match.index >= position) break;
        lastLineStart = match.index + match[0].length;
        line += 1;
    }
    return {
        line: line,
        column: position + 1 - lastLineStart
    };
}



function $dcd3b74fe66bf195$export$96a9681e539deed(location) {
    return $dcd3b74fe66bf195$export$867940333fd9f869(location.source, (0, $4267d2d052abdbf4$export$e7fd20fad3cf4b5f)(location.source, location.start));
}
function $dcd3b74fe66bf195$export$867940333fd9f869(source, sourceLocation) {
    const firstLineColumnOffset = source.locationOffset.column - 1;
    const body = "".padStart(firstLineColumnOffset) + source.body;
    const lineIndex = sourceLocation.line - 1;
    const lineOffset = source.locationOffset.line - 1;
    const lineNum = sourceLocation.line + lineOffset;
    const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
    const columnNum = sourceLocation.column + columnOffset;
    const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
    const lines = body.split(/\r\n|[\n\r]/g);
    const locationLine = lines[lineIndex]; // Special case for minified documents
    if (locationLine.length > 120) {
        const subLineIndex = Math.floor(columnNum / 80);
        const subLineColumnNum = columnNum % 80;
        const subLines = [];
        for(let i = 0; i < locationLine.length; i += 80)subLines.push(locationLine.slice(i, i + 80));
        return locationStr + $dcd3b74fe66bf195$var$printPrefixedLines([
            [
                `${lineNum} |`,
                subLines[0]
            ],
            ...subLines.slice(1, subLineIndex + 1).map((subLine)=>[
                    "|",
                    subLine
                ]),
            [
                "|",
                "^".padStart(subLineColumnNum)
            ],
            [
                "|",
                subLines[subLineIndex + 1]
            ]
        ]);
    }
    return locationStr + $dcd3b74fe66bf195$var$printPrefixedLines([
        // Lines specified like this: ["prefix", "string"],
        [
            `${lineNum - 1} |`,
            lines[lineIndex - 1]
        ],
        [
            `${lineNum} |`,
            locationLine
        ],
        [
            "|",
            "^".padStart(columnNum)
        ],
        [
            `${lineNum + 1} |`,
            lines[lineIndex + 1]
        ]
    ]);
}
function $dcd3b74fe66bf195$var$printPrefixedLines(lines) {
    const existingLines = lines.filter(([_, line])=>line !== undefined);
    const padLen = Math.max(...existingLines.map(([prefix])=>prefix.length));
    return existingLines.map(([prefix, line])=>prefix.padStart(padLen) + (line ? " " + line : "")).join("\n");
}


function $30ab8f7423b1097a$var$toNormalizedOptions(args) {
    const firstArg = args[0];
    if (firstArg == null || "kind" in firstArg || "length" in firstArg) return {
        nodes: firstArg,
        source: args[1],
        positions: args[2],
        path: args[3],
        originalError: args[4],
        extensions: args[5]
    };
    return firstArg;
}
class $30ab8f7423b1097a$export$92d6ed0888e7cb7f extends Error {
    /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */ /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */ /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */ /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */ /**
   * The original error thrown from a field resolver during execution.
   */ /**
   * Extension fields to add to the formatted error.
   */ /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */ constructor(message, ...rawArgs){
        var _this$nodes, _nodeLocations$, _ref;
        const { nodes: nodes, source: source, positions: positions, path: path, originalError: originalError, extensions: extensions } = $30ab8f7423b1097a$var$toNormalizedOptions(rawArgs);
        super(message);
        this.name = "GraphQLError";
        this.path = path !== null && path !== void 0 ? path : undefined;
        this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.
        this.nodes = $30ab8f7423b1097a$var$undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [
            nodes
        ] : undefined);
        const nodeLocations = $30ab8f7423b1097a$var$undefinedIfEmpty((_this$nodes = this.nodes) === null || _this$nodes === void 0 ? void 0 : _this$nodes.map((node)=>node.loc).filter((loc)=>loc != null)); // Compute locations in the source for the given nodes/positions.
        this.source = source !== null && source !== void 0 ? source : nodeLocations === null || nodeLocations === void 0 ? void 0 : (_nodeLocations$ = nodeLocations[0]) === null || _nodeLocations$ === void 0 ? void 0 : _nodeLocations$.source;
        this.positions = positions !== null && positions !== void 0 ? positions : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>loc.start);
        this.locations = positions && source ? positions.map((pos)=>(0, $4267d2d052abdbf4$export$e7fd20fad3cf4b5f)(source, pos)) : nodeLocations === null || nodeLocations === void 0 ? void 0 : nodeLocations.map((loc)=>(0, $4267d2d052abdbf4$export$e7fd20fad3cf4b5f)(loc.source, loc.start));
        const originalExtensions = (0, $c1a8fd65ae6bd73a$export$c10d0b04eaa80a43)(originalError === null || originalError === void 0 ? void 0 : originalError.extensions) ? originalError === null || originalError === void 0 ? void 0 : originalError.extensions : undefined;
        this.extensions = (_ref = extensions !== null && extensions !== void 0 ? extensions : originalExtensions) !== null && _ref !== void 0 ? _ref : Object.create(null); // Only properties prescribed by the spec should be enumerable.
        // Keep the rest as non-enumerable.
        Object.defineProperties(this, {
            message: {
                writable: true,
                enumerable: true
            },
            name: {
                enumerable: false
            },
            nodes: {
                enumerable: false
            },
            source: {
                enumerable: false
            },
            positions: {
                enumerable: false
            },
            originalError: {
                enumerable: false
            }
        }); // Include (non-enumerable) stack trace.
        /* c8 ignore start */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
        if (originalError !== null && originalError !== void 0 && originalError.stack) Object.defineProperty(this, "stack", {
            value: originalError.stack,
            writable: true,
            configurable: true
        });
        else if (Error.captureStackTrace) Error.captureStackTrace(this, $30ab8f7423b1097a$export$92d6ed0888e7cb7f);
        else Object.defineProperty(this, "stack", {
            value: Error().stack,
            writable: true,
            configurable: true
        });
    /* c8 ignore stop */ }
    get [Symbol.toStringTag]() {
        return "GraphQLError";
    }
    toString() {
        let output = this.message;
        if (this.nodes) {
            for (const node of this.nodes)if (node.loc) output += "\n\n" + (0, $dcd3b74fe66bf195$export$96a9681e539deed)(node.loc);
        } else if (this.source && this.locations) for (const location of this.locations)output += "\n\n" + (0, $dcd3b74fe66bf195$export$867940333fd9f869)(this.source, location);
        return output;
    }
    toJSON() {
        const formattedError = {
            message: this.message
        };
        if (this.locations != null) formattedError.locations = this.locations;
        if (this.path != null) formattedError.path = this.path;
        if (this.extensions != null && Object.keys(this.extensions).length > 0) formattedError.extensions = this.extensions;
        return formattedError;
    }
}
function $30ab8f7423b1097a$var$undefinedIfEmpty(array) {
    return array === undefined || array.length === 0 ? undefined : array;
}
function $30ab8f7423b1097a$export$55ee1551a3f962e6(error) {
    return error.toString();
}
function $30ab8f7423b1097a$export$7b5b869ee98c16ab(error) {
    return error.toJSON();
}


function $c4fb72a27dee0bdf$export$bbee0c6176c019d4(source, position, description) {
    return new (0, $30ab8f7423b1097a$export$92d6ed0888e7cb7f)(`Syntax Error: ${description}`, {
        source: source,
        positions: [
            position
        ]
    });
}


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $74a6e38a6e060a30$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return "Location";
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $74a6e38a6e060a30$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return "Token";
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $74a6e38a6e060a30$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        "definitions"
    ],
    OperationDefinition: [
        "name",
        "variableDefinitions",
        "directives",
        "selectionSet"
    ],
    VariableDefinition: [
        "variable",
        "type",
        "defaultValue",
        "directives"
    ],
    Variable: [
        "name"
    ],
    SelectionSet: [
        "selections"
    ],
    Field: [
        "alias",
        "name",
        "arguments",
        "directives",
        "selectionSet"
    ],
    Argument: [
        "name",
        "value"
    ],
    FragmentSpread: [
        "name",
        "directives"
    ],
    InlineFragment: [
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    FragmentDefinition: [
        "name",
        "variableDefinitions",
        "typeCondition",
        "directives",
        "selectionSet"
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        "values"
    ],
    ObjectValue: [
        "fields"
    ],
    ObjectField: [
        "name",
        "value"
    ],
    Directive: [
        "name",
        "arguments"
    ],
    NamedType: [
        "name"
    ],
    ListType: [
        "type"
    ],
    NonNullType: [
        "type"
    ],
    SchemaDefinition: [
        "description",
        "directives",
        "operationTypes"
    ],
    OperationTypeDefinition: [
        "type"
    ],
    ScalarTypeDefinition: [
        "description",
        "name",
        "directives"
    ],
    ObjectTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    FieldDefinition: [
        "description",
        "name",
        "arguments",
        "type",
        "directives"
    ],
    InputValueDefinition: [
        "description",
        "name",
        "type",
        "defaultValue",
        "directives"
    ],
    InterfaceTypeDefinition: [
        "description",
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeDefinition: [
        "description",
        "name",
        "directives",
        "types"
    ],
    EnumTypeDefinition: [
        "description",
        "name",
        "directives",
        "values"
    ],
    EnumValueDefinition: [
        "description",
        "name",
        "directives"
    ],
    InputObjectTypeDefinition: [
        "description",
        "name",
        "directives",
        "fields"
    ],
    DirectiveDefinition: [
        "description",
        "name",
        "arguments",
        "locations"
    ],
    SchemaExtension: [
        "directives",
        "operationTypes"
    ],
    ScalarTypeExtension: [
        "name",
        "directives"
    ],
    ObjectTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    InterfaceTypeExtension: [
        "name",
        "interfaces",
        "directives",
        "fields"
    ],
    UnionTypeExtension: [
        "name",
        "directives",
        "types"
    ],
    EnumTypeExtension: [
        "name",
        "directives",
        "values"
    ],
    InputObjectTypeExtension: [
        "name",
        "directives",
        "fields"
    ]
};
const $74a6e38a6e060a30$var$kindValues = new Set(Object.keys($74a6e38a6e060a30$export$4fcd777a40ccf407));
function $74a6e38a6e060a30$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === "string" && $74a6e38a6e060a30$var$kindValues.has(maybeKind);
}
/** Name */ var $74a6e38a6e060a30$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode["QUERY"] = "query";
    OperationTypeNode["MUTATION"] = "mutation";
    OperationTypeNode["SUBSCRIPTION"] = "subscription";
})($74a6e38a6e060a30$export$f58c50edb4aef9d4 || ($74a6e38a6e060a30$export$f58c50edb4aef9d4 = {}));


/**
 * The set of allowed directive location values.
 */ var $4f90084b5d94f8dc$export$b45ffd2948484c41;
(function(DirectiveLocation) {
    DirectiveLocation["QUERY"] = "QUERY";
    DirectiveLocation["MUTATION"] = "MUTATION";
    DirectiveLocation["SUBSCRIPTION"] = "SUBSCRIPTION";
    DirectiveLocation["FIELD"] = "FIELD";
    DirectiveLocation["FRAGMENT_DEFINITION"] = "FRAGMENT_DEFINITION";
    DirectiveLocation["FRAGMENT_SPREAD"] = "FRAGMENT_SPREAD";
    DirectiveLocation["INLINE_FRAGMENT"] = "INLINE_FRAGMENT";
    DirectiveLocation["VARIABLE_DEFINITION"] = "VARIABLE_DEFINITION";
    DirectiveLocation["SCHEMA"] = "SCHEMA";
    DirectiveLocation["SCALAR"] = "SCALAR";
    DirectiveLocation["OBJECT"] = "OBJECT";
    DirectiveLocation["FIELD_DEFINITION"] = "FIELD_DEFINITION";
    DirectiveLocation["ARGUMENT_DEFINITION"] = "ARGUMENT_DEFINITION";
    DirectiveLocation["INTERFACE"] = "INTERFACE";
    DirectiveLocation["UNION"] = "UNION";
    DirectiveLocation["ENUM"] = "ENUM";
    DirectiveLocation["ENUM_VALUE"] = "ENUM_VALUE";
    DirectiveLocation["INPUT_OBJECT"] = "INPUT_OBJECT";
    DirectiveLocation["INPUT_FIELD_DEFINITION"] = "INPUT_FIELD_DEFINITION";
})($4f90084b5d94f8dc$export$b45ffd2948484c41 || ($4f90084b5d94f8dc$export$b45ffd2948484c41 = {}));
 /**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */ 

/**
 * The set of allowed kind values for AST nodes.
 */ var $addc2f9aaa51cfa5$export$a84bdc57c5122798;
(function(Kind) {
    Kind["NAME"] = "Name";
    Kind["DOCUMENT"] = "Document";
    Kind["OPERATION_DEFINITION"] = "OperationDefinition";
    Kind["VARIABLE_DEFINITION"] = "VariableDefinition";
    Kind["SELECTION_SET"] = "SelectionSet";
    Kind["FIELD"] = "Field";
    Kind["ARGUMENT"] = "Argument";
    Kind["FRAGMENT_SPREAD"] = "FragmentSpread";
    Kind["INLINE_FRAGMENT"] = "InlineFragment";
    Kind["FRAGMENT_DEFINITION"] = "FragmentDefinition";
    Kind["VARIABLE"] = "Variable";
    Kind["INT"] = "IntValue";
    Kind["FLOAT"] = "FloatValue";
    Kind["STRING"] = "StringValue";
    Kind["BOOLEAN"] = "BooleanValue";
    Kind["NULL"] = "NullValue";
    Kind["ENUM"] = "EnumValue";
    Kind["LIST"] = "ListValue";
    Kind["OBJECT"] = "ObjectValue";
    Kind["OBJECT_FIELD"] = "ObjectField";
    Kind["DIRECTIVE"] = "Directive";
    Kind["NAMED_TYPE"] = "NamedType";
    Kind["LIST_TYPE"] = "ListType";
    Kind["NON_NULL_TYPE"] = "NonNullType";
    Kind["SCHEMA_DEFINITION"] = "SchemaDefinition";
    Kind["OPERATION_TYPE_DEFINITION"] = "OperationTypeDefinition";
    Kind["SCALAR_TYPE_DEFINITION"] = "ScalarTypeDefinition";
    Kind["OBJECT_TYPE_DEFINITION"] = "ObjectTypeDefinition";
    Kind["FIELD_DEFINITION"] = "FieldDefinition";
    Kind["INPUT_VALUE_DEFINITION"] = "InputValueDefinition";
    Kind["INTERFACE_TYPE_DEFINITION"] = "InterfaceTypeDefinition";
    Kind["UNION_TYPE_DEFINITION"] = "UnionTypeDefinition";
    Kind["ENUM_TYPE_DEFINITION"] = "EnumTypeDefinition";
    Kind["ENUM_VALUE_DEFINITION"] = "EnumValueDefinition";
    Kind["INPUT_OBJECT_TYPE_DEFINITION"] = "InputObjectTypeDefinition";
    Kind["DIRECTIVE_DEFINITION"] = "DirectiveDefinition";
    Kind["SCHEMA_EXTENSION"] = "SchemaExtension";
    Kind["SCALAR_TYPE_EXTENSION"] = "ScalarTypeExtension";
    Kind["OBJECT_TYPE_EXTENSION"] = "ObjectTypeExtension";
    Kind["INTERFACE_TYPE_EXTENSION"] = "InterfaceTypeExtension";
    Kind["UNION_TYPE_EXTENSION"] = "UnionTypeExtension";
    Kind["ENUM_TYPE_EXTENSION"] = "EnumTypeExtension";
    Kind["INPUT_OBJECT_TYPE_EXTENSION"] = "InputObjectTypeExtension";
})($addc2f9aaa51cfa5$export$a84bdc57c5122798 || ($addc2f9aaa51cfa5$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 



/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $6374f040ad864b22$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $6374f040ad864b22$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $6374f040ad864b22$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $6374f040ad864b22$export$45a677ea7cb6d5c8(code) {
    return $6374f040ad864b22$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $6374f040ad864b22$export$d3f406ff46035894(code) {
    return $6374f040ad864b22$export$79c5d5217943d6a7(code) || $6374f040ad864b22$export$727d9dbc4fbb948f(code) || code === 0x005f;
}


function $793319546472cc8f$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $793319546472cc8f$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $793319546472cc8f$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $6374f040ad864b22$export$3c52dd84024ae72c)(str.charCodeAt(i)))++i;
    return i;
}
function $793319546472cc8f$export$40862a63ef85e395(value) {
    if (value === "") return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $793319546472cc8f$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $6374f040ad864b22$export$3c52dd84024ae72c)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith("\\");
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ""; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $6374f040ad864b22$export$3c52dd84024ae72c)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += "\n";
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += "\n";
    return '"""' + result + '"""';
}



/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */ var $f1a4742d8ee8916b$export$8b9d26ab11394711;
(function(TokenKind) {
    TokenKind["SOF"] = "<SOF>";
    TokenKind["EOF"] = "<EOF>";
    TokenKind["BANG"] = "!";
    TokenKind["DOLLAR"] = "$";
    TokenKind["AMP"] = "&";
    TokenKind["PAREN_L"] = "(";
    TokenKind["PAREN_R"] = ")";
    TokenKind["SPREAD"] = "...";
    TokenKind["COLON"] = ":";
    TokenKind["EQUALS"] = "=";
    TokenKind["AT"] = "@";
    TokenKind["BRACKET_L"] = "[";
    TokenKind["BRACKET_R"] = "]";
    TokenKind["BRACE_L"] = "{";
    TokenKind["PIPE"] = "|";
    TokenKind["BRACE_R"] = "}";
    TokenKind["NAME"] = "Name";
    TokenKind["INT"] = "Int";
    TokenKind["FLOAT"] = "Float";
    TokenKind["STRING"] = "String";
    TokenKind["BLOCK_STRING"] = "BlockString";
    TokenKind["COMMENT"] = "Comment";
})($f1a4742d8ee8916b$export$8b9d26ab11394711 || ($f1a4742d8ee8916b$export$8b9d26ab11394711 = {}));
 /**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */ 

class $b26ab8a3e948be10$export$6168dc8908a6c652 {
    /**
   * The previously focused non-ignored token.
   */ /**
   * The currently focused non-ignored token.
   */ /**
   * The (1-indexed) line containing the current token.
   */ /**
   * The character offset at which the current line begins.
   */ constructor(source){
        const startOfFileToken = new (0, $74a6e38a6e060a30$export$50792b0e93539fde)((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).SOF, 0, 0, 0, 0);
        this.source = source;
        this.lastToken = startOfFileToken;
        this.token = startOfFileToken;
        this.line = 1;
        this.lineStart = 0;
    }
    get [Symbol.toStringTag]() {
        return "Lexer";
    }
    /**
   * Advances the token stream to the next non-ignored token.
   */ advance() {
        this.lastToken = this.token;
        const token = this.token = this.lookahead();
        return token;
    }
    /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */ lookahead() {
        let token = this.token;
        if (token.kind !== (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).EOF) {
            do if (token.next) token = token.next;
            else {
                // Read the next token and form a link in the token linked-list.
                const nextToken = $b26ab8a3e948be10$var$readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.
                token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.
                nextToken.prev = token;
                token = nextToken;
            }
            while (token.kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).COMMENT);
        }
        return token;
    }
}
function $b26ab8a3e948be10$export$59ac0f4da287406a(kind) {
    return kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BANG || kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).DOLLAR || kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).AMP || kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).PAREN_L || kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).PAREN_R || kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).SPREAD || kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).COLON || kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).EQUALS || kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).AT || kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACKET_L || kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACKET_R || kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_L || kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).PIPE || kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_R;
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */ function $b26ab8a3e948be10$var$isUnicodeScalarValue(code) {
    return code >= 0x0000 && code <= 0xd7ff || code >= 0xe000 && code <= 0x10ffff;
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */ function $b26ab8a3e948be10$var$isSupplementaryCodePoint(body, location) {
    return $b26ab8a3e948be10$var$isLeadingSurrogate(body.charCodeAt(location)) && $b26ab8a3e948be10$var$isTrailingSurrogate(body.charCodeAt(location + 1));
}
function $b26ab8a3e948be10$var$isLeadingSurrogate(code) {
    return code >= 0xd800 && code <= 0xdbff;
}
function $b26ab8a3e948be10$var$isTrailingSurrogate(code) {
    return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */ function $b26ab8a3e948be10$var$printCodePointAt(lexer, location) {
    const code = lexer.source.body.codePointAt(location);
    if (code === undefined) return (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).EOF;
    else if (code >= 0x0020 && code <= 0x007e) {
        // Printable ASCII
        const char = String.fromCodePoint(code);
        return char === '"' ? "'\"'" : `"${char}"`;
    } // Unicode code point
    return "U+" + code.toString(16).toUpperCase().padStart(4, "0");
}
/**
 * Create a token with line and column location information.
 */ function $b26ab8a3e948be10$var$createToken(lexer, kind, start, end, value) {
    const line = lexer.line;
    const col = 1 + start - lexer.lineStart;
    return new (0, $74a6e38a6e060a30$export$50792b0e93539fde)(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */ function $b26ab8a3e948be10$var$readNextToken(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // SourceCharacter
        switch(code){
            // Ignored ::
            //   - UnicodeBOM
            //   - WhiteSpace
            //   - LineTerminator
            //   - Comment
            //   - Comma
            //
            // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
            //
            // WhiteSpace ::
            //   - "Horizontal Tab (U+0009)"
            //   - "Space (U+0020)"
            //
            // Comma :: ,
            case 0xfeff:
            case 0x0009:
            case 0x0020:
            case 0x002c:
                // ,
                ++position;
                continue;
            // LineTerminator ::
            //   - "New Line (U+000A)"
            //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
            //   - "Carriage Return (U+000D)" "New Line (U+000A)"
            case 0x000a:
                // \n
                ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            case 0x000d:
                // \r
                if (body.charCodeAt(position + 1) === 0x000a) position += 2;
                else ++position;
                ++lexer.line;
                lexer.lineStart = position;
                continue;
            // Comment
            case 0x0023:
                // #
                return $b26ab8a3e948be10$var$readComment(lexer, position);
            // Token ::
            //   - Punctuator
            //   - Name
            //   - IntValue
            //   - FloatValue
            //   - StringValue
            //
            // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }
            case 0x0021:
                // !
                return $b26ab8a3e948be10$var$createToken(lexer, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BANG, position, position + 1);
            case 0x0024:
                // $
                return $b26ab8a3e948be10$var$createToken(lexer, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).DOLLAR, position, position + 1);
            case 0x0026:
                // &
                return $b26ab8a3e948be10$var$createToken(lexer, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).AMP, position, position + 1);
            case 0x0028:
                // (
                return $b26ab8a3e948be10$var$createToken(lexer, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).PAREN_L, position, position + 1);
            case 0x0029:
                // )
                return $b26ab8a3e948be10$var$createToken(lexer, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).PAREN_R, position, position + 1);
            case 0x002e:
                // .
                if (body.charCodeAt(position + 1) === 0x002e && body.charCodeAt(position + 2) === 0x002e) return $b26ab8a3e948be10$var$createToken(lexer, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).SPREAD, position, position + 3);
                break;
            case 0x003a:
                // :
                return $b26ab8a3e948be10$var$createToken(lexer, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).COLON, position, position + 1);
            case 0x003d:
                // =
                return $b26ab8a3e948be10$var$createToken(lexer, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).EQUALS, position, position + 1);
            case 0x0040:
                // @
                return $b26ab8a3e948be10$var$createToken(lexer, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).AT, position, position + 1);
            case 0x005b:
                // [
                return $b26ab8a3e948be10$var$createToken(lexer, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACKET_L, position, position + 1);
            case 0x005d:
                // ]
                return $b26ab8a3e948be10$var$createToken(lexer, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACKET_R, position, position + 1);
            case 0x007b:
                // {
                return $b26ab8a3e948be10$var$createToken(lexer, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_L, position, position + 1);
            case 0x007c:
                // |
                return $b26ab8a3e948be10$var$createToken(lexer, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).PIPE, position, position + 1);
            case 0x007d:
                // }
                return $b26ab8a3e948be10$var$createToken(lexer, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_R, position, position + 1);
            // StringValue
            case 0x0022:
                // "
                if (body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) return $b26ab8a3e948be10$var$readBlockString(lexer, position);
                return $b26ab8a3e948be10$var$readString(lexer, position);
        } // IntValue | FloatValue (Digit | -)
        if ((0, $6374f040ad864b22$export$727d9dbc4fbb948f)(code) || code === 0x002d) return $b26ab8a3e948be10$var$readNumber(lexer, position, code);
         // Name
        if ((0, $6374f040ad864b22$export$45a677ea7cb6d5c8)(code)) return $b26ab8a3e948be10$var$readName(lexer, position);
        throw (0, $c4fb72a27dee0bdf$export$bbee0c6176c019d4)(lexer.source, position, code === 0x0027 ? "Unexpected single quote character ('), did you mean to use a double quote (\")?" : $b26ab8a3e948be10$var$isUnicodeScalarValue(code) || $b26ab8a3e948be10$var$isSupplementaryCodePoint(body, position) ? `Unexpected character: ${$b26ab8a3e948be10$var$printCodePointAt(lexer, position)}.` : `Invalid character: ${$b26ab8a3e948be10$var$printCodePointAt(lexer, position)}.`);
    }
    return $b26ab8a3e948be10$var$createToken(lexer, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */ function $b26ab8a3e948be10$var$readComment(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position); // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($b26ab8a3e948be10$var$isUnicodeScalarValue(code)) ++position;
        else if ($b26ab8a3e948be10$var$isSupplementaryCodePoint(body, position)) position += 2;
        else break;
    }
    return $b26ab8a3e948be10$var$createToken(lexer, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).COMMENT, start, position, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */ function $b26ab8a3e948be10$var$readNumber(lexer, start, firstCode) {
    const body = lexer.source.body;
    let position = start;
    let code = firstCode;
    let isFloat = false; // NegativeSign (-)
    if (code === 0x002d) code = body.charCodeAt(++position);
     // Zero (0)
    if (code === 0x0030) {
        code = body.charCodeAt(++position);
        if ((0, $6374f040ad864b22$export$727d9dbc4fbb948f)(code)) throw (0, $c4fb72a27dee0bdf$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, unexpected digit after 0: ${$b26ab8a3e948be10$var$printCodePointAt(lexer, position)}.`);
    } else {
        position = $b26ab8a3e948be10$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Full stop (.)
    if (code === 0x002e) {
        isFloat = true;
        code = body.charCodeAt(++position);
        position = $b26ab8a3e948be10$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // E e
    if (code === 0x0045 || code === 0x0065) {
        isFloat = true;
        code = body.charCodeAt(++position); // + -
        if (code === 0x002b || code === 0x002d) code = body.charCodeAt(++position);
        position = $b26ab8a3e948be10$var$readDigits(lexer, position, code);
        code = body.charCodeAt(position);
    } // Numbers cannot be followed by . or NameStart
    if (code === 0x002e || (0, $6374f040ad864b22$export$45a677ea7cb6d5c8)(code)) throw (0, $c4fb72a27dee0bdf$export$bbee0c6176c019d4)(lexer.source, position, `Invalid number, expected digit but got: ${$b26ab8a3e948be10$var$printCodePointAt(lexer, position)}.`);
    return $b26ab8a3e948be10$var$createToken(lexer, isFloat ? (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).FLOAT : (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).INT, start, position, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading one or more digits.
 */ function $b26ab8a3e948be10$var$readDigits(lexer, start, firstCode) {
    if (!(0, $6374f040ad864b22$export$727d9dbc4fbb948f)(firstCode)) throw (0, $c4fb72a27dee0bdf$export$bbee0c6176c019d4)(lexer.source, start, `Invalid number, expected digit but got: ${$b26ab8a3e948be10$var$printCodePointAt(lexer, start)}.`);
    const body = lexer.source.body;
    let position = start + 1; // +1 to skip first firstCode
    while((0, $6374f040ad864b22$export$727d9dbc4fbb948f)(body.charCodeAt(position)))++position;
    return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */ function $b26ab8a3e948be10$var$readString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    let chunkStart = position;
    let value = "";
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Quote (")
        if (code === 0x0022) {
            value += body.slice(chunkStart, position);
            return $b26ab8a3e948be10$var$createToken(lexer, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).STRING, start, position + 1, value);
        } // Escape Sequence (\)
        if (code === 0x005c) {
            value += body.slice(chunkStart, position);
            const escape = body.charCodeAt(position + 1) === 0x0075 // u
             ? body.charCodeAt(position + 2) === 0x007b // {
             ? $b26ab8a3e948be10$var$readEscapedUnicodeVariableWidth(lexer, position) : $b26ab8a3e948be10$var$readEscapedUnicodeFixedWidth(lexer, position) : $b26ab8a3e948be10$var$readEscapedCharacter(lexer, position);
            value += escape.value;
            position += escape.size;
            chunkStart = position;
            continue;
        } // LineTerminator (\n | \r)
        if (code === 0x000a || code === 0x000d) break;
         // SourceCharacter
        if ($b26ab8a3e948be10$var$isUnicodeScalarValue(code)) ++position;
        else if ($b26ab8a3e948be10$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $c4fb72a27dee0bdf$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$b26ab8a3e948be10$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $c4fb72a27dee0bdf$export$bbee0c6176c019d4)(lexer.source, position, "Unterminated string.");
} // The string value and lexed size of an escape sequence.
function $b26ab8a3e948be10$var$readEscapedUnicodeVariableWidth(lexer, position) {
    const body = lexer.source.body;
    let point = 0;
    let size = 3; // Cannot be larger than 12 chars (\u{00000000}).
    while(size < 12){
        const code = body.charCodeAt(position + size++); // Closing Brace (})
        if (code === 0x007d) {
            // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
            if (size < 5 || !$b26ab8a3e948be10$var$isUnicodeScalarValue(point)) break;
            return {
                value: String.fromCodePoint(point),
                size: size
            };
        } // Append this hex digit to the code point.
        point = point << 4 | $b26ab8a3e948be10$var$readHexDigit(code);
        if (point < 0) break;
    }
    throw (0, $c4fb72a27dee0bdf$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + size)}".`);
}
function $b26ab8a3e948be10$var$readEscapedUnicodeFixedWidth(lexer, position) {
    const body = lexer.source.body;
    const code = $b26ab8a3e948be10$var$read16BitHexCode(body, position + 2);
    if ($b26ab8a3e948be10$var$isUnicodeScalarValue(code)) return {
        value: String.fromCodePoint(code),
        size: 6
    };
     // GraphQL allows JSON-style surrogate pair escape sequences, but only when
    // a valid pair is formed.
    if ($b26ab8a3e948be10$var$isLeadingSurrogate(code)) // \u
    {
        if (body.charCodeAt(position + 6) === 0x005c && body.charCodeAt(position + 7) === 0x0075) {
            const trailingCode = $b26ab8a3e948be10$var$read16BitHexCode(body, position + 8);
            if ($b26ab8a3e948be10$var$isTrailingSurrogate(trailingCode)) // JavaScript defines strings as a sequence of UTF-16 code units and
            // encodes Unicode code points above U+FFFF using a surrogate pair of
            // code units. Since this is a surrogate pair escape sequence, just
            // include both codes into the JavaScript string value. Had JavaScript
            // not been internally based on UTF-16, then this surrogate pair would
            // be decoded to retrieve the supplementary code point.
            return {
                value: String.fromCodePoint(code, trailingCode),
                size: 12
            };
        }
    }
    throw (0, $c4fb72a27dee0bdf$export$bbee0c6176c019d4)(lexer.source, position, `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`);
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */ function $b26ab8a3e948be10$var$read16BitHexCode(body, position) {
    // readHexDigit() returns -1 on error. ORing a negative value with any other
    // value always produces a negative value.
    return $b26ab8a3e948be10$var$readHexDigit(body.charCodeAt(position)) << 12 | $b26ab8a3e948be10$var$readHexDigit(body.charCodeAt(position + 1)) << 8 | $b26ab8a3e948be10$var$readHexDigit(body.charCodeAt(position + 2)) << 4 | $b26ab8a3e948be10$var$readHexDigit(body.charCodeAt(position + 3));
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */ function $b26ab8a3e948be10$var$readHexDigit(code) {
    return code >= 0x0030 && code <= 0x0039 // 0-9
     ? code - 0x0030 : code >= 0x0041 && code <= 0x0046 // A-F
     ? code - 0x0037 : code >= 0x0061 && code <= 0x0066 // a-f
     ? code - 0x0057 : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */ function $b26ab8a3e948be10$var$readEscapedCharacter(lexer, position) {
    const body = lexer.source.body;
    const code = body.charCodeAt(position + 1);
    switch(code){
        case 0x0022:
            // "
            return {
                value: '"',
                size: 2
            };
        case 0x005c:
            // \
            return {
                value: "\\",
                size: 2
            };
        case 0x002f:
            // /
            return {
                value: "/",
                size: 2
            };
        case 0x0062:
            // b
            return {
                value: "\b",
                size: 2
            };
        case 0x0066:
            // f
            return {
                value: "\f",
                size: 2
            };
        case 0x006e:
            // n
            return {
                value: "\n",
                size: 2
            };
        case 0x0072:
            // r
            return {
                value: "\r",
                size: 2
            };
        case 0x0074:
            // t
            return {
                value: "	",
                size: 2
            };
    }
    throw (0, $c4fb72a27dee0bdf$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character escape sequence: "${body.slice(position, position + 2)}".`);
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */ function $b26ab8a3e948be10$var$readBlockString(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let lineStart = lexer.lineStart;
    let position = start + 3;
    let chunkStart = position;
    let currentLine = "";
    const blockLines = [];
    while(position < bodyLength){
        const code = body.charCodeAt(position); // Closing Triple-Quote (""")
        if (code === 0x0022 && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            const token = $b26ab8a3e948be10$var$createToken(lexer, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BLOCK_STRING, start, position + 3, (0, $793319546472cc8f$export$d5ee19b441e8d2ae)(blockLines).join("\n"));
            lexer.line += blockLines.length - 1;
            lexer.lineStart = lineStart;
            return token;
        } // Escaped Triple-Quote (\""")
        if (code === 0x005c && body.charCodeAt(position + 1) === 0x0022 && body.charCodeAt(position + 2) === 0x0022 && body.charCodeAt(position + 3) === 0x0022) {
            currentLine += body.slice(chunkStart, position);
            chunkStart = position + 1; // skip only slash
            position += 4;
            continue;
        } // LineTerminator
        if (code === 0x000a || code === 0x000d) {
            currentLine += body.slice(chunkStart, position);
            blockLines.push(currentLine);
            if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) position += 2;
            else ++position;
            currentLine = "";
            chunkStart = position;
            lineStart = position;
            continue;
        } // SourceCharacter
        if ($b26ab8a3e948be10$var$isUnicodeScalarValue(code)) ++position;
        else if ($b26ab8a3e948be10$var$isSupplementaryCodePoint(body, position)) position += 2;
        else throw (0, $c4fb72a27dee0bdf$export$bbee0c6176c019d4)(lexer.source, position, `Invalid character within String: ${$b26ab8a3e948be10$var$printCodePointAt(lexer, position)}.`);
    }
    throw (0, $c4fb72a27dee0bdf$export$bbee0c6176c019d4)(lexer.source, position, "Unterminated string.");
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */ function $b26ab8a3e948be10$var$readName(lexer, start) {
    const body = lexer.source.body;
    const bodyLength = body.length;
    let position = start + 1;
    while(position < bodyLength){
        const code = body.charCodeAt(position);
        if ((0, $6374f040ad864b22$export$d3f406ff46035894)(code)) ++position;
        else break;
    }
    return $b26ab8a3e948be10$var$createToken(lexer, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).NAME, start, position, body.slice(start, position));
}


function $7df4851cf7a690ac$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}


const $3ce4887891173cd9$var$MAX_ARRAY_LENGTH = 10;
const $3ce4887891173cd9$var$MAX_RECURSIVE_DEPTH = 2;
function $3ce4887891173cd9$export$9dec5d1b3b6a130d(value) {
    return $3ce4887891173cd9$var$formatValue(value, []);
}
function $3ce4887891173cd9$var$formatValue(value, seenValues) {
    switch(typeof value){
        case "string":
            return JSON.stringify(value);
        case "function":
            return value.name ? `[function ${value.name}]` : "[function]";
        case "object":
            return $3ce4887891173cd9$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $3ce4887891173cd9$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return "null";
    if (previouslySeenValues.includes(value)) return "[Circular]";
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($3ce4887891173cd9$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === "string" ? jsonValue : $3ce4887891173cd9$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $3ce4887891173cd9$var$formatArray(value, seenValues);
    return $3ce4887891173cd9$var$formatObject(value, seenValues);
}
function $3ce4887891173cd9$var$isJSONable(value) {
    return typeof value.toJSON === "function";
}
function $3ce4887891173cd9$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return "{}";
    if (seenValues.length > $3ce4887891173cd9$var$MAX_RECURSIVE_DEPTH) return "[" + $3ce4887891173cd9$var$getObjectTag(object) + "]";
    const properties = entries.map(([key, value])=>key + ": " + $3ce4887891173cd9$var$formatValue(value, seenValues));
    return "{ " + properties.join(", ") + " }";
}
function $3ce4887891173cd9$var$formatArray(array, seenValues) {
    if (array.length === 0) return "[]";
    if (seenValues.length > $3ce4887891173cd9$var$MAX_RECURSIVE_DEPTH) return "[Array]";
    const len = Math.min($3ce4887891173cd9$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($3ce4887891173cd9$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push("... 1 more item");
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return "[" + items.join(", ") + "]";
}
function $3ce4887891173cd9$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, "").replace(/]$/, "");
    if (tag === "Object" && typeof object.constructor === "function") {
        const name = object.constructor.name;
        if (typeof name === "string" && name !== "") return name;
    }
    return tag;
}



const $130f21dd968b91a8$export$ca03416d6c9e029e = /* c8 ignore next 6 */ // FIXME: https://github.com/graphql/graphql-js/issues/2317
globalThis.process && globalThis.process.env.NODE_ENV === "production" ? function instanceOf(value, constructor) {
    return value instanceof constructor;
} : function instanceOf(value, constructor) {
    if (value instanceof constructor) return true;
    if (typeof value === "object" && value !== null) {
        var _value$constructor;
        // Prefer Symbol.toStringTag since it is immune to minification.
        const className = constructor.prototype[Symbol.toStringTag];
        const valueClassName = Symbol.toStringTag in value // @ts-expect-error TS bug see, https://github.com/microsoft/TypeScript/issues/38009
         ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;
        if (className === valueClassName) {
            const stringifiedValue = (0, $3ce4887891173cd9$export$9dec5d1b3b6a130d)(value);
            throw new Error(`Cannot use ${className} "${stringifiedValue}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
        }
    }
    return false;
};


class $65d9fac888074fe4$export$1d2df86270c81ecb {
    constructor(body, name = "GraphQL request", locationOffset = {
        line: 1,
        column: 1
    }){
        typeof body === "string" || (0, $7df4851cf7a690ac$export$b6cb5906f04696c8)(false, `Body must be a string. Received: ${(0, $3ce4887891173cd9$export$9dec5d1b3b6a130d)(body)}.`);
        this.body = body;
        this.name = name;
        this.locationOffset = locationOffset;
        this.locationOffset.line > 0 || (0, $7df4851cf7a690ac$export$b6cb5906f04696c8)(false, "line in locationOffset is 1-indexed and must be positive.");
        this.locationOffset.column > 0 || (0, $7df4851cf7a690ac$export$b6cb5906f04696c8)(false, "column in locationOffset is 1-indexed and must be positive.");
    }
    get [Symbol.toStringTag]() {
        return "Source";
    }
}
function $65d9fac888074fe4$export$75135ee9ed6e435b(source) {
    return (0, $130f21dd968b91a8$export$ca03416d6c9e029e)(source, $65d9fac888074fe4$export$1d2df86270c81ecb);
}



function $c90175610888e178$export$98e6a39c04603d36(source, options) {
    const parser = new $c90175610888e178$export$7acfa6ed01010e37(source, options);
    return parser.parseDocument();
}
function $c90175610888e178$export$5303528d1070ff6f(source, options) {
    const parser = new $c90175610888e178$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).SOF);
    const value = parser.parseValueLiteral(false);
    parser.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).EOF);
    return value;
}
function $c90175610888e178$export$e14c466bd0916f7a(source, options) {
    const parser = new $c90175610888e178$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).SOF);
    const value = parser.parseConstValueLiteral();
    parser.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).EOF);
    return value;
}
function $c90175610888e178$export$28b8f402ccc88182(source, options) {
    const parser = new $c90175610888e178$export$7acfa6ed01010e37(source, options);
    parser.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).SOF);
    const type = parser.parseTypeReference();
    parser.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).EOF);
    return type;
}
class $c90175610888e178$export$7acfa6ed01010e37 {
    constructor(source, options = {}){
        const sourceObj = (0, $65d9fac888074fe4$export$75135ee9ed6e435b)(source) ? source : new (0, $65d9fac888074fe4$export$1d2df86270c81ecb)(source);
        this._lexer = new (0, $b26ab8a3e948be10$export$6168dc8908a6c652)(sourceObj);
        this._options = options;
        this._tokenCounter = 0;
    }
    /**
   * Converts a name lex token into a name parse node.
   */ parseName() {
        const token = this.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).NAME);
        return this.node(token, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).NAME,
            value: token.value
        });
    }
    /**
   * Document : Definition+
   */ parseDocument() {
        return this.node(this._lexer.token, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).DOCUMENT,
            definitions: this.many((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).SOF, this.parseDefinition, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).EOF)
        });
    }
    /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */ parseDefinition() {
        if (this.peek((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_L)) return this.parseOperationDefinition();
         // Many definitions begin with a description and require a lookahead.
        const hasDescription = this.peekDescription();
        const keywordToken = hasDescription ? this._lexer.lookahead() : this._lexer.token;
        if (keywordToken.kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).NAME) {
            switch(keywordToken.value){
                case "schema":
                    return this.parseSchemaDefinition();
                case "scalar":
                    return this.parseScalarTypeDefinition();
                case "type":
                    return this.parseObjectTypeDefinition();
                case "interface":
                    return this.parseInterfaceTypeDefinition();
                case "union":
                    return this.parseUnionTypeDefinition();
                case "enum":
                    return this.parseEnumTypeDefinition();
                case "input":
                    return this.parseInputObjectTypeDefinition();
                case "directive":
                    return this.parseDirectiveDefinition();
            }
            if (hasDescription) throw (0, $c4fb72a27dee0bdf$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, "Unexpected description, descriptions are supported only on type definitions.");
            switch(keywordToken.value){
                case "query":
                case "mutation":
                case "subscription":
                    return this.parseOperationDefinition();
                case "fragment":
                    return this.parseFragmentDefinition();
                case "extend":
                    return this.parseTypeSystemExtension();
            }
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */ parseOperationDefinition() {
        const start = this._lexer.token;
        if (this.peek((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_L)) return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: (0, $74a6e38a6e060a30$export$f58c50edb4aef9d4).QUERY,
            name: undefined,
            variableDefinitions: [],
            directives: [],
            selectionSet: this.parseSelectionSet()
        });
        const operation = this.parseOperationType();
        let name;
        if (this.peek((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).NAME)) name = this.parseName();
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).OPERATION_DEFINITION,
            operation: operation,
            name: name,
            variableDefinitions: this.parseVariableDefinitions(),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * OperationType : one of query mutation subscription
   */ parseOperationType() {
        const operationToken = this.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).NAME);
        switch(operationToken.value){
            case "query":
                return (0, $74a6e38a6e060a30$export$f58c50edb4aef9d4).QUERY;
            case "mutation":
                return (0, $74a6e38a6e060a30$export$f58c50edb4aef9d4).MUTATION;
            case "subscription":
                return (0, $74a6e38a6e060a30$export$f58c50edb4aef9d4).SUBSCRIPTION;
        }
        throw this.unexpected(operationToken);
    }
    /**
   * VariableDefinitions : ( VariableDefinition+ )
   */ parseVariableDefinitions() {
        return this.optionalMany((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).PAREN_L, this.parseVariableDefinition, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */ parseVariableDefinition() {
        return this.node(this._lexer.token, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).VARIABLE_DEFINITION,
            variable: this.parseVariable(),
            type: (this.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).COLON), this.parseTypeReference()),
            defaultValue: this.expectOptionalToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).EQUALS) ? this.parseConstValueLiteral() : undefined,
            directives: this.parseConstDirectives()
        });
    }
    /**
   * Variable : $ Name
   */ parseVariable() {
        const start = this._lexer.token;
        this.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).DOLLAR);
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).VARIABLE,
            name: this.parseName()
        });
    }
    /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */ parseSelectionSet() {
        return this.node(this._lexer.token, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).SELECTION_SET,
            selections: this.many((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_L, this.parseSelection, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */ parseSelection() {
        return this.peek((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).SPREAD) ? this.parseFragment() : this.parseField();
    }
    /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */ parseField() {
        const start = this._lexer.token;
        const nameOrAlias = this.parseName();
        let alias;
        let name;
        if (this.expectOptionalToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).COLON)) {
            alias = nameOrAlias;
            name = this.parseName();
        } else name = nameOrAlias;
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).FIELD,
            alias: alias,
            name: name,
            arguments: this.parseArguments(false),
            directives: this.parseDirectives(false),
            selectionSet: this.peek((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_L) ? this.parseSelectionSet() : undefined
        });
    }
    /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */ parseArguments(isConst) {
        const item = isConst ? this.parseConstArgument : this.parseArgument;
        return this.optionalMany((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).PAREN_L, item, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * Argument[Const] : Name : Value[?Const]
   */ parseArgument(isConst = false) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).ARGUMENT,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    parseConstArgument() {
        return this.parseArgument(true);
    }
    /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */ parseFragment() {
        const start = this._lexer.token;
        this.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).SPREAD);
        const hasTypeCondition = this.expectOptionalKeyword("on");
        if (!hasTypeCondition && this.peek((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).NAME)) return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).FRAGMENT_SPREAD,
            name: this.parseFragmentName(),
            directives: this.parseDirectives(false)
        });
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).INLINE_FRAGMENT,
            typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */ parseFragmentDefinition() {
        const start = this._lexer.token;
        this.expectKeyword("fragment"); // Legacy support for defining variables within fragments changes
        // the grammar of FragmentDefinition:
        //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet
        if (this._options.allowLegacyFragmentVariables === true) return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            variableDefinitions: this.parseVariableDefinitions(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).FRAGMENT_DEFINITION,
            name: this.parseFragmentName(),
            typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
            directives: this.parseDirectives(false),
            selectionSet: this.parseSelectionSet()
        });
    }
    /**
   * FragmentName : Name but not `on`
   */ parseFragmentName() {
        if (this._lexer.token.value === "on") throw this.unexpected();
        return this.parseName();
    }
    /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseValueLiteral(isConst) {
        const token = this._lexer.token;
        switch(token.kind){
            case (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACKET_L:
                return this.parseList(isConst);
            case (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_L:
                return this.parseObject(isConst);
            case (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).INT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).INT,
                    value: token.value
                });
            case (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).FLOAT:
                this.advanceLexer();
                return this.node(token, {
                    kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).FLOAT,
                    value: token.value
                });
            case (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).STRING:
            case (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BLOCK_STRING:
                return this.parseStringLiteral();
            case (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).NAME:
                this.advanceLexer();
                switch(token.value){
                    case "true":
                        return this.node(token, {
                            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).BOOLEAN,
                            value: true
                        });
                    case "false":
                        return this.node(token, {
                            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).BOOLEAN,
                            value: false
                        });
                    case "null":
                        return this.node(token, {
                            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).NULL
                        });
                    default:
                        return this.node(token, {
                            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).ENUM,
                            value: token.value
                        });
                }
            case (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).DOLLAR:
                if (isConst) {
                    this.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).DOLLAR);
                    if (this._lexer.token.kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).NAME) {
                        const varName = this._lexer.token.value;
                        throw (0, $c4fb72a27dee0bdf$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected variable "$${varName}" in constant value.`);
                    } else throw this.unexpected(token);
                }
                return this.parseVariable();
            default:
                throw this.unexpected();
        }
    }
    parseConstValueLiteral() {
        return this.parseValueLiteral(true);
    }
    parseStringLiteral() {
        const token = this._lexer.token;
        this.advanceLexer();
        return this.node(token, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).STRING,
            value: token.value,
            block: token.kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BLOCK_STRING
        });
    }
    /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */ parseList(isConst) {
        const item = ()=>this.parseValueLiteral(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).LIST,
            values: this.any((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACKET_L, item, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACKET_R)
        });
    }
    /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */ parseObject(isConst) {
        const item = ()=>this.parseObjectField(isConst);
        return this.node(this._lexer.token, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).OBJECT,
            fields: this.any((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_L, item, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_R)
        });
    }
    /**
   * ObjectField[Const] : Name : Value[?Const]
   */ parseObjectField(isConst) {
        const start = this._lexer.token;
        const name = this.parseName();
        this.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).COLON);
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).OBJECT_FIELD,
            name: name,
            value: this.parseValueLiteral(isConst)
        });
    }
    /**
   * Directives[Const] : Directive[?Const]+
   */ parseDirectives(isConst) {
        const directives = [];
        while(this.peek((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).AT))directives.push(this.parseDirective(isConst));
        return directives;
    }
    parseConstDirectives() {
        return this.parseDirectives(true);
    }
    /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */ parseDirective(isConst) {
        const start = this._lexer.token;
        this.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).AT);
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).DIRECTIVE,
            name: this.parseName(),
            arguments: this.parseArguments(isConst)
        });
    }
    /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */ parseTypeReference() {
        const start = this._lexer.token;
        let type;
        if (this.expectOptionalToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACKET_L)) {
            const innerType = this.parseTypeReference();
            this.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACKET_R);
            type = this.node(start, {
                kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).LIST_TYPE,
                type: innerType
            });
        } else type = this.parseNamedType();
        if (this.expectOptionalToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BANG)) return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).NON_NULL_TYPE,
            type: type
        });
        return type;
    }
    /**
   * NamedType : Name
   */ parseNamedType() {
        return this.node(this._lexer.token, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).NAMED_TYPE,
            name: this.parseName()
        });
    }
    peekDescription() {
        return this.peek((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).STRING) || this.peek((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BLOCK_STRING);
    }
    /**
   * Description : StringValue
   */ parseDescription() {
        if (this.peekDescription()) return this.parseStringLiteral();
    }
    /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */ parseSchemaDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.many((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_R);
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).SCHEMA_DEFINITION,
            description: description,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * OperationTypeDefinition : OperationType : NamedType
   */ parseOperationTypeDefinition() {
        const start = this._lexer.token;
        const operation = this.parseOperationType();
        this.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).COLON);
        const type = this.parseNamedType();
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).OPERATION_TYPE_DEFINITION,
            operation: operation,
            type: type
        });
    }
    /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */ parseScalarTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */ parseObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */ parseImplementsInterfaces() {
        return this.expectOptionalKeyword("implements") ? this.delimitedMany((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).AMP, this.parseNamedType) : [];
    }
    /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */ parseFieldsDefinition() {
        return this.optionalMany((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_L, this.parseFieldDefinition, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */ parseFieldDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        this.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).FIELD_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            type: type,
            directives: directives
        });
    }
    /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */ parseArgumentDefs() {
        return this.optionalMany((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).PAREN_L, this.parseInputValueDef, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).PAREN_R);
    }
    /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */ parseInputValueDef() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseName();
        this.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).COLON);
        const type = this.parseTypeReference();
        let defaultValue;
        if (this.expectOptionalToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).EQUALS)) defaultValue = this.parseConstValueLiteral();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).INPUT_VALUE_DEFINITION,
            description: description,
            name: name,
            type: type,
            defaultValue: defaultValue,
            directives: directives
        });
    }
    /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */ parseInterfaceTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION,
            description: description,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */ parseUnionTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).UNION_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */ parseUnionMemberTypes() {
        return this.expectOptionalToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).EQUALS) ? this.delimitedMany((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).PIPE, this.parseNamedType) : [];
    }
    /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */ parseEnumTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */ parseEnumValuesDefinition() {
        return this.optionalMany((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_L, this.parseEnumValueDefinition, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */ parseEnumValueDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        const name = this.parseEnumValueName();
        const directives = this.parseConstDirectives();
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).ENUM_VALUE_DEFINITION,
            description: description,
            name: name,
            directives: directives
        });
    }
    /**
   * EnumValue : Name but not `true`, `false` or `null`
   */ parseEnumValueName() {
        if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null") throw (0, $c4fb72a27dee0bdf$export$bbee0c6176c019d4)(this._lexer.source, this._lexer.token.start, `${$c90175610888e178$var$getTokenDesc(this._lexer.token)} is reserved and cannot be used for an enum value.`);
        return this.parseName();
    }
    /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */ parseInputObjectTypeDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION,
            description: description,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */ parseInputFieldsDefinition() {
        return this.optionalMany((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_L, this.parseInputValueDef, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_R);
    }
    /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */ parseTypeSystemExtension() {
        const keywordToken = this._lexer.lookahead();
        if (keywordToken.kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).NAME) switch(keywordToken.value){
            case "schema":
                return this.parseSchemaExtension();
            case "scalar":
                return this.parseScalarTypeExtension();
            case "type":
                return this.parseObjectTypeExtension();
            case "interface":
                return this.parseInterfaceTypeExtension();
            case "union":
                return this.parseUnionTypeExtension();
            case "enum":
                return this.parseEnumTypeExtension();
            case "input":
                return this.parseInputObjectTypeExtension();
        }
        throw this.unexpected(keywordToken);
    }
    /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */ parseSchemaExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("schema");
        const directives = this.parseConstDirectives();
        const operationTypes = this.optionalMany((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_L, this.parseOperationTypeDefinition, (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).BRACE_R);
        if (directives.length === 0 && operationTypes.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).SCHEMA_EXTENSION,
            directives: directives,
            operationTypes: operationTypes
        });
    }
    /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */ parseScalarTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("scalar");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        if (directives.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION,
            name: name,
            directives: directives
        });
    }
    /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */ parseObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("type");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */ parseInterfaceTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("interface");
        const name = this.parseName();
        const interfaces = this.parseImplementsInterfaces();
        const directives = this.parseConstDirectives();
        const fields = this.parseFieldsDefinition();
        if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION,
            name: name,
            interfaces: interfaces,
            directives: directives,
            fields: fields
        });
    }
    /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */ parseUnionTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("union");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const types = this.parseUnionMemberTypes();
        if (directives.length === 0 && types.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).UNION_TYPE_EXTENSION,
            name: name,
            directives: directives,
            types: types
        });
    }
    /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */ parseEnumTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("enum");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const values = this.parseEnumValuesDefinition();
        if (directives.length === 0 && values.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION,
            name: name,
            directives: directives,
            values: values
        });
    }
    /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */ parseInputObjectTypeExtension() {
        const start = this._lexer.token;
        this.expectKeyword("extend");
        this.expectKeyword("input");
        const name = this.parseName();
        const directives = this.parseConstDirectives();
        const fields = this.parseInputFieldsDefinition();
        if (directives.length === 0 && fields.length === 0) throw this.unexpected();
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION,
            name: name,
            directives: directives,
            fields: fields
        });
    }
    /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */ parseDirectiveDefinition() {
        const start = this._lexer.token;
        const description = this.parseDescription();
        this.expectKeyword("directive");
        this.expectToken((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).AT);
        const name = this.parseName();
        const args = this.parseArgumentDefs();
        const repeatable = this.expectOptionalKeyword("repeatable");
        this.expectKeyword("on");
        const locations = this.parseDirectiveLocations();
        return this.node(start, {
            kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).DIRECTIVE_DEFINITION,
            description: description,
            name: name,
            arguments: args,
            repeatable: repeatable,
            locations: locations
        });
    }
    /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */ parseDirectiveLocations() {
        return this.delimitedMany((0, $f1a4742d8ee8916b$export$8b9d26ab11394711).PIPE, this.parseDirectiveLocation);
    }
    /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */ parseDirectiveLocation() {
        const start = this._lexer.token;
        const name = this.parseName();
        if (Object.prototype.hasOwnProperty.call((0, $4f90084b5d94f8dc$export$b45ffd2948484c41), name.value)) return name;
        throw this.unexpected(start);
    }
    /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */ node(startToken, node) {
        if (this._options.noLocation !== true) node.loc = new (0, $74a6e38a6e060a30$export$18a2be9195644f38)(startToken, this._lexer.lastToken, this._lexer.source);
        return node;
    }
    /**
   * Determines if the next token is of a given kind
   */ peek(kind) {
        return this._lexer.token.kind === kind;
    }
    /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return token;
        }
        throw (0, $c4fb72a27dee0bdf$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected ${$c90175610888e178$var$getTokenKindDesc(kind)}, found ${$c90175610888e178$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalToken(kind) {
        const token = this._lexer.token;
        if (token.kind === kind) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */ expectKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).NAME && token.value === value) this.advanceLexer();
        else throw (0, $c4fb72a27dee0bdf$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Expected "${value}", found ${$c90175610888e178$var$getTokenDesc(token)}.`);
    }
    /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */ expectOptionalKeyword(value) {
        const token = this._lexer.token;
        if (token.kind === (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).NAME && token.value === value) {
            this.advanceLexer();
            return true;
        }
        return false;
    }
    /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */ unexpected(atToken) {
        const token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
        return (0, $c4fb72a27dee0bdf$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Unexpected ${$c90175610888e178$var$getTokenDesc(token)}.`);
    }
    /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ any(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        while(!this.expectOptionalToken(closeKind))nodes.push(parseFn.call(this));
        return nodes;
    }
    /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ optionalMany(openKind, parseFn, closeKind) {
        if (this.expectOptionalToken(openKind)) {
            const nodes = [];
            do nodes.push(parseFn.call(this));
            while (!this.expectOptionalToken(closeKind));
            return nodes;
        }
        return [];
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */ many(openKind, parseFn, closeKind) {
        this.expectToken(openKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (!this.expectOptionalToken(closeKind));
        return nodes;
    }
    /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */ delimitedMany(delimiterKind, parseFn) {
        this.expectOptionalToken(delimiterKind);
        const nodes = [];
        do nodes.push(parseFn.call(this));
        while (this.expectOptionalToken(delimiterKind));
        return nodes;
    }
    advanceLexer() {
        const { maxTokens: maxTokens } = this._options;
        const token = this._lexer.advance();
        if (maxTokens !== undefined && token.kind !== (0, $f1a4742d8ee8916b$export$8b9d26ab11394711).EOF) {
            ++this._tokenCounter;
            if (this._tokenCounter > maxTokens) throw (0, $c4fb72a27dee0bdf$export$bbee0c6176c019d4)(this._lexer.source, token.start, `Document contains more that ${maxTokens} tokens. Parsing aborted.`);
        }
    }
}
/**
 * A helper function to describe a token as a string for debugging.
 */ function $c90175610888e178$var$getTokenDesc(token) {
    const value = token.value;
    return $c90175610888e178$var$getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : "");
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */ function $c90175610888e178$var$getTokenKindDesc(kind) {
    return (0, $b26ab8a3e948be10$export$59ac0f4da287406a)(kind) ? `"${kind}"` : kind;
}


var $d155419fd10bd2b6$var$docCache = new Map();
var $d155419fd10bd2b6$var$fragmentSourceMap = new Map();
var $d155419fd10bd2b6$var$printFragmentWarnings = true;
var $d155419fd10bd2b6$var$experimentalFragmentVariables = false;
function $d155419fd10bd2b6$var$normalize(string) {
    return string.replace(/[\s,]+/g, " ").trim();
}
function $d155419fd10bd2b6$var$cacheKeyFromLoc(loc) {
    return $d155419fd10bd2b6$var$normalize(loc.source.body.substring(loc.start, loc.end));
}
function $d155419fd10bd2b6$var$processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function(fragmentDefinition) {
        if (fragmentDefinition.kind === "FragmentDefinition") {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = $d155419fd10bd2b6$var$cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = $d155419fd10bd2b6$var$fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if ($d155419fd10bd2b6$var$printFragmentWarnings) console.warn("Warning: fragment with name " + fragmentName + " already exists.\n" + "graphql-tag enforces all fragment names across your application to be unique; read more about\n" + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
            } else if (!sourceKeySet) $d155419fd10bd2b6$var$fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        } else definitions.push(fragmentDefinition);
    });
    return (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, ast), {
        definitions: definitions
    });
}
function $d155419fd10bd2b6$var$stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function(node) {
        if (node.loc) delete node.loc;
        Object.keys(node).forEach(function(key) {
            var value = node[key];
            if (value && typeof value === "object") workSet.add(value);
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function $d155419fd10bd2b6$var$parseDocument(source) {
    var cacheKey = $d155419fd10bd2b6$var$normalize(source);
    if (!$d155419fd10bd2b6$var$docCache.has(cacheKey)) {
        var parsed = (0, $c90175610888e178$export$98e6a39c04603d36)(source, {
            experimentalFragmentVariables: $d155419fd10bd2b6$var$experimentalFragmentVariables,
            allowLegacyFragmentVariables: $d155419fd10bd2b6$var$experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== "Document") throw new Error("Not a valid GraphQL document.");
        $d155419fd10bd2b6$var$docCache.set(cacheKey, $d155419fd10bd2b6$var$stripLoc($d155419fd10bd2b6$var$processFragments(parsed)));
    }
    return $d155419fd10bd2b6$var$docCache.get(cacheKey);
}
function $d155419fd10bd2b6$export$72e4926bf8358653(literals) {
    var args = [];
    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
    if (typeof literals === "string") literals = [
        literals
    ];
    var result = literals[0];
    args.forEach(function(arg, i) {
        if (arg && arg.kind === "Document") result += arg.loc.source.body;
        else result += arg;
        result += literals[i + 1];
    });
    return $d155419fd10bd2b6$var$parseDocument(result);
}
function $d155419fd10bd2b6$export$657554ef4dc7ac2d() {
    $d155419fd10bd2b6$var$docCache.clear();
    $d155419fd10bd2b6$var$fragmentSourceMap.clear();
}
function $d155419fd10bd2b6$export$e4294e638636c6ab() {
    $d155419fd10bd2b6$var$printFragmentWarnings = false;
}
function $d155419fd10bd2b6$export$78cf889af350c840() {
    $d155419fd10bd2b6$var$experimentalFragmentVariables = true;
}
function $d155419fd10bd2b6$export$5290df9bbbd3cfa() {
    $d155419fd10bd2b6$var$experimentalFragmentVariables = false;
}
var $d155419fd10bd2b6$var$extras = {
    gql: $d155419fd10bd2b6$export$72e4926bf8358653,
    resetCaches: $d155419fd10bd2b6$export$657554ef4dc7ac2d,
    disableFragmentWarnings: $d155419fd10bd2b6$export$e4294e638636c6ab,
    enableExperimentalFragmentVariables: $d155419fd10bd2b6$export$78cf889af350c840,
    disableExperimentalFragmentVariables: $d155419fd10bd2b6$export$5290df9bbbd3cfa
};
(function(gql_1) {
    gql_1.gql = $d155419fd10bd2b6$var$extras.gql, gql_1.resetCaches = $d155419fd10bd2b6$var$extras.resetCaches, gql_1.disableFragmentWarnings = $d155419fd10bd2b6$var$extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = $d155419fd10bd2b6$var$extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = $d155419fd10bd2b6$var$extras.disableExperimentalFragmentVariables;
})($d155419fd10bd2b6$export$72e4926bf8358653 || ($d155419fd10bd2b6$export$72e4926bf8358653 = {}));
$d155419fd10bd2b6$export$72e4926bf8358653["default"] = $d155419fd10bd2b6$export$72e4926bf8358653;
var $d155419fd10bd2b6$export$2e2bcd8739ae039 = $d155419fd10bd2b6$export$72e4926bf8358653;




/**
 * Merges the provided objects shallowly and removes
 * all properties with an `undefined` value
 */ function $9017e689666d6554$export$8e16b83750b44988() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}


function $77f4ff3b2e7d3a15$export$235b7fc70b9fc359(defaults, options) {
    return (0, $9017e689666d6554$export$8e16b83750b44988)(defaults, options, options.variables && {
        variables: (0, $9017e689666d6554$export$8e16b83750b44988)((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, defaults && defaults.variables), options.variables))
    });
}


const { toString: $9c119e23bb7e8c34$var$toString, hasOwnProperty: $9c119e23bb7e8c34$var$hasOwnProperty } = Object.prototype;
const $9c119e23bb7e8c34$var$fnToStr = Function.prototype.toString;
const $9c119e23bb7e8c34$var$previousComparisons = new Map();
function $9c119e23bb7e8c34$export$411ce8e5a71e3069(a, b) {
    try {
        return $9c119e23bb7e8c34$var$check(a, b);
    } finally{
        $9c119e23bb7e8c34$var$previousComparisons.clear();
    }
}
var // Allow default imports as well.
$9c119e23bb7e8c34$export$2e2bcd8739ae039 = $9c119e23bb7e8c34$export$411ce8e5a71e3069;
function $9c119e23bb7e8c34$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = $9c119e23bb7e8c34$var$toString.call(a);
    const bTag = $9c119e23bb7e8c34$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case "[object Array]":
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case "[object Object]":
            {
                if ($9c119e23bb7e8c34$var$previouslyCompared(a, b)) return true;
                const aKeys = $9c119e23bb7e8c34$var$definedKeys(a);
                const bKeys = $9c119e23bb7e8c34$var$definedKeys(b);
                // If `a` and `b` have a different number of enumerable keys, they
                // must be different.
                const keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                // Now make sure they have the same keys.
                for(let k = 0; k < keyCount; ++k){
                    if (!$9c119e23bb7e8c34$var$hasOwnProperty.call(b, aKeys[k])) return false;
                }
                // Finally, check deep equality of all child properties.
                for(let k = 0; k < keyCount; ++k){
                    const key = aKeys[k];
                    if (!$9c119e23bb7e8c34$var$check(a[key], b[key])) return false;
                }
                return true;
            }
        case "[object Error]":
            return a.name === b.name && a.message === b.message;
        case "[object Number]":
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case "[object Boolean]":
        case "[object Date]":
            return +a === +b;
        case "[object RegExp]":
        case "[object String]":
            return a == `${b}`;
        case "[object Map]":
        case "[object Set]":
            {
                if (a.size !== b.size) return false;
                if ($9c119e23bb7e8c34$var$previouslyCompared(a, b)) return true;
                const aIterator = a.entries();
                const isMap = aTag === "[object Map]";
                while(true){
                    const info = aIterator.next();
                    if (info.done) break;
                    // If a instanceof Set, aValue === aKey.
                    const [aKey, aValue] = info.value;
                    // So this works the same way for both Set and Map.
                    if (!b.has(aKey)) return false;
                    // However, we care about deep equality of values only when dealing
                    // with Map structures.
                    if (isMap && !$9c119e23bb7e8c34$var$check(aValue, b.get(aKey))) return false;
                }
                return true;
            }
        case "[object Uint16Array]":
        case "[object Uint8Array]":
        case "[object Uint32Array]":
        case "[object Int32Array]":
        case "[object Int8Array]":
        case "[object Int16Array]":
        case "[object ArrayBuffer]":
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case "[object DataView]":
            {
                let len = a.byteLength;
                if (len === b.byteLength) {
                    while(len-- && a[len] === b[len]);
                }
                return len === -1;
            }
        case "[object AsyncFunction]":
        case "[object GeneratorFunction]":
        case "[object AsyncGeneratorFunction]":
        case "[object Function]":
            {
                const aCode = $9c119e23bb7e8c34$var$fnToStr.call(a);
                if (aCode !== $9c119e23bb7e8c34$var$fnToStr.call(b)) return false;
                // We consider non-native functions equal if they have the same code
                // (native functions require === because their code is censored).
                // Note that this behavior is not entirely sound, since !== function
                // objects with the same code can behave differently depending on
                // their closure scope. However, any function can behave differently
                // depending on the values of its input arguments (including this)
                // and its calling context (including its closure scope), even
                // though the function object is === to itself; and it is entirely
                // possible for functions that are not === to behave exactly the
                // same under all conceivable circumstances. Because none of these
                // factors are statically decidable in JavaScript, JS function
                // equality is not well-defined. This ambiguity allows us to
                // consider the best possible heuristic among various imperfect
                // options, and equating non-native functions that have the same
                // code has enormous practical benefits, such as when comparing
                // functions that are repeatedly passed as fresh function
                // expressions within objects that are otherwise deeply equal. Since
                // any function created from the same syntactic expression (in the
                // same code location) will always stringify to the same code
                // according to fnToStr.call, we can reasonably expect these
                // repeatedly passed function expressions to have the same code, and
                // thus behave "the same" (with all the caveats mentioned above),
                // even though the runtime function objects are !== to one another.
                return !$9c119e23bb7e8c34$var$endsWith(aCode, $9c119e23bb7e8c34$var$nativeCodeSuffix);
            }
    }
    // Otherwise the values are not equal.
    return false;
}
function $9c119e23bb7e8c34$var$definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter($9c119e23bb7e8c34$var$isDefinedKey, obj);
}
function $9c119e23bb7e8c34$var$isDefinedKey(key) {
    return this[key] !== void 0;
}
const $9c119e23bb7e8c34$var$nativeCodeSuffix = "{ [native code] }";
function $9c119e23bb7e8c34$var$endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function $9c119e23bb7e8c34$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = $9c119e23bb7e8c34$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $9c119e23bb7e8c34$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}



function $1f6a19d4ae0f8e0c$var$defaultDispose() {}
class $1f6a19d4ae0f8e0c$export$d3a0331d2c286dc8 {
    constructor(max = Infinity, dispose = $1f6a19d4ae0f8e0c$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    get size() {
        return this.map.size;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    }
    clean() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            if (node === this.newest) this.newest = node.older;
            if (node === this.oldest) this.oldest = node.newer;
            if (node.newer) node.newer.older = node.older;
            if (node.older) node.older.newer = node.newer;
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    }
}

function $e043dec6e16a9988$var$noop() {}
const $e043dec6e16a9988$var$defaultDispose = $e043dec6e16a9988$var$noop;
const $e043dec6e16a9988$var$_WeakRef = typeof WeakRef !== "undefined" ? WeakRef : function(value) {
    return {
        deref: ()=>value
    };
};
const $e043dec6e16a9988$var$_WeakMap = typeof WeakMap !== "undefined" ? WeakMap : Map;
const $e043dec6e16a9988$var$_FinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : function() {
    return {
        register: $e043dec6e16a9988$var$noop,
        unregister: $e043dec6e16a9988$var$noop
    };
};
const $e043dec6e16a9988$var$finalizationBatchSize = 10024;
class $e043dec6e16a9988$export$87b462129af3b7d4 {
    constructor(max = Infinity, dispose = $e043dec6e16a9988$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new $e043dec6e16a9988$var$_WeakMap();
        this.newest = null;
        this.oldest = null;
        this.unfinalizedNodes = new Set();
        this.finalizationScheduled = false;
        this.size = 0;
        this.finalize = ()=>{
            const iterator = this.unfinalizedNodes.values();
            for(let i = 0; i < $e043dec6e16a9988$var$finalizationBatchSize; i++){
                const node = iterator.next().value;
                if (!node) break;
                this.unfinalizedNodes.delete(node);
                const key = node.key;
                delete node.key;
                node.keyRef = new $e043dec6e16a9988$var$_WeakRef(key);
                this.registry.register(key, node, node);
            }
            if (this.unfinalizedNodes.size > 0) queueMicrotask(this.finalize);
            else this.finalizationScheduled = false;
        };
        this.registry = new $e043dec6e16a9988$var$_FinalizationRegistry(this.deleteNode.bind(this));
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.scheduleFinalization(node);
        this.map.set(key, node);
        this.size++;
        return node.value;
    }
    clean() {
        while(this.oldest && this.size > this.max)this.deleteNode(this.oldest);
    }
    deleteNode(node) {
        if (node === this.newest) this.newest = node.older;
        if (node === this.oldest) this.oldest = node.newer;
        if (node.newer) node.newer.older = node.older;
        if (node.older) node.older.newer = node.newer;
        this.size--;
        const key = node.key || node.keyRef && node.keyRef.deref();
        this.dispose(node.value, key);
        if (!node.keyRef) this.unfinalizedNodes.delete(node);
        else this.registry.unregister(node);
        if (key) this.map.delete(key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            this.deleteNode(node);
            return true;
        }
        return false;
    }
    scheduleFinalization(node) {
        this.unfinalizedNodes.add(node);
        if (!this.finalizationScheduled) {
            this.finalizationScheduled = true;
            queueMicrotask(this.finalize);
        }
    }
}


var $df1718e4a0eb4d0a$var$scheduledCleanup = new WeakSet();
function $df1718e4a0eb4d0a$var$schedule(cache) {
    if (!$df1718e4a0eb4d0a$var$scheduledCleanup.has(cache)) {
        $df1718e4a0eb4d0a$var$scheduledCleanup.add(cache);
        setTimeout(function() {
            cache.clean();
            $df1718e4a0eb4d0a$var$scheduledCleanup.delete(cache);
        }, 100);
    }
}
var $df1718e4a0eb4d0a$export$8dbad6f439bb2331 = function(max, dispose) {
    /*
    Some builds of `WeakCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $e043dec6e16a9988$export$87b462129af3b7d4)(max, dispose);
    cache.set = function(key, value) {
        $df1718e4a0eb4d0a$var$schedule(this);
        return (0, $e043dec6e16a9988$export$87b462129af3b7d4).prototype.set.call(this, key, value);
    };
    return cache;
};
var $df1718e4a0eb4d0a$export$5b4f745137d91413 = function(max, dispose) {
    /*
    Some builds of `StrongCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $1f6a19d4ae0f8e0c$export$d3a0331d2c286dc8)(max, dispose);
    cache.set = function(key, value) {
        $df1718e4a0eb4d0a$var$schedule(this);
        return (0, $1f6a19d4ae0f8e0c$export$d3a0331d2c286dc8).prototype.set.call(this, key, value);
    };
    return cache;
};



var $e8270474df1c6a9d$var$cacheSizeSymbol = Symbol.for("apollo.cacheSize");
var $e8270474df1c6a9d$export$f29926b23b28936b = (0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, (0, $040d8b3cb21a952a$export$2e2bcd8739ae039)[$e8270474df1c6a9d$var$cacheSizeSymbol]);




var $19eefe0273f1ef83$var$globalCaches = {};
function $19eefe0273f1ef83$export$a8fcd406d9e37621(name, getSize) {
    $19eefe0273f1ef83$var$globalCaches[name] = getSize;
}
var $19eefe0273f1ef83$export$dfdba94ce46d2ea5 = globalThis.__DEV__ !== false ? $19eefe0273f1ef83$var$_getApolloClientMemoryInternals : undefined;
var $19eefe0273f1ef83$export$e95a5a2210e62466 = globalThis.__DEV__ !== false ? $19eefe0273f1ef83$var$_getInMemoryCacheMemoryInternals : undefined;
var $19eefe0273f1ef83$export$e7ed438e82606689 = globalThis.__DEV__ !== false ? $19eefe0273f1ef83$var$_getApolloCacheMemoryInternals : undefined;
function $19eefe0273f1ef83$var$getCurrentCacheSizes() {
    // `defaultCacheSizes` is a `const enum` that will be inlined during build, so we have to reconstruct it's shape here
    var defaults = {
        parser: 1000 /* defaultCacheSizes["parser"] */ ,
        canonicalStringify: 1000 /* defaultCacheSizes["canonicalStringify"] */ ,
        print: 2000 /* defaultCacheSizes["print"] */ ,
        "documentTransform.cache": 2000 /* defaultCacheSizes["documentTransform.cache"] */ ,
        "queryManager.getDocumentInfo": 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ ,
        "PersistedQueryLink.persistedQueryHashes": 2000 /* defaultCacheSizes["PersistedQueryLink.persistedQueryHashes"] */ ,
        "fragmentRegistry.transform": 2000 /* defaultCacheSizes["fragmentRegistry.transform"] */ ,
        "fragmentRegistry.lookup": 1000 /* defaultCacheSizes["fragmentRegistry.lookup"] */ ,
        "fragmentRegistry.findFragmentSpreads": 4000 /* defaultCacheSizes["fragmentRegistry.findFragmentSpreads"] */ ,
        "cache.fragmentQueryDocuments": 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
        "removeTypenameFromVariables.getVariableDefinitions": 2000 /* defaultCacheSizes["removeTypenameFromVariables.getVariableDefinitions"] */ ,
        "inMemoryCache.maybeBroadcastWatch": 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
        "inMemoryCache.executeSelectionSet": 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
        "inMemoryCache.executeSubSelectedArray": 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ 
    };
    return Object.fromEntries(Object.entries(defaults).map(function(_a) {
        var k = _a[0], v = _a[1];
        return [
            k,
            (0, $e8270474df1c6a9d$export$f29926b23b28936b)[k] || v
        ];
    }));
}
function $19eefe0273f1ef83$var$_getApolloClientMemoryInternals() {
    var _a, _b, _c, _d, _e;
    if (!(globalThis.__DEV__ !== false)) throw new Error("only supported in development mode");
    return {
        limits: $19eefe0273f1ef83$var$getCurrentCacheSizes(),
        sizes: (0, $e2e041e4a1657497$export$18ce0697a983be9b)({
            print: (_a = $19eefe0273f1ef83$var$globalCaches.print) === null || _a === void 0 ? void 0 : _a.call($19eefe0273f1ef83$var$globalCaches),
            parser: (_b = $19eefe0273f1ef83$var$globalCaches.parser) === null || _b === void 0 ? void 0 : _b.call($19eefe0273f1ef83$var$globalCaches),
            canonicalStringify: (_c = $19eefe0273f1ef83$var$globalCaches.canonicalStringify) === null || _c === void 0 ? void 0 : _c.call($19eefe0273f1ef83$var$globalCaches),
            links: $19eefe0273f1ef83$var$linkInfo(this.link),
            queryManager: {
                getDocumentInfo: this["queryManager"]["transformCache"].size,
                documentTransforms: $19eefe0273f1ef83$var$transformInfo(this["queryManager"].documentTransform)
            }
        }, (_e = (_d = this.cache).getMemoryInternals) === null || _e === void 0 ? void 0 : _e.call(_d))
    };
}
function $19eefe0273f1ef83$var$_getApolloCacheMemoryInternals() {
    return {
        cache: {
            fragmentQueryDocuments: $19eefe0273f1ef83$var$getWrapperInformation(this["getFragmentDoc"])
        }
    };
}
function $19eefe0273f1ef83$var$_getInMemoryCacheMemoryInternals() {
    var fragments = this.config.fragments;
    return (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, $19eefe0273f1ef83$var$_getApolloCacheMemoryInternals.apply(this)), {
        addTypenameDocumentTransform: $19eefe0273f1ef83$var$transformInfo(this["addTypenameTransform"]),
        inMemoryCache: {
            executeSelectionSet: $19eefe0273f1ef83$var$getWrapperInformation(this["storeReader"]["executeSelectionSet"]),
            executeSubSelectedArray: $19eefe0273f1ef83$var$getWrapperInformation(this["storeReader"]["executeSubSelectedArray"]),
            maybeBroadcastWatch: $19eefe0273f1ef83$var$getWrapperInformation(this["maybeBroadcastWatch"])
        },
        fragmentRegistry: {
            findFragmentSpreads: $19eefe0273f1ef83$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.findFragmentSpreads),
            lookup: $19eefe0273f1ef83$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.lookup),
            transform: $19eefe0273f1ef83$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.transform)
        }
    });
}
function $19eefe0273f1ef83$var$isWrapper(f) {
    return !!f && "dirtyKey" in f;
}
function $19eefe0273f1ef83$var$getWrapperInformation(f) {
    return $19eefe0273f1ef83$var$isWrapper(f) ? f.size : undefined;
}
function $19eefe0273f1ef83$var$isDefined(value) {
    return value != null;
}
function $19eefe0273f1ef83$var$transformInfo(transform) {
    return $19eefe0273f1ef83$var$recurseTransformInfo(transform).map(function(cache) {
        return {
            cache: cache
        };
    });
}
function $19eefe0273f1ef83$var$recurseTransformInfo(transform) {
    return transform ? (0, $e2e041e4a1657497$export$1216008129fb82ed)((0, $e2e041e4a1657497$export$1216008129fb82ed)([
        $19eefe0273f1ef83$var$getWrapperInformation(transform === null || transform === void 0 ? void 0 : transform["performWork"])
    ], $19eefe0273f1ef83$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["left"]), true), $19eefe0273f1ef83$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["right"]), true).filter($19eefe0273f1ef83$var$isDefined) : [];
}
function $19eefe0273f1ef83$var$linkInfo(link) {
    var _a;
    return link ? (0, $e2e041e4a1657497$export$1216008129fb82ed)((0, $e2e041e4a1657497$export$1216008129fb82ed)([
        (_a = link === null || link === void 0 ? void 0 : link.getMemoryInternals) === null || _a === void 0 ? void 0 : _a.call(link)
    ], $19eefe0273f1ef83$var$linkInfo(link === null || link === void 0 ? void 0 : link.left), true), $19eefe0273f1ef83$var$linkInfo(link === null || link === void 0 ? void 0 : link.right), true).filter($19eefe0273f1ef83$var$isDefined) : [];
}


var $fa8747fdebb30d60$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($fa8747fdebb30d60$export$d1d99cf900472499 || ($fa8747fdebb30d60$export$d1d99cf900472499 = {}));
var $fa8747fdebb30d60$var$cache;
function $fa8747fdebb30d60$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $fa8747fdebb30d60$export$d1d99cf900472499.Query:
            name = "Query";
            break;
        case $fa8747fdebb30d60$export$d1d99cf900472499.Mutation:
            name = "Mutation";
            break;
        case $fa8747fdebb30d60$export$d1d99cf900472499.Subscription:
            name = "Subscription";
            break;
    }
    return name;
}
function $fa8747fdebb30d60$export$8f49e4af10703ce3(document) {
    if (!$fa8747fdebb30d60$var$cache) $fa8747fdebb30d60$var$cache = new (0, $df1718e4a0eb4d0a$export$8dbad6f439bb2331)((0, $e8270474df1c6a9d$export$f29926b23b28936b).parser || 1000 /* defaultCacheSizes.parser */ );
    var cached = $fa8747fdebb30d60$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $57583217334b5278$export$f5708dca728d7177)(!!document && !!document.kind, 59, document);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for(var _i = 0, _a = document.definitions; _i < _a.length; _i++){
        var x = _a[_i];
        if (x.kind === "FragmentDefinition") {
            fragments.push(x);
            continue;
        }
        if (x.kind === "OperationDefinition") switch(x.operation){
            case "query":
                queries.push(x);
                break;
            case "mutation":
                mutations.push(x);
                break;
            case "subscription":
                subscriptions.push(x);
                break;
        }
    }
    (0, $57583217334b5278$export$f5708dca728d7177)(!fragments.length || queries.length || mutations.length || subscriptions.length, 60);
    (0, $57583217334b5278$export$f5708dca728d7177)(queries.length + mutations.length + subscriptions.length <= 1, 61, document, queries.length, subscriptions.length, mutations.length);
    type = queries.length ? $fa8747fdebb30d60$export$d1d99cf900472499.Query : $fa8747fdebb30d60$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $fa8747fdebb30d60$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $57583217334b5278$export$f5708dca728d7177)(definitions.length === 1, 62, document, definitions.length);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === "Name") name = definition.name.value;
    else name = "data"; // fallback to using data if no name
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $fa8747fdebb30d60$var$cache.set(document, payload);
    return payload;
}
$fa8747fdebb30d60$export$8f49e4af10703ce3.resetCache = function() {
    $fa8747fdebb30d60$var$cache = undefined;
};
if (globalThis.__DEV__ !== false) (0, $19eefe0273f1ef83$export$a8fcd406d9e37621)("parser", function() {
    return $fa8747fdebb30d60$var$cache ? $fa8747fdebb30d60$var$cache.size : 0;
});
function $fa8747fdebb30d60$export$6dfb8732f737404c(document, type) {
    var operation = $fa8747fdebb30d60$export$8f49e4af10703ce3(document);
    var requiredOperationName = $fa8747fdebb30d60$export$5db520940cf00715(type);
    var usedOperationName = $fa8747fdebb30d60$export$5db520940cf00715(operation.type);
    (0, $57583217334b5278$export$f5708dca728d7177)(operation.type === type, 63, requiredOperationName, requiredOperationName, usedOperationName);
}




function $a5b286f532530da9$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === "object";
}
function $a5b286f532530da9$export$53b83ca8eaab0383(obj) {
    return obj !== null && typeof obj === "object" && (Object.getPrototypeOf(obj) === Object.prototype || Object.getPrototypeOf(obj) === null);
}


var $9eab3cada5a2feb5$export$4995664c1b49842e = Symbol();
function $9eab3cada5a2feb5$export$345f95cc6b6b9b0b(result) {
    if (result.extensions) return Array.isArray(result.extensions[$9eab3cada5a2feb5$export$4995664c1b49842e]);
    return false;
}
function $9eab3cada5a2feb5$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty("graphQLErrors");
}
// Sets the error message on this error according to the
// the GraphQL and network errors that are present.
// If the error message has already been set through the
// constructor or otherwise, this function is a nop.
var $9eab3cada5a2feb5$var$generateErrorMessage = function(err) {
    var errors = (0, $e2e041e4a1657497$export$1216008129fb82ed)((0, $e2e041e4a1657497$export$1216008129fb82ed)((0, $e2e041e4a1657497$export$1216008129fb82ed)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError) errors.push(err.networkError);
    return errors// The rest of the code sometimes unsafely types non-Error objects as GraphQLErrors
    .map(function(err) {
        return (0, $a5b286f532530da9$export$417207af72fad9c9)(err) && err.message || "Error message not found.";
    }).join("\n");
};
var $9eab3cada5a2feb5$export$26a337512320b8c6 = /** @class */ function(_super) {
    (0, $e2e041e4a1657497$export$a8ba968b8961cb8a)(ApolloError, _super);
    // Constructs an instance of ApolloError given a GraphQLError
    // or a network error. Note that one of these has to be a valid
    // value or the constructed error will be meaningless.
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $9eab3cada5a2feb5$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        // We're not using `Object.setPrototypeOf` here as it isn't fully
        // supported on Android (see issue #3236).
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);





function $7626a5aec6f1579a$export$eb9a56e7a29e494(override) {
    var context = $6a3c74d1b5373fb5$exports.useContext((0, $9056696600b1719a$export$a47505d961ee3a1)());
    var client = override || context.client;
    (0, $57583217334b5278$export$f5708dca728d7177)(!!client, 49);
    return client;
}


function $1f0b8701b604e718$export$609860bf8b0084c(mutation, options) {
    var client = (0, $7626a5aec6f1579a$export$eb9a56e7a29e494)(options === null || options === void 0 ? void 0 : options.client);
    (0, $fa8747fdebb30d60$export$6dfb8732f737404c)(mutation, (0, $fa8747fdebb30d60$export$d1d99cf900472499).Mutation);
    var _a = $6a3c74d1b5373fb5$exports.useState({
        called: false,
        loading: false,
        client: client
    }), result = _a[0], setResult = _a[1];
    var ref = $6a3c74d1b5373fb5$exports.useRef({
        result: result,
        mutationId: 0,
        isMounted: true,
        client: client,
        mutation: mutation,
        options: options
    });
    Object.assign(ref.current, {
        client: client,
        options: options,
        mutation: mutation
    });
    var execute = $6a3c74d1b5373fb5$exports.useCallback(function(executeOptions) {
        if (executeOptions === void 0) executeOptions = {};
        var _a = ref.current, options = _a.options, mutation = _a.mutation;
        var baseOptions = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options), {
            mutation: mutation
        });
        var client = executeOptions.client || ref.current.client;
        if (!ref.current.result.loading && !baseOptions.ignoreResults && ref.current.isMounted) setResult(ref.current.result = {
            loading: true,
            error: void 0,
            data: void 0,
            called: true,
            client: client
        });
        var mutationId = ++ref.current.mutationId;
        var clientOptions = (0, $77f4ff3b2e7d3a15$export$235b7fc70b9fc359)(baseOptions, executeOptions);
        return client.mutate(clientOptions).then(function(response) {
            var _a, _b;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0 ? new (0, $9eab3cada5a2feb5$export$26a337512320b8c6)({
                graphQLErrors: errors
            }) : void 0;
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (error && onError) onError(error, clientOptions);
            if (mutationId === ref.current.mutationId && !clientOptions.ignoreResults) {
                var result_1 = {
                    called: true,
                    loading: false,
                    data: data,
                    error: error,
                    client: client
                };
                if (ref.current.isMounted && !(0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(ref.current.result, result_1)) setResult(ref.current.result = result_1);
            }
            var onCompleted = executeOptions.onCompleted || ((_b = ref.current.options) === null || _b === void 0 ? void 0 : _b.onCompleted);
            if (!error) onCompleted === null || onCompleted === void 0 || onCompleted(response.data, clientOptions);
            return response;
        }).catch(function(error) {
            var _a;
            if (mutationId === ref.current.mutationId && ref.current.isMounted) {
                var result_2 = {
                    loading: false,
                    error: error,
                    data: void 0,
                    called: true,
                    client: client
                };
                if (!(0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(ref.current.result, result_2)) setResult(ref.current.result = result_2);
            }
            var onError = executeOptions.onError || ((_a = ref.current.options) === null || _a === void 0 ? void 0 : _a.onError);
            if (onError) {
                onError(error, clientOptions);
                // TODO(brian): why are we returning this here???
                return {
                    data: void 0,
                    errors: error
                };
            }
            throw error;
        });
    }, []);
    var reset = $6a3c74d1b5373fb5$exports.useCallback(function() {
        if (ref.current.isMounted) {
            var result_3 = {
                called: false,
                loading: false,
                client: client
            };
            Object.assign(ref.current, {
                mutationId: 0,
                result: result_3
            });
            setResult(result_3);
        }
    }, []);
    $6a3c74d1b5373fb5$exports.useEffect(function() {
        ref.current.isMounted = true;
        return function() {
            ref.current.isMounted = false;
        };
    }, []);
    return [
        execute,
        (0, $e2e041e4a1657497$export$18ce0697a983be9b)({
            reset: reset
        }, result)
    ];
}







var $331eb147df61d31e$var$didWarnUncachedGetSnapshot = false;
// Prevent webpack from complaining about our feature detection of the
// useSyncExternalStore property of the React namespace, which is expected not
// to exist when using React 17 and earlier, and that's fine.
var $331eb147df61d31e$var$uSESKey = "useSyncExternalStore";
var $331eb147df61d31e$var$realHook = $6a3c74d1b5373fb5$exports[$331eb147df61d31e$var$uSESKey];
var $331eb147df61d31e$export$306c0aa65ff9ec16 = $331eb147df61d31e$var$realHook || function(subscribe, getSnapshot, getServerSnapshot) {
    // Read the current snapshot from the store on every render. Again, this
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    var value = getSnapshot();
    if (// DEVIATION: Using __DEV__
    globalThis.__DEV__ !== false && !$331eb147df61d31e$var$didWarnUncachedGetSnapshot && // DEVIATION: Not using Object.is because we know our snapshots will never
    // be exotic primitive values like NaN, which is !== itself.
    value !== getSnapshot()) {
        $331eb147df61d31e$var$didWarnUncachedGetSnapshot = true;
        // DEVIATION: Using invariant.error instead of console.error directly.
        globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).error(58);
    }
    // Because updates are synchronous, we don't queue them. Instead we force a
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    var _a = $6a3c74d1b5373fb5$exports.useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _a[0].inst, forceUpdate = _a[1];
    // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    if (0, $9865fa0c1163b711$export$4001f6cd4a62405b) // DEVIATION: We avoid calling useLayoutEffect when !canUseLayoutEffect,
    // which may seem like a conditional hook, but this code ends up behaving
    // unconditionally (one way or the other) because canUseLayoutEffect is
    // constant.
    $6a3c74d1b5373fb5$exports.useLayoutEffect(function() {
        Object.assign(inst, {
            value: value,
            getSnapshot: getSnapshot
        });
        // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($331eb147df61d31e$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    else Object.assign(inst, {
        value: value,
        getSnapshot: getSnapshot
    });
    $6a3c74d1b5373fb5$exports.useEffect(function() {
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($331eb147df61d31e$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        // Subscribe to the store and return a clean-up function.
        return subscribe(function handleStoreChange() {
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($331eb147df61d31e$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    return value;
};
function $331eb147df61d31e$var$checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    } catch (_b) {
        return true;
    }
}



// A version of Array.isArray that works better with readonly arrays.
var $93b6d5db950815ab$export$43bee75e5e14138e = Array.isArray;
function $93b6d5db950815ab$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}


function $7d98bd712ac3042c$var$deepFreeze(value) {
    var workSet = new Set([
        value
    ]);
    workSet.forEach(function(obj) {
        if ((0, $a5b286f532530da9$export$417207af72fad9c9)(obj) && $7d98bd712ac3042c$var$shallowFreeze(obj) === obj) Object.getOwnPropertyNames(obj).forEach(function(name) {
            if ((0, $a5b286f532530da9$export$417207af72fad9c9)(obj[name])) workSet.add(obj[name]);
        });
    });
    return value;
}
function $7d98bd712ac3042c$var$shallowFreeze(obj) {
    if (globalThis.__DEV__ !== false && !Object.isFrozen(obj)) try {
        Object.freeze(obj);
    } catch (e) {
        // Some types like Uint8Array and Node.js's Buffer cannot be frozen, but
        // they all throw a TypeError when you try, so we re-throw any exceptions
        // that are not TypeErrors, since that would be unexpected.
        if (e instanceof TypeError) return null;
        throw e;
    }
    return obj;
}
function $7d98bd712ac3042c$export$7f9c177735b71f18(obj) {
    if (globalThis.__DEV__ !== false) $7d98bd712ac3042c$var$deepFreeze(obj);
    return obj;
}




/**
 * The current status of a query’s execution in our system.
 */ var $d609460db1ab26e8$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    /**
     * The query has never been run before and the query is now currently running. A query will still
     * have this network status even if a partial data result was returned from the cache, but a
     * query was dispatched anyway.
     */ NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    /**
     * If `setVariables` was called and a query was fired because of that then the network status
     * will be `setVariables` until the result of that query comes back.
     */ NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    /**
     * Indicates that `fetchMore` was called on this query and that the query created is currently in
     * flight.
     */ NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    /**
     * Similar to the `setVariables` network status. It means that `refetch` was called on a query
     * and the refetch request is currently in flight.
     */ NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    /**
     * Indicates that a polling query is currently in flight. So for example if you are polling a
     * query every 10 seconds then the network status will switch to `poll` every 10 seconds whenever
     * a poll request has been sent but not resolved.
     */ NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    /**
     * No request is in flight for this query, and no errors happened. Everything is OK.
     */ NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    /**
     * No request is in flight for this query, but one or more errors were detected.
     */ NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($d609460db1ab26e8$export$bd096ddbd246c79c || ($d609460db1ab26e8$export$bd096ddbd246c79c = {}));
function $d609460db1ab26e8$export$37509604341a3464(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
function $d609460db1ab26e8$export$427e8a52ef0f96e2(networkStatus) {
    return networkStatus === 7 || networkStatus === 8;
}




var $5ddc6cf91ca8fe18$var$wrapperSymbol = Symbol.for("apollo.hook.wrappers");
function $5ddc6cf91ca8fe18$export$7f12579c79e39619(hookName, useHook, clientOrObsQuery) {
    var queryManager = clientOrObsQuery["queryManager"];
    var wrappers = queryManager && queryManager[$5ddc6cf91ca8fe18$var$wrapperSymbol];
    var wrapper = wrappers && wrappers[hookName];
    return wrapper ? wrapper(useHook) : useHook;
}


var $f72ec353e2162d59$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $f72ec353e2162d59$export$dd0a697e1782aedd(query, options) {
    if (options === void 0) options = Object.create(null);
    return (0, $5ddc6cf91ca8fe18$export$7f12579c79e39619)("useQuery", $f72ec353e2162d59$var$_useQuery, (0, $7626a5aec6f1579a$export$eb9a56e7a29e494)(options && options.client))(query, options);
}
function $f72ec353e2162d59$var$_useQuery(query, options) {
    return $f72ec353e2162d59$export$6342ea8c555e49e5((0, $7626a5aec6f1579a$export$eb9a56e7a29e494)(options.client), query).useQuery(options);
}
function $f72ec353e2162d59$export$6342ea8c555e49e5(client, query) {
    var stateRef = $6a3c74d1b5373fb5$exports.useRef();
    if (!stateRef.current || client !== stateRef.current.client || query !== stateRef.current.query) stateRef.current = new $f72ec353e2162d59$var$InternalState(client, query, stateRef.current);
    var state = stateRef.current;
    // By default, InternalState.prototype.forceUpdate is an empty function, but
    // we replace it here (before anyone has had a chance to see this state yet)
    // with a function that unconditionally forces an update, using the latest
    // setTick function. Updating this state by calling state.forceUpdate is the
    // only way we trigger React component updates (no other useState calls within
    // the InternalState class).
    state.forceUpdateState = $6a3c74d1b5373fb5$exports.useReducer(function(tick) {
        return tick + 1;
    }, 0)[1];
    return state;
}
var $f72ec353e2162d59$var$InternalState = /** @class */ function() {
    function InternalState(client, query, previous) {
        var _this = this;
        this.client = client;
        this.query = query;
        /**
         * Will be overwritten by the `useSyncExternalStore` "force update" method
         * whenever it is available and reset to `forceUpdateState` when it isn't.
         */ this.forceUpdate = function() {
            return _this.forceUpdateState();
        };
        this.ssrDisabledResult = (0, $7d98bd712ac3042c$export$7f9c177735b71f18)({
            loading: true,
            data: void 0,
            error: void 0,
            networkStatus: (0, $d609460db1ab26e8$export$bd096ddbd246c79c).loading
        });
        this.skipStandbyResult = (0, $7d98bd712ac3042c$export$7f9c177735b71f18)({
            loading: false,
            data: void 0,
            error: void 0,
            networkStatus: (0, $d609460db1ab26e8$export$bd096ddbd246c79c).ready
        });
        // This cache allows the referential stability of this.result (as returned by
        // getCurrentResult) to translate into referential stability of the resulting
        // QueryResult object returned by toQueryResult.
        this.toQueryResultCache = new ((0, $9865fa0c1163b711$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
        (0, $fa8747fdebb30d60$export$6dfb8732f737404c)(query, (0, $fa8747fdebb30d60$export$d1d99cf900472499).Query);
        // Reuse previousData from previous InternalState (if any) to provide
        // continuity of previousData even if/when the query or client changes.
        var previousResult = previous && previous.result;
        var previousData = previousResult && previousResult.data;
        if (previousData) this.previousData = previousData;
    }
    /**
     * Forces an update using local component state.
     * As this is not batched with `useSyncExternalStore` updates,
     * this is only used as a fallback if the `useSyncExternalStore` "force update"
     * method is not registered at the moment.
     * See https://github.com/facebook/react/issues/25191
     *  */ InternalState.prototype.forceUpdateState = function() {
        // Replaced (in useInternalState) with a method that triggers an update.
        globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).warn(51);
    };
    InternalState.prototype.executeQuery = function(options) {
        var _this = this;
        var _a;
        if (options.query) Object.assign(this, {
            query: options.query
        });
        this.watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        var concast = this.observable.reobserveAsConcast(this.getObsQueryOptions());
        // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
        // but save the current data as this.previousData, just like setResult
        // usually does.
        this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
        this.result = void 0;
        this.forceUpdate();
        return new Promise(function(resolve) {
            var result;
            // Subscribe to the concast independently of the ObservableQuery in case
            // the component gets unmounted before the promise resolves. This prevents
            // the concast from terminating early and resolving with `undefined` when
            // there are no more subscribers for the concast.
            concast.subscribe({
                next: function(value) {
                    result = value;
                },
                error: function() {
                    resolve(_this.toQueryResult(_this.observable.getCurrentResult()));
                },
                complete: function() {
                    resolve(_this.toQueryResult(result));
                }
            });
        });
    };
    // Methods beginning with use- should be called according to the standard
    // rules of React hooks: only at the top level of the calling function, and
    // without any dynamic conditional logic.
    InternalState.prototype.useQuery = function(options) {
        var _this = this;
        // The renderPromises field gets initialized here in the useQuery method, at
        // the beginning of everything (for a given component rendering, at least),
        // so we can safely use this.renderPromises in other/later InternalState
        // methods without worrying it might be uninitialized. Even after
        // initialization, this.renderPromises is usually undefined (unless SSR is
        // happening), but that's fine as long as it has been initialized that way,
        // rather than left uninitialized.
        this.renderPromises = $6a3c74d1b5373fb5$exports.useContext((0, $9056696600b1719a$export$a47505d961ee3a1)()).renderPromises;
        this.useOptions(options);
        var obsQuery = this.useObservableQuery();
        var result = (0, $331eb147df61d31e$export$306c0aa65ff9ec16)($6a3c74d1b5373fb5$exports.useCallback(function(handleStoreChange) {
            if (_this.renderPromises) return function() {};
            _this.forceUpdate = handleStoreChange;
            var onNext = function() {
                var previousResult = _this.result;
                // We use `getCurrentResult()` instead of the onNext argument because
                // the values differ slightly. Specifically, loading results will have
                // an empty object for data instead of `undefined` for some reason.
                var result = obsQuery.getCurrentResult();
                // Make sure we're not attempting to re-render similar results
                if (previousResult && previousResult.loading === result.loading && previousResult.networkStatus === result.networkStatus && (0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(previousResult.data, result.data)) return;
                _this.setResult(result);
            };
            var onError = function(error) {
                subscription.unsubscribe();
                subscription = obsQuery.resubscribeAfterError(onNext, onError);
                if (!$f72ec353e2162d59$var$hasOwnProperty.call(error, "graphQLErrors")) // The error is not a GraphQL error
                throw error;
                var previousResult = _this.result;
                if (!previousResult || previousResult && previousResult.loading || !(0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(error, previousResult.error)) _this.setResult({
                    data: previousResult && previousResult.data,
                    error: error,
                    loading: false,
                    networkStatus: (0, $d609460db1ab26e8$export$bd096ddbd246c79c).error
                });
            };
            var subscription = obsQuery.subscribe(onNext, onError);
            // Do the "unsubscribe" with a short delay.
            // This way, an existing subscription can be reused without an additional
            // request if "unsubscribe"  and "resubscribe" to the same ObservableQuery
            // happen in very fast succession.
            return function() {
                setTimeout(function() {
                    return subscription.unsubscribe();
                });
                _this.forceUpdate = function() {
                    return _this.forceUpdateState();
                };
            };
        }, [
            // We memoize the subscribe function using useCallback and the following
            // dependency keys, because the subscribe function reference is all that
            // useSyncExternalStore uses internally as a dependency key for the
            // useEffect ultimately responsible for the subscription, so we are
            // effectively passing this dependency array to that useEffect buried
            // inside useSyncExternalStore, as desired.
            obsQuery,
            this.renderPromises,
            this.client.disableNetworkFetches
        ]), function() {
            return _this.getCurrentResult();
        }, function() {
            return _this.getCurrentResult();
        });
        // TODO Remove this method when we remove support for options.partialRefetch.
        this.unsafeHandlePartialRefetch(result);
        return this.toQueryResult(result);
    };
    InternalState.prototype.useOptions = function(options) {
        var _a;
        var watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        // Update this.watchQueryOptions, but only when they have changed, which
        // allows us to depend on the referential stability of
        // this.watchQueryOptions elsewhere.
        var currentWatchQueryOptions = this.watchQueryOptions;
        if (!(0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(watchQueryOptions, currentWatchQueryOptions)) {
            this.watchQueryOptions = watchQueryOptions;
            if (currentWatchQueryOptions && this.observable) {
                // Though it might be tempting to postpone this reobserve call to the
                // useEffect block, we need getCurrentResult to return an appropriate
                // loading:true result synchronously (later within the same call to
                // useQuery). Since we already have this.observable here (not true for
                // the very first call to useQuery), we are not initiating any new
                // subscriptions, though it does feel less than ideal that reobserve
                // (potentially) kicks off a network request (for example, when the
                // variables have changed), which is technically a side-effect.
                this.observable.reobserve(this.getObsQueryOptions());
                // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
                // but save the current data as this.previousData, just like setResult
                // usually does.
                this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
                this.result = void 0;
            }
        }
        // Make sure state.onCompleted and state.onError always reflect the latest
        // options.onCompleted and options.onError callbacks provided to useQuery,
        // since those functions are often recreated every time useQuery is called.
        // Like the forceUpdate method, the versions of these methods inherited from
        // InternalState.prototype are empty no-ops, but we can override them on the
        // base state object (without modifying the prototype).
        this.onCompleted = options.onCompleted || InternalState.prototype.onCompleted;
        this.onError = options.onError || InternalState.prototype.onError;
        if ((this.renderPromises || this.client.disableNetworkFetches) && this.queryHookOptions.ssr === false && !this.queryHookOptions.skip) // If SSR has been explicitly disabled, and this function has been called
        // on the server side, return the default loading state.
        this.result = this.ssrDisabledResult;
        else if (this.queryHookOptions.skip || this.watchQueryOptions.fetchPolicy === "standby") // When skipping a query (ie. we're not querying for data but still want to
        // render children), make sure the `data` is cleared out and `loading` is
        // set to `false` (since we aren't loading anything).
        //
        // NOTE: We no longer think this is the correct behavior. Skipping should
        // not automatically set `data` to `undefined`, but instead leave the
        // previous data in place. In other words, skipping should not mandate that
        // previously received data is all of a sudden removed. Unfortunately,
        // changing this is breaking, so we'll have to wait until Apollo Client 4.0
        // to address this.
        this.result = this.skipStandbyResult;
        else if (this.result === this.ssrDisabledResult || this.result === this.skipStandbyResult) this.result = void 0;
    };
    InternalState.prototype.getObsQueryOptions = function() {
        var toMerge = [];
        var globalDefaults = this.client.defaultOptions.watchQuery;
        if (globalDefaults) toMerge.push(globalDefaults);
        if (this.queryHookOptions.defaultOptions) toMerge.push(this.queryHookOptions.defaultOptions);
        // We use compact rather than mergeOptions for this part of the merge,
        // because we want watchQueryOptions.variables (if defined) to replace
        // this.observable.options.variables whole. This replacement allows
        // removing variables by removing them from the variables input to
        // useQuery. If the variables were always merged together (rather than
        // replaced), there would be no way to remove existing variables.
        // However, the variables from options.defaultOptions and globalDefaults
        // (if provided) should be merged, to ensure individual defaulted
        // variables always have values, if not otherwise defined in
        // observable.options or watchQueryOptions.
        toMerge.push((0, $9017e689666d6554$export$8e16b83750b44988)(this.observable && this.observable.options, this.watchQueryOptions));
        return toMerge.reduce((0, $77f4ff3b2e7d3a15$export$235b7fc70b9fc359));
    };
    // A function to massage options before passing them to ObservableQuery.
    InternalState.prototype.createWatchQueryOptions = function(_a) {
        var _b;
        if (_a === void 0) _a = {};
        var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, // The above options are useQuery-specific, so this ...otherOptions spread
        // makes otherOptions almost a WatchQueryOptions object, except for the
        // query property that we add below.
        otherOptions = (0, $e2e041e4a1657497$export$3c9a16f847548506)(_a, [
            "skip",
            "ssr",
            "onCompleted",
            "onError",
            "defaultOptions"
        ]);
        // This Object.assign is safe because otherOptions is a fresh ...rest object
        // that did not exist until just now, so modifications are still allowed.
        var watchQueryOptions = Object.assign(otherOptions, {
            query: this.query
        });
        if (this.renderPromises && (watchQueryOptions.fetchPolicy === "network-only" || watchQueryOptions.fetchPolicy === "cache-and-network")) // this behavior was added to react-apollo without explanation in this PR
        // https://github.com/apollographql/react-apollo/pull/1579
        watchQueryOptions.fetchPolicy = "cache-first";
        if (!watchQueryOptions.variables) watchQueryOptions.variables = {};
        if (skip) {
            var _c = watchQueryOptions.fetchPolicy, fetchPolicy = _c === void 0 ? this.getDefaultFetchPolicy() : _c, _d = watchQueryOptions.initialFetchPolicy, initialFetchPolicy = _d === void 0 ? fetchPolicy : _d;
            // When skipping, we set watchQueryOptions.fetchPolicy initially to
            // "standby", but we also need/want to preserve the initial non-standby
            // fetchPolicy that would have been used if not skipping.
            Object.assign(watchQueryOptions, {
                initialFetchPolicy: initialFetchPolicy,
                fetchPolicy: "standby"
            });
        } else if (!watchQueryOptions.fetchPolicy) watchQueryOptions.fetchPolicy = ((_b = this.observable) === null || _b === void 0 ? void 0 : _b.options.initialFetchPolicy) || this.getDefaultFetchPolicy();
        return watchQueryOptions;
    };
    InternalState.prototype.getDefaultFetchPolicy = function() {
        var _a, _b;
        return ((_a = this.queryHookOptions.defaultOptions) === null || _a === void 0 ? void 0 : _a.fetchPolicy) || ((_b = this.client.defaultOptions.watchQuery) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "cache-first";
    };
    // Defining these methods as no-ops on the prototype allows us to call
    // state.onCompleted and/or state.onError without worrying about whether a
    // callback was provided.
    InternalState.prototype.onCompleted = function(data) {};
    InternalState.prototype.onError = function(error) {};
    InternalState.prototype.useObservableQuery = function() {
        // See if there is an existing observable that was used to fetch the same
        // data and if so, use it instead since it will contain the proper queryId
        // to fetch the result set. This is used during SSR.
        var obsQuery = this.observable = this.renderPromises && this.renderPromises.getSSRObservable(this.watchQueryOptions) || this.observable || // Reuse this.observable if possible (and not SSR)
        this.client.watchQuery(this.getObsQueryOptions());
        this.obsQueryFields = $6a3c74d1b5373fb5$exports.useMemo(function() {
            return {
                refetch: obsQuery.refetch.bind(obsQuery),
                reobserve: obsQuery.reobserve.bind(obsQuery),
                fetchMore: obsQuery.fetchMore.bind(obsQuery),
                updateQuery: obsQuery.updateQuery.bind(obsQuery),
                startPolling: obsQuery.startPolling.bind(obsQuery),
                stopPolling: obsQuery.stopPolling.bind(obsQuery),
                subscribeToMore: obsQuery.subscribeToMore.bind(obsQuery)
            };
        }, [
            obsQuery
        ]);
        var ssrAllowed = !(this.queryHookOptions.ssr === false || this.queryHookOptions.skip);
        if (this.renderPromises && ssrAllowed) {
            this.renderPromises.registerSSRObservable(obsQuery);
            if (obsQuery.getCurrentResult().loading) // TODO: This is a legacy API which could probably be cleaned up
            this.renderPromises.addObservableQueryPromise(obsQuery);
        }
        return obsQuery;
    };
    InternalState.prototype.setResult = function(nextResult) {
        var previousResult = this.result;
        if (previousResult && previousResult.data) this.previousData = previousResult.data;
        this.result = nextResult;
        // Calling state.setResult always triggers an update, though some call sites
        // perform additional equality checks before committing to an update.
        this.forceUpdate();
        this.handleErrorOrCompleted(nextResult, previousResult);
    };
    InternalState.prototype.handleErrorOrCompleted = function(result, previousResult) {
        var _this = this;
        if (!result.loading) {
            var error_1 = this.toApolloError(result);
            // wait a tick in case we are in the middle of rendering a component
            Promise.resolve().then(function() {
                if (error_1) _this.onError(error_1);
                else if (result.data && (previousResult === null || previousResult === void 0 ? void 0 : previousResult.networkStatus) !== result.networkStatus && result.networkStatus === (0, $d609460db1ab26e8$export$bd096ddbd246c79c).ready) _this.onCompleted(result.data);
            }).catch(function(error) {
                globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).warn(error);
            });
        }
    };
    InternalState.prototype.toApolloError = function(result) {
        return (0, $93b6d5db950815ab$export$d307f5934e447d0e)(result.errors) ? new (0, $9eab3cada5a2feb5$export$26a337512320b8c6)({
            graphQLErrors: result.errors
        }) : result.error;
    };
    InternalState.prototype.getCurrentResult = function() {
        // Using this.result as a cache ensures getCurrentResult continues returning
        // the same (===) result object, unless state.setResult has been called, or
        // we're doing server rendering and therefore override the result below.
        if (!this.result) this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult());
        return this.result;
    };
    InternalState.prototype.toQueryResult = function(result) {
        var queryResult = this.toQueryResultCache.get(result);
        if (queryResult) return queryResult;
        var data = result.data, partial = result.partial, resultWithoutPartial = (0, $e2e041e4a1657497$export$3c9a16f847548506)(result, [
            "data",
            "partial"
        ]);
        this.toQueryResultCache.set(result, queryResult = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({
            data: data
        }, resultWithoutPartial), this.obsQueryFields), {
            client: this.client,
            observable: this.observable,
            variables: this.observable.variables,
            called: !this.queryHookOptions.skip,
            previousData: this.previousData
        }));
        if (!queryResult.error && (0, $93b6d5db950815ab$export$d307f5934e447d0e)(result.errors)) // Until a set naming convention for networkError and graphQLErrors is
        // decided upon, we map errors (graphQLErrors) to the error options.
        // TODO: Is it possible for both result.error and result.errors to be
        // defined here?
        queryResult.error = new (0, $9eab3cada5a2feb5$export$26a337512320b8c6)({
            graphQLErrors: result.errors
        });
        return queryResult;
    };
    InternalState.prototype.unsafeHandlePartialRefetch = function(result) {
        // WARNING: SIDE-EFFECTS IN THE RENDER FUNCTION
        //
        // TODO: This code should be removed when the partialRefetch option is
        // removed. I was unable to get this hook to behave reasonably in certain
        // edge cases when this block was put in an effect.
        if (result.partial && this.queryHookOptions.partialRefetch && !result.loading && (!result.data || Object.keys(result.data).length === 0) && this.observable.options.fetchPolicy !== "cache-only") {
            Object.assign(result, {
                loading: true,
                networkStatus: (0, $d609460db1ab26e8$export$bd096ddbd246c79c).refetch
            });
            this.observable.refetch();
        }
    };
    return InternalState;
}();



var $2MPlc = parcelRequire("2MPlc");
function $172ff61ce62d7cbc$export$3e2954bd81bb419(id) {
    return !!id && typeof id === "string";
}
function $172ff61ce62d7cbc$export$6064ddd2b05f6d4c(a) {
    return !!a && typeof a === "object" && $172ff61ce62d7cbc$export$3e2954bd81bb419(a.id);
}
var $172ff61ce62d7cbc$export$8436e53e45ffe15b;
(function(UserType) {
    UserType["TELIA"] = "TELIA";
    UserType["CUSTOMER"] = "CUSTOMER";
})($172ff61ce62d7cbc$export$8436e53e45ffe15b || ($172ff61ce62d7cbc$export$8436e53e45ffe15b = {}));
const $172ff61ce62d7cbc$export$47ad037f731ba4b4 = "TELIA_NO";
const $172ff61ce62d7cbc$export$861a3271cad515fc = {
    id: "DK",
    countryCode: "45",
    name: "Denmark"
};
const $172ff61ce62d7cbc$export$3f443bcc5237c742 = {
    id: "EE",
    countryCode: "372",
    name: "Estonia"
};
const $172ff61ce62d7cbc$export$b742dc37108d5cac = {
    id: "FI",
    countryCode: "358",
    name: "Finland"
};
const $172ff61ce62d7cbc$export$7158f0ceb70f54c7 = {
    id: "LT",
    countryCode: "370",
    name: "Lithuania"
};
const $172ff61ce62d7cbc$export$c01351c0af048e39 = {
    id: "NO",
    countryCode: "47",
    name: "Norway"
};
const $172ff61ce62d7cbc$export$88d2e60d4be28663 = {
    id: "SE",
    countryCode: "46",
    name: "Sweden"
};
const $172ff61ce62d7cbc$export$234e4f7526f79ef2 = {
    DK: $172ff61ce62d7cbc$export$861a3271cad515fc,
    EE: $172ff61ce62d7cbc$export$3f443bcc5237c742,
    FI: $172ff61ce62d7cbc$export$b742dc37108d5cac,
    LT: $172ff61ce62d7cbc$export$7158f0ceb70f54c7,
    NO: $172ff61ce62d7cbc$export$c01351c0af048e39,
    SE: $172ff61ce62d7cbc$export$88d2e60d4be28663
};
var $172ff61ce62d7cbc$export$7cdaaadd8ebca335;
(function(UserAccessStatusType) {
    UserAccessStatusType["APPLYING"] = "APPLYING";
    UserAccessStatusType["PENDING"] = "PENDING";
    UserAccessStatusType["GRANTED"] = "GRANTED";
    UserAccessStatusType["REJECTED"] = "REJECTED";
})($172ff61ce62d7cbc$export$7cdaaadd8ebca335 || ($172ff61ce62d7cbc$export$7cdaaadd8ebca335 = {}));
var $172ff61ce62d7cbc$export$129c58e487698430;
(function(OriginatorAddressType) {
    OriginatorAddressType["ALL"] = "ALL";
    OriginatorAddressType["ACCESS_NUMBER_ON_PRODUCT"] = "ACCESS_NUMBER_ON_PRODUCT";
    OriginatorAddressType["ANY_ACCESS_NUMBER"] = "ANY_ACCESS_NUMBER";
    OriginatorAddressType["ANY_ALPHANUMERIC"] = "ANY_ALPHANUMERIC";
    OriginatorAddressType["ANY_NUMBERS"] = "ANY_NUMBERS";
    OriginatorAddressType["ANY_MO_LONG_NUMBER"] = "ANY_MO_LONG_NUMBER";
    OriginatorAddressType["WHITELISTED_SENDER_IDS"] = "WHITELISTED_SENDER_IDS";
})($172ff61ce62d7cbc$export$129c58e487698430 || ($172ff61ce62d7cbc$export$129c58e487698430 = {}));
const $172ff61ce62d7cbc$export$ffe0ab13bb6538c3 = [
    {
        id: "ALL",
        name: "All",
        description: "The SMS sender may be overwritten with anything"
    },
    {
        id: "ACCESS_NUMBER_ON_PRODUCT",
        name: "Access Number on Product",
        description: "The SMS sender may only be the product's short number"
    },
    {
        id: "ANY_ALPHANUMERIC",
        name: "Any Alphanumeric",
        description: "The SMS sender may be overwritten by an alphanumeric text"
    },
    {
        id: "ANY_NUMBERS",
        name: "Any Number",
        description: "The SMS sender may be overwritten by any number"
    },
    {
        id: "WHITELISTED_SENDER_IDS",
        name: "Whitelisted Sender IDs",
        description: "The SMS sender may be overwritten by a whitelisted sender ID that allows this access number as a sender"
    },
    {
        id: "ANY_ACCESS_NUMBER",
        name: "Any Access Number",
        description: "The SMS sender may be overwritten by any provisioned access number"
    },
    {
        id: "ANY_MO_LONG_NUMBER",
        name: "Any MO Long Number",
        description: "The SMS sender may be overwritten by any MO long number"
    }
];
function $172ff61ce62d7cbc$export$971988415fa03ad1(obj) {
    return !!obj?.feeModels;
}
var $172ff61ce62d7cbc$export$a673edc7510eb870;
(function(EndpointProtocol) {
    EndpointProtocol["SOAP"] = "SOAP";
    EndpointProtocol["REST"] = "REST";
    EndpointProtocol["REST_V2"] = "REST_V2";
    EndpointProtocol["SMPP"] = "SMPP";
})($172ff61ce62d7cbc$export$a673edc7510eb870 || ($172ff61ce62d7cbc$export$a673edc7510eb870 = {}));
const $172ff61ce62d7cbc$export$6b92774e83861126 = [
    {
        id: "SOAP",
        name: "SOAP"
    },
    {
        id: "REST",
        name: "REST"
    },
    {
        id: "REST_V2",
        name: "REST v2"
    },
    {
        id: "SMPP",
        name: "SMPP"
    }
];
var $172ff61ce62d7cbc$export$ccffb060fdc5f218;
(function(DefaultCharset) {
    DefaultCharset["GSM8"] = "GSM8";
    DefaultCharset["GSM7"] = "GSM7";
    DefaultCharset["ISO_8859_1"] = "ISO_8859_1";
    DefaultCharset["ISO_8859_15"] = "ISO_8859_15";
})($172ff61ce62d7cbc$export$ccffb060fdc5f218 || ($172ff61ce62d7cbc$export$ccffb060fdc5f218 = {}));
var $172ff61ce62d7cbc$export$3bee95f236788aea;
(function(GroupPeriod) {
    GroupPeriod["DAY"] = "DAY";
    GroupPeriod["WEEK"] = "WEEK";
    GroupPeriod["MONTH"] = "MONTH";
    GroupPeriod["QUARTER"] = "QUARTER";
})($172ff61ce62d7cbc$export$3bee95f236788aea || ($172ff61ce62d7cbc$export$3bee95f236788aea = {}));
const $172ff61ce62d7cbc$export$db3db0d524d9fb83 = "TRANSMITTER";
const $172ff61ce62d7cbc$export$dd3c5a3535ca86a8 = "RECEIVER";
const $172ff61ce62d7cbc$export$bf4896bf79e14963 = "TRANSCEIVER";
function $172ff61ce62d7cbc$export$57069f5b2ecc9128(obj) {
    return !!obj.name;
}
function $172ff61ce62d7cbc$export$b318649ae9e7b3d1(obj) {
    return !!obj.message;
}
var $172ff61ce62d7cbc$export$33b7659dcf229bab;
(function(TrafficFeeType) {
    TrafficFeeType["HOME"] = "HOME";
    TrafficFeeType["DOMESTIC"] = "DOMESTIC";
    TrafficFeeType["FOREIGN"] = "FOREIGN";
})($172ff61ce62d7cbc$export$33b7659dcf229bab || ($172ff61ce62d7cbc$export$33b7659dcf229bab = {}));
var $172ff61ce62d7cbc$export$9f6da38922c64bfe;
(function(ResolutionId) {
    ResolutionId["Delivered"] = "DELIVERED";
    ResolutionId["Expired"] = "EXPIRED";
    ResolutionId["Rejected"] = "REJECTED";
})($172ff61ce62d7cbc$export$9f6da38922c64bfe || ($172ff61ce62d7cbc$export$9f6da38922c64bfe = {}));
const $172ff61ce62d7cbc$export$47ca0f3cafc31c27 = [
    {
        id: "DELIVERED",
        name: "Delivered"
    },
    {
        id: "REJECTED",
        name: "Rejected"
    },
    {
        id: "EXPIRED",
        name: "Expired"
    }
];
var $172ff61ce62d7cbc$export$7605bd3600fc0161;
(function(MfaConfig) {
    MfaConfig["ON"] = "ON";
    MfaConfig["OPTIONAL"] = "OPTIONAL";
    MfaConfig["OFF"] = "OFF";
})($172ff61ce62d7cbc$export$7605bd3600fc0161 || ($172ff61ce62d7cbc$export$7605bd3600fc0161 = {}));



var $fgmOP = parcelRequire("fgmOP");
var $d88123c5e21caba9$exports = {};
$d88123c5e21caba9$exports = "mutation logoutMutation{logoutMutation{user{id}}}";


var $dad67faa2a055d78$exports = {};
$dad67faa2a055d78$exports = "query customer($customerId:ID!){customer(id:$customerId){...customerFragment}}fragment customerFragment on Customer{id countryId brandId company{...companyFragment}users{...userFragment}contracts{...contractFragment products{...productFragment}}contacts{...contactFragment}}fragment userFragment on User{id cognitoId firstName lastName phone email description permissions type userAccessStatusType customerId comment roles rolesMap{resource roles permissions}isSSOUser mfaOptions{sms{enabled phone}app{enabled}}}fragment companyFragment on Company{id countryId brandId name organizationNumber businessAddress{streetAddress postCode city country}billingAddress{streetAddress postCode city country}differentBillingAddress}fragment contractFragment on Contract{...contractNoDatesFragment startDate endDate}fragment contractNoDatesFragment on Contract{id name type invoiceIncludeVat invoiceReference invoiceCustomerEmail invoiceAccountId h2SystemId comment}fragment productFragment on Product{id countryId brandId customerId contractId productType accessNumber accessNumberRange{from to count}rbmAgentOwner startDate endDate inheritsEndDate gracePeriodStartDate establishFee monthlyFee addressingPolicy allowedOriginatingAddresses name comment routingConfigId qosProfile{enabled maxSmsPerSecond messagePriority}features{id featureTypeId startDate endDate featureProperties{accessNumberId}}feeOverrides{feeTypeId amount}}fragment contactFragment on Contact{id name phone email comment channels}";


var $faa9e9ee47efa167$exports = {};
$faa9e9ee47efa167$exports = "query customerOverviews{customerOverviews{...customerOverviewFragment}}fragment customerOverviewFragment on CustomerOverview{id countryId brandId name productOverviews{productTypeId customerId contractId productId productName state accessNumber accessNumberRange{from to count}reservedOas rbmAgentOwner productOverviewType}}";


var $06a51a6eb4e11bab$exports = {};
$06a51a6eb4e11bab$exports = "query user($userId:ID){user(id:$userId){...userFragment}}fragment userFragment on User{id cognitoId firstName lastName phone email description permissions type userAccessStatusType customerId comment roles rolesMap{resource roles permissions}isSSOUser mfaOptions{sms{enabled phone}app{enabled}}}";







var $fgmOP = parcelRequire("fgmOP");
var $e4437228d0353e41$exports = {};
$e4437228d0353e41$exports = "query brands{brands{...brandFragment}}fragment brandFragment on Brand{id countryId organizationNumber currencyCode name}";



const $97a71fda4fbdc6d3$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useBrands", "INFO");
const $97a71fda4fbdc6d3$export$da3999a1d9248c0c = ()=>{
    const { loading: loading, data: { brands: brands } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($e4437228d0353e41$exports)))), {
        fetchPolicy: "cache-first"
    });
    const sortedBrands = (0, $fgmOP.useMemo)(()=>brands?.slice().sort((0, $f5d0c2a7498ff49b$exports.sort).sortByNameComparator), [
        brands
    ]);
    const getBrand = (brandId)=>brands?.find(({ id: id })=>id === brandId);
    const getName = (id)=>getBrand(id)?.name || id;
    const getCountryId = (id)=>getBrand(id)?.countryId;
    const getCurrencyCode = (id)=>getBrand(id)?.currencyCode || "\u20AC$\xa3";
    const getCountryBrands = (countryId)=>brands?.filter((brand)=>brand.countryId === countryId);
    const useBrandsHook = {
        loading: loading,
        brands: sortedBrands,
        getCountryBrands: getCountryBrands,
        getBrand: getBrand,
        getName: getName,
        getCountryId: getCountryId,
        getCurrencyCode: getCurrencyCode
    };
    $97a71fda4fbdc6d3$var$log.debug(useBrandsHook);
    return useBrandsHook;
};




var $2MPlc = parcelRequire("2MPlc");


var $i1fKd = parcelRequire("i1fKd");
function $fd08b8b1bc01022d$var$isKey(token) {
    return !!token.name;
}
const $fd08b8b1bc01022d$var$getParamIndex = (key, dict)=>{
    return dict[key];
};
const $fd08b8b1bc01022d$export$a354029f4b48868 = (pathDef)=>{
    const tokens = (0, $i1fKd.parse)(pathDef);
    const paramIndexDict = tokens.filter($fd08b8b1bc01022d$var$isKey).reduce((paramsMap, { name: name }, index, e)=>{
        return {
            ...paramsMap,
            [`${name}`]: index + 1
        };
    }, {});
    return (paramName, pathValue)=>{
        const pathRegExp = (0, $i1fKd.pathToRegexp)(pathDef);
        const pathMatches = pathRegExp.exec(pathValue);
        const paramIndex = $fd08b8b1bc01022d$var$getParamIndex(paramName, paramIndexDict);
        return pathMatches === null || paramIndex === undefined || pathMatches[paramIndex] === undefined ? null : pathMatches[paramIndex];
    };
};


const $f0766878e6344ba1$export$9438edcc6b9f5c53 = "*";
const $f0766878e6344ba1$export$1b9df9ecacfea58f = "/brands/";
const $f0766878e6344ba1$export$93708f253272c045 = "brandId";
const $f0766878e6344ba1$export$cd6433988d440abd = $f0766878e6344ba1$export$1b9df9ecacfea58f + ":" + $f0766878e6344ba1$export$93708f253272c045;
const $f0766878e6344ba1$export$f6b9cdeb49fe5ab8 = "/customers/";
const $f0766878e6344ba1$export$4b4f0f9b9a289c53 = "customerId";
const $f0766878e6344ba1$export$2fb9bd30205cee01 = $f0766878e6344ba1$export$f6b9cdeb49fe5ab8 + ":" + $f0766878e6344ba1$export$4b4f0f9b9a289c53;
const $f0766878e6344ba1$export$993826779366976 = (resource)=>(0, $fd08b8b1bc01022d$export$a354029f4b48868)($f0766878e6344ba1$export$cd6433988d440abd)($f0766878e6344ba1$export$93708f253272c045, resource);
const $f0766878e6344ba1$export$478fced2f9225abd = (resource)=>(0, $fd08b8b1bc01022d$export$a354029f4b48868)($f0766878e6344ba1$export$2fb9bd30205cee01)($f0766878e6344ba1$export$4b4f0f9b9a289c53, resource);
const $f0766878e6344ba1$export$6cbb68b164ad4ab0 = (rolesMap, brandId, exact = false)=>{
    const groupedPermissions = rolesMap ? rolesMap.filter((map)=>$f0766878e6344ba1$export$993826779366976(map.resource) === brandId || !exact && $f0766878e6344ba1$export$993826779366976(map.resource) === $f0766878e6344ba1$export$9438edcc6b9f5c53).flatMap((filteredMap)=>filteredMap.permissions) : [];
    return groupedPermissions.filter((permission, index)=>groupedPermissions.indexOf(permission) === index);
};
const $f0766878e6344ba1$export$165845d5e7ca2d2 = (rolesMap, customerId, exact = false)=>{
    if (!rolesMap) return [];
    const groupedPermissions = rolesMap.filter(({ resource: resource })=>$f0766878e6344ba1$export$478fced2f9225abd(resource) === customerId).flatMap(({ permissions: permissions })=>permissions);
    return groupedPermissions.filter((permission, index)=>groupedPermissions.indexOf(permission) === index);
};
const $f0766878e6344ba1$export$7eb85035e0831f9 = (user, brandId)=>{
    switch(user?.type){
        case (0, $172ff61ce62d7cbc$export$8436e53e45ffe15b).TELIA:
            return $f0766878e6344ba1$export$6cbb68b164ad4ab0(user.rolesMap, brandId);
        case (0, $172ff61ce62d7cbc$export$8436e53e45ffe15b).CUSTOMER:
            return $f0766878e6344ba1$export$165845d5e7ca2d2(user.rolesMap);
        default:
            return [];
    }
};
const $f0766878e6344ba1$export$3254d322a8fc91ef = (permission, user, brandId)=>$f0766878e6344ba1$export$7eb85035e0831f9(user, brandId).includes(permission);
const $f0766878e6344ba1$export$3d0aaf4e18171e03 = (permission, user, customerId)=>$f0766878e6344ba1$export$165845d5e7ca2d2(user.rolesMap, customerId).includes(permission);
const $f0766878e6344ba1$export$e9754c33bbfb0695 = (prev, updated)=>{
    // If no previous rolesMap is given, all resources in new has been added
    if (!prev) return updated?.map(({ resource: resource })=>resource) || [];
    else if (!updated) return prev.map(({ resource: resource })=>resource) || [];
    // Find entries in rolesMap that has been updated
    const updatedResources = updated.reduce((updatedResources, resourceRoles)=>{
        // Find corresponding resource in previous rolesMap
        const prevResourceRoles = prev?.find(({ resource: resource })=>resource === resourceRoles.resource)?.roles || [];
        // If length of roles lists are not matching or content are not matching, roles list has been changed
        if (prevResourceRoles.length !== resourceRoles.roles.length || resourceRoles.roles.some((role)=>!prevResourceRoles.includes(role))) return [
            ...updatedResources,
            resourceRoles.resource
        ];
        else return updatedResources;
    }, []);
    // Find entries in rolesMap that has been deleted from prev
    const deletedResources = prev.reduce((deletedResources, { resource: resource })=>{
        // If there is no resource in updatedRoles map that matches the one in prev,
        // it has been deleted, include in updated resources list
        if (!updated.some((resourceRoles)=>resource === resourceRoles.resource)) return [
            ...deletedResources,
            resource
        ];
        else return deletedResources;
    }, []);
    return [
        ...updatedResources,
        ...deletedResources
    ];
};



const $d9122fadf72c2a2d$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useResourceRoles", "INFO");
const $d9122fadf72c2a2d$export$7852d8680b86d89b = ()=>{
    const isMatch = (param, extractedParam)=>extractedParam && (extractedParam === param || extractedParam === (0, $2MPlc.RESOURCE_WILDCARD));
    const addBrandRole = (roleId, brandId, rolesMap)=>$d9122fadf72c2a2d$var$_addResourceRole(roleId, (0, $2MPlc.RESOURCE_BRAND_PREFIX) + brandId, rolesMap || []);
    const removeBrandRole = (roleId, brandId, rolesMap)=>$d9122fadf72c2a2d$var$_removeResourceRole(roleId, (0, $2MPlc.RESOURCE_BRAND_PREFIX) + brandId, rolesMap || []);
    const getBrandRoles = (brandId = (0, $2MPlc.RESOURCE_WILDCARD), rolesMap, exact = false)=>rolesMap ? exact ? rolesMap?.find(({ resource: resource })=>brandId === (0, $2MPlc.getBrandId)(resource))?.roles || [] : rolesMap.reduce((prev, { resource: resource, roles: roles })=>isMatch(brandId, (0, $2MPlc.getBrandId)(resource)) ? [
                ...prev,
                ...roles.filter((role)=>!prev.includes(role))
            ] : prev, []) : [];
    const getCustomerRoles = (customerId, rolesMap)=>{
        return rolesMap?.find(({ resource: resource })=>customerId === (0, $f0766878e6344ba1$export$478fced2f9225abd)(resource))?.roles || [];
    };
    const addCustomerRole = (roleId, customerId, rolesMap)=>$d9122fadf72c2a2d$var$_addResourceRole(roleId, (0, $2MPlc.RESOURCE_CUSTOMER_PREFIX) + customerId, rolesMap || []);
    const removeCustomerRole = (roleId, customerId, rolesMap)=>$d9122fadf72c2a2d$var$_removeResourceRole(roleId, (0, $2MPlc.RESOURCE_CUSTOMER_PREFIX) + customerId, rolesMap || [], true);
    const getCustomerIds = (rolesMap)=>{
        if (!rolesMap) return [];
        const customerIds = rolesMap.filter(({ resource: resource })=>resource.startsWith((0, $2MPlc.RESOURCE_CUSTOMER_PREFIX))).map(({ resource: resource })=>(0, $f0766878e6344ba1$export$478fced2f9225abd)(resource)).filter((id)=>id !== null);
        return customerIds;
    };
    const useResourceRoles = {
        getBrandRoles: getBrandRoles,
        addBrandRole: addBrandRole,
        removeBrandRole: removeBrandRole,
        getCustomerRoles: getCustomerRoles,
        addCustomerRole: addCustomerRole,
        removeCustomerRole: removeCustomerRole,
        getCustomerIds: getCustomerIds
    };
    return useResourceRoles;
};
const $d9122fadf72c2a2d$var$_addResourceRole = (roleId, resource, rolesMap)=>{
    let updatedRolesMap = rolesMap.slice();
    //Look for existing resourceRoles object to add role to
    const resourceRoles = rolesMap.find((map)=>map.resource === resource);
    if (resourceRoles) //Only append role if it is not in list
    {
        if (!resourceRoles.roles.includes(roleId)) {
            updatedRolesMap.remove(resourceRoles);
            updatedRolesMap.push({
                ...resourceRoles,
                roles: [
                    ...resourceRoles.roles,
                    roleId
                ]
            });
        }
    } else updatedRolesMap.push({
        resource: resource,
        roles: [
            roleId
        ]
    });
    return updatedRolesMap;
};
const $d9122fadf72c2a2d$var$_removeResourceRole = (roleId, resource, rolesMap, keepEmptyList // If true will keep resource with empty roles list, otherwise resource will be removed if the role removal results in an empty list
)=>{
    let updatedRolesMap = rolesMap.slice();
    const resourceRoles = rolesMap.find((map)=>map.resource === resource);
    if (resourceRoles) {
        const updatedResourceRoles = {
            ...resourceRoles,
            roles: resourceRoles.roles.slice().remove(roleId)
        };
        updatedRolesMap.remove(resourceRoles);
        if (!updatedResourceRoles.roles.isEmpty() || keepEmptyList) updatedRolesMap.push(updatedResourceRoles);
    }
    return updatedRolesMap;
};




var $fgmOP = parcelRequire("fgmOP");
var $23365fac7669bab3$exports = {};
$23365fac7669bab3$exports = "query roles($userType:UserTypeEnum){roles(userType:$userType){...roleFragment}}fragment roleFragment on Role{id userType name description permissions}";



const $3b1b6b64a4bd4f9b$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useRoles", "INFO");
const $3b1b6b64a4bd4f9b$export$a884b22cb22f8e99 = ()=>{
    const _nameCompare = (a, b)=>a.name.localeCompare(b.name);
    const { loading: loading, data: data } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($23365fac7669bab3$exports)))), {
        fetchPolicy: "cache-first"
    });
    const useRolesHook = (0, $fgmOP.useMemo)(()=>{
        const roles = (data?.roles.slice() || []).sort(_nameCompare);
        return {
            loading: loading,
            roles: roles,
            teliaRoles: roles.filter(({ userType: userType })=>userType === "TELIA"),
            customerRoles: roles.filter(({ userType: userType })=>userType === "CUSTOMER"),
            getRole: (roleId)=>roles.find(({ id: id })=>id === roleId)
        };
    }, [
        data,
        loading
    ]);
    $3b1b6b64a4bd4f9b$var$log.debug("render", useRolesHook);
    return useRolesHook;
};


const $4ef4d658949bf0e9$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useUser", "INFO");
const $4ef4d658949bf0e9$export$23bbbc4533528f03 = ()=>{
    const userContext = (0, $fgmOP.useContext)($4ef4d658949bf0e9$var$UserContext);
    return userContext;
};
const $4ef4d658949bf0e9$var$UserContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createContext(undefined);
const $4ef4d658949bf0e9$var$userQueryGql = (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($06a51a6eb4e11bab$exports))));
const $4ef4d658949bf0e9$export$88f24fd8fcfab6ca = (props)=>{
    const { loading: loadingRoles } = (0, $3b1b6b64a4bd4f9b$export$a884b22cb22f8e99)();
    const { data: { user: realUser } = {}, loading: loadingUser, refetch: refetch, error: error } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)($4ef4d658949bf0e9$var$userQueryGql, {
        fetchPolicy: "no-cache",
        onCompleted: (data)=>{
            $4ef4d658949bf0e9$var$log.debug("UserProvider userQuery resolved", data);
            (0, $f6a2cb476a1b1720$export$5ceec5c8be62fa1b)(data.user);
        }
    });
    const [logout] = (0, $1f0b8701b604e718$export$609860bf8b0084c)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($d88123c5e21caba9$exports)))), {
        onCompleted: ()=>{
            localStorage.removeItem("x-token");
            window.location.href = "/logout";
        },
        onError: (err)=>{
            $4ef4d658949bf0e9$var$log.error("logout mutation rejected", err);
        }
    });
    const [impersonatedUser, setImpersonatedUser] = (0, $fgmOP.useState)();
    const isImpersonating = !!impersonatedUser;
    const user = isImpersonating ? impersonatedUser : realUser;
    const isCustomer = ()=>!!user && user.type === "CUSTOMER";
    const isTelia = ()=>!!user && user.type === "TELIA";
    const { setPreference: setPreference, getPreference: getPreference } = (0, $7059d4d5f1933e7a$export$bbd7d970555e2952)([
        "brandId",
        "customerId"
    ]);
    const userCustomerIds = (0, $fgmOP.useMemo)(()=>{
        if (!isCustomer()) return undefined;
        const customerIds = user?.rolesMap.map(({ resource: resource })=>(0, $2MPlc.getCustomerId)(resource)).filter((id)=>id !== undefined);
        if (customerIds && customerIds.length === 1 || !getPreference("customerId")) setPreference("customerId", customerIds[0]);
        return customerIds;
    }, [
        user
    ]);
    const customerId = getPreference("customerId");
    const { data: { customer: customer } = {}, loading: loadingCustomer } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($dad67faa2a055d78$exports)))), {
        variables: {
            customerId: customerId
        },
        skip: !isCustomer()
    });
    const { loading: loadingBrands, brands: brands, getBrand: getBrand } = (0, $97a71fda4fbdc6d3$export$da3999a1d9248c0c)();
    const { getBrandRoles: getBrandRoles, getCustomerRoles: getCustomerRoles } = (0, $d9122fadf72c2a2d$export$7852d8680b86d89b)();
    const userBrands = (0, $fgmOP.useMemo)(()=>{
        const userBrands = isTelia() ? brands?.filter(({ id: brandId })=>!user || !getBrandRoles(brandId, user.rolesMap).isEmpty()) : isCustomer() && customer && getBrand(customer.brandId) ? [
            getBrand(customer.brandId)
        ] : [];
        $4ef4d658949bf0e9$var$log.debug("useMemo", {
            userBrands: userBrands,
            brands: brands,
            user: user,
            customer: customer
        });
        if (userBrands?.length === 1) setPreference("brandId", userBrands[0].id);
        return userBrands;
    }, [
        user,
        customer,
        brands
    ]);
    const currentUserBrand = userBrands?.find((b)=>b.id === getPreference("brandId"));
    const { loading: loadingCustomerOverviews, data: { customerOverviews: customerOverviews } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($faa9e9ee47efa167$exports)))), {
        skip: !currentUserBrand
    });
    const getCustomerOverview = (customerId)=>customerOverviews && customerOverviews.find(({ id: id })=>id === customerId);
    const currentBrandRoles = (0, $fgmOP.useMemo)(()=>user ? user.type === (0, $172ff61ce62d7cbc$export$8436e53e45ffe15b).CUSTOMER ? getCustomerRoles(customerId, user.rolesMap) : getBrandRoles(currentUserBrand?.id, user.rolesMap) : [], [
        user,
        currentUserBrand
    ]);
    const currentBrandRealUserRoles = (0, $fgmOP.useMemo)(()=>realUser ? realUser.type === (0, $172ff61ce62d7cbc$export$8436e53e45ffe15b).CUSTOMER ? getCustomerRoles(customerId, realUser.rolesMap) : getBrandRoles(currentUserBrand?.id, realUser.rolesMap) : [], [
        realUser,
        currentUserBrand
    ]);
    const hasPermission = (permissionId, permissionUser = user, brandId = currentUserBrand?.id)=>{
        if (!permissionUser) return false;
        return permissionUser.type === (0, $172ff61ce62d7cbc$export$8436e53e45ffe15b).TELIA ? (0, $2MPlc.hasUserBrandPermission)(permissionId, permissionUser, brandId) : (0, $2MPlc.hasUserCustomerPermission)(permissionId, permissionUser, customerId);
    };
    const hasRealUserPermission = (permissionId)=>hasPermission(permissionId, realUser);
    const hasAnyPermission = (...permissionIds)=>permissionIds.some((permissionId)=>hasPermission(permissionId));
    const hasBrandPermission = (permissionId, brandId)=>hasPermission(permissionId, user, brandId);
    const hasCustomerPermission = (permissionId, customerId)=>{
        if (!user) return false;
        if (isCustomer()) return (0, $2MPlc.hasUserCustomerPermission)(permissionId, user, customerId);
        // For Telia users, we need to check if we have permission to manage the brand of the customer
        const { brandId: brandId } = getCustomerOverview(customerId) || {};
        return !!(brandId && hasBrandPermission(permissionId, brandId));
    };
    const userContext = {
        user: user,
        loadingUser: loadingUser || loadingRoles || loadingBrands || loadingCustomer || loadingCustomerOverviews,
        userError: error,
        hasPermission: hasPermission,
        hasAnyPermission: hasAnyPermission,
        hasBrandPermission: hasBrandPermission,
        hasCustomerPermission: hasCustomerPermission,
        isCustomer: isCustomer,
        isTelia: isTelia,
        logout: logout,
        realUser: realUser,
        hasRealUserPermission: hasRealUserPermission,
        isImpersonating: isImpersonating,
        setImpersonatedUser: setImpersonatedUser,
        customerId: customerId,
        customer: customer,
        userCustomerIds: userCustomerIds,
        userBrands: userBrands,
        currentUserBrand: currentUserBrand,
        currentBrandRoles: currentBrandRoles,
        currentBrandRealUserRoles: currentBrandRealUserRoles,
        refetch: refetch
    };
    $4ef4d658949bf0e9$var$log.debug("UserProvider", userContext);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($4ef4d658949bf0e9$var$UserContext.Provider, {
        value: userContext,
        children: props.children
    });
};



const $ca0941499cca84bb$export$457c4eb8edaa023d = "CUSTOMER_COMPANY_MANAGE";
const $ca0941499cca84bb$export$9687129cd10e92bc = "CUSTOMER_USERS_MANAGE";
const $ca0941499cca84bb$export$d6141afe674cb67b = "CUSTOMER_CONTRACTS_MANAGE";
const $ca0941499cca84bb$export$3dd817f0ec35d602 = "CUSTOMER_PRODUCTS_MANAGE";
const $ca0941499cca84bb$export$2c134167e4d6a0ca = "CUSTOMER_TECHNICAL_MANAGE";
const $ca0941499cca84bb$export$9745fea74799dd7b = "CUSTOMER_SETTLEMENTS_READ";
const $ca0941499cca84bb$export$4576703433079908 = "CUSTOMER_STATISTICS_REPORT";
const $ca0941499cca84bb$export$5d3c7c2c3a35af76 = "CUSTOMER_DOCUMENTS_READ";
const $ca0941499cca84bb$export$167b208d1ae7a371 = "CUSTOMER_DOCUMENTS_MANAGE";
const $ca0941499cca84bb$export$68386f5280c68bd1 = "CUSTOMER_RESERVED_OA_MANAGE";
const $ca0941499cca84bb$export$b352d5cce6351906 = "PERMISSIONS_MANAGE";
const $ca0941499cca84bb$export$3bccc9c7f40c5944 = "ROLES_ASSUME";
const $ca0941499cca84bb$export$7a72678803583a64 = "ROLES_MANAGE";
const $ca0941499cca84bb$export$619b28da925d56b7 = "TELIA_USERS_MANAGE";
const $ca0941499cca84bb$export$d9a19ca7f33b36c1 = "ALL_CUSTOMERS_MANAGE";
const $ca0941499cca84bb$export$5baf0ad38a5e4791 = "ALL_CUSTOMERS_READ";
const $ca0941499cca84bb$export$2217feab9eac9873 = "MESSAGE_CHANNELS_MANAGE";
const $ca0941499cca84bb$export$c7086708a0f042bc = "SMPP_CONNECTIONS_READ";
const $ca0941499cca84bb$export$ebd186ac99b8cefb = "CHANGELOGS_MANAGE";
const $ca0941499cca84bb$export$230c8d0b320c75d5 = "SETTLEMENTS_ADJUST";
const $ca0941499cca84bb$export$5391912c22b803f7 = "SETTLEMENTS_APPROVE";
const $ca0941499cca84bb$export$25aa7820472518b2 = "MANAGE_MESSAGE_STATUS";
const $ca0941499cca84bb$export$b70455accb535b43 = "RESERVED_OA_MANAGE";
const $ca0941499cca84bb$export$69e1ef3f3bd133aa = "PRODUCT_FEATURES_MANAGE";



parcelRequire("fgmOP");
var $1a525afc32e731fd$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = "";
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") return arg;
        if (typeof arg !== "object") return "";
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) return arg.toString();
        var classes = "";
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + " " + newClass;
        return value + newClass;
    }
    if (0, $1a525afc32e731fd$exports) {
        classNames.default = classNames;
        $1a525afc32e731fd$exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();


const $98cbb91c03e56cc2$export$312428d8e7d71751 = (props)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("ul", {
        id: props.id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("list list--links list--links--block", props.className),
        children: props.children
    });
var $98cbb91c03e56cc2$export$2e2bcd8739ae039 = $98cbb91c03e56cc2$export$312428d8e7d71751;



parcelRequire("fgmOP");


const $c3440150448da8b8$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useLoading", "INFO");
let $c3440150448da8b8$var$loadingQueries = [];
const $c3440150448da8b8$var$addLoadingQuery = (query)=>{
    $c3440150448da8b8$var$loadingQueries.push(query);
};
const $c3440150448da8b8$var$removeLoadingQuery = (query)=>{
    $c3440150448da8b8$var$loadingQueries.splice($c3440150448da8b8$var$loadingQueries.indexOf(query), 1);
};
const $c3440150448da8b8$var$reset = ()=>{
    $c3440150448da8b8$var$loadingQueries = [];
};
const $c3440150448da8b8$export$1c72fe480f599e97 = (queryStates)=>{
    queryStates?.forEach(({ query: query, isLoading: isLoading })=>{
        isLoading ? $c3440150448da8b8$var$addLoadingQuery(query) : $c3440150448da8b8$var$removeLoadingQuery(query);
    });
    return {
        isLoading: Object.keys($c3440150448da8b8$var$loadingQueries).length > 0,
        reset: $c3440150448da8b8$var$reset
    };
};



parcelRequire("fgmOP");
const $d7d83d70b2cd6f85$var$Loading = (props)=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: "spinner spinner--lg",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "spinner__blade spinner__blade--0"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "spinner__blade spinner__blade--1"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "spinner__blade spinner__blade--2"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "spinner__blade spinner__blade--3"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "spinner__blade spinner__blade--4"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "spinner__blade spinner__blade--5"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "spinner__blade spinner__blade--6"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "spinner__blade spinner__blade--7"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "spinner__blade spinner__blade--8"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "spinner__blade spinner__blade--9"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "spinner__blade spinner__blade--10"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "spinner__blade spinner__blade--11"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "spinner__blade spinner__blade--12"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "spinner__blade spinner__blade--13"
            })
        ]
    });
};
var $d7d83d70b2cd6f85$export$2e2bcd8739ae039 = $d7d83d70b2cd6f85$var$Loading;


const $02b201edbdb8a3c4$var$PageTitleFc = (props)=>{
    const { isLoading: isLoading, reset: reset } = (0, $c3440150448da8b8$export$1c72fe480f599e97)();
    reset();
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("h1", {
        className: "heading heading--level-1 page-title__title",
        children: [
            props.title || props.children,
            props.showLoading && isLoading && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "page-title__spinner",
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $02b201edbdb8a3c4$export$2e2bcd8739ae039 = $02b201edbdb8a3c4$var$PageTitleFc;





var $fgmOP = parcelRequire("fgmOP");


var $fgmOP = parcelRequire("fgmOP");

//
// WARNING
//
// Do not make manual changes to this file.
// This file was generated by scripts/generate-icons.js.
//
//

var $fgmOP = parcelRequire("fgmOP");
var $ed97cf8fbd7b8a05$export$d824b604106683ab = [
    "GIF",
    "abroad",
    "activity-level",
    "add-circle",
    "add",
    "address-book",
    "ai-robot",
    "airplay",
    "alarm-off",
    "alarm",
    "alert-filled",
    "alert",
    "arrow-down",
    "arrow-large-down",
    "arrow-large-left",
    "arrow-large-right",
    "arrow-large-up",
    "arrow-left",
    "arrow-right",
    "arrow-small-down",
    "arrow-small-left",
    "arrow-small-right",
    "arrow-small-up",
    "arrow-subdirectory",
    "arrow-up",
    "attach",
    "attachment",
    "b2b-customer",
    "bag",
    "bar-chart",
    "basketball",
    "battery",
    "best-in-test",
    "blood-pressure",
    "bluetooth",
    "bookmark",
    "broadband",
    "broken-phone",
    "bulb",
    "business-continuity",
    "business-intelligence",
    "business",
    "calendar",
    "camera",
    "card-view",
    "care",
    "cart",
    "cast",
    "chat-robot",
    "chat",
    "check-circle-filled",
    "check-circle",
    "check-mark-circle",
    "check-mark",
    "chevron-down",
    "chevron-left",
    "chevron-right",
    "chevron-up",
    "child-boy",
    "child-girl",
    "child2",
    "close-circle",
    "close",
    "cloud-connect",
    "cloud",
    "coffee",
    "company",
    "compass",
    "connected-building",
    "connected",
    "construction",
    "contact",
    "conversation",
    "copy",
    "core-router",
    "credit-card",
    "customer-dialogue",
    "daas-device",
    "data-transfer",
    "delete-filled",
    "delete",
    "delivery",
    "desktop",
    "devices",
    "dislike",
    "doc",
    "document-doc",
    "document-edit",
    "document-pdf",
    "document-ppt",
    "document-xls",
    "document",
    "download",
    "drone",
    "dsl-hub",
    "edit",
    "education",
    "efficiency",
    "email",
    "end-user",
    "entertainment",
    "environment",
    "error-filled",
    "error",
    "esim-simcard",
    "esim",
    "euro",
    "excel",
    "external",
    "face-id",
    "facebook",
    "facemask",
    "fiber",
    "film",
    "filter",
    "fingerprint",
    "five-g",
    "flag",
    "focus",
    "folder-copy",
    "folder-new",
    "folder",
    "food",
    "fraud",
    "games",
    "getting-started",
    "gift",
    "graph",
    "grid-view",
    "group",
    "handshake",
    "headphones",
    "heart-filled",
    "heart",
    "help",
    "home-care",
    "home-installation",
    "home",
    "hospital",
    "image",
    "industrial-iot",
    "industry",
    "infinite",
    "info-filled",
    "info",
    "instagram",
    "insurance",
    "internet",
    "invoice",
    "job-search",
    "key",
    "kontantkort",
    "laptop",
    "late-payment",
    "layers",
    "letter",
    "lightbulb",
    "like-fin",
    "like",
    "link",
    "linkedin",
    "list-view",
    "lock-locked",
    "lock-open",
    "lock-unlocked",
    "lock",
    "login",
    "logout",
    "map",
    "measuring-health",
    "media-content",
    "megaphone",
    "menu",
    "microphone",
    "minus",
    "mms",
    "mobile-broadband",
    "mobile",
    "moisture",
    "money-back",
    "money-euro",
    "money-krone",
    "money",
    "more-horizontal",
    "more-low",
    "more-vertical",
    "more",
    "music",
    "mute",
    "network",
    "new-contact",
    "new-group",
    "news",
    "offering",
    "offshore",
    "open",
    "optimization",
    "org-chart",
    "parental-guide",
    "password-invisible",
    "password-visible",
    "pay-monthly",
    "pay-once",
    "payment-success",
    "payment",
    "pebble",
    "people-hub",
    "people",
    "pet-dog",
    "phone-recycling",
    "phone-ringing",
    "phone",
    "pie-chart",
    "pin",
    "place",
    "plane",
    "play",
    "player-settings",
    "plus-minus",
    "plus",
    "police",
    "portal",
    "position",
    "power-grid",
    "premises-datacenter",
    "premises-large",
    "premises-medium",
    "premises-small",
    "premises",
    "present",
    "press-button",
    "price",
    "print",
    "product-bankid-mobile",
    "product-bedrift-click",
    "product-bedriftsnett",
    "product-data-boost",
    "product-data-rollover",
    "product-data-sharing",
    "product-extra-datasim",
    "product-ladeavtale",
    "product-mobilpant",
    "product-music-freedom",
    "product-roam-like-home",
    "product-skjermforsikring",
    "product-svitsj",
    "product-telia-startup",
    "pulse",
    "question-circle",
    "question-filled",
    "question",
    "rack",
    "radio",
    "record",
    "recycle",
    "refill-card",
    "refill",
    "refresh",
    "register",
    "remote-control",
    "repair",
    "replace",
    "report",
    "reservation",
    "return-arrow",
    "reverse",
    "roaming",
    "robot",
    "route",
    "router",
    "ruler",
    "satellite",
    "save",
    "savings",
    "search",
    "secure-device",
    "secured2",
    "security-camera",
    "security",
    "send",
    "sense-car",
    "server",
    "service-device",
    "service-supervision",
    "services",
    "settings",
    "share",
    "shopping",
    "shoppingcart",
    "shuffle",
    "signal",
    "signature",
    "sim-card",
    "skip-back10sec",
    "skip-back30sec",
    "skip-forward10sec",
    "skip-forward30sec",
    "slow-wifi",
    "smart-wifi",
    "smartphone",
    "smartwatch",
    "smiley-happy",
    "smiley-sad",
    "sms",
    "snapchat",
    "snowflake",
    "sorter",
    "speedometer-dots",
    "speedometer-max",
    "speedometer-normal",
    "speedometer-rask",
    "speedometer",
    "spell-check",
    "split",
    "spyware",
    "star-filled",
    "star",
    "statistics",
    "stop",
    "store",
    "stream",
    "suitcase",
    "summary",
    "support",
    "sustainability",
    "switch",
    "sync",
    "table-view",
    "tablet",
    "tag",
    "tags",
    "temperature",
    "thinking",
    "time-waiting",
    "time",
    "trade-phone",
    "trailer",
    "train",
    "transfer",
    "trash",
    "tv-next",
    "tv-pause",
    "tv-play",
    "tv-previous",
    "tv-simple",
    "tv-stop",
    "tv",
    "twitter",
    "undo",
    "upload",
    "usb",
    "user-admin",
    "user-new",
    "user",
    "vcard",
    "video-conference",
    "video",
    "visibility-filled",
    "visibility",
    "voice-switch",
    "voicemail",
    "volume",
    "wallet",
    "wallplug",
    "warning",
    "wavelength",
    "weather",
    "whatsapp",
    "wireless-off",
    "wireless",
    "world-alert",
    "world-off",
    "world-question",
    "world",
    "wrench",
    "youtube",
    "zoom-out",
    "zoom"
];
var $ed97cf8fbd7b8a05$export$747068d7030dba8a = {
    GIF: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M25.322 34.768h-1.568c-.467 0-.924-.336-1.372-1.008a2.448 2.448 0 01-.447-1.064 1.484 1.484 0 01.825-1.162 3.21 3.21 0 011.806-.546h3.5c.691 0 1.037.317 1.037.952v4.9a4.213 4.213 0 01-1.876 3.7 8.875 8.875 0 01-2.577 1.218c-.974.29-1.984.436-3 .434a9.182 9.182 0 01-5.011-1.415 9.7 9.7 0 01-3.458-3.695 10.323 10.323 0 01-1.219-4.942 10.007 10.007 0 011.471-5.32 10.467 10.467 0 013.821-3.738 10.082 10.082 0 015.04-1.33 9.665 9.665 0 015.24 1.448.9.9 0 01.42.84c0 .463-.095.92-.28 1.344A3.125 3.125 0 0127 26.41c-.202.224-.483.36-.784.378a1.557 1.557 0 01-.672-.2c-.547-.276-1.12-.5-1.708-.672a6.04 6.04 0 00-1.567-.2 6.13 6.13 0 00-4.508 1.75A6.022 6.022 0 0016 31.94a6.75 6.75 0 00.8 3.318 5.7 5.7 0 002.142 2.225c.919.53 1.964.8 3.024.785a6.5 6.5 0 003.36-.869l-.004-2.631zm6.72-10.948a1.573 1.573 0 01.882-1.246A3.455 3.455 0 0134.842 22c.728 0 1.092.336 1.092 1.008v15.876a3.777 3.777 0 01-.616 2.1 1.69 1.69 0 01-1.343.953c-.487 0-.972-.364-1.457-1.092a2.495 2.495 0 01-.476-1.148V23.82zm11.592 9.995v5.069a3.777 3.777 0 01-.616 2.1 1.69 1.69 0 01-1.344.953c-.486 0-.971-.364-1.456-1.092a2.495 2.495 0 01-.476-1.148V23.988a1.573 1.573 0 01.882-1.246 3.455 3.455 0 011.918-.574h9.044c.69 0 1.035.327 1.036.98 0 .5-.1.995-.294 1.456-.16.414-.408.789-.728 1.096a1.29 1.29 0 01-.854.392h-7.112v4.088h6.188c.653 0 .98.308.98.924a3.367 3.367 0 01-.546 1.876 1.509 1.509 0 01-1.218.839l-5.404-.004zM4 20a2 2 0 01-2-2v-4a8.009 8.009 0 018-8h4a2 2 0 010 4h-4a4 4 0 00-4 4v4a2 2 0 01-2 2zm56 0a2 2 0 01-2-2v-4a4 4 0 00-4-4h-4a2 2 0 010-4h4a8.009 8.009 0 018 8v4a2 2 0 01-2 2zm-6 38h-4a2 2 0 010-4h4a4 4 0 004-4v-4a2 2 0 014 0v4a8.009 8.009 0 01-8 8zm-40 0h-4a8.009 8.009 0 01-8-8v-4a2 2 0 014 0v4a4 4 0 004 4h4a2 2 0 010 4z"
    })),
    abroad: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M57.48 30.94L50 26.19A14 14 0 0042.51 24h-1.68L30 13.07l-.14-.07a4 4 0 00-2.6-1h-2.9a4 4 0 00-3.94 4.66L21.64 24H17l-4.8-6.4A4 4 0 009 16H8a4 4 0 00-4 4v11.53a6 6 0 003.32 5.36L12 39.26a26.15 26.15 0 005.71 2.05l-3.12 4.37a4 4 0 003.3 6.32h5.42a4.002 4.002 0 002.46-.84L37.54 42h16.72a6 6 0 003.22-11.06zM24.36 16h2.89l8 8h-9.56l-1.33-8zm-1.05 32h-5.42L25 38h11.16H36v.13L23.31 48zm32.87-11.44A1.91 1.91 0 0154.26 38H40.17a4 4 0 00-4-4H25a4 4 0 00-3.26 1.68l-1.46 2a22.16 22.16 0 01-6.48-2l-4.69-2.36A2 2 0 018 31.53V20h1l4.8 6.4A4 4 0 0017 28h25.51a10 10 0 015.36 1.56l7.47 4.75a1.94 1.94 0 01.84 2.25z"
    })),
    "activity-level": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M32 6a26 26 0 1026 26A26.029 26.029 0 0032 6zm0 48a22 22 0 1122-22 22.025 22.025 0 01-22 22zm16-22a2 2 0 01-4 0 11.974 11.974 0 00-.497-3.429 2.001 2.001 0 013.834-1.142c.44 1.484.664 3.023.663 4.571zm-10.586-2.586l8-8a2 2 0 00-2.828-2.828l-.781.781A15.99 15.99 0 0016 32a2 2 0 004 0 11.986 11.986 0 0118.945-9.773l-4.36 4.359-.004.006a6.023 6.023 0 102.827 2.827l.006-.005zM32 34a2 2 0 110-4 2 2 0 010 4z"
    })),
    "add-circle": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 6a26 26 0 0126 26c0 14.36-11.64 26-26 26S6 46.36 6 32 17.64 6 32 6zm0 4c-12.15 0-22 9.85-22 22s9.85 22 22 22 22-9.85 22-22-9.85-22-22-22zm0 10a2 2 0 012 2v8h8a2 2 0 110 4h-8v8a2 2 0 11-4 0v-8h-8a2 2 0 110-4h8v-8a2 2 0 012-2z"
    })),
    add: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M32 6a26 26 0 1026 26A26.029 26.029 0 0032 6zm0 48a22 22 0 1122-22 22.025 22.025 0 01-22 22zm14-22a2 2 0 01-2 2H34v10a2 2 0 01-4 0V34H20a2 2 0 010-4h10V20a2 2 0 014 0v10h10a2 2 0 012 2z"
    })),
    "address-book": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M26.355 25.972a7.7 7.7 0 1114.759 3.08c.75.351 1.465.813 2.097 1.356C44.73 31.713 46 33.697 46 36.183v.602A5.215 5.215 0 0140.785 42h-13.57A5.215 5.215 0 0122 36.785v-.602c0-2.515 1.338-4.498 2.858-5.785a9.574 9.574 0 012.13-1.362 7.673 7.673 0 01-.633-3.064zm7.7-3.7a3.7 3.7 0 100 7.4 3.7 3.7 0 000-7.4zM40.785 38c.67 0 1.215-.544 1.215-1.215v-.602c0-1.038-.524-1.991-1.397-2.742-.752-.646-1.598-.998-2.22-1.1a7.664 7.664 0 01-4.328 1.331 7.664 7.664 0 01-4.343-1.34c-.573.086-1.46.434-2.27 1.12-.909.769-1.442 1.722-1.442 2.73v.602c0 .672.544 1.216 1.215 1.216h13.57z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M13 8a4 4 0 014-4h29a8 8 0 018 8v40a8 8 0 01-8 8H17a4 4 0 01-4-4v-7h-1a2 2 0 110-4h1v-6h-1a2 2 0 110-4h1v-6h-1a2 2 0 110-4h1v-6h-1a2 2 0 110-4h1V8zm4 41h1a2 2 0 100-4h-1v-6h1a2 2 0 100-4h-1v-6h1a2 2 0 100-4h-1v-6h1a2 2 0 100-4h-1V8h29a4 4 0 014 4v40a4 4 0 01-4 4H17v-7z",
        clipRule: "evenodd"
    })),
    "ai-robot": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M54.76 30.973v-6.22a8.303 8.303 0 00-8.293-8.293h-2.073v-4.722a4.147 4.147 0 10-4.147 0v4.722H23.66v-4.722a4.147 4.147 0 10-4.147 0v4.722H17.44a8.303 8.303 0 00-8.293 8.293v6.22a4.147 4.147 0 000 8.294v12.44A8.303 8.303 0 0017.44 60h29.027a8.303 8.303 0 008.293-8.293v-12.44a4.147 4.147 0 100-8.294zm-4.146 20.733a4.151 4.151 0 01-4.147 4.147H17.44a4.151 4.151 0 01-4.147-4.147V24.753a4.151 4.151 0 014.147-4.147h29.027a4.151 4.151 0 014.147 4.147v26.953zM29.88 33.046a6.22 6.22 0 10-6.22 6.22 6.227 6.227 0 006.22-6.22zm-8.293 0a2.073 2.073 0 114.147 0 2.073 2.073 0 01-4.147 0zm18.66-6.22a6.22 6.22 0 106.22 6.22 6.227 6.227 0 00-6.22-6.22zm0 8.294a2.073 2.073 0 110-4.147 2.073 2.073 0 010 4.147zm3.787 9.2c.645.946.4 2.236-.546 2.88-2.304 1.57-6.4 2.433-11.534 2.433s-9.23-.863-11.534-2.432a2.074 2.074 0 012.334-3.428c.59.402 2.998 1.714 9.2 1.714 6.201 0 8.609-1.312 9.2-1.714a2.076 2.076 0 012.88.546z",
        clipRule: "evenodd"
    })),
    airplay: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M60 20v24a8.01 8.01 0 01-8 8h-4a2 2 0 010-4h4a4.005 4.005 0 004-4V20a4.005 4.005 0 00-4-4H12a4.004 4.004 0 00-4 4v24a4.004 4.004 0 004 4h4a2 2 0 010 4h-4a8.01 8.01 0 01-8-8V20a8.01 8.01 0 018-8h40a8.01 8.01 0 018 8zM41.784 49.88A4 4 0 0138.392 56H25.608a4 4 0 01-3.392-6.12l6.391-10.226a4 4 0 016.786 0l6.391 10.227zM38.392 52L32 41.773 25.608 52h12.784z"
    })),
    "alarm-off": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M47.1 39.449l6.257 5.24c-2.628-5.26-3.608-10.35-3.568-17.88 0-6.941-5.547-12.491-11.994-15.062a6.002 6.002 0 00-2.242-6.623 5.994 5.994 0 00-6.99 0 6.002 6.002 0 00-2.241 6.624 22.367 22.367 0 00-6.997 4.37l3.009 2.59a19.595 19.595 0 016.436-3.62 18.06 18.06 0 011.8-.52 38.732 38.732 0 01-.59-4 3.421 3.421 0 010-.41 1.552 1.552 0 010-.2 2 2 0 113.997 0c.005.066.005.133 0 .2.009.136.009.273 0 .41a38.732 38.732 0 01-.59 4c.61.142 1.21.316 1.8.52 5.167 1.72 10.564 5.97 10.564 11.72a49.288 49.288 0 001.35 12.641zM11.189 52h38.37l-4.768-4H13.468c3.508-6.38 4.787-12.201 4.787-21.142 0-.357.02-.714.06-1.07l-3.438-2.88a13.01 13.01 0 00-.62 3.95c0 9.07-1.42 14.601-5.417 21.142a2.591 2.591 0 000 2.62A2.678 2.678 0 0011.189 52zm20.828 8a22.07 22.07 0 01-10.215-2.51 2 2 0 011.86-3.49 18.072 18.072 0 008.355 2 17.833 17.833 0 008.356-2 1.998 1.998 0 012.968 1.843 2 2 0 01-1.11 1.696A22.068 22.068 0 0132.018 60zm27.367-4.73l.15-.17a2 2 0 00-.24-2.81l-3.768-3.16L48.239 43 20.944 20.127l-2.999-2.56-10.624-8.92a2.026 2.026 0 00-2.854.265 2.028 2.028 0 00.265 2.855l14.183 11.87L52.667 52l4.048 3.35c.78.659 1.93.624 2.669-.08z"
    })),
    alarm: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M54.72 47.988c-4.004-6.546-5.425-12.081-5.425-21.16 0-6.946-5.555-12.501-12.011-15.074a6.006 6.006 0 10-11.491 0c-6.456 2.573-12.011 8.128-12.011 15.074 0 9.079-1.422 14.614-5.426 21.16a2.593 2.593 0 000 2.623 2.683 2.683 0 002.323 1.381h41.719a2.683 2.683 0 002.352-1.381 2.593 2.593 0 00-.03-2.623zm-41.73 0c3.514-6.386 4.795-12.211 4.795-21.16 0-5.755 5.405-10.009 10.58-11.73a18.17 18.17 0 011.802-.52 38.744 38.744 0 01-.59-4.005 3.426 3.426 0 010-.41 1.555 1.555 0 010-.2 2.002 2.002 0 014.003 0c.004.066.004.133 0 .2.008.137.008.274 0 .41a38.744 38.744 0 01-.59 4.004c.609.142 1.21.316 1.801.52 5.175 1.752 10.58 6.006 10.58 11.732 0 8.948 1.281 14.773 4.795 21.16H12.99z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M21.309 57.487A22.11 22.11 0 0031.539 60a22.1 22.1 0 0010.229-2.463 2.002 2.002 0 10-1.862-3.543 17.867 17.867 0 01-8.368 2.002c-2.91.015-5.78-.672-8.368-2.002a2.002 2.002 0 00-1.861 3.493z"
    })),
    "alert-filled": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M60 32c0 15.464-12.536 28-28 28-15.457-.017-27.983-12.543-28-28C4 16.536 16.536 4 32 4s28 12.536 28 28zM34.228 46.042a2.809 2.809 0 00-.568-1.346c-.558-.818-1.096-1.227-1.615-1.227-.402.018-.782.19-1.062.48a3.61 3.61 0 00-.867 1.3 4.417 4.417 0 00-.344 1.72c0 .758.418 1.137 1.256 1.137.776 0 1.536-.229 2.183-.658.678-.44 1.017-.908 1.017-1.406zM29.35 20.68v17.922c.001 1.033.493 1.55 1.476 1.55.93 0 1.838-.318 2.61-.912.81-.608 1.216-1.246 1.216-1.914V19.404a3.613 3.613 0 00-.638-1.779c-.663-1.154-1.328-1.731-1.993-1.731a1.75 1.75 0 00-1.216.638 4.998 4.998 0 00-1.037 1.778 6.828 6.828 0 00-.418 2.37z",
        clipRule: "evenodd"
    })),
    alert: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 60c15.464 0 28-12.536 28-28S47.464 4 32 4 4 16.536 4 32c.017 15.457 12.543 27.983 28 28zm0-51.692c13.085 0 23.692 10.607 23.692 23.692S45.085 55.692 32 55.692 8.308 45.085 8.308 32C8.322 18.921 18.92 8.322 32 8.308z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M29.35 38.603V20.681a6.828 6.828 0 01.417-2.371 4.991 4.991 0 011.037-1.778 1.75 1.75 0 011.216-.638c.665 0 1.33.577 1.993 1.731.36.509.583 1.128.638 1.78v17.922c0 .668-.406 1.306-1.217 1.914-.77.594-1.68.911-2.609.911-.983 0-1.475-.516-1.476-1.549zm4.31 6.093a2.8 2.8 0 01.568 1.346c0 .498-.339.966-1.017 1.406a3.947 3.947 0 01-2.183.658c-.838 0-1.256-.379-1.256-1.137a4.417 4.417 0 01.344-1.72 3.61 3.61 0 01.867-1.3c.28-.29.66-.462 1.062-.48.518 0 1.057.41 1.615 1.227z"
    })),
    "arrow-down": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M49.414 39.414l-16 16a1.999 1.999 0 01-2.828 0l-16-16a2 2 0 012.828-2.828L30 49.172V10a2 2 0 114 0v39.172l12.586-12.586a2 2 0 012.828 2.828z"
    })),
    "arrow-large-down": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M12.662 32.513a2 2 0 012.704.026l.12.123L30 48.788V10a2 2 0 011.85-1.995L32 8a2 2 0 011.995 1.85L34 10v38.789l14.513-16.127a2 2 0 012.692-.259l.133.11a2 2 0 01.259 2.692l-.11.133-18.008 20.008-.141.14-.075.065-.085.065-.129.087-.206.111-.166.068-.19.058-.192.038-.131.015-.165.007-.162-.007-.166-.02-.105-.02-.167-.045-.15-.054-.154-.07-.144-.08-.164-.114-.133-.111-.168-.172-17.973-19.97a2 2 0 01.15-2.824z"
    })),
    "arrow-large-left": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M31.487 12.662a2 2 0 01-.026 2.704l-.123.12L15.212 30H54a2 2 0 011.995 1.85L56 32a2 2 0 01-1.85 1.995L54 34H15.211l16.127 14.513a2 2 0 01.259 2.692l-.11.133a2 2 0 01-2.692.259l-.133-.11L8.654 33.479l-.14-.141-.065-.075-.065-.085-.087-.129-.111-.206-.068-.166-.058-.19-.038-.192-.015-.131L8 31.999l.007-.162.02-.166.02-.105.045-.167.054-.15.07-.154.08-.144.114-.164.111-.133.172-.168 19.97-17.973a2 2 0 012.824.15z"
    })),
    "arrow-large-right": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32.513 51.338a2 2 0 01.026-2.704l.123-.12L48.788 34H10a2 2 0 01-1.995-1.85L8 32a2 2 0 011.85-1.995L10 30h38.789L32.662 15.487a2 2 0 01-.259-2.692l.11-.133a2 2 0 012.692-.259l.133.11 20.008 18.008.14.141.065.075.065.085.087.129.111.206.068.166.058.19.038.192.015.131.007.165-.007.162-.02.166-.02.105-.045.167-.054.15-.07.154-.08.144-.114.164-.111.133-.172.168-19.97 17.973a2 2 0 01-2.824-.15z"
    })),
    "arrow-large-up": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M51.338 31.487a2 2 0 01-2.704-.026l-.12-.123L34 15.212V54a2 2 0 01-1.85 1.995L32 56a2 2 0 01-1.995-1.85L30 54V15.211L15.487 31.338a2 2 0 01-2.692.259l-.133-.11a2 2 0 01-.259-2.692l.11-.133L30.521 8.654l.141-.14.075-.065.085-.065.129-.087.206-.111.166-.068.19-.058.192-.038.131-.015.165-.007.162.007.166.02.105.02.167.045.15.054.154.07.144.08.164.114.133.111.168.172 17.973 19.97a2 2 0 01-.15 2.824z"
    })),
    "arrow-left": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M56 32a2 2 0 01-2 2H14.828l12.586 12.586a2 2 0 11-2.828 2.828l-16-16a2 2 0 010-2.828l16-16a2 2 0 112.828 2.828L14.828 30H54a2 2 0 012 2z"
    })),
    "arrow-right": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M55.414 33.414l-16 16a2 2 0 01-2.828-2.828L49.172 34H10a2 2 0 110-4h39.172L36.586 17.414a2 2 0 012.828-2.828l16 16a2 2 0 010 2.828z"
    })),
    "arrow-small-down": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M30.614 45.286L16.272 24.45c-.502-.73-.289-1.71.477-2.19.27-.169.586-.259.91-.259h28.683C47.257 22 48 22.708 48 23.581c0 .309-.095.61-.272.868L33.387 45.286c-.503.73-1.531.934-2.297.455"
    })),
    "arrow-small-left": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M18.714 30.614L39.55 16.272c.73-.502 1.71-.289 2.19.477.169.27.259.586.259.91v28.683C42 47.257 41.292 48 40.419 48c-.309 0-.61-.095-.868-.272L18.714 33.387c-.73-.503-.934-1.531-.455-2.297"
    })),
    "arrow-small-right": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M45.286 33.386L24.45 47.728c-.73.502-1.71.289-2.19-.477a1.716 1.716 0 01-.259-.91V17.658C22 16.743 22.708 16 23.581 16c.309 0 .61.095.868.272l20.837 14.341c.73.503.934 1.531.455 2.297"
    })),
    "arrow-small-up": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M33.386 18.714L47.728 39.55c.502.73.289 1.71-.477 2.19-.27.169-.586.259-.91.259H17.658C16.743 42 16 41.292 16 40.419c0-.309.095-.61.272-.868l14.341-20.837c.503-.73 1.531-.934 2.297-.455"
    })),
    "arrow-subdirectory": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M51.41 35.41l-12 12a2 2 0 01-2.82-2.82L45.17 36H20a8 8 0 01-8-8V18a2 2 0 114 0v10a4 4 0 004 4h25.17l-8.58-8.59a2 2 0 012.82-2.82l12 12a2 2 0 010 2.82z",
        clipRule: "evenodd"
    })),
    "arrow-up": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M49.414 27.414a1.999 1.999 0 01-2.828 0L34 14.828V54a2 2 0 01-4 0V14.828L17.414 27.414a2 2 0 11-2.828-2.828l16-16a2 2 0 012.828 0l16 16a1.998 1.998 0 010 2.828z"
    })),
    attach: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M53.77 27.82L45.64 36 36 45.55l-5.21 5.25c-5.293 5.146-13.737 5.087-18.957-.133-5.22-5.22-5.279-13.664-.133-18.957l15.56-15.56A2.008 2.008 0 0130.09 19L14.53 34.54A9.521 9.521 0 1028 48l5.31-5.3L51 25a6 6 0 00-4.3-10.25 6 6 0 00-4.24 1.75l-3.13 3.13v.06L24.78 34.18 23 36a2.5 2.5 0 000 3.53 2.56 2.56 0 003.54 0l16.27-16.31a2.001 2.001 0 012.83 2.83L29.38 42.31a6.5 6.5 0 11-9.19-9.19l19.44-19.44a10 10 0 0114.14 14.14z"
    })),
    attachment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M56.772 26.488l-9.35 9.407-11.084 10.982-5.992 6.037c-6.086 5.917-15.797 5.85-21.799-.153-6.003-6.003-6.07-15.713-.153-21.8l17.893-17.893a2.31 2.31 0 113.254 3.278l-17.893 17.87c-4.274 4.277-4.271 11.21.006 15.484 4.277 4.274 11.21 4.271 15.484-.006l6.106-6.095 20.343-20.354a6.9 6.9 0 00-4.945-11.787 6.9 6.9 0 00-4.876 2.013l-3.6 3.6v.068l-16.73 16.663-2.048 2.093a2.875 2.875 0 000 4.06 2.944 2.944 0 004.071 0l18.71-18.756a2.301 2.301 0 113.254 3.254L28.725 43.15a7.475 7.475 0 11-10.568-10.568l22.355-22.355c4.512-4.358 11.684-4.296 16.12.14 4.436 4.436 4.498 11.608.14 16.12z",
        clipRule: "evenodd"
    })),
    "b2b-customer": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M21.414 17C22.72 12.383 26.964 9 32 9c5.035 0 9.28 3.383 10.586 8H52a8 8 0 018 8v22a8 8 0 01-8 8H12a8 8 0 01-8-8V25a8 8 0 018-8h9.414zm4.26 0a7 7 0 0112.652 0H25.674zM56 25a4 4 0 00-4-4H12a4 4 0 00-4 4v4a4 4 0 004 4h12v-.5a4 4 0 014-4h7a4 4 0 014 4v.5h13a4 4 0 004-4v-4zM12 37h12.03A4 4 0 0028 40.5h7a4 4 0 003.97-3.5H52c1.457 0 2.823-.39 4-1.07V47a4 4 0 01-4 4H12a4 4 0 01-4-4V35.93A7.963 7.963 0 0012 37zm16-4.5v4h7v-4h-7z",
        clipRule: "evenodd"
    })),
    bag: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M55.33 49.191l-3.15-29.615A3.992 3.992 0 0048.203 16H44a12 12 0 00-24 0h-4.2a3.993 3.993 0 00-3.98 3.576L8.67 49.204A8 8 0 0016.631 58h30.74a8.001 8.001 0 007.96-8.809zM32.002 8a8.01 8.01 0 018 8h-16a8.009 8.009 0 018-8zm18.336 44.685A3.956 3.956 0 0147.371 54h-30.74a3.999 3.999 0 01-3.98-4.385L15.8 20H20v8a2 2 0 004 0v-8h16v8a2 2 0 004 0v-8h4.202l3.148 29.602a3.953 3.953 0 01-1.014 3.083z"
    })),
    "bar-chart": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M58 52h-6V12a4.004 4.004 0 00-4-4h-8a4.004 4.004 0 00-4 4v12h-8a4.004 4.004 0 00-4 4v4h-8a4.004 4.004 0 00-4 4v16H6a2 2 0 100 4h52a2 2 0 100-4zm-42 0V36h8v16h-8zm12 0V28h8v24h-8zm12 0V12h8v40h-8z",
        clipRule: "evenodd"
    })),
    basketball: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M51.905 51.669c10.832-10.944 10.788-28.584-.101-39.473-10.889-10.889-28.529-10.934-39.473-.1-.043.036-.09.065-.13.105-.04.04-.07.087-.106.13-10.833 10.944-10.788 28.584.101 39.473 10.889 10.889 28.529 10.934 39.473.1.043-.036.09-.065.13-.105.04-.04.07-.087.106-.13zm-21.99 3.926a23.583 23.583 0 01-13.067-5.398L32 35.046l4.554 4.554a27.91 27.91 0 00-6.639 15.995zm9.685-12.95l7.552 7.552a23.585 23.585 0 01-12.91 5.386A23.62 23.62 0 0139.6 42.645zm3.046-3.045a23.62 23.62 0 0112.937-5.358 23.584 23.584 0 01-5.386 12.91L42.646 39.6zm12.949-9.684a27.91 27.91 0 00-15.996 6.638L35.045 32l15.152-15.152a23.583 23.583 0 015.398 13.068zM13.803 16.848l7.466 7.467a23.623 23.623 0 01-12.845 5.35 23.587 23.587 0 015.379-12.817zm3.045-3.045a23.586 23.586 0 0112.816-5.379 23.622 23.622 0 01-5.35 12.845l-7.466-7.466zm17.144-5.405a23.582 23.582 0 0113.16 5.405L32 28.954l-4.64-4.639a27.913 27.913 0 006.632-15.917zM8.398 33.992a27.911 27.911 0 0015.917-6.631L28.955 32 13.803 47.15a23.582 23.582 0 01-5.405-13.159z",
        clipRule: "evenodd"
    })),
    battery: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M27.415 24.586A2 2 0 0026 24H15.82A3.674 3.674 0 0012 27.5v9a3.674 3.674 0 003.82 3.5H38a2 2 0 001.414-3.414l-12-12zM16 35.994V28h9.172l7.998 7.998L16 35.995zM56 22h-.252A8.015 8.015 0 0048 16H12a8.01 8.01 0 00-8 8v16a8.01 8.01 0 008 8h36a8.015 8.015 0 007.748-6H56c2.244 0 4-2.05 4-4.666V26.666C60 24.05 58.244 22 56 22zm0 15.334c.008.233-.051.465-.17.666H52v2a4.004 4.004 0 01-4 4H12a4.004 4.004 0 01-4-4V24a4.004 4.004 0 014-4h36a4.004 4.004 0 014 4v2h3.83c.119.201.178.433.17.666v10.668z",
        clipRule: "evenodd"
    })),
    "best-in-test": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M48 4a4 4 0 014 4v4h3.83a4 4 0 013.95 4.64A16.12 16.12 0 0149.48 29 20.2 20.2 0 0138 39v3c.005.09.005.18 0 .27.005.09.005.18 0 .27a18.88 18.88 0 0111.38 12.34 3.94 3.94 0 01-.63 3.51A4 4 0 0145.54 60H18.46a4 4 0 01-3.84-5.13A18.92 18.92 0 0126 42.53a1.64 1.64 0 010-.23V39a20.41 20.41 0 01-11.5-10A16.1 16.1 0 014.22 16.66 4 4 0 018.17 12H12V8a4 4 0 014-4zM34 39.89a17.45 17.45 0 01-4 0V42c.005.09.005.18 0 .27.005.09.005.18 0 .27a4 4 0 01-2.63 3.74A14.87 14.87 0 0018.45 56h27.09a14.83 14.83 0 00-8.91-9.71A4 4 0 0134 42.54a2.48 2.48 0 010-.27 2.48 2.48 0 010-.27zM48 8H16v11.131c.004.505.02.999.1 1.519.02.18.08.35.08.53.06.46.13.92.23 1.37.03.17.12.33.12.5.109.486.242.967.4 1.44.04.11.11.22.11.33.2.56.43 1.12.68 1.66A15.93 15.93 0 0032 36a15.87 15.87 0 0014.26-9.46 18.28 18.28 0 001.74-7.8V8zm-14.12 3.55c.75 0 1.12.31 1.12 1v16.31a3.9 3.9 0 01-.63 2.14 1.77 1.77 0 01-1.38 1c-.5 0-.98-.37-1.5-1.12A2.39 2.39 0 0131 29.7V16.32l-3.4 1.56a1.09 1.09 0 01-.46.12c-.48 0-.94-.36-1.38-1a2.27 2.27 0 01-.43-1.08c0-.53.45-1.01 1.35-1.43l5.93-2.68a3.24 3.24 0 011.27-.26zM12 16H8.17a12 12 0 004.26 7.33v-.17c-.02-.12-.07-.24-.07-.37-.11-.6-.2-1.21-.26-1.83v-.17c-.1-.68-.1-1.36-.1-2.05V16zm43.77 0h-3.83v4.35c-.02.26-.07.52-.07.78l-.06.5-.09.67c-.03.18-.1.35-.1.53l-.09.5A12 12 0 0055.77 16z"
    })),
    "blood-pressure": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M55.826 34.275l-20.494 21.25a4.297 4.297 0 01-3.108 1.327h-.008a4.298 4.298 0 01-3.107-1.317L8.329 34.12a14.98 14.98 0 01-1.779-2.063 2.166 2.166 0 011.801-3.37h9.495l3.734-7.47a2.167 2.167 0 013.876 0l6.729 13.459 2.395-4.792a2.167 2.167 0 011.938-1.197h6.5a2.167 2.167 0 110 4.333h-5.161l-3.734 7.47a2.167 2.167 0 01-3.877 0l-6.728-13.46-2.395 4.791a2.167 2.167 0 01-1.939 1.198h-5.883l18.917 19.498 20.489-21.25c4.407-4.642 4.396-11.926-.025-16.553a10.927 10.927 0 00-7.894-3.38h-.017a10.929 10.929 0 00-7.9 3.404l-3.15 3.266c-.408.422-.97.661-1.557.662h-.003a2.166 2.166 0 01-1.555-.658l-3.159-3.256a10.928 10.928 0 00-7.894-3.38h-.016a10.93 10.93 0 00-7.901 3.404 11.907 11.907 0 00-3.244 9.411 2.167 2.167 0 01-4.314.409 16.24 16.24 0 014.439-12.829A15.226 15.226 0 0119.53 7.038h.023a15.227 15.227 0 0111.004 4.696l1.6 1.649 1.594-1.654A15.226 15.226 0 0144.764 7h.024a15.227 15.227 0 0111.004 4.696c6.03 6.313 6.045 16.248.034 22.579z",
        clipRule: "evenodd"
    })),
    bluetooth: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M31.126 8.201a2 2 0 012.11.226l14 11a2 2 0 010 3.146l-12 9.427 11.998 9.427a2 2 0 010 3.146l-14 11A2 2 0 0130 54V36.115l-10.765 8.458a2 2 0 01-2.47-3.146L28.762 32l-11.999-9.427a2 2 0 012.471-3.146L30 27.885V10a2 2 0 011.126-1.799zM34 36.115L42.763 43 34 49.885v-13.77zm0-8.23v-13.77L42.763 21 34 27.885z",
        clipRule: "evenodd"
    })),
    bookmark: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M46 6H18a8.01 8.01 0 00-8 8v41.839a3.97 3.97 0 002.268 3.605 3.97 3.97 0 004.23-.482L32 46.562l15.502 12.4A4 4 0 0054 55.839V14a8.01 8.01 0 00-8-8zM34.499 43.438a3.974 3.974 0 00-4.997 0L14 55.838V14a4.004 4.004 0 014-4h28a4.004 4.004 0 014 4l.013 41.848-15.514-12.41z"
    })),
    broadband: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M33.833 32.423v23.834a2.167 2.167 0 11-4.333 0V32.422a2.167 2.167 0 114.333 0zm7.661-20.66a2.166 2.166 0 10-3.064 3.064 6.501 6.501 0 010 9.192 2.166 2.166 0 103.064 3.064c4.23-4.23 4.23-11.09 0-15.32zm6.128-6.129A2.167 2.167 0 1044.558 8.7a15.165 15.165 0 010 21.448 2.167 2.167 0 003.064 3.065 19.5 19.5 0 000-27.578zm-15.955 10.54a3.25 3.25 0 100 6.499 3.25 3.25 0 000-6.5zm-6.764-4.412a2.167 2.167 0 00-3.064 0c-4.23 4.231-4.23 11.09 0 15.321a2.167 2.167 0 103.064-3.064 6.502 6.502 0 010-9.192 2.166 2.166 0 000-3.065zm-10.57 7.661A15.063 15.063 0 0118.776 8.7a2.167 2.167 0 00-3.064-3.064 19.5 19.5 0 000 27.577 2.167 2.167 0 003.064-3.065 15.063 15.063 0 01-4.443-10.724z",
        clipRule: "evenodd"
    })),
    "broken-phone": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M33.56 7.914l3.77 1.277a3.77 3.77 0 012.353 4.777l-3.75 11.219a1.995 1.995 0 001.247 2.523c.206.07.421.107.638.11a1.995 1.995 0 001.885-1.357l3.81-11.209a7.749 7.749 0 00-4.857-9.833l-3.81-1.276a1.995 1.995 0 10-1.286 3.77zm-4.218 44.328a1.925 1.925 0 11-3.85 0 1.925 1.925 0 013.85 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M38.856 34.012c0-1.102.893-1.995 1.994-1.995a1.995 1.995 0 012.014 1.995v18.24A7.758 7.758 0 0135.117 60H19.759A7.768 7.768 0 0112 52.252V14.845a7.768 7.768 0 017.739-7.758h7.04a1.994 1.994 0 010 3.989h-7.04a3.77 3.77 0 00-3.75 3.77v29.647h22.867V34.012zm-19.117 21.94h15.357v.059a3.76 3.76 0 003.83-3.76v-3.77H15.988v3.77a3.76 3.76 0 003.75 3.7zm25.369-30.836c.33-.003.655-.085.947-.239l4.837-2.662a1.995 1.995 0 10-1.915-3.5l-4.856 2.662a1.994 1.994 0 00.997 3.74h-.01zm-.04 0h-.01.05-.04z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M45.736 27.031l4.668 1.357v-.02a1.994 1.994 0 01-.549 3.919 2.081 2.081 0 01-.548-.08l-4.668-1.336a1.996 1.996 0 111.097-3.84z"
    })),
    bulb: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M59.999 32a2 2 0 01-2 2h-4a2 2 0 010-4h4a2 2 0 012 2zm-8.201-19.8a2 2 0 00-2.828 0l-2.828 2.828a2 2 0 102.828 2.828l2.828-2.828a2 2 0 000-2.828zM31.999 12a2 2 0 002-2V6a2 2 0 10-4 0v4a2 2 0 002 2zm-14.142 5.857a1.999 1.999 0 000-2.828l-2.828-2.828a2 2 0 10-2.828 2.828l2.828 2.828a1.999 1.999 0 002.828 0zM10 30H6a2 2 0 100 4h4a2 2 0 000-4zm37.999 2a15.968 15.968 0 01-5.53 12.075c-.347.314-.63.695-.831 1.119l-1.639 3.278v3.3a8.123 8.123 0 01-7.009 8.166A8.002 8.002 0 0124 52v-3.527l-1.642-3.284a3.583 3.583 0 00-.83-1.118A15.99 15.99 0 1147.998 32zm-12 18h-8v2a4.002 4.002 0 004.51 3.968A4.175 4.175 0 0036 51.77V50zm8-18a12 12 0 10-19.853 9.046 7.547 7.547 0 011.79 2.352l1.3 2.601h9.527l1.297-2.595a7.54 7.54 0 011.792-2.353 11.973 11.973 0 004.147-9.052z",
        clipRule: "evenodd"
    })),
    "business-continuity": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M36 27.014a2 2 0 00-2 2v6h-6a2 2 0 00-2 2v4h-6a2 2 0 00-2 2v10h-1a2 2 0 100 4h30a2 2 0 000-4h-1v-24a2 2 0 00-2-2h-8zm-6 26h4v-14h-4v14zm-8 0h4v-8h-4v8zm20 0h-4v-22h4v22zm11.9-4.251a2 2 0 01-.781-2.718 22.919 22.919 0 002.75-8.84 22.958 22.958 0 00-.53-7.72 2 2 0 013.887-.944 26.96 26.96 0 01.622 9.061 26.92 26.92 0 01-3.23 10.38 2 2 0 01-2.718.781z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M9 33c0-12.703 10.297-23 23-23 7.47 0 14.11 3.56 18.313 9.082H43.5a2 2 0 000 4h10.076a3 3 0 002.99-2.74l.926-10.655a2 2 0 00-3.984-.347l-.575 6.605C47.983 9.878 40.446 6 32 6 17.088 6 5 18.088 5 33c0 4.92 1.318 9.54 3.622 13.516a2 2 0 103.461-2.005A22.886 22.886 0 019 33z"
    })),
    "business-intelligence": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M46.553 24h-1.2a10.09 10.09 0 00-1.46-3.51l1.07-1.08a2 2 0 00-2.82-2.82l-1.08 1.07a10.09 10.09 0 00-3.51-1.46V15a2 2 0 10-4 0v1.2a10.09 10.09 0 00-3.51 1.46l-1.08-1.07a2 2 0 00-2.82 2.82l1.07 1.08a10.09 10.09 0 00-1.46 3.51h-1.2a2 2 0 100 4h1.2a10.09 10.09 0 001.46 3.51l-1.07 1.08a2 2 0 102.82 2.82l1.08-1.07a10.09 10.09 0 003.51 1.46V37a2 2 0 104 0v-1.2a10.09 10.09 0 003.51-1.46l1.08 1.07a2 2 0 002.82-2.82l-1.07-1.08a10.09 10.09 0 001.46-3.51h1.2a2 2 0 100-4zm-11 8a6 6 0 110-12 6 6 0 010 12z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M34.553 4c-12.404-.007-22.58 9.823-23 22.22l-4.54 5.12a4 4 0 003 6.66h1.54v8a4 4 0 004 4h6a4 4 0 014 4v2a4 4 0 004 4h16a4 4 0 004-4V44.91a24.08 24.08 0 008-17.91c0-12.703-10.298-23-23-23zm12.4 37.9a4 4 0 00-1.4 3V56h-16v-2a8 8 0 00-8-8h-6V34h-5.55l5.55-6.24V27c0-10.493 8.506-19 19-19 10.493 0 19 8.507 19 19a20.27 20.27 0 01-6.6 14.9z",
        clipRule: "evenodd"
    })),
    business: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M38 8a6 6 0 016 6v2h10a6 6 0 016 6v28a6 6 0 01-6 6H10a6 6 0 01-6-6V22a6 6 0 016-6h10v-2a6 6 0 016-6zm18 33.65a5.8 5.8 0 01-2 .35H10a5.8 5.8 0 01-2-.35V50a2 2 0 002 2h44a2 2 0 002-2zM54 20H10a2 2 0 00-2 2v14a2 2 0 002 2h44a2 2 0 002-2V22a2 2 0 00-2-2zM32 32a2 2 0 110 4 2 2 0 010-4zm6-20H26a2 2 0 00-2 2v2h16v-2a2 2 0 00-2-2z"
    })),
    calendar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M58 51.385V16.923c-.003-2.378-1.941-4.305-4.333-4.308h-4.334V8.308C49.331 5.93 47.393 4.003 45 4h-4.333c-2.392.003-4.33 1.93-4.334 4.308v4.307h-8.666V8.308C27.664 5.93 25.725 4.003 23.333 4H19c-2.392.003-4.33 1.93-4.333 4.308v4.307h-4.334c-2.392.003-4.33 1.93-4.333 4.308v34.462c.005 4.756 3.882 8.61 8.667 8.615h34.666c4.785-.005 8.662-3.86 8.667-8.615zM45 16.923h-4.333V8.308H45v8.615zm-21.667 0H19V8.308h4.333v8.615zm26 0h4.334v8.062H10.333v-8.062h4.334c.002 2.378 1.941 4.305 4.333 4.308h4.333c2.393-.003 4.331-1.93 4.334-4.308h8.666c.003 2.378 1.942 4.305 4.334 4.308H45c2.392-.003 4.33-1.93 4.333-4.308zm-39 12.062v22.4c.003 2.378 1.942 4.305 4.334 4.307h34.666c2.392-.002 4.331-1.93 4.334-4.307v-22.4H10.333z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M14.695 35.307c0-1.105.9-2 2.012-2h4.671c1.111 0 2.012.895 2.012 2v1.402c0 1.105-.9 2-2.012 2h-4.671a2.006 2.006 0 01-2.012-2v-1.402zm13.042 0c0-1.105.901-2 2.012-2h4.671c1.112 0 2.012.895 2.012 2v1.402c0 1.105-.9 2-2.012 2h-4.67a2.006 2.006 0 01-2.013-2v-1.402zm13.043 0c0-1.105.9-2 2.012-2h4.67c1.112 0 2.013.895 2.013 2v1.402c0 1.105-.901 2-2.012 2h-4.671a2.006 2.006 0 01-2.012-2v-1.402zM14.695 46.111c0-1.104.9-2 2.012-2h4.671c1.111 0 2.012.896 2.012 2v1.403c0 1.104-.9 2-2.012 2h-4.671a2.006 2.006 0 01-2.012-2V46.11zm13.042 0c0-1.104.901-2 2.012-2h4.671c1.112 0 2.012.896 2.012 2v1.403c0 1.104-.9 2-2.012 2h-4.67a2.006 2.006 0 01-2.013-2V46.11zm13.043 0c0-1.104.9-2 2.012-2h4.67c1.112 0 2.013.896 2.013 2v1.403c0 1.104-.901 2-2.012 2h-4.671a2.006 2.006 0 01-2.012-2V46.11z"
    })),
    camera: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M51.385 16.923h-4.909L43.848 9.04C42.812 5.931 40.554 4 37.957 4H26.043c-2.597 0-4.855 1.931-5.891 5.04l-2.628 7.883h-4.909A8.625 8.625 0 004 25.54v25.846A8.625 8.625 0 0012.615 60h38.77A8.625 8.625 0 0060 51.385V25.539a8.625 8.625 0 00-8.615-8.616zm-27.147-6.52c.459-1.376 1.255-2.095 1.805-2.095h11.913c.55 0 1.347.72 1.805 2.094l2.174 6.521h-19.87l2.173-6.52zm31.454 40.982a4.312 4.312 0 01-4.307 4.307h-38.77a4.312 4.312 0 01-4.307-4.307V25.539a4.312 4.312 0 014.307-4.308h38.77a4.312 4.312 0 014.307 4.307v25.847zM32 25.539c-7.137 0-12.923 5.785-12.923 12.922 0 7.138 5.786 12.924 12.923 12.924 7.137 0 12.923-5.786 12.923-12.923-.008-7.134-5.79-12.916-12.923-12.924zm0 21.538a8.615 8.615 0 118.615-8.615A8.625 8.625 0 0132 47.077z",
        clipRule: "evenodd"
    })),
    "card-view": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M12 8h40a4 4 0 014 4v14a4 4 0 01-4 4H12a4 4 0 01-4-4V12a4 4 0 014-4zm14 18h26V12H26v14zm-4 0V12H12v14h10zm-10 8h40a4 4 0 014 4v14a4 4 0 01-4 4H12a4 4 0 01-4-4V38a4 4 0 014-4zm0 4h10v14H12V38zm40 14H26V38h26v14z",
        clipRule: "evenodd"
    })),
    care: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M57.402 36.72a8.615 8.615 0 00-2.685-1.881A17.017 17.017 0 0042.78 24.032a13.727 13.727 0 10-24.874.007A16.91 16.91 0 005 40.44v4.223a8.457 8.457 0 008.447 8.447h23.186l6.216 6.426a3.163 3.163 0 004.55-.001l10.003-10.341a9.042 9.042 0 000-12.472zM30.342 8.762a9.503 9.503 0 11-9.503 9.503 9.513 9.513 0 019.502-9.503zm-21.118 35.9v-4.223a12.686 12.686 0 0111.305-12.594 13.683 13.683 0 0019.619.007 12.78 12.78 0 019.68 6.384 8.49 8.49 0 00-4.684 2.486l-.02.02-.02-.02a8.483 8.483 0 00-12.259 0 9.04 9.04 0 00-.269 12.164H13.447a4.228 4.228 0 01-4.223-4.223zm45.142 1.595l-9.242 9.556-9.243-9.556a4.785 4.785 0 010-6.598 4.26 4.26 0 016.188 0l1.537 1.589a2.175 2.175 0 003.035 0l1.538-1.59a4.26 4.26 0 016.187 0 4.784 4.784 0 010 6.599z",
        clipRule: "evenodd"
    })),
    cart: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M49.438 42a5.99 5.99 0 005.821-4.544l4.622-18.486A4 4 0 0056 14H17.24l-.957-4.784A4.01 4.01 0 0012.36 6H6a2 2 0 100 4h6.361l7.295 36.478A5.999 5.999 0 1027.65 54h14.7a6 6 0 100-4h-14.7a6.019 6.019 0 00-3.961-3.755L22.839 42h26.6zM56 18l-4.622 18.486A1.996 1.996 0 0149.438 38H22.04l-4-20H56zM22 54a2 2 0 01-.003-4l.001.001h.003a2 2 0 110 4zm26-4a2 2 0 110 4 2 2 0 010-4z",
        clipRule: "evenodd"
    })),
    cast: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M60 20v24a8.01 8.01 0 01-8 8H30a2 2 0 010-4h22a4.005 4.005 0 004-4V20a4.005 4.005 0 00-4-4H12a4.004 4.004 0 00-4 4v6a2 2 0 01-4 0v-6a8.01 8.01 0 018-8h40a8.01 8.01 0 018 8zM6 48a2 2 0 100 4 2 2 0 000-4zm.889-16H6a2 2 0 100 4h.889A13.114 13.114 0 0120 49.111V50a2 2 0 004 0v-.889A17.12 17.12 0 006.889 32zm-.09 8H6a2 2 0 100 4h.8a5.206 5.206 0 015.2 5.2v.8a2 2 0 004 0v-.8A9.21 9.21 0 006.8 40z"
    })),
    "chat-robot": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M16.5 44a.5.5 0 100 1 .5.5 0 000-1zm-2.5.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0zm11.5-.5a.5.5 0 100 1 .5.5 0 000-1zm-2.5.5a2.5 2.5 0 115 0 2.5 2.5 0 01-5 0z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M28 32.83a3.001 3.001 0 10-2 0V34H16v-1.17a3.001 3.001 0 10-2 0v1.232A8.001 8.001 0 007 42v1a3 3 0 100 6v3a8 8 0 008 8h12a8 8 0 008-8v-3a3 3 0 100-6v-1a8.001 8.001 0 00-7-7.938v-1.233zM15 38a4 4 0 00-4 4v10a4 4 0 004 4h12a4 4 0 004-4V42a4 4 0 00-4-4H15z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M16 49a1 1 0 00-1 1.019c.003.056.009.174.015.233a4.452 4.452 0 00.796 2.08C16.656 53.513 18.237 54.5 21 54.5s4.344-.986 5.189-2.169a4.452 4.452 0 00.796-2.08A5.519 5.519 0 0027 50a1 1 0 00-1-1H16zm1.12 2.112s-.084-.075-.12-.112h8a1.836 1.836 0 01-.12.112l-.084.073c-.48.42-1.502 1.315-3.796 1.315-2.294 0-3.317-.895-3.796-1.315l-.084-.073z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M39 16a2 2 0 11-4 0 2 2 0 014 0zm7 0a2 2 0 11-4 0 2 2 0 014 0zm7 0a2 2 0 11-4 0 2 2 0 014 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M35 4a8 8 0 00-8 8v7a8 8 0 008 8h1v4a2 2 0 003.302 1.519L45.74 27H52a8 8 0 008-8v-7a8 8 0 00-8-8H35zm17 19h-6c-1 0-2 0-3 1l-3 2.5V25a2 2 0 00-2-2h-3a4 4 0 01-4-4v-7a4 4 0 014-4h17a4 4 0 014 4v7a4 4 0 01-4 4z",
        clipRule: "evenodd"
    })),
    chat: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M52 7H24a8.01 8.01 0 00-8 8v8h-4a8.01 8.01 0 00-8 8v12a8.01 8.01 0 008 8h7.17l5.709 5.708A3 3 0 0030 54.586V51h9.999a8.01 8.01 0 008-8v-8H52a8.01 8.01 0 008-8V15a8.01 8.01 0 00-8-8zm-8.001 36a4.004 4.004 0 01-4 4H26v5.172L20.826 47H12a4.004 4.004 0 01-4-4V31a4.004 4.004 0 014-4h4a8.01 8.01 0 008 8h6v3.586a2.999 2.999 0 005.121 2.122L40.83 35H44v8zM56 27a4.004 4.004 0 01-4 4H39.173L34 36.172V31H24a4.004 4.004 0 01-4-4V15a4.004 4.004 0 014-4h28a4.004 4.004 0 014 4v12z",
        clipRule: "evenodd"
    })),
    "check-circle-filled": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 4C16.536 4 4 16.536 4 32s12.536 28 28 28 28-12.536 28-28C59.983 16.543 47.457 4.017 32 4zm12.561 20.58L31.638 43.963a2.15 2.15 0 01-3.315.328l-8.615-8.615a2.154 2.154 0 013.046-3.046l6.758 6.757L40.977 22.19a2.154 2.154 0 113.584 2.39z",
        clipRule: "evenodd"
    })),
    "check-circle": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 4C16.536 4 4 16.536 4 32s12.536 28 28 28 28-12.536 28-28C59.983 16.543 47.456 4.017 32 4zm0 51.693C18.915 55.693 8.307 45.085 8.307 32S18.915 8.308 32 8.308c13.084 0 23.692 10.607 23.692 23.692C55.677 45.08 45.078 55.678 32 55.693zM44.56 24.58L31.639 43.963a2.151 2.151 0 01-3.315.328l-8.616-8.615a2.154 2.154 0 013.046-3.046l6.758 6.757L40.977 22.19a2.154 2.154 0 113.584 2.39z",
        clipRule: "evenodd"
    })),
    "check-mark-circle": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 6a26 26 0 0126 26c0 14.36-11.64 26-26 26S6 46.36 6 32 17.64 6 32 6zm0 4c-12.15 0-22 9.85-22 22s9.85 22 22 22 22-9.85 22-22-9.85-22-22-22zm10.498 12.007a2 2 0 011.042 3.463L30.17 41.11a2 2 0 01-1.44.7h-.08a2 2 0 01-1.41-.58l-6.7-6.7a2.001 2.001 0 012.83-2.83l5.17 5.17 12-14a2 2 0 011.958-.863z"
    })),
    "check-mark": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M11.365 34.538a2 2 0 10-2.73 2.924l15 14a2 2 0 002.847-.119l29-32a2 2 0 10-2.964-2.686L24.881 47.153 11.365 34.538z"
    })),
    "chevron-down": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M53.032 24.865l-19.5 19.5a2.166 2.166 0 01-3.064 0l-19.5-19.5a2.166 2.166 0 113.064-3.064L32 39.77 49.968 21.8a2.167 2.167 0 013.064 3.064z",
        clipRule: "evenodd"
    })),
    "chevron-left": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M42.116 49.89a2.167 2.167 0 01-2.899 3.22l-21.666-19.5a2.166 2.166 0 010-3.22l21.666-19.5a2.167 2.167 0 012.9 3.22L22.237 32l19.878 17.89z",
        clipRule: "evenodd"
    })),
    "chevron-right": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M47.166 32c0 .614-.26 1.2-.717 1.61l-21.666 19.5a2.166 2.166 0 01-2.9-3.22L41.762 32 21.884 14.11a2.166 2.166 0 012.898-3.22l21.667 19.5c.457.41.718.996.718 1.61z",
        clipRule: "evenodd"
    })),
    "chevron-up": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M53.032 42.199a2.166 2.166 0 01-3.064 0L32 24.23 14.032 42.198a2.167 2.167 0 01-3.064-3.064l19.5-19.5a2.166 2.166 0 013.064 0l19.5 19.5a2.166 2.166 0 010 3.064z",
        clipRule: "evenodd"
    })),
    "child-boy": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M13.87 12.13c5.94-6.68 17.83-9.02 26.68-5.3a13.16 13.16 0 0110.54 5.76c2.47 3.76 2.8 8.76.91 13.76v1.43l.33.09v.02a7.82 7.82 0 010 15l-.76.21a20 20 0 01-39.14 0l-.81-.23a7.82 7.82 0 010-15l.44-.12c-2.8-5.51-2.19-11.14 1.81-15.62zM40 21.78a40.17 40.17 0 01-24 9V39c0 8.837 7.163 16 16 16s16-7.163 16-16V27.66c-3.3-.88-5.92-3.35-8-5.88zm-2.965 22.76a2 2 0 011.785 2.97v.06a7.8 7.8 0 01-6.537 4.01l-.283.005a7.8 7.8 0 01-6.82-4.015 2.011 2.011 0 013.49-2 3.8 3.8 0 006.65 0 2 2 0 011.715-1.03zM12 32a3.81 3.81 0 000 6.75zm40 0v6.7a3.82 3.82 0 000-6.7zm-22.27 3.33c.17.386.21.797.136 1.183a1.997 1.997 0 01-3.796.457 2.06 2.06 0 00-1.85-.8 2.1 2.1 0 00-1.86.8 2 2 0 01-3.872-.714 2 2 0 01.212-.926 5.92 5.92 0 015.52-3.2 5.84 5.84 0 015.51 3.2zm16 0c.17.386.21.797.136 1.183a1.997 1.997 0 01-3.796.457 2.06 2.06 0 00-1.85-.8 2.1 2.1 0 00-1.838.772l.008-.012a2.01 2.01 0 01-.186.302A2.002 2.002 0 0134.7 35.37c.19-.368.415-.71.67-1.024a5.915 5.915 0 014.85-2.216 5.84 5.84 0 015.51 3.2zm-6.838-24.909C31.547 7.38 21.722 9.267 16.86 14.74c-2.15 2.44-4.03 6.49-.78 12a35.77 35.77 0 0022.91-9.34 2 2 0 012.94.3c2.47 3.35 4.65 5.29 6.74 6a10.69 10.69 0 00-.98-8.96 9.15 9.15 0 00-7.64-4h-.06a1.6 1.6 0 01-.39-.05l-.36-.12z"
    })),
    "child-girl": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M21.57 7.82a23.25 23.25 0 0124-.61A24.2 24.2 0 0158 29.08v1.49a7.72 7.72 0 010 7.53v5c0 9.498 1.71 12.14 1.979 12.511l.021.029-.06-.04a2 2 0 01-.66 3.4c-.26.09-2.7.87-8.09.87a33.18 33.18 0 01-12.63-2.7l-.47.13a20 20 0 01-11-.23l-.581.249A33.27 33.27 0 0114.24 59.87c-5.4 0-7.84-.78-8.1-.87a2 2 0 01-1.29-1.55 2 2 0 01.67-1.79c.22-.24 2-2.74 2-12.54v-5.89a7.63 7.63 0 010-5.69c-.02-.8-.08-1.61-.08-2.43-.07-1.86-.16-11.43 5.26-17.2a12.82 12.82 0 018.87-4.09zM54 41.66a5.3 5.3 0 01-.67.23l-.76.21a20 20 0 01-8.75 12.73 26.09 26.09 0 007.39 1.1v-.02a38.91 38.91 0 004.33-.22C54.72 53.4 54 49.56 54 43.1zm-42.56-.21v1.65c0 6.46-.71 10.3-1.54 12.59a39 39 0 004.34.22A26.55 26.55 0 0022 54.7a20 20 0 01-8.58-12.58l-.81-.23a7.19 7.19 0 01-1.17-.44zM25 20.8c-2.11 2.53-4.73 5-8 5.88V38c.002 8.312 6.368 15.239 14.65 15.94.44.04.89.06 1.35.06h.8c8.523-.427 15.21-7.467 15.2-16v-8.2a40.17 40.17 0 01-24-9zm13.035 22.74a2 2 0 011.785 2.97v.06a7.8 7.8 0 01-6.537 4.01l-.283.005a7.8 7.8 0 01-6.82-4.015 2.011 2.011 0 013.49-2 3.8 3.8 0 006.65 0 2 2 0 011.715-1.03zM52.78 30.92v6.91l.22-.1a3.71 3.71 0 001-.8 3.77 3.77 0 001-2.55 3.81 3.81 0 00-1-2.58 3.71 3.71 0 00-1-.8 1.51 1.51 0 00-.22-.08zm-39.61-.01A.56.56 0 0013 31a3.67 3.67 0 00-1.47 1.41 3.73 3.73 0 00-.56 1.94 3.82 3.82 0 00.55 2 3.7 3.7 0 001.48 1.4l.17.07zm12.297.253l.245.003a5.84 5.84 0 015.018 3.204 2 2 0 01-1.665 2.792l-.165.008a2 2 0 01-1.83-1.2 2.06 2.06 0 00-1.85-.8l-.165-.01-.164.004a2.1 2.1 0 00-1.531.806 2 2 0 01-1.615 1.28l-.169.015h-.168A2 2 0 0119.7 34.37a5.92 5.92 0 015.273-3.206l.247.006.247-.007zm16 0l.245.003a5.84 5.84 0 015.018 3.204 2 2 0 01-1.665 2.792l-.165.008a2 2 0 01-1.83-1.2 2.06 2.06 0 00-1.85-.8l-.165-.01-.164.004a2.1 2.1 0 00-1.531.806 2 2 0 01-1.69 1.101l-.15.002a2 2 0 01-1.82-2.703 5.92 5.92 0 015.273-3.206l.247.006.247-.007zM43.62 10.79a19.34 19.34 0 00-20.24.69l-.11.07a2.32 2.32 0 01-.53.25h-.55a8.91 8.91 0 00-6.57 2.84c-3.09 3.36-4.07 8.94-4.19 12.68a8.1 8.1 0 011.19-.45l.38-.11V25a2 2 0 011.85-2c2.55-.17 5.16-2.17 8.21-6.27a2 2 0 012.94-.3 35.83 35.83 0 0024.64 9.38H51a2 2 0 011.46.58c.085.084.159.178.22.28l.69.2c.214.058.424.128.63.21a20.18 20.18 0 00-10.38-16.29z"
    })),
    child2: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M18.7 35.33c-.144.29-.214.604-.211.916a1.999 1.999 0 003.872.724 2.1 2.1 0 011.86-.8 2.06 2.06 0 011.85.8 2 2 0 001.83 1.2 1.998 1.998 0 001.97-1.682 1.99 1.99 0 00-.14-1.158 5.84 5.84 0 00-5.51-3.2 5.92 5.92 0 00-5.52 3.2zm20.12 12.24a7.8 7.8 0 01-13.64 0 2.011 2.011 0 113.49-2 3.8 3.8 0 006.65 0 2 2 0 113.5 1.94v.06zm6.91-12.24a5.84 5.84 0 00-5.51-3.2 5.92 5.92 0 00-4.962 2.36 5.916 5.916 0 00-.557.88 2 2 0 003.486 1.885c.076-.098.143-.205.2-.319a2.1 2.1 0 011.834-.766 2.06 2.06 0 011.85.8 2 2 0 001.83 1.2 1.998 1.998 0 001.97-1.682c.068-.379.027-.78-.14-1.158z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M52 27.78l.33.09v.02a7.82 7.82 0 010 15l-.76.21a20 20 0 01-39.14 0l-.81-.23a7.82 7.82 0 010-15l.44-.12c-2.8-5.51-2.19-11.14 1.81-15.62 5.94-6.68 17.83-9.02 26.68-5.3a13.16 13.16 0 0110.54 5.76c2.47 3.76 2.8 8.76.91 13.76v1.43zM9.96 35.375A3.81 3.81 0 0012 38.75V32a3.81 3.81 0 00-2.042 3.375zM48 39c0 8.837-7.164 16-16 16-8.837 0-16-7.163-16-16v-8.22a40.17 40.17 0 0024-9c2.08 2.53 4.7 5 8 5.88V39zm-6.07-21.3c2.47 3.35 4.65 5.29 6.74 6a10.69 10.69 0 00-.98-8.96 9.15 9.15 0 00-7.64-4h-.06a1.55 1.55 0 01-.39-.05l-.36-.12c-7.38-3.25-17.44-1.39-22.38 4.17-2.15 2.44-4.03 6.49-.78 12a35.77 35.77 0 0022.91-9.34 2 2 0 012.94.3zM52 32a3.82 3.82 0 010 6.7V32z",
        clipRule: "evenodd"
    })),
    "close-circle": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 56c13.255 0 24-10.745 24-24S45.255 8 32 8 8 18.745 8 32s10.745 24 24 24zm0 4c15.464 0 28-12.536 28-28S47.464 4 32 4 4 16.536 4 32s12.536 28 28 28z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M25.277 22.695a2 2 0 10-2.9 2.755l6.864 7.225-6.764 7.12a2 2 0 002.9 2.755L32 35.58l6.622 6.97a2 2 0 102.9-2.755l-6.764-7.12 6.864-7.225a2 2 0 10-2.9-2.755L32 29.771l-6.723-7.076z"
    })),
    close: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M51.365 48.301a2.166 2.166 0 01-3.063 3.064L32.5 35.563 16.7 51.365a2.166 2.166 0 01-3.064-3.064l15.8-15.801-15.801-15.802a2.166 2.166 0 013.064-3.064L32.5 29.436l15.802-15.802a2.167 2.167 0 013.063 3.064L35.564 32.5l15.801 15.8z",
        clipRule: "evenodd"
    })),
    "cloud-connect": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M51.607 34.168A10.018 10.018 0 0041.775 26c-.436 0-.872.029-1.304.087a14.004 14.004 0 00-26.574 4.06A12 12 0 0015.775 54h34a10 10 0 001.832-19.832zM49.775 50h-34a8 8 0 010-16h2v-2a10 10 0 0119.547-2.984l.61 1.95 1.936-.65A5.989 5.989 0 0147.775 36v2h2a6 6 0 110 12zM38.663 9.15a2 2 0 011.346-2.487A16.018 16.018 0 0159.917 17.43a2.002 2.002 0 01-1.343 2.5 2 2 0 01-2.491-1.36 12.016 12.016 0 00-14.932-8.073 2.002 2.002 0 01-2.488-1.346zm13.223 10.184a2.002 2.002 0 01-1.22 2.552 2.001 2.001 0 01-2.552-1.22 4.006 4.006 0 00-5.103-2.44 2 2 0 01-1.338-3.77 8.006 8.006 0 0110.213 4.878z"
    })),
    cloud: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M51.832 30.169A10.017 10.017 0 0042 22c-.436 0-.872.029-1.304.087a14.005 14.005 0 00-26.574 4.06A12 12 0 0016 50h34a10 10 0 001.832-19.831zM50 46H16a8 8 0 110-16h2v-2a10.001 10.001 0 0119.547-2.985l.608 1.951 1.938-.65A5.988 5.988 0 0148 32v2h2a6 6 0 010 12z",
        clipRule: "evenodd"
    })),
    coffee: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M49.519 41.333a7.26 7.26 0 001.448-14.373 10.783 10.783 0 00-1.344-.142l-1.142-.001v-.002a4.152 4.152 0 00-4.148-4.148h-31.11a4.152 4.152 0 00-4.149 4.148v8.296a18.678 18.678 0 004.755 12.445H10.11A3.115 3.115 0 007 50.666v1.038A8.306 8.306 0 0015.296 60H42.26a8.306 8.306 0 008.297-8.296v-1.037a3.115 3.115 0 00-3.111-3.111h-3.718a18.712 18.712 0 003.683-6.223h2.109zm-.046-10.37c.224.008.448.029.67.062a3.112 3.112 0 01-.624 6.16h-1.162c.08-.688.122-1.38.125-2.074v-4.148h.991zM42.26 55.852H15.296a4.152 4.152 0 01-4.148-4.148h35.26a4.152 4.152 0 01-4.149 4.148zm-21.985-8.296a14.532 14.532 0 01-7.052-12.445v-8.296h31.111v8.296a14.532 14.532 0 01-7.052 12.445H20.275zm.993-35.867a2.077 2.077 0 000-2.933L20.052 7.54a2.074 2.074 0 112.933-2.933L24.2 5.823a6.227 6.227 0 010 8.798l-.357.357a2.074 2.074 0 00-.327 2.508 2.075 2.075 0 01-3.585 2.089 6.227 6.227 0 01.98-7.53l.356-.357zm10.371 0a2.076 2.076 0 000-2.933L30.423 7.54a2.074 2.074 0 112.933-2.933l1.215 1.216a6.227 6.227 0 010 8.798l-.356.357a2.074 2.074 0 00-.329 2.507 2.074 2.074 0 11-3.585 2.087 6.225 6.225 0 01.98-7.527l.357-.357z",
        clipRule: "evenodd"
    })),
    company: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M42 6a8 8 0 018 8v44H36v-6a2 2 0 00-2-2h-4a2 2 0 00-2 2v6H14V14a8 8 0 018-8zm0 4H22a4 4 0 00-4 4v40h6v-2a6 6 0 015.775-5.996L30 46h4a6 6 0 016 6v2h6V14a4 4 0 00-4-4zM26 38v4h-4v-4h4zm8 0v4h-4v-4h4zm8 0v4h-4v-4h4zm-16-8v4h-4v-4h4zm8 0v4h-4v-4h4zm8 0v4h-4v-4h4zm-16-8v4h-4v-4h4zm8 0v4h-4v-4h4zm8 0v4h-4v-4h4zm-16-8v4h-4v-4h4zm8 0v4h-4v-4h4zm8 0v4h-4v-4h4z"
    })),
    compass: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M32 6a26 26 0 1026 26A26.029 26.029 0 0032 6zm2 47.905V50a2 2 0 00-4 0v3.905A22.033 22.033 0 0110.095 34H14a2 2 0 100-4h-3.905A22.033 22.033 0 0130 10.095V14a2 2 0 004 0v-3.905A22.033 22.033 0 0153.905 30H50a2 2 0 000 4h3.905A22.033 22.033 0 0134 53.905zm6.924-36.029l-13.28 5.312a8.045 8.045 0 00-4.456 4.457l-5.311 13.279a3.999 3.999 0 005.2 5.2l13.278-5.313a8.045 8.045 0 004.457-4.456l5.311-13.279a4 4 0 00-5.2-5.2h.001zm-3.825 16.993a4.021 4.021 0 01-2.23 2.229l-13.284 5.329.005-.017 5.31-13.28a4.02 4.02 0 012.23-2.228l13.278-5.312-5.309 13.279zM29 32a3 3 0 116 0 3 3 0 01-6 0z"
    })),
    "connected-building": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M46.34 25.745a4.15 4.15 0 00-5.866 0l-7.437 7.437V15.375a4.152 4.152 0 00-4.148-4.148H8.149A4.152 4.152 0 004 15.375v39.407a4.152 4.152 0 004.148 4.148h45.63a4.152 4.152 0 004.148-4.148V39.048a4.12 4.12 0 00-1.215-2.933l-10.37-10.37zM20.593 54.782h-4.149v-4.148h4.149v4.148zm8.296 0H24.74V48.56a2.074 2.074 0 00-2.074-2.074H14.37a2.074 2.074 0 00-2.074 2.074v6.222H8.148V15.375l20.74-.003v39.41zm24.889 0H33.037V39.048l10.37-10.37 10.37 10.37v15.734zM24.74 40.264a2.074 2.074 0 01-2.074 2.074H14.37a2.074 2.074 0 110-4.148h8.297c1.145 0 2.074.928 2.074 2.074zm0-8.297a2.074 2.074 0 01-2.074 2.074H14.37a2.074 2.074 0 110-4.148h8.297c1.145 0 2.074.929 2.074 2.074zm0-8.296a2.074 2.074 0 01-2.074 2.074H14.37a2.074 2.074 0 110-4.148h8.297c1.145 0 2.074.928 2.074 2.074zM39.259 38.19h8.297a2.074 2.074 0 010 4.148h-8.297a2.074 2.074 0 110-4.148zm10.37 10.37a2.074 2.074 0 01-2.073 2.074h-8.297a2.074 2.074 0 110-4.148h8.297c1.145 0 2.074.928 2.074 2.074zm8.888-29.123a2.07 2.07 0 01-2.58-1.397c-1.97-6.582-8.897-10.328-15.484-8.372a2.074 2.074 0 11-1.185-3.976c8.784-2.609 18.021 2.387 20.646 11.165a2.074 2.074 0 01-1.397 2.58zm-18.784-3.014a2.074 2.074 0 011.261-2.649 8.302 8.302 0 0110.591 5.058 2.074 2.074 0 11-3.911 1.381 4.154 4.154 0 00-5.292-2.53 2.074 2.074 0 01-2.649-1.26z",
        clipRule: "evenodd"
    })),
    connected: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M8 32C8 18.745 18.745 8 32 8s24 10.745 24 24c0 12.581-9.68 22.902-22 23.918V47h1.948a6.277 6.277 0 004.165-1.58A5.609 5.609 0 0042 41.222V31a2 2 0 100-4h-4v-6a2 2 0 10-4 0v6h-5v-6a2 2 0 10-4 0v6h-4a2 2 0 100 4v10.086A5.914 5.914 0 0026.914 47H30v11a2 2 0 002 2c15.464 0 28-12.536 28-28S47.464 4 32 4 4 16.536 4 32c0 10.805 6.121 20.178 15.076 24.845a2 2 0 001.848-3.547C13.24 49.292 8 41.257 8 32zm17-1v10.086A1.914 1.914 0 0026.914 43h9.034c.557 0 1.094-.204 1.51-.573.345-.306.542-.744.542-1.204V31H25z",
        clipRule: "evenodd"
    })),
    construction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M54 18a4.004 4.004 0 004-4v-4a4.004 4.004 0 00-4-4H14.83A3.973 3.973 0 0012 7.172l-5.707 5.707A3 3 0 008.414 18h3.587v6.35a5.997 5.997 0 107.196 8.651 2 2 0 10-3.463-2.002A2 2 0 1114 28a2 2 0 002-2v-8h18v36h-4a2 2 0 000 4h26a2 2 0 000-4h-4V18h2zm-6 36h-9.34l9.342-10.677V54zm-10-5.323V38h9.343L38 48.677zM48 34h-9.34l9.342-10.677V34zm-10-5.323V18h9.343L38 28.677zM10.83 14l4-4H54l.003 4H10.829z"
    })),
    contact: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M54 12a6 6 0 016 6v28a6 6 0 01-6 6H10a6 6 0 01-6-6V18a6 6 0 016-6h44zm0 4H10a2 2 0 00-1.995 1.85L8 18v28a2 2 0 001.85 1.995L10 48h44a2 2 0 001.995-1.85L56 46V18a2 2 0 00-2-2zm-29.5 4c3.945 0 7.143 3.168 7.143 7.077a6.932 6.932 0 01-1.067 3.698c3.74.758 6.425 4.02 6.424 7.802v.885C37 41.416 35.401 43 33.429 43H15.57C13.6 43 12 41.416 12 39.462v-.885c-.001-3.783 2.684-7.044 6.424-7.802a6.932 6.932 0 01-1.067-3.698c0-3.909 3.198-7.077 7.143-7.077zm3.712 13c-2.128 1.581-5.31 1.581-7.438 0-2.666.084-4.776 1.94-4.774 4.2v.6c0 .663.634 1.2 1.417 1.2h14.166c.783 0 1.417-.537 1.417-1.2v-.6c.002-2.265-2.117-4.122-4.788-4.2zM50 28a2 2 0 110 4H39a2 2 0 110-4h11zm-25.5-4a3.5 3.5 0 100 7 3.5 3.5 0 000-7zM50 21a2 2 0 110 4H39a2 2 0 110-4h11z"
    })),
    conversation: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M52.223 44.59a8.296 8.296 0 10-15.631 0 10.403 10.403 0 00-4.629 3.492 10.403 10.403 0 00-4.629-3.492 8.296 8.296 0 10-15.631 0A10.378 10.378 0 005 54.278a6.229 6.229 0 006.222 6.222h16.593a6.19 6.19 0 004.148-1.598 6.19 6.19 0 004.148 1.598h16.593a6.229 6.229 0 006.222-6.222 10.378 10.378 0 00-6.703-9.688zm-7.816-6.905a4.148 4.148 0 110 8.297 4.148 4.148 0 010-8.297zm-24.888 0a4.148 4.148 0 110 8.297 4.148 4.148 0 010-8.297zm8.296 18.667H11.222a2.076 2.076 0 01-2.074-2.074 6.23 6.23 0 015.03-6.105 8.265 8.265 0 0010.68 0 6.23 6.23 0 015.03 6.105 2.076 2.076 0 01-2.073 2.074zm24.889 0H36.11a2.076 2.076 0 01-2.074-2.074 6.23 6.23 0 015.03-6.105 8.265 8.265 0 0010.68 0 6.23 6.23 0 015.03 6.105 2.076 2.076 0 01-2.073 2.074zm0-47.704H37.822A6.227 6.227 0 0031.963 4.5h-20.74A6.229 6.229 0 005 10.722v8.296a6.23 6.23 0 006.222 6.223h5.363l5.92 5.918a3.11 3.11 0 005.31-2.2v-3.718h8.296v3.718a3.11 3.11 0 005.31 2.2l5.92-5.918h5.363a6.23 6.23 0 006.222-6.223V14.87a6.229 6.229 0 00-6.222-6.222zM23.667 21.093v5.363l-5.363-5.363h-7.082a2.076 2.076 0 01-2.074-2.075v-8.296a2.076 2.076 0 012.074-2.074h20.741c.553 0 1.082.221 1.47.614a6.224 6.224 0 00-3.544 5.608v4.149c.001.707.124 1.408.363 2.074h-6.585zm31.11-2.075a2.076 2.076 0 01-2.073 2.075h-7.082l-5.363 5.363v-5.363h-4.148a2.076 2.076 0 01-2.074-2.075V14.87a2.076 2.076 0 012.074-2.074h16.593a2.077 2.077 0 012.074 2.074v4.149z",
        clipRule: "evenodd"
    })),
    copy: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M49.333 58H25.5c-.575 0-1.126-.21-1.532-.586A1.925 1.925 0 0123.333 56V26c0-2.122.913-4.157 2.539-5.657C27.497 18.843 29.702 18 32 18h23.833c.575 0 1.126.21 1.532.586.407.375.635.884.635 1.414v30c0 2.122-.913 4.157-2.538 5.657-1.626 1.5-3.83 2.343-6.129 2.343zm-21.666-4h21.666c1.15 0 2.252-.421 3.064-1.172.813-.75 1.27-1.767 1.27-2.828V22H32c-1.15 0-2.252.421-3.064 1.172-.813.75-1.27 1.767-1.27 2.828v28z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M16.833 48H8.167c-.575 0-1.126-.21-1.532-.586A1.925 1.925 0 016 46V14c0-2.122.913-4.157 2.538-5.657C10.164 6.843 12.368 6 14.667 6H38.5c.575 0 1.126.21 1.532.586.407.375.635.884.635 1.414v4c0 .53-.228 1.04-.635 1.414A2.261 2.261 0 0138.5 14c-.574 0-1.126-.21-1.532-.586A1.925 1.925 0 0136.333 12v-2H14.668c-1.15 0-2.252.421-3.064 1.172-.813.75-1.27 1.767-1.27 2.828v30h6.5c.575 0 1.126.21 1.533.586.406.375.634.884.634 1.414 0 .53-.228 1.04-.634 1.414a2.262 2.262 0 01-1.533.586z"
    })),
    "core-router": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M38.642 18.243l-7.07-7.071-7.072 7.07a2 2 0 002.828 2.83l2.465-2.465V26a2 2 0 004 0v-6.95l2.02 2.021a2 2 0 102.83-2.828zm4.6 6.343l-7.07 7.07 7.07 7.072a2 2 0 002.829-2.829l-2.464-2.464H51a2 2 0 100-4h-6.95l2.02-2.021a2 2 0 00-2.828-2.828zm-4.6 21.171l-7.07 7.071-7.072-7.07a2 2 0 012.828-2.83l2.465 2.465V38a2 2 0 014 0v6.95l2.02-2.021a2 2 0 112.83 2.828zM20.758 24.586l7.07 7.07-7.07 7.072a2 2 0 01-2.829-2.829l2.464-2.464H13a2 2 0 110-4h6.95l-2.02-2.021a2 2 0 012.828-2.828z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 8C18.745 8 8 18.745 8 32s10.745 24 24 24 24-10.745 24-24S45.255 8 32 8zM4 32C4 16.536 16.536 4 32 4s28 12.536 28 28-12.536 28-28 28S4 47.464 4 32z",
        clipRule: "evenodd"
    })),
    "credit-card": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M12 12.19a8 8 0 00-8 8v22a8 8 0 008 8h40a8 8 0 008-8v-22a8 8 0 00-8-8H12zm-4 8a4 4 0 014-4h40a4 4 0 014 4v2H8v-2zm0 6v16a4 4 0 004 4h40a4 4 0 004-4v-16H8z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M12 33.19a2 2 0 012-2h18a2 2 0 110 4H14a2 2 0 01-2-2z",
        clipRule: "evenodd"
    })),
    "customer-dialogue": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M52 16.5a2 2 0 01-2 2H36a2 2 0 110-4h14a2 2 0 012 2zm-8 4h-8a2 2 0 100 4h8a2 2 0 100-4zm16-6v10a8.01 8.01 0 01-8 8h-1.172l-5.707 5.707A3 3 0 0140 36.086V32.5h-4a11.924 11.924 0 01-1.984 6.594A14.02 14.02 0 0144 52.5a6.007 6.007 0 01-6 6H10a6.007 6.007 0 01-6-6 14.02 14.02 0 019.985-13.406A11.956 11.956 0 0126 20.68V14.5a8.01 8.01 0 018-8h18a8.01 8.01 0 018 8zm-44 18a8 8 0 108-8 8.01 8.01 0 00-8 8zm14.572 10.029a11.94 11.94 0 01-13.143 0A10.004 10.004 0 008 52.499a2.003 2.003 0 002 2h28a2.003 2.003 0 002-2 10.004 10.004 0 00-9.428-9.97zM56 14.5a4.004 4.004 0 00-4-4H34a4.004 4.004 0 00-4 4v7.623a12.046 12.046 0 015.3 6.377H44v5.172l5.172-5.172H52a4.004 4.004 0 004-4v-10z",
        clipRule: "evenodd"
    })),
    "daas-device": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M33 52a2 2 0 11-4 0 2 2 0 014 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M23 4a8 8 0 00-8 8v40a8 8 0 008 8h16a8 8 0 008-8V37a2 2 0 10-4 0v7H19V12a4 4 0 014-4h16a4 4 0 014 4v3.5a2 2 0 104 0V12a8 8 0 00-8-8H23zm-4 44v4a4 4 0 004 4h16a4 4 0 004-4v-4H19z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M48.367 20.572a2 2 0 01.173 2.823L36.279 37.258a2 2 0 01-2.936.065l-6.641-6.866a2 2 0 112.875-2.78l5.138 5.311 10.828-12.243a2 2 0 012.824-.173z",
        clipRule: "evenodd"
    })),
    "data-transfer": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M13.373 10a1.994 1.994 0 00-1.518.68l-7.27 7.27a2 2 0 102.83 2.828l4.307-4.308V34a2 2 0 104 0V17.193l3.586 3.585a2 2 0 002.828-2.828l-7.27-7.27a1.994 1.994 0 00-1.493-.68zm15.349 19.53l-4.308-4.308a2 2 0 10-2.828 2.828l7.269 7.27a1.994 1.994 0 001.518.68 1.993 1.993 0 001.493-.68l7.27-7.27a2 2 0 10-2.828-2.828l-3.586 3.585V12a2 2 0 00-4 0v17.53zM45.74 47a2 2 0 104 0 2 2 0 00-4 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M56 11a4 4 0 014 4v36a4 4 0 01-4 4H40a4 4 0 01-4-4V35.692a2 2 0 114 0v3.616h15.461c.187 0 .368.025.539.073V15H40v4.23a2 2 0 01-4 0V15a4 4 0 014-4h16zm0 32.234a2.002 2.002 0 01-.539.074H40V51h16v-7.766z",
        clipRule: "evenodd"
    })),
    "delete-filled": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M55.414 15.414A2 2 0 0054 12H44V8a4.004 4.004 0 00-4-4H24a4.004 4.004 0 00-4 4v4H10a2 2 0 100 4h44a2 2 0 001.414-.586zM40 12H24V8h16v4zM12 50V22a2 2 0 012-2h36a2 2 0 012 2v28a8 8 0 01-8 8H20a8 8 0 01-8-8zm16-1V29a2 2 0 00-4 0v20a2 2 0 004 0zm12 0V29a2 2 0 00-4 0v20a2 2 0 004 0z",
        clipRule: "evenodd"
    })),
    "delete": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M52.63 22.667v29.037A8.306 8.306 0 0144.333 60H19.444a8.306 8.306 0 01-8.296-8.296V22.667a2.074 2.074 0 114.148 0v29.037a4.153 4.153 0 004.148 4.148h24.89a4.153 4.153 0 004.147-4.148V22.667a2.074 2.074 0 114.149 0zm4.148-8.297a2.074 2.074 0 01-2.074 2.074H9.074a2.074 2.074 0 110-4.148h10.37V8.148A4.153 4.153 0 0123.593 4h16.592a4.153 4.153 0 014.148 4.148v4.148h10.37c1.146 0 2.075.929 2.075 2.074zm-33.185-2.074h16.592V8.148H23.593v4.148zm4.148 35.26V26.815a2.074 2.074 0 10-4.148 0v20.74a2.074 2.074 0 004.148 0zm12.444 0V26.815a2.074 2.074 0 10-4.148 0v20.74a2.074 2.074 0 004.148 0z",
        clipRule: "evenodd"
    })),
    delivery: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M20.584 27.415l-4-4A2 2 0 0115.998 22v-6a2 2 0 014 0v5l.115.287 3.3 3.3a2 2 0 11-2.829 2.828zM60 37.817v8.184a4.004 4.004 0 01-4 4h-2.295a6.995 6.995 0 01-13.418-.029 1.967 1.967 0 01-.288.03H27.704a6.995 6.995 0 01-13.418-.03 1.966 1.966 0 01-.287.03h-2.134a3.939 3.939 0 01-3.867-4V31.78A13.988 13.988 0 1129.472 14h10.527a4.004 4.004 0 014 4v4h4.93a3.992 3.992 0 013.329 1.782l6.398 9.598A7.972 7.972 0 0160 37.817zm-42.002-5.816c5.523 0 10-4.478 10-10 0-5.524-4.477-10-10-10s-10 4.476-10 10c.006 5.52 4.48 9.993 10 10zm6 16a3 3 0 10-6 0 3 3 0 006 0zm16.001-30h-8.59A13.97 13.97 0 0112 34.63V46h2c.095.003.192.013.287.03A6.995 6.995 0 0127.704 46h12.295V18zm10 30a3 3 0 10-6 0 3 3 0 006 0zm6-10.184a3.986 3.986 0 00-.671-2.218L48.929 26h-4.93v15.685A6.976 6.976 0 0153.705 46h2.294v-8.184z",
        clipRule: "evenodd"
    })),
    desktop: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M52 12H12a8.01 8.01 0 00-8 8v20a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8V20a8.01 8.01 0 00-8-8zm4 28a4.005 4.005 0 01-4 4H12a4.004 4.004 0 01-4-4V20a4.004 4.004 0 014-4h40a4.005 4.005 0 014 4v20zM44 52a2 2 0 01-2 2H22a2 2 0 010-4h20a2 2 0 012 2z"
    })),
    devices: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M50 4H30a8.01 8.01 0 00-8 8v4h-8a8.01 8.01 0 00-8 8v28a8.01 8.01 0 008 8h10a8.007 8.007 0 007.737-6H50a8.01 8.01 0 008-8V12a8.01 8.01 0 00-8-8zM30 8h20a4.004 4.004 0 014 4v26H32V24a8.007 8.007 0 00-6-7.737V12a4.004 4.004 0 014-4zM14 20h10a4.004 4.004 0 014 4v20H10V24a4.004 4.004 0 014-4zm10 36H14a4.004 4.004 0 01-4-4v-4h18v4a4.004 4.004 0 01-4 4zm30-10a4.004 4.004 0 01-4 4H32v-8h22v4zm-16 0a2 2 0 114 0 2 2 0 01-4 0zm-17 6a2 2 0 11-4 0 2 2 0 014 0z",
        clipRule: "evenodd"
    })),
    dislike: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M9.175 41.578h8.351a4.147 4.147 0 002.942-1.228c6.027 2.112 11.372 8.068 13.287 15.002a6.288 6.288 0 005.39 4.604 6.123 6.123 0 006.167-3.253c.226-.423.428-.858.607-1.302a12.242 12.242 0 00.16-8.448l-2.637-7.462h9.575a6.27 6.27 0 006.263-6.264V31.14a6.265 6.265 0 00-2.895-5.279 6.22 6.22 0 00.807-3.072v-2.088a6.273 6.273 0 00-4.616-6.042 6.237 6.237 0 00.44-2.308v-2.088A6.27 6.27 0 0046.755 4H20.658a2.07 2.07 0 00-.522.074A2.07 2.07 0 0019.614 4H7.088A2.088 2.088 0 005 6.088v31.315a4.18 4.18 0 004.175 4.175zm39.666-31.315v2.088a2.09 2.09 0 01-2.087 2.087 2.088 2.088 0 000 4.176h4.175a2.09 2.09 0 012.088 2.087v2.088a2.09 2.09 0 01-2.088 2.088 2.088 2.088 0 000 4.175h2.088a2.09 2.09 0 012.087 2.088v2.087a2.09 2.09 0 01-2.087 2.088H40.49a1.97 1.97 0 00-.39.04c-.046.008-.09.023-.135.035-.057.015-.114.024-.17.044-.02.007-.035.018-.053.025-.072.03-.143.062-.211.1-.055.028-.11.055-.161.087-.058.039-.114.08-.168.125-.052.041-.105.08-.153.126s-.09.098-.134.148c-.043.051-.088.1-.126.154-.04.056-.072.117-.107.177-.031.056-.065.11-.091.169-.029.062-.049.127-.07.192a1.613 1.613 0 00-.06.194c-.015.06-.022.122-.03.184-.012.076-.02.153-.023.23 0 .02-.006.038-.006.058 0 .044.01.086.013.13.005.149.03.297.075.44.012.041.016.083.031.125l3.608 10.21a8.04 8.04 0 01-.084 5.532 9.086 9.086 0 01-.417.895 1.992 1.992 0 01-2.024 1.07 2.097 2.097 0 01-1.825-1.564C35.501 45.993 29.028 38.89 21.7 36.365V8.175h25.053a2.09 2.09 0 012.087 2.088zM9.175 8.176h8.351v29.171c0 .02-.006.037-.006.056H9.175V8.176z",
        clipRule: "evenodd"
    })),
    doc: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M50.828 16L40 5.172A3.973 3.973 0 0037.172 4H20a8.01 8.01 0 00-8 8v44a4.004 4.004 0 004 4h28a8.01 8.01 0 008-8V18.828A3.972 3.972 0 0050.828 16zm-5.656 0H40v-5.172L45.172 16zM44 56H16V12a4.004 4.004 0 014-4h16v8a4.004 4.004 0 004 4h8v32a4.004 4.004 0 01-4 4zm-2-20a2 2 0 01-2 2H24a2 2 0 110-4h16a2 2 0 012 2zm0-10a2 2 0 01-2 2H24a2 2 0 110-4h16a2 2 0 012 2zm0 20a2 2 0 01-2 2H24a2 2 0 110-4h16a2 2 0 012 2z",
        clipRule: "evenodd"
    })),
    "document-doc": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M52.223 53.549a2 2 0 10-3.846-1.099c-.426 1.491-.985 2.28-1.623 2.74-.655.474-1.68.81-3.454.81h-27v-3a2 2 0 10-4 0v3a4 4 0 004 4h27.046c2.208-.006 4.166-.423 5.75-1.567 1.612-1.164 2.553-2.875 3.127-4.884zM13.075 44c1.725 0 3.225-.375 4.55-1.1 2.625-1.45 4.2-4.25 4.2-7.925 0-1.525-.35-2.95-1.05-4.225-1.425-2.575-4.15-4.25-7.45-4.25H9.5c-1.225 0-2.5.825-2.5 1.625V42c0 .475.85 2 1.725 2h4.35zm-2.6-14.1H13.5c2.825 0 4.75 2.075 4.75 5.175 0 3.475-1.85 5.525-4.975 5.525h-2.8V29.9zm21.958 14.475c1.55 0 3-.4 4.375-1.175 2.7-1.575 4.575-4.55 4.575-7.95a8.948 8.948 0 00-1.15-4.45c-1.525-2.775-4.475-4.675-7.8-4.675-1.55 0-3 .4-4.35 1.175-2.725 1.575-4.6 4.55-4.6 7.95 0 1.575.375 3.075 1.15 4.45 1.525 2.775 4.475 4.675 7.8 4.675zm0-3.55c-.925 0-1.8-.25-2.6-.725a5.6 5.6 0 01-2.75-4.85c0-.975.225-1.875.7-2.725.9-1.7 2.65-2.85 4.65-2.85.925 0 1.8.225 2.625.7 1.6.95 2.725 2.775 2.725 4.875 0 .975-.225 1.875-.675 2.725-.925 1.7-2.675 2.85-4.675 2.85zM56.44 42.85c.574-.5.974-1.425.974-2.3 0-.575-.3-.875-.9-.875-.35 0-.8.125-1.375.375-1.075.475-2.15.725-3.25.725-.95 0-1.825-.225-2.6-.7-1.575-.9-2.6-2.675-2.6-4.8 0-1.025.225-1.95.675-2.8.875-1.675 2.6-2.75 4.7-2.75.95 0 1.925.25 2.95.775.225.125.425.175.6.175.775 0 1.575-1.275 1.575-2.5 0-.35-.125-.6-.375-.75-1.375-.875-2.95-1.3-4.675-1.3-1.575 0-3.075.4-4.45 1.2a9.329 9.329 0 00-4.65 8.1c0 1.575.375 3.05 1.1 4.4 1.45 2.725 4.225 4.55 7.5 4.55 1.775 0 3.725-.625 4.8-1.525zm-4.726-26.264L40.3 5.172A3.974 3.974 0 0037.472 4H20.3a8.009 8.009 0 00-8 8v6a2 2 0 104 0v-6a4 4 0 014-4h16v8a4 4 0 004 4h10a2 2 0 001.414-3.414zM40.3 10.828L45.472 16H40.3v-5.172z"
    })),
    "document-edit": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M48.116 27.037a4 4 0 015.657.007l4.235 4.245A4 4 0 0158 36.946L45.685 49.23a4 4 0 01-2.044 1.092l-5.303 1.054c-2.8.557-5.265-1.915-4.702-4.713l1.068-5.3a4 4 0 011.097-2.042l12.315-12.284zm7.06 7.077L50.94 29.87 38.625 42.153l-1.067 5.3 5.302-1.055 12.316-12.284z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M8 12a8 8 0 018-8h28a4 4 0 014 4v15a2 2 0 11-4 0V8H16a4 4 0 00-4 4v44h27.801a4 4 0 003.406-1.903l.09-.146a2 2 0 113.406 2.098l-.09.146A8 8 0 0139.801 60H12a4 4 0 01-4-4V12z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M16 20a2 2 0 012-2h20a2 2 0 110 4H18a2 2 0 01-2-2zm0 8a2 2 0 012-2h20a2 2 0 110 4H18a2 2 0 01-2-2zm0 8a2 2 0 012-2h12a2 2 0 110 4H18a2 2 0 01-2-2z",
        clipRule: "evenodd"
    })),
    "document-pdf": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M12.387 39.02v3.864a3.786 3.786 0 01-.616 2.1 1.693 1.693 0 01-1.344.953c-.486 0-.972-.364-1.456-1.092a2.664 2.664 0 01-.477-1.145V27.988a1.574 1.574 0 01.883-1.246 3.452 3.452 0 011.918-.574h4.592a6.73 6.73 0 013.416.854 5.911 5.911 0 012.282 2.31 6.715 6.715 0 01.8 3.276 5.614 5.614 0 01-.6 2.548 6.918 6.918 0 01-1.567 2.072 7.157 7.157 0 01-2.114 1.33 6.255 6.255 0 01-2.353.462h-3.364zm3.387-3.64a2.766 2.766 0 002.017-.8 2.659 2.659 0 00.812-1.974 2.701 2.701 0 00-.8-2.016 2.783 2.783 0 00-2.031-.784h-3.385v5.574h3.387zm10.92 10.388c-.485 0-.97-.364-1.456-1.092a2.5 2.5 0 01-.476-1.149V27.988a1.574 1.574 0 01.883-1.246 3.448 3.448 0 011.918-.574h4.283c1.74-.03 3.455.42 4.957 1.3a9.094 9.094 0 013.374 3.458 9.632 9.632 0 011.189 4.732 11.095 11.095 0 01-1.246 5.376 8.591 8.591 0 01-3.458 3.514 10.393 10.393 0 01-5.1 1.218l-4.868.002zm5.1-3.808a5.232 5.232 0 004.1-1.638 6.577 6.577 0 001.469-4.551 5.958 5.958 0 00-1.47-4.2 4.992 4.992 0 00-3.85-1.6h-3.39V41.96h3.14zm16.292-4.145v5.069a3.777 3.777 0 01-.616 2.1 1.691 1.691 0 01-1.344.953c-.485 0-.97-.364-1.456-1.092a2.505 2.505 0 01-.476-1.148V27.988a1.572 1.572 0 01.882-1.246 3.454 3.454 0 011.918-.574h9.044c.691 0 1.036.327 1.036.98 0 .499-.1.993-.294 1.452-.16.413-.408.786-.728 1.092-.225.233-.53.373-.854.392h-7.112v4.088h6.188c.653 0 .98.308.98.924a3.369 3.369 0 01-.546 1.876 1.51 1.51 0 01-1.218.839l-5.404.004zM44 60H16a4 4 0 01-4-4v-3a2 2 0 114 0v3h28a3.98 3.98 0 003.937-3.332 2.002 2.002 0 013.946.664A7.973 7.973 0 0144 60zm7.414-43.414L40 5.172A3.974 3.974 0 0037.172 4H20a8.009 8.009 0 00-8 8v6a2 2 0 004 0v-6a4 4 0 014-4h16v8a4 4 0 004 4h10a2 2 0 001.414-3.414zM40 10.828L45.172 16H40v-5.172z"
    })),
    "document-ppt": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M51.924 53.55a2 2 0 00-3.846-1.099c-.427 1.491-.985 2.28-1.623 2.74-.65.47-1.665.804-3.412.81L43.001 56H16v-3a2 2 0 10-4 0v3a4 4 0 004 4h27c2.226 0 4.2-.414 5.796-1.566 1.611-1.164 2.553-2.875 3.127-4.884zM16.483 39.011c1.654 0 3.306-.667 4.64-1.856 1.334-1.189 2.233-2.929 2.233-4.785 0-1.247-.26-2.378-.812-3.393-1.102-2-3.247-3.277-5.916-3.277h-4.755c-1.421 0-2.9.957-2.9 1.885v16.27c0 .492.985 2.32 2 2.32 1.015 0 2.03-1.567 2.03-3.162v-4.002h3.48zm-3.48-9.54h3.51c1.71 0 2.928 1.188 2.928 2.9 0 1.623-1.275 2.87-2.928 2.87h-3.51v-5.77zm20.331 9.54c1.653 0 3.306-.667 4.64-1.856 1.334-1.189 2.233-2.929 2.233-4.785 0-1.247-.26-2.378-.812-3.393-1.102-2-3.248-3.277-5.916-3.277h-4.756c-1.42 0-2.9.957-2.9 1.885v16.27c0 .492.986 2.32 2.001 2.32s2.03-1.567 2.03-3.162v-4.002h3.48zm-3.48-9.54h3.51c1.71 0 2.928 1.188 2.928 2.9 0 1.623-1.276 2.87-2.929 2.87h-3.509v-5.77zm17.17 14.383c0 .551.986 2.32 2 2.32 1.016 0 2.03-1.566 2.03-3.16v-13.11h3.858c1.015 0 2.03-1.566 2.03-3.16 0-.697-.377-1.045-1.131-1.045H43.95c-1.421 0-2.9.957-2.9 1.885 0 .551.986 2.32 2 2.32h3.974v13.95zm4.39-27.268L40.001 5.172A3.974 3.974 0 0037.172 4H20a8.009 8.009 0 00-8 8v6a2 2 0 104 0v-6a4 4 0 014-4h16v8a4 4 0 004 4h10a2 2 0 001.414-3.414zm-11.413-5.758L45.172 16H40v-5.172z"
    })),
    "document-xls": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M50 4H18a8 8 0 00-8 8v44a4 4 0 004 4h32a8 8 0 008-8V8a4 4 0 00-4-4zm0 48a4 4 0 01-4 4H14V12a4 4 0 014-4h32v44zM38.96 40.42c.804 0 1.608.252 2.232.684.12.084.18.192.18.348 0 .576-.36 1.14-.732 1.14a.49.49 0 01-.214-.06l-.086-.048c-.528-.312-1.008-.468-1.44-.468-.684 0-1.176.3-1.176.732 0 .295.119.47.52.68l.128.064c.22.116.57.259 1.047.445l.213.083c1.536.576 2.22 1.38 2.22 2.628 0 .972-.588 1.788-1.488 2.208a3.419 3.419 0 01-1.488.324c-.816 0-1.668-.312-2.292-.768-.312-.228-.552-.48-.708-.756-.096-.156-.144-.288-.144-.384 0-.348.552-.708 1.092-.708a.46.46 0 01.348.132c.54.612 1.044.852 1.704.852.78 0 1.296-.348 1.296-.888 0-.276-.12-.516-.36-.708-.24-.192-.672-.408-1.308-.636-1.776-.66-2.46-1.344-2.46-2.532 0-.9.6-1.668 1.476-2.064.444-.204.924-.3 1.44-.3zm-10.56.108c.348 0 .516.156.516.468 0 .408-.144.804-.42 1.176l-1.788 2.4 2.232 2.892a.518.518 0 01.108.312c0 .66-.408 1.296-.828 1.296-.18 0-.348-.096-.504-.3l-2.172-2.94-1.932 2.784c-.216.3-.432.456-.648.456-.432 0-.912-.792-.912-1.068 0-.108.036-.204.108-.3l2.388-3.18-2.052-2.676c-.168-.228-.252-.42-.252-.564 0-.372.6-.756 1.188-.756.18 0 .324.06.42.192l1.848 2.532 1.464-2.148c.228-.324.756-.576 1.236-.576zm2.94 0c.312 0 .468.144.468.432v6.36h3.12c.3 0 .444.144.444.42 0 .432-.192.864-.432 1.092-.132.108-.252.168-.372.168h-3.6c-.42 0-.828-.732-.828-.96v-6.732c0-.384.612-.78 1.2-.78zM25 26a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1zm8 0a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1zm8 0a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1zm-16-8a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1zm8 0a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1zm8 0a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2a1 1 0 011-1z"
    })),
    document: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M50 4a4 4 0 014 4v44a8 8 0 01-8 8H14a4 4 0 01-4-4V12a8 8 0 018-8zm0 4H18a4 4 0 00-4 4v44h32a4 4 0 004-4V8zm-8 18a2 2 0 110 4H30a2 2 0 110-4zm-20 0a2 2 0 110 4 2 2 0 010-4zm20-8a2 2 0 110 4H30a2 2 0 110-4zm-20 0a2 2 0 110 4 2 2 0 010-4z"
    })),
    download: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M60 29.692v19.385a8.625 8.625 0 01-8.615 8.615h-38.77A8.625 8.625 0 014 49.077V29.692a2.154 2.154 0 014.308 0v19.385a4.313 4.313 0 004.307 4.308h38.77a4.313 4.313 0 004.307-4.308V29.692a2.154 2.154 0 014.308 0zM29.716 43.377a3.233 3.233 0 004.568 0l12.162-12.162A2.154 2.154 0 0043.4 28.17l-9.246 9.247V8.154a2.154 2.154 0 10-4.308 0v29.262L20.6 28.17a2.154 2.154 0 10-3.046 3.045l12.162 12.162z",
        clipRule: "evenodd"
    })),
    drone: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M54 18h-2v-4h6a2 2 0 000-4H42a2 2 0 000 4h6v4h-8.764l-.894-1.79A3.98 3.98 0 0034.764 14h-5.528a3.979 3.979 0 00-3.578 2.21L24.764 18H16v-4h6a2 2 0 000-4H6a2 2 0 100 4h6v4h-2a6.007 6.007 0 00-6 6v2a6.007 6.007 0 006 6h12.832a10.004 10.004 0 0018.334.002l.001-.002H54a6.007 6.007 0 006-6v-2a6.007 6.007 0 00-6-6zm2 8a2.003 2.003 0 01-2 2H40.485a2.975 2.975 0 00-2.816 1.973c-.05.143-.106.285-.166.423l-.002.003a6.003 6.003 0 01-11.168-.421A2.98 2.98 0 0023.509 28H10a2.003 2.003 0 01-2-2v-2a2.003 2.003 0 012-2h15.382a2.98 2.98 0 002.683-1.658L29.236 18h5.528l1.17 2.34A2.982 2.982 0 0038.618 22H54a2.003 2.003 0 012 2v2zM25.249 44.69a2 2 0 111.502-3.707 14.116 14.116 0 0010.498 0 2.001 2.001 0 111.502 3.707 18.056 18.056 0 01-13.502 0zm20.482 3.098a1.999 1.999 0 01-.73 2.733 26.029 26.029 0 01-26.002 0 1.999 1.999 0 112.002-3.463 22.03 22.03 0 0021.998 0 1.998 1.998 0 012.732.73z"
    })),
    "dsl-hub": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M48 8H16a8.01 8.01 0 00-8 8v32a8.01 8.01 0 008 8h32a8.01 8.01 0 008-8V16a8.01 8.01 0 00-8-8zm4 40a4.004 4.004 0 01-4 4H16a4.004 4.004 0 01-4-4V16a4.004 4.004 0 014-4h32a4.004 4.004 0 014 4v32zm-8-32H20a4.004 4.004 0 00-4 4v16a4.004 4.004 0 004 4h2v4a4.004 4.004 0 004 4h12a4.004 4.004 0 004-4v-4h2a4.004 4.004 0 004-4V20a4.004 4.004 0 00-4-4zm0 20h-2a4.004 4.004 0 00-4 4v4H26v-4a4.004 4.004 0 00-4-4h-2V20h6v4a2 2 0 004 0v-4h4v4a2 2 0 004 0v-4h6v16z"
    })),
    edit: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M56.752 15.64L47.58 6.466a4.094 4.094 0 00-5.656 0L12.005 36.385a6.027 6.027 0 00-1.45 2.345L5.488 53.937a3.003 3.003 0 003.795 3.795l15.206-5.069a6.027 6.027 0 002.346-1.45l29.918-29.918a4 4 0 000-5.656zM13.625 42.17l7.424 7.423-11.134 3.71 3.71-11.134zm11.127 5.47l-9.172-9.173 23.172-23.172 9.172 9.172L24.752 47.64zm26-26l-9.172-9.173 3.172-3.172 9.174 9.17-3.174 3.174z"
    })),
    education: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M17 4a8 8 0 00-8 8v40a8 8 0 008 8h36.5a2 2 0 100-4h-36a4 4 0 010-8h36a2 2 0 002-2V8a4 4 0 00-4-4H17zm34.5 40V8h-29v36h29zm-33-36H17a4 4 0 00-4 4v33.385A7.962 7.962 0 0117.5 44h1V8z",
        clipRule: "evenodd"
    })),
    efficiency: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M25.207 19a2 2 0 012 2v5.392l-1.413.434c-2.02.62-3.828 1.73-5.284 3.195l-1.158 1.164-1.336-.888-3.354-1.852-2.253 4.07 3.281 1.812 1.693.441-.346 1.835a12.774 12.774 0 00.09 5.176l.505 2.235-2.083.18-3.209 1.773 2.253 4.07 3.179-1.756 1.186-1.848 1.755 1.689a12.715 12.715 0 005.081 2.995l1.413.434V56h4.66v-4.45l1.413-.433a12.707 12.707 0 004.81-2.741l1.059-.962 4.259 2.353 2.253-4.07-4.109-2.27.356-1.48a12.774 12.774 0 00.098-5.507l-.291-1.438 4.841-2.675a2 2 0 111.934 3.502l-2.334 1.29a16.845 16.845 0 01-.068 4.244l2.333 1.29a3.056 3.056 0 011.197 4.155l-3.167 5.72a3.059 3.059 0 01-4.155 1.194l-2.635-1.455a16.703 16.703 0 01-3.794 2.17v2.506A3.058 3.058 0 0132.808 60h-6.542a3.058 3.058 0 01-3.059-3.057v-2.507a16.711 16.711 0 01-4.037-2.358l-3.466 1.915a3.059 3.059 0 01-4.155-1.196L8.383 47.08a3.056 3.056 0 011.197-4.157l3.366-1.86a16.842 16.842 0 01-.052-3.71L9.649 35.56a3.056 3.056 0 01-1.197-4.156l3.166-5.719a3.06 3.06 0 014.156-1.195l3.03 1.674a16.721 16.721 0 014.403-2.657V21a2 2 0 012-2z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M30 35a4 4 0 100 8 4 4 0 000-8zm-8 4a8 8 0 1116 0 8 8 0 01-16 0zM42.5 8a9.5 9.5 0 100 19 9.5 9.5 0 000-19zM29 17.5C29 10.044 35.045 4 42.5 4 49.956 4 56 10.044 56 17.5S49.956 31 42.5 31C35.045 31 29 24.956 29 17.5z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M43 10a2 2 0 012 2v6.828l-3.585 3.586a2 2 0 11-2.829-2.828L41 17.172V12a2 2 0 012-2z",
        clipRule: "evenodd"
    })),
    email: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M52 12H12a8.01 8.01 0 00-8 8v24a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8V20a8.01 8.01 0 00-8-8zm0 4c.346.005.69.055 1.023.15L39.172 30H24.828l-13.85-13.85A3.95 3.95 0 0112 16h40zm4 28a4.004 4.004 0 01-4 4H12a4.004 4.004 0 01-4-4V20a3.95 3.95 0 01.15-1.023L22 32.828A3.973 3.973 0 0024.828 34h14.344A3.973 3.973 0 0042 32.828l13.85-13.85c.095.332.145.676.15 1.022v24z",
        clipRule: "evenodd"
    })),
    "end-user": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M45.613 30.907a16 16 0 10-27.226 0A18.03 18.03 0 004 48.543v2a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8v-2a18.03 18.03 0 00-14.387-17.636zM32 10.543c6.627 0 12 5.372 12 12 0 6.627-5.373 12-12 12s-12-5.373-12-12c.007-6.625 5.376-11.993 12-12zm24 40a4.004 4.004 0 01-4 4H12a4.004 4.004 0 01-4-4v-2c.012-7.523 5.964-13.692 13.481-13.974a15.908 15.908 0 0021.038 0c7.517.282 13.47 6.451 13.481 13.974v2z",
        clipRule: "evenodd"
    })),
    entertainment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M45.133 32.589l-14 3.111A3.975 3.975 0 0028 39.604v7.343A8.823 8.823 0 0024 46c-4.411 0-8 3.14-8 7s3.589 7 8 7 8-3.14 8-7a6.157 6.157 0 00-.037-.635A1.94 1.94 0 0032 52V39.605l14-3.112v8.454A8.823 8.823 0 0042 44c-4.411 0-8 3.14-8 7s3.589 7 8 7 8-3.14 8-7a6.157 6.157 0 00-.037-.635A1.94 1.94 0 0050 50V36.493a4 4 0 00-4.867-3.904zM24 56c-2.168 0-4-1.374-4-3s1.832-3 4-3 4 1.374 4 3-1.832 3-4 3zm18-2c-2.168 0-4-1.374-4-3s1.832-3 4-3 4 1.374 4 3-1.832 3-4 3zm14-30H26.198l28.234-5.646a4 4 0 003.136-4.707l-1.137-5.692a4 4 0 00-4.707-3.139L7.216 13.718A4.01 4.01 0 004 17.64V50a4.004 4.004 0 004 4h4a2 2 0 000-4H8V28h48v22h-2a2 2 0 000 4h2a4.004 4.004 0 004-4V28a4.004 4.004 0 00-4-4zM45.94 10.485a1.99 1.99 0 00.056-.444l6.512-1.303 1.139 5.694-9.15 1.83 1.443-5.777zm-12 2c.003-.011.003-.023.005-.034l7.769-1.554-1.558 6.233-7.765 1.553 1.55-6.198zm-17.88 9.03a1.988 1.988 0 00-.056.445L8 23.56v-5.92l9.503-1.901-1.443 5.776zm5.784-6.644l7.765-1.553-1.55 6.197c-.002.011-.002.023-.005.035l-7.768 1.553 1.558-6.232z"
    })),
    environment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M51.999 8h-20a24.093 24.093 0 00-17.492 7.566 23.982 23.982 0 00-.702 32.075A17.256 17.256 0 009.999 58a2 2 0 004 0 13.06 13.06 0 012.67-7.533A23.864 23.864 0 0032.019 56a23.77 23.77 0 0016.413-6.509A24.092 24.092 0 0056 32V12a4.004 4.004 0 00-4-4zm0 24a19.996 19.996 0 01-32.656 15.484L22.827 44h13.172a2 2 0 000-4h-9.172l6-6h9.172a2 2 0 000-4h-5.172l6.586-6.586a2 2 0 10-2.828-2.828l-6.586 6.586V22a2 2 0 00-4 0v9.172l-6 6V28a2 2 0 00-4 0v13.172l-3.484 3.484A19.997 19.997 0 0131.999 12h20v20z"
    })),
    "error-filled": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M58.8 43.884L39.397 11.547a7.998 7.998 0 00-13.72-.001L6.275 43.884A8 8 0 0013.134 56H51.94a8 8 0 006.86-12.116zm-28.263-6.907v-11.82a4 4 0 01.316-1.564c.171-.443.438-.844.782-1.172.242-.25.57-.4.918-.421.501 0 1.002.38 1.503 1.142.272.335.44.743.481 1.173v11.82c0 .44-.306.862-.918 1.263-.581.392-1.267.6-1.968.601-.742 0-1.113-.34-1.114-1.022zm4.242 6.947a2.825 2.825 0 00-.572-1.354c-.561-.823-1.103-1.234-1.625-1.234a1.587 1.587 0 00-1.068.482 3.63 3.63 0 00-.872 1.309 4.446 4.446 0 00-.347 1.73c0 .762.422 1.143 1.264 1.143.781 0 1.545-.23 2.196-.662.683-.442 1.024-.914 1.024-1.414z",
        clipRule: "evenodd"
    })),
    error: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M38.858 11.547l19.404 32.337A8 8 0 0151.402 56H12.596a8 8 0 01-6.86-12.116L25.14 11.546a7.998 7.998 0 0113.718.001zM51.402 52a3.955 3.955 0 003.48-2.029 3.953 3.953 0 00-.05-4.028L35.43 13.605a3.998 3.998 0 00-6.86-.001L9.166 45.943A4 4 0 0012.596 52h38.806zM30 36.978v-11.82c0-.538.107-1.07.316-1.565.171-.443.438-.843.782-1.172.242-.25.57-.4.917-.42.502 0 1.003.38 1.504 1.14.272.337.44.745.481 1.174v11.82c0 .441-.306.862-.918 1.264-.582.391-1.267.6-1.968.6-.742 0-1.113-.34-1.114-1.021zm4.242 6.946a2.825 2.825 0 00-.572-1.354c-.561-.823-1.103-1.234-1.625-1.234a1.587 1.587 0 00-1.068.482 3.63 3.63 0 00-.872 1.309 4.444 4.444 0 00-.347 1.73c0 .762.421 1.143 1.264 1.143.781 0 1.545-.23 2.196-.662.683-.442 1.024-.913 1.024-1.414z",
        clipRule: "evenodd"
    })),
    "esim-simcard": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M46 6H18a8.01 8.01 0 00-8 8v36a8.01 8.01 0 008 8h28a8.01 8.01 0 008-8V14a8.01 8.01 0 00-8-8zm4 44a4.005 4.005 0 01-4 4h-4v-2a2 2 0 00-4 0v2h-4v-2a2 2 0 00-4 0v2h-4v-2a2 2 0 00-4 0v2h-4a4.005 4.005 0 01-4-4V14a4.005 4.005 0 014-4h4v2a2 2 0 004 0v-2h4v2a2 2 0 004 0v-2h4v2a2 2 0 004 0v-2h4a4.005 4.005 0 014 4v36zm-8-32H28.028a3.972 3.972 0 00-2.828 1.172L19.172 25.2A3.972 3.972 0 0018 28.028V42a4.005 4.005 0 004 4h20a4.005 4.005 0 004-4V22a4.005 4.005 0 00-4-4zm0 24H22V28.028L28.028 22H42v20z"
    })),
    esim: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M12.963 41.545a7.567 7.567 0 001.992-.877 2.14 2.14 0 00.78-.944c.2-.423.303-.884.303-1.352 0-.52-.281-.78-.844-.782a3.026 3.026 0 00-1.373.378 6.395 6.395 0 01-2.772.809 3.676 3.676 0 01-2.35-.77 3.502 3.502 0 01-1.268-2.036h8.079a1.2 1.2 0 00.965-.69 2.844 2.844 0 00.436-1.552 6.316 6.316 0 00-.767-3.078 5.87 5.87 0 00-2.18-2.255 6.04 6.04 0 00-3.18-.85 6.486 6.486 0 00-3.353.903 6.883 6.883 0 00-2.482 2.567 7.33 7.33 0 00-.95 3.71 7.255 7.255 0 003.313 6.103 6.203 6.203 0 003.473 1.026 7.98 7.98 0 002.178-.31zM8.539 31.257a3.295 3.295 0 012.166-.742 2.913 2.913 0 012.059.784 2.714 2.714 0 01.898 1.942H7.43a3.187 3.187 0 011.108-1.984zm19.169 4.929a1.986 1.986 0 00-.79-1.593 10.969 10.969 0 00-2.88-1.43 11.413 11.413 0 01-4.17-2.404 4.57 4.57 0 01-1.243-3.294 4.522 4.522 0 01.899-2.74 5.955 5.955 0 012.35-1.905 7.443 7.443 0 013.168-.675 8.65 8.65 0 012.602.404 8.341 8.341 0 012.31 1.134.89.89 0 01.395.785 3.265 3.265 0 01-.5 1.768 1.386 1.386 0 01-1.11.796 1.368 1.368 0 01-.661-.242 6.245 6.245 0 00-3.168-1.055 3.44 3.44 0 00-1.863.46 1.37 1.37 0 00-.724 1.188c-.012.327.09.647.29.906.318.332.7.598 1.122.782.555.28 1.483.67 2.785 1.173a8.823 8.823 0 013.71 2.391 5.345 5.345 0 011.176 3.525 5.115 5.115 0 01-.898 2.955 5.956 5.956 0 01-2.39 2.026 7.448 7.448 0 01-3.261.714 7.938 7.938 0 01-2.68-.472 8.817 8.817 0 01-2.363-1.242 5.53 5.53 0 01-1.558-1.714 1.88 1.88 0 01-.316-.863 1.37 1.37 0 01.752-1.095 2.91 2.91 0 011.65-.498.97.97 0 01.765.296 6.094 6.094 0 001.784 1.47 4.28 4.28 0 001.966.446 3.576 3.576 0 002.073-.54 1.687 1.687 0 00.778-1.457zm8.66-13.797c.686 0 1.03.324 1.03.971v15.31a3.716 3.716 0 01-.582 2.026 1.59 1.59 0 01-1.267.918c-.458 0-.916-.351-1.373-1.054a2.431 2.431 0 01-.447-1.106v-15.31a1.516 1.516 0 01.83-1.2 3.194 3.194 0 011.808-.554v-.001zm23.63.945V38.75a3.66 3.66 0 01-.276 1.404c-.153.4-.387.764-.688 1.068a1.218 1.218 0 01-.831.391c-.422 0-.87-.342-1.346-1.026a2.137 2.137 0 01-.423-1.08v-11.72l-3.908 8.318c-.387.793-.854 1.19-1.4 1.188h-.923a1.854 1.854 0 01-1.373-.892 3.441 3.441 0 01-.421-.7l-3.857-7.913V38.75c0 .482-.093.959-.277 1.404-.152.4-.386.764-.686 1.068a1.218 1.218 0 01-.831.391c-.476 0-.925-.342-1.348-1.026a2.13 2.13 0 01-.42-1.08V24.09a1.471 1.471 0 01.803-1.163 3.107 3.107 0 011.758-.538H45a.958.958 0 01.978.538l4.699 9.884 4.119-9.073a2.17 2.17 0 01.99-.958 3.15 3.15 0 011.52-.391h1.689c.268-.016.532.07.739.242a.91.91 0 01.264.703zM9.999 22v-8a8.01 8.01 0 018-8h28a8.01 8.01 0 018 8v4a2 2 0 01-4 0v-4a4.005 4.005 0 00-4-4h-28a4.004 4.004 0 00-4 4v8a2 2 0 01-4 0zm44 22v6a8.01 8.01 0 01-8 8h-28a8.01 8.01 0 01-8-8v-4a2 2 0 014 0v4a4.004 4.004 0 004 4h28a4.004 4.004 0 004-4v-6a2 2 0 014 0z"
    })),
    euro: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M28.207 39.889c2.206 5.013 5.909 7.518 11.104 7.518 1.516 0 3.631-.402 6.345-1.207 1.655-.493 2.873-.74 3.655-.74 1.609 0 2.413.716 2.413 2.148a8.018 8.018 0 01-.862 3.66c-.575 1.14-1.344 2.002-2.31 2.584-1.103.625-2.552 1.14-4.345 1.542A25.317 25.317 0 0138.62 56c-5.102 0-9.482-1.421-13.138-4.263-3.655-2.842-6.218-6.791-7.689-11.848h-2.689c-.322 0-.655-.121-1-.368-.346-.246-.793-.683-1.346-1.309-.505-.627-.758-1.254-.758-1.879 0-.673.482-1.31 1.449-1.914.964-.604 1.975-.906 3.033-.906h.414c-.045-.269-.07-.917-.07-1.947 0-1.164.025-1.901.07-2.215h-.827c-.322 0-.656-.123-1-.37-.345-.244-.793-.681-1.345-1.308-.506-.625-.76-1.252-.76-1.88 0-.67.485-1.308 1.45-1.912.966-.605 1.977-.906 3.035-.906h.964c1.794-4.923 4.61-8.816 8.45-11.68C30.702 8.433 35.01 7 39.792 7c4.047 0 7.77 1.051 11.171 3.153.692.448 1.036 1.052 1.036 1.813a7.286 7.286 0 01-.656 3.054c-.435.962-.964 1.724-1.586 2.282-.62.56-1.251.839-1.896.839-.369 0-.804-.134-1.31-.402-2.574-1.432-4.92-2.148-7.034-2.148-4.92 0-8.622 2.461-11.105 7.384h16.691c1.15 0 1.723.515 1.723 1.544 0 1.164-.334 2.258-1 3.288-.667 1.03-1.367 1.544-2.103 1.544H26.551c-.044.314-.069 1.051-.069 2.215 0 1.03.025 1.678.07 1.947h16.137c1.151 0 1.724.514 1.724 1.544 0 1.163-.333 2.26-1 3.29-.666 1.03-1.366 1.542-2.102 1.542H28.207z",
        clipRule: "evenodd"
    })),
    excel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M16.799 39.71l-4.508 6.5c-.504.709-1.008 1.063-1.512 1.063s-1.037-.4-1.6-1.2a2.613 2.613 0 01-.533-1.288 1.15 1.15 0 01.252-.7l5.573-7.42-4.787-6.252a2.49 2.49 0 01-.585-1.316c0-.428.289-.828.867-1.2a3.446 3.446 0 011.9-.56 1.152 1.152 0 01.98.448l4.312 5.908 3.416-5.012a3.033 3.033 0 011.218-.952 3.857 3.857 0 011.667-.396c.8 0 1.2.364 1.2 1.092a4.533 4.533 0 01-.98 2.744l-4.171 5.6 5.208 6.748c.162.208.251.464.252.728.009.74-.2 1.466-.6 2.088a1.66 1.66 0 01-1.33.938 1.493 1.493 0 01-1.175-.7l-5.064-6.862zM29.45 47.1c-.486 0-.97-.364-1.456-1.092a2.501 2.501 0 01-.476-1.149V29.153a1.573 1.573 0 01.882-1.246 3.451 3.451 0 011.918-.574c.728 0 1.092.336 1.092 1.008v14.84h7.28c.691 0 1.037.327 1.037.98 0 .5-.1.995-.294 1.456a3.04 3.04 0 01-.73 1.092 1.29 1.29 0 01-.852.392H29.45zm25.676-5.488a5.211 5.211 0 01-.952 3.066 6.3 6.3 0 01-2.534 2.1 8.065 8.065 0 01-3.457.742 8.674 8.674 0 01-2.843-.49 9.51 9.51 0 01-2.506-1.288 5.784 5.784 0 01-1.651-1.778 1.908 1.908 0 01-.337-.9 1.423 1.423 0 01.8-1.133 3.154 3.154 0 011.75-.518 1.044 1.044 0 01.812.308 6.453 6.453 0 001.89 1.526 4.65 4.65 0 002.087.462 3.848 3.848 0 002.2-.56 1.738 1.738 0 00.826-1.512 2.042 2.042 0 00-.84-1.652 11.796 11.796 0 00-3.052-1.484 12.173 12.173 0 01-4.424-2.492 4.918 4.918 0 01-.364-6.258 6.3 6.3 0 012.493-1.974 8.024 8.024 0 013.359-.7 9.28 9.28 0 012.758.42 8.901 8.901 0 012.45 1.176.916.916 0 01.42.812 3.329 3.329 0 01-.531 1.834 1.468 1.468 0 01-1.177.826 1.453 1.453 0 01-.7-.252 6.737 6.737 0 00-3.36-1.092 3.706 3.706 0 00-1.974.476 1.414 1.414 0 00-.77 1.232c-.011.34.098.672.308.938a3.65 3.65 0 001.19.812c.588.29 1.573.696 2.954 1.217a9.363 9.363 0 013.934 2.48 5.452 5.452 0 011.24 3.656zm-11.128 19.72h-28a4 4 0 01-4-4v-3a2 2 0 014 0v3h28A3.981 3.981 0 0047.935 54a2 2 0 113.946.664 7.973 7.973 0 01-7.883 6.668zm7.414-43.414L39.999 6.505a3.972 3.972 0 00-2.828-1.172H19.999a8.009 8.009 0 00-8 8v6a2 2 0 004 0v-6a4 4 0 014-4h16v8a4 4 0 004 4h10a2.001 2.001 0 001.414-3.414zM39.998 12.16l5.172 5.172h-5.172V12.16z"
    })),
    external: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M59.914 23.848V7.909A3.93 3.93 0 0055.994 4H40.055a2.154 2.154 0 000 4.308h12.407L29.846 30.923a2.154 2.154 0 000 3.048c.393.39.922.614 1.476.624a2.154 2.154 0 001.529-.624l22.755-22.766v12.643a2.154 2.154 0 004.308 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M12.217 60H47.4a8.228 8.228 0 008.217-8.174V38.462a2.154 2.154 0 00-4.308 0v13.321a3.92 3.92 0 01-3.909 3.91H12.217a3.92 3.92 0 01-3.91-3.867v-35.27a3.909 3.909 0 013.91-3.94h13.321a2.154 2.154 0 100-4.308H12.217A8.217 8.217 0 004 16.557v35.27A8.228 8.228 0 0012.217 60z"
    })),
    "face-id": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M20 10c-5.523 0-10 4.477-10 10v2a2 2 0 11-4 0v-2c0-7.732 6.268-14 14-14h2a2 2 0 110 4h-2zm20-2a2 2 0 012-2h2c7.732 0 14 6.268 14 14v2a2 2 0 11-4 0v-2c0-5.523-4.477-10-10-10h-2a2 2 0 01-2-2zM23.519 27c-1.074 0-1.485.402-1.73.893a2 2 0 11-3.579-1.786C19.163 24.197 21 23 23.52 23c2.713 0 4.31 1.578 5.168 2.926a2 2 0 01-3.374 2.148c-.218-.343-.458-.606-.723-.782-.243-.16-.57-.292-1.071-.292zm17 0c-1.074 0-1.485.402-1.73.893a2 2 0 11-3.578-1.786c.952-1.91 2.788-3.107 5.308-3.107 2.713 0 4.31 1.578 5.168 2.926a2 2 0 01-3.374 2.148c-.218-.343-.458-.606-.723-.782-.243-.16-.57-.292-1.071-.292zM21.57 37.602a2 2 0 012.828-.032C25.95 39.087 27.912 41 32 41c3.645 0 6.095-1.957 7.602-3.43a2 2 0 112.796 2.86C40.632 42.157 37.217 45 32 45c-5.724 0-8.671-2.881-10.393-4.565l-.005-.005a2 2 0 01-.032-2.828zM8 40a2 2 0 012 2v2c0 5.523 4.477 10 10 10h2a2 2 0 110 4h-2c-7.732 0-14-6.268-14-14v-2a2 2 0 012-2zm48 0a2 2 0 012 2v2c0 7.732-6.268 14-14 14h-2a2 2 0 110-4h2c5.523 0 10-4.477 10-10v-2a2 2 0 012-2z",
        clipRule: "evenodd"
    })),
    facebook: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M36.2 60H24.73V32H19v-9.654h5.73v-5.79C24.73 8.681 27.961 4 37.153 4h7.662v9.654H40.03c-3.578 0-3.82 1.356-3.82 3.864l-.01 4.828h8.673L43.861 32h-7.65v28h-.012z",
        clipRule: "evenodd"
    })),
    facemask: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M21 26a3 3 0 116.001 0A3 3 0 0121 26zm19 3a3 3 0 100-6 3 3 0 000 6zm9.442 22.265l.03.11-.234.066a25.932 25.932 0 01-34.476 0l-.235-.067.031-.109a26 26 0 1134.884 0zM10.289 28.456l10.589 7.06A7.974 7.974 0 0125.525 34h12.95a7.974 7.974 0 014.647 1.515l10.589-7.059a21.998 21.998 0 00-43.422 0zm8 10.14l-8.261-5.507a21.915 21.915 0 005.784 13.79l2.022-7.077a7.86 7.86 0 01.455-1.206zm26.58 11.23l-2.549-8.925a3.938 3.938 0 00-.452-.994l-.188-.28A4.009 4.009 0 0038.475 38h-12.95a4.01 4.01 0 00-3.204 1.624l-.191.286a3.968 3.968 0 00-.45.99l-2.55 8.926a21.93 21.93 0 0025.74 0h-.001zm9.103-16.737l-8.261 5.508c.184.39.336.792.455 1.206l2.022 7.076a21.915 21.915 0 005.784-13.79z"
    })),
    fiber: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M44 28h-2V12a2 2 0 00-4 0v16h-4V6a2 2 0 10-4 0v22h-4V12a2 2 0 00-4 0v16h-2a4.005 4.005 0 00-4 4v24a4.005 4.005 0 004 4h24a4.005 4.005 0 004-4V32a4.005 4.005 0 00-4-4zM20 56V32h24l.003 24H20z"
    })),
    film: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M56 28.667H26.331l30.13-6.55a2.166 2.166 0 001.663-2.542L55.958 8.74a2.166 2.166 0 00-2.605-1.687l-35.265 8.015-.129-.052-.035.089-12.238 2.781A2.167 2.167 0 004 20v32.5a4.338 4.338 0 004.333 4.333H56a4.338 4.338 0 004.333-4.333V33A4.338 4.338 0 0056 28.667zm-17.227-7.139l-7.248 1.576 2.924-7.31 7.26-1.65-2.888 7.218c-.022.055-.03.11-.047.166zm-12.359 2.687l-8.177 1.777 2.866-7.165 8.212-1.866-2.9 7.254zm27.044-5.88l-9.592 2.086 2.977-7.444 5.302-1.205 1.313 6.564zM8.333 21.73l7.636-1.735-2.844 7.109-4.792 1.041V21.73zm0 30.77V33H56l.003 19.5H8.333z",
        clipRule: "evenodd"
    })),
    filter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M57.846 41H46.793a8.603 8.603 0 00-16.663 0H6.154a2.154 2.154 0 100 4.308H30.13a8.603 8.603 0 0016.663 0h11.053a2.154 2.154 0 000-4.308zm-19.384 6.462a4.308 4.308 0 110-8.616 4.308 4.308 0 010 8.616zM6.154 23.769h11.053a8.603 8.603 0 0016.663 0h23.976a2.154 2.154 0 000-4.307H33.87a8.603 8.603 0 00-16.663 0H6.154a2.154 2.154 0 000 4.307zm19.384-6.461a4.308 4.308 0 110 8.615 4.308 4.308 0 010-8.615z",
        clipRule: "evenodd"
    })),
    fingerprint: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32.352 8.036c-3.668 0-7.07.893-10.02 2.438a1.973 1.973 0 01-2.677-.867 2.033 2.033 0 01.854-2.72C24.015 5.052 28.041 4 32.352 4 46.752 4 57 15.883 57 30.234c0 1.39-.08 2.832-.157 3.912a71.075 71.075 0 01-.107 1.327l-.05.523c-.115 1.108-1.094 1.912-2.185 1.794-1.092-.117-1.883-1.11-1.768-2.219m0 0v-.005l.003-.022.01-.09.032-.35c.028-.304.064-.737.101-1.25.074-1.034.146-2.367.146-3.62 0-12.398-8.73-22.198-20.673-22.198m-14.93 3.178a2.04 2.04 0 01-.124 2.85c-4.074 3.79-6.054 8.773-5.816 14.573.046 1.113-.806 2.053-1.903 2.1-1.096.046-2.022-.819-2.068-1.932-.285-6.934 2.124-13.087 7.102-17.717a1.966 1.966 0 012.808.126z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M21.673 20.52c-2.023 2.794-2.748 6.256-2.748 8.705 0 5.524-4.52 9.705-10.157 9.069-1.09-.123-1.877-1.121-1.756-2.229.122-1.107 1.104-1.906 2.195-1.783 3.307.373 5.743-1.963 5.743-5.057 0-3.1.887-7.458 3.52-11.096 2.706-3.736 7.152-6.562 13.87-6.562 5.936 0 10.084 2.275 12.954 5.772a2.04 2.04 0 01-.255 2.842 1.967 1.967 0 01-2.799-.259c-2.099-2.557-5.12-4.319-9.9-4.319-5.46 0-8.714 2.22-10.667 4.917zm24.89 1.765a1.98 1.98 0 012.548 1.202c.777 2.156.91 4.073.865 5.967-.017.754-.064 1.53-.111 2.3l-.03.514a50.247 50.247 0 00-.106 3.011c0 1.614.123 3.039.423 4.121.308 1.113.7 1.508.963 1.642.64.325 1.306.417 1.844.417a4.376 4.376 0 00.763-.067l.016-.003a1.984 1.984 0 012.39 1.473c.267 1.08-.38 2.176-1.445 2.447l-.543.103a8.24 8.24 0 01-1.181.083c-.954 0-2.274-.16-3.622-.843-1.724-.876-2.574-2.581-3.012-4.159-.445-1.607-.57-3.462-.57-5.214 0-1.195.054-2.274.111-3.251l.033-.551c.047-.765.088-1.449.104-2.12.038-1.602-.078-2.968-.624-4.484-.378-1.046.152-2.205 1.183-2.588z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32.352 22.666c-3.459 0-5.963 2.712-5.963 5.55 0 1.114-.89 2.018-1.987 2.018-1.098 0-1.987-.904-1.987-2.018 0-5.234 4.452-9.585 9.937-9.585 4.762 0 9.937 3.75 9.937 10.09 0 9.116-3.192 16.658-8.97 23.057a1.966 1.966 0 01-2.807.124 2.04 2.04 0 01-.122-2.852c5.154-5.708 7.924-12.293 7.924-20.33 0-3.75-3.022-6.053-5.962-6.053zm-8.23 9.72c1.024.4 1.535 1.568 1.141 2.608-2.791 7.37-8.434 10.489-14.144 10.875-1.095.074-2.042-.767-2.115-1.88-.073-1.111.756-2.073 1.85-2.147 4.334-.293 8.522-2.548 10.7-8.296a1.978 1.978 0 012.568-1.16zm4.223 20.976a2.037 2.037 0 01-.603 2.788c-3.557 2.311-6.968 3.114-9.021 3.598-.293.07-.559.132-.793.191-1.065.27-2.144-.387-2.41-1.468s.381-2.177 1.446-2.447c.28-.072.58-.143.894-.218 2.057-.49 4.799-1.144 7.742-3.056a1.97 1.97 0 012.745.612z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32.456 26.705c1.096.059 1.938 1.009 1.88 2.122v.007l-.012.183c-.008.112-.021.272-.041.476-.04.407-.105.993-.214 1.733a52.718 52.718 0 01-1.292 6.103c-1.465 5.393-7.602 14.99-19.117 16.103-1.093.106-2.063-.708-2.167-1.818-.104-1.11.697-2.094 1.79-2.2 9.352-.904 14.477-8.797 15.662-13.158a48.66 48.66 0 001.193-5.626c.098-.669.156-1.187.19-1.53a16.773 16.773 0 00.038-.47v-.015c.059-1.113.994-1.968 2.09-1.91zm11.952 18.768c1.04.352 1.604 1.495 1.256 2.552-1.138 3.468-3.898 7.338-7.686 10.085a1.968 1.968 0 01-2.772-.469 2.038 2.038 0 01.462-2.815c3.168-2.298 5.377-5.49 6.226-8.077a1.98 1.98 0 012.514-1.276z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M42.89 45.582a1.973 1.973 0 012.667.903c.66 1.339 1.82 2.078 3.284 2.488 1.507.422 3.114.432 4.378.432 1.098 0 1.988.904 1.988 2.018 0 1.114-.89 2.018-1.988 2.018h-.059c-1.228 0-3.314 0-5.376-.577-1.451-.407-2.987-1.127-4.239-2.394a8.28 8.28 0 01-1.544-2.18 2.033 2.033 0 01.89-2.708z",
        clipRule: "evenodd"
    })),
    "five-g": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M32.5 30.2c-.7 1.1-1 2.3-1 3.6 0 1.2.3 2.3.8 3.3s1.3 1.8 2.3 2.5c1 .6 2.1.9 3.3.9.7 0 1.4-.1 2-.3.6-.2 1.2-.5 1.7-.8.8-.6 1.3-1.4 1.3-2.5v-3.3c0-.4-.2-.6-.7-.6H40c-.4 0-.8.1-1.2.4-.4.2-.6.5-.6.8 0 .1.1.4.3.7.3.4.6.7.9.7h1v1.8c-.7.4-1.4.6-2.2.6-.7 0-1.4-.2-2-.5-.6-.3-1.1-.8-1.4-1.5-.4-.6-.5-1.4-.5-2.2 0-1.2.4-2.2 1.2-3 .8-.8 1.8-1.2 3-1.2.4 0 .7 0 1 .1.3.1.7.2 1.1.4.2.1.3.1.4.1.2 0 .3-.1.5-.3.2-.2.3-.4.4-.7.1-.3.2-.6.2-.9 0-.3-.1-.4-.3-.6-1-.6-2.2-1-3.5-1-1.2 0-2.3.3-3.4.9s-1.7 1.5-2.4 2.6zM25.6 38c-.5 0-.9-.1-1.3-.3-.4-.2-.7-.5-1-.9-.1-.2-.3-.3-.6-.3-.4 0-.8.1-1.2.4-.4.2-.5.5-.5.7 0 .1.1.3.1.5.4.7 1 1.3 1.7 1.7.8.4 1.7.6 2.6.6.9 0 1.7-.2 2.4-.6.7-.4 1.3-.9 1.8-1.6.5-.7.7-1.4.7-2.3 0-.7-.2-1.4-.6-2.1a4.63 4.63 0 00-3.9-2.1c-.3 0-.7 0-1.1.1-.4.1-.7.2-1.1.3l.1-2.8h4.7c.3 0 .6-.2.8-.6.2-.4.4-.8.4-1.2 0-.4-.2-.6-.7-.6h-5.8c-.4 0-.8.1-1.1.3-.4.2-.5.5-.6.8l-.2 5.3c0 .2.1.4.3.7.3.4.5.6.9.6.1 0 .2 0 .4-.1.4-.2.8-.4 1.3-.5.4-.1.9-.2 1.2-.2.7 0 1.2.2 1.7.6.4.4.7.8.7 1.4 0 .6-.2 1.1-.7 1.4-.2.6-.8.8-1.4.8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M53.7 23.2c-.4-1-1.6-1.6-2.6-1.1-.5.2-.9.6-1.1 1.1-.2.5-.2 1 0 1.5 3.3 7.7 1.4 16.7-4.9 22.4-7.1 6.4-18 6.7-25.4.8-4.5-3.6-7.1-8.6-7.4-14.3-.3-5.6 1.8-11.1 5.7-15 3.8-3.8 8.9-5.8 14.3-5.7.6 0 1-.2 1.4-.5.4-.4.6-.9.6-1.4 0-1.1-.9-2-2-2-7.2-.1-14.1 3-18.7 8.6-6.9 8.4-7.1 20.9-.1 29.6 4.3 5.4 10.4 8.5 17.2 8.9H32c6.3 0 12.3-2.5 16.7-6.9 6.9-6.9 8.8-17.1 5-26z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M41.3 22.6c.4.4.9.6 1.4.6h.1c.6 0 1.1-.3 1.4-.7l9.4-11.2c.7-.8.6-2.1-.2-2.8-.8-.7-2.1-.6-2.8.2l-8 9.6-3.4-3.4c-.8-.8-2-.8-2.8 0-.8.8-.8 2 0 2.8l4.9 4.9z"
    })),
    flag: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M54.347 7.462a2.976 2.976 0 00-3.131.271c-4.984 3.704-9.912 2.153-15.616.36-6.23-1.964-13.287-4.184-20.244 1.793a3.947 3.947 0 00-1.357 3.003v33.32a10.047 10.047 0 00-7.9 8.372A3.005 3.005 0 009.079 58h13.84a3.006 3.006 0 002.98-3.418 10.048 10.048 0 00-7.9-8.37v-9.303c5.262-4.486 10.44-2.876 16.4-1.002 6.345 1.998 13.537 4.261 20.608-2.117a3.009 3.009 0 00.992-2.235V10.14a2.98 2.98 0 00-1.652-2.678v.001zM21.657 54H10.34a6.002 6.002 0 0111.316 0zm30.342-22.892c-5.26 4.488-10.43 2.864-16.4.984-3.204-1.008-6.62-2.083-10.125-2.083a14.542 14.542 0 00-7.48 1.988l-.03-19.077c5.268-4.525 10.442-2.899 16.434-1.012 5.42 1.706 11.507 3.62 17.6.095v19.105z"
    })),
    focus: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 4a2 2 0 012 2v4.09c10.554.95 18.96 9.356 19.91 19.91H58a2 2 0 110 4h-4.09C52.96 44.554 44.554 52.96 34 53.91V58a2 2 0 11-4 0v-4.09C19.446 52.96 11.04 44.554 10.09 34H6a2 2 0 110-4h4.09c.95-10.554 9.356-18.96 19.91-19.91V6a2 2 0 012-2zm2 45.89V45a2 2 0 10-4 0v4.89c-8.343-.922-14.968-7.547-15.89-15.89H19a2 2 0 100-4h-4.89c.922-8.343 7.547-14.968 15.89-15.89V19a2 2 0 104 0v-4.89c8.343.922 14.968 7.547 15.89 15.89H45a2 2 0 100 4h4.89c-.922 8.343-7.547 14.968-15.89 15.89z",
        clipRule: "evenodd"
    })),
    "folder-copy": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M12 8a8 8 0 00-8 8v21a8.001 8.001 0 007 7.938V49a8 8 0 008 8h33a8 8 0 008-8V31a8.001 8.001 0 00-7-7.938V20a8 8 0 00-8-8H32.624a6.12 6.12 0 00-5.742-4H12zm17 6.118c0-1.17-.948-2.118-2.118-2.118H12a4 4 0 00-4 4v21a4.002 4.002 0 003 3.874V27a8 8 0 018-8h14.294a6.708 6.708 0 016.138 4H49v-3a4 4 0 00-4-4H29v-1.882zM33.294 23A2.706 2.706 0 0136 25.706V27h16a4 4 0 014 4v18a4 4 0 01-4 4H19a4 4 0 01-4-4V27a4 4 0 014-4h14.294z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M20 35a2 2 0 012-2h27a2 2 0 110 4H22a2 2 0 01-2-2z",
        clipRule: "evenodd"
    })),
    "folder-new": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M48 30.088c1.105 0 2 .855 2 1.909v7.635h8c1.105 0 2 .855 2 1.91 0 1.053-.895 1.908-2 1.908h-8v7.635c0 1.054-.895 1.909-2 1.909-1.104 0-2-.855-2-1.909V43.45h-8c-1.104 0-2-.855-2-1.909s.896-1.909 2-1.909h8v-7.635c0-1.054.896-1.909 2-1.909zm8-7.635c0-2.045-1.684-3.714-3.8-3.813l-.2-.005H32v-1.909c0-1.054-.895-1.908-2-1.908H10c-1.054 0-1.918.778-1.994 1.766L8 16.727V43.45c0 2.044 1.684 3.714 3.8 3.813l.2.005h34-10c1.105 0 2 .854 2 1.908 0 1.054-.895 1.91-2 1.91h-2l-.046-.003L12 51.085c-4.334 0-7.864-3.29-7.996-7.397L4 43.45V16.726c0-3.09 2.566-5.61 5.775-5.722L10 11h20c2.462-.001 4.666 1.432 5.574 3.599l.086.219H52c4.335 0 7.865 3.29 7.997 7.397l.003.238v7.635c0 1.054-.895 1.909-2 1.909-1.104 0-2-.855-2-1.909v-7.635zm-8 1.909c1.105 0 2 .854 2 1.909 0 1.054-.895 1.908-2 1.908H16c-1.104 0-2-.854-2-1.908 0-1.055.896-1.91 2-1.91h32z",
        clipRule: "evenodd"
    })),
    folder: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M52 15H35.657A6.01 6.01 0 0030 11H10a6.007 6.007 0 00-6 6v28a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8V23a8.01 8.01 0 00-8-8zm4 30a4.004 4.004 0 01-4 4H12a4.004 4.004 0 01-4-4V17a2.002 2.002 0 012-2h20a2.002 2.002 0 012 2v2h20a4.004 4.004 0 014 4v22zm-6-18a2 2 0 01-2 2H16a2 2 0 110-4h32a2 2 0 012 2z",
        clipRule: "evenodd"
    })),
    food: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M45 59.53a6.67 6.67 0 01-6.66-6.66v-.1L39.22 37a5.2 5.2 0 01-2-1.39 7.8 7.8 0 01-1.62-5.4V14.45a8.32 8.32 0 012.5-6.16c4-3.9 11.32-3.83 11.63-3.82a2 2 0 012 2v46.4A6.67 6.67 0 0145 59.53zm-2.66-6.61a2.66 2.66 0 105.32-.05V8.58c-2.15.25-5.14.93-6.81 2.57a4.41 4.41 0 00-1.32 3.3v15.86c.005.06.005.12 0 .18a3.94 3.94 0 00.65 2.51 1.48 1.48 0 001.17.44 2 2 0 011.95 2.1l-.96 17.38z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M27.11 32l1.07 20.49a6.64 6.64 0 01-6.45 6.64h-.4a6.65 6.65 0 01-6.46-6.64v-.11L16 32c-3.83-1.16-4.12-4.55-3.95-7.15l.56-18.4a2 2 0 013.457-1.312 2 2 0 01.543 1.432L16 25c-.19 3 .38 3.17 2.22 3.34l1.92.18-1.27 24a2.66 2.66 0 005.31 0l-1.26-24 1.91-.18c1.85-.17 2.42-.37 2.23-3.27L26.5 6.53a2 2 0 114-.12l.56 18.47c.16 2.54-.12 5.92-3.95 7.12z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M21.53 25.19a2 2 0 01-2-2V6.47a2 2 0 014 0v16.72a2 2 0 01-2 2z"
    })),
    fraud: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M39.384 12.13a1.47 1.47 0 01-.51 0c.169.024.34.024.51 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M50.614 29.4c1.47-2.69 1.84-6.82 1.19-12.82v-.23c-1.22-5.2-5.88-8.41-12-8.27a20.07 20.07 0 00-22.72 1.69c-4.37 3.66-8.36 9.91-3.81 19.38a7.2 7.2 0 00-3.94 6.43 7 7 0 004.51 6.53c4.93 10.82 10.51 16.41 17 17 .58.08 1.17.08 1.75 0 6.49-.62 12.06-6.21 17-17a7 7 0 004.49-6.53 7.14 7.14 0 00-3.47-6.18zm-31.07-16.51a16.05 16.05 0 0118.64-1.07l.26.14a1.572 1.572 0 00.93.13c4.37-.26 7.61 1.68 8.45 5.06a26.193 26.193 0 01-.15 8.7 35.12 35.12 0 00-2.5-2.62c-2.12-2.07-4.51-4.43-5.38-7.11v-.06a.853.853 0 00-.09-.22 1.304 1.304 0 00-.08-.17 1.82 1.82 0 00-.54-.59.999.999 0 00-.26-.16 1.797 1.797 0 00-.55-.19.757.757 0 00-.26 0c-.12-.02-.24-.02-.36 0h-.19a.8.8 0 00-.15 0l-.2.08-.19.1c-.153.08-.292.184-.41.31a.346.346 0 00-.1.11 1.516 1.516 0 00-.28.4c-1 2-2.89 2.76-8.56 3.49-5.93.86-9.62 2.61-11.67 5.73-1.63-4.75-.4-8.68 3.64-12.06zm8.54 10.36c-6.17.89-8.54 2.58-9.54 5.25h-.01a97 97 0 0026.15.08c-.427-.584-1.058-1.219-1.627-1.792-.23-.232-.45-.454-.643-.658a32 32 0 01-5-5.78c-2.33 1.84-5.54 2.41-9.33 2.9zm16 9.4c-1 4.2-2.68 6.44-4.9 6.66-2 .13-3.53-1.87-4.71-5.94 3.207-.087 6.41-.327 9.61-.72zm-19.05 6.67c1.82 0 3.33-1.94 4.47-5.94h.02c-3.18-.06-6.36-.28-9.59-.66 1.01 4.16 2.67 6.37 4.94 6.6h.16zm22.61-.8a2 2 0 00-1.37 1.14c-4.46 10.07-9.36 15.3-14.58 15.54-5.2-.23-10.11-5.46-14.61-15.54a2 2 0 00-1.37-1.14 3 3 0 01-2.42-3 3.4 3.4 0 012.44-3.18c1.39 6.83 4.33 10.5 8.79 10.94h.5c3.47 0 5.61-2.45 7-5.18 1.35 2.73 3.51 5.18 7 5.18h.51c4.34-.43 7.25-4 8.67-10.68a3.23 3.23 0 011.88 2.98 3 3 0 01-2.42 2.94h-.02z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M32.084 59.21c.17.002.338-.022.5-.07a6.35 6.35 0 01-.87.07h.37zm-.37-.01h-.38a1.68 1.68 0 01-.5-.07c.291.044.585.067.88.07z"
    })),
    games: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M26 41.998a2 2 0 01-2 2h-2v2a2 2 0 01-4 0v-2h-2a2 2 0 010-4h2v-2a2 2 0 014 0v2h2a2 2 0 012 2zm22-4a2 2 0 100 4 2 2 0 000-4zm-6 4a2 2 0 100 4 2 2 0 000-4zm17.981-.77a15.994 15.994 0 01-25.643 13.517 3.979 3.979 0 00-2.405-.747h-.223a3.44 3.44 0 00-2.048.747A15.997 15.997 0 014.02 41.228c.508-8.639 7.724-15.349 16.377-15.229H32v-2a8.009 8.009 0 018-8 4.004 4.004 0 004-4V8a2 2 0 014 0v4a8.009 8.009 0 01-8 8 4.004 4.004 0 00-4 4v2h7.604c8.653-.12 15.868 6.59 16.377 15.229zm-3.996.188c-.41-6.504-5.865-11.534-12.381-11.417H20.396c-6.516-.117-11.971 4.913-12.382 11.417A11.994 11.994 0 0027.242 51.56a7.366 7.366 0 014.468-1.562h.223a7.996 7.996 0 014.824 1.562 11.996 11.996 0 0019.228-10.144z",
        clipRule: "evenodd"
    })),
    "getting-started": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M31.893 17.643a6.051 6.051 0 106.05 6.05 6.058 6.058 0 00-6.05-6.05zm0 8.068a2.017 2.017 0 110-4.034 2.017 2.017 0 010 4.034zm2.017 24.204v8.068a2.017 2.017 0 01-4.034 0v-8.068a2.017 2.017 0 014.034 0zm6.05 0v4.034a2.017 2.017 0 01-4.033 0v-4.034a2.017 2.017 0 014.034 0zm-12.101 0v4.034a2.017 2.017 0 01-4.034 0v-4.034a2.017 2.017 0 014.034 0zm25.814-11.553a17.703 17.703 0 00-7.28-10.227C46.428 15.426 37.77 7.47 34.34 4.832a4.014 4.014 0 00-4.893 0c-3.429 2.64-12.088 10.594-12.053 23.303a17.702 17.702 0 00-7.28 10.228 4.058 4.058 0 001.03 3.772 4.001 4.001 0 003.684 1.148l5.88-1.176c.239.522.48 1.044.748 1.576a4 4 0 003.596 2.198h13.684a4 4 0 003.596-2.198c.268-.532.509-1.054.748-1.576l5.88 1.176a4 4 0 003.683-1.148 4.059 4.059 0 001.031-3.773zm-39.635.93a12.921 12.921 0 013.78-6.308 34.179 34.179 0 001.361 5.304l-5.141 1.004zm24.697 2.555l-13.679.018C15.42 22.779 27.864 11.14 31.88 8.029c4.042 3.11 16.48 14.744 6.859 33.82l-.003-.002zm5.867-3.549a34.182 34.182 0 001.365-5.313 12.937 12.937 0 013.783 6.343l-5.148-1.03z",
        clipRule: "evenodd"
    })),
    gift: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M56 16h-8.06c.04-.332.06-.666.06-1a9 9 0 00-16-5.64A9 9 0 0016 15c0 .334.02.668.06 1H8a3.84 3.84 0 00-4 3.67v6.66A3.84 3.84 0 008 30v18a8 8 0 008 8h32a8 8 0 008-8V30a3.84 3.84 0 004-3.67v-6.66A3.84 3.84 0 0056 16zm-17-6a5 5 0 015 5 4.79 4.79 0 01-.11 1h-9.78a4.79 4.79 0 01-.11-1 5 5 0 015-5zm-19 5a5 5 0 0110 0 4.79 4.79 0 01-.11 1h-9.78a4.79 4.79 0 01-.11-1zm10 5v6H8v-6h22zM12 48V30h18v22H16a4 4 0 01-4-4zm40 0a4 4 0 01-4 4H34V30h18v18zm0-22H34v-6h22v6h-4z"
    })),
    graph: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M58.39 55.833c0 1.197-.97 2.167-2.167 2.167H15.056a8.677 8.677 0 01-8.666-8.667V8.167a2.167 2.167 0 114.333 0v41.166a4.338 4.338 0 004.333 4.334h41.167c1.197 0 2.167.97 2.167 2.166zM17.223 40.667a2.16 2.16 0 001.532-.635l8.218-8.218 5.603 5.603a4.336 4.336 0 006.127 0L51.89 24.23v5.603a2.167 2.167 0 104.334 0v-8.666a4.338 4.338 0 00-4.334-4.334h-8.666a2.167 2.167 0 000 4.334h5.603L35.639 34.353l-5.602-5.603a4.435 4.435 0 00-6.128 0l-8.218 8.218a2.167 2.167 0 001.532 3.699z",
        clipRule: "evenodd"
    })),
    "grid-view": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M10 8h18a2 2 0 012 2v18a2 2 0 01-2 2H10a2 2 0 01-2-2V10a2 2 0 012-2zm2 4v14h14V12H12zm-2 22h18a2 2 0 012 2v18a2 2 0 01-2 2H10a2 2 0 01-2-2V36a2 2 0 012-2zm2 4v14h14V38H12zM54 8H36a2 2 0 00-2 2v18a2 2 0 002 2h18a2 2 0 002-2V10a2 2 0 00-2-2zM38 26V12h14v14H38zm-2 8h18a2 2 0 012 2v18a2 2 0 01-2 2H36a2 2 0 01-2-2V36a2 2 0 012-2zm2 4v14h14V38H38z",
        clipRule: "evenodd"
    })),
    group: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M21.47 18.538A12 12 0 0135 23.54l.224.358A11.82 11.82 0 0136.63 27.4a10.7 10.7 0 01.3 2.21 4.7 4.7 0 010 .53 12.39 12.39 0 01-.36 2.94 11.36 11.36 0 01-1.11 2.8A17.5 17.5 0 0138.27 37a14.91 14.91 0 013.14 2.12 12.89 12.89 0 012.15 2.46 14 14 0 01.87 1.54 11.5 11.5 0 01.09 9.98 5.18 5.18 0 01-4.52 3H9.74a5.18 5.18 0 01-4.52-3 11.7 11.7 0 011-11.52A13.63 13.63 0 0111.51 37a19.9 19.9 0 012.86-1.12 11.84 11.84 0 01-1.1-2.79 12.39 12.39 0 01-.36-2.94 12 12 0 018.56-11.612zM32.69 39.32a12 12 0 01-7.8 2.88h-.42a11.92 11.92 0 01-7.38-2.87 14.39 14.39 0 00-3.27 1 9.73 9.73 0 00-4.27 3.47 7.71 7.71 0 00-.8 7.41c.24.45.63.92 1 .92H40c.37 0 .76-.47 1-.92a7.65 7.65 0 00-.78-7.42 8 8 0 00-.51-.68 9.79 9.79 0 00-3.76-2.79 15 15 0 00-3.26-1zm17.302-26.708a11.17 11.17 0 01.928 11.758 13.32 13.32 0 017.28 5.21 10.75 10.75 0 01.9 10.68 4.92 4.92 0 01-4.29 2.86h-7.14a15.8 15.8 0 00-2.2-4h9.34c.22 0 .52-.3.76-.75a6.83 6.83 0 00-.72-6.59 10.08 10.08 0 00-6.68-4A11.09 11.09 0 0141 30.39c-.36 0-.71 0-1.06-.05v-.19a14.34 14.34 0 00-.25-2.72c-.07-.42-.17-.83-.27-1.23a6.39 6.39 0 001.58.19 7.16 7.16 0 005.74-2.88 7.09 7.09 0 001.43-4.29 7.16 7.16 0 00-14.24-1.09 14.67 14.67 0 00-3.66-2 11.17 11.17 0 0119.722-3.518zM24.89 22.12v.01a8 8 0 00-6.38 12.94c.258.326.535.637.83.93A8 8 0 0022 37.65a8 8 0 004.2.43 8.09 8.09 0 004.16-2.09 9.05 9.05 0 00.83-.93 7.93 7.93 0 001.41-2.85 8.07 8.07 0 000-4.14 7.88 7.88 0 00-2-3.55 8 8 0 00-5.71-2.4z"
    })),
    handshake: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M50.931 40.829c-.538.5-1.29.779-1.974.905a5.145 5.145 0 01-1.65 2.967 5.148 5.148 0 01-3.136 1.303 4.513 4.513 0 01-1.477 2.492 4.788 4.788 0 01-3.858 1.116l-.602.4a8.001 8.001 0 01-7.276.822c-4.56 1.027-9.14-.466-11.111-1.243-1.083-.426-1.954-1.127-2.63-1.9L12 41.729a3.981 3.981 0 01-1.999.535H8a4 4 0 01-4-4V19.162a4 4 0 014-4h2a3.99 3.99 0 012.732 1.078c1.626-.101 2.56-.54 3.34-1.008.25-.15.488-.306.76-.484l.007-.005c.259-.17.554-.363.864-.546.644-.382 1.409-.756 2.37-.966.72-.157 1.642-.152 2.433-.115.851.039 1.785.128 2.635.227a71.878 71.878 0 012.667.364l2.496-1.22a2.01 2.01 0 01.197-.083c1.7-.617 3.727-.444 5.594-.038 1.932.419 4.016 1.162 6.012 2.005 2.955 1.249 5.85 2.774 7.977 3.97A4.001 4.001 0 0154 15.162h2a4 4 0 014 4v19.1a4 4 0 01-4 4h-2a3.992 3.992 0 01-3.069-1.433zm-.95-17.93l.019.011v13.353c0 .389-.848 1.323-1.978 1.53a5.312 5.312 0 00-.157-.202 600.264 600.264 0 00-6.949-8.324c-1.656-1.942-3.54-3.929-5-5.42a153.189 153.189 0 00-2.476-2.474l-.014-.013a2.002 2.002 0 00-2.348-.373l-5.656 2.776a1.607 1.607 0 01-1.645-2.749l3.877-2.78 4.293-2.097c.63-.197 1.713-.207 3.3.138 1.593.345 3.423.987 5.303 1.78 3.754 1.586 7.46 3.677 9.431 4.844zM14 37.95l.005-.004 6.223 7.112c.35.4.718.667 1.085.812a19.81 19.81 0 004.212 1.144l-2.764-2.181a2 2 0 112.479-3.14l6.08 4.8a4 4 0 003.61.698l-7.653-6.707a2 2 0 012.636-3.009l9.12 7.994a.792.792 0 001.256-.897 6.348 6.348 0 01-.053-.051L31.95 36.33a2 2 0 112.811-2.845l8.287 8.19a1.165 1.165 0 001.596.041 1.149 1.149 0 00.13-1.587 594.369 594.369 0 00-6.9-8.266c-1.573-1.842-3.386-3.756-4.817-5.22a151.564 151.564 0 00-1.448-1.46l-4.425 2.17a5.607 5.607 0 01-5.738-9.589l.908-.651-.031-.002c-.78-.036-1.237-.007-1.396.028-.405.089-.762.248-1.186.5-.222.131-.445.277-.717.455l-.02.013c-.257.168-.555.363-.876.556A10.53 10.53 0 0114 20.13v17.82zM8 19.162v19.1h2v-19.1H8zm46 0v19.1h2v-19.1h-2z",
        clipRule: "evenodd"
    })),
    headphones: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M54 33.763V31.5c0-12.15-9.85-22-22-22s-22 9.85-22 22v2.263A8.007 8.007 0 004 41.5v6a8.01 8.01 0 008 8h2a4.004 4.004 0 004-4v-14a4.004 4.004 0 00-4-4v-2c0-9.941 8.059-18 18-18s18 8.059 18 18v2a4.004 4.004 0 00-4 4v14a4.004 4.004 0 004 4h2a8.01 8.01 0 008-8v-6a8.007 8.007 0 00-6-7.737zM14.003 51.5H12a4.004 4.004 0 01-4-4v-6a4.004 4.004 0 014-4h2l.003 14zM56 47.5a4.004 4.004 0 01-4 4h-2l-.003-14H52a4.004 4.004 0 014 4v6z",
        clipRule: "evenodd"
    })),
    "heart-filled": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M53.82 12.35a14.08 14.08 0 00-20.35 0L32 13.87l-1.47-1.52a14.08 14.08 0 00-20.35 0c-5.562 5.833-5.562 15.007 0 20.84l19 19.59a4 4 0 005.74 0l19-19.59c5.534-5.86 5.49-15.033-.1-20.84z",
        clipRule: "evenodd"
    })),
    heart: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M55.792 11.713a15.241 15.241 0 00-22.04 0l-1.598 1.65-1.598-1.65a15.241 15.241 0 00-22.04 0c-6.021 6.321-6.021 16.257 0 22.578l20.527 21.22a4.322 4.322 0 006.223 0l20.526-21.22c6.021-6.321 6.021-16.257 0-22.578zm-3.115 19.565l-20.52 21.22-20.526-21.22c-4.415-4.634-4.415-11.918 0-16.552a10.908 10.908 0 0115.811 0l3.155 3.26a2.232 2.232 0 003.115 0l3.154-3.26a10.908 10.908 0 0115.811 0c4.415 4.634 4.415 11.918 0 16.552z",
        clipRule: "evenodd"
    })),
    help: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32.115 40.765l7.141-7.626.694-.756c4.937-5.44 6.586-8.794 6.586-12.972 0-2.288-.555-4.438-1.733-6.31C42.515 9.357 38.147 7 32.669 7c-5.762 0-11.392 2.983-14.75 7.782l-.226.33c-.485.693-.693 1.317-.693 1.803 0 1.178 2.01 4.922 4.23 4.922.415 0 .831-.138 1.247-.416.347-.277.902-.832 1.664-1.664 2.982-3.328 4.992-4.576 7.696-4.576 3.12 0 5.408 2.08 5.408 4.854 0 2.426-1.317 4.714-4.437 8.112l-6.725 7.141c-.486.624-.763 1.179-.763 1.733 0 .555.347 1.456 1.04 2.635 1.04 1.595 2.15 2.427 3.328 2.427.763 0 1.525-.416 2.427-1.318zM30.38 56.99c-2.704 0-5.269-4.506-5.269-6.24 0-2.426 3.952-4.992 7.765-4.992 2.011 0 3.051.902 3.051 2.774 0 2.842-1.317 5.754-2.981 7.28-.832.762-1.664 1.178-2.566 1.178z",
        clipRule: "evenodd"
    })),
    "home-care": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M46.001 46a2 2 0 01-2 2v2a8 8 0 01-16 0v-6c-4.41 0-8-3.252-8-7.25V26a2 2 0 012-2h4a2 2 0 010 4h-2v8.75c0 1.792 1.794 3.25 4 3.25h4c2.206 0 4-1.458 4-3.25V28h-2a2 2 0 110-4h4a2 2 0 012 2v10.75c0 3.998-3.588 7.25-8 7.25v6a4 4 0 108 0v-2a2 2 0 110-4h4a2 2 0 012 2zm12.066-16.828L36.244 7.349a6 6 0 00-8.485 0L5.936 29.172A4 4 0 008.764 36h1.237v18a4.004 4.004 0 004 4h10a2 2 0 000-4h-10V32H8.764l21.823-21.823a2.049 2.049 0 012.828 0L55.24 32H50v22h-2a2 2 0 100 4h2a4.004 4.004 0 004-4V36h1.238a4 4 0 002.828-6.828z"
    })),
    "home-installation": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M34.587 5.14a3.987 3.987 0 00-5.614.03l-23.8 23.85c-2.508 2.512-.728 6.802 2.822 6.802h2.456v20.191A3.987 3.987 0 0014.438 60h5.838a1.993 1.993 0 000-3.987h-5.838V31.835H7.995l23.8-23.848L56.12 31.835h-6.37v24.178H38.075a3.987 3.987 0 01-3.987-3.987v-2.99h1.855a5.383 5.383 0 003.653-1.443 5.232 5.232 0 001.66-3.844v-8.89a1.924 1.924 0 00-.006-3.848h-3.206v-4.97a1.924 1.924 0 10-3.848 0v4.97h-4.088v-4.97a1.924 1.924 0 10-3.847 0v4.97h-3.207a1.924 1.924 0 00-.007 3.848v8.768a5.51 5.51 0 001.748 4.047 5.08 5.08 0 003.448 1.362H30.1v2.99A7.974 7.974 0 0038.075 60H49.75a3.987 3.987 0 003.987-3.987v-20.19h2.382c3.57 0 5.34-4.334 2.79-6.834L34.588 5.14zm2.95 29.719h-10.77v8.768c0 .44.18.859.496 1.15.27.25.619.387.98.387h7.7c.437 0 .858-.166 1.185-.467.26-.24.409-.586.409-.948v-8.89z",
        clipRule: "evenodd"
    })),
    home: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M58.795 29.24L36.361 6.808a6.167 6.167 0 00-8.722 0L5.205 29.24a4.112 4.112 0 002.907 7.02h3.328v18.503a4.116 4.116 0 004.112 4.112h32.896a4.116 4.116 0 004.112-4.112V36.26h3.328a4.112 4.112 0 002.907-7.02zm-10.347 2.908v22.616H15.552V32.148h-7.44L30.546 9.714a2.104 2.104 0 012.908 0l22.434 22.434h-7.44zm-18.504 8.224v6.168a4.116 4.116 0 004.112 4.112h6.168a4.116 4.116 0 004.112-4.112v-6.168a4.116 4.116 0 00-4.112-4.112h-6.168a4.116 4.116 0 00-4.112 4.112zm4.112 0h6.168l.003 6.168h-6.171v-6.168z",
        clipRule: "evenodd"
    })),
    hospital: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M26 18a2 2 0 012-2h2v-2a2 2 0 014 0v2h2a2 2 0 010 4h-2v2a2 2 0 01-4 0v-2h-2a2 2 0 01-2-2zm26-8v44a6.007 6.007 0 01-6 6H18a6.007 6.007 0 01-6-6V10a6.007 6.007 0 016-6h28a6.007 6.007 0 016 6zM30 48h-4v8h4v-8zm8 0h-4v8h4v-8zm10-38a2.003 2.003 0 00-2-2H18a2.003 2.003 0 00-2 2v44a2.003 2.003 0 002 2h4v-8a4.005 4.005 0 014-4h12a4.005 4.005 0 014 4v8h4a2.003 2.003 0 002-2V10zm-8 26H24a2 2 0 000 4h16a2 2 0 000-4zm0-8H24a2 2 0 000 4h16a2 2 0 000-4z"
    })),
    image: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M51.5 8.166h-39a8.677 8.677 0 00-8.667 8.667v30.334a8.677 8.677 0 008.667 8.666h39a8.677 8.677 0 008.666-8.666V16.832A8.677 8.677 0 0051.5 8.167zm4.333 39A4.338 4.338 0 0151.5 51.5h-39a4.338 4.338 0 01-4.334-4.334V16.834A4.338 4.338 0 0112.5 12.5h39a4.338 4.338 0 014.333 4.333v30.334zM20.083 32a7.583 7.583 0 10-7.583-7.584A7.592 7.592 0 0020.083 32zm0-10.834a3.25 3.25 0 110 6.5 3.25 3.25 0 010-6.5zm32.948 13.635a2.166 2.166 0 11-3.063 3.064l-7.135-7.135-13.635 13.635a2.166 2.166 0 01-3.064 0l-4.968-4.968-7.135 7.135a2.167 2.167 0 01-3.063-3.064l7.134-7.135a4.336 4.336 0 016.128 0l3.436 3.436L39.77 27.666a4.336 4.336 0 016.128 0l7.134 7.135z",
        clipRule: "evenodd"
    })),
    "industrial-iot": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M57.27 26.067L53.088 17.7a7.99 7.99 0 00-13.411-8.58 2.017 2.017 0 00-.36.09l-17.782 6.467a9.991 9.991 0 10-8.927 17.717l-.02.02L25.173 46H18a4.004 4.004 0 00-4 4v4a4.004 4.004 0 004 4h30a4.004 4.004 0 004-4v-4a4.004 4.004 0 00-4-4h-5.172L25.052 28.223c.088-.186.17-.374.247-.567L38.3 22.928l-1.57 3.138a4.01 4.01 0 00.249 4.01l3.357 5.033a2 2 0 103.328-2.218l-3.355-5.035 3.14-6.28a7.907 7.907 0 006.722-.762l3.52 7.042-3.355 5.035a2 2 0 103.328 2.218l3.357-5.036a4.01 4.01 0 00.249-4.006zM10 24a6 6 0 116 6 6.007 6.007 0 01-6-6zm38 26l.004 4H18v-4h30zm-10.827-4h-6.344L18.5 33.67a9.97 9.97 0 004.135-2.21L37.173 46zM25.958 23.16a9.914 9.914 0 00-1.41-4.322l13.456-4.892L38 14c0 1.532.442 3.03 1.275 4.317L25.958 23.16zM46 18a4 4 0 110-8 4 4 0 010 8z"
    })),
    industry: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M54 4a4 4 0 014 4v46a4 4 0 01-4 4H8a4 4 0 01-4-4V32.872a4 4 0 011.278-2.931l10-9.286A4 4 0 0122 23.586v3.827l7.278-6.758a4 4 0 012.49-1.062l.232-.007a4 4 0 014 4v3.827l7.278-6.758a4 4 0 012.49-1.062l.232-.007V8a4 4 0 014-4h4zm0 4h-4v15.586c0 2.667-4 2.667-4 0l-10.64 9.88C34.082 34.654 32 33.746 32 32v-8.414l-10.64 9.88C20.082 34.654 18 33.746 18 32v-8.414L8 32.872V54h46V8zM20 45a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4zm-24-8a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4zm8 0a2 2 0 110 4 2 2 0 010-4z"
    })),
    infinite: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M47.284 40.87c-1.146 0-3.785-.634-8.583-4.888A57.423 57.423 0 0134.66 32a57.375 57.375 0 014.003-3.95c4.82-4.28 7.47-4.92 8.62-4.92 5.077 0 9.208 3.98 9.208 8.87 0 4.892-4.13 8.872-9.208 8.872zm-22.207-4.888c-4.798 4.254-7.437 4.889-8.583 4.889-5.077 0-9.208-3.98-9.208-8.871 0-4.892 4.13-8.871 9.208-8.871 1.146 0 3.785.635 8.583 4.888A57.433 57.433 0 0129.116 32a57.433 57.433 0 01-4.039 3.982zM47.284 19c-3.155 0-7.032 2.024-11.525 6.014a60.68 60.68 0 00-3.87 3.78 60.68 60.68 0 00-3.87-3.78C23.525 21.024 19.648 19 16.492 19 9.053 19 3 24.832 3 32s6.053 13 13.493 13c3.155 0 7.033-2.024 11.525-6.014a60.682 60.682 0 003.87-3.78 60.682 60.682 0 003.871 3.78C40.252 42.976 44.13 45 47.285 45c7.44 0 13.493-5.832 13.493-13s-6.053-13-13.493-13z",
        clipRule: "evenodd"
    })),
    "info-filled": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 4C16.536 4 4 16.536 4 32s12.536 28 28 28 28-12.536 28-28C59.982 16.543 47.456 4.017 32 4zm2.153 22.64v17.034a4.307 4.307 0 01-.34 1.684 3.48 3.48 0 01-.842 1.263c-.26.27-.613.431-.988.453-.54 0-1.08-.41-1.62-1.23a2.372 2.372 0 01-.517-1.263V27.546c0-.474.33-.927.988-1.36a3.8 3.8 0 012.12-.646c.799 0 1.199.366 1.2 1.1zm.26-8.486a4.786 4.786 0 01-.372 1.863 3.912 3.912 0 01-.94 1.41 1.71 1.71 0 01-1.15.52c-.562 0-1.145-.444-1.75-1.33a3.043 3.043 0 01-.616-1.458c0-.54.368-1.047 1.103-1.523a4.277 4.277 0 012.365-.713c.907 0 1.36.41 1.36 1.232z",
        clipRule: "evenodd"
    })),
    info: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 4C16.536 4 4 16.536 4 32s12.536 28 28 28 28-12.536 28-28C59.982 16.543 47.456 4.018 32 4zm0 51.693C18.915 55.693 8.307 45.085 8.307 32S18.915 8.308 32 8.308c13.084 0 23.692 10.607 23.692 23.692C55.677 45.08 45.078 55.678 32 55.693zm2.153-29.053v17.034a4.307 4.307 0 01-.34 1.684 3.48 3.48 0 01-.842 1.263c-.26.27-.613.431-.988.453-.54 0-1.08-.41-1.62-1.23a2.372 2.372 0 01-.517-1.263V27.547c0-.475.33-.928.988-1.36a3.8 3.8 0 012.12-.647c.799 0 1.199.367 1.2 1.1zm.26-8.485a4.786 4.786 0 01-.372 1.863 3.912 3.912 0 01-.94 1.41 1.71 1.71 0 01-1.15.519c-.562 0-1.145-.443-1.75-1.33a3.043 3.043 0 01-.616-1.458c0-.539.368-1.046 1.103-1.522a4.277 4.277 0 012.365-.714c.907 0 1.36.41 1.36 1.232z",
        clipRule: "evenodd"
    })),
    instagram: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M17.621 32c0-7.941 6.437-14.379 14.378-14.379A14.378 14.378 0 0146.378 32c0 7.94-6.438 14.378-14.379 14.378-7.94 0-14.378-6.437-14.378-14.378zM32 41.333a9.334 9.334 0 110-18.667 9.334 9.334 0 010 18.667z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M50.306 17.053a3.36 3.36 0 11-6.72 0 3.36 3.36 0 016.72 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 4c-7.604 0-8.56.032-11.544.168-2.984.137-5.016.61-6.8 1.302a13.726 13.726 0 00-4.96 3.23 13.726 13.726 0 00-3.23 4.96c-.689 1.78-1.162 3.815-1.298 6.796C4.032 23.436 4 24.396 4 32c0 7.604.032 8.56.168 11.544.137 2.984.61 5.016 1.302 6.8a13.726 13.726 0 003.23 4.96 13.725 13.725 0 004.96 3.23c1.78.691 3.817 1.165 6.8 1.3 2.983.137 3.936.166 11.54.166 7.604 0 8.56-.032 11.544-.17 2.984-.136 5.016-.609 6.8-1.3a14.32 14.32 0 008.186-8.19c.692-1.78 1.166-3.816 1.302-6.8.136-2.983.168-3.936.168-11.54 0-7.604-.032-8.56-.17-11.544-.136-2.984-.609-5.016-1.3-6.8a13.725 13.725 0 00-3.23-4.96 13.726 13.726 0 00-4.96-3.23c-1.78-.689-3.816-1.162-6.796-1.298C40.563 4.032 39.604 4 32 4zm0 5.044c7.475 0 8.361.03 11.314.16 2.73.125 4.213.581 5.2.964 1.307.508 2.24 1.115 3.22 2.095.978.98 1.585 1.913 2.093 3.219.384.986.84 2.47.965 5.2.134 2.953.16 3.84.16 11.314 0 7.475-.03 8.362-.16 11.315-.125 2.73-.581 4.213-.965 5.2-.508 1.307-1.114 2.24-2.094 3.219-.98.98-1.913 1.586-3.22 2.094-.985.384-2.469.84-5.2.964-2.951.135-3.84.16-11.314.16s-8.362-.028-11.314-.16c-2.73-.124-4.213-.58-5.2-.964-1.307-.508-2.24-1.114-3.22-2.094-.978-.98-1.585-1.91-2.094-3.217-.383-.986-.839-2.47-.964-5.2-.134-2.953-.16-3.84-.16-11.314 0-7.475.03-8.362.16-11.315.125-2.73.581-4.212.964-5.2.509-1.307 1.115-2.24 2.095-3.219.98-.979 1.913-1.586 3.22-2.094.985-.383 2.469-.84 5.2-.964 2.952-.135 3.84-.16 11.314-.16v-.003z",
        clipRule: "evenodd"
    })),
    insurance: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M40 4a8 8 0 018 8v40a8 8 0 01-8 8H24a8 8 0 01-8-8V12a8 8 0 018-8zm4 44H20v4a4 4 0 004 4h16a4 4 0 004-4v-4zm-12 2a2 2 0 110 4 2 2 0 010-4zm8-42H24a4 4 0 00-4 4v13.32l4.16-4.13a2 2 0 013.06.28l3.06 4.45 3.31-3.3a2 2 0 012.82 2.82l-5 5a2 2 0 01-1.59.58 2 2 0 01-1.47-.86l-3.06-4.44L20 31v13h24V12a4 4 0 00-4-4z"
    })),
    internet: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M59.999 32C59.981 16.587 47.523 4.08 32.11 4.003h-.024c-.03 0-.058-.003-.087-.003l-.083.002h-.03C16.446 4.066 3.97 16.617 4 32.058 4.03 47.498 16.556 59.999 31.998 60H32c15.456-.018 27.982-12.544 27.999-28zm-6.844 10.647a49.45 49.45 0 00-8.83-2.843 51.21 51.21 0 000-15.606 49.464 49.464 0 008.832-2.84 23.609 23.609 0 01-.002 21.289zM31.999 55.372c-3.136-2.033-5.695-6.49-7.188-12.108a52.508 52.508 0 0114.375 0C37.694 48.882 35.134 53.338 32 55.371zm0-16.91a57.92 57.92 0 00-8.068.574c-.73-4.662-.73-9.41 0-14.072 2.673.379 5.369.571 8.068.575h.007a57.906 57.906 0 008.06-.574c.363 2.328.546 4.68.548 7.035a45.884 45.884 0 01-.548 7.036A57.885 57.885 0 0032 38.462zm0-29.834c3.135 2.034 5.695 6.491 7.188 12.11-2.38.325-4.78.49-7.181.493h-.007a53.749 53.749 0 01-7.188-.495C26.304 15.118 28.863 10.661 32 8.628zm18.846 9.036a45.422 45.422 0 01-7.376 2.311A31.363 31.363 0 0038.704 9.28a23.766 23.766 0 0112.14 8.384zM25.295 9.28a31.362 31.362 0 00-4.766 10.694 45.377 45.377 0 01-7.374-2.312 23.766 23.766 0 0112.14-8.382zM10.842 21.354a49.392 49.392 0 008.83 2.842 51.291 51.291 0 000 15.608 49.441 49.441 0 00-8.83 2.842 23.61 23.61 0 010-21.292zm2.312 24.984a45.442 45.442 0 017.374-2.312 31.364 31.364 0 004.765 10.694 23.765 23.765 0 01-12.14-8.382zm25.55 8.382a31.362 31.362 0 004.764-10.694c2.52.56 4.987 1.333 7.375 2.312a23.765 23.765 0 01-12.14 8.382z",
        clipRule: "evenodd"
    })),
    invoice: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M48 4H20a8.01 8.01 0 00-8 8v44a4.004 4.004 0 004 4h28a8.01 8.01 0 008-8V8a4.004 4.004 0 00-4-4zm0 48a4.004 4.004 0 01-4 4l-28 .002V12a4.004 4.004 0 014-4h28v44zM22 40a2 2 0 012-2h16a2 2 0 110 4H24a2 2 0 01-2-2zm0-8a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2zm20 16a2 2 0 01-2 2h-4a2 2 0 110-4h4a2 2 0 012 2zm-3.41-14.59a1.965 1.965 0 01-.55-1.8c.023-.13.06-.258.11-.38a2.32 2.32 0 01.19-.34 1.44 1.44 0 01.25-.3 1.993 1.993 0 011.8-.55c.13.023.257.06.38.11a2.145 2.145 0 011.08 1.08c.05.122.087.25.11.38a1.965 1.965 0 01-.55 1.8c-.088.097-.19.18-.3.25a2.188 2.188 0 01-.34.19 2.71 2.71 0 01-.38.11 1.965 1.965 0 01-1.8-.55zM22 24a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2zm16.04.39a1.918 1.918 0 010-.78c.021-.13.058-.258.11-.38a2.32 2.32 0 01.19-.34c.072-.112.155-.216.25-.31a2.015 2.015 0 011.8-.54c.129.027.256.064.38.11.12.05.234.113.34.19a1.778 1.778 0 01.55.55c.073.108.136.221.19.34.15.367.189.77.11 1.16-.023.13-.06.258-.11.38a2.315 2.315 0 01-.19.34c-.07.11-.153.212-.25.3a1.98 1.98 0 01-2.82 0 1.446 1.446 0 01-.25-.3 2.32 2.32 0 01-.19-.34 1.797 1.797 0 01-.11-.38zM22 16a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2zm16.04.39a1.918 1.918 0 010-.78 1.8 1.8 0 01.11-.38 2.32 2.32 0 01.19-.34 1.44 1.44 0 01.25-.3 1.993 1.993 0 011.8-.55c.129.027.256.064.38.11a2.146 2.146 0 011.08 1.08c.05.122.087.25.11.38.053.257.053.523 0 .78-.023.13-.06.258-.11.38a2.309 2.309 0 01-.44.65c-.091.09-.192.171-.3.24a1.67 1.67 0 01-.34.19c-.123.05-.25.087-.38.11a1.998 1.998 0 01-1.8-.54 1.828 1.828 0 01-.25-.31 2.324 2.324 0 01-.19-.34 1.803 1.803 0 01-.11-.38z",
        clipRule: "evenodd"
    })),
    "job-search": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M57.586 48.758l-6.794-6.794a24.032 24.032 0 10-8.828 8.828l6.622 6.622a6.25 6.25 0 008.828 0l.172-.172a6 6 0 000-8.484zM10 30a20 20 0 1120 20 20.022 20.022 0 01-20-20zm44.758 24.414l-.172.172a2.244 2.244 0 01-3.172 0l-6.112-6.112a24.22 24.22 0 003.172-3.172l6.284 6.284a2.002 2.002 0 010 2.828zM37.536 26.658a8 8 0 10-15.073 0A10.008 10.008 0 0016 36a6.006 6.006 0 006 6h16a6.006 6.006 0 006-6 10.008 10.008 0 00-6.464-9.342zM30 20a4 4 0 110 8 4 4 0 010-8zm8 18H22a2.003 2.003 0 01-2-2 6.008 6.008 0 014.85-5.887 7.97 7.97 0 0010.3 0A6.007 6.007 0 0140 36a2.002 2.002 0 01-2 2z"
    })),
    key: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M44 14a6 6 0 106 6 6.007 6.007 0 00-6-6zm0 8a2 2 0 110-4 2 2 0 010 4zM54.205 9.92a19.997 19.997 0 00-33.661 18.71L5.172 44A3.974 3.974 0 004 46.829V56a4.004 4.004 0 004 4h6a4.004 4.004 0 004-4v-2h1a5.006 5.006 0 005-5v-1h2a4.004 4.004 0 004-4v-2h1.308A19.993 19.993 0 0054.205 9.92zm1.72 15.64a15.983 15.983 0 01-23.06 12.75 2.988 2.988 0 00-1.314-.31H26v6h-6v5a1 1 0 01-1 1h-5v6H8v-9.172l15.78-15.78a3.005 3.005 0 00.768-2.9 15.999 15.999 0 1131.378-2.587h-.001z"
    })),
    kontantkort: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M14.56 32.53v3.12a2.11 2.11 0 01-.35 1.2 1 1 0 01-.76.54c-.28 0-.56-.21-.83-.62a1.451 1.451 0 01-.27-.66v-9a.89.89 0 01.5-.71 1.94 1.94 0 011.09-.4c.42 0 .62.2.62.58v3.56l3.88-3.59a1.83 1.83 0 01.64-.4 1.93 1.93 0 01.73-.15c.43 0 .64.2.64.58a2.358 2.358 0 01-.18.89 1.999 1.999 0 01-.51.73l-3.33 3.08 4.1 4a.52.52 0 01.14.4c.005.398-.102.79-.31 1.13a.85.85 0 01-.69.51A1 1 0 0119 37l-4.44-4.47z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M25.59 33.32h-1.42v2.33a2.19 2.19 0 01-.35 1.2 1 1 0 01-.77.54c-.28 0-.55-.21-.83-.62a1.54 1.54 0 01-.27-.66v-8.94a.89.89 0 01.5-.71 2 2 0 011.09-.33H26a3.91 3.91 0 012 .48 3.33 3.33 0 011.29 1.29 3.61 3.61 0 01.46 1.83 3.17 3.17 0 01-.5 1.7 4 4 0 01-1.4 1.33l1.85 2.64a.66.66 0 01.13.4 2 2 0 01-.33 1.09c-.22.33-.45.5-.69.5a.92.92 0 01-.7-.48l-2.52-3.59zm.32-2a1.61 1.61 0 001.14-.45 1.42 1.42 0 00.47-1.08 1.45 1.45 0 00-.46-1.11 1.6 1.6 0 00-1.15-.44h-1.74v3.08h1.74z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M10 12h44a6 6 0 016 6v28a6 6 0 01-6 6H10a6 6 0 01-6-6V18a6 6 0 016-6zm46 6a2 2 0 00-2-2H10a2 2 0 00-2 2v28a2 2 0 002 2h44a2 2 0 002-2V18z",
        clipRule: "evenodd"
    })),
    laptop: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M59.558 46.79l-2.45-4.9V15.186A4.189 4.189 0 0052.924 11H11.076a4.189 4.189 0 00-4.185 4.185V41.89l-2.45 4.9a4.185 4.185 0 003.743 6.056h47.63a4.185 4.185 0 003.743-6.056zM11.077 15.186h41.847v25.108H11.077V15.185zM8.185 48.662l2.092-4.184h43.445l2.092 4.184H8.184z",
        clipRule: "evenodd"
    })),
    "late-payment": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M8.667 4.726a6 6 0 00-6 6v18a6 6 0 006 6h16a2 2 0 000-4h-16a2 2 0 01-2-2V18.282H43.11v3.444a2 2 0 004 0v-11a6 6 0 00-6-6H8.667zm34.444 9.556v-3.556a2 2 0 00-2-2H8.667a2 2 0 00-2 2v3.556H43.11z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M43.167 30.726c-6.352 0-11.5 5.149-11.5 11.5s5.148 11.5 11.5 11.5c6.35 0 11.5-5.149 11.5-11.5s-5.15-11.5-11.5-11.5zm-15.5 11.5c0-8.56 6.94-15.5 15.5-15.5 8.56 0 15.5 6.94 15.5 15.5 0 8.56-6.94 15.5-15.5 15.5-8.56 0-15.5-6.94-15.5-15.5z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M43.167 34.44a2 2 0 012 2v7.175a2 2 0 01-.471 1.29l-2.893 3.431a2 2 0 11-3.058-2.578l2.422-2.873V36.44a2 2 0 012-2z",
        clipRule: "evenodd"
    })),
    layers: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M54 30h-6V20a4.005 4.005 0 00-4-4H34v-6a4.004 4.004 0 00-4-4H10a4.004 4.004 0 00-4 4v20a4.004 4.004 0 004 4h6v10a4.005 4.005 0 004 4h10v6a4.005 4.005 0 004 4h20a4.005 4.005 0 004-4V34a4.005 4.005 0 00-4-4zm-44 0V10h20v6H20a4.005 4.005 0 00-4 4v10h-6zm10-10h24l.001 11.985L44 32l.001.015L44.003 44H20V20zm34 34H34v-6h10a4.005 4.005 0 004-4V34h6v20z"
    })),
    letter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M46 26a2 2 0 01-2 2H24a2 2 0 010-4h20a2 2 0 012 2zm-22-8h20a2 2 0 000-4H24a2 2 0 000 4zm20 16H24a2 2 0 000 4h20a2 2 0 000-4zM54 8v44a8.01 8.01 0 01-8 8H14a8.01 8.01 0 01-8-8v-2a4.004 4.004 0 014-4h4V12a8.01 8.01 0 018-8h28a4.004 4.004 0 014 4zM14 56h25.083A7.94 7.94 0 0138 52v-2H10v2a4.004 4.004 0 004 4zM50 8H22a4.004 4.004 0 00-4 4v34h20a4.004 4.004 0 014 4v2a4 4 0 108 0V8z"
    })),
    lightbulb: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M35 54a2 2 0 110 4h-6a2 2 0 110-4h6zm1-5a2 2 0 110 4h-8a2 2 0 110-4h8zm-4-32c7.732 0 14 6.268 14 14 0 4.953-2.596 9.445-6.713 11.957l-.648 3.415A2 2 0 0136.674 48h-9.382a2 2 0 01-1.967-1.637l-.631-3.418-.284-.179A13.993 13.993 0 0118 31c0-7.732 6.268-14 14-14zm0 4c-5.523 0-10 4.477-10 10a9.998 9.998 0 005.41 8.888 2 2 0 011.048 1.413L28.956 44h6.062l.512-2.701a2 2 0 011.048-1.405A9.998 9.998 0 0042 31c0-5.523-4.477-10-10-10zm-20 9a2 2 0 110 4H6a2 2 0 110-4h6zm46 0a2 2 0 110 4h-6a2 2 0 110-4h6zm-6.465-17.918a2 2 0 010 2.828l-4.242 4.243a2 2 0 11-2.829-2.828l4.243-4.243a2 2 0 012.828 0zm-36.087-.066l4.243 4.243a2 2 0 11-2.829 2.828l-4.242-4.243a2 2 0 012.828-2.828zM32 4a2 2 0 012 2v6a2 2 0 11-4 0V6a2 2 0 012-2z"
    })),
    "like-fin": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M16.4 28.8c-.1-.7-.2-1.3-.2-2 0-5.4 4.4-9.9 9.9-9.9.9 0 1.7.1 2.5.3-.6.5-.9 1.3-.7 2.1.2.9 1 1.5 1.9 1.5.2 0 .3 0 .5-.1l3.6-.9c1.3-.3 2.1-1.7 1.7-2.9l-.9-3.6c-.3-1.1-1.4-1.7-2.4-1.4-.9.2-1.5 1-1.5 1.9-1.5-.5-3.1-.8-4.7-.8-7.7 0-13.9 6.2-13.9 13.9 0 .9.1 1.9.3 2.8.2.9 1 1.6 2 1.6h.4c1.1-.4 1.8-1.5 1.5-2.5zm2.3 11.8c.9-.2 1.5-.9 1.5-1.8 1.8.9 3.8 1.3 5.9 1.3 7.7 0 13.9-6.2 13.9-13.9 0-1.2-.2-2.5-.5-3.7-.3-1.1-1.4-1.7-2.5-1.4-1.1.3-1.7 1.4-1.4 2.5.2.9.4 1.7.4 2.6 0 5.4-4.4 9.9-9.9 9.9-1.3 0-2.6-.3-3.8-.7.7-.4 1.1-1.3.9-2.2-.3-1.1-1.3-1.7-2.4-1.5l-3.6.9c-1.3.3-2.1 1.6-1.8 2.9l.9 3.6c.2.9 1 1.5 1.9 1.5h.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("circle", {
        cx: "33.8",
        cy: "52",
        r: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M41.8 4h-16c-3.5 0-6.5 2.3-7.6 5.4-.4 1.2.5 2.5 1.8 2.5h.2c.8 0 1.5-.5 1.8-1.3.6-1.5 2-2.6 3.8-2.6h16c2.2 0 4 1.8 4 4v32h-24v-.2c0-1.1-.9-2-2-2s-2 .9-2 2V52c0 4.4 3.6 8 8 8h16c4.4 0 8-3.6 8-8V12c0-4.4-3.6-8-8-8zm4 48c0 2.2-1.8 4-4 4h-16c-2.2 0-4-1.8-4-4v-4h24v4z"
    })),
    like: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M55.104 22.422h-8.35a4.147 4.147 0 00-2.942 1.228c-6.027-2.112-11.372-8.068-13.288-15.002a6.288 6.288 0 00-5.39-4.604 6.123 6.123 0 00-6.166 3.253c-.226.423-.428.858-.608 1.302a12.241 12.241 0 00-.16 8.448l2.637 7.462h-9.574A6.27 6.27 0 005 30.773v2.087a6.264 6.264 0 002.895 5.279 6.22 6.22 0 00-.807 3.072v2.088a6.273 6.273 0 004.615 6.042 6.24 6.24 0 00-.44 2.308v2.088A6.27 6.27 0 0017.526 60h26.096a2.05 2.05 0 00.522-.074c.17.047.346.072.522.074h12.526a2.088 2.088 0 002.088-2.088V26.597a4.18 4.18 0 00-4.176-4.175zM15.438 53.737v-2.088a2.09 2.09 0 012.088-2.087 2.088 2.088 0 000-4.176h-4.175a2.09 2.09 0 01-2.088-2.087V41.21a2.09 2.09 0 012.088-2.088 2.088 2.088 0 000-4.175h-2.088a2.09 2.09 0 01-2.088-2.088v-2.087a2.09 2.09 0 012.088-2.088h12.526c.13 0 .26-.014.389-.04.047-.008.09-.023.136-.035.057-.015.114-.024.17-.044.019-.007.034-.018.052-.025a2.05 2.05 0 00.212-.1c.054-.028.11-.054.161-.087.058-.039.114-.08.167-.125.052-.041.106-.08.154-.126s.09-.098.133-.149c.044-.05.089-.099.127-.153.04-.056.072-.117.106-.177.032-.056.066-.11.092-.169.028-.062.048-.127.07-.192.022-.064.045-.128.06-.194.014-.06.021-.122.03-.184.012-.076.02-.153.023-.23 0-.02.006-.038.006-.058 0-.044-.01-.086-.013-.13a1.607 1.607 0 00-.076-.44c-.012-.041-.016-.083-.03-.125l-3.608-10.21a8.04 8.04 0 01.084-5.532 9.07 9.07 0 01.416-.895 1.992 1.992 0 012.024-1.07A2.097 2.097 0 0126.5 9.758c2.277 8.247 8.75 15.351 16.078 17.876v28.19H17.526a2.09 2.09 0 01-2.088-2.088zm39.666 2.087h-8.35v-29.17c0-.02.005-.037.005-.056h8.345v29.227z",
        clipRule: "evenodd"
    })),
    link: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M37.383 27.972c4.572 4.583 4.572 12.001 0 16.584L25.368 56.57c-4.583 4.572-12.001 4.572-16.584 0L7.43 55.216c-4.572-4.583-4.572-12.001 0-16.584l8.14-8.14a2.132 2.132 0 013.014 3.015l-8.14 8.14a7.471 7.471 0 000 10.554l1.356 1.355a7.473 7.473 0 0010.554 0l12.015-12.015a7.471 7.471 0 000-10.554l-1.743-1.744a2.132 2.132 0 113.014-3.014l1.744 1.743zM56.571 8.784L55.216 7.43c-4.583-4.572-12.001-4.572-16.584 0L26.617 19.444c-4.572 4.583-4.572 12.001 0 16.584l1.744 1.743a2.132 2.132 0 103.014-3.014l-1.743-1.744a7.471 7.471 0 010-10.554l12.015-12.015a7.473 7.473 0 0110.554 0l1.355 1.355a7.471 7.471 0 010 10.554l-8.14 8.14a2.132 2.132 0 003.015 3.014l8.14-8.14c4.572-4.582 4.572-12 0-16.583z",
        clipRule: "evenodd"
    })),
    linkedin: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M10.73 4C7.011 4 4 7.02 4 10.738c0 3.721 3.011 6.742 6.73 6.742 3.712 0 6.726-3.021 6.726-6.742C17.456 7.02 14.442 4 10.73 4zm35.348 17.664c-5.645 0-9.431 3.1-10.98 6.04h-.154v-5.109H23.809V60h11.6V41.495c0-4.878.923-9.605 6.963-9.605 5.95 0 6.032 5.58 6.032 9.92V60h11.594V39.48c0-10.071-2.17-17.817-13.92-17.817zM16.533 60H4.927V22.593h11.606V60z"
    })),
    "list-view": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M10.99 15a3 3 0 10.01 0h-.01zM8 32a3 3 0 116.001.001A3 3 0 018 32zm0 14a3 3 0 116.001.001A3 3 0 018 46zm12.037-16h33.926c1.12 0 2.037.895 2.037 2s-.912 2-2.037 2H20.037C18.912 34 18 33.104 18 32c0-1.105.912-2 2.037-2zm-.002 14C18.91 44 18 44.896 18 46.001s.911 1.998 2.035 1.999h33.927C55.087 48 56 47.105 56 46.001S55.09 44 53.965 44h-33.93zm34.076-24.005H20.184a2.103 2.103 0 01-.295 0c-1.122-.08-1.965-1.038-1.884-2.14.082-1.102 1.058-1.93 2.179-1.85H54.11c1.008.072 1.81.86 1.884 1.85.081 1.102-.762 2.06-1.884 2.14z"
    })),
    "lock-locked": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 6c7.732 0 14 6.268 14 14v6a6 6 0 012.34.47l.227.102A6 6 0 0152 32v6a19.81 19.81 0 01-.49 4.38c-2.24 9.936-11.59 16.6-21.714 15.478C19.673 56.736 12.01 48.185 12 38v-6a6 6 0 013.67-5.53l.28-.11A6 6 0 0118 26v-6c0-7.732 6.268-14 14-14zm14 24H18a2 2 0 00-.79.2h-.1A2 2 0 0016 32v6c-.001 1.174.13 2.345.39 3.49 1.788 7.95 9.266 13.287 17.366 12.392C41.856 52.988 47.989 46.15 48 38v-6a2 2 0 00-1.12-1.84h-.09A2 2 0 0046 30zm-13.303 4.057A4 4 0 0134 41.46V48a2 2 0 11-4 0v-6.54a4 4 0 012.697-7.403zM32 10c-5.523 0-10 4.477-10 10v6h20v-6c0-5.523-4.477-10-10-10z"
    })),
    "lock-open": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M46.33 24.744H23.52a10.364 10.364 0 1117.263-11.403 2.074 2.074 0 003.59-2.08c-3.893-6.747-12.42-9.217-19.315-5.594-6.896 3.622-9.702 12.043-6.356 19.077h-1.407A8.305 8.305 0 009 33.04v18.665A8.305 8.305 0 0017.296 60H46.33a8.305 8.305 0 008.295-8.295V33.04a8.305 8.305 0 00-8.295-8.296zm4.148 26.96a4.152 4.152 0 01-4.148 4.148H17.296a4.152 4.152 0 01-4.148-4.147V33.04a4.152 4.152 0 014.148-4.148H46.33a4.152 4.152 0 014.148 4.148v18.665zM33.886 41.336v6.222a2.074 2.074 0 11-4.147 0v-6.222a2.074 2.074 0 014.147 0z",
        clipRule: "evenodd"
    })),
    "lock-unlocked": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M28.14 5.3a14.08 14.08 0 0110.45 2.27 13.41 13.41 0 015.68 8.85l.73 4.24a2.029 2.029 0 01-4 .68l-.72-4.24a9.44 9.44 0 00-4-6.24 10.12 10.12 0 00-7.47-1.62c-5.364.831-9.047 5.842-8.24 11.21L21.69 27H46a6 6 0 012.34.47l.227.102A6 6 0 0152 33v6a19.81 19.81 0 01-.49 4.38c-2.24 9.936-11.59 16.6-21.714 15.478C19.673 57.736 12.01 49.185 12 39v-6a6 6 0 013.63-5.53l.274-.108a5.79 5.79 0 011.726-.342l-1-5.9C15.45 13.575 20.598 6.498 28.14 5.3zM46 31H18a2 2 0 00-.79.2h-.1A2 2 0 0016 33v6c-.001 1.174.13 2.345.39 3.49 1.788 7.95 9.266 13.287 17.366 12.392C41.856 53.988 47.989 47.15 48 39v-6a2 2 0 00-1.12-1.84h-.09A2 2 0 0046 31zm-13.303 4.057A4 4 0 0134 42.46V49a2 2 0 11-4 0v-6.54a4 4 0 012.697-7.403z"
    })),
    lock: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M46.333 24.74h-.01l-.034-7.119-.005-.136C45.736 9.885 39.41 4 31.793 4 24.172 4 17.849 9.885 17.3 17.485l-.038 7.257A8.305 8.305 0 009 33.037v18.667A8.306 8.306 0 0017.296 60h29.037a8.306 8.306 0 008.297-8.296V33.037a8.306 8.306 0 00-8.297-8.296zM31.815 8.149a10.38 10.38 0 0110.325 9.565l.035 7.028H21.41l.034-7.028a10.422 10.422 0 0110.37-9.565zM50.48 51.704a4.152 4.152 0 01-4.148 4.148H17.296a4.152 4.152 0 01-4.148-4.148V33.037a4.152 4.152 0 014.148-4.148h29.037a4.152 4.152 0 014.148 4.148v18.667zm-16.59-10.37v6.222a2.074 2.074 0 01-4.148 0v-6.223a2.074 2.074 0 114.148 0z",
        clipRule: "evenodd"
    })),
    login: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M37.602 34.167H8.168a2.167 2.167 0 010-4.334h29.435l-9.3-9.301a2.167 2.167 0 013.063-3.064l12.999 12.999c.101.101.192.213.272.332.034.051.057.107.087.16.085.131.146.276.178.429.02.063.043.123.056.188.056.28.056.568 0 .848-.013.065-.037.125-.056.188a1.269 1.269 0 01-.178.428c-.03.054-.053.11-.087.161-.08.12-.17.23-.272.332l-13 12.999a2.167 2.167 0 01-3.064-3.064l9.302-9.301zM49.334 6h-26a2.167 2.167 0 000 4.333h26a4.338 4.338 0 014.334 4.334v34.666a4.338 4.338 0 01-4.334 4.334h-26a2.167 2.167 0 100 4.333h26A8.677 8.677 0 0058 49.333V14.667A8.677 8.677 0 0049.333 6z",
        clipRule: "evenodd"
    })),
    logout: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M58.53 33.533L45.533 46.532a2.166 2.166 0 11-3.064-3.064l9.301-9.302H22.333a2.167 2.167 0 110-4.333H51.77l-9.3-9.301a2.167 2.167 0 013.063-3.064L58.53 30.467c.1.101.192.212.271.332.035.051.058.107.087.16.086.131.146.276.18.429.018.063.042.123.055.188.056.28.056.568 0 .848-.013.065-.037.125-.056.188a1.27 1.27 0 01-.179.428c-.03.054-.053.11-.087.16-.08.12-.17.232-.271.333zM33.168 53.667h-19.5a4.338 4.338 0 01-4.334-4.334V14.667a4.338 4.338 0 014.334-4.334h19.5a2.167 2.167 0 100-4.333h-19.5A8.677 8.677 0 005 14.667v34.666A8.677 8.677 0 0013.667 58h19.5a2.167 2.167 0 100-4.333z",
        clipRule: "evenodd"
    })),
    map: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M31.916 14.458c-5.776 0-10.458 4.682-10.458 10.458 0 5.775 4.682 10.457 10.458 10.457 5.775 0 10.457-4.682 10.457-10.457-.006-5.773-4.685-10.452-10.457-10.458zm0 16.732a6.275 6.275 0 116.274-6.274 6.281 6.281 0 01-6.274 6.274zm0-27.19C20.369 4.013 11.013 13.37 11 24.916c0 13.06 14.254 29.391 18.625 34.087a3.141 3.141 0 002.29.997h.003a3.141 3.141 0 002.29-.999c4.37-4.694 18.623-21.025 18.623-34.085C52.818 13.37 43.461 4.013 31.915 4zm0 51.312c-4.11-4.54-16.733-19.387-16.733-30.396 0-9.242 7.491-16.733 16.733-16.733 9.24 0 16.732 7.491 16.732 16.733 0 11.009-12.624 25.857-16.733 30.396z",
        clipRule: "evenodd"
    })),
    "measuring-health": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M50 32a5.996 5.996 0 00-2 11.65V46a10 10 0 01-20 0V31.882A18.022 18.022 0 0044 14v-4a4.004 4.004 0 00-4-4h-2.555a4 4 0 100 4H40v4a14 14 0 01-28 0v-4h2.555a4 4 0 100-4H12a4.004 4.004 0 00-4 4v4a18.022 18.022 0 0016 17.882V46a14 14 0 0028 0v-2.35A5.996 5.996 0 0050 32zm0 8a2 2 0 110-4 2 2 0 010 4z"
    })),
    "media-content": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M20 4a8 8 0 00-8 8v2a2 2 0 104 0v-2a4 4 0 014-4h17v8a4 4 0 004 4h7v3a2 2 0 104 0v-4.724a4 4 0 00-1.046-2.697L41.572 5.303A4 4 0 0038.618 4H20zm25.922 12L41 10.609V16h4.922z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M52 41.5a2 2 0 10-4 0V52a4 4 0 01-4 4H16V46a2 2 0 10-4 0v10a4 4 0 004 4h28a8 8 0 008-8V41.5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M19.5 38a8.5 8.5 0 100-17 8.5 8.5 0 000 17zm0 4C26.404 42 32 36.404 32 29.5S26.404 17 19.5 17 7 22.596 7 29.5 12.596 42 19.5 42zm24.597-17.793a2 2 0 00-2.912.379A1.994 1.994 0 0040.6 26v14.053c-1.486-.803-3.265-1.195-5.135-1.024-4.675.426-8.153 4.203-7.767 8.437.386 4.234 4.489 7.322 9.164 6.896 4.675-.426 8.152-4.204 7.766-8.438a7.084 7.084 0 00-.068-.526c.026-.129.04-.262.04-.398V29.833l5.863 4.886a2 2 0 102.56-3.073l-8.926-7.439zm-7.598 26.171c2.855-.26 4.298-2.42 4.146-4.091-.153-1.672-1.962-3.535-4.817-3.275-2.856.26-4.299 2.42-4.146 4.091.152 1.672 1.961 3.535 4.817 3.275z",
        clipRule: "evenodd"
    })),
    megaphone: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M38.372 10.275a2.99 2.99 0 00-3.115.227l-9.291 6.636A9.944 9.944 0 0120.154 19H12a8.01 8.01 0 00-8 8v4a8.014 8.014 0 006.398 7.839l2.927 11.708a5.88 5.88 0 0011.41-2.854l-2.094-8.376a9.96 9.96 0 013.326 1.546l9.288 6.634A3 3 0 0040 45.057V12.943a2.987 2.987 0 00-1.628-2.668zm-17.86 40.001a1.88 1.88 0 01-3.306-.7L14.562 39h3.876l2.416 9.664a1.867 1.867 0 01-.342 1.612zM36 43.113l-7.708-5.504A13.916 13.916 0 0020.154 35H12a4.004 4.004 0 01-4-4v-4a4.004 4.004 0 014-4h8.154a13.917 13.917 0 008.137-2.607L36 14.887v28.227zM52 29a20.636 20.636 0 01-4.48 13.3 2 2 0 01-3.04-2.6A16.604 16.604 0 0048 29a16.604 16.604 0 00-3.52-10.7 2 2 0 013.04-2.6A20.636 20.636 0 0152 29zm8 0c0 7.455-2.362 14.49-6.48 19.3a2 2 0 01-3.04-2.6C53.989 41.601 56 35.515 56 29c0-6.515-2.012-12.601-5.52-16.7a2 2 0 013.04-2.6C57.638 14.51 60 21.544 60 29z",
        clipRule: "evenodd"
    })),
    menu: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M10.333 16.833c0-1.196.97-2.166 2.167-2.166h39a2.167 2.167 0 110 4.333h-39a2.167 2.167 0 01-2.167-2.167zM51.5 45h-39a2.167 2.167 0 100 4.333h39a2.167 2.167 0 100-4.333zm0-15.167h-39a2.167 2.167 0 000 4.334h39a2.167 2.167 0 000-4.334z",
        clipRule: "evenodd"
    })),
    microphone: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32.131 46c6.624-.008 11.993-5.376 12-12V16c0-6.627-5.372-12-12-12-6.627 0-12 5.373-12 12v18c.008 6.624 5.376 11.992 12 12zm0-38a8.01 8.01 0 018 8v18a8 8 0 11-16 0v-4h6a2 2 0 100-4h-6v-4h6a2 2 0 000-4h-6v-2a8.01 8.01 0 018-8zm17.92 34.89a19.874 19.874 0 01-15.92 11V58a2 2 0 01-4 0v-4.11a19.874 19.874 0 01-15.92-11 2 2 0 113.583-1.78 16.007 16.007 0 0028.675 0 2 2 0 113.582 1.78z",
        clipRule: "evenodd"
    })),
    minus: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M51.5 30h-39a2.167 2.167 0 100 4.333h39a2.167 2.167 0 100-4.333z",
        clipRule: "evenodd"
    })),
    mms: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M47.85 21.49a2 2 0 11-4 0 2 2 0 014 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M50.07 10H13.93a9.75 9.75 0 00-9.73 9.74v16.78a9.76 9.76 0 009.73 9.74h9.61V52a2 2 0 001.24 1.85 2 2 0 002.22-.44l4.93-4.92 2.22-2.23h16c2.13 0 4.2-.703 5.89-2a10.001 10.001 0 002.62-3 9.67 9.67 0 001.22-4.72v-16.8A9.75 9.75 0 0050.07 10zM33.28 42.26a2 2 0 00-.92.23c-.178.09-.34.208-.48.35l-4.34 4.33v-2.91a2 2 0 00-2-2H13.93a5.73 5.73 0 01-5.72-5.44l10.22-10.23a2 2 0 012.84 0l10.25 10.25L37 42.26h-3.72zm9.31 0h7.48a5.68 5.68 0 003.01-.86l-8.81-8.81a2 2 0 00-2.84 0l-4.25 4.26 5.41 5.41zm13.21-5.74a5.534 5.534 0 01-.26 1.69l-8.45-8.45a6 6 0 00-8.49 0L34.35 34 24.09 23.76a6 6 0 00-8.49 0l-7.4 7.41V19.74A5.74 5.74 0 0113.93 14h36.14a5.75 5.75 0 015.73 5.74v16.78z",
        clipRule: "evenodd"
    })),
    "mobile-broadband": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M32 4H16a8.01 8.01 0 00-8 8v40a8.01 8.01 0 008 8h16a8.01 8.01 0 008-8V12a8.01 8.01 0 00-8-8zm-20 8a4.004 4.004 0 014-4h16a4.004 4.004 0 014 4v32H12V12zm24 40a4.005 4.005 0 01-4 4H16a4.005 4.005 0 01-4-4v-4h24v4zm-14 0a2 2 0 114 0 2 2 0 01-4 0zm30-24a9.943 9.943 0 01-2.928 7.071 2.003 2.003 0 01-2.829.001 2.003 2.003 0 01-.001-2.829 6 6 0 000-8.486 2 2 0 112.83-2.828A9.942 9.942 0 0152 28zm8 0a17.88 17.88 0 01-5.272 12.728 2 2 0 01-2.829-2.829 14 14 0 000-19.798 2 2 0 112.829-2.829A17.88 17.88 0 0160 28z"
    })),
    mobile: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M40 4a8 8 0 018 8v40a8 8 0 01-8 8H24a8 8 0 01-8-8V12a8 8 0 018-8zm4 44H20v4a4 4 0 004 4h16a4 4 0 004-4v-4zm-12 2a2 2 0 110 4 2 2 0 010-4zm8-42H24a4 4 0 00-4 4v32h24V12a4 4 0 00-4-4z"
    })),
    moisture: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M22 36a10 10 0 01-10-10c0-4.67 6.623-14.561 8.227-16.957l.123-.183L22 6.48l1.65 2.38.123.183C25.377 11.44 32 21.331 32 26a10 10 0 01-10 10zm0-22.38c-2.88 4.49-6 10.2-6 12.38a6 6 0 1012 0c0-2.18-3.12-7.89-6-12.38zM30 60a8 8 0 01-8-8c0-3.75 5.29-11.6 6.35-13.14L30 36.48l1.65 2.38C32.71 40.4 38 48.25 38 52a8 8 0 01-8 8zm0-16.36c-2.13 3.41-4 7-4 8.36a4 4 0 108 0c0-1.33-1.87-4.95-4-8.36zm8.343-5.983A8 8 0 0052 32c0-3.75-5.29-11.6-6.35-13.14L44 16.48l-1.65 2.38C41.29 20.4 36 28.25 36 32a8 8 0 002.343 5.657zM40 32c0-1.36 1.87-4.95 4-8.36 2.13 3.41 4 7.03 4 8.36a4 4 0 11-8 0z",
        clipRule: "evenodd"
    })),
    "money-back": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M47.293 52.244c-3.488.467-5.17 1.628-7.131 2.981-1.003.692-2.08 1.435-3.507 2.161-.06.03-.12.057-.181.08-6.74 2.627-14.927 1.572-19.987-1.802a1.99 1.99 0 01-.21-.161L5.774 46.279a5.214 5.214 0 016.021-8.447l7.507 4.278a5.628 5.628 0 013.888-2.542l9.297-1.447c.076-.054.16-.115.254-.18.41-.29.986-.682 1.655-1.1 1.29-.805 3.108-1.822 4.793-2.271 2.176-.58 4.855-.403 6.797-.154.4.05.78.107 1.132.163A4 4 0 0151.096 31h5a4 4 0 014 4v16a4 4 0 01-4 4h-5a4.002 4.002 0 01-3.803-2.756zm-.197-13.61a32.594 32.594 0 00-1.618-.25c-1.866-.24-3.883-.315-5.26.051-1.074.286-2.468 1.028-3.703 1.8a32.36 32.36 0 00-1.892 1.278l-.108.08-.025.019-.005.003c-.264.2-.574.332-.901.383l-9.78 1.522a1.634 1.634 0 00.378 3.243l8.939-.696a2 2 0 11.31 3.988l-8.938.696a5.636 5.636 0 01-5.955-4.472l-8.723-4.972a1.214 1.214 0 00-1.402 1.966l10.4 9.133c3.932 2.558 10.619 3.472 16.115 1.37.779-.405 1.539-.927 2.36-1.49 2.26-1.552 4.98-3.42 9.808-4.04v-9.613zm4 11.462V51h5V35h-5v15.096zM25.096 9c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10zm-14 10c0-7.732 6.268-14 14-14s14 6.268 14 14-6.268 14-14 14-14-6.268-14-14z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M26.596 21.5c.42 0 .9-.74.9-1.44 0-.3-.16-.46-.5-.46h-4.68c-.02-.08-.02-.28-.02-.58 0-.34 0-.56.02-.66h4.98c.42 0 .9-.74.9-1.44 0-.3-.16-.46-.5-.46h-4.84c.72-1.46 1.8-2.2 3.22-2.2.62 0 1.3.22 2.04.64.14.08.28.12.38.12.18 0 .38-.08.56-.26.36-.32.64-.94.64-1.58 0-.22-.1-.4-.3-.54-.98-.62-2.06-.94-3.24-.94-2.78 0-5.16 1.82-6.2 4.76h-.28c-.62 0-1.3.44-1.3.84 0 .38.42.8.62.94.1.08.18.12.28.12h.24c-.02.1-.02.32-.02.66 0 .3 0 .5.02.58h-.12c-.62 0-1.3.44-1.3.84 0 .38.42.8.62.94.1.08.18.12.28.12h.78c.86 3.02 3.08 4.8 6.04 4.8 1.12 0 2.24-.26 2.88-.64.56-.34.92-1.08.92-1.86 0-.42-.24-.64-.7-.64-.22 0-.58.08-1.06.22-.78.24-1.4.36-1.84.36-1.5 0-2.58-.74-3.22-2.24h3.8z"
    })),
    "money-euro": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M21.11 14.05A21 21 0 0160 25a21.001 21.001 0 01-10 17.89 21 21 0 01-7 7A21.09 21.09 0 0125 60a21 21 0 01-10.99-38.95 21 21 0 017-7zM11.21 29A17 17 0 0025 56a17.06 17.06 0 009.91-3.21A21.67 21.67 0 0132 53c-11.598 0-21-9.402-21-21a22.29 22.29 0 01.21-3zm7.03-7A17 17 0 0032 49a16.9 16.9 0 0010-3.24A20.84 20.84 0 0118.24 22zM39 8c-9.389 0-17 7.611-17 17s7.611 17 17 17a17 17 0 0017-17c0-9.389-7.611-17-17-17zm1.56 5.47A9.38 9.38 0 0145.72 15a1 1 0 01.47.85 3.5 3.5 0 01-1 2.5 1.28 1.28 0 01-.88.41 1.37 1.37 0 01-.6-.19 6.58 6.58 0 00-3.22-1A5.45 5.45 0 0035.4 21H43c.53 0 .78.25.78.72 0 1.11-.75 2.28-1.42 2.28h-7.78a8.55 8.55 0 000 1.06 6.54 6.54 0 000 .94h7.35c.54 0 .79.25.79.72 0 1.11-.72 2.28-1.42 2.28h-6a5.21 5.21 0 005.09 3.53 10.54 10.54 0 002.9-.56 7.24 7.24 0 011.71-.35c.73 0 1.11.35 1.11 1a3.47 3.47 0 01-1.45 2.94 9.7 9.7 0 01-4.55 1c-4.67 0-8.17-2.81-9.53-7.58h-1.27a.68.68 0 01-.45-.19 2.32 2.32 0 01-1-1.48c0-.64 1.08-1.33 2.06-1.33h.28a4.92 4.92 0 010-.94 6.42 6.42 0 010-1.06h-.47a.68.68 0 01-.45-.19 2.32 2.32 0 01-1-1.48c0-.64 1.08-1.33 2.05-1.33h.45c1.64-4.64 5.4-7.51 9.78-7.51z"
    })),
    "money-krone": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M37.54 32.12c-.26 0-.56-.16-.86-.5l-5.54-5.6v3.92c0 1.1-.7 2.18-1.4 2.18s-1.38-1.22-1.38-1.6V19.18c0-.64 1.02-1.3 2-1.3.52 0 .78.24.78.72v4.46l4.86-4.5c.46-.42 1.1-.68 1.72-.68.54 0 .8.24.8.72 0 .74-.32 1.56-.86 2.04l-4.18 3.86 5.14 5.06c.12.12.18.28.18.5 0 1.04-.62 2.06-1.26 2.06z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M49 32.12c-.3 0-.58-.2-.88-.6l-3.16-4.5h-1.78v2.92c0 1.1-.7 2.18-1.4 2.18s-1.38-1.26-1.38-1.6V19.3c0-.64 1.02-1.3 2-1.3h3.04c1.84 0 3.32.86 4.08 2.22.38.68.56 1.44.56 2.3 0 1.5-.88 2.92-2.38 3.8l2.42 3.3c.1.16.16.32.16.5 0 .98-.66 2-1.28 2zM43.18 20.6h2.18c1.18 0 2.02.82 2.02 1.94 0 1.06-.9 1.92-2.02 1.92h-2.18V20.6z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M60 25a21 21 0 00-38.89-10.95h-.1a21 21 0 00-7 7A21 21 0 0025 60a21.09 21.09 0 0018-10.11 21 21 0 007-7A21 21 0 0060 25zM25 56a17 17 0 01-13.79-27 22.301 22.301 0 00-.21 3c0 11.598 9.402 21 21 21a21.676 21.676 0 002.91-.21A17.06 17.06 0 0125 56zm-8.159-16.28A17 17 0 0032.001 49a16.9 16.9 0 0010-3.24A20.84 20.84 0 0118.24 22a17 17 0 00-1.4 17.72zM39.001 42c-9.39 0-17-7.611-17-17S29.61 8 39 8c9.388 0 17 7.611 17 17a17 17 0 01-17 17z",
        clipRule: "evenodd"
    })),
    money: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M60 25.001a20.977 20.977 0 00-38.884-10.949c-.034.018-.07.03-.103.05a21.017 21.017 0 00-6.961 6.981A20.998 20.998 0 0025 60a21.1 21.1 0 0017.952-10.114 21.003 21.003 0 007.01-7.009A20.984 20.984 0 0060 25.001zm-35 31a17.014 17.014 0 01-13.787-26.963c-.14.982-.21 1.972-.212 2.963.014 11.592 9.408 20.986 21 21a20.687 20.687 0 002.91-.212A17.033 17.033 0 0125 56zm7-7a17.013 17.013 0 01-13.76-27 20.844 20.844 0 0023.764 23.76A16.899 16.899 0 0132 49zm7-7c-9.388 0-17-7.611-17-17 0-9.388 7.612-17 17-17 9.389 0 17 7.612 17 17-.01 9.384-7.616 16.99-17 17zm-3.604-21h7.64c.537 0 .79.252.79.725 0 1.105-.759 2.275-1.422 2.275h-7.825a8.15 8.15 0 00-.032 1.064c-.013.313-.002.625.032.936h7.355c.538 0 .79.252.79.725 0 1.105-.759 2.275-1.42 2.275h-6a5.205 5.205 0 005.083 3.534c.99-.052 1.968-.243 2.905-.568a7.063 7.063 0 011.673-.347c.728 0 1.106.347 1.106 1.01a3.448 3.448 0 01-1.453 2.936 9.671 9.671 0 01-4.545 1.01c-4.673 0-8.177-2.81-9.534-7.575h-1.231a.68.68 0 01-.442-.19 2.312 2.312 0 01-.98-1.483c0-.633 1.075-1.327 2.051-1.327h.28a6.194 6.194 0 01-.031-.936 8.15 8.15 0 01.031-1.064h-.47a.68.68 0 01-.443-.19 2.311 2.311 0 01-.98-1.483c0-.633 1.072-1.327 2.052-1.327h.442c1.643-4.64 5.398-7.514 9.786-7.514a9.385 9.385 0 015.116 1.483c.295.184.474.507.473.854a3.49 3.49 0 01-1.01 2.493 1.27 1.27 0 01-.885.412 1.308 1.308 0 01-.599-.19 6.65 6.65 0 00-3.22-1.01c-2.242 0-3.947 1.166-5.083 3.472z",
        clipRule: "evenodd"
    })),
    "more-horizontal": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M18 36a4 4 0 110-8 4 4 0 010 8zm10-4a4 4 0 108 0 4 4 0 00-8 0zm18 4a4 4 0 110-8 4 4 0 010 8z",
        clipRule: "evenodd"
    })),
    "more-low": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M43 42c0 2.75 2.25 5 5 5s5-2.25 5-5-2.25-5-5-5-5 2.25-5 5zm-6 0c0-2.75-2.25-5-5-5s-5 2.25-5 5 2.25 5 5 5 5-2.25 5-5zm-16 0c0-2.75-2.25-5-5-5s-5 2.25-5 5 2.25 5 5 5 5-2.25 5-5z"
    })),
    "more-vertical": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M28 18a4 4 0 118 0 4 4 0 01-8 0zm4 10a4 4 0 100 8 4 4 0 000-8zm-4 18a4 4 0 118 0 4 4 0 01-8 0z",
        clipRule: "evenodd"
    })),
    more: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M43 32c0 2.75 2.25 5 5 5s5-2.25 5-5-2.25-5-5-5-5 2.25-5 5zm-6 0c0-2.75-2.25-5-5-5s-5 2.25-5 5 2.25 5 5 5 5-2.25 5-5zm-16 0c0-2.75-2.25-5-5-5s-5 2.25-5 5 2.25 5 5 5 5-2.25 5-5z"
    })),
    music: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M52.491 10.872a3.986 3.986 0 00-3.391-.768l-22 5.077a3.981 3.981 0 00-3.1 3.897V38.84a9.755 9.755 0 00-5-1.353c-4.963 0-9 3.59-9 8 0 4.412 4.037 8 9 8s9-3.588 9-8V19.08l22-5.078v18.84a9.755 9.755 0 00-5-1.354c-4.963 0-9 3.59-9 8 0 4.412 4.037 8 9 8s9-3.588 9-8V14.001a3.977 3.977 0 00-1.509-3.129zM19 49.487c-2.757 0-5-1.794-5-4s2.243-4 5-4 5 1.794 5 4-2.243 4-5 4zm21-10c0 2.206 2.243 4 5 4s5-1.794 5-4-2.243-4-5-4-5 1.794-5 4z",
        clipRule: "evenodd"
    })),
    mute: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M51.428 11.676l1.749-2.137a2.167 2.167 0 10-3.354-2.744l-13.49 16.487v-9.885a4.333 4.333 0 00-7.397-3.064L18.103 21.167h-3.436A8.677 8.677 0 006 29.833v4.334a8.677 8.677 0 008.667 8.666h3.436l1.228 1.23-8.508 10.398a2.167 2.167 0 103.354 2.745l8.234-10.064 6.525 6.525a4.333 4.333 0 007.397-3.064V30.125l6.276-7.67A19.239 19.239 0 0145 32c.118 4.19-1.23 8.29-3.813 11.59a2.167 2.167 0 003.293 2.82A22.356 22.356 0 0049.333 32a23.054 23.054 0 00-3.832-13.079l3.11-3.803A28.806 28.806 0 0153.668 32c0 7.059-2.18 13.652-5.98 18.09a2.167 2.167 0 003.293 2.82C55.44 47.696 58 40.075 58 32c0-7.79-2.4-15.134-6.572-20.324zM19.898 38.5h-5.231a4.338 4.338 0 01-4.334-4.333v-4.334a4.338 4.338 0 014.334-4.333h5.23L32 13.397v15.181l-9.911 12.114-2.192-2.192zM32 50.603l-6.832-6.831L32 35.422v15.181z",
        clipRule: "evenodd"
    })),
    network: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M53.95 39.964a5.95 5.95 0 00-3.159.909l-6.35-5.08c2.254-4.03 1.977-9-.711-12.754l4.17-4.17a8.02 8.02 0 10-2.825-2.826l-4.17 4.17a11.92 11.92 0 00-14.726.668l-10.57-8.809a6.014 6.014 0 10-2.56 3.07l10.572 8.809a11.774 11.774 0 00-1.434 8.182l-3.611 1.313a7.984 7.984 0 101.369 3.755l3.61-1.313a12.037 12.037 0 006.503 5.406l-1.127 6.759a5.99 5.99 0 103.942.655l1.124-6.747a11.925 11.925 0 007.94-3.054l6.357 5.085a5.99 5.99 0 105.656-4.028zm-41.958 1.998a3.996 3.996 0 110-7.992 3.996 3.996 0 010 7.992zm39.96-33.966a3.996 3.996 0 110 7.992 3.996 3.996 0 010-7.992zM9.994 11.992a1.998 1.998 0 110-3.996 1.998 1.998 0 010 3.996zm19.98 43.956a1.998 1.998 0 110-3.996 1.998 1.998 0 010 3.996zm3.996-17.982a7.992 7.992 0 117.992-7.992 8.001 8.001 0 01-7.992 7.992zm19.98 9.99a1.998 1.998 0 110-3.996 1.998 1.998 0 010 3.996z",
        clipRule: "evenodd"
    })),
    "new-contact": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M49.86 31.712a16.11 16.11 0 00-11.413-10.547 13 13 0 10-23.557.006A16.015 16.015 0 002.667 36.702v4a8.01 8.01 0 008 8h20.59a13.997 13.997 0 1018.603-16.99zM26.667 6.702a9 9 0 11-9 9 9.01 9.01 0 019-9zm-16 38a4.004 4.004 0 01-4-4v-4a12.015 12.015 0 0110.707-11.928 12.959 12.959 0 0018.58.007 12.106 12.106 0 019.11 5.941c-.133-.004-.263-.02-.397-.02a14.016 14.016 0 00-14 14h-20zm34 10a10 10 0 1110-10 10.012 10.012 0 01-10 10zm7-10a2 2 0 01-2 2h-3v3a2 2 0 01-4 0v-3h-3a2 2 0 110-4h3v-3a2 2 0 014 0v3h3a2 2 0 012 2z"
    })),
    "new-group": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M14.693 26.25C13.023 24.156 12 21.538 12 18.5 12 12.17 17.257 6 24 6c6.069 0 10.745 3.702 12.241 8.32 6.811.044 12.319 5.579 12.319 12.4 0 6.848-5.552 12.4-12.4 12.4a12.36 12.36 0 01-4.979-1.04h-2.514c-2.185 0-4.825.9-6.902 2.523-2.059 1.608-3.365 3.755-3.365 6.192v2.965a2 2 0 002 2h14.72a2 2 0 010 4H20.4a6 6 0 01-6-6v-2.32H10a6 6 0 01-6-6v-2.965c0-3.992 2.16-7.202 4.902-9.344a16.4 16.4 0 015.79-2.88zM16 18.5c0-4.409 3.743-8.5 8-8.5 4.11 0 7.064 2.301 8.212 4.962-4.913 1.648-8.452 6.29-8.452 11.758 0 2.851.962 5.478 2.58 7.573-2.465.44-4.973 1.544-7.038 3.158-1.924 1.503-3.562 3.533-4.367 5.989H10a2 2 0 01-2-2v-2.965c0-2.437 1.307-4.584 3.365-6.192 2.077-1.623 4.717-2.523 6.902-2.523h.626a2 2 0 001.9-1.375 2 2 0 00-.684-2.55C17.58 24.15 16 21.64 16 18.5zm20.16-.18a8.4 8.4 0 100 16.8 8.4 8.4 0 000-16.8z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M47.68 53.76a2 2 0 004 0v-6.32H58a2 2 0 100-4h-6.32v-6.32a2 2 0 10-4 0v6.32h-6.32a2 2 0 100 4h6.32v6.32z"
    })),
    news: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M36 36a2 2 0 01-2 2H18a2 2 0 010-4h16a2 2 0 012 2zm-2 6H18a2 2 0 000 4h16a2 2 0 000-4zm2-24v10a2 2 0 01-2 2H18a2 2 0 01-2-2V18a2 2 0 012-2h16a2 2 0 012 2zm-4 2H20v6h12v-6zm24 2v28a8.01 8.01 0 01-8 8H16a8.01 8.01 0 01-8-8V10a4.004 4.004 0 014-4h28a4.004 4.004 0 014 4v8h8a4.005 4.005 0 014 4zM41.083 54A7.94 7.94 0 0140 50V10H12v40a4.005 4.005 0 004 4h25.083zM52 22h-8v28a4 4 0 108 0V22z"
    })),
    offering: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M58.299 33.47a6.422 6.422 0 00-8.3-.613V26a4.004 4.004 0 004-4v-6a4.005 4.005 0 00-4-4h-2a7.989 7.989 0 00-14-5.274A7.99 7.99 0 0020 12h-2a4.004 4.004 0 00-4 4v6a4.004 4.004 0 004 4v8.09a3.97 3.97 0 00-2 1.082l-10 10a4.004 4.004 0 000 5.656L13.173 58a4.003 4.003 0 005.656 0l2-2h22.344A3.972 3.972 0 0046 54.828L58.299 42.53a6.412 6.412 0 000-9.058zm-12.3 2.753l-2.282 1.957A6.01 6.01 0 0038 34h-2v-8h10v10.223zM50 16l.004 6H36v-6h14zM40 8a4.004 4.004 0 014 4h-8a4.004 4.004 0 014-4zM28 8a4.004 4.004 0 014 4h-8a4.004 4.004 0 014-4zm-10 8h14v6H18v-6zm14 10v8H22v-8h10zm23.472 13.701L43.17 52h-24L16 55.172 8.828 48l10-10H38a2 2 0 01.527 3.93c-.246.047-.496.07-.747.07H28a2 2 0 100 4h10a5.97 5.97 0 001.431-.173 8.01 8.01 0 003.556-1.753l9.217-7.9A2.405 2.405 0 0155.47 39.7z"
    })),
    offshore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M52 32h2a2 2 0 012 2v8a2 2 0 01-2 2h-8v6a2 2 0 01-4 0v-6H22v6a2 2 0 01-4 0v-6h-8a2 2 0 01-2-2v-8a2 2 0 012-2h6.39L8.3 19.06a2.003 2.003 0 113.4-2.12l8.44 13.5L22 9.82A2 2 0 0124 8h2a2 2 0 114 0h2a2 2 0 012 1.82l2 22c.005.06.005.12 0 .18h2v-6a6 6 0 016-6h6a2 2 0 012 2v10zm-9.414-7.414A2 2 0 0042 26v6h6v-8h-4a2 2 0 00-1.414.586zM30.53 16l-.36-4h-4.34l-.36 4h5.06zm.73 8l-.36-4h-5.8l-.36 4h6.52zm.74 8l-.37-4h-7.26L24 32h8zm-20 8h40v-4H12v4z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M57.414 57.414A2 2 0 0058 56a2 2 0 00-2.07-2.07c-1.86 0-3.01-.82-4.26-3a2.873 2.873 0 00-.33-.43 2 2 0 00-1.85-.52l-.19.05-.19.07-.18.09a2.873 2.873 0 00-.43.33c-.12.126-.225.267-.31.42-1.26 2.19-2.4 3-4.26 3-1.86 0-3.01-.82-4.26-3a2.873 2.873 0 00-.33-.43 2.07 2.07 0 00-.42-.31l-.24-.11-.24-.08a1.19 1.19 0 00-.26 0 1.737 1.737 0 00-.51 0 2.449 2.449 0 00-.37.08 1.99 1.99 0 00-.36.16 2.873 2.873 0 00-.43.33 2.07 2.07 0 00-.31.42c-1.26 2.19-2.4 3-4.26 3-1.86 0-3.01-.82-4.26-3a2.078 2.078 0 00-.54-.6 1.999 1.999 0 00-1.79-.3 1.99 1.99 0 00-.36.16 2.873 2.873 0 00-.43.33c-.12.126-.225.267-.31.42-1.26 2.19-2.4 3-4.26 3-1.86 0-3.01-.82-4.26-3a1.999 1.999 0 00-.74-.75 1.99 1.99 0 00-.36-.16 2.323 2.323 0 00-.38-.08 1.737 1.737 0 00-.51 0 2.449 2.449 0 00-.37.08 2 2 0 00-1.11.9C11 53.19 9.86 54 8 54a2 2 0 100 4 7.86 7.86 0 006-2.59A7.86 7.86 0 0020 58a7.86 7.86 0 006-2.59A7.86 7.86 0 0032 58a7.86 7.86 0 006-2.59 8.24 8.24 0 0012 0A7.86 7.86 0 0056 58a2 2 0 001.414-.586z"
    })),
    open: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M28 8a2 2 0 110 4H15.63A3.63 3.63 0 0012 15.66v32.75A3.64 3.64 0 0015.63 52H48.3a3.64 3.64 0 003.63-3.63V36a2 2 0 114 0v12.41A7.64 7.64 0 0148.3 56H15.63A7.64 7.64 0 018 48.41V15.66A7.63 7.63 0 0115.63 8H28zm28.28-4a3.65 3.65 0 013.64 3.63v14.8a2 2 0 11-4 0V10.69L34.79 31.83a2 2 0 01-1.42.58 2 2 0 01-1.37-.58A2 2 0 0132 29L53 8H41.48a2 2 0 110-4h14.8z"
    })),
    optimization: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M34.828 29.172a3.999 3.999 0 11-5.655 5.655 3.999 3.999 0 015.655-5.655zM48 32a16 16 0 11-16-16 16.018 16.018 0 0116 16zm-4 0a12 12 0 10-12 12 12.014 12.014 0 0012-12zm14 0A26 26 0 1132 6a26.03 26.03 0 0126 26zm-4 0a22 22 0 10-22 22 22.025 22.025 0 0022-22z"
    })),
    "org-chart": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M55.692 40.615h-6.461v-6.461a4.312 4.312 0 00-4.308-4.308h-10.77v-6.461h15.078a4.312 4.312 0 004.307-4.308V8.307A4.312 4.312 0 0049.231 4H14.769a4.312 4.312 0 00-4.308 4.308v10.769a4.312 4.312 0 004.308 4.308h15.077v6.461h-10.77a4.312 4.312 0 00-4.307 4.308v6.461H8.307A4.312 4.312 0 004 44.923v10.77A4.312 4.312 0 008.308 60h15.077a4.312 4.312 0 004.307-4.308V44.923a4.312 4.312 0 00-4.307-4.308h-4.309v-6.461h25.847v6.461h-4.308a4.312 4.312 0 00-4.307 4.308v10.77A4.312 4.312 0 0040.615 60h15.077A4.312 4.312 0 0060 55.692V44.923a4.312 4.312 0 00-4.308-4.308zM14.77 8.308h34.462v10.769H14.769V8.307zm8.616 47.384H8.308V44.923h15.077v10.77zm32.308 0H40.615V44.923h15.078v10.77z",
        clipRule: "evenodd"
    })),
    "parental-guide": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M56.745 39.273a16.597 16.597 0 00-12.667-16.096 13.473 13.473 0 10-24.41 0A16.597 16.597 0 007 39.273v4.145a8.3 8.3 0 008.29 8.291h8.292v2.073A6.225 6.225 0 0029.8 60h20.727a6.225 6.225 0 006.218-6.218v-2.073a8.228 8.228 0 00-1.152-4.195 8.026 8.026 0 001.152-4.096v-4.145zM31.873 8.183a9.327 9.327 0 11-9.328 9.326 9.337 9.337 0 019.327-9.327zM15.29 47.562a4.15 4.15 0 01-4.146-4.145v-4.145a12.451 12.451 0 0111.097-12.361 13.43 13.43 0 0019.261 0A12.451 12.451 0 0152.6 39.272v4.146c-.007.347-.063.69-.166 1.022a8.226 8.226 0 00-3.014-.96 9.327 9.327 0 10-18.513 0 8.297 8.297 0 00-6.204 4.084h-9.412zm30.054-5.181a5.182 5.182 0 11-10.363 0 5.182 5.182 0 0110.363 0zm7.255 11.4a2.075 2.075 0 01-2.073 2.073H29.8a2.075 2.075 0 01-2.073-2.073v-2.073a4.15 4.15 0 014.145-4.145h.541a9.318 9.318 0 0015.5 0h.541a4.15 4.15 0 014.146 4.145v2.073z",
        clipRule: "evenodd"
    })),
    "password-invisible": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M49.128 19.836c-.432-.295-.868-.559-1.303-.832l5.59-5.59a2 2 0 00-2.83-2.828l-6.4 6.401A28.26 28.26 0 0032 14C16.919 14 4 28.582 4 32c0 2.104 4.898 8.434 12.178 12.993l-5.592 5.593a2 2 0 102.828 2.828l6.405-6.405A28.19 28.19 0 0032 50c15.081 0 28-14.582 28-18 0-2.477-5.182-8.275-10.872-12.164zM8.092 32C9.532 29.088 19.852 18 32 18a23.55 23.55 0 019.174 1.998l-2.232 2.232A11.98 11.98 0 0022.23 38.942L19.073 42.1C13.17 38.609 8.97 33.779 8.092 32zM40 32a7.984 7.984 0 01-12.056 6.884l6.378-6.378A1.996 1.996 0 0038.25 32c0-.957-.231-1.9-.673-2.75l1.307-1.306A7.94 7.94 0 0140 32zm-16 0a7.985 7.985 0 0112.056-6.884l-1.394 1.394A5.96 5.96 0 0032.25 26a1.995 1.995 0 00-.87 3.793l-6.264 6.263A7.939 7.939 0 0124 32zm8 14a23.5 23.5 0 01-9.175-1.997l2.233-2.233A11.98 11.98 0 0041.77 25.058l3.156-3.156c.7.415 1.353.832 1.945 1.237a32.513 32.513 0 019.032 8.873C54.441 34.942 44.133 46 32 46z"
    })),
    "password-visible": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M32 20a12 12 0 1012 12 12.013 12.013 0 00-12-12zm0 20a8 8 0 118-8 8.01 8.01 0 01-8 8zm6.25-8a2 2 0 01-4 0 2.003 2.003 0 00-2-2 2 2 0 010-4 6.006 6.006 0 016 6zm10.878-12.164C43.54 16.018 37.618 14 32 14 16.919 14 4 28.582 4 32c0 3.418 12.919 18 28 18s28-14.582 28-18c0-2.477-5.182-8.275-10.872-12.164zM32 46C19.852 46 9.531 34.912 8.092 32 9.532 29.088 19.852 18 32 18c6.075 0 11.44 2.794 14.871 5.139a32.513 32.513 0 019.032 8.873C54.441 34.942 44.133 46 32 46z"
    })),
    "pay-monthly": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M4 12a8 8 0 018-8h40a8 8 0 018 8v40a8 8 0 01-8 8H12a8 8 0 01-8-8V12zm8-4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V12a4 4 0 00-4-4H12z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M15.44 48.56a1.5 1.5 0 010-2.12l31-31a1.5 1.5 0 012.12 2.12l-31 31a1.5 1.5 0 01-2.12 0z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M22.5 25.5c.42 0 .9-.74.9-1.44 0-.3-.16-.46-.5-.46h-4.68c-.02-.08-.02-.28-.02-.58 0-.34 0-.56.02-.66h4.98c.42 0 .9-.74.9-1.44 0-.3-.16-.46-.5-.46h-4.84c.72-1.46 1.8-2.2 3.22-2.2.62 0 1.3.22 2.04.64.14.08.28.12.38.12.18 0 .38-.08.56-.26.36-.32.64-.94.64-1.58 0-.22-.1-.4-.3-.54-.98-.62-2.06-.94-3.24-.94-2.78 0-5.16 1.82-6.2 4.76h-.28c-.62 0-1.3.44-1.3.84 0 .38.42.8.62.94.1.08.18.12.28.12h.24c-.02.1-.02.32-.02.66 0 .3 0 .5.02.58h-.12c-.62 0-1.3.44-1.3.84 0 .38.42.8.62.94.1.08.18.12.28.12h.78c.86 3.02 3.08 4.8 6.04 4.8 1.12 0 2.24-.26 2.88-.64.56-.34.92-1.08.92-1.86 0-.42-.24-.64-.7-.64-.22 0-.58.08-1.06.22-.78.24-1.4.36-1.84.36-1.5 0-2.58-.74-3.22-2.24h3.8zm17.244 23.196c.24.272.48.4.688.4.512 0 1.008-.816 1.008-1.648 0-.176-.048-.304-.144-.4L37.184 43l3.344-3.088c.432-.384.688-1.04.688-1.632 0-.384-.208-.576-.64-.576-.496 0-1.008.208-1.376.544l-3.888 3.6V38.28c0-.384-.208-.576-.624-.576-.784 0-1.6.528-1.6 1.04v9.072c0 .304.544 1.28 1.104 1.28s1.12-.864 1.12-1.744v-3.136l4.432 4.48zm9.625 0c.24.272.48.4.688.4.512 0 1.008-.816 1.008-1.648 0-.176-.048-.304-.144-.4L46.809 43l3.344-3.088c.432-.384.688-1.04.688-1.632 0-.384-.208-.576-.64-.576-.496 0-1.008.208-1.376.544l-3.888 3.6V38.28c0-.384-.208-.576-.624-.576-.784 0-1.6.528-1.6 1.04v9.072c0 .304.544 1.28 1.104 1.28s1.12-.864 1.12-1.744v-3.136l4.432 4.48z"
    })),
    "pay-once": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M3.962 10.97a7.003 7.003 0 017.007-7.007h41.986c3.87 0 7.007 3.13 7.007 7.007v41.985a7.004 7.004 0 01-7.007 7.008H10.97a7.004 7.004 0 01-7.007-7.008V10.97zm3.5 0v41.985a3.504 3.504 0 003.507 3.508h41.986a3.504 3.504 0 003.507-3.508V10.97a3.503 3.503 0 00-3.507-3.507H10.97a3.503 3.503 0 00-3.507 3.507zm20.759 25.206c1.158 2.704 3.102 4.055 5.83 4.055.795 0 1.906-.217 3.33-.65.87-.267 1.51-.4 1.92-.4.844 0 1.267.386 1.267 1.159 0 .7-.15 1.358-.453 1.974-.302.614-.706 1.08-1.213 1.394-.579.337-1.34.615-2.281.832a12.97 12.97 0 01-2.933.326c-2.679 0-4.978-.766-6.897-2.3-1.92-1.532-3.265-3.663-4.037-6.39h-1.412c-.169 0-.344-.066-.525-.199-.182-.133-.416-.368-.707-.705-.265-.339-.398-.677-.398-1.014 0-.363.254-.707.761-1.033.506-.325 1.037-.489 1.593-.489h.217c-.024-.144-.037-.494-.037-1.05 0-.627.013-1.025.037-1.194h-.434c-.17 0-.345-.067-.525-.2-.181-.132-.417-.367-.706-.706-.266-.337-.4-.675-.4-1.013 0-.362.255-.706.761-1.032a2.899 2.899 0 011.594-.489h.506c.942-2.655 2.42-4.755 4.436-6.3 2.016-1.544 4.278-2.317 6.789-2.317 2.124 0 4.079.567 5.865 1.701.363.242.543.567.543.978a4.02 4.02 0 01-.344 1.647c-.228.52-.506.93-.833 1.231-.325.302-.657.453-.995.453-.194 0-.422-.072-.688-.217-1.351-.772-2.583-1.159-3.693-1.159-2.583 0-4.526 1.328-5.83 3.983h8.763c.603 0 .904.278.904.833a3.27 3.27 0 01-.525 1.774c-.35.555-.717.833-1.103.833h-9.016c-.024.169-.036.567-.036 1.194 0 .556.012.906.036 1.05h8.472c.604 0 .905.278.905.833 0 .628-.175 1.22-.525 1.775-.35.555-.717.832-1.103.832h-6.88z",
        clipRule: "evenodd"
    })),
    "payment-success": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M56 30.836V16a8.01 8.01 0 00-8-8H12a8.01 8.01 0 00-8 8v20a8.01 8.01 0 008 8h18.302A14.997 14.997 0 1056 30.836zM12 12h36a4.004 4.004 0 014 4v2H8v-2a4.004 4.004 0 014-4zM8 36V22h44v5.743A14.97 14.97 0 0030.05 40H12a4.004 4.004 0 01-4-4zm37 16c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11c-.007 6.072-4.928 10.993-11 11zm6.664-13.89l-6 8.999a1.998 1.998 0 01-3.078.305l-4-4a2 2 0 112.828-2.828l2.275 2.274 4.647-6.97a2 2 0 113.328 2.22z",
        clipRule: "evenodd"
    })),
    payment: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M44 8a8 8 0 017.93 6.91c.044.362.067.726.07 1.09a8 8 0 018 8v24a8 8 0 01-8 8H12a8 8 0 01-8-8V14a6 6 0 016-6zM8 19.65V48a4 4 0 004 4h40a4 4 0 004-4v-4H46a8 8 0 110-16h10v-4a4 4 0 00-4-4H10a5.8 5.8 0 01-2-.35zM56 32H46a4 4 0 100 8h10v-8zm-10 2a2 2 0 110 4 2 2 0 010-4zm-2-22H10a2 2 0 000 4h38a3.882 3.882 0 00-.18-1.19l-.067-.198A4 4 0 0044 12z"
    })),
    pebble: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M59 17.517C59 7.476 51.703 4 43.638 4 26.739 4 6 15.2 6 29.49 6 40.69 20.978 60 32.116 60 42.87 60 59 42.234 59 17.517z",
        clipRule: "evenodd"
    })),
    "people-hub": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M53.998 40a5.981 5.981 0 00-4.293 1.817l-4.638-2.141a17.899 17.899 0 00-5.903-19.768l2.533-4.054a6.016 6.016 0 10-3.389-2.122l-2.536 4.058a17.966 17.966 0 00-21.208 28.148l-2.27 2.52a6.002 6.002 0 102.974 2.677l2.266-2.518a17.92 17.92 0 0025.845-5.315l4.647 2.144A6 6 0 1053.998 40zm-11-32a2 2 0 110 4 2 2 0 010-4zm-15 12a13.998 13.998 0 0112.89 19.462c-.078-.153-.142-.314-.229-.463a10.019 10.019 0 00-5.127-4.333 7.999 7.999 0 10-15.07-.008 10.043 10.043 0 00-5.358 4.794A14 14 0 0127.998 20zm0 16a4 4 0 110-8 4 4 0 010 8zm-18 20a2 2 0 110-4 2 2 0 010 4zm18-8a13.953 13.953 0 01-9.99-4.21 6.005 6.005 0 014.841-5.677 7.97 7.97 0 0010.288.01 5.94 5.94 0 014.848 5.671A13.952 13.952 0 0127.998 48zm26 0a2 2 0 110-4.001 2 2 0 010 4.001z"
    })),
    people: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M60.166 30.333V26a10.842 10.842 0 00-7.002-10.12 8.667 8.667 0 10-16.329 0A10.87 10.87 0 0032 19.527a10.869 10.869 0 00-4.836-3.649 8.667 8.667 0 10-16.329 0A10.842 10.842 0 003.833 26v4.334a6.507 6.507 0 006.5 6.5c.002.982.172 1.956.502 2.88a10.842 10.842 0 00-7.002 10.12v4.334a6.507 6.507 0 006.5 6.5h17.333A6.466 6.466 0 0032 58.997a6.466 6.466 0 004.333 1.67h17.333a6.507 6.507 0 006.5-6.5v-4.334a10.842 10.842 0 00-7.002-10.12c.33-.924.5-1.898.502-2.88a6.507 6.507 0 006.5-6.5zM45 8.667a4.333 4.333 0 110 8.666 4.333 4.333 0 010-8.666zm-26 0a4.333 4.333 0 110 8.666 4.333 4.333 0 010-8.666zm10.833 45.5a2.17 2.17 0 01-2.167 2.166H10.333a2.17 2.17 0 01-2.167-2.166v-4.334a6.509 6.509 0 015.255-6.377 8.634 8.634 0 0011.157 0 6.509 6.509 0 015.255 6.377v4.334zM14.666 36.833a4.333 4.333 0 118.667 0 4.333 4.333 0 01-8.667 0zm41.167 13v4.334a2.17 2.17 0 01-2.167 2.166H36.333a2.17 2.17 0 01-2.167-2.166v-4.334a6.509 6.509 0 015.255-6.377 8.634 8.634 0 0011.157 0 6.509 6.509 0 015.255 6.377zm-15.167-13a4.333 4.333 0 118.667 0 4.333 4.333 0 01-8.667 0zM52.494 32.5a8.654 8.654 0 00-15.659 7.213A10.87 10.87 0 0032 43.36a10.87 10.87 0 00-4.836-3.648A8.656 8.656 0 0011.506 32.5h-1.173a2.17 2.17 0 01-2.167-2.167V26a6.508 6.508 0 015.255-6.378 8.634 8.634 0 0011.157 0A6.508 6.508 0 0129.833 26v4.333a2.167 2.167 0 104.333 0V26a6.509 6.509 0 015.255-6.378 8.634 8.634 0 0011.157 0A6.508 6.508 0 0155.833 26v4.333a2.17 2.17 0 01-2.167 2.167h-1.172z",
        clipRule: "evenodd"
    })),
    "pet-dog": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M56.877 17.517l-9.705-3.235-7.866-9.44A3 3 0 0034 6.762v13.681a4.018 4.018 0 01-3.693 3.99l-18.995 1.461-3.455-8.637a2 2 0 00-3.714 1.486L8 28.387v12.785L5.172 44A3.974 3.974 0 004 46.828V52a6.007 6.007 0 006 6h2a6.006 6.006 0 006-6v-1.04L26.7 44h5.79l3.173 11.1A4.016 4.016 0 0039.51 58H42a6.006 6.006 0 006-6v-5.845c0-3.247.478-6.477 1.419-9.586L51.47 30h2.967a3.994 3.994 0 003.88-3.03l1.173-4.687a4.02 4.02 0 00-2.614-4.766zM54.437 26H46a2 2 0 000 4h1.28l-1.696 5.433-.031.11A37.218 37.218 0 0044 46.155V52a2.003 2.003 0 01-2 2h-2.491l-3.172-11.099a4.017 4.017 0 00-3.847-2.9H26.7c-.908 0-1.789.31-2.498.876l-8.702 6.96a3.982 3.982 0 00-1.5 3.125V52a2.003 2.003 0 01-2 2h-2a2.003 2.003 0 01-2-2v-5.172L10.828 44A3.97 3.97 0 0012 41.172v-11.32l18.613-1.432A8.037 8.037 0 0038 20.443V9.523l6.099 7.32c.476.572 1.102 1 1.808 1.234l9.703 3.235L54.438 26z"
    })),
    "phone-recycling": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M46.655 50.135a2.053 2.053 0 114.106 0 2.053 2.053 0 01-4.106 0zM60 19.339v34.902a4.11 4.11 0 01-4.106 4.106H41.523a4.11 4.11 0 01-4.107-4.106V39.87a2.053 2.053 0 114.107 0v2.053h14.37V19.339h-14.37v4.106a2.053 2.053 0 01-4.107 0V19.34a4.11 4.11 0 014.107-4.106h14.37A4.11 4.11 0 0160 19.34zm-4.106 26.69H41.523v8.212h14.37V46.03zM37.444 29.62l-2.938-5.141a2.053 2.053 0 10-3.564 2.037l2.937 5.14h-7.93l.6-.6a2.053 2.053 0 10-2.902-2.904L19.54 32.26a2.032 2.032 0 00-.385.553 2.045 2.045 0 00-.174.488l-.004.013a2.054 2.054 0 00-.014.654c.02.18.064.357.13.526l.001.004.01.014c.069.159.159.308.266.444.03.038.058.074.09.11.028.032.05.067.08.097l4.106 4.106a2.053 2.053 0 002.903-2.903l-.602-.601h7.93a4.106 4.106 0 003.566-6.143zm-22.61 2.037H8.105l4.178-7.313.601 1.803a2.053 2.053 0 003.896-1.299l-2.053-6.16c-.015-.043-.038-.08-.055-.122a1.58 1.58 0 00-.194-.366 2.018 2.018 0 00-.112-.156 2.024 2.024 0 00-.153-.164 1.673 1.673 0 00-.123-.115 2.07 2.07 0 00-.212-.152c-.028-.018-.051-.04-.08-.057-.013-.007-.026-.01-.038-.017a2.043 2.043 0 00-.253-.112c-.04-.016-.08-.034-.12-.047a2.013 2.013 0 00-.262-.058c-.043-.007-.086-.018-.13-.023a2.009 2.009 0 00-.25-.005c-.051 0-.101-.002-.151.003-.072.008-.144.02-.215.037-.064.013-.128.024-.19.043-.02.006-.04.007-.06.014L5.97 19.444a2.053 2.053 0 001.3 3.895l1.06-.353-3.79 6.634a4.106 4.106 0 003.565 6.143h6.727a2.053 2.053 0 100-4.106zm9.922-15.966l-1.06-.354a2.053 2.053 0 10-1.3 3.896l6.159 2.053c.02.007.039.004.058.01.18.055.366.085.554.09.013 0 .025.006.038.006.009 0 .017-.004.026-.004a2.01 2.01 0 00.549-.086l.443-.181c.039-.022.07-.052.107-.076a2.068 2.068 0 00.512-.469c.007-.01.012-.022.02-.032a2.04 2.04 0 00.259-.496c.008-.022.024-.038.031-.06l2.053-6.16a2.053 2.053 0 00-3.895-1.298l-.601 1.803-4.152-7.265a4.105 4.105 0 00-7.13 0l-2.91 5.093a2.053 2.053 0 003.565 2.037l2.91-5.093 3.764 6.586z",
        clipRule: "evenodd"
    })),
    "phone-ringing": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M40.827 40a4.002 4.002 0 00-5.657 0L32 43.172 20.827 32l3.172-3.172a4.004 4.004 0 000-5.656L16.827 16a4.002 4.002 0 00-5.657 0l-1.272 1.273a18.019 18.019 0 000 25.454L21.271 54.1a18.02 18.02 0 0025.455 0L48 52.828a4.004 4.004 0 000-5.656L40.827 40zm3.071 11.273a14.015 14.015 0 01-19.799 0L12.726 39.9a14.017 14.017 0 010-19.8L14 18.829 21.17 26 18 29.172a4.004 4.004 0 000 5.656L29.17 46a4.002 4.002 0 005.656 0l3.172-3.172L45.17 50l-1.272 1.273zM57.998 30a2 2 0 01-4 0 20.022 20.022 0 00-20-20 2 2 0 010-4 24.027 24.027 0 0124 24zm-8 0a2 2 0 01-4 0 12.013 12.013 0 00-12-12 2 2 0 010-4 16.018 16.018 0 0116 16zm-16-4a2 2 0 010-4 8.01 8.01 0 018 8 2 2 0 01-4 0 4.005 4.005 0 00-4-4z"
    })),
    phone: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M58.742 44.261L49.681 35.2a4.54 4.54 0 00-6.273 0l-4.166 4.166a2.221 2.221 0 01-3.138.001l-11.47-11.471a2.216 2.216 0 010-3.136l4.167-4.167a4.442 4.442 0 000-6.272l-9.062-9.063a4.54 4.54 0 00-6.273 0l-3.629 3.63c-7.783 7.8-7.783 20.428 0 28.228l17.048 17.048c7.8 7.783 20.428 7.783 28.229 0l3.63-3.63a4.442 4.442 0 00-.002-6.272zm-6.765 6.766c-6.067 6.053-15.89 6.053-21.956 0L12.973 33.979c-6.053-6.067-6.053-15.89 0-21.956l3.63-3.63 9.061 9.063-4.166 4.166a6.652 6.652 0 000 9.41l11.47 11.472a6.664 6.664 0 009.41-.001l4.166-4.167 9.062 9.062-3.629 3.629z",
        clipRule: "evenodd"
    })),
    "pie-chart": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M38.406 4.017a3.983 3.983 0 00-3.034 1.01 4.028 4.028 0 00-1.319 2.978v21.943H55.99a4.039 4.039 0 002.984-1.321 3.95 3.95 0 001.01-3.031c-1.127-11.418-10.16-20.451-21.578-21.58zm-.35 21.925l-.038-17.937a20.045 20.045 0 0117.974 17.937H38.055zm5.9 10.017H28.042V20.045a4.037 4.037 0 00-1.339-3 3.951 3.951 0 00-3.057-.992C12.236 17.299 3.693 27.095 4.008 38.568c.316 11.474 9.386 20.784 20.847 21.401.393.021.784.032 1.173.031 11.248.003 20.695-8.464 21.92-19.645a3.951 3.951 0 00-.992-3.057 4.037 4.037 0 00-3-1.34zm-18.89 20.009c-9.368-.507-16.782-8.112-17.05-17.49-.27-9.377 6.697-17.395 16.02-18.437v15.918a4.011 4.011 0 004.008 4.007l15.922-.041c-1.06 9.508-9.346 16.543-18.9 16.043z",
        clipRule: "evenodd"
    })),
    pin: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M47.792 37.385A17.089 17.089 0 0042 27.008V14.472l2.342-4.683A4.001 4.001 0 0040.763 4H23.235a4 4 0 00-3.578 5.79L22 14.471v12.536a17.088 17.088 0 00-5.793 10.377A4.003 4.003 0 0020.166 42h9.833v14a2 2 0 004 0V42h9.834a4.003 4.003 0 003.96-4.615zM40.762 8l-1.999 4H25.235l-2-4h17.527zm-8.715 30.005c-.016 0-.03-.005-.048-.005-.017 0-.032.004-.049.005l-11.793.005a12.9 12.9 0 014.652-8.125A2.978 2.978 0 0026 27.5V16h12v11.501a2.978 2.978 0 001.19 2.384A12.854 12.854 0 0143.832 38l-11.785.005z"
    })),
    place: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 4a20 20 0 0120 20c0 12.49-13.63 28.11-17.81 32.55a3 3 0 01-2.19 1l-.207-.007a3 3 0 01-1.983-.943C25.63 52.11 12 36.49 12 24c0-11.046 8.954-20 20-20zm0 4c-8.837 0-16 7.163-16 16 0 10.53 12.07 24.73 16 29.07C35.93 48.73 48 34.53 48 24c0-8.837-7.163-16-16-16zm0 6a10 10 0 0110 10c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10zm0 4a6 6 0 100 12 6 6 0 000-12z"
    })),
    plane: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M57.234 30.849l-7.428-4.727a13.913 13.913 0 00-7.481-2.178h-1.666l-10.8-10.877a2.071 2.071 0 00-.117-.109A3.983 3.983 0 0027.15 12h-2.886a3.98 3.98 0 00-3.927 4.636l1.218 7.308H16.94l-4.778-6.372a4.003 4.003 0 00-3.184-1.59H7.98A3.985 3.985 0 004 19.961v11.475a5.94 5.94 0 003.3 5.34l4.7 2.35a25.78 25.78 0 005.682 2.05l-3.1 4.34a3.98 3.98 0 003.239 6.295h5.402a4.009 4.009 0 002.444-.838l11.72-9.115h16.64a5.972 5.972 0 003.207-11.01zM24.265 15.98h2.877l7.907 7.963h-9.457l-1.327-7.963zm-1.042 31.85h-5.402l7.11-9.953 11.107-.016-.018.016h-.17v.133l-12.627 9.82zm32.716-11.388a1.923 1.923 0 01-1.911 1.435H40.004a4.05 4.05 0 00-.219-1.293 3.932 3.932 0 00-3.765-2.688H24.93a3.987 3.987 0 00-3.24 1.668l-1.459 2.043a21.778 21.778 0 01-6.45-2.041l-4.7-2.35a1.98 1.98 0 01-1.1-1.78V19.962h.996l4.778 6.372a4.003 4.003 0 003.184 1.59h25.386a9.94 9.94 0 015.343 1.557l7.428 4.727a1.923 1.923 0 01.843 2.235z",
        clipRule: "evenodd"
    })),
    play: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M51.068 26.927L21.155 10.153A6 6 0 0012 15.257v33.486a5.922 5.922 0 003.104 5.254 5.926 5.926 0 006.051-.15l29.823-16.72.09-.054a6.002 6.002 0 000-10.146zm-2.1 6.74l-29.81 16.714-.09.053A2 2 0 0116 48.744V15.256a1.96 1.96 0 011.035-1.751c.3-.165.637-.254.98-.257.374.002.74.113 1.053.317l29.9 16.767a2 2 0 010 3.334z"
    })),
    "player-settings": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M52 12H12a8.01 8.01 0 00-8 8v20a8.01 8.01 0 008 8h4v5.586a2.999 2.999 0 005.121 2.121L28.828 48H52a8.01 8.01 0 008-8V20a8.01 8.01 0 00-8-8zm4 28a4.005 4.005 0 01-4 4H27.172L20 51.172V44h-8a4.004 4.004 0 01-4-4V20a4.004 4.004 0 014-4h40a4.005 4.005 0 014 4v20zm-4-10a2 2 0 01-2 2H14a2 2 0 010-4h36a2 2 0 012 2zm-10 8a2 2 0 01-2 2H14a2 2 0 010-4h26a2 2 0 012 2z"
    })),
    "plus-minus": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M45 14.666H19c-9.573 0-17.333 7.76-17.333 17.334 0 9.573 7.76 17.333 17.333 17.333h26c9.573 0 17.334-7.76 17.334-17.333 0-9.573-7.76-17.334-17.334-17.334zM45 45H19c-7.18 0-13-5.82-13-13s5.82-13 13-13h26c7.18 0 13 5.82 13 13s-5.82 13-13 13zM27.667 32c0 1.196-.97 2.166-2.167 2.166H14.667a2.167 2.167 0 110-4.333H25.5c1.197 0 2.167.97 2.167 2.167zM51.5 32c0 1.196-.97 2.166-2.166 2.166h-3.25v3.25a2.167 2.167 0 01-4.334 0v-3.25H38.5a2.167 2.167 0 110-4.333h3.25v-3.25a2.167 2.167 0 014.334 0v3.25h3.25c1.196 0 2.166.97 2.166 2.167z",
        clipRule: "evenodd"
    })),
    plus: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M34.167 52V13a2.167 2.167 0 00-4.334 0v39a2.167 2.167 0 004.334 0z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M51.5 30h-39a2.167 2.167 0 000 4.333h39a2.167 2.167 0 100-4.333z",
        clipRule: "evenodd"
    })),
    police: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M38.36 41.78a2.1 2.1 0 01-.94-.23L32 38.7l-5.42 2.85a2 2 0 01-2.11-.15 2 2 0 01-.8-2l1-6-4.39-4.28a2 2 0 011.11-3.41l6.06-.88 2.72-5.5a2 2 0 013.58 0l2.72 5.5 6.06.88a2 2 0 011.11 3.41l-4.35 4.28 1 6a2 2 0 01-2 2.34l.07.04zM32 34.44a1.91 1.91 0 01.93.23l2.77 1.45-.53-3.12a2 2 0 01.58-1.77L38 29.09l-3.1-.45a2 2 0 01-1.51-1.1L32 24.74l-1.38 2.8a2 2 0 01-1.51 1.1l-3.1.45 2.24 2.18a2 2 0 01.58 1.73l-.53 3.08 2.77-1.45c.29-.14.61-.206.93-.19z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 57a1.837 1.837 0 01-.41 0C18.08 54.11 10 43.56 10 35c.097-2.94.499-5.863 1.2-8.72 1.11-5.3 1.68-8.66-.59-10.84a2 2 0 010-2.85l5-5a2 2 0 012.35-.36 13.21 13.21 0 0013.13 0 2 2 0 011.86 0 13.21 13.21 0 0013.13 0 2 2 0 012.35.36l5 5a2 2 0 010 2.85c-2.27 2.18-1.7 5.54-.59 10.84A42.42 42.42 0 0154 35c0 8.56-8.08 19.11-21.59 22a1.837 1.837 0 01-.41 0zM14.69 14.13c2.375 3.662 1.394 8.369.437 12.97l-.007.03A39.373 39.373 0 0014 35c0 6.73 6.87 15.43 18 18 11.13-2.52 18-11.22 18-18a39.367 39.367 0 00-1.12-7.9c-1-4.58-2-9.3.43-13l-2.72-2.71A16.89 16.89 0 0132 11.23a16.89 16.89 0 01-14.59.19l-2.72 2.71z",
        clipRule: "evenodd"
    })),
    portal: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M13 17.707c0 .85-.672 1.54-1.5 1.54s-1.5-.69-1.5-1.54c0-.85.672-1.54 1.5-1.54s1.5.69 1.5 1.54zm5 0c0 .85-.672 1.54-1.5 1.54s-1.5-.69-1.5-1.54c0-.85.672-1.54 1.5-1.54s1.5.69 1.5 1.54z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M8 11a4 4 0 00-4 4v34a4 4 0 004 4h48a4 4 0 004-4V15a4 4 0 00-4-4H8zm0 4h48v5.64H8V15zm0 9.64V49h48V24.64H8z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 26a7 7 0 00-6.386 9.872A6.998 6.998 0 0022 42v1a4 4 0 004 4h12a4 4 0 004-4v-1a6.998 6.998 0 00-3.614-6.128A7 7 0 0032 26zm-3 7a3 3 0 116 0 3 3 0 01-6 0zm6.53 6.047A6.968 6.968 0 0132 40a6.968 6.968 0 01-3.53-.953A3 3 0 0026 42v1h12v-1a3 3 0 00-2.47-2.953z",
        clipRule: "evenodd"
    })),
    position: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M4.683 29.9L53.21 8.149a2 2 0 012.643 2.643L34.1 59.317a2 2 0 01-3.722-.186L24 40 4.869 33.623a2 2 0 01-.186-3.722zm6.32 1.551l14.262 4.754a4 4 0 012.53 2.53l4.754 14.262 17.506-39.052-39.052 17.506z"
    })),
    "power-grid": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M52 32h-8.964l-.04-.21c.081-.057.158-.12.23-.188L50.828 24A3.975 3.975 0 0052 21.172V20a4.005 4.005 0 00-4-4h-8.04l-1.685-8.755A4.004 4.004 0 0034.348 4h-4.696a4.004 4.004 0 00-3.927 3.244L24.04 16H16a4.004 4.004 0 00-4 4v1.172A3.973 3.973 0 0013.172 24l7.825 7.825-.034.175H12a4.004 4.004 0 00-4 4v1.172A3.973 3.973 0 009.172 40l8 8H16a4.004 4.004 0 00-4 4v4a4.004 4.004 0 004 4h32a4.004 4.004 0 004-4v-4a4.005 4.005 0 00-4-4h-1.172l8-8A3.975 3.975 0 0056 37.172V36a4.005 4.005 0 00-4-4zm-4-12v1.172l-5.91 5.91L40.73 20H48zM29.652 8h4.696l1.538 8h-7.772l1.538-8zm-2.308 12h9.31l2.309 12H25.036l2.308-12zm-3.077 16h15.466l2.308 12H21.959l2.308-12zM16 21.172V20h7.271l-1.362 7.081L16 21.172zm-4 16V36h8.194l-1.51 7.855L12 37.172zM48 52v4H16l-.003-4H48zm4-14.828l-6.683 6.683L43.806 36H52v1.172z"
    })),
    "premises-datacenter": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M14 10a4 4 0 00-4 4v36a4 4 0 004 4h36a4 4 0 004-4V14a4 4 0 00-4-4H14zm0 4h36v36H38v-9a2 2 0 00-2-2h-8a2 2 0 00-2 2v9H14V14zm16 36h4v-7h-4v7z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M20 23a2 2 0 012-2h20a2 2 0 110 4H22a2 2 0 01-2-2zm0 9a2 2 0 012-2h20a2 2 0 110 4H22a2 2 0 01-2-2z",
        clipRule: "evenodd"
    })),
    "premises-large": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M16 15a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm14-21a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm-7 0a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M8 8a4 4 0 014-4h26a4 4 0 014 4v9.01c.166-.007.333-.01.5-.01C49.956 17 56 23.044 56 30.5S49.956 44 42.5 44c-.167 0-.334-.003-.5-.01V56a4 4 0 01-4 4H12a4 4 0 01-4-4V8zm30 35.232c-5.243-1.853-9-6.854-9-12.732 0-5.878 3.757-10.879 9-12.732V8H12v48h7v-9a2 2 0 012-2h8a2 2 0 012 2v9h7V43.232zM27 56h-4v-7h4v7zm6-25.5a9.5 9.5 0 1119 0 9.5 9.5 0 01-19 0z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M45.022 35c.14 0 .28-.07.434-.196.28-.266.504-.77.504-1.274 0-.322-.168-.49-.518-.49h-3.64v-7.42c0-.336-.182-.504-.546-.504-.686 0-1.4.462-1.4.91v7.854c0 .266.476 1.12.966 1.12h4.2z"
    })),
    "premises-medium": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M16 15a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm14-21a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm-7 0a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M8 8a4 4 0 014-4h26a4 4 0 014 4v9.01c.166-.007.333-.01.5-.01C49.956 17 56 23.044 56 30.5S49.956 44 42.5 44c-.167 0-.334-.003-.5-.01V56a4 4 0 01-4 4H12a4 4 0 01-4-4V8zm30 35.232c-5.243-1.853-9-6.854-9-12.732 0-5.878 3.757-10.879 9-12.732V8H12v48h7v-9a2 2 0 012-2h8a2 2 0 012 2v9h7V43.232zM27 56h-4v-7h4v7zm6-25.5a9.5 9.5 0 1119 0 9.5 9.5 0 01-19 0z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M45.647 33.992c0 .294.49 1.092.938 1.092.154 0 .294-.07.448-.21.28-.266.504-.77.504-1.274v-7.994c0-.322-.196-.49-.532-.49h-.896c-.56 0-1.148.308-1.33.7l-2.184 4.704-2.492-5.124c-.084-.182-.252-.28-.518-.28h-.77c-.672 0-1.358.448-1.358.882v7.994c0 .294.434 1.092.938 1.092.154 0 .294-.07.448-.21.28-.266.504-.77.504-1.274v-5.684l2.044 4.102c.084.168.154.294.224.364.238.308.49.462.728.462h.49c.294 0 .532-.21.742-.616l2.072-4.312v6.076z"
    })),
    "premises-small": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M16 15a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm14-21a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm-7 0a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M8 8a4 4 0 014-4h26a4 4 0 014 4v9.01c.166-.007.333-.01.5-.01C49.956 17 56 23.044 56 30.5S49.956 44 42.5 44c-.167 0-.334-.003-.5-.01V56a4 4 0 01-4 4H12a4 4 0 01-4-4V8zm30 35.232c-5.243-1.853-9-6.854-9-12.732 0-5.878 3.757-10.879 9-12.732V8H12v48h7v-9a2 2 0 012-2h8a2 2 0 012 2v9h7V43.232zM27 56h-4v-7h4v7zm6-25.5a9.5 9.5 0 1119 0 9.5 9.5 0 01-19 0z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M46.071 32.256c0-1.456-.798-2.394-2.59-3.066-.686-.266-1.176-.462-1.47-.616-.588-.28-.756-.49-.756-.868 0-.504.574-.854 1.372-.854.504 0 1.064.182 1.68.546.14.084.252.126.35.126.434 0 .854-.658.854-1.33a.458.458 0 00-.21-.406 4.651 4.651 0 00-2.604-.798 3.97 3.97 0 00-1.68.35c-1.022.462-1.722 1.358-1.722 2.408 0 1.386.798 2.184 2.87 2.954.742.266 1.246.518 1.526.742.28.224.42.504.42.826 0 .63-.602 1.036-1.512 1.036-.77 0-1.358-.28-1.988-.994a.538.538 0 00-.406-.154c-.63 0-1.274.42-1.274.826 0 .112.056.266.168.448.182.322.462.616.826.882.728.532 1.722.896 2.674.896.63 0 1.204-.126 1.736-.378 1.05-.49 1.736-1.442 1.736-2.576z"
    })),
    premises: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M19 4a4 4 0 00-4 4v48a4 4 0 004 4h26a4 4 0 004-4V8a4 4 0 00-4-4H19zm0 4h26v48h-6v-9a2 2 0 00-2-2H27a2 2 0 00-2 2v9h-6V8zm10 48h6v-7h-6v7z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M23 15a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm0 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm14-21a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm-7 0a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm7 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm-7 0a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm7 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm-7 0a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm7 7a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2zm-7 0a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 01-1 1h-2a1 1 0 01-1-1v-2z"
    })),
    present: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M56 17h-8.061A8.99 8.99 0 0032 10.356 8.993 8.993 0 0016.056 17H8a3.848 3.848 0 00-4 3.668v6.666A3.848 3.848 0 008 31v18a8.01 8.01 0 008 8h32a8.01 8.01 0 008-8V31a3.848 3.848 0 004-3.666v-6.666A3.848 3.848 0 0056 17zm-17-6a4.972 4.972 0 014.893 6h-9.781A4.953 4.953 0 0139 11zm-19 5a5 5 0 119.889 1h-9.784A5.03 5.03 0 0120 16zm10 5v6H8v-6h22zM12 49V31h18v22H16a4.004 4.004 0 01-4-4zm40 0a4.004 4.004 0 01-4 4H34V31h18v18zM34 27v-6h22v6H34z",
        clipRule: "evenodd"
    })),
    "press-button": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M46.06 30.964a6.186 6.186 0 00-2.293.437 6.246 6.246 0 00-2.986-3.799 14.514 14.514 0 10-17.535 4.028v2.607a6.335 6.335 0 00-7.173-2.218 6.224 6.224 0 00-3.454 8.546l7.123 14.746A8.34 8.34 0 0027.212 60h16.774a8.306 8.306 0 008.296-8.296V37.186a6.229 6.229 0 00-6.222-6.222zM19.098 18.519a10.37 10.37 0 1116.592 8.296v-8.117a6.368 6.368 0 00-5.618-6.372 6.223 6.223 0 00-6.826 6.193v8.296a10.392 10.392 0 01-4.148-8.296zm29.037 33.185a4.152 4.152 0 01-4.148 4.148H27.212a4.17 4.17 0 01-3.736-2.344L16.354 38.76a2.077 2.077 0 011.16-2.852 1.85 1.85 0 01.646-.115 2.287 2.287 0 012.008 1.324l2.472 5.118a2.075 2.075 0 001.867 1.172h.813a2.074 2.074 0 002.074-2.074V18.519a2.073 2.073 0 012.285-2.063 2.19 2.19 0 011.863 2.242v14.34a2.074 2.074 0 004.148 0 2.074 2.074 0 114.148 0v4.148a2.074 2.074 0 004.148 0 2.074 2.074 0 114.149 0v14.518z",
        clipRule: "evenodd"
    })),
    price: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M58.72 13.42A4 4 0 0055.66 12h-3.827V8a4.004 4.004 0 00-4-4h-32a4.004 4.004 0 00-4 4v4H8.006a4.006 4.006 0 00-3.952 4.661 16.097 16.097 0 0010.28 12.35 20.414 20.414 0 0011.5 10.009V42c.002.1.012.199.03.297a1.99 1.99 0 00-.024.23 18.937 18.937 0 00-11.39 12.347A4.004 4.004 0 0018.297 60H45.37a4.003 4.003 0 003.846-5.125 18.903 18.903 0 00-11.383-12.338 1.984 1.984 0 00-.027-.268 1.98 1.98 0 00.027-.269v-2.981a20.2 20.2 0 0011.48-10.001 16.096 16.096 0 0010.3-12.357 3.985 3.985 0 00-.894-3.241zM8.001 16h3.831v2.741c0 .688.037 1.37.098 2.047.005.059.008.118.014.177.06.615.152 1.224.263 1.83.022.123.043.246.067.369l.03.162A12.01 12.01 0 018.002 16zM45.37 56l-27.084.006a14.874 14.874 0 018.916-9.719 4 4 0 002.631-3.75 1.992 1.992 0 00-.027-.27 1.98 1.98 0 00.027-.267v-2.108a17.84 17.84 0 004-.01V42c.003.09.012.18.027.269a1.982 1.982 0 00-.027.268 3.997 3.997 0 002.63 3.75A14.843 14.843 0 0145.37 56zm2.463-37.26a18.156 18.156 0 01-1.742 7.796A15.85 15.85 0 0131.833 36a15.933 15.933 0 01-14.279-9.516 18.387 18.387 0 01-.789-1.994 18.24 18.24 0 01-.407-1.44c-.04-.166-.083-.33-.118-.496a18.067 18.067 0 01-.228-1.377c-.024-.177-.057-.35-.075-.529a18.538 18.538 0 01-.104-1.9V8h32v10.74zm3.529 4.586c.035-.166.06-.334.091-.5.032-.175.067-.349.095-.524.036-.223.064-.448.093-.673.022-.168.047-.334.065-.502.027-.257.045-.515.063-.773.01-.138.025-.275.032-.413.021-.399.032-.799.032-1.2V16h3.828l.006.001a12.018 12.018 0 01-4.305 7.325zM24.596 16.95a2.292 2.292 0 01-.431-1.065c0-.536.45-1.016 1.352-1.438l5.928-2.677c.4-.172.83-.26 1.266-.259.749 0 1.123.346 1.123 1.036v16.317a3.893 3.893 0 01-.633 2.159 1.74 1.74 0 01-1.382.978c-.48 0-.978-.374-1.496-1.122a2.42 2.42 0 01-.49-1.18V16.316l-3.395 1.554c-.144.07-.3.11-.46.115-.48 0-.94-.345-1.382-1.036z",
        clipRule: "evenodd"
    })),
    print: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M22 42a2 2 0 012-2h16a2 2 0 110 4H24a2 2 0 01-2-2zm2 5a2 2 0 100 4h16a2 2 0 100-4H24z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M56 25h-4v-6.172A4 4 0 0050.828 16L40 5.172A4 4 0 0037.172 4H20a8 8 0 00-8 8v13H8a4 4 0 00-4 4v17a4 4 0 004 4h4v6a4 4 0 004 4h28a8 8 0 008-8v-2h4a4 4 0 004-4V29a4 4 0 00-4-4zM16 12a4 4 0 014-4h16v8a4 4 0 004 4h8v5H16V12zm24 4v-5.172L45.172 16H40zM12 46H8V29h48v17h-4V33H12v13zm4-9v19h28a4 4 0 004-4V37H16z",
        clipRule: "evenodd"
    })),
    "product-bankid-mobile": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M40 4a8 8 0 018 8v40a8 8 0 01-8 8H24a8 8 0 01-8-8V12a8 8 0 018-8zm4 44H20v4a4 4 0 004 4h16a4 4 0 004-4v-4zm-12 2a2 2 0 110 4 2 2 0 010-4zm8-42H24a4 4 0 00-4 4v32h24V12a4 4 0 00-4-4zm1 23a1 1 0 010 2h-4a1 1 0 010-2h4zm-7 0a1 1 0 010 2h-4a1 1 0 010-2h4zm-7 0a1 1 0 010 2h-4a1 1 0 010-2h4zm7-4a1 1 0 010 2h-4a1 1 0 010-2h4zm-7 0a1 1 0 010 2h-4a1 1 0 010-2h4zm14-4a1 1 0 010 2h-4a1 1 0 010-2h4zm-7 0a1 1 0 010 2h-4a1 1 0 010-2h4zm7-4a1 1 0 010 2h-4a1 1 0 010-2h4zm-14 0a1 1 0 010 2h-4a1 1 0 010-2h4z"
    })),
    "product-bedrift-click": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M31.44 7.86a2 2 0 010 4h-8.87A3.58 3.58 0 0019 15.44V45h22V21.49a2 2 0 114 0V52.6a7.58 7.58 0 01-7.54 7.57H22.57A7.57 7.57 0 0115 52.6V15.44a7.58 7.58 0 017.59-7.58zM41 49H19v3.6a3.57 3.57 0 003.59 3.57h14.87A3.57 3.57 0 0041 52.6V49zm-10.98 1.74a1.86 1.86 0 110 3.72 1.86 1.86 0 010-3.72zm13.62-47.1A1.28 1.28 0 0145.05 5v2.93h2.663a1.27 1.27 0 011.207 1.31c0 1.24-.82 2.62-1.92 2.62h-2v1.7c0 1.31-.86 2.77-2 2.77-1.14 0-2-1.49-2-2.23v-2.24h-2.24c-1.05 0-1.9-1.51-1.9-2.1a2 2 0 011.43-1.64 3 3 0 011.08-.19h1.66V5.64c0-1.11 1.43-2 2.61-2z"
    })),
    "product-bedriftsnett": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M33.88 8.38L53.82 18.7A4.14 4.14 0 0156 22.35V52a4.13 4.13 0 01-4.1 4.1h-18a4.13 4.13 0 01-4.13-4.1v-7.65a2.025 2.025 0 014.05 0V52a.07.07 0 00.08.08h18A.07.07 0 0052 52V22.35L32 12h-.13L12 22.3v29.63a.07.07 0 00.07.08h10.2a2.025 2.025 0 010 4.05H12.1A4.13 4.13 0 018 51.93V22.35a4.11 4.11 0 012.17-3.63L30 8.38a4.1 4.1 0 013.88 0zm9.62 15.04a14.27 14.27 0 010 20.2 2 2 0 01-2.83-2.83 10.26 10.26 0 000-14.54 2.001 2.001 0 012.83-2.83zm-21.32-.636A2 2 0 0123 26.25a10.28 10.28 0 000 14.54 2 2 0 01-1.249 3.414l-.156.006-.17-.008a2 2 0 01-1.235-.582 14.27 14.27 0 010-20.2 2 2 0 011.99-.636zm16.23 4.366a9 9 0 010 12.75 2 2 0 01-1.41.58 2 2 0 01-1.41-3.41 5 5 0 000-7.09 2 2 0 112.82-2.83zm-11.198-.513A2.008 2.008 0 0128.1 30a5 5 0 000 7.09 2 2 0 010 2.83 2 2 0 01-1.41.56 2 2 0 01-1.42-.58 9 9 0 010-12.75 2.008 2.008 0 011.942-.513zm4.578 4.843a2.04 2.04 0 110 4.08 2.04 2.04 0 010-4.08z"
    })),
    "product-data-boost": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M25.71 17.47c9.56-8.22 21.14-6.79 25.33-5.89a4 4 0 013.16 3.69c.2 4.32-.21 15.95-9.8 24.12a17.54 17.54 0 01-3 12.07l.03-.03a4 4 0 01-6.75-.39l-2.9-5.19c-.58.18-1.09.31-1.67.45a4 4 0 01-4-1.3l-8.8-10.27a4 4 0 01-.68-4.16c.25-.57.47-1.05.71-1.57l-4.69-3.71a3.35 3.35 0 01-.58-.55 4 4 0 011.27-6.15 17.53 17.53 0 0112.37-1.12zm-3.168 27.554l.176.007a2 2 0 011.362.699 2 2 0 01-.23 2.78l-3 2.59a2 2 0 11-2.59-3l3-2.6a2 2 0 011.458-.47zM18.65 40.46l.176.006a2 2 0 011.364.694A2 2 0 0120 44l-6.13 5.13a2 2 0 11-2.59-3l6.09-5.19a2 2 0 011.456-.474zm21.92 1.76a33.07 33.07 0 01-4.91 2.36l2.56 4.58a13 13 0 002.35-6.94zm9.75-26.7C45.4 14.47 28.6 12.58 20.4 32.11l8.8 10.32.01.02c20.58-5.01 21.36-21.93 21.11-26.93zM14.752 35.894l.176.007a2 2 0 011.362.699 2 2 0 01-.29 2.81L13 42a2 2 0 01-2.53-3.03l3-2.6a2 2 0 011.458-.47zm19.79-14.872a6 6 0 117.78 9.137 6 6 0 01-7.78-9.137zm5.417 3.28a2 2 0 00-3.049 2.588h.02a2 2 0 002.8.23 2 2 0 00.23-2.819zM22.36 20.91a12.82 12.82 0 00-7.16 1.25l4.03 3.19a35.16 35.16 0 013.13-4.44z"
    })),
    "product-data-rollover": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M31.18 8.39A23.49 23.49 0 0151.3 17.9l.36-2.18a1.81 1.81 0 01.74-1.19 1.78 1.78 0 011.36-.32A1.83 1.83 0 0155 15c.238.392.323.859.24 1.31l-1.06 6.5a2.3 2.3 0 01-1 1.52 2.22 2.22 0 01-1.25.38 2.73 2.73 0 01-.54-.07L45 23.07a1.84 1.84 0 01-1.2-2.51 1.89 1.89 0 012.2-1.03l1.87.47a19.68 19.68 0 102.74 19.25 2 2 0 013.7 1.48 23.62 23.62 0 01-39.21 7.42 23.44 23.44 0 01-6.34-17.76c.924-11.906 10.498-21.301 22.42-22zM29.7 27.32c.26 0 .42.09.48.29L32.82 35a.71.71 0 010 .26 1.82 1.82 0 01-.29 1 .77.77 0 01-.63.44c-.233 0-.463-.17-.69-.51a1.92 1.92 0 01-.19-.38l-.31-1.07H27l-.4 1.12a1.5 1.5 0 01-.34.56.64.64 0 01-.46.22c-.23 0-.46-.17-.68-.51a1.18 1.18 0 01-.23-.54 1 1 0 01.05-.23L27.59 28a.85.85 0 01.27-.34 1.57 1.57 0 01.48-.25c.17-.059.35-.09.53-.09h.83zm14.41 0c.26 0 .42.09.48.29L47.24 35a.71.71 0 010 .26 1.82 1.82 0 01-.29 1 .77.77 0 01-.63.44c-.227 0-.457-.17-.69-.51a1.92 1.92 0 01-.19-.38l-.31-1.07h-3.76L41 35.86a1.5 1.5 0 01-.34.56.64.64 0 01-.46.22c-.23 0-.46-.17-.68-.51a1.18 1.18 0 01-.23-.54.7.7 0 01.06-.23L42 28a.85.85 0 01.27-.34 1.57 1.57 0 01.48-.25c.17-.059.35-.09.53-.09h.83zm-4.89.04c.35 0 .52.15.52.47a1.82 1.82 0 01-.29 1 .82.82 0 01-.63.44h-1.75v5.95a1.82 1.82 0 01-.29 1 .8.8 0 01-.64.44c-.22 0-.45-.17-.68-.51a1.13 1.13 0 01-.22-.54v-6.35h-1.81c-.22 0-.45-.17-.68-.51a1.17 1.17 0 01-.22-.54.72.72 0 01.41-.58c.267-.176.58-.27.9-.27h5.38zm-19.19 0a4.45 4.45 0 012.33.61A4.31 4.31 0 0124 29.59c.377.682.57 1.45.56 2.23a5.21 5.21 0 01-.58 2.52A4 4 0 0122.3 36a4.89 4.89 0 01-2.39.58l-2.29-.01c-.23 0-.46-.17-.69-.52a1.21 1.21 0 01-.22-.54v-7.3c0-.21.14-.4.42-.58a1.59 1.59 0 01.9-.27h2zm.1 1.76h-1.59v5.63l1.46.03a2.46 2.46 0 001.94-.78 3.11 3.11 0 00.69-2.14 2.81 2.81 0 00-.69-2 2.33 2.33 0 00-1.81-.74zm8.73.24l-1.35 3.8h2.66l-1.31-3.8zm14.42 0l-1.35 3.8h2.66l-1.31-3.8z"
    })),
    "product-data-sharing": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M31.18 8.39A23.49 23.49 0 0151.3 17.9l.36-2.18a1.81 1.81 0 01.74-1.19 1.78 1.78 0 011.36-.32A1.83 1.83 0 0155 15c.238.392.323.859.24 1.31l-1.06 6.5a2.3 2.3 0 01-1 1.52 2.22 2.22 0 01-1.25.38 2.73 2.73 0 01-.54-.07L45 23.07a1.84 1.84 0 01-1.2-2.51 1.89 1.89 0 012.2-1.03l1.87.47a19.68 19.68 0 102.74 19.25 2 2 0 013.7 1.48 23.62 23.62 0 01-39.21 7.42 23.44 23.44 0 01-6.34-17.76c.924-11.906 10.498-21.301 22.42-22zm3.61 11.84a2 2 0 112.82 2.82l-1.86 1.86h2.84a4 4 0 014 4V41a4 4 0 01-4 4H26.11a4 4 0 01-4-4V28.91a4 4 0 014-4H29l-1.92-1.86a2 2 0 112.83-2.82l2.44 2.43zm-4.44 16.68h-4.24V41h4.24v-4.09zm8.24-.03h-4.24V41h4.24v-4.12zm-8.24-7.97h-4.24v4h4.24v-4zm8.24-.04h-4.24v4h4.24v-4z"
    })),
    "product-extra-datasim": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M31.4 10.52a7.2 7.2 0 015.15 2.13l9.16 9.19A7.2 7.2 0 0147.84 27v25.88a7.3 7.3 0 01-7.29 7.29h-21a7.3 7.3 0 01-7.29-7.29V17.81a7.3 7.3 0 017.29-7.29zm0 4.05H19.59a3.24 3.24 0 00-3.23 3.24v35.07a3.24 3.24 0 003.23 3.24h21a3.24 3.24 0 003.24-3.24V27a3.21 3.21 0 00-.95-2.28l-9.2-9.2a3.21 3.21 0 00-2.28-.95zm5.69 20.5a3.79 3.79 0 013.78 3.78v10.53a3.79 3.79 0 01-3.78 3.78h-14a3.79 3.79 0 01-3.79-3.78V38.85a3.79 3.79 0 013.79-3.78zm-.29 11h-4.7v3h4.7v-3zm-8.77-7h-4.7v10h4.7v-10zm8.77 0h-4.71v3h4.71v-3zM46.3 4.1a2 2 0 012 2v2h2a2 2 0 110 4h-2v2a2 2 0 11-4 0v-2h-2a2 2 0 110-4h2v-2a2 2 0 012-2z"
    })),
    "product-ladeavtale": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M27.41 25.29a2 2 0 00-1.41-.58H15.82a3.67 3.67 0 00-3.82 3.5v9a3.68 3.68 0 003.82 3.5H38a2 2 0 001.41-3.42l-12-12zM16 36.7v-8h9.17l8 8H16zm40-14h-.25a8 8 0 00-7.75-6H12a8 8 0 00-8 8v16a8 8 0 008 8h36a8 8 0 007.75-6H56c2.24 0 4-2.05 4-4.67V27.37c0-2.61-1.76-4.66-4-4.66v-.01zM56 38c.01.235-.05.468-.17.67H52v2a4 4 0 01-4 4H12a4 4 0 01-4-4v-16a4 4 0 014-4h36a4 4 0 014 4v2h3.83c.12.199.179.428.17.66V38z"
    })),
    "product-mobilpant": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M36.92 4a8 8 0 018 8v13.12l2.74-2.74a2 2 0 112.83 2.83l-5.54 5.54a2.89 2.89 0 01-4.05 0l-5.54-5.54a2.001 2.001 0 012.83-2.83l2.73 2.74V12a4 4 0 00-4-4h-16a4 4 0 00-4 4v32h24v-7.36a2 2 0 114 0V52a8 8 0 01-8 8h-16a8 8 0 01-8-8V12a8 8 0 018-8zm4 44h-24v4a4 4 0 004 4h16a4 4 0 004-4v-4zm-12 2a2 2 0 110 4 2 2 0 010-4z"
    })),
    "product-music-freedom": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M56.06 16a1.68 1.68 0 00-.09-.32 2.88 2.88 0 00-2-1.76c-2.23-.61-6 .86-8.59 2.34a3.56 3.56 0 00-1-1.31 3.71 3.71 0 00-3.15-.72l-18.89 4.31a3.69 3.69 0 00-2.88 3.62v.11C17 21 13.81 19.91 11.89 20.43a2.82 2.82 0 00-2 1.73c-.04.104-.07.21-.09.32-.46 2.33-.26 7 3.64 8.29a4.37 4.37 0 001 3.32 6.62 6.62 0 005 2.17v2.33a8.64 8.64 0 00-4-1c-4.41 0-8 3.2-8 7.14 0 3.94 3.59 7.13 8 7.13s8-3.2 8-7.13V22.38l18.26-4.21v15.28a8.76 8.76 0 00-4-1c-4.41 0-8 3.2-8 7.13 0 3.93 3.58 7.13 8 7.13s8-3.2 8-7.13v-9h.16a7 7 0 005.23-2.29 4.5 4.5 0 001-3.56c4.24-1.34 4.46-6.29 3.97-8.73zM15.47 47.91c-2.21 0-4-1.41-4-3.14 0-1.73 1.79-3.14 4-3.14s4 1.41 4 3.14c0 1.73-1.8 3.14-4 3.14zm4-15.64a2.72 2.72 0 01-1.91-.71c-.09-.1-.27-.33.11-1l.06-.11c.1-.154.174-.323.22-.5a2 2 0 00-1.42-2.45l-1.61-.43c-1.1-.29-1.28-1.7-1.27-2.71A16.22 16.22 0 0119.46 27l.01 5.27zm18.27 10.5c-2.21 0-4-1.41-4-3.14 0-1.73 1.79-3.14 4-3.14s4 1.41 4 3.14c0 1.73-1.81 3.14-4.01 3.14h.01zM50.77 21l-1.77.44a2 2 0 00-1.42 2.45c.046.177.12.346.22.5l.06.1c.47.85.23 1.15.12 1.28a3 3 0 01-2.29.81v-5.85a17.49 17.49 0 016.5-3c.09 1.18-.08 2.89-1.42 3.27z"
    })),
    "product-roam-like-home": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M47 19c7.18 0 13 5.82 13 13s-5.82 13-13 13H17C9.82 45 4 39.18 4 32s5.82-13 13-13h30zm0 4H17a9 9 0 000 18h30a9 9 0 000-18zm-2 2a7 7 0 110 14 7 7 0 010-14zm0 4a3 3 0 100 6 3 3 0 000-6z"
    })),
    "product-skjermforsikring": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M28.82 7a2 2 0 110 4h-7.06A3.78 3.78 0 0018 14.78v29.73h22.93V34a2 2 0 012-2 2 2 0 012.02 2v18.29a7.78 7.78 0 01-7.77 7.77h-15.4A7.79 7.79 0 0114 52.29V14.78A7.79 7.79 0 0121.76 7zM41 48.51H18v3.78A3.77 3.77 0 0021.76 56h15.4v.06A3.77 3.77 0 0041 52.29v-3.78zm-11.54 1.84a1.93 1.93 0 110 3.86 1.93 1.93 0 010-3.86zm15.895-21.975A2.002 2.002 0 0147.83 27l4.68 1.36v-.02a2 2 0 01-.55 3.93 2.09 2.09 0 01-.55-.08l-4.68-1.34a2.002 2.002 0 01-1.375-2.475zm-10.482-24a2 2 0 012.037-.325l3.82 1.28a7.77 7.77 0 014.87 9.86l-3.82 11.24a2 2 0 01-1.89 1.36 2.05 2.05 0 01-.64-.11A2 2 0 0138 25.15l3.76-11.25a3.78 3.78 0 00-2.36-4.79l-3.78-1.28a2 2 0 01-.747-3.455zM51.08 18.66A2 2 0 0153 22.17l-4.85 2.67a2.1 2.1 0 01-1 .24l.024-.001-.125-.003a2 2 0 01-1.756-1.327l-.048-.153a2 2 0 01.965-2.266z"
    })),
    "product-svitsj": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M46 27.64a2 2 0 012 2V52a8 8 0 01-8 8H24a8 8 0 01-8-8V36.81l-1.78 1.78a2 2 0 11-2.83-2.82l4.68-4.68a2.81 2.81 0 01.79-.55 2 2 0 012.28 0c.293.137.56.323.79.55l4.68 4.68a2 2 0 01-1.41 3.41 2 2 0 01-1.42-.59L20 36.81V44h24V29.64a2 2 0 012-2zM44 48H20v4a4 4 0 004 4h16a4 4 0 004-4v-4zm-12 2a2 2 0 110 4 2 2 0 010-4zm8-46a8 8 0 018 8v6.07l1.78-1.78a2 2 0 112.83 2.83l-4.68 4.68a2.73 2.73 0 01-3.86 0l-4.68-4.68a2.001 2.001 0 012.83-2.83L44 18.07V12a4 4 0 00-4-4H24a4 4 0 00-4 4v12.77a2 2 0 11-4 0V12a8 8 0 018-8z"
    })),
    "product-telia-startup": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M57.52 12.9a4 4 0 00-3.25-1.13c-5.11.55-17.48 2.62-21.85 9.89-1.89 3.14-2 6.75-.45 10.73a9.62 9.62 0 001.08 1.93 8.87 8.87 0 00-1 2.09A14.1 14.1 0 0029.53 35a8.34 8.34 0 00-.85-5.21c-3.95-7.39-15.39-6.11-20.12-5.22a4 4 0 00-2.73 6c1.75 3 7.59 12 15 12a9.33 9.33 0 002.67-.39 8.4 8.4 0 004.52-3.36c1.39.68 2.76 1.69 2.84 2.68v.11a57.62 57.62 0 00-.27 8.83 2 2 0 002 1.92h.1a2 2 0 001.91-2.11c-.19-4.08.15-10.6 1.41-13.06a10.57 10.57 0 005.48 1.59 7.94 7.94 0 001-.05c9.28-.94 15.26-12.31 16.17-22.52a4 4 0 00-1.14-3.31zM22.39 38.21c-4.67 1.38-9.82-4.13-13.08-9.74a34 34 0 016.21-.61c4.26 0 8.13 1 9.61 3.78a4.78 4.78 0 01-2.74 6.57zm19.74-3.59a6.61 6.61 0 01-5.36-2.1 5.14 5.14 0 01-1.06-1.63c-1.12-2.79-1.06-5.13.16-7.16 2.38-4 9.43-6.94 18.82-8-.78 8.74-5.69 18.19-12.56 18.89z"
    })),
    pulse: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M17.252 21.029c.818-1.472 2.951-1.324 3.587.183l.058.156 4.562 13.685 2.793-5.024a2 2 0 011.582-1.022L30 29h24a2 2 0 01.15 3.995L54 33H31.176l-4.428 7.971c-.818 1.473-2.951 1.324-3.587-.183l-.058-.155-4.563-13.687-2.792 5.025a2 2 0 01-1.582 1.022L14 33h-4a2 2 0 01-.15-3.994L10 29h2.822l4.43-7.971z",
        clipRule: "evenodd"
    })),
    "question-circle": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M32 10a22 22 0 11-22 22 22 22 0 0122-22m0-4a26 26 0 1026 26A26 26 0 0032 6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M32.18 36.5a1.9 1.9 0 01-1.25.68c-.59 0-1.16-.42-1.7-1.25a3.2 3.2 0 01-.54-1.35 1.42 1.42 0 01.39-.89L32.53 30a12.91 12.91 0 001.75-2.28 3.93 3.93 0 00.53-1.89 2.32 2.32 0 00-.81-1.75 2.87 2.87 0 00-2-.71 3.68 3.68 0 00-1.93.54 9.37 9.37 0 00-2 1.81 5.8 5.8 0 01-.87.85 1 1 0 01-.63.22c-.57 0-1.11-.4-1.63-1.21a2.82 2.82 0 01-.54-1.32 1.71 1.71 0 01.36-.92 9.21 9.21 0 013.34-3 9 9 0 014.34-1.12 7.85 7.85 0 013.72.85 6.34 6.34 0 012.51 2.29 6 6 0 01.89 3.22 6.85 6.85 0 01-.82 3.22 20.08 20.08 0 01-2.92 3.83zm-.89 8.32c-.69 0-1.37-.5-2-1.52a3.23 3.23 0 01-.67-1.68q0-.91 1.26-1.74a4.87 4.87 0 012.72-.82c1 0 1.56.48 1.56 1.43a5.28 5.28 0 01-.44 2.13 4.65 4.65 0 01-1.09 1.62 1.92 1.92 0 01-1.34.58z"
    })),
    "question-filled": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M4 32C4 16.536 16.536 4 32 4c15.457.017 27.983 12.543 28 28 0 15.464-12.536 28-28 28S4 47.464 4 32zm32.311.906l-4.369 4.666c-.551.551-1.018.806-1.484.806-.721 0-1.4-.51-2.036-1.485-.424-.72-.636-1.272-.636-1.611 0-.34.17-.679.466-1.06l4.114-4.37c1.91-2.078 2.715-3.477 2.715-4.962 0-1.696-1.4-2.969-3.308-2.969-1.654 0-2.884.764-4.708 2.8-.467.509-.806.848-1.018 1.017-.255.17-.51.255-.764.255-1.357 0-2.587-2.29-2.587-3.011 0-.297.127-.68.424-1.103l.138-.202c2.055-2.936 5.498-4.76 9.024-4.76 3.35 0 6.022 1.441 7.422 3.732.721 1.145 1.06 2.46 1.06 3.86 0 2.555-1.009 4.607-4.029 7.935l-.424.462zM27.659 43.68c0 1.06 1.569 3.817 3.223 3.817.551 0 1.06-.255 1.57-.721 1.017-.933 1.823-2.715 1.823-4.454 0-1.145-.636-1.696-1.866-1.696-2.333 0-4.75 1.57-4.75 3.054z",
        clipRule: "evenodd"
    })),
    question: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 4C16.536 4 4 16.536 4 32s12.536 28 28 28 28-12.536 28-28C59.983 16.543 47.457 4.017 32 4zm0 51.692C18.915 55.692 8.308 45.085 8.308 32S18.915 8.308 32 8.308 55.692 18.915 55.692 32C55.678 45.079 45.08 55.678 32 55.692z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M31.942 37.572l4.369-4.665.424-.462c3.02-3.329 4.03-5.38 4.03-7.936 0-1.4-.34-2.715-1.06-3.86-1.4-2.29-4.073-3.732-7.423-3.732-3.525 0-6.97 1.824-9.024 4.76l-.138.202c-.297.424-.424.806-.424 1.103 0 .72 1.23 3.011 2.587 3.011.255 0 .51-.085.764-.254.212-.17.551-.51 1.018-1.018 1.823-2.036 3.053-2.8 4.708-2.8 1.908 0 3.308 1.273 3.308 2.97 0 1.484-.806 2.884-2.715 4.962l-4.114 4.369c-.297.381-.466.72-.466 1.06 0 .34.212.89.636 1.612.636.975 1.315 1.484 2.036 1.484.466 0 .933-.254 1.484-.806zm-1.06 9.925c-1.654 0-3.224-2.757-3.224-3.817 0-1.485 2.418-3.054 4.75-3.054 1.23 0 1.867.552 1.867 1.697 0 1.739-.806 3.52-1.824 4.453-.509.467-1.018.721-1.569.721z",
        clipRule: "evenodd"
    })),
    rack: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M18 13a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2zm0 14a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2zm0 14a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M20 4a8 8 0 00-8 8v40a8 8 0 008 8h24a8 8 0 008-8V12a8 8 0 00-8-8H20zm28 42V36H16v10h32zm-32 4v2a4 4 0 004 4h24a4 4 0 004-4v-2H16zm32-28v10H16V22h32zM16 12a4 4 0 014-4h24a4 4 0 014 4v6H16v-6z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M38 13a2 2 0 11-4 0 2 2 0 014 0zm0 14a2 2 0 11-4 0 2 2 0 014 0zm0 14a2 2 0 11-4 0 2 2 0 014 0zm6-28a2 2 0 11-4 0 2 2 0 014 0zm0 14a2 2 0 11-4 0 2 2 0 014 0zm0 14a2 2 0 11-4 0 2 2 0 014 0z"
    })),
    radio: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M24 28a4 4 0 100 8 4 4 0 000-8z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M12 32c0-6.627 5.373-12 12-12s12 5.373 12 12-5.373 12-12 12-12-5.373-12-12zm12-8a8 8 0 100 16 8 8 0 000-16z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M40 32a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2zm2 6a2 2 0 100 4h8a2 2 0 100-4h-8zm-2-14a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M34 10a2 2 0 10-4 0v2h-4v-2a2 2 0 10-4 0v2h-4v-2a2 2 0 10-4 0v2h-2a8 8 0 00-8 8v24a8 8 0 008 8h40a8 8 0 008-8V20a8 8 0 00-8-8H34v-2zm-22 6a4 4 0 00-4 4v24a4 4 0 004 4h40a4 4 0 004-4V20a4 4 0 00-4-4H12z",
        clipRule: "evenodd"
    })),
    record: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M37 32a5 5 0 11-10 0 5 5 0 0110 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M16.444 55.281A28 28 0 1047.556 8.717a28 28 0 00-31.112 46.564zm2.222-43.236a24 24 0 1126.668 39.911 24 24 0 01-26.668-39.911z",
        clipRule: "evenodd"
    })),
    recycle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M56.513 49.368a8.585 8.585 0 01-7.486 4.3h-9.63l2.802 2.8a2.167 2.167 0 01-3.064 3.064l-6.5-6.5c-.033-.032-.055-.07-.085-.103a2.159 2.159 0 01-.093-.114 2.153 2.153 0 01-.285-.475l-.007-.01v-.004a2.154 2.154 0 01-.152-.688 2.173 2.173 0 01.028-.558l.005-.013a2.158 2.158 0 01.246-.636 2.15 2.15 0 01.343-.462l6.5-6.5a2.166 2.166 0 013.064 3.063l-2.802 2.802h9.63a4.333 4.333 0 003.772-6.465l-5.54-9.802a2.167 2.167 0 113.772-2.133l5.54 9.802a8.586 8.586 0 01-.058 8.632zM19.912 23.053a2.166 2.166 0 002.952-.82l5.363-9.488a4.334 4.334 0 017.545 0l5.985 10.589H38.5a2.167 2.167 0 000 4.333h8.666c1.197 0 2.167-.97 2.167-2.167v-8.666a2.167 2.167 0 10-4.333 0v3.43l-5.455-9.652a8.668 8.668 0 00-15.09 0l-5.363 9.489a2.168 2.168 0 00.82 2.952zm7.754 26.28H14.973a4.333 4.333 0 01-3.773-6.465l5.633-9.964v3.43a2.167 2.167 0 104.333 0v-8.667c0-1.197-.97-2.167-2.166-2.167h-8.667a2.167 2.167 0 000 4.333h3.258L7.428 40.736a8.667 8.667 0 007.545 12.93h12.693a2.167 2.167 0 000-4.333z",
        clipRule: "evenodd"
    })),
    "refill-card": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M49.657 16.828L39.172 6.344A7.95 7.95 0 0033.515 4H20a8.01 8.01 0 00-8 8v40a8.01 8.01 0 008 8h24a8.009 8.009 0 008-8V22.485a7.953 7.953 0 00-2.343-5.657zM48 52a4.004 4.004 0 01-4 4H20a4.004 4.004 0 01-4-4V12a4.004 4.004 0 014-4h13.515a3.972 3.972 0 012.828 1.172l10.485 10.484A3.975 3.975 0 0148 22.486V52zm-4-14a12 12 0 11-12-12h1.172l-2.586-2.586a2 2 0 012.828-2.828l6 6a1.999 1.999 0 010 2.828l-6 6a2 2 0 01-2.828-2.828L33.172 30H32a8 8 0 108 8 2 2 0 014 0z"
    })),
    refill: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M33.49 4a8 8 0 015.7 2.36L49.72 16.9A7.68 7.68 0 0152 22.39V52a8 8 0 01-8 8H20a8 8 0 01-8-8V12a8 8 0 018-8zm0 4H20a4 4 0 00-4 4v40a4 4 0 004 4h24a4 4 0 004-4V22.39a3.73 3.73 0 00-1.1-2.66L36.36 9.19A4.07 4.07 0 0033.49 8zm-.08 12.61L38.84 26a2.85 2.85 0 010 4l-5.43 5.43a2 2 0 01-2.82-2.83l2.58-2.59A7.49 7.49 0 0032 30a8 8 0 108 8 2 2 0 114 0 12 12 0 11-10.79-11.94l-2.62-2.62a2 2 0 012.82-2.83z"
    })),
    refresh: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M53 38.6c-3.385 10.765-14.367 17.223-25.42 14.949-11.054-2.275-18.594-12.544-17.454-23.77C11.266 18.55 20.716 10.006 32 9.998a21.761 21.761 0 0116.37 7.311l.63-4.26a2.02 2.02 0 014 .57L51.73 22a3 3 0 01-3 2.51 3.11 3.11 0 01-.43 0l-9-1.28a2.02 2.02 0 11.57-4l5.54.79A17.78 17.78 0 0032 14c-9.233.005-16.966 6.995-17.899 16.181-.933 9.186 5.236 17.588 14.28 19.45C37.425 51.49 46.41 46.208 49.18 37.4A2.002 2.002 0 1153 38.6z"
    })),
    register: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M42 61.333H14a4 4 0 01-4-4v-44a8.009 8.009 0 018-8h28a4 4 0 014 4v15.025a2 2 0 11-4 0V9.333H18a4 4 0 00-4 4v44h28a4.011 4.011 0 003.459-2 2 2 0 013.463 2 8.026 8.026 0 01-6.922 4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M40.865 32.888c-.405-3.453-1.748-5.989-3.93-7.583a8 8 0 10-13.87 0c-2.182 1.594-3.525 4.131-3.93 7.585a3.967 3.967 0 00.98 3.1 4.015 4.015 0 003 1.347h13.772a4.015 4.015 0 003-1.347 3.966 3.966 0 00.978-3.102zM30 17.333a4 4 0 110 8 4 4 0 010-8zm-6.887 16l-.006.021c.3-2.57 1.2-4.233 2.819-5.148a7.924 7.924 0 008.148 0c1.623.914 2.515 2.571 2.813 5.128H23.113zM39.626 53.7a4 4 0 01-3.9-4.869l1.193-5.363A3.99 3.99 0 0138 41.508l12.172-12.175a4 4 0 015.656 0L60 33.505a4 4 0 010 5.656L47.826 51.333a4 4 0 01-1.963 1.077L40.5 53.604c-.287.064-.58.096-.874.096zm1.2-9.367l-1.192 5.363L45 48.507l12.172-12.174L53 32.161 40.826 44.333zm-9.826 4H21a2 2 0 010-4h10a2 2 0 010 4z"
    })),
    "remote-control": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M17.998 40a2 2 0 114 0 2 2 0 01-4 0zm-2 2a2 2 0 100 4 2 2 0 000-4zm8 0a2 2 0 100 4 2 2 0 000-4zm-4 4a2 2 0 100 4 2 2 0 000-4zm18-14a6 6 0 11-6-6 6.006 6.006 0 016 6zm-4 0A2 2 0 1030 32a2 2 0 004 0zm10-28a2 2 0 000 4 12.013 12.013 0 0112 12 2 2 0 004 0 16.018 16.018 0 00-16-16zm0 8a2 2 0 000 4 4.005 4.005 0 014 4 2 2 0 004 0 8.01 8.01 0 00-8-8zm1.672 12.844a8.008 8.008 0 010 11.312L25.412 56.414A12.607 12.607 0 017.584 38.586l20.258-20.258a8.008 8.008 0 0111.313 0l6.515 6.516zm-2.828 2.828l-6.516-6.516a4.006 4.006 0 00-5.656 0L10.412 41.414a8.607 8.607 0 0012.172 12.172l20.258-20.258a4.004 4.004 0 000-5.656z"
    })),
    repair: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M59.404 15.753a4.002 4.002 0 00-6.687-1.75L45.37 21.35a2.042 2.042 0 01-3.13-.294 2.195 2.195 0 01.408-2.753l7.097-7.097a4.023 4.023 0 001.03-3.9 3.925 3.925 0 00-2.839-2.801 15.974 15.974 0 00-19.296 20.01L6.35 46.758a7.847 7.847 0 00-.674 10.446A7.693 7.693 0 0011.588 60c2.03 0 3.978-.807 5.416-2.24l22.464-22.418a15.962 15.962 0 0020.324-12.883 16.084 16.084 0 00-.388-6.706zm-3.566 6.113a11.966 11.966 0 01-16.181 9.317l-1.213-.47L14.177 54.93a3.696 3.696 0 01-2.761 1.067 3.637 3.637 0 01-2.656-1.338 3.818 3.818 0 01.417-5.07L33.27 25.543l-.47-1.216a11.972 11.972 0 0114.117-15.95l-7.097 7.097a6.148 6.148 0 00-.85 7.884 6.04 6.04 0 009.228.819l7.348-7.369.002.006c.45 1.645.55 3.366.29 5.05zM13.983 52a2 2 0 11-4 0 2 2 0 014 0z",
        clipRule: "evenodd"
    })),
    replace: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M22.68 30.66a2.001 2.001 0 010 2.83l-8.21 8.21H54a2 2 0 110 4H14.47l8.21 8.21a2 2 0 01-2.83 2.83L9.39 46.27a3.64 3.64 0 010-5.15l10.46-10.46a2.001 2.001 0 012.83 0zm21.47-23l10.46 10.46a3.65 3.65 0 01.01 5.15L44.15 33.74a2 2 0 11-2.83-2.83l8.21-8.21H10a2 2 0 110-4h39.53l-8.21-8.22a2 2 0 012.83-2.82z"
    })),
    report: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M20 4a8 8 0 00-8 8v44a4 4 0 004 4h28a8 8 0 008-8V18.276a4 4 0 00-1.046-2.697L41.572 5.303A4 4 0 0038.618 4H20zm-4 8a4 4 0 014-4h17v8a4 4 0 004 4h7v32a4 4 0 01-4 4H16V12zm29.922 4L41 10.609V16h4.922z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M24 28a2 2 0 10-4 0v20a2 2 0 002 2h20a2 2 0 100-4H24V28z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M43.087 28.82a2 2 0 01.592 2.767l-5.5 8.5a2 2 0 01-2.996.418l-2.444-2.139-3.191 3.9a2 2 0 11-3.096-2.532l4.5-5.5a2 2 0 012.865-.24l2.26 1.978 4.244-6.559a2 2 0 012.766-.592z",
        clipRule: "evenodd"
    })),
    reservation: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M32 8c7.495 0 13.316 2.145 17.586 6.414C53.856 18.684 56 24.504 56 32a2 2 0 104 0c0-8.505-2.522-15.35-7.586-20.414C47.35 6.522 40.504 4 32 4a2 2 0 100 4zm-15 6a3 3 0 11-6 0 3 3 0 016 0zM7 35a3 3 0 100-6 3 3 0 000 6zm10 15a3 3 0 11-6 0 3 3 0 016 0zm33 3a3 3 0 100-6 3 3 0 000 6zm-18 7a3 3 0 100-6 3 3 0 000 6zm2-35v7h12a2 2 0 110 4H32a2 2 0 01-2-2v-9a2 2 0 114 0z"
    })),
    "return-arrow": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M60 28v12a8 8 0 01-8 8H10.44l8.29 8.29a2 2 0 11-2.83 2.83L5.44 48.65a3.65 3.65 0 010-5.15L15.9 33a2 2 0 112.83 2.82L10.6 44H52a4 4 0 004-4V28a4 4 0 00-4-4h-9.18a2 2 0 110-4H52a8 8 0 018 8z"
    })),
    reverse: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M37.785 10.624a2 2 0 00-2.903 2.752l3.823 4.032-20.713.01c-7.728.005-13.99 6.27-13.992 13.999v1.008a2 2 0 104 0v-1.008c0-5.52 4.474-9.995 9.994-9.998l21.498-.011-4.585 4.348a2 2 0 102.752 2.902l7.62-7.225a2 2 0 00.074-2.827l-7.568-7.982zm17.979 21.272c.005 5.525-4.47 10.007-9.994 10.01l-19.5.01 4.589-4.352a2 2 0 10-2.752-2.902l-7.62 7.225a2 2 0 00-.074 2.827l7.569 7.982a2 2 0 002.902-2.752l-3.82-4.029 18.708-.01c7.734-.003 13.999-6.279 13.992-14.013l-.001-.994a2 2 0 00-4 .003v.995z"
    })),
    roaming: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M37 4c-9.389 0-17 7.611-17 17s7.611 17 17 17 17-7.611 17-17S46.389 4 37 4zm-8.455 13.933l-4.356.847a12.969 12.969 0 013.629-6.983l.727 6.136zm3.972-.47l-.98-8.263a12.951 12.951 0 016.531-1.157v3.244l-1.833 1.753A4 4 0 0035 15.93v.08a4 4 0 004 4h2.444l.912 2.27c.676 1.681 2.86 2.107 4.119.804l3.441-3.567c.056.487.084.982.084 1.483 0 5.115-2.954 9.54-7.25 11.663v-3.235a4 4 0 00-4-4h-6.764a4 4 0 00-3.578 2.212l-1.043 2.088a12.953 12.953 0 01-3.232-6.862l5.176-1.006a4 4 0 003.208-4.398zm-1.962 14.83A12.94 12.94 0 0037 34c.593 0 1.178-.04 1.75-.117v-4.455h-6.763l-1.432 2.865zm17.658-17.876a13.05 13.05 0 00-6.145-5.392v2.262a4 4 0 01-1.235 2.89L39 15.931v.08h2.444a4 4 0 013.711 2.508l.05.121 1.747-1.81 1.26-2.413z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M29 52a2 2 0 11-4 0 2 2 0 014 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M19 4a8 8 0 00-8 8v40a8 8 0 008 8h16a8 8 0 008-8V42a2 2 0 10-4 0v2H15V12a4 4 0 014-4h2.5a2 2 0 100-4H19zm-4 44v4a4 4 0 004 4h16a4 4 0 004-4v-4H15z",
        clipRule: "evenodd"
    })),
    robot: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M42 3.986a4 4 0 012 7.464V16h2a8 8 0 018 8v6a4 4 0 110 8v12a8 8 0 01-8 8H18a8 8 0 01-8-8V38a4 4 0 110-8v-6a8 8 0 018-8h2v-4.55a4 4 0 114 0V16h16v-4.55a4 4 0 012-7.464zM46 20H18a4 4 0 00-4 4v26a4 4 0 004 4h28a4 4 0 004-4V24a4 4 0 00-4-4zm-5.13 22.35a2 2 0 112.26 3.3C40.9 47.17 36.95 48 32 48c-4.95 0-8.9-.83-11.13-2.35a2 2 0 112.26-3.3C23.7 42.73 26 44 32 44c6 0 8.3-1.27 8.87-1.65zM24 26a6 6 0 110 12 6 6 0 010-12zm16 0a6 6 0 110 12 6 6 0 010-12zm-16 4a2 2 0 100 4 2 2 0 000-4zm16 0a2 2 0 100 4 2 2 0 000-4z"
    })),
    route: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M18 50a2.448 2.448 0 001.787-.778C22.256 46.57 28 39.778 28 34a10 10 0 00-20 0c0 5.773 5.743 12.567 8.21 15.219A2.452 2.452 0 0018 50zm0-22a6.007 6.007 0 016 6c0 3.157-3.019 7.751-6 11.22-2.98-3.469-6-8.066-6-11.22a6.007 6.007 0 016-6zm28 4a2.448 2.448 0 001.787-.778C50.256 28.57 56 21.778 56 16a10 10 0 00-20 0c0 5.773 5.743 12.567 8.21 15.219A2.45 2.45 0 0046 32zm0-22a6.007 6.007 0 016 6c0 3.157-3.019 7.751-6 11.22-2.98-3.469-6-8.066-6-11.22a6.007 6.007 0 016-6zM18 36a2 2 0 110-4 2 2 0 010 4zm28-18a2 2 0 110-4 2 2 0 010 4zm10 20a2 2 0 01-2 2H41.473a5.962 5.962 0 00-5.592 3.825l-3.033 7.799A9.937 9.937 0 0123.528 58H10a2 2 0 110-4h13.527a5.962 5.962 0 005.592-3.825l3.033-7.799A9.937 9.937 0 0141.472 36H54a2 2 0 012 2z"
    })),
    router: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M52 33H12a8.01 8.01 0 00-8 8v6a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8v-6a8.01 8.01 0 00-8-8zm4 14a4.004 4.004 0 01-4 4H12a4.004 4.004 0 01-4-4v-6a4.004 4.004 0 014-4h40a4.004 4.004 0 014 4v6zm-26-3a2 2 0 01-2 2H16a2 2 0 110-4h12a2 2 0 012 2zm12 0a2 2 0 11-4 0 2 2 0 014 0zm8 0a2 2 0 11-4 0 2 2 0 014 0zM15.543 17.848a2 2 0 01.215-2.82c9.337-8.037 23.147-8.037 32.484 0a2 2 0 01-2.605 3.034c-7.839-6.75-19.436-6.75-27.274 0a2 2 0 01-2.82-.214zM32 19a11.822 11.822 0 018.416 3.486 2 2 0 01-2.83 2.828 7.898 7.898 0 00-11.172 0 2 2 0 11-2.83-2.828A11.822 11.822 0 0132 19z",
        clipRule: "evenodd"
    })),
    ruler: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M54 38H26V10a4.004 4.004 0 00-4-4H10a4.004 4.004 0 00-4 4v44a4.004 4.004 0 004 4h44a4.005 4.005 0 004-4V42a4.005 4.005 0 00-4-4zm0 16H10V10h12v4h-6a2 2 0 000 4h6v4h-4a2 2 0 000 4h4v4h-6a2 2 0 000 4h6v4h-4a2 2 0 000 4h4v4a2 2 0 004 0v-4h4v6a2 2 0 004 0v-6h4v4a2 2 0 004 0v-4h4v6a2 2 0 004 0v-6h4v12z"
    })),
    satellite: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M14.308 25.371a1.996 1.996 0 001.88-.184 1.996 1.996 0 00.296-3.078l-4.234-4.234 7.06-7.06 4.233 4.244a2.002 2.002 0 102.825-2.836l-5.65-5.642a1.997 1.997 0 00-2.816 0l-9.885 9.886a1.997 1.997 0 000 2.816l5.641 5.652c.186.187.407.335.65.436zM44.73 56c.372.376.878.588 1.407.59a1.997 1.997 0 001.408-.59l9.874-9.885a1.997 1.997 0 000-2.816l-5.64-5.652a1.998 1.998 0 10-2.826 2.826l4.243 4.234-7.059 7.06-4.233-4.234a1.998 1.998 0 10-2.826 2.826L44.73 56z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M42.722 9.996L54.015 21.29a5.99 5.99 0 01-.07 8.508L31.979 51.767c-.352.366-.83.583-1.337.609a1.996 1.996 0 01-1.408-.59l-1.867-1.867a12.754 12.754 0 01-1.628 6.082 1.997 1.997 0 01-1.468.998h-.28a1.997 1.997 0 01-1.467-.589l-3.235-3.225a5.993 5.993 0 11-8.476-8.478L7.588 41.47a1.997 1.997 0 01.43-3.155 12.748 12.748 0 016.13-1.658L12.28 34.79a1.997 1.997 0 01-.589-1.408 1.998 1.998 0 01.59-1.418l21.965-21.97a5.991 5.991 0 018.476 0zM13.225 49.71a1.997 1.997 0 003.259.648l-2.826-2.826a1.999 1.999 0 00-.433 2.178zm.932-6.562a1.457 1.457 0 00-.549 0c.133-.013.267-.013.4 0h.15zm9.016 8.248A8.988 8.988 0 0012.62 40.832l2.835 2.846 7.718 7.72zm7.429-3.864l20.587-20.591a1.997 1.997 0 000-2.826L39.897 12.822a1.996 1.996 0 00-2.826 0l-20.587 20.59L30.6 47.533z",
        clipRule: "evenodd"
    })),
    save: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M54.828 16L48 9.172A3.974 3.974 0 0045.172 8H16a8.009 8.009 0 00-8 8v32a8.009 8.009 0 008 8h32a8.009 8.009 0 008-8V18.829A3.971 3.971 0 0054.828 16zM21 12h12v9H21v-9zm16 0h4v9h-4v-9zm6 40H21V38h22v14zm9-4a4 4 0 01-4 4h-1V38a4 4 0 00-4-4H21a4 4 0 00-4 4v14h-1a4 4 0 01-4-4V16a4 4 0 014-4h1v9a4 4 0 004 4h20a4 4 0 004-4v-9h.172L52 18.829V48z"
    })),
    savings: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M56 27h-1.103a18.547 18.547 0 00-2.746-4.846l1.808-8.75a2 2 0 00-3.037-2.088l-7.317 4.683a11.991 11.991 0 00-23.067-.554l-.215.098c-.43.193-.86.387-1.264.604C12.814 19.478 8.85 24.93 8.129 31H6a2 2 0 100 4h2.128c.679 5.715 4.238 10.884 9.872 14.25V53a4.004 4.004 0 004 4h4a4.004 4.004 0 004-4v-2h4v2a4.004 4.004 0 004 4h4a4.004 4.004 0 004-4v-3.75A21.343 21.343 0 0054.003 41H56a4.004 4.004 0 004-4v-6a4.004 4.004 0 00-4-4zM32 11a8.01 8.01 0 018 8 7.916 7.916 0 01-2.725 6h-10.55A7.917 7.917 0 0124 19a8.01 8.01 0 018-8zm20.743 26H56v-6h-2.552c-.898 0-1.687-.6-1.926-1.466a14.489 14.489 0 00-3.04-5.55 2.001 2.001 0 01-.44-1.707l1.04-5.035-5.19 3.322a11.82 11.82 0 01-1.734 4.81A1.997 1.997 0 0141 29H22a1.998 1.998 0 01-.353-3.964 11.826 11.826 0 01-1.58-4.863C14.999 23.2 12 27.93 12 33c0 5.352 3.343 10.331 8.941 13.32A2 2 0 0122 48.083V53h4v-2a4.004 4.004 0 014-4h4a4.004 4.004 0 014 4v2h4v-4.916a2 2 0 011.059-1.765 17.24 17.24 0 007.848-8.112A2 2 0 0152.743 37z",
        clipRule: "evenodd"
    })),
    search: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M58.606 55.543L47.773 44.71a2.153 2.153 0 00-.658-.446c8.248-9.776 7.325-24.316-2.094-32.97-9.419-8.655-23.985-8.347-33.03.698-9.044 9.044-9.352 23.61-.698 33.03 8.654 9.419 23.195 10.342 32.97 2.093.107.245.258.469.446.658l10.833 10.834a2.166 2.166 0 103.064-3.064zm-29.698-7.135c-10.77 0-19.5-8.73-19.5-19.5s8.73-19.5 19.5-19.5 19.5 8.73 19.5 19.5c-.013 10.765-8.736 19.488-19.5 19.5z",
        clipRule: "evenodd"
    })),
    "secure-device": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M28 16.341V13.6C28 8.741 32.142 5 37 5s9 3.741 9 8.6v2.741c2.33.824 4 3.047 4 5.659v9a6 6 0 01-6 6H30a6 6 0 01-6-6v-9a6.003 6.003 0 014-5.659zm4-2.741c0-2.431 2.126-4.6 5-4.6s5 2.169 5 4.6V16H32v-2.4zM28 22a2 2 0 012-2h14a2 2 0 012 2v9a2 2 0 01-2 2H30a2 2 0 01-2-2v-9z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M37 24a2 2 0 012 2v2a2 2 0 11-4 0v-2a2 2 0 012-2z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M31 52a2 2 0 11-4 0 2 2 0 014 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M21 4a8 8 0 00-8 8v40a8 8 0 008 8h16a8 8 0 008-8V41a2 2 0 10-4 0v3H17V12a4 4 0 014-4h4.5a2 2 0 100-4H21zm-4 44v4a4 4 0 004 4h16a4 4 0 004-4v-4H17z",
        clipRule: "evenodd"
    })),
    secured2: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M47.167 31.56c0 1.197-.97 2.167-2.167 2.167H34.167V44.56a2.167 2.167 0 01-4.334 0V33.726H19a2.167 2.167 0 110-4.333h10.833V18.56a2.167 2.167 0 114.334 0v10.833H45c1.197 0 2.167.97 2.167 2.167zM58 16.393v10.834c0 24.5-20.264 31.092-24.326 32.165a6.546 6.546 0 01-3.35 0C26.264 58.32 6 51.727 6 27.226V16.394a4.337 4.337 0 014.26-4.332 34.375 34.375 0 0019.12-7.166 4.28 4.28 0 015.24 0 34.376 34.376 0 0019.12 7.166A4.337 4.337 0 0158 16.393zm-4.333 0l-.123-.003A38.692 38.692 0 0131.97 8.323a38.322 38.322 0 01-21.513 8.067 2.39 2.39 0 01-.122.003h-.003l.003 10.833c0 20.789 16.15 26.669 21.1 27.977.37.099.76.099 1.131 0 4.953-1.308 21.102-7.188 21.102-27.977V16.393z",
        clipRule: "evenodd"
    })),
    "security-camera": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M20.501 5.805l36.345 20.983c3.61 2.085 3.976 7.017 1.019 9.656a8.002 8.002 0 01-13.489 8.46l-1.848 1.145a6 6 0 01-6.159.094l-11.517-6.65v9.477a2 2 0 01-2 2H8.104v6.98a2 2 0 11-4 0V41.112a2 2 0 114 0v5.857h12.748v-9.786L7 29.188a6 6 0 01-2.196-8.197l7.5-12.99A6 6 0 0120.5 5.805zm34.345 24.448L18.5 9.269a2 2 0 00-2.732.732l-7.5 12.99A2 2 0 009 25.723L38.369 42.68a2 2 0 002.053-.031L54.9 33.685c1.285-.796 1.257-2.676-.053-3.432zm-7.03 12.522l6.65-4.118a4.002 4.002 0 01-6.65 4.118z",
        clipRule: "evenodd"
    })),
    security: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M33.15 7.36a68.33 68.33 0 0019.42 9.72A2 2 0 0154 19c0 18.88-7.08 32.26-21 39.76a2 2 0 01-1 .24 2 2 0 01-.95-.24c-14-7.5-21-20.88-21-39.76a2 2 0 011.43-1.92 68.33 68.33 0 0019.37-9.72 2 2 0 012.3 0zM32 11.46a72.4 72.4 0 01-18 9c.34 16.31 6.24 27.54 18 34.25C43.76 48 49.66 36.77 50 20.46a72.4 72.4 0 01-18-9zm7.488 12.877A2 2 0 0140.53 27.8l-9.43 11a2 2 0 01-1.44.7h-.02a2 2 0 01-1.41-.59l-4.72-4.71a2.001 2.001 0 012.83-2.83l3.19 3.19 8-9.36a2 2 0 011.958-.863z"
    })),
    send: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M8.416 6.293C5.997 5.18 3.386 7.418 4.13 9.968L10.543 32 4.129 54.032c-.743 2.55 1.868 4.788 4.287 3.675l49.778-22.895c2.408-1.107 2.408-4.517 0-5.624L8.416 6.293zm5.84 23.642L8.743 10.991 49.93 29.935H14.256zm0 4.13L8.743 53.01 49.93 34.066H14.257z",
        clipRule: "evenodd"
    })),
    "sense-car": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M52 34h-5.172L38 25.172A3.974 3.974 0 0035.172 24H17.355a3.983 3.983 0 00-3.715 2.515L10.645 34H8a4.005 4.005 0 00-4 4v6a8.006 8.006 0 007.338 7.967A5.99 5.99 0 0022.65 52H42a1.99 1.99 0 00.337-.034A5.99 5.99 0 0053.65 52H56a4.004 4.004 0 004-4v-6a8.01 8.01 0 00-8-8zM17 52a2 2 0 110-4 2 2 0 010 4zm31 0a2 2 0 110-4 2 2 0 010 4zm8-4h-2.35a5.991 5.991 0 00-11.313.034A2 2 0 0042 48H22.65a5.99 5.99 0 00-11.277-.063A3.996 3.996 0 018 44v-6h4.007a1.977 1.977 0 00.633-.114 1.98 1.98 0 00.451-.213l.02-.011a2.003 2.003 0 00.467-.447c.111-.14.203-.295.272-.46l.007-.012L17.355 28h17.817l9.413 9.413a2 2 0 00.306.25c.048.032.1.054.149.081.063.038.128.073.196.103.065.024.132.045.2.062.057.017.112.04.172.052.13.026.26.039.392.039h6a4.005 4.005 0 014 4v6zM32.663 9.15a2 2 0 011.347-2.487A16.02 16.02 0 0153.917 17.43a1.999 1.999 0 11-3.834 1.14 12.02 12.02 0 00-14.933-8.073 2.001 2.001 0 01-2.487-1.347zm13.223 10.184a2.001 2.001 0 11-3.772 1.332 4.008 4.008 0 00-5.105-2.44 2 2 0 11-1.334-3.77 8.006 8.006 0 0110.21 4.878z"
    })),
    server: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M46.77 4H16.614A8.625 8.625 0 008 12.615v38.77A8.625 8.625 0 0016.615 60H46.77a8.625 8.625 0 008.616-8.615v-38.77A8.625 8.625 0 0046.769 4zm4.307 47.385a4.312 4.312 0 01-4.308 4.307H16.615a4.312 4.312 0 01-4.307-4.307v-8.616h38.769v8.616zm0-12.923h-38.77V25.538h38.77v12.924zM12.307 21.23v-8.616a4.312 4.312 0 014.308-4.307H46.77a4.312 4.312 0 014.308 4.307v8.616h-38.77zm15.078-6.462c0 1.19-.965 2.154-2.154 2.154h-6.462a2.154 2.154 0 010-4.308h6.462c1.19 0 2.154.965 2.154 2.154zM16.615 32c0-1.19.965-2.154 2.154-2.154h6.462a2.154 2.154 0 010 4.308h-6.462A2.154 2.154 0 0116.615 32zm0 17.23c0-1.189.965-2.153 2.154-2.153h6.462a2.154 2.154 0 010 4.308h-6.462a2.154 2.154 0 01-2.154-2.154z",
        clipRule: "evenodd"
    })),
    "service-device": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M28 52a2 2 0 11-4 0 2 2 0 014 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M18 4a8 8 0 00-8 8v40a8 8 0 008 8h16a8 8 0 008-8v-6a2 2 0 00-2-2H14V12a4 4 0 014-4h16a4 4 0 014 4v4.5a2 2 0 104 0V12a8 8 0 00-8-8H18zm-4 44v4a4 4 0 004 4h16a4 4 0 004-4v-4H14z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M31.578 34.924c-3.59 1.636-7.535.679-10.606-1.571-2.914-2.135-4.392-5.489-4.315-8.861a3.414 3.414 0 012.24-3.17c1.177-.44 2.544-.254 3.62.534l3.698 2.71a.953.953 0 00.96-1.311l-3.54-2.594c-1.116-.817-1.702-2.119-1.591-3.41a3.432 3.432 0 012.54-3.042c3.01-.847 6.613-.637 9.388 1.396 3.072 2.25 5.175 5.723 4.698 9.639L51.443 34.6c1.29.945 1.821 2.411 1.837 3.79.015 1.377-.466 2.799-1.35 4.005-.883 1.207-2.093 2.094-3.412 2.494-1.318.401-2.877.337-4.167-.608l-12.773-9.357zm-8.243-4.798c-1.538-1.127-2.45-2.822-2.642-4.647l3.344 2.449c.304.223.648.386 1.012.48 4.338 1.128 7.822-3.628 5.44-7.424a2.96 2.96 0 00-.765-.82l-3.15-2.308c1.867-.316 3.714.009 5.034.976 2.523 1.847 3.595 4.325 2.928 6.745a2 2 0 00.83 2.202l-.001.002 13.714 10.046c.046.034.196.177.2.608.006.432-.154 1.02-.575 1.596-.422.576-.935.906-1.349 1.031-.412.126-.593.026-.64-.008L33.001 31.008 33 31.01a2.001 2.001 0 00-2.35-.127c-2.107 1.365-4.792 1.09-7.315-.757z",
        clipRule: "evenodd"
    })),
    "service-supervision": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M29 52a2 2 0 11-4 0 2 2 0 014 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M19 4a8 8 0 00-8 8v40a8 8 0 008 8h16a8 8 0 008-8V42a2 2 0 10-4 0v2H15V12a4 4 0 014-4h16.5a4 4 0 014 4 2 2 0 104 0 8 8 0 00-8-8H19zm-4 44v4a4 4 0 004 4h16a4 4 0 004-4v-4H15z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M23.506 26.9c4.18 5.655 8.585 8.1 12.602 8.1 4.017 0 8.364-2.445 12.423-8.114-4.435-5.611-8.593-7.916-12.407-7.886-3.833.03-8.058 2.419-12.618 7.9zM36.092 15c5.965-.046 11.466 3.81 16.516 10.633a2 2 0 01.062 2.29C48.01 34.993 42.284 39 36.108 39c-6.165 0-11.961-3.995-16.762-11.052a2 2 0 01.077-2.356C24.603 18.955 30.16 15.047 36.093 15z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M36 24a3 3 0 100 6 3 3 0 000-6zm-7 3a7 7 0 1114 0 7 7 0 01-14 0z",
        clipRule: "evenodd"
    })),
    services: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M12 18a4 4 0 118 0 4 4 0 01-8 0zm4 10a4 4 0 100 8 4 4 0 000-8zm-4 18a4 4 0 118 0 4 4 0 01-8 0zm16-28a4 4 0 118 0 4 4 0 01-8 0zm4 10a4 4 0 100 8 4 4 0 000-8zm-4 18a4 4 0 118 0 4 4 0 01-8 0zm16-28a4 4 0 118 0 4 4 0 01-8 0zm4 10a4 4 0 100 8 4 4 0 000-8zm-4 18a4 4 0 118 0 4 4 0 01-8 0z",
        clipRule: "evenodd"
    })),
    settings: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M31.785 22.001c-5.523 0-10 4.477-10 10 0 5.522 4.477 10 10 10s10-4.478 10-10c-.007-5.52-4.48-9.994-10-10zm0 16a6 6 0 116-6 6.006 6.006 0 01-6 6zm26.652 1.511a3.972 3.972 0 00-1.868-2.44l-3.044-1.757a21.35 21.35 0 000-6.629l3.043-1.757a4.002 4.002 0 001.468-5.458l-1.306-2.259a882.006 882.006 0 01-2.688-4.66 3.997 3.997 0 00-5.475-1.478l-3.053 1.763a21.72 21.72 0 00-5.73-3.332V8.002a4.002 4.002 0 00-3.992-4l-2.611.002c-1.863.003-3.924.006-5.377-.003a3.798 3.798 0 00-2.839 1.161 3.976 3.976 0 00-1.18 2.84v3.503a21.713 21.713 0 00-5.73 3.332L15 13.074a4.004 4.004 0 00-5.46 1.459L8.193 16.87a845.816 845.816 0 01-2.647 4.58 3.997 3.997 0 001.455 5.48l3.044 1.756a21.35 21.35 0 000 6.629l-3.043 1.757a4.005 4.005 0 00-1.468 5.46l1.242 2.143a873.29 873.29 0 012.752 4.772 3.995 3.995 0 005.474 1.481l3.054-1.764a21.736 21.736 0 005.73 3.332V56a4.002 4.002 0 003.994 4l2.603-.003c1.867-.002 3.93-.007 5.386.003h.021a3.997 3.997 0 003.996-4v-3.504a21.729 21.729 0 005.73-3.332l3.054 1.764a4.004 4.004 0 005.461-1.46l1.215-2.109a982.094 982.094 0 012.778-4.807c.54-.917.689-2.012.413-3.04zm-3.866 1.02c-.76 1.301-1.836 3.17-2.793 4.833l-1.209 2.099-5.552-3.206-1.081.992a17.843 17.843 0 01-6.75 3.923l-1.4.44L35.79 56c-.729-.004-1.608-.005-2.54-.005l-2.874.002-2.59.002v-6.385l-1.401-.44a17.835 17.835 0 01-6.75-3.923l-1.082-.993-5.55 3.21c-.74-1.3-1.81-3.147-2.768-4.798l-1.234-2.133 5.539-3.198-.317-1.431a17.616 17.616 0 010-7.812l.317-1.432-5.542-3.194a828.068 828.068 0 002.66-4.605L13 16.538l5.552 3.206 1.082-.992a17.83 17.83 0 016.75-3.924l1.4-.44-.004-6.387c1.461.008 3.532.005 5.405.003l2.599-.002v6.386l1.4.44a17.828 17.828 0 016.749 3.923l1.082.992 5.551-3.21c.724 1.27 1.762 3.062 2.701 4.684l1.3 2.248-5.539 3.198.317 1.431c.584 2.571.584 5.24 0 7.812l-.317 1.431 5.54 3.198 1-1.732-.998 1.73z",
        clipRule: "evenodd"
    })),
    share: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M40.929 40.929c-.29.294-.563.606-.814.934l-16.458-7.315a10.062 10.062 0 000-5.1l16.405-7.383a10.02 10.02 0 10-1.74-3.603l-16.44 7.397a10.07 10.07 0 10.003 12.278l16.458 7.315a9.98 9.98 0 102.586-4.523zm2.828-29.172a6 6 0 110 8.486 5.985 5.985 0 010-8.486zM18.243 36.243a5.997 5.997 0 110-8.486 6.011 6.011 0 010 8.486zm34 16a5.997 5.997 0 110-8.486 6.011 6.011 0 010 8.486z"
    })),
    shopping: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M48 16h-4a12 12 0 00-24 0h-4a4.005 4.005 0 00-4 4v34a4.005 4.005 0 004 4h32a4.005 4.005 0 004-4V20a4.005 4.005 0 00-4-4zM32 8a8.01 8.01 0 018 8H24a8.01 8.01 0 018-8zm16 46H16V20h4v4a2 2 0 004 0v-4l16-.002V24a2 2 0 004 0v-4.002h4V54z"
    })),
    shoppingcart: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M47.44 44a6 6 0 005.82-4.54L57.88 21A4 4 0 0054 16H17.24l-1-4.78A4 4 0 0012.36 8H6a2 2 0 100 4h6.36l7.3 36.48a6 6 0 108 7.52h14.7a6 6 0 100-4H27.65a6 6 0 00-4-3.75L22.84 44h24.6zM54 20l-4.62 18.49A2 2 0 0147.44 40H22l-4-20h36zM22 56a2 2 0 110-4 2 2 0 110 4zm26-4a2 2 0 110 4 2 2 0 010-4z"
    })),
    shuffle: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M35.541 27.431a2.001 2.001 0 01.005-2.829l4.286-4.27A7.949 7.949 0 0145.478 18h7.694l-2.586-2.586a2 2 0 012.828-2.828l6 6a2 2 0 010 2.828l-6 6a2 2 0 01-2.828-2.828L53.172 22h-7.694a4.024 4.024 0 00-2.822 1.166l-4.286 4.27a2.002 2.002 0 01-2.829-.005zm17.873 9.155a2 2 0 10-2.828 2.828L53.172 42H45.48a3.973 3.973 0 01-2.824-1.167L32.552 30.756a1.183 1.183 0 00-.337-.336L22.1 20.334C20.502 18.742 18.39 18 15.452 18H6a2 2 0 100 4h9.452c2.338 0 3.245.59 3.824 1.167l8.862 8.837-8.86 8.83A3.98 3.98 0 0116.452 42H6a2 2 0 100 4h10.453a7.955 7.955 0 005.648-2.332l8.87-8.839 8.861 8.836A7.947 7.947 0 0045.48 46h7.692l-2.586 2.586a2 2 0 002.828 2.828l6-6a2 2 0 000-2.828l-6-6z",
        clipRule: "evenodd"
    })),
    signal: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 32a2 2 0 012 2v22a2 2 0 11-4 0V34a2 2 0 012-2zM43.9 9.27a2.001 2.001 0 012.83 0 18 18 0 010 25.46 2 2 0 11-2.83-2.83 14 14 0 000-19.8 2.001 2.001 0 010-2.83zm-26.63 0a2.001 2.001 0 112.83 2.83A13.92 13.92 0 0016 22a13.92 13.92 0 004.1 9.9 2.001 2.001 0 01-2.83 2.83 18 18 0 010-25.46zm7.075 5.073a2 2 0 011.415 3.417 6 6 0 000 8.48 2 2 0 11-2.83 2.83c-3.904-3.905-3.904-10.235 0-14.14a2 2 0 011.415-.587zm14.792.07a2.001 2.001 0 011.933.517c3.904 3.905 3.904 10.235 0 14.14a2.001 2.001 0 01-2.83-2.83 6 6 0 000-8.48 2.001 2.001 0 01.897-3.348zM32 19a3 3 0 110 6 3 3 0 010-6z"
    })),
    signature: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M21.333 39.629c-.53-2.145-1.95-4.268-4.62-4.554-4.796-.514-6.713 3.987-6.586 7.997.102 2.884 1.143 6.188 3.192 8.995-1.518 1.453-3.428 2.56-5.727 3.039a2 2 0 10.816 3.916c3.126-.651 5.669-2.14 7.658-4.045.064.053.13.105.195.157 2.42 1.91 4.339 3.062 5.959 3.5.848.23 1.69.286 2.504.092a4.279 4.279 0 001.964-1.085c.474-.45.832-.963 1.103-1.383.123-.192.244-.39.352-.567l.037-.06c.122-.2.232-.377.344-.547.453-.69.784-1 1.179-1.147.394-.148 1.028 0 1.677.671.11.136.229.294.36.468.842 1.112 2.18 2.88 4.497 3.837 2.886 1.191 5.69.677 7.628-.02a14.619 14.619 0 002.366-1.104c.287-.166.516-.313.68-.422l.284-.2h.002c.885-.66 1.464-2.22.803-3.106-.602-.806-1.769-1.235-3.192-.103-.1.067-.38.253-.585.372a10.62 10.62 0 01-1.712.799c-1.437.517-3.133.753-4.747.086-1.243-.513-1.887-1.342-2.742-2.445-.164-.211-.335-.432-.52-.664-.513-.638-1.258-1.498-2.357-1.972-1.208-.52-2.502-.447-3.847.057-1.605.602-2.524 1.793-3.118 2.697-.15.228-.29.455-.412.655l-.035.057c-.112.183-.209.341-.306.493-.22.34-.37.53-.49.644-.092.087-.13.096-.141.098h-.002c-.019.005-.166.038-.528-.06-.803-.218-2.32-1.04-4.65-2.88a19.088 19.088 0 002.3-4.956c.76-2.542.947-5.163.417-7.31zM17.5 45.56c-.32 1.637-1.5 4-1.5 4-1-1-1.926-4.125-2-6-.06-1.558 0-3 1-4s2.142-.32 2.5 1c.358 1.318.376 3.084 0 5zM32.334 5.072c-4.127.756-8.173 3.293-10.768 6.488-1.36 1.676-1.19 3.883-.2 5.431l19.636 30.67c.41.638.992 1.15 1.687 1.47 1.162.537 4.055 1.863 6.722 3.018a93.04 93.04 0 003.632 1.502c.497.188.964.354 1.345.464.182.052.407.11.634.143.11.016.287.036.493.027a2.137 2.137 0 001.117-.371c.468-.324.667-.75.723-.874.082-.18.13-.346.156-.452.055-.218.087-.445.109-.634.045-.392.073-.887.092-1.419a95.81 95.81 0 00.027-3.932c-.027-2.905-.123-6.08-.164-7.343a3.988 3.988 0 00-.665-2.076L36.968 7.15c-.93-1.402-2.667-2.438-4.635-2.078zm-7.662 9.01c2.038-2.51 5.26-4.504 8.382-5.075a.378.378 0 01.24.042.9.9 0 01.342.313l18.66 28.103c-.792.343-1.827.823-2.963 1.436-1.955 1.055-4.334 2.566-6.288 4.532l-18.31-28.599a.902.902 0 01-.15-.48c0-.126.036-.21.087-.272zM45.92 46.213c1.393.635 3.29 1.491 5.079 2.265.992.43 1.936.828 2.734 1.148.015-.866.015-1.898.005-2.985a307.11 307.11 0 00-.107-5.394c-.67.296-1.5.69-2.4 1.175-1.809.976-3.778 2.26-5.311 3.791z",
        clipRule: "evenodd"
    })),
    "sim-card": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M33.51 4a8 8 0 015.66 2.34l10.49 10.49A8 8 0 0152 22.49V52a8 8 0 01-8 8H20a8 8 0 01-8-8V12a8 8 0 018-8zm0 4H20a4 4 0 00-4 4v40a4 4 0 004 4h24a4 4 0 004-4V22.49a4 4 0 00-1.17-2.83L36.34 9.17A4 4 0 0033.51 8zM40 32a4 4 0 014 4v12a4 4 0 01-4 4H24a4 4 0 01-4-4V36a4 4 0 014-4zm-10 4h-6v12h6V36zm10 8h-6v4h6v-4zm0-8h-6v4h6v-4z"
    })),
    "skip-back10sec": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M24.309 40.751V29.377l-2.887 1.32a.98.98 0 01-.391.099c-.408 0-.8-.294-1.174-.88a1.95 1.95 0 01-.367-.906c0-.456.383-.864 1.15-1.223l5.038-2.275c.34-.146.707-.221 1.077-.22.636 0 .954.293.954.88v13.87a3.31 3.31 0 01-.538 1.834 1.476 1.476 0 01-1.174.832c-.408 0-.832-.318-1.273-.954a2.058 2.058 0 01-.415-1.003zm7.45-1.8a11.194 11.194 0 01-.745-4.303v-1.297c0-3.388 1.082-5.91 2.956-7.183a5.767 5.767 0 013.293-.937 5.69 5.69 0 015.524 3.82 11.64 11.64 0 01.722 4.3v1.297c0 3.389-1.058 5.91-2.932 7.16a5.97 5.97 0 01-8.817-2.858zm2.524-4.494c0 3.484.984 5.213 2.98 5.213 1.993 0 2.977-1.73 2.977-5.213v-.914c0-3.484-.984-5.213-2.977-5.213-1.996 0-2.98 1.729-2.98 5.213v.914zM30 10H18.828l2.586-2.586a2 2 0 10-2.828-2.828l-6 6a1.984 1.984 0 00-.375.539c-.076.15-.133.31-.169.475l-.004.012a2.006 2.006 0 00-.014.638c.02.175.062.348.127.512l.001.004.009.014a1.977 1.977 0 00.348.539c.027.031.047.066.077.095l6 6a2 2 0 002.828-2.828L18.828 14H30c12.542 0 22 8.598 22 20a20 20 0 11-40 0 2 2 0 00-4 0 24 24 0 0048 0c0-13.683-11.178-24-26-24z"
    })),
    "skip-back30sec": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M39.193 42.77a5.665 5.665 0 003.314-.961c1.874-1.25 2.933-3.772 2.933-7.16v-1.297a11.665 11.665 0 00-.722-4.3 5.689 5.689 0 00-5.525-3.821 5.766 5.766 0 00-3.292.937c-1.875 1.274-2.956 3.795-2.956 7.184v1.297c-.037 1.468.217 2.93.745 4.301a5.64 5.64 0 005.503 3.82zm-2.98-9.227c0-3.484.985-5.213 2.98-5.213 1.994 0 2.977 1.729 2.977 5.213v.914c0 3.484-.983 5.213-2.977 5.213-1.995 0-2.98-1.73-2.98-5.213v-.914zm-8.715 4.331a2.111 2.111 0 00-.8-2.227 3.734 3.734 0 00-2.277-.63h-1.09c-.323 0-.654-.242-.992-.727a1.472 1.472 0 01-.315-.774c0-.291.202-.566.605-.824a2.315 2.315 0 011.26-.388 3.682 3.682 0 002.216-.593 1.868 1.868 0 00.811-1.586 1.655 1.655 0 00-.69-1.344 2.709 2.709 0 00-1.732-.545A4.636 4.636 0 0021.2 29.93a.96.96 0 01-.654.34 1.46 1.46 0 01-1.162-.824 1.663 1.663 0 01-.34-.872.899.899 0 01.146-.46 6.304 6.304 0 012.398-2.132 6.782 6.782 0 013.221-.823 5.871 5.871 0 012.725.629 4.909 4.909 0 011.9 1.656c.445.661.682 1.44.679 2.237a3.889 3.889 0 01-.533 1.984 4.763 4.763 0 01-1.574 1.595 5.026 5.026 0 012.07 1.71c.497.698.764 1.533.764 2.389a4.674 4.674 0 01-.92 2.8 6.223 6.223 0 01-2.374 1.977 7.03 7.03 0 01-3.1.703 7.165 7.165 0 01-3.415-.824 5.312 5.312 0 01-2.277-2.18 1.818 1.818 0 01-.194-.653c0-.34.235-.662.703-.969.444-.299.966-.46 1.502-.46a.824.824 0 01.75.339c.367.52.842.953 1.393 1.272.518.272 1.097.41 1.683.4a3.107 3.107 0 002.57-1.135c.174-.22.29-.48.337-.756zM56 34a24 24 0 01-48 0 2 2 0 114 0 20 20 0 1040 0c0-11.402-9.458-20-22-20H18.828l2.586 2.586a2 2 0 11-2.828 2.828l-6-6c-.03-.03-.05-.064-.077-.094a1.934 1.934 0 01-.088-.108 1.993 1.993 0 01-.26-.432l-.009-.014v-.004a1.989 1.989 0 01-.14-.635 1.997 1.997 0 01.026-.515l.004-.012a1.993 1.993 0 01.228-.587c.085-.156.192-.3.316-.427l6-6a2 2 0 112.828 2.828L18.828 10H30c14.822 0 26 10.317 26 24z"
    })),
    "skip-forward10sec": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M56 34a24 24 0 01-48 0c0-13.683 11.178-24 26-24h11.172l-2.586-2.586a2 2 0 012.828-2.828l6 6a1.984 1.984 0 01.375.539c.076.15.133.31.169.475l.004.012a2.001 2.001 0 01.014.638 1.99 1.99 0 01-.127.512l-.001.004-.009.014c-.068.154-.155.3-.26.432a1.942 1.942 0 01-.088.107c-.027.031-.047.066-.077.095l-6 6a2 2 0 01-2.828-2.828L45.172 14H34c-12.542 0-22 8.598-22 20a20 20 0 1040 0 2 2 0 014 0zm-31.275 7.754c.44.636.864.954 1.272.954a1.476 1.476 0 001.174-.832 3.308 3.308 0 00.538-1.834v-13.87c0-.587-.318-.88-.954-.88a2.705 2.705 0 00-1.076.22l-5.04 2.275c-.766.359-1.15.767-1.149 1.223.044.328.17.64.367.905.375.587.766.88 1.174.88a.982.982 0 00.391-.097l2.887-1.321v11.374c.046.366.19.712.416 1.003zm18.062-12.702c.51 1.375.754 2.834.722 4.3v1.297c0 3.388-1.058 5.91-2.932 7.16a5.97 5.97 0 01-8.817-2.859 11.196 11.196 0 01-.746-4.302v-1.297c0-3.388 1.082-5.91 2.956-7.183a5.767 5.767 0 013.293-.937 5.69 5.69 0 015.524 3.82zm-2.547 4.491c0-3.484-.984-5.213-2.977-5.213-1.996 0-2.98 1.729-2.98 5.213v.914c0 3.484.984 5.213 2.98 5.213 1.993 0 2.977-1.73 2.977-5.213v-.914z"
    })),
    "skip-forward30sec": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M39.193 25.23a5.767 5.767 0 00-3.292.938c-1.875 1.273-2.956 3.795-2.956 7.184v1.297c-.037 1.468.216 2.93.745 4.301a5.97 5.97 0 008.817 2.859c1.874-1.25 2.933-3.772 2.933-7.16v-1.297a11.663 11.663 0 00-.722-4.3 5.688 5.688 0 00-5.525-3.821zm2.978 9.227c0 3.484-.984 5.213-2.978 5.213-1.995 0-2.98-1.73-2.98-5.213v-.914c0-3.484.985-5.213 2.98-5.213 1.994 0 2.978 1.729 2.978 5.213v.914zm-14.673 3.417a2.111 2.111 0 00-.8-2.227 3.734 3.734 0 00-2.277-.63h-1.09c-.323 0-.654-.242-.992-.726a1.472 1.472 0 01-.315-.775c0-.291.202-.566.605-.824a2.306 2.306 0 011.26-.387 3.682 3.682 0 002.216-.594 1.867 1.867 0 00.811-1.586 1.654 1.654 0 00-.69-1.344 2.71 2.71 0 00-1.732-.545A4.637 4.637 0 0021.2 29.93a.96.96 0 01-.654.34 1.46 1.46 0 01-1.162-.824 1.663 1.663 0 01-.34-.872.899.899 0 01.146-.46 6.305 6.305 0 012.398-2.132 6.783 6.783 0 013.221-.823 5.871 5.871 0 012.725.629 4.907 4.907 0 011.9 1.656c.445.661.682 1.44.679 2.237a3.89 3.89 0 01-.533 1.984 4.773 4.773 0 01-1.574 1.595 5.026 5.026 0 012.07 1.71c.497.698.764 1.533.764 2.389a4.674 4.674 0 01-.92 2.8 6.223 6.223 0 01-2.374 1.977 7.03 7.03 0 01-3.1.703 7.165 7.165 0 01-3.415-.824 5.314 5.314 0 01-2.277-2.18 1.82 1.82 0 01-.194-.653c0-.34.235-.662.703-.969.443-.299.966-.46 1.501-.46a.823.823 0 01.751.339c.367.52.842.953 1.393 1.271.518.273 1.097.41 1.683.4a3.108 3.108 0 002.57-1.134c.174-.22.29-.48.337-.756zM56 34a24 24 0 01-48 0c0-13.683 11.178-24 26-24h11.172l-2.586-2.586a2 2 0 012.828-2.828l6 6a1.984 1.984 0 01.375.539c.076.15.133.31.169.475l.004.012a2.006 2.006 0 01.014.638 1.98 1.98 0 01-.127.512l-.001.004-.009.014a1.99 1.99 0 01-.26.432 1.898 1.898 0 01-.088.107c-.027.031-.047.066-.077.095l-6 6a2 2 0 01-2.828-2.828L45.172 14H34c-12.542 0-22 8.598-22 20a20 20 0 1040 0 2 2 0 014 0z"
    })),
    "slow-wifi": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M53 28a2 2 0 11-4 0 2 2 0 014 0zm7-.128A9 9 0 0151 37h-2.172L46 39.828V41a8 8 0 01-16 0h-8a8 8 0 11-16 0 2 2 0 110-4h.05c.01-.05.03-.096.044-.144.002-.053-.008-.104-.004-.157C7.07 24.33 15.63 15 26 15c6.803 0 12.81 4.03 16.426 10.284A9.016 9.016 0 0151.001 19l.127.001A9.06 9.06 0 0160 27.872zm-23.864-4.356a1.995 1.995 0 01-.153.281l-3.608 5.273L37.133 37h4.781a21.646 21.646 0 00-5.778-13.484zM26 19c-2.518.01-4.983.727-7.114 2.067.073.073.14.152.201.236L23.047 27h5.899l3.736-5.46c.124-.179.277-.334.452-.462A13.474 13.474 0 0026 19zM10.08 37h4.787l4.752-7.92-3.817-5.494-.002-.003A21.715 21.715 0 0010.08 37zM18 41h-8a4 4 0 108 0zm14.467-4l-3.6-6h-5.734l-3.6 6h12.934zM42 41h-8a4 4 0 108 0zm14-13.071A5.094 5.094 0 0051.07 23l-.07-.001a5.02 5.02 0 00-4.882 3.906 3.943 3.943 0 01-1.79 2.481 27.582 27.582 0 011.322 5.133l.349-.348A3.973 3.973 0 0148.828 33H51a4.999 4.999 0 004.999-5.071z",
        clipRule: "evenodd"
    })),
    "smart-wifi": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M39.073 35.929a2 2 0 11-2.828 2.829 6.002 6.002 0 00-8.487 0 2 2 0 01-2.828-2.83 10.001 10.001 0 0114.143 0zM32 41a3 3 0 100 6 3 3 0 000-6zm26.933-7.47A3.988 3.988 0 0155.239 36H54v18a4.005 4.005 0 01-4 4H14a4.004 4.004 0 01-4-4V36H8.764a4 4 0 01-2.828-6.828L27.759 7.349a5.998 5.998 0 018.484 0l21.824 21.823a3.988 3.988 0 01.867 4.359zM55.239 32L33.415 10.177a2.049 2.049 0 00-2.828 0L8.764 32h5.237v22h36V32h5.238zm-35.965-1.727a2 2 0 002.828 2.828 14 14 0 0119.799 0 2 2 0 002.828-2.828 17.996 17.996 0 00-25.455 0z"
    })),
    smartphone: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M40 4H24a8.01 8.01 0 00-8 8v40a8.01 8.01 0 008 8h16a8.01 8.01 0 008-8V12a8.01 8.01 0 00-8-8zm-20 8a4.004 4.004 0 014-4h16a4.004 4.004 0 014 4v32H20V12zm24 40a4.004 4.004 0 01-4 4H24a4.004 4.004 0 01-4-4v-4h24v4zm-14 0a2 2 0 114 0 2 2 0 01-4 0z",
        clipRule: "evenodd"
    })),
    smartwatch: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M14.23 9.276A6 6 0 0119.975 5h8.048a6 6 0 015.747 4.276l1.86 6.2A7.99 7.99 0 0139 22v20a7.99 7.99 0 01-3.37 6.524l-1.86 6.2A6 6 0 0128.025 59h-8.048a6 6 0 01-5.747-4.276l-1.86-6.2A7.99 7.99 0 019 42V22a7.99 7.99 0 013.37-6.524l1.86-6.2zM16.987 50l1.073 3.575A2 2 0 0019.976 55h8.048a2 2 0 001.915-1.425L31.012 50H16.988zM29.94 10.425L31.012 14H16.988l1.073-3.575A2 2 0 0119.976 9h8.048a2 2 0 011.915 1.425zM17 18a4 4 0 00-4 4v20a4 4 0 004 4h14a4 4 0 004-4V22a4 4 0 00-4-4H17zm33.315 16.87c.622-2.384.671-5.785-1.98-9.76a2 2 0 013.33-2.22c3.349 5.026 3.398 9.624 2.52 12.99a15.416 15.416 0 01-1.617 3.9c-.272.46-.52.824-.706 1.08a9.526 9.526 0 01-.303.394l-.025.03-.009.01-.003.004-.002.002s.014-.017-.002.002a2 2 0 01-3.043-2.595l1.84-3.837zm0 0a11.417 11.417 0 01-1.195 2.882 9.247 9.247 0 01-.62.923l-.018.022-.005.007 1.838-3.834z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M42.336 29.11c1.15 1.725 1.044 3.255.854 4.073-.143.614-.216.728-.441 1.08-.075.116-.166.258-.282.453-.467.784-.601 2.089.232 2.803a2 2 0 002.82-.217l.003-.004.003-.004.008-.008.018-.022a4.14 4.14 0 00.188-.245c.11-.151.253-.36.407-.622.306-.52.67-1.27.914-2.204.504-1.929.454-4.527-1.396-7.302a2 2 0 00-3.328 2.219z"
    })),
    "smiley-happy": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 4.5c-15.464 0-28 12.536-28 28s12.536 28 28 28 28-12.536 28-28c-.017-15.457-12.543-27.983-28-28zm0 51.692c-13.085 0-23.692-10.607-23.692-23.692S18.915 8.808 32 8.808 55.693 19.415 55.693 32.5C55.678 45.579 45.079 56.177 32 56.192zm16.517-18.77a17.237 17.237 0 01-33.034 0 2.154 2.154 0 014.128-1.228 12.929 12.929 0 0024.777 0 2.154 2.154 0 014.129 1.228zM20.154 26.039a3.23 3.23 0 116.461 0 3.23 3.23 0 01-6.461 0zm17.23 0a3.23 3.23 0 116.462 0 3.23 3.23 0 01-6.461 0z",
        clipRule: "evenodd"
    })),
    "smiley-sad": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 4C16.536 4 4 16.536 4 32s12.536 28 28 28 28-12.536 28-28C59.983 16.543 47.457 4.017 32 4zm0 51.692C18.915 55.692 8.308 45.085 8.308 32S18.915 8.308 32 8.308 55.692 18.915 55.692 32C55.678 45.079 45.08 55.678 32 55.692zM20.154 25.538a3.23 3.23 0 116.461 0 3.23 3.23 0 01-6.461 0zm17.23 0a3.23 3.23 0 116.462 0 3.23 3.23 0 01-6.461 0zm7.174 17.404c-.663.987-2 1.251-2.989.589a17.163 17.163 0 00-19.138 0 2.154 2.154 0 11-2.4-3.578 21.474 21.474 0 0123.938 0c.988.663 1.252 2 .59 2.989z",
        clipRule: "evenodd"
    })),
    sms: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M27.828 23.677a2.64 2.64 0 100-5.279 2.64 2.64 0 000 5.279zm13.167-2.64a2.64 2.64 0 11-5.278 0 2.64 2.64 0 015.278 0zm7.272 2.64a2.64 2.64 0 100-5.279 2.64 2.64 0 000 5.279z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M24.319 7a7.93 7.93 0 00-7.93 7.93v8.424h-4.46A7.93 7.93 0 004 31.284V42.68a7.93 7.93 0 007.93 7.93h10.576l6.152 6.152c1.874 1.873 5.076.546 5.076-2.103v-4.05h5.947a7.93 7.93 0 007.93-7.929v-8.424h4.46A7.93 7.93 0 0060 26.327V14.93A7.93 7.93 0 0052.07 7H24.32zM52.07 30.292a3.965 3.965 0 003.964-3.965V14.93a3.965 3.965 0 00-3.964-3.964H24.319a3.965 3.965 0 00-3.965 3.964v11.398a3.965 3.965 0 003.965 3.965h9.911v5.621l5.622-5.621H52.07zm-35.62-2.973a7.93 7.93 0 007.868 6.938h5.947v4.05c0 2.648 3.202 3.975 5.076 2.102l6.152-6.152h2.152v8.424a3.965 3.965 0 01-3.965 3.965h-9.91v5.621l-5.622-5.621H11.93a3.965 3.965 0 01-3.964-3.965V31.283a3.965 3.965 0 013.964-3.964h4.522z",
        clipRule: "evenodd"
    })),
    snapchat: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M31.431 6.01c-2.31 0-10.139.64-13.832 8.925-1.242 2.787-.945 7.52-.706 11.32.029.448.059.914.08 1.36-.19.106-.54.24-1.089.24-.734 0-1.6-.23-2.575-.688a2.082 2.082 0 00-.887-.182c-1.143 0-2.51.752-2.72 1.872-.154.806.207 1.984 2.8 3.008.233.093.515.182.813.276 1.07.34 2.69.854 3.13 1.89.228.536.136 1.226-.27 2.05-.168.389-3.596 8.202-11.206 9.456a1.162 1.162 0 00-.968 1.214c.011.18.053.356.124.521.572 1.335 2.981 2.314 7.368 2.995.146.198.3.899.392 1.325.093.427.186.855.32 1.314.134.458.476.989 1.36.989.357 0 .777-.08 1.265-.178.73-.143 1.731-.338 2.984-.338.717.001 1.433.062 2.14.18 1.415.236 2.618 1.087 4.011 2.07 1.996 1.411 4.255 3.011 7.689 3.011.094 0 .188 0 .283-.01.11.005.256.01.41.01 3.434 0 5.693-1.6 7.686-3.006 1.396-.986 2.597-1.836 4.014-2.071a13.127 13.127 0 012.139-.181c1.003.006 2.003.113 2.984.32.416.092.84.145 1.265.16.716 0 1.176-.345 1.359-.97.132-.45.227-.873.32-1.3.093-.429.245-1.12.391-1.32 4.388-.682 6.8-1.659 7.367-2.989.072-.166.115-.343.126-.524a1.16 1.16 0 00-.97-1.21c-7.614-1.256-11.04-9.068-11.182-9.4-.432-.88-.523-1.57-.295-2.106.44-1.036 2.058-1.55 3.13-1.89.3-.094.581-.184.812-.275 1.899-.75 2.85-1.67 2.83-2.736-.016-.838-.668-1.584-1.704-1.955a3.117 3.117 0 00-1.168-.224 2.584 2.584 0 00-1.072.218c-.903.423-1.714.653-2.413.684a2.14 2.14 0 01-.941-.234c.021-.385.046-.783.072-1.2l.01-.16c.24-3.804.538-8.54-.706-11.328C42.703 6.647 34.858 6 32.541 6l-1.11.01z",
        clipRule: "evenodd"
    })),
    snowflake: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M56.279 29.58a2.166 2.166 0 101.701-3.984l-6.178-2.639 5.123-2.988a2.167 2.167 0 10-2.183-3.743l-4.88 2.846.752-6.234a2.166 2.166 0 00-4.302-.519l-1.144 9.491-5.106 2.979a10.824 10.824 0 00-5.895-3.404V15.75l7.8-5.85a2.166 2.166 0 10-2.6-3.466l-5.2 3.9V6a2.167 2.167 0 10-4.333 0v4.334l-5.2-3.9a2.166 2.166 0 10-2.6 3.466l7.8 5.85v5.635a10.825 10.825 0 00-5.895 3.404l-5.107-2.979-1.144-9.49a2.166 2.166 0 00-4.301.518l.75 6.234-4.878-2.846a2.167 2.167 0 10-2.184 3.743l5.123 2.988-6.178 2.64a2.166 2.166 0 101.702 3.984l9.14-3.904 4.886 2.85a10.662 10.662 0 000 6.945l-4.887 2.85-9.14-3.902a2.166 2.166 0 10-1.7 3.984l6.177 2.639-5.123 2.988a2.167 2.167 0 002.184 3.743l4.879-2.846-.751 6.235a2.165 2.165 0 104.301.518l1.144-9.491 5.107-2.979a10.824 10.824 0 005.895 3.404v5.635l-7.8 5.85a2.166 2.166 0 002.6 3.466l5.2-3.9V58a2.167 2.167 0 104.333 0v-4.333l5.2 3.9a2.167 2.167 0 102.6-3.466l-7.8-5.85v-5.636a10.825 10.825 0 005.895-3.404l5.106 2.98 1.144 9.49a2.166 2.166 0 104.302-.518l-.752-6.235 4.88 2.846a2.167 2.167 0 102.183-3.743l-5.186-3.025 6.058-2.693a2.166 2.166 0 10-1.76-3.959l-8.912 3.96-4.873-2.842a10.66 10.66 0 000-6.944l4.887-2.85 9.14 3.903zM32 38.5a6.5 6.5 0 116.5-6.5 6.507 6.507 0 01-6.5 6.5z",
        clipRule: "evenodd"
    })),
    sorter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M33.153 42.686L20.301 55.414a2.034 2.034 0 01-2.857 0L4.592 42.686a1.986 1.986 0 010-2.828 2.034 2.034 0 012.856 0l9.405 9.314V10c0-1.105.904-2 2.02-2a2.01 2.01 0 012.02 2v39.172l9.404-9.314a2.033 2.033 0 012.856 0 1.986 1.986 0 010 2.828zm-2.306-21.372L43.699 8.586a2.034 2.034 0 012.857 0l12.852 12.728a1.986 1.986 0 010 2.828 2.034 2.034 0 01-2.856 0l-9.405-9.314V54c0 1.105-.904 2-2.02 2a2.01 2.01 0 01-2.02-2V14.828l-9.404 9.314a2.033 2.033 0 01-2.856 0 1.986 1.986 0 010-2.828z",
        clipRule: "evenodd"
    })),
    "speedometer-dots": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M4.32 31.496a2.371 2.371 0 00-.039.781 25.29 25.29 0 00-.015.946c0 7.414 2.937 14.148 7.707 19.109.836.867 2.18.98 3.152.27l3.629-2.668a2.401 2.401 0 00-2.844-3.868l-1.86 1.368a22.694 22.694 0 01-4.956-13.036H12a2.399 2.399 0 000-4.796H9.352a22.73 22.73 0 015.414-11.438l1.972 1.973a2.407 2.407 0 003.395 0 2.4 2.4 0 000-3.395l-1.828-1.828a22.868 22.868 0 0111.293-4.39v2.808a2.4 2.4 0 104.8 0v-2.809c2.04.211 3.993.688 5.832 1.391a2.404 2.404 0 003.102-1.383 2.404 2.404 0 00-1.383-3.101A27.79 27.79 0 0032 5.602a27.711 27.711 0 00-18.309 6.87 2.412 2.412 0 00-1.14 1.055c-4.727 4.633-7.797 10.946-8.23 17.97zM51.031 12.97a2.407 2.407 0 010 3.394L32.363 35.031a2.4 2.4 0 11-3.394-3.394l18.668-18.668a2.4 2.4 0 013.394 0zm2.38 6.558a2.4 2.4 0 013.237 1.024 27.412 27.412 0 013.082 12.672c0 7.414-2.933 14.148-7.707 19.109-.832.867-2.18.98-3.148.27l-3.629-2.668a2.398 2.398 0 112.84-3.868l1.86 1.368a22.64 22.64 0 004.956-13.036h-4.238a2.399 2.399 0 010-4.796h3.98a22.515 22.515 0 00-2.257-6.84 2.4 2.4 0 011.023-3.235zm0 0"
    })),
    "speedometer-max": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M61.38 48.92H32.46c-1.45 0-2.62-1.17-2.62-2.62s1.17-2.62 2.62-2.62h28.92c1.45 0 2.62 1.17 2.62 2.62s-1.17 2.62-2.62 2.62z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M2.69 50.49c-1.36 0-2.51-1.05-2.61-2.43v-.11C.02 47.23 0 46.52 0 45.82c0-17.06 13.88-30.94 30.94-30.94 13.48 0 25.32 8.61 29.45 21.44a2.61 2.61 0 01-1.69 3.29 2.61 2.61 0 01-3.29-1.69c-3.43-10.65-13.27-17.81-24.47-17.81-14.17 0-25.7 11.53-25.7 25.7 0 .59.02 1.18.06 1.77v.1c.11 1.44-.98 2.69-2.42 2.8h-.19z"
    })),
    "speedometer-normal": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M2.67 50.52c-1.34 0-2.48-1.03-2.58-2.39-.06-.79-.09-1.6-.09-2.39 0-4.06.78-8.01 2.33-11.73A2.593 2.593 0 117.12 36a25.345 25.345 0 00-1.85 11.74c.11 1.43-.96 2.67-2.38 2.78h-.2zm55.92.03h-.22a2.59 2.59 0 01-2.37-2.8c.06-.69.09-1.4.09-2.11 0-14.04-11.42-25.46-25.46-25.46-4.81 0-9.49 1.35-13.54 3.9a2.59 2.59 0 01-2.76-4.38 30.55 30.55 0 0116.3-4.69c16.89 0 30.64 13.74 30.64 30.64 0 .85-.04 1.7-.1 2.53a2.598 2.598 0 01-2.58 2.38zM30.96 48.8c-.6 0-1.2-.21-1.69-.62L5.77 28.04a2.585 2.585 0 01-.28-3.65 2.585 2.585 0 013.65-.28l23.5 20.14c1.09.93 1.21 2.57.28 3.65-.51.6-1.24.91-1.97.91z"
    })),
    "speedometer-rask": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M2.78 50.55c-1.35 0-2.49-1.04-2.59-2.4-.06-.8-.09-1.6-.09-2.39C.1 28.79 13.9 15 30.85 15c2.89 0 5.75.4 8.5 1.19.98.28 1.96.62 2.92 1 1.33.53 1.98 2.05 1.45 3.38s-2.05 1.98-3.38 1.45a25.453 25.453 0 00-9.48-1.82c-14.09 0-25.55 11.46-25.55 25.55 0 .66.03 1.33.08 2 .11 1.43-.96 2.68-2.39 2.79h-.2zm56.13.06h-.21a2.607 2.607 0 01-2.39-2.8c.05-.68.08-1.37.08-2.05 0-4.84-1.36-9.55-3.93-13.62-.77-1.21-.4-2.82.81-3.59s2.82-.4 3.59.81c3.1 4.9 4.73 10.57 4.73 16.4 0 .82-.03 1.65-.1 2.47a2.602 2.602 0 01-2.59 2.39zm-28.78-1.78c-.59 0-1.19-.2-1.67-.61a2.612 2.612 0 01-.32-3.67L48 20.95c.93-1.1 2.57-1.24 3.67-.32a2.6 2.6 0 01.32 3.66l-19.86 23.6c-.51.61-1.25.93-1.99.93z"
    })),
    speedometer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M13 55.31a2 2 0 01-1.54-.72A28 28 0 0141.59 10c.37.12.74.25 1.1.39a2 2 0 11-1.38 3.75c-.32-.12-.63-.23-1-.33A24 24 0 0014.54 52a2 2 0 01-.26 2.81 2 2 0 01-1.28.5zm40 0a2 2 0 01-1.28-.47 2 2 0 01-.26-2.84 24 24 0 001.85-28.1 2 2 0 113.38-2.14 28 28 0 01-2.15 32.83 2 2 0 01-1.54.72zM31.73 38.24a2 2 0 001.27.45 2 2 0 001.55-.69l18-22a2.013 2.013 0 10-3.1-2.57l-18 22a2 2 0 00.28 2.81z"
    })),
    "spell-check": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M19.19 28.365a3.7 3.7 0 00.42.812c.485.728.97 1.092 1.455 1.092a1.688 1.688 0 001.344-.952 3.787 3.787 0 00.616-2.1 1.375 1.375 0 00-.112-.56l-5.6-15.54c-.133-.41-.478-.615-1.036-.616h-1.763c-.386.004-.77.072-1.135.2-.363.12-.704.3-1.008.532a1.652 1.652 0 00-.574.728L6.058 27.525c-.062.16-.1.329-.113.5.06.417.223.812.476 1.148.486.728.971 1.092 1.456 1.092a1.399 1.399 0 00.98-.476c.332-.339.58-.75.728-1.2l.84-2.38h8.01l.754 2.156zm-7.56-5.516l2.855-8.092 2.8 8.092H11.63zm15.707 7.252h6.355a6.087 6.087 0 004.4-1.668 5.6 5.6 0 001.736-4.22 4.714 4.714 0 00-.364-1.808 5.279 5.279 0 00-1.05-1.612 5.078 5.078 0 00-1.61-1.15 5.828 5.828 0 001.5-1.817c.34-.647.518-1.368.518-2.1a4.98 4.98 0 00-.714-2.614 5.245 5.245 0 00-2-1.9 5.918 5.918 0 00-2.913-.713h-4.99a3.452 3.452 0 00-1.918.574 1.575 1.575 0 00-.883 1.246v15.54a2.5 2.5 0 00.477 1.148c.486.73.971 1.094 1.456 1.094zm1.848-16.1h3.864a1.971 1.971 0 011.442.6 2 2 0 01.6 1.47 2.309 2.309 0 01-.6 1.6 1.9 1.9 0 01-1.47.672h-3.836v-4.342zm0 7.644h4.284a2.402 2.402 0 011.792.688 2.472 2.472 0 01.672 1.806 2.406 2.406 0 01-.7 1.75 2.334 2.334 0 01-1.736.714h-4.312v-4.958z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M56.54 25.257c-.536.037-1.06.18-1.54.42-.12.055-.243.088-.365.136a6.941 6.941 0 00-2.176-2.968 7.027 7.027 0 00-4.343-1.512c-.828 0-1.65.148-2.427.435a7.055 7.055 0 01-.153-1.435 6.614 6.614 0 01.742-3.122 5.68 5.68 0 012.128-2.254 5.96 5.96 0 013.151-.84 7.285 7.285 0 013.3.868c.206.117.436.185.672.2.43 0 .83-.294 1.2-.882a3.513 3.513 0 00.561-1.918.9.9 0 00-.42-.84 9.66 9.66 0 00-5.236-1.456 9.8 9.8 0 00-4.985 1.344 10.43 10.43 0 00-3.765 3.752 10.157 10.157 0 00-1.443 5.32 10.399 10.399 0 00.783 3.99L28.485 41.851l-3.672-3.642a7 7 0 10-9.857 9.941l9.23 9.153a6.959 6.959 0 005.37 2.016 7 7 0 005.043-2.639l19-24a6.951 6.951 0 001.37-2.98 6.047 6.047 0 001.483-.885 3.14 3.14 0 00.784-1.134c.204-.456.31-.949.313-1.448a.878.878 0 00-1.009-.976zm-6.073 4.938l-19 24a3 3 0 01-2.348 1.138 3 3 0 01-2.12-.87l-9.23-9.154a3.002 3.002 0 014.23-4.26l6.85 6.792 16.916-21.37a3 3 0 014.705 3.724h-.003z"
    })),
    split: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M22.458 34H6a2 2 0 010-4h16.766l9.587-9.596A7.95 7.95 0 0138 18.072h15l-2.586-2.586a2 2 0 012.828-2.828l6 6a2 2 0 010 2.828l-6 6a2 2 0 01-2.828-2.828L53 22.072H38a4.024 4.024 0 00-2.823 1.166l-8.9 8.909 8.9 8.779A4.023 4.023 0 0038 42.092h15l-2.586-2.586a2 2 0 012.828-2.828l6 6a2 2 0 010 2.828l-6 6a2 2 0 11-2.828-2.828L53 46.092H38a7.949 7.949 0 01-5.647-2.332L22.458 34z"
    })),
    spyware: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M30 22.864V37.33c0 .833.372 1.25 1.113 1.25.702 0 1.387-.256 1.97-.735.611-.491.917-1.006.917-1.546V21.833a3.046 3.046 0 00-.481-1.436c-.5-.931-1.002-1.397-1.504-1.397-.348.025-.675.209-.917.515a4.098 4.098 0 00-.782 1.435A5.854 5.854 0 0030 22.864zm3.681 20.47a2.352 2.352 0 00-.429-1.087c-.42-.66-.827-.99-1.218-.99-.304.015-.59.154-.802.387-.287.295-.51.654-.653 1.05-.173.44-.261.912-.26 1.389 0 .611.316.917.947.917.586 0 1.16-.185 1.648-.532.511-.354.767-.732.767-1.134z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M34.418 7.387a31.732 31.732 0 0017.65 6.614 4.003 4.003 0 013.932 4v10c0 22.616-18.705 28.7-22.455 29.69a6.04 6.04 0 01-3.092 0C26.705 56.702 8 50.618 8 28.002V18a4.003 4.003 0 013.933-4 31.731 31.731 0 0017.65-6.614 3.95 3.95 0 014.835 0zm-1.896 46.438C37.092 52.618 52 47.19 52 28V18c-.038 0-.075 0-.113-.003a35.711 35.711 0 01-19.916-7.446 35.374 35.374 0 01-19.858 7.446A2.142 2.142 0 0112 18h-.003L12 28c0 19.19 14.907 24.618 19.477 25.825.342.091.702.091 1.045 0z",
        clipRule: "evenodd"
    })),
    "star-filled": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M28.202 7.746c1.223-3.661 6.373-3.661 7.596 0l4.974 14.879h15.213c3.863 0 5.49 4.954 2.386 7.267l-12.145 9.05 4.922 14.726c1.233 3.689-2.935 6.818-6.102 4.582L32 49.036 18.954 58.25c-3.167 2.236-7.335-.893-6.102-4.582l4.922-14.726-12.145-9.05c-3.103-2.313-1.477-7.267 2.386-7.267h15.213l4.974-14.88z"
    })),
    star: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M59.763 25.024a4.236 4.236 0 00-4.065-2.915h-14.67L36.046 7.875a4.291 4.291 0 00-8.102-.001l-4.982 14.235H8.292a4.292 4.292 0 00-2.606 7.701l11.987 9.167-4.921 14.763a4.292 4.292 0 006.584 4.836l12.659-9.143 12.66 9.143a4.228 4.228 0 005.051-.02 4.227 4.227 0 001.532-4.817l-4.921-14.762 11.987-9.167a4.237 4.237 0 001.459-4.786zM43.712 35.568a4.295 4.295 0 00-1.466 4.767l4.921 14.762-12.66-9.143a4.284 4.284 0 00-5.024 0l-12.66 9.143 4.922-14.764a4.294 4.294 0 00-1.465-4.765L8.293 26.4h14.67a4.294 4.294 0 004.05-2.873l4.982-14.235 4.982 14.234a4.294 4.294 0 004.051 2.874h14.67l-11.986 9.167z",
        clipRule: "evenodd"
    })),
    statistics: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M58 52h-6V12a4 4 0 00-4-4h-8a4 4 0 00-4 4v12h-8a4 4 0 00-4 4v4h-8a4 4 0 00-4 4v16H6a2 2 0 100 4h52a2 2 0 100-4zm-42 0V36h8v16h-8zm12 0V28h8v24h-8zm12 0V12h8v40h-8z"
    })),
    stop: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M18 32a2 2 0 002 2h24a2 2 0 100-4H20a2 2 0 00-2 2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 4C16.536 4 4 16.536 4 32s12.536 28 28 28 28-12.536 28-28A28 28 0 0032 4zm0 4c13.255 0 24 10.745 24 24S45.255 56 32 56 8 45.255 8 32 18.745 8 32 8z",
        clipRule: "evenodd"
    })),
    store: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M56.47 16.018l-2.902-5.807A3.98 3.98 0 0049.99 8H12.462a3.979 3.979 0 00-3.578 2.21l-2.902 5.807a5.81 5.81 0 00-.43 4.246 7.912 7.912 0 001.782 3.116c-.07.2-.106.41-.108.621v28a4.004 4.004 0 004 4h40a4.004 4.004 0 004-4V24a1.98 1.98 0 00-.108-.621 7.912 7.912 0 001.783-3.115 5.814 5.814 0 00-.43-4.246zM9.56 17.807L12.462 12H49.99l2.904 5.808c.22.406.28.878.169 1.326A4.02 4.02 0 0149.226 22a3.544 3.544 0 01-3.367-2.428l-.736-2.205c-.008-.024-.021-.044-.03-.068a1.97 1.97 0 00-.087-.194 1.976 1.976 0 00-.09-.164 2.043 2.043 0 00-.112-.156 1.974 1.974 0 00-.125-.152 1.837 1.837 0 00-.137-.128c-.05-.043-.096-.085-.148-.122a2.027 2.027 0 00-.17-.106 2.137 2.137 0 00-.156-.086 1.99 1.99 0 00-.195-.075 2.215 2.215 0 00-.17-.053 2.02 2.02 0 00-.2-.035 1.983 1.983 0 00-.196-.02c-.028 0-.053-.008-.081-.008-.041 0-.08.01-.12.012a1.99 1.99 0 00-.406.067c-.035.01-.071.012-.107.024-.024.008-.044.021-.067.03a1.987 1.987 0 00-.195.087 1.979 1.979 0 00-.165.09 1.977 1.977 0 00-.154.111c-.053.04-.105.082-.154.127-.045.042-.084.088-.125.133-.045.05-.087.1-.127.154-.037.051-.068.105-.1.16-.032.055-.065.11-.092.17a1.965 1.965 0 00-.068.177 1.975 1.975 0 00-.06.19 2.042 2.042 0 00-.03.177c-.012.073-.02.146-.023.22 0 .024-.007.047-.007.071a4 4 0 11-8 0 2 2 0 00-4 0 4 4 0 11-8 0c0-.024-.006-.047-.007-.07a1.973 1.973 0 00-.022-.221c-.01-.06-.018-.119-.032-.176a2.026 2.026 0 00-.06-.191 2.249 2.249 0 00-.067-.178c-.027-.058-.06-.113-.092-.17-.032-.054-.063-.108-.1-.159a1.988 1.988 0 00-.127-.154c-.04-.045-.08-.091-.125-.133-.05-.045-.1-.087-.154-.127a1.88 1.88 0 00-.154-.111 1.979 1.979 0 00-.165-.09 1.987 1.987 0 00-.195-.087c-.023-.009-.043-.022-.067-.03-.037-.013-.074-.015-.111-.026a1.754 1.754 0 00-.42-.067c-.034-.001-.067-.01-.102-.01-.023 0-.044.006-.067.007-.078.003-.155.01-.232.023-.055.009-.11.016-.164.03a1.98 1.98 0 00-.205.063c-.055.02-.11.039-.164.063a2 2 0 00-.182.099c-.05.03-.1.059-.148.093-.056.041-.11.086-.162.133-.043.039-.087.077-.126.119-.046.05-.09.104-.131.159a2.025 2.025 0 00-.11.15c-.032.054-.062.11-.09.167a1.953 1.953 0 00-.086.193c-.01.024-.022.044-.03.068l-.736 2.206A3.545 3.545 0 0113.226 22a4.019 4.019 0 01-3.837-2.867c-.11-.448-.05-.92.17-1.326zM21.226 52V38h8v14h-8zm12 0V38h8v14h-8zm12 0V38a4.004 4.004 0 00-4-4h-20a4.004 4.004 0 00-4 4v14h-6V25.716a7.85 7.85 0 002 .284 7.525 7.525 0 005.89-2.848 7.971 7.971 0 0012.11.122 7.973 7.973 0 0012.11-.122A7.525 7.525 0 0049.227 26a7.85 7.85 0 002-.284V52h-6z"
    })),
    stream: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M8.07 18.499a5 5 0 00-5 5v18a5 5 0 005 5h46a5 5 0 005-5v-18a5 5 0 00-5-5h-46zm13.424 19.748c-.198.162-.378.252-.558.252h-5.4c-.63 0-1.242-1.098-1.242-1.44V26.96c0-.576.918-1.17 1.8-1.17.468 0 .702.216.702.648v9.54h4.68c.45 0 .666.216.666.63 0 .648-.288 1.296-.648 1.638zm3.288.36c-.63 0-1.242-1.098-1.242-1.44V26.96c0-.576.918-1.17 1.8-1.17.468 0 .702.216.702.648v10.206c0 .99-.63 1.962-1.26 1.962zm9.601-1.206c-.288.738-.72 1.206-1.206 1.206h-.522c-.342 0-.666-.234-.99-.702a2.763 2.763 0 01-.27-.522L27.58 27.375a1.265 1.265 0 01-.108-.414c0-.576.918-1.17 1.8-1.17.378 0 .594.144.684.45l3.042 8.622 2.79-8.064c.162-.522.99-1.008 1.782-1.008.468 0 .702.216.702.648 0 .306-.054.594-.162.882L34.383 37.4zm13.161.846c-.198.162-.378.252-.558.252h-6.102c-.63 0-1.242-1.098-1.242-1.44v-9.99c0-.576.918-1.17 1.8-1.17h5.922c.45 0 .666.216.666.63 0 .648-.288 1.296-.648 1.638-.198.162-.378.252-.558.252h-4.68v2.538h4.41c.414 0 .63.198.63.594 0 .882-.558 1.746-1.134 1.746h-3.906v2.682h5.382c.45 0 .666.216.666.63 0 .648-.288 1.296-.648 1.638z",
        clipRule: "evenodd"
    })),
    suitcase: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M52 18H42v-6a4.004 4.004 0 00-4-4H26a4.004 4.004 0 00-4 4v6H12a8.01 8.01 0 00-8 8v22a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8V26a8.01 8.01 0 00-8-8zm-6 4v30H18V22h28zM26 12h12v6H26v-6zM8 48V26a4.004 4.004 0 014-4h2v30h-2a4.004 4.004 0 01-4-4zm48 0a4.004 4.004 0 01-4 4h-2V22h2a4.004 4.004 0 014 4v22z",
        clipRule: "evenodd"
    })),
    summary: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M48 4H20a8.01 8.01 0 00-8 8v44a4.004 4.004 0 004 4h28a8.01 8.01 0 008-8V8a4.004 4.004 0 00-4-4zm0 48a4.004 4.004 0 01-4 4l-28 .003V12a4.004 4.004 0 014-4h28v44zm-18-8a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2zm0-12a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2zm0-12a2 2 0 012-2h8a2 2 0 110 4h-8a2 2 0 01-2-2zm-8 12a2 2 0 114 0 2 2 0 01-4 0zm0-12a2 2 0 114 0 2 2 0 01-4 0zm0 24a2 2 0 114 0 2 2 0 01-4 0z",
        clipRule: "evenodd"
    })),
    support: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M45.613 30.958c4.401-7.15 2.546-16.484-4.254-21.408-6.8-4.924-16.247-3.774-21.667 2.639-5.42 6.412-4.98 15.918 1.01 21.803 5.988 5.885 15.5 6.158 21.817.627 7.517.282 13.47 6.452 13.481 13.974v2a4.004 4.004 0 01-4 4H12a4.004 4.004 0 01-4-4v-2a14.057 14.057 0 014.76-10.52 26.11 26.11 0 0015.653 8.26 3.988 3.988 0 10.29-4A22.089 22.089 0 0114.13 33.43l-.003-.005A21.846 21.846 0 0110 20.593a2 2 0 00-4 0 25.804 25.804 0 004.315 14.315A18.067 18.067 0 004 48.593v2a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8v-2a18.03 18.03 0 00-14.387-17.635zM32 34.593c-6.627 0-12-5.373-12-12s5.373-12 12-12 12 5.373 12 12c-.007 6.625-5.376 11.993-12 12z",
        clipRule: "evenodd"
    })),
    sustainability: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M58.298 33.47a6.392 6.392 0 00-5.13-1.815A19.998 19.998 0 0032.176 6.062a19.996 19.996 0 00-16.01 28.97c-.054.05-.116.088-.168.14l-10 10a4.005 4.005 0 000 5.656L13.17 58a3.999 3.999 0 005.657 0l2-2H43.17A3.971 3.971 0 0046 54.828L58.298 42.53a6.413 6.413 0 000-9.058zm-20.3.53h-8.427a28.925 28.925 0 01-.996-6h10.844a28.834 28.834 0 01-.997 6.035c-.141-.01-.279-.035-.423-.035zm-17.85 0a15.881 15.881 0 01-2.016-6h6.444a33.89 33.89 0 00.846 6h-5.274zm13.85-23.657c2.607 1.928 5.03 6.847 5.435 13.657H28.564c.405-6.81 2.829-11.73 5.435-13.658zM43.439 28h6.423a15.843 15.843 0 01-3.021 7.502l-3.123 2.678a6 6 0 00-1.588-2.512A32.807 32.807 0 0043.437 28zm6.425-4h-6.422a28.295 28.295 0 00-3.547-12.875A16.038 16.038 0 0149.863 24zm-21.76-12.875A28.295 28.295 0 0024.556 24h-6.421a16.038 16.038 0 019.968-12.875zM55.47 39.701L43.17 52h-24L16 55.172 8.827 48l10-10h9.241l.006.001.012-.001H38c.26 0 .518.052.759.152.023.013.05.023.073.035a1.996 1.996 0 01-.305 3.743c-.246.047-.496.07-.747.07H28a2 2 0 000 4h10a5.97 5.97 0 001.43-.173 8.007 8.007 0 003.557-1.753l9.216-7.9A2.406 2.406 0 0155.47 39.7z"
    })),
    "switch": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M59.369 20.446l-10.77 10.769a2.154 2.154 0 01-3.045-3.046l7.093-7.092H23.385a2.154 2.154 0 010-4.308h29.262l-7.093-7.092A2.154 2.154 0 1148.6 6.63L59.369 17.4a2.153 2.153 0 010 3.045zm-18.754 22.17H11.353l7.093-7.093a2.154 2.154 0 00-3.046-3.046L4.631 43.247a2.153 2.153 0 000 3.045l10.77 10.77a2.154 2.154 0 003.045-3.047l-7.093-7.092h29.262a2.154 2.154 0 000-4.308z",
        clipRule: "evenodd"
    })),
    sync: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M10.334 34.167A2.167 2.167 0 018.167 32a23.83 23.83 0 0141.167-16.354v-5.313a2.167 2.167 0 114.333 0v10.834c0 1.196-.97 2.166-2.167 2.166H40.667a2.167 2.167 0 010-4.333h5.864a19.498 19.498 0 00-34.03 13c0 1.197-.97 2.167-2.167 2.167zm43.333-4.334c-1.197 0-2.167.97-2.167 2.167a19.498 19.498 0 01-34.03 13h5.864a2.167 2.167 0 100-4.334H12.5c-1.196 0-2.166.97-2.166 2.167v10.834a2.167 2.167 0 104.333 0v-5.313A23.83 23.83 0 0055.834 32c0-1.197-.97-2.167-2.167-2.167z",
        clipRule: "evenodd"
    })),
    "table-view": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M56 53.474c0 .099-.005.196-.013.292.008.077.013.155.013.234 0 1.105-.877 2-1.958 2H10.958C9.877 56 9 55.105 9 54c0-.08.005-.157.013-.234A3.22 3.22 0 019 53.474V10.526C9 9.131 9.895 8 11 8c.152 0 .3.021.442.062.152-.04.31-.062.475-.062h42.166C55.142 8 56 8.895 56 10c0 .08-.005.158-.013.235.008.096.013.193.013.291v42.948zM13 16v16h17V16H13zm39 20H34v16h18V36zm0-4H34V16h18v16zm-39 4h17v16H13V36z",
        clipRule: "evenodd"
    })),
    tablet: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M44 4H20a8.01 8.01 0 00-8 8v40a8.01 8.01 0 008 8h24a8.01 8.01 0 008-8V12a8.01 8.01 0 00-8-8zm-28 8a4.004 4.004 0 014-4h24a4.004 4.004 0 014 4v32H16V12zm32 40a4.004 4.004 0 01-4 4H20a4.004 4.004 0 01-4-4v-4h32v4zm-18 0a2 2 0 114 0 2 2 0 01-4 0z",
        clipRule: "evenodd"
    })),
    tag: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M38 55.512a7.975 7.975 0 01-5.656-2.34L9.172 30A3.972 3.972 0 018 27.171V12a4 4 0 014-4h15.171A3.972 3.972 0 0130 9.172l23.172 23.172a8.007 8.007 0 010 11.312l-9.516 9.516A7.976 7.976 0 0138 55.512zM12 12v15.171l23.172 23.173a4.006 4.006 0 005.656 0l9.516-9.516a4 4 0 000-5.656L27.172 12H12z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M21 27a6 6 0 110-12 6 6 0 010 12zm0-8a2 2 0 100 4 2 2 0 000-4z"
    })),
    tags: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M54.625 34.54a3.948 3.948 0 00-.496-.611l-23.077-23.07C29.546 9.355 26.569 8.07 24.434 8H11.758A3.617 3.617 0 008 11.555v12.876c.072 2.135 1.356 5.112 2.862 6.618L33.94 54.128c.186.186.39.354.602.496 2.534 1.976 6.21 1.825 8.531-.496l11.056-11.065c2.265-2.248 2.462-5.786.655-8.309l-.16-.214zM12.002 11.998h12.35c1.134.06 3.098.916 3.871 1.69l23.066 23.06.09.135.091.117c.766.982.693 2.378-.16 3.224L40.244 51.3c-.858.858-2.262.932-3.241.169l-.117-.092-.117-.078L13.692 28.22c-.731-.73-1.535-2.523-1.673-3.675l-.017-.196V11.998zM20.996 24A2.996 2.996 0 0118 21.004 3.005 3.005 0 0121.004 18 2.996 2.996 0 0124 20.996 2.995 2.995 0 0120.996 24z"
    })),
    temperature: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M28.002 40.35V16a2 2 0 00-4 0v24.35a6 6 0 104 0zm-2 7.65a2 2 0 110-4 2 2 0 010 4zm14-32a2 2 0 012-2h8a2 2 0 010 4h-8a2 2 0 01-2-2zm0 8a2 2 0 012-2h4a2 2 0 010 4h-4a2 2 0 01-2-2zm12 8a2 2 0 01-2 2h-8a2 2 0 110-4h8a2 2 0 012 2zm-16-18a10 10 0 00-20 0v22.22a13.875 13.875 0 00-3.92 11.284 14.028 14.028 0 0012.343 12.41 14.113 14.113 0 0010.918-3.485 13.979 13.979 0 00.659-20.207V14zm-3.33 39.45a9.992 9.992 0 01-16.646-7.992 9.993 9.993 0 013.31-6.895l.666-.596V14a6 6 0 1112 0v23.967l.665.596a9.979 9.979 0 01.006 14.886l-.001.001z"
    })),
    thinking: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M35 4a23.028 23.028 0 00-22.987 22.225l-4.55 5.118A4 4 0 0010.455 38H12v8a4.005 4.005 0 004 4h6a4.004 4.004 0 014 4v2a4.005 4.005 0 004 4h16a4.004 4.004 0 004-4V46l.036-1.093A24.042 24.042 0 0058 27 23.026 23.026 0 0035 4zm12.4 37.897a4.048 4.048 0 00-1.4 3.038V56H30v-2a8.01 8.01 0 00-8-8h-6V34h-5.546L16 27.76V27a19 19 0 0138 0 20.264 20.264 0 01-6.6 14.897zM36 39a2 2 0 11-4 0 2 2 0 014 0zm5.305-20.046a7.988 7.988 0 01-1.203 9.773l-4.688 4.687a2 2 0 01-2.828-2.828l4.687-4.688a3.995 3.995 0 00.602-4.885 3.448 3.448 0 00-5.395-.665l-1.066 1.066a2 2 0 01-2.828-2.828l1.066-1.066a7.448 7.448 0 0111.653 1.434z"
    })),
    "time-waiting": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 54a3 3 0 110 6 3 3 0 010-6zm18-7a3 3 0 110 6 3 3 0 010-6zm-36 0a3 3 0 110 6 3 3 0 010-6zm18-24a2 2 0 012 2v7h12a2 2 0 110 4H32a2 2 0 01-2-2v-9a2 2 0 012-2zM7 29a3 3 0 110 6 3 3 0 010-6zM32 4c8.505 0 15.35 2.522 20.414 7.586C57.478 16.65 60 23.496 60 32a2 2 0 11-4 0c0-7.495-2.145-13.316-6.414-17.586C45.316 10.144 39.496 8 32 8a2 2 0 110-4zm-18 7a3 3 0 110 6 3 3 0 010-6z"
    })),
    time: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M24.482 39.698L30 33.26V18a2 2 0 014 0v16a2 2 0 01-.481 1.302l-6 7a2 2 0 11-3.037-2.604z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 60c15.464 0 28-12.536 28-28S47.464 4 32 4 4 16.536 4 32s12.536 28 28 28zm0-4C18.745 56 8 45.255 8 32S18.745 8 32 8s24 10.745 24 24-10.745 24-24 24z",
        clipRule: "evenodd"
    })),
    "trade-phone": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M31 52a2 2 0 11-4 0 2 2 0 014 0z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M50.57 22.38a2 2 0 00-2.83 0L45 25.12V12a8 8 0 00-8-8H21a8 8 0 00-8 8v40a8 8 0 008 8h16a8 8 0 008-8V36.64a2 2 0 10-4 0V44H17V12a4 4 0 014-4h16a4 4 0 014 4v13.12l-2.73-2.74a2.001 2.001 0 10-2.83 2.83l5.54 5.54a2.89 2.89 0 004.05 0l5.54-5.54a2 2 0 000-2.83zM17 48h24v4a4 4 0 01-4 4H21a4 4 0 01-4-4v-4z",
        clipRule: "evenodd"
    })),
    trailer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M58.102 23.833a3.975 3.975 0 00-3.891-.175l-6.782 3.391a8.035 8.035 0 00-4.472-4.476A10.994 10.994 0 1026.521 22h-4.604a8 8 0 10-13.323.772A8.003 8.003 0 004 30v10a8.01 8.01 0 008 8h15.172l-8.586 8.586a2 2 0 102.828 2.828L30 50.828l8.586 8.586a2 2 0 002.828-2.828L32.828 48H40a8.008 8.008 0 007.429-5.05l6.782 3.392A4 4 0 0060 42.764V27.236a3.975 3.975 0 00-1.898-3.403zM28 15a7 7 0 117 7 7.008 7.008 0 01-7-7zm-13-1a4 4 0 110 8 4 4 0 010-8zm29 26a4.004 4.004 0 01-4 4H12a4.004 4.004 0 01-4-4V30a4.004 4.004 0 014-4h28a4.004 4.004 0 014 4v10zm12 2.764l-8-4v-7.528l8-4v15.528z",
        clipRule: "evenodd"
    })),
    train: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M54 44V12a8.01 8.01 0 00-8-8H18a8.01 8.01 0 00-8 8v32a4.004 4.004 0 004 4h3.73l-7.265 8.72a2 2 0 103.072 2.56L16.27 56h31.46l2.734 3.28a2 2 0 003.072-2.56L46.27 48H50a4.004 4.004 0 004-4zm-3.997-14H34V16h16l.002 14zM18 8h28a4.004 4.004 0 014 4H14a4.004 4.004 0 014-4zm-4 8h16v14H14V16zm5.603 36l3.333-4h18.128l3.333 4H19.604zM14 44V34h36.002v10H14zm32-5a3 3 0 11-6 0 3 3 0 016 0zm-22 0a3 3 0 11-6 0 3 3 0 016 0z"
    })),
    transfer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M46 41a3 3 0 11-6 0 3 3 0 016 0zm-25-3a3 3 0 100 6 3 3 0 000-6zm39-16v6a4.004 4.004 0 01-4 4h-2v14a4.004 4.004 0 01-4 4v4a4.004 4.004 0 01-4 4h-4a4.004 4.004 0 01-4-4v-4H26v4a4.004 4.004 0 01-4 4h-4a4.004 4.004 0 01-4-4v-4a4.004 4.004 0 01-4-4V32H8a4.004 4.004 0 01-4-4v-6a4.004 4.004 0 014-4h2v-4a8.01 8.01 0 018-8h28a8.01 8.01 0 018 8v4h2a4.004 4.004 0 014 4zM30 32V18H14v14h16zm4 0h16.001v-1.988L50 30l.001-.012v-9.983L50 20v-2H34v14zM14 14h36a4.004 4.004 0 00-4-4H18a4.004 4.004 0 00-4 4zm-4 14v-6H8v6h2zm12 22h-4v4h4v-4zm24 0h-4v4h4v-4zm4.002-4V36H14v10h36.002zM56 22h-2v6h2v-6z",
        clipRule: "evenodd"
    })),
    trash: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M38 4a6 6 0 016 6v2h12a2 2 0 110 4h-4v38a6 6 0 01-6 6H18a6 6 0 01-6-6V16H8a2 2 0 110-4h12v-2a6 6 0 016-6zm10 12H16v38a2 2 0 002 2h28a2 2 0 002-2V16zm-24 6a2 2 0 012 2v24a2 2 0 11-4 0V24a2 2 0 012-2zm8 0a2 2 0 012 2v24a2 2 0 11-4 0V24a2 2 0 012-2zm8 0a2 2 0 012 2v24a2 2 0 11-4 0V24a2 2 0 012-2zM38 8H26a2 2 0 00-2 2v2h16v-2a2 2 0 00-2-2z"
    })),
    "tv-next": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M57.998 6v52a2 2 0 01-2 2h-6a2 2 0 01-2-2V36.35L10.921 59.51a3.22 3.22 0 01-4.257-.768l-.177-.255a3.217 3.217 0 01-.489-1.704V7.376a3.35 3.35 0 011.91-3.1 3.227 3.227 0 013.013.213l37.077 23.16V6a2 2 0 012-2h6a2 2 0 012 2z",
        clipRule: "evenodd"
    })),
    "tv-pause": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M54 6v52a2 2 0 01-2 2H42a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2zM22 4H12a2 2 0 00-2 2v52a2 2 0 002 2h10a2 2 0 002-2V6a2 2 0 00-2-2z"
    })),
    "tv-play": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M54.362 35.087L15.584 59.429A3.657 3.657 0 0110 56.275V7.59a3.657 3.657 0 015.584-3.155l38.778 24.343a3.738 3.738 0 010 6.309z",
        clipRule: "evenodd"
    })),
    "tv-previous": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M58 7.376v49.407a3.22 3.22 0 01-.489 1.704l-.177.255a3.219 3.219 0 01-4.257.769L16 36.35V58a2 2 0 01-2 2H8a2 2 0 01-2-2V6a2 2 0 012-2h6a2 2 0 012 2v21.647l37.077-23.16a3.226 3.226 0 013.012-.212A3.351 3.351 0 0158 7.376z",
        clipRule: "evenodd"
    })),
    "tv-simple": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M46 50a2 2 0 110 4H20a2 2 0 110-4h26zm6-40a8 8 0 018 8v22a8 8 0 01-8 8H12a8 8 0 01-8-8V18a8 8 0 018-8h40zm0 4H12a4 4 0 00-4 4v22a4 4 0 004 4h40a4 4 0 004-4V18a4 4 0 00-4-4z"
    })),
    "tv-stop": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M8 14a6 6 0 016-6h36a6 6 0 016 6v36a6 6 0 01-6 6H14a6 6 0 01-6-6V14z"
    })),
    tv: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M52 10H12a8.01 8.01 0 00-8 8v22a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8V18a8.01 8.01 0 00-8-8zm4 30a4.005 4.005 0 01-4 4H12a4.005 4.005 0 01-4-4V18a4.005 4.005 0 014-4h40a4.005 4.005 0 014 4v22zM44 52a2 2 0 01-2 2H22a2 2 0 110-4h20a2 2 0 012 2zM31 19.993a3.62 3.62 0 01-.633 2.07 1.74 1.74 0 01-1.381.937H25v12.993a3.62 3.62 0 01-.633 2.069c-.27.528-.791.881-1.381.938-.5 0-.998-.359-1.497-1.076a2.403 2.403 0 01-.489-1.13V23h-4.014c-.5 0-.998-.359-1.497-1.076a2.402 2.402 0 01-.489-1.13c0-.442.302-.851.906-1.228A3.656 3.656 0 0117.878 19h12c.748 0 1.122.331 1.122.993zm18-.031c0 .447-.082.89-.24 1.309L43.23 37.21a3.85 3.85 0 01-.788 1.309 1.388 1.388 0 01-1.002.48h-.775c-.499 0-.989-.346-1.47-1.041-.165-.24-.3-.5-.4-.775l-5.663-15.832a1.823 1.823 0 01-.16-.615 1.5 1.5 0 01.84-1.189 3.292 3.292 0 011.83-.547.922.922 0 011.016.668L41.01 34l4.302-13.504c.183-.457.531-.83.975-1.042a3.294 3.294 0 011.67-.454c.695 0 1.042.32 1.042.962z",
        clipRule: "evenodd"
    })),
    twitter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M60 15.443a22.752 22.752 0 01-6.596 1.833 11.627 11.627 0 005.05-6.427 22.757 22.757 0 01-7.289 2.817A11.437 11.437 0 0042.778 10c-6.35 0-11.49 5.194-11.49 11.61 0 .906.102 1.8.303 2.648-9.551-.486-18.017-5.103-23.683-12.13a11.71 11.71 0 00-1.556 5.838 11.64 11.64 0 005.106 9.665 11.327 11.327 0 01-5.207-1.449v.147c0 5.624 3.964 10.32 9.215 11.384a11.61 11.61 0 01-3.023.407c-.739 0-1.456-.067-2.161-.203 1.467 4.617 5.7 7.966 10.727 8.057a22.891 22.891 0 01-14.266 4.968c-.929 0-1.836-.057-2.743-.159C9.084 54.076 15.12 56 21.603 56c21.13 0 32.686-17.687 32.686-33.032 0-.498-.011-1.007-.033-1.505A23.383 23.383 0 0060 15.443z",
        clipRule: "evenodd"
    })),
    undo: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M56.461 34.915c.002 12.437-9.3 22.908-21.65 24.373-12.35 1.464-23.842-6.54-26.75-18.633a2 2 0 113.89-.93c2.51 10.416 12.601 17.153 23.182 15.477C45.714 53.528 53.231 44 52.398 33.32c-.832-10.68-9.734-18.927-20.447-18.944-.819 0-1.637.05-2.45.15l3 3a2 2 0 01-2.82 2.83l-5.91-5.91a2.9 2.9 0 01-.86-2.07 2.94 2.94 0 01.86-2.07l5.91-5.9a2 2 0 012.78 2.83l-3.29 3.29c.91-.1 1.825-.15 2.74-.15 13.55.011 24.534 10.99 24.55 24.54z",
        clipRule: "evenodd"
    })),
    upload: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M16.355 32.688l13.171-13.183a3.5 3.5 0 014.947 0l13.172 13.183a2.333 2.333 0 01-3.29 3.29l-10.022-10.01v31.699a2.333 2.333 0 01-4.667 0V25.968l-10.021 10.01a2.333 2.333 0 01-3.29-3.29z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M8.308 34.333c0 1.289-.965 2.334-2.154 2.334-1.19 0-2.154-1.045-2.154-2.334v-21C4 8.18 7.857 4 12.615 4h38.77C56.143 4 60 8.179 60 13.333v21c0 1.289-.964 2.334-2.154 2.334s-2.154-1.045-2.154-2.334v-21c0-2.577-1.928-4.666-4.307-4.666h-38.77c-2.379 0-4.307 2.089-4.307 4.666v21z"
    })),
    usb: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M59.416 30.586l-6-6a2 2 0 00-2.828 2.828L53.174 30H24.83l6.843-6.843a7.004 7.004 0 10-2.828-2.829L19.174 30h-1.467a7 7 0 100 4h7.467l8.977 8.977A3.955 3.955 0 0034 44v6a4.004 4.004 0 004 4h6a4.004 4.004 0 004-4v-6a4.004 4.004 0 00-4-4h-6c-.345.005-.69.055-1.022.15L30.829 34h22.345l-2.586 2.586a2 2 0 002.828 2.828l6-6a2 2 0 000-2.828zM35.002 14a3 3 0 110 6.001 3 3 0 010-6.001zm9 30v6h-6v-6h6zm-33-9a3 3 0 110-6 3 3 0 010 6z"
    })),
    "user-admin": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M48.015 21c0 8.837-7.164 16-16 16a15.94 15.94 0 01-10.65-4.059 2.01 2.01 0 01-.462.092 14.099 14.099 0 00-7.693 3.072c-1.555 1.258-2.86 2.907-3.852 4.873-.447.886-.868 2.098-1.095 3.286-.075.393-.12.763-.156 1.31l-.03.516-.03.719-.039 1.076c-.022.937.007 1.502.109 2l.041.157.11.34c.16.494.414.899.885 1.425.22.247.39.384.72.58.464.273.94.467 1.379.543l.074.011.19.023.646.054.334.004 1.222-.024 1.002-.008 1.788.006L32.013 53a2 2 0 11.003 4H20.088l-4.979-.01-1.022.003-1.647.03c-.184 0-.345-.003-.498-.01l-.301-.02-.604-.057-.238-.03-.226-.035c-.97-.167-1.884-.538-2.734-1.04a6.592 6.592 0 01-1.667-1.357c-.815-.91-1.358-1.776-1.71-2.857l-.12-.374a6.609 6.609 0 01-.092-.33l-.053-.231c-.153-.755-.206-1.457-.196-2.448l.013-.632.048-1.249c.056-1.337.113-2.004.272-2.837.298-1.565.842-3.129 1.453-4.34 1.242-2.46 2.9-4.557 4.907-6.18a18.122 18.122 0 017.678-3.633A15.925 15.925 0 0116.015 21c0-8.837 7.163-16 16-16 8.836 0 16 7.163 16 16zm-28 0c0 6.627 5.372 12 12 12 6.627 0 12-5.373 12-12s-5.373-12-12-12c-6.628 0-12 5.373-12 12z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M58.014 44h-1.2a10.092 10.092 0 00-1.46-3.51l1.07-1.08a2 2 0 00-2.82-2.82l-1.08 1.07a10.09 10.09 0 00-3.51-1.46V35a2 2 0 00-4 0v1.2a10.09 10.09 0 00-3.51 1.46l-1.08-1.07a2 2 0 00-2.82 2.82l1.07 1.08a10.088 10.088 0 00-1.46 3.51h-1.2a2 2 0 100 4h1.2c.26 1.252.756 2.443 1.46 3.51l-1.07 1.08a2 2 0 102.82 2.82l1.08-1.07a10.09 10.09 0 003.51 1.46V57a2 2 0 104 0v-1.2a10.09 10.09 0 003.51-1.46l1.08 1.07a2 2 0 002.82-2.82l-1.07-1.08a10.092 10.092 0 001.46-3.51h1.2a2 2 0 000-4zm-11 8a6 6 0 110-12 6 6 0 010 12z",
        clipRule: "evenodd"
    })),
    "user-new": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 6c8.837 0 16 7.163 16 16s-7.163 16-16 16a15.94 15.94 0 01-10.65-4.06c-.146.05-.3.08-.461.093a14.1 14.1 0 00-7.693 3.071c-1.556 1.26-2.86 2.908-3.852 4.874-.447.887-.869 2.098-1.095 3.286a9.372 9.372 0 00-.137 1.05l-.02.26-.029.516-.031.719-.038 1.076c-.02.843.002 1.385.08 1.848l.028.152.042.157.11.34c.16.494.414.899.885 1.425.22.247.39.384.72.58.463.273.94.467 1.379.543l.036.006.038.005.19.023.646.054.334.004 1.221-.024 1.003-.008 1.788.006L31.999 54a2 2 0 01.151 3.994l-.149.006H20.073l-4.978-.01-1.023.003-1.647.03c-.122 0-.234-.001-.34-.004l-.157-.006-.301-.02-.604-.057-.238-.03-.227-.035c-.97-.167-1.883-.538-2.733-1.04a6.595 6.595 0 01-1.667-1.357c-.734-.82-1.247-1.602-1.598-2.539l-.112-.318-.12-.374-.05-.167-.043-.164-.053-.23c-.134-.66-.19-1.28-.196-2.089v-.359L4 48.602l.047-1.249c.057-1.338.114-2.004.272-2.837.298-1.565.843-3.129 1.454-4.34 1.241-2.46 2.9-4.557 4.906-6.18a18.122 18.122 0 017.678-3.633A15.923 15.923 0 0116 22c0-8.837 7.163-16 16-16zm16 28a2 2 0 012 2v8h8a2 2 0 110 4h-8v8a2 2 0 11-4 0v-8h-8a2 2 0 110-4h8v-8a2 2 0 012-2zM32 10c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12z"
    })),
    user: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M45.61 30.36A15.78 15.78 0 0048 22c0-8.837-7.163-16-16-16s-16 7.163-16 16a15.78 15.78 0 002.39 8.36A18 18 0 004 48v2a8 8 0 008 8h40a8 8 0 008-8v-2a18 18 0 00-14.39-17.64zM32 10c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12zm24 40a4 4 0 01-4 4H12a4 4 0 01-4-4v-2c-.005-7.533 5.952-13.72 13.48-14a15.92 15.92 0 0021 0c7.544.259 13.524 6.452 13.52 14v2z"
    })),
    vcard: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M31.643 27.077a6.933 6.933 0 01-1.067 3.698c3.74.758 6.425 4.02 6.424 7.802v.885C37 41.416 35.401 43 33.429 43H15.57C13.6 43 12 41.416 12 39.462v-.885c-.001-3.783 2.684-7.044 6.424-7.802a6.933 6.933 0 01-1.067-3.698c0-3.909 3.198-7.077 7.143-7.077s7.143 3.168 7.143 7.077zM28 27.5a3.5 3.5 0 10-7 0 3.5 3.5 0 007 0zM31.583 39c.783 0 1.417-.537 1.417-1.2v-.6c.002-2.265-2.116-4.122-4.788-4.2-2.128 1.581-5.31 1.581-7.438 0-2.666.084-4.776 1.94-4.774 4.2v.6c0 .663.634 1.2 1.417 1.2h14.166z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M39 21h11a2 2 0 110 4H39a2 2 0 110-4zm11 7H39a2 2 0 100 4h11a2 2 0 100-4z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M10 12h44a6 6 0 016 6v28a6 6 0 01-6 6H10a6 6 0 01-6-6V18a6 6 0 016-6zm0 4h44a2 2 0 012 2v28a2 2 0 01-2 2H10a2 2 0 01-2-2V18a2 2 0 012-2z",
        clipRule: "evenodd"
    })),
    "video-conference": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M52 12H12a8.01 8.01 0 00-8 8v20a8.01 8.01 0 008 8h18v4h-8a2 2 0 000 4h20a2 2 0 000-4h-8v-4h18a8.01 8.01 0 008-8V20a8.01 8.01 0 00-8-8zM20 44a8.018 8.018 0 016.28-7.81 9.945 9.945 0 0011.44 0A8.018 8.018 0 0144 44H20zm6-16a6 6 0 116 6 6.006 6.006 0 01-6-6zm30 12a4.005 4.005 0 01-4 4h-4a12.04 12.04 0 00-7.326-11.044 10 10 0 10-17.348 0A12.04 12.04 0 0016 44h-4a4.004 4.004 0 01-4-4V20a4.004 4.004 0 014-4h40a4.005 4.005 0 014 4v20z"
    })),
    video: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M52 12H12a8.01 8.01 0 00-8 8v24a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8V20a8.01 8.01 0 00-8-8zm4 32a4.004 4.004 0 01-4 4H12a4.004 4.004 0 01-4-4V20a4.004 4.004 0 014-4h40a4.004 4.004 0 014 4v24zM40.346 28.608l-10.227-6.392A4 4 0 0024 25.608v12.784a4 4 0 006.12 3.392l10.226-6.391a4 4 0 000-6.785zM28 38.392V25.608L38.227 32 28 38.392z",
        clipRule: "evenodd"
    })),
    "visibility-filled": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 12c15.464 0 28 14 28 20S47.464 52 32 52 4 38 4 32s12.536-20 28-20zm0 8c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm0 4.8a7.2 7.2 0 110 14.4 7.2 7.2 0 010-14.4z"
    })),
    visibility: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 12c15.464 0 28 14 28 20S47.464 52 32 52 4 38 4 32s12.536-20 28-20zm0 4c-6.046 0-12.167 2.57-17.228 6.815-2.16 1.811-3.978 3.823-5.229 5.725C8.511 30.111 8 31.423 8 32s.511 1.889 1.543 3.46c1.25 1.902 3.069 3.914 5.229 5.725C19.832 45.431 25.954 48 32 48c6.046 0 12.167-2.57 17.228-6.815 2.16-1.811 3.978-3.823 5.229-5.725C55.489 33.889 56 32.577 56 32s-.511-1.889-1.543-3.46c-1.25-1.902-3.069-3.914-5.229-5.725C44.168 18.569 38.046 16 32 16zm0 6c5.523 0 10 4.477 10 10s-4.477 10-10 10-10-4.477-10-10 4.477-10 10-10zm0 4a6 6 0 100 12 6 6 0 000-12z"
    })),
    "voice-switch": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M24.037 6.007C26.287 5.972 28 7.808 28 9.949v9.703a4 4 0 01-4 4h-4a2 2 0 00-2 2v12.867a2 2 0 002 2h4a4 4 0 014 4v9.73c0 1.995-1.502 3.784-3.636 3.91-1.549.09-3.927.142-6.374-.154-2.392-.288-5.128-.939-7.176-2.448C5.284 51.482 4 46.677 4 44.014V20.186c0-2.426 1.115-4.948 2.63-7.043 1.533-2.121 3.645-4.042 5.978-5.205 1.711-.853 3.939-1.305 5.942-1.563 2.05-.263 4.072-.346 5.487-.368zM24 10.008c-1.326.023-3.14.104-4.94.335-1.893.243-3.575.63-4.668 1.175-1.667.83-3.305 2.286-4.521 3.969C8.635 17.197 8 18.907 8 20.187v23.827c0 1.44.717 5.03 5.186 8.323 1.208.89 3.11 1.435 5.284 1.697 2.056.248 4.11.217 5.53.139v-9.654h-4a6 6 0 01-6-6V25.652a6 6 0 016-6h4v-9.644z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M37.95 32.136a2 2 0 002.828-2.828L36.47 25H48a2 2 0 000-4H37.193l3.585-3.585a2 2 0 00-2.828-2.829l-7.269 7.269a2.009 2.009 0 00-.68 1.558 1.994 1.994 0 00.678 1.453l7.27 7.27zM58 41.349a1.994 1.994 0 00-.68-1.493l-7.27-7.27a2 2 0 10-2.828 2.828L50.808 39H40a2 2 0 000 4h11.53l-4.308 4.308a2 2 0 002.828 2.828l7.27-7.27A2 2 0 0058 41.35z"
    })),
    voicemail: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M49.333 20.084a13 13 0 00-9.75 21.666H24.417a13 13 0 10-9.75 4.334h34.666c7.18 0 13-5.82 13-13s-5.82-13-13-13zM14.667 41.75a8.667 8.667 0 110-17.333 8.667 8.667 0 010 17.333zm34.666 0a8.667 8.667 0 110-17.333 8.667 8.667 0 010 17.333z",
        clipRule: "evenodd"
    })),
    volume: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M33.658 9.332a4.32 4.32 0 00-4.722.94L18.103 21.105h-3.436A8.677 8.677 0 006 29.772v4.333a8.677 8.677 0 008.667 8.667h3.436l10.833 10.833a4.333 4.333 0 007.397-3.064V13.335a4.321 4.321 0 00-2.675-4.003zM32 50.542L19.897 38.437h-5.23a4.338 4.338 0 01-4.334-4.333v-4.333a4.338 4.338 0 014.334-4.334h5.23L32 13.335v37.206zm17.333-18.604a22.355 22.355 0 01-4.853 14.41 2.167 2.167 0 01-3.293-2.819A17.987 17.987 0 0045 31.94c.118-4.19-1.23-8.29-3.813-11.591a2.167 2.167 0 013.293-2.819 22.356 22.356 0 014.853 14.41zm8.667 0c0 8.077-2.559 15.697-7.02 20.91a2.167 2.167 0 01-3.293-2.819c3.8-4.439 5.98-11.032 5.98-18.09 0-7.06-2.18-13.652-5.98-18.091a2.167 2.167 0 013.293-2.819C55.44 16.242 58 23.862 58 31.94z",
        clipRule: "evenodd"
    })),
    wallet: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M52 16a8.01 8.01 0 00-8-8H10a6.007 6.007 0 00-6 6v34a8.01 8.01 0 008 8h40a8.01 8.01 0 008-8V24a8.01 8.01 0 00-8-8zm4 24H46a4 4 0 110-8h10v8zM10 12h34a4.004 4.004 0 014 4H10a2 2 0 110-4zm42 40H12a4.004 4.004 0 01-4-4V19.65a5.96 5.96 0 002 .35h42a4.004 4.004 0 014 4v4H46a8 8 0 000 16h10v4a4.004 4.004 0 01-4 4zm-6-18a2 2 0 110 4 2 2 0 010-4z"
    })),
    wallplug: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M59.412 14.586a2 2 0 00-2.828 0l-8.586 8.586L40.826 16l8.586-8.586a2 2 0 10-2.828-2.828l-8.586 8.586L34.826 10a4.002 4.002 0 00-5.656 0l-9.586 9.586a17.57 17.57 0 00-3.589 19.589L5.582 49.588a6.242 6.242 0 008.828 8.828l10.414-10.413a17.526 17.526 0 0019.588-3.589l9.586-9.586a4.004 4.004 0 000-5.656L50.826 26l8.586-8.586a2 2 0 000-2.828zm-47.83 41.002a2.243 2.243 0 01-3.172-3.172l9.701-9.7a15.837 15.837 0 003.172 3.171l-9.7 9.7zm30.002-14.002a13.557 13.557 0 01-19.172-19.172l9.586-9.586L51.17 32l-9.586 9.586z"
    })),
    warning: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M27.257 39.192c.064 1.344.768 1.984 2.112 1.984 2.752 0 5.44-1.792 5.504-3.584l1.024-25.216c0-1.728-.896-2.56-2.752-2.56-3.52 0-7.168 2.368-7.168 4.608l1.28 24.768zm3.648 16.192c-2.496 0-4.864-4.16-4.864-5.76 0-2.24 3.648-4.608 7.168-4.608 1.856 0 2.816.832 2.816 2.56 0 2.624-1.216 5.312-2.752 6.72-.768.704-1.536 1.088-2.368 1.088z",
        clipRule: "evenodd"
    })),
    wavelength: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M60 28a2 2 0 01-2 2c-2.9 0-3.608 2.241-4.532 7.355C52.658 41.848 51.546 48 45 48c-6.656 0-7.629-8.378-8.486-15.77C35.682 25.07 34.872 20 32 20c-2.872 0-3.682 5.07-4.514 12.23C26.63 39.622 25.656 48 19 48c-6.546 0-7.657-6.152-8.468-10.645C9.608 32.241 8.9 30 6 30a2 2 0 110-4c6.546 0 7.657 6.152 8.468 10.645C15.392 41.759 16.1 44 19 44c2.872 0 3.682-5.07 4.514-12.23C24.37 24.378 25.344 16 32 16c6.656 0 7.629 8.378 8.486 15.77C41.318 38.93 42.128 44 45 44c2.9 0 3.608-2.241 4.532-7.355C50.342 32.152 51.454 26 58 26a2 2 0 012 2z"
    })),
    weather: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M43 16.873a9 9 0 012.933 17.512A9.468 9.468 0 0149 41.373c0 .494-.038.98-.11 1.453A6.5 6.5 0 0146 54.854v.02H12v-.015a8.5 8.5 0 01-8-8.486c0-4.544 3.882-8.617 8.083-8.523A13.046 13.046 0 0112 36.373c0-7.456 6.268-13.5 14-13.5 2.983 0 5.748.9 8.019 2.433A8.998 8.998 0 0143 16.873zm-17 10c-5.555 0-10 4.287-10 9.5 0 .347.02.689.058 1.025l.518 4.554-4.583-.103C10.1 41.806 8 44.016 8 46.373a4.5 4.5 0 004.232 4.492l.133.008H45.6l.098-.007a2.5 2.5 0 001.104-4.628l-2.269-1.39.404-2.629c.042-.277.064-.56.064-.846 0-3.037-2.462-5.5-5.439-5.5l-3.135.048-.977-2.668c-1.38-3.771-5.14-6.38-9.449-6.38zm26.99 9.962l1.438 1.39a2 2 0 01-2.779 2.877l-1.438-1.39a2 2 0 112.778-2.877zM43 20.873a5 5 0 100 10 5 5 0 000-10zm15 5a2 2 0 010 4h-2a2 2 0 110-4h2zM30.181 14.517l1.439 1.39a2 2 0 01-2.779 2.877l-1.438-1.39a2 2 0 112.778-2.877zm25.696-1.033a2 2 0 01-.049 2.828l-1.439 1.39a2 2 0 01-2.778-2.878l1.438-1.39a2 2 0 012.828.05zM40.917 9a2 2 0 012 2v2a2 2 0 11-4 0v-2a2 2 0 012-2z",
        clipRule: "evenodd"
    })),
    whatsapp: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M51.832 12.143C46.578 6.887 39.573 4 32.114 4 16.754 4 4.24 16.453 4.227 31.74a27.71 27.71 0 003.717 13.878L4 60l14.785-3.858a28.003 28.003 0 0013.329 3.379h.013c15.36 0 27.873-12.453 27.886-27.754-.013-7.41-2.914-14.382-8.181-19.624zM32.114 54.824a23.193 23.193 0 01-11.805-3.22l-.842-.505-8.77 2.289 2.34-8.516-.548-.878a22.882 22.882 0 01-3.543-12.267c0-12.693 10.4-23.044 23.181-23.044 6.19 0 12.005 2.409 16.39 6.76 4.371 4.363 6.777 10.15 6.777 16.31-.013 12.734-10.414 23.071-23.18 23.071zm12.713-17.27c-.695-.345-4.117-2.022-4.76-2.261-.64-.226-1.109-.346-1.563.346-.468.692-1.805 2.262-2.206 2.714-.401.466-.816.519-1.51.173-.696-.346-2.942-1.078-5.602-3.446-2.072-1.836-3.462-4.111-3.877-4.803-.4-.692-.04-1.064.308-1.41.307-.306.695-.812 1.042-1.211.348-.4.468-.692.696-1.157.227-.466.12-.865-.054-1.211-.174-.346-1.564-3.765-2.152-5.15-.562-1.356-1.137-1.17-1.564-1.183-.401-.027-.87-.027-1.337-.027-.468 0-1.217.173-1.858.865-.642.692-2.434 2.368-2.434 5.787 0 3.42 2.5 6.706 2.848 7.172.348.465 4.906 7.464 11.898 10.47a38.462 38.462 0 003.97 1.464c1.671.532 3.182.453 4.385.28 1.337-.2 4.117-1.677 4.706-3.3.575-1.623.575-3.007.4-3.3-.173-.292-.64-.465-1.336-.811z",
        clipRule: "evenodd"
    })),
    "wireless-off": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M36 50a4 4 0 11-8 0 4 4 0 018 0zm20.667-31.19a38.874 38.874 0 00-7.446-4.78l4.259-4.684a2 2 0 00-2.96-2.692l-5.191 5.711a38.87 38.87 0 00-37.996 6.446 2 2 0 002.533 3.095 34.884 34.884 0 0132.53-6.315l-6.148 6.763a26.726 26.726 0 00-21.494 5.881 2 2 0 102.557 3.076A23.017 23.017 0 0132 26c.3 0 .598.027.898.04L10.52 50.653a1.997 1.997 0 00.133 2.825 1.998 1.998 0 002.826-.133l11.962-13.159a10.933 10.933 0 0113.767.524 2 2 0 002.629-3.016A14.979 14.979 0 0032 34c-.325 0-.647.018-.969.039l6.649-7.314a23.002 23.002 0 019.01 4.586 2.001 2.001 0 003.28-1.72 2.002 2.002 0 00-.724-1.356 26.98 26.98 0 00-8.589-4.785l5.755-6.33a34.924 34.924 0 017.722 4.786 1.999 1.999 0 002.533-3.095z"
    })),
    wireless: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M35.85 51.333a4.333 4.333 0 11-8.666 0 4.333 4.333 0 018.666 0zm22.39-33.788c-15.543-12.727-37.903-12.727-53.445 0a2.167 2.167 0 102.744 3.353c13.946-11.42 34.01-11.42 47.956 0a2.166 2.166 0 102.745-3.353zM31.517 34a16.227 16.227 0 00-10.658 4.003 2.167 2.167 0 002.848 3.267 11.852 11.852 0 0115.62 0 2.167 2.167 0 002.848-3.267A16.227 16.227 0 0031.517 34zm0-13a29.28 29.28 0 00-18.683 6.755 2.166 2.166 0 102.77 3.332c9.222-7.672 22.605-7.672 31.827 0a2.167 2.167 0 102.77-3.332A29.28 29.28 0 0031.516 21z",
        clipRule: "evenodd"
    })),
    "world-alert": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M21 10.664A23.897 23.897 0 0132 8c.844 0 1.678.044 2.5.129v5.543L31.172 17A4 4 0 0030 19.828V23.5a2 2 0 104 0v-3.672l3.328-3.328a4 4 0 001.172-2.828V8.89a24.041 24.041 0 0113.07 9.211l-3.484 3.484a2 2 0 102.828 2.828l2.752-2.752a23.813 23.813 0 011.872 5.628c.397 1.994.3 4.648.066 6.93a48.811 48.811 0 01-.512 3.608c-.017.094-.03.165-.04.212l-.01.052-.002.01v.002a2 2 0 003.92.792L57 38.5l1.96.395.002-.008.004-.019.013-.068.047-.248a52.892 52.892 0 00.557-3.923c.243-2.367.397-5.513-.121-8.12C56.909 13.676 45.586 4 32 4 16.536 4 4 16.536 4 32c0 4.29 1.221 8.85 3.284 12.862 2.06 4.006 5.033 7.605 8.668 9.841a2 2 0 002.096-3.406c-2.865-1.764-5.392-4.735-7.207-8.264C9.03 39.509 8 35.57 8 32c0-1.453.13-2.875.376-4.257l9.492-2.11A4 4 0 0021 21.73V10.664zm-4 2.6a24.06 24.06 0 00-7.403 10.11L17 21.73v-8.465z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M19 36a4 4 0 00-4 4v3a4 4 0 004 4h1a2 2 0 100-4h-1v-3h4.813a2 2 0 100-4H19zm20.093 9.072c.024.504.288.744.792.744 1.032 0 2.04-.672 2.064-1.344l.384-9.456c0-.648-.336-.96-1.032-.96-1.32 0-2.688.888-2.688 1.728l.48 9.288zm1.368 6.072c.312 0 .6-.144.888-.408.576-.528 1.032-1.536 1.032-2.52 0-.648-.36-.96-1.056-.96-1.32 0-2.688.888-2.688 1.728 0 .6.888 2.16 1.824 2.16z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M44.946 26.267c-1.861-3.615-7.03-3.615-8.892 0L23.472 50.712C21.76 54.04 24.177 58 27.919 58h25.164c3.742 0 6.158-3.96 4.446-7.288L44.946 26.267zm-5.335 1.831a1 1 0 011.778 0l12.582 24.445a1 1 0 01-.89 1.457H27.919a1 1 0 01-.889-1.457l12.582-24.445z",
        clipRule: "evenodd"
    })),
    "world-off": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M8.376 27.743A24.145 24.145 0 008 32c0 4.744 1.287 8.678 3.684 12.422a2 2 0 01-3.368 2.156C5.538 42.24 4 37.565 4 32 4 16.536 16.536 4 32 4c5.32 0 10.3 1.486 14.54 4.067a2 2 0 01-2.08 3.416 23.841 23.841 0 00-6.96-2.85v5.039a4 4 0 01-1.172 2.828L33 19.828V23.5a2 2 0 11-4 0v-3.672A4 4 0 0130.172 17l3.328-3.328V8.046C33.004 8.016 32.504 8 32 8c-3.965 0-7.705.961-11 2.664v11.065a4 4 0 01-3.132 3.905l-9.492 2.109zm1.22-4.369L17 21.73v-8.465a24.06 24.06 0 00-7.403 10.11z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M53.93 17.083a1.987 1.987 0 00-.807.466l-4.814 4.376A4 4 0 0047 24.885V28.5h-4a2 2 0 100 4h5.5A2.5 2.5 0 0051 30v-5.115l2.916-2.65A23.72 23.72 0 0156 32c0 13.255-10.745 24-24 24-4.277 0-8.87-1.633-12.498-3.731a2 2 0 00-2.003 3.462C21.518 58.057 26.806 60 32 60c15.464 0 28-12.536 28-28 0-5.1-1.365-9.848-3.748-13.966a2.007 2.007 0 00-1.446-1.01 1.995 1.995 0 00-.877.059z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M31.641 38.5a2 2 0 012-2h1.641a4 4 0 014 4v6.749a4 4 0 01-4 4h-3.558a4 4 0 01-2.56-.927l-3.944-3.285a2 2 0 112.56-3.074l3.944 3.286h3.558V40.5h-1.641a2 2 0 01-2-2zM5.586 55.758a2 2 0 102.828 2.828L58.586 8.415a2 2 0 00-2.829-2.829L5.586 55.758z"
    })),
    "world-question": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M21 10.664A23.897 23.897 0 0132 8c.84 0 1.675.048 2.5.142v5.53L31.172 17A4 4 0 0030 19.828V23a2 2 0 104 0v-3.172l3.328-3.328a4 4 0 001.172-2.828V8.958c5.3 1.572 9.964 4.944 13.087 9.126l-3.001 3.002a2 2 0 102.828 2.828l2.328-2.328c.9 1.828 1.512 3.745 1.776 5.684a2 2 0 003.964-.54C57.838 14.674 45.547 4 32 4 16.536 4 4 16.536 4 32c0 13 8.597 23.722 20.037 26.446a2 2 0 10.926-3.892C15.403 52.278 8 43.23 8 32c0-1.453.13-2.875.376-4.257l9.492-2.11A4 4 0 0021 21.73V10.664zm-4 2.6a24.06 24.06 0 00-7.403 10.11L17 21.73v-8.465z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M19 36a4 4 0 00-4 4v3a4 4 0 004 4h1a2 2 0 100-4h-1v-3h1.5a2 2 0 100-4H19zm27.518 2.136c0 1.512-.624 2.712-2.52 4.752l-2.472 2.64c-.312.312-.576.456-.84.456-.408 0-.792-.288-1.152-.84-.24-.408-.36-.72-.36-.912 0-.192.096-.384.264-.6l2.328-2.472c1.08-1.176 1.536-1.968 1.536-2.808 0-.96-.792-1.68-1.872-1.68-.936 0-1.632.432-2.664 1.584-.264.288-.456.48-.576.576a.774.774 0 01-.432.144c-.768 0-1.464-1.296-1.464-1.704 0-.168.072-.384.24-.624 1.152-1.728 3.144-2.808 5.184-2.808 1.896 0 3.408.816 4.2 2.112.408.648.6 1.392.6 2.184zm-4.704 12.6c-.288.264-.576.408-.888.408-.936 0-1.824-1.56-1.824-2.16 0-.84 1.368-1.728 2.688-1.728.696 0 1.056.312 1.056.96 0 .984-.456 1.992-1.032 2.52z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M24 42.5C24 32.835 31.835 25 41.5 25S59 32.835 59 42.5 51.165 60 41.5 60 24 52.165 24 42.5zM41.5 29C34.044 29 28 35.044 28 42.5S34.044 56 41.5 56 55 49.956 55 42.5 48.956 29 41.5 29z",
        clipRule: "evenodd"
    })),
    world: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32 4C16.536 4 4 16.536 4 32s12.536 28 28 28 28-12.536 28-28C59.983 16.543 47.457 4.017 32 4zm6.462 10.77V9.21a23.767 23.767 0 0112.832 9.066l-3.586 3.586c-.404.404-.63.951-.631 1.523v4.307h-2.755l-1.172-3.516a4.303 4.303 0 00-4.087-2.945h-4.91v-1.262l3.678-3.677c.403-.404.63-.952.63-1.523zm-21.54-1.032v7.881l-6.828 1.366a23.81 23.81 0 016.829-9.247zM32 55.692a23.67 23.67 0 01-23.285-28.04l.016-.002 9.038-1.807a4.32 4.32 0 003.462-4.224V10.908A23.537 23.537 0 0134.154 8.41v5.467l-3.046 3.046a4.279 4.279 0 00-1.262 3.046v1.262a4.312 4.312 0 004.308 4.307h4.91l1.662 4.99A2.154 2.154 0 0042.769 32h6.462c1.19 0 2.154-.964 2.154-2.154v-5.569l2.146-2.146A23.678 23.678 0 0132 55.692zm2.154-19.384H21.23a4.312 4.312 0 00-4.308 4.307v2.154a4.312 4.312 0 004.308 4.308h3.416l3.045 3.046a4.278 4.278 0 003.046 1.262h3.416a4.312 4.312 0 004.307-4.308v-6.462a4.312 4.312 0 00-4.307-4.307zm0 10.769h-3.416l-3.046-3.046a4.279 4.279 0 00-3.045-1.262H21.23v-2.154h12.923v6.462z",
        clipRule: "evenodd"
    })),
    wrench: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M32.543 8.896A16 16 0 0148 4.5a3.93 3.93 0 012.77 2.8 4 4 0 01-1 3.9l-7.1 7.1a2.19 2.19 0 00-.41 2.75 2 2 0 003.13.29L52.74 14a4 4 0 016.69 1.75 16 16 0 01-19.94 19.59L17 57.76A7.68 7.68 0 0111.6 60h-.36a7.71 7.71 0 01-5.55-2.79 7.85 7.85 0 01.68-10.45L28.7 24.5a16 16 0 013.843-15.604zM44 8a12 12 0 00-11.18 16.32l.47 1.22-24.1 24.05a3.82 3.82 0 00-.41 5.07A3.64 3.64 0 0011.43 56a3.69 3.69 0 002.76-1.07l24.27-24.22 1.22.47a12 12 0 0016.18-9.32 12.08 12.08 0 00-.28-5.06l-7.35 7.37a6 6 0 01-9.23-.82 6.15 6.15 0 01.84-7.88l7.1-7.1A11.563 11.563 0 0044 8zM12 50a2 2 0 110 4 2 2 0 010-4z"
    })),
    youtube: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M59.142 20.696s-.644-3.913-2.146-5.653c-2.145-2.173-4.506-2.173-5.578-2.39C43.694 12 31.893 12 31.893 12s-11.801 0-19.525.652c-1.073.218-3.433.218-5.579 2.392-1.716 1.739-2.145 5.652-2.145 5.652S4 25.26 4 29.826v4.348c0 4.565.644 9.13.644 9.13s.643 3.913 2.145 5.652c2.146 2.174 4.935 2.174 6.223 2.392 4.505.435 19.095.652 19.095.652s11.801 0 19.525-.652c1.073-.218 3.433-.218 5.579-2.392 1.716-1.739 2.145-5.652 2.145-5.652S60 38.74 60 34.174v-4.348c-.215-4.565-.858-9.13-.858-9.13zM26.1 39.39V23.52l15.019 8.044-15.02 7.826z",
        clipRule: "evenodd"
    })),
    "zoom-out": /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        d: "M20 28.5a2 2 0 100 4h20a2 2 0 100-4H20z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M50.792 41.964l6.794 6.794a6 6 0 010 8.484l-.172.172a6.25 6.25 0 01-8.828 0l-6.622-6.622a24.032 24.032 0 118.828-8.828zM13.37 18.889A20 20 0 0010 29.998a20.022 20.022 0 0020 20 20 20 0 10-16.63-31.11zm41.216 35.697l.172-.172a2.001 2.001 0 000-2.828l-6.284-6.284a24.225 24.225 0 01-3.172 3.172l6.112 6.112a2.244 2.244 0 003.172 0z",
        clipRule: "evenodd"
    })),
    zoom: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M58.606 55.543L47.773 44.71a2.153 2.153 0 00-.658-.446c8.248-9.776 7.325-24.316-2.094-32.97-9.419-8.655-23.985-8.347-33.03.698-9.044 9.044-9.352 23.61-.698 33.03 8.654 9.419 23.195 10.342 32.97 2.093.107.245.258.469.446.658l10.833 10.834a2.167 2.167 0 003.064-3.064zm-29.698-7.135c-10.77 0-19.5-8.73-19.5-19.5s8.73-19.5 19.5-19.5 19.5 8.73 19.5 19.5c-.013 10.765-8.736 19.488-19.5 19.5z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M29 18a2 2 0 012 2v18a2 2 0 11-4 0V20a2 2 0 012-2z",
        clipRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M18 29a2 2 0 012-2h18a2 2 0 010 4H20a2 2 0 01-2-2z",
        clipRule: "evenodd"
    }))
};


function $2edc691f96482cbe$export$f04a61298a47a40f(props) {
    if (!props.icon) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("Icon", "Icon--".concat(props.icon), props.spin ? "Icon--spin" : undefined, props.className),
        style: props.style,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 64 64",
        "aria-hidden": props.title ? undefined : true
    }, props.title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("title", null, props.title), (0, $ed97cf8fbd7b8a05$export$747068d7030dba8a)[props.icon]);
}


var $5121558ae6eef82f$var$_excluded = [
    "component",
    "href",
    "text",
    "kind",
    "icon",
    "iconPlacement",
    "size",
    "onClick",
    "className",
    "processingText",
    "isProcessing",
    "isDisabled",
    "type",
    "margin",
    "style"
];
function $5121558ae6eef82f$var$_extends() {
    $5121558ae6eef82f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5121558ae6eef82f$var$_extends.apply(this, arguments);
}
function $5121558ae6eef82f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5121558ae6eef82f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $5121558ae6eef82f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $5121558ae6eef82f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Status: *finished*.
 * Category: Buttons
 */ var $5121558ae6eef82f$var$Button = function Button(props) {
    var _classnames;
    var _props$component = props.component, component = _props$component === void 0 ? "button" : _props$component, href = props.href, text = props.text, kind = props.kind, icon = props.icon, _props$iconPlacement = props.iconPlacement, iconPlacement = _props$iconPlacement === void 0 ? "left" : _props$iconPlacement, size = props.size, onClick = props.onClick, className = props.className, processingText = props.processingText, isProcessing = props.isProcessing, isDisabled = props.isDisabled, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, margin = props.margin, style = props.style, rest = $5121558ae6eef82f$var$_objectWithoutProperties(props, $5121558ae6eef82f$var$_excluded);
    var Tag = component === "link" ? "a" : component;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(Tag, $5121558ae6eef82f$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("button", (_classnames = {}, $5121558ae6eef82f$var$_defineProperty(_classnames, "button--".concat(kind), !isDisabled && kind), $5121558ae6eef82f$var$_defineProperty(_classnames, "button--".concat(size), size), $5121558ae6eef82f$var$_defineProperty(_classnames, "button--margin-".concat(margin), margin), $5121558ae6eef82f$var$_defineProperty(_classnames, "button--processing", isProcessing), $5121558ae6eef82f$var$_defineProperty(_classnames, "button--disabled", isDisabled), _classnames), className ? className : undefined),
        href: href ? href : undefined,
        onClick: onClick,
        disabled: isProcessing || isDisabled,
        type: type,
        style: style
    }, rest), icon && iconPlacement === "left" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $2edc691f96482cbe$export$f04a61298a47a40f), {
        icon: icon,
        style: {
            fill: "currentColor",
            height: size === "xs" ? "16px" : "20px",
            marginBottom: "-8px",
            marginLeft: "-6px",
            marginRight: "10px",
            position: "relative",
            top: "-3.5px",
            width: "20px"
        }
    }), !isProcessing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", null, text), isProcessing && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: "button__processing"
    }, processingText, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: "button__processing-dot"
    }, "."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: "button__processing-dot"
    }, "."), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: "button__processing-dot"
    }, ".")), icon && iconPlacement === "right" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $2edc691f96482cbe$export$f04a61298a47a40f), {
        icon: icon,
        style: {
            fill: "currentColor",
            height: "20px",
            marginBottom: "-8px",
            marginLeft: "10px",
            marginRight: "-6px",
            position: "relative",
            top: "-3.5px",
            width: "20px"
        }
    }));
};
var $5121558ae6eef82f$export$2e2bcd8739ae039 = $5121558ae6eef82f$var$Button;
$5121558ae6eef82f$var$Button.types = {
    button: "button",
    reset: "reset",
    submit: "submit"
};
$5121558ae6eef82f$var$Button.kinds = {
    normal: "normal",
    primary: "primary",
    cancel: "cancel",
    link: "link",
    secondLink: "secondLink",
    inverted: "inverted",
    negative: "negative"
};
$5121558ae6eef82f$var$Button.margins = {
    top: "top",
    bottom: "bottom"
};



var $c30H9 = parcelRequire("c30H9");
parcelRequire("fgmOP");
var $df5238ba9c072d00$exports = {};
$df5238ba9c072d00$exports = "query changelogs{changelogs{...changelogFragment}}fragment changelogFragment on Changelog{id name description createdDate modifiedDate}";






var $fgmOP = parcelRequire("fgmOP");


var $fgmOP = parcelRequire("fgmOP");


var $jPPOv = parcelRequire("jPPOv");



var $fgmOP = parcelRequire("fgmOP");
var $4abcf94e80726891$var$_excluded = [
    "as",
    "children",
    "onKeyDown"
];
function $4abcf94e80726891$var$_extends() {
    $4abcf94e80726891$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4abcf94e80726891$var$_extends.apply(this, arguments);
}
function $4abcf94e80726891$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4abcf94e80726891$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4abcf94e80726891$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $4abcf94e80726891$var$KEY_TAB = 9;
var $4abcf94e80726891$export$30c0e1e687f23fa3 = '\n    a[href],\n    area[href],\n    input:not([disabled]),\n    select:not([disabled]),\n    textarea:not([disabled]),\n    button:not([disabled]),\n    [tabindex="0"]\n';
/**
 * Status: *in progress*.
 * Category: Misc
 *
 * Prevents focusing outside the container with using TAB keys
 */ function $4abcf94e80726891$var$FocusTrap(_ref, ref) {
    var as = _ref.as, children = _ref.children, onKeyDown = _ref.onKeyDown, otherProps = $4abcf94e80726891$var$_objectWithoutProperties(_ref, $4abcf94e80726891$var$_excluded);
    var Element = as;
    var handleKeyDown = function handleKeyDown(event) {
        var focusableElements = ref.current.querySelectorAll($4abcf94e80726891$export$30c0e1e687f23fa3);
        if (event.keyCode === $4abcf94e80726891$var$KEY_TAB) {
            if (event.shiftKey) {
                if (document.activeElement === focusableElements[0]) {
                    event.preventDefault();
                    focusableElements[focusableElements.length - 1].focus();
                }
            } else if (document.activeElement === focusableElements[focusableElements.length - 1]) {
                event.preventDefault();
                focusableElements[0].focus();
            }
        }
        if (onKeyDown) onKeyDown(event);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(Element, $4abcf94e80726891$var$_extends({
        ref: ref
    }, otherProps, {
        onKeyDown: handleKeyDown
    }), children);
}
var $4abcf94e80726891$var$FocusTrapWithForwardRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).forwardRef($4abcf94e80726891$var$FocusTrap);
var $4abcf94e80726891$export$2e2bcd8739ae039 = $4abcf94e80726891$var$FocusTrapWithForwardRef;



var $7f3b80d7462309dd$var$_excluded = [
    "name",
    "heading",
    "children",
    "onSubmit",
    "submitDisabled",
    "submitText",
    "submitKind",
    "onClose",
    "closeText",
    "closeKind",
    "standalone",
    "focusChildElement",
    "renderTo",
    "headerElement",
    "footerElement",
    "size",
    "className"
];
function $7f3b80d7462309dd$var$_extends() {
    $7f3b80d7462309dd$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7f3b80d7462309dd$var$_extends.apply(this, arguments);
}
function $7f3b80d7462309dd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7f3b80d7462309dd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7f3b80d7462309dd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $7f3b80d7462309dd$var$KEY_ESC = 27;
/**
 * Status: *in progress*.
 * Category: Notifications
 *
 * Look at the <a href='#/modal-dialog'>Modal Dialog sample page</a> to see this component in action.
 *
 * TODO:
 ** &lt;div role="dialog"&gt; can be changed to &lt;dialog&gt; when this element is more widely supported
 */ function $7f3b80d7462309dd$var$ModalDialog(_ref) {
    var name = _ref.name, heading = _ref.heading, children = _ref.children, onSubmit = _ref.onSubmit, submitDisabled = _ref.submitDisabled, submitText = _ref.submitText, submitKind = _ref.submitKind, onClose = _ref.onClose, closeText = _ref.closeText, closeKind = _ref.closeKind, standalone = _ref.standalone, focusChildElement = _ref.focusChildElement, renderTo = _ref.renderTo, headerElement = _ref.headerElement, footerElement = _ref.footerElement, size = _ref.size, className = _ref.className, rest = $7f3b80d7462309dd$var$_objectWithoutProperties(_ref, $7f3b80d7462309dd$var$_excluded);
    var modalNode = renderTo || (0, $fgmOP.useContext)((0, $08c2f3412ed8b9d6$export$841858b892ce1f4c));
    var dialogRef = (0, $fgmOP.useRef)();
    var dialogOverlayRef = (0, $fgmOP.useRef)();
    var returnFocusOnDialogClose = function returnFocusOnDialogClose() {
        if (standalone) return;
        var lastFocusedElement = document.activeElement;
        return function() {
            if (lastFocusedElement) lastFocusedElement.focus();
        };
    };
    var setFocusOnDialog = function setFocusOnDialog() {
        if (!dialogRef.current || standalone || focusChildElement) return;
        dialogRef.current.focus();
    };
    var disableAndResetPageScroll = function disableAndResetPageScroll() {
        if (standalone) return;
        var previousOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        if (dialogOverlayRef.current) dialogOverlayRef.current.scrollTop = 0;
        return function() {
            document.body.style.overflow = previousOverflow;
        };
    };
    var onOverlayClick = function onOverlayClick(event) {
        if (event.target !== dialogOverlayRef.current) return;
        if (onClose) onClose();
    };
    var handleKeyDown = function handleKeyDown(event) {
        if (event.keyCode === $7f3b80d7462309dd$var$KEY_ESC && onClose) onClose();
    };
    (0, $fgmOP.useEffect)(returnFocusOnDialogClose, []);
    (0, $fgmOP.useEffect)(setFocusOnDialog, [
        dialogRef.current
    ]);
    (0, $fgmOP.useEffect)(disableAndResetPageScroll, []);
    var defaultHeaderElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("h2", {
        id: "".concat(name, "-heading"),
        className: "modal-dialog__heading"
    }, heading);
    var defaultFooterElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "modal-dialog__footer"
    }, closeText && onClose && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
        size: "small",
        kind: closeKind,
        margin: "top",
        onClick: onClose,
        text: closeText
    }), submitText && onSubmit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
        size: "small",
        kind: submitKind,
        margin: "top",
        onClick: onSubmit,
        text: submitText,
        isDisabled: submitDisabled
    }));
    var renderDialog = function renderDialog(Component) {
        var additionalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(Component, $7f3b80d7462309dd$var$_extends({
            tabIndex: 0,
            onKeyDown: handleKeyDown,
            ref: dialogRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("modal-dialog container", "container--".concat(size), {
                "modal-dialog--standalone": standalone
            }, className ? className : undefined),
            role: "dialog",
            "aria-labelledby": "".concat(name, "-heading"),
            "aria-describedby": "".concat(name, "-description")
        }, rest, additionalProps), headerElement || defaultHeaderElement, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("section", {
            id: "".concat(name, "-description")
        }, children), footerElement || defaultFooterElement);
    };
    if (standalone) return renderDialog("div");
    if (!modalNode) return null;
    // portals need to be wrapped in a fragment because react-docgen doesn't recognize them
    // as a component ref: https://github.com/reactjs/react-docgen/issues/336
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($91d813eb41c8c85f$exports))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        ref: dialogOverlayRef,
        onClick: onOverlayClick,
        tabIndex: "-1",
        className: "modal-dialog-overlay"
    }, renderDialog((0, $4abcf94e80726891$export$2e2bcd8739ae039), {
        as: "div"
    }))), modalNode));
}
$7f3b80d7462309dd$var$ModalDialog.sizes = {
    small: "small",
    medium: "medium",
    large: "large"
};
$7f3b80d7462309dd$var$ModalDialog.defaultProps = {
    closeKind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel,
    size: $7f3b80d7462309dd$var$ModalDialog.sizes.small
};
$7f3b80d7462309dd$var$ModalDialog.propTypes = {
    name: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string.isRequired,
    heading: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).node,
    onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func,
    submitDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    submitText: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    submitKind: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).oneOf(Object.values((0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds)),
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func,
    closeText: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    closeKind: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).oneOf(Object.values((0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds)),
    standalone: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    renderTo: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).any,
    headerElement: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).element,
    footerElement: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).element,
    size: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).oneOf(Object.keys($7f3b80d7462309dd$var$ModalDialog.sizes))
};
var $7f3b80d7462309dd$export$2e2bcd8739ae039 = $7f3b80d7462309dd$var$ModalDialog;



var $fgmOP = parcelRequire("fgmOP");



var $fgmOP = parcelRequire("fgmOP");

var $84bfec4afcb34865$exports = {};
"use strict";
var $d0ff191cc1bb7f3e$exports = {};
"use strict";
var $6c486a43a76d577a$exports = {};
"use strict";
var $ed01ea1e639915fb$exports = {};
"use strict";
var $ed01ea1e639915fb$var$slice = Array.prototype.slice;

var $boCnF = parcelRequire("boCnF");
var $ed01ea1e639915fb$var$origKeys = Object.keys;

var $ed01ea1e639915fb$var$keysShim = $ed01ea1e639915fb$var$origKeys ? function keys(o) {
    return $ed01ea1e639915fb$var$origKeys(o);
} : (parcelRequire("lxArP"));
var $ed01ea1e639915fb$var$originalKeys = Object.keys;
$ed01ea1e639915fb$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($boCnF(object)) return $ed01ea1e639915fb$var$originalKeys($ed01ea1e639915fb$var$slice.call(object));
            return $ed01ea1e639915fb$var$originalKeys(object);
        };
    } else Object.keys = $ed01ea1e639915fb$var$keysShim;
    return Object.keys || $ed01ea1e639915fb$var$keysShim;
};
$ed01ea1e639915fb$exports = $ed01ea1e639915fb$var$keysShim;


var $6c486a43a76d577a$var$hasSymbols = typeof Symbol === "function" && typeof Symbol("foo") === "symbol";
var $6c486a43a76d577a$var$toStr = Object.prototype.toString;
var $6c486a43a76d577a$var$concat = Array.prototype.concat;

var $hb7F2 = parcelRequire("hb7F2");
var $6c486a43a76d577a$var$isFunction = function(fn) {
    return typeof fn === "function" && $6c486a43a76d577a$var$toStr.call(fn) === "[object Function]";
};

var $6c486a43a76d577a$var$supportsDescriptors = (parcelRequire("fyUVU"))();
var $6c486a43a76d577a$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$6c486a43a76d577a$var$isFunction(predicate) || !predicate()) return;
    }
    if ($6c486a43a76d577a$var$supportsDescriptors) $hb7F2(object, name, value, true);
    else $hb7F2(object, name, value);
};
var $6c486a43a76d577a$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $ed01ea1e639915fb$exports(map);
    if ($6c486a43a76d577a$var$hasSymbols) props = $6c486a43a76d577a$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$6c486a43a76d577a$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$6c486a43a76d577a$var$defineProperties.supportsDescriptors = !!$6c486a43a76d577a$var$supportsDescriptors;
$6c486a43a76d577a$exports = $6c486a43a76d577a$var$defineProperties;



var $6smyX = parcelRequire("6smyX");
var $f85aa11a96fa9d80$exports = {};
"use strict";


var $f85aa11a96fa9d80$var$hasSymbols = (parcelRequire("7hv1u"))();

var $kKGfz = parcelRequire("kKGfz");
var $f85aa11a96fa9d80$var$toObject = Object;
var $f85aa11a96fa9d80$var$$push = $kKGfz("Array.prototype.push");
var $f85aa11a96fa9d80$var$$propIsEnumerable = $kKGfz("Object.prototype.propertyIsEnumerable");
var $f85aa11a96fa9d80$var$originalGetSymbols = $f85aa11a96fa9d80$var$hasSymbols ? Object.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
$f85aa11a96fa9d80$exports = function assign(target, source1) {
    if (target == null) throw new TypeError("target must be an object");
    var to = $f85aa11a96fa9d80$var$toObject(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $f85aa11a96fa9d80$var$toObject(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $ed01ea1e639915fb$exports(from);
        var getSymbols = $f85aa11a96fa9d80$var$hasSymbols && (Object.getOwnPropertySymbols || $f85aa11a96fa9d80$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($f85aa11a96fa9d80$var$$propIsEnumerable(from, key)) $f85aa11a96fa9d80$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($f85aa11a96fa9d80$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};


var $f575cf848f0e4790$exports = {};
"use strict";

var $f575cf848f0e4790$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = "abcdefghijklmnopqrst";
    var letters = str.split("");
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = "";
    for(var k in obj)actual += k;
    return str !== actual;
};
var $f575cf848f0e4790$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, "xy");
    } catch (e) {
        return thrower[1] === "y";
    }
    return false;
};
$f575cf848f0e4790$exports = function getPolyfill() {
    if (!Object.assign) return $f85aa11a96fa9d80$exports;
    if ($f575cf848f0e4790$var$lacksProperEnumerationOrder()) return $f85aa11a96fa9d80$exports;
    if ($f575cf848f0e4790$var$assignHasPendingExceptions()) return $f85aa11a96fa9d80$exports;
    return Object.assign;
};


var $72bffe2e8a484f18$exports = {};
"use strict";


$72bffe2e8a484f18$exports = function shimAssign() {
    var polyfill = $f575cf848f0e4790$exports();
    $6c486a43a76d577a$exports(Object, {
        assign: polyfill
    }, {
        assign: function() {
            return Object.assign !== polyfill;
        }
    });
    return polyfill;
};


var $d0ff191cc1bb7f3e$var$polyfill = $6smyX.apply($f575cf848f0e4790$exports());
// eslint-disable-next-line no-unused-vars
var $d0ff191cc1bb7f3e$var$bound = function assign(target, source1) {
    return $d0ff191cc1bb7f3e$var$polyfill(Object, arguments);
};
$6c486a43a76d577a$exports($d0ff191cc1bb7f3e$var$bound, {
    getPolyfill: $f575cf848f0e4790$exports,
    implementation: $f85aa11a96fa9d80$exports,
    shim: $72bffe2e8a484f18$exports
});
$d0ff191cc1bb7f3e$exports = $d0ff191cc1bb7f3e$var$bound;



var $kKGfz = parcelRequire("kKGfz");
var $645d9fec712b8d6b$exports = {};
"use strict";


var $6smyX = parcelRequire("6smyX");
var $c41dbf113556ba48$exports = {};
"use strict";
var $60cc10e9cb1f505b$exports = {};
"use strict";

var $hb7F2 = parcelRequire("hb7F2");

var $60cc10e9cb1f505b$var$hasDescriptors = (parcelRequire("fyUVU"))();

var $60cc10e9cb1f505b$var$functionsHaveConfigurableNames = (parcelRequire("a8J51")).functionsHaveConfigurableNames();

var $026v5 = parcelRequire("026v5");
/** @type {import('.')} */ $60cc10e9cb1f505b$exports = function setFunctionName(fn, name) {
    if (typeof fn !== "function") throw new $026v5("`fn` is not a function");
    var loose = arguments.length > 2 && !!arguments[2];
    if (!loose || $60cc10e9cb1f505b$var$functionsHaveConfigurableNames) {
        if ($60cc10e9cb1f505b$var$hasDescriptors) $hb7F2(/** @type {Parameters<define>[0]} */ fn, "name", name, true, true);
        else $hb7F2(/** @type {Parameters<define>[0]} */ fn, "name", name);
    }
    return fn;
};



var $026v5 = parcelRequire("026v5");
var $c41dbf113556ba48$var$$Object = Object;
$c41dbf113556ba48$exports = $60cc10e9cb1f505b$exports(function flags() {
    if (this == null || this !== $c41dbf113556ba48$var$$Object(this)) throw new $026v5("RegExp.prototype.flags getter called on non-object");
    var result = "";
    if (this.hasIndices) result += "d";
    if (this.global) result += "g";
    if (this.ignoreCase) result += "i";
    if (this.multiline) result += "m";
    if (this.dotAll) result += "s";
    if (this.unicode) result += "u";
    if (this.unicodeSets) result += "v";
    if (this.sticky) result += "y";
    return result;
}, "get flags", true);


var $07dc1993d2a9f57b$exports = {};
"use strict";


var $07dc1993d2a9f57b$require$supportsDescriptors = $6c486a43a76d577a$exports.supportsDescriptors;
var $07dc1993d2a9f57b$var$$gOPD = Object.getOwnPropertyDescriptor;
$07dc1993d2a9f57b$exports = function getPolyfill() {
    if ($07dc1993d2a9f57b$require$supportsDescriptors && /a/mig.flags === "gim") {
        var descriptor = $07dc1993d2a9f57b$var$$gOPD(RegExp.prototype, "flags");
        if (descriptor && typeof descriptor.get === "function" && typeof RegExp.prototype.dotAll === "boolean" && typeof RegExp.prototype.hasIndices === "boolean") {
            /* eslint getter-return: 0 */ var calls = "";
            var o = {};
            Object.defineProperty(o, "hasIndices", {
                get: function() {
                    calls += "d";
                }
            });
            Object.defineProperty(o, "sticky", {
                get: function() {
                    calls += "y";
                }
            });
            if (calls === "dy") return descriptor.get;
        }
    }
    return $c41dbf113556ba48$exports;
};


var $127a11a6ac015f55$exports = {};
"use strict";

var $127a11a6ac015f55$require$supportsDescriptors = $6c486a43a76d577a$exports.supportsDescriptors;

var $127a11a6ac015f55$var$gOPD = Object.getOwnPropertyDescriptor;
var $127a11a6ac015f55$var$defineProperty = Object.defineProperty;
var $127a11a6ac015f55$var$TypeErr = TypeError;
var $127a11a6ac015f55$var$getProto = Object.getPrototypeOf;
var $127a11a6ac015f55$var$regex = /a/;
$127a11a6ac015f55$exports = function shimFlags() {
    if (!$127a11a6ac015f55$require$supportsDescriptors || !$127a11a6ac015f55$var$getProto) throw new $127a11a6ac015f55$var$TypeErr("RegExp.prototype.flags requires a true ES5 environment that supports property descriptors");
    var polyfill = $07dc1993d2a9f57b$exports();
    var proto = $127a11a6ac015f55$var$getProto($127a11a6ac015f55$var$regex);
    var descriptor = $127a11a6ac015f55$var$gOPD(proto, "flags");
    if (!descriptor || descriptor.get !== polyfill) $127a11a6ac015f55$var$defineProperty(proto, "flags", {
        configurable: true,
        enumerable: false,
        get: polyfill
    });
    return polyfill;
};


var $645d9fec712b8d6b$var$flagsBound = $6smyX($07dc1993d2a9f57b$exports());
$6c486a43a76d577a$exports($645d9fec712b8d6b$var$flagsBound, {
    getPolyfill: $07dc1993d2a9f57b$exports,
    implementation: $c41dbf113556ba48$exports,
    shim: $127a11a6ac015f55$exports
});
$645d9fec712b8d6b$exports = $645d9fec712b8d6b$var$flagsBound;



var $a5n6m = parcelRequire("a5n6m");
var $8c5cd06b55d507fd$exports = {};

var $33y03 = parcelRequire("33y03");
"use strict";

var $eUexM = parcelRequire("eUexM");
var $8e476770e0c9e4fb$exports = {};
"use strict";
var $ce1baf7e09ccb712$exports = {};
"use strict";

var $hAbsx = parcelRequire("hAbsx");

var $ce1baf7e09ccb712$var$channel = (parcelRequire("emBdm"))();

var $026v5 = parcelRequire("026v5");
var $ce1baf7e09ccb712$var$SLOT = {
    assert: function(O, slot) {
        if (!O || typeof O !== "object" && typeof O !== "function") throw new $026v5("`O` is not an object");
        if (typeof slot !== "string") throw new $026v5("`slot` must be a string");
        $ce1baf7e09ccb712$var$channel.assert(O);
        if (!$ce1baf7e09ccb712$var$SLOT.has(O, slot)) throw new $026v5("`" + slot + "` is not present on `O`");
    },
    get: function(O, slot) {
        if (!O || typeof O !== "object" && typeof O !== "function") throw new $026v5("`O` is not an object");
        if (typeof slot !== "string") throw new $026v5("`slot` must be a string");
        var slots = $ce1baf7e09ccb712$var$channel.get(O);
        return slots && slots["$" + slot];
    },
    has: function(O, slot) {
        if (!O || typeof O !== "object" && typeof O !== "function") throw new $026v5("`O` is not an object");
        if (typeof slot !== "string") throw new $026v5("`slot` must be a string");
        var slots = $ce1baf7e09ccb712$var$channel.get(O);
        return !!slots && $hAbsx(slots, "$" + slot);
    },
    set: function(O, slot, V) {
        if (!O || typeof O !== "object" && typeof O !== "function") throw new $026v5("`O` is not an object");
        if (typeof slot !== "string") throw new $026v5("`slot` must be a string");
        var slots = $ce1baf7e09ccb712$var$channel.get(O);
        if (!slots) {
            slots = {};
            $ce1baf7e09ccb712$var$channel.set(O, slots);
        }
        slots["$" + slot] = V;
    }
};
if (Object.freeze) Object.freeze($ce1baf7e09ccb712$var$SLOT);
$ce1baf7e09ccb712$exports = $ce1baf7e09ccb712$var$SLOT;


var $8e476770e0c9e4fb$var$$SyntaxError = SyntaxError;
var $8e476770e0c9e4fb$var$$StopIteration = typeof StopIteration === "object" ? StopIteration : null;
$8e476770e0c9e4fb$exports = function getStopIterationIterator(origIterator) {
    if (!$8e476770e0c9e4fb$var$$StopIteration) throw new $8e476770e0c9e4fb$var$$SyntaxError("this environment lacks StopIteration");
    $ce1baf7e09ccb712$exports.set(origIterator, "[[Done]]", false);
    var siIterator = {
        next: function next() {
            var iterator = $ce1baf7e09ccb712$exports.get(this, "[[Iterator]]");
            var done = $ce1baf7e09ccb712$exports.get(iterator, "[[Done]]");
            try {
                return {
                    done: done,
                    value: done ? void 0 : iterator.next()
                };
            } catch (e) {
                $ce1baf7e09ccb712$exports.set(iterator, "[[Done]]", true);
                if (e !== $8e476770e0c9e4fb$var$$StopIteration) throw e;
                return {
                    done: true,
                    value: void 0
                };
            }
        }
    };
    $ce1baf7e09ccb712$exports.set(siIterator, "[[Iterator]]", origIterator);
    return siIterator;
};










if ((parcelRequire("lQzMC"))() || (parcelRequire("7hv1u"))()) {
    var $8c5cd06b55d507fd$var$$iterator = Symbol.iterator;
    // Symbol is available natively or shammed
    // natively:
    //  - Chrome >= 38
    //  - Edge 12-14?, Edge >= 15 for sure
    //  - FF >= 36
    //  - Safari >= 9
    //  - node >= 0.12
    $8c5cd06b55d507fd$exports = function getIterator(iterable) {
        // alternatively, `iterable[$iterator]?.()`
        if (iterable != null && typeof iterable[$8c5cd06b55d507fd$var$$iterator] !== "undefined") return iterable[$8c5cd06b55d507fd$var$$iterator]();
        if ($eUexM(iterable)) // arguments objects lack Symbol.iterator
        // - node 0.12
        return Array.prototype[$8c5cd06b55d507fd$var$$iterator].call(iterable);
    };
} else {
    // Symbol is not available, native or shammed
    var $8c5cd06b55d507fd$var$isArray = (parcelRequire("a6yWc"));
    var $8c5cd06b55d507fd$var$isString = (parcelRequire("5oIKp"));
    var $8c5cd06b55d507fd$var$GetIntrinsic = (parcelRequire("a5n6m"));
    var $8c5cd06b55d507fd$var$$Map = $8c5cd06b55d507fd$var$GetIntrinsic("%Map%", true);
    var $8c5cd06b55d507fd$var$$Set = $8c5cd06b55d507fd$var$GetIntrinsic("%Set%", true);
    var $8c5cd06b55d507fd$var$callBound = (parcelRequire("kKGfz"));
    var $8c5cd06b55d507fd$var$$arrayPush = $8c5cd06b55d507fd$var$callBound("Array.prototype.push");
    var $8c5cd06b55d507fd$var$$charCodeAt = $8c5cd06b55d507fd$var$callBound("String.prototype.charCodeAt");
    var $8c5cd06b55d507fd$var$$stringSlice = $8c5cd06b55d507fd$var$callBound("String.prototype.slice");
    var $8c5cd06b55d507fd$var$advanceStringIndex = function advanceStringIndex(S, index) {
        var length = S.length;
        if (index + 1 >= length) return index + 1;
        var first = $8c5cd06b55d507fd$var$$charCodeAt(S, index);
        if (first < 0xD800 || first > 0xDBFF) return index + 1;
        var second = $8c5cd06b55d507fd$var$$charCodeAt(S, index + 1);
        if (second < 0xDC00 || second > 0xDFFF) return index + 1;
        return index + 2;
    };
    var $8c5cd06b55d507fd$var$getArrayIterator = function getArrayIterator(arraylike) {
        var i = 0;
        return {
            next: function next() {
                var done = i >= arraylike.length;
                var value;
                if (!done) {
                    value = arraylike[i];
                    i += 1;
                }
                return {
                    done: done,
                    value: value
                };
            }
        };
    };
    var $8c5cd06b55d507fd$var$getNonCollectionIterator = function getNonCollectionIterator(iterable, noPrimordialCollections) {
        if ($8c5cd06b55d507fd$var$isArray(iterable) || $eUexM(iterable)) return $8c5cd06b55d507fd$var$getArrayIterator(iterable);
        if ($8c5cd06b55d507fd$var$isString(iterable)) {
            var i = 0;
            return {
                next: function next() {
                    var nextIndex = $8c5cd06b55d507fd$var$advanceStringIndex(iterable, i);
                    var value = $8c5cd06b55d507fd$var$$stringSlice(iterable, i, nextIndex);
                    i = nextIndex;
                    return {
                        done: nextIndex > iterable.length,
                        value: value
                    };
                }
            };
        }
        // es6-shim and es-shims' es-map use a string "_es6-shim iterator_" property on different iterables, such as MapIterator.
        if (noPrimordialCollections && typeof iterable["_es6-shim iterator_"] !== "undefined") return iterable["_es6-shim iterator_"]();
    };
    if (!$8c5cd06b55d507fd$var$$Map && !$8c5cd06b55d507fd$var$$Set) // the only language iterables are Array, String, arguments
    // - Safari <= 6.0
    // - Chrome < 38
    // - node < 0.12
    // - FF < 13
    // - IE < 11
    // - Edge < 11
    $8c5cd06b55d507fd$exports = function getIterator(iterable) {
        if (iterable != null) return $8c5cd06b55d507fd$var$getNonCollectionIterator(iterable, true);
    };
    else {
        // either Map or Set are available, but Symbol is not
        // - es6-shim on an ES5 browser
        // - Safari 6.2 (maybe 6.1?)
        // - FF v[13, 36)
        // - IE 11
        // - Edge 11
        // - Safari v[6, 9)
        var $8c5cd06b55d507fd$var$isMap = (parcelRequire("hnMH2"));
        var $8c5cd06b55d507fd$var$isSet = (parcelRequire("2ZpS0"));
        // Firefox >= 27, IE 11, Safari 6.2 - 9, Edge 11, es6-shim in older envs, all have forEach
        var $8c5cd06b55d507fd$var$$mapForEach = $8c5cd06b55d507fd$var$callBound("Map.prototype.forEach", true);
        var $8c5cd06b55d507fd$var$$setForEach = $8c5cd06b55d507fd$var$callBound("Set.prototype.forEach", true);
        if (typeof $33y03 === "undefined" || !$33y03.versions || !$33y03.versions.node) {
            // Firefox 17 - 26 has `.iterator()`, whose iterator `.next()` either
            // returns a value, or throws a StopIteration object. These browsers
            // do not have any other mechanism for iteration.
            var $8c5cd06b55d507fd$var$$mapIterator = $8c5cd06b55d507fd$var$callBound("Map.prototype.iterator", true);
            var $8c5cd06b55d507fd$var$$setIterator = $8c5cd06b55d507fd$var$callBound("Set.prototype.iterator", true);
        }
        // Firefox 27-35, and some older es6-shim versions, use a string "@@iterator" property
        // this returns a proper iterator object, so we should use it instead of forEach.
        // newer es6-shim versions use a string "_es6-shim iterator_" property.
        var $8c5cd06b55d507fd$var$$mapAtAtIterator = $8c5cd06b55d507fd$var$callBound("Map.prototype.@@iterator", true) || $8c5cd06b55d507fd$var$callBound("Map.prototype._es6-shim iterator_", true);
        var $8c5cd06b55d507fd$var$$setAtAtIterator = $8c5cd06b55d507fd$var$callBound("Set.prototype.@@iterator", true) || $8c5cd06b55d507fd$var$callBound("Set.prototype._es6-shim iterator_", true);
        var $8c5cd06b55d507fd$var$getCollectionIterator = function getCollectionIterator(iterable) {
            if ($8c5cd06b55d507fd$var$isMap(iterable)) {
                if ($8c5cd06b55d507fd$var$$mapIterator) return $8e476770e0c9e4fb$exports($8c5cd06b55d507fd$var$$mapIterator(iterable));
                if ($8c5cd06b55d507fd$var$$mapAtAtIterator) return $8c5cd06b55d507fd$var$$mapAtAtIterator(iterable);
                if ($8c5cd06b55d507fd$var$$mapForEach) {
                    var entries = [];
                    $8c5cd06b55d507fd$var$$mapForEach(iterable, function(v, k) {
                        $8c5cd06b55d507fd$var$$arrayPush(entries, [
                            k,
                            v
                        ]);
                    });
                    return $8c5cd06b55d507fd$var$getArrayIterator(entries);
                }
            }
            if ($8c5cd06b55d507fd$var$isSet(iterable)) {
                if ($8c5cd06b55d507fd$var$$setIterator) return $8e476770e0c9e4fb$exports($8c5cd06b55d507fd$var$$setIterator(iterable));
                if ($8c5cd06b55d507fd$var$$setAtAtIterator) return $8c5cd06b55d507fd$var$$setAtAtIterator(iterable);
                if ($8c5cd06b55d507fd$var$$setForEach) {
                    var values = [];
                    $8c5cd06b55d507fd$var$$setForEach(iterable, function(v) {
                        $8c5cd06b55d507fd$var$$arrayPush(values, v);
                    });
                    return $8c5cd06b55d507fd$var$getArrayIterator(values);
                }
            }
        };
        $8c5cd06b55d507fd$exports = function getIterator(iterable) {
            return $8c5cd06b55d507fd$var$getCollectionIterator(iterable) || $8c5cd06b55d507fd$var$getNonCollectionIterator(iterable);
        };
    }
}



var $emBdm = parcelRequire("emBdm");
var $246e56ee9abdcad6$exports = {};
"use strict";


var $6smyX = parcelRequire("6smyX");
var $03c3c50578c4808a$exports = {};
"use strict";
var $03c3c50578c4808a$var$numberIsNaN = function(value) {
    return value !== value;
};
$03c3c50578c4808a$exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($03c3c50578c4808a$var$numberIsNaN(a) && $03c3c50578c4808a$var$numberIsNaN(b)) return true;
    return false;
};


var $f2a820fddf6728a2$exports = {};
"use strict";

$f2a820fddf6728a2$exports = function getPolyfill() {
    return typeof Object.is === "function" ? Object.is : $03c3c50578c4808a$exports;
};


var $59d14960ef32638d$exports = {};
"use strict";


$59d14960ef32638d$exports = function shimObjectIs() {
    var polyfill = $f2a820fddf6728a2$exports();
    $6c486a43a76d577a$exports(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};


var $246e56ee9abdcad6$var$polyfill = $6smyX($f2a820fddf6728a2$exports(), Object);
$6c486a43a76d577a$exports($246e56ee9abdcad6$var$polyfill, {
    getPolyfill: $f2a820fddf6728a2$exports,
    implementation: $03c3c50578c4808a$exports,
    shim: $59d14960ef32638d$exports
});
$246e56ee9abdcad6$exports = $246e56ee9abdcad6$var$polyfill;



var $eUexM = parcelRequire("eUexM");

var $a6yWc = parcelRequire("a6yWc");
var $66d5cc3896240850$exports = {};
"use strict";

var $6smyX = parcelRequire("6smyX");

var $kKGfz = parcelRequire("kKGfz");

var $a5n6m = parcelRequire("a5n6m");
var $66d5cc3896240850$var$$ArrayBuffer = $a5n6m("%ArrayBuffer%", true);
/** @type {undefined | ((receiver: ArrayBuffer) => number) | ((receiver: unknown) => never)} */ var $66d5cc3896240850$var$$byteLength = $kKGfz("ArrayBuffer.prototype.byteLength", true);
var $66d5cc3896240850$var$$toString = $kKGfz("Object.prototype.toString");
// in node 0.10, ArrayBuffers have no prototype methods, but have an own slot-checking `slice` method
var $66d5cc3896240850$var$abSlice = !!$66d5cc3896240850$var$$ArrayBuffer && !$66d5cc3896240850$var$$byteLength && new $66d5cc3896240850$var$$ArrayBuffer(0).slice;
var $66d5cc3896240850$var$$abSlice = !!$66d5cc3896240850$var$abSlice && $6smyX($66d5cc3896240850$var$abSlice);
/** @type {import('.')} */ $66d5cc3896240850$exports = $66d5cc3896240850$var$$byteLength || $66d5cc3896240850$var$$abSlice ? function isArrayBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    try {
        if ($66d5cc3896240850$var$$byteLength) // @ts-expect-error no idea why TS can't handle the overload
        $66d5cc3896240850$var$$byteLength(obj);
        else // @ts-expect-error TS chooses not to type-narrow inside a closure
        $66d5cc3896240850$var$$abSlice(obj, 0);
        return true;
    } catch (e) {
        return false;
    }
} : $66d5cc3896240850$var$$ArrayBuffer ? function isArrayBuffer(obj) {
    return $66d5cc3896240850$var$$toString(obj) === "[object ArrayBuffer]";
} : function isArrayBuffer(obj) {
    return false;
};


var $f2d25ed5706d8f23$exports = {};
"use strict";
var $f2d25ed5706d8f23$var$getDay = Date.prototype.getDay;
var $f2d25ed5706d8f23$var$tryDateObject = function tryDateGetDayCall(value) {
    try {
        $f2d25ed5706d8f23$var$getDay.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $f2d25ed5706d8f23$var$toStr = Object.prototype.toString;
var $f2d25ed5706d8f23$var$dateClass = "[object Date]";

var $f2d25ed5706d8f23$var$hasToStringTag = (parcelRequire("7kFju"))();
$f2d25ed5706d8f23$exports = function isDateObject(value) {
    if (typeof value !== "object" || value === null) return false;
    return $f2d25ed5706d8f23$var$hasToStringTag ? $f2d25ed5706d8f23$var$tryDateObject(value) : $f2d25ed5706d8f23$var$toStr.call(value) === $f2d25ed5706d8f23$var$dateClass;
};


var $794217716707c711$exports = {};
"use strict";

var $kKGfz = parcelRequire("kKGfz");

var $794217716707c711$var$hasToStringTag = (parcelRequire("7kFju"))();
var $794217716707c711$var$has;
var $794217716707c711$var$$exec;
var $794217716707c711$var$isRegexMarker;
var $794217716707c711$var$badStringifier;
if ($794217716707c711$var$hasToStringTag) {
    $794217716707c711$var$has = $kKGfz("Object.prototype.hasOwnProperty");
    $794217716707c711$var$$exec = $kKGfz("RegExp.prototype.exec");
    $794217716707c711$var$isRegexMarker = {};
    var $794217716707c711$var$throwRegexMarker = function() {
        throw $794217716707c711$var$isRegexMarker;
    };
    $794217716707c711$var$badStringifier = {
        toString: $794217716707c711$var$throwRegexMarker,
        valueOf: $794217716707c711$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === "symbol") $794217716707c711$var$badStringifier[Symbol.toPrimitive] = $794217716707c711$var$throwRegexMarker;
}
var $794217716707c711$var$$toString = $kKGfz("Object.prototype.toString");
var $794217716707c711$var$gOPD = Object.getOwnPropertyDescriptor;
var $794217716707c711$var$regexClass = "[object RegExp]";
$794217716707c711$exports = $794217716707c711$var$hasToStringTag ? function isRegex(value) {
    if (!value || typeof value !== "object") return false;
    var descriptor = $794217716707c711$var$gOPD(value, "lastIndex");
    var hasLastIndexDataProperty = descriptor && $794217716707c711$var$has(descriptor, "value");
    if (!hasLastIndexDataProperty) return false;
    try {
        $794217716707c711$var$$exec(value, $794217716707c711$var$badStringifier);
    } catch (e) {
        return e === $794217716707c711$var$isRegexMarker;
    }
} : function isRegex(value) {
    // In older browsers, typeof regex incorrectly returns 'function'
    if (!value || typeof value !== "object" && typeof value !== "function") return false;
    return $794217716707c711$var$$toString(value) === $794217716707c711$var$regexClass;
};


var $f4f6715b36b8d179$exports = {};
"use strict";

var $kKGfz = parcelRequire("kKGfz");
var $f4f6715b36b8d179$var$$byteLength = $kKGfz("SharedArrayBuffer.prototype.byteLength", true);
/** @type {import('.')} */ $f4f6715b36b8d179$exports = $f4f6715b36b8d179$var$$byteLength ? function isSharedArrayBuffer(obj) {
    if (!obj || typeof obj !== "object") return false;
    try {
        $f4f6715b36b8d179$var$$byteLength(obj);
        return true;
    } catch (e) {
        return false;
    }
} : function isSharedArrayBuffer(obj) {
    return false;
};



var $90ad80eadbedbe62$exports = {};
"use strict";

var $5oIKp = parcelRequire("5oIKp");
var $7dd9e2c3d3efa6fa$exports = {};
"use strict";
var $7dd9e2c3d3efa6fa$var$numToStr = Number.prototype.toString;
var $7dd9e2c3d3efa6fa$var$tryNumberObject = function tryNumberObject(value) {
    try {
        $7dd9e2c3d3efa6fa$var$numToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $7dd9e2c3d3efa6fa$var$toStr = Object.prototype.toString;
var $7dd9e2c3d3efa6fa$var$numClass = "[object Number]";

var $7dd9e2c3d3efa6fa$var$hasToStringTag = (parcelRequire("7kFju"))();
$7dd9e2c3d3efa6fa$exports = function isNumberObject(value) {
    if (typeof value === "number") return true;
    if (typeof value !== "object") return false;
    return $7dd9e2c3d3efa6fa$var$hasToStringTag ? $7dd9e2c3d3efa6fa$var$tryNumberObject(value) : $7dd9e2c3d3efa6fa$var$toStr.call(value) === $7dd9e2c3d3efa6fa$var$numClass;
};


var $cd70aee2c7371b7d$exports = {};
"use strict";

var $kKGfz = parcelRequire("kKGfz");
var $cd70aee2c7371b7d$var$$boolToStr = $kKGfz("Boolean.prototype.toString");
var $cd70aee2c7371b7d$var$$toString = $kKGfz("Object.prototype.toString");
var $cd70aee2c7371b7d$var$tryBooleanObject = function booleanBrandCheck(value) {
    try {
        $cd70aee2c7371b7d$var$$boolToStr(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $cd70aee2c7371b7d$var$boolClass = "[object Boolean]";

var $cd70aee2c7371b7d$var$hasToStringTag = (parcelRequire("7kFju"))();
$cd70aee2c7371b7d$exports = function isBoolean(value) {
    if (typeof value === "boolean") return true;
    if (value === null || typeof value !== "object") return false;
    return $cd70aee2c7371b7d$var$hasToStringTag && Symbol.toStringTag in value ? $cd70aee2c7371b7d$var$tryBooleanObject(value) : $cd70aee2c7371b7d$var$$toString(value) === $cd70aee2c7371b7d$var$boolClass;
};


var $17cca39ec98fe9d8$exports = {};
"use strict";
var $17cca39ec98fe9d8$var$toStr = Object.prototype.toString;

var $17cca39ec98fe9d8$var$hasSymbols = (parcelRequire("lQzMC"))();
if ($17cca39ec98fe9d8$var$hasSymbols) {
    var $17cca39ec98fe9d8$var$symToStr = Symbol.prototype.toString;
    var $17cca39ec98fe9d8$var$symStringRegex = /^Symbol\(.*\)$/;
    var $17cca39ec98fe9d8$var$isSymbolObject = function isRealSymbolObject(value) {
        if (typeof value.valueOf() !== "symbol") return false;
        return $17cca39ec98fe9d8$var$symStringRegex.test($17cca39ec98fe9d8$var$symToStr.call(value));
    };
    $17cca39ec98fe9d8$exports = function isSymbol(value) {
        if (typeof value === "symbol") return true;
        if ($17cca39ec98fe9d8$var$toStr.call(value) !== "[object Symbol]") return false;
        try {
            return $17cca39ec98fe9d8$var$isSymbolObject(value);
        } catch (e) {
            return false;
        }
    };
} else $17cca39ec98fe9d8$exports = function isSymbol(value) {
    // this environment does not support Symbols.
    return false;
};


var $b479d508459932db$exports = {};
"use strict";

var $b479d508459932db$var$hasBigInts = (parcelRequire("1bCpl"))();
if ($b479d508459932db$var$hasBigInts) {
    var $b479d508459932db$var$bigIntValueOf = BigInt.prototype.valueOf;
    var $b479d508459932db$var$tryBigInt = function tryBigIntObject(value) {
        try {
            $b479d508459932db$var$bigIntValueOf.call(value);
            return true;
        } catch (e) {}
        return false;
    };
    $b479d508459932db$exports = function isBigInt(value) {
        if (value === null || typeof value === "undefined" || typeof value === "boolean" || typeof value === "string" || typeof value === "number" || typeof value === "symbol" || typeof value === "function") return false;
        if (typeof value === "bigint") return true;
        return $b479d508459932db$var$tryBigInt(value);
    };
} else $b479d508459932db$exports = function isBigInt(value) {
    return false;
};


// eslint-disable-next-line consistent-return
$90ad80eadbedbe62$exports = function whichBoxedPrimitive(value) {
    // eslint-disable-next-line eqeqeq
    if (value == null || typeof value !== "object" && typeof value !== "function") return null;
    if ($5oIKp(value)) return "String";
    if ($7dd9e2c3d3efa6fa$exports(value)) return "Number";
    if ($cd70aee2c7371b7d$exports(value)) return "Boolean";
    if ($17cca39ec98fe9d8$exports(value)) return "Symbol";
    if ($b479d508459932db$exports(value)) return "BigInt";
};


var $0b17ef6b120a9bcf$exports = {};
"use strict";

var $hnMH2 = parcelRequire("hnMH2");

var $2ZpS0 = parcelRequire("2ZpS0");
var $e89eaea90e90d237$exports = {};
"use strict";
var $e89eaea90e90d237$var$$WeakMap = typeof WeakMap === "function" && WeakMap.prototype ? WeakMap : null;
var $e89eaea90e90d237$var$$WeakSet = typeof WeakSet === "function" && WeakSet.prototype ? WeakSet : null;
var $e89eaea90e90d237$var$exported;
if (!$e89eaea90e90d237$var$$WeakMap) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
$e89eaea90e90d237$var$exported = function isWeakMap(x) {
    // `WeakMap` is not present in this environment.
    return false;
};
var $e89eaea90e90d237$var$$mapHas = $e89eaea90e90d237$var$$WeakMap ? $e89eaea90e90d237$var$$WeakMap.prototype.has : null;
var $e89eaea90e90d237$var$$setHas = $e89eaea90e90d237$var$$WeakSet ? $e89eaea90e90d237$var$$WeakSet.prototype.has : null;
if (!$e89eaea90e90d237$var$exported && !$e89eaea90e90d237$var$$mapHas) /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
$e89eaea90e90d237$var$exported = function isWeakMap(x) {
    // `WeakMap` does not have a `has` method
    return false;
};
/** @type {import('.')} */ $e89eaea90e90d237$exports = $e89eaea90e90d237$var$exported || function isWeakMap(x) {
    if (!x || typeof x !== "object") return false;
    try {
        $e89eaea90e90d237$var$$mapHas.call(x, $e89eaea90e90d237$var$$mapHas);
        if ($e89eaea90e90d237$var$$setHas) try {
            $e89eaea90e90d237$var$$setHas.call(x, $e89eaea90e90d237$var$$setHas);
        } catch (e) {
            return true;
        }
        // @ts-expect-error TS can't figure out that $WeakMap is always truthy here
        return x instanceof $e89eaea90e90d237$var$$WeakMap; // core-js workaround, pre-v3
    } catch (e) {}
    return false;
};


var $4b7a551c48a14aaa$exports = {};
"use strict";

var $a5n6m = parcelRequire("a5n6m");

var $kKGfz = parcelRequire("kKGfz");
var $4b7a551c48a14aaa$var$$WeakSet = $a5n6m("%WeakSet%", true);
var $4b7a551c48a14aaa$var$$setHas = $kKGfz("WeakSet.prototype.has", true);
if ($4b7a551c48a14aaa$var$$setHas) {
    var $4b7a551c48a14aaa$var$$mapHas = $kKGfz("WeakMap.prototype.has", true);
    /** @type {import('.')} */ $4b7a551c48a14aaa$exports = function isWeakSet(x) {
        if (!x || typeof x !== "object") return false;
        try {
            $4b7a551c48a14aaa$var$$setHas(x, $4b7a551c48a14aaa$var$$setHas);
            if ($4b7a551c48a14aaa$var$$mapHas) try {
                $4b7a551c48a14aaa$var$$mapHas(x, $4b7a551c48a14aaa$var$$mapHas);
            } catch (e) {
                return true;
            }
            // @ts-expect-error TS can't figure out that $WeakSet is always truthy here
            return x instanceof $4b7a551c48a14aaa$var$$WeakSet; // core-js workaround, pre-v3
        } catch (e) {}
        return false;
    };
} else /** @type {import('.')} */ // eslint-disable-next-line no-unused-vars
$4b7a551c48a14aaa$exports = function isWeakSet(x) {
    // `WeakSet` does not exist, or does not have a `has` method
    return false;
};


/** @type {import('.')} */ $0b17ef6b120a9bcf$exports = function whichCollection(/** @type {unknown} */ value) {
    if (value && typeof value === "object") {
        if ($hnMH2(value)) return "Map";
        if ($2ZpS0(value)) return "Set";
        if ($e89eaea90e90d237$exports(value)) return "WeakMap";
        if ($4b7a551c48a14aaa$exports(value)) return "WeakSet";
    }
    return false;
};



var $4L6DV = parcelRequire("4L6DV");
var $a07b6be57820a7ee$exports = {};
"use strict";

var $kKGfz = parcelRequire("kKGfz");
var $a07b6be57820a7ee$var$$byteLength = $kKGfz("ArrayBuffer.prototype.byteLength", true);

/** @type {import('.')} */ $a07b6be57820a7ee$exports = function byteLength(ab) {
    if (!$66d5cc3896240850$exports(ab)) return NaN;
    return $a07b6be57820a7ee$var$$byteLength ? $a07b6be57820a7ee$var$$byteLength(ab) : ab.byteLength;
}; // in node < 0.11, byteLength is an own nonconfigurable property


var $84bfec4afcb34865$var$sabByteLength = $kKGfz("SharedArrayBuffer.prototype.byteLength", true);
var $84bfec4afcb34865$var$$getTime = $kKGfz("Date.prototype.getTime");
var $84bfec4afcb34865$var$gPO = Object.getPrototypeOf;
var $84bfec4afcb34865$var$$objToString = $kKGfz("Object.prototype.toString");
var $84bfec4afcb34865$var$$Set = $a5n6m("%Set%", true);
var $84bfec4afcb34865$var$$mapHas = $kKGfz("Map.prototype.has", true);
var $84bfec4afcb34865$var$$mapGet = $kKGfz("Map.prototype.get", true);
var $84bfec4afcb34865$var$$mapSize = $kKGfz("Map.prototype.size", true);
var $84bfec4afcb34865$var$$setAdd = $kKGfz("Set.prototype.add", true);
var $84bfec4afcb34865$var$$setDelete = $kKGfz("Set.prototype.delete", true);
var $84bfec4afcb34865$var$$setHas = $kKGfz("Set.prototype.has", true);
var $84bfec4afcb34865$var$$setSize = $kKGfz("Set.prototype.size", true);
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L401-L414
function $84bfec4afcb34865$var$setHasEqualElement(set, val1, opts, channel) {
    var i = $8c5cd06b55d507fd$exports(set);
    var result;
    while((result = i.next()) && !result.done)if ($84bfec4afcb34865$var$internalDeepEqual(val1, result.value, opts, channel)) {
        // Remove the matching element to make sure we do not check that again.
        $84bfec4afcb34865$var$$setDelete(set, result.value);
        return true;
    }
    return false;
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L416-L439
function $84bfec4afcb34865$var$findLooseMatchingPrimitives(prim) {
    if (typeof prim === "undefined") return null;
    if (typeof prim === "object") return void 0;
    if (typeof prim === "symbol") return false;
    if (typeof prim === "string" || typeof prim === "number") // Loose equal entries exist only if the string is possible to convert to a regular number and not NaN.
    return +prim === +prim; // eslint-disable-line no-implicit-coercion
    return true;
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L449-L460
function $84bfec4afcb34865$var$mapMightHaveLoosePrim(a, b, prim, item, opts, channel) {
    var altValue = $84bfec4afcb34865$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = $84bfec4afcb34865$var$$mapGet(b, altValue);
    var looseOpts = $d0ff191cc1bb7f3e$exports({}, opts, {
        strict: false
    });
    if (typeof curB === "undefined" && !$84bfec4afcb34865$var$$mapHas(b, altValue) || !$84bfec4afcb34865$var$internalDeepEqual(item, curB, looseOpts, channel)) return false;
    // eslint-disable-next-line no-use-before-define
    return !$84bfec4afcb34865$var$$mapHas(a, altValue) && $84bfec4afcb34865$var$internalDeepEqual(item, curB, looseOpts, channel);
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L441-L447
function $84bfec4afcb34865$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $84bfec4afcb34865$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return $84bfec4afcb34865$var$$setHas(b, altValue) && !$84bfec4afcb34865$var$$setHas(a, altValue);
}
// taken from https://github.com/browserify/commonjs-assert/blob/bba838e9ba9e28edf3127ce6974624208502f6bc/internal/util/comparisons.js#L518-L533
function $84bfec4afcb34865$var$mapHasEqualEntry(set, map, key1, item1, opts, channel) {
    var i = $8c5cd06b55d507fd$exports(set);
    var result;
    var key2;
    while((result = i.next()) && !result.done){
        key2 = result.value;
        if (// eslint-disable-next-line no-use-before-define
        $84bfec4afcb34865$var$internalDeepEqual(key1, key2, opts, channel) && $84bfec4afcb34865$var$internalDeepEqual(item1, $84bfec4afcb34865$var$$mapGet(map, key2), opts, channel)) {
            $84bfec4afcb34865$var$$setDelete(set, key2);
            return true;
        }
    }
    return false;
}
function $84bfec4afcb34865$var$internalDeepEqual(actual, expected, options, channel) {
    var opts = options || {};
    // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? $246e56ee9abdcad6$exports(actual, expected) : actual === expected) return true;
    var actualBoxed = $90ad80eadbedbe62$exports(actual);
    var expectedBoxed = $90ad80eadbedbe62$exports(expected);
    if (actualBoxed !== expectedBoxed) return false;
    // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== "object" && typeof expected !== "object") return opts.strict ? $246e56ee9abdcad6$exports(actual, expected) : actual == expected; // eslint-disable-line eqeqeq
    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // see https://github.com/nodejs/node/commit/d3aafd02efd3a403d646a3044adcf14e63a88d32 for memos/channel inspiration
    var hasActual = channel.has(actual);
    var hasExpected = channel.has(expected);
    var sentinel;
    if (hasActual && hasExpected) {
        if (channel.get(actual) === channel.get(expected)) return true;
    } else sentinel = {};
    if (!hasActual) channel.set(actual, sentinel);
    if (!hasExpected) channel.set(expected, sentinel);
    // eslint-disable-next-line no-use-before-define
    return $84bfec4afcb34865$var$objEquiv(actual, expected, opts, channel);
}
function $84bfec4afcb34865$var$isBuffer(x) {
    if (!x || typeof x !== "object" || typeof x.length !== "number") return false;
    if (typeof x.copy !== "function" || typeof x.slice !== "function") return false;
    if (x.length > 0 && typeof x[0] !== "number") return false;
    return !!(x.constructor && x.constructor.isBuffer && x.constructor.isBuffer(x));
}
function $84bfec4afcb34865$var$setEquiv(a, b, opts, channel) {
    if ($84bfec4afcb34865$var$$setSize(a) !== $84bfec4afcb34865$var$$setSize(b)) return false;
    var iA = $8c5cd06b55d507fd$exports(a);
    var iB = $8c5cd06b55d507fd$exports(b);
    var resultA;
    var resultB;
    var set;
    while((resultA = iA.next()) && !resultA.done){
        if (resultA.value && typeof resultA.value === "object") {
            if (!set) set = new $84bfec4afcb34865$var$$Set();
            $84bfec4afcb34865$var$$setAdd(set, resultA.value);
        } else if (!$84bfec4afcb34865$var$$setHas(b, resultA.value)) {
            if (opts.strict) return false;
            if (!$84bfec4afcb34865$var$setMightHaveLoosePrim(a, b, resultA.value)) return false;
            if (!set) set = new $84bfec4afcb34865$var$$Set();
            $84bfec4afcb34865$var$$setAdd(set, resultA.value);
        }
    }
    if (set) {
        while((resultB = iB.next()) && !resultB.done){
            // We have to check if a primitive value is already matching and only if it's not, go hunting for it.
            if (resultB.value && typeof resultB.value === "object") {
                if (!$84bfec4afcb34865$var$setHasEqualElement(set, resultB.value, opts.strict, channel)) return false;
            } else if (!opts.strict && !$84bfec4afcb34865$var$$setHas(a, resultB.value) && !$84bfec4afcb34865$var$setHasEqualElement(set, resultB.value, opts.strict, channel)) return false;
        }
        return $84bfec4afcb34865$var$$setSize(set) === 0;
    }
    return true;
}
function $84bfec4afcb34865$var$mapEquiv(a, b, opts, channel) {
    if ($84bfec4afcb34865$var$$mapSize(a) !== $84bfec4afcb34865$var$$mapSize(b)) return false;
    var iA = $8c5cd06b55d507fd$exports(a);
    var iB = $8c5cd06b55d507fd$exports(b);
    var resultA;
    var resultB;
    var set;
    var key;
    var item1;
    var item2;
    while((resultA = iA.next()) && !resultA.done){
        key = resultA.value[0];
        item1 = resultA.value[1];
        if (key && typeof key === "object") {
            if (!set) set = new $84bfec4afcb34865$var$$Set();
            $84bfec4afcb34865$var$$setAdd(set, key);
        } else {
            item2 = $84bfec4afcb34865$var$$mapGet(b, key);
            if (typeof item2 === "undefined" && !$84bfec4afcb34865$var$$mapHas(b, key) || !$84bfec4afcb34865$var$internalDeepEqual(item1, item2, opts, channel)) {
                if (opts.strict) return false;
                if (!$84bfec4afcb34865$var$mapMightHaveLoosePrim(a, b, key, item1, opts, channel)) return false;
                if (!set) set = new $84bfec4afcb34865$var$$Set();
                $84bfec4afcb34865$var$$setAdd(set, key);
            }
        }
    }
    if (set) {
        while((resultB = iB.next()) && !resultB.done){
            key = resultB.value[0];
            item2 = resultB.value[1];
            if (key && typeof key === "object") {
                if (!$84bfec4afcb34865$var$mapHasEqualEntry(set, a, key, item2, opts, channel)) return false;
            } else if (!opts.strict && (!a.has(key) || !$84bfec4afcb34865$var$internalDeepEqual($84bfec4afcb34865$var$$mapGet(a, key), item2, opts, channel)) && !$84bfec4afcb34865$var$mapHasEqualEntry(set, a, key, item2, $d0ff191cc1bb7f3e$exports({}, opts, {
                strict: false
            }), channel)) return false;
        }
        return $84bfec4afcb34865$var$$setSize(set) === 0;
    }
    return true;
}
function $84bfec4afcb34865$var$objEquiv(a, b, opts, channel) {
    /* eslint max-statements: [2, 100], max-lines-per-function: [2, 120], max-depth: [2, 5], max-lines: [2, 400] */ var i, key;
    if (typeof a !== typeof b) return false;
    if (a == null || b == null) return false;
    if ($84bfec4afcb34865$var$$objToString(a) !== $84bfec4afcb34865$var$$objToString(b)) return false;
    if ($eUexM(a) !== $eUexM(b)) return false;
    var aIsArray = $a6yWc(a);
    var bIsArray = $a6yWc(b);
    if (aIsArray !== bIsArray) return false;
    // TODO: replace when a cross-realm brand check is available
    var aIsError = a instanceof Error;
    var bIsError = b instanceof Error;
    if (aIsError !== bIsError) return false;
    if (aIsError || bIsError) {
        if (a.name !== b.name || a.message !== b.message) return false;
    }
    var aIsRegex = $794217716707c711$exports(a);
    var bIsRegex = $794217716707c711$exports(b);
    if (aIsRegex !== bIsRegex) return false;
    if ((aIsRegex || bIsRegex) && (a.source !== b.source || $645d9fec712b8d6b$exports(a) !== $645d9fec712b8d6b$exports(b))) return false;
    var aIsDate = $f2d25ed5706d8f23$exports(a);
    var bIsDate = $f2d25ed5706d8f23$exports(b);
    if (aIsDate !== bIsDate) return false;
    if (aIsDate || bIsDate) {
        if ($84bfec4afcb34865$var$$getTime(a) !== $84bfec4afcb34865$var$$getTime(b)) return false;
    }
    if (opts.strict && $84bfec4afcb34865$var$gPO && $84bfec4afcb34865$var$gPO(a) !== $84bfec4afcb34865$var$gPO(b)) return false;
    var aWhich = $4L6DV(a);
    var bWhich = $4L6DV(b);
    if (aWhich !== bWhich) return false;
    if (aWhich || bWhich) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    var aIsBuffer = $84bfec4afcb34865$var$isBuffer(a);
    var bIsBuffer = $84bfec4afcb34865$var$isBuffer(b);
    if (aIsBuffer !== bIsBuffer) return false;
    if (aIsBuffer || bIsBuffer) {
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    var aIsArrayBuffer = $66d5cc3896240850$exports(a);
    var bIsArrayBuffer = $66d5cc3896240850$exports(b);
    if (aIsArrayBuffer !== bIsArrayBuffer) return false;
    if (aIsArrayBuffer || bIsArrayBuffer) {
        if ($a07b6be57820a7ee$exports(a) !== $a07b6be57820a7ee$exports(b)) return false;
        return typeof Uint8Array === "function" && $84bfec4afcb34865$var$internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
    }
    var aIsSAB = $f4f6715b36b8d179$exports(a);
    var bIsSAB = $f4f6715b36b8d179$exports(b);
    if (aIsSAB !== bIsSAB) return false;
    if (aIsSAB || bIsSAB) {
        if ($84bfec4afcb34865$var$sabByteLength(a) !== $84bfec4afcb34865$var$sabByteLength(b)) return false;
        return typeof Uint8Array === "function" && $84bfec4afcb34865$var$internalDeepEqual(new Uint8Array(a), new Uint8Array(b), opts, channel);
    }
    if (typeof a !== typeof b) return false;
    var ka = $ed01ea1e639915fb$exports(a);
    var kb = $ed01ea1e639915fb$exports(b);
    // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) return false;
    // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort();
    // ~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
         // eslint-disable-line eqeqeq
    }
    // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$84bfec4afcb34865$var$internalDeepEqual(a[key], b[key], opts, channel)) return false;
    }
    var aCollection = $0b17ef6b120a9bcf$exports(a);
    var bCollection = $0b17ef6b120a9bcf$exports(b);
    if (aCollection !== bCollection) return false;
    if (aCollection === "Set" || bCollection === "Set") return $84bfec4afcb34865$var$setEquiv(a, b, opts, channel);
    if (aCollection === "Map") return $84bfec4afcb34865$var$mapEquiv(a, b, opts, channel);
    return true;
}
$84bfec4afcb34865$exports = function deepEqual(a, b, opts) {
    return $84bfec4afcb34865$var$internalDeepEqual(a, b, opts, $emBdm());
};



var $fgmOP = parcelRequire("fgmOP");




var $fgmOP = parcelRequire("fgmOP");
const $f2c18736b4a6993b$export$788a307bb494601 = (error)=>error?.extensions?.exception;
const $f2c18736b4a6993b$export$9b6f5bcf6474abe5 = (error)=>$f2c18736b4a6993b$export$788a307bb494601(error)?.data;
function $f2c18736b4a6993b$export$1772695dc27e2c41(domainModelError) {
    return !!domainModelError && domainModelError.name === "DomainModelError";
}
const $f2c18736b4a6993b$export$9498e69f47ffab36 = (error)=>$f2c18736b4a6993b$export$1772695dc27e2c41($f2c18736b4a6993b$export$9b6f5bcf6474abe5(error)) ? $f2c18736b4a6993b$export$9b6f5bcf6474abe5(error) : undefined;
function $f2c18736b4a6993b$export$a7cbe72d7c4012af(error) {
    const serverError = error;
    return !!serverError && !!serverError.response && !!serverError.result && !!serverError.statusCode;
}
function $f2c18736b4a6993b$export$24aa3b16ef8ca682(error) {
    const serverParseError = error;
    return !!serverParseError && !!serverParseError.response && !!serverParseError.bodyText && !!serverParseError.statusCode;
}




var $fgmOP = parcelRequire("fgmOP");

const $b5055c1b5d5fd445$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Errors", "INFO");
const $b5055c1b5d5fd445$var$defaultErrorsState = [
    {},
    (key)=>{
        $b5055c1b5d5fd445$var$log.info("setErrorsState default", key);
    }
];
const $b5055c1b5d5fd445$export$3c4f182251610258 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createContext($b5055c1b5d5fd445$var$defaultErrorsState);
const $b5055c1b5d5fd445$export$1ac37773422302f2 = (props)=>{
    const errorsState = (0, $fgmOP.useState)({});
    const [errors] = errorsState;
    $b5055c1b5d5fd445$var$log.debug("render", errors);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($b5055c1b5d5fd445$export$3c4f182251610258.Provider, {
        value: errorsState,
        children: props.children
    });
};



const $427c08048922fa16$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useErrors", "INFO");
const $427c08048922fa16$export$15c3ee8705e5fe1c = (errors)=>(errorKey)=>{
        return errors[`${errorKey}`];
    };
function $427c08048922fa16$export$44b6c4ccb6ebc82e() {
    const errorsState = (0, $fgmOP.useContext)((0, $b5055c1b5d5fd445$export$3c4f182251610258));
    const [errors, setErrors] = errorsState;
    const putError = (key, message)=>{
        $427c08048922fa16$var$log.debug(`Put error '${key}': ${message}`);
        setErrors((errors)=>({
                ...errors,
                [`${key}`]: message
            }));
    };
    const findError = (errorKey)=>{
        const errorValue = $427c08048922fa16$export$15c3ee8705e5fe1c(errors)(errorKey);
        errorValue ? $427c08048922fa16$var$log.debug(`Found error '${errorKey}': ${errorValue}`) : $427c08048922fa16$var$log.debug(`No error '${errorKey}'`);
        return errorValue;
    };
    const clearError = (key)=>{
        $427c08048922fa16$var$log.debug(`Clear error '${key}'`);
        setErrors((errors)=>{
            const cleanedValue = {
                ...errors
            };
            cleanedValue && delete cleanedValue[`${key}`];
            return cleanedValue;
        });
    };
    const clearErrors = ()=>{
        $427c08048922fa16$var$log.debug("clearErrors");
        setErrors({});
    };
    /**
   * Gathers all DomainModelErrors (in graphQLErrors) with entity and field data (from the response's GraphQL errors).
   * Creates the errors map of error messages, where the keys are a combination of the Entity and Field fields:
   *  - "errors.<entity_without_DTO_suffix>.<field> = <error_message>"
   *  ex: errors['COMPANY.NAME'] = "Company name cannot be empty"
   *  ex: errors['CUSTOMER.COMPANY.NAME'] = "Company name cannot be empty"
   *
   * @param graphQLErrors array of GraphQL (mutation) errors
   * @private
   */ const onMutationError = (graphQLErrors)=>{
        $427c08048922fa16$var$log.debug("onMutationError", graphQLErrors);
        graphQLErrors.map((0, $f2c18736b4a6993b$export$9498e69f47ffab36)).filter((0, $f2c18736b4a6993b$export$1772695dc27e2c41)).filter((e)=>e.entity).filter((e)=>e.field).map((e)=>({
                key: e.field,
                // key: `${e.entity.replace(/DTO$/, '')}.${e.field}`,
                message: e.message
            })).forEach(({ key: key, message: message })=>{
            putError(key, message);
        });
    };
    const errorsHook = {
        findError: findError,
        putError: putError,
        clearErrors: clearErrors,
        clearError: clearError,
        onMutationError: onMutationError
    };
    return errorsHook;
}



const $f6ff28847e6675c5$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useFormState", "INFO");
const { isValid: $f6ff28847e6675c5$var$isValid } = (0, $f5d0c2a7498ff49b$exports.period);
const $f6ff28847e6675c5$var$START_DATE_FIELD_ID = "startDate";
const $f6ff28847e6675c5$var$START_TIME_FIELD_ID = "startTime";
const $f6ff28847e6675c5$var$END_DATE_FIELD_ID = "endDate";
const $f6ff28847e6675c5$var$END_TIME_FIELD_ID = "endTime";
function $f6ff28847e6675c5$var$isEntity(entityFieldValue) {
    return entityFieldValue !== null && entityFieldValue !== undefined && !Array.isArray(entityFieldValue) && typeof entityFieldValue === "object";
}
function $f6ff28847e6675c5$var$isString(entityFieldValue) {
    return !!entityFieldValue && typeof entityFieldValue === "string";
}
function $f6ff28847e6675c5$export$232f37f9a0fc548e(obj) {
    return obj;
}
const $f6ff28847e6675c5$export$49dc3e3922f6423e = (entity, fieldName, value)=>{
    const [fieldNamePart, ...fieldNameRest] = fieldName.split(".");
    $f6ff28847e6675c5$var$log.debug("_updatedEntityFieldValue", {
        fieldName: fieldName,
        value: value,
        entity: entity,
        fieldNameRest: fieldNameRest,
        fieldNamePart: fieldNamePart
    });
    if (!fieldNamePart) {
        $f6ff28847e6675c5$var$log.debug("_updatedEntityFieldValue no fieldNamePart", {
            fieldName: fieldName,
            value: value,
            entity: entity,
            fieldNameRest: fieldNameRest,
            fieldNamePart: fieldNamePart
        });
        return value;
    }
    const { isArrayItemField: isArrayItemField, arrayFieldName: arrayFieldName, arrayFieldIndex: arrayFieldIndex } = $f6ff28847e6675c5$export$8cf3649c35bc1711(fieldNamePart);
    const subEntity = isArrayItemField ? (()=>{
        const subEntityArray = [
            ...$f6ff28847e6675c5$export$76a0d1991fe38a5b(arrayFieldName, entity)
        ];
        $f6ff28847e6675c5$var$log.debug("Array item update", {
            isArrayItemField: isArrayItemField,
            arrayFieldName: arrayFieldName,
            arrayFieldIndex: arrayFieldIndex,
            subEntityArray: subEntityArray
        });
        subEntityArray[arrayFieldIndex] = $f6ff28847e6675c5$export$49dc3e3922f6423e($f6ff28847e6675c5$export$76a0d1991fe38a5b(fieldNamePart, entity) || {}, fieldNameRest.join("."), value);
        return subEntityArray;
    })() : fieldNameRest.isEmpty() ? $f6ff28847e6675c5$var$isEntity(value) ? value : Array.isArray(entity[fieldNamePart]) ? Array.isArray(value) ? value : $f6ff28847e6675c5$var$isString(value) ? [
        value
    ] : (()=>{
        $f6ff28847e6675c5$var$log.error("An Array entityField must be of string type in _updatedEntityFieldValue", {
            fieldName: fieldName,
            value: value
        });
        return "Invalid value";
    })() : value : $f6ff28847e6675c5$export$49dc3e3922f6423e({
        ...entity[fieldNamePart]
    }, fieldNameRest.join("."), value);
    return {
        ...entity,
        [`${isArrayItemField ? arrayFieldName : fieldNamePart}`]: subEntity
    };
};
const $f6ff28847e6675c5$var$doCorrectPeriod = (entity, updatedFieldName, setPreference)=>{
    if ((updatedFieldName === $f6ff28847e6675c5$var$START_DATE_FIELD_ID || updatedFieldName === $f6ff28847e6675c5$var$START_TIME_FIELD_ID || updatedFieldName === $f6ff28847e6675c5$var$END_DATE_FIELD_ID || updatedFieldName === $f6ff28847e6675c5$var$END_TIME_FIELD_ID) && !$f6ff28847e6675c5$var$isValid(entity)) {
        let fieldToAdjust;
        let fieldToAdjustValue;
        if (entity.startTime && entity.endTime && entity.startTime > entity.endTime) {
            // If the start date or end date fields was updated
            if (updatedFieldName === $f6ff28847e6675c5$var$START_DATE_FIELD_ID || updatedFieldName === $f6ff28847e6675c5$var$END_DATE_FIELD_ID) {
                fieldToAdjust = updatedFieldName === $f6ff28847e6675c5$var$START_DATE_FIELD_ID ? $f6ff28847e6675c5$var$END_DATE_FIELD_ID : $f6ff28847e6675c5$var$START_DATE_FIELD_ID;
                var date = new Date(entity[updatedFieldName]);
                date.setDate(fieldToAdjust === $f6ff28847e6675c5$var$START_DATE_FIELD_ID ? date.getDate() - 1 : date.getDate() + 1); // Move start or end date one day to make entity valid
                fieldToAdjustValue = date.toISOString().split("T")[0];
            } else {
                fieldToAdjust = updatedFieldName === $f6ff28847e6675c5$var$START_TIME_FIELD_ID ? $f6ff28847e6675c5$var$END_TIME_FIELD_ID : $f6ff28847e6675c5$var$START_TIME_FIELD_ID;
                fieldToAdjustValue = entity[updatedFieldName] || null;
            }
        } else {
            fieldToAdjust = updatedFieldName === $f6ff28847e6675c5$var$START_DATE_FIELD_ID ? $f6ff28847e6675c5$var$END_DATE_FIELD_ID : $f6ff28847e6675c5$var$START_DATE_FIELD_ID;
            fieldToAdjustValue = entity[updatedFieldName] || null;
        }
        setPreference(fieldToAdjust, fieldToAdjustValue);
        return $f6ff28847e6675c5$export$49dc3e3922f6423e(JSON.parse(JSON.stringify(entity)), fieldToAdjust, fieldToAdjustValue);
    } else return entity;
};
const $f6ff28847e6675c5$export$606f11b2eb45ecc6 = (props)=>{
    const { fixedFields: fixedFields, correctPeriod: correctPeriod = true, useUrlParams: useUrlParams, preferenceFieldNames: preferenceFieldNames, validators: validators = {} } = props;
    // const history = useHistory();
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const urlLocation = (0, $dfdceb7c36fce96f$export$45d76561a5302f2b)();
    const urlParams = !useUrlParams ? {} : $e9a95c61c800ecd2$export$311753dab4f1804e(urlLocation.search);
    const { preferences: preferences, setPreference: setPreference } = (0, $7059d4d5f1933e7a$export$bbd7d970555e2952)(preferenceFieldNames);
    const composedInitialEntity = $f6ff28847e6675c5$export$afd2419e625d20a6({
        initialEntity: props.initialEntity,
        preferences: preferences,
        urlParams: urlParams,
        fixedFields: fixedFields
    });
    const [initialEntity, setInitialEntity] = (0, $fgmOP.useState)(composedInitialEntity);
    const [entity, setEntity] = (0, $fgmOP.useState)(initialEntity);
    $f6ff28847e6675c5$var$log.debug("render", {
        props: props,
        entity: entity,
        initialEntity: initialEntity
    });
    (0, $fgmOP.useEffect)(()=>{
        clearErrors();
    }, []);
    (0, $fgmOP.useEffect)(()=>{
        if (useUrlParams) {
            $f6ff28847e6675c5$var$log.debug("updating location parameters with entity fields", entity);
            navigate($e9a95c61c800ecd2$export$3da6096fbfb33018(urlLocation.pathname, entity, $f6ff28847e6675c5$export$df163c189cb34324({
                preferences: preferences,
                fixedFields: fixedFields
            })), {
                replace: true
            });
        }
    }, [
        entity
    ]);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($84bfec4afcb34865$exports)))(initialEntity, composedInitialEntity)) {
        $f6ff28847e6675c5$var$log.debug("updating initialEntity due to changes on formStateOptions", {
            initialEntity: initialEntity,
            composedInitialEntity: composedInitialEntity
        });
        setInitialEntity(composedInitialEntity);
        setEntity(composedInitialEntity);
    }
    const [isEditing, setIsEditing] = (0, $fgmOP.useState)(props.isEditing);
    // const [isDirty, setIsDirty] = useState(false);
    const { putError: putError, findError: findError, clearError: clearError, clearErrors: clearErrors } = (0, $427c08048922fa16$export$44b6c4ccb6ebc82e)();
    const onCancel = ()=>{
        setEntity(initialEntity);
        setIsEditing(false);
        // setIsDirty(false);
        clearErrors();
    };
    const onSaved = (entity)=>{
        setEntity(entity);
        setIsEditing(false);
    // setIsDirty(false);
    };
    const onEdit = ()=>setIsEditing(true);
    const onChange = (fieldName)=>(newValue)=>{
            const value = newValue === "" ? null : newValue;
            $f6ff28847e6675c5$var$log.debug("onChange", fieldName, value);
            clearError(fieldName);
            setEntity((entity)=>{
                let updatedEntity = $f6ff28847e6675c5$export$49dc3e3922f6423e(JSON.parse(JSON.stringify(entity)), fieldName, value);
                updatedEntity = !correctPeriod ? updatedEntity : $f6ff28847e6675c5$var$doCorrectPeriod(updatedEntity, fieldName, setPreference);
                return updatedEntity;
            });
            // setIsDirty(true);
            setPreference(fieldName, value);
        };
    function entityAs() {
        return entity;
    }
    const validate = ()=>{
        clearErrors();
        let isValid = true;
        Object.keys(validators).forEach((fieldId)=>{
            let fieldValidators = validators[fieldId];
            const field = entity[fieldId];
            $f6ff28847e6675c5$var$log.debug("validating", {
                entity: entity,
                fieldValidators: fieldValidators,
                fieldId: fieldId,
                field: field
            });
            if (!Array.isArray(fieldValidators)) fieldValidators = [
                fieldValidators
            ];
            fieldValidators.forEach(({ onValidate: onValidate, regex: regex, error: error })=>{
                const validatorFn = onValidate ? onValidate : field != undefined && regex?.test.bind(regex);
                if (validatorFn && !validatorFn(field)) {
                    isValid = false;
                    putError(fieldId, error);
                }
            });
        });
        return isValid;
    };
    return {
        initialEntity: initialEntity,
        entity: entity,
        entityAs: entityAs,
        subEntityAt: (fieldPath)=>$f6ff28847e6675c5$export$76a0d1991fe38a5b(fieldPath, entity),
        isEditing: isEditing,
        isCreating: initialEntity?.id === null,
        onSaved: onSaved,
        onCancel: onCancel,
        onEdit: onEdit,
        onChange: onChange,
        findError: findError,
        putError: putError,
        clearErrors: clearErrors,
        validate: validate
    };
};
const $f6ff28847e6675c5$export$afd2419e625d20a6 = ({ initialEntity: initialEntity, preferences: preferences, urlParams: urlParams, fixedFields: fixedFields })=>{
    return {
        ...initialEntity,
        ...preferences,
        ...urlParams,
        ...fixedFields
    };
};
const $f6ff28847e6675c5$export$df163c189cb34324 = ({ preferences: preferences = {}, fixedFields: fixedFields = {} })=>{
    const array = Object.keys(preferences).filter((preferenceFieldName)=>preferences[preferenceFieldName] !== null);
    Object.keys(fixedFields).forEach((fieldName)=>{
        array.includes(fieldName) || array.push(fieldName);
    });
    $f6ff28847e6675c5$var$log.debug(`alwaysInUrlParams`, array);
    return array;
};
const $f6ff28847e6675c5$var$arrayFieldSubPathRegexp = /(\w+)\[(\d+)\]$/;
const $f6ff28847e6675c5$export$8cf3649c35bc1711 = (subFieldPath)=>{
    const arrayMatchResult = subFieldPath?.match($f6ff28847e6675c5$var$arrayFieldSubPathRegexp);
    const [isArrayItemField, arrayFieldName, arrayFieldIndex] = arrayMatchResult || [];
    return {
        isArrayItemField: !!isArrayItemField,
        arrayFieldName: !!arrayMatchResult ? arrayFieldName : undefined,
        arrayFieldIndex: !!arrayMatchResult ? parseInt(arrayFieldIndex) : undefined
    };
};
function $f6ff28847e6675c5$export$76a0d1991fe38a5b(fieldPath, entity) {
    const _subEntity = !fieldPath || fieldPath.length == 0 ? entity : fieldPath.split(".").reduce((subEntity, subFieldPath)=>{
        const { isArrayItemField: isArrayItemField, arrayFieldName: arrayFieldName, arrayFieldIndex: arrayFieldIndex } = $f6ff28847e6675c5$export$8cf3649c35bc1711(subFieldPath);
        return subEntity && subFieldPath && (isArrayItemField ? subEntity[arrayFieldName][arrayFieldIndex] : subEntity[subFieldPath]);
    }, entity);
    $f6ff28847e6675c5$var$log.trace("_subEntityAt", {
        fieldPath: fieldPath,
        entity: entity,
        _subEntity: _subEntity
    });
    return _subEntity;
}



// import {Form} from '@telia/styleguide';
// export const FormColumn = Form.FormColumn;
// export default FormColumn;

parcelRequire("fgmOP");
const $6c2490027a2e159e$export$44c04526d4b77f07 = "half";
const $6c2490027a2e159e$export$95dbfef2e4b1962b = "normal";
const $6c2490027a2e159e$export$2e5aae5cf40e4ee1 = "double";
const $6c2490027a2e159e$export$721f69dc1a24ae03 = ({ children: children, size: size = $6c2490027a2e159e$export$2e5aae5cf40e4ee1 })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
        className: `form__column form__column--${size}`,
        children: children
    });
var $6c2490027a2e159e$export$2e2bcd8739ae039 = $6c2490027a2e159e$export$721f69dc1a24ae03;


// import {Form} from '@telia/styleguide';
// export default Form.FormRow;

parcelRequire("fgmOP");
const $bf812ce6eef3f2fe$export$b534bc812df080fd = ({ children: children })=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
        className: "form__row",
        children: children
    });
};
var $bf812ce6eef3f2fe$export$2e2bcd8739ae039 = $bf812ce6eef3f2fe$export$b534bc812df080fd;





parcelRequire("fgmOP");



var $4QBiq = parcelRequire("4QBiq");

var $c30H9 = parcelRequire("c30H9");

var $ksWM4 = parcelRequire("ksWM4");

var $87bf0 = parcelRequire("87bf0");

var $4QBiq = parcelRequire("4QBiq");

var $c30H9 = parcelRequire("c30H9");


String.prototype.isEmpty = function() {
    return !this.length;
};
String.prototype.capitalize = function() {
    return this[0] !== undefined ? this[0].toUpperCase() + this.slice(1) : this;
};
String.prototype.equalsIgnoreCase = function(other) {
    return !!other && other.toUpperCase && this.toUpperCase() === other.toUpperCase();
};
String.prototype.before = function(search) {
    const index = this.indexOf(search);
    return index < 0 ? this : this.substring(0, index);
};
Array.prototype.isEmpty = function() {
    return !this.length;
};
Array.prototype.includes = function(arg) {
    return this.indexOf(arg) > -1;
};
Array.prototype.clone = function() {
    return this.slice();
};
Array.prototype.removeIndex = function(index) {
    this.splice(index, 1);
    return this;
};
Array.prototype.remove = function(item) {
    const i = this.indexOf(item);
    if (i !== -1) this.removeIndex(i);
    return this;
};
Array.prototype.cloneExcluding = function(...items) {
    const clone = this.clone();
    items.forEach((item)=>clone.remove(item));
    return clone;
};
Array.prototype.cloneIncluding = function(...items) {
    const clone = this.clone();
    items.forEach((item)=>clone.includes(item) || clone.push(item));
    return clone;
};
Array.prototype.cloneAfter = function(item) {
    const i = this.indexOf(item);
    return i === -1 ? [] : this.clone().splice(i + 1, this.length);
};
Array.prototype.cloneToggle = function(item) {
    let clone = this.slice();
    clone.includes(item) ? clone.remove(item) : clone.push(item);
    return clone;
};
Array.prototype.flatMap = function(lambda) {
    return [].concat.apply([], this.map(lambda));
};
Array.prototype.head = function() {
    return this[0];
};
Array.range = (start, end)=>Array.from({
        length: end - start + 1
    }, (v, k)=>k + start);
function $752d58955143e4d5$export$b1dee6b72881b450(obj, key) {
    return obj[key];
}
function $752d58955143e4d5$export$1aec36f8cabff997(obj) {
    if (obj === null || obj === undefined) return {};
    const keysOfObject = Object.keys(obj);
    let clone = keysOfObject.reduce((clone, key)=>{
        const prop = $752d58955143e4d5$export$b1dee6b72881b450(obj, key);
        if (prop !== null && prop !== undefined) clone[key] = obj[key];
        return clone;
    }, {});
    return clone;
}
function $752d58955143e4d5$export$b0b7c18d817c65d6(obj, deepness) {
    if (obj === null || obj === undefined || typeof obj === "string" || typeof obj === "number") return obj;
    if (obj instanceof Function) return "Function";
    if (Array.isArray(obj)) return "Array";
    //  last recursion deepness
    if (deepness === 0) {
        if (obj instanceof Error) return "Error: " + obj.message;
        return "Object";
    }
    let clone = Object.keys(obj).reduce((clone, key)=>{
        clone[key] = $752d58955143e4d5$export$b0b7c18d817c65d6(obj[key], deepness && deepness - 1);
        return clone;
    }, {});
    return clone;
}
function $752d58955143e4d5$export$eeccfdd6f27cf302(protocol) {
    return !(protocol === (0, $172ff61ce62d7cbc$export$a673edc7510eb870).SMPP || !protocol);
}


const $44330e49f7a25291$export$2e59fa295abca125 = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
const $44330e49f7a25291$export$e3094c113c143a4e = $44330e49f7a25291$export$2e59fa295abca125.map((monthName, i)=>({
        id: `${i + 1}`.padStart(2, "0"),
        name: monthName
    }));
const $44330e49f7a25291$export$6fda41c7fb23acf9 = Array.range(2018, new Date().getFullYear());
const $44330e49f7a25291$export$1e3dd4b9807b65f0 = (startYear)=>Array.range(startYear, new Date().getFullYear());
const $44330e49f7a25291$export$962cc19e973b4713 = (month)=>{
    let monthNumber;
    if (typeof month === "number") monthNumber = month;
    else if (month instanceof Date) monthNumber = month.getMonth() + 1;
    else {
        monthNumber = parseInt(month);
        if (isNaN(monthNumber)) monthNumber = (0, $4QBiq.i18n).monthNames.indexOf(month) % 12 + 1;
    }
    return monthNumber.toString().padStart(2, "0");
};
const $44330e49f7a25291$export$840c1aaee078ff0d = (yyyyMm)=>yyyyMm.toString().substring(0, 4);
const $44330e49f7a25291$export$157ce98fe402938e = (yyyyMm)=>yyyyMm.toString().substring(4, 6);
const $44330e49f7a25291$export$b1d7f181ed71ff8 = (year, month)=>`${year}${$44330e49f7a25291$export$962cc19e973b4713(month)}`;
const $44330e49f7a25291$export$34be91b8dc87df38 = (humanMonthYear)=>{
    const [monthName, year] = humanMonthYear.split(" ");
    const mm = monthName !== undefined ? $44330e49f7a25291$export$962cc19e973b4713(monthName) : "00";
    const yyyy = year !== undefined ? year : "0000";
    return $44330e49f7a25291$export$b1d7f181ed71ff8(yyyy, mm);
};
const $44330e49f7a25291$export$f6febe6805c8f35c = ()=>{
    const date = new Date(); //  today
    date.setDate(0); //  last day of previous month;
    return date;
};
const $44330e49f7a25291$var$iso8601DurationRegex = /^(-?)P(?=\d|T\d)(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)([DW]))?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+(?:[.,]\d+)?)S)?)?$/;
const $44330e49f7a25291$export$e28555c1bee34381 = (duration)=>!!duration.match($44330e49f7a25291$var$iso8601DurationRegex);
const $44330e49f7a25291$export$61e8d24c061dc344 = (mm)=>{
    const monthIndex = parseInt(mm.toString());
    const nextMonthIndex = monthIndex === 12 ? 1 : monthIndex + 1;
    return nextMonthIndex.toString().padStart(2, "0");
};
const $44330e49f7a25291$export$135d9393c9dc0c8c = (startDate, groupPeriod)=>{
    switch(groupPeriod){
        case (0, $172ff61ce62d7cbc$export$3bee95f236788aea).QUARTER:
            return `${startDate.substring(0, 7)} - ${(0, (/*@__PURE__*/$parcel$interopDefault($c30H9)))(startDate).add(2, "months").format("YYYY-MM")}`;
        case (0, $172ff61ce62d7cbc$export$3bee95f236788aea).MONTH:
            return startDate.substring(0, 7); // yyyy-mm-dd -> yyyy-mm
        case (0, $172ff61ce62d7cbc$export$3bee95f236788aea).WEEK:
            return `${(0, (/*@__PURE__*/$parcel$interopDefault($c30H9)))(startDate).format("YYYY-MM-DD")} - ${(0, (/*@__PURE__*/$parcel$interopDefault($c30H9)))(startDate).add(6, "days").format("YYYY-MM-DD")}`;
        case (0, $172ff61ce62d7cbc$export$3bee95f236788aea).DAY:
        default:
            return (0, (/*@__PURE__*/$parcel$interopDefault($c30H9)))(startDate).format("YYYY-MM-DD");
    }
};
const $44330e49f7a25291$export$8b581d738a0a6b09 = (date)=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($c30H9)))(date).isSameOrAfter((0, (/*@__PURE__*/$parcel$interopDefault($c30H9)))(), "day");
};


// @ts-ignore
(0, (/*@__PURE__*/$parcel$interopDefault($ksWM4)))((0, (/*@__PURE__*/$parcel$interopDefault($c30H9)))); // configure the duration formatter plugin
const $f49b53e246cd14b8$var$DATE_FORMAT = "yyyy-mm-dd";
const $f49b53e246cd14b8$var$DATE_TIME_FORMAT = "yyyy-mm-dd HH:MM:ss";
const $f49b53e246cd14b8$var$DATE_TIME_MS_FORMAT = "yyyy-mm-dd HH:MM:ss.l";
const $f49b53e246cd14b8$var$dateFormat = (date, format, useUTC)=>{
    try {
        if (!date) throw new Error("Empty date");
        return (0, (/*@__PURE__*/$parcel$interopDefault($4QBiq)))(date, format, useUTC);
    } catch (e) {
        return "Invalid date";
    }
};
const $f49b53e246cd14b8$export$324d90190a8b822a = (date)=>$f49b53e246cd14b8$var$dateFormat(date, $f49b53e246cd14b8$var$DATE_FORMAT);
const $f49b53e246cd14b8$export$3a17bddce263fba0 = (date, useUTC)=>$f49b53e246cd14b8$var$dateFormat(date, $f49b53e246cd14b8$var$DATE_TIME_FORMAT, useUTC);
const $f49b53e246cd14b8$export$81385eeb9bf7b92d = (date, useUTC)=>$f49b53e246cd14b8$var$dateFormat(date, $f49b53e246cd14b8$var$DATE_TIME_MS_FORMAT, useUTC);
const $f49b53e246cd14b8$export$962cc19e973b4713 = (date)=>(0, (/*@__PURE__*/$parcel$interopDefault($4QBiq)))(date, "mm");
const $f49b53e246cd14b8$export$af5de1609f06c8e6 = (date)=>(0, (/*@__PURE__*/$parcel$interopDefault($4QBiq)))(date, "mmmm");
const $f49b53e246cd14b8$export$9fae2c2cfc9a30bb = (mm)=>(0, $4QBiq.i18n).monthNames[Number(mm) - 1] || "Invalid Month: " + mm;
const $f49b53e246cd14b8$export$264d20f74979a26a = (yyyymm)=>$f49b53e246cd14b8$export$9fae2c2cfc9a30bb(yyyymm.toString().substring(4, 6)) + " " + yyyymm.toString().substring(0, 4);
const $f49b53e246cd14b8$export$78a48a3d1e5dbe89 = (number, hasTrailingZeros = true)=>{
    if (number !== undefined && (hasTrailingZeros || $f49b53e246cd14b8$export$c5a320298cd10607(number))) return (0, (/*@__PURE__*/$parcel$interopDefault($87bf0)))(number).format("0,0.00").replace(/,/g, " ").replace(".", ",");
    else return $f49b53e246cd14b8$export$32744b5b3bba4764(number);
};
const $f49b53e246cd14b8$export$32744b5b3bba4764 = (number)=>number === undefined ? "" : (0, (/*@__PURE__*/$parcel$interopDefault($87bf0)))(number).format("0,0").replace(/,/g, " ");
const $f49b53e246cd14b8$export$1f34108aa9eb96ab = (duration)=>$f49b53e246cd14b8$var$isString(duration) && !(0, $44330e49f7a25291$export$e28555c1bee34381)(duration) ? "Invalid duration" : (0, (/*@__PURE__*/$parcel$interopDefault($c30H9))).duration(duration).format("y [y] w [w] d [d] h [h] m [m] s [s] S [ms]", {
        trim: "both"
    });
const $f49b53e246cd14b8$export$399a53103314d9bd = (value, maxUnits = 2)=>{
    const fullDuration = $f49b53e246cd14b8$export$1f34108aa9eb96ab(value);
    const splitDuration = fullDuration.split(" ");
    const maxSpaces = maxUnits * 2 - 1;
    return fullDuration === "Invalid duration" ? "Invalid" : splitDuration.length > maxSpaces + 1 ? splitDuration.filter((_, i)=>i <= maxSpaces).join(" ").concat("...") : fullDuration;
};
const $f49b53e246cd14b8$var$integerWithDash = (number, hasTrailingDash)=>hasTrailingDash ? $f49b53e246cd14b8$export$32744b5b3bba4764(number) + ",-" : $f49b53e246cd14b8$export$32744b5b3bba4764(number);
const $f49b53e246cd14b8$export$f4f21ed02b0ddb8f = (number, symbol = "\u20AC$\xa3", showDecimals, hasTrailingDash)=>{
    const value = (showDecimals !== undefined ? showDecimals : $f49b53e246cd14b8$export$c5a320298cd10607(number)) && (!hasTrailingDash || $f49b53e246cd14b8$export$c5a320298cd10607(number)) ? $f49b53e246cd14b8$export$78a48a3d1e5dbe89(number) : $f49b53e246cd14b8$var$integerWithDash(number, hasTrailingDash);
    return `${symbol} ${value}`;
};
const $f49b53e246cd14b8$export$c5a320298cd10607 = (number)=>number !== undefined && number % 1 !== 0;
const $f49b53e246cd14b8$export$e7d368fcf53f1001 = (str)=>{
    return str && (str?.slice(-1).toLowerCase() === "s" ? str + "'" : str + "'s");
};
const $f49b53e246cd14b8$var$format = {
    date: $f49b53e246cd14b8$export$324d90190a8b822a,
    dateTime: $f49b53e246cd14b8$export$3a17bddce263fba0,
    dateTimeMs: $f49b53e246cd14b8$export$81385eeb9bf7b92d,
    month: $f49b53e246cd14b8$export$af5de1609f06c8e6,
    monthMm: $f49b53e246cd14b8$export$962cc19e973b4713,
    monthName: $f49b53e246cd14b8$export$9fae2c2cfc9a30bb,
    yearMonth: $f49b53e246cd14b8$export$264d20f74979a26a,
    decimal: $f49b53e246cd14b8$export$78a48a3d1e5dbe89,
    integer: $f49b53e246cd14b8$export$32744b5b3bba4764,
    duration: $f49b53e246cd14b8$export$1f34108aa9eb96ab,
    durationCompact: $f49b53e246cd14b8$export$399a53103314d9bd,
    hasDecimals: $f49b53e246cd14b8$export$c5a320298cd10607,
    currency: $f49b53e246cd14b8$export$f4f21ed02b0ddb8f,
    possessiveForm: $f49b53e246cd14b8$export$e7d368fcf53f1001
};
var $f49b53e246cd14b8$export$2e2bcd8739ae039 = $f49b53e246cd14b8$var$format;
const $f49b53e246cd14b8$export$58a7c28088f31fdb = (c)=>`${c.id} ${c.name ? `- ${c.name}` : ""}`;
function $f49b53e246cd14b8$var$isString(value) {
    return typeof value === "string" || value instanceof String;
}





var $f3667d8dcb757ea0$export$2e2bcd8739ae039 = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;


var $b65cd9bf4035c1b1$export$2e2bcd8739ae039 = /[\0-\x1F\x7F-\x9F]/;


var $33b50a5db625281c$export$2e2bcd8739ae039 = /[\xAD\u0600-\u0605\u061C\u06DD\u070F\u0890\u0891\u08E2\u180E\u200B-\u200F\u202A-\u202E\u2060-\u2064\u2066-\u206F\uFEFF\uFFF9-\uFFFB]|\uD804[\uDCBD\uDCCD]|\uD80D[\uDC30-\uDC3F]|\uD82F[\uDCA0-\uDCA3]|\uD834[\uDD73-\uDD7A]|\uDB40[\uDC01\uDC20-\uDC7F]/;


var $9cb60247761ca567$export$2e2bcd8739ae039 = /[!-#%-\*,-\/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD803[\uDEAD\uDF55-\uDF59\uDF86-\uDF89]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC8\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5A\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDEB9\uDF3C-\uDF3E]|\uD806[\uDC3B\uDD44-\uDD46\uDDE2\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2\uDF00-\uDF09]|\uD807[\uDC41-\uDC45\uDC70\uDC71\uDEF7\uDEF8\uDF43-\uDF4F\uDFFF]|\uD809[\uDC70-\uDC74]|\uD80B[\uDFF1\uDFF2]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD81B[\uDE97-\uDE9A\uDFE2]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;


var $56c6919cd9bec901$export$2e2bcd8739ae039 = /[\$\+<->\^`\|~\xA2-\xA6\xA8\xA9\xAC\xAE-\xB1\xB4\xB8\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u02FF\u0375\u0384\u0385\u03F6\u0482\u058D-\u058F\u0606-\u0608\u060B\u060E\u060F\u06DE\u06E9\u06FD\u06FE\u07F6\u07FE\u07FF\u0888\u09F2\u09F3\u09FA\u09FB\u0AF1\u0B70\u0BF3-\u0BFA\u0C7F\u0D4F\u0D79\u0E3F\u0F01-\u0F03\u0F13\u0F15-\u0F17\u0F1A-\u0F1F\u0F34\u0F36\u0F38\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE\u0FCF\u0FD5-\u0FD8\u109E\u109F\u1390-\u1399\u166D\u17DB\u1940\u19DE-\u19FF\u1B61-\u1B6A\u1B74-\u1B7C\u1FBD\u1FBF-\u1FC1\u1FCD-\u1FCF\u1FDD-\u1FDF\u1FED-\u1FEF\u1FFD\u1FFE\u2044\u2052\u207A-\u207C\u208A-\u208C\u20A0-\u20C0\u2100\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A\u218B\u2190-\u2307\u230C-\u2328\u232B-\u2426\u2440-\u244A\u249C-\u24E9\u2500-\u2767\u2794-\u27C4\u27C7-\u27E5\u27F0-\u2982\u2999-\u29D7\u29DC-\u29FB\u29FE-\u2B73\u2B76-\u2B95\u2B97-\u2BFF\u2CE5-\u2CEA\u2E50\u2E51\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u2FFF\u3004\u3012\u3013\u3020\u3036\u3037\u303E\u303F\u309B\u309C\u3190\u3191\u3196-\u319F\u31C0-\u31E3\u31EF\u3200-\u321E\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA490-\uA4C6\uA700-\uA716\uA720\uA721\uA789\uA78A\uA828-\uA82B\uA836-\uA839\uAA77-\uAA79\uAB5B\uAB6A\uAB6B\uFB29\uFBB2-\uFBC2\uFD40-\uFD4F\uFDCF\uFDFC-\uFDFF\uFE62\uFE64-\uFE66\uFE69\uFF04\uFF0B\uFF1C-\uFF1E\uFF3E\uFF40\uFF5C\uFF5E\uFFE0-\uFFE6\uFFE8-\uFFEE\uFFFC\uFFFD]|\uD800[\uDD37-\uDD3F\uDD79-\uDD89\uDD8C-\uDD8E\uDD90-\uDD9C\uDDA0\uDDD0-\uDDFC]|\uD802[\uDC77\uDC78\uDEC8]|\uD805\uDF3F|\uD807[\uDFD5-\uDFF1]|\uD81A[\uDF3C-\uDF3F\uDF45]|\uD82F\uDC9C|\uD833[\uDF50-\uDFC3]|\uD834[\uDC00-\uDCF5\uDD00-\uDD26\uDD29-\uDD64\uDD6A-\uDD6C\uDD83\uDD84\uDD8C-\uDDA9\uDDAE-\uDDEA\uDE00-\uDE41\uDE45\uDF00-\uDF56]|\uD835[\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3]|\uD836[\uDC00-\uDDFF\uDE37-\uDE3A\uDE6D-\uDE74\uDE76-\uDE83\uDE85\uDE86]|\uD838[\uDD4F\uDEFF]|\uD83B[\uDCAC\uDCB0\uDD2E\uDEF0\uDEF1]|\uD83C[\uDC00-\uDC2B\uDC30-\uDC93\uDCA0-\uDCAE\uDCB1-\uDCBF\uDCC1-\uDCCF\uDCD1-\uDCF5\uDD0D-\uDDAD\uDDE6-\uDE02\uDE10-\uDE3B\uDE40-\uDE48\uDE50\uDE51\uDE60-\uDE65\uDF00-\uDFFF]|\uD83D[\uDC00-\uDED7\uDEDC-\uDEEC\uDEF0-\uDEFC\uDF00-\uDF76\uDF7B-\uDFD9\uDFE0-\uDFEB\uDFF0]|\uD83E[\uDC00-\uDC0B\uDC10-\uDC47\uDC50-\uDC59\uDC60-\uDC87\uDC90-\uDCAD\uDCB0\uDCB1\uDD00-\uDE53\uDE60-\uDE6D\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC5\uDECE-\uDEDB\uDEE0-\uDEE8\uDEF0-\uDEF8\uDF00-\uDF92\uDF94-\uDFCA]/;


var $2f9f89a49f6c0680$export$2e2bcd8739ae039 = /[ \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000]/;




function $db9428dd6f13d9bc$export$2e2bcd8739ae039(opts) {
    const re = {};
    opts = opts || {};
    re.src_Any = (0, $f3667d8dcb757ea0$export$2e2bcd8739ae039).source;
    re.src_Cc = (0, $b65cd9bf4035c1b1$export$2e2bcd8739ae039).source;
    re.src_Z = (0, $2f9f89a49f6c0680$export$2e2bcd8739ae039).source;
    re.src_P = (0, $9cb60247761ca567$export$2e2bcd8739ae039).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join("|");
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join("|");
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    const text_separators = "[><\uFF5C]";
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = "(?:(?!" + text_separators + "|" + re.src_ZPCc + ")" + re.src_Any + ")";
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    re.src_ip4 = "(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)";
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = "(?:(?:(?!" + re.src_ZCc + "|[@/\\[\\]()]).)+@)?";
    re.src_port = "(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?";
    re.src_host_terminator = "(?=$|" + text_separators + "|" + re.src_ZPCc + ")" + "(?!" + (opts["---"] ? "-(?!--)|" : "-|") + "_|:\\d|\\.-|\\.(?!$|" + re.src_ZPCc + "))";
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + "|" + text_separators + "|[()[\\]{}.,\"'?!\\-;]).|" + "\\[(?:(?!" + re.src_ZCc + "|\\]).)*\\]|" + "\\((?:(?!" + re.src_ZCc + "|[)]).)*\\)|" + "\\{(?:(?!" + re.src_ZCc + "|[}]).)*\\}|" + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + // allow `I'm_king` if no pair found
    "\\'(?=" + re.src_pseudo_letter + "|[-])|" + // google has many dots in "google search" links (#66, #81).
    // github has ... in commit range links,
    // Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // - params separator
    // until more examples found.
    "\\.{2,}[a-zA-Z0-9%/&]|" + "\\.(?!" + re.src_ZCc + "|[.]|$)|" + (opts["---"] ? "\\-(?!--(?:[^-]|$))(?:-*)|" // `---` => long dash, terminate
     : "\\-+|") + // allow `,,,` in paths
    ",(?!" + re.src_ZCc + "|$)|" + // allow `;` if not followed by space-like char
    ";(?!" + re.src_ZCc + "|$)|" + // allow `!!!` in paths, but not at the end
    "\\!+(?!" + re.src_ZCc + "|[!]|$)|" + "\\?(?!" + re.src_ZCc + "|[?]|$)" + ")+" + "|\\/" + ")?";
    // Allow anything in markdown spec, forbid quote (") at the first position
    // because emails enclosed in quotes are far more common
    re.src_email_name = '[\\-;:&=\\+\\$,\\.a-zA-Z0-9_][\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]*';
    re.src_xn = "xn--[a-z0-9\\-]{1,59}";
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    "(?:" + re.src_xn + "|" + re.src_pseudo_letter + "{1,63}" + ")";
    re.src_domain = "(?:" + re.src_xn + "|" + "(?:" + re.src_pseudo_letter + ")" + "|" + "(?:" + re.src_pseudo_letter + "(?:-|" + re.src_pseudo_letter + "){0,61}" + re.src_pseudo_letter + ")" + ")";
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ")\\.)*" + re.src_domain /* _root */  + ")" + ")";
    re.tpl_host_fuzzy = "(?:" + re.src_ip4 + "|" + "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))" + ")";
    re.tpl_host_no_ip_fuzzy = "(?:(?:(?:" + re.src_domain + ")\\.)+(?:%TLDS%))";
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    //
    // Main rules
    //
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = "localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:" + re.src_ZPCc + "|>|$))";
    re.tpl_email_fuzzy = "(^|" + text_separators + '|"|\\(|' + re.src_ZCc + ")" + "(" + re.src_email_name + "@" + re.tpl_host_fuzzy_strict + ")";
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_fuzzy_strict + re.src_path + ")";
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    "(^|(?![.:/\\-_@])(?:[$+<=>^`|\uFF5C]|" + re.src_ZPCc + "))" + "((?![$+<=>^`|\uFF5C])" + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ")";
    return re;
}


//
// Helpers
//
// Merge objects
//
function $c5908352fe9d0248$var$assign(obj /* from1, from2, from3, ... */ ) {
    const sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $c5908352fe9d0248$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $c5908352fe9d0248$var$isString(obj) {
    return $c5908352fe9d0248$var$_class(obj) === "[object String]";
}
function $c5908352fe9d0248$var$isObject(obj) {
    return $c5908352fe9d0248$var$_class(obj) === "[object Object]";
}
function $c5908352fe9d0248$var$isRegExp(obj) {
    return $c5908352fe9d0248$var$_class(obj) === "[object RegExp]";
}
function $c5908352fe9d0248$var$isFunction(obj) {
    return $c5908352fe9d0248$var$_class(obj) === "[object Function]";
}
function $c5908352fe9d0248$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}
//
const $c5908352fe9d0248$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $c5908352fe9d0248$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        /* eslint-disable-next-line no-prototype-builtins */ return acc || $c5908352fe9d0248$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
const $c5908352fe9d0248$var$defaultSchemas = {
    "http:": {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp("^\\/\\/" + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, "i");
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    "https:": "http:",
    "ftp:": "http:",
    "//": {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp("^" + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            "(?:localhost|(?:(?:" + self.re.src_domain + ")\\.)+" + self.re.src_domain_root + ")" + self.re.src_port + self.re.src_host_terminator + self.re.src_path, "i");
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ":") return 0;
                if (pos >= 3 && text[pos - 3] === "/") return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    "mailto:": {
        validate: function(text, pos, self) {
            const tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp("^" + self.re.src_email_name + "@" + self.re.src_host_strict, "i");
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
// RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
/* eslint-disable-next-line max-len */ const $c5908352fe9d0248$var$tlds_2ch_src_re = "a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]";
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
const $c5908352fe9d0248$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split("|");
function $c5908352fe9d0248$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = "";
}
function $c5908352fe9d0248$var$createValidator(re) {
    return function(text, pos) {
        const tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $c5908352fe9d0248$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}
// Schemas compiler. Build regexps.
//
function $c5908352fe9d0248$var$compile(self) {
    // Load & clone RE patterns.
    const re = self.re = (0, $db9428dd6f13d9bc$export$2e2bcd8739ae039)(self.__opts__);
    // Define dynamic patterns
    const tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($c5908352fe9d0248$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join("|");
    function untpl(tpl) {
        return tpl.replace("%TLDS%", re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), "i");
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), "i");
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), "i");
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), "i");
    //
    // Compile each schema
    //
    const aliases = [];
    self.__compiled__ = {} // Reset compiled data
    ;
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        const val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        const compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($c5908352fe9d0248$var$isObject(val)) {
            if ($c5908352fe9d0248$var$isRegExp(val.validate)) compiled.validate = $c5908352fe9d0248$var$createValidator(val.validate);
            else if ($c5908352fe9d0248$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($c5908352fe9d0248$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $c5908352fe9d0248$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($c5908352fe9d0248$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[""] = {
        validate: null,
        normalize: $c5908352fe9d0248$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    const slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($c5908352fe9d0248$var$escapeRE).join("|");
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "i");
    self.re.schema_search = RegExp("(^|(?!_)(?:[><\uFF5C]|" + re.src_ZPCc + "))(" + slist + ")", "ig");
    self.re.schema_at_start = RegExp("^" + self.re.schema_search.source, "i");
    self.re.pretest = RegExp("(" + self.re.schema_test.source + ")|(" + self.re.host_fuzzy_test.source + ")|@", "i");
    //
    // Cleanup
    //
    $c5908352fe9d0248$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $c5908352fe9d0248$var$Match(self, shift) {
    const start = self.__index__;
    const end = self.__last_index__;
    const text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $c5908352fe9d0248$var$createMatch(self, shift) {
    const match = new $c5908352fe9d0248$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $c5908352fe9d0248$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $c5908352fe9d0248$var$LinkifyIt)) return new $c5908352fe9d0248$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($c5908352fe9d0248$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $c5908352fe9d0248$var$assign({}, $c5908352fe9d0248$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1 // Next scan position
    ;
    this.__schema__ = "";
    this.__text_cache__ = "";
    this.__schemas__ = $c5908352fe9d0248$var$assign({}, $c5908352fe9d0248$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $c5908352fe9d0248$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $c5908352fe9d0248$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $c5908352fe9d0248$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $c5908352fe9d0248$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $c5908352fe9d0248$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $c5908352fe9d0248$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $c5908352fe9d0248$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    let m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__["http:"]) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = "";
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__["mailto:"]) {
        // guess schemaless emails
        at_pos = text.indexOf("@");
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = "mailto:";
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $c5908352fe9d0248$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $c5908352fe9d0248$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $c5908352fe9d0248$var$LinkifyIt.prototype.match = function match(text) {
    const result = [];
    let shift = 0;
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($c5908352fe9d0248$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    let tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($c5908352fe9d0248$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/**
 * LinkifyIt#matchAtStart(text) -> Match|null
 *
 * Returns fully-formed (not fuzzy) link if it starts at the beginning
 * of the string, and null otherwise.
 **/ $c5908352fe9d0248$var$LinkifyIt.prototype.matchAtStart = function matchAtStart(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return null;
    const m = this.re.schema_at_start.exec(text);
    if (!m) return null;
    const len = this.testSchemaAt(text, m[2], m[0].length);
    if (!len) return null;
    this.__schema__ = m[2];
    this.__index__ = m.index + m[1].length;
    this.__last_index__ = m.index + m[0].length + len;
    return $c5908352fe9d0248$var$createMatch(this, 0);
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $c5908352fe9d0248$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $c5908352fe9d0248$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $c5908352fe9d0248$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $c5908352fe9d0248$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = "http://" + match.url;
    if (match.schema === "mailto:" && !/^mailto:/i.test(match.url)) match.url = "mailto:" + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $c5908352fe9d0248$var$LinkifyIt.prototype.onCompile = function onCompile() {};
var $c5908352fe9d0248$export$2e2bcd8739ae039 = $c5908352fe9d0248$var$LinkifyIt;



var $fgmOP = parcelRequire("fgmOP");
const $dedce9a9f060f410$var$linkify = new (0, $c5908352fe9d0248$export$2e2bcd8739ae039)();
const $dedce9a9f060f410$export$319f0c9e72e6e5d2 = (text)=>{
    if (text && text.match && text.match(/(\r\n|\r|\n)/)) {
        const textLines = text.replace(/(?:\r\n|\r)/g, "\n").split("\n");
        return textLines.map((textLine, i)=>textLines.length - 1 !== i ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                children: [
                    textLine,
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("br", {})
                ]
            }, i) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                children: textLine
            }, i));
    }
    return text;
};
const $dedce9a9f060f410$export$cac4d355fa7ba84d = (input)=>{
    const matches = $dedce9a9f060f410$var$linkify.match(input);
    const contentParts = [];
    let lastIndex = 0;
    if (!matches) contentParts.push({
        content: input,
        link: false
    }); // No links found
    else {
        matches.forEach((match)=>{
            if (match.index > lastIndex) contentParts.push({
                content: input.slice(lastIndex, match.index),
                link: false
            });
            contentParts.push({
                content: match.text.replace(/https?:\/\/(www\.)?|www\./g, ""),
                link: match.url
            });
            lastIndex = match.lastIndex;
        });
        if (lastIndex < input.length) contentParts.push({
            content: input.slice(lastIndex),
            link: false
        });
    }
    return contentParts.map((contentPart)=>({
            ...contentPart,
            content: $dedce9a9f060f410$export$319f0c9e72e6e5d2(contentPart.content)
        }));
};




parcelRequire("fgmOP");


const $ef5f892b79fbbbd8$export$f04a61298a47a40f = ({ icon: icon, info: info, onClick: onClick, className: className })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
        onClick: onClick,
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $2edc691f96482cbe$export$f04a61298a47a40f), {
            icon: icon,
            title: info,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("Icon", className)
        })
    });




parcelRequire("fgmOP");



const $c27474ab5ff5382a$export$23da1e9f164f7ea1 = ({ icon: icon, info: info, linkTo: linkTo, className: className })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
        to: linkTo,
        title: info,
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $2edc691f96482cbe$export$f04a61298a47a40f), {
            icon: icon,
            title: info,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("Icon", className)
        })
    });





var $fgmOP = parcelRequire("fgmOP");

let $acf38b6c25932409$var$uniqueId = 0;
const $acf38b6c25932409$export$28c660c63b792dea = (props)=>{
    const [expanded, setExpanded] = (0, $fgmOP.useState)(props.isExpanded);
    const [id] = (0, $fgmOP.useState)($acf38b6c25932409$var$uniqueId++);
    const { children: children, className: className, buttonContent: buttonContent, label: label, text: text } = props;
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("tooltip", {
            "tooltip--show": expanded
        }, className),
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "tooltip__button-container",
                children: [
                    label && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("label", {
                        htmlFor: `tooltip__button-${id}`,
                        children: label
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("button", {
                        type: "button",
                        id: `tooltip__button-${id}`,
                        className: "tooltip__button",
                        "aria-controls": `tooltip__box-${id}`,
                        "aria-expanded": expanded,
                        onClick: (e)=>{
                            setExpanded(!expanded);
                            e.stopPropagation();
                        },
                        onMouseOver: ()=>setExpanded(true),
                        onMouseOut: ()=>setExpanded(false),
                        children: buttonContent || "i"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "tooltip__box",
                id: `tooltip__box-${id}`,
                children: children || text
            })
        ]
    });
};
var $acf38b6c25932409$export$2e2bcd8739ae039 = $acf38b6c25932409$export$28c660c63b792dea;




parcelRequire("fgmOP");


const $1787422a5c5e42e2$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Checkbox");
function $1787422a5c5e42e2$export$d1c5448ba3406145(props) {
    return props.type === (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox;
}
const $1787422a5c5e42e2$export$48513f6b9f8ce62d = (props)=>{
    const { id: id, isDisabled: isDisabled = false, isEditing: isEditing, inputRef: inputRef, label: label, name: name, onChange: onChange, value: value } = props;
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("field__value__wrapper", {
            "field__value__wrapper--unchecked": !isEditing && !value
        }),
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("input", {
                id: id,
                name: name,
                type: "checkbox",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("visuallyHidden", props.valueClassName),
                value: "on",
                onChange: (e)=>{
                    $1787422a5c5e42e2$var$log.debug("input onChange", label);
                    isEditing && onChange && onChange(e.target.checked);
                },
                onClick: (e)=>{
                    $1787422a5c5e42e2$var$log.debug("onClick", e);
                    e.stopPropagation();
                },
                checked: !!value,
                disabled: !isEditing || isDisabled,
                ref: inputRef
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("label", {
                htmlFor: id,
                className: "label",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("svg", {
                        className: "check-box-with-label__svg",
                        width: "20px",
                        height: "20px",
                        viewBox: "0 0 20 20",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("path", {
                                className: "check-box-with-label__frame",
                                d: "M16,19H4c-1.7,0-3-1.4-3-3V4c0-1.7,1.3-3,3-3h12c1.6,0,3,1.3,3,3v12C19,17.6,17.6,19,16,19z"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("path", {
                                className: "check-box-with-label__check-mark",
                                d: "M5,7.7c1.5,2.4,3.1,4.8,4.6,7.3c2.1-3.3,4.3-6.7,6.4-10"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("path", {
                                className: "check-box-with-label__cross",
                                d: "M6,6L14,14M6,14L14,6"
                            })
                        ]
                    }),
                    label
                ]
            })
        ]
    });
};



parcelRequire("fgmOP");

const $4d1e1c54df2c53ab$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("_DurationTip", "INFO");
const $4d1e1c54df2c53ab$export$48c13954988b43bb = (props)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        children: [
            "ISO 8601 duration format:",
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("ul", {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("li", {
                        children: "PT0.5S: 500 milliseconds"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("li", {
                        children: "PT20S: 20 seconds"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("li", {
                        children: "PT1M20S: 1 minute and 20 seconds"
                    })
                ]
            })
        ]
    });




var $fgmOP = parcelRequire("fgmOP");


const $0857d9353dc337e9$export$d5d25c90fc92fce5 = (id, prefix)=>{
    const fullId = prefix ? `${prefix}-${id}` : `${id}`;
    return !fullId.match(/^[A-Za-z]/) ? id : fullId.replace(/[^A-Za-z_\d\-.:]/g, "-");
};


const $712616d38ca865d1$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("MultiCheckbox");
function $712616d38ca865d1$var$isMultiCheckboxOption(option) {
    return typeof option !== "string";
}
function $712616d38ca865d1$export$789791f6749b534e(props) {
    return props.type === (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi;
}
const $712616d38ca865d1$export$52fe8c8ba20f2bea = (props)=>{
    const { isDisabled: isDisabled = false, isEditing: isEditing, onChange: onChange, options: options, value: tmpValue } = props;
    const value = tmpValue === null || tmpValue === undefined ? [] : tmpValue;
    const onChangeMulti = (0, $fgmOP.useCallback)((option)=>(checked)=>{
            if (!Array.isArray(value)) $712616d38ca865d1$var$log.error("A MultiCheckbox value must be an array. But was: ", value, typeof value);
            else {
                $712616d38ca865d1$var$log.debug("onChangeMulti", value, option, checked);
                const valueClone = value.clone();
                !checked ? valueClone.remove(option) : valueClone.push(option);
                onChange && onChange(valueClone);
            }
        }, [
        value,
        onChange
    ]);
    return !options ? null : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("ul", {
        children: options.map((option)=>{
            const { id: id, name: name, tip: tip, description: description, isDisabled: isDisabledCheckbox = false } = $712616d38ca865d1$var$isMultiCheckboxOption(option) ? option : {
                id: option,
                name: option,
                tip: undefined,
                description: undefined
            };
            const checked = value && Array.isArray(value) && value.includes(id);
            return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("li", {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$2e2bcd8739ae039), {
                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox,
                    label: name,
                    name: (0, $0857d9353dc337e9$export$d5d25c90fc92fce5)(name),
                    value: checked,
                    isDisabled: isDisabled || isDisabledCheckbox,
                    isEditing: isEditing,
                    onChange: onChangeMulti(id),
                    tip: tip || description
                })
            }, id);
        })
    });
};




parcelRequire("fgmOP");


const $c739f2cd2235e68f$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Select", "INFO");
function $c739f2cd2235e68f$var$isSelectOption(op) {
    return typeof op !== "string";
}
function $c739f2cd2235e68f$export$a19294798b20687e(props) {
    return props.type === (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select;
}
const $c739f2cd2235e68f$var$NULL_VALUE_STRING = "--";
const $c739f2cd2235e68f$var$parseSelectOption = (option)=>$c739f2cd2235e68f$var$isSelectOption(option) ? option : {
        id: option,
        name: option
    };
const $c739f2cd2235e68f$export$ef9b1a59e592288f = ({ type: type = "select", ...props })=>{
    // log.debug('render', props);
    const { autocomplete: autocomplete, defaultValue: defaultValue, id: id, isDisabled: isDisabled = false, isNullable: isNullable = false, inputRef: inputRef, name: name, onChange: onChange, options: options, value: value } = props;
    $c739f2cd2235e68f$var$log.debug("render", name, value);
    const unparsedOptions = options && [
        ...options
    ] || [];
    if (!(0, $6efccc49777c4c3d$export$2e2bcd8739ae039).hasValue(value) || isNullable) unparsedOptions.unshift({
        id: null,
        name: defaultValue ? defaultValue : $c739f2cd2235e68f$var$NULL_VALUE_STRING
    });
    else if (!unparsedOptions.some((o)=>$c739f2cd2235e68f$var$isSelectOption(o) ? value === o.id : value === o)) value && unparsedOptions.unshift(value); //  Adds value to the options if not included. //  TODO: remove?
    const selectOptions = unparsedOptions.map($c739f2cd2235e68f$var$parseSelectOption);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("select", {
        id: id,
        name: name,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("field__value", "dropdown-list-with-label__select", props.valueClassName),
        onChange: (e)=>onChange && onChange(selectOptions[e.target.selectedIndex].id),
        disabled: isDisabled,
        value: (0, $6efccc49777c4c3d$export$2e2bcd8739ae039).hasValue(value) ? value : defaultValue ? defaultValue : $c739f2cd2235e68f$var$NULL_VALUE_STRING,
        ref: inputRef,
        autoComplete: autocomplete,
        children: selectOptions && selectOptions.map(({ id: id, name: name })=>{
            const value = id === null ? undefined : id;
            return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("option", {
                className: "dropdown-list-with-label__option",
                value: value,
                children: name
            }, value || "undefined");
        })
    });
};
const $c739f2cd2235e68f$export$cdf9fc299b072aac = ({ defaultValue: defaultValue, options: options, value: value })=>{
    return !(0, $6efccc49777c4c3d$export$2e2bcd8739ae039).hasValue(value) ? defaultValue ? defaultValue : $c739f2cd2235e68f$var$NULL_VALUE_STRING : options && options.map($c739f2cd2235e68f$var$parseSelectOption).find(({ id: id })=>id === value)?.name || "Wrong value:" + value;
};





var $fgmOP = parcelRequire("fgmOP");


const $015f58c808bb0981$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Textarea");
const $015f58c808bb0981$var$setInitialMinHeight = (textareaRef)=>{
    if (textareaRef?.current) textareaRef.current.style.minHeight = textareaRef.current.style.height;
};
const $015f58c808bb0981$var$adjustTextAreaHeight = (textareaRef)=>{
    if (textareaRef?.current) {
        textareaRef.current.style.height = "";
        textareaRef.current.style.height = textareaRef.current.scrollHeight + "px";
    }
};
function $015f58c808bb0981$export$516ccd2e42d23e8b(props) {
    return props.type === (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).textarea;
}
const $015f58c808bb0981$export$379139ebc1c2b235 = (props)=>{
    const { autocomplete: autocomplete, id: id, isDisabled: isDisabled = false, label: label, name: name, onChange: onChange } = props;
    const value = (0, $6efccc49777c4c3d$export$2e2bcd8739ae039).resolveValue(props);
    const textareaRef = (0, $fgmOP.useRef)();
    (0, $fgmOP.useEffect)(()=>$015f58c808bb0981$var$setInitialMinHeight(textareaRef), [
        textareaRef.current
    ]);
    (0, $fgmOP.useEffect)(()=>$015f58c808bb0981$var$adjustTextAreaHeight(textareaRef), [
        value
    ]);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("textarea", {
        id: id,
        name: name || label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("field__value", props.valueClassName),
        disabled: isDisabled,
        placeholder: (0, $6efccc49777c4c3d$export$2e2bcd8739ae039).resolvePlaceholder(props),
        value: value,
        onChange: (e)=>onChange && onChange(e.target.value),
        ref: textareaRef,
        autoComplete: autocomplete
    });
};


const $6efccc49777c4c3d$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Field", "INFO");
let $6efccc49777c4c3d$var$_uniqueId = 0;
const $6efccc49777c4c3d$var$getUniqueId = (typeShortName)=>`field-${typeShortName}-${$6efccc49777c4c3d$var$_uniqueId++}`;
const $6efccc49777c4c3d$export$6c2fadcd8bf80d96 = {
    checkbox: "_field_type_checkbox",
    date: "_field_type_date",
    time: "_field_type_time",
    element: "_field_type_element",
    input: "_field_type_input",
    multi: "_field_type_multi",
    number: "_field_type_number",
    password: "_field_type_password",
    select: "_field_type_select",
    textarea: "_field_type_textarea",
    duration: "_field_type_duration",
    currency: "_field_type_currency"
};
const $6efccc49777c4c3d$var$typeShortName = (type)=>type.replace("_field_type_", "");
function $6efccc49777c4c3d$var$isFieldElementProps(props) {
    return props.type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.element;
}
function $6efccc49777c4c3d$var$isFieldInputProps(props) {
    return !props.type || [
        $6efccc49777c4c3d$export$6c2fadcd8bf80d96.checkbox,
        $6efccc49777c4c3d$export$6c2fadcd8bf80d96.date,
        $6efccc49777c4c3d$export$6c2fadcd8bf80d96.time,
        $6efccc49777c4c3d$export$6c2fadcd8bf80d96.input,
        $6efccc49777c4c3d$export$6c2fadcd8bf80d96.multi,
        $6efccc49777c4c3d$export$6c2fadcd8bf80d96.number,
        $6efccc49777c4c3d$export$6c2fadcd8bf80d96.password,
        $6efccc49777c4c3d$export$6c2fadcd8bf80d96.duration,
        $6efccc49777c4c3d$export$6c2fadcd8bf80d96.currency
    ].includes(props.type);
}
function $6efccc49777c4c3d$var$isFieldDurationProps(props) {
    return props.type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.duration;
}
function $6efccc49777c4c3d$var$isFieldCurrencyProps(props) {
    return props.type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.currency;
}
const $6efccc49777c4c3d$export$a455218a85c89869 = (props)=>{
    const { button: button, className: className, isDisabled: isDisabled = false, error: error, isEditing: isEditing = false, inputRef: inputRef, label: label, name: name, onChange: onChange, tip: tip, type: type = $6efccc49777c4c3d$export$6c2fadcd8bf80d96.input, value: value, autocomplete: autocomplete } = props;
    $6efccc49777c4c3d$var$log.debug("render", props.value);
    const uniqueId = $6efccc49777c4c3d$var$getUniqueId($6efccc49777c4c3d$var$typeShortName(type)); // TODO: useMemo(getUniqueId());
    const hasLink = $6efccc49777c4c3d$var$isFieldInputProps(props) && props.linkTo;
    const FieldValueFc = ()=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("field__value", props.valueClassName, {
                "field__value--default": !$6efccc49777c4c3d$export$a455218a85c89869.hasValue(value),
                "field__value--link": hasLink
            }),
            onDoubleClick: ()=>{
                navigator.clipboard.writeText($6efccc49777c4c3d$export$a455218a85c89869.resolveValue(props).toString());
                (0, $4983ed7d9d06375d$export$b410431fab84fa58).success("Copied " + props.label + " to clipboard", {
                    autoClose: 2500
                });
            },
            children: $6efccc49777c4c3d$var$isFieldElementProps(props) ? props.value || props.children : (0, $dedce9a9f060f410$export$319f0c9e72e6e5d2)($6efccc49777c4c3d$var$hasValue($6efccc49777c4c3d$export$a455218a85c89869.resolveValue(props)) ? "" + $6efccc49777c4c3d$export$a455218a85c89869.resolveValue(props) : "\xa0")
        });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("field", {
            "field--disabled": isDisabled
        }, isEditing ? "field--editing" : "field--displaying", `field--${$6efccc49777c4c3d$var$typeShortName(type)}`, className),
        children: [
            (0, $712616d38ca865d1$export$789791f6749b534e)(props) ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("fieldset", {
                children: [
                    label && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("legend", {
                        className: "label",
                        children: label
                    }),
                    tip && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $acf38b6c25932409$export$2e2bcd8739ae039), {
                        children: tip
                    }),
                    button,
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $712616d38ca865d1$export$52fe8c8ba20f2bea), {
                        ...props
                    })
                ]
            }) : (0, $1787422a5c5e42e2$export$d1c5448ba3406145)(props) ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1787422a5c5e42e2$export$48513f6b9f8ce62d), {
                        id: uniqueId,
                        ...props
                    }),
                    tip && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $acf38b6c25932409$export$2e2bcd8739ae039), {
                        text: tip
                    })
                ]
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    label && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("label", {
                        className: `label`,
                        htmlFor: isEditing ? uniqueId : undefined,
                        children: label
                    }),
                    hasLink && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c27474ab5ff5382a$export$23da1e9f164f7ea1), {
                        linkTo: $6efccc49777c4c3d$var$isString(props.linkTo) ? $e9a95c61c800ecd2$export$d9468344d3651243(props.linkTo, $6efccc49777c4c3d$export$a455218a85c89869.resolveValue(props).toString()) : props.linkTo($6efccc49777c4c3d$export$a455218a85c89869.resolveValue(props).toString()),
                        icon: "open",
                        info: "Open link",
                        className: "field--linkTo__icon"
                    }),
                    tip && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $acf38b6c25932409$export$2e2bcd8739ae039), {
                        children: tip
                    }) || $6efccc49777c4c3d$var$isFieldDurationProps(props) && isEditing && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $acf38b6c25932409$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $4d1e1c54df2c53ab$export$48c13954988b43bb), {})
                    }),
                    button,
                    isEditing ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        className: "field__value__wrapper",
                        children: [
                            $6efccc49777c4c3d$var$isFieldInputProps(props) && props.icon && isEditing && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                className: "field__value__icon",
                                icon: props.icon
                            }),
                            (0, $015f58c808bb0981$export$516ccd2e42d23e8b)(props) ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $015f58c808bb0981$export$379139ebc1c2b235), {
                                id: uniqueId,
                                ...props
                            }) : (0, $c739f2cd2235e68f$export$a19294798b20687e)(props) ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c739f2cd2235e68f$export$ef9b1a59e592288f), {
                                id: uniqueId,
                                ...props
                            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("input", {
                                id: uniqueId,
                                name: name,
                                type: type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.password ? "password" : type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.date ? "date" : type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.time ? "time" : type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.number || type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.currency ? "number" : "text",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("field__value", {
                                    "field__input--date--placeholder": type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.date && !$6efccc49777c4c3d$export$a455218a85c89869.resolveValue(props)
                                }, {
                                    "field__input--date": type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.date
                                }, {
                                    "field__input--time": type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.time
                                }, props.valueClassName),
                                disabled: isDisabled,
                                placeholder: $6efccc49777c4c3d$var$isFieldInputProps(props) ? $6efccc49777c4c3d$export$a455218a85c89869.resolvePlaceholder(props) : undefined,
                                value: $6efccc49777c4c3d$export$a455218a85c89869.resolveValue(props),
                                onChange: (e)=>onChange && onChange(type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.number && e.target.value && !isNaN(Number(e.target.value)) ? Number(e.target.value) : e.target.value),
                                ref: inputRef,
                                autoComplete: autocomplete
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(FieldValueFc, {})
                ]
            }),
            error && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                className: "input-error",
                children: error
            })
        ]
    });
};
function $6efccc49777c4c3d$var$hasValue(str) {
    const has = str !== null && str !== undefined;
    $6efccc49777c4c3d$var$log.debug("hasValue", str, has);
    return has;
}
function $6efccc49777c4c3d$var$isString(str) {
    const isString = $6efccc49777c4c3d$var$hasValue(str) && typeof str === "string";
    $6efccc49777c4c3d$var$log.debug("isString", str, isString);
    return isString;
}
$6efccc49777c4c3d$export$a455218a85c89869.resolvePlaceholder = ({ defaultValue: defaultValue, placeholder: placeholder, label: label })=>$6efccc49777c4c3d$export$a455218a85c89869.hasValue(defaultValue) ? "" + defaultValue : placeholder || label || "";
$6efccc49777c4c3d$export$a455218a85c89869.hasValue = (value)=>value !== null && value !== undefined;
$6efccc49777c4c3d$export$a455218a85c89869.resolveValue = (props)=>{
    const { defaultValue: defaultValue, isEditing: isEditing, label: label, type: type, value: value, currencyCode: currencyCode } = {
        currencyCode: undefined,
        ...props
    };
    return (0, $c739f2cd2235e68f$export$a19294798b20687e)(props) ? (0, $c739f2cd2235e68f$export$cdf9fc299b072aac)(props) : $6efccc49777c4c3d$var$hasValue(value) ? type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.date ? value && (0, $f5d0c2a7498ff49b$exports.format).date(value) : type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.password && !isEditing ? "*".repeat($6efccc49777c4c3d$var$isString(value) && value?.length || 0) : type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.duration && !isEditing ? (0, $f5d0c2a7498ff49b$exports.format).duration(value) : type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.number && !isEditing ? (0, $f49b53e246cd14b8$export$c5a320298cd10607)(value) ? (0, $f5d0c2a7498ff49b$exports.format).decimal(value) : (0, $f5d0c2a7498ff49b$exports.format).integer(value) : type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.currency && !isEditing ? (0, $f5d0c2a7498ff49b$exports.format).currency(value, currencyCode) : value : isEditing ? "" : $6efccc49777c4c3d$var$hasValue(defaultValue) ? type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.duration ? (0, $f5d0c2a7498ff49b$exports.format).duration(defaultValue) : type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.number ? (0, $f49b53e246cd14b8$export$c5a320298cd10607)(defaultValue) ? (0, $f5d0c2a7498ff49b$exports.format).decimal(defaultValue) : (0, $f5d0c2a7498ff49b$exports.format).integer(defaultValue) : type === $6efccc49777c4c3d$export$6c2fadcd8bf80d96.currency && !!currencyCode ? (0, $f5d0c2a7498ff49b$exports.format).currency(defaultValue, currencyCode) : defaultValue : $6efccc49777c4c3d$var$hasValue(label) ? label : "";
};
var $6efccc49777c4c3d$export$2e2bcd8739ae039 = $6efccc49777c4c3d$export$a455218a85c89869;




var $fgmOP = parcelRequire("fgmOP");



const $93299ac43cf6f4bc$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("FieldWithFormState", "INFO");
const $93299ac43cf6f4bc$export$8b5c44f37504e5c3 = (props)=>{
    const { formState: formState, entityFieldId: entityFieldId, onChangeAlso: onChangeAlso, name: name, isEditing: isEditing, error: error, value: propsValue, tip: tip, ...otherProps } = props;
    const value = propsValue ?? formState.subEntityAt(entityFieldId);
    (0, $fgmOP.useEffect)(()=>{
        if (otherProps.type === (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select) /* If dropdown component gets a value which is not included in its options, for example
       * because it's from preferences and doesn't exist in this brand, unset the value.
       */ {
            if (value && otherProps.options !== undefined && !otherProps.options?.some((option)=>typeof option === "string" ? option === value : option.id === value)) {
                $93299ac43cf6f4bc$var$log.warn(`${entityFieldId} '${value}' does not exist in ${otherProps.label} dropdown options, unsetting preference and url param...`);
                formState.onChange(entityFieldId)(null);
            }
        }
    }, [
        otherProps.type === (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select && otherProps.options
    ]);
    try {
        const fieldProps = {
            ...otherProps,
            isEditing: isEditing !== undefined ? isEditing : formState.isEditing,
            value: value,
            onChange: (newValue)=>{
                $93299ac43cf6f4bc$var$log.debug("onChange", {
                    entityFieldId: entityFieldId,
                    newValue: newValue
                });
                formState.onChange(entityFieldId)(newValue);
                onChangeAlso && onChangeAlso(newValue);
            },
            error: error || formState.findError(entityFieldId),
            name: name || entityFieldId,
            tip: entityFieldId === "endDate" ? "Date is inclusive." + (tip ? " " + tip : "") : tip
        };
        $93299ac43cf6f4bc$var$log.debug("render", entityFieldId, value, {
            props: props
        });
        return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$2e2bcd8739ae039), {
            ...fieldProps
        });
    } catch (error) {
        $93299ac43cf6f4bc$var$log.error(error);
        return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $25d390e04dd0ffc0$export$2e2bcd8739ae039), {
            text: `Error rendering FieldWithFormState for ${entityFieldId}`,
            error: error
        });
    }
};




const $2a8cb21a43fac73d$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("TypeToConfirmField", "INFO");
const $2a8cb21a43fac73d$export$f7dbb2b74e32e8db = (props)=>{
    const { confirmText: confirmText, onChange: onChange } = props;
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)({
        isEditing: true
    });
    const prevConfirmedState = (0, $fgmOP.useRef)(false);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("i", {
                children: [
                    " To confirm you are sure, type '",
                    confirmText,
                    "' in the box below. "
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $557d7e86a7a00a80$export$2e2bcd8739ae039), {
                noPadding: true,
                className: "form--compact",
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            entityFieldId: "confirmField",
                            formState: formState,
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).input,
                            placeholder: `Type '${confirmText}'`,
                            onChangeAlso: (value)=>{
                                const isConfirmed = value === confirmText;
                                // Only fire onChange function if confirmed state has actually changed
                                if (prevConfirmedState.current !== isConfirmed) {
                                    prevConfirmedState.current = isConfirmed;
                                    onChange(isConfirmed);
                                }
                            }
                        })
                    })
                })
            })
        ]
    });
};



const $37eb07f38f554cfb$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Modal", "INFO");
const $37eb07f38f554cfb$var$defaultModal = {
    show: false,
    title: "Hidden modal",
    content: undefined,
    name: undefined,
    onConfirm: ()=>{},
    confirmType: "normal",
    confirmText: undefined,
    onCancel: ()=>{},
    cancelText: undefined
};
const $37eb07f38f554cfb$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createContext({
    showModal: (modal)=>{
        $37eb07f38f554cfb$var$log.debug("showModal default", modal);
        return "default ID";
    },
    hideModal: (id)=>$37eb07f38f554cfb$var$log.debug("hideModal default", id)
});
const $37eb07f38f554cfb$export$178405afcd8c5eb = (props)=>{
    const [modal, setModal] = (0, $fgmOP.useState)($37eb07f38f554cfb$var$defaultModal);
    const modalIdEl = (0, $fgmOP.useRef)(null);
    const modalId = modalIdEl.current?.value;
    const modalContext = {
        showModal: (modal)=>{
            const composedModal = {
                ...$37eb07f38f554cfb$var$defaultModal,
                show: true,
                ...modal
            };
            const modalId = "id_" + Date.now();
            $37eb07f38f554cfb$var$log.debug("showModal", {
                modalId: modalId,
                composedModal: composedModal
            });
            setModal(composedModal);
            if (modalIdEl.current) modalIdEl.current.value = modalId;
            return modalId;
        },
        hideModal: (uuid)=>{
            const modalId = modalIdEl.current?.value;
            if (uuid === undefined || uuid === modalId) {
                $37eb07f38f554cfb$var$log.debug("hideModal closing current Modal", uuid);
                setModal({
                    ...$37eb07f38f554cfb$var$defaultModal
                });
            } else $37eb07f38f554cfb$var$log.debug("hideModal skip closing outdated Modal");
        }
    };
    $37eb07f38f554cfb$var$log.debug("render", {
        modalId: modalId,
        modal: modal
    });
    const { show: show, title: title, content: content, name: name, typeToConfirmText: typeToConfirmText, confirmDisabled: confirmDisabled, onConfirm: onConfirm, confirmType: confirmType, confirmText: confirmText, onCancel: onCancel, cancelText: cancelText } = modal;
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)($37eb07f38f554cfb$export$ab57792b9b6974a6.Provider, {
        value: modalContext,
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("input", {
                hidden: true,
                ref: modalIdEl
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($37eb07f38f554cfb$export$bc25a74d11362cd5, {
                show: show,
                title: title,
                name: name,
                typeToConfirmText: typeToConfirmText,
                confirmDisabled: confirmDisabled,
                confirmText: confirmText,
                confirmType: confirmType,
                onConfirm: (...args)=>{
                    setModal($37eb07f38f554cfb$var$defaultModal);
                    onConfirm && onConfirm(...args);
                },
                onCancel: onCancel === null ? undefined : (...args)=>{
                    setModal($37eb07f38f554cfb$var$defaultModal);
                    onCancel && onCancel(...args);
                },
                cancelText: cancelText,
                content: content
            }),
            props.children
        ]
    });
};
const $37eb07f38f554cfb$export$bc25a74d11362cd5 = (props)=>{
    const { show: show, title: title, content: content, onConfirm: onConfirm, confirmType: confirmType, confirmText: confirmText, confirmDisabled: confirmDisabled = false, typeToConfirmText: typeToConfirmText, onCancel: onCancel, cancelText: cancelText, name: name, children: children } = props;
    const [submitDisabled, setSubmitDisabled] = (0, $fgmOP.useState)(!!typeToConfirmText || confirmDisabled);
    (0, $fgmOP.useEffect)(()=>{
        setSubmitDisabled(!!typeToConfirmText || confirmDisabled);
    }, [
        confirmDisabled,
        typeToConfirmText
    ]);
    return show ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $7f3b80d7462309dd$export$2e2bcd8739ae039), {
        size: "medium",
        name: name || "confirmation-dialog",
        heading: title,
        submitDisabled: submitDisabled,
        submitText: confirmText,
        submitKind: confirmType,
        onSubmit: onConfirm,
        closeText: cancelText || "Close",
        onClose: onCancel,
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                children: content || children
            }),
            typeToConfirmText && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $2a8cb21a43fac73d$export$f7dbb2b74e32e8db), {
                confirmText: typeToConfirmText,
                onChange: (confirmed)=>{
                    setSubmitDisabled(!confirmed);
                }
            })
        ]
    }) : null;
};


function $3e050b9d09f8075d$export$33ffd74ebf07f060() {
    const modalContext = (0, $fgmOP.useContext)((0, $37eb07f38f554cfb$export$ab57792b9b6974a6));
    return modalContext;
}








parcelRequire("fgmOP");


parcelRequire("fgmOP");
const $c6ae9b2aa04c9dac$export$255717ca5d7fa2c5 = (props)=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
        className: "accordion__panel rich-text-area",
        id: props.id,
        children: props.open && props.children
    });
};




parcelRequire("fgmOP");

parcelRequire("fgmOP");
const $48e3ca3a490a7f4b$export$2c4ed7bbcd775ba4 = ({ open: open, description: description })=>{
    return description && !open ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
        className: "accordion-item__description",
        children: description
    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {});
};


const $a5a916473d447b2f$export$67cd7f5d9b6a95dc = (props)=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h3", {
        className: "accordion__header heading heading--level-3",
        onClick: props.onClick,
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("button", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("accordion__header-button", props.buttonClassName),
            "aria-expanded": props.open,
            "aria-controls": props.id,
            children: [
                props.children,
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $48e3ca3a490a7f4b$export$2c4ed7bbcd775ba4), {
                    open: props.open,
                    description: props.description
                })
            ]
        })
    });
};




const $cb8470b63aea6339$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("AccordionItem", "INFO");
const $cb8470b63aea6339$export$f0e32a3434bae448 = (props)=>{
    $cb8470b63aea6339$var$log.debug("props", props);
    const { id: id, header: header, headerRightElement: headerRightElement, content: content, description: description, open: open, isDisabled: isDisabled, onToggleOpen: onToggleOpen, checkboxAction: checkboxAction, checkboxValue: checkboxValue, checkboxIsEditing: checkboxIsEditing, showOpenStateIcon: showOpenStateIcon = true, noBorder: noBorder = false } = props;
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("accordion", {
            "accordion--open": open
        }, props.classNames, noBorder && "accordion-item__no-border"),
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $a5a916473d447b2f$export$67cd7f5d9b6a95dc), {
                id: `AccordionItemHeader_${id}`,
                open: !!open,
                onClick: onToggleOpen && !isDisabled ? onToggleOpen : ()=>{},
                buttonClassName: description && "accordion__header-button-description",
                description: description,
                children: [
                    checkboxAction && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox,
                        isEditing: checkboxIsEditing,
                        className: "",
                        onChange: checkboxAction,
                        value: checkboxValue
                    }),
                    headerRightElement && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        className: "floatRight",
                        children: headerRightElement
                    }),
                    showOpenStateIcon && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                        icon: open ? "arrow-small-down" : "arrow-small-right",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                            disabled: isDisabled
                        })
                    }),
                    header
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c6ae9b2aa04c9dac$export$255717ca5d7fa2c5), {
                id: `AccordionItemContent_${id}`,
                open: !!open,
                children: content
            })
        ]
    });
};
var $cb8470b63aea6339$export$2e2bcd8739ae039 = $cb8470b63aea6339$export$f0e32a3434bae448;




parcelRequire("fgmOP");


var $fgmOP = parcelRequire("fgmOP");

parcelRequire("l8GLF");


var $l8GLF = parcelRequire("l8GLF");
const $843993963127ec3e$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useSelectedIds", "INFO");
const $843993963127ec3e$export$1c9b7756eccadc96 = (initialSelectedIds)=>{
    const [selectedIds, setSelectedIds] = (0, $fgmOP.useState)(initialSelectedIds);
    const getId = (id)=>(0, $l8GLF.isID)(id) ? id : id.id;
    const onSelectId = (idx)=>(value)=>{
            const id = getId(idx);
            $843993963127ec3e$var$log.debug("onSelectId", id, value);
            setSelectedIds((selected)=>value ? selected.cloneIncluding(id) : selected.cloneExcluding(id));
        };
    const onSelectAll = (objectsWithId)=>(value)=>{
            $843993963127ec3e$var$log.debug("onSelectAll", value);
            setSelectedIds((_)=>!value || !objectsWithId ? [] : objectsWithId.map(({ id: id })=>id));
        };
    const isSelected = (idx)=>selectedIds.includes(getId(idx));
    const areAllSelected = (objectsWithId)=>objectsWithId && objectsWithId.length > 0 && selectedIds && selectedIds.length > 0 && objectsWithId.length == selectedIds.length;
    const onToggleSelected = (idx)=>{
        $843993963127ec3e$var$log.debug("onToggleSelected", {
            idx: idx,
            currentlySelected: isSelected(idx)
        });
        onSelectId(idx)(!isSelected(idx));
    };
    return {
        selectedIds: selectedIds,
        onSelectId: onSelectId,
        onToggleSelected: onToggleSelected,
        onSelectAll: onSelectAll,
        isSelected: isSelected,
        areAllSelected: areAllSelected
    };
};


var $4a7c720bc23270cb$exports = {};
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $33y03 = parcelRequire("33y03");
var $4a7c720bc23270cb$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $4a7c720bc23270cb$var$formatRegExp = /%[sdj%]/g;
$4a7c720bc23270cb$exports.format = function(f) {
    if (!$4a7c720bc23270cb$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($4a7c720bc23270cb$var$inspect(arguments[i]));
        return objects.join(" ");
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($4a7c720bc23270cb$var$formatRegExp, function(x) {
        if (x === "%%") return "%";
        if (i >= len) return x;
        switch(x){
            case "%s":
                return String(args[i++]);
            case "%d":
                return Number(args[i++]);
            case "%j":
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return "[Circular]";
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($4a7c720bc23270cb$var$isNull(x) || !$4a7c720bc23270cb$var$isObject(x)) str += " " + x;
    else str += " " + $4a7c720bc23270cb$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
$4a7c720bc23270cb$exports.deprecate = function(fn, msg) {
    if (typeof $33y03 !== "undefined" && $33y03.noDeprecation === true) return fn;
    // Allow for deprecating things in the process of starting up.
    if (typeof $33y03 === "undefined") return function() {
        return $4a7c720bc23270cb$exports.deprecate(fn, msg).apply(this, arguments);
    };
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($33y03.throwDeprecation) throw new Error(msg);
            else if ($33y03.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};
var $4a7c720bc23270cb$var$debugs = {};
var $4a7c720bc23270cb$var$debugEnvRegex = /^$/;
var $4a7c720bc23270cb$var$debugEnv;
$4a7c720bc23270cb$exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$4a7c720bc23270cb$var$debugs[set]) {
        if ($4a7c720bc23270cb$var$debugEnvRegex.test(set)) {
            var pid = $33y03.pid;
            $4a7c720bc23270cb$var$debugs[set] = function() {
                var msg = $4a7c720bc23270cb$exports.format.apply($4a7c720bc23270cb$exports, arguments);
                console.error("%s %d: %s", set, pid, msg);
            };
        } else $4a7c720bc23270cb$var$debugs[set] = function() {};
    }
    return $4a7c720bc23270cb$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $4a7c720bc23270cb$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $4a7c720bc23270cb$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($4a7c720bc23270cb$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    $4a7c720bc23270cb$exports._extend(ctx, opts);
    // set default options
    if ($4a7c720bc23270cb$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($4a7c720bc23270cb$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($4a7c720bc23270cb$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($4a7c720bc23270cb$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $4a7c720bc23270cb$var$stylizeWithColor;
    return $4a7c720bc23270cb$var$formatValue(ctx, obj, ctx.depth);
}
$4a7c720bc23270cb$exports.inspect = $4a7c720bc23270cb$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$4a7c720bc23270cb$var$inspect.colors = {
    "bold": [
        1,
        22
    ],
    "italic": [
        3,
        23
    ],
    "underline": [
        4,
        24
    ],
    "inverse": [
        7,
        27
    ],
    "white": [
        37,
        39
    ],
    "grey": [
        90,
        39
    ],
    "black": [
        30,
        39
    ],
    "blue": [
        34,
        39
    ],
    "cyan": [
        36,
        39
    ],
    "green": [
        32,
        39
    ],
    "magenta": [
        35,
        39
    ],
    "red": [
        31,
        39
    ],
    "yellow": [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$4a7c720bc23270cb$var$inspect.styles = {
    "special": "cyan",
    "number": "yellow",
    "boolean": "yellow",
    "undefined": "grey",
    "null": "bold",
    "string": "green",
    "date": "magenta",
    // "name": intentionally not styling
    "regexp": "red"
};
function $4a7c720bc23270cb$var$stylizeWithColor(str, styleType) {
    var style = $4a7c720bc23270cb$var$inspect.styles[styleType];
    if (style) return "\x1b[" + $4a7c720bc23270cb$var$inspect.colors[style][0] + "m" + str + "\x1b[" + $4a7c720bc23270cb$var$inspect.colors[style][1] + "m";
    else return str;
}
function $4a7c720bc23270cb$var$stylizeNoColor(str, styleType) {
    return str;
}
function $4a7c720bc23270cb$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $4a7c720bc23270cb$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $4a7c720bc23270cb$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== $4a7c720bc23270cb$exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$4a7c720bc23270cb$var$isString(ret)) ret = $4a7c720bc23270cb$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $4a7c720bc23270cb$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $4a7c720bc23270cb$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($4a7c720bc23270cb$var$isError(value) && (keys.indexOf("message") >= 0 || keys.indexOf("description") >= 0)) return $4a7c720bc23270cb$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($4a7c720bc23270cb$var$isFunction(value)) {
            var name = value.name ? ": " + value.name : "";
            return ctx.stylize("[Function" + name + "]", "special");
        }
        if ($4a7c720bc23270cb$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        if ($4a7c720bc23270cb$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), "date");
        if ($4a7c720bc23270cb$var$isError(value)) return $4a7c720bc23270cb$var$formatError(value);
    }
    var base = "", array = false, braces = [
        "{",
        "}"
    ];
    // Make Array say that they are Array
    if ($4a7c720bc23270cb$var$isArray(value)) {
        array = true;
        braces = [
            "[",
            "]"
        ];
    }
    // Make functions say that they are functions
    if ($4a7c720bc23270cb$var$isFunction(value)) {
        var n = value.name ? ": " + value.name : "";
        base = " [Function" + n + "]";
    }
    // Make RegExps say that they are RegExps
    if ($4a7c720bc23270cb$var$isRegExp(value)) base = " " + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($4a7c720bc23270cb$var$isDate(value)) base = " " + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($4a7c720bc23270cb$var$isError(value)) base = " " + $4a7c720bc23270cb$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($4a7c720bc23270cb$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), "regexp");
        else return ctx.stylize("[Object]", "special");
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $4a7c720bc23270cb$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $4a7c720bc23270cb$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $4a7c720bc23270cb$var$reduceToSingleString(output, base, braces);
}
function $4a7c720bc23270cb$var$formatPrimitive(ctx, value) {
    if ($4a7c720bc23270cb$var$isUndefined(value)) return ctx.stylize("undefined", "undefined");
    if ($4a7c720bc23270cb$var$isString(value)) {
        var simple = "'" + JSON.stringify(value).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return ctx.stylize(simple, "string");
    }
    if ($4a7c720bc23270cb$var$isNumber(value)) return ctx.stylize("" + value, "number");
    if ($4a7c720bc23270cb$var$isBoolean(value)) return ctx.stylize("" + value, "boolean");
    // For some reason typeof null is "object", so special case here.
    if ($4a7c720bc23270cb$var$isNull(value)) return ctx.stylize("null", "null");
}
function $4a7c720bc23270cb$var$formatError(value) {
    return "[" + Error.prototype.toString.call(value) + "]";
}
function $4a7c720bc23270cb$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($4a7c720bc23270cb$var$hasOwnProperty(value, String(i))) output.push($4a7c720bc23270cb$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push("");
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($4a7c720bc23270cb$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $4a7c720bc23270cb$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize("[Getter/Setter]", "special");
        else str = ctx.stylize("[Getter]", "special");
    } else if (desc.set) str = ctx.stylize("[Setter]", "special");
    if (!$4a7c720bc23270cb$var$hasOwnProperty(visibleKeys, key)) name = "[" + key + "]";
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($4a7c720bc23270cb$var$isNull(recurseTimes)) str = $4a7c720bc23270cb$var$formatValue(ctx, desc.value, null);
            else str = $4a7c720bc23270cb$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf("\n") > -1) {
                if (array) str = str.split("\n").map(function(line) {
                    return "  " + line;
                }).join("\n").slice(2);
                else str = "\n" + str.split("\n").map(function(line) {
                    return "   " + line;
                }).join("\n");
            }
        } else str = ctx.stylize("[Circular]", "special");
    }
    if ($4a7c720bc23270cb$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify("" + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, "name");
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, "string");
        }
    }
    return name + ": " + str;
}
function $4a7c720bc23270cb$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf("\n") >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, "").length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === "" ? "" : base + "\n ") + " " + output.join(",\n  ") + " " + braces[1];
    return braces[0] + base + " " + output.join(", ") + " " + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
$4a7c720bc23270cb$exports.types = (parcelRequire("j7Rq5"));
function $4a7c720bc23270cb$var$isArray(ar) {
    return Array.isArray(ar);
}
$4a7c720bc23270cb$exports.isArray = $4a7c720bc23270cb$var$isArray;
function $4a7c720bc23270cb$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
$4a7c720bc23270cb$exports.isBoolean = $4a7c720bc23270cb$var$isBoolean;
function $4a7c720bc23270cb$var$isNull(arg) {
    return arg === null;
}
$4a7c720bc23270cb$exports.isNull = $4a7c720bc23270cb$var$isNull;
function $4a7c720bc23270cb$var$isNullOrUndefined(arg) {
    return arg == null;
}
$4a7c720bc23270cb$exports.isNullOrUndefined = $4a7c720bc23270cb$var$isNullOrUndefined;
function $4a7c720bc23270cb$var$isNumber(arg) {
    return typeof arg === "number";
}
$4a7c720bc23270cb$exports.isNumber = $4a7c720bc23270cb$var$isNumber;
function $4a7c720bc23270cb$var$isString(arg) {
    return typeof arg === "string";
}
$4a7c720bc23270cb$exports.isString = $4a7c720bc23270cb$var$isString;
function $4a7c720bc23270cb$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
$4a7c720bc23270cb$exports.isSymbol = $4a7c720bc23270cb$var$isSymbol;
function $4a7c720bc23270cb$var$isUndefined(arg) {
    return arg === void 0;
}
$4a7c720bc23270cb$exports.isUndefined = $4a7c720bc23270cb$var$isUndefined;
function $4a7c720bc23270cb$var$isRegExp(re) {
    return $4a7c720bc23270cb$var$isObject(re) && $4a7c720bc23270cb$var$objectToString(re) === "[object RegExp]";
}
$4a7c720bc23270cb$exports.isRegExp = $4a7c720bc23270cb$var$isRegExp;
$4a7c720bc23270cb$exports.types.isRegExp = $4a7c720bc23270cb$var$isRegExp;
function $4a7c720bc23270cb$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
$4a7c720bc23270cb$exports.isObject = $4a7c720bc23270cb$var$isObject;
function $4a7c720bc23270cb$var$isDate(d) {
    return $4a7c720bc23270cb$var$isObject(d) && $4a7c720bc23270cb$var$objectToString(d) === "[object Date]";
}
$4a7c720bc23270cb$exports.isDate = $4a7c720bc23270cb$var$isDate;
$4a7c720bc23270cb$exports.types.isDate = $4a7c720bc23270cb$var$isDate;
function $4a7c720bc23270cb$var$isError(e) {
    return $4a7c720bc23270cb$var$isObject(e) && ($4a7c720bc23270cb$var$objectToString(e) === "[object Error]" || e instanceof Error);
}
$4a7c720bc23270cb$exports.isError = $4a7c720bc23270cb$var$isError;
$4a7c720bc23270cb$exports.types.isNativeError = $4a7c720bc23270cb$var$isError;
function $4a7c720bc23270cb$var$isFunction(arg) {
    return typeof arg === "function";
}
$4a7c720bc23270cb$exports.isFunction = $4a7c720bc23270cb$var$isFunction;
function $4a7c720bc23270cb$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
$4a7c720bc23270cb$exports.isPrimitive = $4a7c720bc23270cb$var$isPrimitive;

$4a7c720bc23270cb$exports.isBuffer = (parcelRequire("casFQ"));
function $4a7c720bc23270cb$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $4a7c720bc23270cb$var$pad(n) {
    return n < 10 ? "0" + n.toString(10) : n.toString(10);
}
var $4a7c720bc23270cb$var$months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
// 26 Feb 16:19:34
function $4a7c720bc23270cb$var$timestamp() {
    var d = new Date();
    var time = [
        $4a7c720bc23270cb$var$pad(d.getHours()),
        $4a7c720bc23270cb$var$pad(d.getMinutes()),
        $4a7c720bc23270cb$var$pad(d.getSeconds())
    ].join(":");
    return [
        d.getDate(),
        $4a7c720bc23270cb$var$months[d.getMonth()],
        time
    ].join(" ");
}
// log is just a thin wrapper to console.log that prepends a timestamp
$4a7c720bc23270cb$exports.log = function() {
    console.log("%s - %s", $4a7c720bc23270cb$var$timestamp(), $4a7c720bc23270cb$exports.format.apply($4a7c720bc23270cb$exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ $4a7c720bc23270cb$exports.inherits = (parcelRequire("kaPX0"));
$4a7c720bc23270cb$exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$4a7c720bc23270cb$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $4a7c720bc23270cb$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $4a7c720bc23270cb$var$kCustomPromisifiedSymbol = typeof Symbol !== "undefined" ? Symbol("util.promisify.custom") : undefined;
$4a7c720bc23270cb$exports.promisify = function promisify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    if ($4a7c720bc23270cb$var$kCustomPromisifiedSymbol && original[$4a7c720bc23270cb$var$kCustomPromisifiedSymbol]) {
        var fn = original[$4a7c720bc23270cb$var$kCustomPromisifiedSymbol];
        if (typeof fn !== "function") throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $4a7c720bc23270cb$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($4a7c720bc23270cb$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $4a7c720bc23270cb$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $4a7c720bc23270cb$var$getOwnPropertyDescriptors(original));
};
$4a7c720bc23270cb$exports.promisify.custom = $4a7c720bc23270cb$var$kCustomPromisifiedSymbol;
function $4a7c720bc23270cb$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error("Promise was rejected with a falsy value");
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $4a7c720bc23270cb$var$callbackify(original) {
    if (typeof original !== "function") throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== "function") throw new TypeError("The last argument must be of type Function");
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $33y03.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $33y03.nextTick($4a7c720bc23270cb$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $4a7c720bc23270cb$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
$4a7c720bc23270cb$exports.callbackify = $4a7c720bc23270cb$var$callbackify;



const $22dbb5b4c09ac376$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("AccordtionList", "INFO");
const $22dbb5b4c09ac376$export$1266ff14c7754c00 = (props)=>{
    const { id: id, label: label, className: className, multipleOpen: multipleOpen, initialAllOpen: initialAllOpen, initialOpenItemId: initialOpenItemId, children: children, rightElement: rightElement } = props;
    const { isSelected: isSelected, selectedIds: selectedIds, onToggleSelected: onToggleSelected } = (0, $843993963127ec3e$export$1c9b7756eccadc96)(initialOpenItemId ? [
        initialOpenItemId
    ] : initialAllOpen && children ? children.map(({ id: id })=>id) : []);
    const childrenArray = !children ? [] : (0, $4a7c720bc23270cb$exports.isArray)(children) ? children : [
        children
    ];
    $22dbb5b4c09ac376$var$log.debug("render", {
        ...props,
        selectedIds: selectedIds,
        childrenArray: childrenArray
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("accordion-list", className),
        id: id || "accordion-list",
        children: [
            label && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("label", {
                className: `label accordion-list__label`,
                children: label
            }),
            rightElement && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: `accordion-list__right-element`,
                children: rightElement
            }),
            childrenArray.map((child)=>({
                    ...child,
                    props: {
                        ...child.props,
                        open: !child.props.isDisabled && isSelected(child.props),
                        onToggleOpen: ()=>!child.props.isDisabled && onToggleSelected(child.props)
                    }
                }))
        ]
    });
};




parcelRequire("fgmOP");
const $dd22cd0dae287e6b$export$17e5a9408a16e37a = ({ buttons: buttons, description: description, children: children, className: className })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
        className: `pop-up-line ${className || ""}`,
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
            className: "pop-up-line__container container container--small",
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                    className: "pop-up-line__description",
                    children: description || children
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                    className: "pop-up-line__buttons",
                    children: buttons
                })
            ]
        })
    });
var $dd22cd0dae287e6b$export$2e2bcd8739ae039 = $dd22cd0dae287e6b$export$17e5a9408a16e37a;



parcelRequire("fgmOP");

const $3aab005a822ef6ff$export$322d72904d61e323 = (props)=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))(props.className),
        children: props.children
    });
};
var $3aab005a822ef6ff$export$2e2bcd8739ae039 = $3aab005a822ef6ff$export$322d72904d61e323;



parcelRequire("fgmOP");



const $db47bfc18c452fea$var$PageSubtitle = ({ subtitle: subtitle, children: children, showLoading: showLoading = true })=>{
    const { isLoading: isLoading, reset: reset } = (0, $c3440150448da8b8$export$1c72fe480f599e97)();
    reset();
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("h2", {
        className: "page-subtitle__subtitle heading heading--level-2",
        children: [
            subtitle || children,
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("br", {}),
            showLoading && isLoading && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "page-subtitle__spinner",
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {})
            })
        ]
    });
};
var $db47bfc18c452fea$export$2e2bcd8739ae039 = $db47bfc18c452fea$var$PageSubtitle;




var $fgmOP = parcelRequire("fgmOP");

var $6c5ad09ca0869b1d$exports = {};
$6c5ad09ca0869b1d$exports = "mutation incrPageViewMetric($heading:String$userType:UserTypeEnum$brandId:ID$page:String$customerId:ID){incrPageViewMetric(heading:$heading userType:$userType brandId:$brandId page:$page customerId:$customerId)}";





const $c08555a029d66447$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("PageViewCounter", "DEBUG");
var $c08555a029d66447$export$a8a3e93435678ff9;
(function(Heading) {
    Heading["PROVISIONING"] = "Provisioning";
    Heading["SETTLEMENT"] = "Settlement";
    Heading["REPORT"] = "Report";
    Heading["MANAGEMENT"] = "Management";
    Heading["DOCUMENTS"] = "Documents";
    Heading["SUPPORT"] = "Support";
})($c08555a029d66447$export$a8a3e93435678ff9 || ($c08555a029d66447$export$a8a3e93435678ff9 = {}));
const $c08555a029d66447$export$40a70d7fc5397651 = ({ page: page })=>{
    const { customerId: customerId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const { pathname: pathname } = (0, $dfdceb7c36fce96f$export$45d76561a5302f2b)();
    const { realUser: realUser, currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const [incrMetric] = (0, $1f0b8701b604e718$export$609860bf8b0084c)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($6c5ad09ca0869b1d$exports)))));
    const getHeadingFromPath = ()=>{
        const routes = [
            {
                path: $e9a95c61c800ecd2$export$ebba33cd31d6b30c,
                heading: "Provisioning"
            },
            {
                path: $e9a95c61c800ecd2$export$257fa15708996d38,
                heading: "Settlement"
            },
            {
                path: $e9a95c61c800ecd2$export$e3d31417f21c1ce7,
                heading: "Report"
            },
            {
                path: $e9a95c61c800ecd2$export$2793f93164573ad,
                heading: "Management"
            },
            {
                path: $e9a95c61c800ecd2$export$6b504632b4cea2e8,
                heading: "Documents"
            },
            {
                path: $e9a95c61c800ecd2$export$b2e11634d600f33e,
                heading: "Support"
            }
        ];
        return routes.find(({ path: path })=>(0, $8776d7b69d623a41$export$81336c211d5ff295)(path + "/*", pathname))?.heading;
    };
    (0, $fgmOP.useEffect)(()=>{
        incrMetric({
            variables: {
                userType: realUser?.type,
                heading: getHeadingFromPath(),
                page: page,
                brandId: currentUserBrand?.id,
                customerId: customerId
            }
        });
    }, [
        pathname
    ]);
    return null;
};





var $fgmOP = parcelRequire("fgmOP");

function $a82309880227f2e9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Category: FormElements
 *
 * The layout of a form is created by nesting `form__row` and `form__column`.
 * Inside each column you add the components you need for creating your own form.
 *
 * More form examples on the <a href="/forms">forms sample page</a>.
 */ var $a82309880227f2e9$var$Form = function Form(_ref) {
    var id = _ref.id, action = _ref.action, method = _ref.method, onSubmit = _ref.onSubmit, children = _ref.children, className = _ref.className;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("form", {
        id: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("form", $a82309880227f2e9$var$_defineProperty({}, className, className)),
        action: action,
        method: method,
        onSubmit: onSubmit
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("fieldset", {
        className: "form__fieldset"
    }, children));
};
var $a82309880227f2e9$var$FormRow = function FormRow(_ref2) {
    var children = _ref2.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "form__row"
    }, children);
};
var $a82309880227f2e9$var$FormColumn = function FormColumn(_ref3) {
    var size = _ref3.size, children = _ref3.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "form__column ".concat(size ? "form__column--" + size : "")
    }, children);
};
var $a82309880227f2e9$var$FormSuccessMessage = function FormSuccessMessage(_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "form__success"
    }, children);
};
$a82309880227f2e9$var$Form.FormRow = $a82309880227f2e9$var$FormRow;
$a82309880227f2e9$var$Form.FormColumn = $a82309880227f2e9$var$FormColumn;
$a82309880227f2e9$var$Form.FormSuccessMessage = $a82309880227f2e9$var$FormSuccessMessage;
var $a82309880227f2e9$export$2e2bcd8739ae039 = $a82309880227f2e9$var$Form;


parcelRequire("fgmOP");
var $ef1590c0f35960dd$exports = {};
$ef1590c0f35960dd$exports = "mutation saveChangelog($changelog:ChangelogInput!){saveChangelog(changelog:$changelog){...changelogFragment}}fragment changelogFragment on Changelog{id name description createdDate modifiedDate}";





parcelRequire("fgmOP");



const $6afa790c69fae185$export$251b62dd86dd2816 = (obj)=>{
    if (obj && Array.isArray(obj)) return obj.map($6afa790c69fae185$export$251b62dd86dd2816);
    else if (obj && typeof obj === "object") {
        const mutableObj = {
            ...obj
        };
        Object.keys(mutableObj).forEach((key)=>{
            if (key === "__typename") delete mutableObj[key];
            else mutableObj[key] = $6afa790c69fae185$export$251b62dd86dd2816(mutableObj[key]);
        });
        return mutableObj;
    } else return obj;
};
const $6afa790c69fae185$export$f5cac05ac3bf56d8 = (user)=>{
    const updatedUser = {
        ...user
    };
    delete updatedUser.isSSOUser;
    delete updatedUser.mfaOptions;
    updatedUser.rolesMap = user.rolesMap.map(({ roles: roles, resource: resource })=>({
            roles: roles,
            resource: resource
        }));
    return updatedUser;
};




const $6cbfdbba46e9faf5$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useMutationWrap", "INFO");
function $6cbfdbba46e9faf5$export$f2b4a60791265356(mutationDocumentNode, options) {
    const { showModal: showModal, hideModal: hideModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const { clearErrors: clearErrors, onMutationError: onMutationError } = (0, $427c08048922fa16$export$44b6c4ccb6ebc82e)();
    const [graphQlMutation, _] = (0, $1f0b8701b604e718$export$609860bf8b0084c)(mutationDocumentNode, options);
    const useMutationWrapHook = async (options)=>{
        $6cbfdbba46e9faf5$var$log.debug("useMutationWrapHook called with", options);
        const { loadingText: loadingText, successText: successText, ...otherOptions } = options || {};
        $6cbfdbba46e9faf5$var$log.debug("useMutationWrapHook clearError");
        clearErrors();
        $6cbfdbba46e9faf5$var$log.debug(!!loadingText ? "showing loading modal" : "skip showing loading modal", {
            loadingText: loadingText
        });
        const modalId = showModal({
            title: loadingText || "",
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}),
            onCancel: undefined,
            show: !!loadingText
        });
        const cleanedOptions = (0, $6afa790c69fae185$export$251b62dd86dd2816)({
            ...otherOptions
        });
        $6cbfdbba46e9faf5$var$log.debug("Mutation options without __typeName", cleanedOptions);
        try {
            const graphQLResult = await graphQlMutation(cleanedOptions);
            $6cbfdbba46e9faf5$var$log.debug("graphQLResult", graphQLResult);
            hideModal(modalId);
            $6cbfdbba46e9faf5$var$log.debug(!!successText ? "showing success toast" : "skip showing success toast", {
                successText: successText
            });
            !!successText && (0, $4983ed7d9d06375d$export$b410431fab84fa58).success(successText, {
                autoClose: 2500
            }); //  TODO: useToast hook
            return graphQLResult; //  TODO: formState.onSave() ?
        } catch (error) {
            $6cbfdbba46e9faf5$var$log.info("mutation error", error);
            error.graphQLErrors && onMutationError(error.graphQLErrors);
            hideModal(modalId);
            return {}; //  TODO: throw?
        }
    };
    return useMutationWrapHook;
}






const $6ff2c84b86453e8d$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Changelog Form", "INFO");
const $6ff2c84b86453e8d$export$18ef4ca7dd7cd1c3 = ({ changelog: changelog, refetch: refetch })=>{
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)({
        isEditing: true,
        fixedFields: {
            id: changelog?.id
        },
        initialEntity: changelog
    });
    $6ff2c84b86453e8d$var$log.debug("ChangelogForm", changelog);
    const saveChangelog = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($ef1590c0f35960dd$exports)))));
    const onSaveChangelog = async ()=>{
        const { modifiedDate: modifiedDate, createdDate: createdDate, ...changelog } = {
            ...formState.entityAs()
        };
        $6ff2c84b86453e8d$var$log.debug("onSaveChangelog", {
            changelog: changelog
        });
        await saveChangelog({
            loadingText: "Saving Changelog...",
            successText: "Changelog saved",
            variables: {
                changelog: changelog
            }
        });
        refetch && refetch();
    };
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
        className: "marginBottom2 form--compact",
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $a82309880227f2e9$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "name",
                                    label: "Name"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).textarea,
                                entityFieldId: "description",
                                label: "Description"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                        text: "Save",
                        onClick: onSaveChangelog,
                        kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary
                    })
                })
            ]
        })
    });
};


const $ae6ab804e2d9e2b4$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Changelogs", "INFO");
const $ae6ab804e2d9e2b4$export$99b8af0a7c1639 = (props)=>{
    const { hasPermission: hasPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { loading: loading, data: { changelogs: changelogs } = {}, refetch: refetch } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($df5238ba9c072d00$exports)))), {});
    (0, $c3440150448da8b8$export$1c72fe480f599e97)([
        {
            query: "messageChannels",
            isLoading: loading
        }
    ]);
    const { showModal: showModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const onEditChangelog = (changelog)=>{
        showModal({
            title: `${changelog ? "Edit" : "Create"}  Changelog`,
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6ff2c84b86453e8d$export$18ef4ca7dd7cd1c3), {
                changelog: changelog,
                refetch: refetch
            })
        });
    };
    $ae6ab804e2d9e2b4$var$log.debug("Changelogs", props);
    const isEditButtonDisplayed = hasPermission((0, $ca0941499cca84bb$export$ebd186ac99b8cefb)) && props.hideEdit !== true;
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Product Changes"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "documents-changelogs"
            }),
            isEditButtonDisplayed && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                className: "marginBottom",
                onClick: ()=>onEditChangelog(),
                text: "Create changelog"
            }),
            !changelogs || changelogs?.length === 0 ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$2e2bcd8739ae039), {
                children: "No changelogs"
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $22dbb5b4c09ac376$export$1266ff14c7754c00), {
                    multipleOpen: true,
                    initialOpenItemId: "0",
                    className: "noMarginLeft",
                    children: changelogs.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$2e2bcd8739ae039), {
                        children: "No changelogs"
                    }) : changelogs.slice(0, props.displayLimit).map((changelog, i)=>{
                        const formatDate = (date)=>(0, (/*@__PURE__*/$parcel$interopDefault($c30H9)))(date).format("YYYY-MM-DD HH:mm");
                        const createdDateFormatted = formatDate(changelog.createdDate);
                        const modifiedDateFormatted = formatDate(changelog.modifiedDate);
                        const isModifiedDateDisplayed = (0, (/*@__PURE__*/$parcel$interopDefault($c30H9)))(changelog.modifiedDate).diff((0, (/*@__PURE__*/$parcel$interopDefault($c30H9)))(changelog.createdDate), "hours") > 1;
                        const descriptionParts = (0, $dedce9a9f060f410$export$cac4d355fa7ba84d)(changelog.description);
                        return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $cb8470b63aea6339$export$2e2bcd8739ae039), {
                            noBorder: true,
                            id: i.toString(),
                            header: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                                        className: "changelog__name marginRight heading--level-3",
                                        children: [
                                            changelog.name,
                                            isEditButtonDisplayed && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                                icon: "edit",
                                                className: "blueText rem1 changelog__edit",
                                                onClick: ()=>onEditChangelog(changelog)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                        className: "changelog__date",
                                        children: [
                                            createdDateFormatted,
                                            isModifiedDateDisplayed && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                                                className: "marginLeft",
                                                children: [
                                                    "edited ",
                                                    modifiedDateFormatted
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                className: "changelog__description",
                                children: descriptionParts.map((descriptionPart, index)=>descriptionPart.link ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("a", {
                                        className: "link support__link",
                                        href: `${descriptionPart.link}`,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        children: descriptionPart.content
                                    }, index) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                        children: descriptionPart.content
                                    }, index))
                            })
                        }, i.toString());
                    })
                })
            }),
            props.displayLimit && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("p", {
                className: "details",
                children: [
                    "Full list of product changes are found in the",
                    " ",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("a", {
                        className: "link support__link",
                        href: (0, $e9a95c61c800ecd2$export$8446dfcdf93bf41b),
                        children: "Documents"
                    }),
                    " ",
                    "page."
                ]
            })
        ]
    });
};



const $2570513f2d07519e$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Home", "INFO");
const $2570513f2d07519e$export$6715b713e0327f9f = (_)=>{
    const { user: user, hasPermission: hasPermission, isTelia: isTelia, isCustomer: isCustomer, customerId: customerId } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    $2570513f2d07519e$var$log.debug("render", {
        user: user
    });
    const loginGuardedLink = (link)=>isCustomer() && customerId ? link : $e9a95c61c800ecd2$export$eed606b4351295d7;
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $02b201edbdb8a3c4$export$2e2bcd8739ae039), {
                title: "Telia Bulk Messaging Web"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "home"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                children: "Welcome to the Telia Bulk Messaging Web for customers using Telia Bulk Messaging services."
            }),
            isTelia() && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                        children: "Here, Telia users of the Bulk Messaging Web can:"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $98cbb91c03e56cc2$export$312428d8e7d71751), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Item, {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Link, {
                                    href: formatWithBrand($e9a95c61c800ecd2$export$ebba33cd31d6b30c),
                                    children: "Administrate all Customers"
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Item, {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Link, {
                                    href: formatWithBrand($e9a95c61c800ecd2$export$257fa15708996d38),
                                    children: "See settlement (invoice) details"
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Item, {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Link, {
                                    href: formatWithBrand($e9a95c61c800ecd2$export$1e42e92685e98be9),
                                    children: "Create traffic reports"
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Item, {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Link, {
                                    href: formatWithBrand($e9a95c61c800ecd2$export$9bd348b6232639d7),
                                    children: "Manage Telia Bulk Messaging Web Telia users"
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Item, {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Link, {
                                    href: $e9a95c61c800ecd2$export$6b504632b4cea2e8,
                                    children: "Access documentation"
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Item, {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Link, {
                                    href: $e9a95c61c800ecd2$export$b2e11634d600f33e,
                                    children: "Access support guidelines"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ae6ab804e2d9e2b4$export$99b8af0a7c1639), {
                        displayLimit: 3,
                        hideEdit: true
                    })
                ]
            }),
            (!user || isCustomer() && customerId) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                        children: "Here, Bulk Messaging Web customers can:"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $98cbb91c03e56cc2$export$312428d8e7d71751), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Item, {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Link, {
                                    href: loginGuardedLink(formatWithBrand($e9a95c61c800ecd2$export$a91491caafc6bee3, customerId || "")),
                                    children: "See settlement (invoice) details"
                                })
                            }),
                            hasPermission((0, $ca0941499cca84bb$export$4576703433079908)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Item, {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Link, {
                                    href: formatWithBrand($e9a95c61c800ecd2$export$1e42e92685e98be9),
                                    children: "Create traffic reports"
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Item, {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Link, {
                                    href: loginGuardedLink(formatWithBrand($e9a95c61c800ecd2$export$1208ff990906387d, customerId || "")),
                                    children: "Manage services"
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Item, {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Link, {
                                    href: loginGuardedLink(formatWithBrand($e9a95c61c800ecd2$export$f9e6c07fc68d7984, customerId || "")),
                                    children: "Manage Telia Bulk Messaging Web users"
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Item, {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Link, {
                                    href: loginGuardedLink(formatWithBrand($e9a95c61c800ecd2$export$6d02b57a0acc5177, customerId || "")),
                                    children: "Manage communication contacts"
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Item, {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Link, {
                                    href: $e9a95c61c800ecd2$export$6b504632b4cea2e8,
                                    children: [
                                        "Access documentation ",
                                        !user ? "(no LOGIN required)" : ""
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Item, {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Link, {
                                    href: $e9a95c61c800ecd2$export$b2e11634d600f33e,
                                    children: [
                                        "Access support guidelines ",
                                        !user ? "(no LOGIN required)" : ""
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




parcelRequire("fgmOP");







parcelRequire("fgmOP");

const $c65faac65c1ca170$var$SectionTitleFc = (props)=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h3", {
        className: "section__title heading heading--level-3",
        children: props.title || props.children
    });
};
var $c65faac65c1ca170$export$2e2bcd8739ae039 = $c65faac65c1ca170$var$SectionTitleFc;




const $1779cb5c0b7a93cf$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Support", "INFO");
const $1779cb5c0b7a93cf$export$c7a1df07a9ed91ad = ()=>{
    const supportContacts = [
        {
            country: "Norway",
            email: "cpa-support@telia.no"
        },
        {
            country: "Sweden",
            email: "bulk-messaging@telia.se",
            message: "In the subject field of the e-mail, please describe the ticket type e.g. Order, Invoice, Support and Company name and if possible, company organizational number."
        }
    ];
    $1779cb5c0b7a93cf$var$log.debug("render");
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $02b201edbdb8a3c4$export$2e2bcd8739ae039), {
                title: "Support"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "support"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                children: "For questions related to the Telia Bulk Messaging product or this portal you can contact:"
            }),
            supportContacts.map(({ country: country, email: email, message: message })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
                    className: "form-group",
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                            title: country
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).element,
                                    label: "Email",
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("a", {
                                        className: "link support__link",
                                        href: `mailto:${email}`,
                                        children: email
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                                        children: message
                                    })
                                })
                            })
                        })
                    ]
                })),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("p", {
                className: "details",
                children: [
                    "More details are found in the Bulk Messaging agreement appendix 2, found in the",
                    " ",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("a", {
                        className: "link support__link",
                        href: $e9a95c61c800ecd2$export$6b504632b4cea2e8,
                        children: "Documents"
                    }),
                    " ",
                    "page."
                ]
            })
        ]
    });
};




var $fgmOP = parcelRequire("fgmOP");






parcelRequire("fgmOP");

const $53784455b29a4a12$var$NoPermissionFc = ()=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
        description: "You have no permissions to access this section."
    });
};
var $53784455b29a4a12$export$2e2bcd8739ae039 = $53784455b29a4a12$var$NoPermissionFc;


const $25887dbff4a0e1e1$export$c4b3fb0689333860 = ()=>{
    const { loadingUser: loadingUser, userBrands: userBrands } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { getPreference: getPreference, setPreference: setPreference } = (0, $7059d4d5f1933e7a$export$bbd7d970555e2952)([
        "brandId"
    ]);
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const brandId = getPreference("brandId");
    const pathBrandId = (0, $fgmOP.useMemo)(()=>{
        const match = (0, $8776d7b69d623a41$export$81336c211d5ff295)($e9a95c61c800ecd2$export$c71c29f33fa7576a + "/*", location.pathname);
        return match?.params?.brandId?.toUpperCase();
    }, [
        location.pathname
    ]);
    const userHasPathBrand = (0, $fgmOP.useMemo)(()=>{
        return !!userBrands?.find(({ id: id })=>id === pathBrandId);
    }, [
        userBrands,
        pathBrandId
    ]);
    (0, $fgmOP.useEffect)(()=>{
        if (userHasPathBrand && brandId !== pathBrandId) {
            setPreference("brandId", pathBrandId);
            navigate(0);
        }
    }, [
        userHasPathBrand,
        pathBrandId
    ]);
    return loadingUser || !brandId ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : pathBrandId && !userHasPathBrand ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $53784455b29a4a12$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$910ae8079b2c2852), {});
};



parcelRequire("fgmOP");









parcelRequire("fgmOP");



const $bbc56e5aa7afa1c4$export$729687bd6e83ee94 = ({ ariaLabel: ariaLabel, children: children, className: className, ...others })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("nav", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("submenu", className),
        "aria-labelledby": "submenu__label",
        ...others,
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h3", {
                id: "submenu__label",
                className: "visuallyhidden",
                children: ariaLabel
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("ul", {
                children: children
            })
        ]
    });
const $bbc56e5aa7afa1c4$export$b1233990f455934d = ({ link: link, text: text, badge: badge, children: children, className: className, ...others })=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("li", {
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $9fb784f5d8b1fb75$export$b0d92dbee9b5b60d), {
            id: (0, $0857d9353dc337e9$export$d5d25c90fc92fce5)(text, "submenuItem"),
            to: link,
            className: ({ isActive: isActive })=>(0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("submenu__item", className, {
                    "submenu__item--active": isActive
                }),
            children: [
                text,
                badge !== undefined && badge !== null && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                    className: "badge",
                    children: badge
                })
            ]
        })
    });
};



parcelRequire("fgmOP");


const $abcc0b9b07b77c66$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Rerouter", "INFO");
const $abcc0b9b07b77c66$export$6533858383d32124 = (props)=>{
    const { isDisplayed: isDisplayed, navigateTo: navigateTo, children: children } = props;
    $abcc0b9b07b77c66$var$log.debug("render", props);
    if (isDisplayed) return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$444b3ab0cb9aec40), {
        to: navigateTo
    });
};





var $l8GLF = parcelRequire("l8GLF");

parcelRequire("fgmOP");


var $l8GLF = parcelRequire("l8GLF");

const $7d454832d4521bcd$var$DOCUMENT_PREFIX = `Telia_Bulk_Messaging_Agreement`;
const $7d454832d4521bcd$var$ORDER_FORM_PREFIX = `Order_Form_Telia_Bulk_Messaging`;
const $7d454832d4521bcd$var$PDF = ".pdf";
const $7d454832d4521bcd$var$DOCX = ".docx";
const $7d454832d4521bcd$var$XLSX = ".xlsx";
const $7d454832d4521bcd$var$BULK_MESSAGING_AGREEMENT = {
    name: "Bulk Messaging agreement",
    url: `${$7d454832d4521bcd$var$DOCUMENT_PREFIX}`,
    extension: $7d454832d4521bcd$var$PDF
};
const $7d454832d4521bcd$var$DATA_PROTECTION_ROLES = {
    name: "Bulk Messaging product - Data protection roles",
    url: "Bulk_Messaging_product_Data_protection_roles",
    extension: $7d454832d4521bcd$var$PDF
};
const $7d454832d4521bcd$var$APPENDIX_1 = {
    name: "Appendix 1: General Terms and Conditions for Bulk Messaging Services",
    url: `${$7d454832d4521bcd$var$DOCUMENT_PREFIX}_APPENDIX_1_General_Terms_and_Conditions_for_Bulk_Messaging_Services`,
    extension: $7d454832d4521bcd$var$PDF
};
const $7d454832d4521bcd$var$APPENDIX_2 = {
    name: "Appendix 2: Contact information",
    url: `${$7d454832d4521bcd$var$DOCUMENT_PREFIX}_APPENDIX_2_Contact_Information`,
    extension: $7d454832d4521bcd$var$PDF
};
const $7d454832d4521bcd$var$APPENDIX_3 = {
    name: "Appendix 3: Product Summary",
    url: `${$7d454832d4521bcd$var$DOCUMENT_PREFIX}_APPENDIX_3_Product_Summary`,
    extension: $7d454832d4521bcd$var$PDF
};
const $7d454832d4521bcd$var$APPENDIX_4 = {
    name: "Appendix 4: Fees",
    url: `${$7d454832d4521bcd$var$DOCUMENT_PREFIX}_APPENDIX_4_Fees`,
    extension: $7d454832d4521bcd$var$PDF
};
const $7d454832d4521bcd$var$APPENDIX_4_2 = {
    name: "Appendix 4: Fees valid from 2025-07-01",
    url: `${$7d454832d4521bcd$var$DOCUMENT_PREFIX}_APPENDIX_4_Fees_2`,
    extension: $7d454832d4521bcd$var$PDF
};
const $7d454832d4521bcd$var$APPENDIX_5 = {
    name: "Appendix 5: Data Processing Agreement",
    url: `${$7d454832d4521bcd$var$DOCUMENT_PREFIX}_APPENDIX_5_Data_Processing_Agreement`,
    extension: $7d454832d4521bcd$var$PDF
};
const $7d454832d4521bcd$var$APPENDIX_6 = {
    name: "Appendix 6: Service Specific Terms and Conditions for SenderID Protection",
    url: `${$7d454832d4521bcd$var$DOCUMENT_PREFIX}_APPENDIX_6_Service_Specific_Terms_and_Conditions_for_SenderID_Protection`,
    extension: $7d454832d4521bcd$var$PDF
};
const $7d454832d4521bcd$var$ORDER_FORM_BULK_SMS = {
    name: "Bulk SMS",
    url: `${$7d454832d4521bcd$var$ORDER_FORM_PREFIX}_Bulk_SMS`,
    extension: $7d454832d4521bcd$var$XLSX
};
const $7d454832d4521bcd$var$ORDER_FORM_RBM = {
    name: "RBM",
    url: `${$7d454832d4521bcd$var$ORDER_FORM_PREFIX}_RBM`,
    extension: $7d454832d4521bcd$var$XLSX
};
const $7d454832d4521bcd$var$ORDER_FORM_SENDERID = {
    name: "SMS SenderID Protection",
    url: `${$7d454832d4521bcd$var$ORDER_FORM_PREFIX}_SMS_SenderID_Protection`,
    extension: $7d454832d4521bcd$var$XLSX
};
const $7d454832d4521bcd$var$NO_DOCUMENTS = [
    $7d454832d4521bcd$var$BULK_MESSAGING_AGREEMENT,
    $7d454832d4521bcd$var$APPENDIX_1,
    $7d454832d4521bcd$var$APPENDIX_2,
    $7d454832d4521bcd$var$APPENDIX_3,
    $7d454832d4521bcd$var$APPENDIX_4,
    $7d454832d4521bcd$var$APPENDIX_5,
    $7d454832d4521bcd$var$APPENDIX_6
];
const $7d454832d4521bcd$var$SE_DOCUMENTS = [
    {
        ...$7d454832d4521bcd$var$BULK_MESSAGING_AGREEMENT,
        extension: $7d454832d4521bcd$var$DOCX
    },
    $7d454832d4521bcd$var$APPENDIX_1,
    {
        ...$7d454832d4521bcd$var$APPENDIX_2,
        extension: $7d454832d4521bcd$var$DOCX
    },
    $7d454832d4521bcd$var$APPENDIX_3,
    $7d454832d4521bcd$var$APPENDIX_4,
    $7d454832d4521bcd$var$APPENDIX_4_2,
    $7d454832d4521bcd$var$DATA_PROTECTION_ROLES
];
const $7d454832d4521bcd$var$SE_ORDER_FORMS = [
    $7d454832d4521bcd$var$ORDER_FORM_BULK_SMS,
    $7d454832d4521bcd$var$ORDER_FORM_RBM,
    $7d454832d4521bcd$var$ORDER_FORM_SENDERID
];
const $7d454832d4521bcd$var$buildDocumentUrl = ({ name: name, url: url, extension: extension }, countryId, host)=>({
        name: name,
        url: `${host}/documents/commercial/${countryId.toLowerCase()}/cpa_agreement/${url}${extension}`
    });
const $7d454832d4521bcd$export$782f6f8dc0feb7b3 = (countries, host)=>{
    let countriesDocuments = {};
    countries.forEach(({ id: id })=>{
        const countryId = id;
        switch(countryId){
            case (0, $l8GLF.NO).id:
                countriesDocuments[countryId] = {
                    documents: $7d454832d4521bcd$var$NO_DOCUMENTS.map((document)=>$7d454832d4521bcd$var$buildDocumentUrl(document, id, host)),
                    orderForms: []
                };
                break;
            case (0, $l8GLF.SE).id:
                countriesDocuments[countryId] = {
                    documents: $7d454832d4521bcd$var$SE_DOCUMENTS.map((document)=>$7d454832d4521bcd$var$buildDocumentUrl(document, id, host)),
                    orderForms: $7d454832d4521bcd$var$SE_ORDER_FORMS.map((orderForm)=>$7d454832d4521bcd$var$buildDocumentUrl(orderForm, id, host))
                };
                break;
            default:
                countriesDocuments[countryId] = {
                    documents: [],
                    orderForms: []
                };
                break;
        }
    });
    return countriesDocuments;
};
const $7d454832d4521bcd$export$b4d907e1b54ebf2c = ()=>{
    const host = (0, $ce151254b700f66a$export$d8292f95ffcfb18f)();
    const countriesDocuments = $7d454832d4521bcd$export$782f6f8dc0feb7b3(Object.values((0, $l8GLF.allCountries)), host);
    const isKeyOfCountryList = (key)=>{
        return key in countriesDocuments;
    };
    const getCountryDocuments = (countryId)=>countryId && isKeyOfCountryList(countryId) ? countriesDocuments[countryId] : {
            documents: [],
            orderForms: []
        };
    return {
        countriesDocuments: countriesDocuments,
        getCountryDocuments: getCountryDocuments
    };
};











parcelRequire("fgmOP");


const $d8d7fa9fc21de820$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ListItemFc", "INFO");
const $d8d7fa9fc21de820$export$1bb894a6832c4ef1 = ({ id: id, className: className, onClick: onClick, link: link, children: children })=>{
    $d8d7fa9fc21de820$var$log.debug("render", {
        id: id,
        className: className,
        link: link,
        onClick: onClick,
        children: children
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("li", {
        id: id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("list__item list__item--block", {
            "list__item--link list__link": !!onClick || !!link
        }, className),
        onClick: onClick,
        children: link ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
            to: link,
            children: children
        }) : children
    });
};
var $d8d7fa9fc21de820$export$2e2bcd8739ae039 = $d8d7fa9fc21de820$export$1bb894a6832c4ef1;






const $778ee46cbff9eb3c$var$Link = (0, $3b8522ff8ac59784$export$2e2bcd8739ae039).Link;
const $778ee46cbff9eb3c$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("DocumentsCommercial");
const $778ee46cbff9eb3c$export$b53293c19fd0236a = ()=>{
    $778ee46cbff9eb3c$var$log.debug("render");
    const { currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { getCountryDocuments: getCountryDocuments } = (0, $7d454832d4521bcd$export$b4d907e1b54ebf2c)();
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)({
        initialEntity: {
            selectedCountry: currentUserBrand?.countryId || (0, $l8GLF.NO).id
        },
        isEditing: true
    });
    const enabledCountries = {
        [(0, $l8GLF.allCountries).NO.id]: (0, $l8GLF.allCountries).NO,
        [(0, $l8GLF.allCountries).SE.id]: (0, $l8GLF.allCountries).SE
    };
    const selectedCountry = enabledCountries[formState.entity.selectedCountry?.toString()];
    const { documents: documents, orderForms: orderForms } = getCountryDocuments(selectedCountry?.id);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "documents-commercial"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Commercial"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: "selectedCountry",
                            label: "Country",
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                            options: Object.values(enabledCountries)
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {})
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("h4", {
                className: "documents-commercial__aggreement",
                children: [
                    "Telia ",
                    selectedCountry?.name,
                    " - Bulk Messaging agreement"
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $98cbb91c03e56cc2$export$312428d8e7d71751), {
                children: documents.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$2e2bcd8739ae039), {
                    description: `No documents uploaded ${selectedCountry ? `for ${selectedCountry.name}` : ""}`
                }) : documents.map(({ name: name, url: url })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d8d7fa9fc21de820$export$1bb894a6832c4ef1), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($778ee46cbff9eb3c$var$Link, {
                            href: `${url}`,
                            target: "_blank",
                            children: name
                        })
                    }))
            }),
            !orderForms.isEmpty() && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h4", {
                        className: "documents-commercial__order-form",
                        children: "Order forms"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $98cbb91c03e56cc2$export$312428d8e7d71751), {
                        children: orderForms.map(({ name: name, url: url })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d8d7fa9fc21de820$export$1bb894a6832c4ef1), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($778ee46cbff9eb3c$var$Link, {
                                    href: `${url}`,
                                    target: "_blank",
                                    children: name
                                })
                            }))
                    })
                ]
            })
        ]
    });
};



parcelRequire("fgmOP");







const $14042d0715b70b14$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("DocumentsMain");
const $14042d0715b70b14$var$guides = [
    {
        name: "Bulk Messaging Implementation Guide",
        url: "developer/index.html"
    },
    {
        name: "Bulk SMS REST API v2",
        url: "api/restv2/bulk.html"
    },
    {
        name: "Bulk SMS Callback REST API v2",
        url: "api/restv2/bulk-callback.html"
    }
];
const $14042d0715b70b14$var$legacyGuides = [
    {
        name: "Bulk SMS Implementation guide (SOAP)",
        url: "api/soap/cpa-api-guide.html"
    },
    {
        name: "Bulk SMS REST API v1",
        url: "api/rest/bulk.html"
    },
    {
        name: "Bulk SMS Callback REST API v1",
        url: "api/rest/bulk-callback.html"
    }
];
const $14042d0715b70b14$export$1a2f9c4fba561dfd = (props)=>{
    $14042d0715b70b14$var$log.debug("render", props);
    const host = (0, $ce151254b700f66a$export$d8292f95ffcfb18f)();
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "documents-technical"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "API guides"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $98cbb91c03e56cc2$export$2e2bcd8739ae039), {
                children: $14042d0715b70b14$var$guides.map(({ name: name, url: url })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d8d7fa9fc21de820$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("a", {
                            href: `${host}/documents/${url}`,
                            target: "_blank",
                            children: name
                        })
                    }, name))
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Legacy guides"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $98cbb91c03e56cc2$export$2e2bcd8739ae039), {
                children: $14042d0715b70b14$var$legacyGuides.map(({ name: name, url: url })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d8d7fa9fc21de820$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("a", {
                            href: `${host}/documents/${url}`,
                            target: "_blank",
                            children: name
                        })
                    }, name))
            })
        ]
    });
};


const $8169138e1cbfd71d$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("DocumentsMain");
const $8169138e1cbfd71d$export$22c59631e6c46e5a = (props)=>{
    const { loadingUser: loadingUser, isTelia: isTelia } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    $8169138e1cbfd71d$var$log.debug("render", props);
    const subPath = $e9a95c61c800ecd2$export$e8c60b88aa54a6db($e9a95c61c800ecd2$export$6b504632b4cea2e8);
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $02b201edbdb8a3c4$export$2e2bcd8739ae039), {
                title: "Documents"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bbc56e5aa7afa1c4$export$729687bd6e83ee94), {
                ariaLabel: "Management submenu",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                        link: formatWithBrand($e9a95c61c800ecd2$export$b637f01461133315),
                        text: "Technical"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                        link: formatWithBrand($e9a95c61c800ecd2$export$7a2a39ee24a1b093),
                        text: "Commercial"
                    }),
                    isTelia() && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                        link: formatWithBrand($e9a95c61c800ecd2$export$8446dfcdf93bf41b),
                        text: "Product Changes"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $b60bd97a1f982072$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $dfdceb7c36fce96f$export$3565eb3d00ca5a74), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                            path: subPath($e9a95c61c800ecd2$export$6b504632b4cea2e8),
                            element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$444b3ab0cb9aec40), {
                                replace: true,
                                to: formatWithBrand($e9a95c61c800ecd2$export$b637f01461133315)
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                            path: subPath($e9a95c61c800ecd2$export$b637f01461133315),
                            element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $14042d0715b70b14$export$1a2f9c4fba561dfd), {})
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                            path: subPath($e9a95c61c800ecd2$export$7a2a39ee24a1b093),
                            element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $778ee46cbff9eb3c$export$b53293c19fd0236a), {})
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                            path: subPath($e9a95c61c800ecd2$export$8446dfcdf93bf41b),
                            element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $abcc0b9b07b77c66$export$6533858383d32124), {
                                isDisplayed: loadingUser || !!isTelia(),
                                navigateTo: formatWithBrand($e9a95c61c800ecd2$export$6b504632b4cea2e8),
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ae6ab804e2d9e2b4$export$99b8af0a7c1639), {})
                            })
                        })
                    ]
                })
            }, location.pathname)
        ]
    });
};




var $fgmOP = parcelRequire("fgmOP");




const $f79b987821d4b4ca$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Brand", "INFO");
const $f79b987821d4b4ca$export$c6c17a9b4d06c1 = (_)=>{
    const { brandId: brandId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const { search: search, hash: hash } = (0, $dfdceb7c36fce96f$export$45d76561a5302f2b)();
    const { setPreference: setPreference, getPreference: getPreference } = (0, $7059d4d5f1933e7a$export$bbd7d970555e2952)([
        "brandId"
    ]);
    let redirectUrl = decodeURI(hash.substr(1));
    (0, $fgmOP.useEffect)(()=>{
        const currBrandId = getPreference("brandId");
        currBrandId && (redirectUrl = redirectUrl.replace(currBrandId.toLowerCase(), brandId.toLowerCase())); //Inject new brand into URL
        setPreference("brandId", brandId);
        window.location.href = redirectUrl;
    }, []);
    $f79b987821d4b4ca$var$log.debug("render", {
        brandId: brandId,
        search: search,
        hash: hash
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $02b201edbdb8a3c4$export$2e2bcd8739ae039), {
                title: "Brand selection"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("p", {
                children: [
                    "Setting brand ID '",
                    brandId,
                    "' user preference"
                ]
            })
        ]
    });
};




var $fgmOP = parcelRequire("fgmOP");


var $jPPOv = parcelRequire("jPPOv");

var $fgmOP = parcelRequire("fgmOP");


var $jPPOv = parcelRequire("jPPOv");
var $455b1208162e5848$var$MenuHeading = function MenuHeading(_ref) {
    var menuLinks = _ref.menuLinks, activeIndex = _ref.activeIndex, LinkTemplate = _ref.LinkTemplate;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("ul", {
        className: "menu__top--heading"
    }, menuLinks.map(function(menuLink, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("li", {
            key: menuLink.heading && menuLink.heading.text
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(LinkTemplate, {
            url: menuLink.heading.url,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("menu__top--heading-item link", {
                "menu__top--heading-item--active": activeIndex === index
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
            className: "link__content"
        }, menuLink.heading.text)));
    }));
};
var $455b1208162e5848$var$MenuTop = function MenuTop(_ref2) {
    var LinkTemplate = _ref2.LinkTemplate, activeIndex = _ref2.activeIndex, menuLinks = _ref2.menuLinks;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "menu__top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($455b1208162e5848$var$MenuHeading, {
        LinkTemplate: LinkTemplate,
        activeIndex: activeIndex,
        menuLinks: menuLinks
    }));
};
$455b1208162e5848$var$MenuTop.propTypes = {
    menuLinks: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).array,
    activeIndex: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).number,
    LinkTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func
};
$455b1208162e5848$var$MenuTop.defaultProps = {
    menuLinks: [],
    activeIndex: 0
};
var $455b1208162e5848$export$2e2bcd8739ae039 = $455b1208162e5848$var$MenuTop;



var $fgmOP = parcelRequire("fgmOP");


var $jPPOv = parcelRequire("jPPOv");

var $fgmOP = parcelRequire("fgmOP");


var $jPPOv = parcelRequire("jPPOv");
function $fc098853ee9e916f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Status: *in progress*.
 * Category: Loader
 *
 * Future work: Replace it with gif
 *
 */ var $fc098853ee9e916f$var$Spinner = function Spinner(_ref) {
    var _classnames;
    var className = _ref.className, _ref$type = _ref.type, type = _ref$type === void 0 ? "lg" : _ref$type;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("spinner", (_classnames = {}, $fc098853ee9e916f$var$_defineProperty(_classnames, className, className), $fc098853ee9e916f$var$_defineProperty(_classnames, "spinner--".concat(type), type), _classnames))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "spinner__blade spinner__blade--0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "spinner__blade spinner__blade--1"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "spinner__blade spinner__blade--2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "spinner__blade spinner__blade--3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "spinner__blade spinner__blade--4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "spinner__blade spinner__blade--5"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "spinner__blade spinner__blade--6"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "spinner__blade spinner__blade--7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "spinner__blade spinner__blade--8"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "spinner__blade spinner__blade--9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "spinner__blade spinner__blade--10"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "spinner__blade spinner__blade--11"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "spinner__blade spinner__blade--12"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "spinner__blade spinner__blade--13"
    }));
};
$fc098853ee9e916f$var$Spinner.propTypes = {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).oneOf([
        "sm",
        "md",
        "lg"
    ])
};
var $fc098853ee9e916f$export$2e2bcd8739ae039 = $fc098853ee9e916f$var$Spinner;




var $fgmOP = parcelRequire("fgmOP");


var $jPPOv = parcelRequire("jPPOv");

var $fgmOP = parcelRequire("fgmOP");

var $jPPOv = parcelRequire("jPPOv");

var $f918fdc2557d205d$exports = {};
/**
 * Module exports.
 */ $f918fdc2557d205d$exports = $f918fdc2557d205d$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $f918fdc2557d205d$var$deprecate(fn, msg) {
    if ($f918fdc2557d205d$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($f918fdc2557d205d$var$config("throwDeprecation")) throw new Error(msg);
            else if ($f918fdc2557d205d$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $f918fdc2557d205d$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}



var $fgmOP = parcelRequire("fgmOP");

var $jPPOv = parcelRequire("jPPOv");

var $17fd359044299102$var$_excluded = [
    "text",
    "children",
    "isUsingGrayText",
    "className"
];
function $17fd359044299102$var$_extends() {
    $17fd359044299102$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $17fd359044299102$var$_extends.apply(this, arguments);
}
function $17fd359044299102$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $17fd359044299102$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $17fd359044299102$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $17fd359044299102$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Status: *finished*
 * Category: FormElements
 *
 * Standard color is black. Labels used with TextBoxWithLabel, TextAreaWithLabel and DropDownListWithLabel should appear on top of input element and be in grey color.
 */ var $17fd359044299102$var$Label = function Label(_ref) {
    var _classnames;
    var text = _ref.text, children = _ref.children, isUsingGrayText = _ref.isUsingGrayText, className = _ref.className, rest = $17fd359044299102$var$_objectWithoutProperties(_ref, $17fd359044299102$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("label", $17fd359044299102$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("label", (_classnames = {}, $17fd359044299102$var$_defineProperty(_classnames, className, className), $17fd359044299102$var$_defineProperty(_classnames, "label--gray-text", isUsingGrayText), _classnames))
    }, rest), text || children);
};
$17fd359044299102$var$Label.propTypes = {
    /** Content of this label. */ text: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).node,
    /** Content of this label. */ children: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).node,
    isUsingGrayText: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool
};
var $17fd359044299102$export$2e2bcd8739ae039 = $17fd359044299102$var$Label;



var $fgmOP = parcelRequire("fgmOP");

var $jPPOv = parcelRequire("jPPOv");


var $d26e677704dc0cdd$var$_excluded = [
    "className",
    "type",
    "placeholder",
    "disabled",
    "error",
    "small"
];
function $d26e677704dc0cdd$var$_extends() {
    $d26e677704dc0cdd$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d26e677704dc0cdd$var$_extends.apply(this, arguments);
}
function $d26e677704dc0cdd$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d26e677704dc0cdd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d26e677704dc0cdd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d26e677704dc0cdd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d26e677704dc0cdd$var$TextBox = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).forwardRef((0, (/*@__PURE__*/$parcel$interopDefault($f918fdc2557d205d$exports)))(function(_ref, ref) {
    var _classnames;
    var className = _ref.className, type = _ref.type, placeholder = _ref.placeholder, disabled = _ref.disabled, error = _ref.error, small = _ref.small, rest = $d26e677704dc0cdd$var$_objectWithoutProperties(_ref, $d26e677704dc0cdd$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("input", $d26e677704dc0cdd$var$_extends({
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("textbox", (_classnames = {}, $d26e677704dc0cdd$var$_defineProperty(_classnames, className, className), $d26e677704dc0cdd$var$_defineProperty(_classnames, "textbox--with-error", error), $d26e677704dc0cdd$var$_defineProperty(_classnames, "textbox--small", small), _classnames)),
        type: type,
        placeholder: placeholder,
        disabled: disabled
    }, rest));
}, "<TextBox/> from Telia Styleguide is a deprecated component. Use <TextField/> instead"));
$d26e677704dc0cdd$var$TextBox.displayName = "TextBox";
$d26e677704dc0cdd$var$TextBox.defaultProps = {
    placeholder: "",
    onChange: function onChange() {}
};
$d26e677704dc0cdd$var$TextBox.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    small: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func
};
var $d26e677704dc0cdd$export$2e2bcd8739ae039 = $d26e677704dc0cdd$var$TextBox;



var $fgmOP = parcelRequire("fgmOP");

var $jPPOv = parcelRequire("jPPOv");





var $2d40ff4eb8df1c5b$var$_excluded = [
    "className",
    "type",
    "placeholder",
    "disabled",
    "error",
    "small",
    "iconName",
    "iconColor",
    "iconIsButton",
    "iconLabel",
    "onIconClick",
    "displayLoader"
];
function $2d40ff4eb8df1c5b$var$_extends() {
    $2d40ff4eb8df1c5b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2d40ff4eb8df1c5b$var$_extends.apply(this, arguments);
}
function $2d40ff4eb8df1c5b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2d40ff4eb8df1c5b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2d40ff4eb8df1c5b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2d40ff4eb8df1c5b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $2d40ff4eb8df1c5b$var$TextBoxIcon = function TextBoxIcon(_ref) {
    var iconName = _ref.iconName, iconIsButton = _ref.iconIsButton, iconColor = _ref.iconColor, iconLabel = _ref.iconLabel, onClick = _ref.onClick, displayLoader = _ref.displayLoader;
    if (!iconName) return null;
    if (iconIsButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, displayLoader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        style: {
            position: "absolute",
            bottom: 0,
            top: 0,
            right: 0,
            padding: "4px 10px"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $fc098853ee9e916f$export$2e2bcd8739ae039), {
        type: "sm"
    })), !displayLoader && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("button", {
        onClick: onClick,
        className: "textbox-with-icon__icon-wrapper textbox-with-icon__button button--stripped",
        "aria-label": iconLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $058eda357a1eb9d2$export$2e2bcd8739ae039), {
        className: "textbox-with-icon__icon",
        iconName: iconName,
        color: iconColor
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: "textbox-with-icon__icon-wrapper",
        "aria-label": iconLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $058eda357a1eb9d2$export$2e2bcd8739ae039), {
        className: "textbox-with-icon__icon",
        iconName: iconName,
        color: iconColor
    }));
};
/**
 * Status: *finished*.
 * Category: FormElements
 **/ var $2d40ff4eb8df1c5b$var$TextBoxWithIcon = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).forwardRef((0, (/*@__PURE__*/$parcel$interopDefault($f918fdc2557d205d$exports)))(function(_ref2, ref) {
    var _classnames;
    var className = _ref2.className, type = _ref2.type, placeholder = _ref2.placeholder, disabled = _ref2.disabled, error = _ref2.error, small = _ref2.small, iconName = _ref2.iconName, iconColor = _ref2.iconColor, iconIsButton = _ref2.iconIsButton, iconLabel = _ref2.iconLabel, onIconClick = _ref2.onIconClick, displayLoader = _ref2.displayLoader, rest = $2d40ff4eb8df1c5b$var$_objectWithoutProperties(_ref2, $2d40ff4eb8df1c5b$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("textbox-with-icon", (_classnames = {}, $2d40ff4eb8df1c5b$var$_defineProperty(_classnames, "textbox-with-icon--small", small), $2d40ff4eb8df1c5b$var$_defineProperty(_classnames, className, className), _classnames))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $d26e677704dc0cdd$export$2e2bcd8739ae039), $2d40ff4eb8df1c5b$var$_extends({
        ref: ref,
        type: type,
        placeholder: placeholder,
        disabled: disabled,
        error: error,
        small: small
    }, rest)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($2d40ff4eb8df1c5b$var$TextBoxIcon, {
        iconName: iconName,
        iconIsButton: iconIsButton,
        iconColor: iconColor,
        iconLabel: iconLabel,
        onClick: onIconClick,
        displayLoader: displayLoader
    }));
}, "<TextBoxWithIcon/> from Telia Styleguide is a deprecated component. Use <TextField/> instead"));
$2d40ff4eb8df1c5b$var$TextBoxWithIcon.displayName = "TextBoxWithIcon";
$2d40ff4eb8df1c5b$var$TextBoxWithIcon.defaultProps = {
    iconColor: "black",
    placeholder: "",
    onChange: function onChange() {}
};
$2d40ff4eb8df1c5b$var$TextBoxWithIcon.propTypes = {
    type: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    error: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    small: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    iconName: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    iconColor: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    iconIsButton: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    iconLabel: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    title: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func
};
var $2d40ff4eb8df1c5b$export$2e2bcd8739ae039 = $2d40ff4eb8df1c5b$var$TextBoxWithIcon;


var $f53014ba0bcca079$var$_excluded = [
    "labelText",
    "type",
    "placeholder",
    "hideLabel",
    "errorMessage",
    "disabled",
    "withIcon",
    "iconName",
    "iconColor",
    "iconIsButton",
    "iconLabel"
];
function $f53014ba0bcca079$var$_extends() {
    $f53014ba0bcca079$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f53014ba0bcca079$var$_extends.apply(this, arguments);
}
function $f53014ba0bcca079$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f53014ba0bcca079$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f53014ba0bcca079$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Status: *in progress*.
 * Category: FormElements
 **/ var $f53014ba0bcca079$var$TextBoxWithLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).forwardRef((0, (/*@__PURE__*/$parcel$interopDefault($f918fdc2557d205d$exports)))(function(_ref, ref) {
    var labelText = _ref.labelText, type = _ref.type, placeholder = _ref.placeholder, hideLabel = _ref.hideLabel, errorMessage = _ref.errorMessage, disabled = _ref.disabled, withIcon = _ref.withIcon, iconName = _ref.iconName, iconColor = _ref.iconColor, iconIsButton = _ref.iconIsButton, iconLabel = _ref.iconLabel, rest = $f53014ba0bcca079$var$_objectWithoutProperties(_ref, $f53014ba0bcca079$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $17fd359044299102$export$2e2bcd8739ae039), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("textbox-with-label", {
            "textbox-with-label--with-error": errorMessage
        }),
        isUsingGrayText: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("textbox-with-label__label-text", {
            "sr-only": hideLabel
        })
    }, labelText), withIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $2d40ff4eb8df1c5b$export$2e2bcd8739ae039), $f53014ba0bcca079$var$_extends({
        ref: ref,
        type: type,
        placeholder: placeholder,
        disabled: disabled,
        error: !!errorMessage,
        iconName: iconName,
        iconColor: iconColor,
        iconIsButton: iconIsButton,
        iconLabel: iconLabel,
        "aria-invalid": !!errorMessage
    }, rest)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $d26e677704dc0cdd$export$2e2bcd8739ae039), $f53014ba0bcca079$var$_extends({
        ref: ref,
        type: type,
        placeholder: placeholder,
        disabled: disabled,
        error: !!errorMessage,
        "aria-invalid": !!errorMessage
    }, rest)), errorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("p", {
        role: "alert",
        className: "input-error",
        "aria-live": "polite"
    }, errorMessage));
}, "<TextBoxWithLabel/> from Telia Styleguide is a deprecated component. Use <TextField/> instead"));
$f53014ba0bcca079$var$TextBoxWithLabel.displayName = "TextBoxWithLabel";
$f53014ba0bcca079$var$TextBoxWithLabel.defaultProps = {
    iconColor: "black",
    placeholder: "",
    onChange: function onChange() {}
};
$f53014ba0bcca079$var$TextBoxWithLabel.propTypes = {
    labelText: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    hideLabel: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    type: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    placeholder: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    errorMessage: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    disabled: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    withIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    iconName: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    iconColor: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    iconIsButton: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    iconLabel: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func
};
var $f53014ba0bcca079$export$2e2bcd8739ae039 = $f53014ba0bcca079$var$TextBoxWithLabel;


//
// WARNING
//
// Do not make manual changes to this file.
// This file was generated by scripts/generate-icons.js.
//
// Generated from: search.svg
//

var $fgmOP = parcelRequire("fgmOP");

function $8a6fb53e81a0c46b$export$82eafebb825fc23f(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("Icon", "Icon--search", props.className),
        style: props.style,
        "aria-hidden": props.title ? undefined : true,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 64 64"
    }, props.title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("title", null, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M58.606 55.543L47.773 44.71a2.153 2.153 0 00-.658-.446c8.248-9.776 7.325-24.316-2.094-32.97-9.419-8.655-23.985-8.347-33.03.698-9.044 9.044-9.352 23.61-.698 33.03 8.654 9.419 23.195 10.342 32.97 2.093.107.245.258.469.446.658l10.833 10.834a2.166 2.166 0 103.064-3.064zm-29.698-7.135c-10.77 0-19.5-8.73-19.5-19.5s8.73-19.5 19.5-19.5 19.5 8.73 19.5 19.5c-.013 10.765-8.736 19.488-19.5 19.5z",
        clipRule: "evenodd"
    }));
}



function $cb565f02c681ee8f$var$_extends() {
    $cb565f02c681ee8f$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cb565f02c681ee8f$var$_extends.apply(this, arguments);
}
function $cb565f02c681ee8f$var$_slicedToArray(arr, i) {
    return $cb565f02c681ee8f$var$_arrayWithHoles(arr) || $cb565f02c681ee8f$var$_iterableToArrayLimit(arr, i) || $cb565f02c681ee8f$var$_unsupportedIterableToArray(arr, i) || $cb565f02c681ee8f$var$_nonIterableRest();
}
function $cb565f02c681ee8f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cb565f02c681ee8f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cb565f02c681ee8f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cb565f02c681ee8f$var$_arrayLikeToArray(o, minLen);
}
function $cb565f02c681ee8f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cb565f02c681ee8f$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $cb565f02c681ee8f$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $cb565f02c681ee8f$var$KEY_ESC = 27;
function $cb565f02c681ee8f$export$2e2bcd8739ae039(_ref) {
    var onSubmit = _ref.onSubmit, searchLabel = _ref.searchLabel, searchButtonLabel = _ref.searchButtonLabel, searchButtonAbortText = _ref.searchButtonAbortText;
    var _useState = (0, $fgmOP.useState)(false), _useState2 = $cb565f02c681ee8f$var$_slicedToArray(_useState, 2), focused = _useState2[0], setFocused = _useState2[1];
    var _useState3 = (0, $fgmOP.useState)(""), _useState4 = $cb565f02c681ee8f$var$_slicedToArray(_useState3, 2), searchQuery = _useState4[0], setSearchQuery = _useState4[1];
    var _useState5 = (0, $fgmOP.useState)(false), _useState6 = $cb565f02c681ee8f$var$_slicedToArray(_useState5, 2), loading = _useState6[0], setLoading = _useState6[1];
    var searchBoxRef = (0, $fgmOP.useRef)();
    var openSearchButton = (0, $fgmOP.useRef)();
    (0, $fgmOP.useEffect)(function() {
        document.addEventListener("keydown", handleKeyDown);
        return function() {
            return document.removeEventListener("keydown", handleKeyDown);
        };
    });
    var handleKeyDown = function handleKeyDown(event) {
        if (event.keyCode === $cb565f02c681ee8f$var$KEY_ESC && focused) closeSeachBox();
    };
    var closeSeachBox = function closeSeachBox() {
        setFocused(false);
        if (openSearchButton.current) openSearchButton.current.focus();
    };
    var handleSubmit = function handleSubmit(e) {
        e.preventDefault();
        if (onSubmit) onSubmit(e, searchQuery);
        setLoading(true);
    };
    var renderSearchField = function renderSearchField(Component) {
        var additionalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(Component, $cb565f02c681ee8f$var$_extends({
            className: "menu__search--open",
            ref: searchBoxRef
        }, additionalProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("form", {
            onSubmit: handleSubmit,
            className: "menu__search--open-form"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $f53014ba0bcca079$export$2e2bcd8739ae039), {
            type: "search",
            autoFocus: true,
            withIcon: true,
            iconName: "ico_search",
            iconLabel: searchButtonLabel,
            disabled: loading,
            iconIsButton: true,
            onIconClick: onSubmit,
            displayLoader: loading,
            small: true,
            hideLabel: true,
            labelText: searchLabel,
            value: searchQuery,
            onChange: function onChange(e) {
                return setSearchQuery(e.target.value);
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("button", {
            className: "menu__search--open-abort-button button button--small",
            onClick: function onClick() {
                return closeSeachBox();
            },
            "aria-label": searchButtonAbortText ? searchButtonAbortText : "Lukk"
        }, searchButtonAbortText ? searchButtonAbortText : "Lukk"));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("menu__search", {
            "menu__search--focused": focused
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("button", {
        ref: openSearchButton,
        className: "menu__search button--stripped",
        onClick: function onClick() {
            return setFocused(true);
        },
        "aria-label": searchButtonLabel ? searchButtonLabel : "S\xf8k"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $8a6fb53e81a0c46b$export$82eafebb825fc23f), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "menu__search--label",
        "aria-label": searchButtonLabel ? searchButtonLabel : "S\xf8k"
    })), focused && renderSearchField((0, $4abcf94e80726891$export$2e2bcd8739ae039), {
        as: "div"
    }));
}
$cb565f02c681ee8f$export$2e2bcd8739ae039.propTypes = {
    onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func,
    searchLabel: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    searchButtonLabel: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    searchButtonAbortText: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
};



var $fgmOP = parcelRequire("fgmOP");

var $fgmOP = parcelRequire("fgmOP");


var $7b56b64578173efe$var$_excluded = [
    "className",
    "text",
    "children",
    "href",
    "iconPosition",
    "iconColor",
    "negative",
    "target",
    "type",
    "inverted"
];
function $7b56b64578173efe$var$_extends() {
    $7b56b64578173efe$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7b56b64578173efe$var$_extends.apply(this, arguments);
}
function $7b56b64578173efe$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $7b56b64578173efe$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $7b56b64578173efe$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $7b56b64578173efe$export$a6c7ac8248d6e38a = function Link(props) {
    var className = props.className, text = props.text, children = props.children, href = props.href, iconPosition = props.iconPosition, _props$iconColor = props.iconColor, iconColor = _props$iconColor === void 0 ? "core-purple" : _props$iconColor, negative = props.negative, _props$target = props.target, target = _props$target === void 0 ? undefined : _props$target, _props$type = props.type, type = _props$type === void 0 ? "link" : _props$type, _props$inverted = props.inverted, inverted = _props$inverted === void 0 ? false : _props$inverted, rest = $7b56b64578173efe$var$_objectWithoutProperties(props, $7b56b64578173efe$var$_excluded);
    var icon;
    // Support for deprecated icons
    function checkForDeprecatedIcons() {
        if (props.icon === "back-icon") return icon = "arrow-left";
        if (props.icon === "forward-icon") return icon = "arrow-right";
        return icon = props.icon;
    }
    checkForDeprecatedIcons();
    if (type === "bubble-link") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("a", $7b56b64578173efe$var$_extends({
        href: href,
        target: target
    }, rest, {
        className: "bubble-link bubble-link--".concat(iconColor).concat(inverted ? "-inverted" : "")
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "bubble-link--flex-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: "bubble-link--icon-circle\n              bubble-link--circle-background--".concat(iconColor).concat(inverted ? "-inverted" : "")
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $2edc691f96482cbe$export$f04a61298a47a40f), {
        icon: icon,
        className: "bubble-link--icon bubble-link--icon-color--".concat(iconColor).concat(inverted ? "-inverted" : "")
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: "bubble-link--text"
    }, children)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("a", $7b56b64578173efe$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))(negative ? "link--negative" : "link", icon && iconColor !== "white" ? "link--icon" : "", icon && iconColor === "white" ? "link--negative--icon" : "", className ? className : undefined),
        style: !icon ? {
            padding: 0
        } : {},
        href: href,
        target: target
    }, rest), icon && iconPosition === "before" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $2edc691f96482cbe$export$f04a61298a47a40f), {
        icon: icon,
        className: "link--icon--before link--".concat(iconColor === "white" ? "negative--" : "", "icon--").concat(iconColor)
    }) : null, text, children, icon && iconPosition === "after" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $2edc691f96482cbe$export$f04a61298a47a40f), {
        icon: icon,
        className: "link--icon--after link--".concat(iconColor === "white" ? "negative--" : "", "icon--").concat(iconColor)
    }) : null);
};
var $7b56b64578173efe$export$2e2bcd8739ae039 = $7b56b64578173efe$export$a6c7ac8248d6e38a;


function $fcbcbe844e23bd39$var$_slicedToArray(arr, i) {
    return $fcbcbe844e23bd39$var$_arrayWithHoles(arr) || $fcbcbe844e23bd39$var$_iterableToArrayLimit(arr, i) || $fcbcbe844e23bd39$var$_unsupportedIterableToArray(arr, i) || $fcbcbe844e23bd39$var$_nonIterableRest();
}
function $fcbcbe844e23bd39$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $fcbcbe844e23bd39$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $fcbcbe844e23bd39$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $fcbcbe844e23bd39$var$_arrayLikeToArray(o, minLen);
}
function $fcbcbe844e23bd39$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $fcbcbe844e23bd39$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $fcbcbe844e23bd39$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $fcbcbe844e23bd39$var$MenuDropdown = function MenuDropdown(props) {
    var dropdownMenu = props.dropdownMenu, isLoggedIn = props.isLoggedIn, daasLink = props.daasLink, logoutUrl = props.logoutUrl;
    if (!dropdownMenu) return null;
    var _useState = (0, $fgmOP.useState)(dropdownMenu.type), _useState2 = $fcbcbe844e23bd39$var$_slicedToArray(_useState, 2), type = _useState2[0], setType = _useState2[1];
    function checkEnv(host) {
        if (host === "stage.telia.no" || host === "at-min-side.telia.no") return "https://stage.telia.no";
        if (host === "pt.stage.telia.no") return "https://pt.stage.telia.no/min-side/";
        return false;
    }
    var stageEnv = checkEnv(window.location.host);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "menu__dropdown"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "menu__dropdown--button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("button", {
        className: "button button--link ".concat(type === "B2C" ? "button--active" : ""),
        onClick: function onClick() {
            return setType("B2C");
        }
    }, "Privat"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("button", {
        className: "button button--link ".concat(type === "B2B" ? "button--active" : ""),
        onClick: function onClick() {
            return setType("B2B");
        }
    }, "Bedrift")), type === "B2C" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "menu__dropdown--links"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $7b56b64578173efe$export$2e2bcd8739ae039), {
        type: "bubble-link",
        href: stageEnv ? "".concat(stageEnv, "/min-side/") : "https://www.telia.no/minside/hjem",
        icon: "home",
        inverted: dropdownMenu.channel !== "mobil"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        style: {
            marginLeft: ".5rem"
        }
    }, "Hjem"))), type === "B2B" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "menu__dropdown--links"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $7b56b64578173efe$export$2e2bcd8739ae039), {
        type: "bubble-link",
        href: "https://minbedrift.telia.no/",
        icon: "mobile",
        inverted: dropdownMenu.channel !== "min-bedrift"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        style: {
            marginLeft: ".5rem"
        }
    }, "Min Bedrift")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $7b56b64578173efe$export$2e2bcd8739ae039), {
        type: "bubble-link",
        href: "https://minportal.telia.no/",
        icon: "wireless",
        inverted: dropdownMenu.channel !== "min-portal"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        style: {
            marginLeft: ".5rem"
        }
    }, "Min Portal")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $7b56b64578173efe$export$2e2bcd8739ae039), {
        type: "bubble-link",
        href: "https://sb.telia.no/bn/login",
        icon: "product-bedriftsnett",
        inverted: dropdownMenu.channel !== "bedriftsnett"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        style: {
            marginLeft: ".5rem"
        }
    }, "Bedriftsnett")), daasLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $7b56b64578173efe$export$2e2bcd8739ae039), {
        type: "bubble-link",
        href: daasLink.url,
        icon: "mobile",
        inverted: dropdownMenu.channel !== "min-bedrift"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        style: {
            marginLeft: ".5rem"
        }
    }, daasLink.text)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        style: {
            marginBottom: "1rem"
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $7b56b64578173efe$export$2e2bcd8739ae039), {
        href: "https://www.telia.no/bedrift/info/",
        icon: "list-view",
        iconPosition: "before",
        iconColor: "black",
        style: {
            marginLeft: "2.25rem"
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        style: {
            paddingLeft: ".8rem"
        }
    }, "Andre portaler"))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "menu__dropdown--logout"
    }, !isLoggedIn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("p", {
        className: "menu__dropdown--logout--not-logged-in"
    }, "Logg ut"), isLoggedIn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $7b56b64578173efe$export$2e2bcd8739ae039), {
        href: logoutUrl !== null && logoutUrl !== void 0 ? logoutUrl : "https://www.telia.no/logout/"
    }, "Logg ut")));
};
var $fcbcbe844e23bd39$export$2e2bcd8739ae039 = $fcbcbe844e23bd39$var$MenuDropdown;



var $fgmOP = parcelRequire("fgmOP");
//
// WARNING
//
// Do not make manual changes to this file.
// This file was generated by scripts/generate-icons.js.
//
// Generated from: shoppingcart.svg
//

var $fgmOP = parcelRequire("fgmOP");

function $191e75bcf8f90869$export$efbbf2b401951550(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("Icon", "Icon--shoppingcart", props.className),
        style: props.style,
        "aria-hidden": props.title ? undefined : true,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 64 64"
    }, props.title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("title", null, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M47.44 44a6 6 0 005.82-4.54L57.88 21A4 4 0 0054 16H17.24l-1-4.78A4 4 0 0012.36 8H6a2 2 0 100 4h6.36l7.3 36.48a6 6 0 108 7.52h14.7a6 6 0 100-4H27.65a6 6 0 00-4-3.75L22.84 44h24.6zM54 20l-4.62 18.49A2 2 0 0147.44 40H22l-4-20h36zM22 56a2 2 0 110-4 2 2 0 110 4zm26-4a2 2 0 110 4 2 2 0 010-4z"
    }));
}


var $311b3bc38fba1e04$var$MenuCart = function MenuCart(_ref) {
    var _ref$onClick = _ref.onClick, onClick = _ref$onClick === void 0 ? function(_event) {
        return undefined;
    } : _ref$onClick, numberOfItemsInCart = _ref.numberOfItemsInCart;
    var handleClick = function handleClick(event) {
        event.stopPropagation();
        onClick(event);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("button", {
        className: "menu-cart__button",
        onClick: handleClick,
        "aria-label": "Kasse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "menu-cart__icon-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $191e75bcf8f90869$export$efbbf2b401951550), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: "menu-cart__item-count"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: "menu-cart__item-count-text"
    }, numberOfItemsInCart))));
};
var $311b3bc38fba1e04$export$2e2bcd8739ae039 = $311b3bc38fba1e04$var$MenuCart;


//
// WARNING
//
// Do not make manual changes to this file.
// This file was generated by scripts/generate-icons.js.
//
// Generated from: menu.svg
//

var $fgmOP = parcelRequire("fgmOP");

function $b472cb2d4da653aa$export$46e1d66043f363e6(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("Icon", "Icon--menu", props.className),
        style: props.style,
        "aria-hidden": props.title ? undefined : true,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 64 64"
    }, props.title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("title", null, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M10.333 16.833c0-1.196.97-2.166 2.167-2.166h39a2.167 2.167 0 110 4.333h-39a2.167 2.167 0 01-2.167-2.167zM51.5 45h-39a2.167 2.167 0 100 4.333h39a2.167 2.167 0 100-4.333zm0-15.167h-39a2.167 2.167 0 000 4.334h39a2.167 2.167 0 000-4.334z",
        clipRule: "evenodd"
    }));
}

//
// WARNING
//
// Do not make manual changes to this file.
// This file was generated by scripts/generate-icons.js.
//
// Generated from: user.svg
//

var $fgmOP = parcelRequire("fgmOP");

function $022489766ffb92ac$export$4202723ba73439f5(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("Icon", "Icon--user", props.className),
        style: props.style,
        "aria-hidden": props.title ? undefined : true,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 64 64"
    }, props.title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("title", null, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M45.61 30.36A15.78 15.78 0 0048 22c0-8.837-7.163-16-16-16s-16 7.163-16 16a15.78 15.78 0 002.39 8.36A18 18 0 004 48v2a8 8 0 008 8h40a8 8 0 008-8v-2a18 18 0 00-14.39-17.64zM32 10c6.627 0 12 5.373 12 12s-5.373 12-12 12-12-5.373-12-12 5.373-12 12-12zm24 40a4 4 0 01-4 4H12a4 4 0 01-4-4v-2c-.005-7.533 5.952-13.72 13.48-14a15.92 15.92 0 0021 0c7.544.259 13.524 6.452 13.52 14v2z"
    }));
}


function $d4f93dcb9a6ad409$var$_slicedToArray(arr, i) {
    return $d4f93dcb9a6ad409$var$_arrayWithHoles(arr) || $d4f93dcb9a6ad409$var$_iterableToArrayLimit(arr, i) || $d4f93dcb9a6ad409$var$_unsupportedIterableToArray(arr, i) || $d4f93dcb9a6ad409$var$_nonIterableRest();
}
function $d4f93dcb9a6ad409$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d4f93dcb9a6ad409$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d4f93dcb9a6ad409$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d4f93dcb9a6ad409$var$_arrayLikeToArray(o, minLen);
}
function $d4f93dcb9a6ad409$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d4f93dcb9a6ad409$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $d4f93dcb9a6ad409$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $d4f93dcb9a6ad409$var$ItemWithSubmenu = function ItemWithSubmenu(_ref) {
    var onToggleSubmenu = _ref.onToggleSubmenu, isOpen = _ref.isOpen, text = _ref.text, subLinks = _ref.subLinks, LinkTemplate = _ref.LinkTemplate, isActive = _ref.isActive;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("button--stripped menu__item link menu__submenu", {
            "menu__submenu--active": isActive
        }),
        onClick: onToggleSubmenu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: "menu__submenu-link"
    }, text, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $058eda357a1eb9d2$export$2e2bcd8739ae039), {
        iconName: "ico_dropArrow",
        color: "purple",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("icon-link__icon menu__submenu-icon", {
            "menu__submenu-icon--open": isOpen
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("menu__submenu-container", {
            "menu__submenu-container--open": isOpen
        })
    }, subLinks.map(function(sublink) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(LinkTemplate, {
            key: sublink.text,
            className: "menu__subitem link",
            url: sublink.url
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
            className: "link__content"
        }, sublink.text));
    })));
};
var $d4f93dcb9a6ad409$var$MenuLinkItem = function MenuLinkItem(_ref2) {
    var link = _ref2.link, LinkTemplate = _ref2.LinkTemplate, onToggleSubmenu = _ref2.onToggleSubmenu, isSubmenuOpen = _ref2.isSubmenuOpen, isActive = _ref2.isActive;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("li", null, link.url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(LinkTemplate, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("menu__item link", {
            "menu__item--active": isActive
        }),
        url: link.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: "link__content"
    }, link.text)), !link.url && link.subLinks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($d4f93dcb9a6ad409$var$ItemWithSubmenu, {
        text: link.text,
        subLinks: link.subLinks,
        onToggleSubmenu: onToggleSubmenu,
        isOpen: isSubmenuOpen,
        isActive: isActive,
        LinkTemplate: LinkTemplate
    }));
};
var $d4f93dcb9a6ad409$var$LoginButton = function LoginButton(_ref3) {
    var loginUrl = _ref3.loginUrl, LinkTemplate = _ref3.LinkTemplate, _ref3$value = _ref3.value, value = _ref3$value === void 0 ? "logg inn" : _ref3$value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(LinkTemplate, {
        className: "menu__login-button menu__login-button__mobile",
        url: loginUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $022489766ffb92ac$export$4202723ba73439f5), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(LinkTemplate, {
        className: "menu__login-button menu__login-button__desktop button button--small",
        url: loginUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $022489766ffb92ac$export$4202723ba73439f5), {
        style: {
            height: "1rem"
        }
    }), value));
};
var $d4f93dcb9a6ad409$var$MyPageButton = function MyPageButton(_ref4) {
    var myPageUrl = _ref4.myPageUrl, LinkTemplate = _ref4.LinkTemplate, _ref4$value = _ref4.value, value = _ref4$value === void 0 ? "min side" : _ref4$value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(LinkTemplate, {
        className: "menu__mypage-button menu__mypage-button__mobile",
        url: myPageUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $022489766ffb92ac$export$4202723ba73439f5), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(LinkTemplate, {
        className: "menu__mypage-button menu__mypage-button__desktop button button--small",
        url: myPageUrl
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $022489766ffb92ac$export$4202723ba73439f5), {
        style: {
            height: "1rem"
        }
    }), value));
};
var $d4f93dcb9a6ad409$var$MyAppsDropdown = function MyAppsDropdown(_ref5) {
    var onClick = _ref5.onClick;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("button", {
        className: "menu__mypage-button menu__mypage-button__mobile",
        onClick: onClick,
        style: {
            marginRight: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $022489766ffb92ac$export$4202723ba73439f5), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("button", {
        className: "menu__mypage-button menu__mypage-button__desktop button button--small",
        onClick: onClick,
        style: {
            marginRight: 0
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $022489766ffb92ac$export$4202723ba73439f5), {
        style: {
            height: "1rem"
        }
    }), "mine sider"));
};
var $d4f93dcb9a6ad409$var$MobileMenuButton = function MobileMenuButton(_ref6) {
    var onMenuToggle = _ref6.onMenuToggle;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("button", {
        className: "menu__mobile-button",
        onClick: onMenuToggle,
        "aria-label": "Meny"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $b472cb2d4da653aa$export$46e1d66043f363e6), null));
};
var $d4f93dcb9a6ad409$var$MenuLogo = function MenuLogo(_ref7) {
    var _ref7$logo = _ref7.logo, url = _ref7$logo.url, image = _ref7$logo.image, imageInverted = _ref7$logo.imageInverted, title = _ref7$logo.title, LinkTemplate = _ref7.LinkTemplate, onlyLogo = _ref7.onlyLogo;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(LinkTemplate, {
        url: url,
        className: "menu__logo-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("img", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("menu__logo", {
            "menu__logo--only": onlyLogo
        }),
        src: image,
        alt: title
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("img", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("menu__logo--inverted", {
            "menu__logo--only": onlyLogo
        }),
        src: imageInverted,
        alt: ""
    }));
};
var $d4f93dcb9a6ad409$var$MenuContent = function MenuContent(_ref8) {
    var menuLink = _ref8.menuLink, buttonValues = _ref8.buttonValues, openedSubmenuIndex = _ref8.openedSubmenuIndex, activeIndex = _ref8.activeIndex, _onToggleSubmenu = _ref8.onToggleSubmenu, logo = _ref8.logo, LinkTemplate = _ref8.LinkTemplate, onMobileMenuToggle = _ref8.onMobileMenuToggle, onSearchSubmit = _ref8.onSearchSubmit, searchLabel = _ref8.searchLabel, searchButtonLabel = _ref8.searchButtonLabel, searchButtonAbortText = _ref8.searchButtonAbortText, isLoggedIn = _ref8.isLoggedIn, logoutUrl = _ref8.logoutUrl, loginUrl = _ref8.loginUrl, myPageUrl = _ref8.myPageUrl, isLoading = _ref8.isLoading, onlyLogo = _ref8.onlyLogo, dropdownMenu = _ref8.dropdownMenu, onCartClick = _ref8.onCartClick, numberOfItemsInCart = _ref8.numberOfItemsInCart, daasLink = _ref8.daasLink;
    var _useState = (0, $fgmOP.useState)(!!(dropdownMenu !== null && dropdownMenu !== void 0 && dropdownMenu.visible)), _useState2 = $d4f93dcb9a6ad409$var$_slicedToArray(_useState, 2), menuDropdownIsVisible = _useState2[0], setMenuDropdownVisibilty = _useState2[1];
    var shouldShowCartIcon = !!onCartClick && numberOfItemsInCart > 0;
    var toggleMenuDropdownVisibilty = function toggleMenuDropdownVisibilty() {
        setMenuDropdownVisibilty(!menuDropdownIsVisible);
    };
    if (onlyLogo) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "menu__content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($d4f93dcb9a6ad409$var$MenuLogo, {
        LinkTemplate: LinkTemplate,
        logo: logo,
        onlyLogo: onlyLogo
    }), shouldShowCartIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "menu__content-panel"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "menu__content-right"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $311b3bc38fba1e04$export$2e2bcd8739ae039), {
        onClick: onCartClick,
        numberOfItemsInCart: numberOfItemsInCart
    }))));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "menu__content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($d4f93dcb9a6ad409$var$MenuLogo, {
        LinkTemplate: LinkTemplate,
        logo: logo
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $fc098853ee9e916f$export$2e2bcd8739ae039), null), menuLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("ul", {
        id: "".concat(menuLink.heading && menuLink.heading.text, "-panel"),
        className: "menu__content-panel"
    }, menuLink.links.map(function(link, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($d4f93dcb9a6ad409$var$MenuLinkItem, {
            LinkTemplate: LinkTemplate,
            isSubmenuOpen: openedSubmenuIndex === index,
            isActive: activeIndex === index,
            onToggleSubmenu: function onToggleSubmenu(event) {
                return _onToggleSubmenu(index, event);
            },
            key: link.text,
            link: link
        });
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "menu__content-right"
    }, onSearchSubmit && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $cb565f02c681ee8f$export$2e2bcd8739ae039), {
        onSubmit: onSearchSubmit,
        searchLabel: searchLabel,
        searchButtonLabel: searchButtonLabel,
        searchButtonAbortText: searchButtonAbortText
    }), shouldShowCartIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $311b3bc38fba1e04$export$2e2bcd8739ae039), {
        onClick: onCartClick,
        numberOfItemsInCart: numberOfItemsInCart
    }), loginUrl && !isLoggedIn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($d4f93dcb9a6ad409$var$LoginButton, {
        LinkTemplate: LinkTemplate,
        loginUrl: loginUrl,
        value: buttonValues === null || buttonValues === void 0 ? void 0 : buttonValues.login
    }), myPageUrl && isLoggedIn && !dropdownMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($d4f93dcb9a6ad409$var$MyPageButton, {
        LinkTemplate: LinkTemplate,
        myPageUrl: myPageUrl,
        onClick: toggleMenuDropdownVisibilty,
        value: buttonValues === null || buttonValues === void 0 ? void 0 : buttonValues.myPage
    }), myPageUrl && isLoggedIn && dropdownMenu && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($d4f93dcb9a6ad409$var$MyAppsDropdown, {
        LinkTemplate: LinkTemplate,
        onClick: toggleMenuDropdownVisibilty
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($d4f93dcb9a6ad409$var$MobileMenuButton, {
        onMenuToggle: onMobileMenuToggle
    })), menuDropdownIsVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $fcbcbe844e23bd39$export$2e2bcd8739ae039), {
        dropdownMenu: dropdownMenu,
        isLoggedIn: isLoggedIn,
        daasLink: daasLink,
        logoutUrl: logoutUrl
    }));
};
$d4f93dcb9a6ad409$var$MenuContent.propTypes = {
    menuLink: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
        links: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).array,
        heading: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
            text: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
        })
    }),
    buttonValues: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
        login: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
        myPage: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
    }),
    logo: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
        url: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
    }),
    openedSubmenuIndex: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).number,
    onToggleSubmenu: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func,
    searchLabel: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    searchButtonAbortText: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    onlyLogo: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool
};
var $d4f93dcb9a6ad409$export$2e2bcd8739ae039 = $d4f93dcb9a6ad409$var$MenuContent;



var $fgmOP = parcelRequire("fgmOP");


var $jPPOv = parcelRequire("jPPOv");


var $fgmOP = parcelRequire("fgmOP");

var $jPPOv = parcelRequire("jPPOv");
//
// WARNING
//
// Do not make manual changes to this file.
// This file was generated by scripts/generate-icons.js.
//
// Generated from: chevron-down.svg
//

var $fgmOP = parcelRequire("fgmOP");

function $b77da9cb7d9580ee$export$4857d3f3f5f8319b(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("Icon", "Icon--chevron-down", props.className),
        style: props.style,
        "aria-hidden": props.title ? undefined : true,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 64 64"
    }, props.title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("title", null, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M53.032 24.865l-19.5 19.5a2.166 2.166 0 01-3.064 0l-19.5-19.5a2.166 2.166 0 113.064-3.064L32 39.77 49.968 21.8a2.167 2.167 0 013.064 3.064z",
        clipRule: "evenodd"
    }));
}



var $fgmOP = parcelRequire("fgmOP");

var $jPPOv = parcelRequire("jPPOv");
var $1d5c3300446b5bd9$var$MobileSubmenu = function MobileSubmenu(_ref) {
    var link = _ref.link, LinkTemplate = _ref.LinkTemplate, onItemSelected = _ref.onItemSelected;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "menu__mobile-submenu"
    }, link.subLinks.map(function(sublink, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(LinkTemplate, {
            onClick: function onClick() {
                return onItemSelected(index, sublink);
            },
            key: sublink.text,
            className: "menu__mobile-subitem link",
            url: sublink.url
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
            className: "link__content"
        }, sublink.text));
    }));
};
$1d5c3300446b5bd9$var$MobileSubmenu.propTypes = {
    link: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
        text: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
        url: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
    }),
    onItemSelected: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func,
    LinkTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func
};
var $1d5c3300446b5bd9$export$2e2bcd8739ae039 = $1d5c3300446b5bd9$var$MobileSubmenu;


function $8403c10500878c91$var$_slicedToArray(arr, i) {
    return $8403c10500878c91$var$_arrayWithHoles(arr) || $8403c10500878c91$var$_iterableToArrayLimit(arr, i) || $8403c10500878c91$var$_unsupportedIterableToArray(arr, i) || $8403c10500878c91$var$_nonIterableRest();
}
function $8403c10500878c91$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8403c10500878c91$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8403c10500878c91$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8403c10500878c91$var$_arrayLikeToArray(o, minLen);
}
function $8403c10500878c91$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8403c10500878c91$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $8403c10500878c91$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $8403c10500878c91$var$MobileMenuItemWithDropdown = function MobileMenuItemWithDropdown(_ref) {
    var link = _ref.link, onItemSelected = _ref.onItemSelected, LinkTemplate = _ref.LinkTemplate;
    var _useState = (0, $fgmOP.useState)(false), _useState2 = $8403c10500878c91$var$_slicedToArray(_useState, 2), isExpanded = _useState2[0], setIsExpanded = _useState2[1];
    var isExpandedClass = isExpanded ? "expanded" : "not-expanded";
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "menu__mobile-dropdown-menu",
        onClick: function onClick() {
            return setIsExpanded(!isExpanded);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("button", {
        className: "menu__mobile-dropdown-menu__arrow-button",
        onClick: function onClick() {
            return setIsExpanded(!isExpanded);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $b77da9cb7d9580ee$export$4857d3f3f5f8319b), {
        className: "menu__mobile-dropdown-menu__arrow-icon ".concat(isExpandedClass)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: "menu__mobile-dropdown-menu__header"
    }, link.text), isExpanded && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $1d5c3300446b5bd9$export$2e2bcd8739ae039), {
        link: link,
        onItemSelected: onItemSelected,
        LinkTemplate: LinkTemplate
    }));
};
$8403c10500878c91$var$MobileMenuItemWithDropdown.propTypes = {
    link: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
        text: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
        url: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
    }),
    onItemSelected: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func,
    LinkTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func
};
var $8403c10500878c91$export$2e2bcd8739ae039 = $8403c10500878c91$var$MobileMenuItemWithDropdown;



var $fgmOP = parcelRequire("fgmOP");

var $jPPOv = parcelRequire("jPPOv");

//
// WARNING
//
// Do not make manual changes to this file.
// This file was generated by scripts/generate-icons.js.
//
// Generated from: close.svg
//

var $fgmOP = parcelRequire("fgmOP");

function $d49814c0aa714622$export$cae179f078f4b4a4(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("Icon", "Icon--close", props.className),
        style: props.style,
        "aria-hidden": props.title ? undefined : true,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 64 64"
    }, props.title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("title", null, props.title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        fillRule: "evenodd",
        d: "M51.365 48.301a2.166 2.166 0 01-3.063 3.064L32.5 35.563 16.7 51.365a2.166 2.166 0 01-3.064-3.064l15.8-15.801-15.801-15.802a2.166 2.166 0 013.064-3.064L32.5 29.436l15.802-15.802a2.167 2.167 0 013.063 3.064L35.564 32.5l15.801 15.8z",
        clipRule: "evenodd"
    }));
}


var $7ac3829989293c8e$var$MobileMenuCloseButton = function MobileMenuCloseButton(_ref) {
    var onClick = _ref.onClick, mobileMenuCloseButtonLabel = _ref.mobileMenuCloseButtonLabel, _ref$value = _ref.value, value = _ref$value === void 0 ? "Lukk" : _ref$value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("button", {
        className: "menu__mobile-close-button",
        onClick: onClick,
        "aria-label": mobileMenuCloseButtonLabel ? mobileMenuCloseButtonLabel : "Lukk"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", null, value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $d49814c0aa714622$export$cae179f078f4b4a4), {
        className: "menu__mobile-close-button-icon"
    }));
};
var $7ac3829989293c8e$var$MobileMenuHeaderItem = function MobileMenuHeaderItem(_ref2) {
    var index = _ref2.index, onHeaderItemSelected = _ref2.onHeaderItemSelected, menuLink = _ref2.menuLink, isActive = _ref2.isActive, LinkTemplate = _ref2.LinkTemplate;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("li", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        onClick: function onClick(e) {
            if (!isActive) e.preventDefault();
            onHeaderItemSelected(index);
        },
        tabIndex: "0",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("menu__mobile-heading-item", {
            "menu__mobile-heading-item--active": isActive
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(LinkTemplate, {
        className: "menu__mobile-heading-item-link",
        url: menuLink.heading.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: "menu__mobile-heading-item-text"
    }, menuLink.heading && menuLink.heading.text))));
};
var $7ac3829989293c8e$var$MobileMenuHeader = function MobileMenuHeader(_ref3) {
    var onMobileMenuToggle = _ref3.onMobileMenuToggle, menuLinks = _ref3.menuLinks, LinkTemplate = _ref3.LinkTemplate, selectedIndex = _ref3.selectedIndex, onHeaderItemSelected = _ref3.onHeaderItemSelected, mobileMenuCloseButtonLabel = _ref3.mobileMenuCloseButtonLabel, closeButtonValue = _ref3.closeButtonValue;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "menu__mobile-header"
    }, menuLinks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("ul", {
        className: "menu__mobile-heading-links"
    }, menuLinks.map(function(menuLink, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($7ac3829989293c8e$var$MobileMenuHeaderItem, {
            key: menuLink.heading ? menuLink.heading.text : index,
            index: index,
            LinkTemplate: LinkTemplate,
            menuLink: menuLink,
            isActive: selectedIndex === index,
            onHeaderItemSelected: onHeaderItemSelected
        });
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($7ac3829989293c8e$var$MobileMenuCloseButton, {
        onClick: onMobileMenuToggle,
        mobileMenuCloseButtonLabel: mobileMenuCloseButtonLabel,
        value: closeButtonValue
    }));
};
$7ac3829989293c8e$var$MobileMenuHeader.propTypes = {
    LinkTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func,
    onMobileMenuToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func,
    menuLinks: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
        heading: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
            text: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
            url: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
        }),
        links: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
            text: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
            url: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
        }))
    })),
    mobileMenuCloseButtonLabel: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
};
var $7ac3829989293c8e$export$2e2bcd8739ae039 = $7ac3829989293c8e$var$MobileMenuHeader;



var $fgmOP = parcelRequire("fgmOP");

var $jPPOv = parcelRequire("jPPOv");
var $5dbbb97a4de6e96b$var$MobileMenuItem = function MobileMenuItem(_ref) {
    var link = _ref.link, onItemSelected = _ref.onItemSelected, LinkTemplate = _ref.LinkTemplate;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(LinkTemplate, {
        onClick: onItemSelected,
        className: "menu__mobile-item link",
        url: link.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: "link__content"
    }, link.text)));
};
$5dbbb97a4de6e96b$var$MobileMenuItem.propTypes = {
    link: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
        text: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
        url: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
    }),
    onItemSelected: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func,
    LinkTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func
};
var $5dbbb97a4de6e96b$export$2e2bcd8739ae039 = $5dbbb97a4de6e96b$var$MobileMenuItem;



var $fgmOP = parcelRequire("fgmOP");

var $jPPOv = parcelRequire("jPPOv");

var $df87aa9253aa7ee2$var$_excluded = [
    "className",
    "short",
    "left"
];
function $df87aa9253aa7ee2$var$_extends() {
    $df87aa9253aa7ee2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $df87aa9253aa7ee2$var$_extends.apply(this, arguments);
}
function $df87aa9253aa7ee2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $df87aa9253aa7ee2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $df87aa9253aa7ee2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $df87aa9253aa7ee2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Status: *finished*
 * Category: Misc
 *
 * The css-class <code>.horizontal-rule</code> can be used on any element to give it a grey border in bottom of
 * the element, or it can be used on the <code>&lt;hr/&gt;</code> tag as a standalone component.
 * The style should be used to define a thematic break.
 */ var $df87aa9253aa7ee2$var$HorizontalRule = function HorizontalRule(_ref) {
    var _classnames;
    var className = _ref.className, _short = _ref["short"], left = _ref.left, rest = $df87aa9253aa7ee2$var$_objectWithoutProperties(_ref, $df87aa9253aa7ee2$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("hr", $df87aa9253aa7ee2$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("horizontal-rule", (_classnames = {}, $df87aa9253aa7ee2$var$_defineProperty(_classnames, className, className), $df87aa9253aa7ee2$var$_defineProperty(_classnames, "horizontal-rule--short", _short), $df87aa9253aa7ee2$var$_defineProperty(_classnames, "horizontal-rule--left", left), _classnames))
    }, rest));
};
$df87aa9253aa7ee2$var$HorizontalRule.propTypes = {
    /** Whenever this should be short or not. */ "short": (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    /** Whenever this should be left aligned. */ left: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool
};
var $df87aa9253aa7ee2$export$2e2bcd8739ae039 = $df87aa9253aa7ee2$var$HorizontalRule;


function $8c3f1ccb77f75e30$var$_slicedToArray(arr, i) {
    return $8c3f1ccb77f75e30$var$_arrayWithHoles(arr) || $8c3f1ccb77f75e30$var$_iterableToArrayLimit(arr, i) || $8c3f1ccb77f75e30$var$_unsupportedIterableToArray(arr, i) || $8c3f1ccb77f75e30$var$_nonIterableRest();
}
function $8c3f1ccb77f75e30$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $8c3f1ccb77f75e30$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $8c3f1ccb77f75e30$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $8c3f1ccb77f75e30$var$_arrayLikeToArray(o, minLen);
}
function $8c3f1ccb77f75e30$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $8c3f1ccb77f75e30$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $8c3f1ccb77f75e30$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $8c3f1ccb77f75e30$var$KEY_ESC = 27;
var $8c3f1ccb77f75e30$var$MobileMenuItemSection = function MobileMenuItemSection(_ref) {
    var menuLink = _ref.menuLink, onItemSelected = _ref.onItemSelected, LinkTemplate = _ref.LinkTemplate, _ref$value = _ref.value, value = _ref$value === void 0 ? "Forside" : _ref$value;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("section", {
        id: "".concat(menuLink.heading && menuLink.heading.text, "-mobile-panel"),
        className: "menu__mobile-panel"
    }, menuLink.heading && menuLink.heading.url && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(LinkTemplate, {
        onClick: onItemSelected,
        className: "menu__mobile-item link",
        url: menuLink.heading.url
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: "link__content"
    }, value)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $df87aa9253aa7ee2$export$2e2bcd8739ae039), null)), menuLink.links.map(function(link, index) {
        if (link.subLinks) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
            key: link.text
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $8403c10500878c91$export$2e2bcd8739ae039), {
            index: index,
            link: link,
            onItemSelected: onItemSelected,
            LinkTemplate: LinkTemplate
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $df87aa9253aa7ee2$export$2e2bcd8739ae039), null));
        else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
            key: link.text
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $5dbbb97a4de6e96b$export$2e2bcd8739ae039), {
            index: index,
            link: link,
            onItemSelected: onItemSelected,
            LinkTemplate: LinkTemplate
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $df87aa9253aa7ee2$export$2e2bcd8739ae039), null));
    }));
};
var $8c3f1ccb77f75e30$var$MobileMenu = function MobileMenu(_ref2) {
    var isOpen = _ref2.isOpen, LinkTemplate = _ref2.LinkTemplate, onMobileMenuToggle = _ref2.onMobileMenuToggle, menuLinks = _ref2.menuLinks, onMenuItemSelected = _ref2.onMenuItemSelected, isLoading = _ref2.isLoading, activeIndex = _ref2.activeIndex, mobileMenuCloseButtonLabel = _ref2.mobileMenuCloseButtonLabel, buttonValues = _ref2.buttonValues;
    var _useState = (0, $fgmOP.useState)(activeIndex !== null && activeIndex !== void 0 ? activeIndex : 0), _useState2 = $8c3f1ccb77f75e30$var$_slicedToArray(_useState, 2), selectedHeaderIndex = _useState2[0], setSelectedHeaderIndex = _useState2[1];
    (0, $fgmOP.useEffect)(function() {
        document.addEventListener("keydown", handleKeyDown);
        return function() {
            return document.removeEventListener("keydown", handleKeyDown);
        };
    });
    var handleKeyDown = function handleKeyDown(event) {
        if (event.keyCode === $8c3f1ccb77f75e30$var$KEY_ESC) onMobileMenuToggle();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "menu__overlay"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("menu__mobile", {
            "menu__mobile--open": isOpen
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $7ac3829989293c8e$export$2e2bcd8739ae039), {
        onMobileMenuToggle: onMobileMenuToggle,
        menuLinks: menuLinks,
        LinkTemplate: LinkTemplate,
        selectedIndex: selectedHeaderIndex,
        onHeaderItemSelected: function onHeaderItemSelected(index) {
            return setSelectedHeaderIndex(index);
        },
        mobileMenuCloseButtonLabel: mobileMenuCloseButtonLabel,
        closeButtonValue: buttonValues === null || buttonValues === void 0 ? void 0 : buttonValues.closeButton
    }), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $fc098853ee9e916f$export$2e2bcd8739ae039), null), menuLinks && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($8c3f1ccb77f75e30$var$MobileMenuItemSection, {
        menuLink: menuLinks[selectedHeaderIndex],
        onItemSelected: onMenuItemSelected,
        value: buttonValues === null || buttonValues === void 0 ? void 0 : buttonValues.frontPage,
        LinkTemplate: LinkTemplate
    })));
};
$8c3f1ccb77f75e30$var$MobileMenu.propTypes = {
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    LinkTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func,
    onMobileMenuToggle: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func,
    menuLinks: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
        heading: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
            text: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
            url: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
        }),
        links: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
            text: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
            url: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
        }))
    })),
    buttonValues: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
        frontPage: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
        closeButton: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
    }),
    onMenuItemSelected: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    mobileMenuCloseButtonLabel: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
};
var $8c3f1ccb77f75e30$export$2e2bcd8739ae039 = $8c3f1ccb77f75e30$var$MobileMenu;



var $4da52773fae940f2$var$_excluded = [
    "url"
];
function $4da52773fae940f2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4da52773fae940f2$var$_extends() {
    $4da52773fae940f2$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4da52773fae940f2$var$_extends.apply(this, arguments);
}
function $4da52773fae940f2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4da52773fae940f2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4da52773fae940f2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $4da52773fae940f2$var$_slicedToArray(arr, i) {
    return $4da52773fae940f2$var$_arrayWithHoles(arr) || $4da52773fae940f2$var$_iterableToArrayLimit(arr, i) || $4da52773fae940f2$var$_unsupportedIterableToArray(arr, i) || $4da52773fae940f2$var$_nonIterableRest();
}
function $4da52773fae940f2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4da52773fae940f2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4da52773fae940f2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4da52773fae940f2$var$_arrayLikeToArray(o, minLen);
}
function $4da52773fae940f2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4da52773fae940f2$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $4da52773fae940f2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Status: *In progress*.
 * Category: PageElements
 **/ var $4da52773fae940f2$var$Menu = function Menu(_ref) {
    var menuLinks = _ref.menuLinks, buttonValues = _ref.buttonValues, className = _ref.className, logoImageDesktopPath = _ref.logoImageDesktopPath, logoImageInverseDesktopPath = _ref.logoImageInverseDesktopPath, logoTitle = _ref.logoTitle, logoUrl = _ref.logoUrl, activeIndex = _ref.activeIndex, activeLinkIndex = _ref.activeLinkIndex, onSearchSubmit = _ref.onSearchSubmit, searchLabel = _ref.searchLabel, searchButtonLabel = _ref.searchButtonLabel, searchButtonAbortText = _ref.searchButtonAbortText, mobileMenuCloseButtonLabel = _ref.mobileMenuCloseButtonLabel, linkTemplate = _ref.linkTemplate, lockBodyOnMenuOpen = _ref.lockBodyOnMenuOpen, isLoggedIn = _ref.isLoggedIn, loginUrl = _ref.loginUrl, logoutUrl = _ref.logoutUrl, myPageUrl = _ref.myPageUrl, isLoading = _ref.isLoading, onlyLogo = _ref.onlyLogo, dropdownMenu = _ref.dropdownMenu, onCartClick = _ref.onCartClick, numberOfItemsInCart = _ref.numberOfItemsInCart, daasLink = _ref.daasLink;
    var _useState = (0, $fgmOP.useState)(false), _useState2 = $4da52773fae940f2$var$_slicedToArray(_useState, 2), mobileMenuOpen = _useState2[0], setMobileMenuOpen = _useState2[1];
    var _useState3 = (0, $fgmOP.useState)(undefined), _useState4 = $4da52773fae940f2$var$_slicedToArray(_useState3, 2), lastActiveMenuContentElement = _useState4[0], setLastActiveMenuContentElement = _useState4[1];
    var _useState5 = (0, $fgmOP.useState)(-1), _useState6 = $4da52773fae940f2$var$_slicedToArray(_useState5, 2), openedSubmenuIndex = _useState6[0], setOpenedSubmenuIndex = _useState6[1];
    var mobileMenuRef = (0, $fgmOP.useRef)();
    (0, $fgmOP.useEffect)(function() {
        document.addEventListener("click", onClickaway);
        document.addEventListener("keydown", onGlobalKeyDown);
        return function() {
            document.removeEventListener("click", onClickaway);
            document.removeEventListener("keydown", onGlobalKeyDown);
        };
    });
    var defaultLinkTemplate = function defaultLinkTemplate(_ref2) {
        var url = _ref2.url, otherProps = $4da52773fae940f2$var$_objectWithoutProperties(_ref2, $4da52773fae940f2$var$_excluded);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("a", $4da52773fae940f2$var$_extends({
            href: url
        }, otherProps));
    };
    var LinkTemplate = linkTemplate || defaultLinkTemplate;
    var openedSubmenu = null;
    var isDescendant = function isDescendant(parent, child) {
        while(child){
            if (child === parent) return true;
            child = child.parentNode;
        }
        return false;
    };
    var onGlobalKeyDown = function onGlobalKeyDown(e) {
        var key = e.which || e.keyCode;
        if (key === 27 && openedSubmenuIndex !== -1) // escape key
        toggleSubmenu(openedSubmenuIndex, e);
    };
    var onClickaway = function onClickaway(e) {
        if (!openedSubmenu) return;
        if (isDescendant(openedSubmenu, e.target)) return;
        setOpenedSubmenuIndex(-1);
        openedSubmenu = null;
    };
    var toggleMobileMenu = function toggleMobileMenu() {
        if (!mobileMenuOpen) {
            setFocusOnFirstFocusableElement();
            setLastActiveMenuContentElement(document.activeElement);
            if (lockBodyOnMenuOpen) document.body.classList.add("body--locked");
        } else {
            returnFocusOnDialogClose();
            if (lockBodyOnMenuOpen) document.body.classList.remove("body--locked");
        }
        setMobileMenuOpen(!mobileMenuOpen);
    };
    var setFocusOnFirstFocusableElement = function setFocusOnFirstFocusableElement() {
        if (!mobileMenuRef.current) return;
        var focusableElements = mobileMenuRef.current.querySelectorAll((0, $4abcf94e80726891$export$30c0e1e687f23fa3));
        if (!focusableElements.length) return;
        if (!activeIndex || activeIndex === 0) focusableElements[0].focus();
    };
    (0, $fgmOP.useEffect)(setFocusOnFirstFocusableElement);
    var returnFocusOnDialogClose = function returnFocusOnDialogClose() {
        if (lastActiveMenuContentElement) lastActiveMenuContentElement.focus();
    };
    var toggleSubmenu = function toggleSubmenu(submenuIndex, e) {
        e.stopPropagation();
        if (openedSubmenuIndex === submenuIndex) {
            setOpenedSubmenuIndex(-1);
            openedSubmenu = null;
        } else {
            setOpenedSubmenuIndex(submenuIndex);
            openedSubmenu = e.target;
        }
    };
    var renderMobileMenu = function renderMobileMenu(Component) {
        var additionalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(Component, $4da52773fae940f2$var$_extends({
            ref: mobileMenuRef
        }, additionalProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $8c3f1ccb77f75e30$export$2e2bcd8739ae039), {
            isOpen: mobileMenuOpen,
            LinkTemplate: LinkTemplate,
            onMobileMenuToggle: toggleMobileMenu,
            menuLinks: menuLinks,
            activeIndex: activeIndex,
            onMenuItemSelected: toggleMobileMenu,
            isLoading: isLoading,
            mobileMenuCloseButtonLabel: mobileMenuCloseButtonLabel,
            buttonValues: {
                frontPage: buttonValues === null || buttonValues === void 0 ? void 0 : buttonValues.frontPage,
                closeButton: buttonValues === null || buttonValues === void 0 ? void 0 : buttonValues.closeButton
            }
        }));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("menu", $4da52773fae940f2$var$_defineProperty({}, className, className))
    }, !onlyLogo && menuLinks && menuLinks.length > 1 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $455b1208162e5848$export$2e2bcd8739ae039), {
        activeIndex: activeIndex,
        menuLinks: menuLinks,
        LinkTemplate: LinkTemplate
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $d4f93dcb9a6ad409$export$2e2bcd8739ae039), {
        logo: {
            image: logoImageDesktopPath,
            imageInverted: logoImageInverseDesktopPath,
            title: logoTitle,
            url: logoUrl
        },
        LinkTemplate: LinkTemplate,
        menuLink: menuLinks && menuLinks[activeIndex],
        onToggleSubmenu: toggleSubmenu,
        openedSubmenuIndex: openedSubmenuIndex,
        activeIndex: activeLinkIndex,
        loginUrl: loginUrl,
        logoutUrl: logoutUrl,
        onMobileMenuToggle: toggleMobileMenu,
        onSearchSubmit: onSearchSubmit,
        searchLabel: searchLabel,
        searchButtonLabel: searchButtonLabel,
        searchButtonAbortText: searchButtonAbortText,
        isLoggedIn: isLoggedIn,
        myPageUrl: myPageUrl,
        isLoading: isLoading,
        onlyLogo: onlyLogo,
        dropdownMenu: dropdownMenu,
        onCartClick: onCartClick,
        numberOfItemsInCart: numberOfItemsInCart,
        daasLink: daasLink,
        buttonValues: {
            login: buttonValues === null || buttonValues === void 0 ? void 0 : buttonValues.login,
            myPage: buttonValues === null || buttonValues === void 0 ? void 0 : buttonValues.myPage
        }
    }), !onlyLogo && mobileMenuOpen && renderMobileMenu((0, $4abcf94e80726891$export$2e2bcd8739ae039), {
        as: "div"
    }));
};
$4da52773fae940f2$var$Menu.propTypes = {
    menuLinks: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
        heading: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
            text: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
            url: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
        }),
        links: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
            text: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
            url: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
        }))
    })),
    buttonValues: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
        login: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
        myPage: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
        frontPage: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
        closeButton: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
    }),
    logoImageDesktopPath: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    logoImageInverseDesktopPath: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    logoTitle: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    logoUrl: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    activeIndex: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).number,
    activeLinkIndex: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).number,
    onSearchSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func,
    searchLabel: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    searchButtonLabel: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    searchButtonAbortText: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    mobileMenuCloseButtonLabel: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    linkTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func,
    lockBodyOnMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    isLoggedIn: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    loginUrl: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    myPageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    cartUrl: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    onlyLogo: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool
};
var $4da52773fae940f2$export$2e2bcd8739ae039 = $4da52773fae940f2$var$Menu;


parcelRequire("fgmOP");





var $fgmOP = parcelRequire("fgmOP");





const { PRODUCT_OVERVIEW_TYPE_ACCESS_NUMBER: $fd8c6dbb137f29e9$var$PRODUCT_OVERVIEW_TYPE_ACCESS_NUMBER, PRODUCT_OVERVIEW_TYPE_ACCESS_NUMBER_RANGE: $fd8c6dbb137f29e9$var$PRODUCT_OVERVIEW_TYPE_ACCESS_NUMBER_RANGE, PRODUCT_OVERVIEW_TYPE_RESERVED_OA: $fd8c6dbb137f29e9$var$PRODUCT_OVERVIEW_TYPE_RESERVED_OA, PRODUCT_OVERVIEW_TYPE_RBM: $fd8c6dbb137f29e9$var$PRODUCT_OVERVIEW_TYPE_RBM, PRODUCT_OVERVIEW_TYPE_GENERIC: $fd8c6dbb137f29e9$var$PRODUCT_OVERVIEW_TYPE_GENERIC } = (0, $f5d0c2a7498ff49b$exports.constants);
const $fd8c6dbb137f29e9$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useProductOverviewTypes", "INFO");
const $fd8c6dbb137f29e9$export$c7485df156f0670e = ()=>{
    function isAccessNumberOverview(overview) {
        const { productOverviewType: productOverviewType } = overview;
        $fd8c6dbb137f29e9$var$log.debug("isAccessNumberOverview", {
            productOverviewType: productOverviewType
        });
        return productOverviewType === $fd8c6dbb137f29e9$var$PRODUCT_OVERVIEW_TYPE_ACCESS_NUMBER;
    }
    function isAccessNumberRangeOverview(overview) {
        const { productOverviewType: productOverviewType } = overview;
        $fd8c6dbb137f29e9$var$log.debug("isAccessNumberRangeOverview", {
            productOverviewType: productOverviewType
        });
        return productOverviewType === $fd8c6dbb137f29e9$var$PRODUCT_OVERVIEW_TYPE_ACCESS_NUMBER_RANGE;
    }
    function isReservedOaOverview(overview) {
        const { productOverviewType: productOverviewType } = overview;
        $fd8c6dbb137f29e9$var$log.debug("isReservedOaOverview", {
            productOverviewType: productOverviewType
        });
        return productOverviewType === $fd8c6dbb137f29e9$var$PRODUCT_OVERVIEW_TYPE_RESERVED_OA;
    }
    function isRbmOverview(overview) {
        const { productOverviewType: productOverviewType } = overview;
        $fd8c6dbb137f29e9$var$log.debug("isRbmOverview", {
            productOverviewType: productOverviewType
        });
        return productOverviewType === $fd8c6dbb137f29e9$var$PRODUCT_OVERVIEW_TYPE_RBM;
    }
    function isGenericOverview(overview) {
        const { productOverviewType: productOverviewType } = overview;
        $fd8c6dbb137f29e9$var$log.debug("isGenericOverview", {
            productOverviewType: productOverviewType
        });
        return productOverviewType === $fd8c6dbb137f29e9$var$PRODUCT_OVERVIEW_TYPE_GENERIC;
    }
    return {
        isAccessNumberOverview: isAccessNumberOverview,
        isAccessNumberRangeOverview: isAccessNumberRangeOverview,
        isReservedOaOverview: isReservedOaOverview,
        isRbmOverview: isRbmOverview,
        isGenericOverview: isGenericOverview
    };
};



const $8d8d8b3d38044bbe$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useCustomerOverviews", "INFO");
const $8d8d8b3d38044bbe$export$d27d8317adc3c298 = (props = {})=>{
    const { loadingUser: loadingUser, currentUserBrand: currentUserBrand, isTelia: isTelia } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { loading: loadingOverviews, data: { customerOverviews: customerOverviews } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($faa9e9ee47efa167$exports)))), {
        skip: props.skipQuery || !currentUserBrand && !isTelia()
    });
    $8d8d8b3d38044bbe$var$log.debug("customerOverviews", customerOverviews);
    const { getBrand: getBrand } = (0, $97a71fda4fbdc6d3$export$da3999a1d9248c0c)();
    const { isAccessNumberOverview: isAccessNumberOverview, isAccessNumberRangeOverview: isAccessNumberRangeOverview, isReservedOaOverview: isReservedOaOverview, isRbmOverview: isRbmOverview, isGenericOverview: isGenericOverview } = (0, $fd8c6dbb137f29e9$export$c7485df156f0670e)();
    const sortedOverviews = (0, $fgmOP.useMemo)(()=>customerOverviews && [
            ...customerOverviews
        ]?.sort((0, $f5d0c2a7498ff49b$exports.sort).sortByNameComparator) //Sort customers
        .map(({ productOverviews: productOverviews, ...customerOverview })=>({
                ...customerOverview,
                productOverviews: productOverviews.map((overview)=>isReservedOaOverview(overview) ? {
                        ...overview,
                        reservedOas: overview.reservedOas?.slice().sort()
                    } : overview)?.slice().sort((a, b)=>(0, $f5d0c2a7498ff49b$exports.sort).productOverviewsComparator(a, b) || isAccessNumberOverview(a) && isAccessNumberOverview(b) && (0, $f5d0c2a7498ff49b$exports.sort).accessNumbersSortComparator(a.accessNumber, b.accessNumber) || isAccessNumberRangeOverview(a) && isAccessNumberRangeOverview(b) && (0, $f5d0c2a7498ff49b$exports.sort).accessNumbersSortComparator(a.accessNumberRange.from, b.accessNumberRange.from) || isReservedOaOverview(a) && isReservedOaOverview(b) && (0, $f5d0c2a7498ff49b$exports.sort).reservedOaOverviewsComparator(a, b) || isRbmOverview(a) && isRbmOverview(b) && (0, $f5d0c2a7498ff49b$exports.sort).rbmOverviewsComparator(a, b) || 0)
            })), [
        customerOverviews
    ]);
    const brandFilteredSortedOverviews = (0, $fgmOP.useMemo)(()=>sortedOverviews && [
            ...sortedOverviews
        ].filter(({ brandId: brandId })=>brandId === currentUserBrand?.id), [
        sortedOverviews
    ]);
    $8d8d8b3d38044bbe$var$log.debug("sortedCustomerOverviews", sortedOverviews);
    const getCustomerOverview = (customerId)=>customerOverviews && customerOverviews.find(({ id: id })=>id === customerId);
    const getName = (customerId)=>getCustomerOverview(customerId)?.name || customerId;
    const getCurrencyCode = (customerId)=>getBrand(customerId)?.currencyCode || "???";
    const useCustomerOverviewsHook = {
        loading: loadingOverviews || loadingUser,
        customerOverviews: brandFilteredSortedOverviews,
        allCountryCustomerOverviews: sortedOverviews,
        getCustomerOverview: getCustomerOverview,
        getName: getName,
        getCurrencyCode: getCurrencyCode
    };
    $8d8d8b3d38044bbe$var$log.debug(useCustomerOverviewsHook);
    return useCustomerOverviewsHook;
};





var $l8GLF = parcelRequire("l8GLF");

var $602a2a49417b565c$exports = {};
$602a2a49417b565c$exports = new URL("telia-logo-reversed.689ef1ec.png", import.meta.url).toString();


var $2fdaa75c663c5a2e$exports = {};
$2fdaa75c663c5a2e$exports = new URL("telia-logo.a5f5e7d7.png", import.meta.url).toString();



const $9a89c88ae55065be$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Header", "INFO");
const $9a89c88ae55065be$var$findActiveMenuLink = (menuLinks, pathname)=>menuLinks.reduce((res, link, i)=>res >= 0 ? res : link.url && pathname.startsWith(link.url) ? i : res, -1);
const $9a89c88ae55065be$var$commonMenuLinks = [
    {
        text: "Documents",
        url: $e9a95c61c800ecd2$export$6b504632b4cea2e8
    },
    {
        text: "Support",
        url: $e9a95c61c800ecd2$export$b2e11634d600f33e
    }
];
const $9a89c88ae55065be$var$customSortOrder = [
    "Provisioning",
    "Settlement",
    "Report",
    "Management",
    "Documents",
    "Support",
    "Customer:"
];
const $9a89c88ae55065be$export$bbd9ca791e3cd06 = (a, b)=>{
    const getSortIndex = (text)=>$9a89c88ae55065be$var$customSortOrder.findIndex((item)=>text.startsWith(item));
    const indexA = getSortIndex(a.text);
    const indexB = getSortIndex(b.text);
    return indexA - indexB;
};
const $9a89c88ae55065be$var$formatCustomerName = (customer)=>`${customer?.name} (${customer?.countryId})`;
const $9a89c88ae55065be$export$a68d8bfe77b35dab = (_)=>{
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const location = (0, $dfdceb7c36fce96f$export$45d76561a5302f2b)();
    const { user: user, hasPermission: hasPermission, isTelia: isTelia, isCustomer: isCustomer, loadingUser: loadingUser, userBrands: userBrands, currentUserBrand: currentUserBrand, customerId: userCustomerId, userCustomerIds: userCustomerIds } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { loading: loadingCustomer, getCustomerOverview: getCustomerOverview } = (0, $8d8d8b3d38044bbe$export$d27d8317adc3c298)({
        skipQuery: !currentUserBrand
    });
    const menuLinks = [
        ...$9a89c88ae55065be$var$commonMenuLinks
    ];
    const menuHeadings = userBrands && userBrands.length > 0 ? userBrands.map(({ id: id, name: name })=>({
            text: name,
            url: `/brand/${id}?=location#${encodeURI(window.location.href)}`
        })) : [
        {
            text: "Hidden heading for logged out",
            url: `/`
        }
    ];
    if (!currentUserBrand && userBrands && userBrands?.length > 1) menuLinks.push({
        text: "Please select a Brand from the list above.",
        url: "/"
    });
    else if (user) {
        if (isTelia()) {
            if (user.userAccessStatusType === (0, $l8GLF.UserAccessStatusType).APPLYING) menuLinks.push({
                text: "Request Access",
                url: $e9a95c61c800ecd2$export$9b5625cb178fcc5d
            });
            if (hasPermission((0, $ca0941499cca84bb$export$5baf0ad38a5e4791))) {
                menuLinks.push({
                    text: "Customers",
                    url: formatWithBrand($e9a95c61c800ecd2$export$ebba33cd31d6b30c)
                });
                menuLinks.push({
                    text: "Settlement",
                    url: formatWithBrand($e9a95c61c800ecd2$export$257fa15708996d38)
                });
                menuLinks.push({
                    text: "Report",
                    url: formatWithBrand($e9a95c61c800ecd2$export$e3d31417f21c1ce7)
                });
                menuLinks.push({
                    text: "Management",
                    url: formatWithBrand($e9a95c61c800ecd2$export$2793f93164573ad)
                });
            }
        }
        if (isCustomer() && userCustomerId) {
            menuLinks.push({
                text: "Customer",
                url: formatWithBrand($e9a95c61c800ecd2$export$80abc9f9ce9de04c, userCustomerId)
            });
            hasPermission((0, $ca0941499cca84bb$export$4576703433079908)) && menuLinks.push({
                text: "Report",
                url: formatWithBrand($e9a95c61c800ecd2$export$e3d31417f21c1ce7)
            });
            if (!loadingCustomer && userCustomerIds && userCustomerIds.length > 1) menuLinks.push({
                text: `Customer: ${$9a89c88ae55065be$var$formatCustomerName(getCustomerOverview(userCustomerId))}`,
                subLinks: userCustomerIds.filter((customerId)=>customerId != userCustomerId).map((customerId)=>({
                        text: $9a89c88ae55065be$var$formatCustomerName(getCustomerOverview(customerId)),
                        url: `${$e9a95c61c800ecd2$export$d9468344d3651243($e9a95c61c800ecd2$export$212905122e5ccd9e, customerId)}?=location#${encodeURI(window.location.href)}`
                    }))
            });
        }
        // Sort the menuLinks based on the custom order
        menuLinks.sort($9a89c88ae55065be$export$bbd9ca791e3cd06);
    }
    $9a89c88ae55065be$var$log.debug("render", {
        user: user,
        userBrands: userBrands,
        currentUserBrand: currentUserBrand,
        menuHeadings: menuHeadings,
        menuLinks: menuLinks
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("header", {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $4da52773fae940f2$export$2e2bcd8739ae039), {
                menuLinks: menuHeadings?.map(({ text: text, url: url })=>({
                        heading: {
                            text: text,
                            url: url
                        },
                        links: menuLinks
                    })),
                buttonValues: {
                    login: "LOG IN",
                    myPage: "MY PROFILE",
                    frontPage: "Front page",
                    closeButton: "Close"
                },
                activeLinkIndex: $9a89c88ae55065be$var$findActiveMenuLink(menuLinks, location.pathname),
                activeIndex: menuHeadings.reduce((x, { text: text }, i)=>text === currentUserBrand?.name ? i : x, 0),
                loginUrl: $e9a95c61c800ecd2$export$eed606b4351295d7,
                isLoggedIn: !!user,
                myPageUrl: user && $e9a95c61c800ecd2$export$ff09b90989b21a8,
                logoImageDesktopPath: (0, (/*@__PURE__*/$parcel$interopDefault($2fdaa75c663c5a2e$exports))),
                logoImageInverseDesktopPath: (0, (/*@__PURE__*/$parcel$interopDefault($602a2a49417b565c$exports))),
                logoTitle: "Telia Bulk Messaging",
                logoUrl: $e9a95c61c800ecd2$export$a7c5707626fc90f,
                linkTemplate: ({ url: url, ...otherProps })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                        to: url,
                        ...otherProps
                    }),
                isLoading: loadingUser || loadingCustomer
            }),
            !(0, $ce151254b700f66a$export$1cfdf9a01e3f7773)() && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "envText",
                children: [
                    "Env: ",
                    (0, $ce151254b700f66a$export$23dc01e5cb551e17)()
                ]
            })
        ]
    });
};




var $fgmOP = parcelRequire("fgmOP");





const $c4840f1b64d4c34e$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("UserCustomer", "DEBUG");
const $c4840f1b64d4c34e$export$1ee4848b33ad558a = ()=>{
    const { customerId: customerId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const { hash: hash } = (0, $dfdceb7c36fce96f$export$45d76561a5302f2b)();
    const { getCustomerOverview: getCustomerOverview } = (0, $8d8d8b3d38044bbe$export$d27d8317adc3c298)();
    const { setPreference: setPreference, getPreference: getPreference } = (0, $7059d4d5f1933e7a$export$bbd7d970555e2952)([
        "customerId",
        "brandId"
    ]);
    let redirectUrl = decodeURI(hash.substr(1));
    (0, $fgmOP.useEffect)(()=>{
        const currCustomerId = getPreference("customerId");
        const currBrandId = getPreference("brandId");
        const { brandId: brandId } = getCustomerOverview(customerId) || {};
        currCustomerId && currBrandId && (redirectUrl = redirectUrl.replace(currCustomerId.toLowerCase(), customerId.toLowerCase()).replace(currBrandId.toLowerCase(), brandId?.toLowerCase() || currBrandId.toLowerCase())); //Inject new customer into URL
        setPreference("customerId", customerId);
        window.location.href = redirectUrl;
    }, [
        customerId
    ]);
    $c4840f1b64d4c34e$var$log.debug("render", {
        customerId: customerId,
        hash: hash
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {});
};





var $fgmOP = parcelRequire("fgmOP");

var $66f5a169f8640548$exports = {};
$66f5a169f8640548$exports = "query pendingUsers{pendingUsers{...userFragment description}}fragment userFragment on User{id cognitoId firstName lastName phone email description permissions type userAccessStatusType customerId comment roles rolesMap{resource roles permissions}isSSOUser mfaOptions{sms{enabled phone}app{enabled}}}";


var $bec02a301bb122cd$exports = {};
$bec02a301bb122cd$exports = "query teliaUsers{teliaUsers{...userFragment}}fragment userFragment on User{id cognitoId firstName lastName phone email description permissions type userAccessStatusType customerId comment roles rolesMap{resource roles permissions}isSSOUser mfaOptions{sms{enabled phone}app{enabled}}}";






var $fgmOP = parcelRequire("fgmOP");
var $f84262e6380c3c22$exports = {};
$f84262e6380c3c22$exports = "query serviceCategories{serviceCategories{id name types{id typeId name invoiceText}}}";




var $l8GLF = parcelRequire("l8GLF");

const $5cd44d723b4013a5$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useServiceCategories", "INFO");
function $5cd44d723b4013a5$export$97aa5844287be9bb() {
    const { currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const isServiceCategoriesVisible = (0, $fgmOP.useMemo)(()=>(0, $l8GLF.TELIA_NO) === currentUserBrand?.id, [
        currentUserBrand
    ]);
    const { loading: loading, data: { serviceCategories: serviceCategories } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($f84262e6380c3c22$exports)))), {
        fetchPolicy: "cache-first"
    });
    $5cd44d723b4013a5$var$log.debug("useServiceCategories", {
        loading: loading,
        serviceCategories: serviceCategories,
        isServiceCategoriesVisible: isServiceCategoriesVisible
    });
    const getServiceCategory = (serviceCategoryId)=>serviceCategories?.find(({ id: id })=>id === serviceCategoryId);
    const serviceCategoryDisplayName = (serviceCategoryId)=>{
        const serviceCategory = getServiceCategory(serviceCategoryId);
        return serviceCategoryId + (serviceCategory ? ` ${serviceCategory.name}` : "");
    };
    const categoryTypeDisplayName = (serviceCategoryId, categoryTypeId)=>{
        const serviceCategory = getServiceCategory(serviceCategoryId);
        const categoryType = serviceCategory?.types?.find(({ typeId: typeId })=>typeId === categoryTypeId);
        return categoryTypeId + (categoryType ? ` ${categoryType.name}` : "");
    };
    return {
        loading: loading,
        serviceCategories: serviceCategories,
        isServiceCategoriesVisible: isServiceCategoriesVisible,
        serviceCategoryDisplayName: serviceCategoryDisplayName,
        categoryTypeDisplayName: categoryTypeDisplayName
    };
}





var $l8GLF = parcelRequire("l8GLF");





parcelRequire("fgmOP");



const $cfbdc6dab8250bcb$var$BreadCrumbFc = (props)=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("breadcrumbs__breadcrumb", props.className),
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
            id: (0, $0857d9353dc337e9$export$d5d25c90fc92fce5)(props.text, "breadCrumb"),
            to: props.link,
            children: props.text
        })
    });
};
var $cfbdc6dab8250bcb$export$2e2bcd8739ae039 = $cfbdc6dab8250bcb$var$BreadCrumbFc;



parcelRequire("fgmOP");
const $d7169106c226792c$var$BreadCrumbsFc = (props)=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("ul", {
        className: "breadcrumbs",
        children: props.children
    });
};
var $d7169106c226792c$export$2e2bcd8739ae039 = $d7169106c226792c$var$BreadCrumbsFc;







var $jPPOv = parcelRequire("jPPOv");

var $fgmOP = parcelRequire("fgmOP");

function $208e3a63656dc21c$var$_slicedToArray(arr, i) {
    return $208e3a63656dc21c$var$_arrayWithHoles(arr) || $208e3a63656dc21c$var$_iterableToArrayLimit(arr, i) || $208e3a63656dc21c$var$_unsupportedIterableToArray(arr, i) || $208e3a63656dc21c$var$_nonIterableRest();
}
function $208e3a63656dc21c$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $208e3a63656dc21c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $208e3a63656dc21c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $208e3a63656dc21c$var$_arrayLikeToArray(o, minLen);
}
function $208e3a63656dc21c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $208e3a63656dc21c$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $208e3a63656dc21c$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $208e3a63656dc21c$var$uniqueId = 0;
/**
 * Status: *finished*
 * Category: FormElements
 **/ var $208e3a63656dc21c$var$Tooltip = function Tooltip(_ref) {
    var buttonContent = _ref.buttonContent, children = _ref.children, className = _ref.className, isExpanded = _ref.isExpanded, label = _ref.label, text = _ref.text, isPositionAbsolute = _ref.isPositionAbsolute;
    var _useState = (0, $fgmOP.useState)(isExpanded), _useState2 = $208e3a63656dc21c$var$_slicedToArray(_useState, 2), expanded = _useState2[0], setExpanded = _useState2[1];
    var _useState3 = (0, $fgmOP.useState)($208e3a63656dc21c$var$uniqueId++), _useState4 = $208e3a63656dc21c$var$_slicedToArray(_useState3, 1), id = _useState4[0];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("tooltip", {
            "tooltip--show": expanded
        }, className)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "tooltip__button-container"
    }, label && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("label", {
        htmlFor: "tooltip__button-".concat(id)
    }, label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("button", {
        type: "button",
        id: "tooltip__button-".concat(id),
        className: "tooltip__button",
        "aria-controls": "tooltip__box-".concat(id),
        "aria-expanded": expanded,
        onClick: function onClick(e) {
            setExpanded(!expanded);
            e.stopPropagation();
        },
        onMouseOver: function onMouseOver() {
            return setExpanded(true);
        },
        onMouseOut: function onMouseOut() {
            return setExpanded(false);
        }
    }, buttonContent || "i")), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("tooltip__box", {
            "tooltip__box--absolute": isPositionAbsolute
        }),
        id: "tooltip__box-".concat(id)
    }, children || text));
};
$208e3a63656dc21c$var$Tooltip.propTypes = {
    /** Content of the tooltip button; defaults to "i". */ buttonContent: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).node,
    /** The content of the tooltip (if a plain string is not enough). Provide either `text` or `children`. */ children: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    isExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    /** If provided, add a label to the tooltip button. */ label: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    /** The content of the tooltip as a plain string. Provide either `text` or `children`. */ text: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
};
var $208e3a63656dc21c$export$2e2bcd8739ae039 = $208e3a63656dc21c$var$Tooltip;



var $fgmOP = parcelRequire("fgmOP");






var $fgmOP = parcelRequire("fgmOP");

var $jPPOv = parcelRequire("jPPOv");

function $e361cc0c141925d1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $e361cc0c141925d1$var$PANEL = {
    LEFT: "left",
    RIGHT: "right"
};
/**
 * Status: *In progress*.
 * Category: FormElements
 */ var $e361cc0c141925d1$var$ToggleSwitch = function ToggleSwitch(_ref) {
    var _classnames;
    var leftLabel = _ref.leftLabel, rightLabel = _ref.rightLabel, leftOnClickHandler = _ref.leftOnClickHandler, rightOnClickHandler = _ref.rightOnClickHandler, active = _ref.active, backgroundColor = _ref.backgroundColor, className = _ref.className;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("toggle-switch", (_classnames = {}, $e361cc0c141925d1$var$_defineProperty(_classnames, "toggle-switch__".concat(backgroundColor), true), $e361cc0c141925d1$var$_defineProperty(_classnames, className, className), _classnames)),
        role: "group"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("button", {
        type: "button",
        "aria-pressed": active === $e361cc0c141925d1$var$PANEL.LEFT,
        className: "toggle-switch__button",
        onClick: leftOnClickHandler
    }, leftLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("button", {
        type: "button",
        "aria-pressed": active === $e361cc0c141925d1$var$PANEL.RIGHT,
        className: "toggle-switch__button",
        onClick: rightOnClickHandler
    }, rightLabel));
};
$e361cc0c141925d1$var$ToggleSwitch.defaultProps = {
    leftOnClickHandler: function leftOnClickHandler() {},
    rightOnClickHandler: function rightOnClickHandler() {},
    backgroundColor: "white"
};
$e361cc0c141925d1$var$ToggleSwitch.propTypes = {
    active: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).oneOf(Object.keys($e361cc0c141925d1$var$PANEL).map(function(k) {
        return $e361cc0c141925d1$var$PANEL[k];
    })),
    backgroundColor: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).oneOf([
        "white",
        "grey"
    ]),
    className: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    leftLabel: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    rightLabel: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    leftOnClickHandler: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func,
    rightOnClickHandler: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func
};
var $e361cc0c141925d1$export$2e2bcd8739ae039 = $e361cc0c141925d1$var$ToggleSwitch;


parcelRequire("fgmOP");

var $ecc4226f40c1c037$export$b6967b18ec8f2513;
(function(ToggleSwitchState) {
    ToggleSwitchState["LEFT"] = "left";
    ToggleSwitchState["RIGHT"] = "right";
})($ecc4226f40c1c037$export$b6967b18ec8f2513 || ($ecc4226f40c1c037$export$b6967b18ec8f2513 = {}));
const $ecc4226f40c1c037$export$fb4216da1f591b95 = (props)=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $e361cc0c141925d1$export$2e2bcd8739ae039), {
        ...props
    });
};





var $fgmOP = parcelRequire("fgmOP");


var $fgmOP = parcelRequire("fgmOP");
function $64dd508e143a084d$var$_slicedToArray(arr, i) {
    return $64dd508e143a084d$var$_arrayWithHoles(arr) || $64dd508e143a084d$var$_iterableToArrayLimit(arr, i) || $64dd508e143a084d$var$_unsupportedIterableToArray(arr, i) || $64dd508e143a084d$var$_nonIterableRest();
}
function $64dd508e143a084d$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $64dd508e143a084d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $64dd508e143a084d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $64dd508e143a084d$var$ownKeys(Object(source), true).forEach(function(key) {
            $64dd508e143a084d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $64dd508e143a084d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $64dd508e143a084d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $64dd508e143a084d$var$_toConsumableArray(arr) {
    return $64dd508e143a084d$var$_arrayWithoutHoles(arr) || $64dd508e143a084d$var$_iterableToArray(arr) || $64dd508e143a084d$var$_unsupportedIterableToArray(arr) || $64dd508e143a084d$var$_nonIterableSpread();
}
function $64dd508e143a084d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $64dd508e143a084d$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $64dd508e143a084d$var$_arrayLikeToArray(arr);
}
function $64dd508e143a084d$var$_toArray(arr) {
    return $64dd508e143a084d$var$_arrayWithHoles(arr) || $64dd508e143a084d$var$_iterableToArray(arr) || $64dd508e143a084d$var$_unsupportedIterableToArray(arr) || $64dd508e143a084d$var$_nonIterableRest();
}
function $64dd508e143a084d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $64dd508e143a084d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $64dd508e143a084d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $64dd508e143a084d$var$_arrayLikeToArray(o, minLen);
}
function $64dd508e143a084d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $64dd508e143a084d$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $64dd508e143a084d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $64dd508e143a084d$var$DEFAULT_MAX_SORTED_FIELDS = 2;
var $64dd508e143a084d$var$ORDER_CORRECT = -1;
var $64dd508e143a084d$var$ORDER_INDIFFERENT = 0;
var $64dd508e143a084d$var$ORDER_WRONG = 1;
var $64dd508e143a084d$var$updateSorting = function updateSorting(_ref, field, maxSortingFields) {
    var _ref2 = $64dd508e143a084d$var$_toArray(_ref), sortingArray = _ref2.slice(0);
    return !field ? $64dd508e143a084d$var$_toConsumableArray(sortingArray) : [
        {
            field: field,
            inverted: !sortingArray[0] || sortingArray[0].field !== field ? false : !sortingArray[0].inverted
        }
    ].concat($64dd508e143a084d$var$_toConsumableArray(sortingArray.filter(function(s) {
        return s.field !== field;
    }))).slice(0, maxSortingFields);
};
var $64dd508e143a084d$var$findFieldSorting = function findFieldSorting(field, sortingArray) {
    return !sortingArray ? undefined : sortingArray.reduce(function(found, sorting, index, array) {
        return found ? found : field === sorting.field ? {
            inverted: !!sorting.inverted,
            priority: array.length > 1 ? index + 1 : undefined
        } : undefined;
    }, undefined);
};
var $64dd508e143a084d$var$createThSortablePropsGetter = function createThSortablePropsGetter(sortingArray, setSortingArray, maxSortingFields) {
    return function(field) {
        var fieldSorting = $64dd508e143a084d$var$findFieldSorting(field, sortingArray);
        return $64dd508e143a084d$var$_objectSpread({
            onSort: function onSort() {
                setSortingArray($64dd508e143a084d$var$updateSorting(sortingArray, field, maxSortingFields));
            }
        }, fieldSorting ? {
            isSorted: true,
            isSortedDesc: !!fieldSorting.inverted,
            sortPriority: fieldSorting.priority
        } : {
            isSorted: false
        });
    };
};
var $64dd508e143a084d$var$hasValue = function hasValue(value) {
    return value !== null && typeof value !== "undefined";
};
var $64dd508e143a084d$var$createComparator = function createComparator(_ref3) {
    var field = _ref3.field, inverted = _ref3.inverted;
    var specialFieldComparators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(a, b) {
        var valueA = a ? a[field] : null, valueB = b ? b[field] : null;
        var result = !field || !$64dd508e143a084d$var$hasValue(valueA) && !$64dd508e143a084d$var$hasValue(valueB) ? $64dd508e143a084d$var$ORDER_INDIFFERENT : !$64dd508e143a084d$var$hasValue(valueA) ? $64dd508e143a084d$var$ORDER_CORRECT : !$64dd508e143a084d$var$hasValue(valueB) ? $64dd508e143a084d$var$ORDER_WRONG : specialFieldComparators[field] ? specialFieldComparators[field](valueA, valueB) : valueA.localeCompare //  String.localCompare
         ? valueA.localeCompare(valueB) : valueA - valueB;
        return (inverted ? -1 : 1) * result;
    };
};
var $64dd508e143a084d$var$sortObjects = function sortObjects(objects, sortingArray, specialFieldComparators) {
    if (!objects || objects.length === 0 || !sortingArray || sortingArray.length === 0) return objects;
    var sortComparator = function sortComparator(a, b) {
        return sortingArray.reduce(function(res, sorting) {
            return res !== $64dd508e143a084d$var$ORDER_INDIFFERENT ? res : $64dd508e143a084d$var$createComparator(sorting, specialFieldComparators)(a, b);
        }, $64dd508e143a084d$var$ORDER_INDIFFERENT);
    };
    return $64dd508e143a084d$var$_toConsumableArray(objects).sort(sortComparator);
};
var $64dd508e143a084d$var$parseInitialSorting = function parseInitialSorting(initialSorting) {
    if (initialSorting === null || typeof initialSorting === "undefined") return [];
    return (Array.isArray(initialSorting) ? initialSorting : [
        initialSorting
    ]).map(function(initialSorting) {
        return typeof initialSorting === "string" ? initialSorting.startsWith("!") ? {
            field: initialSorting.substring(1),
            inverted: true
        } : {
            field: initialSorting
        } : initialSorting;
    }).filter(function(sorting) {
        return sorting.field;
    });
};
var $64dd508e143a084d$export$14720e7a4b73e95c = function useThSortable() {
    var objects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var maxSortedFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $64dd508e143a084d$var$DEFAULT_MAX_SORTED_FIELDS;
    var initialSorting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var specialFieldComparators = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var _useState = (0, $fgmOP.useState)($64dd508e143a084d$var$parseInitialSorting(initialSorting)), _useState2 = $64dd508e143a084d$var$_slicedToArray(_useState, 2), sortingArray = _useState2[0], setSortingArray = _useState2[1];
    var sortedObjects = (0, $fgmOP.useMemo)(function() {
        return $64dd508e143a084d$var$sortObjects(objects, sortingArray, specialFieldComparators);
    }, [
        objects,
        maxSortedFields,
        sortingArray,
        specialFieldComparators
    ]);
    var thSortablePropsGetter = $64dd508e143a084d$var$createThSortablePropsGetter(sortingArray, setSortingArray, maxSortedFields);
    return [
        sortedObjects,
        thSortablePropsGetter
    ];
};


var $c1364c3d18563e9b$var$_excluded = [
    "children",
    "clickable",
    "className"
], $c1364c3d18563e9b$var$_excluded2 = [
    "children",
    "className"
], $c1364c3d18563e9b$var$_excluded3 = [
    "children",
    "className"
], $c1364c3d18563e9b$var$_excluded4 = [
    "children",
    "white",
    "className"
], $c1364c3d18563e9b$var$_excluded5 = [
    "children",
    "className"
], $c1364c3d18563e9b$var$_excluded6 = [
    "children",
    "className"
], $c1364c3d18563e9b$var$_excluded7 = [
    "children",
    "className"
], $c1364c3d18563e9b$var$_excluded8 = [
    "children",
    "className",
    "onSort",
    "isSorted",
    "isSortedDesc",
    "sortPriority"
];
function $c1364c3d18563e9b$var$_extends() {
    $c1364c3d18563e9b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c1364c3d18563e9b$var$_extends.apply(this, arguments);
}
function $c1364c3d18563e9b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c1364c3d18563e9b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c1364c3d18563e9b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c1364c3d18563e9b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Status: *finished*
 * Category: Tables
 *
 * This table component use negative margins to achieve full width rows in the table,
 * and padding to add back the negative margin value. To avoid horizontal scrolling
 * it is important to style the nearest full width element with <code>overflow-x: hidden;</code>.
 *
 * It's also recommended to use this component within an element with a styling that centers-, and
 * sets the content to a max-width.
 */ var $c1364c3d18563e9b$var$FullWidthTable = function FullWidthTable(_ref) {
    var _classnames;
    var children = _ref.children, clickable = _ref.clickable, className = _ref.className, rest = $c1364c3d18563e9b$var$_objectWithoutProperties(_ref, $c1364c3d18563e9b$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("table", $c1364c3d18563e9b$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("full-width-table", (_classnames = {}, $c1364c3d18563e9b$var$_defineProperty(_classnames, className, className), $c1364c3d18563e9b$var$_defineProperty(_classnames, "full-width-table--clickable", clickable), _classnames))
    }, rest), children);
};
var $c1364c3d18563e9b$var$THead = function THead(_ref2) {
    var children = _ref2.children, className = _ref2.className, rest = $c1364c3d18563e9b$var$_objectWithoutProperties(_ref2, $c1364c3d18563e9b$var$_excluded2);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("thead", $c1364c3d18563e9b$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("full-width-table__header", $c1364c3d18563e9b$var$_defineProperty({}, className, className))
    }, rest), children);
};
$c1364c3d18563e9b$var$FullWidthTable.THead = $c1364c3d18563e9b$var$THead;
var $c1364c3d18563e9b$var$TBody = function TBody(_ref3) {
    var children = _ref3.children, className = _ref3.className, rest = $c1364c3d18563e9b$var$_objectWithoutProperties(_ref3, $c1364c3d18563e9b$var$_excluded3);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("tbody", $c1364c3d18563e9b$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("full-width-table__body", $c1364c3d18563e9b$var$_defineProperty({}, className, className))
    }, rest), children);
};
$c1364c3d18563e9b$var$FullWidthTable.TBody = $c1364c3d18563e9b$var$TBody;
var $c1364c3d18563e9b$var$TFoot = function TFoot(_ref4) {
    var _classnames4;
    var children = _ref4.children, white = _ref4.white, className = _ref4.className, rest = $c1364c3d18563e9b$var$_objectWithoutProperties(_ref4, $c1364c3d18563e9b$var$_excluded4);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("tfoot", $c1364c3d18563e9b$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("full-width-table__footer", (_classnames4 = {}, $c1364c3d18563e9b$var$_defineProperty(_classnames4, className, className), $c1364c3d18563e9b$var$_defineProperty(_classnames4, "full-width-table__footer--alt", white), _classnames4))
    }, rest), children);
};
$c1364c3d18563e9b$var$FullWidthTable.TFoot = $c1364c3d18563e9b$var$TFoot;
var $c1364c3d18563e9b$var$Tr = function Tr(_ref5) {
    var children = _ref5.children, className = _ref5.className, rest = $c1364c3d18563e9b$var$_objectWithoutProperties(_ref5, $c1364c3d18563e9b$var$_excluded5);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("tr", $c1364c3d18563e9b$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("full-width-table__row", $c1364c3d18563e9b$var$_defineProperty({}, className, className))
    }, rest), children);
};
$c1364c3d18563e9b$var$FullWidthTable.Tr = $c1364c3d18563e9b$var$Tr;
var $c1364c3d18563e9b$var$Td = function Td(_ref6) {
    var children = _ref6.children, className = _ref6.className, rest = $c1364c3d18563e9b$var$_objectWithoutProperties(_ref6, $c1364c3d18563e9b$var$_excluded6);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("td", $c1364c3d18563e9b$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("full-width-table__cell", $c1364c3d18563e9b$var$_defineProperty({}, className, className))
    }, rest), children);
};
$c1364c3d18563e9b$var$FullWidthTable.Td = $c1364c3d18563e9b$var$Td;
var $c1364c3d18563e9b$var$Th = function Th(_ref7) {
    var children = _ref7.children, className = _ref7.className, rest = $c1364c3d18563e9b$var$_objectWithoutProperties(_ref7, $c1364c3d18563e9b$var$_excluded7);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("th", $c1364c3d18563e9b$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("full-width-table__cell", $c1364c3d18563e9b$var$_defineProperty({}, className, className))
    }, rest), children);
};
$c1364c3d18563e9b$var$FullWidthTable.Th = $c1364c3d18563e9b$var$Th;
var $c1364c3d18563e9b$var$ThSortable = function ThSortable(_ref8) {
    var children = _ref8.children, className = _ref8.className, onSort = _ref8.onSort, _ref8$isSorted = _ref8.isSorted, isSorted = _ref8$isSorted === void 0 ? false : _ref8$isSorted, _ref8$isSortedDesc = _ref8.isSortedDesc, isSortedDesc = _ref8$isSortedDesc === void 0 ? false : _ref8$isSortedDesc, _ref8$sortPriority = _ref8.sortPriority, sortPriority = _ref8$sortPriority === void 0 ? null : _ref8$sortPriority, rest = $c1364c3d18563e9b$var$_objectWithoutProperties(_ref8, $c1364c3d18563e9b$var$_excluded8);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($c1364c3d18563e9b$var$FullWidthTable.Th, $c1364c3d18563e9b$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("full-width-table__cell--sortable", className)
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("button", {
        type: "button",
        onClick: onSort,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("button", "button--sortable", $c1364c3d18563e9b$var$_defineProperty({}, "button--sorted-".concat(isSortedDesc ? "desc" : "asc"), isSorted), $c1364c3d18563e9b$var$_defineProperty({}, "button--sorted-".concat(sortPriority), isSorted && sortPriority !== null))
    }, children));
};
$c1364c3d18563e9b$var$FullWidthTable.ThSortable = $c1364c3d18563e9b$var$ThSortable;
$c1364c3d18563e9b$var$FullWidthTable.useThSortable = (0, $64dd508e143a084d$export$14720e7a4b73e95c);
var $c1364c3d18563e9b$export$2e2bcd8739ae039 = $c1364c3d18563e9b$var$FullWidthTable;


var $a129443168ef7da6$exports = {};
"use strict";
Object.defineProperty($a129443168ef7da6$exports, "__esModule", {
    value: true
});
$a129443168ef7da6$exports.useThSortable = void 0;

var $fgmOP = parcelRequire("fgmOP");
function $a129443168ef7da6$var$_slicedToArray(arr, i) {
    return $a129443168ef7da6$var$_arrayWithHoles(arr) || $a129443168ef7da6$var$_iterableToArrayLimit(arr, i) || $a129443168ef7da6$var$_unsupportedIterableToArray(arr, i) || $a129443168ef7da6$var$_nonIterableRest();
}
function $a129443168ef7da6$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $a129443168ef7da6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $a129443168ef7da6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $a129443168ef7da6$var$ownKeys(Object(source), true).forEach(function(key) {
            $a129443168ef7da6$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $a129443168ef7da6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $a129443168ef7da6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a129443168ef7da6$var$_toConsumableArray(arr) {
    return $a129443168ef7da6$var$_arrayWithoutHoles(arr) || $a129443168ef7da6$var$_iterableToArray(arr) || $a129443168ef7da6$var$_unsupportedIterableToArray(arr) || $a129443168ef7da6$var$_nonIterableSpread();
}
function $a129443168ef7da6$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a129443168ef7da6$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $a129443168ef7da6$var$_arrayLikeToArray(arr);
}
function $a129443168ef7da6$var$_toArray(arr) {
    return $a129443168ef7da6$var$_arrayWithHoles(arr) || $a129443168ef7da6$var$_iterableToArray(arr) || $a129443168ef7da6$var$_unsupportedIterableToArray(arr) || $a129443168ef7da6$var$_nonIterableRest();
}
function $a129443168ef7da6$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a129443168ef7da6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a129443168ef7da6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a129443168ef7da6$var$_arrayLikeToArray(o, minLen);
}
function $a129443168ef7da6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a129443168ef7da6$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $a129443168ef7da6$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $a129443168ef7da6$var$DEFAULT_MAX_SORTED_FIELDS = 2;
var $a129443168ef7da6$var$ORDER_CORRECT = -1;
var $a129443168ef7da6$var$ORDER_INDIFFERENT = 0;
var $a129443168ef7da6$var$ORDER_WRONG = 1;
var $a129443168ef7da6$var$updateSorting = function updateSorting(_ref, field, maxSortingFields) {
    var _ref2 = $a129443168ef7da6$var$_toArray(_ref), sortingArray = _ref2.slice(0);
    return !field ? $a129443168ef7da6$var$_toConsumableArray(sortingArray) : [
        {
            field: field,
            inverted: !sortingArray[0] || sortingArray[0].field !== field ? false : !sortingArray[0].inverted
        }
    ].concat($a129443168ef7da6$var$_toConsumableArray(sortingArray.filter(function(s) {
        return s.field !== field;
    }))).slice(0, maxSortingFields);
};
var $a129443168ef7da6$var$findFieldSorting = function findFieldSorting(field, sortingArray) {
    return !sortingArray ? undefined : sortingArray.reduce(function(found, sorting, index, array) {
        return found ? found : field === sorting.field ? {
            inverted: !!sorting.inverted,
            priority: array.length > 1 ? index + 1 : undefined
        } : undefined;
    }, undefined);
};
var $a129443168ef7da6$var$createThSortablePropsGetter = function createThSortablePropsGetter(sortingArray, setSortingArray, maxSortingFields) {
    return function(field) {
        var fieldSorting = $a129443168ef7da6$var$findFieldSorting(field, sortingArray);
        return $a129443168ef7da6$var$_objectSpread({
            onSort: function onSort() {
                setSortingArray($a129443168ef7da6$var$updateSorting(sortingArray, field, maxSortingFields));
            }
        }, fieldSorting ? {
            isSorted: true,
            isSortedDesc: !!fieldSorting.inverted,
            sortPriority: fieldSorting.priority
        } : {
            isSorted: false
        });
    };
};
var $a129443168ef7da6$var$hasValue = function hasValue(value) {
    return value !== null && typeof value !== "undefined";
};
var $a129443168ef7da6$var$createComparator = function createComparator(_ref3) {
    var field = _ref3.field, inverted = _ref3.inverted;
    var specialFieldComparators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function(a, b) {
        var valueA = a ? a[field] : null, valueB = b ? b[field] : null;
        var result = !field || !$a129443168ef7da6$var$hasValue(valueA) && !$a129443168ef7da6$var$hasValue(valueB) ? $a129443168ef7da6$var$ORDER_INDIFFERENT : !$a129443168ef7da6$var$hasValue(valueA) ? $a129443168ef7da6$var$ORDER_CORRECT : !$a129443168ef7da6$var$hasValue(valueB) ? $a129443168ef7da6$var$ORDER_WRONG : specialFieldComparators[field] ? specialFieldComparators[field](valueA, valueB) : valueA.localeCompare //  String.localCompare
         ? valueA.localeCompare(valueB) : valueA - valueB;
        return (inverted ? -1 : 1) * result;
    };
};
var $a129443168ef7da6$var$sortObjects = function sortObjects(objects, sortingArray, specialFieldComparators) {
    if (!objects || objects.length === 0 || !sortingArray || sortingArray.length === 0) return objects;
    var sortComparator = function sortComparator(a, b) {
        return sortingArray.reduce(function(res, sorting) {
            return res !== $a129443168ef7da6$var$ORDER_INDIFFERENT ? res : $a129443168ef7da6$var$createComparator(sorting, specialFieldComparators)(a, b);
        }, $a129443168ef7da6$var$ORDER_INDIFFERENT);
    };
    return $a129443168ef7da6$var$_toConsumableArray(objects).sort(sortComparator);
};
var $a129443168ef7da6$var$parseInitialSorting = function parseInitialSorting(initialSorting) {
    if (initialSorting === null || typeof initialSorting === "undefined") return [];
    return (Array.isArray(initialSorting) ? initialSorting : [
        initialSorting
    ]).map(function(initialSorting) {
        return typeof initialSorting === "string" ? initialSorting.startsWith("!") ? {
            field: initialSorting.substring(1),
            inverted: true
        } : {
            field: initialSorting
        } : initialSorting;
    }).filter(function(sorting) {
        return sorting.field;
    });
};
/**
 * Returns a sorted version of the objects parameter,
 * and a function to get ThSortableProps.
 *
 * @param objects   The original array of objects to be sorted.
 * @param maxSortedFields   The maximum number of sorting criteria.
 * @param initialSorting    The initial sorting array, expressed as [[string]] or [[Sorting]].
 *                          When using [[string]] format, the value is the name of the object's property,
 *                          prefix with '!' to invert the sorting.
 * @param specialFieldComparators   A dictionary object for special object's property comparators.
 */ var $a129443168ef7da6$var$useThSortable = function useThSortable() {
    var objects = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var maxSortedFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $a129443168ef7da6$var$DEFAULT_MAX_SORTED_FIELDS;
    var initialSorting = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var specialFieldComparators = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    var _useState = (0, $fgmOP.useState)($a129443168ef7da6$var$parseInitialSorting(initialSorting)), _useState2 = $a129443168ef7da6$var$_slicedToArray(_useState, 2), sortingArray = _useState2[0], setSortingArray = _useState2[1];
    var sortedObjects = (0, $fgmOP.useMemo)(function() {
        return $a129443168ef7da6$var$sortObjects(objects, sortingArray, specialFieldComparators);
    }, [
        objects,
        maxSortedFields,
        sortingArray,
        specialFieldComparators
    ]);
    var thSortablePropsGetter = $a129443168ef7da6$var$createThSortablePropsGetter(sortingArray, setSortingArray, maxSortedFields);
    return [
        sortedObjects,
        thSortablePropsGetter
    ];
};
$a129443168ef7da6$exports.useThSortable = $a129443168ef7da6$var$useThSortable;



var $fgmOP = parcelRequire("fgmOP");

var $9a5ae0917f888406$exports = {};
$9a5ae0917f888406$exports = "query productsSessions{productsSessions{...productSessionsFragment}}fragment productSessionsFragment on ProductSessions{productId customerId customerName receiverCount transmitterCount transceiverCount maxSessions}";







const $611f8b4c08ff43ac$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SmppSummaryTables", "INFO");
const { THead: $611f8b4c08ff43ac$var$THead, Tr: $611f8b4c08ff43ac$var$Tr, ThSortable: $611f8b4c08ff43ac$var$ThSortable, TBody: $611f8b4c08ff43ac$var$TBody, Td: $611f8b4c08ff43ac$var$Td } = (0, $c1364c3d18563e9b$export$2e2bcd8739ae039);
const $611f8b4c08ff43ac$export$360077c5630c247c = (_props)=>{
    const { loading: loading, data: { productsSessions: productsSessions } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($9a5ae0917f888406$exports)))));
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const activeTableContent = (0, $fgmOP.useMemo)(()=>productsSessions ? productsSessions.filter(({ receiverCount: receiverCount, transmitterCount: transmitterCount, transceiverCount: transceiverCount })=>receiverCount || transmitterCount || transceiverCount) : [], [
        productsSessions
    ]);
    const inactiveTableContent = (0, $fgmOP.useMemo)(()=>productsSessions ? productsSessions.filter(({ receiverCount: receiverCount, transmitterCount: transmitterCount, transceiverCount: transceiverCount })=>!receiverCount && !transmitterCount && !transceiverCount) : [], [
        productsSessions
    ]);
    const [sortedActiveTableContent, getThActiveSortableProps] = (0, $a129443168ef7da6$exports.useThSortable)(activeTableContent, 3, [], {});
    const [sortedInactiveTableContent, getThInactiveSortableProps] = (0, $a129443168ef7da6$exports.useThSortable)(inactiveTableContent, 3, [], {});
    const getTable = (tableItems, getThSortableProps, title, errorMessage)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                    children: [
                        title,
                        " "
                    ]
                }),
                !(tableItems && tableItems.length) ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$2e2bcd8739ae039), {
                    children: errorMessage
                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039), {
                    clickable: true,
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($611f8b4c08ff43ac$var$THead, {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)($611f8b4c08ff43ac$var$Tr, {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($611f8b4c08ff43ac$var$ThSortable, {
                                        ...getThSortableProps("productId"),
                                        children: "Service ID"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($611f8b4c08ff43ac$var$ThSortable, {
                                        ...getThSortableProps("customerId"),
                                        children: "Customer ID"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($611f8b4c08ff43ac$var$ThSortable, {
                                        ...getThSortableProps("customerName"),
                                        children: "Customer"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($611f8b4c08ff43ac$var$ThSortable, {
                                        ...getThSortableProps("receiverCount"),
                                        children: "Receivers"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($611f8b4c08ff43ac$var$ThSortable, {
                                        ...getThSortableProps("transmitterCount"),
                                        children: "Transmitters"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($611f8b4c08ff43ac$var$ThSortable, {
                                        ...getThSortableProps("transceiverCount"),
                                        children: " Transceivers"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($611f8b4c08ff43ac$var$ThSortable, {
                                        ...getThSortableProps("maxSessions"),
                                        children: "Max Sessions"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($611f8b4c08ff43ac$var$TBody, {
                            children: tableItems.map(({ productId: productId, customerId: customerId, customerName: customerName, receiverCount: receiverCount, transmitterCount: transmitterCount, transceiverCount: transceiverCount, maxSessions: maxSessions }, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)($611f8b4c08ff43ac$var$Tr, {
                                    onClick: ()=>navigate(formatWithBrand($e9a95c61c800ecd2$export$80abc9f9ce9de04c, customerId)),
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($611f8b4c08ff43ac$var$Td, {
                                            children: productId
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($611f8b4c08ff43ac$var$Td, {
                                            children: customerId
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($611f8b4c08ff43ac$var$Td, {
                                            children: customerName
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($611f8b4c08ff43ac$var$Td, {
                                            children: receiverCount
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($611f8b4c08ff43ac$var$Td, {
                                            children: transmitterCount
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($611f8b4c08ff43ac$var$Td, {
                                            children: transceiverCount
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($611f8b4c08ff43ac$var$Td, {
                                            children: maxSessions
                                        })
                                    ]
                                }, i))
                        })
                    ]
                })
            ]
        });
    $611f8b4c08ff43ac$var$log.debug("productsSessions", {
        productsSessions: productsSessions
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: loading && !productsSessions ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
            children: [
                getTable(sortedActiveTableContent, getThActiveSortableProps, "Products with active Sessions", "No Products with active Sessions found"),
                getTable(sortedInactiveTableContent, getThInactiveSortableProps, "Products with no Sessions", "No Products with SMPP configuration found")
            ]
        })
    });
};








var $fgmOP = parcelRequire("fgmOP");
var $6a277913234cb26a$exports = {};
$6a277913234cb26a$exports = "mutation unbindSmppSession($session:SmppSessionWithProductDetailsInput){unbindSmppSession(session:$session)}";


var $0d4ecb7730457cbc$exports = {};
$0d4ecb7730457cbc$exports = "query smppSessionsWithProductDetails($customerId:ID){smppSessionsWithProductDetails(customerId:$customerId){...smppSessionsWithProductDetailsFragment}}fragment smppSessionsWithProductDetailsFragment on SmppSessionsWithProductDetails{sessionId instanceId productId sessionCreatedAt bindType customerId apiCredentials}";








const $6fadca55099b66d6$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useUserCustomer", "INFO");
const $6fadca55099b66d6$export$dd46433206d0b2d9 = ()=>{
    const { isCustomer: isCustomer, customerId: customerId, customer: customer } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const customerName = customer?.company?.name || customerId;
    const useUserCustomer = {
        loading: !!isCustomer() && !customer,
        customer: customer,
        customerName: customerName
    };
    $6fadca55099b66d6$var$log.debug(useUserCustomer);
    return useUserCustomer;
};



var $fgmOP = parcelRequire("fgmOP");
const $b06c1af11eebe0e3$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useCustomerName", "INFO");
const $b06c1af11eebe0e3$export$6830a00b8ce0c90e = ()=>{
    const { isCustomer: isCustomer } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { customerName: customerName } = (0, $6fadca55099b66d6$export$dd46433206d0b2d9)();
    const { loading: loading, customerOverviews: customerOverviews, getName: getName } = (0, $8d8d8b3d38044bbe$export$d27d8317adc3c298)();
    const getCustomerName = (0, $fgmOP.useCallback)((customerId)=>!customerId ? "" : isCustomer() ? customerName || customerId : getName(customerId), [
        isCustomer,
        customerName,
        getName
    ]);
    const useCustomerName = {
        getCustomerName: getCustomerName
    };
    $b06c1af11eebe0e3$var$log.debug(useCustomerName);
    return useCustomerName;
};











parcelRequire("fgmOP");
const $2e4c8094e1930e9a$export$db87c465bc6102be = (props)=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("form", {
        onSubmit: (e)=>{
            e.preventDefault();
            props.onSubmit && props.onSubmit(e);
        },
        children: props.children
    });
};
var $2e4c8094e1930e9a$export$2e2bcd8739ae039 = $2e4c8094e1930e9a$export$db87c465bc6102be;






const $c23531f918a5c963$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SmppConnectionsTable", "INFO");
const { THead: $c23531f918a5c963$var$THead, Tr: $c23531f918a5c963$var$Tr, Th: $c23531f918a5c963$var$Th, ThSortable: $c23531f918a5c963$var$ThSortable, TBody: $c23531f918a5c963$var$TBody, Td: $c23531f918a5c963$var$Td } = (0, $c1364c3d18563e9b$export$2e2bcd8739ae039);
const $c23531f918a5c963$var$SmppConnectionsTable = ({ customerId: customerId })=>{
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)({
        isEditing: true,
        useUrlParams: false
    });
    const { entity: entity, onChange: onChange } = formState;
    const { showModal: showModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const [showForm, setShowForm] = (0, $fgmOP.useState)(false);
    const { hasPermission: hasPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { customerName: customerName } = (0, $6fadca55099b66d6$export$dd46433206d0b2d9)();
    const { getCustomerName: getCustomerName } = (0, $b06c1af11eebe0e3$export$6830a00b8ce0c90e)();
    const customerNameById = getCustomerName(customerId);
    const smppSessionsWithProductDetailsOperationVariables = {
        variables: {
            customerId: customerId
        },
        onCompleted: (data)=>{
            if (data.smppSessionsWithProductDetails && data.smppSessionsWithProductDetails.length > 0) setShowForm(true);
        }
    };
    const { loading: loading, error: error, data: data, refetch: refetch } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($0d4ecb7730457cbc$exports)))), smppSessionsWithProductDetailsOperationVariables);
    const unbindSmppSession = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($6a277913234cb26a$exports)))));
    const disconnectSession = (session)=>{
        unbindSmppSession({
            loadingText: "Disconnecting...",
            successText: "Session disconnected",
            variables: {
                session: session
            },
            update: ()=>{
                refetch(smppSessionsWithProductDetailsOperationVariables);
            }
        });
    };
    const onUnbind = (session)=>{
        $c23531f918a5c963$var$log.debug("disconnectSession", {
            session: session
        });
        showModal({
            show: true,
            title: `Disconnect SMPP session`,
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                children: [
                    "Are you sure you want to unbind ",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("b", {
                        children: [
                            " ServiceID:",
                            session.productId,
                            " "
                        ]
                    }),
                    " session?"
                ]
            }),
            confirmText: "Disconnect",
            confirmType: "negative",
            onConfirm: ()=>disconnectSession(session)
        });
    };
    const [expandedCells, setExpandedCells] = (0, $fgmOP.useState)({});
    const handleCellClick = (rowIndex, columnId)=>{
        const cellKey = `${rowIndex}-${columnId}`;
        setExpandedCells((prevState)=>({
                ...prevState,
                [cellKey]: !prevState[cellKey]
            }));
    };
    const truncateText = (text, length, isExpanded)=>{
        if (isExpanded) return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("strong", {
            children: text
        });
        if (!text) return "";
        return text.length > length ? text.substring(0, length) + "..." : text;
    };
    const filteredData = (0, $fgmOP.useMemo)(()=>{
        if (!data || !data.smppSessionsWithProductDetails) return [];
        const fromDateTime = entity.fromDate ? new Date(`${entity.fromDate}T${entity.fromTime || "00:00:00"}`) : null;
        const toDateTime = entity.toDate ? new Date(`${entity.toDate}T${entity.toTime || "23:59:59"}`) : null;
        return data.smppSessionsWithProductDetails.filter((item)=>{
            const sessionDate = new Date(item.sessionCreatedAt);
            const productIdFilter = entity.productId ? String(entity.productId) : "";
            const customerIdFilter = entity.customerId ? String(entity.customerId) : "";
            const filterConditions = [
                !productIdFilter || item.productId.includes(productIdFilter),
                !customerIdFilter || item.customerId.includes(customerIdFilter),
                !fromDateTime || sessionDate >= fromDateTime,
                !toDateTime || sessionDate <= toDateTime
            ];
            return filterConditions.every((condition)=>condition);
        });
    }, [
        data,
        entity
    ]);
    const [sortedTableContent, getThSortableProps] = (0, $c1364c3d18563e9b$export$2e2bcd8739ae039).useThSortable(filteredData, 3, [], {});
    if (loading) return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {});
    if (error) return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("p", {
        children: [
            "Error: ",
            error.message
        ]
    });
    $c23531f918a5c963$var$log.debug("sortedTableContent", {
        sortedTableContent: sortedTableContent
    });
    const displayedCustomerName = customerName || customerNameById;
    const isManagement = !customerId;
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "form--column--margin--normal",
                children: showForm && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $2e4c8094e1930e9a$export$2e2bcd8739ae039), {
                    onSubmit: (e)=>e.preventDefault(),
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: [
                                    isManagement ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "customerId",
                                        label: "Customer ID",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).input,
                                        onChange: onChange("customerId")
                                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                        label: "Customer",
                                        value: displayedCustomerName,
                                        isDisabled: true
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "productId",
                                        label: "Service ID",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).input,
                                        onChange: onChange("productId")
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                            formState: formState,
                                            entityFieldId: "fromDate",
                                            label: "From date",
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date,
                                            defaultValue: entity.inheritsEndDate ? entity.toDate : "no end"
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                            formState: formState,
                                            entityFieldId: "fromTime",
                                            label: "From time",
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).time,
                                            defaultValue: "End of day"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                            formState: formState,
                                            entityFieldId: "toDate",
                                            label: "To date",
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date,
                                            defaultValue: entity.inheritsEndDate ? entity.toDate : "no end"
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                            formState: formState,
                                            entityFieldId: "toTime",
                                            label: "To time",
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).time,
                                            defaultValue: "End of day"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            sortedTableContent && sortedTableContent.length > 0 ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039), {
                clickable: false,
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($c23531f918a5c963$var$THead, {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)($c23531f918a5c963$var$Tr, {
                            children: [
                                isManagement && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($c23531f918a5c963$var$ThSortable, {
                                    ...getThSortableProps("customerId"),
                                    children: "Customer ID"
                                }),
                                isManagement && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($c23531f918a5c963$var$ThSortable, {
                                    ...getThSortableProps("customerId"),
                                    children: "Customer"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($c23531f918a5c963$var$ThSortable, {
                                    ...getThSortableProps("productId"),
                                    children: "Service ID"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($c23531f918a5c963$var$ThSortable, {
                                    ...getThSortableProps("sessionCreatedAt"),
                                    children: "Start Date"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($c23531f918a5c963$var$ThSortable, {
                                    ...getThSortableProps("apiCredentials"),
                                    children: "Username"
                                }),
                                !customerId && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($c23531f918a5c963$var$ThSortable, {
                                    ...getThSortableProps("instanceId"),
                                    children: "ECS Instance ID"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($c23531f918a5c963$var$ThSortable, {
                                    ...getThSortableProps("bindType"),
                                    children: "Session Type"
                                }),
                                hasPermission((0, $ca0941499cca84bb$export$2c134167e4d6a0ca)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($c23531f918a5c963$var$Th, {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($c23531f918a5c963$var$TBody, {
                        children: sortedTableContent.map(({ sessionId: sessionId, customerId: customerId, productId: productId, sessionCreatedAt: sessionCreatedAt, apiCredentials: apiCredentials, instanceId: instanceId, bindType: bindType }, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)($c23531f918a5c963$var$Tr, {
                                children: [
                                    isManagement && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($c23531f918a5c963$var$Td, {
                                        children: customerId
                                    }),
                                    isManagement && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($c23531f918a5c963$var$Td, {
                                        children: getCustomerName(customerId)
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($c23531f918a5c963$var$Td, {
                                        children: productId
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($c23531f918a5c963$var$Td, {
                                        onClick: ()=>handleCellClick(i, "sessionCreatedAt"),
                                        children: truncateText((0, $f5d0c2a7498ff49b$exports.format).dateTime(sessionCreatedAt), 11, !!expandedCells[`${i}-sessionCreatedAt`])
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($c23531f918a5c963$var$Td, {
                                        onClick: ()=>handleCellClick(i, "apiCredentials"),
                                        children: truncateText(apiCredentials, 11, !!expandedCells[`${i}-apiCredentials`])
                                    }),
                                    isManagement && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($c23531f918a5c963$var$Td, {
                                        onClick: ()=>handleCellClick(i, "instanceId"),
                                        children: truncateText(instanceId, 11, !!expandedCells[`${i}-instanceId`])
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($c23531f918a5c963$var$Td, {
                                        children: bindType
                                    }),
                                    hasPermission((0, $ca0941499cca84bb$export$2c134167e4d6a0ca)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($c23531f918a5c963$var$Td, {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                            text: "Disconnect",
                                            kind: "negative",
                                            onClick: ()=>onUnbind({
                                                    sessionId: sessionId,
                                                    customerId: customerId,
                                                    productId: productId,
                                                    sessionCreatedAt: sessionCreatedAt,
                                                    apiCredentials: apiCredentials,
                                                    instanceId: instanceId,
                                                    bindType: bindType
                                                })
                                        })
                                    })
                                ]
                            }, i))
                    })
                ]
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                children: "No SMPP connections found"
            })
        ]
    });
};
var $c23531f918a5c963$export$2e2bcd8739ae039 = $c23531f918a5c963$var$SmppConnectionsTable;


const $ba52c036a92f272c$export$9ce69eb665c9fd81 = ({ customerId: customerId })=>{
    const [active, setActive] = (0, $fgmOP.useState)(customerId ? (0, $ecc4226f40c1c037$export$b6967b18ec8f2513).RIGHT : (0, $ecc4226f40c1c037$export$b6967b18ec8f2513).LEFT);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                        size: (0, $6c2490027a2e159e$export$95dbfef2e4b1962b),
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                                children: active === (0, $ecc4226f40c1c037$export$b6967b18ec8f2513).LEFT && !customerId ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                                    children: "Smpp summary"
                                }) : active === (0, $ecc4226f40c1c037$export$b6967b18ec8f2513).RIGHT && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                                    children: [
                                        "Smpp connections",
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $208e3a63656dc21c$export$2e2bcd8739ae039), {
                                            text: "Click on cell to view full value"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                                page: "smpp-connections"
                            })
                        ]
                    }),
                    !customerId && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                        size: (0, $6c2490027a2e159e$export$44c04526d4b77f07),
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ecc4226f40c1c037$export$fb4216da1f591b95), {
                            active: active,
                            leftLabel: "Summary view",
                            rightLabel: "Detailed view",
                            leftOnClickHandler: ()=>setActive((0, $ecc4226f40c1c037$export$b6967b18ec8f2513).LEFT),
                            rightOnClickHandler: ()=>setActive((0, $ecc4226f40c1c037$export$b6967b18ec8f2513).RIGHT)
                        })
                    })
                ]
            }),
            active === (0, $ecc4226f40c1c037$export$b6967b18ec8f2513).LEFT && !customerId ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                        children: "List of services configured with SMPP protocol and summaries of their connection status."
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $611f8b4c08ff43ac$export$360077c5630c247c), {})
                ]
            }) : active === (0, $ecc4226f40c1c037$export$b6967b18ec8f2513).RIGHT && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                        children: "List of active SMPP connection details."
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c23531f918a5c963$export$2e2bcd8739ae039), {
                        customerId: customerId
                    })
                ]
            })
        ]
    });
};





var $2MPlc = parcelRequire("2MPlc");


var $fgmOP = parcelRequire("fgmOP");


var $e518621b97fca5b8$exports = {};
$e518621b97fca5b8$exports = "fragment userFragment on User{id cognitoId firstName lastName phone email description permissions type userAccessStatusType customerId comment roles rolesMap{resource roles permissions}isSSOUser mfaOptions{sms{enabled phone}app{enabled}}}";


var $1c96f5f8c4cbad74$exports = {};
$1c96f5f8c4cbad74$exports = "mutation deleteUserMutation($userId:ID!$pageType:UserTypeEnum$customerId:ID){deleteUser(userId:$userId pageType:$pageType customerId:$customerId)}";


var $d2756dbba47edf22$exports = {};
$d2756dbba47edf22$exports = "mutation saveUserMutation($user:UserInput!$pageType:UserTypeEnum$customerId:ID){saveUser(user:$user pageType:$pageType customerId:$customerId){...userFragment}}fragment userFragment on User{id cognitoId firstName lastName phone email description permissions type userAccessStatusType customerId comment roles rolesMap{resource roles permissions}isSSOUser mfaOptions{sms{enabled phone}app{enabled}}}";













function $73d0a56999265e6c$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    var fragments = [];
    document.definitions.forEach(function(definition) {
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === "OperationDefinition") throw (0, $57583217334b5278$export$3991762405098ea)(71, definition.operation, definition.name ? " named '".concat(definition.name.value, "'") : "");
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === "undefined") {
        (0, $57583217334b5278$export$f5708dca728d7177)(fragments.length === 1, 72, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    var query = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, document), {
        definitions: (0, $e2e041e4a1657497$export$1216008129fb82ed)([
            {
                kind: "OperationDefinition",
                // OperationTypeNode is an enum
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions, true)
    });
    return query;
}
function $73d0a56999265e6c$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $73d0a56999265e6c$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case "InlineFragment":
            return selection;
        case "FragmentSpread":
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") return fragmentMap(fragmentName);
            var fragment = fragmentMap && fragmentMap[fragmentName];
            (0, $57583217334b5278$export$f5708dca728d7177)(fragment, 73, fragmentName);
            return fragment || null;
        default:
            return null;
    }
}




var $78b40fbe7ce5625c$export$88a0ad9b6f961b51 = Object.assign(function canonicalStringify(value) {
    return JSON.stringify(value, $78b40fbe7ce5625c$var$stableObjectReplacer);
}, {
    reset: function() {
        // Clearing the sortingMap will reclaim all cached memory, without
        // affecting the logical results of canonicalStringify, but potentially
        // sacrificing performance until the cache is refilled.
        $78b40fbe7ce5625c$var$sortingMap = new (0, $df1718e4a0eb4d0a$export$5b4f745137d91413)((0, $e8270474df1c6a9d$export$f29926b23b28936b).canonicalStringify || 1000 /* defaultCacheSizes.canonicalStringify */ );
    }
});
if (globalThis.__DEV__ !== false) (0, $19eefe0273f1ef83$export$a8fcd406d9e37621)("canonicalStringify", function() {
    return $78b40fbe7ce5625c$var$sortingMap.size;
});
// Values are JSON-serialized arrays of object keys (in any order), and values
// are sorted arrays of the same keys.
var $78b40fbe7ce5625c$var$sortingMap;
$78b40fbe7ce5625c$export$88a0ad9b6f961b51.reset();
// The JSON.stringify function takes an optional second argument called a
// replacer function. This function is called for each key-value pair in the
// object being stringified, and its return value is used instead of the
// original value. If the replacer function returns a new value, that value is
// stringified as JSON instead of the original value of the property.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter
function $78b40fbe7ce5625c$var$stableObjectReplacer(key, value) {
    if (value && typeof value === "object") {
        var proto = Object.getPrototypeOf(value);
        // We don't want to mess with objects that are not "plain" objects, which
        // means their prototype is either Object.prototype or null. This check also
        // prevents needlessly rearranging the indices of arrays.
        if (proto === Object.prototype || proto === null) {
            var keys = Object.keys(value);
            // If keys is already sorted, let JSON.stringify serialize the original
            // value instead of creating a new object with keys in the same order.
            if (keys.every($78b40fbe7ce5625c$var$everyKeyInOrder)) return value;
            var unsortedKey = JSON.stringify(keys);
            var sortedKeys = $78b40fbe7ce5625c$var$sortingMap.get(unsortedKey);
            if (!sortedKeys) {
                keys.sort();
                var sortedKey = JSON.stringify(keys);
                // Checking for sortedKey in the sortingMap allows us to share the same
                // sorted array reference for all permutations of the same set of keys.
                sortedKeys = $78b40fbe7ce5625c$var$sortingMap.get(sortedKey) || keys;
                $78b40fbe7ce5625c$var$sortingMap.set(unsortedKey, sortedKeys);
                $78b40fbe7ce5625c$var$sortingMap.set(sortedKey, sortedKeys);
            }
            var sortedObject_1 = Object.create(proto);
            // Reassigning the keys in sorted order will cause JSON.stringify to
            // serialize them in sorted order.
            sortedKeys.forEach(function(key) {
                sortedObject_1[key] = value[key];
            });
            return sortedObject_1;
        }
    }
    return value;
}
// Since everything that happens in stableObjectReplacer benefits from being as
// efficient as possible, we use a static function as the callback for
// keys.every in order to test if the provided keys are already sorted without
// allocating extra memory for a callback.
function $78b40fbe7ce5625c$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}


function $4ab7359740364a58$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}
function $4ab7359740364a58$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
function $4ab7359740364a58$export$540432d49fcec6c9(value) {
    return (0, $a5b286f532530da9$export$417207af72fad9c9)(value) && value.kind === "Document" && Array.isArray(value.definitions);
}
function $4ab7359740364a58$var$isStringValue(value) {
    return value.kind === "StringValue";
}
function $4ab7359740364a58$var$isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function $4ab7359740364a58$var$isIntValue(value) {
    return value.kind === "IntValue";
}
function $4ab7359740364a58$var$isFloatValue(value) {
    return value.kind === "FloatValue";
}
function $4ab7359740364a58$var$isVariable(value) {
    return value.kind === "Variable";
}
function $4ab7359740364a58$var$isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function $4ab7359740364a58$var$isListValue(value) {
    return value.kind === "ListValue";
}
function $4ab7359740364a58$var$isEnumValue(value) {
    return value.kind === "EnumValue";
}
function $4ab7359740364a58$var$isNullValue(value) {
    return value.kind === "NullValue";
}
function $4ab7359740364a58$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($4ab7359740364a58$var$isIntValue(value) || $4ab7359740364a58$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($4ab7359740364a58$var$isBooleanValue(value) || $4ab7359740364a58$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($4ab7359740364a58$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $4ab7359740364a58$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($4ab7359740364a58$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($4ab7359740364a58$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $4ab7359740364a58$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($4ab7359740364a58$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($4ab7359740364a58$var$isNullValue(value)) argObj[name.value] = null;
    else throw (0, $57583217334b5278$export$3991762405098ea)(82, name.value, value.kind);
}
function $4ab7359740364a58$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $4ab7359740364a58$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $4ab7359740364a58$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $4ab7359740364a58$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $4ab7359740364a58$var$KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive"
];
// Default stable JSON.stringify implementation used by getStoreKeyName. Can be
// updated/replaced with something better by calling
// getStoreKeyName.setStringify(newStringifyFunction).
var $4ab7359740364a58$var$storeKeyNameStringify = (0, $78b40fbe7ce5625c$export$88a0ad9b6f961b51);
var $4ab7359740364a58$export$3cdb6c178b88cabe = Object.assign(function(fieldName, args, directives) {
    if (args && directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives["connection"]["key"], "(").concat($4ab7359740364a58$var$storeKeyNameStringify(filteredArgs_1), ")");
        } else return directives["connection"]["key"];
    }
    var completeFieldName = fieldName;
    if (args) {
        // We can't use `JSON.stringify` here since it's non-deterministic,
        // and can lead to different store key names being created even though
        // the `args` object used during creation has the same properties/values.
        var stringifiedArgs = $4ab7359740364a58$var$storeKeyNameStringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($4ab7359740364a58$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@".concat(key, "(").concat($4ab7359740364a58$var$storeKeyNameStringify(directives[key]), ")");
        else completeFieldName += "@".concat(key);
    });
    return completeFieldName;
}, {
    setStringify: function(s) {
        var previous = $4ab7359740364a58$var$storeKeyNameStringify;
        $4ab7359740364a58$var$storeKeyNameStringify = s;
        return previous;
    }
});
function $4ab7359740364a58$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $4ab7359740364a58$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $4ab7359740364a58$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $4ab7359740364a58$export$cf7bf7e4f289cc26(result, selectionSet, fragmentMap) {
    var fragments;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if ($4ab7359740364a58$export$fb56ad75dd311c12(selection)) {
            if (selection.name.value === "__typename") return result[$4ab7359740364a58$export$7d1ad22471852218(selection)];
        } else if (fragments) fragments.push(selection);
        else fragments = [
            selection
        ];
    }
    if (typeof result.__typename === "string") return result.__typename;
    if (fragments) for(var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++){
        var selection = fragments_1[_b];
        var typename = $4ab7359740364a58$export$cf7bf7e4f289cc26(result, (0, $73d0a56999265e6c$export$f80bdb85f299186)(selection, fragmentMap).selectionSet, fragmentMap);
        if (typeof typename === "string") return typename;
    }
}
function $4ab7359740364a58$export$fb56ad75dd311c12(selection) {
    return selection.kind === "Field";
}
function $4ab7359740364a58$export$22a1cdafaf27bcff(selection) {
    return selection.kind === "InlineFragment";
}


function $d34613b28fb40239$export$a7d0d8111d2386df(doc) {
    (0, $57583217334b5278$export$f5708dca728d7177)(doc && doc.kind === "Document", 74);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
        if (definition.kind !== "OperationDefinition") throw (0, $57583217334b5278$export$3991762405098ea)(75, definition.kind);
        return definition;
    });
    (0, $57583217334b5278$export$f5708dca728d7177)(operations.length <= 1, 76, operations.length);
    return doc;
}
function $d34613b28fb40239$export$7a5b1fa979d2c158(doc) {
    $d34613b28fb40239$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function $d34613b28fb40239$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && !!definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $d34613b28fb40239$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function $d34613b28fb40239$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $d34613b28fb40239$export$7a5b1fa979d2c158(doc);
    (0, $57583217334b5278$export$f5708dca728d7177)(queryDef && queryDef.operation === "query", 77);
    return queryDef;
}
function $d34613b28fb40239$export$772111caef41b3f5(doc) {
    (0, $57583217334b5278$export$f5708dca728d7177)(doc.kind === "Document", 78);
    (0, $57583217334b5278$export$f5708dca728d7177)(doc.definitions.length <= 1, 79);
    var fragmentDef = doc.definitions[0];
    (0, $57583217334b5278$export$f5708dca728d7177)(fragmentDef.kind === "FragmentDefinition", 80);
    return fragmentDef;
}
function $d34613b28fb40239$export$f431198736b7f96d(queryDoc) {
    $d34613b28fb40239$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" || operation === "mutation" || operation === "subscription") return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) // we do this because we want to allow multiple fragment definitions
        // to precede an operation definition.
        fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw (0, $57583217334b5278$export$3991762405098ea)(81);
}
function $d34613b28fb40239$export$84c19026e616569e(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, $4ab7359740364a58$export$a1dab82d368d6525)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}



var $fgmOP = parcelRequire("fgmOP");


const $cd0b9ee27a364316$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useApolloCacheEntity", "INFO");
const $cd0b9ee27a364316$export$4c2508f4134d3a42 = (props)=>{
    const { entityId: entityId, newEntity: newEntity, watchQuery: watchQuery, watchVariables: watchVariables } = props;
    const fragment = (0, $d155419fd10bd2b6$export$72e4926bf8358653)(props.fragment);
    const fragmentDefinion = (0, $d34613b28fb40239$export$5320a7ba9466a3df)(fragment)[0];
    const fragmentName = fragmentDefinion.name.value;
    const fragmentType = fragmentDefinion.typeCondition.name.value;
    const apolloClient = (0, $7626a5aec6f1579a$export$eb9a56e7a29e494)();
    const [initialEntity, setInitialEntity] = (0, $fgmOP.useState)();
    const readEntityFromCache = ()=>{
        const id = `${fragmentType}:${entityId}`;
        const cacheEntity = apolloClient.cache.readFragment({
            fragment: fragment,
            fragmentName: fragmentName,
            id: id
        });
        if (cacheEntity) {
            $cd0b9ee27a364316$var$log.debug(`Found '${id}' fragment in apollo client cache`, cacheEntity);
            setInitialEntity(cacheEntity);
        } else $cd0b9ee27a364316$var$log.warn(`No '${id}' fragment in apollo client cache`);
    };
    const isNewEntity = entityId === $e9a95c61c800ecd2$export$15f47a32373730e5;
    $cd0b9ee27a364316$var$log.debug(isNewEntity ? `Is new ${fragmentType} Entity` : `Entity ID: ${entityId}`);
    if (initialEntity) $cd0b9ee27a364316$var$log.debug("initialEntity already set");
    else if (isNewEntity) {
        $cd0b9ee27a364316$var$log.debug("Setting initialEntity from newEntity");
        setInitialEntity({
            ...newEntity,
            id: null
        });
    } else {
        readEntityFromCache();
        if (watchQuery) apolloClient // Listen to cache changes, and update initialEntity if needed
        .watchQuery({
            fetchPolicy: "cache-first",
            query: watchQuery,
            variables: watchVariables
        }).subscribe(readEntityFromCache);
    }
    const formStateOptions = {
        isEditing: isNewEntity,
        initialEntity: initialEntity
    };
    $cd0b9ee27a364316$var$log.debug({
        props: props,
        formStateOptions: formStateOptions
    });
    return formStateOptions;
};











var $l8GLF = parcelRequire("l8GLF");









parcelRequire("fgmOP");

const $8e2421cb37be9d76$export$7eda936955feae4d = ({ formState: formState, entityFieldId: entityFieldId, className: className, label: label, isEditing: isEditing, tip: tip, value: value })=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
        formState: formState,
        isEditing: isEditing,
        entityFieldId: entityFieldId || "phone",
        label: label || "Mobile",
        placeholder: "+0000000000",
        value: value,
        tip: tip ? tip : isEditing !== undefined && isEditing || formState.isEditing ? "Phone number must start with (+) international code and followed by 5 to 20 digits (without spaces)" : null,
        className: className
    });
};







var $fgmOP = parcelRequire("fgmOP");






parcelRequire("fgmOP");






parcelRequire("fgmOP");

const $702c010b4d2d1d11$var$TableFc = (props)=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("table", {
        id: props.id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))(props.className),
        children: props.children
    });
};
var $702c010b4d2d1d11$export$2e2bcd8739ae039 = $702c010b4d2d1d11$var$TableFc;



var $fgmOP = parcelRequire("fgmOP");

const $1ef5d15835208031$var$TableCellFc = (props)=>{
    return /*#__PURE__*/ (0, $fgmOP.createElement)(props.isHeader ? "th" : "td", {
        id: props.id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))(props.className)
    }, props.children);
};
var $1ef5d15835208031$export$2e2bcd8739ae039 = $1ef5d15835208031$var$TableCellFc;



parcelRequire("fgmOP");

const $41f29eaafa60f6ab$var$TableRowFc = (props)=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("tr", {
        id: props.id,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))(props.className),
        children: props.children
    });
};
var $41f29eaafa60f6ab$export$2e2bcd8739ae039 = $41f29eaafa60f6ab$var$TableRowFc;




const $321246bff7fd88aa$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("RolesTable", "INFO");
const $321246bff7fd88aa$export$beed2416f08339a2 = ({ formState: formState, resourceOptions: resourceOptions, roles: roles, getResourceRoles: getResourceRoles, addResourceRole: addResourceRole, removeResourceRole: removeResourceRole, hasResourceEditPermission: hasResourceEditPermission, showHeadings: showHeadings = true, showDeleteButton: showDeleteButton = false, onRemoveResource: onRemoveResource })=>{
    const hasRoleInAny = (roleId)=>resourceOptions?.some(({ id: id })=>getResourceRoles(id, formState.entityAs().rolesMap).includes(roleId));
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $702c010b4d2d1d11$export$2e2bcd8739ae039), {
        id: "permissionsTable",
        className: "roles__table",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("thead", {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $41f29eaafa60f6ab$export$2e2bcd8739ae039), {
                    className: "roles__table--row",
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef5d15835208031$export$2e2bcd8739ae039), {
                            isHeader: true,
                            className: "label",
                            children: "Role"
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef5d15835208031$export$2e2bcd8739ae039), {
                            isHeader: true,
                            className: "roles__table--spacing"
                        }),
                        showHeadings && resourceOptions.map((resource)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef5d15835208031$export$2e2bcd8739ae039), {
                                className: "rotate-45",
                                isHeader: true,
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                        children: resource.name
                                    })
                                })
                            }, resource.id + "Header"))
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tbody", {
                children: [
                    roles.map((roleOption, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $41f29eaafa60f6ab$export$2e2bcd8739ae039), {
                            className: "roles__table--row",
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef5d15835208031$export$2e2bcd8739ae039), {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("roles__table--name", "label", {
                                        inactive: !hasRoleInAny(roleOption.id)
                                    }),
                                    children: roleOption.name
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef5d15835208031$export$2e2bcd8739ae039), {
                                    className: "roles__table--tip",
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $acf38b6c25932409$export$2e2bcd8739ae039), {
                                        text: roleOption.description
                                    })
                                }),
                                resourceOptions.map((resource)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef5d15835208031$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                            value: getResourceRoles(resource.id, formState.entityAs().rolesMap, true).includes(roleOption.id),
                                            onChange: (checked)=>{
                                                const rolesMap = formState.subEntityAt("rolesMap");
                                                const updatedRolesMap = checked ? addResourceRole(roleOption.id, resource.id, rolesMap) : removeResourceRole(roleOption.id, resource.id, rolesMap);
                                                $321246bff7fd88aa$var$log.debug("updated rolesMap", updatedRolesMap);
                                                formState.onChange("rolesMap")(updatedRolesMap); //TODO: as any
                                            },
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox,
                                            isEditing: formState.isEditing && hasResourceEditPermission(resource.id)
                                        })
                                    }, roleOption.id + resource.id))
                            ]
                        }, roleOption.id)),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $41f29eaafa60f6ab$export$2e2bcd8739ae039), {
                        className: "roles__table--row",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef5d15835208031$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef5d15835208031$export$2e2bcd8739ae039), {}),
                            showDeleteButton && resourceOptions.map(({ id: id })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef5d15835208031$export$2e2bcd8739ae039), {
                                    children: formState.isEditing && hasResourceEditPermission(id) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                        icon: "trash",
                                        className: "redText pointer rem1_25 halfRightMargin",
                                        onClick: ()=>onRemoveResource && onRemoveResource(id)
                                    })
                                }))
                        ]
                    })
                ]
            })
        ]
    });
};


const $90a05629a2e1babc$export$c7e5978effe5f852 = (props)=>{
    const { brands: brands } = (0, $97a71fda4fbdc6d3$export$da3999a1d9248c0c)();
    const { hasBrandPermission: hasBrandPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { addBrandRole: addBrandRole, removeBrandRole: removeBrandRole, getBrandRoles: getBrandRoles } = (0, $d9122fadf72c2a2d$export$7852d8680b86d89b)();
    const brandOptions = (0, $fgmOP.useMemo)(()=>[
            {
                id: "*",
                name: "All Brands"
            },
            ...brands || []
        ], [
        brands
    ]);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $321246bff7fd88aa$export$beed2416f08339a2), {
        ...props,
        resourceOptions: brandOptions,
        addResourceRole: addBrandRole,
        removeResourceRole: removeBrandRole,
        getResourceRoles: (resourceId, rolesMap, exact)=>getBrandRoles(resourceId, rolesMap, exact),
        hasResourceEditPermission: (resourceId)=>hasBrandPermission((0, $ca0941499cca84bb$export$619b28da925d56b7), resourceId)
    });
};




var $2MPlc = parcelRequire("2MPlc");


var $fgmOP = parcelRequire("fgmOP");








var $fgmOP = parcelRequire("fgmOP");

var $fgmOP = parcelRequire("fgmOP");


var $fgmOP = parcelRequire("fgmOP");
function $c296d273c9c62e14$var$_slicedToArray(arr, i) {
    return $c296d273c9c62e14$var$_arrayWithHoles(arr) || $c296d273c9c62e14$var$_iterableToArrayLimit(arr, i) || $c296d273c9c62e14$var$_unsupportedIterableToArray(arr, i) || $c296d273c9c62e14$var$_nonIterableRest();
}
function $c296d273c9c62e14$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c296d273c9c62e14$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c296d273c9c62e14$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c296d273c9c62e14$var$_arrayLikeToArray(o, minLen);
}
function $c296d273c9c62e14$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c296d273c9c62e14$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c296d273c9c62e14$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $c296d273c9c62e14$export$f8168d8dd8fd66e6 = function useFocus(props) {
    var localRef = (0, $fgmOP.useRef)(null);
    var inputRef = props.inputRef || localRef;
    var _useState = (0, $fgmOP.useState)(false), _useState2 = $c296d273c9c62e14$var$_slicedToArray(_useState, 2), focus = _useState2[0], setFocus = _useState2[1];
    (0, $fgmOP.useEffect)(function() {
        if (inputRef.current) {
            if (focus) inputRef.current.focus();
            else inputRef.current.blur();
        }
    }, [
        focus,
        inputRef.current
    ]);
    var onFocus = function onFocus(e) {
        setFocus(true);
        if (props.onFocus) props.onFocus(e);
    };
    var onBlur = function onBlur(e) {
        setFocus(false);
        if (props.onBlur) props.onBlur(e);
    };
    var onKeyDown = function onKeyDown(e) {
        if (props.onKeyDown) props.onKeyDown(e);
        if (e.keyCode === 9) e.stopPropagation();
    };
    return {
        inputRef: inputRef,
        focus: focus,
        setFocus: setFocus,
        onFocus: onFocus,
        onBlur: onBlur,
        onChange: props.onChange,
        onKeyDown: onKeyDown
    };
};




var $fgmOP = parcelRequire("fgmOP");


function $c750dd4eaae8b86c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c750dd4eaae8b86c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $c750dd4eaae8b86c$var$ownKeys(Object(source), true).forEach(function(key) {
            $c750dd4eaae8b86c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $c750dd4eaae8b86c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c750dd4eaae8b86c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $c750dd4eaae8b86c$export$383be6bbb4f37a3e = {
    // White
    white: "#FFFFFF",
    // Accent
    accent250: "#ebebeb",
    // Purple
    corePurple100: "#fbf0ff",
    corePurple200: "#edc8ff",
    corePurple300: "#de99ff",
    corePurple400: "#c158f8",
    corePurple500: "#990ae3",
    corePurple600: "#7d00bd",
    corePurple700: "#5f008f",
    corePurple800: "#3f005e",
    corePurple850: "#29003e",
    corePurple900: "#1f002e",
    // Grey
    grey50: "#f4f4f9",
    grey100: "#f2f2f2",
    grey200: "#dbdbdb",
    grey300: "#bdbdbd",
    grey400: "#9c9c9c",
    grey500: "#7a7a7a",
    grey600: "#646464",
    grey700: "#4e4e4e",
    grey800: "#383838",
    grey900: "#222222",
    // Green
    green100: "#ccefdd",
    green200: "#a6e3c4",
    green300: "#73d3a2",
    green400: "#4cc789",
    green500: "#26bb6f",
    green600: "#00af56",
    green700: "#008641",
    green800: "#00572a",
    green900: "#00361a",
    // Red
    red100: "#fad1de",
    red200: "#f6aec6",
    red300: "#f07fa5",
    red400: "#eb5185",
    red500: "#e4175c",
    red600: "#be0040",
    red700: "#890e37",
    red800: "#5b0925",
    red900: "#390617",
    // Orange
    orange100: "#ffebcc",
    orange200: "#ffdca6",
    orange300: "#ffc366",
    orange400: "#ffaf33",
    orange500: "#ff9b00",
    orange600: "#cc7c00",
    orange700: "#995d00",
    orange800: "#663e00",
    orange900: "#402700",
    // Blue
    blue100: "#ccebff",
    blue200: "#a6dbff",
    blue300: "#66c2ff",
    blue400: "#33adff",
    blue500: "#0099ff",
    blue600: "#007acc",
    blue700: "#00558f",
    blue800: "#003d66",
    blue900: "#00253d"
};
var $c750dd4eaae8b86c$export$eeac0f1c28b9ef0 = {
    corePurple: $c750dd4eaae8b86c$export$383be6bbb4f37a3e.corePurple500,
    deepPurple: $c750dd4eaae8b86c$export$383be6bbb4f37a3e.corePurple800,
    blackPurple: $c750dd4eaae8b86c$export$383be6bbb4f37a3e.corePurple900,
    lightGrey: $c750dd4eaae8b86c$export$383be6bbb4f37a3e.grey200,
    darkGrey: $c750dd4eaae8b86c$export$383be6bbb4f37a3e.grey400,
    black: $c750dd4eaae8b86c$export$383be6bbb4f37a3e.grey900,
    green: $c750dd4eaae8b86c$export$383be6bbb4f37a3e.green500,
    red: $c750dd4eaae8b86c$export$383be6bbb4f37a3e.red500,
    orange: $c750dd4eaae8b86c$export$383be6bbb4f37a3e.orange500,
    blue: $c750dd4eaae8b86c$export$383be6bbb4f37a3e.blue500
};
var $c750dd4eaae8b86c$export$8f45430ccf837300 = $c750dd4eaae8b86c$var$_objectSpread($c750dd4eaae8b86c$var$_objectSpread({}, $c750dd4eaae8b86c$export$383be6bbb4f37a3e), $c750dd4eaae8b86c$export$eeac0f1c28b9ef0);



var $fgmOP = parcelRequire("fgmOP");



var $5f3f030b0726df57$export$353f5b6fc5456de1 = function Button(props) {
    var _props$kind = props.kind, kind = _props$kind === void 0 ? "primary" : _props$kind, label = props.label, href = props.href, onClick = props.onClick, icon = props.icon, ariaLabel = props.ariaLabel, iconRight = props.iconRight, _props$disabled = props.disabled, disabled = _props$disabled === void 0 ? false : _props$disabled, _props$active = props.active, active = _props$active === void 0 ? false : _props$active, _props$size = props.size, size = _props$size === void 0 ? "default" : _props$size, target = props.target, _props$type = props.type, type = _props$type === void 0 ? "button" : _props$type, className = props.className, _props$loading = props.loading, loading = _props$loading === void 0 ? false : _props$loading, dataTestId = props.dataTestId;
    var Tag = href ? "a" : "button";
    var handleClick = function handleClick(e) {
        if (href && onClick) e.preventDefault();
        if (onClick) onClick(e);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(Tag, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("telia-business-button", "telia-business-button--".concat(kind), "telia-business-button--".concat(size), {
            "telia-business-button--iconRight": iconRight,
            "telia-business-button--iconLeft": icon && !iconRight,
            "telia-business-button--ball": icon && !label,
            "telia-business-button--disabled": disabled || loading,
            "telia-business-button--active": active
        }, className),
        href: href,
        onClick: handleClick,
        disabled: disabled,
        type: href ? undefined : type,
        target: href ? target : undefined,
        "aria-label": ariaLabel,
        "aria-busy": loading,
        "data-testid": dataTestId
    }, loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("telia-business-button__spinner", {
            "telia-business-button__spinner--loading": loading
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $fc098853ee9e916f$export$2e2bcd8739ae039), {
        type: "sm"
    })), icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $2edc691f96482cbe$export$f04a61298a47a40f), {
        icon: icon,
        className: "telia-business-button__icon"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: loading ? "telia-business-button__label--loading" : ""
    }, label));
};


function $7454850214ee9cd5$var$_slicedToArray(arr, i) {
    return $7454850214ee9cd5$var$_arrayWithHoles(arr) || $7454850214ee9cd5$var$_iterableToArrayLimit(arr, i) || $7454850214ee9cd5$var$_unsupportedIterableToArray(arr, i) || $7454850214ee9cd5$var$_nonIterableRest();
}
function $7454850214ee9cd5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7454850214ee9cd5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7454850214ee9cd5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7454850214ee9cd5$var$_arrayLikeToArray(o, minLen);
}
function $7454850214ee9cd5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $7454850214ee9cd5$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $7454850214ee9cd5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $7454850214ee9cd5$export$27b7f944ca46a5e1 = function FieldInstructions(props) {
    var _props$open;
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useState(false), _React$useState2 = $7454850214ee9cd5$var$_slicedToArray(_React$useState, 2), open = _React$useState2[0], setOpen = _React$useState2[1];
    var _props$position = props.position, position = _props$position === void 0 ? "top-end" : _props$position;
    var toggle = function toggle(o) {
        if (props.setOpen !== undefined) props.setOpen(o);
        else setOpen(o);
    };
    var showCard = (_props$open = props.open) !== null && _props$open !== void 0 ? _props$open : open;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "telia-field-instructions"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "telia-field-instructions--icon",
        onClick: function onClick() {
            var _props$open2;
            return toggle((_props$open2 = !props.open, _props$open2 !== void 0) ? _props$open2 : !open);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $2edc691f96482cbe$export$f04a61298a47a40f), {
        icon: "question-circle",
        style: {
            width: "13px",
            height: "13px",
            color: (0, $c750dd4eaae8b86c$export$8f45430ccf837300).corePurple500
        }
    })), showCard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("telia-field-instructions--card", "telia-field-instructions--card__".concat(position))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "telia-field-instructions--card--header"
    }, props.label, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $5f3f030b0726df57$export$353f5b6fc5456de1), {
        icon: "close",
        size: "compact",
        kind: "secondary-text",
        onClick: function onClick() {
            return toggle(false);
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "telia-field-instructions--card--divider"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "telia-field-instructions--card--body"
    }, props.description), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "telia-field-instructions--card--arrow"
    })));
};


function $818b1019a2737a09$var$_slicedToArray(arr, i) {
    return $818b1019a2737a09$var$_arrayWithHoles(arr) || $818b1019a2737a09$var$_iterableToArrayLimit(arr, i) || $818b1019a2737a09$var$_unsupportedIterableToArray(arr, i) || $818b1019a2737a09$var$_nonIterableRest();
}
function $818b1019a2737a09$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $818b1019a2737a09$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $818b1019a2737a09$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $818b1019a2737a09$var$_arrayLikeToArray(o, minLen);
}
function $818b1019a2737a09$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $818b1019a2737a09$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $818b1019a2737a09$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $818b1019a2737a09$export$2c73285ae9390cec = function TextField(props) {
    var _useFocus = (0, $c296d273c9c62e14$export$f8168d8dd8fd66e6)(props), onChange = _useFocus.onChange, onBlur = _useFocus.onBlur, onFocus = _useFocus.onFocus, onKeyDown = _useFocus.onKeyDown, focus = _useFocus.focus, setFocus = _useFocus.setFocus, inputRef = _useFocus.inputRef;
    var inputLabelId = props.label && props.id ? "".concat(props.id, "-label") : undefined;
    var successIcon = props.kind === "purpur" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $2edc691f96482cbe$export$f04a61298a47a40f), {
        icon: "check-circle-filled"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $2edc691f96482cbe$export$f04a61298a47a40f), {
        icon: "check-mark-circle"
    });
    var statusIcon = props.success ? successIcon : props.error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $2edc691f96482cbe$export$f04a61298a47a40f), {
        icon: "alert"
    }) : null;
    var inputHasValue = props.value && props.value.length || inputRef.current && inputRef.current.value.length;
    /**
   * To support the compact TextField we need to position the label within the input,
   * and move to the border when input is active.
   * To position it correctly we need to find the width of the items in front of the input
   * an apply the appropriate offset.
   */ var _useState = (0, $fgmOP.useState)(undefined), _useState2 = $818b1019a2737a09$var$_slicedToArray(_useState, 2), compactLabelLeftOffset = _useState2[0], setCompactLabelLeftOffset = _useState2[1];
    var leftContentRef = (0, $fgmOP.useRef)(null);
    (0, $fgmOP.useEffect)(function() {
        return setCompactLabelLeftOffset(leftContentRef.current ? leftContentRef.current.clientWidth : undefined);
    }, [
        leftContentRef.current
    ]);
    var labelStyle = props.size === "compact" && !(focus || inputHasValue) && compactLabelLeftOffset ? {
        left: "calc(".concat(compactLabelLeftOffset, "px + 0.75rem)")
    } : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("telia-textfield", {
            "telia-textfield--focus": !!focus,
            "telia-textfield--success": !!props.success,
            "telia-textfield--error": !!props.error,
            "telia-textfield--disabled": !!props.disabled,
            "telia-textfield--compact": props.size === "compact",
            "telia-textfield--withValue": inputHasValue,
            "telia-textfield--white": props.kind === "white",
            "telia-textfield--grey": props.kind === "grey",
            "telia-textfield--purpur": props.kind === "purpur",
            "telia-textfield--prepended": !!props.leftContent,
            "telia-textfield--appended": !!props.rightContent || props.success || props.error
        }, props.className),
        onClick: function onClick() {
            if (!props.disabled) setFocus(true);
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", null, props.label ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("label", {
        style: labelStyle,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("telia-textfield__label"),
        id: inputLabelId
    }, props.label) : null, props.fieldInstructionsProps && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $7454850214ee9cd5$export$27b7f944ca46a5e1), props.fieldInstructionsProps), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "telia-textfield__content"
    }, props.leftContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        ref: leftContentRef,
        className: "telia-textfield__leftContent",
        onClick: function onClick(e) {
            return e.stopPropagation();
        }
    }, props.leftContent) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("input", {
        className: "telia-textfield__input",
        id: props.id,
        name: props.name,
        ref: inputRef,
        type: props.type || "text",
        placeholder: props.placeholder,
        disabled: props.disabled,
        required: props.required,
        value: props.value,
        "aria-label": props["aria-label"],
        "aria-labelledby": inputLabelId,
        "aria-activedescendant": props["aria-activedescendant"],
        "aria-autocomplete": props["aria-autocomplete"],
        "aria-controls": props["aria-controls"],
        autoComplete: props.autoComplete,
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyDown,
        onPaste: props.onPaste,
        onKeyUp: props.onKeyUp,
        maxLength: props.maxlength,
        "data-testid": props.dataTestId,
        autoFocus: props.autoFocus,
        "data-tracking-id": props.dataTrackingId
    }), statusIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: "telia-textfield__status"
    }, statusIcon) : null, props.rightContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "telia-textfield__rightContent",
        onClick: function onClick(e) {
            return e.stopPropagation();
        }
    }, props.rightContent) : null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("small", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("telia-textfield__helptext")
    }, props.helpText));
};



var $b9b1f7b66cd50c54$export$bc81b1baaa8c945f = function QuickSearch(props) {
    var animated = props.animated;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("telia-quick-search", {
            "telia-quick-search--animated": animated
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $818b1019a2737a09$export$2c73285ae9390cec), props));
};




var $fgmOP = parcelRequire("fgmOP");




var $fgmOP = parcelRequire("fgmOP");
var $5ff8066851a44240$exports = {};
$5ff8066851a44240$exports = "query countries{countries{...countryFragment}}fragment countryFragment on Country{id countryCode name}";



const $c21c461bc3365537$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useCountries", "INFO");
const $c21c461bc3365537$export$1984d0199e312f12 = ()=>{
    const { loading: loading, data: { countries: countries } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($5ff8066851a44240$exports)))), {
        fetchPolicy: "cache-first"
    });
    const sortedCountries = (0, $fgmOP.useMemo)(()=>countries?.slice().sort((0, $f5d0c2a7498ff49b$exports.sort).sortByNameComparator), [
        countries
    ]);
    const getCountry = (countryId)=>countries?.find(({ id: id })=>id === countryId);
    const getName = (id)=>getCountry(id)?.name || id;
    const useCountriesHook = {
        loading: loading,
        countries: sortedCountries,
        getCountry: getCountry,
        getName: getName
    };
    $c21c461bc3365537$var$log.debug(useCountriesHook);
    return useCountriesHook;
};




parcelRequire("fgmOP");



const $152b6193e99b7439$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useShowInactive", "INFO");
const $152b6193e99b7439$export$480d39f1cf55370f = "SHOW_INACTIVE";
const $152b6193e99b7439$export$84f600a904db3b68 = ()=>{
    const { getPreference: getPreference, setPreference: setPreference } = (0, $7059d4d5f1933e7a$export$bbd7d970555e2952)([
        $152b6193e99b7439$export$480d39f1cf55370f
    ]);
    const showInactive = getPreference($152b6193e99b7439$export$480d39f1cf55370f) || false;
    const showInactiveComponent = /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
        label: "Show inactive",
        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox,
        isEditing: true,
        value: showInactive,
        onChange: (value)=>{
            $152b6193e99b7439$var$log.debug("showInactiveComponent onChange", value);
            setPreference($152b6193e99b7439$export$480d39f1cf55370f, value);
        },
        tip: "Show entities in past or future periods"
    });
    const useShowInactiveHook = {
        showInactive: showInactive,
        showInactiveComponent: showInactiveComponent
    };
    $152b6193e99b7439$var$log.debug("render", useShowInactiveHook);
    return useShowInactiveHook;
};










const $b0a17a4c00f32741$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("PickCustomer", "INFO");
const $b0a17a4c00f32741$var$getState = (productOverviews)=>{
    return productOverviews?.some(({ state: state })=>state === "ACTIVE") ? "ACTIVE" : productOverviews?.some(({ state: state })=>state === "FUTURE") ? "FUTURE" : "EXPIRED";
};
const $b0a17a4c00f32741$export$85d3a2964d58e2ad = ({ selectedCustomerIds: selectedCustomerIds, onPickCustomer: onPickCustomer })=>{
    const { loading: loadingCustomerOverviews, allCountryCustomerOverviews: allCountryCustomerOverviews } = (0, $8d8d8b3d38044bbe$export$d27d8317adc3c298)();
    const { loading: loadingCountries, getName: getName } = (0, $c21c461bc3365537$export$1984d0199e312f12)();
    const { loading: loadingBrands, getName: getBrandName } = (0, $97a71fda4fbdc6d3$export$da3999a1d9248c0c)();
    const { showInactiveComponent: showInactiveComponent, showInactive: showInactive } = (0, $152b6193e99b7439$export$84f600a904db3b68)();
    const { hasBrandPermission: hasBrandPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const [filter, setFilter] = (0, $fgmOP.useState)("");
    const enrichedOverviews = (0, $fgmOP.useMemo)(()=>allCountryCustomerOverviews?.map(({ id: id, name: name, productOverviews: productOverviews, countryId: countryId, brandId: brandId })=>({
                customerId: id,
                isSelected: selectedCustomerIds.includes(id),
                customerName: name,
                state: $b0a17a4c00f32741$var$getState(productOverviews),
                countryName: getName(countryId),
                brandName: getBrandName(brandId),
                brandId: brandId
            })), [
        allCountryCustomerOverviews,
        selectedCustomerIds
    ]);
    const filteredEnrichedOverviews = (0, $fgmOP.useMemo)(()=>enrichedOverviews?.filter(({ customerName: customerName, state: state, brandId: brandId })=>hasBrandPermission((0, $ca0941499cca84bb$export$9687129cd10e92bc), brandId) && // Filter by permission
            customerName.toLowerCase().includes(filter) && // Filter by search string
            (showInactive || state === "ACTIVE" // Filter 'EXPIRED' and 'FUTURE', unless showInactive is checked
            )), [
        enrichedOverviews,
        filter,
        showInactive
    ]);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $b9b1f7b66cd50c54$export$bc81b1baaa8c945f), {
                placeholder: "Search customers",
                value: filter,
                onChange: ({ target: { value: value } })=>setFilter(value.toLowerCase()),
                error: filteredEnrichedOverviews?.length === 0,
                leftContent: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $2edc691f96482cbe$export$f04a61298a47a40f), {
                    icon: "search"
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "marginTop marginBottomHalfRem",
                children: showInactiveComponent
            }),
            loadingCustomerOverviews || loadingCountries || loadingBrands ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    filteredEnrichedOverviews?.length === 0 && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $dd22cd0dae287e6b$export$2e2bcd8739ae039), {
                        children: [
                            "No customers found with current filter ",
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                className: "teliaPurple",
                                children: filter
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $98cbb91c03e56cc2$export$2e2bcd8739ae039), {
                        children: filteredEnrichedOverviews?.map(({ customerId: customerId, isSelected: isSelected, customerName: customerName, state: state, brandName: brandName })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d8d7fa9fc21de820$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                    "list__item--selected": isSelected
                                }),
                                onClick: ()=>!isSelected && onPickCustomer(customerId),
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                    className: "displayFlex",
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox,
                                            value: isSelected
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                            className: "marginLeft paddingLeft flexGrow",
                                            children: customerName
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("marginLeft flexBasis10", state.toLowerCase() + "Period"),
                                            children: state
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                                            className: "paddingLeft flexGrow",
                                            children: [
                                                "Brand: ",
                                                brandName
                                            ]
                                        })
                                    ]
                                })
                            }))
                    })
                ]
            })
        ]
    });
};



const $d900639f38b72159$export$df616dc05b3783cb = ({ formState: formState, ...props })=>{
    const { customerId: customerId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const { addCustomerRole: addCustomerRole, removeCustomerRole: removeCustomerRole, getCustomerRoles: getCustomerRoles, getCustomerIds: getCustomerIds } = (0, $d9122fadf72c2a2d$export$7852d8680b86d89b)();
    const { hasPermission: hasPermission, hasCustomerPermission: hasCustomerPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { getCustomerOverview: getCustomerOverview } = (0, $8d8d8b3d38044bbe$export$d27d8317adc3c298)();
    const { showModal: showModal, hideModal: hideModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const { rolesMap: rolesMap } = formState.entityAs();
    const [addedCustomerIds, setAddedCustomerIds] = (0, $fgmOP.useState)([]);
    (0, $fgmOP.useEffect)(()=>{
        // Once we stop editing, reset added customers list
        !formState.isEditing && setAddedCustomerIds([]);
    }, [
        formState.isEditing
    ]);
    // Overly complex sorting logic. We want to sort the customer we are currently viewing first,
    // then the rest alphabetically, then the ones that are newly added in this edit last.
    const customerComparator = (0, $fgmOP.useCallback)((a, b)=>{
        // customerId is the customer we are currently viewing and should be sorted first
        if (a.id.equalsIgnoreCase(customerId)) return -1; // a is the customer we are currently viewing, sort it before b
        if (b.id.equalsIgnoreCase(customerId)) return 1; // b is the customer we are currently viewing, sort it before a
        // a or b has been added in this edit, keep original order (at the end)
        if ([
            a.id,
            b.id
        ].some((id)=>addedCustomerIds.includes(id))) return 0;
        // Sort alphabetically
        return a.name.localeCompare(b.name);
    }, [
        customerId,
        addedCustomerIds
    ]);
    const customerOptions = (0, $fgmOP.useMemo)(()=>(rolesMap || []).filter(({ resource: resource })=>resource.startsWith((0, $2MPlc.RESOURCE_CUSTOMER_PREFIX))).map(({ resource: resource })=>{
            const id = (0, $2MPlc.getCustomerId)(resource) || "";
            const { name: name = customerId, countryId: countryId } = getCustomerOverview(id) || {};
            return {
                id: id,
                name: `${name} (${countryId})`
            };
        }).sort(customerComparator), [
        rolesMap,
        getCustomerOverview,
        customerComparator
    ]);
    const addCustomer = ()=>{
        const addCustomerModalId = showModal({
            title: "Pick a customer to add:",
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $b0a17a4c00f32741$export$85d3a2964d58e2ad), {
                selectedCustomerIds: getCustomerIds(formState.subEntityAt("rolesMap")),
                onPickCustomer: (customerId)=>{
                    formState.onChange("rolesMap")([
                        ...formState.subEntityAt("rolesMap") || [],
                        {
                            resource: (0, $2MPlc.RESOURCE_CUSTOMER_PREFIX) + customerId,
                            roles: []
                        }
                    ]);
                    setAddedCustomerIds([
                        ...addedCustomerIds,
                        customerId
                    ]);
                    hideModal(addCustomerModalId);
                }
            })
        });
    };
    const onDeleteCustomerRoles = (customerId)=>{
        formState.onChange("rolesMap")((formState.subEntityAt("rolesMap") || []).filter(({ resource: resource })=>resource && !resource.endsWith(customerId)));
    };
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $321246bff7fd88aa$export$beed2416f08339a2), {
                ...props,
                resourceOptions: customerOptions,
                formState: formState,
                showHeadings: customerOptions.length > 1,
                showDeleteButton: customerOptions.length > 1,
                addResourceRole: addCustomerRole,
                removeResourceRole: removeCustomerRole,
                getResourceRoles: (customerId, rolesMap)=>getCustomerRoles(customerId, rolesMap),
                hasResourceEditPermission: (customerId)=>hasCustomerPermission((0, $ca0941499cca84bb$export$9687129cd10e92bc), customerId),
                onRemoveResource: (customerId)=>onDeleteCustomerRoles(customerId)
            }),
            formState.isEditing && hasPermission((0, $ca0941499cca84bb$export$d9a19ca7f33b36c1)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                text: "Additional customer user",
                onClick: addCustomer
            })
        ]
    });
};


const $93c577777b23c9fd$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("User", "INFO");
const $93c577777b23c9fd$var$customerQueryGql = (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($dad67faa2a055d78$exports))));
const $93c577777b23c9fd$var$teliaUsersQueryGql = (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($bec02a301bb122cd$exports))));
const $93c577777b23c9fd$export$855561da725d001b = (props)=>{
    const { type: type, goBackUrl: goBackUrl } = props;
    const { customerId: customerId, userId: userId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const { hasPermission: hasPermission, hasCustomerPermission: hasCustomerPermission, hasBrandPermission: hasBrandPermission, user: user, isTelia: isTelia } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { showModal: showModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const { brands: brands } = (0, $97a71fda4fbdc6d3$export$da3999a1d9248c0c)();
    const { getName: getName } = (0, $8d8d8b3d38044bbe$export$d27d8317adc3c298)();
    const brandOptions = (0, $fgmOP.useMemo)(()=>[
            {
                id: "*",
                name: "All Brands"
            },
            ...brands || []
        ], [
        brands
    ]);
    const { getBrandRoles: getBrandRoles } = (0, $d9122fadf72c2a2d$export$7852d8680b86d89b)();
    const useApolloCacheEntityProps = {
        fragment: (0, (/*@__PURE__*/$parcel$interopDefault($e518621b97fca5b8$exports))),
        entityId: userId,
        newEntity: {
            customerId: customerId,
            firstName: null,
            lastName: null,
            email: null,
            phone: null,
            rolesMap: customerId ? [
                {
                    resource: (0, $2MPlc.RESOURCE_CUSTOMER_PREFIX) + customerId,
                    roles: []
                }
            ] : [],
            comment: null
        }
    };
    const formStateOptions = (0, $cd0b9ee27a364316$export$4c2508f4134d3a42)(useApolloCacheEntityProps);
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)({
        ...formStateOptions,
        validators: {
            phone: {
                regex: /^\+\d{5,20}$/,
                error: "Phone number must start with (+) international code and followed by 5 to 20 digits (without spaces)"
            }
        }
    });
    const saveUser = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($d2756dbba47edf22$exports)))), {
        refetchQueries: user?.id === userId ? [
            "user"
        ] : []
    } // If logged in user is modifying their own user, force update of user query to get updated data
    );
    const onSave = ()=>{
        const saveUser = formState.entityAs();
        const currAdminRoles = user?.rolesMap && brandOptions?.reduce((prev, { id: id })=>getBrandRoles(id, user.rolesMap, true).includes("TELIA_ADMIN") ? [
                ...prev,
                id
            ] : prev, []);
        const newAdminRoles = brandOptions?.reduce((prev, { id: id })=>getBrandRoles(id, saveUser.rolesMap, true).includes("TELIA_ADMIN") ? [
                ...prev,
                id
            ] : prev, []);
        const deletingAdminRole = currAdminRoles && newAdminRoles && currAdminRoles.some((b)=>!newAdminRoles.includes(b));
        const hasAllBrandAdminRole = newAdminRoles?.includes("*");
        const initialUser = formState.initialEntity;
        // Get all resources that has been newly added to rolesMap, i.e. not present in initial rolesMap
        const addedCustomerIds = (0, $2MPlc.getUpdatedRolesMapResources)(initialUser.rolesMap, saveUser.rolesMap).filter((updatedResource)=>updatedResource.startsWith((0, $2MPlc.RESOURCE_CUSTOMER_PREFIX)) && // Only customer resources
            !initialUser.rolesMap?.find(({ resource: resource })=>resource === updatedResource) // Not present in initial rolesMap (before editing was started)
        );
        if (addedCustomerIds.length > 0) showModal({
            title: "Add additional customer user?",
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                        children: "You are about to give this user access to the following customer(s):"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $98cbb91c03e56cc2$export$2e2bcd8739ae039), {
                        children: addedCustomerIds.map((resource)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d8d7fa9fc21de820$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                    children: getName((0, $2MPlc.getCustomerId)(resource) || resource)
                                })
                            }, resource))
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                        children: "Orders of additional access must be sent from the e-mail address of a user with administrator access to the customer(s). The order e-mail must be uploaded to the documents section of the customer(s) before giving the additional user access to the customer in this web portal."
                    })
                ]
            }),
            typeToConfirmText: "confirm",
            confirmText: "Update",
            confirmType: "primary",
            onConfirm: onConfirmSave
        });
        else if (saveUser.id === user?.id && deletingAdminRole && !hasAllBrandAdminRole) showModal({
            title: "Delete your own administrator role?",
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                children: "You are about to delete your own administrator role, are you sure you want to continue? You will not be able to edit your roles for this brand after this."
            }),
            confirmType: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary,
            confirmText: "Confirm",
            cancelText: "Cancel",
            onConfirm: onConfirmSave
        });
        else onConfirmSave();
    };
    const onConfirmSave = ()=>{
        const user = (0, $6afa790c69fae185$export$f5cac05ac3bf56d8)(formState.entityAs());
        if (!formState.validate()) return;
        if (formState.subEntityAt("rolesMap").some(({ roles: roles })=>roles.isEmpty())) {
            (0, $4983ed7d9d06375d$export$b410431fab84fa58).error("At least one role must be selected for each resource");
            return;
        }
        $93c577777b23c9fd$var$log.debug("onSave", {
            user: user,
            customerId: customerId,
            type: type
        });
        saveUser({
            loadingText: "Saving user...",
            successText: "User saved",
            variables: {
                user: {
                    ...user,
                    type: user.type ? user.type : props.type
                },
                customerId: customerId,
                pageType: type
            },
            update: (proxy, { data: data })=>{
                const { saveUser: saveUser } = data || {};
                $93c577777b23c9fd$var$log.debug("saveUserMutation update", saveUser);
                if (saveUser && !formState.entity.id) {
                    //  create new user
                    if (type === "CUSTOMER") {
                        //  TODO: move the update list of users to parent component?
                        const data = proxy.readQuery({
                            query: $93c577777b23c9fd$var$customerQueryGql,
                            variables: {
                                customerId: customerId
                            }
                        });
                        const updatedUsers = [
                            ...data?.customer?.users || [],
                            saveUser
                        ];
                        $93c577777b23c9fd$var$log.debug("data", updatedUsers);
                        proxy.writeQuery({
                            query: $93c577777b23c9fd$var$customerQueryGql,
                            data: {
                                customer: {
                                    users: updatedUsers
                                }
                            }
                        });
                        navigate(formatWithBrand($e9a95c61c800ecd2$export$cf0ddd3620037cd5, customerId, saveUser.id), {
                            replace: true
                        });
                    } else if (type === "TELIA") {
                        const data = proxy.readQuery({
                            query: $93c577777b23c9fd$var$teliaUsersQueryGql,
                            variables: {}
                        });
                        // data?.teliaUsers.push(saveUser);
                        const updatedUsers = [
                            ...data?.teliaUsers || [],
                            saveUser
                        ];
                        proxy.writeQuery({
                            query: $93c577777b23c9fd$var$teliaUsersQueryGql,
                            data: {
                                teliaUsers: updatedUsers
                            }
                        });
                        navigate(formatWithBrand($e9a95c61c800ecd2$export$eaa88fbc12af3f84, saveUser.id), {
                            replace: true
                        });
                    } else $93c577777b23c9fd$var$log.error("unrecognized user type", type);
                }
            }
        }).then(({ data: data })=>{
            const { saveUser: saveUser } = data || {
                saveUser: undefined
            };
            $93c577777b23c9fd$var$log.debug("saveUserMutate resolved", saveUser);
            saveUser && formState.onSaved((0, $f6ff28847e6675c5$export$232f37f9a0fc548e)(saveUser));
            return saveUser;
        });
    };
    const onDelete = ()=>{
        $93c577777b23c9fd$var$log.debug("onDelete");
        const user = formState.entity;
        showModal({
            title: "Delete user",
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                children: `Are you sure you want to delete user '${user.firstName} ${user.lastName}' ?`
            }),
            confirmType: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.negative,
            confirmText: "Delete",
            onConfirm: onConfirmDelete
        });
    };
    const deleteUser = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($1c96f5f8c4cbad74$exports)))));
    const onConfirmDelete = ()=>{
        $93c577777b23c9fd$var$log.debug("onConfirmDelete", {
            userId: userId
        });
        deleteUser({
            loadingText: "Deleting user...",
            successText: "User deleted",
            variables: {
                userId: userId,
                customerId: customerId,
                pageType: type
            },
            update: (proxy, { data: data })=>{
                const { deleteUser: userId } = data || {};
                $93c577777b23c9fd$var$log.debug("deleteUserMutation update", userId);
                if (type === (0, $l8GLF.UserType).CUSTOMER) {
                    //  TODO: move the update list of users to parent component?
                    const data = proxy.readQuery({
                        query: $93c577777b23c9fd$var$customerQueryGql,
                        variables: {
                            customerId: customerId
                        }
                    });
                    if (data) {
                        const users = data.customer?.users?.filter((user)=>user.id !== userId);
                        proxy.writeQuery({
                            query: $93c577777b23c9fd$var$customerQueryGql,
                            data: {
                                customer: {
                                    ...data.customer,
                                    users: users
                                }
                            },
                            overwrite: true
                        });
                    }
                } else if (type === (0, $l8GLF.UserType).TELIA) {
                    const data = proxy.readQuery({
                        query: $93c577777b23c9fd$var$teliaUsersQueryGql,
                        variables: {}
                    });
                    $93c577777b23c9fd$var$log.debug("data", data);
                    if (data) {
                        const teliaUsers = data.teliaUsers.filter((user)=>user.id !== userId);
                        proxy.writeQuery({
                            query: $93c577777b23c9fd$var$teliaUsersQueryGql,
                            variables: {},
                            data: {
                                teliaUsers: teliaUsers
                            },
                            overwrite: true
                        });
                    }
                } else $93c577777b23c9fd$var$log.error("unrecognized user type", type);
            }
        }).then(({ data: data })=>{
            const { deleteUser: deleteUser } = data || {
                deleteUser: undefined
            };
            $93c577777b23c9fd$var$log.debug("deleteUser resolved", deleteUser);
            navigate(goBackUrl);
        });
    };
    $93c577777b23c9fd$var$log.debug("props", props);
    const { isEditing: isEditing, entity: entity, onEdit: onEdit, onCancel: onCancel } = formState;
    const isCreating = entity && !entity.id;
    const roleOptions = props.roles || [];
    const isAllowedToManageAll = formState.subEntityAt("rolesMap")?.every(({ resource: resource })=>{
        if (type === (0, $l8GLF.UserType).CUSTOMER) {
            const customerId = (0, $2MPlc.getCustomerId)(resource);
            return !!(customerId && hasCustomerPermission((0, $ca0941499cca84bb$export$9687129cd10e92bc), customerId));
        }
        const brandId = (0, $2MPlc.getBrandId)(resource);
        return !!(brandId && hasBrandPermission((0, $ca0941499cca84bb$export$9687129cd10e92bc), brandId));
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "User Info"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "user"
            }),
            !entity ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $2e4c8094e1930e9a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "firstName",
                                    label: "Firstname",
                                    className: "form__field"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "lastName",
                                    label: "Lastname",
                                    className: "form__field"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "email",
                                    label: "Email",
                                    isEditing: isEditing && isCreating,
                                    className: "form__field"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {}),
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $8e2421cb37be9d76$export$7eda936955feae4d), {
                                    formState: formState,
                                    className: "form__field"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {}),
                                " "
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            size: (0, $6c2490027a2e159e$export$44c04526d4b77f07),
                            children: type === (0, $l8GLF.UserType).CUSTOMER ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d900639f38b72159$export$df616dc05b3783cb), {
                                formState: formState,
                                roles: roleOptions
                            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $90a05629a2e1babc$export$c7e5978effe5f852), {
                                formState: formState,
                                roles: roleOptions
                            })
                        })
                    }),
                    !isEditing ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        children: [
                            (type === (0, $l8GLF.UserType).TELIA ? hasPermission((0, $ca0941499cca84bb$export$619b28da925d56b7)) : isTelia() ? hasPermission((0, $ca0941499cca84bb$export$9687129cd10e92bc)) : hasCustomerPermission((0, $ca0941499cca84bb$export$9687129cd10e92bc), customerId)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                        text: "Edit",
                                        onClick: onEdit
                                    }),
                                    isAllowedToManageAll && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                        text: "Delete",
                                        onClick: onDelete,
                                        kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.negative
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                                to: goBackUrl,
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    text: "Back to Users",
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                text: "Save",
                                onClick: onSave,
                                kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                text: "Cancel",
                                onClick: onCancel,
                                kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel
                            })
                        ]
                    })
                ]
            })
        ]
    });
};





var $fgmOP = parcelRequire("fgmOP");














var $ff9mn = parcelRequire("ff9mn");


var $fgmOP = parcelRequire("fgmOP");











const $c25b1426f30dd551$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("UserList");
const $c25b1426f30dd551$export$f61ed0586120f3c = (props)=>{
    const routeParams = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const customerId = routeParams.customerId || props.customerId;
    $c25b1426f30dd551$var$log.debug("props", props);
    const { users: users, onSelectUser: onSelectUser, usersBaseUrl: usersBaseUrl } = props;
    const { loading: loading, getRole: getRole } = (0, $3b1b6b64a4bd4f9b$export$a884b22cb22f8e99)();
    const { currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { getBrandRoles: getBrandRoles, getCustomerRoles: getCustomerRoles } = (0, $d9122fadf72c2a2d$export$7852d8680b86d89b)();
    const sortedUsers = (0, $fgmOP.useMemo)(()=>users.slice().sort((0, $ff9mn.userComparator)), [
        users
    ]);
    return loading ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : sortedUsers && !sortedUsers.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $98cbb91c03e56cc2$export$2e2bcd8739ae039), {
        id: "usersList",
        children: sortedUsers.map((user)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $d8d7fa9fc21de820$export$2e2bcd8739ae039), {
                id: (0, $0857d9353dc337e9$export$d5d25c90fc92fce5)(user.id, "user"),
                link: usersBaseUrl && $e9a95c61c800ecd2$export$f7e2c8231c57a8bd(usersBaseUrl, user.id),
                onClick: onSelectUser && (()=>onSelectUser(user)),
                children: [
                    user.firstName || user.lastName ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        className: "bold",
                        children: [
                            user.firstName,
                            " ",
                            user.lastName
                        ]
                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        className: "bold missing",
                        children: "no name"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                className: "labelPrefix",
                                children: "Email "
                            }),
                            " ",
                            user.email
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                className: "labelPrefix",
                                children: "Roles "
                            }),
                            " ",
                            (user.type === (0, $172ff61ce62d7cbc$export$8436e53e45ffe15b).TELIA ? getBrandRoles(currentUserBrand?.id, user.rolesMap) : getCustomerRoles(customerId || "", user.rolesMap)).map((roleId)=>getRole(roleId)?.name || roleId).join(", ")
                        ]
                    })
                ]
            }, user.id))
    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
        children: "No users found"
    });
};


const $839ba3e12383cc14$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Users", "INFO");
const $839ba3e12383cc14$export$1644816dbb0b080d = (props)=>{
    const { customerId: customerId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const { users: users = [], usersBaseUrl: usersBaseUrl } = props;
    const { hasPermission: hasPermission, hasCustomerPermission: hasCustomerPermission, isTelia: isTelia } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)({
        isEditing: true,
        preferenceFieldNames: [
            "showWithoutRoles"
        ]
    });
    const filteredUsers = (0, $fgmOP.useMemo)(()=>users.filter((user)=>formState.entity.showWithoutRoles || !user.rolesMap?.isEmpty()), [
        formState.entity
    ]);
    $839ba3e12383cc14$var$log.debug("Users", props);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Users"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "users"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                children: "List of people who may access this Telia Bulk Messaging Web application. Users may have different roles which grants them different permissions."
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: "showWithoutRoles",
                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox,
                        label: "Include users without roles"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c25b1426f30dd551$export$f61ed0586120f3c), {
                users: filteredUsers,
                usersBaseUrl: usersBaseUrl
            }),
            (!(0, $8776d7b69d623a41$export$81336c211d5ff295)($e9a95c61c800ecd2$export$9bd348b6232639d7, usersBaseUrl) && isTelia() ? hasPermission((0, $ca0941499cca84bb$export$9687129cd10e92bc)) : hasCustomerPermission((0, $ca0941499cca84bb$export$9687129cd10e92bc), customerId)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        id: (0, $0857d9353dc337e9$export$d5d25c90fc92fce5)("createUser"),
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                            to: $e9a95c61c800ecd2$export$f7e2c8231c57a8bd(usersBaseUrl, $e9a95c61c800ecd2$export$15f47a32373730e5),
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                text: "Create user"
                            })
                        })
                    })
                })
            })
        ]
    });
};





var $fgmOP = parcelRequire("fgmOP");







parcelRequire("fgmOP");





const $6d5c205a2e0d9b54$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("OverviewBoxFc", "INFO");
const $6d5c205a2e0d9b54$export$5eec21ae6681837e = (props)=>{
    $6d5c205a2e0d9b54$var$log.debug("render", {
        props: props
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
        id: (0, $0857d9353dc337e9$export$d5d25c90fc92fce5)(props.title, "overviewBox"),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("overview-box feature-box", "feature-box--medium", {
            "overview-box--warning": props.warning
        }, props.className, {
            "feature-box--border": true
        }),
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
            to: props.link,
            className: "overview-box__link",
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                    className: "feature-box__icon overview-box__icon",
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                        icon: props.icon
                    })
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h3", {
                    className: "feature-box__heading heading heading--level-3",
                    children: props.title
                }),
                props.subTitle && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                    className: "overview-box__subTitle",
                    children: props.subTitle
                })
            ]
        })
    });
};




var $fgmOP = parcelRequire("fgmOP");
/**
 * Status: *finished*.
 * Category: Boxes
 *
 * There should be a minimum of three- and a maximum of eight boxes when using this component.
 **/ var $c117377efee68418$var$FeatureBoxes = function FeatureBoxes(_ref) {
    var children = _ref.children, hasBorder = _ref.hasBorder, size = _ref.size;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "feature-boxes"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Children.map(children, function(child) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).cloneElement(child, {
            hasBorder: hasBorder,
            size: size
        });
    }));
};
var $c117377efee68418$export$2e2bcd8739ae039 = $c117377efee68418$var$FeatureBoxes;


parcelRequire("fgmOP");

const $e7ded3c00eb49c59$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("OverviewBoxGridFc", "INFO");
const $e7ded3c00eb49c59$export$237d44eeb6e90e79 = (props)=>{
    const children = Array.isArray(props.children) ? props.children.filter((c)=>!!c) : props.children;
    $e7ded3c00eb49c59$var$log.debug("render", {
        props: props
    }, {
        children: children
    });
    //  @ts-ignore
    return children ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c117377efee68418$export$2e2bcd8739ae039), {
        children: children
    }) : null;
};




const $a80156612c540a62$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ManagementOverview", "INFO");
const $a80156612c540a62$export$a4c417c18d929f4e = ({ users: users, pendingUsers: pendingUsers })=>{
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const { isServiceCategoriesVisible: isServiceCategoriesVisible } = (0, $5cd44d723b4013a5$export$97aa5844287be9bb)();
    const { user: user, hasBrandPermission: hasBrandPermission, hasPermission: hasPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const isTeliaAdmin = (0, $fgmOP.useMemo)(()=>hasBrandPermission((0, $ca0941499cca84bb$export$619b28da925d56b7), "*"), [
        user
    ]);
    const totalUsers = users ? users.length : 0;
    const totalPendingUsers = pendingUsers ? pendingUsers.length : 0;
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("Overview"),
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Overview "
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "overview"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $e7ded3c00eb49c59$export$237d44eeb6e90e79), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "chat",
                        title: `Communication`,
                        link: formatWithBrand($e9a95c61c800ecd2$export$569ed52e5b30464)
                    }),
                    isTeliaAdmin && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "replace",
                        title: `Message Channels`,
                        link: formatWithBrand($e9a95c61c800ecd2$export$949c5bd8f8d67240)
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "police",
                        title: `Permissions & Roles`,
                        link: formatWithBrand($e9a95c61c800ecd2$export$64c513f4bd4de646)
                    }),
                    isServiceCategoriesVisible && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "tags",
                        title: `Service Categories`,
                        link: formatWithBrand($e9a95c61c800ecd2$export$eb03b2a2e7303d43)
                    }),
                    isTeliaAdmin && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "server",
                        title: `SMSCs`,
                        link: formatWithBrand($e9a95c61c800ecd2$export$524b16a9ead1cc8f)
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "group",
                        title: `${totalUsers} User${totalUsers === 1 ? "" : "s"}`,
                        warning: totalUsers === 0,
                        link: formatWithBrand($e9a95c61c800ecd2$export$9bd348b6232639d7)
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "user-new",
                        title: `${totalPendingUsers} Pending User${totalPendingUsers === 1 ? "" : "s"}`,
                        warning: !!totalPendingUsers,
                        link: formatWithBrand($e9a95c61c800ecd2$export$84e81f0486c8c4ce)
                    }),
                    hasPermission((0, $ca0941499cca84bb$export$c7086708a0f042bc)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "signal",
                        title: "Smpp Connections",
                        link: formatWithBrand($e9a95c61c800ecd2$export$b9e9de52d0e57205)
                    })
                ]
            })
        ]
    });
};






var $fgmOP = parcelRequire("fgmOP");
var $36752eef17d2fd6d$exports = {};
$36752eef17d2fd6d$exports = "query channels{channels{...channelFragment}}fragment channelFragment on Channel{id name description}";


var $c6cacb5ffab3de60$exports = {};
$c6cacb5ffab3de60$exports = "query findContacts($channels:[ID]$roles:[ID]$productTypes:[ID]$showInactive:Boolean){findContacts(channels:$channels roles:$roles productTypes:$productTypes showInactive:$showInactive)}";







var $6N8I1 = parcelRequire("6N8I1");
var $f09dd4bd70da0752$exports = {};
$f09dd4bd70da0752$exports = "query productTypes{productTypes{...productTypeFragment}}fragment productTypeFragment on ProductType{id countryId brandId name description establishFee monthlyFee canSend feeModels{...feeModelFragment}smppApiConfigDefaults{...smppApiConfigFragment}features{id name description}}fragment feeModelFragment on FeeModel{description startDate endDate fees{description feeTypeId fixedAmount steps{from to amount}}}fragment smppApiConfigFragment on SmppApiConfig{defaultCharset windowSize maxWindowSize maxSessions minReceiverSessionAlarmThreshold minTransmitterSessionAlarmThreshold}";




var $l8GLF = parcelRequire("l8GLF");


const { FEE_TYPE_ESTABLISHMENT: $eedf1befe0d24b54$var$FEE_TYPE_ESTABLISHMENT, FEE_TYPE_MONTHLY: $eedf1befe0d24b54$var$FEE_TYPE_MONTHLY } = (0, $f5d0c2a7498ff49b$exports.constants);
const $eedf1befe0d24b54$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useFees", "INFO");
const $eedf1befe0d24b54$export$52d95f0c8d681dd7 = ()=>{
    const getFee = ({ feeModels: feeModels }, feeTypeId)=>{
        return feeModels.map(({ fees: fees })=>fees).flat().find((fee)=>fee.feeTypeId === feeTypeId);
    };
    const getEstablishFee = (productType, customFeeId)=>{
        const establishFee = getFee(productType, (customFeeId ? `${customFeeId}_` : "") + $eedf1befe0d24b54$var$FEE_TYPE_ESTABLISHMENT);
        $eedf1befe0d24b54$var$log.debug("getEstablishFee", {
            establishFee: establishFee
        });
        return establishFee?.fixedAmount;
    };
    const getMonthlyFee = (productType, customFeeId)=>{
        const monthlyFee = getFee(productType, (customFeeId ? `${customFeeId}_` : "") + $eedf1befe0d24b54$var$FEE_TYPE_MONTHLY);
        $eedf1befe0d24b54$var$log.debug("getMonthlyFee", {
            monthlyFee: monthlyFee
        });
        return monthlyFee?.fixedAmount;
    };
    const useFeeModels = {
        getFee: getFee,
        getEstablishFee: getEstablishFee,
        getMonthlyFee: getMonthlyFee
    };
    return useFeeModels;
};


const $98effcf86fafb9fb$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useProductTypes", "INFO");
const $98effcf86fafb9fb$var$DEFAULT_QOS_MESSAGE_PRIORITY = 2;
const $98effcf86fafb9fb$var$DEFAULT_QOS_MAX_SMS_PER_SECOND = 80;
const $98effcf86fafb9fb$export$75025970e7082eca = ()=>{
    const { getEstablishFee: _getEstablishFee, getMonthlyFee: _getMonthlyFee } = (0, $eedf1befe0d24b54$export$52d95f0c8d681dd7)();
    const { loading: loading, data: { productTypes: productTypes = [] } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($f09dd4bd70da0752$exports)))));
    const _getProductType = (id)=>{
        const productType = productTypes.find((pt)=>pt.id === id);
        $98effcf86fafb9fb$var$log.debug("productType", id, productType);
        return productType;
    };
    const getBrandProductTypes = (brandId)=>productTypes?.filter((productType)=>productType.brandId === brandId);
    const getEstablishFee = (id, customFeeId)=>{
        const productType = _getProductType(id);
        const establishFee = (0, $l8GLF.hasFeeModels)(productType) ? _getEstablishFee(productType, customFeeId) : undefined;
        $98effcf86fafb9fb$var$log.debug("getEstablishFee", id, productType, establishFee);
        return establishFee;
    };
    const getMonthlyFee = (id, customFeeId)=>{
        const productType = _getProductType(id);
        const monthlyFee = (0, $l8GLF.hasFeeModels)(productType) ? _getMonthlyFee(productType, customFeeId) : undefined;
        $98effcf86fafb9fb$var$log.debug("getMonthlyFee", id, productType, monthlyFee);
        return monthlyFee;
    };
    const getFees = (id)=>{
        const productType = _getProductType(id);
        const fees = productType?.feeModels?.filter((feeModel)=>(0, $f5d0c2a7498ff49b$exports.period).isActive(feeModel)).flatMap(({ fees: fees })=>fees);
        return fees || [];
    };
    const getName = (id)=>{
        const productType = _getProductType(id);
        const name = productType?.name || id;
        $98effcf86fafb9fb$var$log.debug("getName", id, productType, name);
        return name;
    };
    const getDescription = (id)=>{
        const productType = _getProductType(id);
        const description = productType?.description || id;
        $98effcf86fafb9fb$var$log.debug("getDescription", id, productType, description);
        return description;
    };
    const getAccessNumberDisplayName = (id)=>{
        const displayName = id.startsWith((0, $6N8I1.PRODUCT_TYPE_MO_LONG_NUMBER)) || id.startsWith((0, $6N8I1.PRODUCT_TYPE_MO_CUSTOMER_NUMBER)) ? "Long Number" : "Short Number";
        $98effcf86fafb9fb$var$log.debug("getAccessNumberDisplayName", id, displayName);
        return displayName;
    };
    const getDefaultQoSMessagePriority = (id)=>{
        $98effcf86fafb9fb$var$log.debug("getQoSMessagePriority", id);
        return $98effcf86fafb9fb$var$DEFAULT_QOS_MESSAGE_PRIORITY; // TODO: Move to productType?
    };
    const getDefaultQoSMaxSmsPerSecond = (id)=>{
        $98effcf86fafb9fb$var$log.debug("getQoSMaxSmsPerSecond", id);
        return $98effcf86fafb9fb$var$DEFAULT_QOS_MAX_SMS_PER_SECOND; // TODO: Move to productType?
    };
    const getProductTypeFeatures = (id)=>{
        const productType = _getProductType(id);
        const features = productType?.features || [];
        $98effcf86fafb9fb$var$log.debug("getProductTypeFeatures", features);
        return features;
    };
    const getProductTypeFeature = (id, featureTypeId)=>{
        const productType = _getProductType(id);
        const feature = productType?.features?.find((feature)=>feature.id === featureTypeId);
        $98effcf86fafb9fb$var$log.debug("getProductFeature", id, featureTypeId, productType, feature);
        return feature;
    };
    const isDirectChargeRange = (id)=>{
        return id.includes("DIRECT_CHARGE_RANGE");
    };
    //  Product Capabilities
    const canSend = (id)=>{
        const productType = _getProductType(id);
        const canSend = productType?.canSend || false;
        $98effcf86fafb9fb$var$log.debug("getDescription", id, productType, canSend);
        return canSend;
    };
    const canReserveOa = (id)=>!!id.match("RESERVED_OA.*");
    const usesAccessNumberRange = (id)=>{
        const usesAccessNumberRange = id.includes("_RANGE");
        $98effcf86fafb9fb$var$log.debug("usesAccessNumberRange", id, usesAccessNumberRange);
        return usesAccessNumberRange;
    };
    const usesAccessNumber = (id)=>{
        const usesAccessNumber = id.startsWith((0, $6N8I1.PRODUCT_TYPE_SMS_BULK)) || id.startsWith((0, $6N8I1.PRODUCT_TYPE_MO_LONG_NUMBER)) && !id.includes("_RANGE") || id.startsWith((0, $6N8I1.PRODUCT_TYPE_EVENT));
        $98effcf86fafb9fb$var$log.debug("usesAccessNumber", id, usesAccessNumber);
        return usesAccessNumber;
    };
    const usesPrefixNumber = (id)=>{
        const usesPrefixNumber = id.startsWith((0, $6N8I1.PRODUCT_TYPE_MO_CUSTOMER_NUMBER));
        $98effcf86fafb9fb$var$log.debug("usesPrefixNumber", id, usesPrefixNumber);
        return usesPrefixNumber;
    };
    const usesRbmAgentOwner = (id)=>{
        return id.startsWith("RBM");
    };
    const usesProductName = (id)=>{
        return canReserveOa(id);
    };
    const usesFeatures = (id)=>{
        return id?.startsWith((0, $6N8I1.PRODUCT_TYPE_MO_SERVICE));
    };
    const hasProductTechnicalApiCredentials = (id)=>{
        return canSend(id);
    };
    const hasProductTechnicalDr = (id)=>{
        return canSend(id);
    };
    const hasProductTechnicalMo = (id)=>{
        const hasProductTechnicalMo = id.startsWith((0, $6N8I1.PRODUCT_TYPE_SMS_BULK)) || id.startsWith((0, $6N8I1.PRODUCT_TYPE_MO_LONG_NUMBER)) || id.startsWith((0, $6N8I1.PRODUCT_TYPE_MO_DIRECT_CHARGE_RANGE)) || id.startsWith((0, $6N8I1.PRODUCT_TYPE_MO_CUSTOMER_NUMBER)) || id.startsWith((0, $6N8I1.PRODUCT_TYPE_MO_SERVICE));
        $98effcf86fafb9fb$var$log.debug("hasProductTechnicalMo", id, hasProductTechnicalMo);
        return hasProductTechnicalMo;
    };
    const hasProductTechnical = (id)=>{
        return hasProductTechnicalApiCredentials(id) || hasProductTechnicalDr(id) || hasProductTechnicalMo(id);
    };
    const brandHasCanSendProductType = (brandId)=>{
        return !!getBrandProductTypes(brandId).filter(({ id: id })=>canSend(id)).length;
    };
    const getProductTypeSmppApiDefaultConfig = (id)=>{
        return _getProductType(id)?.smppApiConfigDefaults;
    };
    const useProductTypes = {
        loading: loading,
        productTypes: productTypes,
        getBrandProductTypes: getBrandProductTypes,
        getEstablishFee: getEstablishFee,
        getMonthlyFee: getMonthlyFee,
        getFees: getFees,
        getName: getName,
        getDescription: getDescription,
        getAccessNumberDisplayName: getAccessNumberDisplayName,
        getDefaultQoSMessagePriority: getDefaultQoSMessagePriority,
        getDefaultQoSMaxSmsPerSecond: getDefaultQoSMaxSmsPerSecond,
        getProductTypeFeatures: getProductTypeFeatures,
        getProductTypeFeature: getProductTypeFeature,
        isDirectChargeRange: isDirectChargeRange,
        canSend: canSend,
        usesAccessNumberRange: usesAccessNumberRange,
        usesAccessNumber: usesAccessNumber,
        usesPrefixNumber: usesPrefixNumber,
        usesProductName: usesProductName,
        usesFeatures: usesFeatures,
        hasProductTechnical: hasProductTechnical,
        hasProductTechnicalApiCredentials: hasProductTechnicalApiCredentials,
        hasProductTechnicalDr: hasProductTechnicalDr,
        hasProductTechnicalMo: hasProductTechnicalMo,
        usesRbmAgentOwner: usesRbmAgentOwner,
        canReserveOa: canReserveOa,
        brandHasCanSendProductType: brandHasCanSendProductType,
        getProductTypeSmppApiDefaultConfig: getProductTypeSmppApiDefaultConfig
    };
    $98effcf86fafb9fb$var$log.debug("render", useProductTypes);
    return useProductTypes;
};















const $604f1014b77d3c4c$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Notifications", "INFO");
const $604f1014b77d3c4c$export$e8de2912389971df = (props)=>{
    const formStateOptions = {
        isEditing: true,
        useUrlParams: true
    };
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)(formStateOptions);
    const { loading: loadingChannels, data: { channels: channelOptions } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($36752eef17d2fd6d$exports)))));
    (0, $c3440150448da8b8$export$1c72fe480f599e97)([
        {
            query: "channels",
            isLoading: loadingChannels
        }
    ]);
    const { customerRoles: roleOptions, loading: loadingRoles } = (0, $3b1b6b64a4bd4f9b$export$a884b22cb22f8e99)();
    const { getBrandProductTypes: getBrandProductTypes, loading: loadingProductTypes } = (0, $98effcf86fafb9fb$export$75025970e7082eca)();
    const { currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const productTypesOptions = (0, $fgmOP.useMemo)(()=>currentUserBrand && getBrandProductTypes(currentUserBrand?.id), [
        currentUserBrand?.id,
        getBrandProductTypes
    ]);
    const [fetched, setFetched] = (0, $fgmOP.useState)(false);
    const { loading: loadingFindContacts, data: { findContacts: findContacts } = {}, refetch: refetch, fetchMore: fetchMore, called: called } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($c6cacb5ffab3de60$exports)))), {
        notifyOnNetworkStatusChange: true
    });
    (0, $c3440150448da8b8$export$1c72fe480f599e97)([
        {
            query: "contacts",
            isLoading: loadingFindContacts
        }
    ]);
    $604f1014b77d3c4c$var$log.debug("render", {
        channelOptions: channelOptions,
        roleOptions: roleOptions,
        productTypesOptions: productTypesOptions,
        findContacts: findContacts
    });
    const { channels: channels, roles: roles, productTypes: productTypes, showInactive: showInactive } = formState.entity;
    const onFind = ()=>{
        $604f1014b77d3c4c$var$log.debug("onFind", {
            channels: channels,
            roles: roles,
            productTypes: productTypes,
            showInactive: showInactive
        });
        setFetched(true);
        refetch({
            channels: channels,
            roles: roles,
            productTypes: productTypes,
            showInactive: showInactive
        });
    };
    const onSendEmail = ()=>{
        const concatEmails = findContacts?.reduce((concat, email)=>concat ? `${concat};${email}` : email, "") || "";
        $604f1014b77d3c4c$var$log.debug("onSendEmail", concatEmails);
        window.open("mailto:?subject=Telia Bulk Messaging notification&bcc=" + concatEmails, "_blank");
    };
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Communication notifications"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "communication"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("p", {
                children: [
                    "Send email to all customers' ",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("b", {
                        children: "communication contacts"
                    }),
                    " and ",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("b", {
                        children: "users"
                    }),
                    "."
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                        title: "Notification receivers filters"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "channels",
                                    label: "Contact type",
                                    options: channelOptions,
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "roles",
                                    label: "User role",
                                    options: roleOptions,
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: "productTypes",
                        label: "Service Types",
                        options: productTypesOptions,
                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: "showInactive",
                        label: "Show inactive",
                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                        onClick: onFind,
                        text: "Find emails"
                    })
                })
            }),
            fetched && loadingFindContacts ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : fetched && findContacts && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
                className: "form-group form-group--padding",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                        title: "User and Contact emails"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $98cbb91c03e56cc2$export$2e2bcd8739ae039), {
                        children: findContacts.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                            description: "Your search did not match any email"
                        }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                                    description: `Your search matches ${findContacts.length} emails`,
                                    buttons: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                        onClick: onSendEmail,
                                        text: "Send email"
                                    })
                                }),
                                findContacts.map((email, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d8d7fa9fc21de820$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                            children: email
                                        })
                                    }, i))
                            ]
                        })
                    })
                ]
            })
        ]
    });
};





var $ff9mn = parcelRequire("ff9mn");

parcelRequire("fgmOP");


var $96530654b2b3bd8b$exports = {};
$96530654b2b3bd8b$exports = "mutation approveOrRejectUser($id:ID!$userAccessStatusType:UserAccessStatusType!){approveOrRejectUser(id:$id userAccessStatusType:$userAccessStatusType)}";










var $l8GLF = parcelRequire("l8GLF");







parcelRequire("fgmOP");






const $ab8010b3a2c3a452$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SelfServiceUser", "INFO");
const $ab8010b3a2c3a452$export$1409e1ddd63aa01b = (props)=>{
    const { formState: formState } = props;
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: "firstName",
                            label: "First name"
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: "lastName",
                            label: "Last name"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: "email",
                        label: "Email",
                        isEditing: false
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $8e2421cb37be9d76$export$7eda936955feae4d), {
                        formState: formState
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: "description",
                        label: "Reason",
                        tip: formState.isEditing ? "Please specify your reason to getting access to Telia Bulk Messaging Web" : null,
                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).textarea
                    })
                })
            })
        ]
    });
};


const $6b6c0d029eae9259$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("PendingUser", "INFO");
const $6b6c0d029eae9259$export$489f8725f8e8f4f2 = (props)=>{
    const { userId: userId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const useApolloCacheEntityProps = {
        fragment: (0, (/*@__PURE__*/$parcel$interopDefault($e518621b97fca5b8$exports))),
        entityId: userId,
        newEntity: {
            firstName: null,
            lastName: null,
            email: null,
            phone: null,
            rolesMap: []
        }
    };
    const formStateOptions = (0, $cd0b9ee27a364316$export$4c2508f4134d3a42)(useApolloCacheEntityProps);
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)({
        ...formStateOptions,
        isEditing: false
    });
    const approveOrRejectUser = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($96530654b2b3bd8b$exports)))));
    const addUserToCachedApprovedList = (proxy, user)=>{
        const { teliaUsers: teliaUsers = [] } = proxy.readQuery({
            query: (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($bec02a301bb122cd$exports)))),
            variables: {}
        }) || {};
        const updatedTeliaUsers = [
            ...teliaUsers,
            user
        ].sort((0, $ff9mn.userComparator));
        proxy.writeQuery({
            query: (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($bec02a301bb122cd$exports)))),
            data: {
                teliaUsers: updatedTeliaUsers
            }
        });
    };
    const removeUserFromCachedPendingList = (proxy, user)=>{
        const { pendingUsers: pendingUsers = [] } = proxy.readQuery({
            query: (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($66f5a169f8640548$exports)))),
            variables: {}
        }) || {};
        const updatedPendingUsers = pendingUsers.filter((pendingUser)=>pendingUser.id !== user.id);
        proxy.writeQuery({
            query: (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($66f5a169f8640548$exports)))),
            data: {
                pendingUsers: updatedPendingUsers
            }
        });
    };
    const onApprove = ()=>{
        approveOrRejectUser({
            loadingText: "Approving user...",
            successText: "User approved",
            variables: {
                id: userId,
                userAccessStatusType: (0, $l8GLF.UserAccessStatusType).GRANTED
            },
            update: (proxy, { data: data })=>{
                const approvedUser = formState.entityAs();
                approvedUser.userAccessStatusType = (0, $l8GLF.UserAccessStatusType).GRANTED;
                $6b6c0d029eae9259$var$log.debug("approveOrRejectUser update", userId);
                addUserToCachedApprovedList(proxy, approvedUser);
                removeUserFromCachedPendingList(proxy, approvedUser);
                // Go to management page of approved user
                navigate(formatWithBrand($e9a95c61c800ecd2$export$eaa88fbc12af3f84, approvedUser.id), {
                    replace: true
                });
            }
        });
    };
    const onReject = ()=>{
        approveOrRejectUser({
            loadingText: "Rejecting user...",
            successText: "User rejected",
            variables: {
                id: userId,
                userAccessStatusType: (0, $l8GLF.UserAccessStatusType).REJECTED
            },
            update: (proxy, { data: data })=>{
                // const {id: userId} = data || {};
                const rejectedUser = formState.entityAs();
                $6b6c0d029eae9259$var$log.debug("approveOrRejectUser update", userId);
                removeUserFromCachedPendingList(proxy, rejectedUser);
                navigate(formatWithBrand($e9a95c61c800ecd2$export$84e81f0486c8c4ce), {
                    replace: true
                });
            }
        });
    };
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Approve or Reject User"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "pending-user"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                children: "The following user has applied for access to Telia Bulk Messaging Web. By approving the users application they are given access to Telia Bulk Messaging Web."
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $2e4c8094e1930e9a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ab8010b3a2c3a452$export$1409e1ddd63aa01b), {
                        formState: formState
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                        text: "Approve",
                                        onClick: onApprove,
                                        kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                        text: "Reject",
                                        onClick: onReject,
                                        kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.negative
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};



parcelRequire("fgmOP");








const $4422967deb2131e8$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("PendingUsers", "INFO");
const $4422967deb2131e8$export$24635e21cd1f028e = (props)=>{
    const { users: users = [] } = props;
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    $4422967deb2131e8$var$log.debug("props", props);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Pending Users"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "pending-users"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                children: "List of people have applied for access to Telia Bulk Messaging Web. Telia admins may reject or approve access for these users."
            }),
            users.length === 0 ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$2e2bcd8739ae039), {
                children: "No pending users"
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $98cbb91c03e56cc2$export$2e2bcd8739ae039), {
                id: "pendingUsersList",
                children: users.map((user)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $d8d7fa9fc21de820$export$2e2bcd8739ae039), {
                        link: formatWithBrand($e9a95c61c800ecd2$export$80c5118692739077, user.id),
                        children: [
                            user.firstName || user.lastName ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                className: "bold",
                                children: [
                                    user.firstName,
                                    " ",
                                    user.lastName
                                ]
                            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                className: "bold missing",
                                children: "no name"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                        className: "labelPrefix",
                                        children: "Email "
                                    }),
                                    " ",
                                    user.email
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                        className: "labelPrefix",
                                        children: "Reason "
                                    }),
                                    " ",
                                    user.description
                                ]
                            })
                        ]
                    }, user.id))
            })
        ]
    });
};






var $fgmOP = parcelRequire("fgmOP");
var $13604643f2d96ba7$exports = {};
$13604643f2d96ba7$exports = "mutation saveRoleMutation($role:RoleInput!){saveRole(role:$role){...roleFragment}}fragment roleFragment on Role{id userType name description permissions}";


var $140c2b29ea67c42f$exports = {};
$140c2b29ea67c42f$exports = "query permissions{permissions{...permissionFragment}}fragment permissionFragment on Permission{id category name description}";



const $b8aae9a7442d3dc8$export$660997f0cca272c0 = "TELIA";
const $b8aae9a7442d3dc8$export$1d0cc9f143bfe9fc = "CUSTOMER";
const $b8aae9a7442d3dc8$export$b14ad400b1d09e0f = {
    TELIA: $b8aae9a7442d3dc8$export$660997f0cca272c0,
    CUSTOMER: $b8aae9a7442d3dc8$export$1d0cc9f143bfe9fc
};
var $b8aae9a7442d3dc8$export$2e2bcd8739ae039 = $b8aae9a7442d3dc8$export$b14ad400b1d09e0f;



















const $370e480e604885e6$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Permissions");
const $370e480e604885e6$var$categoryCompare = (category, other)=>$370e480e604885e6$var$categorySorting(category) - $370e480e604885e6$var$categorySorting(other);
const $370e480e604885e6$var$categorySorting = (category)=>{
    switch(category){
        case "CUSTOMER":
            return 1000;
        case "TELIA":
            return 2000;
        case "SETTLEMENT":
            return 3000;
        case "AUTH":
            return 4000;
        default:
            return 5000;
    }
};
const $370e480e604885e6$export$474c02f71c38b0f = (props)=>{
    const [isEditing, setIsEditing] = (0, $fgmOP.useState)(false);
    const { hasPermission: hasPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { loading: loadingRoles, roles: rolesUnsorted, getRole: getRole } = (0, $3b1b6b64a4bd4f9b$export$a884b22cb22f8e99)();
    const roles = rolesUnsorted?.slice().sort((p, other)=>p.id.localeCompare(other.id));
    const { loading: loadingPermissions, data: { permissions: permissionsUnsorted } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($140c2b29ea67c42f$exports)))));
    (0, $c3440150448da8b8$export$1c72fe480f599e97)([
        {
            query: "Permissions",
            isLoading: loadingPermissions
        },
        {
            query: "Roles",
            isLoading: loadingRoles
        }
    ]);
    const permissions = permissionsUnsorted?.slice().sort((p, other)=>$370e480e604885e6$var$categoryCompare(p.category, other.category) + p.id.localeCompare(other.id));
    const togglePermission = (roleId, permissionId)=>(value)=>{
            $370e480e604885e6$var$log.debug("togglePermission", {
                roleId: roleId,
                permissionId: permissionId,
                value: value
            });
            const oldRole = getRole(roleId);
            const role = {
                ...oldRole,
                permissions: oldRole?.permissions.cloneToggle(permissionId) || []
            };
            onSave(role);
        };
    const saveRole = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($13604643f2d96ba7$exports)))));
    const onSave = (role)=>{
        $370e480e604885e6$var$log.debug("onSave", {
            role: role
        });
        saveRole({
            loadingText: "Saving role...",
            successText: "Role saved",
            variables: {
                role: (0, $6afa790c69fae185$export$251b62dd86dd2816)(role)
            }
        });
    };
    $370e480e604885e6$var$log.debug("Permissions", {
        isEditing: isEditing,
        roles: roles,
        permissions: permissions
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Permissions"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "permissions"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                children: permissions && !permissions.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $702c010b4d2d1d11$export$2e2bcd8739ae039), {
                    id: "permissionsTable",
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $41f29eaafa60f6ab$export$2e2bcd8739ae039), {
                                type: "header",
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef5d15835208031$export$2e2bcd8739ae039), {
                                        isHeader: true,
                                        children: " "
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef5d15835208031$export$2e2bcd8739ae039), {
                                        isHeader: true,
                                        children: " "
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef5d15835208031$export$2e2bcd8739ae039), {
                                        isHeader: true,
                                        children: " "
                                    }),
                                    roles.map((role)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef5d15835208031$export$2e2bcd8739ae039), {
                                            className: "rotate-45",
                                            isHeader: true,
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                                className: "",
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                    children: role.id
                                                })
                                            })
                                        }, "Role" + role.id))
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("tbody", {
                            children: permissions.map((aPermission)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $41f29eaafa60f6ab$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef5d15835208031$export$2e2bcd8739ae039), {
                                            children: aPermission.id
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef5d15835208031$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $acf38b6c25932409$export$2e2bcd8739ae039), {
                                                text: aPermission.category,
                                                buttonContent: aPermission.category && aPermission.category.substring(0, 1),
                                                className: `tooltip--${aPermission.category && aPermission.category.substring(0, 1)}`
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef5d15835208031$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $acf38b6c25932409$export$2e2bcd8739ae039), {
                                                text: aPermission.description
                                            })
                                        }),
                                        roles?.map((role)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef5d15835208031$export$2e2bcd8739ae039), {
                                                className: "",
                                                children: (role.userType === (0, $b8aae9a7442d3dc8$export$2e2bcd8739ae039).TELIA || aPermission.category === "CUSTOMER") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox,
                                                    value: role.permissions.includes(aPermission.id),
                                                    isEditing: isEditing,
                                                    onChange: togglePermission(role.id, aPermission.id)
                                                })
                                            }, aPermission.id + role.id))
                                    ]
                                }, aPermission.id))
                        })
                    ]
                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                    children: "No permissions found"
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("br", {}),
            isEditing ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    onClick: ()=>setIsEditing(false),
                                    text: "Stop editing"
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                        description: `Changes are applied immediately!`
                    })
                ]
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: hasPermission((0, $ca0941499cca84bb$export$7a72678803583a64)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                            onClick: ()=>setIsEditing(true),
                            text: "Edit roles"
                        })
                    })
                })
            })
        ]
    });
};





var $fgmOP = parcelRequire("fgmOP");





const $76384f47643d68f0$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ServiceCategories", "INFO");
const $76384f47643d68f0$export$9fd55fac4e8e45e5 = (props)=>{
    const { loading: loading, serviceCategories: serviceCategories } = (0, $5cd44d723b4013a5$export$97aa5844287be9bb)();
    $76384f47643d68f0$var$log.debug("render", props);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Service Categories"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "service-categories"
            }),
            loading && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}),
            serviceCategories && !serviceCategories.isEmpty() && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("table", {
                id: "serviceCategoryTable",
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("tbody", {
                    children: serviceCategories.map((serviceCategory)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                            className: "paddingTop",
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                className: "bold",
                                                children: serviceCategory.id
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                            className: "paddingTop",
                                            colSpan: 3,
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                className: "bold",
                                                children: serviceCategory.name
                                            })
                                        })
                                    ]
                                }, "serviceCategory-" + serviceCategory.id),
                                serviceCategory.types?.map((categoryType)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {}),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                                children: categoryType.typeId
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                                children: categoryType.name
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("td", {
                                                children: [
                                                    '"',
                                                    categoryType.invoiceText,
                                                    '"'
                                                ]
                                            })
                                        ]
                                    }, `serviceCategoryType-${categoryType.id}`))
                            ]
                        }, "React.Fragment.serviceCategory-" + serviceCategory.id))
                })
            })
        ]
    });
};






parcelRequire("fgmOP");

var $e8d6f17f71da1dc4$exports = {};
$e8d6f17f71da1dc4$exports = "fragment smscFragment on Smsc{id name description smscNodes{...smscNodeFragment}smscConnection{...smscConnectionFragment}healthConfig{...healthConfigFragment}timeZone countryId}fragment healthConfigFragment on HealthConfig{enquireLinkInterval enquireLinkTimeout}fragment smscNodeFragment on SmscNode{id enabled host port name comment}fragment smscConnectionFragment on SmscConnection{connectTimeout bindTimeout requestTimeout windowMonitorInterval}";


var $e14e6c5eeee2c310$exports = {};
$e14e6c5eeee2c310$exports = "mutation saveSmsc($smsc:SmscInput!){saveSmsc(smsc:$smsc){...smscFragment}}fragment smscFragment on Smsc{id name description smscNodes{...smscNodeFragment}smscConnection{...smscConnectionFragment}healthConfig{...healthConfigFragment}timeZone countryId}fragment healthConfigFragment on HealthConfig{enquireLinkInterval enquireLinkTimeout}fragment smscNodeFragment on SmscNode{id enabled host port name comment}fragment smscConnectionFragment on SmscConnection{connectTimeout bindTimeout requestTimeout windowMonitorInterval}";


var $032304f87e9ba72f$exports = {};
$032304f87e9ba72f$exports = "query smscs($countryId:ID){smscs(countryId:$countryId){...smscFragment}}fragment smscFragment on Smsc{id name description smscNodes{...smscNodeFragment}smscConnection{...smscConnectionFragment}healthConfig{...healthConfigFragment}timeZone countryId}fragment healthConfigFragment on HealthConfig{enquireLinkInterval enquireLinkTimeout}fragment smscNodeFragment on SmscNode{id enabled host port name comment}fragment smscConnectionFragment on SmscConnection{connectTimeout bindTimeout requestTimeout windowMonitorInterval}";








var $0b0e588890cecab6$exports = {};
var $27823647d6e11c64$exports = {};
$27823647d6e11c64$exports = JSON.parse('{"AD":{"id":"AD","name":"Andorra","timezones":["Europe/Andorra"],"cities":["Andorra la Vella","Canillo","Encamp","Engordany","Escaldes-Engordany","La Massana","Llorts","Ordino","Santa Coloma","Sispony","Soldeu"]},"AE":{"id":"AE","name":"United Arab Emirates","timezones":["Asia/Dubai"],"cities":["Abu Dhabi","Al Ain","Al Khan","Ar Ruways","As Satwah","Dayrah","Dubai","Fujairah","Ras al-Khaimah","Sharjah"]},"AF":{"id":"AF","name":"Afghanistan","timezones":["Asia/Kabul"],"cities":["Herat","Kabul","Kandahar","Molah","Rana","Shar","Sharif","Wazir Akbar Khan"]},"AG":{"id":"AG","name":"Antigua & Barbuda","timezones":["America/Port_of_Spain"],"cities":[]},"AI":{"id":"AI","name":"Anguilla","timezones":["America/Port_of_Spain"],"cities":[]},"AL":{"id":"AL","name":"Albania","timezones":["Europe/Tirane"],"cities":["Elbasan","Petran","Pogradec","Shkoder","Tirana","Ura Vajgurore"]},"AM":{"id":"AM","name":"Armenia","timezones":["Asia/Yerevan"],"cities":["Abovyan","Agarak","Apaga","Aparan","Arabkir","Ashtarak","Erebuni Fortress","Hrazdan","Ijevan","Jermuk","Kapan","Tsaghkadzor","Vanadzor","Yerevan"]},"AO":{"id":"AO","name":"Angola","timezones":["Africa/Lagos"],"cities":["Ambriz","Benguela","Cabinda","Cacole","Camabatela","Cazeta","Huambo","Kuito","Lobito","Luanda","Lubango","Lucapa","Lumeje","Malanje","Menongue","Muxaluando","Namibe","Ondjiva","Piri","Saurimo","Talatona"]},"AQ":{"id":"AQ","name":"Antarctica","timezones":["Antarctica/Rothera","Antarctica/Palmer","Antarctica/Mawson","Antarctica/Davis","Antarctica/Casey","Antarctica/Vostok","Antarctica/DumontDUrville","Antarctica/Syowa","Antarctica/Troll","Pacific/Auckland"],"cities":[]},"AR":{"id":"AR","name":"Argentina","timezones":["America/Argentina/Buenos_Aires","America/Argentina/Cordoba","America/Argentina/Salta","America/Argentina/Jujuy","America/Argentina/Tucuman","America/Argentina/Catamarca","America/Argentina/La_Rioja","America/Argentina/San_Juan","America/Argentina/Mendoza","America/Argentina/San_Luis","America/Argentina/Rio_Gallegos","America/Argentina/Ushuaia"],"cities":["28 de Noviembre","Abasto","Acassuso","Acebal","Acevedo","Adelia Maria","Agua de Oro","Albardon","Albarellos","Alberdi","Alberti","Aldo Bonzi","Alejandro Korn","Alicia","Allen","Almafuerte","Almagro","Almirante Brown","Alta Gracia","Alta Italia","Alvarez","Alvear","Anatuya","Angelica","Antonio Carboni","Apostoles","Arequito","Armstrong","Arrecifes","Arroyito","Arroyito Challaco","Arroyo Seco","Arteaga","Asamblea","Ascension","Avellaneda","Ayacucho","Azara","Azul","Balcarce","Balnearia","Banda del Rio Sali","Bandera","Banfield","Baradero","Bariloche","Barrio Fisherton","Batan","Beccar","Belen de Escobar","Belgrano","Bell Ville","Bella Vista","Benavidez","Berazategui","Berisso","Bernal","Bernardo Larroude","Bernasconi","Bigand","Bombal","Bordenave","Bosch","Bosques","Boulogne","Bovril","Bragado","Brandsen","Brinkmann","Buenos Aires","Burzaco","Bustinza","Caballito","Calderon","Caleta Olivia","Caleufu","Camilo Aldao","Campana","Canada de Gomez","Canada del Ucle","Canada Rosquin","Canals","Canning","Canuelas","Capilla del Monte","Capilla del Senor","Capitan Bermudez","Carhue","Carlos Casares","Carlos Pellegrini","Carlos Tejedor","Caseros","Casilda","Castelar","Castelli","Castillo","Catriel","Catrilo","Cavanagh","Centenario","Ceres","Cervantes","Chacabuco","Chacarita","Chajari","Charata","Chateaubriand","Chilecito","Chivilcoy","Choele Choel","Chorroarin","Cinco Saltos","Cipolletti","City Bell","Ciudad General Belgrano","Ciudadela","Claypole","Clorinda","Colon","Colonia Baron","Colonia Caroya","Colonia San Miguel Arcangel","Comodoro Rivadavia","Concepcion","Concordia","Constituyentes","Coronel Dorrego","Coronel Martinez de Hoz","Coronel Pringles","Corral de Bustos","Corralitos","Corrientes","Cosquin","Coy Aike","Cramer","Crespo","Cruz del Eje","Curuzu Cuatia","Cutral-Co","Darregueira","De Mayo","Del Campillo","Del Viso","Despenaderos","Devoto","Diaz","Diego de Alvear","Doblas","Dock Sud","Dolores","Don Bosco","Don Torcuato","Drabble","Eduardo Castex","El Calafate","El Dorado","El Hoyo","El Palomar","El Talar","El Trebol","Eldorado","Embalse","Empalme Lobos","Ensenada","Esperanza","Esquel","Esteban Echeverria","Ezeiza","Ezpeleta","Famailla","Fatima","Federal","Fernandez","Firmat","Florencio Varela","Florentino Ameghino","Flores","Floresta","Florida","Formosa","Francisco Alvarez","Franck","Fray Luis A. Beltran","Freyre","Frias","Funes","Gaiman","Galvez","Garin","Garupa","General Acha","General Alvear","General Cabrera","General Deheza","General Guido","General Juan Madariaga","General Lagos","General Las Heras","General Lavalle","General Mansilla","General Martin Miguel de Guemes","General Pacheco","General Paz","General Pico","General Roca","General Rodriguez","General San Martin","General Viamonte","General Villegas","Germania","Glew","Gobernador Crespo","Gobernador Galvez","Godoy","Godoy Cruz","Gonzalez Catan","Gonzalez Moreno","Goya","Granadero Baigorria","Grand Bourg","Gualeguay","Guatrache","Guernica","Henderson","Hernando","Hersilia","Hilario","Hilario Ascasubi","Hipatia","Hipolito Yrigoyen","Huanchillas","Huanguelen","Huinca Renanco","Humahuaca","Hurlingham","Ibarlucea","Ibicuy","Independencia","Ingeniero Beaugey","Ingeniero Luiggi","Ingeniero Maschwitz","Intendente Alvear","Isidro Casanova","Ituzaingo","James Craik","Jauregui","Jeppener","Jesus Maria","Jose Leon Suarez","Jose Marmol","Juan Pujol","Justiniano Posse","La Banda","La Boca","La Calera","La Cumbre","La Falda","La Leonesa","La Lucila","La Madrid","La Pampa","La Para","La Paz","La Plata","La Punta","La Rioja","La Tablada","La Union","La Violeta","Laborde","Laboulaye","Laferrere","Laguna Alsina","Lanus","Larroque","Las Catitas","Las Flores","Las Heras","Las Perdices","Las Rosas","Las Talitas","Las Varillas","Lavalle","Leandro N. Alem","Leones","Libertad","Lima","Liniers","Llavallol","Lobos","Lomas de Zamora","Lomas del Mirador","Longchamps","Los Antiguos","Los Cardales","Los Molinos","Los Polvorines","Luis Guillon","Lujan de Cuyo","Luque","Luzuriaga","Lynch","Macachin","Magdalena","Maggiolo","Maipu","Manantial","Manfredi","Manuel J. Cobo","Maquinista Savio","Mar de Ajo","Mar del Plata","Mar del Tuyu","Marcos Juarez","Marcos Paz","Margarita","Maria Ignacia","Maria Juana","Mariano Acosta","Mariano J. Haedo","Mariano Moreno","Martinez","Matheu","Mayor Buratovich","Melincue","Mendiolaza","Mendoza","Mercedes","Merlo","Minacar","Miramar","Monje","Monte Hermoso","Monteros","Montserrat","Moreno","Moron","Morteros","Muniz","Munro","Navarro","Necochea","Nogoya","Nordelta","Nunez","Obera","Oliva","Oliveros","Olivos","Oncativo","Open Door","Ordonez","Palermo","Palmira","Palpala","Partido de Jose C. Paz","Pasco","Paso del Rey","Paternal","Pavon","Pedernales","Pedro Luro","Pellegrini","Perez","Pergamino","Perico","Perito Moreno","Piamonte","Pico de Salamanca","Pico Truncado","Pigue","Pilar","Pinamar","Piquete Cabado","Platanos","Plaza Huincul","Plottier","Pontevedra","Portena","Posadas","Pozo del Molle","Presidente Derqui","Puan","Pueblo San Jose","Puerto Madryn","Puerto Rico","Pueyrredon","Punta Alta","Quilmes","Rada Tilly","Rafael Calzada","Rafael Castillo","Rafael Obligado","Rafaela","Ramallo","Ramos Mejia","Ranchos","Rancul","Ranelagh","Rawson","Realico","Recoleta","Reconquista","Remedios de Escalada","Resistencia","Retiro","Rio Ceballos","Rio Colorado","Rio Grande","Rio Piedras","Rio Segundo","Rio Tercero","Rivadavia","Rocamora","Rodriguez Pena","Rojas","Roldan","Roque Perez","Rosario","Rosas","Rufino","Sacanta","Saenz Pena","Saladillo","Salguero","Salsipuedes","Salta","Salto","Salto Grande","Sampacho","San Andres","San Andres de Giles","San Antonio de Areco","San Antonio de Arredondo","San Antonio de Obligado","San Antonio de Padua","San Antonio Oeste","San Benito","San Bernardo","San Carlos de Bolivar","San Cayetano","San Clemente","San Cristobal","San Fernando","San Fernando del Valle de Catamarca","San Francisco","San Francisco de Santa Fe","San Francisco Solano","San Genaro","San Gregorio","San Guillermo","San Isidro","San Isidro de Lules","San Javier","San Jeronimo Norte","San Jorge","San Jose","San Jose de la Esquina","San Juan","San Justo","San Lorenzo","San Luis","San Manuel","San Martin","San Martin de las Escobas","San Miguel","San Miguel del Monte","San Nicolas","San Pedro","San Rafael","San Salvador","San Salvador de Jujuy","San Telmo","San Vicente","Sanchez","Santa Clara de Saguier","Santa Elena","Santa Fe","Santa Lucia","Santa Rita","Santa Rosa","Santa Teresita","Santiago del Estero","Santo Tome","Santos Lugares","Sarandi","Sarmiento","Segui","Sierra de la Ventana","Sierra de los Padres","Sinsacate","Suipacha","Sunchales","Tablada","Tacuari","Tafi Viejo","Tandil","Tapalque","Tapiales","Temperley","Teodelina","Thames","Tigre","Tio Pujio","Todd","Tornquist","Tortuguitas","Tostado","Totoras","Trelew","Trenque Lauquen","Tres Arroyos","Trevelin","Tristan Suarez","Tunuyan","Tupungato","Turdera","Ucacha","Uriburu","Ushuaia","Valle Hermoso","Vedia","Veinticinco de Mayo","Venado Tuerto","Vera","Veronica","Viale","Viamonte","Vicente Lopez","Victoria","Vicuna Mackenna","Viedma","Villa Aberastain","Villa Adelina","Villa Allende","Villa Alsina","Villa Amelia","Villa Angela","Villa Ballester","Villa Bosch","Villa Canas","Villa Carlos Paz","Villa Constitucion","Villa de Maria","Villa de Mayo","Villa del Parque","Villa Dolores","Villa Dominico","Villa Elisa","Villa General Belgrano","Villa Gesell","Villa Giardino","Villa Huidobro","Villa Insuperable","Villa La Angostura","Villa Las Rosas","Villa Lugano","Villa Luzuriaga","Villa Madero","Villa Maria Grande","Villa Media Agua","Villa Mercedes","Villa Nueva","Villa Ocampo","Villa Paranacito","Villa Regina","Villa Robles","Villa Rosa","Villa Trinidad","Villa Urquiza","Villaguay","Vuelta de Obligado","Warnes","Wheelwright","Wilde","Winifreda","Yerba Buena","Zenon Pereyra"]},"AS":{"id":"AS","name":"Samoa (American)","timezones":["Pacific/Pago_Pago"],"cities":[]},"AT":{"id":"AT","name":"Austria","timezones":["Europe/Vienna"],"cities":["Absam","Absdorf","Abtenau","Abtsdorf","Ach","Achenkirch","Achensee","Admont","Adnet","Afritz","Aggsbach","Aichbach","Aichdorf","Aifersdorf","Aigen","Aigen im Muehlkreis","Ainet","Aistersheim","Alberndorf in der Riedmark","Alberschwende","Aldrans","Alkoven","Alland","Allhartsberg","Alpbach","Altach","Altenberg","Altenberg bei Linz","Altenburg","Altendorf","Altenhof am Hausruck","Altenmarkt an der Triesting","Altenmarkt im Pongau","Altheim","Althofen","Altlengbach","Altlichtenwarth","Altmunster","Altwaidhofen","Am See","Amaliendorf","Ampass","Ampfelwang","Amstetten","Andorf","Anger","Anif","Annenheim","Ansfelden","Anthering","Apfelberg","Arbesthal","Ardagger Markt","Ardning","Arnoldstein","Arriach","Asberg","Aschach an der Donau","Aschau","Aspang Markt","Asparn","Asperhofen","Asten","Attersee","Attnang-Puchheim","Atzbach","Au","Auersthal","Aufhausen","Augsdorf","Aurolzmunster","Axams","Bach","Bad Blumau","Bad Deutsch-Altenburg","Bad Erlach","Bad Fischau","Bad Gams","Bad Gastein","Bad Gleichenberg","Bad Goisern","Bad Hall","Bad Hofgastein","Bad Ischl","Bad Kreuzen","Bad Pirawarth","Bad Radkersburg","Bad Schallerbach","Bad Tatzmannsdorf","Bad Voslau","Baden bei Wien","Baernbach","Baldramsdorf","Bartholomaberg","Barwies","Bauer","Baumgarten im Burgenland","Baumgartenberg","Baumkirchen","Berg","Bergau","Bergheim","Berndorf","Bernhardsthal","Bernstein","Berwang","Bezau","Biberbach","Biberwier","Bichlbach","Biedermann","Biedermannsdorf","Birgitz","Bisamberg","Bizau","Bleiberg ob Villach","Bleiburg","Blindenmarkt","Bludenz","Bludesch","Blumau","Bockfliess","Bodensdorf","Boheimkirchen","Bosendurnbach","Bramberg am Wildkogel","Brandberg","Braunau am Inn","Bregenz","Breitenbrunn","Breitenfurt bei Wien","Breitenwang","Brixen im Thale","Bruck am Ziller","Bruck an der Grossglocknerstrasse","Bruck an der Leitha","Bruck an der Mur","Bruckl","Bruckneudorf","Bruendl","Bruggen","Brunn am Gebirge","Buch","Buch bei Jenbach","Buchkirchen","Burgkirchen","Burgschleinitz","Burmoos","Dalaas","Dechantskirchen","Dellach","Desselbrunn","Deutsch Goritz","Deutsch-Wagram","Deutschfeistritz","Deutschkreutz","Deutschlandsberg","Diepoltsham","Dietach","Dietersdorf am Gnasbach","Dobersberg","Dobersdorf","Doblbach","Dobldorf","Doebriach","Donnerskirchen","Doren","Dorf","Dorfgastein","Dorfla","Dornbirn","Drassburg","Drassmarkt","Dross","Durnstein","Ebbs","Eben im Pongau","Ebenau","Ebendorf","Ebenfurth","Ebensee","Ebenthal","Ebergassing","Eberndorf","Eberschwang","Ebersdorf","Eberstein","Ebreichsdorf","Eckartsau","Edelschrott","Edelstal","Edlitz","Edt bei Lambach","Eferding","Egg","Egg am Faaker See","Eggenburg","Eggendorf","Eggendorf im Thale","Eggersdorf bei Graz","Ehrenhausen","Ehrwald","Eibiswald","Eichgraben","Eisbach","Eisenberg","Eisenerz","Eisenstadt","Eisentratten","Eisgarn","Elixhausen","Ellmau","Elsbethen","Emberg","Emmersdorf an der Donau","Engelhartszell","Engersdorf","Engerwitzdorf","Enns","Ennsdorf","Enzenkirchen","Enzenreith","Enzersdorf an der Fischa","Enzersfeld","Enzesfeld","Erlauf","Ernst","Ernstbrunn","Ernsthofen","Erpersdorf","Erpfendorf","Esternberg","Eugendorf","Faak am See","Falkenburg","Fehring","Feistritz","Feistritz an der Drau","Feld am See","Feldbach","Feldkirch","Feldkirchen an der Donau","Feldkirchen bei Graz","Feldkirchen bei Mattighofen","Feldkirchen in Karnten","Felixdorf","Ferndorf","Fernitz","Feuchten","Feuersbrunn","Fieberbrunn","Filzmoos","Finkenberg","Finsing","Fischamend Dorf","Fischbach","Fischerndorf","Fiss","Flachau","Fladnitz im Raabtal","Flattach","Fliess","Flinsdorf","Foederlach","Fohnsdorf","Forst","Frankenburg","Frankenmarkt","Frattingsdorf","Frauenkirchen","Freienstein","Freilassing","Freinberg","Freistadt","Friedburg","Friesach","Frohnleiten","Fuernitz","Fuerstenfeld","Fugen","Fulpmes","Furthof","Fusch an der Glocknerstrasse","Fuschl am See","Fussach","Gaaden","Gaal","Gablitz","Gaflenz","Gailitz","Gaisberg","Gallbrunn","Gallneukirchen","Gallspach","Gallzein","Galtur","Gaming","Gampern","Gansbach","Ganserndorf","Gargellen","Gars am Kamp","Garsten","Gaschurn","Gaspoltshofen","Gasthof","Gattendorf","Gaweinstal","Geinberg","Geras","Gerasdorf am Steinfelde","Gerasdorf bei Wien","Gerersdorf","Gerlos","Getzersdorf","Gfohl","Giesshubl","Glan","Glaubendorf","Gleisdorf","Glinzendorf","Gloggnitz","Gmund","Gmunden","Gnadenwald","Gnas","Gobelsburg","Goedersdorf","Goesselsdorf","Gofis","Going","Goldegg","Gollersdorf","Golling an der Salzach","Gols","Gortipohl","Gosau","Gosdorf","Gosing","Gostling an der Ybbs","Gotzendorf","Gotzendorf an der Leitha","Gotzens","Gotzis","Grabelsdorf","Graen","Grafenbach","Grafendorf","Grafendorf bei Hartberg","Grafendorf bei Stainz","Grafenschlag","Grafenstein","Grafenweg","Grafenworth","Gramastetten","Gramatneusiedl","Grambach","Gratkorn","Gratwein","Graz","Grein","Gresten","Gries","Gries am Brenner","Grieselstein","Grieskirchen","Griffen","Grimmenstein","Grobming","Grodig","Gross","Gross-Enzersdorf","Gross-Schweinbarth","Gross-Siegharts","Grossarl","Grossebersdorf","Grossklein","Grosspesendorf","Grossraming","Grossrussbach","Grossweikersdorf","Grunbach am Schneeberg","Gruner Baum","Gschnitz","Guessing","Gugging","Guglwald","Gumpoldskirchen","Gunselsdorf","Gunskirchen","Guntersdorf","Guntramsdorf","Gurten","Gurtis","Gutau","Gutenstein","Guttaring","Haag","Haag am Hausruck","Hadersdorf am Kamp","Hadersfeld","Hadres","Hagenberg im Muhlkreis","Haibach ob der Donau","Haid","Haidershofen","Haiming","Haimingerberg","Hainburg an der Donau","Hainfeld","Halbturn","Haldensee","Hall","Hall in Tirol","Hallein","Haller","Hallstatt","Harbach","Hard","Hart","Hartberg","Hartkirchen","Haslau an der Donau","Hatting","Hatzendorf","Haus","Hausbrunn","Hausleiten","Hausmannstatten","Hautzendorf","Heidenreichstein","Heiligenkreuz am Waasen","Heimschuh","Heissberg","Heissingfelding","Heiterwang","Hellmonsodt","Henndorf am Wallersee","Hennersdorf","Hermagor","Hernstein","Herrnbaumgarten","Herzogenburg","Herzogsdorf","Himberg","Himmelreich","Hinterbruehl","Hinterburg","Hinterglemm","Hintersdorf","Hinterstoder","Hinterthiersee","Hintertux","Hinterwaldberg","Hipping","Hirm","Hirschegg","Hirtenberg","Hochburg","Hochgurgl","Hochleithen","Hochneukirchen","Hochsoelden","Hochst","Hoehe","Hof am Leithaberge","Hof bei Salzburg","Hofen","Hofkirchen im Traunkreis","Hoflein","Hofstatten an der Raab","Hofstetten","Hohenau","Hohenberg","Hohenburg","Hoheneich","Hohenems","Hohentauern","Hohenwarth","Hohenzell","Hohnhart","Hollabrunn","Hollenthon","Hollersbach im Pinzgau","Holzhausen","Hopfgarten im Brixental","Horbranz","Horersdorf","Horn","Hornstein","Horsching","Huetten","Huttschlag","Igls","Im Brand","Imst","Innerkrems","Innermanzing","Innsbruck","Inzersdorf im Kremstal","Inzing","Ischgl","Isper","Jagenbach","Jagerberg","Japons","Jeging","Jenbach","Jennersdorf","Jerzens","Jochberg","Jois","Judenau","Judenburg","Judendorf","Jungholz","Kainach bei Voitsberg","Kaindorf","Kalsdorf bei Graz","Kaltenbrunn","Kaltenleutgeben","Kanzelhoehe","Kapelln","Kapfenberg","Kapfing","Kappern","Kappl","Kaprun","Karl","Karlstetten","Karteis","Katsdorf","Katzelsdorf","Kaumberg","Kefermarkt","Kematen in Tirol","Kennelbach","Keutschach am See","Kienberg","Kierling","Kilb","Kindberg","Kirchbach in Steiermark","Kirchberg am Wagram","Kirchberg in Tirol","Kirchbichl","Kirchdorf an der Krems","Kirchdorf in Tirol","Kirchham","Kirchschlag","Kirchschlag bei Linz","Kittsee","Klagenfurt","Klam","Klaus","Klein-Harras","Kleinbergl","Kleinkirchheim","Kleinstubing","Klingfurth","Klosterle","Klostermarienberg","Klosterneuburg","Knappenberg","Knittelfeld","Kobenz","Kobersdorf","Koblach","Koestenberg","Koetschach","Koflach","Kollmitzberg","Konigstetten","Konigswiesen","Kopfing im Innkreis","Koppl","Korneuburg","Kossen","Kottingbrunn","Kottmannsdorf","Kraig","Kramsach","Krems","Kremsbruecke","Kremsdorf","Kremsmunster","Krenglbach","Kreuz","Krieglach","Krispl","Kritzendorf","Kroatisch Minihof","Krottendorf bei Ligist","Krumbach","Krumbach Markt","Krumegg","Krumpendorf","Kuchl","Kuehnsdorf","Kuehtai","Kufstein","Kumberg","Kundl","Laa an der Thaya","Laab im Walde","Laaben","Laakirchen","Labach","Lambrechten","Lamprechtshausen","Landeck","Landegg","Landskron","Lanersbach","Langeck im Burgenland","Langenlois","Langenrohr","Langenstein","Langenzersdorf","Lannach","Lanzenkirchen","Lassee","Lassnitzhohe","Latschach","Launsdorf","Lauterach","Lavamund","Lavant","Laxenburg","Lebring","Lech","Lechaschau","Leibnitz, Styria","Leisach","Leiten","Leitring","Lembach im Muhlkreis","Lend","Lendorf","Lenzing","Leoben","Leobendorf","Leobersdorf","Leogang","Leonding","Leonfelden","Leopoldsdorf","Lermoos","Leutasch","Leutschach","Lichtenau","Lichtenberg","Lichtenegg","Lichtenworth","Liebenfels","Lieboch","Lienz","Liesfeld","Liezen","Ligist","Lilienfeld","Lindenberg","Linz","Litschau","Lobenstein","Lochau","Lochen","Lofer","Lohnsburg","Loimersdorf","Loipersbach","Loosdorf","Loretto","Ludesch","Luftenberg an der Donau","Lungotz","Lustenau","Lutzmannsburg","Mader","Madseit","Maglern","Maiersdorf","Maildorf","Mairhof","Maissau","Mallnitz","Mandling","Mank","Mannersdorf am Leithagebirge","Mannersdorf an der Rabnitz","Mannsworth","Marbach","Marchegg","Marchtrenk","Margarethen am Moos","Maria Alm am Steinernen Meer","Maria Buch","Maria Elend","Maria Ellend","Maria Enzersdorf","Maria Lankowitz","Maria Lanzendorf","Maria Saal","Maria Schmolln","Maria Taferl","Maria Worth","Maria-Anzbach","Mariazell","Markgrafneusiedl","Markt Allhau","Markt Neuhodis","Markt Piesting","Marktl","Marz","Mathon","Matrei am Brenner","Matrei in Osttirol","Mattersburg","Mattsee","Mauerbach","Mauerkirchen","Maurach","Mauterndorf","Mauthausen","Mayrhofen","Meggenhofen","Mehrnbach","Meiningen","Meisten","Melk","Mellach","Mettmach","Michelbach Markt","Micheldorf in Oberoesterreich","Mieming","Miesenbach","Millstatt","Mistelbach","Mittelberg","Mitterdorf im Muerztal","Mitterkirchen im Machland","Mitterndorf an der Fischa","Mittersill","Moellbruecke","Mollersdorf","Molln","Mollram","Monchhof","Mondsee","Moos","Moosburg","Moosdorf","Mooskirchen","Mosern","Motz","Muckendorf an der Donau","Muerzhofen","Muerzsteg","Muerzzuschlag","Muhlbach am Manhartsberg","Munchendorf","Muntlix","Munzbach","Munzkirchen","Murau","Murfeld","Mutters","Naarn im Machlande","Nassereith","Natternbach","Nauders","Neckenmarkt","Neidling","Nenzing","Nesselwangle","Nestelbach bei Graz","Neudau","Neudorf bei Landsee","Neudorf bei Staatz","Neudorfl","Neufeld an der Leitha","Neuhofen","Neuhofen an der Krems","Neuhofen an der Ybbs","Neukirchen","Neukirchen am Walde","Neukirchen an der Enknach","Neukirchen an der Vockla","Neulengbach","Neumarkt am Wallersee","Neumarkt an der Ybbs","Neumarkt im Hausruckkreis","Neumarkt im Muhlkreis","Neumarkt in Steiermark","Neunkirchen","Neusiedl am See","Neusiedl bei Guessing","Neustift","Neutal","Neuzeug","Nickelsdorf","Niederachen","Niederalm","Niederdorf","Niederkreuzstetten","Niederland","Niederleis","Niederndorf","Niederneukirchen","Niederwaldkirchen","Niederwolz","Nochling","Nussdorf","Nussdorf am Haunsberg","Nuziders","Obdach","Ober-Grafendorf","Oberaich","Oberaichwald","Oberalm","Oberau","Obergruenburg","Obergurgl","Oberhausen","Oberhofen im Inntal","Oberkappel","Oberkirchbach","Oberkohlstaetten","Obernberg","Obernberg am Brenner","Oberndorf an der Melk","Oberndorf bei Salzburg","Oberneukirchen","Oberort","Oberperfuss","Oberpullendorf","Oberrohrbach","Oberschutzen","Obersdorf","Obersiebenbrunn","Obertauern","Obertrum am See","Obervellach","Oberwaltersdorf","Oberwart","Oberweis","Oberwolbling","Obritzberg","Obsteig","Oed","Oehling","Oepping","Oetz","OEtztal-Bahnhof","Offenhausen","Oftering","Oggau","Ohlsdorf","Ollern","Opponitz","Ort im Innkreis","Orth an der Donau","Oslip","Ossiach","Ostermiething","Ottendorf bei Gleisdorf","Ottenheim","Ottensheim","Pabneukirchen","Pachfurth","Paldau","Panzendorf","Parndorf","Parschlug","Pasching","Passail","Passthurn","Patsch","Pattergassen","Payerbach","Peggau","Perchtoldsdorf","Perg","Pernegg an der Mur","Pernitz","Pertisau","Perwang am Grabensee","Petersdorf","Petronell-Carnuntum","Pettenbach","Pettnau","Pettneu","Petzenkirchen","Peuerbach","Pfaffstatten","Pfons","Pfunds","Piberbach","Pichl","Pichl bei Wels","Pichling bei Stainz","Piesendorf","Pillberg","Pillichsdorf","Pinggau","Pinkafeld","Pinsdorf","Piringsdorf","Pirka","Pischeldorf","Pischelsdorf am Engelbach","Pischelsdorf in Steiermark","Pitten","Plangeross","Plankenau","Plescherken","Pochlarn","Poelten","Poertschach am Woerthersee","Poetting","Poggstall","Polfing","Pottelsdorf","Pottenbrunn","Pottendorf","Pottenstein","Pottsching","Potzneusiedl","Poysbrunn","Poysdorf","Prabach","Pram","Preding","Pregarten","Pressbaum","Prinzersdorf","Puch","Puch bei Hallein","Puchberg am Schneeberg","Puchenau","Pucking","Purbach","Purbach am Neusiedlersee","Purgg","Purgstall","Purkersdorf","Pyhra","Raab","Raaba","Raabs an der Thaya","Radfeld","Radstadt","Ramsau im Zillertal","Randegg","Rangersdorf","Rankweil","Rannersdorf","Rappoltenkirchen","Rauchenwarth","Rauris","Redlham","Regau","Regelsbrunn","Reichenau an der Rax","Reichenau im Muhlkreis","Reichendorf","Reichraming","Reifnitz","Reisenberg","Reitdorf","Reith","Reith bei Seefeld","Reith im Alpbachtal","Rekawinkel","Reutte","Ried im Innkreis","Ried im Traunkreis","Ried im Zillertal","Ried in der Riedmark","Riedenthal","Rieding","Riedlingsdorf","Riefensberg","Riegersburg","Riezlern","Ringelsdorf","Rinn","Rohrau","Rohrbach am Kulm","Rohrbach am Steinfelde","Rohrbach in Oberosterreich","Rohrmoos","Roppen","Rosegg","Rosenau am Hengstpass","Rosenbach","Rosental","Rotenbach","Rothis","Rotholz","Rottenbach","Rottenmann","Rubring","Ruden","Rudersdorf","Rum","Rutzenmoos","Saalbach","Saalfelden am Steinernen Meer","Sachendorf","Sachsenburg","Saint Anton","Salzburg","Sankt Agatha","Sankt Andra am Zicksee","Sankt Andrae","Sankt Florian","Sankt Gallenkirch","Sankt Georgen am Ybbsfelde","Sankt Georgen im Attergau","Sankt Johann im Pongau","Sankt Kanzian","Sankt Kathrein am Hauenstein","Sankt Lorenzen","Sankt Lorenzen im Muerztal","Sankt Margarethen im Burgenland","Sankt Marienkirchen am Hausruck","Sankt Martin am Techelsberg","Sankt Martin am Ybbsfelde","Sankt Michael im Burgenland","Sankt Michael in Obersteiermark","Sankt Oswald","Sankt Pankraz","Sankt Peter","Sankt Polten","Sankt Ruprecht an der Raab","Sankt Stefan im Rosental","Sankt Ulrich bei Steyr","Sankt Valentin","Sankt Veit an der Glan","Sankt Veit im Pongau","Sankt Wolfgang","Sarleinsbach","Satteins","Sauerbrunn","Sausenstein","Schachendorf","Schalchen","Schardenberg","Scharding","Scharnstein","Scharten","Schattendorf","Scheffau am Wilden Kaiser","Scheifling","Schiefling am See","Schladming","Schleinbach","Schlierbach","Schlins","Schlitters","Schmirn","Schneeberg","Schoenau","Schoenberg im Stubaital","Schoerfling","Schonbuhel an der Donau","Schongrabern","Schonkirchen","Schoppernau","Schrems","Schruns","Schutzen am Gebirge","Schwadorf","Schwaigs","Schwanberg","Schwanenstadt","Schwarzach","Schwarzach im Pongau","Schwarzau am Steinfelde","Schwarzau im Gebirge","Schwarzenau","Schwarzenberg am Boehmerwald","Schwaz","Schwechat","Schweiggers","Schwendau","Schwertberg","Schwoich","Sebersdorf","Seckau","Seeboden","Seefeld in Tirol","Seeham","Seekirchen am Wallersee","Seewalchen","Seiersberg","Seitenstetten Markt","Semmering","Semriach","Serfaus","Sernau","Sibratsgfall","Siebenhirten","Siegendorf im Burgenland","Sieghartskirchen","Sierndorf","Sierning","Siezenheim","Sillian","Silz","Sinabelkirchen","Sinnersdorf","Sipbachzell","Sirnitz","Sistrans","Sitzenberg","Solden","Soll","Sollenau","Sommerein","Sooss","Spielberg bei Knittelfeld","Spillern","Spital am Pyhrn","Spittal an der Drau","Spitz","Spratzern","Staatz","Stadelbach","Stadl-Paura","Stadtschlaining","Stainz","Stainz bei Straden","Stams","Stans","Stattegg","Statzendorf","Steg","Stegersbach","Stein an der Donau","Stein an der Enns","Stein im Jauntal","Steinabruckl","Steinach am Brenner","Steinakirchen am Forst","Steinberg bei Ligist","Steindorf am Ossiacher See","Steinerberg","Steinerkirchen an der Traun","Steinfeld","Steinhaus","Steinhaus am Semmering","Stettenhof","Steyr","Steyregg","Stiegl","Stockerau","Stoob","Straden","Strass","Strassen","Strassengel","Strasshof an der Nordbahn","Strasswalchen","Strau","Strobl","Stubach","Stubenberg","Studenzen","Stuhlfelden","Stuhlsdorf","Stumm","Stummerberg","Sulz","Sulz im Wienerwald","Sulzau","Sulzberg","Tadten","Tal","Tamsweg","Tannheim","Tarrenz","Tattendorf","Taufkirchen an der Pram","Taufkirchen an der Trattnach","Tauplitz","Taxenbach","Telfes im Stubai","Telfs","Ternberg","Ternitz","Teufenbach","Thal","Thalgau","Thalheim bei Wels","Thalling","Thaur","Thaya","Theresienfeld","Thoerl","Thuringen","Tiefenbach","Tiefgraben","Tieschen","Tirol","Tobaj","Toeschling","Toesenssteinach","Traboch","Traisen","Traiskirchen","Traismauer","Trasdorf","Traun","Traunkirchen","Traunstein","Trausdorf an der Wulka","Trautmannsdorf an der Leitha","Tribuswinkel","Trieben","Tristach","Troepolach","Trofaiach","Trumau","Tschagguns","Tschoeran","Tulln","Tullnerbach-Lawies","Tumeltsham","Turnitz","Turrach","Tweng","Uderns","Ulmerfeld","Ulrichsberg","Ulrichskirchen","Ungenach","Unterberg","Untergrub","Unterjoch","Unterlamm","Unterparschenbrunn","Unterpremstatten","Unterpullendorf","Unterpurkla","Unterradlberg","Unterrohr","Untersiebenbrunn","Unterwaltersdorf","Unterweitersdorf","Unzmarkt","Uttendorf","Utzenaich","Veitsch","Velden am Woerthersee","Vent","Vienna","Vigaun","Viktorsberg","Viktring","Villach","Virgen","Vitis","Vocklabruck","Vocklamarkt","Voelkermarkt","Voitsberg","Volders","Vols","Vorau","Vorchdorf","Vorderlanersbach","Vordernberg","Vosendorf","Wagna","Wagrain","Waidhofen an der Thaya","Waidhofen an der Ybbs","Waidmannsfeld","Waidring","Waizenkirchen","Walbersdorf","Walchsee","Wald am Arlberg","Waldenstein","Walding","Waldkirchen am Wesen","Waldzell","Wallern an der Trattnach","Wallern im Burgenland","Wallsee","Wals","Waltersdorf an der March","Waltersdorf in Oststeiermark","Wampersdorf","Wang","Wangle","Wartberg","Wartberg an der Krems","Warth","Wattens","Watzelsdorf","Watzendorf","Waxenberg","Weibern","Weiden am See","Weigelsdorf","Weikendorf","Weikersdorf am Steinfelde","Weilbach","Weiler","Weinburg am Sassbach","Weissbriach","Weissenbach am Lech","Weissenkirchen in der Wachau","Weisskirchen an der Traun","Weisskirchen in Steiermark","Weiten","Weitersfeld","Weitra","Weiz","Wels","Weng bei Admont","Weng im Innkreis","Wenns","Weppersdorf","Werfen","Werfenweng","Werndorf","Wernstein am Inn","Westendorf","Wettmannstatten","Wiener Neudorf","Wiener Neustadt","Wienerherberg","Wies","Wieselburg","Wiesing","Wiesmath","Wieting","Wildon","Wilfleinsdorf","Wilhelmsburg","Wilhering","Wimpassing an der Leitha","Wimpassing im Schwarzatale","Winden am See","Windischgarsten","Winkl","Winzendorf","Woelfnitz","Wolfau","Wolfpassing","Wolfsberg","Wolfsgraben","Wolfurt","Wolkersdorf im Weinviertel","Wollersdorf","Wordern","Worgl","Wulkaprodersdorf","Wundschuh","Wurflach","Wurmbrand","Ybbs an der Donau","Ybbsitz","Zams","Zeillern","Zeiselmauer","Zell am Moos","Zell am See","Zell am Ziller","Zell an der Ybbs","Zellerndorf","Zeltweg","Zemendorf","Zettling","Ziersdorf","Zillingdorf","Zillingtal","Zipf","Zirl","Zistersdorf","Zobing","Zuers","Zurndorf","Zwentendorf","Zwettl Stadt","Zwolfaxing"]},"AU":{"id":"AU","name":"Australia","timezones":["Australia/Lord_Howe","Antarctica/Macquarie","Australia/Hobart","Australia/Currie","Australia/Melbourne","Australia/Sydney","Australia/Broken_Hill","Australia/Brisbane","Australia/Lindeman","Australia/Adelaide","Australia/Darwin","Australia/Perth","Australia/Eucla"],"cities":["Abbotsford","Abbotsham","Aberdeen","Aberfoyle","Aberglasslyn","Abermain","Acacia Ridge","Adamstown","Adelaide","Adelong","Advancetown","Agnes Banks","Agnes Water","Airlie Beach","Aitkenvale","Albany","Albany Creek","Albert Park","Alberton","Albion","Albion Park","Albury","Aldgate","Aldinga","Aldinga Beach","Alexandra","Alexandria","Alfredton","Alice Springs","Allambee","Allansford","Allanson","Allora","Alma","Alphington","Alpine","Alstonville","Alton Downs","Altona","Amamoor","Amaroo","Angaston","Anglesea","Anna Bay","Annandale","Apollo Bay","Applecross","Applethorpe","Ararat","Arcadia","Argents Hill","Armadale","Armidale","Armstrong Creek","Arno Bay","Arrawarra","Artarmon","Ascot","Ascot Vale","Ashburton","Ashfield","Ashgrove","Ashton","Aspendale","Aspley","Asquith","Atherton","Attadale","Auburn","Augusta","Austinmer","Austins Ferry","Australind","Avalon","Avenue","Avoca Beach","Avondale","Axedale","Aylmerton","Ayr","Babinda","Bacchus Marsh","Bagdad","Bahrs Scrub","Bairnsdale","Baker","Balaclava","Balaklava","Bald Hills","Balgowlah","Balgownie","Balhannah","Ballan","Ballarat","Ballina","Balmain","Balmoral","Balnarring","Balwyn","Balwyn North","Bangalow","Bangor","Banksmeadow","Bankstown","Bannockburn","Barcoo","Barellan","Bargara","Bargo","Baringhup","Barkstead","Barnsley","Barry","Barwon Downs","Barwon Heads","Basin View","Bass Hill","Bassendean","Batchelor","Bateau Bay","Batesford","Bathurst","Batlow","Baulkham Hills","Baxter","Bayles","Baynton","Bayswater","Beachmere","Beacon","Beaconsfield","Beaconsfield Upper","Beaudesert","Beaumaris","Beaumont","Beauty Point","Bedford Park","Bedfordale","Beeac","Beechwood","Beechworth","Beenak","Beenleigh","Beerwah","Bega","Belair","Belconnen","Belgian Gardens","Belgrave","Belgrave Heights","Bell","Bellambi","Bellara","Bellbird","Bellbrae","Bellerive","Bellevue Hill","Belmont","Belrose","Benalla","Benambra","Bendigo","Benowa","Bensville","Bentleigh","Bentleigh East","Bentley","Beresfield","Berkeley","Berkeley Vale","Berowra","Berridale","Berrima","Berry","Berwick","Bethania Junction","Beveridge","Beverley","Bexley","Bicheno","Bicton","Big Pats Creek","Bilinga","Biloela","Bilpin","Binda","Binnaway","Birdwood","Birkdale","Birkenhead","Black Hill","Black Rock","Blackburn","Blackbutt","Blackheath","Blackmans Bay","Blacktown","Blackwall","Blackwarry","Blackwater","Blackwood","Blair Athol","Blakehurst","Blaxland","Blayney","Bli Bli","Boambee","Boat Harbour","Bobin","Boddington","Bogangar","Bohle Plains","Bolton","Bolwarra","Bomaderry","Bombala","Bonbeach","Bondi","Boneo","Bongaree","Bonnells Bay","Bonnet Bay","Bonython","Booker Bay","Bool Lagoon","Boolarra","Boonah","Boondall","Booral","Bordertown","Boronia","Botany","Boulder","Bourke","Bowen","Bowenfels","Bowral","Bowraville","Box Hill","Box Hill South","Boyup Brook","Bradbury","Braddon","Braeside","Braidwood","Brandon","Brandy Hill","Branxton","Brewarrina","Briar Hill","Bridgetown","Bridgewater","Brighton","Brighton East","Brighton-Le-Sands","Bringelly","Brisbane","Broadbeach","Broadford","Broadmeadows","Broadwater","Broke","Broken Hill","Bronte","Brookdale","Brookfield","Brooklyn","Brookvale","Broome","Brown Hill","Browns Plains","Bruce","Brunswick","Buchan","Buckland","Buderim","Budgewoi","Bulahdelah","Bulga","Bulimba","Bulla","Bulleen","Bulli","Bullsbrook","Bullyard","Buln Buln","Bunbury","Bundaberg","Bundalong","Bundamba","Bundanoon","Bundeena","Bundook","Bundoora","Bungendore","Bungonia","Buninyong","Burekup","Burleigh Heads","Burnett Heads","Burnie","Burnley","Burnside","Burpengary","Burradoo","Burraneer","Burrum","Burrum Heads","Burwood","Bushland Beach","Busselton","Butchers Ridge","Buxton","Byford","Byron Bay","Caboolture","Cairns","Calen","Calingiri","Callala Bay","Callington","Caloundra","Caltowie","Camberwell","Cambewarra","Cambridge","Camden","Camden Haven","Cammeray","Campbell","Campbellfield","Campbelltown","Camperdown","Canadian","Canberra","Cannington","Cannonvale","Canterbury","Canungra","Capalaba","Caragabal","Caravonica","Carbrook","Cardiff","Cardigan","Cardinia","Cardup","Caringbah","Carlingford","Carlsruhe","Carlton","Carlton North","Carlton South","Carnarvon","Carnegie","Caroline Springs","Carrick","Carrington","Carrum","Carrum Downs","Casino","Casterton","Castle Hill","Castlecrag","Castlemaine","Caulfield","Caulfield North","Caulfield South","Caversham","Cawarral","Cawongla","Cedar Grove","Ceduna","Central Coast","Cessnock","Charlestown","Chatswood","Chatsworth Island","Chelsea","Cheltenham","Chinchilla","Chippendale","Chipping Norton","Christies","Chullora","Churchill","City of Parramatta","City of West Torrens","Clare","Claremont","Clarence Town","Clareville","Clarinda","Clarkefield","Clayton North","Cleveland","Clifton","Clifton Hill","Clifton Springs","Clontarf","Closeburn","Clovelly","Clunes","Clyde","Clyde North","Cobbitty","Coburg","Cockatoo","Cockburn","Coffs Harbour","Colac","Coleambally","Coledale","Coleraine","Collaroy","Collie","Collingwood","Collinsvale","Colo","Colo Vale","Como","Concord","Condamine","Condobolin","Coniston","Connells Point","Coober Pedy","Cooee","Coogee","Cook","Cooktown","Coolah","Coolamon","Coolangatta","Cooloolabin","Coolum","Coolum Beach","Coolup","Cooma","Coomera","Coonawarra","Coondoo","Cooranbong","Cooroy","Coorparoo","Cootamundra","Copacabana","Copmanhurst","Corinda","Corinthia","Corio","Corlette","Coromandel Valley","Corrimal","Cotham","Cottesloe","Coutts Crossing","Cowan","Cowes","Cowra","Crafers","Craigieburn","Cranbourne","Crawford","Cremorne","Crescent Head","Creswick","Crib Point","Cringila","Cronulla","Crookwell","Crossley","Crows Nest","Croydon","Croydon North","Crystal Creek","Cudlee Creek","Cummins","Cundletown","Curl Curl","Currumbin","Cygnet","Daceyville","Daisy Hill","Dakabin","Dalby","Dalkeith","Dandenong","Dapto","Dardanup","Darkan","Darley","Darling","Darling Point","Darlinghurst","Darlington","Darra","Darwin","Davidson","Davistown","Dawson","Dayboro","Daylesford","Deagon","Deakin","Deception Bay","Deepdene","Deer Park","Deloraine","Denham","Denman","Dereel","Derrimut","Derwent","Devonport","Diamond Creek","Diggers Rest","Dilston","Dimboola","Dimbulah","Dingley","Dirranbandi","Dodges Ferry","Dolans Bay","Don","Doncaster","Doncaster East","Donnybrook","Donvale","Doonside","Doreen","Dorrigo","Doubtful Creek","Douglas","Douglas Park","Dover Heights","Drayton","Dromana","Drouin","Drouin South","Drouin West","Drummond Cove","Drummoyne","Drysdale","Dubbo","Dumbalk","Dumbleyung","Dundas","Dundowran","Dungog","Dunkeld","Dunmore","Dunolly","Dunsborough","Dural","Eagle Farm","Eagle Heights","Eagleby","Eaglehawk","Eaglemont","Earlwood","East Fremantle","East Gosford","East Maitland","East Malvern","Eastwood","Eaton","Ebbw Vale","Ebenezer","Echuca","Echunga","Eden","Eden Park","Edge Hill","Edgecliff","Edith","Edithvale","Edmonton","Edwardstown","Eight Mile Plains","Elderslie","Elizabeth","Ellalong","Ellangowan","Ellendale","Ellerslie","Elsternwick","Eltham","Eltham North","Elwood","Emerald","Empire Bay","Emu Park","Emu Plains","Emu Vale","Encounter Bay","Endeavour","Endeavour Hills","Enfield","Engadine","Enmore","Enoggera","Epping","Erina","Erskine","Eschol","Esk","Esperance","Essendon","Ettalong Beach","Eudlo","Eudunda","Eumundi","Euroa","Evandale","Everton","Exeter","Exmouth","Failford","Fairfield","Fairview","Fairy Meadow","Fassifern","Faulconbridge","Fawkner","Fern Tree","Fern Tree Gully","Ferndale","Ferntree Gully","Fernvale","Ferny Creek","Figtree","Findon","Fingal","Fingal Bay","Fitzroy","Flemington","Flinders","Flynn","Footscray","Forbes","Forest","Forest Hill","Forestville","Forrest","Forsayth","Forster","Foster","Franklin","Frankston","Freeling","Freemans Reach","Fremantle","Freshwater","Fulham","Fullerton","Fyshwick","Galston","Garfield","Gatton","Gawler","Gayndah","Gaythorne","Geelong","Geelong West","Gellibrand","George Town","Gepps Cross","Geraldton","Gerringong","Gheerulla","Gilberton","Gilmore","Gilston","Gin Gin","Girraween","Gisborne","Gladesville","Gladstone","Glass House Mountains","Glebe","Glen Huntly","Glen Huon","Glen Innes","Glen Iris","Glen Osmond","Glen Waverley","Glenbrook","Glenburn","Glenelg","Glenfield","Glengarry","Glenhaven","Glenorchy","Glenore Grove","Glenorie","Glenreagh","Glenroy","Glenvale","Glossodia","Gloucester","Golconda","Gold Coast","Golden Grove","Goodna","Goodwood","Goolwa","Goomeri","Goonellabah","Goornong","Gooseberry Hill","Gordon","Gordonvale","Gore Hill","Gorokan","Gosford","Gosforth","Gosnells","Goulburn","Gould","Gowrie","Gracemere","Grafton","Grandchester","Grange","Grant","Grantham","Granville","Grassmere","Gravesend","Green Hill","Green Point","Greenbank","Greendale","Greensborough","Greenvale","Greenwich","Gregadoo","Grenfell","Greta","Griffith","Grove","Grovedale","Guildford","Gundaroo","Gunnedah","Gymea","Gymea Bay","Gympie","Haberfield","Hackham","Haddon","Hadspen","Hagley","Hahndorf","Hall","Hallam","Hallett","Halls Gap","Hamilton","Hammond","Hampton","Hampton Park","Happy Valley","Harrington","Harristown","Harvey","Hastings","Hastings Point","Hat Head","Hawker","Hawkesbury Heights","Hawksburn","Hawthorn","Hawthorne","Haymarket","Hazelbrook","Hazelwood","Healesville","Heathcote","Heathcote Junction","Heatherton","Heathmont","Heddon Greta","Heidelberg","Helensburgh","Helensvale","Hendon","Hepburn Springs","Hervey Bay","Hexham","Highbury","Highett","Highfields","Hill Top","Hillcrest","Hindmarsh","Hobart","Hoddles Creek","Hollow Tree","Holroyd","Holsworthy","Homebush","Hope Island","Hope Valley","Hopetoun","Hoppers Crossing","Hornsby","Horsham","Hove","Howard","Howard Springs","Howden","Howe","Howlong","Hughesdale","Hunter","Hunters Hill","Huntly","Huonville","Hurstbridge","Hurstville","Hurstville Grove","Hyland Park","Illawarra","Illawong","Iluka","Indented Head","Ingham","Ingle Farm","Ingleburn","Inglewood","Innisfail","Inverell","Inverloch","Invermay","Ipswich","Isabella","Ivanhoe","Ivanhoe East","Ives","Jacobs Well","Jannali","Jarrahdale","Jensen","Jilliby","Jimboomba","Jindabyne","Jindivick","Judbury","Junee","Kadina","Kalgoorlie","Kallista","Kalorama","Kambalda","Kangaroo Flat","Kangaroo Point","Kanwal","Kapunda","Karalee","Karana Downs","Kardella","Kardella South","Kareela","Karnup","Karoonda","Karratha","Katherine","Katoomba","Kawungan","Keilor","Keiraville","Keith","Kellyville","Kelmscott","Kelso","Kelvin Grove","Kempsey","Kempton","Kendall","Kenilworth","Kenmore","Kennington","Kensington","Kensington and Norwood","Kenthurst","Kenwick","Kerang","Kerry","Keswick","Kettering","Kew","Kew East","Keysborough","Keysbrook","Kiama","Kilcoy","Kilcunda","Killara","Killarney","Killcare","Killingworth","Kilmore","Kilsyth","Kincumber","Kindred","Kingaroy","Kinglake","Kings Cross","Kings Park","Kingscliff","Kingsthorpe","Kingston","Kingswood","Kinross","Kirrawee","Kirribilli","Kirwan","Koah","Kobble","Koetong","Kogarah","Kojonup","Koo-Wee-Rup","Koolewong","Koorawatha","Koornalla","Kootingal","Kooyong","Koroit","Korumburra","Kotara","Kununurra","Kuranda","Kurnell","Kurrajong Heights","Kurri Kurri","Kyabram","Kyneton","Kyogle","Laang","Laguna","Laidley","Lake Cathie","Lake Heights","Lake Illawarra","Lake Munmorah","Lakemba","Lakes Entrance","Lalor","Lambton","Lamington","Lancefield","Lancelin","Landsborough","Lane Cove","Lang Lang","Langhorne Creek","Langley","Langwarrin","Lara","Largs North","Latrobe","Lauderdale","Launceston","Laverton","Lavington","Lawgi","Lawnton","Lawson","Lebrina","Leeton","Legana","Leichhardt","Lemon Tree Passage","Lennox Head","Leongatha","Leopold","Lethbridge","Leumeah","Leura","Lewiston","Lidcombe","Lilli Pilli","Lilydale","Limestone","Linden","Lindenow","Lindfield","Lindisfarne","Lisarow","Lismore","Lithgow","Little Bay","Little Hampton","Little River","Liverpool","Loch","Lockhart","Lockridge","Loftus","Logan","Logan City","Logan Village","Loganholme","Loganlea","Long Jetty","Long Plains","Long Point","Longford","Longreach","Longueville","Longwarry","Lovely Banks","Lowanna","Lower Chittering","Lower Plenty","Lowood","Loxton","Luddenham","Ludlow","Lugarno","Lulworth","Lutana","Lyndhurst","Lyndoch","Lyneham","Lyons","Lysterfield","Macarthur","Macedon","Mackay","Macksville","Maclean","Macleod","Macquarie Park","Maddington","Maffra","Magill","Maidenwell","Maitland","Malabar","Maleny","Mallala","Mallanganee","Malmsbury","Malvern","Mandalong","Mandurah","Mangalore","Mangerton","Manildra","Manjimup","Manly","Mannering Park","Manning","Manning Point","Mannum","Mansfield","Mapleton","Mareeba","Margaret River","Margate","Marian","Maribyrnong","Marino","Marion","Marlee","Marmor","Marong","Maroochydore","Maroota","Maroubra","Marrickville","Marsden","Marsden Park","Marshalltown","Martins Creek","Marulan","Maryborough","Maryland","Marysville","Mascot","Maslin Beach","Matcham","Matraville","Maudsland","Maybole","Mayfield","Maylands","McCrae","McGraths Hill","McKinnon","McLachlan","McLaren Flat","McLaren Vale","Meadows","Medlow Bath","Medowie","Melbourne","Melrose","Melton","Melton South","Melville","Menai","Menangle","Mentone","Meredith","Merewether","Meringandan","Merlynston","Mernda","Merredin","Merriwa","Merrylands","Middlemount","Middleton","Midway Point","Mildura","Mile End","Miles","Milton","Miners Rest","Minlaton","Minmi","Minto","Miranda","Mirani","Mirboo","Mirboo North","Mirrabooka","Mission Beach","Mitcham","Mitchell","Mitchelton","Mitiamo","Mittagong","Moama","Moana","Modbury","Moggill","Mona Vale","Monash","Monbulk","Mont Albert North","Monteagle","Monterey","Montmorency","Montrose","Montville","Mooloolaba","Mooloolah Valley","Moonah","Moonee Ponds","Mooney Mooney","Moorabbin","Mooralla","Moore","Moore Park","Moorooduc","Mooroolbark","Mooroopna","Moranbah","Morang","Morayfield","Mordialloc","Moree","Moriac","Morisset","Mornington","Morphett Vale","Mortdale","Mortlake","Moruya","Morwell","Mosman","Mosman Park","Moss Vale","Mossman","Mount Barker","Mount Colah","Mount Cotton","Mount Dandenong","Mount Direction","Mount Druitt","Mount Egerton","Mount Eliza","Mount Evelyn","Mount Gambier","Mount Gravatt","Mount Helen","Mount Helena","Mount Isa","Mount Julian","Mount Keira","Mount Larcom","Mount Lofty","Mount Macedon","Mount Martha","Mount Molloy","Mount Morgan","Mount Ousley","Mount Perry","Mount Pleasant","Mount Saint Thomas","Mount Waverley","Mount White","Mourilyan","Muchea","Mudgee","Mudgeeraba","Mudjimba","Mulgoa","Mulgrave","Mullewa","Mullumbimby","Mundaring","Mundijong","Murray Bridge","Murrumba","Murrumbateman","Murrumbeena","Murrurundi","Murtoa","Murwillumbah","Muswellbrook","Mylor","Myrrhee","Myrtleford","Nagambie","Nairne","Nambour","Nambucca Heads","Nana Glen","Nanango","Nannup","Napoleons","Nar Nar Goon","Narangba","Narara","Narellan","Narooma","Narrabeen","Narrabri","Narrandera","Narrawong","Narre Warren","Narre Warren North","Narrogin","Narromine","Neath","Nebo","Nedlands","Neerim South","Nelson Bay","Nerang","Nerrigundah","Nerrina","Neutral Bay","New Farm","New Lambton","New Town","Newcastle","Newmarket","Newnham","Newport","Newry","Newstead","Newtown","Nhill","Nindaroo","Ningi","Nirranda","Noarlunga","Noble Park","Noosa","Noosaville","Norah","Nords Wharf","Norlane","Norman Park","Normanhurst","Normanton","Normanville","North Beach","North Fitzroy","North Mackay","North Melbourne","North Tamborine","North Turramurra","Northam","Northcote","Northgate","Northmead","Norton Summit","Norwood","Notting Hill","Nowra","Nullawarre","Nunawading","Nuriootpa","Nyora","Oak Park","Oakdale","Oakey","Oakhurst","Oaklands","Oakleigh","Oakleigh South","Oatlands","Oatley","Oberon","Obi Obi","Ocean Shores","Officer","Old Bar","Old Beach","Olinda","Oman-Ama","One Tree Hill","Orange","Orchard Hills","Orford","Orient Point","Ormeau","Ormiston","Ormond","Orroroo","Osborne","Ourimbah","Oxenford","Oxley","Oyster Bay","Paddington","Padstow","Pakenham","Pallarenda","Palm Beach","Palm Cove","Palm Island","Palmer","Palmwoods","Pambula","Paradise","Paramatta","Parap","Park Ridge","Parkdale","Parkerville","Parkes","Parkhurst","Parkville","Parkwood","Pearce","Pearcedale","Pechey","Pelican","Pendle Hills","Penfield","Penguin","Pennant Hills","Penrith","Penshurst","Perenjori","Perth","Peterborough","Petrie","Phillip","Pialba","Piawaning","Picnic Bay","Picton","Piggabeen","Pimpama","Pine Mountain","Pinery","Pinjarra","Pinkenba","Pioneer","Pipers Brook","Pitt Town","Pittsworth","Plympton","Point Clare","Point Cook","Point Lonsdale","Point Lookout","Point Pass","Point Vernon","Pokolbin","Pomona","Pontville","Poowong","Port Adelaide","Port Augusta","Port Douglas","Port Fairy","Port Hacking","Port Hedland","Port Kembla","Port Lincoln","Port MacDonnell","Port Macquarie","Port Melbourne","Port Noarlunga","Port Pirie","Port Sorell","Portarlington","Portland","Portsea","Potts Point","Prahran","Preston","Proserpine","Prospect","Purnim","Pymble","Pyrmont","Quakers Hill","Queanbeyan","Queenscliff","Queensferry","Queenstown","Railton","Ramsgate","Randwick","Rathmines","Ravenswood","Raworth","Raymond Terrace","Red Hill","Redan","Redbank","Redcliffe","Redfern","Redhead","Redland Bay","Redlynch","Reedy Creek","Regents Park","Research","Reservoir","Retreat","Revesby","Reynella","Rhodes","Riana","Richmond","Riddell","Ridgley","Ringwood","Ringwood East","Ringwood North","Ripley","Risdon","River Heads","Riverside","Riverstone","Riverton","Riverview","Riverwood","Robertson","Robertstown","Robinvale","Rochedale","Rochester","Rockbank","Rockdale","Rockhampton","Rockingham","Rocklea","Rodborough","Rokeby","Roleystone","Roma","Romsey","Rooty Hill","Rosanna","Rose Bay","Rosebery","Rosebud","Rosehill","Roseville","Rosewood","Roseworthy","Ross","Ross Creek","Ross River","Rowville","Royal Park","Rozelle","Rudall","Rushworth","Rutherford","Rydalmere","Ryde","Rye","Rylstone","Safety Bay","Saint Albans","Saint Andrews","Saint George","Saint Georges Basin","Saint Helena","Saint Ives","Saint James","Saint Leonards","Saint Lucia","Saint Marys","Saint Peters","Saints","Salamander Bay","Sale","Salisbury","Salt Ash","Samford","San Remo","Sanctuary Point","Sandford","Sandgate","Sandringham","Sandstone Point","Sandy Bay","Sandy Hollow","Sans Souci","Sapphire","Sarina","Sarina Beach","Sassafras","Scarborough","Scarness","Scarsdale","Schofields","Scone","Scoresby","Scottsdale","Seacliff","Seacombe","Seaford","Seaforth","Seaton","Seaview","Sebastopol","Selbourne","Selby","Sellicks Beach","Sellicks Hill","Semaphore","Serpentine","Seven Hills","Seven Mile Beach","Seville","Seville East","Seymour","Sheffield","Shellharbour","Shenton Park","Sherbrook","Shoal Point","Shorncliffe","Silvan","Silverdale","Silverwater","Singleton","Sippy Downs","Slacks Creek","Smithfield","Smithton","Smythes Creek","Smythesdale","Snowtown","Somersby","Somerset","Somerton","Somerville","Sorrento","South Melbourne","South Perth","South West Rocks","South Yarra","Southbank","Southern Brook","Southport","Spearwood","Spencer","Spotswood","Spreyton","Spring Field","Spring Hill","Springfield","Springvale","Springvale South","Springwood","St Helens","St Kilda","Stanhope","Stanley","Stanmore","Stannum","Stanthorpe","Stapylton","Stawell","Stieglitz","Stirling","Stockton","Stockyard Creek","Stoneville","Stradbroke","Stratford","Strathalbyn","Strathfield","Strathfieldsaye","Strathmore","Strathpine","Streaky Bay","Stroud","Stuart Park","Sturt","Subiaco","Success","Suffolk Park","Sulphur Creek","Summerholm","Summertown","Sunbury","Sunnybank","Sunnyside","Sunshine","Surfers Paradise","Surrey Hills","Sutherland","Swan Hill","Swan View","Swansea","Sydenham","Sydney","Sylvania","Sylvania Waters","Tahmoor","Tallangatta","Tallarook","Tallebudgera","Talmalmo","Tambo Upper","Tamborine","Tammin","Tamworth","Tannum Sands","Tanunda","Taree","Taren Point","Tarlee","Tarneit","Taroona","Tarragindi","Tarrawanna","Tarro","Tarzali","Tatura","Tawonga","Teesdale","Telegraph Point","Temora","Tempe","Templestowe","Templestowe Lower","Tenambit","Tennyson","Tenterfield","Teralba","Terrigal","Terry Hills","Tewantin","Thagoona","Thargomindah","The Basin","The Entrance","The Oaks","The Patch","The Rocks","Thebarton","Thirlmere","Thirroul","Thomastown","Thompson","Thornbury","Thornlands","Thornleigh","Thornton","Thuringowa","Thursday Island","Tiaro","Tieri","Tinamba","Tincurrin","Tingoora","Tolga","Tom Price","Tomago","Tongala","Toogoolawah","Toogoom","Toolangi","Toolern Vale","Toongabbie","Toora","Tooradin","Toorak","Toorbul","Tooronga","Toowong","Toowoomba","Torbanlea","Toronto","Torquay","Tottenham","Toukley","Townsville","Towradgi","Trafalgar","Traralgon","Traralgon South","Trentham","Trinity Beach","Truganina","Trunkey","Tuggerah","Tuggeranong","Tugun","Tullamarine","Tully","Tumut","Tuncurry","Tunnack","Turners Beach","Turramurra","Tweed Heads","Two Rocks","Two Wells","Tyabb","Tyalgum","Tynong","Uki","Ulladulla","Ulmarra","Ultimo","Ulverstone","Umina","Unanderra","Underwood","Unley","Upper Brookfield","Upper Burringbar","Upper Caboolture","Upper Coomera","Upwey","Uraidla","Urangan","Valla Beach","Valley Heights","Vaucluse","Venus Bay","Verdun","Vermont","Victor Harbor","Victoria Park","Victoria Point","Villawood","Vineyard","Virginia","Waaia","Wacol","Wagga Wagga","Wahgunyah","Wahroonga","Waikerie","Waitara","Walgett","Walhalla","Wallacia","Wallan","Wallaroo","Wallington","Walliston","Wallsend","Walmer","Wamberal","Wamuran","Wanbi","Wandin North","Wandoan","Wangaratta","Wangi Wangi","Wanneroo","Wantirna","Wantirna South","Waratah","Warburton","Warnbro","Warnervale","Warragul","Warrandyte","Warrane","Warrawong","Warren","Warren Shire","Warrigal","Warrimoo","Warrnambool","Warwick","Waterford","Waterloo","Waterloo Corner","Watsonia","Wattle Grove","Waubra","Wauchope","Waurn Ponds","Waverley","Waverton","Wayville","Wedderburn","Weetah","Weethalle","Wellard","Wellington","Wellington Point","Welshpool","Wembley","Wendouree","Wentworth","Wentworth Falls","Wentworthville","Werribee","Werribee South","West Burleigh","West End","West Hoxton","West Pymble","West Wyalong","Westbrook","Westfield","Westmead","Weston","Weston Creek","Wheelers Hill","White Rock","Whitfield","Whittlesea","Whyalla","Wickham","Wilberforce","Willaston","Willaura","Williams","Williamstown","Willow Grove","Willow Vale","Willunga","Wilmot","Wilson","Wilton","Wiluna","Wimbledon","Winchelsea","Windang","Windaroo","Windellama","Windermere Park","Windsor","Windsor Downs","Wingham","Winkleigh","Wodonga","Wollar","Wollert","Wollongbar","Wollongong","Womboota","Won Wron","Wondai","Wonga Park","Wongan Hills","Wonthaggi","Woodburn","Woodend","Woodford","Woodgate","Woodleigh","Woodridge","Woodside","Woodstock","Woodvale","Woodville","Woolamai","Woolgoolga","Woolloomooloo","Woolooware","Wooloweyah","Woolwich","Woombah","Woombye","Woonona","Woori Yallock","Woorim","Wooroolin","Worongary","Woronora","Woy Woy","Wulkuraka","Wyalkatchem","Wyalong","Wyee","Wyndham","Wynnum","Wynyard","Wyong","Wyongah","Wyreema","Yaamba","Yackandandah","Yallingup","Yallourn","Yallourn North","Yamba","Yanchep","Yandina","Yangan","Yankalilla","Yapeen","Yaroomba","Yarpturk","Yarra Glen","Yarra Junction","Yarragon","Yarram","Yarraman","Yarrambat","Yarraville","Yarrawarrah","Yass","Yatala","Yea","Yellow Rock","Yenda","Yeoval","Yeppoon","Yerrinbool","Yinnar","Yolla","York","Yorkeys Knob","Young","Yowie Bay","Zeehan"]},"AW":{"id":"AW","name":"Aruba","timezones":["America/Curacao"],"cities":["Noord","Oranjestad","Palm Beach","Paradera","Ponton","Sabaneta","San Barbola","Santa Cruz","Sero Blanco","Sint Nicolaas","Tanki Lender"]},"AX":{"id":"AX","name":"\xc5land Islands","timezones":["Europe/Helsinki"],"cities":[]},"AZ":{"id":"AZ","name":"Azerbaijan","timezones":["Asia/Baku"],"cities":["Baku","Nakhchivan","Quba","Qusar","Sulutapa","Sumqayit","Xirdalan","Zurges"]},"BA":{"id":"BA","name":"Bosnia & Herzegovina","timezones":["Europe/Belgrade"],"cities":[]},"BB":{"id":"BB","name":"Barbados","timezones":["America/Barbados"],"cities":["Atlantic Shores","Bagatelle","Bloomsbury","Bridgetown","Bruce Vale","Cave Hill","Clapham","Hastings","Holetown","Husbands","Jackmans","Oistins","Pine Housing Estate","Porters","Rendezvous","Rockley","The Garden","Wanstead","Warners","Warrens","White Hill","Wildey","Worthing"]},"BD":{"id":"BD","name":"Bangladesh","timezones":["Asia/Dhaka"],"cities":["Agrabad","Bangla","Barisal","Bazar","Chittagong","Comilla","Delta","Dhaka","Hossain","Jessore","Kabi","Kazipur","Mymensingh","Narayanganj","Rajshahi","Tejgaon","Uttara"]},"BE":{"id":"BE","name":"Belgium","timezones":["Europe/Brussels"],"cities":["Aalbeke","Aalst","Aalter","Aarschot","Aarsele","Aartrijke","Aartselaar","Achel","Adegem","Adinkerke","Afsnee","Agimont","Alken","Alleur","Alsemberg","Alveringem","Amay","Ampsin","Andenne","Anderlecht","Anderlues","Andrimont","Angleur","Ans","Anseroeul","Anthisnes","Antwerp","Anzegem","Appels","Appelterre-Eichem","Arbrefontaine","Ardooie","Arendonk","Argenteau","Arlon","Arquennes","Arsimont","As","Asse","Assebroek","Assenede","Assent","Assesse","Astene","Astenet","Ath","Attenhoven","Attre","Aubange","Aubel","Auderghem","Auvelais","Avekapelle","Avelgem","Averbode","Awans","Awirs","Aywaille","Baal","Baarle-Hertog","Baasrode","Baelen","Baisy-Thy","Balen","Banneux","Barchon","Barry","Basecles","Bassenge","Bassevelde","Bastogne","Battice","Baudour","Bavegem","Bavikhove","Bazel","Beaufays","Beauvechain","Beernem","Beerse","Beersel","Beervelde","Beerzel","Beez","Begijnendijk","Beigem","Bekkevoort","Belgrade","Belle Fontaine","Bellem","Beloeil","Belsele","Berchem","Berendrecht","Beringen","Berlaar","Berlare","Bernissart","Bertem","Bertrix","Betekom","Bevel","Beveren","Beverlo","Beyne-Heusay","Bierbeek","Biercee","Bierges","Bierset","Bilstain","Bilzen","Binche","Bissegem","Blaasveld","Blanden","Blankenberge","Blegny","Bocholt","Boechout","Boezinge","Boncelles","Bonheiden","Bonlez","Booischot","Boom","Boorsem","Boortmeerbeek","Borchtlombeek","Borgerhout","Borgloon","Bornem","Borsbeek","Borsbeke","Bouge","Bouillon","Boussu","Bousval","Boutersem","Bouwel","Bovekerke","Bovesse","Braine-le-Chateau","Braine-le-Comte","Braives","Brasmenil","Brasschaat","Brecht","Bredene","Bree","Bressoux","Broechem","Brugelette","Bruges","Brussegem","Brussels","Budingen","Buggenhout","Buizingen","Bunsbeek","Burcht","Burdinne","Burst","Butgenbach","Buvrinnes","Carnieres","Casteau","Celles","Cerexhe-Heuseux","Chapelle-lez-Herlaimont","Charleroi","Charneux","Chastre","Chatelet","Chatelineau","Chaudfontaine","Chaumont-Gistoux","Chaussee-Notre-Dame-Louvignies","Chenee","Chercq","Chevron","Chievres","Chimay","Chiny","Ciney","Ciplet","Clavier","Colfontaine","Comblain-au-Pont","Comines","Coret","Corroy-le-Grand","Couillet","Cour-sur-Heure","Courcelles","Court-Saint-Etienne","Couthuin","Couvin","Crisnee","Cuesmes","Dadizele","Dalhem","Damme","Dampremy","Dave","De Haan","De Klinge","De Panne","De Pinte","Deerlijk","Deftinge","Deinze","Denderbelle","Denderhoutem","Denderleeuw","Dendermonde","Dentergem","Dessel","Desselgem","Destelbergen","Deurle","Deurne","Diegem","Diepenbeek","Diest","Diksmuide","Dilbeek","Dilsen","Dinant","Dison","Donceel","Dongelberg","Dorinne","Dottignies","Dour","Dranouter","Drogenbos","Drongen","Dudzele","Duffel","Duisburg","Dworp","Ecaussinnes-Lalaing","Edegem","Eeklo","Eernegem","Eghezee","Eigenbilzen","Eke","Ekeren","Eksaarde","Eksel","Elen","Elewijt","Elingen","Ellezelles","Ellignies-Sainte-Anne","Elverdinge","Elversele","Emblem","Embourg","Emptinne","Enghien","Engis","Ensival","Eppegem","Erbaut","Erembodegem","Erezee","Erondegem","Erpe","Erpent","Erps-Kwerps","Erquelinnes","Ertvelde","Esneux","Essen","Essene","Estaimpuis","Estinnes-au-Val","Etalle","Etikhove","Etterbeek","Eupen","Everbeek","Everberg","Evere","Evergem","Faimes","Falisolle","Fallais","Farciennes","Fayt-lez-Manage","Feluy","Ferrieres","Fexhe-le-Haut-Clocher","Fexhe-Slins","Filot","Flawinne","Flemalle-Grande","Flemalle-Haute","Flenu","Fleron","Fleurus","Flobecq","Floreffe","Florennes","Florenville","Fontaine","Fontaine-Valmont","Forchies-la-Marche","Forest","Forrieres","Fosse des Loups","Frameries","Franiere","Frasnes-lez-Buissenal","Freylange","Gages","Galmaarden","Ganshoren","Gavere","Geel","Geer","Geetbets","Gellik","Gelrode","Geluwe","Gembloux","Genk","Gentbrugge","Gentinnes","Genval","Geraardsbergen","Gerpinnes","Gesves","Ghent","Ghislenghien","Ghlin","Gierle","Gijzegem","Gilly","Gingelom","Gistel","Gits","Glabbeek","Glimes","Gobard","Godarville","Goe","Gooik","Goor","Gosselies","Gourdinne","Goutroux","Gouy-lez-Pieton","Grand","Grand-Leez","Grand-Rechain","Grand-Reng","Grembergen","Grez-Doiceau","Grimbergen","Grimminge","Grivegnee","Grobbendonk","Groot-Bijgaarden","Gruitrode","Gullegem","Haacht","Haaltert","Haasdonk","Haasrode","Haccourt","Haine-Saint-Paul","Halen","Hallaar","Halle","Ham","Ham-sur-Heure","Ham-sur-Sambre","Hamme","Hamme-Mille","Hamoir","Hamont","Hampteau","Haneffe","Hannut","Hansbeke","Harelbeke","Haren","Hasselt","Haut-Ittre","Hautrage","Havay","Havre","Hechtel","Heers","Heestert","Heffen","Heindonk","Heist","Heist-op-den-Berg","Hekelgem","Helchteren","Hemiksem","Henri-Chapelle","Hensies","Heppen","Herdersem","Herent","Herentals","Herenthout","Herinnes","Herk-de-Stad","Herlaimont","Hermalle-sous-Argenteau","Hermee","Herne","Herseaux","Herselt","Herstal","Herve","Herzele","Heule","Heure-le-Romain","Heusden","Heusy","Hever","Heverlee","Hingene","Hoboken","Hodeige","Hoegaarden","Hoeilaart","Hoeleden","Hoeselt","Hoevenen","Hofstade","Hognoul","Hollain","Holland","Hollogne","Holsbeek","Hombeek","Hooglede","Hoogstraten","Horion-Hozemont","Hornu","Hotton","Houdeng-Goegnies","Houffalize","Housse","Houtain-le-Val","Houtaing","Houthalen","Houthem","Houthulst","Houtvenne","Hove","Huizingen","Huldenberg","Hulshout","Humbeek","Huy","Hyon","Ichtegem","Iddergem","Idegem","Impe","Incourt","Ingelmunster","Ingooigem","Isnes","Itegem","Itterbeek","Ittre","Ixelles-Elsene","Izegem","Izel","Jabbeke","Jambes","Jamioulx","Jauche","Jemappes","Jemelle","Jemeppe-sur-Meuse","Jemeppe-sur-Sambre","Jette","Jodoigne","Jumet","Jupille-sur-Meuse","Juprelle","Jurbise","Kachtem","Kain","Kalken","Kalmthout","Kampenhout","Kanegem","Kapelle-op-den-Bos","Kapellen","Kaprijke","Kasterlee","Kaulille","Keerbergen","Kemzeke","Kerkhove","Kerksken","Kermt","Kersbeek-Miskom","Kessel","Kessel-Lo","Kettenis","Kinrooi","Klein-Gelmen","Klemskerke","Knesselare","Knokke","Knokke-Heist","Koekelare","Koersel","Koksijde","Koningshooikt","Kontich","Korbeek-Dijle","Korbeek-Lo","Kortemark","Kortenaken","Kortenberg","Kortessem","Kortrijk","Kortrijk-Dutsel","Kozen","Kraainem","Kruibeke","Kruishoutem","Kuringen","Kuurne","Kwaadmechelen","La Calamine","La Hestre","La Hulpe","Laarne","Labuissiere","Laken","Lambermont","Lanaken","Landegem","Landelies","Landen","Langdorp","Langemark","Lanklaar","Latinne","Lauwe","Le Tilleul","Lebbeke","Lede","Ledeberg","Ledegem","Leefdaal","Leerbeek","Leernes","Leest","Leffinge","Leisele","Lembeek","Lendelede","Lennik","Leopoldsburg","Lessines","Letterhoutem","Leuven","Leuze","Leval-Trahegnies","Libramont","Lichtaart","Lichtervelde","Liedekerke","Lier","Ligny","Lille","Lillois-Witterzee","Limal","Limbourg","Limelette","Lincent","Linden","Linkebeek","Lint","Lippelo","Lisogne","Lissewege","Lives-sur-Meuse","Lixhe","Lobbes","Lochristi","Lodelinsart","Loenhout","Loker","Lokeren","Lommel","Loncin","Londerzeel","Lontzen","Loppem","Lot","Lotenhulle","Loupoigne","Louvain-la-Neuve","Louveigne","Lovendegem","Loverval","Lubbeek","Lummen","Luttre","Maaseik","Maasmechelen","Machelen","Magnee","Maisieres","Maldegem","Malderen","Malmedy","Malonne","Manage","Manhay","Marais","Marche-en-Famenne","Marche-lez-Ecaussinnes","Marchienne-au-Pont","Marchin","Marcinelle","Mariakerke","Mariekerke","Mariembourg","Marke","Markegem","Massemen","Maurage","Mechelen","Meensel-Kiezegem","Meerbeke","Meerhout","Meerlaar","Meerle","Meersel","Meeuwen","Meigem","Meise","Meldert","Melen","Melkwezer","Melle","Melsbroek","Melsele","Membach","Menen","Merchtem","Mere","Merelbeke","Merendree","Merksem","Merksplas","Mespelare","Messancy","Mettet","Meulebeke","Middelburg","Middelkerke","Minderhout","Modave","Moen","Moerbeke","Moerzeke","Moha","Mol","Molenbeek","Molenbeek-Saint-Jean","Molenstede","Momalle","Monceau-sur-Sambre","Mons","Mont-Saint-Guibert","Mont-Sainte-Aldegonde","Mont-sur-Marchienne","Montegnee","Montignies-lez-Lens","Montignies-sur-Sambre","Montzen","Moorsel","Moorslede","Morialme","Morkhoven","Morlanwelz-Mariemont","Mortsel","Mouscron","Muizen","Munsterbilzen","Naast","Nalinnes","Nameche","Namur","Nandrin","Natoye","Nazareth","Neder-Over-Heembeek","Nederbrakel","Nederhasselt","Neerharen","Neerijse","Neerlinter","Neerpelt","Nethen","Neuville-en-Condroz","Nevele","Niel","Nieuwenhove","Nieuwerkerken","Nieuwpoort","Nieuwrode","Nijlen","Nil Saint-Vincent","Nimy","Ninove","Nivelles","Nodebais","Nokere","Nossegem","Nouvelles","Nukerke","Obaix","Obourg","Oedelem","Oelegem","Oeselgem","Ohain","Ohey","Okegem","Olen","Olne","Onze-Lieve-Vrouw-Waver","Ooigem","Oordegem","Oostakker","Oosteeklo","Oostende","Oosterzele","Oostham","Oostkamp","Oostmalle","Oostrozebeke","Oostvleteren","Opbrakel","Opglabbeek","Opgrimbie","Ophain","Opitter","Opoeteren","Oppem","Oppuurs","Opwijk","Orbais","Orp-le-Grand","Ostend","Otegem","Othee","Ottignies","Oud-Heverlee","Oud-Turnhout","Oudegem","Oudenaarde","Oudenburg","Ougree","Oupeye","Outer","Outrijve","Overheide","Overijse","Overmere","Overpelt","Paal","Pamel","Parike","Park","Passendale","Peer","Pellenberg","Pepinster","Peronnes","Pervijze","Perwez","Petegem","Peutie","Pipaix","Pittem","Plainevaux","Plancenoit","Ploegsteert","Poederlee","Poelkapelle","Pollare","Pont-a-Celles","Pont-de-Loup","Poperinge","Poppel","Post","Presles","Profondeville","Pulderbos","Pulle","Putte","Puurs","Quaregnon","Quenast","Quevaucamps","Quievrain","Ramet","Ramsdonk","Ramsel","Ramskapelle","Rance","Ransart","Ranst","Ravels","Rebaix","Recht","Reet","Rekem","Rekkem","Relegem","Remersdaal","Remicourt","Reninge","Renlies","Ressaix","Ressegem","Retie","Retinne","Rhisnes","Richelle","Riemst","Rijkevorsel","Rijmenam","Rillaar","Rixensart","Rochefort","Rocourt","Rode","Roeselare","Roeulx","Romsee","Ronse","Rosieres","Rosmeer","Rotselaar","Roux","Ruddervoorde","Ruien","Ruisbroek","Ruiselede","Rumbeke","Rummen","Rumst","Sablon","Saint-Georges-sur-Meuse","Saint-Ghislain","Saint-Gilles","Saint-Jean-Geest","Saint-Josse-ten-Noode","Saint-Leger","Saint-Mard","Saint-Nicolas","Saint-Remy","Saint-Sauveur","Saint-Servais","Saint-Symphorien","Sainte-Ode","Saintes","Saive","Sankt Vith","Sart Melin","Sart-Dames-Avelines","Sart-en-Fagne","Sart-lez-Spa","Schaarbeek","Schaffen","Schalkhoven","Scheldewindeke","Schelle","Schellebelle","Schendelbeke","Schepdaal","Scherpenheuvel","Schilde","Schoonaarde","Schorisse","Schoten","Schriek","Schulen","Sclayn","Seilles","Seneffe","Seraing","Serskamp","Sijsele","Sinaai","Sint-Agatha-Berchem","Sint-Agatha-Rode","Sint-Amands","Sint-Amandsberg","Sint-Andries","Sint-Baafs-Vijve","Sint-Denijs-Westrem","Sint-Genesius-Rode","Sint-Gillis-bij-Dendermonde","Sint-Gillis-Waas","Sint-Katelijne-Waver","Sint-Kornelis-Horebeke","Sint-Lambrechts-Herk","Sint-Laureins","Sint-Lievens-Houtem","Sint-Maria-Latem","Sint-Martens-Latem","Sint-Michiels","Sint-Niklaas","Sint-Pauwels","Sint-Pieters op de Dijk","Sint-Pieters-Leeuw","Sint-Stevens-Woluwe","Sint-Truiden","Sirault","Sleidinge","Soignies","Sombreffe","Soumagne","Souvret","Spa","Sprimont","Stabroek","Staden","Stavelot","Steendorp","Steenokkerzeel","Stekene","Stembert","Stene","Ster","Sterrebeek","Stevoort","Stokkem","Stoumont","Stree","Strepy-Bracquegnies","Strombeek-Bever","Tamines","Temse","Teralfene","Terhagen","Ternat","Tertre","Tervuren","Tessenderlo","Testelt","Theux","Thimeon","Thimister","Thisnes","Thuin","Thulin","Thy-le-Chateau","Thynes","Tiegem","Tielt","Tienen","Tildonk","Tilff","Tilleur","Tisselt","Toernich","Tohogne","Tongeren","Tongerlo","Tongre-Notre-Dame","Torhout","Tournai","Transinne","Trazegnies","Tremelo","Trooz","Tubize","Turnhout","Uccle","Ulbeek","Ursel","Vance","Varsenare","Vaux","Vaux-sous-Chevremont","Vedrin","Veerle","Velaine-sur-Sambre","Velaines","Veldegem","Velm","Veltem-Beisem","Verlaine","Verrebroek","Verviers","Veurne","Viane","Vichte","Vielsalm","Viesville","Villers-la-Ville","Villers-le-Bouillet","Villers-sur-Semois","Vilvoorde","Vinderhoute","Virton","Vise","Vivegnis","Vladslo","Vlekkem","Vlezenbeek","Vliermaal","Vliermaalroot","Vlierzele","Vlissegem","Vollezele","Voormezele","Voroux-Goreux","Vorselaar","Vosselaar","Vossem","Vottem","Vremde","Waarloos","Waarschoot","Waasmunster","Wachtebeke","Wagnelee","Wakken","Waleffe Saint-Georges","Walhain","Walhorn","Wanfercee-Baulet","Wangenies","Wanne","Wanze","Warchin","Waregem","Waremme","Warneton","Warquignies","Warsage","Wasmes","Waterloo","Watermael-Boitsfort","Watervliet","Waudrez","Wavre","Ways","Wechelderzande","Weelde","Welkenraedt","Welle","Wellen","Wemmel","Wenduine","Wepion","Werchter","Werken","Wervik","Wespelaar","Westende","Westerlo","Westmalle","Westouter","Wetteren","Wevelgem","Wezemaal","Wezembeek-Oppem","Wichelen","Wiekevorst","Wielsbeke","Wierde","Wieze","Wijgmaal","Wijnegem","Willebroek","Wilrijk","Wilsele","Wingene","Winksele","Woesten","Wolfsdonk","Wolkrange","Woluwe-Saint-Lambert","Woluwe-Saint-Pierre - Sint-Pieters-Woluwe","Wolvertem","Wommelgem","Wondelgem","Wortegem","Wuustwezel","Xhendremael","Xhoris","Ypres","Yvoir","Zaffelare","Zandbergen","Zandhoven","Zarren","Zaventem","Zedelgem","Zeebrugge","Zele","Zellik","Zelzate","Zemst","Zeveneken","Zichem","Zingem","Zoersel","Zolder","Zomergem","Zonhoven","Zonnebeke","Zottegem","Zoutleeuw","Zuienkerke","Zulte","Zutendaal","Zwartenbroek","Zwevegem","Zwevezele","Zwijnaarde","Zwijndrecht"]},"BF":{"id":"BF","name":"Burkina Faso","timezones":["Africa/Abidjan"],"cities":[]},"BG":{"id":"BG","name":"Bulgaria","timezones":["Europe/Sofia"],"cities":["Akhtopol","Aksakovo","Aleksandriya","Alfatar","Anton","Antonovo","Ardino","Asenovgrad","Aytos","Babovo","Baltchik","Banite","Bankya","Bansko","Barutin","Batak","Belene","Belogradchik","Beloslav","Belovo","Berkovitsa","Bistritsa","Blagoevgrad","Boboshevo","Bobovdol","Borovan","Borovo","Botevgrad","Bratsigovo","Bregare","Bukovo","Burgas","Byala","Byala Slatina","Chakalarovo","Chernolik","Chernomorets","Cherven","Cherven Bryag","Chiprovtsi","Chirpan","Choba","Debelets","Devin","Dimitrovgrad","Dobrich","Dolna Banya","Dolna Mitropoliya","Dolna Oryakhovitsa","Dospat","Dragash Voyvoda","Draginovo","Dragizhevo","Dryanovo","Dulgopol","Dulovo","Dupnitsa","Elena","Elin Pelin","Elkhovo","Etropole","Gabrovo","Ganchovo","General-Toshevo","Glogovo","Godech","Gorna Oryakhovitsa","Gotse Delchev","Gulubovo","Gurkovo","Gurmazovo","Haskovo","Ikhtiman","Iskrets","Isperikh","Isperikhovo","Ivaylovgrad","Kableshkovo","Kamenovo","Kardzhali","Karlovo","Karnobat","Kavarna","Kazanlak","Kazashka Reka","Kharmanli","Khisarya","Knezha","Konush","Koprivets","Koprivlen","Kostenets","Kostievo","Kostinbrod","Kovachite","Kozloduy","Kran","Krichim","Krivodol","Krumovgrad","Krupnik","Kula","Kyustendil","Lom","Lovech","Lozno","Lukovit","Lyaskovets","Lyulyakovo","Madan","Malo Konare","Marikostinovo","Markovo","Mesta","Mezdra","Mikrevo","Moderno Predgradie","Momchilgrad","Montana","Moravka","Muglizh","Nesebar","Nikopol","Nova Zagora","Novi Iskur","Novi Pazar","Obzor","Omurtag","Orizovo","Orlovets","Oryakhovets","Oryakhovitsa","Ovoshtnik","Panagyurishte","Pavel Banya","Pavlikeni","Pazardzhik","Pchelishte","Pernik","Peshtera","Petrich","Pleven","Plovdiv","Poleto","Polski Trumbesh","Pomorie","Popovo","Pravets","Prespa","Provadiya","Radnevo","Raduil","Rakitovo","Rakovski","Ravda","Razgrad","Razlog","Rila","Rodopi","Rousse","Rozino","Rudozem","Ruen","Samokov","Samovodene","Samuil","Sandanski","Sandrovo","Septemvri","Sevlievo","Shabla","Shivachevo","Shumen","Silistra","Simeonovgrad","Simitli","Skravena","Slatina","Sliven","Slivnitsa","Smolyan","Smyadovo","Sofia","Sofronievo","Sokolets","Sopot","Sozopol","Sredets","Stamboliyski","Stara Zagora","Strazhitsa","Strelcha","Suedinenie","Svilengrad","Svishtov","Svoge","Targovishte","Tervel","Tochilari","Topoli","Topolovo","Troyan","Trustenik","Tryavna","Tutrakan","Varna","Veliko","Veliko Tarnovo","Velingrad","Vetren","Vidin","Vievo","Vlado Trichkov","Vrachesh","Vratsa","Yakoruda","Yambol","Zavet","Zlatitrap","Zlatograd"]},"BH":{"id":"BH","name":"Bahrain","timezones":["Asia/Qatar"],"cities":["Al Budayyi`","Al Hadd","Al Hamalah","Al Janabiyah","Al Markh","Al Muharraq","Bani Jamrah","Barbar","Jurdab","Madinat `Isa","Madinat Hamad","Manama","Oil City","Sanabis","Sanad","Sitrah","Tubli"]},"BI":{"id":"BI","name":"Burundi","timezones":["Africa/Maputo"],"cities":[]},"BJ":{"id":"BJ","name":"Benin","timezones":["Africa/Lagos"],"cities":[]},"BL":{"id":"BL","name":"St Barthelemy","timezones":["America/Port_of_Spain"],"cities":[]},"BM":{"id":"BM","name":"Bermuda","timezones":["Atlantic/Bermuda"],"cities":[]},"BN":{"id":"BN","name":"Brunei","timezones":["Asia/Brunei"],"cities":["Bandar Seri Begawan","Bangar","Kampong Jerudong","Kuala Balai","Kuala Belait","Panaga","Seria","Tutong"]},"BO":{"id":"BO","name":"Bolivia","timezones":["America/La_Paz"],"cities":["Anillo","Aroma","Bermejo","Caracasa","Cobija","Cochabamba","Cotoca","Cruz","Guayaramerin","La Paz","Oruro","Riberalta","Santa Cruz","Sucre","Tarija","Trinidad"]},"BQ":{"id":"BQ","name":"Caribbean Netherlands","timezones":["America/Curacao"],"cities":[]},"BR":{"id":"BR","name":"Brazil","timezones":["America/Noronha","America/Belem","America/Fortaleza","America/Recife","America/Araguaina","America/Maceio","America/Bahia","America/Sao_Paulo","America/Campo_Grande","America/Cuiaba","America/Santarem","America/Porto_Velho","America/Boa_Vista","America/Manaus","America/Eirunepe","America/Rio_Branco"],"cities":["Abadiania","Abaetetuba","Abelardo Luz","Abidos","Abrantes","Abreu","Abreu e Lima","Acarau","Acopiara","Acorizal","Acu","Acucena","Adamantina","Adustina","Afogados da Ingazeira","Afonso Claudio","Agrestina","Agua Boa","Agua Clara","Aguai","Aguanil","Aguas Claras","Aguas da Prata","Aguas de Chapeco","Aguas de Lindoia","Aguas de Sao Pedro","Aguas Lindas","Agudo","Agudos","Agulha","Alagoa Grande","Alagoa Nova","Alagoinha","Alagoinhas","Alambari","Aldeia","Alegre","Alegres","Alegrete","Alem Paraiba","Alfenas","Alfredo Chaves","Almeirim","Almirante Tamandare","Aloandia","Alta Floresta","Altamira","Altaneira","Alterosa","Altinho","Altinopolis","Alto","Alto Alegre","Alto do Rodrigues","Alto Paraiso de Goias","Alto Piquiri","Alto Santo","Altos","Alvares Machado","Alvorada","Alvorada do Sul","Amambai","Amaraji","Amarante","Amarante do Maranhao","Amazonas","America de Cima","America Dourada","Americana","Americo Brasiliense","Amparo","Anadia","Anajas","Ananindeua","Anchieta","Andarai","Andradas","Andradina","Andre","Andre da Rocha","Angatuba","Angical do Piaui","Angicos","Angra dos Reis","Anhembi","Anhumas","Antas","Antonina","Antonio Carlos","Antonio Prado","Aparecida","Aparecida do Rio Negro","Aperibe","Apiai","Apiuna","Apodi","Apora","Apucarana","Apuiares","Aquidaba","Aquidauana","Aquiraz","Aracai","Aracaju","Aracariguama","Aracas","Aracati","Aracatuba","Araci","Aracoiaba da Serra","Aracruz","Aracuai","Aragarcas","Araguari","Arandu","Arapiraca","Arapongas","Arapoti","Arapua","Araquari","Ararangua","Araraquara","Araras","Ararica","Araripina","Araruama","Araruna","Araujos","Arceburgo","Arcos","Arcoverde","Areado","Areal","Arealva","Areia Branca","Areial","Aricanduva","Ariquemes","Armacao de Buzios","Armazem","Aroeiras","Arraial","Arraial do Cabo","Arroio do Meio","Arroio do Silva","Arroio do Tigre","Arroio dos Ratos","Arroio Grande","Artur Nogueira","Ascurra","Assis","Assis Chateaubriand","Atibaia","Auriflama","Avanhandava","Avare","Azurita","Bady Bassitt","Baia da Traicao","Baiao","Bairro da Velha Central","Baixo Guandu","Balsa Nova","Balsamo","Balsas","Bambui","Banabuiu","Bananal","Bandeirantes","Bangu","Barao de Cocais","Barao de Cotegipe","Barao de Grajau","Barauna","Barbacena","Barbalha","Barbosa","Barcarena","Barra","Barra Bonita","Barra da Tijuca","Barra de Sao Miguel","Barra do Bugres","Barra do Corda","Barra do Jacare","Barra do Ribeiro","Barra Mansa","Barra Velha","Barracao","Barras","Barreiras","Barretos","Barrinha","Barro","Barrocas","Barueri","Batatais","Batista","Baturite","Bauru","Bayeux","Bebedouro","Beberibe","Bela Vista","Bela Vista de Goias","Bela Vista do Paraiso","Belem","Belem do Brejo do Cruz","Belford Roxo","Belo Horizonte","Belo Jardim","Benedito Novo","Benevides","Bento","Berilo","Bernardo","Bertioga","Betania","Betim","Bezerros","Bicas","Biguacu","Birigui","Biritiba Mirim","Biritinga","Bituruna","Blumenau","Boa Esperanca","Boa Ventura","Boa Vista","Boa Vista do Burica","Bocaiuva","Bocaiuva do Sul","Boituva","Bom Conselho","Bom Despacho","Bom Jardim","Bom Jardim de Minas","Bom Jesus","Bom Jesus da Lapa","Bom Jesus do Amparo","Bom Jesus do Itabapoana","Bom Jesus dos Perdoes","Bom Principio","Bom Retiro do Sul","Bombinhas","Bonfim","Bonito","Boqueirao","Boquim","Borda da Mata","Borrazopolis","Botafogo","Botucatu","Botupora","Botuvera","Braco do Norte","Braganca","Braganca Paulista","Branco","Bras","Brasa","Brasil","Brasilandia","Brasopolis","Brejetuba","Brejinho de Nazare","Brejo da Madre de Deus","Brejo Santo","Breves","Brochier","Brodosqui","Brotas","Brumadinho","Brumado","Brusque","Bueno Brandao","Buique","Buritama","Buriti","Buritizeiro","Butia","Buzios","Caapora","Caarapo","Cabedelo","Cabo de Santo Agostinho","Cabo Frio","Cabralia","Cabralia Paulista","Cabreuva","Cabrobo","Cacapava","Cacapava do Sul","Cacequi","Caceres","Cachoeira","Cachoeira do Sul","Cachoeira Grande","Cachoeira Paulista","Cachoeiras","Cachoeiras de Macacu","Cachoeirinha","Cachoeiro de Itapemirim","Cacimba de Dentro","Cacique Doble","Cacoal","Caete","Caetite","Cafarnaum","Cafelandia","Caiana","Caiaponia","Caibate","Caico","Caieiras","Caiua","Cajamar","Cajati","Cajazeiras","Cajobi","Cajuru","Calcado","Calcoene","Caldas","Caldas Novas","California","Camacari","Camamu","Camanducaia","Camaqua","Camaragibe","Cambe","Camboriu","Cambui","Cambuquira","Cameta","Campestre","Campina","Campina Grande","Campina Grande do Sul","Campinas","Campinas do Sul","Campinorte","Campo","Campo Alegre","Campo Bom","Campo Ere","Campo Formoso","Campo Grande","Campo Largo","Campo Magro","Campo Maior","Campo Mourao","Campo Novo","Campo Verde","Campos","Campos do Jordao","Campos dos Goytacazes","Campos Gerais","Campos Novos","Campos Sales","Canarana","Canas","Canavieiras","Candeal","Candeias","Candelaria","Candido Mota","Candoi","Canela","Canelinha","Cangucu","Canhotinho","Caninde","Caninde de Sao Francisco","Canoas","Canoinhas","Cansancao","Cantagalo","Cantanhede","Capanema","Capao Alto","Capao Bonito","Capao da Canoa","Capao do Leao","Caparao","Capela","Capela do Alto","Capelinha","Capetinga","Capinopolis","Capistrano","Capitao Poco","Capivari","Caputira","Caraa","Caraguatatuba","Carambei","Carangola","Carapebus","Carapicuiba","Caratinga","Caraubas","Carazinho","Cardeal da Silva","Cardoso","Cariacica","Carinhanha","Caripi","Carius","Carlos Barbosa","Carmo da Mata","Carmo do Cajuru","Carmo do Rio Claro","Carmopolis","Carmopolis de Minas","Carnaiba","Carolina","Carpina","Caruaru","Casa Nova","Casca","Cascavel","Casimiro de Abreu","Cassia","Cassilandia","Cassino","Castanhal","Castelo","Castro","Cataguases","Catalao","Catanduva","Catanduvas","Catarina","Catende","Catu","Caucaia","Caxambu","Caxias","Caxias do Sul","Ceara Mirim","Cedral","Cedro do Abaete","Ceilandia","Centenario do Sul","Central","Ceres","Cerqueira Cesar","Cerquilho","Cerro Azul","Cerro Branco","Cerro Grande","Cerro Largo","Cesario Lange","Ceu Azul","Cha Grande","Chapada","Chapadao","Chapadinha","Charqueada","Charqueadas","Chaval","Chavantes","Chopinzinho","Cianorte","Cicero Dantas","Cidade","Cidade de Deus","Cidade Nova","Cipotanea","Claro dos Pocoes","Claudio","Clementina","Clevelandia","Coari","Cocal","Cocalinho","Cocos","Coelho","Colatina","Colina","Colinas","Colombo","Colorado","Comodoro","Conceicao","Conceicao da Barra","Conceicao das Alagoas","Conceicao de Macabu","Conceicao do Araguaia","Conceicao do Coite","Conceicao do Mato Dentro","Conchal","Conchas","Concordia","Condado","Conde","Congonhas","Conselheiro Lafaiete","Contagem","Contenda","Convento da Penha","Cordeiro","Cordeiropolis","Cordilheira","Coreau","Coremas","Corguinho","Cornelio Procopio","Coroados","Coroas","Coroata","Coromandel","Coronel","Coronel Fabriciano","Correia Pinto","Correntina","Cortes","Corumba de Goias","Coruripe","Cosmopolis","Cosmorama","Cotia","Crateus","Crato","Cravinhos","Cristais","Cristalina","Cristiano Otoni","Cruz","Cruz Alta","Cruz das Almas","Cruzeiro","Cruzeiro da Fortaleza","Cruzeiro do Oeste","Cruzeiro do Sul","Cruzilia","Cubatao","Cuite","Cunha Pora","Cupira","Curimata","Curitiba","Curitibanos","Currais Novos","Cururupu","Curvelo","Delfinopolis","Descalvado","Descanso","Diadema","Diamantina","Diamantino","Dias","Dionisio Cerqueira","Divinopolis","Dix-sept Rosado","Dobrada","Dois Corregos","Dois Irmaos","Dois Vizinhos","Dom Feliciano","Dom Pedrito","Dom Silverio","Domingos Martins","Dores do Indaia","Dourado","Dourados","Doutor Camargo","Doutor Mauricio Cardoso","Dracena","Duartina","Duas Barras","Dumont","Duque de Caxias","Eldorado","Elias Fausto","Elisiario","Eloi Mendes","Embu","Embu Guacu","Encantado","Encruzilhada do Sul","Engenheiro Beltrao","Engenheiro Schmidt","Entre Rios","Entre Rios de Minas","Erechim","Erval Grande","Erval Velho","Ervalia","Escada","Esmeraldas","Espera Feliz","Esperanca","Esperantina","Espinosa","Espirito Santo","Espirito Santo do Pinhal","Espumoso","Estancia","Estancia Nova","Estancia Velha","Esteio","Estiva","Estreito","Estrela","Eugenio","Eugenopolis","Eusebio","Extrema","Extremoz","Exu","Farroupilha","Fartura","Fatima","Faxinal","Faxinal do Soturno","Faxinal dos Guedes","Fazenda Rio Grande","Feira de Santana","Feira Nova","Feliz","Fenix","Fernando Prestes","Fernandopolis","Ferraz de Vasconcelos","Flexeiras","Florania","Flores","Flores da Cunha","Floresta Azul","Floriano","Florinia","Formiga","Formosa","Forquilha","Forquilhinha","Fortaleza","Fortuna","Foz do Jordao","Fragoso","Franca","Francisco Beltrao","Francisco Morato","Francisco Sa","Franco da Rocha","Frederico Westphalen","Frei Paulo","Freitas","Fronteira","Frutal","Fundao","Gameleira","Gandu","Garanhuns","Garca","Gardenia Azul","Garibaldi","Garimpo Novo","Garopaba","Garuva","Gaspar","Gaviao Peixoto","General Carneiro","General Salgado","Getulio Vargas","Girau do Ponciano","Gloria","Gloria do Goita","Glorinha","Goiana","Goianapolis","Goianesia","Goianinha","Goianira","Goias","Gomes","Goncalves","Governador Valadares","Graca Aranha","Grajau","Gramado","Granito","Granja","Grao Mogol","Groairas","Guacui","Guai","Guaianases","Guaicara","Guaira","Guajeru","Guamare","Guanambi","Guanhaes","Guapiacu","Guapimirim","Guapo","Guapore","Guara","Guarabira","Guaraci","Guaraciaba","Guaragi","Guaramirim","Guaranesia","Guarani dOeste","Guaranta","Guarapari","Guarapuava","Guararapes","Guararema","Guaratingueta","Guaratuba","Guarei","Guariba","Guaruja","Guarulhos","Guaxupe","Gurjao","Gurupi","Heliodora","Heliopolis","Horizontina","Iacanga","Iacu","Ibaiti","Ibate","Ibatiba","Ibiaca","Ibicoara","Ibipeba","Ibipora","Ibirama","Ibirarema","Ibirataia","Ibirite","Ibiruba","Ibitinga","Ibiuna","Icapui","Icara","Icarai","Icem","Ico","Icoraci","Igaracu do Tiete","Igarapava","Igarape","Igarassu","Igarata","Igreja Nova","Igrejinha","Iguaba Grande","Iguai","Iguape","Iguaracu","Iguatu","Ijui","Ilha Solteira","Ilhabela","Ilhota","Imbituba","Imbituva","Imperatriz","Indaial","Indaiatuba","Indianopolis","Inga","Inhacora","Inhangapi","Inhauma","Inhumas","Inocencia","Inubia Paulista","Ipaba","Ipameri","Ipatinga","Ipaucu","Ipero","Ipeuna","Ipiau","Ipira","Ipiranga","Ipojuca","Ipora","Ipu","Ipua","Ipubi","Ipumirim","Iracema","Iracemapolis","Iraceminha","Irai","Iranduba","Irati","Irece","Iretama","Irupi","Itabaiana","Itabaianinha","Itabapoana","Itaberaba","Itabira","Itabirinha de Mantena","Itabirito","Itaborai","Itabuna","Itacare","Itaete","Itagi","Itagiba","Itaguacu","Itaguai","Itaguatins","Itaipava","Itaipu","Itaitinga","Itaituba","Itajobi","Itajuba","Itajuipe","Italva","Itamaraca","Itamarati","Itambaraca","Itambe","Itamogi","Itamonte","Itanhaem","Itanhandu","Itanhomi","Itaocara","Itapaci","Itapagipe","Itaparica","Itape","Itapecerica","Itapecerica da Serra","Itapecuru Mirim","Itapejara","Itapema","Itaperuna","Itapetinga","Itapetininga","Itapeva","Itapevi","Itapicuru","Itapipoca","Itapira","Itapiranga","Itapissuma","Itapixuna","Itapo","Itapolis","Itaporanga","Itapua","Itapuranga","Itaquaquecetuba","Itaqui","Itarantim","Itarare","Itatiaia","Itatiba","Itatinga","Itatira","Itau de Minas","Itauna","Itinga da Serra","Itirapina","Itiuba","Itobi","Itororo","Itu","Itubera","Ituiutaba","Itumbiara","Ituporanga","Iturama","Ituverava","Iuna","Ivaipora","Ivoti","Jaboatao dos Guararapes","Jabora","Jaborandi","Jaboticabal","Jaboticatubas","Jacarau","Jacarepagua","Jacarezinho","Jaci","Jaciara","Jacobina","Jacuizinho","Jacupiranga","Jacutinga","Jaguapita","Jaguaquara","Jaguarao","Jaguaras","Jaguariaiva","Jaguaribe","Jaguaripe","Jaguariuna","Jaguaruana","Jaguaruna","Jaiba","Jales","Jampruca","Janauba","Jandaia do Sul","Jandira","Japaratinga","Japeri","Japira","Jardim Alegre","Jardim de Piranhas","Jardinopolis","Jarinu","Jaru","Jatai","Jataizinho","Jequitinhonha","Jerico","Jeronimo Monteiro","Jesuania","Jetiba","Ji Parana","Jiquirica","Joacaba","Joanopolis","Joao Camara","Joao Lisboa","Joao Monlevade","Joao Neiva","Joao Pinheiro","Joaquim","Joaquim Tavora","Joinville","Jose Boiteux","Jose Bonifacio","Jose de Freitas","Juatuba","Juazeiro","Juazeiro do Norte","Jucara","Jucurutu","Juiz de Fora","Julio de Castilhos","Julio Mesquita","Jumirim","Jundiai do Sul","Junqueiro","Junqueiropolis","Juquia","Juquitiba","Juripiranga","Juru","Juruaia","Juruena","Juruti","Jussara","Jussari","Ladario","Lagarto","Lages","Lagoa","Lagoa da Canoa","Lagoa da Prata","Lagoa do Carro","Lagoa dos Gatos","Lagoa Salgada","Lagoa Santa","Lagoa Seca","Lagoa Vermelha","Laguna","Laguna Carapa","Lajeado","Lajinha","Lambari","Lapa","Laranjal Paulista","Laranjeiras","Laranjeiras do Sul","Lauro","Lavinia","Lavras","Lavras da Mangabeira","Lavras do Sul","Lavrinhas","Lebon Regis","Leme","Lencois","Lencois Paulista","Leopoldina","Liberdade","Lima Campos","Limeira","Limoeiro","Limoeiro do Norte","Linhares","Lins","Loanda","Londrina","Lontra","Lorena","Louveira","Lucena","Luis Antonio","Luis Correia","Lumiar","Luminarias","Luz","Luzerna","Luziania","Macaiba","Macaparana","Macatuba","Macau","Macaubas","Macedonia","Machadinho","Machado","Machados","Macuco","Madre de Deus","Mafra","Mage","Mairi","Mairinque","Malacacheta","Mamanguape","Mambore","Mamonas","Manacapuru","Manaus","Mandaguacu","Mandaguari","Mandirituba","Manga","Mangabeira","Mangaratiba","Mangueirinha","Manhuacu","Manhumirim","Mantena","Mantenopolis","Mar de Espanha","Maracaju","Maracana","Maracanau","Maragogipe","Maraial","Maranguape","Marataizes","Marau","Maravilha","Marcelino Ramos","Marcelino Vieira","Marco","Marcolandia","Marechal Candido Rondon","Marechal Deodoro","Maria da Fe","Marialva","Mariana","Marica","Marilandia","Mariluz","Marituba","Marques","Martinopolis","Maruim","Marumbi","Marzagao","Massape","Massaranduba","Matao","Matelandia","Mateus Leme","Matina","Matinhos","Matipo","Mato Grosso","Matozinhos","Matutina","Maua","Maxaranguape","Medeiros Neto","Medianeira","Meier","Mendes","Mendes Pimentel","Mendonca","Mesquita","Messias","Miguel Pereira","Miguelopolis","Milagres","Minas","Mineiros","Mineiros do Tiete","Miracatu","Miracema","Miracema do Tocantins","Miraima","Miranda","Mirandopolis","Mirassol","Mirim Doce","Mirinzal","Missao Velha","Mococa","Moema","Mogeiro","Mogi das Cruzes","Mogi Mirim","Mogi-Gaucu","Mongagua","Monte Alegre","Monte Alto","Monte Aprazivel","Monte Azul","Monte Azul Paulista","Monte Belo","Monte Carmelo","Monte Dourado","Monte Mor","Monte Santo","Monte Siao","Monteiro","Monteiro Lobato","Montenegro","Montes Altos","Montes Claros","Montividiu","Morada Nova","Moreno","Morretes","Morrinhos","Morro Agudo","Morro da Fumaca","Morro de Sao Paulo","Morro do Chapeu","Morro Reuter","Morungaba","Mossoro","Mostardas","Mucuri","Muliterno","Munhoz","Muniz Ferreira","Muniz Freire","Muqui","Muritiba","Mutum","Muzambinho","Nanuque","Nao Me Toque","Narandiba","Natal","Natercia","Navegantes","Navirai","Nazare","Nazare da Mata","Nazare Paulista","Neopolis","Neropolis","Nilo Pecanha","Nilopolis","Niquelandia","Niteroi","Nobres","Norte","Nossa Senhora","Nossa Senhora da Gloria","Nossa Senhora Das Gracas","Nossa Senhora do Socorro","Nova","Nova Alianca","Nova Araca","Nova Aurora","Nova Bassano","Nova Brescia","Nova Canaa","Nova Cruz","Nova Esperanca","Nova Friburgo","Nova Independencia","Nova Itarana","Nova Lima","Nova Londrina","Nova Odessa","Nova Palma","Nova Petropolis","Nova Ponte","Nova Prata","Nova Resende","Nova Serrana","Nova Timboteua","Nova Trento","Nova Venecia","Novo Hamburgo","Novo Horizonte","Novo Mundo","Novo Oriente","Novo Recreio","Nucleo Bandeirante","Nunes Freire","Nuporanga","Ocara","Oeiras","Olimpia","Olinda","Oliveira","Oratorios","Orlandia","Orleans","Orobo","Osasco","Osorio","Otacilio Costa","Ouricangas","Ouricuri","Ourinhos","Ouro Branco","Ouro Fino","Ouro Preto","Ouro Preto do Oeste","Ouro Verde","Ouvidor","Pacaembu","Pacatuba","Pachecos","Padre","Paicandu","Palestina","Palhoca","Palma","Palmares","Palmares do Sul","Palmas","Palmeira","Palmeira das Missoes","Palmeira dos Indios","Palmeiras de Goias","Palmelo","Palmital","Palmitinho","Palmitos","Palotina","Panambi","Pancas","Panorama","Pao de Acucar","Papagaios","Para de Minas","Paracambi","Paracuru","Paragominas","Paraguacu","Paraguacu Paulista","Parai","Paraiba do Sul","Paraibano","Paraibuna","Paraipaba","Paraiso","Paraiso do Tocantins","Paraisopolis","Paraitinga","Parana","Paranaiba","Paranapanema","Paranavai","Paranoa","Paraopeba","Parapeuna","Paraty","Parelhas","Pariquera Acu","Parnaiba","Parnamirim","Parobe","Passo Fundo","Passos","Pastos Bons","Pato Branco","Patos","Patos de Minas","Patrocinio","Patrocinio Paulista","Pau Brasil","Pau dos Ferros","Pauini","Pauliceia","Paulinia","Paulista","Paulo Afonso","Paulo Jacinto","Paulo Lopes","Paverama","Peabiru","Pecem","Pederneiras","Pedra Bonita","Pedra Grande","Pedranopolis","Pedreira","Pedro Afonso","Pedro Avelino","Pedro de Toledo","Pedro Leopoldo","Pelotas","Pena","Penapolis","Pendencias","Penedo","Penha","Perdigao","Perdoes","Pereira Barreto","Pereiro","Peruibe","Pesqueira","Petrolina","Piabeta","Picada","Picos","Picui","Piedade","Piedade do Rio Grande","Piedade dos Gerais","Pien","Pilao Arcado","Pilar do Sul","Pimenta","Pimenta Bueno","Pindamonhangaba","Pindobacu","Pindoretama","Pinhais","Pinhalao","Pinhalzinho","Pinheiral","Pinhoes","Piquet Carneiro","Piracaia","Piracanjuba","Piracema","Piracicaba","Pirai","Pirai do Sul","Piraju","Pirajuba","Pirajui","Pirangi","Pirapora do Bom Jesus","Pirapozinho","Piraquara","Pirassununga","Piratininga","Piritiba","Pitanga","Pitangueiras","Pitangui","Piuma","Planalto","Platina","Poa","Poco Branco","Poco das Antas","Poco Verde","Pojuca","Pombal","Pomerode","Pompeia","Pompeu","Pongai","Ponta Grossa","Ponta Pora","Pontal","Pontal do Parana","Pontalina","Ponte de Itabapoana","Ponte Nova","Ponte Serrada","Pontes e Lacerda","Porangatu","Porecatu","Portao","Porteira do Pinhal","Porto","Porto Alegre","Porto Amazonas","Porto Belo","Porto Esperidiao","Porto Feliz","Porto Ferreira","Porto Grande","Porto Nacional","Porto Real","Porto Sao Jose Velho","Porto Seguro","Porto Uniao","Porto Velho","Posse","Posto Fiscal Rolim de Moura","Pote","Potirendaba","Pouso Alegre","Pradopolis","Praia Grande","Prata","Pratania","Pratapolis","Presidente Bernardes","Presidente Dutra","Presidente Epitacio","Presidente Getulio","Presidente Kennedy","Presidente Medici","Presidente Olegario","Presidente Prudente","Presidente Venceslau","Primavera","Primeiro de Maio","Progresso","Promissao","Propria","Prudentopolis","Putinga","Puxinana","Quarai","Quata","Quatigua","Quatis","Quatro Barras","Quatro Pontes","Quebrangulo","Queimadas","Queimados","Querencia","Querencia do Norte","Quilombo","Quipapa","Quirinopolis","Quissama","Quitandinha","Quixada","Quixeramobim","Quixere","Rafard","Rancharia","Rancho Queimado","Raposa (1)","Raposos","Raul Soares","Realeza","Reboucas","Recanto","Recife","Redencao","Reduto","Registro","Remigio","Renascenca","Repartimento","Resende","Resende Costa","Restinga","Restinga Seca","Riachao do Jacuipe","Riacho das Almas","Riacho Fundo","Rialma","Ribas do Rio Pardo","Ribeira do Pombal","Ribeirao","Ribeirao Bonito","Ribeirao Corrente","Ribeirao do Pinhal","Ribeirao Pires","Rio Acima","Rio Azul","Rio Bananal","Rio Bonito","Rio Branco","Rio Branco do Sul","Rio Brilhante","Rio Casca","Rio Claro","Rio das Ostras","Rio das Pedras","Rio de Janeiro","Rio do Pires","Rio do Sul","Rio dos Cedros","Rio Formoso","Rio Grande","Rio Grande da Serra","Rio Largo","Rio Manso","Rio Negrinho","Rio Negro","Rio Novo","Rio Novo do Sul","Rio Paranaiba","Rio Pardo","Rio Pardo de Minas","Rio Piracicaba","Rio Tinto","Rio Verde de Mato Grosso","Roca Sales","Rodeio Bonito","Rodeiro","Rodrigues","Rolandia","Rolante","Ronda Alta","Rondon","Rosalia","Rosario","Rosario do Sul","Roseira","Rubiataba","Rubim","Russas","Sabara","Sabaudia","Sabinopolis","Sacramento","Sales","Sales Oliveira","Salesopolis","Salgado","Salgueiro","Salinas da Margarida","Salto","Salto de Pirapora","Salto Grande","Salvador","Samambaia","Sampaio Correia","Sananduva","Sangao","Sanharo","Santa","Santa Adelia","Santa Barbara","Santa Barbara do Sul","Santa Branca","Santa Cruz","Santa Cruz Cabralia","Santa Cruz da Baixa Verde","Santa Cruz do Capibaribe","Santa Cruz do Rio Pardo","Santa Cruz do Sul","Santa Fe","Santa Fe do Sul","Santa Gertrudes","Santa Helena","Santa Ines","Santa Isabel","Santa Isabel do Ivai","Santa Isabel do Para","Santa Leopoldina","Santa Lucia","Santa Luzia","Santa Maria","Santa Maria da Vitoria","Santa Maria de Itabira","Santa Rita","Santa Rita do Passa Quatro","Santa Rita do Sapucai","Santa Rosa","Santa Teresa","Santa Teresinha","Santa Terezinha","Santana","Santana da Vargem","Santana de Parnaiba","Santana do Cariri","Santana do Ipanema","Santana do Livramento","Santana do Matos","Santana do Paraiso","Santarem Novo","Santiago","Santo","Santo Aleixo","Santo Amaro","Santo Amaro da Imperatriz","Santo Anastacio","Santo Antonio","Santo Antonio da Patrulha","Santo Antonio da Platina","Santo Antonio de Jesus","Santo Antonio de Lisboa","Santo Antonio de Padua","Santo Antonio de Posse","Santo Antonio do Amparo","Santo Antonio do Caiua","Santo Antonio do Grama","Santo Antonio do Jardim","Santo Antonio do Leverger","Santo Antonio do Monte","Santo Antonio do Pinhal","Santo Antonio do Retiro","Santo Estevao","Santo Expedito","Santo Inacio","Santos","Santos Dumont","Sao Bento","Sao Bento do Sapucai","Sao Bernardo","Sao Caetano","Sao Caetano do Sul","Sao Carlos","Sao Cristovao","Sao Domingos","Sao Felipe","Sao Felix","Sao Fidelis","Sao Francisco","Sao Francisco de Paula","Sao Francisco do Conde","Sao Francisco do Sul","Sao Gabriel","Sao Gabriel da Cachoeira","Sao Geraldo do Araguaia","Sao Goncalo","Sao Goncalo do Amarante","Sao Goncalo do Para","Sao Goncalo do Sapucai","Sao Goncalo dos Campos","Sao Gotardo","Sao Jeronimo","Sao Joao","Sao Joao Batista","Sao Joao da Barra","Sao Joao da Boa Vista","Sao Joao de Meriti","Sao Joao de Pirabas","Sao Joao do Paraiso","Sao Joao Evangelista","Sao Joao Nepomuceno","Sao Joaquim","Sao Joaquim da Barra","Sao Joaquim de Bicas","Sao Joaquim do Monte","Sao Jose","Sao Jose da Barra","Sao Jose da Laje","Sao Jose de Mipibu","Sao Jose de Piranhas","Sao Jose de Ribamar","Sao Jose do Calcado","Sao Jose do Cedro","Sao Jose do Egito","Sao Jose do Goiabal","Sao Jose do Inhacora","Sao Jose do Ouro","Sao Jose do Rio Pardo","Sao Jose do Rio Preto","Sao Lourenco da Mata","Sao Lourenco da Serra","Sao Lourenco do Sul","Sao Lourenco dOeste","Sao Luis","Sao Luis de Montes Belos","Sao Luis do Paraitinga","Sao Luiz Gonzaga","Sao Manoel","Sao Manuel","Sao Marcos","Sao Miguel","Sao Miguel Arcanjo","Sao Miguel do Araguaia","Sao Miguel do Iguacu","Sao Miguel dos Campos","Sao Paulo","Sao Paulo do Potengi","Sao Pedro","Sao Pedro da Aldeia","Sao Pedro do Ivai","Sao Pedro do Sul","Sao Pedro dos Ferros","Sao Roque","Sao Salvador","Sao Sebastiao","Sao Sebastiao da Amoreira","Sao Sebastiao da Grama","Sao Sebastiao do Cai","Sao Sebastiao do Maranhao","Sao Sebastiao do Paraiso","Sao Sepe","Sao Simao","Sao Tome","Sao Vicente","Sao Vicente de Paula","Sape","Sapeacu","Sapiranga","Sapucaia","Sapucaia do Sul","Saquarema","Sarandi","Sarapui","Sardoa","Sarzedo","Satuba","Saudades","Schroeder","Seabra","Seara","Sebastianopolis do Sul","Seberi","Sede Nova","Sem Peixe","Senador Canedo","Senhor do Bonfim","Serafina","Seropedica","Serra","Serra Azul","Serra Negra","Serra Preta","Serra Talhada","Serrana","Serrania","Serrinha","Serro","Sertania","Sertanopolis","Sertao","Sertaozinho","Sete Lagoas","Sidrolandia","Silva Jardim","Silveiras","Simao Dias","Simao Pereira","Simoes","Simplicio Mendes","Siqueira Campos","Sitio Figueira","Sitio Novo","Sobradinho","Sobral","Socorro","Soledade","Sombrio","Sorocaba","Sorriso","Sousa","Stio Ouro Fino","Sulina","Sumare","Suzano","Tabatinga","Tabira","Taboao da Serra","Tabuleiro do Norte","Taguatinga","Taiacu","Taiobeiras","Taiuva","Tamandare","Tambau","Tamboril","Tamoios","Tanabi","Tangua","Tanque Novo","Tapejara","Tapira","Tapirai","Taquara","Taquaral","Taquarana","Taquari","Taquaritinga","Tarumirim","Tatuamunha","Taua","Taubate","Teixeira","Telemaco Borba","Tenente Ananias","Tenorio","Teodoro Sampaio","Terenos","Teresina","Teresopolis","Terra Boa","Terra Nova","Terra Rica","Terra Roxa","Teutonia","Tiangua","Tibagi","Tibau","Tiete","Tijuca","Tijucas","Timbauba","Timbe","Timbo","Timon","Timoteo","Tiradentes","Tobias Barreto","Tocantins","Toledo","Tomar do Geru","Tome Acu","Toritama","Torres","Touros","Tramandai","Tremembe","Tres Barras","Tres Cachoeiras","Tres Coroas","Tres Marias","Tres Passos","Tres Pontas","Tres Rios","Trindade","Triunfo","Tubarao","Tucum","Tucunduva","Tucurui","Tuiuti","Tumiritinga","Tupa","Tupaciguara","Tupanatinga","Tupancireta","Tuparendi","Tupi Paulista","Turmalina","Turvo","Uaua","Uba","Ubaira","Ubaitaba","Ubarana","Ubata","Ubatuba","Uberaba","Uberlandia","Uchoa","Uibai","Uirauna","Umbauba","Umbuzeiro","Umirim","Umuarama","Unai","Uniao da Vitoria","Urai","Urania","Urubici","Uruburetama","Urucania","Urucuca","Uruguaiana","Urupes","Urussanga","Vacaria","Valenca","Valente","Valentim Gentil","Valerio","Valinhos","Valparaiso","Vargem Alta","Vargem Grande do Sul","Vargem Grande Paulista","Varginha","Varjota","Varzea","Varzea Paulista","Varzelandia","Vassouras","Velha","Venancio Aires","Venda Nova","Vera Cruz","Veranopolis","Vespasiano","Vespasiano Correa","Viana","Vicencia","Vicente","Vicosa","Vicosa do Ceara","Videira","Vila Maria","Vila Muriqui","Vila Rica","Vila Velha","Vilar dos Teles","Vilhena","Vinhedo","Virgem da Lapa","Virginia","Virginopolis","Virmond","Visconde do Rio Branco","Vista Alegre do Alto","Vitoria de Santo Antao","Vitorino Freire","Volta Grande","Volta Redonda","Votorantim","Votuporanga","Wenceslau Braz","Witmarsum","Xanxere","Xavantina","Xaxim"]},"BS":{"id":"BS","name":"Bahamas","timezones":["America/Nassau"],"cities":["Andros Town","Dunmore Town","Freeport","Marsh Harbour","Nassau","Palmetto Point","Spanish Wells"]},"BT":{"id":"BT","name":"Bhutan","timezones":["Asia/Thimphu"],"cities":[]},"BW":{"id":"BW","name":"Botswana","timezones":["Africa/Maputo"],"cities":["Francistown","Gaborone","Orapa","Serowe","Village"]},"BY":{"id":"BY","name":"Belarus","timezones":["Europe/Minsk"],"cities":["Baranovichi","Borisov","Brest","Dzyarzhynsk","Horki","Hrodna","Lahoysk","Lida","Lyakhovichi","Lyaskavichy","Mazyr","Minsk","Mogilev","Navapolatsk","Orsha","Pinsk","Polatsk","Radoshkovichi","Shklow","Vitebsk","Zaslawye","Zhodzina"]},"BZ":{"id":"BZ","name":"Belize","timezones":["America/Belize"],"cities":["Belize City","Belmopan","Benque Viejo del Carmen","Freetown Sibun","Ladyville","San Ignacio","San Pedro Town"]},"CA":{"id":"CA","name":"Canada","timezones":["America/St_Johns","America/Halifax","America/Glace_Bay","America/Moncton","America/Goose_Bay","America/Blanc-Sablon","America/Toronto","America/Nipigon","America/Thunder_Bay","America/Iqaluit","America/Pangnirtung","America/Resolute","America/Atikokan","America/Rankin_Inlet","America/Winnipeg","America/Rainy_River","America/Regina","America/Swift_Current","America/Edmonton","America/Cambridge_Bay","America/Yellowknife","America/Inuvik","America/Creston","America/Dawson_Creek","America/Fort_Nelson","America/Vancouver","America/Whitehorse","America/Dawson"],"cities":["100 Mile House","Abbey","Abbotsford","Acadia Valley","Acme","Acton","Acton Vale","Agassiz","Agincourt","Ailsa Craig","Airdrie","Ajax","Aklavik","Alameda","Albanel","Alberton","Aldergrove","Alert Bay","Alexander","Alexandria","Alfred","Allan","Allardville","Allenford","Alliston","Alma","Almonte","Alton","Altona","Alvinston","Amherst","Amherstburg","Amos","Amqui","Ancaster","Andrew","Ange-Gardien","Angliers","Angus","Annapolis Royal","Antigonish","Apohaqui","Apple Hill","Apsley","Arborfield","Arborg","Arcadia","Arcola","Arctic Bay","Ardmore","Ardrossan","Arelee","Arichat","Arkona","Armagh","Armstrong","Arnprior","Arthabaska","Arthur","Arundel","Arva","Arviat","Asbestos","Ascot Corner","Ashcroft","Ashmont","Ashville","Assiniboia","Aston-Jonction","Athabasca","Athens","Atikameg","Atikokan","Atlin","Attawapiskat","Atwood","Audet","Aurora","Austin","Authier","Avonmore","Aylesford","Aylmer","Aylsham","Ayr","Ayton","Baddeck","Baden","Baie Verte","Baie-Comeau","Baie-Des-Sables","Baie-du-Febvre","Baie-Saint-Paul","Baie-Sainte-Catherine","Bala","Balcarres","Baldonnel","Baldur","Baltimore","Bamfield","Bancroft","Banff","Barkerville","Barnaby River","Barons","Barraute","Barrhead","Barrie","Barriere","Barrington","Barrington Passage","Bashaw","Bassano","Bath","Bathurst","Batiscan","Battleford","Bay Bulls","Bay de Verde","Bay Roberts","Bayfield","Beachburg","Beaconsfield","Beamsville","Bear River","Bearn","Bearskin Lake","Beauceville","Beauharnois","Beaumont","Beauport","Beaupre","Beausejour","Beauval","Beaux-Rivages--Lac-des-Ecorces--Val-Barrette","Beaver Bank","Beaver Crossing","Beaverlodge","Beaverton","Becancour","Bedford","Beeton","Begin","Beiseker","Bell Island","Bella Bella","Belle River","Belleville","Bellevue","Beloeil","Belwood","Bentley","Berry Mills","Berthier-Sur-Mer","Berthierville","Berwick","Berwyn","Bethune","Betsiamites","Bic","Biencourt","Bienfait","Big River","Big Valley","Biggar","Binscarth","Birch Hills","Birchy Bay","Birtle","Black Creek","Black Diamond","Blackfalds","Blackie","Blacks Harbour","Blackville","Blaine Lake","Blainville","Blairmore","Blandford","Blenheim","Blind River","Bloomfield","Blue River","Bluewater","Bobcaygeon","Bois-des-Filion","Boisbriand","Boischatel","Boissevain","Bolton","Bonaventure","Bonne Bay","Bonnyville","Bonsecours","Bonshaw","Borden","Borden-Carleton","Boswell","Boucherville","Bouctouche","Bourget","Bow Island","Bowden","Bowmanville","Bowser","Boyle","Bracebridge","Brackendale","Bradford","Bramalea","Brampton","Brandon","Brantford","Brechin","Bredenbury","Brentwood Bay","Breslau","Breton","Bridge Lake","Bridgetown","Bridgewater","Brigham","Brighton","Brigus","Britt","Broadview","Brochet","Brockville","Brome","Bromhead","Bromont","Brookfield","Brooklyn","Brooks","Brossard","Bruno","Bryson","Buckhorn","Buckingham","Buffalo Narrows","Burgeo","Burgessville","Burin","Burlington","Burnaby","Burns Lake","Burnside","Cabano","Cabri","Cache Creek","Calder","Caledon","Caledonia","Calgary","Calixa-Lavallee","Callander","Calmar","Cambridge","Cambridge Bay","Camlachie","Campbell River","Campbellford","Campbellton","Campbellville","Camrose","Canal Flats","Candiac","Canfield","Canim Lake","Canmore","Canning","Cannington","Canoe Narrows","Canora","Canso","Canterbury","Canwood","Canyon","Cap-aux-Meules","Cap-Chat","Cap-Saint-Ignace","Cap-Sante","Cape Dorset","Caraquet","Carberry","Carbonear","Cardigan","Cardinal","Cardston","Carignan","Carleton Place","Carleton-sur-Mer","Carlisle","Carlyle","Carmacks","Carman","Carmel","Carnduff","Caroline","Caronport","Carp","Carrot River","Carrying Place","Carseland","Carstairs","Carters Cove","Cartier","Cartwright","Casimir","Casselman","Castle Bay","Castlegar","Cat Lake","Causapscal","Cavendish","Cayley","Cayuga","Cedar Valley","Central Bedeque","Centreville","Ceylon","Chalk River","Chambly","Champlain","Chandler","Chapais","Chapel Arm","Chapleau","Charlemagne","Charlesbourg","Charlie Lake","Charlottetown","Charny","Chase","Chateau-Richer","Chateauguay","Chatham","Chatsworth","Cheapside","Chelmsford","Chelsea","Chemainus","Cheneville","Cherry Grove","Chertsey","Chesley","Chester","Chestermere","Chesterville","Cheticamp","Chibougamau","Chicoutimi","Chilliwack","Chipman","Church Point","Churchill","Churchville","Chute-aux-Outardes","Circonscription electorale de Jacques-Cartier","Clair","Clairmont","Claremont","Clarence","Clarence-Rockland","Clarenville","Clarenville-Shoal Harbour","Claresholm","Clarke City","Clarkson","Clearwater","Clementsvale","Clermont","Cleveland","Clifford","Clinton","Clive","Clyde River","Coal Harbour","Coaldale","Coaticook","Cobble Hill","Cobden","Coboconk","Cobourg","Coburg","Cochrane","Colborne","Cold Lake","Coldstream","Coldwater","Coleman","Coleraine","Coleville","Colinet","Colliers","Collingwood","Colonsay","Colville Lake","Comber","Comox","Compton","Conception Bay South","Concord","Conestogo","Coniston","Conquest","Consort","Contrecoeur","Cookshire-Eaton","Copper Cliff","Coquitlam","Corbyville","Corner Brook","Cornwall","Cornwallis","Cote-Saint-Luc","Cottam","Courtenay","Courtland","Courtright","Coutts","Cow Head","Cowansville","Cowichan Bay","Cowley","Crabtree","Craik","Cranberry","Cranberry Portage","Cranbrook","Crapaud","Creemore","Creston","Crofton","Cromer","Cross Lake","Crossfield","Cudworth","Cumberland","Cumberland Bay","Cumberland House","Cupar","Cut Knife","Czar","Dalhousie","Dalmeny","Danville","Dartmouth","Dashwood","Dauphin","Daveluyville","Davidson","Dawson City","Dawson Creek","Dawson Settlement","Daysland","Debden","Debert","DeBolt","Deep River","Deer Lake","Delaware","Delaware West","Delburne","Delhi","Deline","Delisle","Delson","Delta","Denfield","Denman Island","Deroche","Desbiens","Deschaillons-sur-Saint-Laurent","Deschambault","Deseronto","Deux-Montagnes","Devon","Didsbury","Dieppe","Digby","Dinsmore","Disraeli","Dixville","Doaktown","Dog Creek","Dolbeau-Mistassini","Dollard-Des Ormeaux","Domain","Dominion City","Domremy","Don Mills","Donnacona","Donnelly","Dorchester","Dorion-Gardens","Dorset","Dorval","Dover","Downsview","Drayton","Drayton Valley","Dresden","Drumbo","Drumheller","Drummondville","Dryden","Dublin","Duchess","Duck Lake","Dudswell","Dufresne","Dugald","Duhamel","Duncan","Dundalk","Dundas","Dundurn","Dunham","Dunnville","Dunsford","Dupuy","Durham","Eaglesham","Earlton","East Angus","East Broughton","East Chezzetcook","East Coulee","East Margaree","Eastern Passage","Eastman","Eastport","Eatonville","Echo Bay","Eckville","Economy","Edam","Eden","Edgerton","Edgewood","Edmonton","Edmundston","Edson","Eganville","Elbow","Elgin","Elk Point","Elliot Lake","Elliston","Elma","Elmira","Elmsdale","Elmvale","Elora","Elrose","Embrun","Emerald","Emerald Junction","Emo","Empress","Emsdale","Enderby","Enfield","Englehart","Enterprise","Entwistle","Eriksdale","Erin","Espanola","Esprit-Saint","Essex","Esterhazy","Estevan","Eston","Etobicoke","Eureka","Everett","Exeter","Fabreville","Fairmont Hot Springs","Fairview, Alberta","Farnham","Fenelon Falls","Fergus","Ferintosh","Ferme-Neuve","Fermeuse","Fermont","Fernie","Field","Fillmore","Finch","Flat River","Flesherton","Flin Flon","Florenceville-Bristol","Foam Lake","Fogo","Fonthill","Foremost","Forest","Forestburg","Forestville","Fort Albany","Fort Erie","Fort Frances","Fort Good Hope","Fort Hope","Fort Kent","Fort Macleod","Fort McMurray","Fort McPherson","Fort Nelson","Fort Saskatchewan","Fort Severn","Fort Simpson","Fort Smith","Fort St. James","Fort St. John","Fort Vermilion","Fort-Coulonge","Fortierville","Fortune","Fox Creek","Foxtrap","Foymount","Francis","Frankford","Fraser Lake","Fredericton","Fredericton Junction","Frelighsburg","Frobisher","Fruitvale","Gabriola","Gadsby","Galahad","Gambo","Gananoque","Gander","Gander Bay","Ganges","Garden River","Garibaldi","Garibaldi Highlands","Garnish","Garrick","Garson","Gatineau","Gem","Georgetown","Geraldton","Gibsons","Gilbert Plains","Gillam","Gimli","Girouxville","Glace Bay","Gladstone","Glaslyn","Gleichen","Glen Robertson","Glencoe","Glendon","Glentworth","Glenwood","Gloucester","Glovertown","Goderich","Gogama","Gold Bridge","Golden","Golden Lake","Gore","Gore Bay","Granby","Grand Bend","Grand Falls","Grand Falls-Windsor","Grand Forks","Grand Rapids","Grand Valley","Grand-Remous","Grand-Saint-Esprit","Grande Cache","Grande Prairie","Grande-Anse","Grande-Riviere","Grandora","Granton","Granum","Granville Ferry","Grasmere","Gravelbourg","Gravenhurst","Gray Creek","Great Village","Greater Sudbury","Greely","Greenfield Park","Greenspond","Greenwood","Grenfell","Grenville","Gretna","Grimsby","Grimshaw","Grindrod","Griswold","Gronlid","Grono Road","Guelph","Guigues","Gull Lake","Guysborough","Hafford","Hagensborg","Hagersville","Haileybury","Halfmoon Bay","Haliburton","Halifax","Ham-Nord","Hamilton","Hamiota","Hampden","Hampton","Hanley","Hanna","Hanover","Hantsport","Happy Valley-Goose Bay","Harbour Grace","Harbour Main","Hardisty","Hare Bay","Harriston","Harrow","Hartland","Hartley Bay","Hartney","Harvey","Hastings","Havelock","Havre Boucher","Havre-Aubert","Havre-Saint-Pierre","Hawkesbury","Hawkestone Beach","Hay Lakes","Hay River","Hazelton","Head of Jeddore","Hearst","Hebertville","Hebron","Hemmingford","Henryville","Hensall","Herbert","Heron Bay","Hespeler","High Level","High Prairie","High River","Hillsburgh","Hinton","Hobbema","Holden","Holman","Holyrood","Honeymoon Bay","Hope","Hornepayne","Houston","Howick","Howley","Hubbards","Hudson","Hudson Bay","Hull","Humboldt","Hunter River","Huntingdon","Huntsville","Huron East","Hythe","Ignace","Ilderton","Ile-a-la-Crosse","Indian Head","Ingersoll","Ingleside","Inglewood","Inglis","Ingonish","Innisfail","Innisfil","Inukjuak","Inuvik","Invermere","Inverness","Inwood","Iona","Iqaluit","Irma","Iroquois","Iroquois Falls","Irricana","Islington","Italy Cross","Ituna","Ivujivik","Jacksons","Jasper","Jenner","Jerseyville","Joliette","Jonquiere","Jordan","Jordan Falls","Kagawong","Kamloops","Kamouraska","Kamsack","Kanata","Kangiqsujuaq","Kangirsuk","Kapuskasing","Kars","Kaslo","Kazabazua","Kedgwick","Keene","Keewatin","Kelowna","Kelvington","Kemptville","Kenora","Kensington","Kent Bridge","Kentville","Kerrobert","Kerwood","Keswick","Keswick Beach","Kettleby","Killarney","Kilworthy","Kimberley","Kimmirut","Kincardine","Kindersley","King City","Kingsey Falls","Kingston","Kingsville","Kinistino","Kinuso","Kippen","Kirkland","Kirkland Lake","Kirkton","Kisbey","Kispiox","Kitchener","Kitimat","Kitscoty","Kitwanga","Klemtu","Knowlton","Kohler","Komoka","Kugaaruk","Kugluktuk","Kuujjuaq","Kuujjuarapik","La Baie","La Conception","La Corey","La Durantaye","La Guadeloupe","La Loche","La Malbaie","La Morandiere","La Patrie","La Pocatiere","La Prairie","La Presentation","La Ronge","La Salle","La Sarre","La Tabatiere","La Tuque","La Visitation","Labelle","Labrador City","Lac du Bonnet","Lac La Biche","Lac-aux-Sables","Lac-Drolet","Lac-Megantic","Lachenaie","Lachine","Lachute","Lacolle","Lacombe","Ladysmith","Lafleche","LaHave","Lake Cowichan","Lake Lenore","Lake Louise","Lakeburn","Lakefield","Lambton","Lamont","Lampman","Lanark","Lancaster","Lancaster Park","Landrienne","Lang","Langdon","Langenburg","Langham","Langley","Lanigan","Lanoraie","Lantzville","Lasalle","Lashburn","Laurentia Beach","Laurier-Station","Laval","Lavaltrie","Laverlochere","Lavillette","Lawrencetown","Leader","Leamington","Leduc","Lefroy","Legal","Lemberg","Leonard","Lery","Les Cedres","Les Coteaux","Les Escoumins","Les Mechins","Leslieville","Lethbridge","Levack","Levis","Lewisporte","Lillooet","Limoges","Lindsay","Lipton","Listowel","Little Current","Little Narrows","Lively","Liverpool","Lloydminster","Logan Lake","London","Londonderry","Long Sault","Longueuil","Lorraine","Lotbiniere","Lougheed","Louisbourg","Louiseville","Lourdes","Lower Island Cove","Lucan","Lucknow","Lucky Lake","Lumby","Lumsden","Lunenburg","Luseland","Luskville","Lyn","Lyster","Lytton","Maberly","Mabou","Macamic","MacGregor","Mackenzie","Macklin","MacTier","Madoc","Magog","Magrath","Mahone Bay","Maidstone","Malagawatch","Malakwa","Malartic","Mallaig","Malton","Mandeville","Manitou","Manitouwadge","Maniwaki","Mankota","Mannville","Manor","Manotick Station","Manseau","Mansonville","Maple","Maple Creek","Maple Ridge","Mar","Marathon","Marbleton","Marchand","Margaree Valley","Margaretsville","Maria","Marieville","Markdale","Markham","Markstay","Marmora","Martinville","Marwayne","Maryfield","Marystown","Marysville","Mascouche","Maskinonge","Masset","Massey","Masson-Angers","Massueville","Matagami","Matane","Matheson","Maxville","Mayne","McBride","McCreary","McGregor","McLennan","McMasterville","Meadow Lake","Meaford","Medicine Hat","Melbourne Ridge","Melfort","Melita","Melocheville","Melville","Memphremagog","Memramcook","Mercier","Merlin","Merrickville","Merritt","Merville","Messines","Metabetchouan-Lac-a-la-Croix","Meteghan","Meteghan River","Metis-sur-Mer","Miami","Midale","Middle Arm","Middle Musquodoboit","Middleton","Midhurst","Midland","Milden","Mildmay","Milford","Milford Station","Milk River","Mill Village","Millarville","Millbrook","Millet","Millville","Milton","Milverton","Minden","Minnedosa","Minto","Mira Gut","Mirabel","Miramichi","Miscouche","Mission","Mississauga","Mistatim","Mitchell","Moberly Lake","Mobile","Moffat","Moncton","Mont-Joli","Mont-Laurier","Mont-Royal","Mont-Saint-Gregoire","Mont-Saint-Hilaire","Mont-Saint-Michel","Mont-Tremblant","Montague","Montebello","Montmagny","Montmartre","Montreal","Montreal East","Moonbeam","Mooretown","Moose Creek","Moose Jaw","Moose Lake","Moosehorn","Moosomin","Moosonee","Moraviantown","Morden","Morell","Morewood","Morinville","Morrin","Morris","Morrisburg","Mortlach","Mount Brydges","Mount Elgin","Mount Forest","Mount Pearl","Mount Stewart","Mount Uniacke","Mountain View","Muirkirk","Mulgrave","Mundare","Munson","Munster","Murdochville","Murray Harbour","Murray River","Musquodoboit Harbour","Myrnam","Nackawic","Naicam","Nakina","Nakusp","Nampa","Namur","Nanaimo","Nanoose Bay","Nantes","Nanton","Napanee","Napierville","Nauwigewauk","Neepawa","Neguac","Neilburg","Nelson","Nepean","Neudorf","Neuville","New Aiyansh","New Carlisle","New Denver","New Dundee","New Glasgow","New Hamburg","New Harbour","New Liskeard","New Ross","New Waterford","New Westminster","New-Richmond","New-Wes-Valley","Newburgh","Newcastle Creek","Newcastle Village","Newdale","Newmarket","Newport","Newton","Newtown","Niagara","Niagara Falls","Niagara-on-the-Lake","Nicolet","Nipawin","Nipigon","Nisku","Niverville","Nobleford","Nobleton","Nokomis","Nominingue","Norfolk County","Norman Wells","Normandin","Norquay","North Battleford","North Bay","North Delta","North Hatley","North Lunenburg","North Perth","North Portal","North Russell","North Rustico","North Saanich","North Star","North Sydney","North Vancouver","North York","Norval","Norway House","Norwich","Norwood","Notre-Dame-de-Lourdes","Notre-Dame-du-Bon-Conseil","Notre-Dame-du-Mont-Carmel","Notre-Dame-du-Nord","Notre-Dame-du-Portage","Nouvelle","Noyan","Oak Lake","Oak Point","Oakville","Obedjiwan","Odessa","Ogoki","Ohsweken","Oil Springs","Oka","Okanagan Centre","Okotoks","Old Perlican","Oldcastle","Olds","Oliver","Omemee","Omerville","Onanole","Onion Lake","Onoway","Orangeville","Orillia","Orleans","Ormstown","Oromocto","Orono","Orton","Oshawa","Osoyoos","Ottawa","Otter Lake","Otterburn Park","Otterburne","Outlook","Owen Sound","Oxbow","Oxdrift","Oxford","Oxford House","Oyama","Pain Court","Paisley","Pakenham","Palmarolle","Palmerston","Papineauville","Paradise Cove","Paradise Valley","Parham","Paris","Parisville","Parkhill","Parksville","Parry Sound","Parson","Pasadena","Pascal","Paspebiac","Pass Lake","Paulatuk","Peace River","Peachland","Pefferlaw","Pelly","Pemberton","Pembroke","Penetanguishene","Penhold","Pennfield","Penobsquis","Penticton","Penzance","Perth","Perth-Andover","Petawawa","Peterborough","Petherton","Petit-de-Grat","Petitcodiac","Petite-Riviere-Saint-Francois","Petrolia","Pickering","Picton","Pictou","Pierreville","Pierson","Pikangikum","Pilot Butte","Pilot Mound","Pinantan Lake","Pinawa","Pincher Creek","Pincourt","Pine Falls","Piney","Pitt Meadows","Placentia","Plamondon","Plantagenet Station","Plaster Rock","Plessisville","Plum Coulee","Plumas","Plympton","Point Edward","Pointe-a-la-Croix","Pointe-aux-Trembles","Pointe-Calumet","Pointe-Claire","Pointe-Fortune","Pointe-Lebel","Pointe-Verte","Ponoka","Pont-Rouge","Pont-Viau","Pontypool","Poplar Hill","Port Alberni","Port Alice","Port au Choix","Port au Port","Port Burwell","Port Clements","Port Colborne","Port Coquitlam","Port Credit","Port Dover","Port Edward","Port Elgin","Port Hardy","Port Hawkesbury","Port Hope","Port Lorne","Port McNeill","Port McNicoll","Port Medway","Port Moody","Port Morien","Port Perry","Port Renfrew","Port Royal","Port Saunders","Port Stanley","Port-Cartier","Port-Daniel","Portage","Portage la Prairie","Portage-du-Fort","Porters Lake","Portneuf","Portugal Cove","Potter","Pouce Coupe","Pouch Cove","Powassan","Powell River","Preeceville","Prescott","Price","Priceville","Prince","Prince Albert","Prince George","Prince Rupert","Princeton","Princeville","Pritchard","Prospect","Provost","Pugwash","Pukatawagan","Puslinch","Puvirnituq","Pynns","Qualicum Beach","Quaqtaq","Quathiaski Cove","Quebec","Queen Charlotte","Quesnel","Quill Lake","Quispamsis","Quyon","Racine","Radisson","Radville","Rainbow Lake","Raleigh","Ramea","Rankin Inlet","Rapid City","Rawdon","Raymond","Raymore","Red Deer","Red Lake","Red Rock","Redcliff","Redvers","Redwater","Regina","Rencontre East","Renfrew","Renous","Repentigny","Revelstoke","Rexdale","Rhein","Richibucto","Richmond","Richmond Hill","Ridgetown","Ridgeway","Rigaud","Rimbey","Rimouski","Ripley","Ripon","Ripples","River Hebert","River John","Rivers","Riverside-Albert","Riverton","Riverview","Riviere-Beaudette","Riviere-Bleue","Riviere-Ouelle","Riviere-Rouge","Riviere-Saint-Paul","Roberts Creek","Roberval","Roblin","Rocanville","Rockland","Rockville","Rockwood","Rocky Mountain House","Roddickton","Rogersville","Roland","Rosalind","Rosedale","Rosemary","Rosemere","Roseneath","Rosetown","Rossburn","Rossland","Rossport","Rosthern","Rothesay","Rougemont","Rouleau","Rouyn-Noranda","Roxboro","Roxton Falls","Roxton Pond","Rumsey","Russell","Rycroft","Saanichton","Sable River","Sabrevois","Sackville","Saguenay","Saint Andrews","Saint Etienne-De-Lauzon","Saint John","Saint Romuald","Saint-Adalbert","Saint-Adelphe","Saint-Agapit","Saint-Aime-du-Lac-des-Iles","Saint-Alban","Saint-Alexis-des-Monts","Saint-Ambroise","Saint-Anaclet-de-Lessard","Saint-Andre","Saint-Andre-Avellin","Saint-Anicet","Saint-Anselme","Saint-Antoine-de-Tilly","Saint-Antoine-sur-Richelieu","Saint-Antonin","Saint-Apollinaire","Saint-Arsene","Saint-Aubert","Saint-Augustin","Saint-Augustin-de-Desmaures","Saint-Barnabe-Sud","Saint-Barthelemy","Saint-Basile","Saint-Basile-le-Grand","Saint-Benjamin","Saint-Bruno","Saint-Bruno-de-Montarville","Saint-Camille","Saint-Casimir","Saint-Cesaire","Saint-Charles-de-Bellechasse","Saint-Charles-sur-Richelieu","Saint-Clement","Saint-Colomban","Saint-Come","Saint-Come--Liniere","Saint-Cyprien","Saint-Cyrille-de-Wendover","Saint-Damase","Saint-Denis","Saint-Dominique","Saint-Donat","Saint-Elie","Saint-Elzear","Saint-Etienne-des-Gres","Saint-Eusebe","Saint-Eustache","Saint-Fabien","Saint-Fabien-de-Panet","Saint-Faustin--Lac-Carre","Saint-Felicien","Saint-Felix-de-Kingsey","Saint-Felix-de-Valois","Saint-Ferdinand","Saint-Ferreol-les-Neiges","Saint-Flavien","Saint-Francois-du-Lac","Saint-Frederic","Saint-Gabriel","Saint-Gabriel-de-Valcartier","Saint-Gedeon","Saint-Georges","Saint-Georges-de-Windsor","Saint-Germain-de-Grantham","Saint-Gilles","Saint-Godefroi","Saint-Guillaume","Saint-Henri","Saint-Hilaire","Saint-Honore-de-Temiscouata","Saint-Hubert-de-Riviere-du-Loup","Saint-Hugues","Saint-Hyacinthe","Saint-Irenee","Saint-Isidore","Saint-Jacques","Saint-Jean-de-Dieu","Saint-Jean-de-Matha","Saint-Jean-Port-Joli","Saint-Jean-sur-Richelieu","Saint-Jerome","Saint-Joachim","Saint-Joachim-de-Shefford","Saint-Joseph-de-Beauce","Saint-Jude","Saint-Lambert","Saint-Lazare-de-Bellechasse","Saint-Leon-de-Standon","Saint-Leonard","Saint-Liboire","Saint-Lin","Saint-Lin-Laurentides","Saint-Louis de Kent","Saint-Louis-de-Gonzague","Saint-Luc","Saint-Ludger","Saint-Malachie","Saint-Marc-de-Figuery","Saint-Marc-des-Carrieres","Saint-Marc-sur-Richelieu","Saint-Mathieu","Saint-Maurice","Saint-Michel","Saint-Michel-de-Bellechasse","Saint-Michel-des-Saints","Saint-Nazaire","Saint-Odilon-de-Cranbourne","Saint-Pacome","Saint-Pamphile","Saint-Pascal","Saint-Paul","Saint-Paul-de-la-Croix","Saint-Paulin","Saint-Philemon","Saint-Philippe","Saint-Philippe-de-Neri","Saint-Pie","Saint-Pierre","Saint-Pierre-de-Broughton","Saint-Pierre-les-Becquets","Saint-Placide","Saint-Polycarpe","Saint-Prosper","Saint-Quentin","Saint-Raphael","Saint-Raymond","Saint-Remi","Saint-Roch","Saint-Roch-de-Richelieu","Saint-Roch-des-Aulnaies","Saint-Sauveur","Saint-Sebastien","Saint-Severe","Saint-Simon-de-Rimouski","Saint-Stanislas","Saint-Stanislas-de-Kostka","Saint-Sylvere","Saint-Sylvestre","Saint-Telesphore","Saint-Thomas","Saint-Tite","Saint-Ubalde","Saint-Ulric","Saint-Urbain","Saint-Urbain-Premier","Saint-Vallier","Saint-Venant-de-Paquette","Saint-Victor","Saint-Wenceslas","Saint-Zacharie","Saint-Zenon","Saint-Zotique","Sainte-Adele","Sainte-Agathe-des-Monts","Sainte-Angele-de-Premont","Sainte-Anne-de-Beaupre","Sainte-Anne-de-Bellevue","Sainte-Anne-de-la-Perade","Sainte-Anne-des-Monts","Sainte-Anne-du-Lac","Sainte-Brigitte-des-Saults","Sainte-Catherine","Sainte-Cecile-de-Masham","Sainte-Cecile-de-Whitton","Sainte-Claire","Sainte-Clotilde-de-Horton","Sainte-Croix","Sainte-Famille","Sainte-Foy","Sainte-Gertrude","Sainte-Helene-de-Bagot","Sainte-Helene-de-Breakeyville","Sainte-Julie","Sainte-Julienne","Sainte-Justine","Sainte-Marcelline-de-Kildare","Sainte-Marguerite","Sainte-Marie","Sainte-Marthe","Sainte-Marthe-sur-le-Lac","Sainte-Martine","Sainte-Melanie","Sainte-Monique","Sainte-Perpetue","Sainte-Thecle","Sainte-Therese","Salaberry-de-Valleyfield","Salisbury","Salmo","Salmon Arm","Salmon River","Sandy Bay","Sandy Lake","Sanikiluaq","Sardis","Sarnia","Saskatoon","Saulnierville","Sault Ste. Marie","Savona","Sawyerville","Sayabec","Sayward","Scarborough","Schefferville","Schomberg","Schreiber","Scotland","Scotsburn","Scotstown","Scott","Scoudouc","Seaforth","Searchmont","Sechelt","Seldom-Little Seldom","Selkirk","Senneterre","Senneville","Sept-Iles","Seton Portage","Severn Bridge","Sexsmith","Shamattawa","Shanklin","Shannon","Shannonville","Sharbot Lake","Shaunavon","Shawinigan","Shawinigan-Sud","Shawnigan Lake","Shawville","Shediac","Sheho","Shelburne","Shellbrook","Sherbrooke","Sherrington","Sherwood Park","Shigawake","Shoal Lake","Shubenacadie","Sicamous","Sidney","Sillery","Silton","Simcoe","Sioux Lookout","Skidegate","Slave Lake","Slocan","Smithers","Smiths Falls","Smithville","Smoky Lake","Smooth Rock Falls","Snow Lake","Sointula","Sombra","Sooke","Sorel","Sorel-Tracy","Sorrento","Souris","South Augusta","South Gower","South Indian Lake","South Lancaster","South Mountain","South Porcupine","South River","South Slocan","Southend Reindeer","Southey","Spanish","Sparta","Spencerville","Sperling","Spillimacheen","Spirit River","Spiritwood","Spring Hill","Springdale","Springfield","Springhill","Spruce Grove","Spy Hill","Squamish","St-Hubert","St-Lazare","St-Timothee","St. Albert","St. Andrews","St. Anthony","St. Brieux","St. Catharines","St. Jacobs","St. Louis","St. Marys","St. Paul","St. Peters Bay","St. Stephen","St. Thomas","St. Walburg","Stanbridge East","Standard","Stanley Bridge, Hope River, Bayview, Cavendish and North Rustico","Star City","Stayner","Steinbach","Stella","Stellarton","Stephenville","Stephenville Crossing","Stettler","Stevensville","Stewiacke","Stirling","Stittsville","Stoneham","Stonewall","Stoney Creek","Stony Mountain","Stony Plain","Stouffville","Stoughton","Strasbourg","Stratford","Strathmore","Strathroy","Streetsville","Sturgeon Falls","Sturgis","Summerland","Summerside","Sunderland","Sundridge","Surrey","Sussex","Sutton","Swan River","Swastika","Swift Current","Sydenham","Sydney","Sydney Mines","Sylvan Lake","Taber","Tadoussac","Tahsis","Takla Landing","Tappen","Taschereau","Tasiujaq","Tatamagouche","Tavistock","Taylor","Tecumseh","Teeswater","Temiscaming","Tennion","Terrace","Terrace Bay","Terre Noire","Terrebonne","Teulon","Thamesford","Thamesville","The Pas","Thedford","Theodore","Theresa","Thetford-Mines","Thompson","Thorhild","Thornbury","Thorndale","Thornhill","Thorold","Three Hills","Three Mile Plains","Thunder Bay","Thurso","Tilbury","Tilley","Tillsonburg","Timberlea","Timmins","Tisdale","Tlell","Tofield","Tofino","Tompkins","Torbay","Toronto","Torrington","Tottenham","Tracadie","Trail","Treherne","Trenton","Tring-Jonction","Trochu","Trois Pistoles","Trout Creek","Trout River","Troy","Truro","Tsawwassen","Tuktoyaktuk","Tumbler Ridge","Turner Valley","Turtleford","Tusket","Tweed","Twillingate","Two Hills","Tyndall","Ucluelet","Union Bay","Unionville","Unity","Upper Island Cove","Upton","Utterson","Uxbridge","Val-Brillant","Val-David","Val-des-Monts","Val-Morin","Valcourt","Valemount","Vallee-Jonction","Valley","Valleyview","Van Anda","Vancouver","Vanderhoof","Vankleek Hill","Varennes","Vaudreuil-Dorion","Vaughan","Vauxhall","Vegreville","Vercheres","Verdun","Vermilion","Verner","Vernon","Vernon Bridge","Victoria","Victoria Cove","Victoria Harbour","Victoriaville","Vieux-Saint-Laurent","Viking","Villa Marie","Ville-Marie","Vineland Station","Virden","Viscount","Vonda","Vulcan","Wabana","Wabigoon","Wabush","Wadena","Wainfleet","Wainwright","Wakaw","Wakefield","Waldeck","Waldheim","Walkerton","Wallace","Wallaceburg","Warkworth","Warman","Warner","Warsaw","Warwick","Wasaga Beach","Washago","Waterdown","Waterford","Waterloo","Waterville","Watford","Watrous","Watson","Watson Lake","Waubaushene","Wawa","Waweig","Wawota","Weedon","Weir","Weldon","Welland","Wellesley","Wellington","Wembley","Wemindji","West Bay","West Chezzetcook","West Hill","West Lake","West Osgoode","Westbank","Western Bay","Westlock","Westmount","Weston","Westport","Westree","Westville","Wetaskiwin","Weyburn","Wheatley","Whistler Village","Whitby","White City","White Fox","White River","White Rock","Whitecourt","Whitehorse","Whitemouth","Whites Lake","Whitney","Whycocomagh","Wiarton","Wickham","Wilcox","Wildwood","Wilkie","Williams Lake","Williamsburg","Willingdon","Willow Bunch","Willowdale","Willowvale","Winchester","Windermere","Windham Centre","Windsor","Winfield","Wingham","Winkler","Winnipeg","Winnipegosis","Wiseton","Wishart","Witless Bay","Wittenburg","Wolfville","Wolseley","Wood Mountain","Woodbridge","Woodlands","Woodridge","Woodstock","Worsley","Wrentham","Wright-Gracefield-Northfield","Wymark","Wynyard","Wyoming","Yahk","Yamachiche","Yamaska","Yarker","Yarmouth","Yellow Grass","Yellowknife","York","Yorkton","Youbou","Young","Youngstown"]},"CC":{"id":"CC","name":"Cocos (Keeling) Islands","timezones":["Indian/Cocos"],"cities":[]},"CD":{"id":"CD","name":"Congo (Dem. Rep.)","timezones":["Africa/Maputo","Africa/Lagos"],"cities":[]},"CF":{"id":"CF","name":"Central African Rep.","timezones":["Africa/Lagos"],"cities":[]},"CG":{"id":"CG","name":"Congo (Rep.)","timezones":["Africa/Lagos"],"cities":[]},"CH":{"id":"CH","name":"Switzerland","timezones":["Europe/Zurich"],"cities":["Aadorf","Aarau","Aarberg","Aarburg","Abtwil","Adelboden","Adligenswil","Adliswil","Aesch","Aeschau","Aeschlen ob Gunten","Aettenschwil","Aeugst am Albis","Affoltern am Albis","Agno","Agra","Aigle","Airolo","Alberswil","Albligen","Alchenstorf","Allaman","Allschwil","Alpnach","Alt-Bachs","Altdorf","Altendorf","Altenrhein","Alterswil","Altishofen","Altnau","Altstatten","Amden","Amriswil","Amsoldingen","Andermatt","Andwil","Anieres","Appenzell","Apples","Apro","Arbaz","Arbedo","Arbon","Arcegno","Ardon","Arisdorf","Aristau","Arlesheim","Arni","Arogno","Arosa","Arth","Arzier","Arzo","Ascona","Assens","Attalens","Attinghausen","Attiswil","Au","Aubonne","Auenstein","Augst","Ausser-Dinhard","Autigny","Auvernier","Auw","Avenches","Avry","Ayent","Ayer","Baar","Bach","Bachenbulach","Bad Ragaz","Bad Zurzach","Baden","Balerna","Balgach","Ballwil","Balsthal","Balterswil","Banco","Bangerten","Bannwil","Barbereche","Baretswil","Bariswil","Basadingen","Basel","Basse-Nendaz","Bassecourt","Bassersdorf","Batterkinden","Baulmes","Bauma","Bavois","Bazenheid","Beckenried","Begnins","Beinwil","Belfaux","Bellerive","Bellevue","Bellinzona","Bellmund","Belmont-sur-Lausanne","Belp","Benken","Berg","Berikon","Beringen","Berlikon","Bern","Bern / Liebefeld","Berneck","Bernex","Beromuenster","Bettingen","Bettlach","Beuson","Bevaix","Bevilard","Bex","Biasca","Biberist","Biel-Benken","Biel/Bienne","Biere","Bigenthal","Bigorio","Bilten","Binningen","Bioggio","Birmensdorf","Birmenstorf","Birr","Birsfelden","Bissegg","Bissone","Bitsch","Blonay","Blumenstein","Bogis-Bossey","Boll","Bolligen","Bonaduz","Bonigen","Bonnefontaine","Bonstetten","Borex","Bosingen","Bottens","Bottenwil","Bottighofen","Bottmingen","Boudry","Bouveret","Bramois","Breitenbach","Bremgarten","Brenzikofen","Brienz","Brig","Brislach","Brissago","Bristen","Brittnau","Broc","Bronschhofen","Brugg","Brunnen","Brusino Arsizio","Brutten","Bruttisellen","Bubendorf","Bubikon","Buch","Buchberg","Buchrain","Buchs","Buchs / Buchs (Dorf)","Buetschwil","Buix","Bulach","Bulle","Buochs","Buonas","Burchen","Buren an der Aare","Buren nid dem Bach","Burgdorf","Burglen","Bursins","Busserach","Bussigny","Busswil","Buttes","Buttisholz","Butzberg","Buus","Cadempino","Cadenazzo","Cadro","Camorino","Campfer","Canobbio","Capolago","Carouge","Cartigny","Caslano","Castione","Cazis","Celerina","Celigny","Cernier","Chalais","Cham","Chambesy","Chamoson","Champagne","Champex","Champsec","Chancy","Chapelle","Chardonne","Charmey","Charrat-les-Chenes","Chatel-Saint-Denis","Chatelaine","Chavannes","Chavannes de Bogis","Chavannes-les-Forts","Chavornay","Cheiry","Chene-Bougeries","Chene-Bourg","Chene-Paquier","Cheseaux-sur-Lausanne","Chesieres","Chexbres","Cheyres","Chez-le-Bart","Chiasso","Chippis","Chur","Claro","Coeuve","Cointrin","Collombey","Colombier","Concise","Confignon","Conthey","Contone","Coppet","Corcelles","Cordast","Corgemont","Corminboeuf","Cornaux","Corsier","Cortaillod","Cossonay","Cottens","Courfaivre","Courgenay","Courrendlin","Courroux","Court","Courtedoux","Courtelary","Courtemaiche","Courtepin","Courtetelle","Courtion","Couvet","Crassier","Cremines","Cressier","Crissier","Cudrefin","Cugnasco","Cugy","Cully","Dachsen","Daettlikon","Dagmersellen","Daillens","Dallenwil","Daniken","Dardagny","Dattwil","Davos","Davos Dorf","Davos Platz","Degersheim","Deitingen","Densbueren","Derendingen","Diegten","Dielsdorf","Diepoldsau","Diessbach","Diessenhofen","Dietikon","Doettingen","Domat","Dombresson","Domdidier","Dompierre","Dornach","Dottikon","Dozwil","Dubendorf","Durnten","Durrenasch","Ebikon","Ebnat-Kappel","Ecublens","Ecuvillens","Effretikon","Egerkingen","Egg","Eggenwil","Eggersriet","Eggiwil","Eglisau","Egliswil","Egnach","Eich","Eichberg","Eiken","Einigen","Einsiedeln","Elgg","Ellikon an der Thur","Elsau-Raeterschen","Embrach","Emmen","Emmenbruecke","Emmetten","Endingen","Engelberg","Ennenda","Enney","Entlebuch","Epalinges","Epautheyres","Ependes","Erde","Erlach","Erlen","Erlenbach","Ermatingen","Erschwil","Ersigen","Erstfeld","Eschenbach","Eschlikon","Escholzmatt","Essertines-sur-Rolle","Estavayer-le-Lac","Ettingen","Euthal","Evilard","Evionnaz","Eysins","Fahrwangen","Fallanden","Faoug","Fehraltorf","Felben","Feldbach","Feldbrunnen","Feldmeilen","Felsberg","Felsenau","Ferden","Ferenbalm","Feuerthalen","Feusisberg","Finhaut","Fischenthal","Fischingen","Flaach","Flamatt","Flawil","Fleurier","Flims","Fluehli","Flueli","Flums","Flurlingen","Fontainemelon","Forel","Founex","Fraubrunnen","Frauenfeld","Freidorf","Freienbach","Frenkendorf","Fribourg","Frick","Froideville","Frutigen","Fulenbach","Full","Fullinsdorf","Fully","Furstenaubruck","Gachlingen","Gais","Gampel","Gampelen","Gandria","Ganterschwil","Gebenstorf","Gelfingen","Gelterkinden","Genestrerio","Geneva","Gerlafingen","Gerlikon","Gersau","Gerzensee","Gettnau","Geuensee","Gimel","Gingins","Gipf-Oberfrick","Giswil","Giubiasco","Givrins","Gland","Glaris","Glarus","Glattburg","Glattfelden","Glion","Glis","Gnosca","Goldach","Goldau","Goldiwil","Gommiswald","Gonten","Gontenschwil","Gordevio","Gordola","Goslikon","Gossau","Gottlieben","Grabs","Graenichen","Grancy","Grandcour","Grandson","Grandval","Grandvillard","Granges","Granges-pres-Sion","Gravesano","Greifensee","Grellingen","Grenchen","Greppen","Grimentz","Grimisuat","Grindelwald","Grolley","Grone","Grono","Grossandelfingen","Grosswangen","Grueningen","Grund","Gryon","Gstaad","Gumligen","Gummenen","Gunten","Gunzgen","Guttingen","Gwatt","Habkern","Habsburg","Hagenbuch","Hagendorf","Hagglingen","Hagneck","Haldenstein","Hasle","Hauptwil","Hausen","Hausen am Albis / Hausen (Dorf)","Hauterive","Hauteville","Heerbrugg","Heiden","Heimberg","Heimiswil","Heitenried","Hellbuehl","Hemmental","Henau","Hendschiken","Henggart","Herbetswil","Herdern","Hergiswil","Herisau","Hermance","Hermetschwil-Staffeln","Herrliberg","Herzogenbuchsee","Hettlingen","Hildisrieden","Hilterfingen","Himmelried","Hindelbank","Hinterkappelen","Hinwil","Hirzel-Kirche","Hittnau","Hitzkirch","Hochdorf","Hochwald","Hoerstetten","Hofstetten","Holderbank","Holstein","Hombrechtikon","Horgen","Horn","Hornussen","Horw","Hundwil","Hunenberg","Hunibach","Huntwangen","Hunzenschwil","Huttwil","Ibach","Igis","Ilanz","Illnau","Immensee","Ingenbohl","Ins","Interlaken","Inwil","Iragna","Iseo","Iserables","Islikon","Ittenthal","Jegenstorf","Jenaz","Jona","Jonen","Jonschwil","Jussy","Kaiseraugst","Kaiserstuhl","Kaisten","Kallnach","Kaltbrunn","Kappel","Kastanienbaum","Kefikon","Kehrsatz","Kempttal","Kernenried","Kerns","Kerzers","Kiesen","Kilchberg","Killwangen","Kirchberg","Kirchdorf","Kleinlutzel","Klingnau","Klosters Platz","Klosters Serneus","Kloten","Koblenz","Kollbrunn","Kolliken","Konolfingen","Koppigen","Kradolf","Krauchthal","Kreuzlingen","Kriegstetten","Kriens","Kronbuhl","Kuesnacht","Kulm","La Chaux","La Chaux-de-Fonds","La Chiesaz","La Neuveville","La Plaine","La Roche","La Sarraz","La Tour-de-Peilz","Laax","Lachen","Lamboing","Landquart","Langenbruck","Langenthal","Langnau","Langnau am Albis","Lauenen","Lauerz","Laufelfingen","Laufen","Laufenburg","Laupen","Lausanne","Lausen","Le Brassus","Le Bry","Le Cret","Le Grand-Saconnex","Le Landeron","Le Locle","Le Mont-sur-Lausanne","Le Noirmont","Le Sentier","Le Vaud","Leibstadt","Lengnau","Lenk","Lenz","Lenzburg","Lenzerheide","Les Acacias","Les Breuleux","Les Diablerets","Les Geneveys-sur-Coffrane","Les Genevez","Les Hauts-Geneveys","Les Pommerats","Les Verrieres","Leukerbad","Leutwil","Leysin","Lichtensteig","Liddes","Liebistorf","Lienz","Liestal","Ligerz","Lignieres","Lindau","Littau","Locarno","Loco","Lodrino","Lohn","Lommis","Losone","Lostorf","Lotzwil","Lucens","Lucerne","Lugano","Lungern","Lurtigen","Lutisburg","Lutry","Luvis","Lyss","Lyssach","Maerstetten-Dorf","Magadino","Magden","Maggia","Maisprach","Malleray","Malters","Mannedorf","Manno","Marin","Maroggia","Marsens","Martigny-Croix","Martigny-Ville","Maschwanden","Massagno","Matt","Matzendorf","Matzingen","Mauensee","Maur","Meggen","Meierskappel","Meilen","Meinier","Meinisberg","Meiringen","Meisterschwanden","Melano","Melchnau","Melide","Mellingen","Mels","Mendrisio","Menziken","Menzingen","Merenschwand","Merishausen","Messen","Mettendorf","Mettlen","Mettmenstetten","Meyrin","Miecourt","Minusio","Mohlin","Mollis","Monchaltorf","Montagnola","Montana","Montet","Monthey","Montreux","Moosleerau","Morbio Inferiore","Morcote","Morges","Morgins","Morigen","Moriken","Morschach","Morschwil","Mosnang","Motiers","Moudon","Moutier","Muerren","Muhen","Muhlau","Muhleberg","Mullheim","Mumliswil","Mumpf","Munchenbuchsee","Munchenstein","Munchwilen","Munsingen","Munster","Muolen","Muotathal","Murgenthal","Muri","Muri bei Bern","Murten","Muttenz","Nafels","Nanikon","Naters","Nax","Neftenbach","Nesslau","Netstal","Neu-Rheinau","Neuchatel","Neuenhof","Neuenkirch","Neuhausen","Neuheim","Neukirch","Neunkirch","Neyruz","Nidau","Niederbipp","Niederbuchsiten","Niederburen","Niedererlinsbach","Niedergosgen","Niederhallwil","Niederhelfenschwil","Niederlenz","Niederrohrdorf","Niederscherli","Niederurnen","Niederuzwil","Niederweningen","Nohl","Noreaz","Nottwil","Novaggio","Novazzano","Nunningen","Nurensdorf","Nussbaumen","Nyon","Ober Urdorf","Oberbalm","Oberbipp","Oberbuchsiten","Oberburg","Oberdiessbach","Oberdorf","Oberegg","Oberembrach","Oberengstringen","Oberentfelden","Obergerlafingen","Oberglatt","Obergosgen","Oberhelfenschwil","Oberhofen","Oberhofen bei Etzgen","Oberkirch","Oberlunkhofen","Oberonz","Oberrieden","Oberriet","Obersaxen","Oberschlatt","Oberstocken","Oberuzwil","Obervaz","Oberwangen","Oberweningen","Oberwil","Obfelden","Oensingen","Oetwil / Oetwil an der Limmat","Oetwil am See","Oftringen","Olten","Onex","Onnens","Opfikon","Orbe","Ormalingen","Oron-la-ville","Orpund","Orsonnens","Orvin","Ossingen","Ostermundigen","Otelfingen","Othmarsingen","Ottenbach","Ouchy","Ovronnaz","Palezieux","Pampigny","Paudex","Payerne","Perlen","Perroy","Pery","Peseux","Pfaeffikon","Pfaffnau","Pfeffikon","Pfeffingen","Pfungen","Pfyn","Pieterlen","Plaffeien","Plan-les-Ouates","Porrentruy","Porsel","Portalban- Dessous","Prangins","Pratteln","Pregassona","Preles","Preverenges","Prilly","Puidoux","Pully","Pura","Quartino","Rafz","Ramsen","Rances","Raperswilen","Rapperswil","Raron","Rebstein","Rechthalten","Reconvilier","Regensdorf","Rehetobel","Reichenburg","Reiden","Reigoldswil","Reinach","Rekingen","Renens","Rhazuns","Rheineck","Rheinfelden","Riaz","Richenthal","Richigen","Richterswil","Ricken","Rickenbach","Riddes","Ried","Riedholz","Rifferswil","Riggisberg","Rikon / Rikon (Dorfkern)","Ringgenberg","Riva San Vitale","Roche","Roemerswil","Roggwil","Rohr","Rohrbach","Rolle","Romainmotier","Romanel","Romanshorn","Romont","Rondchatel","Root","Rorbas","Rorschach","Roschenz","Rossens","Rothenbach","Rothenthurm","Rothrist","Rotkreuz","Roveredo","Rubigen","Rudlingen","Rudolfstetten","Rue","Rueggisberg","Rueti","Rueyres","Rufi","Rumlang","Rupperswil","Ruschlikon","Russikon","Russin","Ruswil","Ruthi","Saanen","Saanenmoser","Saas-Fee","Saas-Grund","Sachseln","Safenwil","Saignelegier","Saint-Aubin","Saint-Aubin-Sauges","Saint-Blaise","Saint-Cergue","Saint-Imier","Saint-Leonard","Saint-Livres","Saint-Maurice","Saint-Prex","Saint-Sulpice","Sainte-Croix","Salmsach","Samstagern","Sankt Gallenkappel","Sankt Margrethen","Sargans","Sariswil","Sarmenstorf","Sarn","Sarnen","Satigny","Sattel","Saviese","Savigny","Savognin","Saxon","Schachen","Schaffhausen","Schafisheim","Schanis","Schattdorf","Schenkon","Schiers","Schindellegi","Schinznach Bad","Schinznach Dorf","Schlatt","Schleitheim","Schlieren","Schmerikon","Schmitten","Schnottwil","Schoetz","Schoftland","Schonbuhl","Schonenberg","Schonenbuch","Schonenwerd","Schongau","Schonholzerswilen","Schonried","Schubelbach","Schuepfheim","Schupfen","Schwarzenberg","Schwarzenburg","Schwellbrunn","Schwyz","Scuol","Seedorf","Seegraben","Seelisberg","Seengen","Seewis im Pratigau","Seftigen","Seltisberg","Selzach","Sembrancher","Sementina","Sempach","Semsales","Sennwald","Seon","Sessa","Seuzach Dorf","Sevelen","Sezegnin","Siebnen","Sierre","Siglistorf","Sigriswil","Sils-Segl Maria","Sins","Sion","Sirnach","Siselen","Sissach","Siviriez","Solothurn","Sonceboz","Sonvico","Sonvilier","Sorengo","Sottens","Soyhieres","Speicher","Spiez","Spreitenbach","St. Gallen","Stabio","Stadel","Stafa","Stallikon","Stans","Stansstad","Staufen","Steckborn","Steffisburg","Steg","Stein","Stein am Rhein","Steinen","Steinhausen","Stettfurt","Stettlen","Stoos","Strengelbach","Subingen","Suhr","Sulgen","Sulz","Sumiswald","Sursee","Tafers","Tagerwilen","Tamins","Tanay","Tann","Tasch","Tauffelen","Tavannes","Tegerfelden","Tenero","Termen","Territet","Tesserete","Teufen AR","Teufenthal","Thalheim","Thalwil","Thayngen","Therwil","Thielle","Thierachern","Thierrens","Thonex","Thorishaus","Thun","Thundorf","Thusis","Toffen","Tramelan","Trasadingen","Travers","Treyvaux","Triengen","Trimbach","Trimmis","Trogen","Troistorrents","Trubbach","Trubschachen","Trun","Tschuggen","Tuggen","Turbenthal","Turgi","Twann","Udligenswil","Ueberstorf","Uerikon","Uerkheim","Uetendorf","Uetikon","Ufhusen","Uhwiesen","Uitikon","Ulrichen","Unter-Teufen","Unterageri","Unterehrendingen","Unterengstringen","Untererlinsbach","Unteriberg","Unterkulm","Unterlunkhofen","Unterseen","Untersiggenthal","Untervaz","Ursenbach","Urtenen","Uster","Utzenstorf","Uznach","Uzwil","Vacallo","Vallorbe","Vandoeuvres","Vauderens","Vaulruz","Veltheim","Verbier","Vercorin","Vernayaz","Vernier","Verscio","Versoix","Vesenaz","Vessy","Vetroz","Vevey","Vex","Veyrier","Veytaux","Vicques","Viganello","Villa","Villars","Villars-sur-Glane","Villars-sur-Ollon","Villaz-Saint-Pierre","Villeneuve","Villeret","Villigen","Villmergen","Villnachern","Vilters","Vinzel","Vionnaz","Visp","Vitznau","Volketswil","Vordemwald","Vouvry","Vuadens","Vuiteboeuf","Vullierens","Wabern","Wadenswil","Wagenhausen","Wahlen","Walchwil","Wald","Waldenburg","Waldhaus","Waldkirch","Waldstatt","Walkringen","Wallisellen","Waltenschwil","Walzenhausen","Wangen","Wangen an der Aare","Wangi","Wangs","Wasen","Wattwil","Wauwil","Weesen","Wegenstetten","Weggis","Weinfelden","Weiningen","Weissbad","Weisslingen","Welschenrohr","Wengen","Werthenstein","Wettingen","Wetzikon","Wichtrach","Wiedlisbach","Wiesendangen","Wigoltingen","Wikon","Wil","Wila","Wildegg","Wilderswil","Wileroltigen","Willisau","Wimmis","Windisch","Winkel","Winterberg","Winterthur","Wittenbach","Wittnau","Wohlen","Wolfenschiessen","Wolfgang","Wolfhalden","Wolfwil","Wolhusen","Wollerau","Worb","Worben","Worblaufen","Wuppenau","Wurenlingen","Wurenlos","Wynau","Yens","Yverdon-les-Bains","Yvonand","Yvorne","Zaziwil","Zeglingen","Zeihen","Zell","Zermatt","Ziegelbrucke","Zihlschlacht","Zizers","Zofingen","Zollbruck","Zollikofen","Zollikon","Zuchwil","Zuckenriet","Zufikon","Zug","Zullwil","Zumikon","Zunzgen","Zurich","Zuzgen","Zuzwil","Zwingen"]},"CI":{"id":"CI","name":"C\xf4te d\'Ivoire","timezones":["Africa/Abidjan"],"cities":[]},"CK":{"id":"CK","name":"Cook Islands","timezones":["Pacific/Rarotonga"],"cities":[]},"CL":{"id":"CL","name":"Chile","timezones":["America/Santiago","Pacific/Easter"],"cities":["Algarrobo","Angol","Antofagasta","Apoquindo","Arauco","Arica","Buin","Bulnes","Calama","Caldera","Castro","Catemu","Centro","Cerrillos de Tamaya","Chicureo Abajo","Chiguayante","Chillan","Chillan Viejo","Chimbarongo","Chonchi","Chuquicamata","Coihaique","Colina","Collipulli","Concon","Constitucion","Coquimbo","Coronel","Cunco","Curacavi","Dalcahue","El Arco","El Bosque","El Monte","El Quisco","El Salto","El Salvador","El Valle","Fresia","Galvarino","Graneros","Hanga Roa","Iquique","La Calera","La Cisterna","La Granja","La Laja","La Ligua","La Reina","La Serena","La Union","Lampa","Las Condes","Lautaro","Llanquihue","Lo Barnechea","Lolol","Los Andes","Los Angeles","Machali","Macul","Maipu","Maquina Atacama","Maule","Mejillones","Melipilla","Miraflores","Molina","Monte Aguila","Nacimiento","Nogales","Nunoa","Olmue","Osorno","Ovalle","Paillaco","Penablanca","Penaflor","Port Montt","Providencia","Puchuncavi","Pucon","Puente Alto","Puerto Aisen","Puerto Natales","Puerto Varas","Punta Arenas","Puren","Purranque","Quellon","Quemchi","Quilicura","Quillota","Rancagua","Recoleta","Renaca","Renca","Rengo","Rinconada","Rio Bueno","San Antonio","San Bernardo","San Carlos","San Felipe","San Fernando","San Javier","San Martin","San Pedro","Santa Barbara","Santiago","Talagante","Talca","Talcahuano","Tarapaca","Temuco","Tome","Valdivia","Vallenar","Villa Alemana","Villarrica","Vitacura"]},"CM":{"id":"CM","name":"Cameroon","timezones":["Africa/Lagos"],"cities":["Bafia","Bafoussam","Bamenda","Buea","Douala","Kribi","Kumba","Ringo","Tibati"]},"CN":{"id":"CN","name":"China","timezones":["Asia/Shanghai","Asia/Urumqi"],"cities":["Aishang","Aizhou","Aksu","Anbang","Anbu","Ancheng","Anda","Andong","Angu","Anguo","Anhu","Anji","Anjiang","Ankang","Anke","Anqing","Anqiu","Anshan","Anshun","Ansu","Anxi","Anyang","Anying","Anzhou","Anzi","Aojiang","Aoma","Bagong","Baicheng","Baidu","Baihua","Baile","Bailicun","Baipo","Baise City","Baisha","Baishan","Baishi","Baitang","Baixiang","Baixin","Baiyashi","Baiyi","Baiyin","Baiyu","Baiyun","Baizhang","Baliqiao","Bamao","Bangke","Bangtou","Bantou","Banxi","Banyou","Baocheng","Baodi","Baodian","Baoding","Baojiang","Baoluo","Baoqing","Baoshan","Baotao","Baotian","Baotou","Baoxing","Baoyu","Base","Baying","Bazhou","Baziqiang","Beichan","Beidou","Beihai","Beijie","Beijing","Beilin","Beilun","Beishan","Beixi","Beixiao","Beiying","Beiyuan","Bengbu","Benxi","Bianzhuang","Bibo","Bijie","Binhe","Binjiang","Binzhou","Biyang","Bobai","Bohai","Boji","Bole","Boli","Boshan","Boxing","Bozhou","Buxin","Caijing","Caishen","Caiyuan","Cangnan","Cangshang","Cangzhou","Caopu","Caoxi","Caozhai","Cengang","Cenyang","Cezi","Chadianzi","Chaicun","Chaigoubu","Chamdo","Changchao","Changchun","Changde","Changfeng","Changhe","Changjian","Changjiang","Changle","Changning","Changping","Changqing","Changsha","Changshan","Changsheng","Changshu City","Changting","Changtu","Changxiacun","Changxin","Changzheng","Changzhi","Changzhong","Changzhou","Chaohu","Chaoyang","Chaozhou","Chen Xian","Chendu","Chengbei","Chengdong","Chengdu","Chengfeng","Chengguan","Chenghua","Chengjian","Chengmai","Chengnan","Chengqiao","Chenguang","Chengxi","Chengxian Chengguanzhen","Chengxiang","Chengyang","Chengzhong","Chenyang","Chenzhou","Chifeng","Chiping","Chizhou","Chongqing","Chongwen","Chongxian","Choucheng","Chuansha","Chum","Chunhua","Chunjiang","Chuxiong","Chuzhou","Cicheng","Cili","Citai","Cixi","Cuibei","Cuiyuan","Cuizhu","Cuntou","Dabaizhuang","Dabao","Dabu","Dachen","Dachuan","Dagang","Dahai","Dahuaishu","Daidong","Daishan","Daixi","Daizhong","Daji","Dajie","Daju","Dali","Dalian","Dampu","Dancheng","Dandong","Danfeng","Dangshan","Dangyang","Danjiang","Danjiangkou","Danyang","Danzao","Danzhou","Daojiang","Daotou","Daoxu","Daqiao","Daqing","Daqiuzhuang","Dasha","Dashiqiao","Dashun","Datang","Datong","Dawa","Dawang","Dawukou","Daxie","Daxing","Dayan","Dayang","Daye","Dayun","Dazhong","Dazhou","Dazu","Defeng","Dehui","Dengbu","Dengzhou","Deqing","Deyang","Deyuan","Deyue","Dezhou","Diankou","Dianzhong","Dianzi","Digang","Dingcheng","Dinghai","Dingqiao","Dingtao","Dingxi","Dingzha","Dingzhou","Dipu","Dongchang","Dongcheng","Dongcun","Dongdu","Dongfang","Dongfeng","Dongguan","Donghai","Donghe","Donghong","Donghuxu","Dongjiaying","Dongli","Donglin","Dongliu","Dongning","Dongshen","Dongsheng","Dongshi","Dongtou","Dongxi","Dongxiao","Dongxin","Dongxing","Dongyang","Dongying","Doujiang","Doumen","Dujiacun","Dungdo","Duoba","Dushu","Duwei","Duyun","Edong","Ejia","Enshi","Erqi","Eshan","Ezhou","Fangqiao","Fangshan","Fangxian Chengguanzhen","Fangzhuang","Fangzi","Fanjing","Fanzhong","Feihong","Feilong","Feixian","Feiyun","Fendou","Fengcheng","Fenggang","Fengjiang","Fenglin","Fengling","Fengming","Fengnan","Fengqi","Fengqiao","Fengqing","Fengshan","Fengshang","Fengshun","Fengtai","Fengting","Fengxian","Fengxiang","Fengzhou","Fenshang","Fenyang","Foshan","Fotang","Fuchun","Fuchunjiang","Fudao","Fuding","Fugu","Fuhao","Fuling","Fumin","Fuqiang","Furong","Fusheng","Fushun","Futian","Fuxin","Fuyang","Fuzhou","Gaiwei","Gaiyu","Gamlung","Gangcun","Ganjiang","Gannan","Ganyao","Ganzhou","Gaobeidian","Gaobu","Gaocheng","Gaoji","Gaoping","Gaoqiao","Gaotang","Gaoting","Gaoxin","Gaozhao","Gaozhou","Gejiu","Gongchang","Gongjiang","Gongjiao","Gongli","Gongyi","Gongyuan","Goushan","Gouzhuang","Guali","Guancheng","Guangchang","Guangdong","Guangming","Guangtai","Guangtong","Guangxi","Guangyuan","Guangzhou","Guanli","Guanqiao","Guantian","Gucheng","Guigang","Guili","Guilin","Guixi","Guiyang","Guiyuan","Guizhoumanzuxiang","Gujiang","Gujiao","Guli","Gunan","Guodian","Guohe","Guoji","Guoshang","Guozhen","Gushan","Gushi","Guxiang","Guyong","Guyuan","Gyari","Haibei","Haicheng","Haidian","Haifu","Haihong","Haijing","Haikou","Hailar","Hailin","Hainan","Haitang","Haixing","Haiyang","Haiyu","Haizhou","Handan","Hangbu","Hangong","Hangu","Hangzhou","Hanjiang","Hanshan","Hanshang","Hanting","Hanzhong","Haocheng","Haozhuang","Harbin","Hebei","Hebi","Hecheng","Hechi","Hechun","Hecun","Hedong","Hefei","Hegang","Heibei","Heihe","Hejiang","Hejin","Hekou","Heliang","Hengdian","Henghe","Hengjie","Hengshui","Hengyang","Hengzhou","Heping","Heshun","Hetao","Hetian","Hexi","Hexun","Heyi","Heyuan","Heze","Hezhou","Hezhu","Hezuo","Hohhot","Hongchang","Honglin","Hongling","Hongpan","Hongqiao","Hongshan","Hongshun","Hongtang","Hongwei","Hongxi","Hongyan","Hongyangshu","Hongyuan","Hongyun","Houxiangcheng","Houzhai","Huabei","Huacheng","Huadian","Huadong","Huafeng","Huagong","Huagongchang","Huaibei","Huaihe","Huaihua","Huainan","Huairou","Huajiashan","Huajie","Huali","Hualin","Hualong","Huamei","Huanan","Huangbao","Huangdao","Huangdu","Huanggang","Huanghou","Huanghu","Huanghua","Huangjia","Huangjue","Huangshan","Huangshi","Huangxuan","Huangyan","Huangyuan Chengguanzhen","Huangze","Huangzhai","Huangzhou","Huanzhen","Huaqiang","Huaqiao","Huashan","Huatan","Huating","Huawei","Huaxia","Huaxin","Huaxing","Huayang","Huaying","Huayuan","Huayue","Huayuji","Huazhong","Huazhou","Huge","Huicheng","Huigang","Huilongba","Huimin","Huixin","Huiyang","Huizhou","Hulan","Huling","Hulu","Huludao","Huoshan","Huozhou","Hupi","Huquan","Hushan","Huzhen","Huzhou","Jiadi","Jiading","Jiafu","Jiahao","Jiahe Chengguanzhen","Jiahu","Jialing","Jiamusi","Jianci","Jiangbei","Jiangchuanlu","Jiangdong","Jiangguantun","Jiangjia","Jiangjin Qu","Jiangkou","Jiangmen","Jiangnan","Jiangshan","Jiangtian","Jiangwan","Jiangwang","Jiangyan","Jiangyin","Jiangyou","Jianning","Jianxing","Jianyang","Jianyuan","Jianzhong","Jiaojiang","Jiaokou","Jiaotong","Jiaotou","Jiaowei","Jiaoyu","Jiaoyuan","Jiaoyun","Jiaozhou","Jiaozuo","Jiaqin","Jiaxin","Jiaxing","Jiaying","Jiayuan","Jiayue","Jiazhuang","Jicheng","Jiedong","Jiefang","Jiehe","Jielong","Jieshou","Jiexi","Jiexiu","Jieyang","Jifeng","Jiguang","Jilin City","Jimo","Jin Jiang","Jinan","Jinbi","Jincheng","Jinchuan","Jinci","Jinda","Jinde","Jindi","Jindian","Jinding","Jindou","Jindu","Jingbei","Jingcheng","Jingdezhen","Jingdong","Jingdu","Jingfeng","Jinghai","Jinghe","Jinghong","Jinghu","Jinghua","Jingjiang","Jinglian","Jinglong","Jingmen","Jingning Chengguanzhen","Jingshan","Jingtian","Jinguang","Jingxi","Jingyuan","Jingzhong","Jingzhou","Jinhai","Jinhe","Jinhong","Jinhu","Jinhua","Jining","Jinjiang","Jinli","Jinling","Jinlong","Jinlu","Jinlun","Jinma","Jinmao","Jinmen","Jinming","Jinnan","Jinpan","Jinpu","Jinqiao","Jinqingzhen","Jinsha","Jinshadi","Jinshan","Jinshi","Jintan","Jintian","Jinwo","Jinxiangzhen","Jinxing","Jinyang","Jinyi","Jinyin","Jinying","Jinyuan","Jinyun","Jinzao","Jinzhong","Jinzhou","Jishou","Jishu","Jiuba","Jiuguan","Jiuzong","Jixi","Jiya","Jiyang","Jizhou","Jondag","Juchuan","Juhua","Julong","Jundu","Junlin","Junping","Junpu","Kaifeng","Kaihua","Kaili","Kaiyuan","Kaiyun","Kandun","Kang Xian","Kangcun","Kangda","Karamay","Kashgar","Kecheng","Keqiao","Keshan","Korla","Kouqian","Kouquan","Kuangyan","Kuicheng","Kuiju","Kuishan","Kumul","Kunlun","Kunming","Kunshan","Kunyang","Kuytun","Laibin","Laiwu","Laiyi","Lake","Langfang","Langli","Langzhong","Lanhai","Lanjiang","Lanping","Lantang","Lanxi","Lanzhou","Laohekou","Laonian","Lecheng","Ledong","Lengshuijiang","Leshan","Lhasa","Lianghu","Liangping","Liangzhu","Lianhua","Lianjiang","Liannan","Lianping","Lianshan","Lianshi","Lianshui","Lianyuan","Lianyungang","Liaocheng","Liaoyang","Liaoyuan","Libang","Licheng","Lida","Lidong","Lidu","Lihou","Lijiang","Lijing","Linbei","Lincang","Lincheng","Lindian","Linfen","Lingang","Lingcheng","Lingdong","Linghu","Lingnga","Lingshi","Lingshui","Lingxi","Lingzhi","Linhai","Linjiang","Linkou","Linnan","Linping","Linqi","Linqing","Linqu","Lintong","Linxia Chengguanzhen","Linyi","Linze","Linzhou","Lishang","Lishu","Lishui","Liu`an","Liucheng","Liudao","Liudong","Liuhe","Liuheng","Liujian","Liujiang","Liulin","Liushi","Liuzhou","Liwu","Liyuan","Lize","Longchuan","Longdong","Longfeng","Longgang","Longgong","Longhu","Longhua","Longjian","Longjiang","Longjin","Longlin","Longmao","Longmen","Longnan","Longquan","Longshan","Longtai","Longteng","Longxiang","Longxin","Longxing","Longxun","Longyan","Longzhou","Loufan","Lucheng","Lugouqiao","Luhua","Lujiazhi","Lung","Luobu","Luocheng","Luofang","Luohe","Luohu","Luoling","Luomen","Luorong","Luoxi","Luoyang","Luoyuan","Luozhuang","Luqiao","Luquan","Lushang","Luwan","Luzhou","Macao","Maji","Majin","Maoba","Maodian","Maodun","Maoming","Maotai","Mapai","Mawei","Mayao","Mayu","Meicheng","Meijiang","Meilian","Meilin","Meishan","Meixi","Meiyu","Meiyuan","Meizhou","Mengshan","Mengyin","Mengzhou","Mengzi","Mianyang","Miaogao","Mingde","Mingdu","Mingjia","Mingjing","Mingshui","Mingxi","Mingxing","Mingzhou","Mingzhu","Minhang","Minjiang","Minjie","Minzhu","Minzu","Mishan","Miyun","Moushan","Mudanjiang","Muling","Nagqu","Name","Nanchang","Nanchong","Nanda","Nandu","Nanfang","Nanguo","Nangxian","Nanhai","Nanhan","Nanhe","Nanhu","Nanjiang","Nanjin","Nanjing","Nankai","Nanlong","Nanma","Nanmen","Nanning","Nanping","Nanshan","Nantang","Nantong","Nanxi","Nanxianglong","Nanxun","Nanyang","Nanying","Nanyuan","Nanzhao","Nanzhuang","Napo","Naxi Yaozuxiang","Neijiang","Nenjiang","Niaojiang","Ningbo","Ningde","Ninghai","Ninghe","Ningyi","Niulanshan","Niunaichang","Nongkeng","Nyingchi County","Oucheng","Oujiang","Panjin Shi","Panxi","Panzhihua","Pengcheng","Penglai","Pengshan","Pengyu","Pingchuan","Pingdingshan","Pinghu","Pingliang","Pinglu","Pingwang","Pingxiang","Pingyang","Pingyao County","Pingyi","Pingyin","Pingyuan","Pizhou","Potang","Pucheng","Pudong","Puning","Puqing","Putian","Putuo","Putuoshan","Puyang","Puyuan","Qiandao","Qiandaohu","Qianhai","Qianjiang","Qianjin","Qianling","Qianqing","Qianshan","Qiantan","Qiantang","Qianyu","Qiaodou","Qiaolian","Qiaoting","Qiaoxia","Qiaoyuan","Qiaozhen","Qidu","Qijiashan","Qike","Qingdao","Qingfeng Chengguanzhen","Qinggang","Qinghai","Qinghu","Qingma","Qingnian","Qingquan","Qingshan","Qingshuiwan","Qingtian","Qingtong","Qingxin","Qingyang","Qingyuan","Qingzhen","Qingzhou","Qinhuangdao","Qinjiang","Qinzhou","Qionghai","Qiongshan","Qiqihar","Qitai","Quanzhou","Qujiang","Qujing","Qushan","Quzhou","Renhe","Renhou","Renmin","Renqiu","Renrong","Rizhao","Rongjiang","Rongjin","Rongle","Rongshan","Rongsheng","Rongxian","Rongxing","Ruicheng","Ruifeng","Ruihu","Ruili","Ruiting","Ruixing","Ruiying","Rujia","Sailing","Sandu","Sanguan","Sanhe","Sanjiang","Sanjiangkou","Sanjiaocheng","Sanjiu","Sanlian","Sanmao","Sanmen","Sanmenxia","Sanming","Sanpailou","Santai","Santiaolou","Sanya","Sanyi","Sanyou","Sanyuanpu","Sanzhang","Shamen","Shancheng","Shangbao","Shangbu","Shangdong","Shangfang","Shanghai","Shanghu","Shangjiang","Shangluo","Shangma","Shangnan","Shangqiu","Shangrao","Shangsha","Shangsi","Shangtang","Shangwang","Shangwu","Shangxi","Shangye","Shangying","Shangzhang","Shangzhi","Shangzhou","Shanhe","Shanhu","Shanrui","Shanshui","Shantou","Shanwei","Shanzhuang","Shaoguan","Shaoguang","Shaowu","Shaoxing","Shashan","Shashi","Shecheng","Shejiazhuang","Shekou","Shengdu","Shengfang","Shengli","Shengping","Shengshan","Shenjiamen","Shenlong","Shennan","Shensha","Shenwan","Shenyan","Shenyang","Shenzhen","Shenzhou","Shibei","Shifan","Shifang","Shihezi","Shiji","Shijiazhuang","Shijing","Shijingxiang","Shiling","Shilou","Shima","Shinian","Shipu","Shiqi","Shiqiaopu","Shishi","Shixia","Shiyan","Shizheng","Shizhong","Shizhu","Shouchang","Shouchun","Shouguang","Shouyang","Shuangcheng","Shuanglin","Shuanglong","Shuangqiao","Shuangshipu","Shuangtang","Shuangxi","Shuangyashan","Shuguang","Shuhong","Shuigang","Shuiku","Shuitian","Shuitou","Shuiwu","Shule","Shuliang","Shunde","Shunshui","Shuozhou","Shuyi","Sichuan","Side","Siduxu","Sijiqing","Sili","Simao","Simcun","Simen","Siting","Siyang","Sizhou","Songling","Songyang","Songyuan","Suihua","Suining","Suixi","Suji","Sundun","Sungang","Suqian","Suxi","Suzhou","Suzhuang","Taicang","Taihe","Taikang","Tailai","Taili","Taimen","Taiping","Taipingyan","Taishan","Taixing","Taiyuan","Taizhou","Tancheng","Tang Xian","Tangbian","Tangchang","Tangcheng","Tangdukou","Tangtou","Tangxi","Tangxia","Tangyuan","Tanshi","Taocheng","Taohua","Taoshan","Taoxi","Taoyuan","Taozhuang","Tara","Tashi","Taxi","Tengjiao","Tengzhou","Tianbao","Tianchang","Tiancheng","Tianchi","Tiandong","Tianfu","Tiangang","Tianhai","Tianhong","Tianjin","Tianle","Tianli","Tianma","Tianning","Tianshan","Tianshi","Tianshui","Tiantai Chengguanzhen","Tianyang","Tianyi","Tianyuan","Tianzhen","Tianzhu","Tieli","Tieling","Tieshan","Tingpang","Tongbai","Tongchuan","Tongcun","Tongji","Tongliao","Tongling","Tonglu","Tongmin","Tongren","Tongwang","Tongxiang","Tongyu","Tongyuan","Tumu","Turpan Diqu","Wanbao","Wangfu","Wangluo","Wangshang","Wangsu","Wanjia","Wanning","Wanquan","Wansong","Wanxi","Weibo","Weidun","Weifang","Weihai","Weinan","Weitang","Weiyang","Wenchang","Wenhou","Wenlan","Wenlin","Wenling","Wenquan","Wenshan","Wenshang","Wenxi","Wenxing","Wenzhou","Wuhai","Wuhan","Wuhou","Wuhu","Wuling","Wuning","Wushan","Wutai","Wutong","Wuwei","Wuxi","Wuxia","Wuxing","Wuyang","Wuyi","Wuyishan","Wuzhen","Wuzhishan","Wuzhong","Wuzhou","Xiabancheng","Xiadianmiao","Xiakou","Xiamen","Xianchang","Xiandu","Xiangcheng","Xiangfan","Xiangfeng","Xiangjiang","Xiangnan","Xiangru","Xiangshan","Xiangsheng","Xiangsi","Xiangtan","Xiangtong","Xiangxi","Xiangyi","Xiangyuan","Xianjiang","Xianlin","Xianning","Xianqiao","Xianren","Xianrenqiao","Xiantao","Xianyang","Xianyou","Xiaogan","Xiaogang","Xiaoheshan","Xiaojiahe","Xiaojiang","Xiaomi","Xiaoqu","Xiaoshan","Xiaoshun","Xiaosi","Xiaoxi","Xiaozheng","Xiapu","Xiasha","Xiashi","Xiatangyunxiang","Xiayuan","Xiazhi","Xiazhuang","Xibei","Xibu","Xichang","Xichong","Xidian","Xiedian","Xieqiao","Xiezhou","Xigu","Xiguan","Xihu","Xijiao","Xijing","Xikou","Xiling","Ximeng","Xinao","Xincao","Xinchang","Xinchen","Xincheng","Xindi","Xindu","Xingang","Xingchang","Xingchen","Xingcheng","Xingfeng","Xingguang","Xinghua","Xingqiao","Xingtai","Xinguang","Xingwang","Xingxian","Xingxiangcun","Xingxing","Xingye","Xingyi","Xingyuan","Xinhua","Xinhuang","Xinhui","Xining","Xinjian","Xinjiang","Xinmin","Xinning","Xinqiao","Xinrong","Xinsha","Xinshijie","Xintai","Xintangbian","Xintian","Xinxiang","Xinxing","Xinyang","Xinyi","Xinyou","Xinzha","Xinzheng","Xinzhou","Xiping","Xiqu","Xishan","Xitang","Xiushan","Xiushui","Xiuying","Xiuyu","Xixi","Xiyang","Xiyue","Xizhang","Xizhou","Xuancheng","Xuanwu","Xuanzhou","Xuchang","Xucheng","Xucun","Xuefeng","Xuexi","Xuexiao","Xuezhuang","Xuhui","Xunxian","Xunyi Chengguanzhen","Xushan","Xuzhou","Yahao","Yajin","Yalan","Yalongwan","Yanchang","Yancheng","Yandang","Yandao","Yangce","Yangcun","Yangda","Yangfen","Yanggu","Yangjiang","Yangling","Yanglou","Yangmiao","Yangpu","Yangqitan","Yangqu","Yangquan","Yangshan","Yanguan","Yangxunqiao","Yangzhong","Yangzhou","Yanhai","Yanji","Yanjiang","Yanjiao","Yanjing","Yanming","Yanshi","Yanta","Yantai","Yantan","Yaocheng","Yaofeng","Yaohua","Yaoluoping","Yaozhuang","Yayu","Yibin","Yichang","Yicheng","Yichun","Yidong","Yifeng","Yifu","Yijin","Yijing","Yili","Yinchuan","Yindian","Yinfang","Yingcai","Yingchuan","Yingdu","Yinggen","Yingjia","Yingjie","Yingqian","Yingtai","Yinhai","Yining","Yinjiang","Yinliang","Yinshan","Yintian","Yinxin","Yinzhou","Yiqiao","Yisa","Yishan","Yishui","Yitian","Yiting","Yiwu","Yiyang","Yizheng","Yizhong","Yizhou","Yongchuan","Yongjia","Yongjiawan","Yongjin","Yongjiu","Yongkang","Yongning","Yongqiang","Yongxing","Yongzhou","Youchegang","Youjia","Youjiang","Youshi","Youyi","Yuanchang","Yuanheng","Yuanli","Yuanling","Yuanping","Yuanpu","Yuanqu","Yuantong","Yuanyang","Yucai","Yucheng","Yuchi","Yuecheng","Yuehu","Yuehua","Yuele","Yueliangwan","Yueqing","Yuetai","Yuhai","Yuhan","Yuhang","Yuhong","Yuhuan","Yuhuayuan","Yuhui","Yujing","Yulin","Yulong","Yuncheng","Yunfeng","Yunfu","Yungang","Yungcun","Yunling","Yunnan","Yunting","Yunyang","Yuting","Yutou","Yuxi","Yuxiang","Yuyao","Yuyuan","Yuzhen","Yuzhong Chengguanzhen","Yuzi","Zaoyang","Zaozhuang","Zhancheng","Zhanghe","Zhanghou","Zhangjiagang","Zhangjiajie","Zhangjiakou","Zhangjiang","Zhangqi","Zhangqiu","Zhangshan","Zhangshu","Zhangye","Zhangzhai","Zhangzhou","Zhangzhuang","Zhanjiang","Zhanmao","Zhaobaoshan","Zhaodong","Zhaoqing","Zhaotong","Zhaoyu","Zhaozhou","Zhapu","Zhedong","Zhengda","Zhengdi","Zhengding","Zhenghai","Zhengjiang","Zhengyuan","Zhengzhou","Zhenhua","Zhenjiang","Zhenxi","Zhenxing","Zhenzhou","Zhenzhuquan","Zheshang","Zhicheng","Zhijiang","Zhili","Zhima","Zhixing","Zhiye","Zhiyuan","Zhizhong","Zhongdian","Zhongfang","Zhongfu","Zhonggongmiao","Zhongji","Zhongjian","Zhonglin","Zhongnan","Zhongqiao","Zhongshan","Zhongtang","Zhongtian","Zhongtu","Zhongwei","Zhongxiang","Zhongxin","Zhongxing","Zhongyang","Zhongyicun","Zhongyin","Zhongyuan","Zhongzhou","Zhoukou","Zhoushan","Zhouwangmiao","Zhouxiang","Zhuhai","Zhuji","Zhujiajian","Zhujiajiao","Zhulin","Zhumadian","Zhuozhou","Zhuxi Chengguanzhen","Zhuxiang","Zhuyuan","Zibo","Zicheng","Zigong","Zijin","Ziyang","Ziyu","Zongxoi","Zoucheng","Zunyi","Zuxi"]},"CO":{"id":"CO","name":"Colombia","timezones":["America/Bogota"],"cities":["Acacias","Acevedo","Aguachica","Antioquia","Arauca","Armenia","Atlantico","Barrancabermeja","Barranquilla","Bello","Bermudez","Boyaca","Bucaramanga","Buenaventura","Buga","Cajica","Calamar","Caldas","Candelaria","Cartagena","Cartago","Cauca","Chia","Chiquinquira","Chocho","Columbia","Corozal","Cota","Cumaribo","Cundinamarca","Dosquebradas","Duitama","El Colegio","Engativa","Envigado","Espinal","Florencia","Floridablanca","Fonseca","Fundacion","Fusagasuga","Galapa","Ginebra","Giron","Guarne","Ibague","Inirida","Ipiales","Itagui","La Ceja","La Estrella","La Mesa","La Union","Los Patios","Madrid","Magdalena","Manizales","Miami","Mitu","Montenegro","Mosquera","Municipio de Copacabana","Neiva","Obando","Palmira","Pamplona","Pasto","Pereira","Piedecuesta","Pitalito","Planadas","Popayan","Puerta Roja","Puerto Tejada","Purificacion","Riohacha","Rionegro","Risaralda","Sabana de Torres","Sabaneta","Sachica","San Clemente","San Diego","San Gil","San Martin","Santa Marta","Santa Rosa de Cabal","Santa Rosa del Sur","Santiago de Cali","Silvania","Sincelejo","Soacha","Sogamoso","Soledad","Sopo","Tarapaca","Tauramena","Tenjo","Tocancipa","Tunja","Turbaco","Ubaque","Urumita","Valledupar","Velez","Villa del Rosario","Villamaria","Villavicencio","Yopal","Yotoco","Yumbo"]},"CR":{"id":"CR","name":"Costa Rica","timezones":["America/Costa_Rica"],"cities":["Alajuela","Alajuelita","Alfaro","Aserri","Atenas","Barva","Cartago","Colon","Corazon de Jesus","Coronado","Coyol","Curridabat","Desamparados","Escazu","Esparza","Filadelfia","Grecia","Guachipelin","Guacima","Guadalupe","Guapiles","Heredia","Isla de Tibas","Jaco","La Garita","Liberia","Llorente","Mercedes","Mexico","Miramar","Moravia","Palmares","Paraiso","Pavas","Perez","Poas","Puerto Jimenez","Puntarenas","Quepos","Quesada","Sabanilla","San Diego","San Francisco","San Isidro","San Joaquin","San Jose de la Montana","San Josecito","San Juan","San Marcos","San Pablo","San Pedro","San Rafael","San Ramon","Santa Ana","Santa Cecilia","Santa Cruz","Santo Domingo","Sarchi","Siquirres","Tres Rios","Turrialba","Turrucares","Zapote","Zarcero"]},"CU":{"id":"CU","name":"Cuba","timezones":["America/Havana"],"cities":["Bayamo","Cienfuegos","Habana","Havana","La Habana","Las Tunas","Matanzas","Santiago de Cuba","Varadero","Villa"]},"CV":{"id":"CV","name":"Cape Verde","timezones":["Atlantic/Cape_Verde"],"cities":[]},"CW":{"id":"CW","name":"Curacao","timezones":["America/Curacao"],"cities":[]},"CX":{"id":"CX","name":"Christmas Island","timezones":["Indian/Christmas"],"cities":[]},"CY":{"id":"CY","name":"Cyprus","timezones":["Asia/Nicosia"],"cities":["Agia Anna","Aradippou","Ayia Marina","Chlorakas","Deryneia","Famagusta","Geroskipou","Kato Lakatamia","Kato Polemidia","Kiti","Kyrenia","Larnaca","Laxia","Limassol","Livadia","Morfou","Mouttagiaka","Nicosia","Paphos","Paralimni","Parekklisha","Prodromi","Sotira","Strovolos","Tera"]},"CZ":{"id":"CZ","name":"Czech Republic","timezones":["Europe/Prague"],"cities":["Adamov","Albrechtice","Arnoltice","As","Babice","Banov","Baska","Batelov","Bavory","Bechyne","Bela pod Bezdezem","Belotin","Benatky nad Jizerou","Benesov","Benesovice","Bernartice","Bernartice nad Odrou","Beroun","Bezdekov","Bilina","Bilovice","Bilovice nad Svitavou","Bitovany","Blansko","Blatna","Blizevedly","Blovice","Blucina","Bludov","Bludovice","Bochov","Bohumin","Bohunovice","Bojanov","Bojkovice","Bolatice","Bolebor","Bor","Boretice","Borohradek","Borotin","Borovany","Borsice","Bosin","Boskovice","Bradlec","Brandys nad Labem-Stara Boleslav","Branky","Branov","Bratrikov","Brezi","Brezno","Brezolupy","Brezova","Brno","Brod","Brodce","Brodek","Broumov","Brtnice","Bruntal","Brusperk","Bucovice","Budyne nad Ohri","Bukovec","Bustehrad","Bylnice","Bystrice","Bystrice nad Pernstejnem","Bystrice pod Hostynem","Cakovice","Caslav","Cebin","Cechtice","Cejc","Cejkovice","Celadna","Celakovice","Cepi","Cercany","Cerekvice nad Loucnou","Cerhenice","Cerna Hora","Cerna za Bory","Cerncice","Cernosice","Cernotin","Cervene Pecky","Cerveny Kostelec","Ceska","Ceska Skalice","Ceska Trebova","Ceska Ves","Ceske Mezirici","Cesky Brod","Cesky Dub","Cestice","Cheb","Cheznovice","Chlumcany","Chlumec","Chlumec nad Cidlinou","Chlupice","Chocen","Chocerady","Chodov","Chodova Plana","Chomutov","Chotebor","Chotesov","Chotetov","Chotoviny","Choustnik","Choustnikovo Hradiste","Chrast","Chrastna","Chribska","Chroustovice","Chrudim","Chvalec","Chyne","Cista","Citoliby","Citov","Ckyne","Ctidruzice","Cvikov","Dalovice","Damnice","Darkovicky","Davle","Deblin","Dehylov","Dejvice","Desna","Detmarovice","Dily","Divisov","Dlouha Trebova","Dlouhe","Dobra","Dobra Voda","Dobrany","Dobre","Dobrichovice","Dobris","Dobriv","Dobronin","Dobroslavice","Dobruska","Doksy","Dolany","Dolni Becva","Dolni Benesov","Dolni Berkovice","Dolni Bojanovice","Dolni Brezany","Dolni Dunajovice","Dolni Jircany","Dolni Kounice","Dolni Nemci","Dolni Poustevna","Dolni Radechova","Dolni Sucha","Dolni Sytova","Dolni Terlicko","Dolni Zandov","Domasov","Domazelice","Domazlice","Doubravnik","Doubravy","Doudleby nad Orlici","Drahotuse","Drisy","Drnovice","Drzkov","Drzovice","Dubec","Dubenec","Dubi","Dubicko","Dubnany","Dubne","Duchcov","Dukovany","Dusejov","Dvorce","Dvur Kralove nad Labem","Dymokury","Ejpovice","Filipova","Francova Lhota","Frantiskovy Lazne","Frenstat pod Radhostem","Frydek-Mistek","Frydlant","Frydlant nad Ostravici","Frystak","Fulnek","Golcuv Jenikov","Grucovice","Habartov","Haj ve Slezsku","Haje","Hajnice","Halenkov","Hamr","Harrachov","Havrice","Hermanuv Mestec","Hlasna Treban","Hlinsko","Hlubocepy","Hlubocky","Hluboka nad Vltavou","Hlucin","Hodice","Hodslavice","Holasice","Holesov","Holice","Holoubkov","Holubice","Holysov","Horesedly","Horice","Horin","Horni Becva","Horni Benesov","Horni Bojanovice","Horni Briza","Horni Lutyne","Horni Nemci","Horni Pocernice","Horni Podluzi","Horni Redice","Horni Slavkov","Horomerice","Horousanky","Horovice","Horsovsky Tyn","Hospozin","Hosteradice","Hostice","Hostin","Hostinne","Hostivice","Hostomice","Hovezi","Hovorany","Hovorcovice","Hrabetice","Hradcovice","Hradec","Hradec nad Moravici","Hradek","Hradek nad Nisou","Hradiste","Hranice","Hrdejovice","Hronov","Hrusovany nad Jevisovkou","Hrusovany u Brna","Hudlice","Hukvaldy","Hulin","Humpolec","Hustopece","Hvozd","Hysly","Ivancice","Ivanovice na Hane","Jablonec nad Nisou","Jablonne nad Orlici","Jablonne v Podjestedi","Jablunka","Jablunkov","Jalubi","Janovice","Janovice nad Uhlavou","Jaromer","Jaroslav","Jaroslavice","Jedovnice","Jenec","Jesenice","Jesenik","Jevicko","Jevisovice","Jezov","Jihlava","Jilemnice","Jilove u Prahy","Jilovec","Jiloviste","Jince","Jindrichuv Hradec","Jinocany","Jirice","Jirickov","Jirkov","Jirny","Jistebnik","Kacerov","Kacice","Kadan","Kamenice","Kamenicky Senov","Kamenne Zehrovice","Kamenny Privoz","Kamyk","Kaplice","Karlin","Karlovy Vary","Karvina","Kaznejov","Kbely","Kdyne","Kladno","Klasterec nad Ohri","Klatovy","Klecany","Klicany","Klimkovice","Klobouky","Knezmost","Kochovice","Koci","Kolodeje","Komarice","Komorni Lhotka","Konice","Kopidlno","Koprivnice","Korycany","Kosmonosy","Kostelec na Hane","Kostelec nad Cernymi Lesy","Kostelec nad Labem","Kostelec nad Orlici","Kostelni Hlavno","Kostice","Kotencice","Kourim","Kouty","Kozmice","Kralice na Hane","Kraliky","Kralovice","Kralupy nad Vltavou","Kraluv Dvur","Kraslice","Krasna Hora nad Vltavou","Krasna Lipa","Kratonohy","Kravare","Krchleby","Krenovice","Krepenice","Kresice","Kretin","Krhova","Krivoklat","Krizanov","Krmelin","Krnov","Krnsko","Krouna","Krtiny","Krumvir","Krupka","Ktis","Kuncice","Kuncina","Kunovice","Kunratice","Kunstat","Kurim","Kvetnice","Kyjov","Kylesovice","Lachov","Ladvi","Lampertice","Lanskroun","Lanzhot","Lasenice","Lazne Bohdanec","Lazne Libverda","Ledec nad Sazavou","Lednice","Leskovec","Lesonice","Letohrad","Letovice","Lety","Lhota","Lhota pod Libcany","Lhotka","Liban","Libcany","Liberec","Libesice","Libeznice","Libice nad Cidlinou","Libis","Libocany","Libochovicky","Libos","Lichkov","Lichnov (o. Novy Jicin)","Line","Lipence","Lipnik nad Becvou","Lipova","Lisov","Litava","Liten","Litovel","Litvinov","Lodenice","Loket","Lomnice","Lomnice nad Luznici","Lomnice nad Popelkou","Loucany","Loucen","Loukov","Lounovice pod Blanikem","Louny","Lovosice","Lubenec","Luby","Luhacovice","Luka","Lukov","Lustenice","Lutin","Luze","Luzna","Lysa nad Labem","Lysice","Mala Skala","Malcice","Malenice","Malenovice","Malesov","Maly Ujezd","Marianska","Markvartovice","Marov u Upice","Mcely","Mechenice","Menany","Merklin","Mesice","Mestec","Mesto Touskov","Mezibori","Mezilesi","Michle","Mikulov","Mikulovice","Milevsko","Milikov","Milin","Milonice","Milotice","Milovice","Mimon","Miroslav","Mirosov","Mirosovice","Mlada Vozice","Mlade Buky","Mladkov","Mlazovice","Mnichovice","Mnisek pod Brdy","Modrice","Mohelnice","Mokra Horakov","Mokrany","Moran","Moravicany","Moravska Nova Ves","Moravska Trebova","Moravske Budejovice","Moravsky Beroun","Moravsky Krumlov","Moravsky Pisek","Moravsky Zizkov","Most","Mostek","Mosty u Jablunkova","Mratin","Mrlinek","Msec","Mseno","Mukarov","Mutenice","Nachod","Naklo","Napajedla","Nasavrky","Navsi u Jablunkova","Nechanice","Nedakonice","Nedomice","Nedvedice","Nehvizdy","Nejdek","Nelahozeves","Nenkovice","Nepomysl","Neratovice","Nesovice","Nezamyslice","Nezvestice","Nikolcice","Nivnice","Nova Cerekev","Nova Lhota","Nova Paka","Nova Vcelnice","Nova Ves","Nove Dvory","Nove Mesto na Morave","Nove Mesto nad Metuji","Nove Straseci","Nove Veseli","Novosedly","Novy Bor","Novy Bydzov","Novy Hrozenkov","Novy Jicin","Novy Knin","Novy Oldrichov","Nucice","Nupaky","Nydek","Nymburk","Nyrany","Nyrsko","Obrany","Obristvi","Ochoz","Odolena Voda","Odry","Ohrobec","Okrisky","Olomouc","Olomucany","Olovi","Olsany","Ondrejov","Oparany","Opatovice nad Labem","Opava","Opocno","Orlova","Osecna","Osek","Osik","Oslavany","Ostopovice","Ostrava","Ostromer","Ostrov","Ostrov u Macochy","Ostrozska Lhota","Ostrozska Nova Ves","Otnice","Otrokovice","Pacov","Palkovice","Pardubice","Pariz","Pavlice","Pchery","Pecin","Pecky","Pelhrimov","Perstejn","Petrovice","Petrovice u Karvine","Petrvald","Pilsen","Pisecna","Pistovice","Plana","Planany","Plouznice","Pocatky","Pocenice","Podborany","Podebrady","Podivin","Polepy","Polesovice","Police nad Metuji","Policka","Polna","Poricany","Poritsch","Postoloprty","Postrelmov","Potstejn","Prachatice","Prackovice nad Labem","Prague","Prazmo","Preckov","Predklasteri","Predmerice nad Jizerou","Predmerice nad Labem","Predmesti","Prelouc","Prepere","Prerov nad Labem","Prestice","Prezletice","Pribor","Pribyslav","Prikazy","Primda","Prlov","Prosetin","Protivin","Provodov","Pruhonice","Prusanky","Psary","Pustejov","Pysely","Radim","Radnice","Radostice","Radostin","Radun","Raj","Rajec-Jestrebi","Rajecko","Rakovnik","Rapotice","Rapotin","Raspenava","Rataje","Ratibor","Ratiskovice","Rebesovice","Repy","Ricany","Rikovice","Ritka","Rokycany","Rokytnice","Rokytnice nad Jizerou","Ronov nad Doubravou","Rosice","Roudnice nad Labem","Roudnicek","Rousinov","Rovensko pod Troskami","Rovina","Rovna","Rozdrojovice","Rozmital pod Tremsinem","Roznov pod Radhostem","Rozsochatec","Roztoky","Rtyne","Ruda nad Moravou","Rudikov","Rudna","Rudolfov","Rudoltice","Rybna","Rychnov","Rychnov nad Kneznou","Rychvald","Rymarov","Sadska","Sanov","Sany","Satov","Seberov","Sebrov","Sedlcany","Sedlec","Sedliste","Seibersdorf","Semily","Senec","Senice na Hane","Senohraby","Senov","Sestajovice","Sezemice","Sibrina","Silherovice","Siluvky","Sivice","Skalice","Skalsko","Skripov","Skuhrov nad Belou","Skutec","Slany","Slapanice","Slapy","Slavicin","Slavkov u Brna","Slavonice","Sloup","Sluknov","Slusovice","Smirice","Smrzovka","Snedovice","Snezne","Sobeslav","Sobotka","Sokolov","Spalene Porici","Spytihnev","Stalkov","Stankov","Stara Paka","Stara Voda","Stare Mesto","Stare Sedliste","Starec","Starovice","Starovicky","Stary Bydzov","Statenice","Stenovice","Stepanov","Sterboholy","Sternberk","Steti","Stezery","Stitina","Stity","Stochov","Stod","Stoky","Strachotice","Strachotin","Strakonice","Strancice","Strasice","Straz nad Nisou","Straz pod Ralskem","Strazek","Straznice","Strelice","Stribrec","Stribrna Skalice","Stribro","Stritez nad Ludinou","Strunkovice nad Blanici","Studenka","Sucha Loz","Sudkov","Sumice","Sumperk","Susice","Svatava","Svaty Jan nad Malsi","Svetla nad Sazavou","Sviadnov","Svihov","Svitavka","Svitavy","Svojek","Svojkov","Syrovice","Tachlovice","Tachov","Tehov","Telc","Telnice","Temice","Teplice","Tesetice","Tetin","Tisice","Tisnov","Tlumacov","Tman","Tosovice","Trebechovice pod Orebem","Trebestovice","Trebon","Tremesna","Tremosna","Trhovy Stepanov","Trinec","Trmice","Troja","Trstenice","Trutnov","Tucapy","Tuchlovice","Tuchomerice","Tupesy","Turnov","Tursko","Tvarozna","Tvrdonice","Tynec nad Sazavou","Tyniste nad Orlici","Uhersky Brod","Uhersky Ostroh","Uhonice","Uhrice","Ujezd","Ujezd nad Lesy","Unetice","Unicov","Usti nad Orlici","Ustin","Uvaly","Uzice","Vacenovice","Valasske Klobouky","Valasske Mezirici","Valtice","Vamberk","Varnsdorf","Vcelna","Velehrad","Velesin","Velesovice","Velka Bites","Velka Bystrice","Velka Dobra","Velka Jesenice","Velka Polom","Velke Albrechtice","Velke Brezno","Velke Heraltice","Velke Hydcice","Velke Losiny","Velke Mezirici","Velke Opatovice","Velke Popovice","Velke Prilepy","Velke Svatonovice","Velky","Velky Borek","Velky Osek","Veltrusy","Velvary","Vendryne","Vernovice","Veseli nad Luznici","Veseli nad Moravou","Veverska Bityska","Veverske Kninice","Vidce","Vimperk","Vinarice","Vinicne Sumice","Visnove","Vitkov","Vizovice","Vlachovice","Vladislav","Vlasim","Vlastislav","Vlcovice","Vochov","Vodnany","Vojkovice","Volyne","Votice","Vracov","Vrane nad Vltavou","Vratimov","Vratkov","Vrbice","Vrbno pod Pradedem","Vrchlabi","Vresina","Vsechovice","Vselibice","Vsenory","Vsestary","Vsetaty","Vsetin","Vtelno","Vyprachtice","Vysker","Vysoka","Vysoka nad Labem","Vysoke Myto","Vysoke Veseli","Zabcice","Zabreh","Zadni Treban","Zajeci","Zamberk","Zampach","Zandov","Zasova","Zatcany","Zborovice","Zbuch","Zbysov","Zdanice","Zdeslav","Zdiby","Zdice","Zdirec","Zdounky","Zehun","Zelenec","Zelenka","Zelesice","Zeletava","Zeleznice","Zelezny Brod","Zeliv","Zeravice","Zidlochovice","Zilina","Zipotin","Zizkov","Zlata","Zlate Hory","Zlicin","Zliv","Znojmo","Zubri","Zulova","Zvole"]},"DE":{"id":"DE","name":"Germany","timezones":["Europe/Zurich","Europe/Berlin"],"cities":["Aach","Aachen","Aalen","Abbensen","Abberode","Abenberg","Abensberg","Abstatt","Abtsbessingen","Abtsgmuend","Abtswind","Abtweiler","Achern","Achim","Achstetten","Adelebsen","Adelheidsdorf","Adelmannsfelden","Adelschlag","Adelsdorf","Adelsheim","Adelshofen","Adelsried","Adenau","Adenbuettel","Adendorf","Adlkofen","Adlum","Adorf","Aerzen","Affalterbach","Affaltern","Affing","Affinghausen","Aftholderberg","Aglasterhausen","Ahaus","Ahausen","Ahlen","Ahlhorn","Aholfing","Aholming","Ahorn","Ahrbruck","Ahrensboek","Ahrensbok","Ahrensburg","Ahrensfelde","Ahrenshagen","Ahrensmoor","Ahstedt","Aicha vorm Wald","Aichach","Aichelberg","Aichhalden","Aichstetten","Aichtal","Aichwald","Aidenbach","Aidlingen","Aindling","Aindorf","Ainring","Aislingen","Aitrach","Aitrang","Aken","Albaching","Albbruck","Albeck","Albersdorf","Albershausen","Albersweiler","Albertshausen","Albig","Albisheim","Albrechts","Albstadt","Aldekerk","Aldenhoven","Aldersbach","Aldingen","Alesheim","Aletshausen","Alexander","Alfdorf","Alfeld","Alfhausen","Alfstedt","Alfter","Algermissen","Alheim","Allee","Allendorf","Allensbach","Allersberg","Allershausen","Alleshausen","Alling","Allmannshofen","Allmendingen","Allmersbach im Tal","Allstedt","Almstedt","Alpen","Alpenrod","Alperstedt","Alpirsbach","Alsbach","Alsbach-Hahnlein","Alsdorf","Alsfeld","Alsheim","Alt Buchhorst","Alt Bukow","Alt Golm","Alt Ruppin","Alt Schwerin","Altbach","Altbelgern","Altdobern","Altdorf","Alteglofsheim","Alten","Altena","Altenahr","Altenau","Altenbeken","Altenberg","Altenberge","Altenburg","Altendiez","Altenglan","Altengottern","Altengronau","Altenhasslau","Altenholz","Altenkirchen","Altenkrempe","Altenkunstadt","Altenmarkt","Altenmedingen","Altenmunster","Altenriet","Altenstadt","Altensteig","Altenthann","Altentreptow","Alterhofen","Altersbach","Altfraunhofen","Althegnenberg","Altheim","Althengstett","Althutte","Altingen","Altkirchen","Altlandsberg","Altleiningen","Altlussheim","Altmannstein","Altoetting","Altomunster","Altrip","Altshausen","Altstadt","Alttechau","Altusried","Altwittenbek","Alveslohe","Alzenau in Unterfranken","Alzey","Am Mellensee","Am See","Amberg","Amelinghausen","Amerang","Ammern","Ammerndorf","Amoneburg","Amorbach","Ampermoching","Ampfing","Amstetten","Amtzell","Andechs","Anderlingen","Andernach","Andreasberg","Anger","Angermunde","Angern","Anker","Ankershagen","Anklam","Ankum","Annaberg-Buchholz","Annaburg","Annerod","Annweiler am Trifels","Anrath","Anrochte","Ansbach","Antdorf","Anzing","Apen","Apenburg","Apensen","Apfeldorf","Apfelstadt","Apolda","Appel","Appen","Appenweier","Arberg","Arenrath","Arensdorf","Arenshausen","Aresing","Arft","Argenthal","Arlaching","Arlewatt","Armsheim","Armstorf","Arnbach","Arnbruck","Arnsberg","Arnschwang","Arnsdorf","Arnstadt","Arnstein","Arnstorf","Arrach","Artern","Artlenburg","Arzbach","Arzberg","Asbach","Asbach-Baumenheim","Ascha","Aschaffenburg","Aschau","Ascheberg","Ascheffel","Aschendorf","Aschersleben","Aschheim","Asendorf","Aspach","Asperg","Aspisheim","Assel","Assenheim","Asslar","Assling","Astfeld","Atteln","Attendorn","Attenkirchen","Attenweiler","Atting","Atzendorf","Au","Au am Rhein","Au in der Hallertau","Aub","Aue","Auen","Auenstein","Auerbach","Aufhausen","Auggen","Augsburg","Augustdorf","Augustfehn","Augustusburg","Aukrug","Aulendorf","Aull","Auma","Aumuhle","Aurach","Aurachtal","Aurich","Autenzell","Auw","Axstedt","Aying","Ayl","Baar-Ebenhausen","Baasdorf","Baasem","Babenhausen","Babensham","Babow","Bach","Bach an der Donau","Bacharach","Bachhagel","Bachingen an der Brenz","Backnang","Bad Abbach","Bad Aibling","Bad Alexandersbad","Bad Arolsen","Bad Bellingen","Bad Bentheim","Bad Bergzabern","Bad Berka","Bad Berleburg","Bad Berneck im Fichtelgebirge","Bad Bevensen","Bad Bibra","Bad Blankenburg","Bad Bocklet","Bad Boll","Bad Bramstedt","Bad Breisig","Bad Buchau","Bad Camberg","Bad Ditzenbach","Bad Doberan","Bad Driburg","Bad Duben","Bad Duerkheim","Bad Durrenberg","Bad Durrheim","Bad Eilsen","Bad Elster","Bad Ems","Bad Endbach","Bad Endorf","Bad Essen","Bad Fallingbostel","Bad Feilnbach","Bad Frankenhausen","Bad Freienwalde","Bad Fussing","Bad Gandersheim","Bad Godesberg","Bad Gogging","Bad Gottleuba","Bad Griesbach","Bad Grund","Bad Harzburg","Bad Heilbrunn","Bad Herrenalb","Bad Hersfeld","Bad Hindelang","Bad Homburg","Bad Honnef","Bad Honningen","Bad Iburg","Bad Karlshafen","Bad Kissingen","Bad Kleinen","Bad Klosterlausnitz","Bad Kohlgrub","Bad Konig","Bad Konigshofen im Grabfeld","Bad Kosen","Bad Kostritz","Bad Kreuznach","Bad Krozingen","Bad Laasphe","Bad Laer","Bad Langensalza","Bad Lauchstadt","Bad Lausick","Bad Lauterberg im Harz","Bad Liebenstein","Bad Liebenwerda","Bad Liebenzell","Bad Lippspringe","Bad Lobenstein","Bad Marienberg","Bad Mergentheim","Bad Munder am Deister","Bad Munster am Stein-Ebernburg","Bad Munstereifel","Bad Muskau","Bad Nauheim","Bad Nenndorf","Bad Neuenahr-Ahrweiler","Bad Neustadt an der Saale","Bad Oeynhausen","Bad Oldesloe","Bad Orb","Bad Peterstal-Griesbach","Bad Pyrmont","Bad Rappenau","Bad Reichenhall","Bad Rippoldsau-Schapbach","Bad Rothenfelde","Bad Saarow","Bad Sachsa","Bad Sackingen","Bad Salzdetfurth","Bad Salzschlirf","Bad Salzuflen","Bad Salzungen","Bad Sassendorf","Bad Schachen","Bad Schandau","Bad Schmiedeberg","Bad Schussenried","Bad Schwalbach","Bad Schwartau","Bad Segeberg","Bad Soden am Taunus","Bad Soden-Salmunster","Bad Sooden-Allendorf","Bad Staffelstein","Bad Steben","Bad Sulza","Bad Teinach-Zavelstein","Bad Tennstedt","Bad Toelz","Bad Uberkingen","Bad Urach","Bad Vilbel","Bad Waldsee","Bad Wiessee","Bad Wildbad im Schwarzwald","Bad Wildungen","Bad Wilsnack","Bad Wimpfen","Bad Windsheim","Bad Worishofen","Bad Wurzach","Bad Zwischenahn","Badbergen","Baddeckenstedt","Badem","Baden-Baden","Badenhausen","Badenweiler","Badow","Badra","Baesweiler","Bahlingen","Bahratal","Bahrdorf","Bahrenfleth","Baienfurt","Baierbrunn","Baiern","Baiersbronn","Baiersdorf","Baindt","Bakum","Baldham","Balgheim","Balingen","Ballendorf","Ballenstedt","Ballersbach","Ballrechten","Ballstadt","Baltmannsweiler","Baltringen","Baltrum","Balve","Bamberg","Bamlach","Bammental","Bank","Bankewitz","Bann","Bannberscheid","Bannemin","Bannewitz","Banteln","Banzkow","Barbelroth","Barbing","Barby","Barchfeld","Bardenberg","Bardowick","Barendorf","Barenstein","Barenthal","Bargenstedt","Bargfeld-Stegen","Barghorst","Bargstedt","Bargteheide","Bargum","Barkelsby","Barkenholm","Barkow","Barleben","Barmstedt","Barnau","Barnstorf","Barntrup","Barsbuettel","Barsinghausen","Barssel","Barstadt","Barth","Bartholoma","Bartow","Barum","Baruth","Barwedel","Basel","Bassenheim","Bassum","Bastheim","Bastorf","Battenberg","Batzhausen","Baudenbach","Baumholder","Baunach","Baunatal","Bausendorf","Bautzen","Bawinkel","Bayenthal","Bayerbach","Bayerisch Eisenstein","Bayerisch Gmain","Bayern","Bayersoien","Bayreuth","Bayrischzell","Beaumarais","Bebra","Becheln","Becherbach","Bechhofen","Bechtolsheim","Beckdorf","Beckedorf","Beckeln","Beckingen","Beckstedt","Beckum","Bedburdyck","Bedburg","Bederkesa","Beedenbostel","Beelen","Beelitz","Beerfelden","Beeskow","Beesten","Beetzendorf","Beetzsee","Behrendorf","Behrenhoff","Behringen","Beierfeld","Beiersdorf","Beierstedt","Beilngries","Beilrode","Beilstein","Beim Kronsberg","Beimerstetten","Beindersheim","Beinerstadt","Bekond","Belecke","Belgern","Belgershain","Bell","Bellamont","Bellenberg","Bellershausen","Bellheim","Belm","Beltheim","Belum","Belzig","Bemerode","Bempflingen","Bendeleben","Bendestorf","Bendfeld","Bendorf","Benediktbeuern","Benneckenstein","Benningen","Benningen am Neckar","Bennungen","Bensberg","Benshausen","Bensheim","Bentfeld","Bentwisch","Benz","Benzingerode","Beratzhausen","Berching","Berchtesgaden","Berg","Berga","Bergbau","Berge","Bergen","Bergen auf Ruegen","Bergfelde","Berggiesshubel","Berghaupten","Berghausen","Bergheim","Berghulen","Bergisch Gladbach","Bergkamen","Bergkirchen","Berglern","Berglicht","Bergneustadt","Bergrheinfeld","Bergtheim","Bergweiler","Berka","Berkenthin","Berkheim","Berlin","Berlingerode","Bermatingen","Bermbach","Bermersheim","Bermuthshain","Bernau","Bernau am Chiemsee","Bernau bei Berlin","Bernburg","Berne","Berngau","Bernhardswald","Bernkastel-Kues","Bernried","Bernsbach","Bernsdorf","Bernstadt","Bernterode","Berod bei Wallmerod","Bersenbruck","Berumbur","Berzdorf","Bescheid","Besigheim","Besitz","Bestensee","Bestwig","Betheln","Bettingen","Betzdorf","Betzendorf","Betzenstein","Betzigau","Beucha","Beuern","Beuren","Bevern","Beverstedt","Beverungen","Bexbach","Bexhovede","Biberach an der Riss","Biberbach","Biblis","Biburg","Bichl","Bickenbach","Biebelsheim","Bieber","Biebesheim","Biedenkopf","Biederitz","Bielefeld","Bienenbuttel","Bienstadt","Biere","Bierlingen","Biesenthal","Biesingen","Biessenhofen","Bietigheim","Bietigheim-Bissingen","Bietingen","Bilk","Billerbeck","Billigheim","Billigheim-Ingenheim","Billings","Billingshausen","Bimohlen","Binau","Bindlach","Bingen","Bingen am Rhein","Binsfeld","Binzen","Bippen","Birenbach","Birkenau","Birkenfeld","Birkenheide","Birkenhof","Birkenlohe","Birkenwerder","Birkheim","Birlenbach","Birlinghoven","Birnbach","Birstein","Bischberg","Bischheim","Bischoffen","Bischofferode","Bischofsgrun","Bischofsheim","Bischofsheim an der Rhon","Bischofsmais","Bischofswerda","Bischofswiesen","Bischweier","Bisingen","Bismark","Bispingen","Bissendorf","Bissingen","Bissingen an der Teck","Bistensee","Bitburg","Bitterfeld-Wolfen","Bitz","Blaibach","Blaichach","Blankenburg","Blankenfelde","Blankenhagen","Blankenhain","Blankenheim","Blankenloch","Blankenrath","Blankensee","Blankenstein","Blatzheim","Blaubeuren Abbey","Blechhammer","Bleckede","Bleckenrode","Bleialf","Bleicherode","Blender","Bliesdorf","Blieskastel","Bliesmengen-Bolchen","Blievenstorf","Blitzenreute","Blomberg","Blomesche Wildnis","Blumberg","Blume","Blumenthal","Bobbau","Bobenheim am Berg","Bobenheim-Roxheim","Bobingen","Bobrach","Bocholt","Bochum","Bocka","Bockau","Bockelwitz","Bockenau","Bockenem","Bockenheim","Bockhorn","Bockhorst","Boddenstedt","Boddin","Bodelshausen","Boden","Bodenfelde","Bodenheim","Bodenkirchen","Bodenmais","Bodensee","Bodenteich","Bodenwerder","Bodenwohr","Bodman-Ludwigshafen","Bodolz","Boel","Boffzen","Bofingen","Bogen","Bogenhausen","Bohl-Iggelheim","Bohlen","Bohmenkirch","Bohmstedt","Bohmte","Bohringen","Boich","Boizenburg","Boklund","Bolanden","Boldebuck","Boldela","Bollendorf","Bollingstedt","Bollschweil","Bollstein","Bolsterlang","Bomlitz","Bondorf","Bonebuttel","Bonefeld","Bonen","Bonn","Bonndorf im Schwarzwald","Bonnigheim","Bonningstedt","Bonstetten","Boos","Boostedt","Bopfingen","Boppard","Bordelum","Bordesholm","Borgdorf-Seedorf","Borgentreich","Borger","Borgholzhausen","Borgsdorf","Borgstedt","Borgsum","Borken","Borkheide","Borkum","Borkwalde","Born","Borna","Borne","Bornheim","Bornhoved","Bornich","Bornitz","Bornsen","Bornstein","Borsdorf","Borsfleth","Borstel","Borstel-Hohenraden","Bortlingen","Bosau","Bosel","Bosingen","Bosleben-Wullersleben","Botersen","Bothkamp","Bottrop","Botzingen","Bous","Bovenden","Boxberg","Brachbach","Brackel","Brackenheim","Brake (Unterweser)","Brakel","Bramsche","Bramstedt","Brand","Brand-Erbisdorf","Brande-Hornerkirchen","Brandenburg","Brandis","Brandl","Brandshagen","Brannenburg","Braubach","Braunfels","Braunlage","Braunlingen","Braunsbach","Braunsbedra","Braunschweig","Brauweiler","Brebel","Breckerfeld","Breddenberg","Breddorf","Bredenbek","Bredeney","Bredstedt","Breesen","Breest","Bregenstedt","Breidenbach","Breiholz","Breisach","Breit","Breitbrunn am Chiemsee","Breitenau","Breitenbach","Breitenbach am Herzberg","Breitenberg","Breitenbrunn","Breitenburg","Breitenfelde","Breitengussbach","Breitenworbis","Breitnau","Breitscheid","Breitscheidt","Breitungen","Brekendorf","Bremen","Bremerhaven","Bremervorde","Brennberg","Brensbach","Brenz","Bretten","Bretthausen","Bretzfeld","Breuna","Brey","Brickeln","Brieselang","Brieske","Brieskow-Finkenheerd","Brietlingen","Brilon","Britz","Brockum","Brodersby","Broderstorf","Brodhagen","Broeckel","Brokdorf","Brokstedt","Brome","Bromskirchen","Brotterode","Bruch","Bruchhausen","Bruchhausen-Vilsen","Bruchkobel","Bruchmuhlbach-Miesau","Bruchsal","Bruchweiler","Bruck","Bruck in der Oberpfalz","Bruckberg","Brucken","Bruckmuhl","Brucktal","Bruel","Bruggen","Bruhl","Brunn","Brunnthal","Brunsbuttel","Brunstorf","Brusewitz","Brussow","Bubenheim","Bubenreuth","Bubesheim","Buborn","Buch","Buch am Buchrain","Buch am Erlbach","Bucha","Buchbach","Buchberg","Buchel","Buchen","Buchenbach","Buchenberg","Buchfart","Buchholz","Buchholz in der Nordheide","Buchlberg","Buchloe","Buchwaldchen","Buchwalde","Buckeburg","Buckenhof","Buckow","Buden","Budenheim","Budingen","Bueddenstedt","Buedelsdorf","Buende","Buggingen","Buhl","Buhlen","Buhler","Buhlerhohe","Buhlertal","Buhlertann","Buhlerzell","Bulkau","Bullay","Bulow","Bulowerburg","Bunde","Bundenthal","Bunsoh","Burbach","Buren","Burg","Burg auf Fehmarn","Burg bei Magdeburg","Burg Stargard","Burg-Grambke","Burgau","Burgberg","Burgbernheim","Burgbrohl","Burgdorf, Hanover","Burgebrach","Burgen","Burgerhof","Burghaslach","Burghaun","Burghausen","Burgheim","Burgkirchen an der Alz","Burgkunstadt","Burglauer","Burglengenfeld","Burgoberbach","Burgrieden","Burgschwalbach","Burgsinn","Burgsponheim","Burgstadt","Burgstall","Burgstetten","Burgthann","Burgwedel","Burgwindheim","Burk","Burkardroth","Burkau","Burkhardtsdorf","Burladingen","Burscheid","Burstadt","Burtenbach","Burweg","Buschbell","Buschhausen","Busdorf","Busenberg","Butjadingen","Buttelborn","Buttelstedt","Buttenheim","Buttenwiesen","Butthard","Buttstedt","Butzbach","Butzow","Buxheim","Buxtehude","Cadenberge","Cadolzburg","Calau","Calbe","Calberlah","Calden","Callbach","Callenberg","Calvorde","Calw","Cambs","Camin","Cannewitz","Cappel","Cappeln","Caputh","Carlow","Carlsberg","Carmzow","Carolinensiel","Castrop-Rauxel","Catterfeld","Celle","Cham","Chamerau","Chemnitz","Chieming","Chiemsee","Chostlarn","Clausen","Claussnitz","Clausthal","Clausthal-Zellerfeld","Cleebronn","Cloppenburg","Coburg","Cochem","Coesfeld","Colbe","Colbitz","Colditz","Colmnitz","Colnrade","Cologne","Contwig","Coppenbrugge","Coppengrave","Cornberg","Coswig","Cottbus","Crailsheim","Cramonshagen","Cranz","Cremlingen","Creussen","Creuzburg","Crimmitschau","Crinitz","Crivitz","Crossen","Crostau","Crottendorf","Cunewalde","Cuxhaven","Daaden","Dabel","Dabelow","Dabendorf","Dabergotz","Dachau","Dachwig","Dackscheid","Dagersheim","Dahlem","Dahlen","Dahlenburg","Dahlenwarsleben","Dahlewitz","Dahme","Dahn","Dahnsdorf","Dallgow-Doeberitz","Dalum","Dambeck","Damlos","Damme","Damp","Danischenhagen","Dankenfeld","Dankmarshausen","Danndorf","Dannenberg","Dannstadt-Schauernheim","Dardesheim","Darmstadt","Darstein","Dasing","Dassel","Dassendorf","Dassow","Datteln","Dattenberg","Dauborn","Dauchingen","Daun","Dausenau","Deckenpfronn","Dedeleben","Dedelstorf","Dederstedt","Degerloch","Deggendorf","Deggenhausen","Deggingen","Deidesheim","Deilingen","Deining","Deiningen","Deinste","Deisenhofen","Deisslingen","Deizisau","Delbruck","Delingsdorf","Delitzsch","Dellfeld","Delligsen","Dellmensingen","Delmenhorst","Delve","Demitz-Thumitz","Demmin","Denkendorf","Denkingen","Denklingen","Densborn","Dentlein am Forst","Denzlingen","Derben","Derenburg","Dermbach","Dernau","Dernbach","Derschen","Dersum","Dessau","Dessow","Destedt","Detern","Detmold","Dettelbach","Dettenhausen","Dettighofen","Dettingen an der Erms","Dettingen an der Iller","Dettingen unter Teck","Dettmannsdorf","Deutsch","Deutsch Evern","Deutsches Haus","Deutz","Deutzen","Dexheim","Diana","Dibbersen","Diebach","Dieblich","Dieburg","Diedersdorf","Diedorf","Diefflen","Diekholzen","Dielheim","Dielingen","Dienheim","Dienstweiler","Diepenau","Diepersdorf","Diepholz","Dierdorf","Dierkow","Dieskau","Diessen am Ammersee","Dietenheim","Dietenhofen","Dietersburg","Dietersheim","Dietfurt","Dietingen","Dietlingen","Dietmannsried","Dietramszell","Dietrichingen","Dietzenbach","Diez","Dillenburg","Dillingen","Dillingen an der Donau","Dingelstadt","Dingelstedt","Dingolfing","Dingolshausen","Dingstede","Dinkelscherben","Dinklage","Dinslaken","Dintesheim","Dipbach","Dippach","Dipperz","Dippoldiswalde","Dirlewang","Dirmingen","Dirmstein","Dischingen","Dissen","Ditfurt","Dittelbrunn","Dittelsdorf","Dittelsheim-Hessloch","Dittenheim","Dittweiler","Ditzingen","Dobel","Dobeln","Doberlug-Kirchhain","Doberschau","Doberschutz","Dobitschen","Dobler","Dobra","Dockingen","Dogern","Dohlau","Dohle","Dohna","Dohren","Dolgesheim","Dollern","Dollnstein","Dombuhl","Domitz","Dommitzsch","Domsdorf","Domsuhl","Donaueschingen","Donaustauf","Donndorf","Donnersdorf","Donsieders","Donzdorf","Dorentrup","Dorf","Dorf Doberitz","Dorfen","Dorfles","Dorfprozelten","Dormagen","Dormettingen","Dornburg","Dorndorf","Dornhan","Dornheim","Dornstadt","Dornstetten","Dornum","Dorpen","Dorpstedt","Dorstadt","Dorsten","Dorth","Dortmund","Dorum","Dorverden","Dorzbach","Dossenheim","Dotlingen","Dotternhausen","Drachselsried","Drage","Dransfeld","Dranske","Drebach","Drebkau","Dreetz","Dreieich","Dreikirchen","Dreis","Dreisbach","Drelsdorf","Drensteinfurt","Dresden","Drestedt","Dreveskirchen","Driedorf","Driftsethe","Drochtersen","Drolshagen","Droyssig","Drubeck","Duchelsdorf","Ducherow","Duchroth","Dudenhofen","Duderode","Duderstadt","Duggendorf","Duingen","Duisburg","Dulmen","Dummerstorf","Dungenheim","Dunningen","Dunnwald","Dunzweiler","Durach","Durbach","Durbheim","Durchhausen","Durlangen","Durmentingen","Durmersheim","Durnau","Durrbrunn","Dusseldorf","Dusslingen","Ebeleben","Ebelsbach","Ebendorf","Ebensfeld","Ebenweiler","Eberbach","Eberdingen","Eberhardzell","Ebermannsdorf","Ebermannstadt","Ebern","Ebernhahn","Ebersbach","Ebersbach an der Fils","Ebersberg","Ebersdorf","Ebershausen","Eberstadt","Eberswalde","Ebertsheim","Ebhausen","Ebnat","Ebrach","Ebringen","Ebstorf","Eching","Echterdingen","Echzell","Eckartsberg","Eckartsberga","Eckernforde","Eckersdorf","Eckfeld","Ecklingerode","Eddelak","Edelsfeld","Edemissen","Eden","Edenkoben","Ederheim","Edesheim","Edewecht","Edingen-Neckarhausen","Edling","Effelder","Effeltrich","Efringen-Kirchen","Egeln","Egelsbach","Egenhausen","Egenhofen","Egesheim","Egestorf","Egg an der Gunz","Eggebek","Eggenfelden","Eggenstein-Leopoldshafen","Eggenthal","Eggersdorf","Eggesin","Eggingen","Egglham","Eggolsheim","Eggstatt","Eging","Egling","Egloffstein","Egmating","Ehekirchen","Ehingen","Ehlscheid","Ehndorf","Ehningen","Ehrenberg","Ehrenburg","Ehrenfeld","Ehrenfriedersdorf","Ehringshausen","Eibau","Eibelshausen","Eibelstadt","Eibenstock","Eibsee","Eich","Eichelgarten","Eichen","Eichenau","Eichenbarleben","Eichenberg","Eichenbuhl","Eichendorf","Eichenzell","Eicherloh","Eichstaett","Eichstedt","Eichstetten","Eichtersheim","Eichwalde","Eicklingen","Eigeltingen","Eilenburg","Eilenburg, Berg","Eilsleben","Eime","Eimeldingen","Eimsheim","Einbeck","Einhaus","Einhausen","Einsbach","Einselthum","Eiselfing","Eisenach","Eisenbach","Eisenberg","Eisfeld","Eisingen","Eislingen","Eitelborn","Eitensheim","Eiterfeld","Eitorf","Eitting","Elbe","Elbingerode","Eldena","Eldingen","Elend","Elfershausen","Elgersburg","Elisabeth-Sophien-Koog","Elkenroth","Ellefeld","Ellenberg","Ellerau","Ellerbek","Ellerdorf","Ellerhoop","Ellerstadt","Ellgau","Ellhofen","Ellingen","Ellrich","Ellwangen","Ellzee","Elm","Elmenhorst","Elmlohe","Elmpt","Elmshorn","Elmstein","Elsdorf","Elsdorf-Westermuhlen","Elsendorf","Elsenfeld","Elsfleth","Elster","Elsterberg","Elsterwerda","Elstorf","Elstra","Elterlein","Eltmann","Eltville","Elxleben","Elz","Elzach","Elze","Embsen","Emden","Emerkingen","Emlichheim","Emmelshausen","Emmendorf","Emmerich","Emmering","Emmerzhausen","Emmingen-Liptingen","Empfertshausen","Empfingen","Emsburen","Emsdetten","Emskirchen","Emstal","Emstek","Emtinghausen","Emtmannsberg","Endingen","Engden","Engelsberg","Engelsbrand","Engelsburg","Engelshof","Engelskirchen","Engelstadt","Engelthal","Engen","Enger","Eningen unter Achalm","Enkenbach-Alsenborn","Enkirch","Ennepetal","Ennigerloh","Ensdorf","Ensen","Entringen","Epfenbach","Epfendorf","Eppelborn","Eppelheim","Eppelsheim","Eppenbrunn","Eppendorf","Eppenrod","Eppertshausen","Eppingen","Eppishausen","Eppstein","Erbach","Erbach im Odenwald","Erbendorf","Erbes-Budesheim","Erda","Erdeborn","Erding","Erdmannhausen","Erdweg","Eresing","Erfde","Erfelden","Erftstadt","Erfurt","Ergersheim","Ergolding","Ergoldsbach","Erika","Ering","Eriskirch","Erkelenz","Erkheim","Erkner","Erkrath","Erlabrunn","Erlach","Erlangen","Erlau","Erlbach","Erlenbach","Erlenbach am Main","Erlenbach bei Marktheidenfeld","Erlenmoos","Erlensee","Erligheim","Ermershausen","Ermke","Erndtebruck","Ernsgaden","Ernst","Ernsthof","Ernstroda","Ernstthal","Erolzheim","Erpel","Erpolzheim","Ersingen","Ertingen","Erwitte","Erzenhausen","Erzhausen","Erzingen","Eschach","Eschau","Eschbach","Eschborn","Escheburg","Eschede","Eschelbronn","Eschenbach","Eschenlohe","Eschershausen","Eschfeld","Eschlkam","Eschwege","Eschweiler","Esens","Esgrus","Eslarn","Eslohe","Espelkamp","Espelkamp-Mittwald","Espenau","Espenhain","Essel","Esselborn","Essen","Essenbach","Essenheim","Essingen","Esslingen am Neckar","Estenfeld","Esterwegen","Esthal","Estorf","Etschberg","Etteln","Ettenheim","Ettenstatt","Ettersburg","Etterschlag","Ettleben","Ettlingen","Ettringen","Etzelwang","Etzenricht","Euerbach","Euerdorf","Eurasburg","Euskirchen","Eussenheim","Eutin","Eutingen","Everode","Eversmeer","Everswinkel","Evessen","Ewersbach","Eydelstedt","Eyendorf","Eystrup","Fachbach","Fahrdorf","Fahrenbach","Fahrendorf","Fahrenkrug","Fahrenzhausen","Fahrland","Faid","Falkenberg","Falkendorf","Falkenfels","Falkensee","Falkenstein","Fallersleben","Falls","Fambach","Farchant","Fargau-Pratjau","Farnroda","Farnstadt","Fassberg","Fatschenbrunn","Faulbach","Fehl-Ritzhausen","Fehmarn","Fehrbellin","Feilbingert","Feilitzsch","Feldafing","Feldberg","Feldberg-Ort","Felde","Feldkirchen","Feldkirchen-Westerham","Feldrennach","Fell","Fellbach","Felm","Felsberg","Ferchesar","Fernthal","Festenburg","Feucht","Feuchtwangen","Feusdorf","Fichtelberg","Fichtenberg","Fichtenwalde","Filderstadt","Filsen","Filsum","Filzen","Fincken","Finkenbach","Finnentrop","Finningen","Finowfurt","Finsing","Finsterwalde","Fintel","Firrel","Fischach","Fischbach","Fischbachau","Fischen","Fischerbach","Fischerhude","Fischingen","Flachslanden","Flacht","Flammersfeld","Flechtingen","Fleckeby","Flecken Zechlin","Flein","Fleisbach","Flensburg","Flieden","Flinsbach","Flintbek","Flintsbach","Floha","Flomborn","Flonheim","Florsheim","Florstadt","Floss","Flothe","Flurstedt","Fockbek","Fohren","Fohren-Linden","Forbach","Forchheim","Forchtenberg","Forheim","Forst","Forstern","Forsthaus","Forstinning","Frammersbach","Frankenau","Frankenberg","Frankenheim","Frankenstein","Frankenthal","Frankenwinheim","Frankfurt (Oder)","Frankfurt am Main","Frankisch-Crumbach","Frankweiler","Franzenheim","Frasdorf","Frauenau","Frauendorf","Frauenstein","Fraunberg","Fraureuth","Frechen","Freckenfeld","Freckenhorst","Fredelsloh","Freden","Fredersdorf","Freiberg","Freiberg am Neckar","Freiburg","Freihung","Freilassing","Freimersheim","Freinsheim","Freirachdorf","Freisbach","Freisen","Freising","Freital","Freiwalde","Fremdingen","Frensdorf","Freren","Fresenburg","Freudenberg","Freudenburg","Freudenstadt","Freudental","Freudenweiler","Freund","Freyburg","Freystadt","Freyung","Frickenhausen","Frickingen","Fridingen an der Donau","Fridolfing","Friedberg","Friedeburg","Friedelsheim","Friedensau","Friedensdorf","Friedenweiler","Friedersdorf","Friedewald","Friedland","Friedrichroda","Friedrichsdorf","Friedrichshafen","Friedrichsholm","Friedrichskoog","Friedrichsort","Friedrichstadt","Friedrichsthal","Friedrichswerth","Frielendorf","Friemar","Friesack","Friesenhagen","Friesenheim","Friesenried","Friesoythe","Friolzheim","Frittlingen","Fritzlar","Frohburg","Frommern","Frondenberg","Fronhausen","Fronhofen","Frontenhausen","Frose","Fuchshain","Fuchsstadt","Fulda","Fuldabruck","Fuldatal","Funfeichen","Funfstetten","Furholzen","Furstenau","Furstenberg","Fursteneck","Furstenstein","Furstenwald","Furstenwalde","Furstenzell","Furth","Furth im Wald","Furthen","Furtwangen im Schwarzwald","Fusternberg","Gablenz","Gablingen","Gachenbach","Gadebusch","Gadegast","Gagern","Gaggenau","Gahlkow","Gaiberg","Gaienhofen","Gaildorf","Gailingen","Gaimersheim","Gaishofen","Gaissach","Galenbeck","Gammellund","Gammelsdorf","Gammelshausen","Gammertingen","Ganderkesee","Gangelt","Gangkofen","Gangloff","Garbek","Garbsen","Garching an der Alz","Garching bei Munchen","Gardelegen","Garden","Garlstorf","Garmisch-Partenkirchen","Garrel","Gars","Gartow","Gartringen","Garz","Gatersleben","Gattendorf","Gau-Algesheim","Gau-Bickelheim","Gau-Bischofsheim","Gau-Odernheim","Gaukonigshofen","Gauting","Gebenbach","Gebesee","Gebhardshain","Gechingen","Gedern","Geeste","Geesthacht","Gefell","Gefrees","Gehaus","Gehlenbeck","Gehofen","Gehrde","Gehrden","Gehrweiler","Geiersthal","Geilenkirchen","Geinsheim","Geiselbach","Geiselhoring","Geiselwind","Geisenfeld","Geisenhain","Geisenhausen","Geisenheim","Geisfeld","Geisig","Geising","Geisingen","Geisling","Geislingen","Geislingen an der Steige","Geithain","Gelbensande","Geldern","Geldersheim","Gelenau","Gelnhausen","Gelsenkirchen","Geltendorf","Gelting","Gemmingen","Gemmrigheim","Gemunden","Gemunden an der Wohra","Genderkingen","Gendorf","Gengenbach","Genkingen","Gensingen","Genthin","Georgensgmund","Georgenthal","Georgsdorf","Georgsmarienhutte","Gera","Geraberg","Gerabronn","Gerach","Geratskirchen","Gerau","Gerbershausen","Gerbrunn","Gerbstedt","Gerdau","Geretsried","Gerhardshofen","Gerichshain","Geringswalde","Gerlachsheim","Gerlfangen","Gerlingen","Germering","Germersheim","Gernrode","Gernsbach","Gernsheim","Gerolfingen","Gerolsbach","Gerolsheim","Gerolstein","Gerolzhofen","Gersdorf","Gersfeld","Gershasen","Gersheim","Gerstetten","Gersthofen","Gerstungen","Gerwisch","Gerzen","Gescher","Geschwenda","Geseke","Gessertshausen","Gestungshausen","Getelo","Gettorf","Gevelsberg","Gevensleben","Geversdorf","Geyer","Giebelstadt","Gieboldehausen","Gielde","Gieleroth","Giengen an der Brenz","Gierstadt","Giesen","Giesenkirchen","Giessen","Gifhorn","Giggenhausen","Gilching","Gillenfeld","Gillersdorf","Gilserberg","Gimbsheim","Gingen an der Fils","Gingst","Ginsheim-Gustavsburg","Girod","Gittelde","Gladbach","Gladbeck","Gladenbach","Glan-Munchweiler","Glandorf","Glasewitz","Glashagen","Glashutte","Glashutten","Glattbach","Glatten","Glauburg","Glauchau","Gleichen","Gleiritsch","Gleissenberg","Gleisweiler","Gleschendorf","Glien","Glienicke","Glinde","Glindenberg","Glonn","Gluckstadt","Gmain bei Weidach","Gmund am Tegernsee","Gnadau","Gnarrenburg","Gnaschwitz","Gnoien","Gnotzheim","Gnutz","Goch","Gochsheim","Goda","Goggingen","Gohrde","Gohren","Goldbach","Goldberg","Goldelund","Goldenstedt","Goldewin","Goldkronach","Gollheim","Gollhofen","Golm","Golmbach","Golssen","Golzow","Gomadingen","Gomaringen","Gommern","Gommersheim","Gondelsheim","Gondenbrett","Gonnheim","Gorenzen","Goritz","Gorkwitz","Gornsdorf","Gorschendorf","Gorwihl","Goseck","Gosheim","Goslar","Gossel","Gossen","Gossersweiler-Stein","Gossnitz","Gossweinstein","Gotha","Gotteszell","Gottfrieding","Gottmadingen","Graach","Grabau","Graben","Graben-Neudorf","Grabenstatt","Grabenstetten","Grabow","Grafelfing","Grafenau","Grafenberg","Grafengehaig","Grafenhainichen","Grafenhausen","Grafenrheinfeld","Grafenroda","Grafenthal","Grafenwohr","Grafhorst","Grafing bei Munchen","Grafrath","Grafschaft","Grainau","Graitschen","Grambin","Grambow","Grammow","Gramzow","Gransee","Grasberg","Grasbrunn","Grassau","Gravenbruch","Graveneck","Gravenwiesbach","Grebbin","Grebenau","Grebenhain","Grebenstein","Greding","Green","Grefrath","Greifenberg","Greifenstein","Greifswald","Greiling","Greiz","Gremersdorf","Gremsdorf","Grenzach-Wyhlen","Grenzau","Greppin","Grethem","Grethen","Grettstadt","Greussen","Greussenheim","Greven","Grevenbroich","Grevesmuhlen","Gribow","Gries","Griesheim","Griesingen","Griesstatt","Grimma","Grimmen","Grobenzell","Grobzig","Groditz","Groeningen","Groitzsch","Grolsheim","Grombach","Gromitz","Gronau","Gronenbach","Gronwohld","Gross Bengerstorf","Gross Gronau","Gross Kiesow","Gross Koris","Gross Kreutz","Gross Kummerfeld","Gross Lindow","Gross Miltzow","Gross Oesingen","Gross Rheide","Gross Santersleben","Gross Twulpstedt","Gross Wittensee","Gross-Bieberau","Gross-Gerau","Gross-Rohrheim","Gross-Umstadt","Gross-Zimmern","Grossaitingen","Grossalmerode","Grossbardorf","Grossbeeren","Grossbettlingen","Grossbottwar","Grossbreitenbach","Grosselfingen","Grossenaspe","Grossengottern","Grossenhain","Grossenkneten","Grossenluder","Grossensee","Grossenseebach","Grossenwiehe","Grosserlach","Grosshabersdorf","Grosshansdorf","Grossharthau","Grossheide","Grossheirath","Grossheubach","Grosskarolinenfeld","Grosskorbetha","Grosskrotzenburg","Grosskugel","Grosslittgen","Grosslobichau","Grossmaischeid","Grossmehring","Grossmonra","Grossostheim","Grossposna","Grossraschen","Grossrinderfeld","Grossrohrsdorf","Grossrosseln","Grossruckerswalde","Grossschirma","Grossschonau","Grosssolt","Grosswallstadt","Grosswechsungen","Grove","Gruibingen","Gruna","Grunberg","Grundau","Grundhof","Grunenberg","Grunenplan","Grunenthal","Grunhainichen","Grunheide","Grunhof","Grunkraut","Grunstadt","Grunwald","Gschwend","Guben","Guckheim","Gudensberg","Guenzburg","Guestrow","Guglingen","Gulzow","Gulzowshof","Gummersbach","Gundelfingen","Gundelsheim","Gundernhausen","Gundersheim","Gundremmingen","Gunningen","Guntersblum","Guntersleben","Gunthersleben","Gunzenhausen","Gurtweil","Gustavel","Gusten","Gusterath","Gutach (Schwarzwaldbahn)","Gutach im Breisgau","Gutenacker","Gutenberg","Gutenstetten","Gutenzell-Hurbel","Gutmadingen","Gutow","Gutzkow","Guxhagen","Gyhum","Haag","Haag an der Amper","Haan","Haar","Haarbach","Haaren","Habach","Habenhausen","Habersdorf","Hachenburg","Hackenheim","Hadamar","Hademstorf","Haenigsen","Hafenlohr","Haffkrug","Hage","Hagelstadt","Hagen","Hagenbach","Hagenburg","Hagenow","Hagnau","Hahn","Hahnbach","Hahnenbach","Hahnheim","Hahnstatten","Haibach","Haide","Haidhof","Haidmuhle","Haiger","Haigerloch","Haimhausen","Haiming","Haina","Hainewalde","Hainichen","Hainsfarth","Haiterbach","Halbe","Halberg","Halberstadt","Halblech","Halbs","Haldensleben I","Haldenwang","Halfing","Hallbergmoos","Halle","Halle Neustadt","Hallenberg","Hallerndorf","Hallnberg","Hallschlag","Hallstadt","Halsbach","Halsbrucke","Halsenbach","Halstenbek","Haltern","Halver","Halvesbostel","Hamb","Hamberge","Hambergen","Hambrucken","Hambuhren","Hamburg","Hamdorf","Hamelin","Hamm","Hammah","Hammelburg","Hammersbach","Hamminkeln","Hamwarde","Hanau","Handeloh","Handewitt","Hanerau-Hademarschen","Hanhofen","Hankensbuttel","Hannover","Hanover","Hanstedt","Happurg","Harburg","Hard","Hardegsen","Hardenberg","Hardheim","Hardt","Haren","Hargesheim","Harlachen","Harmsdorf","Harmstorf","Harpstedt","Harra","Harrislee","Harschbach","Harsefeld","Harsewinkel","Harsleben","Harste","Harsum","Hartenfels","Hartenholm","Hartenstein","Hartha","Harthausen","Hartheim","Hartmannsdorf","Harxheim","Harzgerode","Hasbergen","Haschbach an der Glan","Hasel","Haselbach","Haseldorf","Haselunne","Hasenmoor","Haslach im Kinzigtal","Hasloch","Hasloh","Hassel","Hasselbach","Hasselberg","Hasselfelde","Hassfurt","Hassloch","Hassmersheim","Haste","Hastenrath","Haswede","Hatten","Hattenhofen","Hattersheim","Hattert","Hattingen","Hattorf","Hattstedt","Hatzenbuhl","Hatzfeld","Haus","Hausach","Hausen","Hausen am Tann","Hausen ob Verena","Hausen uber Aar","Hauser","Hausern","Hausham","Hausten","Hauteroda","Hauzenberg","Havelberg","Haverkamp","Havixbeck","Hawangen","Hayingen","Hebertsfelden","Hebertshausen","Hechingen","Hechthausen","Hecklingen","Heddesheim","Heede","Heeg","Heek","Heeslingen","Hefersweiler","Hegge","Hehlen","Heide","Heideck","Heidehof","Heidekamp","Heidelberg","Heiden","Heidenau","Heidenburg","Heidenheim","Heidesheim","Heigenbrucken","Heikendorf","Heilbad Heiligenstadt","Heilbronn","Heiligengrabe","Heiligenhafen","Heiligenhagen","Heiligenhaus","Heiligenroth","Heiligenstadt","Heiligenstedtenerkamp","Heiligenthal","Heiligkreuzsteinach","Heilingen","Heilsbronn","Heimbach","Heimbuchenthal","Heimenkirch","Heimertingen","Heimerzheim","Heimsheim","Heimstetten","Heinade","Heinbockel","Heinersreuth","Heiningen","Heinkenborstel","Heinrichsthal","Heinsberg","Heinsdorf","Heinz","Heinzenberg","Heinzenhausen","Heisede","Heist","Heitersheim","Helbra","Heldrungen","Helfant","Helferskirchen","Hellenhahn-Schellenberg","Hellenthal","Hellstein","Hellweg","Helmbrechts","Helmenzen","Helmern","Helmershausen","Helmstadt","Helmste","Helmstedt","Helpsen","Helsa","Heltersberg","Helvesiek","Hemau","Hemdingen","Hemelingen","Hemer","Hemhofen","Hemmelzen","Hemmersdorf","Hemmingen","Hemmingstedt","Hemmoor","Hemsbach","Hemsbunde","Hemslingen","Henfenfeld","Hengersberg","Hennef","Hennickendorf","Hennigsdorf","Hennstedt","Hennweiler","Henstedt-Ulzburg","Hepberg","Heppdiel","Heppenheim an der Bergstrasse","Hepstedt","Herbertingen","Herbolzheim","Herborn","Herbrechtingen","Herbsleben","Herbstein","Herdecke","Herdorf","Herdwangen-Schonach","Herfatz","Herford","Herforst","Hergenfeld","Hergisdorf","Hergolding","Hergolshausen","Heringen","Heringsdorf","Herleshausen","Hermannsburg","Hermaringen","Hermersberg","Hermeskeil","Hermsdorf","Herne","Heroldsbach","Heroldsberg","Herren Steinfeld","Herren-Sulzbach","Herrenberg","Herresbach","Herrieden","Herringen","Herrischried","Herrnburg","Herrnhut","Herrsching am Ammersee","Herrstein","Hersbruck","Herschbach","Herschberg","Herscheid","Herschweiler-Pettersheim","Herten","Herxheim","Herzberg","Herzberg am Harz","Herzebrock","Herzfeld","Herzlake","Herzogenaurach","Herzogenrath","Herzogsweiler","Hesedorf","Hesel","Hespe","Hessdorf","Hesselbach","Hessen","Hessheim","Hessigheim","Hessisch Lichtenau","Hessisch Oldendorf","Hetschburg","Hettenleidelheim","Hettenrodt","Hettstadt","Hettstedt","Hetzenhausen","Hetzerath","Hetzlinshofen","Hetzwege","Heubach","Heuchelheim","Heuchlingen","Heudeber","Heudorf","Heuerssen","Heusenstamm","Heustreu","Heusweiler","Heuweiler","Heyerode","Hiddenhausen","Hiddensee","Hilbersdorf","Hilchenbach","Hildburghausen","Hildebrandshausen","Hilden","Hilders","Hildesheim","Hildrizhausen","Hilgermissen","Hilgert","Hilgertshausen-Tandern","Hille","Hillersleben","Hillesheim","Hillscheid","Hilpoltstein","Hilscheid","Hilter","Hiltpoltstein","Hiltrup","Hilwartshausen","Hilzingen","Himbergen","Himmelkron","Himmelpforten","Himmelstadt","Hinrichshagen","Hinte","Hinterhermsdorf","Hinterm Horn","Hinterschmiding","Hinterzarten","Hirrlingen","Hirschaid","Hirschau","Hirschberg","Hirschfelde","Hirschhorn","Hirschstein","Hirstein","Hirzenhain","Hirzlei","Hittbergen","Hitzacker","Hitzhofen","Hobbersdorf","Hobeck","Hochberg","Hochborn","Hochdonn","Hochdorf","Hochdorf-Assenheim","Hochenschwand","Hochheim am Main","Hochkirch","Hochscheid","Hochspeyer","Hochst im Odenwald","Hochstadt","Hochstadt an der Aisch","Hochstadten","Hochstenbach","Hochstetten-Dhaun","Hochstrasse","Hochwang","Hockendorf","Hockenheim","Hodenhagen","Hof","Hofbieber","Hofen","Hofen an der Enz","Hofer","Hofgarten","Hofgeismar","Hofheim","Hofheim am Taunus","Hofkirchen","Hofstetten","Hohberg","Hohe","Hoheinod","Hohen","Hohen Neuendorf","Hohen Schwarfs","Hohen Wangelin","Hohenaspe","Hohenau","Hohenberg","Hohenbergham","Hohenbocka","Hohenbrunn","Hohendodeleben","Hoheneggelsen","Hohenerxleben","Hohenfelde","Hohenfels","Hohenfinow","Hohenfurch","Hohenhameln","Hohenhaus","Hohenhorn","Hohenkammer","Hohenkirchen-Siegertsbrunn","Hohenleimbach","Hohenleipisch","Hohenleuben","Hohenlimburg","Hohenlinden","Hohenlockstedt","Hohenmolsen","Hohenollen","Hohenpeissenberg","Hohenroda","Hohenroth","Hohenschaftlarn","Hohenstein","Hohenstein-Ernstthal","Hohentengen am Hochrhein","Hohenthann","Hohenwart","Hohenwarthe","Hohenwestedt","Hohn","Hohndorf","Hohne","Hohnhorst","Hohnstein","Hohnstorf","Hohr-Grenzhausen","Hoisdorf","Hoitlingen","Holdorf","Holle","Hollenbach","Hollenstedt","Holler","Hollern","Hollfeld","Hollingstedt","Hollstadt","Holm","Holte","Holthausen","Holtinghausen","Holtland","Holtsee","Holzbach","Holzengel","Holzgerlingen","Holzgunz","Holzhausen","Holzhausen an der Haide","Holzheim","Holzkirchen","Holzmaden","Holzminden","Holzweissig","Holzwickede","Homberg","Homburg","Honebach","Hoogstede","Hopferau","Hopfingen","Hoppegarten","Hoppstadten-Weiersbach","Hopsten","Horath","Horb am Neckar","Horbach","Horbruch","Hordt","Horgau","Horgertshausen","Horhausen","Hormersdorf","Horn-Bad Meinberg","Hornbach","Hornberg","Hornburg","Horneburg","Horperath","Horressen","Horrweiler","Horselgau","Horst","Horstdorf","Horstedt","Horstel","Horstmar","Hosbach","Hosenfeld","Hoslwang","Hosskirch","Host","Hotensleben","Hovelhof","Hoya","Hoyerswerda","Hoym","Huckelhoven","Huckeswagen","Hude","Huellhorst","Huffelsheim","Huffenhardt","Hufingen","Hugelsheim","Huglfing","Huhnerhof","Huje","Hulben","Humptrup","Hunderdorf","Hundhaupten","Hundisburg","Hundsangen","Hundsdorf","Hunfeld","Hungen","Hungenroth","Hunxe","Hunzel","Hurlach","Hurtgenwald","Husby","Husum","Hutschenhausen","Huttblek","Huttenberg","Hutthurm","Huttisheim","Huttlingen","Ibach","Ibbenbueren","Ichenhausen","Ichtershausen","Icker","Icking","Idar-Oberstein","Idenheim","Idstein","Iffeldorf","Iffezheim","Igel","Igensdorf","Igersheim","Iggensbach","Iggingen","Ihlow","Ihringen","Ihrlerstein","Ilbesheim","Ilfeld","Illerrieden","Illertissen","Illingen","Illschwang","Ilmenau","Ilmmunster","Ilsede","Ilsenburg","Ilsfeld","Ilshofen","Ilvesheim","Im Loh","Immendingen","Immenhausen","Immenreuth","Immenstaad am Bodensee","Immenstadt im Allgau","Imsbach","In der Meer","Inchenhofen","Inden","Ingelfingen","Ingelheim am Rhein","Ingersleben","Ingoldingen","Ingolstadt","Innernzell","Inning am Ammersee","Inning am Holz","Insel","Insheim","Insingen","Insul","Inzell","Inzigkofen","Inzlingen","Inzmuhlen","Iphofen","Ippesheim","Ipsheim","Irlbach","Irmenach","Irrel","Irschenberg","Irsee","Irxleben","Isen","Isenburg","Isenbuttel","Iserlohn","Ismaning","Isny im Allgau","Ispringen","Isselburg","Isseroda","Isserstedt","Issigau","Issum","Istein","Ittersbach","Ittlingen","Itzehoe","Itzstedt","Ivenack","Jacobsdorf","Jaderberg","Jagel","Jagerhof","Jagsthausen","Jagstzell","Jahnsdorf","Jahnshof","Jameln","Jarmen","Jebenhausen","Jeddeloh Eins","Jelmstorf","Jembke","Jemgum","Jena","Jengen","Jerichow","Jersbek","Jersleben","Jesberg","Jesendorf","Jessen","Jessnitz","Jestadt","Jesteburg","Jestetten","Jettenbach","Jettingen-Scheppach","Jetzendorf","Jevenstedt","Jever","Jheringsfehn","Joachimsthal","Jockgrim","Joehlingen","Johannesberg","Johanngeorgenstadt","Johstadt","Jork","Jorl","Jubek","Juchen","Jugenheim","Juist","Julbach","Julich","Juliusburg","Jungingen","Junkerath","Juterbog","Kaaks","Kaarst","Kadelburg","Kaden","Kagsdorf","Kahl am Main","Kahla","Kaisersbach","Kaisersesch","Kaiserslautern","Kaisheim","Kakenstorf","Kalbach","Kaldenkirchen","Kalefeld","Kalenborn-Scheuern","Kalkar","Kalkreuth","Kall","Kallmunz","Kallstadt","Kaltenengers","Kaltenkirchen","Kaltennordheim","Kaltenwestheim","Kamen","Kamenz","Kammerforst","Kammerstein","Kamp-Bornhofen","Kamp-Lintfort","Kampen","Kamsdorf","Kandel","Kandern","Kanzlei","Kapellen-Drusweiler","Kapellenberg","Kappel-Grafenhausen","Kappeln","Kappelrodeck","Kapsweyer","Karbach","Karben","Karin","Karl","Karlsbad","Karlsdorf-Neuthard","Karlsfeld","Karlshagen","Karlshausen","Karlshuld","Karlskron","Karlsruhe","Karlstadt am Main","Karlstein","Karlum","Karsbach","Karsdorf","Karstadt","Karweiler","Kasbach-Ohlenberg","Kasdorf","Kasel-Golzig","Kasendorf","Kasseedorf","Kassel","Kassow","Kastel","Kastellaun","Kastl","Kastorf","Katlenburg-Lindau","Katzenelnbogen","Katzenmoos","Katzenstein","Katzow","Katzwang","Katzwinkel","Kaub","Kaufbeuren","Kaufering","Kaufungen","Kaulsdorf","Kayhude","Kayna","Kefenrod","Kefferhausen","Kehl","Keidelheim","Keitum","Kelberg","Kelbra","Kelheim","Kelkheim (Taunus)","Kell","Kellenhusen","Keller","Kellinghusen","Kelsterbach","Kemberg","Kemerting","Kemmern","Kemnath","Kempen","Kempenich","Kempfeld","Kempten (Allgaeu)","Kendenich","Kenn","Kennenburg","Kenzingen","Kerlingen","Kerpen","Kervenheim","Kerzenheim","Kesselbach","Kesselsdorf","Kestert","Ketsch","Kettenkamp","Kettershausen","Kettig","Ketzin","Kevelaer","Kiedrich","Kiefersfelden","Kiel","Kienberg","Kierspe","Kieselbach","Kieselbronn","Kiez","Kindelbruck","Kinding","Kindsbach","Kinheim","Kinsau","Kipfenberg","Kippenheim","Kirberg","Kirburg","Kirchardt","Kirchberg","Kirchdorf","Kirchdorf am Inn","Kirchdorf im Wald","Kirchehrenbach","Kirchen","Kirchendemenreuth","Kirchenlamitz","Kirchentellinsfurt","Kirchenthumbach","Kirchgellersen","Kirchhain","Kirchham","Kirchhasel","Kirchhaslach","Kirchheilingen","Kirchheim","Kirchheim am Ries","Kirchheim an der Weinstrasse","Kirchheim unter Teck","Kirchheimbolanden","Kirchhellen","Kirchhundem","Kirchlauter","Kirchlengern","Kirchlinteln","Kirchreit","Kirchroth","Kirchsahr","Kirchseelte","Kirchseeon","Kirchtimke","Kirchweg","Kirchweidach","Kirchweyhe","Kirchworbis","Kirchzarten","Kirchzell","Kirkel","Kirn","Kirrweiler","Kirschau","Kirschfurt","Kirschhofen","Kirspenich","Kirtorf","Kisdorf","Kisselbach","Kissenbruck","Kissing","Kisslegg","Kist","Kitzingen","Kitzscher","Kladen","Klais","Klanxbull","Klaus","Klausdorf","Klausen","Klausheide","Klein Ammensleben","Klein Berssen","Klein Kedingshagen","Klein Lichtenhagen","Klein Meckelsen","Klein Nordende","Klein Offenseth-Sparrieshoop","Klein Rogahn","Klein Ronnau","Klein Wesenberg","Klein Wittensee","Klein-Gerau","Klein-Schlamin","Klein-Winternheim","Klein-Zimmern","Kleinbeeren","Kleinblittersdorf","Kleinbundenbach","Kleinfahner","Kleinfurra","Kleinheubach","Kleinkahl","Kleinmachnow","Kleinmaischeid","Kleinostheim","Kleinrinderfeld","Kleinschwabhausen","Kleinsendelbach","Kleinsteinhausen","Kleinwallstadt","Kleinwolmsdorf","Klettwitz","Kleve","Klinge","Klingenberg","Klingenberg am Main","Klingenmunster","Klingenthal","Klink","Klipphausen","Kloster","Klosterhauser","Klosterlechfeld","Klostermansfeld","Klostersee","Klotten","Klotze","Kluis","Klutz","Knesebeck","Knetzgau","Knittelsheim","Knittlingen","Knobelsdorf","Knoringen","Kobern-Gondorf","Koblenz","Kochel","Kodersdorf","Koditz","Kodnitz","Kofering","Kohlberg","Kohra","Kohren-Sahlis","Kolbermoor","Kolbingen","Kolitzheim","Kolkwitz","Kolleda","Kollerbach","Kollmar","Kolln-Reisiek","Kollnburg","Kolpien","Komp","Kongen","Konigheim","Konigs Wusterhausen","Konigsbach-Stein","Konigsberg in Bayern","Konigsbronn","Konigsbruck","Konigsbrunn","Konigsdorf","Konigsee","Konigseggwald","Konigsfeld","Konigsfeld im Schwarzwald","Konigsheim","Konigslutter am Elm","Konigstein","Konigstein im Taunus","Konigswartha","Konigswinter","Konken","Konnern","Konradsreuth","Konstanz","Konz","Konzell","Korb","Korbach","Korchow","Kordel","Korle","Korntal","Kornwestheim","Korperich","Korschenbroich","Kosching","Kossa","Kothel","Kottenheim","Kotterichen","Kottgeisering","Kottweiler-Schwanden","Kotzting","Koxhausen","Kraft","Kraftisried","Kraiburg am Inn","Krailling","Krakow am See","Kramerhof","Kranenburg","Kranichfeld","Kranzberg","Krauchenwies","Kraupa","Krauschwitz","Krautheim","Krefeld","Kreiensen","Kreischa","Kremmen","Krempe","Kremperheide","Kressbronn am Bodensee","Krettnach","Kretzschau","Kreuz","Kreuzau","Kreuztal","Kreuzwertheim","Krickenbach","Kriebitzsch","Kriebstein","Kriftel","Kritzmow","Kritzow","Krolpa","Krombach","Kronach","Kronau","Kronberg","Kronshagen","Kropelin","Kropp","Kroppelshagen-Fahrendorf","Kroppenstedt","Kroslin","Krostitz","Krov","Kruden","Kruft","Krugsdorf","Krugzell","Krumbach","Krumhermersdorf","Krummensee","Krummesse","Krumpa","Krumstedt","Krun","Kubschutz","Kuchen","Kuddeworde","Kuenzelsau","Kueps Oberfranken","Kuhardt","Kuhbach","Kuhn","Kuhndorf","Kuhstedt","Kukels","Kulmbach","Kulsheim","Kulz","Kumhausen","Kummerfeld","Kummersbruck","Kunreuth","Kunzell","Kunzing","Kupferberg","Kupferzell","Kuppenheim","Kurnach","Kurnbach","Kurort Hartha","Kurort Steinbach-Hallenberg","Kurten","Kurtscheid","Kusel","Kusterdingen","Kutenholz","Kutzenhausen","Kyritz","Laaber","Laage","Laasdorf","Laatzen","Labejum","Labenz","Laboe","Lachen","Lachendorf","Ladbergen","Ladenburg","Laer","Lage","Lagerdorf","Lagesbuttel","Lahden","Lahm","Lahnstein","Lahr","Lahrbach","Laichingen","Lain","Lalendorf","Lam","Lambertsberg","Lambrecht","Lambsheim","Lamerdingen","Lampertheim","Lampertswalde","Lamspringe","Lamstedt","Landau","Landau an der Isar","Landensberg","Landesbergen","Landrecht","Landsberg","Landsberg am Lech","Landscheid","Landscheide","Landshut","Landstuhl","Langballig","Langebruck","Langeln","Langelsheim","Langen","Langenargen","Langenau","Langenbach","Langenberg","Langenbernsdorf","Langendorf","Langenenslingen","Langenfeld","Langenhagen","Langenhorn","Langenlonsheim","Langenmosen","Langenneufnach","Langenpreising","Langenselbold","Langensendelbach","Langenweddingen","Langenwetzendorf","Langenwolmsdorf","Langenzenn","Langeoog","Langerringen","Langerwehe","Langewiesen","Langfurth","Langgons","Langlingen","Langquaid","Langstedt","Langsur","Langwasser","Langwedel","Langweid","Langweiler","Langwieden","Langwitz","Lappersdorf","Lasbek","Lassan","Lassentin","Lastrup","Lathen","Laubach","Lauben","Laubenheim","Laubusch","Laucha","Lauchhammer","Lauchheim","Lauchringen","Lauda-Konigshofen","Laudenbach","Laudert","Lauenau","Lauenbruck","Lauenburg","Lauenhagen","Lauf","Lauf an der Pegnitz","Laufach","Laufen","Laufenburg","Lauffen am Neckar","Laugna","Lauingen","Laumersheim","Laupheim","Laurenburg","Lauscha","Lauschied","Lausitz","Laussnitz","Lauta","Lautenbach","Lautenthal","Lauter","Lauterach","Lauterbach","Lauterbach/Schwarzwald","Lauterburg","Lauterecken","Lauterhofen","Lautern","Lautersheim","Lautertal","Lautrach","Lautzenhausen","Lawalde","Lebach","Lebrade","Lebus","Lebusa","Lechbruck","Leck","Lederhose","Leegebruch","Leeheim","Leer","Leezdorf","Leezen","Legau","Legden","Lehen","Lehesten","Lehmen","Lehmke","Lehndorf","Lehrberg","Lehre","Lehrensteinsfeld","Lehrte","Leibelbach","Leibertingen","Leiblfing","Leichlingen","Leidersbach","Leiferde","Leimbach","Leimen","Leimersheim","Leinach","Leinburg","Leinefelde","Leinfelden-Echterdingen","Leingarten","Leinsweiler","Leipheim","Leipzig","Leisnig","Leitershofen","Leitzkau","Leiwen","Leizen","Lemberg","Lembruch","Lemforde","Lemgo","Lemwerder","Lengdorf","Lengede","Lengenfeld","Lengerich","Lenggries","Lengthal","Lennestadt","Lensahn","Lentfohrden","Lenting","Lenzkirch","Leonberg","Leopoldshagen","Leopoldshohe","Lerbach","Lessien","Lettenreuth","Leubsdorf","Leukersdorf","Leun","Leuna","Leutenbach","Leutenberg","Leutershausen","Leuthen","Leutkirch im Allgau","Leverkusen","Lich","Lichte","Lichtenau","Lichtenberg","Lichtenbroich","Lichtenfels","Lichtenstein","Lichtentanne","Lichtenwald","Liebenau","Liebenburg","Liebenscheid","Liebenstein","Liebenwalde","Lieberose","Liederbach","Lienen","Liepgarten","Lieser","Lieskau","Lietzen","Lilienthal","Limbach","Limbach-Oberfrohna","Limburg an der Lahn","Limburgerhof","Lindau","Linde","Linden","Lindenau","Lindenberg im Allgau","Lindenfels","Lindenthal","Lindern","Lindewitt","Lindhorst","Lindigshof","Lindlar","Lindwedel","Lingen","Lingenfeld","Lingerhahn","Linkenbach","Linkenheim-Hochstetten","Linnich","Linow","Linsburg","Lintig","Linz am Rhein","Lippe","Lipporn","Lippstadt","Lissendorf","Listerfehrda","Litzendorf","Lobau","Loch","Lochau","Lochgau","Lochhausen","Lochum","Loddin","Loderburg","Loffenau","Loffingen","Lohberg","Lohe-Rickelshof","Loheide","Lohfelden","Lohmar","Lohnberg","Lohne","Lohnsfeld","Lohr a. Main","Lohra","Lohsa","Loiching","Loitz","Lollar","Lollbach","Lommatzsch","Longkamp","Longuich","Loningen","Lonnerstadt","Lonnig","Lonsee","Lonsingen","Loose","Lorch","Lorsch","Lorscheid","Lorup","Losheim","Lossburg","Lossnitz","Lostau","Lotte","Lottstetten","Lotzbeuren","Lowenstein","Loxstedt","Lubbecke","Lubbenau","Lubesse","Lubmin","Lubstorf","Lubtheen","Lubz","Luchem","Lucka","Luckau","Luckenbach","Luckenwalde","Ludersdorf","Ludersfeld","Ludinghausen","Ludwigsburg","Ludwigsfelde","Ludwigshafen","Ludwigshafen am Rhein","Ludwigshohe","Ludwigslust","Ludwigsstadt","Luebben","Luechow","Luerdissen","Luft","Luftkurort Arendsee","Lugau","Lugde","Luhden","Luhe-Wildenau","Lunne","Lunzenau","Lupburg","Lurschau","Lutau","Lutjenburg","Lutjensee","Lutter am Barenberge","Luttgenrode","Luttum","Lutz","Lutzelbach","Lutzen","Lutzerath","Lutzingen","Lychen","Lynow","Maasholm","Machern","Machtolsheim","Macken","Mackenbach","Magdala","Magdeburg","Magstadt","Mahlberg","Mahlow","Mahndorf","Maierhofen","Maikammer","Mailing","Mainaschaff","Mainbernheim","Mainburg","Mainhardt","Mainleus","Mainstockheim","Maintal","Mainz","Maisach","Maitenbeth","Malberg","Malborn","Malchin","Malchow","Malente","Malgersdorf","Mallersdorf-Pfaffenberg","Mallin","Malsburg","Malsch","Malschwitz","Malsfeld","Malterdingen","Mammendorf","Mamming","Manching","Mandel","Mandern","Mannebach","Mannheim","Mannichswalde","Mansfeld","Mantel","Marbach am Neckar","Marburg","March","Margarethen","Margertshausen","Margetshochheim","Mariaposching","Marienberg","Marienburg","Marienfeld","Marienhafe","Marienhagen","Marienhausen","Marienheide","Marienrachdorf","Marienstein","Mariental","Maring-Noviand","Mark","Markdorf","Markersbach","Markgroningen","Markkleeberg","Marklkofen","Marklohe","Markneukirchen","Markranstadt","Marksuhl","Markt","Markt Einersheim","Markt Erlbach","Markt Indersdorf","Markt Rettenbach","Markt Schwaben","Markt Wald","Marktbreit","Marktgraitz","Marktheidenfeld","Marktl","Marktleugast","Marktleuthen","Marktoberdorf","Marktredwitz","Marktrodach","Marktschellenberg","Marktschorgast","Marl","Marlow","Marne","Marnheim","Marpingen","Marquartstein","Marsberg","Marschacht","Marschall","Marsdorf","Martensrade","Martfeld","Martinsried","Marwitz","Marxen","Marxgrun","Marxheim","Marzling","Maschen","Maselheim","Massbach","Massenbachhausen","Massenhausen","Massenheim","Massing","Mastershausen","Mastholte","Mattstedt","Mauer","Mauerstetten","Maulbronn","Maulburg","Mauth","Maxdorf","Maxhutte-Haidhof","Maximilian","Mayen","Mechelgrun","Mechelroda","Mechenried","Mechernich","Meckenbach","Meckenbeuren","Meckenheim","Meckesheim","Mecklenburg","Medard","Medebach","Medelby","Medow","Meeder","Meerane","Meerbeck","Meerbusch","Meersburg","Meesiger","Megesheim","Mehlbach","Mehlingen","Mehlmeisel","Mehmels","Mehr","Mehring","Meine","Meinersen","Meinerzhagen","Meiningen","Meinsdorf","Meisenheim","Meissen","Meissenheim","Meitingen","Melbeck","Melchow","Meldorf","Melle","Mellenbach-Glasbach","Mellingen","Mellrichstadt","Melsbach","Melsdorf","Melsungen","Memmelsdorf","Memmingen","Memmingerberg","Menden","Mendig","Mengen","Mengerschied","Mengersgereuth-Hammern","Mengerskirchen","Mengkofen","Menslage","Meppen","Merching","Merchweiler","Merdingen","Merenberg","Mering","Merkelbach","Merkendorf","Merkers","Merklingen","Merschwitz","Merseburg","Mersheim","Mertendorf","Mertingen","Mertloch","Merxheim","Merzalben","Merzen","Merzenich","Merzhausen","Merzig","Meschede","Messel","Messkirch","Messstetten","Metelen","Metjendorf","Metten","Mettenheim","Metterich","Mettingen","Mettlach","Mettmann","Metzingen","Metzlos-Gehag","Meudt","Meuro","Meuselwitz","Meyn","Michelau","Michelbach an der Bilz","Michelfeld","Michelstadt","Michendorf","Mickhausen","Midlum","Miehlen","Mielenhausen","Mielkendorf","Miellen","Miesbach","Mieste","Mietingen","Mihla","Milbertshofen","Mildenau","Mildstedt","Milow","Miltenberg","Milzau","Mindelheim","Mindelstetten","Minden","Minfeld","Minsen","Mintraching","Mirow","Missen-Wilhams","Mistelbach","Mistelgau","Mittbach","Mittegrossefehn","Mittelbach","Mittelberg","Mittelbiberach","Mitteleschenbach","Mittelherwigsdorf","Mittelneufnach","Mittelnkirchen","Mittelrot","Mittelsaida","Mittelstenweiler","Mittelstetten","Mittelstreu","Mittenaar","Mittenwald","Mittenwalde","Mitterfelden","Mitterfels","Mitterstetten","Mitterteich","Mittweida","Mitwitz","Mixdorf","Mochau","Mochenwangen","Mockern","Mockmuhl","Mockrehna","Moers","Mogendorf","Mogglingen","Moglingen","Mohlsdorf","Mohnesee","Mohren","Mohrendorf","Mohrkirch","Moisburg","Molbergen","Molfsee","Mollenhagen","Molln","Molschow","Molsheim","Mombris","Momlingen","Mommenheim","Monchberg","Monchsdeggingen","Monchsroth","Monchweiler","Monheim","Monheim am Rhein","Monkeberg","Monreal","Monschau","Monsheim","Montabaur","Monzelfeld","Monzingen","Moor","Moorenweis","Moos","Moosach","Moosburg","Moosinning","Moosthenning","Morbach","Morenhoven","Morfelden-Walldorf","Moringen","Moritz","Moritzburg","Morlenbach","Morsbach","Morscheid","Morschheim","Morschied","Morsfeld","Morshausen","Morsleben","Morslingen","Mosbach","Moschenfeld","Moser","Mossingen","Mottgers","Mottingen","Motzingen","Moyland","Much","Mucheln","Mudau","Muden","Mudersbach","Mudershausen","Muehldorf","Muehlheim am Main","Mugeln","Muggendorf","Muggensturm","Muhl Rosin","Muhlacker","Muhlau","Muhle","Muhlen","Muhlhausen","Muhlhausen-Ehingen","Muhlheim an der Donau","Muhltal","Muhltroff","Muhr am See","Mulda","Muldenhammer","Muldenstein","Mulfingen","Mulheim-Karlich","Mullrose","Mulsen","Mulsum","Munchaurach","Munchberg","Muncheberg","Munchenbernsdorf","Munchhausen","Munchsmunster","Munchsteinach","Munchweiler am Klingbach","Munchweiler an der Alsenz","Munderkingen","Mundersbach","Munich","Munnerstadt","Munsing","Munsingen","Munster","Munster-Sarmsheim","Munsterdorf","Munstermaifeld","Munzenberg","Munzingen","Murchin","Murg","Murlenbach","Murnau am Staffelsee","Murr","Murrhardt","Muschenbach","Mutlangen","Mutterschied","Mutterstadt","Mutzenich","Mutzschen","Mylau","Nabburg","Nachrodt-Wiblingwerde","Nachterstedt","Nachtsheim","Nackenheim","Nagel","Nagold","Nahe","Nahrendorf","Naila","Nakensdorf","Nalbach","Namborn","Nandlstadt","Nanzweiler","Nassau","Nassenfels","Nastatten","Nattenheim","Nattheim","Nauen","Nauendorf","Nauheim","Naumburg","Naunheim","Naunhof","Nauort","Naurath","Nebra","Nebringen","Neckarbischofsheim","Neckargemund","Neckargerach","Neckarrems","Neckarsteinach","Neckarsulm","Neckartailfingen","Neckartenzlingen","Neckarweihingen","Neckarwestheim","Neckarzimmern","Neehausen","Neenstetten","Neermoor","Neetze","Negast","Nehren","Neidenfels","Neidenstein","Neidlingen","Neitersen","Nellingen","Nennhausen","Nennig","Nennslingen","Nentershausen","Nerchau","Neresheim","Neroth","Nersingen","Nesselwang","Netphen","Nettersheim","Nettetal","Netze","Netzschkau","Neu Darchau","Neu Duvenstedt","Neu Isenburg","Neu Kaliss","Neu Sanitz","Neu Vitense","Neu Wulmstorf","Neu Zauche","Neu-Anspach","Neu-Ulm","Neubeckum","Neuberg","Neubeuern","Neubiberg","Neuborger","Neubrandenburg","Neubrunn","Neubukow","Neubulach","Neuburg","Neuburg an der Donau","Neudietendorf","Neudorf","Neudrossenfeld","Neuenbrook","Neuenburg am Rhein","Neuendettelsau","Neuendorf","Neuengors","Neuenhagen","Neuenhaus","Neuenkirchen","Neuenmarkt","Neuenrade","Neuenstadt am Kocher","Neuenstein","Neuental","Neuerburg","Neufahrn bei Freising","Neufarn","Neuffen","Neufra","Neufrach","Neufraunhofen","Neugersdorf","Neuhardenberg","Neuhaus","Neuhaus am Inn","Neuhaus am Rennweg","Neuhaus-Schierschnitz","Neuhausel","Neuhausen","Neuhausen auf den Fildern","Neuhausen ob Eck","Neuhemsbach","Neuhof","Neuhofen","Neuhutten","Neukamperfehn","Neukeferloh","Neukieritzsch","Neukirch","Neukirch/Lausitz","Neukirchen","Neukirchen am Teisenberg","Neukirchen-Vluyn","Neukloster","Neuleiningen","Neulussheim","Neumagen-Dhron","Neumark","Neumarkt in der Oberpfalz","Neumarkt-Sankt Veit","Neunburg vorm Wald","Neundorf","Neunheilingen","Neunkirchen","Neunkirchen am Sand","Neuotting","Neupetershain","Neupotz","Neuravensburg","Neureichenau","Neuried","Neuruppin","Neusalza-Spremberg","Neusass","Neuschonau","Neusitz","Neusorg","Neuss","Neustadt","Neustadt (Orla)","Neustadt am Rubenberge","Neustadt an der Aisch","Neustadt an der Orla","Neustadt an der Waldnaab","Neustadt bei Coburg","Neustadt in Holstein","Neustadt in Sachsen","Neustadt-Glewe","Neustadt/Westerwald","Neustrelitz","Neutraubling","Neutrebbin","Neutz-Lettewitz","Neuweiler","Neuwerk","Neuwied","Neuwittenbek","Neuzelle","Neverin","Neversdorf","Newel","Nickenich","Nidda","Nidderau","Nideggen","Niebull","Niedenstein","Nieder Ohmen","Nieder-Beerbach","Nieder-Olm","Niederaichbach","Niederalben","Niederalsen","Niederalteich","Niederau","Niederaula","Niederbrechen","Niederbreitbach","Niederburg","Niederding","Niederdorf","Niederdorfelden","Niederdorla","Niedereisenhausen","Niedereschach","Niederfell","Niederfischbach","Niederfrohna","Niederheimbach","Niederkassel","Niederkirchen","Niederkirchen bei Deidesheim","Niederkruchten","Niederlangen","Niederlindhart","Niedermurach","Niedernberg","Niederndodeleben","Niederneisen","Niederneuching","Niedernhall","Niedernhausen","Niedernwohren","Niederorschel","Niederpollnitz","Niederquembach","Niederrieden","Niedersachswerfen","Niederschonenfeld","Niederselters","Niederspier","Niederstadtfeld","Niederstaufenbach","Niederstetten","Niederstotzingen","Niederviehbach","Niederwambach","Niederweidbach","Niederwerrn","Niederwiesa","Niederwinkling","Niederwuerschnitz","Niederzeuzheim","Niederzier","Niederzissen","Niefern-Oschelbronn","Nieheim","Niemberg","Niemegk","Nienborstel","Nienburg","Nienburg/Saale","Niendorf","Nienhagen","Nienstadt","Niepars","Nierstein","Niesgrau","Niesky","Nieste","Nindorf","Nittel","Nittenau","Nittendorf","Nitz","Nobitz","Noda","Nohfelden","Nohra","Nonnenhorn","Nonnweiler","Norddeich","Norden","Nordendorf","Nordenham","Norderney","Norderstapel","Norderstedt","Nordhalben","Nordhastedt","Nordhausen","Nordheim","Nordhofen","Nordholz","Nordhorn","Nordkirchen","Nordrach","Nordstemmen","Nordwalde","Norheim","Norken","Norsingen","Norten-Hardenberg","Northeim","Nortmoor","Nortorf","Nortrup","Norvenich","Nossen","Nottuln","Notzingen","Nubbel","Nudlingen","Nufringen","Numbrecht","Nunchritz","Nuremberg","Nurtingen","Nusplingen","Nussdorf am Inn","Nusse","Nussloch","Ober-Erlenbach","Ober-Hilbersheim","Ober-Morlen","Ober-Olm","Ober-Ramstadt","Ober-Roden","Oberammergau","Oberasbach","Oberau","Oberaudorf","Oberaula","Oberberg","Oberbillig","Oberbodnitz","Oberboihingen","Oberderdingen","Oberdiebach","Oberding","Oberdischingen","Oberdolling","Oberdorla","Oberelbert","Oberelsbach","Oberfell","Obergebra","Obergriesbach","Obergunzburg","Obergurig","Oberhaching","Oberhaid","Oberharmersbach","Oberhausen","Oberhausen-Rheinhausen","Oberhermsdorf","Oberhof","Oberhonnefeld-Gierend","Oberhundem","Oberickelsheim","Oberirsen","Oberkail","Oberkammlach","Oberkirch","Oberkirchen","Oberkochen","Oberkotzau","Oberlahr","Oberlaindern","Oberleichtersbach","Oberlungwitz","Obermarchtal","Obermeilingen","Obermeitingen","Obermichelbach","Obermohr","Obermoschel","Obernbreit","Obernburg am Main","Oberndorf","Oberneukirchen","Oberneuses","Obernfeld","Obernheim-Kirchenarnbach","Obernkirchen","Obernzell","Obernzenn","Oberopfingen","Oberornau","Oberotterbach","Oberottmarshausen","Oberpframmern","Oberpierscheid","Oberpleichfeld","Oberpleis","Oberporing","Oberporlitz","Oberraden","Oberreichenbach","Oberried","Oberrieden","Oberriexingen","Oberrod","Oberrot","Oberschefflenz","Oberscheinfeld","Oberschleissheim","Oberschneiding","Oberschona","Oberschweinbach","Oberseifersdorf","Obersontheim","Oberstadion","Oberstadtfeld","Oberstaufen","Oberstdorf","Oberstenfeld","Oberstreu","Obersuhl","Obertaufkirchen","Oberteuringen","Oberthal","Oberthulba","Obertraubling","Obertrubach","Obertshausen","Oberursel","Oberviechtach","Oberweimar","Oberweis","Oberweissbach","Oberwesel","Oberwiesenthal","Oberwinter","Oberwolfach","Oberzissen","Obing","Obrigheim","Obristfeld","Ochsenfurt","Ochsenhausen","Ochtendung","Ochtmersleben","Ochtrup","Ockenfels","Odelzhausen","Odendorf","Odenheim","Odenthal","Oderberg","Odernheim","Oebisfelde","Oechsen","Oederan","Oedheim","Oelde","Oelerse","Oelixdorf","Oelsberg","Oelsen","Oelsnitz","Oelzschau","Oer-Erkenschwick","Oerlenbach","Oerlinghausen","Oersdorf","Oesterdeichstrich","Oestrich-Winkel","Oettersdorf","Oettingen in Bayern","Oeversee","Offenau","Offenbach","Offenbach an der Queich","Offenbach-Hundheim","Offenberg","Offenburg","Offenhausen","Offingen","Offstein","Ofterdingen","Oftersheim","Oggelshausen","Ohlsbach","Ohlsdorf","Ohlstadt","Ohmden","Ohningen","Ohorn","Ohrdruf","Ohren","Ohrensen","Ohringen","Olbernhau","Olbersdorf","Olbersleben","Olbronn-Durrn","Olching","Oldenburg","Oldenburg in Holstein","Oldendorf","Oldenswort","Oldersum","Olderup","Oldisleben","Olfen","Olpe","Olsberg","Olsbrucken","Olzheim","Opfenbach","Opfingen","Oppach","Oppenau","Oppendorf","Oppenheim","Oppenweiler","Oppurg","Oranienbaum","Oranienburg","Orbis","Oring","Ornbau","Orsingen-Nenzingen","Ortenberg","Ortenburg","Ortrand","Osann-Monzel","Osburg","Osch","Oschatz","Oschersleben","Oschingen","Osdorf","Osede","Osingen","Osloss","Ostbevern","Ostelsheim","Osten","Ostenfeld","Osterberg","Osterbrock","Osterburg","Osterburken","Ostercappeln","Osterfeld","Osterhausen","Osterhofen","Osterholz-Scharmbeck","Osternienburg","Osterode","Osterode am Harz","Osterrade","Osterronfeld","Osterspai","Osterstedt","Osterwald","Osterwieck","Ostfildern","Ostheim","Osthofen","Ostrach","Ostramondra","Ostrhauderfehn","Ostringen","Ostritz","Ostseebad Ahrenshoop","Ostseebad Baabe","Ostseebad Binz","Ostseebad Boltenhagen","Ostseebad Dierhagen","Ostseebad Gohren","Ostseebad Kuhlungsborn","Ostseebad Nienhagen","Ostseebad Prerow","Ostseebad Sellin","Ostseebad Zinnowitz","Oststeinbek","Othenstorf","Otigheim","Otisheim","Ottenbach","Ottendorf-Okrilla","Ottenhofen","Ottensoos","Otter","Otterbach","Otterberg","Otterfing","Otterloh","Otterndorf","Ottersberg","Ottersheim","Otterstadt","Ottersweier","Otterwisch","Ottobeuren","Ottobrunn","Ottrau","Ottweiler","Otze","Otzing","Ovelgoenne","Ovelgonne","Overath","Owen","Owingen","Owschlag","Oy-Mittelberg","Oyten","Padelugge","Padenstedt","Paderborn","Pahl","Painten","Palling","Panschwitz-Kuckau","Pansdorf","Pantelitz","Papenburg","Papendorf","Pappenheim","Paradies","Parchim","Parey","Parkstein","Parkstetten","Parnsberg","Parsau","Parsdorf","Partenheim","Partenstein","Parum","Pasewalk","Passau","Passow","Pastetten","Pattensen","Patzig","Paulinenaue","Paunzhausen","Pausa","Pauscha","Pechbrunn","Peckelsheim","Peetsch","Pegau","Pegnitz","Peine","Peissenberg","Peiting","Peitz","Pellingen","Pellworm","Pelm","Pemfling","Penig","Pentenried","Pentling","Penzberg","Penzing","Perach","Perkam","Perl","Perleberg","Perlesreut","Pesch","Pessenburgheim","Pesterwitz","Petersaurach","Petersberg","Petersdorf","Petershagen","Petershausen","Petriroda","Petting","Pettstadt","Pewsum","Pfaffen-Schwabenheim","Pfaffenhausen","Pfaffenhofen","Pfaffenhofen an der Ilm","Pfaffenhofen an der Roth","Pfaffenweiler","Pfaffing","Pfaffroda","Pfalzfeld","Pfalzgrafenweiler","Pfarrkirchen","Pfarrweisach","Pfatter","Pfedelbach","Pfeffelbach","Pfeffenhausen","Pflummern","Pforring","Pforzen","Pforzheim","Pfreimd","Pfronten","Pfullendorf","Pfullingen","Pfungstadt","Philippsburg","Philippsthal","Pickliessem","Piding","Piesport","Pilsach","Pilsting","Pinneberg","Pinnow","Pirk","Pirmasens","Pirna","Pittenhart","Pixel","Plaidt","Plan","Planegg","Plankstadt","Plate","Platkow","Platten","Plattenburg","Plattling","Plau am See","Plaue","Plauen","Plech","Pleckhausen","Pleidelsheim","Plein","Pleinfeld","Pleiskirchen","Pleisweiler-Oberhofen","Pleizenhausen","Plessa","Plettenberg","Pleystein","Pliening","Pliezhausen","Plochingen","Plodda","Ploen","Plossberg","Pluderhausen","Pluwig","Pockau","Pocking","Podeldorf","Poggensee","Pohl","Pohnstorf","Poing","Point","Polch","Politz","Pollenfeld","Pollhagen","Polling","Pommelsbrunn","Pommerby","Pomster","Poppenhausen","Poppenlauer","Poppenricht","Pornbach","Porta Westfalica","Posing","Possendorf","Possenheim","Possneck","Postbauer-Heng","Postmunster","Potsdam","Pottenstein","Pottmes","Pouch","Poxdorf","Pracht","Prackenbach","Prangendorf","Prebberede","Prebitz","Preetz","Preith","Premnitz","Prenzlau","Pressath","Pressen","Pressig","Prestewitz","Pretzfeld","Preussisch Oldendorf","Prichsenstadt","Prien am Chiemsee","Priesendorf","Priestewitz","Prietitz","Prisdorf","Prittriching","Pritzwalk","Probsteierhagen","Prohn","Proseken","Protzen","Pruchten","Prum","Prumzurlay","Prutting","Puchersreuth","Puchheim","Puderbach","Pulheim","Pullach im Isartal","Pullenreuth","Pullhausen","Puls","Pulsnitz","Purgen","Puschendorf","Putbus","Putlitz","Puttlingen","Putzbrunn","Pyrbaum","Quaal","Quakenbruck","Quarnbek","Quarnstedt","Quedlinburg","Queidersbach","Querfurt","Querum","Quickborn","Quierschied","Quitzow","Raben","Rabenau","Rabenholz","Rabenkirchen-Fauluck","Rabke","Rachelsbach","Rackith","Rackwitz","Radbruch","Radeberg","Radebeul","Radeburg","Radefeld","Radegast","Radevormwald","Radibor","Radolfzell","Raesfeld","Raguhn","Rahden","Raibach","Rain","Raisdorf","Raisting","Ralingen","Rambin","Ramerberg","Rammelsbach","Rammenau","Rammingen","Ramsau","Ramsen","Ramsla","Ramsloh","Ramstein-Miesenbach","Ramsthal","Randersacker","Rangendingen","Rangsdorf","Ranis","Ransbach-Baumbach","Ranstadt","Ransweiler","Rantum","Rantzau","Rappenau","Raschau","Rasdorf","Rasselstein","Rastatt","Rastdorf","Rastede","Rastenberg","Rastow","Ratekau","Rath","Rathenow","Ratingen","Rattelsdorf","Rattenberg","Rattenkirchen","Ratzeburg","Raubach","Raubling","Rauda","Rauen","Rauenberg","Rauenstein","Raunheim","Rauschenberg","Rausdorf","Ravensburg","Ravenstein","Rechberg","Rechberghausen","Rechenberg-Bienenmuhle","Rechtenbach","Rechtenfleth","Rechtenstein","Rechtmehring","Rechtsupweg","Recke","Recklinghausen","Reddelich","Redefin","Redekin","Rednitzhembach","Redwitz an der Rodach","Rees","Regen","Regensburg","Regenstauf","Regis-Breitingen","Regnitzlosau","Rehau","Rehburg-Loccum","Rehden","Reher","Rehfelde","Rehhorst","Rehling","Rehlingen-Siersburg","Rehna","Reich","Reichardtswerben","Reichartshausen","Reichelsheim","Reichenbach","Reichenbach im Tale","Reichenbach-Steegen","Reichenbach/Vogtland","Reichenschwand","Reichersbeuern","Reichertshausen","Reichertshofen","Reilingen","Reimlingen","Reimsbach","Reinbek","Reinfeld","Reinhartshausen","Reinheim","Reinsberg","Reinsdorf","Reinstadt","Reipoltskirchen","Reisbach","Reischach","Reiskirchen","Reit im Winkl","Reithofen","Reitmehring","Reitsch","Rellingen","Remagen","Remels","Remlingen","Remmesweiler","Remptendorf","Remscheid","Renchen","Rendsburg","Rengsdorf","Rennerod","Rennersdorf","Rennertshofen","Renningen","Renquishausen","Rentrisch","Rentweinsdorf","Reppenstedt","Retgendorf","Rethwisch","Rettenberg","Rettersen","Rettert","Rettigheim","Rettin","Retzstadt","Reute","Reuth","Reutlingen","Reutlingendorf","Rhade","Rhadereistedt","Rhaunen","Rheda-Wiedenbruck","Rhede","Rheden","Rhein","Rheinau","Rheinbach","Rheinberg","Rheinbollen","Rheinbreitbach","Rheinbrohl","Rheine","Rheinfelden","Rheinsberg","Rheinzabern","Rheurdt","Rhinow","Rhumspringe","Ribbeck","Ribbesbuttel","Ribnitz","Ribnitz-Damgarten","Richen","Rickenbach","Rickert","Riding","Riedbach","Riede","Rieden","Riedenberg","Riedenburg","Riedenheim","Rieder","Riederich","Riedering","Riedhausen","Riedlingen","Riedmoos","Riegel","Riegelsberg","Riegsee","Rielasingen-Worblingen","Riemerling","Rieneck","Riepsdorf","Riesa","Rieseby","Rieste","Rietberg","Rietheim","Riethnordhausen","Rietschen","Rimbach","Rimhorn","Rimpar","Rimschweiler","Rimsting","Rinchnach","Ringenwalde","Ringsberg","Ringsheim","Rinteln","Rinzenberg","Riol","Ritschenhausen","Ritterhude","Rittersdorf","Robel","Rochlitz","Rockenberg","Rockenhausen","Rodach","Rodalben","Roden","Rodenbach","Rodenberg","Rodental","Rodersheim-Gronau","Rodewisch","Rodgau","Rodheim","Roding","Rodinghausen","Roehrnbach","Roes","Roetgen","Roetz","Rofingen","Roggenburg","Roggentin","Rogling","Rohr","Rohrbach","Rohrdorf","Rohrenfels","Rohrmoos","Rohrsdorf","Roigheim","Roklum","Rollbach","Rollshausen","Romhild","Rommerskirchen","Romrod","Romsthal","Rondeshagen","Ronneburg","Ronnenberg","Ronsberg","Rorichum","Rosbach vor der Hohe","Roschbach","Rosdorf","Roseburg","Rosenburg","Rosendahl","Rosenfeld","Rosengarten","Rosenheim","Rosenkopf","Rosenthal","Rositz","Roslau","Rosrath","Rossau","Rossdorf","Rosshaupten","Rosslau","Rosstal","Rosswein","Rostock","Rot am See","Rotenburg","Rotenburg an der Fulda","Rotenhain","Roth","Rotha","Rothenbach","Rothenbach an der Pegnitz","Rothenbuch","Rothenburg","Rothenfels","Rothenstein","Rothhausen","Rothlein","Rothof","Rott am Inn","Rottach","Rottach-Egern","Rottenacker","Rottenbach","Rottenbuch","Rottenburg","Rottenburg an der Laaber","Rottendorf","Rottenstuben","Rotterode","Rotthalmunster","Rottingen","Rottleberode","Rottweil","Rovershagen","Roxel","Rubke","Ruchheim","Ruchsen","Ruckeroth","Ruckersdorf","Ruckholz","Rudelzhausen","Ruderatshofen","Rudersberg","Rudersdorf","Ruderting","Rudesheim","Rudesheim am Rhein","Rudolstadt","Rugendorf","Rugheim","Rugland","Ruhen","Ruhla","Ruhland","Ruhpolding","Ruhstorf","Ruit","Rullstorf","Rulzheim","Rumeltshausen","Rummer","Rummingen","Rumohr","Runding","Runkel","Runthe","Ruppach-Goldhausen","Ruppertsberg","Ruppertshofen","Ruppertsweiler","Ruppichteroth","Ruschberg","Ruscheid","Ruspel","Rust","Rutesheim","Ruthen","Ruthnick","Rutsweiler an der Lauter","Saal","Saaldorf","Saalfeld","Saalstadt","Saara","Saarburg","Saarlouis","Saarwellingen","Sachsen","Sachsenhagen","Sachsenheim","Sachsenkam","Sack","Saerbeck","Saffig","Sagard","Sailauf","Saint Egidien","Saint Michaelisdonn","Salach","Salching","Saldenburg","Salem","Salgen","Salm","Salmtal","Salz","Salzbergen","Salzburg","Salzgitter","Salzgitter-Bad","Salzhausen","Salzhemmendorf","Salzkotten","Salzstetten","Salzwedel","Salzweg","Samerberg","Samern","Samswegen","Samtens","Sand","Sandberg","Sandbostel","Sande","Sandersdorf","Sandersleben","Sandesneben","Sandhausen","Sandkrug","Sangerhausen","Sankt Andreasberg","Sankt Augustin","Sankt Englmar","Sankt Georgen im Schwarzwald","Sankt Ingbert","Sankt Katharinen","Sankt Leon-Rot","Sankt Peter-Ording","Sankt Wendel","Sankt Wolfgang","Sanssouci","Sargenroth","Sarkwitz","Sarlhusen","Sarstedt","Sasbach","Sasbachwalden","Sassenberg","Sassenburg","Sassnitz","Satjendorf","Satrup","Satteldorf","Sattelstadt","Satzvey","Sauensiek","Sauerlach","Sauldorf","Saulgau","Schaafheim","Schaalby","Schacht-Audorf","Schackendorf","Schacksdorf","Schadeleben","Schafflund","Schafstedt","Schalkau","Schalksmuhle","Schallstadt","Schammelsdorf","Scharbeutz","Scharnebeck","Scharnhorst","Scharrel","Schauenstein","Schauerberg","Schaulings","Schaumburg","Schechen","Schechingen","Scheden","Scheer","Scheessel","Scheidegg","Scheinfeld","Schelklingen","Schellerten","Schellhorn","Schellweiler","Schenefeld","Schenkenhorst","Schenkenzell","Schenklengsfeld","Scherenbostel","Schermbeck","Schermen","Scherstetten","Schesslitz","Scheuerfeld","Scheuerhalden","Scheuring","Scheyern","Schieder-Schwalenberg","Schierling","Schiffdorf","Schifferstadt","Schiffweiler","Schildau","Schildow","Schillingsfurst","Schillingshof","Schiltach","Schiltberg","Schindhard","Schiphorst","Schirgiswalde","Schirmitz","Schirnding","Schkeuditz","Schkolen","Schkopau","Schladen","Schlaitdorf","Schlammersdorf","Schlangen","Schlangenbad","Schlanstedt","Schlat","Schleching","Schlegel","Schlehdorf","Schleid","Schleiden","Schleife","Schleiz","Schlema","Schlepzig","Schleswig","Schlettau","Schleusingen","Schlieben","Schliengen","Schlier","Schlierbach","Schliersee","Schlitz","Schloss","Schloss Holte-Stukenbrock","Schlossberg","Schlotfeld","Schlotheim","Schluchsee","Schluchtern","Schlusselfeld","Schmalenberg","Schmalensee","Schmalkalden","Schmallenberg","Schmelz","Schmerz","Schmidgaden","Schmidmuhlen","Schmidt","Schmidthachenbach","Schmiechen","Schmiedefeld am Rennsteig","Schmilau","Schmitten","Schmittweiler","Schmolln","Schnabelwaid","Schnackenburg","Schnaitsee","Schnaittach","Schnaittenbach","Schneckenhausen","Schnee","Schneeberg","Schnega","Schneizlreuth","Schnellbach","Schnelldorf","Schnellmannshausen","Schneppenbach","Schneverdingen","Schney","Schnurpflingen","Schoeffengrund","Schoenberg","Schoenheide","Schollbrunn","Schollene","Schollkrippen","Schollnach","Schomberg","Schonach im Schwarzwald","Schonaich","Schonau","Schonau im Schwarzwald","Schonberg","Schonborn","Schonbrunn","Schondorf am Ammersee","Schondra","Schonebeck","Schoneberg","Schoneck","Schonecken","Schonefeld","Schoneiche","Schonenberg","Schonenberg-Kubelberg","Schonewalde","Schoneworde","Schonfeld","Schonfliess","Schongau","Schongeising","Schoningen","Schonkirchen","Schonsee","Schonstett","Schonthal","Schonungen","Schonwald","Schonwald im Schwarzwald","Schonwalde","Schopfheim","Schopfloch","Schoppenstedt","Schoppingen","Schopsdorf","Schorndorf","Schornsheim","Schortens","Schossin","Schotten","Schramberg","Schriesheim","Schrobenhausen","Schrozberg","Schuby","Schuld","Schulendorf","Schulldorf","Schuller","Schulzendorf","Schuttertal","Schutterwald","Schuttorf","Schutz","Schutzbach","Schutzenhof","Schwaan","Schwabach","Schwaben","Schwabenheim","Schwabhausen","Schwabmunchen","Schwabniederhofen","Schwabstedt","Schwaibach","Schwaig","Schwaigern","Schwaikheim","Schwalbach","Schwalbach am Taunus","Schwalingen","Schwallungen","Schwalmstadt","Schwalmtal","Schwandorf in Bayern","Schwanebeck","Schwaneberg","Schwanewede","Schwanfeld","Schwangau","Schwansee","Schwarme","Schwarmstedt","Schwarz","Schwarzach","Schwarzbach","Schwarzenbach","Schwarzenbach am Wald","Schwarzenbach an der Saale","Schwarzenbek","Schwarzenberg","Schwarzenborn","Schwarzenbruck","Schwarzenfeld","Schwarzhausen","Schwarzheide","Schwarzholz","Schwarzwald","Schwebheim","Schwedelbach","Schwedt (Oder)","Schwegenheim","Schweiburg","Schweich","Schweigen-Rechtenbach","Schweinfurt","Schweitenkirchen","Schweizerhof","Schwelm","Schwendi","Schwenningen","Schwerin","Schweringen","Schwerstedt","Schwerte","Schwesing","Schwetzingen","Schwieberdingen","Schwienau","Schwifting","Schwindegg","Schwirzheim","Schwollen","Schworstadt","Sebnitz","Seck","Seckach","Seebach","Seebad Ahlbeck","Seebad Bansin","Seebad Heringsdorf","Seebergen","Seebruck","Seeburg","Seedorf","Seefeld","Seeg","Seega","Seehaus","Seehausen","Seeheilbad Graal-Muritz","Seeheim-Jugenheim","Seehof","Seeland","Seelbach","Seelitz","Seelow","Seelscheid","Seelze","Seeon-Seebruck","Seesbach","Seesen","Seeshaupt","Seester","Seevetal","Seffern","Sefferweich","Sehlde","Sehlem","Sehlen","Sehma","Sehnde","Seifhennersdorf","Selb","Selbach","Selbitz","Selent","Seligenstadt","Seligenthal","Sellerich","Sellin","Selm","Selmsdorf","Selsingen","Selters","Selzen","Sembach","Senden","Sendenhorst","Senftenberg","Sengenthal","Sennfeld","Sensweiler","Senzig","Sereetz","Serrig","Sersheim","Sesslach","Seth","Seubersdorf","Seukendorf","Sexau","Sibbesse","Sickte","Siebenbaumen","Siedenbrunzow","Siedenburg","Siegburg","Siegelsbach","Siegen","Siegenburg","Siegsdorf","Sielenbach","Sierksdorf","Siershahn","Siesbach","Sievershutten","Sieverstedt","Sigmaringen","Sigmaringendorf","Sigmarszell","Silling","Simbach","Simbach am Inn","Simmelsdorf","Simmerath","Simmern","Simmersfeld","Simmertal","Simonsberg","Sindelfingen","Sindorf","Sindringen","Singen","Singenbach","Singhofen","Sinn","Sinsheim","Sinzheim","Sinzig","Sinzing","Sippersfeld","Sipplingen","Sittensen","Sochtenau","Soemmerda","Soest","Sogel","Sohland","Sohlde","Sohren","Solden","Solingen","Solkwitz","Soller","Sollerup","Sollstedt","Solms","Soltau","Soltendieck","Somborn","Sommerland","Sommerloch","Sondershausen","Sondheim","Sonneberg","Sonnefeld","Sonnschied","Sonsbeck","Sontheim","Sontheim an der Brenz","Sonthofen","Sontra","Sorth","Sorup","Sosa","Sotterhausen","Sottrum","Soyen","Spaichingen","Spalt","Spangdahlem","Spangenberg","Spardorf","Spatzenhausen","Spay","Spechtsbrunn","Spechtshausen","Speicher","Speichersdorf","Speinshart","Spelle","Spenge","Spessart","Spetzerfehn","Speyer","Spiegelau","Spiegelberg","Spiegelsberge","Spielberg","Spiesen-Elversberg","Spitzkunnersdorf","Splietsdorf","Sponheim","Spora","Spornitz","Spraitbach","Spree","Spreenhagen","Spremberg","Sprendlingen","Sprengel","Springe","Springstille","Sprockhovel","Stabelow","Stade","Stadecken-Elsheim","Stadelhofen","Stadt","Stadt Wehlen","Stadtallendorf","Stadtbergen","Stadthagen","Stadtilm","Stadtkyll","Stadtlauringen","Stadtlohn","Stadtoldendorf","Stadtprozelten","Stadtroda","Stadtsteinach","Stahl","Stahlhofen","Stahnsdorf","Staig","Stammbach","Stammheim","Stamsried","Stangerode","Stapelburg","Stapelfeld","Starnberg","Stassfurt","Stauchitz","Staudt","Staufen im Breisgau","Staufenberg","Stegaurach","Stegen","Steglitz Bezirk","Steigra","Steimbke","Steimel","Stein","Stein an der Traun","Stein-Neukirch","Steinach","Steinau an der Strasse","Steinbach am Taunus","Steinburg","Steineberg","Steinegg","Steinen","Steinenbronn","Steineroth","Steinfeld","Steinfurt","Steingaden","Steinhagen","Steinhausen","Steinheim","Steinheim am Albuch","Steinheim am der Murr","Steinhoring","Steinhorst","Steinigtwolmsdorf","Steinlah","Steinmauern","Steintoch","Steinweiler","Steinwenden","Steinwiesen","Steisslingen","Stelle","Stellshagen","Stelzenberg","Stendal","Stepfershausen","Stephanskirchen","Sterbfritz","Sternberg","Sternenfels","Sterup","Sterzhausen","Stetten","Stettfeld","Steuden","Steudnitz","Steyerberg","Stiege","Stimpfach","Stinstedt","Stockach","Stockelsdorf","Stockhausen","Stockhausen-Illfurth","Stockheim","Stockse","Stocksee","Stockstadt am Main","Stockstadt am Rhein","Stoetze","Stolberg","Stolk","Stollberg","Stolpen","Stolzenau","Stolzenhagen","Storkow","Stornstein","Stotten","Stotternheim","Stottwang","Straelen","Strahlungen","Stralsund","Strande","Strassberg","Strasskirchen","Strasslach-Dingharting","Straubing","Straupitz","Strausberg","Straussfurt","Streich","Streithausen","Strickscheid","Strohkirchen","Strohn","Stromberg","Strucklingen","Strullendorf","Struxdorf","Stubenberg","Stuhlingen","Stuhr","Stukenbrock","Stulln","Stuttgart","Stutzengrun","Stutzerbach","Styrum","Suckow","Suddendorf","Suderau","Suderbrarup","Suderburg","Suderholz","Suderlugum","Suderstapel","Sudheide","Sudlohn","Sugenheim","Suhl","Suhlendorf","Sulfeld","Sulingen","Sulz am Neckar","Sulzbach","Sulzbach am Main","Sulzbach-Rosenberg","Sulzberg","Sulzemoos","Sulzfeld","Sulzgries","Sulzheim","Sulzthal","Sunching","Sundern","Sundhausen","Supplingen","Surheim","Susel","Sussen","Syke","Syrau","Taarstedt","Tabarz","Tacherting","Taching am See","Tailfingen","Talheim","Talkau","Tamm","Tangendorf","Tangerhutte","Tangermunde","Tangstedt","Tann","Tanna","Tannesberg","Tannhausen","Tantow","Tapfheim","Tappenbeck","Tarbek","Tarmow","Tarmstedt","Tarp","Tating","Tauberbischofsheim","Tauberfeld","Tauberrettersheim","Taucha","Tauche","Taufkirchen","Taunusstein","Taura","Tawern","Tecklenburg","Tegernheim","Tegernsee","Teichwolframsdorf","Teisendorf","Teising","Teisnach","Teistungenburg","Telgte","Tellingstedt","Teltow","Temmels","Templin","Tengen","Teningen","Tennenbronn","Terborg","Teschow","Tespe","Tessin","Tetenbull","Tetenhusen","Teterow","Tettau","Tettenwang","Tettnang Castle","Teublitz","Teuchern","Teugn","Teuschnitz","Teutschenthal","Thaden","Thale","Thaleischweiler-Froschen","Thalfang","Thalhausen","Thalheim","Thallichtenberg","Thallwitz","Thalmassing","Thalwenden","Thannberg","Thannhausen","Tharandt","Thedinghausen","Theilenhofen","Theilheim","Theissen","Theley","Themar","Thermalbad Wiesenbad","Thiendorf","Thierhaupten","Thierstein","Tholey","Thoma","Thomasburg","Thomm","Thuine","Thulba","Thum","Thungen","Thungersheim","Thur","Thurkow","Thurnau","Thyrnau","Thyrow","Tiddische","Tiefenbach","Tiefenbronn","Tiefenort","Tiefenthal","Tieplitz","Tieringen","Tilleda","Timmaspe","Timmendorf","Timmendorf Beach","Timmenrode","Tinnum","Tirschenreuth","Titisee-Neustadt","Titting","Tittling","Tittmoning","Titz","Tobertitz","Todenbuttel","Todendorf","Todesfelde","Todtenried","Todtenweis","Todtmoos","Todtnau","Todtnauberg","Toging am Inn","Tomerdingen","Tonbach","Tonisvorst","Tonndorf","Tonning","Topen","Toppenstedt","Torgau","Torgelow","Tornesch","Tostedt","Traben-Trarbach","Trabitz","Traisen","Traitsching","Trappenkamp","Trassem","Traubing","Traunreut","Traunstein","Traunwalchen","Trautskirchen","Trebbin","Treben","Trebendorf","Trebsen","Trebur","Treffelhausen","Treffelstein","Treia","Treis-Karden","Tremsbuttel","Trendelburg","Trent","Treuchtlingen","Treudelberg","Treuen","Treuenbrietzen","Triberg im Schwarzwald","Trier","Trierweiler","Triftern","Trimbs","Trippstadt","Triptis","Trittau","Trochtelfingen","Trogen","Troisdorf","Trollenhagen","Trossingen","Trostau","Trostberg an der Alz","Truchtlaching","Trulben","Trunkelsberg","Trusetal","Tschernitz","Tuerkenfeld","Tulau","Tuningen","Tuntenhausen","Turkheim","Tussenhausen","Tuszshing","Tutow","Tuttlingen","Tutzing","Tutzpatz","Twielenfleth","Twist","Twiste","Twistringen","Ubach-Palenberg","Uberfeld","Uberherrn","Uberlingen","Ubersee","Ubstadt-Weiher","Uchte","Uchtelhausen","Uckendorf","Udenheim","Uder","Uebigau","Ueckermunde","Uedem","Uehlfeld","Uelitz","Uelsen","Uelvesbull","Uelzen","Uersfeld","Uess","Ueterlande","Uetersen","Uettingen","Uetze","Uffenheim","Uffing","Uhingen","Uhldingen-Muhlhofen","Uhler","Uhlingen-Birkendorf","Ulbersdorf","Ulm","Ulmen","Ulmet","Ulrichstein","Ulsnis","Umkirch","Ummendorf","Umpfenbach","Unkel","Unlingen","Unna","Unnau","Unterammergau","Unterbaldingen","Unterdiessen","Unterdietfurt","Untereglfing","Untereisesheim","Unterensingen","Untereuerheim","Unterfoehring","Untergimpern","Untergriesbach","Untergruppenbach","Unterhaching","Unterhausen","Unterkirnach","Unterliezheim","Unterluss","Untermeitingen","Untermunkheim","Unterneukirchen","Unterpleichfeld","Unterreichenbach","Unterreit","Unterroth","Unterschleichach","Unterschleissheim","Unterschneidheim","Untersiemau","Untersteinach","Unterthingau","Unteruhldingen","Unterwellenborn","Unterwossen","Untrasried","Upgant-Schott","Urbach","Urbar","Urexweiler","Urmitz","Ursensollen","Urspringen","Urweiler","Urzig","Usedom","Usingen","Uslar","Ustersbach","Uttenreuth","Uttenweiler","Utting","Utzenfeld","Uxheim","Vacha","Vachendorf","Vahlbruch","Vahldorf","Vaihingen an der Enz","Vallendar","Valley","Varel","Vastorf","Vaterstetten","Vechelde","Vechta","Veckenstedt","Vegesack","Vehlow","Veilsdorf","Veitsbronn","Veitshochheim","Velbert","Velburg","Velden","Veldenz","Velen","Vellahn","Vellberg","Vellmar","Velpke","Velten","Veltheim","Vendersheim","Venne","Verchen","Verden an der Aller","Veringendorf","Veringenstadt","Verl","Versmold","Vesser","Vestenberg","Vestenbergsgreuth","Vetschau","Vettelschoss","Vettweiss","Viecheln","Viechtach","Vielbach","Vienenburg","Vier","Vierden","Viereth-Trunstadt","Vierhofen","Vierkirchen","Viernau","Viernheim","Viersen","Vieselbach","Vietgest","Villenbach","Villingen","Villingen-Schwenningen","Villingendorf","Villmar","Vilsbiburg","Vilseck","Vilsheim","Vilshofen","Vilshoven","Visbek","Visselhovede","Vitte","Vlotho","Vluyn","Voerde","Vogelsdorf","Vogelsen","Vogt","Vogtareuth","Vogtsburg","Vohburg an der Donau","Vohenstrauss","Vohl","Vohrenbach","Vohringen","Volkach","Volkenschwand","Volkenshagen","Volkersweiler","Volkertshausen","Volklingen","Volkmarsen","Vollersode","Vollersroda","Vollkofen","Vollrathsruhe","Voltlage","Volxheim","Vorbach","Vorden","Vordorf","Vorland","Vorra","Vorstetten","Vorwerk","Voslapp","Vreden","Waakirchen","Waal","Wabern","Wachau","Wachenheim an der Weinstrasse","Wachenroth","Wachsenburg","Wachtberg","Wachtendonk","Wachtersbach","Wachtum","Wacken","Wackernheim","Wackerow","Wackersdorf","Wadelsdorf","Wadern","Wadersloh","Wadgassen","Waffenbrunn","Wagenfeld","Wagenhoff","Wagersrott","Waghausel","Waging am See","Wahlstedt","Wahnwegen","Wahrenholz","Waiblingen","Waibstadt","Waidhaus","Wain","Waischenfeld","Wakendorf","Walchum","Wald","Wald-Michelbach","Waldalgesheim","Waldaschaff","Waldau","Waldbockelheim","Waldbreitbach","Waldbrol","Waldbrunn","Waldburg","Waldbuttelbrunn","Waldeck","Waldems","Waldenbuch","Waldenburg","Walderbach","Waldershof","Waldesch","Waldfeucht","Waldfischbach-Burgalben","Waldhambach","Waldheim","Waldkappel","Waldkirch","Waldkirchen","Waldkraiburg","Waldlaubersheim","Waldmohr","Waldmunchen","Waldorf","Waldsassen","Waldschlosschen","Waldsee","Waldshut","Waldshut-Tiengen","Waldsieversdorf","Waldstetten","Walhausen","Walheim","Walkenried","Wall","Walldorf","Walldurn","Walle","Wallendorf","Wallenfels","Wallenhorst","Wallerfangen","Wallersdorf","Wallerstein","Wallertheim","Walleshausen","Wallhausen","Wallmerod","Walluf","Walpertshofen","Walpertskirchen","Walsdorf","Walshausen","Walsleben","Walsrode","Waltenhofen","Waltersdorf","Waltershausen","Walting","Waltrop","Wandlitz","Wanfried","Wang","Wangen","Wangen im Allgau","Wangerooge","Wankendorf","Wanna","Wanne-Eickel","Wannweil","Wansleben","Wanzleben","Warberg","Warburg","Wardenburg","Wardow","Waren","Warendorf","Warin","Warmensteinach","Warmsen","Warnau","Warngau","Warnow","Warrenzin","Warstein","Wartenberg","Wartenberg-Rohrbach","Warthausen","Warza","Wasbek","Wasbuttel","Waschenbach","Waschenbeuren","Wasenweiler","Wassenach","Wassenberg","Wasser","Wasserburg am Inn","Wasserleben","Wasserliesch","Wasserlosen","Wassermungenau","Wassersleben","Wassertrudingen","Wasungen","Wathlingen","Wattenbek","Wattenheim","Wattmannshagen","Watzenborn","Waxweiler","Wechingen","Wechmar","Wechselburg","Weddel","Weddelbrook","Weddingstedt","Wedel","Wedringen","Weede","Weener","Weenzen","Wees","Weeze","Wefensleben","Weferlingen","Wegberg","Wegeleben","Wegscheid","Wehingen","Wehlheiden","Wehnrath","Wehr","Wehrbleck","Wehrheim","Weiberg","Weibern","Weibersbrunn","Weichering","Weichs","Weida","Weiden","Weidenbach","Weidenberg","Weidenhahn","Weidenhof","Weidenthal","Weidhausen","Weiding","Weigendorf","Weihenzell","Weiherhammer","Weihmichl","Weikersheim","Weil","Weil am Rhein","Weil der Stadt","Weil im Schonbuch","Weilar","Weilbach","Weilburg","Weiler","Weiler-Simmerberg","Weilerbach","Weilersbach","Weilerswist","Weilheim","Weilheim an der Teck","Weilmunster","Weiltingen","Weimar","Weinahr","Weinbach","Weinbohla","Weingarten","Weinheim","Weinsberg","Weinsfeld","Weinsheim","Weinstadt-Endersbach","Weischlitz","Weisel","Weisen","Weisenbach","Weisendorf","Weisenheim am Berg","Weisenheim am Sand","Weiskirchen","Weismain","Weissach","Weissandt-Golzau","Weissbach","Weissdorf","Weissen","Weissenborn","Weissenbrunn","Weissenburg","Weissenfeld","Weissenfels","Weissenhorn","Weissenohe","Weissensee","Weissenstadt","Weissenthurm","Weisswasser","Weisweil","Weitefeld","Weitenhagen","Weitersborn","Weitersburg","Weiterstadt","Weitersweiler","Weitnau","Weitramsdorf","Weitzschen","Weixerau","Welbsleben","Welden","Welgesheim","Welkenbach","Welle","Wellheim","Welschbillig","Welshofen","Welsleben","Welterod","Welver","Welzheim","Welzow","Wemding","Wenddorf","Wendeburg","Wendelstein","Wenden","Wendhausen","Wendisch Evern","Wendisch Rietz","Wendlingen am Neckar","Wendtorf","Wengelsdorf","Wennigsen","Wentorf","Wentorf bei Hamburg","Wenzenbach","Wenzendorf","Wenzingen","Wenzlow","Werben","Werda","Werdau","Werder","Werdohl","Werl","Werlaburgdorf","Werlau","Werlte","Wermelskirchen","Wermsdorf","Wernau","Wernberg-Koblitz","Werne","Werneck","Wernersberg","Werneuchen","Wernigerode","Werningshausen","Wernrode","Werpeloh","Werste","Wertach","Wertheim am Main","Werther","Wertingen","Wesel","Weselberg","Wesenberg","Wesendorf","Wesselburen","Wesseling","Wesseln","Wessiszell","Wessling","Wessobrunn Abbey","Weste","Westendorf","Westensee","Wester-Ohrstedt","Westerburg","Westerdeichstrich","Westeregeln","Westergellersen","Westerheim","Westerholt","Westerhorn","Westerkappeln","Westerland","Westerronfeld","Westerstede","Westerstetten","Westfeld","Westhausen","Westheim","Westhofen","Westkirchen","Westrhauderfehn","Wetschen","Wettelsheim","Wettenberg","Wetter","Wetter (Ruhr)","Wetterzeube","Wettin","Wettringen","Wettstetten","Wetzlar","Weyarn","Weyerbusch","Weyhausen","Weyhe","Wichte","Wickede","Wicklesgreuth","Wiebelsheim","Wiedemar","Wiederau","Wiedergeltingen","Wiefelstede","Wiehe","Wiehl","Wiek","Wielenbach","Wienhausen","Wienrode","Wiernsheim","Wiesau","Wiesbach","Wiesbaden","Wieseck","Wieselbach","Wiesenbach","Wiesenburg","Wiesenfeld","Wiesenfelden","Wiesensteig","Wiesent","Wiesentheid","Wieske","Wiesloch","Wiesmoor","Wiesthal","Wietmarschen","Wietze","Wietzen","Wietzendorf","Wiggensbach","Wilburgstetten","Wildau","Wildberg","Wildbergerhutte","Wildenberg","Wildenfels","Wildeshausen","Wildpoldsried","Wilferdingen","Wilgartswiesen","Wilhelm","Wilhelmsburg","Wilhelmsdorf","Wilhelmsfeld","Wilhelmshaven","Wilhelmsheim","Wilhelmsthal","Wilhermsdorf","Wilkau-Hasslau","Willebadessen","Willensen","Willich","Willingen","Willmars","Willmenrod","Willmersdorf","Willroth","Willstatt","Wilnsdorf","Wilsdruff","Wilstedt","Wilster","Wilsum","Wilthen","Wiltingen","Wimmelburg","Wimsheim","Wincheringen","Windach","Windberg","Windeby","Windehausen","Winden","Windesheim","Windhagen","Windischeschenbach","Windischleuba","Windorf","Windsbach","Wingst","Winhoring","Winkelhaid","Winkwitz","Winnen","Winnenden","Winnigstedt","Winningen","Winnweiler","Winsen","Winterbach","Winterberg","Winterhausen","Winterlingen","Winterrieden","Wintersdorf","Wintrich","Winzeln","Winzer","Wipfeld","Wippershain","Wirdum","Wirges","Wirsberg","Wisch","Wischhafen","Wismar","Wisper","Wissen","Wistedt","Wittdun","Wittekindshof","Wittelshofen","Witten","Wittenbeck","Wittenberg","Wittenberge","Wittenborn","Wittenburg","Wittenforden","Wittgendorf","Wittgensdorf","Wittgert","Wittichenau","Wittighausen","Wittingen","Wittislingen","Wittlich","Wittmund","Wittnau","Wittorf","Wittstock","Witzenhausen","Witzhave","Witzin","Witzwort","Woffleben","Wohlsborn","Wohltorf","Wohnbach","Wohnrod","Wohra","Wohrden","Woldegk","Woldert","Wolfach","Wolfegg","Wolfen","Wolferlingen","Wolferode","Wolfersdorf","Wolfersheim","Wolfgang","Wolfhagen","Wolfis","Wolfmannshausen","Wolframs-Eschenbach","Wolfratshausen","Wolfsburg","Wolfschlugen","Wolfsegg","Wolfsheim","Wolgast","Wolkenstein","Wollbrandshausen","Wollstein","Wolmirstedt","Wolnzach","Wolpertshausen","Wolpertswende","Wolpinghausen","Wolsdorf","Wolsendorf","Wolsfeld","Woltersdorf","Woltershausen","Woltingerode","Womrath","Wonfurt","Wonsees","Worbis","Worfelden","Worms","Wormstedt","Worpswede","Worrstadt","Worth","Worth am Main","Worth am Rhein","Worthsee","Wotersen","Wredenhagen","Wremen","Wrestedt","Wriedel","Wriezen","Wrist","Wrixum","Wuelfrath","Wulfen","Wulften","Wumbach","Wundersleben","Wunnenberg","Wunsiedel","Wunstorf","Wuppertal","Wurmannsquick","Wurmberg","Wurmlingen","Wurmsham","Wurselen","Wurzbach","Wurzburg","Wurzen","Wustenriet","Wustenrot","Wusterhausen","Wusterhusen","Wustermark","Wusterwitz","Wustheuterode","Wustweiler","Wutoschingen","Wyhl","Wyk auf Fohr","Xanten","Zaberfeld","Zahna","Zainingen","Zaisenhausen","Zaisertshofen","Zapel","Zapfendorf","Zarpen","Zarrendorf","Zarrentin","Zaulsdorf","Zechlin Dorf","Zehdenick","Zeil","Zeiskam","Zeithain","Zeitlofs","Zeitz","Zell","Zell am Harmersbach","Zell am Main","Zell im Wiesental","Zell unter Aichelberg","Zella-Mehlis","Zellingen","Zeltingen-Rachtig","Zemmer","Zempin","Zeppernick","Zerben","Zerbst","Zerf","Zernien","Zerre","Zerrenthin","Zetel","Zeulenroda","Zeuthen","Zeven","Ziegendorf","Zielitz","Ziemetshausen","Zierenberg","Ziesar","Ziesendorf","Ziltendorf","Zimmern","Zimmern ob Rottweil","Zingst","Zipplingen","Zirkow","Zirndorf","Zittau","Zolling","Zollstock","Zorbig","Zorge","Zorneding","Zornheim","Zoschingen","Zossen","Zottelstedt","Zschopau","Zschorlau","Zschornewitz","Zschortau","Zuchering","Zuffenhausen","Zuhlsdorf","Zulpich","Zusamaltheim","Zusmarshausen","Zussow","Zuzenhausen","Zweiflingen","Zwenkau","Zwesten","Zwickau","Zwiefalten","Zwiesel","Zwingenberg","Zwonitz"]},"DJ":{"id":"DJ","name":"Djibouti","timezones":["Africa/Nairobi"],"cities":[]},"DK":{"id":"DK","name":"Denmark","timezones":["Europe/Copenhagen"],"cities":["Aabenraa","Aabybro","Aalborg","Aarhus","Aars","Abyhoj","Agedrup","Agerbaek","Agerskov","Akirkeby","Albaek","Albertslund","Ale","Alestrup","Aller","Allerod","Allingabro","Allinge","Almind","Alsgarde","Alslev","Anholt","Ans","Ansager","Arden","Arre","Arslev","Arup","Asa","Askeby","Asnaes","Asperup","Assens","Astrup","Augustenborg","Auning","Avlum","Baekke","Baekmarksbro","Baelum","Bagsvaerd","Balle","Ballerup","Bandholm","Baring","Barrit","Beder","Bedsted","Bevtoft","Billund","Bjaert","Bjaeverskov","Bjerringbro","Blavand","Blokhus","Blommenslyst","Boeslunde","Bogense","Bogo By","Bolderslev","Bording Stationsby","Borkop","Borre","Borum","Borup","Bovlingbjerg","Bovrup","Brabrand","Braedstrup","Bramming","Brande","Branderup","Bredballe","Bredebro","Bredsten","Brejning","Brenderup","Broager","Brobyvaerk","Brondby Strand","Bronshoj","Brorup","Brovst","Bruunshab","Bryrup","Bylderup-Bov","Charlottenlund","Christiansfeld","Copenhagen","Dalmose","Dannemare","Daugard","Dianalund","Dong","Dronninglund","Dronningmolle","Dybvad","Ebberup","Ebeltoft","Ega","Egernsund","Egtved","Ejby","Ejstrup","Elsinore","Engesvang","Errindlev","Erslev","Esbjerg","Eskebjerg","Eskilstrup","Espergaerde","Faaborg","Fakse","Farevejle","Farum","Farup","Farvang","Fensmark","Ferritslev","Ferslev","Fjenneslev","Fjerritslev","Flauenskjold","Flemming","Follenslev","Fovling","Fredensborg","Fredericia","Frederiksberg","Frederiksdal","Frederikshavn","Frederikssund","Frorup","Frostrup","Fuglebjerg","Gadbjerg","Gadstrup","Galten","Gammel Svebolle","Gandrup","Ganlose","Gedved","Gelsted","Gentofte","Gesten","Gilleleje","Gislev","Gislinge","Gistrup","Give","Gjerlev","Gjern","Gjol","Gladsaxe","Glamsbjerg","Glejbjerg","Glesborg","Glostrup","Glumso","Glyngore","Gording","Gorlose","Graested","Gram","Gredstedbro","Greve","Greve Strand","Grevinge","Grindsted","Gudbjerg","Gudhjem","Gudme","Guldborg","Haderslev","Haderup","Hadsten","Hadsund","Hals","Hammel","Hammershoj","Hampen","Hanstholm","Harboore","Harby","Harlev","Harndrup","Harpelunde","Hasle","Haslev","Hasselager","Havdrup","Havndal","Hedehusene","Hedensted","Hejls","Hejnsvig","Hellebaek","Hellerup","Helsinge","Hemmet","Henne","Henne Strand","Herfolge","Herlev","Herlufmagle","Herning","Hesselager","Himmelev","Hinnerup","Hirtshals","Hjallerup","Hjerm","Hjortshoj","Hobro","Hodsager","Hojbjerg","Hojby","Hoje Tastrup","Hojslev","Holbaek","Holeby","Holme","Holme-Olstrup","Holstebro","Holsted","Holte","Hoptrup","Horbelev","Hornbaek","Horning","Hornslet","Hornsyld","Horsens","Horslunde","Horve","Hosterkob","Hou","Hovedgard","Humble","Humlebaek","Hundested","Hundslund","Hurup","Hvide Sande","Hvidovre","Hyllinge","Idestrup","Ikast","Janderup","Jelling","Jerslev","Jerup","Jordrup","Jorlunde","Juelsminde","Jyderup","Jyllinge","Jystrup","Kaldred","Kalundborg","Kalvehave","Karise","Karlslunde","Karlstrup","Karrebaeksminde","Karup","Kastrup","Kejlstrup","Kerteminde","Kettinge","Kibaek","Kirke Eskilstrup","Kirke Hvalso","Kirke Saby","Kirke-Hyllinge","Kjargaard","Kjellerup","Klampenborg","Klarup","Klemensker","Klippinge","Klokkerholm","Klovborg","Knebel","Kokkedal","Koldby","Kolding","Kolind","Kolsen","Kongens Lyngby","Kongerslev","Krusa","Kvaerndrup","Kvistgard","Kvols","Laeso","Lambjerg","Langa","Langeskov","Lasby","Laurbjerg","Ledoje","Lejre","Lem","Lemming","Lemvig","Lille Skensved","Liseleje","Logstrup","Lokken","Losning","Lundby Stationsby","Lunderskov","Lyngby","Lynge","Lystrup","Malling","Malov","Mariager","Maribo","Marslet","Marslev","Marstal","Martofte","Melby","Mern","Middelfart","Millinge","Moldrup","Morke","Morkov","Morud","Munke Bjergby","Munkebo","Naerum","Naesby","Naestved","Nakskov","Nexo","Nibe","Nim","Nimtofte","Niva","No","Nodebo","Norager","Nordborg","Nordby","Nordenskov","Norre Aby","Norre Asmindrup","Norre Bindslev","Norre Nebel","Norre Snede","Norreballe","Norresundby","Nyborg","Nygard","Nykobing Falster","Nykobing Mors","Nykobing Sjaelland","Nysted","Odder","Oddesund Syd","Odense","Odsted","Oksbol","Olsted","Olstykke","Omme","Orbaek","Ornhoj","Orsted","Orum","Osby","Ostbirk","Oster Assels","Ostermarie","Ostervra","Otterup","Oure","Padborg","Pandrup","Ramlose","Randbol","Randers","Ranum","Rebaek","Refsvindinge","Regstrup","Ribe","Ringe","Ringsted","Risskov","Rodding","Rodkaersbro","Rodvig","Ronde","Roskilde","Roslev","Rude","Ruds-Vedby","Rungsted","Ry","Rynkeby","Ryomgard","Ryslinge","Sabro","Saeby","Salten","Saltum","Sandager","Sanderum","Sandved","Sherrebek","Silkeborg","Sindal","Sjolund","Skaelskor","Skaering","Skagen","Skals","Skamby","Skanderborg","Skarup","Skibby","Skive","Skjern","Skodsborg","Skodstrup","Skovlunde","Slagelse","Slangerup","Slet","Snedsted","Snekkersten","Snertinge","Soborg","Soby","Soesmarke","Solbjerg","Sollested","Solrod","Sommersted","Sonder Omme","Sonder Stenderup","Sonderso","Soro","Sorring","Sorvad","Spentrup","Spjald","Spottrup","Stakroge","Stege","Stenderup","Stenlille","Stenlose","Stenstrup","Stensved","Stoholm","Stokkemarke","Store Fuglede","Store Heddinge","Store Merlose","Storvorde","Stouby","Stovring","Strandby","Strib","Stroby","Struer","Suldrup","Sulsted","Sundby","Sunds","Svaneke","Svanninge","Svendborg","Svenstrup","Svinninge","Taastrup","Tagerup","Tappernoje","Tarbaek","Tarm","Tars","Tejn","Terndrup","Them","Thisted","Thorso","Tikob","Tilst","Tim","Tinglev","Tistrup","Tisvildeleje","Tjaereborg","Tjebberup","Toftlund","Tollose","Tommerup","Toreby","Tornby","Torrig","Torring","Tranbjerg","Tranebjerg","Tranekaer","Trelde","Trige","TRUE","Trustrup","Tullebolle","Tune","Tureby","Tylstrup","Ugerlose","Uldum","Ulfborg","Ullerslev","Ulstrup","Vadum","Vaeggerlose","Vaerlose","Vamdrup","Vandel","Vantinge","Varde","Vasby","Vebbestrup","Vedbaek","Vederso","Veflinge","Vejby","Vejen","Vejle","Vejstrup","Vekso","Vemb","Vemmelev","Verninge","Vestbjerg","Vester Hassing","Vester-Skerninge","Vesterborg","Vestervig","Viborg","Viby","Vig","Vildbjerg","Vils","Vinderup","Vinkel","Vipperod","Virring","Virum","Vissenbjerg","Viuf","Vivild","Vodskov","Vojens","Vorbasse","Vordingborg","Vra"]},"DM":{"id":"DM","name":"Dominica","timezones":["America/Port_of_Spain"],"cities":[]},"DO":{"id":"DO","name":"Dominican Republic","timezones":["America/Santo_Domingo"],"cities":["Arenazo","Bavaro","Boca Chica","Cabarete","Cotui","Dominica","Guaricano","Hato Mayor del Rey","Jimani","La Romana","Los Alcarrizos","Los Prados","Moca","Pedernales","Puerto Plata","Punta Cana","Sabaneta","San Cristobal","San Fernando de Monte Cristi","San Jose de Ocoa","Santa Cruz de Barahona","Santiago de los Caballeros","Santo Domingo"]},"DZ":{"id":"DZ","name":"Algeria","timezones":["Africa/Algiers"],"cities":["Algiers","Annaba","Azazga","Batna City","Blida","Bordj","Bordj Bou Arreridj","Bougara","Cheraga","Chlef","Constantine","Djelfa","Draria","El Tarf","Hussein Dey","Illizi","Jijel","Kouba","Laghouat","Oran","Ouargla","Oued Smar","Relizane","Rouiba","Saida","Souk Ahras","Tamanghasset","Tiaret","Tissemsilt","Tizi","Tizi Ouzou","Tlemcen"]},"EC":{"id":"EC","name":"Ecuador","timezones":["America/Guayaquil","Pacific/Galapagos"],"cities":["Ambato","Atacames","Atuntaqui","Bahia de Caraquez","Banos","Calderon","Cayambe","Cuenca","Daule","El Carmen","El Naranjal","Esmeraldas","Florida","General Leonidas Plaza Gutierrez","Guabo","Gualaceo","Guamote","Guayaquil","Guayas","Guayllabamba","Hacienda Bolivia","Hacienda Duran","Hacienda Ibarra","Hacienda Santa Catalina","Huaquillas","Ibarra","Jipijapa","La Esperanza","La Libertad","La Troncal","Latacunga","Loja","Loreto","Macara","Macas","Machachi","Machala","Manta","Milagro","Montecristi","Nabon","Olmedo","Otavalo","Paccha","Pasaje","Pelileo","Pichincha","Playas","Portoviejo","Puerto Francisco de Orellana","Puyo","Quevedo","Quito","Riobamba","Salinas","Samborondon","San Miguel","San Rafael","Santa Cruz","Santa Elena","Santo Domingo de los Colorados","Sucre","Tababela","Tarapoa","Tena","Vinces","Zamora","Zaruma","Zumba"]},"EE":{"id":"EE","name":"Estonia","timezones":["Europe/Tallinn"],"cities":["Aasmae","Aaviku","Aespa","Ahtma","Alliku","Ambla","Antsla","Ardu","Avinurme","Elva","Emmaste","Haabneeme","Haage","Haapsalu","Halinga","Harju","Harku","Kaarma","Kadrina","Kehra","Keila","Kiili","Kohila","Kohtla","Kose","Kulna","Kuressaare","Kuusalu","Laagri","Lagedi","Lahtse","Lepna","Loksa","Loo","Lubja","Maardu","Muraste","Narva","Otepaeae","Paide","Paikuse","Paldiski","Palivere","Peetri","Puhja","Rakke","Rakvere","Rapla","Saku","Saue","Sindi","Somerpalu","Syare","Tabasalu","Tabivere","Tallinn","Tamsalu","Tapa","Tartu","Toila","Vaida","Valga","Vara","Venevere","Viimsi","Viljandi","Voka"]},"EG":{"id":"EG","name":"Egypt","timezones":["Africa/Cairo"],"cities":["Abu Hammad","Al Mahallah al Kubra","Al Mansurah","Al Marj","Alexandria","Almazah","Ar Rawdah","Assiut","Az Zamalik","Badr","Banha","Bani Suwayf","Cairo","Damietta","Faraskur","Flaminj","Giza","Heliopolis","Helwan","Hurghada","Ismailia","Kafr ash Shaykh","Luxor","Madinat an Nasr","Madinat as Sadis min Uktubar","Minya","Nasr","New Cairo","Port Said","Rafah","Ramsis","Sadat","Shirbin","Shubra","Sohag","Suez","Tanta","Toukh","Zagazig"]},"EH":{"id":"EH","name":"Western Sahara","timezones":["Africa/El_Aaiun"],"cities":[]},"ER":{"id":"ER","name":"Eritrea","timezones":["Africa/Nairobi"],"cities":[]},"ES":{"id":"ES","name":"Spain","timezones":["Europe/Madrid","Africa/Ceuta","Atlantic/Canary"],"cities":["A Cidade","A Estrada","A Pobra do Caraminal","Abadino","Abanilla","Abanto","Abaran","Abegondo","Abrera","Acala del Rio","Aceuchal","Adeje","Ador","Adra","Adrall","Aduna","Agaete","Agoncillo","Agost","Agramunt","Agreda","Aguadulce","Aguilafuente","Aguilar","Aguilar de Campoo","Aguilar del Rio Alhama","Agullana","Agullent","Ahigal","Aielo de Malferit","Aiguafreda","Aizarnazabal","Aizoain","Ajalvir","Ajo","Ajofrin","Alaejos","Alagon","Alameda","Alanis","Alava","Alba de Tormes","Albacete","Albaida","Albal","Albalat dels Sorells","Albalat dels Tarongers","Albalate de Cinca","Albarreal de Tajo","Albatera","Albelda de Iregua","Albendin","Alberic","Alberite","Albolote","Alboraya","Albox","Albuixech","Albujon","Alburquerque","Alcala de Xivert","Alcala del Obispo","Alcala la Real","Alcanadre","Alcanar","Alcantara","Alcantarilla","Alcarras","Alcazar de San Juan","Alcobendas","Alcoletge","Alcorisa","Alcossebre","Alcover","Alcoy","Aldaia","Aldealsenor","Aldeamayor de San Martin","Aldeanueva","Aldeanueva de Ebro","Aldeaseca de Armuna","Aldeatejada","Alegria","Alella","Alfafar","Alfajarin","Alfambra","Alfara de Algimia","Alfara del Patriarca","Alfaro","Alfarrasi","Alfondeguilla","Alforja","Algadefe","Algaida","Algar","Algarrobo","Algeciras","Algemesi","Algete","Algezares","Alginet","Algodonales","Algorta","Alguazas","Alhama de Aragon","Alhama de Granada","Alhama de Murcia","Alhambra","Alhaurin de la Torre","Alhaurin el Grande","Alhendin","Alicante","Aliseda","Aljaraque","Allariz","Almagro","Almansa","Almargen","Almassera","Almassora","Almazan","Almazcara","Almenar","Almenara","Almendralejo","Almensilla","Almodovar del Campo","Almodovar del Rio","Almonacid de Zorita","Almonte","Almoradi","Almoster","Almudebar","Almuna","Alonsotegi","Alora","Alosno","Alovera","Alozaina","Alpedrete","Alpicat","Alquerias","Alta","Altafulla","Altea","Altet","Altura","Alumbres","Alza","Alzira","Amavida","Amer","Ames","Ametlla","Amorebieta","Amposta","Ampuero","Amurrio","Anchuelo","Andeiro","Andoain","Andorra","Andosilla","Andujar","Anglesola","Anguciana","Anoeta","Anora","Anorbe","Antas","Antequera","Antigua","Aracena","Arafo","Arama","Aranda de Duero","Aranguren","Aranjuez","Aravaca","Arbizu","Arbo","Arboleas","Arca","Arcade","Arce","Archena","Archidona","Arcicollar","Arcos de la Frontera","Arenas de San Pedro","Arenys de Mar","Arenys de Munt","Ares","Arevalo","Argamasilla de Alba","Argamasilla de Calatrava","Arganda","Argelaguer","Argentona","Arges","Argonos","Arico","Arino","Arjona","Armilla","Armunia","Arnedillo","Arnedo","Arnuero","Aroche","Arona","Arrecife","Arriate","Arrigorriaga","Arroyal","Arroyo","Arroyo de la Luz","Arroyo de la Miel","Arroyo del Ojanco","Arroyomolinos","Arrubal","Artajo","Artajona","Artana","Arteixo","Artenara","Artes","Artesa de Segre","Arucas","Arzua","As Pontes de Garcia Rodriguez","Aspe","Asteasu","Astigarraga","Astorga","Astrabudua","Astrain","Astudillo","Atarfe","Atarrabia","Ataun","Ateca","Autol","Avia","Avinyonet del Penedes","Axpe","Ayamonte","Ayegui","Azagra","Azkoitia","Aznalcazar","Aznalcollar","Azpeitia","Azuaga","Azuqueca de Henares","Babilafuente","Badajoz","Badalona","Baena","Baeza","Baga","Bailen","Baina","Bajamar","Balaguer","Balazote","Balenya","Balerma","Balsareny","Balsicas","Banugues","Bara","Barakaldo","Baranain","Barbarroja","Barbastro","Barbate","Barcarrota","Barcelona","Barcena de Cicero","Bargas","Barranda","Barros","Bas","Basauri","Batres","Baza","Beas","Beas de Segura","Becerril de la Sierra","Bedmar","Begijar","Begis","Begues","Begur","Bejar","Belgida","Belicena","Bellpuig","Bellvei","Bellver de Cerdanya","Bellvis","Belvis de Jarama","Belvis de la Jara","Bembibre","Benacazon","Benagalbon","Benahadux","Benahavis","Benamargosa","Benameji","Benatae","Benavarri / Benabarre","Benavente","Benavides","Benejuzar","Beniajan","Beniarbeig","Beniarjo","Beniarres","Benicassim","Benicolet","Benidoleig","Benidorm","Beniel","Benifairo de les Valls","Benifato","Beniganim","Benijofar","Benimodo","Beniparrell","Benisano","Benissa","Benisuera","Benitachell","Beranga","Berango","Berantevilla","Berastegui","Berga","Bergondo","Berguenda","Beriain","Berja","Bermeo","Bernuy","Berriatua","Berriobeiti","Berriozar","Berriz","Berrobi","Berron","Bescano","Betanzos","Betelu","Betera","Beznar","Biar","Bicorp","Bigastro","Bigues i Riells","Bilbao","Binefar","Bitem","Blanca","Blancos","Blanes","Boadilla del Monte","Bocairent","Boceguillas","Boecillo","Bogajo","Boimorto","Boiro","Bolanos de Calatrava","Bollullos de la Mitacion","Bollullos par del Condado","Boltana","Bolvir","Bonares","Borben","Bordils","Borja","Bormujos","Bornos","Borox","Borriol","Botarell","Botorrita","Brafim","Brazatortas","Brea de Aragon","Breda","Brenes","Brihuega","Brion","Briviesca","Broto","Brunete","Buenache de Alarcon","Bueu","Bujaraloz","Bullas","Burela de Cabo","Burgos","Burguillos","Burguillos del Cerro","Burjassot","Burlata","Burriana","Busot","Bustarviejo","Busturi-Axpe","Cabana","Cabanaquinta","Cabanas","Cabanas de la Sagra","Cabanes","Cabanillas del Campo","Cabeza del Buey","Cabezarrubias del Puerto","Cabezo de Torres","Cabezon de la Sal","Caborana","Cabra","Cabrera de Almanza","Cabrerizos","Cabrils","Cacheiras","Cadiar","Cadiz","Cadreita","Caion","Cajar","Cala","Cala del Moral","Cala Millor","Cala Ratjada","Calaf","Calafell","Calahonda","Calahorra","Calamonte","Calasparra","Calatayud","Calatorao","Caldelas","Calders","Caldes de Malavella","Calella","Calig","Callosa de Segura","Calo","Calonge","Calpe","Camarassa","Camarenilla","Camargo","Camarinas","Camarma de Esteruelas","Camas","Cambados","Cambre","Cambrils","Camos","Campanario","Campillo","Campillos","Campina","Campins","Campo","Campo de Criptana","Campo Real","Campohermoso","Camponaraya","Campos","Camprodon","Campuzano","Can Picafort","Canal","Canals","Canar","Candas","Candelaria","Candeleda","Caneja","Canet de Mar","Canete de las Torres","Cangas de Onis","Cangas del Narcea","Cangas do Morrazo","Canillas de Albaida","Canovelles","Cantillana","Cantimpalos","Capdepera","Capela","Capella","Capellades","Capileira","Capmany","Capsec","Carabana","Caravaca","Carbajal de la Legua","Carbajosa de la Sagrada","Carballo","Carcabuey","Carcar","Carcastillo","Cardedeu","Cardenal","Cardenosa","Cardona","Carinena","Carlet","Carmona","Carpesa","Carpio","Carral","Carranque","Carrascal de Barregas","Carrion de los Cespedes","Carrion de los Condes","Carrizo de la Ribera","Cartagena","Cartama","Cartaya","Cartelle","Casabermeja","Casar de Caceres","Casares","Casarrubios del Monte","Casas del Castanar","Casas del Monte","Casas Viejas","Caserio El Campello","Casetas","Casillas de Coria","Casillas del Angel","Casla","Caso","Caspe","Castalla","Castandiello","Castejon","Castejon del Puente","Castell de Ferro","Castellar de la Frontera","Castellar de Santiago","Castellar del Valles","Castellbell i el Vilar","Castellbisbal","Castelldefels","Castellet","Castello","Castellvell del Camp","Castellvi de Rosanes","Castelseras","Castilblanco de los Arroyos","Castilleja de Guzman","Castilleja de la Cuesta","Castillo de Locubin","Castillo del Romeral","Castrillon","Castro","Castro Urdiales","Castrogonzalo","Castropol","Castuera","Catadau","Catarroja","Cati","Catoira","Catral","Caudete","Cazalegas","Cazorla","Cea","Cebolla","Cebreros","Cecenas","Cedillo del Condado","Celanova","Celeiro","Celeiros","Celra","Cenes de la Vega","Cenicero","Cenicientos","Central","Cerceda","Cercedilla","Cerdeda","Cerro Muriano","Cervello","Cervera","Cervera del Rio Alhama","Cervo","Cetina","Ceuta","Ceuti","Chantada","Chapela","Chauchina","Checa","Chelva","Cheste","Chiclana de la Frontera","Chiclana de Segura","Chilches","Chiloeches","Chinchilla de Monte Aragon","Chipiona","Chiva","Chozas de Canales","Chucena","Churra","Churriana","Churriana de la Vega","Cicero","Cidones","Ciempozuelos","Cieza","Cifuentes","Cigales","Cijuela","Cilleros","Ciriza","Cisterniga","Cistierna","Ciudad Real","Ciudad Rodrigo","Ciutadella","Cizur Menor","Cobatillas","Cobena","Cobisa","Coca","Cocentaina","Cogollos","Coin","Coiros","Colera","Coles","Colinas de Trasmonte","Colindres","Collado","Collado Mediano","Collado Villalba","Collbato","Colmenar de Oreja","Colmenar del Arroyo","Colmenar Viejo","Colmenarejo","Colonia de San Pedro","Comares","Comillas","Competa","Compostela","Conil de la Frontera","Consell","Constanti","Constantina","Consuegra","Corbera","Corbera de Llobregat","Corchuela","Cordova","Corella","Corgo","Coria","Coristanco","Corme-Porto","Cornellana","Corral de Almaguer","Corralejo","Corrales","Cortegana","Cortes de la Frontera","Cortiguera","Corvera","Coslada","Costa","Costur","Couso de Salas","Covaleda","Cox","Creixell","Crevillent","Cruce de Arinaga","Cruces","Cruilles","Cruz","Cuadros","Cuarte de Huerva","Cubas","Cubelles","Cubillos del Sil","Cudillero","Cuellar","Cuenca","Cueto","Cuevas de San Marcos","Cuevas de Vinroma","Cuevas del Almanzora","Cullera","Culleredo","Cunit","Cuntis","Curro","Curtis","Daganzo de Arriba","Daimiel","Dalias","Daroca","Daya Vieja","Deba","Denia","Derio","Deustu","Diezma","Dilar","Dodro","Dolores","Domingo Perez","Don Benito","Dos Hermanas","Dosbarrios","Dosrius","Duenas","Dumbria","Durango","Durcal","Echarri-Aranaz","Egues-Uharte","Eibar","Ejea de los Caballeros","El Abrigo","El Alamo","El Arahal","El Astillero","El Ballestero","El Barco de Avila","El Burgo de Ebro","El Burgo de Osma","el Camp de Mirra","el Campello","El Casar","el Catllar","El Coronil","El Corrillo","El Cuervo","El Ejido","El Escorial","El Espinar","El Garrobo","El Grado","El Grao","El Hoyo de Pinares","el Masnou","El Medano","El Molar","El Moral","el Morche","el Morell","El Palmar","El Palmar de Troya","El Papiol","El Pedernoso","El Perello","el Poal","El Pozo de los Frailes","el Prat de Llobregat","El Provencio","El Puerto","El Raal","El Real de la Jara","El Saler","El Sauzal","El Sotillo","El Tablero","El Torno","El Toro","El Vellon","El Vendrell","El Viso de San Juan","El Viso del Alcor","Elburgo","Elche","Elda","Elechas","Elexalde","Elgoibar","Elgorriaga","Elizondo","Elorrio","els Hostalets de Pierola","Els Monjos","els Pallaresos","Eltzaburu","Encinas Reales","Encinasola","Eneriz","Enguera","Entrambasaguas","Entrevias","Epila","Erandio","Ermua","Errenteria","Escalona","Escalonilla","Escatron","Escurial","Esparreguera","Espartinas","Espejo","Espera","Espiel","Espinardo","Espirdo","Esplugues de Llobregat","Esplus","Espolla","Esquivias","Esteiro","Estella-Lizarra","Estellencs","Estepa","Estepona","Estrada","Ezcaray","Fabero","Falces","Falset","Fasnia","Faura","Felanitx","Fene","Ferreira","Ferreries","Ferrol","Figaro","Figueras","Finestrat","Firgas","Fitero","Flix","Formentera de Segura","Fornells de la Selva","Fortia","Fortuna","Forua","Foz","Fraga","Frailes","Fregenal de la Sierra","Fresno de la Vega","Frigiliana","Friol","Fruiz","Fuengirola","Fuenlabrada","Fuenmayor","Fuensalida","Fuensanta","Fuensanta de Martos","Fuente del Maestre","Fuente el Fresno","Fuente el Saz","Fuente Vaqueros","Fuente-Alamo","Fuentealbilla","Fuentelapena","Fuenterrabia","Fuentes","Fuentes de Andalucia","Fuentes de Ebro","Fuentes de Jiloca","Fuentes de Leon","Fuentes de Valdepero","Gaceta","Galapagar","Galapagos","Galaroza","Galdakao","Galdames Beitia","Galera","Galizano","Gallarta","Gallur","Galvez","Gamiz","Gamonal","Gandesa","Gandia","Garachico","Garcia","Garciaz","Gargallo","Garraf","Garrigas","Garriguella","Garrovillas","Garrucha","Gata","Gata de Gorgos","Gaucin","Gautegiz Arteaga","Gava","Gelida","Gelsa","Gelves","Genoves","Gerena","Gernika-Lumo","Getafe","Getaria","Gilet","Gines","Girona","Gironella","Gizaburuaga","Godella","Godelleta","Gojar","Golmayo","Golmes","Gondomar","Gordon","Gorriti","Gozon de Ucieza","Grado","Granada","Granadilla de Abona","Granja de Rocamora","Granollers","Graus","Grazalema","Grijota","Grinon","Grisen","Grove, O","Guadalajara","Guadalcazar","Guadalix de la Sierra","Guadalupe","Guadamur","Guadarrama","Guadiana del Caudillo","Guadiaro","Guadix","Guamasa","Guardamar del Segura","Guardo","Guarena","Guarnizo","Guejar-Sierra","Guenes","Guevejar","Guijuelo","Guillena","Guimar","Guitiriz","Gurb","Guzman","Haro","Hellin","Henares","Herencia","Hernani","Hernansancho","Hernialde","Herrera","Herrera de Pisuerga","Herrera del Duque","Higuera la Real","Hijar","Hinojedo","Hinojos","Hinojosa del Duque","Hinojosa del Valle","Hondon de las Nieves","Hondon de los Frailes","Hontanares de Eresma","Hontoria del Pinar","Horcajo de las Torres","Horche","Hornachos","Hornachuelos","Horta de Sant Joan","Hortichuela","Hospital","Hostalric","Hoya-Gonzalo","Hoyo de Manzanares","Huarte-Araquil","Huecas","Huelma","Huelva","Huelves","Huercal de Almeria","Huercal Overa","Huercanos","Huertas","Huerto","Huesca","Huete","Huetor Santillan","Huetor Vega","Huetor-Tajar","Huevar","Humanes","Humanes de Madrid","Hurchillo","Ibarra","Ibarruri","Ibi","Ibiza","Ibros","Icod de los Vinos","Idiazabal","Igualada","Igualeja","Igueste","Illa","Illana","Illas","Illescas","Illora","Illueca","Inca","Incio","Infantes","Ingenio","Iniesta","Ipazter","Irun","Irura","Isla Becoa","Isla Cristina","Isora","Itza","Iznajar","Iznate","Jabaga","Jabali Nuevo","Jaca","Jacarilla","Jaraiz de la Vera","Javea","Jerez de la Frontera","Jerez de los Caballeros","Jerte","Jesus","Jijona","Jimena de la Frontera","Joanetes","Jodar","Jorba","Jumilla","Juneda","La Abadilla","La Adrada","La Alameda de la Sagra","La Alberca","La Algaba","La Aljorra","La Almunia de Dona Godina","La Antilla","La Arena","La Baneza","la Baronia de Rialb","La Batlloria","La Bisbal","la Bisbal del Penedes","La Cabrera","La Calzada","La Calzada de Calatrava","La Calzada de Oropesa","La Campana","La Canada","La Canada de San Urbano","La Canalosa","La Canonja","La Caridad","La Carlota","La Carolina","La Cavada","La Codosera","La Espina","la Febro","La Felguera","La Figuera","La Flecha","La Floresta Pearson","La Florida","La Fresneda","La Frontera","La Fuente de San Esteban","La Galera","La Garganta","la Garriga","La Gineta","La Granada","la Granadella","La Granja","La Granja de San Vicente","La Guancha","La Guardia","La Guardia de Jaen","La Herradura","La Higuerita","La Lantejuela","La Llacuna","La Llagosta","La Llosa","La Luisiana","La Mamola","La Mancha Blanca","La Matanza de Acentejo","La Mojonera","La Muela","La Nora","la Nou de Bergueda","la Nucia","La Oliva","La Orden","La Orotava","La Palma del Condado","La Paz","La Pedraja de Portillo","La Pedrera","La Penilla","La Perdoma","La Plana","La Playa de Arguineguin","La Pobla de Claramunt","La Pobla de Lillet","la Pobla de Mafumet","la Pobla de Montornes","La Pola de Gordon","La Puebla de Almoradiel","La Puebla de Arganzon","La Puebla de Cazalla","La Puebla de Hijar","La Puebla de los Infantes","La Puebla de Montalban","La Puebla del Rio","La Pueblanueva","La Puerta de Segura","La Rambla","La Rapita","La Raya","La Red de Valdetuejar","La Riba","la Riera de Gaia","La Rinconada","La Robla","La Roca del Valles","La Roda","La Roda de Andalucia","La Seca","La Secuita","La Selva","La Serna","La Solana","La Torre","la Vall","la Vall del Bac","La Vera","La Victoria","La Victoria de Acentejo","La Vinuela","La Virgen del Camino","La Virgen del Pilar","La Yedra","Labajos","Lagartera","Lago","Laguardia","Laguna de Duero","Lajares","Lalin","Lama","Lamadrid","Lanaja","Landa","Langa","Langa de Duero","Langreo","Lanjaron","Lantadilla","Laracha","Lardero","Laredo","Las Cabezas de San Juan","Las Galletas","Las Hortichuelas","Las Islas","Las Matas","Las Navas de la Concepcion","Las Navas del Marques","Las Palmas de Gran Canaria","Las Rozas de Madrid","Las Torres de Cotillas","Las Vegas","Las Ventanas","Las Ventas de Retamosa","Lasarte","Laudio-Llodio","Lazagurria","Lebrija","Ledana","Ledrada","Legasa","Legazpia","Legorreta","Lekeitio","Lepe","Lerin","Lerma","les Borges del Camp","Les Fonts","Lezama","Lezo","Liano","Librilla","Liencres","Lijar","Lillo","Limones","Limpias","Linares","Linyola","Lires","Llafranc","Llagostera","Llanera","Llanes","Llano","Lledo","Lleida","Llerena","Llers","Llinars del Valles","Lliria","Llofriu","Lloret de Mar","Llosa de Ranes","Lobios","Lodosa","Loeches","Loja","Lomo de Arico","Lopera","Lorca","Loriguilla","Lorqui","Los Alcazares","Los Angeles","Los Barrios","Los Corrales","Los Corrales de Buelna","Los Cristianos","Los Dolores","Los Gallardos","Los Garres","Los Hueros","Los Llanos de Aridane","Los Marines","Los Molinos","Los Montes","Los Narejos","Los Navalmorales","Los Navalucillos","Los Palacios","Los Palacios y Villafranca","Los Rios","Los Rosales","Los Santos de la Humosa","Los Silos","Los Villares","Los Yebenes","Losar de la Vera","Lousame","Luanco","Luarca","Lucena","Lucena del Cid","Lucena del Puerto","Luceni","Lucillos","Lugo","Lugones","Luou","Luyando","Luzaide","Luzmela","Macael","Macanet de la Selva","Maceira","Madrid","Madridanos","Madridejos","Madrigal de la Vera","Madrigalejo","Madrigueras","Madronera","Magan","Mahon","Mairena del Alcor","Mairena del Aljarafe","Majadahonda","Malagon","Malgrat de Mar","Maliano","Mallen","Malpartida de Caceres","Malpartida de Plasencia","Malpica","Manacor","Mancha Real","Manilva","Manises","Manlleu","Manresa","Manuel","Manzanares","Manzanares el Real","Maracena","Marbella","Marchamalo","Marchena","Marcilla","Margarida","Maria de Huerva","Maria de la Salut","Marin","Mariola","Marmolejo","Martin","Martinet","Martorell","Martos","Marugan","Marzagan","Masdenverge","Maside","Masllorenc","Maspalomas","Masquefa","Massamagrell","Mata","Matadepera","Mataelpino","Mataluenga","Matamorosa","Matapozuelos","Mayor","Mazagon","Meano","Mecina Fondales","Meco","Medina de Pomar","Medina del Campo","Medina-Sidonia","Medinya","Medio","Mediona","Medrano","Meira","Meis","Mejorada","Mejorada del Campo","Meliana","Melilla","Membrilla","Mendaro","Mengibar","Mentrida","Mequinensa / Mequinenza","Mercadal","Mestanza","Mezalocha","Miajadas","Mieres","Miguel Esteban","Miguelturra","Mijas","Milagro","Millares","Minas de Riotinto","Ministerio","Mino","Miono","Mira","Mirador","Miraflores de la Sierra","Miramar","Miranda de Arga","Miranda de Ebro","Miranda del Castanar","Mislata","Moana","Mocejon","Mogente","Moguer","Moia","Moja","Mojacar Pueblo","Mojados","Molina de Aragon","Molina de Segura","Molinos de Duero","Molins de Rei","Mollina","Mollo","Mombeltran","Monachil","Moncada","Moncofar","Monda","Mondariz","Mondonedo","Mondujar","Monesterio","Monforte de Lemos","Monforte del Cid","Monistrol de Calders","Monserrat","Mont","Montagut","Montalban de Cordoba","Montcada i Reixac","Monte","Monteagudo","Montealegre del Castillo","Montearagon","Montefrio","Montehermoso","Montejicar","Montellano","Montemayor de Pililla","Monterroso","Monterrubio de la Serena","Montesa","Montesquiu","Montfulla","Montgat","Montijo","Montilla","Montillana","Montmajor","Montroy","Montseny","Monzalbarba","Monzon","Mora","Mora de Rubielos","Moraleja de Enmedio","Moralzarzal","Morata de Jalon","Morata de Tajuna","Moratalla","Moreda","Morella","Moriscos","Morro del Jable","Mortera","Moscas del Paramo","Mosqueruela","Mostoles","Mota del Marques","Motilla del Palancar","Motril","Moya","Muchamiel","Mugardos","Mula","Mungia","Mura","Murcia","Muriedas","Muro","Muro del Alcoy","Muros","Muros de Nalon","Museros","Mutiloa","Mutilva Baja","Mutriku","Nalda","Nambroca","Nanclares de la Oca","Naquera","Nava de la Asuncion","Navacerrada","Navaconcejo","Navahermosa","Navalcan","Navalcarnero","Navalmoral de la Mata","Navalperal de Pinares","Navamorcuende","Navarcles","Navaridas","Navarres","Navarrete","Navas de Riofrio","Navas del Rey","Navata","Navatejera","Navezuelas","Navia","Neda","Negreira","Nembro","Nerja","Nerva","Nestares","Nigran","Nijar","Nino Perdido","Nivar","Noain","Noja","Nora","Norena","Novallas","Novelda","Noves","Nubledo","Nueva","Nuevo Baztan","Nuez de Ebro","Nules","Numancia de la Sagra","O Barco de Valdeorras","O Carballino","O Grove","O Mazo","Oasis (La Marina)","Obanos","Ocana","Odena","Odon","Ogijares","Ojen","Olaberria","Olazagutia","Oleiros","Olesa de Bonesvalls","Olesa de Montserrat","Oliana","Olias del Rey","Olite","Oliva","Oliva de Merida","Oliva de Plasencia","Olivares","Olivella","Olivenza","Olmedo","Olocau","Olot","Olula de Castro","Olula del Rio","Olvega","Olvera","Onda","Ondara","Ondarroa","Onil","Ontigola","Ontinena","Ontinyent","Ontur","Orce","Orcoyen","Ordes","Ordis","Orellana la Vieja","Oria","Orial","Orihuela","Orio","Oroso","Orpesa/Oropesa del Mar","Ortiguero","Oruna","Orusco","Osuna","Otero","Otura","Ouces","Ourense","Outes","Oviedo","Oyon","Oza de los Rios","Padilla del Ducado","Padul","Paiporta","Pajara","Palafolls","Palafrugell","Palau","Palencia","Palma de Mallorca","Palma del Rio","Palmeira","Palmera","Palmones","Palol","Palomares del Rio","Palos de la Frontera","Pals","Pamplona","Panillo","Panticosa","Pantoja","Para","Paracuellos","Paracuellos de Jarama","Parada","Paradas","Paradela","Parbayon","Parcent","Paredes de Nava","Parla","Parres","Pasai San Pedro","Pasaia","Pastrana","Paterna","Paterna del Campo","Pau","Pauels","Pedrajas","Pedrajas de San Esteban","Pedralba","Pedreguer","Pedrezuela","Pedro","Pedro Abad","Pedro Munoz","Pedrola","Pedrosillo de Alba","Pedrosillo el Ralo","Pego","Pelayos de la Presa","Peligros","Penafiel","Penaflor","Penagos","Penarroya-Pueblonuevo","Perafita","Perafort","Peralejo","Perales del Alfambra","Perales del Puerto","Peratallada","Perdiguera","Pereiro de Aguiar","Periedo","Perillo","Pescador","Pescueza","Petrel","Petres","Pezuela de las Torres","Piedra","Piedrabuena","Piera","Pilar de la Horadada","Pilas","Pina de Ebro","Pinar","Pineda de Mar","Pinos del Valle","Pinos Puente","Pinoso","Pinseque","Pinto","Pioz","Placencia","Plan","Planes","Plasencia","Plasenzuela","Playa","Playa Blanca","Plegamans","Plentzia","Poblete","Poboa de San Xulian","Poboleda","Pola de Laviana","Pola de Lena","Pola de Siero","Polan","Polinya","Polop","Pomar","Pomar de Cinca","Ponferrada","Pont de Molins","Pontejos","Pontevedra","Pontos","Ponts","Poris de Abona","Porrino","Port de Sagunt","Portillo","Portillo de Toledo","Porto","Porto Cristo","Portocolom","Portonovo","Portugalete","Portus","Posadas","Pozo de Guadalajara","Pozo de la Serna","Pozoamargo","Pozoblanco","Pozuelo del Rey","Pradejon","Prado del Rey","Pravia","Premia de Mar","Priego","Priego de Cordoba","Pruna","Pruvia","Pucol","Puebla de Alfinden","Puebla de Don Fadrique","Puebla de la Calzada","Puebla del Maestre","Puente Viesgo","Puente-Genil","Puentelarra","Puentenansa","Puerto","Puerto de Gandia","Puerto de la Cruz","Puerto del Carmen","Puerto del Rosario","Puerto Lumbreras","Puerto Real","Puertollano","Pueyo","Pueyo de Santa Cruz","Puig","Puigpelat","Pulgar","Pulianas","Purchil","Quart de Poblet","Quel","Quer","Querol","Quijorna","Quincoces de Yuso","Quintana de la Serena","Quintana de Raneros","Quintanar de la Orden","Quintanar del Rey","Quintes","Rafal","Rafelbunyol","Rafelcofer","Rafelguaraf","Rairiz de Veiga","Rajadell","Ramales de la Victoria","Rasines","Real","Real de Gandia","Rebolledo","Rebordanes","Recas","Redes","Redondela","Redovan","Reinosa","Rendar","Renedo","Reocin","Requena","Reus","Revellinos","Reyes","Rianxo","Riaza","Riba","Ribadavia","Ribadeo","Ribadesella","Ribarroja","Ribeira","Ribera del Fresno","Ribes de Freser","Ricla","Riells i Viabrea","Rielves","Rincon","Rincon de la Victoria","Rincon de Soto","Rioja","Riola","Rios","Ripoll","Ripollet","Riudellots de la Selva","Riudoms","Riumors","Rivabellosa","Roales","Robleda-Cervantes","Robledillo de Gata","Robledillo de la Vera","Robledo de Chavela","Rocafort","Roda de Bara","Rodonya","Rojales","Roldan","Ron","Ronda","Roquetas de Mar","Rosell","Roses","Rota","Rubielos de Mora","Ruente","Rupit","Rus","Rute","Saamasas","Sabadell","Sabero","Sabinanigo","Sabiote","Sabucedo","Sada","Sagra","Sagunto","Salamanca","Salas de los Infantes","Salceda","Salcedo","Saldana","Salinas","Sallent","Salobral","Salobre","Salou","Salt","Salteras","Salvatierra","Salvatierra de los Barros","Salvatierra de Mino","San Adrian","San Agustin de Guadalix","San Andres del Rabanedo","San Anton","San Antonio","San Blas","San Clemente","San Cristobal","San Cristobal de Entrevinas","San Esteban del Valle","San Felices","San Feliz de Torio","San Fernando","San Fernando de Henares","San Ildefonso","San Isidro","San Javier","San Jorge","San Juan","San Juan de Alicante","San Juan de Aznalfarache","San Juan de Moro","San Juan del Puerto","San Julian de Muskiz","San Luis de Sabinillas","San Martin","San Martin de la Vega","San Martin de Unx","San Martin de Valdeiglesias","San Martino","San Miguel","San Miguel de las Duenas","San Nicolas","San Nicolas del Puerto","San Pedro","San Pedro del Pinatar","San Rafael","San Roman","San Roque","San Sebastian","San Sebastian de los Ballesteros","San Vicent del Raspeig","San Vicente","San Vicente de Alcantara","San Vicente de Leon","Sancibrian","Sancti Spiritus","Sangonera la Verde","Sanlucar la Mayor","Sant Andreu de la Barca","Sant Andreu de Llavaneres","Sant Bartomeu del Grau","Sant Carles de la Rapita","Sant Feliu de Llobregat","Sant Joan de les Abadesses","Sant Joan de Vilatorrada","Sant Joan les Fonts","Sant Jordi","Sant Josep de sa Talaia","Sant Just Desvern","Sant Marti de Malda","Sant Pere de Ribes","Sant Pere de Riudebitlles","Sant Pere, Santa Caterina i La Ribera","Sant Vicenc de Castellet","Santa Barbara","Santa Brigida","Santa Coloma de Farners","Santa Coloma de Gramenet","Santa Coloma de Queralt","Santa Cristina","Santa Cristina de Aro","Santa Cruz","Santa Cruz de Bezana","Santa Cruz de La Palma","Santa Cruz de la Zarza","Santa Cruz de Mudela","Santa Cruz de Tenerife","Santa Eulalia","Santa Eulalia Bajera","Santa Fe","Santa Fe de Mondujar","Santa Lucia","Santa Margarida","Santa Maria","Santa Maria de Palautordera","Santa Maria del Cami","Santa Maria del Campo","Santa Maria del Paramo","Santa Marina del Rey","Santa Marta de Ortigueira","Santa Marta de Tormes","Santa Olalla","Santa Oliva","Santa Pau","Santa Perpetua de Mogoda","Santa Pola","Santa Uxia de Ribeira","Santalla","Santander","Santiago","Santiago de Cartes","Santiago de Compostela","Santiago de la Ribera","Santiago Pena","Santiponce","Santisteban del Puerto","Santiurde de Toranzo","Santo Angel","Santo Domingo","Santo Domingo de la Calzada","Santomera","Santona","Santovenia de Pisuerga","Santpedor","Santurtzi","Sarandones","Sardina","Sarinena","Saron","Sarria","Sarria de Ter","Sarroca de Lleida","Sax","Sayalonga","Sedavi","Segorbe","Segovia","Segura","Segura de la Sierra","Selaya","Selva","Senija","Seoane","Sepulveda","Serena","Serra","Serracines","Serranillos del Valle","Serrateix","ses Salines","Sesena","Sesena Nuevo","Sestao","Seva","Sevares","Sevilla La Nueva","Seville","Sierra","Sierra de Fuentes","Sierra de Luna","Siete Iglesias de Trabancos","Sigueiro","Siguenza","Silla","Silleda","Sils","Simancas","Sitges","Sixto","Sobarzo","Sobradiel","Sobremazas","Socuellamos","Sodupe","Sojuela","Solares","Sollana","Soller","Solsona","Somahoz","Somo","Son Curt","Son Servera","Soneja","Sopela","Sorbas","Soria","Sotillo de la Adrada","Soto","Soto de Cerrato","Soto de la Marina","Sotogrande","Sotopalacios","Sotrondio","Suances","Subirats","Sudanell","Sueca","Sufli","Tabernas","Taboada","Tacoronte","Tafalla","Tahiche","Talamanca de Jarama","Talarn","Talavera de la Reina","Tamames","Tamaraceite","Taradell","Tarancon","Tarazona","Tarazona de la Mancha","Tarifa","Tarragona","Tarrega","Teba","Tegueste","Teguise","Tejina","Telde","Tenteniguada","Teo","Termino","Teror","Terradillos","Terrassa","Terrer","Teruel","Teulada","Tiagua","Tiana","Tias","Tigaiga","Tijarafe","Tijola","Tineo","Titulcia","Tobarra","Toledo","Tolosa","Tomares","Tombrio de Arriba","Tomelloso","Tomino","Tona","Tora de Riubregos","Toral de los Vados","Tordera","Tordesillas","Tordillos","Toreno","Torija","Tormantos","Toro","Torralba de Calatrava","Torralba de Oropesa","Torre del Campo","Torre del Mar","Torre-Pacheco","Torreaguera","Torreblascopedro","Torrecaballeros","Torrecilla de Alcaniz","Torredembarra","Torredonjimeno","Torrefarrera","Torrefeta","Torrejon de la Calzada","Torrejon del Rey","Torrelaguna","Torrelavega","Torrelles de Llobregat","Torrelletas","Torrelodones","Torremenga","Torremocha del Campo","Torremolinos","Torrent","Torrenueva","Torreperogil","Torres","Torres de Berrellen","Torres de la Alameda","Torres de Segre","Torresandino","Torrevieja","Torrijos","Torroella de Fluvia","Torroella de Montgri","Torrox","Tortella","Tortola de Henares","Tortosa","Totana","Touro","Tous","Trabada","Traiguera","Traslavina","Trasona","Trazo","Trebujena","Tremp","Trespaderne","Trevino","Triana","Trillo","Trives","Trobajo del Camino","Trujillanos","Trujillo","Tudela","Tudela de Duero","Tuineje","Turia","Turis","Ubrique","Uceda","Ugena","Ugijar","Ujo","Ullastrell","Umbrete","Urda","Urdiain","Urduna","Urnieta","Urroz","Urtuella","Usansolo","Useras","Usurbil","Utebo","Utiel","Utrera","Vaciamadrid","Val de Santo Domingo","Valcabado","Valdeavero","Valdeaveruelo","Valdecabras","Valdecilla","Valdemaqueda","Valdemorillo","Valdemoro","Valdepenas","Valdepenas de la Sierra","Valdepolo","Valderrey","Valderrobres","Valderrubio","Valdesogo de Abajo","Valdetorres","Valdetorres de Jarama","Valdezufre","Valdilecha","Valencia","Valencia de Don Juan","Valencina de la Concepcion","Vall de Almonacid","Vallada","Valladolid","Valladolises","Valldoreix","Valle","Valle de Oro","Valles","Valleseco","Vallgorguina","Vallirana","Vallmoll","Valls","Valmojado","Valpalmas","Valsequillo de Gran Canaria","Valverde","Valverde del Camino","Valverde del Fresno","Valverde del Majano","Vedra","Vejer de la Frontera","Velez de Benaudalla","Velez-Rubio","Velilla","Velilla de San Antonio","Venta","Venta de Banos","Ventallo","Venturada","Vera","Verdu","Vergel","Verges","Verin","Viana","Viator","Vic","Vicar","Vicolozano","Vigo","Vila","Vila-real","Vila-seca","Vilabertran","Vilacolum","Viladecans","Viladrau","Vilafant","Vilagarcia de Arousa","Vilajuiga","Vilamalla","Vilamaniscle","Vilanova","Vilanova de Arousa","Vilaplana","Vilasantar","Vilassar de Mar","Vilatenim","Vilavella","Vilches","Villa","Villa de Don Fadrique","Villa del Prado","Villa del Rio","Villabalter","Villabanez","Villablino","Villabona","Villacanas","Villacarriedo","Villacarrillo","Villacastin","Villacondide","Villaconejos","Villacuende","Villafranca","Villafranca de Cordoba","Villafranca de los Barros","Villafranca de los Caballeros","Villafranca del Campo","Villafranqueza","Villahermosa","Villajoyosa","Villalar de los Comuneros","Villalba de los Alcores","Villalbilla","Villalonga","Villalpardo","Villaluenga","Villamalea","Villamanrique","Villamanrique de la Condesa","Villamanta","Villamartin","Villamayor","Villamayor de Santiago","Villamediana de Iregua","Villamiel de Toledo","Villamuriel de Cerrato","Villanubla","Villanueva","Villanueva de Azoague","Villanueva de Castellon","Villanueva de Cordoba","Villanueva de Gallego","Villanueva de Gomez","Villanueva de la Canada","Villanueva de la Jara","Villanueva de la Reina","Villanueva de la Serena","Villanueva de la Torre","Villanueva de Perales","Villanueva de Villaescusa","Villanueva del Ariscal","Villanueva del Arzobispo","Villanueva del Fresno","Villanueva del Pardillo","Villanueva del Rio","Villanueva del Rosario","Villaquilambre","Villar","Villar de Gallimazo","Villar de Olalla","Villar del Arzobispo","Villaralbo","Villarcayo","Villarejo","Villares de la Reina","Villares del Saz","Villaricos","Villarluengo","Villarquemado","Villarreal de Alava","Villarrobledo","Villarrubia","Villarrubia de los Ojos","Villarrubia de Santiago","Villarta de San Juan","Villasana de Mena","Villaseca de la Sagra","Villasequilla de Yepes","Villasevil","Villatuerta","Villaverde de los Cestos","Villaverde del Rio","Villaviad","Villaviciosa","Villaviciosa de Odon","Villena","Vinaixa","Vinales","Vinalesa","Vinaros","Vitigudino","Vitoria-Gasteiz","Viveda","Viveiro","Vivero","Xunqueira de Espadanedo","Yaiza","Yebes","Yecla","Yeles","Yepes","Yuncler","Yuncos","Yunquera de Henares","Zafra","Zahara de los Atunes","Zahinos","Zalamea la Real","Zamora","Zamudio","Zaragoza","Zaramillo","Zaratamo","Zaratan","Zarautz","Zarzalejo","Zarzuela","Ziga","Zorraquin","Zuazo de Vitoria","Zubia","Zubiri","Zuera","Zumaia","Zumarraga"]},"ET":{"id":"ET","name":"Ethiopia","timezones":["Africa/Nairobi"],"cities":[]},"FI":{"id":"FI","name":"Finland","timezones":["Europe/Helsinki"],"cities":["Aapajoki","Aavasaksa","Aitoo","Akaa","Alastaro","Alaveteli","Alavieska","Alavus","Alvettula","Angelniemi","Anjala","Anttila","Askola","Aura","Bergoe","Box","Broby","Degerby","Eno","Erajarvi","Espoo","Eura","Eurajoki","Evijaervi","Evitskog","Fiskars","Forsby","Forssa","Gammelby","Haapavesi","Haeme","Haermae","Haijaa","Halikko","Halkia","Halli","Halsua","Hamina","Hammaslahti","Hanko","Harjavalta","Harviala","Hattula","Hauho","Haukipudas","Haukkala","Hausjaervi","Heimari","Heinola","Helsingby","Helsinki","Hervanta","Hiltulanlahti","Himanka","Hinthaara","Hirvensalmi","Hirvihaara","Hoegsara","Hoeytiae","Hollola","Huittinen","Humppila","Huuvari","Hyvinkaeae","Ihode","Ii","Iisalmi","Iittala","Ilkka","Ilmajoki","Ilmarinen","Ilveskylae","Imatra","Inkeroinen","Isojoki","Itaekylae","Ivalo","Jaervelae","Jakobstad","Janakkala","Joensuu","Jokela","Jokikunta","Jokimaa","Jokioinen","Jormua","Joroinen","Jorvas","Joutseno","Jurva","Juuka","Juupajoki","Jyskae","Kaakamo","Kaarina","Kaemmenniemi","Kaerrby","Kaipiainen","Kaipola","Kaivanto","Kajaani","Kalajoki","Kalanti","Kangasala","Kangasniemi","Kankaanpaeae","Kannonkoski","Kannus","Kantomaanpaeae","Kantti","Kantvik","Karhula","Karinkanta","Karjaa","Karjalohja","Karkkila","Karkku","Karstula","Karttula","Karunki","Karvia","Kaskinen","Kauhajoki","Kauhakorpi","Kauhava","Kauniainen","Kausala","Kaustinen","Kauttua","Kauvatsa","Kello","Kellokoski","Kemi","Keminmaa","Kempele","Kerava","Kerkkoo","Keuruu","Kihnioe","Kiiminki","Kiistala","Kiljava","Kimito","Kinnula","Kirjala","Kirkkonummi","Kisko","Kitee","Kiuruvesi","Kivijaervi","Klaukkala","Kokkola","Kolari","Kolinkylae","Koljonvirta","Kontiolahti","Kontiomaeki","Kopsa","Koria","Kormu","Korplax","Korppoo","Korsholm","Koskenkorva","Koskioinen","Kotka","Kouvola","Kronoby","Kruusila","Kuhmalahti","Kuhmo","Kuivakangas","Kuivaniemi","Kulho","Kuni","Kuohu","Kuopio","Kuortane","Kurikka","Kuusamo","Kuusankoski","Kuusisto","Kvevlax","Kylmaekoski","Kyroeskoski","Kyynaeroe","Laeyliaeinen","Lahela","Lahti","Laihia","Laikko","Laitikkala","Laitila","Lammi","Lampinsaari","Lapinlahti","Lappajaervi","Lappeenranta","Lapua","Larsmo","Latovainio","Laukaa","Laukkoski","Launonen","Lautiosaari","Lehmo","Lehtimaeki","Lemi","Lepaa","Lepplax","Levanto","Lieksa","Lielax","Lieto","Lievestuore","Liljendal","Liminka","Linna","Linnavuori","Liperi","Littoinen","Lohja","Lohtaja","Loimaa","Loppi","Louhi","Loviisa","Lumijoki","Luohua","Luoma-aho","Maenttae","Maentyharju","Majvik","Mankila","Mantila","Martensby","Marttila","Masala","Masku","Mattila","Mehtaekylae","Merimasku","Metsaekansa","Mieto","Mikkeli","Mouhijaervi","Muhos","Multia","Munsala","Muonio","Muurame","Muurla","Myllykoski","Mynaemaeki","Naantali","Naervijoki","Nahkela","Nakkila","Narva","Nastola","Neuvoton","Niinijoki","Niittylahti","Nivala","Nokia","Noormarkku","Nousiainen","Nukari","Nummela","Nummenkylae","Nummi","Nunnanlahti","Nuppulinna","Nurmes","Nurmo","Nuutajaervi","Nykarleby","OEvermalax","Oitti","Oja","Okskoski","Orimattila","Orivesi","Otalampi","Oulainen","Oulu","Oulunsalo","Outokumpu","Paalijaervi","Paattinen","Padasjoki","Paelkaene","Paimio","Paippinen","Palojoki","Palokka","Pankakoski","Pargas","Parkano","Parkkuu","Pattijoki","Peipohja","Pellinki","Pello","Peraelae","Peraseinajoki","Pernioe","Pertteli","Perttula","Pihtipudas","Piispanristi","Pilkanmaa","Pirkkala","Pjelax","Pockar","Poeytyae","Pohjola","Poikelus","Poitsila","Pori","Porlammi","Pornainen","Porvoo","Pukkila","Punkaharju","Punkalaidun","Puolanka","Purmo","Purola","Pusula","Puumala","Pyhaejoki","Pyhaentae","Pyhamaa","Raahe","Raisio","Rantasalmi","Raseborg","Rauma","Rautalampi","Rautjaervi","Ravijoki","Revonlahti","Riihikoski","Riistavesi","Ristiina","Roeykkae","Roismala","Rovaniemi","Ruokolahti","Ruovesi","Rusko","Ruto","Ruutana","Ryttylae","Saaksmaki","Saarijaervi","Saekylae","Saeviae","Sahalahti","Sajaniemi","Salo","Saloinen","Salomaa","Sammaljoki","Sappee","Saukkola","Saunalahti","Sauvo","Savitaipale","Savonlinna","Saynatsalo","Seinaejoki","Sievi","Siikainen","Siivikkala","Simoniemi","Simpele","Sipoo","Siuntio","Siuro","Skinnarby","Skuru","Soederkulla","Soeoermarkku","Solberg","Somerniemi","Somero","Sotkamo","Sotkuma","Suhmura","Sundby","Sundom","Suolahti","Suomusjaervi","Suomussalmi","Suonenjoki","Svarta","Sykaeraeinen","Taavetti","Taipalsaari","Tammela","Tampella","Tampere","Tarttila","Tarvasjoki","Tenala","Terjaerv","Tervajoki","Tervakoski","Tervalampi","Teuva","Tikkakoski","Toelby","Toholampi","Toijala","Toivala","Tolkis","Tornio","Tortinmaeki","Tottijarvi","Tuomikylae","Turenki","Turku","Tuulos","Tuuri","Tuusula","Tyrnaevae","Uimaharju","Ulvila","Utsjoki","Utti","Uurainen","Uusikaupunki","Vaajakoski","Vaasa","Vaeaeksy","Vaesterskog","Vahto","Vakkola","Valkama","Valkeakoski","Valkeala","Valkola","Vammala","Vanhalinna","Vantaa","Varkaus","Vasarainen","Vaskio","Vaulammi","Vehniae","Veikkola","Venetheitto","Vesanka","Veteli","Viantie","Vihtavuori","Vihti","Viiala","Viitasaari","Viljakkala","Vilppula","Vimpeli","Virrat","Vuokatti","Ylaemylly","Ylihaermae","Ylitornio","Ylivieska","Ypaejae"]},"FJ":{"id":"FJ","name":"Fiji","timezones":["Pacific/Fiji"],"cities":[]},"FK":{"id":"FK","name":"Falkland Islands","timezones":["Atlantic/Stanley"],"cities":[]},"FM":{"id":"FM","name":"Micronesia","timezones":["Pacific/Chuuk","Pacific/Pohnpei","Pacific/Kosrae"],"cities":[]},"FO":{"id":"FO","name":"Faroe Islands","timezones":["Atlantic/Faroe"],"cities":["Argir","Glyvrar","Hvalba","Innan Glyvur","Leirvik","Saltangara","Signabour","Strendur"]},"FR":{"id":"FR","name":"France","timezones":["Europe/Paris"],"cities":["Aast","Abancourt","Abbans-Dessus","Abbaretz","Abbecourt","Abbeville","Abbeville-les-Conflans","Abeilhan","Abere","Abergement-Saint-Jean","Abilly","Ablain-Saint-Nazaire","Ablaincourt-Pressoir","Ablainzevelle","Ablis","Ablon-sur-Seine","Abondance","Abondant","Abreschviller","Abrest","Abscon","Abzac","Achatel","Achenheim","Acheres","Acheville","Achicourt","Achiet-le-Grand","Achiet-le-Petit","Acigne","Acq","Acquigny","Acy-en-Multien","Adam-les-Vercel","Adamswiller","Adelans-et-le-Val-de-Bithaine","Adissan","Adriers","Afa","Agay","Agde","Agen","Agneaux","Agnetz","Agnin","Agnos","Agny","Aguilcourt","Ahaxe-Alciette-Bascassan","Ahuille","Ahun","Ahuy","Aiffres","Aigaliers","Aiglemont","Aignan","Aigne","Aigny","Aigonnay","Aigre","Aigrefeuille","Aigrefeuille-sur-Maine","Aigremont","Aiguebelette-le-Lac","Aiguebelle","Aigueblanche","Aiguefonde","Aigueperse","Aigues-Mortes","Aigues-Vives","Aiguillon","Ailette","Aillas","Aillevillers-et-Lyaumont","Aillon-le-Vieux","Ailly-le-Haut-Clocher","Ailly-sur-Noye","Ailly-sur-Somme","Aimargues","Aime","Ainay-le-Chateau","Aincourt","Ainhoa","Airaines","Aire-sur-la-Lys","Airel","Airvault","Aiserey","Aissey","Aiton","Aix-en-Ergny","Aix-en-Issart","Aix-en-Othe","Aix-en-Provence","Aix-les-Bains","Aix-Noulette","Aixe-sur-Vienne","Aizenay","Ajaccio","Alairac","Alata","Alban","Albas","Albefeuille-Lagarde","Albens","Albert","Albertville","Albi","Albias","Albigny-sur-Saone","Albiosc","Alboussiere","Albussac","Alby-sur-Cheran","Alenya","Alfortville","Algolsheim","Algrange","Alignan-du-Vent","Alissas","Alix","Alixan","Alizay","Allain","Allaire","Allan","Allassac","Allauch","Allegre","Alleins","Allemans-du-Dropt","Allennes-les-Marais","Alleriot","Allery","Allevard","Alliancelles","Allier","Allieres","Allinges","Allogny","Allondrelle-la-Malmaison","Allonne","Allonnes","Allonville","Allonzier-la-Caille","Allos","Allouagne","Alloue","Allouis","Allouville-Bellefosse","Alluy","Alluyes","Ally","Alos-Sibas-Abense","Alteckendorf","Altkirch","Altorf","Altviller","Alvimare","Alzonne","Amagney","Amailloux","Amancey","Amancy","Amange","Amanlis","Amanvillers","Amathay-Vesigneux","Amaye-sur-Orne","Ambazac","Amberac","Amberieux","Amberieux-en-Dombes","Ambert","Ambes","Ambierle","Ambleny","Ambleteuse","Amboise","Ambon","Ambonnay","Ambres","Ambrieres","Ambronay","Ambrus","Ambutrix","Amelecourt","Amelie-les-Bains-Palalda","Amen","Ames","Amfreville","Amfreville-la-Mi-Voie","Amfreville-sous-les-Monts","Amiens","Amigny","Amigny-Rouy","Amillis","Amilly","Ammerschwihr","Ammerzwiller","Amneville","Amou","Amplepuis","Amponville","Ampuis","Ampus","Amure","Anais","Ance","Anceaumeville","Ancemont","Ancenis","Ancerville","Anche","Anchenoncourt-et-Chazel","Ancinnes","Ancizan","Ancone","Ancy","Ancy-le-Franc","Ancy-sur-Moselle","Andance","Andancette","Andard","Ande","Andechy","Andel","Andelot-Morval","Andernos-les-Bains","Andeville","Andigne","Andilly","Andoins","Andolsheim","Andon","Andonville","Andouille","Andouille-Neuville","Andres","Andrest","Andresy","Andreze","Andrezieux-Boutheon","Anduze","Anet","Anetz","Ange","Angeac-Champagne","Angeac-Charente","Angely","Angers","Angerville-la-Martel","Angervilliers","Angevillers","Angicourt","Angiens","Anglade","Anglefort","Angles","Anglet","Angliers","Anglure","Angoulins","Angoume","Angoville-sur-Ay","Angres","Anguerny","Angy","Anhaux","Anhiers","Aniane","Aniche","Anizy-le-Chateau","Anjou","Anjoutey","Anlhiac","Annay","Annay-sur-Serein","Annebault","Annecy","Annecy-le-Vieux","Annemasse","Annepont","Annequin","Annesse-et-Beaulieu","Annet-sur-Marne","Anneville-Ambourville","Anneyron","Annezay","Annezin","Annoeullin","Annois","Annonay","Annot","Annouville-Vilmesnil","Anor","Anould","Ansac-sur-Vienne","Ansauvillers","Anse","Ansouis","Antagnac","Anteuil","Anthe","Antheuil-Portes","Anthon","Anthy-sur-Leman","Antibes","Antignac","Antigny","Antilly","Antogny le Tillac","Antony","Antrain","Anzat-le-Luguet","Anzin","Anzin-Saint-Aubin","Anzy-le-Duc","Aoste","Aougny","Aouste-sur-Sye","Apach","Apcher","Appenwihr","Appeville","Appeville-Annebault","Appietto","Appoigny","Apprieu","Apremont","Apt","Araches-la-Frasse","Aragon","Aramits","Aramon","Arancou","Arbent","Arberats-Sillegue","Arbin","Arbois","Arbonne","Arboucave","Arbus","Arbusigny","Arc-et-Senans","Arc-sur-Tille","Arcachon","Arcay","Arcens","Arces","Archamps","Arche","Arches","Archettes","Archiac","Archingeay","Arcine","Arcis-sur-Aube","Arcon","Arcueil","Arcy-Sainte-Restitue","Ardenay-sur-Merize","Ardentes","Ardes","Ardiege","Ardillieres","Ardoix","Ardon","Ardres","Areines","Arengosse","Arenthon","Ares","Aressy","Arette","Argancy","Argelers","Argeles-Gazost","Argeliers","Argelliers","Argences","Argens","Argent-sur-Sauldre","Argentan","Argentat","Argenteuil","Argentiere","Argentine","Argenton-les-Vallees","Argenton-sur-Creuse","Argentre","Argentre-du-Plessis","Argeville","Argol","Argueil","Arinthod","Arlanc","Arlay","Arlebosc","Arles","Arleux","Arleux-en-Gohelle","Armaucourt","Armbouts-Cappel","Armenonville-les-Gatineaux","Armes","Armoy","Arnac-Pompadour","Arnage","Arnas","Arnay-le-Duc","Arnieres-sur-Iton","Arnouville","Arnouville-les-Mantes","Aron","Arpaillargues-et-Aureillac","Arpajon","Arpajon-sur-Cere","Arpenans","Arpheuilles-Saint-Priest","Arques","Arques-la-Bataille","Arquettes-en-Val","Arrabloy","Arradon","Arras","Arraute-Charritte","Arreau","Arrenes","Arrigas","Arrigny","Arrou","Ars","Ars-en-Re","Ars-Laquenexy","Ars-sur-Formans","Ars-sur-Moselle","Arsac","Arsac-en-Velay","Arsague","Artannes-sur-Indre","Artas","Artenay","Arthaz-Pont-Notre-Dame","Arthes","Arthez-de-Bearn","Arthon","Arthon-en-Retz","Artigat","Artigueloutan","Artiguelouve","Artigues","Artigues-pres-Bordeaux","Artix","Artolsheim","Arudy","Arvert","Arveyres","Arvillard","Arville","Arvillers","Arx","Arzacq-Arraziguet","Arzal","Arzano","Arzon","Asasp-Arros","Ascain","Ascheres-le-Marche","Ascoux","Ascq","Aslonnes","Asnans-Beauvoisin","Asnieres","Asnieres-sur-Oise","Asnieres-sur-Seine","Aspach-le-Bas","Aspach-le-Haut","Asperes","Aspet","Aspremont","Asque","Assas","Assat","Assay","Assevent","Assier","Assignan","Asson","Astaffort","Astille","Astis","Athee","Athesans-Etroitefontaine","Athies","Athies-sous-Laon","Athis-Mons","Attenschwiller","Attiches","Attichy","Attignat-Oncin","Attigny","Atton","Atur","Aubagne","Aubais","Aubas","Aubenas","Auberchicourt","Aubergenville","Auberives-sur-Vareze","Aubers","Auberville-la-Campagne","Auberville-la-Renault","Aubervilliers","Aubevoye","Aubiac","Aubie-et-Espessas","Aubiere","Aubiet","Aubignan","Aubigne","Aubigne-Racan","Aubigney","Aubigny","Aubigny-au-Bac","Aubigny-en-Artois","Aubigny-en-Laonnois","Aubigny-en-Plaine","Aubin","Aubin-Saint-Vaast","Aubinges","Aubord","Auboue","Aubrac","Aubrives","Aubry-du-Hainaut","Aubusson","Auby","Aucamville","Auch","Auchel","Auchy-les-Hesdin","Auchy-les-Mines","Auchy-lez-Orchies","Audelange","Audenge","Audes","Audierne","Audignies","Audincourt","Audincthun","Audruicq","Audun-le-Roman","Audun-le-Tiche","Auffargis","Auffay","Auffreville-Brasseuil","Auga","Augignac","Augny","Aulhat-Saint-Privat","Aulnat","Aulnay","Aulnay-sous-Bois","Aulnay-sur-Marne","Aulnay-sur-Mauldre","Aulnoye-Aymeries","Ault","Aumagne","Aumale","Aumenancourt","Aumetz","Aumont","Aumont-Aubrac","Aumont-en-Halatte","Aumontzey","Aumur","Aunay-les-Bois","Aunay-sous-Auneau","Aunay-sur-Odon","Auneau","Auneuil","Aups","Auray","Aurec-sur-Loire","Aureil","Aureilhan","Auriac","Auriac-sur-Vendinelle","Auribeau-sur-Siagne","Aurignac","Aurillac","Auriol","Aurons","Aussevielle","Aussillon","Aussonce","Aussonne","Autechaux","Auterive","Auteuil","Autevielle-Saint-Martin-Bideren","Authevernes","Authie","Authon","Authou","Authouillet","Autoreille","Autrans","Autreche","Autremencourt","Autreville","Autry-le-Chatel","Autun","Auvergny","Auvers","Auvers-Saint-Georges","Auvers-sur-Oise","Auvillar","Auvillars","Auvillers-les-Forges","Auvilliers-en-Gatinais","Auxais","Auxances","Auxange","Auxerre","Auxey-Duresses","Auxi-le-Chateau","Auxon","Auxon-Dessous","Auxon-Dessus","Auxonne","Auxy","Auzances","Auzeville-Tolosane","Auzielle","Auzon","Auzouer-en-Touraine","Availles-Limouzine","Avallon","Avancon","Avanne-Aveney","Avanton","Avaray","Aveize","Aveizieux","Avelin","Aveluy","Avenay","Avensan","Aventignan","Averdoingt","Averdon","Averton","Avesnelles","Avesnes-en-Bray","Avesnes-le-Comte","Avesnes-le-Sec","Avesnes-les-Aubert","Avesnes-sur-Helpe","Aveze","Aviernoz","Avignon","Avignonet-Lauragais","Avion","Aviron","Avize","Avoine","Avon","Avon-la-Peze","Avord","Avot","Avrainville","Avranches","Avremesnil","Avressieux","Avril","Avrille","Ax-les-Thermes","Aydat","Ayencourt","Ayette","Ayguemorte-les-Graves","Ayguesvives","Aymeries","Aynac","Ayrens","Ayse","Aytre","Azas","Azay-le-Brule","Azay-le-Rideau","Azay-sur-Cher","Azay-sur-Indre","Aze","Azerables","Azerailles","Azet","Azille","Azur","Azy-sur-Marne","Babeau-Bouldoux","Baccarat","Bach","Bachant","Bachy","Bacilly","Baconnes","Bacqueville","Bacqueville-en-Caux","Baden","Badevel","Bagard","Bagas","Bage-la-Ville","Bages","Bagnac-sur-Cele","Bagneaux","Bagneaux-sur-Loing","Bagneux","Bagnolet","Bagnols","Bagnols-en-Foret","Bagnols-sur-Ceze","Baguer-Morvan","Baguer-Pican","Baho","Baignes-Sainte-Radegonde","Baigneux-les-Juifs","Baillargues","Bailleau-le-Pin","Baillet-en-France","Bailleul","Bailleul-le-Soc","Bailleul-Sir-Berthoult","Bailleul-sur-Therain","Bailly","Bailly-Carrois","Bailly-le-Franc","Bailly-Romainvilliers","Bain-de-Bretagne","Bains","Bains-les-Bains","Bains-sur-Oust","Bainville-sur-Madon","Baisieux","Baixas","Bajus","Balagny-sur-Therain","Balan","Balanod","Balaruc-le-Vieux","Balaruc-les-Bains","Balaze","Balbigny","Baldenheim","Baldersheim","Balgau","Ballainvilliers","Ballaison","Ballan-Mire","Ballancourt-sur-Essonne","Balleroy","Ballon","Balma","Balschwiller","Balzac","Ban-de-Laveline","Banassac","Bandol AOC","Bangor","Banize","Bannalec","Banne","Bannes","Bannieres","Banon","Bantigny","Bantzenheim","Banville","Banvou","Banyuls de la Marenda","Banyuls-dels-Aspres","Bapaume","Bar-le-Duc","Bar-sur-Aube","Bar-sur-Seine","Baraqueville","Barastre","Barbaira","Barbaste","Barbatre","Barbazan-Debat","Barbechat","Barbentane","Barberaz","Barbery","Barbeville","Barbezieux-Saint-Hilaire","Barbieres","Barbizon","Barby","Barc","Barcelonnette","Bardos","Barembach","Barentin","Barenton-Bugny","Barfleur","Barges","Barinque","Barisey-au-Plain","Barisey-la-Cote","Barjac","Barjols","Barjon","Barjouville","Barlin","Barneville-Carteret","Baron","Baronville","Barr","Barraux","Barreme","Barro","Barrou","Bartenheim","Barzy-en-Thierache","Bas-en-Basset","Bascons","Bassan","Basse-Goulaine","Basse-Ham","Basse-Rentgen","Basse-sur-le-Rupt","Bassemberg","Bassens","Bassigney","Bassillac","Bassoles-Aulers","Bassou","Bassu","Bassussarry","Bastennes","Bastia","Batilly","Batilly-en-Gatinais","Battenheim","Battrans","Batz-sur-Mer","Batzendorf","Baud","Baudemont","Baudreix","Baulay","Baule","Baulne","Baulon","Baume-les-Dames","Baume-les-Messieurs","Baune","Baupte","Baurech","Bauvin","Bavans","Bavay","Bavent","Bavilliers","Bavincourt","Baye","Bayet","Bayeux","Bayon","Bayonne","Bazailles","Bazancourt","Bazarnes","Bazas","Bazeilles","Bazemont","Bazens","Bazet","Bazian","Bazicourt","Baziege","Bazien","Bazincourt-sur-Epte","Bazoches","Bazoches-les-Gallerandes","Bazoches-sur-Guyonne","Bazoches-sur-Hoene","Bazoches-sur-le-Betz","Bazoges-en-Paillers","Bazoilles-sur-Meuse","Bazoncourt","Bazouges-la-Perouse","Bazouges-sous-Hede","Bazouges-sur-le-Loir","Bazuel","Beaucaire","Beaucamps-le-Vieux","Beaucamps-Ligny","Beauce","Beauchamp","Beauchamps","Beauchamps-sur-Huillard","Beauchastel","Beauchene","Beaucourt","Beaucouze","Beaucroissant","Beaudricourt","Beaufort","Beaufort-en-Vallee","Beaufou","Beaugency","Beaujeu","Beaulieu-sous-Parthenay","Beaulieu-sur-Dordogne","Beaulieu-sur-Loire","Beaulieu-sur-Mer","Beaumetz-les-Loges","Beaumont","Beaumont-de-Lomagne","Beaumont-de-Pertuis","Beaumont-du-Gatinais","Beaumont-du-Perigord","Beaumont-en-Veron","Beaumont-Hague","Beaumont-le-Roger","Beaumont-les-Autels","Beaumont-les-Nonains","Beaumont-les-Valence","Beaumont-Pied-de-Boeuf","Beaumont-sur-Oise","Beaumont-sur-Sarthe","Beaune","Beaune-la-Rolande","Beaupont","Beaupreau","Beaupuy","Beauquesne","Beaurains","Beaurainville","Beauregard-Baret","Beauregard-Vendon","Beaurepaire","Beaurevoir","Beaurieux","Beausemblant","Beausoleil","Beaussault","Beautheil","Beautiran","Beautor","Beautot","Beauvais","Beauvais-sur-Matha","Beauval","Beauvallon","Beauvene","Beauvernois","Beauvezer","Beauville","Beauvoir","Beauvoir-de-Marc","Beauvoir-sur-Mer","Beauvoir-sur-Niort","Beauvoisin","Beauzac","Beauzelle","Bechy","Becon-les-Granits","Bedarrides","Bedee","Bedous","Beganne","Begard","Begles","Beguey","Behren-les-Forbach","Beignon","Beine-Nauroy","Beinheim","Beire-le-Chatel","Bel Air","Belarga","Belaye","Belbeuf","Belcodene","Belfort","Belfort-du-Quercy","Belgentier","Belgodere","Belhade","Beliet","Beligneux","Bellac","Bellaing","Bellancourt","Belle-Isle-en-Terre","Belleau","Bellebrune","Bellechaume","Bellefond","Bellefontaine","Bellefosse","Bellegarde","Bellegarde-du-Razes","Bellegarde-en-Diois","Bellegarde-Sainte-Marie","Bellegarde-sur-Valserine","Bellemagny","Bellenaves","Bellencombre","Belleneuve","Bellengreville","Bellentre","Belleray","Bellerive-sur-Allier","Bellesserre","Belleu","Bellevaux","Bellevesvre","Belleville","Belleville-en-Caux","Belleville-sur-Loire","Belleville-sur-Mer","Belleville-sur-Meuse","Belleville-sur-Vie","Bellevue-la-Montagne","Belley","Bellignat","Belloy-en-France","Belmont","Belmont-sur-Rance","Belmontet","Belpech","Belrupt-en-Verdunois","Belveze","Belz","Benamenil","Bene","Benerville-sur-Mer","Benesse-Maremne","Benestroff","Benfeld","Benifontaine","Benney","Bennwihr","Benon","Benouville","Beon","Berat","Bercenay-en-Othe","Berck","Berck-Plage","Berdoues","Berenx","Berg-sur-Moselle","Bergerac","Bergheim","Bergholtz","Bergonne","Bergues","Berjou","Berlaimont","Berles-au-Bois","Bermeries","Bermicourt","Bernadets","Bernard","Bernaville","Bernay","Bernay-Saint-Martin","Berne","Bernes-sur-Oise","Berneuil-sur-Aisne","Berneval-le-Grand","Bernex","Bernieres-le-Patry","Bernieres-sur-Mer","Bernin","Bernis","Bernos-Beaulac","Berriac","Berric","Berry-Bouy","Bersaillin","Bersee","Berson","Berthecourt","Berthelange","Berthen","Bertholene","Bertin","Bertincourt","Bertrange","Bertrimoutier","Bertry","Berville-en-Roumois","Berville-la-Campagne","Berville-sur-Seine","Berviller-en-Moselle","Berzeme","Berzet","Besayes","Besne","Bessais-le-Fromental","Bessan","Bessancourt","Bessay","Besse","Besse-sur-Braye","Besse-sur-Issole","Besseges","Bessenay","Bessens","Bessey-les-Citeaux","Bessieres","Bessines","Bessines-sur-Gartempe","Besson","Bessoncourt","Bessonies","Betaille","Bethancourt-en-Valois","Bethencourt-sur-Mer","Betheniville","Betheny","Bethisy-Saint-Pierre","Bethoncourt","Betschdorf","Bettancourt-la-Ferree","Bettignies","Betting","Betton","Bettviller","Bettwiller","Betz","Beugin","Beugneux","Beure","Beurlay","Beuste","Beutal","Beuvillers","Beuvrages","Beuvraignes","Beuvron-en-Auge","Beuvry-la-Foret","Beuzec-Cap-Sizun","Beuzeville","Bevenais","Beychac-et-Caillau","Beynes","Beynost","Beyrede-Jumet","Beyrie-en-Bearn","Beyssenac","Bezac","Bezannes","Bezons","Bezouce","Bezu-Saint-Eloi","Biache-Saint-Vaast","Biard","Biarritz","Biars-sur-Cere","Biaudos","Bichancourt","Bicqueley","Bidache","Bidarray","Bidart","Bief-du-Fourg","Bielle","Bienville","Bienvillers-au-Bois","Biermont","Bierne","Bierry-les-Belles-Fontaines","Biesheim","Biesles","Bietlenheim","Bieville-Beuville","Bievres","Biganos","Bignac","Bignan","Bignoux","Biguglia","Bihorel","Bilieu","Billere","Billey","Billiers","Billom","Billy","Billy-Berclau","Billy-Montigny","Billy-sous-les-Cotes","Billy-sur-Ourcq","Bindernheim","Binges","Binic","Bining","Bionville-sur-Nied","Biot","Bioule","Birac-sur-Trec","Biriatou","Birieux","Biscarrosse","Bischheim","Bischoffsheim","Bischwihr","Bischwiller","Bisel","Bitche","Biviers","Biville-sur-Mer","Bizanos","Blacourt","Blacqueville","Blacy","Blaesheim","Blagnac","Blagny","Blaignan","Blain","Blainville","Blainville-sur-Mer","Blainville-sur-Orne","Blaise","Blaise-sous-Arzillieres","Blaison-Gohier","Blamont","Blan","Blancafort","Blanchefosse-et-Bay","Blangy-sur-Bresle","Blanot","Blanquefort","Blanzat","Blanzay-sur-Boutonne","Blanzy","Blanzy-la-Salonnaise","Blaringhem","Blaudeix","Blausasc","Blauzac","Blavozy","Blaye","Blaye-les-Mines","Bleigny-le-Carreau","Blendecques","Blenod-les-Pont-a-Mousson","Blenod-les-Toul","Blerancourdelle","Blere","Bleriot-Plage","Blesle","Bletterans","Bleury","Bligny-les-Beaune","Blincourt","Blingel","Blodelsheim","Blois","Blomard","Blondefontaine","Blonville-sur-Mer","Blotzheim","Blou","Bloye","Blyes","Bobigny","Bocquegney","Boe","Boege","Boeil-Bezing","Boen-sur-Lignon","Boersch","Boeschepe","Boeseghem","Boesenbiesen","Bohain-en-Vermandois","Bohal","Boigneville","Boigny","Boigny-sur-Bionne","Bois","Bois-Anzeray","Bois-Arnault","Bois-Colombes","Bois-de-Cene","Bois-de-Gand","Bois-de-la-Pierre","Bois-Grenier","Bois-Guillaume","Bois-Jerome-Saint-Ouen","Bois-le-Roi","Boisbergues","Boiscommun","Boisemont","Boisjean","Boisleux-au-Mont","Boismont","Boismorand","Boisse-Penchot","Boisseron","Boisset-et-Gaujac","Boisseuil","Boissey-le-Chatel","Boissezon","Boissieres","Boissise-la-Bertrand","Boissise-le-Roi","Boissy-Fresnoy","Boissy-le-Bois","Boissy-le-Chatel","Boissy-le-Girard","Boissy-Maugis","Boissy-Mauvoisin","Boissy-sous-Saint-Yon","Boisville-la-Saint-Pere","Boisyvon","Bolandoz","Bolbec","Bollene","Bolleville","Bollezeele","Bollwiller","Bolsenheim","Bommes","Bompas","Bon-Encontre","Bonchamp-les-Laval","Boncourt-le-Bois","Boncourt-sur-Meuse","Bondeville","Bondigoux","Bondoufle","Bondues","Bondy","Bongheat","Bonifacio","Bonlier","Bonnard","Bonnat","Bonnebosq","Bonnee","Bonnegarde","Bonneguete","Bonneil","Bonnelles","Bonnemain","Bonnes","Bonnet","Bonnetable","Bonnetage","Bonnetan","Bonneuil-en-France","Bonneuil-en-Valois","Bonneuil-les-Eaux","Bonneuil-sur-Marne","Bonneval","Bonnevaux-le-Prieure","Bonnevent-Velloreille","Bonneville","Bonneville-Aptot","Bonneville-la-Louvet","Bonnieres-sur-Seine","Bonnieux","Bonny-sur-Loire","Bonrepos","Bonrepos-Riquet","Bons-en-Chablais","Bonsecours","Bonson","Bonzac","Boos","Boqueho","Bor-et-Bar","Boran-sur-Oise","Bord","Bordeaux","Borderes","Borderes-et-Lamensans","Bordes","Bords","Borgo","Bormes-les-Mimosas","Bornay","Bornel","Bosc Renoult","Bosc-Guerard-Saint-Adrien","Bosc-le-Hard","Bosc-Mesnil","Bosgouet","Bosguerard-de-Marcouville","Bosjean","Bosmont-sur-Serre","Bosrobert","Bossancourt","Bossay-sur-Claise","Bossendorf","Bossey","Botsorhel","Bouafles","Bouan","Bouaye","Boubers-sur-Canche","Boubiers","Bouc-Bel-Air","Boucau","Bouchain","Bouchemaine","Boucheporn","Bouchet","Boucoiran-et-Nozieres","Bouee","Bouer","Bouere","Bouex","Bouffemont","Bouffere","Bougarber","Bouge-Chambalud","Bougival","Bougnon","Bougue","Bouguenais","Bougy","Bouhet","Bouillargues","Bouilly","Bouilly-en-Gatinais","Bouin","Boujan-sur-Libron","Boulages","Boulancourt","Boulange","Boulay-les-Barres","Boulay-Moselle","Boulazac","Bouleurs","Bouliac","Boulieu-les-Annonay","Bouligney","Bouligny","Boullay-les-Troux","Boulleret","Boulleville","Bouloc","Boulogne-Billancourt","Boulogne-la-Grasse","Boulogne-sur-Gesse","Boulogne-sur-Mer","Bouloire","Boult-sur-Suippe","Boulzicourt","Bouniagues","Bouquet","Bouquetot","Bouray-sur-Juine","Bourbon-Lancy","Bourbonne-les-Bains","Bourbourg","Bourbriac","Bourcefranc-le-Chapus","Bourdenay","Bourdon","Bouresse","Bourg","Bourg-Achard","Bourg-Argental","Bourg-Blanc","Bourg-de-Thizy","Bourg-en-Bresse","Bourg-la-Reine","Bourg-le-Comte","Bourg-le-Roi","Bourg-les-Valence","Bourg-Saint-Andeol","Bourg-Saint-Maurice","Bourg-Sainte-Marie","Bourg-sous-Chatelet","Bourganeuf","Bourgbarre","Bourges","Bourget","Bourghelles","Bourgneuf","Bourgneuf-en-Retz","Bourgogne","Bourgoin","Bourguebus","Bourgueil","Bourguignon-sous-Coucy","Bourlon","Bourneville","Bournezeau","Bourogne","Bourran","Bourron-Marlotte","Bours","Boursault","Bourseville","Boursieres","Bourth","Boury-en-Vexin","Bousbach","Bousbecque","Bousies","Boussac","Boussay","Boussenac","Boussens","Boussieres","Boussois","Boussy-Saint-Antoine","Boust","Boutancourt","Boutiers-Saint-Trojan","Boutigny-Prouais","Boutigny-sur-Essonne","Bouvaincourt-sur-Bresle","Bouvante","Bouvelinghem","Bouvesse-Quirieu","Bouvigny-Boyeffles","Bouville","Bouvincourt-en-Vermandois","Bouvron","Bouxieres-aux-Chenes","Bouxieres-aux-Dames","Bouxwiller","Bouzel","Bouzigues","Bouzincourt","Bouzonville","Bouzonville-en-Beauce","Bouzy","Bouzy-la-Foret","Boves","Boyer","Boynes","Boz","Bozel","Bozouls","Brachy","Bracieux","Brain-sur-Allonnes","Brain-sur-Vilaine","Braine","Brains","Bram","Bramans","Branches","Brancourt-en-Laonnois","Brandivy","Brando","Brandonnet","Branges","Branne","Branoux-les-Taillades","Bransles","Braquis","Bras","Brasles","Brasparts","Brassac","Brassac-les-Mines","Brassempouy","Braucourt","Braud-et-Saint-Louis","Brax","Bray","Bray-Dunes","Bray-en-Val","Bray-et-Lu","Bray-Saint-Christophe","Bray-sur-Seine","Bray-sur-Somme","Braye-sous-Faye","Brazey-en-Plaine","Breal-sous-Montfort","Brebieres","Brece","Brecey","Brech","Breconchaux","Bree","Bregy","Brehal","Brehand","Breil-sur-Roya","Breitenbach-Haut-Rhin","Breles","Bremenil","Bremontier-Merval","Brenouille","Brens","Bresles","Bresse-sur-Grosne","Bressolles","Bressols","Bresson","Bressuire","Brest","Bretagne","Breteil","Breteniere","Bretenoux","Breteuil","Bretignolles","Bretignolles-sur-Mer","Bretigny","Bretteville-sur-Laize","Bretteville-sur-Odon","Breuil","Breuil-le-Sec","Breuil-le-Vert","Breuil-Magne","Breuillet","Breuilpont","Breuschwickersheim","Breuvannes-en-Bassigny","Breux-sur-Avre","Breval","Breviandes","Brexent-Enocq","Breze","Brezins","Brezolles","Brianconnet","Briare","Briarres-sur-Essonne","Briatexte","Bricon","Bricquebec","Bricqueville-la-Blouette","Bricqueville-sur-Mer","Bricy","Brides-les-Bains","Bridore","Brie","Brie-Comte-Robert","Brie-et-Angonnes","Briec","Brienne-la-Vieille","Briennon","Brienon-sur-Armancon","Brieres-les-Scelles","Brieuil-sur-Chize","Brieulles-sur-Meuse","Briey","Brignac-la-Plaine","Brignais","Brigne","Brignoles","Brignon","Brignoud","Brigueuil","Briis-sous-Forges","Brimeux","Brin-sur-Seille","Brinay","Brindas","Bringolo","Brinon-sur-Beuvron","Briollay","Brion","Brionne","Briord","Brioude","Brioux-sur-Boutonne","Briouze","Briscous","Brison-Saint-Innocent","Brissac","Brissac-Quince","Brissy-Hamegicourt","Brive","Brive-la-Gaillarde","Brives-Charensac","Brives-sur-Charente","Brix","Brochon","Broglie","Brognon","Broin","Brombos","Bron","Broons","Brossac","Brosville","Brou","Brou-sur-Chantereine","Brouay","Brouckerque","Brouderdorff","Broue","Brouennes","Brouilla","Brouqueyran","Brousse","Brousseval","Brouviller","Bru","Bruch","Brue-Auriac","Bruebach","Bruges","Brugheas","Brugny-Vaudancourt","Bruguieres","Bruille-Saint-Amand","Bruley","Brullioles","Brulon","Brumath","Brunoy","Brunstatt","Brussey","Brussieu","Brusvily","Brux","Bruyeres-et-Montberault","Bruyeres-le-Chatel","Bruyeres-sur-Oise","Bruz","Bry-sur-Marne","Bu","Buanes","Bubry","Buc","Buceels","Bucey-les-Gy","Bucheres","Buchy","Bucquoy","Bucy-le-Long","Bucy-les-Cerny","Budos","Bueil","Buellas","Buffard","Bugeat","Bugnicourt","Buhl","Buigny-les-Gamaches","Buire-le-Sec","Buironfosse","Buis-les-Baronnies","Bulat-Pestivien","Bulgneville","Bulhon","Bulles","Bully","Bully-les-Mines","Buno-Bonnevaux","Bunzac","Burbure","Bures-sur-Yvette","Burie","Burlats","Burnhaupt-le-Haut","Buros","Bury","Busigny","Busloup","Busque","Bussac-Foret","Bussang","Bussiere-Galant","Bussiere-Poitevine","Bussieres-les-Belmont","Bussunarits-Sarrasquette","Bussus-Bussuel","Bussy-le-Chateau","Bussy-le-Grand","Bussy-les-Daours","Bussy-Lettree","Bussy-Saint-Georges","Busy","Buthiers","Butry-sur-Oise","Buxerolles","Buxeuil","Buxieres-les-Mines","Buxy","Buzan","Buzancais","Buzet-sur-Baise","Buzet-sur-Tarn","Buzy","Cabanac","Cabanac-et-Villagrains","Cabannes","Cabara","Cabariot","Cabasse","Cabestany","Cabourg","Cabries","Cabris","Cachan","Cadalen","Cadaujac","Caden","Cadenet","Cadillac","Cadillac-en-Fronsadais","Cadolive","Cadours","Caen","Caestre","Cagnac-les-Mines","Cagnes-sur-Mer","Cagnicourt","Cagny","Cahagnes","Cahors","Cahuzac","Cahuzac-sur-Vere","Caille","Caillouel-Crepigny","Cailloux-sur-Fontaines","Cairanne","Cairon","Caissargues","Cajarc","Calais","Calas","Calavante","Calcatoggio","Calenzana","Callac","Callas","Calleville","Callian","Calmels-et-le-Viala","Calmont","Calonne-Ricouart","Calonne-sur-la-Lys","Caluire-et-Cuire","Calvi","Calvisson","Camaret-sur-Aigues","Camaret-sur-Mer","Camarsac","Cambes","Cambieure","Camblain-Chatelain","Camblanes-et-Meynac","Cambo-les-Bains","Cambounet-sur-le-Sor","Cambrai","Cambrin","Cambronne-les-Ribecourt","Came","Cameyrac","Camiac-et-Saint-Denis","Camiers","Camlez","Camoel","Camon","Camors","Campagnan","Campagne","Campagne-les-Hesdin","Campagne-les-Wardrecques","Campagnolles","Campeaux","Campeneac","Campet-et-Lamolere","Camphin-en-Carembault","Camphin-en-Pevele","Campigneulles-les-Petites","Campremy","Camprond","Camps-la-Source","Campuac","Campugnan","Canaples","Cancale","Cancon","Cande","Cande-sur-Beuvron","Candillargues","Candresse","Canejan","Canet-de-Salars","Canet-Plage","Cangey","Canisy","Canlers","Canly","Cannes","Cannes-Ecluse","Cannet","Canohes","Canouville","Canteleu","Cantin","Cany-Barville","Capbreton","Capdenac-Gare","Capelle","Capelle-Fermont","Capendu","Capens","Capestang","Capinghem","Capoulet-et-Junac","Cappel","Cappelle-Brouck","Cappelle-en-Pevele","Cappelle-la-Grande","Captieux","Capvern","Caragoudes","Caraman","Carantec","Carantilly","Carbon-Blanc","Carbonne","Carcans","Carcassonne","Carces","Carcopino","Cardaillac","Cardesse","Cardonville","Cardroc","Carency","Carentan","Carentoir","Carhaix-Plouguer","Carignan","Carling","Carlipa","Carlucet","Carlus","Carmaux","Carnac","Carneville","Carnieres","Carnin","Carnon-Plage","Carnoules","Carolles","Caromb","Carpentras","Carpiquet","Carquefou","Carqueiranne","Carresse-Cassaber","Carrieres-sous-Poissy","Carrieres-sur-Seine","Carros","Carrouges","Carry-le-Rouet","Carsac-Aillac","Carspach","Cartelegue","Cartignies","Carville-la-Folletiere","Carvin","Casanova","Cases-de-Pene","Cassagne","Cassagnes","Cassagnes-Begonhes","Cassagnoles","Cassel","Casseneuil","Cassis","Casson","Cast","Castagnede","Castanet-le-Haut","Castanet-Tolosan","Casteide-Cami","Castelginest","Casteljaloux","Castellane","Castellar","Castellare-di-Mercurio","Castello-di-Rostino","Castelmoron-sur-Lot","Castelnau-de-Brassac","Castelnau-de-Levis","Castelnau-de-Montmiral","Castelnau-Durban","Castelnau-le-Lez","Castelnau-Montratier","Castelnau-sur-Gupie","Castelnau-Valence","Castelnaud-de-Gratecambe","Castelnaudary","Castels","Castelsagrat","Castelsarrasin","Castera-Loubix","Castet","Castetner","Castets-en-Dorthe","Castiglione","Castillon-Debats","Castillon-du-Gard","Castillon-la-Bataille","Castillon-Massas","Castillonnes","Castilly","Castres","Castres-Gironde","Castries","Catenay","Catenoy","Cattenom","Catus","Caucalieres","Caudan","Caudebec-en-Caux","Caudecoste","Caudrot","Caudry","Cauge","Caullery","Caulnes","Caumont","Caumont-sur-Durance","Caumont-sur-Garonne","Cauneille","Caunes-Minervois","Caurel","Cauroir","Cauroy-les-Hermonville","Caussade-Riviere","Causse-de-la-Selle","Cauvigny","Cauville-sur-Mer","Caux","Caux-et-Sauzens","Cauzac","Cavaillon","Cavalaire-sur-Mer","Cavan","Caveirac","Cavignac","Cavillargues","Cavillon","Cayeux-sur-Mer","Caylus","Cayrac","Cazals-des-Bayles","Cazaux","Cazaux-Layrisse","Cazavet","Cazeres","Cazes-Mondenard","Cazevieille","Cazilhac","Cazouls-les-Beziers","Ceauce","Ceaux","Cebazat","Ceignes","Ceintrey","Celle-Levescault","Celles-en-Bassigny","Celles-sur-Belle","Celles-sur-Durolle","Cellettes","Cellieu","Celon","Cenac","Cendras","Cenon","Cenon-sur-Vienne","Centres","Cepet","Cepie","Cepoy","Cerans-Foulletourte","Cercier","Cercoux","Cerdon","Cere","Cerelles","Cereste","Ceret","Cergy","Cerilly","Cerise","Cerisiers","Cerisy-la-Foret","Cerisy-la-Salle","Cerizay","Cernay","Cernay-la-Ville","Cerneux","Cerny","Cerons","Cers","Certines","Cervens","Cervera de la Marenda","Cervieres","Cervione","Cesar","Cesarches","Cescau","Cesny-aux-Vignes","Cesny-Bois-Halbout","Cessales","Cessenon-sur-Orb","Cesseras","Cessey","Cessieu","Cesson","Cessy","Cestas","Ceton","Ceyrat","Ceyreste","Ceyssat","Ceyzeriat","Cezay","Chaban","Chabanais","Chabestan","Chabeuil","Chablis","Chabons","Chabottes","Chabrillan","Chabris","Chacenay","Chadeleuf","Chadrac","Chadron","Chaffois","Chagey","Chagny","Chaignay","Chail","Chaillac","Chaillac-sur-Vienne","Chaille-les-Marais","Chailles","Chaillevette","Chailloue","Chailly-en-Biere","Chailly-en-Gatinais","Chainaz-les-Frasses","Chaingy","Chaix","Chalais","Chalamont","Chalampe","Chalandry-Elaire","Chaleins","Chalencon","Chalette-sur-Loing","Chalette-sur-Voire","Chaleze","Chalezeule","Chaligny","Chalindrey","Challain-la-Potherie","Challans","Challes-les-Eaux","Challet","Challex","Chalmaison","Chalo-Saint-Mars","Chalon","Chalonnes-sur-Loire","Chalons-en-Champagne","Chalonvillars","Chalou-Moulineux","Chamagne","Chamagnieu","Chambalud","Chamberet","Chambilly","Chamblac","Chamblanc","Chambles","Chamblet","Chambley-Bussieres","Chambly","Chamboeuf","Chambon","Chambon-sur-Lac","Chambon-sur-Voueize","Chambonas","Chambord","Chamboret","Chamborigaud","Chambors","Chambost-Longessaigne","Chamboulive","Chambourcy","Chambourg-sur-Indre","Chambrecy","Chambretaud","Chambry","Chamelet","Chameyrat","Chamigny","Chamonix","Chamouilley","Chamoux","Chamoux-sur-Gelon","Champ","Champ-le-Duc","Champ-sur-Drac","Champagnac","Champagnac-le-Vieux","Champagnat","Champagne","Champagne-les-Marais","Champagne-Mouton","Champagne-sur-Oise","Champagne-sur-Seine","Champagney","Champagnole","Champanges","Champcenest","Champcerie","Champcevinel","Champcueil","Champdieu","Champdotre","Champdray","Champeaux","Champeix","Champenay","Champenoux","Champeon","Champey-sur-Moselle","Champforgeuil","Champfromier","Champhol","Champien","Champier","Champigne","Champigneulles","Champigny","Champigny-sur-Marne","Champlan","Champlemy","Champlitte","Champniers","Champoly","Champoulet","Champs","Champs-sur-Marne","Champs-sur-Tarentaine-Marchal","Champs-sur-Yonne","Champsac","Champtercier","Champtoce-sur-Loire","Champtoceaux","Champvans","Chanas","Chanceaux-sur-Choisille","Chancelade","Chancenay","Change","Changis-sur-Marne","Chaniers","Chanonat","Chanoz-Chatenay","Chanteau","Chantecorps","Chanteheux","Chanteloup","Chanteloup-en-Brie","Chanteloup-les-Bois","Chanteloup-les-Vignes","Chantemerle-sur-la-Soie","Chantepie","Chanteuges","Chantilly","Chantome","Chantonnay","Chantraine","Chantrans","Chanveaux","Chaon","Chapareillan","Chapdes-Beaufort","Chapeiry","Chapelle-Vallon","Chapelle-Voland","Chaponnay","Chaponost","Chaptelat","Chaptuzat","Charancieu","Charantonnay","Charavines","Charbonnieres-les-Bains","Charbonnieres-les-Varennes","Charbuy","Charentay","Charenton-le-Pont","Charge","Chargey-les-Gray","Chargey-les-Port","Charleval","Charleville","Charlieu","Charly","Charly-sur-Marne","Charmant","Charmes","Charmes-sur-Rhone","Charmont-en-Beauce","Charmont-sous-Barbuise","Charnas","Charnay","Charnay-les-Macon","Charnecles","Charny","Charolles","Charonville","Charost","Charquemont","Charrecey","Charron","Charroux","Charsonville","Charteves","Chartres","Chartres-de-Bretagne","Chartrettes","Charvieu-Chavagneux","Charvonnex","Chas","Chasnais","Chasne-sur-Illet","Chaspinhac","Chassagnes","Chassagny","Chasse-sur-Rhone","Chasselay","Chassemy","Chassenard","Chasseneuil","Chasseneuil-du-Poitou","Chasseneuil-sur-Bonnieure","Chassey-le-Camp","Chassiers","Chassieu","Chataincourt","Chateau","Chateau-Arnoux-Saint-Auban","Chateau-Chervix","Chateau-Chinon(Ville)","Chateau-du-Loir","Chateau-Gontier","Chateau-Landon","Chateau-Porcien","Chateau-Renault","Chateau-Salins","Chateau-sur-Epte","Chateaubleau","Chateaubourg","Chateaubriand","Chateaubriant","Chateaudouble","Chateaufort","Chateaugay","Chateaugiron","Chateaumeillant","Chateauneuf","Chateauneuf-de-Bordette","Chateauneuf-de-Gadagne","Chateauneuf-de-Galaure","Chateauneuf-du-Faou","Chateauneuf-du-Rhone","Chateauneuf-en-Thymerais","Chateauneuf-Grasse","Chateauneuf-la-Foret","Chateauneuf-le-Rouge","Chateauneuf-les-Martigues","Chateauneuf-sur-Charente","Chateauneuf-sur-Loire","Chateauneuf-sur-Sarthe","Chateaurenard","Chateauvillain","Chatel","Chatel-de-Neuvre","Chatel-Guyon","Chatel-Saint-Germain","Chatel-sur-Moselle","Chatelaillon-Plage","Chatelaines","Chatelais","Chatelaudren","Chateldon","Chatelet","Chatelus","Chatelus-le-Marcheix","Chatenay-sur-Seine","Chatenet","Chatenois","Chatenois-les-Forges","Chatenoy","Chatenoy-le-Royal","Chatignonville","Chatillon","Chatillon-Coligny","Chatillon-la-Palud","Chatillon-le-Duc","Chatillon-le-Roi","Chatillon-les-Sons","Chatillon-sur-Chalaronne","Chatillon-sur-Cher","Chatillon-sur-Indre","Chatillon-sur-Loire","Chatillon-sur-Saone","Chatillon-sur-Seiche","Chatillon-sur-Thouet","Chatonnay","Chatonrupt-Sommermont","Chatou","Chatres","Chatres-sur-Cher","Chatte","Chatuzange-le-Goubet","Chauche","Chaudefonds-sur-Layon","Chaudefontaine","Chaudon","Chaudron-en-Mauges","Chauffailles","Chauffry","Chaufour-les-Bonnieres","Chaufour-Notre-Dame","Chaulnes","Chaumes","Chaumes-en-Brie","Chaumont","Chaumont-en-Vexin","Chaumontel","Chaumousey","Chauny","Chauray","Chauriat","Chaussin","Chaussoy-Epagny","Chaussy","Chauve","Chauvigny","Chauvincourt-Provemont","Chauvry","Chaux","Chavagne","Chavagnes-en-Paillers","Chavagnes-les-Redoux","Chavaignes","Chavanay","Chavannes-sur-Reyssouze","Chavanod","Chavanoz","Chavaroux","Chavenay","Chavigny","Chaville","Chazelles","Chazelles-sur-Lyon","Checy","Chedigny","Chef-Boutonne","Cheffes","Chehery","Chelan","Chelles","Chemaze","Chemere","Chemere-le-Roi","Chemery","Chemery-les-Deux","Chemille-Melay","Chemilly-sur-Serein","Cheminot","Chemy","Chenailler-Mascheix","Chenaud","Chenay-le-Chatel","Chenerailles","Chenevelles","Chenex","Chenimenil","Chennevieres-sur-Marne","Chenonceaux","Chenou","Chenove","Chens-sur-Leman","Cheny","Chepoix","Cheptainville","Chepy","Cherac","Cherbourg-Octeville","Chereng","Cheret","Cherier","Cherisey","Cherisy","Cheron","Cheroy","Cherre","Cherreau","Cherves-Chatelars","Cherves-Richemont","Chervettes","Cherveux","Chesley","Chessy","Chessy-les-Pres","Cheux","Chevaigne","Cheval-Blanc","Chevalet-le-Haut","Chevanceaux","Chevannes","Cheverny","Chevigny","Chevigny-Saint-Sauveur","Chevillon","Chevillon-sur-Huillard","Chevilly","Chevilly-Larue","Chevincourt","Chevire-le-Rouge","Chevrainvilliers","Chevremont","Chevreuse","Chevrier","Chevrieres","Chevrotaine","Chevru","Chevry","Chevry-Cossigny","Chevry-en-Sereine","Cheyssieu","Chezery-Forens","Chezy","Chezy-sur-Marne","Chiche","Chichery","Chierry","Chieulles","Chignin","Chigny-les-Roses","Chigy","Chilhac","Chille","Chilly","Chilly-Mazarin","Chimilin","Chinon","Chire-en-Montreuil","Chirens","Chiry-Ourscamp","Chissay-en-Touraine","Chisseaux","Chissey-en-Morvan","Chitenay","Chivres-en-Laonnois","Chize","Chocques","Choisel","Choisey","Choisy","Choisy-au-Bac","Choisy-en-Brie","Choisy-le-Roi","Cholet","Chomerac","Chorges","Chourgnac","Chouy","Choye","Chozeau","Chuelles","Chuzelles","Ciboure","Ciel","Cierrey","Cieurac","Cieux","Cinq-Mars-la-Pile","Cinqueux","Cintegabelle","Cintheaux","Cintre","Cires-les-Mello","Cirey","Cirey-sur-Vezouze","Ciron","Ciry-le-Noble","Cissac-Medoc","Cisse","Cistrieres","Citerne","Citry","Civaux","Civens","Civrac-de-Blaye","Civrac-en-Medoc","Civray","Civray-de-Touraine","Civrieux","Civry-en-Montagne","Cize","Cizely","Claira","Clairac","Clairfontaine","Clairmarais","Clairoix","Clairvaux-dAveyron","Clairvaux-les-Lacs","Claix","Clamart","Clamecy","Claouey","Clapiers","Clarac","Claracq","Clarafond","Clarensac","Clarques","Clary","Classun","Clasville","Clavel","Clavette","Claviers","Claville","Claye-Souilly","Cleder","Cleguer","Cleguerec","Clelles","Clement","Clemery","Clemont","Clenay","Cleon","Clerieux","Clermont","Clermont-Ferrand","Clerval","Clery-Saint-Andre","Clesse","Clety","Clevilliers","Clichy","Clichy-sous-Bois","Clinchamps-sur-Orne","Cliron","Clisson","Clohars-Carnoet","Clohars-Fouesnant","Clouange","Clouzeau","Cloyes-sur-le-Loir","Cluny","Cluses","Coaraze","Coarraze","Cobrieux","Cocheren","Cocumont","Codognan","Codolet","Coesmes","Coeuvres-et-Valsery","Coex","Cogles","Cogna","Cognac","Cognin","Cogolin","Coignet","Coignieres","Coimeres","Coincy","Coirac","Coise-Saint-Jean-Pied-Gauthier","Coivrel","Colayrac-Saint-Cirq","Colembert","Coligny","Collandres-Quincarnon","Collegien","Colleret","Colleville","Colleville-Montgomery","Collias","Collioure","Collobrieres","Collonges-les-Premieres","Collonges-sous-Saleve","Collorgues","Colmar","Colmars","Cologne","Colomars","Colombe","Colombelles","Colombes","Colombier","Colombier-Fontaine","Colombier-le-Cardinal","Colombier-le-Vieux","Colombier-Saugnieu","Colombieres-sur-Orb","Colombiers","Colomby-sur-Thaon","Colomiers","Colomieu","Colondannes","Colonzelle","Colpo","Coltainville","Combas","Comblanchien","Combloux","Combon","Combourg","Combrand","Combree","Combrit","Combronde","Combs-la-Ville","Comines","Commelle-Vernay","Commenchon","Commensacq","Commentry","Commeny","Commequiers","Commer","Commercy","Commes","Commissey","Communay","Compans","Compertrix","Compolibat","Compreignac","Comps","Concarneau","Conceze","Conches-en-Ouche","Conches-sur-Gondoire","Conchy-les-Pots","Condac","Condat","Condat-sur-Vienne","Conde-en-Brie","Conde-Northen","Conde-Sainte-Libiaire","Conde-sur-Iton","Conde-sur-Marne","Conde-sur-Noireau","Conde-sur-Sarthe","Conde-sur-Suippe","Conde-sur-Vesgre","Conde-sur-Vire","Condecourt","Condeon","Condette","Condezaygues","Condillac","Condom","Condrieu","Conflans-en-Jarnisy","Conflans-Sainte-Honorine","Conflans-sur-Loing","Conflans-sur-Seine","Confolens","Congenies","Conliege","Connantray-Vaurefroy","Conne-de-Labarde","Connerre","Conquereuil","Conques-sur-Orbiel","Cons-Sainte-Colombe","Contamine-sur-Arve","Contes","Contigne","Contoire","Contre","Contres","Contrexeville","Contrisson","Contz-les-Bains","Copponex","Coquelles","Corancez","Coray","Corbara","Corbarieu","Corbas","Corbehem","Corbeil-Cerf","Corbeil-Essonnes","Corbeilles","Corbelin","Corbeny","Corbere-Aberes","Corbere-les-Cabanes","Corbie","Corbieres","Corbigny","Corbonod","Corbreuse","Corcelles-les-Citeaux","Corcelles-les-Monts","Corcieux","Corconne","Corcy","Cordelle","Cordemais","Cordes-sur-Ciel","Cordes-Tolosannes","Cordon","Corenc","Corgnac-sur-lIsle","Corgoloin","Corignac","Corlay","Cormainville","Corme-Ecluse","Corme-Royal","Cormeilles","Cormeilles-en-Parisis","Cormeilles-en-Vexin","Cormelles-le-Royal","Cormeray","Cormery","Cormes","Cormicy","Cormolain","Cormontreuil","Cormoranche-sur-Saone","Cornac","Cornas","Corne","Cornebarrieu","Corneilla-de-Conflent","Corneilla-del-Vercol","Corneilla-la-Riviere","Cornier","Cornille","Cornillon-Confoux","Cornillon-en-Trieves","Cornimont","Cornus","Corny-sur-Moselle","Coron","Corpe","Corps-Nuds","Correze","Corroy","Cors","Corsept","Corseul","Corte","Corveissiat","Corze","Cosges","Cosmes","Cosne-Cours-sur-Loire","Cosqueville","Cosse-le-Vivien","Cossesseville","Costaros","Cotdoussan","Cotignac","Cottenchy","Cottevrard","Cottun","Couargues","Coublevie","Coubon","Coubron","Couches","Couchey","Coucy-le-Chateau-Auffrique","Couddes","Coudehard","Coudekerque-Branche","Coudes","Coudoux","Coudray","Coudray-au-Perche","Coudray-Rabut","Coudroy","Coudun","Coueron","Couesmes-Vauce","Coufouleux","Couhe","Couilly-Pont-aux-Dames","Couiza","Coulaines","Coulandon","Coulans-sur-Gee","Coulaures","Coullons","Coulogne","Couloisy","Coulombiers","Coulomby","Coulommes","Coulommiers","Coulommiers-la-Tour","Coulon","Coulonces","Coulonges","Coulonges-Thouarsais","Coulounieix-Chamiers","Coulouvray-Boisbenatre","Coulvain","Coulx","Coume","Coupelle-Vieille","Coupesarte","Coupeville","Coupigny","Coupru","Coupvray","Cour-Cheverny","Cour-et-Buis","Cour-sur-Loire","Courances","Courbeveille","Courbevoie","Courcais","Courcay","Courcelles","Courcelles-Chaussy","Courcelles-en-Bassee","Courcelles-Epayelles","Courcelles-les-Gisors","Courcelles-les-Lens","Courcelles-sur-Nied","Courcelles-sur-Seine","Courcelles-sur-Viosne","Courcemont","Courcerac","Courchaton","Courchelettes","Courchevel","Courcon","Courcouronnes","Courcy","Courcy-aux-Loges","Courdemanche","Courdimanche-sur-Essonne","Courgis","Courlans","Courlaoux","Courlay","Courmelles","Courmemin","Cournon","Cournon-dAuvergne","Cournonsec","Cournonterral","Courpalay","Courpiere","Courquetaine","Cours","Cours-de-Monsegur","Cours-la-Ville","Cours-les-Bains","Cours-les-Barres","Coursac","Coursan","Courseulles-sur-Mer","Courson","Courson-les-Carrieres","Courson-Monteloup","Courtelevant","Courtenay","Courtenot","Courteranges","Courthezon","Courtisols","Courtomer","Courtonne-la-Meurdrac","Courtry","Courville-sur-Eure","Courzieu","Cousance","Cousances-les-Forges","Cousolre","Coussay-les-Bois","Coutances","Coutarnoux","Couterne","Couternon","Couteuges","Coutevroult","Coutiches","Coutras","Couvains","Couville","Couvron-et-Aumencourt","Coux","Couy","Couze-et-Saint-Front","Couzeix","Couzon","Coye-la-Foret","Coyriere","Cozes","Crach","Craincourt","Cramant","Cran-Gevrier","Crancey","Crancot","Cransac","Cranves-Sales","Craon","Craonne","Craponne","Cras-sur-Reyssouze","Cravanche","Cravans","Cravant","Cravant-les-Coteaux","Cravent","Crayssac","Crazannes","Creances","Creches-sur-Saone","Crecy-sur-Serre","Credin","Cregy-les-Meaux","Crehange","Crehen","Creil","Creissan","Creissels","Cremeaux","Cremieu","Crepey","Cresancey","Crespieres","Crespin","Cressat","Cresse","Cresserons","Crest","Creully","Creusot","Creutzwald","Creuzier-le-Neuf","Creuzier-le-Vieux","Crevant-Laveine","Crevechamps","Crevecoeur-le-Grand","Crevin","Crezancy","Criel-sur-Mer","Crillon-le-Brave","Crimolois","Crisenoy","Crisolles","Crissey","Crochte","Crocq","Croisette","Croisilles","Croissanville","Croissy-Beaubourg","Croissy-sur-Celle","Croissy-sur-Seine","Croix","Croix-Chapeau","Croix-de-Vie","Croix-Mare","Croixanvec","Crolles","Cros-de-Ronesque","Crosne","Crottet","Crouay","Croutelle","Crouttes","Crouy-sur-Cosson","Crouy-sur-Ourcq","Croze","Crozes-Hermitage","Crozon","Cruas","Cruet","Crugny","Cruscades","Cruseilles","Crusnes","Cruzilles-les-Mepillat","Cruzy","Cublac","Cubry-les-Soing","Cubzac-les-Ponts","Cucq","Cucuron","Cuers","Cuffies","Cuffy","Cugand","Cuges-les-Pins","Cugnaux","Cuigy-en-Bray","Cuinchy","Cuincy","Cuinzier","Cuise-la-Motte","Cuiseaux","Cuisery","Culhat","Culmont","Culoz","Cumieres","Cunfin","Cunlhat","Cuon","Cuperly","Cuqueron","Curchy","Curdin","Curel","Curgies","Curtafond","Curzay-sur-Vonne","Cussay","Cusset","Cussey-les-Forges","Cussy-les-Forges","Custines","Cusy","Cuttoli-Corticchiato","Cuvergnon","Cuverville","Cuvilly","Cuvry","Cuxac-Cabardes","Cuy","Cuy-Saint-Fiacre","Cuzieu","Cysoing","Dabo","Dachstein","Dadonville","Dagneux","Dainville","Dalhunden","Dallet","Dalmas","Damazan","Dambach-la-Ville","Dambenois","Dame-Marie","Damelevieres","Damerey","Damery","Damgan","Damiatte","Damigny","Dammarie-les-Lys","Dammarie-sur-Saulx","Dammartin-en-Goele","Dammartin-en-Serve","Damparis","Dampierre","Dampierre-au-Temple","Dampierre-en-Burly","Dampierre-en-Crot","Dampierre-les-Bois","Dampierre-les-Conflans","Dampierre-sur-Blevy","Dampierre-sur-Boutonne","Dampmart","Damprichard","Dampsmesnil","Dampvalley-les-Colombe","Damville","Damvix","Dancevoir","Dangeau","Dangeul","Danjoutin","Danne-et-Quatre-Vents","Dannemoine","Daoulas","Dardilly","Dareize","Dargnies","Dargoire","Darmont","Darnetal","Darney","Darnieulles","Darvoy","Dasle","Daubensand","Daubeuf-la-Campagne","Dauendorf","Daumeray","Daux","Dauzat-sur-Vodable","Davenescourt","Davezieux","Dax","Deauville","Decazeville","Dechy","Decines-Charpieu","Decize","Delettes","Delle","Delme","Demouville","Demuin","Denain","Denat","Denee","Denevre","Denice","Denier","Dennebroeucq","Denneville","Denney","Denting","Dercy","Dernancourt","Derval","Desaignes","Desertines","Desvres","Detrier","Dettwiller","Deuil-la-Barre","Deulemont","Devecey","Devillac","Deville-les-Rouen","Devrouze","Deyme","Deyvillers","Dezize-les-Maranges","Dhuisy","Diarville","Didenheim","Die","Diebling","Dieffenbach-au-Val","Diemeringen","Diemoz","Dienville","Dieppe","Dieppe-sous-Douaumont","Dierre","Dietwiller","Dieue-sur-Meuse","Dieulefit","Dieulouard","Dieupentale","Dieuze","Dieval","Diffembach-les-Hellimer","Diges","Digne-les-Bains","Digoin","Dijon","Dimbsthal","Dimechaux","Dinan","Dinard","Dinge","Dingsheim","Dingy-en-Vuache","Dingy-Saint-Clair","Dinoze","Dionay","Dissay","Disse-sous-Ballon","Distre","Distroff","Dive","Dives-sur-Mer","Divion","Divonne-les-Bains","Dixmont","Dizy","Doazit","Docelles","Doeuil-sur-le-Mignon","Dogneville","Doingt","Doissin","Doix","Dol-de-Bretagne","Dole","Dollon","Dolo","Dolomieu","Domagne","Domaize","Domalain","Domancy","Domart-sur-la-Luce","Domats","Dombasle-sur-Meurthe","Domene","Domerat","Domessargues","Domessin","Domevre-sur-Durbion","Domezain-Berraute","Domfront","Domgermain","Domjevin","Dommartin","Dommartin-les-Remiremont","Dommartin-les-Toul","Domont","Dompierre-les-Ormes","Dompierre-sur-Besbre","Dompierre-sur-Mer","Dompierre-sur-Veyle","Dompierre-sur-Yon","Donchery","Doncourt-les-Conflans","Donges","Donjeux","Donnemarie-Dontilly","Donnery","Donneville","Donnezac","Dontrien","Donville-les-Bains","Donzacq","Donzere","Donzy","Donzy-le-Pertuis","Dordives","Dorlisheim","Dormans","Dormelles","Dornes","Dornot","Dortan","Dorval","Douai","Douarnenez","Doubs","Douchy","Douchy-les-Mines","Doudeville","Doue-la-Fontaine","Douilly","Doulezon","Doullens","Doumy","Dounoux","Dourdain","Dourdan","Dourges","Dourgne","Doussard","Douvaine","Douville","Douvres","Douvres-la-Delivrande","Douvrin","Doux","Douy-la-Ramee","Douzy","Doville","Doyet","Dozule","Drace","Drachenbronn-Birlenbach","Dracy-le-Fort","Draguignan","Draillant","Drain","Drancy","Drap","Draveil","Dreffeac","Dremil-Lafage","Dreslincourt","Dreuil-les-Amiens","Dreux","Dreville","Drocourt","Drom","Droupt-Saint-Basle","Drouville","Druillat","Drulingen","Drusenheim","Druye","Druyes-les-Belles-Fontaines","Dry","Ducey","Duclair","Duerne","Dugny","Dugny-sur-Meuse","Duingt","Duisans","Dullin","Dun-le-Poelier","Dun-sur-Auron","Duneau","Dunes","Duniere","Dunkirk","Duppigheim","Durance","Duranus","Durban-Corbieres","Durcet","Durette","Durfort","Durlinsdorf","Durmenach","Durrenbach","Durrenentzen","Durstel","Durtal","Durtol","Dury","Duttlenheim","Eance","Eaubonne","Eaucourt-sur-Somme","Eaunes","Eaux-Bonnes","Eaux-Puiseaux","Eauze","Ebersviller","Eblange","Ecaillon","Ecalles-Alix","Ecaquelon","Ecardenville-la-Campagne","Ecardenville-sur-Eure","Ecault","Eccles","Echalas","Echarcon","Echauffour","Echavanne","Echemire","Echenans","Echenevex","Echenon","Echenoz-la-Meline","Echevannes","Echevis","Echillais","Echinghen","Echire","Eckbolsheim","Eckwersheim","Eclaron-Braucourt-Sainte-Liviere","Ecleux","Ecluzelles","Ecoche","Ecole","Ecole-Valentin","Ecommoy","Ecorcei","Ecos","Ecouen","Ecouflant","Ecourt-Saint-Quentin","Ecouviez","Ecoyeux","Ecques","Ecquevilly","Ecretteville-les-Baons","Ecrosnes","Ecrouves","Ectot-les-Baons","Ecueil","Ecueille","Ecuelles","Ecuille","Ecuires","Ecuisses","Ecully","Ecury-sur-Coole","Edern","Effiat","Effry","Egletons","Egligny","Egly","Egreville","Eguilles","Eichhoffen","Einville-au-Jard","el Volo","Elbeuf","Eletot","Eleu-dit-Leauwette","Elincourt","Elincourt-Sainte-Marguerite","Elliant","Ellon","Elna","Elnes","Eloise","Eloyes","els Banys de la Presta","Elven","Emance","Embrun","Embry","Emerainville","Emieville","Emmerin","Enchenberg","Enencourt-le-Sec","Enghien-les-Bains","Engins","Englefontaine","Englos","Ennery","Ennevelin","Ennezat","Ennordres","Enquin-les-Mines","Ensisheim","Ensues-la-Redonne","Entraigues-sur-la-Sorgue","Entrains-sur-Nohain","Entrammes","Entrange","Entraygues-sur-Truyere","Entre-deux-Guiers","Entrecasteaux","Entremont-le-Vieux","Entressen","Entzheim","Enveig","Envermeu","Epagne-Epagnette","Epagny","Epaignes","Epegard","Epenancourt","Epenede","Epercieux-Saint-Paul","Eperlecques","Epernon","Epertully","Epervans","Epfig","Epiais-Rhus","Epieds-en-Beauce","Epierre","Epinac","Epinay","Epinay-sous-Senart","Epineuil-le-Fleuriel","Epinouze","Epinoy","Episy","Epoisses","Epone","Epouville","Eppe-Sauvage","Eppeville","Epping","Epuisay","Equeurdreville-Hainneville","Equihen-Plage","Er","Eragny","Erbray","Erbree","Erce-en-Lamee","Erce-pres-Liffre","Erceville","Ercheu","Erdeven","Ergersheim","Ergny","Ergue-Gaberic","Erize-Saint-Dizier","Ermenonville","Ermont","Ernee","Ernemont-sur-Buchy","Ernestviller","Ernolsheim-Bruche","Erome","Eroudeville","Erquinghem-Lys","Erquinvillers","Erquy","Erre","Errouville","Erstein","Ervauville","Esbarres","Esbly","Escalquens","Escames","Escassefort","Escaudain","Escaudoeuvres","Escautpont","Escazeaux","Eschau","Eschbach-au-Val","Eschentzwiller","Esches","Esclainvillers","Escolives-Sainte-Camille","Escombres-et-le-Chesnois","Escondeaux","Escorneboeuf","Escou","Escout","Escoutoux","Escurolles","Esery","Eslettes","Esmery-Hallon","Esnandes","Esnouveaux","Espagnac","Espalais","Espalion","Espaly-Saint-Marcel","Esparron-de-Verdon","Espedaillac","Espelette","Espeluche","Espezel","Espiet","Espinasses","Espira-de-Conflent","Espirat","Espondeilhan","Esquay-Notre-Dame","Esquay-sur-Seulles","Esquelbecq","Esquerchin","Esquerdes","Esquibien","Esquieze-Sere","Essegney","Essert","Essertaux","Esserts-Saleve","Essey","Essey-les-Nancy","Essia","Essigny-le-Grand","Esson","Essoyes","Estadens","Estagel","Estaing","Estaires","Esternay","Estevelles","Estillac","Estivareilles","Estouches","Estouteville-Ecalles","Estouy","Estrablin","Estree-Blanche","Estrees","Estrees-les-Crecy","Estrees-Saint-Denis","Estrees-sur-Noye","Esvres","Etable","Etables","Etables-sur-Mer","Etaimpuis","Etaing","Etainhus","Etalondes","Etampes-sur-Marne","Etang-sur-Arroux","Etaules","Etauliers","Etaux","Etaves-et-Bocquiaux","Eteimbes","Etel","Etelfay","Etercy","Eternoz","Eterville","Etevaux","Eth","Etigny","Etiolles","Etival","Etival-Clairefontaine","Etival-les-le-Mans","Etoges","Etoile-sur-Rhone","Etourvy","Etouvans","Etouvy","Etrechy","Etreillers","Etrelles","Etrembieres","Etrepagny","Etrepilly","Etreux","Etrez","Etriac","Etriche","Etricourt-Manancourt","Etroeungt","Etroussat","Ettendorf","Etting","Etupes","Etuz","Etzling","Eu","Eulmont","Euville","Evans","Evenos","Everly","Eveux","Evin-Malmaison","Evran","Evrecy","Evron","Excenevex","Excideuil","Exideuil","Exincourt","Exireuil","Exoudun","Eybens","Eybouleuf","Eygalieres","Eyguieres","Eygurande-et-Gardedeuil","Eyjeaux","Eyliac","Eymet","Eymoutiers","Eyragues","Eyrans","Eysines","Eyzin-Pinet","Ezanville","Eze","Ezy-sur-Eure","Fabregues","Fabrezan","Faches","Faches-Thumesnil","Fagnieres","Faimbe","Fains-Veel","Falaise","Falck","Falicon","Fallerans","Falleron","Falletans","Famars","Fameck","Fampoux","Fanjeaux","Faramans","Farbus","Farebersviller","Fareins","Faremoutiers","Farges-les-Chalon","Fargues","Fargues-Saint-Hilaire","Farincourt","Fatouville-Grestain","Fauch","Faucigny","Faucogney-et-la-Mer","Faucompierre","Faulquemont","Faulx","Faumont","Fauquembergues","Fauville-en-Caux","Favars","Faverges","Faverges-de-la-Tour","Faverolles-la-Campagne","Faverolles-sur-Cher","Favieres","Fay-aux-Loges","Fay-de-Bretagne","Fay-les-Nemours","Fayence","Fayet-le-Chateau","Fayl-Billot","Fays-la-Chapelle","Fayssac","Feas","Fechain","Fegersheim","Fegreac","Feigeres","Feignies","Feillens","Fein","Feissons-sur-Isere","Feldkirch","Felines","Felix","Fellering","Felletin","Fenain","Fenay","Fendeille","Fenetrange","Feneu","Feneyrols","Fenioux","Fenouillet","Fere-Champenoise","Fere-en-Tardenois","Ferel","Ferfay","Fericy","Ferin","Fermanville","Ferney-Voltaire","Ferolles-Attilly","Ferques","Ferrals-les-Corbieres","Ferreol","Ferrette","Ferreux-Quincey","Ferriere-la-Grande","Ferriere-la-Petite","Ferriere-Larcon","Ferrieres","Ferrieres-en-Brie","Ferrieres-en-Gatinais","Ferrieres-Haut-Clocher","Ferrieres-les-Scey","Ferrieres-sur-Ariege","Fesches-le-Chatel","Fesques","Fessenheim","Festieux","Festubert","Feternes","Feucherolles","Feuges","Feuguerolles-sur-Seulles","Feuilla","Feuquieres","Feuquieres-en-Vimeu","Feurs","Feves","Fey","Feytiat","Feyzin","Fiefs","Fiennes","Fierville-Bray","Fierville-les-Mines","Figanieres","Figeac","Fignieres","Filain","Fille","Fillievres","Fillinges","Filstroff","Finhan","Firmi","Firminy","Fislis","Fismes","Fitilieu","Fitz-James","Flagnac","Flamanville","Flamarens","Flancourt-Catelon","Flangebouche","Flaucourt","Flaux","Flavacourt","Flavigny","Flavigny-sur-Moselle","Flavin","Flavy-le-Martel","Flaxlanden","Flayosc","Fleac","Flechin","Flee","Flers","Flers-en-Escrebieux","Flers-sur-Noye","Fletrange","Fletre","Fleurance","Fleurbaix","Fleure","Fleurey-sur-Ouche","Fleurie","Fleuriel","Fleury","Fleury-en-Biere","Fleury-les-Aubrais","Fleury-Merogis","Fleury-sur-Andelle","Fleury-sur-Orne","Fleville-devant-Nancy","Flevy","Flines-les-Mortagne","Flines-lez-Raches","Flins-sur-Seine","Flixecourt","Floing","Floirac","Florac","Florange","Florensac","Florent-en-Argonne","Florentin","Floyon","Flumet","Foameix-Ornel","Foecy","Foissiat","Foix","Folelli","Folembray","Folgensbourg","Follainville-Dennemont","Folles","Folleville","Folschviller","Fonbeauzard","Foncine-le-Haut","Fondettes","Fons","Fonsorbes","Font-Romeu-Odeillo-Via","Fontain","Fontaine","Fontaine-au-Bois","Fontaine-Bonneleau","Fontaine-en-Dormois","Fontaine-Etoupefour","Fontaine-Guerin","Fontaine-Heudebourg","Fontaine-la-Mallet","Fontaine-le-Comte","Fontaine-le-Dun","Fontaine-le-Pin","Fontaine-les-Bassets","Fontaine-les-Dijon","Fontaine-les-Gres","Fontaine-les-Luxeuil","Fontaine-Milon","Fontaine-Notre-Dame","Fontaine-Simon","Fontaine-sous-Jouy","Fontaine-sous-Preaux","Fontaine-sur-Somme","Fontaine-Uterte","Fontainebleau","Fontaines","Fontaines-Saint-Martin","Fontaines-sur-Saone","Fontanes","Fontanil-Cornillon","Fontannes","Fontcouverte","Fontenai-les-Louvets","Fontenay","Fontenay-aux-Roses","Fontenay-en-Parisis","Fontenay-le-Comte","Fontenay-le-Fleury","Fontenay-le-Vicomte","Fontenay-sous-Bois","Fontenay-sur-Loing","Fontenay-sur-Vegre","Fontenay-Tresigny","Fontenelle-en-Brie","Fontenilles","Fontenoy","Fontenoy-la-Joute","Fontenoy-le-Chateau","Fontes","Fontjoncouse","Fontpedrosa","Fontrabiouse","Fontvannes","Fontvieille","Forbach","Forcalqueiret","Forcalquier","Force","Forest-sur-Marque","Foret-la-Folie","Forfry","Forges","Forges-les-Bains","Forges-les-Eaux","Forleans","Formerie","Fors","Fort-Mahon-Plage","Fort-Mardyck","Fortschwihr","Fos-sur-Mer","Fosse","Fossemanant","Fosses","Fosses-et-Baleyssac","Fouchy","Fouday","Fouencamps","Fouesnant","Foug","Fougax-et-Barrineuf","Fougere","Fougeres","Fougeres-sur-Bievre","Fougerolles","Fouillard","Fouilleuse","Foulangues","Foulayronnes","Foulcrey","Fouquebrune","Fouquieres-les-Lens","Four","Fouras","Fourchambault","Fourches","Fourdrinoy","Fourg","Fourmies","Fournes-en-Weppes","Fournier","Fournival","Fournols","Fouronnes","Fourques","Fourques-sur-Garonne","Fourqueux","Fours-Saint-Laurent","Foussemagne","Fragnes","Fraisans","Fraisses","Fraize","Fralignes","Frambouhans","Framerville-Rainecourt","Francaltroff","Francardo","Francheleins","Francheville","Francieres","Franclens","Francois","Franconville","Francourville","Frangy","Franois","Franqueville","Franvillers","Franxault","Frauenberg","Frebuans","Frechede","Frechencourt","Frechou","Fredille","Fregimont","Fregouville","Freistroff","Frejairolles","Freland","Frelinghien","Fremainville","Fremifontaine","Fremonville","Frencq","Frenes","Freneuse","Frepillon","Fresnay-en-Retz","Fresnay-le-Gilmert","Fresnay-sur-Sarthe","Fresne","Fresne-Cauverville","Fresne-la-Mere","Fresne-Saint-Mames","Fresneaux-Montchevreuil","Fresnes","Fresnes-au-Mont","Fresnes-en-Woevre","Fresnes-les-Montauban","Fresnes-sur-Escaut","Fresnes-sur-Marne","Fresnicourt-le-Dolmen","Fresnoy-la-Riviere","Fresnoy-le-Grand","Frespech","Fressac","Fressain","Fresse","Fresse-sur-Moselle","Fressenneville","Fressies","Fressines","Frethun","Fretigney-et-Velloreille","Fretin","Frevent","Frevillers","Frevin-Capelle","Friauville","Frieres-Faillouel","Friesen","Friville-Escarbotin","Frocourt","Froges","Froidestrees","Froidfond","Froissy","Fromelles","Fromont","Fromonville","Froncles","Fronsac","Frontenac","Frontenas","Frontenay-Rohan-Rohan","Frontenay-sur-Dive","Frontenex","Frontignan","Frontignan-Saves","Fronton","Frontonas","Frossay","Frouard","Frouzins","Frozes","Frucourt","Frugeres-les-Mines","Fruges","Fuisse","Fultot","Fumay","Fumel","Furchhausen","Furiani","Fussy","Fuveau","Fye","Gaas","Gabaston","Gabat","Gace","Gagnac-sur-Garonne","Gagnieres","Gagny","Gahard","Gailhan","Gaillac","Gaillac-Toulza","Gaillan-en-Medoc","Gaillard","Gaillefontaine","Gaillon","Galametz","Galapian","Galargues","Galfingue","Galgon","Galie","Gallardon","Gallician","Galluis","Gamaches","Gamarde-les-Bains","Gambais","Gambsheim","Gan","Ganac","Gandrange","Ganges","Gannat","Gap","Garancieres-en-Drouais","Garanou","Garat","Garche","Garches","Garchizy","Gardanne","Gardonne","Garencieres","Garennes-sur-Eure","Gareoult","Gargenville","Garlan","Garlin","Garons","Garrevaques","Garrigues","Garris","Garrosse","Gas","Gasny","Gassin","Gasville-Oiseme","Gatelles","Gatey","Gattieres","Gauchy","Gauciel","Gauriac","Gauriaguet","Gauville-la-Campagne","Gavarnie","Gavray","Gaye","Geanges","Geaune","Geay","Gee","Geispolsheim","Gelannes","Gelles","Gelos","Geloux","Gemeaux","Gemenos","Gemil","Gemozac","Genac","Genas","Genay","Gencay","Gendrey","Gene","Genebrieres","Genech","Genelard","Generac","Generargues","Genet","Geneuille","Geney","Genille","Genis","Genissac","Genissiat","Genissieux","Genlis","Gennes","Gennes-sur-Seiche","Gennetines","Gennevilliers","Gensac","Gensac-la-Pallue","Gente","Gentilly","Georges","Geovreisset","Ger","Gerard","Gerbaix","Gerbecourt-et-Haplemont","Gerbeviller","Gergy","Gerland","Germaine","Germainville","Germenay","Germigny-sur-Loire","Germond-Rouvre","Gerstheim","Gervais","Gervans","Gerzat","Gesnes-le-Gandelin","Geste","Gestel","Gesvres","Getigne","Geudertheim","Geveze","Gevrey-Chambertin","Gevrieux","Gex","Geyssans","Gezaincourt","Gezoncourt","Ghisonaccia","Ghyvelde","Giat","Giberville","Gidy","Gien","Gieres","Gievres","Gif-sur-Yvette","Gigean","Gignac","Gignac-la-Nerthe","Gigny-sur-Saone","Gilette","Gilles","Gilley","Gilly-les-Citeaux","Gilly-sur-Isere","Gimbrett","Gimeux","Gimont","Ginasservis","Ginestas","Ginestet","Girancourt","Giraumont","Girolles","Giromagny","Giron","Gironcourt-sur-Vraine","Gironde-sur-Dropt","Giroussens","Gisors","Givenchy-en-Gohelle","Givet","Givors","Givraines","Givrand","Givrauval","Givron","Givry","Glanon","Glatigny","Gleize","Glenic","Glomel","Glos-sur-Risle","Goderville","Godewaersvelde","Goersdorf","Goes","Goetzenbruck","Goeulzin","Goin","Goincourt","Golbey","Golfe-Juan","Gombergean","Gomelange","Gomene","Gomer","Gometz-la-Ville","Gometz-le-Chatel","Gommegnies","Gommerville","Goncelin","Gondecourt","Gondeville","Gondrecourt-le-Chateau","Gondreville","Gonesse","Gonfaron","Gonfreville-Caillot","Gonfreville-lOrcher","Gonnehem","Gonneville-la-Mallet","Gonneville-sur-Mer","Gontier","Gorbio","Gorcy","Gordes","Gorges","Gornac","Gorre","Gorron","Gorze","Gosnay","Gosselming","Gottenhouse","Gouaix","Gouaux","Goudelin","Goudourville","Gouesnach","Gouesnou","Gouezec","Gouillons","Gouise","Goulet","Goult","Goupillieres","Gourdan-Polignan","Gourdon","Gourge","Gourhel","Gourin","Gourlizon","Gournay-en-Bray","Gournay-sur-Marne","Gourvillette","Goury","Goussainville","Gousse","Goutrens","Gouts","Gouttieres","Gouvernes","Gouves","Gouvieux","Gouville-sur-Mer","Goux-les-Dambelin","Goux-les-Usiers","Gouy-en-Artois","Gouy-en-Ternois","Gouy-Saint-Andre","Gouy-sous-Bellonne","Gouze","Gouzeaucourt","Goven","Goxwiller","Goyrans","Grabels","Gracay","Graces","Gradignan","Gragnague","Graincourt-les-Havrincourt","Grainville","Grainville-la-Teinturiere","Grainville-sur-Odon","Graissessac","Gramat","Grammond","Grand","Grand Champ","Grand-Auverne","Grand-Charmont","Grand-Fort-Philippe","Grand-Fougeray","Grand-Laviers","Grand-Rozoy","Grandchamp","Grandchamps-des-Fontaines","Grande-Synthe","Grandfontaine","Grandfontaine-Fournets","Grandfresnoy","Grandpre","Grandris","Grandsaigne","Grandvaux","Grandvillars","Grandville-Gaudreville","Grandvillers","Grandvilliers","Grane","Granges","Granges-le-Bourg","Granges-sur-Vologne","Grangues","Grans","Granville","Grasse","Grassendorf","Gratentour","Gratot","Graulhet","Grauves","Gravelines","Graveron-Semerville","Graveson","Gravigny","Gray","Grazac","Grazay","Greasque","Gremecey","Gremevillers","Gremonville","Grenade","Grenay","Greneville-en-Beauce","Grenoble","Grentheville","Grentzingen","Greolieres","Greoux-les-Bains","Grepiac","Gresse-en-Vercors","Gresswiller","Gressy","Gresy-sur-Aix","Gresy-sur-Isere","Gretz-Armainvilliers","Grez-en-Bouere","Grez-sur-Loing","Grezieu-la-Varenne","Grezillac","Grezolles","Gries","Griesbach-au-Val","Griesheim-pres-Molsheim","Grignan","Grignols","Grigny","Grillon","Grilly","Grimaud","Gripport","Griselles","Grisolles","Grisy-Suisnes","Grisy-sur-Seine","Grivillers","Groffliers","Groissiat","Groisy","Groix","Gron","Gros-Rederching","Grosbliederstroff","Grosbreuil","Groslay","Grosrouvre","Grosseto-Prugna","Grossoeuvre","Grozon","Gruchet-le-Valasse","Gruey-les-Surance","Gruffy","Grugies","Gruissan","Grun-Bordas","Grundviller","Gruson","Grussenheim","Guebwiller","Guecelard","Guegon","Guemar","Guemene-Penfao","Guemene-sur-Scorff","Guenange","Guengat","Guenin","Guenrouet","Guer","Guerande","Guerard","Guercheville","Gueret","Guerigny","Guerlesquin","Guernes","Guerting","Guerville","Guesnain","Guessling-Hemering","Guethary","Gueugnon","Gueures","Gueux","Guewenheim","Guiche","Guichen","Guiclan","Guidel","Guignen","Guignes","Guigneville","Guignicourt","Guignicourt-sur-Vence","Guiler-sur-Goyen","Guilers","Guilherand-Granges","Guillestre","Guilliers","Guilly","Guilvinec","Guines","Guingamp","Guipavas","Guipel","Guipronvel","Guipry","Guiscard","Guise","Guiseniers","Guitalens","Guivry","Gujan-Mestras","Gumbrechtshoffen","Gundershoffen","Gundolsheim","Guntzviller","Guny","Gurs","Guyancourt","Gy-en-Sologne","Habas","Habere-Lullin","Habsheim","Hadol","Hagenbach","Hagenthal-le-Haut","Hagetmau","Hageville","Hagondange","Haguenau","Haillicourt","Haironville","Haisnes","Hallencourt","Hallennes-lez-Haubourdin","Hallering","Hallines","Halloy-les-Pernois","Halluin","Ham","Ham-en-Artois","Ham-sous-Varsberg","Ham-sur-Meuse","Hamars","Hambach","Hambers","Hamel","Hammeville","Han-sur-Nied","Hanches","Hangenbieten","Hangest-en-Santerre","Hannogne-Saint-Martin","Hantay","Hanvec","Happonvilliers","Haramont","Haraucourt","Harbonnieres","Harcanville","Harcigny","Harcourt","Hardelot-Plage","Hardencourt","Hardifort","Hardinvast","Harfleur","Hargicourt","Hargnies","Harnes","Haroue","Harprich","Harreberg","Harreville-les-Chanteurs","Harskirchen","Hartmannswiller","Hary","Hasnon","Hasparren","Haspres","Hastingues","Hatten","Hattenville","Hattstatt","Haubourdin","Hauconcourt","Haucourt-Moulaine","Haudiomont","Haudivillers","Haulchin","Haussignemont","Haussimont","Haussy","Haut-Clocher","Haute-Goulaine","Haute-Isle","Haute-Rivoire","Haute-Vigneulles","Hautecloque","Hautefage-la-Tour","Hautefort","Hauteluce","Hauterive","Hauterives","Hauteville-les-Dijon","Hauteville-Lompnes","Hauteville-sur-Mer","Hautmont","Hautot-sur-Mer","Hautvillers","Hautvillers-Ouville","Haveluy","Haverskerque","Havrincourt","Hayange","Haybes","Hazebrouck","Hebecourt","Hebecrevon","Hebuterne","Hede-Bazouges","Hegenheim","Heidwiller","Heiligenberg","Heillecourt","Heilly","Heimersdorf","Heimsbrunn","Heiteren","Helesmes","Helette","Helfaut","Hellemmes-Lille","Hellimer","Hem","Hemevillers","Heming","Hemonstoir","Henansal","Hendaye","Henin-Beaumont","Henin-sur-Cojeul","Hennebont","Henon","Henonville","Henouville","Henrichemont","Henridorff","Henvic","Herbeys","Herbignac","Herblay","Herchies","Herepian","Heres","Hergnies","Heric","Hericourt","Hericy","Herimoncourt","Herin","Herisson","Herlies","Hermanville-sur-Mer","Hermelange","Hermeray","Hermes","Hermies","Hermillon","Herny","Herouvillette","Herrlisheim-pres-Colmar","Herserange","Hersin-Coupigny","Hery-sur-Alby","Herzeele","Hesdin","Hesingue","Hestrus","Hettange-Grande","Heuchin","Heudebouville","Heudicourt","Heudicourt-sous-les-Cotes","Heudreville-sur-Eure","Heugas","Heuqueville","Heurtevent","Heutregiville","Heyrieux","Higueres-Souye","Hilbesheim","Hillion","Hindlingen","Hinges","Hipsheim","Hirel","Hirsingue","Hirson","Hochfelden","Hochstatt","Hocquigny","Hodenc-en-Bray","Hodeng-Hodenger","Hoenheim","Hoerdt","Hohfrankenheim","Hohwiller","Holnon","Holtzheim","Holtzwihr","Holving","Hombleux","Homblieres","Hombourg","Hombourg-Budange","Hombourg-Haut","Homecourt","Homps","Hon-Hergies","Hondeghem","Hondouville","Hondschoote","Honfleur","Honnecourt-sur-Escaut","Hopital-Camfrout","Horbourg-Wihr","Hordain","Horgues","Hornaing","Hossegor","Houchin","Houdain-lez-Bavay","Houdan","Houdelmont","Houdemont","Houeilles","Houilles","Houlbec-Cocherel","Houlette","Houlgate","Houlle","Houplin-Ancoisne","Houplines","Houppeville","Hourtin","Houry","Houssen","Housseville","Houville-la-Branche","Houx","Hoymille","Hubersent","Huberville","Huchenneville","Hucqueliers","Hudimesnil","Huelgoat","Huest","Huez","Hugier","Huiron","Huisseau-sur-Cosson","Huisseau-sur-Mauves","Hulluch","Hultehouse","Hundling","Hundsbach","Huningue","Hunspach","Huppy","Hure","Huriel","Hurigny","Husseren-les-Chateaux","Husseren-Wesserling","Hussigny-Godbrange","Huttenheim","Hyemondans","Idrac-Respailles","Idron","Iffendic","Ifs","Igney","Igny","Igon","Igoville","Illange","Ille-sur-Tet","Illfurth","Illhaeusern","Illiat","Illiers-Combray","Illifaut","Illkirch-Graffenstaden","Illois","Illzach","Imling","Imphy","Incheville","Inchy","Indre","Ingersheim","Ingolsheim","Ingrandes","Ingre","Inguiniel","Ingwiller","Innenheim","Inxent","Ippling","Irai","Irancy","Irigny","Irissarry","Irodouer","Irouleguy","Irreville","Is-sur-Tille","Isbergues","Isches","Isigny-le-Buat","Isigny-sur-Mer","Isle","Isle-et-Bardais","Isles-les-Villenoy","Isneauville","Isola","Ispoure","Isques","Issancourt-et-Rumel","Issenhausen","Issenheim","Issoire","Issou","Issoudun","Issus","Issy-les-Moulineaux","Istres","Itancourt","Iteuil","Ittenheim","Itteville","Itxassou","Iville","Ivoy-le-Pre","Ivry-la-Bataille","Ivry-le-Temple","Ivry-sur-Seine","Iwuy","Izeaux","Izernore","Izeron","Izier","Izon","Izotges","Jabreilles-les-Bordes","Jacob-Bellecombette","Jacou","Jainvillotte","Jallais","Jallans","Jallerange","Jalognes","Jalogny","Jalons","Jambles","Jametz","Jandun","Janneyrias","Janville","Janville-sur-Juine","Janvilliers","Janvry","Janze","Jarcieu","Jard-sur-Mer","Jardin","Jardres","Jargeau","Jarmenil","Jarnac-Champagne","Jarnages","Jarny","Jarrie","Jarrier","Jars","Jarville-la-Malgrange","Jarze","Jassans-Riottier","Jasseron","Jaucourt","Jaujac","Jaunay-Clan","Jaure","Jausiers","Jaux","Javene","Javrezac","Jayat","Jazeneuil","Jeandelaincourt","Jeanmenil","Jebsheim","Jegun","Jenlain","Jesonville","Jettingen","Jeu-les-Bois","Jeufosse","Jeumont","Jeune","Jeurre","Jeux-les-Bard","Jeuxey","Jezainville","Job","Jobourg","Joch","Joeuf","Joigny","Joigny-sur-Meuse","Joinville","Joinville-le-Pont","Jolimetz","Jolivet","Jonage","Jonchery-sur-Vesle","Joncourt","Jonquerets-de-Livet","Jonquerettes","Jonquieres","Jons","Jonvelle","Jonvilliers","Jonzac","Jonzier-Epagny","Jonzieux","Josnes","Josse","Josselin","Jossigny","Jouarre","Jouars-Pontchartrain","Jouaville","Joudreville","Joue-sur-Erdre","Jougne","Jouhet","Jouques","Journans","Journiac","Journy","Joux","Jouy-en-Josas","Jouy-le-Chatel","Jouy-le-Moutier","Jouy-le-Potier","Jouy-sous-Thelle","Jouy-sur-Eure","Jouy-sur-Morin","Juan-les-Pins","Jugeals-Nazareth","Jugon-les-Lacs","Juigne-sur-Loire","Juigne-sur-Sarthe","Juillac","Juillan","Juilles","Juilly","Jujurieux","Julienas","Julienne","Jully-sur-Sarce","Jumeauville","Jumelles","Jumilhac-le-Grand","Junay","Jungholtz","Juniville","Jupilles","Jurancon","Jury","Jussey","Jussy","Juvaincourt","Juvignac","Juvigny","Juvigny-en-Perthois","Juville","Juvisy-sur-Orge","Juziers","Kaltenhouse","Kappelen","Katzenthal","Kaysersberg","Kedange-sur-Canner","Kembs","Kerbach","Kerfot","Kerfourn","Kergloff","Kerien","Kerity","Kerlaz","Kerlouan","Kernascleden","Kerpert","Kervignac","Kesseldorf","Kienheim","Kientzheim","Killem","Kilstett","Kingersheim","Kintzheim","Knutange","Koenigsmacker","Koeur-la-Petite","Krafft","Krautergersheim","Kriegsheim","Kruth","Kunheim","Kuntzig","Kurtzenhouse","Kutzenhausen","La Baconniere","La Barben","La Barre-de-Monts","La Barre-en-Ouche","La Barthe","La Bassee","La Bastide","La Bathie","La Batie","La Baule-Escoublac","La Baume-de-Transit","La Baussaine","La Bazoche-Gouet","La Bazoge","La Begue","La Bernerie-en-Retz","La Berthenoux","La Bigne","La Biolle","La Bohalle","La Boissiere-des-Landes","La Bosse","La Bosse-de-Bretagne","La Bouexiere","La Bouilladisse","La Bourboule","La Bourgonce","La Boussac","La Bresse","La Bretonne","La Bridoire","La Brigue","La Brillanne","La Broque","La Brosse","La Bruffiere","La Brulatte","La Buisse","La Buissiere","La Bussiere","La Calmette","La Calotterie","La Canourgue","La Capelle","La Caunette","La Cavalerie","La Celle","La Celle-Saint-Cloud","La Celle-sous-Montmirail","La Celle-sur-Seine","La Cerlangue","La Chaise","La Chaise-Baudouin","La Chaize-le-Vicomte","La Chapelaude","La Chapelle","La Chapelle-aux-Bois","La Chapelle-aux-Lys","La Chapelle-Baton","La Chapelle-Blanche","La Chapelle-de-Brain","La Chapelle-de-Guinchay","La Chapelle-en-Vercors","La Chapelle-Gaudin","La Chapelle-Gauthier","La Chapelle-Heulin","La Chapelle-Laurent","La Chapelle-Montligeon","La Chapelle-Orthemale","La Chapelle-Saint-Luc","La Chapelle-sur-Chezy","La Chapelle-Yvon","La Charme","La Charmee","La Chartre-sur-le-Loir","La Chataigneraie","La Chatre","La Chatre-Langlin","La Chaumusse","La Chaussaire","La Chaussee","La Chaux-du-Dombief","La Cheneviere","La Chevallerais","La Chevroliere","La Ciotat","La Clayette","La Clisse","La Clotte","La Clusaz","La Cluse-et-Mijoux","La Colle-sur-Loup","La Combelle","La Copechagniere","La Coquille","La Cornuaille","La Cote","La Couarde-sur-Mer","La Coucourde","La Coudre","La Coulonche","La Courneuve","La Couronne","La Couture-Boussey","La Crau","La Croix-Valmer","La Cropte","La Dagueniere","La Defense","La Destrousse","La Dominelais","La Fare-en-Champsaur","La Farlede","La Faute-sur-Mer","La Faye","La Fere","La Ferriere","La Ferriere-Bochard","La Ferte","La Ferte-Alais","La Ferte-Mace","La Ferte-Milon","La Ferte-Saint-Cyr","La Ferte-Saint-Samson","La Ferte-sous-Jouarre","La Feuillade","La Feuillie","La Flachere","La Fleche","La Flocelliere","La Flotte","La Force","La Forest-Landerneau","La Foret","La Foret-Fouesnant","La Forie","La Fouillade","La Fouillouse","La Foux","La Foye-Monjault","La Frasse","La Frenaye","La Fresnais","La Frette","La Frette-sur-Seine","La Gacilly","La Gaillarde","La Garde","La Garenne","La Garenne-Colombes","La Garnache","La Gaubretiere","La Gaude","La Gavotte","La Glacerie","La Gorgue","La Gouesniere","La Grand-Croix","La Grande-Motte","La Grandville","La Grave","La Graverie","La Gree-Saint-Laurent","La Greve-sur-Mignon","La Grigonnais","La Groise","La Guerche","La Guerche-de-Bretagne","La Gueroulde","La Guierche","La Guyonniere","La Haie","La Halle","La Hallotiere","La Haye","La Haye-Saint-Sylvestre","La Houblonniere","La Houssaye-en-Brie","La Houssoye","La Jaille-Yvon","La Jarne","La Jarrie","La Jubaudiere","La Jumelliere","La Laigne","La Lande","La Landec","La Laupie","La Lechere","La Limouziniere","La Liviniere","La Londe","La Londe-les-Maures","La Loubiere","La Loupe","La Lucerne-dOutremer","La Machine","La Madeleine","La Madeleine-sur-Loing","La Magdelaine-sur-Tarn","La Mailleraye-sur-Seine","La Malhoure","La Marche","La Marolle-en-Sologne","La Martiniere","La Maxe","La Meauffe","La Meaugon","La Meignanne","La Meilleraie-Tillay","La Meilleraye-de-Bretagne","La Membrolle-sur-Choisille","La Membrolle-sur-Longuenee","La Menitre","La Meziere","La Milesse","La Montagne","La Mothe-Saint-Heray","La Motte","La Motte-Chalancon","La Motte-du-Caire","La Motte-Fouquet","La Motte-Saint-Jean","La Motte-Saint-Martin","La Motte-Servolex","La Mulatiere","La Muraz","La Mure","La Napoule","La Nerthe","La Neuveville-devant-Lepanges","La Neuville-du-Bosc","La Noe","La Norville","La Palud","La Paute","La Penne-sur-Huveaune","La Perche","La Place","La Plagne","La Plaine","La Plaine-Saint-Denis","La Planche","La Plane","La Pointe","La Poiteviniere","La Pommeraye","La Porcherie","La Porte","La Possonniere","La Poste","La Poterie","La Poterie-Mathieu","La Poueze","La Puye","La Queue-en-Brie","La Queue-les-Yvelines","La Ravoire","La Remuee","La Renaudiere","La Reole","La Reorthe","La Ricamarie","La Richardais","La Riche","La Riviere","La Riviere-de-Corps","La Rixouse","La Roche","La Roche-Blanche","La Roche-des-Arnauds","La Roche-sur-le-Buis","La Roche-sur-Yon","La Rochefoucauld","La Rochegiron","La Rochelle","La Rochenard","La Rochette","La Rochette-sur-Crest","La Romagne","La Ronde","La Roque-Baignard","La Roquebrussanne","La Roquette-sur-Siagne","La Rouine","La Rouquette","La Rouviere","La Salette-Fallavaux","La Salle-de-Vihiers","La Salvetat-Lauragais","La Salvetat-Saint-Gilles","La Salvetat-sur-Agout","La Saulce","La Sauve","La Sauvetat-de-Saveres","La Seauve-sur-Semene","La Seguiniere","La Selle-en-Hermoy","La Selve","La Sentinelle","La Seyne-sur-Mer","La Sone","La Souche","La Souterraine","La Suze-sur-Sarthe","La Tagniere","La Taillee","La Talaudiere","La Tardiere","La Terrasse","La Tessoualle","La Teste-de-Buch","La Tour","La Tour-dAuvergne","La Tour-de-Scay","La Tour-du-Crieu","La Tour-Saint-Gelin","La Tour-sur-Orb","La Tourette","La Tranche-sur-Mer","La Treille","La Tremblade","La Trimouille","La Trinite","La Trinite-de-Reville","La Tronche","La Tuiliere","La Turballe","La Turbie","La Vacherie","La Valette-du-Var","La Vallee de Dormelles","La Varenne","La Vaupaliere","La Verpilliere","La Verrie","La Verriere","La Vespiere","La Veze","La Ville","La Ville aux Chiens","La Ville-aux-Bois","La Villedieu","La Villedieu-les-Quenoche","La Villeneuve","La Villetelle","La Voulte-sur-Rhone","La Vraie-Croix","La Walck","La Wantzenau","Laas","Labaroche","Labarthe-sur-Leze","Labastide-Beauvoir","Labastide-Cezeracq","Labastide-dArmagnac","Labastide-de-Virac","Labastide-Gabausse","Labastide-Rouairoux","Labastide-Saint-Pierre","Labastidette","Labatut","Labege","Labenne","Labessiere-Candeil","Labeuvriere","Lablachere","Labouheyre","Labouquerie","Labourse","Labretonie","Labruguiere","Labruyere","Labry","Labuissiere","Lacabarede","Lacadee","Lacanau","Lacapelle-Cabanac","Lacapelle-Marival","Lacapelle-Viescamp","Lacaune","Lacaussade","Lachapelle","Lachapelle-sous-Chaux","Lachapelle-sous-Rougemont","Lachaux","Lacour","Lacq","Lacroix-Falgarde","Lacroix-Saint-Ouen","Lacroix-sur-Meuse","Lacrost","Lacs","Ladoix-Serrigny","Ladon","Laduz","Lafare","Lafeuillade-en-Vezie","Lafitole","Lafox","Lagardelle-sur-Leze","Lagardere","Lagarrigue","Lagnes","Lagnieu","Lagny-le-Sec","Lagor","Lagord","Lagrave","Laguenne","Laguiole","Lagupie","Lahitte-Toupiere","Lahonce","Lahontan","Lahosse","Lahourcade","Laifour","Laigne","Laigne-en-Belin","Laignelet","Laignes","Laigneville","LAiguillon-sur-Mer","Laille","Lailly-en-Val","Lainsecq","Laissac","Laissaud","Laissey","Laiz","Laize","Lalanne-Arque","Lalbenque","Laleu","Lalinde","Lallaing","Lalonquette","Laloubere","Lamagdelaine","Lamagistere","Lamaire","Lamalou-les-Bains","Lamanon","Lamarche","Lamarche-sur-Saone","Lamastre","Lamativie","Lamaziere-Basse","Lamballe","Lambersart","Lambert","Lambesc","Lambres-lez-Douai","Lamnay","Lamorlaye","Lamorville","Lamothe-Landerron","Lamothe-Montravel","Lamotte-Beuvron","Lampaul-Guimiliau","Lampaul-Plouarzel","Lampertheim","Lampertsloch","Lancey","Lancie","Lancieux","Lancon-Provence","Lancrans","Landas","Landebia","Landeda","Landelles","Landelles-et-Coupigny","Landemont","Landepereuse","Landerneau","Landeronde","Landes","Landevant","Landevieille","Landivisiau","Landogne","Landos","Landrecies","Landres","Landrethun-le-Nord","Landrethun-les-Ardres","Landrevarzec","Landry","Landser","Landujan","Landunvez","Lanester","Laneuvelotte","Laneuveville-aux-Bois","Laneuveville-devant-Bayon","Laneuveville-devant-Nancy","Langan","Langeac","Langeais","Langensoultzbach","Langlade","Langoat","Langoelan","Langoiran","Langolen","Langon","Langonnet","Langourla","Langres","Langrune-sur-Mer","Langueux","Languidic","Lanhelin","Laning","Lanleff","Lanmerin","Lanmeur","Lanne","Lanne-en-Baretous","Lannebert","Lannemezan","Lannilis","Lannion","Lannoy","Lannoy-Cuillere","Lanobre","Lanouee","Lanrelas","Lanrodec","Lans","Lans-en-Vercors","Lansac","Lansargues","Lanta","Lantenne-Vertiere","Lanthenans","Lantignie","Lantilly","Lanton","Lantriac","Lanvallay","Lanvaudan","Lanveoc","Lanvollon","Lanzac","Laon","Lapalisse","Lapalme","Lapalud","Laparrouquial","Lapenche","Laperriere-sur-Saone","Lapeyrouse-Fossat","Lapeyrouse-Mornay","Lapoutroie","Lapouyade","Lapte","Lapugnoy","Laquenexy","Laqueuille","Laragne-Monteglin","LArbresle","Larcay","Larchant","Larche","Lardy","Largeasse","Largillay-Marsonnay","Lariviere-Arnoncourt","Larmor-Baden","Larmor-Plage","Laroche-Saint-Cydroine","Laroin","Laroque-de-Fa","Larrazet","Larressore","Larriviere-Saint-Savin","Laruns","Larzicourt","Lasalle","Lasbordes","Lassay-les-Chateaux","Lassay-sur-Croisne","Lasseran","Lasserre","Lasseube","Lassigny","Lasson","Lassy","Lastic","Lathuile","Latille","Latour","Latour-Bas-Elne","Latresne","Latronquiere","Lattainville","Lattes","Lattre-Saint-Quentin","Laudun-lArdoise","Laugnac","Launaguet","Launay","Laurabuc","Laure","Laurede","Laurenan","Laurens","Laurent","Lauret","Lauris","Laussonne","Lautenbach","Lauterbourg","Lautrec","Lauzerte","Lauzerville","Lauzun","Laval","Laval-sur-Doulon","Laval-sur-Vologne","Lavannes","Lavans-les-Saint-Claude","Lavans-Vuillafans","Lavardac","Lavardens","Lavardin","Lavau","Lavaur","Lavaurette","Lavelanet","Laventie","Lavergne","Lavernose-Lacasse","Laversine","Laversines","Laverune","Lavit","Lavours","Lavoute-Chilhac","Laxou","Laye","Layrac","Layrisse","Le Baizil","Le Ban-Saint-Martin","Le Bar-sur-Loup","Le Barboux","Le Barcares","Le Bardon","Le Barp","Le Beausset","Le Bernard","Le Bessat","Le Bez","Le Bignon","Le Blanc","Le Blanc-Mesnil","Le Bleymard","Le Bocasse","Le Bois","Le Bois-Plage-en-Re","Le Bonhomme","Le Bono","Le Bosc","Le Bosc-Roger-en-Roumois","Le Bouchage","Le Boulay-Morin","Le Boupere","Le Bourg","Le Bourget","Le Bourgneuf-la-Foret","Le Bouscat","Le Bousquet","Le Breil","Le Breuil","Le Breuil-sur-Couze","Le Broc","Le Brugeron","Le Buisson-de-Cadouin","Le Cailar","Le Cannet","Le Castellet","Le Castera","Le Cateau-Cambresis","Le Caylar","Le Cellier","Le Cendre","Le Cergne","Le Chambon","Le Champ-pres-Froges","Le Champ-Saint-Pere","Le Chateau","Le Chateau Gaillard","Le Chatel","Le Chatelard","Le Chatelet-en-Brie","Le Chatelet-sur-Retourne","Le Chaylard","Le Chesnay","Le Chesne","Le Cheylas","Le Collet-de-Deze","Le Comte","Le Conquet","Le Coteau","Le Coudray","Le Coudray-Baillet","Le Coudray-Montceaux","Le Cres","Le Crest","Le Creusot","Le Croisic","Le Crotoy","Le Deluge","Le Deschaux","Le Dezert","Le Donjon","Le Dorat","Le Doulieu","Le Falgoux","Le Faou","Le Faouet","Le Fayet","Le Fenouiller","Le Ferre","Le Fidelaire","Le Fief-Sauvin","Le Foeil","Le Folgoet","Le Fossat","Le Fousseret","Le Fraysse","Le Fresne-Camilly","Le Fuilet","Le Garric","Le Gavre","Le Gond","Le Grand Village","Le Grand-Bornand","Le Grand-Pressigny","Le Grand-Quevilly","Le Gratteris","Le Grau-du-Roi","Le Gua","Le Guerno","Le Guildo","Le Haillan","Le Havre","Le Herie-la-Vieville","Le Hohwald","Le Houlme","Le Kremlin-Bicetre","Le Landin","Le Landreau","Le Lardin-Saint-Lazare","Le Lavandou","Le Lez","Le Longeron","Le Loroux","Le Loroux-Bottereau","Le Louroux-Beconnais","Le Luart","Le Luc","Le Lude","Le Manoir","Le Mans","Le Marillais","Le Martinet","Le Mas","Le May-sur-Evre","Le Mayet","Le Mazeau","Le Mee-sur-Seine","Le Meix-Saint-Epoing","Le Mele-sur-Sarthe","Le Menil","Le Meriot","Le Merlerault","Le Mesnil-Amelot","Le Mesnil-en-Thelle","Le Mesnil-en-Vallee","Le Mesnil-Esnard","Le Mesnil-Fuguet","Le Mesnil-le-Roi","Le Mesnil-Ozenne","Le Mesnil-Vigot","Le Mesnil-Villeman","Le Meux","Le Molard","Le Molay","Le Monastier-Pin-Mories","Le Monastier-sur-Gazeille","Le Mont-Dore","Le Monteil","Le Montel","Le Muy","Le Neubourg","Le Noyer","Le Palais","Le Pallet","Le Parc","Le Parcq","Le Passage","Le Pecq","Le Pellerin","Le Perray-en-Yvelines","Le Perreux-sur-Marne","Le Perrier","Le Petit-Quevilly","Le Pian-sur-Garonne","Le Pin","Le Pin-la-Garenne","Le Pizou","Le Plan-de-la-Tour","Le Planois","Le Plessier-sur-Bulles","Le Plessis","Le Plessis-Belleville","Le Plessis-Bouchard","Le Plessis-Grammoire","Le Plessis-Hebert","Le Plessis-Pate","Le Plessis-Robinson","Le Plessis-Trevise","Le Poet","Le Poet-Laval","Le Poinconnet","Le Poire-sur-Velluire","Le Pont","Le Pont-de-Claix","Le Pontet","Le Porge","Le Port","Le Port-Marly","Le Portel","Le Pouget","Le Pouliguen","Le Pout","Le Pouzin","Le Pradet","Le Pre-Saint-Gervais","Le Puy","Le Puy-en-Velay","Le Puy-Sainte-Reparade","Le Quesnel","Le Quesnoy","Le Raincy","Le Relecq-Kerhuon","Le Renouard","Le Revest-les-Eaux","Le Rheu","Le Roncenay-Authenay","Le Rouget","Le Rouret","Le Rove","Le Sacq","Le Sap","Le Segur","Le Soler","Le Sourn","Le Syndicat","Le Taillan-Medoc","Le Tallud","Le Teich","Le Teil","Le Teilleul","Le Temple-de-Bretagne","Le Theil","Le Theil-de-Bretagne","Le Thieulin","Le Thillay","Le Thillot","Le Tholonet","Le Tholy","Le Thor","Le Thou","Le Thoureil","Le Thuit-Signol","Le Thuit-Simer","Le Tignet","Le Torquesne","Le Touquet-Paris-Plage","Le Tourne","Le Tourneur","Le Touvet","Le Trait","Le Treport","Le Trevoux","Le Tronchet","Le Tronquay","Le Val","Le Val-dAjol","Le Vaudioux","Le Vaudreuil","Le Vaumain","Le Verger","Le Vernet","Le Versoud","Le Vesinet","Le Vieux","Le Vieux Bourg","Le Vigan","Le Vigean","Le Vigeant","Le Vigen","Le Vivier-sur-Mer","Le Voide","Lealvillers","Leaz","Lecelles","Lechatelet","Lechelle","Lecousse","Lectoure","Ledenon","Lederzeele","Leers","Leffincourt","Leffrinckoucke","Leforest","Lege","Lege-Cap-Ferret","Leguevin","Lehon","Leigneux","Leintrey","Lelling","Lemainville","Lembach","Lemberg","Leme","Lemmes","Lempdes","Lempdes-sur-Allagnon","Lemps","Lencloitre","Lennon","Lenoncourt","Lens","Lens-Lestang","Lent","Lentigny","Lentilly","Lentiol","Leojac","Leon","Leouville","Lepin-le-Lac","Lepuix","Lepuy","Lere","Lery","Les Abrets","Les Ageux","Les Alleuds","Les Allies","Les Allues","Les Ancizes-Comps","Les Andelys","Les Angles","Les Arcs","Les Ardillats","Les Artigues-de-Lussac","Les Assions","Les Aubiers","Les Avanchers-Valmorel","Les Avenieres","Les Bains","Les Baux de Provence","Les Baux-de-Breteuil","Les Billanges","Les Bordes","Les Bordes-sur-Lez","Les Breviaires","Les Brouzils","Les Cabanes","Les Cabannes","Les Cars","Les Champs","Les Chapelles","Les Charmontois","Les Cheres","Les Clayes-sous-Bois","Les Clouzeaux","Les Combes","Les Deux-Fays","Les Echelles","Les Ecrennes","Les Eglisottes-et-Chalaures","Les Eparres","Les Epesses","Les Essards","Les Essards-Taignevaux","Les Essarts","Les Etangs","Les Eyzies-de-Tayac-Sireuil","Les Fins","Les Fontaines","Les Fonts","Les Forges","Les Fourgs","Les Gets","Les Gours","Les Grands-Chezeaux","Les Granges","Les Gras","Les Halles","Les Hays","Les Herbiers","Les Hogues","Les Hopitaux-Vieux","Les Hotelleries","Les Houches","Les Jumeaux","Les Landes","Les Landes-Genusson","Les Laumes","Les Lilas","Les Loges","Les Loges-en-Josas","Les Lucs-sur-Boulogne","Les Mages","Les Marches","Les Martres","Les Mathes","Les Maures","Les Mees","Les Mesneux","Les Mesnuls","Les Milles","Les Moitiers-en-Bauptois","Les Molieres","Les Montils","Les Mureaux","Les Nouillers","Les Ollieres-sur-Eyrieux","Les Olmes","Les Ormes","Les Ormes-sur-Voulzie","Les Palais","Les Pavillons-sous-Bois","Les Peintures","Les Pennes-Mirabeau","Les Petites Loges","Les Pieux","Les Pineaux","Les Pins","Les Places","Les Rives","Les Rivieres-Henruel","Les Roches","Les Rosiers","Les Rosiers-sur-Loire","Les Rousses","Les Sables","Les Sauvages","Les Sorinieres","Les Taillades","Les Thilliers-en-Vexin","Les Touches","Les Vallees","Les Vans","Les Varennes","Les Vigneaux","Les Villedieu","Lescar","Lescheraines","Lescherolles","Lesches","Lesconil","Lescout","Lescure","Lesdain","Lesigny","Lesneven","Lespesses","Lespielle","Lespignan","Lespinasse","Lesquin","Lessay","Lesse","Lessy","Lestelle-Betharram","Lestiou","Lestrem","Letanne","Letricourt","Leuc","Leucate","Leudeville","Leugny","Leuilly-sous-Coucy","Leuville-sur-Orge","Leuvrigny","Levainville","Leval","Levallois-Perret","Levens","Levernois","Leves","Levet","Levie","Levier","Levignacq","Levis","Levroux","Lewarde","Lexy","Leyme","Leyr","Leyrieu","Leysse","Lezan","Lezardrieux","Lezat-sur-Leze","Lezay","Lezennes","Lezignan-Corbieres","Lezigne","Lezigneux","Lezoux","Lheraule","Lherm","Lhommaize","Lhuis","Liancourt","Liancourt-Saint-Pierre","Liart","Libercourt","Libourne","Licques","Liepvre","Lieramont","Liergues","Liernais","Lieu-Saint-Amand","Lieuran-les-Beziers","Lieurey","Lieuron","Lieusaint","Lieuvillers","Liffol-le-Grand","Liffre","Ligescourt","Lignan-sur-Orb","Ligne","Lignerolles","Lignieres-Chatelain","Lignieres-la-Carelle","Lignol","Ligny-en-Barrois","Ligny-en-Cambresis","Ligny-le-Chatel","Ligny-le-Ribault","Ligsdorf","Ligueil","Liguge","Lihons","Lihus","Lille","Lillebonne","Lillers","Limas","Limay","Limeil-Brevannes","Limeray","Limersheim","Limerzel","Limesy","Limetz-Villez","Limoges","Limoges-Fourches","Limogne-en-Quercy","Limonest","Limony","Limours","Limoux","Linars","Linas","Lincel","Lingolsheim","Lingreville","Linselles","Linxe","Liocourt","Lion-en-Sullias","Lion-sur-Mer","Liouc","Lipsheim","Lire","Lisieux","Lisle","LIsle-dEspagnac","LIsle-sur-le-Doubs","Lisle-sur-Tarn","Lisors","Lisses","Lissieu","Lissy","Lit-et-Mixe","Livarot","Liverdun","Liverdy-en-Brie","Livernon","Livet-et-Gavet","Livet-sur-Authou","Livinhac-le-Haut","Livre-sur-Changeon","Livron","Livron-sur-Drome","Livry-Gargan","Livry-sur-Seine","Lixhausen","Lixheim","Lizac","Lizy-sur-Ourcq","Llupia","Loche","Loche-sur-Indrois","Locmaria-Grand-Champ","Locmaria-Plouzane","Locmariaquer","Locmine","Locmiquelic","Locoal-Mendon","Locon","Locquemeau","Locquirec","Loctudy","Loge-Fougereuse","Logelbach","Logelheim","Lognes","Logonna-Daoulas","Logonna-Quimerch","Logrian-Florian","Lohr","Loire","Loire-les-Marais","Loire-sur-Rhone","Loiron","Loisin","Loison-sous-Lens","Loisy","Loisy-sur-Marne","Loix","Lokmaria","Lombers","Lombez","Lombron","Lomme","Lommerange","Lompret","Londigny","Londinieres","Longages","Longchamp","Longchamp-sous-Chatenois","Longeault","Longecourt-en-Plaine","Longes","Longessaigne","Longevelle-sur-Doubs","Longeves","Longeville-en-Barrois","Longeville-les-Metz","Longeville-les-Saint-Avold","Longeville-sur-Mer","Longfosse","Longjumeau","Longlaville","Longnes","Longpont-sur-Orge","Longpre-les-Corps-Saints","Longue-Jumelles","Longueau","Longueil-Annel","Longueil-Sainte-Marie","Longuenesse","Longueville","Longueville-sur-Scie","Longuyon","Longvic","Longwy","Lons","Lons-le-Saunier","Loon-Plage","Loos","Loos-en-Gohelle","Loperhet","Lorcieres","Lorette","Lorey","Lorgies","Lorgues","Lorient","Lorignac","Loriol-du-Comtat","Loriol-sur-Drome","Lorlanges","Lormaison","Lormaye","Lormont","Lorquin","Lorrez-le-Bocage-Preaux","Lorris","Lorry-Mardigny","Los Masos","Losne","Louailles","Louannec","Louargat","Louatre","Loubaresse","Loubes-Bernac","Loubeyrat","Loubieng","Loubigne","Loubille","Loudeac","Loudes","Loudrefing","Loudun","Loue","Louer","Lougres","Louhans","Loupershouse","Loupes","Loupiac-de-la-Reole","Loupian","Louplande","Lourches","Lourdes","Lourenties","Loures-Barousse","Louresse-Rochemenier","Lourmarin","Lourties-Monbrun","Loury","Louveciennes","Louvemont","Louverne","Louvie-Juzon","Louviers","Louvigne-de-Bais","Louvignies-Quesnoy","Louvigny","Louvil","Louvrechy","Louvres","Louvroil","Louzouer","Louzy","Lovagny","Loyat","Loyes","Loyettes","Lozanne","Lozinghem","Lozon","Luant","Lubersac","Luc","Luc-sur-Mer","Luc-sur-Orbieu","Lucciana","Luce","Luceau","Lucenay","Lucey","Luchy","Lucon","Lucq-de-Bearn","Lucy-sur-Cure","Ludon-Medoc","Ludres","Luemschwiller","Lugny-Champagne","Lugny-les-Charolles","Lugrin","Luisant","Luitre","Lullin","Lully","Lumbin","Lumbres","Lumeau","Lumio","Lunel","Lunel-Viel","Luneray","Lupe","Luppy","Lupstein","Luquet","Lurais","Luray","Lurcy","Lurcy-Levis","Lure","Lury-sur-Arnon","Lus-la-Croix-Haute","Lusanger","Lusignan","Lusignan-Grand","Lusigny","Lusigny-sur-Barse","Lussac","Lussac-les-Chateaux","Lussac-les-Eglises","Lussant","Lussas","Lussat","Luttange","Lutter","Lutterbach","Lutz-en-Dunois","Lux","Luxe","Luxeuil-les-Bains","Luxey","Luynes","Luz-Saint-Sauveur","Luzarches","Luze","Luzille","Luzinay","Luzy","Lyaud","Lynde","Lyon","Mably","Macau","Mache","Machecoul","Machemont","Macheren","Machezal","Maclas","Macot-la-Plagne","Madirac","Madre","Madriat","Mael-Carhaix","Maennolsheim","Maffliers","Magagnosc","Magalas","Magenta","Magescq","Magland","Magnan","Magnanville","Magne","Magneux-Haute-Rive","Magnieres","Magny","Magny-Cours","Magny-en-Vexin","Magny-le-Desert","Magny-le-Hongre","Magny-les-Hameaux","Magny-les-Villers","Magny-sur-Tille","Magrie","Magstatt-le-Haut","Maiche","Maidieres","Maigne","Maignelay-Montigny","Maillane","Maille","Maillebois","Mailly-Champagne","Mailly-la-Ville","Mailly-le-Camp","Mailly-Maillet","Mailly-Raineval","Maincy","Maing","Maintenon","Mainvilliers","Mainxe","Mairieux","Mairy-sur-Marne","Maisdon-sur-Sevre","Maisnil","Maisnil-les-Ruitz","Maison-Ponthieu","Maisons-Alfort","Maisons-Laffitte","Maisonsgoutte","Maisontiers","Maisse","Maizeroy","Maizieres-les-Metz","Malabry","Malafretaz","Malain","Malakoff","Malancourt-la-Montagne","Malange","Malansac","Malataverne","Malaucene","Malaumont","Malaunay","Malause","Malaussanne","Malay-le-Grand","Malegoude","Malemort-du-Comtat","Malemort-sur-Correze","Malesherbes","Malestroit","Maleville","Malguenac","Malicorne","Malicorne-sur-Sarthe","Malijai","Malincourt","Malintrat","Malissard","Malleloy","Mallemoisson","Mallemort","Malling","Malmerspach","Malmont","Malpas","Malras","Malrevers","Malves-en-Minervois","Malville","Malzeville","Mamers","Mametz","Mamey","Mamirolle","Manchecourt","Mancieulles","Mandagout","Mandelieu-la-Napoule","Mandeure","Mandres-la-Cote","Mandres-les-Roses","Manduel","Mane","Maneglise","Mangiennes","Mangonville","Manicamp","Maninghen-Henne","Manneville-es-Plains","Mannevillette","Manom","Manoncourt-sur-Seille","Manonviller","Manosque","Manot","Mansigne","Mansle","Manspach","Mantes-la-Jolie","Mantes-la-Ville","Manthelan","Mantoche","Mantry","Manzat","Manziat","Marange-Silvange","Marange-Zondrange","Marans","Maraussan","Marbache","Marc","Marcamps","Marcay","Marce-sur-Esves","Marcelcave","Marcellaz-Albanais","Marchainville","Marchaux","Marche-Allouarde","Marcheprime","Marchesieux","Marcheville","Marchiennes","Marciac","Marcigny","Marcilhac-sur-Cele","Marcillac","Marcillac-la-Croisille","Marcillat-en-Combraille","Marcilloles","Marcilly-en-Bassigny","Marcilly-en-Beauce","Marcilly-en-Villette","Marcilly-sur-Eure","Marcilly-sur-Seine","Marcilly-sur-Tille","Marcilly-sur-Vienne","Marck","Marckolsheim","Marcoing","Marcollin","Marconnelle","Marcoussis","Marcouville","Marcoux","Marcq","Marcq-en-Baroeul","Marcq-en-Ostrevent","Mardeuil","Mardie","Mardyck","Mareau-aux-Bois","Mareau-aux-Pres","Mareil-en-France","Mareil-Marly","Mareil-sur-Loir","Mareil-sur-Mauldre","Marenla","Marennes","Marest","Marestaing","Mareuil","Mareuil-Caubert","Mareuil-en-Brie","Mareuil-le-Port","Mareuil-les-Meaux","Mareuil-sur-Cher","Mareuil-sur-Lay-Dissais","Mareuil-sur-Ourcq","Margaux","Margencel","Margency","Margerie-Chantagret","Margny","Margny-les-Compiegne","Margon","Marguerittes","Margut","Marie","Marienthal","Marignac","Marignac-Lasclares","Marignane","Marigne","Marignier","Marigny","Marigny-Brizay","Marigny-Chemereau","Marigny-en-Orxois","Marigny-le-Chatel","Marigny-les-Usages","Marigny-Marmande","Marin","Marines","Maringes","Maringues","Marle","Marlenheim","Marles-en-Brie","Marles-les-Mines","Marliens","Marlioz","Marlotte","Marly","Marly-la-Ville","Marly-le-Roi","Marmagne","Marmande","Marmanhac","Marmoutier","Marnand","Marnaz","Marnes","Marnes-la-Coquette","Maroeuil","Marolles","Marolles-en-Brie","Marolles-en-Hurepoix","Marols","Maromme","Maron","Marpent","Marquay","Marquefave","Marqueglise","Marques","Marquillies","Marquion","Marquise","Marquixanes","Mars","Mars-sur-Allier","Marsac","Marsac-en-Livradois","Marsac-sur-lIsle","Marsainvilliers","Marsais","Marsais-Sainte-Radegonde","Marsaneix","Marsangy","Marsannay-le-Bois","Marsanne","Marsat","Marsaz","Marseillan","Marseille","Marseille-en-Beauvaisis","Marseilles-les-Aubigny","Marsillargues","Marsilly","Marssac-sur-Tarn","Martainville-Epreville","Martel","Marthod","Martiel","Martignas-sur-Jalle","Martigne-Briand","Martigne-Ferchaud","Martigny","Martigues","Martillac","Martin-Eglise","Martinet","Martinvast","Martot","Martres-Tolosane","Marval","Marvejols","Marville-les-Bois","Marzan","Marzy","Mas-Grenier","Mas-Saintes-Puelles","Masevaux","Maslacq","Maslives","Masnieres","Masny","Masparraute","Massat","Masserac","Masseret","Massiac","Massieu","Massieux","Massingy-les-Semur","Massugas","Massy","Mastaing","Matha","Mathay","Mathenay","Mathieu","Matignon","Matigny","Matour","Mattaincourt","Mattexey","Matzenheim","Maubeuge","Maubourguet","Mauchamps","Maucor","Mauguio","Maule","Mauleon-Licharre","Maulevrier","Mauperthuis","Mauprevoir","Mauran","Maure","Maure-de-Bretagne","Maurecourt","Maureilhan","Maureillas-las-Illas","Mauremont","Maurens","Maurepas","Mauressargues","Maureville","Mauriac","Maurois","Mauron","Maurrin","Maurs","Maussane-les-Alpilles","Mauves","Mauves-sur-Huisne","Mauves-sur-Loire","Mauvezin-de-Prat","Maux","Mauzac","Mauze-sur-le-Mignon","Mauzens-et-Miremont","Maxent","Maxeville","Maxilly-sur-Saone","May-en-Multien","May-sur-Orne","Mayenne","Mayet","Maysel","Mazamet","Mazan","Mazange","Maze","Mazeray","Mazeres-de-Neste","Mazeres-sur-Salat","Mazerolles","Mazerolles-le-Salin","Mazet-Saint-Voy","Mazeuil","Mazieres-en-Gatine","Mazieres-en-Mauges","Mazingarbe","Mazion","Meaudre","Meaulte","Meaux","Meauzac","Medan","Medis","Medreac","Mees","Megrit","Meharicourt","Mehun-sur-Yevre","Meigneux","Meilhac","Meilhan","Meilhan-sur-Garonne","Meillant","Meillerie","Meillon","Meillonnas","Meisenthal","Mejannes-le-Clap","Mejannes-les-Ales","Melay","Melesse","Melgven","Mellac","Melle","Mellecey","Melleran","Melleray","Mellionnec","Mello","Melrand","Melsheim","Melun","Membrey","Menat","Mende","Mendionde","Meneac","Menerbes","Menesplet","Menestreau-en-Villette","Menetou-Salon","Menetreol-sur-Sauldre","Menetrol","Menil-Erreux","Menil-Hermei","Menil-la-Horgne","Menil-sur-Belvitte","Menilles","Mennecy","Mennevret","Mens","Mensignac","Menthon-Saint-Bernard","Menton","Menucourt","Menville","Meounes-les-Montrieux","Mer","Mercenac","Merckeghem","Mercues","Mercurol","Mercy-le-Bas","Merdrignac","Mere","Mereau","Merenvielle","Mereville","Merey-sous-Montrond","Mergey","Mericourt","Meriel","Merignac","Merignas","Merignat","Merignies","Merigny","Merindol","Merlas","Merlebach","Merlevenez","Merlimont","Merlines","Mernel","Meroux","Merry-la-Vallee","Merry-sur-Yonne","Mers-les-Bains","Mertzen","Mertzwiller","Meru","Mervans","Merville","Merville-Franceville-Plage","Merxheim","Mery","Mery-es-Bois","Mery-sur-Oise","Mery-sur-Seine","Mesanger","Mesangueville","Meschers-sur-Gironde","Mescoules","Mesland","Meslay","Meslay-du-Maine","Meslay-le-Vidame","Meslin","Mesnil-Raoul","Mesnil-Saint-Georges","Mesnil-Saint-Nicaise","Mesnil-Sellieres","Mesnil-sous-Vienne","Mesplede","Messac","Messanges","Messei","Messein","Messia-sur-Sorne","Messigny-et-Vantoux","Messimy","Messon","Messy","Metabief","Meteren","Mettray","Metz","Metz-Tessy","Metzeral","Metzeresche","Metzervisse","Meucon","Meudon","Meulan-en-Yvelines","Meung-sur-Loire","Meurchin","Meursault","Meuse","Meusnes","Meuzac","Mevoisins","Meximieux","Mexy","Meyenheim","Meylan","Meymac","Meynes","Meyrargues","Meyras","Meyreuil","Meyssac","Meythet","Meyzieu","Meze","Mezel","Mezeres","Mezeriat","Mezidon-Canon","Mezieres-en-Drouais","Mezieres-lez-Clery","Mezieres-sous-Lavardin","Mezieres-sur-Couesnon","Mezieres-sur-Seine","Mezzavia","Michelbach-le-Bas","Mielan","Miellin","Mietesheim","Mieussy","Migennes","Miglos","Mignaloux-Beauvoir","Migne-Auxances","Mignieres","Migron","Milhaud","Milizac","Millac","Millas","Millau","Millencourt","Millery","Milly","Milly-la-Foret","Milly-Lamartine","Milly-sur-Therain","Milon-la-Chapelle","Mimbaste","Mimet","Mimizan","Mine de Bert","Mingot","Miniac-Morvan","Miniac-sous-Becherel","Minihy-Treguier","Minversheim","Minzier","Mionnay","Mions","Mios","Mirabel-aux-Baronnies","Miradoux","Miramas","Mirambeau","Miramont-de-Guyenne","Miramont-Sensacq","Mirande","Mirebeau","Mirebeau-sur-Beze","Mirecourt","Miremont","Mirepeix","Mirepoix","Mirepoix-sur-Tarn","Mireval-Lauragais","Miribel","Miserey","Miserey-Salines","Mison","Misse","Missillac","Missiriac","Misson","Missy-sur-Aisne","Mitry-Mory","Mittelbronn","Mittelhausbergen","Mittelwihr","Mitterand","Mittersheim","Modane","Moelan-sur-Mer","Moens","Moernach","Moeslains","Mogneville","Mogues","Mohon","Moineville","Moinville-la-Jeulin","Moirans","Moirans-en-Montagne","Moire","Moisdon-la-Riviere","Moislains","Moissac","Moissat","Moisselles","Moissieu-sur-Dolon","Moissy-Cramayel","Moisville","Molac","Molandier","Molesme","Moliens","Molieres-sur-Ceze","Moliets-et-Maa","Molinet","Molineuf","Molleges","Molliens-au-Bois","Mollkirch","Moloy","Molsheim","Moltifao","Momas","Mombrier","Momeres","Mommenheim","Momy","Monbahus","Monbalen","Monbrun","Moncale","Monce-en-Belin","Monceau-le-Neuf-et-Faucouzy","Monceau-le-Waast","Monceau-Saint-Waast","Monceaux","Moncel-sur-Seille","Moncetz-Longevas","Moncheaux-les-Frevent","Monchecourt","Monchy-Breton","Monchy-Humieres","Monchy-Saint-Eloi","Monclar-de-Quercy","Moncontour","Moncoutant","Mondelange","Mondescourt","Mondetour","Mondeville","Mondon","Mondonville","Mondragon","Mondrainville","Mondrepuis","Monein","Monestier-de-Clermont","Monesties","Monetay-sur-Loire","Moneteau","Monferran-Plaves","Monferran-Saves","Monflanquin","Monistrol-sur-Loire","Monnaie","Monnetier-Mornex","Monneville","Monnieres","Monpazier","Mons","Mons-en-Baroeul","Mons-en-Montois","Mons-en-Pevele","Monsac","Monsegur","Monsempron-Libos","Monsireigne","Monsteroux-Milieu","Mont","Mont-Bonvillers","Mont-Cauvaire","Mont-de-Marsan","Mont-Notre-Dame","Mont-pres-Chambord","Mont-Saint-Aignan","Mont-Saint-Martin","Mont-Saint-Pere","Mont-Saxonnex","Mont-sur-Meurthe","Mont-sur-Monnet","Montabard","Montady","Montagnac","Montagnat","Montagne","Montagney","Montagnieu","Montagnole","Montagny-en-Vexin","Montagny-les-Lanches","Montagny-les-Seurre","Montagny-Sainte-Felicite","Montagny-sur-Grosne","Montagrier","Montagut","Montaigu","Montaigu-de-Quercy","Montaigut-sur-Save","Montainville","Montalet-le-Bois","Montalieu-Vercieu","Montamise","Montanay","Montardon","Montargis","Montarlot-les-Rioz","Montarnaud","Montastruc-de-Salies","Montastruc-la-Conseillere","Montataire","Montauban","Montauban-de-Bretagne","Montaud","Montaudin","Montaulieu","Montaure","Montauroux","Montaut","Montayral","Montbard","Montbartier","Montbazin","Montbazon","Montbel","Montbellet","Montberon","Montbert","Montbeton","Montbeugny","Montbizot","Montblanc","Montboillon","Montbonnot-Saint-Martin","Montboucher-sur-Jabron","Montbouton","Montbrison","Montbron","Montbronn","Montbrun-Bocage","Montcaret","Montcarra","Montceau","Montceau-les-Mines","Montceaux","Montceaux-les-Meaux","Montcel","Montcenis","Montcey","Montchamp","Montchanin","Montchaude","Montclar","Montcornet","Montcourt-Fromonville","Montcoy","Montcuq","Montcy-Notre-Dame","Montdidier","Montdoumerc","Montdragon","Monteaux","Montebourg","Montech","Montecheroux","Monteglin","Monteils","Montel-de-Gelat","Montelier","Montemboeuf","Montendre","Montenescourt","Montenois","Montenoison","Monterblanc","Montereau-Fault-Yonne","Monterfil","Montescot","Montesquieu","Montesquieu-des-Alberes","Montesquieu-Volvestre","Montessaux","Montesson","Montestruc-sur-Gers","Montestrucq","Monteux","Montevrain","Monteynard","Montfarville","Montfaucon","Montfaucon-en-Velay","Montfaucon-Montigne","Montfavet","Montfermeil","Montfermy","Montferrand-du-Perigord","Montferrand-le-Chateau","Montferrat","Montferrier-sur-Lez","Montfleur","Montfort","Montfort-en-Chalosse","Montfort-sur-Meu","Montfrin","Montfroc","Montfuron","Montgaillard","Montgaroult","Montgermont","Montgeron","Montgesty","Montgirod","Montgiscard","Montgivray","Montherme","Monthieux","Monthodon","Monthou-sur-Bievre","Monthou-sur-Cher","Monthureux-sur-Saone","Monthyon","Monticello","Montier-en-Der","Montierchaume","Montiers","Montignac-de-Lauzun","Montignac-le-Coq","Montigne-le-Brillant","Montigne-les-Rairies","Montigny","Montigny-en-Cambresis","Montigny-en-Gohelle","Montigny-le-Bretonneux","Montigny-le-Chartif","Montigny-Lengrain","Montigny-les-Cormeilles","Montigny-sur-Loing","Montilly","Montilly-sur-Noireau","Montiron","Montivilliers","Montjavoult","Montjean-sur-Loire","Montlhery","Montliard","Montlieu-la-Garde","Montlignon","Montlivault","Montlouis","Montlouis-sur-Loire","Montluel","Montmacq","Montmagny","Montmalin","Montmarault","Montmartin","Montmartin-en-Graignes","Montmartin-sur-Mer","Montmelian","Montmerle-sur-Saone","Montmeyran","Montmirail","Montmiral","Montmirat","Montmoreau-Saint-Cybard","Montmorency","Montmorency-Beaufort","Montmorillon","Montmorot","Montoir-de-Bretagne","Montoire-sur-le-Loir","Montois-la-Montagne","Montoison","Montolivet","Montournais","Montpellier","Montpeyroux","Montpezat","Montpezat-de-Quercy","Montpezat-sous-Bauzon","Montpincon","Montpinier","Montpitol","Montpon-Menesterol","Montpothier","Montrabe","Montreal","Montreal-la-Cluse","Montredon-des-Corbieres","Montredon-Labessonnie","Montrejeau","Montrelais","Montrem","Montrequienne","Montresor","Montret","Montreuil","Montreuil-aux-Lions","Montreuil-Bonnin","Montreuil-en-Caux","Montreuil-sous-Perouse","Montreuil-sur-Blaise","Montreuil-sur-Breche","Montreuil-sur-Lozon","Montreuil-sur-Mer","Montreux-Jeune","Montrevel","Montrevel-en-Bresse","Montrichard","Montricoux","Montrodat","Montrond","Montrond-les-Bains","Montrouge","Montrouveau","Montry","Monts","Monts-en-Bessin","Monts-sur-Guesnes","Montsalvy","Montsauche-les-Settons","Montsegur-sur-Lauzon","Montseveroux","Montsoreau","Montsoult","Montussan","Montvalen","Montvalent","Montvendre","Montverdun","Montville","Moon-sur-Elle","Moosch","Moragne","Morainvilliers","Morance","Morancez","Morangis","Morbecque","Morbier","Morcenx","Mordelles","Moreac","Moree","Morelmaison","Morestel","Moret-sur-Loing","Moreuil","Morez","Morgny","Morgny-la-Pommeraye","Morhange","Morienval","Morieres-les-Avignon","Morieux","Morigny-Champigny","Morisel","Moriville","Morlaas","Morlaix","Mormant","Mornac","Mornac-sur-Seudre","Mornant","Mornay","Mornay-sur-Allier","Moroges","Morogues","Morre","Morsain","Morsang-sur-Orge","Morsbach","Morsbronn-les-Bains","Morschwiller-le-Bas","Mortagne","Mortagne-au-Perche","Mortagne-du-Nord","Mortagne-sur-Sevre","Mortain","Mortcerf","Morteau","Morteaux-Couliboeuf","Mortefontaine","Mortefontaine-en-Thelle","Mortree","Mortzwiller","Morvillers-Saint-Saturnin","Morvilliers","Morzine","Moslins","Mosnac","Mosson","Motteville","Mouans-Sartoux","Mouaze","Mouchin","Mouflers","Mougins","Mougon","Mouguerre","Mouilleron-en-Pareds","Mouilleron-le-Captif","Mouledous","Moules","Mouliets-et-Villemartin","Moulin","Moulin-Mage","Moulin-Neuf","Moulin-sous-Touvent","Moulineaux","Moulines","Moulinet","Moulins","Moulins-Engilbert","Moulins-les-Metz","Moulins-sur-Cephons","Moulins-sur-Yevre","Moulle","Moult","Moumour","Mourenx","Moureze","Mouries","Mourioux-Vieilleville","Mourmelon-le-Grand","Mourmelon-le-Petit","Mouroux","Mours","Mours-Saint-Eusebe","Moussan","Mousseaux-Neuville","Moussey","Mousson","Moussoulens","Moussy","Moussy-le-Neuf","Moussy-le-Vieux","Mousteru","Moustier-en-Fagne","Mouthe","Mouthier-en-Bresse","Mouthiers-sur-Boeme","Moutiers","Moutiers-les-Mauxfaits","Moutiers-sur-le-Lay","Mouvaux","Mouxy","Mouy","Mouzeil","Mouzieys-Teulet","Mouzillon","Mouzon","Moyaux","Moyencourt","Moyenmoutier","Moyenneville","Moyeuvre-Grande","Moyon","Moyrazes","Moyvillers","Mozac","Muespach-le-Haut","Muides-sur-Loire","Muidorge","Muirancourt","Muizon","Mulcent","Mulcey","Mulhouse","Mulsanne","Munchhouse","Mundolsheim","Munster","Mur-de-Bretagne","Mur-de-Sologne","Murat","Mures","Muret","Murianette","Muro","Murol","Muron","Murs-Erigne","Murviel-les-Beziers","Murviel-les-Montpellier","Mus","Mussidan","Mussig","Mutzig","Muzillac","Nadillac","Nages-et-Solorgues","Nailloux","Naintre","Naizin","Najac","Nalliers","Nancy","Nandy","Nangis","Nans-les-Pins","Nanterre","Nantes","Nanteuil-en-Vallee","Nanteuil-le-Haudouin","Nanteuil-les-Meaux","Nantiat","Nantoin","Nanton","Nantua","Naours","Narbonne","Narbonne-Plage","Nargis","Narrosse","Nattages","Naucelle","Naujan-et-Postiac","Naux","Navailles-Angos","Navarrenx","Naves","Nay","Nayemont-les-Fosses","Nazelles-Negron","Neauphle-le-Chateau","Neauphlette","Nebian","Nebouzat","Nedonchel","Neewiller-pres-Lauterbourg","Neffes","Neffies","Nefiach","Negrepelisse","Negron","Nehou","Nemours","Neoules","Nercillac","Nere","Neris-les-Bains","Neron","Neronde-sur-Dore","Ners","Nersac","Nerville-la-Foret","Nery","Nesle","Nesles","Nesles-la-Montagne","Nesles-la-Vallee","Nesmy","Nessa","Neuf Eglise","Neuf-Brisach","Neufchateau","Neufchatel-en-Bray","Neufchef","Neufgrange","Neuflize","Neufmanil","Neufmesnil","Neufmoutiers-en-Brie","Neufvy-sur-Aronde","Neuil","Neuille","Neuilly","Neuilly-en-Thelle","Neuilly-le-Bisson","Neuilly-le-Real","Neuilly-les-Dijon","Neuilly-Plaisance","Neuilly-Saint-Front","Neuilly-sous-Clermont","Neuilly-sur-Marne","Neuilly-sur-Seine","Neulliac","Neung-sur-Beuvron","Neure","Neussargues-Moissac","Neuve-Maison","Neuvecelle","Neuves-Maisons","Neuvic","Neuvic-Entier","Neuvicq-le-Chateau","Neuville","Neuville-aux-Bois","Neuville-Bosc","Neuville-de-Poitou","Neuville-en-Ferrain","Neuville-Ferrieres","Neuville-les-Dames","Neuville-les-Dieppe","Neuville-Saint-Remy","Neuville-Saint-Vaast","Neuville-sur-Ain","Neuville-sur-Brenne","Neuville-sur-Escaut","Neuville-sur-Oise","Neuville-sur-Saone","Neuville-sur-Sarthe","Neuville-sur-Seine","Neuviller-sur-Moselle","Neuvireuil","Neuvy","Neuvy-Bouin","Neuvy-en-Beauce","Neuvy-en-Sullias","Neuvy-le-Roi","Neuvy-Saint-Sepulchre","Nevers","Nevez","Nevian","Neville","Nexon","Neydens","Nibas","Nibelle","Nice","Nicole","Nicorps","Niderhoff","Niderviller","Niederbronn-les-Bains","Niederbruck","Niederentzen","Niederhaslach","Niederhausbergen","Niedermodern","Niederschaeffolsheim","Nieppe","Niergnies","Nieuil","Nieul-le-Virouil","Nieul-les-Saintes","Nieul-sur-Mer","Nievroz","Niffer","Niherne","Nilvange","Niort","Nissan-lez-Enserune","Nitting","Nivillac","Nivolas-Vermelle","Nizas","Noailhac","Noaillac","Noaillan","Noailles","Noe","Noeux-les-Auxi","Noeux-les-Mines","Nogent","Nogent-le-Phaye","Nogent-le-Roi","Nogent-le-Rotrou","Nogent-sur-Eure","Nogent-sur-Marne","Nogent-sur-Oise","Nogent-sur-Seine","Nogent-sur-Vernisson","Nohanent","Nohic","Noidans-le-Ferroux","Noidans-les-Vesoul","Noilhan","Nointel","Nointot","Noiron","Noiron-sous-Gevrey","Noirterre","Noiseau","Noisiel","Noisseville","Noisy-le-Grand","Noisy-le-Roi","Noisy-le-Sec","Noisy-Rudignon","Noisy-sur-Ecole","Noisy-sur-Oise","Nolay","Nomain","Nomeny","Nomexy","Nommay","Nonancourt","Nonette","Nonneville","Nontron","Nonville","Nonvilliers-Grandhoux","Noordpeene","Nordausques","Nordhouse","Norges-la-Ville","Normanville","Normier","Norrent-Fontes","Norrey-en-Auge","Norroy-le-Sec","Norroy-le-Veneur","Norroy-les-Pont-a-Mousson","Nort-sur-Erdre","Nostang","Nothalten","Notre-Dame-de-Boisset","Notre-Dame-de-Bondeville","Notre-Dame-de-Cenilly","Notre-Dame-de-Commiers","Notre-Dame-de-Gravenchon","Notre-Dame-de-la-Rouviere","Notre-Dame-de-Livaye","Notre-Dame-de-Livoye","Notre-Dame-de-Mesage","Notre-Dame-de-Riez","Notre-Dame-de-Sanilhac","Notre-Dame-des-Landes","Notre-Dame-du-Pre","Nouaille-Maupertuis","Nouainville","Nouan-le-Fuzelier","Noueilles","Nouilly","Nousseviller-les-Bitche","Nousseviller-Saint-Nabor","Nouvelle-Eglise","Nouvion-le-Comte","Nouvion-le-Vineux","Nouvion-sur-Meuse","Nouvoitou","Nouzonville","Novalaise","Noveant-sur-Moselle","Noves","Novillard","Novillars","Novion-Porcien","Noyal-Muzillac","Noyal-Pontivy","Noyal-sur-Vilaine","Noyant-de-Touraine","Noyant-la-Gravoyere","Noyant-la-Plaine","Noyarey","Noyelles-Godault","Noyelles-sous-Lens","Noyelles-sur-Escaut","Noyen-sur-Sarthe","Noyers","Noyers-Bocage","Noyers-sur-Cher","Noyon","Nozay","Nuaille","Nuaille-sur-Boutonne","Nueil-sur-Layon","Nuelles","Nuits-Saint-Georges","Nyoiseau","Nyons","Obenheim","Oberbronn","Oberentzen","Oberhaslach","Oberhausbergen","Oberhergheim","Oberhoffen-sur-Moder","Oberlauterbach","Obermodern-Zutzendorf","Obermorschwihr","Obermorschwiller","Obernai","Obersaasheim","Oberschaeffolsheim","Objat","Oblinghem","Obtree","Ochey","Octeville","Octeville-sur-Mer","Oderen","Odomez","Odos","Oelleville","OEting","Oeyreluy","Offekerque","Offemont","Offendorf","Offoy","Offranville","Ogenne-Camptort","Oger","Ogeu-les-Bains","Ogeviller","Ogy","Oignies","Oingt","Oinville-sur-Montcient","Oiron","Oiselay-et-Grachaux","Oisemont","Oisly","Oisseau","Oissel","Oisy","Oisy-le-Verger","Oizon","Olargues","Olby","Olemps","Oletta","Olivet","Ollainville","Olle","Ollezy","Ollieres","Olliergues","Ollioules","Olloix","Olmet","Olonne-sur-Mer","Olonzac","Oloron-Sainte-Marie","Olwisheim","Omessa","Omonville-la-Rogue","Ondes","Ondres","Ondreville-sur-Essonne","Onet-le-Chateau","Onnaing","Onnion","Ons-en-Bray","Onzain","Opio","Oppede","Optevoz","Oradour","Oradour-Fanais","Oradour-sur-Glane","Oraison","Orangis","Orban","Orbec","Orbeil","Orbey","Orcet","Orchaise","Orchamps-Vennes","Orches","Orchies","Orcier","Orcines","Ordan-Larroque","Ordiarp","Oregue","Oresmaux","Orgelet","Orgeres","Orgerus","Orgeval","Orgon","Orgueil","Orignolles","Origny-en-Thierache","Origny-le-Sec","Origny-Sainte-Benoite","Oriol-en-Royans","Orion","Orleat","Orlienas","Orlu","Orly","Ormersviller","Ormes","Ormes-et-Ville","Ormesson-sur-Marne","Ormoy","Ormoy-Villers","Ornacieux","Ornans","Ornex","Orny","Orphin","Orrouer","Orrouy","Orry-la-Ville","Orsan","Orsanco","Orsonville","Orthez","Ortoncourt","Orval","Orvault","Orvaux","Orveau-Bellesauve","Orvillers-Sorel","Osne-le-Val","Osny","Ossages","Osse","Osses","Ossun","Ostheim","Ostricourt","Ostwald","Ota","Othis","Ottange","Ottmarsheim","Ottonville","Ottrott","Ouanne","Ouarville","Ouchamps","Oucques","Oudon","Ouerre","Ouezy","Ouffieres","Ougney","Ouhans","Ouilly-le-Tesson","Ouilly-le-Vicomte","Ouistreham","Oulchy-le-Chateau","Oullins","Oupia","Ourches","Ouroux","Ouroux-sur-Saone","Oursbelille","Ousse","Ousson-sur-Loire","Outarville","Outille","Outines","Outreau","Ouveillan","Ouville","Ouzilly","Ouzouer-le-Marche","Ouzouer-sur-Loire","Ouzouer-sur-Trezee","Ovanches","Ovillers-la-Boisselle","Oye-Plage","Oyeu","Oyonnax","Oytier-Saint-Oblas","Ozan","Ozoir-la-Ferriere","Ozolles","Ozouer-le-Voulgis","Pabu","Pace","Pact","Pacy-sur-Eure","Pageas","Pagny-la-Ville","Pagny-sur-Meuse","Pagny-sur-Moselle","Paillart","Paillencourt","Paillet","Paimboeuf","Paimpol","Paimpont","Painblanc","Pair-et-Grandrupt","Paix","Paizay-le-Chapt","Paizay-le-Sec","Paizay-le-Tort","Palaiseau","Palaja","Palalda","Palaminy","Palau-del-Vidre","Palavas-les-Flots","Paleyrac","Palinges","Palleau","Palluau","Palluau-sur-Indre","Pallud","Pamfou","Pamiers","Pamproux","Panassac","Panazol","Panissieres","Pannece","Pannes","Panossas","Pantin","Panzoult","Paradou","Paray-le-Monial","Paray-sous-Briailles","Paray-Vieille-Poste","Paraza","Parcay-Meslay","Parce-sur-Sarthe","Parcieux","Pareds","Parempuyre","Parent","Parentis-en-Born","Pargny-Filain","Pargny-la-Dhuys","Pargny-les-Bois","Pargny-sur-Saulx","Parigne","Parigne-sur-Braye","Parigny","Paris","Paris 17 Batignolles-Monceau","Parisot","Parly","Parmain","Parnans","Parnay","Parne-sur-Roc","Paron","Parsac","Parthenay","Parthenay-de-Bretagne","Parzac","Pas-en-Artois","Paslieres","Pasly","Pasques","Passel","Passy","Patay","Pau","Pauilhac","Pauillac Haut","Paul","Paulhac","Paulhaguet","Paulhan","Paulx","Pavie","Pavilly","Payrac","Payrin-Augmontel","Payroux","Payzac","Peaugres","Peaule","Pebrac","Pechabou","Pechbonnieu","Pecquencourt","Pecqueuse","Pegomas","Peillac","Peille","Peillon","Peillonnex","Peipin","Peisey-Nancroix","Pelissanne","Pellegrue","Pellevoisin","Pellouailles-les-Vignes","Pelousey","Peltre","Pelussin","Penchard","Pencran","Pende","Penestin","Penguily","Penmarch","Pennautier","Penne-dAgenais","Pennedepie","Penol","Penta-di-Casinca","Penvenan","Pepieux","Peray","Percy","Pere","Perenchies","Peret","Peri","Periers","Perignac","Perignat-les-Sarlieve","Perigne","Perigneux","Perigny","Perillos","Pern","Pernay","Pernes","Pernes-les-Boulogne","Pernes-les-Fontaines","Perols","Peron","Peronnas","Peronne","Peronne-en-Melantois","Perouse","Peroy-les-Gombries","Perpezac-le-Noir","Perpignan","Perrecy-les-Forges","Perreux","Perrex","Perrier","Perriers-sur-Andelle","Perrignier","Perrigny","Perrigny-les-Dijon","Perrogney-les-Fontaines","Perros-Guirec","Perrou","Perruel","Pers","Pers-Jussy","Persan","Persquen","Perthes-les-Brienne","Pertheville-Ners","Pertuis","Pessac","Pessac-sur-Dordogne","Pessan","Pessans","Pessat-Villeneuve","Petit Chaumont","Petit-Couronne","Petit-Landau","Petit-Mars","Petit-Palais-et-Cornemps","Petite-Foret","Petite-Rosselle","Petiville","Petreto-Bicchisano","Peumerit","Pexonne","Pey","Peymeinade","Peynier","Peypin","Peyrat-le-Chateau","Peyrehorade","Peyriac-de-Mer","Peyriac-Minervois","Peyrignac","Peyrilhac","Peyrilles","Peyrins","Peyrissas","Peyrolles-en-Provence","Peyruis","Peyrus","Peyrusse-Massas","Pezenas","Pezens","Pezilla-la-Riviere","Pezou","Pfaffenheim","Pfaffenhoffen","Pfastatt","Pfettisheim","Pfulgriesheim","Phaffans","Phalempin","Phalsbourg","Pia","Piazza","Piblange","Pibrac","Picauville","Picquigny","Piegros-la-Clastre","Piegut-Pluviers","Piennes","Pierre","Pierre-Benite","Pierre-de-Bresse","Pierre-la-Treiche","Pierre-Levee","Pierrefeu-du-Var","Pierrefitte-Nestalas","Pierrefitte-sur-Seine","Pierrefonds","Pierrefort","Pierregot","Pierrelatte","Pierrelaye","Pierremande","Pierrepont-sur-Avre","Pierrerue","Pierres","Pierrevert","Pierrevillers","Pierric","Pierry","Pietralba","Pieusse","Pignan","Pignans","Pignols","Pihem","Pimbo","Pimprez","Pin","Pinet","Pineuilh","Piney","Pinon","Pinsaguel","Piolenc","Pionsat","Pipriac","Piquecos","Pire-sur-Seiche","Pirey","Pirou","Piscop","Piseux","Pissos","Pissotte","Pissy-Poville","Pithiviers","Pitres","Pizay","Plabennec","Place","Plailly","Plaimpied-Givaudins","Plaine-de-Walsch","Plaine-Haute","Plaintel","Plaisance","Plaisance-du-Touch","Plaisir","Plan-de-Cuques","Planay","Plancher-Bas","Planches","Planguenoual","Planzolles","Plappeville","Plassay","Plateau","Plaudren","Plauzat","Pleboulle","Plechatel","Pledran","Plehedel","Plelan-le-Grand","Plelan-le-Petit","Plelauff","Plelo","Plemet","Plenee-Jugon","Pleneuf-Val-Andre","Plerguer","Plerin","Plerneuf","Plescop","Plesidy","Plesnois","Plessala","Plesse","Plessis-Barbuise","Plessis-de-Roye","Plestan","Plestin-les-Greves","Pleucadeuc","Pleudihen-sur-Rance","Pleugriffet","Pleugueneuc","Pleumartin","Pleumeleuc","Pleumeur-Bodou","Pleure","Pleurs","Pleurtuit","Pleuven","Pleyben","Pleyber-Christ","Plobannalec-Lesconil","Plobsheim","Ploemel","Ploemeur","Ploerdut","Ploeren","Ploermel","Ploeuc-sur-Lie","Ploeven","Plogonnec","Plomb","Plombieres-les-Bains","Plombieres-les-Dijon","Plomelin","Plomeur","Plonevez-du-Faou","Plorec-sur-Arguenon","Plottes","Plouagat","Plouaret","Plouarzel","Plouasne","Plouay","Ploubalay","Ploubazlanec","Ploubezre","Ploudalmezeau","Ploudaniel","Plouec-du-Trieux","Plouedern","Plouer-sur-Rance","Plouescat","Plouezec","Ploufragan","Plougar","Plougasnou","Plougastel-Daoulas","Plougonvelin","Plougonven","Plougoulm","Plougoumelen","Plougourvest","Plougrescant","Plouguerneau","Plouguin","Plouha","Plouharnel","Plouigneau","Ploumagoar","Ploumilliau","Ploumoguer","Plouneour-Menez","Plouneour-Trez","Plounerin","Plounevez-Lochrist","Plounevezel","Plourin","Plourivo","Plouvain","Plouvara","Plouvien","Plouvorn","Plouzane","Plozevet","Pludual","Pluduno","Pluguffan","Pluherlin","Plumaugat","Plumeliau","Plumelin","Plumergat","Plumoison","Pluneret","Plurien","Plusquellec","Plussulien","Pluvault","Pluvigner","Pluzunet","Poce-sur-Cisse","Podensac","Poeuilly","Poey-de-Lescar","Poggio-dOletta","Pogny","Poigny-la-Foret","Poilly-lez-Gien","Poilly-sur-Tholon","Poinsenot","Pointis-Inard","Poisat","Poiseul-les-Saulx","Poisieux","Poisson","Poissons","Poissy","Poisy","Poitiers","Poix","Poix-de-Picardie","Poix-du-Nord","Poligny","Pollestres","Polliat","Pomacle","Pomarez","Pomerols","Pomeys","Pommard","Pommeret","Pommerit-Jaudy","Pommerit-le-Vicomte","Pommeuse","Pommevic","Pommiers","Pommiers-la-Placette","Pompadour","Pompaire","Pompertuzat","Pompey","Pompidou","Pompignan","Pomponne","Pomport","Poncey-les-Athee","Ponchon","Poncin","Poncins","Pons","Pont","Pont-a-Marcq","Pont-a-Vendin","Pont-Audemer","Pont-Aven","Pont-de-Barret","Pont-de-Beauvoisin","Pont-de-Briques","Pont-de-Buis-les-Quimerch","Pont-de-Cheruy","Pont-de-Labeaume","Pont-de-Larn","Pont-de-Metz","Pont-de-Roide","Pont-de-Salars","Pont-de-Vaux","Pont-de-Veyle","Pont-du-Casse","Pont-du-Chateau","Pont-en-Royans","Pont-Eveque","Pont-Hebert","Pont-Noyelles","Pont-Remy","Pont-Saint-Esprit","Pont-Saint-Mard","Pont-Saint-Martin","Pont-Saint-Pierre","Pont-Saint-Vincent","Pont-Sainte-Marie","Pont-Sainte-Maxence","Pont-Salomon","Pont-Scorff","Pont-sur-Sambre","Pont-sur-Seine","Pont-sur-Yonne","Pontacq","Pontailler-sur-Saone","Pontarlier","Pontarme","Pontaubault","Pontault-Combault","Pontaumur","Pontaut","Pontavert","Pontcarre","Pontcharra","Pontcharra-sur-Turdine","Pontchateau","Pontcirq","Ponte-Leccia","Ponteilla","Pontenx-les-Forges","Pontgibaud","Pontgouin","Ponthevrard","Ponthierry","Pontigne","Pontigny","Pontivy","Pontlevoy","Pontoise","Pontorson","Pontours","Pontpoint","Pontruet","Ponts","Pontvallain","Popian","Porcelette","Porcheres","Porcheresse","Porcheville","Porcieu-Amblagnieu","Pordic","Pornic","Pornichet","Port-Brillet","Port-Cros","Port-de-Bouc","Port-des-Barques","Port-en-Bessin-Huppain","Port-Joinville","Port-la-Nouvelle","Port-Launay","Port-Louis","Port-Mort","Port-Saint-Louis-du-Rhone","Port-Saint-Pere","Port-Sainte-Foy-et-Ponchapt","Port-Sainte-Marie","Port-sur-Saone","Portbail","Portel-des-Corbieres","Portes-les-Valence","Portet-sur-Garonne","Portets","Porticcio","Portieux","Portiragnes","Porto","Porto-Vecchio","Portrieux","Ports","Portvendres","Poses","Potigny","Pouan-les-Vallees","Pouance","Pouffonds","Pougny","Pougues-les-Eaux","Pougy","Pouille","Pouillenay","Pouilley-Francais","Pouilley-les-Vignes","Pouillon","Pouilloux","Pouilly","Pouilly-en-Auxois","Pouilly-le-Monial","Pouilly-les-Nonains","Pouilly-sous-Charlieu","Pouilly-sur-Loire","Pouilly-sur-Serre","Pouilly-sur-Vingeanne","Poulainville","Poulan-Pouzols","Pouldergat","Pouldreuzic","Poule-les-Echarmeaux","Pouligney-Lusans","Poullan-sur-Mer","Poullaouen","Poulx","Pournoy-la-Grasse","Pourrain","Pourrieres","Pouru-Saint-Remy","Poussan","Pouxeux","Pouydesseaux","Pouzauges","Pouzay","Pouzilhac","Pouzolles","Pouzols-Minervois","Poville","Pradelles","Prades","Prades-le-Lez","Pradieres","Prahecq","Pralognan-la-Vanoise","Pranzac","Prasville","Prat","Prats-de-Carlux","Pray","Prayssac","Prayssas","Praz","Praz-sur-Arly","Pre-en-Pail","Preaux","Precey","Prechac","Precieux","Precigne","Precorbin","Precy-sous-Thil","Precy-sur-Marne","Precy-sur-Oise","Precy-sur-Vrin","Prefailles","Prefontaines","Preguillac","Preignac","Preignan","Premanon","Premery","Premian","Premontre","Preseau","Presles-en-Brie","Presles-et-Thierny","Pressagny-le-Val","Pressignac-Vicq","Pressigny","Pressigny-les-Pins","Pretot-Vicquemare","Preuschdorf","Prevessin-Moens","Prey","Prigonrieux","Primarette","Primat","Prin-Deyrancon","Princay","Pringy","Prinquiau","Prisse","Privas","Prix","Prix-les-Mezieres","Proissans","Prompsat","Pronville","Propriano","Prouais","Prouilly","Prouvy","Prouzel","Provencheres-sur-Fave","Provencheres-sur-Meuse","Proveysieux","Proville","Provin","Provins","Proyart","Prudhomat","Prunay-Cassereau","Prunay-le-Gillon","Prunay-sur-Essonne","Prunelli-di-Fiumorbo","Prunieres","Pruniers","Pruzilly","Publier","Puceul","Puchevillers","Puget-sur-Argens","Puget-Ville","Pugey","Pugieu","Pugnac","Pugny-Chatenod","Puicheric","Puihardy","Puilacher","Puilboreau","Puimichel","Puiseaux","Puiseux-en-France","Puiseux-le-Hauberger","Puisieulx","Puisieux","Puissalicon","Puisseguin","Puisserguier","Pujaudran","Pujaut","Pujo-le-Plan","Pujols","Puligny-Montrachet","Pulligny","Pulnoy","Pulversheim","Pusignan","Pussay","Puteaux","Putot-en-Bessin","Puttelange-les-Thionville","Puy-Guillaume","Puy-Saint-Andre","Puy-Saint-Martin","Puybegon","Puybrun","Puycelsi","Puycornet","Puygouzon","Puygros","Puylaurens","Puyloubier","Puymiclan","Puyravault","Puyreaux","Puyricard","Quaedypre","Quarouble","Quarre-les-Tombes","Quatremare","Queaux","Quebriac","Quedillac","Queige","Quelaines-Saint-Gault","Quelneuc","Quenoche","Querenaing","Quernes","Querqueville","Querrien","Querrieu","Quers","Quesnoy-sur-Deule","Quessoy","Questembert","Quetigny","Quettehou","Quettreville-sur-Sienne","Quevauvillers","Queven","Quevert","Quevillon","Queyrac","Queyrieres","Quezac","Quiberon","Quiberville","Quibou","Quiers","Quievrechain","Quievrecourt","Quievy","Quillan","Quillebeuf-sur-Seine","Quilly","Quily","Quimper","Quincampoix","Quincie-en-Beaujolais","Quincieu","Quincy","Quincy-sous-Senart","Quincy-Voisins","Quineville","Quingey","Quinsac","Quint-Fonsegrives","Quintenic","Quintin","Quissac","Rabastens-de-Bigorre","Rabat-les-Trois-Seigneurs","Rablay-sur-Layon","Rabou","Raches","Racquinghem","Racrange","Radinghem","Radinghem-en-Weppes","Radon","Radonvilliers","Raedersheim","Raffetot","Rahon","Rai","Raids","Raimbeaucourt","Rainfreville","Rainneville","Rainville","Rainvillers","Raismes","Raizeux","Ramatuelle","Rambert","Rambervillers","Rambouillet","Rammersmatt","Ramonchamp","Ramonville-Saint-Agne","Rance","Rancogne","Randan","Randens","Ranes","Rang","Rang-du-Fliers","Rans","Ranspach","Rantigny","Ranville","Raon-aux-Bois","Raon-sur-Plaine","Rarecourt","Ratieres","Ratte","Raucourt-et-Flaba","Rauville-la-Place","Rauwiller","Rauzan","Ravenel","Ravieres","Ray-sur-Saone","Rayssac","Razac-sur-lIsle","Real","Realmont","Realville","Reaumont","Reaumur","Rebais","Rebenacq","Rebrechien","Rebreuve-sur-Canche","Rebreuviette","Recey-sur-Ource","Rechesy","Rechicourt-le-Chateau","Recloses","Recologne","Recologne-les-Rioz","Recques-sur-Course","Recquignies","Redene","Redessan","Reding","Redon","Reffuveille","Regniowez","Reguiny","Reguisheim","Regusse","Rehainviller","Rehon","Reichshoffen","Reichstett","Reignac-sur-Indre","Reignier-Esery","Reillanne","Reilly","Reims","Reims-la-Brulee","Reiners","Reiningue","Reipertswiller","Reitwiller","Relanges","Remaucourt","Remecourt","Remelfang","Remelfing","Remenoville","Remerangles","Remereville","Remering-les-Puttelange","Remigny","Remilly","Reminiac","Remiremont","Remoulins","Remungol","Remuzat","Remy","Renage","Renaison","Renault","Renaze","Rene","Renescure","Rennes","Renneville","Repaix","Reparsac","Replonges","Requeil","Requista","Ressons-le-Long","Ressons-sur-Matz","Restinclieres","Rethel","Rethondes","Retiers","Retonfey","Retournac","Retschwiller","Rettel","Rety","Reuil-en-Brie","Reuil-sur-Breche","Reuilly","Reuilly-Sauvigny","Reumont","Reuves","Revel","Revel-Tourdan","Reventin-Vaugris","Revest-des-Brousses","Reviers","Revigny","Revigny-sur-Ornain","Reville","Revin","Reynies","Reyrieux","Reyssouze","Rezonville","Rhinau","Riaille","Rians","Riantec","Ribaute-les-Tavernes","Ribecourt-Dreslincourt","Ribemont","Ribemont-sur-Ancre","Riberac","Ribiers","Ricarville","Richardmenil","Richebourg","Richelieu","Richeling","Richemont","Richwiller","Ricquebourg","Riec-sur-Belon","Riedisheim","Riedseltz","Riencourt-les-Bapaume","Rieulay","Rieumes","Rieupeyroux","Rieux","Rieux-de-Pelleport","Rieux-en-Cambresis","Rieux-Minervois","Riez","Rignac","Rignieux-le-Franc","Rilhac-Rancon","Rillieux-la-Pape","Rimbaud","Rimogne","Ringendorf","Rinxent","Riocaud","Riom","Riom-es-Montagnes","Rion-des-Landes","Rions","Riorges","Riotord","Rioz","Ris-Orangis","Rittershoffen","Rivarennes","Rive-de-Gier","Rivecourt","Rivedoux-Plage","Rivery","Rivesaltes","Riviere","Rivieres","Riville","Rixheim","Roaillan","Roanne","Roannes-Saint-Mary","Robert","Robion","Rocbaron","Roche","Roche-la-Moliere","Roche-le-Peyroux","Roche-lez-Beaupre","Rochechouart","Rochecorbon","Rochefort","Rochefort-du-Gard","Rochefort-en-Terre","Rochefort-sur-Loire","Rochefort-sur-Nenon","Rochegude","Rochemaure","Rocher","Roches","Roches-les-Blamont","Roches-Premarie-Andille","Roches-sur-Marne","Rocheserviere","Rochesson","Rochetoirin","Rochetrejoux","Rochy-Conde","Rocquemont","Rocquencourt","Rocroi","Rodelinghem","Roderen","Rodern","Rodez","Roeschwoog","Roeulx","Roeux","Roeze-sur-Sarthe","Roffey","Roffiac","Rogerville","Rognac","Rognaix","Rognes","Rognonas","Rohan","Rohr","Rohrbach-les-Bitche","Roiffieux","Roisel","Roissy-en-Brie","Roissy-en-France","Rolampont","Rollancourt","Rolleville","Rollot","Romagnat","Romagne","Romagnieu","Romain","Romain-sur-Meuse","Romaine","Romainville","Romaneche-Thorins","Romange","Romans","Rombas","Romegoux","Romeny-sur-Marne","Romeries","Romille","Romilly-sur-Andelle","Romilly-sur-Seine","Romorantin-Lanthenay","Rompon","Roncey","Ronchin","Roncq","Ronnet","Ronno","Ronsenac","Ronthon","Roost-Warendin","Roppe","Roppenheim","Roppentzwiller","Roquebilliere","Roquebrune","Roquebrune-Cap-Martin","Roquebrune-sur-Argens","Roquecor","Roquecourbe","Roquefort","Roquefort-de-Sault","Roquefort-des-Corbieres","Roquefort-la-Bedoule","Roquefort-sur-Garonne","Roquefort-sur-Soulzon","Roquelaure-Saint-Aubin","Roquemaure","Roques","Roqueseriere","Roquesteron","Roquetoire","Roquettes","Roquevaire","Rosay","Rosay-sur-Lieure","Roscoff","Rosel","Rosenwiller","Rosheim","Rosieres","Rosieres-aux-Salines","Rosieres-en-Haye","Rosieres-en-Santerre","Rosieres-pres-Troyes","Rosieres-sur-Mance","Rosny-sous-Bois","Rosny-sur-Seine","Rosoy-en-Multien","Rospez","Rosporden","Rosselange","Rossfeld","Rosteig","Rostrenen","Rosult","Rothau","Rotherens","Rots","Rott","Rouans","Roubaix","Roubia","Roubion","Roucy","Rouen","Rouffach","Rouffiac-Tolosan","Rouffignac","Rouffignac-Saint-Cernin-de-Reilhac","Rouge-Perriers","Rougegoutte","Rougemont","Rougiers","Rouillac","Rouille","Rouillon","Rouilly-Sacey","Roujan","Roulans","Roullens","Roullet-Saint-Estephe","Roumare","Roumazieres","Roumegoux","Roumoules","Rountzenheim","Rouperroux","Rousies","Roussay","Rousseloy","Rousset","Roussillon","Rousson","Roussy","Roussy-le-Village","Routot","Rouville","Rouvillers","Rouvre","Rouvres-la-Chetive","Rouvroy","Rouvroy-sur-Audry","Rouvroy-sur-Marne","Rouxmesnil-Bouteilles","Rouy-le-Grand","Rouziers-de-Touraine","Roville-aux-Chenes","Royan","Royas","Royat","Roybon","Roye","Roye-sur-Matz","Rozay-en-Brie","Rozerieulles","Rozier-en-Donzy","Rozieres-en-Beauce","Rozoy-Bellevalle","Rozoy-sur-Serre","Ruaudin","Rubelles","Rubempre","Ruch","Rucqueville","Rue","Rueil-Malmaison","Ruelisheim","Ruelle","Ruelle-sur-Touvre","Ruesnes","Ruffec","Ruffey-les-Beaune","Ruffey-les-Echirey","Ruffey-sur-Seille","Ruffiac","Rugles","Ruille-Froid-Fonds","Ruille-le-Gravelais","Ruitz","Rully","Rumaucourt","Rumegies","Rumersheim-le-Haut","Rumigny","Rumilly","Rumilly-en-Cambresis","Rungis","Ruoms","Rupt","Rupt-sur-Moselle","Rurange-les-Thionville","Russ","Ruy","Ry","Saacy-sur-Marne","Saales","Sabatier","Sable-sur-Sarthe","Sablonceaux","Sablons","Sabres","Sacey","Sachin","Saclas","Saclay","Sacquenville","Sacy","Sadirac","Saessolsheim","Saffre","Sagy","Sahurs","Saignes","Sail-sous-Couzan","Saillans","Sailly-en-Ostrevent","Sailly-Flibeaucourt","Sailly-Labourse","Sailly-le-Sec","Sailly-lez-Cambrai","Sailly-sur-la-Lys","Sain-Bel","Sainghin-en-Melantois","Sainghin-en-Weppes","Sainneville","Sainpuits","Sains-du-Nord","Sains-en-Amienois","Sains-en-Gohelle","Saint Nicolas Les Arras","Saint-Abit","Saint-Adrien","Saint-Affrique","Saint-Agathon","Saint-Agnant","Saint-Agoulin","Saint-Agreve","Saint-Aignan-des-Noyers","Saint-Aignan-sur-Roe","Saint-Aigulin","Saint-Albain","Saint-Alban-de-Roche","Saint-Alban-du-Rhone","Saint-Alban-Leysse","Saint-Alexandre","Saint-Amancet","Saint-Amand-de-Belves","Saint-Amand-de-Coly","Saint-Amand-en-Puisaye","Saint-Amand-les-Eaux","Saint-Amand-Magnazeix","Saint-Amand-Montrond","Saint-Amand-sur-Fion","Saint-Amans-Soult","Saint-Amans-Valtoret","Saint-Amant-de-Boixe","Saint-Amant-Tallende","Saint-Amarin","Saint-Ambroix","Saint-Amour","Saint-Andeol-de-Vals","Saint-Andeux","Saint-Andiol","Saint-Andre","Saint-Andre-de-Chalencon","Saint-Andre-de-Corcy","Saint-Andre-de-Messei","Saint-Andre-de-Roquelongue","Saint-Andre-de-Rosans","Saint-Andre-de-Sangonis","Saint-Andre-des-Eaux","Saint-Andre-en-Vivarais","Saint-Andre-Farivillers","Saint-Andre-le-Gaz","Saint-Andre-le-Puy","Saint-Andre-les-Alpes","Saint-Andre-les-Vergers","Saint-Andre-lez-Lille","Saint-Andre-sur-Orne","Saint-Andre-Treize-Voies","Saint-Androny","Saint-Angeau","Saint-Angel","Saint-Antoine-Cumond","Saint-Antoine-du-Rocher","Saint-Antoine-la-Foret","Saint-Antonin-sur-Bayon","Saint-Apollinaire","Saint-Appolinard","Saint-Aquilin-de-Pacy","Saint-Armel","Saint-Arnoult","Saint-Arnoult-des-Bois","Saint-Arnoult-en-Yvelines","Saint-Astier","Saint-Auban","Saint-Aubert","Saint-Aubin","Saint-Aubin-de-Baubigne","Saint-Aubin-de-Lanquais","Saint-Aubin-de-Medoc","Saint-Aubin-des-Chateaux","Saint-Aubin-du-Cormier","Saint-Aubin-du-Plain","Saint-Aubin-en-Bray","Saint-Aubin-en-Charollais","Saint-Aubin-les-Elbeuf","Saint-Aubin-les-Forges","Saint-Aubin-sous-Erquery","Saint-Aubin-sur-Gaillon","Saint-Aubin-sur-Mer","Saint-Aubin-sur-Scie","Saint-Augustin","Saint-Aunes","Saint-Avaugourd-des-Landes","Saint-Ave","Saint-Avertin","Saint-Avit","Saint-Avit-les-Guespieres","Saint-Avold","Saint-Avre","Saint-Ay","Saint-Aygulf","Saint-Baldoph","Saint-Bardoux","Saint-Barnabe","Saint-Barthelemy-de-Bussiere","Saint-Barthelemy-de-Vals","Saint-Barthelemy-Lestra","Saint-Baudille-de-la-Tour","Saint-Bauzille-de-Montmel","Saint-Bauzille-de-Putois","Saint-Beat","Saint-Benezet","Saint-Benin-dAzy","Saint-Benoit","Saint-Benoit-des-Ondes","Saint-Benoit-sur-Loire","Saint-Berain-sur-Dheune","Saint-Bernard","Saint-Beron","Saint-Berthevin","Saint-Bihy","Saint-Blaise-la-Roche","Saint-Bohaire","Saint-Boil","Saint-Boingt","Saint-Bonnet-de-Mure","Saint-Bonnet-le-Chateau","Saint-Bonnet-le-Troncy","Saint-Bonnet-les-Allier","Saint-Branchs","Saint-Brandan","Saint-Bres","Saint-Brevin-les-Pins","Saint-Briac-sur-Mer","Saint-Brice","Saint-Brice-de-Landelles","Saint-Brice-sous-Foret","Saint-Brieuc","Saint-Bris-le-Vineux","Saint-Brisson-sur-Loire","Saint-Calais","Saint-Cannat","Saint-Caprais-de-Bordeaux","Saint-Carne","Saint-Carreuc","Saint-Cassin","Saint-Cast-le-Guildo","Saint-Cere","Saint-Cergues","Saint-Cesaire","Saint-Cezaire-sur-Siagne","Saint-Cezert","Saint-Chamassy","Saint-Chamond","Saint-Chaptes","Saint-Chartres","Saint-Chef","Saint-Cheron-du-Chemin","Saint-Chinian","Saint-Christo-en-Jarez","Saint-Christol","Saint-Christol-les-Ales","Saint-Christophe-de-Valains","Saint-Christophe-du-Bois","Saint-Christophe-du-Ligneron","Saint-Christophe-en-Boucherie","Saint-Christophe-en-Brionnais","Saint-Christophe-sur-Avre","Saint-Christophe-sur-Guiers","Saint-Christophe-sur-le-Nais","Saint-Christophe-sur-Roc","Saint-Ciers-sur-Gironde","Saint-Cirgues","Saint-Clair","Saint-Clair-de-la-Tour","Saint-Clair-du-Rhone","Saint-Clair-sur-Galaure","Saint-Clar-de-Riviere","Saint-Claud","Saint-Claude","Saint-Claude-de-Diray","Saint-Clement","Saint-Clement-de-la-Place","Saint-Clement-des-Levees","Saint-Clet","Saint-Cloud","Saint-Colomban","Saint-Congard","Saint-Contest","Saint-Corneille","Saint-Cornier-des-Landes","Saint-Coulitz","Saint-Coulomb","Saint-Creac","Saint-Crepin-Ibouvillers","Saint-Crespin-sur-Moine","Saint-Cyprien","Saint-Cyprien-Plage","Saint-Cyr-du-Gault","Saint-Cyr-en-Pail","Saint-Cyr-en-Val","Saint-Cyr-la-Campagne","Saint-Cyr-le-Chatoux","Saint-Cyr-les-Champagnes","Saint-Cyr-sur-le-Rhone","Saint-Cyr-sur-Loire","Saint-Cyr-sur-Menthon","Saint-Cyr-sur-Mer","Saint-Cyr-sur-Morin","Saint-Denis","Saint-Denis-dAnjou","Saint-Denis-de-Cabanne","Saint-Denis-de-Palin","Saint-Denis-de-Pile","Saint-Denis-de-Vaux","Saint-Denis-des-Murs","Saint-Denis-en-Bugey","Saint-Denis-en-Val","Saint-Denis-le-Gast","Saint-Denis-le-Thiboult","Saint-Denis-les-Rebais","Saint-Denis-sur-Coise","Saint-Denis-sur-Sarthon","Saint-Derrien","Saint-Desir","Saint-Desirat","Saint-Desire","Saint-Dezery","Saint-Didier-de-Formans","Saint-Didier-de-la-Tour","Saint-Didier-en-Donjon","Saint-Didier-en-Velay","Saint-Didier-sous-Riverie","Saint-Didier-sur-Chalaronne","Saint-Didier-sur-Rochefort","Saint-Die-des-Vosges","Saint-Dionisy","Saint-Disdier","Saint-Divy","Saint-Dizier","Saint-Dizier-en-Diois","Saint-Dolay","Saint-Domet","Saint-Domineuc","Saint-Donan","Saint-Doulchard","Saint-Drezery","Saint-Ebremond-de-Bonfosse","Saint-Elier","Saint-Eliph","Saint-Elix-Seglan","Saint-Eloi","Saint-Eloy-de-Gy","Saint-Eloy-la-Glaciere","Saint-Eloy-les-Mines","Saint-Emilion","Saint-Erblon","Saint-Erme-Outre-et-Ramecourt","Saint-Esteve","Saint-Esteve-Janson","Saint-Etienne","Saint-Etienne-au-Mont","Saint-Etienne-au-Temple","Saint-Etienne-de-Baigorry","Saint-Etienne-de-Brillouet","Saint-Etienne-de-Crossey","Saint-Etienne-de-Cuines","Saint-Etienne-de-Fontbellon","Saint-Etienne-de-Montluc","Saint-Etienne-de-Saint-Geoirs","Saint-Etienne-de-Tinee","Saint-Etienne-de-Tulmont","Saint-Etienne-de-Valoux","Saint-Etienne-des-Oullieres","Saint-Etienne-du-Bois","Saint-Etienne-du-Gres","Saint-Etienne-du-Valdonnez","Saint-Etienne-du-Vauvray","Saint-Etienne-en-Cogles","Saint-Etienne-la-Varenne","Saint-Etienne-le-Molard","Saint-Etienne-les-Orgues","Saint-Etienne-sous-Bailleul","Saint-Etienne-sur-Chalaronne","Saint-Etienne-sur-Suippe","Saint-Eulien","Saint-Eustache-la-Foret","Saint-Evarzec","Saint-Faust","Saint-Felicien","Saint-Felix-de-Rieutord","Saint-Felix-de-Villadeix","Saint-Fiacre","Saint-Fiacre-sur-Maine","Saint-Firmin","Saint-Firmin-des-Pres","Saint-Florent","Saint-Florent-le-Vieil","Saint-Florent-sur-Auzonnet","Saint-Florent-sur-Cher","Saint-Florentin","Saint-Floret","Saint-Floris","Saint-Flour","Saint-Flovier","Saint-Folquin","Saint-Fons","Saint-Forgeux","Saint-Fort","Saint-Fregant","Saint-Fromond","Saint-Front","Saint-Fulgent","Saint-Fuscien","Saint-Galmier","Saint-Gatien-des-Bois","Saint-Gaudens","Saint-Gaultier","Saint-Gein","Saint-Gelais","Saint-Gely-du-Fesc","Saint-Gence","Saint-Generoux","Saint-Genes-du-Retz","Saint-Genest-Lerpt","Saint-Genest-Malifaux","Saint-Gengoux-de-Scisse","Saint-Genies-Bellevue","Saint-Genies-de-Comolas","Saint-Genies-de-Malgoires","Saint-Genies-des-Mourgues","Saint-Genis-Laval","Saint-Genis-les-Ollieres","Saint-Genis-Pouilly","Saint-Genix-sur-Guiers","Saint-Genou","Saint-Geoire-en-Valdaine","Saint-Geoirs","Saint-Georges-de-Baroille","Saint-Georges-de-Didonne","Saint-Georges-de-Luzencon","Saint-Georges-de-Montaigu","Saint-Georges-de-Pointindoux","Saint-Georges-de-Poisieux","Saint-Georges-de-Reneins","Saint-Georges-des-Coteaux","Saint-Georges-du-Bois","Saint-Georges-du-Rosay","Saint-Georges-du-Vievre","Saint-Georges-Haute-Ville","Saint-Georges-le-Flechard","Saint-Georges-les-Baillargeaux","Saint-Georges-Montcocq","Saint-Georges-sur-Allier","Saint-Georges-sur-Arnon","Saint-Georges-sur-Baulche","Saint-Georges-sur-Cher","Saint-Georges-sur-Eure","Saint-Georges-sur-Fontaine","Saint-Georges-sur-Loire","Saint-Georges-sur-Renon","Saint-Gerand","Saint-Gerand-de-Vaux","Saint-Gereon","Saint-Germain","Saint-Germain-de-Joux","Saint-Germain-de-la-Grange","Saint-Germain-de-Princay","Saint-Germain-de-Tournebut","Saint-Germain-des-Fosses","Saint-Germain-des-Pres","Saint-Germain-du-Corbeis","Saint-Germain-du-Plain","Saint-Germain-du-Puch","Saint-Germain-du-Puy","Saint-Germain-en-Laye","Saint-Germain-la-Blanche-Herbe","Saint-Germain-la-Ville","Saint-Germain-Langot","Saint-Germain-Laprade","Saint-Germain-Laxis","Saint-Germain-Lembron","Saint-Germain-les-Arpajon","Saint-Germain-les-Belles","Saint-Germain-les-Corbeil","Saint-Germain-les-Paroisses","Saint-Germain-les-Vergnes","Saint-Germain-Nuelles","Saint-Germain-sous-Doue","Saint-Germain-sur-Avre","Saint-Germain-sur-Moine","Saint-Germain-sur-Morin","Saint-Germain-sur-Rhone","Saint-Germain-Village","Saint-Germainmont","Saint-Germer-de-Fly","Saint-Gervais-en-Belin","Saint-Gervais-la-Foret","Saint-Gervais-les-Bains","Saint-Gervais-sous-Meymont","Saint-Gervais-sur-Roubion","Saint-Gervazy","Saint-Geyrac","Saint-Gildas-des-Bois","Saint-Gilles","Saint-Gilles-des-Marais","Saint-Gilles-les-Bois","Saint-Gingolph","Saint-Girons","Saint-Goazec","Saint-Gobain","Saint-Gondon","Saint-Gondran","Saint-Gonnery","Saint-Gratien","Saint-Grave","Saint-Gregoire","Saint-Guilhem-le-Desert","Saint-Guinoux","Saint-Heand","Saint-Helen","Saint-Herblain","Saint-Herve","Saint-Hilaire-Cusson-la-Valmitte","Saint-Hilaire-de-Brethmas","Saint-Hilaire-de-Chaleons","Saint-Hilaire-de-Court","Saint-Hilaire-de-la-Cote","Saint-Hilaire-de-Loulay","Saint-Hilaire-de-Riez","Saint-Hilaire-de-Talmont","Saint-Hilaire-de-Voust","Saint-Hilaire-du-Harcouet","Saint-Hilaire-le-Vouhis","Saint-Hilaire-les-Andresis","Saint-Hilaire-les-Courbes","Saint-Hilaire-lez-Cambrai","Saint-Hilaire-Peyroux","Saint-Hilaire-Saint-Mesmin","Saint-Hilarion","Saint-Hilliers","Saint-Hippolyte","Saint-Hippolyte-de-Montaigu","Saint-Hippolyte-du-Fort","Saint-Honore-les-Bains","Saint-Hostien","Saint-Igneuc","Saint-Illide","Saint-Imoges","Saint-Ismier","Saint-Jacques-de-la-Lande","Saint-Jean-aux-Amognes","Saint-Jean-Bonnefonds","Saint-Jean-Brevelay","Saint-Jean-de-Boiseau","Saint-Jean-de-Bournay","Saint-Jean-de-Braye","Saint-Jean-de-Chevelu","Saint-Jean-de-Cornies","Saint-Jean-de-Gonville","Saint-Jean-de-la-Ruelle","Saint-Jean-de-Laur","Saint-Jean-de-Lier","Saint-Jean-de-Liversay","Saint-Jean-de-Losne","Saint-Jean-de-Luz","Saint-Jean-de-Marcel","Saint-Jean-de-Marsacq","Saint-Jean-de-Maurienne","Saint-Jean-de-Moirans","Saint-Jean-de-Monts","Saint-Jean-de-Muzols","Saint-Jean-de-Sauves","Saint-Jean-de-Serres","Saint-Jean-de-Sixt","Saint-Jean-de-Soudain","Saint-Jean-de-Vedas","Saint-Jean-des-Baisants","Saint-Jean-des-Champs","Saint-Jean-des-Mauvrets","Saint-Jean-des-Ollieres","Saint-Jean-des-Vignes","Saint-Jean-du-Bruel","Saint-Jean-du-Cardonnay","Saint-Jean-du-Falga","Saint-Jean-en-Royans","Saint-Jean-Kerdaniel","Saint-Jean-Kourtzerode","Saint-Jean-la-Poterie","Saint-Jean-Lasseille","Saint-Jean-le-Blanc","Saint-Jean-le-Centenier","Saint-Jean-le-Thomas","Saint-Jean-les-Deux-Jumeaux","Saint-Jean-Ligoure","Saint-Jean-Pied-de-Port","Saint-Jean-Rohrbach","Saint-Jean-Saint-Germain","Saint-Jean-sur-Erve","Saint-Jean-sur-Vilaine","Saint-Jean-Trolimon","Saint-Jeannet","Saint-Jeoire","Saint-Jeoire-Prieure","Saint-Jeures","Saint-Joachim","Saint-Jorioz","Saint-Jory","Saint-Joseph-de-Riviere","Saint-Jouan-des-Guerets","Saint-Jouvent","Saint-Judoce","Saint-Julien","Saint-Julien-de-Cassagnas","Saint-Julien-de-Chedon","Saint-Julien-de-Concelles","Saint-Julien-de-Coppel","Saint-Julien-de-Lampon","Saint-Julien-de-Vouvantes","Saint-Julien-des-Landes","Saint-Julien-du-Puy","Saint-Julien-du-Sault","Saint-Julien-en-Born","Saint-Julien-en-Champsaur","Saint-Julien-en-Genevois","Saint-Julien-le-Roux","Saint-Julien-le-Vendomois","Saint-Julien-les-Metz","Saint-Julien-les-Villas","Saint-Julien-sur-Bibost","Saint-Julien-sur-Sarthe","Saint-Junien","Saint-Just-Chaleyssin","Saint-Just-de-Claix","Saint-Just-en-Bas","Saint-Just-en-Chaussee","Saint-Just-en-Chevalet","Saint-Just-le-Martel","Saint-Just-Malmont","Saint-Just-pres-Brioude","Saint-Lactencin","Saint-Lager","Saint-Lager-Bressac","Saint-Lambert-du-Lattay","Saint-Lambert-la-Potherie","Saint-Lambert-sur-Dive","Saint-Lanne","Saint-Lary-Boujean","Saint-Lary-Soulan","Saint-Launeuc","Saint-Laurent-Blangy","Saint-Laurent-Bretagne","Saint-Laurent-de-la-Plaine","Saint-Laurent-de-la-Pree","Saint-Laurent-de-la-Salanque","Saint-Laurent-de-Levezou","Saint-Laurent-de-Mure","Saint-Laurent-de-Neste","Saint-Laurent-des-Autels","Saint-Laurent-des-Combes","Saint-Laurent-du-Bois","Saint-Laurent-du-Mottay","Saint-Laurent-du-Pont","Saint-Laurent-du-Var","Saint-Laurent-en-Beaumont","Saint-Laurent-en-Gatines","Saint-Laurent-la-Roche","Saint-Laurent-Rochefort","Saint-Laurent-sur-Gorre","Saint-Laurent-sur-Sevre","Saint-Laurs","Saint-Leger-aux-Bois","Saint-Leger-de-Rotes","Saint-Leger-des-Vignes","Saint-Leger-du-Bourg-Denis","Saint-Leger-en-Bray","Saint-Leger-les-Domart","Saint-Leger-sous-Brienne","Saint-Leger-sous-Cholet","Saint-Leger-sur-Dheune","Saint-Leonard","Saint-Leonard-de-Noblat","Saint-Leu-la-Foret","Saint-Lezin","Saint-Lieux-les-Lavaur","Saint-Lormel","Saint-Loubes","Saint-Louis","Saint-Louis-de-Montferrand","Saint-Loup","Saint-Loup-Cammas","Saint-Loup-Hors","Saint-Lubin-des-Joncherets","Saint-Lumier-en-Champagne","Saint-Lumine-de-Clisson","Saint-Luperce","Saint-Lupicin","Saint-Lye","Saint-Lye-la-Foret","Saint-Lyphard","Saint-Lys","Saint-Macaire","Saint-Macaire-du-Bois","Saint-Macaire-en-Mauges","Saint-Magne-de-Castillon","Saint-Maigner","Saint-Maigrin","Saint-Maime","Saint-Maixant","Saint-Malo-de-Guersac","Saint-Malo-de-la-Lande","Saint-Malo-de-Phily","Saint-Malo-du-Bois","Saint-Malo-en-Donziois","Saint-Mamert-du-Gard","Saint-Mamet-la-Salvetat","Saint-Mammes","Saint-Mande","Saint-Mandrier-sur-Mer","Saint-Marc-Jaumegarde","Saint-Marceau","Saint-Marcel-Bel-Accueil","Saint-Marcel-les-Valence","Saint-Marcel-sur-Aude","Saint-Marcellin","Saint-Marcellin-en-Forez","Saint-Mard","Saint-Mard-de-Vaux","Saint-Mariens","Saint-Mars-de-Coutais","Saint-Mars-de-Locquenay","Saint-Mars-du-Desert","Saint-Mars-la-Jaille","Saint-Martial","Saint-Martial-de-Vitaterne","Saint-Martin-au-Laert","Saint-Martin-Belle-Roche","Saint-Martin-Bellevue","Saint-Martin-Boulogne","Saint-Martin-Choquel","Saint-Martin-de-Belleville","Saint-Martin-de-Bernegoue","Saint-Martin-de-Blagny","Saint-Martin-de-Crau","Saint-Martin-de-Fontenay","Saint-Martin-de-la-Brasque","Saint-Martin-de-Lenne","Saint-Martin-de-Londres","Saint-Martin-de-Nigelles","Saint-Martin-de-Re","Saint-Martin-de-Riberac","Saint-Martin-de-Seignanx","Saint-Martin-de-Valamas","Saint-Martin-de-Valgalgues","Saint-Martin-des-Bois","Saint-Martin-des-Champs","Saint-Martin-des-Noyers","Saint-Martin-des-Olmes","Saint-Martin-du-Bois","Saint-Martin-du-Bosc","Saint-Martin-du-Manoir","Saint-Martin-du-Mont","Saint-Martin-du-Puy","Saint-Martin-du-Tertre","Saint-Martin-du-Tilleul","Saint-Martin-du-Var","Saint-Martin-en-Biere","Saint-Martin-en-Bresse","Saint-Martin-en-Campagne","Saint-Martin-en-Gatinois","Saint-Martin-en-Haut","Saint-Martin-la-Campagne","Saint-Martin-la-Plaine","Saint-Martin-Lacaussade","Saint-Martin-Lalande","Saint-Martin-le-Beau","Saint-Martin-le-Noeud","Saint-Martin-le-Pin","Saint-Martin-le-Vieil","Saint-Martin-le-Vinoux","Saint-Martin-les-Melle","Saint-Martin-Longueau","Saint-Martin-Osmonville","Saint-Martin-Sainte-Catherine","Saint-Martin-sur-Arve","Saint-Martin-sur-le-Pre","Saint-Martin-sur-Nohain","Saint-Martin-sur-Ocre","Saint-Martin-Terressus","Saint-Martin-Valmeroux","Saint-Mary","Saint-Mathieu-de-Treviers","Saint-Mathurin","Saint-Maudan","Saint-Maulvis","Saint-Maurice","Saint-Maurice-de-Cazevieille","Saint-Maurice-de-Gourdans","Saint-Maurice-de-Lignon","Saint-Maurice-de-Remens","Saint-Maurice-la-Clouere","Saint-Maurice-la-Souterraine","Saint-Maurice-les-Brousses","Saint-Maurice-Montcouronne","Saint-Maurice-sur-Aveyron","Saint-Maurice-sur-Dargoire","Saint-Maurice-sur-Eygues","Saint-Maurice-sur-Fessard","Saint-Maurice-sur-Moselle","Saint-Max","Saint-Maxent","Saint-Maximin","Saint-Maximin-la-Sainte-Baume","Saint-Maxire","Saint-Meard-de-Gurcon","Saint-Medard-de-Guizieres","Saint-Medard-en-Forez","Saint-Meen-le-Grand","Saint-Melaine-sur-Aubance","Saint-Meloir-des-Ondes","Saint-Meme-les-Carrieres","Saint-Memmie","Saint-Michel","Saint-Michel-Chef-Chef","Saint-Michel-de-Chabrillanoux","Saint-Michel-de-Maurienne","Saint-Michel-de-Rieufret","Saint-Michel-de-Volangis","Saint-Michel-des-Andaines","Saint-Michel-le-Cloucq","Saint-Michel-lObservatoire","Saint-Michel-Mont-Mercure","Saint-Michel-sous-Bois","Saint-Michel-sur-Meurthe","Saint-Michel-sur-Orge","Saint-Michel-sur-Savasse","Saint-Michel-sur-Ternoise","Saint-Michel-Treve","Saint-Mihiel","Saint-Mitre-les-Remparts","Saint-Morillon","Saint-Nabord","Saint-Nauphary","Saint-Nazaire","Saint-Nazaire-de-Valentane","Saint-Nectaire","Saint-Nicolas-de-Bliquetuit","Saint-Nicolas-de-la-Grave","Saint-Nicolas-de-Port","Saint-Nicolas-de-Redon","Saint-Nicolas-du-Pelem","Saint-Nolff","Saint-Nom-la-Breteche","Saint-Offenge-Dessous","Saint-Offenge-Dessus","Saint-Omer","Saint-Omer-en-Chaussee","Saint-Orens-de-Gameville","Saint-Orens-Pouy-Petit","Saint-Ouen","Saint-Ouen-de-Thouberville","Saint-Ouen-des-Besaces","Saint-Ouen-des-Toits","Saint-Ouen-du-Breuil","Saint-Ouen-du-Mesnil-Oger","Saint-Ouen-du-Tilleul","Saint-Ouen-en-Brie","Saint-Ouen-les-Parey","Saint-Ouen-sur-Iton","Saint-Ouen-sur-Morin","Saint-Oulph","Saint-Ours","Saint-Pabu","Saint-Pair-du-Mont","Saint-Pair-sur-Mer","Saint-Pal-de-Mons","Saint-Palais","Saint-Pancre","Saint-Pandelon","Saint-Pantaleon-de-Larche","Saint-Papoul","Saint-Pardoux-du-Breuil","Saint-Pargoire","Saint-Parize-le-Chatel","Saint-Parres-aux-Tertres","Saint-Parres-les-Vaudes","Saint-Paterne","Saint-Paterne-Racan","Saint-Pathus","Saint-Patrice-de-Claids","Saint-Paul","Saint-Paul-de-Jarrat","Saint-Paul-de-Varces","Saint-Paul-de-Vence","Saint-Paul-de-Vezelin","Saint-Paul-du-Vernay","Saint-Paul-en-Chablais","Saint-Paul-en-Cornillon","Saint-Paul-en-Foret","Saint-Paul-en-Jarez","Saint-Paul-en-Pareds","Saint-Paul-les-Dax","Saint-Paul-les-Durance","Saint-Paul-les-Romans","Saint-Paul-Trois-Chateaux","Saint-Paulet-de-Caisson","Saint-Pee-sur-Nivelle","Saint-Pellerin","Saint-Peray","Saint-Perdon","Saint-Pere","Saint-Pere-en-Retz","Saint-Pern","Saint-Philbert-de-Bouaine","Saint-Philbert-de-Grand-Lieu","Saint-Philbert-du-Pont-Charrault","Saint-Philibert","Saint-Piat","Saint-Pierre-Bois","Saint-Pierre-Brouck","Saint-Pierre-dAllevard","Saint-Pierre-de-Boeuf","Saint-Pierre-de-Bressieux","Saint-Pierre-de-Chandieu","Saint-Pierre-de-Jards","Saint-Pierre-de-Lages","Saint-Pierre-de-Maille","Saint-Pierre-de-Mons","Saint-Pierre-de-Plesguen","Saint-Pierre-de-Trivisy","Saint-Pierre-de-Varengeville","Saint-Pierre-de-Varennes","Saint-Pierre-des-Corps","Saint-Pierre-des-Echaubrognes","Saint-Pierre-des-Fleurs","Saint-Pierre-du-Chemin","Saint-Pierre-du-Mont","Saint-Pierre-du-Palais","Saint-Pierre-du-Perray","Saint-Pierre-du-Regard","Saint-Pierre-du-Vauvray","Saint-Pierre-en-Port","Saint-Pierre-en-Val","Saint-Pierre-la-Bourlhonne","Saint-Pierre-la-Cour","Saint-Pierre-la-Garenne","Saint-Pierre-la-Palud","Saint-Pierre-Lavis","Saint-Pierre-le-Chastel","Saint-Pierre-le-Moutier","Saint-Pierre-le-Vieux","Saint-Pierre-les-Elbeuf","Saint-Pierre-Montlimart","Saint-Pierre-sur-Dives","Saint-Pierre-Tarentaine","Saint-Pierreville","Saint-Pol-sur-Mer","Saint-Pol-sur-Ternoise","Saint-Pompont","Saint-Pont","Saint-Porchaire","Saint-Porquier","Saint-Pouange","Saint-Pourcain-sur-Sioule","Saint-Prest","Saint-Priest-des-Champs","Saint-Priest-en-Jarez","Saint-Priest-la-Roche","Saint-Priest-la-Vetre","Saint-Priest-Taurion","Saint-Prim","Saint-Privat","Saint-Privat-de-Vallongue","Saint-Privat-la-Montagne","Saint-Prix","Saint-Projet","Saint-Prouant","Saint-Pryve-Saint-Mesmin","Saint-Python","Saint-Quay-Perros","Saint-Quay-Portrieux","Saint-Quentin","Saint-Quentin-de-Baron","Saint-Quentin-du-Dropt","Saint-Quentin-en-Mauges","Saint-Quentin-Fallavier","Saint-Quentin-la-Poterie","Saint-Quentin-le-Verger","Saint-Quentin-les-Chardonnets","Saint-Quentin-sur-Indrois","Saint-Quentin-sur-le-Homme","Saint-Rambert-en-Bugey","Saint-Regle","Saint-Remeze","Saint-Remimont","Saint-Remy","Saint-Remy-du-Nord","Saint-Remy-en-Mauges","Saint-Remy-en-Rollat","Saint-Remy-la-Vanne","Saint-Remy-la-Varenne","Saint-Remy-les-Chevreuse","Saint-Remy-sur-Avre","Saint-Remy-sur-Durolle","Saint-Renan","Saint-Reverien","Saint-Riquier","Saint-Rirand","Saint-Robert","Saint-Roch","Saint-Rogatien","Saint-Romain-de-Colbosc","Saint-Romain-de-Lerps","Saint-Romain-en-Gal","Saint-Romain-en-Gier","Saint-Romain-la-Motte","Saint-Romain-la-Virvee","Saint-Romain-Lachalm","Saint-Romain-le-Preux","Saint-Romain-le-Puy","Saint-Romain-les-Atheux","Saint-Rome-de-Tarn","Saint-Saens","Saint-Saire","Saint-Samson-sur-Rance","Saint-Sandoux","Saint-Sardos","Saint-Saturnin-du-Limet","Saint-Saturnin-les-Apt","Saint-Saturnin-les-Avignon","Saint-Saturnin-sur-Loire","Saint-Saulge","Saint-Saulve","Saint-Sauvant","Saint-Sauveur-dAunis","Saint-Sauveur-de-Montagut","Saint-Sauveur-Gouvernet","Saint-Sauveur-la-Sagne","Saint-Sauveur-le-Vicomte","Saint-Sauveur-Lendelin","Saint-Savin","Saint-Savinien","Saint-Saviol","Saint-Savournin","Saint-Sebastien","Saint-Sebastien-de-Morsent","Saint-Secondin","Saint-Segal","Saint-Seglin","Saint-Seine-sur-Vingeanne","Saint-Selve","Saint-Senoch","Saint-Senoux","Saint-Series","Saint-Sernin","Saint-Sernin-du-Bois","Saint-Servant","Saint-Seurin-de-Cadourne","Saint-Seurin-de-Cursac","Saint-Seurin-de-Prats","Saint-Sever","Saint-Sever-Calvados","Saint-Siffret","Saint-Sigismond","Saint-Simeon-de-Bressieux","Saint-Simon","Saint-Simon-de-Pellouaille","Saint-Sixt","Saint-Sixte","Saint-Sorlin-en-Valloire","Saint-Souplet","Saint-Soupplets","Saint-Suliac","Saint-Sulpice-de-Faleyrens","Saint-Sulpice-de-Royan","Saint-Sulpice-et-Cameyrac","Saint-Sulpice-la-Foret","Saint-Sulpice-le-Vieux","Saint-Sulpice-les-Feuilles","Saint-Sulpice-sur-Leze","Saint-Sulpice-sur-Risle","Saint-Sylvain","Saint-Sylvestre-sur-Lot","Saint-Symphorien-de-Lay","Saint-Symphorien-dOzon","Saint-Symphorien-sur-Coise","Saint-Symphorien-sur-Saone","Saint-Theodorit","Saint-Thibaud-de-Couz","Saint-Thibault","Saint-Thibault-des-Vignes","Saint-Thibery","Saint-Thierry","Saint-Thurial","Saint-Trivier-de-Courtes","Saint-Trivier-sur-Moignans","Saint-Trojan-les-Bains","Saint-Tropez","Saint-Tugdual","Saint-Urbain","Saint-Urbain-Maconcourt","Saint-Usage","Saint-Uze","Saint-Vaast-du-Val","Saint-Vaast-en-Auge","Saint-Vaast-la-Hougue","Saint-Vaast-les-Mello","Saint-Valery-en-Caux","Saint-Valery-sur-Somme","Saint-Vallier","Saint-Vallier-de-Thiey","Saint-Varent","Saint-Vaury","Saint-Venant","Saint-Verand","Saint-Viance","Saint-Viatre","Saint-Viaud","Saint-Victor-de-Cessieu","Saint-Victor-la-Coste","Saint-Victor-sur-Arlanc","Saint-Victor-sur-Loire","Saint-Victor-sur-Rhins","Saint-Victoret","Saint-Victurnien","Saint-Vigor","Saint-Vincent-de-Connezac","Saint-Vincent-de-Durfort","Saint-Vincent-de-Paul","Saint-Vincent-de-Tyrosse","Saint-Vincent-des-Landes","Saint-Vincent-sur-Graon","Saint-Vit","Saint-Vital","Saint-Vite","Saint-Vivien","Saint-Vivien-de-Medoc","Saint-Vrain","Saint-Vulbas","Saint-Witz","Saint-Xandre","Saint-Ybars","Saint-Yorre","Saint-Yrieix-la-Perche","Saint-Yrieix-sur-Charente","Saint-Yvi","Saint-Yzan-de-Soudiac","Saint-Zacharie","Sainte-Adresse","Sainte-Anastasie-sur-Issole","Sainte-Anne-Saint-Priest","Sainte-Anne-sur-Vilaine","Sainte-Austreberthe","Sainte-Bazeille","Sainte-Blandine","Sainte-Catherine","Sainte-Cecile","Sainte-Colombe-de-Duras","Sainte-Colombe-sur-Gand","Sainte-Colombe-sur-Guette","Sainte-Consorce","Sainte-Croix","Sainte-Croix-aux-Mines","Sainte-Croix-en-Jarez","Sainte-Croix-en-Plaine","Sainte-Croix-Grand-Tonne","Sainte-Croix-Hague","Sainte-Croix-Volvestre","Sainte-Eanne","Sainte-Enimie","Sainte-Eulalie-en-Born","Sainte-Eusoye","Sainte-Fauste","Sainte-Fereole","Sainte-Flaive-des-Loups","Sainte-Florence","Sainte-Florine","Sainte-Fortunade","Sainte-Foy-de-Longas","Sainte-Foy-de-Peyrolieres","Sainte-Foy-la-Grande","Sainte-Foy-les-Lyon","Sainte-Gemme-la-Plaine","Sainte-Gemme-Martaillac","Sainte-Genevieve","Sainte-Helene","Sainte-Hermine","Sainte-Honorine-du-Fay","Sainte-Livrade-sur-Lot","Sainte-Luce-sur-Loire","Sainte-Lucie de Porto-Vecchio","Sainte-Lucie-de-Tallano","Sainte-Marguerite","Sainte-Marguerite-des-Loges","Sainte-Marie","Sainte-Marie-aux-Chenes","Sainte-Marie-aux-Mines","Sainte-Marie-Cappel","Sainte-Marie-de-Chignac","Sainte-Marie-de-Cuines","Sainte-Marie-de-Re","Sainte-Marie-du-Mont","Sainte-Marie-Kerque","Sainte-Marie-Laumont","Sainte-Maure-de-Touraine","Sainte-Maxime","Sainte-Menehould","Sainte-Mere-Eglise","Sainte-Neomaye","Sainte-Opportune-du-Bosc","Sainte-Ouenne","Sainte-Pazanne","Sainte-Preuve","Sainte-Radegonde","Sainte-Reine-de-Bretagne","Sainte-Sabine-sur-Longeve","Sainte-Savine","Sainte-Seve","Sainte-Sigolene","Sainte-Solange","Sainte-Soulle","Sainte-Suzanne","Sainte-Terre","Sainte-Tulle","Sainte-Valiere","Sainte-Verge","Saintes","Saintes-Maries-de-la-Mer","Saintry-sur-Seine","Saints","Saints-Geosmes","Sainville","Saissac","Saisseval","Saivres","Saix","Salagnon","Salaise-sur-Sanne","Salans","Salbert","Salbris","Saleich","Saleilles","Salernes","Salers","Sales","Saleux","Salies-de-Bearn","Salies-du-Salat","Saligny","Saligny-le-Vif","Saligny-sur-Roudon","Salin-de-Giraud","Salindres","Salins","Salins-les-Bains","Salins-les-Thermes","Sallanches","Sallaumines","Salleboeuf","Sallertaine","Salles-de-Barbezieux","Salles-la-Source","Salles-Mongiscard","Salles-sur-Mer","Salome","Salon-de-Provence","Salouel","Salses-le-Chateau","Salvagnac","Salviac","Salvizinet","Salzuit","Samadet","Samatan","Samazan","Sambin","Sameon","Samer","Samognat","Samois-sur-Seine","Samoreau","Sampigny-les-Maranges","Samson","San-Giuliano","San-Nicolao","Sanary-sur-Mer","Sancerre","Sanchey","Sancourt","Sand","Sandillon","Sandouville","Sandrans","Sangatte","Sanguinet","Sannerville","Sannois","Sansais","Sant Andreu de Sureda","Sant Genis de Fontanes","Sant Joan de Pladecorts","Santa-Maria-Poggio","Santeny","Santes","Santeuil","Santranges","Sanvignes-les-Mines","Sanxay","Saone","Sapogne-et-Feucheres","Sapogne-sur-Marche","Saramon","Saran","Sarcelles","Sarcey","Sarcicourt","Sardan","Sardieu","Sardon","Sare","Sarge-sur-Braye","Sarliac-sur-lIsle","Sarralbe","Sarraltroff","Sarrant","Sarras","Sarrazac","Sarre","Sarre-Union","Sarrebourg","Sarreguemines","Sarrey","Sarrians","Sarrola-Carcopino","Sarry","Sars-Poteries","Sartrouville","Sarzeau","Sassay","Sassenage","Sassenay","Sassey-sur-Meuse","Sathonay-Camp","Sathonay-Village","Satillieu","Satolas-et-Bonce","Saubens","Saubion","Saubrigues","Saubusse","Saucats","Saudoy","Saugon","Saugues","Saujon","Saulces-Monclin","Saulcy-sur-Meurthe","Saules","Saulge","Saulieu","Saulnes","Saulnieres","Saulnot","Saulny","Saulon-la-Chapelle","Saulon-la-Rue","Sault","Sault-Brenaz","Sault-les-Rethel","Sault-Saint-Remy","Saultain","Saulx-les-Chartreux","Saulx-Marchais","Saulxures","Saulxures-les-Nancy","Saulxures-sur-Moselotte","Saulzoir","Saumane-de-Vaucluse","Saumeray","Saumur","Saurat","Sauret-Besserve","Sausheim","Saussan","Saussay-la-Campagne","Saussemesnil","Saussenac","Sausset-les-Pins","Saussey","Saussines","Sautel","Sauteyrargues","Sautron","Sauvage","Sauvagney","Sauvagnon","Sauvat","Sauve","Sauverny","Sauvessanges","Sauveterre","Sauveterre-de-Bearn","Sauveterre-de-Comminges","Sauveterre-de-Guyenne","Sauveterre-la-Lemance","Sauvian","Sauvigney-les-Pesmes","Sauvigny-les-Bois","Sauxillanges","Sauze","Sauze-Vaussais","Sauzelles","Sauzet","Sauzon","Savasse","Savenay","Savennieres","Saverdun","Saverne","Savieres","Savignac-les-Eglises","Savignac-sur-Leyze","Savigne","Savigne-sous-le-Lude","Savigneux","Savigny","Savigny-en-Revermont","Savigny-en-Septaine","Savigny-le-Sec","Savigny-le-Temple","Savigny-les-Beaune","Savigny-sur-Braye","Savigny-sur-Clairis","Savigny-sur-Orge","Savoie","Savonnieres","Savouges","Savoyeux","Savy","Savy-Berlette","Sayat","Scaer","Sceaux","Sceaux-du-Gatinais","Sceaux-sur-Huisne","Scharrachbergheim-Irmstett","Scherwiller","Schillersdorf","Schiltigheim","Schirmeck","Schirrhein","Schmittviller","Schnersheim","Schoeneck","Schopperten","Schorbach","Schweighouse-Thann","Schwenheim","Scientrier","Sciez","Scionzier","Scorbe-Clairvaux","Scrignac","Scy-Chazelles","Sebazac-Concoures","Sebecourt","Sebourg","Secheval","Seclin","Secondigny","Sedan","Sedzere","Sees","Seez","Segalas","Segny","Segonzac","Segonzat","Segre","Segrie","Segry","Seichamps","Seiches-sur-le-Loir","Seignalens","Seignelay","Seignosse","Seilh","Seilhac","Seine-Port","Seingbouse","Seissan","Selle","Selles","Selles-Saint-Denis","Selles-sur-Cher","Selles-sur-Nahon","Sellieres","Selommes","Seloncourt","Selongey","Seltz","Semalens","Semblancay","Semeac","Semeacq-Blachon","Semecourt","Semoine","Semoutiers-Montsaon","Semoy","Sempigny","Semur-en-Brionnais","Senan","Senas","Sendets","Sene","Senlecques","Senlis","Sennece-les-Macon","Sennecey-le-Grand","Sennely","Senneville-sur-Fecamp","Senonches","Senones","Senonges","Senozan","Sens","Sens-de-Bretagne","Sentheim","Senuc","Sepmeries","Seppois-le-Bas","Seppois-le-Haut","Sept-Forges","Sept-Saulx","Septeme","Septemes-les-Vallons","Septeuil","Septfonds","Septvaux","Sequedin","Seraincourt","Serans","Seraucourt-le-Grand","Serbannes","Serdinya","Sereilhac","Serein","Seremange-Erzange","Serent","Serezin-de-la-Tour","Serezin-du-Rhone","Sergeac","Sergy","Serifontaine","Serignan","Serignan-du-Comtat","Serigne","Sermaises","Sermamagny","Sermerieu","Sermoise","Sermoyer","Sernhac","Serocourt","Seronville","Serques","Serquigny","Serre-les-Sapins","Serres","Serres-Castet","Serres-Gaston","Serres-Morlaas","Serres-Sainte-Marie","Serres-sur-Arget","Serrieres","Serrieres-de-Briord","Serrieres-en-Chautagne","Serris","Serrouville","Sers","Servais","Servance","Servant","Servas","Servaville-Salmonville","Servian","Servon","Servon-sur-Vilaine","Sery","Sery-les-Mezieres","Sessenheim","Seugy","Seuil","Seuillet","Seurre","Sevelinges","Severac","Severac-le-Chateau","Seveux","Sevran","Sevres-Anxaumont","Sevrey","Sevrier","Sewen","Sexey-aux-Forges","Seyches","Seyne-les-Alpes","Seynod","Seyre","Seyssel","Seysses","Seyssinet","Seyssinet-Pariset","Seyssins","Seyssuel","Sezanne","Sibiril","Siccieu-Saint-Julien-et-Carisieu","Siegen","Sierck-les-Bains","Sierentz","Sierville","Sigean","Sigloy","Signes","Signy","Signy-le-Petit","Signy-Signets","Sigogne","Sigoules","Sigournais","Sigy-en-Bray","Silfiac","Sillans","Sille-le-Guillaume","Sillery","Sillingy","Silly-la-Poterie","Silly-le-Long","Silly-sur-Nied","Silly-Tillard","Simandre","Simandres","Simiane-Collongue","Simorre","Sin-le-Noble","Sinard","Sinceny","Sion-les-Mines","Siran","Sireuil","Siros","Sisco","Sissonne","Sissy","Sisteron","Sivry-Courtry","Sivry-sur-Meuse","Six-Fours-les-Plages","Sizun","Smarves","Sochaux","Soignolles-en-Brie","Soing-Cubry-Charentenay","Soissons","Soissons-sur-Nacey","Soisy-sous-Montmorency","Soisy-sur-Ecole","Soisy-sur-Seine","Soize","Solaize","Solaro","Solers","Solesmes","Soleymieux","Solferino","Solgne","Soliers","Solignac","Solignac-sous-Roche","Solignac-sur-Loire","Soligny-la-Trappe","Sollies-Pont","Sollies-Toucas","Sollies-Ville","Sologny","Somain","Sombacour","Sombernon","Somloire","Sommaing","Somme","Sommecaise","Sommedieue","Sommelonne","Sommerance","Sommervieu","Sommerviller","Sommieres","Sommieres-du-Clain","Sonchamp","Sondernach","Songeons","Sonnay","Sonnaz","Sonzay","Soorts-Hossegor","Sorbey","Sorbiers","Sorcy-Saint-Martin","Sore","Sorede","Sorel-en-Vimeu","Sorel-Moussel","Soreze","Sorges","Sorgues","Sorigny","Sormonne","Sornay","Sorquainville","Sorrus","Sort-en-Chalosse","Sospel","Sottevast","Sotteville","Sotteville-sur-Mer","Souastre","Soubise","Soublecause","Souchez","Soucht","Soucieu-en-Jarrest","Soucy","Soudan","Soues","Souesmes","Souffelweyersheim","Soufflenheim","Sougy","Sougy-sur-Loire","Souilhanels","Souillac","Soulac-sur-Mer","Soulaincourt","Soulaines-Dhuys","Soulaines-sur-Aubance","Soulaire-et-Bourg","Soulanges","Soulangis","Soulge-sur-Ouette","Soulieres","Souligne-sous-Ballon","Soulitre","Soullans","Soultz-Haut-Rhin","Soultz-sous-Forets","Soultzeren","Soultzmatt","Soulvache","Soumeras","Soumoulou","Souppes-sur-Loing","Souprosse","Souraide","Sourcieux-les-Mines","Sourdeval","Sourdon","Sourdun","Sourribes","Sours","Souspierre","Soustons","Souvans","Souvigne","Souvigne-sur-Sarthe","Souvigny","Souvigny-en-Sologne","Souzay-Champigny","Souzy","Souzy-la-Briche","Soyaux","Soyers","Soyons","Spay","Spechbach-le-Bas","Spechbach-le-Haut","Speracedes","Spezet","Spicheren","Spincourt","Sponville","Spycker","Squiffiec","St Chamas","St Laurent des Arbres","St-Malo","Staffelfelden","Stains","Steenbecque","Steenvoorde","Steenwerck","Steige","Steinbach","Steinbourg","Stella-Plage","Stenay","Still","Stiring-Wendel","Stosswihr","Strasbourg","Strazeele","Strueth","Succieu","Suce-sur-Erdre","Sucy-en-Brie","Suhescun","Suin","Suippes","Sully-la-Chapelle","Sully-sur-Loire","Sulniac","Sundhoffen","Supt","Surat","Surba","Suresnes","Surgeres","Surgy","Surin","Surques","Surtainville","Surville","Survilliers","Sury-en-Vaux","Sury-le-Comtal","Surzur","Sus","Sussargues","Suzanne","Suze-la-Rousse","Tabanac","Tacoignieres","Taden","Taglio-Isolaccio","Tagnon","Taillades","Taillebourg","Taillis","Tailly","Taintrux","Taissy","Taize-Aizie","Tajan","Talange","Talant","Talence","Talensac","Tallard","Tallende","Taller","Talloires","Tallud-Sainte-Gemme","Talon","Taluyers","Tamnay-en-Bazois","Tancrou","Taninges","Tanneron","Taradeau","Tarare","Tarascon","Tarascon-sur-Ariege","Tarbes","Tarcenay","Tarentaise","Targassonne","Targon","Tarnes","Tarnos","Tartaras","Tartas","Tartigny","Tassille","Tassin-la-Demi-Lune","Tatinghem","Taule","Taulignan","Taupont","Tauriac","Tauriac-de-Camares","Tautavel","Tauxieres-Mutry","Tauxigny","Tavaux","Tavel","Tavera","Tavernes","Taverny","Tavers","Tavey","Tayrac","Tecou","Teillet-Argenty","Teissieres-de-Cornet","Telgruc-sur-Mer","Teloche","Templemars","Templeuve","Tence","Tende","Tendon","Terce","Tercis-les-Bains","Terdeghem","Tergnier","Ternand","Ternay","Terrasson-Lavilledieu","Terraube","Terrebasse","Terssac","Terves","Terville","Tessy-sur-Vire","Teteghem","Teuillac","Teurtheville-Hague","Teyjat","Teyran","Thaims","Thaire","Thal-Drulingen","Thann","Thaon","Thaon-les-Vosges","Thauron","Theding","Thegra","Theil-sur-Vanne","Theillay","Theix","Theize","Thelus","Themericourt","Thenay","Thenelles","Thenezay","Thenissey","Thennelieres","Thennes","Thenon","Theoule-sur-Mer","Therdonne","Therouanne","Theuville","Theuville-aux-Maillots","Theys","Thezan-les-Beziers","Theze","Theziers","Thezy-Glimont","Thiais","Thiant","Thiberville","Thiefosse","Thiergeville","Thiers","Thiers-sur-Theve","Thierville","Thierville-sur-Meuse","Thietreville","Thieuloy-Saint-Antoine","Thieville","Thil","Thilay","Thilouze","Thimert-Gatelles","Thimory","Thin-le-Moutier","Thionville","Thise","Thivars","Thivencelle","Thiverval-Grignon","Thiviers","Thizy-les-Bourgs","Thodure","Thoirette","Thoiry","Thoissey","Thomery","Thones","Thonnance-les-Joinville","Thonon-les-Bains","Thoraise","Thorens-Glieres","Thorigny","Thorigny-sur-Marne","Thou","Thouare-sur-Loire","Thouars","Thourotte","Thoux","Thuir","Thuit-Hebert","Thulay","Thumeries","Thun-Saint-Amand","Thurageau","Thure","Thuret","Thurins","Thury-Harcourt","Thusy","Thyez","Tierce","Tiercelet","Tigery","Tignes","Tignieu-Jameyzieu","Tigy","Til-Chatel","Tillay-le-Peneux","Tille","Tillenay","Tillieres","Tillieres-sur-Avre","Tilloy-et-Bellay","Tilloy-lez-Cambrai","Tilloy-lez-Marchiennes","Tilly-sur-Meuse","Tilques","Tinchebray","Tincques","Tincry","Tinqueux","Tinteniac","Tiranges","Tirepied","Tivernon","Tocqueville","Tocqueville-en-Caux","Tollevast","Tombeboeuf","Tomblaine","Tonnay-Boutonne","Tonnay-Charente","Tonneins","Tonnerre","Tonnoy","Torce-en-Vallee","Torcieu","Torcy","Torcy-le-Grand","Torderes","Torfou","Torigni-sur-Vire","Torpes","Torreilles","Torsac","Torvilliers","Torxe","Tosse","Tossiat","Totes","Touchay","Toucy","Toudon","Toufflers","Toul","Toulaud","Toulenne","Toulon","Toulon-sur-Arroux","Toulouges","Toulouse","Toulouzette","Toulx-Sainte-Croix","Touques","Touquin","Tour-en-Sologne","Tourbes","Tourcoing","Tourgeville","Tourlaville","Tourly","Tournan-en-Brie","Tournay-sur-Odon","Tournecoupe","Tournedos-Bois-Hubert","Tournefeuille","Tournehem-sur-la-Hem","Tournieres","Tournoisis","Tournon-Saint-Martin","Tournus","Tourouvre","Tourrette-Levens","Tourrettes-sur-Loup","Tourriers","Tours","Tours-en-Savoie","Tours-sur-Marne","Tours-sur-Meymont","Tourtrol","Tourves","Tourville-en-Auge","Tourville-la-Campagne","Tourville-la-Chapelle","Tourville-la-Riviere","Tourville-les-Ifs","Tourville-sur-Odon","Tourville-sur-Sienne","Toury","Toussaint","Toussieu","Toussieux","Toussus-le-Noble","Toutlemonde","Touville","Touvois","Touvre","Touzac","Tracy-le-Mont","Tracy-le-Val","Tracy-sur-Loire","Traenheim","Trainel","Trainou","Tramole","Tramoyes","Trange","Trans-en-Provence","Trappes","Traubach-le-Bas","Trausse","Travecy","Treauville","Trebes","Trebeurden","Trebry","Treclun","Tredarzec","Treduder","Treffendel","Treffieux","Trefflean","Treffort","Treffrin","Treflez","Tregarantec","Tregastel","Treglamus","Tregourez","Treguidel","Tregunc","Treignac","Treillieres","Treize-Septiers","Trelaze","Trelevern","Trelissac","Trelivan","Trelly","Trelon","Tremblay","Tremel","Trementines","Tremery","Tremeven","Tremilly","Tremons","Tremont-sur-Saulx","Tremuson","Treon","Trepied","Trept","Tresilley","Tresques","Tressan","Tressange","Tresserve","Tresses","Trets","Treuzy-Levelay","Treve","Treveneuc","Treveray","Treverien","Treves","Trevien","Trevignin","Trevoux","Trezioux","Triaize","Tricot","Trie-Chateau","Trie-sur-Baise","Triel-sur-Seine","Trieux","Trigavou","Trignac","Trigueres","Trilbardou","Trilport","Triors","Trith-Saint-Leger","Trizac","Trizay","Troarn","Troche","Trogues","Troissereux","Troissy","Troisvilles","Tronville-en-Barrois","Trosly-Breuil","Trouhans","Trouillas","Trouley-Labarthe","Troussencourt","Troussey","Trouville","Trouville-la-Haule","Trouville-sur-Mer","Trouy","Troyes","Troyon","Truchtersheim","Trumilly","Truyes","Tubersent","Tuchan","Tucquegnieux","Tuffe","Tulle","Tullins","Tupigny","Turckheim","Turquant","Tursac","Tuzaguet","Uberach","Uchacq-et-Parentis","Uchaud","Uchaux","Uckange","Ueberstrass","Ugine","Ugny-sur-Meuse","Uhrwiller","Ully-Saint-Georges","Umpeau","Undurein","Ungersheim","Unieux","Ur","Urbeis","Urcay","Urcel","Urcuit","Urdos","Uriage-les-Bains","Urmatt","Urou-et-Crennes","Urrugne","Urt","Uruffe","Urval","Urville-Nacqueville","Ury","Urzy","Us","Ussac","Usseau","Ussel","Usson-du-Poitou","Ussy","Ustaritz","Utelle","Uvernet-Fours","Uxegney","Uxem","Uzein","Uzerche","Uzos","Vaas","Vacheresse","Vacognes-Neuilly","Vacon","Vacquieres","Vacquiers","Vadenay","Vadencourt","Vagney","Vahl-les-Benestroff","Vailhauques","Vaillant","Vailly","Vailly-sur-Aisne","Vailly-sur-Sauldre","Vaire","Vaire-sous-Corbie","Vaires-sur-Marne","Vaison-la-Romaine","Vaissac","Vaivre-et-Montoille","Val-de-Fier","Val-de-la-Haye","Val-et-Chatillon","Valaire","Valay","Valberg","Valbonne","Valcourt","Valdahon","Valdampierre","Valdoie","Valdurenque","Valencay","Valence","Valence-sur-Baise","Valenciennes","Valencin","Valencogne","Valensole","Valentigney","Valenton","Valescourt","Valff","Valflaunes","Valines","Vallangoujard","Vallans","Vallant-Saint-Georges","Vallauris","Valle-di-Mezzana","Vallegue","Valleiry","Valleraugue","Valleres","Vallerois-Lorioz","Valleroy-le-Sec","Vallesvilles","Vallet","Vallier","Valliguieres","Valliquerville","Vallon-en-Sully","Vallouise","Valmestroff","Valmondois","Valmont","Valmy","Valognes","Valpuiseaux","Valras-Plage","Valreas","Valros","Vals-les-Bains","Vals-pres-le-Puy","Vanclans","Vandieres","Vandoeuvre-les-Nancy","Vandoncourt","Vandre","Vandrimare","Vandy","Vannes","Vanosc","Vantoux","Vanves","Vanville","Vanzac","Varades","Varages","Varaignes","Varaize","Varanges","Varangeville","Varaville","Varces-Allieres-et-Risset","Varen","Varennes","Varennes-en-Argonne","Varennes-Jarcy","Varennes-le-Grand","Varennes-les-Macon","Varennes-sous-Dun","Varennes-sur-Allier","Varennes-sur-Loire","Varennes-sur-Seine","Varennes-Vauzelles","Varesnes","Varetz","Varilhes","Varinfroy","Varois-et-Chaignot","Varrains","Varreddes","Vars","Varsberg","Varzay","Varzy","Vasles","Vassel","Vasselay","Vassy","Vasteville","Vatan","Vathimenil","Vatimesnil","Vauban","Vaubecourt","Vauchamps","Vauchelles","Vauchelles-les-Domart","Vauchelles-les-Quesnoy","Vauchonvilliers","Vaucouleurs","Vaucresson","Vaudebarrier","Vaudemange","Vaudesson","Vaudeville","Vaudoy-en-Brie","Vaudreching","Vaudrey","Vaugneray","Vaugrigneuse","Vauhallan","Vaujours","Vaulry","Vault-de-Lugny","Vaulx-en-Velin","Vaulx-Milieu","Vaumas","Vaumoise","Vaumort","Vaureal","Vaureilles","Vauvert","Vauville","Vauvillers","Vaux-en-Bugey","Vaux-la-Petite","Vaux-le-Penil","Vaux-les-Pres","Vaux-les-Saint-Claude","Vaux-sur-Aure","Vaux-sur-Blaise","Vaux-sur-Eure","Vaux-sur-Mer","Vaux-sur-Poligny","Vaux-sur-Seine","Vauxbuin","Vauxtin","Vaxoncourt","Vay","Vayrac","Vayres","Veauche","Veaugues","Vecoux","Vecquemont","Vecqueville","Vedene","Veho","Veigne","Veigy-Foncenex","Velaine-en-Haye","Velaines","Velars-sur-Ouche","Velaux","Velines","Velle-le-Chatel","Velleches","Velleminfroy","Velleron","Velotte-et-Tatignecourt","Velye","Velzic","Vemars","Venables","Venansault","Venant","Venarey-les-Laumes","Venasque","Vence","Vendargues","Vendat","Vendays-Montalivet","Vendegies-sur-Ecaillon","Vendemian","Vendenheim","Vendeuil-Caply","Vendeuvre-du-Poitou","Vendeville","Vendin-le-Vieil","Vendin-les-Bethune","Vendome","Vendrennes","Vendres","Venejan","Venelles","Venerand","Venerque","Venette","Veneux-les-Sablons","Venizel","Venizy","Vennecy","Venon","Venoy","Ventabren","Ventes-Saint-Remy","Venteuil","Venthon","Ventiseri","Ver-sur-Launette","Verac","Verargues","Verberie","Verchaix","Verchamp","Verchin","Verdelais","Verderonne","Verdon","Verdun","Verdun-en-Lauragais","Verdun-sur-Garonne","Verdun-sur-le-Doubs","Veretz","Verfeil","Vergeze","Vergongheon","Vergt","Veria","Verigny","Verines","Verjux","Verlinghem","Vermand","Vermelles","Vermenton","Vern-sur-Seiche","Vernaison","Verne","Vernegues","Verneil-le-Chetif","Vernet-les-Bains","Verneugheol","Verneuil","Verneuil-en-Bourbonnais","Verneuil-en-Halatte","Verneuil-sous-Coucy","Verneuil-sur-Avre","Verneuil-sur-Seine","Verneuil-sur-Vienne","Vernierfontaine","Vernines","Verniolle","Vernioz","Vernon","Vernosc-les-Annonay","Vernou-sur-Brenne","Vernouillet","Vernoux-en-Vivarais","Verny","Veron","Verpillieres","Verquieres","Verquigneul","Verquin","Verrey-sous-Salmaise","Verrieres","Verrieres-le-Buisson","Vers","Vers-en-Montagne","Vers-Pont-du-Gard","Vers-sur-Selles","Versailles","Versailleux","Versigny","Verson","Versonnex","Vert","Vert-en-Drouais","Vert-le-Grand","Vert-le-Petit","Vert-Saint-Denis","Vertaizon","Verthemex","Vertolaye","Verton","Vertou","Vertrieu","Vertus","Vervezelle","Vervins","Very","Verze","Verzeille","Verzenay","Vescovato","Vesigneul-sur-Coole","Vesly","Vesoul","Vestric-et-Candiac","Vetheuil","Vetraz-Monthoux","Veuil","Veurey-Voroize","Veynes","Veyrac","Veyras","Veyre-Monton","Veyrier-du-Lac","Veyrignac","Vezac","Vezelise","Vezenobres","Vezezoux","Vezin-le-Coquet","Vezins","Viabon","Vialas","Vianne","Viarmes","Vias","Vibersviller","Vibraye","Vic-en-Bigorre","Vic-Fezensac","Vic-la-Gardiole","Vic-le-Comte","Vic-le-Fesq","Vic-sur-Aisne","Vic-sur-Cere","Vic-sur-Seille","Vichy","Vico","Vicq","Vidauban","Videix","Vieille-Brioude","Vieille-Eglise","Vieille-Eglise-en-Yvelines","Vieillevigne","Vieilley","Vielle-Saint-Girons","Vielle-Tursan","Viellespeze","Vielmur-sur-Agout","Viels-Maisons","Vienne","Vienville","Vierville","Vierzon","Viesly","Viessoix","Vieux","Vieux Conde","Vieux-Berquin","Vieux-Boucau-les-Bains","Vieux-Charmont","Vieux-Conde","Vieux-Ferrette","Vieux-Fume","Vieux-Manoir","Vieux-Moulin","Vieux-Rouen-sur-Bresle","Vieux-Thann","Vif","Vigeois","Vignacourt","Vignes","Vigneulles","Vigneulles-les-Hattonchatel","Vigneux-de-Bretagne","Vigneux-sur-Seine","Vignoc","Vignolles","Vignols","Vignonet","Vignot","Vigny","Vigoulet-Auzil","Vigouroux","Vigueron","Vigy","Vihiers","Vilallonga dels Monts","Villabe","Villabon","Villacourt","Village-Neuf","Villaines-la-Juhel","Villaines-les-Rochers","Villaines-sous-Bois","Villaines-sous-Luce","Villaines-sous-Malicorne","Villamblard","Villamee","Villard","Villard-Bonnot","Villard-de-Lans","Villard-Saint-Christophe","Villard-sur-Doron","Villards","Villargondran","Villaries","Villarlurin","Villars","Villars-Brandis","Villars-Colmars","Villars-en-Pons","Villars-et-Villenotte","Villars-les-Dombes","Villars-sur-Var","Villarzel-Cabardes","Villasavary","Villaz","Ville","Ville-du-Pont","Ville-en-Tardenois","Ville-la-Grand","Ville-sous-Anjou","Ville-sur-Cousances","Ville-sur-Jarnioux","Ville-sur-Lumes","Ville-sur-Tourbe","Villebarou","Villebernier","Villeblevin","Villebois-Lavalette","Villebon-sur-Yvette","Villebret","Villebrumier","Villecerf","Villeconin","Villecresnes","Villecroze","Villedieu","Villedieu-les-Poeles","Villedomer","Villedoux","Villefagnan","Villefontaine","Villefranche-de-Lauragais","Villefranche-de-Rouergue","Villefranche-du-Queyran","Villefranche-le-Chateau","Villefranche-sur-Cher","Villefranche-sur-Mer","Villefranque","Villegailhenc","Villegats","Villegouge","Villejesus","Villejoubert","Villejuif","Villejust","Villelaure","Villelongue-de-la-Salanque","Villemandeur","Villemarechal","Villembray","Villemeux-sur-Eure","Villemoirieu","Villemoisson-sur-Orge","Villemolaque","Villemomble","Villemort","Villemotier","Villemoustaussou","Villemoyenne","Villemur","Villemur-sur-Tarn","Villemurlin","Villenauxe-la-Grande","Villenave","Villeneuve","Villeneuve les beziers","Villeneuve-au-Chemin","Villeneuve-de-Berg","Villeneuve-de-Duras","Villeneuve-de-la-Raho","Villeneuve-de-Marc","Villeneuve-de-Marsan","Villeneuve-des-Escaldes","Villeneuve-Frouville","Villeneuve-la-Garenne","Villeneuve-la-Guyard","Villeneuve-la-Riviere","Villeneuve-le-Comte","Villeneuve-le-Roi","Villeneuve-Lecussan","Villeneuve-les-Avignon","Villeneuve-les-Bouloc","Villeneuve-les-Genets","Villeneuve-les-Maguelone","Villeneuve-les-Sablons","Villeneuve-Loubet","Villeneuve-Minervois","Villeneuve-Saint-Georges","Villeneuve-Saint-Germain","Villeneuve-sur-Allier","Villeneuve-sur-Fere","Villeneuve-sur-Lot","Villeneuve-sur-Yonne","Villeneuve-Tolosane","Villennes-sur-Seine","Villenouvelle","Villenoy","Villeny","Villeparisis","Villeperdue","Villepinte","Villepreux","Villequier-Aumont","Villerable","Villerest","Villermain","Villeron","Villers","Villers-Allerand","Villers-au-Bois","Villers-au-Tertre","Villers-aux-Vents","Villers-Bocage","Villers-Bretonneux","Villers-Canivet","Villers-Farlay","Villers-Helon","Villers-la-Montagne","Villers-le-Lac","Villers-le-Sec","Villers-les-Nancy","Villers-les-Ormes","Villers-les-Pots","Villers-les-Roye","Villers-Outreaux","Villers-Plouich","Villers-Pol","Villers-Saint-Frambourg","Villers-Saint-Genest","Villers-Saint-Paul","Villers-Saint-Sepulcre","Villers-Semeuse","Villers-Sire-Nicole","Villers-sous-Preny","Villers-sous-Saint-Leu","Villers-sur-Fere","Villers-sur-le-Mont","Villers-sur-Mer","Villers-sur-Meuse","Villers-sur-Port","Villers-sur-Saulnot","Villersexel","Villerupt","Villerville","Villes-sur-Auzon","Villesequelande","Villesiscle","Villetaneuse","Villetelle","Villeton","Villetrun","Villette","Villettes","Villeurbanne","Villevallier","Villevaude","Villeve","Villeveque","Villeveyrac","Villevieux","Villevillon","Villevocance","Villexavier","Villey-Saint-Etienne","Villey-sur-Tille","Villez-sous-Bailleul","Villie-Morgon","Villiers-Adam","Villiers-au-Bouin","Villiers-Couture","Villiers-en-Desoeuvre","Villiers-en-Plaine","Villiers-le-Bacle","Villiers-le-Bel","Villiers-le-Mahieu","Villiers-Saint-Georges","Villiers-sous-Grez","Villiers-sur-Chize","Villiers-sur-Marne","Villiers-sur-Morin","Villiers-sur-Orge","Villiers-sur-Seine","Villiers-sur-Tholon","Villieu-Loyes-Mollon","Villing","Villons-les-Buissons","Villorceau","Villotte-sur-Aire","Villy-Bocage","Villy-le-Bouveret","Villy-le-Pelloux","Vimines","Vimory","Vimoutiers","Vimy","Vinassan","Vinay","Vinca","Vincelles","Vincennes","Vincent","Vincey","Vincly","Vindelle","Vineuil","Vineuil-Saint-Firmin","Vinneuf","Vinon-sur-Verdon","Vinzelles","Vinzier","Viodos-Abense-de-Bas","Violaines","Violay","Viomenil","Vion","Viplaix","Vire","Virelade","Vireux-Molhain","Vireux-Wallerand","Virey-le-Grand","Viriat","Virieu-le-Grand","Virignin","Viriville","Viroflay","Virville","Viry","Viry-Noureuil","Vitrac","Vitrac-Saint-Vincent","Vitreux","Vitrimont","Vitrolles","Vitry-aux-Loges","Vitry-en-Artois","Vitry-en-Perthois","Vitry-la-Ville","Vitry-sur-Orne","Vitry-sur-Seine","Vitteaux","Vittel","Vittersbourg","Viuz-en-Sallaz","Viven","Vivier","Vivier-au-Court","Vivieres","Viviers","Viviers-du-Lac","Viviers-les-Montagnes","Viviez","Vivonne","Vivy","Vix","Vizille","Vocance","Voglans","Voillecomte","Voiron","Voisin","Voisins-le-Bretonneux","Voissant","Vollore-Ville","Volmerange-les-Boulay","Volmerange-les-Mines","Volonne","Volvic","Volx","Vonnas","Voreppe","Vorey","Vorges","Vouel","Vouhe","Vouille","Vouille-les-Marais","Vouillers","Voujeaucourt","Voulangis","Voultegon","Voulton","Voulx","Vouneuil-sous-Biard","Vouneuil-sur-Vienne","Vourey","Vourles","Voutezac","Voutre","Vouvant","Vouvray","Vouzan","Vouzeron","Vouziers","Vouzon","Vouzy","Voves","Vraiville","Vraux","Vred","Vriange","Vrigne-aux-Bois","Vrigny","Vritz","Vue","Vulaines-sur-Seine","Vulbens","Wahagnies","Wahlenheim","Wail","Wailly","Wailly-Beaucamp","Waldhouse","Waldighofen","Waldweistroff","Waldwisse","Walheim","Wallers","Walscheid","Wambaix","Wambercourt","Wambrechies","Wandignies-Hamage","Wangen","Wangenbourg-Engenthal","Wanquetin","Warcq","Warendin","Wargnies-le-Petit","Warhem","Warlaing","Warlus","Warluzel","Warmeriville","Warnecourt","Wasnes-au-Bac","Wasquehal","Wasselonne","Wassy","Watten","Wattignies","Wattrelos","Wattwiller","Wavignies","Waville","Wavrechain-sous-Denain","Wavrechain-sous-Faulx","Wavrin","Waziers","Weislingen","Weitbruch","Wentzwiller","Werentzhouse","Wervicq-Sud","Westbecourt","Westhoffen","Westhouse","Weyersheim","Wickerschwihr","Widensolen","Wierre-Effroy","Wignehies","Wihr-au-Val","Wildersbach","Willems","Willencourt","Willer-sur-Thur","Willerwald","Willgottheim","Wimereux","Wimille","Wingen-sur-Moder","Wingersheim","Wingles","Winnezeele","Wintersbourg","Wintzenbach","Wintzenheim","Wintzfelden","Wirwignes","Wissant","Wissembourg","Wissignicourt","Wissous","Witry-les-Reims","Wittelsheim","Wittenheim","Witternheim","Wittersdorf","Wittersheim","Wittes","Wittisheim","Wiwersheim","Wizernes","Woerth","Woincourt","Woippy","Wolfgantzen","Wolfisheim","Wolschheim","Wolxheim","Wormhout","Woustviller","Wuenheim","Xaintray","Xanton-Chassenon","Xertigny","Xures","Yaucourt-Bussus","Ychoux","Ydes","Yebleron","Yebles","Yenne","Yermenonville","Yerres","Yerville","Yevre-la-Ville","Yffiniac","Ygos-Saint-Saturnin","Ygrande","Ymare","Youx","Yport","Ypreville-Biville","Yronde-et-Buron","Yssac-la-Tourette","Yssandon","Yssingeaux","Ytrac","Yversay","Yves","Yvetot","Yvette","Yvias","Yvoire","Yvrac","Yvrac-et-Malleyrand","Yzernay","Yzeure","Yzeures-sur-Creuse","Yzosse","Zellwiller","Zillisheim","Zimmersheim","Zimming","Zinswiller","Zittersheim","Zouafques","Zutzendorf"]},"GA":{"id":"GA","name":"Gabon","timezones":["Africa/Lagos"],"cities":["Gamba","Libreville","Mamagnia","Moanda","Port-Gentil"]},"GB":{"id":"GB","name":"United Kingdom","timezones":["Europe/London"],"cities":["Abberton","Abbots Langley","Aberaeron","Aberchirder","Abercynon","Aberdare","Aberdeen","Aberfeldy","Aberford","Aberfoyle","Abergavenny","Abergele","Abergwynfi","Abergynolwyn","Aberkenfig","Aberlour","Abersychan","Abertillery","Aberystwyth","Abingdon","Aboyne","Accrington","Acton","Addington","Addlestone","Adlingfleet","Aghalee","Aintree","Airdrie","Akeley","Albrighton","Alcester","Aldeburgh","Alderholt","Alderley Edge","Aldermaston","Aldershot","Aldridge","Alexandria","Alfold","Alford","Alfreton","Alloa","Alness","Alnwick","Alresford","Alrewas","Alsager","Alston","Altham","Alton","Altrincham","Alva","Alvechurch","Alveston","Ambleside","Amersham","Amesbury","Amlwch","Ammanford","Ampthill","Andover","Angmering","Anlaby","Annalong","Annan","Annesley","Anniesland","Anstey","Anstruther","Antrim","Appleby","Appleford","Appleton","Appley Bridge","Arbroath","Ardingly","Ardmillan","Ardrossan","Arlesey","Arley","Armadale","Armagh","Armitage","Arnold","Arrochar","Arthog","Arundel","Ascot","Ash","Ash Vale","Ashbourne","Ashburton","Ashby de la Launde","Ashby de la Zouch","Ashdon","Ashen","Ashfield","Ashford","Ashington","Ashley","Ashmore","Ashtead","Ashton in Makerfield","Ashton-under-Lyne","Ashwell","Askam in Furness","Askern","Askham","Astley","Aston","Aston Clinton","Atherstone","Atherton","Attleborough","Atworth","Auchinleck","Auchterarder","Auchtermuchty","Augher","Aughnacloy","Aultbea","Aveley","Aviemore","Avoch","Avonmouth","Axbridge","Axminster","Aycliffe","Aylesbury","Aylesford","Aylsham","Ayr","Babraham","Back","Bacton","Bacup","Bagillt","Bagshot","Baildon","Bainton","Bakewell","Bala","Baldock","Balerno","Balham","Ball","Ballingry","Balloch","Ballybogy","Ballycastle","Ballyclare","Ballymena","Ballymoney","Ballynahinch","Bampton","Banbridge","Banbury","Banchory","Banff","Bangor","Bangor-is-y-coed","Banham","Banstead","Barbaraville","Bargoed","Barking","Barkway","Barley","Barmouth","Barmston","Barnard Castle","Barnes","Barnet","Barnham","Barnoldswick","Barnsley","Barnstaple","Barnwell","Barrow","Barrow in Furness","Barrow upon Humber","Barrow upon Soar","Barrowford","Barry","Barton in Fabis","Barton on Sea","Barton under Needwood","Barton upon Humber","Barton-le-Clay","Barwell","Basildon","Basingstoke","Baslow","Bath","Bathgate","Batley","Battle","Bawtry","Bayble","Bayford","Beach","Beaconsfield","Beal","Bealings","Beaminster","Beaufort","Beaulieu","Beauly","Beaumaris","Beaumont","Beaworthy","Bebington","Beccles","Beckenham","Beckingham","Beckley","Beckton","Bedale","Bedford","Bedlington","Bedminster","Bedworth","Beer","Beeston","Beith","Bekesbourne","Belbroughton","Belcoo","Belfast","Belleek","Bellshill","Belmont","Belper","Belvedere","Bembridge","Ben Rhydding","Benburb","Benenden","Benllech","Benson","Bentley","Berkeley","Berkhamstead","Bermondsey","Berwick","Berwick-Upon-Tweed","Besthorpe","Betchworth","Bettws","Betws","Beverley","Bewdley","Bexhill","Bexleyheath","Bicester","Bickenhill","Bickleigh","Biddenden","Biddenham","Biddulph","Bideford","Bidford-on-Avon","Bidston","Bierton","Biggar","Biggin Hill","Biggleswade","Bignor","Bildeston","Billericay","Billesley","Billingham","Billingshurst","Bilsthorpe","Bilston","Binfield","Bingham","Bingley","Binsted","Birchanger","Birchington","Birdbrook","Birkenhead","Birmingham","Birnam","Birstall","Birtley","Bishop Auckland","Bishop Burton","Bishopbriggs","Bishops Cleeve","Bishops Waltham","Bishopstoke","Bishopstrow","Bishopton","Bisley","Blackburn","Blackford","Blackheath","Blackpool","Blackwater","Blackwood","Blaenau-Ffestiniog","Blaenavon","Blaenwaun","Blaina","Blairgowrie","Blakeney","Blandford Forum","Blaydon","Bledlow","Bletchingley","Bletchley","Blewbury","Blidworth","Bloomsbury","Bloxwich","Blunham","Bluntisham","Blyth","Bodelwyddan","Bodmin","Bognor Regis","Boldon Colliery","Bollington","Bolney","Bolsover","Bolton","Bonar Bridge","Bonnybridge","Bonnyrigg","Bookham","Bootle","Bordesley","Boreham","Borehamwood","Borough Green","Boroughbridge","Bosbury","Boscastle","Boston","Boston Spa","Botesdale","Bothwell","Botley","Bottesford","Bourne","Bourne End","Bournemouth","Bournville","Bourton on the Water","Bovey Tracey","Bow","Bowdon","Bowes","Bowness-on-Windermere","Box","Boxley","Bozeat","Brackley","Bracknell","Bradfield St George","Bradford","Bradford-on-Avon","Bradwell on Sea","Braintree","Bramford","Bramhall","Bramley","Brampton","Brandesburton","Brandon","Bransford","Bransgore","Brasted","Braunstone","Braunton","Brayton","Brechin","Brecon","Bredbury","Brede","Brenchley","Brentford","Brentwood","Brewood","Bridge","Bridgemary","Bridgend","Bridgham","Bridgnorth","Bridgwater","Bridlington","Bridport","Brierfield","Brierley Hill","Brigg","Brighouse","Brightlingsea","Brighton","Brigstock","Brimpton","Brimscombe","Bristol","Briton Ferry","Brixham","Brixton Hill","Brixworth","Broad Blunsdon","Broadstairs","Broadstone","Broadwas","Broadway","Brockenhurst","Brockley Green","Brockworth","Bromborough","Bromham","Brompton","Bromsgrove","Bromyard","Brook","Brooke","Brookland","Broom","Broseley","Brough","Broughton","Broughty Ferry","Brownhills","Broxbourne","Broxburn","Bruton","Buckden","Buckfastleigh","Buckhurst Hill","Buckie","Buckingham","Buckland","Buckley","Bucknell","Bude","Budleigh Salterton","Bugbrooke","Builth Wells","Bulford","Bulkington","Bulwell","Bungay","Buntingford","Burbage","Burford","Burgess Hill","Burgh le Marsh","Burghclere","Burley","Burnham","Burnham on Crouch","Burnham-on-Sea","Burnley","Burnopfield","Burntisland","Burntwood","Burry Port","Burscough","Burslem","Burstwick","Burton","Burton Pidsea","Burton-on-Trent","Burwash","Burwell","Bury","Bury St Edmunds","Burythorpe","Bushey","Butterton","Buxted","Buxton","Byfield","Byfleet","Cadbury","Caddington","Caernarfon","Caerphilly","Caersws","Caister-on-Sea","Caistor","Caldicot","Callander","Callington","Calne","Calstock","Calverton","Cam","Camberley","Camberwell","Camborne","Cambridge","Cambuslang","Cambusnethan","Camelford","Campbeltown","Canewdon","Cannock","Canterbury","Capel","Capenhurst","Carbrooke","Cardiff","Cardigan","Cardonald","Cardross","Carlisle","Carlton","Carlton le Moorland","Carluke","Carmarthen","Carnforth","Carnmoney","Carnoustie","Carrbridge","Carrickfergus","Carrowdore","Carshalton","Carterton","Castle Cary","Castle Donington","Castle Douglas","Castlederg","Castleford","Castlereagh","Castleton","Castlewellan","Caston","Caterham","Catford","Catherington","Catterick","Caversham","Cawston","Caxton","Caythorpe","Chacombe","Chaddesden","Chadwell","Chalfont Saint Peter","Chalgrove","Chandlers Ford","Chapel en le Frith","Chapeltown","Chard","Charfield","Charing Cross","Charlestown","Charlton on Otmoor","Charlwood","Charmouth","Chartham","Chasetown","Chatham","Chatteris","Cheadle","Cheadle Hulme","Cheam","Checkley","Cheddar","Chellaston","Chelmsford","Chelsfield","Cheltenham","Chepstow","Chertsey","Chesham","Cheshunt","Chessington","Chester","Chester-le-Street","Chesterfield","Chestfield","Chichester","Chigwell","Chilbolton","Chilcompton","Childwall","Chilton","Chilton Trinity","Chilwell","Chingford","Chinley","Chinnor","Chippenham","Chipping Campden","Chipping Norton","Chipping Ongar","Chipping Sodbury","Chipstead","Chislehurst","Chiswick","Choppington","Chorley","Christchurch","Christleton","Chryston","Chulmleigh","Church","Church Gresley","Church Leigh","Church Stretton","Churchill","Cinderford","Cirencester","City of London","City of Westminster","Clackmannan","Clacton-on-Sea","Clapham","Clarbeston Road","Clare","Claverdon","Clavering","Claygate","Clayton West","Cleator","Cleator Moor","Cleckheaton","Clevedon","Cleveleys","Cliffe","Clifton","Clifton Hampden","Clipstone","Clitheroe","Clovenfords","Clun","Clunderwen","Clutton","Clydach","Clydebank","Coalbrookdale","Coalisland","Coalville","Coatbridge","Cobham","Cockerham","Cockermouth","Codsall","Coed-Talon","Cogenhoe","Coggeshall","Colchester","Coleford","Coleraine","Colnbrook","Colne","Colwyn Bay","Colyford","Colyton","Comber","Compton","Compton Dundon","Comrie","Congleton","Conisbrough","Connahs Quay","Conon Bridge","Consett","Conway","Cookham","Cooksbridge","Cookstown","Coppenhall","Coppull","Corbridge","Corby","Corfe Castle","Corfe Mullen","Corpach","Corringham","Corsham","Corwen","Coseley","Cosham","Cotgrave","Cottenham","Cottered","Cottingham","Coulsdon","Countess Wear","Coupar Angus","Covent Garden","Coventry","Cowbridge","Cowden","Cowdenbeath","Cowley","Cradley","Craigavon","Cramlington","Cranbrook","Cranfield","Cranford","Cranleigh","Crathorne","Craven Arms","Crawley","Crayford","Crediton","Crewe","Crewkerne","Criccieth","Crick","Crickhowell","Cricklade","Cricklewood","Crieff","Crofton","Cromer","Cromwell","Crook","Crookham","Crosby","Cross","Cross in Hand","Cross Keys","Crossgar","Crossgates","Crosshouse","Croston","Croughton","Crowborough","Crowland","Crowthorne","Croxley Green","Croydon","Crumlin","Crymych","Cublington","Cuckfield","Cuffley","Cullen","Cullompton","Cumbernauld","Cumnock","Cupar","Curdridge","Currie","Cwmbran","Cynwyd","Dagenham","Dalbeattie","Dalkeith","Dalry","Dalton in Furness","Daresbury","Darfield","Darlaston","Darlington","Dartford","Dartmouth","Darvel","Darwen","Datchet","Daventry","Dawley","Dawlish","Deal","Dean","Deighton","Denbigh","Denby","Denham","Denny","Denton","Deptford","Derby","Dereham","Derwen","Desborough","Devizes","Dewsbury","Didcot","Diddington","Dinas Powys","Dingestow","Dingwall","Dinnington","Diss","Doagh","Dolgelly","Dollar","Dollis Hill","Dolwyddelan","Donaghadee","Doncaster","Donnington","Dorchester","Dorking","Dorney","Dornoch","Dorridge","Douglas","Doune","Dover","Dovercourt","Downend","Downham Market","Downpatrick","Draperstown","Draycott","Draycott in the Moors","Drayton","Drayton Bassett","Drayton Saint Leonard","Driffield","Drighlington","Droitwich","Dromara","Dromore","Dronfield","Droxford","Droylsden","Drumahoe","Drumchapel","Drybrook","Drymen","Duddington","Dudley","Duffield","Duffus","Dukinfield","Dulverton","Dulwich","Dumbarton","Dumbleton","Dumfries","Dunbar","Dunblane","Dunchurch","Dundee","Dundonald","Dunfermline","Dungannon","Dungiven","Dunkeld","Dunkeswell","Dunmurry","Dunning","Dunoon","Duns","Dunstable","Durham","Durrington","Dursley","Duxford","Dyce","Dymock","Dyserth","Eagle","Eaglesfield","Eaglesham","Earley","Earlham","Earls Colne","Earls Court","Earlston","Earnley","Easington","Easingwold","East Barnet","East Bergholt","East Boldon","East Budleigh","East Challow","East Cowes","East Down","East Dulwich","East Grinstead","East Hagbourne","East Ham","East Hanningfield","East Harling","East Hoathly","East Horsley","East Keal","East Kilbride","East Leake","East Linton","East Malling","East Molesey","East Peckham","East Preston","East Retford","East Stour","East Tilbury","Eastbourne","Eastchurch","Eastcote","Eastham","Eastington","Eastleigh","Easton","Eastwood","Ebbw Vale","Eccles","Eccleshall","Edenbridge","Edenfield","Edgbaston","Edgefield","Edgware","Edinburgh","Edmonton","Edwalton","Edwinstowe","Effingham","Egerton","Egham","Egremont","Egton","Elderslie","Elgin","Elland","Ellesmere","Ellesmere Port","Ellington","Ellon","Elloughton","Elmley Lovett","Elstead","Elstree","Elsworth","Eltham","Ely","Empingham","Emsworth","Enfield","Englefield Green","Enniskillen","Enstone","Epping","Epping Green","Epsom","Erdington","Erith","Esher","Essendon","Etchingham","Eton","Eversholt","Evesham","Ewelme","Ewhurst","Exeter","Exminster","Exmouth","Eye","Eyemouth","Eynsham","Failsworth","Fairford","Fairlight","Fakenham","Falkirk","Falkland","Falmouth","Fangfoss","Fareham","Faringdon","Farmborough","Farnborough","Farndon","Farnham","Farnham Royal","Farningham","Farnworth","Fauldhouse","Faulkland","Faversham","Felbridge","Felixstowe","Felsted","Feltham","Ferndale","Ferryhill","Ferryside","Filey","Fillongley","Finchampstead","Finchley","Finedon","Fintry","Fishburn","Fishguard","Fitzwilliam","Fivemiletown","Fladbury","Fleet","Fleetwood","Flint","Flitwick","Flordon","Fochabers","Folkestone","Ford","Fordingbridge","Forest Row","Forfar","Formby","Forres","Fort William","Four Marks","Fowey","Fownhope","Framlingham","Frant","Fraserburgh","Freckleton","Frensham","Freshwater","Fressingfield","Friern Barnet","Frimley","Fringford","Frinton-on-Sea","Friskney","Frithville","Frizington","Frodsham","Froggatt","Frome","Fulham","Fulmer","Gaerwen","Gainsborough","Galashiels","Galston","Gamlingay","Gargrave","Gargunnock","Garrison","Garstang","Garston","Garth","Gateshead","Gatwick","Gaydon","Gayton Thorpe","Gelligaer","Gifford","Giggleswick","Gillingham","Gipping","Girton","Girvan","Glasdrumman","Glasgow","Glastonbury","Glenboig","Glenrothes","Glenshee","Glentham","Glossop","Gloucester","Gnosall","Godalming","Godmanchester","Godmersham","Godstone","Golborne","Gomersal","Goodmayes","Goodwick","Goole","Goostrey","Gordon","Gorebridge","Goring","Gorleston-on-Sea","Gorseinon","Gorslas","Gorton","Gosberton","Gosfield","Gosforth","Gosport","Goudhurst","Gourock","Granby","Grange","Grangemouth","Grantham","Grantown on Spey","Grasmere","Grateley","Graveley","Gravesend","Grays","Great Amwell","Great Baddow","Great Barton","Great Billing","Great Chesterford","Great Dunmow","Great Fransham","Great Gidding","Great Glemham","Great Gransden","Great Milton","Great Missenden","Great Ryburgh","Great Staughton","Great Torrington","Great Waldingfield","Great Yarmouth","Greenfield","Greenford","Greenhead","Greenhithe","Greenisland","Greenock","Greensted","Greenwich","Grendon","Grendon Underwood","Gresford","Gretna","Gretna Green","Gretton","Grimsargh","Grimsby","Groombridge","Grove","Guildford","Guisborough","Guiseley","Gullane","Gunnislake","Guthrie","Hackbridge","Hackney","Haddenham","Haddington","Hadleigh","Hadlow","Hadlow Down","Hagley","Hailsham","Halesowen","Halesworth","Halewood","Halifax","Halstead","Halton","Haltwhistle","Halwell","Hamble","Hambleden","Hambleton","Hamilton","Hammersmith","Hampton","Hampton Lucy","Handcross","Handforth","Handsworth","Hanley","Hanwell","Hanworth","Hapton","Harby","Hardham","Harefield","Harlaxton","Harlech","Harlesden","Harleston","Harlow","Harold Wood","Harpenden","Harrogate","Harrold","Harrow","Harrow on the Hill","Harrow Weald","Hartfield","Hartford","Hartlepool","Hartley","Hartpury","Hartwell","Harwell","Harwich","Harworth","Haslemere","Haslingden","Hassocks","Hastings","Hatch","Hatfield","Hatherleigh","Hathersage","Hatton","Havant","Haverfordwest","Haverhill","Havering atte Bower","Hawarden","Hawes","Hawick","Hawkhurst","Hawkwell","Hawley","Haydock","Haydon Bridge","Hayes","Hayle","Haywards Heath","Hazel Grove","Hazelwood","Headcorn","Headington","Headley","Heanor","Heath","Heathfield","Heathrow","Hebburn","Hebden Bridge","Heckington","Heckmondwike","Hedgerley","Hednesford","Hedon","Helens Bay","Helensburgh","Hellesdon","Helmsley","Helston","Hemel Hempstead","Hemingstone","Hemswell","Hemsworth","Hendon","Henfield","Hengoed","Henham","Henley","Henley-on-Thames","Henlow","Hennock","Henstridge","Hereford","Heriot","Hermitage","Herne Bay","Herriard","Hersham","Herstmonceux","Hertford","Hessle","Heston","Heswall","Hever","Hexham","Heybridge","Heysham","Heythrop","Heywood","High Bentham","High Blantyre","High Halden","High Legh","High Peak","High Peak Junction","High Wycombe","Higham Ferrers","Higham on the Hill","Highbridge","Highbury","Highcliffe","Higher Bebington","Hightown","Highway","Highworth","Hilborough","Hilderstone","Hill","Hillingdon","Hillsborough","Hillside","Hilton","Hinckley","Hindhead","Hindley","Hindon","Hingham","Hinton St George","Histon","Hitcham","Hitchin","Hockley","Hoddesdon","Holbeach","Holborn","Holmes Chapel","Holmewood","Holmfirth","Holsworthy","Holt","Holyhead","Holywell","Holywood","Honingham","Honiton","Hook","Hooke","Hopwood","Horam","Horbling","Horbury","Horley","Horncastle","Hornchurch","Horndean","Horndon on the Hill","Hornsea","Hornsey","Horrabridge","Horsham","Horsmonden","Horsted Keynes","Horton Kirby","Horwich","Hotham","Houghton on the Hill","Houghton Regis","Houghton-le-Spring","Houston","Hove","Howden","Hoylake","Hucknall Torkard","Hucknall under Huthwaite","Huddersfield","Huish","Hull","Humberston","Humbie","Hungerford","Hunstanton","Huntingdon","Huntly","Huntspill","Hursley","Hurstbourne Tarrant","Hurstpierpoint","Hurworth","Huyton","Hyde","Hythe","Ibstock","Ickenham","Ifield","Ilchester","Ilford","Ilfracombe","Ilkeston","Ilkley","Ilminster","Immingham","Inchinnan","Ingatestone","Innerleithen","Insch","Inveraray","Invergordon","Inverkeilor","Inverkeithing","Inverkip","Inverness","Inverness-shire","Inverurie","Ipswich","Irlam","Irthlingborough","Irvine","Isham","Isleham","Isleworth","Islington","Islip","Itchen","Itchen Abbas","Iver","Ivybridge","Iwerne Courtney","Jarrow","Jedburgh","Johnstone","Jordanstown","Juniper Green","Kedington","Keele","Keighley","Keith","Kelbrook","Kelly","Kelmarsh","Kelsall","Kelso","Kelty","Kelvedon","Kempston","Kendal","Kenilworth","Kenley","Kennington","Kennoway","Kensington","Kent","Keresley","Keston","Keswick","Ketley","Kettering","Keynsham","Kibworth Harcourt","Kidderminster","Kidlington","Kidsgrove","Kidwelly","Kilbarchan","Kilbirnie","Kilbride","Kilkeel","Killamarsh","Killin","Kilmacolm","Kilmarnock","Kilsyth","Kilwinning","Kimberley","Kimbolton","Kingham","Kinghorn","Kinglassie","Kings Langley","Kings Lynn","Kings Norton","Kings Sutton","Kingsbridge","Kingskerswell","Kingsland","Kingsteignton","Kingston","Kingston Seymour","Kingswinford","Kingswood","Kingussie","Kinloch Rannoch","Kinmel","Kinnerley","Kinross","Kirby Cross","Kirk Ella","Kirkby","Kirkby in Ashfield","Kirkby Stephen","Kirkcaldy","Kirkconnel","Kirkcudbright","Kirkham","Kirkintilloch","Kirkliston","Kirkwall","Kirriemuir","Kirtlington","Kirton in Lindsey","Knaresborough","Knebworth","Kneeton","Knighton","Knottingley","Knowsley","Knutsford","Kyle of Lochalsh","Laindon","Lakenheath","Lambeth","Lambourn","Lampeter","Lanark","Lancaster","Lancing","Landrake","Langho","Langley","Langport","Langstone","Lapworth","Larbert","Largs","Larkhall","Larne","Lauder","Laugharne","Launceston","Laurencekirk","Lavant","Lavendon","Lawrencetown","Laxfield","Laxton","Leatherhead","Lechlade","Leconfield","Ledbury","Lee","Lee-on-the-Solent","Leeds","Leek","Leek Wootton","Leicester","Leigh","Leigh-on-Sea","Leighton Buzzard","Leiston","Leitholm","Lenham","Leominster","Lerwick","Lesmahagow","Letchworth","Leuchars","Leven","Levenshulme","Lewes","Lewisham","Leyburn","Leyland","Leysdown-on-Sea","Leyton","Lichfield","Lidlington","Lifton","Limavady","Limekilns","Lincoln","Lindal in Furness","Lindfield","Lingfield","Linlithgow","Linthwaite","Linton","Linton upon Ouse","Liphook","Lisburn","Liskeard","Lisnaskea","Liss","Litherland","Little Barningham","Little Canfield","Little Eaton","Little Gaddesden","Little Hulton","Little Kimble","Little Lever","Little Milton","Little Paxton","Littleborough","Littlebury","Littlehampton","Littleport","Liverpool","Liversedge","Livingston","Llanbedr","Llanddulas","Llandeilo","Llandovery","Llandrillo","Llandrindod Wells","Llandudno","Llandudno Junction","Llanelli","Llanfair-Dyffryn-Clwyd","Llanfairfechan","Llanfyllin","Llanfyrnach","Llangattock","Llangefni","Llangennech","Llangollen","Llanharan","Llanidloes","Llanishen","Llanon","Llanrwst","Llansantffraid-ym-Mechain","Llantrisant","Llantwit Fardre","Llantwit Major","Llanwrda","Llanwrtyd Wells","Llanymynech","Llwyngwril","Llwynypia","Loanhead","Lochgelly","Lochgilphead","Lochmaddy","Lochwinnoch","Lockerbie","Loddington","London","London Borough of Bromley","London Borough of Hounslow","London Borough of Wandsworth","Londonderry","Long Buckby","Long Ditton","Long Eaton","Long Melford","Long Stratton","Longdown","Longfield","Longhope","Longniddry","Longport","Longridge","Longstanton","Longton","Looe","Loppington","Lossiemouth","Lostwithiel","Loudwater","Loughborough","Loughor","Loughton","Louth","Low Ham","Lowdham","Lower Beeding","Lower Brailes","Lower Darwen","Lowestoft","Lowton","Lubenham","Ludlow","Lupton","Lurgan","Lustleigh","Luton","Lutterworth","Lydbury North","Lydney","Lyme Regis","Lyminge","Lymington","Lymm","Lympsham","Lyndhurst","Lyng","Lytchett Minster","Lytham","Mablethorpe","Macclesfield","Macduff","Machynlleth","Maerdy","Maesteg","Maghera","Magherafelt","Magheralin","Maghull","Maida Vale","Maiden Newton","Maidenhead","Maidstone","Malden","Maldon","Mallaig","Malmesbury","Malpas","Malton","Malvern","Manchester","Manningtree","Manor","Mansfield","Mansfield Woodhouse","Manton","March","Marcham","Marden","Margate","Marhamchurch","Mark","Market Deeping","Market Drayton","Market Harborough","Market Rasen","Market Weighton","Markfield","Marlborough","Marlow","Marnhull","Marple","Marr","Marsham","Marske","Martin","Martley","Martock","Maryhill","Maryport","Masham","Matching","Matlock","Mattishall","Mauchline","Maulden","Maybole","Mayfair","Mayfield","Meanwood","Measham","Medmenham","Medstead","Meesden","Meggies","Meifod","Melbourne","Meldreth","Melksham","Mells","Melrose","Melton","Melton Constable","Melton Mowbray","Menai Bridge","Mendlesham","Menheniot","Menston","Meopham","Mere","Merthyr Mawr","Merthyr Tydfil","Merton","Metheringham","Methil","Mexborough","Mickleton","Mid Calder","Middlesbrough","Middleton","Middleton One Row","Middlewich","Midford","Midgham","Midhurst","Midsomer Norton","Mildenhall","Milford","Milford Haven","Milford on Sea","Mill Hill","Millbrook","Millom","Milltimber","Milnathort","Milnthorpe","Milton","Milton Keynes","Milton on Stour","Minchinhampton","Minehead","Minster","Minster Lovell","Minsterley","Mirfield","Mitcham","Mitcheldean","Mobberley","Mochdre","Moira","Mold","Molesey","Mollington","Moneymore","Monifieth","Monkswood","Monkton","Monmouth","Montgomery","Montrose","Monyash","Moorsholm","Moorside","Morden","More","Morecambe","Moreton","Moreton in Marsh","Morley","Morpeth","Morriston","Moseley","Moss","Mossley","Moston","Motherwell","Moulton","Moulton St Michael","Mount Bures","Mount Hamilton","Mountain Ash","Mountsorrel","Much Hadham","Much Hoole","Much Wenlock","Muir of Ord","Mundesley","Murton","Musselburgh","Myddle","Mytholmroyd","Myton on Swale","Nafferton","Nailsea","Nairn","Nantwich","Nantyglo","Napton on the Hill","Narberth","Naseby","Nash","Nassington","Neasden","Neath","Needingworth","Neilston","Nelson","Neston","Nettlebed","Nettleton","New Barnet","New Buckenham","New Cross","New Ferry","New Mills","New Milton","New Quay","New Romney","New Southgate","New Tredegar","Newark on Trent","Newbiggin-by-the-Sea","Newbold","Newbridge","Newburgh","Newbury","Newcastle","Newcastle Emlyn","Newcastle upon Tyne","Newcastle-under-Lyme","Newent","Newhall","Newham","Newhaven","Newick","Newlands","Newmarket","Newport","Newport Pagnell","Newport-On-Tay","Newquay","Newry","Newton Abbot","Newton Aycliffe","Newton on Trent","Newton Stewart","Newton-le-Willows","Newtonmore","Newtown","Newtownabbey","Newtownards","Norbury","Nordelph","Norham","Normandy","Normanton","North Berwick","North Elmsall","North Ferriby","North Hykeham","North Kilworth","North Leigh","North Moreton","North Newton","North Petherton","North Shields","North Somercotes","North Tawton","North Walsham","North Waltham","North Weald","Northallerton","Northampton","Northenden","Northfield","Northfleet","Northleach","Northolt","Northop","Northrepps","Northwich","Northwood","Norton","Norton Lindsey","Norwich","Norwood","Nottingham","Nuffield","Nuneaton","Nutfield","Nutley","Oadby","Oakamoor","Oakford","Oakham","Oakhill","Oakley","Oare","Oban","Odiham","Offord Cluny","Okehampton","Old Basing","Old Buckenham","Old Colwyn","Old Malton","Old Windsor","Oldbury","Oldham","Oldmeldrum","Olney","Omagh","Ormesby","Ormiston","Ormskirk","Orpington","Ossett","Oswaldtwistle","Oswestry","Otford","Otley","Otterburn","Ottershaw","Ottery St Mary","Oulton","Oundle","Overton","Oving","Ovingdean","Owslebury","Oxenhope","Oxford","Oxshott","Oxted","Padbury","Paddock Wood","Padiham","Padstow","Paignton","Painswick","Paisley","Palmers Green","Pampisford","Papworth Everard","Par","Parbold","Partington","Partridge Green","Paston","Patchway","Pathhead","Patrington","Paul","Peebles","Pelsall","Pembroke","Pembroke Dock","Pembury","Penarth","Pencader","Pencaitland","Pencarreg","Pencoed","Pendlebury","Penicuik","Penkridge","Penn","Pennington","Penrice","Penrith","Penryn","Penshurst","Pentraeth","Penwortham","Penzance","Perivale","Perranporth","Pershore","Perth","Peterborough","Peterculter","Peterhead","Peterlee","Petersfield","Petworth","Pevensey","Pewsey","Pickering","Piddington","Pilham","Pilton","Pinner","Pinxton","Pitlochry","Pitsford","Pittenweem","Plaistow","Plaitford","Pleshey","Plockton","Plumstead","Plymouth","Plymstock","Pocklington","Polegate","Polmont","Polperro","Ponders End","Pontardawe","Pontefract","Ponteland","Pontesbury","Pontycymer","Pontypool","Pontypridd","Poole","Poplar","Porlock","Port Erroll","Port Glasgow","Port Sunlight","Port Talbot","Portadown","Portaferry","Portchester","Portglenone","Porth","Porthcawl","Porthleven","Portishead","Portlethen","Portmadoc","Portree","Portrush","Portslade-by-Sea","Portsmouth","Portstewart","Postling","Potters Bar","Potterspury","Potton","Poulton le Fylde","Powfoot","Powick","Poynton","Prees","Preesall","Prescot","Prestatyn","Presteigne","Preston","Prestonpans","Prestwich","Prestwick","Princes Risborough","Princethorpe","Privett","Prudhoe","Puckeridge","Pudsey","Pulborough village hall","Pulloxhill","Purfleet","Purleigh","Purley","Pwllheli","Pyle","Quedgeley","Queenborough","Queensferry","Quinton","Radcliffe","Radcliffe on Trent","Radlett","Radnage","Radstock","Rainford","Rainham","Rainhill","Rainworth","Ramsbottom","Ramsbury","Ramsey","Ramsey Saint Marys","Ramsgate","Randalstown","Ratcliffe on Soar","Rathfriland","Ravenstone","Rawmarsh","Rawreth","Rawtenstall","Rayleigh","Rayne","Raynes Park","Reading","Redbourn","Redcar","Reddish","Redditch","Redhill","Redland","Redruth","Reed","Reepham","Reigate","Renfrew","Renton","Repton","Reydon","Rhayader","Rhondda","Rhoose","Rhos-on-Sea","Rhyl","Richmond","Rickmansworth","Ridingmill","Rimington","Ringmer","Ringwood","Ripe","Ripley","Ripon","Ripponden","Risca","Risley","River","Rivington","Roade","Roath","Robertsbridge","Rochdale","Roche","Rochester","Rochford","Rock","Rock Ferry","Roehampton","Roffey","Rogerstone","Rogiet","Romford","Romsey","Ross on Wye","Rosslea","Rosyth","Rothbury","Rotherfield","Rotherham","Rothesay","Rothwell","Rottingdean","Rowde","Rowhedge","Rowlands Castle","Rowlands Gill","Rowley Regis","Roxwell","Royal Leamington Spa","Royal Tunbridge Wells","Royal Wootton Bassett","Roydon","Royston","Ruabon","Ruddington","Rugby","Rugeley","Ruislip","Runcorn","Rushden","Rustington","Rutherglen","Ruthin","Ryde","Rye","Ryton","Sacriston","Saffron Walden","Saint Agnes","Saint Annes on the Sea","Saint Bees","Saint Brides Major","Saint Clears","Saint Columb Major","Saint Erme","Saint Ives","Saint Leonards-on-Sea","Saint Neots","Sale","Salford","Salfords","Salisbury","Saltash","Saltburn-by-the-Sea","Saltcoats","Salthouse","Sandbach","Sanderstead","Sandhurst","Sandiacre","Sandown","Sandwell","Sandwich","Sandy","Sandycroft","Sanquhar","Sarratt","Saundersfoot","Sawbridgeworth","Sawley","Saxmundham","Saxtead","Scalby","Scapa","Scarborough","Scunthorpe","Seacroft","Seaford","Seaham","Seale","Seascale","Seaton","Seaview","Sedbergh","Sedgeberrow","Sedgefield","Sedgley","Seend","Seghill","Selborne","Selby","Selkirk","Selsey","Selston","Send","Settle","Seven Kings","Sevenoaks","Shadoxhurst","Shaftesbury","Shalford","Shanklin","Shardlow","Shaw","Shawbury","Sheering","Sheerness","Sheffield","Shefford","Sheldon","Shelford","Shenfield","Shepperton","Shepshed","Shepton Mallet","Sherborne","Sherfield upon Loddon","Sheringham","Shifnal","Shildon","Shilton","Shinfield","Shipley","Shipston on Stour","Shirebrook","Shirehampton","Shireoaks","Shoeburyness","Shoreham-by-Sea","Shotley Gate","Shotton","Shotts","Shrewsbury","Shrivenham","Sidcot","Sidcup","Sidlesham","Sidmouth","Sileby","Silloth","Silsden","Silsoe","Silverdale","Silverstone","Sittingbourne","Skegness","Skelmersdale","Skelmorlie","Skelton","Skilgate","Skipton","Slapton","Slawitt","Sleaford","Slinfold","Slough","Smalley","Smarden","Smethwick","Snaresbrook","Snettisham","Snodland","Soham","Solihull","Somerset","Somersham","Somerton","Sompting","Sonning","South Benfleet","South Brent","South Brewham","South Carlton","South Cave","South Cerney","South Elmsall","South Hayling","South Hetton","South Killingholme","South Milford","South Molton","South Normanton","South Ockendon","South Petherton","South Shields","Southall","Southam","Southampton","Southbourne","Southend-on-Sea","Southgate","Southminster","Southport","Southsea","Southwark","Southwater","Southwell","Southwick","Southwold","Sowerby Bridge","Spalding","Sparsholt","Speke","Speldhurst","Spennymoor","Spetisbury","Spilsby","Spittal","Spondon","Spratton","Sprowston","Square","St Albans","St Andrews","St Asaph","St Austell","St Helens","St Ives","St. Dogmaels","Stafford","Staindrop","Staines","Stalham","Stallingborough","Stalybridge","Stamford","Stanbridge","Standlake","Stanford","Stanground","Stanhope","Stanley","Stanmore","Stanstead","Stansted","Stanton","Stanton Fitzwarren","Stanwell","Staple","Staplehurst","Star","Staverton","Stawell","Steeple Claydon","Steeton","Stepps","Stevenage","Stevenston","Steventon","Stewarton","Steyning","Stiffkey","Stifford","Stillington","Stirling","Stisted","Stock","Stockbridge","Stockcross","Stockport","Stocksbridge","Stocksfield","Stockton","Stockton-on-Tees","Stoke","Stoke by Nayland","Stoke Climsland","Stoke Newington","Stoke Poges","Stoke Prior","Stoke upon Tern","Stoke-on-Trent","Stokesley","Stone","Stone Allerton","Stonehaven","Stonehouse","Stoneleigh","Stonesfield","Stony Stratford","Stornoway","Storrington","Stotfold","Stourbridge","Stourport On Severn","Stow","Stow on the Wold","Stowe","Stowmarket","Strabane","Stranmillis","Stranraer","Stratfield Mortimer","Stratford","Stratford-upon-Avon","Strathaven","Strathmiglo","Strathyre","Streatham","Streatley","Stretford","Stretton on Fosse","Stromness","Strood","Stroud","Stuartfield","Studham","Studley","Sturmer","Sturminster Newton","Stutton","Sudbury","Sully","Sunbury-on-Thames","Sunderland","Sundon Park","Sunningdale","Sunninghill","Surbiton","Surrey","Sutton","Sutton Bridge","Sutton Coldfield","Sutton Courtenay","Sutton in Ashfield","Sutton on Hull","Sutton on the Hill","Sutton on Trent","Swadlincote","Swaffham","Swalwell","Swanage","Swanland","Swanscombe","Swansea","Swavesey","Swaythling","Swindon","Swindon Village","Swinton","Swynnerton","Symington","Syston","Tackley","Tadcaster","Tadley","Tadmarton","Tadworth","Tain","Takeley","Talgarth","Talsarnau","Talybont","Tamworth","Tandragee","Tansley","Taplow","Tarbert","Tarleton","Tarporley","Tatsfield","Tattershall","Taunton","Tavistock","Taynuilt","Tayport","Teddington","Teignmouth","Telford","Temple","Templecombe","Templepatrick","Tempo","Tenbury Wells","Tenby","Tendring","Tenterden","Tetbury","Tetsworth","Tewin","Tewkesbury","Teynham","Thakeham","Thame","Thames Ditton","Thatcham","The Hyde","Theale","Thetford","Theydon Bois","Thirsk","Thornaby","Thornbury","Thornton","Thornton Heath","Thornton-in-Craven","Thorpe St Peter","Thorrington","Thrapston","Three Legged Cross","Threlkeld","Thurleigh","Thurso","Thurston","Ticehurst","Ticknall","Tideswell","Tilbury","Tile Hill","Tilehurst","Tillicoultry","Tillingham","Timperley","Tipton","Tiptree","Tisbury","Tiverton","Toddington","Todmorden","Tollard Royal","Tollerton","Tonbridge","Tongham","Tonypandy","Tonyrefail","Torpoint","Torquay","Totnes","Tottenham","Totteridge","Totternhoe","Totton","Towcester","Tranent","Tredegar","Trefonen","Treforest","Tregarth","Trehafod","Treharris","Treherbert","Trent","Treorchy","Treuddyn","Trimdon","Tring","Troon","Trowbridge","Truro","Trusthorpe","Tunstall","Turnberry","Turriff","Turvey","Tweedmouth","Twickenham","Twyford","Tyldesley","Tynemouth","Tywardreath","Uckfield","Uddingston","Ufford","Ulceby","Ulcombe","Ullesthorpe","Ulverston","Unstone","Uphall","Upminster","Upper Beeding","Upper Slaughter","Uppingham","Upton","Upton upon Severn","Upwell","Urchfont","Urmston","Ushaw Moor","Usk","Uttoxeter","Uxbridge","Valley","Ventnor","Verwood","Victoria","Voe","Waddesdon","Wadebridge","Wadhurst","Wakefield","Waldringfield","Wales","Walford","Walgrave","Walkden","Walker","Wallasey","Wallingford","Wallington","Wallsend","Walmer","Walsall","Waltham","Waltham Abbey","Waltham Cross","Walthamstow","Walton on Thames","Walton on the Hill","Walton-on-the-Naze","Wanstead","Wantage","Warden","Ware","Wareham","Warfield","Wargrave","Waringstown","Warlingham","Warmington","Warminster","Warrenpoint","Warrington","Warton","Warwick","Washington","Watchet","Watchfield","Water Orton","Waterbeach","Waterlooville","Watford","Wath upon Dearne","Watlington","Wattisfield","Watton","Weald","Wealdstone","Weare","Weaverham","Wedmore","Wednesbury","Wednesfield","Weedon","Weedon Bec","Well","Welling","Wellingborough","Wellington","Wells","Welshpool","Welwyn","Welwyn Garden City","Wem","Wembley","Wemyss Bay","Wendover","Wentworth","Weobley","West Ashby","West Bromwich","West Byfleet","West Calder","West Clandon","West Cowes","West Drayton","West Grinstead","West Horsley","West Kilbride","West Kirby","West Langdon","West Linton","West Malling","West Mersea","West Raynham","West Row","West Rudham","West Wickham","West Wittering","Westbury","Westbury-sub-Mendip","Westcott","Westerham","Westfield","Westgate","Westgate on Sea","Westhay","Westhoughton","Westleigh","Westleton","Weston","Weston in Gordano","Weston under Lizard","Weston-super-Mare","Wetherby","Wethersfield","Weybridge","Weymouth","Whaley Bridge","Whalley","Wheathampstead","Wheatley","Wheaton Aston","Whetstone","Whickham","Whimple","Whisby","Whitbourne","Whitburn","Whitby","Whitchurch","Whitefield","Whitehaven","Whitehouse","Whiteparish","Whitland","Whitley Bay","Whitnash","Whitstable","Whittlebury","Whittlesey","Whittlesford","Whitton","Whitwell","Whitwick","Whyteleafe","Wick","Wicken","Wickersley","Wickford","Wickham","Wickham Bishops","Wickham Market","Widdrington","Widmerpool","Widnes","Wigan","Wigston","Wigton","Wilburton","Wilden","Willaston","Willenhall","Willesden","Willingale Doe","Willingham","Willington","Willington Quay","Wilmington","Wilmslow","Wilnecote","Wilshamstead","Wimbledon","Wimborne Minster","Wincanton","Winchester","Windermere","Windlesham","Windsor","Wing","Wingate","Winkleigh","Winlaton","Winnersh","Winnington","Winsford","Winslow","Winterborne Kingston","Winterbourne Dauntsey","Winton","Wirksworth","Wisbech","Wishaw","Witham","Withernsea","Withernwick","Withington","Witley","Witney","Wix","Woburn Sands","Woking","Wokingham","Wold Newton","Woldingham","Wolstanton","Wolverhampton","Wolverley","Wombourne","Wombwell","Wooburn","Woodbridge","Woodford","Woodford Green","Woodhall Spa","Woodham Ferrers","Woodhouse","Woodley","Woodmancote","Woodsetts","Woodstock","Woolacombe","Woolwich","Woore","Wootton","Worcester","Worcester Park","Workington","Worksop","Worle","Worminghall","Worsley","Worth","Worthing","Wotton Underwood","Wotton-under-Edge","Wragby","Wrangaton","Wrangle","Wrawby","Wraysbury","Wrea Green","Wrexham","Wrington","Writtle","Wroughton","Wroxall","Wyke","Wymeswold","Wymondham","Wythenshawe","Wyton","Wyverstone","Yarm","Yate","Yatton","Yeadon","Yelverton","Yeovil","York","Yoxford","Ystalyfera","Ystrad Mynach","Ystradgynlais","Zeals"]},"GD":{"id":"GD","name":"Grenada","timezones":["America/Port_of_Spain"],"cities":[]},"GE":{"id":"GE","name":"Georgia","timezones":["Asia/Tbilisi"],"cities":["Gogolesubani","Kutaisi","Lentekhi","Qazbegi","Samtredia","Sukhumi","Tbilisi","Zemo-Avchala","Zugdidi"]},"GF":{"id":"GF","name":"French Guiana","timezones":["America/Cayenne"],"cities":[]},"GG":{"id":"GG","name":"Guernsey","timezones":["Europe/London"],"cities":[]},"GH":{"id":"GH","name":"Ghana","timezones":["Africa/Accra"],"cities":["Accra","Bawku","Berekum","Bolgatanga","Cape Coast","Home","Koforidua","Kumasi","Legon","Mampong","Navrongo","Sunyani","Takoradi","Tema","Wa","Winneba"]},"GI":{"id":"GI","name":"Gibraltar","timezones":["Europe/Gibraltar"],"cities":[]},"GL":{"id":"GL","name":"Greenland","timezones":["America/Godthab","America/Danmarkshavn","America/Scoresbysund","America/Thule"],"cities":["Aasiaat","Ilulissat","Kapisillit","Maniitsoq","Narsaq","Narsarsuaq","Nuuk","Nuussuaq","Paamiut","Qaqortoq","Qasigiannguit","Qeqertarsuaq","Qeqertat","Sisimiut","Tasiilaq","Upernavik","Uummannaq Kommune"]},"GM":{"id":"GM","name":"Gambia","timezones":["Africa/Abidjan"],"cities":[]},"GN":{"id":"GN","name":"Guinea","timezones":["Africa/Abidjan"],"cities":["Conakry","Dabola","Kalia","Kankan","Lola","Mamou","Port Kamsar","Sangaredi"]},"GP":{"id":"GP","name":"Guadeloupe","timezones":["America/Port_of_Spain"],"cities":["Anse-Bertrand","Baie Mahault","Baie-Mahault","Baillif","Basse-Terre","Capesterre-Belle-Eau","Capesterre-de-Marie-Galante","Deshaies","Gourbeyre","Goyave","Grand-Bourg","Lamentin","Le Gosier","Le Moule","Les Abymes","Petit-Bourg","Petit-Canal","Pointe-Noire","Port-Louis","Saint-Claude","Saint-Francois","Saint-Louis","Sainte-Anne","Sainte-Rose","Terre-de-Bas","Terre-de-Haut","Trois-Rivieres","Village"]},"GQ":{"id":"GQ","name":"Equatorial Guinea","timezones":["Africa/Lagos"],"cities":[]},"GR":{"id":"GR","name":"Greece","timezones":["Europe/Athens"],"cities":["Aegina","Agioi Anargyroi","Agios Nikolaos","Agrinio","Aigaleo","Aigio","Alexandreia","Alexandroupoli","Aliartos","Alimos","Amaliada","Anavyssos","Andravida","Ano Liosia","Archaia Nemea","Argos","Argostoli","Argyroupoli","Arta","Aspropyrgos","Athens","Attica","Ayios Stefanos","Chalcis","Chania","Chios","Cholargos","Corfu","Corinth","Dafni","Dionysos","Drama","Ekali","Elassona","Elefsina","Elliniko","Eretria","Farsala","Filippiada","Filothei","Florina","Galatsi","Giannitsa","Glyfada","Gonnoi","Goumenissa","Heraklion","Hydra","Ialysos","Ierapetra","Igoumenitsa","Ioannina","Kaisariani","Kalamaria","Kalamata","Kalamos","Kallithea","Kalymnos","Kamatero","Karditsa","Kassiopi","Kastoria","Katerini","Kavala","Keratea","Keratsini","Kifissia","Kilkis","Komotini","Koropi","Kos","Kouvaras","Kozani","Kranidi","Kryonerion","Kymi","Lamia","Larisa","Lefkada","Lefkimmi","Leontario","Litochoro","Lixouri","Loutraki","Lykovrysi","Magoula","Makrygialos","Mandra","Marathon","Markopoulo Mesogaias","Megalochari","Megara","Melissia","Mesagros","Messolonghi","Metaxades","Moires","Mytilene","Nafpaktos","Nafplion","Naousa","Naxos","Nea Alikarnassos","Nea Filadelfeia","Nea Ionia","Nea Kios","Nea Makri","Nea Peramos","Nea Smyrni","Nikaia","Orestiada","Ormylia","Oropos","Paiania","Pallini","Paloukia","Panorama","Parga","Patmos","Pefki","Pella","Perama","Peristeri","Pikermi","Piraeus","Platy","Polichni","Porto Rafti","Preveza","Psychiko","Ptolemaida","Pylaia","Pyrgos","Rafina","Rethymno","Rhodes","Rio","Salamina","Samothraki","Serres","Servia","Sindos","Skala","Skala Oropou","Skiathos","Sparta","Spata","Symi","Tavros","Thebes","Thermi","Thessaloniki","Tinos","Trikala","Tripoli","Vari","Varkiza","Vergina","Veroia","Volos","Voula","Vouliagmeni","Xanthi","Xylokastro","Zakynthos"]},"GS":{"id":"GS","name":"South Georgia & the South Sandwich Islands","timezones":["Atlantic/South_Georgia"],"cities":[]},"GT":{"id":"GT","name":"Guatemala","timezones":["America/Guatemala"],"cities":["Antigua Guatemala","Cambote","Catarina","Central","Chimaltenango","Chiquimula","Ciudad Vieja","Coban","El Limon","El Naranjo","El Salvador","Escuintla","Esquipulas","Flores","Guatemala City","Huehuetenango","Jocotenango","La Reforma","Mazatenango","Melchor de Mencos","Mixco","Palin","Panajachel","Petapa","Puerto Barrios","Quesada","Quetzaltenango","Retalhuleu","San Antonio Miramar","San Jose Pinula","San Juan","San Marcos","San Pedro Sacatepequez","Santa Catarina Pinula","Santa Cruz La Laguna","Santa Cruz Naranjo","Santa Lucia Cotzumalguapa","Santa Rosa","Solola","Villa Nueva","Vista Hermosa","Zacapa"]},"GU":{"id":"GU","name":"Guam","timezones":["Pacific/Guam"],"cities":["Barrigada Village","Dededo Village","Inarajan Village","Santa Rita","Tamuning-Tumon-Harmon Village","Yigo Village"]},"GW":{"id":"GW","name":"Guinea-Bissau","timezones":["Africa/Bissau"],"cities":[]},"GY":{"id":"GY","name":"Guyana","timezones":["America/Guyana"],"cities":[]},"HK":{"id":"HK","name":"Hong Kong","timezones":["Asia/Hong_Kong"],"cities":["Aberdeen","Causeway Bay","Central District","Cha Kwo Ling","Chai Wan Kok","Chek Chue","Cheung Kong","Cheung Sha Wan","Chuen Lung","Chung Hau","Fa Yuen","Fanling","Fo Tan","Happy Valley","Ho Man Tin","Hong Kong","Hung Hom","Kat O Sheung Wai","Kennedy Town","Kowloon","Kowloon Tong","Kwai Chung","Kwun Hang","Lai Chi Wo","Lam Tei","Lam Tin","Lin Fa Tei","Lo So Shing","Ma On Shan Tsuen","Ma Wan","Ma Yau Tong","Mau Ping","Mid Levels","Mong Kok","Nam A","Ngau Chi Wan","Ngau Tau Kok","North Point","Pak Ngan Heung","Peng Chau","Ping Yeung","Quarry Bay","Repulse Bay","Sai Keng","San Tsuen","San Tung Chung Hang","Sha Po Kong","Sha Tau Kok","Sha Tin Wai","Sham Shui Po","Sham Tseng","Shatin","Shau Kei Wan","Shek Kip Mei","Shek Tong Tsui","Sheung Shui","Sheung Tsuen","Shuen Wan","Tai Chau To","Tai Hang","Tai Kok Tsui","Tai Lin Pai","Tai Po","Tai Tan","Tai Wai","Tai Wan To","Tin Shui Wai","Tin Wan Resettlement Estate","Ting Kau","To Kwa Wan","Tseung Kwan O","Tsimshatsui","Tsing Lung Tau","Tsz Wan Shan","Tuen Mun San Hui","Wan Tsai","Wo Che","Wong Chuk Hang","Wong Tai Sin","Yau Ma Tei","Ying Pun","Yuen Long San Hui"]},"HN":{"id":"HN","name":"Honduras","timezones":["America/Tegucigalpa"],"cities":["Choloma","Comayagua","Comayaguela","Coxen Hole","El Barro","El Paraiso","El Progreso","La Ceiba","La Hacienda","Morazan","Nacaome","Pinalejo","Piraera","Puerto Lempira","San Antonio de Flores","San Pedro Sula","Santa Barbara","Sula","Tegucigalpa"]},"HR":{"id":"HR","name":"Croatia","timezones":["Europe/Belgrade"],"cities":["Antunovac","Baska","Baska Voda","Bedekovcina","Bestovje","Betina","Bibinje","Bizovac","Bjelovar","Bracevci","Brdovec","Bregana","Brela","Brsadin","Buje","Cabuna","Cavtat","Cepin","Cestica","Core","Crikvenica","Dalj","Darda","Delnice","Desinic","Donja Pusca","Donja Zelina","Donji Kraljevec","Dubrovnik","Dugo Selo","Fazana","Fuzine","Galgovo","Glina","Gornja Lomnica","Gornji Kriz","Gornji Stupnik","Hreljin","Icici","Ivanec","Ivanic-Grad","Karlovac","Karojba","Kastel Gomilica","Kastel Luksic","Kastel Sucurac","Koprivnica","Kostrena","Kraljevec na Sutli","Krapina","Kriz","Krk","Krsan","Kutjevo","Labin","Lapad","Lekenik","Lepoglava","Lovran","Lukavec","Lupoglav","Makarska","Matulji","Medulin","Mlini","Mursko Sredisce","Nedelisce","Nova Gradiska","Novi Marof","Novi Vinodolski","Novo Cice","Nustar","Okrug Gornji","Opatija","Orahovica","Orebic","Orle","Oroslavje","Osijek","Pakrac","Pazin","Petrcane","Petrinja","Piskorevci","Podastrana","Podgajci Posavski","Popovaca","Postira","Pregrada","Prelog","Primosten","Privlaka","Pula","Rab","Rakitje","Rijeka","Rovinj","Samobor","Sapjane","Senkovec","Sesvete","Sesvetski Kraljevec","Sice","Silas","Simuni","Sinj","Sisak","Slatina","Slavonski Brod","Sokolovac","Solin","Split","Splitska","Strmec","Strmec Samoborski","Sveti Ivan Zelina","Tar","Torcec","Trogir","Tuzno","Umag","Varazdinske Toplice","Vardarac","Velika Gorica","Vetovo","Vinica","Vinkovci","Virje","Virovitica","Viskovci","Vojnic","Vrata","Vratisinec","Vrbnik","Vrbovec","Vukovar","Zabok","Zadar","Zagreb","Zapresic","Zlatar"]},"HT":{"id":"HT","name":"Haiti","timezones":["America/Port-au-Prince"],"cities":["Carrefour","Delmar","Duverger","Jacmel","Masseau","Moise","Petionville","Port-au-Prince","Prince","Turgeau"]},"HU":{"id":"HU","name":"Hungary","timezones":["Europe/Budapest"],"cities":["Abaujszanto","Abda","Abony","Acs","Acsa","Adacs","Adony","Agard","Ajak","Ajka","Alap","Albertirsa","Almasfuzito","Almaskamaras","Almosd","Alsogalla","Alsonemedi","Alsopahok","Alsoszentivan","Alsotold","Alsozsolca","Aparhant","Apatfalva","Apc","Apostag","Arnot","Asotthalom","Aszalo","Aszar","Aszod","Atkar","Attala","Babolna","Bacsalmas","Badacsonytomaj","Badacsonytordemic","Bag","Bagyogszovat","Baja","Bajna","Bakonybel","Bakonycsernye","Bakonyszentlaszlo","Bakonyszombathely","Balassagyarmat","Balaton","Balatonalmadi","Balatonboglar","Balatonfokajar","Balatonfured","Balatonfuzfo","Balatonkenese","Balatonlelle","Balatonszabadi","Balatonszarszo","Balkany","Balloszog","Balmazujvaros","Banhorvati","Baracs","Baracska","Barand","Barcs","Bataszek","Batonyterenye","Bazsi","Becsehely","Bekasmegyer","Bekesszentandras","Belapatfalva","Beled","Beloiannisz","Benye","Berekfurdo","Berettyoujfalu","Berhida","Berkesd","Besnyo","Biatorbagy","Bicske","Biharkeresztes","Bikal","Bocs","Bodajk","Bodaszolo","Bodrogkisfalud","Bogyiszlo","Bohonye","Bokod","Boldog","Boldva","Boly","Boncodfolde","Bonyhad","Borcs","Borsodszirak","Budajeno","Budakalasz","Budakeszi","Budaors","Budapest","Bugac","Bugyi","Buk","Bukkaranyos","Buzsak","Cegled","Cegledbercel","Celldomolk","Center","Cered","Ciko","Cirak","Csabacsud","Csajag","Csakvar","Csanadpalota","Csanytelek","Csecse","Csemo","Csepa","Cserenfa","Cserepfalu","Cserszegtomaj","Csobad","Csobanka","Csoeroeg","Csogle","Csolyospalos","Csomad","Csomor","Csongrad","Csopak","Csorna","Csorvas","Csovar","Dabas","Dad","Danszentmiklos","Dany","Debrecen","Decs","Dedestapolcsany","Deg","Delegyhaza","Demjen","Derecske","Deszk","Devavanya","Devecser","Diosd","Dobrokoz","Domaszek","Dombovar","Dombrad","Domoszlo","Domsod","Donat","Dorog","Doroghaza","Dudar","Dunabogdany","Dunafoldvar","Dunaharaszti","Dunakeszi","Dunaszeg","Dunaszentgyorgy","Dunavarsany","Dunavecse","Dusnok","Ebes","Ecs","Ecser","Edeleny","Eger","Egerszolat","Egyek","Egyhazasdengeleg","Egyhazashetye","Emod","Encs","Eperjeske","Ercsi","Erdokertes","Esztergom","Farmos","Fegyvernek","Fehergyarmat","Felsopakony","Felsoszentivan","Felsotarkany","Felsozsolca","Fertod","Fertoszentmiklos","Fot","Fuzesabony","Fuzesgyarmat","Galambok","Galgamacsa","Garab","Gardony","Gasztony","Gavavencsello","Gelse","Gemzse","Gencsapati","Gerjen","God","Golle","Gonyu","Gorbehaza","Gorgeteg","Gyal","Gyar","Gyenesdias","Gyomaendrod","Gyomro","Gyongyos","Gyongyossolymos","Gyongyostarjan","Gyorkony","Gyorladamer","Gyorsag","Gyorujbarat","Gyorzamoly","Gyula","Gyulahaza","Hajduboszormeny","Hajdudorog","Hajduhadhaz","Hajdunanas","Hajdusamson","Hajduszoboszlo","Hajmasker","Halaszi","Halasztelek","Halimba","Harkany","Harta","Hatvan","Hegyeshalom","Hegyfalu","Hegyhatmaroc","Hegyhatszentmarton","Hehalom","Helvecia","Herceghalom","Hercegkut","Hercegszanto","Hered","Herend","Hernad","Hernadkak","Hernadnemeti","Heves","Hevesaranyos","Hevizgyoerk","Hidas","Hodmezovasarhely","Homrogd","Hont","Hort","Hosszuheteny","Ibrany","Ikreny","Inancs","Inarcs","Iregszemcse","Isaszeg","Ivancsa","Izmeny","Janoshalma","Janoshida","Janossomorja","Jaszapati","Jaszbereny","Jaszfelsoszentgyorgy","Jaszfenyszaru","Jaszkiser","Jaszladany","Juta","Kacsota","Kadarkut","Kajaszo","Kallo","Kalocsa","Kaloz","Kapolnasnyek","Kaposmero","Kapuvar","Karancskeszi","Karancslapujto","Karancssag","Karcag","Kartal","Kazincbarcika","Kecel","Kemecse","Kemence","Kerecsend","Kerekegyhaza","Kerekharaszt","Kerepes","Kesznyeten","Keszthely","Keszu","Ketegyhaza","Kevermes","Kincsesbanya","Kisar","Kisber","Kisdorog","Kisgyor","Kiskinizs","Kiskoros","Kiskunfelegyhaza","Kiskunhalas","Kiskunlachaza","Kislang","Kismanyok","Kismaros","Kisnemedi","Kispest","Kistapolca","Kistarcsa","Kistelek","Kistokaj","Kistormas","Kisujszallas","Kisvarda","Kisvaszar","Klarafalva","Koka","Kolontar","Komlo","Komlod","Kompolt","Kony","Kophaza","Kormend","Kornye","Korosladany","Koszarhegy","Koszeg","Kotaj","Kotelek","Kubekhaza","Kulcs","Kulsobarand","Kunagota","Kunbaja","Kunhegyes","Kunszentmarton","Kunszentmiklos","Kunsziget","Kurd","Kurityan","Labatlan","Labod","Ladbesenyo","Lajoskomarom","Lajosmizse","Lazi","Leanyfalu","Lebeny","Lenti","Letenye","Levelek","Lovas","Lovaszi","Madocsa","Maglod","Magy","Magyaregres","Magyarhertelend","Magyarnandor","Majoshaza","Makad","Makkoshotyka","Maklar","Mako","Malyi","Mandok","Many","Marcali","Mariapocs","Markaz","Marokpapi","Martely","Martfu","Martonvasar","Mateszalka","Matraballa","Matraszolos","Mecseknadasd","Medgyesegyhaza","Melykut","Mende","Mernye","Mesztegnyo","Mezobereny","Mezofalva","Mezohegyes","Mezokovesd","Mezonyarad","Mezoszilas","Mezotur","Mindszent","Misefa","Miskolc","Mogyorod","Monor","Monorierdo","Mor","Morahalom","Mosonszentmiklos","Mosonszolnok","Mucsony","Nagyatad","Nagybarca","Nagyberki","Nagycenk","Nagycserkesz","Nagydobsza","Nagyhalasz","Nagyhegyes","Nagyigmand","Nagykallo","Nagykanizsa","Nagykapornak","Nagykata","Nagykereki","Nagykeresztur","Nagykoros","Nagykoru","Nagykovacsi","Nagykozar","Nagymagocs","Nagymanyok","Nagynyarad","Nagypali","Nagysap","Nagyszekeres","Nagyszenas","Nagyszokoly","Nagytarcsa","Nagytotfalu","Nagyvazsony","Nagyvenyim","Naszaly","Nemesbod","Nemesbuek","Nemesvid","Nemesvita","Nemetker","Neszmely","Nezsa","Nogradsap","Nogradsipek","Nyekladhaza","Nyergesujfalu","Nyiradony","Nyirbator","Nyiregyhaza","Nyirmartonfalva","Nyirtass","Nyul","Ocsa","Ocseny","Ocsod","Ofeherto","Onga","Orbottyan","Oroshaza","Oroszlany","Ostoros","Otteveny","Ozd","Paka","Pakod","Pakozd","Paks","Palotabozsok","Papa","Part","Paszto","Patroha","Patvarc","Paty","Pazmand","Pecel","Pecol","Pellerd","Per","Perbal","Perenye","Peteri","Petfuerdo","Petofibanya","Petohaza","Pilis","Piliscsaba","Pilismarot","Pilisszanto","Pilisszentivan","Pilisszentkereszt","Pilisvorosvar","Polgar","Polgardi","Pomaz","Posfa","Puspokladany","Pusztaszabolcs","Pusztaszemes","Pusztavacs","Pusztavam","Pusztazamor","Rabapatona","Rabapaty","Racalmas","Rackeresztur","Rackeve","Rad","Rajka","Rakoczifalva","Rakocziujfalu","Repcelak","Repceszemere","Retsag","Revfueloep","Rimoc","Roszke","Rudabanya","Sajokapolna","Sajokeresztur","Sajooeroes","Sajopalfala","Sajoszentpeter","Sajovamos","Salfold","Salgotarjan","Sandorfalva","Sarbogard","Sarisap","Sarkad","Sarmellek","Sarosd","Sarospatak","Sarpentele","Sarpilis","Sarszentagota","Sarszentlorinc","Sarszentmihaly","Sarvar","Sasd","Saska","Se","Selyeb","Senyo","Seregelyes","Siklos","Simontornya","Sirok","Solt","Soltszentimre","Solymar","Somogysard","Somogyudvarhely","Sopron","Sopronkovesd","Sored","Soskut","Suelysap","Sukoro","Sumeg","Szabadbattyan","Szabadszallas","Szabadszentkiraly","Szabolcs","Szabolcsveresmart","Szajk","Szajol","Szalaszend","Szany","Szar","Szarvas","Szazhalombatta","Szecseny","Szecsenyfelfalu","Szeged","Szeghalom","Szegvar","Szemely","Szendehely","Szentendre","Szentes","Szentgotthard","Szentistvan","Szentkatalin","Szentkiralyszabadja","Szentlorinc","Szentmartonkata","Szepetnek","Szeremle","Szerencs","Szigetcsep","Szigethalom","Szigetszentmarton","Szigetszentmiklos","Szigetvar","Szigliget","Szikszo","Szilsarkany","Szirmabesenyo","Szod","Szodliget","Szogliget","Szokolya","Szolnok","Szombathely","Szomod","Szomor","Szuhakallo","Tab","Tabajd","Taborfalva","Taksony","Taktaszada","Tamasi","Tapiobicske","Tapiogyorgye","Tapiosag","Tapioszecso","Tapioszele","Taplanszentkereszt","Tapolca","Tar","Tarcal","Tarjan","Tarnok","Tarpa","Tass","Taszar","Tat","Tata","Teglas","Telekes","Telep","Telki","Tepe","Terem","Tet","Tetetlen","Tevel","Tinnye","Tiszaadony","Tiszabo","Tiszacsege","Tiszafoldvar","Tiszafured","Tiszalok","Tiszaluc","Tiszapalkonya","Tiszaszalka","Tiszaujvaros","Tiszavalk","Tiszavasvari","Toekoel","Toeroekbalint","Tokodaltaro","Tolna","Tomorkeny","Tompa","Tordas","Torokszentmiklos","Torony","Toszeg","Totkomlos","Totszerdahely","Tura","Turkeve","Ujfeherto","Ujkenez","Ujkigyos","Ujlengyel","Ujszasz","Ujszentmargita","Ujszilvas","Ujudvar","Ullo","Uraiujfalu","Uri","Urom","Vacduka","Vacratot","Vacszentlaszlo","Vadna","Vaja","Vajszlo","Valko","Valkonya","Vamospercs","Vamosszabadi","Varalja","Varbalog","Varbo","Vardomb","Varosfoeld","Varpalota","Vasarosdombo","Vasvar","Vecses","Vegegyhaza","Velence","Vep","Veresegyhaz","Veroce","Verseg","Vertessomlo","Vertesszolos","Vertestolna","Vezseny","Visznek","Vitnyed","Vizslas","Zagyvaszanto","Zahony","Zalaegerszeg","Zalakomar","Zalalovo","Zalaszentgrot","Zamoly","Zebecke","Zebegeny","Zichyujfalu","Zirc","Zsambek","Zsambok","Zsombo"]},"ID":{"id":"ID","name":"Indonesia","timezones":["Asia/Jakarta","Asia/Pontianak","Asia/Makassar","Asia/Jayapura"],"cities":["Abadi","Adiantorop","Airmadidi","Ambarawa","Ambon City","Amlapura","Anggrek","Angkasa","Area","Badung","Bali","Balige","Balikpapan","Banda Aceh","Bandar","Bandar Lampung","Bandung","Bangkalan","Bangkinang","Bangli","Banjar","Banjarbaru","Banjarmasin","Banjarnegara","Bantaeng","Bantan","Bantul","Banyumas","Banyuwangi","Baratjaya","Batang","Batu","Baturaja","Baubau","Bekasi","Bengkalis","Bengkulu","Bima","Binjai","Bitung","Blitar","Blora","Bogor","Bojonegoro","Bondowoso","Bontang","Boyolali","Bukit Tinggi","Bulukumba","Buntok","Cakrawala","Cempaka","Cengkareng","Ciamis","Cianjur","Cibitung","Cibubur","Cihampelas","Cikarang","Cikini","Cilacap","Cilegon","Cilincing","Cimahi","Cimanggis","Cipinanglatihan","Ciputat","Cirebon","Citeureup","Darmaga","Darussalam","Demak","Denpasar","Depok","Depok Jaya","Dumai","Duren","Duri","Gandul","Garut","Gedung","Gianyar","Gorontalo","Gresik","Guntung","Gunungsitoli","Holis","Indo","Indramayu","Jagakarsa","Jakarta","Jambi City","Jayapura","Jember","Jepara","Jimbaran","Jombang","Kabanjahe","Kalideres","Kalimantan","Kandangan","Karanganyar","Karawang","Kartasura","Kebayoran Baru","Kebayoran Lama Selatan","Kebumen","Kediri","Kelapa Dua","Kemang","Kendal","Kepanjen","Kerinci","Kerobokan","Klaten","Kopeng","Kota","Kudus","Kulon","Kuningan","Kupang","Kuta","Lamongan","Lampeong","Langsa","Lapan","Lawang","Lestari","Lhokseumawe","Lubuk Pakam","Lumajang","Madiun","Magelang","Magetan","Mail","Majalengka","Makassar","Malang","Mamuju","Manado","Maros","Mataram","Medan","Mega","Menara","Menteng","Mojoagung","Mojokerto","Muntilan","Negara","Negeribesar","Nganjuk","Ngawi","Nusa","Nusa Dua","Nusantara","Pacitan","Padang","Palaihari","Palangka","Palangkaraya","Palembang","Palu","Pamekasan","Pamulang","Panasuan","Pandeglang","Pangaturan","Parakan","Pare","Parman","Pasuruan","Patam","Pati","Payakumbuh","Pekalongan","Pekan","Pekanbaru","Pemalang","Pematangsiantar","Polerejo","Pondok","Ponorogo","Pontianak","Porsea","Poso","Probolinggo","Purbalingga","Purwakarta","Purwodadi Grobogan","Purwokerto","Purworejo","Pusat","Riau","Salatiga","Samarinda","Sampang","Sampit","Sangereng","Sanur","Sejahtera","Sekupang","Selatan","Selong","Semarang","Sengkang","Sentul","Serang","Serdang","Serpong","Sidoarjo","Sigli","Sijunjung","Simpang","Singaraja","Singkawang","Situbondo","Sleman","Soasio","Soe","Soho","Solo","Sragen","Stabat","Subang","Sukabumi","Sukoharjo","Sumedang","Sungailiat","Sunggal","Sungguminasa","Surabaya","Surabayan","Surakarta","Tabanan","Tangsel","Tanjung","Tanjung Balai","Tanjungpinang","Tarakan","Tasikmalaya","Tebingtinggi","Tegal","Temanggung","Tembagapura","Tengah","Tenggara","Tenggarong","Tigaraksa","Tigarasa","Timur","Tipar Timur","Tirtagangga","Tomohon","Tondano","Trenggalek","Tuban","Tulungagung","Ubud","Udayana","Ungaran","Utama","Utara","Veteran","Wilayah","Wonogiri","Wonosari","Wonosobo","Yogyakarta"]},"IE":{"id":"IE","name":"Ireland","timezones":["Europe/Dublin"],"cities":["Abbeyfeale","Abbeyleix","Ardee","Arklow","Artane","Ashbourne","Athboy","Athenry","Athlone","Athy","Bagenalstown","Bailieborough","Balbriggan","Baldoyle","Balgriffin","Ballina","Ballinadee","Ballinasloe","Ballincollig","Ballineen","Ballinrobe","Ballintober","Ballivor","Ballon","Ballsbridge","Ballybrack","Ballybrit","Ballycullen","Ballyfermot","Ballygarvan","Ballyhooly","Ballymahon","Ballymote","Ballymount","Ballymun","Ballyphilip","Ballyragget","Ballyroe","Ballyvaghan","Bandon","Bantry","Berrings","Bettystown","Birr","Blackrock","Blanchardstown","Blessington","Bodyke","Boherbue","Bray","Broadford","Buncrana","Bundoran","Cabinteely","Cabra","Caher","Cahersiveen","Callan","Carbury","Carlow","Carnew","Carraroe","Carrick","Carrick on Shannon","Carrick-on-Suir","Carrickmacross","Carrickmines","Carrigaline","Carrigtohill","Cashel","Castlebar","Castleblayney","Castlebridge","Castleknock","Castlemaine","Castlerea","Cavan","Celbridge","Clane","Clarecastle","Claregalway","Claremorris","Clogherhead","Clonakilty","Clondalkin","Clonee","Clones","Clonmel","Clonsilla","Clontarf","Coachford","Cobh","Coolock","Cork","County Galway","County Wexford","Courtown","Crookhaven","Cross","Crosshaven","Crumlin","Crusheen","Dalkey","Delgany","Donabate","Donegal","Donnybrook","Doolin","Doughiska","Douglas","Drogheda","Droichead Nua","Dublin","Duleek","Dunboyne","Dundalk","Dundrum","Dungarvan","Dunlavin","Dunleer","Dunshaughlin","Edenderry","Enfield","Ennis","Enniscorthy","Enniskerry","Feakle","Ferbane","Fermoy","Finglas","Firhouse","Foxford","Foxrock","Foynes","Galway","Garristown","Geevagh","Glanmire","Glasnevin","Glen","Glenealy","Glengarriff","Glenties","Gorey","Gort","Grange","Greystones","Headford","Hospital","Inchicore","Irishtown","Island","Jamestown","Kanturk","Kells","Kenmare","Kilbride Cross Roads","Kilcock","Kilcoole","Kilcullen","Kildalkey","Kildare","Kilfinane","Kilkenny","Killala","Killaloe","Killarney","Killiney","Killinick","Killorglin","Killurin","Killybegs","Killygordon","Kilmainham","Kilmichael","Kilmore","Kilrush","Kiltamagh","Kingscourt","Kingswood","Kinsale","Kinvarra","Leamlara","Leixlip","Leopardstown","Letterkenny","Limerick","Lisselton","Listowel","Longford","Longwood","Loughrea","Louth","Lucan","Lusk","Macroom","Malahide","Mallow","Manorhamilton","Marino","Maynooth","Mayo","Midleton","Milltown","Mitchelstown","Monaghan","Monasterevin","Monkstown","Mornington","Mount Merrion","Mountrath","Moycullen","Mullinavat","Mullingar","Naas","Naul","Navan","Nenagh","New Ross","Newcastle West","Newmarket","Newport","Oranmore","Oughterard","Oysterhaven","Passage West","Patrickswell","Portarlington","Porterstown","Portmarnock","Portumna","Prosperous","Raheny","Rathcoole","Rathfarnham","Rathgar","Rathmines","Rathmolyon","Rathowen","Ratoath","Ringaskiddy","River","Roscommon","Roscrea","Rush","Saggart","Saint Mullins","Sallins","Sallynoggin","Sandyford","Sandymount","Santry","Seafield","Shankill","Shannon","Shrule","Sixmilebridge","Skerries","Skibbereen","Slieve","Sligo","Spiddal","Stepaside","Stillorgan","Stradbally","Straffan","Summerhill","Sutton","Swinford","Swords","Tallaght","Templeogue","Terenure","Thomastown","Thurles","Tipperary","Tralee","Trim","Tuam","Tullamore","Tullow","Tyrrellspass","Virginia","Walkinstown","Waterford","Westport","Wexford","Wicklow","Williamstown","Windy Arbour","Youghal"]},"IL":{"id":"IL","name":"Israel","timezones":["Asia/Jerusalem"],"cities":["`Alma","`Amir","`Arugot","`Aseret","`En Ayyala","`En HaShelosha","`Evron","Acre","Afiqim","Ahituv","Allonim","Ashdod","Ashqelon","Azor","Bahan","Baraq","Bareqet","Bat Hadar","Bat Hefer","Bat Yam","Beersheba","Ben Shemen-Kefar Hano`ar","Bene Ziyyon","Bet Alfa","Bet Dagan","Bet Oren","Bet Shemesh","Binyamina","Biriyya","Dabburiya","Dimona","Eilat","Elyakhin","Elyaqim","Emunim","Et Taiyiba","Even Yehuda","Gan Hayyim","Gan Yavne","Ganne Tiqwa","Gedera","Gibbeton","Gimzo","Ginnosar","Giv`at Hayyim","Hadar `Am","Hadar Ramatayim","Hadera","Hadid","Haifa","HaKarmel","Haluz","Hazav","Hazor Ashdod","Hazor HaGelilit","Herut","Herzliya","Hever","Hod HaSharon","Holon","Hurfeish","Jaffa","Jerusalem","Kadima","Karkur","Kefar Daniyyel","Kefar Netter","Kefar Witqin","Kefar Yona","Kfar Saba","Liman","Lod","maalot Tarshiha","Magen","Maghar","Mazkeret Batya","Mazliah","Mazor","Mesillat Ziyyon","Migdal","Mikhmoret","Misgav Regional Council","Mizpe Netofa","Modiin","Moran","Naham","Nahariya","Nazareth","Nazerat `Illit","Nesher","Ness Ziona","Netanya","Netivot","Newe Efrayim","Newe Yamin","Nir Zevi","Nirim","Nordiyya","Ofaqim","Or `Aqiva","Or Yehuda","Pardes Hanna Karkur","Pardesiyya","Pasuta","Petah Tikwah","Qiryat Ata","Qiryat Bialik","Qiryat Gat","Qiryat Hayyim","Qiryat Motzkin","Qiryat Ono","Qiryat Tiv`on","Qiryat Yam","Ramat Aviv","Ramat Dawid","Ramat Ef`al","Ramat Gan","Ramat HaSharon","Ramat Poleg","Ramat Yishay","Ramla","Ramot Naftali","Rehovot","Rinnatya","Rishon LeZion","Rishpon","Safed","Sarid","Savyon","Sde Boker","Sde Warburg","Sderot","Sedot Yam","Shamir","Shave Ziyyon","Shefayim","Shelomi","Shetulim","Shoval","Talme Menashe","Tel Aviv","Tel Mond","Tiberias","Timrat","Tirat Karmel","Tirat Yehuda","Urim","Yaqum","Yavne","Yehud","Zoran"]},"IM":{"id":"IM","name":"Isle of Man","timezones":["Europe/London"],"cities":["Ballasalla","Castletown","Crosby","Dalby","Douglas","Foxdale","Laxey","Onchan","Peel","Port Erin","Port Saint Mary","Ramsey","Saint Johns"]},"IN":{"id":"IN","name":"India","timezones":["Asia/Kolkata"],"cities":["Abdul","Adilabad","Adwani","Agartala","Agra","Ahmedabad","Ahmednagar","Aizawl","Ajabpur","Ajmer","Akividu","Akola","Alanallur","Alangulam","Alappuzha","Aldona","Alibag","Aligarh","Alipur","Allahabad","Almora","Aluva","Alwar","Amal","Amalapuram","Ambad","Ambah","Ambala","Ambarnath","Ambejogai","Ambikapur","Ambur","Amer","Amet","Amravati","Amreli","Amritsar","Anand","Anantapur","Anantnag","Anantpur","Anchal","Andheri","Andra","Angadipuram","Angul","Ankleshwar","Annamalainagar","Antapur","Arakkonam","Arani","Aranmula","Arch","Ariyalur","Arora","Arpora","Arunachal","Arvi","Asansol","Assagao","Attingal","Attur","Aundh","Aurangabad","Avanigadda","Azamgarh","Baddi","Badlapur","Bagalkot","Bagh","Bagpat","Bahadurgarh","Baharampur","Baidyabati","Bala","Balaghat","Balana","Balanagar","Balangir","Balasore","Bali","Ballabgarh","Balu","Balurghat","Bambolim","Banda","Bandra","Banga","Bangalore","Bangaon","Bank","Banka","Bankura","Banswara","Bapatla","Barakpur","Baramati","Barddhaman","Bardoli","Bareilly","Bargarh","Barmer","Barnala","Baroda","Barpali","Barpeta","Basirhat","Basti","Basu","Batala","Bawan","Bawana","Beawar","Begusarai","Behala","Bela","Belapur","Belgaum","Belgharia","Bellare","Bellary","Bemetara","Berasia","Betalbatim","Betim","Betul","Bhadath","Bhadohi","Bhadravati","Bhagalpur","Bhagwan","Bhandari","Bhandup","Bharatpur","Bharuch","Bhatapara","Bhatinda","Bhatkal","Bhavnagar","Bhawan","Bhilai","Bhilwara","Bhimavaram","Bhiwandi","Bhiwani","Bhoj","Bhongir","Bhopal","Bhubaneswar","Bhuj","Bhusawal","Bichpuri","Bidar","Bihar Sharif","Bijapur","Bikaner","Bilaspur","Bilimora","Binavas","Binnaguri","Bishnupur","Bobbili","Bodhan","Bodinayakkanur","Boisar","Bokaro","Bolpur","Botad","Brahmapur","Budaun","Budbud","Budha","Bulandshahr","Bundi","Calangute","Candolim","Canning","Caranzalem","Chakan","Chakra","Chalisgaon","Chamba","Champa","Chand","Chandan","Chandannagar","Chandauli","Chandausi","Chandigarh","Chandrapur","Changanacheri","Channapatna","Charan","Charu","Chen","Chengannur","Chennai","Chetan","Cheyyar","Chhabra","Chhachhrauli","Chhota Udepur","Chicalim","Chidambaram","Chikodi","Chinchvad","Chintamani","Chiplun","Chirala","Chitra","Chitradurga","Chittoor","Chittur","Choolai","Chopda","Chopra","Churachandpur","Coimbatore","Colaba","Connaught Place","Coonoor","Cuddalore","Cumbum","Cuncolim","Curchorem","Cuttack","Dadri","Dahanu","Dahod","Dam Dam","Daman","Damoh","Dang","Dangi","Darbhanga","Darjeeling","Darsi","Dasna","Dasua","Davangere","Dehradun","Delhi","Deolali","Deoria","Devgarh","Devipattinam","Dewas","Dhaka","Dhamtari","Dhanbad","Dhansura","Dhar","Dharamsala","Dharapuram","Dharavi","Dhariwal","Dharmapuri","Dharwad","Dhenkanal","Dhone","Dhrol","Dhubri","Dhule","Dhuri","Dibrugarh","Dicholi","Dimapur","Dinanagar","Dindigul","Dindori","Dipas","Dogadda","Dona Paula","Dumka","Durg","Durgapur","Dwarahat","Dwarka","Edavanna","Ekkattuthangal","Ellora Caves","Eluru","Eral","Ernakulam","Erode","Etawah","Faizabad","Farakka","Faridabad","Faridkot","Fatehabad","Fatehgarh","Fatehpur","Firozabad","Firozpur","Fort","Gadag","Gampalagudem","Gandhidham","Gandhigram","Gandhinagar","Ganga","Ganganagar","Gangapur","Gangrar","Gangtok","Gannavaram","Ganpat","Gargoti","Garhshankar","Gaya","Ghana","Ghatal","Ghatkopar","Ghaziabad","Goa","Gobichettipalayam","Godhra","Gohana","Golaghat","Gold","Gonda","Gorakhpur","Goregaon","Goshaingaon","Gudivada","Gudur","Guindy","Gujrat","Gulbarga","Guna","Guntur","Gurdaspur","Gurgaon","Guruvayur","Guwahati","Gwalior","Habra","Hadadi","Haldia","Haldwani","Hamirpur","Hansi","Hapur","Hari","Haridwar","Haripad","Haripur","Haryana","Hassan","Haveri","Hazaribagh","Himatnagar","Hinganghat","Hingoli","Hira","Hiriyur","Hisar","Honavar","Hong","Hoshangabad","Hoshiarpur","Hosur","Howrah","Hubli","Hugli","Hyderabad","Ichalkaranji","Idukki","Igatpuri","Iglas","Imphal","Indore","Indraprast","Irinjalakuda","Itanagar","Jabalpur","Jadabpur","Jagdalpur","Jagraon","Jaipur","Jaisalmer","Jajpur","Jalalabad","Jalalpur","Jalandhar","Jalesar","Jalgaon Jamod","Jalna","Jalpaiguri","Jamal","Jammu","Jamnagar","Jamshedpur","Janjgir","Jaspur","Jatani","Jaunpur","Jayanti","Jaynagar","Jaypur","Jha Jha","Jhajjar","Jhalawar","Jhansi","Jhargram","Jharsuguda","Jhunjhunun","Jind","Jodhpur","Jorhat","Junagadh","Kadapa","Kagal","Kailaras","Kaimganj","Kaithal","Kakdwip","Kakinada","Kaladi","Kalam","Kalamboli","Kalan","Kalinga","Kalka","Kalkaji Devi","Kalol","Kalpakkam","Kalpetta","Kalra","Kalyan","Kalyani","Kamalpur","Kamalpura","Kamat","Kanakpura","Kanchipuram","Kanchrapara","Kandi","Kangayam","Kangra","Kanhangad","Kanigiri","Kaniyambadi","Kankauli","Kanniyakumari","Kannur","Kanpur","Kapurthala Town","Karad","Karaikal","Karaikudi","Karamadai","Karamsad","Karanja","Karari","Kargil","Karimganj","Karimnagar","Karjat","Karnal","Karsiyang","Karur","Karwar","Kasal","Kasaragod","Kasganj","Kashipur","Kasia","Kataria","Kathua","Katni","Katoya","Katra","Kaul","Kavali","Kavaratti","Kayamkulam","Keshod","Khajuraho Group of Monuments","Khalapur","Khambhat","Khammam","Khan","Khanna","Kharagpur","Kharar","Khargone","Khatauli","Kheda","Khergam","Kheri","Khinwara","Khopoli","Khurda","Khurja","Kishangarh","Koch Bihar","Kochi","Kodaikanal","Kodungallur","Kohima","Kokrajhar","Kolar","Kolayat","Kolhapur","Kolkata","Kollam","Kollegal","Koni","Konnagar","Koothanallur","Koppal","Koraput","Korba","Kosamba","Kot Isa Khan","Kota","Kotian","Kottagudem","Kottakkal","Kottarakara","Kottayam","Kovilpatti","Kovvur","Kozhikode","Krishnagiri","Kulti","Kumar","Kumbakonam","Kumhari","Kundan","Kunwar","Kuppam","Kurali","Kurnool","Kushalnagar","Kuzhithurai","Ladwa","Lakhimpur","Lala","Lalgudi","Lamba Harisingh","Lanka","Latur","Liluah","Lohaghat","Lucknow","Ludhiana","Machhiwara","Machilipatnam","Madanapalle","Madgaon","Madhoganj","Madikeri","Madurai","Madurantakam","Mahabalipuram","Mahad","Mahajan","Mahal","Maharaj","Mahatma","Mahesana","Mahesh","Mahim","Mahulia","Malappuram","Maldah","Malpur","Manali","Mancherial","Mandal","Mandapeta","Mandi","Mandla","Mandsaur","Mandvi","Mandya","Mangalagiri","Mangalore","Mangaon","Manipala","Manipur","Manjeri","Manna","Mannargudi","Manor","Mansa","Manu","Markal","Markapur","Marmagao","Maru","Mashobra","Matar","Mathan","Mathura","Mattanur","Mavelikara","Mawana","Mayapur","Medak","Medarametla","Medchal","Medinipur","Meerut","Mehra","Mettur","Mhow","Mill","Miraj","Mirza Murad","Mirzapur","Mithapur","Modasa","Moga","Mohala","Mohali","Mohan","Moradabad","Morena","Morinda","Morvi","Motihari","Mount Abu","Muddanuru","Mukerian","Muktsar","Multi","Mumbai","Mundgod","Mundra","Munger","Murshidabad","Mussoorie","Muzaffarnagar","Muzaffarpur","Mylapore","Mysore","Nabadwip","Nabha","Nadgaon","Nadia","Nadiad","Nagal","Nagapattinam","Nagar","Nagara","Nagari","Nagaur","Nagercoil","Nagpur","Nagwa","Naini","Nalagarh","Nalbari","Nalgonda","Namakkal","Namrup","Nanda","Nanded","Nandi","Nandigama","Nandurbar","Nandyal","Naraina","Narasaraopet","Narayangaon","Narela","Narnaul","Narsapur","Nashik","Nathdwara","Navelim","Navsari","Nayagarh","Nazira","Nehra","Nellore","Neral","Neri","New Delhi","Neyveli","Nila","Nilambur","Nilokheri","Nizamabad","Noida","Nongpoh","Nongstoin","North Lakhimpur","Nurpur","Nuzvid","Odhan","Omalur","Ongole","Ooty","Orai","Osmanabad","Ottappalam","Pachmarhi","Padrauna","Pahalgam","Pakala","Pala","Palakkad","Palampur","Palani","Palayam","Palghar","Pali","Palladam","Paloncha","Palus","Palwal","Panchal","Panchgani","Pandharpur","Panipat","Panjim","Panruti","Pantnagar","Panvel","Paonta Sahib","Parappanangadi","Paravur","Parbhani","Parel","Parra","Patan","Patancheru","Patel","Patelguda","Pathanamthitta","Pathankot","Patiala","Patna","Pattambi","Pattukkottai","Pauri","Payyanur","Peddapuram","Pehowa","Perambalur","Peranampattu","Perundurai","Petlad","Phagwara","Phaphamau","Piduguralla","Pilani","Pileru","Pilkhuwa","Pimpri","Pitampura","Pithapuram","Pithoragarh","Pochampalli","Pollachi","Ponda","Ponnani","Ponneri","Porbandar","Port Blair","Potti","Powai","Proddatur","Puducherry","Pudukkottai","Puliyur","Punalur","Pune","Puras","Puri","Purnea","Puruliya","Pusa","Pushkar","Puttur","Quepem","Raichur","Raigarh","Raipur","Rajahmundry","Rajapalaiyam","Rajapur","Rajkot","Rajpur","Rajpura","Raju","Rama","Ramanagaram","Ramanathapuram","Ramapuram","Ramavaram","Ramgarh","Ramnagar","Rampur","Rana","Ranaghat","Ranchi","Rander","Raniganj","Ranippettai","Ranjan","Ratlam","Ratnagiri","Raurkela","Rawal","Raxaul","Rayagada","Rewa","Rewari","Ring","Rishikesh","Rohtak","Roorkee","Roshan","Rudrapur","Rupnagar","Rupnarayanpur","Sachin","Sagar","Saha","Saharanpur","Sahibabad","Sakri","Salem","Saligao","Salt Lake City","Samastipur","Sambalpur","Sanand","Sandur","Sangam","Sangamner","Sangli","Sangola","Sangrur","Sanquelim","Saranga","Sarangi","Sarwar","Satara","Satna","Sattur","Sawi","Secunderabad","Sehore","Sendhwa","Serampore","Shadnagar","Shahabad","Shahapur","Shahdara","Shahdol","Shahjahanpur","Shahkot","Shamsabad","Shanti Grama","Shillong","Shimla","Shimoga","Shirgaon","Shiv","Sholavandan","Shoranur","Shrigonda","Shyamnagar","Sibsagar","Sidhi","Sidhpur","Sikar","Sikka","Silchar","Siliguri","Silvassa","Singarayakonda","Singtam","Sinnar","Sion","Sirhind","Sirkazhi","Sirohi","Sirsa","Sirsi","Siruguppa","Siruseri","Sirwani","Sitapur","Siuri","Sivaganga","Sivakasi","Sodhi","Sojat","Solan","Solapur","Solim","Somnath","Soni","Sonipat","Sopara","Srikakulam","Srikalahasti","Srinagar","Sriperumbudur","Srirangam","Srivilliputhur","Sukma","Sultan","Sultanpur","Sultans Battery","Suman","Sunam","Sundargarh","Surana","Suratgarh","Surendranagar","Suriapet","Tadepallegudem","Tala","Talcher","Talegaon Dabhade","Talwandi Sabo","Tambaram","Tanda","Tanuku","Tarn Taran","Teri","Tezpur","Thalassery","Thane","Thanjavur","Thasra","Thenali","Thenkasi","Thirumangalam","Thiruthani","Thiruvananthapuram","Thiruvarur","Thoothukudi","Thrissur","Tikamgarh","Tindivanam","Tinsukia","Tiptur","Tiruchchendur","Tiruchi","Tirumala","Tirumala - Tirupati","Tirunelveli","Tiruppur","Tirur","Tiruvalla","Tiruvallur","Tiruvannamalai","Tohana","Tonk","Trimbak","Tuljapur","Turaiyur","Udaigiri","Udaipur","Udupi","Ujjain","Ulhasnagar","Ulubari","Umred","Unnao","Uppal","Uttarkashi","Vadamadurai","Vadner","Vadodara","Vaikam","Vainguinim","Valsad","Vandalur","Vandavasi","Vaniyambadi","Vapi","Varanasi","Vasai","Vasco","Vashi","Vazhakulam","Vellore","Verna","Vidisha","Vijapur","Vijayawada","Vikarabad","Vikasnagar","Villupuram","Vinukonda","Virar","Visakhapatnam","Visnagar","Vizianagaram","Wai","Warangal","Wardha","Wellington","Yadgir","Yamunanagar","Yanam","Yavatmal","Yeola","Yercaud"]},"IO":{"id":"IO","name":"British Indian Ocean Territory","timezones":["Indian/Chagos"],"cities":[]},"IQ":{"id":"IQ","name":"Iraq","timezones":["Asia/Baghdad"],"cities":["Al `Amarah","Al Hillah","Baghdad","Bahr","Basere","Basra","Erbil","Haji Hasan","Hayat","Karkh","Kirkuk","Manawi","Mosul","Najaf","Sulaymaniyah","Tikrit"]},"IR":{"id":"IR","name":"Iran","timezones":["Asia/Tehran"],"cities":["`Aliabad","`Aliabad-e Aq Hesar","`Oryan","Abadan","Abol","Ahvaz","Amlash","Amol","Arak","Ardabil","Ardakan","Arnan","Arsanjan","Asadabad","Ashan","Ashna","Ashtian","Astara","Azad","Azadi","Azaran","Babol","Badr","Baft","Baghin","Baharan","Bakhtiari","Bakhtiaruyeh","Baladeh","Banak","Band","Bandar-e Khamir","Bandar-e Mahshahr","Barbun","Bardsir","Baseri Hadi","Bastak","Behbahan","Behdasht","Behjan","Behshahr","Bidak","Birizg","Birjand","Bonab","Borran-e Bala","Bostan","Bukan","Chabahar","Chah Deraz","Chapar","Dadeh","Damavand","Damghan","Darmian","Dezful","Dorud","Emam","Esfarayen","Eslamshahr","Estahban","Evin","Falavarjan","Fardis","Farsi","Fasa","Fordu","Garmsar","Gazan-e Bala","Gerash","Germi","Gharbi","Gilan-e Gharb","Gilas","Golestan","Golpayegan","Golriz","Gorgan","Gostar","Hadishahr","Hamadan","Hasanabad-e Qadamgah","Hashtgerd","Hashtpar","Hirad","Homa","Hormozabad","Hush","Idah","Ilam","Iranshahr","Isfahan","Jadir","Jahan","Jahan Nama","Jahrom","Jiroft","Julfa","Kabir","Kaman","Karaj","Karimkhan","Kashan","Kelarabad","Kerman","Kermanshah","Khalkhal","Khameneh","Khash","Khomeyn","Khomeyni Shahr","Khong","Khorasan","Khowrasgan","Khowrshid","Khvajeh","Khvoy","Kian","Kish","Kord Kandi","Kordestan-e `Olya","Kordovan-e Sofla","Lahijan","Lamerd","Mahabad","Mahallat","Mahestan","Malayer","Malek Talesh","Malekan","Mamasani","Manjil","Maragheh","Marand","Mashhad","Mehin","Mehregan","Meshgin Shahr","Meybod","Miandoab","Mianej","Mobarakeh","Moghan","Mohr","Nahavand","Najafabad","Naji","Nasir","Negar","Nehbandan","Neka","Neyriz","Neyshabur","Novin","Onar","Parpis","Parsian","Pasargad","Payam","Peshgoman","Peyk","Piruz","Post","Qasr od Dasht","Qazvin","Qeshm","Quchan","Rabor","Rafsanjan","Rasak","Rasht","Ravand","Ravansar","Ravar","Rayen","Razan","Razaviyeh","Razi","Rigan","Sabz","Sabzevar","Sahand","Salmas","Saman","Samen","Sanandaj","Saravan","Sari","Saveh","Semirom","Semnan","Sena","Servan","Shadman","Shahid","Shahid Chamran","Shahid Madani","Shahr","Shahrak","Shahrak-e Direh","Shahrak-e Milad","Shahrak-e Pars","Shahreza","Shahriar","Shahrud","Sharif","Shazand","Shiraz","Shirvan","Siahkal","Sirjan","Sistan-e `Olya","Soltanabad","Tabriz","Taha","Takestan","Tiran","Tonekabon","Torkan","Urmia","Vaj","Valilu","Vandar","Varamin","Wahna","Yasuj","Yazd","Zabol","Zahedan","Zahra","Zangiabad","Zanjan","Zarand"]},"IS":{"id":"IS","name":"Iceland","timezones":["Atlantic/Reykjavik"],"cities":["Akranes","Akureyri","Borgarnes","Dalvik","Grindavik","Hella","Holmavik","Husavik","Hvammstangi","Hveragerdi","Hvolsvollur","Kopavogur","Reykjavik","Selfoss","Skagastrond","Stokkseyri","Vestmannaeyjar","Vogar"]},"IT":{"id":"IT","name":"Italy","timezones":["Europe/Rome"],"cities":["Abano Terme","Abbadia Lariana","Abbadia San Salvatore","Abbasanta","Abbiategrasso","Abetone","Acate","Acerno","Acerra","Aci Castello","Aci Catena","Acireale","Acquafredda","Acquafredda Inferiore","Acquapendente","Acquappesa","Acquaro","Acquasparta","Acquaviva","Acquaviva delle Fonti","Acquaviva Picena","Acqui Terme","Acri","Adelfia","Adrano","Adria","Adro","Affi","Afragola","Africo Nuovo","Agazzano","Agerola","Agira","Agliana","Agliano","Aglientu","Agna","Agnadello","Agnone","Agordo","Agrano","Agrate Brianza","Agrigento","Agro","Agropoli","Agugliano","Agugliaro","Ai Palazzi","Aiello","Aiello del Sabato","Ailano","Ailoche","Airasca","Airola","Airole","Airuno","Ala","Ala di Stura","Alanno","Alassio","Alatri","Alba","Albanella","Albano di Lucania","Albano Laziale","Albano Vercellese","Albaredo","Albareto","Albenga","Albergo","Alberobello","Alberoni","Albettone","Albiate","Albignasego","Albina","Albinea","Albino","Albissola Marina","Albizzate","Albuzzano","Alcamo","Alcara li Fusi","Aldeno","Ales","Alessandria","Alessandria della Rocca","Alessano","Alezio","Alfonsine","Alghero","Algund","Alice Castello","Alife","Alimena","Alleghe","Allerona","Alliste","Allumiere","Almenno San Bartolomeo","Almese","Alpette","Alpignano","Altamura","Altare","Altavilla","Altavilla Irpina","Altavilla Milicia","Altavilla Silentina","Altavilla Vicentina","Altedo","Altessano","Altidona","Altino","Altofonte","Altomonte","Altopascio","Alviano","Alvignanello","Alvignano","Alvito","Alzano Lombardo","Amalfi","Amandola","Amantea","Amaro","Amato","Ambra","Ambrogio","Ameglia","Amelia","Ameno","Amorosi","Ampezzo","Anacapri","Anagni","Ancarano","Ancona","Andezeno","Andorno Micca","Andrano","Andria","Anfo","Angera","Anghiari","Angolo Terme","Angri","Anguillara","Anguillara Veneta","Anna","Annicco","Annone Veneto","Antea","Antella","Anterselva di Mezzo","Antico di Maiolo","Antignano","Antonimina","Antrodoco","Anzano del Parco","Anzio","Aosta","Apice","Apiro","Appiano Gentile","Appiano sulla strada del vino","Appignano","Appignano del Tronto","Apricena","Aprilia","Aquileia","Aquilonia","Aquino","Arabba","Aradeo","Aragona","Arborea","Arborio","Arbus","Arcade","Arce","Arcene","Arcevia","Arcidosso","Arco","Arcola","Arcole","Arconate","Arcore","Arcugnano","Ardea","Ardesio","Arenzano","Arese","Arezzo","Argelato","Argenta","Ariano Ferrarese","Ariano Irpino","Ariano nel Polesine","Ariccia","Arielli","Arienzo","Arignano","Arizzano","Arluno","Armeno","Armento","Arnesano","Arona","Arosio","Arpaia","Arpino","Arqua Polesine","Arquata Scrivia","Arre","Arrone","Arsago Seprio","Arsita","Arta Terme","Artena","Artogne","Arzachena","Arzano","Arzene","Arzignano","Asciano","Ascoli Piceno","Ascoli Satriano","Asiago","Asola","Asolo","Assemini","Assisi","Asso","Assoro","Asti","Atella","Atena Lucana","Atessa","Atina","Atri","Atripalda","Attigliano","Attimis","Atzara","Augusta","Auletta","Aulla","Aurelia","Auronzo di Cadore","Avella","Avellino","Aversa","Avezzano","Aviano","Avigliana","Avigliano","Avigliano Umbro","Avio","Avola","Azeglio","Azzano","Azzano Decimo","Azzano San Paolo","Azzate","Bacoli","Badia","Badia Calavena","Badia Polesine","Badolato","Bagheria","Baglio Rizzo","Bagnacavallo","Bagnara","Bagnara Calabra","Bagnara di Romagna","Bagnasco","Bagni","Bagni di Lucca","Bagno a Ripoli","Bagno di Romagna","Bagnoli del Trigno","Bagnoli di Sopra","Bagnoli Irpino","Bagnolo","Bagnolo Cremasco","Bagnolo in Piano","Bagnolo Mella","Bagnolo Piemonte","Bagnolo San Vito","Baia","Baiano","Baiso","Balangero","Baldissero Torinese","Balestrate-Foce","Ballabio","Baluello","Balvano","Balzola","Baragiano","Baranzate","Baratte","Barbarano Vicentino","Barbarasco","Barberino di Mugello","Barbiano","Bardolino","Bardonecchia","Bareggio","Barga","Bargagli","Barge","Bari","Bari Sardo","Baricella","Barile","Barisciano","Barlassina","Barletta","Barni","Baronissi","Barra","Barrafranca","Barrali","Baruchella","Barumini","Barzana","Basaldella","Baschi","Basciano","Baselice","Basiliano","Basilicanova","Bassano Bresciano","Bassano del Grappa","Bassano in Teverina","Bassano Romano","Bastia umbra","Bastiglia","Battaglia Terme","Battipaglia","Baunei","Baveno","Bazzano","Bedollo","Begliano","Beinasco","Beinette","Belfiore","Belforte","Belgioioso","Bella","Bellagio","Bellano","Bellante","Bellaria-Igea Marina","Bellariva","Bellinzago Novarese","Bellocchi","Bellona","Belluno","Belmonte Mezzagno","Belmonte Piceno","Belpasso","Belsito","Belvedere","Belvedere di Spinello","Belvedere Marittimo","Belvedere Ostrense","Benestare","Benetutti","Benevello","Benevento","Benna","Bentivoglio","Berbenno di Valtellina","Berceto","Bergamo","Berlingo","Bernalda","Bernate Ticino","Bertinoro","Bertonico","Berzo Demo","Besana in Brianza","Besano","Besnate","Besozzo","Bettola","Bettolle","Bettona","Beura-Cardezza","Bevilacqua","Biancade","Biancano","Biancavilla","Bianco","Bianconese","Biandronno","Bianzone","Biassono","Bibbiano","Bibbiena","Bibbona","Bibione","Biella","Bienno","Bientina","Binanuova","Binasco","Bisaccia","Bisacquino","Bisceglie","Bitetto","Bitonto","Bitritto","Bitti","Bivongi","Blera","Boara","Bobbio","Boccheggiano","Bocchignano","Boffalora sopra Ticino","Bogliasco","Bojano","Bolano","Bollate","Bollengo","Bologna","Bolzano","Bolzano Vicentino","Bompietro","Bomporto","Bonarcado","Bonassola","Bonavicina","Bondeno","Bonea","Bonorva","Bordighera","Boretto","Borgaro Torinese","Borgetto","Borghetto","Borghetto di Vara","Borghetto Santo Spirito","Borgia","Borgo","Borgo a Mozzano","Borgo di Terzo","Borgo Priolo","Borgo Sabotino-Foce Verde","Borgo San Dalmazzo","Borgo San Giacomo","Borgo San Lorenzo","Borgo Ticino","Borgo Tossignano","Borgo Val di Taro","Borgo Vercelli","Borgomanero","Borgone","Borgonovo","Borgonovo Val Tidone","Borgoricco","Borgorose","Borgosatollo","Borgosesia","Bornasco","Borno","Borrello","Borzonasca","Bosa","Boschetto","Bosco","Bosco Chiesanuova","Bosconero","Boscoreale","Boscotrecase","Bosisio Parini","Bossolasco","Bottanuco","Bova Marina","Bovalino","Bovegno","Boves","Bovezzo","Boville Ernica","Bovino","Bovisio-Masciago","Bovolenta","Bovolone","Bozzolo","Bra","Braccagni","Bracciano","Bracigliano","Brancaleone","Brandizzo","Braone","Brebbia","Breda di Piave","Breganze","Breguzzo","Brembate","Brembilla","Brendola","Brenner","Breno","Brescello","Brescia","Bressana Bottarone","Bressanvido","Bresso","Briatico","Bricherasio","Briga Novarese","Brignano","Brindisi","Brissago-Valtravaglia","Brivio","Brixen","Brolo","Broni","Bronte","Bronzolo","Brossasco","Brosso","Brugherio","Brugine","Brugnera","Bruino","Brunate","Bruneck","Brunella","Bruno","Brusciano","Brusnengo","Bubbio","Bucchianico","Bucciano","Buccino","Bucine","Budrio","Buggiano","Buia","Buonabitacolo","Burano","Buriasco","Burolo","Buronzo","Busalla","Busca","Buscate","Buscoldo","Busseto","Bussi sul Tirino","Bussolengo","Bussoleno","Busto Arsizio","Busto Garolfo","Butera","Buti","Buttapietra","Buttigliera Alta","Buttrio","Cabras","Caccamo","Caccuri","Cadelbosco di Sopra","Cadeo","Cadoneghe","Caerano di San Marco","Caggiano","Cagli","Cagliari","Cagnano Varano","Caianello","Caiatia","Cairate","Cairo Montenotte","Caivano","Calalzo di Cadore","Calamandrana","Calangianus","Calascibetta","Calatabiano","Calatafimi","Calcara","Calcata","Calci","Calcinaia","Calcinate","Calcinato","Calcinelli","Calcio","Caldaro sulla Strada del Vino","Caldarola","Calderara di Reno","Caldogno","Caldonazzo","Calendasco","Calenzano","Calice al Cornoviglio","Calimera","Calitri","Calizzano","Calliano","Calolziocorte","Caltagirone","Caltanissetta","Caltavuturo","Caluso","Calvanico","Calvatone","Calvenzano","Calvisano","Calvizzano","Camaiore","Cambiago","Cambiano","Camburzano","Camerano","Camerata Picena","Cameri","Cameriano","Camerino","Camerlona","Caminetto","Camino","Camisa","Camisano","Camisano Vicentino","Camogli","Campagna","Campagnano di Roma","Campagnola","Campagnola Emilia","Camparada","Campegine","Campertogno","Campi","Campi Bisenzio","Campi Salentina","Campiglia Marittima","Campiglio","Campione","Campli","Campo","Campo Ligure","Campo San Martino","Campo Tizzoro","Campobasso","Campobello di Licata","Campobello di Mazara","Campodarsego","Campodenno","Campodimele","Campodipietra","Campodoro","Campofelice di Roccella","Campofilone","Campoformido","Campofranco","Campogalliano","Campoleone","Campoli Appennino","Campolieto","Campolongo Maggiore","Campomarino","Campomorone","Camponogara","Campora","Camporeale","Camporosso","Camposampiero","Camposano","Canale","Canaro","Canazei","Cancello","Cancello ed Arnone","Candelo","Candia Canavese","Candia Lomellina","Candiana","Candiolo","Canegrate","Canelli","Canicattini Bagni","Canino","Canistro","Cannara","Cannella","Cannero Riviera","Canneto Pavese","Cannobio","Canonica","Canosa di Puglia","Canosa Sannita","Canossa","Cantagallo","Cantalice","Cantalupo in Sabina","Cantalupo Ligure","Cantarana","Cantu","Canzo","Caorle","Caorso","Capaccio","Capaci","Capalbio","Capannelle","Capannoli","Capannori","Capena","Capergnanica","Capistrano","Capistrello","Capitignano","Capo Rizzuto","Capodimonte","Capodrise","Capoliveri","Capoterra","Cappella Maggiore","Cappelle sul Tavo","Capralba","Capranica","Caprese Michelangelo","Capri","Capriate San Gervasio","Caprie","Caprino Bergamasco","Caprino Veronese","Capriolo","Capriva del Friuli","Capua","Capurso","Caraglio","Carapelle","Carasco","Carate Brianza","Caravaggio","Caravate","Caravino","Caravonica","Carbonara al Ticino","Carbonara di Bari","Carbonara di Po","Carbonera","Carbonia","Carcare","Carcereri","Carceri","Cardano","Cardito","Carema","Carenno","Carentino","Caresana","Cariati","Carignano","Carini","Carinola","Carlazzo","Carlentini","Carlino","Carloforte","Carmagnola","Carmiano","Carmignano","Carmignano di Brenta","Carnago","Carnate","Carobbio","Carolei","Caronia","Carosino","Carovigno","Carpaneto Piacentino","Carpegna","Carpenedolo","Carpeneto","Carpi","Carpiano","Carpignano Sesia","Carpinello","Carpineti","Carpineto Romano","Carrara","Carsoli","Cartoceto","Cartura","Carugate","Carvico","Casa Bartolacelli-Stella","Casa Gherardi","Casa Pace","Casa Paradiso","Casa Zola","Casacalenda","Casacanditella","Casaccia II","Casaglia","Casal di Principe","Casal Velino","Casalbordino","Casalborgone","Casalbuttano ed Uniti","Casale","Casale Corte Cerro","Casale di Mezzani","Casale di Scodosia","Casale Monferrato","Casale sul Sile","Casalecchio di Reno","Casaleggio Novara","Casaletto Spartano","Casalgrande","Casalgrasso","Casali","Casalmaggiore","Casalmaiocco","Casalmorano","Casalnuovo di Napoli","Casaloldo","Casalpusterlengo","Casalromano","Casalserugo","Casaluce","Casalvecchio Siculo","Casalvieri","Casalvolone","Casalzuigno","Casamarciano","Casamassima","Casandrino","Casanova","Casapulla","Casarano","Casaratta","Casargo","Casarile","Casarsa della Delizia","Casate Raffa","Casateia","Casatenovo","Casavecchia","Casazza","Cascia","Casciana Terme","Cascina","Cascine Maggio","Case","Case Catania","Case Franchini","Casei Gerola","Caselette","Caselle","Caselle Lurani","Caselle Torinese","Caserta","Casier","Casignana","Casina","Casinalbo","Casnigo","Casola di Napoli","Casoli","Casorate Primo","Casorate Sempione","Casorezzo","Casoria","Casperia","Caspoggio","Cassacco","Cassano","Cassano delle Murge","Cassano Spinola","Cassine Superiore","Cassino","Cassolnovo","Castagnaro","Castagneto Carducci","Castagneto Po","Castagnole","Castano Primo","Casteggio","Castegnato","Castel","Castel Bolognese","Castel Colonna","Castel del Piano","Castel di Casio","Castel di Judica","Castel Focognano","Castel Frentano","Castel Gabbiano","Castel Gandolfo","Castel Giorgio","Castel Goffredo","Castel Guelfo di Bologna","Castel Madama","Castel Maggiore","Castel Mella","Castel San Giovanni","Castel San Lorenzo","Castel San Pietro Romano","Castel San Pietro Terme","Castel Viscardo","Castel Volturno","Castelbellino","Castelbuono","Castelcucco","Casteldaccia","Castelfidardo","Castelfiorentino","Castelfranci","Castelfranco di Sopra","Castelfranco di Sotto","Castelfranco Emilia","Castelfranco Veneto","Castelgomberto","Castelgrande","Castellabate","Castellalto","Castellammare del Golfo","Castellammare di Stabia","Castellamonte","Castellana Grotte","Castellana Sicula","Castellaneta","Castellanza","Castellar Guidobono","Castellarano","Castellaro","Castellazzo Bormida","Castellengo","Castelleone","Castelletto","Castelletto sopra Ticino","Castelli","Castelli Calepio","Castellina in Chianti","Castellina Marittima","Castelliri","Castello","Castello di Annone","Castello di Godego","Castello di Serravalle","Castellucchio","Castelluccio Inferiore","Castelmassa","Castelnovo di Sotto","Castelnuovo","Castelnuovo Berardenga","Castelnuovo dei Sabbioni","Castelnuovo della Daunia","Castelnuovo di Garfagnana","Castelnuovo di Porto","Castelnuovo di Val di Cecina","Castelnuovo di Verona","Castelnuovo Don Bosco","Castelnuovo Magra","Castelnuovo Nigra","Castelnuovo Rangone","Castelnuovo Scrivia","Castelpagano","Castelplanio","Castelpoto","Castelraimondo","Castelseprio","Casteltermini","Castelvecchio","Castelvecchio Pascoli","Castelvenere","Castelverde","Castelvetrano","Castelvetro di Modena","Castenaso","Castenedolo","Castiadas","Castiglion Fibocchi","Castiglion Fiorentino","Castiglione","Castiglione Chiavarese","Castiglione Cosentino","Castiglione dei Pepoli","Castiglione del Lago","Castiglione della Pescaia","Castiglione delle Stiviere","Castiglione di Cervia","Castiglione di Garfagnana","Castiglione di Sicilia","Castiglione Messer Raimondo","Castiglione Olona","Castignano","Castilenti","Castione della Presolana","Castions di Strada","Casto","Castorano","Castri di Lecce","Castrignano del Capo","Castro dei Volsci","Castrocaro Terme","Castrofilippo","Castrolibero","Castronno","Castroreale","Castrovillari","Catania","Catanzaro","Catenanuova","Catignano","Cattolica","Cattolica Eraclea","Caulonia","Cava Manara","Cavacurta","Cavagnolo","Cavaion Veronese","Cavalese","Cavallermaggiore","Cavallino","Cavallirio","Cavareno","Cavaria con Premezzo","Cavarzere","Cave","Cavenago di Brianza","Cavezzo","Cavour","Cavriago","Cavriana","Cavriglia","Cazzago San Martino","Ceccano","Cecchini","Cecina","Cedessano","Cedrasco","Ceggia","Ceglie Messapica","Celano","Celenza Valfortore","Celico","Cellamare","Celle Ligure","Cellino Attanasio","Cellino San Marco","Cellio","Cellole","Cembra","Cenaia","Cencenighe Agordino","Cene","Cengio","Centallo","Cento","Centola","Centrale","Centuripe","Cepagatti","Ceppaloni","Ceprano","Cerano","Cerasolo","Cercepiccola","Cercola","Cerea","Ceregnano","Ceres","Ceresara","Cerete","Ceriale","Ceriano Laghetto","Cerignola","Cermenate","Cernobbio","Cernusco sul Naviglio","Cerredolo","Cerreto Guidi","Cerreto Laziale","Cerreto Sannita","Cerrione","Cerro Maggiore","Certaldo","Certosa","Certosa di Pavia","Cervaro","Cerveno","Cervere","Cerveteri","Cervia","Cervignano del Friuli","Cervino","Cervo","Cesa","Cesana Torinese","Cesano Maderno","Cesara","Cese","Cesena","Cesenatico","Cesiomaggiore","Ceto","Cetraro","Ceva","Chambave","Champdepraz","Charvensod","Cherasco","Chiampo","Chianciano Terme","Chiara","Chiaramonte Gulfi","Chiarano","Chiaravalle","Chiaravalle Centrale","Chiari","Chiavari","Chiavazza","Chiavenna","Chieri","Chiesina Uzzanese","Chieti","Chioggia","Chiomonte","Chions","Chitignano","Chiusanico","Chiusano di San Domenico","Chiusavecchia","Chiusi","Chiusi della Verna","Chivasso","Cicagna","Cicciano","Ciciliano","Cicognolo","Cigliano","Cignone","Cilavegna","Cimadolmo","Cimego","Ciminna","Cimitile","Cinecitta","Cingoli","Cinisello Balsamo","Cinisi","Cinquefrondi","Cintano","Cinto Caomaggiore","Circello","Cirimido","Cisano Bergamasco","Cisano sul Neva","Ciserano","Cislago","Cisliano","Cison di Valmarino","Cisterna di Latina","Cisternino","Cittadella","Cittaducale","Cittanova","Cittiglio","Civezzano","Cividale del Friuli","Cividate Camuno","Civita Castellana","Civitanova Alta","Civitanova Marche","Civitavecchia","Civitella del Tronto","Civitella di Romagna","Civitella in Val di Chiana","Civitella Marittima","Civitella Roveto","Civitella San Paolo","Cizzago-Comezzano","Cles","Clusone","Coccaglio","Cocconato","Cocquio-Trevisago","Codaruina","Codevigo","Codigoro","Codogno","Codroipo","Codrongianos","Coggiola","Cogne","Cogoleto","Cogorno","Cola","Colbordolo","Colere","Colico","Collalto","Collazzone","Colle","Colle Umberto","Collecchio","Collecorvino","Colledara","Colledimezzo","Colleferro","Collefontana-Fontana Liri Inferiore","Collegno","Collelungo","Collepasso","Collesano","Colli del Tronto","Colliano","Collinas","Colloredo di Prato","Colmurano","Cologna","Cologna Veneta","Cologne","Cologno al Serio","Cologno Monzese","Colombaro","Colonna","Colonnella","Colorno","Coltura","Comacchio","Comano","Comazzo","Comerio","Comiso","Como","Compiano","Comun Nuovo","Cona","Conco","Concordia Sagittaria","Concordia sulla Secchia","Concorezzo","Condofuri","Condove","Conegliano","Confienza","Conselice","Conselve","Contigliano","Contrada","Controguerra","Contursi Terme","Conversano","Copertino","Copiano","Copparo","Coppe","Coppito","Corato","Corbetta","Corbola","Corchiano","Corciano","Cordenons","Cordignano","Cordovado","Corea Castelluccia San Paolo","Coredo","Corfinio","Cori","Coriano","Corigliano Calabro","Corinaldo","Corio","Corleone","Corleto Perticara","Cormons","Cornaiano","Cornaredo","Cornedo Vicentino","Corno","Corno di Rosazzo","Corno Giovine","Cornuda","Corona","Correggio","Correzzola","Corridonia","Corropoli","Corsano","Corsico","Cortandone","Corte","Corte Franca","Cortemaggiore","Cortenova","Corteolona","Corti","Cortina","Cortona","Corvara","Corzano","Coseano","Cosenza","Cossato","Costa","Costa di Rovigo","Costa Volpino","Costabissara","Costarainera","Costermano","Cotignola","Cotronei","Courmayeur","Covo","Cozzo","Creazzo","Crema","Cremolino","Cremona","Crescentino","Crespano del Grappa","Crespellano","Crespiatica","Crespina","Crespino","Cressa","Crevacuore","Crevalcore","Crispiano","Croce","Crocetta del Montello","Crodo","Cropani","Crosia","Crotone","Cuceglio","Cuggiono","Cuglieri","Cugnoli","Cumiana","Cumignano sul Naviglio","Cuneo","Cunico","Cupello","Cupra Marittima","Cupramontana","Curcuris","Curinga","Curno","Curtarolo","Cusano Milanino","Cusano Mutri","Cusino","Custonaci","Cutrofiano","Dairago","Dalmine","Darfo","Davoli","Decima","Decollatura","Deggiano","Dego","Deiva Marina","Delia","Delianuova","Dello","Demonte","Deruta","Dervio","Desenzano del Garda","Desio","Deutschnofen","Diamante","Diano Marina","Diano San Pietro","Dicomano","Diecimo","Dignano","Dimaro","Dipignano","Dogliani","Dolceacqua","Dolianova","Dolo","Domanico","Domaso","Domegliara","Domodossola","Domusnovas","Dongo","Doria","Dorno","Dosolo","Dossobuono","Dosson","Dovadola","Dozza","Drapia","Dro","Dronero","Druento","Druogno","Dubino","Dueville","Dugenta","Duino-Aurisina","Eboli","Edolo","Elmas","Empoli","Endine Gaiano","Enemonzo-Quinis","Enna","Envie","Eraclea","Erba","Erchie","Ercolano","Erice","Erve","Escalaplano","Escolca","Esine","Esino Lario","Esperia","Este","Etroubles","Fabbri","Fabbrica","Fabbrico","Fabriano","Fabrica di Roma","Faedis","Faenza","Fagagna","Faggiano","Fagnano Olona","Faiano","Falciano","Falconara","Falconara Albanese","Falconara Marittima","Falcone","Falerna","Falerone","Falze-Signoressa","Fanano","Fanna","Fano","Fantina","Fara Filiorum Petri","Fara in Sabina","Fara Novarese","Farnese","Farra di Soligo","Fasano","Fastello","Fauglia","Favara","Favaro Veneto","Favria","Feldthurns","Felegara","Feletto","Feletto Umberto","Felino","Felitto","Feltre","Fenile","Ferentino","Fermignano","Fermo","Ferno","Feroleto della Chiesa","Ferrandina","Ferrara","Ferrari","Ferrazzano","Ferrero","Ferriere","Fiano","Fiano Romano","Ficarazzi","Ficarolo","Ficarra","Ficulle","Fidenza","Field","Fiera","Fiesole","Fiesso Umbertiano","Figino","Figline Valdarno","Filadelfia","Filettino","Filetto","Filiano","Filighera","Filo","Filottrano","Finale Emilia","Finale Ligure","Fino Mornasco","Fiorano Modenese","Fiore","Fisciano","Fiuggi","Fiume Veneto","Fiumefreddo di Sicilia","Fiumicello","Fiumicino","Flaibano","Flero","Florence","Floridia","Fluminimaggiore","Flussio","Foggia","Foglianise","Fogliano Redipuglia","Foglizzo","Foiano della Chiana","Foiano di Val Fortore","Folgaria","Folignano","Foligno","Follina","Follonica","Fombio","Fondi","Fonni","Fontana","Fontana Liri","Fontanafredda","Fontanarosa","Fontanelice","Fontanella","Fontanellato","Fontanelle","Fontaniva","Fontevivo","Fonzaso","Forano","Forenza","Foresto","Forino","Forio","Forlimpopoli","Formello","Formia","Formicola","Formigine","Fornace di Miramare","Fornaci","Fornaci di Barga","Forno","Forno Alpi Graie","Forno Canavese","Fornovo di Taro","Forte dei Marmi","Fortunago","Fosco","Fosdinovo","Fossa","Fossacesia","Fossalta di Piave","Fossalta di Portogruaro","Fossano","Fossato di Vico","Fossombrone","Frabosa Sottana","Fragagnano","Francavilla al Mare","Francavilla di Sicilia","Francavilla Fontana","Francavilla in Sinni","Francenigo","Francofonte","Francolise","Frascaro","Frascati","Frascineto","Frassineto Po","Frasso Telesino","Frattamaggiore","Frattaminore","Frattocchie","Fregene","Frigento","Frisa","Front","Frontone","Frosinone","Frugarolo","Fucecchio","Fumane","Fumone","Furci Siculo","Furore","Fuscaldo","Fusignano","Futani","Gabbiano","Gabbro","Gabicce Mare","Gadoni","Gaeta","Gaggi","Gaggiano","Gaggio Montano","Gagliano del Capo","Gaiarine","Gaiole in Chianti","Gais","Galatina","Galatone","Galbiate","Galdo","Galeata","Gallarate","Gallese","Galliate","Gallicano","Gallicano nel Lazio","Galliera","Galliera Veneta","Gallignano","Gallio","Gallipoli","Gallo","Gambara","Gambellara","Gambettola","Gandino","Gangi","Garbagnate Milanese","Garda","Gardone Riviera","Gardone Val Trompia","Garessio","Gargnano","Garibaldi","Garlasco","Garlate","Garlenda","Garrufo","Gassino Torinese","Gattatico","Gatteo","Gatteo a Mare","Gattinara","Gavardo","Gavi","Gavinana","Gavirate","Gavoi","Gazoldo degli Ippoliti","Gazzada Schianno","Gazzaniga","Gazzo","Gazzo Veronese","Gazzola","Gazzuolo","Gela","Gemona","Genazzano","Genivolta","Genoa","Genzano di Roma","Gera Lario","Gerano","Gerenzago","Gergei","Germagnano","Gessate","Gessopalena","Gesualdo","Ghedi","Ghemme","Ghiffa","Ghilarza","Ghisalba","Giano Vetusto","Giardinello","Giardinetto Vecchio","Giardini","Giardini-Naxos","Giarratana","Giarre","Giaveno","Giavera del Montello","Gibellina","Giffoni Valle Piana","Gignese","Gimigliano","Ginosa","Gioia","Gioia del Colle","Gioia Tauro","Gioiosa Ionica","Gioiosa Marea","Giove","Giovinazzo","Girifalco","Gissi","Giugliano in Campania","Giuliana","Giuliano","Giuliano Teatino","Giulianova","Giungano","Giussago","Giussano","Godiasco","Godo","Goito","Golasecca","Golfo Aranci","Gonars","Gonnesa","Gonnosfanadiga","Gonnostramatza","Gonzaga","Gordona","Gorgo al Monticano","Gorgonzola","Gorizia","Gorla Maggiore","Gorle","Gorno","Gossolengo","Gottolengo","Gozzano","Gradara","Grado","Gradoli","Graglia","Gragnano","Gragnano Trebbiense","Grammichele","Grandate","Granitola Torretta","Grantorto","Grassano","Gravedona","Gravellona Toce","Gravina in Puglia","Grazzanise","Grazzano Badoglio","Greci","Gressoney-Saint-Jean","Greve in Chianti","Grezzana","Grignasco","Grigno","Grimaldi","Grisignano di Zocco","Gropello Cairoli","Grosio","Grosseto","Grotta","Grottaferrata","Grottaglie","Grottaminarda","Grottammare","Grottazzolina","Grotte","Grotte di Castro","Grottolella","Gruaro","Grugliasco","Grumello Cremonese","Grumello del Monte","Grumento Nova","Grumo Appula","Grumo Nevano","Grumolo delle Abbadesse","Guagnano","Gualdo Cattaneo","Gualdo Tadino","Gualtieri","Guamaggiore","Guarda Veneta","Guardamiglio","Guardavalle","Guardia Piemontese","Guardia Sanframondi","Guardiagrele","Guardialfiera","Guarrato","Guasila","Guastalla","Gubbio","Guidizzolo","Guido","Guidonia","Guiglia","Gurro","Guspini","Gussago","Gusti","Iesi","Iglesias","Il Ciocco","Illasi","Imola","Imperia","Impruneta","Induno Olona","Innichen","Inverigo","Inveruno","Inzago","Ischia","Ischia di Castro","Ischitella","Iseo","Isernia","Isili","Isola","Isola del Cantone","Isola del Giglio","Isola del Gran Sasso","Isola del Liri","Isola della Scala","Isola delle Femmine","Isola Dovarese","Isola Vicentina","Isorella","Ispica","Ispra","Issime","Istrana","Itala","Itri","Ittiri","Ivrea","Izano","Jesolo","Jolanda di Savoia","Klausen","La Gala","La Loggia","La Maddalena","La Morra","La Salle","La Salute di Livenza","La Spezia","La Valle Agordina","La Via","La Villa","Labico","Lacchiarella","Lacco Ameno","Ladispoli","Lago","Lagosanto","Laigueglia","Lainate","Laino Borgo","Laives","Lajatico","Lajen","Lake Bolsena","Lallio","Lama Mocogno","Lammari","Lamon","Lampedusa","Lamporecchio","Lana","Lancenigo","Lancenigo-Villorba","Lanciano","Landriano","Langhirano","Lanusei","Lanuvio","Lanzo Torinese","Lapio","Lappato","Larciano","Larderello","Lardirago","Lari","Lariano","Larino","Lasino","Lastra","Lastra a Signa","Laterina","Laterza","Latiano","Latina","Latisana","Latronico","Laureana di Borrello","Lauria","Lauro","Lavagna","Lavello","Lavena Ponte Tresa","Laveno-Mombello","Lavis","Lazise","Lazzaro","Le Castella","Lecce","Lecco","Leffe","Legnago","Legnano","Legnaro","Lendinara","Lenna","Lenno","Leno","Lenola","Lentate sul Seveso","Lentiai","Lentini","Leonessa","Leonforte","Leporano","Lercara Friddi","Lerici","Lerma","Lesa","Lesegno","Lesina","Lessona","Lestizza","Lettomanoppello","Lettopalena","Levane","Levanto","Levata","Leverano","Levico Terme","Lezzeno","Librizzi","Licata","Licciana Nardi","Lido","Lido di Camaiore","Lido di Ostia","Lierna","Lignano Sabbiadoro","Limana","Limatola","Limbiate","Limena","Limite","Limiti di Greccio","Limone Piemonte","Lingotto","Lioni","Lipari","Liscate","Lissone","Liveri","Livigno","Livinallongo del Col di Lana","Livorno","Livorno Ferraris","Lizzanello","Lizzano","Lizzola","Loano","Localita della Chiesa","Locate di Triulzi","Locati","Locorotondo","Locri","Lodi","Lodi Vecchio","Lograto","Loiano","Lomagna","Lomazzo","Lombardore","Lomello","Lonate Ceppino","Lonate Pozzolo","Lonato","Longare","Longarone","Longiano","Longobardi","Lonigo","Loreggia","Loreo","Loreto","Loreto Aprutino","Loria","Loro Ciuffenna","Loro Piceno","Lovere","Lozzo Atestino","Lozzo di Cadore","Luca","Lucca","Lucera","Luciana","Luciano","Lucino","Lucito","Luco dei Marsi","Lucugnano","Lugagnano","Lugnano","Lugnano in Teverina","Lugo","Luino","Lunamatrona","Lungavilla","Lungro","Lurago Marinone","Lurate Caccivio","Lustra","Lutago","Luzzano","Luzzi","Maccagno","Maccarese","Macello","Macerata","Macerata Campania","Macomer","Maddalena di Cazzano","Maddaloni","Maderno","Madignano","Madonna","Madonna di Campiglio","Maerne","Mafalda","Magenta","Maggio","Magione","Magliano","Magliano Alpi","Magliano di Tenna","Magliano in Toscana","Magliano Sabina","Maglie","Magnago","Magno","Magreta","Maierato","Maiolati Spontini","Mairano","Malalbergo","Malcesine","Malcontenta","Maletto","Malgrate","Malnate","Malo","Malonno","Mals","Maltignano","Mammola","Mandas","Mandello del Lario","Manduria","Manerbio","Manfredonia","Maniago","Manocalzati","Manoppello","Manta","Mantova","Mantovana","Manzano","Manziana","Manzoni","Mapello","Maranello","Marano di Napoli","Marano Ticino","Marano Vicentino","Maratea","Marcallo con Casone","Marcaria","Marcellina","Marche","Marciana Marina","Marcianise","Marco","Marcon","Mareno di Piave","Mareo","Maresca","Margarita","Marghera","Margherita di Savoia","Mariae","Mariano","Mariano Comense","Mariglianella","Marigliano","Marignano","Marina","Marina di Andora","Marina di Campo","Marina di Carrara","Marina di Castagneto Carducci","Marina di Cerveteri","Marina di Ginosa","Marina di Gioiosa Ionica","Marina di Ragusa","Marineo","Marini","Marino","Marlia","Marmirolo","Marnate","Marola","Marone","Marostica","Marotta","Marrubiu","Marsala","Marsciano","Marsico Nuovo","Marta","Martano","Martellago","Martignacco","Martignano","Martina Franca","Martinengo","Martiniana Po","Martinsicuro","Martirano","Maruggio","Marzabotto","Marzano","Marzano di Nola","Mas","Masainas","Mascali","Mascalucia","Maser","Masera","Maserada sul Piave","Masi Torello","Maslianico","Mason","Massa","Massa e Cozzile","Massa Fiscaglia","Massa Lombarda","Massa Marittima","Massa Martana","Massafra","Massarosa","Masserano","Massignano","Masullas","Matelica","Matera","Mathi","Matino","Mauro","Mazara del Vallo","Mazzano Romano","Mazzarino","Mazzo di Valtellina","Meana Sardo","Meano","Meda","Mede","Medea","Medesano","Medicina","Medolago","Medole","Medolla","Meduna di Livenza","Mel","Melara","Meldola","Melegnano","Melendugno","Melfi","Melicucco","Melilli","Melissano","Melito di Porto Salvo","Melizzano","Melzo","Menaggio","Mendicino","Menfi","Mentana","Meolo","Meran","Merano","Merate","Mercatino Conca","Mercato","Mercato San Severino","Mercato Saraceno","Mercenasco","Mercogliano","Mereto di Tomba","Mergo","Mergozzo","Mesagne","Mesola","Mesoraca","Messina","Mestre","Mestrino","Meta","Metaponto","Mezzanego","Mezzano","Mezzocorona","Mezzolara","Mezzolombardo","Mezzomerico","Miglianico","Migliarino","Migliaro","Miglionico","Mignanego","Mignano Monte Lungo","Milan","Milanesi","Milano","Milano Marittima","Milazzo","Milena","Militello in Val di Catania","Militello Rosmarino","Millesimo","Milo","Mineo","Minerbe","Minerbio","Minervino di Lecce","Minervino Murge","Minori","Minturno","Mira","Mirabella","Mirabella Eclano","Mirabella Imbaccari","Mirabello","Mirabello Monferrato","Miradolo Terme","Mirandola","Mirano","Miravalle","Misano Adriatico","Misilmeri","Misinto","Missaglia","Misterbianco","Mistretta","Modena","Modica","Modigliana","Modugno","Moena","Moglia","Mogliano","Mogliano Veneto","Mogoro","Moiano","Moimacco","Moio della Civitella","Mojo Alcantara","Mola di Bari","Molazzana","Molfetta","Molinari","Molinella","Molino","Molise","Moliterno","Mombercelli","Momo","Monaco","Monasterace","Monastero","Monasterolo del Castello","Monastir","Moncalieri","Moncalvo","Mondavio","Mondolfo","Mondragone","Moneglia","Monfalcone","Monforte San Giorgio","Monghidoro","Mongrando","Moniga del Garda","Monopoli","Monreale","Monsampietro Morico","Monsampolo del Tronto","Monsano","Monselice","Monserrato","Monsummano Terme","Montafia","Montagnana","Montalbano","Montalbano Jonico","Montalcino","Montaldo","Montale","Montalenghe","Montalto delle Marche","Montalto di Castro","Montalto Dora","Montalto Uffugo","Montanara","Montanaro","Montanaso Lombardo","Montappone","Monte","Monte Castello di Vibio","Monte Compatri","Monte di Malo","Monte di Procida","Monte Giberto","Monte Porzio Catone","Monte Roberto","Monte San Giovanni Campano","Monte San Giusto","Monte San Pietro","Monte San Savino","Monte San Vito","Monte Urano","Monte Vidon Corrado","Montebello","Montebello Vicentino","Montebelluna","Montecalvoli","Montecarlo","Montecarotto","Montecassiano","Montecastrilli","Montecatini Terme","Montecchia di Crosara","Montecchio","Montecchio Emilia","Montecchio Maggiore","Montechiarugolo","Montecorice","Montecorvino Rovella","Montecosaro","Montefalcione","Montefano","Montefiascone","Montefiore Conca","Montefiorino","Monteforte Irpino","Montefortino","Montefranco","Montefredane","Montegaldella","Montegiorgio","Montegranaro","Montegrotto Terme","Monteiasi","Montelabbate","Montelanico","Montelepre","Montelparo","Montelupo Fiorentino","Montemaggiore al Metauro","Montemarano","Montemarciano","Montemassi","Montemiletto","Montemurlo","Montemurro","Montenero di Bisaccia","Montenerodomo","Monteodorisio","Montepaone","Montepiano","Monteprandone","Montepulciano","Montepulciano Stazione","Monterchi","Montereale","Montereale Valcellina","Monterenzio","Monteriggioni","Monteroduni","Monteroni di Lecce","Monterosi","Monterosso al Mare","Monterosso Calabro","Monterotondo","Monterubbiano","Montesano Salentino","Montesano sulla Marcellana","Montesarchio","Montescaglioso","Montescudo","Montese","Montesilvano Colle","Montespertoli","Montevago","Montevarchi","Monteveglio","Monteverde","Monteviale","Monticelli","Monticello","Monticello Conte Otto","Montichiari","Monticiano","Montignoso","Montodine","Montoggio","Montorio al Vomano","Montoro","Montorso Vicentino","Monza","Monzambano","Monzuno","Mora","Morano Calabro","Morbegno","Morciano di Leuca","Morciano di Romagna","Morcone","Mordano","Moretta","Morgano","Morgex","Mori","Moricone","Morlupo","Mornago","Morolo","Morozzo","Morrone","Morrovalle","Mortara","Mortegliano","Morter","Moscufo","Moso","Mossa","Motta di Livenza","Motta San Giovanni","Motta San Guglielmo","Motta Visconti","Mottafollone","Mottalciata","Mottola","Mozzagrogna","Mozzanica","Mozzate","Mozzecane","Muggia","Mugnano","Mugnano del Cardinale","Mulazzano","Murano","Muravera","Murlo","Muro Leccese","Muro Lucano","Muros","Musei","Musile di Piave","Mussomeli","Nanto","Naples","Narbolia","Narcao","Narni","Narni Scalo","Naro","Naturns","Natz-Schabs","Navacchio","Nave","Nazzano","Negrar","Neirone","Neive","Nembro","Nepi","Nereto","Nervesa della Battaglia","Nerviano","Nettuno","Neumarkt","Neviano","Neviano degli Arduini","Nichelino","Nicola","Nicolosi","Nicosia","Nicotera","Niederdorf","Nimis","Niscemi","Nizza di Sicilia","Nizza Monferrato","Noale","Nocciano","Nocelleto","Nocera Inferiore","Nocera Superiore","Nocera Terinese","Noceto","Noci","Nociglia","Nogara","Nogaredo al Torre","Nogarole Rocca","Noicattaro","Nola","Noli","Nonantola","None","Norcia","Norma","Notaresco","Noto","Nova Milanese","Nova Siri","Novafeltria","Novalesa","Novara","Novate Mezzola","Novate Milanese","Nove","Novellara","Novello","Noventa di Piave","Noventa Vicentina","Novi di Modena","Novi Ligure","Novi Velia","Novoli","Numana","Nuoro","Nurachi","Nurallao","Nuraminis","Nurri","Nusco","Nuvolento","Occhieppo Inferiore","Occhieppo Superiore","Occhiobello","Ocre","Oderzo","Offagna","Offanengo","Offida","Offlaga","Oggiono","Oglianico","Olbia","Oleggio","Olevano Romano","Olevano sul Tusciano","Olgiate Comasco","Olgiate Molgora","Olgiate Olona","Olginate","Oliena","Oliva","Oliveri","Oliveto","Oliveto Citra","Oliveto Lario","Olivetta","Olmedo","Omegna","Omignano","Opera","Oppeano","Oppido Lucano","Orani","Oratino","Orbassano","Orbetello","Orciano di Pesaro","Orgiano","Orgosolo","Oria","Origgio","Orio al Serio","Orio Litta","Oriolo Romano","Oristano","Ormea","Ormelle","Ornago","Ornavasso","Orosei","Orotelli","Orsenigo","Orsogna","Orta Nova","Orta San Giulio","Orte","Ortelle","Ortona","Ortonovo","Ortovero","Orvieto","Orzinuovi","Orzivecchi","Osiglia","Osimo","Osnago","Osoppo","Ospedaletti","Ospedaletto","Ospedaletto Euganeo","Ospedaletto-Expopisa","Ospitaletto","Ossago Lodigiano","Ossi","Ossona","Ostiano","Ostiglia","Ostigliano","Ostra","Ostra Vetere","Ostuni","Otranto","Otricoli","Ottaviano","Ottiglio","Oulx","Ovada","Ovaro","Ozegna","Ozieri","Ozzano Monferrato","Ozzero","Pace","Paceco","Pacentro","Pachino","Paciano","Paderno","Paderno Dugnano","Paderno Franciacorta","Paderno Ponchielli","Padua","Padula","Paesana","Paese","Pagani","Paganica","Pagazzano","Paglieta","Pago Veiano","Palagianello","Palagiano","Palagonia","Palaia","Palau","Palazzina","Palazzo","Palazzo Canavese","Palazzolo","Palazzolo Acreide","Palazzolo dello Stella","Palermo","Palestrina","Paliano","Palizzi Marina","Palladio","Pallanza-Intra-Suna","Pallanzeno","Pallerone","Palma Campania","Palma di Montechiaro","Palmanova","Palmariggi","Palmas Arborea","Palmi","Palo del Colle","Palombara Sabina","Palosco","Paluzza","Panaro","Pancalieri","Pandino","Panicale","Pannarano","Pantano","Pantigliate","Panzano","Paola","Parabiago","Parabita","Paratico","Parghelia","Parigi","Parma","Parre","Partanna","Partinico","Paruzzaro","Pasian di Prato","Passarella","Passetto","Passignano sul Trasimeno","Passirano","Passo","Passo Corese","Passo di Treia","Pastene","Pastrengo","Pasturo","Paterno","Paternopoli","Patrica","Patti","Pauli Arbarei","Paulilatino","Paullo","Pavia","Pavia di Udine","Pavona","Pavone Canavese","Pavullo nel Frignano","Peccioli","Pecetto","Pedara","Pedaso","Pedavena","Pedemonte","Pederobba","Peglio","Pegognaga","Pelago","Pellegrini","Pellegrino","Pellegrino Parmense","Pellestrina","Pellezzano","Pennabilli","Penne","Perdasdefogu","Perdaxius","Perdifumo","Perfugas","Pergine Valsugana","Pergola","Perignano","Perinaldo","Pernumia","Pero","Perosa Argentina","Pertengo","Perteole","Pertosa","Perugia","Pesaro","Pescantina","Pescara","Pescarolo ed Uniti","Peschici","Peschiera Borromeo","Peschiera del Garda","Pescia","Pescina","Pescocostanzo","Pessinetto","Pessione","Petacciato","Petilia Policastro","Petriano","Petritoli","Petrosino","Petruro","Pettinengo","Pettoranello del Molise","Pettorazza Grimani","Peveragno","Pezzana","Pezze di Greco","Piacenza","Piadena","Piaggine","Pian Camuno","Pian-Fossal","Piana","Piana degli Albanesi","Piancastagnaio","Piancogno","Piandimeleto","Piane Crati","Pianella","Pianello Val Tidone","Pianezza","Pianezze","Piangipane","Pianiga","Piano","Piano di Coreglia-Ghivizzano","Piano di Sorrento","Piano-Vetrale","Pianoro","Piasco","Piateda","Piavon","Piazza","Piazza al Serchio","Piazza Armerina","Piazza Brembana","Piazza Roma","Piazzola sul Brenta","Picerno","Pico","Piedimonte Etneo","Piedimonte Matese","Piedimonte San Germano","Piegaro","Piemonte","Pieris","Pietra","Pietra Ligure","Pietrabbondante","Pietracuta","Pietrapaola","Pietraperzia","Pietrasanta","Pieve","Pieve Albignola","Pieve del Cairo","Pieve di Cadore","Pieve di Cento","Pieve di Soligo","Pieve Fosciana","Pieve Ligure","Pieve San Giacomo","Pieve Vecchia","Pievebovigliana","Pievepelago","Piglio","Pignataro Interamna","Pignataro Maggiore","Pignola","Pignone","Pilcante","Pimonte","Pinarella","Pinerolo","Pineta","Pineto","Pinzano al Tagliamento","Pinzolo","Piobbico","Piobesi Torinese","Pioltello","Piombino","Piombino Dese","Pioraco","Piossasco","Piove di Sacco","Piovene Rocchette","Piraino","Pirri","Pisa","Pisciotta","Pisogne","Pisticci","Pistoia","Pistrino","Pitigliano","Piumazzo","Pizzighettone","Pizzo","Plan da Tieja","Ploaghe","Pocenia","Podenzana","Podenzano","Pofi","Poggiardo","Poggibonsi","Poggio","Poggio a Caiano","Poggio Berni","Poggio di Roio","Poggio Mirteto","Poggio Moiano","Poggio Nativo","Poggio Renatico","Poggio Rusco","Poggio San Lorenzo","Poggiomarino","Pogliano","Pogliano Milanese","Pogno","Poiana Maggiore","Poirino","Polesella","Polesine Parmense","Poli","Policoro","Polignano a Mare","Polinago","Polistena","Polla","Pollein","Pollenza","Pollica","Pollina","Polverara","Polverigi","Pomarance","Pombia","Pomezia","Pompei","Pompiano","Pomponesco","Poncarale","Ponsacco","Ponso","Pont","Pont-Canavese","Pont-Saint-Martin","Pontassieve","Ponte","Ponte a Evola","Ponte a Moriano","Ponte Basso","Ponte Buggianese","Ponte di Barbarano","Ponte di Piave","Ponte Galeria-La Pisana","Ponte Lambro","Ponte nelle Alpi","Ponte Nossa","Ponte San Giovanni","Ponte San Nicolo","Ponte San Pietro","Pontecagnano","Pontecchio","Pontecchio Polesine","Pontecorvo","Pontecurone","Pontedassio","Pontedera","Pontelongo","Pontenure","Pontestura","Pontevico","Ponti","Ponticelli","Pontida","Pontinia","Pontremoli","Ponza","Ponzano","Ponzano Veneto","Ponzone","Popoli","Poppi","Porano","Porcari","Porcia","Pordenone","Porlezza","Porpetto","Porretta Terme","Porta","Portici","Portico di Caserta","Porto","Porto Azzurro","Porto Empedocle","Porto Ercole","Porto Garibaldi","Porto Potenza Picena","Porto Recanati","Porto San Giorgio","Porto Tolle","Porto Torres","Porto Viro","Portoferraio","Portofino","Portogruaro","Portomaggiore","Portoscuso","Portovenere","Positano","Posta Fibreno","Posta Vecchia","Postiglione","Postioma","Potenza","Potenza Picena","Povegliano","Povegliano Veronese","Poviglio","Pozza di Fassa","Pozza-San Marco","Pozzallo","Pozzilli","Pozzo","Pozzo di Gotto","Pozzolengo","Pozzoleone","Pozzolo","Pozzolo Formigaro","Pozzonovo","Pozzuoli","Pozzuolo del Friuli","Prad am Stilfser Joch","Pradamano","Praia a Mare","Praiano","Pralormo","Pralungo","Pramaggiore","Prarolo","Prata","Prata Camportaccio","Prata di Pordenone","Prata Sannita","Prato","Prato Sesia","Pratola Peligna","Pratola Serra","Pratovecchio","Pravisdomini","Pray","Predazzo","Predore","Predosa","Preganziol","Premana","Premariacco","Premosello-Chiovenda","Presicce","Pressana","Pretoro","Prevalle","Prezza","Priolo Gargallo","Priverno","Prizzi","Procida","Provesano","Province of Messina","Puglianello","Pugliano","Puianello","Pula","Pulsano","Punta Marina","Putignano","Quadri","Quagliuzzo","Qualiano","Qualso","Quaregna","Quargnento","Quarona","Quarrata","Quart","Quarto","Quarto Inferiore","Quartucciu","Quattordio","Quattro Castella","Quero","Quiliano","Quindici","Quinto di Treviso","Quinto Vercellese","Quinto Vicentino","Quistello","Racale","Racalmuto","Racconigi","Radda in Chianti","Raffadali","Ragogna","Ragusa","Raiano","Raldon","Ramacca","Ramiseto","Ramon","Ramponio","Rancio Valcuvia","Randazzo","Ranieri","Rapagnano","Rapallo","Rapolla","Rassina","Ratschings","Ravanusa","Ravarino","Ravello","Ravenna","Ravi","Recale","Recanati","Recco","Recoaro Terme","Regalbuto","Reggello","Reggio Calabria","Reggiolo","Regina","Regina Margherita","Remanzacco","Renazzo","Rende","Reno","Resana","Rescaldina","Resia","Revello","Revere","Revigliasco","Revine","Rezzato","Rho","Riale","Riano","Ribera","Ribolla","Ricadi","Riccia","Riccione","Riccovolto","Riese Pio X","Riesi","Rieti","Rignano Flaminio","Rignano Garganico","Rimini","Rino","Rio Marina","Rio Saliceto","Riola Sardo","Riolo Terme","Riomaggiore","Rionero in Vulture","Ripa","Ripa Teatina","Ripa-Pozzi-Querceta-Ponterosso","Ripafratta-Farneta","Ripalta Cremasca","Riparbella","Ripatransone","Ripe","Ripe San Ginesio","Ripi","Ripoli","Riposto","Riva","Riva del Garda","Riva Ligure","Riva presso Chieri","Rivalba","Rivalta","Rivalta di Torino","Rivanazzano","Rivara","Rivarolo del Re ed Uniti","Rivarolo Ligure","Rivarolo Mantovano","Rivello","Rivergaro","Riviera","Rivignano","Rivodutri","Rivoli","Rizzi","Rizziconi","Roasio","Robassomero","Robbiate","Robbio","Robecchetto con Induno","Robecco sul Naviglio","Rocca","Rocca Canavese","Rocca di Papa","Rocca Massima","Rocca Priora","Rocca San Casciano","Roccabernarda","Roccabianca","Roccadaspide","Roccafranca","Roccalumera","Roccamonfina","Roccapiemonte","Roccarainola","Roccaromana","Roccasecca","Roccastrada","Roccavione","Roccavivara","Roccavivi","Roccella","Roccella Ionica","Rocchetta di Vara","Rocco","Rodano","Rodeneck-Rodengo","Rodi Garganico","Rodigo","Roggiano Gravina","Rogliano","Rognano","Roiano","Rolo","Romagnano Sesia","Romana","Romanengo","Romano Canavese","Romano di Lombardia","Rome","Romentino","Rometta","Roncade","Roncadelle","Roncalceci","Roncegno","Ronchi","Ronchi dei Legionari","Ronchis","Ronciglione","Ronco","Ronco Scrivia","Ronco-Chiesa","Roncoferraro","Roncone","Rondissone","Rosa","Rosate","Rosciano","Rose","Roseto Capo Spulico","Roseto degli Abruzzi","Roseto Valfortore","Rosignano Marittimo","Rosignano Solvay-Castiglioncello","Rosolina","Rosolini","Rossano","Rossano Veneto","Rossi","Rossiglione","Rota Greca","Rotella","Rotello","Rotondi","Rottofreno","Rovagnate","Rovato","Rovellasca","Rovello Porro","Roverbella","Rovere","Roveredo","Roveredo in Piano","Rovereto","Rovetta","Roviano","Rovigo","Rovito","Rozzano","Rubano","Rubbiano","Rubiana","Rubiera","Ruda","Rudiano","Ruffano","Rufina","Ruoti","Russi","Russo","Rutigliano","Ruviano","Ruvo di Puglia","Sabatino","Sabaudia","Sabbio Chiese","Sabbioneta","Sacco","Saccolongo","Sacile","Sacrofano","Sagrado","Saint-Pierre","Saint-Vincent","Sala Baganza","Sala Bolognese","Sala Consilina","Salara","Salassa","Sale","Sale Marasino","Salemi","Salento","Salerno","Saletto","Salice Salentino","Saliceto","Saline","Salmour","Salorno","Salsomaggiore Terme","Saltocchio","Saludecio","Saluggia","Saluzzo","Salvaterra","Salve","Salvirola","Salzano","Samarate","Samassi","Sambruson","Sambuceto","Sammichele di Bari","Samone","San Bartolomeo","San Bassano","San Benedetto dei Marsi","San Benedetto del Tronto","San Benedetto Po","San Benedetto Val di Sambro","San Benigno Canavese","San Bernardino","San Biagio","San Biagio di Callalta","San Bonifacio","San Carlo","San Casciano dei Bagni","San Casciano in Val di Pesa","San Cassiano","San Cataldo","San Cesareo","San Cesario di Lecce","San Cesario sul Panaro","San Chirico Raparo","San Cipirello","San Cipriano Picentino","San Colombano al Lambro","San Costanzo","San Daniele del Friuli","San Demetrio Corone","San Dona","San Donaci","San Donato","San Donato di Lecce","San Donato Milanese","San Dorligo della Valle","San Fedele","San Felice Circeo","San Felice sul Panaro","San Ferdinando","San Ferdinando di Puglia","San Fili","San Filippo","San Fior","San Fiorano","San Francesco","San Francesco al Campo","San Fratello","San Gavino Monreale","San Gemini","San Genesio ed Uniti","San Gennaro Vesuviano","San Germano Vercellese","San Giacomo","San Giacomo degli Schiavoni","San Gillio","San Gimignano","San Ginesio","San Giorgio","San Giorgio a Cremano","San Giorgio a Liri","San Giorgio Canavese","San Giorgio del Sannio","San Giorgio della Richinvelda","San Giorgio di Lomellina","San Giorgio di Nogaro","San Giorgio di Piano","San Giorgio in Bosco","San Giorgio Ionico","San Giorgio la Molara","San Giorgio Piacentino","San Giovanni","San Giovanni a Piro","San Giovanni al Natisone","San Giovanni Bianco","San Giovanni Gemini","San Giovanni in Croce","San Giovanni in Fiore","San Giovanni in Marignano","San Giovanni in Persiceto","San Giovanni la Punta","San Giovanni Lupatoto","San Giovanni Rotondo","San Giovanni Suergiu","San Giovanni Valdarno","San Giuliano Milanese","San Giuliano Terme","San Giuseppe","San Giuseppe Jato","San Giuseppe Vesuviano","San Giustino","San Giusto Canavese","San Gregorio","San Gregorio da Sassola","San Gregorio di Catania","San Lazzaro degli Armeni","San Lazzaro di Savena","San Leo","San Lorenzello","San Lorenzo","San Lorenzo al Mare","San Lorenzo del Vallo","San Lorenzo in Campo","San Lorenzo Isontino","San Luca","San Lucido","San Mango","San Mango Piemonte","San Marcello","San Marcello Pistoiese","San Marco","San Marco Argentano","San Marco dei Cavoti","San Marco Evangelista","San Marco in Lamis","San Mariano","San Martino","San Martino al Tagliamento","San Martino Buon Albergo","San Martino Canavese","San Martino di Lupari","San Martino in Pensilis","San Martino in Rio","San Martino in Strada","San Martino Sannita","San Martino Siccomario","San Marzano di San Giuseppe","San Marzano sul Sarno","San Maurizio","San Maurizio Canavese","San Mauro","San Mauro Pascoli","San Mauro Torinese","San Michele al Tagliamento","San Michele Prazzo","San Michele Salentino","San Miniato","San Miniato Basso","San Nazario","San Niccolo","San Nicola","San Nicola Arcella","San Nicolo","San Pancrazio Salentino","San Paolo","San Pellegrino Terme","San Piero a Sieve","San Piero in Bagno","San Piero Patti","San Pietro","San Pietro a Maida","San Pietro di Cadore","San Pietro di Feletto","San Pietro in Casale","San Pietro in Gu","San Pietro in Lama","San Pietro Mosezzo","San Pietro Vernotico","San Pietro Viminario","San Polo","San Polo di Piave","San Prisco","San Prospero","San Quirino","San Raineri","San Rocco","San Rufo","San Salvatore","San Salvatore Monferrato","San Salvatore Telesino","San Salvo","San Sebastiano al Vesuvio","San Secondo","San Secondo Parmense","San Severino","San Severino Marche","San Severo","San Sisto","San Sossio Baronia","San Sosti","San Sperate","San Tammaro","San Teodoro","San Valentino Torio","San Venanzio","San Venanzo","San Vendemiano","San Vero Milis","San Vincenzo","San Vito","San Vito al Tagliamento","San Vito Chietino","San Vito dei Normanni","San Vito di Cadore","San Vito Lo Capo","San Vito Romano","San Vittore","San Zaccaria","San Zeno","San Zenone al Lambro","San Zenone al Po","San Zenone degli Ezzelini","Sand in Taufers","Sandigliano","Sandon","Sandrigo","Sangano","Sanguinetto","Sanluri","Sannicandro di Bari","Sannicandro Garganico","Sannicola","Sanremo","Sansepolcro","Sant Angelo","Santa Barbara","Santa Caterina dello Ionio","Santa Caterina Villarmosa","Santa Cristina","Santa Croce","Santa Croce Camerina","Santa Elisabetta","Santa Eufemia Lamezia","Santa Fiora","Santa Flavia","Santa Giuletta","Santa Giusta","Santa Giustina","Santa Giustina in Colle","Santa Lucia","Santa Lucia di Piave","Santa Margherita di Belice","Santa Margherita Ligure","Santa Maria","Santa Maria a Monte","Santa Maria a Vico","Santa Maria Capua Vetere","Santa Maria Codifiume","Santa Maria degli Angeli","Santa Maria di Licodia","Santa Maria di Sala","Santa Maria Imbaro","Santa Maria Nuova","Santa Marinella","Santa Ninfa","Santa Severa","Santa Sofia","Santa Teresa di Riva","Santa Teresa Gallura","Santa Venerina","Santa Vittoria di Libiola","Santa Vittoria in Matenano","Santadi","Santarcangelo di Romagna","Santeramo in Colle","Santi","Santi Cosma e Damiano","Santo Pietro","Santo Spirito","Santo Stefano","Santo Stefano al Mare","Santo Stefano Belbo","Santo Stefano di Briga","Santo Stefano di Cadore","Santo Stefano di Magra","Santo Stefano di Rogliano","Santo Stefano Quisquina","Santo Stefano Ticino","Santo Stino di Livenza","Santorso","Santu Lussurgiu","Saponara","Sapri","Sarcedo","Sarezzo","Sarmede","Sarnano","Sarnico","Sarno","Sarnthein","Saronno","Sarroch","Sarsina","Sarteano","Sartirana Lomellina","Sarzana","Sassa","Sassari","Sassello","Sassetta","Sassinoro","Sasso","Sasso Marconi","Sassoferrato","Sassuolo","Saturnia","Sava","Saviano","Savigliano","Savignano sul Panaro","Savignano sul Rubicone","Savio","Savona","Scafa","Scafati","Scala","Scaldasole","Scalea","Scalenghe","Scaletta Zanclea","Scandiano","Scandicci","Scanno","Scansano","Scanzano","Scanzano Jonico","Scarlino","Scarmagno","Scarperia","Scauri","Scerni","Schiavon","Schio","Schlanders","Sciacca","Scicli","Scilla","Scoppito","Scordia","Scorrano","Scuola","Seano","Seborga","Secondigliano","Sedegliano","Sedico","Sedilo","Sedriano","Segariu","Seglia San Bernardo","Segni","Segrate","Selargius","Selci","Selegas","Sella","Selva","Selvazzano Dentro","Selvino","Seminara","Senago","Senerchia","Seniga","Senigallia","Senise","Sennori","Seravezza","Seregno","Sergnano","Seriate","Serino","Serle","Sermide","Sermoneta","Sernaglia della Battaglia","Serra","Serra Pedace","Serra San Bruno","Serra San Quirico","Serracapriola","Serradifalco","Serraglio","Serramanna","Serramazzoni","Serramezzana","Serrano","Serrara Fontana","Serravalle Pistoiese","Serravalle Scrivia","Serravalle Sesia","Serre","Serrenti","Sersale","Servigliano","Sessa Aurunca","Sesto al Reghena","Sesto Calende","Sesto Fiorentino","Sesto San Giovanni","Sestri Levante","Sestriere","Sestu","Settimo","Settimo San Pietro","Settimo Torinese","Settimo Vittone","Seveso","Sexten","Sezze","Sgonico","Sgurgola","Siamaggiore","Siamanna","Siano","Siapiccia","Sibari","Sicignano degli Alburni","Siculiana","Siderno","Siena","Sigillo","Signa","Silanus","Silea","Siliqua","Sillavengo","Silvi","Silvi Paese","Simaxis","Simone","Sinalunga","Sindia","Siniscola","Sinnai","Sinopoli","Sirignano","Sirmione","Siziano","Sizzano","Soave","Soci","Sogliano Cavour","Solagna","Solarino","Solaro","Solarolo","Solato","Solbiate Arno","Solbiate Olona","Solda","Soldano","Soleminis","Solesino","Soleto","Soliera","Solignano Nuovo","Solofra","Solopaca","Solto Collina","Somma Lombardo","Somma Vesuviana","Sommacampagna","Sommariva del Bosco","Sommariva Perno","Sommatino","Sona","Soncino","Sondalo","Sondrio","Sonnino","Sora","Soragna","Sorbolo","Sordevolo","Soresina","Sorgono","Sori","Soriano nel Cimino","Sorisole","Sorrento","Sorso","Sortino","Sospiro","Sospirolo","Sossano","Sotto Castello","Sotto il Monte Giovanni XXIII","Sottomarina","Soverato Marina","Sovere","Soveria Mannelli","Sovicille","Spadafora","Sparanise","Sparone","Specchia","Spello","Sperlonga","Sperone","Spezzano Albanese","Spezzano della Sila","Spigno Saturnia","Spilamberto","Spilimbergo","Spin","Spina","Spinazzola","Spinea","Spineda","Spinete","Spineto","Spinetoli","Spinetta Marengo","Spirano","Spoleto","Spoltore","Spotorno","Spresiano","Squillace","Squinzano","Staffolo","Stagno","Stanghella","Staranzano","Statte","Stazione Castelguelfo","Stazione Ponte Rio","Stazzano","Stefania","Stella Cilento","Sterzing","Stezzano","Stia","Stienta","Stigliano","Stimigliano","Stornarella","Storo","Stra","Strada San Zeno","Stradella","Strambino","Stresa","Stretti","Strevi","Striano","Strigno","Strona","Stroncone","Strongoli","Stroppiana","Sturno","Suardi","Subbiano","Subiaco","Sulmona","Sulzano","Sumirago","Suno","Supino","Surbo","Susa","Susegana","Sutri","Sutrio","Suzzara","Syracuse","Taggia","Tagliacozzo","Taglio di Po","Taibon Agordino","Taino","Taio","Talsano","Taormina","Taranta Peligna","Tarantasca","Taranto","Tarcento","Tarquinia","Tarvisio","Tarzo","Tassullo","Taurano","Taurianova","Tavagnacco","Tavarnelle Val di Pesa","Tavarnuzze","Taverna","Tavernola Bergamasca","Taviano","Tavullia","Teggiano","Teglio","Teglio Veneto","Telese","Telgate","Tempio Pausania","Tenno","Teolo","Teramo","Terenten","Terenzo","Terlan","Terlizzi","Termeno","Termini Imerese","Termoli","Ternate","Terni","Terracina","Terralba","Terranova da Sibari","Terranuova Bracciolini","Terrarossa","Terrasini","Terricciola","Terruggia","Tertenia","Terzigno","Terzo","Terzorio","Tessera","Tezze sul Brenta","Thiene","Thiesi","Ticengo","Tina","Tione di Trento","Tirano","Tiriolo","Tirrenia","Tito","Tivoli","Toblach","Todi","Toffia","Toirano","Tolentino","Tolfa","Tollegno","Tolmezzo","Tolve","Tomba","Tombolo","Tonezza del Cimone","Torano Castello","Torchiarolo","Torella dei Lombardi","Torgiano","Torgnon","Toritto","Tornaco","Tornareccio","Toro","Torrazza","Torre","Torre a Mare","Torre Annunziata","Torre Boldone","Torre del Greco","Torre del Lago Puccini","Torre di Ruggiero","Torre Orsaia","Torre Pellice","Torre San Patrizio","Torre Santa Susanna","Torrebelvicino","Torrecuso","Torreglia","Torregrotta","Torrenova","Torretta","Torrevecchia Teatina","Torri","Torri del Benaco","Torri di Quartesolo","Torri in Sabina","Torriana","Torrice","Torricella","Torrile","Torrita di Siena","Torrita Tiberina","Tortona","Tortora","Tortoreto","Torviscosa","Toscolano-Maderno","Tossicia","Trabia","Tradate","Tramonti","Tramutola","Trana","Trani","Transacqua","Traona","Trapani","Trappeto","Trasacco","Tratalias","Travagliato","Travedona Monate","Traversetolo","Travo","Trebaseleghe","Trebisacce","Trecastagni","Trecate","Trecenta","Tredozio","Treglio","Tregnago","Treia","Trento","Trentola-Ducenta","Trepuzzi","Trequanda","Tres","Trescore Balneario","Trescore Cremasco","Tresenda","Trevenzuolo","Trevi","Trevico","Treviglio","Trevignano","Trevignano Romano","Treviso","Trezzano Rosa","Trezzano sul Naviglio","Tribiano","Tricarico","Tricase","Tricesimo","Trichiana","Trieste","Triggianello","Triggiano","Trigolo","Trinitapoli","Trino","Trissino","Triuggio","Trivento","Trivero","Trivignano","Trivignano Udinese","Trofarello","Troia","Troina","Tromello","Tronzano Vercellese","Tropea","Trovo","Truccazzano","Tufino","Tuglie","Tuili","Tuoro sul Trasimeno","Turbigo","Turi","Turin","Turriaco","Tursi","Tusa","Tuscania","Udine","Ugento","Uggiate Trevano","Umbertide","Urbania","Urbino","Urbisaglia","Urgnano","Ururi","Uscio","Usellus","Usini","Usmate Velate","Ussana","Uta","Uzzano","Vacri","Vadena","Vado","Vado Ligure","Vaglia","Vaglio Basilicata","Vahrn","Vaiano","Vaiano Cremasco","Vailate","Vairano Patenora","Vajont","Valdagno","Valdengo","Valdieri","Valdobbiadene","Valduggia","Valeggio sul Mincio","Valentano","Valentina","Valenza","Valenzano","Valfabbrica","Valfenera","Valganna","Valguarnera Caropepe","Vallata","Valle","Valle Agricola","Valle di Cadore","Valle Lomellina","Valle Mosso","Vallecrosia","Vallefiorita","Vallerano","Valli del Pasubio","Vallo","Vallo della Lucania","Vallombrosa","Valmadrera","Valmontone","Valperga","Valverde","Vanzaghello","Vanzago","Varallo Pombia","Varallo Sesia","Varano","Varapodio","Varazze","Varedo","Varese","Varese Ligure","Varzo","Vas","Vasanello","Vascon","Vasto","Vattaro","Vecchiano-Nodica","Vedano Olona","Vedelago","Veglie","Velletri","Vellezzo Bellini","Vena di Maida","Venafro","Venaria Reale","Venarotta","Venaus","Venegono Inferiore","Venegono Superiore","Venetico","Veneto","Venice","Venosa","Ventimiglia","Ventimiglia di Sicilia","Venturina","Verbicaro","Vercelli","Vercurago","Verdellino","Verdello","Vergano-Villa","Vergato","Vergiate","Vermezzo","Vernate","Vernio","Vernole","Verolanuova","Verolavecchia","Verolengo","Veroli","Verona","Veronella","Verrone","Vertova","Verucchio","Verzuolo","Vescovana","Vescovato","Vespolate","Vestone","Vetralla","Vezzano Ligure","Vezzano sul Crostolo","Viadana","Viagrande","Viano","Viareggio","Vibo Valentia","Vicarello","Vicari","Vicchio","Vicenza","Vico Equense","Vicoforte","Vicolungo","Vicopisano","Vicovaro","Vidardo","Vidiciatico","Vidigulfo","Vieste","Vietri sul Mare","Vigarano Mainarda","Vigarano Pieve","Vigasio","Vigevano","Vigliano Biellese","Vignacastrisi","Vignale Monferrato","Vignanello","Vignate","Vignola","Vigo di Cadore","Vigo di Fassa","Vigo Rendena","Vigodarzere","Vigolo Vattaro","Vigolzone","Vigone","Vigonovo","Vigonza","Viguzzolo","Villa","Villa Bartolomea","Villa Basilica","Villa Castelli","Villa Cortese","Villa del Conte","Villa di Serio","Villa di Tirano","Villa Estense","Villa Faraldi","Villa Guardia","Villa Lagarina","Villa Literno","Villa Marina","Villa Minozzo","Villa Morelli","Villa Ottone","Villa San Giovanni","Villa San Pietro","Villa San Sebastiano","Villa Santa Lucia","Villa Verucchio","Villa Vicentina","Villabate","Villacidro","Villadose","Villafranca di Forli","Villafranca di Verona","Villafranca in Lunigiana","Villafranca Piemonte","Villafranca Tirrena","Villafrati","Villaggio","Villaggio Montegrappa","Villagrazia","Villalago","Villamagna","Villamar","Villamassargia","Villanova","Villanova del Ghebbo-Valdentro","Villanova Monferrato","Villanovafranca","Villanterio","Villanuova sul Clisi","Villapiana","Villaputzu","Villar","Villaricca","Villarosa","Villasalto","Villasanta","Villasmundo","Villasor","Villaspeciosa","Villastellone","Villastrada","Villaurbana","Villaverla","Villavesco","Ville","Villetta","Vimercate","Vimodrone","Vinci","Viola","Virgilio","Viscone","Viserba","Visinale","Vistrorio","Viterbo","Vitigliano","Vitorchiano","Vittoria","Vittorio Veneto","Vittuone","Vitulano","Vitulazio","Vivaro","Vizzini","Vo","Vobarno","Voghenza","Voghera","Vogogna","Volano","Volla","Volpago del Montello","Volpedo","Volpiano","Volta Mantovana","Voltago","Volterra","Volturara Irpina","Volturino","Volvera","Welsberg-Taisten","Welschnofen","Zafferana Etnea","Zagarolo","Zambana","Zambrone","Zandobbio","Zanetti","Zangarona","Zanica","Zelarino","Zelo","Zelo Buon Persico","Zeme","Zerbo","Zerfaliu","Zermeghedo","Zero Branco","Zevio","Zibido San Giacomo","Zimella","Zimone","Zinasco","Zoagli","Zocca","Zogno","Zola Predosa","Zoldo Alto","Zollino","Zoppola","Zumaglia"]},"JE":{"id":"JE","name":"Jersey","timezones":["Europe/London"],"cities":[]},"JM":{"id":"JM","name":"Jamaica","timezones":["America/Jamaica"],"cities":["Black River","Browns Town","Gordon Town","Gregory Park","Kingston","Mandeville","May Pen","Moneague","Montego Bay","Negril","Ocho Rios","Old Harbour","Port Maria","Portland Cottage","Portmore","Runaway Bay","Spanish Town"]},"JO":{"id":"JO","name":"Jordan","timezones":["Asia/Amman"],"cities":[]},"JP":{"id":"JP","name":"Japan","timezones":["Asia/Tokyo"],"cities":["Abashiri","Abiko","Abira","Aboshiku-okinohama","Agano","Agena","Ageo","Aikawa","Aioi","Aisai","Aitsu","Aizu-Wakamatsu","Akao","Akasaka","Akasaki","Akashi","Akeno","Aki","Akiruno-shi","Akishima","Akita","Ama-higashimachi","Amagasaki","Ami","Anabuki","Anan","Anesaki","Anjo","Annaka","Aoicho","Aomori","Arai","Arakawa","Ariake","Arida","Arita","Asahi","Asahikawa","Asahimachi","Asaka","Ashihara","Ashikaga","Ashiya","Aso","Atami","Atsugi","Awara","Ayase","Azuchi","Azumino","Bakurocho","Bandaicho","Bando","Beppu","Bibai","Budo","Chatan","Chiba","Chichibu","Chigasaki","Chiji","Chikusei","Chino","Chiran","Chiryu","Chita","Chitose","Choshi","Chuo","Daido","Daigo","Daimon","Daisen","Daitocho","Date","Ebetsu","Ebina","Ebisu","Echizen","Edagawa","Edogawa-ku","Ena","Eniwa-shi","Esashi","Fuchu-machi","Fuchucho","Fuefuki-shi","Fuji","Fujieda","Fujiidera","Fujimi","Fujimino","Fujinomiya","Fujioka","Fujisato","Fujisawa","Fujita","Fukai","Fukayacho","Fukiage-fujimi","Fukuchi","Fukuchiyama","Fukuda","Fukui","Fukui-shi","Fukuoka","Fukuroi","Fukushima-shi","Fukuyama","Fumoto","Funabashi","Fushiki-minatomachi","Fushimi","Fussa","Futoo","Futtsu","Gamagori","Gannosu","Geinocho-mukumoto","Gifu","Ginowan","Ginza","Gobo","Godo","Gojo","Gosen","Goshogawara","Gotanda","Gotemba","Gotsucho","Goya","Gujo","Gundo","Gushikawa","Gyoda","Habikino","Hachiman-cho","Hachimantai","Hachimori","Hachinohe","Hadano","Haebaru","Hagi","Haibara-akanedai","Haijima","Hakata","Hakodate","Hakone","Hakozaki","Hakui","Hama","Hamada","Hamamatsu","Hamana","Hamura","Hanabatacho","Hanamaki","Hanawadamachi","Handa","Hannan","Hanno","Hanyu","Harigaya","Hashima","Hashimoto","Hasuda","Hatogaya-honcho","Hatoyama","Hatsukaichi","Hayama","Hayashi","Hayashima","Hayashino","Heiwajima","Hekinan","Hidaka","Hidakacho-ebara","Higashi-iwashiro","Higashi-takadama","Higashiasahimachi","Higashiboridori","Higashicho","Higashiiya-takano","Higashiiya-wakabayashi","Higashikawa","Higashimurayama-shi","Higashine","Higashiomi-shi","Higashiosaka","Higashiura","Higashiyama","Higashiyamato","Hiji","Hikari","Hikawa","Hiki","Hikone","Himeji","Himi","Hinata","Hino","Hinode","Hirakata","Hirakawa","Hiranuma","Hiratsuka","Hirokawa","Hirosaki","Hiroshima","Hita","Hitachi","Hitoyoshi","Hiyoshi","Hodogayacho","Hofu","Hojo","Hokota","Hokuto-shi","Hommachi","Honcho","Honden","Hongo","Honjo","Honjocho","Horinouchi","Horyuji","Hosobara","Hotei","Hyogo","Ibara","Ibaraki","Ichi","Ichibanhoridoricho","Ichihara","Ichikawa","Ichimura","Ichinogo","Ichinomiya","Ichinomiyacho","Ichinomotocho","Ichinoseki","Ida","Iida","Iiyama","Iizuka","Iju","Ikaruga","Ikeda","Ikedacho-itano","Ikejiri","Ikoma","Ikuno","Imabari-shi","Imabuku","Imagami","Imaicho","Imari","Imizucho","Ina","Inabe","Inage","Inagi-shi","Inami","Inashiki","Inazawa","Innoshima Hara-cho","Ino","Inuyama","Inzai","Iruma","Isahaya","Isawa","Ise","Isehara","Isesaki","Ishida","Ishigaki","Ishige","Ishii","Ishikari","Ishikawa","Ishiki","Ishinomaki","Ishioka","Isomura","Isoya","Isumi","Itabashi","Itako","Itami","Itoi","Itoigawa","Itoman","Iwade","Iwaki","Iwakiri","Iwakuni","Iwakura","Iwamizawa","Iwanai","Iwanuma","Iwata","Iwatsuki","Izu","Izumi","Izumiotsu","Izumo","Izunokuni","Jissen","Joetsu","Jogo","Joshi","Joso","Jumonji","Kabe","Kadoma","Kaga","Kagawa","Kagoshima","Kagoya","Kahoku","Kaigandori","Kainan","Kaisei","Kaita","Kaizu","Kaizuka","Kakamigahara","Kakegawa","Kakogawa","Kakuda","Kamagaya-shi","Kamaishi","Kamakura","Kameda-honcho","Kameoka","Kameyama","Kami-kawakami","Kami-nagarekawacho","Kamibun","Kamigori","Kamikawa","Kamikita-kita","Kamimura","Kaminokawa","Kaminoyama","Kamirenjaku","Kamisu","Kamitosa","Kamo","Kamogatacho-kamogata","Kamoi","Kanada","Kanagawa","Kanaya","Kanayama","Kanazawa","Kanda","Kanegasaki","Kani","Kanie","Kano","Kanomata","Kanuma","Kanzaki","Karatsu","Kariya","Kasai","Kasama","Kasamatsucho","Kasaoka","Kaseda-shirakame","Kashiba","Kashihara","Kashima","Kashima-shi","Kashiwa","Kashiwagimachi","Kashiwara","Kashiwazaki","Kasuga","Kasugai","Kasukabe","Kasumicho","Kasumigaseki","Kasumigaura","Kataoka","Katori-shi","Katsumada","Katsura","Katsuura","Katsuyama","Katta","Kawagoe","Kawaguchi","Kawahara","Kawanishi","Kawasaki","Kayano","Kazo","Kazuka","Kazuno","Kesennuma","Keta","Kichijoji-honcho","Kii-nagashimaku-nagashima","Kikuchi","Kikugawa","Kikyo","Kimitsu","Kinokawa","Kinoshita","Kiryu","Kisarazu","Kishiwada","Kita","Kita-sannomaru","Kitagata","Kitahiroshima","Kitaibaraki","Kitakami","Kitakata","Kitakyushu","Kitami","Kitamoto","Kitanagoya","Kitaozuma","Kitsuki","Kitsuregawa","Kiyama","Kiyokawa","Kiyose","Kiyosu","Kobe","Kochi-shi","Kochino","Kocho","Kodaira","Kodamacho-kodamaminami","Kofu","Koga","Koganei","Kojima","Koka","Kokawa","Kokubu-matsuki","Kokubunji","Kokufu","Kokura","Kokuryo","Komaba","Komae-shi","Komagane","Komagawa","Komagome","Komaki","Komatsu","Komatsubara","Komatsushimacho","Komono","Komoro","Konan","Konancho-fukawa","Konosu","Koori","Koriyama","Koryocho-itazu","Kosai","Kose","Koshigaya","Koto","Kotohira","Kotoku","Koyama","Koyasan","Koyo","Koza","Kubo","Kudamatsu","Kugayama","Kukichuo","Kumagaya","Kumamoto","Kumano","Kunitachi","Kurami","Kurashiki","Kurayoshi","Kure","Kurihara","Kurihashi","Kurobeshin","Kurogi","Kuroishi","Kuroiwa","Kurume","Kusai","Kusatsu","Kuse","Kushimoto","Kushiro","Kusunoki","Kutchan","Kuwana-shi","Kyodo","Kyoritsu","Kyoto","Kyowa","Machi","Machida","Machiya","Maebaru","Maebashi","Maibara","Maizuru","Maki","Makinohara","Makuhari","Marugame","Marunouchi","Maruyama","Masaki","Mashiko","Masuda","Matsubara","Matsudo","Matsue-shi","Matsukawamachi","Matsumoto","Matsusaka","Matsuto","Matsuyama","Meguro","Meiji","Mibu","Midori","Miemachi","Mihama","Mihara","Miki","Mima","Mimasaka","Minabe","Minamata","Minami","Minamiaoyama","Minamiashigara","Minamiuonuma","Minato","Minatogawa","Minatomachi","Mine","Mineyama","Mino","Minobu","Minokamo","Minoshima","Minowa","Misakicho","Misakimachi-konami","Misato","Misawa","Mishima","Mitai","Mitake","Mito-shi","Mitsucho-iwami","Mitsui","Mitsukaido","Mitsuke","Mitsushimacho-osaki","Miura","Miwa","Miyagi","Miyako","Miyakojima","Miyakonojo","Miyama","Miyata","Miyazaki-shi","Miyazu","Miyoshi","Mizugama","Mizuko","Mizunami","Mizusawa","Mizushima-nishichidoricho","Mobara","Mochida","Moji","Mombetsu","Momoishi","Monzenmachi-igisu","Mooka","Mori","Moriguchi","Morioka","Moriya","Moriyama","Morodomitsu","Morohongo","Morowa","Motegi","Motomiya","Muikamachi","Muko","Murai","Murakami","Murata","Murayama","Muroran","Muroto-misakicho","Musa","Musashimurayama","Musashino","Mutsu","Mutsumi","Nabari","Nada","Naebocho","Nagahama","Nagano-shi","Naganohara","Nagao","Nagaoka","Nagareyama","Nagasaki","Nagase","Nagashima","Nagato","Nagawado","Nago","Nagoya-shi","Naha","Naitobokujo","Naka","Nakada","Nakagawa","Nakagomi","Nakagusuku","Nakahai","Nakahata","Nakaichi","Nakama","Nakamura","Nakanishi","Nakano","Nakano-kami","Nakanoshima","Nakatsu","Nakatsugawa","Nakayama","Nakazawa","Nakijin","Namerikawa","Nanae","Nanao","Nanto","Nara","Narashino-shi","Narita","Narutocho-mitsuishi","Nasa","Nasukarasuyama","Natori-shi","Natsumi","Nayoro","Nemuro","Nerima-ku","Neyagawa","Nichinan","Nihommatsu","Niigata","Niihama","Niimi","Niitsu","Niiza","Nikaho","Ninohe","Ninomiya","Nirasaki","Nishi","Nishi-Tokyo-shi","Nishihara","Nishikawa","Nishikicho","Nishiko","Nishimachi","Nishime","Nishinomiya","Nishio","Nishiwaki","Nishiyama","Nisshin","Nita","Nobeoka","Nobitome","Noboribetsu","Noda","Nodani","Nogata","Noguchi","Nomimachi","Nomura","None-mura","Nonoichi","Nose","Noshiro","Numazu","Nyuzen","Oarai","Obama","Obanazawa","Obari","Obayashi","Obihiro","Obu","Obuse","Ochiai","Ochikawa","Odaira","Odawara","Odori","Ogaki","Ogawa","Ogi","Ogori-shimogo","Oguni","Ogura","Ohara","Oiso","Oiwake","Oizu","Ojiya","Okawa","Okawachi","Okaya","Okayama","Okazaki","Okegawa","Okinawa","Okubo","Okuchi","Okuma","Okuura","Omachi","Omaezaki","Omagari","Ome","Omihachiman","Omiya","Omiya-ku","Omori","Omura","Omuta","Onna","Ono","Onoda","Onogawa","Onojo","Onomichi","Onuma","Osaka","Osaki","Osawa","Oshima","Oshu","Ota","Otake","Otani","Otaru","Otawara","Otemachi","Otsukacho","Otsuki","Otsuku-kibi","owariasahi","Oyabe","Oyama","Oyamato","Ozu","Raiba","Rankoshi-cho","Rifu","Ritto","Roppongi","Ryugasaki","Ryuo","Sabae","Sado","Saga-shi","Sagae","Sagamihara-shi","Saidaiji-naka","Saijo","Saikai","Saiki","Saitama","Sakado","Sakae","Sakai","Sakaidecho","Sakaiminato","Sakata","Saku","Sakura","Sakuracho","Sakurai","Sakurajima-koikecho","Sakurakabu","Sandacho","Sango","Sanjo","Sanmu","Sanno","Sannohe","Sano","Sanuki","Sapporo","Sarugakucho","Sasaguri","Sasayama","Sasebo","Satocho-sato","Satte","Sawara","Sayama","Sayo","Seiro","Sekicho-furumaya","Senboku","Sendai","Senju","Sennan","Senriyama","Senzoku","Seta","Setagaya-ku","Seto","Settsu","Shiba-Kaigandori","Shibadaimon","Shibata","Shibaura","Shibukawa","Shichibancho","Shijonawate","Shikamaku-miya","Shiki","Shima","Shimabara","Shimada","Shimizukoji","Shimizumachi","Shimo-iino","Shimoda","Shimogo","Shimomeguro","Shimonoseki","Shimotoda","Shimotsucho-kominami","Shimotsuke","Shin","Shin-shigai","Shinagawa","Shingu","Shinjo","Shinjuku","Shinkawa","Shinmachi","Shinshiro","Shinshuku","Shinsuka","Shiobaru","Shiogama","Shiojiri","Shioya","Shirakawa-machi","Shiraoka","Shirayamamachi","Shiretoko","Shiroi","Shiroishi","Shirokane","Shisui","Shitama","Shizukuishi","Shizunai-misono","Shizuoka","Shobara","Shobusawa","Shoinmachi-koji","Shonaicho","Showa","Shuchi","Sodegaura","Sogabe-minamijo","Soja","Soka","Sone","Sonobe","Subashiri","Suda","Suginomecho","Sugito","Sugiyama","Suigetsu","Suijo","Suita","Sukagawa","Sukumo","Sumidacho","Sumiyocho-kawauchi","Sumiyoshi","Sumoto","Susaki","Susami","Susono","Suwa","Suzaka","Suzuka","Tachibana","Tadotsu","Taga","Tagajo-shi","Tagawa","Tahara","Taiji","Taiki","Tainoura","Tajimi","Tajiri","Takahama","Takahashi","Takaishi","Takaiwa","Takajo","Takajomachi","Takamatsu","Takamori","Takanawa","Takaoka","Takara","Takarazuka","Takasagocho-takasemachi","Takasaki","Takase","Takashima","Takasu","Takata","Takatsuki","Takayama","Takedamachi","Takemiya","Takeo","Taketoyo","Takicho-oda","Takikawa","Takinogawa","Tama","Tamachi","Tamagawa","Tamana","Tamano","Tamashima","Tamatsukuri","Tamura","Tanabe","Tanaka","Taniyama-chuo","Tanushimarumachi-sugawara","Tashima","Tashiro","Tatebayashi","Tateyama","Tatsumi","Tatsuno","Tatsunocho-tominaga","Tawaramoto","Teine-ku","Temma","Tendo","Tennojicho-kita","Tenri","Toba","Tobata","Tobe","Tobo","Tochigi","Togane","Toge","Togitsu","Tokai","Tokamachi","Toki","Tokiwa","Tokiwamachi-tokiwa","Tokoname","Tokorozawa","Tokushima","Tokuyama","Tokyo","Tomakomai","Tomioka","Tomisato","Tomiya","Tomo","Tomobe","Tonami","Tondabayashi","Tone","Tono","Toranomon","Toride","Toshima Mura","Tosu","Totsukacho","Tottori-shi","Towada","Toyama-shi","Toyo","Toyoake","Toyoda","Toyohashi","Toyohira-ku","Toyokawa","Toyonaka","Toyonomachi-toyono","Toyooka","Toyota","Tsu","Tsubame","Tsubata","Tsuchiara","Tsuchiura","Tsudanuma","Tsuhako","Tsukawaki","Tsukayama","Tsukuba","Tsukubamirai","Tsukumiura","Tsuru","Tsuruga","Tsurugashima","Tsurumi","Tsuruoka","Tsushima","Tsuyama","Ube","Uchimaru","Ueda, Nagano","Ueki","Ueno","Ueno-ebisumachi","Uenohara","Uji","Ujiie","Uki","Umeda","Uonuma","Uozu","Urasoe","Urayama","Urayasu","Ureshino","Uruma","Usa","Ushiku","Usuki","Utazu","Utsunomiya","Uwajima","Uwayama","Wadayama","Wajima","Wakamatsucho","Wakasa","Wakayama","Wakicho","Wakimachi","Wakkanai","Wako","Warabi-shi","Waseda","Watari","Yabase","Yabasehoncho","Yabu","Yabuki","Yachimata","Yachiyo","Yaese","Yahagi","Yahata","Yaita","Yaizu","Yakage","Yakuin-Horibata","Yakumo","Yamada","Yamadayu","Yamaga","Yamagata-shi","Yamaguchi","Yamakita","Yamanashi","Yamano","Yamashitacho","Yamato-Takada","Yamatomachi","Yamatomachi-mitsuai","Yamauchi","Yamawaki","Yamazaki","Yamazakicho-nakabirose","Yanagawa","Yanagi","Yanai","Yano","Yanocho-futatsugi","Yao","Yashima","Yashio-shi","Yasu-shi","Yasuda","Yasugicho","Yatsushiro","Yawata","Yodogawa","Yoichi","Yokaichiba","Yokkaichi","Yokogawa","Yokohama","Yokoo","Yokosuka","Yokotemachi","Yomitan Son","Yomogita","Yonago","Yoneyamacho-nishino","Yonezawa","Yorii","Yorishimacho","Yoshida","Yoshida-kasugacho","Yoshii","Yoshikawa","Yoshimi","Yoshino","Yotsukaido","Youkaichi","Yubari","Yufutsu","Yugawara","Yuge","Yuki","Yukuhashi","Yunoshima","Yurihonjo","Yutaka","Yuzawa","Zama","Zushi"]},"KE":{"id":"KE","name":"Kenya","timezones":["Africa/Nairobi"],"cities":["Bondo","Chuka","Eldoret","Kabete","Kaiboi","Karatina","Kiambu","Kikuyu","Kisii","Kisumu","Kitale","Kitui","Machakos","Maseno","Mbita","Mombasa","Nairobi","Nakuru","Sawa Sawa","Siaya","Thika","Turbo","Wote"]},"KG":{"id":"KG","name":"Kyrgyzstan","timezones":["Asia/Bishkek"],"cities":[]},"KH":{"id":"KH","name":"Cambodia","timezones":["Asia/Bangkok"],"cities":["Moung Roessei","Phnom Penh","Phumi Boeng (1)","Phumi Chhuk","Phumi Preah Haoh","Phumi Prei","Phumi Prek Mrinh","Phumi Siem Reab","Phumi Thmei","Phumi Thnal","Phumi Vott Phnum","Sihanoukville","Tuol Kok","Vott Kampong Svay"]},"KI":{"id":"KI","name":"Kiribati","timezones":["Pacific/Tarawa","Pacific/Enderbury","Pacific/Kiritimati"],"cities":[]},"KM":{"id":"KM","name":"Comoros","timezones":["Africa/Nairobi"],"cities":[]},"KN":{"id":"KN","name":"St Kitts & Nevis","timezones":["America/Port_of_Spain"],"cities":[]},"KP":{"id":"KP","name":"Korea (North)","timezones":["Asia/Pyongyang"],"cities":[]},"KR":{"id":"KR","name":"Korea (South)","timezones":["Asia/Seoul"],"cities":[]},"KW":{"id":"KW","name":"Kuwait","timezones":["Asia/Riyadh"],"cities":["Abraq Khaytan","Ad Dasmah","Ad Dawhah","Al Ahmadi","Al Farwaniyah","Al Shamiya","Ar Rawdah","As Salimiyah","Ash Shu`aybah","Ash Shuwaykh","Bayan","Hawalli","Janub as Surrah","Kayfan","Kuwait City","Salwa"]},"KY":{"id":"KY","name":"Cayman Islands","timezones":["America/Cayman"],"cities":["Bodden Town","Coral Gables","George Town","Newlands","Savannah","Spot Bay","West Bay"]},"KZ":{"id":"KZ","name":"Kazakhstan","timezones":["Asia/Almaty","Asia/Qyzylorda","Asia/Aqtobe","Asia/Aqtau","Asia/Oral"],"cities":["Aksay","Aksoran","Almaty","Aqtas","Aqtau","Astana","Atyrau","Baikonur","Dostyk","Dzhezkazgan","Ekibastuz","Esil","Karagandy","Kazakh","Kentau","Koktem","Kostanay","Kyzyl","Kyzylorda","Lomonosovka","Oral","Pavlodar","Petropavl","Qaraghandy","Qaskeleng","Ridder","Rudnyy","Semey","Serebryansk","Shymkent","Sonaly","Stepnogorsk","Taldyk","Taldykorgan","Talghar","Taraz","Temirtau","Turkestan","Uritskiy","Ust-Kamenogorsk","Vostok","Zyryanovsk"]},"LA":{"id":"LA","name":"Laos","timezones":["Asia/Bangkok"],"cities":[]},"LB":{"id":"LB","name":"Lebanon","timezones":["Asia/Beirut"],"cities":["Aaley","Adma","Ashrafiye","Baabda","Baalbek","Beirut","Broummana","Bsalim","Chekka","Dbaiye","Dik el Mehdi","Halba","Hboub","Sarba","Sidon","Tripoli","Yanar","Zgharta"]},"LC":{"id":"LC","name":"St Lucia","timezones":["America/Port_of_Spain"],"cities":[]},"LI":{"id":"LI","name":"Liechtenstein","timezones":["Europe/Zurich"],"cities":["Balzers","Bendern","Eschen","Gamprin","Mauren","Nendeln","Planken","Ruggell","Schaan","Schaanwald","Schellenberg","Triesen","Triesenberg","Vaduz"]},"LK":{"id":"LK","name":"Sri Lanka","timezones":["Asia/Colombo"],"cities":["Badulla","Battaramulla South","Biyagama","Boralesgamuwa South","Colombo","Dehiwala","Dehiwala-Mount Lavinia","Eppawala","Gampaha","Gangodawila North","Hekitta","Homagama","Kaduwela","Kandana","Kandy","Katubedda","Katunayaka","Kelaniya","Kohuwala","Maharagama","Makola South","Matale","Moratuwa","Nattandiya Town","Negombo","Nugegoda","Orugodawatta","Padukka","Pannipitiya","Peradeniya","Piliyandala","Ragama","Rajagiriya","Sri Jayewardenepura Kotte","Talapathpitiya","Wattala","Wellampitiya"]},"LR":{"id":"LR","name":"Liberia","timezones":["Africa/Monrovia"],"cities":[]},"LS":{"id":"LS","name":"Lesotho","timezones":["Africa/Johannesburg"],"cities":[]},"LT":{"id":"LT","name":"Lithuania","timezones":["Europe/Vilnius"],"cities":[]},"LU":{"id":"LU","name":"Luxembourg","timezones":["Europe/Luxembourg"],"cities":["Ahn","Alzingen","Bascharage","Beaufort","Beckerich","Beggen","Beidweiler","Belvaux","Berchem","Bereldange","Bergem","Bertrange","Bettembourg","Betzdorf","Bigonville","Bissen","Bivange","Bofferdange","Bonnevoie","Bourglinster","Bridel","Burmerange","Canach","Cap","Capellen","Colmar","Contern","Crauthem","Dalheim","Differdange","Dippach","Dudelange","Echternach","Ehnen","Ernster","Erpeldange-lez-Bous","Esch-sur-Alzette","Esch-sur-Sure","Ettelbruck","Foetz","Frisange","Godbrange","Goetzingen","Gonderange","Gosseldange","Gostingen","Grevenknapp","Grevenmacher","Grosbous","Hagen","Hautcharage","Heffingen","Heisdorf-sur-Alzette","Helmdange","Helmsange","Hersberg","Hesperange","Hobscheid","Hollerich","Holzem","Huncherange","Hunsdorf","Itzig","Junglinster","Kayl","Kehlen","Kleinbettingen","Koetschette","Lamadelaine","Larochette","Leudelange","Limpertsberg","Lintgen","Lorentzweiler","Luxembourg","Luxembourg-Kirchberg","Mamer","Medernach","Merl","Mersch","Mertert","Mondercange","Mondorf-les-Bains","Moutfort","Niedercorn","Noerdange","Nospelt","Oberanven","Oetrange","Olm","Pontpierre","Remerschen","Remich","Rodange","Roeser","Roodt-sur-Syre","Rumelange","Sandweiler","Sanem","Schieren","Schifflange","Schoos","Schouweiler","Schuttrange","Soleuvre","Steinfort","Steinsel","Strassen","Syren","Tetange","Tuntange","Uebersyren","Walferdange","Wasserbillig","Wolpert","Wormeldange"]},"LV":{"id":"LV","name":"Latvia","timezones":["Europe/Riga"],"cities":["Adazi","Agenskalns","Aizkraukle","Aizpute","Baldone","Balvi","Bauska","Brankas","Carnikava","Centrs","Daugavpils","Dobele","Durbe","Gulbene","Ilguciems","Izvalta","Jaunolaine","Jelgava","Kandava","Kolka","Lapmezciems","Liepa","Ludza","Madona","Malpils","Malta","Marupe","Mazsalaca","Ogre","Olaine","Ozolnieki","Pilsrundale","Priedkalne","Pure","Riga","Salaspils","Saldus","Sigulda","Smiltene","Stalgene","Talsi","Tukums","Valka","Valmiera","Varsava","Ventspils","Zasa","Zilupe"]},"LY":{"id":"LY","name":"Libya","timezones":["Africa/Tripoli"],"cities":["Benghazi","Misratah","Sabha","Tripoli","Zliten"]},"MA":{"id":"MA","name":"Morocco","timezones":["Africa/Casablanca"],"cities":["Afourer","Agadir","Ait Melloul","Al Hoceima","Assa","Benguerir","Beni Mellal","Berrechid","Casablanca","Deroua","El Gara","El Hajeb","El Jadida","Erfoud","Fes","Fkih Ben Salah","Kenitra","Khemisset","Khouribga","Ksar el Kebir","Larache","Mansour","Marrakesh","Mehediyah","Meknes","Mohammedia","Nador","Ouazzane","Oued Zem","Oujda","Oulad Teima","Rabat","Safi","Sefrou","Settat","Sidi Bennour","Sidi Slimane","Skhirat","Tahala","Tan-Tan","Tangier","Tarfaya","Taza","Temara","Tiflet","Tiznit","Touissite"]},"MC":{"id":"MC","name":"Monaco","timezones":["Europe/Monaco"],"cities":[]},"MD":{"id":"MD","name":"Moldova","timezones":["Europe/Chisinau"],"cities":[]},"ME":{"id":"ME","name":"Montenegro","timezones":["Europe/Belgrade"],"cities":["Budva","Crna Gora","Herceg Novi","Igalo","Kotor","Niksic","Pljevlja","Podgorica","Stari Bar","Ulcinj"]},"MF":{"id":"MF","name":"St Martin (French part)","timezones":["America/Port_of_Spain"],"cities":[]},"MG":{"id":"MG","name":"Madagascar","timezones":["Africa/Nairobi"],"cities":["Ambanja","Antananarivo","Antsirabe","Antsiranana","Fianarantsoa","Toamasina","Toliara"]},"MH":{"id":"MH","name":"Marshall Islands","timezones":["Pacific/Majuro","Pacific/Kwajalein"],"cities":[]},"MK":{"id":"MK","name":"Macedonia","timezones":["Europe/Belgrade"],"cities":["Berovo","Bitola","Bogdanci","Cair","Debar","Delcevo","Demir Hisar","Gevgelija","Gostivar","Ilinden","Kadino","Kavadarci","Kicevo","Kumanovo","Labunista","Lisice","Makedonska Kamenica","Negotino","Novo Selo","Ohrid","Prilep","Pripor","Probistip","Radovis","Shtip","Skopje","Struga","Strumica","Tetovo","Veles"]},"ML":{"id":"ML","name":"Mali","timezones":["Africa/Abidjan"],"cities":[]},"MM":{"id":"MM","name":"Myanmar (Burma)","timezones":["Asia/Rangoon"],"cities":[]},"MN":{"id":"MN","name":"Mongolia","timezones":["Asia/Ulaanbaatar","Asia/Hovd","Asia/Choibalsan"],"cities":["Altai","Arvayheer","Baruun-Urt","Bayangol","Bayanhongor","Cecerleg","Chihertey","Choyr","Dalandzadgad","Darhan","Han-Uul","Javhlant","Khovd","Mandalgovi","Ovoot","Saynshand","Toyrim","Ulaan-Uul","Ulan Bator","Uliastay","Undurkhaan"]},"MO":{"id":"MO","name":"Macau","timezones":["Asia/Macau"],"cities":[]},"MP":{"id":"MP","name":"Northern Mariana Islands","timezones":["Pacific/Guam"],"cities":[]},"MQ":{"id":"MQ","name":"Martinique","timezones":["America/Martinique"],"cities":["Case-Pilote","Ducos","Fort-de-France","Le Carbet","Le Diamant","Le Francois","Le Gros-Morne","Le Lamentin","Le Morne-Rouge","Le Robert","Les Trois-Ilets","Riviere-Salee","Saint-Esprit","Saint-Joseph","Sainte-Anne","Sainte-Luce","Sainte-Marie","Schoelcher"]},"MR":{"id":"MR","name":"Mauritania","timezones":["Africa/Abidjan"],"cities":[]},"MS":{"id":"MS","name":"Montserrat","timezones":["America/Port_of_Spain"],"cities":[]},"MT":{"id":"MT","name":"Malta","timezones":["Europe/Malta"],"cities":["Attard","Balzan","Bingemma","Birgu","Birkirkara","Bugibba","Cospicua","Dingli","Fgura","Floriana","Fontana","Ghajnsielem","Gharb","Ghasri","Ghaxaq","Gudja","Gzira","Hal Gharghur","Hamrun","Haz-Zebbug","Il-Madliena","Il-Pergla","Imsida","Imtarfa","Iz-Zebbiegh","Kirkop","L-Iklin","L-Iskorvit","Lija","Luqa","Manikata","Marsa","Marsalforn","Marsaskala","Marsaxlokk","Mdina","Mellieha","Mosta","Mqabba","Munxar","Nadur","Naxxar","Paola","Pembroke","Qormi","Qrendi","Rabat","Safi","Saint John","Saint Lawrence","Saint Lucia","Saint Venera","San Pawl il-Bahar","Sannat","Senglea","Siggiewi","Sliema","Swieqi","Tarxien","Valletta","Victoria","Xaghra","Xewkija","Zabbar","Zejtun","Zurrieq"]},"MU":{"id":"MU","name":"Mauritius","timezones":["Indian/Mauritius"],"cities":["Beau Bassin","Chemin Grenier","Ebene CyberCity","Floreal","Goodlands","Le Reduit","Port Louis","Port Mathurin","Quatre Bornes","Rose Hill","Saint Jean","Tamarin","Vacoas"]},"MV":{"id":"MV","name":"Maldives","timezones":["Indian/Maldives"],"cities":[]},"MW":{"id":"MW","name":"Malawi","timezones":["Africa/Maputo"],"cities":[]},"MX":{"id":"MX","name":"Mexico","timezones":["America/Mexico_City","America/Cancun","America/Merida","America/Monterrey","America/Matamoros","America/Mazatlan","America/Chihuahua","America/Ojinaga","America/Hermosillo","America/Tijuana","America/Santa_Isabel","America/Bahia_Banderas"],"cities":["Abasolo","Acambaro","Acambay","Acapulco","Acatic","Acatlan de Perez Figueroa","Acatzingo de Hidalgo","Acolman","Actopan","Acuna","Adolfo Lopez Mateos","Adolfo Ruiz Cortines","Agua Amarga","Agua Azul","Agua Dulce","Agua Prieta","Aguascalientes","Ahome","Ahualulco de Mercado","Ajijic","Alamo","Alamos","Aldama","Allende","Almada","Almoloya","Altamira","Altotonga","Alvaro Obregon Borough","Amado Nervo","Ameca","Amecameca de Juarez","Anahuac","Angamacutiro de la Union","Apan","Apaseo el Alto","Apaseo el Grande","Apatzingan","Apaxco de Ocampo","Apizaco","Apodaca","Arandas","Arcelia","Arizpe","Arriaga","Asuncion Ixtaltepec","Asuncion Nochixtlan","Atequiza","Atizapan","Atlacholoaya","Atlacomulco","Atlatlahucan","Atlixco","Atlzayanca","Atotonilco el Alto","Atoyac de Alvarez","Autlan de Navarro","Autopista Puebla Orizaba 185 (La Condusa)","Axochiapan","Azcapotzalco","Azteca","Badiraguato","Bahia de Kino","Baja California","Balancan de Dominguez","Bamoa","Banderas del Aguila","Banderilla","Barra de Navidad","Barranca de Santa Clara","Barrio de Mexico","Benito Juarez","Benito Juarez (Santa Elena)","Berriozabal","Boca del Rio","Brisas Barra de Suchiate","Bucerias","Cabo San Lucas","Cabos","Cadereyta","Cadereyta de Montes","Cadereyta Jimenez","Cajeme","Cajititlan","Camargo","Campeche","Campestre Tarimbaro","Cananea","Canatlan","Candelaria","Cardenas","Cardonal","Catemaco","Cazones de Herrera","Celaya","Centro","Cerritos","Chalco de Diaz Covarrubias","Chapala","Chetumal","Chiapa de Corzo","Chiapas","Chiautempan","Chiautla","Chicago","Chiconcuac","Chignahuapan","Chihuahua","Chilpancingo","Cholula","Ciudad Ayala","Ciudad Constitucion","Ciudad de Huajuapam de Leon","Ciudad de Villa de Alvarez","Ciudad del Carmen","Ciudad Hidalgo","Ciudad Lopez Mateos","Ciudad Madero","Ciudad Mendoza","Ciudad Nezahualcoyotl","Ciudad Sabinas","Ciudad Sahagun","Ciudad Valles","Ciudad Victoria","Coacalco","Coahuila","Coatepec","Coatzacoalcos","Coatzintla","Cocoyoc","Cocula","Colima","Colimas","Colon","Colonia","Colonia Benito Juarez","Colonia Cuauhtemoc","Colonia de Venado","Colonia Emiliano Zapata (Ejido Santiago Temoaya)","Colonia Guerrero (Los Guajes)","Colonia Hidalgo","Colonia la Presa (Ejido de Chapultepec)","Colonia Lopez Nelio (Las Palmas)","Colonia Madero (Madero)","Colonia Mexico","Colonia Miguel Aleman Valdez","Colonia Veracruz","Comalcalco","Compostela","Corregidora","Cortazar","Cosamaloapan de Carpio","Cosoleacaque","Coyoacan","Coyuca de Catalan","Cuajimalpa","Cuarta Brigada","Cuauhtemoc","Cuautepec","Cuautepec de Hinojosa","Cuautitlan","Cuautla","Cuautlancingo","Cuernavaca","Cuitlahuac","Cunduacan","Cutzamala de Pinzon","Cuyoaco","Dolores Hidalgo Cuna de la Independencia Nacional","Durango","Ecatepec de Morelos","Ejido de Otumba (Loma Bonita)","Ejido Distrito Federal","Ejido Santa Maria Tianguistenco (Ejido el Rosario)","El Alto Culiacan","El Carmen","El Colli","El Fuerte de Montes Claros","El Grullo","El Leon","El Mirador","El Ocotito","El Parque","El Potrero","El Rio","El Sabinal (San Pedro)","El Salto","El Sauz","El Tecuan","El Torreon","Emiliano Zapata","Empalme","Ensenada","Epazoyucan","Erongaricuaro","Escobedo","Escondida de lo Verde","Escuinapa de Hidalgo","Escuintla","Estado de Mexico","Estados Unidos","Ex-Hacienda Pantitlan","Ezequiel Montes","Florida","Fortin de las Flores","Fraccionamiento Iberica Calimaya","Francisco Castellanos","Francisco I. Madero","Fresnillo","Frontera","Garcia","Garza Garcia","General Escobedo","General Teran","Gomez Palacio","Graciano Sanchez","Granjas","Guadalajara","Guadalupe","Guadalupe Victoria","Guadalupito","Guamuchil","Guanajuato","Guasave","Guaymas","Gueramaro","Gustavo A. Madero Borough","Gutierrez Zamora","Hermosillo","Heroica Alvarado","Heroica Caborca","Heroica Coscomatepec de Bravo","Heroica Matamoros","Heroica Zitacuaro","Huandacareo","Huanimaro","Huatabampo","Huauchinango","Huehuetoca","Huejotzingo","Huejucar","Huichapan","Huimanguillo","Huimilpan","Huixquilucan","Huixtla","Hunucma","Iglesia Vieja","Ignacio Allende","Iguala de la Independencia","Insurgentes","Irapuato","Isla Holbox","Isla Mujeres","Ixmiquilpan","Ixtapa","Ixtapa-Zihuatanejo","Ixtapaluca","Ixtapan de la Sal","Ixtlahuaca de Villada","Ixtlahuacan del Rio","Ixtlan del Rio","Izamal","Iztacalco","Iztapalapa","Izucar de Matamoros","Jacobo","Jacona de Plancarte","Jala","Jalapa","Jalisco","Jalostotitlan","Jalpa","Jaltipan de Morelos","Jalupa","Jaumave","Jerez de Garcia Salinas","Jesus Carranza","Jesus del Monte","Jesus Maria","Jilotepec","Jimenez","Jiquilpan de Juarez","Jiquipilco","Jiutepec","Jocotepec","Jocotitlan","Jojutla","Jonacatepec de Leandro Valle","Jose Cardel","Juan","Juarez","Kanasin","Kilometro 32 Texcoco Lecheria","La Barca","La Canada","La Ciudad","La Cruz","La Florida","La Habana","La Herradura","La Isla","La Joya","La Moncada","La Paletena","La Paz","La Piedad","La Pista de Tizayuca","La Reforma","La Tapachula","La Union","La Victoria","Lagos de Moreno","Laredo","Las Americas","Las Cabanas (Colinas de los Angeles)","Las Canoras (Altiva)","Las Choapas","Las Delicias","Leon","Lerdo","Lerma","Leyva Solano","Libramiento Leon-Salamanca","Libres","Linares","Loma de los Cavazos (Maria de la Luz)","Loreto","Los Garzas","Los Mochis","Los Reyes","Los Reyes de Salgado","Los Sabinos","Luvianos","Macuspana","Madero","Magdalena de Kino","Magdalena Petlacalco","Magiscatzin","Malinalco","Manuel Avila Camacho","Manzanillo","Mariano Matamoros","Marquelia","Martinez de la Torre","Mazatecochco","Mazatepec","Mazatlan","Medellin de Bravo","Melchor","Melchor Muzquiz","Mendoza","Mexicali","Mexico City","Mextepec","Mier","Miguel Aleman","Miguel Hidalgo","Mina Mexico","Mineral","Mineral de la Reforma","Mineral del Chico","Mineral del Monte","Mixquiahuala de Juarez","Moctezuma","Monclova","Monte Leon","Montemorelos","Monterrey","Morelia","Morelos","Moroleon","Motozintla de Mendoza","Muna","Nacozari Viejo","Naucalpan","Navojoa","Navolato","Netzahualcoyotl","Nextlalpan","Nicolas Romero","Nogales","Noxtepec de Zaragoza (El Aguacate)","Nueva Italia de Ruiz","Nuevo Casas Grandes","Nuevo Coahuila","Nuevo Ideal","Nuevo Laredo","Nuevo Leon","Oaxaca","Oaxtepec","Ocotlan","Ocoyoacac","Ocozocoautla de Espinosa","Ojinaga","Ojo de Agua","Ojuelos de Jalisco","Orizaba","Oxkutzkab","Pabellon","Pabellon de Arteaga","Pachuca","Pachuca de Soto","Panotla","Pantanal","Paraiso","Paraje Nuevo","Parral","Paseos de Tecamac","Paso Real","Pastor Ortiz","Patzcuaro","Pedregal de Jerico","Pedro Escobedo","Pedro Meoqui","Pericos","Perote","Pesqueria","Petaquillas","Petatlan","Pichucalco","Piedras Negras","Playa del Carmen","Polanco","Poncitlan","Poza Rica Chacas","Poza Rica de Hidalgo","Primero de Mayo","Progreso","Prolongacion Avenida Mexico Norte","Puebla","Pueblo Hidalgo","Pueblo Juarez (La Magdalena)","Pueblo Viejo","Pueblo Yaqui","Puente de Ixtla","Puente Grande","Puerto Escondido","Puerto Mexico","Puerto Morelos","Puerto Vallarta","Purisima de Bustos","Purisima del Zapote","Puruandiro","Queseria","Quintana Roo","Quiroga","Ramos Arizpe","Rancho Xalnene","Rayon","Reforma (Madrigal 2da. Seccion)","Refractarios Guadalajara","Reyes de Vallarta","Reynosa","Rincon de Tamayo","Rio Blanco","Rio Bravo","Roma","Rosarito","Sahuayo de Morelos","Salamanca","Salina Cruz","Salinas de Hidalgo","Saltillo","Salvatierra","San Agustin","San Agustin (Salvador Alvarado)","San Agustin Altamirano","San Agustin Tlaxiaca","San Andres Cholula","San Andres Tuxtla","San Angel Inn","San Antonio","San Antonio la Isla","San Antonio Virreyes","San Bernardo","San Cristobal","San Felipe","San Felipe Torres Mochas [Ganaderia]","San Fernando","San Francisco","San Francisco Javier","San Gabriel","San Jeronimo de Juarez","San Jose del Valle","San Jose Iturbide","San Juan","San Juan Bautista Tuxtla","San Juan de Aragon","San Juan del Rio","San Luis","San Luis de la Paz","San Luis Soyatlan","San Martin de Camargo","San Martin Duraznos","San Martin Hidalgo","San Martin Notario","San Martin Texmelucan de Labastida","San Mateo","San Mateo Atenco","San Mateo Mexicaltzingo","San Miguel","San Miguel Balderas","San Miguel de Allende","San Miguel de Atotonilco","San Miguel de Cozumel","San Miguel de Papasquiaro","San Miguel el Alto","San Miguel el Alto (El Puerto)","San Miguel Zinacantepec","San Nicolas","San Nicolas Totolapan","San Pablo Hidalgo","San Patricio","San Pedro","San Pedro Cholula","San Pedro de Las Colonias","San Pedro de Nolasco","San Pedro Piedra Gorda","San Pedro Pochutla","San Rafael","San Salvador Atenco","San Salvador Huixcolotla","San Salvador Tzompantepec","San Sebastian el Grande","San Sebastian Tutla","San Sebastian Xhala","San Simon de Guerrero","San Vicente","San Vicente Chicoloapan","Santa Anita","Santa Apolonia","Santa Catalina","Santa Catarina","Santa Catarina Juquila","Santa Fe","Santa Isabel Tlanepantla","Santa Lucia","Santa Maria Chimalhuacan","Santiago","Santiago de Queretaro","Santiago Ixcuintla","Santiago Tianguistenco","Satelite","Seccion Primera Santiago Tetla","Selene","Sierra Madre","Silao","Sinaloa de Leyva","Sombrerete","Sonora","Soto la Marina","Suchiapa","Tabasco","Tablon Grande (Bombas de Apaxco)","Tacambaro de Codallos","Tacotalpa","Tala","Tamaulipas","Tamazula de Gordiano","Tampico","Tampico Alto","Tangancicuaro de Arista","Tapachula","Tapalpa","Taxco","Teapa","Tecalitlan","Tecamachalco","Tecate","Tecax","Tecoman","Tecuala","Tejupilco de Hidalgo","Tekoh","Teloloapan","Temascalcingo","Temascaltepec de Gonzalez","Temixco","Tenamaxtlan","Tenancingo de Degollado","Tenosique de Pino Suarez","Teoloyucan","Teotihuacan de Arista","Tepalcatepec","Tepeaca","Tepeapulco","Tepeji de Ocampo","Tepetlacolco","Tepetlapa","Tepic","Tepotzotlan","Tepoztlan","Tequila","Tequisistlan","Tequisquiapan","Tequixquiac","Texcoco","Tezonapa","Tezontepec","Tezontepec de Aldama","Tezoyuca","Tierra Blanca","Tierra Colorada","Tijuana","Tilzapotla","Tirindaro","Tizapan el Alto","Tlacolula de Matamoros","Tlacotalpan","Tlahuac","Tlahuelilpan","Tlajomulco de Zuniga","Tlalmanalco de Velazquez","Tlalnepantla","Tlalpan","Tlaltizapan","Tlanalapa","Tlapa de Comonfort","Tlapacoyan","Tlaquepaque","Tlaquiltenango","Tlatlauquitepec","Tlatlaya","Tlaxcala","Tlaxcalancingo","Tocatlan","Tocumbo","Todos Santos","Tolcayuca","Toluca","Tonala","Tonatico","Topolobampo","Tula de Allende","Tulancingo","Tultepec","Tultitlan","Tulum","Tuxpan","Tuxpan de Rodriguez Cano","Tuxtla","Uman","Union de Tula","Ures","Uriangato","Ursulo Galvan","Uruapan","Valladolid","Valle de Bravo","Valle de Santiago","Valle Hermoso","Valles","Venustiano Carranza","Veracruz","Vicente Guerrero","Victoria","Villa Cuauhtemoc Otzolotepec","Villa de Almoloya de Juarez","Villa de Costa Rica","Villa Garcia","Villa Hidalgo","Villa Nanchital","Villadiego","Villagran","Villahermosa","Visitacion","Vistahermosa de Negrete","Xalapa","Xalisco","Xochimilco","Xochitepec","Xonacatlan","Yanga","Yautepec","Yecapixtla","Yucatan","Yurecuaro","Yuriria","Zacapoaxtla","Zacapu","Zacatecas","Zacatelco","Zacatepec","Zacatlan","Zacualpan","Zacualtipan","Zamora","Zapopan","Zapotitlan de Vadillo","Zapotlan de Juarez","Zapotlanejo","Zaragoza","Zinapecuaro","Zitlala","Zongolica","Zumpango"]},"MY":{"id":"MY","name":"Malaysia","timezones":["Asia/Kuala_Lumpur","Asia/Kuching"],"cities":["Alor Gajah","Alor Star","Ampang","Ayer Itam","Ayer Tawar","Bachok","Bagan Serai","Bahau","Balik Pulau","Bandar","Bandar Baru Bangi","Bandar Tenggara","Bandar Tun Razak","Bangi","Banting","Baru","Batang Berjuntai","Batang Kali","Batu","Batu Arang","Batu Berendam","Batu Caves","Batu Feringgi","Batu Gajah","Batu Pahat","Bau","Bayan Lepas","Beaufort","Bedong","Bentung","Benut","Bidur","Bintulu","Bongawan","Broga","Bukit Asahan","Bukit Gambir","Bukit Kayu Hitam","Bukit Mertajam","Bukit Pasir","Bukit Rotan","Butterworth","Cameron Highlands","Changloon","Chemor","Cheras","Cukai","Cyberjaya","Damansara","Dengkil","Dungun","Durian Tunggal","Gebeng","Gelang Patah","Gemas","Genting","George Town","Gerik","Gopeng","Gua Musang","Gurun","Hulu Langat","Hutan Melintang","Inanam","Ipoh","Itam","Jasin","Jawi","Jelutong","Jenjarum","Jeram","Jerantut","Jertih","Jinjang","Jitra","Johor Bahru","Juasseh","Kajang","Kampar","Kampong Changkat","Kampong Kahang Batu Twenty-eight","Kampong Kemaman","Kampong Pasir Segambut","Kampung Ayer Keroh","Kampung Baharu Nilai","Kampung Batu Kikir","Kampung Batu Uban","Kampung Bota Kiri","Kampung Likas","Kampung Paya Simpang Empat Genting","Kampung Pekan Kechil Beranang","Kampung Tanjung Aru","Kampung Tasek","Kampung Teluk Baru","Kampung Teriang","Kamunting","Kangar","Kapar","Karak","Keningau","Kepala Batas","Kepong","Keramat Pulai","Kerling","Kertih","Ketereh","Klang","Kluang","Kompleks Sukan Tenom","Kota","Kota Baharu","Kota Belud","Kota Bharu","Kota Kinabalu","Kota Tinggi","Kuah","Kuala","Kuala Berang","Kuala Kangsar","Kuala Ketil","Kuala Klawang","Kuala Kubu Baharu","Kuala Lipis","Kuala Lumpur","Kuala Nerang","Kuala Pahang","Kuala Penyu","Kuala Pilah","Kuala Selangor","Kuala Terengganu","Kuang","Kuantan","Kubang Kerian","Kuching","Kulai","Kulim","Labis","Labu","Lahad Datu","Lahat","Langat","Layang Layang","Lenggeng","Lintang","Lukut","Lumut","Lunas","Machang","Malacca","Mantin","Marang","Masai","Masjid Tanah","Melaka Tengah","Melor","Membakut","Menggatal","Menglembu","Mentekab","Merbok","Merlimau","Miri","Muadzam Shah","Muar town","Mukah","Nibong Tebal","Padang Rengas","Padang Serai","Pandan","Pantai","Pantai Remis","Papar","Parit","Parit Buntar","Parit Raja","Pasir Gudang","Pasir Mas","Pasir Puteh","Pedas","Pekan","Penaga","Penampang","Pendang","Pengerang","Pengkalan Chepa","Pengkalan Kempas","Perai","Permatang Pauh","Petaling Jaya","Pontian Kechil","Port Dickson","Port Klang","Puchong Batu Dua Belas","Pudu","Pudu Ulu","Pulau Pinang","Pusing","Putrajaya","Ranau","Raub","Rawang","Rembau","Rengam","Rengit","Sabak Bernam","Sandakan","Sarikei","Seberang Jaya","Segamat","Selama","Semenyih","Semerah","Senggarang","Sentul","Sepang","Serdang","Seremban","Serendah","Seri Kembangan","Seri Manjung","Setapak","Shah Alam","Sibu","Simpang Empat","Simpang Pertang","Simpang Renggam","Simpang Tiga","Simunjan","Sitiawan","Slim River","Sungai Bakap","Sungai Besar","Sungai Besi","Sungai Buluh","Sungai Pelek","Sungai Petani","Sungai Puyu","Sungai Udang","Taiping","Taman Bukit Skudai","Taman Desa","Taman Kota Jaya","Taman Megah Ria","Taman Prai","Taman Senai","Taman Senawang Indah","Taman Seremban Jaya","Taman Sri Ampang","Tambunan","Tamparuli","Tampin","Tampoi","Tanah Merah","Tanah Merah New Village Site C","Tangkak","Tanjong","Tanjong Karang","Tanjong Malim","Tanjung","Tanjung Bunga","Tanjung Sepat","Tapah Road","Tasek Glugor","Tatau","Tawau","Teluk Intan","Teluk Panglima Garang","Temerluh","Temoh","Teriang","Teronoh","Tumpat","Ulu Tiram","Victoria"]},"MZ":{"id":"MZ","name":"Mozambique","timezones":["Africa/Maputo"],"cities":["Beira","Maputo","Matola","Mozambique","Nampula","Pemba","Quelimane","Tete"]},"NA":{"id":"NA","name":"Namibia","timezones":["Africa/Windhoek"],"cities":["Etunda","Grootfontein","Katima Mulilo","Keetmanshoop","Mpapuka","Olympia","Ondangwa","Ongwediva","Oranjemund","Oshakati","Otjiwarongo","Outapi","Swakopmund","Tsumeb","Walvis Bay","Windhoek"]},"NC":{"id":"NC","name":"New Caledonia","timezones":["Pacific/Noumea"],"cities":["Dumbea","Mont-Dore","Noumea","Nouville","Paita"]},"NE":{"id":"NE","name":"Niger","timezones":["Africa/Lagos"],"cities":[]},"NF":{"id":"NF","name":"Norfolk Island","timezones":["Pacific/Norfolk"],"cities":[]},"NG":{"id":"NG","name":"Nigeria","timezones":["Africa/Lagos"],"cities":["Aba","Abakaliki","Abeokuta","Abraka","Abuja","Ado-Ekiti","Adodo","Aganga","Agege","Agidingbi","Ajegunle","Ajuwon","Akure","Alimosho","Anambra","Apapa","Ayobo","Benin City","Birnin Kebbi","Bonny","Burutu","Bwari","Calabar","Chafe","Damaturu","Egbeda","Ekpoma","Enugu","Forum","Funtua","Ibadan","Ido","Ifako","Igando","Igueben","Ikeja","Ikorodu","Ikotun","Ile-Ife","Ilesa","Ilorin","Ipaja","Iseri-Oke","Isolo","Jalingo","Jos","Kaduna","Kano","Kebbi","Lagos","Lekki","Lokoja","Magodo","Makurdi","Maryland","Minna","Mogho","Mowe","Mushin","Nsukka","Obafemi","Obudu","Odau","Ojo","Ojota","Ondo","Onigbongbo","Orile Oshodi","Oshodi","Osogbo","Ota","Owerri","Oworonsoki","Port Harcourt","Shomolu","Suleja","Suru-Lere","Tara","Ughelli","Ungwan Madaki","Uyo","Warri","Yaba","Yola","Zaria"]},"NI":{"id":"NI","name":"Nicaragua","timezones":["America/Managua"],"cities":["Bluefields","Chinandega","El Panama","Esteli","Granada","Jinotega","Los Arados","Managua","Masaya","Matagalpa","Ocotal","Rivas","San Juan del Sur"]},"NL":{"id":"NL","name":"Netherlands","timezones":["Europe/Amsterdam"],"cities":["Aagtekerke","Aalburg","Aalden","Aalsmeer","Aalsmeerderbrug","Aalst","Aalten","Aardenburg","Abbekerk","Abbenes","Abcoude","Achterberg","Achterveld","Achthuizen","Achtmaal","Aduard","Aerdenhout","Aerdt","Afferden","Akersloot","Akkrum","Albergen","Alblasserdam","Alde Leie","Alem","Alkmaar","Almelo","Almere","Almere Haven","Almkerk","Alphen","Alphen aan den Rijn","Ameide","America","Amerongen","Amersfoort","Ammerstol","Ammerzoden","Amstelhoek","Amstelveen","Amstenrade","Amsterdam","Anderen","Andijk","Ane","Angeren","Anjum","Ankeveen","Anloo","Anna Paulowna","Annen","Apeldoorn","Appelscha","Appeltern","Appingedam","Arcen","Arkel","Arnemuiden","Arnhem","Asperen","Assen","Assendelft","Asten","Augustinusga","Avenhorn","Axel","Baambrugge","Baarland","Baarle-Nassau","Baarlo","Baarn","Baars","Babberich","Badhoevedorp","Baexem","Bakel","Baken","Bakhuizen","Balgoij","Balk","Ballum","Banholt","Barchem","Barendrecht","Barneveld","Batenburg","Bathmen","Bavel","Bedum","Beegden","Beek","Beekbergen","Beerta","Beerzerveld","Beesd","Beesel","Beets","Beetsterzwaag","Beilen","Beinsdorp","Belfeld","Bellingwolde","Bemelen","Bemmel","Beneden-Leeuwen","Bennebroek","Bennekom","Benningbroek","Benthuizen","Berg","Berg en Dal","Bergambacht","Bergeijk","Bergen","Bergen op Zoom","Bergentheim","Bergharen","Berghem","Bergschenhoek","Beringe","Berkenwoude","Berkhout","Berlicum","Best","Beugen","Beuningen","Beusichem","Beverwijk","Biddinghuizen","Bierum","Biervliet","Biest","Bilthoven","Bitgum","Bladel","Blaricum","Bleiswijk","Blerick","Bleskensgraaf","Blitterswijck","Bloemendaal","Blokker","Blokzijl","Bocholtz","Bodegraven","Boeicop","Boekel","Boelenslaan","Boerakker","Boesingheliede","Bolsward","Borculo","Borger","Born","Borne","Borsele","Bosch en Duin","Boskoop","Bosschenhoofd","Bourtange","Boven-Hardinxveld","Boven-Leeuwen","Bovenkarspel","Bovensmilde","Boxmeer","Boxtel","Brakel","Breda","Bredevoort","Breezand","Breskens","Breugel","Breukelen","Breukeleveen","Brielle","Briltil","Britsum","Broek in Waterland","Broek op Langedijk","Broekhin","Broekhuizen","Brouwershaven","Bruchem","Brucht","Bruinisse","Brummen","Brunssum","Buchten","Budel","Budel-Dorplein","Budel-Schoot","Buinerveen","Buitenkaag","Buitenpost","Bunde","Bunnik","Bunschoten","Buren","Burgerveen","Burgum","Burgwerd","Burum","Bussum","Buurse","Cadier en Keer","Cadzand","Callantsoog","Capelle aan den IJssel","Castricum","Centrum","Chaam","Clinge","Coevorden","Colijnsplaat","Colmschate","Craailo","Cromvoirt","Cruquius","Cuijk","Culemborg","Daarle","Dalen","Dalfsen","Damwald","De Bilt","De Blesse","De Cocksdorp","De Falom","De Glind","De Goorn","De Hoef","De Horst","De Klomp","De Koog","De Kwakel","De Lier","De Lutte","De Meern","De Moer","De Punt","De Rijp","De Steeg","De Waal","De Westereen","De Wijk","De Wilp","De Zilk","Dedemsvaart","Deest","Delden","Delfgauw","Delft","Delfzijl","Den Bommel","Den Burg","Den Deijl","Den Dolder","Den Dungen","Den Helder","Den Hoorn","Den Hout","Den Ilp","Den Oever","Denekamp","Deurne","Deventer","Didam","Diemen","Diepenheim","Diepenveen","Dieren","Diessen","Dieteren","Diever","Dijk","Dinteloord","Dinxperlo","Dirkshorn","Dirksland","Dodewaard","Doenrade","Doesburg","Doetinchem","Dokkum","Domburg","Dongen","Doorn","Doornenburg","Doornspijk","Doorwerth","Dordrecht","Dorp","Dorst","Drachten","Drempt","Dreumel","Driebergen","Driebruggen","Driehuis","Driel","Driemond","Drogeham","Dronryp","Dronten","Drunen","Druten","Duin","Duiven","Duivendrecht","Dwingeloo","Earnewald","Echt","Echten","Echtenerbrug","Eckart","Edam","Ede","Ederveen","Eede","Eefde","Eelde-Paterswolde","Eelderwolde","Eemnes","Eenrum","Eerbeek","Eersel","Eethen","Eext","Eexterzandvoort","Egchel","Egmond aan Zee","Egmond-Binnen","Eibergen","Eijsden","Eindhoven","Einighausen","Elburg","Ell","Ellecom","Elsendorp","Elsloo","Elst","Emmeloord","Emmen","Emmer-Compascuum","Emst","Engelen","Enkhuizen","Ens","Enschede","Enschot","Enspijk","Enter","Enumatil","Epe","Epen","Epse","Erica","Erichem","Erm","Ermelo","Erp","Escharen","Espel","Etten","Everdingen","Ewijk","Exloo","Eygelshoven","Eys","Ezinge","Farmsum","Feanwalden","Ferwert","Fijnaart","Finsterwolde","Fleringen","Fluitenberg","Flushing","Foxhol","Franeker","Frederiksoord","Gaanderen","Galder","Gameren","Gapinge","Garderen","Garmerwolde","Garsthuizen","Garyp","Gasselte","Gasselternijveen","Geertruidenberg","Geervliet","Gees","Geesteren","Geldermalsen","Geldrop","Geleen","Gelselaar","Gemeente Rotterdam","Gemert","Gemonde","Genderen","Gendringen","Gendt","Genemuiden","Gennep","Giesbeek","Giessenburg","Giessendam","Gieten","Gieterveen","Giethoorn","Gilze","Glimmen","Goes","Goirle","Goor","Gorinchem","Gorredijk","Gorssel","Gouda","Gouderak","Goudswaard","Goutum","Gramsbergen","Grashoek","Grathem","Grave","Greup","Grijpskerk","Groeningen","Groenlo","Groenveld","Groesbeek","Groessen","Groet","Groningen","Gronsveld","Groot-Agelo","Groot-Ammers","Grootebroek","Grootegast","Grou","Grubbenvorst","Gulpen","Guttecoven","Gytsjerk","Haaften","Haaksbergen","Haalderen","Haamstede","Haaren","Haarle","Haarlem","Haarlemmerliede","Haelen","Halfweg","Halle","Hallum","Halsteren","Hank","Hantum","Hantumhuizen","Hapert","Haps","Hardenberg","Harderwijk","Haren","Harich","Harkema","Harkstede","Harlingen","Harmelen","Hartwerd","Hasselt","Hattem","Haule","Haulerwijk","Hauwert","Havelte","Hazerswoude-Dorp","Hazerswoude-Rijndijk","Hedel","Heeg","Heelsum","Heemskerk","Heemstede","Heenvliet","Heerde","Heerenveen","Heerhugowaard","Heerjansdam","Heerle","Heerlen","Heesch","Heeswijk","Heeswijk-Dinther","Heeten","Heeze","Heijen","Heijningen","Heikant","Heilig Landstichting","Heiloo","Heinenoord","Heino","Hekelingen","Helden","Helenaveen","Hellendoorn","Hellevoetsluis","Hellouw","Helmond","Helvoirt","Hem","Hemelum","Hendrik-Ido-Ambacht","Hengelo","Hengevelde","Hennaard","Hensbroek","Herbaijum","Herkenbosch","Herkingen","Hernen","Herpen","Herten","Herveld","Herwijnen","Heteren","Heukelum","Heusden","Heveadorp","Heythuysen","Hierden","Hijken","Hillegom","Hilvarenbeek","Hilversum","Hindeloopen","Hippolytushoef","Hoedekenskerke","Hoek","Hoek van Holland","Hoenderloo","Hoensbroek","Hoevelaken","Hoge Donk","Hollandsche Rading","Hollandscheveld","Hollum","Holten","Holthees","Holthone","Holtum","Holwierde","Homoet","Honselersdijk","Hoofddorp","Hoofdplaat","Hoogblokland","Hooge Zwaluwe","Hoogeloon","Hoogerheide","Hoogersmilde","Hoogeveen","Hoogezand","Hooghalen","Hoogkarspel","Hoogkerk","Hoogland","Hooglanderveen","Hoogmade","Hoogvliet","Hoogwoud","Hoorn","Hoornaar","Horn","Horst","Hout","Houtakker","Houten","Huijbergen","Huis ter Heide","Huissen","Huizen","Hulsberg","Hulshorst","Hulst","Hummelo","Hurdegaryp","IJhorst","IJlst","IJmuiden","IJsselmuiden","IJsselstein","IJzendijke","IJzendoorn","Ilpendam","Ingelum","Ingen","Ittervoort","Jabeek","Jisp","Joppe","Joure","Jubbega","Julianadorp","Jutrijp","Kaag","Kaatsheuvel","Kalenberg","Kamerik","Kampen","Kamperland","Kantens","Kapelle","Kats","Katwijk","Katwijk aan Zee","Katwoude","Keijenborg","Kekerdom","Keldonk","Kerk-Avezaath","Kerkdriel","Kerkenveld","Kerkrade","Kessel","Kesteren","Kimswerd","Kinderdijk","Klaaswaal","Klazienaveen","Klimmen","Kloetinge","Kloosterhaar","Klundert","Kockengen","Koedijk","Koekange","Koewacht","Kolham","Kolhorn","Kollum","Kommerzijl","Koog aan de Zaan","Kootstertille","Kootwijkerbroek","Kortenhoef","Kortgene","Koudekerk aan den Rijn","Koudekerke","Koudum","Kraggenburg","Krimpen aan de Lek","Krimpen aan den IJssel","Krommenie","Kropswolde","Kruiningen","Kruisland","Kudelstaart","Kuitaart","Kwintsheul","Laag-Soeren","Lage Mierde","Lage Zwaluwe","Landsmeer","Langedijk","Langezwaag","Laren","Lathum","Leek","Leerdam","Leersum","Leeuwarden","Legemeer","Leiden","Leiderdorp","Leidschendam","Leimuiden","Lekkerkerk","Lelystad","Lemele","Lemelerveld","Lemiers","Lemmer","Lent","Lettele","Leusden","Leuth","Lewenborg","Lexmond","Lichtenvoorde","Liempde","Lienden","Lies","Lieshout","Liessel","Lievelde","Lijnden","Limbricht","Limmel","Limmen","Linne","Linschoten","Lippenhuizen","Lisse","Lithoijen","Lobith","Lochem","Loenen","Loon op Zand","Loosdrecht","Loozen","Lopik","Loppersum","Losser","Lottum","Lunteren","Lutjebroek","Lutjewinkel","Lutten","Luyksgestel","Maarheeze","Maarn","Maarssen","Maarssenbroek","Maartensdijk","Maasbommel","Maasbracht","Maasbree","Maasdam","Maasdijk","Maashees","Maaskantje","Maasland","Maassluis","Maastricht","Made","Makkum","Malden","Manderveen","Margraten","Marienberg","Markelo","Marknesse","Marrum","Marum","Mastenbroek","Maurik","Mechelen","Medemblik","Meeden","Meer","Meerkerk","Meerlo","Meerssen","Meeuwen","Megchelen","Meijel","Melick","Meppel","Merkelbeek","Merselo","Middelbeers","Middelburg","Middelharnis","Middenbeemster","Middenmeer","Midlum","Mierlo","Mijdrecht","Mijnsheerenland","Mildam","Milheeze","Mill","Millingen","Millingen aan de Rijn","Milsbeek","Moerdijk","Moergestel","Moerkapelle","Molenaarsgraaf","Molenhoek","Molenschot","Monnickendam","Monster","Montfoort","Montfort","Mook","Mookhoek","Moordrecht","Mortel","Muiden","Muiderberg","Munstergeleen","Muntendam","Mussel","Naaldwijk","Naarden","Nederasselt","Nederhemert","Nederhorst den Berg","Nederweert","Neede","Neer","Neer-Andel","Nes","Netterden","Nibbixwoud","Nieuw-Amsterdam","Nieuw-Balinge","Nieuw-Beijerland","Nieuw-Bergen","Nieuw-Buinen","Nieuw-Dordrecht","Nieuw-Lekkerland","Nieuw-Namen","Nieuw-Schoonebeek","Nieuw-Vennep","Nieuw-Vossemeer","Nieuwdorp","Nieuwe Pekela","Nieuwe Wetering","Nieuwe-Niedorp","Nieuwe-Tonge","Nieuwegein","Nieuwehorne","Nieuwendijk","Nieuwer-Ter-Aa","Nieuwerbrug","Nieuwerkerk aan den IJssel","Nieuweschoot","Nieuwkoop","Nieuwkuijk","Nieuwlande","Nieuwleusen","Nieuwolda","Nieuwpoort","Nieuwstadt","Nieuwveen","Nigtevecht","Nijbroek","Nijhuizum","Nijkerk","Nijkerkerveen","Nijland","Nijmegen","Nijnsel","Nijverdal","Nistelrode","Noardburgum","Noorbeek","Noord-Scharwoude","Noord-Sleen","Noordbroek","Noordeloos","Noorden","Noordgouwe","Noordhorn","Noordlaren","Noordscheschut","Noordwelle","Noordwijk aan Zee","Noordwijk-Binnen","Noordwijkerhout","Noordwolde","Nootdorp","Norg","Nuenen","Nuis","Nuland","Numansdorp","Nunhem","Nunspeet","Nuth","Obbicht","Obdam","Ochten","Odijk","Oeffelt","Oegstgeest","Oene","Oijen","Oirsbeek","Oirschot","Oisterwijk","Oldeberkoop","Oldebroek","Oldeholtpade","Oldehove","Oldekerk","Oldemarkt","Oldenzaal","Olst","Ommen","Onnen","Ooij","Ooltgensplaat","Oost-Souburg","Oostburg","Oostendam","Oosterbeek","Oosterbierum","Oosterend","Oosterhesselen","Oosterhout","Oosterland","Oosternijkerk","Oosterwolde","Oosterzee","Oosthuizen","Oostkapelle","Oostvoorne","Oostwold","Oostwoud","Oostzaan","Ootmarsum","Op den Bosch","Opeinde","Ophemert","Opheusden","Opmeer","Oranje","Oranjewoud","Ospel","Oss","Ossendrecht","Oterleek","Otterlo","Ottersum","Oud-Ade","Oud-Alblas","Oud-Beijerland","Oud-Gastel","Oud-Zuilen","Ouddorp","Oude Pekela","Oude Wetering","Oude-Tonge","Oudega","Oudehaske","Oudehorne","Oudelande","Oudemirdum","Oudemolen","Oudenbosch","Oudendijk","Ouderkerk aan de Amstel","Oudeschild","Oudesluis","Oudewater","Oudkarspel","Oudorp","Oudwoude","Overasselt","Overberg","Overdinkel","Overloon","Overveen","Ovezande","Palemig","Pannerden","Panningen","Papekop","Papendrecht","Partij","Paterswolde","Peize","Pernis","Petten","Philippine","Piershil","Pieterburen","Pieterzijl","Pijnacker","Pingjum","Plasmolen","Poeldijk","Poortugaal","Poortvliet","Posterholt","Princenhof","Prinsenbeek","Puiflijk","Purmerend","Purmerland","Puth","Putte","Putten","Puttershoek","Raalte","Raamsdonksveer","Randwijk","Ravenstein","Ravenswoud","Reeuwijk","Rekken","Renesse","Renkum","Renswoude","Ressen","Retranchement","Reusel","Reuver","Rheden","Rhenen","Rhenoy","Rhoon","Ridderkerk","Riethoven","Rietveld","Rijckholt","Rijen","Rijkevoort","Rijnsburg","Rijpwetering","Rijsbergen","Rijsenhout","Rijssen","Rijswijk","Rilland","Rinsumageast","Rips","Rivierenwijk","Rixtel","Rockanje","Roden","Rodenrijs","Roelofarendsveen","Roermond","Roggel","Rolde","Roodeschool","Roosendaal","Roosteren","Rooth","Rosmalen","Rossum","Rotterdam","Rottum","Rozenburg","Rozendaal","Rucphen","Ruinen","Ruinerwold","Rutten","Ruurlo","s-Heerenberg","Saasveld","Sambeek","Santpoort-Noord","Sappemeer","Sas van Gent","Sassenheim","Schagen","Schagerbrug","Schaijk","Schalkhaar","Scharmer","Scheemda","Schellinkhout","Schermerhorn","Scherpenisse","Scherpenzeel","Schiedam","Schiermonnikoog","Schijndel","Schildwolde","Schimmert","Schin op Geul","Schinnen","Schinveld","Schipborg","Schipluiden","Schoondijke","Schoonebeek","Schoonhoven","Schoorl","Schore","Sellingen","Serooskerke","Sevenum","Sibculo","Siddeburen","Siebengewald","Silvolde","Simpelveld","Sint Agatha","Sint Annaland","Sint Annaparochie","Sint Anthonis","Sint Hubert","Sint Jansteen","Sint Joost","Sint Maarten","Sint Maartensdijk","Sint Nicolaasga","Sint Odilienberg","Sint Pancras","Sint Philipsland","Sint Willebrord","Sint-Michielsgestel","Sint-Oedenrode","Sintjohannesga","Sittard","Slagharen","Sleen","Sleeuwijk","Slenaken","Sliedrecht","Slijk-Ewijk","Slochteren","Slootdorp","Sloterdijk","Sluis","Sluiskil","Smilde","Sneek","Soerendonk","Soest","Soesterberg","Someren","Sommelsdijk","Son en Breugel","Spaarndam","Spakenburg","Spanbroek","Spaubeek","Spierdijk","Spijk","Spijkenisse","Sprang","Sprundel","Stadskanaal","Stampersgat","Staphorst","Stationsbuurt","Stedum","Steenbergen","Steensel","Steenwijk","Steggerda","Steijl","Stein","Stellendam","Sterksel","Stevensbeek","Stevensweert","Stiens","Stolwijk","Stompetoren","Stompwijk","Stoutenburg","Strijen","Strijensas","Stroe","Stuifzand","Sumar","Surhuisterveen","Surhuizum","Susteren","Suwald","Swalmen","Sweikhuizen","Swifterbant","Taarlo","Tegelen","Ten Boer","Ten Post","Ter Aar","Ter Apel","Ter Apelkanaal","Terblijt","Terborg","Terheijden","Terneuzen","Terschuur","Teteringen","The Hague","Tholen","Tiel","Tienhoven","Tienraij","Tijnje","Tilburg","Tilligte","Tinte","Tjerkwerd","Tolbert","Toldijk","Tolkamer","Tricht","Tubbergen","Tuitjenhorn","Tull","Tweede Exloermond","Tweede Valthermond","Twello","Twijzelerheide","Twisk","Tynaarlo","Tytsjerk","Tzummarum","Uddel","Uden","Udenhout","Ugchelen","Uitdam","Uitgeest","Uithoorn","Uithuizen","Uithuizermeeden","Uitwellingerga","Ulestraten","Ulft","Ulicoten","Ulrum","Ulvenhout","Ureterp","Urk","Urmond","Ursem","Utrecht","Vaals","Vaassen","Valburg","Valkenburg","Valkenswaard","Valthe","Valthermond","Varik","Varsseveld","Vasse","Veen","Veendam","Veenendaal","Veenhuizen","Veenoord","Veghel","Velddriel","Velden","Veldhoven","Velp","Velsen","Velsen-Noord","Ven-Zelderheide","Venhorst","Venhuizen","Venlo","Venray","Vianen","Vierhouten","Vierlingsbeek","Vierpolders","Vijfhuizen","Vilt","Vinkeveen","Vlaardingen","Vlagtwedde","Vledder","Vleuten","Vlieland","Vlijmen","Vlodrop","Voerendaal","Vogelenzang","Vogelwaarde","Volendam","Volkel","Voorburg","Voorhout","Voorschoten","Voorst","Voorthuizen","Vorden","Vorstenbosch","Vortum-Mullem","Vragender","Vreeland","Vries","Vriezenveen","Vroomshoop","Vrouwenpolder","Vught","Vuren","Waalre","Waalwijk","Waardenburg","Waarder","Waarland","Waddinxveen","Wagenberg","Wagenborgen","Wageningen","Walterswald","Wamel","Wanroij","Wanssum","Wapenveld","Warder","Warffum","Warmenhuizen","Warmond","Warnsveld","Waspik","Wassenaar","Wateringen","Waterland","Weerselo","Weert","Weesp","Wehl","Weidum","Well","Wellerlooi","Wemeldinge","Werkendam","Werkhoven","Wervershoof","Wessem","West-Knollendam","West-Terschelling","Westbeemster","Westbroek","Westdorpe","Westerbork","Westerhaar-Vriezenveensewijk","Westerhoven","Westervoort","Westerwijtwerd","Westkapelle","Westmaas","Westzaan","Weurt","Wezep","Wierden","Wieringerwaard","Wieringerwerf","Wierum","Wijchen","Wijckel","Wijdenes","Wijdewormer","Wijhe","Wijk aan Zee","Wijk bij Duurstede","Wijlre","Wijnaldum","Wijnandsrade","Wijngaarden","Wijster","Wildervank","Willemstad","Wilnis","Wilp","Winkel","Winschoten","Winssen","Winsum","Wintelre","Winterswijk","Wissenkerke","Witharen","Wittem","Witteveen","Woensdrecht","Woerden","Woerdense Verlaat","Wognum","Wolfheze","Wolphaartsdijk","Woltersum","Wolvega","Wommels","Wons","Workum","Wormer","Wormerveer","Woubrugge","Woudenberg","Woudrichem","Woudsend","Wouwsche Plantage","Yde","Yerseke","Ysbrechtum","Zaamslag","Zaandam","Zaandijk","Zaanstad","Zalk","Zaltbommel","Zandeweer","Zandvoort","Zeddam","Zeeland","Zeerijp","Zeewolde","Zeist","Zelhem","Zetten","Zevenaar","Zevenbergen","Zevenbergschen Hoek","Zevenhoven","Zevenhuizen","Zierikzee","Zieuwent","Zijderveld","Zoetermeer","Zoeterwoude","Zonnemaire","Zorgvlied","Zoutelande","Zoutkamp","Zuid-Beijerland","Zuid-Scharwoude","Zuidbroek","Zuidermeer","Zuiderpark","Zuidhorn","Zuidland","Zuidlaren","Zuidoostbeemster","Zuidwolde","Zuidzande","Zuilichem","Zundert","Zutphen","Zwaag","Zwaagdijk-Oost","Zwaanshoek","Zwanenburg","Zwartebroek","Zwartemeer","Zwartewaal","Zwartsluis","Zwijndrecht","Zwinderen","Zwolle"]},"NO":{"id":"NO","name":"Norway","timezones":["Europe/Oslo"],"cities":["Abelvaer","Adalsbruk","Adland","Agotnes","Agskardet","Aker","Akkarfjord","Akrehamn","Al","Alen","Algard","Almas","Alta","Alvdal","Amli","Amot","Ana-Sira","Andalsnes","Andenes","Angvika","Ankenes","Annstad","Ardal","Ardalstangen","Arendal","Arland","Arneberg","Arnes","Aros","As","Asen","Aseral","Asgardstrand","Ask","Asker","Askim","Aukra","Auli","Aurdal","Aure","Aursmoen","Austbo","Austbygdi","Austevoll","Austmarka","Baerums verk","Bagn","Balestrand","Ballangen","Ballstad","Bangsund","Barkaker","Barstadvik","Batnfjordsora","Batsto","Beisfjord","Beitostolen","Bekkjarvik","Berge","Bergen","Berger","Berkak","Birkeland","Birtavarre","Bjaland","Bjerka","Bjerkvik","Bjoneroa","Bjordal","Bjorke","Bjorkelangen","Bjornevatn","Blaker","Blakset","Bleikvasslia","Bo","Bomlo","Bones","Borge","Borgen","Borhaug","Borkenes","Borregard","Bostad","Bovagen","Boverfjorden","Brandbu","Brandval","Brattholmen","Brattvag","Brekke","Brekstad","Brennasen","Brevik","Bronnoysund","Bru","Bruflat","Brumunddal","Brusand","Bruvik","Bryne","Bud","Burfjord","Buskerud","Buvika","Byglandsfjord","Bygstad","Bykle","Byrknes Nordre","Cavkkus","Dal","Dale","Dalen","Davik","Deknepollen","Digermulen","Dilling","Dimmelsvik","Dirdal","Disena","Dokka","Dolemo","Dovre","Drag","Drammen","Drangedal","Drobak","Dverberg","Dyrvika","Ebru","Egersund","Eggedal","Eggkleiva","Eide","Eidfjord","Eidsa","Eidsberg","Eidsdal","Eidsfoss","Eidsnes","Eidsvag","Eidsvoll","Eidsvoll verk","Eikanger","Eikelandsosen","Eiken","Eina","Eivindvik","Elverum","Enebakkneset","Enga","Engalsvik","Erdal","Erfjord","Ervik","Espeland","Etne","Evanger","Evenskjer","Evje","Eydehavn","Faberg","Faervik","Fagernes","Fagerstrand","Fall","Fardal","Farsund","Fauske","Feda","Fedje","Feiring","Felle","Fenstad","Fetsund","Fevik","Figgjo","Finnoy","Finnsnes","Finsand","Fiska","Fiskum","Fister","Fitjar","Fjellstrand","Fla","Flam","Flateby","Flekke","Flekkefjord","Flemma","Flesberg","Flesnes","Floro","Florvag","Foldereid","Folderoy","Folkestad","Follafoss","Follebu","Follese","Fonnes","Forde","Fornebu","Fosnavag","Fossdalen","Fosser","Fotlandsvag","Fredrikstad","Frekhaug","Fresvik","Frogner","Froland","From","Furnes","Fyrde","Fyresdal","Gan","Gardermoen","Gargan","Garnes","Gasbakken","Gaupen","Geilo","Geithus","Gjerdrum","Gjerstad","Gjolme","Glesvaer","Glomfjord","Godoy","Godvik","Gol","Gran","Gransherad","Granvin","Gratangen","Gravdal","Greaker","Grendi","Gressvik","Grimstad","Groa","Grong","Grua","Gullaug","Gvarv","Haddal","Haegeland","Haerland","Hagan","Hagavik","Hakadal","Halden","Hallingby","Halsa","Haltdalen","Hamar","Hamarvik","Hammerfest","Hansnes","Haram","Hareid","Harstad","Haslum","Hasvik","Hatlestranda","Hauge","Haugesund","Haukeland","Havik","Hebnes","Hedal","Heggedal","Heggenes","Hegra","Heimdal","Helgeland","Helgeroa","Hell","Hellandsjoen","Helleland","Hellesylt","Hellvik","Hemnes","Hemnesberget","Hemnskjela","Hemsedal","Henningsvaer","Herand","Heroysund","Herre","Hersaeter","Hestvika","Hetlevik","Hildre","Hitra","Hjellestad","Hjelmas","Hjelset","Hjorungavag","Hof","Hokkasen","Hokksund","Hol","Hole","Holen","Holmefjord","Holmen","Holmenkollen","Holmestrand","Holsen","Holter","Hommelvik","Hommersak","Honefoss","Hordvik","Hornnes","Horte","Horten","Hov","Hovag","Hovden","Hovet","Hovik verk","Hovin","Hoyanger","Hundven","Hunndalen","Husoy","Hustad","Hvalstad","Hvam","Hvitsten","Hvittingfoss","Hyggen","Hylkje","Hyllestad","Ikornnes","Indre Arna","Indre Billefjord","Indre Klubben","Indre Ulvsvag","Indreby","Innbygda","Inndyr","Innvik","Isdalsto","Ise","Ivgobahta","Jakobselv","Jar","Jaren","Jessheim","Jevnaker","Jomna","Jorpeland","Kabelvag","Kaldfarnes","Kalvag","Kamben","Karasjok","Karlshus","Kaupanger","Kautokeino","Kirkenaer","Kirkenes","Kjeller","Kjellmyra","Kjerstad","Kjollefjord","Kjopsvik","Kleive","Klepp","Kleppe","Kleppesto","Kleppstad","Klofta","Klokkarvik","Knapper","Knappstad","Knarrevik","Knarrlaget","Kolbjornsvik","Kolbotn","Kolbu","Kolltveit","Kolnes","Kolsas","Kolvereid","Kongsberg","Kongshamn","Kongsvika","Kongsvinger","Konsmo","Konsvikosen","Kopervik","Koppang","Korgen","Kornsjo","Korsvegen","Kragero","Krakeroy","Krakstad","Kristiansand","Kristiansund","Kroderen","Krokstadelva","Kval","Kvalsund","Kvam","Kvammen","Kvanne","Kvelde","Kvinesdal","Kvinlog","Kvisvik","Kviteseid","Kyrkjebo","Kyrksaeterora","Lakselv","Laksevag","Laksvatn","Lalm","Land","Langangen","Langesund","Langevag","Langfjordbotn","Langhus","Larkollen","Larvik","Laukvik","Lauvsnes","Lauvstad","Leikang","Leines","Leira","Leirfjord","Leirsund","Leirvik","Leknes","Lena","Lensvik","Lenvik","Lepsoy","Levanger","Lidaladdi","Lier","Lillehammer","Lillesand","Lindas","Loddefjord","Lodingen","Loen","Lofthus","Loken","Lokken Verk","Lom","Lonevag","Longva","Lorenfallet","Loten","Lovund","Lundamo","Lunde","Lunner","Lyngdal","Lyngseidet","Lyngstad","Lysaker","Lysoysundet","Magnor","Malm","Maloy","Malvik","Mandal","Manger","Manndalen","Marheim","Masfjorden","Mathopen","Maura","Mehamn","Meisingset","Melbu","Meldal","Melhus","Melsomvik","Meraker","Mestervik","Midsund","Miland","Minnesund","Mirza Rafi Sauda","Misje","Misvaer","Mjolkeraen","Mjondalen","Mo","Mo i Rana","Modalen","Moelv","Moen","Moi","Molde","Moldjord","Morgedal","Mosby","Mosjoen","Moss","Movik","Myking","Myre","Mysen","Na","Naerbo","Naersnes","Namsos","Namsskogan","Narvik","Naustdal","Nedenes","Nedre Frei","Nesbru","Nesbyen","Nesgrenda","Nesna","Nesoddtangen","Nesttun","Neverdal","Nevlunghamn","Nodeland","Nordby Bruk","Nordfjordeid","Nordkisa","Nordland","Nordstrono","Noresund","Norheimsund","Notodden","Nybergsund","Nyborg","Nydalen","Nygardsjoen","Nyhus","Nykirke","Odda","Odnes","Oksfjord","Oksvoll","Olden","Olderdalen","Olen","Oltedal","Oma","Onarheim","Oppdal","Oppegard","Opphaug","Oresvika","Orje","Orkanger","Ornes","Orre","Os","Oslo","Otta","Otteroy","Ottestad","Oveland","Ovre Ardal","Ovrebo","Oyeren","Oystese","Porsgrunn","Prestfoss","Raholt","Rakkestad","Ramberg","Ramfjordbotn","Ramnes","Rana","Ranasfoss","Randaberg","Ranheim","Raudeberg","Raudsand","Raufoss","Rauland","Re","Reine","Reinsvoll","Reipa","Reistad","Reitan","Rena","Rennebu","Rindal","Ringebu","Ringsaker","Ringstad","Risoyhamn","Rjukan","Roa","Rodberg","Rodoy","Rognan","Rogne","Rokland","Roldal","Rollag","Rolvsoy","Romedal","Rong","Roros","Rorvik","Rosendal","Rossland","Rost","Rovde","Roverud","Royken","Royneberg","Rubbestadneset","Rud","Rygge","Rykene","Rypefjord","Saebo","Saebovik","Saetre","Saevareid","Saeveland","Sagvag","Salhus","Salsbruket","Salsnes","Saltnes","Samuelsberg","Sand","Sandane","Sande","Sandefjord","Sandeid","Sander","Sandnes","Sandnessjoen","Sandshamn","Sandstad","Sandtorg","Sandvika","Sandvoll","Sannidal","Sarpsborg","Saupstad","Selasvatn","Selje","Seljord","Sellebakk","Selva","Selvaer","Sem","Setermoen","Siggerud","Siljan","Silsand","Singsas","Sira","Sirevag","Sistranda","Sjovegan","Skabu","Skage","Skanevik","Skarer","Skarnes","Skatoy","Skaun","Skedsmokorset","Skeie","Ski","Skien","Skjeberg","Skjerstad","Skjervoy","Skjold","Skjoldastraumen","Skjolden","Skodje","Skogn","Skoppum","Skotbu","Skotterud","Skreia","Skudeneshavn","Skulsfjord","Skutvika","Slastad","Slattum","Slemdal","Slemmestad","Sletta","Snaase","Snillfjord","Sogn","Sokna","Sokndal","Soknedal","Sola","Solbergelva","Solvorn","Sommaroy","Somna","Son","Sondeled","Sor-Fron","Sorbo","Soreidgrenda","Sorli","Sortland","Sorum","Sorumsand","Sorvaer","Sorvagen","Sorvik","Spangereid","Sparbu","Sperrebotn","Spillum","Spydeberg","Stabbestad","Stabekk","Stamnes","Stamsund","Stange","Stathelle","Staubo","Stavanger","Stavern","Steigen","Steinberg","Steinkjer","Steinsdalen","Sto","Stokke","Stokmarknes","Stol","Storas","Stordal","Storebo","Storforshei","Storslett","Storsteinnes","Stranda","Straume","Straumen","Strommen","Stronstad","Strusshamn","Stryn","Suldalsosen","Sulisjielmma","Sund","Sundal","Sunde","Sunndalsora","Surnadalsora","Svarstad","Svartskog","Sveio","Svelgen","Svelvik","Svene","Svortland","Sylling","Syvik","Tafjord","Talvik","Tananger","Tanem","Tangen","Tau","Tennevoll","Tennfjord","Tertnes","Tiller","Tingvoll","Tistedal","Tjeldsto","Tjelta","Tjong","Tjorvag","Tjotta","Tofte","Tolga","Tomasjorda","Tomter","Tonstad","Tornes","Torod","Torp","Torpo","Tovik","Trana","Tranby","Trengereid","Tretten","Treungen","Trofors","Trollfjorden","Tromsdalen","Trondheim","Trones","Turoy","Tvedestrand","Tveit","Tynset","Tyristrand","Tysnes","Tysse","Tyssedal","Uggdal","Ulefoss","Ulstein","Ulsteinvik","Ulvagen","Ulvik","Undeim","Uskedalen","Utsira","Utskarpen","Uvdal","Vadheim","Vage","Vagland","Vaksdal","Vale","Valen","Valer","Valestrand","Valestrandfossen","Valldal","Valle","Valsoyfjord","Vangsvika","Vannvag","Vanse","Varangerbotn","Varhaug","Vassenden","Vatne","Vedavagen","Vegarshei","Veggli","Venabygd","Vennesla","Verdal","Vestby","Vestfossen","Vestnes","Vestra Mosterhamn","Vestre Gausdal","Vevang","Vevelstad","Vigrestad","Vikebygd","Vikedal","Vikersund","Vikesa","Vikran","Vingelen","Vinje","Vinstra","Voksa","Volda","Vollen","Vormedal","Vormsund","Voss","Vossestrand","Vraliosen","Ytre Alvik"]},"NP":{"id":"NP","name":"Nepal","timezones":["Asia/Kathmandu"],"cities":["Bharatpur","Jawlakhel","Kathmandu","Lumbini","Palpa","Patan"]},"NR":{"id":"NR","name":"Nauru","timezones":["Pacific/Nauru"],"cities":[]},"NU":{"id":"NU","name":"Niue","timezones":["Pacific/Niue"],"cities":[]},"NZ":{"id":"NZ","name":"New Zealand","timezones":["Pacific/Auckland","Pacific/Chatham"],"cities":["Ahaura","Albany","Amberley","Ashhurst","Auckland","Avondale","Awanui","Balclutha","Balfour","Beachlands","Belmont","Bethlehem","Blackburn","Bombay","Brightwater","Browns Bay","Bulls","Campbells Bay","Cashmere Hills","Cave","Cheviot","Christchurch","Clarks","Clevedon","Clinton","Clive","Clyde","Coalgate","Coatesville","Collingwood","Colville","Coromandel","Darfield","Dargaville","Douglas","Doyleston","Drury","Dunedin","Duvauchelle","East Tamaki","Eastbourne","Edendale","Eltham","Fairlie","Favona","Foxton","Foxton Beach","Franz Josef","Gisborne","Glen Eden","Glenbrook","Greenhithe","Greerton","Greymouth","Haast","Halswell","Hamilton","Hastings","Havelock North","Hawarden","Hawera","Herne Bay","Hikuai","Hokitika","Howick","Hunterville","Invercargill","Johnsonville","Kaeo","Kaiata","Kaikoura","Kaitangata","Kaiwaka","Kaiwharawhara","Kamo","Karamea","Katikati","Kawakawa","Kawerau","Kawhia","Kerikeri","Khandallah","Kimbolton","Kirwee","Kohukohu","Kumeu","Kurow","Lake Tekapo","Leamington","Leeston","Levels","Levin","Lincoln","Linwood","Longburn","Lower Hutt","Lumsden","Mangaroa","Mangawhai Heads","Mangere","Mangonui","Manukau","Manunui","Marua","Masterton","Matakana","Maungatapere","Maungaturoto","Menzies Ferry","Methven","Milton","Mission Bay","Moerewa","Mosgiel","Mossburn","Mount Maunganui","Murupara","Myross Bush","Napier City","Nelson","New Plymouth","Ngaio","Ngatea","North Shore","Northcote Point","Northland","Oakura","Oamaru","Oban","Ohaupo","Ohura","Okaiawa","Okaihau","Okato","Onga Onga","Opaheke","Opotiki","Opunake","Orakei","Oratia","Orewa","Otaki","Otaki Beach","Otane","Otautau","Otematata","Otorohanga","Oturehua","Outram","Owaka","Oxford","Paekakariki","Paeroa","Paihia","Pakuranga","Palmerston North","Panmure","Papakura","Papamoa","Paradise","Paraparaumu","Paraparaumu Beach","Paremata","Parnell","Penrose","Petone","Piopio","Pirongia","Pleasant Point","Pokeno","Ponsonby","Porangahau","Porirua","Port Chalmers","Portland","Puhoi","Pukeatua","Punakaiki","Queenstown","Raglan","Rakaia","Rakaia Gorge","Ranfurly","Red Beach","Renwick","Reporoa","Riverhead","Riversdale","Riverton","Rolleston","Rotherham","Rotorua","Ruawai","Russell","Saint Heliers","Sawyers Bay","Sefton","Silverdale","Springs Junction","Stanmore Bay","Swanson","Tahoraiti","Takaka","Takanini","Takapau","Takapuna","Tamahere","Taradale","Tasman","Taupiri","Taupo","Tauranga","Te Anau","Te Atatu","Te Kauwhata","Te Roti","Templeton","Thames","Timaru","Tinwald","Tirau","Titirangi North","Tokomaru","Tokoroa","Torbay","Tuakau","Tuatapere","Turangi","Upper Moutere","Urenui","Waiau","Waiau Pa","Waihi","Waihi Beach","Waikanae","Waikari","Waikawa","Waikuku","Waikuku Beach","Waimana","Waimauku","Wainuiomata","Waiouru","Waipara","Waipawa","Waipu","Wairoa","Waitakere City","Waitangi","Waitara","Waitati","Waitoa","Waiuku","Wakefield","Walton","Wanaka","Wanganui","Warkworth","Waverley","Wellington","Wellsford","Wendon Valley","West Melton","Weston","Westport","Weymouth","Whakatane","Whangamata","Whangaparaoa","Whangarei","Whitianga","Winchester","Windermere","Winton","Woodend","Woolston","Wyndham","Yaldhurst"]},"OM":{"id":"OM","name":"Oman","timezones":["Asia/Dubai"],"cities":["Al Sohar","Muscat","Nizwa","Ruwi","Saham","Salalah","Samad"]},"PA":{"id":"PA","name":"Panama","timezones":["America/Panama"],"cities":["Aguadulce","Albrook","Ancon","Arosemena","Arraijan","Balboa","Bella Vista","Bocas del Toro","Boquete","Bugaba","Calidonia","Campo Alegre","Cerro Viento","Chigore","Chiriqui","Cocle","Corozal","Cristobal","Curundame","Curundu","David","El Arado","El Cangrejo","El Lago","Elena","Entre Rios","Finca Blanco Numero Uno","Fuerte Amador","Guadalupe","Jimenez","Juan Diaz","Juan Franco","Kuba","La Chorrera","La Exposicion","La Loma","Las Mercedes","Las Sabanas","Las Tablas","Llano Tugri","Los Angeles","Muerto","Mulatupo","Paitilla","Panama City","Parque Lefevre","Peru","Playa Blanca","Plaza","Portobelo","Pueblo Nuevo","Quebrada de Camilo","Rio Abajo","Sabalo","Sacramento","San Cristobal","San Felipe","San Francisco","San Miguelito","Santa Ana","Santa Catalina","Santa Clara","Santa Isabel","Santiago","Santo Domingo","Tocumen","Torre","Torres Bluff","Veraguas","Victoria","Vista Alegre","Vista Hermosa"]},"PE":{"id":"PE","name":"Peru","timezones":["America/Lima"],"cities":["Abancay","Arequipa","Ate","Ayacucho","Bagua","Barranca","Barranco","Bellavista","Bolivar","Cajamarca","Callao","Calle","Caras","Cerro de Pasco","Chachapoyas","Chiclayo","Chimbote","Chincha","Cusco","Cuzco","El Agustino","Hacienda La Palma","Huacho","Huancavelica","Huancayo","Huaral","Huaraz","Huaytara","Ica","Ilo","Imperial","Iquitos","Jaen","Jesus Maria","Jose Olaya","Juliaca","Junin","La Molina","La Perla","La Punta","Lambayeque","Lima","Lince","Loreto","Lurigancho","Machu Picchu","Maldonado","Minas de Marcona","Miraflores","Moquegua","Moyobamba","Pasco","Paucarpata","Pimentel","Pisco","Piura","Progreso","Pucallpa","Puerto Inca","Puerto Maldonado","Puno","Rimac","Rioja","San Borja","San Isidro","San Juan Bautista","San Martin","San Miguel","Santa","Santiago","Santiago De Surco","Sullana","Surco","Surquillo","Tacna","Talara","Tarapoto","Tingo Maria","Trujillo","Tumbes","Ventanilla","Victoria"]},"PF":{"id":"PF","name":"French Polynesia","timezones":["Pacific/Tahiti","Pacific/Marquesas","Pacific/Gambier"],"cities":["Arue","Faaa","Mahina","Paeau","Papeete","Pirae","Punaauia"]},"PG":{"id":"PG","name":"Papua New Guinea","timezones":["Pacific/Port_Moresby","Pacific/Bougainville"],"cities":["Aitape","Arawa","Daru","Goroka","Kavieng","Kerema","Kikori","Kimbe","Kiunga","Kokopo","Kundiawa","Kupano","Lae","Lorengau","Madang","Mendi","Mount Hagen","Namatanai","Nambaga","Paivara","Pongani","Popondetta","Port Moresby","Vanimo","Wabag","Waigani","Wewak"]},"PH":{"id":"PH","name":"Philippines","timezones":["Asia/Manila"],"cities":["Abucay","Acacia","Aguilar","Agusan Pequeno","Alabang","Alaminos","Alcala","Alfonso","Alitagtag","Amadeo","Angat","Angeles City","Angono","Antipolo","Apalit","Aquino","Arayat","Asia","Aurora","Ayala","Baao","Baclaran","Bacolod City","Bacoor","Bagac","Bago City","Bagong Nayon","Baguio City","Bagumbayan","Balabag","Balagtas","Balamban","Balanga","Balayan","Baliuag","Balungao","Barbar","Bataan","Batangas","Bates","Batis","Bauan","Bautista","Bay","Bayan","Bayawan","Binan","Binangonan","Binondo","Blumentritt","Boac","Bocaue","Bonifacio","Bool","Bukidnon","Bulacan","Burgos","Bustos","Buting","Butuan","Cabanatuan City","Cabatuan","Cabugao","Cabuyao","Cafe","Cagayan","Cagayan de Oro","Cainta","Calaca","Calamba","Calamba City","Calapan","Calasiao","Calbayog City","Calinan","Caloocan","Caloocan City","Campus","Candelaria","Candon","Canlubang","Capitol","Cardona","Carlatan","Carlos","Carmona","Carolinas","Cauayan","Cavinti","Cavite City","Cebu City","Central","Centre","Centro","China","Cinco","City of Batac","Cogan","Concepcion","Cotabato City","Cruz","Cubao","Dagupan","Danao","Dapitan","Daraga","Dasmarinas","Davao City","Del Monte","Del Pilar","Digos","Diliman Primero","Dinas","Dingras","Dipolog City","Dolores","Domingo","Don Bosco Executive Village","Don Jose","Dumaguete","Fairview","Feliciano","Fernandez","Fernando","Fortuna","Gallego","General","General Santos","General Trias","Gitagum","Gloria","Guagua","Hagonoy","Hilongos","Himamaylan","Ilagan","Iligan","Ilog","Iloilo City","Imus","Interior","Iriga City","Isabela","Island Park","Jagna","Kalibo","Kapatagan","Kawit","Kidapawan","Koronadal","La Salette","La Trinidad","La Union","Laguerta","Laguna","Lahug","Lamitan","Laoag","Lapu-Lapu City","Las Pinas","Lawis","Legaspi","Leon","Leyte","Liberty","Libis","Lilio","Limay","Lipa City","Llanera","Looc","Los Banos","Los Martires","Lourdes","Lucena City","Luna","Luzon","Mabalacat","Mabini","Macabebe","Magsaysay","Makati City","Malabon","Malasiqui","Malate","Malolos","Malvar","Mamungan","Manaoag","Mandaluyong City","Mandaue City","Mangaldan","Mangrove","Manila","Mapua","Maquiling","Marcos","Maria","Marikina City","Marilag","Marilao","Marina","Mariveles","Masbate","Matalam","Matandang Balara","Mauban","Mawab","Merville Subdivision","Meycauayan","Miagao","Minalin","Mindanaw","Minglanilla","Misamis","Molave","Munoz East","Muntinlupa","Naga","Naga City","Naguilian","Navotas","New Manila","Norte","Novaliches","Nueva","Oara","Obando","Occidental","Olongapo City","Orani","Orion","Osmena","Ozamiz City","Pacita","Padre Garcia","Paete","Pagadian","Pagasinan","Pagsanjan","Palma Gil","Palo","Pampanga","Panabo","Pandi","Pangil","Paniqui","Paranaque City","Pardo","Pasay","Pasig","Pasong Tamo","Pateros","Paul","Philippine","Pias","Pikit","Pinaglabanan","Plaridel","Plaza","Poblacion","Poblacion, San Felipe","Princesa","Province of Cebu","Province of Laguna","Province of Pampanga","Province of Pangasinan","Puerto Princesa City","Pulilan","Putatan","Quezon","Quezon City","Ramon","Real","Rizal","Rodriguez","Roosevelt","Roque","Rosales","Rosario West","Roxas City","Salcedo","Salinas","Salle","Samal","Sampaloc","San Agustin","San Andres","San Antonio","San Carlos City","San Fabian","San Fernando","San Francisco","San Jose","San Jose del Monte","San Juan","San Mateo","San Miguel","San Pablo City","San Pedro","San Vicente","Santa Cruz","Santa Rosa","Santiago","Santo","Santo Tomas","Santos","Sariaya","Silang","Silay","Siniloan","Smart","Sorsogon","Sta Cruz","Sto Nino","Subic","Sucat","Sulo","Sultan Kudarat","Summit","Suyo","Taal","Tacloban City","Tacurong","Taft","Tagaytay","Tagbilaran City","Taguig","Tagum","Talisay City","Talon","Tamag","Tambler","Tambo","Tanauan","Tanay","Tandang Sora","Tanza","Tarlac City","Tayabas","Taytay","Tayug","Tejeros Convention","Tigbauan","Toledo City","Trece Martires City","Trinidad","Tuguegarao City","Tuktukan","Ugong Norte","Upper Bicutan","Urdaneta","Valencia","Valenzuela","Vargas","Ventura","Veronica","Victorias City","Victory","Vigan","Villa","Villanueva","Vito","West","West Triangle","Wines","Zamboanga City"]},"PK":{"id":"PK","name":"Pakistan","timezones":["Asia/Karachi"],"cities":["Abbottabad","Attock","Batgram","Bhimbar","Burewala","Cantt","Chakwal","Clifton","Daska","Daud Khel","Dera Ghazi Khan","Faisalabad","Fazal","Gilgit","Goth Abad Magsi","Gujar Khan","Gujranwala","Gujrat","Gulberg","Gulshan-e-Iqbal","Habib Baihk","Haripur","Havelian","Hyderabad","Islamabad","Jhang City","Jhang Sadr","Jhelum","Jhumra","Kabirwala","Karachi","Kasur","Khan","Khanewal","Khanpur","Kohat","Lahore","Mandi","Mandi Bahauddin","Mansehra","Mardan","Mian Channu","Mianwali","Miran Shah","Multan","Muzaffarabad","Nangar","Nankana Sahib","Narowal","New Mirpur","Nowshera","Okara","Peshawar","Pindi","Plot","Quetta","Rawalpindi","Rawlakot","Saddar","Sahiwal","Sarai Sidhu","Sargodha","Sarwar","Sheikhupura","Sialkot","Sukkur","Toba Tek Singh","Usman","Wazirabad","Ziauddin"]},"PL":{"id":"PL","name":"Poland","timezones":["Europe/Warsaw"],"cities":["Adama","Alwernia","Andrespol","Andrychow","Anin","Annopol","Arkadia","Babienica","Babimost","Baborow","Baboszewo","Balice","Banino","Baniocha","Baran","Baranow","Baranowko","Barciany","Barcice","Barcin","Barczewo","Barglowka","Barlinek","Bartoszyce","Baruchowo","Barwice","Bazanowka","Beblo","Bedkow","Bejsce","Belk","Belsk Duzy","Belsznica","Bestwina","Bestwinka","Biala","Bialobrzegi","Bialy Dunajec","Bibice","Biecz","Biedrusko","Bielany","Bielany Wroclawskie","Bielawa","Bielawy","Bielcza","Bieliny","Bielkowo","Bielsk","Bielsk Podlaski","Bielsko-Biala","Bierun","Bierun Nowy","Bierutow","Biesiekierz","Biezanow-Prokocim","Bircza","Biskupice","Biskupice Oloboczne","Biskupiec","Biskupin","Bisztynek","Blachownia","Blazowa","Bledzew","Blizne","Blizyn","Bobrowniki","Bobrza","Bochnia","Bochotnica","Bochowo","Bodzentyn","Bogatynia","Bogdaszowice","Bogumilowice","Bogunice","Boguslaw","Bohdan","Bojadla","Bojano","Bojanowo","Bojszow","Bojszowy","Bolechowice","Boleslaw","Bolewice","Bolkow","Bolszewo","Borek Strzelinski","Borki","Borkowice","Borkowo","Borne Sulinowo","Borowa","Borowe","Borowiec","Bory","Borzecin","Borzykowo","Bralin","Bramki","Braniewo","Braszewice","Bratkowice","Brenna","Brochocin","Brodnica","Brok","Brudzice","Brudzowice","Brynica","Brzeg","Brzeg Dolny","Brzesko","Brzeszcze","Brzezinka","Brzeziny","Brzeznica","Brzostek","Brzostowka","Brzoza Krolewska","Brzozow","Brzyska Wola","Buczkowice","Budziska","Budzyn","Buk","Bukowice","Bukowiec Opoczynski","Bukowina Tatrzanska","Bukowno","Bukowsko","Burzenin","Bychawa","Byczyna","Bydgoszcz","Bydlin","Byslaw","Bystra","Bystrzyca Klodzka","Bytom","Cekcyn","Cekow","Chalupki","Charzykowy","Checiny","Chelm","Chelmek","Chelmsko Slaskie","Chmielnik","Chmielow","Chocianow","Chociwel","Choczewo","Chocznia","Chojna","Chojnice","Choroszcz","Chorzele","Chorzelow","Choszczno","Chotel","Chotomow","Chrzan","Chrzastowka","Chrzesne","Chrzowice","Chwaszczyno","Chybie","Chylice","Chyliczki","Cianowice Duze","Ciasna","Ciechocin","Ciechocinek","Cierpice","Cieszkow","Cieszyn","Ciezkowice","Cigacice","Cisiec","Cmielow","Cmolas","Cwiklice","Cybinka","Czaniec","Czaplinek","Czapury","Czarna","Czarne","Czarnkow","Czarnozyly","Czarny Bor","Czarny Dunajec","Czarny Las","Czarze","Czastary","Czechowice-Dziedzice","Czekanow","Czeladz","Czempin","Czernica","Czernichow","Czerniewice","Czersk","Czerwiensk","Czerwionka-Leszczyny","Czerwonak","Czluchow","Czosnow","Czudec","Czyzyny","Dabki","Dabrowa","Dabrowa Bialostocka","Dabrowa Biskupia","Dabrowa Chelminska","Dabrowa Chotomowska","Dabrowka Wielka","Dabrowno","Dabrowskie","Daleszyce","Damnica","Dankowice","Dargoslaw","Darnowo","Debe Wielkie","Debica","Debina","Deblin","Debno","Debowiec","Debrzno Wies","Deszczno","Dlugopole-Zdroj","Dobiesz","Dobieszowice","Dobra","Dobre Miasto","Dobrodzien","Dobromierz","Dobron","Dobroszyce","Dobrzany","Dobrzen Wielki","Dobrzyca","Dolaszewo","Dolice","Domaniewice","Domaradz","Domaslaw","Dopiewiec","Drawno","Drawsko Pomorskie","Drewnica","Drezdenko","Drohiczyn","Drozdowo","Druzbice","Drzewica","Duczki","Dukla","Dulcza Wielka","Dunaj","Duszniki-Zdroj","Dygowo","Dylewo","Dynow","Dywity","Dzialoszyn","Dziechciniec","Dziegielow","Dziekanow Lesny","Dzielna","Dzierzazno","Dzierzgon","Dzierzoniow","Dziewin","Dzikowiec","Dziwnow","Dzwierzuty","Elblag","Elzbieta","Fabianki","Falkow","Falkowo","Frank","Frombork","Frydrychowice","Frysztak","Gadka Stara","Garbow","Garby","Garki","Garwolin","Gaszowice","Gaworzyce","Gdow","Gdynia","Giby","Gieraltowice","Gizalki","Gizyce","Gliwice","Glogow Malopolski","Glogowek","Gloskow","Glowienka","Glowna","Glowno","Glubczyce","Glucholazy","Gluchow","Gluszyca","Gmina Babiak","Gmina Bobrowo","Gmina Chmielno","Gmina Ciechanowiec","Gmina Gnojno","Gmina Kiszkowo","Gmina Kolno","Gmina Konarzyny","Gmina Lipno","Gmina Ludwin","Gmina Lutomiersk","Gmina Morawica","Gmina Moszczenica","Gmina Opole Lubelskie","Gmina Przywidz","Gmina Sadowie","Gmina Sierakowice","Gmina Strzelin","Gmina Szubin","Gmina Widawa","Gmina Wyszki","Gmina Zakliczyn","Gniew","Gniewino","Gniewkowo","Gniezno","Gnuszyn","Godziszewo","Gogolin","Golanice","Golasowice","Golczewo","Goleszow","Golkowice","Golotczyzna","Golub-Dobrzyn","Gomunice","Gora","Gora Kalwaria","Gora Pulawska","Gora Siewierska","Gorazdze","Gorki Wielkie","Gorlice","Gorno","Gorz","Gorzkow","Gorzkowice","Gorzow","Gorzow Slaski","Gorzyce","Gorzyczki","Gostyn","Gostynin","Goszczyn","Gowarzewo","Gowino","Gozdnica","Gozdowo","Grabiec","Grabki Duze","Grabow nad Prosna","Grabowka","Gracze","Grajewo","Grebocice","Grebocin","Grodki","Grodkow","Grodzisk","Grodzisk Mazowiecki","Grodzisk Wielkopolski","Grodzisko Dolne","Grojec","Gromiec","Gronowo Elblaskie","Gruczno","Grunwald","Grupa","Gruszczyn","Grybow","Gryfice","Gryfino","Gryfow Slaski","Grzebien","Grzegorz","Grzmiaca","Grzmucin","Gubin","Gzin","Haczow","Harasiuki","Hecznarowice","Henrykow","Hornowek","Hucisko Jawornickie","Humniska","Huta Dabrowa","Huta Dlutowska","Huta Stara","Ilowa","Ilowo","Ilza","Imielin","Iwaniska","Iwanowice","Iwiczna","Iwierzyce","Iwla","Iwonicz-Zdroj","Izabela","Izabelin","Jablonica","Jablonka","Jablonna","Janin","Jankowice","Janow","Janow Lubelski","Jarkowice","Jarocin","Jaroszow","Jaroszowiec","Jasienica","Jasienica Dolna","Jasieniec","Jaslo","Jastkow","Jastrowie","Jastrzebie","Jawiszowice","Jawor","Jaworzno","Jaworzyna Slaska","Jedlicze","Jedlnia-Letnisko","Jelesnia","Jemielnica","Jerzmanowice","Jeziora Wielkie","Jeziorany","Jezowe","Jordanow","Jozefatow","Jozefoslaw","Jozefow","Juchnowiec Koscielny","Jugow","Juszkowo","Jutrosin","Kaczkowo","Kaczor","Kalety","Kalisz","Kalwaria Zebrzydowska","Kamien","Kamien Krajenski","Kamien Pomorski","Kamien Slaski","Kamienica Polska","Kamieniec","Kamienna Gora","Kamionki","Kampinos","Kanczuga","Karchowice","Karczew","Kargowa","Karlikowo","Karlino","Karnice","Karniowice","Karpacz","Karpiska","Karsko","Kartuzy","Kasinka","Katarzyna","Katowice","Katy","Katy Wroclawskie","Kazimierz Biskupi","Kazimierz Dolny","Kazimierza Wielka","Kazmierz","Kcynia","Keblowo","Kedzierzyn","Kedzierzyn-Kozle","Kety","Kicin","Kielce","Kielcz","Kielczow","Kielno","Kielpin","Kijewo Krolewskie","Klaj","Klecko","Klecza Dolna","Kleczany","Klenica","Kleszczewo","Kleszczow","Klikawa","Klikuszowa","Klimontow","Kliniska","Klobuck","Klodawa","Klomnice","Kluczbork","Klucze","Knurow","Knyszyn","Kobiernice","Kobierzyce","Kobior","Kobylanka","Kobylka","Kobylnica","Kochcice","Kocierzew Poludniowy","Kocmyrzow","Kojszowka","Kokoszkowy","Kolbudy","Kolbuszowa","Koleczkowo","Kolno","Kolodziejewo","Kolonia Zawada","Kolonowskie","Koluszki","Komorniki","Komorow","Komorsk","Konarzewo","Konarzyce","Konczyce Male","Koniakow","Koniecpol","Konin","Koniusza","Konopiska","Konradowka","Konstancin-Jeziorna","Konstantyn","Konstantynow","Konstantynow Lodzki","Kopki","Korczyna","Korfantow","Kornik","Koronowo","Korsze","Korytow","Korzenna","Kosakowo","Koscielisko","Koscierzyna","Kosina","Kostrzyn","Kostrzyn nad Odra","Koszalin","Koszecin","Koszyce","Koteze","Kotlin","Kowal","Kowalew","Kowalewo","Kowalewo Pomorskie","Kowalkow","Kowalowa","Kowary","Kowiesy","Kozieglowy","Kozienice","Kozmin Wielkopolski","Kozminek","Kozuchow","Kozy","Krakow","Krapkowice","Krasiejow","Krasne","Krasnik","Krasnystaw","Krasocin","Kraszew","Krepa Kaszubska","Krokowa","Kroscienko Wyzne","Krosno","Krosno Odrzanskie","Krosnowice","Krotoszyn","Kruszyn","Kruszyna","Krynica","Krynica-Zdroj","Krypno","Krzepice","Krzeszow","Krzeszowice","Krzyki-Partynice","Krzyszkowice","Krzywcza","Krzywin","Krzyz Wielkopolski","Krzyzanowice","Ksiazenice","Ksieginice","Kukow","Kuligow","Kunice","Kunow","Kurdwanow","Kurek","Kurylowka","Kurzetnik","Kusnierz","Kutno","Kuznia","Kuznica Czarnkowska","Kuzniki","Kwaczala","Kwidzyn","Kwilcz","Labiszyn","Labowa","Labunie","Lachowice","Lack","Lacko","Ladek","Lajsk","Laka","Lancut","Lany","Lask","Laska","Laskarzew","Latowicz","Laziska","Laziska Gorne","Leba","Lebork","Leczna","Ledziny","Legionowo","Legnica","Legowo","Lekawica","Lelow","Lesko","Lesna","Lesnica","Leszkowice","Leszno","Lewin Brzeski","Lezajsk","Libiaz","Lidzbark","Ligota","Limanowa","Liniewo","Linowko","Lipinki Luzyckie","Lipiny","Lipnica Murowana","Lipnica Wielka","Lipnik","Lipno","Lipowa","Lipsko","Lipusz","Lisewo","Liskow","Liszki","Liw","Lobez","Lobzenica","Lochow","Lochowo","Lodygowice","Lomianki","Lomianki Dolne","Lomnica","Lotyn","Lowicz","Lubaczow","Luban","Lubanie","Lubartow","Lubaszowa","Lubawa","Lubawka","Lubenia","Lubichowo","Lubicz","Lubien","Lubin","Lublewo","Lublin","Lubliniec","Lubnice","Lubochnia","Lubomia","Lubomierz","Lubon","Luborzyca","Lubraniec","Lubsko","Lubsza","Lubycza Krolewska","Lukow","Lulin","Lusowko","Lutynia","Luzino","Lysomice","Mackowice","Magnuszew","Majdan Krolewski","Majewo","Makow","Makow Mazowiecki","Makow Podhalanski","Makowiec","Maksymilianowo","Malbork","Malczyce","Malogoszcz","Manowo","Marcinowice","Marek","Margonin","Maria","Marki","Marklowice","Marta","Mary","MaryLka","Maslice","Maslow","Maszewo","Mazancowice","Mechelinki","Medyka","Medynia Glogowska","Melno","Meszna","Mialy","Miasteczko Slaskie","Miastko","Michalowice","Miechow","Mieczewo","Miedzna","Miedzyborow","Miedzyborz","Miedzybrodzie Zywieckie","Miedzylesie","Miedzyzdroje","Miejska Gorka","Mielec","Mielno","Mieroszow","Mierzecice","Mierzeszyn","Mikolajki","Mikoszewo","Mikstat","Milanow","Milcza","Milejow","Milicz","Milkowice","Milobadz","Miloradz","Milowka","Minoga","Mirkow","Miroslaw","Miroslawiec","Mirsk","Miszkowice","Mniow","Modlnica","Modlniczka","Modrze","Mogilany","Mogilno","Mokrsko","Morawica","Moryn","Mosina","Mosty","Moszczanka","Mragowo","Mrocza","Mrowino","Mscice","Msciwojow","Mszana","Mszana Dolna","Mucharz","Murowana Goslina","Muszyna","Myslachowice","Myslenice","Mysliborz","Myszkow","Myszyniec","Nacpolsk","Nadarzyn","Naklo","Naleczow","Namyslow","Naprawa","Narew","Narzym","Nasielsk","Nawodna","Nebrowo Wielkie","Nidzica","Nieborowice","Niechanowo","Niedomice","Niedrzwica Duza","Niegoslawice","Nielisz","Niemcz","Niemcza","Niemodlin","Nienadowka","Niepolomice","Niewierz","Nisko","Niwica","Nowa","Nowa Biala","Nowa Deba","Nowa Huta","Nowa Ruda","Nowa Slupia","Nowa Sol","Nowa Wies Elcka","Nowe Chechlo","Nowe Lignowy","Nowe Miasto Lubawskie","Nowe Miasto nad Pilica","Nowe Miasto nad Warta","Nowe Skalmierzyce","Nowo-Aleksandrowo","Nowogard","Nowogrodziec","Nowy Dwor","Nowy Dwor Gdanski","Nowy Dwor Mazowiecki","Nowy Korczyn","Nowy Staw","Nowy Swietow","Nowy Targ","Nowy Tomysl","Nowy Wisnicz","Nysa","Oblaczkowo","Oborniki","Obrzycko","Obsza","Odolanow","Odolin","Odrzykon","Ogrody","Ogrodzieniec","Ojrzen","Oksywie","Olawa","Olecko","Olejnica","Olesnica","Olesno","Oleszno","Olimpia","Olkusz","Olszany","Olszowice","Olsztyn","Olsztynek","Olszyna","Oltarzew","Opalenica","Opatow","Opatowek","Opoczno","Opole","Orchowo","Orneta","Ornontowice","Orzel","Orzesze","Orzysz","Osieck","Osieczna","Osiek","Osiek Jasielski","Osielsko","Osno","Osno Lubuskie","Ostaszewo","Ostrog","Ostroszowice","Ostrow","Ostrow Lubelski","Ostrow Mazowiecka","Ostrowek","Ostrowite","Ostrowy","Ostrzeszow","Otoki","Otomin","Otrebusy","Otwock","Otyn","Owinska","Ozarow Mazowiecki","Ozimek","Ozorkow","Pabianice","Pacanow","Pajeczno","Paledzie","Paliszewo","Paniowki","Papowo","Parczew","Pastuchow","Paulina","Pawlowice","Pcim","Peczniew","Pedziwiatry","Pegow","Pelplin","Pepowo","Pewel Mala","Piaseczno","Piasek","Piaski","Piastow","Piechowice","Piekary","Piekary Slaskie","Piekielnik","Piekoszow","Pielgrzymka","Pielice","Piensk","Pierwoszyno","Pieszkow","Pieszyce","Pietrowice Wielkie","Pietrzykowice","Pila","Pila Koscielecka","Pilawa","Pilawa Gorna","Pilchowice","Pilica","Pinczow","Pionki","Pisarzowice","Pisz","Plesna","Pleszew","Plewiska","Plochocin","Pniewy","Pobiedna","Pobiedziska","Poczesna","Podegrodzie","Podgorne","Podgorze","Podlasie","Podleze","Pogodki","Pogorzela","Pogwizdow","Pokrzywnica","Polajewo","Polanka Wielka","Polczyn-Zdroj","Police","Polkowice","Polomia","Polskie","Pomiechowek","Pomorskie","Popow","Popowice","Poraj","Poreba","Poswietne","Poznan","Prabuty","Praca","Praszka","Prawiedniki","Prochowice","Prokocim","Prosna","Proszowice","Pruchna","Prudnik","Prusice","Pruszcz Gdanski","Pruszcz Pomorski","Przasnysz","Przechlewo","Przeclaw","Przemet","Przemysl","Przemyslaw","Przeworsk","Przezmierowo","Przygodzice","Przylep","Przyrow","Przysiek","Przystajn","Przyszowice","Pszczew","Pszczyna","Pszow","Puck","Pustkow","Puszczew","Puszczykowo","Pyrzyce","Pyskowice","Pysznica","Rabien","Rabka-Zdroj","Raciaz","Raciazek","Racula","Raczka","Raczki","Radgoszcz","Radlin","Radlow","Radom","Radomin","Radomsko","Radomysl Wielki","Radoslaw","Radostowice","Radoszyce","Radymno","Radzanow","Radzanowo","Radziechowy","Radziejowice","Radzionkow","Radzymin","Radzyn Podlaski","Rajszew","Rakow","Rakowiec","Rakszawa","Ranizow","Raszowa","Raszowka","Raszyn","Rawa Mazowiecka","Rawicz","Rebkow","Rebowo","Reczno","Reda","Regimin","Rejowiec","Reszel","Rewa","Rewal","Roczyny","Rogalinek","Rogow","Rogowo","Rogoznik","Rogozno","Rokietnica","Rokitki","Rokitnica","Ropczyce","Rosnowko","Rostarzewo","Rozanka","Rozgarty","Rozprza","Roztoka","Ruda","Rudka","Rudna Mala","Rudnik nad Sanem","Rudy","Rudzica","Rudziniec","Rumia","Rumianek","Rusiec","Rybna","Rybnik","Rybno","Rychwal","Rydzyna","Ryglice","Ryki","Ryman","Rymanow","Ryn","Rypin","Rzasnia","Rzeczyce","Rzemien","Rzepin","Rzeszotary","Rzewnie","Rzgow Pierwszy","Rzuchowa","Sadlinki","Sadlno","Sady","Samin","Sandomierz","Sanniki","Sanok","Santok","Sarbinowo","Scinawa Mala","Scinawa Nyska","Sedziszow","Sedziszow Malopolski","Sepolno Krajenskie","Serock","Serwis","Sianow","Sidra","Sidzina","Siechnice","Siedlce","Siedlec","Siekierczyn","Siemiatycze","Siemirowice","Siemkowice","Sieniawa","Sieniawa Zarska","Sieniawka","Siennica","Siennica Nadolna","Sieradz","Sieroszowice","Sierpc","Siewierz","Siwek","Skala","Skarszewy","Skarzysko-Kamienna","Skawina","Skierdy","Skierniewice","Skoczow","Skomlin","Skopanie","Skorcz","Skorzec","Skorzewo","Skrbensko","Skrzetusz","Skrzyszow","Skwierzyna","Slawkow","Slawno B","Slawoszyno","Slemien","Slomniki","Slone","Slupca","Slupno","Smardzew","Smardzowice","Smigiel","Smolec","Smolnica","Smolnik","Sobienie Jeziory","Sobotka","Sobowidz","Sochaczew","Sochocin","Soczewka","Sokolow Malopolski","Sokolowsko","Solec Kujawski","Sompolno","Sopot","Sosnie","Sosnowiec","Sroda Wielkopolska","Stadla","Stalowa Wola","Staniatki","Staniszow","Stankowo","Stanowice","Stara","Stara Kamienica","Stara Lubianka","Starachowice","Stare Babice","Stare Bogaczowice","Stare Czarnowo","Stare Juchy","Stare Kurowo","Stare Miasto","Stary Broniszew","Stary Garbow","Stary Sacz","Stary Zamosc","Staszow","Staw","Stawiany","Stawiguda","Stegna","Steszew","Stoczek","Stolno","Stopnica","Straszyn","Strawczyn","Strazow","Stronie Slaskie","Stroze","Strumien","Strykow","Stryszawa","Stryszow","Strzalkowo","Strzebielino","Strzebin","Strzegom","Strzelce Krajenskie","Strzelce Opolskie","Strzeleczki","Strzelno","Strzeszow","Strzyze","Strzyzow","Studzieniec","Subkowy","Sucha Beskidzka","Suchedniow","Suchowola","Suchy Dab","Suchy Las","Sulechow","Sulejow","Sulejowek","Sulistrowice","Sulmierzyce","Sulmin","Suloszowa","Supienie","Susiec","Susz","Suszec","Suwaki","Swarorzyn","Swarzedz","Swarzewo","Swiatki","Swidnica","Swidnik","Swidwin","Swiebodzice","Swiebodzin","Swiecie nad Osa","Swiekatowo","Swierk","Swierklany","Swieta Katarzyna","Swietno","Swietoniowa","Swiniary","Swoboda","Sycewice","Sycow","Syrynia","Szadek","Szadlowice","Szczaniec","Szczawno","Szczawno-Zdroj","Szczecin","Szczecinek","Szczejkowice","Szczepanow","Szczercow","Szczucin","Szczuczyn","Szczurowa","Szczyrk","Szczytniki","Szczytno","Szebnie","Szemud","Szepietowo","Szewce","Szlachta","Szostka","Szowsko","Szprotawa","Szreniawa","Sztum","Sztutowo","Szyce","Szydlowiec","Szydlowo","Szyldak","Szymanow","Szypliszki","Tanowo","Tarchaly Wielkie","Tarczyn","Targanice","Tarnobrzeg","Tarnogrod","Tarnow Opolski","Tarnowiec","Tarnowo Podgorne","Tarnowskie Gory","Tczew","Tecza","Tegoborze","Tenczyn","Teofilow","Teresin","Terespol","Tluczan","Tolkmicko","Tomaszow","Tomaszow Lubelski","Tomaszowice","Topola Mala","Torzym","Toszek","Towarzystwo","Trabki","Trawniki","Trojanow","Trzciana","Trzcianka","Trzciel","Trzcinsko","Trzebinia","Trzebnica","Trzebownisko","Trzebunia","Trzemesnia","Trzemeszno","Trzemeszno Lubuskie","Trzesniow","Trzeszczyn","Trzyciaz","Trzydnik Duzy","Tuchola","Tuchow","Tuczno","Tulce","Turbia","Turek","Turobin","Turowiec","Tuszyn","Twardawa","Twardogora","Tworog","Tychy","Tyczyn","Tykocin","Tylicz","Tylmanowa","Tymbark","Tymowa","Tyszowce","Uciechow","Ujazd","Ujscie","Ulez","Unieszewo","Ustanow","Ustka","Ustron","Ustrzyki Dolne","Wabrzezno","Wachock","Wadowice","Wadowice Gorne","Waganiec","Wagrowiec","Walcz","Walim","Wambierzyce","Wapielsk","Warka","Warsaw","Warzachewka Polska","Warzno","Warzymice","Wasilkow","Wasniow","Wawel","Wawolnica","Wegierska Gorka","Wegliniec","Weglowice","Wegrzce Wielkie","Wejherowo","Wiazow","Wicko","Wieckowice","Wielbark","Wielen Zaobrzanski","Wielgie","Wielichowo","Wieliczka","Wieliszew","Wielki Klincz","Wieloglowy","Wielopole Skrzynskie","Wielowies","Wieruszow","Wierzchowisko","Wieszowa","Wijewo","Wilczeta","Wilczyce","Wilczyn","Wilga","Wilkanowo","Wilkow","Wilkowice","Wilkowisko","Winnica","Winsko","Wiorek","Wisla","Wisla Wielka","Wisniew","Wisniowa","Wisznice","Witaszyce","Witkowo","Witnica","Wlodawa","Wlodzimierz","Wloszczowa","Wojciech","Wojkowice","Wojkowice Koscielne","Wola Baranowska","Wola Filipowska","Wola Kopcowa","Wola Krzysztoporska","Wola Radlowska","Wola Rasztowska","Wola Rebkowska","Wola Zaradzynska","Wolborz","Wolbrom","Wolin","Wolka","Wolow","Wolsztyn","Wozniki","Wreczyca Wielka","Wronki","Wrzesnia","Wrzosowa","Wrzosowka","Wschowa","Wylatowo","Wymiarki","Wyrzysk","Wysogotowo","Wysoka","Wysoka Strzyzowska","Wysokie Mazowieckie","Wystep","Wyszogrod","Zabia Wola","Zabierzow Bochenski","Zablocie","Zabno","Zabor","Zabrowo","Zabrze","Zabrzeg","Zaczernie","Zagnansk","Zagorow","Zagorzyce","Zagosciniec","Zagrodno","Zakopane","Zalakowo","Zalasewo","Zalesie","Zaleszany","Zalewo","Zalubice Nowe","Zalubice Stare","Zaluski","Zaniemysl","Zaparcin","Zarow","Zarowka","Zarszyn","Zary","Zator","Zawada","Zawady","Zawadzkie","Zawidow","Zawiercie","Zawoja","Zawonia","Zbaszyn","Zbaszynek","Zbiczno","Zblewo","Zbroslawice","Zdunska Wola","Zduny","Zdzieszowice","Zebowice","Zebrzydowice","Zegrze Pomorskie","Zelazkow","Zelow","Zembrzyce","Zerkow","Zernica","Zerniki","Zgierz","Zglobice","Zglobien","Zgorsko","Zgorzala","Zgorzelec","Ziebice","Zielona","Zielone","Zielonka","Zielonki","Zielonki-Wies","Zlocieniec","Zloczew","Zlotow","Zloty Stok","Zmigrod","Znin","Zofia","Zorawia","Zorawina","Zosin","Zrecin","Zukowo","Zurawica","Zwolen","Zyrakow"]},"PM":{"id":"PM","name":"St Pierre & Miquelon","timezones":["America/Miquelon"],"cities":[]},"PN":{"id":"PN","name":"Pitcairn","timezones":["Pacific/Pitcairn"],"cities":[]},"PR":{"id":"PR","name":"Puerto Rico","timezones":["America/Puerto_Rico"],"cities":["Adjuntas","Aguada","Aguadilla","Aguas Buenas","Aibonito","Anasco","Arecibo","Arroyo","Bajadero","Barceloneta","Barranquitas","Boqueron","Cabo Rojo","Caguas","Camuy","Canovanas","Carolina","Catano","Cayey","Ceiba","Ciales","Cidra","Coamo","Corozal","Coto Laurel","Culebra","Dorado","Ensenada","Fajardo","Florida","Garrochales","Guanica","Guayama","Guayanilla","Guaynabo","Gurabo","Hatillo","Hormigueros","Humacao","Isabela","Jayuya","Juana Diaz","Juncos","Lajas","Lares","Las Piedras","Loiza","Luquillo","Manati","Maricao","Maunabo","Mayaguez","Mercedita","Moca","Morovis","Naguabo","Naranjito","Orocovis","Palmer","Patillas","Penuelas","Ponce","Punta Santiago","Quebradillas","Residencial Puerto Real","Rincon","Rio Grande","Sabana Grande","Sabana Seca","Saint Just","Salinas","San Antonio","San German","San Juan","San Lorenzo","San Sebastian","Santa Isabel","Toa Alta","Toa Baja","Trujillo Alto","Utuado","Vega Alta","Vega Baja","Vieques","Villalba","Yabucoa","Yauco"]},"PS":{"id":"PS","name":"Palestine","timezones":["Asia/Gaza","Asia/Hebron"],"cities":["Al Mawasi","Bethlehem","Gaza","Hebron","Jenin","Jericho","Nablus","Ramallah"]},"PT":{"id":"PT","name":"Portugal","timezones":["Europe/Lisbon","Atlantic/Madeira","Atlantic/Azores"],"cities":["Abobada","Abrantes","Acores","Aguada de Cima","Agualva","Agucadoura","Aguiar da Beira Municipality","Alandroal","Albergaria-a-Velha","Albufeira","Alcabideche","Alcacer do Sal","Alcains","Alcanede","Alcanena","Alcobaca","Alcochete","Alcoentre","Aldeia de Paio Pires","Aldeia do Meio","Aldeia dos Fernandes","Alenquer","Alfarelos","Alfena","Alfornelos","Alfragide","Alges","Algoz","Algueirao","Alhandra","Alhos Vedros","Aljezur","Aljustrel","Almada","Almancil","Almargem","Almeirim","Almodovar","Alpiarca","Alportel","Alqueidao da Serra","Alter do Chao","Altura","Alvaiazere","Alvarinhos","Alvelos","Alverca","Amadora","Amarante","Amares","Amiaes de Cima","Amor","Amora","Amoreira","Amorim","Anadia","Anta","Apulia","Arazede","Arco da Calheta","Arcos de Valdevez","Arcozelo","Arganil","Argoncilhe","Armacao de Pera","Arouca","Arraiolos","Arrifana","Arronches","Arruda dos Vinhos","Arvore","Assumar","Atalaia","Atouguia da Baleia","Avanca","Aveiras de Cima","Aveiro","Avelar","Avidos","Avintes","Azoia","Azueira","Azurem","Baguim","Baguim do Monte","Baleia","Baltar","Barcarena","Barcelos","Barreiro","Barrosas","Basto","Batalha","Beira","Beja","Belas","Belmonte","Bemfica","Benafim","Benavente","Benedita","Bicesse","Bico","Boavista","Bobadela","Boliqueime","Bombarral","Borba","Boticas","Bouca","Braga","Braganca","Brito","Bucelas","Buraca","Cabanelas","Cabeceiras de Basto","Cabeco de Vide","Cabecudos","Cabrela","Cacela","Cacem","Cacilhas","Cadaval","Caldas","Caldas da Rainha","Caldas das Taipas","Caldas de Sao Jorge","Caldas de Vizela","Calvao","Calvaria de Cima","Camarate","Caminha","Campanario","Campia","Campinho","Campo","Campo Maior","Canecas","Canedo","Canelas","Canhas","Canical","Canico","Canidelo","Cano","Cantanhede","Caparica","Caramulo","Carapinheira","Carcavelos","Carnaxide","Carrazedo","Carregado","Carrico","Cartaxo","Carvalhal","Carvalho","Carvalhosa","Carvoeiro","Casal","Casal da Areia","Cascais","Castanheira do Ribatejo","Castelejo","Castelo","Castelo Branco","Castelo de Paiva","Castro Daire","Castro Marim","Castro Verde Municipality","Catraia de Sao Paio","Cavaleiros","Cavaloes","Caxias","Ceira","Celorico de Basto","Cercal","Cernache","Cesar","Chao de Couce","Charneca","Chaves","Cidade","Cinfaes","Coimbra","Colares","Colmeias","Condeixa-a-Nova","Constance","Constancia","Corroios","Cortegaca","Costa de Caparica","Costa de Lavos","Covilha","Creixomil","Cruz Quebrada","Cuba","Cucujaes","Dalvares","Damaia","Darque","Dois Portos","Dona Maria","Dossaos","Eixo","Elvas","Encarnacao","Entroncamento","Ericeira","Ermidas","Escapaes","Escoural","Esmoriz","Espinho","Esposende","Estarreja","Estoi","Estombar","Estoril","Estremoz","Evora","Fafe","Famoes","Fanzeres","Fao","Faro","Feira","Felgueiras","Ferradosa","Ferreira","Ferreira do Alentejo","Ferrel","Ferro","Fiaes","Figueira da Foz Municipality","Figueira de Lorvao","Figueiro dos Vinhos","Fogueteiro","Folgados","Forte","Foz do Sousa","Fradelos","Freamunde","Frielas","Funchal","Fundao","Gafanha da Nazare","Galiza","Gandara dos Olivais","Gandra","Garruchas","Gemunde","Godim","Golega","Gondomar","Gouveia","Graca","Gradil","Grandola","Granja","Granja do Ulmeiro","Grijo","Guarda","Guardizela","Guia","Guimaraes","Gulpilhares","Igreja Nova","Ilhavo","Infesta","Joane","Jovim","Juncal","Lagarinhos","Lago","Lagoa","Lagoas","Lagos","Lajes","Lamego","Landim","Lavos","Lavra","Lavradio","Leca da Palmeira","Leca do Bailio","Leiria","Linda a Velha","Linhaceira","Linho","Lisbon","Lordelo","Loule","Lourel de Baixo","Loures","Lourical","Lourosa","Lousa","Lousada","Lousado","Macas de Caminho","Maceda","Macedo de Cavaleiros","Maceira","Machico","Macieira da Lixa","Madeira","Mafra","Maia","Malveira","Malveira da Serra","Mamouros","Mangualde","Manique de Baixo","Manique do Intendente","Marco","Marco de Canaveses","Margaride","Marinha","Marinha Grande","Marinhais","Marteleira","Martinganca","Massama","Massarelos","Matosinhos Municipality","Mealhada","Mem Martins","Mesao Frio","Mexilhoeira Grande","Milharado","Milhazes","Minde","Mira","Miranda do Corvo","Miranda do Douro","Mirandela","Mocarria","Modivas","Moita","Moncao","Monchique","Monforte","Monsanto","Monsaraz","Montalvo","Monte Estoril","Montelavar","Montemor-o-Novo","Montemor-o-Velho","Montes","Montijo","Moreira de Conegos","Mortagua","Moscavide","Moura","Moure","Mourisca do Vouga","Mozelos","Muro","Murtede","Murteira","Nadadouro","Negrelos","Neiva","Nelas","Nespereira","Nine","Nisa","Nogueira","Nogueira da Regedoura","Nogueira do Cravo","Obidos","Odemira","Odivelas","Oeiras","Oia","Olhao","Olhos de Agua","Olivais","Olival","Oliveira","Oliveira do Bairro","Oliveira do Douro","Oliveira do Hospital","Ortiga","Ota","Ourem","Ourique","Outeiro","Ovar","Paco de Arcos","Paderne","Palhaca","Palhais","Palmeira","Palmela","Parada de Gonta","Parada do Bispo","Paraiso","Parchal","Pardilho","Parede","Paredes","Paredes da Beira","Paredes de Coura","Pataias","Paul","Pechao","Pedreiras","Pedroso","Pedroucos","Pegoes Velhos","Penacova","Penafiel","Penedono","Penela","Penha Garcia","Peniche","Penteado","Pereira","Pero Pinheiro","Pevidem","Piedade","Pinhal","Pinhal Novo","Pinheiro","Pinheiro da Bemposta","Pinheiro de Azere","Poceirao","Poco Barreto","Poiares","Polima","Pombal","Ponta","Ponta Delgada","Ponta do Sol","Ponte","Ponte da Barca","Ponte de Lima","Ponte de Sor","Ponte de Vagos","Pontevel","Pontinha","Portalegre","Portel","Portela","Portimao","Porto","Porto Alto","Porto da Cruz","Porto de Mos","Porto Moniz","Porto Salvo","Povoa","Povoa da Galega","Povoa de Lanhoso","Povoa de Santa Iria","Povoa de Santo Adriao","Povoa do Forno","Prado","Pragal","Praia da Vitoria","Praia de Mira","Praia do Almoxarife","Praia do Carvoeiro","Praia do Ribatejo","Prazins","Prime","Proenca-a-Nova","Quarteira","Quejas","Queluz","Queluz de Baixo","Quinchaes","Quinta","Quinta do Anjo","Ramada","Ramo","Rana","Real","Rebordosa","Recarei","Redondo","Regueira de Pontes","Reguengo Grande","Reguengos de Monsaraz","Riachos","Riba de Ave","Ribeira Brava","Ribeira Grande","Ribeirao","Rinchoa","Rio de Moinhos","Rio de Mouro","Rio Maior","Rio Tinto","Romariz","Ronfe","Roque","Roriz","Runa","Sabugal","Sacavem","Salreu","Salto","Salvaterra de Magos","Samil","Samora Correia","Samouco","Sandim","Sanfins do Douro","Sangalhos","Sanguedo","Santa Barbara de Nexe","Santa Catarina","Santa Catarina da Serra","Santa Clara-a-Velha","Santa Comba Dao","Santa Cruz","Santa Iria da Azoia","Santa Marta","Santa Marta de Penaguiao","Santana","Santiago","Santiago da Guarda","Santiago de Riba-Ul","Santiago do Cacem","Santo Andre","Santo Antao do Tojal","Santo Antonio","Santo Antonio da Charneca","Santo Tirso","Sao Bras","Sao Bras de Alportel","Sao Domingos de Rana","Sao Felix da Marinha","Sao Francisco","Sao Joao","Sao Joao da Madeira","Sao Joao da Talha","Sao Joao das Lampas","Sao Joao de Ver","Sao Joao do Campo","Sao Joao dos Montes","Sao Juliao do Tojal","Sao Mamede de Infesta","Sao Marcos","Sao Pedro da Cadeira","Sao Pedro do Estoril","Sao Romao do Coronado","Sao Roque","Sao Vicente da Beira","Sao Vicente de Lafoes","Sardoal","Sarilhos Grandes","Satao","Seia","Seixal","Sendim","Senhora da Hora","Seroa","Serpa","Serpins","Serta","Sesimbra","Sete Rios","Sever do Vouga","Silva","Silvares","Silveira","Silves","Sines Municipality","Sintra","Soalheira","Sobrado","Sobrado de Paiva","Sobral de Monte Agraco","Sobralinho","Sobreda","Sobreiro","Sobrosa","Soito","Soure Municipality","Souto da Carpalhosa","Souzel","Sul","Tabuaco","Talaide","Tamel","Tarouca","Taveiro","Tavira Municipality","Teixoso","Telhado","Tercena","Terena","Tires","Tocha","Tomar","Tondela","Torre da Marinha","Torre de Moncorvo","Torres Novas","Torres Vedras","Touguinha","Tourais","Trafaria","Trancoso","Trancoso de Baixo","Travanca","Treixedo","Trofa","Tunes","Turcifal","Vagos","Valado de Frades","Valbom","Vale","Vale da Pinta","Vale de Acor","Vale de Cambra","Valega","Valenca","Valongo","Valverde","Varzea do Douro","Venda do Pinheiro","Vendas Novas","Vermelha","Vermoil","Vialonga","Viana do Alentejo","Viana do Castelo","Vidago","Vidigueira","Vieira de Leiria","Vieira do Minho","Vila Alva","Vila Boa de Quires","Vila Cha","Vila Cha de Ourique","Vila de Porto Santo","Vila do Bispo","Vila do Conde","Vila Franca de Xira","Vila Franca do Rosario","Vila Nogueira de Azeitao","Vila Nova","Vila Nova da Barquinha","Vila Nova de Cerveira","Vila Nova de Famalicao","Vila Nova de Gaia","Vila Nova de Paiva","Vila Praia de Ancora","Vila Real","Vila Verde","Vilar de Perdizes","Vilar do Paraiso","Vilar do Pinheiro","Vilar Formoso","Vilarinho das Paranheiras","Vilarinho de Arcos","Vilarinho do Bairro","Vilela","Vimieiro","Vinhais","Viseu","Vizela","Zambujal","Zibreira"]},"PW":{"id":"PW","name":"Palau","timezones":["Pacific/Palau"],"cities":[]},"PY":{"id":"PY","name":"Paraguay","timezones":["America/Asuncion"],"cities":["Ayolas","Boqueron","Chore","Ciudad del Este","Colonia Mariano Roque Alonso","Coronel Oviedo","Fernando de la Mora","Fuerte Olimpo","Hernandarias","Hohenau","Independencia","La Paz","Limpio","Loma Plata","Luque","Nemby","Presidente Franco","Salto del Guaira","San Alberto","San Juan Bautista","San Lorenzo","Santa Rita","Santa Rosa","Villa Elisa","Villa Hayes","Villarrica","Yataity"]},"QA":{"id":"QA","name":"Qatar","timezones":["Asia/Qatar"],"cities":[]},"RE":{"id":"RE","name":"R\xe9union","timezones":["Indian/Reunion"],"cities":[]},"RO":{"id":"RO","name":"Romania","timezones":["Europe/Bucharest"],"cities":["Adjud","Afumati","Agnita","Aiud","Alba","Alba Iulia","Albesti-Paleologu","Alesd","Alexandria","Alunu","Apahida","Apata","Arad","Avrig","Baba Novac","Baia Mare","Baia Sprie","Baicoi","Baile Olanesti","Baiut","Balomiru de Camp","Balotesti","Banesti","Baraolt","Barbuletu","Bascov","Becicherecu Mic","Berceni","Berzasca","Bethausen","Bic","Bilciuresti","Birda","Blaj","Bobolia","Bocsa","Bogdanita","Bolintin Deal","Borca","Borsa","Bozieni","Bragadiru","Branistea","Brazii de Sus","Breaza","Bucecea","Bucharest","Bucsani","Bucu","Bucurestii Noi","Buftea","Buhusi","Bujor","Bumbesti-Jiu","Busteni","Buzias","Calafat","Calan","Calarasi","Calinesti","Campeni","Campia","Campia Turzii","Campina","Campulung Moldovenesc","Campulung Muscel","Cara","Caracal","Caransebes","Carbunesti","Carei","Catcau","Catunele","Cernisoara","Cetatea de Balta","Cetatuia","Chiajna","Chiselet","Chisineu-Cris","Chisoda","Chitila","Cisnadie","Ciumani","Cluj-Napoca","Cobadin","Codlea","Cojasca","Comana","Comanesti","Corabia","Corbeanca","Corbita","Corlateni","Cosbuc","Costesti","Cotnari","Covasna","Craiova","Crangasi","Crasna","Cris","Cristian","Cristuru Secuiesc","Cugir","Curtici","Cuza Voda","Daia Romana","Decebal","Dej","Deta","Deva","Dimitrie Cantemir","Ditrau","Doamna","Dobroesti","Domnesti","Dor Marunt","Dorohoi","Dragotesti","Dridu","Dudestii Vechi","Dumbravita","Eforie","Fabrica","Faget","Fagetu","Falcau","Falticeni","Fetesti","Filias","Filiasi","Filipestii de Padure","Floresti","Fogarasch","Fundulea","Gaesti","Garla-Mare","Gataia","Geoagiu","Gheorgheni","Gherea","Gherla","Giarmata","Gilau","Giroc","Giulesti","Giurgiu","Glina","Gramesti","Grojdibodu","Gura Humorului","Hangulesti","Harsova","Hateg","Horia","Huedin","Humulesti","Hunedoara","Husi","Iadara","Iernut","Ion Ghica","Iorga","Izvoru Crisului","Jibou","Jilava","Lacu","Lacu Sinaia","Lancram","Lazuri","Lehliu-Gara","Lenauheim","Livezi","Ludesti","Lugoj","Lunguletu","Macin","Madaras","Magura","Magurele","Mandruloc","Mangalia","Manta","Marasheshty","Marasti","Marginea","Masloc","Matasari","Matei","Medgidia","Miercurea Sibiului","Miercurea-Ciuc","Mihai Bravu","Mihail Kogalniceanu","Mioveni","Mircea","Mizil","Moara Vlasiei","Mocira","Mogosoaia","Moinesti","Moisei","Moldova Noua","Moreni","Moroda","Motru","Murfatlar","Musenita","Nana","Nasaud","Navodari","Negresti","Negru Voda","Nenciulesti","Nicolae Balcescu","Nucsoara","Obreja","Ocna Mures","Ocnita","Odobesti","Odorheiu Secuiesc","Oltenita","Oradea","Oravita","Orsova","Otelu Rosu","Otopeni","Padureni","Panciu","Panduri","Pantelimon","Pascani","Patarlagele","Pecica","Petresti","Plopeni","Podu Dambovitei","Poiana Ilvei","Popesti","Popesti-Leordeni","Potlogi","Prejmer","Prim Decembrie","Prod","Pucheni","Rabagani","Racari","Racoasa","Racovita","Radauti","Radovanu","Ramnicu Sarat","Reghin","Roata de Jos","Rohia","Roman","Rosia","Rosiori de Vede","Sacele","Salatrucel","Salcea","Salcioara","Salonta","Sancraieni","Sangeorge","Sangeorz-Bai","Santimbru","Satu Mare","Saveni","Schela","Sebes","Seini","Sfantu Gheorghe","Sfantu-Gheorghe","Sibiu","Siculeni","Sighisoara","Simeria","Slatina","Slobozia","Soimus","Somcuta Mare","Sovata","Spiru Haret","Stalpeni","Stanilesti","Stefanesti","Stefanestii de Jos","Stroesti","Suceava","Susenii Bargaului","Sutesti","Talisoara","Tandarei","Targu Gangulesti","Targu Neamt","Tartasesti","Tatarani","Tatarusi","Tecuci","Teiu","Teius","Telega","Tibeni","Tileagd","Timus","Tina","Tipari","Titesti","Titu","Tomesti","Topoloveni","Traian","Trestiana","Tulcea","Tulnici","Tunari","Turda","Turnu Magurele","Turnu Ruieni","Tuzla","Uioara de Jos","Ungheni","Unirea","Urlati","Urziceni","Utvin","Vacaresti","Valcea","Valea Lupului","Valea Seaca","Valenii de Munte","Vama","Vaslui","Vatra Dornei","Vedea","Vetresti-Herastrau","Victoria","Videle","Vidin","Vidra","Viseu de Jos","Viseu de Sus","Voinesti","Voiteg","Voluntari","Voronet","Zetea","Zimnicea"]},"RS":{"id":"RS","name":"Serbia","timezones":["Europe/Belgrade"],"cities":["Ada","Aleksinac","Apatin","Arilje","Avala","Backa Topola","Backi Jarak","Backi Petrovac","Backo Gradiste","Banatsko Novo Selo","Barajevo","Basaid","Batajnica","Becej","Belgrade","Bocar","Bor","Cantavir","Coka","Cukarica","Cuprija","Debeljaca","Despotovac","Dolovo","Drenovac","Futog","Glozan","Golubinci","Gornji Milanovac","Grocka","Ingija","Izvor","Jagodina","Kacarevo","Kanjiza","Kovin","Kragujevac","Kraljevo","Leskovac","Loznica","Melenci","Nikinci","Nova Pazova","Novi Banovci","Novi Becej","Novi Belgrade","Novi Pazar","Novi Sad","Odzaci","Palic","Paracin","Petrovac","Petrovaradin","Pirot","Popovac","Priboj","Prokuplje","Ratkovo","Ruma","Rumenka","Savski Venac","Selo Mladenovac","Senta","Sibac","Simanovci","Sirig","Smederevo","Sombor","Srbobran","Sremcica","Sremska Kamenica","Sremska Mitrovica","Sremski Karlovci","Stara Pazova","Stari Banovci","Subotica","Surcin","Svilajnac","Svrljig","Temerin","Titel","Tornjos","Ugrinovci","Umcari","Umka","Vajska","Valjevo","Veternik","Vrbas","Zajecar","Zemun Polje","Zlatibor","Zrenjanin"]},"RU":{"id":"RU","name":"Russia","timezones":["Europe/Kaliningrad","Europe/Moscow","Europe/Simferopol","Europe/Volgograd","Europe/Samara","Asia/Yekaterinburg","Asia/Omsk","Asia/Novosibirsk","Asia/Novokuznetsk","Asia/Krasnoyarsk","Asia/Irkutsk","Asia/Chita","Asia/Yakutsk","Asia/Khandyga","Asia/Vladivostok","Asia/Sakhalin","Asia/Ust-Nera","Asia/Magadan","Asia/Srednekolymsk","Asia/Kamchatka","Asia/Anadyr"],"cities":["Abakan","Abinsk","Achinsk","Adygeysk","Agapovka","Agidel","Akhtubinsk","Aksay","Aksenovo","Alapayevsk","Aldan","Aleksandrov","Aleksandrovka","Alekseyevka","Aleksin","Aleksino","Aleysk","Alikovo","Altay","Altayskoye","Amur","Amursk","Anapa","Angarsk","Anuchino","Anzhero-Sudzhensk","Apatity","Apazovo","Aprelevka","Aramil","Ariadnoye","Arkhangelsk","Arkhara","Armavir","Aro","Artem","Arti","Arzamas","Asbest","Asha","Ashchibutak","Asino","Astrakhan","Atkarsk","Atlas","Avangard","Avri","Avtozavodskiy Rayon","Aykino","Azov","Bagan","Baksan","Balabanovo","Balakovo","Balashikha","Balashov","Baltiysk","Barabash","Baranchinskiy","Barda","Barnaul","Bashkortostan","Bataysk","Baykal","Baza","Begunitsy","Belaya Kalitva","Belebey","Belgorod","Belogorka","Belogorsk","Belorechensk","Beloretsk","Belovo","Belyy","Berdsk","Berezayka","Berezniki","Berezovka","Beryozovsky","Betlitsa","Beya","Bezhetsk","Bibayevo","Bilibino","Birobidzhan","Birsk","Birzha","Biysk","Blagovar","Blagoveshchensk","Bogdanovich","Bogdashino","Bogoroditsk","Bogorodsk","Bogorodskoye","Boguchany","Boksitogorsk","Bologoye","Bor","Borisoglebsk","Borkovka","Borodino","Borodynovka","Borovichi","Borovskiy","Borzya","Bovykiny","Bras","Bratsk","Brod","Bronnitsy","Bryansk","Bugry","Bulgakov","Buyantsevo","Buzuluk","Chapayevsk","Chaplygin","Chastyye","Chaykovskiy","Cheboksary","Chekhov","Chelbasskaya","Chelyabinsk","Chemashur","Cheremkhovo","Cherepanovo","Cherepovets","Cherkessk","Cherkizovo","Chernigovka","Chernogolovka","Chernogorsk","Chernushka","Chernyakhovsk","Chesnokovka","Chik","China","Chita","Chiverevo","Chkalov","Chudovo","Chyorny Yar","Dagomys","Dalmatovo","Damkhurts","Danilov","Dedenevo","Dedovsk","Denisovo","Derbent","Desnogorsk","Detchino","Dimitrovgrad","Dinskaya","Divnogorsk","Divo","Dmitriyevka","Dmitrov","Dobryanka","Dolgoprudnyy","Domodedovo","Donetsk","Donskoy","Drezna","Druzhba","Dubenka","Dubna","Dubovka","Dubrovka","Dudinka","Dyurtyuli","Dzerzhinsk","Dzerzhinskiy","Elektrogorsk","Elektrostal","Elektrougli","Elista","Enkheluk","Fatezh","Fialka","Filatovskoye","Filial","Frolovo","Frunzenskiy","Fryazino","Furmanov","Gagarin","Gagino","Gatchina","Gaurilov","Gelendzhik","Georgiyevsk","Georgiyevskoye","Glazov","Glazunovka","Glebychevo","Gogolya","Golitsyno","Golovchino","Gorbatov","Gorin","Gorno-Altaysk","Gornozavodsk","Gorodna","Granit","Grozny","Gryazovets","Gubakha","Gubkin","Gubkinskiy","Gudermes","Gukovo","Gusev","Gusinoozyorsk","Gvardeysk","Ibresi","Ibrya","Iglino","Igra","Ilim","Ilovlya","Ilya","Insar","Inta","Irbit","Irkutsk","Isheyevka","Ishim","Ishimbay","Ishimskiy","Ishkulovo","Ishley","Iskitim","Istra","Ivangorod","Ivanovo","Izberbash","Izhevsk","Izmaylovo","Kabanovo","Kabardino","Kachkanar","Kadrovik","Kalashnikovo","Kalinina","Kaliningrad","Kalininskaya","Kalino","Kaltan","Kaluga","Kamchatka","Kamenka","Kamennogorsk","Kamennomostskiy","Kamenolomni","Kamensk","Kamensk-Shakhtinskiy","Kamyshin","Kamyshovka","Kanash","Kanavka","Kandalaksha","Kanevskaya","Kansk","Karabash","Karabulak","Karachev","Karin Perevoz","Karla Marksa","Kartaly","Kashira","Kasimov","Kasli","Kastornoye","Katav-Ivanovsk","Kavkaz","Kemerovo","Khabarovsk","Khabarskoye","Khangash-Yurt","Khanty-Mansiysk","Kharp","Khasavyurt","Khimki","Kholmistyy","Kholmsk","Khrenovoye","Kichmengskiy Gorodok","Kimovsk","Kimry","Kineshma","Kingisepp","Kirgiz-Miyaki","Kirilly","Kirishi","Kirov","Kirova","Kirovgrad","Kirovo-Chepetsk","Kirovsk","Kirovskaya","Kirsanov","Kiryabinskoye","Kirzhach","Kislovodsk","Kizlyar","Kizner","Klimovsk","Klin","Klintsy","Klyuchi","Klyuchi-Bulak","Kochkurovo","Kodinsk","Kola","Kolomino","Kolomna","Kolpashevo","Kolpino","Komarov","Komintern","Komsomolsk-on-Amur","Konakovo","Kondopoga","Konosha","Kopeysk","Koptyuga","Korkino","Korolev","Korsakov","Koryazhma","Kosteniki","Kostomuksha","Kostroma","Kotlas","Kovdor","Kovrov","Kraskovo","Krasnoarmeysk","Krasnoarmeyskaya","Krasnoarmeyskoye","Krasnodar","Krasnodarskiy","Krasnogorsk","Krasnogorskiy","Krasnogvardeyskiy","Krasnokamensk","Krasnokamsk","Krasnoobsk","Krasnoufimsk","Krasnoyarsk","Krasnoye-na-Volge","Krasnoznamensk","Krasnyy Kut","Krasnyy Sulin","Krasnyy Yar","Kristall","Kromy","Kronshtadt","Kropotkin","Krugloye","Krymsk","Kstovo","Kubinka","Kugesi","Kulikov","Kumertau","Kungur","Kupavna","Kurchatov","Kurgan","Kurganinsk","Kursk","Kurtamysh","Kusa","Kusakovka","Kushnarenkovo","Kushva","Kuybyshev","Kuznetsk","Kuznetskiy Rayon","Kuzovatovo","Kvatchi","Kyshtym","Kyzyl","Labinsk","Labytnangi","Lada","Lakinsk","Lampovo","Lazo","Lebedev","Lenina","Leningradskaya","Leningradskiy","Leninogorsk","Leninsk-Kuznetsky","Leninskiy","Leninskoye","Lenkino","Lermontov","Lesnoy","Lesnoy Gorodok","Lesodacha","Lesosibirsk","Lesozavodsk","Likino-Dulevo","Linda","Linevo","Liniya","Lipetsk","Lisikha","Liski","Livny","Lobnya","Lodeynoye Pole","Lomonosov","Losino-Petrovskiy","Luchegorsk","Lukhovitsy","Luzino","Lyantor","Lytkarino","Lyubertsy","Magadan","Magdagachi","Magnitnyy","Magnitogorsk","Makhachkala","Maksimovka","Malaya Vishera","Malino","Maloyaroslavets","Malysheva","Mamontovka","Mamontovo","Manturovo","Mariinskiy Posad","Markovo","Marks","Maslyanino","Mayakovskogo","Maykop","Maykor","Mednogorsk","Medvedevo","Medvenka","Mega","Megion","Melenki","Meleuz","Metallostroy","Metallurg","Mezhdurechensk","Mga","Miass","Miasskoye","Michurinsk","Mikhaylovskoye","Millerovo","Mineralnye Vody","Minusinsk","Mira","Moldavanskoye","Monchegorsk","Monino","Morozov","Morozovo","Morozovsk","Morshansk","Moscow","Moskovskaya","Moskovskiy","Mostovskoy","Mozdok","Mozhaysk","Mozhga","Mtsensk","Muravlenko","Murmansk","Murmashi","Murom","Myski","Mytishchi","Naberezhnyye Chelny","Nadezhdinka","Nadvoitsy","Nadym","Nakhabino","Nakhodka","Naro-Fominsk","Nartkala","Naryan-Mar","Nauka","Naumkino","Nazarovo","Nazran","Neftekamsk","Neftekumsk","Nefteyugansk","Nelazskoye","Nelidovo","Neman","Neryungri","Neva","Nevinnomyssk","Nevskiy","Neya","Nikel","Nikolayevsk","Nikolayevsk-on-Amur","Nikulin","Nizhegorodskaya","Nizhnekamsk","Nizhneudinsk","Nizhnevartovsk","Nizhneyashkino","Nizhniy Novgorod","Nizhniy Odes","Nizhniy Tagil","Noginsk","Noginskaya","Nova","Novator","Novaya Igirma","Novaya Silava","Novoaltaysk","Novobelokatay","Novocheboksarsk","Novocherkassk","Novodmitriyevka","Novodvinsk","Novokorsunskaya","Novokruchininskiy","Novokuybyshevsk","Novokuznetsk","Novomichurinsk","Novomoskovsk","Novorossiysk","Novoselovo","Novosemeykino","Novoshakhtinsk","Novoshakhtinskiy","Novosibirsk","Novosokolovogorskiy","Novotroitsk","Novovarshavka","Novovoronezh","Novoye Devyatkino","Novozavedennoye","Novozolotovskaya","Novozybkov","Novy Urengoy","Novyy","Noyabrsk","Nyagan","Nytva","Obninsk","Obyedineniye","Ocher","Odintsovo","Ogarev","Okha","Okhansk","Okulovka","Olenegorsk","Olimpiyskiy","Omchak","Omsk","Orekhovo-Zuyevo","Orenburg","Orlovskiy","Orshanka","Orsk","Oshib","Osnova","Ostankino","Ostrov","Otradnoye","Otradnyy","Ovchinnikov","Panayevsk","Pangody","Parapino","Parfino","Pargolovo","Parkovyy","Partizansk","Patrushi","Pavlovo","Pavlovsk","Pavlovskaya","Pavlovskaya Sloboda","Pavlovskiy Posad","Pechora","Pechory","Penza","Perepravnaya","Perm","Perovka","Persianovka","Pervo","Pervomayskaya","Pervouralsk","Peschanka","Pestovo","Petergof","Petropavlovka","Petropavlovsk-Kamchatsky","Petrozavodsk","Pikalyovo","Pioner","Piter","Pitkyaranta","Pivovar","Plavsk","Pleloye","Podgortsy","Podolsk","Podstepki","Pokrov","Polevskoy","Polyarnyy","Poronaysk","Posad","Poselok","Postnikova","Potok","Povarovo","Povedniki","Poztykeres","Pregradnaya","Priozersk","Prirechensk","Progress","Prokhladnyy","Protvino","Pryazha","Pskov","Pskovskoye","Pugachev","Pulkovo","Purovsk","Pushchino","Pushkin","Pushkina","Pushkino","Putilkovo","Pyatigorsk","Pychas","Pyshma","Radist","Raduga","Rakita","Ramenskoye","Rassvet","Ratmirovo","Raychikhinsk","Redkino","Reftinskiy","Reutov","Revda","Rezh","Rikasikha","Rodionovka","Rodionovo-Nesvetayskaya","Rodniki","Romanovka","Rosa","Roshchino","Rossiyskiy","Rostov","Rostov-on-Don","Rostovskaya","Rovnoye","Rozhdestvenka","Rubin","Rubtsovsk","Russa","Ruza","Ruzayevka","Ryasnoye","Ryazan","Rybinsk","Rybnoye","Rzhev","Safonovo","Saint Petersburg","Salavat","Salekhard","Salym","Samara","Samsonovka","Saransk","Sarapul","Saratov","Sarov","Sartykov","Sary","Satis","Satka","Sayanogorsk","Sayansk","Sebezh","Segezha","Selo","Selyatino","Semibratovo","Semyonov","Serafimovskiy","Serdobsk","Sergeyevka","Sergiyev Posad","Sergiyevskoye","Serov","Serpukhov","Sertolovo","Seryshevo","Sestroretsk","Severo","Severo-Zapad","Severodvinsk","Severomorsk","Seversk","Severskaya","Sevsk","Shadrinsk","Shakhty","Shalinskoye","Shalushka","Sharapova Okhota","Sharnutovskiy","Shatura","Shaturtorf","Shchekino","Shchelkovo","Shebalino","Shebekino","Sheksna","Shelekhov","Sheregesh","Shoshma","Shumerlya","Sibay","Sistema","Skala","Skat","Skovorodino","Slantsy","Slavgorod","Slavyanka","Slavyansk-na-Kubani","Sloboda","Slyudyanka","Smolensk","Smolenskaya","Snegiri","Snezhinsk","Snezhinskiy","Snezhnogorsk","Sobinka","Sochi","Sodyshka","Sofrino","Sokol","Sokolovo","Soldatskoye","Solikamsk","Solnechnogorsk","Sorochinsk","Sortavala","Sosnogorsk","Sosnovo","Sosnovoborsk","Sosnovyy Bor","Sosny","Sovetsk","Sovetskiy","Spas-Demensk","Spassk","Sputnik","Sredneuralsk","Srostki","Staraya Kupavna","Staraya Russa","Starobachaty","Starodub","Staronizhestebliyevskaya","Staropesterevo","Starovelichkovskaya","Start","Stary Oskol","Stavropol","Sterlitamak","Strezhevoy","Stroiteley","Studenets","Stupino","Sukhanovo","Surgut","Surkhakhi","Sursk","Sverdlova","Sverdlovskaya","Sverdlovskiy","Svetlaya","Svetlogorsk","Svetlograd","Svetlyy","Svetogorsk","Sviblovo","Svirsk","Svobodnaya","Svobodnyy","Syamzha","Syktyvkar","Taganrog","Tagil","Taksimo","Taldom","Tambov","Tapkhar","Tarko-Sale","Tarusa","Tatlybayevo","Taushkasy","Tayga","Tayshet","Tazovskiy","Techa","Temryuk","Teykovo","Tikhoretsk","Tikhvin","Tim","Timiryazev","Tochka","Tolstoy","Tolyatti","Tomilino","Tomsk","Topki","Torzhok","Tosno","Trekhgornyy","Troitsk","Troitsko-Pechorsk","Trubchevsk","Tsna","Tsudakhar","Tuapse","Tuchkovo","Tula","Tulun","Turinsk","Tuymazy","Tver","Tynda","Tyrma","Tyrnyauz","Tyumen","Uchaly","Udomlya","Ufa","Uglegorsk","Uglich","Ugra","Ugresha","Ukhta","Uktuz","Ulan-Ude","Ulyanovsk","Unecha","Ural","Uray","Urengoy","Urgal","Urus-Martan","Uryupinsk","Urzhum","Usinsk","Usinskoye","Uspenskoye","Ussuriysk","Uvarovo","Uyar","Uzlovaya","Vagay","Valday","Valentin","Vanino","Varvarovka","Vega","Velikiy Ustyug","Velikiye Luki","Veliky Novgorod","Verkhnekazymskiy","Verkhniy Ufaley","Verkhnyaya Pyshma","Verkhnyaya Salda","Veshki","Vichuga","Vidnoye","Vikhorevka","Vinsady","Vitebskaya","Vladikavkaz","Vladimir","Vladivostok","Vladykino","Vnukovo","Volga","Volgodonsk","Volgograd","Volgorechensk","Volkhonshchino","Volkhov","Volna","Volochek","Volodarskiy","Vologda","Volovo","Volzhsk","Volzhskiy","Vorkuta","Voronezh","Voronezhskiy","Vorovskogo","Voskresensk","Voskresenskoye","Vostochnaya","Vostochnyy","Votkinsk","Vsevolozhsk","Vurnary","Vyatka","Vyatskiye Polyany","Vyazemskiy","Vyazniki","Vyborg","Vyksa","Vysokogornyy","Vysokovsk","Vytegra","Yakhroma","Yakovlevo","Yakutsk","Yalta","Yalutorovsk","Yanaul","Yaratovo","Yaroslavl","Yashkino","Yaya","Yekaterinburg","Yekaterinoslavka","Yekaterinovka","Yelabuga","Yelanskiy","Yelets","Yelizovo","Yermolkino","Yessentuki","Yeysk","Yoshkar-Ola","Yugorsk","Yugra","Yurga","Yuzhno-Sakhalinsk","Zainsk","Zaokskiy","Zaozersk","Zaprudnya","Zaraysk","Zarechenskiy","Zarechnyy","Zarinsk","Zavodoukovsk","Zavodouspenskoye","Zelenodolsk","Zelenogorsk","Zelenograd","Zelenogradsk","Zernograd","Zeya","Zheleznodorozhnyy","Zheleznogorsk","Zheleznogorsk-Ilimskiy","Zheleznovodsk","Zhigulevsk","Zhirnovsk","Zhukovskiy","Zhukovskogo","Zhuravna","Zima","Zlatoust","Zolotarevka","Zori","Zubovo","Zvenigorod","Zvenigovo","Zvezda"]},"RW":{"id":"RW","name":"Rwanda","timezones":["Africa/Maputo"],"cities":[]},"SA":{"id":"SA","name":"Saudi Arabia","timezones":["Asia/Riyadh"],"cities":["Abha","Abqaiq","Al Bahah","Al Faruq","Al Hufuf","Al Qatif","Al Yamamah","At Tuwal","Buraidah","Dammam","Dhahran","Hayil","Jazirah","Jeddah","Jizan","Jubail","Khamis Mushait","Khobar","Khulays","Linah","Madinat Yanbu` as Sina`iyah","Mecca","Medina","Mina","Najran","Rabigh","Rahimah","Rahman","Ramdah","Ras Tanura","Riyadh","Sabya","Safwa","Sakaka","Sambah","Sayhat","Tabuk","Yanbu` al Bahr"]},"SB":{"id":"SB","name":"Solomon Islands","timezones":["Pacific/Guadalcanal"],"cities":[]},"SC":{"id":"SC","name":"Seychelles","timezones":["Indian/Mahe"],"cities":[]},"SD":{"id":"SD","name":"Sudan","timezones":["Africa/Khartoum"],"cities":["Kassala","Khartoum","Nyala","Shendi","Thabit","Umm Durman"]},"SE":{"id":"SE","name":"Sweden","timezones":["Europe/Stockholm"],"cities":["Aby","AElmhult","AElvdalen","AElvkarleby","AElvsbyn","Agnesberg","Agunnaryd","Akarp","Akers Styckebruk","Akersberga","Alafors","Alandsbro","Aled","Alem","Alfta","Alingsas","Allerum","Almeboda","Almunge","Alno","Alsen","Alsterbro","Alstermo","Alta","Altersbruk","Alunda","Alvangen","Alvesta","Alvsjo","Amal","Ambjornarp","Amotfors","Anderslov","Anderstorp","Aneby","Ange","Angered","Ankarsrum","Ankarsvik","Annelov","Annerstad","Ansvar","Aplared","Arboga","Arbra","Arholma","Arjaeng","Arjeplog","Arkelstorp","Arla","Arloev","Arnasvall","Arsunda","Arvidsjaur","Arvika","Aryd","As","Asa","Asarna","Asarum","Asbro","Aseda","Asele","Asenhoga","Asensbruk","Ashammar","Askersund","Askim","Askloster","Asmundtorp","Aspas","Aspered","Aspero","Astorp","Atorp","Atran","Atvidaberg","Avesta","Axvall","Backa","Backaryd","Backe","Backefors","Balinge","Ballingslov","Balsta","Bankeryd","Bara","Barkarby","Barseback","Barsebackshamn","Bastad","Beddinge Lage","Bengtsfors","Berga","Bergeforsen","Bergkvara","Bergshamra","Bergsjoe","Bergvik","Bettna","Billdal","Billeberga","Billesholm","Billinge","Billingsfors","Bjarnum","Bjarred","Bjartra","Bjasta","Bjorbo","Bjoringe","Bjorkhaga","Bjorklinge","Bjorkoby","Bjorkvik","Bjorna","Bjorneborg","Bjornlunda","Bjuraker","Bjurholm","Bjursas","Bjuv","Blackstad","Blasmark","Blattnicksele","Blentarp","Bockara","Bodafors","Boden","Bofors","Bohus","Boliden","Bollebygd","Bollnas","Bollstabruk","Bor","Borensberg","Borghamn","Borgholm","Borgstena","Borrby","Botsmark","Bottnaryd","Boxholm","Braas","Braecke","Brakne-Hoby","Bralanda","Bramhult","Branno","Brastad","Bredared","Bredaryd","Bro","Broby","Brokind","Bromma","Bromoella","Brosarp","Brottby","Brunflo","Brunnby","Bua","Bullmark","Bunkeflostrand","Burea","Burtraesk","Bygdea","Bygdsiljum","Byske","Charlottenberg","Dala-Floda","Dala-Jarna","Dalaro","Dalby","Dals Langed","Dals Rostock","Dalsjofors","Dalstorp","Danderyd","Degeberga","Degerfors","Deje","Delsbo","Dikanaes","Dingle","Dio","Djura","Djuras","Djurhamn","Djursholm","Domsjo","Donso","Dorotea","Dosjebro","Drottningholm","Duved","Dyltabruk","Ed","Edsbro","Edsbyn","Edsele","Edshultshall","Edsvalla","Ekeby","Ekenassjon","Ekshaerad","Eksjoe","Eldsberga","Elloes","Emmaboda","Enanger","Enebyberg","Eneryda","Enkoping","Enskede-Arsta-Vantoer","Enviken","Erikslund","Eriksmala","Eskilstuna","Eslov","Faergelanda","Faerjestaden","Fagelfors","Fageras","Fagerberg","Fagered","Fagerhult","Fagersanna","Fagersta","Fagervik","Falkenberg","Fallfors","Falun","Farbo","Farila","Farlov","Farna","Farnas","Faro","Fellingsbro","Fengersfors","Figeholm","Filipstad","Finja","Finnerodja","Finspang","Fiskeby","Fjaeras station","Fjalkinge","Fjardhundra","Fjugesta","Flen","Fleninge","Flisby","Floby","Floda","Flyinge","Follinge","Fors","Forsa","Forsbacka","Forsby","Forserum","Forshaga","Forsheda","Forslov","Frandefors","Fransta","Fredriksberg","Frillesas","Fristad","Fritsla","Froso","Frovi","Frufallan","Furulund","Furuvik","Gabo","Gagnef","Gallo","Gallstad","Gamla stan","Gamleby","Gammelstad","Ganghester","Gards Kopinge","Gargnas","Garpenberg","Garphyttan","Garsas","Garsnas","Gemla","Genarp","Genevad","Getinge","Gidea","Gimo","Gislaved","Glanshammar","Glimakra","Glommen","Glommerstrask","Glostorp","Glumslov","Gnarp","Gnesta","Gnosjoe","Goetene","Gota","Gothenburg","Grabo","Graddo","Graestorp","Grangarde","Grangesberg","Grasmyr","Graso","Grebbestad","Grillby","Grimeton","Grimsas","Grimslov","Grimstorp","Grisslehamn","Grondal","Gronskara","Grums","Grundsund","Grycksbo","Gryt","Grythyttan","Gualov","Guldsmedshyttan","Gullbrandstorp","Gullspang","Gunnebo","Gunnilse","Gusselby","Gustafs","Gustavsberg","Gusum","Gyttorp","Hackas","Hacksvik","Haegersten","Haellefors","Haerryda","Haesselby","Hagfors","Hagglund","Hajom","Hakkas","Haknas","Haljarp","Hallabro","Halland","Hallarod","Hallberg","Halleforsnas","Hallekis","Hallestad","Hallevadsholm","Hallingsjo","Hallsberg","Hallsta","Hallstahammar","Hallstavik","Halmstad","Halso","Halta","Hamburgsund","Hammar","Hammaro","Hammarstrand","Hammenhog","Hammerdal","Hamneda","Hamrangefjarden","Hanaskog","Handen","Haparanda","Harads","Harbo","Harby","Harestad","Harmanger","Harplinge","Harslov","Hasselby","Hasselfors","Hasslarp","Hasslo","Hastveda","Havdhem","Hebo","Hedared","Hede","Hedekas","Hedemora","Hedesunda","Helgum","Helsingborg","Hemmingsmark","Hemse","Henan","Herrangen","Herrljunga","Hestra","Hillared","Hillerstorp","Hindas","Hjaerup","Hjalteby","Hjarnarp","Hjartum","Hjo","Hoegsby","Hoeoer","Hoerby","Hoernefors","Hofors","Hoganas","Hogsaters","Hogsjo","Hok","Hokerum","Hollviken","Holmen","Holmsjo","Holmsund","Holmsveden","Holo","Holsbybrunn","Holsljunga","Hono","Horn","Horndal","Horred","Hortlax","Hova","Hovas","Hoviksnas","Hovmantorp","Huarod","Huddinge","Hudiksvall","Hultafors","Hultsfred","Hunnebostrand","Hunnestad","Huskvarna","Husum","Hyllinge","Hyltebruk","Hyssna","Iggesund","Immeln","Indal","Ingarp","Ingelstad","Ingmarso","Insjon","Jaemjoe","Jaervsoe","Jamshog","Jarbo","Jarlasa","Jarna","Jarpen","Jarved","Joern","Johanneshov","Johannishus","Jokkmokk","Jonaker","Jonsered","Jordbro","Jorlanda","Jude","Junosuando","Kaevlinge","Kage","Kagerod","Kalix","Kallby","Kallered","Kallinge","Kallo","Kalmar","Kareby","Karesuando","Karl Gustav","Karlsborg","Karlshamn","Karlskoga","Karlskrona","Karlstad","Karna","Karra","Katrineholm","Kattarp","Katthammarsvik","Kattilstorp","Kil","Kilafors","Killeberg","Kimstad","Kinna","Kinnared","Kinnarp","Kiruna","Kisa","Kista","Kivik","Kladesholmen","Klagerup","Klagshamn","Klagstorp","Klassbol","Klavrestrom","Klintehamn","Klippan","Klovedal","Knared","Knislinge","Knivsta","Knutby","Kode","Kolback","Kolmarden","Kolsva","Konga","Koping","Kopingebro","Kopmanholmen","Kopparberg","Koppom","Korpilombolo","Korsberga","Korskrogen","Koskullskulle","Kosta","Kramfors","Kristdala","Kristianstad","Kristineberg","Kristinehamn","Krokom","Krylbo","Kulla","Kullavik","Kulltorp","Kumla","Kungsaengen","Kungsbacka","Kungsgarden","Kungshamn","Kungsoer","Kvanum","Kvibille","Kvicksund","Kvidinge","Kvissleby","Kyrkobyn","Lagan","Laholm","Lammhult","Landeryd","Landfjarden","Landsbro","Landskrona","Landvetter","Langas","Langasjo","Langhem","Langsele","Langshyttan","Langviksmon","Lanna","Lannavaara","Larbro","Larv","Lavsjo","Laxa","Lekeryd","Leksand","Lenhovda","Lerberget","Lerdala","Lerum","Lessebo","Liden","Lidhult","Lidingoe","Lidkoping","Likenas","Lilla Edet","Lillpite","Lima","Limhamn","Limmared","Lindas","Lindesberg","Lindome","Linghem","Linneryd","Listerby","Lit","Ljugarn","Ljung","Ljungaverk","Ljungby","Ljungbyhed","Ljungbyholm","Ljungsarp","Ljungsbro","Ljungskile","Ljusdal","Ljusfallshammar","Ljusne","Ljustero","Ljustorp","Loberod","Loddekopinge","Loderup","Lodose","Lomma","Lonashult","Lonsboda","Los","Lotorp","Lottorp","Lovanger","Lovestad","Lovikka","Ludvigsborg","Ludvika","Lugnvik","Lund","Lycke","Lyckeby","Lycksele","Lysekil","Lysvik","Mala","Maleras","Malilla","Malma","Malmback","Malmberget","Malmkoping","Malmo","Malsryd","Malung","Mankarbo","Mansarp","Mantorp","Marback","Mardaklev","Mariannelund","Mariefred","Marieholm","Mariestad","Markaryd","Marma","Marsta","Marstrand","Matfors","Mellansel","Mellbystrand","Mellerud","Mjallom","Mjolby","Mockfjard","Moelle","Moelndal","Moensteras","Moerbylanga","Moheda","Moholm","Moliden","Molkom","Molltorp","Molnbo","Molnlycke","Mora","Morarp","Morgongava","Morlunda","Morrum","Morsil","Morup","Motala","Mullhyttan","Mullsjoe","Munka-Ljungby","Munkedal","Munkfors","Musko","Myggenas","Myresjo","Nacka","Nalden","Nashulta","Nassjo","Nasum","Nasviken","Nattraby","Navekvarn","Navlinge","Nissafors","Njurundabommen","Njutanger","Nodinge","Nodinge-Nol","Nora","Norberg","Nordingra","Nordmaling","Norrahammar","Norrala","Norrfjarden","Norrhult","Norrsundet","Norrtalje","Norsborg","Norsholm","Norsjoe","Nossebro","Nybro","Nygard","Nyhammar","Nyhamnslage","Nykil","Nykroppa","Nykvarn","Nyland","Nynas","Nynashamn","Nysater","Nyvang","Obbola","Ockelbo","Odakra","Odeborg","Odensbacken","OEckeroe","OEdeshoeg","OErkelljunga","OEsterbymo","OEstervala","OEsthammar","OEverkalix","OEvertornea","Ojebyn","Ojersjo","Olofstorp","Olofstroem","Olsfors","Onnestad","Orby","Orbyhus","Oregrund","Ormaryd","Orno","Ornskoldsvik","Orrefors","Orsa","Orsundsbro","Orviken","Osby","Oskarshamn","Oskarstrom","Osmo","Ostansjo","Osterbybruk","Osterhaninge","Osterskar","Ostra","Ostra Frolunda","Ostra Hindalebyn","Ostra Karup","Ostra Ryd","Otterbacken","Ovanaker","Overhornas","Overkovland","Overlida","Overum","Oviken","Oxaback","Oxelosund","Oxie","Paarp","Pajala","Palange","Palsboda","Partille","Paskallavik","Perstorp","Pilgrimstad","Pixbo","Raa","Raettvik","Ramdala","Ramnas","Ramsele","Ramsjo","Ramvik","Ranea","Rangedala","Ransater","Ransta","Ravlanda","Reftele","Rejmyre","Rekarne","Rengsjo","Reso","Restad","Riddarhyttan","Rimbo","Rimforsa","Ring","Ringarum","Rinkaby","Roback","Robertsfors","Rockneby","Rodeby","Roke","Rolfstorp","Romakloster","Romelanda","Ronnang","Ronneby","Ronninge","Roro","Rorvik","Rosersberg","Rosson","Rostanga","Rosvik","Rotebro","Rottne","Ruda","Rundvik","Ryd","Rydaholm","Rydboholm","Rydeback","Rydobruk","Rydsgard","Ryssby","Saeffle","Saeter","Saevar","Saevast","Saevsjoe","Sagmyra","Sala","Saltsjo-Duvnas","Saltsjobaden","Sand","Sandared","Sandarne","Sandby","Sandhem","Sandhult","Sandviken","Sankt Olof","Saro","Satila","Savedalen","Savsjostrom","Saxtorp","Segersta","Seglora","Segmon","Sennan","Sexdrega","Sibbhult","Sidensjo","Sifferbo","Sigtuna","Siljansnas","Simlangsdalen","Simrishamn","Sjalevad","Sjoebo","Sjomarken","Sjotofta","Sjovik","Sjuntorp","Ska","Skaerhamn","Skaerholmen","Skallinge","Skane","Skanes Fagerhult","Skanninge","Skanor med Falsterbo","Skara","Skaraborg","Skarblacka","Skarplinge","Skarpnaeck","Skattkarr","Skee","Skelleftehamn","Skene","Skepplanda","Skillingaryd","Skillinge","Skinnskatteberg","Skivarp","Skogas","Skoghall","Skogstorp","Skoldinge","Skollersta","Skondal","Skruv","Skultuna","Skummeslovsstrand","Skurup","Skyllberg","Skyttorp","Slite","Sloinge","Slottsbron","Slutarp","Smalandsstenar","Smedjebacken","Smedstorp","Smoegen","Soderakra","Soderala","Soderby","Soderfors","Sodergard","Soderhamn","Sodra Sandby","Sodra Sunderbyn","Sodra Vi","Soederbaerke","Soederkoeping","Sollebrunn","Solleftea","Sollentuna","Solna","Sommen","Soraker","Sorberge","Sorombacken","Sorsele","Sosdala","Sovde","Spanga","Sparsor","Spekerod","Staffanstorp","Stallarholmen","Stalldalen","Stanga","Stehag","Stenhamra","Stenkullen","Stensele","Stenstorp","Stenungsund","Stigen","Stigtomta","Stjarnhov","Stoby","Stockaryd","Stockholm","Stocksund","Stode","Stollet","Stora","Stora Hoga","Stora Mellosa","Stora Skedvi","Stora Vika","Storebro","Storfors","Storlien","Storuman","Storvik","Storvreta","Stra","Strangnas","Stratjara","Stravalla","Stroemstad","Stroemsund","Stromsbruk","Stromsholm","Stromsnasbruk","Strovelstorp","Stugun","Sturefors","Sturko","Styrso","Sundborn","Sundbyberg","Sundsbruk","Sundsvall","Sunnansjo","Sunne","Sunnemo","Surahammar","Surte","Svaloev","Svaneholm","Svanesund","Svangsta","Svardsjo","Svarta","Svartinge","Svartsjo","Svedala","Sveg","Svenljunga","Svensbyn","Svenshogen","Svenstavik","Taberg","Taby","Taenndalen","Taernaby","Taftea","Tagarp","Talje","Taljo","Tallasen","Tallberg","Tanumshede","Tarnsjo","Tavelsjo","Teckomatorp","Tegeltorp","Tenhult","Tibro","Tidaholm","Tidan","Tierp","Timmele","Timmernabben","Timmersdala","Timra","Tingsryd","Tingstade","Tjornarp","Toecksfors","Toere","Toereboda","Tolg","Tollarp","Tollered","Tomelilla","Torekov","Tormestorp","Torpshammar","Torsaker","Torsas","Torsby","Torshalla","Torslanda","Torup","Tranas","Tranemo","Trangsund","Transtrand","Traryd","Traslovslage","Travad","Trehorningsjo","Trekanten","Trelleborg","Trollhattan","Trosa","Tullinge","Tumba","Tun","Tungelsta","Tvaaker","Tvaralund","Tving","Tygelsjo","Tyreso Strand","Tyringe","Tystberga","Ucklum","Uddebo","Uddeholm","Uddevalla","Ugglarp","Ullared","Ulricehamn","Ulrika","Undersaker","Unnaryd","Uppharad","Upplands Vasby","Uppsala","Urshult","Ursviken","Utansjo","Uttran","Vackelsang","Vaddo","Vaderstad","Vadstena","Vaeja","Vaellingby","Vaennaes","Vaermdoe","Vaggeryd","Vagnharad","Valadalen","Valberg","Valbo","Valdemarsvik","Valla","Vallakra","Vallda","Vallentuna","Vallsta","Valskog","Vanersborg","Vankiva","Vannasby","Vansbro","Vara","Varberg","Varby","Varekil","Vargarda","Vargon","Varing","Varmland","Varnamo","Varnhem","Varobacka","Varsas","Varsta","Vartofta","Vase","Vassmolosa","Vasterfarnebo","Vasterljung","Vastervik","Vastra Amtervik","Vastra Frolunda","Vastra Karup","Vastra Ramlosa","Vastra Torup","Vato","Vattholma","Vaxholm","Vaxjo","Vaxtorp","Veberod","Veddige","Vedum","Vega","Vegby","Veinge","Vejbystrand","Vellinge","Vendelso","Vessigebro","Vetlanda","Vidsel","Vikarbyn","Viken","Vikingstad","Vikmanshyttan","Viksjofors","Vilhelmina","Villan","Vimmerby","Vinberg","Vindeln","Vingaker","Vinninga","Vinslov","Vintrie","Vintrosa","Virsbo Bruk","Virserum","Visby","Viskafors","Vislanda","Vissefjarda","Vitaby","Vittaryd","Vittsjo","Vollsjo","Vrena","Vreta Kloster","Vretstorp","Yngsjo","Ystad","Ytterby","Zinkgruvan"]},"SG":{"id":"SG","name":"Singapore","timezones":["Asia/Singapore"],"cities":["Ang Mo Kio New Town","Ayer Raja New Town","Bedok New Town","Boon Lay","Bukit Batok New Town","Bukit Panjang New Town","Bukit Timah","Bukit Timah Estate","Changi Village","Choa Chu Kang New Town","Clementi New Town","Holland Village","Hougang","Jurong East New Town","Jurong Town","Jurong West New Town","Kalang","Kampong Pasir Ris","Kembangan","Pandan Valley","Pasir Panjang","Punggol","Queenstown Estate","Serangoon","Simei New Town","Singapore","Tai Seng","Tampines New Town","Tanglin Halt","Tanjong Pagar","Toa Payoh New Town","Woodlands New Town","Yew Tee","Yishun New Town"]},"SH":{"id":"SH","name":"St Helena","timezones":["Africa/Abidjan"],"cities":[]},"SI":{"id":"SI","name":"Slovenia","timezones":["Europe/Belgrade"],"cities":["Ankaran","Begunje na Gorenjskem","Beltinci","Besnica","Bevke","Bistrica pri Rusah","Bled","Bohinjska Bela","Borovnica","Breginj","Brestanica","Breznica","Cemsenik","Cerklje ob Krki","Cerknica","Cersak","Cirkovce","Crensovci","Dekani","Dob","Dobravlje","Dobrova","Dobrunje","Dol pri Ljubljani","Dolenjske Toplice","Dornava","Dravograd","Globoko","Gmajnica","Gorenja Vas","Gorisnica","Gornja Radgona","Grize","Grosuplje","Horjul","Hotedrsica","Hrastnik","Hrusica","Idrija","Ig","Ilirska Bistrica","Izola","Jesenice","Kamnik","Kidricevo","Knezak","Kobarid","Kojsko","Komenda","Koper","Krajna","Kranj","Kranjska Gora","Lenart v Slov. Goricah","Lendava","Lesce","Limbus","Litija","Ljubecna","Ljubljana","Log pri Brezovici","Logatec","Lokev","Lovrenc na Dravskem Polju","Lovrenc na Pohorju","Maribor","Markovci","Medvode","Menges","Mezica","Miklavz na Dravskem Polju","Miren","Mirna","Mojstrana","Moravce","Mozirje","Murska Sobota","Naklo","Notranje Gorice","Nova Cerkev","Nova Gorica","Novo Mesto","Pernica","Pesnica pri Mariboru","Petrovce","Piran","Pobegi","Podbocje","Polhov Gradec","Poljcane","Polzela","Postojna","Prebold","Preserje","Prestranek","Prevalje","Ptuj","Puconci","Radlje ob Dravi","Radomlje","Radovljica","Rakek","Ravne","Ravne na Koroskem","Rocinj","Secovlje","Selnica ob Dravi","Sempeter pri Gorici","Sencur","Sentjanz","Sentvid pri Sticni","Sevnica","Skofljica","Slovenj Gradec","Slovenska Bistrica","Slovenske Konjice","Smarje","Smarje pri Jelsah","Smarje-Sap","Smartno ob Paki","Smlednik","Sostanj","Spodnje Hoce","Spodnji Brnik","Spodnji Duplek","Spodnji Ivanjci","Sredisce ob Dravi","Stahovica","Stara Cerkev","Stari Trg pri Lozu","Starse","Tisina","Tolmin","Trbovlje","Trzic","Trzin","Velenje","Velika Loka","Verzej","Videm","Vipava","Vodice","Vojnik","Vrhnika","Zagorje ob Savi","Zelezniki","Zgornja Polskava","Zgornje Gorje","Zgornje Hoce","Zgornje Skofije","Zidani Most","Ziri"]},"SJ":{"id":"SJ","name":"Svalbard & Jan Mayen","timezones":["Europe/Oslo"],"cities":[]},"SK":{"id":"SK","name":"Slovakia","timezones":["Europe/Prague"],"cities":["Bahon","Baka","Banovce nad Bebravou","Bardejov","Bela","Beladice","Bernolakovo","Besenov","Blatnica","Bobrov","Bohdanovce","Boleraz","Borovce","Branc","Bratislava","Brezno","Brezova pod Bradlom","Bystricka","Cecejovce","Cechynce","Cerova","Cerveny Hradok","Cerveny Kamen","Chlebnice","Chorvatsky Grob","Chtelnica","Cifer","Detva","Diakovce","Diviaky nad Nitricou","Dlha nad Oravou","Dlhe Klcovo","Dlhe nad Cirochou","Dolna Marikova","Dolna Streda","Dolne Oresany","Dolne Vestenice","Dolny Hricov","Dolny Stal","Druzstevna pri Hornade","Eliasovce","Fintice","Galanta","Gbely","Gelnica","Giraltovce","Golianovo","Handlova","Hencovce","Hlinik","Hlinik nad Hronom","Hlohovec","Holic","Holice","Horna Lehota","Horna Stubna","Horne Oresany","Horne Saliby","Horny Smokovec","Hradiste","Hrinova","Hrochot,Slovakia","Hruby Sur","Ilava","Istebne","Ivanka pri Dunaji","Jablonove","Jacovce","Jasenica","Jaslovske Bohunice","Jelenec","Jelka","Kajal","Kanianka","Klatova Nova Ves","Klokoc","Klokocov","Kolarovo","Komjatice","Kopcany","Kosicka Nova Ves","Kremnica","Krizovany nad Dudvahom","Krompachy","Krupina","Krusovce","Kukova","Kvetoslavov","Kysucky Lieskovec","Ladce","Lednicke Rovne","Lehota","Lemesany","Levice","Likavka","Liptovske Revuce","Liptovsky Hradok","Lozorno","Lubina","Ludanice","Lukacovce","Madunice","Malacky","Maly Lapas","Marianka","Martin","Mesto","Michalovce","Miloslavov","Mojmirovce","Moldava nad Bodvou","Moravany nad Vahom","Mutne","Myjava","Nana","Nededza","Nitra","Nitrianske Rudno","Nitrianske Sucany","Nizna","Nizna Kamenica","Nova Bana","Novaky","Nove Sady","Novy Salas","Nyrovce","Okoc","Olesna","Opatovce nad Nitrou","Opoj","Oravske Vesele","Pastuchov","Pata","Pernek","Pezinok","Plave Vozokany","Plavecke Podhradie","Pliesovce","Pobedim","Podbrezova","Podolie","Polomka","Poprad","Potvorice","Praha","Prakovce","Praznovce","Prievidza","Proc","Reca","Rosina","Rovinka","Ruzindol","Sabinov","Samorin","Sarisske Bohdanovce","Secovce","Secovska Polianka","Selice","Selpice","Sena","Senec","Senica","Sipkove","Skalica","Sladkovicovo","Slovenska Ves","Slovensky Grob","Smizany","Snina","Sobrance","Solosnica","Spacince","Spissky Hrusov","Spissky Stiavnik","Spissky Stvrtok","Stara Lesna","Stara Tura","Stary Smokovec","Staskov","Stefanov","Stropkov","Studienka","Stupava","Sucany","Sucha nad Parnou","Svaty Kriz","Svaty Peter","Svit","Svodin","Tajov","Terchova","Tesedikovo","Tlmace","Tomasov","Torysky","Trnava","Trnovec nad Vahom","Trstena","Turany","Tvrdosin","Tvrdosovce","Udavske","Urmince","Vahovce","Varhanovce","Varin","Vecelkov","Velcice","Velicna","Velky Meder","Vinne","Vitanova","Vlckovce","Vlkanova","Vojcice","Vrable","Vrutky","Vysne Raslavice","Vysny Orlik","Zakamenne","Zavod","Zbince","Zelenec","Zeliezovce","Ziar nad Hronom","Zikava","Zlate","Zuberec","Zvolen"]},"SL":{"id":"SL","name":"Sierra Leone","timezones":["Africa/Abidjan"],"cities":[]},"SM":{"id":"SM","name":"San Marino","timezones":["Europe/Rome"],"cities":["Acquaviva","Falciano","Fiorentino","San Marino","Serravalle"]},"SN":{"id":"SN","name":"Senegal","timezones":["Africa/Abidjan"],"cities":["Boussinki","Camberene","Dakar","Dodji","Guediawaye","Kaolack","Kedougou","Louga","Madina Kokoun","Saint-Louis","Sama","Tanaf"]},"SO":{"id":"SO","name":"Somalia","timezones":["Africa/Nairobi"],"cities":[]},"SR":{"id":"SR","name":"Suriname","timezones":["America/Paramaribo"],"cities":["Botopasi","Brownsweg","Friendship","Groningen","Moengo","Nieuw Amsterdam","Onverwacht","Paramaribo","Totness"]},"SS":{"id":"SS","name":"South Sudan","timezones":["Africa/Khartoum"],"cities":[]},"ST":{"id":"ST","name":"Sao Tome & Principe","timezones":["Africa/Abidjan"],"cities":[]},"SV":{"id":"SV","name":"El Salvador","timezones":["America/El_Salvador"],"cities":["Ahuachapan","Antiguo Cuscatlan","Apaneca","Apopa","Ayutuxtepeque","Botoncillal El Botoncillo","Coatepeque","Colon","Colonia Escalon","Cuscatancingo","Delgado","Gigante","Guazapa","Ilopango","La Libertad","Lourdes","Mejicanos","Nuevo Cuscatlan","Ozatlan","San Jose Villanueva","San Marcos","San Miguel","San Salvador","Santa Ana","Santa Tecla","Santiago Texacuangos","Sonsonate","Soyapango","Usulutan","Zaragoza"]},"SX":{"id":"SX","name":"St Maarten (Dutch part)","timezones":["America/Curacao"],"cities":[]},"SY":{"id":"SY","name":"Syria","timezones":["Asia/Damascus"],"cities":[]},"SZ":{"id":"SZ","name":"Swaziland","timezones":["Africa/Johannesburg"],"cities":["Kwaluseni","Lobamba","Manzini","Mbabane","Piggs Peak"]},"TC":{"id":"TC","name":"Turks & Caicos Is","timezones":["America/Grand_Turk"],"cities":[]},"TD":{"id":"TD","name":"Chad","timezones":["Africa/Ndjamena"],"cities":[]},"TF":{"id":"TF","name":"French Southern & Antarctic Lands","timezones":["Indian/Reunion","Indian/Kerguelen"],"cities":[]},"TG":{"id":"TG","name":"Togo","timezones":["Africa/Abidjan"],"cities":[]},"TH":{"id":"TH","name":"Thailand","timezones":["Asia/Bangkok"],"cities":["Amnat Charoen","Amphawa","Amphoe Aranyaprathet","Ang Thong","Ayutthaya","Ban Ang Thong","Ban Bang Phli Nakhon","Ban Bang Plong","Ban Bueng","Ban Don Sak","Ban Hua Thale","Ban Khlong Ngae","Ban Khlong Prasong","Ban Khlong Prawet","Ban Khlong Takhian","Ban Ko Pao","Ban Na","Ban Nam Hak","Ban Pat Mon","Ban Phichit","Ban Phlam","Ban Pong Lang","Ban Pratunam Tha Khai","Ban Talat Rangsit","Ban Tha Duea","Ban Tha Pai","Ban Tha Ruea","Ban Tham","Ban Wang Yai","Bang Kapi","Bang Khae","Bang Khun Thian","Bang Kruai","Bang Lamung","Bang Na","Bang Phlat","Bang Sao Thong","Bang Sue","Bangkok","Buriram","Cha-am","Chachoengsao","Chaiyaphum","Chanthaburi","Chatuchak","Chiang Mai","Chiang Muan","Chiang Rai","Chon Buri","Chulabhorn","Chumphon","Din Daeng","Don Mueang","Dusit","Hat Yai","Hua Hin","Huai Khwang","Ka Bang","Kalasin","Kamphaeng Phet","Kanchanaburi","Kathu","Khan Na Yao","Khlong Luang","Khlong San","Khlong Toei","Khlung","Khon Kaen","Klaeng","Kosum Phisai","Krabi","Krathum Baen","Kumphawapi","Lampang","Lamphun","Lat Krabang","Loei","Long","Lopburi","Mae Hong Son","Mae Sot","Maha Sarakham","Makkasan","Manorom","Min Buri","Muak Lek","Mueang Nonthaburi","Mueang Samut Prakan","Mukdahan","Nakhon Pathom","Nakhon Ratchasima","Nakhon Sawan","Nakhon Si Thammarat","Nan","Narathiwat","New Sukhothai","Non Thai","Nong Bua","Nong Bua Lamphu","Nong Khai","Nong Prue","Pak Kret","Pathum Thani","Pathum Wan","Pattani","Pattaya","Phachi","Phan","Phang Khon","Phang Nga","Phanna Nikhom","Phatthalung","Phaya Thai","Phayao","Phetchabun","Phetchaburi","Phichit","Phitsanulok","Photharam","Phrae","Phuket","Prachin Buri","Prachuap Khiri Khan","Prakanong","Ranong","Ratchaburi","Rawai","Rayong","Roi Et","Sa Kaeo","Sakon Nakhon","Salaya","Sam Khok","Sam Sen","Samphanthawong","Samut Sakhon","Samut Songkhram","San Sai","Sathon","Sattahip","Satun","Sena","Si Racha","Si Sa Ket","Sing Buri","Songkhla","Suan Luang","Sung Noen","Suphan Buri","Surin","Tak","Thalang","Thanyaburi","Thon Buri","Trang","Trat","Ubon Ratchathani","Udon Thani","Uthai Thani","Uttaradit","Wang Thonglang","Watthana","Wiphawadi","Yala","Yasothon"]},"TJ":{"id":"TJ","name":"Tajikistan","timezones":["Asia/Dushanbe"],"cities":[]},"TK":{"id":"TK","name":"Tokelau","timezones":["Pacific/Fakaofo"],"cities":[]},"TL":{"id":"TL","name":"East Timor","timezones":["Asia/Dili"],"cities":[]},"TM":{"id":"TM","name":"Turkmenistan","timezones":["Asia/Ashgabat"],"cities":[]},"TN":{"id":"TN","name":"Tunisia","timezones":["Africa/Tunis"],"cities":["Ariana","Beja","Gafsa","Hammamet","Le Bardo","Manouba","Monastir","Rades","Sfax","Sidi Bouzid","Sousse","Tunis"]},"TO":{"id":"TO","name":"Tonga","timezones":["Pacific/Tongatapu"],"cities":[]},"TR":{"id":"TR","name":"Turkey","timezones":["Europe/Istanbul"],"cities":["Abdullah","Acibadem","Ada","Adana","Adnan Menderes","Afyonkarahisar","Akhisar","Aksaray","Alanya","Alpaslan","Amasra","Amasya","Andac","Ankara","Antakya","Antalya","Ardahan","Artvin","Atakoy","Ataturk","Atlas","Ayazaga","Aydin","Aydogan","Aydogdu","Babaeski","Balcova","Banaz","Bandirma","Bartin","Basari","Baskent","Baskil","Batman","Bayburt","Bayrampasa","Belek","Bergama","Besiktas","Beykent","Beykoz","Beysehir","Biga","Bilecik","Bilgi","Bingol","Birbir","Bitam","Bitlis","Bodrum","Bogazici","Bolu","Bor","Bornova","Bozuyuk","Buca","Bucak","Bueyuekcekmece","Bugdayli","Bulut","Burdur","Burgaz","Burhaniye","Bursa","Calkaya","Camliyayla","Cekme","Celal","Cermik","Ceyhan","Cine","Cukurova","Dalaman","Darica","Dayanikli","Demetevleri","Deniz","Denizli","Doga","Dogankoy","Dogu","Dogus","Dokuz","Dortyol","Doruklu","Dumlupinar","Duran","Duzce","Edebey","Edirne","Edremit","Elbistan","Elek","Erbaa","Ercis","Erciyes","Erenkoy","Erzin","Erzincan","Erzurum","Esenkent","Esentepe","Esenyurt","Eser","Eskisehir","Etimesgut","Fatih","Ferizli","Fethiye","Findikli","Gazi","Gaziantep","Gebze","Gediz","Gelibolu","Gemlik","Germencik","Geulzuk","Giresun","Girne","Golmarmara","Gonen","Gunbuldu","Guzelyurt","Hakkari","Halic","Harbiye","Harran","Hendek","Hurriyet","Ibrahim","Ikitelli","Iskilip","Isparta","Istanbul","Izmir","Kadikoey","Kadikoy","Kadir","Kadirli","Kagithane","Karabuk","Karaca","Karakoy","Karaman","Karamursel","Karatekin","Kars","Kartal","Kastamonu","Kayseri","Kecioeren","Kemal","Kibriskoy","Kilis","Kirikkale","Kisir","Kocakoy","Kocatepe","Konak","Konya","Korfez","Kozan","Kucukcekmece","Kumluca","Kusadasi","Kuzey","Magnesia ad Sipylum","Mahmutkoy","Malatya","Maltepe","Manavgat","Mardin","Marmaris","Maslak","Mehmet Akif Ersoy","Meliksah","Meric","Mersin","Merzifon","Mezitli","Milas","Mugla","Muradiye","Muratpasa","Mustafa","Mustafa Kemal","Mustafakemalpasa","Nazilli","Niksar","Niluefer","Nizip","Ordu","Orhangazi","Orta","Osmaneli","Osmangazi","Osmaniye","Ostim","Pamukkale","Patnos","Pendik","Piri","Rize","Sabanci","Safranbolu","Saglik","Sahinbey","Salihli","Samsun","Sanayi","Sanliurfa","Sariyer","Seferihisar","Sehitkamil","Selcuk","Serdivan","Serik","Seydisehir","Seyhan","Siirt","Sile","Silifke","Siliviri","Sinankoy","Sincan","Sinop","Sirnak","Sisli","Sisman","Sivas","Soeke","Suleyman","Sultanpinar","Sungurlu","Susurluk","Taksim","Tarsus","Tasdelen","Tatvan","Tesvikiye","Tire","Tokat Province","Toprak","Torbali","Toros","Trabzon","Trakya","Tunceli","Turgut","Turgutlu","Uchisar","UEskuedar","Ugur","Ulker","Uludag","Ulus","Umraniye","Unieh","Urgub","Urla","Uzun Keupru","Van","Yagcilar","Yakakoy","Yalova","Yaman","Yasarkoy","Yeditepe","Yeni","Yenibosna","Yildiz","Yozgat","Yuregir","Zekeriya","Zeytinburnu","Zonguldak"]},"TT":{"id":"TT","name":"Trinidad & Tobago","timezones":["America/Port_of_Spain"],"cities":[]},"TV":{"id":"TV","name":"Tuvalu","timezones":["Pacific/Funafuti"],"cities":[]},"TW":{"id":"TW","name":"Taiwan","timezones":["Asia/Taipei"],"cities":["Budai","Caogang","Chang-hua","Checheng","Chiayi","Dahu","Douliu","Erlin","Fanlu","Fengshan","Gangshan","Gaozhongyicun","Hemei","Hengchun","Hsinchu","Hualian","Jincheng","Kao-sung","Kaohsiung City","Keelung","Linkou","Lugang","Ma-kung","Maru","Matsu","Meilun","Miaoli","Nanhua","Nankan","Nantou","Neihu","Pingtung","Pozi","Puli","Shalun","Shetou","Shoufeng","Shuilin","Shuiliu","Shuishang","Shulin","Shuyi","Suqin","Taichang","Taichung","Tainan","Taipei","Taipingding","Taitung","Taoyuan","Toucheng","Tuchang","Wan-hua","Wangtongwen","Wanluan","Wutai","Xinji","Xinzhuang","Yangmei","Yanping","Yilan","Yuli","Yunlin County","Zhubei","Zhunan","Zhuqi"]},"TZ":{"id":"TZ","name":"Tanzania","timezones":["Africa/Nairobi"],"cities":["Arusha","Bukoba","Dar es Salaam","Dodoma","Morogoro","Mwanza","Njombe","Raha","Tanga","Zanzibar"]},"UA":{"id":"UA","name":"Ukraine","timezones":["Europe/Kiev","Europe/Uzhgorod","Europe/Zaporozhye"],"cities":["Aleksandriya","Aleksandrovka","Alekseyevo-Druzhkovka","Alupka","Alushta","Babin","Barashivka","Baryshivka","Belaya","Berdychiv","Berehove","Bila Hora","Bila Tserkva","Bolekhiv","Borodyanka","Bortnychi","Boryslav","Boryspil","Boryspil Raion","Boyarka","Bozhenka","Brody","Brovary","Bryanka","Bucha","Buchach","Bukova","Bushtyno","Cherkasy","Chernev","Chernihiv","Chernivtsi","Chervona Hirka","Chervonohrad","Chop","Darakhov","Davydov","Desna","Dimitrov","Dmitrovichi","Dnipropetrovsk","Donetsk","Drohobych","Druzhkovka","Dubno","Dzhankoy","Energodar","Fastiv","Feodosiya","Fontanka","Frunze","German","Goncharov","Gorlovka","Grebenyuk","Haysyn","Hlukhiv","Horlivka","Horodenka","Hoshiv","Illintsi","Irpin","Ivankov","Ivanov","Izmail","Kakhovka","Kalush","Kalynivka","Kaniv","Kerch","Kharkiv","Kherson","Khust","Khyzha","Kiev","Kirovohrad","Kirovsk","Knyazhychi","Kolomyia","Komsomolsk","Konotop","Korosten","Korostyshiv","Kovel","Kozyatyn","Kramatorsk","Krasnodon","Krasnohrad","Kremenchuk","Kremenets","Kreminna","Kryvyy Rih","Kuna","Kurakhovo","Kurylivka","Kuznetsovsk","Kvasyliv","Kyseliv","Kyyiv","Lanovka","Lenina","Letychiv","Lisichansk","Lityn","Lohvynove","Lubny","Lugansk","Luganskoye","Luhansk","Lutsk","Lutugino","Lviv","Makariv","Makiyivka","Maksim","Mala Tokmachka","Malyn","Mariupol","Markova","Mega","Melitopol","Merefa","Monastyryshche","Mukacheve","Mykolayiv","Mylove","Nadezhda","Netishyn","Nizhyn","Nosivka","Novi Sanzhary","Novomoskovsk","Novyy Buh","Obukhov","Odesa","Oleh","Oreanda","Osnova","Osypenko","Pavlograd","Pavlohrad","Petranka","Petrenky","Pobeda","Podol","Poltava","Poplavy","Pyrohiv","Rayhorodka","Rivne","Rodinskoye","Romaniv","Romny","Rovenki","Rubizhne","Saky","Selidovo","Semen","Sencha","Serhiyi","Sevastopol","Shepetivka","Shevchenka","Shevchenko","Shostka","Shpola","Simferopol","Slavuta","Sloviansk","Slynkivshchyna","Smila","Sokol","Sokoliv","Soroka","Soroki","Sorotskoye","Spas","Stakhanov","Stanislav","Stat","Stryi","Sudak","Sumy","Svalyava","Svessa","Teplodar","Teremky","Ternopil","Ternovka","Tkachenka","Tokmak","Toporov","Torez","Trypillia","Tsvetkov","Tsyurupinsk","Turka","Tyachiv","Ugledar","Ukrayinka","Uzhhorod","Vasylkiv","Vinnytsya","Volkov","Volnovakha","Voronovo","Vorovskiy","Voznesenka","Vyshhorod","Vyshneve","Yalta","Yasinovataya","Yenakiyeve","Zabolotiv","Zaporizhia","Zaporozhe","Zastava","Zavod","Zdolbuniv","Zhashkiv","Zhdanovka","Zhmerynka","Zhytomyr","Zlazne","Zmiyiv","Zolochiv","Zolotonosha"]},"UG":{"id":"UG","name":"Uganda","timezones":["Africa/Nairobi"],"cities":[]},"UM":{"id":"UM","name":"US minor outlying islands","timezones":["Pacific/Pago_Pago","Pacific/Wake","Pacific/Honolulu"],"cities":[]},"US":{"id":"US","name":"United States","timezones":["America/New_York","America/Detroit","America/Kentucky/Louisville","America/Kentucky/Monticello","America/Indiana/Indianapolis","America/Indiana/Vincennes","America/Indiana/Winamac","America/Indiana/Marengo","America/Indiana/Petersburg","America/Indiana/Vevay","America/Chicago","America/Indiana/Tell_City","America/Indiana/Knox","America/Menominee","America/North_Dakota/Center","America/North_Dakota/New_Salem","America/North_Dakota/Beulah","America/Denver","America/Boise","America/Phoenix","America/Los_Angeles","America/Metlakatla","America/Anchorage","America/Juneau","America/Sitka","America/Yakutat","America/Nome","America/Adak","Pacific/Honolulu"],"cities":["Abbeville","Abbotsford","Abbott","Abbottstown","Abercrombie","Aberdeen","Aberdeen Proving Ground","Abernathy","Abilene","Abingdon","Abington","Abington Township","Abiquiu","Abita Springs","Abrams","Absarokee","Absecon","Acampo","Access","Accident","Accokeek","Accomac","Accord","Accoville","Achille","Achilles","Ackerly","Ackerman","Ackley","Acme","Acton","Acushnet","Acworth","Ada","Adah","Adair","Adairsville","Adairville","Adak","Adams","Adams Center","Adams Run","Adamstown","Adamsville","Addieville","Addis","Addison","Addyston","Adel","Adelanto","Adell","Adena","Adger","Adin","Adkins","Admire","Adolphus","Adona","Adrian","Advance","Afton","Agar","Agate","Agawam","Agency","Agoura Hills","Agra","Aguanga","Aguila","Ahoskie","Ahwahnee","Aiken","Ailey","Ainsworth","Air Force Academy","Airville","Airway Heights","Aitkin","Ajo","Akaska","Akeley","Akhiok","Akiachak","Akiak","Akron","Akutan","Alabaster","Alachua","Alakanuk","Alamance","Alameda","Alamo","Alamogordo","Alamosa","Alanson","Alapaha","Alba","Albany","Albemarle","Albers","Albert City","Albert Lea","Alberton","Albertson","Albertville","Albia","Albin","Albion","Alborn","Albright","Albrightsville","Albuquerque","Alburg","Alburnett","Alburtis","Alcalde","Alcester","Alcoa","Alcolu","Alda","Alden","Alderpoint","Alderson","Aldie","Aldrich","Aledo","Alex","Alexander","Alexander City","Alexandria","Alexandria Bay","Alexis","Alford","Alfred","Alfred Station","Alger","Algodones","Algoma","Algona","Algonac","Algonquin","Alhambra","Alice","Aliceville","Aline","Aliquippa","Aliso Viejo","Alkol","Allamuchy","Allardt","Allegan","Allegany","Allen","Allen Park","Allendale","Allenhurst","Allenport","Allenspark","Allenton","Allentown","Allenwood","Allerton","Alliance","Allison","Allison Park","Allons","Alloway","Allston","Allyn","Alma","Alma Center","Almena","Almira","Almo","Almond","Almont","Alna","Alpaugh","Alpena","Alpha","Alpharetta","Alpine","Alplaus","Alsea","Alsey","Alsip","Alstead","Alta","Alta Vista","Altadena","Altamont","Altamonte Springs","Altaville","Altavista","Altenburg","Altha","Altmar","Alto","Alton","Alton Bay","Altona","Altoona","Altura","Alturas","Altus","Alum Bank","Alum Creek","Alva","Alvada","Alvarado","Alvaton","Alverda","Alverton","Alvin","Alviso","Alvo","Alvord","Alvordton","Ama","Amagansett","Amana","Amanda","Amargosa Valley","Amarillo","Amawalk","Amazonia","Amberg","Ambler","Amboy","Ambridge","Ambrose","Amelia","Amelia Court House","Amenia","America","American Canyon","American Falls","American Fork","Americus","Amery","Ames","Amesbury","Amesville","Amherst","Amherst Junction","Amherstdale","Amidon","Amissville","Amite","Amity","Amityville","Ammon","Amo","Amoret","Amory","Amsterdam","Amston","Anacoco","Anaconda","Anacortes","Anadarko","Anaheim","Anahola","Anahuac","Anamosa","Anchor Point","Anchorage","Ancona","Andale","Andalusia","Anderson","Andersonville","Andes","Andover","Andreas","Andrew","Andrews","Andrews Air Force Base","Angel Fire","Angelica","Angie","Angier","Angle Inlet","Angleton","Angola","Angoon","Angora","Anguilla","Angwin","Animas","Anita","Aniwa","Ankeny","Anmoore","Ann Arbor","Anna","Annabella","Annandale","Annandale-on-Hudson","Annapolis","Annawan","Anniston","Annona","Annville","Anoka","Anselmo","Ansley","Anson","Ansonia","Ansted","Antelope","Anthem","Anthon","Anthony","Antigo","Antioch","Antlers","Antrim","Antwerp","Anza","Apache","Apache Junction","Apalachicola","Apalachin","Apex","Apison","Aplington","Apollo","Apollo Beach","Apopka","Appalachia","Apple Creek","Apple River","Apple Valley","Applegate","Appleton","Appleton City","Appling","Appomattox","Aptos","Aquasco","Aquashicola","Aquebogue","Aquilla","Arab","Arabi","Aragon","Aransas Pass","Arapaho","Arapahoe","Ararat","Arbela","Arbon","Arbovale","Arbuckle","Arbyrd","Arcade","Arcadia","Arcanum","Arcata","Archbald","Archbold","Archer","Archer City","Archie","Arco","Arcola","Arden","Ardmore","Ardsley","Aredale","Arena","Arenas Valley","Arendtsville","Arenzville","Argenta","Argillite","Argonia","Argonne","Argos","Argusville","Argyle","Ariel","Arimo","Arispe","Ariton","Arivaca","Arizona City","Arkadelphia","Arkansas City","Arkdale","Arkoma","Arkville","Arlee","Arley","Arlington","Arlington Heights","Arma","Armada","Armagh","Armington","Armona","Armonk","Armour","Armstrong","Armuchee","Arnaudville","Arnegard","Arnett","Arnold","Arnoldsburg","Arnoldsville","Aroma Park","Aromas","Aroostook Band of Micmac Trust Land","Arp","Arpin","Arriba","Arrington","Arrowsmith","Arroyo Grande","Arroyo Hondo","Arroyo Seco","Artesia","Artesian","Arthur","Arthur City","Arvada","Arverne","Arvin","Arvonia","Ary","Asbury","Asbury Park","Ascutney","Ash","Ash Flat","Ash Fork","Ash Grove","Ash Hill","Ashaway","Ashburn","Ashburnham","Ashby","Ashcamp","Ashdown","Asheboro","Asherton","Asheville","Ashfield","Ashford","Ashkum","Ashland","Ashland City","Ashley","Ashmore","Ashtabula","Ashton","Ashville","Askov","Asotin","Aspen","Aspermont","Aspers","Assaria","Assonet","Assumption","Astatula","Aston Arms","Astor","Astoria","Atalissa","Atascadero","Atascosa","Atchison","Atco","Atglen","Athelstane","Athena","Athens","Atherton","Athol","Atkins","Atkinson","Atlanta","Atlantic","Atlantic Beach","Atlantic City","Atlantic Highlands","Atlantic Mine","Atlasburg","Atmore","Atoka","Atqasuk","Attalla","Attapulgus","Attica","Attleboro","Attleboro Falls","Atwater","Atwood","Au Gres","Au Sable Forks","Au Train","Auberry","Aubrey","Auburn","Auburn Hills","Auburndale","Audubon","Augusta","Aulander","Ault","Aumsville","Aurelia","Aurora","Austell","Austerlitz","Austin","Austinburg","Austinville","Autaugaville","Autryville","Auxier","Auxvasse","Ava","Avalon","Avella","Avenal","Avenel","Aventura","Averill Park","Avery","Avila Beach","Avilla","Avinger","Aviston","Avoca","Avon","Avon Lake","Avon Park","Avon-by-the-Sea","Avondale","Avondale Estates","Avonmore","Awendaw","Axis","Axtell","Axton","Ayden","Ayer","Aylett","Aynor","Azalea","Azle","Aztec","Azusa","Babb","Babbitt","Babcock","Babson Park","Babylon","Backus","Bacliff","Bad Axe","Baden","Badger","Badin","Bagdad","Baggs","Bagley","Bagwell","Bahama","Bailey","Bailey Island","Baileys Harbor","Baileyton","Baileyville","Bainbridge","Bainbridge Island","Bainville","Baird","Bairdford","Baisden","Baker","Baker City","Bakersfield","Bakersville","Bakewell","Bala-Cynwyd","Balaton","Bald Knob","Baldwin","Baldwin City","Baldwin Park","Baldwin Place","Baldwinsville","Baldwinville","Baldwyn","Ball","Ball Ground","Ballantine","Ballico","Ballinger","Ballston Lake","Ballston Spa","Ballwin","Bally","Balsam Lake","Baltic","Baltimore","Bamberg","Bancroft","Bandera","Bandon","Bangor","Bangs","Banks","Bankston","Banner","Banner Elk","Banning","Bannister","Banquete","Bantam","Bapchule","Baptistown","Bar Harbor","Baraboo","Baraga","Barbeau","Barberton","Barboursville","Barbourville","Barclay","Bardstown","Bardwell","Bargersville","Baring","Bark River","Barkhamsted","Barling","Barlow","Barnard","Barnardsville","Barnegat","Barnes","Barnes City","Barnesville","Barnet","Barneveld","Barney","Barnhart","Barnsdall","Barnstable","Barnstead","Barnum","Barnwell","Baroda","Barre","Barren Springs","Barrett","Barrington","Barron","Barronett","Barrow","Barry","Barryton","Barryville","Barstow","Bart Township","Bartelso","Bartlesville","Bartlett","Bartley","Barto","Barton","Bartonsville","Bartow","Basalt","Bascom","Basehor","Basile","Basin","Basking Ridge","Bassett","Bassfield","Bastrop","Basye","Batavia","Batchelor","Batchtown","Bates City","Batesburg","Batesville","Bath","Bathgate","Baton Rouge","Batson","Battle Creek","Battle Ground","Battle Lake","Battle Mountain","Battleboro","Baudette","Bausman","Bauxite","Baxley","Baxter","Baxter Springs","Bay City","Bay Minette","Bay Port","Bay Saint Louis","Bay Shore","Bay Springs","Bay Village","Bayard","Bayboro","Bayfield","Bayonne","Bayport","Bayside","Baytown","Bayview","Bayville","Bazine","Beach","Beach City","Beach Haven","Beach Lake","Beachwood","Beacon","Beacon Falls","Bealeton","Beaman","Bean Station","Beans Purchase","Bear","Bear Creek","Bear Lake","Bear River City","Bearden","Beardstown","Bearsville","Beasley","Beatrice","Beattie","Beatty","Beattyville","Beaufort","Beaumont","Beauty","Beaver","Beaver Bay","Beaver Creek","Beaver Crossing","Beaver Dam","Beaver Falls","Beaver Meadows","Beaver Springs","Beaverdam","Beaverton","Beavertown","Bechtelsville","Beckemeyer","Becker","Becket","Beckley","Beckville","Bedford","Bedford Hills","Bedford Park","Bedias","Bedminster","Bee Branch","Bee Spring","Beebe","Beech Bluff","Beech Bottom","Beech Creek","Beech Grove","Beech Island","Beecher","Beecher City","Beechgrove","Beechmont","Beeville","Beggs","Bel Air","Bel Alton","Belcamp","Belchertown","Belcourt","Belden","Beldenville","Belding","Belen","Belfair","Belfast","Belfield","Belford","Belfry","Belgium","Belgrade","Belhaven","Belington","Belknap","Bell","Bell Buckle","Bell City","Bell Island Hot Springs","Bella Vista","Bellaire","Bellbrook","Belle","Belle Center","Belle Chasse","Belle Fourche","Belle Glade","Belle Haven","Belle Mead","Belle Plaine","Belle Rose","Belle Valley","Belle Vernon","Belleair Beach","Bellefontaine","Bellefonte","Bellemont","Bellerose","Belleview","Belleville","Bellevue","Bellflower","Bellingham","Bellmawr","Bellmore","Bellows Falls","Bellport","Bells","Bellville","Bellvue","Bellwood","Belmar","Belmond","Belmont","Beloit","Belpre","Belt","Belton","Beltrami","Beltsville","Belvidere","Belvidere Center","Belview","Belvue","Belzoni","Bement","Bemidji","Bemus Point","Ben Lomond","Ben Wheeler","Bena","Benavides","Bend","Bendersville","Benedict","Benham","Benicia","Benkelman","Benld","Bennet","Bennett","Bennettsville","Bennington","Benoit","Bensalem","Bensenville","Benson","Bent","Bent Mountain","Bentleyville","Benton","Benton City","Benton Harbor","Benton Ridge","Bentonia","Bentonville","Benwood","Benzonia","Berea","Beresford","Bergen","Bergenfield","Berger","Bergheim","Berkeley","Berkeley Heights","Berkeley Springs","Berkley","Berkshire","Berlin","Berlin Center","Berlin Heights","Bern","Bernalillo","Bernard","Bernardston","Bernardsville","Berne","Bernice","Bernie","Bernville","Berrien Center","Berrien Springs","Berry","Berry Creek","Berrysburg","Berryton","Berryville","Bertha","Berthoud","Bertram","Bertrand","Berwick","Berwind","Berwyn","Beryl","Bessemer","Bessemer City","Bethalto","Bethania","Bethany","Bethany Beach","Bethel","Bethel Island","Bethel Park","Bethel Springs","Bethesda","Bethlehem","Bethpage","Bethune","Betsy Layne","Bettendorf","Beulah","Beulaville","Beverly","Beverly Hills","Bevington","Bickmore","Bicknell","Biddeford","Bidwell","Bieber","Big Bay","Big Bear","Big Bear Lake","Big Bend","Big Cabin","Big Cove Tannery","Big Creek","Big Falls","Big Flats","Big Horn","Big Lake","Big Pine","Big Pine Key","Big Piney","Big Pool","Big Rapids","Big Rock","Big Sandy","Big Sky","Big Spring","Big Springs","Big Stone City","Big Stone Gap","Big Sur","Big Timber","Big Wells","Bigbend","Bigelow","Bigfoot","Bigfork","Biggs","Biggsville","Biglerville","Bill","Billerica","Billings","Biloxi","Bim","Binford","Bingen","Binger","Bingham Lake","Binghamton","Biola","Bippus","Birch River","Birch Run","Birch Tree","Birchleaf","Birchwood","Bird City","Bird in Hand","Bird Island","Birdsboro","Birdseye","Birdsnest","Birmingham","Birnamwood","Bisbee","Biscoe","Bishop","Bishopville","Bismarck","Bison","Bitely","Bivalve","Bivins","Biwabik","Bixby","Blachly","Black Canyon City","Black Creek","Black Diamond","Black Eagle","Black Earth","Black Hawk","Black Mountain","Black River","Black River Falls","Black Rock","Blackduck","Blackfoot","Blackhawk","Blacklick","Blacksburg","Blackshear","Blackstock","Blackstone","Blacksville","Blackville","Blackwater","Blackwell","Blackwood","Bladenboro","Bladensburg","Blain","Blaine","Blair","Blairs","Blairs Mills","Blairsburg","Blairstown","Blairsville","Blakely","Blakesburg","Blakeslee","Blanch","Blanchard","Blanchardville","Blanchester","Blanco","Bland","Blandburg","Blandford","Blanding","Blandinsville","Blandon","Blauvelt","Bledsoe","Blencoe","Blenheim","Blenker","Blessing","Bliss","Blissfield","Block Island","Blockton","Blodgett","Blodgett Mills","Bloomburg","Bloomdale","Bloomer","Bloomery","Bloomfield","Bloomfield Hills","Blooming Glen","Blooming Grove","Blooming Prairie","Bloomingburg","Bloomingdale","Bloomington","Bloomington Springs","Bloomsburg","Bloomsbury","Bloomsdale","Bloomville","Blossburg","Blossom","Blossvale","Blountstown","Blountsville","Blountville","Blowing Rock","Blue","Blue Ball","Blue Bell","Blue Creek","Blue Earth","Blue Eye","Blue Grass","Blue Hill","Blue Island","Blue Jay","Blue Lake","Blue Mound","Blue Mounds","Blue Mountain","Blue Mountain Lake","Blue Point","Blue Rapids","Blue Ridge","Blue Ridge Summit","Blue River","Blue Springs","Bluebell","Bluefield","Bluejacket","Bluemont","Bluewater","Bluff","Bluff City","Bluff Dale","Bluffs","Bluffton","Bluford","Blum","Bly","Blythe","Blytheville","Blythewood","Boalsburg","Boardman","Boaz","Bob White","Bobtown","Boca Grande","Boca Raton","Bode","Bodega Bay","Bodfish","Boelus","Boerne","Bogalusa","Bogard","Bogart","Bogata","Boggstown","Bogota","Bogue Chitto","Bohannon","Bohemia","Boiceville","Boiling Springs","Boise","Boise City","Boissevain","Bokchito","Bokeelia","Bolckow","Boligee","Bolinas","Boling","Bolingbroke","Bolingbrook","Bolivar","Bolivia","Bolt","Bolton","Bolton Landing","Bomont","Bon Aqua","Bonaire","Bonaparte","Bondsville","Bonduel","Bondurant","Bondville","Bone Gap","Bonfield","Bonham","Bonifay","Bonita","Bonita Springs","Bonlee","Bonne Terre","Bonneau","Bonner Springs","Bonnerdale","Bonners Ferry","Bonney Lake","Bonnie","Bonnieville","Bonnots Mill","Bonnyman","Bono","Bonsall","Boody","Booker","Boomer","Boone","Boones Mill","Booneville","Boonsboro","Boonton","Boonville","Boothbay","Boothbay Harbor","Borden","Bordentown","Borger","Boring","Boron","Borrego Springs","Boscobel","Bosque Farms","Bossier City","Bostic","Boston","Bostwick","Boswell","Bosworth","Bothell","Botkins","Bottineau","Boulder","Boulder City","Boulder Creek","Boulder Town","Boulevard","Bound Brook","Bountiful","Bourbon","Bourbonnais","Bourg","Boutte","Bovard","Bovey","Bovina","Bovina Center","Bow","Bow Center","Bowdoin Center","Bowdoinham","Bowdon","Bowerston","Bowersville","Bowie","Bowler","Bowling Green","Bowlus","Bowman","Bowmanstown","Bowmansville","Box Elder","Box Springs","Boxford","Boxholm","Boyce","Boyceville","Boyd","Boyden","Boyds","Boydton","Boyers","Boyertown","Boyle","Boylston","Boyne City","Boyne Falls","Boynton","Boynton Beach","Bozeman","Braceville","Bracey","Brackenridge","Brackettville","Brackney","Braddock","Bradenton","Bradenton Beach","Bradenville","Bradford","Bradley","Bradley Beach","Bradley Junction","Bradner","Bradshaw","Brady","Bradyville","Bragg City","Braham","Braidwood","Brainerd","Braintree","Braithwaite","Braman","Bramwell","Branch","Branch Township","Branchland","Branchville","Brandamore","Brandenburg","Brandon","Brandt","Brandy Station","Brandywine","Branford","Branson","Brant","Brant Lake","Brantingham","Braselton","Brashear","Brasher Falls","Brasstown","Brattleboro","Brave","Brawley","Braxton","Brayton","Brazil","Brazoria","Brea","Breaux Bridge","Breckenridge","Brecksville","Breda","Breese","Breezewood","Breezy Point","Breinigsville","Bremen","Bremerton","Bremo Bluff","Brenham","Brent","Brentwood","Bretton Woods","Brevard","Brewer","Brewerton","Brewster","Brewton","Brian Head","Briarcliff Manor","Bricelyn","Briceville","Brick Township","Bridge City","Bridgehampton","Bridgeport","Bridger","Bridgeton","Bridgeview","Bridgeville","Bridgewater","Bridgewater Corners","Bridgman","Bridgton","Brielle","Brier Hill","Brierfield","Brigantine","Briggs","Briggsdale","Brigham City","Brighton","Brightwaters","Brightwood","Brilliant","Brillion","Brimfield","Brimley","Bringhurst","Brinkley","Brisbane","Briscoe","Bristol","Bristolville","Bristow","Britt","Brittany","Britton","Broad Brook","Broad Run","Broadalbin","Broaddus","Broadlands","Broadus","Broadview","Broadview Heights","Broadway","Brockport","Brockton","Brockway","Brocton","Brodhead","Brodheadsville","Brodnax","Brogue","Brohard","Broken Arrow","Broken Bow","Bronaugh","Bronson","Bronston","Bronte","Bronwood","Bronxville","Brook","Brook Park","Brookdale","Brookeland","Brooker","Brookeville","Brookfield","Brookhaven","Brookings","Brookland","Brooklandville","Brooklet","Brooklin","Brookline","Brooklyn","Brookport","Brooks","Brookshire","Brookston","Brooksville","Brookton","Brooktondale","Brookville","Brookwood","Broomall","Broomfield","Brooten","Broseley","Broughton","Broussard","Browder","Brown City","Brownell","Brownfield","Browning","Browns Mills","Browns Summit","Browns Valley","Brownsboro","Brownsburg","Brownsdale","Brownstown","Brownsville","Browntown","Brownville","Brownwood","Broxton","Bruce","Bruceton","Bruceton Mills","Bruceville","Bruin","Brule","Brundidge","Bruner","Bruni","Bruning","Bruno","Brunsville","Brunswick","Brush","Brush Prairie","Brushton","Brusly","Brussels","Bryan","Bryans Road","Bryant","Bryant Pond","Bryantville","Bryce Canyon","Bryce Canyon City","Bryceville","Bryn Athyn","Bryn Mawr","Bryson","Bryson City","Buchanan","Buchanan Dam","Buckatunna","Buckeye","Buckeystown","Buckfield","Buckhannon","Buckhead","Buckholts","Buckingham","Buckingham Township","Buckland","Buckley","Bucklin","Buckner","Bucksport","Bucyrus","Bud","Buda","Budd Lake","Bude","Buellton","Buena","Buena Park","Buena Vista","Buffalo","Buffalo Center","Buffalo Gap","Buffalo Grove","Buffalo Lake","Buffalo Valley","Buford","Buhl","Buhler","Buies Creek","Bulan","Bulger","Bull Shoals","Bullard","Bullhead","Bullhead City","Bullock","Bulls Gap","Bullville","Bulpitt","Bulverde","Bumpass","Bumpus Mills","Buna","Bunceton","Bunch","Buncombe","Bunker Hill","Bunkie","Bunn","Bunnell","Bunnlevel","Bunola","Buras","Burbank","Burden","Burdett","Burdick","Bureau","Burgaw","Burgess","Burgettstown","Burgin","Burkburnett","Burke","Burkesville","Burket","Burkeville","Burleson","Burley","Burlingame","Burlington","Burlington Flats","Burlington Junction","Burlison","Burnet","Burnettsville","Burney","Burneyville","Burnham","Burns","Burns Flat","Burnside","Burnsville","Burnt Hills","Burr","Burr Hill","Burrton","Burt","Burton","Burtonsville","Burtrum","Burwell","Busby","Bush","Bushkill","Bushland","Bushnell","Bushton","Buskirk","Busy","Butler","Butlerville","Butner","Butte","Butte des Morts","Butterfield","Butternut","Buttonwillow","Buxton","Buzzards Bay","Byers","Byesville","Byfield","Byhalia","Bylas","Bynum","Byram","Byrdstown","Byron","Byron Center","Cabazon","Cabery","Cabin Creek","Cabin John","Cable","Cabool","Cabot","Cache","Cactus","Caddo","Caddo Gap","Caddo Mills","Cade","Cades","Cadet","Cadillac","Cadiz","Cadott","Cadyville","Cainsville","Cairnbrook","Cairo","Calabasas","Calabash","Calais","Calamus","Calder","Caldwell","Caledonia","Calera","Calexico","Calhan","Calhoun","Calhoun City","Calhoun Falls","Calico Rock","Caliente","Califon","California","California City","Calimesa","Calipatria","Calistoga","Callahan","Callao","Callaway","Callicoon","Calmar","Calpella","Calpine","Calumet","Calumet City","Calvert","Calvert City","Calverton","Calypso","Camanche","Camano","Camarillo","Camas","Cambria","Cambria Heights","Cambridge","Cambridge City","Cambridge Springs","Cambridgeport","Camby","Camden","Camden Point","Camdenton","Cameron","Cameron Mills","Camilla","Camillus","Camino","Camp Creek","Camp Dennison","Camp Douglas","Camp H M Smith","Camp Hill","Camp Meeker","Camp Point","Camp Verde","Camp Wood","Campbell","Campbell Hall","Campbell Hill","Campbellsburg","Campbellsport","Campbellsville","Campbelltown","Campo","Campobello","Campti","Campton","Campton Upper Village","Campus","Cana","Canaan","Canada","Canadensis","Canadian","Canajoharie","Canal Fulton","Canal Point","Canal Winchester","Canalou","Canandaigua","Canastota","Canby","Candia","Candler","Cando","Candor","Canehill","Caney","Caneyville","Canfield","Canisteo","Canmer","Cannel City","Cannelton","Cannon","Cannon Falls","Cannonville","Canoga Park","Canon","Canon City","Canonsburg","Canterbury","Canton","Cantonment","Cantrall","Canute","Canutillo","Canvas","Canyon","Canyon City","Canyon Country","Canyon Lake","Canyonville","Capac","Cape Canaveral","Cape Charles","Cape Coral","Cape Elizabeth","Cape Fair","Cape Girardeau","Cape May","Cape May Court House","Cape May Point","Cape Neddick","Cape Porpoise","Cape Vincent","Capeville","Capistrano Beach","Capitan","Capitola","Capon Bridge","Capron","Captain Cook","Captiva","Caputa","Caraway","Carbon","Carbon Hill","Carbonado","Carbondale","Cardale","Cardington","Carefree","Carencro","Carey","Careywood","Caribou","Carl Junction","Carle Place","Carleton","Carlin","Carlinville","Carlisle","Carlock","Carlos","Carlotta","Carlsbad","Carlsborg","Carlstadt","Carlton","Carlyle","Carman","Carmel","Carmel Valley","Carmen","Carmi","Carmichael","Carmichaels","Carmine","Carnation","Carnegie","Carnesville","Carney","Caro","Caroga Lake","Carol Stream","Carolina","Carolina Beach","Carp Lake","Carpentersville","Carpinteria","Carr","Carrabelle","Carrboro","Carrie","Carrier","Carrier Mills","Carriere","Carrington","Carrizo Springs","Carrizozo","Carroll","Carrollton","Carrolltown","Carrsville","Carson","Carson City","Carsonville","Carter Lake","Carteret","Cartersville","Carterville","Carthage","Cartwright","Caruthers","Caruthersville","Carver","Cary","Caryville","Casa Grande","Casanova","Casar","Cascade","Cascade Locks","Cascilla","Casco","Caseville","Casey","Caseyville","Cashiers","Cashion","Cashmere","Cashton","Cashtown","Casnovia","Casper","Caspian","Cass City","Cass Lake","Cassadaga","Cassatt","Cassel","Casselberry","Casselton","Cassoday","Cassopolis","Casstown","Cassville","Castaic","Castalia","Castalian Springs","Castile","Castine","Castle Dale","Castle Hayne","Castle Point","Castle Rock","Castleberry","Castleton","Castleton-on-Hudson","Castlewood","Castor","Castorland","Castro Valley","Castroville","Cat Spring","Cataldo","Catasauqua","Cataula","Cataumet","Catawba","Catawissa","Catharpin","Cathedral City","Catherine","Catheys Valley","Cathlamet","Catlett","Catlettsburg","Catlin","Cato","Catonsville","Catoosa","Catron","Catskill","Cattaraugus","Caulfield","Cavalier","Cave City","Cave Creek","Cave Junction","Cave Spring","Cave Springs","Cave-in-Rock","Cavendish","Cavour","Cawood","Cayce","Cayucos","Cayuga","Cayuta","Cazadero","Cazenovia","Cecil","Cecilia","Cecilton","Cedar","Cedar Bluff","Cedar Bluffs","Cedar Brook","Cedar City","Cedar Creek","Cedar Crest","Cedar Falls","Cedar Glen","Cedar Grove","Cedar Hill","Cedar Key","Cedar Knolls","Cedar Lake","Cedar Park","Cedar Point","Cedar Rapids","Cedar Ridge","Cedar Springs","Cedar Vale","Cedar Valley","Cedarburg","Cedaredge","Cedarhurst","Cedartown","Cedarville","Celeste","Celina","Celoron","Cement","Cement City","Centenary","Center","Center Barnstead","Center City","Center Conway","Center Cross","Center Harbor","Center Hill","Center Junction","Center Line","Center Moriches","Center Ossipee","Center Point","Center Ridge","Center Rutland","Center Sandwich","Center Tuftonboro","Center Valley","Centerbrook","Centerburg","Centereach","Centerfield","Centerport","Centerton","Centertown","Centerview","Centerville","Centrahoma","Central","Central Bridge","Central City","Central Falls","Central Islip","Central Lake","Central Point","Central Square","Central Valley","Central Village","Centralia","Centre","Centre Hall","Centreville","Centuria","Century","Ceres","Ceresco","Cerrillos","Cerritos","Cerro","Cerro Gordo","Cerulean","Chadbourn","Chadds Ford","Chadron","Chadwick","Chaffee","Chagrin Falls","Chalfont","Challis","Chalmette","Chama","Chamberino","Chamberlain","Chambers","Chambersburg","Champaign","Champion","Champlain","Champlin","Chana","Chancellor","Chandler","Chandlersville","Chandlerville","Chanhassen","Channahon","Channelview","Channing","Chantilly","Chanute","Chaparral","Chapel Hill","Chapin","Chaplin","Chapman","Chapmansboro","Chapmanville","Chappaqua","Chappell Hill","Chardon","Charenton","Chariton","Charlemont","Charleroi","Charles City","Charles Town","Charleston","Charlestown","Charlevoix","Charlotte","Charlotte Court House","Charlotte Hall","Charlottesville","Charlotteville","Charlton","Charter Oak","Charter Township of Clinton","Chartley","Chase","Chase City","Chaseburg","Chaseley","Chaska","Chassell","Chataignier","Chatfield","Chatham","Chatom","Chatsworth","Chattahoochee","Chattanooga","Chattaroy","Chaumont","Chauncey","Chautauqua","Chauvin","Chavies","Chazy","Chebanse","Chebeague Island","Cheboygan","Checotah","Chefornak","Chehalis","Chelan","Chelan Falls","Chelmsford","Chelsea","Cheltenham","Chemung","Chenango Forks","Cheney","Cheneyville","Chenoa","Chepachet","Cheraw","Cheriton","Cherokee","Cherokee Village","Cherry Hill","Cherry Log","Cherry Point Marine Base Mobile Home Park","Cherry Tree","Cherry Valley","Cherryfield","Cherryvale","Cherryville","Chesaning","Chesapeake","Chesapeake Beach","Chesapeake City","Cheshire","Chesnee","Chester","Chester Heights","Chester Springs","Chesterfield","Chesterhill","Chesterland","Chesterton","Chestertown","Chestnut","Chestnut Hill","Chestnut Mountain","Chestnut Ridge","Cheswick","Chetek","Chetopa","Chevak","Chevy Chase","Chewelah","Cheyenne","Cheyenne Wells","Cheyney","Chicago","Chicago Heights","Chicago Ridge","Chichester","Chickamauga","Chickasha","Chicken","Chico","Chicopee","Chicora","Chiefland","Childersburg","Childress","Childs","Chilhowee","Chilhowie","Chili","Chillicothe","Chilo","Chilton","Chimacum","China Grove","China Springs","Chinchilla","Chincoteague Island","Chinese Camp","Chinle","Chino","Chino Hills","Chino Valley","Chinook","Chipley","Chippewa Falls","Chippewa Lake","Chireno","Chisago City","Chisholm","Chittenango","Chittenden","Chloride","Chocorua","Chocowinity","Choctaw","Chokio","Choteau","Choudrant","Chouteau","Chowchilla","Chrisman","Christchurch","Christiana","Christiansburg","Christine","Christmas","Christmas Valley","Christopher","Christoval","Chualar","Chuckey","Chugiak","Chugwater","Chula","Chula Vista","Chunchula","Chunky","Church Hill","Church Point","Church Rock","Churchton","Churchville","Churdan","Churubusco","Cibola","Cibolo","Cicero","Cimarron","Cincinnati","Cincinnatus","Cinebar","Circle","Circle Pines","Circleville","Cisco","Cisne","Cissna Park","Citra","Citronelle","Citrus Heights","City of Angels","City of Industry","City of Picher (historical)","City of Saint Marys","City of Saint Peters","Clackamas","Claflin","Claire City","Clairton","Clam Lake","Clancy","Clanton","Clara City","Clare","Claremont","Claremore","Clarence","Clarendon","Clarendon Hills","Claridge","Clarinda","Clarington","Clarion","Clarissa","Clark","Clark Fork","Clark Mills","Clarkesville","Clarkfield","Clarkia","Clarklake","Clarkrange","Clarks","Clarks Grove","Clarks Hill","Clarks Summit","Clarksboro","Clarksburg","Clarksdale","Clarkson","Clarkston","Clarksville","Clarkton","Claryville","Clatonia","Clatskanie","Claude","Claudville","Claverack","Clawson","Claxton","Clay","Clay Center","Clay City","Claymont","Claypool","Claysburg","Claysville","Clayton","Cle Elum","Clear Brook","Clear Fork","Clear Lake","Clear Spring","Clearbrook","Clearfield","Clearlake","Clearlake Oaks","Clearmont","Clearville","Clearwater","Clearwater Beach","Cleburne","Cleghorn","Clementon","Clements","Clemmons","Clemons","Clemson","Clendenin","Clermont","Cleveland","Clever","Cleves","Clewiston","Clifford","Cliffside Park","Cliffwood","Clifton","Clifton Forge","Clifton Heights","Clifton Park","Clifton Springs","Climax","Climax Springs","Clinchco","Clint","Clinton","Clinton Corners","Clintondale","Clintonville","Clintwood","Clio","Clive","Clontarf","Clopton","Cloquet","Closplint","Closter","Cloud","Cloudcroft","Clover","Cloverdale","Cloverport","Clovis","Clute","Clyde","Clyde Park","Clyman","Clymer","Clyo","Coachella","Coahoma","Coal Center","Coal City","Coal Hill","Coal Mountain","Coal Township","Coal Valley","Coaldale","Coalfield","Coalgate","Coalinga","Coalmont","Coalport","Coalville","Coarsegold","Coatesville","Coats","Coatsburg","Cobalt","Cobb","Cobbs Creek","Cobden","Cobleskill","Coburn","Cochecton","Cochise","Cochiti Lake","Cochiti Pueblo","Cochran","Cochrane","Cochranton","Cochranville","Cockeysville","Cocoa","Cocoa Beach","Cocolamus","Coden","Cody","Coeburn","Coeymans","Coeymans Hollow","Coffee Springs","Coffeen","Coffeeville","Coffey","Coffeyville","Coffman Cove","Coggon","Cogswell","Cohasset","Cohocton","Cohoes","Cohutta","Coin","Coinjock","Cokato","Cokeburg","Coker","Cokeville","Colbert","Colby","Colchester","Colcord","Cold Brook","Cold Spring","Cold Spring Harbor","Cold Springs","Colden","Coldspring","Coldwater","Cole Camp","Colebrook","Coleman","Colerain","Coleraine","Coleridge","Colesburg","Coleville","Colfax","Colgate","College Corner","College Grove","College Park","College Place","College Point","College Station","Collegedale","Collegeport","Collegeville","Colleyville","Colliers","Collierville","Collingswood","Collins","Collinston","Collinsville","Collinwood","Collison","Colman","Colmar","Colmesneil","Colo","Cologne","Coloma","Colon","Colona","Colonia","Colonial Beach","Colonial Heights","Colony","Colora","Colorado City","Colorado Springs","Colquitt","Colstrip","Colt","Colton","Colts Neck","Columbia","Columbia City","Columbia Cross Roads","Columbia Falls","Columbia Station","Columbiana","Columbiaville","Columbus","Columbus Grove","Columbus Junction","Colusa","Colver","Colville","Colwich","Comanche","Combined Locks","Combs","Comer","Comfort","Comfrey","Commack","Commerce","Commerce City","Commercial Point","Commiskey","Como","Comptche","Compton","Comstock","Comstock Park","Conception Junction","Concho","Concord","Concordia","Concordville","Concrete","Condon","Conestoga","Conesus","Conesville","Confluence","Conger","Congers","Congerville","Congress","Conifer","Conklin","Conley","Conneaut","Conneaut Lake","Conneautville","Connell","Connellsville","Connelly Springs","Connersville","Conover","Conowingo","Conrad","Conrath","Conroe","Conroy","Conshohocken","Constableville","Constantia","Constantine","Contact","Content","Continental","Contoocook","Convent","Converse","Convoy","Conway","Conway Springs","Conyers","Conyngham","Cook","Cookeville","Cookstown","Cooksville","Coolidge","Coolin","Coolville","Coon Rapids","Coon Valley","Cooper","Cooper Landing","Coopers Plains","Coopersburg","Cooperstown","Coopersville","Coos Bay","Copake","Copake Falls","Copalis Beach","Copan","Cope","Copeland","Copenhagen","Copeville","Copiague","Coplay","Coppell","Copper Center","Copper Harbor","Copperas Cove","Copperhill","Copperopolis","Coquille","Coral","Coral Gables","Coralville","Coram","Coraopolis","Corbett","Corbin","Corcoran","Cordele","Cordell","Cordesville","Cordova","Corfu","Corinna","Corinne","Corinth","Corn","Cornelia","Cornelius","Cornell","Cornersville","Corning","Cornish","Cornish Flat","Cornville","Cornwall","Cornwall Bridge","Cornwall-on-Hudson","Cornwallville","Corolla","Corona","Corona del Mar","Coronado","Corpus Christi","Corrales","Correctionville","Corrigan","Corry","Corryton","Corsica","Corsicana","Cortaro","Corte Madera","Cortez","Cortland","Corunna","Corvallis","Corwith","Cory","Corydon","Cos Cob","Cosby","Coshocton","Cosmopolis","Cosmos","Costa Mesa","Cotati","Cottage Grove","Cottage Hills","Cottageville","Cottekill","Cotton","Cotton Valley","Cottondale","Cottonport","Cottontown","Cottonwood","Cotuit","Cotulla","Coudersport","Coulee City","Coulee Dam","Coulterville","Counce","Council","Council Bluffs","Council Grove","Council Hill","Country Club Hills","Coupeville","Coupland","Courtland","Coushatta","Cove","Covelo","Coventry","Covert","Covina","Covington","Cowan","Cowansville","Coward","Cowden","Cowen","Coweta","Cowiche","Cowlesville","Cowley","Cowpens","Coxs Creek","Coxsackie","Coyle","Coyote","Cozad","Crab Orchard","Crabtree","Craftsbury","Craig","Craigmont","Craigsville","Craigville","Cramerton","Cranberry Township","Cranbury","Crandall","Crandon","Crane","Crane Hill","Crane Lake","Cranesville","Cranfills Gap","Cranford","Cranks","Cranston","Craryville","Crawford","Crawfordsville","Crawfordville","Crawley","Creal Springs","Cream Ridge","Creede","Creedmoor","Creekside","Creighton","Creola","Creole","Cresbard","Crescent","Crescent City","Crescent Hills","Crescent Mills","Crescent Valley","Cresco","Cresskill","Cresson","Crest Hill","Crested Butte","Crestline","Creston","Crestone","Crestview","Crestwood","Creswell","Crete","Creve Coeur","Crewe","Crimora","Cripple Creek","Crisfield","Crittenden","Critz","Crivitz","Crocker","Crockett","Crofton","Croghan","Crompond","Cromwell","Crooks","Crookston","Crooksville","Cropseyville","Crosby","Crosbyton","Cross","Cross City","Cross Junction","Cross Lake","Cross Plains","Cross River","Crossett","Crossville","Crosswicks","Croswell","Crothersville","Croton","Croton Falls","Croton-on-Hudson","Crow Agency","Crowder","Crowell","Crowheart","Crowley","Crown City","Crown Point","Crownpoint","Crownsville","Crows Landing","Croydon","Crozet","Crucible","Cruger","Crum","Crum Lynne","Crump","Crumpler","Crystal","Crystal City","Crystal Falls","Crystal Lake","Crystal River","Crystal Springs","Cub Run","Cuba","Cuba City","Cudahy","Cuddebackville","Cuddy Hill","Cuero","Culbertson","Culdesac","Cullen","Culleoka","Cullman","Culloden","Cullom","Cullowhee","Culpeper","Culver","Culver City","Cumberland","Cumberland Center","Cumberland City","Cumberland Foreside","Cumberland Furnace","Cumberland Gap","Cumby","Cumming","Cummings","Cummington","Cunningham","Cupertino","Currie","Currituck","Curryville","Curtice","Curtis","Curtis Bay","Curtiss","Curwensville","Cushing","Cusick","Cusseta","Custar","Custer","Custer City","Cut Bank","Cut Off","Cutchogue","Cuthbert","Cutler","Cuttingsville","Cuyahoga Falls","Cyclone","Cygnet","Cylinder","Cynthiana","Cypress","Cypress Inn","Cyril","Dacoma","Dacono","Dacula","Dade City","Dadeville","Daggett","Dagsboro","Dahlgren","Dahlonega","Daingerfield","Daisetta","Daisytown","Dakota","Dakota City","Dale","Daleville","Dalhart","Dallas","Dallas Center","Dallas City","Dallastown","Dalmatia","Dalton","Dalton City","Daly City","Dalzell","Damariscotta","Damascus","Damon","Dana","Dana Point","Danbury","Danby","Dandridge","Dane","Danese","Danforth","Dania Beach","Daniels","Danielson","Danielsville","Dannemora","Dansville","Dante","Danube","Danvers","Danville","Daphne","Darby","Dardanelle","Darden","Darien","Darlington","Darmstadt","Darrington","Darrouzett","Darrow","Darwin","Dassel","Dateland","Datil","Dauphin","Dauphin Island","Davenport","David City","Davidson","Davidsonville","Davis","Davis City","Davis Junction","Davisboro","Davisburg","Davison","Daviston","Davisville","Davy","Dawes","Dawn","Dawson","Dawson Springs","Dawsonville","Days Creek","Dayton","Daytona Beach","Dayville","Dazey","De Beque","De Borgia","De Forest","De Graff","De Kalb","De Kalb Junction","De Leon","De Leon Springs","De Queen","De Smet","De Soto","De Valls Bluff","De Witt","Deadwood","Deal","Deal Island","Deale","Deansboro","Deanville","Dearborn","Dearborn Heights","Dearing","Death Valley Junction","Deatsville","Deaver","DeBary","Debord","Decatur","Decaturville","Decherd","Decker","Deckerville","Declo","Decorah","Dedham","Deep River","Deep Run","Deep Water","Deepwater","Deer","Deer Island","Deer Isle","Deer Lodge","Deer Park","Deer River","Deer Trail","Deerfield","Deerfield Beach","Deering","Deerwood","Defiance","Deford","DeFuniak Springs","DeKalb","Del Mar","Del Norte","Del Rey","Del Rio","Del Valle","Delafield","DeLand","Delano","Delanson","Delaplaine","Delavan","Delaware","Delaware City","Delbarton","Delcambre","Delco","Delevan","Delhi","Delight","Dell","Dell Rapids","Delmar","Delmont","Deloit","Delphi","Delphos","Delray","Delray Beach","Delta","Deltana","Deltaville","Delton","Deltona","Dema","Demarest","Deming","Demopolis","Demorest","DeMossville","DeMotte","Denair","Dendron","Denham Springs","Denison","Denmark","Dennis","Dennis Port","Dennison","Denniston","Dennysville","Dent","Denton","Denver","Denver City","Denville","Depauw","Depere","Depew","Depoe Bay","Deposit","Depue","Deputy","DeQuincy","Derby","Derby Center","Derby Line","DeRidder","Derma","Dermott","Derry","DeRuyter","Derwood","Des Allemands","Des Arc","Des Moines","Des Plaines","Descanso","Desert Hot Springs","Deshler","DeSoto","Destin","Destrehan","Detroit","Detroit Lakes","Devens","Deville","Devils Lake","Devine","Devon","Dewar","Dewey","DeWitt","Dewy Rose","Dexter","Dexter City","Diablo","Diagonal","Diamond","Diamond Bar","Diamond Point","Diamond Springs","Diamondhead","Diamondville","Diana","Diboll","Dickerson","Dickeyville","Dickinson","Dickinson Center","Dickson","Dickson City","Dierks","Dieterich","Dietrich","Diggs","Dighton","Dill City","Dillard","Diller","Dilley","Dillingham","Dillon","Dillon Beach","Dillonvale","Dillsboro","Dillsburg","Dillwyn","Dime Box","Dimmitt","Dimock","Dimondale","Dingess","Dingmans Ferry","Dinuba","Dinwiddie","Discovery Bay","Disputanta","Distant","District Heights","Dittmer","Divernon","Divide","Dividing Creek","Dix","Dixfield","Dixie","Dixmont","Dixon","Dixon Springs","Dixons Mills","Dixonville","Dobbs Ferry","Dobson","Docena","Dodd City","Doddridge","Dodge","Dodge Center","Dodge City","Dodgeville","Dodgewood","Doerun","Dolan Springs","Doland","Dolgeville","Dollar Bay","Dolliver","Dolomite","Dolores","Dolphin","Dolton","Donald","Donalds","Donaldson","Donaldsonville","Donalsonville","Donegal","Dongola","Donie","Doniphan","Donna","Donnellson","Donnelly","Donnelsville","Donner","Donora","Donovan","Doon","Dora","Dorchester","Dorena","Dornsife","Dorothy","Dorr","Dorrance","Dorris","Dorset","Dorsey","Dos Palos","Doss","Doswell","Dothan","Double Springs","Dougherty","Douglas","Douglas City","Douglass","Douglassville","Douglasville","Dousman","Dover","Dover Plains","Dover-Foxcroft","Dow","Dowagiac","Dowell","Dowelltown","Dowling","Downers Grove","Downey","Downieville","Downingtown","Downs","Downsville","Dows","Doyle","Doylestown","Doyline","Dozier","Dracut","Dragoon","Drain","Drakes Branch","Drakesboro","Draper","Drasco","Dravosburg","Drayden","Dresden","Dresher","Dresser","Drewryville","Drexel","Drexel Hill","Drift","Drifting","Driftwood","Driggs","Dripping Springs","Driscoll","Drummond","Drummonds","Drumore","Drumright","Drums","Dry Branch","Dry Creek","Dry Fork","Dry Prong","Dry Ridge","Dry Run","Drybranch","Dryden","Dryfork","Du Bois","Du Quoin","Duanesburg","Duarte","Dubach","Dublin","DuBois","Dubois","Dubuque","Duchesne","Duck","Duck Creek Village","Duck Hill","Ducktown","Dudley","Due West","Duff","Duffield","Dufur","Dugger","Dugway","Duke","Duke Center","Dukedom","Dulac","Dulce","Dulles","Duluth","Dulzura","Dumas","Dumfries","Dumont","Dunbar","Dunbarton Center","Duncan","Duncannon","Duncans Mills","Duncansville","Duncanville","Duncombe","Dundalk","Dundas","Dundee","Dunedin","Dunellen","Dungannon","Dunkerton","Dunkirk","Dunlap","Dunlow","Dunmor","Dunmore","Dunn","Dunn Loring","Dunnell","Dunnellon","Dunnsville","Dunnville","Dunseith","Dunsmuir","Dunstable","Duplessis","Dupo","DuPont","Dupont","Dupuyer","Duquesne","Durand","Durango","Durant","Durbin","Durham","Durhamville","Duryea","Dushore","Duson","Dustin","Dutch Flat","Dutch Harbor","Dutch John","Dutton","Duvall","Duxbury","Dwale","Dwight","Dyer","Dyersburg","Dyersville","Dysart","Eads","Eagar","Eagle","Eagle Bend","Eagle Bridge","Eagle Butte","Eagle Creek","Eagle Grove","Eagle Lake","Eagle Mountain","Eagle Nest","Eagle Pass","Eagle Point","Eagle River","Eagle Rock","Eagle Springs","Eagleville","Earl Park","Earle","Earleville","Earlham","Earlimart","Earling","Earlsboro","Earlton","Earlville","Early","Earlysville","Earth","Earth City","Easley","East Alton","East Amherst","East Andover","East Aurora","East Bank","East Barre","East Bend","East Berkshire","East Berlin","East Bernard","East Berne","East Bernstadt","East Blue Hill","East Boothbay","East Brady","East Branch","East Bridgewater","East Brookfield","East Brunswick","East Burke","East Butler","East Calais","East Canaan","East Candia","East Carbon City","East Carondelet","East Chatham","East Chicago","East China Township","East Claridon","East Corinth","East Dennis","East Dover","East Dublin","East Dubuque","East Durham","East Earl","East Elmhurst","East Fairfield","East Fairview","East Falmouth","East Flat Rock","East Freedom","East Freetown","East Galesburg","East Granby","East Grand Forks","East Greenbush","East Greenville","East Greenwich","East Haddam","East Hampstead","East Hampton","East Hanover","East Hardwick","East Hartford","East Hartland","East Haven","East Helena","East Irvine","East Islip","East Jordan","East Kingston","East Lake","East Lansing","East Leroy","East Liberty","East Liverpool","East Longmeadow","East Lynn","East Machias","East Marion","East McKeesport","East Meadow","East Meredith","East Middlebury","East Millinocket","East Millsboro","East Moline","East Montpelier","East Moriches","East New Market","East Northport","East Norwich","East Orange","East Orleans","East Otis","East Palatka","East Palestine","East Peoria","East Petersburg","East Pharsalia","East Pittsburgh","East Point","East Prairie","East Prospect","East Providence","East Quogue","East Randolph","East Rochester","East Rockaway","East Rutherford","East Saint Louis","East Sandwich","East Setauket","East Sparta","East Stone Gap","East Stoneham","East Stroudsburg","East Syracuse","East Taunton","East Tawas","East Thetford","East Troy","East Wakefield","East Walpole","East Wareham","East Waterboro","East Wenatchee","East Weymouth","East Windsor Hill","Eastaboga","Eastanollee","Eastchester","Eastern","Eastford","Eastham","Easthampton","Eastlake","Eastland","Eastman","Easton","Eastover","Eastpoint","Eastpointe","Eastport","Eastsound","Eastview","Eastville","Eaton","Eaton Rapids","Eatonton","Eatontown","Eatonville","Eau Claire","Eau Galle","Ebensburg","Echo","Eckert","Eckerty","Eclectic","Economy","Ecorse","Ecru","Ector","Edcouch","Eddington","Eddy","Eddyville","Edelstein","Eden","Eden Prairie","Eden Valley","Edenton","Edgar","Edgard","Edgartown","Edgecomb","Edgefield","Edgeley","Edgemont","Edgemoor","Edgerton","Edgewater","Edgewood","Edina","Edinboro","Edinburg","Edinburgh","Edison","Edisto Island","Edmeston","Edmond","Edmonds","Edmonton","Edmore","Edna","Edneyville","Edon","Edson","Edwall","Edwards","Edwards Air Force Base","Edwardsburg","Edwardsport","Edwardsville","Effie","Effingham","Effort","Efland","Egan","Egg Harbor","Egg Harbor City","Eglin","Eglon","Egypt","Ehrenberg","Eielson Air Force Base","Eight Mile","Eighty Four","Ekalaka","Ekron","El Cajon","El Campo","El Centro","El Cerrito","El Dorado","El Dorado Hills","El Dorado Springs","El Granada","El Macero","El Mirage","El Monte","El Paso","El Prado","El Reno","El Segundo","El Sobrante","Elba","Elberon","Elbert","Elberta","Elberton","Elbow Lake","Elbridge","Elburn","Elcho","Elco","Elderton","Eldon","Eldora","Eldorado","Eldred","Eldridge","Eleanor","Electra","Elephant Butte","Eleva","Elfrida","Elgin","Eliot","Elizabeth","Elizabeth City","Elizabethton","Elizabethtown","Elizabethville","Elizaville","Elk","Elk City","Elk Falls","Elk Garden","Elk Grove","Elk Grove Village","Elk Horn","Elk Mills","Elk Mound","Elk Park","Elk Point","Elk Rapids","Elk River","Elkader","Elkfork","Elkhart","Elkhart Lake","Elkhorn","Elkhorn City","Elkin","Elkins","Elkins Park","Elkland","Elkmont","Elko","Elkridge","Elkton","Elkview","Elkville","Elkwood","Ellabell","Ellaville","Ellenboro","Ellenburg Center","Ellenburg Depot","Ellendale","Ellensburg","Ellenton","Ellenville","Ellenwood","Ellerbe","Ellerslie","Ellettsville","Ellicott City","Ellicottville","Ellijay","Ellington","Ellinwood","Elliott","Elliottsburg","Ellis","Ellis Grove","Elliston","Ellisville","Elloree","Ellsinore","Ellsworth","Ellwood City","Elm City","Elm Creek","Elm Grove","Elma","Elmdale","Elmendorf","Elmer","Elmer City","Elmhurst","Elmira","Elmo","Elmont","Elmora","Elmore","Elmore City","Elmsford","Elmwood","Elmwood Park","Elnora","Elon","Elora","Eloy","Elroy","Elsa","Elsah","Elsberry","Elsie","Elsinore","Elton","Eltopia","Elvaston","Elverson","Elverta","Elwell","Elwood","Ely","Elyria","Elysburg","Elysian","Elysian Fields","Embarrass","Embudo","Emden","Emerado","Emerald Isle","Emerson","Emery","Emeryville","Emigrant","Emily","Eminence","Emlenton","Emmaus","Emmet","Emmetsburg","Emmett","Emmitsburg","Emmons","Emory","Empire","Emporia","Emporium","Encampment","Encinitas","Encino","Endeavor","Enderlin","Endicott","Energy","Enfield","Engelhard","England","Englewood","Englewood Cliffs","Englishtown","Enid","Enigma","Enka","Ennice","Ennis","Enola","Enon","Enoree","Enosburg Falls","Enterprise","Entiat","Enumclaw","Eolia","Epes","Ephraim","Ephrata","Epping","Epps","Epsom","Epworth","Equality","Equinunk","Erath","Erbacon","Erhard","Erick","Erie","Erieville","Erin","Erlanger","Eros","Errol","Erskine","Erving","Ervings Location","Erwin","Erwinna","Erwinville","Esbon","Escalante","Escalon","Escanaba","Escondido","Esko","Eskridge","Esmond","Esmont","Espanola","Esparto","Esperance","Essex","Essex Fells","Essex Junction","Essexville","Essie","Essington","Estacada","Estancia","Estell Manor","Estelline","Estero","Estes Park","Estherville","Estherwood","Estill","Estill Springs","Estillfork","Ethel","Ethelsville","Ethridge","Etna","Etna Green","Etoile","Eton","Etowah","Etta","Ettrick","Eubank","Eucha","Euclid","Eudora","Eufaula","Eugene","Euless","Eunice","Eupora","Eureka","Eureka Springs","Eustace","Eustis","Eutaw","Eutawville","Eva","Evangeline","Evans","Evans City","Evans Mills","Evansdale","Evanston","Evansville","Evant","Evart","Evarts","Eveleth","Evensville","Everest","Everett","Everetts","Everglades City","Evergreen","Evergreen Park","Everly","Everson","Everton","Evington","Ewan","Ewen","Ewing","Excel","Excello","Excelsior","Excelsior Springs","Exeland","Exeter","Exira","Exline","Exmore","Experiment","Export","Exton","Eyota","Ezel","Fabens","Faber","Fabius","Fackler","Factoryville","Fair Bluff","Fair Grove","Fair Haven","Fair Lawn","Fair Oaks","Fair Play","Fairacres","Fairbank","Fairbanks","Fairbanks North Star Borough","Fairborn","Fairburn","Fairbury","Fairchance","Fairchild","Fairchild Air Force Base","Fairdale","Fairdealing","Fairfax","Fairfax Station","Fairfield","Fairfield Bay","Fairgrove","Fairhaven","Fairhope","Fairland","Fairlee","Fairless Hills","Fairmont","Fairmont City","Fairmount","Fairplay","Fairport","Fairton","Fairview","Fairview Heights","Fairview Village","Faith","Falcon","Falconer","Falfurrias","Falkland","Falkner","Falkville","Fall Branch","Fall City","Fall Creek","Fall River","Fall River Mills","Fallbrook","Falling Rock","Falling Waters","Fallon","Falls","Falls Church","Falls City","Falls Creek","Falls Mills","Falls of Rough","Falls Village","Fallsburg","Fallston","Falmouth","Fancy Farm","Fannettsburg","Fanwood","Far Hills","Far Rockaway","Farber","Fargo","Faribault","Farina","Farley","Farlington","Farmdale","Farmer City","Farmersburg","Farmersville","Farmerville","Farmingdale","Farmington","Farmington Hills","Farmingville","Farmland","Farmville","Farnham","Farnhamville","Farragut","Farrell","Farson","Farwell","Faulkner","Faulkton","Fawn Grove","Fawnskin","Faxon","Fayette","Fayette City","Fayetteville","Fayville","Feasterville-Trevose","Federal Way","Federalsburg","Feeding Hills","Felda","Felicity","Fellsmere","Felton","Fenelton","Fennimore","Fennville","Fenton","Fentress","Fenwick","Fenwick Island","Ferdinand","Fergus Falls","Ferguson","Fernandina Beach","Ferndale","Fernley","Fernwood","Ferriday","Ferris","Ferrisburgh","Ferron","Ferrum","Ferrysburg","Fertile","Fessenden","Festus","Feura Bush","Fiddletown","Fidelity","Fieldale","Fielding","Fieldon","Fife Lake","Fifty Lakes","Filer","Filley","Fillmore","Fincastle","Finchville","Findlay","Finger","Fingerville","Finksburg","Finlayson","Finley","Finleyville","Firebaugh","Firestone","Firth","Fischer","Fish Camp","Fish Creek","Fish Haven","Fishel","Fisher","Fishers","Fishers Island","Fishersville","Fisherville","Fishkill","Fishtail","Fisk","Fiskdale","Fitchburg","Fitzgerald","Fitzhugh","Fitzpatrick","Fitzwilliam","Five Points","Flag Pond","Flagler","Flagler Beach","Flagstaff","Flanagan","Flanders","Flandreau","Flasher","Flat Lick","Flat Rock","Flatgap","Flatwoods","Flaxton","Flaxville","Fleetwood","Fleischmanns","Fleming","Flemingsburg","Flemington","Flensburg","Fletcher","Flint","Flinton","Flintstone","Flintville","Flippin","Flomaton","Floodwood","Flora","Flora Vista","Florahome","Floral City","Floral Park","Florala","Florence","Floresville","Florham Park","Florida","Florien","Florissant","Flossmoor","Flourtown","Flovilla","Flower Mound","Floweree","Flowery Branch","Flowood","Floyd","Floydada","Floyds Knobs","Fluker","Flushing","Fly Creek","Fogelsville","Folcroft","Foley","Folkston","Follansbee","Follett","Folly Beach","Folsom","Fombell","Fond du Lac","Fonda","Fontana","Fontanelle","Foothill Ranch","Forbes","Forbes Road","Ford","Ford City","Fordland","Fordoche","Fords","Fordsville","Fordville","Fordyce","Foreman","Forest","Forest City","Forest Falls","Forest Grove","Forest Hill","Forest Hills","Forest Home","Forest Junction","Forest Knolls","Forest Lake","Forest Park","Forest River","Forestdale","Foresthill","Foreston","Forestport","Forestville","Forgan","Foristell","Fork Union","Forked River","Forkland","Forks","Forksville","Forman","Formoso","Forney","Forrest","Forrest City","Forreston","Forsyth","Fort Ann","Fort Apache","Fort Ashby","Fort Atkinson","Fort Belvoir","Fort Benning","Fort Benton","Fort Blackmore","Fort Bragg","Fort Branch","Fort Bridger","Fort Calhoun","Fort Campbell North","Fort Cobb","Fort Collins","Fort Davis","Fort Defiance","Fort Deposit","Fort Dodge","Fort Drum","Fort Duchesne","Fort Edward","Fort Fairfield","Fort Gaines","Fort Garland","Fort Gay","Fort George Meade","Fort Gibson","Fort Gratiot Township","Fort Greely","Fort Hall","Fort Irwin","Fort Jennings","Fort Jones","Fort Kent","Fort Knox","Fort Lauderdale","Fort Lee","Fort Leonard Wood","Fort Loramie","Fort Loudon","Fort Lupton","Fort Madison","Fort McCoy","Fort McDowell","Fort Meade","Fort Mill","Fort Mitchell","Fort Montgomery","Fort Morgan","Fort Myers","Fort Myers Beach","Fort Oglethorpe","Fort Payne","Fort Pierre","Fort Plain","Fort Polk","Fort Ransom","Fort Recovery","Fort Richardson","Fort Riley-Camp Whiteside","Fort Ripley","Fort Rucker","Fort Scott","Fort Sill Indian School Reservation (historical)","Fort Smith","Fort Stewart","Fort Stockton","Fort Sumner","Fort Thomas","Fort Thompson","Fort Totten","Fort Valley","Fort Walton Beach","Fort Washakie","Fort Washington","Fort Wayne","Fort White","Fort Worth","Fort Yates","Fortine","Fortson","Fortuna","Fortville","Foss","Fossil","Fosston","Foster","Foster City","Fosters","Fostoria","Fouke","Fountain","Fountain City","Fountain Green","Fountain Hills","Fountain Inn","Fountain Run","Fountain Valley","Fountaintown","Fountainville","Four Oaks","Fowler","Fowlerville","Fox Island","Fox Lake","Fox River Grove","Foxborough","Foxburg","Foxhome","Foxworth","Frackville","Framingham","Francestown","Francesville","Francisco","Franconia","Frankenmuth","Frankewing","Frankford","Frankfort","Franklin","Franklin Grove","Franklin Lakes","Franklin Park","Franklin Springs","Franklin Square","Franklinton","Franklinville","Frankston","Franksville","Frankton","Franktown","Frannie","Fraser","Frazee","Frazer","Frazeysburg","Frazier Park","Fraziers Bottom","Fred","Frederic","Frederica","Frederick","Fredericksburg","Fredericktown","Fredonia","Free Soil","Free Union","Freeburg","Freeburn","Freedom","Freehold","Freehold Borough","Freeland","Freeman","Freeport","Freer","Freetown","Freeville","Fremont","French Camp","French Lick","French Settlement","French Village","Frenchburg","Frenchtown","Frenchville","Fresh Meadows","Fresno","Frewsburg","Friant","Friars Point","Friday Harbor","Friedens","Friend","Friendly","Friendship","Friendsville","Friendswood","Fries","Friona","Frisco","Frisco City","Fritch","Frohna","Froid","Front Royal","Frontenac","Frost","Frostburg","Frostproof","Fruita","Fruitdale","Fruitland","Fruitland Park","Fruitport","Fruitvale","Fryburg","Fryeburg","Ft. Pierce","Ft. Washington","Fulda","Fullerton","Fulshear","Fulton","Fultondale","Fultonham","Fultonville","Fults","Funkstown","Fuquay-Varina","Furlong","Fyffe","Gable","Gackle","Gadsden","Gaffney","Gagetown","Gail","Gaines","Gainesboro","Gainestown","Gainesville","Gaithersburg","Galatia","Galax","Galena","Galena Park","Gales Ferry","Galesburg","Galesville","Galien","Galion","Galivants Ferry","Gallatin","Gallatin Gateway","Galliano","Gallion","Gallipolis","Gallipolis Ferry","Gallitzin","Galloway","Gallup","Galt","Galva","Galveston","Galway","Gambier","Gambrills","Ganado","Gans","Gansevoort","Gap","Gap Mills","Garards Fort","Garber","Garberville","Garciasville","Garden City","Garden Grove","Garden Plain","Garden Prairie","Garden Valley","Gardena","Gardendale","Gardiner","Gardner","Gardners","Gardnerville","Garfield","Garland","Garnavillo","Garner","Garnerville","Garnet Valley","Garnett","Garrard","Garretson","Garrett","Garrettsville","Garrison","Garryowen","Garvin","Garwin","Garwood","Gary","Garysburg","Garyville","Gas","Gas City","Gasport","Gasquet","Gassaway","Gassville","Gaston","Gastonia","Gastonville","Gate City","Gates","Gates Mills","Gatesville","Gateway","Gatlinburg","Gatzke","Gauley Bridge","Gause","Gautier","Gay","Gaylesville","Gaylord","Gaylordsville","Gays Creek","Gays Mills","Gazelle","Geary","Geff","Geigertown","Geismar","Genesee","Geneseo","Geneva","Genoa","Genoa City","Gentry","Gentryville","George","George West","Georgetown","Georgiana","Gerald","Geraldine","Gerber","Gering","Gerlach","German Valley","Germansville","Germanton","Germantown","Geronimo","Gerrardstown","Gerry","Gervais","Gettysburg","Getzville","Geuda Springs","Geyser","Geyserville","Gheens","Ghent","Gibbon","Gibbsboro","Gibbstown","Gibsland","Gibson","Gibson City","Gibsonburg","Gibsonia","Gibsonton","Gibsonville","Giddings","Gideon","Gifford","Gig Harbor","Gila","Gila Bend","Gilbert","Gilbertown","Gilberts","Gilbertsville","Gilbertville","Gilboa","Gilby","Gilcrest","Gilford","Gill","Gillespie","Gillett","Gillett Grove","Gillette","Gillham","Gillsville","Gilman","Gilman City","Gilmanton","Gilmanton Ironworks","Gilmer","Gilmore City","Gilroy","Gilson","Gilsum","Giltner","Girard","Girardville","Girdwood","Girvin","Gladbrook","Glade Spring","Glade Valley","Gladehill","Gladewater","Gladstone","Gladwin","Gladwyne","Gladys","Glasco","Glasford","Glasgow","Glassboro","Glassport","Glastonbury","Gleason","Glen Allan","Glen Allen","Glen Arbor","Glen Arm","Glen Burnie","Glen Campbell","Glen Carbon","Glen Cove","Glen Daniel","Glen Easton","Glen Elder","Glen Ellen","Glen Ellyn","Glen Flora","Glen Fork","Glen Gardner","Glen Head","Glen Hope","Glen Lyon","Glen Mills","Glen Oaks","Glen Ridge","Glen Rock","Glen Rose","Glen Saint Mary","Glen Spey","Glen Ullin","Glenallen","Glenbeulah","Glenbrook","Glenburn","Glencoe","Glendale","Glendale Heights","Glendive","Glendo","Glendora","Glenelg","Glenfield","Glenford","Glengary","Glenham","Glenmont","Glenmoore","Glenmora","Glenn","Glenn Dale","Glenns Ferry","Glennville","Glenolden","Glenpool","Glenrock","Glens","Glens Falls","Glens Fork","Glenshaw","Glenside","Glenview","Glenvil","Glenville","Glenwood","Glenwood City","Glenwood Landing","Glenwood Springs","Glidden","Globe","Glorieta","Gloster","Gloucester","Gloucester City","Gloucester Point","Glouster","Glover","Gloversville","Glyndon","Gobles","Goddard","Godfrey","Godley","Godwin","Goehner","Goessel","Goff","Goffstown","Golconda","Gold Bar","Gold Beach","Gold Canyon","Gold Hill","Golden","Golden City","Golden Eagle","Golden Meadow","Golden Valley","Goldendale","Goldenrod","Goldens Bridge","Goldfield","Goldonna","Goldsboro","Goldsmith","Goldston","Goldthwaite","Goldvein","Goleta","Goliad","Goltry","Gonvick","Gonzales","Goochland","Good Hope","Good Thunder","Goode","Goodells","Goodfield","Goodhue","Gooding","Goodland","Goodlettsville","Goodman","Goodnews Bay","Goodrich","Goodridge","Goodview","Goodwater","Goodwell","Goodyear","Goose Creek","Gordo","Gordon","Gordonsville","Gordonville","Gore","Gore Springs","Goreville","Gorham","Gorin","Gorman","Goshen","Gosport","Gotha","Gotham","Gothenburg","Gould","Gouldsboro","Gouverneur","Gowanda","Gowen","Gower","Gowrie","Grabill","Grace","Grace City","Gracemont","Graceville","Grady","Gradyville","Graettinger","Graford","Grafton","Graham","Grain Valley","Grambling","Gramercy","Grammer","Grampian","Granada","Granada Hills","Granbury","Granby","Grand Bay","Grand Blanc","Grand Cane","Grand Canyon","Grand Coulee","Grand Forks","Grand Haven","Grand Island","Grand Isle","Grand Junction","Grand Lake","Grand Ledge","Grand Marais","Grand Marsh","Grand Meadow","Grand Mound","Grand Portage","Grand Prairie","Grand Rapids","Grand Ridge","Grand River","Grand Rivers","Grand Ronde","Grand Saline","Grand Terrace","Grand Tower","Grand View","Grandfalls","Grandfield","Grandin","Grandview","Grandville","Grandy","Granger","Grangeville","Granite","Granite Bay","Granite City","Granite Falls","Granite Quarry","Graniteville","Grant","Grant City","Grant Park","Grantham","Granton","Grants","Grants Pass","Grantsboro","Grantsburg","Grantsville","Grantville","Granville","Granville Summit","Grapeland","Grapeview","Grapevine","Grasonville","Grass Lake","Grass Valley","Grassflat","Grassy Creek","Grassy Meadows","Gratiot","Gratis","Graton","Gratz","Gravel Switch","Gravelly","Gravette","Gravity","Gravois Mills","Grawn","Gray","Gray Court","Gray Summit","Grayland","Grayling","Grayslake","Grayson","Graysville","Graytown","Grayville","Great Barrington","Great Bend","Great Cacapon","Great Falls","Great Lakes","Great Meadows","Great Mills","Great Neck","Great River","Greater Capitol Heights","Greeley","Greeleyville","Green","Green Bank","Green Bay","Green Castle","Green City","Green Cove Springs","Green Forest","Green Isle","Green Lake","Green Lane","Green Mountain","Green Mountain Falls","Green Pond","Green River","Green Sea","Green Springs","Green Valley","Green Village","Greenacres","Greenback","Greenbackville","Greenbank","Greenbelt","Greenbrae","Greenbrier","Greenbush","Greencastle","Greendale","Greene","Greeneville","Greenfield","Greenland","Greenlawn","Greenleaf","Greenock","Greenport","Greens Farms","Greensboro","Greensburg","Greentop","Greentown","Greenup","Greenvale","Greenview","Greenville","Greenway Downs","Greenwell Springs","Greenwich","Greenwood","Greenwood Lake","Greenwood Springs","Greenwood Village","Greer","Gregory","Grelton","Grenada","Grenloch","Grenville","Gresham","Grethel","Gretna","Grey Eagle","Greybull","Greycliff","Gridley","Griffin","Griffith","Griffithsville","Griffithville","Grifton","Griggsville","Grimes","Grimesland","Grimsley","Grindstone","Grinnell","Griswold","Groesbeck","Groom","Grosse Ile","Grosse Pointe","Grosse Tete","Grosvenor Dale","Groton","Grottoes","Grouse Creek","Grove","Grove City","Grove Hill","Grove Oak","Groveland","Groveport","Grover","Grover Beach","Grover Hill","Grovertown","Groves","Groveton","Grovetown","Gruetli-Laager","Grundy","Grundy Center","Gruver","Grygla","Guadalupe","Gualala","Guatay","Guerneville","Guernsey","Gueydan","Guffey","Guide Rock","Guilderland","Guilford","Guin","Guinda","Gulf Breeze","Gulf Shores","Gulfport","Gully","Gum Spring","Gunlock","Gunnison","Gunpowder","Gunter","Guntersville","Guntown","Gurley","Gurnee","Gustine","Guston","Guthrie","Guthrie Center","Guttenberg","Guy","Guymon","Guys","Guys Mills","Guysville","Guyton","Gwinn","Gwinner","Gwynedd","Gwynedd Valley","Gwynn Oak","Gypsum","Gypsy","Hacienda Heights","Hackberry","Hackensack","Hackett","Hackettstown","Haddam","Haddock","Haddon Heights","Haddonfield","Hadley","Hadlyme","Hagan","Hager City","Hagerhill","Hagerman","Hagerstown","Hahira","Hahnville","Haigler","Hailey","Haines","Haines City","Hainesport","Hakalau","Halbur","Hale","Haledon","Hales Corners","Halethorpe","Haleyville","Half Moon Bay","Halfway","Halifax","Hall","Hallam","Hallandale","Hallett","Hallettsville","Halliday","Hallie","Hallieford","Hallock","Hallowell","Halls","Hallstead","Hallsville","Halltown","Hallwood","Halma","Halsey","Halstad","Halstead","Haltom City","Hambleton","Hamburg","Hamden","Hamel","Hamer","Hamersville","Hamilton","Hamler","Hamlet","Hamlin","Hammon","Hammond","Hammondsport","Hammonton","Hampden","Hampden Sydney","Hampshire","Hampstead","Hampton","Hampton Bays","Hampton Falls","Hamptonville","Hamtramck","Hana","Hanalei","Hanapepe","Hanceville","Hancock","Hancocks Bridge","Hanford","Hankamer","Hankinson","Hanksville","Hanley Falls","Hanlontown","Hanna","Hanna City","Hannacroix","Hannah","Hannibal","Hanover","Hanover Park","Hanoverton","Hanska","Hanson","Hansville","Happy","Happy Camp","Happy Jack","Happy Valley","Harbeson","Harbor Beach","Harbor City","Harbor Springs","Harborcreek","Harborside","Harborton","Hardeeville","Hardin","Hardinsburg","Hardtner","Hardwick","Hardy","Hardyville","Harford","Harker Heights","Harlan","Harlem","Harleton","Harleysville","Harlingen","Harlowton","Harmans","Harmon","Harmonsburg","Harmony","Harned","Harold","Harper","Harper Woods","Harpers Ferry","Harpersville","Harpster","Harpswell","Harpursville","Harrah","Harrells","Harriet","Harrietta","Harriman","Harrington","Harrington Park","Harris","Harrisburg","Harrison","Harrison City","Harrison Valley","Harrisonburg","Harrisonville","Harrisville","Harrod","Harrodsburg","Harrogate","Harrold","Harshaw","Hart","Hartfield","Hartford","Hartford City","Hartington","Hartland","Hartley","Hartline","Hartly","Hartman","Harts","Hartsburg","Hartsdale","Hartsel","Hartselle","Hartsfield","Hartshorne","Hartstown","Hartsville","Hartville","Hartwell","Hartwick","Hartwood","Harvard","Harvest","Harvey","Harveys Lake","Harveyville","Harviell","Harwich","Harwich Port","Harwick","Harwinton","Harwood","Harwood Heights","Hasbrouck Heights","Haskell","Haskins","Haslet","Haslett","Hastings","Hastings-on-Hudson","Hasty","Hat Creek","Hatboro","Hatch","Hatfield","Hathaway Pines","Hathorne","Hatley","Hattiesburg","Hattieville","Haubstadt","Haughton","Hauppauge","Havana","Havelock","Haven","Havensville","Haverford","Haverhill","Haverstraw","Havertown","Haviland","Havre","Havre de Grace","Haw River","Hawaiian Gardens","Hawaiian Ocean View","Hawarden","Hawesville","Hawkeye","Hawkins","Hawkinsville","Hawley","Haworth","Hawthorn","Hawthorne","Haxtun","Hay","Hay Springs","Hayden","Haydenville","Hayes","Hayesville","Hayfield","Hayfork","Haymarket","Haynesville","Hayneville","Hays","Haysi","Haysville","Hayti","Hayward","Hazard","Hazel","Hazel Crest","Hazel Green","Hazel Park","Hazelhurst","Hazelton","Hazelwood","Hazen","Hazlehurst","Hazlet","Hazleton","Head of Westport","Headland","Healdsburg","Healdton","Healy","Hearne","Heath","Heath Springs","Heathsville","Heavener","Hebbronville","Heber","Heber Springs","Hebron","Hector","Hedgesville","Hedrick","Heflin","Hegins","Heidelberg","Heidrick","Heiskell","Helen","Helena","Helendale","Helenwood","Helix","Hellertown","Helmetta","Helotes","Helper","Helvetia","Hematite","Hemet","Hemingford","Hemingway","Hemlock","Hemphill","Hempstead","Henagar","Henderson","Hendersonville","Hendricks","Hendrix","Henefer","Hennepin","Hennessey","Henniker","Henning","Henrico","Henrietta","Henry","Henryetta","Henryville","Hensley","Hephzibah","Hepler","Heppner","Hepzibah","Herald","Herculaneum","Hercules","Hereford","Herington","Herkimer","Herlong","Herman","Hermann","Hermansville","Hermanville","Herminie","Hermiston","Hermitage","Hermon","Hermosa","Hermosa Beach","Hernando","Herndon","Hernshaw","Herod","Heron","Heron Lake","Herrick","Herriman","Herrin","Hershey","Hertford","Hesperia","Hesperus","Hessmer","Hesston","Hettick","Hettinger","Heuvelton","Hewett","Hewitt","Hewlett","Heyburn","Heyworth","Hialeah","Hiawassee","Hiawatha","Hibbing","Hibbs","Hickman","Hickory","Hickory Corners","Hickory Flat","Hickory Hills","Hickory Valley","Hicksville","Hico","Hidalgo","Hidden Valley Lake","Hiddenite","Higden","Higdon","Higganum","Higgins","Higginsville","High Bridge","High Falls","High Island","High Point","High Ridge","High Springs","High View","Highland","Highland Falls","Highland Home","Highland Lakes","Highland Mills","Highland Park","Highland Springs","Highlands","Highlandville","Highmore","Highspire","Hightstown","Highwood","Higley","Hiko","Hilbert","Hildale","Hildebran","Hildreth","Hilham","Hill","Hill City","Hillburn","Hilliard","Hillister","Hillman","Hills","Hillsboro","Hillsborough","Hillsdale","Hillside","Hillsville","Hilltop","Hillview","Hilmar","Hilo","Hilton","Hilton Head Island","Himrod","Hinckley","Hindman","Hindsboro","Hindsville","Hines","Hinesburg","Hinesville","Hingham","Hinkley","Hinsdale","Hinton","Hiram","Hitchcock","Hitterdal","Hiwasse","Hixson","Hixton","Ho-Ho-Kus","Hoagland","Hobart","Hobbs","Hobbsville","Hobe Sound","Hoboken","Hobson","Hockessin","Hockley","Hodge","Hodgen","Hodgenville","Hodges","Hoffman","Hoffman Estates","Hogansburg","Hogansville","Hohenwald","Hoisington","Hokah","Holabird","Holbrook","Holcomb","Holcombe","Holden","Holdenville","Holderness","Holdingford","Holdrege","Holgate","Holiday","Holland","Holland Patent","Hollandale","Holley","Holliday","Hollidaysburg","Hollis","Hollis Center","Hollister","Holliston","Holloman Air Force Base","Hollow Rock","Holloway","Hollsopple","Holly","Holly Grove","Holly Hill","Holly Pond","Holly Ridge","Holly Springs","Hollywood","Holmdel","Holmen","Holmes","Holmesville","Holstein","Holt","Holton","Holts Summit","Holtsville","Holtville","Holtwood","Holualoa","Holy Cross","Holyoke","Holyrood","Home","Homedale","Homeland","Homer","Homer City","Homer Glen","Homerville","Homestead","Hometown","Homewood","Homeworth","Hominy","Homosassa","Honaker","Honaunau","Hondo","Honea Path","Honeoye","Honeoye Falls","Honesdale","Honey Brook","Honey Creek","Honey Grove","Honeydew","Honeyville","Honolulu","Honor","Hood River","Hoodsport","Hooker","Hooks","Hooksett","Hookstown","Hooper","Hooper Bay","Hoopeston","Hoople","Hoosick","Hoosick Falls","Hooversville","Hop Bottom","Hopatcong","Hope","Hope Hull","Hope Mills","Hope Valley","Hopedale","Hopewell","Hopewell Junction","Hopkins","Hopkinsville","Hopkinton","Hopland","Hopwood","Hoquiam","Horatio","Horicon","Horn Lake","Hornbeak","Hornbeck","Hornell","Horner","Hornick","Horntown","Horse Branch","Horse Cave","Horse Shoe","Horseheads","Horseshoe Bay","Horseshoe Bend","Horsham","Hortense","Horton","Hortonville","Hoschton","Hosford","Hoskins","Hoskinston","Hosmer","Hospers","Hosston","Hostetter","Hot Springs","Hot Springs National Park","Hot Springs Village","Hotchkiss","Houghton","Houghton Lake","Houlka","Houlton","Houma","House Springs","Houston","Houtzdale","Hoven","Hovland","Howard","Howard Beach","Howard City","Howard Lake","Howardsville","Howe","Howell","Howes Cave","Howie In The Hills","Howland","Hoxie","Hoyleton","Hoyt","Hoyt Lakes","Huachuca City","Hubbard","Hubbard Lake","Hubbardston","Hubbardsville","Hubbell","Hubert","Hubertus","Huddleston","Huddy","Hudson","Hudson Falls","Hudsonville","Huffman","Huger","Hughes","Hughes Springs","Hugheston","Hughesville","Hughson","Hugo","Hugoton","Hulbert","Hulett","Hull","Humansville","Humarock","Humbird","Humble","Humboldt","Hume","Humeston","Hummelstown","Humphrey","Hundred","Hungerford","Hunker","Hunlock Creek","Hunt","Hunt Valley","Hunter","Huntersville","Huntertown","Huntingburg","Huntingdon","Huntingdon Valley","Huntington","Huntington Beach","Huntington Mills","Huntington Park","Huntington Station","Huntington Woods","Huntingtown","Huntland","Huntley","Huntsburg","Huntsville","Hurdland","Hurdle Mills","Hurley","Hurleyville","Hurlock","Huron","Hurricane","Hurst","Hurt","Hurtsboro","Huson","Hustisford","Hustler","Hustontown","Hustonville","Husum","Hutchins","Hutchinson","Huttig","Hutto","Huttonsville","Huxley","Hyampom","Hyannis","Hyattsville","Hyde","Hyde Park","Hyden","Hydes","Hydesville","Hydeville","Hydro","Hygiene","Hymera","Hyndman","Hyrum","Hysham","Iaeger","Iberia","Ickesburg","Ida","Ida Grove","Idabel","Idaho Falls","Idaho Springs","Idalia","Idalou","Idaville","Ider","Idledale","Idyllwild","Ignacio","Igo","Ijamsville","Iliff","Ilion","Imlay City","Imler","Immaculata","Immokalee","Imogene","Imperial","Imperial Beach","Ina","Inchelium","Incline Village","Independence","India","Indialantic","Indian Head","Indian Hills","Indian Lake","Indian Mound","Indian Orchard","Indian River","Indian Rocks Beach","Indian Trail","Indian Wells","Indiana","Indianapolis","Indianola","Indiantown","Indio","Industry","Inez","Ingalls","Ingleside","Inglewood","Inglis","Ingomar","Ingraham","Ingram","Inkom","Inkster","Inland","Inman","Inola","Institute","Intercession City","Intercourse","Interlachen","Interlaken","Interlochen","International Falls","Inver Grove Heights","Inverness","Inwood","Inyokern","Iola","Ione","Ionia","Iota","Iowa","Iowa City","Iowa Falls","Iowa Park","Ipswich","Iraan","Irasburg","Iredell","Ireland","Irene","Ireton","Irma","Irmo","Iron City","Iron Junction","Iron Mountain","Iron Ridge","Iron River","Iron Station","Irons","Ironton","Ironwood","Iroquois","Irrigon","Irvine","Irving","Irvington","Irwin","Irwinton","Isabel","Isabella","Isanti","Iselin","Ishpeming","Islamorada","Island","Island Falls","Island Heights","Island Lake","Island Park","Islandia","Islandton","Isle","Isle of Palms","Isle of Wight","Islesboro","Islesford","Isleta","Isleton","Islip","Islip Terrace","Ismay","Issaquah","Italia","Italy","Itasca","Ithaca","Itmann","Itta Bena","Iuka","Iva","Ivanhoe","Ivel","Ivins","Ivor","Ivoryton","Ivydale","Ixonia","Jack","Jackpot","Jacks Creek","Jacksboro","Jackson","Jackson Center","Jackson Heights","Jackson Township","Jacksonboro","Jacksonburg","Jacksons Gap","Jacksonville","Jacksonville Beach","Jacobs Creek","Jacobsburg","Jacobson","Jacumba Hot Springs","Jaffrey","Jal","Jamaica","Jamaica Plain","Jameson","Jamesport","Jamestown","Jamesville","Jamison","Jamul","Jane Lew","Janesville","Jaroso","Jarreau","Jarrell","Jarrettsville","Jarvisburg","Jasonville","Jasper","Jay","Jayess","Jayton","Jean","Jeanerette","Jeannette","Jeddo","Jeff","Jeffers","Jefferson","Jefferson City","Jefferson Valley","Jeffersonton","Jeffersonville","Jeffrey","Jekyll Island","Jellico","Jemez Pueblo","Jemez Springs","Jemison","Jena","Jenison","Jenkins","Jenkinsburg","Jenkinsville","Jenkintown","Jenks","Jenner","Jennerstown","Jennings","Jensen Beach","Jeremiah","Jericho","Jerico Springs","Jermyn","Jerome","Jersey","Jersey City","Jersey Shore","Jerseyville","Jerusalem","Jessup","Jesup","Jet","Jetersville","Jetmore","Jewell","Jewett","Jewett City","Jim Falls","Jim Thorpe","Joanna","Joaquin","Jobstown","Joelton","Joes","Johannesburg","John Day","Johns Island","Johnson","Johnson City","Johnson Creek","Johnsonburg","Johnsonville","Johnston","Johnston City","Johnstown","Joice","Joiner","Joliet","Jolon","Jones","Jonesboro","Jonesborough","Jonesburg","Jonesport","Jonestown","Jonesville","Joplin","Joppa","Jordan","Jordan Valley","Joseph","Josephine","Joshua","Joshua Tree","Jourdanton","Joy","Jud","Juda","Judith Gap","Judsonia","Julesburg","Juliaetta","Julian","Juliette","Jumping Branch","Junction","Junction City","June Lake","Juneau","Juniata","Junior","Juno Beach","Jupiter","Justice","Justin","Kadoka","Kahoka","Kahuku","Kahului","Kailua","Kaiser","Kake","Kaktovik","Kalaheo","Kalama","Kalamazoo","Kaleva","Kalida","Kalispell","Kalkaska","Kalona","Kalskag","Kamas","Kamiah","Kampsville","Kanab","Kanawha","Kandiyohi","Kane","Kaneville","Kankakee","Kannapolis","Kanopolis","Kansas","Kansas City","Kansasville","Kapaau","Kaplan","Kapolei","Karlstad","Karnack","Karnak","Karnes City","Karns City","Karthaus","Karval","Kasota","Kasson","Kathleen","Katonah","Katy","Kaufman","Kaukauna","Kaumakani","Kaunakakai","Kauneonga Lake","Kaw City","Kaweah","Kawkawlin","Kaycee","Kayenta","Kaysville","Kealakekua","Keams Canyon","Keansburg","Kearney","Kearneysville","Kearny","Keasbey","Keatchie","Keauhou","Keavy","Kechi","Keedysville","Keego Harbor","Keene","Keene Valley","Keenesburg","Keeseville","Keewatin","Keezletown","Kegley","Keithville","Keizer","Kekaha","Kelayres","Kelford","Keller","Kellerton","Kelley","Kelliher","Kellogg","Kelly","Kellyton","Kellyville","Kelseyville","Kelso","Kemah","Kemmerer","Kemp","Kempner","Kempton","Kenai","Kenansville","Kenbridge","Kendalia","Kendall","Kendall Park","Kendallville","Kendrick","Kenduskeag","Kenedy","Kenesaw","Kenilworth","Kenly","Kenmare","Kenmore","Kenna","Kennan","Kennard","Kennebec","Kennebunk","Kennebunkport","Kennedale","Kennedy","Kennedyville","Kenner","Kennerdell","Kennesaw","Kennett","Kennett Square","Kennewick","Kenney","Keno","Kenosha","Kenova","Kensett","Kensington","Kent","Kent City","Kentfield","Kentland","Kenton","Kents Hill","Kents Store","Kentwood","Kenvil","Kenyon","Keokuk","Keosauqua","Keota","Kerby","Kerens","Kerhonkson","Kerkhoven","Kerman","Kermit","Kernersville","Kernville","Kerrick","Kerrville","Kersey","Kershaw","Keshena","Keswick","Ketchikan","Ketchum","Kettle Falls","Kettle Island","Kettleman City","Keuka Park","Kevil","Kevin","Kew Gardens","Kewadin","Kewanee","Kewanna","Kewaskum","Kewaunee","Key Biscayne","Key Largo","Key West","Keyes","Keymar","Keyport","Keyser","Keystone","Keystone Heights","Keysville","Keytesville","Kiamesha Lake","Kiana","Kiefer","Kiel","Kieler","Kiester","Kihei","Kila","Kilauea","Kilbourne","Kilgore","Kilkenny","Kilkenny Township","Kill Devil Hills","Killbuck","Killdeer","Killeen","Killen","Killington","Killingworth","Kilmarnock","Kilmichael","Kiln","Kimball","Kimballton","Kimberling City","Kimberly","Kimberton","Kimbolton","Kimmell","Kimper","Kincaid","Kinde","Kinder","Kinderhook","Kindred","King","King and Queen Court House","King City","King Cove","King George","King of Prussia","King Salmon","King William","Kingdom City","Kingfield","Kingfisher","Kingman","Kings Bay Base","Kings Beach","Kings Mills","Kings Mountain","Kings Park","Kingsburg","Kingsbury","Kingsford","Kingsland","Kingsley","Kingsport","Kingston","Kingston Springs","Kingstree","Kingsville","Kingwood","Kinmundy","Kinnear","Kinsley","Kinsman","Kinston","Kinta","Kintnersville","Kintyre","Kinzers","Kiowa","Kipling","Kipnuk","Kirby","Kirbyville","Kirk","Kirkland","Kirklin","Kirksey","Kirksville","Kirkville","Kirkwood","Kiron","Kirtland","Kirwin","Kismet","Kissee Mills","Kissimmee","Kite","Kittanning","Kittery","Kittery Point","Kitts Hill","Kitty Hawk","Klamath","Klamath Falls","Klamath River","Klawock","Klemme","Knapp","Knife River","Knightdale","Knights Landing","Knightsen","Knightstown","Knightsville","Knippa","Knob Lick","Knob Noster","Knott","Knox","Knox City","Knox Dale","Knoxville","Kodak","Kodiak","Kohler","Kokomo","Koloa","Konawa","Kongiganak","Kooskia","Koppel","Kopperl","Kosciusko","Kotlik","Kountze","Kouts","Koyuk","Krakow","Kramer","Krebs","Kremmling","Krum","Kula","Kulm","Kulpmont","Kuna","Kunkletown","Kure Beach","Kurtistown","Kuttawa","Kutztown","Kwethluk","Kykotsmovi Village","Kyle","Kyles Ford","La Barge","La Belle","La Blanca","La Canada Flintridge","La Center","La Conner","La Crescent","La Crescenta","La Crosse","La Cygne","La Farge","La Fayette","La Feria","La Fontaine","La Fox","La Grande","La Grange","La Grange Park","La Habra","La Harpe","La Honda","La Jara","La Jolla","La Joya","La Junta","La Luz","La Marque","La Mesa","La Mirada","La Moille","La Motte","La Palma","La Pine","La Plata","La Pointe","La Porte","La Porte City","La Prairie","La Pryor","La Puente","La Quinta","La Rue","La Sal","La Salle","La Valle","La Vergne","La Verne","La Vernia","La Veta","La Vista","Labadie","Labadieville","LaBelle","LaBolt","Lac du Flambeau","Lacey","Laceys Spring","Laceyville","Lachine","Lackawaxen","Lackey","Lacombe","Lacon","Lacona","Laconia","Ladd","Laddonia","Ladera Ranch","Ladoga","Ladonia","Ladora","Ladson","Lady Lake","Ladysmith","Lafayette","LaFayette","Lafferty","Lafitte","LaFollette","Lagrange","Lagrangeville","Lagro","Laguna","Laguna Beach","Laguna Hills","Laguna Niguel","Laguna Woods","Lagunitas","Lahaina","Lahaska","Laingsburg","Lake","Lake Alfred","Lake Andes","Lake Ann","Lake Ariel","Lake Arrowhead","Lake Arthur","Lake Benton","Lake Bluff","Lake Bronson","Lake Buena Vista","Lake Butler","Lake Charles","Lake City","Lake Cormorant","Lake Crystal","Lake Dallas","Lake Delton","Lake Elmo","Lake Elsinore","Lake Forest","Lake Geneva","Lake George","Lake Grove","Lake Hamilton","Lake Harmony","Lake Havasu City","Lake Helen","Lake Hiawatha","Lake Hopatcong","Lake Hughes","Lake in the Hills","Lake Isabella","Lake Jackson","Lake Junaluska","Lake Katrine","Lake Lillian","Lake Linden","Lake Lure","Lake Luzerne","Lake Lynn","Lake Mary","Lake Mills","Lake Monroe","Lake Nebagamon","Lake Norden","Lake Odessa","Lake Orion","Lake Oswego","Lake Ozark","Lake Panasoffkee","Lake Park","Lake Peekskill","Lake Placid","Lake Pleasant","Lake Preston","Lake Providence","Lake Saint Louis","Lake Shasta","Lake Station","Lake Stevens","Lake Tomahawk","Lake Toxaway","Lake View","Lake Villa","Lake Village","Lake Waccamaw","Lake Wales","Lake Wilson","Lake Winola","Lake Worth","Lake Zurich","Lakebay","Lakefield","Lakehead","Lakehurst","Lakeland","Lakemont","Lakemore","Lakeport","Lakeside","Laketown","Lakeview","Lakeville","Lakewood","Lakin","Lakota","Lamar","Lambert","Lamberton","Lambertville","Lambsburg","Lame Deer","Lamesa","Lamoni","Lamont","LaMoure","Lampasas","Lamy","Lanai","Lanark","Lancaster","Lancing","Landenberg","Lander","Landing","Landis","Landisburg","Landisville","Landrum","Lanesboro","Lanesville","Lanett","Laneville","Lanexa","Langdon","Langeloth","Langford","Langhorne","Langley","Langston","Langsville","Lanham","Lanoka Harbor","Lansdale","Lansdowne","Lanse","Lansford","Lansing","Lantry","Laona","Laotto","Lapeer","Lapel","Lapine","Laplace","Laporte","Lapwai","Laquey","Laramie","Larchmont","Larchwood","Laredo","Largo","Larimore","Larkspur","Larned","Larose","Las Animas","Las Cruces","Las Vegas","LaSalle","Lascassas","Latexo","Latham","Lathrop","Latimer","Laton","Latonia","Latrobe","Latta","Lattimer","Lattimore","Lauderdale","Laughlin","Laughlintown","Laura","Laurel","Laurel Hill","Laurel Springs","Laurelton","Laurelville","Laurens","Laurinburg","Laurys Station","Lavaca","Lavalette","Lavallette","Laveen","LaVerkin","Laverne","Lavon","Lavonia","Lawler","Lawn","Lawndale","Lawnside","Lawrence","Lawrenceburg","Lawrenceville","Lawson","Lawton","Layton","Laytonville","Le Center","Le Grand","Le Mars","Le Raysville","Le Roy","Le Sueur","Lead","Lead Hill","Leadville","Leadwood","Leaf River","League City","Leakesville","Leakey","Leander","Leary","Leavenworth","Leavittsburg","Leawood","Lebanon","Lebanon Junction","Lebec","Lebo","Leburn","Lecanto","LeClaire","Lecompte","Lecompton","Ledbetter","Lederach","Ledgewood","Ledyard","Ledyard Center","Lee","Lee Center","Leechburg","Leedey","Leeds","Leeper","Leesburg","Leesport","Leesville","Leeton","Leetonia","Leetsdale","Lefor","Lefors","Lehi","Lehigh","Lehigh Acres","Lehighton","Lehman","Lehr","Leicester","Leigh","Leighton","Leipsic","Leitchfield","Leland","Lemasters","Lemmon","Lemon Grove","Lemont","Lemont Furnace","Lemoore","Lemoyne","Lempster","Lena","Lenapah","Lenexa","Lengby","Lenhartsville","Lenni","Lennon","Lennox","Lenoir","Lenoir City","Lenora","Lenore","Lenox","Leo","Leola","Leoma","Leominster","Leon","Leona","Leonard","Leonardo","Leonardsville","Leonardtown","Leonardville","Leonia","Leonidas","Leonore","Leonville","Leopold","Leopolis","Leoti","Lepanto","Lerna","LeRoy","Leroy","Lesage","Leslie","Lester","Lester Prairie","Lesterville","Letart","Letohatchee","Letts","Levan","Levant","Levelland","Levelock","Levels","Leverett","Levering","Levittown","Lewellen","Lewes","Lewis","Lewis Center","Lewis Run","Lewisberry","Lewisburg","Lewisport","Lewiston","Lewiston Woodville","Lewistown","Lewisville","Lexa","Lexington","Lexington Park","Libby","Liberal","Liberty","Liberty Center","Liberty Corner","Liberty Hill","Liberty Lake","Libertytown","Libertyville","Lick Creek","Licking","Lidgerwood","Liebenthal","Lignum","Ligonier","Lihue","Likely","Lilburn","Lilesville","Lillian","Lillington","Lilliwaup","Lilly","Lily Dale","Lima","Lime Ridge","Lime Springs","Limerick","Limestone","Limington","Limon","Lincoln","Lincoln City","Lincoln Park","Lincolndale","Lincolnshire","Lincolnton","Lincolnville","Lincolnville Center","Lincolnwood","Lincroft","Lindale","Linden","Lindenhurst","Lindley","Lindon","Lindsay","Lindsborg","Lindside","Lindstrom","Linesville","Lineville","Linkwood","Linn","Linn Creek","Linneus","Linthicum Heights","Linton","Linville","Linwood","Lipan","Lisbon","Lisbon Falls","Liscomb","Lisle","Lismore","Listie","Litchfield","Litchfield Park","Litchfield Plains","Lithia","Lithia Springs","Lithonia","Lithopolis","Lititz","Little America","Little Chute","Little Compton","Little Elm","Little Falls","Little Ferry","Little Hocking","Little Meadows","Little Mountain","Little Neck","Little River","Little River-Academy","Little Rock","Little Rock Air Force Base","Little Silver","Little Suamico","Little Valley","Littlefield","Littlefork","Littlerock","Littlestown","Littleton","Live Oak","Livermore","Livermore Falls","Liverpool","Livingston","Livingston Manor","Livonia","Lizella","Lizton","Llano","Loa","Loachapoka","Loami","Lobelville","Local","Loch Sheldrake","Lock Haven","Lockbourne","Locke","Lockeford","Lockesburg","Lockhart","Lockney","Lockport","Lockwood","Loco","Locust","Locust Fork","Locust Gap","Locust Grove","Locust Valley","Loda","Lodge","Lodge Grass","Lodi","Log Lane Village","Logan","Logandale","Logansport","Loganton","Loganville","Lohman","Lohn","Lolita","Lolo","Loma","Loma Linda","Lomax","Lombard","Lomira","Lomita","Lompoc","Lonaconing","London","London Mills","Londonderry","Lone Grove","Lone Jack","Lone Oak","Lone Pine","Lone Rock","Lone Tree","Lone Wolf","Lonedell","Long Beach","Long Branch","Long Grove","Long Island","Long Island City","Long Lake","Long Lane","Long Pine","Long Pond","Long Prairie","Long Valley","Longboat Key","Longbranch","Longdale","Longmeadow","Longmont","Longport","Longs","Longton","Longview","Longville","Longwood","Lonoke","Lonsdale","Loogootee","Lookout","Lookout Mountain","Loomis","Loon Lake","Loop","Loose Creek","Lopez","Lorain","Loraine","Loranger","Lordsburg","Lore City","Lorena","Lorenzo","Loretto","Lorimor","Loris","Lorman","Lorraine","Lorton","Los Alamitos","Los Alamos","Los Altos","Los Altos Hills","Los Angeles","Los Banos","Los Fresnos","Los Gatos","Los Lunas","Los Molinos","Los Olivos","Los Osos","Losantville","Lost City","Lost Creek","Lost Nation","Lost Springs","Lostant","Lostine","Lothian","Lott","Lottie","Lottsburg","Lotus","Loudon","Loudonville","Louin","Louisa","Louisburg","Louise","Louisiana","Louisville","Loup City","Lovejoy","Lovelady","Loveland","Lovell","Lovelock","Lovely","Loves Park","Lovettsville","Loveville","Lovilia","Loving","Lovingston","Lovington","Low and Burbanks Grant","Low Moor","Lowber","Lowden","Lowell","Lowellville","Lower Brule","Lower Lake","Lower Salem","Lowgap","Lowman","Lowmansville","Lowndes","Lowndesboro","Lowry","Lowry City","Lowville","Loxahatchee Groves","Loxley","Loyal","Loyalhanna","Loyall","Loysville","Lu Verne","Lubbock","Lubec","Lucama","Lucan","Lucas","Lucasville","Lucedale","Lucerne","Lucerne Valley","Lucinda","Luck","Luckey","Ludington","Ludlow","Ludlow Falls","Ludowici","Lueders","Lufkin","Lugoff","Lula","Luling","Lumberport","Lumberton","Lumberville","Lummi Island","Lumpkin","Luna Pier","Lund","Lunenburg","Lupton City","Luray","Lusby","Lusk","Lutcher","Luther","Luthersburg","Luthersville","Lutherville-Timonium","Lutsen","Luttrell","Lutz","Luverne","Luxemburg","Luxor","Luxora","Luzerne","Lydia","Lyerly","Lykens","Lyle","Lyles","Lyman","Lyme","Lynbrook","Lynch","Lynch Station","Lynchburg","Lynco","Lynd","Lyndeborough","Lynden","Lyndhurst","Lyndon","Lyndon Center","Lyndon Station","Lyndonville","Lynn","Lynn Center","Lynn Haven","Lynnfield","Lynnville","Lynnwood","Lynwood","Lyon","Lyons","Lytle","Lytle Creek","Mabank","Mabel","Mabelvale","Maben","Mableton","Mabton","Macclenny","Macclesfield","Macdoel","Macedon","Macedonia","Macfarlan","Machesney Park","Machias","Machiasport","Mackay","Mackinac Island","Mackinaw","Mackinaw City","Macksburg","Macomb","Macon","Macungie","Mad River","Madawaska","Madbury","Maddock","Madelia","Madera","Madill","Madison","Madison Heights","Madison Lake","Madisonville","Madras","Madrid","Magalia","Magazine","Magdalena","Magee","Maggie Valley","Magna","Magnolia","Magnolia Springs","Mahaffey","Mahanoy City","Mahaska","Mahnomen","Mahomet","Mahopac","Mahwah","Maiden","Maiden Rock","Maidens","Maidsville","Mainesburg","Maineville","Maitland","Maize","Makanda","Makawao","Makinen","Malabar","Malad City","Malaga","Malakoff","Malcom","Malden","Malibu","Malin","Malinta","Mallory","Malmo","Malone","Malott","Malta","Malvern","Malverne","Mamaroneck","Mammoth","Mammoth Lakes","Mamou","Man","Manahawkin","Manasquan","Manassas","Manassas Park","Manawa","Mancelona","Manchaca","Manchaug","Manchester","Manchester Center","Manchester Township","Manchester-by-the-Sea","Mancos","Mandan","Mandaree","Manderson","Mandeville","Mangum","Manhasset","Manhattan","Manhattan Beach","Manheim","Manila","Manistee","Manistique","Manito","Manitou","Manitou Springs","Manitowoc","Mankato","Manlius","Manly","Mannford","Manning","Mannington","Manns Choice","Mannsville","Manokotak","Manomet","Manor","Manorville","Manquin","Mansfield","Mansfield Center","Mansfield Depot","Manson","Mansura","Mantachie","Manteca","Mantee","Manteno","Manteo","Manti","Mantoloking","Manton","Mantorville","Mantua","Manvel","Manville","Many","Many Farms","Manzanita","Manzanola","Maple City","Maple Falls","Maple Grove","Maple Heights","Maple Hill","Maple Lake","Maple Park","Maple Plain","Maple Rapids","Maple Shade","Maple Valley","Maplesville","Mapleton","Mapleville","Maplewood","Mappsville","Maquoketa","Marana","Marathon","Marble","Marble Falls","Marble Hill","Marble Rock","Marblehead","Marblehill","Marblemount","Marbury","Marceline","Marcell","Marcellus","March Air Force Base","Marco Island","Marcus","Marcus Hook","Marcy","Mardela Springs","Marengo","Marenisco","Marfa","Margaret","Margaretville","Margate City","Maria Stein","Marianna","Maribel","Maricopa","Marienthal","Marienville","Marietta","Marina","Marina del Rey","Marine","Marine City","Marine on Saint Croix","Marinette","Maringouin","Marion","Marion Center","Marion Heights","Marion Junction","Marionville","Mariposa","Marissa","Mark Center","Marked Tree","Markesan","Markham","Markle","Markleeville","Markleville","Markleysburg","Marks","Marksville","Marlboro","Marlborough","Marlette","Marlin","Marlinton","Marlow","Marlton","Marmora","Marne","Maroa","Marquand","Marquette","Marquez","Marrero","Marriottsville","Mars","Mars Hill","Marseilles","Marshall","Marshalls Creek","Marshalltown","Marshallville","Marshfield","Marshfield Hills","Marshville","Marsing","Marsteller","Marstons Mills","Mart","Martell","Martelle","Martha","Marthasville","Marthaville","Martin","Martindale","Martinez","Martins Creek","Martins Ferry","Martinsburg","Martinsdale","Martinsville","Martville","Mary Esther","Marydel","Maryknoll","Maryland","Maryland Heights","Marylhurst","Maryneal","Marysvale","Marysville","Maryville","Mascot","Mascotte","Mascoutah","Mashantucket","Mashpee","Maskell","Mason","Mason City","Masontown","Masonville","Maspeth","Mass City","Massapequa","Massapequa Park","Massena","Massey","Massillon","Mastic","Mastic Beach","Masury","Matamoras","Matawan","Matewan","Matfield Green","Mather Field","Mathews","Mathias","Mathis","Mathiston","Matinicus","Matoaka","Mattapan","Mattapoisett","Mattaponi","Mattawa","Mattawamkeag","Mattawan","Mattawana","Matteson","Matthews","Mattituck","Mattoon","Mauckport","Maud","Mauk","Mauldin","Maumee","Maumelle","Maunaloa","Maupin","Maurepas","Maurertown","Maurice","Mauriceville","Maury","Maury City","Mauston","Max","Max Meadows","Maxatawny","Maxbass","Maxton","Maxwell","May","May Creek","Maybee","Maybrook","Mayer","Mayesville","Mayetta","Mayfield","Mayflower","Maylene","Maynard","Maynardville","Mayo","Mayodan","Maypearl","Mayport","Mays Landing","Maysel","Maysville","Mayville","Maywood","Mazeppa","Mazomanie","Mazon","McAdoo","McAlester","McAlister","McAlisterville","McAllen","McAlpin","McArthur","McBain","McBee","McCall","McCalla","McCamey","McCammon","McCaysville","McCleary","McClellan Park Census Designated Place","McClelland","McClellandtown","McClellanville","McCloud","McClure","McClusky","McColl","McComb","McConnells","McConnellsburg","McConnelsville","McCook","McCool","McCool Junction","McCordsville","McCormick","McCoy","McCune","McCurtain","McCutchenville","McDaniels","McDavid","McDermitt","McDermott","McDonald","McDonough","McDowell","McElhattan","McEwen","McFall","McFarland","McGaheysville","McGehee","McGraw","McGregor","McHenry","McIntosh","McKean Township","McKee","McKees Rocks","McKeesport","McKenna","McKenzie","McKinleyville","McKinney","McLain","McLaughlin","McLean","McLeansboro","McLeansville","McLoud","McMechen","McMillan","McMinnville","McNabb","McNary","McNeal","McPherson","McQueeney","McRae","McSherrystown","McVeytown","McVille","Meacham","Mead","Meade","Meadow","Meadow Bridge","Meadow Grove","Meadow Lands","Meadow Valley","Meadow Vista","Meadowlands","Meadows of Dan","Meadowview","Meadview","Meadville","Meally","Meansville","Mears","Mebane","Mecca","Mechanic Falls","Mechanicsburg","Mechanicsville","Mechanicville","Mecosta","Medanales","Medaryville","Medfield","Medford","Media","Mediapolis","Medical Lake","Medicine Lake","Medicine Lodge","Medicine Park","Medina","Medinah","Medon","Medora","Medway","Meeker","Meeteetse","Meherrin","Mehoopany","Mekoryuk","Melba","Melbourne","Melbourne Beach","Melcher-Dallas","Melcroft","Melfa","Melissa","Mellen","Mellenville","Melrose","Melrose Park","Melstone","Melville","Melvin","Melvindale","Memphis","Mena","Menahga","Menan","Menard","Menasha","Mendenhall","Mendham","Mendocino","Mendon","Mendota","Menifee","Menlo","Menlo Park","Menno","Meno","Menominee","Menomonee Falls","Mentone","Mentor","Mequon","Mer Rouge","Meraux","Merced","Mercedes","Mercer","Mercer Island","Mercersburg","Merchantville","Meredith","Mereta","Meriden","Meridian","Meridianville","Merino","Merion","Merit","Merkel","Merlin","Mermentau","Merna","Merrick","Merrifield","Merrill","Merrillan","Merrillville","Merrimac","Merrimack","Merriman","Merritt","Merritt Island","Merry Hill","Merry Point","Merryville","Merton","Mertzon","Mertztown","Mesa","Mescalero","Meshoppen","Mesick","Mesilla","Mesilla Park","Mesquite","Metairie","Metaline Falls","Metamora","Metcalf","Methow","Methuen","Metlakatla","Metropolis","Metropolitan","Metter","Metuchen","Metz","Mexia","Mexico","Meyersdale","Mi-Wuk Village","Miami","Miami Beach","Miamisburg","Miamitown","Miamiville","Micanopy","Michie","Michigan Center","Michigan City","Michigantown","Mickleton","Mico","Micro","Middle Bass","Middle Granville","Middle Grove","Middle Haddam","Middle Island","Middle Point","Middle River","Middle Village","Middleboro","Middlebourne","Middleburg","Middleburgh","Middlebury","Middlefield","Middleport","Middlesboro","Middlesex","Middleton","Middletown","Middletown Springs","Middleville","Midfield","Midkiff","Midland","Midland City","Midland Park","Midlothian","Midvale","Midville","Midway","Midway City","Midway Park","Midwest","Mifflin","Mifflinburg","Mifflintown","Mifflinville","Mikado","Milaca","Milam","Milan","Milano","Milbank","Milburn","Miles","Miles City","Milesburg","Milford","Milford Center","Mililani Town","Mill City","Mill Creek","Mill Hall","Mill Neck","Mill River","Mill Shoals","Mill Spring","Mill Valley","Milladore","Millboro","Millbrae","Millbrook","Millburn","Millbury","Milldale","Milledgeville","Millen","Miller","Miller Place","Millers Creek","Millersburg","Millersport","Millerstown","Millersview","Millersville","Millerton","Millfield","Millheim","Millican","Milligan","Milliken","Millington","Millinocket","Millis","Millmont","Millport","Millry","Mills","Mills River","Millsap","Millsboro","Millstadt","Millstone","Milltown","Millville","Millwood","Milmay","Milner","Milnesville","Milnor","Milo","Milpitas","Milroy","Milton","Milton Mills","Milton-Freewater","Miltona","Miltonvale","Milwaukee","Milwaukie","Mimbres","Mims","Minburn","Minco","Minden","Minden City","Mine Hill","Mineola","Mineral","Mineral Bluff","Mineral City","Mineral Point","Mineral Ridge","Mineral Springs","Mineral Wells","Minersville","Minerva","Minford","Mingo Junction","Minier","Minneapolis","Minneola","Minneota","Minnesota Lake","Minnetonka","Minnewaukan","Minnie","Minoa","Minocqua","Minonk","Minooka","Minot","Minotola","Minster","Minto","Minturn","Mio","Mira Loma","Miramar","Miramar Beach","Miranda","Mishawaka","Mishicot","Mission","Mission Hill","Mission Hills","Mission Viejo","Missoula","Missouri City","Missouri Valley","Mitchell","Mitchellville","Mize","Moab","Moapa","Moatsville","Moberly","Mobile","Mobridge","Moccasin","Mocksville","Modale","Modena","Modesto","Modoc","Mogadore","Mohave Valley","Mohawk","Mohegan Lake","Mohnton","Mohrsville","Mojave","Mokelumne Hill","Mokena","Molalla","Molena","Moline","Molino","Mollusk","Molt","Momence","Mona","Monaca","Monahans","Moncks Corner","Moncure","Mondamin","Mondovi","Monee","Monessen","Moneta","Monett","Monette","Monkton","Monmouth","Monmouth Beach","Monmouth Junction","Monon","Monona","Monongahela","Monponsett","Monroe","Monroe Center","Monroe City","Monroe Township","Monroeton","Monroeville","Monrovia","Monsey","Monson","Mont Belvieu","Mont Clare","Mont Vernon","Montague","Montandon","Montara","Montauk","Montclair","Monte Rio","Monte Vista","Monteagle","Montebello","Montegut","Montello","Monterey","Monterey County","Monterey Park","Monterville","Montesano","Montevallo","Montevideo","Monteview","Montezuma","Montfort","Montgomery","Montgomery Center","Montgomery City","Montgomery Creek","Montgomery Village","Montgomeryville","Monticello","Montour","Montour Falls","Montoursville","Montpelier","Montreal","Montreat","Montrose","Montross","Montvale","Montverde","Montville","Monument","Monument Beach","Moodus","Moody","Mooers","Mooers Forks","Moon","Moonachie","Moorcroft","Moore","Moore Haven","Moorefield","Mooreland","Moores Hill","Mooresboro","Mooresburg","Moorestown Township","Mooresville","Mooreton","Mooreville","Moorhead","Mooringsport","Moorland","Moorpark","Moose","Moose Lake","Moosic","Moosup","Mora","Moraga","Moran","Moravia","Moravian Falls","Moreauville","Morehead","Morehead City","Moreland","Morenci","Moreno Valley","Moretown","Morgan","Morgan City","Morgan Hill","Morganfield","Morganton","Morgantown","Morganville","Moriah","Moriarty","Moriches","Morley","Morning Sun","Morning View","Moro","Morocco","Morongo Valley","Moroni","Morral","Morrice","Morrill","Morrilton","Morris","Morris Chapel","Morris Plains","Morrisdale","Morrison","Morrisonville","Morriston","Morristown","Morrisville","Morro Bay","Morrow","Morse","Morse Bluff","Morton","Morton Grove","Mortons Gap","Morven","Mosca","Moscow","Moscow Mills","Moseley","Moses Lake","Mosheim","Mosier","Mosinee","Moss","Moss Beach","Moss Landing","Moss Point","Mossyrock","Motley","Mott","Moulton","Moultonborough","Moultrie","Mound","Mound Bayou","Mound City","Moundridge","Mounds","Moundsville","Moundville","Mount Airy","Mount Angel","Mount Arlington","Mount Auburn","Mount Ayr","Mount Berry","Mount Bethel","Mount Blanchard","Mount Calvary","Mount Carbon","Mount Carmel","Mount Carroll","Mount Clemens","Mount Cory","Mount Crawford","Mount Croghan","Mount Eaton","Mount Eden","Mount Enterprise","Mount Ephraim","Mount Erie","Mount Gay","Mount Gilead","Mount Gretna","Mount Hermon","Mount Holly","Mount Holly Springs","Mount Hope","Mount Horeb","Mount Ida","Mount Jackson","Mount Jewett","Mount Joy","Mount Juliet","Mount Kisco","Mount Laurel","Mount Lookout","Mount Morris","Mount Nebo","Mount Olive","Mount Olivet","Mount Orab","Mount Pleasant","Mount Pleasant Mills","Mount Pocono","Mount Prospect","Mount Pulaski","Mount Rainier","Mount Royal","Mount Saint Joseph","Mount Savage","Mount Shasta","Mount Sidney","Mount Sinai","Mount Sterling","Mount Storm","Mount Tremper","Mount Ulla","Mount Union","Mount Upton","Mount Vernon","Mount Victoria","Mount Victory","Mount Vision","Mount Washington","Mount Wilson","Mount Wolf","Mount Zion","Mountain","Mountain City","Mountain Grove","Mountain Home","Mountain Iron","Mountain Lake","Mountain Lakes","Mountain Pine","Mountain Ranch","Mountain Top","Mountain View","Mountain Village","Mountainair","Mountainburg","Mountainside","Mountainville","Mountlake Terrace","Mountville","Mousie","Mouth of Wilson","Mouthcard","Moville","Moweaqua","Moxee City","Moyie Springs","Moyock","Mt Pleasant","Mt. Dora","Mt. Morris","Mt. Pleasant","Mt. Vernon","Muenster","Muir","Mukilteo","Mukwonago","Mulberry","Mulberry Grove","Muldoon","Muldraugh","Muldrow","Muleshoe","Mulga","Mulino","Mulkeytown","Mullan","Mullen","Mullica Hill","Mulliken","Mullin","Mullins","Mullinville","Mulvane","Muncie","Muncy","Munday","Mundelein","Munford","Munfordville","Munger","Munich","Munising","Munith","Munnsville","Munroe Falls","Munster","Murchison","Murdock","Murfreesboro","Murphy","Murphys","Murphysboro","Murray","Murrayville","Murrells Inlet","Murrieta","Murrysville","Muscatine","Muscle Shoals","Muscoda","Muse","Musella","Muskego","Muskegon","Muskogee","Mustang","Mutual","Myakka City","Myerstown","Myersville","Mylo","Myrtle","Myrtle Beach","Myrtle Creek","Myrtle Point","Mystic","Myton","N. Lawrence","Nabb","Nabesna","Naco","Nacogdoches","Nacoochee","Nageezi","Nags Head","Nahant","Nahunta","Naknek","Nampa","Nancy","Nanjemoy","Nanticoke","Nantucket","Nanty Glo","Nanuet","Naoma","Napa","Napavine","Naper","Naperville","Napier","Naples","Napoleon","Napoleonville","Nappanee","Nara Visa","Narberth","Narka","Narragansett","Narrows","Narrowsburg","Narvon","Naselle","Nash","Nashoba","Nashotah","Nashport","Nashua","Nashville","Nashwauk","Nassau","Nassawadox","Natalbany","Natalia","Natchez","Natchitoches","Natick","National City","National Park","Natrona Heights","Natural Bridge","Natural Bridge Station","Naturita","Naubinway","Naugatuck","Nauvoo","Navajo","Navarre","Navasota","Naylor","Nazan Village","Nazareth","Neah Bay","Nebo","Nebraska City","Necedah","Neche","Nederland","Nedrow","Needham","Needham Heights","Needles","Needmore","Needville","Neely","Neelyville","Neenah","Neeses","Neffs","Negaunee","Negley","Nehalem","Neillsville","Nekoosa","Neligh","Nellis","Nellysford","Nelson","Nelsonville","Nemacolin","Nemaha","Nemo","Nenana","Neodesha","Neoga","Neola","Neosho","Neosho Falls","Neosho Rapids","Neotsu","Nephi","Neponset","Neptune Beach","Neptune City","Nerstrand","Nesbit","Nesconset","Nescopeck","Neshanic Station","Neshkoro","Nesquehoning","Ness City","Nester","Netawaka","Netcong","Nettleton","Nevada","Nevada City","Neversink","Nevis","New Albany","New Albin","New Alexandria","New Almaden","New Athens","New Auburn","New Baden","New Baltimore","New Bavaria","New Bedford","New Berlin","New Berlinville","New Bern","New Bethlehem","New Blaine","New Bloomfield","New Boston","New Braintree","New Braunfels","New Bremen","New Brighton","New Britain","New Brockton","New Brunswick","New Buffalo","New Burnside","New Cambria","New Canaan","New Caney","New Canton","New Carlisle","New Castle","New Church","New City","New Columbia","New Concord","New Creek","New Cumberland","New Cuyama","New Deal","New Derry","New Douglas","New Durham","New Eagle","New Effington","New Egypt","New England","New Enterprise","New Era","New Fairfield","New Florence","New Franken","New Franklin","New Freedom","New Galilee","New Germany","New Glarus","New Gloucester","New Goshen","New Hampton","New Harbor","New Harmony","New Hartford","New Haven","New Hebron","New Hill","New Holland","New Holstein","New Hope","New Hudson","New Hyde Park","New Iberia","New Ipswich","New Johnsonville","New Kensington","New Kent","New Knoxville","New Laguna","New Lebanon","New Lenox","New Lexington","New Liberty","New Lisbon","New Llano","New London","New Lothrop","New Madrid","New Market","New Marshfield","New Martinsville","New Meadows","New Memphis","New Middletown","New Milford","New Orleans","New Oxford","New Palestine","New Paltz","New Paris","New Park","New Philadelphia","New Plymouth","New Point","New Port Richey","New Portland","New Prague","New Preston","New Providence","New Raymer","New Richland","New Richmond","New Riegel","New Ringgold","New River","New Roads","New Rochelle","New Rockford","New Ross","New Salem","New Salisbury","New Sharon","New Smyrna Beach","New Springfield","New Stanton","New Straitsville","New Stuyahok","New Tazewell","New Town","New Tripoli","New Troy","New Ulm","New Underwood","New Vernon","New Vienna","New Vineyard","New Virginia","New Washington","New Waterford","New Waverly","New Weston","New Wilmington","New Windsor","New Woodstock","New York","New York Mills","Newalla","Newark","Newark Valley","Newaygo","Newberg","Newbern","Newberry","Newberry Springs","Newborn","Newburg","Newburgh","Newbury","Newbury Center","Newbury Old Town","Newbury Park","Newburyport","Newcastle","Newcomb","Newcomerstown","Newell","Newellton","Newfane","Newfield","Newfields","Newfolden","Newfoundland","Newhall","Newhope","Newington","Newkirk","Newland","Newman","Newman Grove","Newman Lake","Newmanstown","Newmarket","Newnan","Newport","Newport Beach","Newport Center","Newport Coast","Newport News","Newry","Newsoms","Newton","Newton Center","Newton Falls","Newton Grove","Newton Highlands","Newton Lower Falls","Newton Upper Falls","Newtonsville","Newtonville","Newtown","Newtown Square","Newville","Nezperce","Niagara","Niagara Falls","Niangua","Niantic","Nicasio","Niceville","Nicholasville","Nicholls","Nichols","Nicholson","Nicholville","Nickelsville","Nickerson","Nicktown","Nicollet","Nicoma Park","Nielsville","Nikiski","Niland","Niles","Nilwood","Nine Mile Falls","Ninety Six","Nineveh","Ninilchik","Ninnekah","Ninole","Niobe","Niobrara","Niota","Nipomo","Nisswa","Nitro","Niwot","Nixa","Nixon","Noatak","Noble","Nobleboro","Noblesville","Nocona","Noel","Nogal","Nogales","Nokesville","Nokomis","Nolanville","Nolensville","Nome","Nondalton","Nooksack","Noonan","Noorvik","Nora Springs","Norborne","Norco","Norcross","Nordland","Norfolk","Norlina","Norma","Normal","Normalville","Norman","Norman Park","Normandy","Normandy Beach","Normangee","Normantown","Norridgewock","Norris","Norris City","Norristown","North","North Adams","North Amherst","North Andover","North Anson","North Apollo","North Arlington","North Attleboro","North Augusta","North Aurora","North Babylon","North Baltimore","North Bangor","North Beach","North Bend","North Bennington","North Bergen","North Berwick","North Billerica","North Bloomfield","North Bonneville","North Branch","North Branford","North Bridgton","North Brookfield","North Brunswick","North Carrollton","North Carver","North Charleston","North Chatham","North Chelmsford","North Chicago","North Chili","North Clarendon","North Collins","North Conway","North Creek","North Dartmouth","North Dighton","North East","North Eastham","North Easton","North English","North Fairfield","North Falmouth","North Fork","North Fort Myers","North Franklin","North Freedom","North Garden","North Grafton","North Granby","North Greece","North Grosvenor Dale","North Hampton","North Hatfield","North Haven","North Haverhill","North Henderson","North Hero","North Highlands","North Hills","North Hollywood","North Jackson","North Judson","North Kingstown","North Kingsville","North Las Vegas","North Lemmon","North Lewisburg","North Liberty","North Lima","North Little Rock","North Loup","North Manchester","North Matewan","North Miami Beach","North Monmouth","North Myrtle Beach","North Newton","North Olmsted","North Oxford","North Palm Beach","North Pembroke","North Plains","North Platte","North Point","North Pole","North Pomfret","North Port","North Powder","North Prairie","North Providence","North Reading","North Richland Hills","North Ridgeville","North Rose","North Royalton","North Salem","North Salt Lake","North San Juan","North Sandwich","North Scituate","North Sioux City","North Smithfield","North Springfield","North Stonington","North Sutton","North Tazewell","North Tonawanda","North Troy","North Truro","North Vernon","North Versailles","North Wales","North Walpole","North Waterboro","North Webster","North Weymouth","North Wilkesboro","North Windham","North Woodstock","North Zulch","Northampton","Northboro","Northborough","Northbridge","Northbrook","Northeast Harbor","Northern Cambria","Northfield","Northfield Falls","Northford","Northfork","Northome","Northport","Northridge","Northumberland","Northvale","Northville","Northway","Northwood","Norton","Nortonville","Norwalk","Norway","Norwell","Norwich","Norwood","Norwood Young America","Notasulga","Notre Dame","Nottingham","Nova","Novato","Novelty","Novi","Novinger","Nowata","Noxapater","Noxen","Noxon","Nucla","Nuevo","NuMine","Nunda","Nunica","Nunn","Nunnelly","Nuremberg","Nutley","Nutrioso","Nyack","Nye","Nyssa","Oacoma","Oak Bluffs","Oak Brook","Oak City","Oak Creek","Oak Forest","Oak Grove","Oak Harbor","Oak Hill","Oak Island","Oak Lawn","Oak Park","Oak Ridge","Oak Run","Oak View","Oakboro","Oakdale","Oakes","Oakesdale","Oakfield","Oakham","Oakhurst","Oakland","Oakland City","Oakland Estates Mobile Home Park","Oakland Gardens","Oakley","Oaklyn","Oakman","Oakmont","Oaks","Oakton","Oakvale","Oakville","Oakwood","Oberlin","Obion","Oblong","Ocala","Ocate","Occidental","Occoquan","Ocean City","Ocean Gate","Ocean Grove","Ocean Isle Beach","Ocean Park","Ocean Shores","Ocean Springs","Ocean View","Oceana","Oceano","Oceanport","Oceanside","Oceanville","Ochelata","Ocheyedan","Ochlocknee","Ocilla","Ocklawaha","Ocoee","Oconomowoc","Oconto","Oconto Falls","Ocotillo","Odanah","Odebolt","Odell","Odem","Oden","Odenton","Odenville","Odessa","Odin","Odon","Odum","Oelrichs","Oelwein","Ogallah","Ogallala","Ogden","Ogdensburg","Ogema","Ogilvie","Oglesby","Oglethorpe","Ogunquit","Ohatchee","Ohio","Ohio City","Ohiopyle","Oil City","Oil Springs","Oilton","Ojai","Ojo Caliente","Okahumpka","Okanogan","Okarche","Okatie","Okay","Okeana","Okeechobee","Okeene","Okemah","Okemos","Oketo","Oklahoma City","Oklaunion","Oklee","Okmulgee","Okoboji","Okolona","Oktaha","Ola","Olalla","Olancha","Olanta","Olathe","Olaton","Old Bethpage","Old Bridge","Old Chatham","Old Fields","Old Forge","Old Fort","Old Greenwich","Old Hickory","Old Kotzebue","Old Lyme","Old Ocean","Old Orchard Beach","Old Pekin","Old Saybrook","Old Town","Old Westbury","Oldfort","Oldsmar","Oldtown","Oldwick","Olean","Oley","Olin","Olive Branch","Olive Hill","Olivebridge","Oliveburg","Olivehurst","Oliver Springs","Olivet","Olivette","Olivia","Olla","Ollie","Olmito","Olmsted","Olmsted Falls","Olmstedville","Olney","Olney Springs","Olpe","Olsburg","Olton","Olympia","Olympia Fields","Olyphant","Omaha","Omak","Omega","Omena","Omro","Ona","Onaga","Onalaska","Onamia","Onancock","Onarga","Onawa","Onaway","Oneco","Oneida","Onekama","Oneonta","Onia","Onley","Onondaga","Onset","Onslow","Onsted","Ontario","Ontonagon","Onyx","Oologah","Ooltewah","Oostburg","Opa-locka","Opdyke","Opelika","Opelousas","Opheim","Ophiem","Opolis","Opp","Oquawka","Oracle","Oradell","Oran","Orange","Orange Beach","Orange City","Orange Cove","Orange Grove","Orange Park","Orange Springs","Orangeburg","Orangevale","Orangeville","Orchard","Orchard Hill","Orchard Park","Ord","Orderville","Ordway","Ore City","Oreana","Orefield","Oregon","Oregon City","Oregon House","Oregonia","Oreland","Orem","Orford","Orfordville","Orient","Oriental","Orinda","Orion","Oriska","Oriskany","Oriskany Falls","Orland","Orland Park","Orlando","Orleans","Orlinda","Orma","Ormond Beach","Orofino","Orondo","Orono","Oronoco","Oronogo","Orosi","Oroville","Orrington","Orrs Island","Orrstown","Orrtanna","Orrville","Orting","Ortonville","Orwell","Orwigsburg","Osage","Osage Beach","Osage City","Osakis","Osawatomie","Osborn","Osborne","Osburn","Osceola","Osceola Mills","Osco","Oscoda","Osgood","Oshkosh","Oshtemo","Oskaloosa","Oslo","Osmond","Osprey","Osseo","Ossian","Ossineke","Ossining","Ossipee","Osteen","Osterville","Ostrander","Oswego","Osyka","Otego","Othello","Otho","Otis","Otis Orchards","Otisco","Otisville","Otoe","Otsego","Ottawa","Otter","Otter Lake","Otterbein","Ottertail","Otto","Ottosen","Ottoville","Ottsville","Ottumwa","Otway","Ouray","Outing","Outlook","Overbrook","Overgaard","Overland Park","Overpeck","Overton","Ovid","Oviedo","Owaneco","Owasso","Owatonna","Owego","Owen","Owens Cross Roads","Owensboro","Owensburg","Owensville","Owenton","Owings","Owings Mills","Owingsville","Owosso","Oxford","Oxford Junction","Oxnard","Oxon Hill","Oyster Bay","Ozan","Ozark","Ozawkie","Ozona","Ozone","Ozone Park","Pablo","Pacific","Pacific City","Pacific Grove","Pacific Junction","Pacific Palisades","Pacifica","Packwood","Pacoima","Pacolet","Paden","Paden City","Paducah","Paeonian Springs","Page","Pageland","Pageton","Pagosa Springs","Pahala","Pahoa","Pahokee","Pahrump","Paia","Paige","Painesdale","Painesville","Paint Lick","Paint Rock","Painted Post","Painter","Paintsville","Pala","Palacios","Palatine","Palatka","Palermo","Palestine","Palisade","Palisades","Palisades Park","Pall Mall","Palm","Palm Bay","Palm Beach","Palm Beach Gardens","Palm City","Palm Coast","Palm Desert","Palm Harbor","Palm Springs","Palmdale","Palmer","Palmer Lake","Palmerdale","Palmersville","Palmerton","Palmetto","Palmyra","Palo","Palo Alto","Palo Cedro","Palo Verde","Paloma","Palos Heights","Palos Hills","Palos Park","Palos Verdes Peninsula","Palouse","Pampa","Pamplico","Pamplin","Pana","Panaca","Panacea","Panama","Panama City","Panama City Beach","Pandora","Pangburn","Panguitch","Panhandle","Panola","Panora","Panorama City","Pansey","Pantego","Paola","Paoli","Paonia","Papillion","Parachute","Paradis","Paradise","Paradise Valley","Paradox","Paragon","Paragould","Paramount","Paramus","Pardeeville","Paris","Parish","Park","Park City","Park Falls","Park Forest","Park Hill","Park Hills","Park Rapids","Park Ridge","Park River","Parker","Parker City","Parker Ford","Parkers Lake","Parkers Prairie","Parkersburg","Parkesburg","Parkman","Parksley","Parkston","Parkton","Parkville","Parlier","Parlin","Parma","Parnell","Parowan","Parrish","Parrottsville","Parshall","Parsippany","Parsons","Parsonsburg","Parsonsfield","Partlow","Partridge","Pasadena","Pascagoula","Pasco","Pascoag","Paso Robles","Pass Christian","Passaic","Passumpsic","Pataskala","Patchogue","Paterson","Patoka","Paton","Patrick","Patrick Springs","Patriot","Patten","Patterson","Pattersonville","Pattison","Patton","Pattonsburg","Pattonville","Paul","Paul Smiths","Paulden","Paulding","Paulina","Pauline","Paullina","Pauls Valley","Paulsboro","Pauma Valley","Pavilion","Pavillion","Pavo","Paw Paw","Pawcatuck","Pawhuska","Pawlet","Pawleys Island","Pawling","Pawnee","Pawnee City","Pawtucket","Paxico","Paxinos","Paxton","Payette","Payne","Paynesville","Payneville","Payson","Pea Ridge","Peabody","Peace Dale","Peach Bottom","Peach Creek","Peach Orchard","Peach Springs","Peachland","Peachtree City","Peak","Peaks Island","Peapack","Pearblossom","Pearce","Pearcy","Pearisburg","Pearl","Pearl City","Pearl City, Manana","Pearl River","Pearland","Pearlington","Pearsall","Pearson","Pease","Pebble Beach","Pecatonica","Peck","Pecks Mill","Peckville","Peconic","Pecos","Peculiar","Pedricktown","Pedro Bay","Peebles","Peekskill","Peel","Peetz","Peever","Peggs","Pegram","Pekin","Pelahatchie","Pelham","Pelican","Pelican Lake","Pelican Rapids","Pelion","Pelkie","Pell City","Pella","Pellston","Pelzer","Pemberton","Pemberville","Pembina","Pembine","Pembroke","Pembroke Pines","Pen Argyl","Penasco","Pender","Pendergrass","Pendleton","Penelope","Penfield","Pengilly","Penhook","Peninsula","Penitas","Penn","Penn Laird","Penn Run","Penn Valley","Penn Yan","Pennellville","Penney Farms","Penngrove","Pennington","Pennington Gap","Pennock","Penns Grove","Penns Park","Pennsauken Township","Pennsboro","Pennsburg","Pennsville Township","Pennsylvania Furnace","Pennville","Penokee","Penrose","Penryn","Pensacola","Pentress","Pentwater","Peoria","Peoria Heights","Peosta","Peotone","Pepperell","Pequannock","Pequea","Pequot Lakes","Peralta","Percy","Perdido","Perham","Peridot","Perkasie","Perkins","Perkinston","Perkinsville","Perkiomenville","Perley","Perrineville","Perrinton","Perris","Perronville","Perry","Perry Hall","Perry Point","Perryman","Perryopolis","Perrysburg","Perryton","Perryville","Pershing","Persia","Perth Amboy","Peru","Pescadero","Peshastin","Peshtigo","Pesotum","Petal","Petaluma","Peterborough","Peterman","Petersburg","Petersham","Peterson","Peterstown","Petoskey","Petroleum","Petrolia","Petros","Pettigrew","Pevely","Pewamo","Pewaukee","Pewee Valley","Peyton","Pfafftown","Pflugerville","Pharr","Phelan","Phelps","Phenix","Phenix City","Phil Campbell","Philadelphia","Philip","Philipp","Philippi","Philipsburg","Phillips","Phillipsburg","Philo","Philomath","Philpot","Phippsburg","Phoenicia","Phoenix","Phoenixville","Piasa","Picabo","Picayune","Pickens","Pickerington","Pickett","Pickstown","Pickton","Pico Rivera","Picture Rocks","Piedmont","Pierce","Pierce City","Pierceton","Piercy","Piermont","Pierpont","Pierre","Pierre Part","Pierron","Pierson","Pierz","Piffard","Pigeon","Pigeon Forge","Piggott","Pike Road","Pikesville","Piketon","Pikeville","Pillager","Pilot","Pilot Grove","Pilot Hill","Pilot Knob","Pilot Mound","Pilot Mountain","Pilot Point","Pilot Rock","Pilot Station","Pima","Pima County","Pimento","Pinckney","Pinckneyville","Pinconning","Pine","Pine Beach","Pine Bluff","Pine Bluffs","Pine Brook","Pine Bush","Pine City","Pine Forge","Pine Grove","Pine Grove Mills","Pine Hill","Pine Island","Pine Knot","Pine Lake","Pine Mountain","Pine Mountain Club","Pine Plains","Pine Ridge","Pine River","Pine Top","Pine Valley","Pinebluff","Pinecrest","Pinedale","Pinehill","Pinehurst","Pinellas Park","Pineola","Pinesdale","Pinetop-Lakeside","Pinetops","Pinetown","Pineville","Pinewood","Piney Creek","Piney Flats","Piney View","Piney Woods","Pingree","Pink Hill","Pinnacle","Pinola","Pinole","Pinon","Pinon Hills","Pinson","Pioche","Pioneer","Pioneertown","Pipe Creek","Piper City","Pipersville","Pipestone","Piqua","Pirtleville","Piscataway","Piseco","Pisgah","Pisgah Forest","Pismo Beach","Pitcairn","Pitcher","Pitkin","Pitman","Pittsboro","Pittsburg","Pittsburgh","Pittsfield","Pittsford","Pittston","Pittstown","Pittsview","Pittsville","Pixley","Placedo","Placentia","Placerville","Placida","Placitas","Plain","Plain City","Plain Dealing","Plainfield","Plains","Plainsboro","Plainview","Plainville","Plainwell","Plaistow","Planada","Plankinton","Plano","Plant City","Plantation","Plantersville","Plantsville","Plaquemine","Plato","Platte","Platte City","Plattekill","Plattenville","Platteville","Plattsburg","Plattsburgh","Plattsmouth","Playa del Rey","Plaza","Pleasant City","Pleasant Dale","Pleasant Garden","Pleasant Grove","Pleasant Hill","Pleasant Hope","Pleasant Lake","Pleasant Mount","Pleasant Plain","Pleasant Plains","Pleasant Prairie","Pleasant Ridge","Pleasant Shade","Pleasant Unity","Pleasant Valley","Pleasant View","Pleasanton","Pleasantville","Pleasureville","Plentywood","Plover","Plum Branch","Plum City","Plumerville","Plummer","Plummers Landing","Plumsteadville","Plumville","Plymouth","Plymouth Meeting","Plympton","Poca","Pocahontas","Pocasset","Pocatello","Pocola","Pocomoke City","Pocono Pines","Pocono Summit","Poestenkill","Point","Point Arena","Point Comfort","Point Harbor","Point Hope","Point Lay","Point Lookout","Point of Rocks","Point Pleasant","Point Pleasant Beach","Point Reyes Station","Point Roberts","Pointblank","Polacca","Poland","Polk","Polk City","Polkton","Polkville","Pollard","Pollock","Pollock Pines","Pollocksville","Pollok","Polo","Polson","Pomaria","Pomerene","Pomeroy","Pomfret","Pomfret Center","Pomona","Pomona Park","Pompano Beach","Pompey","Pompton Lakes","Pompton Plains","Ponca","Ponca City","Ponce de Leon","Ponchatoula","Pond Creek","Ponder","Ponderay","Ponemah","Poneto","Ponsford","Ponte Vedra","Ponte Vedra Beach","Pontiac","Pontotoc","Pooler","Poolesville","Poolville","Pope","Pope Valley","Poplar","Poplar Bluff","Poplar Branch","Poplar Grove","Poplarville","Poquoson","Porcupine","Port Allegany","Port Allen","Port Angeles","Port Aransas","Port Arthur","Port Austin","Port Barre","Port Bolivar","Port Byron","Port Carbon","Port Charlotte","Port Chester","Port Clinton","Port Crane","Port Deposit","Port Edwards","Port Elizabeth","Port Gibson","Port Hadlock","Port Henry","Port Hope","Port Hueneme","Port Huron","Port Isabel","Port Jefferson","Port Jefferson Station","Port Jervis","Port Lavaca","Port Leyden","Port Ludlow","Port Mansfield","Port Matilda","Port Monmouth","Port Murray","Port Neches","Port Norris","Port Orange","Port Orchard","Port Orford","Port Penn","Port Reading","Port Republic","Port Richey","Port Royal","Port Saint Joe","Port Saint Lucie","Port Salerno","Port Sanilac","Port Tobacco","Port Townsend","Port Trevorton","Port Washington","Portage","Portageville","Portal","Portales","Porter","Porter Corners","Portersville","Porterville","Portland","Portola","Portola Valley","Portsmouth","Portville","Porum","Posen","Poseyville","Post","Post Falls","Post Mills","Poston","Postville","Poteau","Poteet","Poth","Potlatch","Potomac","Potosi","Potsdam","Potter","Potter Valley","Pottersville","Potterville","Potts Camp","Pottsboro","Pottstown","Pottsville","Potwin","Poughkeepsie","Poughquag","Poulan","Poulsbo","Poultney","Pound","Pound Ridge","Pounding Mill","Poway","Powder Springs","Powderly","Powell","Powell Butte","Powellsville","Powellton","Powers","Powers Lake","Powhatan","Powhatan Point","Pownal","Poyen","Poynette","Poynor","Poyntelle","Prague","Prairie","Prairie City","Prairie du Chien","Prairie du Rocher","Prairie du Sac","Prairie Farm","Prairie Grove","Prairie View","Prairie Village","Prairieton","Prairieville","Prather","Pratt","Pratts","Prattsburgh","Prattsville","Prattville","Preble","Preemption","Premier","Prentiss","Prescott","Prescott Valley","Presho","Presidio","Presque Isle","Presto","Preston","Preston City","Preston Hollow","Prestonsburg","Prewitt","Price","Prichard","Pride","Priest River","Primghar","Primm Springs","Primus","Prince Frederick","Prince George","Princess Anne","Princeton","Princeton Junction","Princeville","Princewick","Prineville","Prinsburg","Printer","Prior Lake","Pritchett","Procious","Proctor","Proctorville","Progreso","Prompton","Prophetstown","Prospect","Prospect Harbor","Prospect Heights","Prospect Park","Prosper","Prosperity","Prosser","Protection","Protivin","Providence","Providence Forge","Provincetown","Provo","Prudenville","Prudhoe Bay","Pryor","Pueblo","Puerto Rico","Pukalani","Pukwana","Pulaski","Pullman","Pungoteague","Punta Gorda","Punxsutawney","Purcell","Purcellville","Purchase","Purdin","Purdon","Purdy","Purdys","Purgitsville","Purlear","Purling","Purvis","Puryear","Put-in-Bay","Putnam","Putnam Station","Putnam Valley","Putney","Puyallup","Pylesville","Quail","Quakake","Quaker City","Quaker Hill","Quakertown","Quality","Quanah","Quantico","Quapaw","Quarryville","Quartzsite","Quasqueton","Quebeck","Quechee","Queen Anne","Queen City","Queen Creek","Queens Village","Queensbury","Queenstown","Quemado","Questa","Quilcene","Quimby","Quincy","Quinebaug","Quinlan","Quinnesec","Quinter","Quinton","Quinwood","Quitman","Qulin","Quogue","Raccoon","Raceland","Racine","Radcliff","Radcliffe","Radford","Radisson","Radnor","Raeford","Ragland","Rahway","Rainbow","Rainbow City","Rainelle","Rainier","Rainsville","Raleigh","Ralls","Ralph","Ralston","Ramah","Ramer","Ramey","Ramona","Ramseur","Ramsey","Ranburne","Ranchita","Rancho Cordova","Rancho Cucamonga","Rancho Mirage","Rancho Palos Verdes","Rancho Santa Fe","Rancho Santa Margarita","Ranchos de Taos","Rancocas","Randall","Randallstown","Randle","Randleman","Randlett","Randolph","Randolph Center","Randolph Township","Random Lake","Rangely","Ranger","Rankin","Ransom","Ransom Canyon","Ransomville","Ranson","Rantoul","Raphine","Rapid City","Rapid River","Rapidan","Raquette Lake","Raritan","Rathdrum","Ratliff City","Raton","Rattan","Ravalli","Raven","Ravena","Ravencliff","Ravenden","Ravenel","Ravenna","Ravensdale","Ravenswood","Ravenwood","Ravia","Rawlings","Rawlins","Rawson","Ray","Ray Center","Ray City","Rayland","Raymond","Raymondville","Raymore","Rayne","Raynham","Rayville","Raywick","Readfield","Reading","Readlyn","Readsboro","Readyville","Reamstown","Reardan","Rebecca","Rebersburg","Rector","Red Bank","Red Banks","Red Bay","Red Bluff","Red Boiling Springs","Red Bud","Red Cloud","Red Creek","Red Hill","Red Hook","Red House","Red Jacket","Red Lake Falls","Red Level","Red Lion","Red Lodge","Red Oak","Red River","Red Rock","Red Springs","Red Wing","Redan","Redby","Reddick","Redding","Redding Ridge","Redfield","Redford","Redfox","Redkey","Redlands","Redmon","Redmond","Redondo Beach","Redwater","Redway","Redwood","Redwood City","Redwood Estates","Redwood Falls","Redwood Valley","Reed City","Reed Point","Reedley","Reeds","Reeds Spring","Reedsburg","Reedsport","Reedsville","Reedville","Reedy","Reelsville","Reese","Reeseville","Reevesville","Reform","Refugio","Regent","Register","Rego Park","Rehoboth","Rehoboth Beach","Reidsville","Reidville","Reinbeck","Reinholds","Reisterstown","Reklaw","Reliance","Rembert","Rembrandt","Remer","Remington","Remlap","Remote","Remsen","Remsenburg","Remus","Renfrew","Renner","Reno","Renovo","Rensselaer","Rensselaer Falls","Renton","Rentz","Renville","Renwick","Repton","Republic","Resaca","Reseda","Reserve","Reston","Revere","Revillo","Rex","Rexburg","Rexford","Rexmont","Rexville","Reydell","Reydon","Reynolds","Reynoldsburg","Reynoldsville","Rhame","Rheems","Rhine","Rhinebeck","Rhineland","Rhinelander","Rhoadesville","Rhodelia","Rhodell","Rhodes","Rhodesdale","Rhodhiss","Rhome","Rialto","Rib Lake","Ribera","Rice","Rice Lake","Rices Landing","Riceville","Rich Creek","Rich Hill","Rich Square","Richards","Richardson","Richardton","Richboro","Richburg","Richeyville","Richfield","Richfield Springs","Richford","Richgrove","Richland","Richland Center","Richlands","Richlandtown","Richmond","Richmond Hill","Richton","Richton Park","Richvale","Richview","Richwood","Rickman","Rickreall","Riddle","Riddleton","Riderwood","Ridge","Ridge Farm","Ridge Spring","Ridgecrest","Ridgedale","Ridgefield","Ridgefield Park","Ridgeland","Ridgeley","Ridgely","Ridgeview","Ridgeville","Ridgeway","Ridgewood","Ridgway","Ridley Park","Ridott","Riegelsville","Riegelwood","Rienzi","Riesel","Rifle","Riga","Rigby","Riggins","Riley","Rillton","Rimersburg","Rimforest","Rimrock","Rinard","Rincon","Rindge","Riner","Rineyville","Ringgold","Ringle","Ringling","Ringoes","Ringsted","Ringtown","Ringwood","Rio","Rio Dell","Rio Grande","Rio Grande City","Rio Hondo","Rio Linda","Rio Nido","Rio Rancho","Rio Rico","Rio Verde","Rio Vista","Ripley","Ripon","Rippey","Ripplemead","Ripton","Rising City","Rising Fawn","Rising Star","Rising Sun","Risingsun","Rison","Rittman","Ritzville","Riva","River Edge","River Falls","River Forest","River Grove","River Pines","River Rouge","Riverbank","Riverdale","Riverdale Hills","Riverhead","Riverside","Riverside County","Riverton","Riverview","Rives","Rives Junction","Rivesville","Riviera","Rixeyville","Roach","Roachdale","Roan Mountain","Roann","Roanoke","Roanoke Rapids","Roaring Branch","Roaring River","Roaring Spring","Robards","Robbins","Robbinsville","Robersonville","Robert","Robert Lee","Roberta","Roberts","Robertsdale","Robertson","Robertsville","Robesonia","Robins","Robinson","Robinson Creek","Robinsonville","Robstown","Roby","Roca","Rochdale","Rochelle","Rochelle Park","Rochester","Rociada","Rock","Rock Creek","Rock Falls","Rock Hall","Rock Hill","Rock Island","Rock Port","Rock Rapids","Rock River","Rock Spring","Rock Springs","Rock Tavern","Rock Valley","Rock View","Rockaway","Rockaway Beach","Rockaway Park","Rockbridge","Rockdale","Rockfield","Rockford","Rockholds","Rockhouse","Rockingham","Rockland","Rockledge","Rocklin","Rockmart","Rockport","Rocksprings","Rockton","Rockvale","Rockville","Rockville Centre","Rockwall","Rockwell","Rockwell City","Rockwood","Rocky","Rocky Face","Rocky Ford","Rocky Gap","Rocky Hill","Rocky Mount","Rocky Point","Rocky River","Rodanthe","Rodeo","Roderfield","Rodman","Rodney","Roebling","Roebuck","Rogers","Rogers City","Rogersville","Roggen","Rogue River","Rohnert Park","Rohrersville","Roland","Rolesville","Rolfe","Roll","Rolla","Rolling Fork","Rolling Meadows","Rolling Prairie","Rollingbay","Rollingstone","Rollinsford","Roma","Rome","Rome City","Romeo","Romeoville","Romney","Romulus","Ronald","Ronan","Ronceverte","Ronda","Ronkonkoma","Ronks","Roodhouse","Roosevelt","Rootstown","Roper","Ropesville","Rosalia","Rosamond","Rosburg","Roscoe","Roscommon","Rose Bud","Rose City","Rose Creek","Rose Hill","Roseau","Roseboro","Rosebud","Roseburg","Rosebush","Rosedale","Roseland","Roselle","Roselle Park","Rosemary Beach","Rosemead","Rosemont","Rosemount","Rosenberg","Rosendale","Rosenhayn","Rosepine","Roseville","Rosewood","Rosharon","Rosholt","Rosiclare","Rosine","Roslindale","Roslyn","Roslyn Heights","Rosman","Ross","Rosser","Rossford","Rossiter","Rossville","Roswell","Rotan","Rothbury","Rothsay","Rothschild","Rotonda","Rotterdam Junction","Rougemont","Rough and Ready","Roulette","Round Hill","Round Lake","Round Mountain","Round O","Round Rock","Round Top","Roundhill","Roundup","Rouses Point","Rousseau","Rowan","Rowe","Rowena","Rowesville","Rowland","Rowland Heights","Rowlesburg","Rowlett","Rowley","Roxana","Roxboro","Roxbury","Roxie","Roy","Roy-Winifred Junction","Royal","Royal Center","Royal City","Royal Oak","Royal Palm Beach","Royalton","Royersford","Royse City","Royston","Rozet","Rubicon","Ruby","Ruckersville","Rudd","Rudolph","Rudyard","Ruffin","Ruffs Dale","Rugby","Ruidoso","Ruidoso Downs","Rule","Ruleville","Rulo","Rumford","Rumney","Rumsey","Rumson","Runge","Runnells","Runnemede","Running Springs","Rupert","Rural Hall","Rural Retreat","Rural Ridge","Rural Valley","Rush","Rush Center","Rush City","Rush Hill","Rush Valley","Rushford","Rushmore","Rushville","Rusk","Ruskin","Russell","Russell Springs","Russells Point","Russellton","Russellville","Russia","Russian Mission","Russiaville","Rustburg","Ruston","Ruth","Ruther Glen","Rutherford","Rutherfordton","Ruthton","Ruthven","Rutland","Rutledge","Ryan","Rydal","Ryde","Rye","Sabattus","Sabetha","Sabillasville","Sabin","Sabina","Sabinal","Sabot","Sabula","Sac City","Sacaton","Sachse","Sackets Harbor","Saco","Sacramento","Sacred Heart","Saddle Brook","Saddle River","Sadieville","Sadler","Saegertown","Safety Harbor","Safford","Sag Harbor","Sagamore","Sagamore Beach","Sagaponack","Saginaw","Sagle","Saguache","Sahuarita","Sailor Springs","Saint Agatha","Saint Albans","Saint Amant","Saint Ann","Saint Anne","Saint Ansgar","Saint Anthony","Saint Bonaventure","Saint Boniface","Saint Bonifacius","Saint Catharine","Saint Charles","Saint Clair","Saint Clair Shores","Saint Clairsville","Saint Cloud","Saint Croix Falls","Saint David","Saint Edward","Saint Elizabeth","Saint Elmo","Saint Francis","Saint Francisville","Saint Gabriel","Saint George","Saint Germain","Saint Hedwig","Saint Helen","Saint Helena","Saint Helens","Saint Henry","Saint Hilaire","Saint Ignace","Saint Ignatius","Saint Jacob","Saint James","Saint James City","Saint Joe","Saint John","Saint Johns","Saint Johnsbury","Saint Johnsville","Saint Joseph","Saint Leo","Saint Leonard","Saint Libory","Saint Louis","Saint Louis Park","Saint Louisville","Saint Marie","Saint Maries","Saint Marks","Saint Martin","Saint Martinville","Saint Mary","Saint Marys","Saint Matthews","Saint Meinrad","Saint Michael","Saint Michaels","Saint Nazianz","Saint Onge","Saint Paris","Saint Paul","Saint Paul Park","Saint Pauls","Saint Peter","Saint Peters","Saint Petersburg","Saint Regis","Saint Regis Falls","Saint Robert","Saint Simons Island","Saint Stephen","Saint Stephens","Saint Thomas","Sainte Marie","Salado","Salamanca","Sale City","Sale Creek","Salem","Salemburg","Salesville","Salida","Salina","Salinas","Saline","Salineville","Salisbury","Salisbury Mills","Salix","Salkum","Sallis","Sallisaw","Salmon","Salome","Salt Lake City","Salt Lick","Salt Point","Salt Rock","Salters","Saltillo","Salton City","Saltsburg","Saltville","Saluda","Salvisa","Salyer","Salyersville","Sammamish","Samoa","Samson","San Andreas","San Angelo","San Anselmo","San Antonio","San Augustine","San Benito","San Bernardino","San Bernardino County","San Bruno","San Carlos","San Clemente","San Cristobal","San Diego","San Dimas","San Elizario","San Felipe","San Fernando","San Fidel","San Francisco","San Gabriel","San Geronimo","San Gregorio","San Jacinto","San Joaquin","San Jon","San Jose","San Juan","San Juan Bautista","San Juan Capistrano","San Leandro","San Lorenzo","San Luis","San Luis Obispo","San Luis Rey Heights","San Manuel","San Marcos","San Marino","San Martin","San Mateo","San Miguel","San Pablo","San Pedro","San Pierre","San Rafael","San Ramon","San Saba","San Simeon","San Simon","San Ysidro","Sanborn","Sanbornton","Sanbornville","Sand Coulee","Sand Creek","Sand Fork","Sand Lake","Sand Point","Sand Springs","Sandborn","Sanders","Sanderson","Sandersville","Sandia","Sandia Park","Sandoval","Sandoval County","Sandown","Sandpoint","Sandston","Sandstone","Sandusky","Sandwich","Sandy","Sandy City","Sandy Creek","Sandy Hook","Sandy Lake","Sandy Ridge","Sandy Spring","Sandyville","Sanford","Sanger","Sangerville","Sanibel","Santa Ana","Santa Ana Heights","Santa Anna","Santa Barbara","Santa Clara","Santa Clarita","Santa Claus","Santa Cruz","Santa Fe","Santa Fe Springs","Santa Margarita","Santa Maria","Santa Monica","Santa Paula","Santa Rosa","Santa Rosa Beach","Santa Teresa","Santa Ynez","Santa Ysabel","Santaquin","Santee","Santo","Sapphire","Sapulpa","Sarah","Sarah Ann","Sarahsville","Saraland","Saranac","Saranac Lake","Sarasota","Saratoga","Saratoga Springs","Sarcoxie","Sardinia","Sardis","Sarepta","Sargent","Sarita","Sarona","Saronville","Sartell","Sarver","Sasakwa","Satanta","Satartia","Satellite Beach","Satsop","Satsuma","Saucier","Saugatuck","Saugerties","Saugus","Sauk Centre","Sauk City","Sauk Rapids","Saukville","Saulsbury","Saulsville","Sault Ste. Marie","Saunderstown","Saunemin","Sauquoit","Sausalito","Savage","Savanna","Savannah","Savonburg","Savoy","Sawyer","Saxon","Saxonburg","Saxton","Saxtons River","Saybrook","Saylorsburg","Sayre","Sayreville","Sayville","Scales Mound","Scammon Bay","Scandia","Scandinavia","Scappoose","Scarborough","Scarbro","Scarsdale","Scarville","Scenery Hill","Schaefferstown","Schaghticoke","Schaller","Schaumburg","Schellsburg","Schenectady","Schenevus","Schenley","Schererville","Schertz","Schiller Park","Schlater","Schleswig","Schnecksville","Schneider","Schodack Landing","Schoenchen","Schofield","Schoharie","Schoolcraft","Schroon Lake","Schulenburg","Schulter","Schurz","Schuyler","Schuylerville","Schuylkill Haven","Schwenksville","Science Hill","Scio","Sciota","Scipio","Scipio Center","Scituate","Scobey","Scotch Plains","Scotia","Scotland","Scotland Neck","Scotrun","Scott","Scott Air Force Base","Scott City","Scott Depot","Scottdale","Scottown","Scotts","Scotts Hill","Scotts Mills","Scotts Valley","Scottsbluff","Scottsboro","Scottsburg","Scottsdale","Scottsville","Scottville","Scranton","Scribner","Scroggins","Scurry","Sea Cliff","Sea Girt","Sea Island","Sea Isle City","Sea Ranch","Seabeck","Seabrook","Seadrift","Seaford","Seagoville","Seagraves","Seagrove","Seahurst","Seal","Seal Beach","Seal Cove","Seal Rock","Seale","Sealevel","Sealy","Seaman","Searcy","Searsboro","Searsmont","Seaside","Seaside Heights","Seaside Park","Seaton","Seatonville","Seattle","Sebastian","Sebastopol","Sebec","Sebeka","Sebewaing","Sebree","Sebring","Secaucus","Second Mesa","Secor","Section","Sedalia","Sedan","Sedgwick","Sedona","Sedro-Woolley","Seekonk","Seeley","Seeley Lake","Seffner","Seguin","Seiling","Selah","Selawik","Selby","Selbyville","Selden","Seligman","Selinsgrove","Selkirk","Sellersburg","Sellersville","Sells","Selma","Selmer","Seminary","Seminole","Semmes","Senath","Senatobia","Seneca","Seneca Falls","Senecaville","Senoia","Sentinel Butte","Sequim","Sequoia","Serafina","Serena","Sergeant Bluff","Sergeantsville","Sesser","Seth","Seven Mile","Seven Springs","Seven Valleys","Severance","Severn","Severna Park","Severy","Sevierville","Seville","Sewanee","Seward","Sewaren","Sewell","Sewickley","Seymour","Shabbona","Shacklefords","Shade Gap","Shady Cove","Shady Dale","Shady Point","Shady Side","Shady Spring","Shady Valley","Shadyside","Shafer","Shafter","Shaftsbury","Shakopee","Shalimar","Shallotte","Shallowater","Shamokin","Shamokin Dam","Shamrock","Shandaken","Shandon","Shanks","Shanksville","Shannon","Shannon City","Shapleigh","Sharon","Sharon Center","Sharon Hill","Sharon Springs","Sharpsburg","Sharpsville","Sharptown","Shartlesville","Shasta","Shattuck","Shavertown","Shaw","Shaw Island","Shawano","Shawboro","Shawnee","Shawnee on Delaware","Shawneetown","Shawsville","Sheboygan","Sheboygan Falls","Shedd","Sheep Springs","Sheffield","Sheffield Lake","Shelbiana","Shelburn","Shelburne","Shelburne Falls","Shelby","Shelbyville","Sheldahl","Sheldon","Sheldon Springs","Shell","Shell Knob","Shell Lake","Shell Rock","Shelley","Shellman","Shellsburg","Shelly","Shelocta","Shelter Island","Shelter Island Heights","Shelton","Shenandoah","Shenandoah Junction","Shepherd","Shepherdstown","Shepherdsville","Sherborn","Sherburn","Sherburne","Sheridan","Sherman","Sherman Oaks","Shermans Dale","Sherrard","Sherrill","Sherrills Ford","Sherrodsville","Sherwood","Shevlin","Sheyenne","Shickley","Shickshinny","Shidler","Shiloh","Shiner","Shingle Springs","Shinglehouse","Shingleton","Shingletown","Shinnston","Shiocton","Shipman","Shippensburg","Shippenville","Shippingport","Shiprock","Shipshewana","Shirley","Shirley Mills","Shirleysburg","Shoals","Shobonier","Shoemakersville","Shohola","Shokan","Shongaloo","Shoreham","Shorewood","Short Hills","Shoshone","Shoshoni","Show Low","Shreve","Shreveport","Shrewsbury","Shrub Oak","Shubuta","Shumway","Shungnak","Shutesbury","Sibley","Sicily Island","Sicklerville","Side Lake","Sidell","Sidman","Sidney","Sidney Center","Sidon","Siemens","Sierra Madre","Sierra Vista","Signal Hill","Signal Mountain","Sigourney","Sikes","Sikeston","Silas","Siler City","Silex","Siloam","Siloam Springs","Silsbee","Silt","Silva","Silvana","Silver Bay","Silver City","Silver Creek","Silver Grove","Silver Lake","Silver Spring","Silver Springs","Silverado","Silverdale","Silverhill","Silverstreet","Silverthorne","Silverton","Silvis","Simi Valley","Simla","Simmesport","Simms","Simon","Simonton","Simpson","Simpsonville","Sims","Simsboro","Simsbury","Sinclair","Sinclairville","Sinks Grove","Sinton","Sioux Center","Sioux City","Sioux Falls","Sioux Rapids","Sipesville","Sipsey","Siren","Sisseton","Sister Bay","Sisters","Sistersville","Sitka","Six Lakes","Six Mile","Skaguay","Skamokawa","Skandia","Skaneateles","Skaneateles Falls","Skanee","Skellytown","Skiatook","Skidmore","Skillman","Skippack","Skokie","Skowhegan","Skyforest","Skykomish","Skyland","Slagle","Slanesville","Slate Hill","Slater","Slatersville","Slatington","Slaton","Slaty Fork","Slaughter","Slaughters","Slayton","Sleepy Eye","Slidell","Sligo","Slinger","Slingerlands","Slippery Rock","Sloan","Sloansville","Sloatsburg","Slocomb","Sloughhouse","Slovan","Smackover","Smarr","Smartt","Smethport","Smilax","Smiley","Smith Center","Smith River","Smithers","Smithfield","Smithland","Smiths","Smiths Creek","Smiths Grove","Smithsburg","Smithshire","Smithton","Smithtown","Smithville","Smithville Flats","Smoaks","Smock","Smoke Run","Smoketown","Smyer","Smyrna","Smyrna Mills","Sneads","Sneads Ferry","Sneedville","Snelling","Snellville","Snohomish","Snoqualmie","Snover","Snow Camp","Snow Hill","Snow Shoe","Snowflake","Snowmass","Snowmass Village","Snyder","Soap Lake","Sobieski","Social Circle","Society Hill","Socorro","Sod","Soda Springs","Soddy-Daisy","Sodus","Solana Beach","Soldier","Soldiers Grove","Soldotna","Solebury","Soledad","Solen","Solomons","Solon","Solon Springs","Solsberry","Solvang","Solway","Somerdale","Somers","Somers Point","Somerset","Somerset Center","Somersworth","Somerton","Somerville","Somis","Somonauk","Sonoita","Sonoma","Sonora","Sopchoppy","Soper","Soperton","Sophia","Soquel","Sorento","Sorrento","Soso","Soudan","Souderton","Soulsbyville","Sound Beach","Sour Lake","South Amboy","South Barre","South Bay","South Beach","South Beloit","South Bend","South Berwick","South Boardman","South Boston","South Bound Brook","South Bristol","South Burlington","South Cairo","South Canaan","South Casco","South Charleston","South China","South Dartmouth","South Deerfield","South Dennis","South Easton","South Egremont","South El Monte","South Elgin","South English","South Fallsburg","South Fork","South Freeport","South Fulton","South Gate","South Gibson","South Glastonbury","South Glens Falls","South Hackensack","South Hadley","South Hamilton","South Harwich","South Haven","South Hero","South Hill","South Holland","South Houston","South Hutchinson","South Jamesport","South Jordan","South Kent","South Lake Tahoe","South Lancaster","South Lebanon","South Londonderry","South Lyon","South Mills","South Milwaukee","South New Berlin","South Newfane","South Orange","South Otselic","South Ozone Park","South Padre Island","South Paris","South Park Township","South Pasadena","South Pekin","South Pittsburg","South Plainfield","South Plymouth","South Point","South Pomfret","South Portland","South Prairie","South Range","South River","South Rockwood","South Roxana","South Royalton","South Ryegate","South Saint Paul","South Salem","South Sanford","South Seaville","South Shore","South Sioux City","South Solon","South Sterling","South Strafford","South Tamworth","South Vienna","South Wales","South Wayne","South Webster","South Wellfleet","South West City","South Weymouth","South Whitley","South Williamson","South Willington","South Wilmington","South Windsor","South Woodstock","South Yarmouth","Southampton","Southaven","Southborough","Southbridge","Southbury","Southern Pines","Southfield","Southfields","Southgate","Southington","Southlake","Southmayd","Southold","Southport","Southside","Southview","Southwest Harbor","Southwick","Spain","Spalding","Spanaway","Spanish Fork","Spanish Fort","Spanishburg","Sparkill","Sparkman","Sparks","Sparland","Sparrow Bush","Sparrows Point","Sparta","Spartanburg","Spartansburg","Spavinaw","Spearfish","Spearman","Spearsville","Spearville","Speculator","Spencer","Spencerport","Spencertown","Spencerville","Sperry","Sperryville","Spiceland","Spicer","Spicewood","Spickard","Spindale","Spinnerstown","Spirit Lake","Spiro","Spivey","Splendora","Spofford","Spokane","Spooner","Spotswood","Spotsylvania","Spout Spring","Spraggs","Sprakers","Spreckels","Spring","Spring Arbor","Spring Branch","Spring Church","Spring City","Spring Creek","Spring Glen","Spring Green","Spring Grove","Spring Hill","Spring Hope","Spring House","Spring Lake","Spring Lake Park","Spring Mills","Spring Park","Spring Run","Spring Valley","Springboro","Springdale","Springer","Springerville","Springfield","Springfield Gardens","Springfield Township","Springhill","Springport","Springtown","Springvale","Springview","Springville","Springwater","Spruce","Spruce Pine","Spurlockville","Squaw Lake","Squaw Valley","Squires","St Louis","St. Augustine","St. Charles","St. Genevieve","St. Helena","St. Joseph","St. Rose","Staatsburg","Stacy","Stacyville","Stafford","Stafford Springs","Staffordsville","Stahlstown","Staley","Stamford","Stanardsville","Stanberry","Stanchfield","Standard","Standish","Stanfield","Stanford","Stanfordville","Stanhope","Stanley","Stanton","Stantonsburg","Stanville","Stanwood","Staples","Stapleton","Star","Star City","Star Lake","Star Prairie","Starbuck","Starford","Stark","Stark City","Starke","Starksboro","Starkville","Starkweather","Starr","Startex","State Center","State College","State Line","State Road","State University","Stateline","Staten Island","Statenville","Statesboro","Statesville","Statham","Staunton","Stayton","Steamboat Rock","Steamboat Springs","Steamburg","Stearns","Stebbins","Stedman","Steedman","Steele","Steele City","Steeleville","Steelville","Steen","Steens","Steep Falls","Steger","Steilacoom","Steinauer","Steinhatchee","Stella","Stem","Stephen","Stephens","Stephens City","Stephenson","Stephensport","Stephentown","Stephenville","Sterling","Sterling Forest","Sterling Heights","Sterlington","Sterrett","Stetson","Stetsonville","Steuben","Steubenville","Stevens","Stevens Point","Stevenson","Stevenson Ranch","Stevensville","Stevinson","Steward","Stewardson","Stewart","Stewartstown","Stewartsville","Stewartville","Stickney","Stigler","Stilesville","Still Pond","Stillman Valley","Stillmore","Stillwater","Stilwell","Stinesville","Stinnett","Stinson Beach","Stirling","Stites","Stittville","Stockbridge","Stockdale","Stockertown","Stockholm","Stockport","Stockton","Stockton Springs","Stoddard","Stokesdale","Stollings","Stone","Stone Creek","Stone Harbor","Stone Lake","Stone Mountain","Stone Park","Stone Ridge","Stoneboro","Stonefort","Stoneham","Stoneville","Stonewall","Stonington","Stony Brook","Stony Creek","Stony Point","Stonyford","Storden","Storm Lake","Stormville","Storrs","Story","Story City","Stotts City","Stoughton","Stout","Stoutland","Stover","Stow","Stowe","Stoystown","Strafford","Strasburg","Stratford","Stratham","Strathmore","Strattanville","Stratton","Straughn","Strawberry","Strawberry Plains","Strawberry Point","Strawn","Streamwood","Streator","Street","Streeter","Streetman","Streetsboro","Stringer","Stromsburg","Strong","Stronghurst","Strongstown","Strongsville","Stroud","Stroudsburg","Strum","Strunk","Struthers","Stryker","Stuart","Stuarts Draft","Studio City","Stump Creek","Sturbridge","Sturgeon","Sturgeon Bay","Sturgeon Lake","Sturgis","Sturtevant","Stuttgart","Stuyvesant","Suamico","Sublette","Sublimity","Succasunna","Suches","Sudan","Sudbury","Sudlersville","Suffern","Suffield","Suffolk","Sugar City","Sugar Grove","Sugar Hill","Sugar Land","Sugar Loaf","Sugar Run","Sugar Tree","Sugar Valley","Sugarcreek","Sugarloaf","Sugarloaf Township","Sugartown","Suisun","Suitland","Sula","Sulligent","Sullivan","Sully","Sulphur","Sulphur Bluff","Sulphur Springs","Sultan","Sumas","Sumerduck","Sumiton","Summer Shade","Summerdale","Summerfield","Summerhill","Summerland","Summerland Key","Summers","Summersville","Summerton","Summertown","Summerville","Summit","Summit Hill","Summit Lake","Summit Station","Summitville","Sumner","Sumrall","Sumter","Sun","Sun City","Sun City Center","Sun City West","Sun Prairie","Sun River","Sun Valley","Sunapee","Sunbright","Sunburg","Sunburst","Sunbury","Suncook","Sundance","Sunderland","Sundown","Sunflower","Sunland","Sunman","Sunnyside","Sunnyvale","Sunol","Sunray","Sunrise","Sunrise Beach","Sunset","Sunset Beach","Sunshine","Superior","Supply","Suquamish","Surgoinsville","Suring","Surprise","Surrency","Surry","Susanville","Susquehanna","Sussex","Sutersville","Sutherland","Sutherland Springs","Sutherlin","Sutter","Sutter Creek","Sutton","Suttons Bay","Suwanee","Suwannee","Swainsboro","Swaledale","Swampscott","Swan","Swannanoa","Swans Island","Swansboro","Swansea","Swanton","Swanville","Swanzey","Swarthmore","Swartswood","Swartz","Swartz Creek","Swayzee","Swedesboro","Sweeny","Sweet","Sweet Home","Sweet Springs","Sweet Valley","Sweet Water","Sweetser","Sweetwater","Swiftwater","Swink","Swisher","Swisshome","Switz City","Switzer","Swoope","Sybertsville","Sycamore","Sykeston","Sykesville","Sylacauga","Sylmar","Sylva","Sylvan Beach","Sylvan Grove","Sylvania","Sylvester","Symsonia","Syosset","Syracuse","Taberg","Tabernash","Table Grove","Tabor","Tabor City","Tacoma","Taft","Tafton","Taftville","Tahlequah","Tahoe City","Tahoe Valley","Tahoe Vista","Tahoka","Taholah","Tahoma","Tahuya","Takoma Park","Talala","Talbott","Talbotton","Talco","Talcott","Talent","Talihina","Talkeetna","Talking Rock","Tall Timbers","Talladega","Tallahassee","Tallapoosa","Tallassee","Tallmadge","Tallulah","Talmo","Talmoon","Taloga","Tama","Tamaqua","Tamassee","Tamms","Tampa","Tampico","Tamworth","Taneytown","Taneyville","Tangent","Tangerine","Tangier","Tangipahoa","Tanner","Tannersville","Taos","Taos Ski Valley","Tappahannock","Tappan","Tappen","Tar Heel","Tarawa Terrace I","Tarboro","Tarentum","Tariffville","Tarkio","Tarpon Springs","Tarrs","Tarrytown","Tarzana","Tasley","Tatamy","Tate","Tatum","Taunton","Tavares","Tavernier","Tawas City","Taylor","Taylor Springs","Taylors","Taylors Falls","Taylorsville","Taylorville","Tazewell","Tea","Teachey","Teague","Teaneck","Teasdale","Tebbetts","Tecumseh","Teec Nos Pos","Tehachapi","Tehama","Tekamah","Tekoa","Tekonsha","Telephone","Telford","Tell City","Teller","Tellico Plains","Telluride","Telogia","Temecula","Tempe","Temperance","Temple","Temple City","Temple Hills","Templeton","Ten Mile","Ten Sleep","Tenafly","Tenaha","Tenants Harbor","Tenino","Tennent","Tennessee","Tennessee Colony","Tennessee Ridge","Tennille","Tensed","Tenstrike","Terlingua","Terlton","Terra Alta","Terra Bella","Terrace Park","Terre Haute","Terre Hill","Terrebonne","Terrell","Terreton","Terril","Terry","Terryville","Tescott","Tesuque","Teterboro","Teton","Teton Village","Tetonia","Teutopolis","Tewksbury","Texarkana","Texas City","Texhoma","Texico","Texline","Thackerville","Thatcher","Thaxton","Thayer","Thayne","The Bronx","The Colony","The Dalles","The Plains","The Rock","The Villages","Thelma","Thendara","Theodore","Theresa","Thermal","Thermopolis","Thetford Center","Thibodaux","Thief River Falls","Thiells","Thiensville","Thomas","Thomasboro","Thomaston","Thomasville","Thompson","Thompson Falls","Thompsontown","Thompsonville","Thomson","Thonotosassa","Thoreau","Thorn Hill","Thornburg","Thorndale","Thorndike","Thorne Bay","Thornton","Thorntown","Thornville","Thornwood","Thorofare","Thorp","Thousand Oaks","Thousand Palms","Thrall","Three Bridges","Three Forks","Three Lakes","Three Mile Bay","Three Oaks","Three Rivers","Three Springs","Throckmorton","Thurmond","Thurmont","Thurston","Tiburon","Tickfaw","Ticonderoga","Tidioute","Tierra Amarilla","Tieton","Tiffin","Tifton","Tigard","Tiger","Tigerton","Tigerville","Tignall","Tijeras","Tilden","Tilghman","Tiline","Tillamook","Tillar","Tilleda","Tillson","Tilton","Tiltonsville","Timber Lake","Timberlake","Timberon","Timberville","Timbo","Timewell","Timmonsville","Timpson","Tingley","Tinley Park","Tioga","Tiona","Tionesta","Tipp City","Tipton","Tiptonville","Tire Hill","Tiro","Tishomingo","Tiskilwa","Titonka","Titus","Titusville","Tiverton","Tivoli","Toano","Tobaccoville","Tobyhanna","Toccoa","Toccoa Falls","Todd","Toddville","Tofte","Togiak","Toivola","Tok","Toksook Bay","Tolar","Toledo","Tolland","Tollesboro","Tolleson","Tollhouse","Tolna","Tolono","Toluca","Tom Bean","Tomah","Tomahawk","Tomball","Tombstone","Tomkins Cove","Tompkinsville","Toms Brook","Toms River","Tonasket","Tonawanda","Toney","Tonganoxie","Tonica","Tonkawa","Tonopah","Tontitown","Tonto Basin","Tony","Tooele","Toomsboro","Toomsuba","Toone","Topanga","Topeka","Topock","Toppenish","Topping","Topsfield","Topsham","Topton","Tornado","Tornillo","Toronto","Torrance","Torreon","Torrey","Torrington","Totowa","Totz","Tougaloo","Toughkenamon","Toulon","Toutle","Tovey","Towaco","Towanda","Tower","Tower City","Tower Hill","Town Creek","Town of Boxborough","Town of Bozrah","Town of East Lyme","Town of Mount Desert","Towner","Townsend","Townshend","Townville","Towson","Toxey","Trabuco Canyon","Tracy","Tracy City","Tracys Landing","Tracyton","Trade","Traer","Trafalgar","Trafford","Trail","Transfer","Traphill","Trappe","Travelers Rest","Traverse City","Treadwell","Trego","Treichlers","Trementina","Tremont","Tremonton","Trempealeau","Trenary","Trent","Trenton","Tres Pinos","Tresckow","Trevett","Trevor","Trevorton","Trexlertown","Treynor","Trezevant","Triadelphia","Triangle","Tribes Hill","Tribune","Trimble","Trimont","Trinidad","Trinity","Trion","Tripoli","Tripp","Triumph","Trivoli","Trona","Tropic","Trosper","Troup","Troupsburg","Trout Creek","Trout Run","Troutdale","Troutman","Troutville","Troy","Truchas","Truckee","Trufant","Truman","Trumann","Trumansburg","Trumbauersville","Trumbull","Truro","Trussville","Truth or Consequences","Truxton","Tryon","Tsaile","Tualatin","Tuba City","Tubac","Tuckahoe","Tuckasegee","Tucker","Tuckerman","Tuckerton","Tucson","Tucumcari","Tujunga","Tulare","Tulare County","Tularosa","Tulelake","Tulia","Tullahoma","Tully","Tulsa","Tumacacori","Tumtum","Tumwater","Tunas","Tunbridge","Tunica","Tunkhannock","Tunnel Hill","Tunnelton","Tuntutuliak","Tuolumne","Tupelo","Tupper Lake","Turbeville","Turbotville","Turin","Turkey","Turkey Creek","Turlock","Turner","Turners Falls","Turners Station","Turnerville","Turpin","Turtle Creek","Turtle Lake","Tuscaloosa","Tuscarawas","Tuscola","Tuscumbia","Tuskegee","Tustin","Tutor Key","Tuttle","Tutwiler","Tuxedo Park","Twain Harte","Twelve Mile","Twentynine Palms","Twin Bridges","Twin City","Twin Falls","Twin Lake","Twin Lakes","Twin Peaks","Twin Valley","Twining","Twinsburg","Twisp","Two Buttes","Two Harbors","Two Rivers","Tyaskin","Tybee Island","Tybo","Tygh Valley","Tyler","Tylertown","Tyndall","Tyner","Tyngsboro","Tyringham","Tyrone","Tyronza","Ubly","Udall","Uhrichsville","Ukiah","Uledi","Ulen","Ullin","Ulm","Ulster","Ulster Park","Ulysses","Umatilla","Umpire","Unadilla","Unalakleet","Unalaska","Uncasville","Underhill","Underwood","Unicoi","Union","Union Bridge","Union City","Union Dale","Union Grove","Union Hall","Union Hill","Union Lake","Union Mills","Union Point","Union Springs","Union Star","Union Township","Uniondale","Uniontown","Unionville","Unity","Universal City","University","University Park","University Place","Unorganized Territory of Camp Lejeune","Upatoi","Upland","Upper Abbot","Upper Black Eddy","Upper Darby","Upper Falls","Upper Jay","Upper Marlboro","Upper Saddle River","Upper Sandusky","Upperco","Upperville","Upsala","Upton","Urbana","Urbandale","Urbanna","Uriah","Urich","Ursa","Ute","Utica","Utopia","Uvalda","Uvalde","Uxbridge","Vacaville","Vacherie","Vader","Vail","Vails Gate","Valatie","Valders","Valdese","Valdez","Valdosta","Vale","Valencia","Valentine","Valentines","Valera","Valhalla","Valhermoso Springs","Valier","Valle","Vallecito","Vallejo","Valles Mines","Valley","Valley Bend","Valley Center","Valley City","Valley Cottage","Valley Falls","Valley Farms","Valley Forge","Valley Green","Valley Head","Valley Mills","Valley Park","Valley Springs","Valley Stream","Valley View","Valley Village","Valleyford","Valliant","Vallonia","Valmeyer","Valparaiso","Valrico","Van","Van Alstyne","Van Buren","Van Dyne","Van Etten","Van Horn","Van Horne","Van Lear","Van Meter","Van Nuys","Van Vleck","Van Vleet","Van Wert","Van Wyck","Vance","Vanceburg","Vancleave","Vancouver","Vandalia","Vanderbilt","Vandergrift","Vandiver","Vanleer","Vanlue","Vansant","Vanzant","Vardaman","Varna","Varnville","Vashon","Vass","Vassalboro","Vassar","Vaughan","Vaughn","Vauxhall","Veblen","Veedersburg","Vega","Velarde","Velva","Vendor","Venedocia","Veneta","Venetia","Venice","Ventnor City","Ventress","Ventura","Venus","Veradale","Verbank","Verdi","Verdigre","Verdon","Verdugo City","Verdunville","Vergas","Vergennes","Vermilion","Vermillion","Vermont","Vermontville","Vernal","Verndale","Vernon","Vernon Center","Vernon Hill","Vernon Hills","Vernonia","Vero Beach","Verona","Verplanck","Versailles","Vershire","Vesper","Vesta","Vestaburg","Vestal","Vesuvius","Vevay","Veyo","Vian","Viborg","Viburnum","Vicco","Vici","Vicksburg","Victor","Victoria","Victorville","Vida","Vidalia","Vidor","Vienna","Vilas","Villa Grove","Villa Park","Villa Rica","Villa Ridge","Village","Village Mills","Villanova","Villanueva","Villard","Villas","Ville Platte","Villisca","Vilonia","Vina","Vinalhaven","Vincennes","Vincent","Vincentown","Vine Grove","Vineland","Vinemont","Vineyard Haven","Vining","Vinita","Vinton","Vintondale","Viola","Violet","Violet Hill","Viper","Virden","Virgie","Virgilina","Virgin","Virginia","Virginia Beach","Viroqua","Visalia","Vista","Vivian","Volborg","Volcano","Volga","Voluntown","Von Ormy","Vona","Vonore","Voorhees Township","Voorheesville","Vulcan","Waban","Wabash","Wabasha","Wabasso","Waccabuc","Wachapreague","Waco","Waconia","Waddell","Waddy","Wade","Wadena","Wadesboro","Wadesville","Wading River","Wadley","Wadmalaw Island","Wadsworth","Waelder","Wagener","Wagner","Wagoner","Wahiawa","Wahkon","Wahoo","Wahpeton","Waialua","Waikoloa","Wailuku","Waimanalo","Wainscott","Wainwright","Waipahu","Waite Park","Waitsburg","Waitsfield","Wakarusa","Wake","Wake Forest","WaKeeney","Wakefield","Wakeman","Wakita","Wakonda","Walbridge","Walcott","Walden","Waldo","Waldoboro","Waldorf","Waldport","Waldron","Waldwick","Wales","Waleska","Walford","Walhalla","Walhonding","Walker","Walker Valley","Walkersville","Walkerton","Walkertown","Walkerville","Wall","Wall Lake","Walla Walla","Wallace","Wallaceton","Walland","Wallback","Wallburg","Walled Lake","Waller","Wallingford","Wallington","Wallins Creek","Wallis","Wallkill","Wallowa","Walls","Wallsburg","Walnut","Walnut Bottom","Walnut Cove","Walnut Creek","Walnut Grove","Walnut Ridge","Walnut Shade","Walnut Springs","Walnutport","Walpole","Walsenburg","Walsh","Walshville","Walstonburg","Walterboro","Walters","Waltham","Walthill","Walton","Waltonville","Walworth","Wamego","Wampsville","Wampum","Wamsutter","Wana","Wanakena","Wanamingo","Wanaque","Wanatah","Wanchese","Waneta","Wanette","Wannaska","Wantagh","Wapakoneta","Wapato","Wapella","Wapello","Wappapello","Wappingers Falls","Wapwallopen","War","Warba","Ward","Warden","Wardensville","Ware","Ware Neck","Ware Shoals","Wareham","Waretown","Warfordsburg","Warm Springs","Warminster","Warne","Warner","Warner Robins","Warner Springs","Warners","Warren","Warren Center","Warren Township","Warrendale","Warrens","Warrensburg","Warrensville","Warrenton","Warrenville","Warrington","Warrior","Warriors Mark","Warroad","Warsaw","Wartburg","Wartrace","Warwick","Wasco","Waseca","Washburn","Washington","Washington Boro","Washington Court House","Washington Crossing","Washington Grove","Washington Township","Washingtonville","Washougal","Wasilla","Waskom","Wassaic","Watauga","Watchung","Water Mill","Water Valley","Waterboro","Waterbury","Waterbury Center","Waterford","Waterford Flat","Waterford Works","Waterloo","Waterman","Waterport","Waterproof","Waters","Watersmeet","Watertown","Waterville","Waterville Valley","Watervliet","Watford City","Wathena","Watkins","Watkins Glen","Watkinsville","Watonga","Watseka","Watson","Watsontown","Watsonville","Watts","Wattsburg","Wattsville","Waubun","Wauchula","Waucoma","Wauconda","Waukee","Waukegan","Waukesha","Waukomis","Waukon","Waunakee","Wauneta","Waupaca","Waupun","Wauregan","Waurika","Wausa","Wausau","Wauseon","Wautoma","Waveland","Waverly","Waverly Hall","Wawaka","Waxahachie","Waxhaw","Waycross","Wayland","Waymart","Wayne","Wayne City","Waynesboro","Waynesburg","Waynesfield","Waynesville","Waynetown","Waynoka","Wayzata","Weare","Weatherford","Weatherly","Weatogue","Weaubleau","Weaver","Weaverville","Webb","Webb City","Webbers Falls","Webberville","Weber City","Webster","Webster City","Webster Springs","Wedowee","Weed","Weedsport","Weedville","Weehawken","Weeksbury","Weems","Weeping Water","Weidman","Weimar","Weiner","Weippe","Weir","Weirsdale","Weirton","Weiser","Welaka","Welch","Welches","Welcome","Weldon","Weleetka","Wellborn","Wellesley","Wellesley Hills","Wellfleet","Wellford","Wellington","Wellman","Wellpinit","Wells","Wellsboro","Wellsburg","Wellsley","Wellston","Wellsville","Wellton","Welsh","Wenatchee","Wendel","Wendell","Wenden","Wendover","Wenham","Wenona","Wenonah","Wentworth","Wentzville","Wernersville","Weskan","Weslaco","Wesley","Wesley Chapel","Wessington","Wessington Springs","Wesson","West","West Alexander","West Alexandria","West Alton","West Babylon","West Baldwin","West Barnstable","West Bend","West Berlin","West Blocton","West Bloomfield","West Boylston","West Branch","West Briar","West Bridgewater","West Brookfield","West Burke","West Burlington","West Chatham","West Chazy","West Chester","West Chesterfield","West Chicago","West Columbia","West Concord","West Corinth","West Cornwall","West Covina","West Coxsackie","West Creek","West Danville","West Decatur","West Dennis","West Des Moines","West Dover","West Dummerston","West Dundee","West Durham","West Edmeston","West End","West Enfield","West Falls","West Falmouth","West Fargo","West Farmington","West Finley","West Fork","West Frankfort","West Friendship","West Glover","West Granby","West Green","West Greenwich","West Groton","West Grove","West Hamlin","West Harrison","West Hartford","West Hartland","West Harwich","West Haven","West Haverstraw","West Helena","West Hempstead","West Henrietta","West Hills","West Hollywood","West Islip","West Jefferson","West Jordan","West Kingston","West Lafayette","West Lebanon","West Leyden","West Liberty","West Linn","West Long Branch","West Louisville","West Manchester","West Mansfield","West McLean","West Memphis","West Middlesex","West Middleton","West Mifflin","West Milford","West Milton","West Mineral","West Minot","West Monroe","West New York","West Newbury","West Newton","West Nyack","West Olive","West Orange","West Paducah","West Palm Beach","West Paris","West Park","West Pawlet","West Pittsburg","West Plains","West Point","West Portsmouth","West Richland","West River","West Rockport","West Roxbury","West Rutland","West Sacramento","West Salem","West Sand Lake","West Sayville","West Shokan","West Simsbury","West Springfield","West Stockbridge","West Stockholm","West Suffield","West Sunbury","West Swanzey","West Terre Haute","West Tisbury","West Topsham","West Townsend","West Union","West Unity","West Valley","West Van Lear","West Wardsboro","West Wareham","West Warwick","West Wendover","West Winfield","West Yarmouth","West Yellowstone","Westboro","Westborough","Westbrook","Westbrookville","Westbury","Westby","Westchester","Westcliffe","Westerlo","Westerly","Western Grove","Western Springs","Westernport","Westernville","Westerville","Westfield","Westfield Center","Westford","Westgate","Westhampton","Westhampton Beach","Westhope","Westlake","Westlake Village","Westland","Westley","Westminster","Westmont","Westmoreland","Westmoreland City","Weston","Westover","Westphalia","Westpoint","Westport","Westside","Westtown","Westview","Westville","Westwego","Westwood","Wethersfield","Wetmore","Wetumka","Wetumpka","Wewahitchka","Wewoka","Wexford","Weyauwega","Weyerhaeuser","Weyers Cave","Weymouth","Whaleyville","Wharncliffe","Wharton","What Cheer","Whately","Whatley","Wheat Ridge","Wheatfield","Wheatland","Wheaton","Wheeler","Wheelersburg","Wheeling","Wheelwright","Whigham","Whippany","Whipple","Whitakers","White","White Bear Lake","White Bird","White Bluff","White Castle","White City","White Cloud","White Deer","White Hall","White Haven","White Heath","White House","White Lake","White Marsh","White Mountain Lake","White Oak","White Pigeon","White Pine","White Plains","White Post","White River Junction","White Salmon","White Sands","White Springs","White Stone","White Sulphur Springs","White Swan","White Water","Whiteface","Whitefield","Whitefish","Whiteford","Whitehall","Whitehall Township","Whitehouse","Whitehouse Station","Whiteland","Whiteman Air Force Base","Whiteriver","Whites Creek","Whitesboro","Whitesburg","Whiteside","Whitestone","Whitestown","Whitesville","Whitethorn","Whiteville","Whitewater","Whitewright","Whiting","Whitingham","Whitinsville","Whitley City","Whitman","Whitmire","Whitmore","Whitmore Lake","Whitney","Whitney Point","Whitsett","Whittemore","Whittier","Whittington","Whitwell","Wibaux","Wichita","Wichita Falls","Wickenburg","Wickes","Wickliffe","Wiconisco","Widener","Wiergate","Wiggins","Wilber","Wilberforce","Wilbraham","Wilbur","Wilburton","Wilcox","Wild Rose","Wilder","Wilderville","Wildomar","Wildorado","Wildwood","Wiley","Wilkes Barre","Wilkesboro","Wilkinson","Willacoochee","Willamina","Willapa","Willard","Willcox","Willet","Williams","Williams Bay","Williamsburg","Williamsfield","Williamson","Williamsport","Williamston","Williamstown","Williamsville","Willimantic","Willingboro","Willis","Willis Wharf","Willisburg","Williston","Williston Park","Willisville","Willits","Willmar","Willoughby","Willow Creek","Willow Grove","Willow Hill","Willow Lake","Willow River","Willow Springs","Willow Street","Willowbrook","Willows","Wills Point","Willsboro","Willseyville","Willshire","Wilmar","Wilmer","Wilmerding","Wilmette","Wilmington","Wilmont","Wilmore","Wilmot","Wilsall","Wilsey","Wilseyville","Wilson","Wilsonville","Wilton","Wilton Manors","Wimauma","Wimberley","Wimbledon","Winamac","Winchendon","Winchester","Winchester Center","Wind Gap","Wind Ridge","Windber","Winder","Windermere","Windfall","Windham","Windham Center","Windom","Window Rock","Windsor","Windsor Heights","Windsor Locks","Windsor Mill","Windthorst","Winesburg","Winfield","Wing","Wingate","Wingdale","Winger","Wingina","Wingo","Winifrede","Wink","Winlock","Winnebago","Winneconne","Winnemucca","Winner","Winnetka","Winnett","Winnfield","Winnie","Winnsboro","Winona","Winona Lake","Winooski","Winside","Winslow","Winslow Township","Winsted","Winston","Winston-Salem","Winter","Winter Garden","Winter Harbor","Winter Haven","Winter Park","Winter Springs","Winterhaven","Winterport","Winters","Winterset","Winterthur","Winterville","Winthrop","Winthrop Harbor","Winton","Wiota","Wirtz","Wiscasset","Wisconsin Dells","Wisconsin Rapids","Wisdom","Wise","Wishek","Wisner","Wister","Withams","Withee","Witt","Witten","Wittenberg","Wittensville","Wittmann","Wixom","Woburn","Woden","Wofford Heights","Wolbach","Wolcott","Wolcottville","Wolf Point","Wolfe City","Wolfeboro","Wolfeboro Falls","Wolfforth","Wolford","Wolverton","Womelsdorf","Wonder Lake","Wonewoc","Wood Dale","Wood Lake","Wood River","Wood River Junction","Wood-Ridge","Woodacre","Woodberry Forest","Woodbine","Woodbourne","Woodbridge","Woodburn","Woodbury","Woodbury Heights","Woodcliff Lake","Woodford","Woodgate","Woodhaven","Woodhull","Woodinville","Woodlake","Woodland","Woodland Hills","Woodland Mills","Woodland Park","Woodlawn","Woodleaf","Woodlyn","Woodmere","Woodridge","Woodruff","Woods Cross","Woods Hole","Woodsboro","Woodsfield","Woodside","Woodson","Woodstock","Woodstown","Woodsville","Woodville","Woodward","Woodway","Woodworth","Woolstock","Woolwich","Woonsocket","Wooster","Wooton","Worcester","Worden","Worland","Worley","Worth","Wortham","Worthing","Worthington","Worthington Center","Worthington Springs","Worthville","Worton","Wray","Wrens","Wrenshall","Wrentham","Wright","Wright City","Wrightstown","Wrightsville","Wrightsville Beach","Wrightwood","Wurtsboro","Wyaconda","Wyalusing","Wyandanch","Wyandotte","Wyanet","Wyckoff","Wyco","Wye Mills","Wykoff","Wylie","Wylliesburg","Wymore","Wynantskill","Wyncote","Wyndmere","Wynne","Wynnewood","Wynona","Wynot","Wyocena","Wyoming","Wysox","Wytheville","Xenia","Yachats","Yacolt","Yadkinville","Yakima","Yalaha","Yale","Yamhill","Yampa","Yanceyville","Yankeetown","Yankton","Yantis","Yaphank","Yarmouth","Yarmouth Port","Yates Center","Yates City","Yatesboro","Yatesville","Yazoo City","Yeaddiss","Yellow Spring","Yellow Springs","Yellville","Yelm","Yemassee","Yerington","Yermo","Yoakum","Yoder","Yolyn","Yoncalla","Yonkers","Yorba Linda","York","York Beach","York Corner","York Harbor","York Haven","York Springs","Yorkshire","Yorktown","Yorktown Heights","Yorkville","Yosemite Valley","Young","Young America","Young Harris","Youngstown","Youngsville","Youngtown","Youngwood","Yountville","Ypsilanti","Yreka","Yuba City","Yucaipa","Yucca","Yucca Valley","Yukon","Yulan","Yulee","Yuma","Yutan","Zachary","Zaleski","Zalma","Zanesfield","Zanesville","Zapata","Zarephath","Zavalla","Zearing","Zebulon","Zeeland","Zeigler","Zelienople","Zellwood","Zenda","Zephyr","Zephyr Cove","Zephyrhills","Zieglersville","Zillah","Zimmerman","Zion","Zion Grove","Zionhill","Zionsville","Zionville","Zirconia","Zolfo Springs","Zortman","Zullinger","Zumbrota","Zuni","Zurich","Zwingle"]},"UY":{"id":"UY","name":"Uruguay","timezones":["America/Montevideo"],"cities":["Barra de Carrasco","Canelones","Colonia del Sacramento","Durazno","Florida","La Floresta","La Paz","Las Piedras","Maldonado","Mercedes","Montevideo","Punta del Este","Salto","San Carlos","Toledo","Union"]},"UZ":{"id":"UZ","name":"Uzbekistan","timezones":["Asia/Samarkand","Asia/Tashkent"],"cities":[]},"VA":{"id":"VA","name":"Vatican City","timezones":["Europe/Rome"],"cities":[]},"VC":{"id":"VC","name":"St Vincent","timezones":["America/Port_of_Spain"],"cities":[]},"VE":{"id":"VE","name":"Venezuela","timezones":["America/Caracas"],"cities":["Acarigua","Anaco","Araure","Bachaquero","Barcelona","Barinas","Barquisimeto","Bejuma","Bolivar","Cabimas","Cabudare","Cagua","Caja de Agua","Calabozo","Campo de Carabobo","Caraballeda","Caracas","Caripe","Carrizal","Catia La Mar","Charallave","Chivacoa","Ciudad Guayana","Ciudad Ojeda","Ciudad Piar","Colonia Tovar","Coro","Cua","Curazaito","El Chorro","El Recreo","El Roque","El Rosal","El Tigre","El Vigia","Guachara","Guanare","Guarenas","Guatire","Guayana","Gueiria","La Castellana","La Cruz","La Guaira","La Urbina","La Verdad","La Victoria","La Villa del Rosario","Londres","Los Chorros","Los Teques","Macuto","Maiquetia","Maracaibo","Maracay","Maria","Mariguitar","Matanzas","Miranda","Monte Cristo","Naguanagua","Ocumare","Pampatar","Porlamar","Puerto Cabello","Puerto La Cruz","Puerto Ordaz and San Felix","Punto Fijo","Sabaneta","San Antonio","San Antonio de Los Altos","San Diego","San Felipe","San Felix","San Francisco","San Joaquin","San Jose de Guanipa","Santa Cruz del Zulia","Santa Fe","Santa Teresa","Solano","Tariba","Torre","Trujillo","Tucupita","Turmero","Valencia","Valera","Valle","Vargas"]},"VG":{"id":"VG","name":"Virgin Islands (UK)","timezones":["America/Port_of_Spain"],"cities":[]},"VI":{"id":"VI","name":"Virgin Islands (US)","timezones":["America/Port_of_Spain"],"cities":[]},"VN":{"id":"VN","name":"Vietnam","timezones":["Asia/Bangkok","Asia/Ho_Chi_Minh"],"cities":["An Dinh","An Giang","An Nhon","An Tam","An Thanh","Ap Sai Gon","Ap Trung","Bac Giang","Bac Kan","Bac Ninh","Bach Ma","Bang","Ben Nghe","Ben Than","Bien Hoa","Binh Phuoc","Binh Thanh","Binh Thoai","Buon Ma Thuot","Ca Mau","Cam Pha","Can Tho","Cho Ha","Chuong Duong","Co Giang","Da Lat","Da Nang","Dac Loc","Di An","Dien Bien Phu","Dinh Long","Dong","Dong Nai","Dong Thap","Duc Thang","Giong Ngai","Giong Truong","Go Vap","Ha Dong","Ha Long","Ha Nam","Ha Tinh","Haiphong","Hanoi","Ho Chi Minh City","Hoang Mai","Hung Yen","Huong Tinh","Khanh Hoa","Kon Tum","Lang Dung","Lang Hong","Lang Son","Lao Cai","Le Loi","Long An","Long Tan","Long Van","Luong Hoi","Minh Khai","Nghi Loc","Nha Be","Nha Trang","Phan Thon","Phu Nhuan","Phu Tho","Phu Xuyen","Phu Yen","Phuong Tan","Pleiku","Quan Ngoc","Quan Trang","Quang Nam","Quang Tri","Quang Trung","Qui Nhon","Soc Trang","Tam Ky","Tan Binh","Tan Thuan Dong","Tang","Tay Ninh","Thach That","Thanh Nguyen","Thanh Pho Ha Giang","Thanh Pho Hai Duong","Thanh Pho Hoa Binh","Thanh Pho Ninh Binh","Thanh Pho Thai Binh","Thanh Pho Thai Nguyen","Thanh Pho Tuyen Quang","Thon Bao An","Thong Nhat","Thu Dau Mot","Thu Duc","Thuan An","Thuan Cong","Tra Vinh","Trao","Truong Lam","Truong Son","Van Hai","Van Tan","Vi Thanh","Vinh","Vinh Long","Vinh Yen","Xom Phuoc My","Xom Thang","Xom Truong Dinh","Yen Bai","Yen Thanh"]},"VU":{"id":"VU","name":"Vanuatu","timezones":["Pacific/Efate"],"cities":[]},"WF":{"id":"WF","name":"Wallis & Futuna","timezones":["Pacific/Wallis"],"cities":[]},"WS":{"id":"WS","name":"Samoa (western)","timezones":["Pacific/Apia"],"cities":[]},"YE":{"id":"YE","name":"Yemen","timezones":["Asia/Riyadh"],"cities":[]},"YT":{"id":"YT","name":"Mayotte","timezones":["Africa/Nairobi"],"cities":["Bandaboa","Chiconi","Combani","Dzaoudzi","Dzoumonye","Koungou","Mamoudzou","Ouangani","Pamandzi","Sada","Tsingoni","Tsoundzou 1"]},"ZA":{"id":"ZA","name":"South Africa","timezones":["Africa/Johannesburg"],"cities":["Alberton","Alice","Alrode","Amanzimtoti","Ashton","Atlantis","Balfour","Bathurst","Beaufort West","Bedfordview","Belhar","Bellville","Benoni","Bergvliet","Bethal","Bethlehem","Bloemfontein","Boksburg","Bothasig","Botshabelo","Braamfontein","Brackenfell","Brakpan","Bredasdorp","Brits","Bronkhorstspruit","Brooklyn","Bryanston","Buffalo","Butterworth","Cape Town","Capital Park","Carletonville","Carolina","Centurion","City of Cape Town","Clanwilliam","Claremont","Coega","Coligny","Constantia","Craighall","Cullinan","De Aar","Delmas","Deneysville","Despatch","Doornfontein","Dube Location","Duiwelskloof","Dullstroom","Dundee","Durban","Durbanville","East London","Edenburg","Edenvale","Eersterivier","Elandsfontein","Elarduspark","Eloff","Elsburg","Elsenburg","Emerald Hill","Emnambithi-Ladysmith","Empangeni","Erasmia","Ermelo","Eshowe","Evander","Faure","Florida Glen","Fochville","Fordsburg","Fort Cox","Franschhoek","Gansbaai","Ganspan","George","Germiston","Gezina","Gillitts","Gingindlovu","Glen Austin","Goodwood","Graaff Reinet","Grabouw","Grahamstown","Greytown","Groblersdal","Haenertsburg","Harrismith","Hartbeespoort","Hartenbos","Hartswater","Hatfield","Hawston","Hazyview","Heidelberg","Hekpoort","Henley on Klip","Hennenman","Hermanus","Hillcrest","Hilton","Himeville","Hluhluwe","Hoedspruit","Hogsback","Houghton Estate","Hout Bay","Howick","Humansdorp","Hyde Park","Irene","Isando","Ixopo","Johannesburg","Kalkbaai","Katlehong","Kempton Park","Kimberley","Kingsborough","Kingsley","Kingsmead","Kinross","Kleinmond","Klerksdorp","Kloof","Knysna","Kokstad","Kraaifontein","Kranskop","Kriel","Kroonstad","Krugersdorp","Kuils River","KwaDukuza","La Lucia","La Motte","Ladybrand","Lansdowne","Laudium","Lephalale","Lichtenburg","Lombardy East","London","Louis Trichardt","Lutzville","Lydenburg","Lyndhurst","Lynnwood","Lyttelton","Machadodorp","Mafikeng","Maidstone","Majuba","Malmesbury","Malvern","Maraisburg","Margate","Marshalltown","Meadowridge","Medunsa","Melkbosstrand","Merrivale","Messina","Meyerton","Middelburg","Midrand","Milnerton","Mmabatho","Mobeni","Modderfontein","Mokopane","Montagu","Monument Park","Mooi River","Mookgophong","Moorreesburg","Morningside Manor","Mossel Bay","Mount Edgecombe","Mthatha","Muizenberg","Napier","Nelspruit","New Germany","Newcastle","Newlands","Nigel","Northcliff","Odendaalsrus","Ogies","Olifantsfontein","Onderstepoort","Onverwacht","Oranjeville","Oranjezicht","Ottosdal","Oudtshoorn","Overport","Paarl","Panorama","Parktown","Parkview","Parow","Peninsula","Phalaborwa","Philadelphia","Philipstown","Phoenix","Phokeng","Pietermaritzburg","Pinelands","Pinetown","Plettenberg Bay","Plumstead","Polokwane","Pongola","Port Alfred","Port Elizabeth","Port Shepstone","Potchefstroom","Pretoria","Prieska","Primrose","Pringle Bay","Queensburgh","Queenstown","Queenswood","Randburg","Randfontein","Rawsonville","Rhodes","Richards Bay","Richmond","Riebeek-Kasteel","Rivonia","Roggebaai","Roodepoort","Rooigrond","Rooihuiskraal","Rosebank","Rosettenville","Rosslyn","Rustenburg","Sabie","Saint Helena Bay","Saint James","Saldanha","Salt Rock","Sandown","Sandton","Sasolburg","Schweizer-Reneke","Scottburgh","Sebokeng","Secunda","Sedgefield","Senekal","Shelly Beach","Silverton","Sinoville","Somerset West","Soshanguve","Soweto","Springs","Standerton","Stanford","Stellenbosch","Stilfontein","Strand","Sun Valley","Swartkops","Temba","Tembisa","Thabazimbi","The Rest","Thohoyandou","Three Anchor Bay","Three Rivers","Tokai","Tongaat","Tzaneen","Uitenhage","Umbogintwini","Umdloti","Umhlanga","Umkomaas","Umtentweni","Upington","Vaalbank","Vaalpark","Vanderbijlpark","Vereeniging","Verulam","Villiersdorp","Virginia","Vosloorus","Vrededorp","Vredenburg","Vryheid","Walkerville","Walmer Heights","Warner Beach","Wartburg","Waverley","Welgelegen","Welgemoed","Welkom","Wellington","Weltevreden","Weltevreedenpark","Westonaria","Westville","White River","Wilderness","Winterton","Witbank","Witpoortjie","Wonderboom","Worcester","Wynberg","Zeerust"]},"ZM":{"id":"ZM","name":"Zambia","timezones":["Africa/Maputo"],"cities":["Kalomo","Kitwe","Livingstone","Lusaka","Macha","Mumbwa","Ndola","Siavonga","Solwezi"]},"ZW":{"id":"ZW","name":"Zimbabwe","timezones":["Africa/Maputo"],"cities":["Bulawayo","Chinhoyi","Greendale","Gwanda","Harare","Kwekwe","Mufakose","Mutare","Victoria Falls"]}}');


// Find timezones with city name and country name.
function $0b0e588890cecab6$var$getTimezones(name) {
    if (!name) return [];
    const countries = Object.values($27823647d6e11c64$exports);
    const matchedCountry = countries.find(function(country) {
        // If country doesn't have cities array in it.
        if (!country.cities) country.cities = [];
        const removedSpaceName = name.replace(/^\s+|\s+$/g, "");
        const lowerCountryName = country.name.toLowerCase().trim();
        const userEnteredCountryName = removedSpaceName.toLowerCase();
        // If user has entered both country name and city name together.
        const nameSplit = name.toLowerCase().split(" ");
        // User entered text matched with the country name.
        const matchedCountryName = lowerCountryName === userEnteredCountryName || nameSplit.includes(lowerCountryName);
        if (matchedCountryName) return true;
        // Matching user entered text with cities name
        const matchCityName = country.cities.find(function(cityName) {
            return cityName.toLowerCase() === name.toLowerCase();
        });
        if (matchCityName) return true;
        return false;
    });
    if (!matchedCountry) return [];
    return matchedCountry.timezones;
}
function $0b0e588890cecab6$var$getTimezonesWithCountryCode(code) {
    if (!code) return [];
    const matchedCountry = $27823647d6e11c64$exports[code];
    if (matchedCountry) return matchedCountry.timezones;
    return [];
}
$0b0e588890cecab6$exports = {
    getTimezonesWithCountryCode: $0b0e588890cecab6$var$getTimezonesWithCountryCode,
    getTimezones: $0b0e588890cecab6$var$getTimezones
};



var $fgmOP = parcelRequire("fgmOP");


const $c8b8b098e861ed14$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useTimezones", "INFO");
const $c8b8b098e861ed14$export$f3ebba1d05adff61 = (brands)=>{
    const timezones = [
        "UTC"
    ];
    if (brands) {
        const brandTimezones = brands.map((brand)=>(0, $0b0e588890cecab6$exports.getTimezonesWithCountryCode)(brand.countryId)[0]);
        timezones.push(...brandTimezones.filter((timezone, index)=>brandTimezones.indexOf(timezone) === index));
    }
    return timezones;
};
const $c8b8b098e861ed14$export$3f5046f9ef450640 = ()=>{
    const { brands: brands } = (0, $97a71fda4fbdc6d3$export$da3999a1d9248c0c)();
    const timezones = (0, $fgmOP.useMemo)(()=>$c8b8b098e861ed14$export$f3ebba1d05adff61(brands), [
        brands
    ]);
    return {
        timezones: timezones
    };
};
















const $d8d3d7bc99b6855a$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Smsc", "INFO");
const $d8d3d7bc99b6855a$var$smscsQueryGql = (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($032304f87e9ba72f$exports))));
const $d8d3d7bc99b6855a$export$9d5619b206d0b60f = (props)=>{
    const { hasPermission: hasPermission, loadingUser: loadingUser, currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { loading: loadingCountries, countries: countries } = (0, $c21c461bc3365537$export$1984d0199e312f12)();
    const params = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const useApolloCacheEntityProps = {
        fragment: (0, (/*@__PURE__*/$parcel$interopDefault($e8d6f17f71da1dc4$exports))),
        watchQuery: $d8d3d7bc99b6855a$var$smscsQueryGql,
        watchVariables: {
            countryId: currentUserBrand?.countryId
        },
        entityId: params.smsc,
        newEntity: {
            id: null,
            ...currentUserBrand ? {
                countryId: currentUserBrand?.countryId
            } : {}
        }
    };
    const formStateOptions = (0, $cd0b9ee27a364316$export$4c2508f4134d3a42)(useApolloCacheEntityProps);
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)(formStateOptions);
    const { isEditing: isEditing, entity: entity, onEdit: onEdit, onCancel: onCancel, isCreating: isCreating } = formState;
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const saveSmsc = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($e14e6c5eeee2c310$exports)))));
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const { timezones: timezones } = (0, $c8b8b098e861ed14$export$3f5046f9ef450640)();
    const onSave = ()=>{
        const smsc = formState.entityAs();
        $d8d3d7bc99b6855a$var$log.debug("onSave", {
            smsc: smsc,
            isCreating: isCreating
        });
        saveSmsc({
            loadingText: "Saving SMSC...",
            successText: "SMSC saved",
            variables: {
                smsc: smsc
            },
            update: (proxy, { data: data })=>{
                const { saveSmsc: saveSmsc } = data || {};
                if (!saveSmsc) {
                    $d8d3d7bc99b6855a$var$log.error("Save Smsc mutation did not return the updated Smsc");
                    return;
                }
                if (isCreating) {
                    $d8d3d7bc99b6855a$var$log.debug("saveSmsc update. New smsc created", saveSmsc);
                    const data = proxy.readQuery({
                        query: $d8d3d7bc99b6855a$var$smscsQueryGql
                    });
                    const smscs = [
                        ...data?.smscs || [],
                        saveSmsc
                    ];
                    proxy.writeQuery({
                        query: $d8d3d7bc99b6855a$var$smscsQueryGql,
                        data: {
                            smscs: smscs
                        }
                    });
                    navigate(formatWithBrand($e9a95c61c800ecd2$export$3448398040c65777, saveSmsc.id), {
                        replace: true
                    });
                } else $d8d3d7bc99b6855a$var$log.debug("saveSmsc update. Existing smsc updated", saveSmsc);
            }
        }).then(({ data: data })=>{
            const { saveSmsc: saveSmsc } = data || {
                saveSmsc: undefined
            };
            $d8d3d7bc99b6855a$var$log.debug("saveSmscMutate resolved", saveSmsc);
            saveSmsc && formState.onSaved((0, $f6ff28847e6675c5$export$232f37f9a0fc548e)(saveSmsc));
        });
    };
    $d8d3d7bc99b6855a$var$log.debug("render", {
        params: params,
        isEditing: isEditing,
        entity: entity,
        onEdit: onEdit,
        onCancel: onCancel,
        isCreating: isCreating
    });
    const formButtons = !entity ? null : !isEditing ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        children: [
            hasPermission((0, $ca0941499cca84bb$export$2217feab9eac9873)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                text: "Edit",
                className: "",
                onClick: onEdit
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                to: formatWithBrand($e9a95c61c800ecd2$export$524b16a9ead1cc8f),
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                    text: "Back to List",
                    kind: "cancel"
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        children: [
            hasPermission((0, $ca0941499cca84bb$export$2217feab9eac9873)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                text: "Save",
                onClick: onSave,
                kind: "primary"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                text: "Cancel",
                onClick: onCancel,
                kind: "cancel"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                children: [
                    "SMSC",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        className: "inlineBlock marginLeft",
                        children: formButtons
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "smsc"
            }),
            !entity || loadingUser || loadingCountries ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "id",
                                label: "ID",
                                isDisabled: !isCreating
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "name",
                                label: "Name"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "countryId",
                                    label: "Country",
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                    options: countries,
                                    isEditing: false
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "timeZone",
                                    label: "Timezone",
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                    options: timezones
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "description",
                                label: "Description",
                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).textarea
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($d8d3d7bc99b6855a$var$SmscNodesFc, {
                        parentId: "smscNodes",
                        formState: formState
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($d8d3d7bc99b6855a$var$HealthConfigFc, {
                        parentId: "healthConfig",
                        formState: formState
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($d8d3d7bc99b6855a$var$SmscConnectionFc, {
                        parentId: "smscConnection",
                        formState: formState
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: formButtons
                        })
                    })
                ]
            })
        ]
    });
};
const $d8d3d7bc99b6855a$var$SmscNodesFc = ({ parentId: parentId, formState: formState })=>{
    const smscNodes = formState.subEntityAt(parentId) || [];
    const { showModal: showModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const onCreateSmscNode = ()=>{
        $d8d3d7bc99b6855a$var$log.debug("onCreateSmscNode", smscNodes);
        formState.onChange(parentId)([
            ...smscNodes,
            {
                enabled: true
            }
        ]);
    };
    const onDeleteSmscNode = (index)=>{
        $d8d3d7bc99b6855a$var$log.debug("onDeleteSmscNode", {
            index: index
        });
        showModal({
            show: true,
            title: "Delete SMSC Node",
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                children: "Are you sure you want to delete the SMSC Node?"
            }),
            confirmType: "negative",
            confirmText: "Delete",
            onConfirm: ()=>onConfirmDeleteSmscNode(index)
        });
    };
    const onConfirmDeleteSmscNode = (index)=>{
        $d8d3d7bc99b6855a$var$log.debug("onConfirmDeleteSmscNode", {
            index: index
        });
        formState.onChange(parentId)(smscNodes.removeIndex(index));
    };
    $d8d3d7bc99b6855a$var$log.debug("SmscNodes", {
        smscNodes: smscNodes
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $22dbb5b4c09ac376$export$1266ff14c7754c00), {
                        label: "SMSC Nodes",
                        multipleOpen: true,
                        initialAllOpen: false,
                        className: "pendingSettlementsList compactSettlementsList noMarginLeft",
                        rightElement: !formState.isEditing ? undefined : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                            text: "Create SMSC Node",
                            onClick: onCreateSmscNode,
                            kind: "normal"
                        }),
                        children: smscNodes.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                            className: "marginTop",
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                                children: "No SMSC nodes"
                            })
                        }) : smscNodes.map((smscNode, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $cb8470b63aea6339$export$2e2bcd8739ae039), {
                                id: parentId + ".smscNode-" + i,
                                header: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                                    children: [
                                        "SMSC Node ",
                                        smscNode.id
                                    ]
                                }),
                                headerRightElement: !formState.isEditing ? undefined : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                    icon: "trash",
                                    onClick: (e)=>{
                                        $d8d3d7bc99b6855a$var$log.warn("trach ", e);
                                        onDeleteSmscNode(i);
                                        e.stopPropagation();
                                    },
                                    info: "Delete",
                                    className: "floatRight settlement__adjustment__icon settlement__adjustment__icon--delete"
                                }),
                                content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($d8d3d7bc99b6855a$var$SmscNodeFc, {
                                    formState: formState,
                                    parentId: `${parentId}[${i}]`
                                }, "smscNode" + i),
                                classNames: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("hideTransition")
                            }, parentId + ".smscNode-" + i))
                    })
                ]
            })
        })
    });
};
const $d8d3d7bc99b6855a$var$SmscNodeFc = ({ parentId: parentId, formState: formState })=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: parentId + ".enabled",
                        label: "Enabled",
                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: parentId + ".id",
                        label: "Node ID"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: parentId + ".name",
                        label: "Name"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: parentId + ".host",
                        label: "Host"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: parentId + ".port",
                        label: "Port",
                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).number
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: parentId + ".comment",
                        label: "Comment",
                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).textarea
                    })
                })
            })
        ]
    });
};
const $d8d3d7bc99b6855a$var$HealthConfigFc = ({ parentId: parentId, formState: formState })=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
        className: "form-group",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                title: "Health Config"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: parentId + ".enquireLinkInterval",
                            label: "Enquire Link Interval",
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).duration
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: parentId + ".enquireLinkTimeout",
                            label: "Enquire Link Timeout",
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).duration
                        })
                    ]
                })
            })
        ]
    });
};
const $d8d3d7bc99b6855a$var$SmscConnectionFc = ({ parentId: parentId, formState: formState })=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
        className: "form-group",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                title: "SMSC Connection"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: parentId + ".connectTimeout",
                            label: "Connect Timeout",
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).duration
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: parentId + ".requestTimeout",
                            label: "Request Timeout",
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).duration
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: parentId + ".bindTimeout",
                            label: "Bind Timeout",
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).duration
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: parentId + ".windowMonitorInterval",
                            label: "Window Monitor Interval",
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).duration
                        })
                    ]
                })
            })
        ]
    });
};






parcelRequire("fgmOP");












const $fd53cb4e79751fb8$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SmscList", "INFO");
const $fd53cb4e79751fb8$export$5bb13c0c2f329eba = ({ currentUserBrand: currentUserBrand })=>{
    const { loading: loading, data: { smscs: smscs } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($032304f87e9ba72f$exports)))), {
        variables: {
            countryId: currentUserBrand?.countryId
        },
        skip: !currentUserBrand
    });
    (0, $c3440150448da8b8$export$1c72fe480f599e97)([
        {
            query: "smscs",
            isLoading: loading
        }
    ]);
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    $fd53cb4e79751fb8$var$log.debug("render", smscs);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "SMSCs"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "smscs"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    size: (0, $6c2490027a2e159e$export$95dbfef2e4b1962b),
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                        to: formatWithBrand($e9a95c61c800ecd2$export$3448398040c65777, $e9a95c61c800ecd2$export$15f47a32373730e5),
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                            text: "Create SMSC"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                children: [
                    smscs && !smscs.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $98cbb91c03e56cc2$export$2e2bcd8739ae039), {
                        id: "smscList",
                        children: smscs.map((smsc)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d8d7fa9fc21de820$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("noPadding", "marginBottomHalfRem"),
                                link: formatWithBrand($e9a95c61c800ecd2$export$3448398040c65777, smsc.id),
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("bold"),
                                            children: smsc.name
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("noHover", "blackText"),
                                            children: [
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                    className: "greyText",
                                                    children: smsc.description ? "Description: " : "No description"
                                                }),
                                                smsc.description
                                            ]
                                        })
                                    ]
                                })
                            }, smsc.id))
                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                        children: "No SMSCs found"
                    }),
                    smscs && smscs.length > 10 && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            size: (0, $6c2490027a2e159e$export$95dbfef2e4b1962b),
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                                to: formatWithBrand($e9a95c61c800ecd2$export$3448398040c65777, $e9a95c61c800ecd2$export$15f47a32373730e5),
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    text: "Create Message Channel"
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};





parcelRequire("fgmOP");

var $cd316400b0aa152e$exports = {};
$cd316400b0aa152e$exports = "fragment messageChannelFragment on MessageChannel{id name description countryId provider endpointUrl callbackUrl smppConfig{...smppConfigFragment}}fragment smppConfigFragment on SmppConfig{smscId smppAccounts{...smppAccountFragment}}fragment smppAccountFragment on SmppAccount{id systemId password comment enabled useSsl systemType smppVersion sessionType sessionCount smppWindow{...smppWindowFragment}subnumberProxy{...subnumberProxyFragment}}fragment smppWindowFragment on SmppWindow{size waitTimeout monitorInterval submitOfferTimeout enquireLinkOfferTimeout}fragment subnumberProxyFragment on SubnumberProxy{enabled matchExpression prefix}";


var $15d4e15da0ce542e$exports = {};
$15d4e15da0ce542e$exports = "mutation saveMessageChannel($messageChannel:MessageChannelInput!){saveMessageChannel(messageChannel:$messageChannel){...messageChannelFragment}}fragment messageChannelFragment on MessageChannel{id name description countryId provider endpointUrl callbackUrl smppConfig{...smppConfigFragment}}fragment smppConfigFragment on SmppConfig{smscId smppAccounts{...smppAccountFragment}}fragment smppAccountFragment on SmppAccount{id systemId password comment enabled useSsl systemType smppVersion sessionType sessionCount smppWindow{...smppWindowFragment}subnumberProxy{...subnumberProxyFragment}}fragment smppWindowFragment on SmppWindow{size waitTimeout monitorInterval submitOfferTimeout enquireLinkOfferTimeout}fragment subnumberProxyFragment on SubnumberProxy{enabled matchExpression prefix}";


var $db8ca951f997b45d$exports = {};
$db8ca951f997b45d$exports = "query messageChannels($countryId:ID!){messageChannels(countryId:$countryId){...messageChannelFragment}}fragment messageChannelFragment on MessageChannel{id name description countryId provider endpointUrl callbackUrl smppConfig{...smppConfigFragment}}fragment smppConfigFragment on SmppConfig{smscId smppAccounts{...smppAccountFragment}}fragment smppAccountFragment on SmppAccount{id systemId password comment enabled useSsl systemType smppVersion sessionType sessionCount smppWindow{...smppWindowFragment}subnumberProxy{...subnumberProxyFragment}}fragment smppWindowFragment on SmppWindow{size waitTimeout monitorInterval submitOfferTimeout enquireLinkOfferTimeout}fragment subnumberProxyFragment on SubnumberProxy{enabled matchExpression prefix}";





















parcelRequire("fgmOP");












parcelRequire("fgmOP");



var $l8GLF = parcelRequire("l8GLF");





parcelRequire("fgmOP");






const $754ad9bee023434c$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SmppWindow", "INFO");
const $754ad9bee023434c$export$f30ae168f1a2a0a5 = ({ parentId: parentId, formState: formState })=>{
    $754ad9bee023434c$var$log.debug("render", {
        parentId: parentId,
        formState: formState
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
        className: "form-group",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                title: "SMPP Window"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: `${parentId}.size`,
                        label: "Size",
                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).number
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: `${parentId}.waitTimeout`,
                            label: "Wait Timeout",
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).duration
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: `${parentId}.monitorInterval`,
                            label: "Monitor Interval",
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).duration
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: `${parentId}.submitOfferTimeout`,
                            label: "Submit Offer Timeout",
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).duration
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: `${parentId}.enquireLinkOfferTimeout`,
                            label: "Enquire Link Offer Interval",
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).duration
                        })
                    ]
                })
            })
        ]
    });
};



parcelRequire("fgmOP");






const $9a88e5e5f9b08f62$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SubnumberProxy", "INFO");
const $9a88e5e5f9b08f62$export$ca9e9bc5d463a952 = ({ parentId: parentId, formState: formState })=>{
    $9a88e5e5f9b08f62$var$log.debug("render", {
        parentId: parentId,
        formState: formState
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
        className: "form-group",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                title: "Subnumber Proxy"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: `${parentId}.enabled`,
                        label: "Enabled",
                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: `${parentId}.prefix`,
                        label: "Prefix",
                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).input,
                        onChangeAlso: (prefix)=>{
                            formState.onChange(`${parentId}.prefix`)(prefix.replace(/\D/g, ""));
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: `${parentId}.matchExpression`,
                        label: "Match Expression",
                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).input
                    })
                })
            })
        ]
    });
};


const $acbda0e7a05b238f$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SmppAccount", "INFO");
const $acbda0e7a05b238f$export$a8c9fc8f7bd00c08 = ({ parentId: parentId, formState: formState })=>{
    $acbda0e7a05b238f$var$log.debug("render", {
        parentId: parentId,
        formState: formState
    });
    const { showModal: showModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const showPassword = (password)=>showModal({
            title: `SMPP Account Password`,
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                children: [
                    "The current ",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("b", {
                        children: "password"
                    }),
                    " is: ",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        className: "purpleGreyBox",
                        children: password
                    })
                ]
            })
        });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: `${parentId}.enabled`,
                        label: "Enabled",
                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: `${parentId}.id`,
                            label: "Account ID"
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: `${parentId}.smppVersion`,
                            label: "SMPP Version",
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                            options: [
                                "3.4",
                                "5.0"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: `${parentId}.systemId`,
                            label: "System ID",
                            tip: "username"
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: `${parentId}.password`,
                            label: "Password",
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).password,
                            autocomplete: `SMPP Account ${parentId} password`,
                            button: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                text: "Show",
                                className: "floatRight",
                                onClick: ()=>showPassword(formState.subEntityAt(`${parentId}.password`))
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: `${parentId}.comment`,
                        label: "Comment",
                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).textarea
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: `${parentId}.sessionCount`,
                            label: "Session Count per SMSC node",
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).number
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: `${parentId}.sessionType`,
                            label: "Session Type",
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                            options: [
                                (0, $l8GLF.TRANSMITTER),
                                (0, $l8GLF.RECEIVER),
                                (0, $l8GLF.TRANSCEIVER)
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: `${parentId}.systemType`,
                            label: "System Type",
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).input
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            className: "positionTop",
                            formState: formState,
                            entityFieldId: `${parentId}.useSsl`,
                            label: "Use SSL",
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $754ad9bee023434c$export$f30ae168f1a2a0a5), {
                formState: formState,
                parentId: `${parentId}.smppWindow`
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9a88e5e5f9b08f62$export$ca9e9bc5d463a952), {
                formState: formState,
                parentId: `${parentId}.subnumberProxy`
            })
        ]
    });
};


const $ca1d989925ad74aa$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SmppConfig", "INFO");
const $ca1d989925ad74aa$export$809f2aa2ee781f4f = ({ formState: formState })=>{
    const parentId = "smppConfig";
    const accountsPath = `${parentId}.smppAccounts`;
    const smppAccounts = formState?.subEntityAt(accountsPath) && [
        ...formState?.subEntityAt(accountsPath)
    ] || [];
    const { loading: loading, data: { smscs: smscs } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($032304f87e9ba72f$exports)))));
    const { showModal: showModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const onCreateAccount = ()=>{
        $ca1d989925ad74aa$var$log.debug("onCreateAccount", smppAccounts);
        formState.onChange(accountsPath)([
            ...smppAccounts,
            {}
        ]);
    };
    const onDeleteAccount = (index)=>{
        $ca1d989925ad74aa$var$log.debug("onDeleteAccount", {
            index: index
        });
        showModal({
            show: true,
            title: "Delete SMPP Account",
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                children: "Are you sure you want to delete the SMPP Account?"
            }),
            confirmType: "negative",
            confirmText: "Delete",
            onConfirm: ()=>onConfirmDeleteAccount(index)
        });
    };
    const onConfirmDeleteAccount = (index)=>{
        $ca1d989925ad74aa$var$log.debug("onConfirmDeleteAccount", {
            index: index
        });
        formState.onChange(accountsPath)(smppAccounts.removeIndex(index));
    };
    $ca1d989925ad74aa$var$log.debug("SmppConfigFc", {
        smppAccounts: smppAccounts,
        formState: formState
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: `${parentId}.smscId`,
                        label: "SMSC",
                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                        options: smscs,
                        tip: "The list of SMSC may be updated from Management > SMSCs"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $22dbb5b4c09ac376$export$1266ff14c7754c00), {
                label: "SMPP Accounts",
                multipleOpen: true,
                initialAllOpen: false,
                className: "pendingSettlementsList compactSettlementsList noMarginLeft",
                children: smppAccounts.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                    children: "No SMPP accounts"
                }) : smppAccounts.map((smppAccount, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $cb8470b63aea6339$export$2e2bcd8739ae039), {
                        id: `${parentId}.smppAccount-${i}`,
                        header: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                            children: smppAccount.id
                        }),
                        description: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                disabled: !smppAccount.enabled
                            }),
                            children: [
                                smppAccount.comment,
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                    className: "floatRight",
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                        label: "Enabled",
                                        value: smppAccount.enabled,
                                        isEditing: false,
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox
                                    })
                                })
                            ]
                        }),
                        headerRightElement: !formState.isEditing ? undefined : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                            icon: "trash",
                            onClick: (e)=>{
                                $ca1d989925ad74aa$var$log.warn("trach ", e);
                                onDeleteAccount(i);
                                e.stopPropagation();
                            },
                            info: "Delete",
                            className: "floatRight settlement__adjustment__icon settlement__adjustment__icon--delete"
                        }),
                        content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $acbda0e7a05b238f$export$a8c9fc8f7bd00c08), {
                            formState: formState,
                            parentId: `${parentId}.smppAccounts[${i}]`
                        }, "smppAccount" + i),
                        classNames: "hideTransition"
                    }, `${parentId}.smppAccount-${i}`))
            }),
            formState.isEditing && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                className: "marginBottom",
                text: "Create SMPP Account",
                onClick: onCreateAccount,
                kind: "normal"
            })
        ]
    });
};


const $875603657e94e027$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Message Channel", "INFO");
const $875603657e94e027$var$messageChannelsQueryGql = (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($db8ca951f997b45d$exports))));
const $875603657e94e027$export$e1b690120b007d19 = ()=>{
    const { hasPermission: hasPermission, currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { getCountryId: getCountryId } = (0, $97a71fda4fbdc6d3$export$da3999a1d9248c0c)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const { countries: countries } = (0, $c21c461bc3365537$export$1984d0199e312f12)();
    const params = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const useApolloCacheEntityProps = {
        fragment: (0, (/*@__PURE__*/$parcel$interopDefault($cd316400b0aa152e$exports))),
        watchQuery: $875603657e94e027$var$messageChannelsQueryGql,
        watchVariables: {
            countryId: currentUserBrand?.countryId
        },
        entityId: params.messageChannel,
        newEntity: {
            id: null,
            ...currentUserBrand ? {
                countryId: getCountryId(currentUserBrand.id)
            } : {}
        }
    };
    const formStateOptions = (0, $cd0b9ee27a364316$export$4c2508f4134d3a42)(useApolloCacheEntityProps);
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)(formStateOptions);
    const { isEditing: isEditing, entity: entity, onEdit: onEdit, onCancel: onCancel, onChange: onChange, isCreating: isCreating } = formState;
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const saveMessageChannel = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($15d4e15da0ce542e$exports)))));
    const onSave = ()=>{
        const messageChannel = formState.entityAs();
        $875603657e94e027$var$log.debug("onSave", {
            messageChannel: messageChannel,
            isCreating: isCreating
        });
        saveMessageChannel({
            loadingText: "Saving message channel...",
            successText: "Message channel saved",
            variables: {
                messageChannel: messageChannel
            },
            update: (proxy, { data: data })=>{
                const { saveMessageChannel: saveMessageChannel } = data || {};
                if (!saveMessageChannel) {
                    $875603657e94e027$var$log.error("Save MessageChannel mutation did not return the updated MessageChannel");
                    return;
                }
                if (isCreating) {
                    $875603657e94e027$var$log.debug("saveMessageChannel update. New messageChannel created", saveMessageChannel);
                    const data = proxy.readQuery({
                        query: $875603657e94e027$var$messageChannelsQueryGql
                    });
                    const messageChannels = [
                        ...data?.messageChannels || [],
                        saveMessageChannel
                    ];
                    proxy.writeQuery({
                        query: $875603657e94e027$var$messageChannelsQueryGql,
                        data: {
                            messageChannels: messageChannels
                        }
                    });
                    navigate(formatWithBrand($e9a95c61c800ecd2$export$c8919aa069f267a, saveMessageChannel.id), {
                        replace: true
                    });
                } else $875603657e94e027$var$log.debug("saveMessageChannel update. Existing messageChannel updated", saveMessageChannel);
            }
        }).then(({ data: data })=>{
            const { saveMessageChannel: saveMessageChannel } = data || {
                saveMessageChannel: undefined
            };
            $875603657e94e027$var$log.debug("saveMessageChannelMutate resolved", saveMessageChannel);
            saveMessageChannel && formState.onSaved((0, $f6ff28847e6675c5$export$232f37f9a0fc548e)(saveMessageChannel));
        });
    };
    $875603657e94e027$var$log.debug("render", {
        params: params,
        isEditing: isEditing,
        entity: entity,
        onEdit: onEdit,
        onCancel: onCancel,
        isCreating: isCreating
    });
    const formButtons = !entity ? null : !isEditing ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        children: [
            hasPermission((0, $ca0941499cca84bb$export$2217feab9eac9873)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                text: "Edit",
                className: "",
                onClick: onEdit
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                to: formatWithBrand($e9a95c61c800ecd2$export$949c5bd8f8d67240),
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                    text: "Back to List",
                    kind: "cancel"
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        children: [
            hasPermission((0, $ca0941499cca84bb$export$2217feab9eac9873)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                text: "Save",
                onClick: onSave,
                kind: "primary"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                text: "Cancel",
                onClick: onCancel,
                kind: "cancel"
            })
        ]
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                children: [
                    "Message Channel",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        className: "inlineBlock marginLeft",
                        children: formButtons
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "message-channel"
            }),
            !entity ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "id",
                                label: "ID",
                                isDisabled: !isCreating
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "name",
                                label: "Name"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "description",
                                label: "Description",
                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).textarea
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "countryId",
                                    label: "Country",
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                    options: countries,
                                    isEditing: false
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "provider",
                                        label: "Provider"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ca1d989925ad74aa$export$809f2aa2ee781f4f), {
                        formState: formState
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: formButtons
                        })
                    })
                ]
            })
        ]
    });
};







var $fgmOP = parcelRequire("fgmOP");












const $8d68693bee8f1a18$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("MessageChannelList", "INFO");
const $8d68693bee8f1a18$export$7f22ce6766e8c06d = ({ currentUserBrand: currentUserBrand })=>{
    const { loading: loading, data: { messageChannels: messageChannels } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($db8ca951f997b45d$exports)))), {
        variables: {
            countryId: currentUserBrand?.countryId
        },
        skip: !currentUserBrand
    });
    (0, $c3440150448da8b8$export$1c72fe480f599e97)([
        {
            query: "messageChannels",
            isLoading: loading
        }
    ]);
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    $8d68693bee8f1a18$var$log.debug("render", messageChannels);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Message Channels"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "message-channels"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    size: (0, $6c2490027a2e159e$export$95dbfef2e4b1962b),
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                        to: formatWithBrand($e9a95c61c800ecd2$export$c8919aa069f267a, $e9a95c61c800ecd2$export$15f47a32373730e5),
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                            text: "Create Message Channel"
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                children: [
                    messageChannels && !messageChannels.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $98cbb91c03e56cc2$export$2e2bcd8739ae039), {
                        id: "messageChannelList",
                        children: messageChannels.map((messageChannel)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d8d7fa9fc21de820$export$2e2bcd8739ae039), {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("noPadding", "marginBottomHalfRem"),
                                link: formatWithBrand($e9a95c61c800ecd2$export$c8919aa069f267a, messageChannel.id),
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("bold"),
                                            children: messageChannel.name
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("noHover", "blackText"),
                                            children: [
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                    className: "greyText",
                                                    children: messageChannel.description ? "Description: " : "No description"
                                                }),
                                                messageChannel.description
                                            ]
                                        })
                                    ]
                                })
                            }, messageChannel.id))
                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                        children: "No message channels found"
                    }),
                    messageChannels && messageChannels.length > 10 && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            size: (0, $6c2490027a2e159e$export$95dbfef2e4b1962b),
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                                to: formatWithBrand($e9a95c61c800ecd2$export$c8919aa069f267a, $e9a95c61c800ecd2$export$15f47a32373730e5),
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    text: "Create Message Channel"
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
};


const $3b38e0598fd01d43$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Management", "INFO");
const $3b38e0598fd01d43$export$1985a9f1ec98aaa5 = ()=>{
    const { loadingUser: loadingUser, currentUserBrand: currentUserBrand, user: user, hasBrandPermission: hasBrandPermission, hasPermission: hasPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { loading: loadingPendingUsers, data: { pendingUsers: pendingUsers } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($66f5a169f8640548$exports)))), {
        fetchPolicy: "cache-first"
    });
    const { loading: loadingTeliaUsers, data: { teliaUsers: teliaUsers } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($bec02a301bb122cd$exports)))), {
        skip: !currentUserBrand,
        fetchPolicy: "cache-first"
    });
    const { loading: loadingRoles, teliaRoles: teliaRoles } = (0, $3b1b6b64a4bd4f9b$export$a884b22cb22f8e99)();
    const location = (0, $dfdceb7c36fce96f$export$45d76561a5302f2b)();
    const subPath = $e9a95c61c800ecd2$export$e8c60b88aa54a6db($e9a95c61c800ecd2$export$2793f93164573ad);
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const { loading: loadingCategories, isServiceCategoriesVisible: isServiceCategoriesVisible } = (0, $5cd44d723b4013a5$export$97aa5844287be9bb)();
    const isTeliaAdmin = (0, $fgmOP.useMemo)(()=>hasBrandPermission((0, $ca0941499cca84bb$export$619b28da925d56b7), "*"), [
        loadingTeliaUsers,
        loadingUser,
        loadingRoles,
        loadingCategories,
        user
    ]);
    $3b38e0598fd01d43$var$log.debug("render", {
        loadingTeliaUsers: loadingTeliaUsers,
        teliaUsers: teliaUsers,
        teliaRoles: teliaRoles
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7169106c226792c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $cfbdc6dab8250bcb$export$2e2bcd8739ae039), {
                    text: "Management",
                    link: formatWithBrand($e9a95c61c800ecd2$export$2793f93164573ad)
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $02b201edbdb8a3c4$export$2e2bcd8739ae039), {
                title: "Management"
            }),
            loadingTeliaUsers || loadingPendingUsers || loadingUser || loadingRoles || loadingCategories ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : !teliaUsers || teliaUsers.isEmpty() || !pendingUsers ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                children: "no admin users info"
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bbc56e5aa7afa1c4$export$729687bd6e83ee94), {
                        ariaLabel: "Management submenu",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$dced3bc93f3aa4f2),
                                text: "Overview"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$569ed52e5b30464),
                                text: "Communication"
                            }),
                            isTeliaAdmin && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$949c5bd8f8d67240),
                                text: "Message Channels"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$64c513f4bd4de646),
                                text: "Permissions & Roles"
                            }),
                            isServiceCategoriesVisible && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$eb03b2a2e7303d43),
                                text: "Service Categories"
                            }),
                            isTeliaAdmin && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$524b16a9ead1cc8f),
                                text: "SMSCs"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$9bd348b6232639d7),
                                text: "Users"
                            }),
                            isTeliaAdmin && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$84e81f0486c8c4ce),
                                text: "Pending Users",
                                badge: pendingUsers && pendingUsers.length > 0 ? pendingUsers.length : null
                            }),
                            hasPermission((0, $ca0941499cca84bb$export$c7086708a0f042bc)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$b9e9de52d0e57205),
                                text: "Smpp connections"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $b60bd97a1f982072$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $dfdceb7c36fce96f$export$3565eb3d00ca5a74), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$2793f93164573ad),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$444b3ab0cb9aec40), {
                                        replace: true,
                                        to: formatWithBrand($e9a95c61c800ecd2$export$dced3bc93f3aa4f2)
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$dced3bc93f3aa4f2),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $a80156612c540a62$export$a4c417c18d929f4e), {
                                        users: teliaUsers,
                                        pendingUsers: pendingUsers
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$569ed52e5b30464),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $604f1014b77d3c4c$export$e8de2912389971df), {})
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$c8919aa069f267a),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $abcc0b9b07b77c66$export$6533858383d32124), {
                                        isDisplayed: isTeliaAdmin,
                                        navigateTo: formatWithBrand($e9a95c61c800ecd2$export$2793f93164573ad),
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $875603657e94e027$export$e1b690120b007d19), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$949c5bd8f8d67240),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $abcc0b9b07b77c66$export$6533858383d32124), {
                                        isDisplayed: isTeliaAdmin,
                                        navigateTo: formatWithBrand($e9a95c61c800ecd2$export$2793f93164573ad),
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $8d68693bee8f1a18$export$7f22ce6766e8c06d), {
                                            currentUserBrand: currentUserBrand
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$64c513f4bd4de646),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $370e480e604885e6$export$474c02f71c38b0f), {})
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$eb03b2a2e7303d43),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $abcc0b9b07b77c66$export$6533858383d32124), {
                                        isDisplayed: isServiceCategoriesVisible,
                                        navigateTo: formatWithBrand($e9a95c61c800ecd2$export$2793f93164573ad),
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $76384f47643d68f0$export$9fd55fac4e8e45e5), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$3448398040c65777),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $abcc0b9b07b77c66$export$6533858383d32124), {
                                        isDisplayed: isTeliaAdmin,
                                        navigateTo: formatWithBrand($e9a95c61c800ecd2$export$2793f93164573ad),
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d8d3d7bc99b6855a$export$9d5619b206d0b60f), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$524b16a9ead1cc8f),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $abcc0b9b07b77c66$export$6533858383d32124), {
                                        isDisplayed: isTeliaAdmin,
                                        navigateTo: formatWithBrand($e9a95c61c800ecd2$export$2793f93164573ad),
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $fd53cb4e79751fb8$export$5bb13c0c2f329eba), {
                                            currentUserBrand: currentUserBrand
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$eaa88fbc12af3f84),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93c577777b23c9fd$export$855561da725d001b), {
                                        type: (0, $l8GLF.UserType).TELIA,
                                        roles: teliaRoles,
                                        goBackUrl: formatWithBrand($e9a95c61c800ecd2$export$9bd348b6232639d7)
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$d1f77cc09c8f389e),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$444b3ab0cb9aec40), {
                                        replace: true,
                                        to: formatWithBrand($e9a95c61c800ecd2$export$9bd348b6232639d7)
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$9bd348b6232639d7),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $839ba3e12383cc14$export$1644816dbb0b080d), {
                                        users: teliaUsers,
                                        usersBaseUrl: formatWithBrand($e9a95c61c800ecd2$export$9bd348b6232639d7)
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$84e81f0486c8c4ce),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $abcc0b9b07b77c66$export$6533858383d32124), {
                                        isDisplayed: isTeliaAdmin,
                                        navigateTo: formatWithBrand($e9a95c61c800ecd2$export$2793f93164573ad),
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $4422967deb2131e8$export$24635e21cd1f028e), {
                                            users: pendingUsers
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$80c5118692739077),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6b6c0d029eae9259$export$489f8725f8e8f4f2), {})
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$b9e9de52d0e57205),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $abcc0b9b07b77c66$export$6533858383d32124), {
                                        isDisplayed: hasPermission((0, $ca0941499cca84bb$export$c7086708a0f042bc)),
                                        navigateTo: formatWithBrand($e9a95c61c800ecd2$export$2793f93164573ad),
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba52c036a92f272c$export$9ce69eb665c9fd81), {})
                                    })
                                })
                            ]
                        })
                    }, location.pathname)
                ]
            })
        ]
    });
};






var $fgmOP = parcelRequire("fgmOP");








var $l8GLF = parcelRequire("l8GLF");
















var $8bIny = parcelRequire("8bIny");
const $0c07a1ba3934485c$export$328ce6c10aaccd73 = (address)=>{
    return (0, $8bIny.Address4).isValid(address) && address.split(".").every((section)=>+section < 256);
};
const $0c07a1ba3934485c$export$5aa8a5875c3c9e27 = (address)=>{
    const [ip, subnet] = address.split(/\/(.*)/s);
    if (ip && subnet) return $0c07a1ba3934485c$export$328ce6c10aaccd73(ip) && /^([0-9]|[1-2][0-9]|3[0-2])?$/.test(subnet);
    else return false;
};
const $0c07a1ba3934485c$export$1987372119294ebb = (address)=>!!address && ($0c07a1ba3934485c$export$328ce6c10aaccd73(address) || $0c07a1ba3934485c$export$5aa8a5875c3c9e27(address));




parcelRequire("fgmOP");


var $f6ed88ead75a24f5$exports = {};
$f6ed88ead75a24f5$exports = "mutation saveCompanyTechnical($customerId:ID!$companyTechnical:CompanyTechnicalInput!){saveCompanyTechnical(customerId:$customerId companyTechnical:$companyTechnical){...companyTechnicalFragment}}fragment companyTechnicalFragment on CompanyTechnical{ips{address description}cidrs{address description}}";


var $1b0c2c01c990203d$exports = {};
$1b0c2c01c990203d$exports = "query companyTechnical($customerId:ID!){companyTechnical(customerId:$customerId){...companyTechnicalFragment}}fragment companyTechnicalFragment on CompanyTechnical{ips{address description}cidrs{address description}}";
















const $66c9ce6797c242a3$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("CompanyTechnical", "INFO");
const $66c9ce6797c242a3$export$a0315dd7b15b1fe = ()=>{
    const { customerId: customerId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const { hasPermission: hasPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { loading: loading, data: { companyTechnical: companyTechnical } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($1b0c2c01c990203d$exports)))), {
        variables: {
            customerId: customerId
        },
        skip: !customerId
    });
    (0, $c3440150448da8b8$export$1c72fe480f599e97)([
        {
            query: "CompanyTechnical",
            isLoading: loading
        }
    ]);
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)({
        initialEntity: {
            addresses: companyTechnical ? [
                ...companyTechnical.ips,
                ...companyTechnical.cidrs
            ] : []
        },
        isEditing: false
    });
    const { isEditing: isEditing, onEdit: onEdit, onCancel: onCancel, onChange: onChange, entityAs: entityAs, putError: putError } = formState;
    const accessControlList = entityAs();
    const saveCompanyTechnical = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($f6ed88ead75a24f5$exports)))));
    const onDelete = (indexToDelete)=>onChange("addresses")([
            ...accessControlList.addresses.filter((_, index)=>indexToDelete !== index)
        ]);
    const isAddressesValid = (accessControlList)=>{
        let isValid = true;
        if (!accessControlList.addresses) accessControlList.addresses = [];
        accessControlList.addresses.forEach(({ address: address }, i)=>{
            if (!(0, $0c07a1ba3934485c$export$1987372119294ebb)(address)) {
                putError(`addresses[${i}]`, "Invalid IPv4/CIDR address");
                isValid = false;
            }
        });
        return isValid;
    };
    const onSave = async ()=>{
        $66c9ce6797c242a3$var$log.debug("onSave", {
            customerId: customerId,
            accessControlList: accessControlList
        });
        if (isAddressesValid(accessControlList)) {
            const companyTechnical = {
                ips: Array.from(new Set(accessControlList.addresses.filter(({ address: address })=>(0, $0c07a1ba3934485c$export$328ce6c10aaccd73)(address)))),
                cidrs: Array.from(new Set(accessControlList.addresses.filter(({ address: address })=>(0, $0c07a1ba3934485c$export$5aa8a5875c3c9e27)(address))))
            };
            const { data: data } = await saveCompanyTechnical({
                loadingText: "Saving Company Technical...",
                successText: "Company Technical saved",
                variables: {
                    customerId: customerId,
                    companyTechnical: companyTechnical
                }
            });
            const companyTechnicalResponse = data?.saveCompanyTechnical;
            $66c9ce6797c242a3$var$log.info("saveCompanyTechnicalMutate resolved", companyTechnicalResponse);
            companyTechnicalResponse && formState.onSaved((0, $f6ff28847e6675c5$export$232f37f9a0fc548e)({
                addresses: [
                    ...companyTechnicalResponse.ips,
                    ...companyTechnicalResponse?.cidrs
                ]
            }));
        } else (0, $4983ed7d9d06375d$export$b410431fab84fa58).error("Entered invalid IPv4/CIDR address");
    };
    $66c9ce6797c242a3$var$log.debug("render", {
        customerId: customerId,
        isEditing: isEditing,
        accessControlList: accessControlList,
        onEdit: onEdit,
        onCancel: onCancel
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: hasPermission((0, $ca0941499cca84bb$export$2c134167e4d6a0ca)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                        children: [
                            "Company Technical Configuration",
                            hasPermission((0, $ca0941499cca84bb$export$619b28da925d56b7)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("inlineBlock marginLeft"),
                                children: !isEditing ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                        text: "Edit",
                                        className: "",
                                        onClick: formState.onEdit
                                    })
                                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                            text: "Save",
                                            onClick: onSave,
                                            kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                            text: "Cancel",
                                            onClick: onCancel,
                                            kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                        page: "acl"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                                children: [
                                    "Access Control List",
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $208e3a63656dc21c$export$2e2bcd8739ae039), {
                                        text: "List of IP ranges from which requests will be sent towards SMPP endpoints"
                                    })
                                ]
                            }),
                            accessControlList?.addresses && !accessControlList.addresses.isEmpty() ? accessControlList.addresses?.map((_address, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                ...i === 0 && {
                                                    label: "IP",
                                                    tip: "Entries should be in format of IPv4 or CIDR notation"
                                                },
                                                formState: formState,
                                                entityFieldId: `addresses[${i}].address`,
                                                placeholder: "0.0.0.0",
                                                className: "company-technical__address"
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                ...i === 0 && {
                                                    label: "Description"
                                                },
                                                formState: formState,
                                                defaultValue: "",
                                                entityFieldId: `addresses[${i}].description`,
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).textarea,
                                                className: "company-technical__description"
                                            }),
                                            isEditing && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                                className: "company-technical__icon--wrapper",
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                                    icon: "trash",
                                                    onClick: ()=>{
                                                        onDelete(i);
                                                    },
                                                    className: "company-technical__icon company-technical__icon--delete"
                                                })
                                            })
                                        ]
                                    })
                                }, `address-row-${i}`)) : !isEditing && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                            label: "IP",
                                            defaultValue: "-"
                                        })
                                    })
                                })
                            }),
                            isEditing && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                            kind: "normal",
                                            text: "Add row",
                                            onClick: ()=>{
                                                onChange("addresses")([
                                                    ...accessControlList.addresses,
                                                    {
                                                        address: ""
                                                    }
                                                ]);
                                            }
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
};





parcelRequire("fgmOP");

var $5e30e863cdabb44e$exports = {};
$5e30e863cdabb44e$exports = "fragment companyFragment on Company{id countryId brandId name organizationNumber businessAddress{streetAddress postCode city country}billingAddress{streetAddress postCode city country}differentBillingAddress}";


var $4553cb84252c6436$exports = {};
$4553cb84252c6436$exports = "mutation createCustomer($customer:CustomerInput){createCustomer(customer:$customer){...customerFragment}}fragment customerFragment on Customer{id countryId brandId company{...companyFragment}users{...userFragment}contracts{...contractFragment products{...productFragment}}contacts{...contactFragment}}fragment userFragment on User{id cognitoId firstName lastName phone email description permissions type userAccessStatusType customerId comment roles rolesMap{resource roles permissions}isSSOUser mfaOptions{sms{enabled phone}app{enabled}}}fragment companyFragment on Company{id countryId brandId name organizationNumber businessAddress{streetAddress postCode city country}billingAddress{streetAddress postCode city country}differentBillingAddress}fragment contractFragment on Contract{...contractNoDatesFragment startDate endDate}fragment contractNoDatesFragment on Contract{id name type invoiceIncludeVat invoiceReference invoiceCustomerEmail invoiceAccountId h2SystemId comment}fragment productFragment on Product{id countryId brandId customerId contractId productType accessNumber accessNumberRange{from to count}rbmAgentOwner startDate endDate inheritsEndDate gracePeriodStartDate establishFee monthlyFee addressingPolicy allowedOriginatingAddresses name comment routingConfigId qosProfile{enabled maxSmsPerSecond messagePriority}features{id featureTypeId startDate endDate featureProperties{accessNumberId}}feeOverrides{feeTypeId amount}}fragment contactFragment on Contact{id name phone email comment channels}";


var $d7e62f302d8ff306$exports = {};
$d7e62f302d8ff306$exports = "mutation saveCompany($customerId:ID!$company:CompanyInput!){saveCompany(customerId:$customerId company:$company){...companyFragment}}fragment companyFragment on Company{id countryId brandId name organizationNumber businessAddress{streetAddress postCode city country}billingAddress{streetAddress postCode city country}differentBillingAddress}";













var $fgmOP = parcelRequire("fgmOP");






const $a51d31ff0f88aa5a$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("CountryAndBrandFormRow", "INFO");
const $a51d31ff0f88aa5a$export$45d4b61d19483d8a = ({ formState: formState, canEdit: canEdit = false })=>{
    const { countries: countries } = (0, $c21c461bc3365537$export$1984d0199e312f12)();
    const { getCountryBrands: getCountryBrands, brands: brands } = (0, $97a71fda4fbdc6d3$export$da3999a1d9248c0c)();
    const { isEditing: isEditing, subEntityAt: subEntityAt, onChange: onChange } = formState;
    const countryId = subEntityAt("countryId");
    const countryBrands = (0, $fgmOP.useMemo)(()=>getCountryBrands(countryId), [
        countryId,
        brands
    ]);
    $a51d31ff0f88aa5a$var$log.debug("render", {
        countryId: countryId
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                    formState: formState,
                    entityFieldId: "countryId",
                    label: "Country",
                    options: countries,
                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                    onChangeAlso: (_)=>onChange("brandId")(null),
                    isEditing: canEdit && isEditing
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                    formState: formState,
                    entityFieldId: "brandId",
                    label: "Brand",
                    options: countryBrands,
                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                    isEditing: canEdit && isEditing
                })
            ]
        })
    });
};









const $f2b7e9080d7c1c73$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Company", "INFO");
const $f2b7e9080d7c1c73$var$customerOverviewsQueryGql = (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($faa9e9ee47efa167$exports))));
const $f2b7e9080d7c1c73$export$3cd8970d6dd01fc2 = ()=>{
    const { customerId: customerId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const isCreatingCustomer = customerId === $e9a95c61c800ecd2$export$15f47a32373730e5;
    const { currentUserBrand: currentUserBrand, hasPermission: hasPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const useApolloCacheEntityProps = {
        fragment: (0, (/*@__PURE__*/$parcel$interopDefault($5e30e863cdabb44e$exports))),
        entityId: customerId,
        newEntity: {
            countryId: currentUserBrand?.countryId,
            brandId: currentUserBrand?.id,
            name: null,
            organizationNumber: null,
            businessAddress: {
                streetAddress: null,
                postCode: null,
                city: null,
                country: null
            },
            billingAddress: {
                streetAddress: null,
                postCode: null,
                city: null,
                country: null
            },
            differentBillingAddress: false
        }
    };
    const formStateOptions = (0, $cd0b9ee27a364316$export$4c2508f4134d3a42)(useApolloCacheEntityProps);
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)(formStateOptions);
    const { initialEntity: initialEntity, entity: entity, entityAs: entityAs, isEditing: isEditing, onEdit: onEdit, onCancel: onCancel, onSaved: onSaved } = formState;
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const createCustomer = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($4553cb84252c6436$exports)))));
    const saveCompany = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($d7e62f302d8ff306$exports)))));
    const onSave = async ()=>{
        $f2b7e9080d7c1c73$var$log.debug("onSave for customer", {
            customerId: customerId
        });
        if (isCreatingCustomer) {
            $f2b7e9080d7c1c73$var$log.debug("onSave needs to create the Customer entity before saving Company");
            try {
                const customerId = await createCustomer({
                    variables: {
                        customer: {
                            company: entityAs()
                        }
                    },
                    loadingText: "Creating customer...",
                    successText: "Customer created",
                    update (proxy, { data: updateData }) {
                        const { id: id, company: company, countryId: countryId, brandId: brandId } = updateData?.createCustomer;
                        const { name: name } = company || {};
                        $f2b7e9080d7c1c73$var$log.debug("createCustomer update", {
                            updateData: updateData
                        });
                        const data = proxy.readQuery({
                            query: $f2b7e9080d7c1c73$var$customerOverviewsQueryGql
                        }); //  TODO: move to useCustomerOverviews ? Agree, should be moved
                        $f2b7e9080d7c1c73$var$log.debug("createCustomer customerOverviews", data);
                        const customerOverview = {
                            __typename: "CustomerOverview",
                            id: id,
                            name: name,
                            countryId: countryId,
                            brandId: brandId,
                            productOverviews: []
                        };
                        $f2b7e9080d7c1c73$var$log.debug("createCustomer update", {
                            customerOverview: customerOverview
                        });
                        const customerOverviews = [
                            ...data?.customerOverviews || [],
                            customerOverview
                        ];
                        proxy.writeQuery({
                            query: $f2b7e9080d7c1c73$var$customerOverviewsQueryGql,
                            data: {
                                customerOverviews: customerOverviews
                            }
                        });
                    }
                }).then(({ data: data })=>{
                    $f2b7e9080d7c1c73$var$log.debug("createCustomerMutate data", data);
                    return data?.createCustomer.id;
                });
                // .catch(props.formState.onError)
                $f2b7e9080d7c1c73$var$log.debug("onSave created Customer entity, redirecting to Customers page with ID: ", customerId);
                customerId && navigate(formatWithBrand($e9a95c61c800ecd2$export$bd177ac5e923b770, customerId));
            } catch (error) {
                $f2b7e9080d7c1c73$var$log.warn(`onSave couldn't create the Customer entity`);
            }
        } else {
            $f2b7e9080d7c1c73$var$log.debug("onSave for existing customer", entity);
            saveCompany({
                variables: {
                    customerId: customerId,
                    company: entityAs()
                },
                loadingText: "Saving company...",
                successText: "Company saved",
                update (proxy, { data: data }) {
                    const { saveCompany: saveCompany } = data || {};
                    $f2b7e9080d7c1c73$var$log.debug("saveCompany update", {
                        saveCompany: saveCompany
                    });
                    if (saveCompany && saveCompany.name != initialEntity.name) {
                        $f2b7e9080d7c1c73$var$log.debug("saveCompany update change of company name, updating customerOverviews");
                        try {
                            const data = proxy.readQuery({
                                query: $f2b7e9080d7c1c73$var$customerOverviewsQueryGql
                            }); //  TODO: move to useCustomerOverviews ?
                            if (data) data.customerOverviews = data?.customerOverviews.map((c)=>c.id != customerId ? c : {
                                    ...c,
                                    name: saveCompany.name
                                });
                            proxy.writeQuery({
                                query: $f2b7e9080d7c1c73$var$customerOverviewsQueryGql,
                                data: data
                            });
                        } catch (e) {
                            $f2b7e9080d7c1c73$var$log.debug("customerOverviews not fetched yet, nothing more to update");
                        }
                    }
                }
            }).then(({ data: data })=>{
                const { saveCompany: saveCompany } = data || {
                    saveCompany: undefined
                };
                $f2b7e9080d7c1c73$var$log.debug("saveCompanyMutation resolved", saveCompany);
                saveCompany && onSaved((0, $f6ff28847e6675c5$export$232f37f9a0fc548e)(saveCompany));
                return saveCompany;
            });
        // .catch(props.formState.onError)
        }
    };
    $f2b7e9080d7c1c73$var$log.debug("render", {
        customerId: customerId,
        useApolloCacheEntityProps: useApolloCacheEntityProps,
        isEditing: isEditing,
        entity: entity,
        onEdit: onEdit,
        onCancel: onCancel
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Company"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "company"
            }),
            !entity ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $2e4c8094e1930e9a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $a51d31ff0f88aa5a$export$45d4b61d19483d8a), {
                                formState: formState,
                                canEdit: false
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                            formState: formState,
                                            entityFieldId: "name",
                                            label: "Company name"
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                            formState: formState,
                                            entityFieldId: "organizationNumber",
                                            label: "Org. number"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
                                className: "form-group",
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                                        title: "Business address"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "businessAddress.streetAddress",
                                                label: "Street address",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).textarea
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                    formState: formState,
                                                    entityFieldId: "businessAddress.postCode",
                                                    label: "Zip code"
                                                }),
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                    formState: formState,
                                                    entityFieldId: "businessAddress.city",
                                                    label: "City"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "businessAddress.country",
                                                label: "Country"
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
                                className: "form-group",
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                                        title: "Billing address"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "differentBillingAddress",
                                                label: "Different Billing address",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox
                                            })
                                        })
                                    }),
                                    entity.differentBillingAddress && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                        formState: formState,
                                                        entityFieldId: "billingAddress.streetAddress",
                                                        label: "Street address",
                                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).textarea
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                            formState: formState,
                                                            entityFieldId: "billingAddress.postCode",
                                                            label: "Zip code"
                                                        }),
                                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                            formState: formState,
                                                            entityFieldId: "billingAddress.city",
                                                            label: "City"
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                        formState: formState,
                                                        entityFieldId: "billingAddress.country",
                                                        label: "Country"
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    hasPermission((0, $ca0941499cca84bb$export$457c4eb8edaa023d)) && (!isEditing ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    onClick: onEdit,
                                    text: "edit"
                                })
                            })
                        })
                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        className: "",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                onClick: onSave,
                                text: isCreatingCustomer ? "Create" : "Save",
                                kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                onClick: onCancel,
                                text: "Cancel",
                                kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel
                            })
                        ]
                    }))
                ]
            })
        ]
    });
};






var $fgmOP = parcelRequire("fgmOP");

var $e713af6307ea36b9$exports = {};
$e713af6307ea36b9$exports = "fragment contactFragment on Contact{id name phone email comment channels}";


var $177c7bd0a3819307$exports = {};
$177c7bd0a3819307$exports = "mutation deleteContact($customerId:ID!$contactId:ID!){deleteContact(customerId:$customerId contactId:$contactId)}";


var $a71675a801324abf$exports = {};
$a71675a801324abf$exports = "mutation saveContact($customerId:ID!$contact:ContactInput!){saveContact(customerId:$customerId contact:$contact){...contactFragment}}fragment contactFragment on Contact{id name phone email comment channels}";


















const $b4e6dbee66d99acf$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Contact", "INFO");
const $b4e6dbee66d99acf$var$customerQueryGql = (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($dad67faa2a055d78$exports))));
const $b4e6dbee66d99acf$export$cf103e4e7d1d9b7b = (props)=>{
    const { contactId: contactId, customerId: customerId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const formStateOptions = (0, $cd0b9ee27a364316$export$4c2508f4134d3a42)({
        entityId: contactId,
        fragment: (0, (/*@__PURE__*/$parcel$interopDefault($e713af6307ea36b9$exports))),
        newEntity: {}
    });
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)(formStateOptions);
    const { isEditing: isEditing, entity: entity, findError: findError, onEdit: onEdit, onCancel: onCancel, onChange: onChange, initialEntity: initialEntity } = formState;
    const { hasAnyPermission: hasAnyPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { showModal: showModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const saveContact = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($a71675a801324abf$exports)))));
    const onSave = ()=>{
        const contact = formState.entityAs();
        $b4e6dbee66d99acf$var$log.debug("onSave", {
            contact: contact,
            customerId: customerId
        });
        saveContact({
            loadingText: "Saving contact...",
            successText: "Contact saved",
            variables: {
                contact: {
                    ...contact
                },
                customerId: customerId
            },
            update: (proxy, { data: data })=>{
                const { saveContact: saveContact } = data || {};
                $b4e6dbee66d99acf$var$log.debug("saveContactMutation update", saveContact);
                if (saveContact && !formState.entity.id) {
                    //  create new contact
                    const data = proxy.readQuery({
                        query: $b4e6dbee66d99acf$var$customerQueryGql,
                        variables: {
                            customerId: customerId
                        }
                    });
                    data?.customer?.contacts?.push(saveContact);
                    $b4e6dbee66d99acf$var$log.debug("data", data);
                    proxy.writeQuery({
                        query: $b4e6dbee66d99acf$var$customerQueryGql,
                        data: data
                    });
                    navigate(formatWithBrand($e9a95c61c800ecd2$export$ddfcfcdd7c33e729, customerId, saveContact.id), {
                        replace: true
                    });
                }
            }
        }).then(({ data: data })=>{
            const { saveContact: saveContact } = data || {
                saveContact: undefined
            };
            $b4e6dbee66d99acf$var$log.debug("saveContact resolved", saveContact);
            saveContact && formState.onSaved((0, $f6ff28847e6675c5$export$232f37f9a0fc548e)(saveContact));
            return saveContact;
        });
    };
    const deleteContact = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($177c7bd0a3819307$exports)))));
    const onConfirmDelete = ()=>{
        $b4e6dbee66d99acf$var$log.debug("onConfirmDelete", {
            contactId: contactId
        });
        deleteContact({
            loadingText: "Deleting contact...",
            successText: "Contact deleted",
            variables: {
                contactId: contactId,
                customerId: customerId
            },
            update: (proxy, { data: data })=>{
                const { deleteContact: contactId } = data || {};
                $b4e6dbee66d99acf$var$log.debug("deleteContactMutation update", contactId);
                const customerData = proxy.readQuery({
                    query: $b4e6dbee66d99acf$var$customerQueryGql,
                    variables: {
                        customerId: customerId
                    }
                }) || undefined;
                if (customerData) {
                    customerData.customer.contacts = customerData.customer.contacts?.filter((contact)=>contact.id !== contactId);
                    proxy.writeQuery({
                        query: $b4e6dbee66d99acf$var$customerQueryGql,
                        data: customerData
                    });
                }
            }
        }).then(({ data: data })=>{
            const { deleteContact: deleteContact } = data || {
                deleteContact: undefined
            };
            $b4e6dbee66d99acf$var$log.debug("deleteContact resolved", deleteContact);
            navigate(formatWithBrand($e9a95c61c800ecd2$export$6d02b57a0acc5177, customerId), {
                replace: true
            });
        });
    };
    const onDelete = ()=>{
        $b4e6dbee66d99acf$var$log.debug("onDelete");
        showModal({
            title: "Delete communication contact",
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                children: `Are you sure you want to delete communication contact '${entity.name}'?`
            }),
            confirmType: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.negative,
            confirmText: "Delete",
            onConfirm: onConfirmDelete
        });
    };
    $b4e6dbee66d99acf$var$log.debug("render", {
        formState: formState,
        contactId: contactId
    });
    const channelOptions = props.channels || [];
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Communication contact"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "contact"
            }),
            !entity ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $2e4c8094e1930e9a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "name",
                                label: "Name"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "email",
                                label: "Email"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "phone",
                                label: "Mobile"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "channels",
                                label: "Contact type",
                                options: channelOptions,
                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "comment",
                                label: "Comment",
                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).textarea
                            })
                        })
                    }),
                    !isEditing ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        children: [
                            hasAnyPermission((0, $ca0941499cca84bb$export$619b28da925d56b7), (0, $ca0941499cca84bb$export$9687129cd10e92bc)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                        text: "Edit",
                                        onClick: onEdit
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                        text: "Delete",
                                        onClick: onDelete,
                                        kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.negative
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                                to: formatWithBrand($e9a95c61c800ecd2$export$6d02b57a0acc5177, customerId),
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    text: "Back to Contacts",
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                text: "Save",
                                onClick: onSave,
                                kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                text: "Cancel",
                                onClick: onCancel,
                                kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel
                            })
                        ]
                    })
                ]
            })
        ]
    });
};




parcelRequire("fgmOP");












const $755293202d7f8111$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Contacts", "INFO");
const $755293202d7f8111$export$627675a7dce038ce = ({ channels: channels, contacts: contacts })=>{
    const { customerId: customerId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const { hasPermission: hasPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    $755293202d7f8111$var$log.debug("props", {
        channels: channels,
        contacts: contacts
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                    subtitle: "Communication contacts"
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                    page: "contacts"
                }),
                contacts && !contacts.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $98cbb91c03e56cc2$export$2e2bcd8739ae039), {
                    id: "contactesList",
                    children: contacts.map((contact)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $d8d7fa9fc21de820$export$2e2bcd8739ae039), {
                            id: (0, $0857d9353dc337e9$export$d5d25c90fc92fce5)(contact.id, "contact"),
                            link: formatWithBrand($e9a95c61c800ecd2$export$ddfcfcdd7c33e729, customerId, contact.id),
                            children: [
                                contact.name ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                    className: "bold",
                                    children: contact.name
                                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                    className: "bold missing",
                                    children: "no name"
                                }),
                                contact.email && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                            className: "longLabelPrefix",
                                            children: "Email "
                                        }),
                                        " ",
                                        contact.email
                                    ]
                                }),
                                contact.phone && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                            className: "longLabelPrefix",
                                            children: "Phone "
                                        }),
                                        " ",
                                        contact.phone
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                            className: "longLabelPrefix",
                                            children: "Contact type "
                                        }),
                                        " ",
                                        contact.channels && !contact.channels.isEmpty() ? channels?.filter(({ id: id })=>contact.channels?.includes(id)).map(({ name: name })=>name).join(", ") : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                            className: "redText",
                                            children: "No subjects!"
                                        })
                                    ]
                                }),
                                contact.comment && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                            className: "longLabelPrefix",
                                            children: "Comment "
                                        }),
                                        " ",
                                        contact.comment
                                    ]
                                })
                            ]
                        }, contact.id))
                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                    children: "No communication contacts found"
                }),
                hasPermission((0, $ca0941499cca84bb$export$9687129cd10e92bc)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                    id: "createContact",
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                        to: formatWithBrand($e9a95c61c800ecd2$export$ddfcfcdd7c33e729, customerId, $e9a95c61c800ecd2$export$15f47a32373730e5),
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                            text: "Create communication contact"
                        })
                    })
                })
            ]
        })
    });
};








var $fgmOP = parcelRequire("fgmOP");


var $0ac2f8c89404434d$exports = {};
$0ac2f8c89404434d$exports = "fragment contractFragment on Contract{...contractNoDatesFragment startDate endDate}fragment contractNoDatesFragment on Contract{id name type invoiceIncludeVat invoiceReference invoiceCustomerEmail invoiceAccountId h2SystemId comment}";


var $8ec1d9826f9ab86b$exports = {};
$8ec1d9826f9ab86b$exports = "mutation saveContract($customerId:String!$contract:ContractInput!){saveContract(customerId:$customerId contract:$contract){...contractFragment}}fragment contractFragment on Contract{...contractNoDatesFragment startDate endDate}fragment contractNoDatesFragment on Contract{id name type invoiceIncludeVat invoiceReference invoiceCustomerEmail invoiceAccountId h2SystemId comment}";


























var $iEMYl = parcelRequire("iEMYl");



var $fgmOP = parcelRequire("fgmOP");




const $112a7c90a6dc0b9c$export$b90441f04b7a6203 = ()=>{
    const hasProductFeatures = (product)=>{
        return !!product.features;
    };
    const extractAccessNumbers = (product)=>{
        if (!product.features) return [];
        return product.features.reduce((accessNumbers, { featureProperties: featureProperties })=>featureProperties?.accessNumberId ? [
                ...accessNumbers,
                featureProperties.accessNumberId
            ] : accessNumbers, []);
    };
    const getFeature = (product, id)=>{
        return product.features?.find((feature)=>feature.id === id);
    };
    return {
        hasProductFeatures: hasProductFeatures,
        extractAccessNumbers: extractAccessNumbers,
        getFeature: getFeature
    };
};




var $fgmOP = parcelRequire("fgmOP");


const $24ef8762983c02cb$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useProductOverviews", "INFO");
const $24ef8762983c02cb$export$4c0ac5f906c0b8d6 = ()=>{
    const { loading: loading, customerOverviews: customerOverviews } = (0, $8d8d8b3d38044bbe$export$d27d8317adc3c298)();
    const { isReservedOaOverview: isReservedOaOverview } = (0, $fd8c6dbb137f29e9$export$c7485df156f0670e)();
    const productOverviewMap = (0, $fgmOP.useMemo)(()=>customerOverviews && customerOverviews.flatMap(({ productOverviews: productOverviews, name: name })=>[
                productOverviews?.map((overview)=>({
                        ...overview,
                        companyName: name
                    }))
            ]).flatMap((overviews)=>overviews).filter((overview)=>overview).reduce((map, overview)=>({
                ...map,
                [`${overview.productId}`]: overview
            }), {}) || {}, [
        customerOverviews
    ]);
    const getProductOverview = (productId)=>productOverviewMap[productId];
    const getCustomerIdByProductId = (0, $fgmOP.useCallback)((productId)=>loading ? "loading..." : getProductOverview(productId)?.customerId, [
        loading
    ]);
    const getCompanyNameByProductId = (0, $fgmOP.useCallback)((productId)=>loading ? "loading..." : getProductOverview(productId)?.companyName, [
        loading
    ]);
    const getAccessNumberByProductId = (0, $fgmOP.useCallback)((productId)=>loading ? "loading..." : getProductOverview(productId)?.accessNumber, [
        loading
    ]);
    const getReservedOasByProductId = (0, $fgmOP.useCallback)((productId)=>loading ? "loading..." : getProductOverview(productId)?.reservedOas?.join(", "), [
        loading
    ]);
    const getReservedOaProductsOverview = ()=>Object.values(productOverviewMap).filter((productOverview)=>isReservedOaOverview(productOverview) && productOverview.reservedOas && productOverview.reservedOas.length > 0);
    const useProductOverviewsHook = {
        loading: loading,
        getProductOverview: getProductOverview,
        getReservedOaProductsOverview: getReservedOaProductsOverview,
        getCustomerIdByProductId: getCustomerIdByProductId,
        getCompanyNameByProductId: getCompanyNameByProductId,
        getAccessNumberByProductId: getAccessNumberByProductId,
        getReservedOasByProductId: getReservedOasByProductId
    };
    $24ef8762983c02cb$var$log.debug(productOverviewMap);
    return useProductOverviewsHook;
};



const $1889e1147019478d$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useFormattedText", "INFO");
const $1889e1147019478d$export$edbfa4c6d5f6410c = ()=>{
    const { getReservedOasByProductId: getReservedOasByProductId } = (0, $24ef8762983c02cb$export$4c0ac5f906c0b8d6)();
    const { canReserveOa: canReserveOa, usesRbmAgentOwner: usesRbmAgentOwner } = (0, $98effcf86fafb9fb$export$75025970e7082eca)();
    const { hasProductFeatures: hasProductFeatures, extractAccessNumbers: extractAccessNumbers } = (0, $112a7c90a6dc0b9c$export$b90441f04b7a6203)();
    const accessNumberOrRange = (obj)=>obj.accessNumber ? obj.accessNumber : obj.accessNumberRange ? `${obj.accessNumberRange?.from}-${obj.accessNumberRange?.to} (${obj.accessNumberRange?.count})` : "No access Number";
    const productSubject = (product)=>{
        return usesRbmAgentOwner(product.productType) ? product.rbmAgentOwner || "" : canReserveOa(product.productType) ? getReservedOasByProductId(product.id) || "" : hasProductFeatures(product) ? `Access Numbers (${extractAccessNumbers(product).length})` : accessNumberOrRange(product);
    };
    return {
        accessNumberOrRange: accessNumberOrRange,
        productSubject: productSubject
    };
};






const $afa3ff43d46630b5$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ServicesTable", "INFO");
const $afa3ff43d46630b5$export$750ab9746aa75e91 = (props)=>{
    const { contracts: contracts } = props;
    const { getEstablishFee: getEstablishFee, getMonthlyFee: getMonthlyFee, getName: getName } = (0, $98effcf86fafb9fb$export$75025970e7082eca)();
    const { productSubject: productSubject } = (0, $1889e1147019478d$export$edbfa4c6d5f6410c)();
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const { customerId: customerId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    $afa3ff43d46630b5$var$log.debug("render", {
        contracts: contracts
    });
    const tableContent = (0, $fgmOP.useMemo)(()=>contracts.flatMap(({ id: id, name: name, startDate: startDate, endDate: endDate, products: products })=>{
            const enrichedContract = {
                isContract: true,
                productType: "Contract " + id,
                contractId: id,
                subject: name || "",
                startDate: startDate || "",
                endDate: endDate || "",
                activeStatus: (0, $iEMYl.activeStatus)({
                    startDate: startDate,
                    endDate: endDate
                })
            };
            const enrichedProducts = products.map((product)=>({
                    ...product,
                    isContract: false,
                    productId: product.id,
                    productType: getName(product.productType),
                    subject: productSubject(product),
                    establishFee: product.establishFee !== undefined && product.establishFee !== null ? product.establishFee : getEstablishFee(product.productType),
                    monthlyFee: product.monthlyFee !== undefined && product.monthlyFee !== null ? product.monthlyFee : getMonthlyFee(product.productType),
                    activeStatus: (0, $iEMYl.activeStatus)(product)
                }));
            return contracts.length > 1 ? [
                enrichedContract,
                ...enrichedProducts
            ] : enrichedProducts;
        }), [
        contracts,
        getName,
        productSubject,
        getEstablishFee,
        getMonthlyFee,
        (0, $iEMYl.activeStatus)
    ]);
    const [sortedTableContent, getThSortableProps] = (0, $c1364c3d18563e9b$export$2e2bcd8739ae039).useThSortable(tableContent, 3, [], {});
    $afa3ff43d46630b5$var$log.debug("sortedTableContent", {
        sortedTableContent: sortedTableContent
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
        children: contracts && !contracts.isEmpty() && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039), {
            clickable: false,
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).THead, {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Tr, {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                ...getThSortableProps("productType"),
                                children: "Service Type"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                ...getThSortableProps("subject"),
                                children: "Subject"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Th, {
                                className: "table__cell--min-width marginRight",
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $acf38b6c25932409$export$2e2bcd8739ae039), {
                                    text: `Display service's comment if available`
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                ...getThSortableProps("establishFee"),
                                children: "Establish Fee"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                ...getThSortableProps("monthlyFee"),
                                children: "Monthly Fee"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                ...getThSortableProps("startDate"),
                                children: "Start date"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                ...getThSortableProps("endDate"),
                                children: "End date"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                ...getThSortableProps("activeStatus"),
                                children: "Active Status"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).TBody, {
                    children: sortedTableContent.map(({ isContract: isContract, contractId: contractId, productId: productId, productType: productType, subject: subject, comment: comment, establishFee: establishFee, monthlyFee: monthlyFee, startDate: startDate, endDate: endDate, activeStatus: activeStatus }, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Tr, {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                inactive: activeStatus !== "ACTIVE"
                            }, "pointer"),
                            onClick: ()=>navigate(isContract ? formatWithBrand($e9a95c61c800ecd2$export$57a19d7397b7cbfa, customerId, contractId) : formatWithBrand($e9a95c61c800ecd2$export$dc7ad6b828d74f36, customerId, contractId, productId)),
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                    children: isContract ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                                        className: "bold",
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                                icon: "business",
                                                className: "vertical-align-bottom"
                                            }),
                                            " ",
                                            productType
                                        ]
                                    }) : productType
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                    children: subject
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                    className: "table__cell--min-width",
                                    children: comment && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $acf38b6c25932409$export$2e2bcd8739ae039), {
                                        text: comment
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                    children: (0, $f5d0c2a7498ff49b$exports.format).integer(establishFee)
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                    children: (0, $f5d0c2a7498ff49b$exports.format).integer(monthlyFee)
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                        disabled: !startDate
                                    }),
                                    children: startDate ? (0, $f5d0c2a7498ff49b$exports.format).date(startDate) : "no start"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                        disabled: !endDate
                                    }),
                                    children: endDate ? (0, $f5d0c2a7498ff49b$exports.format).date(endDate) : "no end"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))(activeStatus.toLowerCase() + "Period"),
                                    children: activeStatus
                                })
                            ]
                        }, i))
                })
            ]
        })
    });
};


const { contractTypes: $76411173383b38d2$var$contractTypes, EXTERNAL_CONTRACT_TYPE: $76411173383b38d2$var$EXTERNAL_CONTRACT_TYPE, INTERNAL_CONTRACT_TYPE: $76411173383b38d2$var$INTERNAL_CONTRACT_TYPE } = (0, $f5d0c2a7498ff49b$exports.constants);
const $76411173383b38d2$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Contract", "INFO");
const $76411173383b38d2$var$customerQueryGql = (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($dad67faa2a055d78$exports))));
const $76411173383b38d2$export$da3bb712330cc125 = (props)=>{
    const { contracts: contracts, refetchCustomer: refetchCustomer } = props;
    const { customerId: customerId, contractId: contractId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const contract = contracts?.find(({ id: id })=>id === contractId);
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const { hasPermission: hasPermission, currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { showInactiveComponent: showInactiveComponent } = (0, $152b6193e99b7439$export$84f600a904db3b68)();
    const { showModal: showModal, hideModal: hideModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const { getName: getName, canReserveOa: canReserveOa } = (0, $98effcf86fafb9fb$export$75025970e7082eca)();
    const formFragmentOptions = {
        fragment: (0, (/*@__PURE__*/$parcel$interopDefault($0ac2f8c89404434d$exports))),
        entityId: contractId,
        newEntity: {
            name: null,
            startDate: null,
            endDate: null,
            type: "EXTERNAL",
            invoiceReference: null,
            invoiceAccountId: null,
            invoiceIncludeVat: true,
            comment: null
        }
    };
    const formStateOptions = (0, $cd0b9ee27a364316$export$4c2508f4134d3a42)(formFragmentOptions);
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)(formStateOptions);
    const { entityAs: entityAs, initialEntity: initialEntity, entity: entity, isEditing: isEditing, onEdit: onEdit, onCancel: onCancel, onChange: onChange } = formState;
    const contact = formState.entityAs();
    const showExternalFields = contact.type === $76411173383b38d2$var$EXTERNAL_CONTRACT_TYPE;
    const showInternalFields = contact.type === $76411173383b38d2$var$INTERNAL_CONTRACT_TYPE;
    const saveContract = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($8ec1d9826f9ab86b$exports)))));
    const onSave = ()=>{
        const { name: contractName, endDate: finalEndDate } = entityAs();
        const initialEndDate = initialEntity.endDate;
        const inheritsEndDateProducts = contract?.products?.filter(({ inheritsEndDate: inheritsEndDate, endDate: productEndDate })=>inheritsEndDate || !initialEndDate && !productEndDate) || [];
        if (initialEndDate === finalEndDate || inheritsEndDateProducts.isEmpty()) onConfirmSave();
        else showModal({
            title: "Update Contract End Date",
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("p", {
                        children: [
                            "Are you sure you want to update the ",
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("b", {
                                children: contractName && `'${contractName}'`
                            }),
                            " contract's end date?"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                        children: "This will also adjust the end date of the following services:"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $98cbb91c03e56cc2$export$2e2bcd8739ae039), {
                        children: inheritsEndDateProducts.map(({ id: productId, productType: productType })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d8d7fa9fc21de820$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                                            children: [
                                                getName(productType),
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                                            children: [
                                                " (id: ",
                                                productId,
                                                ")"
                                            ]
                                        })
                                    ]
                                })
                            }, productId))
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                        children: " These services will NOT be able to send messages after the end date has passed."
                    })
                ]
            }),
            typeToConfirmText: "update",
            confirmText: "Update",
            confirmType: "primary",
            onConfirm: ()=>onConfirmSave()
        });
    };
    const onConfirmSave = ()=>{
        $76411173383b38d2$var$log.debug("onSave", {
            customerId: customerId,
            entity: entity
        });
        saveContract({
            loadingText: "Saving contract...",
            successText: "Contract saved",
            variables: {
                customerId: customerId,
                contract: entityAs()
            },
            update: (proxy, { data: updateData })=>{
                const { saveContract: saveContract } = updateData || {};
                if (!saveContract) return;
                if (initialEntity.id) {
                    //  Contract already existed
                    $76411173383b38d2$var$log.debug("saveContractMutate update. Existing contract updated", saveContract);
                    if (initialEntity.endDate !== saveContract.endDate) {
                        $76411173383b38d2$var$log.warn("Contract end date has been modified. Services end date might have been adjusted. Re-fetching customer...");
                        refetchCustomer();
                        contract?.products.some(({ productType: productType })=>canReserveOa(productType)) && proxy.evict({
                            id: "ROOT_QUERY",
                            fieldName: "reservedOas",
                            args: {
                                countryId: currentUserBrand?.countryId
                            }
                        });
                    }
                } else {
                    $76411173383b38d2$var$log.debug("saveContractMutate update. New contract created", saveContract);
                    const data = proxy.readQuery({
                        query: $76411173383b38d2$var$customerQueryGql,
                        variables: {
                            customerId: customerId
                        }
                    });
                    if (!data) throw new Error(`Couldn't get Customer from Apollo Cache`);
                    $76411173383b38d2$var$log.debug("saveContractMutate update. Customer query data", (0, (/*@__PURE__*/$parcel$interopDefault($4a7c720bc23270cb$exports))).inspect(data));
                    const contracts = [
                        ...data.customer.contracts || [],
                        {
                            ...saveContract,
                            products: []
                        }
                    ];
                    $76411173383b38d2$var$log.debug("saveContractMutate update. Contracts", contracts);
                    proxy.writeQuery({
                        query: $76411173383b38d2$var$customerQueryGql,
                        data: {
                            customer: {
                                ...data.customer,
                                contracts: contracts
                            }
                        }
                    });
                    navigate(formatWithBrand($e9a95c61c800ecd2$export$57a19d7397b7cbfa, customerId, saveContract.id), {
                        replace: true
                    });
                }
            }
        }).then(({ data: data })=>{
            const { saveContract: saveContract } = data || {
                saveContract: undefined
            };
            $76411173383b38d2$var$log.debug("saveContractMutate resolved", saveContract);
            saveContract && formState.onSaved((0, $f6ff28847e6675c5$export$232f37f9a0fc548e)(saveContract));
            return saveContract;
        });
    };
    $76411173383b38d2$var$log.debug("render", props);
    const formButtons = (inPageSubtitle)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                "inlineBlock marginLeft": inPageSubtitle
            }),
            children: !isEditing ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                children: hasPermission((0, $ca0941499cca84bb$export$d6141afe674cb67b)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                    text: "Edit",
                    onClick: onEdit
                })
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                        text: "Save",
                        onClick: onSave,
                        kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                        text: "Cancel",
                        onClick: onCancel,
                        kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel
                    })
                ]
            })
        });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                children: [
                    "Contract",
                    formButtons(true)
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "contract"
            }),
            !entity ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                children: "No form entity info"
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $2e4c8094e1930e9a$export$2e2bcd8739ae039), {
                onSubmit: (e)=>{
                    $76411173383b38d2$var$log.debug("onSubmit");
                    entity.messageId && navigate(formatWithBrand($e9a95c61c800ecd2$export$164d2bdecc76515, entity.messageId), {
                        replace: true
                    });
                },
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "id",
                                    label: "Contract ID",
                                    isEditing: false
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "name",
                                    label: "Name"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "startDate",
                                    label: "Start date",
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "endDate",
                                    label: "End date",
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date,
                                    defaultValue: "no end"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                label: "Active Status",
                                value: (0, $f5d0c2a7498ff49b$exports.period).activeStatus(entity),
                                valueClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))((0, $f5d0c2a7498ff49b$exports.period).activeStatus(entity).toLowerCase() + "Period")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
                        className: "entity-group",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                                title: "Invoicing"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "type",
                                        label: "Contract type",
                                        options: $76411173383b38d2$var$contractTypes,
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                        tip: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("ul", {
                                            children: [
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                            className: "bold",
                                                            children: $76411173383b38d2$var$EXTERNAL_CONTRACT_TYPE
                                                        }),
                                                        " contract which will be invoiced"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("li", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                            className: "bold",
                                                            children: $76411173383b38d2$var$INTERNAL_CONTRACT_TYPE
                                                        }),
                                                        " contract do NOT get invoiced"
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            showExternalFields && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                    formState: formState,
                                                    entityFieldId: "invoiceReference",
                                                    label: "Customer invoice ref.",
                                                    onChange: onChange("invoiceReference")
                                                }),
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                    formState: formState,
                                                    entityFieldId: "invoiceAccountId",
                                                    label: "Invoice account ID",
                                                    onChange: onChange("invoiceAccountId")
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "invoiceCustomerEmail",
                                                label: "Invoice e-mail address",
                                                onChange: onChange("invoiceCustomerEmail")
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                    children: [
                                        showExternalFields && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                            formState: formState,
                                            entityFieldId: "invoiceIncludeVat",
                                            label: "Include VAT",
                                            onChange: onChange("invoiceIncludeVat"),
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox
                                        }),
                                        showInternalFields && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                            formState: formState,
                                            entityFieldId: "h2SystemId",
                                            label: "H2 System ID",
                                            onChange: onChange("h2SystemId"),
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).input
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "comment",
                                label: "Comment",
                                onChange: onChange("comment"),
                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).textarea
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: formButtons()
                        })
                    })
                ]
            }),
            contract && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("hr", {}),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                        subtitle: `Contract's services`
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                size: (0, $6c2490027a2e159e$export$95dbfef2e4b1962b),
                                children: showInactiveComponent
                            }),
                            hasPermission((0, $ca0941499cca84bb$export$3dd817f0ec35d602)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                size: (0, $6c2490027a2e159e$export$95dbfef2e4b1962b),
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                                        to: formatWithBrand($e9a95c61c800ecd2$export$2a4a027f8fef3234, customerId, contractId),
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                            text: "Create service"
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        children: contract.products && !contract.products.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $afa3ff43d46630b5$export$750ab9746aa75e91), {
                                contracts: [
                                    contract
                                ]
                            })
                        }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                            children: "No services found"
                        })
                    })
                ]
            })
        ]
    });
};







var $fgmOP = parcelRequire("fgmOP");


var $9qR8M = parcelRequire("9qR8M");














const { isActive: $5c6c94830b43772e$var$isActive, isExpired: $5c6c94830b43772e$var$isExpired, isFuture: $5c6c94830b43772e$var$isFuture, isValid: $5c6c94830b43772e$var$isValid } = (0, $f5d0c2a7498ff49b$exports.period);
const $5c6c94830b43772e$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Contracts", "INFO");
const $5c6c94830b43772e$export$b280440818570a28 = ({ customerId: customerId, contracts: unfilteredContracts })=>{
    const { hasPermission: hasPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const { showInactiveComponent: showInactiveComponent, showInactive: showInactive } = (0, $152b6193e99b7439$export$84f600a904db3b68)();
    const contracts = (0, $fgmOP.useMemo)(()=>unfilteredContracts?.filter((contract)=>showInactive || $5c6c94830b43772e$var$isActive(contract)), [
        unfilteredContracts,
        showInactive
    ]);
    $5c6c94830b43772e$var$log.debug("props", {
        customerId: customerId,
        unfilteredContracts: unfilteredContracts,
        contracts: contracts
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                    subtitle: "Contracts"
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                    page: "contracts"
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                        children: showInactiveComponent
                    })
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                    children: contracts && !contracts.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $98cbb91c03e56cc2$export$2e2bcd8739ae039), {
                        id: "contractList",
                        children: contracts.map((contract)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $d8d7fa9fc21de820$export$2e2bcd8739ae039), {
                                id: (0, $0857d9353dc337e9$export$d5d25c90fc92fce5)(contract.id, "contract"),
                                link: formatWithBrand($e9a95c61c800ecd2$export$57a19d7397b7cbfa, customerId, contract.id),
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                    inactive: !$5c6c94830b43772e$var$isActive(contract)
                                }),
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                            className: "bold",
                                            children: (0, $f5d0c2a7498ff49b$exports.format).contractDisplayName(contract)
                                        })
                                    }),
                                    !$5c6c94830b43772e$var$isValid(contract) ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                className: "redText",
                                                children: "Invalid contract dates "
                                            }),
                                            "Start: ",
                                            contract.startDate,
                                            " - End:",
                                            " ",
                                            contract.endDate
                                        ]
                                    }) : $5c6c94830b43772e$var$isExpired(contract) ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                className: "labelPrefix",
                                                children: "Ended "
                                            }),
                                            (0, (/*@__PURE__*/$parcel$interopDefault($9qR8M))).ago(contract.endDate)
                                        ]
                                    }) : $5c6c94830b43772e$var$isFuture(contract) ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                className: "labelPrefix",
                                                children: "Starts "
                                            }),
                                            (0, (/*@__PURE__*/$parcel$interopDefault($9qR8M))).ago(contract.startDate)
                                        ]
                                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                className: "labelPrefix",
                                                children: "Started "
                                            }),
                                            (0, (/*@__PURE__*/$parcel$interopDefault($9qR8M))).ago(contract.startDate),
                                            contract.endDate ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                        className: "greyText",
                                                        children: " ends "
                                                    }),
                                                    (0, (/*@__PURE__*/$parcel$interopDefault($9qR8M))).ago(contract.endDate)
                                                ]
                                            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                className: "greyText",
                                                children: " no end "
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                className: "labelPrefix",
                                                children: "Services"
                                            }),
                                            contract.products.length,
                                            " service",
                                            contract.products.length === 1 ? "" : "s"
                                        ]
                                    })
                                ]
                            }, contract.id))
                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                        children: "No contracts found"
                    })
                }),
                hasPermission((0, $ca0941499cca84bb$export$d6141afe674cb67b)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                    id: "createContract",
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                        to: formatWithBrand($e9a95c61c800ecd2$export$e66d5a68f99a70f0, customerId),
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                            text: "Create contract"
                        })
                    })
                })
            ]
        })
    });
};





parcelRequire("fgmOP");

var $7c56a23b568b6925$exports = {};
$7c56a23b568b6925$exports = "query settlements($customerId:ID$year:Int$month:Int$contractType:ContractTypeEnum){settlements(customerId:$customerId year:$year month:$month contractType:$contractType){...settlementFragment}}fragment settlementFragment on Settlement{date id state stateAction{action comment}yearMonth currencyCode isComplete customer{...customerMinimalFragment}contract{...contractNoDatesFragment}summary{...settlementSummaryFragment}productTypeSummaries{...settlementProductTypeSummaryFragment}adjustments{comment price feeCategory{productTypeId feeId}}productDetails{productDetailId productId productTypeId total fees{...productFeeFragment}}}fragment contractNoDatesFragment on Contract{id name type invoiceIncludeVat invoiceReference invoiceCustomerEmail invoiceAccountId h2SystemId comment}fragment customerMinimalFragment on Customer{id company{id name organizationNumber countryId brandId}}fragment settlementSummaryFragment on SettlementSummary{settlementTotal adjustmentTotal totalExclVat vat vatPercentage totalInclVat}fragment settlementProductTypeSummaryFragment on SettlementProductTypeSummary{productTypeId fees{...productFeeFragment}total}fragment productFeeFragment on ProductFee{feeId type quantity fee total}fragment productFeeFragment on ProductFee{feeId type quantity fee total}";
















var $fgmOP = parcelRequire("fgmOP");
var $0fe803a534c2ebd1$exports = {};
$0fe803a534c2ebd1$exports = "query settlement($id:ID!$customerId:ID){settlement(id:$id customerId:$customerId){...settlementFragment}}fragment settlementFragment on Settlement{date id state stateAction{action comment}yearMonth currencyCode isComplete customer{...customerMinimalFragment}contract{...contractNoDatesFragment}summary{...settlementSummaryFragment}productTypeSummaries{...settlementProductTypeSummaryFragment}adjustments{comment price feeCategory{productTypeId feeId}}productDetails{productDetailId productId productTypeId total fees{...productFeeFragment}}}fragment contractNoDatesFragment on Contract{id name type invoiceIncludeVat invoiceReference invoiceCustomerEmail invoiceAccountId h2SystemId comment}fragment customerMinimalFragment on Customer{id company{id name organizationNumber countryId brandId}}fragment settlementSummaryFragment on SettlementSummary{settlementTotal adjustmentTotal totalExclVat vat vatPercentage totalInclVat}fragment settlementProductTypeSummaryFragment on SettlementProductTypeSummary{productTypeId fees{...productFeeFragment}total}fragment productFeeFragment on ProductFee{feeId type quantity fee total}fragment productFeeFragment on ProductFee{feeId type quantity fee total}";













var $87bf0 = parcelRequire("87bf0");

var $fgmOP = parcelRequire("fgmOP");
var $2104f7470a335007$exports = {};
$2104f7470a335007$exports = "mutation adjustSettlement($id:ID!$adjustments:[AdjustmentInput]!){adjustSettlement(id:$id adjustments:$adjustments){...settlementFragment}}fragment settlementFragment on Settlement{date id state stateAction{action comment}yearMonth currencyCode isComplete customer{...customerMinimalFragment}contract{...contractNoDatesFragment}summary{...settlementSummaryFragment}productTypeSummaries{...settlementProductTypeSummaryFragment}adjustments{comment price feeCategory{productTypeId feeId}}productDetails{productDetailId productId productTypeId total fees{...productFeeFragment}}}fragment contractNoDatesFragment on Contract{id name type invoiceIncludeVat invoiceReference invoiceCustomerEmail invoiceAccountId h2SystemId comment}fragment customerMinimalFragment on Customer{id company{id name organizationNumber countryId brandId}}fragment settlementSummaryFragment on SettlementSummary{settlementTotal adjustmentTotal totalExclVat vat vatPercentage totalInclVat}fragment settlementProductTypeSummaryFragment on SettlementProductTypeSummary{productTypeId fees{...productFeeFragment}total}fragment productFeeFragment on ProductFee{feeId type quantity fee total}fragment productFeeFragment on ProductFee{feeId type quantity fee total}";





var $b56b72c9c87b1dc9$exports = {};
$b56b72c9c87b1dc9$exports = "query feeTypes{feeTypes{...feeTypeFragment}}fragment feeTypeFragment on FeeType{id name feeCategory description overridable}";



const $8b6aef5039628d87$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useFeeTypes", "DEBUG");
const $8b6aef5039628d87$export$aaa77af7e2cec54a = ()=>{
    const { loading: loading, data: { feeTypes: feeTypes } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($b56b72c9c87b1dc9$exports)))), {
        fetchPolicy: "cache-first"
    });
    $8b6aef5039628d87$var$log.debug("useFeeTypes", {
        loading: loading,
        feeTypes: feeTypes
    });
    const getFeeName = (feeTypeId)=>feeTypes?.find((type)=>type.id.equalsIgnoreCase(feeTypeId))?.name || feeTypeId;
    return {
        getFeeName: getFeeName,
        loading: loading
    };
};








const $d8d058783023d092$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SettlementAdjustments", "INFO");
const $d8d058783023d092$var$emptyNewAdjustment = {
    comment: "",
    price: 0.0,
    status: "NEW"
};
const $d8d058783023d092$export$3db4720934042bea = (props)=>{
    const { getName: productTypeName, getBrandProductTypes: getBrandProductTypes, getFees: getFees } = (0, $98effcf86fafb9fb$export$75025970e7082eca)();
    const { getFeeName: getFeeName } = (0, $8b6aef5039628d87$export$aaa77af7e2cec54a)();
    const { currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const [adjustments, setAdjustments] = (0, $fgmOP.useState)([]);
    const [newAdjustment, setNewAdjustment] = (0, $fgmOP.useState)($d8d058783023d092$var$emptyNewAdjustment);
    // const isAdjusting = !!newAdjustment;
    const isAdjusting = props.isAdjusting;
    const adjustmentInputRef = (0, $fgmOP.useRef)();
    // useLayoutEffect(() => {
    //   log.debug('useEffect adjustmentInputRef?.current', adjustmentInputRef.current);
    //   adjustmentInputRef.current?.focus();
    // }, [adjustmentInputRef.current]);
    const initAdjustments = (adjustments)=>{
        $d8d058783023d092$var$log.debug("initAdjustments", adjustments);
        adjustments && setAdjustments(adjustments?.map((adj)=>({
                status: "EXTERNAL",
                ...adj
            })));
    };
    (0, $fgmOP.useEffect)(()=>{
        initAdjustments(props.adjustments);
    }, [
        props.adjustments,
        props.isAdjusting
    ]);
    const adjustSettlement = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($2104f7470a335007$exports)))));
    const onAdjustSettlement = (id, adjustments)=>{
        $d8d058783023d092$var$log.info("onAdjustSettlement", {
            id: id,
            adjustments: adjustments
        });
        adjustSettlement({
            loadingText: "Adjusting settlement...",
            successText: "Settlement adjusted",
            variables: {
                id: id,
                adjustments: adjustments
            },
            update: (proxy, { data: data })=>{
                const { adjustSettlement: adjustSettlement } = data || {};
                $d8d058783023d092$var$log.info("adjustSettlement update", adjustSettlement);
                adjustSettlement && proxy.writeQuery({
                    query: (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($0fe803a534c2ebd1$exports)))),
                    data: {
                        settlement: adjustSettlement
                    },
                    variables: {
                        id: adjustSettlement.id,
                        customerId: adjustSettlement.customer.id
                    }
                });
            }
        }).then(({ data: data })=>{
            const { adjustSettlement: adjustSettlement } = data || {};
            $d8d058783023d092$var$log.debug("adjustSettlement resolved", adjustSettlement);
            initAdjustments(adjustSettlement?.adjustments || []);
            props.onDoneAdjusting && props.onDoneAdjusting();
            return adjustSettlement;
        });
    };
    const onAddAdjustment = ()=>{
        const adjustment = {
            ...newAdjustment
        };
        if (adjustment.feeCategory?.productTypeId && !adjustment.feeCategory?.feeId) {
            setNewAdjustment({
                ...adjustment,
                feeIdError: "Please select a fee"
            });
            return;
        }
        if (!adjustment.comment || adjustment.comment.isEmpty()) {
            setNewAdjustment({
                ...adjustment,
                commentError: "Please write an adjustment comment"
            });
            return; // Prevent adding Adjustment without comment
        }
        if (adjustment.price === undefined || adjustment.price.toString().isEmpty()) {
            setNewAdjustment({
                ...adjustment,
                priceError: "Invalid price"
            });
            return; // Prevent adding Adjustment without price
        }
        const parsedPrice = (0, (/*@__PURE__*/$parcel$interopDefault($87bf0)))(adjustment.price.toString().replace(",", "."));
        if (parsedPrice.value() === null) {
            setNewAdjustment({
                ...adjustment,
                priceError: "Invalid price"
            });
            return; // Prevent adding Adjustment with invalid price value
        }
        adjustment.price = parsedPrice.value() || 0;
        setNewAdjustment($d8d058783023d092$var$emptyNewAdjustment);
        setAdjustments((adjustments)=>[
                ...adjustments,
                adjustment
            ]);
    };
    const onDeleteAdjustment = (i)=>()=>setAdjustments((adjustments)=>{
                if (adjustments[i].status === "EXTERNAL") {
                    adjustments[i].status = "DELETED";
                    return [
                        ...adjustments
                    ];
                } else if (adjustments[i].status === "NEW") return adjustments.filter((adj, j)=>j !== i);
                else {
                    $d8d058783023d092$var$log.error("Unexpected adjustment status onDeleteAdjustment", adjustments[i].status);
                    return [
                        ...adjustments
                    ];
                }
            });
    const onUndoDeleteAdjustment = (i)=>()=>setAdjustments((adjustments)=>{
                if (adjustments[i].status === "DELETED") {
                    adjustments[i].status = "EXTERNAL";
                    return [
                        ...adjustments
                    ];
                } else {
                    $d8d058783023d092$var$log.error("Unexpected adjustment status onUndoDeleteAdjustment", adjustments[i].status);
                    return [
                        ...adjustments
                    ];
                }
            });
    const onChangeAdjustment = (field)=>(value)=>{
            $d8d058783023d092$var$log.debug("onChangeAdjustment", field, value);
            setNewAdjustment((newAdjustment)=>{
                return field === "productTypeId" ? {
                    ...newAdjustment,
                    productTypeIdError: "",
                    feeCategory: {
                        productTypeId: value
                    }
                } //TODO: as any
                 : field === "feeId" ? {
                    ...newAdjustment,
                    feeIdError: "",
                    feeCategory: {
                        ...newAdjustment?.feeCategory,
                        feeId: value
                    }
                } : {
                    ...newAdjustment,
                    [`${field}Error`]: "",
                    [field]: value
                };
            });
        };
    const onSaveAdjustments = ()=>{
        console.log(newAdjustment);
        if (newAdjustment && (newAdjustment.feeCategory && !newAdjustment.feeCategory?.productTypeId.isEmpty() || newAdjustment.feeCategory && !newAdjustment.feeCategory?.feeId.isEmpty() || !newAdjustment.comment.isEmpty() || newAdjustment.price !== 0)) {
            setNewAdjustment({
                ...newAdjustment,
                uncompletedError: true
            });
            return;
        }
        const finalAdjustments = adjustments.filter(({ status: status })=>status !== "DELETED").map(({ feeCategory: feeCategory, comment: comment, price: price, status: status })=>({
                feeCategory: feeCategory,
                comment: comment,
                price: price,
                status: status
            }));
        $d8d058783023d092$var$log.info("onSaveAdjustments", finalAdjustments);
        // onCancelAdjusting();
        if (!props.settlement?.id) $d8d058783023d092$var$log.error("Prop settlement required for adjusting settlement");
        else onAdjustSettlement(props.settlement.id, finalAdjustments);
    };
    return !isAdjusting && (!adjustments || adjustments.isEmpty()) ? null : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
        className: "settlement__aggregate",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("table", {
                id: "settlementAdjustmentsTable",
                className: "settlement__list",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("thead", {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("tr", {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                    colSpan: isAdjusting ? 5 : 4,
                                    children: "Adjustments"
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                        children: "Comment"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                        children: "Service Type"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                        children: "Fee"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                        className: "rightText",
                                        children: "Cost"
                                    }),
                                    isAdjusting && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                        children: "\xa0"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tbody", {
                        children: [
                            adjustments?.map(({ feeCategory: feeCategory, comment: comment, price: price, status: status }, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("settlement__list__item", {
                                        "settlement__adjustment--new": status === "NEW"
                                    }, {
                                        "settlement__adjustment--deleted": status === "DELETED"
                                    }),
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                            children: comment
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                            children: productTypeName(feeCategory?.productTypeId || "--")
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                            children: getFeeName(feeCategory?.feeId || "--")
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                            className: "rightText noWrap",
                                            children: (0, $f5d0c2a7498ff49b$exports.format).decimal(price)
                                        }),
                                        isAdjusting && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                            width: "1%",
                                            children: status === "DELETED" ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                                icon: "undo",
                                                onClick: onUndoDeleteAdjustment(i),
                                                info: "Undo",
                                                className: "settlement__adjustment__icon settlement__adjustment__icon--undo"
                                            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                                icon: "trash",
                                                onClick: onDeleteAdjustment(i),
                                                info: "Delete",
                                                className: "settlement__adjustment__icon settlement__adjustment__icon--delete"
                                            })
                                        })
                                    ]
                                }, i)),
                            isAdjusting && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                                        className: "settlement__list__item settlement__list__item--adjusting",
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                                    className: "settlement__adjustment__text",
                                                    value: newAdjustment?.comment,
                                                    onChange: onChangeAdjustment("comment"),
                                                    isEditing: true,
                                                    inputRef: adjustmentInputRef,
                                                    error: newAdjustment?.commentError
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                                    className: "settlement__adjustment__producttype",
                                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                    value: newAdjustment?.feeCategory?.productTypeId,
                                                    error: newAdjustment?.productTypeIdError,
                                                    onChange: onChangeAdjustment("productTypeId"),
                                                    isEditing: true,
                                                    options: currentUserBrand && getBrandProductTypes(currentUserBrand?.id)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                                    className: "settlement__adjustment__fee",
                                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                    value: newAdjustment?.feeCategory?.feeId,
                                                    error: newAdjustment?.feeIdError,
                                                    onChange: onChangeAdjustment("feeId"),
                                                    isEditing: !!newAdjustment?.feeCategory?.productTypeId,
                                                    defaultValue: !newAdjustment?.feeCategory?.productTypeId ? "Pick Service Type" : "",
                                                    options: getFees(newAdjustment?.feeCategory?.productTypeId || "").map(({ feeTypeId: feeTypeId })=>({
                                                            id: feeTypeId,
                                                            name: getFeeName(feeTypeId) || feeTypeId
                                                        }))
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                                className: "rightText noWrap",
                                                width: "1%",
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                                    className: "settlement__adjustment__price",
                                                    value: newAdjustment?.price,
                                                    onChange: onChangeAdjustment("price"),
                                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).number,
                                                    isEditing: true,
                                                    error: newAdjustment?.priceError
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                                    icon: "add-circle",
                                                    onClick: onAddAdjustment,
                                                    info: "Add",
                                                    className: "settlement__adjustment__icon settlement__adjustment__icon--add"
                                                })
                                            })
                                        ]
                                    }),
                                    newAdjustment.uncompletedError && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                                colSpan: 2
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                                colSpan: 3,
                                                align: "right",
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                    className: "input-error settlement__adjustment_add--tip",
                                                    children: "Complete adjustment by pressing the Add (+) button"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            isAdjusting && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "settlement__adjustment__buttons",
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                        text: "Save Adjustments",
                        onClick: onSaveAdjustments,
                        kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                        text: "Cancel Adjustments",
                        onClick: props.onDoneAdjusting,
                        kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel
                    })
                ]
            })
        ]
    });
};




parcelRequire("fgmOP");



const $f4af27daf75d614a$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SettlementHeader");
const $f4af27daf75d614a$export$553ff2106228b243 = (props)=>{
    // log.debug('render', props);
    const { settlement: settlement } = props;
    if (!settlement) return null;
    const { id: settlementId, state: state, yearMonth: yearMonth, date: settlementDate, currencyCode: currencyCode, customer: { id: customerId, company: { name: companyName, organizationNumber: organizationNumber } }, contract: { id: contractId, invoiceReference: invoiceReference, invoiceAccountId: invoiceAccountId, invoiceIncludeVat: invoiceIncludeVat }, summary: { totalInclVat: totalInclVat } } = settlement;
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
        className: "settlement__header",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "settlement__logo",
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("img", {
                    className: "",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($2fdaa75c663c5a2e$exports))),
                    alt: "Telia logo"
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("table", {
                id: "settlementHeaderTable",
                className: "settlement__fields",
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tbody", {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    className: "settlement__field settlement__field--label",
                                    children: "Customer name"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    className: "settlement__field settlement__field--value",
                                    children: companyName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    className: "settlement__field settlement__field--label",
                                    children: "Customer num."
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    className: "settlement__field settlement__field--value",
                                    children: customerId
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    className: "settlement__field settlement__field--label",
                                    children: "Organization num."
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    className: "settlement__field settlement__field--value",
                                    children: organizationNumber
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    className: "settlement__field settlement__field--label",
                                    children: "Contract num."
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    className: "settlement__field settlement__field--value",
                                    children: contractId
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    className: "settlement__field settlement__field--label",
                                    children: "Settlement num."
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    className: "settlement__field settlement__field--value",
                                    children: settlementId
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    className: "settlement__field settlement__field--label",
                                    children: "Settlement month"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    className: "settlement__field settlement__field--value",
                                    children: yearMonth
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    className: "settlement__field settlement__field--label",
                                    children: "Settlement date"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    className: "settlement__field settlement__field--value",
                                    children: (0, $f5d0c2a7498ff49b$exports.format).date(settlementDate)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    className: "settlement__field settlement__field--label",
                                    children: "Customer Invoice ref."
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    className: "settlement__field settlement__field--value",
                                    children: invoiceReference
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    className: "settlement__field settlement__field--label bold",
                                    children: "Invoice total"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("td", {
                                    className: "settlement__field settlement__field--value bold",
                                    children: [
                                        currencyCode,
                                        " ",
                                        (0, $f5d0c2a7498ff49b$exports.format).decimal(totalInclVat)
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};





var $fgmOP = parcelRequire("fgmOP");








var $fgmOP = parcelRequire("fgmOP");



const $9fe4c78a6b2e4f74$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SettlementFeesTableGroup", "INFO");
const $9fe4c78a6b2e4f74$var$CountAvgTotalGroupFc = ({ quantity: quantity, fee: fee, total: total })=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                className: "rightText width0-on-small-only",
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                    children: [
                        (0, $f5d0c2a7498ff49b$exports.format).integer(quantity),
                        " \xd7"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                className: "rightText width0-on-small-only",
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                    children: [
                        (0, $f5d0c2a7498ff49b$exports.format).decimal(fee),
                        " ="
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                className: "rightText noWrap",
                children: (0, $f5d0c2a7498ff49b$exports.format).decimal(total)
            })
        ]
    });
};
const $9fe4c78a6b2e4f74$export$83b162e8887c541d = ({ name: name, total: total, fees: fees, otherYearsData: otherYearsData = [], highlight: highlight = false })=>{
    const { getFeeName: getFeeName } = (0, $8b6aef5039628d87$export$aaa77af7e2cec54a)();
    otherYearsData = otherYearsData.slice().sort((a, b)=>a.year < b.year ? 1 : -1);
    const allFeeIds = new Set(fees?.filter(({ total: feeTotal })=>!!feeTotal).map((fee)=>fee.feeId));
    otherYearsData.forEach(({ data: { fees: fees } })=>fees.forEach(({ feeId: feeId })=>allFeeIds.add(feeId)));
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("settlement__list__item settlement__list__item--total", highlight && "settlement__list__item--selected"),
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                        colSpan: 3,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                        className: "rightText noWrap",
                        children: (0, $f5d0c2a7498ff49b$exports.format).decimal(total)
                    }),
                    otherYearsData.map(({ data: data }, i)=>{
                        return data.name === name ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    colSpan: 2
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    className: "rightText noWrap",
                                    children: (0, $f5d0c2a7498ff49b$exports.format).decimal(data.total)
                                })
                            ]
                        }, "other_year_" + i) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                            colSpan: 3
                        }, "other_year_" + i);
                    })
                ]
            }),
            Array.from(allFeeIds).map((feeId, i)=>{
                const foundMainFee = fees.find((fee)=>fee.feeId === feeId);
                return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("settlement__list__item settlement__list__item--details", highlight && "settlement__list__item--selected"),
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("td", {
                            children: [
                                "\xa0 \xa0",
                                getFeeName(feeId)
                            ]
                        }),
                        foundMainFee ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($9fe4c78a6b2e4f74$var$CountAvgTotalGroupFc, {
                            quantity: foundMainFee.quantity,
                            fee: foundMainFee.fee,
                            total: foundMainFee.total
                        }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                            colSpan: 3
                        }),
                        otherYearsData.map(({ data: data }, i)=>{
                            const foundFee = data.fees.find((fee)=>data.name === name && fee.feeId === feeId);
                            return foundFee ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($9fe4c78a6b2e4f74$var$CountAvgTotalGroupFc, {
                                quantity: foundFee.quantity,
                                fee: foundFee.fee,
                                total: foundFee.total
                            }, "count_avg_group_" + i) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                colSpan: 3
                            }, "count_avg_group_" + i);
                        })
                    ]
                }, `transaction_${i}`);
            })
        ]
    }, name);
};


const $494bc68b634056b7$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SettlementPerProductDetails", "INFO");
const $494bc68b634056b7$export$3686548213ca73ed = ({ settlement: propSettlement, pdf: pdf, showPerProductDetails: showPerProductDetails, onShowPerProductDetailsToggle: onShowPerProductDetailsToggle })=>{
    const { getName: getName } = (0, $98effcf86fafb9fb$export$75025970e7082eca)();
    const { canReserveOa: canReserveOa } = (0, $98effcf86fafb9fb$export$75025970e7082eca)();
    const { loading: loadingProductOverview, getProductOverview: getProductOverview } = (0, $24ef8762983c02cb$export$4c0ac5f906c0b8d6)();
    const settlement = (0, $fgmOP.useMemo)(()=>propSettlement && {
            ...propSettlement,
            productDetails: propSettlement.productDetails?.map((productDetail)=>!canReserveOa(productDetail.productTypeId) ? productDetail : {
                    ...productDetail,
                    productDetailId: getProductOverview(productDetail.productId)?.productName
                })
        }, [
        propSettlement,
        loadingProductOverview
    ]);
    const { productDetails: productDetails } = settlement;
    $494bc68b634056b7$var$log.debug("render", {
        showPerProductDetails: showPerProductDetails,
        pdf: pdf,
        productDetails: productDetails
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("settlement__aggregate"),
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("table", {
            id: "settlementPerProductDetailsTable",
            className: "settlement__list",
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("th", {
                                children: [
                                    "Per service details",
                                    pdf || /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                        className: "settlement__show_details__button",
                                        onClick: onShowPerProductDetailsToggle,
                                        children: showPerProductDetails ? "hide" : "show"
                                    })
                                ]
                            }),
                            (pdf || showPerProductDetails) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                        className: "rightText width0-on-small-only",
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                            children: "Count"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                        className: "rightText width0-on-small-only",
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                            children: "Fee"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                        className: "rightText",
                                        children: "Total"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                (pdf || showPerProductDetails) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("tbody", {
                    children: productDetails && productDetails.map(({ total: total, productTypeId: productTypeId, productDetailId: productDetailId, fees: fees }, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fe4c78a6b2e4f74$export$83b162e8887c541d), {
                            name: `${getName(productTypeId)} ${productDetailId ? " \xb7 " + productDetailId : ""}`,
                            total: total,
                            fees: fees
                        }, i))
                })
            ]
        })
    });
};



parcelRequire("fgmOP");





const $4085a222edcc7ccc$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SettlementProductTypesSummary", "INFO");
const $4085a222edcc7ccc$export$75d15c67158151c7 = ({ productTypeSummaries: productTypeSummaries })=>{
    const { getName: getName } = (0, $98effcf86fafb9fb$export$75025970e7082eca)();
    $4085a222edcc7ccc$var$log.debug("SettlementProductTypesSummaryFc", productTypeSummaries);
    return !productTypeSummaries ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $25d390e04dd0ffc0$export$2e2bcd8739ae039), {
        children: "Missing settlement's service summaries"
    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("section", {
        className: "settlement__aggregate",
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("table", {
            id: "settlementProductTypesSummaryTable",
            className: "settlement__list",
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                children: "Service type summary"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                className: "rightText width0-on-small-only",
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                    children: "Count"
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                className: "rightText width0-on-small-only",
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                    children: "Fee"
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                className: "rightText",
                                children: "Total"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("tbody", {
                    children: productTypeSummaries.map(({ productTypeId: productTypeId, total: total, fees: fees }, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fe4c78a6b2e4f74$export$83b162e8887c541d), {
                            name: getName(productTypeId),
                            total: total,
                            fees: fees
                        }, i))
                })
            ]
        })
    });
};





var $fgmOP = parcelRequire("fgmOP");


const $eefead8bfd0d9ad2$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SettlementTotalSummary");
const $eefead8bfd0d9ad2$export$a6fce5eecaef430 = (props)=>{
    // log.debug('render', props);
    const { settlement: settlement, showVat: showVat = true } = props;
    // const {loading, settlement} = props.settlementQuery;
    if (!settlement) return null;
    const { currencyCode: currencyCode, contract: { invoiceIncludeVat: invoiceIncludeVat = false } = {}, summary: { settlementTotal: settlementTotal, adjustmentTotal: adjustmentTotal, totalExclVat: totalExclVat, vat: vat, vatPercentage: vatPercentage, totalInclVat: totalInclVat } } = settlement;
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("section", {
        className: "settlement__aggregate",
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("table", {
            id: "settlementTotalSummaryTable",
            className: "settlement__list",
            children: [
                (showVat || adjustmentTotal !== 0) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("thead", {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                children: "Totals summary"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                className: "rightText",
                                children: "Cost"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tbody", {
                    children: [
                        adjustmentTotal !== 0 && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                                    className: "settlement__list__item",
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                            children: "Settlement sum"
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                            className: "rightText noWrap",
                                            children: (0, $f5d0c2a7498ff49b$exports.format).decimal(settlementTotal)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                                    className: "settlement__list__item",
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                            children: "Adjustments sum"
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                            className: "rightText noWrap",
                                            children: (0, $f5d0c2a7498ff49b$exports.format).decimal(adjustmentTotal)
                                        })
                                    ]
                                })
                            ]
                        }),
                        showVat ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                                    className: "settlement__list__item",
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                            children: "Invoice base"
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                            className: "rightText noWrap",
                                            children: (0, $f5d0c2a7498ff49b$exports.format).decimal(totalExclVat)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                                    className: "settlement__list__item",
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("td", {
                                            children: [
                                                "VAT ",
                                                (0, $f5d0c2a7498ff49b$exports.format).decimal(vatPercentage),
                                                "%"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                            className: "rightText",
                                            children: (0, $f5d0c2a7498ff49b$exports.format).decimal(vat)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                                    className: "settlement__list__item settlement__list__item--sum bold",
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                            children: "Invoice total"
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("td", {
                                            className: "rightText noWrap",
                                            children: [
                                                currencyCode,
                                                " ",
                                                (0, $f5d0c2a7498ff49b$exports.format).decimal(totalInclVat)
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                            className: "settlement__list__item settlement__list__item--sum bold",
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    children: "Total excluding VAT"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("td", {
                                    className: "rightText noWrap",
                                    children: [
                                        currencyCode,
                                        " ",
                                        (0, $f5d0c2a7498ff49b$exports.format).decimal(totalExclVat)
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};


const $ede1d69ade64ddbb$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Settlement", "INFO");
const $ede1d69ade64ddbb$export$e957498a727fb850 = (props)=>{
    const { settlementId: settlementId, customerId: customerId, pdf: pdf } = props;
    const [showPerProductDetails, setShowPerProductDetails] = (0, $fgmOP.useState)(false);
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const onShowPerProductDetailsToggle = ()=>{
        setShowPerProductDetails((prevState)=>!prevState);
    };
    const { loading: loading, data: { settlement: settlement } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($0fe803a534c2ebd1$exports)))), {
        variables: {
            id: settlementId,
            customerId: customerId
        }
    });
    $ede1d69ade64ddbb$var$log.debug("render", {
        showPerProductDetails: showPerProductDetails,
        props: props,
        loading: loading,
        settlement: settlement
    });
    if (loading) return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {});
    if (!settlement) return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
        description: `Couldn't fetch settlement ID '${settlementId}' from customer ID '${customerId}'`
    });
    const { state: state } = settlement;
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("settlement", {
            "settlement--pending": state !== "APPROVED"
        }, {
            "settlement--pdf": pdf
        }),
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
            children: [
                pdf ? null : state === "APPROVED" ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("section", {
                    className: "settlement__approval",
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                        description: `Settlement ready to print`,
                        buttons: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                            text: "Printable Version",
                            onClick: ()=>window.open($e9a95c61c800ecd2$export$d9468344d3651243($e9a95c61c800ecd2$export$aca1887b2f6340cd, settlement.customer.id, settlement.id), "_blank")
                        })
                    })
                }) : state === "PENDING" ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("section", {
                    className: "settlement__approval",
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                        description: `This settlement hasn't been accepted for approval yet`
                    })
                }) : state === "READY_FOR_APPROVAL" && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("section", {
                    className: "settlement__approval",
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                        description: `This settlement hasn't been approved yet`
                    })
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $f4af27daf75d614a$export$553ff2106228b243), {
                    settlement: settlement
                }),
                settlement.productTypeSummaries && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $4085a222edcc7ccc$export$75d15c67158151c7), {
                    productTypeSummaries: settlement.productTypeSummaries
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $494bc68b634056b7$export$3686548213ca73ed), {
                    settlement: settlement,
                    pdf: pdf,
                    onShowPerProductDetailsToggle: onShowPerProductDetailsToggle,
                    showPerProductDetails: showPerProductDetails
                }),
                settlement.adjustments && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d8d058783023d092$export$3db4720934042bea), {
                    adjustments: settlement.adjustments
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $eefead8bfd0d9ad2$export$a6fce5eecaef430), {
                    settlement: settlement
                }),
                pdf && setTimeout(window.print, 800)
            ]
        })
    });
};



parcelRequire("fgmOP");




const $4027eb6f96bed6f2$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SettlementDateTotalLine", "INFO");
const $4027eb6f96bed6f2$export$bd87a5471f9d79f4 = (props)=>{
    const { settlement: settlement, showCompanyName: showCompanyName } = props;
    $4027eb6f96bed6f2$var$log.debug("settlement", settlement);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: "settlement__name",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                className: "settlement__Name_date",
                children: [
                    (0, $f5d0c2a7498ff49b$exports.format).yearMonth(settlement.yearMonth),
                    " ",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                        icon: "calendar"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                className: "settlement__name__total",
                children: (0, $f5d0c2a7498ff49b$exports.format).currency(settlement.summary.totalExclVat, settlement.currencyCode)
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                className: "settlement__name__id",
                children: [
                    settlement.id,
                    " Settl#"
                ]
            }),
            showCompanyName && settlement.customer.company.name
        ]
    });
};


const $f18dd74b507cedb4$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("CustomerSettlementApprovedList", "INFO");
const $f18dd74b507cedb4$export$606fa1b4aa5e213b = (props)=>{
    const { customerId: customerId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const { getCustomerOverview: getCustomerOverview } = (0, $8d8d8b3d38044bbe$export$d27d8317adc3c298)();
    const customerOverview = getCustomerOverview(customerId);
    const { loading: loading, data: { settlements: settlements } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($7c56a23b568b6925$exports)))), {
        skip: !customerOverview,
        variables: {
            customerId: customerId
        }
    });
    (0, $c3440150448da8b8$export$1c72fe480f599e97)([
        {
            query: "Settlements",
            isLoading: loading
        }
    ]);
    const sortedSettlements = settlements?.slice().sort((a, o)=>{
        return o.yearMonth.localeCompare(a.yearMonth);
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("CustomerSettlementApprovedList", props.className),
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Settlements"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "settlements"
            }),
            !sortedSettlements || sortedSettlements.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                description: `No settlements for this customer`
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $22dbb5b4c09ac376$export$1266ff14c7754c00), {
                multipleOpen: false,
                initialOpenItemId: sortedSettlements.length === 1 ? sortedSettlements[0].id : undefined,
                children: sortedSettlements.map((settlement)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $cb8470b63aea6339$export$2e2bcd8739ae039), {
                        id: (0, $0857d9353dc337e9$export$d5d25c90fc92fce5)(settlement.id, "settlement"),
                        header: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $4027eb6f96bed6f2$export$bd87a5471f9d79f4), {
                            settlement: settlement
                        }),
                        content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ede1d69ade64ddbb$export$e957498a727fb850), {
                            settlementId: settlement.id,
                            customerId: customerId
                        })
                    }, settlement.id))
            })
        ]
    });
};








var $fgmOP = parcelRequire("fgmOP");

var $4d68c9ea54876411$exports = {};
$4d68c9ea54876411$exports = "fragment customerDocumentFragment on CustomerDocument{id name description date version uploader active}";


var $d8cfed90d3f13f83$exports = {};
$d8cfed90d3f13f83$exports = "mutation getSignedDownloadUrl($bucket:String!$brandId:String!$customerId:String!$fileName:String!){getSignedDownloadUrl(bucket:$bucket brandId:$brandId customerId:$customerId fileName:$fileName){...getSignedDownloadUrl}}fragment getSignedDownloadUrl on SignedUrlResponse{url key}";


var $9da56d736d5c09a5$exports = {};
$9da56d736d5c09a5$exports = "mutation getSignedUploadUrl($bucket:String!$brandId:String!$customerId:String!$fileName:String!$fileSize:Int!$fileType:String!$tags:[TagInput!]!){getSignedUploadUrl(bucket:$bucket brandId:$brandId customerId:$customerId fileName:$fileName fileSize:$fileSize fileType:$fileType tags:$tags){...getSignedUploadUrl}}fragment getSignedUploadUrl on SignedUrlResponse{url fields key}";


var $abfe6aac6fb6bb71$exports = {};
$abfe6aac6fb6bb71$exports = "mutation saveCustomerDocument($bucket:String!$customerId:ID!$document:DocumentInput!$fileKey:String$tags:[TagInput!]){saveCustomerDocument(bucket:$bucket customerId:$customerId document:$document fileKey:$fileKey tags:$tags){...customerDocumentFragment}}fragment customerDocumentFragment on CustomerDocument{id name description date version uploader active}";
















const $094f42e36775e720$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Document", "INFO");
const $094f42e36775e720$export$b34a105447964f9f = (_props)=>{
    const { customerId: customerId, documentId: documentId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const { getCustomerOverview: getCustomerOverview } = (0, $8d8d8b3d38044bbe$export$d27d8317adc3c298)();
    const { brandId: brandId } = getCustomerOverview(customerId) || {};
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const [generateSignedUploadUrl] = (0, $1f0b8701b604e718$export$609860bf8b0084c)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($9da56d736d5c09a5$exports)))));
    const [generateSignedDownloadUrl] = (0, $1f0b8701b604e718$export$609860bf8b0084c)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($d8cfed90d3f13f83$exports)))));
    const saveDocument = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($abfe6aac6fb6bb71$exports)))));
    const [uploadedFile, setUploadedFile] = (0, $fgmOP.useState)(null);
    const [fileUploaded, setFileUploaded] = (0, $fgmOP.useState)(false);
    const formFragmentOptions = {
        fragment: (0, (/*@__PURE__*/$parcel$interopDefault($4d68c9ea54876411$exports))),
        entityId: documentId,
        newEntity: {
            id: "",
            name: "",
            description: "",
            date: "",
            version: "",
            uploader: "",
            active: true
        }
    };
    const formStateOptions = (0, $cd0b9ee27a364316$export$4c2508f4134d3a42)(formFragmentOptions);
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)(formStateOptions);
    const { entityAs: entityAs, entity: entity, isEditing: isEditing, onEdit: onEdit, onCancel: onCancel } = formState;
    const onSave = async ()=>{
        let fileKey = null;
        const bucket = (0, $ce151254b700f66a$export$880b260d7239d413)();
        const tags = [
            {
                key: "title",
                value: entity.name?.toString() || ""
            },
            {
                key: "description",
                value: entity.description?.toString() || ""
            },
            {
                key: "date",
                value: entity.date?.toString() || ""
            },
            {
                key: "uploader",
                value: entity.uploader?.toString() || ""
            },
            {
                key: "active",
                value: entity.active ? "true" : "false"
            }
        ];
        try {
            if (uploadedFile) {
                const { data: signedUrlData } = await generateSignedUploadUrl({
                    variables: {
                        bucket: bucket,
                        brandId: brandId,
                        customerId: customerId,
                        fileName: uploadedFile.name,
                        fileType: uploadedFile.type,
                        fileSize: uploadedFile.size,
                        tags: tags
                    }
                });
                if (!signedUrlData || !signedUrlData.getSignedUploadUrl) throw new Error("Failed to generate signed URL");
                const { url: signedUrl, fields: fields } = signedUrlData.getSignedUploadUrl;
                fileKey = fields.key;
                const formData = new FormData();
                Object.entries(fields).forEach(([key, value])=>{
                    formData.append(key, value);
                });
                formData.append("file", uploadedFile);
                await fetch(signedUrl, {
                    method: "POST",
                    body: formData
                });
            }
        } catch (error) {
            if (error.response?.status) alert(error.response.data.message);
            return;
        }
        try {
            const { data: data } = await saveDocument({
                loadingText: "Saving document...",
                successText: "Document saved",
                variables: {
                    bucket: bucket,
                    customerId: customerId,
                    document: entityAs(),
                    file: null,
                    fileKey: fileKey,
                    tags: tags
                },
                context: {
                    hasUpload: true
                }
            });
            const { saveCustomerDocument: saveCustomerDocument } = data || {
                saveCustomerDocument: undefined
            };
            if (saveCustomerDocument) {
                formState.onSaved((0, $f6ff28847e6675c5$export$232f37f9a0fc548e)(saveCustomerDocument));
                navigate(formatWithBrand($e9a95c61c800ecd2$export$f862805185457fce, customerId, saveCustomerDocument.id));
            }
        } catch (error) {
            throw new Error("Failed to save the document. The operation was aborted.");
        }
    };
    const handleUploadedFile = (e)=>{
        const files = e.target.files;
        if (!files) return;
        const file = files[0];
        const currentTimestamp = new Date().toISOString();
        const formattedTimestamp = (0, $f5d0c2a7498ff49b$exports.format).dateTime(currentTimestamp);
        formState.onChange("id")(file.name);
        formState.onChange("name")(file.name);
        formState.onChange("date")(formattedTimestamp);
        setFileUploaded(true);
        setUploadedFile(file);
    };
    const formButtons = (inPageSubtitle)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                "inlineBlock marginLeft": inPageSubtitle
            }),
            children: !isEditing ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                        text: "Edit",
                        onClick: onEdit
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                        text: "Download",
                        onClick: handleDownloadFile
                    })
                ]
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                        text: "Save",
                        onClick: onSave,
                        kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                        text: "Cancel",
                        onClick: onCancel,
                        kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel
                    })
                ]
            })
        });
    const handleDownloadFile = async ()=>{
        const bucket = (0, $ce151254b700f66a$export$880b260d7239d413)();
        const fileName = entity.name;
        const { data: downloadUrlData } = await generateSignedDownloadUrl({
            variables: {
                bucket: bucket,
                brandId: brandId,
                customerId: customerId,
                fileName: fileName
            }
        });
        if (!downloadUrlData || !downloadUrlData.getSignedDownloadUrl) throw new Error("Failed to generate download URL");
        const { url: url } = downloadUrlData.getSignedDownloadUrl;
        window.location.href = url;
    };
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                children: [
                    "Document",
                    formButtons(true)
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "document"
            }),
            !formState.entity ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                children: "No form entity info"
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $2e4c8094e1930e9a$export$2e2bcd8739ae039), {
                onSubmit: (e)=>{
                    $094f42e36775e720$var$log.debug("onSubmit");
                    e.preventDefault();
                },
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: isEditing && !fileUploaded && documentId === "_create_" ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("label", {
                                        htmlFor: "fileInput",
                                        style: {
                                            display: "inline-block"
                                        },
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                            text: "Upload file",
                                            onClick: ()=>document.getElementById("fileInput")?.click()
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("input", {
                                        type: "file",
                                        id: "fileInput",
                                        className: "custom-file-input",
                                        onChange: handleUploadedFile
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "name",
                                label: "Filename",
                                isEditing: false,
                                className: "break-word"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "description",
                                label: "Description",
                                isEditing: isEditing,
                                className: "break-word"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "date",
                                label: "Date",
                                isEditing: false
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "uploader",
                                label: "Uploader",
                                isEditing: false
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "version",
                                label: "Version",
                                isEditing: false
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "active",
                                label: "Active",
                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox
                            })
                        })
                    })
                ]
            })
        ]
    });
};






parcelRequire("fgmOP");

var $9de66378d3cd4660$exports = {};
$9de66378d3cd4660$exports = "query customerDocuments($customerId:ID!){customerDocuments(customerId:$customerId){...customerDocumentFragment}}fragment customerDocumentFragment on CustomerDocument{id name description date version uploader active}";












const { THead: $17ea0037c549c0bc$var$THead, Tr: $17ea0037c549c0bc$var$Tr, ThSortable: $17ea0037c549c0bc$var$ThSortable, TBody: $17ea0037c549c0bc$var$TBody, Td: $17ea0037c549c0bc$var$Td } = (0, $c1364c3d18563e9b$export$2e2bcd8739ae039);
const $17ea0037c549c0bc$export$5ab5355d0a784c8c = ({ customerId: customerId })=>{
    const { hasPermission: hasPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const { showInactiveComponent: showInactiveComponent, showInactive: showInactive } = (0, $152b6193e99b7439$export$84f600a904db3b68)();
    const { loading: loadingDocuments, data: documentsData } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($9de66378d3cd4660$exports)))), {
        variables: {
            customerId: customerId
        }
    });
    (0, $c3440150448da8b8$export$1c72fe480f599e97)([
        {
            query: "customerDocuments",
            isLoading: loadingDocuments
        }
    ]);
    const documents = documentsData?.customerDocuments || [];
    const filteredDocuments = showInactive ? documents : documents.filter((doc)=>doc.active);
    const [sortedDocuments, getThSortableProps] = (0, $a129443168ef7da6$exports.useThSortable)(filteredDocuments, 3, [], {});
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                children: "Documents"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "documents"
            }),
            showInactiveComponent,
            !(sortedDocuments && sortedDocuments.length) ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                children: "No documents found"
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039), {
                clickable: true,
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($17ea0037c549c0bc$var$THead, {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)($17ea0037c549c0bc$var$Tr, {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($17ea0037c549c0bc$var$ThSortable, {
                                    ...getThSortableProps("name"),
                                    children: "Filename"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($17ea0037c549c0bc$var$ThSortable, {
                                    ...getThSortableProps("date"),
                                    children: "Date"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($17ea0037c549c0bc$var$ThSortable, {
                                    ...getThSortableProps("uploader"),
                                    children: "Uploader"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($17ea0037c549c0bc$var$TBody, {
                        children: sortedDocuments.map((document, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($17ea0037c549c0bc$var$Tr, {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                                    to: formatWithBrand($e9a95c61c800ecd2$export$f862805185457fce, customerId, document.id),
                                    style: {
                                        display: "contents",
                                        textDecoration: "none",
                                        color: "inherit"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($17ea0037c549c0bc$var$Td, {
                                            className: "break-word",
                                            children: document.name
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($17ea0037c549c0bc$var$Td, {
                                            children: document.date
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($17ea0037c549c0bc$var$Td, {
                                            children: document.uploader
                                        })
                                    ]
                                })
                            }, document.id))
                    })
                ]
            }),
            hasPermission((0, $ca0941499cca84bb$export$167b208d1ae7a371)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                id: "createDocument",
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                    to: formatWithBrand($e9a95c61c800ecd2$export$1cd2c36c01be113e, customerId),
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                        text: "Upload document"
                    })
                })
            })
        ]
    });
};




var $fgmOP = parcelRequire("fgmOP");












const $0c50f3a7c549d9f9$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("provisioning/utils", "INFO");
const $0c50f3a7c549d9f9$export$8389a24b7ef9bb78 = (contracts = [], showInactive)=>{
    $0c50f3a7c549d9f9$var$log.debug("filterContracts", showInactive);
    return contracts.filter((contract)=>showInactive || (0, $f5d0c2a7498ff49b$exports.period).isActive(contract)).map((contract)=>({
            ...contract,
            products: contract.products.filter((product)=>showInactive || (0, $f5d0c2a7498ff49b$exports.period).isActive(product))
        }));
};


const $2f1ca21755509cd9$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ProvisioningOverview", "INFO");
const $2f1ca21755509cd9$export$afa8f1fa72c122c5 = ({ customer: customer })=>{
    if (!customer) return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {});
    const { showInactive: showInactive } = (0, $152b6193e99b7439$export$84f600a904db3b68)();
    const contracts = (0, $fgmOP.useMemo)(()=>(0, $0c50f3a7c549d9f9$export$8389a24b7ef9bb78)(customer.contracts, showInactive), [
        customer
    ]);
    const { hasPermission: hasPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const titleCompany = customer.company.name ? "Company information" : "missing company name";
    const totalContracts = contracts.length;
    const totalUsers = customer.users?.length;
    const totalContacts = customer.contacts?.length;
    const totalProducts = contracts.reduce((total, contract)=>total + contract.products.length, 0);
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    $2f1ca21755509cd9$var$log.debug("render", {
        customer: customer,
        showInactive: showInactive
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: "ProvisioningOverviewFc",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Overview"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "overview"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $e7ded3c00eb49c59$export$237d44eeb6e90e79), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "company",
                        title: titleCompany,
                        warning: !customer?.company.name,
                        link: formatWithBrand($e9a95c61c800ecd2$export$725b0abc5ad90944, customer.id)
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "group",
                        title: `${totalUsers} User${totalUsers === 1 ? "" : "s"}`,
                        warning: totalUsers === 0,
                        link: formatWithBrand($e9a95c61c800ecd2$export$f9e6c07fc68d7984, customer.id)
                    }),
                    (hasPermission((0, $ca0941499cca84bb$export$d6141afe674cb67b)) || customer && customer.contracts && customer.contracts.length >= 1) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "business",
                        title: `${totalContracts} Contract${totalContracts === 1 ? "" : "s"}`,
                        warning: totalContracts === 0,
                        link: formatWithBrand($e9a95c61c800ecd2$export$a4009a798127382a, customer.id)
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "shoppingcart",
                        title: `${totalProducts} Service${totalProducts === 1 ? "" : "s"}`,
                        warning: totalProducts === 0,
                        link: formatWithBrand($e9a95c61c800ecd2$export$1208ff990906387d, customer.id)
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "chat",
                        title: `${totalContacts} Communication contacts`,
                        link: formatWithBrand($e9a95c61c800ecd2$export$6d02b57a0acc5177, customer.id)
                    }),
                    hasPermission((0, $ca0941499cca84bb$export$9745fea74799dd7b)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "money",
                        title: "Settlements",
                        link: formatWithBrand($e9a95c61c800ecd2$export$a91491caafc6bee3, customer.id)
                    }),
                    hasPermission((0, $ca0941499cca84bb$export$2c134167e4d6a0ca)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "list-view",
                        title: "ACL",
                        link: formatWithBrand($e9a95c61c800ecd2$export$369b0d9ad9b3e58, customer.id)
                    }),
                    (hasPermission((0, $ca0941499cca84bb$export$c7086708a0f042bc)) || hasPermission((0, $ca0941499cca84bb$export$2c134167e4d6a0ca))) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "signal",
                        title: `Smpp Connections`,
                        link: formatWithBrand($e9a95c61c800ecd2$export$185e199732aa14cd, customer.id)
                    }),
                    hasPermission((0, $ca0941499cca84bb$export$5d3c7c2c3a35af76)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "document",
                        title: `Documents`,
                        link: formatWithBrand($e9a95c61c800ecd2$export$da866688141ddd00, customer.id)
                    })
                ]
            })
        ]
    });
};






var $6N8I1 = parcelRequire("6N8I1");



var $c30H9 = parcelRequire("c30H9");

var $fgmOP = parcelRequire("fgmOP");


var $9440e7fd1caa7b81$exports = {};
$9440e7fd1caa7b81$exports = "fragment productFragment on Product{id countryId brandId customerId contractId productType accessNumber accessNumberRange{from to count}rbmAgentOwner startDate endDate inheritsEndDate gracePeriodStartDate establishFee monthlyFee addressingPolicy allowedOriginatingAddresses name comment routingConfigId qosProfile{enabled maxSmsPerSecond messagePriority}features{id featureTypeId startDate endDate featureProperties{accessNumberId}}feeOverrides{feeTypeId amount}}";


var $29a24a008c14ae51$exports = {};
$29a24a008c14ae51$exports = "mutation saveProduct($product:ProductInput!){saveProduct(product:$product){...productFragment}}fragment productFragment on Product{id countryId brandId customerId contractId productType accessNumber accessNumberRange{from to count}rbmAgentOwner startDate endDate inheritsEndDate gracePeriodStartDate establishFee monthlyFee addressingPolicy allowedOriginatingAddresses name comment routingConfigId qosProfile{enabled maxSmsPerSecond messagePriority}features{id featureTypeId startDate endDate featureProperties{accessNumberId}}feeOverrides{feeTypeId amount}}";




var $cb40802b0ad9775f$exports = {};
$cb40802b0ad9775f$exports = "query reservedOas($countryId:ID$ownerProductId:ID$customerId:ID){reservedOas(countryId:$countryId ownerProductId:$ownerProductId customerId:$customerId){...reservedOaFragment}}fragment reservedOaFragment on ReservedOa{id senderId countryId ownerProductId startDate endDate effect allowedProductIds oaFormatClassifier modifiedDate modifiedBy}";











var $l8GLF = parcelRequire("l8GLF");













var $fgmOP = parcelRequire("fgmOP");


var $fgmOP = parcelRequire("fgmOP");
var $526d8aded934eeda$exports = {};
$526d8aded934eeda$exports = "query accessNumberHistory($customerId:ID){accessNumberHistory(customerId:$customerId){accessNumber accessNumberRange{from to count}productHistory{id featureId customerId contractId startDate endDate}}}";





const $795fd6aaaa16f06b$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useAccessNumberHistory ", "INFO");
const $795fd6aaaa16f06b$export$4324e0562a89d177 = ()=>{
    const { currentUserBrand: currentUserBrand, isCustomer: isCustomer, customerId: customerId } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { loading: loadingCustomerOverviews, getName: getName } = (0, $8d8d8b3d38044bbe$export$d27d8317adc3c298)();
    const { loading: loading, data: { accessNumberHistory: accessNumberHistoryList } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($526d8aded934eeda$exports)))), {
        fetchPolicy: "no-cache",
        skip: !currentUserBrand?.id,
        ...isCustomer() && {
            variables: {
                customerId: customerId
            }
        }
    });
    const enrichedAccessNumberHistoryList = (0, $fgmOP.useMemo)(()=>loadingCustomerOverviews ? accessNumberHistoryList : accessNumberHistoryList?.map(({ productHistory: productHistory, ...accessNumberHistory })=>({
                ...accessNumberHistory,
                productHistory: productHistory?.map((productHistory)=>({
                        ...productHistory,
                        customerName: getName(productHistory.customerId)
                    }))
            })), [
        loadingCustomerOverviews,
        accessNumberHistoryList
    ]);
    const hook = {
        loading: loading,
        accessNumberHistoryList: enrichedAccessNumberHistoryList
    };
    $795fd6aaaa16f06b$var$log.debug(hook);
    return hook;
};



var $6c1eaed6c8fc0151$exports = {};
$6c1eaed6c8fc0151$exports = "query accessNumberSeries($countryId:ID!){accessNumberSeries(countryId:$countryId){id name from to comment productTypes featureTypes}}";




const $c6547a3d4307612c$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useAccessNumberSeries", "INFO");
const $c6547a3d4307612c$export$a05a5e3e25ee1bb = ()=>{
    const { currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { loading: loading, data: { accessNumberSeries: accessNumberSeries } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($6c1eaed6c8fc0151$exports)))), {
        variables: {
            countryId: currentUserBrand?.countryId
        },
        skip: !currentUserBrand
    });
    const hook = {
        loading: loading,
        accessNumberSeriesList: accessNumberSeries
    };
    $c6547a3d4307612c$var$log.debug(hook);
    return hook;
};








const $36a4608a51053324$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("PickAccessNumber", "INFO");
const $36a4608a51053324$export$a0cbf456f5f6d2a2 = (props)=>{
    const { productType: productType, featureType: featureType, productId: productId, featureId: featureId, currentNumber: currentNumber, startDate: startDate, endDate: endDate, onPickAccessNumber: onPickAccessNumber, rangeCount: rangeCount } = props;
    const [selectedSeriesId, setSelectedSeriesId] = (0, $fgmOP.useState)();
    const [processingSelectedSeries, setProcessingSelectedSeries] = (0, $fgmOP.useState)(false);
    const { loading: loadingAccessNumberHistory, accessNumberHistoryList: accessNumberHistoryList } = (0, $795fd6aaaa16f06b$export$4324e0562a89d177)();
    const { loading: loadingAccessNumberSeries, accessNumberSeriesList: accessNumberSeriesList } = (0, $c6547a3d4307612c$export$a05a5e3e25ee1bb)();
    const filteredAccessNumberSeriesList = (0, $fgmOP.useMemo)(()=>accessNumberSeriesList?.filter(({ productTypes: productTypes, featureTypes: featureTypes })=>productTypes?.includes(productType) && (!featureType || featureTypes?.includes(featureType))), [
        productType,
        accessNumberSeriesList
    ]);
    const selectedSeries = (0, $fgmOP.useMemo)(()=>!selectedSeriesId ? undefined : filteredAccessNumberSeriesList?.find(({ id: id })=>id === selectedSeriesId), [
        filteredAccessNumberSeriesList,
        selectedSeriesId
    ]);
    const selectedSeriesValues = (0, $fgmOP.useMemo)(()=>selectedSeries && (0, $f5d0c2a7498ff49b$exports.range).rangeValues(selectedSeries), [
        selectedSeries
    ]);
    const selectedSeriesHistory = (0, $fgmOP.useMemo)(()=>selectedSeries && accessNumberHistoryList?.filter((h)=>h.accessNumber ? (0, $f5d0c2a7498ff49b$exports.range).rangeIncludes(selectedSeries, h.accessNumber) : h.accessNumberRange ? (0, $f5d0c2a7498ff49b$exports.range).rangesOverlap(selectedSeries, h.accessNumberRange) : undefined), [
        selectedSeries,
        accessNumberHistoryList
    ]);
    (0, $fgmOP.useCallback)(()=>setProcessingSelectedSeries(selectedSeriesId !== undefined && selectedSeriesHistory === undefined), [
        selectedSeriesId,
        selectedSeriesHistory
    ]);
    const [hoveredIndex, setHoveredIndex] = (0, $fgmOP.useState)();
    $36a4608a51053324$var$log.debug("render", {
        props: props,
        loadingAccessNumberHistory: loadingAccessNumberHistory,
        loadingAccessNumberSeries: loadingAccessNumberSeries,
        accessNumberHistoryList: accessNumberHistoryList,
        filteredAccessNumberSeriesList: filteredAccessNumberSeriesList,
        accessNumberSeriesList: accessNumberSeriesList,
        selectedSeriesId: selectedSeriesId,
        selectedSeries: selectedSeries,
        selectedSeriesValues: selectedSeriesValues,
        selectedSeriesHistory: selectedSeriesHistory,
        processingSelectedSeries: processingSelectedSeries,
        rangeCount: rangeCount
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
        children: loadingAccessNumberSeries || loadingAccessNumberHistory ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
            children: !filteredAccessNumberSeriesList ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                children: "Preparing access number series..."
            }) : filteredAccessNumberSeriesList.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $25d390e04dd0ffc0$export$2e2bcd8739ae039), {
                children: [
                    "No access number series found for service type ",
                    productType
                ]
            }) : !selectedSeriesId ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                id: "customer-list__wrapper",
                className: "customer-list--wrapper",
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $98cbb91c03e56cc2$export$2e2bcd8739ae039), {
                    className: "customer-list",
                    children: filteredAccessNumberSeriesList.map((series)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $d8d7fa9fc21de820$export$2e2bcd8739ae039), {
                            className: "customer-list__item",
                            onClick: ()=>setSelectedSeriesId(series.id),
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                            className: "bold width8rem noWrap",
                                            children: series.name || series.id
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                            className: "width8rem rightText",
                                            children: series.from
                                        }),
                                        " -",
                                        " ",
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                                            className: "width8rem",
                                            children: [
                                                " ",
                                                series.to
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                    className: "default",
                                    children: series.comment
                                })
                            ]
                        }, series.from))
                })
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                children: processingSelectedSeries ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {
                    children: "Processing Series..."
                }) : !selectedSeries || !selectedSeriesValues || !selectedSeriesHistory ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $25d390e04dd0ffc0$export$2e2bcd8739ae039), {
                    children: "Unexpected state selecting series values"
                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                    children: [
                        "Available ",
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                            className: "bold",
                            children: selectedSeries.name || selectedSeries.id
                        }),
                        " numbers",
                        " ",
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                            className: "bold",
                            children: endDate ? `between ${startDate} and ${endDate}` : `from ${startDate}`
                        }),
                        ":",
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                            children: selectedSeriesValues.map((seriesAccessNumber, i)=>{
                                const isTaken = selectedSeriesHistory.filter((h)=>h.accessNumber ? h.accessNumber === seriesAccessNumber : h.accessNumberRange && (0, $f5d0c2a7498ff49b$exports.range).rangeIncludes(h.accessNumberRange, seriesAccessNumber)).some((h)=>h.productHistory.some((ph)=>(featureType && ph.featureId !== featureId || !productId || productId && ph.id !== productId) && (0, $f5d0c2a7498ff49b$exports.period).overlap(ph, {
                                            startDate: startDate,
                                            endDate: endDate
                                        })));
                                const isRange = rangeCount !== undefined;
                                const rangeTo = rangeCount === undefined ? undefined : (0, $f5d0c2a7498ff49b$exports.range).rangeTo(seriesAccessNumber, rangeCount);
                                const isRangeOutOfSeries = rangeTo && rangeTo.localeCompare(selectedSeries.to) > 0;
                                const isAnyInRangeTaken = !isTaken && rangeTo && selectedSeriesHistory.filter((h)=>h.accessNumber ? (0, $f5d0c2a7498ff49b$exports.range).rangeIncludes({
                                        from: seriesAccessNumber,
                                        to: rangeTo
                                    }, h.accessNumber) : h.accessNumberRange && (0, $f5d0c2a7498ff49b$exports.range).rangesOverlap(h.accessNumberRange, {
                                        from: seriesAccessNumber,
                                        to: rangeTo
                                    })).some((h)=>h.productHistory.some((ph)=>(!productId || productId && ph.id !== productId) && (0, $f5d0c2a7498ff49b$exports.period).overlap(ph, {
                                            startDate: startDate,
                                            endDate: endDate
                                        })));
                                const isAnyInRangeUnavailable = isRangeOutOfSeries || isAnyInRangeTaken;
                                const isInHoveredRange = hoveredIndex && isRange && i >= hoveredIndex && i - hoveredIndex < rangeCount;
                                return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                                    children: [
                                        i % 10 === 0 && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("br", {}),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                            onMouseOver: ()=>!isTaken && !isAnyInRangeUnavailable && setHoveredIndex(i),
                                            onMouseOut: ()=>setHoveredIndex(undefined),
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))(isTaken ? "forbidden" : isAnyInRangeUnavailable ? "unavailable" : "pick", isInHoveredRange && "highlight"),
                                            title: isTaken ? "Access Number in use" : isAnyInRangeUnavailable ? "Access Number Range partially unavailable" : isRange ? `Available range start for ${rangeCount} numbers` : "Available",
                                            onClick: ()=>!isTaken && !isAnyInRangeUnavailable ? onPickAccessNumber(seriesAccessNumber) : {},
                                            children: seriesAccessNumber
                                        }),
                                        "\xa0"
                                    ]
                                }, seriesAccessNumber);
                            })
                        })
                    ]
                })
            })
        })
    });
};



parcelRequire("fgmOP");






var $ff9mn = parcelRequire("ff9mn");



var $fgmOP = parcelRequire("fgmOP");

var $f968c1cb0c366df8$exports = {};
$f968c1cb0c366df8$exports = "mutation deleteReservedOa($id:ID!){deleteReservedOa(id:$id)}";


var $c1fe3061eb2cf0f8$exports = {};
$c1fe3061eb2cf0f8$exports = "mutation saveReservedOa($reservedOa:ReservedOaInput!$customerId:ID){saveReservedOa(reservedOa:$reservedOa customerId:$customerId){...reservedOaFragment}}fragment reservedOaFragment on ReservedOa{id senderId countryId ownerProductId startDate endDate effect allowedProductIds oaFormatClassifier modifiedDate modifiedBy}";









const $69a9e83e15e141c6$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useSenderIdClassifier", "INFO");
const $69a9e83e15e141c6$var$classifierData = {
    ALPHANUM: {
        id: "ALPHANUM",
        name: "Lowercase alphanumeric text",
        description: "Text match for lowercase alphanumeric string",
        icon: "spell-check"
    },
    NUMBER: {
        id: "NUMBER",
        name: "Phone with country code",
        description: "Phone number match including country code prefix",
        match: /^\+{1}[\d]+$/,
        icon: "roaming"
    },
    SHORTCODE: {
        id: "SHORTCODE",
        name: "Short number",
        description: "Short code match of 3 or 6 digit code",
        match: /^(\d{3,6}){1}$/,
        icon: "smartphone"
    }
};
const $69a9e83e15e141c6$export$7b1ed049266074b0 = ()=>{
    const getClassifier = (id)=>{
        return $69a9e83e15e141c6$var$classifierData[id];
    };
    const getName = (id)=>{
        return getClassifier(id).name;
    };
    const getIcon = (id)=>{
        return getClassifier(id).icon;
    };
    const getClassifierFromSenderId = (senderId)=>{
        if (!senderId || !senderId.length) return null;
        if ($69a9e83e15e141c6$var$classifierData.SHORTCODE.match?.test(senderId)) return $69a9e83e15e141c6$var$classifierData.SHORTCODE.id;
        else if ($69a9e83e15e141c6$var$classifierData.NUMBER.match?.test(senderId)) return $69a9e83e15e141c6$var$classifierData.NUMBER.id;
        else return $69a9e83e15e141c6$var$classifierData.ALPHANUM.id;
    };
    const useSenderIdClassifierHook = {
        classifiers: Object.values($69a9e83e15e141c6$var$classifierData),
        getName: getName,
        getIcon: getIcon,
        getClassifierFromSenderId: getClassifierFromSenderId
    };
    $69a9e83e15e141c6$var$log.debug("render", useSenderIdClassifierHook);
    return useSenderIdClassifierHook;
};











var $fgmOP = parcelRequire("fgmOP");









const $d9df0c7d3d753c54$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("PickProductByAccessNumber", "INFO");
const $d9df0c7d3d753c54$export$aad2586b0cd7fdd8 = (props)=>{
    const { selectedProductIds: selectedProductIds = [], onPickProductByAccessNumber: onPickProductByAccessNumber } = props;
    const { loading: loadingAccessNumberHistory, accessNumberHistoryList: accessNumberHistoryList } = (0, $795fd6aaaa16f06b$export$4324e0562a89d177)();
    const { showInactive: showInactive, showInactiveComponent: showInactiveComponent } = (0, $152b6193e99b7439$export$84f600a904db3b68)();
    const productOverviews = (0, $fgmOP.useMemo)(()=>accessNumberHistoryList?.filter(({ accessNumber: accessNumber })=>accessNumber).map(({ accessNumber: accessNumber, productHistory: productHistory })=>productHistory.filter((product)=>showInactive || (0, $f5d0c2a7498ff49b$exports.period).activeStatus(product) === (0, $f5d0c2a7498ff49b$exports.period).ACTIVE)?.flatMap((product)=>({
                    accessNumber: accessNumber,
                    companyName: product.customerName,
                    productId: product.id,
                    state: (0, $f5d0c2a7498ff49b$exports.period).activeStatus(product)
                }))).flat(), [
        accessNumberHistoryList,
        showInactive
    ]);
    const [filter, setFilter] = (0, $fgmOP.useState)("");
    const filteredProductOverviews = (0, $fgmOP.useMemo)(()=>productOverviews?.filter(({ accessNumber: accessNumber, companyName: companyName, productId: productId })=>accessNumber.startsWith(filter) || companyName.toLowerCase().includes(filter) || productId.startsWith(filter)), [
        filter,
        productOverviews
    ]);
    const filterInput = (0, $fgmOP.useRef)();
    (0, $fgmOP.useEffect)(()=>{
        $d9df0c7d3d753c54$var$log.debug("useEffect", filterInput, filterInput?.current);
        filterInput?.current?.focus();
    }, [
        filterInput.current
    ]);
    $d9df0c7d3d753c54$var$log.debug("render", {
        selectedProductIds: selectedProductIds,
        loadingAccessNumberHistory: loadingAccessNumberHistory,
        accessNumberHistoryList: accessNumberHistoryList,
        productOverviews: productOverviews,
        filterInputCurrent: filterInput.current
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                placeholder: "Filter",
                icon: "search",
                isEditing: true,
                value: filter,
                onChange: (value)=>setFilter((value || "").toLowerCase()),
                inputRef: filterInput
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "marginTop marginBottomHalfRem",
                children: showInactiveComponent
            }),
            loadingAccessNumberHistory ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : !productOverviews || productOverviews.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $25d390e04dd0ffc0$export$2e2bcd8739ae039), {
                children: "No access numbers history found"
            }) : !filteredProductOverviews || filteredProductOverviews.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                children: [
                    "No access numbers products found with current '",
                    filter,
                    "' filter"
                ]
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "",
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $98cbb91c03e56cc2$export$2e2bcd8739ae039), {
                    className: "",
                    children: filteredProductOverviews.map(({ accessNumber: accessNumber, productId: productId, state: state, companyName: companyName }, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d8d7fa9fc21de820$export$2e2bcd8739ae039), {
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                "list__item--selected": selectedProductIds.some((selectedProductId)=>selectedProductId === productId)
                            }),
                            onClick: ()=>productId && onPickProductByAccessNumber(selectedProductIds.cloneToggle(productId).join(", ")),
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox,
                                        value: selectedProductIds.some((selectedProductId)=>selectedProductId === productId),
                                        className: "width1rem",
                                        isEditing: false
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                        className: "width5rem rightText",
                                        children: accessNumber
                                    }),
                                    " -",
                                    " ",
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("width4rem", state.toLowerCase() + "Period"),
                                        children: state
                                    }),
                                    " -",
                                    " ",
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                        className: "width10rem",
                                        children: companyName
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                                        className: "width8rem",
                                        children: [
                                            " (prod: ",
                                            productId,
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        }, i))
                })
            })
        ]
    });
};




parcelRequire("fgmOP");







parcelRequire("fgmOP");





parcelRequire("fgmOP");



const $ce376c355cc87947$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SenderIdInput", "INFO");
const $ce376c355cc87947$export$595093fbd6091dac = ({ formState: formState, showLabels: showLabels = true, isEditing: isEditing = true, entityFieldIdPrefix: entityFieldIdPrefix = "", effect: effect })=>{
    const { classifiers: classifiers, getClassifierFromSenderId: getClassifierFromSenderId } = (0, $69a9e83e15e141c6$export$7b1ed049266074b0)();
    $ce376c355cc87947$var$log.debug("SenderIdInput", {
        formState: formState
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                formState: formState,
                isEditing: isEditing,
                entityFieldId: `${entityFieldIdPrefix}senderId`,
                ...showLabels ? {
                    label: "SenderID",
                    tip: "Unique SenderID (in lower case). Max length is 11 characters."
                } : {
                    placeholder: "SenderID"
                },
                onChangeAlso: (senderId)=>{
                    formState.onChange(`${entityFieldIdPrefix}oaFormatClassifier`)(getClassifierFromSenderId(senderId));
                }
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                formState: formState,
                entityFieldId: `${entityFieldIdPrefix}oaFormatClassifier`,
                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                isEditing: false,
                options: classifiers,
                ...showLabels && {
                    label: "Classifier",
                    tip: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("ul", {
                        children: classifiers.map(({ name: name, description: description })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("b", {
                                        children: name
                                    }),
                                    ": ",
                                    description
                                ]
                            }))
                    })
                }
            })
        ]
    });
};


const $89ea620eb3d21217$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SenderIdForm", "INFO");
const $89ea620eb3d21217$export$cae20410e9b01ec6 = ({ formState: formState })=>{
    const { subEntityAt: subEntityAt } = formState;
    const deleteRow = (rowIndex)=>{
        const updatedsenderIds = subEntityAt("senderIds").clone();
        updatedsenderIds.splice(rowIndex, 1);
        formState.onChange("senderIds")(updatedsenderIds);
    };
    const addRow = ()=>{
        const senderIds = subEntityAt("senderIds");
        formState.onChange("senderIds")([
            ...senderIds,
            {
                senderId: "",
                oaFormatClassifier: null
            }
        ]);
    };
    const senderIds = subEntityAt("senderIds");
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        children: [
            senderIds?.map(({ id: id }, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                    className: "product__technical__features__icon--wrapper",
                                    children: (senderIds.length > 1 || id !== undefined) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                        icon: "trash",
                                        onClick: ()=>deleteRow(i),
                                        info: "Delete",
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("product__technical__features__icon", "product__technical__features__icon--delete")
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ce376c355cc87947$export$595093fbd6091dac), {
                                    formState: formState,
                                    entityFieldIdPrefix: `senderIds[${i}].`,
                                    isEditing: !id,
                                    showLabels: i === 0
                                })
                            ]
                        })
                    })
                }, `senderid-row-${i}`)),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                            kind: "normal",
                            text: "Add row",
                            onClick: addRow
                        })
                    })
                })
            })
        ]
    });
};


const $28dc28500f618054$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SenderIdForm", "INFO");
const $28dc28500f618054$export$655aea63faaaf575 = ({ reservedOa: reservedOa, senderIds: senderIds, onSave: onSave })=>{
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)({
        isEditing: true,
        initialEntity: {
            senderIds: senderIds
        }
    });
    const { subEntityAt: subEntityAt } = formState;
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: "form--compact",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $89ea620eb3d21217$export$cae20410e9b01ec6), {
                formState: formState
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                            kind: "primary",
                            text: "Save",
                            onClick: ()=>{
                                onSave && onSave(reservedOa, subEntityAt("senderIds"));
                            }
                        })
                    })
                })
            })
        ]
    });
};





var $fgmOP = parcelRequire("fgmOP");














const $bed5b827c9dbde3e$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReservedOaForm", "INFO");
const $bed5b827c9dbde3e$export$154a62ca6c897b3d = ({ ownerProductId: ownerProductId, effect: effect, onSaveReservedOa: onSaveReservedOa })=>{
    const { hasPermission: hasPermission, currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)({
        isEditing: false,
        fixedFields: {
            ownerProductId: ownerProductId,
            effect: effect
        }
    });
    const { entity: entity, isEditing: isEditing, onEdit: onEdit, onCancel: onCancel, subEntityAt: subEntityAt } = formState;
    const [isCreating, setIsCreating] = (0, $fgmOP.useState)(false);
    const { getAccessNumberByProductId: getAccessNumberByProductId } = (0, $24ef8762983c02cb$export$4c0ac5f906c0b8d6)();
    const { brandHasCanSendProductType: brandHasCanSendProductType } = (0, $98effcf86fafb9fb$export$75025970e7082eca)();
    //  Allowed sender product ID pick by access number
    const { showModal: showModal, hideModal: hideModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    let modalId;
    const onPickButtonClick = (accessNumberField)=>()=>{
            const config = {
                title: `Pick allowed products by short number`,
                content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d9df0c7d3d753c54$export$aad2586b0cd7fdd8), {
                    selectedProductIds: (0, $6a29cc004e8ac96f$export$da8945421f81f838)(subEntityAt("allowedProductIds")),
                    onPickProductByAccessNumber: onPickAccessNumber(accessNumberField)
                })
            };
            modalId = showModal(config);
        };
    const onPickAccessNumber = (accessNumberField)=>(accessNumber)=>{
            $bed5b827c9dbde3e$var$log.info("onPickAccessNumber", {
                accessNumberField: accessNumberField,
                accessNumber: accessNumber
            });
            formState.onChange(accessNumberField)(accessNumber);
            hideModal(modalId);
        };
    const onSave = ()=>{
        const reservedOa = {
            ...formState.entityAs(),
            allowedProductIds: effect === "DENY" ? undefined : (0, $6a29cc004e8ac96f$export$da8945421f81f838)(subEntityAt("allowedProductIds"))
        };
        $bed5b827c9dbde3e$var$log.debug("onSave", {
            reservedOa: reservedOa
        });
        onSaveReservedOa(reservedOa).then((saveReservedOa)=>{
            saveReservedOa && formState.onCancel();
            saveReservedOa && setIsCreating(false);
            return saveReservedOa;
        });
    };
    $bed5b827c9dbde3e$var$log.debug("ReservedOaFormFc", {
        isCreating: isCreating,
        formState: formState
    });
    return !hasPermission((0, $ca0941499cca84bb$export$b70455accb535b43)) ? null : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
        className: "marginBottom2",
        children: isEditing ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $2e4c8094e1930e9a$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ce376c355cc87947$export$595093fbd6091dac), {
                                formState: formState,
                                effect: effect
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                entity.effect === "ALLOW" && currentUserBrand && brandHasCanSendProductType(currentUserBrand?.id) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "allowedProductIds",
                                    label: "Allowed Short Num.",
                                    isDisabled: true,
                                    isEditing: false,
                                    value: entity.effect === "ALLOW" ? (0, $6a29cc004e8ac96f$export$da8945421f81f838)(subEntityAt("allowedProductIds")).map((allowedProductId)=>getAccessNumberByProductId(allowedProductId) || "???").join((0, $6a29cc004e8ac96f$export$c9b0ebc05e3e420a)) : "na",
                                    button: isEditing && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                        text: "Pick",
                                        className: "floatRight",
                                        onClick: onPickButtonClick("allowedProductIds")
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {})
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                            text: entity.effect === "ALLOW" ? "Reserve" : "Block",
                            onClick: onSave,
                            kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary,
                            isDisabled: !formState.entity?.oaFormatClassifier
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                            text: "Cancel",
                            onClick: onCancel,
                            kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel
                        })
                    ]
                })
            ]
        }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
            text: effect === "DENY" ? "Block SenderID" : "Reserve SenderID",
            onClick: onEdit,
            kind: "normal"
        })
    });
};


const $6a29cc004e8ac96f$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReservedOas", "INFO");
const { activeStatus: $6a29cc004e8ac96f$var$activeStatus } = (0, $f5d0c2a7498ff49b$exports.period);
const $6a29cc004e8ac96f$export$c9b0ebc05e3e420a = ", ";
const $6a29cc004e8ac96f$export$da8945421f81f838 = (comaSeparatedIds)=>comaSeparatedIds?.split($6a29cc004e8ac96f$export$c9b0ebc05e3e420a).map((id)=>id.trim()).filter((id)=>id.length > 0) || [];
const $6a29cc004e8ac96f$export$3f83a1de419856a9 = ({ customerId: customerId, ownerProductId: ownerProductId, effect: effect, allowAdmin: allowAdmin })=>{
    const { isTelia: isTelia, isCustomer: isCustomer, hasPermission: hasPermission, currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { getCompanyNameByProductId: getCompanyNameByProductId, getAccessNumberByProductId: getAccessNumberByProductId, getCustomerIdByProductId: getCustomerIdByProductId } = (0, $24ef8762983c02cb$export$4c0ac5f906c0b8d6)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const { brandHasCanSendProductType: brandHasCanSendProductType } = (0, $98effcf86fafb9fb$export$75025970e7082eca)();
    const { getName: getName, getIcon: getIcon } = (0, $69a9e83e15e141c6$export$7b1ed049266074b0)();
    const currentUserCountryId = currentUserBrand?.countryId;
    const { data: { reservedOas: reservedOas } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($cb40802b0ad9775f$exports)))), {
        variables: {
            countryId: currentUserCountryId,
            ...isTelia() ? {} //  in order to have more consistent cache updating under Telia users managing Reserved OAs
             : {
                ownerProductId: ownerProductId,
                customerId: customerId
            }
        }
    });
    const filteredReservedOas = (0, $fgmOP.useMemo)(()=>(reservedOas || []).filter((roa)=>!effect || effect === roa.effect).filter((roa)=>!ownerProductId || ownerProductId === roa.ownerProductId).map(({ allowedProductIds: allowedProductIds, ...reservedOa })=>{
            const sortedAllowedProducts = allowedProductIds?.map((productId)=>({
                    productId: productId,
                    accessNumber: getAccessNumberByProductId(productId)
                })).sort((0, $ff9mn.withAccessNumbersSortComparator));
            return {
                ...reservedOa,
                senderIds: [
                    {
                        ...reservedOa
                    }
                ],
                allowedProductIds: allowedProductIds,
                companyName: reservedOa.ownerProductId ? getCompanyNameByProductId(reservedOa.ownerProductId) : undefined,
                customerId: reservedOa.ownerProductId ? getCustomerIdByProductId(reservedOa.ownerProductId) : undefined,
                allowedProducts: sortedAllowedProducts,
                accessNumber: sortedAllowedProducts?.head()?.accessNumber,
                activeStatus: $6a29cc004e8ac96f$var$activeStatus(reservedOa)
            };
        }).reduce((prev, reservedOa)=>{
            // Find existing entry with identical list of allowed access numbers
            const existingReservedOas = prev.find(({ id: id, allowedProducts: allowedProducts }, i)=>allowedProducts?.length === reservedOa.allowedProducts?.length && id !== reservedOa.id && allowedProducts?.every(({ productId: productId, accessNumber: accessNumber })=>reservedOa.allowedProducts?.find((allowedProduct)=>allowedProduct.accessNumber === accessNumber && allowedProduct.productId === productId)));
            // If an existing entry with identical list of allowed access numbers was found, add entry
            if (existingReservedOas) existingReservedOas.senderIds?.push({
                id: reservedOa.id,
                senderId: reservedOa.senderId,
                oaFormatClassifier: reservedOa.oaFormatClassifier
            });
            else prev = [
                ...prev,
                reservedOa
            ];
            return prev;
        }, []), [
        reservedOas,
        getCompanyNameByProductId
    ]);
    const [sortedReservedOas, getThSortableProps] = (0, $c1364c3d18563e9b$export$2e2bcd8739ae039).useThSortable(filteredReservedOas, 3, [], {
        // @ts-ignore: special comparators not well defined
        accessNumber: (0, $ff9mn.accessNumbersSortComparator)
    });
    const saveReservedOa = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($c1fe3061eb2cf0f8$exports)))));
    const onSaveReservedOa = (reservedOa)=>{
        //  Define ReservedOaInput type
        $6a29cc004e8ac96f$var$log.debug("onSaveReservedOa", {
            reservedOa: reservedOa
        });
        return saveReservedOa({
            loadingText: "Saving SenderID...",
            successText: "SenderID saved",
            variables: {
                ...isCustomer() && {
                    customerId: customerId
                },
                reservedOa: reservedOa
            },
            update: (proxy, { data: updateData })=>{
                const { saveReservedOa: saveReservedOa } = updateData || {};
                const { reservedOas: reservedOas = [] } = proxy.readQuery({
                    query: (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($cb40802b0ad9775f$exports)))),
                    variables: {
                        countryId: currentUserCountryId
                    }
                }) || {};
                const updateReservedOas = reservedOas.filter(({ id: id })=>reservedOa.id !== id);
                saveReservedOa && updateReservedOas.push(saveReservedOa);
                $6a29cc004e8ac96f$var$log.debug("saveReservedOa update", {
                    saveReservedOa: saveReservedOa,
                    reservedOas: reservedOas,
                    updateReservedOas: updateReservedOas
                });
                proxy.writeQuery({
                    query: (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($cb40802b0ad9775f$exports)))),
                    data: {
                        reservedOas: updateReservedOas
                    },
                    variables: {
                        countryId: currentUserCountryId
                    }
                });
            }
        }).then(({ data: data })=>{
            const { saveReservedOa: saveReservedOa } = data || {
                saveReservedOa: undefined
            };
            $6a29cc004e8ac96f$var$log.debug("saveReservedOaMutate resolved", saveReservedOa);
            return saveReservedOa;
        });
    };
    const { showModal: showModal, hideModal: hideModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const senderIdModalRef = (0, $fgmOP.useRef)();
    const onSaveSenderIds = (previousSenderIds)=>(reservedOa, senderIds)=>{
            hideModal(senderIdModalRef.current);
            const newSenderIds = senderIds?.reduce((prev, curr)=>curr.id === undefined ? [
                    ...prev,
                    curr
                ] : prev, []);
            const deletedSenderIds = previousSenderIds?.reduce((prev, curr)=>!senderIds?.find(({ id: id })=>id === curr.id) ? [
                    ...prev,
                    curr
                ] : prev, []);
            newSenderIds?.forEach(({ id: id, senderId: senderId, oaFormatClassifier: oaFormatClassifier })=>onSaveReservedOa(toReservedOaInput({
                    ...reservedOa,
                    id: id,
                    senderId: senderId,
                    oaFormatClassifier: oaFormatClassifier
                })));
            if (deletedSenderIds && deletedSenderIds.length > 0) onDeleteReservedOa(deletedSenderIds);
        };
    const onEditSenderIds = (reservedOa, senderIds)=>{
        senderIdModalRef.current = showModal({
            title: "Add/Remove senderIds",
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $28dc28500f618054$export$655aea63faaaf575), {
                reservedOa: reservedOa,
                senderIds: senderIds,
                onSave: onSaveSenderIds(senderIds)
            })
        });
    };
    const onEditAllowedSenders = (reservedOa, senderIds)=>{
        const { senderId: senderId, allowedProductIds: allowedProductIds } = reservedOa;
        const editAllowedSendersModalId = showModal({
            title: "Add/Remove allowed senders for Reserved SenderID: " + senderId,
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d9df0c7d3d753c54$export$aad2586b0cd7fdd8), {
                selectedProductIds: allowedProductIds,
                onPickProductByAccessNumber: (comaSeparatedProductIds)=>{
                    onUpdatedAllowedProductIds(senderIds, comaSeparatedProductIds);
                    hideModal(editAllowedSendersModalId);
                }
            })
        });
        $6a29cc004e8ac96f$var$log.info("onEditReservedOa", reservedOa);
    };
    const onUpdatedAllowedProductIds = (senderIds, comaSeparatedProductIds)=>{
        senderIds.forEach(({ id: id })=>{
            const reservedOa = reservedOas?.find((reservedOa)=>reservedOa.id === id);
            if (!reservedOa) return;
            const allowedProductIds = $6a29cc004e8ac96f$export$da8945421f81f838(comaSeparatedProductIds);
            const reservedOaInput = toReservedOaInput({
                ...reservedOa,
                allowedProductIds: allowedProductIds
            });
            $6a29cc004e8ac96f$var$log.info("onUpdatedAllowedProductIds", comaSeparatedProductIds, allowedProductIds, reservedOa, reservedOaInput);
            onSaveReservedOa(reservedOaInput).then($6a29cc004e8ac96f$var$log.debug);
        });
    };
    const toReservedOaInput = ({ id: id, senderId: senderId, effect: effect, ownerProductId: ownerProductId, oaFormatClassifier: oaFormatClassifier, allowedProductIds: allowedProductIds, ...reservedOa })=>({
            id: id,
            senderId: senderId,
            effect: effect,
            ownerProductId: ownerProductId,
            oaFormatClassifier: oaFormatClassifier,
            allowedProductIds: allowedProductIds
        });
    const onDeleteReservedOa = (senderIds)=>{
        showModal({
            title: `Delete SenderID${senderIds.length > 1 ? "s" : ""}`,
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                children: [
                    "Are you sure you want to delete",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("b", {
                        children: senderIds.map(({ senderId: senderId }, i, { length: length })=>` '${senderId}'` + (i < length - 2 ? "," : i === length - 2 ? " &" : " " // Format array: 'abc', '123', 'efg' & '456'
                            ))
                    }),
                    "from the reserved OAs?"
                ]
            }),
            confirmText: "Delete",
            confirmType: "negative",
            onConfirm: ()=>senderIds.forEach(({ id: id })=>onConfirmDelete(id))
        });
    };
    const deleteReservedOa = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($f968c1cb0c366df8$exports)))));
    const onConfirmDelete = (id)=>{
        $6a29cc004e8ac96f$var$log.debug("onConfirmDelete");
        deleteReservedOa({
            loadingText: "Deleting SenderID...",
            successText: "SenderID deleted",
            variables: {
                id: id
            },
            update: (proxy, {})=>{
                const data = proxy.readQuery({
                    query: (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($cb40802b0ad9775f$exports)))),
                    variables: {
                        countryId: currentUserCountryId
                    }
                }) || {
                    reservedOas: []
                };
                const reservedOas = data.reservedOas.filter((reservedOa)=>reservedOa.id !== id);
                $6a29cc004e8ac96f$var$log.debug("deleteReservedOa update", {
                    id: id,
                    data: data,
                    reservedOas: reservedOas
                });
                proxy.writeQuery({
                    query: (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($cb40802b0ad9775f$exports)))),
                    variables: {
                        countryId: currentUserCountryId
                    },
                    data: {
                        reservedOas: reservedOas
                    }
                });
            }
        }).then($6a29cc004e8ac96f$var$log.debug);
    };
    $6a29cc004e8ac96f$var$log.debug("ReservedOasFc", {
        reservedOas: reservedOas
    });
    const { THead: THead, Th: Th, Tr: Tr, ThSortable: ThSortable, TBody: TBody, Td: Td } = (0, $c1364c3d18563e9b$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            sortedReservedOas && !sortedReservedOas.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039), {
                clickable: false,
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(THead, {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)(Tr, {
                            children: [
                                allowAdmin && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Th, {
                                    className: "minWidth"
                                }),
                                effect === "ALLOW" && allowAdmin && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Th, {
                                    className: "minWidth"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(ThSortable, {
                                    ...getThSortableProps("senderId"),
                                    className: "leftText",
                                    children: "SenderID(s)"
                                }),
                                !effect && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(ThSortable, {
                                    ...getThSortableProps("effect"),
                                    children: "Effect"
                                }),
                                !ownerProductId && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(ThSortable, {
                                    ...getThSortableProps("companyName"),
                                    children: "Customer"
                                }),
                                !ownerProductId && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(ThSortable, {
                                    ...getThSortableProps("ownerProductId"),
                                    children: "Service"
                                }),
                                effect !== "DENY" && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(ThSortable, {
                                            ...getThSortableProps("accessNumber"),
                                            children: "Allowed short numbers"
                                        }),
                                        allowAdmin && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Th, {
                                            className: "minWidth"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(TBody, {
                        children: sortedReservedOas?.map(({ companyName: reservedOaCompanyName, customerId: reservedOaCustomerId, allowedProducts: reservedOaAllowedProducts, accessNumber: accessNumber, activeStatus: activeStatus, startDate: startDate, endDate: endDate, ...reservedOa }, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)(Tr, {
                                children: [
                                    allowAdmin && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                        className: "minWidth",
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                            icon: "trash",
                                            className: "redText pointer rem1",
                                            onClick: ()=>onDeleteReservedOa(reservedOa.senderIds)
                                        })
                                    }),
                                    allowAdmin && reservedOa.effect === "ALLOW" && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                        className: "minWidth",
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                            icon: "edit",
                                            className: "blueText pointer rem1 marginRight",
                                            onClick: ()=>onEditSenderIds(reservedOa, reservedOa.senderIds)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                        style: {
                                            textAlign: "left",
                                            display: "flex",
                                            flexWrap: "wrap"
                                        },
                                        children: (reservedOa.senderIds?.length ? reservedOa.senderIds : [
                                            {
                                                ...reservedOa
                                            }
                                        ]).map(({ senderId: senderId, oaFormatClassifier: oaFormatClassifier }, i, senderIds)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                                style: {
                                                    whiteSpace: "nowrap"
                                                },
                                                children: [
                                                    oaFormatClassifier && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                                        className: "rem1_25",
                                                        icon: getIcon(oaFormatClassifier),
                                                        info: getName(oaFormatClassifier)
                                                    }),
                                                    senderId,
                                                    i < senderIds.length - 1 && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                        className: "marginRight",
                                                        children: ","
                                                    })
                                                ]
                                            }))
                                    }),
                                    !effect && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))(reservedOa.effect !== "ALLOW" && "redText"),
                                        children: reservedOa.effect === "ALLOW" ? "Allow" : "Block"
                                    }),
                                    !ownerProductId && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                            disabled: !reservedOa.ownerProductId
                                        }),
                                        children: reservedOa.ownerProductId ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                                            to: formatWithBrand($e9a95c61c800ecd2$export$80abc9f9ce9de04c, reservedOaCustomerId),
                                            children: reservedOaCompanyName || "???"
                                        }) : "System"
                                    }),
                                    !ownerProductId && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                            disabled: !reservedOa.ownerProductId
                                        }),
                                        children: reservedOa.ownerProductId ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                                            to: formatWithBrand($e9a95c61c800ecd2$export$844e157d47c2ab60, reservedOa.ownerProductId),
                                            children: reservedOa.ownerProductId
                                        }) : "System"
                                    }),
                                    effect !== "DENY" && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                            disabled: !reservedOaAllowedProducts?.length
                                        }),
                                        children: reservedOaAllowedProducts?.map(({ productId: productId, accessNumber: accessNumber }, index, all)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                                                children: [
                                                    hasPermission((0, $ca0941499cca84bb$export$5baf0ad38a5e4791)) ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                                                        to: formatWithBrand($e9a95c61c800ecd2$export$844e157d47c2ab60, productId),
                                                        children: accessNumber || "???"
                                                    }) : accessNumber || "???",
                                                    index < all.length - 1 && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                        children: ", "
                                                    })
                                                ]
                                            }, index)) || "na"
                                    }),
                                    (hasPermission((0, $ca0941499cca84bb$export$b70455accb535b43)) || hasPermission((0, $ca0941499cca84bb$export$68386f5280c68bd1))) && effect === "ALLOW" && currentUserBrand?.id && brandHasCanSendProductType(currentUserBrand?.id) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                        className: "minWidth",
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                            icon: "edit",
                                            className: "blueText pointer rem1",
                                            onClick: ()=>onEditAllowedSenders(reservedOa, reservedOa.senderIds)
                                        })
                                    })
                                ]
                            }, i))
                    })
                ]
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                children: [
                    "There are no ",
                    effect === "DENY" ? "blocked" : "reserved",
                    " SenderIDs"
                ]
            }),
            allowAdmin && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bed5b827c9dbde3e$export$154a62ca6c897b3d), {
                ownerProductId: ownerProductId,
                effect: effect,
                onSaveReservedOa: onSaveReservedOa
            })
        ]
    });
};





const $4f298aa2be767f10$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ProvisionReservedOas", "INFO");
const $4f298aa2be767f10$export$1b1eceeab469768d = ({ startDate: startDate, endDate: endDate, ownerProductId: ownerProductId })=>{
    const { customerId: customerId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const { isTelia: isTelia, hasPermission: hasPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    $4f298aa2be767f10$var$log.debug("render", {
        ownerProductId: ownerProductId
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("h3", {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                        icon: "security",
                        className: "blueText vertical-align-bottom"
                    }),
                    "Reserved SenderIDs"
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6a29cc004e8ac96f$export$3f83a1de419856a9), {
                effect: "ALLOW",
                ownerProductId: ownerProductId,
                customerId: customerId,
                allowAdmin: hasPermission((0, $ca0941499cca84bb$export$b70455accb535b43))
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("br", {}),
            hasPermission((0, $ca0941499cca84bb$export$b70455accb535b43)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("h3", {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                icon: "warning",
                                className: "redText vertical-align-bottom"
                            }),
                            "Blocked SenderIDs (Visible only for Telia users)"
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6a29cc004e8ac96f$export$3f83a1de419856a9), {
                        effect: "DENY",
                        ownerProductId: ownerProductId,
                        customerId: customerId,
                        allowAdmin: hasPermission((0, $ca0941499cca84bb$export$b70455accb535b43))
                    })
                ]
            })
        ]
    });
};




parcelRequire("fgmOP");






parcelRequire("fgmOP");








const $25de2a4562a40438$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("PendingUsers", "INFO");
const { activeStatus: $25de2a4562a40438$var$activeStatus, isValid: $25de2a4562a40438$var$isValid } = (0, $f5d0c2a7498ff49b$exports.period);
const $25de2a4562a40438$export$1c317f5be70d1aa1 = ({ product: product, id: id, saveCallback: saveCallback })=>{
    const i = product.features?.findIndex((feature)=>feature.id === id);
    const fieldPrefix = `features[${i}]`;
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)({
        isEditing: true,
        initialEntity: product
    });
    const { isEditing: isEditing, onChange: onChange, entityAs: entityAs } = formState;
    const entity = entityAs();
    const feature = entity.features ? entity.features[i] : undefined;
    $25de2a4562a40438$var$log.debug("FeatureForm", product, feature);
    const { showModal: showModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const { getProductTypeFeatures: getProductTypeFeatures } = (0, $98effcf86fafb9fb$export$75025970e7082eca)();
    const onSaveFeature = async ()=>{
        const product = {
            ...entity
        };
        $25de2a4562a40438$var$log.debug("onSaveFeature", {
            product: product
        });
        saveCallback(product);
    };
    let modalId = "";
    const updateAccessNumberRange = (from, count)=>{
        const accessNumberRange = {
            from: from,
            to: !from || !count ? undefined : (0, $f5d0c2a7498ff49b$exports.range).rangeTo(from, count),
            count: count
        };
        $25de2a4562a40438$var$log.debug("updateAccessNumberRange ", accessNumberRange);
        onChange("accessNumberRange")(accessNumberRange);
    };
    const onPickAccessNumber = (accessNumberField)=>(accessNumber)=>{
            onChange(accessNumberField)(accessNumber);
            if (accessNumberField === "accessNumberRange.from") {
                const count = entity.accessNumberRange?.count;
                updateAccessNumberRange(accessNumber, count);
            }
            // need to create an updated entity, since react has not yet triggered a useFormState update so old state still appears in entity
            const updatedEntity = {
                ...entity,
                features: entity.features?.map((feature)=>{
                    if (feature.id === id) return {
                        ...feature,
                        featureProperties: {
                            ...feature.featureProperties,
                            accessNumberId: accessNumber
                        }
                    };
                    return feature;
                })
            };
            const config = {
                title: `${id ? "Edit" : "Create"}  Feature`,
                content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($25de2a4562a40438$export$1c317f5be70d1aa1, {
                    product: updatedEntity,
                    id: id,
                    saveCallback: saveCallback
                })
            };
            showModal(config);
        };
    const onPickButtonClick = (accessNumberField)=>()=>{
            const config = {
                title: `Pick access number`,
                content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $36a4608a51053324$export$a0cbf456f5f6d2a2), {
                    productType: entity.productType,
                    productId: entity.id,
                    featureType: entity.features?.[i]?.featureTypeId,
                    featureId: entity.features?.[i]?.id,
                    currentNumber: entity.features?.[i].featureProperties?.accessNumberId,
                    rangeCount: entity.accessNumberRange?.count,
                    startDate: entity.features?.[i]?.startDate || entity.startDate,
                    endDate: entity.features?.[i]?.endDate || entity.endDate,
                    onPickAccessNumber: onPickAccessNumber(accessNumberField)
                })
            };
            modalId = showModal(config);
        };
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
        className: "marginBottom2 form--compact",
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $a82309880227f2e9$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: `${fieldPrefix}.featureTypeId`,
                                    label: "Feature Type",
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                    options: getProductTypeFeatures(entity.productType)
                                })
                            })
                        }),
                        entity.features && entity.features[i]?.featureTypeId /* This will need more validation when we add more featureTypes */  && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: `${fieldPrefix}.featureProperties.accessNumberId`,
                                        label: "Access Number",
                                        tip: !$25de2a4562a40438$var$isValid(entity) && `Disabled because dates are ${$25de2a4562a40438$var$activeStatus(entity)}.`,
                                        button: isEditing && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                            text: "Pick",
                                            className: "floatRight",
                                            onClick: onPickButtonClick(`${fieldPrefix}.featureProperties.accessNumberId`),
                                            isDisabled: !$25de2a4562a40438$var$isValid(entity)
                                        }),
                                        isDisabled: !$25de2a4562a40438$var$isValid(entity)
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {})
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: `${fieldPrefix}.startDate`,
                                        label: "Feature start date",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date,
                                        defaultValue: feature?.startDate,
                                        tip: "Leave empty to inherit service's start date"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: `${fieldPrefix}.endDate`,
                                        label: "Feature end date",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date,
                                        defaultValue: feature?.endDate,
                                        tip: "Leave empty to inherit service's end date"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("br", {})
                    ]
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                        text: "Save",
                        onClick: onSaveFeature,
                        kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary
                    })
                })
            ]
        })
    });
};





var $iEMYl = parcelRequire("iEMYl");




var $fgmOP = parcelRequire("fgmOP");









const $7d43655f3cd9f5ce$var$getAccessNumberName = (featureTypeId)=>{
    switch(featureTypeId){
        case "RECEIVE_ON_SHORT_NUMBER":
            return "Short Number";
        case "RECEIVE_ON_LONG_NUMBER":
            return "Long Number";
        default:
            return "Access Number";
    }
};
const $7d43655f3cd9f5ce$export$e2b8eb038115bae6 = ({ product: product, showActions: showActions, saveCallback: saveCallback, onUpdate: onUpdate })=>{
    const { showModal: showModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const { getProductTypeFeature: getProductTypeFeature } = (0, $98effcf86fafb9fb$export$75025970e7082eca)();
    const { getFeature: getFeature } = (0, $112a7c90a6dc0b9c$export$b90441f04b7a6203)();
    const { showInactiveComponent: showInactiveComponent, showInactive: showInactive } = (0, $152b6193e99b7439$export$84f600a904db3b68)();
    const enrichedFeatures = (0, $fgmOP.useMemo)(()=>product.features?.map((feature)=>({
                ...feature,
                activeStatus: (0, $iEMYl.activeStatus)({
                    startDate: feature.startDate || product.startDate,
                    endDate: feature.endDate || product.endDate
                }),
                featurePropertiesAccessNumberId: feature.featureProperties?.accessNumberId
            })).filter(({ activeStatus: activeStatus })=>showInactive || activeStatus === "ACTIVE") || [], [
        product,
        showInactive
    ]);
    const [sortedFeatures, getThSortableProps] = (0, $a129443168ef7da6$exports.useThSortable)(enrichedFeatures);
    const onDelete = (featureId)=>{
        const feature = getFeature(product, featureId);
        showModal({
            title: "Delete feature",
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                children: [
                    feature && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $98cbb91c03e56cc2$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d8d7fa9fc21de820$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("b", {
                                        children: getProductTypeFeature(product.productType, feature.featureTypeId)?.name
                                    }),
                                    feature.featureProperties?.accessNumberId && " - ",
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("b", {
                                        children: feature.featureProperties?.accessNumberId
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                        children: "Are you sure you want to delete this feature?"
                    })
                ]
            }),
            confirmText: "Delete",
            confirmType: "negative",
            onConfirm: ()=>onConfirmDelete(featureId)
        });
    };
    const onConfirmDelete = (featureId)=>{
        saveCallback({
            ...product,
            features: product.features?.filter((feature)=>feature.id !== featureId)
        });
    };
    const { THead: THead, Th: Th, Tr: Tr, ThSortable: ThSortable, TBody: TBody, Td: Td } = (0, $c1364c3d18563e9b$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            showInactiveComponent,
            sortedFeatures.length === 0 ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$2e2bcd8739ae039), {
                className: "marginTop",
                children: "No active features"
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(THead, {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)(Tr, {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(ThSortable, {
                                    ...getThSortableProps("featureTypeId"),
                                    children: "Feature"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(ThSortable, {
                                    ...getThSortableProps("featurePropertiesAccessNumberId"),
                                    children: "Properties"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(ThSortable, {
                                    ...getThSortableProps("startDate"),
                                    children: "Start date"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(ThSortable, {
                                    ...getThSortableProps("endDate"),
                                    children: "End date"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(ThSortable, {
                                    ...getThSortableProps("activeStatus"),
                                    className: "maxWidth10rem",
                                    children: "Active Status"
                                }),
                                showActions && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Th, {
                                            className: "minWidth"
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Th, {
                                            className: "minWidth"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(TBody, {
                        children: sortedFeatures.map((feature, i)=>{
                            const { id: id, featureTypeId: featureTypeId, startDate: startDate, endDate: endDate, featureProperties: featureProperties, activeStatus: activeStatus } = feature;
                            const productFeatureType = getProductTypeFeature(product.productType, featureTypeId);
                            return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)(Tr, {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                    inactive: activeStatus !== "ACTIVE"
                                }),
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)(Td, {
                                        children: [
                                            productFeatureType?.name || featureTypeId,
                                            productFeatureType?.description && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $acf38b6c25932409$export$2e2bcd8739ae039), {
                                                children: productFeatureType.description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                        children: featureProperties?.accessNumberId ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("i", {
                                                    className: "disabled",
                                                    children: [
                                                        $7d43655f3cd9f5ce$var$getAccessNumberName(featureTypeId),
                                                        " - "
                                                    ]
                                                }),
                                                featureProperties.accessNumberId
                                            ]
                                        }) : "no properties"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                            disabled: !startDate
                                        }),
                                        children: startDate ? (0, $f5d0c2a7498ff49b$exports.format).date(startDate) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                                            children: [
                                                (0, $f5d0c2a7498ff49b$exports.format).date(product.startDate),
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $acf38b6c25932409$export$2e2bcd8739ae039), {
                                                    children: "Inherited from service"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                            disabled: !endDate
                                        }),
                                        children: endDate ? (0, $f5d0c2a7498ff49b$exports.format).date(endDate) : product.endDate ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                                            children: [
                                                (0, $f5d0c2a7498ff49b$exports.format).date(product.endDate),
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $acf38b6c25932409$export$2e2bcd8739ae039), {
                                                    children: "Inherited from service"
                                                })
                                            ]
                                        }) : "no end"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))(activeStatus.toLowerCase() + "Period", "maxWidth10rem"),
                                        children: activeStatus
                                    }),
                                    showActions && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                                className: "minWidth",
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                                    icon: "edit",
                                                    className: "blueText pointer rem1_25 marginLeft",
                                                    onClick: ()=>onUpdate(feature)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                                className: "minWidth",
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                                    icon: "delete",
                                                    className: "redText pointer rem1_25 ",
                                                    onClick: ()=>onDelete(id)
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }, id);
                        })
                    })
                ]
            })
        ]
    });
};


const $da9b4505e0d42a56$export$af2e3040d613d334 = ({ formState: formState, onSave: onSave })=>{
    const { isEditing: isEditing, entityAs: entityAs } = formState;
    const entity = entityAs();
    const { showModal: showModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const onUpdate = (feature)=>{
        showModal({
            title: `${feature.id ? "Edit" : "Create"}  Feature`,
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $25de2a4562a40438$export$1c317f5be70d1aa1), {
                product: {
                    ...entity,
                    features: [
                        ...entity.features || [],
                        ...!feature.id ? [
                            feature
                        ] : []
                    ]
                },
                id: feature.id,
                saveCallback: onSave
            })
        });
    };
    const onAdd = ()=>{
        const newFeature = {
            id: ""
        };
        onUpdate(newFeature);
    };
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("hr", {
                className: "horizontal-rule marginTop2"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                children: [
                    "Service Features",
                    !isEditing && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                        text: "Add feature",
                        className: "marginLeft",
                        onClick: onAdd
                    })
                ]
            }),
            entity.features && entity.features.length > 0 ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $7d43655f3cd9f5ce$export$e2b8eb038115bae6), {
                product: entity,
                showActions: !isEditing,
                saveCallback: onSave,
                onUpdate: onUpdate
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$2e2bcd8739ae039), {
                children: "No features provisioned yet"
            })
        ]
    });
};





var $g6Bzp = parcelRequire("g6Bzp");



var $fgmOP = parcelRequire("fgmOP");

var $85c3e3a7230373aa$exports = {};
$85c3e3a7230373aa$exports = "mutation generateSecret($customerId:ID!$contractId:ID!$productId:ID!$protocol:EndpointProtocol){generateSecret(customerId:$customerId contractId:$contractId productId:$productId protocol:$protocol){clientId secret secretLastUpdated}}";


var $989a550bf093bfad$exports = {};
$989a550bf093bfad$exports = "mutation saveProductTechnical($customerId:String!$contractId:String!$productId:String!$productTechnical:ProductTechnicalInput!){saveProductTechnical(customerId:$customerId contractId:$contractId productId:$productId productTechnical:$productTechnical){...productTechnicalFragment}}fragment productTechnicalFragment on ProductTechnical{...productTechnicalBaseFragment smppApiConfig{...smppApiConfigFragment}}fragment smppApiConfigFragment on SmppApiConfig{defaultCharset windowSize maxWindowSize maxSessions minReceiverSessionAlarmThreshold minTransmitterSessionAlarmThreshold}fragment productTechnicalBaseFragment on ProductTechnical{id features protocol apiCredentials{clientId secretLength secretLastUpdated}endpoints{mo{endpoint protocol username password}dr{endpoint protocol username password}}}";


var $5e246e8a477e946c$exports = {};
$5e246e8a477e946c$exports = "query productTechnical($customerId:ID!$contractId:ID!$productId:ID!){productTechnical(customerId:$customerId contractId:$contractId productId:$productId){...productTechnicalFragment}}fragment productTechnicalFragment on ProductTechnical{...productTechnicalBaseFragment smppApiConfig{...smppApiConfigFragment}}fragment smppApiConfigFragment on SmppApiConfig{defaultCharset windowSize maxWindowSize maxSessions minReceiverSessionAlarmThreshold minTransmitterSessionAlarmThreshold}fragment productTechnicalBaseFragment on ProductTechnical{id features protocol apiCredentials{clientId secretLength secretLastUpdated}endpoints{mo{endpoint protocol username password}dr{endpoint protocol username password}}}";









var $l8GLF = parcelRequire("l8GLF");











var $fgmOP = parcelRequire("fgmOP");









const $68905fbd5cd29bdb$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ProductTechnicalFeatures", "INFO");
const $68905fbd5cd29bdb$var$EMPTY_FEATURE_ROW = {
    featureKey: "",
    featureValue: ""
};
const $68905fbd5cd29bdb$export$772a5c0050fa028b = ({ formState: formState })=>{
    const { isEditing: isEditing } = formState;
    const technical = formState.entityAs();
    const initialFeatureRows = ()=>{
        return technical.features?.split(";").map((row)=>{
            const feature = row.split("=");
            return {
                featureKey: feature[0],
                featureValue: feature[1]
            };
        }) || [];
    };
    const [featureRows, setFeatureRows] = (0, $fgmOP.useState)(initialFeatureRows());
    (0, $fgmOP.useEffect)(()=>{
        if (!isEditing) {
            const rows = initialFeatureRows();
            if (rows.length !== featureRows.length || rows.some(({ featureKey: featureKey, featureValue: featureValue }, i)=>featureKey !== featureRows[i].featureKey || featureValue !== featureRows[i].featureValue)) setFeatureRows(rows);
        }
    }, [
        technical
    ]);
    (0, $fgmOP.useEffect)(()=>{
        const newFeatures = featureRows.map((row)=>`${row.featureKey}=${row.featureValue}`).join(";");
        $68905fbd5cd29bdb$var$log.debug("newFeatures", newFeatures);
        formState.onChange("features")(newFeatures);
    }, [
        featureRows
    ]);
    const deleteRow = (rowIndex)=>{
        const updatedFeatureRows = featureRows.clone();
        updatedFeatureRows.splice(rowIndex, 1);
        setFeatureRows(updatedFeatureRows);
    };
    $68905fbd5cd29bdb$var$log.debug("features", {
        features: technical.features
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
        className: "form-group",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                children: [
                    "Service Features",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $acf38b6c25932409$export$2e2bcd8739ae039), {
                        text: "Service features will be encoded on the format 'key1=value1;key2=value2', for use in other services."
                    })
                ]
            }),
            featureRows && !featureRows.isEmpty() && featureRows?.map(({ featureKey: featureKey, featureValue: featureValue }, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                ...i === 0 && {
                                    label: "Key"
                                },
                                value: featureKey,
                                placeholder: "Key",
                                onChange: (value)=>{
                                    const newTechnicalRows = featureRows.clone();
                                    newTechnicalRows[i].featureKey = value?.toString() || "";
                                    setFeatureRows(newTechnicalRows);
                                },
                                isEditing: isEditing
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                ...i === 0 && {
                                    label: "Value"
                                },
                                value: featureValue,
                                placeholder: "Value",
                                onChange: (value)=>{
                                    const newTechnicalRows = featureRows.clone();
                                    newTechnicalRows[i].featureValue = value?.toString() || "";
                                    setFeatureRows(newTechnicalRows);
                                },
                                isEditing: isEditing
                            }),
                            isEditing && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                className: "product__technical__features__icon--wrapper",
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                    icon: "trash",
                                    onClick: ()=>deleteRow(i),
                                    info: "Delete",
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("product__technical__features__icon", "product__technical__features__icon--delete")
                                })
                            })
                        ]
                    })
                }, `feature-row-${i}`)),
            (!featureRows || featureRows.length === 0) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: !isEditing ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                label: "Key",
                                placeholder: "Key",
                                isEditing: isEditing
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                label: "Value",
                                placeholder: "Value",
                                isEditing: isEditing
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("label", {
                                className: "label",
                                children: "Key"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("label", {
                                className: "label",
                                children: "Value"
                            })
                        ]
                    })
                })
            }),
            isEditing && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                            kind: "normal",
                            text: "Add row",
                            onClick: ()=>setFeatureRows((currRows)=>[
                                        ...currRows,
                                        {
                                            ...$68905fbd5cd29bdb$var$EMPTY_FEATURE_ROW
                                        }
                                    ])
                        })
                    })
                })
            })
        ]
    });
};


const $99cc06fc8e1abb51$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ProductTechnical", "INFO");
const $99cc06fc8e1abb51$var$noCallbackPlaceholder = "No callback";
const $99cc06fc8e1abb51$export$7ea64f2593104482 = ({ productTypeId: productTypeId })=>{
    const [isSecretValidMessage, setIsSecretValidMessage] = (0, $fgmOP.useState)("");
    const [isSaving, setIsSaving] = (0, $fgmOP.useState)(false);
    const { contractId: contractId, customerId: customerId, productId: productId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const { hasProductTechnicalApiCredentials: hasProductTechnicalApiCredentials, hasProductTechnicalDr: hasProductTechnicalDr, hasProductTechnicalMo: hasProductTechnicalMo, getProductTypeSmppApiDefaultConfig: getProductTypeSmppApiDefaultConfig } = (0, $98effcf86fafb9fb$export$75025970e7082eca)();
    const { showModal: showModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const smppApiDefaultConfig = getProductTypeSmppApiDefaultConfig(productTypeId);
    const { loading: loading, error: productTechnicalQueryError, data: { productTechnical: productTechnical } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($5e246e8a477e946c$exports)))), {
        variables: {
            contractId: contractId,
            customerId: customerId,
            productId: productId
        }
    });
    const initialEntity = productTechnical ? (0, $f6ff28847e6675c5$export$232f37f9a0fc548e)(productTechnical) : {
        __typename: "ProductTechnical",
        endpoints: {
            __typename: "DeliveryEndpoints",
            mo: {
                __typename: "DeliveryEndpoint"
            },
            dr: {
                __typename: "DeliveryEndpoint"
            }
        },
        apiCredentials: {
            __typename: "Credentials"
        },
        smppApiConfig: {
            __typename: "SmppApiConfig"
        }
    };
    //  TODO: confirm not loading from ApolloCache
    // const formFragmentOptions: UseApolloCacheEntityProps = {
    //   fragment: productTechnicalFragment,
    //   entityId: productId,
    //   newEntity: initialEntity,
    // };
    // const formStateOptions = useApolloCacheEntity(formFragmentOptions);
    const formStateOptions = {
        initialEntity: initialEntity,
        isEditing: false
    };
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)(formStateOptions);
    const saveProductTechnical = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($989a550bf093bfad$exports)))));
    const onSave = async ()=>{
        setIsSaving(true);
        const technical = formState.entityAs();
        delete technical.apiCredentials; //  NOTE: do not send apiCredentials since shouldn't be modified at all
        delete technical.id; //  NOTE: do not send id since is only for client apollo cache
        if (technical.protocol !== (0, $l8GLF.EndpointProtocol).SMPP) delete technical.smppApiConfig;
        technical.protocol = getProtocol();
        if (!(0, $g6Bzp.getIsProtocolCredentialsRequired)(technical.protocol)) delete technical.endpoints; //  NOTE: remove endpoints when protocol does not require them
        $99cc06fc8e1abb51$var$log.debug("onSave", {
            customerId: customerId,
            contractId: contractId,
            productId: productId,
            technical: technical
        });
        const { data: data } = await saveProductTechnical({
            loadingText: "Saving service technical...",
            successText: "ServiceTechnical saved",
            variables: {
                customerId: customerId,
                contractId: contractId,
                productId: productId,
                productTechnical: technical
            }
        });
        const productTechnical = data?.saveProductTechnical;
        $99cc06fc8e1abb51$var$log.info("saveServiceTechnicalMutate resolved", productTechnical);
        productTechnical && formState.onSaved((0, $f6ff28847e6675c5$export$232f37f9a0fc548e)(productTechnical));
        setIsSaving(false);
    };
    //  API Credentials
    const onGenerateSecret = ()=>{
        const config = {
            title: "Client Secret generation",
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                children: [
                    "This action will ",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("b", {
                        children: "invalidate the current credentials"
                    }),
                    ", a new secret will be generated and saved as the valid credentials"
                ]
            }),
            onConfirm: onGenerateSecretConfirmed,
            confirmText: "Generate new secret"
        };
        showModal(config);
    };
    const generateSecret = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($85c3e3a7230373aa$exports)))));
    const onGenerateSecretConfirmed = async ()=>{
        const protocol = getProtocol();
        $99cc06fc8e1abb51$var$log.debug("generateSecret confirmed", protocol);
        if (protocol !== (0, $l8GLF.EndpointProtocol).SMPP) await onSave();
        generateSecret({
            loadingText: "Generating secret...",
            successText: "Secret updated",
            variables: {
                customerId: customerId,
                contractId: contractId,
                productId: productId,
                protocol: protocol
            }
        }).then(({ data: data })=>{
            const { generateSecret: generateSecret } = data || {
                generateSecret: undefined
            };
            $99cc06fc8e1abb51$var$log.info("generateSecret resolved", generateSecret);
            if (generateSecret) {
                formState.onChange("apiCredentials.clientId")(generateSecret.clientId);
                formState.onChange("apiCredentials.secretLength")(generateSecret.secret.length);
                formState.onChange("apiCredentials.secretLastUpdated")(generateSecret.secretLastUpdated);
                onSecretGenerated(generateSecret.secret);
            }
        });
    };
    const onSecretGenerated = (secret)=>{
        const config = {
            title: "Client Secret updated",
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                children: [
                    "The client secret has been updated. This is the only time it will be displayed. The ",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("b", {
                        children: "new secret"
                    }),
                    " is:",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        className: "purpleGreyBox",
                        children: secret
                    })
                ]
            })
        };
        showModal(config);
    };
    //  Endpoints passwords
    const onShowEndpointPassword = (password)=>()=>{
            const config = {
                title: `Endpoint Password`,
                content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                    children: [
                        "The current ",
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("b", {
                            children: "password"
                        }),
                        " is: ",
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                            className: "purpleGreyBox",
                            children: password
                        })
                    ]
                })
            };
            showModal(config);
        };
    const getProtocol = ()=>{
        return entity.protocol ? entity.protocol : entity.endpoints?.mo.protocol;
    };
    const getProtocolMessage = (protocol)=>{
        if (protocol === (0, $l8GLF.EndpointProtocol).SMPP) return `${protocol} protocol uses API Credentials`;
        else return "";
    };
    const getIsSecretValid = (protocol, secretLength)=>{
        switch(protocol){
            case (0, $l8GLF.EndpointProtocol).SMPP:
                return secretLength === 8;
            case null:
            case undefined:
                return true;
            default:
                return !!secretLength && secretLength >= 32;
        }
    };
    const getWindowSize = (defaultWindowSize, defaultMaxWindowSize, selectedWindowSize, selectedMaxWindowSize)=>{
        const windowSize = selectedWindowSize || defaultWindowSize;
        const maxWindowSize = selectedMaxWindowSize || defaultMaxWindowSize;
        return windowSize > maxWindowSize ? maxWindowSize : windowSize;
    };
    const isBelowMinWindowSize = (windowSize)=>windowSize !== undefined && windowSize !== null && windowSize < 1;
    const isAboveMaxWindowSize = (windowSize)=>{
        const maxWindowSize = entity.smppApiConfig?.maxWindowSize ? entity.smppApiConfig.maxWindowSize : smppApiDefaultConfig?.maxWindowSize;
        return windowSize !== undefined && windowSize !== null && maxWindowSize > 0 && windowSize > maxWindowSize;
    };
    $99cc06fc8e1abb51$var$log.debug("render", {
        productTypeId: productTypeId,
        productTechnical: productTechnical
    });
    const { isEditing: isEditing, entity: entity, onCancel: onCancel, onChange: onChange, findError: findError } = formState;
    (0, $fgmOP.useEffect)(()=>{
        const isValid = getIsSecretValid(getProtocol(), entity.apiCredentials?.secretLength);
        if (isValid) setIsSecretValidMessage("");
        else setIsSecretValidMessage("Key must be regenerated when switching between REST/SOAP and SMPP");
    }, [
        entity.protocol,
        entity.endpoints?.mo.protocol,
        entity.endpoints?.dr.protocol,
        entity.apiCredentials?.secretLength
    ]);
    const { user: user, hasPermission: hasPermission, hasBrandPermission: hasBrandPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const isTeliaAdmin = (0, $fgmOP.useMemo)(()=>hasBrandPermission((0, $ca0941499cca84bb$export$619b28da925d56b7), "*"), [
        user
    ]);
    const isEditingSmppTechnical = isTeliaAdmin && isEditing;
    const formButtons = (inPageSubtitle)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                "inlineBlock marginLeft": inPageSubtitle
            }),
            children: !isEditing ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                children: hasPermission((0, $ca0941499cca84bb$export$2c134167e4d6a0ca)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                    text: "Edit",
                    className: "",
                    onClick: formState.onEdit
                })
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                        text: "Save",
                        className: "",
                        onClick: onSave,
                        kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                        text: "Cancel",
                        className: "",
                        onClick: onCancel,
                        kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel
                    })
                ]
            })
        });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("hr", {
                className: "horizontal-rule marginTop2"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                children: [
                    "Service Technical Configuration",
                    formButtons(true)
                ]
            }),
            !entity ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                                title: "Telia API Configuration"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "protocol",
                                        label: "Protocol",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                        value: getProtocol(),
                                        options: (0, $l8GLF.endpointProtocolOptions),
                                        defaultValue: $99cc06fc8e1abb51$var$noCallbackPlaceholder,
                                        isNullable: true,
                                        tip: getProtocolMessage(getProtocol()),
                                        onChangeAlso: (protocol)=>{
                                            formState.onChange("endpoints.mo.protocol")(protocol);
                                            formState.onChange("endpoints.dr.protocol")(protocol);
                                        }
                                    })
                                })
                            }),
                            (hasProductTechnicalApiCredentials(productTypeId) || getProtocol() === (0, $l8GLF.EndpointProtocol).SMPP) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                                label: "Client ID",
                                                value: entity.apiCredentials?.clientId,
                                                defaultValue: "Not created yet",
                                                isEditing: false,
                                                onChange: onChange("apiCredentials.clientId"),
                                                tip: `It's created during the first Client Secret generation`,
                                                error: findError("ApiCredentials.id")
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                                    label: "Client Secret",
                                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).element,
                                                    value: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                                        text: entity.apiCredentials?.secretLastUpdated ? "Re-generate" : "Generate",
                                                        onClick: onGenerateSecret
                                                    }),
                                                    isEditing: false,
                                                    error: !isSaving ? isSecretValidMessage : "",
                                                    tip: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                                                        children: [
                                                            "It ",
                                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("b", {
                                                                children: "displays only once"
                                                            }),
                                                            " after generation"
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {})
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                                label: "Client Secret Last Updated",
                                                value: entity.apiCredentials?.secretLastUpdated,
                                                defaultValue: "NEVER",
                                                isEditing: false
                                            })
                                        })
                                    }),
                                    getProtocol() === (0, $l8GLF.EndpointProtocol).SMPP && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                        formState: formState,
                                                        defaultValue: smppApiDefaultConfig?.defaultCharset,
                                                        entityFieldId: "smppApiConfig.defaultCharset",
                                                        label: "Default Charset",
                                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                        tip: `Will apply default ${smppApiDefaultConfig?.defaultCharset} Default Charset if left empty`,
                                                        options: Object.values((0, $l8GLF.DefaultCharset))
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                            formState: formState,
                                                            defaultValue: getWindowSize(smppApiDefaultConfig?.windowSize, smppApiDefaultConfig?.maxWindowSize, entity.smppApiConfig?.windowSize, entity.smppApiConfig?.maxWindowSize),
                                                            entityFieldId: "smppApiConfig.windowSize",
                                                            label: "Window Size",
                                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).number,
                                                            tip: `Will apply default ${smppApiDefaultConfig?.windowSize} Window Size if left empty, or ${smppApiDefaultConfig?.maxWindowSize} Max Window Size if it exceeds Max Window Size`,
                                                            error: isBelowMinWindowSize(entity.smppApiConfig?.windowSize) ? "Window Size must be higher than 0" : isAboveMaxWindowSize(entity.smppApiConfig?.windowSize) ? "Window Size must not exceed Max Window Size" : ""
                                                        }),
                                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                            formState: formState,
                                                            defaultValue: smppApiDefaultConfig?.maxWindowSize,
                                                            entityFieldId: "smppApiConfig.maxWindowSize",
                                                            label: "Maximum Window Size",
                                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).number,
                                                            tip: `Will apply default ${smppApiDefaultConfig?.maxWindowSize} Max Window Size if left empty`,
                                                            isEditing: isEditingSmppTechnical,
                                                            error: isBelowMinWindowSize(entity.smppApiConfig?.maxWindowSize) ? "Max Window Size must be higher than 0" : ""
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                        formState: formState,
                                                        defaultValue: smppApiDefaultConfig?.maxSessions,
                                                        entityFieldId: "smppApiConfig.maxSessions",
                                                        label: "Maximum of SMPP sessions",
                                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).number,
                                                        tip: `Will apply default ${smppApiDefaultConfig?.maxSessions} Max Sessions if left empty`,
                                                        isEditing: isEditingSmppTechnical
                                                    })
                                                })
                                            }),
                                            isTeliaAdmin && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                                formState: formState,
                                                                defaultValue: smppApiDefaultConfig?.minReceiverSessionAlarmThreshold,
                                                                entityFieldId: "smppApiConfig.minReceiverSessionAlarmThreshold",
                                                                label: "Minimum Receiver Session Count Alarm Threshold",
                                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).number,
                                                                tip: `Will apply default ${smppApiDefaultConfig?.minReceiverSessionAlarmThreshold} Minimum Receiver Session Count Alarm Threshold if left empty`
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                                formState: formState,
                                                                defaultValue: smppApiDefaultConfig?.minTransmitterSessionAlarmThreshold,
                                                                entityFieldId: "smppApiConfig.minTransmitterSessionAlarmThreshold",
                                                                label: "Minimum Transmitter Session Count Alarm Threshold",
                                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).number,
                                                                tip: `Will apply default ${smppApiDefaultConfig?.minReceiverSessionAlarmThreshold} Minimum Transmitter Session Count Alarm Threshold if left empty`
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (0, $g6Bzp.getIsProtocolCredentialsRequired)(getProtocol()) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                        children: [
                            hasProductTechnicalMo(productTypeId) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
                                className: "form-group",
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                                        title: "Mobile Originated Callback"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "endpoints.mo.protocol",
                                                label: "Protocol",
                                                isEditing: false,
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                options: (0, $l8GLF.endpointProtocolOptions),
                                                defaultValue: $99cc06fc8e1abb51$var$noCallbackPlaceholder,
                                                tip: getProtocolMessage(entity.endpoints?.mo.protocol)
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "endpoints.mo.endpoint",
                                                label: "Endpoint",
                                                placeholder: "https://..."
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                    formState: formState,
                                                    entityFieldId: "endpoints.mo.username",
                                                    label: "Username",
                                                    autocomplete: `service ${entity.id} mo username`
                                                }),
                                                isEditing ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                    formState: formState,
                                                    entityFieldId: "endpoints.mo.password",
                                                    label: "Password",
                                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).password,
                                                    autocomplete: `service ${entity.id} mo password`
                                                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                                    label: "Password",
                                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).element,
                                                    value: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                                        text: "show",
                                                        isDisabled: isEditing,
                                                        onClick: onShowEndpointPassword(entity.endpoints?.mo.password)
                                                    }),
                                                    isEditing: false
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            hasProductTechnicalDr(productTypeId) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
                                className: "form-group",
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                                        title: "Delivery Report Callback"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "endpoints.dr.protocol",
                                                label: "Protocol",
                                                isEditing: false,
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                options: (0, $l8GLF.endpointProtocolOptions),
                                                defaultValue: $99cc06fc8e1abb51$var$noCallbackPlaceholder,
                                                tip: getProtocolMessage(entity.endpoints?.dr.protocol)
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "endpoints.dr.endpoint",
                                                label: "Endpoint",
                                                placeholder: "https://..."
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                    formState: formState,
                                                    entityFieldId: "endpoints.dr.username",
                                                    label: "Username",
                                                    autocomplete: `service ${entity.id} dr username`
                                                }),
                                                isEditing ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                    formState: formState,
                                                    entityFieldId: "endpoints.dr.password",
                                                    label: "Password",
                                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).password,
                                                    autocomplete: `service ${entity.id} dr password`
                                                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                                    label: "Password",
                                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).element,
                                                    isEditing: false,
                                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                                        text: "show",
                                                        isDisabled: isEditing,
                                                        onClick: onShowEndpointPassword(entity.endpoints?.dr?.password)
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    hasPermission((0, $ca0941499cca84bb$export$69e1ef3f3bd133aa)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $68905fbd5cd29bdb$export$772a5c0050fa028b), {
                        formState: formState
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: formButtons(false)
                        })
                    })
                ]
            })
        ]
    });
};


const $c88f8d341fd43e4e$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Service", "INFO");
const { activeStatus: $c88f8d341fd43e4e$var$activeStatus, isValid: $c88f8d341fd43e4e$var$isValid } = (0, $f5d0c2a7498ff49b$exports.period);
const $c88f8d341fd43e4e$var$customerQueryGql = (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($dad67faa2a055d78$exports))));
const $c88f8d341fd43e4e$var$customerOverviewQueryGql = (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($faa9e9ee47efa167$exports))));
const $c88f8d341fd43e4e$export$8b2af884909d32a5 = (props)=>{
    const { contractId: contractId, customerId: customerId, productId: productId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const { showModal: showModal, hideModal: hideModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const { loading: loading, getBrandProductTypes: getBrandProductTypes, getEstablishFee: getEstablishFee, getMonthlyFee: getMonthlyFee, getAccessNumberDisplayName: getAccessNumberDisplayName, getDefaultQoSMessagePriority: getDefaultQoSMessagePriority, getDefaultQoSMaxSmsPerSecond: getDefaultQoSMaxSmsPerSecond, usesAccessNumberRange: usesAccessNumberRange, usesAccessNumber: usesAccessNumber, usesPrefixNumber: usesPrefixNumber, usesRbmAgentOwner: usesRbmAgentOwner, usesProductName: usesProductName, usesFeatures: usesFeatures, hasProductTechnical: hasProductTechnical, canReserveOa: canReserveOa, canSend: canSend } = (0, $98effcf86fafb9fb$export$75025970e7082eca)();
    const formFragmentOptions = {
        fragment: (0, (/*@__PURE__*/$parcel$interopDefault($9440e7fd1caa7b81$exports))),
        entityId: productId,
        newEntity: {
            countryId: props.countryId,
            brandId: props.brandId,
            customerId: customerId,
            contractId: contractId,
            qosProfile: {
                enabled: true
            }
        },
        watchQuery: $c88f8d341fd43e4e$var$customerQueryGql,
        watchVariables: {
            customerId: customerId
        }
    };
    const formStateOptions = (0, $cd0b9ee27a364316$export$4c2508f4134d3a42)(formFragmentOptions);
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)(formStateOptions);
    const { initialEntity: initialEntity, isEditing: isEditing, onCancel: onCancel, onChange: onChange, subEntityAt: subEntityAt, entityAs: entityAs } = formState;
    const entity = entityAs();
    const productTypeId = entity.productType;
    const countryId = subEntityAt("countryId");
    const brandId = subEntityAt("brandId");
    const brandsProductTypes = (0, $fgmOP.useMemo)(()=>getBrandProductTypes(brandId), [
        getBrandProductTypes,
        brandId
    ]);
    const productType = brandsProductTypes.find((productType)=>productType.id === productTypeId);
    const { hasPermission: hasPermission, currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const saveProduct = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($29a24a008c14ae51$exports)))));
    const onSave = ()=>{
        const { endDate: finalEndDate } = entityAs();
        const initialEndDate = initialEntity.endDate;
        if (initialEndDate === finalEndDate) onConfirmSave();
        else showModal({
            title: "Update Service End Date",
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                        children: "Are you sure you want to update the service's end date?"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                        children: " This service will NOT be able to send messages after the end date has passed."
                    })
                ]
            }),
            typeToConfirmText: "update",
            confirmText: "Update",
            confirmType: "primary",
            onConfirm: ()=>onConfirmSave()
        });
    };
    const onConfirmSave = (product = formState.entityAs())=>{
        delete product.inheritsEndDate;
        product.features = product.features?.length ? product.features.filter((feature)=>Object.keys(feature).length > 0) : product.features;
        product.feeOverrides = product.feeOverrides?.filter(({ amount: amount })=>amount !== null);
        if (canSend(productTypeId) && product.qosProfile) {
            if (!Number.isInteger(product.qosProfile?.messagePriority)) product.qosProfile.messagePriority = getDefaultQoSMessagePriority(productTypeId);
            if (!Number.isInteger(product.qosProfile?.maxSmsPerSecond)) product.qosProfile.maxSmsPerSecond = getDefaultQoSMaxSmsPerSecond(productTypeId);
        }
        $c88f8d341fd43e4e$var$log.debug("onSave", {
            customerId: customerId,
            contractId: contractId,
            product: product
        });
        saveProduct({
            loadingText: "Saving service...",
            successText: "Service saved",
            variables: {
                customerId: customerId,
                contractId: contractId,
                product: product
            },
            update (proxy, { data: data }) {
                const { saveProduct: saveProduct } = data || {};
                $c88f8d341fd43e4e$var$log.debug("saveProduct update", saveProduct);
                if (!initialEntity.id) {
                    $c88f8d341fd43e4e$var$log.debug("saveProduct update. New product created", saveProduct);
                    try {
                        const data = proxy.readQuery({
                            query: $c88f8d341fd43e4e$var$customerQueryGql,
                            variables: {
                                customerId: customerId
                            }
                        });
                        $c88f8d341fd43e4e$var$log.debug("saveProduct update. Customer query data", (0, (/*@__PURE__*/$parcel$interopDefault($4a7c720bc23270cb$exports))).inspect(data));
                        if (data) {
                            const contracts = data.customer?.contracts?.map((c)=>c.id != contractId ? c : {
                                    ...c,
                                    products: [
                                        ...c.products,
                                        {
                                            ...saveProduct
                                        }
                                    ]
                                });
                            proxy.writeQuery({
                                query: $c88f8d341fd43e4e$var$customerQueryGql,
                                data: {
                                    customer: {
                                        ...data.customer,
                                        contracts: contracts
                                    }
                                }
                            });
                        }
                    } catch (e) {
                        $c88f8d341fd43e4e$var$log.warn("Customer Apollo cache not created yet");
                    }
                    saveProduct && navigate(//  TODO: replace in useMutationWrap() checking for __CREATE__ id ?
                    formatWithBrand($e9a95c61c800ecd2$export$dc7ad6b828d74f36, customerId, contractId, saveProduct.id), {
                        replace: true
                    });
                } else {
                    const { reservedOas: reservedOas = [] } = proxy.readQuery({
                        query: (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($cb40802b0ad9775f$exports)))),
                        variables: {
                            countryId: currentUserBrand?.countryId
                        }
                    }) || {};
                    const updateReservedOas = reservedOas.map((reservedOa)=>reservedOa.ownerProductId === product.id ? {
                            ...reservedOa,
                            startDate: product.startDate,
                            endDate: product.endDate
                        } : reservedOa);
                    $c88f8d341fd43e4e$var$log.debug("saveReservedOa update", {
                        reservedOas: reservedOas,
                        updateReservedOas: updateReservedOas
                    });
                    proxy.writeQuery({
                        query: (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($cb40802b0ad9775f$exports)))),
                        data: {
                            reservedOas: updateReservedOas
                        },
                        variables: {
                            countryId: currentUserBrand?.countryId
                        }
                    });
                    const { customerOverviews: customerOverviews = [] } = proxy.readQuery({
                        query: $c88f8d341fd43e4e$var$customerOverviewQueryGql
                    }) || {};
                    $c88f8d341fd43e4e$var$log.debug("saveProduct update. CustomerOverview query data", (0, (/*@__PURE__*/$parcel$interopDefault($4a7c720bc23270cb$exports))).inspect(customerOverviews));
                    const updateCustomerOverviews = customerOverviews.map((customerOverview)=>customerOverview.id === saveProduct?.customerId ? {
                            ...customerOverview,
                            productOverviews: customerOverview.productOverviews.map((productOverview)=>productOverview.productId === saveProduct.id && productOverview.productOverviewType === "reservedOa" ? {
                                    ...productOverview,
                                    productName: saveProduct.name
                                } : productOverview)
                        } : customerOverview);
                    proxy.writeQuery({
                        query: $c88f8d341fd43e4e$var$customerOverviewQueryGql,
                        data: {
                            customerOverviews: updateCustomerOverviews
                        }
                    });
                }
            }
        }).then(({ data: data })=>{
            const { saveProduct: saveProduct } = data || {
                saveProduct: undefined
            };
            saveProduct && formState.onSaved((0, $f6ff28847e6675c5$export$232f37f9a0fc548e)(saveProduct));
        });
    };
    const onEdit = ()=>{
        const { entity: entity, onChange: onChange, onEdit: onEdit } = formState;
        if (entity.inheritsEndDate) {
            onChange("inheritsEndDate")(false);
            onChange("endDate")(null);
        }
        recalculateGracePeriodStartDate(true, entity.startDate);
        onEdit();
    };
    //  Access Number pick
    let modalId;
    const onPickButtonClick = (accessNumberField)=>()=>{
            const config = {
                title: `Pick access number`,
                content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $36a4608a51053324$export$a0cbf456f5f6d2a2), {
                    productType: productTypeId,
                    productId: productId,
                    rangeCount: entity.accessNumberRange?.count,
                    startDate: entity.startDate,
                    endDate: entity.endDate,
                    onPickAccessNumber: onPickAccessNumber(accessNumberField)
                })
            };
            modalId = showModal(config);
        };
    const onPickAccessNumber = (accessNumberField)=>(accessNumber)=>{
            onChange(accessNumberField)(accessNumber);
            if (accessNumberField === "accessNumberRange.from") {
                const count = entity.accessNumberRange?.count;
                updateAccessNumberRange(accessNumber, count);
            }
            hideModal(modalId);
        };
    (0, $fgmOP.useEffect)(()=>{
        if (usesFeatures(productTypeId)) {
            const { feeOverrides: feeOverrides } = entity;
            const expectedFields = productType?.features?.map((feature)=>{
                return [
                    feature.id + "_" + (0, $6N8I1.FEE_TYPE_ESTABLISHMENT),
                    feature.id + "_" + (0, $6N8I1.FEE_TYPE_MONTHLY)
                ];
            }).flat().filter((expectedField)=>!feeOverrides || !feeOverrides.some(({ feeTypeId: feeTypeId })=>feeTypeId === expectedField)) || [];
            expectedFields.forEach((expectedField)=>onChange("feeOverrides")([
                    {
                        feeTypeId: expectedField,
                        amount: null
                    },
                    ...feeOverrides ? feeOverrides : []
                ].sort((a, b)=>{
                    const aIsEstablishFee = a.feeTypeId.endsWith((0, $6N8I1.FEE_TYPE_ESTABLISHMENT));
                    const bIsEstablishFee = b.feeTypeId.endsWith((0, $6N8I1.FEE_TYPE_ESTABLISHMENT));
                    return aIsEstablishFee && !bIsEstablishFee ? -1 : !aIsEstablishFee && bIsEstablishFee ? 1 : a.feeTypeId.localeCompare(b.feeTypeId);
                })));
        }
    }, [
        entity.feeOverrides,
        productTypeId,
        productType?.features
    ]);
    const updateAccessNumberRange = (from, count)=>{
        const accessNumberRange = {
            from: from,
            to: !from || !count ? undefined : (0, $f5d0c2a7498ff49b$exports.range).rangeTo(from, count),
            count: count
        };
        $c88f8d341fd43e4e$var$log.debug("updateAccessNumberRange ", accessNumberRange);
        onChange("accessNumberRange")(accessNumberRange);
    };
    $c88f8d341fd43e4e$var$log.debug("render", {
        countryId: countryId,
        brandId: brandId,
        contractId: contractId,
        customerId: customerId,
        productId: productId,
        brandsProductTypes: brandsProductTypes,
        formFragmentOptions: formFragmentOptions,
        formStateOptions: formStateOptions,
        formState: formState
    });
    const formButtons = (inPageSubtitle)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                "inlineBlock marginLeft": inPageSubtitle
            }),
            children: !isEditing ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                children: [
                    hasPermission((0, $ca0941499cca84bb$export$3dd817f0ec35d602)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                        text: "Edit",
                        className: "",
                        onClick: onEdit
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                        to: formatWithBrand($e9a95c61c800ecd2$export$57a19d7397b7cbfa, customerId, contractId),
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                            text: "Go to contract",
                            kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                        text: "Save",
                        className: "",
                        onClick: onSave,
                        kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                        text: "Cancel",
                        className: "",
                        onClick: onCancel,
                        kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel
                    })
                ]
            })
        });
    const recalculateGracePeriodStartDate = (value, startDate = entity.startDate)=>{
        onChange("gracePeriodStartDate")(value && startDate ? (0, (/*@__PURE__*/$parcel$interopDefault($c30H9)))(startDate).subtract((0, $6N8I1.GRACE_PERIOD), "days").format("YYYY-MM-DD") : null);
    };
    const resetProductTypeSpecificFields = ()=>{
        onChange("accessNumber")(null);
        onChange("accessNumberRange")(null);
        onChange("rbmAgentOwner")(null);
    };
    const productTypeField = /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
        formState: formState,
        entityFieldId: "productType",
        label: "Service Type",
        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
        options: brandsProductTypes,
        tip: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("ul", {
            children: brandsProductTypes?.map((productType)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                            className: "bold",
                            children: productType.name
                        }),
                        " - ",
                        productType.description
                    ]
                }, productType.id))
        }),
        onChangeAlso: resetProductTypeSpecificFields
    });
    const productFeesFields = entity && !loading && productTypeId && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                    formState: formState,
                    entityFieldId: "establishFee",
                    label: "Service establish fee" + (usesAccessNumberRange(productTypeId) ? " per num." : ""),
                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).number,
                    defaultValue: getEstablishFee(productTypeId),
                    tip: isEditing ? "Left EMPTY for DEFAULT establish FEE" : entity.establishFee === null ? "Applying DEFAULT establish Fee" : null
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                    formState: formState,
                    entityFieldId: "monthlyFee",
                    label: "Service monthly fee" + (usesAccessNumberRange(productTypeId) ? " per num." : ""),
                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).number,
                    defaultValue: getMonthlyFee(productTypeId),
                    tip: isEditing ? "Left EMPTY for DEFAULT monthly FEE" : entity.monthlyFee === null ? "Applying DEFAULT monthly Fee" : null
                })
            ]
        })
    });
    const featureFeesFields = ()=>{
        const fragments = [
            ...entity.feeOverrides || []
        ].map(({ feeTypeId: feeTypeId }, i)=>{
            const action = feeTypeId.endsWith((0, $6N8I1.FEE_TYPE_ESTABLISHMENT)) ? (0, $6N8I1.FEE_TYPE_ESTABLISHMENT) : (0, $6N8I1.FEE_TYPE_MONTHLY);
            const feeTypeIdWithoutAction = feeTypeId.split("_").slice(0, -1).join("_");
            const label = `${feeTypeId.includes("RECEIVE_ON_SHORT_NUMBER") ? " Short num. " : feeTypeId.includes("RECEIVE_ON_LONG_NUMBER") ? "Long num. " : feeTypeIdWithoutAction} ${action === (0, $6N8I1.FEE_TYPE_ESTABLISHMENT) ? "establish" : action === (0, $6N8I1.FEE_TYPE_MONTHLY) ? "monthly" : ""} fee`;
            return {
                feeTypeId: feeTypeId,
                action: action,
                fragment: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                    className: "marginBottom",
                    formState: formState,
                    entityFieldId: `feeOverrides[${i}].amount`,
                    label: label,
                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).number,
                    defaultValue: action === (0, $6N8I1.FEE_TYPE_ESTABLISHMENT) ? getEstablishFee(productTypeId, feeTypeIdWithoutAction) : getMonthlyFee(productTypeId, feeTypeIdWithoutAction),
                    tip: isEditing ? "Left EMPTY for DEFAULT establish FEE" : entity.establishFee === null ? "Applying DEFAULT establish Fee" : null
                }, feeTypeId + "-" + i)
            };
        })// Sort by feeTypeId first, then by action
        .sort((a, b)=>a.feeTypeId.localeCompare(b.feeTypeId) || a.action.localeCompare(b.action));
        let featureFeesFragment = /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {});
        for(let i = 0; i < fragments.length; i += 2)featureFeesFragment = /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
            children: [
                featureFeesFragment,
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                        children: fragments.slice(i, i + 2).map(({ fragment: fragment })=>fragment)
                    })
                })
            ]
        });
        return featureFeesFragment;
    };
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                children: [
                    "Service",
                    formButtons(true)
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "service"
            }),
            !entity || loading ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("ServiceForm"),
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $a51d31ff0f88aa5a$export$45d4b61d19483d8a), {
                        formState: formState,
                        canEdit: false
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "id",
                                    label: "Service ID",
                                    isEditing: false
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "contractId",
                                    label: "Contract ID",
                                    isEditing: false
                                })
                            ]
                        })
                    }),
                    !productTypeId ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                productTypeField,
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {})
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                    children: [
                                        productTypeField,
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                            label: "Active Status",
                                            value: $c88f8d341fd43e4e$var$activeStatus(entity),
                                            valueClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))($c88f8d341fd43e4e$var$activeStatus(entity).replace(/[^a-zA-Z]/g, "").toLowerCase() + "Period"),
                                            tip: "Calculated from start and end dates"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                            formState: formState,
                                            entityFieldId: "startDate",
                                            label: "Start date",
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date,
                                            defaultValue: "since ever",
                                            onChangeAlso: (value)=>{
                                                recalculateGracePeriodStartDate(!!entity.gracePeriodStartDate || !entity.id, value);
                                            }
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                            formState: formState,
                                            entityFieldId: "endDate",
                                            label: "End date",
                                            value: entity.inheritsEndDate ? undefined : entity.endDate,
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date,
                                            defaultValue: entity.inheritsEndDate ? entity.endDate : "no end",
                                            tip: isEditing ? `Left empty to inherit contract's end date` : entity.inheritsEndDate && `Inherits contract's end date`
                                        })
                                    ]
                                })
                            }),
                            entity.startDate && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                positionTop: !!entity.gracePeriodStartDate
                                            }),
                                            isEditing: false,
                                            label: "Grace period",
                                            tip: `Service is enabled ${(0, $6N8I1.GRACE_PERIOD)} days before actual product start date at a limited bandwidth`,
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox,
                                            value: !!entity.gracePeriodStartDate,
                                            onChange: (value)=>{
                                                recalculateGracePeriodStartDate(value);
                                            }
                                        }),
                                        entity.gracePeriodStartDate && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                            formState: formState,
                                            isEditing: false,
                                            entityFieldId: "gracePeriodStartDate",
                                            label: "Grace period start date",
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date
                                        })
                                    ]
                                })
                            }),
                            $c88f8d341fd43e4e$var$isValid(entity) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                                children: [
                                    usesAccessNumberRange(productTypeId) ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
                                        className: "form-group",
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                                                title: "Access Number Range"
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                            formState: formState,
                                                            entityFieldId: "accessNumberRange.count",
                                                            label: "Count",
                                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).number,
                                                            tip: isEditing && !$c88f8d341fd43e4e$var$isValid(entity) && `Disabled because dates are ${$c88f8d341fd43e4e$var$activeStatus(entity)}.`,
                                                            isDisabled: !$c88f8d341fd43e4e$var$isValid(entity),
                                                            onChangeAlso: (count)=>updateAccessNumberRange(entity.accessNumberRange?.from, count)
                                                        }),
                                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {})
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                            formState: formState,
                                                            entityFieldId: "accessNumberRange.from",
                                                            label: "From",
                                                            tip: isEditing && (!$c88f8d341fd43e4e$var$isValid(entity) ? `Disabled because dates are ${$c88f8d341fd43e4e$var$activeStatus(entity)}.` : !entity.accessNumberRange?.count ? `Disabled because of access number range count` : undefined),
                                                            button: isEditing && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                                                text: "Pick",
                                                                className: "floatRight",
                                                                onClick: onPickButtonClick("accessNumberRange.from"),
                                                                isDisabled: !$c88f8d341fd43e4e$var$isValid(entity) || !entity.accessNumberRange?.count
                                                            }),
                                                            isDisabled: !$c88f8d341fd43e4e$var$isValid(entity) || !entity.accessNumberRange?.count
                                                        }),
                                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                            formState: formState,
                                                            entityFieldId: "accessNumberRange.to",
                                                            label: "To",
                                                            isEditing: false,
                                                            isDisabled: !$c88f8d341fd43e4e$var$isValid(entity) || !entity.accessNumberRange?.count
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }) : usesAccessNumber(productTypeId) ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                    formState: formState,
                                                    entityFieldId: "accessNumber",
                                                    label: getAccessNumberDisplayName(productTypeId),
                                                    tip: isEditing && !$c88f8d341fd43e4e$var$isValid(entity) && `Disabled because dates are ${$c88f8d341fd43e4e$var$activeStatus(entity)}.`,
                                                    button: isEditing && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                                        text: "Pick",
                                                        className: "floatRight",
                                                        onClick: onPickButtonClick("accessNumber"),
                                                        isDisabled: !$c88f8d341fd43e4e$var$isValid(entity)
                                                    }),
                                                    isDisabled: !$c88f8d341fd43e4e$var$isValid(entity)
                                                }),
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {})
                                            ]
                                        })
                                    }) : usesRbmAgentOwner(productTypeId) ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                    formState: formState,
                                                    entityFieldId: "rbmAgentOwner",
                                                    label: "RBM Agent Owner email",
                                                    tip: "Customer Agent Owner email address in the Google Jibe platform.",
                                                    isDisabled: !$c88f8d341fd43e4e$var$isValid(entity)
                                                }),
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {})
                                            ]
                                        })
                                    }) : usesPrefixNumber(productTypeId) ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: [
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                    formState: formState,
                                                    entityFieldId: "accessNumber",
                                                    label: getAccessNumberDisplayName(productTypeId),
                                                    tip: isEditing && !$c88f8d341fd43e4e$var$isValid(entity) && `Disabled because dates are ${$c88f8d341fd43e4e$var$activeStatus(entity)}.`,
                                                    onChangeAlso: (number)=>onChange(`accessNumber`)(number.replace(/\D/g, "")),
                                                    isDisabled: !$c88f8d341fd43e4e$var$isValid(entity)
                                                }),
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {})
                                            ]
                                        })
                                    }) : null,
                                    !usesFeatures(productTypeId) && productFeesFields,
                                    canSend(productTypeId) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                        formState: formState,
                                                        entityFieldId: "allowedOriginatingAddresses",
                                                        label: "Allowed Originating Addresses",
                                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi,
                                                        onChangeAlso: (value)=>{
                                                            // If ALL is selected, remove all other values
                                                            if (value.includes((0, $l8GLF.OriginatorAddressType).ALL)) onChange("allowedOriginatingAddresses")([
                                                                (0, $l8GLF.OriginatorAddressType).ALL
                                                            ]);
                                                        },
                                                        options: (0, $l8GLF.addressTypeOptions).map((option)=>({
                                                                ...option,
                                                                isDisabled: option.id !== (0, $l8GLF.OriginatorAddressType).ALL && subEntityAt("allowedOriginatingAddresses")?.includes((0, $l8GLF.OriginatorAddressType).ALL)
                                                            })),
                                                        tip: "Multiple selections are allowed, originating address will be permitted if allowed by any selected policy."
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                                                        title: "QoS Profile"
                                                    }),
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                                formState: formState,
                                                                entityFieldId: "qosProfile.enabled",
                                                                label: "Enabled",
                                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                                            children: [
                                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                                    formState: formState,
                                                                    entityFieldId: "qosProfile.messagePriority",
                                                                    label: "Message Priority",
                                                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).number,
                                                                    isDisabled: !entity.qosProfile?.enabled,
                                                                    defaultValue: getDefaultQoSMessagePriority(productTypeId),
                                                                    tip: `Will apply default priority ${getDefaultQoSMessagePriority(productTypeId)} if left empty.`
                                                                }),
                                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                                    formState: formState,
                                                                    entityFieldId: "qosProfile.maxSmsPerSecond",
                                                                    label: "Max SMS/second",
                                                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).number,
                                                                    isDisabled: !entity.qosProfile?.enabled,
                                                                    defaultValue: getDefaultQoSMaxSmsPerSecond(productTypeId),
                                                                    tip: `Will apply default ${getDefaultQoSMaxSmsPerSecond(productTypeId)} max SMS/second if left empty.`
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: usesProductName(productTypeId) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "name",
                                                label: "Name",
                                                tip: "Name of this group of Sender IDs"
                                            })
                                        })
                                    }),
                                    usesFeatures(productTypeId) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                                                        title: "Service fees"
                                                    }),
                                                    productFeesFields
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
                                                className: "form-group",
                                                children: [
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                                                        title: "Feature fees"
                                                    }),
                                                    featureFeesFields()
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "comment",
                                                label: "Comment",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).textarea
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                            children: formButtons(false)
                                        })
                                    })
                                ]
                            }),
                            usesFeatures(productTypeId) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $da9b4505e0d42a56$export$af2e3040d613d334), {
                                formState: formState,
                                onSave: onConfirmSave
                            }),
                            entity.id && hasPermission((0, $ca0941499cca84bb$export$2c134167e4d6a0ca)) && productTypeId && hasProductTechnical(productTypeId) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $99cc06fc8e1abb51$export$7ea64f2593104482), {
                                productTypeId: productTypeId
                            }),
                            entity.id === productId && canReserveOa(productTypeId) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $4f298aa2be767f10$export$1b1eceeab469768d), {
                                ownerProductId: productId,
                                startDate: subEntityAt("startDate"),
                                endDate: subEntityAt("endDate")
                            })
                        ]
                    })
                ]
            })
        ]
    });
};






var $fgmOP = parcelRequire("fgmOP");

















const $b9117d55fa52f543$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Services", "INFO");
const $b9117d55fa52f543$export$c447b0cdbd1cd184 = (props)=>{
    const [contractId, setContractId] = (0, $fgmOP.useState)();
    const { hasPermission: hasPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { showInactive: showInactive, showInactiveComponent: showInactiveComponent } = (0, $152b6193e99b7439$export$84f600a904db3b68)();
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const { customerId: customerId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const { showModal: showModal, hideModal: hideModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const contracts = (0, $0c50f3a7c549d9f9$export$8389a24b7ef9bb78)(props.contracts, showInactive);
    const onCreateProduct = (contractId)=>()=>{
            $b9117d55fa52f543$var$log.debug("onCreateProduct for contract " + contractId);
            navigate(formatWithBrand($e9a95c61c800ecd2$export$2a4a027f8fef3234, customerId, contractId));
        };
    const hasProducts = (contracts)=>{
        let isContractsContained = contracts && !contracts.isEmpty();
        let isProductsContained = false;
        if (isContractsContained) for(let i = 0; i < contracts.length; i++){
            const isProductsContained = !contracts[i].products.isEmpty();
            if (isProductsContained) return isProductsContained;
        }
        return isContractsContained && isProductsContained;
    };
    const onCreate = ()=>{
        !contracts || contracts.length === 0 ? showModal({
            title: "No contracts",
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                children: "`In order to create a service, should at least one contract be available`"
            }),
            confirmText: `Go to Contracts`,
            onConfirm: ()=>navigate(formatWithBrand($e9a95c61c800ecd2$export$a4009a798127382a, customerId))
        }) : contracts.length > 1 ? showModal({
            title: "Multiple contracts",
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                        children: "Select the corresponding service's Contract"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                isEditing: true,
                                options: contracts.map((c)=>({
                                        id: c.id,
                                        name: (0, $f5d0c2a7498ff49b$exports.format).contractDisplayName(c)
                                    })),
                                value: contractId,
                                onChange: (contractId)=>{
                                    $b9117d55fa52f543$var$log.debug("Multiple contracts, onChange contract ID", contractId);
                                    contractId && onCreateProduct(contractId)();
                                    hideModal();
                                }
                            })
                        })
                    })
                ]
            }),
            onCancel: ()=>{
                setContractId(undefined);
            }
        }) : onCreateProduct(contracts[0].id)();
    };
    $b9117d55fa52f543$var$log.debug("render", {
        customerId: customerId,
        showInactive: showInactive,
        contractId: contractId
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Services"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "services"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                        size: (0, $6c2490027a2e159e$export$95dbfef2e4b1962b),
                        children: showInactiveComponent
                    }),
                    hasPermission((0, $ca0941499cca84bb$export$3dd817f0ec35d602)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                        size: (0, $6c2490027a2e159e$export$95dbfef2e4b1962b),
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                            id: (0, $0857d9353dc337e9$export$d5d25c90fc92fce5)("createProduct"),
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                onClick: onCreate,
                                text: "Create service"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                children: hasProducts(contracts) ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $afa3ff43d46630b5$export$750ab9746aa75e91), {
                        contracts: contracts
                    })
                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                    children: "No services found"
                })
            })
        ]
    });
};


const $8e40c2561f1c547f$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Customer", "INFO");
const $8e40c2561f1c547f$export$371eacf23b8ce55b = (props)=>{
    const { customerId: customerId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const { pathname: pathname } = (0, $dfdceb7c36fce96f$export$45d76561a5302f2b)();
    const { currentUserBrand: currentUserBrand, isCustomer: isCustomer, hasPermission: hasPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { customerRoles: customerRoles } = (0, $3b1b6b64a4bd4f9b$export$a884b22cb22f8e99)();
    const { loading: loading, data: data, error: error, refetch: refetch } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($dad67faa2a055d78$exports)))), {
        variables: {
            customerId: customerId
        },
        skip: customerId === $e9a95c61c800ecd2$export$15f47a32373730e5,
        fetchPolicy: "cache-first"
    });
    const refetchCustomer = ()=>refetch();
    const customer = data?.customer;
    const { data: { channels: channels = [] } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($36752eef17d2fd6d$exports)))));
    const isCreatingCustomer = customerId === $e9a95c61c800ecd2$export$15f47a32373730e5;
    const subPath = $e9a95c61c800ecd2$export$e8c60b88aa54a6db($e9a95c61c800ecd2$export$80abc9f9ce9de04c);
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    (0, $fgmOP.useEffect)(()=>{
        if (currentUserBrand?.id && customer && currentUserBrand.id !== customer?.brandId) isCustomer() ? navigate("/") : navigate(formatWithBrand($e9a95c61c800ecd2$export$5410ffbe3babddcb));
    }, [
        currentUserBrand,
        customer
    ]);
    $8e40c2561f1c547f$var$log.debug("render", {
        customerId: customerId,
        customer: customer,
        channels: channels,
        isCreatingCustomer: isCreatingCustomer
    });
    const pageTitle = loading ? "Loading Customer" : isCreatingCustomer ? "Creating customer" : customer && customer.company ? customer.company.name ? customer.company.name : "missing company name" : "No customer";
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7169106c226792c$export$2e2bcd8739ae039), {
                children: hasPermission((0, $ca0941499cca84bb$export$5baf0ad38a5e4791)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $cfbdc6dab8250bcb$export$2e2bcd8739ae039), {
                    text: "Provisioning",
                    link: formatWithBrand($e9a95c61c800ecd2$export$ebba33cd31d6b30c)
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $02b201edbdb8a3c4$export$2e2bcd8739ae039), {
                title: pageTitle
            }),
            loading ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : error ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $25d390e04dd0ffc0$export$2e2bcd8739ae039), {
                error: error
            }) : isCreatingCustomer ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$3565eb3d00ca5a74), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                    path: subPath($e9a95c61c800ecd2$export$725b0abc5ad90944),
                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $f2b7e9080d7c1c73$export$3cd8970d6dd01fc2), {})
                })
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bbc56e5aa7afa1c4$export$729687bd6e83ee94), {
                        ariaLabel: "Customer submenu",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$bd177ac5e923b770, customerId),
                                text: "Overview"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$725b0abc5ad90944, customerId),
                                text: "Company"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$f9e6c07fc68d7984, customerId),
                                text: "Users"
                            }),
                            (hasPermission((0, $ca0941499cca84bb$export$d6141afe674cb67b)) || customer && customer.contracts && customer.contracts.length >= 1) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$a4009a798127382a, customerId),
                                text: "Contracts"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$1208ff990906387d, customerId),
                                text: "Services"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$6d02b57a0acc5177, customerId),
                                text: "Communication"
                            }),
                            hasPermission((0, $ca0941499cca84bb$export$9745fea74799dd7b)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$a91491caafc6bee3, customerId),
                                text: "Settlements"
                            }),
                            hasPermission((0, $ca0941499cca84bb$export$2c134167e4d6a0ca)) && customer && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$369b0d9ad9b3e58, customer.id),
                                text: "ACL"
                            }),
                            (hasPermission((0, $ca0941499cca84bb$export$c7086708a0f042bc)) || hasPermission((0, $ca0941499cca84bb$export$2c134167e4d6a0ca))) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$185e199732aa14cd, customerId),
                                text: "Smpp Connections"
                            }),
                            hasPermission((0, $ca0941499cca84bb$export$5d3c7c2c3a35af76)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$da866688141ddd00, customerId),
                                text: "Documents"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $b60bd97a1f982072$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $dfdceb7c36fce96f$export$3565eb3d00ca5a74), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: subPath($e9a95c61c800ecd2$export$80abc9f9ce9de04c),
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$444b3ab0cb9aec40), {
                                            replace: true,
                                            to: formatWithBrand($e9a95c61c800ecd2$export$bd177ac5e923b770, customerId)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: subPath($e9a95c61c800ecd2$export$bd177ac5e923b770),
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $2f1ca21755509cd9$export$afa8f1fa72c122c5), {
                                            customer: customer
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: subPath($e9a95c61c800ecd2$export$725b0abc5ad90944),
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $f2b7e9080d7c1c73$export$3cd8970d6dd01fc2), {})
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: subPath($e9a95c61c800ecd2$export$cf0ddd3620037cd5),
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93c577777b23c9fd$export$855561da725d001b), {
                                            type: (0, $l8GLF.UserType).CUSTOMER,
                                            customerId: customerId,
                                            roles: customerRoles,
                                            goBackUrl: formatWithBrand($e9a95c61c800ecd2$export$f9e6c07fc68d7984, customerId)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: subPath($e9a95c61c800ecd2$export$f9e6c07fc68d7984),
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $839ba3e12383cc14$export$1644816dbb0b080d), {
                                            users: customer?.users,
                                            usersBaseUrl: pathname
                                        })
                                    }),
                                    [
                                        $e9a95c61c800ecd2$export$1c1df467d8f9dd85,
                                        $e9a95c61c800ecd2$export$e50d1075c5756827
                                    ].map((path)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                            path: subPath(path),
                                            element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$444b3ab0cb9aec40), {
                                                to: pathname.replace("products", "services")
                                            })
                                        }, path)),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: subPath($e9a95c61c800ecd2$export$dc7ad6b828d74f36),
                                        element: !customer ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $25d390e04dd0ffc0$export$2e2bcd8739ae039), {
                                            text: "Customer is undefined, ID: " + customerId
                                        }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c88f8d341fd43e4e$export$8b2af884909d32a5), {
                                            countryId: customer.countryId,
                                            brandId: customer.brandId
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: subPath($e9a95c61c800ecd2$export$1208ff990906387d),
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $b9117d55fa52f543$export$c447b0cdbd1cd184), {
                                            contracts: customer?.contracts
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: subPath($e9a95c61c800ecd2$export$57a19d7397b7cbfa),
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $76411173383b38d2$export$da3bb712330cc125), {
                                            contracts: customer?.contracts,
                                            refetchCustomer: refetchCustomer
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: subPath($e9a95c61c800ecd2$export$a4009a798127382a),
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5c6c94830b43772e$export$b280440818570a28), {
                                            contracts: customer?.contracts,
                                            customerId: customerId
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: subPath($e9a95c61c800ecd2$export$ddfcfcdd7c33e729),
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $b4e6dbee66d99acf$export$cf103e4e7d1d9b7b), {
                                            channels: channels
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: subPath($e9a95c61c800ecd2$export$6d02b57a0acc5177),
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $755293202d7f8111$export$627675a7dce038ce), {
                                            contacts: customer?.contacts,
                                            channels: channels
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: subPath($e9a95c61c800ecd2$export$a91491caafc6bee3),
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $f18dd74b507cedb4$export$606fa1b4aa5e213b), {})
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: subPath($e9a95c61c800ecd2$export$369b0d9ad9b3e58),
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $abcc0b9b07b77c66$export$6533858383d32124), {
                                            isDisplayed: hasPermission((0, $ca0941499cca84bb$export$2c134167e4d6a0ca)),
                                            navigateTo: formatWithBrand($e9a95c61c800ecd2$export$bd177ac5e923b770, customerId),
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $66c9ce6797c242a3$export$a0315dd7b15b1fe), {})
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: subPath($e9a95c61c800ecd2$export$f862805185457fce),
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $094f42e36775e720$export$b34a105447964f9f), {})
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: subPath($e9a95c61c800ecd2$export$da866688141ddd00),
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $17ea0037c549c0bc$export$5ab5355d0a784c8c), {
                                            customerId: customerId
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: subPath($e9a95c61c800ecd2$export$185e199732aa14cd),
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba52c036a92f272c$export$9ce69eb665c9fd81), {
                                            customerId: customerId
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$910ae8079b2c2852), {})
                        ]
                    }, pathname)
                ]
            })
        ]
    });
};






var $fgmOP = parcelRequire("fgmOP");

















parcelRequire("fgmOP");


const $95429ff786afb4e1$var$HighlightSpanFc = (props)=>{
    const { text: text, highlight: highlight = "", onlyWordStart: onlyWordStart = true } = props;
    let parts = text.split(new RegExp(`${onlyWordStart ? "\\b" : ""}(${highlight})`, "gi"));
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))(props.className),
        children: parts.map((part, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                    highlighted: part.toLowerCase() === highlight && highlight.toLowerCase()
                }),
                children: part
            }, i))
    });
};
var $95429ff786afb4e1$export$2e2bcd8739ae039 = $95429ff786afb4e1$var$HighlightSpanFc;










const $28bcf080945e3814$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("CustomerList", "INFO");
const $28bcf080945e3814$export$ab18d90c247c65f4 = (props)=>{
    const [filter, setFilter] = (0, $fgmOP.useState)("");
    const { showInactive: showInactive, showInactiveComponent: showInactiveComponent } = (0, $152b6193e99b7439$export$84f600a904db3b68)();
    const { loading: loading, customerOverviews: customerOverviews } = (0, $8d8d8b3d38044bbe$export$d27d8317adc3c298)();
    (0, $c3440150448da8b8$export$1c72fe480f599e97)([
        {
            query: "Customers",
            isLoading: loading
        }
    ]);
    const customers = (0, $fgmOP.useMemo)(()=>$28bcf080945e3814$export$f84f4103f0eff9cb(customerOverviews, filter, showInactive), [
        customerOverviews,
        filter,
        showInactive
    ]);
    const { hasPermission: hasPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const customersFilterInput = (0, $fgmOP.useRef)();
    (0, $fgmOP.useEffect)(()=>{
        // setFilter('');
        customersFilterInput?.current?.focus();
    }, [
        customersFilterInput.current
    ]);
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    $28bcf080945e3814$var$log.debug("render", {
        customers: customers
    });
    if (!hasPermission((0, $ca0941499cca84bb$export$5baf0ad38a5e4791))) return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $53784455b29a4a12$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7169106c226792c$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $cfbdc6dab8250bcb$export$2e2bcd8739ae039), {
                    text: "Provisioning",
                    link: formatWithBrand($e9a95c61c800ecd2$export$ebba33cd31d6b30c)
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $02b201edbdb8a3c4$export$2e2bcd8739ae039), {
                title: "Customers",
                showLoading: true
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "customers"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$2e2bcd8739ae039), {
                            placeholder: "Filter",
                            icon: "search",
                            isEditing: true,
                            value: filter,
                            onChange: (value)=>setFilter((value || "").toLowerCase()),
                            inputRef: customersFilterInput
                        })
                    }),
                    hasPermission((0, $ca0941499cca84bb$export$d9a19ca7f33b36c1)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                            id: "createCustomerButton",
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                                to: formatWithBrand($e9a95c61c800ecd2$export$725b0abc5ad90944, $e9a95c61c800ecd2$export$15f47a32373730e5),
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    text: "Create customer"
                                })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: showInactiveComponent
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                children: customers && !customers.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                    id: "customer-list__wrapper",
                    className: "customer-list--wrapper",
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $98cbb91c03e56cc2$export$2e2bcd8739ae039), {
                        id: "customer-list",
                        className: "customer-list",
                        children: customers.map((customer)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($28bcf080945e3814$export$76fbf5dfd67987da, {
                                customer: customer,
                                filter: filter
                            }, customer.id))
                    })
                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                    children: filter ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                        children: [
                            "No customers found with current filter ",
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                className: "teliaPurple",
                                children: filter
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                        children: "No customers found"
                    })
                })
            })
        ]
    });
};
const $28bcf080945e3814$var$isActive = ({ state: state })=>state === "ACTIVE";
const $28bcf080945e3814$export$f84f4103f0eff9cb = (customerOverviews = [], filter, showInactive)=>{
    const { isAccessNumberOverview: isAccessNumberOverview, isAccessNumberRangeOverview: isAccessNumberRangeOverview, isReservedOaOverview: isReservedOaOverview, isRbmOverview: isRbmOverview, isGenericOverview: isGenericOverview } = (0, $fd8c6dbb137f29e9$export$c7485df156f0670e)();
    let filteredCustomerOverviews = [
        ...customerOverviews
    ];
    if (!showInactive) filteredCustomerOverviews = filteredCustomerOverviews?.map(({ productOverviews: productOverviews, ...customerOverview })=>({
            productOverviews: productOverviews.filter($28bcf080945e3814$var$isActive),
            ...customerOverview
        })).filter(({ productOverviews: productOverviews })=>productOverviews && productOverviews.length > 0);
    if (filter?.length > 0) {
        if (isNaN(parseInt(filter))) //  text filter to match with customer name
        filteredCustomerOverviews = filteredCustomerOverviews.filter((c)=>c.name && c.name.toLowerCase().includes(filter.toLowerCase()) || c.productOverviews.some((overview)=>isReservedOaOverview(overview) && ("senderids".startsWith(filter.toLowerCase()) || overview.reservedOas?.some((reservedOa)=>reservedOa.startsWith(filter.toLowerCase()))) || isRbmOverview(overview) && ("rbm".startsWith(filter.toLowerCase()) || overview.rbmAgentOwner.startsWith(filter.toLowerCase())) || isGenericOverview(overview) && overview.productTypeId.toLowerCase().startsWith(filter.toLowerCase())));
        else //  numeric filter to match access numbers
        filteredCustomerOverviews = filteredCustomerOverviews?.map(({ productOverviews: productOverviews, ...customerOverview })=>({
                productOverviews: [
                    ...productOverviews.filter((overview)=>isAccessNumberOverview(overview) && overview.accessNumber.startsWith(filter)),
                    ...productOverviews.filter((overview)=>isAccessNumberRangeOverview(overview) && overview.accessNumberRange.from.startsWith(filter))
                ],
                ...customerOverview
            })).filter(({ productOverviews: productOverviews })=>productOverviews?.length);
    }
    $28bcf080945e3814$var$log.debug("customersFilter", filter);
    return filteredCustomerOverviews;
};
const $28bcf080945e3814$export$76fbf5dfd67987da = ({ customer: customer, filter: filter })=>{
    const { isAccessNumberOverview: isAccessNumberOverview, isAccessNumberRangeOverview: isAccessNumberRangeOverview, isReservedOaOverview: isReservedOaOverview, isRbmOverview: isRbmOverview, isGenericOverview: isGenericOverview } = (0, $fd8c6dbb137f29e9$export$c7485df156f0670e)();
    const { getName: getName } = (0, $98effcf86fafb9fb$export$75025970e7082eca)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $d8d7fa9fc21de820$export$2e2bcd8739ae039), {
        className: "customer-list__item",
        id: (0, $0857d9353dc337e9$export$d5d25c90fc92fce5)(customer.id, "customer"),
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                to: formatWithBrand($e9a95c61c800ecd2$export$bd177ac5e923b770, customer.id),
                children: customer.name ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $95429ff786afb4e1$export$2e2bcd8739ae039), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("customer-list__item__company-name bold", {
                        inactive: false
                    }),
                    text: customer.name,
                    highlight: filter,
                    onlyWordStart: false
                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                    className: "customer-list__item__company-name bold missing",
                    children: "missing company name"
                })
            }, customer.id),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "customer-list__item__short-numbers",
                children: [
                    ...customer.productOverviews.map((overview)=>({
                            ...overview,
                            text: isAccessNumberOverview(overview) && overview.accessNumber || isAccessNumberRangeOverview(overview) && "[" + overview.accessNumberRange?.from + "-" + overview.accessNumberRange?.to + "]" || isReservedOaOverview(overview) && overview.reservedOas?.length && overview.reservedOas.length > 0 && `SenderID[${overview.productName ? overview.productName : overview.reservedOas.join(", ")}](${overview.reservedOas.length})` || isRbmOverview(overview) && "RBM[" + overview.rbmAgentOwner + "]" || isGenericOverview(overview) && getName(overview.productTypeId) || ""
                        }))
                ].map(({ customerId: customerId, contractId: contractId, productId: productId, state: state, text: text })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                            [`${state.toLowerCase() + "Period"}`]: !$28bcf080945e3814$var$isActive({
                                state: state
                            })
                        }),
                        title: state,
                        to: formatWithBrand($e9a95c61c800ecd2$export$dc7ad6b828d74f36, customerId, contractId, productId),
                        onClick: (e)=>{
                            $28bcf080945e3814$var$log.debug("accessNumber click", {
                                customerId: customerId,
                                contractId: contractId,
                                productId: productId,
                                text: text
                            });
                            e.stopPropagation();
                        },
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                            className: "accessNumberOverview",
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $95429ff786afb4e1$export$2e2bcd8739ae039), {
                                text: text,
                                highlight: filter,
                                onlyWordStart: true
                            })
                        })
                    }, productId))
            })
        ]
    }, customer.id);
};





var $fgmOP = parcelRequire("fgmOP");

var $8acf2547d4873541$exports = {};
$8acf2547d4873541$exports = "query product($productId:ID!){product(id:$productId){...productFragment}}fragment productFragment on Product{id countryId brandId customerId contractId productType accessNumber accessNumberRange{from to count}rbmAgentOwner startDate endDate inheritsEndDate gracePeriodStartDate establishFee monthlyFee addressingPolicy allowedOriginatingAddresses name comment routingConfigId qosProfile{enabled maxSmsPerSecond messagePriority}features{id featureTypeId startDate endDate featureProperties{accessNumberId}}feeOverrides{feeTypeId amount}}";













const $6cd30cb5db77b431$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ProductRedirectFc", "INFO");
const $6cd30cb5db77b431$export$9539337f23792ff0 = (props)=>{
    const { productId: productId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const { pathname: pathname } = (0, $dfdceb7c36fce96f$export$45d76561a5302f2b)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const { hasPermission: hasPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { loading: loading, data: data, error: error } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($8acf2547d4873541$exports)))), {
        variables: {
            productId: productId
        }
    });
    const product = data?.product;
    (0, $fgmOP.useEffect)(()=>{
        if (!loading && product) navigate(formatWithBrand($e9a95c61c800ecd2$export$dc7ad6b828d74f36, product.customerId, product.contractId, product.id), {
            replace: true
        });
    }, [
        loading,
        product
    ]);
    $6cd30cb5db77b431$var$log.debug("render", {
        productId: productId,
        product: product,
        error: error
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7169106c226792c$export$2e2bcd8739ae039), {
                children: hasPermission((0, $ca0941499cca84bb$export$5baf0ad38a5e4791)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $cfbdc6dab8250bcb$export$2e2bcd8739ae039), {
                    text: "Provisioning",
                    link: formatWithBrand($e9a95c61c800ecd2$export$ebba33cd31d6b30c)
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $02b201edbdb8a3c4$export$2e2bcd8739ae039), {
                title: "Service redirect"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "service-redirect"
            }),
            loading ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                            children: "Finding service's customer and contract information..."
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {})
                ]
            }) : error ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $25d390e04dd0ffc0$export$2e2bcd8739ae039), {
                error: error,
                text: error.message.includes("Forbidden") ? `Authorization error trying to access a service of another customer!` : undefined
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                        children: "Service found redirecting to services page under customer's contract section. "
                    }),
                    product && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                        children: [
                            "Click",
                            " ",
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                                to: formatWithBrand($e9a95c61c800ecd2$export$dc7ad6b828d74f36, product.customerId, product.contractId, product.id),
                                className: "underline",
                                children: "here"
                            }),
                            " ",
                            "if the page doesn't redirect"
                        ]
                    })
                ]
            })
        ]
    });
};




var $fgmOP = parcelRequire("fgmOP");














var $fgmOP = parcelRequire("fgmOP");











const $df05ffef410ba120$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("AccessNumberHistory");
const { activeStatus: $df05ffef410ba120$var$activeStatus, isActive: $df05ffef410ba120$var$isActive, isFuture: $df05ffef410ba120$var$isFuture, isExpired: $df05ffef410ba120$var$isExpired, isValid: $df05ffef410ba120$var$isValid, overlap: $df05ffef410ba120$var$overlap } = (0, $f5d0c2a7498ff49b$exports.period);
const $df05ffef410ba120$export$6fc06777f4868863 = ()=>{
    const { loading: loading, accessNumberHistoryList: accessNumberHistoryList } = (0, $795fd6aaaa16f06b$export$4324e0562a89d177)();
    (0, $c3440150448da8b8$export$1c72fe480f599e97)([
        {
            query: "accessNumberHistory",
            isLoading: loading
        }
    ]);
    const { accessNumberOrRange: accessNumberOrRange } = (0, $1889e1147019478d$export$edbfa4c6d5f6410c)();
    $df05ffef410ba120$var$log.debug("render", {
        loading: loading,
        accessNumberHistoryList: accessNumberHistoryList
    });
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Access Numbers History"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "access-number-history"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                children: accessNumberHistoryList && !accessNumberHistoryList.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                    id: "customer-list__wrapper",
                    className: "customer-list--wrapper",
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $98cbb91c03e56cc2$export$2e2bcd8739ae039), {
                        className: "customer-list",
                        children: accessNumberHistoryList.filter(({ accessNumber: accessNumber })=>accessNumber).map((accessNumber)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $d8d7fa9fc21de820$export$2e2bcd8739ae039), {
                                className: "customer-list__item",
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                            className: "bold width5rem noWrap",
                                            children: accessNumberOrRange(accessNumber)
                                        })
                                    }),
                                    accessNumber.productHistory.map((product)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                            className: "list__link list__item--hover-outline",
                                            onClick: ()=>navigate(formatWithBrand($e9a95c61c800ecd2$export$dc7ad6b828d74f36, product.customerId, product.contractId, product.id)),
                                            children: [
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                    className: "disabled",
                                                    children: "From "
                                                }),
                                                product.startDate,
                                                " ",
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                    className: "disabled",
                                                    children: " to "
                                                }),
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                    className: "width8rem",
                                                    children: product.endDate ? product.endDate : "no end"
                                                }),
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("width5rem", $df05ffef410ba120$var$activeStatus(product).toLowerCase() + "Period"),
                                                    children: $df05ffef410ba120$var$activeStatus(product)
                                                }),
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                                                    children: [
                                                        " ",
                                                        product.customerName
                                                    ]
                                                })
                                            ]
                                        }, accessNumber.accessNumber + "-" + product.id + "-" + product.startDate))
                                ]
                            }, accessNumber.accessNumber))
                    })
                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                    children: "No access numbers found" /*No access numbers found with current filter <span className='teliaPurple'>{customersFilter}</span>*/ 
                })
            })
        ]
    });
};







var $fgmOP = parcelRequire("fgmOP");
var $241392bf121c5ce9$exports = {};
$241392bf121c5ce9$exports = "query aggregatedTransactions($endDate:Date$startDate:Date){aggregatedTransactions(endDate:$endDate startDate:$startDate){...aggregatedTransactionFragment}}fragment aggregatedTransactionFragment on AggregatedTransaction{serviceCategory categoryType accountNumber chargeType balanceType count amount}";















var $fgmOP = parcelRequire("fgmOP");





const $c8112e20ecbc0ea7$export$6527b904945bdb92 = (a, b)=>{
    return a.length !== b.length ? a.length - b.length : a.localeCompare(b);
};
const $c8112e20ecbc0ea7$export$3754e0b777cdd23e = {
    accessNumber: $c8112e20ecbc0ea7$export$6527b904945bdb92
};




const $36a1555d310b2890$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReportDcbTable", "INFO");
const { THead: $36a1555d310b2890$var$THead, Tr: $36a1555d310b2890$var$Tr, ThSortable: $36a1555d310b2890$var$ThSortable, TBody: $36a1555d310b2890$var$TBody, Td: $36a1555d310b2890$var$Td } = (0, $c1364c3d18563e9b$export$2e2bcd8739ae039);
const $36a1555d310b2890$export$470dcfd07ac74636 = [
    "balanceType",
    "chargeType",
    "accountNumber",
    "serviceCategory",
    "categoryType"
];
const $36a1555d310b2890$export$d5523731e7fe4ded = (groupBy)=>{
    const groupByFields = $36a1555d310b2890$export$470dcfd07ac74636.filter((field)=>groupBy.includes(field));
    return [
        ...groupByFields,
        "count",
        "amount"
    ];
};
const $36a1555d310b2890$export$d57d50d329e176cd = (field)=>{
    switch(field){
        case "serviceCategory":
            return "Service category";
        case "categoryType":
            return "Category type";
        case "accountNumber":
            return "Account Num";
        case "chargeType":
            return "Charge type";
        case "balanceType":
            return "Balance type";
        case "count":
            return "Count";
        case "amount":
            return "NOK";
        default:
            return "";
    }
};
const $36a1555d310b2890$export$16136857915bc327 = (aggregatedTransaction, groupBy)=>{
    return groupBy.map((fieldName)=>aggregatedTransaction[fieldName]).join("-");
};
const $36a1555d310b2890$export$5120c51b228c9100 = (acc, row)=>{
    const prevRow = acc[acc.length - 1];
    const prevAcc = acc.slice(0, acc.length - 1); // acc array without prevRow
    return !prevRow ? [
        row
    ] : prevRow.groupId !== row.groupId ? [
        ...prevAcc,
        prevRow,
        row
    ] : [
        ...prevAcc,
        {
            ...row,
            count: row.count + prevRow.count,
            amount: row.amount + prevRow.amount
        }
    ];
};
const $36a1555d310b2890$export$5722980d194eca50 = (aggregatedTransactions, groupBy)=>aggregatedTransactions.map((aggregatedTransaction)=>({
            ...aggregatedTransaction,
            groupId: $36a1555d310b2890$export$16136857915bc327(aggregatedTransaction, groupBy)
        })).sort((a, b)=>a.groupId.localeCompare(b.groupId)).reduce($36a1555d310b2890$export$5120c51b228c9100, []).map((aggregatedTransaction)=>$36a1555d310b2890$export$d5523731e7fe4ded(groupBy).reduce((acc, fieldName)=>({
                ...acc,
                [`${fieldName}`]: aggregatedTransaction[fieldName]
            }), {}));
const $36a1555d310b2890$var$fieldClassName = (field)=>[
        "count",
        "amount"
    ].includes(field) ? "right" : "";
const $36a1555d310b2890$var$_ReportDcbTable = (props)=>{
    $36a1555d310b2890$var$log.debug("render", props);
    const { loading: loading, groupBy: groupBy, aggregatedTransactions: aggregatedTransactions } = props;
    const fields = $36a1555d310b2890$export$d5523731e7fe4ded(groupBy);
    const _groupedAggregatedTransactions = (0, $fgmOP.useMemo)(()=>$36a1555d310b2890$export$5722980d194eca50(aggregatedTransactions, groupBy), [
        aggregatedTransactions,
        groupBy
    ]);
    const [sortedAggregatedTransactions, getThSortableProps] = (0, $c1364c3d18563e9b$export$2e2bcd8739ae039).useThSortable(_groupedAggregatedTransactions, 3, [], (0, $c8112e20ecbc0ea7$export$3754e0b777cdd23e));
    const { serviceCategoryDisplayName: serviceCategoryDisplayName, categoryTypeDisplayName: categoryTypeDisplayName } = (0, $5cd44d723b4013a5$export$97aa5844287be9bb)();
    const fieldValue = (field, aggregatedTransaction)=>{
        const value = aggregatedTransaction[field];
        switch(field){
            case "serviceCategory":
                return serviceCategoryDisplayName(value);
            case "categoryType":
                return categoryTypeDisplayName(aggregatedTransaction.serviceCategory, value);
            case "count":
            case "amount":
                return (0, $f5d0c2a7498ff49b$exports.format).integer(value);
            default:
                return value;
        }
    };
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
            className: "marginTop",
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039), {
                    id: "reportDcbTable",
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($36a1555d310b2890$var$THead, {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($36a1555d310b2890$var$Tr, {
                                children: fields.map((field)=>/*#__PURE__*/ (0, $fgmOP.createElement)($36a1555d310b2890$var$ThSortable, {
                                        ...getThSortableProps(field),
                                        className: $36a1555d310b2890$var$fieldClassName(field),
                                        key: field
                                    }, $36a1555d310b2890$export$d57d50d329e176cd(field)))
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($36a1555d310b2890$var$TBody, {
                            children: sortedAggregatedTransactions && sortedAggregatedTransactions.map((aggregatedTransaction, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($36a1555d310b2890$var$Tr, {
                                    className: aggregatedTransaction.amount < 0 ? "negative" : "",
                                    children: fields.map((field)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($36a1555d310b2890$var$Td, {
                                            className: $36a1555d310b2890$var$fieldClassName(field),
                                            children: fieldValue(field, aggregatedTransaction)
                                        }, field + "i"))
                                }, i))
                        })
                    ]
                }),
                loading && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}),
                aggregatedTransactions && (aggregatedTransactions.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                    children: "No statistics found"
                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                    text: "Download as CSV",
                    onClick: ()=>$36a1555d310b2890$var$downloadAsCsv(sortedAggregatedTransactions, fields)
                }))
            ]
        })
    });
};
const $36a1555d310b2890$var$downloadAsCsv = (aggregatedTransactions, fields)=>{
    const header = fields.map((field)=>`"${$36a1555d310b2890$export$d57d50d329e176cd(field)}"`);
    const rows = aggregatedTransactions.map((aggregatedTransaction, i)=>fields.map((field)=>aggregatedTransaction[field]));
    const content = [
        header,
        ...rows
    ];
    const csv = content.map((line)=>line.join(";")).join("\r\n");
    const filename = "report.csv";
    const blob = new Blob([
        csv
    ], {
        type: "text/csv;charset=utf-8;"
    });
    const link = document.createElement("a");
    if (link.download !== undefined) {
        // support HTML5 download attribute
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};
var $36a1555d310b2890$export$2e2bcd8739ae039 = $36a1555d310b2890$var$_ReportDcbTable;


const { balanceTypes: $eafd33fda0492bba$var$balanceTypes, chargeTypes: $eafd33fda0492bba$var$chargeTypes } = (0, $f5d0c2a7498ff49b$exports.constants);
const $eafd33fda0492bba$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReportDcb", "INFO");
const { isValid: $eafd33fda0492bba$var$isValid } = (0, $f5d0c2a7498ff49b$exports.period);
const $eafd33fda0492bba$var$getGroupedBy = (entity)=>entity?.fieldsGrouping || [];
const $eafd33fda0492bba$var$getFilters = (entity)=>{
    $eafd33fda0492bba$var$log.debug("getFilters");
    const groupedBy = $eafd33fda0492bba$var$getGroupedBy(entity);
    return !entity ? [] : (0, $36a1555d310b2890$export$470dcfd07ac74636).filter((f)=>groupedBy.includes(f)).map((fieldName)=>({
            fieldName: fieldName,
            fieldValue: entity[`${fieldName}Filtering`] || null
        })).filter(({ fieldValue: fieldValue })=>!!fieldValue);
};
const $eafd33fda0492bba$var$filterAggregatedTransactions = (aggregatedTransactions, fieldFilters)=>{
    $eafd33fda0492bba$var$log.debug("filterAggregatedTransactions");
    return aggregatedTransactions?.filter((aggregatedTransaction)=>fieldFilters.every(({ fieldName: fieldName, fieldValue: fieldValue })=>fieldValue === aggregatedTransaction[fieldName]));
};
const $eafd33fda0492bba$var$formStateOptions = {
    isEditing: true,
    useUrlParams: true,
    preferenceFieldNames: [
        "startDate",
        "endDate",
        "fieldsGrouping",
        "balanceTypeFiltering",
        "chargeTypeFiltering",
        "accountNumberFiltering",
        "serviceCategoryFiltering",
        "categoryTypeFiltering"
    ],
    fixedFields: {}
};
const $eafd33fda0492bba$export$c78c2239403a0e35 = (props)=>{
    const [state, setState] = (0, $fgmOP.useState)({
        loading: false,
        editingSearch: true
    });
    const { loading: loading, editingSearch: editingSearch, aggregatedTransactions: aggregatedTransactions } = state;
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)($eafd33fda0492bba$var$formStateOptions);
    const { entity: entity, isEditing: isEditing, onSaved: onSaved, onCancel: onCancel, onEdit: onEdit, onChange: onChange, clearErrors: clearErrors, putError: putError } = formState;
    const { serviceCategories: serviceCategories, serviceCategoryDisplayName: serviceCategoryDisplayName, categoryTypeDisplayName: categoryTypeDisplayName } = (0, $5cd44d723b4013a5$export$97aa5844287be9bb)();
    const fieldFilters = (0, $fgmOP.useMemo)(()=>$eafd33fda0492bba$var$getFilters(entity), [
        entity
    ]);
    const filteredAggregatedTransactions = (0, $fgmOP.useMemo)(()=>$eafd33fda0492bba$var$filterAggregatedTransactions(aggregatedTransactions, fieldFilters), [
        aggregatedTransactions,
        fieldFilters
    ]);
    const apolloClient = (0, $7626a5aec6f1579a$export$eb9a56e7a29e494)();
    const editSearch = ()=>{
        setState({
            loading: false,
            editingSearch: true,
            aggregatedTransactions: undefined
        });
    };
    const fetchAggregatedTransactions = ()=>{
        if (!entity) return;
        const { startDate: startDate, endDate: endDate, fieldsGrouping: fieldsGrouping } = entity;
        const parameters = {
            startDate: startDate,
            endDate: endDate
        };
        $eafd33fda0492bba$var$log.info("Fetch aggregatedTransactions", {
            ...parameters
        });
        clearErrors();
        if (!startDate) {
            putError("startDate", "Start date is required");
            return;
        }
        if (!endDate) {
            putError("endDate", "End date is required");
            return;
        }
        if (!$eafd33fda0492bba$var$isValid(parameters)) {
            putError("startDate", "Invalid search period");
            putError("endDate", "Invalid search period");
            return;
        }
        $eafd33fda0492bba$var$log.info("Fetch aggregated transactions", parameters);
        setState({
            loading: true,
            editingSearch: false
        });
        apolloClient.query({
            query: (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($241392bf121c5ce9$exports)))),
            variables: {
                ...parameters
            }
        }).then((res)=>{
            $eafd33fda0492bba$var$log.debug("resolved fetch aggregatedTransactions", res);
            setState({
                loading: false,
                editingSearch: false,
                aggregatedTransactions: res.data.aggregatedTransactions
            });
        }).catch((error)=>{
            setState({
                loading: false,
                editingSearch: false,
                aggregatedTransactions: [],
                error: error
            });
        });
        return null;
    };
    $eafd33fda0492bba$var$log.debug("render", {
        serviceCategories: serviceCategories,
        props: props,
        state: state
    });
    const isGroupingBy = (field)=>$eafd33fda0492bba$var$getGroupedBy(entity).includes(field);
    const filterDisplayName = ({ fieldName: fieldName, fieldValue: fieldValue })=>{
        switch(fieldName){
            case "serviceCategory":
                return serviceCategoryDisplayName(fieldValue);
            case "categoryType":
                return categoryTypeDisplayName(entity?.serviceCategoryFiltering, fieldValue);
            default:
                return fieldValue;
        }
    };
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        id: "reportDcb",
        className: "form--column--margin--normal",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Direct Charging and Billing"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "dcb"
            }),
            entity && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $2e4c8094e1930e9a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "startDate",
                                    label: "From date",
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date,
                                    defaultValue: "since ever",
                                    isEditing: editingSearch
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "endDate",
                                    label: "To date",
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date,
                                    defaultValue: "no end",
                                    isEditing: editingSearch
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            size: (0, $6c2490027a2e159e$export$2e5aae5cf40e4ee1),
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                id: "fetchStatistics",
                                children: editingSearch ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    onClick: fetchAggregatedTransactions,
                                    text: "Fetch Aggregated Transactions",
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary,
                                    className: "marginTop"
                                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    onClick: editSearch,
                                    text: "Edit search",
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.normal,
                                    className: "marginTop"
                                })
                            })
                        })
                    }),
                    aggregatedTransactions && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        size: (0, $6c2490027a2e159e$export$2e5aae5cf40e4ee1),
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                label: "Field grouping",
                                                formState: formState,
                                                entityFieldId: "fieldsGrouping",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi,
                                                options: [
                                                    {
                                                        id: "balanceType",
                                                        name: "Debit/Credit"
                                                    },
                                                    {
                                                        id: "chargeType",
                                                        name: "Pre/Postpaid"
                                                    },
                                                    {
                                                        id: "accountNumber",
                                                        name: "Account number"
                                                    },
                                                    {
                                                        id: "serviceCategory",
                                                        name: "Service category"
                                                    },
                                                    {
                                                        id: "categoryType",
                                                        name: "Category type",
                                                        description: isGroupingBy("serviceCategory") ? undefined : `Only when grouping by 'Service category'`,
                                                        isDisabled: !isGroupingBy("serviceCategory")
                                                    }
                                                ],
                                                className: "noWrap",
                                                isEditing: true,
                                                onChangeAlso: (grouping)=>grouping.includes("serviceCategory") || onChange("fieldsGrouping")(grouping.cloneExcluding("categoryType"))
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                label: "Balance type filtering",
                                                formState: formState,
                                                entityFieldId: "balanceTypeFiltering",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                options: $eafd33fda0492bba$var$balanceTypes,
                                                className: "noWrap",
                                                isEditing: true,
                                                isNullable: true,
                                                isDisabled: !isGroupingBy("balanceType"),
                                                tip: !isGroupingBy("balanceType") && `Group by 'Debit/Credit' to enable filtering`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        size: (0, $6c2490027a2e159e$export$2e5aae5cf40e4ee1),
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                label: "Charge type filtering",
                                                formState: formState,
                                                entityFieldId: "chargeTypeFiltering",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                options: $eafd33fda0492bba$var$chargeTypes,
                                                className: "noWrap",
                                                isEditing: true,
                                                isNullable: true,
                                                isDisabled: !isGroupingBy("chargeType"),
                                                tip: !isGroupingBy("chargeType") && `Group by 'Pre/Postpaid' to enable filtering`
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                label: "Account num. filtering",
                                                formState: formState,
                                                entityFieldId: "accountNumberFiltering",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).input,
                                                className: "noWrap",
                                                isEditing: true,
                                                isDisabled: !isGroupingBy("accountNumber"),
                                                tip: !isGroupingBy("accountNumber") && `Group by 'Account number' to enable filtering`
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        size: (0, $6c2490027a2e159e$export$2e5aae5cf40e4ee1),
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                            label: "Service category filtering",
                                            formState: formState,
                                            entityFieldId: "serviceCategoryFiltering",
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                            options: serviceCategories?.map(({ id: id })=>({
                                                    id: id,
                                                    name: serviceCategoryDisplayName(id)
                                                })),
                                            className: "noWrap",
                                            isEditing: true,
                                            isNullable: true,
                                            isDisabled: !isGroupingBy("serviceCategory"),
                                            tip: !isGroupingBy("serviceCategory") && `Group by 'Service category' to enable filtering`,
                                            onChangeAlso: ()=>onChange("categoryTypeFiltering")(null)
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        size: (0, $6c2490027a2e159e$export$2e5aae5cf40e4ee1),
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                            label: "Category type filtering",
                                            formState: formState,
                                            entityFieldId: "categoryTypeFiltering",
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                            defaultValue: entity?.serviceCategoryFiltering ? undefined : `Select 'Service category'`,
                                            options: serviceCategories?.filter(({ id: serviceCategoryId })=>serviceCategoryId === entity?.serviceCategoryFiltering).reduce((_, { id: serviceCategoryId, types: types })=>types.map(({ id: comboId, typeId: typeId })=>({
                                                        id: typeId,
                                                        name: categoryTypeDisplayName(serviceCategoryId, typeId)
                                                    })), []),
                                            className: "noWrap",
                                            isEditing: true,
                                            isNullable: true,
                                            isDisabled: !isGroupingBy("categoryType"),
                                            tip: !isGroupingBy("categoryType") && `Group by 'Category type' to enable filtering`
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}),
            filteredAggregatedTransactions && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    fieldFilters && !fieldFilters.isEmpty() && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        id: "filters",
                        children: [
                            "Filters:",
                            fieldFilters.map(({ fieldName: fieldName, fieldValue: fieldValue })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                    className: "filter",
                                    children: filterDisplayName({
                                        fieldName: fieldName,
                                        fieldValue: fieldValue
                                    })
                                }, fieldName))
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $36a1555d310b2890$export$2e2bcd8739ae039), {
                        loading: loading,
                        aggregatedTransactions: filteredAggregatedTransactions,
                        groupBy: $eafd33fda0492bba$var$getGroupedBy(entity)
                    })
                ]
            })
        ]
    });
};




parcelRequire("fgmOP");















var $fgmOP = parcelRequire("fgmOP");
var $ea168c7b8937529d$exports = {};
"use strict";
var $ea168c7b8937529d$var$__extends = $ea168c7b8937529d$exports && $ea168c7b8937529d$exports.__extends || function() {
    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $ea168c7b8937529d$var$__assign = $ea168c7b8937529d$exports && $ea168c7b8937529d$exports.__assign || function() {
    $ea168c7b8937529d$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $ea168c7b8937529d$var$__assign.apply(this, arguments);
};
var $ea168c7b8937529d$var$__rest = $ea168c7b8937529d$exports && $ea168c7b8937529d$exports.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
    }
    return t;
};
var $ea168c7b8937529d$var$__importStar = $ea168c7b8937529d$exports && $ea168c7b8937529d$exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result["default"] = mod;
    return result;
};

var $ea168c7b8937529d$var$PropTypes = $ea168c7b8937529d$var$__importStar((parcelRequire("jPPOv")));

var $ea168c7b8937529d$var$React = $ea168c7b8937529d$var$__importStar((parcelRequire("fgmOP")));
function $ea168c7b8937529d$var$getStyleValue(name, theme, styles) {
    var extra = styles[name + "Style"] || "";
    var style = theme ? theme[name] || "" : "";
    return extra ? extra + ";" + style : style;
}
function $ea168c7b8937529d$var$getStyle(name, theme, styles) {
    var value = $ea168c7b8937529d$var$getStyleValue(name, theme, styles);
    return value ? ' style="' + value + '"' : "";
}
var $ea168c7b8937529d$var$xssmap = {
    '"': "&quot;",
    "'": "&apos;",
    "&": "&amp;",
    ">": "&gt;",
    "<": "&lt"
};
function $ea168c7b8937529d$var$xss(s) {
    if (!s) return s;
    return s.replace(/<|>|&|"|'/g, function(m) {
        return $ea168c7b8937529d$var$xssmap[m];
    });
}
var $ea168c7b8937529d$var$JSONPretty = /** @class */ function(_super) {
    $ea168c7b8937529d$var$__extends(JSONPretty, _super);
    function JSONPretty() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    JSONPretty.prototype.render = function() {
        var _a = this.props, json = _a.json, data = _a.data, replacer = _a.replacer, space = _a.space, themeClassName = _a.themeClassName, theme = _a.theme, onJSONPrettyError = _a.onJSONPrettyError, onError = _a.onError, silent = _a.silent, mainStyle = _a.mainStyle, keyStyle = _a.keyStyle, valueStyle = _a.valueStyle, stringStyle = _a.stringStyle, booleanStyle = _a.booleanStyle, errorStyle = _a.errorStyle, rest = $ea168c7b8937529d$var$__rest(_a, [
            "json",
            "data",
            "replacer",
            "space",
            "themeClassName",
            "theme",
            "onJSONPrettyError",
            "onError",
            "silent",
            "mainStyle",
            "keyStyle",
            "valueStyle",
            "stringStyle",
            "booleanStyle",
            "errorStyle"
        ]);
        var styles = {
            mainStyle: mainStyle,
            keyStyle: keyStyle,
            valueStyle: valueStyle,
            stringStyle: stringStyle,
            booleanStyle: booleanStyle,
            errorStyle: errorStyle
        };
        var obj = data || json;
        // See https://facebook.github.io/react/warnings/unknown-prop.html
        if (typeof obj === "string") try {
            obj = JSON.parse(obj);
        } catch (e) {
            if (!silent) console.warn("[react-json-pretty]: " + e.message);
            if (onJSONPrettyError) onJSONPrettyError(e);
            if (!onJSONPrettyError && onError) {
                onError(e);
                console.warn("JSONPretty#onError is deprecated, please use JSONPretty#onJSONPrettyError instead");
            }
            return $ea168c7b8937529d$var$React.createElement("div", $ea168c7b8937529d$var$__assign({}, rest, {
                dangerouslySetInnerHTML: {
                    __html: '<pre class="__json-pretty-error__"' + $ea168c7b8937529d$var$getStyle("error", theme, styles) + ">" + $ea168c7b8937529d$var$xss(obj) + "</pre>"
                }
            }));
        }
        return $ea168c7b8937529d$var$React.createElement("div", $ea168c7b8937529d$var$__assign({}, rest, {
            dangerouslySetInnerHTML: {
                __html: '<pre class="' + themeClassName + '"' + $ea168c7b8937529d$var$getStyle("main", theme, styles) + ">" + this._pretty(theme, obj, replacer, +space, styles) + "</pre>"
            }
        }));
    };
    // JSON =》 HTML转换器
    JSONPretty.prototype._pretty = function(theme, obj, replacer, space, styles) {
        // 逐行匹配，列举：“key”: "value" | "key": value | "key": [ | "key": { | "key": [],| "Key": {},
        var regLine = /^( *)("[^"]+": )?("[^"]*"|[\w.+-]*)?([,[{]|\[\s*\],?|\{\s*\},?)?$/mg;
        var text = JSON.stringify(obj, typeof replacer === "function" ? replacer : null, isNaN(space) ? 2 : space);
        /* istanbul ignore next */ if (!text) return text;
        return text.replace(/&/g, "&amp;").replace(/\\"([^,])/g, "\\&quot;$1").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(regLine, this._replace.bind(null, theme, styles));
    };
    // 格式化函数
    JSONPretty.prototype._replace = function(theme, styles, match, ind, key, val, tra) {
        var spanEnd = "</span>";
        var keySpan = '<span class="__json-key__"' + $ea168c7b8937529d$var$getStyle("key", theme, styles) + ">";
        var valSpan = '<span class="__json-value__"' + $ea168c7b8937529d$var$getStyle("value", theme, styles) + ">";
        var strSpan = '<span class="__json-string__"' + $ea168c7b8937529d$var$getStyle("string", theme, styles) + ">";
        var booSpan = '<span class="__json-boolean__"' + $ea168c7b8937529d$var$getStyle("boolean", theme, styles) + ">";
        var sps = ind || "";
        if (key) sps = sps + '"' + keySpan + key.replace(/^"|":\s$/g, "") + spanEnd + '": ';
        if (val) {
            if (val === "true" || val === "false") sps = sps + booSpan + val + spanEnd;
            else sps = sps + (val[0] === '"' ? strSpan : valSpan) + val + spanEnd;
        }
        return sps + (tra || "");
    };
    JSONPretty.propTypes = {
        data: $ea168c7b8937529d$var$PropTypes.any,
        json: $ea168c7b8937529d$var$PropTypes.any,
        replacer: $ea168c7b8937529d$var$PropTypes.func,
        silent: $ea168c7b8937529d$var$PropTypes.bool,
        space: $ea168c7b8937529d$var$PropTypes.oneOfType([
            $ea168c7b8937529d$var$PropTypes.number,
            $ea168c7b8937529d$var$PropTypes.string
        ]),
        theme: $ea168c7b8937529d$var$PropTypes.object,
        themeClassName: $ea168c7b8937529d$var$PropTypes.string,
        onJSONPrettyError: $ea168c7b8937529d$var$PropTypes.func
    };
    JSONPretty.defaultProps = {
        data: "",
        json: "",
        silent: true,
        space: 2,
        themeClassName: "__json-pretty__"
    };
    return JSONPretty;
}($ea168c7b8937529d$var$React.Component);
$ea168c7b8937529d$exports = $ea168c7b8937529d$var$JSONPretty;


var $dcdf55e190288146$exports = {};
$dcdf55e190288146$exports = "query detailedMessage($customerId:ID$id:ID!$isCustomer:Boolean){detailedMessage(customerId:$customerId id:$id isCustomer:$isCustomer){...detailedMessageFragment}}fragment detailedMessageFragment on DetailedMessage{accessNumber apiAcceptTime apiNotifyTime contractId cref customerId da daOperator submitDurationMs deliverDurationMs totalDurationMs details events{id time type messagePartId segmentCount status details}messageParts{id segmentCount}messageType messageId oa productId productQosPriority productTypeId segmentCountTotal status submitId version}";















parcelRequire("fgmOP");



const $b5925f5d8efa7340$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useCpaStatusCodes", "INFO");
const $b5925f5d8efa7340$var$getStatusDescription = (code)=>{
    $b5925f5d8efa7340$var$log.debug("cpaStatusCodeDict[code]: " + $b5925f5d8efa7340$var$cpaStatusCodeDict[code], {
        code: code,
        cpaStatusCodeDict: $b5925f5d8efa7340$var$cpaStatusCodeDict
    });
    return $b5925f5d8efa7340$var$cpaStatusCodeDict[code] ? $b5925f5d8efa7340$var$cpaStatusCodeDict[code] : `${code}`;
};
const $b5925f5d8efa7340$export$7ddd8c51b496162d = ()=>{
    return {
        getStatusDescription: $b5925f5d8efa7340$var$getStatusDescription,
        statusCodes: $b5925f5d8efa7340$var$statusCodes
    };
};
const $b5925f5d8efa7340$var$cpaStatusCodeDict = {
    // Success
    "200": "Success",
    // Integrity errors
    "9001": "Duplicate client reference",
    // Input errors
    "9101": "Invalid destination address",
    "9102": "Invalid originating address",
    "9108": "Blocked destination address",
    "9109": "Blocked originating address",
    "9110": "Invalid delivery time",
    // Subscriber errors
    "9201": "Subscriber unknown",
    "9202": "Subscriber temporarily barred",
    "9203": "Subscriber permanently barred",
    "9204": "Subscriber reserved",
    "9207": "Refused by service provider",
    // Payload errors
    "9401": "Invalid payload",
    // Reserved OA
    "9501": "Reserved Sender ID",
    "9502": "Blocked Sender ID look-a-like",
    // Other errors
    "9901": "Unspecified error",
    "9902": "Throttled - status rate exceeded",
    "9903": "Invalid validity period",
    "9904": "Message queue full",
    "9999": "Expired",
    //  Notify errors
    "10105": "Missing endpoint configuration",
    "10103": "Endpoint error",
    "10101": "Endpoint connection error"
};
const $b5925f5d8efa7340$var$statusCodes = Object.keys($b5925f5d8efa7340$var$cpaStatusCodeDict).filter((key)=>key.length < 5).map((key)=>({
        id: key,
        name: `${key}: ${$b5925f5d8efa7340$var$getStatusDescription(parseInt(key))}`
    }));


const $1ef65d6ab92c771d$var$MessageStatusDisplayFc = ({ status: status, details: details })=>{
    const { getStatusDescription: getStatusDescription } = (0, $b5925f5d8efa7340$export$7ddd8c51b496162d)();
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))(!status || status === 9999 ? "greyText" : status === 200 ? "greenText" : "redText"),
        children: [
            status || "",
            status && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $acf38b6c25932409$export$2e2bcd8739ae039), {
                text: `${status}: ${getStatusDescription(status)}`
            }),
            details && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $acf38b6c25932409$export$2e2bcd8739ae039), {
                text: `Details: ${details}`,
                buttonContent: "d",
                className: `tooltip--S`
            }),
            " "
        ]
    });
};
var $1ef65d6ab92c771d$export$2e2bcd8739ae039 = $1ef65d6ab92c771d$var$MessageStatusDisplayFc;




const { THead: $ec980a766bfbc285$var$THead, Tr: $ec980a766bfbc285$var$Tr, Th: $ec980a766bfbc285$var$Th, TBody: $ec980a766bfbc285$var$TBody, Td: $ec980a766bfbc285$var$Td } = (0, $c1364c3d18563e9b$export$2e2bcd8739ae039);
const $ec980a766bfbc285$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReportMessageDetails", "INFO");
const $ec980a766bfbc285$export$538b0548c979c7bd = (props)=>{
    const messageId = props.message.messageId;
    const { getName: getName } = (0, $98effcf86fafb9fb$export$75025970e7082eca)();
    const [showJson, setShowJson] = (0, $fgmOP.useState)(false);
    const { getCustomerName: getCustomerName } = (0, $b06c1af11eebe0e3$export$6830a00b8ce0c90e)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const { isCustomer: isCustomer, user: user, currentUserBrand: currentUserBrand, customerId: customerId } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { loading: loading, error: error, data: data } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($dcdf55e190288146$exports)))), {
        skip: !messageId || !currentUserBrand?.id,
        variables: {
            id: messageId,
            isCustomer: isCustomer(),
            customerId: isCustomer() && user ? customerId : null
        }
    });
    const loadingPlaceholder = loading ? "..." : "unknown";
    const message = {
        ...props.message,
        ...data?.detailedMessage
    };
    $ec980a766bfbc285$var$log.debug("render", {
        message: message
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
        className: "form--compact",
        children: loading && Object.keys(message).length <= 1 ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : error ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $25d390e04dd0ffc0$export$2e2bcd8739ae039), {
            error: error
        }) : !loading && !data?.detailedMessage ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
            children: "Couldn't get the report detailed message"
        }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                label: "Message ID",
                                value: message.messageId,
                                linkTo: formatWithBrand($e9a95c61c800ecd2$export$164d2bdecc76515)
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                label: "Submit ID",
                                value: message.submitId,
                                defaultValue: loadingPlaceholder
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                label: "Customer ref.",
                                value: message.cref,
                                defaultValue: loadingPlaceholder
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "API accept date",
                                    value: message.apiAcceptTime && (0, $f5d0c2a7498ff49b$exports.format).dateTime(message.apiAcceptTime),
                                    defaultValue: loadingPlaceholder
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "Customer ID",
                                    value: message.customerId && message.customerId + " - " + getCustomerName(message.customerId),
                                    defaultValue: loadingPlaceholder
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "Contract ID",
                                    value: message.contractId,
                                    defaultValue: loadingPlaceholder
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "Service ID",
                                    value: message.productId,
                                    defaultValue: loadingPlaceholder
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "Service Type",
                                    value: message.productTypeId && getName(message.productTypeId),
                                    defaultValue: loadingPlaceholder
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "Access Nr.",
                                    value: message.accessNumber,
                                    defaultValue: loadingPlaceholder
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "Orig. Adr.",
                                    value: message.oa,
                                    defaultValue: loadingPlaceholder
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "Dest. Adr.",
                                    value: message.da,
                                    defaultValue: loadingPlaceholder
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "MNO",
                                    value: message.daOperator,
                                    defaultValue: loadingPlaceholder
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "Segments",
                                    value: message.segmentCountTotal,
                                    defaultValue: loadingPlaceholder
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "Message Type",
                                    value: message.messageType,
                                    defaultValue: loadingPlaceholder
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "Report version",
                                    value: message.version,
                                    defaultValue: loadingPlaceholder
                                }),
                                message.status ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "Status",
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).element,
                                    value: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef65d6ab92c771d$export$2e2bcd8739ae039), {
                                        status: message.status,
                                        details: message.details
                                    })
                                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "Status",
                                    defaultValue: loadingPlaceholder
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                    children: [
                        message.messageType === "SMS_MT" && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "Submit duration",
                                    value: message.submitDurationMs ? (0, $f5d0c2a7498ff49b$exports.format).duration(message.submitDurationMs) : "Not sent yet",
                                    tip: "Time span between accepting the api request and submitting the sent request to SMSC"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "Deliver duration",
                                    value: message.deliverDurationMs ? (0, $f5d0c2a7498ff49b$exports.format).duration(message.deliverDurationMs) : "Not delivered yet",
                                    tip: "Time span between accepting the api request and receiving delivered callback from SMSC"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "Notify (DR/MO) duration",
                                    value: message.totalDurationMs ? (0, $f5d0c2a7498ff49b$exports.format).duration(message.totalDurationMs) : "Not notified yet",
                                    tip: "Time span between accepting the api request and notifying the DR/MO endpoint"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {})
                            ]
                        })
                    ]
                }),
                message.messageParts && !message.messageParts.isEmpty() && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h4", {
                            children: "Message Parts"
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($ec980a766bfbc285$var$THead, {
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)($ec980a766bfbc285$var$Tr, {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($ec980a766bfbc285$var$Th, {
                                                children: "Message part ID"
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($ec980a766bfbc285$var$Th, {
                                                children: "Segments"
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($ec980a766bfbc285$var$TBody, {
                                    children: message.messageParts?.map((messagePart, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)($ec980a766bfbc285$var$Tr, {
                                            children: [
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($ec980a766bfbc285$var$Td, {
                                                    className: "noWrap",
                                                    children: messagePart.id
                                                }),
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($ec980a766bfbc285$var$Td, {
                                                    children: messagePart.segmentCount
                                                })
                                            ]
                                        }, i))
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h4", {
                    children: "Events"
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($ec980a766bfbc285$var$THead, {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)($ec980a766bfbc285$var$Tr, {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($ec980a766bfbc285$var$Th, {
                                        children: "Date"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($ec980a766bfbc285$var$Th, {
                                        children: "Delay"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($ec980a766bfbc285$var$Th, {
                                        children: "Type"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($ec980a766bfbc285$var$Th, {
                                        children: "Status"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($ec980a766bfbc285$var$Th, {
                                        children: "Details"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($ec980a766bfbc285$var$TBody, {
                            children: message.events?.map((event, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)($ec980a766bfbc285$var$Tr, {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($ec980a766bfbc285$var$Td, {
                                            className: "noWrap",
                                            children: (0, $f5d0c2a7498ff49b$exports.format).dateTimeMs(event.time)
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($ec980a766bfbc285$var$Td, {
                                            className: "noWrap",
                                            children: message.apiAcceptTime ? (0, $f5d0c2a7498ff49b$exports.format).duration(Date.parse(event.time) - Date.parse(message.apiAcceptTime)) : loadingPlaceholder
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($ec980a766bfbc285$var$Td, {
                                            className: "noWrap",
                                            children: event.type
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($ec980a766bfbc285$var$Td, {
                                            className: "noWrap",
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef65d6ab92c771d$export$2e2bcd8739ae039), {
                                                status: event.status
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($ec980a766bfbc285$var$Td, {
                                            className: "noWrap",
                                            children: event.details && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $acf38b6c25932409$export$28c660c63b792dea), {
                                                text: `Details: ${event.details}`,
                                                buttonContent: "d",
                                                className: `tooltip--S`
                                            })
                                        })
                                    ]
                                }, i))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                    onClick: ()=>setShowJson(!showJson),
                    text: showJson ? "Hide JSON" : "Show JSON",
                    className: "marginTop marginRight"
                }),
                showJson && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ea168c7b8937529d$exports))), {
                    data: (0, $6afa790c69fae185$export$251b62dd86dd2816)(message)
                })
            ]
        })
    });
};


const $f57b83959ccfdbdd$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReportMessageById", "INFO");
const $f57b83959ccfdbdd$export$362d466733da547f = (props)=>{
    const { messageId: messageId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const emptyMessageId = messageId === $e9a95c61c800ecd2$export$5d82aa6adfda83a;
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const formStateOptions = {
        isEditing: true,
        initialEntity: {
            messageId: emptyMessageId ? undefined : messageId
        }
    };
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)(formStateOptions);
    const { entity: entity } = formState;
    $f57b83959ccfdbdd$var$log.debug("render", {
        messageId: messageId,
        entity: entity
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Report Message Details"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "message"
            }),
            entity && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $2e4c8094e1930e9a$export$db87c465bc6102be), {
                onSubmit: (e)=>{
                    $f57b83959ccfdbdd$var$log.debug("onSubmit");
                    entity.messageId && navigate(formatWithBrand($e9a95c61c800ecd2$export$164d2bdecc76515, entity.messageId), {
                        replace: true
                    });
                },
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "messageId",
                                placeholder: "Message ID",
                                label: undefined,
                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).input
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            size: (0, $6c2490027a2e159e$export$2e5aae5cf40e4ee1),
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                id: "fetchMessageById",
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    text: "Fetch message by ID",
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary,
                                    className: "marginTopx",
                                    isDisabled: !entity.messageId,
                                    type: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).types.submit
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("br", {}),
            !emptyMessageId && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ec980a766bfbc285$export$538b0548c979c7bd), {
                message: {
                    messageId: messageId
                }
            })
        ]
    });
};








// The following methods, when called will execute the query, regardless of
// whether the useLazyQuery execute function was called before.
var $6ccde90cf8233047$var$EAGER_METHODS = [
    "refetch",
    "reobserve",
    "fetchMore",
    "updateQuery",
    "startPolling",
    "subscribeToMore"
];
function $6ccde90cf8233047$export$fd83eea6ecd2d8fa(query, options) {
    var _a;
    var execOptionsRef = $6a3c74d1b5373fb5$exports.useRef();
    var optionsRef = $6a3c74d1b5373fb5$exports.useRef();
    var queryRef = $6a3c74d1b5373fb5$exports.useRef();
    var merged = (0, $77f4ff3b2e7d3a15$export$235b7fc70b9fc359)(options, execOptionsRef.current || {});
    var document = (_a = merged === null || merged === void 0 ? void 0 : merged.query) !== null && _a !== void 0 ? _a : query;
    // Use refs to track options and the used query to ensure the `execute`
    // function remains referentially stable between renders.
    optionsRef.current = options;
    queryRef.current = document;
    var internalState = (0, $f72ec353e2162d59$export$6342ea8c555e49e5)((0, $7626a5aec6f1579a$export$eb9a56e7a29e494)(options && options.client), document);
    var useQueryResult = internalState.useQuery((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, merged), {
        skip: !execOptionsRef.current
    }));
    var initialFetchPolicy = useQueryResult.observable.options.initialFetchPolicy || internalState.getDefaultFetchPolicy();
    var result = Object.assign(useQueryResult, {
        called: !!execOptionsRef.current
    });
    // We use useMemo here to make sure the eager methods have a stable identity.
    var eagerMethods = $6a3c74d1b5373fb5$exports.useMemo(function() {
        var eagerMethods = {};
        var _loop_1 = function(key) {
            var method = result[key];
            eagerMethods[key] = function() {
                if (!execOptionsRef.current) {
                    execOptionsRef.current = Object.create(null);
                    // Only the first time populating execOptionsRef.current matters here.
                    internalState.forceUpdateState();
                }
                // @ts-expect-error this is just too generic to type
                return method.apply(this, arguments);
            };
        };
        for(var _i = 0, EAGER_METHODS_1 = $6ccde90cf8233047$var$EAGER_METHODS; _i < EAGER_METHODS_1.length; _i++){
            var key = EAGER_METHODS_1[_i];
            _loop_1(key);
        }
        return eagerMethods;
    }, []);
    Object.assign(result, eagerMethods);
    var execute = $6a3c74d1b5373fb5$exports.useCallback(function(executeOptions) {
        execOptionsRef.current = executeOptions ? (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, executeOptions), {
            fetchPolicy: executeOptions.fetchPolicy || initialFetchPolicy
        }) : {
            fetchPolicy: initialFetchPolicy
        };
        var options = (0, $77f4ff3b2e7d3a15$export$235b7fc70b9fc359)(optionsRef.current, (0, $e2e041e4a1657497$export$18ce0697a983be9b)({
            query: queryRef.current
        }, execOptionsRef.current));
        var promise = internalState.executeQuery((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options), {
            skip: false
        })).then(function(queryResult) {
            return Object.assign(queryResult, eagerMethods);
        });
        // Because the return value of `useLazyQuery` is usually floated, we need
        // to catch the promise to prevent unhandled rejections.
        promise.catch(function() {});
        return promise;
    }, []);
    return [
        execute,
        result
    ];
}





var $fgmOP = parcelRequire("fgmOP");

var $fad3e837670dab47$exports = {};
$fad3e837670dab47$exports = "query detailedMessages($accessNumber:AccessNumberString$contractId:ID$contractType:ContractTypeEnum$cref:String$customerId:ID$da:String$endDate:Date$isCustomer:Boolean$messageType:ID$oa:String$startDate:Date$status:ID$limit:Int$lastEvaluatedKey:String){detailedMessages(accessNumber:$accessNumber contractId:$contractId contractType:$contractType cref:$cref customerId:$customerId da:$da endDate:$endDate isCustomer:$isCustomer messageType:$messageType oa:$oa startDate:$startDate status:$status limit:$limit lastEvaluatedKey:$lastEvaluatedKey){items{...detailedMessageFragment}lastEvaluatedKey}}fragment detailedMessageFragment on DetailedMessage{accessNumber apiAcceptTime apiNotifyTime contractId cref customerId da daOperator submitDurationMs deliverDurationMs totalDurationMs details events{id time type messagePartId segmentCount status details}messageParts{id segmentCount}messageType messageId oa productId productQosPriority productTypeId segmentCountTotal status submitId version}";







const $e0ee09abd75b1062$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useMessageTypes", "INFO");
const $e0ee09abd75b1062$var$messageTypeIds = [
    "SMS_MT",
    "SMS_MO"
];
const $e0ee09abd75b1062$export$609535ef038a9b3f = ()=>{
    const getMessageTypeCompactName = (id)=>{
        return !id ? "?" : id === "SMS_MT" ? "MT" : id === "SMS_MO" ? "MO" : id;
    };
    const getMessageTypeLongName = (id)=>{
        return !id ? "unknown" : id === "SMS_MT" ? "Mobile Terminated" : id === "SMS_MO" ? "Mobile Originated" : id;
    };
    const messageTypeDictionary = $e0ee09abd75b1062$var$messageTypeIds.map((id)=>({
            id: id,
            name: getMessageTypeCompactName(id)
        }));
    const useMessageTypes = {
        messageTypeDictionary: messageTypeDictionary,
        getMessageTypeCompactName: getMessageTypeCompactName,
        getMessageTypeLongName: getMessageTypeLongName
    };
    $e0ee09abd75b1062$var$log.debug("render", useMessageTypes);
    return useMessageTypes;
};
















var $fgmOP = parcelRequire("fgmOP");









const $be5c974db6161b42$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReportMessagesTable", "INFO");
const $be5c974db6161b42$export$a7fe761e8fd28047 = ({ messages: messages })=>{
    const { getCustomerName: getCustomerName } = (0, $b06c1af11eebe0e3$export$6830a00b8ce0c90e)();
    const { getMessageTypeCompactName: getMessageTypeCompactName, getMessageTypeLongName: getMessageTypeLongName } = (0, $e0ee09abd75b1062$export$609535ef038a9b3f)();
    const [message, setMessage] = (0, $fgmOP.useState)();
    const { getStatusDescription: getStatusDescription } = (0, $b5925f5d8efa7340$export$7ddd8c51b496162d)();
    const enrichedMessages = (0, $fgmOP.useMemo)(()=>{
        $be5c974db6161b42$var$log.debug("useMemo enrichedMessages", {
            messages: messages,
            getCustomerName: getCustomerName
        });
        if (!messages) return undefined;
        return messages.map(({ customerId: customerId, ...s })=>({
                ...s,
                customerId: customerId,
                customerName: customerId ? getCustomerName(customerId) : customerId
            }));
    }, [
        messages,
        getCustomerName
    ]);
    const [sortedMessages, getThSortableProps] = (0, $c1364c3d18563e9b$export$2e2bcd8739ae039).useThSortable(enrichedMessages || [], 3, [], (0, $c8112e20ecbc0ea7$export$3754e0b777cdd23e));
    $be5c974db6161b42$var$log.debug("render", {
        messages: messages,
        enrichedMessages: enrichedMessages,
        sortedMessages: sortedMessages
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            message && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $7f3b80d7462309dd$export$2e2bcd8739ae039), {
                name: "message-details",
                heading: "Message Details",
                closeText: "Close",
                onClose: ()=>setMessage(undefined),
                size: "large",
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ec980a766bfbc285$export$538b0548c979c7bd), {
                    message: message
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: "marginTop",
                children: [
                    sortedMessages && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039), {
                        clickable: true,
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).THead, {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Tr, {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("apiAcceptTime"),
                                            children: "Date"
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("customerName"),
                                            children: "Customer"
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("accessNumber"),
                                            children: "Access Nr."
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("oa"),
                                            children: "Orig. Adr."
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("da"),
                                            children: "Dest. Adr."
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("daOperator"),
                                            children: "MNO"
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("segments"),
                                            children: "Seg."
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("messageType"),
                                            children: "Type"
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("status"),
                                            children: "Status"
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("deliverDurationMs"),
                                            children: "Deliver"
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("totalDurationMs"),
                                            children: "Notify"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).TBody, {
                                children: sortedMessages?.map((message, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Tr, {
                                        onClick: ()=>setMessage(message),
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: (0, $f5d0c2a7498ff49b$exports.format).dateTime(message.apiAcceptTime)
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: message.customerName
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: message.accessNumber
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: message.oa
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: message.da
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: message.daOperator
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: (0, $f5d0c2a7498ff49b$exports.format).integer(message.segmentCountTotal)
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                    title: getMessageTypeLongName(message.messageType),
                                                    children: getMessageTypeCompactName(message.messageType)
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                className: "noWrap",
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef65d6ab92c771d$export$2e2bcd8739ae039), {
                                                    status: message.status,
                                                    details: message.details ? message.details : "-"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: message.deliverDurationMs ? (0, $f5d0c2a7498ff49b$exports.format).durationCompact(message.deliverDurationMs) : "..."
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: message.totalDurationMs ? (0, $f5d0c2a7498ff49b$exports.format).durationCompact(message.totalDurationMs) : ((event)=>event?.type === "SMS_NOTIFY_ERROR" ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                                        info: `${event.status}: ${getStatusDescription(event.status)}`,
                                                        icon: "alert",
                                                        className: "redText absolute right0"
                                                    }) : "...")(message.events?.slice(-1)?.head())
                                            })
                                        ]
                                    }, i))
                            })
                        ]
                    }),
                    messages && messages.isEmpty() && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                        children: "No messages found"
                    })
                ]
            })
        ]
    });
};


const $25eaf8efe0e88ab0$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReportMessages", "INFO");
const { isValid: $25eaf8efe0e88ab0$var$isValid } = (0, $f5d0c2a7498ff49b$exports.period);
const $25eaf8efe0e88ab0$export$810b79139e0bdb1b = (props)=>{
    const { isCustomer: isCustomer, isTelia: isTelia, user: user, customerId: customerId } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { customerName: customerName } = (0, $6fadca55099b66d6$export$dd46433206d0b2d9)();
    const { loading: loadingCustomers, customerOverviews: customerOverviews, getName: getName } = (0, $8d8d8b3d38044bbe$export$d27d8317adc3c298)();
    const { messageTypeDictionary: messageTypeDictionary } = (0, $e0ee09abd75b1062$export$609535ef038a9b3f)();
    const [detailedMessages, setDetailedMessages] = (0, $fgmOP.useState)();
    const [lastEvaluatedKey, setLastEvaluatedKey] = (0, $fgmOP.useState)();
    const [isFetchingMore, setIsFetchingMore] = (0, $fgmOP.useState)(false);
    const { statusCodes: statusCodes } = (0, $b5925f5d8efa7340$export$7ddd8c51b496162d)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const formStateOptions = {
        isEditing: true,
        useUrlParams: true,
        preferenceFieldNames: [
            "startDate",
            "endDate",
            "customerId"
        ],
        fixedFields: isCustomer() && customerId ? {
            customerId: customerId
        } : {}
    };
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)(formStateOptions);
    const [fetch, { loading: loading, data: { detailedMessages: detailedMessagesResponse = {} } = {}, refetch: refetch, fetchMore: fetchMore }] = (0, $6ccde90cf8233047$export$fd83eea6ecd2d8fa)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($fad3e837670dab47$exports)))), {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only"
    });
    (0, $fgmOP.useEffect)(()=>{
        $25eaf8efe0e88ab0$var$log.debug("effect for detailedMessagesResponse", {
            detailedMessagesResponse: detailedMessagesResponse,
            loading: loading
        });
        setDetailedMessages(isFetchingMore || !loading && detailedMessagesResponse?.items ? detailedMessagesResponse.items : undefined);
        setLastEvaluatedKey(!loading && detailedMessagesResponse?.lastEvaluatedKey ? detailedMessagesResponse.lastEvaluatedKey : undefined);
    }, [
        detailedMessagesResponse,
        loading
    ]);
    const getDetailedMessagesParameters = ()=>{
        let parameters = {
            ...formState.entity
        };
        formState.clearErrors();
        if (!parameters.startDate) {
            formState.putError("startDate", "Start date is required");
            return undefined;
        }
        if (!parameters.endDate) {
            formState.putError("endDate", "End date is required");
            return undefined;
        }
        if (!$25eaf8efe0e88ab0$var$isValid(parameters)) {
            formState.putError("startDate", "Invalid search period");
            formState.putError("endDate", "Invalid search period");
            return undefined;
        }
        const dateTimeParametersTransformer = ({ startDate: startDate, startTime: startTime, endDate: endDate, endTime: endTime, ...params })=>{
            return {
                startDate: new Date(`${startDate}T${startTime ? startTime : "00:00"}:00.000`).toISOString(),
                endDate: new Date(`${endDate}T${endTime ? endTime : "23:59"}:59.999`).toISOString(),
                limit: 200,
                ...params
            };
        };
        return dateTimeParametersTransformer(parameters);
    };
    const fetchMessages = ()=>{
        const parameters = getDetailedMessagesParameters();
        if (!parameters) return;
        $25eaf8efe0e88ab0$var$log.debug("Fetch messages", parameters);
        setDetailedMessages(undefined);
        fetch({
            variables: {
                customerId: isCustomer() && user ? customerId : null,
                ...parameters,
                isCustomer: isCustomer()
            }
        });
    };
    const fetchMoreMessages = async ()=>{
        const parameters = getDetailedMessagesParameters();
        $25eaf8efe0e88ab0$var$log.debug("Fetch more messages", parameters);
        setIsFetchingMore(true);
        await fetchMore({
            updateQuery: (previousQueryResult, { fetchMoreResult: fetchMoreResult, variables: variables })=>{
                $25eaf8efe0e88ab0$var$log.debug("updateQuery", {
                    previousQueryResult: previousQueryResult,
                    fetchMoreResult: fetchMoreResult,
                    variables: variables
                });
                const allItems = [
                    ...previousQueryResult?.detailedMessages?.items || [],
                    ...fetchMoreResult?.detailedMessages.items || []
                ];
                $25eaf8efe0e88ab0$var$log.trace("all items", allItems);
                return {
                    detailedMessages: {
                        items: allItems,
                        lastEvaluatedKey: fetchMoreResult?.detailedMessages?.lastEvaluatedKey,
                        __typename: "DetailedMessageResponse"
                    }
                };
            },
            variables: {
                lastEvaluatedKey: lastEvaluatedKey
            }
        }).then((res)=>{
            $25eaf8efe0e88ab0$var$log.debug("resolved fetch more messages", res);
            setIsFetchingMore(false);
            const { loading: loading, data: { detailedMessages: { items: items, lastEvaluatedKey: lastEvaluatedKey } } } = res;
        }).catch((error)=>{});
    };
    const { entity: entity } = formState;
    $25eaf8efe0e88ab0$var$log.debug("render", {
        entity: entity,
        customerName: customerName,
        customerOverviews: customerOverviews,
        detailedMessagesCount: detailedMessages?.length,
        detailedMessages: detailedMessages,
        detailedMessagesResponse: detailedMessagesResponse,
        lastEvaluatedKey: lastEvaluatedKey
    }, document.location.host);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Detailed Messages"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "messages"
            }),
            entity && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $2e4c8094e1930e9a$export$db87c465bc6102be), {
                onSubmit: fetchMessages,
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "startDate",
                                        label: "From date",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date,
                                        defaultValue: "since ever"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "startTime",
                                        label: "From time",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).time,
                                        defaultValue: "Start of day"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "endDate",
                                        label: "To date",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date,
                                        defaultValue: entity.inheritsEndDate ? entity.endDate : "no end"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "endTime",
                                        label: "To time",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).time,
                                        defaultValue: "End of day"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: [
                                    isTelia() && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "customerId",
                                        label: "Customer",
                                        options: customerOverviews,
                                        isNullable: true,
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                        isDisabled: loadingCustomers,
                                        onChangeAlso: ()=>formState.onChange("contractId")(null)
                                    }),
                                    isCustomer() && user && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                        label: "Customer",
                                        value: customerName,
                                        isEditing: false
                                    }),
                                    !user && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "customerId",
                                        label: "Customer",
                                        isDisabled: true
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "cref",
                                        label: "Customer ref.",
                                        placeholder: "all references",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).input
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "oa",
                                        label: "Origin Address",
                                        placeholder: "all addresses",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).input,
                                        tip: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                            children: [
                                                "The senders address:",
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("li", {
                                                            children: "A text string"
                                                        }),
                                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("li", {
                                                            children: "Short number"
                                                        }),
                                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("li", {
                                                            children: "MSISDN (+47..)"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "da",
                                        label: "Destination Address",
                                        placeholder: "all addresses",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).input,
                                        error: undefined,
                                        tip: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                            children: [
                                                "The receiver address:",
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("ul", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("li", {
                                                            children: "Short mumber"
                                                        }),
                                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("li", {
                                                            children: "MSISDN (+47..)"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            isTelia() && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "accessNumber",
                                                label: "Access Number",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).input
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "messageType",
                                                label: "Message Type",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                options: messageTypeDictionary,
                                                isNullable: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "status",
                                                label: "Status",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                options: statusCodes,
                                                isNullable: true
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                                                className: "redText",
                                                children: [
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("br", {}),
                                                    "This row only for Telia users"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                size: (0, $6c2490027a2e159e$export$2e5aae5cf40e4ee1),
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                    id: "fetchMessages",
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                        onClick: fetchMessages,
                                        text: "Fetch messages",
                                        kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary,
                                        className: "marginTop marginRight"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                size: (0, $6c2490027a2e159e$export$2e5aae5cf40e4ee1),
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                    id: "goToFetchMessageById",
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                                        to: formatWithBrand($e9a95c61c800ecd2$export$164d2bdecc76515, $e9a95c61c800ecd2$export$5d82aa6adfda83a),
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                            // onClick={() => push(formatWithBrand(AppRoutes.REPORT_MESSAGE__messageId, AppRoutes._EMPTY))}
                                            text: "Fetch message by ID",
                                            className: "marginTop marginRight"
                                        })
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            lastEvaluatedKey && !loading && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                onClick: fetchMoreMessages,
                text: "Fetch more",
                className: "marginRight"
            }),
            !loading && detailedMessages && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                children: [
                    "Showing ",
                    detailedMessages.length,
                    " messages"
                ]
            }),
            loading && detailedMessages && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {}),
            detailedMessages && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $be5c974db6161b42$export$a7fe761e8fd28047), {
                messages: detailedMessages
            }),
            loading && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}),
            lastEvaluatedKey && !loading && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                onClick: fetchMoreMessages,
                text: "Fetch more",
                className: "marginRight"
            }),
            !loading && detailedMessages && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                children: [
                    "Showing ",
                    detailedMessages.length,
                    " messages"
                ]
            })
        ]
    });
};






var $fgmOP = parcelRequire("fgmOP");















var $fgmOP = parcelRequire("fgmOP");








const $d05f3a03894f201a$export$f8c54207235a37f6 = (settlements)=>({
        productTypeSummaries: $d05f3a03894f201a$export$78d808dbf9039b42(settlements),
        total: settlements.map(({ summary: summary })=>summary.totalExclVat).reduce((total, settlementTotal)=>total + settlementTotal, 0),
        adjustmentSummary: settlements.map(({ summary: summary })=>summary.adjustmentTotal).filter((adjustmentTotal)=>adjustmentTotal).reduce((adjustmentSummay, adjustment, i, adjustments)=>({
                total: adjustmentSummay.total + adjustment,
                count: adjustments.length
            }), {
            total: 0,
            count: 0
        })
    });
const $d05f3a03894f201a$export$78d808dbf9039b42 = (settlements)=>Object.values(settlements.map((s)=>s.productTypeSummaries || []).filter((productTypeSummaries)=>productTypeSummaries.length >= 0).reduce((summaryDict, settlementProductTypeSummaries)=>{
        settlementProductTypeSummaries.filter(({ total: total })=>total !== 0).forEach((summary)=>$d05f3a03894f201a$var$aggregateSummaryToDict(summary, summaryDict));
        return summaryDict;
    }, {})).sort((0, $f5d0c2a7498ff49b$exports.sort).sortByProductTypeIdComparator);
// summaryDict mutates!
const $d05f3a03894f201a$var$aggregateSummaryToDict = (summary, summaryDict)=>{
    summaryDict[`${summary.productTypeId}`] = $d05f3a03894f201a$var$aggregateSummaries(summary, summaryDict[`${summary.productTypeId}`]);
};
const $d05f3a03894f201a$var$aggregateSummaries = (a, b)=>({
        productTypeId: a.productTypeId,
        total: a.total + (b?.total || 0),
        fees: $d05f3a03894f201a$export$a59949b8accaf2f6(a.fees, b?.fees)
    });
const $d05f3a03894f201a$export$a59949b8accaf2f6 = (a, b)=>a.filter(({ total: total })=>total !== 0).reduce((aggregatedFees, aFee)=>{
        const foundFee = aggregatedFees?.find(({ feeId: feeId })=>feeId === aFee.feeId);
        if (foundFee) {
            foundFee.quantity = (foundFee.quantity || 1) + (aFee.quantity || 1);
            foundFee.total = foundFee.total + aFee.total;
            if (foundFee.fee !== aFee.fee) foundFee.fee = foundFee.total / foundFee.quantity;
            return aggregatedFees;
        } else return [
            {
                ...aFee
            },
            ...aggregatedFees
        ].sort((0, $f5d0c2a7498ff49b$exports.sort).sortByProductFeeIdComparator);
    }, b?.slice() || []);


const $e9e63b6d29d70b21$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReportMonthSummariesTableFc", "INFO");
const { ALL: $e9e63b6d29d70b21$var$ALL } = (0, $f5d0c2a7498ff49b$exports.constants);
const $e9e63b6d29d70b21$export$542967381b9f19e9 = (props)=>{
    const { years: years, month: month, contractType: contractType, productType: selectedProductType } = props;
    $e9e63b6d29d70b21$var$log.debug("props", {
        props: props
    });
    const { getName: getName, productTypes: productTypes } = (0, $98effcf86fafb9fb$export$75025970e7082eca)();
    const { currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const client = (0, $7626a5aec6f1579a$export$eb9a56e7a29e494)();
    const [yearlyMonthSummaries, setYearlyMonthSummaries] = (0, $fgmOP.useState)();
    const [loading, setLoading] = (0, $fgmOP.useState)(false);
    (0, $fgmOP.useEffect)(()=>{
        const summaries = [];
        setLoading(true);
        currentUserBrand && Promise.all(years.map((year)=>client.query({
                query: (0, $d155419fd10bd2b6$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($7c56a23b568b6925$exports)))),
                variables: {
                    year: parseInt(year),
                    month: parseInt(month),
                    contractType: contractType !== $e9e63b6d29d70b21$var$ALL ? contractType : undefined
                }
            }).then(({ data: { settlements: settlements } })=>{
                $e9e63b6d29d70b21$var$log.debug("settlements", {
                    settlements: settlements
                });
                summaries.push({
                    year: parseInt(year),
                    monthSummary: (0, $d05f3a03894f201a$export$f8c54207235a37f6)(settlements || [])
                });
            }))).then(()=>{
            setYearlyMonthSummaries(summaries.slice().sort((a, b)=>a.year > b.year ? -1 : 1));
            setLoading(false);
        });
    }, [
        years,
        currentUserBrand
    ]);
    $e9e63b6d29d70b21$var$log.debug("yearlyMonthSummaries", {
        yearlyMonthSummaries: yearlyMonthSummaries
    });
    const hasAdjustments = !!yearlyMonthSummaries?.some(({ monthSummary: monthSummary })=>monthSummary.adjustmentSummary.total !== 0);
    return loading ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : !yearlyMonthSummaries || yearlyMonthSummaries.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
        description: `No approved settlements for this month`
    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("section", {
        className: "settlement__aggregate",
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("table", {
            className: "settlement__list",
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("thead", {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                    children: (0, $f5d0c2a7498ff49b$exports.dates).monthNames[parseInt(month) - 1]
                                }),
                                yearlyMonthSummaries.map(({ year: year })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                        colSpan: 3,
                                        className: "centerText",
                                        children: year
                                    }, "th" + year))
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                    children: "Income type summary"
                                }),
                                yearlyMonthSummaries.map(({ year: year })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                                className: "rightText width0-on-small-only",
                                                children: "Count"
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                                className: "rightText",
                                                children: "Average"
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                                className: "rightText",
                                                children: "Total"
                                            })
                                        ]
                                    }, "count-avg-tot" + year))
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tbody", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))(!hasAdjustments && "settlement__list__body--padding__bottom"),
                    children: [
                        productTypes.map((productType, i)=>{
                            const firstYearSummary = yearlyMonthSummaries[0].monthSummary.productTypeSummaries.find(({ productTypeId: productTypeId })=>productTypeId === productType.id);
                            const otherYearsData = yearlyMonthSummaries.slice(1).reduce((data, { year: year, monthSummary: { productTypeSummaries: productTypeSummaries } })=>{
                                const foundSummary = productTypeSummaries.find(({ productTypeId: productTypeId })=>productTypeId === productType.id);
                                return foundSummary ? [
                                    ...data,
                                    {
                                        year: year,
                                        data: {
                                            name: getName(foundSummary.productTypeId),
                                            total: foundSummary.total,
                                            fees: foundSummary.fees
                                        }
                                    }
                                ] : data;
                            }, []);
                            return (firstYearSummary || !otherYearsData.isEmpty()) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fe4c78a6b2e4f74$export$83b162e8887c541d), {
                                name: getName(productType.id),
                                total: firstYearSummary?.total,
                                fees: firstYearSummary?.fees || [],
                                otherYearsData: otherYearsData,
                                highlight: productType.id === selectedProductType
                            }, "table_group_" + i);
                        }),
                        hasAdjustments && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                            className: "settlement__list__item settlement__list__item--total",
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    children: "Adjustments"
                                }, "adjustments"),
                                yearlyMonthSummaries.map(({ monthSummary: monthSummary }, i)=>monthSummary.adjustmentSummary.total !== 0 ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("td", {
                                                className: "rightText noWrap",
                                                children: [
                                                    (0, $f5d0c2a7498ff49b$exports.format).integer(monthSummary.adjustmentSummary.count),
                                                    " \xd7"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("td", {
                                                className: "rightText noWrap",
                                                children: [
                                                    (0, $f5d0c2a7498ff49b$exports.format).decimal(monthSummary.adjustmentSummary.total / monthSummary.adjustmentSummary.count),
                                                    " ="
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                                className: "rightText noWrap",
                                                children: (0, $f5d0c2a7498ff49b$exports.format).decimal(monthSummary.adjustmentSummary.total)
                                            })
                                        ]
                                    }, "adjustment_" + i) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                        colSpan: 3
                                    }, "adjustment_" + i))
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("tfoot", {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("tr", {
                        className: "settlement__list__item settlement__list__item--sum settlement__list__item--total",
                        children: yearlyMonthSummaries.map(({ monthSummary: monthSummary }, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                                children: [
                                    i == 0 && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                        children: "Month Total (excl. VAT)"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {}),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                        className: "rightText noWrap",
                                        children: currentUserBrand?.currencyCode
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("th", {
                                        className: "rightText settlement__list__item--sum",
                                        children: (0, $f5d0c2a7498ff49b$exports.format).decimal(monthSummary.total)
                                    })
                                ]
                            }, "summary_" + i))
                    })
                })
            ]
        })
    });
};








var $fgmOP = parcelRequire("fgmOP");

var $fgmOP = parcelRequire("fgmOP");
var $ef0be999ea46011c$exports = {};
var $ada02440f1acd377$exports = {};
var $3da779549357f46b$exports = {};

var $eHWnd = parcelRequire("eHWnd");
/** Built-in value references. */ var $3da779549357f46b$var$Symbol = $eHWnd.Symbol;
$3da779549357f46b$exports = $3da779549357f46b$var$Symbol;


var $3c4e144189068b4f$exports = {};

/** Used for built-in method references. */ var $3c4e144189068b4f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3c4e144189068b4f$var$hasOwnProperty = $3c4e144189068b4f$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3c4e144189068b4f$var$nativeObjectToString = $3c4e144189068b4f$var$objectProto.toString;
/** Built-in value references. */ var $3c4e144189068b4f$var$symToStringTag = $3da779549357f46b$exports ? $3da779549357f46b$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $3c4e144189068b4f$var$getRawTag(value) {
    var isOwn = $3c4e144189068b4f$var$hasOwnProperty.call(value, $3c4e144189068b4f$var$symToStringTag), tag = value[$3c4e144189068b4f$var$symToStringTag];
    try {
        value[$3c4e144189068b4f$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $3c4e144189068b4f$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$3c4e144189068b4f$var$symToStringTag] = tag;
        else delete value[$3c4e144189068b4f$var$symToStringTag];
    }
    return result;
}
$3c4e144189068b4f$exports = $3c4e144189068b4f$var$getRawTag;


var $b4ad9df5ebbd79cd$exports = {};
/** Used for built-in method references. */ var $b4ad9df5ebbd79cd$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $b4ad9df5ebbd79cd$var$nativeObjectToString = $b4ad9df5ebbd79cd$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $b4ad9df5ebbd79cd$var$objectToString(value) {
    return $b4ad9df5ebbd79cd$var$nativeObjectToString.call(value);
}
$b4ad9df5ebbd79cd$exports = $b4ad9df5ebbd79cd$var$objectToString;


/** `Object#toString` result references. */ var $ada02440f1acd377$var$nullTag = "[object Null]", $ada02440f1acd377$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $ada02440f1acd377$var$symToStringTag = $3da779549357f46b$exports ? $3da779549357f46b$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $ada02440f1acd377$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $ada02440f1acd377$var$undefinedTag : $ada02440f1acd377$var$nullTag;
    return $ada02440f1acd377$var$symToStringTag && $ada02440f1acd377$var$symToStringTag in Object(value) ? $3c4e144189068b4f$exports(value) : $b4ad9df5ebbd79cd$exports(value);
}
$ada02440f1acd377$exports = $ada02440f1acd377$var$baseGetTag;


var $6fd646b25232d34a$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $6fd646b25232d34a$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$6fd646b25232d34a$exports = $6fd646b25232d34a$var$isObject;


/** `Object#toString` result references. */ var $ef0be999ea46011c$var$asyncTag = "[object AsyncFunction]", $ef0be999ea46011c$var$funcTag = "[object Function]", $ef0be999ea46011c$var$genTag = "[object GeneratorFunction]", $ef0be999ea46011c$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $ef0be999ea46011c$var$isFunction(value) {
    if (!$6fd646b25232d34a$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $ada02440f1acd377$exports(value);
    return tag == $ef0be999ea46011c$var$funcTag || tag == $ef0be999ea46011c$var$genTag || tag == $ef0be999ea46011c$var$asyncTag || tag == $ef0be999ea46011c$var$proxyTag;
}
$ef0be999ea46011c$exports = $ef0be999ea46011c$var$isFunction;


/* eslint no-console: 0 */ var $b8908dd384eb6989$var$isDev = false;
var $b8908dd384eb6989$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($b8908dd384eb6989$var$isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


var $36bb6c5dca3fd10c$exports = {};

var $d9532e5a54ad1ff7$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $d9532e5a54ad1ff7$var$isArray = Array.isArray;
$d9532e5a54ad1ff7$exports = $d9532e5a54ad1ff7$var$isArray;


var $bff1b3634f78ba00$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $bff1b3634f78ba00$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$bff1b3634f78ba00$exports = $bff1b3634f78ba00$var$isObjectLike;


/** `Object#toString` result references. */ var $36bb6c5dca3fd10c$var$stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $36bb6c5dca3fd10c$var$isString(value) {
    return typeof value == "string" || !$d9532e5a54ad1ff7$exports(value) && $bff1b3634f78ba00$exports(value) && $ada02440f1acd377$exports(value) == $36bb6c5dca3fd10c$var$stringTag;
}
$36bb6c5dca3fd10c$exports = $36bb6c5dca3fd10c$var$isString;


var $5f4abd17a6959cf9$exports = {};
var $70e141eb4a35881d$exports = {};


/** `Object#toString` result references. */ var $70e141eb4a35881d$var$numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $70e141eb4a35881d$var$isNumber(value) {
    return typeof value == "number" || $bff1b3634f78ba00$exports(value) && $ada02440f1acd377$exports(value) == $70e141eb4a35881d$var$numberTag;
}
$70e141eb4a35881d$exports = $70e141eb4a35881d$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $5f4abd17a6959cf9$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $70e141eb4a35881d$exports(value) && value != +value;
}
$5f4abd17a6959cf9$exports = $5f4abd17a6959cf9$var$isNaN;


var $d0c0e0e0987fd69b$exports = {};
var $b23f68dd51fe151f$exports = {};
var $3633f224c4d48118$exports = {};

var $56150eed2c54c52a$exports = {};

var $1e567e62b72915ef$exports = {};


/** `Object#toString` result references. */ var $1e567e62b72915ef$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $1e567e62b72915ef$var$isSymbol(value) {
    return typeof value == "symbol" || $bff1b3634f78ba00$exports(value) && $ada02440f1acd377$exports(value) == $1e567e62b72915ef$var$symbolTag;
}
$1e567e62b72915ef$exports = $1e567e62b72915ef$var$isSymbol;


/** Used to match property names within property paths. */ var $56150eed2c54c52a$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $56150eed2c54c52a$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $56150eed2c54c52a$var$isKey(value, object) {
    if ($d9532e5a54ad1ff7$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $1e567e62b72915ef$exports(value)) return true;
    return $56150eed2c54c52a$var$reIsPlainProp.test(value) || !$56150eed2c54c52a$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$56150eed2c54c52a$exports = $56150eed2c54c52a$var$isKey;


var $6659843597921998$exports = {};
var $1f6a8f6eef663a52$exports = {};
var $53c2345beb4ce48a$exports = {};
var $9529333ee6d7764d$exports = {};
var $1c114bbc339bdff8$exports = {};
var $a82b2a38a975e4e2$exports = {};
var $fa08ffdc73845b1a$exports = {};
var $7146e84984aa8b69$exports = {};
var $6f25eda1013f8320$exports = {};
var $46f0645e7a5c8b5c$exports = {};

var $c979e2c9e4907df9$exports = {};
var $35b2991a7c7faf7c$exports = {};

var $eHWnd = parcelRequire("eHWnd");
/** Used to detect overreaching core-js shims. */ var $35b2991a7c7faf7c$var$coreJsData = $eHWnd["__core-js_shared__"];
$35b2991a7c7faf7c$exports = $35b2991a7c7faf7c$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $c979e2c9e4907df9$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($35b2991a7c7faf7c$exports && $35b2991a7c7faf7c$exports.keys && $35b2991a7c7faf7c$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $c979e2c9e4907df9$var$isMasked(func) {
    return !!$c979e2c9e4907df9$var$maskSrcKey && $c979e2c9e4907df9$var$maskSrcKey in func;
}
$c979e2c9e4907df9$exports = $c979e2c9e4907df9$var$isMasked;



var $bd79f1810ecec943$exports = {};
/** Used for built-in method references. */ var $bd79f1810ecec943$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $bd79f1810ecec943$var$funcToString = $bd79f1810ecec943$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $bd79f1810ecec943$var$toSource(func) {
    if (func != null) {
        try {
            return $bd79f1810ecec943$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$bd79f1810ecec943$exports = $bd79f1810ecec943$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $46f0645e7a5c8b5c$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $46f0645e7a5c8b5c$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $46f0645e7a5c8b5c$var$funcProto = Function.prototype, $46f0645e7a5c8b5c$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $46f0645e7a5c8b5c$var$funcToString = $46f0645e7a5c8b5c$var$funcProto.toString;
/** Used to check objects for own properties. */ var $46f0645e7a5c8b5c$var$hasOwnProperty = $46f0645e7a5c8b5c$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $46f0645e7a5c8b5c$var$reIsNative = RegExp("^" + $46f0645e7a5c8b5c$var$funcToString.call($46f0645e7a5c8b5c$var$hasOwnProperty).replace($46f0645e7a5c8b5c$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $46f0645e7a5c8b5c$var$baseIsNative(value) {
    if (!$6fd646b25232d34a$exports(value) || $c979e2c9e4907df9$exports(value)) return false;
    var pattern = $ef0be999ea46011c$exports(value) ? $46f0645e7a5c8b5c$var$reIsNative : $46f0645e7a5c8b5c$var$reIsHostCtor;
    return pattern.test($bd79f1810ecec943$exports(value));
}
$46f0645e7a5c8b5c$exports = $46f0645e7a5c8b5c$var$baseIsNative;


var $58dced46a8b4d0a2$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $58dced46a8b4d0a2$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$58dced46a8b4d0a2$exports = $58dced46a8b4d0a2$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $6f25eda1013f8320$var$getNative(object, key) {
    var value = $58dced46a8b4d0a2$exports(object, key);
    return $46f0645e7a5c8b5c$exports(value) ? value : undefined;
}
$6f25eda1013f8320$exports = $6f25eda1013f8320$var$getNative;


/* Built-in method references that are verified to be native. */ var $7146e84984aa8b69$var$nativeCreate = $6f25eda1013f8320$exports(Object, "create");
$7146e84984aa8b69$exports = $7146e84984aa8b69$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $fa08ffdc73845b1a$var$hashClear() {
    this.__data__ = $7146e84984aa8b69$exports ? $7146e84984aa8b69$exports(null) : {};
    this.size = 0;
}
$fa08ffdc73845b1a$exports = $fa08ffdc73845b1a$var$hashClear;


var $c4f6d4a495972f25$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $c4f6d4a495972f25$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$c4f6d4a495972f25$exports = $c4f6d4a495972f25$var$hashDelete;


var $1b064c3f4d4f22b4$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $1b064c3f4d4f22b4$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $1b064c3f4d4f22b4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1b064c3f4d4f22b4$var$hasOwnProperty = $1b064c3f4d4f22b4$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $1b064c3f4d4f22b4$var$hashGet(key) {
    var data = this.__data__;
    if ($7146e84984aa8b69$exports) {
        var result = data[key];
        return result === $1b064c3f4d4f22b4$var$HASH_UNDEFINED ? undefined : result;
    }
    return $1b064c3f4d4f22b4$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$1b064c3f4d4f22b4$exports = $1b064c3f4d4f22b4$var$hashGet;


var $27c87969bd20d012$exports = {};

/** Used for built-in method references. */ var $27c87969bd20d012$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $27c87969bd20d012$var$hasOwnProperty = $27c87969bd20d012$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $27c87969bd20d012$var$hashHas(key) {
    var data = this.__data__;
    return $7146e84984aa8b69$exports ? data[key] !== undefined : $27c87969bd20d012$var$hasOwnProperty.call(data, key);
}
$27c87969bd20d012$exports = $27c87969bd20d012$var$hashHas;


var $cb8554b2d6d52d87$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $cb8554b2d6d52d87$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $cb8554b2d6d52d87$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $7146e84984aa8b69$exports && value === undefined ? $cb8554b2d6d52d87$var$HASH_UNDEFINED : value;
    return this;
}
$cb8554b2d6d52d87$exports = $cb8554b2d6d52d87$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a82b2a38a975e4e2$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$a82b2a38a975e4e2$var$Hash.prototype.clear = $fa08ffdc73845b1a$exports;
$a82b2a38a975e4e2$var$Hash.prototype["delete"] = $c4f6d4a495972f25$exports;
$a82b2a38a975e4e2$var$Hash.prototype.get = $1b064c3f4d4f22b4$exports;
$a82b2a38a975e4e2$var$Hash.prototype.has = $27c87969bd20d012$exports;
$a82b2a38a975e4e2$var$Hash.prototype.set = $cb8554b2d6d52d87$exports;
$a82b2a38a975e4e2$exports = $a82b2a38a975e4e2$var$Hash;


var $a4664e4a86e367f6$exports = {};
var $5d476c8258e3cf90$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $5d476c8258e3cf90$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$5d476c8258e3cf90$exports = $5d476c8258e3cf90$var$listCacheClear;


var $8a30d95e8bcefc0e$exports = {};
var $eac0296b04b4e193$exports = {};
var $d6f8ba4f5fc9d103$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $d6f8ba4f5fc9d103$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$d6f8ba4f5fc9d103$exports = $d6f8ba4f5fc9d103$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $eac0296b04b4e193$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($d6f8ba4f5fc9d103$exports(array[length][0], key)) return length;
    }
    return -1;
}
$eac0296b04b4e193$exports = $eac0296b04b4e193$var$assocIndexOf;


/** Used for built-in method references. */ var $8a30d95e8bcefc0e$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $8a30d95e8bcefc0e$var$splice = $8a30d95e8bcefc0e$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $8a30d95e8bcefc0e$var$listCacheDelete(key) {
    var data = this.__data__, index = $eac0296b04b4e193$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $8a30d95e8bcefc0e$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$8a30d95e8bcefc0e$exports = $8a30d95e8bcefc0e$var$listCacheDelete;


var $5716d09cb5aa9824$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $5716d09cb5aa9824$var$listCacheGet(key) {
    var data = this.__data__, index = $eac0296b04b4e193$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$5716d09cb5aa9824$exports = $5716d09cb5aa9824$var$listCacheGet;


var $3df88c53fef88221$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $3df88c53fef88221$var$listCacheHas(key) {
    return $eac0296b04b4e193$exports(this.__data__, key) > -1;
}
$3df88c53fef88221$exports = $3df88c53fef88221$var$listCacheHas;


var $70b73ad72e37d568$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $70b73ad72e37d568$var$listCacheSet(key, value) {
    var data = this.__data__, index = $eac0296b04b4e193$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$70b73ad72e37d568$exports = $70b73ad72e37d568$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a4664e4a86e367f6$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$a4664e4a86e367f6$var$ListCache.prototype.clear = $5d476c8258e3cf90$exports;
$a4664e4a86e367f6$var$ListCache.prototype["delete"] = $8a30d95e8bcefc0e$exports;
$a4664e4a86e367f6$var$ListCache.prototype.get = $5716d09cb5aa9824$exports;
$a4664e4a86e367f6$var$ListCache.prototype.has = $3df88c53fef88221$exports;
$a4664e4a86e367f6$var$ListCache.prototype.set = $70b73ad72e37d568$exports;
$a4664e4a86e367f6$exports = $a4664e4a86e367f6$var$ListCache;


var $91a4bf742d5a61df$exports = {};


var $eHWnd = parcelRequire("eHWnd");
/* Built-in method references that are verified to be native. */ var $91a4bf742d5a61df$var$Map = $6f25eda1013f8320$exports($eHWnd, "Map");
$91a4bf742d5a61df$exports = $91a4bf742d5a61df$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $1c114bbc339bdff8$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $a82b2a38a975e4e2$exports,
        "map": new ($91a4bf742d5a61df$exports || $a4664e4a86e367f6$exports),
        "string": new $a82b2a38a975e4e2$exports
    };
}
$1c114bbc339bdff8$exports = $1c114bbc339bdff8$var$mapCacheClear;


var $92fe34642a3152ce$exports = {};
var $18fb80e01b273a69$exports = {};
var $4a900e2bf5e7106e$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $4a900e2bf5e7106e$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$4a900e2bf5e7106e$exports = $4a900e2bf5e7106e$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $18fb80e01b273a69$var$getMapData(map, key) {
    var data = map.__data__;
    return $4a900e2bf5e7106e$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$18fb80e01b273a69$exports = $18fb80e01b273a69$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $92fe34642a3152ce$var$mapCacheDelete(key) {
    var result = $18fb80e01b273a69$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$92fe34642a3152ce$exports = $92fe34642a3152ce$var$mapCacheDelete;


var $29eef1273f0541b2$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $29eef1273f0541b2$var$mapCacheGet(key) {
    return $18fb80e01b273a69$exports(this, key).get(key);
}
$29eef1273f0541b2$exports = $29eef1273f0541b2$var$mapCacheGet;


var $8071edc788d1981e$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $8071edc788d1981e$var$mapCacheHas(key) {
    return $18fb80e01b273a69$exports(this, key).has(key);
}
$8071edc788d1981e$exports = $8071edc788d1981e$var$mapCacheHas;


var $8940e8b31eb5ce59$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $8940e8b31eb5ce59$var$mapCacheSet(key, value) {
    var data = $18fb80e01b273a69$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$8940e8b31eb5ce59$exports = $8940e8b31eb5ce59$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $9529333ee6d7764d$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$9529333ee6d7764d$var$MapCache.prototype.clear = $1c114bbc339bdff8$exports;
$9529333ee6d7764d$var$MapCache.prototype["delete"] = $92fe34642a3152ce$exports;
$9529333ee6d7764d$var$MapCache.prototype.get = $29eef1273f0541b2$exports;
$9529333ee6d7764d$var$MapCache.prototype.has = $8071edc788d1981e$exports;
$9529333ee6d7764d$var$MapCache.prototype.set = $8940e8b31eb5ce59$exports;
$9529333ee6d7764d$exports = $9529333ee6d7764d$var$MapCache;


/** Error message constants. */ var $53c2345beb4ce48a$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $53c2345beb4ce48a$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($53c2345beb4ce48a$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($53c2345beb4ce48a$var$memoize.Cache || $9529333ee6d7764d$exports);
    return memoized;
}
// Expose `MapCache`.
$53c2345beb4ce48a$var$memoize.Cache = $9529333ee6d7764d$exports;
$53c2345beb4ce48a$exports = $53c2345beb4ce48a$var$memoize;


/** Used as the maximum memoize cache size. */ var $1f6a8f6eef663a52$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $1f6a8f6eef663a52$var$memoizeCapped(func) {
    var result = $53c2345beb4ce48a$exports(func, function(key) {
        if (cache.size === $1f6a8f6eef663a52$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$1f6a8f6eef663a52$exports = $1f6a8f6eef663a52$var$memoizeCapped;


/** Used to match property names within property paths. */ var $6659843597921998$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $6659843597921998$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $6659843597921998$var$stringToPath = $1f6a8f6eef663a52$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($6659843597921998$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($6659843597921998$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$6659843597921998$exports = $6659843597921998$var$stringToPath;


var $01b267477924cf7f$exports = {};
var $ef3a7fac80cfca21$exports = {};

var $25bfb6471b658c1b$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $25bfb6471b658c1b$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$25bfb6471b658c1b$exports = $25bfb6471b658c1b$var$arrayMap;




/** Used as references for various `Number` constants. */ var $ef3a7fac80cfca21$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $ef3a7fac80cfca21$var$symbolProto = $3da779549357f46b$exports ? $3da779549357f46b$exports.prototype : undefined, $ef3a7fac80cfca21$var$symbolToString = $ef3a7fac80cfca21$var$symbolProto ? $ef3a7fac80cfca21$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $ef3a7fac80cfca21$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($d9532e5a54ad1ff7$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $25bfb6471b658c1b$exports(value, $ef3a7fac80cfca21$var$baseToString) + "";
    if ($1e567e62b72915ef$exports(value)) return $ef3a7fac80cfca21$var$symbolToString ? $ef3a7fac80cfca21$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$ef3a7fac80cfca21$var$INFINITY ? "-0" : result;
}
$ef3a7fac80cfca21$exports = $ef3a7fac80cfca21$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $01b267477924cf7f$var$toString(value) {
    return value == null ? "" : $ef3a7fac80cfca21$exports(value);
}
$01b267477924cf7f$exports = $01b267477924cf7f$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $3633f224c4d48118$var$castPath(value, object) {
    if ($d9532e5a54ad1ff7$exports(value)) return value;
    return $56150eed2c54c52a$exports(value, object) ? [
        value
    ] : $6659843597921998$exports($01b267477924cf7f$exports(value));
}
$3633f224c4d48118$exports = $3633f224c4d48118$var$castPath;


var $561f92de7ef1e551$exports = {};

/** Used as references for various `Number` constants. */ var $561f92de7ef1e551$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $561f92de7ef1e551$var$toKey(value) {
    if (typeof value == "string" || $1e567e62b72915ef$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$561f92de7ef1e551$var$INFINITY ? "-0" : result;
}
$561f92de7ef1e551$exports = $561f92de7ef1e551$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $b23f68dd51fe151f$var$baseGet(object, path) {
    path = $3633f224c4d48118$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$561f92de7ef1e551$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$b23f68dd51fe151f$exports = $b23f68dd51fe151f$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $d0c0e0e0987fd69b$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $b23f68dd51fe151f$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$d0c0e0e0987fd69b$exports = $d0c0e0e0987fd69b$var$get;



var $e6d37abae86076b3$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $e6d37abae86076b3$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($36bb6c5dca3fd10c$exports)))(value) && value.indexOf("%") === value.length - 1;
};
var $e6d37abae86076b3$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($70e141eb4a35881d$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($5f4abd17a6959cf9$exports)))(value);
};
var $e6d37abae86076b3$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $e6d37abae86076b3$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($36bb6c5dca3fd10c$exports)))(value);
};
var $e6d37abae86076b3$var$idCounter = 0;
var $e6d37abae86076b3$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$e6d37abae86076b3$var$idCounter;
    return "".concat(prefix || "").concat(id);
};
var $e6d37abae86076b3$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$e6d37abae86076b3$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($36bb6c5dca3fd10c$exports)))(percent)) return defaultValue;
    var value;
    if ($e6d37abae86076b3$export$e50269385c77c348(percent)) {
        var index = percent.indexOf("%");
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($5f4abd17a6959cf9$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $e6d37abae86076b3$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $e6d37abae86076b3$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $e6d37abae86076b3$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($e6d37abae86076b3$export$7e4aa119212bc614(numberA) && $e6d37abae86076b3$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $e6d37abae86076b3$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === "function" ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($d0c0e0e0987fd69b$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $e6d37abae86076b3$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};



var $1fb33066f3baf75f$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $1fb33066f3baf75f$var$isNil(value) {
    return value == null;
}
$1fb33066f3baf75f$exports = $1fb33066f3baf75f$var$isNil;






var $fgmOP = parcelRequire("fgmOP");
var $5b1a1d37bd1e63b3$exports = {};
"use strict";

$5b1a1d37bd1e63b3$exports = (parcelRequire("3pSlN"));



function $6d132e2dc77fb074$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}



var $fgmOP = parcelRequire("fgmOP");

function $9fee8beacafd8fde$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9fee8beacafd8fde$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9fee8beacafd8fde$var$_typeof(o);
}
/**
 * Determines how values are stacked:
 *
 * - `none` is the default, it adds values on top of each other. No smarts. Negative values will overlap.
 * - `expand` make it so that the values always add up to 1 - so the chart will look like a rectangle.
 * - `wiggle` and `silhouette` tries to keep the chart centered.
 * - `sign` stacks positive values above zero and negative values below zero. Similar to `none` but handles negatives.
 * - `positive` ignores all negative values, and then behaves like \`none\`.
 *
 * Also see https://d3js.org/d3-shape/stack#stack-offsets
 * (note that the `diverging` offset in d3 is named `sign` in recharts)
 */ //
// Event Handler Types -- Copied from @types/react/index.d.ts and adapted for Props.
//
var $9fee8beacafd8fde$var$SVGContainerPropKeys = [
    "viewBox",
    "children"
];
var $9fee8beacafd8fde$export$190f430946f96110 = [
    "aria-activedescendant",
    "aria-atomic",
    "aria-autocomplete",
    "aria-busy",
    "aria-checked",
    "aria-colcount",
    "aria-colindex",
    "aria-colspan",
    "aria-controls",
    "aria-current",
    "aria-describedby",
    "aria-details",
    "aria-disabled",
    "aria-errormessage",
    "aria-expanded",
    "aria-flowto",
    "aria-haspopup",
    "aria-hidden",
    "aria-invalid",
    "aria-keyshortcuts",
    "aria-label",
    "aria-labelledby",
    "aria-level",
    "aria-live",
    "aria-modal",
    "aria-multiline",
    "aria-multiselectable",
    "aria-orientation",
    "aria-owns",
    "aria-placeholder",
    "aria-posinset",
    "aria-pressed",
    "aria-readonly",
    "aria-relevant",
    "aria-required",
    "aria-roledescription",
    "aria-rowcount",
    "aria-rowindex",
    "aria-rowspan",
    "aria-selected",
    "aria-setsize",
    "aria-sort",
    "aria-valuemax",
    "aria-valuemin",
    "aria-valuenow",
    "aria-valuetext",
    "className",
    "color",
    "height",
    "id",
    "lang",
    "max",
    "media",
    "method",
    "min",
    "name",
    "style",
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    "target",
    "width",
    "role",
    "tabIndex",
    "accentHeight",
    "accumulate",
    "additive",
    "alignmentBaseline",
    "allowReorder",
    "alphabetic",
    "amplitude",
    "arabicForm",
    "ascent",
    "attributeName",
    "attributeType",
    "autoReverse",
    "azimuth",
    "baseFrequency",
    "baselineShift",
    "baseProfile",
    "bbox",
    "begin",
    "bias",
    "by",
    "calcMode",
    "capHeight",
    "clip",
    "clipPath",
    "clipPathUnits",
    "clipRule",
    "colorInterpolation",
    "colorInterpolationFilters",
    "colorProfile",
    "colorRendering",
    "contentScriptType",
    "contentStyleType",
    "cursor",
    "cx",
    "cy",
    "d",
    "decelerate",
    "descent",
    "diffuseConstant",
    "direction",
    "display",
    "divisor",
    "dominantBaseline",
    "dur",
    "dx",
    "dy",
    "edgeMode",
    "elevation",
    "enableBackground",
    "end",
    "exponent",
    "externalResourcesRequired",
    "fill",
    "fillOpacity",
    "fillRule",
    "filter",
    "filterRes",
    "filterUnits",
    "floodColor",
    "floodOpacity",
    "focusable",
    "fontFamily",
    "fontSize",
    "fontSizeAdjust",
    "fontStretch",
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "format",
    "from",
    "fx",
    "fy",
    "g1",
    "g2",
    "glyphName",
    "glyphOrientationHorizontal",
    "glyphOrientationVertical",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "hanging",
    "horizAdvX",
    "horizOriginX",
    "href",
    "ideographic",
    "imageRendering",
    "in2",
    "in",
    "intercept",
    "k1",
    "k2",
    "k3",
    "k4",
    "k",
    "kernelMatrix",
    "kernelUnitLength",
    "kerning",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "letterSpacing",
    "lightingColor",
    "limitingConeAngle",
    "local",
    "markerEnd",
    "markerHeight",
    "markerMid",
    "markerStart",
    "markerUnits",
    "markerWidth",
    "mask",
    "maskContentUnits",
    "maskUnits",
    "mathematical",
    "mode",
    "numOctaves",
    "offset",
    "opacity",
    "operator",
    "order",
    "orient",
    "orientation",
    "origin",
    "overflow",
    "overlinePosition",
    "overlineThickness",
    "paintOrder",
    "panose1",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointerEvents",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "r",
    "radius",
    "refX",
    "refY",
    "renderingIntent",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "restart",
    "result",
    "rotate",
    "rx",
    "ry",
    "seed",
    "shapeRendering",
    "slope",
    "spacing",
    "specularConstant",
    "specularExponent",
    "speed",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stemh",
    "stemv",
    "stitchTiles",
    "stopColor",
    "stopOpacity",
    "strikethroughPosition",
    "strikethroughThickness",
    "string",
    "stroke",
    "strokeDasharray",
    "strokeDashoffset",
    "strokeLinecap",
    "strokeLinejoin",
    "strokeMiterlimit",
    "strokeOpacity",
    "strokeWidth",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textAnchor",
    "textDecoration",
    "textLength",
    "textRendering",
    "to",
    "transform",
    "u1",
    "u2",
    "underlinePosition",
    "underlineThickness",
    "unicode",
    "unicodeBidi",
    "unicodeRange",
    "unitsPerEm",
    "vAlphabetic",
    "values",
    "vectorEffect",
    "version",
    "vertAdvY",
    "vertOriginX",
    "vertOriginY",
    "vHanging",
    "vIdeographic",
    "viewTarget",
    "visibility",
    "vMathematical",
    "widths",
    "wordSpacing",
    "writingMode",
    "x1",
    "x2",
    "x",
    "xChannelSelector",
    "xHeight",
    "xlinkActuate",
    "xlinkArcrole",
    "xlinkHref",
    "xlinkRole",
    "xlinkShow",
    "xlinkTitle",
    "xlinkType",
    "xmlBase",
    "xmlLang",
    "xmlns",
    "xmlnsXlink",
    "xmlSpace",
    "y1",
    "y2",
    "y",
    "yChannelSelector",
    "z",
    "zoomAndPan",
    "ref",
    "key",
    "angle"
];
var $9fee8beacafd8fde$var$PolyElementKeys = [
    "points",
    "pathLength"
];
var $9fee8beacafd8fde$export$2b22758266a6fa48 = {
    svg: $9fee8beacafd8fde$var$SVGContainerPropKeys,
    polygon: $9fee8beacafd8fde$var$PolyElementKeys,
    polyline: $9fee8beacafd8fde$var$PolyElementKeys
};
var $9fee8beacafd8fde$export$f30789245f2c4d11 = [
    "dangerouslySetInnerHTML",
    "onCopy",
    "onCopyCapture",
    "onCut",
    "onCutCapture",
    "onPaste",
    "onPasteCapture",
    "onCompositionEnd",
    "onCompositionEndCapture",
    "onCompositionStart",
    "onCompositionStartCapture",
    "onCompositionUpdate",
    "onCompositionUpdateCapture",
    "onFocus",
    "onFocusCapture",
    "onBlur",
    "onBlurCapture",
    "onChange",
    "onChangeCapture",
    "onBeforeInput",
    "onBeforeInputCapture",
    "onInput",
    "onInputCapture",
    "onReset",
    "onResetCapture",
    "onSubmit",
    "onSubmitCapture",
    "onInvalid",
    "onInvalidCapture",
    "onLoad",
    "onLoadCapture",
    "onError",
    "onErrorCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyPress",
    "onKeyPressCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onAbort",
    "onAbortCapture",
    "onCanPlay",
    "onCanPlayCapture",
    "onCanPlayThrough",
    "onCanPlayThroughCapture",
    "onDurationChange",
    "onDurationChangeCapture",
    "onEmptied",
    "onEmptiedCapture",
    "onEncrypted",
    "onEncryptedCapture",
    "onEnded",
    "onEndedCapture",
    "onLoadedData",
    "onLoadedDataCapture",
    "onLoadedMetadata",
    "onLoadedMetadataCapture",
    "onLoadStart",
    "onLoadStartCapture",
    "onPause",
    "onPauseCapture",
    "onPlay",
    "onPlayCapture",
    "onPlaying",
    "onPlayingCapture",
    "onProgress",
    "onProgressCapture",
    "onRateChange",
    "onRateChangeCapture",
    "onSeeked",
    "onSeekedCapture",
    "onSeeking",
    "onSeekingCapture",
    "onStalled",
    "onStalledCapture",
    "onSuspend",
    "onSuspendCapture",
    "onTimeUpdate",
    "onTimeUpdateCapture",
    "onVolumeChange",
    "onVolumeChangeCapture",
    "onWaiting",
    "onWaitingCapture",
    "onAuxClick",
    "onAuxClickCapture",
    "onClick",
    "onClickCapture",
    "onContextMenu",
    "onContextMenuCapture",
    "onDoubleClick",
    "onDoubleClickCapture",
    "onDrag",
    "onDragCapture",
    "onDragEnd",
    "onDragEndCapture",
    "onDragEnter",
    "onDragEnterCapture",
    "onDragExit",
    "onDragExitCapture",
    "onDragLeave",
    "onDragLeaveCapture",
    "onDragOver",
    "onDragOverCapture",
    "onDragStart",
    "onDragStartCapture",
    "onDrop",
    "onDropCapture",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseMoveCapture",
    "onMouseOut",
    "onMouseOutCapture",
    "onMouseOver",
    "onMouseOverCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onSelect",
    "onSelectCapture",
    "onTouchCancel",
    "onTouchCancelCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onTouchMove",
    "onTouchMoveCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerMove",
    "onPointerMoveCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onPointerCancel",
    "onPointerCancelCapture",
    "onPointerEnter",
    "onPointerEnterCapture",
    "onPointerLeave",
    "onPointerLeaveCapture",
    "onPointerOver",
    "onPointerOverCapture",
    "onPointerOut",
    "onPointerOutCapture",
    "onGotPointerCapture",
    "onGotPointerCaptureCapture",
    "onLostPointerCapture",
    "onLostPointerCaptureCapture",
    "onScroll",
    "onScrollCapture",
    "onWheel",
    "onWheelCapture",
    "onAnimationStart",
    "onAnimationStartCapture",
    "onAnimationEnd",
    "onAnimationEndCapture",
    "onAnimationIteration",
    "onAnimationIterationCapture",
    "onTransitionEnd",
    "onTransitionEndCapture"
];
var $9fee8beacafd8fde$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $fgmOP.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($6fd646b25232d34a$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($9fee8beacafd8fde$export$f30789245f2c4d11.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $9fee8beacafd8fde$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $9fee8beacafd8fde$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($6fd646b25232d34a$exports)))(props) || $9fee8beacafd8fde$var$_typeof(props) !== "object") return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($9fee8beacafd8fde$export$f30789245f2c4d11.includes(key) && typeof item === "function") {
            if (!out) out = {};
            out[key] = $9fee8beacafd8fde$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};


var $fa0843e4e64def56$var$_excluded = [
    "children"
], $fa0843e4e64def56$var$_excluded2 = [
    "children"
];
function $fa0843e4e64def56$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $fa0843e4e64def56$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $fa0843e4e64def56$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $fa0843e4e64def56$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $fa0843e4e64def56$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $fa0843e4e64def56$var$_typeof(o);
}
var $fa0843e4e64def56$var$REACT_BROWSER_EVENT_MAP = {
    click: "onClick",
    mousedown: "onMouseDown",
    mouseup: "onMouseUp",
    mouseover: "onMouseOver",
    mousemove: "onMouseMove",
    mouseout: "onMouseOut",
    mouseenter: "onMouseEnter",
    mouseleave: "onMouseLeave",
    touchcancel: "onTouchCancel",
    touchend: "onTouchEnd",
    touchmove: "onTouchMove",
    touchstart: "onTouchStart"
};
var $fa0843e4e64def56$export$e65e0ff8d3882b46 = [
    "auto",
    "linear",
    "pow",
    "sqrt",
    "log",
    "identity",
    "time",
    "band",
    "point",
    "ordinal",
    "quantile",
    "quantize",
    "utc",
    "sequential",
    "threshold"
];
var $fa0843e4e64def56$export$84dbd3b52ff06578 = [
    "plainline",
    "line",
    "square",
    "rect",
    "circle",
    "cross",
    "diamond",
    "star",
    "triangle",
    "wye",
    "none"
];
var $fa0843e4e64def56$export$59a4d7d024cf1025 = [
    "none"
];
var $fa0843e4e64def56$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === "string") return Comp;
    if (!Comp) return "";
    return Comp.displayName || Comp.name || "Component";
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $fa0843e4e64def56$var$lastChildren = null;
var $fa0843e4e64def56$var$lastResult = null;
var $fa0843e4e64def56$export$45b10814cc054894 = function toArray(children) {
    if (children === $fa0843e4e64def56$var$lastChildren && Array.isArray($fa0843e4e64def56$var$lastResult)) return $fa0843e4e64def56$var$lastResult;
    var result = [];
    (0, $fgmOP.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(child)) return;
        if ((0, $5b1a1d37bd1e63b3$exports.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else result.push(child);
    });
    $fa0843e4e64def56$var$lastResult = result;
    $fa0843e4e64def56$var$lastChildren = children;
    return result;
};
function $fa0843e4e64def56$export$fdd5e64c0e8495bb(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map(function(t) {
        return $fa0843e4e64def56$export$be63e0664592e141(t);
    });
    else types = [
        $fa0843e4e64def56$export$be63e0664592e141(type)
    ];
    $fa0843e4e64def56$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($d0c0e0e0987fd69b$exports)))(child, "type.displayName") || (0, (/*@__PURE__*/$parcel$interopDefault($d0c0e0e0987fd69b$exports)))(child, "type.name");
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
function $fa0843e4e64def56$export$64c61536a2b72e0f(children, type) {
    var result = $fa0843e4e64def56$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
}
var $fa0843e4e64def56$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if (Array.isArray(type)) types = type.map(function(t) {
        return $fa0843e4e64def56$export$be63e0664592e141(t);
    });
    else types = [
        $fa0843e4e64def56$export$be63e0664592e141(type)
    ];
    $fa0843e4e64def56$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($d0c0e0e0987fd69b$exports)))(child, "type.displayName");
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $fa0843e4e64def56$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $e6d37abae86076b3$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $e6d37abae86076b3$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $fa0843e4e64def56$var$SVG_TAGS = [
    "a",
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColormatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-url",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "lineGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "script",
    "set",
    "stop",
    "style",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "title",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
];
var $fa0843e4e64def56$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($36bb6c5dca3fd10c$exports)))(child.type) && $fa0843e4e64def56$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $fa0843e4e64def56$export$e78c5929b986eef9 = function isDotProps(dot) {
    return dot && $fa0843e4e64def56$var$_typeof(dot) === "object" && "cx" in dot && "cy" in dot && "r" in dot;
};
var $fa0843e4e64def56$export$be767fcc756dddf6 = function isValidSpreadableProp(property, key, includeEvents, svgElementType) {
    var _FilteredElementKeyMa;
    /**
   * If the svg element type is explicitly included, check against the filtered element key map
   * to determine if there are attributes that should only exist on that element type.
   * @todo Add an internal cjs version of https://github.com/wooorm/svg-element-attributes for full coverage.
   */ var matchingElementTypeKeys = (_FilteredElementKeyMa = (0, $9fee8beacafd8fde$export$2b22758266a6fa48) === null || (0, $9fee8beacafd8fde$export$2b22758266a6fa48) === void 0 ? void 0 : (0, $9fee8beacafd8fde$export$2b22758266a6fa48)[svgElementType]) !== null && _FilteredElementKeyMa !== void 0 ? _FilteredElementKeyMa : [];
    return !(0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(property) && (svgElementType && matchingElementTypeKeys.includes(key) || (0, $9fee8beacafd8fde$export$190f430946f96110).includes(key)) || includeEvents && (0, $9fee8beacafd8fde$export$f30789245f2c4d11).includes(key);
};
var $fa0843e4e64def56$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $fa0843e4e64def56$export$45b10814cc054894(children).forEach(function(entry) {
        if ($fa0843e4e64def56$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $fa0843e4e64def56$export$d697c39a2985a4c = function filterProps(props, includeEvents, svgElementType) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $fgmOP.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($6fd646b25232d34a$exports)))(inputProps)) return null;
    var out = {};
    /**
   * Props are blindly spread onto SVG elements. This loop filters out properties that we don't want to spread.
   * Items filtered out are as follows:
   *   - functions in properties that are SVG attributes (functions are included when includeEvents is true)
   *   - props that are SVG attributes but don't matched the passed svgElementType
   *   - any prop that is not in SVGElementPropKeys (or in EventKeys if includeEvents is true)
   */ Object.keys(inputProps).forEach(function(key) {
        var _inputProps;
        if ($fa0843e4e64def56$export$be767fcc756dddf6((_inputProps = inputProps) === null || _inputProps === void 0 ? void 0 : _inputProps[key], key, includeEvents, svgElementType)) out[key] = inputProps[key];
    });
    return out;
};
var $fa0843e4e64def56$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $fgmOP.Children).count(nextChildren);
    if (count !== (0, $fgmOP.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line @typescript-eslint/no-use-before-define
    return $fa0843e4e64def56$export$96bceecf65400492(Array.isArray(nextChildren) ? nextChildren[0] : nextChildren, Array.isArray(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if (Array.isArray(nextChild) || Array.isArray(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        } else if (!$fa0843e4e64def56$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $fa0843e4e64def56$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $fa0843e4e64def56$var$_objectWithoutProperties(_ref, $fa0843e4e64def56$var$_excluded);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $fa0843e4e64def56$var$_objectWithoutProperties(_ref2, $fa0843e4e64def56$var$_excluded2);
        if (nextChildren && prevChildren) return (0, $6d132e2dc77fb074$export$d36bdfa510afb180)(nextProps, prevProps) && $fa0843e4e64def56$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $6d132e2dc77fb074$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $fa0843e4e64def56$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $fa0843e4e64def56$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($fa0843e4e64def56$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $fa0843e4e64def56$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $fa0843e4e64def56$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $fa0843e4e64def56$var$REACT_BROWSER_EVENT_MAP[type]) return $fa0843e4e64def56$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $fa0843e4e64def56$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $fa0843e4e64def56$export$45b10814cc054894(children).indexOf(child);
};


var $3223330f788ca226$exports = {};
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$3223330f788ca226$exports = (parcelRequire("jKc4S"));


var $61471ee91debe026$exports = {};
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.

$61471ee91debe026$exports = (parcelRequire("9gQ5u"));


var $0fbd870e7e2db3ba$exports = {};
var $564ea96ec94e34c8$exports = {};

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $564ea96ec94e34c8$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$1e567e62b72915ef$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$564ea96ec94e34c8$exports = $564ea96ec94e34c8$var$baseExtremum;


var $03280f01421baec5$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $03280f01421baec5$var$baseGt(value, other) {
    return value > other;
}
$03280f01421baec5$exports = $03280f01421baec5$var$baseGt;


var $0b94856e5f4b18a8$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $0b94856e5f4b18a8$var$identity(value) {
    return value;
}
$0b94856e5f4b18a8$exports = $0b94856e5f4b18a8$var$identity;


/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $0fbd870e7e2db3ba$var$max(array) {
    return array && array.length ? $564ea96ec94e34c8$exports(array, $0b94856e5f4b18a8$exports, $03280f01421baec5$exports) : undefined;
}
$0fbd870e7e2db3ba$exports = $0fbd870e7e2db3ba$var$max;


var $4ba4f43f07120ee1$exports = {};

var $86e16a5bc639dd5b$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $86e16a5bc639dd5b$var$baseLt(value, other) {
    return value < other;
}
$86e16a5bc639dd5b$exports = $86e16a5bc639dd5b$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $4ba4f43f07120ee1$var$min(array) {
    return array && array.length ? $564ea96ec94e34c8$exports(array, $0b94856e5f4b18a8$exports, $86e16a5bc639dd5b$exports) : undefined;
}
$4ba4f43f07120ee1$exports = $4ba4f43f07120ee1$var$min;






var $f6ff90adaf97b5d0$exports = {};
var $d42e70f9e2c218bc$exports = {};
var $a1487791505873c2$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $a1487791505873c2$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$a1487791505873c2$exports = $a1487791505873c2$var$arrayPush;


var $43db5314f8afae18$exports = {};

var $0083fa53e30430bd$exports = {};
var $05dbe40f82307ad4$exports = {};


/** `Object#toString` result references. */ var $05dbe40f82307ad4$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $05dbe40f82307ad4$var$baseIsArguments(value) {
    return $bff1b3634f78ba00$exports(value) && $ada02440f1acd377$exports(value) == $05dbe40f82307ad4$var$argsTag;
}
$05dbe40f82307ad4$exports = $05dbe40f82307ad4$var$baseIsArguments;



/** Used for built-in method references. */ var $0083fa53e30430bd$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $0083fa53e30430bd$var$hasOwnProperty = $0083fa53e30430bd$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $0083fa53e30430bd$var$propertyIsEnumerable = $0083fa53e30430bd$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $0083fa53e30430bd$var$isArguments = $05dbe40f82307ad4$exports(function() {
    return arguments;
}()) ? $05dbe40f82307ad4$exports : function(value) {
    return $bff1b3634f78ba00$exports(value) && $0083fa53e30430bd$var$hasOwnProperty.call(value, "callee") && !$0083fa53e30430bd$var$propertyIsEnumerable.call(value, "callee");
};
$0083fa53e30430bd$exports = $0083fa53e30430bd$var$isArguments;



/** Built-in value references. */ var $43db5314f8afae18$var$spreadableSymbol = $3da779549357f46b$exports ? $3da779549357f46b$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $43db5314f8afae18$var$isFlattenable(value) {
    return $d9532e5a54ad1ff7$exports(value) || $0083fa53e30430bd$exports(value) || !!($43db5314f8afae18$var$spreadableSymbol && value && value[$43db5314f8afae18$var$spreadableSymbol]);
}
$43db5314f8afae18$exports = $43db5314f8afae18$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $d42e70f9e2c218bc$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $43db5314f8afae18$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $d42e70f9e2c218bc$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $a1487791505873c2$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$d42e70f9e2c218bc$exports = $d42e70f9e2c218bc$var$baseFlatten;


var $c21c2d450eef15f5$exports = {};

var $86a15e1908191355$exports = {};
var $fcae04bc6ba05193$exports = {};
var $9c37a98a869302fb$exports = {};
var $96cae3a2087f4a97$exports = {};

var $db29d20a42ef94bf$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $db29d20a42ef94bf$var$stackClear() {
    this.__data__ = new $a4664e4a86e367f6$exports;
    this.size = 0;
}
$db29d20a42ef94bf$exports = $db29d20a42ef94bf$var$stackClear;


var $4cc812c5dfde351d$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $4cc812c5dfde351d$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$4cc812c5dfde351d$exports = $4cc812c5dfde351d$var$stackDelete;


var $90e837807c717112$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $90e837807c717112$var$stackGet(key) {
    return this.__data__.get(key);
}
$90e837807c717112$exports = $90e837807c717112$var$stackGet;


var $195ebe72a4891b65$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $195ebe72a4891b65$var$stackHas(key) {
    return this.__data__.has(key);
}
$195ebe72a4891b65$exports = $195ebe72a4891b65$var$stackHas;


var $3637a6aaed96ff77$exports = {};



/** Used as the size to enable large array optimizations. */ var $3637a6aaed96ff77$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $3637a6aaed96ff77$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $a4664e4a86e367f6$exports) {
        var pairs = data.__data__;
        if (!$91a4bf742d5a61df$exports || pairs.length < $3637a6aaed96ff77$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $9529333ee6d7764d$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$3637a6aaed96ff77$exports = $3637a6aaed96ff77$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $96cae3a2087f4a97$var$Stack(entries) {
    var data = this.__data__ = new $a4664e4a86e367f6$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$96cae3a2087f4a97$var$Stack.prototype.clear = $db29d20a42ef94bf$exports;
$96cae3a2087f4a97$var$Stack.prototype["delete"] = $4cc812c5dfde351d$exports;
$96cae3a2087f4a97$var$Stack.prototype.get = $90e837807c717112$exports;
$96cae3a2087f4a97$var$Stack.prototype.has = $195ebe72a4891b65$exports;
$96cae3a2087f4a97$var$Stack.prototype.set = $3637a6aaed96ff77$exports;
$96cae3a2087f4a97$exports = $96cae3a2087f4a97$var$Stack;


var $cc8d4344f85043cc$exports = {};
var $f6969635a784afd5$exports = {};

var $7fd675da06664448$exports = {};
var $eba3361229eca1af$exports = {};

var $101ba143de794536$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $101ba143de794536$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $101ba143de794536$var$setCacheAdd(value) {
    this.__data__.set(value, $101ba143de794536$var$HASH_UNDEFINED);
    return this;
}
$101ba143de794536$exports = $101ba143de794536$var$setCacheAdd;


var $f70fd9ed5b10147a$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $f70fd9ed5b10147a$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$f70fd9ed5b10147a$exports = $f70fd9ed5b10147a$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $eba3361229eca1af$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $9529333ee6d7764d$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$eba3361229eca1af$var$SetCache.prototype.add = $eba3361229eca1af$var$SetCache.prototype.push = $101ba143de794536$exports;
$eba3361229eca1af$var$SetCache.prototype.has = $f70fd9ed5b10147a$exports;
$eba3361229eca1af$exports = $eba3361229eca1af$var$SetCache;


var $08ed168478904f15$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $08ed168478904f15$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$08ed168478904f15$exports = $08ed168478904f15$var$arraySome;


var $f1dd97b14d1aff02$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $f1dd97b14d1aff02$var$cacheHas(cache, key) {
    return cache.has(key);
}
$f1dd97b14d1aff02$exports = $f1dd97b14d1aff02$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $7fd675da06664448$var$COMPARE_PARTIAL_FLAG = 1, $7fd675da06664448$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $7fd675da06664448$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $7fd675da06664448$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $7fd675da06664448$var$COMPARE_UNORDERED_FLAG ? new $eba3361229eca1af$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$08ed168478904f15$exports(other, function(othValue, othIndex) {
                if (!$f1dd97b14d1aff02$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$7fd675da06664448$exports = $7fd675da06664448$var$equalArrays;


var $6b36a89978201d13$exports = {};

var $dbf215cb0c862173$exports = {};

var $eHWnd = parcelRequire("eHWnd");
/** Built-in value references. */ var $dbf215cb0c862173$var$Uint8Array = $eHWnd.Uint8Array;
$dbf215cb0c862173$exports = $dbf215cb0c862173$var$Uint8Array;




var $19618a1f30ef5f0d$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $19618a1f30ef5f0d$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$19618a1f30ef5f0d$exports = $19618a1f30ef5f0d$var$mapToArray;


var $1c815f34f571a65e$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $1c815f34f571a65e$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$1c815f34f571a65e$exports = $1c815f34f571a65e$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $6b36a89978201d13$var$COMPARE_PARTIAL_FLAG = 1, $6b36a89978201d13$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $6b36a89978201d13$var$boolTag = "[object Boolean]", $6b36a89978201d13$var$dateTag = "[object Date]", $6b36a89978201d13$var$errorTag = "[object Error]", $6b36a89978201d13$var$mapTag = "[object Map]", $6b36a89978201d13$var$numberTag = "[object Number]", $6b36a89978201d13$var$regexpTag = "[object RegExp]", $6b36a89978201d13$var$setTag = "[object Set]", $6b36a89978201d13$var$stringTag = "[object String]", $6b36a89978201d13$var$symbolTag = "[object Symbol]";
var $6b36a89978201d13$var$arrayBufferTag = "[object ArrayBuffer]", $6b36a89978201d13$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $6b36a89978201d13$var$symbolProto = $3da779549357f46b$exports ? $3da779549357f46b$exports.prototype : undefined, $6b36a89978201d13$var$symbolValueOf = $6b36a89978201d13$var$symbolProto ? $6b36a89978201d13$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $6b36a89978201d13$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $6b36a89978201d13$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $6b36a89978201d13$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $dbf215cb0c862173$exports(object), new $dbf215cb0c862173$exports(other))) return false;
            return true;
        case $6b36a89978201d13$var$boolTag:
        case $6b36a89978201d13$var$dateTag:
        case $6b36a89978201d13$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $d6f8ba4f5fc9d103$exports(+object, +other);
        case $6b36a89978201d13$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $6b36a89978201d13$var$regexpTag:
        case $6b36a89978201d13$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $6b36a89978201d13$var$mapTag:
            var convert = $19618a1f30ef5f0d$exports;
        case $6b36a89978201d13$var$setTag:
            var isPartial = bitmask & $6b36a89978201d13$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $1c815f34f571a65e$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $6b36a89978201d13$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $7fd675da06664448$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $6b36a89978201d13$var$symbolTag:
            if ($6b36a89978201d13$var$symbolValueOf) return $6b36a89978201d13$var$symbolValueOf.call(object) == $6b36a89978201d13$var$symbolValueOf.call(other);
    }
    return false;
}
$6b36a89978201d13$exports = $6b36a89978201d13$var$equalByTag;


var $015855226d18feda$exports = {};
var $43747c14472eb155$exports = {};
var $213567c5b44f195a$exports = {};


/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $213567c5b44f195a$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $d9532e5a54ad1ff7$exports(object) ? result : $a1487791505873c2$exports(result, symbolsFunc(object));
}
$213567c5b44f195a$exports = $213567c5b44f195a$var$baseGetAllKeys;


var $e431c68619dfae75$exports = {};
var $d6163c81efaf86d0$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $d6163c81efaf86d0$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$d6163c81efaf86d0$exports = $d6163c81efaf86d0$var$arrayFilter;


var $e3802304d68e8b4e$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $e3802304d68e8b4e$var$stubArray() {
    return [];
}
$e3802304d68e8b4e$exports = $e3802304d68e8b4e$var$stubArray;


/** Used for built-in method references. */ var $e431c68619dfae75$var$objectProto = Object.prototype;
/** Built-in value references. */ var $e431c68619dfae75$var$propertyIsEnumerable = $e431c68619dfae75$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e431c68619dfae75$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $e431c68619dfae75$var$getSymbols = !$e431c68619dfae75$var$nativeGetSymbols ? $e3802304d68e8b4e$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $d6163c81efaf86d0$exports($e431c68619dfae75$var$nativeGetSymbols(object), function(symbol) {
        return $e431c68619dfae75$var$propertyIsEnumerable.call(object, symbol);
    });
};
$e431c68619dfae75$exports = $e431c68619dfae75$var$getSymbols;


var $64e8d697e50831f7$exports = {};
var $9c410420773c04a3$exports = {};
var $85e91f944fd15e79$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $85e91f944fd15e79$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$85e91f944fd15e79$exports = $85e91f944fd15e79$var$baseTimes;





var $gtbqy = parcelRequire("gtbqy");
var $a66ac305766babbb$exports = {};
/** Used as references for various `Number` constants. */ var $a66ac305766babbb$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $a66ac305766babbb$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $a66ac305766babbb$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $a66ac305766babbb$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $a66ac305766babbb$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$a66ac305766babbb$exports = $a66ac305766babbb$var$isIndex;


var $8d4433a0321fe5a1$exports = {};
var $97048b606fef1a0e$exports = {};

var $10f9a41105fe71d3$exports = {};
/** Used as references for various `Number` constants. */ var $10f9a41105fe71d3$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $10f9a41105fe71d3$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $10f9a41105fe71d3$var$MAX_SAFE_INTEGER;
}
$10f9a41105fe71d3$exports = $10f9a41105fe71d3$var$isLength;



/** `Object#toString` result references. */ var $97048b606fef1a0e$var$argsTag = "[object Arguments]", $97048b606fef1a0e$var$arrayTag = "[object Array]", $97048b606fef1a0e$var$boolTag = "[object Boolean]", $97048b606fef1a0e$var$dateTag = "[object Date]", $97048b606fef1a0e$var$errorTag = "[object Error]", $97048b606fef1a0e$var$funcTag = "[object Function]", $97048b606fef1a0e$var$mapTag = "[object Map]", $97048b606fef1a0e$var$numberTag = "[object Number]", $97048b606fef1a0e$var$objectTag = "[object Object]", $97048b606fef1a0e$var$regexpTag = "[object RegExp]", $97048b606fef1a0e$var$setTag = "[object Set]", $97048b606fef1a0e$var$stringTag = "[object String]", $97048b606fef1a0e$var$weakMapTag = "[object WeakMap]";
var $97048b606fef1a0e$var$arrayBufferTag = "[object ArrayBuffer]", $97048b606fef1a0e$var$dataViewTag = "[object DataView]", $97048b606fef1a0e$var$float32Tag = "[object Float32Array]", $97048b606fef1a0e$var$float64Tag = "[object Float64Array]", $97048b606fef1a0e$var$int8Tag = "[object Int8Array]", $97048b606fef1a0e$var$int16Tag = "[object Int16Array]", $97048b606fef1a0e$var$int32Tag = "[object Int32Array]", $97048b606fef1a0e$var$uint8Tag = "[object Uint8Array]", $97048b606fef1a0e$var$uint8ClampedTag = "[object Uint8ClampedArray]", $97048b606fef1a0e$var$uint16Tag = "[object Uint16Array]", $97048b606fef1a0e$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $97048b606fef1a0e$var$typedArrayTags = {};
$97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$float32Tag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$float64Tag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$int8Tag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$int16Tag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$int32Tag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$uint8Tag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$uint8ClampedTag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$uint16Tag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$uint32Tag] = true;
$97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$argsTag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$arrayTag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$arrayBufferTag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$boolTag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$dataViewTag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$dateTag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$errorTag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$funcTag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$mapTag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$numberTag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$objectTag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$regexpTag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$setTag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$stringTag] = $97048b606fef1a0e$var$typedArrayTags[$97048b606fef1a0e$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $97048b606fef1a0e$var$baseIsTypedArray(value) {
    return $bff1b3634f78ba00$exports(value) && $10f9a41105fe71d3$exports(value.length) && !!$97048b606fef1a0e$var$typedArrayTags[$ada02440f1acd377$exports(value)];
}
$97048b606fef1a0e$exports = $97048b606fef1a0e$var$baseIsTypedArray;


var $ea802b0cb4d1e78d$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $ea802b0cb4d1e78d$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$ea802b0cb4d1e78d$exports = $ea802b0cb4d1e78d$var$baseUnary;



var $ipkSi = parcelRequire("ipkSi");
/* Node.js helper references. */ var $8d4433a0321fe5a1$var$nodeIsTypedArray = $ipkSi && $ipkSi.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $8d4433a0321fe5a1$var$isTypedArray = $8d4433a0321fe5a1$var$nodeIsTypedArray ? $ea802b0cb4d1e78d$exports($8d4433a0321fe5a1$var$nodeIsTypedArray) : $97048b606fef1a0e$exports;
$8d4433a0321fe5a1$exports = $8d4433a0321fe5a1$var$isTypedArray;


/** Used for built-in method references. */ var $9c410420773c04a3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9c410420773c04a3$var$hasOwnProperty = $9c410420773c04a3$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $9c410420773c04a3$var$arrayLikeKeys(value, inherited) {
    var isArr = $d9532e5a54ad1ff7$exports(value), isArg = !isArr && $0083fa53e30430bd$exports(value), isBuff = !isArr && !isArg && $gtbqy(value), isType = !isArr && !isArg && !isBuff && $8d4433a0321fe5a1$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $85e91f944fd15e79$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $9c410420773c04a3$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $a66ac305766babbb$exports(key, length)))) result.push(key);
    return result;
}
$9c410420773c04a3$exports = $9c410420773c04a3$var$arrayLikeKeys;


var $c28df8611eb8f59b$exports = {};
var $5dc22ae28da6cc63$exports = {};
/** Used for built-in method references. */ var $5dc22ae28da6cc63$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $5dc22ae28da6cc63$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $5dc22ae28da6cc63$var$objectProto;
    return value === proto;
}
$5dc22ae28da6cc63$exports = $5dc22ae28da6cc63$var$isPrototype;


var $eda4d221fc2d051d$exports = {};
var $dd50e77ee6c1b55b$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $dd50e77ee6c1b55b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$dd50e77ee6c1b55b$exports = $dd50e77ee6c1b55b$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $eda4d221fc2d051d$var$nativeKeys = $dd50e77ee6c1b55b$exports(Object.keys, Object);
$eda4d221fc2d051d$exports = $eda4d221fc2d051d$var$nativeKeys;


/** Used for built-in method references. */ var $c28df8611eb8f59b$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $c28df8611eb8f59b$var$hasOwnProperty = $c28df8611eb8f59b$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $c28df8611eb8f59b$var$baseKeys(object) {
    if (!$5dc22ae28da6cc63$exports(object)) return $eda4d221fc2d051d$exports(object);
    var result = [];
    for(var key in Object(object))if ($c28df8611eb8f59b$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$c28df8611eb8f59b$exports = $c28df8611eb8f59b$var$baseKeys;


var $8fd0dcf5a894c319$exports = {};


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $8fd0dcf5a894c319$var$isArrayLike(value) {
    return value != null && $10f9a41105fe71d3$exports(value.length) && !$ef0be999ea46011c$exports(value);
}
$8fd0dcf5a894c319$exports = $8fd0dcf5a894c319$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $64e8d697e50831f7$var$keys(object) {
    return $8fd0dcf5a894c319$exports(object) ? $9c410420773c04a3$exports(object) : $c28df8611eb8f59b$exports(object);
}
$64e8d697e50831f7$exports = $64e8d697e50831f7$var$keys;


/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $43747c14472eb155$var$getAllKeys(object) {
    return $213567c5b44f195a$exports(object, $64e8d697e50831f7$exports, $e431c68619dfae75$exports);
}
$43747c14472eb155$exports = $43747c14472eb155$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $015855226d18feda$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $015855226d18feda$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $015855226d18feda$var$hasOwnProperty = $015855226d18feda$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $015855226d18feda$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $015855226d18feda$var$COMPARE_PARTIAL_FLAG, objProps = $43747c14472eb155$exports(object), objLength = objProps.length, othProps = $43747c14472eb155$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $015855226d18feda$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$015855226d18feda$exports = $015855226d18feda$var$equalObjects;


var $50390852ba7da0e3$exports = {};
var $3063628f4d300092$exports = {};


var $eHWnd = parcelRequire("eHWnd");
/* Built-in method references that are verified to be native. */ var $3063628f4d300092$var$DataView = $6f25eda1013f8320$exports($eHWnd, "DataView");
$3063628f4d300092$exports = $3063628f4d300092$var$DataView;



var $abd400a897c258a8$exports = {};


var $eHWnd = parcelRequire("eHWnd");
/* Built-in method references that are verified to be native. */ var $abd400a897c258a8$var$Promise = $6f25eda1013f8320$exports($eHWnd, "Promise");
$abd400a897c258a8$exports = $abd400a897c258a8$var$Promise;


var $0be913e5a9ad9a84$exports = {};


var $eHWnd = parcelRequire("eHWnd");
/* Built-in method references that are verified to be native. */ var $0be913e5a9ad9a84$var$Set = $6f25eda1013f8320$exports($eHWnd, "Set");
$0be913e5a9ad9a84$exports = $0be913e5a9ad9a84$var$Set;


var $079a6194aa51654d$exports = {};


var $eHWnd = parcelRequire("eHWnd");
/* Built-in method references that are verified to be native. */ var $079a6194aa51654d$var$WeakMap = $6f25eda1013f8320$exports($eHWnd, "WeakMap");
$079a6194aa51654d$exports = $079a6194aa51654d$var$WeakMap;




/** `Object#toString` result references. */ var $50390852ba7da0e3$var$mapTag = "[object Map]", $50390852ba7da0e3$var$objectTag = "[object Object]", $50390852ba7da0e3$var$promiseTag = "[object Promise]", $50390852ba7da0e3$var$setTag = "[object Set]", $50390852ba7da0e3$var$weakMapTag = "[object WeakMap]";
var $50390852ba7da0e3$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $50390852ba7da0e3$var$dataViewCtorString = $bd79f1810ecec943$exports($3063628f4d300092$exports), $50390852ba7da0e3$var$mapCtorString = $bd79f1810ecec943$exports($91a4bf742d5a61df$exports), $50390852ba7da0e3$var$promiseCtorString = $bd79f1810ecec943$exports($abd400a897c258a8$exports), $50390852ba7da0e3$var$setCtorString = $bd79f1810ecec943$exports($0be913e5a9ad9a84$exports), $50390852ba7da0e3$var$weakMapCtorString = $bd79f1810ecec943$exports($079a6194aa51654d$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $50390852ba7da0e3$var$getTag = $ada02440f1acd377$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($3063628f4d300092$exports && $50390852ba7da0e3$var$getTag(new $3063628f4d300092$exports(new ArrayBuffer(1))) != $50390852ba7da0e3$var$dataViewTag || $91a4bf742d5a61df$exports && $50390852ba7da0e3$var$getTag(new $91a4bf742d5a61df$exports) != $50390852ba7da0e3$var$mapTag || $abd400a897c258a8$exports && $50390852ba7da0e3$var$getTag($abd400a897c258a8$exports.resolve()) != $50390852ba7da0e3$var$promiseTag || $0be913e5a9ad9a84$exports && $50390852ba7da0e3$var$getTag(new $0be913e5a9ad9a84$exports) != $50390852ba7da0e3$var$setTag || $079a6194aa51654d$exports && $50390852ba7da0e3$var$getTag(new $079a6194aa51654d$exports) != $50390852ba7da0e3$var$weakMapTag) $50390852ba7da0e3$var$getTag = function(value) {
    var result = $ada02440f1acd377$exports(value), Ctor = result == $50390852ba7da0e3$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $bd79f1810ecec943$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $50390852ba7da0e3$var$dataViewCtorString:
            return $50390852ba7da0e3$var$dataViewTag;
        case $50390852ba7da0e3$var$mapCtorString:
            return $50390852ba7da0e3$var$mapTag;
        case $50390852ba7da0e3$var$promiseCtorString:
            return $50390852ba7da0e3$var$promiseTag;
        case $50390852ba7da0e3$var$setCtorString:
            return $50390852ba7da0e3$var$setTag;
        case $50390852ba7da0e3$var$weakMapCtorString:
            return $50390852ba7da0e3$var$weakMapTag;
    }
    return result;
};
$50390852ba7da0e3$exports = $50390852ba7da0e3$var$getTag;




var $gtbqy = parcelRequire("gtbqy");

/** Used to compose bitmasks for value comparisons. */ var $f6969635a784afd5$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $f6969635a784afd5$var$argsTag = "[object Arguments]", $f6969635a784afd5$var$arrayTag = "[object Array]", $f6969635a784afd5$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $f6969635a784afd5$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f6969635a784afd5$var$hasOwnProperty = $f6969635a784afd5$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $f6969635a784afd5$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $d9532e5a54ad1ff7$exports(object), othIsArr = $d9532e5a54ad1ff7$exports(other), objTag = objIsArr ? $f6969635a784afd5$var$arrayTag : $50390852ba7da0e3$exports(object), othTag = othIsArr ? $f6969635a784afd5$var$arrayTag : $50390852ba7da0e3$exports(other);
    objTag = objTag == $f6969635a784afd5$var$argsTag ? $f6969635a784afd5$var$objectTag : objTag;
    othTag = othTag == $f6969635a784afd5$var$argsTag ? $f6969635a784afd5$var$objectTag : othTag;
    var objIsObj = objTag == $f6969635a784afd5$var$objectTag, othIsObj = othTag == $f6969635a784afd5$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $gtbqy(object)) {
        if (!$gtbqy(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $96cae3a2087f4a97$exports);
        return objIsArr || $8d4433a0321fe5a1$exports(object) ? $7fd675da06664448$exports(object, other, bitmask, customizer, equalFunc, stack) : $6b36a89978201d13$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $f6969635a784afd5$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $f6969635a784afd5$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $f6969635a784afd5$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $96cae3a2087f4a97$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $96cae3a2087f4a97$exports);
    return $015855226d18feda$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$f6969635a784afd5$exports = $f6969635a784afd5$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $cc8d4344f85043cc$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$bff1b3634f78ba00$exports(value) && !$bff1b3634f78ba00$exports(other)) return value !== value && other !== other;
    return $f6969635a784afd5$exports(value, other, bitmask, customizer, $cc8d4344f85043cc$var$baseIsEqual, stack);
}
$cc8d4344f85043cc$exports = $cc8d4344f85043cc$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $9c37a98a869302fb$var$COMPARE_PARTIAL_FLAG = 1, $9c37a98a869302fb$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $9c37a98a869302fb$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $96cae3a2087f4a97$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $cc8d4344f85043cc$exports(srcValue, objValue, $9c37a98a869302fb$var$COMPARE_PARTIAL_FLAG | $9c37a98a869302fb$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$9c37a98a869302fb$exports = $9c37a98a869302fb$var$baseIsMatch;


var $4b8cfdb6f06a1e2e$exports = {};
var $3673b651ee0b3bde$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $3673b651ee0b3bde$var$isStrictComparable(value) {
    return value === value && !$6fd646b25232d34a$exports(value);
}
$3673b651ee0b3bde$exports = $3673b651ee0b3bde$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $4b8cfdb6f06a1e2e$var$getMatchData(object) {
    var result = $64e8d697e50831f7$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $3673b651ee0b3bde$exports(value)
        ];
    }
    return result;
}
$4b8cfdb6f06a1e2e$exports = $4b8cfdb6f06a1e2e$var$getMatchData;


var $fed89dc46897a5f1$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $fed89dc46897a5f1$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$fed89dc46897a5f1$exports = $fed89dc46897a5f1$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $fcae04bc6ba05193$var$baseMatches(source) {
    var matchData = $4b8cfdb6f06a1e2e$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $fed89dc46897a5f1$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $9c37a98a869302fb$exports(object, source, matchData);
    };
}
$fcae04bc6ba05193$exports = $fcae04bc6ba05193$var$baseMatches;


var $dfe54a2cc5e014c7$exports = {};


var $e523bcce2f3a712b$exports = {};
var $c3873804648b3c74$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $c3873804648b3c74$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$c3873804648b3c74$exports = $c3873804648b3c74$var$baseHasIn;


var $3dfb7bc42936cf48$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $3dfb7bc42936cf48$var$hasPath(object, path, hasFunc) {
    path = $3633f224c4d48118$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $561f92de7ef1e551$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $10f9a41105fe71d3$exports(length) && $a66ac305766babbb$exports(key, length) && ($d9532e5a54ad1ff7$exports(object) || $0083fa53e30430bd$exports(object));
}
$3dfb7bc42936cf48$exports = $3dfb7bc42936cf48$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $e523bcce2f3a712b$var$hasIn(object, path) {
    return object != null && $3dfb7bc42936cf48$exports(object, path, $c3873804648b3c74$exports);
}
$e523bcce2f3a712b$exports = $e523bcce2f3a712b$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $dfe54a2cc5e014c7$var$COMPARE_PARTIAL_FLAG = 1, $dfe54a2cc5e014c7$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $dfe54a2cc5e014c7$var$baseMatchesProperty(path, srcValue) {
    if ($56150eed2c54c52a$exports(path) && $3673b651ee0b3bde$exports(srcValue)) return $fed89dc46897a5f1$exports($561f92de7ef1e551$exports(path), srcValue);
    return function(object) {
        var objValue = $d0c0e0e0987fd69b$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $e523bcce2f3a712b$exports(object, path) : $cc8d4344f85043cc$exports(srcValue, objValue, $dfe54a2cc5e014c7$var$COMPARE_PARTIAL_FLAG | $dfe54a2cc5e014c7$var$COMPARE_UNORDERED_FLAG);
    };
}
$dfe54a2cc5e014c7$exports = $dfe54a2cc5e014c7$var$baseMatchesProperty;




var $817f874c3bc00598$exports = {};
var $4d75498b510b203d$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $4d75498b510b203d$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$4d75498b510b203d$exports = $4d75498b510b203d$var$baseProperty;


var $224692fbaa655fc5$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $224692fbaa655fc5$var$basePropertyDeep(path) {
    return function(object) {
        return $b23f68dd51fe151f$exports(object, path);
    };
}
$224692fbaa655fc5$exports = $224692fbaa655fc5$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $817f874c3bc00598$var$property(path) {
    return $56150eed2c54c52a$exports(path) ? $4d75498b510b203d$exports($561f92de7ef1e551$exports(path)) : $224692fbaa655fc5$exports(path);
}
$817f874c3bc00598$exports = $817f874c3bc00598$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $86a15e1908191355$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $0b94856e5f4b18a8$exports;
    if (typeof value == "object") return $d9532e5a54ad1ff7$exports(value) ? $dfe54a2cc5e014c7$exports(value[0], value[1]) : $fcae04bc6ba05193$exports(value);
    return $817f874c3bc00598$exports(value);
}
$86a15e1908191355$exports = $86a15e1908191355$var$baseIteratee;


var $548405dd1b13d75f$exports = {};
var $e0c588ee25819a54$exports = {};
var $e238a765dc7a57dc$exports = {};
var $4dcddbe6bf8b70e6$exports = {};
var $ebd68f55c70bbab4$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $ebd68f55c70bbab4$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$ebd68f55c70bbab4$exports = $ebd68f55c70bbab4$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $4dcddbe6bf8b70e6$var$baseFor = $ebd68f55c70bbab4$exports();
$4dcddbe6bf8b70e6$exports = $4dcddbe6bf8b70e6$var$baseFor;



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $e238a765dc7a57dc$var$baseForOwn(object, iteratee) {
    return object && $4dcddbe6bf8b70e6$exports(object, iteratee, $64e8d697e50831f7$exports);
}
$e238a765dc7a57dc$exports = $e238a765dc7a57dc$var$baseForOwn;


var $4566ab78742e7de7$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $4566ab78742e7de7$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$8fd0dcf5a894c319$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$4566ab78742e7de7$exports = $4566ab78742e7de7$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $e0c588ee25819a54$var$baseEach = $4566ab78742e7de7$exports($e238a765dc7a57dc$exports);
$e0c588ee25819a54$exports = $e0c588ee25819a54$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $548405dd1b13d75f$var$baseMap(collection, iteratee) {
    var index = -1, result = $8fd0dcf5a894c319$exports(collection) ? Array(collection.length) : [];
    $e0c588ee25819a54$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$548405dd1b13d75f$exports = $548405dd1b13d75f$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $c21c2d450eef15f5$var$map(collection, iteratee) {
    var func = $d9532e5a54ad1ff7$exports(collection) ? $25bfb6471b658c1b$exports : $548405dd1b13d75f$exports;
    return func(collection, $86a15e1908191355$exports(iteratee, 3));
}
$c21c2d450eef15f5$exports = $c21c2d450eef15f5$var$map;


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $f6ff90adaf97b5d0$var$flatMap(collection, iteratee) {
    return $d42e70f9e2c218bc$exports($c21c2d450eef15f5$exports(collection, iteratee), 1);
}
$f6ff90adaf97b5d0$exports = $f6ff90adaf97b5d0$var$flatMap;



var $ad0c997ad9c80793$exports = {};
var $ca965d8778f55729$exports = {};
var $740d4ec76922a28e$exports = {};
var $26a62302a57fdadc$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $26a62302a57fdadc$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$26a62302a57fdadc$exports = $26a62302a57fdadc$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $740d4ec76922a28e$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $26a62302a57fdadc$exports(array, start, end);
}
$740d4ec76922a28e$exports = $740d4ec76922a28e$var$castSlice;


var $2eed9b781ca254cf$exports = {};
/** Used to compose unicode character classes. */ var $2eed9b781ca254cf$var$rsAstralRange = "\ud800-\udfff", $2eed9b781ca254cf$var$rsComboMarksRange = "\\u0300-\\u036f", $2eed9b781ca254cf$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $2eed9b781ca254cf$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $2eed9b781ca254cf$var$rsComboRange = $2eed9b781ca254cf$var$rsComboMarksRange + $2eed9b781ca254cf$var$reComboHalfMarksRange + $2eed9b781ca254cf$var$rsComboSymbolsRange, $2eed9b781ca254cf$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $2eed9b781ca254cf$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $2eed9b781ca254cf$var$reHasUnicode = RegExp("[" + $2eed9b781ca254cf$var$rsZWJ + $2eed9b781ca254cf$var$rsAstralRange + $2eed9b781ca254cf$var$rsComboRange + $2eed9b781ca254cf$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $2eed9b781ca254cf$var$hasUnicode(string) {
    return $2eed9b781ca254cf$var$reHasUnicode.test(string);
}
$2eed9b781ca254cf$exports = $2eed9b781ca254cf$var$hasUnicode;


var $3f6a72865e45a7cf$exports = {};
var $5401d32a9a4859b8$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $5401d32a9a4859b8$var$asciiToArray(string) {
    return string.split("");
}
$5401d32a9a4859b8$exports = $5401d32a9a4859b8$var$asciiToArray;



var $0d4b98fbb353f30d$exports = {};
/** Used to compose unicode character classes. */ var $0d4b98fbb353f30d$var$rsAstralRange = "\ud800-\udfff", $0d4b98fbb353f30d$var$rsComboMarksRange = "\\u0300-\\u036f", $0d4b98fbb353f30d$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $0d4b98fbb353f30d$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $0d4b98fbb353f30d$var$rsComboRange = $0d4b98fbb353f30d$var$rsComboMarksRange + $0d4b98fbb353f30d$var$reComboHalfMarksRange + $0d4b98fbb353f30d$var$rsComboSymbolsRange, $0d4b98fbb353f30d$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $0d4b98fbb353f30d$var$rsAstral = "[" + $0d4b98fbb353f30d$var$rsAstralRange + "]", $0d4b98fbb353f30d$var$rsCombo = "[" + $0d4b98fbb353f30d$var$rsComboRange + "]", $0d4b98fbb353f30d$var$rsFitz = "\ud83c[\udffb-\udfff]", $0d4b98fbb353f30d$var$rsModifier = "(?:" + $0d4b98fbb353f30d$var$rsCombo + "|" + $0d4b98fbb353f30d$var$rsFitz + ")", $0d4b98fbb353f30d$var$rsNonAstral = "[^" + $0d4b98fbb353f30d$var$rsAstralRange + "]", $0d4b98fbb353f30d$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $0d4b98fbb353f30d$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $0d4b98fbb353f30d$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $0d4b98fbb353f30d$var$reOptMod = $0d4b98fbb353f30d$var$rsModifier + "?", $0d4b98fbb353f30d$var$rsOptVar = "[" + $0d4b98fbb353f30d$var$rsVarRange + "]?", $0d4b98fbb353f30d$var$rsOptJoin = "(?:" + $0d4b98fbb353f30d$var$rsZWJ + "(?:" + [
    $0d4b98fbb353f30d$var$rsNonAstral,
    $0d4b98fbb353f30d$var$rsRegional,
    $0d4b98fbb353f30d$var$rsSurrPair
].join("|") + ")" + $0d4b98fbb353f30d$var$rsOptVar + $0d4b98fbb353f30d$var$reOptMod + ")*", $0d4b98fbb353f30d$var$rsSeq = $0d4b98fbb353f30d$var$rsOptVar + $0d4b98fbb353f30d$var$reOptMod + $0d4b98fbb353f30d$var$rsOptJoin, $0d4b98fbb353f30d$var$rsSymbol = "(?:" + [
    $0d4b98fbb353f30d$var$rsNonAstral + $0d4b98fbb353f30d$var$rsCombo + "?",
    $0d4b98fbb353f30d$var$rsCombo,
    $0d4b98fbb353f30d$var$rsRegional,
    $0d4b98fbb353f30d$var$rsSurrPair,
    $0d4b98fbb353f30d$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $0d4b98fbb353f30d$var$reUnicode = RegExp($0d4b98fbb353f30d$var$rsFitz + "(?=" + $0d4b98fbb353f30d$var$rsFitz + ")|" + $0d4b98fbb353f30d$var$rsSymbol + $0d4b98fbb353f30d$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $0d4b98fbb353f30d$var$unicodeToArray(string) {
    return string.match($0d4b98fbb353f30d$var$reUnicode) || [];
}
$0d4b98fbb353f30d$exports = $0d4b98fbb353f30d$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $3f6a72865e45a7cf$var$stringToArray(string) {
    return $2eed9b781ca254cf$exports(string) ? $0d4b98fbb353f30d$exports(string) : $5401d32a9a4859b8$exports(string);
}
$3f6a72865e45a7cf$exports = $3f6a72865e45a7cf$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $ca965d8778f55729$var$createCaseFirst(methodName) {
    return function(string) {
        string = $01b267477924cf7f$exports(string);
        var strSymbols = $2eed9b781ca254cf$exports(string) ? $3f6a72865e45a7cf$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $740d4ec76922a28e$exports(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$ca965d8778f55729$exports = $ca965d8778f55729$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $ad0c997ad9c80793$var$upperFirst = $ca965d8778f55729$exports("toUpperCase");
$ad0c997ad9c80793$exports = $ad0c997ad9c80793$var$upperFirst;


var $3e560c71c494b98e$exports = {};

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $3e560c71c494b98e$var$isEqual(value, other) {
    return $cc8d4344f85043cc$exports(value, other);
}
$3e560c71c494b98e$exports = $3e560c71c494b98e$var$isEqual;


var $024dd103a6f5c4c7$exports = {};

var $ec32bf7421075525$exports = {};




var $6a6f640b5d98fff6$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $6a6f640b5d98fff6$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$6a6f640b5d98fff6$exports = $6a6f640b5d98fff6$var$baseSortBy;



var $1c10279d1dd287d9$exports = {};
var $39ec1558fdb5ccad$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $39ec1558fdb5ccad$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $1e567e62b72915ef$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $1e567e62b72915ef$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$39ec1558fdb5ccad$exports = $39ec1558fdb5ccad$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $1c10279d1dd287d9$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $39ec1558fdb5ccad$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$1c10279d1dd287d9$exports = $1c10279d1dd287d9$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $ec32bf7421075525$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $25bfb6471b658c1b$exports(iteratees, function(iteratee) {
        if ($d9532e5a54ad1ff7$exports(iteratee)) return function(value) {
            return $b23f68dd51fe151f$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $0b94856e5f4b18a8$exports
    ];
    var index = -1;
    iteratees = $25bfb6471b658c1b$exports(iteratees, $ea802b0cb4d1e78d$exports($86a15e1908191355$exports));
    var result = $548405dd1b13d75f$exports(collection, function(value, key, collection) {
        var criteria = $25bfb6471b658c1b$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return $6a6f640b5d98fff6$exports(result, function(object, other) {
        return $1c10279d1dd287d9$exports(object, other, orders);
    });
}
$ec32bf7421075525$exports = $ec32bf7421075525$var$baseOrderBy;


var $d2822d2d9ac7eaa4$exports = {};

var $fa26b78d2b4a9751$exports = {};
var $ed92a5915968e5ec$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $ed92a5915968e5ec$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$ed92a5915968e5ec$exports = $ed92a5915968e5ec$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $fa26b78d2b4a9751$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $fa26b78d2b4a9751$var$overRest(func, start, transform) {
    start = $fa26b78d2b4a9751$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $fa26b78d2b4a9751$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $ed92a5915968e5ec$exports(func, this, otherArgs);
    };
}
$fa26b78d2b4a9751$exports = $fa26b78d2b4a9751$var$overRest;


var $4909f269f7404306$exports = {};
var $424cef58b64e814b$exports = {};
var $292c91880eca2835$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $292c91880eca2835$var$constant(value) {
    return function() {
        return value;
    };
}
$292c91880eca2835$exports = $292c91880eca2835$var$constant;


var $7f15d9ea84166ccf$exports = {};

var $7f15d9ea84166ccf$var$defineProperty = function() {
    try {
        var func = $6f25eda1013f8320$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$7f15d9ea84166ccf$exports = $7f15d9ea84166ccf$var$defineProperty;



/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $424cef58b64e814b$var$baseSetToString = !$7f15d9ea84166ccf$exports ? $0b94856e5f4b18a8$exports : function(func, string) {
    return $7f15d9ea84166ccf$exports(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $292c91880eca2835$exports(string),
        "writable": true
    });
};
$424cef58b64e814b$exports = $424cef58b64e814b$var$baseSetToString;


var $c42450f4e713e212$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $c42450f4e713e212$var$HOT_COUNT = 800, $c42450f4e713e212$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c42450f4e713e212$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $c42450f4e713e212$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $c42450f4e713e212$var$nativeNow(), remaining = $c42450f4e713e212$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $c42450f4e713e212$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$c42450f4e713e212$exports = $c42450f4e713e212$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $4909f269f7404306$var$setToString = $c42450f4e713e212$exports($424cef58b64e814b$exports);
$4909f269f7404306$exports = $4909f269f7404306$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $d2822d2d9ac7eaa4$var$baseRest(func, start) {
    return $4909f269f7404306$exports($fa26b78d2b4a9751$exports(func, start, $0b94856e5f4b18a8$exports), func + "");
}
$d2822d2d9ac7eaa4$exports = $d2822d2d9ac7eaa4$var$baseRest;


var $31c3fe36697999ed$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $31c3fe36697999ed$var$isIterateeCall(value, index, object) {
    if (!$6fd646b25232d34a$exports(object)) return false;
    var type = typeof index;
    if (type == "number" ? $8fd0dcf5a894c319$exports(object) && $a66ac305766babbb$exports(index, object.length) : type == "string" && index in object) return $d6f8ba4f5fc9d103$exports(object[index], value);
    return false;
}
$31c3fe36697999ed$exports = $31c3fe36697999ed$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $024dd103a6f5c4c7$var$sortBy = $d2822d2d9ac7eaa4$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $31c3fe36697999ed$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $31c3fe36697999ed$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $ec32bf7421075525$exports(collection, $d42e70f9e2c218bc$exports(iteratees, 1), []);
});
$024dd103a6f5c4c7$exports = $024dd103a6f5c4c7$var$sortBy;


var $0363e4b2d3630833$exports = {};
(function(globalScope) {
    "use strict";
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", exponentOutOfRange = decimalError + "Exponent out of range: ", mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + "NaN");
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + "NaN");
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + "NaN");
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != "9999") break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + "Infinity");
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + "NaN");
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + "";
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + "";
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return "0";
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + "Division by zero");
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + "LN10 precision limit exceeded");
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = "";
        for(; k--;)zs += "0";
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor("0." + c);
                e++;
            } else x = new Ctor(c0 + "." + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + "");
            x = ln(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += "0";
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + "." + str.slice(1);
            str = str + (e < 0 ? "e" : "e+") + e;
        } else if (e < 0) {
            str = "0." + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + "." + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += ".";
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? "-" + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === "number") {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== "string") throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                "precision",
                "rounding",
                "toExpNeg",
                "toExpPos",
                "LN10"
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
        var i, p, v, ps = [
            "precision",
            1,
            MAX_DIGITS,
            "rounding",
            0,
            8,
            "toExpNeg",
            -1 / 0,
            0,
            "toExpPos",
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ": " + v);
        }
        if ((v = obj[p = "LN10"]) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ": " + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal["default"] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return Decimal;
    });
    else if (0, $0363e4b2d3630833$exports) $0363e4b2d3630833$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != "undefined" && self && self.self == self ? self : Function("return this")();
        globalScope.Decimal = Decimal;
    }
})($0363e4b2d3630833$exports);


function $68b3f1d150044250$var$_toConsumableArray(arr) {
    return $68b3f1d150044250$var$_arrayWithoutHoles(arr) || $68b3f1d150044250$var$_iterableToArray(arr) || $68b3f1d150044250$var$_unsupportedIterableToArray(arr) || $68b3f1d150044250$var$_nonIterableSpread();
}
function $68b3f1d150044250$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $68b3f1d150044250$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $68b3f1d150044250$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $68b3f1d150044250$var$_arrayLikeToArray(o, minLen);
}
function $68b3f1d150044250$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $68b3f1d150044250$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $68b3f1d150044250$var$_arrayLikeToArray(arr);
}
function $68b3f1d150044250$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $68b3f1d150044250$var$identity = function identity(i) {
    return i;
};
var $68b3f1d150044250$export$ca73b6d700d0505 = {
    "@@functional/placeholder": true
};
var $68b3f1d150044250$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $68b3f1d150044250$export$ca73b6d700d0505;
};
var $68b3f1d150044250$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $68b3f1d150044250$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $68b3f1d150044250$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $68b3f1d150044250$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $68b3f1d150044250$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $68b3f1d150044250$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $68b3f1d150044250$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $68b3f1d150044250$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $68b3f1d150044250$export$c3095a23b368d1f2 = function curry(fn) {
    return $68b3f1d150044250$var$curryN(fn.length, fn);
};
var $68b3f1d150044250$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $68b3f1d150044250$export$871de8747c9eaa88 = $68b3f1d150044250$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $68b3f1d150044250$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $68b3f1d150044250$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $68b3f1d150044250$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split("").reverse.join("");
};
var $68b3f1d150044250$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $38a539900f306f16$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $38a539900f306f16$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $38a539900f306f16$var$interpolateNumber = (0, $68b3f1d150044250$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $38a539900f306f16$var$uninterpolateNumber = (0, $68b3f1d150044250$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $38a539900f306f16$var$uninterpolateTruncation = (0, $68b3f1d150044250$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $38a539900f306f16$export$2e2bcd8739ae039 = {
    rangeStep: $38a539900f306f16$var$rangeStep,
    getDigitCount: $38a539900f306f16$var$getDigitCount,
    interpolateNumber: $38a539900f306f16$var$interpolateNumber,
    uninterpolateNumber: $38a539900f306f16$var$uninterpolateNumber,
    uninterpolateTruncation: $38a539900f306f16$var$uninterpolateTruncation
};


function $2d347c72887f1b35$var$_toConsumableArray(arr) {
    return $2d347c72887f1b35$var$_arrayWithoutHoles(arr) || $2d347c72887f1b35$var$_iterableToArray(arr) || $2d347c72887f1b35$var$_unsupportedIterableToArray(arr) || $2d347c72887f1b35$var$_nonIterableSpread();
}
function $2d347c72887f1b35$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2d347c72887f1b35$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $2d347c72887f1b35$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $2d347c72887f1b35$var$_arrayLikeToArray(arr);
}
function $2d347c72887f1b35$var$_slicedToArray(arr, i) {
    return $2d347c72887f1b35$var$_arrayWithHoles(arr) || $2d347c72887f1b35$var$_iterableToArrayLimit(arr, i) || $2d347c72887f1b35$var$_unsupportedIterableToArray(arr, i) || $2d347c72887f1b35$var$_nonIterableRest();
}
function $2d347c72887f1b35$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2d347c72887f1b35$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2d347c72887f1b35$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2d347c72887f1b35$var$_arrayLikeToArray(o, minLen);
}
function $2d347c72887f1b35$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2d347c72887f1b35$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $2d347c72887f1b35$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $2d347c72887f1b35$var$getValidInterval(_ref) {
    var _ref2 = $2d347c72887f1b35$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $2d347c72887f1b35$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(0);
    var digitCount = (0, $38a539900f306f16$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $2d347c72887f1b35$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(10).pow((0, $38a539900f306f16$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $68b3f1d150044250$export$f672e0b6f7222cd7)((0, $68b3f1d150044250$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $68b3f1d150044250$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $2d347c72887f1b35$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $2d347c72887f1b35$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $2d347c72887f1b35$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $2d347c72887f1b35$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $2d347c72887f1b35$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $2d347c72887f1b35$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $2d347c72887f1b35$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($2d347c72887f1b35$var$_toConsumableArray((0, $68b3f1d150044250$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($2d347c72887f1b35$var$_toConsumableArray((0, $68b3f1d150044250$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $68b3f1d150044250$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $2d347c72887f1b35$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $2d347c72887f1b35$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $38a539900f306f16$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $68b3f1d150044250$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $2d347c72887f1b35$var$getTickValuesFn(_ref5) {
    var _ref6 = $2d347c72887f1b35$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $2d347c72887f1b35$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $2d347c72887f1b35$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $2d347c72887f1b35$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $2d347c72887f1b35$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $68b3f1d150044250$export$f672e0b6f7222cd7)((0, $68b3f1d150044250$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(n).mul(step)).toNumber();
    }), (0, $68b3f1d150044250$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $68b3f1d150044250$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $2d347c72887f1b35$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $2d347c72887f1b35$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $2d347c72887f1b35$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $2d347c72887f1b35$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $2d347c72887f1b35$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($2d347c72887f1b35$var$_toConsumableArray((0, $38a539900f306f16$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($0363e4b2d3630833$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $68b3f1d150044250$export$66c1ae025e96b4bc)(values) : values;
}
var $2d347c72887f1b35$export$b84e75ccbfe6a612 = (0, $68b3f1d150044250$export$fc10aeed3a532e2a)($2d347c72887f1b35$var$getNiceTickValuesFn);
var $2d347c72887f1b35$export$4cc7a216492b1f53 = (0, $68b3f1d150044250$export$fc10aeed3a532e2a)($2d347c72887f1b35$var$getTickValuesFn);
var $2d347c72887f1b35$export$e9d28da780436e98 = (0, $68b3f1d150044250$export$fc10aeed3a532e2a)($2d347c72887f1b35$var$getTickValuesFixedDomainFn);





var $fgmOP = parcelRequire("fgmOP");
var $157ae7827df642c9$var$isProduction = true;
var $157ae7827df642c9$var$prefix = "Invariant failed";
function $157ae7827df642c9$export$2e2bcd8739ae039(condition, message) {
    if (condition) return;
    if ($157ae7827df642c9$var$isProduction) throw new Error($157ae7827df642c9$var$prefix);
    var provided = typeof message === "function" ? message() : message;
    var value = provided ? "".concat($157ae7827df642c9$var$prefix, ": ").concat(provided) : $157ae7827df642c9$var$prefix;
    throw new Error(value);
}



var $fgmOP = parcelRequire("fgmOP");
function $ea61c8427271ba9b$var$r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = $ea61c8427271ba9b$var$r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function $ea61c8427271ba9b$export$4f5d2d50c9deca37() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = $ea61c8427271ba9b$var$r(e)) && (n && (n += " "), n += t);
    return n;
}
var $ea61c8427271ba9b$export$2e2bcd8739ae039 = $ea61c8427271ba9b$export$4f5d2d50c9deca37;



var $c94f1401bbf8ca2c$var$_excluded = [
    "children",
    "className"
];
function $c94f1401bbf8ca2c$var$_extends() {
    $c94f1401bbf8ca2c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c94f1401bbf8ca2c$var$_extends.apply(this, arguments);
}
function $c94f1401bbf8ca2c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c94f1401bbf8ca2c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c94f1401bbf8ca2c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $c94f1401bbf8ca2c$export$936d0764594b6eb3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).forwardRef(function(props, ref) {
    var children = props.children, className = props.className, others = $c94f1401bbf8ca2c$var$_objectWithoutProperties(props, $c94f1401bbf8ca2c$var$_excluded);
    var layerClass = (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-layer", className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("g", $c94f1401bbf8ca2c$var$_extends({
        className: layerClass
    }, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(others, true), {
        ref: ref
    }), children);
});



var $f95da76a14a4e49e$var$_excluded = [
    "offset",
    "layout",
    "width",
    "dataKey",
    "data",
    "dataPointFormatter",
    "xAxis",
    "yAxis"
];
function $f95da76a14a4e49e$var$_extends() {
    $f95da76a14a4e49e$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f95da76a14a4e49e$var$_extends.apply(this, arguments);
}
function $f95da76a14a4e49e$var$_slicedToArray(arr, i) {
    return $f95da76a14a4e49e$var$_arrayWithHoles(arr) || $f95da76a14a4e49e$var$_iterableToArrayLimit(arr, i) || $f95da76a14a4e49e$var$_unsupportedIterableToArray(arr, i) || $f95da76a14a4e49e$var$_nonIterableRest();
}
function $f95da76a14a4e49e$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f95da76a14a4e49e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f95da76a14a4e49e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f95da76a14a4e49e$var$_arrayLikeToArray(o, minLen);
}
function $f95da76a14a4e49e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f95da76a14a4e49e$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $f95da76a14a4e49e$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $f95da76a14a4e49e$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $f95da76a14a4e49e$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $f95da76a14a4e49e$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $f95da76a14a4e49e$export$4f4d7676bdf949e5(props) {
    var offset = props.offset, layout = props.layout, width = props.width, dataKey = props.dataKey, data = props.data, dataPointFormatter = props.dataPointFormatter, xAxis = props.xAxis, yAxis = props.yAxis, others = $f95da76a14a4e49e$var$_objectWithoutProperties(props, $f95da76a14a4e49e$var$_excluded);
    var svgProps = (0, $fa0843e4e64def56$export$d697c39a2985a4c)(others, false);
    !!(props.direction === "x" && xAxis.type !== "number") && (0, $157ae7827df642c9$export$2e2bcd8739ae039)(false);
    var errorBars = data.map(function(entry) {
        var _dataPointFormatter = dataPointFormatter(entry, dataKey), x = _dataPointFormatter.x, y = _dataPointFormatter.y, value = _dataPointFormatter.value, errorVal = _dataPointFormatter.errorVal;
        if (!errorVal) return null;
        var lineCoordinates = [];
        var lowBound, highBound;
        if (Array.isArray(errorVal)) {
            var _errorVal = $f95da76a14a4e49e$var$_slicedToArray(errorVal, 2);
            lowBound = _errorVal[0];
            highBound = _errorVal[1];
        } else lowBound = highBound = errorVal;
        if (layout === "vertical") {
            // error bar for horizontal charts, the y is fixed, x is a range value
            var scale = xAxis.scale;
            var yMid = y + offset;
            var yMin = yMid + width;
            var yMax = yMid - width;
            var xMin = scale(value - lowBound);
            var xMax = scale(value + highBound);
            // the right line of |--|
            lineCoordinates.push({
                x1: xMax,
                y1: yMin,
                x2: xMax,
                y2: yMax
            });
            // the middle line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMid,
                x2: xMax,
                y2: yMid
            });
            // the left line of |--|
            lineCoordinates.push({
                x1: xMin,
                y1: yMin,
                x2: xMin,
                y2: yMax
            });
        } else if (layout === "horizontal") {
            // error bar for horizontal charts, the x is fixed, y is a range value
            var _scale = yAxis.scale;
            var xMid = x + offset;
            var _xMin = xMid - width;
            var _xMax = xMid + width;
            var _yMin = _scale(value - lowBound);
            var _yMax = _scale(value + highBound);
            // the top line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMax,
                x2: _xMax,
                y2: _yMax
            });
            // the middle line
            lineCoordinates.push({
                x1: xMid,
                y1: _yMin,
                x2: xMid,
                y2: _yMax
            });
            // the bottom line
            lineCoordinates.push({
                x1: _xMin,
                y1: _yMin,
                x2: _xMax,
                y2: _yMin
            });
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), $f95da76a14a4e49e$var$_extends({
            className: "recharts-errorBar",
            key: "bar-".concat(lineCoordinates.map(function(c) {
                return "".concat(c.x1, "-").concat(c.x2, "-").concat(c.y1, "-").concat(c.y2);
            }))
        }, svgProps), lineCoordinates.map(function(coordinates) {
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("line", $f95da76a14a4e49e$var$_extends({}, coordinates, {
                key: "line-".concat(coordinates.x1, "-").concat(coordinates.x2, "-").concat(coordinates.y1, "-").concat(coordinates.y2)
            }));
        }));
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), {
        className: "recharts-errorBars"
    }, errorBars);
}
$f95da76a14a4e49e$export$4f4d7676bdf949e5.defaultProps = {
    stroke: "black",
    strokeWidth: 1.5,
    width: 5,
    offset: 0,
    layout: "horizontal"
};
$f95da76a14a4e49e$export$4f4d7676bdf949e5.displayName = "ErrorBar";





var $fgmOP = parcelRequire("fgmOP");

var $fgmOP = parcelRequire("fgmOP");




var $fgmOP = parcelRequire("fgmOP");


var $2a6ed8f50f2d8df8$var$_excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function $2a6ed8f50f2d8df8$var$_extends() {
    $2a6ed8f50f2d8df8$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2a6ed8f50f2d8df8$var$_extends.apply(this, arguments);
}
function $2a6ed8f50f2d8df8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $2a6ed8f50f2d8df8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $2a6ed8f50f2d8df8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $2a6ed8f50f2d8df8$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, title = props.title, desc = props.desc, others = $2a6ed8f50f2d8df8$var$_objectWithoutProperties(props, $2a6ed8f50f2d8df8$var$_excluded);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-surface", className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("svg", $2a6ed8f50f2d8df8$var$_extends({}, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(others, true, "svg"), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("title", null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("desc", null, desc), children);
}



var $fgmOP = parcelRequire("fgmOP");




function $0573268efb13f9bd$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0573268efb13f9bd$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0573268efb13f9bd$var$_typeof(o);
}
var $0573268efb13f9bd$var$_excluded = [
    "type",
    "size",
    "sizeType"
];
function $0573268efb13f9bd$var$_extends() {
    $0573268efb13f9bd$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $0573268efb13f9bd$var$_extends.apply(this, arguments);
}
function $0573268efb13f9bd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0573268efb13f9bd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0573268efb13f9bd$var$ownKeys(Object(t), !0).forEach(function(r) {
            $0573268efb13f9bd$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0573268efb13f9bd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0573268efb13f9bd$var$_defineProperty(obj, key, value) {
    key = $0573268efb13f9bd$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0573268efb13f9bd$var$_toPropertyKey(t) {
    var i = $0573268efb13f9bd$var$_toPrimitive(t, "string");
    return "symbol" == $0573268efb13f9bd$var$_typeof(i) ? i : String(i);
}
function $0573268efb13f9bd$var$_toPrimitive(t, r) {
    if ("object" != $0573268efb13f9bd$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0573268efb13f9bd$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $0573268efb13f9bd$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $0573268efb13f9bd$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $0573268efb13f9bd$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $0573268efb13f9bd$var$symbolFactories = {
    symbolCircle: (0, $61471ee91debe026$exports.symbolCircle),
    symbolCross: (0, $61471ee91debe026$exports.symbolCross),
    symbolDiamond: (0, $61471ee91debe026$exports.symbolDiamond),
    symbolSquare: (0, $61471ee91debe026$exports.symbolSquare),
    symbolStar: (0, $61471ee91debe026$exports.symbolStar),
    symbolTriangle: (0, $61471ee91debe026$exports.symbolTriangle),
    symbolWye: (0, $61471ee91debe026$exports.symbolWye)
};
var $0573268efb13f9bd$var$RADIAN = Math.PI / 180;
var $0573268efb13f9bd$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($ad0c997ad9c80793$exports)))(type));
    return $0573268efb13f9bd$var$symbolFactories[name] || (0, $61471ee91debe026$exports.symbolCircle);
};
var $0573268efb13f9bd$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === "area") return size;
    switch(type){
        case "cross":
            return 5 * size * size / 9;
        case "diamond":
            return 0.5 * size * size / Math.sqrt(3);
        case "square":
            return size * size;
        case "star":
            var angle = 18 * $0573268efb13f9bd$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case "triangle":
            return Math.sqrt(3) * size * size / 4;
        case "wye":
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $0573268efb13f9bd$var$registerSymbol = function registerSymbol(key, factory) {
    $0573268efb13f9bd$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($ad0c997ad9c80793$exports)))(key))] = factory;
};
var $0573268efb13f9bd$export$fa456266707bf4e4 = function Symbols(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "circle" : _ref$type, _ref$size = _ref.size, size = _ref$size === void 0 ? 64 : _ref$size, _ref$sizeType = _ref.sizeType, sizeType = _ref$sizeType === void 0 ? "area" : _ref$sizeType, rest = $0573268efb13f9bd$var$_objectWithoutProperties(_ref, $0573268efb13f9bd$var$_excluded);
    var props = $0573268efb13f9bd$var$_objectSpread($0573268efb13f9bd$var$_objectSpread({}, rest), {}, {
        type: type,
        size: size,
        sizeType: sizeType
    });
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = function getPath() {
        var symbolFactory = $0573268efb13f9bd$var$getSymbolFactory(type);
        var symbol = (0, $61471ee91debe026$exports.symbol)().type(symbolFactory).size($0573268efb13f9bd$var$calculateAreaSize(size, sizeType, type));
        return symbol();
    };
    var className = props.className, cx = props.cx, cy = props.cy;
    var filteredProps = (0, $fa0843e4e64def56$export$d697c39a2985a4c)(props, true);
    if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", $0573268efb13f9bd$var$_extends({}, filteredProps, {
        className: (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-symbols", className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
$0573268efb13f9bd$export$fa456266707bf4e4.registerSymbol = $0573268efb13f9bd$var$registerSymbol;



function $2e70184554facfa5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2e70184554facfa5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2e70184554facfa5$var$_typeof(o);
}
function $2e70184554facfa5$var$_extends() {
    $2e70184554facfa5$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2e70184554facfa5$var$_extends.apply(this, arguments);
}
function $2e70184554facfa5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2e70184554facfa5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2e70184554facfa5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2e70184554facfa5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2e70184554facfa5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2e70184554facfa5$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2e70184554facfa5$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $2e70184554facfa5$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $2e70184554facfa5$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2e70184554facfa5$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2e70184554facfa5$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $2e70184554facfa5$var$_callSuper(t, o, e) {
    return o = $2e70184554facfa5$var$_getPrototypeOf(o), $2e70184554facfa5$var$_possibleConstructorReturn(t, $2e70184554facfa5$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $2e70184554facfa5$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $2e70184554facfa5$var$_possibleConstructorReturn(self, call) {
    if (call && ($2e70184554facfa5$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $2e70184554facfa5$var$_assertThisInitialized(self);
}
function $2e70184554facfa5$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2e70184554facfa5$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2e70184554facfa5$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $2e70184554facfa5$var$_getPrototypeOf(o) {
    $2e70184554facfa5$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2e70184554facfa5$var$_getPrototypeOf(o);
}
function $2e70184554facfa5$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $2e70184554facfa5$var$_setPrototypeOf(subClass, superClass);
}
function $2e70184554facfa5$var$_setPrototypeOf(o, p) {
    $2e70184554facfa5$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2e70184554facfa5$var$_setPrototypeOf(o, p);
}
function $2e70184554facfa5$var$_defineProperty(obj, key, value) {
    key = $2e70184554facfa5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2e70184554facfa5$var$_toPropertyKey(t) {
    var i = $2e70184554facfa5$var$_toPrimitive(t, "string");
    return "symbol" == $2e70184554facfa5$var$_typeof(i) ? i : String(i);
}
function $2e70184554facfa5$var$_toPrimitive(t, r) {
    if ("object" != $2e70184554facfa5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2e70184554facfa5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2e70184554facfa5$var$SIZE = 32;
var $2e70184554facfa5$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    $2e70184554facfa5$var$_inherits(DefaultLegendContent, _PureComponent);
    function DefaultLegendContent() {
        $2e70184554facfa5$var$_classCallCheck(this, DefaultLegendContent);
        return $2e70184554facfa5$var$_callSuper(this, DefaultLegendContent, arguments);
    }
    $2e70184554facfa5$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $2e70184554facfa5$var$SIZE / 2;
                var sixthSize = $2e70184554facfa5$var$SIZE / 6;
                var thirdSize = $2e70184554facfa5$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === "plainline") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $2e70184554facfa5$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === "line") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($2e70184554facfa5$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === "rect") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($2e70184554facfa5$var$SIZE / 8, "h").concat($2e70184554facfa5$var$SIZE, "v").concat($2e70184554facfa5$var$SIZE * 3 / 4, "h").concat(-$2e70184554facfa5$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).isValidElement(data.legendIcon)) {
                    var iconProps = $2e70184554facfa5$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $0573268efb13f9bd$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $2e70184554facfa5$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $2e70184554facfa5$var$SIZE,
                    height: $2e70184554facfa5$var$SIZE
                };
                var itemStyle = {
                    display: layout === "horizontal" ? "inline-block" : "block",
                    marginRight: 10
                };
                var svgStyle = {
                    display: "inline-block",
                    verticalAlign: "middle",
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)($2e70184554facfa5$var$_defineProperty($2e70184554facfa5$var$_defineProperty({
                        "recharts-legend-item": true
                    }, "legend-item-".concat(i), true), "inactive", entry.inactive));
                    if (entry.type === "none") return null;
                    // Do not render entry.value as functions. Always require static string properties.
                    var entryValue = !(0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(entry.value) ? entry.value : null;
                    (0, $b8908dd384eb6989$export$c106dd0671a0fc2d)(!(0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(entry.value), 'The name property is also required when using a function for the dataKey of a chart\'s cartesian components. Ex: <Bar name="Name of my Data"/>' // eslint-disable-line max-len
                    );
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("li", $2e70184554facfa5$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i)
                    }, (0, $9fee8beacafd8fde$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $2a6ed8f50f2d8df8$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entryValue, entry, i) : entryValue));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === "horizontal" ? align : "left"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
    return DefaultLegendContent;
}((0, $fgmOP.PureComponent));
$2e70184554facfa5$var$_defineProperty($2e70184554facfa5$export$99f8d96ed0cededa, "displayName", "Legend");
$2e70184554facfa5$var$_defineProperty($2e70184554facfa5$export$99f8d96ed0cededa, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "middle",
    inactiveColor: "#ccc"
});



var $d2ebef8f70eaef80$exports = {};

var $ef02f889f136723a$exports = {};

var $accf976a7f8bfd26$exports = {};
var $0ed4f5855fb52615$exports = {};
var $7b111fc9a3cf35f1$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $7b111fc9a3cf35f1$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$7b111fc9a3cf35f1$exports = $7b111fc9a3cf35f1$var$baseFindIndex;


var $504da3ae907829b0$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $504da3ae907829b0$var$baseIsNaN(value) {
    return value !== value;
}
$504da3ae907829b0$exports = $504da3ae907829b0$var$baseIsNaN;


var $c0d59a3970e0c14a$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $c0d59a3970e0c14a$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$c0d59a3970e0c14a$exports = $c0d59a3970e0c14a$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $0ed4f5855fb52615$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $c0d59a3970e0c14a$exports(array, value, fromIndex) : $7b111fc9a3cf35f1$exports(array, $504da3ae907829b0$exports, fromIndex);
}
$0ed4f5855fb52615$exports = $0ed4f5855fb52615$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $accf976a7f8bfd26$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $0ed4f5855fb52615$exports(array, value, 0) > -1;
}
$accf976a7f8bfd26$exports = $accf976a7f8bfd26$var$arrayIncludes;


var $31bdeaf92463dc3c$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $31bdeaf92463dc3c$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$31bdeaf92463dc3c$exports = $31bdeaf92463dc3c$var$arrayIncludesWith;



var $c8ec93a9c3aaf899$exports = {};

var $137a8625b40e5e83$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $137a8625b40e5e83$var$noop() {
// No operation performed.
}
$137a8625b40e5e83$exports = $137a8625b40e5e83$var$noop;



/** Used as references for various `Number` constants. */ var $c8ec93a9c3aaf899$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $c8ec93a9c3aaf899$var$createSet = !($0be913e5a9ad9a84$exports && 1 / $1c815f34f571a65e$exports(new $0be913e5a9ad9a84$exports([
    ,
    -0
]))[1] == $c8ec93a9c3aaf899$var$INFINITY) ? $137a8625b40e5e83$exports : function(values) {
    return new $0be913e5a9ad9a84$exports(values);
};
$c8ec93a9c3aaf899$exports = $c8ec93a9c3aaf899$var$createSet;



/** Used as the size to enable large array optimizations. */ var $ef02f889f136723a$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $ef02f889f136723a$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $accf976a7f8bfd26$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $31bdeaf92463dc3c$exports;
    } else if (length >= $ef02f889f136723a$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $c8ec93a9c3aaf899$exports(array);
        if (set) return $1c815f34f571a65e$exports(set);
        isCommon = false;
        includes = $f1dd97b14d1aff02$exports;
        seen = new $eba3361229eca1af$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$ef02f889f136723a$exports = $ef02f889f136723a$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $d2ebef8f70eaef80$var$uniqBy(array, iteratee) {
    return array && array.length ? $ef02f889f136723a$exports(array, $86a15e1908191355$exports(iteratee, 2)) : [];
}
$d2ebef8f70eaef80$exports = $d2ebef8f70eaef80$var$uniqBy;



function $4c9946dac4cf84e2$export$b67e33c2fb1535fa(payload, option, defaultUniqBy) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($d2ebef8f70eaef80$exports)))(payload, defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($d2ebef8f70eaef80$exports)))(payload, option);
    return payload;
}


function $c217c6640e254c03$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c217c6640e254c03$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c217c6640e254c03$var$_typeof(o);
}
var $c217c6640e254c03$var$_excluded = [
    "ref"
];
function $c217c6640e254c03$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c217c6640e254c03$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c217c6640e254c03$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c217c6640e254c03$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c217c6640e254c03$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c217c6640e254c03$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c217c6640e254c03$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c217c6640e254c03$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c217c6640e254c03$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c217c6640e254c03$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c217c6640e254c03$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c217c6640e254c03$var$_callSuper(t, o, e) {
    return o = $c217c6640e254c03$var$_getPrototypeOf(o), $c217c6640e254c03$var$_possibleConstructorReturn(t, $c217c6640e254c03$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $c217c6640e254c03$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $c217c6640e254c03$var$_possibleConstructorReturn(self, call) {
    if (call && ($c217c6640e254c03$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c217c6640e254c03$var$_assertThisInitialized(self);
}
function $c217c6640e254c03$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c217c6640e254c03$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c217c6640e254c03$var$_getPrototypeOf(o) {
    $c217c6640e254c03$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c217c6640e254c03$var$_getPrototypeOf(o);
}
function $c217c6640e254c03$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c217c6640e254c03$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c217c6640e254c03$var$_setPrototypeOf(subClass, superClass);
}
function $c217c6640e254c03$var$_setPrototypeOf(o, p) {
    $c217c6640e254c03$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c217c6640e254c03$var$_setPrototypeOf(o, p);
}
function $c217c6640e254c03$var$_defineProperty(obj, key, value) {
    key = $c217c6640e254c03$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c217c6640e254c03$var$_toPropertyKey(t) {
    var i = $c217c6640e254c03$var$_toPrimitive(t, "string");
    return "symbol" == $c217c6640e254c03$var$_typeof(i) ? i : String(i);
}
function $c217c6640e254c03$var$_toPrimitive(t, r) {
    if ("object" != $c217c6640e254c03$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c217c6640e254c03$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $c217c6640e254c03$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c217c6640e254c03$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c217c6640e254c03$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c217c6640e254c03$var$defaultUniqBy(entry) {
    return entry.value;
}
function $c217c6640e254c03$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).cloneElement(content, props);
    if (typeof content === "function") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(content, props);
    var ref = props.ref, otherProps = $c217c6640e254c03$var$_objectWithoutProperties(props, $c217c6640e254c03$var$_excluded);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $2e70184554facfa5$export$99f8d96ed0cededa), otherProps);
}
var $c217c6640e254c03$var$EPS = 1;
var $c217c6640e254c03$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    $c217c6640e254c03$var$_inherits(Legend, _PureComponent);
    function Legend() {
        var _this;
        $c217c6640e254c03$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $c217c6640e254c03$var$_callSuper(this, Legend, [].concat(args));
        $c217c6640e254c03$var$_defineProperty($c217c6640e254c03$var$_assertThisInitialized(_this), "lastBoundingBox", {
            width: -1,
            height: -1
        });
        return _this;
    }
    $c217c6640e254c03$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var _box = this.wrapperNode.getBoundingClientRect();
                    _box.height = this.wrapperNode.offsetHeight;
                    _box.width = this.wrapperNode.offsetWidth;
                    return _box;
                }
                return null;
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var onBBoxUpdate = this.props.onBBoxUpdate;
                var box = this.getBBox();
                if (box) {
                    if (Math.abs(box.width - this.lastBoundingBox.width) > $c217c6640e254c03$var$EPS || Math.abs(box.height - this.lastBoundingBox.height) > $c217c6640e254c03$var$EPS) {
                        this.lastBoundingBox.width = box.width;
                        this.lastBoundingBox.height = box.height;
                        if (onBBoxUpdate) onBBoxUpdate(box);
                    }
                } else if (this.lastBoundingBox.width !== -1 || this.lastBoundingBox.height !== -1) {
                    this.lastBoundingBox.width = -1;
                    this.lastBoundingBox.height = -1;
                    if (onBBoxUpdate) onBBoxUpdate(null);
                }
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                if (this.lastBoundingBox.width >= 0 && this.lastBoundingBox.height >= 0) return $c217c6640e254c03$var$_objectSpread({}, this.lastBoundingBox);
                return {
                    width: 0,
                    height: 0
                };
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === "center" && layout === "vertical") {
                        var _box2 = this.getBBoxSnapshot();
                        hPos = {
                            left: ((chartWidth || 0) - _box2.width) / 2
                        };
                    } else hPos = align === "right" ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === "middle") {
                        var _box3 = this.getBBoxSnapshot();
                        vPos = {
                            top: ((chartHeight || 0) - _box3.height) / 2
                        };
                    } else vPos = verticalAlign === "bottom" ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $c217c6640e254c03$var$_objectSpread($c217c6640e254c03$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $c217c6640e254c03$var$_objectSpread($c217c6640e254c03$var$_objectSpread({
                    position: "absolute",
                    width: width || "auto",
                    height: height || "auto"
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $c217c6640e254c03$var$renderContent(content, $c217c6640e254c03$var$_objectSpread($c217c6640e254c03$var$_objectSpread({}, this.props), {}, {
                    payload: (0, $4c9946dac4cf84e2$export$b67e33c2fb1535fa)(payload, payloadUniqBy, $c217c6640e254c03$var$defaultUniqBy)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var layout = item.props.layout;
                if (layout === "vertical" && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === "horizontal") return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
    return Legend;
}((0, $fgmOP.PureComponent));
$c217c6640e254c03$var$_defineProperty($c217c6640e254c03$export$ed247974535929c7, "displayName", "Legend");
$c217c6640e254c03$var$_defineProperty($c217c6640e254c03$export$ed247974535929c7, "defaultProps", {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "bottom"
});




function $c77276502bcbf93e$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c77276502bcbf93e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c77276502bcbf93e$var$_typeof(o);
}
function $c77276502bcbf93e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c77276502bcbf93e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c77276502bcbf93e$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c77276502bcbf93e$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c77276502bcbf93e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c77276502bcbf93e$var$_defineProperty(obj, key, value) {
    key = $c77276502bcbf93e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c77276502bcbf93e$var$_toPropertyKey(t) {
    var i = $c77276502bcbf93e$var$_toPrimitive(t, "string");
    return "symbol" == $c77276502bcbf93e$var$_typeof(i) ? i : String(i);
}
function $c77276502bcbf93e$var$_toPrimitive(t, r) {
    if ("object" != $c77276502bcbf93e$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c77276502bcbf93e$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $c77276502bcbf93e$export$8f9424d123c36aa = function getLegendProps(_ref) {
    var children = _ref.children, formattedGraphicalItems = _ref.formattedGraphicalItems, legendWidth = _ref.legendWidth, legendContent = _ref.legendContent;
    var legendItem = (0, $fa0843e4e64def56$export$64c61536a2b72e0f)(children, (0, $c217c6640e254c03$export$ed247974535929c7));
    if (!legendItem) return null;
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === "children") legendData = (formattedGraphicalItems || []).reduce(function(result, _ref2) {
        var item = _ref2.item, props = _ref2.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref3) {
        var item = _ref3.item;
        var _item$props = item.props, dataKey = _item$props.dataKey, name = _item$props.name, legendType = _item$props.legendType, hide = _item$props.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendItem.props.iconType || legendType || "square",
            color: (0, $467312b86c271c9f$export$ec6cab5a7a3b93bf)(item),
            value: name || dataKey,
            // @ts-expect-error property strokeDasharray is required in Payload but optional in props
            payload: item.props
        };
    });
    return $c77276502bcbf93e$var$_objectSpread($c77276502bcbf93e$var$_objectSpread($c77276502bcbf93e$var$_objectSpread({}, legendItem.props), (0, $c217c6640e254c03$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};


function $467312b86c271c9f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $467312b86c271c9f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $467312b86c271c9f$var$_typeof(o);
}
function $467312b86c271c9f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $467312b86c271c9f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $467312b86c271c9f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $467312b86c271c9f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $467312b86c271c9f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $467312b86c271c9f$var$_defineProperty(obj, key, value) {
    key = $467312b86c271c9f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $467312b86c271c9f$var$_toPropertyKey(t) {
    var i = $467312b86c271c9f$var$_toPrimitive(t, "string");
    return "symbol" == $467312b86c271c9f$var$_typeof(i) ? i : String(i);
}
function $467312b86c271c9f$var$_toPrimitive(t, r) {
    if ("object" != $467312b86c271c9f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $467312b86c271c9f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $467312b86c271c9f$var$_toConsumableArray(arr) {
    return $467312b86c271c9f$var$_arrayWithoutHoles(arr) || $467312b86c271c9f$var$_iterableToArray(arr) || $467312b86c271c9f$var$_unsupportedIterableToArray(arr) || $467312b86c271c9f$var$_nonIterableSpread();
}
function $467312b86c271c9f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $467312b86c271c9f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $467312b86c271c9f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $467312b86c271c9f$var$_arrayLikeToArray(o, minLen);
}
function $467312b86c271c9f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $467312b86c271c9f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $467312b86c271c9f$var$_arrayLikeToArray(arr);
}
function $467312b86c271c9f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $467312b86c271c9f$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(dataKey)) return defaultValue;
    if ((0, $e6d37abae86076b3$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($d0c0e0e0987fd69b$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $467312b86c271c9f$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($f6ff90adaf97b5d0$exports)))(data, function(entry) {
        return $467312b86c271c9f$export$f97fc4a450f29a(entry, key);
    });
    if (type === "number") {
        // @ts-expect-error parseFloat type only accepts strings
        var domain = flattenData.filter(function(entry) {
            return (0, $e6d37abae86076b3$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($4ba4f43f07120ee1$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($0fbd870e7e2db3ba$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(entry);
    }) : flattenData;
    // Supports x-axis of Date type
    return validateData.map(function(entry) {
        return (0, $e6d37abae86076b3$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : "";
    });
}
var $467312b86c271c9f$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or less ticks ticks then the active tick is at index 0
    if (len <= 1) return 0;
    if (axis && axis.axisType === "angleAxis" && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
        var range = axis.range;
        // ticks are distributed in a circle
        for(var i = 0; i < len; i++){
            var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
            var cur = unsortedTicks[i].coordinate;
            var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
            var sameDirectionCoord = void 0;
            if ((0, $e6d37abae86076b3$export$9d334328eb75e624)(cur - before) !== (0, $e6d37abae86076b3$export$9d334328eb75e624)(after - cur)) {
                var diffInterval = [];
                if ((0, $e6d37abae86076b3$export$9d334328eb75e624)(after - cur) === (0, $e6d37abae86076b3$export$9d334328eb75e624)(range[1] - range[0])) {
                    sameDirectionCoord = after;
                    var curInRange = cur + range[1] - range[0];
                    diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                    diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                } else {
                    sameDirectionCoord = before;
                    var afterInRange = after + range[1] - range[0];
                    diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                    diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                }
                var sameInterval = [
                    Math.min(cur, (sameDirectionCoord + cur) / 2),
                    Math.max(cur, (sameDirectionCoord + cur) / 2)
                ];
                if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                    index = unsortedTicks[i].index;
                    break;
                }
            } else {
                var minValue = Math.min(before, after);
                var maxValue = Math.max(before, after);
                if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                    index = unsortedTicks[i].index;
                    break;
                }
            }
        }
    } else {
        // ticks are distributed in a single direction
        for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
            index = ticks[_i].index;
            break;
        }
    }
    return index;
};
var $467312b86c271c9f$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var _item$props = item.props, stroke = _item$props.stroke, fill = _item$props.fill;
    var result;
    switch(displayName){
        case "Line":
            result = stroke;
            break;
        case "Area":
        case "Radar":
            result = stroke && stroke !== "none" ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $467312b86c271c9f$export$570d306bee26c748 = function getBarSizeList(_ref2) {
    var globalSize = _ref2.barSize, totalSize = _ref2.totalSize, _ref2$stackGroups = _ref2.stackGroups, stackGroups = _ref2$stackGroups === void 0 ? {} : _ref2$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $fa0843e4e64def56$export$be63e0664592e141)(item.type).indexOf("Bar") >= 0;
            });
            if (barItems && barItems.length) {
                var selfSize = barItems[0].props.barSize;
                var cateId = barItems[0].props[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                var barSize = (0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(selfSize) ? globalSize : selfSize;
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(barSize) ? undefined : (0, $e6d37abae86076b3$export$476354dbf49bdff6)(barSize, totalSize, 0)
                });
            }
        }
    }
    return result;
};
var $467312b86c271c9f$export$d36834ecd87f906b = function getBarPosition(_ref3) {
    var barGap = _ref3.barGap, barCategoryGap = _ref3.barCategoryGap, bandSize = _ref3.bandSize, _ref3$sizeList = _ref3.sizeList, sizeList = _ref3$sizeList === void 0 ? [] : _ref3$sizeList, maxBarSize = _ref3.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $e6d37abae86076b3$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result;
    var initialValue = [];
    // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        // @ts-expect-error the type check above does not check for type number explicitly
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newPosition = {
                item: entry.item,
                position: {
                    offset: prev.offset + prev.size + realBarGap,
                    // @ts-expect-error the type check above does not check for type number explicitly
                    size: useFull ? fullBarSize : entry.barSize
                }
            };
            var newRes = [].concat($467312b86c271c9f$var$_toConsumableArray(res), [
                newPosition
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, initialValue);
    } else {
        var _offset = (0, $e6d37abae86076b3$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($467312b86c271c9f$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, initialValue);
    }
    return result;
};
var $467312b86c271c9f$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, _unused, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0);
    var legendProps = (0, $c77276502bcbf93e$export$8f9424d123c36aa)({
        children: children,
        legendWidth: legendWidth
    });
    if (legendProps) {
        var _ref4 = legendBox || {}, boxWidth = _ref4.width, boxHeight = _ref4.height;
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === "vertical" || layout === "horizontal" && verticalAlign === "middle") && align !== "center" && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(offset[align])) return $467312b86c271c9f$var$_objectSpread($467312b86c271c9f$var$_objectSpread({}, offset), {}, $467312b86c271c9f$var$_defineProperty({}, align, offset[align] + (boxWidth || 0)));
        if ((layout === "horizontal" || layout === "vertical" && align === "center") && verticalAlign !== "middle" && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(offset[verticalAlign])) return $467312b86c271c9f$var$_objectSpread($467312b86c271c9f$var$_objectSpread({}, offset), {}, $467312b86c271c9f$var$_defineProperty({}, verticalAlign, offset[verticalAlign] + (boxHeight || 0)));
    }
    return offset;
};
var $467312b86c271c9f$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(axisType)) return true;
    if (layout === "horizontal") return axisType === "yAxis";
    if (layout === "vertical") return axisType === "xAxis";
    if (direction === "x") return axisType === "xAxis";
    if (direction === "y") return axisType === "yAxis";
    return true;
};
var $467312b86c271c9f$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $fa0843e4e64def56$export$fdd5e64c0e8495bb)(children, (0, $f95da76a14a4e49e$export$4f4d7676bdf949e5)).filter(function(errorBarChild) {
        return $467312b86c271c9f$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $467312b86c271c9f$export$f97fc4a450f29a(entry, dataKey);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(entryValue)) return result;
            var mainValue = Array.isArray(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($4ba4f43f07120ee1$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($0fbd870e7e2db3ba$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $467312b86c271c9f$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs(Array.isArray(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs(Array.isArray(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $467312b86c271c9f$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $467312b86c271c9f$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $467312b86c271c9f$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === "number" && dataKey) return $467312b86c271c9f$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $467312b86c271c9f$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $467312b86c271c9f$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === "number") // Calculate the domain of number axis
    return domains.reduce(// @ts-expect-error if (type === number) means that the domain is numerical type
    // - but this link is missing in the type definition
    function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {};
    // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)// @ts-expect-error Date cannot index an object
        if (!tag[entry[i]]) {
            // @ts-expect-error Date cannot index an object
            tag[entry[i]] = true;
            // @ts-expect-error Date cannot index an object
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $467312b86c271c9f$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === "horizontal" && axisType === "xAxis" || layout === "vertical" && axisType === "yAxis" || layout === "centric" && axisType === "angleAxis" || layout === "radial" && axisType === "radiusAxis";
};
var $467312b86c271c9f$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, minValue, maxValue, syncWithTicks) {
    if (syncWithTicks) return ticks.map(function(entry) {
        return entry.coordinate;
    });
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var $467312b86c271c9f$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === "scaleBand" ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === "category" && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === "angleAxis" && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, $e6d37abae86076b3$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) {
        var result = (axis.ticks || axis.niceTicks).map(function(entry) {
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset: offset
            };
        });
        return result.filter(function(row) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($5f4abd17a6959cf9$exports)))(row.coordinate);
        });
    }
    // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
/**
 * combine the handlers
 * @param  {Function} defaultHandler Internal private handler
 * @param  {Function} childHandler Handler function specified in child component
 * @return {Function}                The combined handler
 */ var $467312b86c271c9f$var$handlerWeakMap = new WeakMap();
var $467312b86c271c9f$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, childHandler) {
    if (typeof childHandler !== "function") return defaultHandler;
    if (!$467312b86c271c9f$var$handlerWeakMap.has(defaultHandler)) $467312b86c271c9f$var$handlerWeakMap.set(defaultHandler, new WeakMap());
    var childWeakMap = $467312b86c271c9f$var$handlerWeakMap.get(defaultHandler);
    if (childWeakMap.has(childHandler)) return childWeakMap.get(childHandler);
    var combineHandler = function combineHandler() {
        defaultHandler.apply(void 0, arguments);
        childHandler.apply(void 0, arguments);
    };
    childWeakMap.set(childHandler, combineHandler);
    return combineHandler;
};
var $467312b86c271c9f$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === "auto") {
        if (layout === "radial" && axisType === "radiusAxis") return {
            scale: $3223330f788ca226$exports.scaleBand(),
            realScaleType: "band"
        };
        if (layout === "radial" && axisType === "angleAxis") return {
            scale: $3223330f788ca226$exports.scaleLinear(),
            realScaleType: "linear"
        };
        if (type === "category" && chartType && (chartType.indexOf("LineChart") >= 0 || chartType.indexOf("AreaChart") >= 0 || chartType.indexOf("ComposedChart") >= 0 && !hasBar)) return {
            scale: $3223330f788ca226$exports.scalePoint(),
            realScaleType: "point"
        };
        if (type === "category") return {
            scale: $3223330f788ca226$exports.scaleBand(),
            realScaleType: "band"
        };
        return {
            scale: $3223330f788ca226$exports.scaleLinear(),
            realScaleType: "linear"
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($36bb6c5dca3fd10c$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($ad0c997ad9c80793$exports)))(scale));
        return {
            scale: ($3223330f788ca226$exports[name] || $3223330f788ca226$exports.scalePoint)(),
            realScaleType: $3223330f788ca226$exports[name] ? name : "point"
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $3223330f788ca226$exports.scalePoint(),
        realScaleType: "point"
    };
};
var $467312b86c271c9f$var$EPS = 1e-4;
var $467312b86c271c9f$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - $467312b86c271c9f$var$EPS;
    var maxValue = Math.max(range[0], range[1]) + $467312b86c271c9f$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $467312b86c271c9f$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $467312b86c271c9f$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $e6d37abae86076b3$export$7e4aa119212bc614)(domain[0]) || !(0, $e6d37abae86076b3$export$7e4aa119212bc614)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $e6d37abae86076b3$export$7e4aa119212bc614)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, $e6d37abae86076b3$export$7e4aa119212bc614)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var $467312b86c271c9f$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($5f4abd17a6959cf9$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
var $467312b86c271c9f$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($5f4abd17a6959cf9$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring, no-param-reassign */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring, no-param-reassign */ }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var $467312b86c271c9f$var$STACK_OFFSET_MAP = {
    sign: $467312b86c271c9f$export$3104c513558164c1,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, $61471ee91debe026$exports.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, $61471ee91debe026$exports.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, $61471ee91debe026$exports.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, $61471ee91debe026$exports.stackOffsetWiggle),
    positive: $467312b86c271c9f$export$9f2c6ead70935022
};
var $467312b86c271c9f$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var offsetAccessor = $467312b86c271c9f$var$STACK_OFFSET_MAP[offsetType];
    var stack = (0, $61471ee91debe026$exports.stack)()// @ts-expect-error stack.keys type wants an array of strings, but we provide array of DataKeys
    .keys(dataKeys).value(function(d, key) {
        return +$467312b86c271c9f$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $61471ee91debe026$exports.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    return stack(data);
};
var $467312b86c271c9f$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
    // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var parentStackGroupsInitialValue = {};
    var stackGroups = items.reduce(function(result, item) {
        var _item$props2 = item.props, stackId = _item$props2.stackId, hide = _item$props2.hide;
        if (hide) return result;
        var axisId = item.props[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $e6d37abae86076b3$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $e6d37abae86076b3$export$8b15d37bc3f197d4)("_stackId_")] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $467312b86c271c9f$var$_objectSpread($467312b86c271c9f$var$_objectSpread({}, result), {}, $467312b86c271c9f$var$_defineProperty({}, axisId, parentGroup));
    }, parentStackGroupsInitialValue);
    var axisStackGroupsInitialValue = {};
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) {
            var stackGroupsInitialValue = {};
            group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
                var g = group.stackGroups[stackId];
                return $467312b86c271c9f$var$_objectSpread($467312b86c271c9f$var$_objectSpread({}, res), {}, $467312b86c271c9f$var$_defineProperty({}, stackId, {
                    numericAxisId: numericAxisId,
                    cateAxisId: cateAxisId,
                    items: g.items,
                    stackedData: $467312b86c271c9f$export$c2170542cfc0177c(data, g.items, offsetType)
                }));
            }, stackGroupsInitialValue);
        }
        return $467312b86c271c9f$var$_objectSpread($467312b86c271c9f$var$_objectSpread({}, result), {}, $467312b86c271c9f$var$_defineProperty({}, axisId, group));
    }, axisStackGroupsInitialValue);
};
var $467312b86c271c9f$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== "auto" && scaleType !== "linear") return null;
    if (tickCount && type === "number" && originalDomain && (originalDomain[0] === "auto" || originalDomain[1] === "auto")) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $2d347c72887f1b35$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain([
            (0, (/*@__PURE__*/$parcel$interopDefault($4ba4f43f07120ee1$exports)))(tickValues),
            (0, (/*@__PURE__*/$parcel$interopDefault($0fbd870e7e2db3ba$exports)))(tickValues)
        ]);
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === "number") {
        var _domain = scale.domain();
        var _tickValues = (0, $2d347c72887f1b35$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
function $467312b86c271c9f$export$6e87f3defb83c3f(_ref5) {
    var axis = _ref5.axis, ticks = _ref5.ticks, bandSize = _ref5.bandSize, entry = _ref5.entry, index = _ref5.index, dataKey = _ref5.dataKey;
    if (axis.type === "category") {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, $e6d37abae86076b3$export$66950d3869f5cc67)(ticks, "value", entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $467312b86c271c9f$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(value) ? axis.scale(value) : null;
}
var $467312b86c271c9f$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref6) {
    var axis = _ref6.axis, ticks = _ref6.ticks, offset = _ref6.offset, bandSize = _ref6.bandSize, entry = _ref6.entry, index = _ref6.index;
    if (axis.type === "category") return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $467312b86c271c9f$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $467312b86c271c9f$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref7) {
    var numericAxis = _ref7.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === "number") {
        var minValue = Math.min(domain[0], domain[1]);
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var $467312b86c271c9f$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var stackId = item.props.stackId;
    if ((0, $e6d37abae86076b3$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group) {
            var itemIndex = group.items.indexOf(item);
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $467312b86c271c9f$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($4ba4f43f07120ee1$exports)))(entry.concat([
                result[0]
            ]).filter((0, $e6d37abae86076b3$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($0fbd870e7e2db3ba$exports)))(entry.concat([
                result[1]
            ]).filter((0, $e6d37abae86076b3$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $467312b86c271c9f$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $467312b86c271c9f$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $467312b86c271c9f$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $467312b86c271c9f$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $467312b86c271c9f$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!Array.isArray(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $e6d37abae86076b3$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($467312b86c271c9f$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$467312b86c271c9f$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $e6d37abae86076b3$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($467312b86c271c9f$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$467312b86c271c9f$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $467312b86c271c9f$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    // @ts-expect-error we need to rethink scale type
    if (axis && axis.scale && axis.scale.bandwidth) {
        // @ts-expect-error we need to rethink scale type
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($024dd103a6f5c4c7$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $467312b86c271c9f$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($3e560c71c494b98e$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($d0c0e0e0987fd69b$exports)))(axisChild, "type.defaultProps.domain"))) return calculatedDomain;
    return specifiedDomain;
};
var $467312b86c271c9f$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var _graphicalItem$props = graphicalItem.props, dataKey = _graphicalItem$props.dataKey, name = _graphicalItem$props.name, unit = _graphicalItem$props.unit, formatter = _graphicalItem$props.formatter, tooltipType = _graphicalItem$props.tooltipType, chartType = _graphicalItem$props.chartType, hide = _graphicalItem$props.hide;
    return $467312b86c271c9f$var$_objectSpread($467312b86c271c9f$var$_objectSpread({}, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(graphicalItem, false)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $467312b86c271c9f$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $467312b86c271c9f$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType,
        hide: hide
    });
};




var $ed9b15b562e43bad$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== "undefined" && window.document && window.document.createElement && window.setTimeout);
};
var $ed9b15b562e43bad$export$98f03c5d19621d70 = {
    isSsr: $ed9b15b562e43bad$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $ed9b15b562e43bad$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === "string") $ed9b15b562e43bad$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $ed9b15b562e43bad$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};


function $b283dcf1f7838ffe$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $b283dcf1f7838ffe$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $b283dcf1f7838ffe$var$_typeof(o);
}
function $b283dcf1f7838ffe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b283dcf1f7838ffe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b283dcf1f7838ffe$var$ownKeys(Object(t), !0).forEach(function(r) {
            $b283dcf1f7838ffe$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b283dcf1f7838ffe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b283dcf1f7838ffe$var$_defineProperty(obj, key, value) {
    key = $b283dcf1f7838ffe$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b283dcf1f7838ffe$var$_toPropertyKey(t) {
    var i = $b283dcf1f7838ffe$var$_toPrimitive(t, "string");
    return "symbol" == $b283dcf1f7838ffe$var$_typeof(i) ? i : String(i);
}
function $b283dcf1f7838ffe$var$_toPrimitive(t, r) {
    if ("object" != $b283dcf1f7838ffe$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $b283dcf1f7838ffe$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $b283dcf1f7838ffe$var$_toConsumableArray(arr) {
    return $b283dcf1f7838ffe$var$_arrayWithoutHoles(arr) || $b283dcf1f7838ffe$var$_iterableToArray(arr) || $b283dcf1f7838ffe$var$_unsupportedIterableToArray(arr) || $b283dcf1f7838ffe$var$_nonIterableSpread();
}
function $b283dcf1f7838ffe$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b283dcf1f7838ffe$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b283dcf1f7838ffe$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b283dcf1f7838ffe$var$_arrayLikeToArray(o, minLen);
}
function $b283dcf1f7838ffe$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $b283dcf1f7838ffe$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $b283dcf1f7838ffe$var$_arrayLikeToArray(arr);
}
function $b283dcf1f7838ffe$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $b283dcf1f7838ffe$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $b283dcf1f7838ffe$var$MAX_CACHE_NUM = 2000;
var $b283dcf1f7838ffe$var$SPAN_STYLE = {
    position: "absolute",
    top: "-20000px",
    left: 0,
    padding: 0,
    margin: 0,
    border: "none",
    whiteSpace: "pre"
};
var $b283dcf1f7838ffe$var$STYLE_LIST = [
    "minWidth",
    "maxWidth",
    "width",
    "minHeight",
    "maxHeight",
    "height",
    "top",
    "left",
    "fontSize",
    "lineHeight",
    "padding",
    "margin",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "paddingBottom",
    "marginLeft",
    "marginRight",
    "marginTop",
    "marginBottom"
];
var $b283dcf1f7838ffe$var$MEASUREMENT_SPAN_ID = "recharts_measurement_span";
function $b283dcf1f7838ffe$var$autoCompleteStyle(name, value) {
    if ($b283dcf1f7838ffe$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $b283dcf1f7838ffe$var$camelToMiddleLine(text) {
    var strs = text.split("");
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($b283dcf1f7838ffe$var$_toConsumableArray(result), [
            "-",
            entry.toLowerCase()
        ]);
        return [].concat($b283dcf1f7838ffe$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join("");
}
var $b283dcf1f7838ffe$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($b283dcf1f7838ffe$var$camelToMiddleLine(s), ":").concat($b283dcf1f7838ffe$var$autoCompleteStyle(s, style[s]), ";");
    }, "");
};
function $b283dcf1f7838ffe$var$removeInvalidKeys(obj) {
    var copyObj = $b283dcf1f7838ffe$var$_objectSpread({}, obj);
    Object.keys(copyObj).forEach(function(key) {
        if (!copyObj[key]) delete copyObj[key];
    });
    return copyObj;
}
var $b283dcf1f7838ffe$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $ed9b15b562e43bad$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var copyStyle = $b283dcf1f7838ffe$var$removeInvalidKeys(style);
    var cacheKey = JSON.stringify({
        text: text,
        copyStyle: copyStyle
    });
    if ($b283dcf1f7838ffe$var$stringCache.widthCache[cacheKey]) return $b283dcf1f7838ffe$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($b283dcf1f7838ffe$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement("span");
            measurementSpan.setAttribute("id", $b283dcf1f7838ffe$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute("aria-hidden", "true");
            document.body.appendChild(measurementSpan);
        }
        // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $b283dcf1f7838ffe$var$_objectSpread($b283dcf1f7838ffe$var$_objectSpread({}, $b283dcf1f7838ffe$var$SPAN_STYLE), copyStyle);
        Object.assign(measurementSpan.style, measurementSpanStyle);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $b283dcf1f7838ffe$var$stringCache.widthCache[cacheKey] = result;
        if (++$b283dcf1f7838ffe$var$stringCache.cacheCount > $b283dcf1f7838ffe$var$MAX_CACHE_NUM) {
            $b283dcf1f7838ffe$var$stringCache.cacheCount = 0;
            $b283dcf1f7838ffe$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $b283dcf1f7838ffe$export$622cea445a1c5b7d = function getOffset(rect) {
    return {
        top: rect.top + window.scrollY - document.documentElement.clientTop,
        left: rect.left + window.scrollX - document.documentElement.clientLeft
    };
};



var $f9f846a4f2098ce5$exports = {};
var $7dce128885b699f6$exports = {};

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $7dce128885b699f6$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $7f15d9ea84166ccf$exports) $7f15d9ea84166ccf$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$7dce128885b699f6$exports = $7dce128885b699f6$var$baseAssignValue;




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $f9f846a4f2098ce5$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $86a15e1908191355$exports(iteratee, 3);
    $e238a765dc7a57dc$exports(object, function(value, key, object) {
        $7dce128885b699f6$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$f9f846a4f2098ce5$exports = $f9f846a4f2098ce5$var$mapValues;


var $54cc0954b777287c$exports = {};
var $d218b0aeeef6f96e$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $d218b0aeeef6f96e$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$d218b0aeeef6f96e$exports = $d218b0aeeef6f96e$var$arrayEvery;


var $b25a13f3fb4070e2$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $b25a13f3fb4070e2$var$baseEvery(collection, predicate) {
    var result = true;
    $e0c588ee25819a54$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$b25a13f3fb4070e2$exports = $b25a13f3fb4070e2$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $54cc0954b777287c$var$every(collection, predicate, guard) {
    var func = $d9532e5a54ad1ff7$exports(collection) ? $d218b0aeeef6f96e$exports : $b25a13f3fb4070e2$exports;
    if (guard && $31c3fe36697999ed$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $86a15e1908191355$exports(predicate, 3));
}
$54cc0954b777287c$exports = $54cc0954b777287c$var$every;






var $fgmOP = parcelRequire("fgmOP");


var $fgmOP = parcelRequire("fgmOP");

var $jPPOv = parcelRequire("jPPOv");
var $fa2d9ce264a0f4ef$exports = {};
(function(global, factory) {
    factory($fa2d9ce264a0f4ef$exports);
})($fa2d9ce264a0f4ef$exports, function(exports1) {
    "use strict";
    var getOwnPropertyNames = Object.getOwnPropertyNames, getOwnPropertySymbols = Object.getOwnPropertySymbols;
    var hasOwnProperty = Object.prototype.hasOwnProperty;
    /**
     * Combine two comparators into a single comparators.
     */ function combineComparators(comparatorA, comparatorB) {
        return function isEqual(a, b, state) {
            return comparatorA(a, b, state) && comparatorB(a, b, state);
        };
    }
    /**
     * Wrap the provided `areItemsEqual` method to manage the circular state, allowing
     * for circular references to be safely included in the comparison without creating
     * stack overflows.
     */ function createIsCircular(areItemsEqual) {
        return function isCircular(a, b, state) {
            if (!a || !b || typeof a !== "object" || typeof b !== "object") return areItemsEqual(a, b, state);
            var cache = state.cache;
            var cachedA = cache.get(a);
            var cachedB = cache.get(b);
            if (cachedA && cachedB) return cachedA === b && cachedB === a;
            cache.set(a, b);
            cache.set(b, a);
            var result = areItemsEqual(a, b, state);
            cache.delete(a);
            cache.delete(b);
            return result;
        };
    }
    /**
     * Get the properties to strictly examine, which include both own properties that are
     * not enumerable and symbol properties.
     */ function getStrictProperties(object) {
        return getOwnPropertyNames(object).concat(getOwnPropertySymbols(object));
    }
    /**
     * Whether the object contains the property passed as an own property.
     */ var hasOwn = Object.hasOwn || function(object, property) {
        return hasOwnProperty.call(object, property);
    };
    /**
     * Whether the values passed are strictly equal or both NaN.
     */ function sameValueZeroEqual(a, b) {
        return a || b ? a === b : a === b || a !== a && b !== b;
    }
    var OWNER = "_owner";
    var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor, keys = Object.keys;
    /**
     * Whether the arrays are equal in value.
     */ function areArraysEqual(a, b, state) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!state.equals(a[index], b[index], index, index, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the dates passed are equal in value.
     */ function areDatesEqual(a, b) {
        return sameValueZeroEqual(a.getTime(), b.getTime());
    }
    /**
     * Whether the `Map`s are equal in value.
     */ function areMapsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.entries();
        var index = 0;
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.entries();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                var _a = aResult.value, aKey = _a[0], aValue = _a[1];
                var _b = bResult.value, bKey = _b[0], bValue = _b[1];
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aKey, bKey, index, matchIndex, a, b, state) && state.equals(aValue, bValue, aKey, bKey, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
            index++;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value.
     */ function areObjectsEqual(a, b, state) {
        var properties = keys(a);
        var index = properties.length;
        if (keys(b).length !== index) return false;
        var property;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property) || !state.equals(a[property], b[property], property, property, a, b, state)) return false;
        }
        return true;
    }
    /**
     * Whether the objects are equal in value with strict property checking.
     */ function areObjectsEqualStrict(a, b, state) {
        var properties = getStrictProperties(a);
        var index = properties.length;
        if (getStrictProperties(b).length !== index) return false;
        var property;
        var descriptorA;
        var descriptorB;
        // Decrementing `while` showed faster results than either incrementing or
        // decrementing `for` loop and than an incrementing `while` loop. Declarative
        // methods like `some` / `every` were not used to avoid incurring the garbage
        // cost of anonymous callbacks.
        while(index-- > 0){
            property = properties[index];
            if (property === OWNER && (a.$$typeof || b.$$typeof) && a.$$typeof !== b.$$typeof) return false;
            if (!hasOwn(b, property)) return false;
            if (!state.equals(a[property], b[property], property, property, a, b, state)) return false;
            descriptorA = getOwnPropertyDescriptor(a, property);
            descriptorB = getOwnPropertyDescriptor(b, property);
            if ((descriptorA || descriptorB) && (!descriptorA || !descriptorB || descriptorA.configurable !== descriptorB.configurable || descriptorA.enumerable !== descriptorB.enumerable || descriptorA.writable !== descriptorB.writable)) return false;
        }
        return true;
    }
    /**
     * Whether the primitive wrappers passed are equal in value.
     */ function arePrimitiveWrappersEqual(a, b) {
        return sameValueZeroEqual(a.valueOf(), b.valueOf());
    }
    /**
     * Whether the regexps passed are equal in value.
     */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.flags === b.flags;
    }
    /**
     * Whether the `Set`s are equal in value.
     */ function areSetsEqual(a, b, state) {
        if (a.size !== b.size) return false;
        var matchedIndices = {};
        var aIterable = a.values();
        var aResult;
        var bResult;
        while(aResult = aIterable.next()){
            if (aResult.done) break;
            var bIterable = b.values();
            var hasMatch = false;
            var matchIndex = 0;
            while(bResult = bIterable.next()){
                if (bResult.done) break;
                if (!hasMatch && !matchedIndices[matchIndex] && (hasMatch = state.equals(aResult.value, bResult.value, aResult.value, bResult.value, a, b, state))) matchedIndices[matchIndex] = true;
                matchIndex++;
            }
            if (!hasMatch) return false;
        }
        return true;
    }
    /**
     * Whether the TypedArray instances are equal in value.
     */ function areTypedArraysEqual(a, b) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (a[index] !== b[index]) return false;
        }
        return true;
    }
    var ARGUMENTS_TAG = "[object Arguments]";
    var BOOLEAN_TAG = "[object Boolean]";
    var DATE_TAG = "[object Date]";
    var MAP_TAG = "[object Map]";
    var NUMBER_TAG = "[object Number]";
    var OBJECT_TAG = "[object Object]";
    var REG_EXP_TAG = "[object RegExp]";
    var SET_TAG = "[object Set]";
    var STRING_TAG = "[object String]";
    var isArray = Array.isArray;
    var isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView ? ArrayBuffer.isView : null;
    var assign = Object.assign;
    var getTag = Object.prototype.toString.call.bind(Object.prototype.toString);
    /**
     * Create a comparator method based on the type-specific equality comparators passed.
     */ function createEqualityComparator(_a) {
        var areArraysEqual = _a.areArraysEqual, areDatesEqual = _a.areDatesEqual, areMapsEqual = _a.areMapsEqual, areObjectsEqual = _a.areObjectsEqual, arePrimitiveWrappersEqual = _a.arePrimitiveWrappersEqual, areRegExpsEqual = _a.areRegExpsEqual, areSetsEqual = _a.areSetsEqual, areTypedArraysEqual = _a.areTypedArraysEqual;
        /**
         * compare the value of the two objects and return true if they are equivalent in values
         */ return function comparator(a, b, state) {
            // If the items are strictly equal, no need to do a value comparison.
            if (a === b) return true;
            // If the items are not non-nullish objects, then the only possibility
            // of them being equal but not strictly is if they are both `NaN`. Since
            // `NaN` is uniquely not equal to itself, we can use self-comparison of
            // both objects, which is faster than `isNaN()`.
            if (a == null || b == null || typeof a !== "object" || typeof b !== "object") return a !== a && b !== b;
            var constructor = a.constructor;
            // Checks are listed in order of commonality of use-case:
            //   1. Common complex object types (plain object, array)
            //   2. Common data values (date, regexp)
            //   3. Less-common complex object types (map, set)
            //   4. Less-common data values (promise, primitive wrappers)
            // Inherently this is both subjective and assumptive, however
            // when reviewing comparable libraries in the wild this order
            // appears to be generally consistent.
            // Constructors should match, otherwise there is potential for false positives
            // between class and subclass or custom object and POJO.
            if (constructor !== b.constructor) return false;
            // `isPlainObject` only checks against the object's own realm. Cross-realm
            // comparisons are rare, and will be handled in the ultimate fallback, so
            // we can avoid capturing the string tag.
            if (constructor === Object) return areObjectsEqual(a, b, state);
            // `isArray()` works on subclasses and is cross-realm, so we can avoid capturing
            // the string tag or doing an `instanceof` check.
            if (isArray(a)) return areArraysEqual(a, b, state);
            // `isTypedArray()` works on all possible TypedArray classes, so we can avoid
            // capturing the string tag or comparing against all possible constructors.
            if (isTypedArray != null && isTypedArray(a)) return areTypedArraysEqual(a, b, state);
            // Try to fast-path equality checks for other complex object types in the
            // same realm to avoid capturing the string tag. Strict equality is used
            // instead of `instanceof` because it is more performant for the common
            // use-case. If someone is subclassing a native class, it will be handled
            // with the string tag comparison.
            if (constructor === Date) return areDatesEqual(a, b, state);
            if (constructor === RegExp) return areRegExpsEqual(a, b, state);
            if (constructor === Map) return areMapsEqual(a, b, state);
            if (constructor === Set) return areSetsEqual(a, b, state);
            // Since this is a custom object, capture the string tag to determing its type.
            // This is reasonably performant in modern environments like v8 and SpiderMonkey.
            var tag = getTag(a);
            if (tag === DATE_TAG) return areDatesEqual(a, b, state);
            if (tag === REG_EXP_TAG) return areRegExpsEqual(a, b, state);
            if (tag === MAP_TAG) return areMapsEqual(a, b, state);
            if (tag === SET_TAG) return areSetsEqual(a, b, state);
            if (tag === OBJECT_TAG) // The exception for value comparison is custom `Promise`-like class instances. These should
            // be treated the same as standard `Promise` objects, which means strict equality, and if
            // it reaches this point then that strict equality comparison has already failed.
            return typeof a.then !== "function" && typeof b.then !== "function" && areObjectsEqual(a, b, state);
            // If an arguments tag, it should be treated as a standard object.
            if (tag === ARGUMENTS_TAG) return areObjectsEqual(a, b, state);
            // As the penultimate fallback, check if the values passed are primitive wrappers. This
            // is very rare in modern JS, which is why it is deprioritized compared to all other object
            // types.
            if (tag === BOOLEAN_TAG || tag === NUMBER_TAG || tag === STRING_TAG) return arePrimitiveWrappersEqual(a, b, state);
            // If not matching any tags that require a specific type of comparison, then we hard-code false because
            // the only thing remaining is strict equality, which has already been compared. This is for a few reasons:
            //   - Certain types that cannot be introspected (e.g., `WeakMap`). For these types, this is the only
            //     comparison that can be made.
            //   - For types that can be introspected, but rarely have requirements to be compared
            //     (`ArrayBuffer`, `DataView`, etc.), the cost is avoided to prioritize the common
            //     use-cases (may be included in a future release, if requested enough).
            //   - For types that can be introspected but do not have an objective definition of what
            //     equality is (`Error`, etc.), the subjective decision is to be conservative and strictly compare.
            // In all cases, these decisions should be reevaluated based on changes to the language and
            // common development practices.
            return false;
        };
    }
    /**
     * Create the configuration object used for building comparators.
     */ function createEqualityComparatorConfig(_a) {
        var circular = _a.circular, createCustomConfig = _a.createCustomConfig, strict = _a.strict;
        var config = {
            areArraysEqual: strict ? areObjectsEqualStrict : areArraysEqual,
            areDatesEqual: areDatesEqual,
            areMapsEqual: strict ? combineComparators(areMapsEqual, areObjectsEqualStrict) : areMapsEqual,
            areObjectsEqual: strict ? areObjectsEqualStrict : areObjectsEqual,
            arePrimitiveWrappersEqual: arePrimitiveWrappersEqual,
            areRegExpsEqual: areRegExpsEqual,
            areSetsEqual: strict ? combineComparators(areSetsEqual, areObjectsEqualStrict) : areSetsEqual,
            areTypedArraysEqual: strict ? areObjectsEqualStrict : areTypedArraysEqual
        };
        if (createCustomConfig) config = assign({}, config, createCustomConfig(config));
        if (circular) {
            var areArraysEqual$1 = createIsCircular(config.areArraysEqual);
            var areMapsEqual$1 = createIsCircular(config.areMapsEqual);
            var areObjectsEqual$1 = createIsCircular(config.areObjectsEqual);
            var areSetsEqual$1 = createIsCircular(config.areSetsEqual);
            config = assign({}, config, {
                areArraysEqual: areArraysEqual$1,
                areMapsEqual: areMapsEqual$1,
                areObjectsEqual: areObjectsEqual$1,
                areSetsEqual: areSetsEqual$1
            });
        }
        return config;
    }
    /**
     * Default equality comparator pass-through, used as the standard `isEqual` creator for
     * use inside the built comparator.
     */ function createInternalEqualityComparator(compare) {
        return function(a, b, _indexOrKeyA, _indexOrKeyB, _parentA, _parentB, state) {
            return compare(a, b, state);
        };
    }
    /**
     * Create the `isEqual` function used by the consuming application.
     */ function createIsEqual(_a) {
        var circular = _a.circular, comparator = _a.comparator, createState = _a.createState, equals = _a.equals, strict = _a.strict;
        if (createState) return function isEqual(a, b) {
            var _a = createState(), _b = _a.cache, cache = _b === void 0 ? circular ? new WeakMap() : undefined : _b, meta = _a.meta;
            return comparator(a, b, {
                cache: cache,
                equals: equals,
                meta: meta,
                strict: strict
            });
        };
        if (circular) return function isEqual(a, b) {
            return comparator(a, b, {
                cache: new WeakMap(),
                equals: equals,
                meta: undefined,
                strict: strict
            });
        };
        var state = {
            cache: undefined,
            equals: equals,
            meta: undefined,
            strict: strict
        };
        return function isEqual(a, b) {
            return comparator(a, b, state);
        };
    }
    /**
     * Whether the items passed are deeply-equal in value.
     */ var deepEqual = createCustomEqual();
    /**
     * Whether the items passed are deeply-equal in value based on strict comparison.
     */ var strictDeepEqual = createCustomEqual({
        strict: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references.
     */ var circularDeepEqual = createCustomEqual({
        circular: true
    });
    /**
     * Whether the items passed are deeply-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularDeepEqual = createCustomEqual({
        circular: true,
        strict: true
    });
    /**
     * Whether the items passed are shallowly-equal in value.
     */ var shallowEqual = createCustomEqual({
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value based on strict comparison
     */ var strictShallowEqual = createCustomEqual({
        strict: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references.
     */ var circularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        }
    });
    /**
     * Whether the items passed are shallowly-equal in value, including circular references,
     * based on strict comparison.
     */ var strictCircularShallowEqual = createCustomEqual({
        circular: true,
        createInternalComparator: function() {
            return sameValueZeroEqual;
        },
        strict: true
    });
    /**
     * Create a custom equality comparison method.
     *
     * This can be done to create very targeted comparisons in extreme hot-path scenarios
     * where the standard methods are not performant enough, but can also be used to provide
     * support for legacy environments that do not support expected features like
     * `RegExp.prototype.flags` out of the box.
     */ function createCustomEqual(options) {
        if (options === void 0) options = {};
        var _a = options.circular, circular = _a === void 0 ? false : _a, createCustomInternalComparator = options.createInternalComparator, createState = options.createState, _b = options.strict, strict = _b === void 0 ? false : _b;
        var config = createEqualityComparatorConfig(options);
        var comparator = createEqualityComparator(config);
        var equals = createCustomInternalComparator ? createCustomInternalComparator(comparator) : createInternalEqualityComparator(comparator);
        return createIsEqual({
            circular: circular,
            comparator: comparator,
            createState: createState,
            equals: equals,
            strict: strict
        });
    }
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createCustomEqual;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    exports1.strictCircularDeepEqual = strictCircularDeepEqual;
    exports1.strictCircularShallowEqual = strictCircularShallowEqual;
    exports1.strictDeepEqual = strictDeepEqual;
    exports1.strictShallowEqual = strictShallowEqual;
});


function $7c00f882104ddd97$var$safeRequestAnimationFrame(callback) {
    if (typeof requestAnimationFrame !== "undefined") requestAnimationFrame(callback);
}
function $7c00f882104ddd97$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else $7c00f882104ddd97$var$safeRequestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $938831cb2267f9b4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $938831cb2267f9b4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $938831cb2267f9b4$var$_typeof(o);
}
function $938831cb2267f9b4$var$_toArray(arr) {
    return $938831cb2267f9b4$var$_arrayWithHoles(arr) || $938831cb2267f9b4$var$_iterableToArray(arr) || $938831cb2267f9b4$var$_unsupportedIterableToArray(arr) || $938831cb2267f9b4$var$_nonIterableRest();
}
function $938831cb2267f9b4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $938831cb2267f9b4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $938831cb2267f9b4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $938831cb2267f9b4$var$_arrayLikeToArray(o, minLen);
}
function $938831cb2267f9b4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $938831cb2267f9b4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $938831cb2267f9b4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $938831cb2267f9b4$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $938831cb2267f9b4$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === "number") {
                (0, $7c00f882104ddd97$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $7c00f882104ddd97$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($938831cb2267f9b4$var$_typeof(_style) === "object") {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === "function") _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $9736bc0b00f58bc1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $9736bc0b00f58bc1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $9736bc0b00f58bc1$var$_typeof(o);
}
function $9736bc0b00f58bc1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9736bc0b00f58bc1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9736bc0b00f58bc1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $9736bc0b00f58bc1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9736bc0b00f58bc1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9736bc0b00f58bc1$var$_defineProperty(obj, key, value) {
    key = $9736bc0b00f58bc1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9736bc0b00f58bc1$var$_toPropertyKey(arg) {
    var key = $9736bc0b00f58bc1$var$_toPrimitive(arg, "string");
    return $9736bc0b00f58bc1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9736bc0b00f58bc1$var$_toPrimitive(input, hint) {
    if ($9736bc0b00f58bc1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9736bc0b00f58bc1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $9736bc0b00f58bc1$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $9736bc0b00f58bc1$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $9736bc0b00f58bc1$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $9736bc0b00f58bc1$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $9736bc0b00f58bc1$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $9736bc0b00f58bc1$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $9736bc0b00f58bc1$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || "anonymous function";
        var argNames = "(".concat(args.map(JSON.stringify).join(", "), ")");
        $9736bc0b00f58bc1$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $9736bc0b00f58bc1$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $9736bc0b00f58bc1$var$_objectSpread($9736bc0b00f58bc1$var$_objectSpread({}, res), {}, $9736bc0b00f58bc1$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $9736bc0b00f58bc1$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($9736bc0b00f58bc1$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(",");
};
var $9736bc0b00f58bc1$var$isDev = false;
var $9736bc0b00f58bc1$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($9736bc0b00f58bc1$var$isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $ecaa5006beef1201$var$_slicedToArray(arr, i) {
    return $ecaa5006beef1201$var$_arrayWithHoles(arr) || $ecaa5006beef1201$var$_iterableToArrayLimit(arr, i) || $ecaa5006beef1201$var$_unsupportedIterableToArray(arr, i) || $ecaa5006beef1201$var$_nonIterableRest();
}
function $ecaa5006beef1201$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ecaa5006beef1201$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $ecaa5006beef1201$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ecaa5006beef1201$var$_toConsumableArray(arr) {
    return $ecaa5006beef1201$var$_arrayWithoutHoles(arr) || $ecaa5006beef1201$var$_iterableToArray(arr) || $ecaa5006beef1201$var$_unsupportedIterableToArray(arr) || $ecaa5006beef1201$var$_nonIterableSpread();
}
function $ecaa5006beef1201$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ecaa5006beef1201$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ecaa5006beef1201$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ecaa5006beef1201$var$_arrayLikeToArray(o, minLen);
}
function $ecaa5006beef1201$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ecaa5006beef1201$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ecaa5006beef1201$var$_arrayLikeToArray(arr);
}
function $ecaa5006beef1201$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $ecaa5006beef1201$var$ACCURACY = 1e-4;
var $ecaa5006beef1201$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $ecaa5006beef1201$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $ecaa5006beef1201$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $ecaa5006beef1201$var$cubicBezierFactor(c1, c2);
        return $ecaa5006beef1201$var$multyTime(params, t);
    };
};
var $ecaa5006beef1201$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $ecaa5006beef1201$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($ecaa5006beef1201$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $ecaa5006beef1201$var$multyTime(newParams, t);
    };
};
var $ecaa5006beef1201$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case "linear":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease":
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case "ease-in":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease-out":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case "ease-in-out":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split("(");
            if (easing[0] === "cubic-bezier" && easing[1].split(")")[0].split(",").length === 4) {
                var _easing$1$split$0$spl = easing[1].split(")")[0].split(",").map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $ecaa5006beef1201$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $9736bc0b00f58bc1$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $9736bc0b00f58bc1$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === "number" && num >= 0 && num <= 1;
    }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", args);
    var curveX = $ecaa5006beef1201$var$cubicBezier(x1, x2);
    var curveY = $ecaa5006beef1201$var$cubicBezier(y1, y2);
    var derCurveX = $ecaa5006beef1201$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $ecaa5006beef1201$var$ACCURACY || derVal < $ecaa5006beef1201$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $ecaa5006beef1201$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $ecaa5006beef1201$var$ACCURACY && Math.abs(newV) < $ecaa5006beef1201$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $ecaa5006beef1201$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === "string") switch(easing){
        case "ease":
        case "ease-in-out":
        case "ease-out":
        case "ease-in":
        case "linear":
            return $ecaa5006beef1201$export$56c51296f72f0592(easing);
        case "spring":
            return $ecaa5006beef1201$export$12fc25daf62b865a();
        default:
            if (easing.split("(")[0] === "cubic-bezier") return $ecaa5006beef1201$export$56c51296f72f0592(easing);
            (0, $9736bc0b00f58bc1$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === "function") return easing;
    (0, $9736bc0b00f58bc1$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument type should be function or string, instead received %s", args);
    return null;
};



function $91ef91a26477a714$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $91ef91a26477a714$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $91ef91a26477a714$var$_typeof(o);
}
function $91ef91a26477a714$var$_toConsumableArray(arr) {
    return $91ef91a26477a714$var$_arrayWithoutHoles(arr) || $91ef91a26477a714$var$_iterableToArray(arr) || $91ef91a26477a714$var$_unsupportedIterableToArray(arr) || $91ef91a26477a714$var$_nonIterableSpread();
}
function $91ef91a26477a714$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $91ef91a26477a714$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $91ef91a26477a714$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $91ef91a26477a714$var$_arrayLikeToArray(arr);
}
function $91ef91a26477a714$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $91ef91a26477a714$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $91ef91a26477a714$var$ownKeys(Object(t), !0).forEach(function(r) {
            $91ef91a26477a714$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $91ef91a26477a714$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $91ef91a26477a714$var$_defineProperty(obj, key, value) {
    key = $91ef91a26477a714$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $91ef91a26477a714$var$_toPropertyKey(arg) {
    var key = $91ef91a26477a714$var$_toPrimitive(arg, "string");
    return $91ef91a26477a714$var$_typeof(key) === "symbol" ? key : String(key);
}
function $91ef91a26477a714$var$_toPrimitive(input, hint) {
    if ($91ef91a26477a714$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($91ef91a26477a714$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $91ef91a26477a714$var$_slicedToArray(arr, i) {
    return $91ef91a26477a714$var$_arrayWithHoles(arr) || $91ef91a26477a714$var$_iterableToArrayLimit(arr, i) || $91ef91a26477a714$var$_unsupportedIterableToArray(arr, i) || $91ef91a26477a714$var$_nonIterableRest();
}
function $91ef91a26477a714$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $91ef91a26477a714$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $91ef91a26477a714$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $91ef91a26477a714$var$_arrayLikeToArray(o, minLen);
}
function $91ef91a26477a714$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $91ef91a26477a714$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $91ef91a26477a714$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $91ef91a26477a714$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $91ef91a26477a714$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $91ef91a26477a714$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $9736bc0b00f58bc1$export$d6051a0f7a227332)(function(key, val) {
        if ($91ef91a26477a714$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $91ef91a26477a714$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $91ef91a26477a714$var$_objectSpread($91ef91a26477a714$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $9736bc0b00f58bc1$export$d6051a0f7a227332)(function(key, val) {
        if ($91ef91a26477a714$var$needContinue(val)) return $91ef91a26477a714$var$_objectSpread($91ef91a26477a714$var$_objectSpread({}, val), {}, {
            velocity: $91ef91a26477a714$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $91ef91a26477a714$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
var // configure update function
$91ef91a26477a714$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $9736bc0b00f58bc1$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $91ef91a26477a714$var$_objectSpread($91ef91a26477a714$var$_objectSpread({}, res), {}, $91ef91a26477a714$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $91ef91a26477a714$var$_objectSpread($91ef91a26477a714$var$_objectSpread({}, res), {}, $91ef91a26477a714$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $9736bc0b00f58bc1$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($91ef91a26477a714$var$needContinue).length;
    };
    // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $91ef91a26477a714$var$calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render($91ef91a26477a714$var$_objectSpread($91ef91a26477a714$var$_objectSpread($91ef91a26477a714$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    };
    // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $9736bc0b00f58bc1$export$d6051a0f7a227332)(function(key, val) {
            return $91ef91a26477a714$var$alpha.apply(void 0, $91ef91a26477a714$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle);
        // get union set and add compatible prefix
        render($91ef91a26477a714$var$_objectSpread($91ef91a26477a714$var$_objectSpread($91ef91a26477a714$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $9736bc0b00f58bc1$export$d6051a0f7a227332)(function(key, val) {
                return $91ef91a26477a714$var$alpha.apply(void 0, $91ef91a26477a714$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($91ef91a26477a714$var$_objectSpread($91ef91a26477a714$var$_objectSpread($91ef91a26477a714$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate;
    // return start animation method
    return function() {
        requestAnimationFrame(update);
        // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $39a92a2976fc0b7c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $39a92a2976fc0b7c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $39a92a2976fc0b7c$var$_typeof(o);
}
var $39a92a2976fc0b7c$var$_excluded = [
    "children",
    "begin",
    "duration",
    "attributeName",
    "easing",
    "isActive",
    "steps",
    "from",
    "to",
    "canBegin",
    "onAnimationEnd",
    "shouldReAnimate",
    "onAnimationReStart"
];
function $39a92a2976fc0b7c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $39a92a2976fc0b7c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $39a92a2976fc0b7c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $39a92a2976fc0b7c$var$_toConsumableArray(arr) {
    return $39a92a2976fc0b7c$var$_arrayWithoutHoles(arr) || $39a92a2976fc0b7c$var$_iterableToArray(arr) || $39a92a2976fc0b7c$var$_unsupportedIterableToArray(arr) || $39a92a2976fc0b7c$var$_nonIterableSpread();
}
function $39a92a2976fc0b7c$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $39a92a2976fc0b7c$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $39a92a2976fc0b7c$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $39a92a2976fc0b7c$var$_arrayLikeToArray(o, minLen);
}
function $39a92a2976fc0b7c$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $39a92a2976fc0b7c$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $39a92a2976fc0b7c$var$_arrayLikeToArray(arr);
}
function $39a92a2976fc0b7c$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $39a92a2976fc0b7c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $39a92a2976fc0b7c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $39a92a2976fc0b7c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $39a92a2976fc0b7c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $39a92a2976fc0b7c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $39a92a2976fc0b7c$var$_defineProperty(obj, key, value) {
    key = $39a92a2976fc0b7c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $39a92a2976fc0b7c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $39a92a2976fc0b7c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $39a92a2976fc0b7c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $39a92a2976fc0b7c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $39a92a2976fc0b7c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $39a92a2976fc0b7c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $39a92a2976fc0b7c$var$_toPropertyKey(arg) {
    var key = $39a92a2976fc0b7c$var$_toPrimitive(arg, "string");
    return $39a92a2976fc0b7c$var$_typeof(key) === "symbol" ? key : String(key);
}
function $39a92a2976fc0b7c$var$_toPrimitive(input, hint) {
    if ($39a92a2976fc0b7c$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($39a92a2976fc0b7c$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $39a92a2976fc0b7c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $39a92a2976fc0b7c$var$_setPrototypeOf(subClass, superClass);
}
function $39a92a2976fc0b7c$var$_setPrototypeOf(o, p) {
    $39a92a2976fc0b7c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $39a92a2976fc0b7c$var$_setPrototypeOf(o, p);
}
function $39a92a2976fc0b7c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $39a92a2976fc0b7c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $39a92a2976fc0b7c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $39a92a2976fc0b7c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $39a92a2976fc0b7c$var$_possibleConstructorReturn(this, result);
    };
}
function $39a92a2976fc0b7c$var$_possibleConstructorReturn(self, call) {
    if (call && ($39a92a2976fc0b7c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $39a92a2976fc0b7c$var$_assertThisInitialized(self);
}
function $39a92a2976fc0b7c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $39a92a2976fc0b7c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $39a92a2976fc0b7c$var$_getPrototypeOf(o) {
    $39a92a2976fc0b7c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $39a92a2976fc0b7c$var$_getPrototypeOf(o);
}
var $39a92a2976fc0b7c$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $39a92a2976fc0b7c$var$_inherits(Animate, _PureComponent);
    var _super = $39a92a2976fc0b7c$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $39a92a2976fc0b7c$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children, duration = _this$props.duration;
        _this.handleStyleChange = _this.handleStyleChange.bind($39a92a2976fc0b7c$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($39a92a2976fc0b7c$var$_assertThisInitialized(_this));
        if (!isActive || duration <= 0) {
            _this.state = {
                style: {}
            };
            // if children is a function and animation is not active, set style to 'to'
            if (typeof children === "function") _this.state = {
                style: to
            };
            return $39a92a2976fc0b7c$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === "function") {
                _this.state = {
                    style: from
                };
                return $39a92a2976fc0b7c$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $39a92a2976fc0b7c$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $39a92a2976fc0b7c$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate, to = _this$props3.to, currentFrom = _this$props3.from;
                var style = this.state.style;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $39a92a2976fc0b7c$var$_defineProperty({}, attributeName, to) : to
                    };
                    if (this.state && style) {
                        if (attributeName && style[attributeName] !== to || !attributeName && style !== to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $fa2d9ce264a0f4ef$exports.deepEqual)(prevProps.to, to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? currentFrom : prevProps.to;
                if (this.state && style) {
                    var _newState = {
                        style: attributeName ? $39a92a2976fc0b7c$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && style[attributeName] !== from || !attributeName && style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($39a92a2976fc0b7c$var$_objectSpread($39a92a2976fc0b7c$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                var onAnimationEnd = this.props.onAnimationEnd;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
                if (onAnimationEnd) onAnimationEnd();
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $91ef91a26477a714$export$2e2bcd8739ae039)(from, to, (0, $ecaa5006beef1201$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? "ease" : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === "function" || easing === "spring") return [].concat($39a92a2976fc0b7c$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $9736bc0b00f58bc1$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $39a92a2976fc0b7c$var$_objectSpread($39a92a2976fc0b7c$var$_objectSpread($39a92a2976fc0b7c$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($39a92a2976fc0b7c$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $9736bc0b00f58bc1$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($39a92a2976fc0b7c$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $938831cb2267f9b4$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === "function" || typeof children === "function" || easing === "spring") {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $39a92a2976fc0b7c$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $9736bc0b00f58bc1$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $39a92a2976fc0b7c$var$_objectSpread($39a92a2976fc0b7c$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $39a92a2976fc0b7c$var$_objectWithoutProperties(_this$props4, $39a92a2976fc0b7c$var$_excluded);
                var count = (0, $fgmOP.Children).count(children);
                // eslint-disable-next-line react/destructuring-assignment
                var stateStyle = this.state.style;
                if (typeof children === "function") return children(stateStyle);
                if (!isActive || count === 0 || duration <= 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $fgmOP.cloneElement)(container, $39a92a2976fc0b7c$var$_objectSpread($39a92a2976fc0b7c$var$_objectSpread({}, others), {}, {
                        style: $39a92a2976fc0b7c$var$_objectSpread($39a92a2976fc0b7c$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $fgmOP.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", null, (0, $fgmOP.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $fgmOP.PureComponent));
$39a92a2976fc0b7c$var$Animate.displayName = "Animate";
$39a92a2976fc0b7c$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: "",
    to: "",
    attributeName: "",
    easing: "ease",
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
$39a92a2976fc0b7c$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).oneOf([
                "ease",
                "ease-in",
                "ease-out",
                "ease-in-out",
                "linear"
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).arrayOf("string"),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func
};
var $39a92a2976fc0b7c$export$2e2bcd8739ae039 = $39a92a2976fc0b7c$var$Animate;




var $fgmOP = parcelRequire("fgmOP");

function $c1c135e502bc42ab$export$2e2bcd8739ae039() {
    return $c1c135e502bc42ab$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $c1c135e502bc42ab$export$2e2bcd8739ae039.apply(null, arguments);
}


function $f635cf80030adf8a$export$2e2bcd8739ae039(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}





var $fgmOP = parcelRequire("fgmOP");


var $fgmOP = parcelRequire("fgmOP");
function $26d10889643ee486$export$bbc8a025727ea824(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $fgmOP.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) (0, $fgmOP.Children).map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
function $26d10889643ee486$export$7a874f95ccf533dd(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $26d10889643ee486$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $26d10889643ee486$export$fa71e2345c31d7a2(props, onExited) {
    return $26d10889643ee486$export$bbc8a025727ea824(props.children, function(child) {
        return (0, $fgmOP.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $26d10889643ee486$var$getProp(child, "appear", props),
            enter: $26d10889643ee486$var$getProp(child, "enter", props),
            exit: $26d10889643ee486$var$getProp(child, "exit", props)
        });
    });
}
function $26d10889643ee486$export$36fd1af28d383ec0(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $26d10889643ee486$export$bbc8a025727ea824(nextProps.children);
    var children = $26d10889643ee486$export$7a874f95ccf533dd(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $fgmOP.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $fgmOP.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $fgmOP.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $26d10889643ee486$var$getProp(child, "exit", nextProps),
            enter: $26d10889643ee486$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $fgmOP.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $fgmOP.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $fgmOP.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $26d10889643ee486$var$getProp(child, "exit", nextProps),
            enter: $26d10889643ee486$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}


var $f625e23450a45696$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $f625e23450a45696$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */ var $f625e23450a45696$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    (0, $93570c1e6b118a09$export$2e2bcd8739ae039)(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind((0, $f635cf80030adf8a$export$2e2bcd8739ae039)(_this)); // Initial children should all be entering, dependent on appear
        _this.state = {
            contextValue: {
                isMounting: true
            },
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.mounted = true;
        this.setState({
            contextValue: {
                isMounting: false
            }
        });
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $26d10889643ee486$export$fa71e2345c31d7a2)(nextProps, handleExited) : (0, $26d10889643ee486$export$36fd1af28d383ec0)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    } // node is `undefined` when user provided `nodeRef` prop
    ;
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $26d10889643ee486$export$bbc8a025727ea824)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = (0, $c1c135e502bc42ab$export$2e2bcd8739ae039)({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = (0, $69596327011c9ad6$export$2e2bcd8739ae039)(_this$props, [
            "component",
            "childFactory"
        ]);
        var contextValue = this.state.contextValue;
        var children = $f625e23450a45696$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $ad8be1c743ab13a5$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $ad8be1c743ab13a5$export$2e2bcd8739ae039).Provider, {
            value: contextValue
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(Component, props, children));
    };
    return TransitionGroup;
}((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Component);
$f625e23450a45696$var$TransitionGroup.propTypes = {};
$f625e23450a45696$var$TransitionGroup.defaultProps = $f625e23450a45696$var$defaultProps;
var $f625e23450a45696$export$2e2bcd8739ae039 = $f625e23450a45696$var$TransitionGroup;



var $jPPOv = parcelRequire("jPPOv");

var $fgmOP = parcelRequire("fgmOP");


var $jPPOv = parcelRequire("jPPOv");

var $71e88400aef10f8f$var$_excluded = [
    "children",
    "appearOptions",
    "enterOptions",
    "leaveOptions"
];
function $71e88400aef10f8f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $71e88400aef10f8f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $71e88400aef10f8f$var$_typeof(o);
}
function $71e88400aef10f8f$var$_extends() {
    $71e88400aef10f8f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $71e88400aef10f8f$var$_extends.apply(this, arguments);
}
function $71e88400aef10f8f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $71e88400aef10f8f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $71e88400aef10f8f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $71e88400aef10f8f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $71e88400aef10f8f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $71e88400aef10f8f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $71e88400aef10f8f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $71e88400aef10f8f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $71e88400aef10f8f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $71e88400aef10f8f$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $71e88400aef10f8f$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $71e88400aef10f8f$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $71e88400aef10f8f$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $71e88400aef10f8f$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $71e88400aef10f8f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $71e88400aef10f8f$var$_setPrototypeOf(subClass, superClass);
}
function $71e88400aef10f8f$var$_setPrototypeOf(o, p) {
    $71e88400aef10f8f$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $71e88400aef10f8f$var$_setPrototypeOf(o, p);
}
function $71e88400aef10f8f$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $71e88400aef10f8f$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $71e88400aef10f8f$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $71e88400aef10f8f$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $71e88400aef10f8f$var$_possibleConstructorReturn(this, result);
    };
}
function $71e88400aef10f8f$var$_possibleConstructorReturn(self, call) {
    if (call && ($71e88400aef10f8f$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $71e88400aef10f8f$var$_assertThisInitialized(self);
}
function $71e88400aef10f8f$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $71e88400aef10f8f$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $71e88400aef10f8f$var$_getPrototypeOf(o) {
    $71e88400aef10f8f$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $71e88400aef10f8f$var$_getPrototypeOf(o);
}
function $71e88400aef10f8f$var$_defineProperty(obj, key, value) {
    key = $71e88400aef10f8f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $71e88400aef10f8f$var$_toPropertyKey(arg) {
    var key = $71e88400aef10f8f$var$_toPrimitive(arg, "string");
    return $71e88400aef10f8f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $71e88400aef10f8f$var$_toPrimitive(input, hint) {
    if ($71e88400aef10f8f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($71e88400aef10f8f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $71e88400aef10f8f$var$parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var steps = options.steps, duration = options.duration;
    if (steps && steps.length) return steps.reduce(function(result, entry) {
        return result + (Number.isFinite(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
    if (Number.isFinite(duration)) return duration;
    return 0;
};
var $71e88400aef10f8f$var$AnimateGroupChild = /*#__PURE__*/ function(_Component) {
    $71e88400aef10f8f$var$_inherits(AnimateGroupChild, _Component);
    var _super = $71e88400aef10f8f$var$_createSuper(AnimateGroupChild);
    function AnimateGroupChild() {
        var _this;
        $71e88400aef10f8f$var$_classCallCheck(this, AnimateGroupChild);
        _this = _super.call(this);
        $71e88400aef10f8f$var$_defineProperty($71e88400aef10f8f$var$_assertThisInitialized(_this), "handleEnter", function(node, isAppearing) {
            var _this$props = _this.props, appearOptions = _this$props.appearOptions, enterOptions = _this$props.enterOptions;
            _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
        });
        $71e88400aef10f8f$var$_defineProperty($71e88400aef10f8f$var$_assertThisInitialized(_this), "handleExit", function() {
            var leaveOptions = _this.props.leaveOptions;
            _this.handleStyleActive(leaveOptions);
        });
        _this.state = {
            isActive: false
        };
        return _this;
    }
    $71e88400aef10f8f$var$_createClass(AnimateGroupChild, [
        {
            key: "handleStyleActive",
            value: function handleStyleActive(style) {
                if (style) {
                    var onAnimationEnd = style.onAnimationEnd ? function() {
                        style.onAnimationEnd();
                    } : null;
                    this.setState($71e88400aef10f8f$var$_objectSpread($71e88400aef10f8f$var$_objectSpread({}, style), {}, {
                        onAnimationEnd: onAnimationEnd,
                        isActive: true
                    }));
                }
            }
        },
        {
            key: "parseTimeout",
            value: function parseTimeout() {
                var _this$props2 = this.props, appearOptions = _this$props2.appearOptions, enterOptions = _this$props2.enterOptions, leaveOptions = _this$props2.leaveOptions;
                return $71e88400aef10f8f$var$parseDurationOfSingleTransition(appearOptions) + $71e88400aef10f8f$var$parseDurationOfSingleTransition(enterOptions) + $71e88400aef10f8f$var$parseDurationOfSingleTransition(leaveOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, children = _this$props3.children, appearOptions = _this$props3.appearOptions, enterOptions = _this$props3.enterOptions, leaveOptions = _this$props3.leaveOptions, props = $71e88400aef10f8f$var$_objectWithoutProperties(_this$props3, $71e88400aef10f8f$var$_excluded);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $ed222bb70e4be31d$export$2e2bcd8739ae039), $71e88400aef10f8f$var$_extends({}, props, {
                    onEnter: this.handleEnter,
                    onExit: this.handleExit,
                    timeout: this.parseTimeout()
                }), function() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $39a92a2976fc0b7c$export$2e2bcd8739ae039), _this2.state, (0, $fgmOP.Children).only(children));
                });
            }
        }
    ]);
    return AnimateGroupChild;
}((0, $fgmOP.Component));
$71e88400aef10f8f$var$AnimateGroupChild.propTypes = {
    appearOptions: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).object,
    enterOptions: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).object,
    leaveOptions: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).element
};
var $71e88400aef10f8f$export$2e2bcd8739ae039 = $71e88400aef10f8f$var$AnimateGroupChild;


function $06322a8e959d404f$var$AnimateGroup(props) {
    var component = props.component, children = props.children, appear = props.appear, enter = props.enter, leave = props.leave;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $f625e23450a45696$export$2e2bcd8739ae039), {
        component: component
    }, (0, $fgmOP.Children).map(children, function(child, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $71e88400aef10f8f$export$2e2bcd8739ae039), {
            appearOptions: appear,
            enterOptions: enter,
            leaveOptions: leave,
            key: "child-".concat(index) // eslint-disable-line
        }, child);
    }));
}
$06322a8e959d404f$var$AnimateGroup.propTypes = {
    appear: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).object,
    enter: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).object,
    leave: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).element
    ]),
    component: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).any
};
$06322a8e959d404f$var$AnimateGroup.defaultProps = {
    component: "span"
};
var $06322a8e959d404f$export$2e2bcd8739ae039 = $06322a8e959d404f$var$AnimateGroup;


var $0f3d500d46a22363$export$2e2bcd8739ae039 = (0, $39a92a2976fc0b7c$export$2e2bcd8739ae039);






/**
 * @fileOverview Cross
 */ var $76034bf0313908b8$export$f6f0c3fe4ec306ea = function Cell(_props) {
    return null;
};
$76034bf0313908b8$export$f6f0c3fe4ec306ea.displayName = "Cell";



var $fgmOP = parcelRequire("fgmOP");



var $9140a42b0160403d$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $9140a42b0160403d$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$9140a42b0160403d$exports = $9140a42b0160403d$var$last;



var $fgmOP = parcelRequire("fgmOP");





var $fgmOP = parcelRequire("fgmOP");






function $2e70b82bf90098ec$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2e70b82bf90098ec$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2e70b82bf90098ec$var$_typeof(o);
}
function $2e70b82bf90098ec$var$_slicedToArray(arr, i) {
    return $2e70b82bf90098ec$var$_arrayWithHoles(arr) || $2e70b82bf90098ec$var$_iterableToArrayLimit(arr, i) || $2e70b82bf90098ec$var$_unsupportedIterableToArray(arr, i) || $2e70b82bf90098ec$var$_nonIterableRest();
}
function $2e70b82bf90098ec$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2e70b82bf90098ec$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2e70b82bf90098ec$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2e70b82bf90098ec$var$_arrayLikeToArray(o, minLen);
}
function $2e70b82bf90098ec$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $2e70b82bf90098ec$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $2e70b82bf90098ec$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $2e70b82bf90098ec$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2e70b82bf90098ec$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $2e70b82bf90098ec$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $2e70b82bf90098ec$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2e70b82bf90098ec$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2e70b82bf90098ec$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $2e70b82bf90098ec$var$_toPropertyKey(t) {
    var i = $2e70b82bf90098ec$var$_toPrimitive(t, "string");
    return "symbol" == $2e70b82bf90098ec$var$_typeof(i) ? i : String(i);
}
function $2e70b82bf90098ec$var$_toPrimitive(t, r) {
    if ("object" != $2e70b82bf90098ec$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2e70b82bf90098ec$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2e70b82bf90098ec$var$MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $2e70b82bf90098ec$var$ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var $2e70b82bf90098ec$var$CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var $2e70b82bf90098ec$var$NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var $2e70b82bf90098ec$var$CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    "in": 96,
    Q: 96 / 101.6,
    px: 1
};
var $2e70b82bf90098ec$var$FIXED_CSS_LENGTH_UNITS = Object.keys($2e70b82bf90098ec$var$CONVERSION_RATES);
var $2e70b82bf90098ec$var$STR_NAN = "NaN";
function $2e70b82bf90098ec$var$convertToPx(value, unit) {
    return value * $2e70b82bf90098ec$var$CONVERSION_RATES[unit];
}
var $2e70b82bf90098ec$var$DecimalCSS = /*#__PURE__*/ function() {
    function DecimalCSS(num, unit) {
        $2e70b82bf90098ec$var$_classCallCheck(this, DecimalCSS);
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if (Number.isNaN(num)) this.unit = "";
        if (unit !== "" && !$2e70b82bf90098ec$var$CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = "";
        }
        if ($2e70b82bf90098ec$var$FIXED_CSS_LENGTH_UNITS.includes(unit)) {
            this.num = $2e70b82bf90098ec$var$convertToPx(num, unit);
            this.unit = "px";
        }
    }
    $2e70b82bf90098ec$var$_createClass(DecimalCSS, [
        {
            key: "add",
            value: function add(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num + other.num, this.unit);
            }
        },
        {
            key: "subtract",
            value: function subtract(other) {
                if (this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num - other.num, this.unit);
            }
        },
        {
            key: "multiply",
            value: function multiply(other) {
                if (this.unit !== "" && other.unit !== "" && this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num * other.num, this.unit || other.unit);
            }
        },
        {
            key: "divide",
            value: function divide(other) {
                if (this.unit !== "" && other.unit !== "" && this.unit !== other.unit) return new DecimalCSS(NaN, "");
                return new DecimalCSS(this.num / other.num, this.unit || other.unit);
            }
        },
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.num).concat(this.unit);
            }
        },
        {
            key: "isNaN",
            value: function isNaN() {
                return Number.isNaN(this.num);
            }
        }
    ], [
        {
            key: "parse",
            value: function parse(str) {
                var _NUM_SPLIT_REGEX$exec;
                var _ref = (_NUM_SPLIT_REGEX$exec = $2e70b82bf90098ec$var$NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [], _ref2 = $2e70b82bf90098ec$var$_slicedToArray(_ref, 3), numStr = _ref2[1], unit = _ref2[2];
                return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : "");
            }
        }
    ]);
    return DecimalCSS;
}();
function $2e70b82bf90098ec$var$calculateArithmetic(expr) {
    if (expr.includes($2e70b82bf90098ec$var$STR_NAN)) return $2e70b82bf90098ec$var$STR_NAN;
    var newExpr = expr;
    while(newExpr.includes("*") || newExpr.includes("/")){
        var _MULTIPLY_OR_DIVIDE_R;
        var _ref3 = (_MULTIPLY_OR_DIVIDE_R = $2e70b82bf90098ec$var$MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [], _ref4 = $2e70b82bf90098ec$var$_slicedToArray(_ref3, 4), leftOperand = _ref4[1], operator = _ref4[2], rightOperand = _ref4[3];
        var lTs = $2e70b82bf90098ec$var$DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : "");
        var rTs = $2e70b82bf90098ec$var$DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : "");
        var result = operator === "*" ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return $2e70b82bf90098ec$var$STR_NAN;
        newExpr = newExpr.replace($2e70b82bf90098ec$var$MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes("+") || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var _ref5 = (_ADD_OR_SUBTRACT_REGE = $2e70b82bf90098ec$var$ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [], _ref6 = $2e70b82bf90098ec$var$_slicedToArray(_ref5, 4), _leftOperand = _ref6[1], _operator = _ref6[2], _rightOperand = _ref6[3];
        var _lTs = $2e70b82bf90098ec$var$DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : "");
        var _rTs = $2e70b82bf90098ec$var$DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : "");
        var _result = _operator === "+" ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return $2e70b82bf90098ec$var$STR_NAN;
        newExpr = newExpr.replace($2e70b82bf90098ec$var$ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var $2e70b82bf90098ec$var$PARENTHESES_REGEX = /\(([^()]*)\)/;
function $2e70b82bf90098ec$var$calculateParentheses(expr) {
    var newExpr = expr;
    while(newExpr.includes("(")){
        var _PARENTHESES_REGEX$ex = $2e70b82bf90098ec$var$PARENTHESES_REGEX.exec(newExpr), _PARENTHESES_REGEX$ex2 = $2e70b82bf90098ec$var$_slicedToArray(_PARENTHESES_REGEX$ex, 2), parentheticalExpression = _PARENTHESES_REGEX$ex2[1];
        newExpr = newExpr.replace($2e70b82bf90098ec$var$PARENTHESES_REGEX, $2e70b82bf90098ec$var$calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function $2e70b82bf90098ec$var$evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, "");
    newExpr = $2e70b82bf90098ec$var$calculateParentheses(newExpr);
    newExpr = $2e70b82bf90098ec$var$calculateArithmetic(newExpr);
    return newExpr;
}
function $2e70b82bf90098ec$export$c891f73c9c6d00c9(expression) {
    try {
        return $2e70b82bf90098ec$var$evaluateExpression(expression);
    } catch (e) {
        /* istanbul ignore next */ return $2e70b82bf90098ec$var$STR_NAN;
    }
}
function $2e70b82bf90098ec$export$254eac204f89fd7d(expression) {
    var result = $2e70b82bf90098ec$export$c891f73c9c6d00c9(expression.slice(5, -1));
    if (result === $2e70b82bf90098ec$var$STR_NAN) // notify the user
    return "";
    return result;
}


var $724e819505244f32$var$_excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor",
    "fill"
], $724e819505244f32$var$_excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function $724e819505244f32$var$_extends() {
    $724e819505244f32$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $724e819505244f32$var$_extends.apply(this, arguments);
}
function $724e819505244f32$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $724e819505244f32$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $724e819505244f32$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $724e819505244f32$var$_slicedToArray(arr, i) {
    return $724e819505244f32$var$_arrayWithHoles(arr) || $724e819505244f32$var$_iterableToArrayLimit(arr, i) || $724e819505244f32$var$_unsupportedIterableToArray(arr, i) || $724e819505244f32$var$_nonIterableRest();
}
function $724e819505244f32$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $724e819505244f32$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $724e819505244f32$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $724e819505244f32$var$_arrayLikeToArray(o, minLen);
}
function $724e819505244f32$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $724e819505244f32$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $724e819505244f32$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $724e819505244f32$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $724e819505244f32$var$calculateWordWidths = function calculateWordWidths(_ref) {
    var children = _ref.children, breakAll = _ref.breakAll, style = _ref.style;
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(children)) {
            if (breakAll) words = children.toString().split("");
            else words = children.toString().split($724e819505244f32$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $b283dcf1f7838ffe$export$e5560531f057ad5d)(word, style).width
            };
        });
        var spaceWidth = breakAll ? 0 : (0, $b283dcf1f7838ffe$export$e5560531f057ad5d)("\xa0", style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $724e819505244f32$var$calculateWordsByLines = function calculateWordsByLines(_ref2, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var maxLines = _ref2.maxLines, children = _ref2.children, style = _ref2.style, breakAll = _ref2.breakAll;
    var shouldLimitLines = (0, $e6d37abae86076b3$export$7e4aa119212bc614)(maxLines);
    var text = children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref3) {
            var word = _ref3.word, width = _ref3.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "\u2026";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $724e819505244f32$var$calculateWordWidths({
            breakAll: breakAll,
            style: style,
            children: tempText + suffix
        }).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $724e819505244f32$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $724e819505244f32$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $724e819505244f32$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(children) ? children.toString().split($724e819505244f32$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $724e819505244f32$var$getWordsByLines = function getWordsByLines(_ref4) {
    var width = _ref4.width, scaleToFit = _ref4.scaleToFit, children = _ref4.children, style = _ref4.style, breakAll = _ref4.breakAll, maxLines = _ref4.maxLines;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, $ed9b15b562e43bad$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = $724e819505244f32$var$calculateWordWidths({
            breakAll: breakAll,
            children: children,
            style: style
        });
        if (wordWidths) {
            var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return $724e819505244f32$var$getWordsWithoutCalculate(children);
        return $724e819505244f32$var$calculateWordsByLines({
            breakAll: breakAll,
            children: children,
            maxLines: maxLines,
            style: style
        }, wordsWithComputedWidth, spaceWidth, width, scaleToFit);
    }
    return $724e819505244f32$var$getWordsWithoutCalculate(children);
};
var $724e819505244f32$var$DEFAULT_FILL = "#808080";
var $724e819505244f32$export$5f1af8db9871e1d6 = function Text(_ref5) {
    var _ref5$x = _ref5.x, propsX = _ref5$x === void 0 ? 0 : _ref5$x, _ref5$y = _ref5.y, propsY = _ref5$y === void 0 ? 0 : _ref5$y, _ref5$lineHeight = _ref5.lineHeight, lineHeight = _ref5$lineHeight === void 0 ? "1em" : _ref5$lineHeight, _ref5$capHeight = _ref5.capHeight, capHeight = _ref5$capHeight === void 0 ? "0.71em" : _ref5$capHeight, _ref5$scaleToFit = _ref5.scaleToFit, scaleToFit = _ref5$scaleToFit === void 0 ? false : _ref5$scaleToFit, _ref5$textAnchor = _ref5.textAnchor, textAnchor = _ref5$textAnchor === void 0 ? "start" : _ref5$textAnchor, _ref5$verticalAnchor = _ref5.verticalAnchor, verticalAnchor = _ref5$verticalAnchor === void 0 ? "end" : _ref5$verticalAnchor, _ref5$fill = _ref5.fill, fill = _ref5$fill === void 0 ? $724e819505244f32$var$DEFAULT_FILL : _ref5$fill, props = $724e819505244f32$var$_objectWithoutProperties(_ref5, $724e819505244f32$var$_excluded);
    var wordsByLines = (0, $fgmOP.useMemo)(function() {
        return $724e819505244f32$var$getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit: scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var dx = props.dx, dy = props.dy, angle = props.angle, className = props.className, breakAll = props.breakAll, textProps = $724e819505244f32$var$_objectWithoutProperties(props, $724e819505244f32$var$_excluded2);
    if (!(0, $e6d37abae86076b3$export$402a499e1ea44294)(propsX) || !(0, $e6d37abae86076b3$export$402a499e1ea44294)(propsY)) return null;
    var x = propsX + ((0, $e6d37abae86076b3$export$7e4aa119212bc614)(dx) ? dx : 0);
    var y = propsY + ((0, $e6d37abae86076b3$export$7e4aa119212bc614)(dy) ? dy : 0);
    var startDy;
    switch(verticalAnchor){
        case "start":
            startDy = (0, $2e70b82bf90098ec$export$254eac204f89fd7d)("calc(".concat(capHeight, ")"));
            break;
        case "middle":
            startDy = (0, $2e70b82bf90098ec$export$254eac204f89fd7d)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, $2e70b82bf90098ec$export$254eac204f89fd7d)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var width = props.width;
        transforms.push("scale(".concat(((0, $e6d37abae86076b3$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(" ");
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("text", $724e819505244f32$var$_extends({}, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(textProps, true), {
        x: x,
        y: y,
        className: (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-text", className),
        textAnchor: textAnchor,
        fill: fill.includes("url") ? $724e819505244f32$var$DEFAULT_FILL : fill
    }), wordsByLines.map(function(line, index) {
        var words = line.words.join(breakAll ? "" : " ");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: words
        }, words);
    }));
};






var $fgmOP = parcelRequire("fgmOP");



function $edd20ed1082bc6c5$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $edd20ed1082bc6c5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $edd20ed1082bc6c5$var$_typeof(o);
}
function $edd20ed1082bc6c5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $edd20ed1082bc6c5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $edd20ed1082bc6c5$var$ownKeys(Object(t), !0).forEach(function(r) {
            $edd20ed1082bc6c5$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $edd20ed1082bc6c5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $edd20ed1082bc6c5$var$_defineProperty(obj, key, value) {
    key = $edd20ed1082bc6c5$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $edd20ed1082bc6c5$var$_toPropertyKey(t) {
    var i = $edd20ed1082bc6c5$var$_toPrimitive(t, "string");
    return "symbol" == $edd20ed1082bc6c5$var$_typeof(i) ? i : String(i);
}
function $edd20ed1082bc6c5$var$_toPrimitive(t, r) {
    if ("object" != $edd20ed1082bc6c5$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $edd20ed1082bc6c5$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $edd20ed1082bc6c5$var$_slicedToArray(arr, i) {
    return $edd20ed1082bc6c5$var$_arrayWithHoles(arr) || $edd20ed1082bc6c5$var$_iterableToArrayLimit(arr, i) || $edd20ed1082bc6c5$var$_unsupportedIterableToArray(arr, i) || $edd20ed1082bc6c5$var$_nonIterableRest();
}
function $edd20ed1082bc6c5$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $edd20ed1082bc6c5$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $edd20ed1082bc6c5$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $edd20ed1082bc6c5$var$_arrayLikeToArray(o, minLen);
}
function $edd20ed1082bc6c5$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $edd20ed1082bc6c5$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $edd20ed1082bc6c5$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $edd20ed1082bc6c5$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $edd20ed1082bc6c5$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $edd20ed1082bc6c5$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $edd20ed1082bc6c5$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$edd20ed1082bc6c5$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$edd20ed1082bc6c5$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $edd20ed1082bc6c5$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $edd20ed1082bc6c5$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $e6d37abae86076b3$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $e6d37abae86076b3$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $edd20ed1082bc6c5$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $e6d37abae86076b3$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $e6d37abae86076b3$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(axis.range)) {
            if (axisType === "angleAxis") range = [
                startAngle,
                endAngle
            ];
            else if (axisType === "radiusAxis") range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $edd20ed1082bc6c5$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $467312b86c271c9f$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $467312b86c271c9f$export$9d80152e23bae434)(scale);
        var ticks = (0, $467312b86c271c9f$export$ac086aaa4358d590)(scale, $edd20ed1082bc6c5$var$_objectSpread($edd20ed1082bc6c5$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $edd20ed1082bc6c5$var$_objectSpread($edd20ed1082bc6c5$var$_objectSpread($edd20ed1082bc6c5$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $edd20ed1082bc6c5$var$_objectSpread($edd20ed1082bc6c5$var$_objectSpread({}, result), {}, $edd20ed1082bc6c5$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $edd20ed1082bc6c5$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $edd20ed1082bc6c5$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $edd20ed1082bc6c5$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $edd20ed1082bc6c5$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $edd20ed1082bc6c5$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $edd20ed1082bc6c5$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $edd20ed1082bc6c5$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $edd20ed1082bc6c5$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $edd20ed1082bc6c5$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $edd20ed1082bc6c5$var$_objectSpread($edd20ed1082bc6c5$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $edd20ed1082bc6c5$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};
var $edd20ed1082bc6c5$export$88d525dabc04abcd = function getTickClassName(tick) {
    return !/*#__PURE__*/ (0, $fgmOP.isValidElement)(tick) && !(0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(tick) && typeof tick !== "boolean" ? tick.className : "";
};


function $1c1c6cebf3a026b7$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1c1c6cebf3a026b7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1c1c6cebf3a026b7$var$_typeof(o);
}
var $1c1c6cebf3a026b7$var$_excluded = [
    "offset"
];
function $1c1c6cebf3a026b7$var$_toConsumableArray(arr) {
    return $1c1c6cebf3a026b7$var$_arrayWithoutHoles(arr) || $1c1c6cebf3a026b7$var$_iterableToArray(arr) || $1c1c6cebf3a026b7$var$_unsupportedIterableToArray(arr) || $1c1c6cebf3a026b7$var$_nonIterableSpread();
}
function $1c1c6cebf3a026b7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1c1c6cebf3a026b7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1c1c6cebf3a026b7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1c1c6cebf3a026b7$var$_arrayLikeToArray(o, minLen);
}
function $1c1c6cebf3a026b7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1c1c6cebf3a026b7$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1c1c6cebf3a026b7$var$_arrayLikeToArray(arr);
}
function $1c1c6cebf3a026b7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1c1c6cebf3a026b7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1c1c6cebf3a026b7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1c1c6cebf3a026b7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $1c1c6cebf3a026b7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1c1c6cebf3a026b7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1c1c6cebf3a026b7$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1c1c6cebf3a026b7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1c1c6cebf3a026b7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1c1c6cebf3a026b7$var$_defineProperty(obj, key, value) {
    key = $1c1c6cebf3a026b7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1c1c6cebf3a026b7$var$_toPropertyKey(t) {
    var i = $1c1c6cebf3a026b7$var$_toPrimitive(t, "string");
    return "symbol" == $1c1c6cebf3a026b7$var$_typeof(i) ? i : String(i);
}
function $1c1c6cebf3a026b7$var$_toPrimitive(t, r) {
    if ("object" != $1c1c6cebf3a026b7$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1c1c6cebf3a026b7$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1c1c6cebf3a026b7$var$_extends() {
    $1c1c6cebf3a026b7$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1c1c6cebf3a026b7$var$_extends.apply(this, arguments);
}
var $1c1c6cebf3a026b7$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(formatter)) return formatter(label);
    return label;
};
var $1c1c6cebf3a026b7$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $e6d37abae86076b3$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $1c1c6cebf3a026b7$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $1c1c6cebf3a026b7$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === "insideStart") {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === "insideEnd") {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === "end") {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $edd20ed1082bc6c5$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $edd20ed1082bc6c5$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(labelProps.id) ? (0, $e6d37abae86076b3$export$8b15d37bc3f197d4)("recharts-radial-line-") : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("text", $1c1c6cebf3a026b7$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-radial-bar-label", className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $1c1c6cebf3a026b7$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === "outside") {
        var _polarToCartesian = (0, $edd20ed1082bc6c5$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? "start" : "end",
            verticalAnchor: "middle"
        };
    }
    if (position === "center") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
    if (position === "centerTop") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "start"
    };
    if (position === "centerBottom") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "end"
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $edd20ed1082bc6c5$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
};
var $1c1c6cebf3a026b7$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height;
    // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? "end" : "start";
    var verticalStart = verticalSign > 0 ? "start" : "end";
    // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? "end" : "start";
    var horizontalStart = horizontalSign > 0 ? "start" : "end";
    if (position === "top") {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: "middle",
            verticalAnchor: verticalEnd
        };
        return $1c1c6cebf3a026b7$var$_objectSpread($1c1c6cebf3a026b7$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === "bottom") {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: "middle",
            verticalAnchor: verticalStart
        };
        return $1c1c6cebf3a026b7$var$_objectSpread($1c1c6cebf3a026b7$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === "left") {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: "middle"
        };
        return $1c1c6cebf3a026b7$var$_objectSpread($1c1c6cebf3a026b7$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === "right") {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: "middle"
        };
        return $1c1c6cebf3a026b7$var$_objectSpread($1c1c6cebf3a026b7$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === "insideLeft") return $1c1c6cebf3a026b7$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideRight") return $1c1c6cebf3a026b7$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideTop") return $1c1c6cebf3a026b7$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottom") return $1c1c6cebf3a026b7$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideTopLeft") return $1c1c6cebf3a026b7$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideTopRight") return $1c1c6cebf3a026b7$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottomLeft") return $1c1c6cebf3a026b7$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideBottomRight") return $1c1c6cebf3a026b7$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6fd646b25232d34a$exports)))(position) && ((0, $e6d37abae86076b3$export$7e4aa119212bc614)(position.x) || (0, $e6d37abae86076b3$export$e50269385c77c348)(position.x)) && ((0, $e6d37abae86076b3$export$7e4aa119212bc614)(position.y) || (0, $e6d37abae86076b3$export$e50269385c77c348)(position.y))) return $1c1c6cebf3a026b7$var$_objectSpread({
        x: x + (0, $e6d37abae86076b3$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $e6d37abae86076b3$export$476354dbf49bdff6)(position.y, height),
        textAnchor: "end",
        verticalAnchor: "end"
    }, sizeAttrs);
    return $1c1c6cebf3a026b7$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: "middle",
        verticalAnchor: "middle"
    }, sizeAttrs);
};
var $1c1c6cebf3a026b7$var$isPolar = function isPolar(viewBox) {
    return "cx" in viewBox && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(viewBox.cx);
};
function $1c1c6cebf3a026b7$export$b04be29aa201d4f5(_ref4) {
    var _ref4$offset = _ref4.offset, offset = _ref4$offset === void 0 ? 5 : _ref4$offset, restProps = $1c1c6cebf3a026b7$var$_objectWithoutProperties(_ref4, $1c1c6cebf3a026b7$var$_excluded);
    var props = $1c1c6cebf3a026b7$var$_objectSpread({
        offset: offset
    }, restProps);
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(children) && !/*#__PURE__*/ (0, $fgmOP.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $fgmOP.isValidElement)(content)) return /*#__PURE__*/ (0, $fgmOP.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(content)) {
        label = /*#__PURE__*/ (0, $fgmOP.createElement)(content, props);
        if (/*#__PURE__*/ (0, $fgmOP.isValidElement)(label)) return label;
    } else label = $1c1c6cebf3a026b7$var$getLabel(props);
    var isPolarLabel = $1c1c6cebf3a026b7$var$isPolar(viewBox);
    var attrs = (0, $fa0843e4e64def56$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === "insideStart" || position === "insideEnd" || position === "end")) return $1c1c6cebf3a026b7$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $1c1c6cebf3a026b7$var$getAttrsOfPolarLabel(props) : $1c1c6cebf3a026b7$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $724e819505244f32$export$5f1af8db9871e1d6), $1c1c6cebf3a026b7$var$_extends({
        className: (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-label", className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$1c1c6cebf3a026b7$export$b04be29aa201d4f5.displayName = "Label";
var $1c1c6cebf3a026b7$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $e6d37abae86076b3$export$7e4aa119212bc614)(width) && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(height)) {
        if ((0, $e6d37abae86076b3$export$7e4aa119212bc614)(x) && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $e6d37abae86076b3$export$7e4aa119212bc614)(top) && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $e6d37abae86076b3$export$7e4aa119212bc614)(x) && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $e6d37abae86076b3$export$7e4aa119212bc614)(cx) && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $1c1c6cebf3a026b7$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($1c1c6cebf3a026b7$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $e6d37abae86076b3$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($1c1c6cebf3a026b7$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $fgmOP.isValidElement)(label)) {
        if (label.type === $1c1c6cebf3a026b7$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $fgmOP.cloneElement)(label, {
            key: "label-implicit",
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($1c1c6cebf3a026b7$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($1c1c6cebf3a026b7$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6fd646b25232d34a$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($1c1c6cebf3a026b7$export$b04be29aa201d4f5, $1c1c6cebf3a026b7$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $1c1c6cebf3a026b7$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $1c1c6cebf3a026b7$var$parseViewBox(parentProps);
    var explicitChildren = (0, $fa0843e4e64def56$export$fdd5e64c0e8495bb)(children, $1c1c6cebf3a026b7$export$b04be29aa201d4f5).map(function(child, index) {
        return /*#__PURE__*/ (0, $fgmOP.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            // eslint-disable-next-line react/no-array-index-key
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $1c1c6cebf3a026b7$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($1c1c6cebf3a026b7$var$_toConsumableArray(explicitChildren));
};
$1c1c6cebf3a026b7$export$b04be29aa201d4f5.parseViewBox = $1c1c6cebf3a026b7$var$parseViewBox;
$1c1c6cebf3a026b7$export$b04be29aa201d4f5.renderCallByParent = $1c1c6cebf3a026b7$var$renderCallByParent;





function $1cac7df614058a46$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $1cac7df614058a46$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $1cac7df614058a46$var$_typeof(o);
}
var $1cac7df614058a46$var$_excluded = [
    "valueAccessor"
], $1cac7df614058a46$var$_excluded2 = [
    "data",
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll"
];
function $1cac7df614058a46$var$_toConsumableArray(arr) {
    return $1cac7df614058a46$var$_arrayWithoutHoles(arr) || $1cac7df614058a46$var$_iterableToArray(arr) || $1cac7df614058a46$var$_unsupportedIterableToArray(arr) || $1cac7df614058a46$var$_nonIterableSpread();
}
function $1cac7df614058a46$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $1cac7df614058a46$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $1cac7df614058a46$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $1cac7df614058a46$var$_arrayLikeToArray(o, minLen);
}
function $1cac7df614058a46$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $1cac7df614058a46$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $1cac7df614058a46$var$_arrayLikeToArray(arr);
}
function $1cac7df614058a46$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $1cac7df614058a46$var$_extends() {
    $1cac7df614058a46$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1cac7df614058a46$var$_extends.apply(this, arguments);
}
function $1cac7df614058a46$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1cac7df614058a46$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1cac7df614058a46$var$ownKeys(Object(t), !0).forEach(function(r) {
            $1cac7df614058a46$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1cac7df614058a46$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1cac7df614058a46$var$_defineProperty(obj, key, value) {
    key = $1cac7df614058a46$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1cac7df614058a46$var$_toPropertyKey(t) {
    var i = $1cac7df614058a46$var$_toPrimitive(t, "string");
    return "symbol" == $1cac7df614058a46$var$_typeof(i) ? i : String(i);
}
function $1cac7df614058a46$var$_toPrimitive(t, r) {
    if ("object" != $1cac7df614058a46$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $1cac7df614058a46$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $1cac7df614058a46$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $1cac7df614058a46$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $1cac7df614058a46$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $1cac7df614058a46$var$defaultAccessor = function defaultAccessor(entry) {
    return Array.isArray(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($9140a42b0160403d$exports)))(entry.value) : entry.value;
};
function $1cac7df614058a46$export$835fcf23ab7bf88(_ref) {
    var _ref$valueAccessor = _ref.valueAccessor, valueAccessor = _ref$valueAccessor === void 0 ? $1cac7df614058a46$var$defaultAccessor : _ref$valueAccessor, restProps = $1cac7df614058a46$var$_objectWithoutProperties(_ref, $1cac7df614058a46$var$_excluded);
    var data = restProps.data, dataKey = restProps.dataKey, clockWise = restProps.clockWise, id = restProps.id, textBreakAll = restProps.textBreakAll, others = $1cac7df614058a46$var$_objectWithoutProperties(restProps, $1cac7df614058a46$var$_excluded2);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $467312b86c271c9f$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $1c1c6cebf3a026b7$export$b04be29aa201d4f5), $1cac7df614058a46$var$_extends({}, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $1c1c6cebf3a026b7$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(clockWise) ? entry : $1cac7df614058a46$var$_objectSpread($1cac7df614058a46$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
            ,
            index: index
        }));
    }));
}
$1cac7df614058a46$export$835fcf23ab7bf88.displayName = "LabelList";
function $1cac7df614058a46$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($1cac7df614058a46$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($1cac7df614058a46$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6fd646b25232d34a$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($1cac7df614058a46$export$835fcf23ab7bf88, $1cac7df614058a46$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $1cac7df614058a46$var$renderCallByParent(parentProps, data) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChildren = (0, $fa0843e4e64def56$export$fdd5e64c0e8495bb)(children, $1cac7df614058a46$export$835fcf23ab7bf88).map(function(child, index) {
        return /*#__PURE__*/ (0, $fgmOP.cloneElement)(child, {
            data: data,
            // eslint-disable-next-line react/no-array-index-key
            key: "labelList-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabelList = $1cac7df614058a46$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($1cac7df614058a46$var$_toConsumableArray(explicitChildren));
}
$1cac7df614058a46$export$835fcf23ab7bf88.renderCallByParent = $1cac7df614058a46$var$renderCallByParent;








var $fgmOP = parcelRequire("fgmOP");


var $fgmOP = parcelRequire("fgmOP");

var $a40bd9428eaa92da$exports = {};

var $b7d4ae12aedbf9d4$exports = {};

/** Built-in value references. */ var $b7d4ae12aedbf9d4$var$getPrototype = $dd50e77ee6c1b55b$exports(Object.getPrototypeOf, Object);
$b7d4ae12aedbf9d4$exports = $b7d4ae12aedbf9d4$var$getPrototype;



/** `Object#toString` result references. */ var $a40bd9428eaa92da$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $a40bd9428eaa92da$var$funcProto = Function.prototype, $a40bd9428eaa92da$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $a40bd9428eaa92da$var$funcToString = $a40bd9428eaa92da$var$funcProto.toString;
/** Used to check objects for own properties. */ var $a40bd9428eaa92da$var$hasOwnProperty = $a40bd9428eaa92da$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $a40bd9428eaa92da$var$objectCtorString = $a40bd9428eaa92da$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $a40bd9428eaa92da$var$isPlainObject(value) {
    if (!$bff1b3634f78ba00$exports(value) || $ada02440f1acd377$exports(value) != $a40bd9428eaa92da$var$objectTag) return false;
    var proto = $b7d4ae12aedbf9d4$exports(value);
    if (proto === null) return true;
    var Ctor = $a40bd9428eaa92da$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $a40bd9428eaa92da$var$funcToString.call(Ctor) == $a40bd9428eaa92da$var$objectCtorString;
}
$a40bd9428eaa92da$exports = $a40bd9428eaa92da$var$isPlainObject;


var $494c1f081104108c$exports = {};


/** `Object#toString` result references. */ var $494c1f081104108c$var$boolTag = "[object Boolean]";
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $494c1f081104108c$var$isBoolean(value) {
    return value === true || value === false || $bff1b3634f78ba00$exports(value) && $ada02440f1acd377$exports(value) == $494c1f081104108c$var$boolTag;
}
$494c1f081104108c$exports = $494c1f081104108c$var$isBoolean;




var $fgmOP = parcelRequire("fgmOP");



function $a461e5a23755aeba$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a461e5a23755aeba$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a461e5a23755aeba$var$_typeof(o);
}
function $a461e5a23755aeba$var$_extends() {
    $a461e5a23755aeba$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a461e5a23755aeba$var$_extends.apply(this, arguments);
}
function $a461e5a23755aeba$var$_slicedToArray(arr, i) {
    return $a461e5a23755aeba$var$_arrayWithHoles(arr) || $a461e5a23755aeba$var$_iterableToArrayLimit(arr, i) || $a461e5a23755aeba$var$_unsupportedIterableToArray(arr, i) || $a461e5a23755aeba$var$_nonIterableRest();
}
function $a461e5a23755aeba$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a461e5a23755aeba$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a461e5a23755aeba$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a461e5a23755aeba$var$_arrayLikeToArray(o, minLen);
}
function $a461e5a23755aeba$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a461e5a23755aeba$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $a461e5a23755aeba$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a461e5a23755aeba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a461e5a23755aeba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a461e5a23755aeba$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a461e5a23755aeba$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a461e5a23755aeba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a461e5a23755aeba$var$_defineProperty(obj, key, value) {
    key = $a461e5a23755aeba$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a461e5a23755aeba$var$_toPropertyKey(t) {
    var i = $a461e5a23755aeba$var$_toPrimitive(t, "string");
    return "symbol" == $a461e5a23755aeba$var$_typeof(i) ? i : String(i);
}
function $a461e5a23755aeba$var$_toPrimitive(t, r) {
    if ("object" != $a461e5a23755aeba$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a461e5a23755aeba$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $a461e5a23755aeba$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += "Z";
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $a461e5a23755aeba$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $a461e5a23755aeba$var$defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
};
var $a461e5a23755aeba$export$4617fb02663045ef = function Rectangle(rectangleProps) {
    var props = $a461e5a23755aeba$var$_objectSpread($a461e5a23755aeba$var$_objectSpread({}, $a461e5a23755aeba$var$defaultProps), rectangleProps);
    var pathRef = (0, $fgmOP.useRef)();
    var _useState = (0, $fgmOP.useState)(-1), _useState2 = $a461e5a23755aeba$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $fgmOP.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = props.x, y = props.y, width = props.width, height = props.height, radius = props.radius, className = props.className;
    var animationEasing = props.animationEasing, animationDuration = props.animationDuration, animationBegin = props.animationBegin, isAnimationActive = props.isAnimationActive, isUpdateAnimationActive = props.isUpdateAnimationActive;
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-rectangle", className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", $a461e5a23755aeba$var$_extends({}, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: $a461e5a23755aeba$var$getRectanglePath(x, y, width, height, radius)
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $0f3d500d46a22363$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        to: {
            width: width,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $0f3d500d46a22363$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            isActive: isAnimationActive,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", $a461e5a23755aeba$var$_extends({}, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(props, true), {
            className: layerClass,
            d: $a461e5a23755aeba$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef
        })));
    });
};



var $fgmOP = parcelRequire("fgmOP");



function $d8d55093163642f9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $d8d55093163642f9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $d8d55093163642f9$var$_typeof(o);
}
function $d8d55093163642f9$var$_extends() {
    $d8d55093163642f9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d8d55093163642f9$var$_extends.apply(this, arguments);
}
function $d8d55093163642f9$var$_slicedToArray(arr, i) {
    return $d8d55093163642f9$var$_arrayWithHoles(arr) || $d8d55093163642f9$var$_iterableToArrayLimit(arr, i) || $d8d55093163642f9$var$_unsupportedIterableToArray(arr, i) || $d8d55093163642f9$var$_nonIterableRest();
}
function $d8d55093163642f9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d8d55093163642f9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d8d55093163642f9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d8d55093163642f9$var$_arrayLikeToArray(o, minLen);
}
function $d8d55093163642f9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d8d55093163642f9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $d8d55093163642f9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $d8d55093163642f9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d8d55093163642f9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d8d55093163642f9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $d8d55093163642f9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d8d55093163642f9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d8d55093163642f9$var$_defineProperty(obj, key, value) {
    key = $d8d55093163642f9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d8d55093163642f9$var$_toPropertyKey(t) {
    var i = $d8d55093163642f9$var$_toPrimitive(t, "string");
    return "symbol" == $d8d55093163642f9$var$_typeof(i) ? i : String(i);
}
function $d8d55093163642f9$var$_toPrimitive(t, r) {
    if ("object" != $d8d55093163642f9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $d8d55093163642f9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $d8d55093163642f9$var$getTrapezoidPath = function getTrapezoidPath(x, y, upperWidth, lowerWidth, height) {
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = "M ".concat(x, ",").concat(y);
    path += "L ".concat(x + upperWidth, ",").concat(y);
    path += "L ".concat(x + upperWidth - widthGap / 2, ",").concat(y + height);
    path += "L ".concat(x + upperWidth - widthGap / 2 - lowerWidth, ",").concat(y + height);
    path += "L ".concat(x, ",").concat(y, " Z");
    return path;
};
var $d8d55093163642f9$var$defaultProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
};
var $d8d55093163642f9$export$d1ed33dc592f5337 = function Trapezoid(props) {
    var trapezoidProps = $d8d55093163642f9$var$_objectSpread($d8d55093163642f9$var$_objectSpread({}, $d8d55093163642f9$var$defaultProps), props);
    var pathRef = (0, $fgmOP.useRef)();
    var _useState = (0, $fgmOP.useState)(-1), _useState2 = $d8d55093163642f9$var$_slicedToArray(_useState, 2), totalLength = _useState2[0], setTotalLength = _useState2[1];
    (0, $fgmOP.useEffect)(function() {
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (err) {
        // calculate total length error
        }
    }, []);
    var x = trapezoidProps.x, y = trapezoidProps.y, upperWidth = trapezoidProps.upperWidth, lowerWidth = trapezoidProps.lowerWidth, height = trapezoidProps.height, className = trapezoidProps.className;
    var animationEasing = trapezoidProps.animationEasing, animationDuration = trapezoidProps.animationDuration, animationBegin = trapezoidProps.animationBegin, isUpdateAnimationActive = trapezoidProps.isUpdateAnimationActive;
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-trapezoid", className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("g", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", $d8d55093163642f9$var$_extends({}, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(trapezoidProps, true), {
        className: layerClass,
        d: $d8d55093163642f9$var$getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $0f3d500d46a22363$export$2e2bcd8739ae039), {
        canBegin: totalLength > 0,
        from: {
            upperWidth: 0,
            lowerWidth: 0,
            height: height,
            x: x,
            y: y
        },
        to: {
            upperWidth: upperWidth,
            lowerWidth: lowerWidth,
            height: height,
            x: x,
            y: y
        },
        duration: animationDuration,
        animationEasing: animationEasing,
        isActive: isUpdateAnimationActive
    }, function(_ref) {
        var currUpperWidth = _ref.upperWidth, currLowerWidth = _ref.lowerWidth, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $0f3d500d46a22363$export$2e2bcd8739ae039), {
            canBegin: totalLength > 0,
            from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
            to: "".concat(totalLength, "px 0px"),
            attributeName: "strokeDasharray",
            begin: animationBegin,
            duration: animationDuration,
            easing: animationEasing
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", $d8d55093163642f9$var$_extends({}, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(trapezoidProps, true), {
            className: layerClass,
            d: $d8d55093163642f9$var$getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef
        })));
    });
};



var $fgmOP = parcelRequire("fgmOP");




function $be91be79bbc3212f$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $be91be79bbc3212f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $be91be79bbc3212f$var$_typeof(o);
}
function $be91be79bbc3212f$var$_extends() {
    $be91be79bbc3212f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $be91be79bbc3212f$var$_extends.apply(this, arguments);
}
function $be91be79bbc3212f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $be91be79bbc3212f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $be91be79bbc3212f$var$ownKeys(Object(t), !0).forEach(function(r) {
            $be91be79bbc3212f$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $be91be79bbc3212f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $be91be79bbc3212f$var$_defineProperty(obj, key, value) {
    key = $be91be79bbc3212f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $be91be79bbc3212f$var$_toPropertyKey(t) {
    var i = $be91be79bbc3212f$var$_toPrimitive(t, "string");
    return "symbol" == $be91be79bbc3212f$var$_typeof(i) ? i : String(i);
}
function $be91be79bbc3212f$var$_toPrimitive(t, r) {
    if ("object" != $be91be79bbc3212f$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $be91be79bbc3212f$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $be91be79bbc3212f$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $e6d37abae86076b3$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $be91be79bbc3212f$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $edd20ed1082bc6c5$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $edd20ed1082bc6c5$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $edd20ed1082bc6c5$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $edd20ed1082bc6c5$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $edd20ed1082bc6c5$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $be91be79bbc3212f$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $be91be79bbc3212f$var$getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $edd20ed1082bc6c5$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $edd20ed1082bc6c5$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $edd20ed1082bc6c5$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $edd20ed1082bc6c5$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $be91be79bbc3212f$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $e6d37abae86076b3$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $be91be79bbc3212f$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $be91be79bbc3212f$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $be91be79bbc3212f$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $be91be79bbc3212f$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $be91be79bbc3212f$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $be91be79bbc3212f$var$defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var $be91be79bbc3212f$export$e98c2c7eb2b14f45 = function Sector(sectorProps) {
    var props = $be91be79bbc3212f$var$_objectSpread($be91be79bbc3212f$var$_objectSpread({}, $be91be79bbc3212f$var$defaultProps), sectorProps);
    var cx = props.cx, cy = props.cy, innerRadius = props.innerRadius, outerRadius = props.outerRadius, cornerRadius = props.cornerRadius, forceCornerRadius = props.forceCornerRadius, cornerIsExternal = props.cornerIsExternal, startAngle = props.startAngle, endAngle = props.endAngle, className = props.className;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-sector", className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, $e6d37abae86076b3$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $be91be79bbc3212f$var$getSectorWithCorner({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius: forceCornerRadius,
        cornerIsExternal: cornerIsExternal,
        startAngle: startAngle,
        endAngle: endAngle
    });
    else path = $be91be79bbc3212f$var$getSectorPath({
        cx: cx,
        cy: cy,
        innerRadius: innerRadius,
        outerRadius: outerRadius,
        startAngle: startAngle,
        endAngle: endAngle
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", $be91be79bbc3212f$var$_extends({}, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(props, true), {
        className: layerClass,
        d: path,
        role: "img"
    }));
};




var $6430c30b8465b77b$var$_excluded = [
    "option",
    "shapeType",
    "propTransformer",
    "activeClassName",
    "isActive"
];
function $6430c30b8465b77b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $6430c30b8465b77b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $6430c30b8465b77b$var$_typeof(o);
}
function $6430c30b8465b77b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $6430c30b8465b77b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $6430c30b8465b77b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $6430c30b8465b77b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6430c30b8465b77b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6430c30b8465b77b$var$ownKeys(Object(t), !0).forEach(function(r) {
            $6430c30b8465b77b$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6430c30b8465b77b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6430c30b8465b77b$var$_defineProperty(obj, key, value) {
    key = $6430c30b8465b77b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6430c30b8465b77b$var$_toPropertyKey(t) {
    var i = $6430c30b8465b77b$var$_toPrimitive(t, "string");
    return "symbol" == $6430c30b8465b77b$var$_typeof(i) ? i : String(i);
}
function $6430c30b8465b77b$var$_toPrimitive(t, r) {
    if ("object" != $6430c30b8465b77b$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $6430c30b8465b77b$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a react element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function $6430c30b8465b77b$var$defaultPropTransformer(option, props) {
    return $6430c30b8465b77b$var$_objectSpread($6430c30b8465b77b$var$_objectSpread({}, props), option);
}
function $6430c30b8465b77b$var$isSymbolsProps(shapeType, _elementProps) {
    return shapeType === "symbols";
}
function $6430c30b8465b77b$var$ShapeSelector(_ref) {
    var shapeType = _ref.shapeType, elementProps = _ref.elementProps;
    switch(shapeType){
        case "rectangle":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $a461e5a23755aeba$export$4617fb02663045ef), elementProps);
        case "trapezoid":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $d8d55093163642f9$export$d1ed33dc592f5337), elementProps);
        case "sector":
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $be91be79bbc3212f$export$e98c2c7eb2b14f45), elementProps);
        case "symbols":
            if ($6430c30b8465b77b$var$isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $0573268efb13f9bd$export$fa456266707bf4e4), elementProps);
            break;
        default:
            return null;
    }
}
function $6430c30b8465b77b$export$33c4f706a443da24(option) {
    if (/*#__PURE__*/ (0, $fgmOP.isValidElement)(option)) return option.props;
    return option;
}
function $6430c30b8465b77b$export$6428a7f2611ef1fa(_ref2) {
    var option = _ref2.option, shapeType = _ref2.shapeType, _ref2$propTransformer = _ref2.propTransformer, propTransformer = _ref2$propTransformer === void 0 ? $6430c30b8465b77b$var$defaultPropTransformer : _ref2$propTransformer, _ref2$activeClassName = _ref2.activeClassName, activeClassName = _ref2$activeClassName === void 0 ? "recharts-active-shape" : _ref2$activeClassName, isActive = _ref2.isActive, props = $6430c30b8465b77b$var$_objectWithoutProperties(_ref2, $6430c30b8465b77b$var$_excluded);
    var shape;
    if (/*#__PURE__*/ (0, $fgmOP.isValidElement)(option)) shape = /*#__PURE__*/ (0, $fgmOP.cloneElement)(option, $6430c30b8465b77b$var$_objectSpread($6430c30b8465b77b$var$_objectSpread({}, props), $6430c30b8465b77b$export$33c4f706a443da24(option)));
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(option)) shape = option(props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($a40bd9428eaa92da$exports)))(option) && !(0, (/*@__PURE__*/$parcel$interopDefault($494c1f081104108c$exports)))(option)) {
        var nextProps = propTransformer(option, props);
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($6430c30b8465b77b$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($6430c30b8465b77b$var$ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (isActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), {
        className: activeClassName
    }, shape);
    return shape;
}
function $6430c30b8465b77b$export$4b83e8415af38a18(graphicalItem, _item) {
    return _item != null && "trapezoids" in graphicalItem.props;
}
function $6430c30b8465b77b$export$f722d7e63cc07b(graphicalItem, _item) {
    return _item != null && "sectors" in graphicalItem.props;
}
function $6430c30b8465b77b$export$f62b21bcfd1a733e(graphicalItem, _item) {
    return _item != null && "points" in graphicalItem.props;
}
function $6430c30b8465b77b$export$7c9a98b3f068686f(shapeData, activeTooltipItem) {
    var _activeTooltipItem$la, _activeTooltipItem$la2;
    var xMatches = shapeData.x === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la === void 0 ? void 0 : _activeTooltipItem$la.x) || shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === (activeTooltipItem === null || activeTooltipItem === void 0 || (_activeTooltipItem$la2 = activeTooltipItem.labelViewBox) === null || _activeTooltipItem$la2 === void 0 ? void 0 : _activeTooltipItem$la2.y) || shapeData.y === activeTooltipItem.y;
    return xMatches && yMatches;
}
function $6430c30b8465b77b$export$b356b51e8337a02f(shapeData, activeTooltipItem) {
    var startAngleMatches = shapeData.endAngle === activeTooltipItem.endAngle;
    var endAngleMatches = shapeData.startAngle === activeTooltipItem.startAngle;
    return startAngleMatches && endAngleMatches;
}
function $6430c30b8465b77b$export$559c3a78b4889350(shapeData, activeTooltipItem) {
    var xMatches = shapeData.x === activeTooltipItem.x;
    var yMatches = shapeData.y === activeTooltipItem.y;
    var zMatches = shapeData.z === activeTooltipItem.z;
    return xMatches && yMatches && zMatches;
}
function $6430c30b8465b77b$var$getComparisonFn(graphicalItem, activeItem) {
    var comparison;
    if ($6430c30b8465b77b$export$4b83e8415af38a18(graphicalItem, activeItem)) comparison = $6430c30b8465b77b$export$7c9a98b3f068686f;
    else if ($6430c30b8465b77b$export$f722d7e63cc07b(graphicalItem, activeItem)) comparison = $6430c30b8465b77b$export$b356b51e8337a02f;
    else if ($6430c30b8465b77b$export$f62b21bcfd1a733e(graphicalItem, activeItem)) comparison = $6430c30b8465b77b$export$559c3a78b4889350;
    return comparison;
}
function $6430c30b8465b77b$var$getShapeDataKey(graphicalItem, activeItem) {
    var shapeKey;
    if ($6430c30b8465b77b$export$4b83e8415af38a18(graphicalItem, activeItem)) shapeKey = "trapezoids";
    else if ($6430c30b8465b77b$export$f722d7e63cc07b(graphicalItem, activeItem)) shapeKey = "sectors";
    else if ($6430c30b8465b77b$export$f62b21bcfd1a733e(graphicalItem, activeItem)) shapeKey = "points";
    return shapeKey;
}
function $6430c30b8465b77b$var$getActiveShapeTooltipPayload(graphicalItem, activeItem) {
    if ($6430c30b8465b77b$export$4b83e8415af38a18(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa;
        return (_activeItem$tooltipPa = activeItem.tooltipPayload) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa[0]) === null || _activeItem$tooltipPa === void 0 || (_activeItem$tooltipPa = _activeItem$tooltipPa.payload) === null || _activeItem$tooltipPa === void 0 ? void 0 : _activeItem$tooltipPa.payload;
    }
    if ($6430c30b8465b77b$export$f722d7e63cc07b(graphicalItem, activeItem)) {
        var _activeItem$tooltipPa2;
        return (_activeItem$tooltipPa2 = activeItem.tooltipPayload) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2[0]) === null || _activeItem$tooltipPa2 === void 0 || (_activeItem$tooltipPa2 = _activeItem$tooltipPa2.payload) === null || _activeItem$tooltipPa2 === void 0 ? void 0 : _activeItem$tooltipPa2.payload;
    }
    if ($6430c30b8465b77b$export$f62b21bcfd1a733e(graphicalItem, activeItem)) return activeItem.payload;
    return {};
}
function $6430c30b8465b77b$export$bd5d63c57ca4468(_ref3) {
    var activeTooltipItem = _ref3.activeTooltipItem, graphicalItem = _ref3.graphicalItem, itemData = _ref3.itemData;
    var shapeKey = $6430c30b8465b77b$var$getShapeDataKey(graphicalItem, activeTooltipItem);
    var tooltipPayload = $6430c30b8465b77b$var$getActiveShapeTooltipPayload(graphicalItem, activeTooltipItem);
    var activeItemMatches = itemData.filter(function(datum, dataIndex) {
        var valuesMatch = (0, (/*@__PURE__*/$parcel$interopDefault($3e560c71c494b98e$exports)))(tooltipPayload, datum);
        var mouseCoordinateMatches = graphicalItem.props[shapeKey].filter(function(shapeData) {
            var comparison = $6430c30b8465b77b$var$getComparisonFn(graphicalItem, activeTooltipItem);
            return comparison(shapeData, activeTooltipItem);
        });
        // get the last index in case of multiple matches
        var indexOfMouseCoordinates = graphicalItem.props[shapeKey].indexOf(mouseCoordinateMatches[mouseCoordinateMatches.length - 1]);
        var coordinatesMatch = dataIndex === indexOfMouseCoordinates;
        return valuesMatch && coordinatesMatch;
    });
    // get the last index in case of multiple matches
    var activeIndex = itemData.indexOf(activeItemMatches[activeItemMatches.length - 1]);
    return activeIndex;
}


var $11720b8c37a1f9ec$var$_excluded = [
    "x",
    "y"
];
function $11720b8c37a1f9ec$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $11720b8c37a1f9ec$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $11720b8c37a1f9ec$var$_typeof(o);
}
function $11720b8c37a1f9ec$var$_extends() {
    $11720b8c37a1f9ec$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $11720b8c37a1f9ec$var$_extends.apply(this, arguments);
}
function $11720b8c37a1f9ec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $11720b8c37a1f9ec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $11720b8c37a1f9ec$var$ownKeys(Object(t), !0).forEach(function(r) {
            $11720b8c37a1f9ec$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $11720b8c37a1f9ec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $11720b8c37a1f9ec$var$_defineProperty(obj, key, value) {
    key = $11720b8c37a1f9ec$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $11720b8c37a1f9ec$var$_toPropertyKey(t) {
    var i = $11720b8c37a1f9ec$var$_toPrimitive(t, "string");
    return "symbol" == $11720b8c37a1f9ec$var$_typeof(i) ? i : String(i);
}
function $11720b8c37a1f9ec$var$_toPrimitive(t, r) {
    if ("object" != $11720b8c37a1f9ec$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $11720b8c37a1f9ec$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $11720b8c37a1f9ec$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $11720b8c37a1f9ec$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $11720b8c37a1f9ec$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Rectangle props is expecting x, y, height, width as numbers, name as a string, and radius as a custom type
// When props are being spread in from a user defined component in Bar,
// the prop types of an SVGElement have these typed as something else.
// This function will return the passed in props
// along with x, y, height as numbers, name as a string, and radius as number | [number, number, number, number]
function $11720b8c37a1f9ec$var$typeguardBarRectangleProps(_ref, props) {
    var xProp = _ref.x, yProp = _ref.y, option = $11720b8c37a1f9ec$var$_objectWithoutProperties(_ref, $11720b8c37a1f9ec$var$_excluded);
    var xValue = "".concat(xProp);
    var x = parseInt(xValue, 10);
    var yValue = "".concat(yProp);
    var y = parseInt(yValue, 10);
    var heightValue = "".concat(props.height || option.height);
    var height = parseInt(heightValue, 10);
    var widthValue = "".concat(props.width || option.width);
    var width = parseInt(widthValue, 10);
    return $11720b8c37a1f9ec$var$_objectSpread($11720b8c37a1f9ec$var$_objectSpread($11720b8c37a1f9ec$var$_objectSpread($11720b8c37a1f9ec$var$_objectSpread($11720b8c37a1f9ec$var$_objectSpread({}, props), option), x ? {
        x: x
    } : {}), y ? {
        y: y
    } : {}), {}, {
        height: height,
        width: width,
        name: props.name,
        radius: props.radius
    });
}
function $11720b8c37a1f9ec$export$f19074a6842f9217(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $6430c30b8465b77b$export$6428a7f2611ef1fa), $11720b8c37a1f9ec$var$_extends({
        shapeType: "rectangle",
        propTransformer: $11720b8c37a1f9ec$var$typeguardBarRectangleProps,
        activeClassName: "recharts-active-bar"
    }, props));
}
var $11720b8c37a1f9ec$export$c20d73790de171f0 = function minPointSizeCallback(minPointSize) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return function(value, index) {
        if (typeof minPointSize === "number") return minPointSize;
        var isValueNumber = typeof value === "number";
        if (isValueNumber) return minPointSize(value, index);
        !isValueNumber && (0, $157ae7827df642c9$export$2e2bcd8739ae039)(false);
        return defaultValue;
    };
};


var $3a452a1dde49557c$var$_excluded = [
    "value",
    "background"
];
var $3a452a1dde49557c$var$_Bar;
function $3a452a1dde49557c$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $3a452a1dde49557c$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $3a452a1dde49557c$var$_typeof(o);
}
function $3a452a1dde49557c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3a452a1dde49557c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3a452a1dde49557c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $3a452a1dde49557c$var$_extends() {
    $3a452a1dde49557c$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3a452a1dde49557c$var$_extends.apply(this, arguments);
}
function $3a452a1dde49557c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3a452a1dde49557c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3a452a1dde49557c$var$ownKeys(Object(t), !0).forEach(function(r) {
            $3a452a1dde49557c$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3a452a1dde49557c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $3a452a1dde49557c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3a452a1dde49557c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $3a452a1dde49557c$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $3a452a1dde49557c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3a452a1dde49557c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3a452a1dde49557c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $3a452a1dde49557c$var$_callSuper(t, o, e) {
    return o = $3a452a1dde49557c$var$_getPrototypeOf(o), $3a452a1dde49557c$var$_possibleConstructorReturn(t, $3a452a1dde49557c$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $3a452a1dde49557c$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $3a452a1dde49557c$var$_possibleConstructorReturn(self, call) {
    if (call && ($3a452a1dde49557c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $3a452a1dde49557c$var$_assertThisInitialized(self);
}
function $3a452a1dde49557c$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($3a452a1dde49557c$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $3a452a1dde49557c$var$_getPrototypeOf(o) {
    $3a452a1dde49557c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3a452a1dde49557c$var$_getPrototypeOf(o);
}
function $3a452a1dde49557c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3a452a1dde49557c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $3a452a1dde49557c$var$_setPrototypeOf(subClass, superClass);
}
function $3a452a1dde49557c$var$_setPrototypeOf(o, p) {
    $3a452a1dde49557c$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3a452a1dde49557c$var$_setPrototypeOf(o, p);
}
function $3a452a1dde49557c$var$_defineProperty(obj, key, value) {
    key = $3a452a1dde49557c$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3a452a1dde49557c$var$_toPropertyKey(t) {
    var i = $3a452a1dde49557c$var$_toPrimitive(t, "string");
    return "symbol" == $3a452a1dde49557c$var$_typeof(i) ? i : String(i);
}
function $3a452a1dde49557c$var$_toPrimitive(t, r) {
    if ("object" != $3a452a1dde49557c$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $3a452a1dde49557c$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $3a452a1dde49557c$export$bbc6c6369b38e3d1 = /*#__PURE__*/ function(_PureComponent) {
    $3a452a1dde49557c$var$_inherits(Bar, _PureComponent);
    function Bar() {
        var _this;
        $3a452a1dde49557c$var$_classCallCheck(this, Bar);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $3a452a1dde49557c$var$_callSuper(this, Bar, [].concat(args));
        $3a452a1dde49557c$var$_defineProperty($3a452a1dde49557c$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: false
        });
        $3a452a1dde49557c$var$_defineProperty($3a452a1dde49557c$var$_assertThisInitialized(_this), "id", (0, $e6d37abae86076b3$export$8b15d37bc3f197d4)("recharts-bar-"));
        $3a452a1dde49557c$var$_defineProperty($3a452a1dde49557c$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if (onAnimationEnd) onAnimationEnd();
        });
        $3a452a1dde49557c$var$_defineProperty($3a452a1dde49557c$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if (onAnimationStart) onAnimationStart();
        });
        return _this;
    }
    $3a452a1dde49557c$var$_createClass(Bar, [
        {
            key: "renderRectanglesStatically",
            value: function renderRectanglesStatically(data) {
                var _this2 = this;
                var _this$props = this.props, shape = _this$props.shape, dataKey = _this$props.dataKey, activeIndex = _this$props.activeIndex, activeBar = _this$props.activeBar;
                var baseProps = (0, $fa0843e4e64def56$export$d697c39a2985a4c)(this.props, false);
                return data && data.map(function(entry, i) {
                    var isActive = i === activeIndex;
                    var option = isActive ? activeBar : shape;
                    var props = $3a452a1dde49557c$var$_objectSpread($3a452a1dde49557c$var$_objectSpread($3a452a1dde49557c$var$_objectSpread({}, baseProps), entry), {}, {
                        isActive: isActive,
                        option: option,
                        index: i,
                        dataKey: dataKey,
                        onAnimationStart: _this2.handleAnimationStart,
                        onAnimationEnd: _this2.handleAnimationEnd
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), $3a452a1dde49557c$var$_extends({
                        className: "recharts-bar-rectangle"
                    }, (0, $9fee8beacafd8fde$export$ca62be0d67a3158c)(_this2.props, entry, i), {
                        key: "rectangle-".concat(entry === null || entry === void 0 ? void 0 : entry.x, "-").concat(entry === null || entry === void 0 ? void 0 : entry.y, "-").concat(entry === null || entry === void 0 ? void 0 : entry.value)
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $11720b8c37a1f9ec$export$f19074a6842f9217), props));
                });
            }
        },
        {
            key: "renderRectanglesWithAnimation",
            value: function renderRectanglesWithAnimation() {
                var _this3 = this;
                var _this$props2 = this.props, data = _this$props2.data, layout = _this$props2.layout, isAnimationActive = _this$props2.isAnimationActive, animationBegin = _this$props2.animationBegin, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, animationId = _this$props2.animationId;
                var prevData = this.state.prevData;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $0f3d500d46a22363$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "bar-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    var stepData = data.map(function(entry, index) {
                        var prev = prevData && prevData[index];
                        if (prev) {
                            var interpolatorX = (0, $e6d37abae86076b3$export$d871d53bd7eeb390)(prev.x, entry.x);
                            var interpolatorY = (0, $e6d37abae86076b3$export$d871d53bd7eeb390)(prev.y, entry.y);
                            var interpolatorWidth = (0, $e6d37abae86076b3$export$d871d53bd7eeb390)(prev.width, entry.width);
                            var interpolatorHeight = (0, $e6d37abae86076b3$export$d871d53bd7eeb390)(prev.height, entry.height);
                            return $3a452a1dde49557c$var$_objectSpread($3a452a1dde49557c$var$_objectSpread({}, entry), {}, {
                                x: interpolatorX(t),
                                y: interpolatorY(t),
                                width: interpolatorWidth(t),
                                height: interpolatorHeight(t)
                            });
                        }
                        if (layout === "horizontal") {
                            var _interpolatorHeight = (0, $e6d37abae86076b3$export$d871d53bd7eeb390)(0, entry.height);
                            var h = _interpolatorHeight(t);
                            return $3a452a1dde49557c$var$_objectSpread($3a452a1dde49557c$var$_objectSpread({}, entry), {}, {
                                y: entry.y + entry.height - h,
                                height: h
                            });
                        }
                        var interpolator = (0, $e6d37abae86076b3$export$d871d53bd7eeb390)(0, entry.width);
                        var w = interpolator(t);
                        return $3a452a1dde49557c$var$_objectSpread($3a452a1dde49557c$var$_objectSpread({}, entry), {}, {
                            width: w
                        });
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), null, _this3.renderRectanglesStatically(stepData));
                });
            }
        },
        {
            key: "renderRectangles",
            value: function renderRectangles() {
                var _this$props3 = this.props, data = _this$props3.data, isAnimationActive = _this$props3.isAnimationActive;
                var prevData = this.state.prevData;
                if (isAnimationActive && data && data.length && (!prevData || !(0, (/*@__PURE__*/$parcel$interopDefault($3e560c71c494b98e$exports)))(prevData, data))) return this.renderRectanglesWithAnimation();
                return this.renderRectanglesStatically(data);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this4 = this;
                var _this$props4 = this.props, data = _this$props4.data, dataKey = _this$props4.dataKey, activeIndex = _this$props4.activeIndex;
                var backgroundProps = (0, $fa0843e4e64def56$export$d697c39a2985a4c)(this.props.background, false);
                return data.map(function(entry, i) {
                    var value = entry.value, background = entry.background, rest = $3a452a1dde49557c$var$_objectWithoutProperties(entry, $3a452a1dde49557c$var$_excluded);
                    if (!background) return null;
                    var props = $3a452a1dde49557c$var$_objectSpread($3a452a1dde49557c$var$_objectSpread($3a452a1dde49557c$var$_objectSpread($3a452a1dde49557c$var$_objectSpread($3a452a1dde49557c$var$_objectSpread({}, rest), {}, {
                        fill: "#eee"
                    }, background), backgroundProps), (0, $9fee8beacafd8fde$export$ca62be0d67a3158c)(_this4.props, entry, i)), {}, {
                        onAnimationStart: _this4.handleAnimationStart,
                        onAnimationEnd: _this4.handleAnimationEnd,
                        dataKey: dataKey,
                        index: i,
                        key: "background-bar-".concat(i),
                        className: "recharts-bar-background-rectangle"
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $11720b8c37a1f9ec$export$f19074a6842f9217), $3a452a1dde49557c$var$_extends({
                        option: _this4.props.background,
                        isActive: i === activeIndex
                    }, props));
                });
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props5 = this.props, data = _this$props5.data, xAxis = _this$props5.xAxis, yAxis = _this$props5.yAxis, layout = _this$props5.layout, children = _this$props5.children;
                var errorBarItems = (0, $fa0843e4e64def56$export$fdd5e64c0e8495bb)(children, (0, $f95da76a14a4e49e$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var offset = layout === "vertical" ? data[0].height / 2 : data[0].width / 2;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    /**
         * if the value coming from `getComposedData` is an array then this is a stacked bar chart.
         * arr[1] represents end value of the bar since the data is in the form of [startValue, endValue].
         * */ var value = Array.isArray(dataPoint.value) ? dataPoint.value[1] : dataPoint.value;
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: value,
                        errorVal: (0, $467312b86c271c9f$export$f97fc4a450f29a)(dataPoint, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).cloneElement(item, {
                        key: "error-bar-".concat(clipPathId, "-").concat(item.props.dataKey),
                        data: data,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        offset: offset,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, hide = _this$props6.hide, data = _this$props6.data, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, left = _this$props6.left, top = _this$props6.top, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, background = _this$props6.background, id = _this$props6.id;
                if (hide || !data || !data.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var layerClass = (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-bar", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                }))) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), {
                    className: "recharts-bar-rectangles",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, background ? this.renderBackground() : null, this.renderRectangles()), this.renderErrorBar(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $1cac7df614058a46$export$835fcf23ab7bf88).renderCallByParent(this.props, data));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curData: nextProps.data,
                    prevData: prevState.curData
                };
                if (nextProps.data !== prevState.curData) return {
                    curData: nextProps.data
                };
                return null;
            }
        }
    ]);
    return Bar;
}((0, $fgmOP.PureComponent));
$3a452a1dde49557c$var$_Bar = $3a452a1dde49557c$export$bbc6c6369b38e3d1;
$3a452a1dde49557c$var$_defineProperty($3a452a1dde49557c$export$bbc6c6369b38e3d1, "displayName", "Bar");
$3a452a1dde49557c$var$_defineProperty($3a452a1dde49557c$export$bbc6c6369b38e3d1, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    legendType: "rect",
    minPointSize: 0,
    hide: false,
    data: [],
    layout: "vertical",
    activeBar: false,
    isAnimationActive: !(0, $ed9b15b562e43bad$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 400,
    animationEasing: "ease"
});
/**
 * Compose the data of each group
 * @param {Object} props Props for the component
 * @param {Object} item        An instance of Bar
 * @param {Array} barPosition  The offset and size of each bar
 * @param {Object} xAxis       The configuration of x-axis
 * @param {Object} yAxis       The configuration of y-axis
 * @param {Array} stackedData  The stacked data of a bar item
 * @return{Array} Composed data
 */ $3a452a1dde49557c$var$_defineProperty($3a452a1dde49557c$export$bbc6c6369b38e3d1, "getComposedData", function(_ref2) {
    var props = _ref2.props, item = _ref2.item, barPosition = _ref2.barPosition, bandSize = _ref2.bandSize, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var pos = (0, $467312b86c271c9f$export$778e70011fdf4625)(barPosition, item);
    if (!pos) return null;
    var layout = props.layout;
    var _item$props = item.props, dataKey = _item$props.dataKey, children = _item$props.children, minPointSizeProp = _item$props.minPointSize;
    var numericAxis = layout === "horizontal" ? yAxis : xAxis;
    var stackedDomain = stackedData ? numericAxis.scale.domain() : null;
    var baseValue = (0, $467312b86c271c9f$export$54f3200dd4a8a235)({
        numericAxis: numericAxis
    });
    var cells = (0, $fa0843e4e64def56$export$fdd5e64c0e8495bb)(children, (0, $76034bf0313908b8$export$f6f0c3fe4ec306ea));
    var rects = displayedData.map(function(entry, index) {
        var value, x, y, width, height, background;
        if (stackedData) value = (0, $467312b86c271c9f$export$c7ec0fa96d0c462e)(stackedData[dataStartIndex + index], stackedDomain);
        else {
            value = (0, $467312b86c271c9f$export$f97fc4a450f29a)(entry, dataKey);
            if (!Array.isArray(value)) value = [
                baseValue,
                value
            ];
        }
        var minPointSize = (0, $11720b8c37a1f9ec$export$c20d73790de171f0)(minPointSizeProp, $3a452a1dde49557c$var$_Bar.defaultProps.minPointSize)(value[1], index);
        if (layout === "horizontal") {
            var _ref4;
            var _ref3 = [
                yAxis.scale(value[0]),
                yAxis.scale(value[1])
            ], baseValueScale = _ref3[0], currentValueScale = _ref3[1];
            x = (0, $467312b86c271c9f$export$8abb9e87422f3a0c)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            y = (_ref4 = currentValueScale !== null && currentValueScale !== void 0 ? currentValueScale : baseValueScale) !== null && _ref4 !== void 0 ? _ref4 : undefined;
            width = pos.size;
            var computedHeight = baseValueScale - currentValueScale;
            height = Number.isNaN(computedHeight) ? 0 : computedHeight;
            background = {
                x: x,
                y: yAxis.y,
                width: width,
                height: yAxis.height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(height) < Math.abs(minPointSize)) {
                var delta = (0, $e6d37abae86076b3$export$9d334328eb75e624)(height || minPointSize) * (Math.abs(minPointSize) - Math.abs(height));
                y -= delta;
                height += delta;
            }
        } else {
            var _ref5 = [
                xAxis.scale(value[0]),
                xAxis.scale(value[1])
            ], _baseValueScale = _ref5[0], _currentValueScale = _ref5[1];
            x = _baseValueScale;
            y = (0, $467312b86c271c9f$export$8abb9e87422f3a0c)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                offset: pos.offset,
                entry: entry,
                index: index
            });
            width = _currentValueScale - _baseValueScale;
            height = pos.size;
            background = {
                x: xAxis.x,
                y: y,
                width: xAxis.width,
                height: height
            };
            if (Math.abs(minPointSize) > 0 && Math.abs(width) < Math.abs(minPointSize)) {
                var _delta = (0, $e6d37abae86076b3$export$9d334328eb75e624)(width || minPointSize) * (Math.abs(minPointSize) - Math.abs(width));
                width += _delta;
            }
        }
        return $3a452a1dde49557c$var$_objectSpread($3a452a1dde49557c$var$_objectSpread($3a452a1dde49557c$var$_objectSpread({}, entry), {}, {
            x: x,
            y: y,
            width: width,
            height: height,
            value: stackedData ? value : value[1],
            payload: entry,
            background: background
        }, cells && cells[index] && cells[index].props), {}, {
            tooltipPayload: [
                (0, $467312b86c271c9f$export$a4ea3faa19bc2d90)(item, entry)
            ],
            tooltipPosition: {
                x: x + width / 2,
                y: y + height / 2
            }
        });
    });
    return $3a452a1dde49557c$var$_objectSpread({
        data: rects,
        layout: layout
    }, offset);
});


function $8f9440c92078f509$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8f9440c92078f509$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8f9440c92078f509$var$_typeof(o);
}
function $8f9440c92078f509$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $8f9440c92078f509$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $8f9440c92078f509$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $8f9440c92078f509$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $8f9440c92078f509$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $8f9440c92078f509$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $8f9440c92078f509$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8f9440c92078f509$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8f9440c92078f509$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8f9440c92078f509$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8f9440c92078f509$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8f9440c92078f509$var$_defineProperty(obj, key, value) {
    key = $8f9440c92078f509$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8f9440c92078f509$var$_toPropertyKey(t) {
    var i = $8f9440c92078f509$var$_toPrimitive(t, "string");
    return "symbol" == $8f9440c92078f509$var$_typeof(i) ? i : String(i);
}
function $8f9440c92078f509$var$_toPrimitive(t, r) {
    if ("object" != $8f9440c92078f509$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8f9440c92078f509$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $8f9440c92078f509$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $fa0843e4e64def56$export$64c61536a2b72e0f)(children, (0, $3a452a1dde49557c$export$bbc6c6369b38e3d1));
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? "Mirror" : "");
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === "number" && (axis.padding === "gap" || axis.padding === "no-gap")) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort();
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            if (Number.isFinite(smallestDistanceBetweenValues)) {
                var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
                var rangeWidth = axis.layout === "vertical" ? offset.height : offset.width;
                if (axis.padding === "gap") calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
                if (axis.padding === "no-gap") {
                    var gap = (0, $e6d37abae86076b3$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                    var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                    calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
                }
            }
        }
        if (axisType === "xAxis") range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === "yAxis") range = layout === "horizontal" ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $467312b86c271c9f$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $467312b86c271c9f$export$9d80152e23bae434)(scale);
        var ticks = (0, $467312b86c271c9f$export$ac086aaa4358d590)(scale, $8f9440c92078f509$var$_objectSpread($8f9440c92078f509$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === "xAxis") {
            needSpace = orientation === "top" && !mirror || orientation === "bottom" && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === "yAxis") {
            needSpace = orientation === "left" && !mirror || orientation === "right" && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $8f9440c92078f509$var$_objectSpread($8f9440c92078f509$var$_objectSpread($8f9440c92078f509$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === "xAxis" ? offset.width : axis.width,
            height: axisType === "yAxis" ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $467312b86c271c9f$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === "xAxis") steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $8f9440c92078f509$var$_objectSpread($8f9440c92078f509$var$_objectSpread({}, result), {}, $8f9440c92078f509$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $8f9440c92078f509$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $8f9440c92078f509$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $8f9440c92078f509$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $8f9440c92078f509$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $8f9440c92078f509$var$_classCallCheck(this, ScaleHelper);
        this.scale = scale;
    }
    $8f9440c92078f509$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case "start":
                        return this.scale(value);
                    case "middle":
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case "end":
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
    return ScaleHelper;
}();
$8f9440c92078f509$var$_defineProperty($8f9440c92078f509$export$dae1ac4449a69ee8, "EPS", 1e-4);
var $8f9440c92078f509$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $8f9440c92078f509$var$_objectSpread($8f9440c92078f509$var$_objectSpread({}, res), {}, $8f9440c92078f509$var$_defineProperty({}, key, $8f9440c92078f509$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $8f9440c92078f509$var$_objectSpread($8f9440c92078f509$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($f9f846a4f2098ce5$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($54cc0954b777287c$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};
function $8f9440c92078f509$export$e3df76cf4464bc81(angle) {
    return (angle % 180 + 180) % 180;
}
var $8f9440c92078f509$export$3ee78d51cffc2b68 = function getAngledRectangleWidth(_ref6) {
    var width = _ref6.width, height = _ref6.height;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = $8f9440c92078f509$export$e3df76cf4464bc81(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};


/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * If isValid is provided, all candidates must suffice the condition, else undefined is returned.
 * @param {T[]} array An input array.
 * @param {integer} n A number
 * @param {Function} isValid A function to evaluate a candidate form the array
 * @returns {T[]} The result array of the same type as the input array.
 */ function $e12b8fc129235fd6$export$41514b9f058a6886(array, n, isValid) {
    if (n < 1) return [];
    if (n === 1 && isValid === undefined) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        if (isValid === undefined || isValid(array[i]) === true) result.push(array[i]);
        else return undefined;
    }
    return result;
}


function $09d8c4d26e1c2c67$export$a1966f4ad955c82b(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, $8f9440c92078f509$export$3ee78d51cffc2b68)(size, angle);
}
function $09d8c4d26e1c2c67$export$a257eb8806d5033d(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === "width";
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function $09d8c4d26e1c2c67$export$795910f5f15a9633(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function $09d8c4d26e1c2c67$export$beeebbe3ff1b306b(ticks, interval) {
    return (0, $e12b8fc129235fd6$export$41514b9f058a6886)(ticks, interval + 1);
}




function $64ec28c7971e4cdb$export$77bf2ab5711b7f99(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var initialStart = boundaries.start, end = boundaries.end;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluate all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, $e12b8fc129235fd6$export$41514b9f058a6886)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, $09d8c4d26e1c2c67$export$795910f5f15a9633)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}


function $86edc879bedcac50$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $86edc879bedcac50$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $86edc879bedcac50$var$_typeof(o);
}
function $86edc879bedcac50$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $86edc879bedcac50$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $86edc879bedcac50$var$ownKeys(Object(t), !0).forEach(function(r) {
            $86edc879bedcac50$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $86edc879bedcac50$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $86edc879bedcac50$var$_defineProperty(obj, key, value) {
    key = $86edc879bedcac50$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $86edc879bedcac50$var$_toPropertyKey(t) {
    var i = $86edc879bedcac50$var$_toPrimitive(t, "string");
    return "symbol" == $86edc879bedcac50$var$_typeof(i) ? i : String(i);
}
function $86edc879bedcac50$var$_toPrimitive(t, r) {
    if ("object" != $86edc879bedcac50$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $86edc879bedcac50$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $86edc879bedcac50$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start;
    var end = boundaries.end;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = $86edc879bedcac50$var$_objectSpread($86edc879bedcac50$var$_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $86edc879bedcac50$var$_objectSpread($86edc879bedcac50$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $09d8c4d26e1c2c67$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
            result[i] = $86edc879bedcac50$var$_objectSpread($86edc879bedcac50$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function $86edc879bedcac50$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    var result = (ticks || []).slice();
    var len = result.length;
    var start = boundaries.start, end = boundaries.end;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = $86edc879bedcac50$var$_objectSpread($86edc879bedcac50$var$_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        var isTailShow = (0, $09d8c4d26e1c2c67$export$795910f5f15a9633)(sign, tail.tickCoord, function() {
            return tailSize;
        }, start, end);
        if (isTailShow) {
            end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
            result[len - 1] = $86edc879bedcac50$var$_objectSpread($86edc879bedcac50$var$_objectSpread({}, tail), {}, {
                isShow: true
            });
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = function getSize() {
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = $86edc879bedcac50$var$_objectSpread($86edc879bedcac50$var$_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = $86edc879bedcac50$var$_objectSpread($86edc879bedcac50$var$_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        var isShow = (0, $09d8c4d26e1c2c67$export$795910f5f15a9633)(sign, entry.tickCoord, getSize, start, end);
        if (isShow) {
            start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
            result[i] = $86edc879bedcac50$var$_objectSpread($86edc879bedcac50$var$_objectSpread({}, entry), {}, {
                isShow: true
            });
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function $86edc879bedcac50$export$3d27d42b1034de5c(props, fontSize, letterSpacing) {
    var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit, angle = props.angle;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, $e6d37abae86076b3$export$7e4aa119212bc614)(interval) || (0, $ed9b15b562e43bad$export$98f03c5d19621d70).isSsr) return (0, $09d8c4d26e1c2c67$export$beeebbe3ff1b306b)(ticks, typeof interval === "number" && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(interval) ? interval : 0);
    var candidates = [];
    var sizeKey = orientation === "top" || orientation === "bottom" ? "width" : "height";
    var unitSize = unit && sizeKey === "width" ? (0, $b283dcf1f7838ffe$export$e5560531f057ad5d)(unit, {
        fontSize: fontSize,
        letterSpacing: letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = function getTickSize(content, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(tickFormatter) ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === "width" ? (0, $09d8c4d26e1c2c67$export$a1966f4ad955c82b)((0, $b283dcf1f7838ffe$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        }), unitSize, angle) : (0, $b283dcf1f7838ffe$export$e5560531f057ad5d)(value, {
            fontSize: fontSize,
            letterSpacing: letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, $e6d37abae86076b3$export$9d334328eb75e624)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, $09d8c4d26e1c2c67$export$a257eb8806d5033d)(viewBox, sign, sizeKey);
    if (interval === "equidistantPreserveStart") return (0, $64ec28c7971e4cdb$export$77bf2ab5711b7f99)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === "preserveStart" || interval === "preserveStartEnd") candidates = $86edc879bedcac50$var$getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === "preserveStartEnd");
    else candidates = $86edc879bedcac50$var$getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter(function(entry) {
        return entry.isShow;
    });
}



var $fgmOP = parcelRequire("fgmOP");











var $a9c8dc1516444688$var$_excluded = [
    "viewBox"
], $a9c8dc1516444688$var$_excluded2 = [
    "viewBox"
], $a9c8dc1516444688$var$_excluded3 = [
    "ticks"
];
function $a9c8dc1516444688$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a9c8dc1516444688$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a9c8dc1516444688$var$_typeof(o);
}
function $a9c8dc1516444688$var$_extends() {
    $a9c8dc1516444688$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $a9c8dc1516444688$var$_extends.apply(this, arguments);
}
function $a9c8dc1516444688$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a9c8dc1516444688$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a9c8dc1516444688$var$ownKeys(Object(t), !0).forEach(function(r) {
            $a9c8dc1516444688$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a9c8dc1516444688$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a9c8dc1516444688$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $a9c8dc1516444688$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $a9c8dc1516444688$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $a9c8dc1516444688$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a9c8dc1516444688$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $a9c8dc1516444688$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $a9c8dc1516444688$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a9c8dc1516444688$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a9c8dc1516444688$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $a9c8dc1516444688$var$_callSuper(t, o, e) {
    return o = $a9c8dc1516444688$var$_getPrototypeOf(o), $a9c8dc1516444688$var$_possibleConstructorReturn(t, $a9c8dc1516444688$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $a9c8dc1516444688$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $a9c8dc1516444688$var$_possibleConstructorReturn(self, call) {
    if (call && ($a9c8dc1516444688$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $a9c8dc1516444688$var$_assertThisInitialized(self);
}
function $a9c8dc1516444688$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $a9c8dc1516444688$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($a9c8dc1516444688$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $a9c8dc1516444688$var$_getPrototypeOf(o) {
    $a9c8dc1516444688$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $a9c8dc1516444688$var$_getPrototypeOf(o);
}
function $a9c8dc1516444688$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $a9c8dc1516444688$var$_setPrototypeOf(subClass, superClass);
}
function $a9c8dc1516444688$var$_setPrototypeOf(o, p) {
    $a9c8dc1516444688$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $a9c8dc1516444688$var$_setPrototypeOf(o, p);
}
function $a9c8dc1516444688$var$_defineProperty(obj, key, value) {
    key = $a9c8dc1516444688$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $a9c8dc1516444688$var$_toPropertyKey(t) {
    var i = $a9c8dc1516444688$var$_toPrimitive(t, "string");
    return "symbol" == $a9c8dc1516444688$var$_typeof(i) ? i : String(i);
}
function $a9c8dc1516444688$var$_toPrimitive(t, r) {
    if ("object" != $a9c8dc1516444688$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $a9c8dc1516444688$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $a9c8dc1516444688$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    $a9c8dc1516444688$var$_inherits(CartesianAxis, _Component);
    function CartesianAxis(props) {
        var _this;
        $a9c8dc1516444688$var$_classCallCheck(this, CartesianAxis);
        _this = $a9c8dc1516444688$var$_callSuper(this, CartesianAxis, [
            props
        ]);
        _this.state = {
            fontSize: "",
            letterSpacing: ""
        };
        return _this;
    }
    $a9c8dc1516444688$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref, nextState) {
                var viewBox = _ref.viewBox, restProps = $a9c8dc1516444688$var$_objectWithoutProperties(_ref, $a9c8dc1516444688$var$_excluded);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $a9c8dc1516444688$var$_objectWithoutProperties(_this$props, $a9c8dc1516444688$var$_excluded2);
                return !(0, $6d132e2dc77fb074$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $6d132e2dc77fb074$export$d36bdfa510afb180)(restProps, restPropsOld) || !(0, $6d132e2dc77fb074$export$d36bdfa510afb180)(nextState, this.state);
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var htmlLayer = this.layerReference;
                if (!htmlLayer) return;
                var tick = htmlLayer.getElementsByClassName("recharts-cartesian-axis-tick-value")[0];
                if (tick) this.setState({
                    fontSize: window.getComputedStyle(tick).fontSize,
                    letterSpacing: window.getComputedStyle(tick).letterSpacing
                });
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $e6d37abae86076b3$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case "top":
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case "left":
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case "right":
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case "left":
                        textAnchor = mirror ? "start" : "end";
                        break;
                    case "right":
                        textAnchor = mirror ? "end" : "start";
                        break;
                    default:
                        textAnchor = "middle";
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = "end";
                switch(orientation){
                    case "left":
                    case "right":
                        verticalAnchor = "middle";
                        break;
                    case "top":
                        verticalAnchor = mirror ? "start" : "end";
                        break;
                    default:
                        verticalAnchor = mirror ? "end" : "start";
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $a9c8dc1516444688$var$_objectSpread($a9c8dc1516444688$var$_objectSpread($a9c8dc1516444688$var$_objectSpread({}, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(this.props, false)), (0, $fa0843e4e64def56$export$d697c39a2985a4c)(axisLine, false)), {}, {
                    fill: "none"
                });
                if (orientation === "top" || orientation === "bottom") {
                    var needHeight = +(orientation === "top" && !mirror || orientation === "bottom" && mirror);
                    props = $a9c8dc1516444688$var$_objectSpread($a9c8dc1516444688$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === "left" && !mirror || orientation === "right" && mirror);
                    props = $a9c8dc1516444688$var$_objectSpread($a9c8dc1516444688$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("line", $a9c8dc1516444688$var$_extends({}, props, {
                    className: (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-cartesian-axis-line", (0, (/*@__PURE__*/$parcel$interopDefault($d0c0e0e0987fd69b$exports)))(axisLine, "className"))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @param {string} fontSize Fontsize to consider for tick spacing
     * @param {string} letterSpacing Letterspacing to consider for tick spacing
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks, fontSize, letterSpacing) {
                var _this2 = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = (0, $86edc879bedcac50$export$3d27d42b1034de5c)($a9c8dc1516444688$var$_objectSpread($a9c8dc1516444688$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }), fontSize, letterSpacing);
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $fa0843e4e64def56$export$d697c39a2985a4c)(this.props, false);
                var customTickProps = (0, $fa0843e4e64def56$export$d697c39a2985a4c)(tick, false);
                var tickLineProps = $a9c8dc1516444688$var$_objectSpread($a9c8dc1516444688$var$_objectSpread({}, axisProps), {}, {
                    fill: "none"
                }, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(tickLine, false));
                var items = finalTicks.map(function(entry, i) {
                    var _this2$getTickLineCoo = _this2.getTickLineCoord(entry), lineCoord = _this2$getTickLineCoo.line, tickCoord = _this2$getTickLineCoo.tick;
                    var tickProps = $a9c8dc1516444688$var$_objectSpread($a9c8dc1516444688$var$_objectSpread($a9c8dc1516444688$var$_objectSpread($a9c8dc1516444688$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: "none",
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), $a9c8dc1516444688$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
                    }, (0, $9fee8beacafd8fde$export$ca62be0d67a3158c)(_this2.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("line", $a9c8dc1516444688$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-cartesian-axis-tick-line", (0, (/*@__PURE__*/$parcel$interopDefault($d0c0e0e0987fd69b$exports)))(tickLine, "className"))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || "")));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this3 = this;
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $a9c8dc1516444688$var$_objectWithoutProperties(_this$props8, $a9c8dc1516444688$var$_excluded3);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), {
                    className: (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-cartesian-axis", className),
                    ref: function ref(_ref2) {
                        _this3.layerReference = _ref2;
                    }
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks, this.state.fontSize, this.state.letterSpacing), (0, $1c1c6cebf3a026b7$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $724e819505244f32$export$5f1af8db9871e1d6), $a9c8dc1516444688$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return CartesianAxis;
}((0, $fgmOP.Component));
$a9c8dc1516444688$var$_defineProperty($a9c8dc1516444688$export$bdd99f2cdf352bae, "displayName", "CartesianAxis");
$a9c8dc1516444688$var$_defineProperty($a9c8dc1516444688$export$bdd99f2cdf352bae, "defaultProps", {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: "bottom",
    // The ticks
    ticks: [],
    stroke: "#666",
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: "preserveEnd"
});



var $fgmOP = parcelRequire("fgmOP");

var $51a71fc4cae58866$exports = {};
var $3245d72046e391c2$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $3245d72046e391c2$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$8fd0dcf5a894c319$exports(collection)) {
            var iteratee = $86a15e1908191355$exports(predicate, 3);
            collection = $64e8d697e50831f7$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$3245d72046e391c2$exports = $3245d72046e391c2$var$createFind;


var $fa776b72b9a4c2a4$exports = {};


var $0c358df20b49b598$exports = {};
var $aa760505f8438a94$exports = {};
var $83e45abea2f0070d$exports = {};
var $a372b0c9758fdfb1$exports = {};
var $6a6716ad62cc5c05$exports = {};
/** Used to match a single whitespace character. */ var $6a6716ad62cc5c05$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $6a6716ad62cc5c05$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $6a6716ad62cc5c05$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$6a6716ad62cc5c05$exports = $6a6716ad62cc5c05$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $a372b0c9758fdfb1$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $a372b0c9758fdfb1$var$baseTrim(string) {
    return string ? string.slice(0, $6a6716ad62cc5c05$exports(string) + 1).replace($a372b0c9758fdfb1$var$reTrimStart, "") : string;
}
$a372b0c9758fdfb1$exports = $a372b0c9758fdfb1$var$baseTrim;




/** Used as references for various `Number` constants. */ var $83e45abea2f0070d$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $83e45abea2f0070d$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $83e45abea2f0070d$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $83e45abea2f0070d$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $83e45abea2f0070d$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $83e45abea2f0070d$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($1e567e62b72915ef$exports(value)) return $83e45abea2f0070d$var$NAN;
    if ($6fd646b25232d34a$exports(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $6fd646b25232d34a$exports(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $a372b0c9758fdfb1$exports(value);
    var isBinary = $83e45abea2f0070d$var$reIsBinary.test(value);
    return isBinary || $83e45abea2f0070d$var$reIsOctal.test(value) ? $83e45abea2f0070d$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $83e45abea2f0070d$var$reIsBadHex.test(value) ? $83e45abea2f0070d$var$NAN : +value;
}
$83e45abea2f0070d$exports = $83e45abea2f0070d$var$toNumber;


/** Used as references for various `Number` constants. */ var $aa760505f8438a94$var$INFINITY = 1 / 0, $aa760505f8438a94$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $aa760505f8438a94$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $83e45abea2f0070d$exports(value);
    if (value === $aa760505f8438a94$var$INFINITY || value === -$aa760505f8438a94$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $aa760505f8438a94$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$aa760505f8438a94$exports = $aa760505f8438a94$var$toFinite;


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $0c358df20b49b598$var$toInteger(value) {
    var result = $aa760505f8438a94$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$0c358df20b49b598$exports = $0c358df20b49b598$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $fa776b72b9a4c2a4$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $fa776b72b9a4c2a4$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $0c358df20b49b598$exports(fromIndex);
    if (index < 0) index = $fa776b72b9a4c2a4$var$nativeMax(length + index, 0);
    return $7b111fc9a3cf35f1$exports(array, $86a15e1908191355$exports(predicate, 3), index);
}
$fa776b72b9a4c2a4$exports = $fa776b72b9a4c2a4$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $51a71fc4cae58866$var$find = $3245d72046e391c2$exports($fa776b72b9a4c2a4$exports);
$51a71fc4cae58866$exports = $51a71fc4cae58866$var$find;




var $1bcbf862eafcb836$export$7e29f973febe72ad = (0, (/*@__PURE__*/$parcel$interopDefault($53c2345beb4ce48a$exports)))(function(offset) {
    return {
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    };
}, function(offset) {
    return [
        "l",
        offset.left,
        "t",
        offset.top,
        "w",
        offset.width,
        "h",
        offset.height
    ].join("");
});



function $bf7c628d5130940b$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $bf7c628d5130940b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $bf7c628d5130940b$var$_typeof(o);
}
var $bf7c628d5130940b$export$92c2a2c8239475bf = /*#__PURE__*/ (0, $fgmOP.createContext)(undefined);
var $bf7c628d5130940b$export$40ceabe61e17c4dc = /*#__PURE__*/ (0, $fgmOP.createContext)(undefined);
var $bf7c628d5130940b$export$29b7735f8b5653b2 = /*#__PURE__*/ (0, $fgmOP.createContext)(undefined);
var $bf7c628d5130940b$export$482c85f2026f212e = /*#__PURE__*/ (0, $fgmOP.createContext)({});
var $bf7c628d5130940b$export$e42cfe3f3988c70f = /*#__PURE__*/ (0, $fgmOP.createContext)(undefined);
var $bf7c628d5130940b$export$b18854f928720bc8 = /*#__PURE__*/ (0, $fgmOP.createContext)(0);
var $bf7c628d5130940b$export$3c3f0c9338cf7530 = /*#__PURE__*/ (0, $fgmOP.createContext)(0);
var $bf7c628d5130940b$export$e22c0f72c980af5a = function ChartLayoutContextProvider(props) {
    var _props$state = props.state, xAxisMap = _props$state.xAxisMap, yAxisMap = _props$state.yAxisMap, offset = _props$state.offset, clipPathId = props.clipPathId, children = props.children, width = props.width, height = props.height;
    /**
   * Perhaps we should compute this property when reading? Let's see what is more often used
   */ var viewBox = (0, $1bcbf862eafcb836$export$7e29f973febe72ad)(offset);
    /*
   * This pretends to be a single context but actually is split into multiple smaller ones.
   * Why?
   * Because one React Context only allows to set one value.
   * But we need to set multiple values.
   * If we do that with one context, then we force re-render on components that might not even be interested
   * in the part of the state that has changed.
   *
   * By splitting into smaller contexts, we allow each components to be optimized and only re-render when its dependencies change.
   *
   * To actually achieve the optimal re-render, it is necessary to use React.memo().
   * See the test file for details.
   */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($bf7c628d5130940b$export$92c2a2c8239475bf.Provider, {
        value: xAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($bf7c628d5130940b$export$40ceabe61e17c4dc.Provider, {
        value: yAxisMap
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($bf7c628d5130940b$export$482c85f2026f212e.Provider, {
        value: offset
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($bf7c628d5130940b$export$29b7735f8b5653b2.Provider, {
        value: viewBox
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($bf7c628d5130940b$export$e42cfe3f3988c70f.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($bf7c628d5130940b$export$b18854f928720bc8.Provider, {
        value: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($bf7c628d5130940b$export$3c3f0c9338cf7530.Provider, {
        value: width
    }, children)))))));
};
var $bf7c628d5130940b$export$71e825c43eae6ca6 = function useClipPathId() {
    return (0, $fgmOP.useContext)($bf7c628d5130940b$export$e42cfe3f3988c70f);
};
function $bf7c628d5130940b$var$getKeysForDebug(object) {
    var keys = Object.keys(object);
    if (keys.length === 0) return "There are no available ids.";
    return "Available ids are: ".concat(keys, ".");
}
var $bf7c628d5130940b$export$54f54805c81085c5 = function useXAxisOrThrow(xAxisId) {
    var xAxisMap = (0, $fgmOP.useContext)($bf7c628d5130940b$export$92c2a2c8239475bf);
    !(xAxisMap != null) && (0, $157ae7827df642c9$export$2e2bcd8739ae039)(false);
    var xAxis = xAxisMap[xAxisId];
    !(xAxis != null) && (0, $157ae7827df642c9$export$2e2bcd8739ae039)(false);
    return xAxis;
};
var $bf7c628d5130940b$export$1d855c2865750a72 = function useArbitraryXAxis() {
    var xAxisMap = (0, $fgmOP.useContext)($bf7c628d5130940b$export$92c2a2c8239475bf);
    return (0, $e6d37abae86076b3$export$b88993f0aa0bf776)(xAxisMap);
};
var $bf7c628d5130940b$export$a691147b33d52613 = function useArbitraryYAxis() {
    var yAxisMap = (0, $fgmOP.useContext)($bf7c628d5130940b$export$40ceabe61e17c4dc);
    return (0, $e6d37abae86076b3$export$b88993f0aa0bf776)(yAxisMap);
};
var $bf7c628d5130940b$export$631ee617f1052e16 = function useYAxisWithFiniteDomainOrRandom() {
    var yAxisMap = (0, $fgmOP.useContext)($bf7c628d5130940b$export$40ceabe61e17c4dc);
    var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($51a71fc4cae58866$exports)))(yAxisMap, function(axis) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($54cc0954b777287c$exports)))(axis.domain, Number.isFinite);
    });
    return yAxisWithFiniteDomain || (0, $e6d37abae86076b3$export$b88993f0aa0bf776)(yAxisMap);
};
var $bf7c628d5130940b$export$6f8958021ad81c20 = function useYAxisOrThrow(yAxisId) {
    var yAxisMap = (0, $fgmOP.useContext)($bf7c628d5130940b$export$40ceabe61e17c4dc);
    !(yAxisMap != null) && (0, $157ae7827df642c9$export$2e2bcd8739ae039)(false);
    var yAxis = yAxisMap[yAxisId];
    !(yAxis != null) && (0, $157ae7827df642c9$export$2e2bcd8739ae039)(false);
    return yAxis;
};
var $bf7c628d5130940b$export$76b29bb074e0c45a = function useViewBox() {
    var viewBox = (0, $fgmOP.useContext)($bf7c628d5130940b$export$29b7735f8b5653b2);
    return viewBox;
};
var $bf7c628d5130940b$export$99e5207fa7e69f17 = function useOffset() {
    return (0, $fgmOP.useContext)($bf7c628d5130940b$export$482c85f2026f212e);
};
var $bf7c628d5130940b$export$8854f7ece606854b = function useChartWidth() {
    return (0, $fgmOP.useContext)($bf7c628d5130940b$export$3c3f0c9338cf7530);
};
var $bf7c628d5130940b$export$369ae257969c6f9f = function useChartHeight() {
    return (0, $fgmOP.useContext)($bf7c628d5130940b$export$b18854f928720bc8);
};


var $620b095cfe971036$var$_excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], $620b095cfe971036$var$_excluded2 = [
    "offset"
];
function $620b095cfe971036$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $620b095cfe971036$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $620b095cfe971036$var$_typeof(o);
}
function $620b095cfe971036$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $620b095cfe971036$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $620b095cfe971036$var$ownKeys(Object(t), !0).forEach(function(r) {
            $620b095cfe971036$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $620b095cfe971036$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $620b095cfe971036$var$_defineProperty(obj, key, value) {
    key = $620b095cfe971036$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $620b095cfe971036$var$_toPropertyKey(t) {
    var i = $620b095cfe971036$var$_toPrimitive(t, "string");
    return "symbol" == $620b095cfe971036$var$_typeof(i) ? i : String(i);
}
function $620b095cfe971036$var$_toPrimitive(t, r) {
    if ("object" != $620b095cfe971036$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $620b095cfe971036$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $620b095cfe971036$var$_extends() {
    $620b095cfe971036$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $620b095cfe971036$var$_extends.apply(this, arguments);
}
function $620b095cfe971036$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $620b095cfe971036$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $620b095cfe971036$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * The <CartesianGrid horizontal
 */ var $620b095cfe971036$var$Background = function Background(props) {
    var fill = props.fill;
    if (!fill || fill === "none") return null;
    var fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("rect", {
        x: x,
        y: y,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function $620b095cfe971036$var$renderLineItem(option, props) {
    var lineItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(option)) lineItem = option(props);
    else {
        var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $620b095cfe971036$var$_objectWithoutProperties(props, $620b095cfe971036$var$_excluded);
        var _filterProps = (0, $fa0843e4e64def56$export$d697c39a2985a4c)(others, false), __ = _filterProps.offset, restOfFilteredProps = $620b095cfe971036$var$_objectWithoutProperties(_filterProps, $620b095cfe971036$var$_excluded2);
        lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("line", $620b095cfe971036$var$_extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function $620b095cfe971036$var$HorizontalGridLines(props) {
    var x = props.x, width = props.width, _props$horizontal = props.horizontal, horizontal = _props$horizontal === void 0 ? true : _props$horizontal, horizontalPoints = props.horizontalPoints;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var items = horizontalPoints.map(function(entry, i) {
        var lineItemProps = $620b095cfe971036$var$_objectSpread($620b095cfe971036$var$_objectSpread({}, props), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return $620b095cfe971036$var$renderLineItem(horizontal, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function $620b095cfe971036$var$VerticalGridLines(props) {
    var y = props.y, height = props.height, _props$vertical = props.vertical, vertical = _props$vertical === void 0 ? true : _props$vertical, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var items = verticalPoints.map(function(entry, i) {
        var lineItemProps = $620b095cfe971036$var$_objectSpread($620b095cfe971036$var$_objectSpread({}, props), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return $620b095cfe971036$var$renderLineItem(vertical, lineItemProps);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function $620b095cfe971036$var$HorizontalStripes(props) {
    var horizontalFill = props.horizontalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, horizontalPoints = props.horizontalPoints, _props$horizontal2 = props.horizontal, horizontal = _props$horizontal2 === void 0 ? true : _props$horizontal2;
    if (!horizontal || !horizontalFill || !horizontalFill.length) return null;
    // Why =y -y? I was trying to find any difference that this makes, with floating point numbers and edge cases but ... nothing.
    var roundedSortedHorizontalPoints = horizontalPoints.map(function(e) {
        return Math.round(e + y - y);
    }).sort(function(a, b) {
        return a - b;
    });
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map(function(entry, i) {
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var lastStripe = !roundedSortedHorizontalPoints[i + 1];
        var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function $620b095cfe971036$var$VerticalStripes(props) {
    var _props$vertical2 = props.vertical, vertical = _props$vertical2 === void 0 ? true : _props$vertical2, verticalFill = props.verticalFill, fillOpacity = props.fillOpacity, x = props.x, y = props.y, width = props.width, height = props.height, verticalPoints = props.verticalPoints;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map(function(e) {
        return Math.round(e + x - x);
    }).sort(function(a, b) {
        return a - b;
    });
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map(function(entry, i) {
        var lastStripe = !roundedSortedVerticalPoints[i + 1];
        var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("rect", {
            key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
            ,
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var $620b095cfe971036$var$defaultVerticalCoordinatesGenerator = function defaultVerticalCoordinatesGenerator(_ref, syncWithTicks) {
    var xAxis = _ref.xAxis, width = _ref.width, height = _ref.height, offset = _ref.offset;
    return (0, $467312b86c271c9f$export$846dc5ac5fecff74)((0, $86edc879bedcac50$export$3d27d42b1034de5c)($620b095cfe971036$var$_objectSpread($620b095cfe971036$var$_objectSpread($620b095cfe971036$var$_objectSpread({}, (0, $a9c8dc1516444688$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
        ticks: (0, $467312b86c271c9f$export$c829ee42daf7f66d)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var $620b095cfe971036$var$defaultHorizontalCoordinatesGenerator = function defaultHorizontalCoordinatesGenerator(_ref2, syncWithTicks) {
    var yAxis = _ref2.yAxis, width = _ref2.width, height = _ref2.height, offset = _ref2.offset;
    return (0, $467312b86c271c9f$export$846dc5ac5fecff74)((0, $86edc879bedcac50$export$3d27d42b1034de5c)($620b095cfe971036$var$_objectSpread($620b095cfe971036$var$_objectSpread($620b095cfe971036$var$_objectSpread({}, (0, $a9c8dc1516444688$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
        ticks: (0, $467312b86c271c9f$export$c829ee42daf7f66d)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var $620b095cfe971036$var$defaultProps = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: "#ccc",
    fill: "none",
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
};
function $620b095cfe971036$export$6440e27b9f186856(props) {
    var _props$stroke, _props$fill, _props$horizontal3, _props$horizontalFill, _props$vertical3, _props$verticalFill;
    var chartWidth = (0, $bf7c628d5130940b$export$8854f7ece606854b)();
    var chartHeight = (0, $bf7c628d5130940b$export$369ae257969c6f9f)();
    var offset = (0, $bf7c628d5130940b$export$99e5207fa7e69f17)();
    var propsIncludingDefaults = $620b095cfe971036$var$_objectSpread($620b095cfe971036$var$_objectSpread({}, props), {}, {
        stroke: (_props$stroke = props.stroke) !== null && _props$stroke !== void 0 ? _props$stroke : $620b095cfe971036$var$defaultProps.stroke,
        fill: (_props$fill = props.fill) !== null && _props$fill !== void 0 ? _props$fill : $620b095cfe971036$var$defaultProps.fill,
        horizontal: (_props$horizontal3 = props.horizontal) !== null && _props$horizontal3 !== void 0 ? _props$horizontal3 : $620b095cfe971036$var$defaultProps.horizontal,
        horizontalFill: (_props$horizontalFill = props.horizontalFill) !== null && _props$horizontalFill !== void 0 ? _props$horizontalFill : $620b095cfe971036$var$defaultProps.horizontalFill,
        vertical: (_props$vertical3 = props.vertical) !== null && _props$vertical3 !== void 0 ? _props$vertical3 : $620b095cfe971036$var$defaultProps.vertical,
        verticalFill: (_props$verticalFill = props.verticalFill) !== null && _props$verticalFill !== void 0 ? _props$verticalFill : $620b095cfe971036$var$defaultProps.verticalFill,
        x: (0, $e6d37abae86076b3$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
        y: (0, $e6d37abae86076b3$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
        width: (0, $e6d37abae86076b3$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
        height: (0, $e6d37abae86076b3$export$7e4aa119212bc614)(props.height) ? props.height : offset.height
    });
    var x = propsIncludingDefaults.x, y = propsIncludingDefaults.y, width = propsIncludingDefaults.width, height = propsIncludingDefaults.height, syncWithTicks = propsIncludingDefaults.syncWithTicks, horizontalValues = propsIncludingDefaults.horizontalValues, verticalValues = propsIncludingDefaults.verticalValues;
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var xAxis = (0, $bf7c628d5130940b$export$1d855c2865750a72)();
    // @ts-expect-error the scale prop is mixed up - we need to untagle this at some point
    var yAxis = (0, $bf7c628d5130940b$export$631ee617f1052e16)();
    if (!(0, $e6d37abae86076b3$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $e6d37abae86076b3$export$7e4aa119212bc614)(height) || height <= 0 || !(0, $e6d37abae86076b3$export$7e4aa119212bc614)(x) || x !== +x || !(0, $e6d37abae86076b3$export$7e4aa119212bc614)(y) || y !== +y) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside of the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || $620b095cfe971036$var$defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || $620b095cfe971036$var$defaultHorizontalCoordinatesGenerator;
    var horizontalPoints = propsIncludingDefaults.horizontalPoints, verticalPoints = propsIncludingDefaults.verticalPoints;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(horizontalCoordinatesGenerator)) {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? $620b095cfe971036$var$_objectSpread($620b095cfe971036$var$_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, $b8908dd384eb6989$export$c106dd0671a0fc2d)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat($620b095cfe971036$var$_typeof(generatorResult), "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(verticalCoordinatesGenerator)) {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? $620b095cfe971036$var$_objectSpread($620b095cfe971036$var$_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth,
            height: chartHeight,
            offset: offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, $b8908dd384eb6989$export$c106dd0671a0fc2d)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat($620b095cfe971036$var$_typeof(_generatorResult), "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($620b095cfe971036$var$Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($620b095cfe971036$var$HorizontalGridLines, $620b095cfe971036$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($620b095cfe971036$var$VerticalGridLines, $620b095cfe971036$var$_extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($620b095cfe971036$var$HorizontalStripes, $620b095cfe971036$var$_extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement($620b095cfe971036$var$VerticalStripes, $620b095cfe971036$var$_extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })));
}
$620b095cfe971036$export$6440e27b9f186856.displayName = "CartesianGrid";


var $fgmOP = parcelRequire("fgmOP");






var $fgmOP = parcelRequire("fgmOP");







function $55a9a5890e8a5777$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $55a9a5890e8a5777$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $55a9a5890e8a5777$var$_typeof(o);
}
function $55a9a5890e8a5777$var$_extends() {
    $55a9a5890e8a5777$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $55a9a5890e8a5777$var$_extends.apply(this, arguments);
}
function $55a9a5890e8a5777$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $55a9a5890e8a5777$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $55a9a5890e8a5777$var$ownKeys(Object(t), !0).forEach(function(r) {
            $55a9a5890e8a5777$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $55a9a5890e8a5777$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $55a9a5890e8a5777$var$_defineProperty(obj, key, value) {
    key = $55a9a5890e8a5777$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $55a9a5890e8a5777$var$_toPropertyKey(t) {
    var i = $55a9a5890e8a5777$var$_toPrimitive(t, "string");
    return "symbol" == $55a9a5890e8a5777$var$_typeof(i) ? i : String(i);
}
function $55a9a5890e8a5777$var$_toPrimitive(t, r) {
    if ("object" != $55a9a5890e8a5777$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $55a9a5890e8a5777$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $55a9a5890e8a5777$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $61471ee91debe026$exports.curveBasisClosed),
    curveBasisOpen: (0, $61471ee91debe026$exports.curveBasisOpen),
    curveBasis: (0, $61471ee91debe026$exports.curveBasis),
    curveBumpX: (0, $61471ee91debe026$exports.curveBumpX),
    curveBumpY: (0, $61471ee91debe026$exports.curveBumpY),
    curveLinearClosed: (0, $61471ee91debe026$exports.curveLinearClosed),
    curveLinear: (0, $61471ee91debe026$exports.curveLinear),
    curveMonotoneX: (0, $61471ee91debe026$exports.curveMonotoneX),
    curveMonotoneY: (0, $61471ee91debe026$exports.curveMonotoneY),
    curveNatural: (0, $61471ee91debe026$exports.curveNatural),
    curveStep: (0, $61471ee91debe026$exports.curveStep),
    curveStepAfter: (0, $61471ee91debe026$exports.curveStepAfter),
    curveStepBefore: (0, $61471ee91debe026$exports.curveStepBefore)
};
var $55a9a5890e8a5777$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $55a9a5890e8a5777$var$getX = function getX(p) {
    return p.x;
};
var $55a9a5890e8a5777$var$getY = function getY(p) {
    return p.y;
};
var $55a9a5890e8a5777$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($ad0c997ad9c80793$exports)))(type));
    if ((name === "curveMonotone" || name === "curveBump") && layout) return $55a9a5890e8a5777$var$CURVE_FACTORIES["".concat(name).concat(layout === "vertical" ? "Y" : "X")];
    return $55a9a5890e8a5777$var$CURVE_FACTORIES[name] || (0, $61471ee91debe026$exports.curveLinear);
};
var $55a9a5890e8a5777$export$2aa3fd96c49a84a8 = function getPath(_ref) {
    var _ref$type = _ref.type, type = _ref$type === void 0 ? "linear" : _ref$type, _ref$points = _ref.points, points = _ref$points === void 0 ? [] : _ref$points, baseLine = _ref.baseLine, layout = _ref.layout, _ref$connectNulls = _ref.connectNulls, connectNulls = _ref$connectNulls === void 0 ? false : _ref$connectNulls;
    var curveFactory = $55a9a5890e8a5777$var$getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(function(entry) {
        return $55a9a5890e8a5777$var$defined(entry);
    }) : points;
    var lineFunction;
    if (Array.isArray(baseLine)) {
        var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
            return $55a9a5890e8a5777$var$defined(base);
        }) : baseLine;
        var areaPoints = formatPoints.map(function(entry, index) {
            return $55a9a5890e8a5777$var$_objectSpread($55a9a5890e8a5777$var$_objectSpread({}, entry), {}, {
                base: formatBaseLine[index]
            });
        });
        if (layout === "vertical") lineFunction = (0, $61471ee91debe026$exports.area)().y($55a9a5890e8a5777$var$getY).x1($55a9a5890e8a5777$var$getX).x0(function(d) {
            return d.base.x;
        });
        else lineFunction = (0, $61471ee91debe026$exports.area)().x($55a9a5890e8a5777$var$getX).y1($55a9a5890e8a5777$var$getY).y0(function(d) {
            return d.base.y;
        });
        lineFunction.defined($55a9a5890e8a5777$var$defined).curve(curveFactory);
        return lineFunction(areaPoints);
    }
    if (layout === "vertical" && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $61471ee91debe026$exports.area)().y($55a9a5890e8a5777$var$getY).x1($55a9a5890e8a5777$var$getX).x0(baseLine);
    else if ((0, $e6d37abae86076b3$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $61471ee91debe026$exports.area)().x($55a9a5890e8a5777$var$getX).y1($55a9a5890e8a5777$var$getY).y0(baseLine);
    else lineFunction = (0, $61471ee91debe026$exports.line)().x($55a9a5890e8a5777$var$getX).y($55a9a5890e8a5777$var$getY);
    lineFunction.defined($55a9a5890e8a5777$var$defined).curve(curveFactory);
    return lineFunction(formatPoints);
};
var $55a9a5890e8a5777$export$b0e83c3ef8d2db1 = function Curve(props) {
    var className = props.className, points = props.points, path = props.path, pathRef = props.pathRef;
    if ((!points || !points.length) && !path) return null;
    var realPath = points && points.length ? $55a9a5890e8a5777$export$2aa3fd96c49a84a8(props) : path;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", $55a9a5890e8a5777$var$_extends({}, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(props, false), (0, $9fee8beacafd8fde$export$7c4c290a4a9c1b1e)(props), {
        className: (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-curve", className),
        d: realPath,
        ref: pathRef
    }));
};



var $fgmOP = parcelRequire("fgmOP");



function $1698e123872278b0$var$_extends() {
    $1698e123872278b0$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1698e123872278b0$var$_extends.apply(this, arguments);
}
var $1698e123872278b0$export$d046b3c4a416f60d = function Dot(props) {
    var cx = props.cx, cy = props.cy, r = props.r, className = props.className;
    var layerClass = (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-dot", className);
    if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("circle", $1698e123872278b0$var$_extends({}, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(props, false), (0, $9fee8beacafd8fde$export$7c4c290a4a9c1b1e)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};









var $ce2e58c9d73cd4fc$var$_excluded = [
    "type",
    "layout",
    "connectNulls",
    "ref"
];
function $ce2e58c9d73cd4fc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $ce2e58c9d73cd4fc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $ce2e58c9d73cd4fc$var$_typeof(o);
}
function $ce2e58c9d73cd4fc$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ce2e58c9d73cd4fc$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ce2e58c9d73cd4fc$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ce2e58c9d73cd4fc$var$_extends() {
    $ce2e58c9d73cd4fc$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ce2e58c9d73cd4fc$var$_extends.apply(this, arguments);
}
function $ce2e58c9d73cd4fc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ce2e58c9d73cd4fc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ce2e58c9d73cd4fc$var$ownKeys(Object(t), !0).forEach(function(r) {
            $ce2e58c9d73cd4fc$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ce2e58c9d73cd4fc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ce2e58c9d73cd4fc$var$_toConsumableArray(arr) {
    return $ce2e58c9d73cd4fc$var$_arrayWithoutHoles(arr) || $ce2e58c9d73cd4fc$var$_iterableToArray(arr) || $ce2e58c9d73cd4fc$var$_unsupportedIterableToArray(arr) || $ce2e58c9d73cd4fc$var$_nonIterableSpread();
}
function $ce2e58c9d73cd4fc$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ce2e58c9d73cd4fc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ce2e58c9d73cd4fc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ce2e58c9d73cd4fc$var$_arrayLikeToArray(o, minLen);
}
function $ce2e58c9d73cd4fc$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $ce2e58c9d73cd4fc$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ce2e58c9d73cd4fc$var$_arrayLikeToArray(arr);
}
function $ce2e58c9d73cd4fc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ce2e58c9d73cd4fc$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ce2e58c9d73cd4fc$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $ce2e58c9d73cd4fc$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $ce2e58c9d73cd4fc$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ce2e58c9d73cd4fc$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ce2e58c9d73cd4fc$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $ce2e58c9d73cd4fc$var$_callSuper(t, o, e) {
    return o = $ce2e58c9d73cd4fc$var$_getPrototypeOf(o), $ce2e58c9d73cd4fc$var$_possibleConstructorReturn(t, $ce2e58c9d73cd4fc$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $ce2e58c9d73cd4fc$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $ce2e58c9d73cd4fc$var$_possibleConstructorReturn(self, call) {
    if (call && ($ce2e58c9d73cd4fc$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $ce2e58c9d73cd4fc$var$_assertThisInitialized(self);
}
function $ce2e58c9d73cd4fc$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($ce2e58c9d73cd4fc$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $ce2e58c9d73cd4fc$var$_getPrototypeOf(o) {
    $ce2e58c9d73cd4fc$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ce2e58c9d73cd4fc$var$_getPrototypeOf(o);
}
function $ce2e58c9d73cd4fc$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ce2e58c9d73cd4fc$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $ce2e58c9d73cd4fc$var$_setPrototypeOf(subClass, superClass);
}
function $ce2e58c9d73cd4fc$var$_setPrototypeOf(o, p) {
    $ce2e58c9d73cd4fc$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ce2e58c9d73cd4fc$var$_setPrototypeOf(o, p);
}
function $ce2e58c9d73cd4fc$var$_defineProperty(obj, key, value) {
    key = $ce2e58c9d73cd4fc$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ce2e58c9d73cd4fc$var$_toPropertyKey(t) {
    var i = $ce2e58c9d73cd4fc$var$_toPrimitive(t, "string");
    return "symbol" == $ce2e58c9d73cd4fc$var$_typeof(i) ? i : String(i);
}
function $ce2e58c9d73cd4fc$var$_toPrimitive(t, r) {
    if ("object" != $ce2e58c9d73cd4fc$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ce2e58c9d73cd4fc$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $ce2e58c9d73cd4fc$export$17d680238e50603e = /*#__PURE__*/ function(_PureComponent) {
    $ce2e58c9d73cd4fc$var$_inherits(Line, _PureComponent);
    function Line() {
        var _this;
        $ce2e58c9d73cd4fc$var$_classCallCheck(this, Line);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $ce2e58c9d73cd4fc$var$_callSuper(this, Line, [].concat(args));
        $ce2e58c9d73cd4fc$var$_defineProperty($ce2e58c9d73cd4fc$var$_assertThisInitialized(_this), "state", {
            isAnimationFinished: true,
            totalLength: 0
        });
        $ce2e58c9d73cd4fc$var$_defineProperty($ce2e58c9d73cd4fc$var$_assertThisInitialized(_this), "generateSimpleStrokeDasharray", function(totalLength, length) {
            return "".concat(length, "px ").concat(totalLength - length, "px");
        });
        $ce2e58c9d73cd4fc$var$_defineProperty($ce2e58c9d73cd4fc$var$_assertThisInitialized(_this), "getStrokeDasharray", function(length, totalLength, lines) {
            var lineLength = lines.reduce(function(pre, next) {
                return pre + next;
            });
            // if lineLength is 0 return the default when no strokeDasharray is provided
            if (!lineLength) return _this.generateSimpleStrokeDasharray(totalLength, length);
            var count = Math.floor(length / lineLength);
            var remainLength = length % lineLength;
            var restLength = totalLength - length;
            var remainLines = [];
            for(var i = 0, sum = 0; i < lines.length; sum += lines[i], ++i)if (sum + lines[i] > remainLength) {
                remainLines = [].concat($ce2e58c9d73cd4fc$var$_toConsumableArray(lines.slice(0, i)), [
                    remainLength - sum
                ]);
                break;
            }
            var emptyLines = remainLines.length % 2 === 0 ? [
                0,
                restLength
            ] : [
                restLength
            ];
            return [].concat($ce2e58c9d73cd4fc$var$_toConsumableArray(Line.repeat(lines, count)), $ce2e58c9d73cd4fc$var$_toConsumableArray(remainLines), emptyLines).map(function(line) {
                return "".concat(line, "px");
            }).join(", ");
        });
        $ce2e58c9d73cd4fc$var$_defineProperty($ce2e58c9d73cd4fc$var$_assertThisInitialized(_this), "id", (0, $e6d37abae86076b3$export$8b15d37bc3f197d4)("recharts-line-"));
        $ce2e58c9d73cd4fc$var$_defineProperty($ce2e58c9d73cd4fc$var$_assertThisInitialized(_this), "pathRef", function(node) {
            _this.mainCurve = node;
        });
        $ce2e58c9d73cd4fc$var$_defineProperty($ce2e58c9d73cd4fc$var$_assertThisInitialized(_this), "handleAnimationEnd", function() {
            _this.setState({
                isAnimationFinished: true
            });
            if (_this.props.onAnimationEnd) _this.props.onAnimationEnd();
        });
        $ce2e58c9d73cd4fc$var$_defineProperty($ce2e58c9d73cd4fc$var$_assertThisInitialized(_this), "handleAnimationStart", function() {
            _this.setState({
                isAnimationFinished: false
            });
            if (_this.props.onAnimationStart) _this.props.onAnimationStart();
        });
        return _this;
    }
    $ce2e58c9d73cd4fc$var$_createClass(Line, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (!this.props.isAnimationActive) return;
                var totalLength = this.getTotalLength();
                if (totalLength !== this.state.totalLength) this.setState({
                    totalLength: totalLength
                });
            }
        },
        {
            key: "getTotalLength",
            value: function getTotalLength() {
                var curveDom = this.mainCurve;
                try {
                    return curveDom && curveDom.getTotalLength && curveDom.getTotalLength() || 0;
                } catch (err) {
                    return 0;
                }
            }
        },
        {
            key: "renderErrorBar",
            value: function renderErrorBar(needClip, clipPathId) {
                if (this.props.isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props = this.props, points = _this$props.points, xAxis = _this$props.xAxis, yAxis = _this$props.yAxis, layout = _this$props.layout, children = _this$props.children;
                var errorBarItems = (0, $fa0843e4e64def56$export$fdd5e64c0e8495bb)(children, (0, $f95da76a14a4e49e$export$4f4d7676bdf949e5));
                if (!errorBarItems) return null;
                var dataPointFormatter = function dataPointFormatter(dataPoint, dataKey) {
                    return {
                        x: dataPoint.x,
                        y: dataPoint.y,
                        value: dataPoint.value,
                        errorVal: (0, $467312b86c271c9f$export$f97fc4a450f29a)(dataPoint.payload, dataKey)
                    };
                };
                var errorBarProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), errorBarProps, errorBarItems.map(function(item) {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).cloneElement(item, {
                        key: "bar-".concat(item.props.dataKey),
                        data: points,
                        xAxis: xAxis,
                        yAxis: yAxis,
                        layout: layout,
                        dataPointFormatter: dataPointFormatter
                    });
                }));
            }
        },
        {
            key: "renderDots",
            value: function renderDots(needClip, clipDot, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                if (isAnimationActive && !this.state.isAnimationFinished) return null;
                var _this$props2 = this.props, dot = _this$props2.dot, points = _this$props2.points, dataKey = _this$props2.dataKey;
                var lineProps = (0, $fa0843e4e64def56$export$d697c39a2985a4c)(this.props, false);
                var customDotProps = (0, $fa0843e4e64def56$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $ce2e58c9d73cd4fc$var$_objectSpread($ce2e58c9d73cd4fc$var$_objectSpread($ce2e58c9d73cd4fc$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, lineProps), customDotProps), {}, {
                        value: entry.value,
                        dataKey: dataKey,
                        cx: entry.x,
                        cy: entry.y,
                        index: i,
                        payload: entry.payload
                    });
                    return Line.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipDot ? "" : "dots-").concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), $ce2e58c9d73cd4fc$var$_extends({
                    className: "recharts-line-dots",
                    key: "dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderCurveStatically",
            value: function renderCurveStatically(points, needClip, clipPathId, props) {
                var _this$props3 = this.props, type = _this$props3.type, layout = _this$props3.layout, connectNulls = _this$props3.connectNulls, ref = _this$props3.ref, others = $ce2e58c9d73cd4fc$var$_objectWithoutProperties(_this$props3, $ce2e58c9d73cd4fc$var$_excluded);
                var curveProps = $ce2e58c9d73cd4fc$var$_objectSpread($ce2e58c9d73cd4fc$var$_objectSpread($ce2e58c9d73cd4fc$var$_objectSpread({}, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(others, true)), {}, {
                    fill: "none",
                    className: "recharts-line-curve",
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null,
                    points: points
                }, props), {}, {
                    type: type,
                    layout: layout,
                    connectNulls: connectNulls
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $55a9a5890e8a5777$export$b0e83c3ef8d2db1), $ce2e58c9d73cd4fc$var$_extends({}, curveProps, {
                    pathRef: this.pathRef
                }));
            }
        },
        {
            key: "renderCurveWithAnimation",
            value: function renderCurveWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props4 = this.props, points = _this$props4.points, strokeDasharray = _this$props4.strokeDasharray, isAnimationActive = _this$props4.isAnimationActive, animationBegin = _this$props4.animationBegin, animationDuration = _this$props4.animationDuration, animationEasing = _this$props4.animationEasing, animationId = _this$props4.animationId, animateNewValues = _this$props4.animateNewValues, width = _this$props4.width, height = _this$props4.height;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, totalLength = _this$state.totalLength;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $0f3d500d46a22363$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "line-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length;
                        var stepData = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $e6d37abae86076b3$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $e6d37abae86076b3$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $ce2e58c9d73cd4fc$var$_objectSpread($ce2e58c9d73cd4fc$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            // magic number of faking previous x and y location
                            if (animateNewValues) {
                                var _interpolatorX = (0, $e6d37abae86076b3$export$d871d53bd7eeb390)(width * 2, entry.x);
                                var _interpolatorY = (0, $e6d37abae86076b3$export$d871d53bd7eeb390)(height / 2, entry.y);
                                return $ce2e58c9d73cd4fc$var$_objectSpread($ce2e58c9d73cd4fc$var$_objectSpread({}, entry), {}, {
                                    x: _interpolatorX(t),
                                    y: _interpolatorY(t)
                                });
                            }
                            return $ce2e58c9d73cd4fc$var$_objectSpread($ce2e58c9d73cd4fc$var$_objectSpread({}, entry), {}, {
                                x: entry.x,
                                y: entry.y
                            });
                        });
                        return _this2.renderCurveStatically(stepData, needClip, clipPathId);
                    }
                    var interpolator = (0, $e6d37abae86076b3$export$d871d53bd7eeb390)(0, totalLength);
                    var curLength = interpolator(t);
                    var currentStrokeDasharray;
                    if (strokeDasharray) {
                        var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map(function(num) {
                            return parseFloat(num);
                        });
                        currentStrokeDasharray = _this2.getStrokeDasharray(curLength, totalLength, lines);
                    } else currentStrokeDasharray = _this2.generateSimpleStrokeDasharray(totalLength, curLength);
                    return _this2.renderCurveStatically(points, needClip, clipPathId, {
                        strokeDasharray: currentStrokeDasharray
                    });
                });
            }
        },
        {
            key: "renderCurve",
            value: function renderCurve(needClip, clipPathId) {
                var _this$props5 = this.props, points = _this$props5.points, isAnimationActive = _this$props5.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($3e560c71c494b98e$exports)))(prevPoints, points))) return this.renderCurveWithAnimation(needClip, clipPathId);
                return this.renderCurveStatically(points, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _filterProps;
                var _this$props6 = this.props, hide = _this$props6.hide, dot = _this$props6.dot, points = _this$props6.points, className = _this$props6.className, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, top = _this$props6.top, left = _this$props6.left, width = _this$props6.width, height = _this$props6.height, isAnimationActive = _this$props6.isAnimationActive, id = _this$props6.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-line", className);
                var needClipX = xAxis && xAxis.allowDataOverflow;
                var needClipY = yAxis && yAxis.allowDataOverflow;
                var needClip = needClipX || needClipY;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(id) ? this.id : id;
                var _ref2 = (_filterProps = (0, $fa0843e4e64def56$export$d697c39a2985a4c)(dot, false)) !== null && _filterProps !== void 0 ? _filterProps : {
                    r: 3,
                    strokeWidth: 2
                }, _ref2$r = _ref2.r, r = _ref2$r === void 0 ? 3 : _ref2$r, _ref2$strokeWidth = _ref2.strokeWidth, strokeWidth = _ref2$strokeWidth === void 0 ? 2 : _ref2$strokeWidth;
                var _ref3 = (0, $fa0843e4e64def56$export$e78c5929b986eef9)(dot) ? dot : {}, _ref3$clipDot = _ref3.clipDot, clipDot = _ref3$clipDot === void 0 ? true : _ref3$clipDot;
                var dotSize = r * 2 + strokeWidth;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClipX || needClipY ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("rect", {
                    x: needClipX ? left : left - width / 2,
                    y: needClipY ? top : top - height / 2,
                    width: needClipX ? width : width * 2,
                    height: needClipY ? height : height * 2
                })), !clipDot && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("clipPath", {
                    id: "clipPath-dots-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("rect", {
                    x: left - dotSize / 2,
                    y: top - dotSize / 2,
                    width: width + dotSize,
                    height: height + dotSize
                }))) : null, !hasSinglePoint && this.renderCurve(needClip, clipPathId), this.renderErrorBar(needClip, clipPathId), (hasSinglePoint || dot) && this.renderDots(needClip, clipDot, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $1cac7df614058a46$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    prevPoints: prevState.curPoints
                };
                if (nextProps.points !== prevState.curPoints) return {
                    curPoints: nextProps.points
                };
                return null;
            }
        },
        {
            key: "repeat",
            value: function repeat(lines, count) {
                var linesUnit = lines.length % 2 !== 0 ? [].concat($ce2e58c9d73cd4fc$var$_toConsumableArray(lines), [
                    0
                ]) : lines;
                var result = [];
                for(var i = 0; i < count; ++i)result = [].concat($ce2e58c9d73cd4fc$var$_toConsumableArray(result), $ce2e58c9d73cd4fc$var$_toConsumableArray(linesUnit));
                return result;
            }
        },
        {
            key: "renderDotItem",
            value: function renderDotItem(option, props) {
                var dotItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(option)) dotItem = option(props);
                else {
                    var className = (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-line-dot", typeof option !== "boolean" ? option.className : "");
                    dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $1698e123872278b0$export$d046b3c4a416f60d), $ce2e58c9d73cd4fc$var$_extends({}, props, {
                        className: className
                    }));
                }
                return dotItem;
            }
        }
    ]);
    return Line;
}((0, $fgmOP.PureComponent));
$ce2e58c9d73cd4fc$var$_defineProperty($ce2e58c9d73cd4fc$export$17d680238e50603e, "displayName", "Line");
$ce2e58c9d73cd4fc$var$_defineProperty($ce2e58c9d73cd4fc$export$17d680238e50603e, "defaultProps", {
    xAxisId: 0,
    yAxisId: 0,
    connectNulls: false,
    activeDot: true,
    dot: true,
    legendType: "line",
    stroke: "#3182bd",
    strokeWidth: 1,
    fill: "#fff",
    points: [],
    isAnimationActive: !(0, $ed9b15b562e43bad$export$98f03c5d19621d70).isSsr,
    animateNewValues: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease",
    hide: false,
    label: false
});
/**
 * Compose the data of each group
 * @param {Object} props The props from the component
 * @param  {Object} xAxis   The configuration of x-axis
 * @param  {Object} yAxis   The configuration of y-axis
 * @param  {String} dataKey The unique key of a group
 * @return {Array}  Composed data
 */ $ce2e58c9d73cd4fc$var$_defineProperty($ce2e58c9d73cd4fc$export$17d680238e50603e, "getComposedData", function(_ref4) {
    var props = _ref4.props, xAxis = _ref4.xAxis, yAxis = _ref4.yAxis, xAxisTicks = _ref4.xAxisTicks, yAxisTicks = _ref4.yAxisTicks, dataKey = _ref4.dataKey, bandSize = _ref4.bandSize, displayedData = _ref4.displayedData, offset = _ref4.offset;
    var layout = props.layout;
    var points = displayedData.map(function(entry, index) {
        var value = (0, $467312b86c271c9f$export$f97fc4a450f29a)(entry, dataKey);
        if (layout === "horizontal") return {
            x: (0, $467312b86c271c9f$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: (0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(value) ? null : yAxis.scale(value),
            value: value,
            payload: entry
        };
        return {
            x: (0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(value) ? null : xAxis.scale(value),
            y: (0, $467312b86c271c9f$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    return $ce2e58c9d73cd4fc$var$_objectSpread({
        points: points,
        layout: layout
    }, offset);
});

/**
 * @fileOverview Line Chart
 */ 
var $fgmOP = parcelRequire("fgmOP");


var $a3aff5e7543de9ca$exports = {};
var $adadc143895e62b4$exports = {};
var $6cd2d17ae3ae9b9d$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6cd2d17ae3ae9b9d$var$nativeCeil = Math.ceil, $6cd2d17ae3ae9b9d$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $6cd2d17ae3ae9b9d$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $6cd2d17ae3ae9b9d$var$nativeMax($6cd2d17ae3ae9b9d$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$6cd2d17ae3ae9b9d$exports = $6cd2d17ae3ae9b9d$var$baseRange;




/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $adadc143895e62b4$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != "number" && $31c3fe36697999ed$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $aa760505f8438a94$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $aa760505f8438a94$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $aa760505f8438a94$exports(step);
        return $6cd2d17ae3ae9b9d$exports(start, end, step, fromRight);
    };
}
$adadc143895e62b4$exports = $adadc143895e62b4$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $a3aff5e7543de9ca$var$range = $adadc143895e62b4$exports();
$a3aff5e7543de9ca$exports = $a3aff5e7543de9ca$var$range;




var $f1dee9cd6a2dde8d$exports = {};
var $dec16f9e72f3ccea$exports = {};

var $9218aae35e2162df$exports = {};

var $eHWnd = parcelRequire("eHWnd");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $9218aae35e2162df$var$now = function() {
    return $eHWnd.Date.now();
};
$9218aae35e2162df$exports = $9218aae35e2162df$var$now;



/** Error message constants. */ var $dec16f9e72f3ccea$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $dec16f9e72f3ccea$var$nativeMax = Math.max, $dec16f9e72f3ccea$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $dec16f9e72f3ccea$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($dec16f9e72f3ccea$var$FUNC_ERROR_TEXT);
    wait = $83e45abea2f0070d$exports(wait) || 0;
    if ($6fd646b25232d34a$exports(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $dec16f9e72f3ccea$var$nativeMax($83e45abea2f0070d$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $dec16f9e72f3ccea$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $9218aae35e2162df$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($9218aae35e2162df$exports());
    }
    function debounced() {
        var time = $9218aae35e2162df$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$dec16f9e72f3ccea$exports = $dec16f9e72f3ccea$var$debounce;



/** Error message constants. */ var $f1dee9cd6a2dde8d$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $f1dee9cd6a2dde8d$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($f1dee9cd6a2dde8d$var$FUNC_ERROR_TEXT);
    if ($6fd646b25232d34a$exports(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $dec16f9e72f3ccea$exports(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
$f1dee9cd6a2dde8d$exports = $f1dee9cd6a2dde8d$var$throttle;







var $fgmOP = parcelRequire("fgmOP");

var $fgmOP = parcelRequire("fgmOP");




function $f83276f9a9fd10ef$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $f83276f9a9fd10ef$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $f83276f9a9fd10ef$var$_typeof(o);
}
function $f83276f9a9fd10ef$var$_extends() {
    $f83276f9a9fd10ef$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f83276f9a9fd10ef$var$_extends.apply(this, arguments);
}
function $f83276f9a9fd10ef$var$_slicedToArray(arr, i) {
    return $f83276f9a9fd10ef$var$_arrayWithHoles(arr) || $f83276f9a9fd10ef$var$_iterableToArrayLimit(arr, i) || $f83276f9a9fd10ef$var$_unsupportedIterableToArray(arr, i) || $f83276f9a9fd10ef$var$_nonIterableRest();
}
function $f83276f9a9fd10ef$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f83276f9a9fd10ef$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f83276f9a9fd10ef$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f83276f9a9fd10ef$var$_arrayLikeToArray(o, minLen);
}
function $f83276f9a9fd10ef$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f83276f9a9fd10ef$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $f83276f9a9fd10ef$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $f83276f9a9fd10ef$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f83276f9a9fd10ef$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f83276f9a9fd10ef$var$ownKeys(Object(t), !0).forEach(function(r) {
            $f83276f9a9fd10ef$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f83276f9a9fd10ef$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f83276f9a9fd10ef$var$_defineProperty(obj, key, value) {
    key = $f83276f9a9fd10ef$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f83276f9a9fd10ef$var$_toPropertyKey(t) {
    var i = $f83276f9a9fd10ef$var$_toPrimitive(t, "string");
    return "symbol" == $f83276f9a9fd10ef$var$_typeof(i) ? i : String(i);
}
function $f83276f9a9fd10ef$var$_toPrimitive(t, r) {
    if ("object" != $f83276f9a9fd10ef$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $f83276f9a9fd10ef$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $f83276f9a9fd10ef$var$defaultFormatter(value) {
    return Array.isArray(value) && (0, $e6d37abae86076b3$export$402a499e1ea44294)(value[0]) && (0, $e6d37abae86076b3$export$402a499e1ea44294)(value[1]) ? value.join(" ~ ") : value;
}
var $f83276f9a9fd10ef$export$6fe33945eebf9ac8 = function DefaultTooltipContent(props) {
    var _props$separator = props.separator, separator = _props$separator === void 0 ? " : " : _props$separator, _props$contentStyle = props.contentStyle, contentStyle = _props$contentStyle === void 0 ? {} : _props$contentStyle, _props$itemStyle = props.itemStyle, itemStyle = _props$itemStyle === void 0 ? {} : _props$itemStyle, _props$labelStyle = props.labelStyle, labelStyle = _props$labelStyle === void 0 ? {} : _props$labelStyle, payload = props.payload, formatter = props.formatter, itemSorter = props.itemSorter, wrapperClassName = props.wrapperClassName, labelClassName = props.labelClassName, label = props.label, labelFormatter = props.labelFormatter, _props$accessibilityL = props.accessibilityLayer, accessibilityLayer = _props$accessibilityL === void 0 ? false : _props$accessibilityL;
    var renderContent = function renderContent() {
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($024dd103a6f5c4c7$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                if (entry.type === "none") return null;
                var finalItemStyle = $f83276f9a9fd10ef$var$_objectSpread({
                    display: "block",
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || "#000"
                }, itemStyle);
                var finalFormatter = entry.formatter || formatter || $f83276f9a9fd10ef$var$defaultFormatter;
                var value = entry.value, name = entry.name;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter && finalValue != null && finalName != null) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) {
                        var _formatted = $f83276f9a9fd10ef$var$_slicedToArray(formatted, 2);
                        finalValue = _formatted[0];
                        finalName = _formatted[1];
                    } else finalValue = formatted;
                }
                return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, $e6d37abae86076b3$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, $e6d37abae86076b3$export$402a499e1ea44294)(finalName) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || "")));
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = $f83276f9a9fd10ef$var$_objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: "#fff",
        border: "1px solid #ccc",
        whiteSpace: "nowrap"
    }, contentStyle);
    var finalLabelStyle = $f83276f9a9fd10ef$var$_objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(label);
    var finalLabel = hasLabel ? label : "";
    var wrapperCN = (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-default-tooltip", wrapperClassName);
    var labelCN = (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-tooltip-label", labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: "status",
        "aria-live": "assertive"
    } : {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", $f83276f9a9fd10ef$var$_extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};



var $fgmOP = parcelRequire("fgmOP");


function $0ae0c675c8e5a018$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $0ae0c675c8e5a018$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $0ae0c675c8e5a018$var$_typeof(o);
}
function $0ae0c675c8e5a018$var$_defineProperty(obj, key, value) {
    key = $0ae0c675c8e5a018$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0ae0c675c8e5a018$var$_toPropertyKey(t) {
    var i = $0ae0c675c8e5a018$var$_toPrimitive(t, "string");
    return "symbol" == $0ae0c675c8e5a018$var$_typeof(i) ? i : String(i);
}
function $0ae0c675c8e5a018$var$_toPrimitive(t, r) {
    if ("object" != $0ae0c675c8e5a018$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $0ae0c675c8e5a018$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $0ae0c675c8e5a018$var$CSS_CLASS_PREFIX = "recharts-tooltip-wrapper";
var $0ae0c675c8e5a018$var$TOOLTIP_HIDDEN = {
    visibility: "hidden"
};
function $0ae0c675c8e5a018$export$46aee7ef09f78756(_ref) {
    var coordinate = _ref.coordinate, translateX = _ref.translateX, translateY = _ref.translateY;
    return (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)($0ae0c675c8e5a018$var$CSS_CLASS_PREFIX, $0ae0c675c8e5a018$var$_defineProperty($0ae0c675c8e5a018$var$_defineProperty($0ae0c675c8e5a018$var$_defineProperty($0ae0c675c8e5a018$var$_defineProperty({}, "".concat($0ae0c675c8e5a018$var$CSS_CLASS_PREFIX, "-right"), (0, $e6d37abae86076b3$export$7e4aa119212bc614)(translateX) && coordinate && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), "".concat($0ae0c675c8e5a018$var$CSS_CLASS_PREFIX, "-left"), (0, $e6d37abae86076b3$export$7e4aa119212bc614)(translateX) && coordinate && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), "".concat($0ae0c675c8e5a018$var$CSS_CLASS_PREFIX, "-bottom"), (0, $e6d37abae86076b3$export$7e4aa119212bc614)(translateY) && coordinate && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), "".concat($0ae0c675c8e5a018$var$CSS_CLASS_PREFIX, "-top"), (0, $e6d37abae86076b3$export$7e4aa119212bc614)(translateY) && coordinate && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y));
}
function $0ae0c675c8e5a018$export$4cccba03fe0eccc6(_ref2) {
    var allowEscapeViewBox = _ref2.allowEscapeViewBox, coordinate = _ref2.coordinate, key = _ref2.key, offsetTopLeft = _ref2.offsetTopLeft, position = _ref2.position, reverseDirection = _ref2.reverseDirection, tooltipDimension = _ref2.tooltipDimension, viewBox = _ref2.viewBox, viewBoxDimension = _ref2.viewBoxDimension;
    if (position && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - offsetTopLeft;
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBox[key];
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBox[key]);
        return Math.max(negative, viewBox[key]);
    }
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBox[key] + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBox[key]);
    return Math.max(positive, viewBox[key]);
}
function $0ae0c675c8e5a018$export$4fe0982879780f9b(_ref3) {
    var translateX = _ref3.translateX, translateY = _ref3.translateY, useTranslate3d = _ref3.useTranslate3d;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function $0ae0c675c8e5a018$export$25e3b0ae21503056(_ref4) {
    var allowEscapeViewBox = _ref4.allowEscapeViewBox, coordinate = _ref4.coordinate, offsetTopLeft = _ref4.offsetTopLeft, position = _ref4.position, reverseDirection = _ref4.reverseDirection, tooltipBox = _ref4.tooltipBox, useTranslate3d = _ref4.useTranslate3d, viewBox = _ref4.viewBox;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = $0ae0c675c8e5a018$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: "x",
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox: viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = $0ae0c675c8e5a018$export$4cccba03fe0eccc6({
            allowEscapeViewBox: allowEscapeViewBox,
            coordinate: coordinate,
            key: "y",
            offsetTopLeft: offsetTopLeft,
            position: position,
            reverseDirection: reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox: viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = $0ae0c675c8e5a018$export$4fe0982879780f9b({
            translateX: translateX,
            translateY: translateY,
            useTranslate3d: useTranslate3d
        });
    } else cssProperties = $0ae0c675c8e5a018$var$TOOLTIP_HIDDEN;
    return {
        cssProperties: cssProperties,
        cssClasses: $0ae0c675c8e5a018$export$46aee7ef09f78756({
            translateX: translateX,
            translateY: translateY,
            coordinate: coordinate
        })
    };
}


function $c0cea98c2f5076d1$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $c0cea98c2f5076d1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $c0cea98c2f5076d1$var$_typeof(o);
}
function $c0cea98c2f5076d1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c0cea98c2f5076d1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c0cea98c2f5076d1$var$ownKeys(Object(t), !0).forEach(function(r) {
            $c0cea98c2f5076d1$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c0cea98c2f5076d1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c0cea98c2f5076d1$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c0cea98c2f5076d1$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $c0cea98c2f5076d1$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $c0cea98c2f5076d1$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c0cea98c2f5076d1$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c0cea98c2f5076d1$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $c0cea98c2f5076d1$var$_callSuper(t, o, e) {
    return o = $c0cea98c2f5076d1$var$_getPrototypeOf(o), $c0cea98c2f5076d1$var$_possibleConstructorReturn(t, $c0cea98c2f5076d1$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $c0cea98c2f5076d1$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $c0cea98c2f5076d1$var$_possibleConstructorReturn(self, call) {
    if (call && ($c0cea98c2f5076d1$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $c0cea98c2f5076d1$var$_assertThisInitialized(self);
}
function $c0cea98c2f5076d1$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($c0cea98c2f5076d1$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $c0cea98c2f5076d1$var$_getPrototypeOf(o) {
    $c0cea98c2f5076d1$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c0cea98c2f5076d1$var$_getPrototypeOf(o);
}
function $c0cea98c2f5076d1$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c0cea98c2f5076d1$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $c0cea98c2f5076d1$var$_setPrototypeOf(subClass, superClass);
}
function $c0cea98c2f5076d1$var$_setPrototypeOf(o, p) {
    $c0cea98c2f5076d1$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c0cea98c2f5076d1$var$_setPrototypeOf(o, p);
}
function $c0cea98c2f5076d1$var$_defineProperty(obj, key, value) {
    key = $c0cea98c2f5076d1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c0cea98c2f5076d1$var$_toPropertyKey(t) {
    var i = $c0cea98c2f5076d1$var$_toPrimitive(t, "string");
    return "symbol" == $c0cea98c2f5076d1$var$_typeof(i) ? i : String(i);
}
function $c0cea98c2f5076d1$var$_toPrimitive(t, r) {
    if ("object" != $c0cea98c2f5076d1$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $c0cea98c2f5076d1$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $c0cea98c2f5076d1$var$EPSILON = 1;
var $c0cea98c2f5076d1$export$9e6cee7b86551b9c = /*#__PURE__*/ function(_PureComponent) {
    $c0cea98c2f5076d1$var$_inherits(TooltipBoundingBox, _PureComponent);
    function TooltipBoundingBox() {
        var _this;
        $c0cea98c2f5076d1$var$_classCallCheck(this, TooltipBoundingBox);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $c0cea98c2f5076d1$var$_callSuper(this, TooltipBoundingBox, [].concat(args));
        $c0cea98c2f5076d1$var$_defineProperty($c0cea98c2f5076d1$var$_assertThisInitialized(_this), "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            },
            lastBoundingBox: {
                width: -1,
                height: -1
            }
        });
        $c0cea98c2f5076d1$var$_defineProperty($c0cea98c2f5076d1$var$_assertThisInitialized(_this), "handleKeyDown", function(event) {
            if (event.key === "Escape") {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                _this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = _this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = _this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
        return _this;
    }
    $c0cea98c2f5076d1$var$_createClass(TooltipBoundingBox, [
        {
            key: "updateBBox",
            value: function updateBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - this.state.lastBoundingBox.width) > $c0cea98c2f5076d1$var$EPSILON || Math.abs(box.height - this.state.lastBoundingBox.height) > $c0cea98c2f5076d1$var$EPSILON) this.setState({
                        lastBoundingBox: {
                            width: box.width,
                            height: box.height
                        }
                    });
                } else if (this.state.lastBoundingBox.width !== -1 || this.state.lastBoundingBox.height !== -1) this.setState({
                    lastBoundingBox: {
                        width: -1,
                        height: -1
                    }
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.addEventListener("keydown", this.handleKeyDown);
                this.updateBBox();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("keydown", this.handleKeyDown);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                var _this$props$coordinat5, _this$props$coordinat6;
                if (this.props.active) this.updateBBox();
                if (!this.state.dismissed) return;
                if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, children = _this$props.children, coordinate = _this$props.coordinate, hasPayload = _this$props.hasPayload, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var _getTooltipTranslate = (0, $0ae0c675c8e5a018$export$25e3b0ae21503056)({
                    allowEscapeViewBox: allowEscapeViewBox,
                    coordinate: coordinate,
                    offsetTopLeft: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    tooltipBox: this.state.lastBoundingBox,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox
                }), cssClasses = _getTooltipTranslate.cssClasses, cssProperties = _getTooltipTranslate.cssProperties;
                var outerStyle = $c0cea98c2f5076d1$var$_objectSpread($c0cea98c2f5076d1$var$_objectSpread({
                    transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : undefined
                }, cssProperties), {}, {
                    pointerEvents: "none",
                    visibility: !this.state.dismissed && active && hasPayload ? "visible" : "hidden",
                    position: "absolute",
                    top: 0,
                    left: 0
                }, wrapperStyle);
                return(/*#__PURE__*/ // This element allow listening to the `Escape` key.
                // See https://github.com/recharts/recharts/pull/2925
                (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
                    tabIndex: -1,
                    className: cssClasses,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, children));
            }
        }
    ]);
    return TooltipBoundingBox;
}((0, $fgmOP.PureComponent));




function $745d4834f0c300ba$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $745d4834f0c300ba$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $745d4834f0c300ba$var$_typeof(o);
}
function $745d4834f0c300ba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $745d4834f0c300ba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $745d4834f0c300ba$var$ownKeys(Object(t), !0).forEach(function(r) {
            $745d4834f0c300ba$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $745d4834f0c300ba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $745d4834f0c300ba$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $745d4834f0c300ba$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $745d4834f0c300ba$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $745d4834f0c300ba$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $745d4834f0c300ba$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $745d4834f0c300ba$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $745d4834f0c300ba$var$_callSuper(t, o, e) {
    return o = $745d4834f0c300ba$var$_getPrototypeOf(o), $745d4834f0c300ba$var$_possibleConstructorReturn(t, $745d4834f0c300ba$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $745d4834f0c300ba$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $745d4834f0c300ba$var$_possibleConstructorReturn(self, call) {
    if (call && ($745d4834f0c300ba$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $745d4834f0c300ba$var$_assertThisInitialized(self);
}
function $745d4834f0c300ba$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $745d4834f0c300ba$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($745d4834f0c300ba$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $745d4834f0c300ba$var$_getPrototypeOf(o) {
    $745d4834f0c300ba$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $745d4834f0c300ba$var$_getPrototypeOf(o);
}
function $745d4834f0c300ba$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $745d4834f0c300ba$var$_setPrototypeOf(subClass, superClass);
}
function $745d4834f0c300ba$var$_setPrototypeOf(o, p) {
    $745d4834f0c300ba$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $745d4834f0c300ba$var$_setPrototypeOf(o, p);
}
function $745d4834f0c300ba$var$_defineProperty(obj, key, value) {
    key = $745d4834f0c300ba$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $745d4834f0c300ba$var$_toPropertyKey(t) {
    var i = $745d4834f0c300ba$var$_toPrimitive(t, "string");
    return "symbol" == $745d4834f0c300ba$var$_typeof(i) ? i : String(i);
}
function $745d4834f0c300ba$var$_toPrimitive(t, r) {
    if ("object" != $745d4834f0c300ba$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $745d4834f0c300ba$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $745d4834f0c300ba$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $745d4834f0c300ba$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).cloneElement(content, props);
    if (typeof content === "function") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $f83276f9a9fd10ef$export$6fe33945eebf9ac8), props);
}
var $745d4834f0c300ba$export$28c660c63b792dea = /*#__PURE__*/ function(_PureComponent) {
    $745d4834f0c300ba$var$_inherits(Tooltip, _PureComponent);
    function Tooltip() {
        $745d4834f0c300ba$var$_classCallCheck(this, Tooltip);
        return $745d4834f0c300ba$var$_callSuper(this, Tooltip, arguments);
    }
    $745d4834f0c300ba$var$_createClass(Tooltip, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this$props = this.props, active = _this$props.active, allowEscapeViewBox = _this$props.allowEscapeViewBox, animationDuration = _this$props.animationDuration, animationEasing = _this$props.animationEasing, content = _this$props.content, coordinate = _this$props.coordinate, filterNull = _this$props.filterNull, isAnimationActive = _this$props.isAnimationActive, offset = _this$props.offset, payload = _this$props.payload, payloadUniqBy = _this$props.payloadUniqBy, position = _this$props.position, reverseDirection = _this$props.reverseDirection, useTranslate3d = _this$props.useTranslate3d, viewBox = _this$props.viewBox, wrapperStyle = _this$props.wrapperStyle;
                var finalPayload = payload !== null && payload !== void 0 ? payload : [];
                if (filterNull && finalPayload.length) finalPayload = (0, $4c9946dac4cf84e2$export$b67e33c2fb1535fa)(payload.filter(function(entry) {
                    return entry.value != null && (entry.hide !== true || _this.props.includeHidden);
                }), payloadUniqBy, $745d4834f0c300ba$var$defaultUniqBy);
                var hasPayload = finalPayload.length > 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c0cea98c2f5076d1$export$9e6cee7b86551b9c), {
                    allowEscapeViewBox: allowEscapeViewBox,
                    animationDuration: animationDuration,
                    animationEasing: animationEasing,
                    isAnimationActive: isAnimationActive,
                    active: active,
                    coordinate: coordinate,
                    hasPayload: hasPayload,
                    offset: offset,
                    position: position,
                    reverseDirection: reverseDirection,
                    useTranslate3d: useTranslate3d,
                    viewBox: viewBox,
                    wrapperStyle: wrapperStyle
                }, $745d4834f0c300ba$var$renderContent(content, $745d4834f0c300ba$var$_objectSpread($745d4834f0c300ba$var$_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
    return Tooltip;
}((0, $fgmOP.PureComponent));
$745d4834f0c300ba$var$_defineProperty($745d4834f0c300ba$export$28c660c63b792dea, "displayName", "Tooltip");
$745d4834f0c300ba$var$_defineProperty($745d4834f0c300ba$export$28c660c63b792dea, "defaultProps", {
    accessibilityLayer: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: "ease",
    contentStyle: {},
    coordinate: {
        x: 0,
        y: 0
    },
    cursor: true,
    cursorStyle: {},
    filterNull: true,
    isAnimationActive: !(0, $ed9b15b562e43bad$export$98f03c5d19621d70).isSsr,
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: " : ",
    trigger: "hover",
    useTranslate3d: false,
    viewBox: {
        x: 0,
        y: 0,
        height: 0,
        width: 0
    },
    wrapperStyle: {}
});







var $fgmOP = parcelRequire("fgmOP");








function $5a1feb36ca7155b8$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5a1feb36ca7155b8$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5a1feb36ca7155b8$var$_typeof(o);
}
function $5a1feb36ca7155b8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5a1feb36ca7155b8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5a1feb36ca7155b8$var$ownKeys(Object(t), !0).forEach(function(r) {
            $5a1feb36ca7155b8$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5a1feb36ca7155b8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $5a1feb36ca7155b8$var$_defineProperty(obj, key, value) {
    key = $5a1feb36ca7155b8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5a1feb36ca7155b8$var$_toPropertyKey(t) {
    var i = $5a1feb36ca7155b8$var$_toPrimitive(t, "string");
    return "symbol" == $5a1feb36ca7155b8$var$_typeof(i) ? i : String(i);
}
function $5a1feb36ca7155b8$var$_toPrimitive(t, r) {
    if ("object" != $5a1feb36ca7155b8$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $5a1feb36ca7155b8$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $5a1feb36ca7155b8$var$PREFIX_LIST = [
    "Webkit",
    "Moz",
    "O",
    "ms"
];
var $5a1feb36ca7155b8$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $5a1feb36ca7155b8$var$PREFIX_LIST.reduce(function(res, entry) {
        return $5a1feb36ca7155b8$var$_objectSpread($5a1feb36ca7155b8$var$_objectSpread({}, res), {}, $5a1feb36ca7155b8$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $2462b1ef157bd0f4$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $2462b1ef157bd0f4$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $2462b1ef157bd0f4$var$_typeof(o);
}
function $2462b1ef157bd0f4$var$_extends() {
    $2462b1ef157bd0f4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2462b1ef157bd0f4$var$_extends.apply(this, arguments);
}
function $2462b1ef157bd0f4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2462b1ef157bd0f4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2462b1ef157bd0f4$var$ownKeys(Object(t), !0).forEach(function(r) {
            $2462b1ef157bd0f4$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2462b1ef157bd0f4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $2462b1ef157bd0f4$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $2462b1ef157bd0f4$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $2462b1ef157bd0f4$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $2462b1ef157bd0f4$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $2462b1ef157bd0f4$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $2462b1ef157bd0f4$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $2462b1ef157bd0f4$var$_callSuper(t, o, e) {
    return o = $2462b1ef157bd0f4$var$_getPrototypeOf(o), $2462b1ef157bd0f4$var$_possibleConstructorReturn(t, $2462b1ef157bd0f4$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $2462b1ef157bd0f4$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $2462b1ef157bd0f4$var$_possibleConstructorReturn(self, call) {
    if (call && ($2462b1ef157bd0f4$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $2462b1ef157bd0f4$var$_assertThisInitialized(self);
}
function $2462b1ef157bd0f4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($2462b1ef157bd0f4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $2462b1ef157bd0f4$var$_getPrototypeOf(o) {
    $2462b1ef157bd0f4$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $2462b1ef157bd0f4$var$_getPrototypeOf(o);
}
function $2462b1ef157bd0f4$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $2462b1ef157bd0f4$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $2462b1ef157bd0f4$var$_setPrototypeOf(subClass, superClass);
}
function $2462b1ef157bd0f4$var$_setPrototypeOf(o, p) {
    $2462b1ef157bd0f4$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $2462b1ef157bd0f4$var$_setPrototypeOf(o, p);
}
function $2462b1ef157bd0f4$var$_defineProperty(obj, key, value) {
    key = $2462b1ef157bd0f4$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2462b1ef157bd0f4$var$_toPropertyKey(t) {
    var i = $2462b1ef157bd0f4$var$_toPrimitive(t, "string");
    return "symbol" == $2462b1ef157bd0f4$var$_typeof(i) ? i : String(i);
}
function $2462b1ef157bd0f4$var$_toPrimitive(t, r) {
    if ("object" != $2462b1ef157bd0f4$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $2462b1ef157bd0f4$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $2462b1ef157bd0f4$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $3223330f788ca226$exports.scalePoint)().domain((0, (/*@__PURE__*/$parcel$interopDefault($a3aff5e7543de9ca$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        isTravellerFocused: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $2462b1ef157bd0f4$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $2462b1ef157bd0f4$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    $2462b1ef157bd0f4$var$_inherits(Brush, _PureComponent);
    function Brush(props) {
        var _this;
        $2462b1ef157bd0f4$var$_classCallCheck(this, Brush);
        _this = $2462b1ef157bd0f4$var$_callSuper(this, Brush, [
            props
        ]);
        $2462b1ef157bd0f4$var$_defineProperty($2462b1ef157bd0f4$var$_assertThisInitialized(_this), "handleDrag", function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        });
        $2462b1ef157bd0f4$var$_defineProperty($2462b1ef157bd0f4$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        });
        $2462b1ef157bd0f4$var$_defineProperty($2462b1ef157bd0f4$var$_assertThisInitialized(_this), "handleDragEnd", function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            }, function() {
                var _this$props = _this.props, endIndex = _this$props.endIndex, onDragEnd = _this$props.onDragEnd, startIndex = _this$props.startIndex;
                onDragEnd === null || onDragEnd === void 0 || onDragEnd({
                    endIndex: endIndex,
                    startIndex: startIndex
                });
            });
            _this.detachDragEndListener();
        });
        $2462b1ef157bd0f4$var$_defineProperty($2462b1ef157bd0f4$var$_assertThisInitialized(_this), "handleLeaveWrapper", function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        });
        $2462b1ef157bd0f4$var$_defineProperty($2462b1ef157bd0f4$var$_assertThisInitialized(_this), "handleEnterSlideOrTraveller", function() {
            _this.setState({
                isTextActive: true
            });
        });
        $2462b1ef157bd0f4$var$_defineProperty($2462b1ef157bd0f4$var$_assertThisInitialized(_this), "handleLeaveSlideOrTraveller", function() {
            _this.setState({
                isTextActive: false
            });
        });
        $2462b1ef157bd0f4$var$_defineProperty($2462b1ef157bd0f4$var$_assertThisInitialized(_this), "handleSlideDragStart", function(e) {
            var event = $2462b1ef157bd0f4$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        });
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind($2462b1ef157bd0f4$var$_assertThisInitialized(_this), "startX"),
            endX: _this.handleTravellerDragStart.bind($2462b1ef157bd0f4$var$_assertThisInitialized(_this), "endX")
        };
        _this.state = {};
        return _this;
    }
    $2462b1ef157bd0f4$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props2 = this.props, gap = _this$props2.gap, data = _this$props2.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props3 = this.props, data = _this$props3.data, tickFormatter = _this$props3.tickFormatter, dataKey = _this$props3.dataKey;
                var text = (0, $467312b86c271c9f$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener("mouseup", this.handleDragEnd, true);
                window.addEventListener("touchend", this.handleDragEnd, true);
                window.addEventListener("mousemove", this.handleDrag, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener("mouseup", this.handleDragEnd, true);
                window.removeEventListener("touchend", this.handleDragEnd, true);
                window.removeEventListener("mousemove", this.handleDrag, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, startIndex = _this$props4.startIndex, endIndex = _this$props4.endIndex, onChange = _this$props4.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $2462b1ef157bd0f4$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props5 = this.props, x = _this$props5.x, width = _this$props5.width, travellerWidth = _this$props5.travellerWidth, onChange = _this$props5.onChange, gap = _this$props5.gap, data = _this$props5.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === "startX" && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === "endX" && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState($2462b1ef157bd0f4$var$_defineProperty($2462b1ef157bd0f4$var$_defineProperty({}, movingTravellerId, prevValue + delta), "brushMoveStartX", e.pageX), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "handleTravellerMoveKeyboard",
            value: function handleTravellerMoveKeyboard(direction, id) {
                var _this2 = this;
                // scaleValues are a list of coordinates. For example: [65, 250, 435, 620, 805, 990].
                var _this$state3 = this.state, scaleValues = _this$state3.scaleValues, startX = _this$state3.startX, endX = _this$state3.endX;
                // currentScaleValue refers to which coordinate the current traveller should be placed at.
                var currentScaleValue = this.state[id];
                var currentIndex = scaleValues.indexOf(currentScaleValue);
                if (currentIndex === -1) return;
                var newIndex = currentIndex + direction;
                if (newIndex === -1 || newIndex >= scaleValues.length) return;
                var newScaleValue = scaleValues[newIndex];
                // Prevent travellers from being on top of each other or overlapping
                if (id === "startX" && newScaleValue >= endX || id === "endX" && newScaleValue <= startX) return;
                this.setState($2462b1ef157bd0f4$var$_defineProperty({}, id, newScaleValue), function() {
                    _this2.props.onChange(_this2.getIndex({
                        startX: _this2.state.startX,
                        endX: _this2.state.endX
                    }));
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, fill = _this$props6.fill, stroke = _this$props6.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props7 = this.props, x = _this$props7.x, y = _this$props7.y, width = _this$props7.width, height = _this$props7.height, data = _this$props7.data, children = _this$props7.children, padding = _this$props7.padding;
                var chartElement = (0, $fgmOP.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _this3 = this;
                var _this$props8 = this.props, y = _this$props8.y, travellerWidth = _this$props8.travellerWidth, height = _this$props8.height, traveller = _this$props8.traveller, ariaLabel = _this$props8.ariaLabel, data = _this$props8.data, startIndex = _this$props8.startIndex, endIndex = _this$props8.endIndex;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $2462b1ef157bd0f4$var$_objectSpread($2462b1ef157bd0f4$var$_objectSpread({}, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(this.props, false)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                var ariaLabelBrush = ariaLabel || "Min value: ".concat(data[startIndex].name, ", Max value: ").concat(data[endIndex].name);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), {
                    tabIndex: 0,
                    role: "slider",
                    "aria-label": ariaLabelBrush,
                    "aria-valuenow": travellerX,
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    onKeyDown: function onKeyDown(e) {
                        if (![
                            "ArrowLeft",
                            "ArrowRight"
                        ].includes(e.key)) return;
                        e.preventDefault();
                        e.stopPropagation();
                        _this3.handleTravellerMoveKeyboard(e.key === "ArrowRight" ? 1 : -1, id);
                    },
                    onFocus: function onFocus() {
                        _this3.setState({
                            isTravellerFocused: true
                        });
                    },
                    onBlur: function onBlur() {
                        _this3.setState({
                            isTravellerFocused: false
                        });
                    },
                    style: {
                        cursor: "col-resize"
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props9 = this.props, y = _this$props9.y, height = _this$props9.height, stroke = _this$props9.stroke, travellerWidth = _this$props9.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: "move"
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props10 = this.props, startIndex = _this$props10.startIndex, endIndex = _this$props10.endIndex, y = _this$props10.y, height = _this$props10.height, travellerWidth = _this$props10.travellerWidth, stroke = _this$props10.stroke;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: "none",
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $724e819505244f32$export$5f1af8db9871e1d6), $2462b1ef157bd0f4$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $724e819505244f32$export$5f1af8db9871e1d6), $2462b1ef157bd0f4$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props11 = this.props, data = _this$props11.data, className = _this$props11.className, children = _this$props11.children, x = _this$props11.x, y = _this$props11.y, width = _this$props11.width, height = _this$props11.height, alwaysShowText = _this$props11.alwaysShowText;
                var _this$state5 = this.state, startX = _this$state5.startX, endX = _this$state5.endX, isTextActive = _this$state5.isTextActive, isSlideMoving = _this$state5.isSlideMoving, isTravellerMoving = _this$state5.isTravellerMoving, isTravellerFocused = _this$state5.isTravellerFocused;
                if (!data || !data.length || !(0, $e6d37abae86076b3$export$7e4aa119212bc614)(x) || !(0, $e6d37abae86076b3$export$7e4aa119212bc614)(y) || !(0, $e6d37abae86076b3$export$7e4aa119212bc614)(width) || !(0, $e6d37abae86076b3$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-brush", className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Children.count(children) === 1;
                var style = (0, $5a1feb36ca7155b8$export$4a9169b65825efee)("userSelect", "none");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, "startX"), this.renderTravellerLayer(endX, "endX"), (isTextActive || isSlideMoving || isTravellerMoving || isTravellerFocused || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $2462b1ef157bd0f4$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $2462b1ef157bd0f4$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(valueRange, x) {
                var len = valueRange.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (valueRange[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= valueRange[end] ? end : start;
            }
        }
    ]);
    return Brush;
}((0, $fgmOP.PureComponent));
$2462b1ef157bd0f4$var$_defineProperty($2462b1ef157bd0f4$export$59bc2e3533b384a0, "displayName", "Brush");
$2462b1ef157bd0f4$var$_defineProperty($2462b1ef157bd0f4$export$59bc2e3533b384a0, "defaultProps", {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: "#fff",
    stroke: "#666",
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
});






var $fgmOP = parcelRequire("fgmOP");






var $dc101728f8e8d7f3$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = "extendDomain";
    return ifOverflow === value;
};





function $dc3e867636f8ec77$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dc3e867636f8ec77$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dc3e867636f8ec77$var$_typeof(o);
}
function $dc3e867636f8ec77$var$_extends() {
    $dc3e867636f8ec77$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $dc3e867636f8ec77$var$_extends.apply(this, arguments);
}
function $dc3e867636f8ec77$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dc3e867636f8ec77$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dc3e867636f8ec77$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dc3e867636f8ec77$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dc3e867636f8ec77$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dc3e867636f8ec77$var$_defineProperty(obj, key, value) {
    key = $dc3e867636f8ec77$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dc3e867636f8ec77$var$_toPropertyKey(t) {
    var i = $dc3e867636f8ec77$var$_toPrimitive(t, "string");
    return "symbol" == $dc3e867636f8ec77$var$_typeof(i) ? i : String(i);
}
function $dc3e867636f8ec77$var$_toPrimitive(t, r) {
    if ("object" != $dc3e867636f8ec77$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $dc3e867636f8ec77$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $dc3e867636f8ec77$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $8f9440c92078f509$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $dc101728f8e8d7f3$export$3fb112445eb31879)(props, "discard") && !scales.isInRange(result)) return null;
    return result;
};
function $dc3e867636f8ec77$export$aa7f0b0106bff39(props) {
    var x = props.x, y = props.y, r = props.r, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    var isX = (0, $e6d37abae86076b3$export$402a499e1ea44294)(x);
    var isY = (0, $e6d37abae86076b3$export$402a499e1ea44294)(y);
    (0, $b8908dd384eb6989$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    if (!isX || !isY) return null;
    var coordinate = $dc3e867636f8ec77$var$getCoordinate(props);
    if (!coordinate) return null;
    var cx = coordinate.x, cy = coordinate.y;
    var shape = props.shape, className = props.className;
    var clipPath = (0, $dc101728f8e8d7f3$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    var dotProps = $dc3e867636f8ec77$var$_objectSpread($dc3e867636f8ec77$var$_objectSpread({
        clipPath: clipPath
    }, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(props, true)), {}, {
        cx: cx,
        cy: cy
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), {
        className: (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-reference-dot", className)
    }, $dc3e867636f8ec77$export$aa7f0b0106bff39.renderDot(shape, dotProps), (0, $1c1c6cebf3a026b7$export$b04be29aa201d4f5).renderCallByParent(props, {
        x: cx - r,
        y: cy - r,
        width: 2 * r,
        height: 2 * r
    }));
}
$dc3e867636f8ec77$export$aa7f0b0106bff39.displayName = "ReferenceDot";
$dc3e867636f8ec77$export$aa7f0b0106bff39.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#fff",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1
};
$dc3e867636f8ec77$export$aa7f0b0106bff39.renderDot = function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $1698e123872278b0$export$d046b3c4a416f60d), $dc3e867636f8ec77$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
};



var $fgmOP = parcelRequire("fgmOP");

var $a622509e13118563$exports = {};


var $a4b99da5987406f2$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $a4b99da5987406f2$var$baseSome(collection, predicate) {
    var result;
    $e0c588ee25819a54$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$a4b99da5987406f2$exports = $a4b99da5987406f2$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $a622509e13118563$var$some(collection, predicate, guard) {
    var func = $d9532e5a54ad1ff7$exports(collection) ? $08ed168478904f15$exports : $a4b99da5987406f2$exports;
    if (guard && $31c3fe36697999ed$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $86a15e1908191355$exports(predicate, 3));
}
$a622509e13118563$exports = $a622509e13118563$var$some;











function $4e56b5d41b5952a9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $4e56b5d41b5952a9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $4e56b5d41b5952a9$var$_typeof(o);
}
function $4e56b5d41b5952a9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4e56b5d41b5952a9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4e56b5d41b5952a9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $4e56b5d41b5952a9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4e56b5d41b5952a9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $4e56b5d41b5952a9$var$_defineProperty(obj, key, value) {
    key = $4e56b5d41b5952a9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4e56b5d41b5952a9$var$_toPropertyKey(t) {
    var i = $4e56b5d41b5952a9$var$_toPrimitive(t, "string");
    return "symbol" == $4e56b5d41b5952a9$var$_typeof(i) ? i : String(i);
}
function $4e56b5d41b5952a9$var$_toPrimitive(t, r) {
    if ("object" != $4e56b5d41b5952a9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $4e56b5d41b5952a9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $4e56b5d41b5952a9$var$_slicedToArray(arr, i) {
    return $4e56b5d41b5952a9$var$_arrayWithHoles(arr) || $4e56b5d41b5952a9$var$_iterableToArrayLimit(arr, i) || $4e56b5d41b5952a9$var$_unsupportedIterableToArray(arr, i) || $4e56b5d41b5952a9$var$_nonIterableRest();
}
function $4e56b5d41b5952a9$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4e56b5d41b5952a9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4e56b5d41b5952a9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4e56b5d41b5952a9$var$_arrayLikeToArray(o, minLen);
}
function $4e56b5d41b5952a9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4e56b5d41b5952a9$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $4e56b5d41b5952a9$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $4e56b5d41b5952a9$var$_extends() {
    $4e56b5d41b5952a9$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4e56b5d41b5952a9$var$_extends.apply(this, arguments);
}
/**
 * This excludes `viewBox` prop from svg for two reasons:
 * 1. The components wants viewBox of object type, and svg wants string
 *    - so there's a conflict, and the component will throw if it gets string
 * 2. Internally the component calls `filterProps` which filters the viewBox away anyway
 */ var $4e56b5d41b5952a9$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("line", $4e56b5d41b5952a9$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
};
var $4e56b5d41b5952a9$export$f273d496b213b6da = function getEndPoints(scales, isFixedX, isFixedY, isSegment, viewBox, position, xAxisOrientation, yAxisOrientation, props) {
    var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
    if (isFixedY) {
        var yCoord = props.y;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $dc101728f8e8d7f3$export$3fb112445eb31879)(props, "discard") && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return yAxisOrientation === "left" ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $dc101728f8e8d7f3$export$3fb112445eb31879)(props, "discard") && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return xAxisOrientation === "top" ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $dc101728f8e8d7f3$export$3fb112445eb31879)(props, "discard") && (0, (/*@__PURE__*/$parcel$interopDefault($a622509e13118563$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $4e56b5d41b5952a9$export$b2f28e248e7838eb(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxisId = props.xAxisId, yAxisId = props.yAxisId, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow;
    var clipPathId = (0, $bf7c628d5130940b$export$71e825c43eae6ca6)();
    var xAxis = (0, $bf7c628d5130940b$export$54f54805c81085c5)(xAxisId);
    var yAxis = (0, $bf7c628d5130940b$export$6f8958021ad81c20)(yAxisId);
    var viewBox = (0, $bf7c628d5130940b$export$76b29bb074e0c45a)();
    if (!clipPathId || !viewBox) return null;
    (0, $b8908dd384eb6989$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $8f9440c92078f509$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $e6d37abae86076b3$export$402a499e1ea44294)(fixedX);
    var isY = (0, $e6d37abae86076b3$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $4e56b5d41b5952a9$export$f273d496b213b6da(scales, isX, isY, isSegment, viewBox, props.position, xAxis.orientation, yAxis.orientation, props);
    if (!endPoints) return null;
    var _endPoints = $4e56b5d41b5952a9$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $dc101728f8e8d7f3$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $4e56b5d41b5952a9$var$_objectSpread($4e56b5d41b5952a9$var$_objectSpread({
        clipPath: clipPath
    }, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), {
        className: (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-reference-line", className)
    }, $4e56b5d41b5952a9$var$renderLine(shape, lineProps), (0, $1c1c6cebf3a026b7$export$b04be29aa201d4f5).renderCallByParent(props, (0, $8f9440c92078f509$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
$4e56b5d41b5952a9$export$b2f28e248e7838eb.displayName = "ReferenceLine";
$4e56b5d41b5952a9$export$b2f28e248e7838eb.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    fill: "none",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1,
    position: "middle"
};



var $fgmOP = parcelRequire("fgmOP");










function $8a88a4f18aba3a5a$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $8a88a4f18aba3a5a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $8a88a4f18aba3a5a$var$_typeof(o);
}
function $8a88a4f18aba3a5a$var$_extends() {
    $8a88a4f18aba3a5a$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $8a88a4f18aba3a5a$var$_extends.apply(this, arguments);
}
function $8a88a4f18aba3a5a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8a88a4f18aba3a5a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8a88a4f18aba3a5a$var$ownKeys(Object(t), !0).forEach(function(r) {
            $8a88a4f18aba3a5a$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8a88a4f18aba3a5a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8a88a4f18aba3a5a$var$_defineProperty(obj, key, value) {
    key = $8a88a4f18aba3a5a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $8a88a4f18aba3a5a$var$_toPropertyKey(t) {
    var i = $8a88a4f18aba3a5a$var$_toPrimitive(t, "string");
    return "symbol" == $8a88a4f18aba3a5a$var$_typeof(i) ? i : String(i);
}
function $8a88a4f18aba3a5a$var$_toPrimitive(t, r) {
    if ("object" != $8a88a4f18aba3a5a$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $8a88a4f18aba3a5a$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $8a88a4f18aba3a5a$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $8f9440c92078f509$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: "start"
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: "start"
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: "end"
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: "end"
        }) : scales.y.rangeMax
    };
    if ((0, $dc101728f8e8d7f3$export$3fb112445eb31879)(props, "discard") && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $8f9440c92078f509$export$c7964a5b9439ae62)(p1, p2);
};
function $8a88a4f18aba3a5a$export$b4ec4f050ce240b9(props) {
    var x1 = props.x1, x2 = props.x2, y1 = props.y1, y2 = props.y2, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $b8908dd384eb6989$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var hasX1 = (0, $e6d37abae86076b3$export$402a499e1ea44294)(x1);
    var hasX2 = (0, $e6d37abae86076b3$export$402a499e1ea44294)(x2);
    var hasY1 = (0, $e6d37abae86076b3$export$402a499e1ea44294)(y1);
    var hasY2 = (0, $e6d37abae86076b3$export$402a499e1ea44294)(y2);
    var shape = props.shape;
    if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
    var rect = $8a88a4f18aba3a5a$var$getRect(hasX1, hasX2, hasY1, hasY2, props);
    if (!rect && !shape) return null;
    var clipPath = (0, $dc101728f8e8d7f3$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), {
        className: (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-reference-area", className)
    }, $8a88a4f18aba3a5a$export$b4ec4f050ce240b9.renderRect(shape, $8a88a4f18aba3a5a$var$_objectSpread($8a88a4f18aba3a5a$var$_objectSpread({
        clipPath: clipPath
    }, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(props, true)), rect)), (0, $1c1c6cebf3a026b7$export$b04be29aa201d4f5).renderCallByParent(props, rect));
}
$8a88a4f18aba3a5a$export$b4ec4f050ce240b9.displayName = "ReferenceArea";
$8a88a4f18aba3a5a$export$b4ec4f050ce240b9.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#ccc",
    fillOpacity: 0.5,
    stroke: "none",
    strokeWidth: 1
};
$8a88a4f18aba3a5a$export$b4ec4f050ce240b9.renderRect = function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $a461e5a23755aeba$export$4617fb02663045ef), $8a88a4f18aba3a5a$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
};





function $e11e33efef47ca63$var$_toConsumableArray(arr) {
    return $e11e33efef47ca63$var$_arrayWithoutHoles(arr) || $e11e33efef47ca63$var$_iterableToArray(arr) || $e11e33efef47ca63$var$_unsupportedIterableToArray(arr) || $e11e33efef47ca63$var$_nonIterableSpread();
}
function $e11e33efef47ca63$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e11e33efef47ca63$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e11e33efef47ca63$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e11e33efef47ca63$var$_arrayLikeToArray(o, minLen);
}
function $e11e33efef47ca63$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $e11e33efef47ca63$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e11e33efef47ca63$var$_arrayLikeToArray(arr);
}
function $e11e33efef47ca63$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $e11e33efef47ca63$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $fa0843e4e64def56$export$fdd5e64c0e8495bb)(children, (0, $4e56b5d41b5952a9$export$b2f28e248e7838eb));
    var dots = (0, $fa0843e4e64def56$export$fdd5e64c0e8495bb)(children, (0, $dc3e867636f8ec77$export$aa7f0b0106bff39));
    var elements = [].concat($e11e33efef47ca63$var$_toConsumableArray(lines), $e11e33efef47ca63$var$_toConsumableArray(dots));
    var areas = (0, $fa0843e4e64def56$export$fdd5e64c0e8495bb)(children, (0, $8a88a4f18aba3a5a$export$b4ec4f050ce240b9));
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $dc101728f8e8d7f3$export$3fb112445eb31879)(el.props, "extendDomain") && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $dc101728f8e8d7f3$export$3fb112445eb31879)(el.props, "extendDomain") && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(el.props[key1]) && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $e6d37abae86076b3$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};




var $192a62d9f3d0874c$exports = {};
"use strict";
var $192a62d9f3d0874c$var$has = Object.prototype.hasOwnProperty, $192a62d9f3d0874c$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $192a62d9f3d0874c$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $192a62d9f3d0874c$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $192a62d9f3d0874c$var$Events().__proto__) $192a62d9f3d0874c$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $192a62d9f3d0874c$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $192a62d9f3d0874c$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $192a62d9f3d0874c$var$EE(fn, context || emitter, once), evt = $192a62d9f3d0874c$var$prefix ? $192a62d9f3d0874c$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $192a62d9f3d0874c$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $192a62d9f3d0874c$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $192a62d9f3d0874c$var$EventEmitter() {
    this._events = new $192a62d9f3d0874c$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $192a62d9f3d0874c$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($192a62d9f3d0874c$var$has.call(events, name)) names.push($192a62d9f3d0874c$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $192a62d9f3d0874c$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $192a62d9f3d0874c$var$prefix ? $192a62d9f3d0874c$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $192a62d9f3d0874c$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $192a62d9f3d0874c$var$prefix ? $192a62d9f3d0874c$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $192a62d9f3d0874c$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $192a62d9f3d0874c$var$prefix ? $192a62d9f3d0874c$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $192a62d9f3d0874c$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $192a62d9f3d0874c$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $192a62d9f3d0874c$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $192a62d9f3d0874c$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $192a62d9f3d0874c$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $192a62d9f3d0874c$var$prefix ? $192a62d9f3d0874c$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $192a62d9f3d0874c$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $192a62d9f3d0874c$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $192a62d9f3d0874c$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $192a62d9f3d0874c$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $192a62d9f3d0874c$var$prefix ? $192a62d9f3d0874c$var$prefix + event : event;
        if (this._events[evt]) $192a62d9f3d0874c$var$clearEvent(this, evt);
    } else {
        this._events = new $192a62d9f3d0874c$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$192a62d9f3d0874c$var$EventEmitter.prototype.off = $192a62d9f3d0874c$var$EventEmitter.prototype.removeListener;
$192a62d9f3d0874c$var$EventEmitter.prototype.addListener = $192a62d9f3d0874c$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$192a62d9f3d0874c$var$EventEmitter.prefixed = $192a62d9f3d0874c$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$192a62d9f3d0874c$var$EventEmitter.EventEmitter = $192a62d9f3d0874c$var$EventEmitter;
$192a62d9f3d0874c$exports = $192a62d9f3d0874c$var$EventEmitter;


var $219cd27da47b8e04$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($192a62d9f3d0874c$exports)))();
var $219cd27da47b8e04$export$ff9a08f6d0c38b8f = "recharts.syncMouseEvents";



function $aa430c7c4f5466d0$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $aa430c7c4f5466d0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $aa430c7c4f5466d0$var$_typeof(o);
}
function $aa430c7c4f5466d0$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $aa430c7c4f5466d0$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $aa430c7c4f5466d0$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $aa430c7c4f5466d0$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $aa430c7c4f5466d0$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $aa430c7c4f5466d0$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $aa430c7c4f5466d0$var$_defineProperty(obj, key, value) {
    key = $aa430c7c4f5466d0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aa430c7c4f5466d0$var$_toPropertyKey(t) {
    var i = $aa430c7c4f5466d0$var$_toPrimitive(t, "string");
    return "symbol" == $aa430c7c4f5466d0$var$_typeof(i) ? i : String(i);
}
function $aa430c7c4f5466d0$var$_toPrimitive(t, r) {
    if ("object" != $aa430c7c4f5466d0$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $aa430c7c4f5466d0$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $aa430c7c4f5466d0$export$a2c2de1efa8671eb = /*#__PURE__*/ function() {
    function AccessibilityManager() {
        $aa430c7c4f5466d0$var$_classCallCheck(this, AccessibilityManager);
        $aa430c7c4f5466d0$var$_defineProperty(this, "activeIndex", 0);
        $aa430c7c4f5466d0$var$_defineProperty(this, "coordinateList", []);
        $aa430c7c4f5466d0$var$_defineProperty(this, "layout", "horizontal");
    }
    $aa430c7c4f5466d0$var$_createClass(AccessibilityManager, [
        {
            key: "setDetails",
            value: function setDetails(_ref) {
                var _ref2;
                var _ref$coordinateList = _ref.coordinateList, coordinateList = _ref$coordinateList === void 0 ? null : _ref$coordinateList, _ref$container = _ref.container, container = _ref$container === void 0 ? null : _ref$container, _ref$layout = _ref.layout, layout = _ref$layout === void 0 ? null : _ref$layout, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? null : _ref$offset, _ref$mouseHandlerCall = _ref.mouseHandlerCallback, mouseHandlerCallback = _ref$mouseHandlerCall === void 0 ? null : _ref$mouseHandlerCall;
                this.coordinateList = (_ref2 = coordinateList !== null && coordinateList !== void 0 ? coordinateList : this.coordinateList) !== null && _ref2 !== void 0 ? _ref2 : [];
                this.container = container !== null && container !== void 0 ? container : this.container;
                this.layout = layout !== null && layout !== void 0 ? layout : this.layout;
                this.offset = offset !== null && offset !== void 0 ? offset : this.offset;
                this.mouseHandlerCallback = mouseHandlerCallback !== null && mouseHandlerCallback !== void 0 ? mouseHandlerCallback : this.mouseHandlerCallback;
                // Keep activeIndex in the bounds between 0 and the last coordinate index
                this.activeIndex = Math.min(Math.max(this.activeIndex, 0), this.coordinateList.length - 1);
            }
        },
        {
            key: "focus",
            value: function focus() {
                this.spoofMouse();
            }
        },
        {
            key: "keyboardEvent",
            value: function keyboardEvent(e) {
                // The AccessibilityManager relies on the Tooltip component. When tooltips suddenly stop existing,
                // it can cause errors. We use this function to check. We don't want arrow keys to be processed
                // if there are no tooltips, since that will cause unexpected behavior of users.
                if (this.coordinateList.length === 0) return;
                switch(e.key){
                    case "ArrowRight":
                        if (this.layout !== "horizontal") return;
                        this.activeIndex = Math.min(this.activeIndex + 1, this.coordinateList.length - 1);
                        this.spoofMouse();
                        break;
                    case "ArrowLeft":
                        if (this.layout !== "horizontal") return;
                        this.activeIndex = Math.max(this.activeIndex - 1, 0);
                        this.spoofMouse();
                        break;
                    default:
                        break;
                }
            }
        },
        {
            key: "setIndex",
            value: function setIndex(newIndex) {
                this.activeIndex = newIndex;
            }
        },
        {
            key: "spoofMouse",
            value: function spoofMouse() {
                var _window, _window2;
                if (this.layout !== "horizontal") return;
                // This can happen when the tooltips suddenly stop existing as children of the component
                // That update doesn't otherwise fire events, so we have to double check here.
                if (this.coordinateList.length === 0) return;
                var _this$container$getBo = this.container.getBoundingClientRect(), x = _this$container$getBo.x, y = _this$container$getBo.y, height = _this$container$getBo.height;
                var coordinate = this.coordinateList[this.activeIndex].coordinate;
                var scrollOffsetX = ((_window = window) === null || _window === void 0 ? void 0 : _window.scrollX) || 0;
                var scrollOffsetY = ((_window2 = window) === null || _window2 === void 0 ? void 0 : _window2.scrollY) || 0;
                var pageX = x + coordinate + scrollOffsetX;
                var pageY = y + this.offset.top + height / 2 + scrollOffsetY;
                this.mouseHandlerCallback({
                    pageX: pageX,
                    pageY: pageY
                });
            }
        }
    ]);
    return AccessibilityManager;
}();



function $5f8143aecb63dd51$export$33279f645a5831b7(domain, allowDataOverflow, axisType) {
    if (axisType === "number" && allowDataOverflow === true && Array.isArray(domain)) {
        var domainStart = domain === null || domain === void 0 ? void 0 : domain[0];
        var domainEnd = domain === null || domain === void 0 ? void 0 : domain[1];
        /*
     * The `isNumber` check is needed because the user could also provide strings like "dataMin" via the domain props.
     * In such case, we have to compute the domain from the data.
     */ if (!!domainStart && !!domainEnd && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(domainStart) && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(domainEnd)) return true;
    }
    return false;
}




var $fgmOP = parcelRequire("fgmOP");



var $fgmOP = parcelRequire("fgmOP");



function $efd7f2da8c228830$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $efd7f2da8c228830$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $efd7f2da8c228830$var$_typeof(o);
}
var $efd7f2da8c228830$var$_excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function $efd7f2da8c228830$var$_extends() {
    $efd7f2da8c228830$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $efd7f2da8c228830$var$_extends.apply(this, arguments);
}
function $efd7f2da8c228830$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $efd7f2da8c228830$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $efd7f2da8c228830$var$ownKeys(Object(t), !0).forEach(function(r) {
            $efd7f2da8c228830$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $efd7f2da8c228830$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $efd7f2da8c228830$var$_defineProperty(obj, key, value) {
    key = $efd7f2da8c228830$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $efd7f2da8c228830$var$_toPropertyKey(t) {
    var i = $efd7f2da8c228830$var$_toPrimitive(t, "string");
    return "symbol" == $efd7f2da8c228830$var$_typeof(i) ? i : String(i);
}
function $efd7f2da8c228830$var$_toPrimitive(t, r) {
    if ("object" != $efd7f2da8c228830$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $efd7f2da8c228830$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $efd7f2da8c228830$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $efd7f2da8c228830$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $efd7f2da8c228830$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $efd7f2da8c228830$var$getPath = function getPath(x, y, width, height, top, left) {
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var $efd7f2da8c228830$export$3c877bb842c36952 = function Cross(_ref) {
    var _ref$x = _ref.x, x = _ref$x === void 0 ? 0 : _ref$x, _ref$y = _ref.y, y = _ref$y === void 0 ? 0 : _ref$y, _ref$top = _ref.top, top = _ref$top === void 0 ? 0 : _ref$top, _ref$left = _ref.left, left = _ref$left === void 0 ? 0 : _ref$left, _ref$width = _ref.width, width = _ref$width === void 0 ? 0 : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? 0 : _ref$height, className = _ref.className, rest = $efd7f2da8c228830$var$_objectWithoutProperties(_ref, $efd7f2da8c228830$var$_excluded);
    var props = $efd7f2da8c228830$var$_objectSpread({
        x: x,
        y: y,
        top: top,
        left: left,
        width: width,
        height: height
    }, rest);
    if (!(0, $e6d37abae86076b3$export$7e4aa119212bc614)(x) || !(0, $e6d37abae86076b3$export$7e4aa119212bc614)(y) || !(0, $e6d37abae86076b3$export$7e4aa119212bc614)(width) || !(0, $e6d37abae86076b3$export$7e4aa119212bc614)(height) || !(0, $e6d37abae86076b3$export$7e4aa119212bc614)(top) || !(0, $e6d37abae86076b3$export$7e4aa119212bc614)(left)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("path", $efd7f2da8c228830$var$_extends({}, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(props, true), {
        className: (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-cross", className),
        d: $efd7f2da8c228830$var$getPath(x, y, width, height, top, left)
    }));
};


function $6f01519263d2bc40$export$f84ec1ecc69a13c9(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: "none",
        fill: "#ccc",
        x: layout === "horizontal" ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === "horizontal" ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === "horizontal" ? tooltipAxisBandSize : offset.width - 1,
        height: layout === "horizontal" ? offset.height - 1 : tooltipAxisBandSize
    };
}




function $deb2a30a56c7c780$export$ad661ef85a042a4f(activeCoordinate) {
    var cx = activeCoordinate.cx, cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
    var startPoint = (0, $edd20ed1082bc6c5$export$5c9a959bb3fc7749)(cx, cy, radius, startAngle);
    var endPoint = (0, $edd20ed1082bc6c5$export$5c9a959bb3fc7749)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx: cx,
        cy: cy,
        radius: radius,
        startAngle: startAngle,
        endAngle: endAngle
    };
}





function $f651ea8aefa39f50$export$56e1305620ce5745(layout, activeCoordinate, offset) {
    var x1, y1, x2, y2;
    if (layout === "horizontal") {
        x1 = activeCoordinate.x;
        x2 = x1;
        y1 = offset.top;
        y2 = offset.top + offset.height;
    } else if (layout === "vertical") {
        y1 = activeCoordinate.y;
        y2 = y1;
        x1 = offset.left;
        x2 = offset.left + offset.width;
    } else if (activeCoordinate.cx != null && activeCoordinate.cy != null) {
        if (layout === "centric") {
            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
            var innerPoint = (0, $edd20ed1082bc6c5$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
            var outerPoint = (0, $edd20ed1082bc6c5$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
            x1 = innerPoint.x;
            y1 = innerPoint.y;
            x2 = outerPoint.x;
            y2 = outerPoint.y;
        } else return (0, $deb2a30a56c7c780$export$ad661ef85a042a4f)(activeCoordinate);
    }
    return [
        {
            x: x1,
            y: y1
        },
        {
            x: x2,
            y: y2
        }
    ];
}



function $dcbc75b63b08d3f9$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $dcbc75b63b08d3f9$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $dcbc75b63b08d3f9$var$_typeof(o);
}
function $dcbc75b63b08d3f9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dcbc75b63b08d3f9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dcbc75b63b08d3f9$var$ownKeys(Object(t), !0).forEach(function(r) {
            $dcbc75b63b08d3f9$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dcbc75b63b08d3f9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dcbc75b63b08d3f9$var$_defineProperty(obj, key, value) {
    key = $dcbc75b63b08d3f9$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $dcbc75b63b08d3f9$var$_toPropertyKey(t) {
    var i = $dcbc75b63b08d3f9$var$_toPrimitive(t, "string");
    return "symbol" == $dcbc75b63b08d3f9$var$_typeof(i) ? i : String(i);
}
function $dcbc75b63b08d3f9$var$_toPrimitive(t, r) {
    if ("object" != $dcbc75b63b08d3f9$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $dcbc75b63b08d3f9$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $dcbc75b63b08d3f9$export$b6a79797ad180576(props) {
    var element = props.element, tooltipEventType = props.tooltipEventType, isActive = props.isActive, activeCoordinate = props.activeCoordinate, activePayload = props.activePayload, offset = props.offset, activeTooltipIndex = props.activeTooltipIndex, tooltipAxisBandSize = props.tooltipAxisBandSize, layout = props.layout, chartName = props.chartName;
    if (!element || !element.props.cursor || !isActive || !activeCoordinate || chartName !== "ScatterChart" && tooltipEventType !== "axis") return null;
    var restProps;
    var cursorComp = (0, $55a9a5890e8a5777$export$b0e83c3ef8d2db1);
    if (chartName === "ScatterChart") {
        restProps = activeCoordinate;
        cursorComp = (0, $efd7f2da8c228830$export$3c877bb842c36952);
    } else if (chartName === "BarChart") {
        restProps = (0, $6f01519263d2bc40$export$f84ec1ecc69a13c9)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, $a461e5a23755aeba$export$4617fb02663045ef);
    } else if (layout === "radial") {
        var _getRadialCursorPoint = (0, $deb2a30a56c7c780$export$ad661ef85a042a4f)(activeCoordinate), cx = _getRadialCursorPoint.cx, cy = _getRadialCursorPoint.cy, radius = _getRadialCursorPoint.radius, startAngle = _getRadialCursorPoint.startAngle, endAngle = _getRadialCursorPoint.endAngle;
        restProps = {
            cx: cx,
            cy: cy,
            startAngle: startAngle,
            endAngle: endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, $be91be79bbc3212f$export$e98c2c7eb2b14f45);
    } else {
        restProps = {
            points: (0, $f651ea8aefa39f50$export$56e1305620ce5745)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, $55a9a5890e8a5777$export$b0e83c3ef8d2db1);
    }
    var cursorProps = $dcbc75b63b08d3f9$var$_objectSpread($dcbc75b63b08d3f9$var$_objectSpread($dcbc75b63b08d3f9$var$_objectSpread($dcbc75b63b08d3f9$var$_objectSpread({
        stroke: "#ccc",
        pointerEvents: "none"
    }, offset), restProps), (0, $fa0843e4e64def56$export$d697c39a2985a4c)(element.props.cursor, false)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-tooltip-cursor", element.props.cursor.className)
    });
    return /*#__PURE__*/ (0, $fgmOP.isValidElement)(element.props.cursor) ? /*#__PURE__*/ (0, $fgmOP.cloneElement)(element.props.cursor, cursorProps) : /*#__PURE__*/ (0, $fgmOP.createElement)(cursorComp, cursorProps);
}



var $93a80a75167ace33$var$_excluded = [
    "item"
], $93a80a75167ace33$var$_excluded2 = [
    "children",
    "className",
    "width",
    "height",
    "style",
    "compact",
    "title",
    "desc"
];
function $93a80a75167ace33$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $93a80a75167ace33$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $93a80a75167ace33$var$_typeof(o);
}
function $93a80a75167ace33$var$_extends() {
    $93a80a75167ace33$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $93a80a75167ace33$var$_extends.apply(this, arguments);
}
function $93a80a75167ace33$var$_slicedToArray(arr, i) {
    return $93a80a75167ace33$var$_arrayWithHoles(arr) || $93a80a75167ace33$var$_iterableToArrayLimit(arr, i) || $93a80a75167ace33$var$_unsupportedIterableToArray(arr, i) || $93a80a75167ace33$var$_nonIterableRest();
}
function $93a80a75167ace33$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $93a80a75167ace33$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $93a80a75167ace33$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $93a80a75167ace33$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $93a80a75167ace33$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $93a80a75167ace33$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $93a80a75167ace33$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $93a80a75167ace33$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $93a80a75167ace33$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $93a80a75167ace33$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $93a80a75167ace33$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $93a80a75167ace33$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $93a80a75167ace33$var$_callSuper(t, o, e) {
    return o = $93a80a75167ace33$var$_getPrototypeOf(o), $93a80a75167ace33$var$_possibleConstructorReturn(t, $93a80a75167ace33$var$_isNativeReflectConstruct() ? Reflect.construct(o, e || [], $93a80a75167ace33$var$_getPrototypeOf(t).constructor) : o.apply(t, e));
}
function $93a80a75167ace33$var$_possibleConstructorReturn(self, call) {
    if (call && ($93a80a75167ace33$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $93a80a75167ace33$var$_assertThisInitialized(self);
}
function $93a80a75167ace33$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($93a80a75167ace33$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function $93a80a75167ace33$var$_getPrototypeOf(o) {
    $93a80a75167ace33$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $93a80a75167ace33$var$_getPrototypeOf(o);
}
function $93a80a75167ace33$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $93a80a75167ace33$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $93a80a75167ace33$var$_setPrototypeOf(subClass, superClass);
}
function $93a80a75167ace33$var$_setPrototypeOf(o, p) {
    $93a80a75167ace33$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $93a80a75167ace33$var$_setPrototypeOf(o, p);
}
function $93a80a75167ace33$var$_toConsumableArray(arr) {
    return $93a80a75167ace33$var$_arrayWithoutHoles(arr) || $93a80a75167ace33$var$_iterableToArray(arr) || $93a80a75167ace33$var$_unsupportedIterableToArray(arr) || $93a80a75167ace33$var$_nonIterableSpread();
}
function $93a80a75167ace33$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $93a80a75167ace33$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $93a80a75167ace33$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $93a80a75167ace33$var$_arrayLikeToArray(o, minLen);
}
function $93a80a75167ace33$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $93a80a75167ace33$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $93a80a75167ace33$var$_arrayLikeToArray(arr);
}
function $93a80a75167ace33$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $93a80a75167ace33$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $93a80a75167ace33$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $93a80a75167ace33$var$ownKeys(Object(t), !0).forEach(function(r) {
            $93a80a75167ace33$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $93a80a75167ace33$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $93a80a75167ace33$var$_defineProperty(obj, key, value) {
    key = $93a80a75167ace33$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $93a80a75167ace33$var$_toPropertyKey(t) {
    var i = $93a80a75167ace33$var$_toPrimitive(t, "string");
    return "symbol" == $93a80a75167ace33$var$_typeof(i) ? i : String(i);
}
function $93a80a75167ace33$var$_toPrimitive(t, r) {
    if ("object" != $93a80a75167ace33$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $93a80a75167ace33$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $93a80a75167ace33$var$ORIENT_MAP = {
    xAxis: [
        "bottom",
        "top"
    ],
    yAxis: [
        "left",
        "right"
    ]
};
var $93a80a75167ace33$var$FULL_WIDTH_AND_HEIGHT = {
    width: "100%",
    height: "100%"
};
var $93a80a75167ace33$var$originCoordinate = {
    x: 0,
    y: 0
};
/**
 * This function exists as a temporary workaround.
 *
 * Why? generateCategoricalChart does not render `{children}` directly;
 * instead it passes them through `renderByOrder` function which reads their handlers.
 *
 * So, this is a handler that does nothing.
 * Once we get rid of `renderByOrder` and switch to JSX only, we can get rid of this handler too.
 *
 * @param {JSX} element as is in JSX
 * @returns {JSX} the same element
 */ function $93a80a75167ace33$var$renderAsIs(element) {
    return element;
}
var $93a80a75167ace33$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === "horizontal") return rangeObj.x;
    if (layout === "vertical") return rangeObj.y;
    if (layout === "centric") return rangeObj.angle;
    return rangeObj.radius;
};
var $93a80a75167ace33$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === "horizontal") return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === "vertical") return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === "centric") {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, rangeObj), (0, $edd20ed1082bc6c5$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, rangeObj), (0, $edd20ed1082bc6c5$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $93a80a75167ace33$var$originCoordinate;
};
var $93a80a75167ace33$var$getDisplayedData = function getDisplayedData(data, _ref) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems !== null && graphicalItems !== void 0 ? graphicalItems : []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($93a80a75167ace33$var$_toConsumableArray(result), $93a80a75167ace33$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData.length > 0) return itemsData;
    if (data && data.length && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(dataStartIndex) && (0, $e6d37abae86076b3$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
function $93a80a75167ace33$var$getDefaultDomainByAxisType(axisType) {
    return axisType === "number" ? [
        0,
        "auto"
    ] : undefined;
}
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $93a80a75167ace33$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $93a80a75167ace33$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
    // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var _child$props$data;
        /**
     * Fixes: https://github.com/recharts/recharts/issues/3669
     * Defaulting to chartData below to fix an edge case where the tooltip does not include data from all charts
     * when a separate dataset is passed to chart prop data and specified on Line/Area/etc prop data
     */ var data = (_child$props$data = child.props.data) !== null && _child$props$data !== void 0 ? _child$props$data : chartData;
        if (data && state.dataStartIndex + state.dataEndIndex !== 0) data = data.slice(state.dataStartIndex, state.dataEndIndex + 1);
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $e6d37abae86076b3$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($93a80a75167ace33$var$_toConsumableArray(result), [
            (0, $467312b86c271c9f$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $93a80a75167ace33$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $93a80a75167ace33$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $467312b86c271c9f$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $93a80a75167ace33$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $93a80a75167ace33$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
var $93a80a75167ace33$export$7a36da8ad5d1965e = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $467312b86c271c9f$export$9fc1baaa6c6368b)(layout, axisType);
    // Eliminate duplicated axes
    return axes.reduce(function(result, child) {
        var _child$props$domain2;
        var _child$props = child.props, type = _child$props.type, dataKey = _child$props.dataKey, allowDataOverflow = _child$props.allowDataOverflow, allowDuplicatedCategory = _child$props.allowDuplicatedCategory, scale = _child$props.scale, ticks = _child$props.ticks, includeHidden = _child$props.includeHidden;
        var axisId = child.props[axisIdKey];
        if (result[axisId]) return result;
        var displayedData = $93a80a75167ace33$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        var domain, duplicateDomain, categoricalDomain;
        /*
     * This is a hack to short-circuit the domain creation here to enhance performance.
     * Usually, the data is used to determine the domain, but when the user specifies
     * a domain upfront (via props), there is no need to calculate the domain start and end,
     * which is very expensive for a larger amount of data.
     * The only thing that would prohibit short-circuiting is when the user doesn't allow data overflow,
     * because the axis is supposed to ignore the specified domain that way.
     */ if ((0, $5f8143aecb63dd51$export$33279f645a5831b7)(child.props.domain, allowDataOverflow, type)) {
            domain = (0, $467312b86c271c9f$export$a0bc8660980558a0)(child.props.domain, null, allowDataOverflow);
            /* The chart can be categorical and have the domain specified in numbers
       * we still need to calculate the categorical domain
       * TODO: refactor this more
       */ if (isCategorical && (type === "number" || scale !== "auto")) categoricalDomain = (0, $467312b86c271c9f$export$6a1e7873444c95a7)(displayedData, dataKey, "category");
        }
        // if the domain is defaulted we need this for `originalDomain` as well
        var defaultDomain = $93a80a75167ace33$var$getDefaultDomainByAxisType(type);
        // we didn't create the domain from user's props above, so we need to calculate it
        if (!domain || domain.length === 0) {
            var _child$props$domain;
            var childDomain = (_child$props$domain = child.props.domain) !== null && _child$props$domain !== void 0 ? _child$props$domain : defaultDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $467312b86c271c9f$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === "category" && isCategorical) {
                    // the field type is category data and this axis is categorical axis
                    var duplicate = (0, $e6d37abae86076b3$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain;
                        // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($a3aff5e7543de9ca$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $467312b86c271c9f$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($93a80a75167ace33$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === "category") {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $467312b86c271c9f$export$c9a5230f0dda41bf)(childDomain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === "" || (0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(entry) ? finalDomain : [].concat($93a80a75167ace33$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== "" && !(0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(entry);
                    });
                } else if (type === "number") {
                    // the field type is numerical
                    var errorBarsDomain = (0, $467312b86c271c9f$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === "number" || scale !== "auto")) categoricalDomain = (0, $467312b86c271c9f$export$6a1e7873444c95a7)(displayedData, dataKey, "category");
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($a3aff5e7543de9ca$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === "number") // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === "expand" ? [
                0,
                1
            ] : (0, $467312b86c271c9f$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $467312b86c271c9f$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId && (includeHidden || !item.props.hide);
            }), type, layout, true);
            if (type === "number") {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $e11e33efef47ca63$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (childDomain) domain = (0, $467312b86c271c9f$export$a0bc8660980558a0)(childDomain, domain, allowDataOverflow);
            } else if (type === "category" && childDomain) {
                var axisDomain = childDomain;
                var isDomainValid = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValid) domain = axisDomain;
            }
        }
        return $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, result), {}, $93a80a75167ace33$var$_defineProperty({}, axisId, $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, child.props), {}, {
            axisType: axisType,
            domain: domain,
            categoricalDomain: categoricalDomain,
            duplicateDomain: duplicateDomain,
            originalDomain: (_child$props$domain2 = child.props.domain) !== null && _child$props$domain2 !== void 0 ? _child$props$domain2 : defaultDomain,
            isCategorical: isCategorical,
            layout: layout
        })));
    }, {});
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $93a80a75167ace33$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $93a80a75167ace33$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $467312b86c271c9f$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1;
    // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    return graphicalItems.reduce(function(result, child) {
        var axisId = child.props[axisIdKey];
        var originalDomain = $93a80a75167ace33$var$getDefaultDomainByAxisType("number");
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($a3aff5e7543de9ca$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $467312b86c271c9f$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $e11e33efef47ca63$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $467312b86c271c9f$export$a0bc8660980558a0)(originalDomain, (0, $467312b86c271c9f$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    return item.props[axisIdKey] === axisId && !item.props.hide;
                }), "number", layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $e11e33efef47ca63$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, result), {}, $93a80a75167ace33$var$_defineProperty({}, axisId, $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($d0c0e0e0987fd69b$exports)))($93a80a75167ace33$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: originalDomain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {React.ComponentType}  [AxisComp]      Axis Component
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $93a80a75167ace33$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? "xAxis" : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id");
    // Get all the instance of Axis
    var axes = (0, $fa0843e4e64def56$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $93a80a75167ace33$export$7a36da8ad5d1965e(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $93a80a75167ace33$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $93a80a75167ace33$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $e6d37abae86076b3$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $467312b86c271c9f$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($024dd103a6f5c4c7$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $467312b86c271c9f$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
var $93a80a75167ace33$export$e5182fb58612e577 = function createDefaultState(props) {
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $fa0843e4e64def56$export$64c61536a2b72e0f)(children, (0, $2462b1ef157bd0f4$export$59bc2e3533b384a0));
    var startIndex = 0;
    var endIndex = 0;
    if (props.data && props.data.length !== 0) endIndex = props.data.length - 1;
    if (brushItem && brushItem.props) {
        if (brushItem.props.startIndex >= 0) startIndex = brushItem.props.startIndex;
        if (brushItem.props.endIndex >= 0) endIndex = brushItem.props.endIndex;
    }
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: Boolean(defaultShowTooltip)
    };
};
var $93a80a75167ace33$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $fa0843e4e64def56$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf("Bar") >= 0;
    });
};
var $93a80a75167ace33$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === "horizontal") return {
        numericAxisName: "yAxis",
        cateAxisName: "xAxis"
    };
    if (layout === "vertical") return {
        numericAxisName: "xAxis",
        cateAxisName: "yAxis"
    };
    if (layout === "centric") return {
        numericAxisName: "radiusAxis",
        cateAxisName: "angleAxis"
    };
    return {
        numericAxisName: "angleAxis",
        cateAxisName: "radiusAxis"
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} params.props          Latest props
 * @param  {Array}  params.graphicalItems The instances of item
 * @param  {Object} params.xAxisMap       The configuration of x-axis
 * @param  {Object} params.yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox        The boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $93a80a75167ace33$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $fa0843e4e64def56$export$64c61536a2b72e0f)(children, (0, $2462b1ef157bd0f4$export$59bc2e3533b384a0));
    var legendItem = (0, $fa0843e4e64def56$export$64c61536a2b72e0f)(children, (0, $c217c6640e254c03$export$ed247974535929c7));
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, result), {}, $93a80a75167ace33$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, result), {}, $93a80a75167ace33$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($d0c0e0e0987fd69b$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $2462b1ef157bd0f4$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) // @ts-expect-error margin is optional in props but required in appendOffsetOfLegend
    offset = (0, $467312b86c271c9f$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    var offsetWidth = width - offset.left - offset.right;
    var offsetHeight = height - offset.top - offset.bottom;
    return $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
};
// Determine the size of the axis, used for calculation of relative bar sizes
var $93a80a75167ace33$var$getCartesianAxisSize = function getCartesianAxisSize(axisObj, axisName) {
    if (axisName === "xAxis") return axisObj[axisName].width;
    if (axisName === "yAxis") return axisObj[axisName].height;
    // This is only supported for Bar charts (i.e. charts with cartesian axes), so we should never get here
    return undefined;
};
var $93a80a75167ace33$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var _CategoricalChartWrapper;
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? "axis" : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        "axis"
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $93a80a75167ace33$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $93a80a75167ace33$var$hasGraphicalBarItem(graphicalItems);
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $93a80a75167ace33$var$getDisplayedData(props.data, {
                graphicalItems: [
                    item
                ],
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            });
            var _item$props = item.props, dataKey = _item$props.dataKey, childMaxBarSize = _item$props.maxBarSize;
            // axisId of the numerical axis
            var numericAxisId = item.props["".concat(numericAxisName, "Id")];
            // axisId of the categorical axis
            var cateAxisId = item.props["".concat(cateAxisName, "Id")];
            var axisObjInitialValue = {};
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _item$type$displayNam, _item$type;
                // map of axisId to axis for a specific axis type
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                // axisId of axis we are currently computing
                var id = item.props["".concat(entry.axisType, "Id")];
                /**
         * tell the user in dev mode that their configuration is incorrect if we cannot find a match between
         * axisId on the chart and axisId on the axis. zAxis does not get passed in the map for ComposedChart,
         * leave it out of the check for now.
         */ !(axisMap && axisMap[id] || entry.axisType === "zAxis") && (0, $157ae7827df642c9$export$2e2bcd8739ae039)(false);
                // the axis we are currently formatting
                var axis = axisMap[id];
                return $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, result), {}, $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_defineProperty({}, entry.axisType, axis), "".concat(entry.axisType, "Ticks"), (0, $467312b86c271c9f$export$c829ee42daf7f66d)(axis)));
            }, axisObjInitialValue);
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $467312b86c271c9f$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $fa0843e4e64def56$export$be63e0664592e141)(item.type).indexOf("Bar") >= 0;
            var bandSize = (0, $467312b86c271c9f$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            var sizeList = hasBar && (0, $467312b86c271c9f$export$570d306bee26c748)({
                barSize: barSize,
                stackGroups: stackGroups,
                totalSize: $93a80a75167ace33$var$getCartesianAxisSize(axisObj, cateAxisName)
            });
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // If it is bar, calculate the position of bar
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $467312b86c271c9f$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $467312b86c271c9f$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, pos), {}, {
                        position: $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            // @ts-expect-error we should stop reading data from ReactElements
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) formattedItems.push({
                props: $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, composedFn($93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, axisObj), {}, {
                    displayedData: displayedData,
                    props: props,
                    dataKey: dataKey,
                    item: item,
                    bandSize: bandSize,
                    barPosition: barPosition,
                    offset: offset,
                    stackedData: stackedData,
                    layout: layout,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }))), {}, $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_defineProperty({
                    key: item.key || "item-".concat(index)
                }, numericAxisName, axisObj[numericAxisName]), cateAxisName, axisObj[cateAxisName]), "animationId", updateId)),
                childIndex: (0, $fa0843e4e64def56$export$857ca101f741953)(item, props.children),
                item: item
            });
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $fa0843e4e64def56$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $93a80a75167ace33$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $fa0843e4e64def56$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $467312b86c271c9f$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, result), {}, $93a80a75167ace33$var$_defineProperty({}, name, $93a80a75167ace33$var$getAxisMap(props, $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $93a80a75167ace33$var$calculateOffset($93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace("Map", ""), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $93a80a75167ace33$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    return _CategoricalChartWrapper = /*#__PURE__*/ function(_Component) {
        $93a80a75167ace33$var$_inherits(CategoricalChartWrapper, _Component);
        function CategoricalChartWrapper(_props) {
            var _props$id, _props$throttleDelay;
            var _this;
            $93a80a75167ace33$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = $93a80a75167ace33$var$_callSuper(this, CategoricalChartWrapper, [
                _props
            ]);
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "eventEmitterSymbol", Symbol("rechartsEventEmitter"));
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "accessibilityManager", new (0, $aa430c7c4f5466d0$export$a2c2de1efa8671eb)());
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "handleLegendBBoxUpdate", function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($93a80a75167ace33$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "handleReceiveSyncEvent", function(cId, data, emitter) {
                if (_this.props.syncId === cId) {
                    if (emitter === _this.eventEmitterSymbol && typeof _this.props.syncMethod !== "function") return;
                    _this.applySyncEvent(data);
                }
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "handleBrushChange", function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $93a80a75167ace33$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            });
            /**
       * The handler of mouse entering chart
       * @param  {Object} e              Event object
       * @return {Null}                  null
       */ $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "handleMouseEnter", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    var onMouseEnter = _this.props.onMouseEnter;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "triggeredAfterMouseMove", function(e) {
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseMove = _this.props.onMouseMove;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(onMouseMove)) onMouseMove(nextState, e);
            });
            /**
       * The handler of mouse entering a scatter
       * @param {Object} el The active scatter
       * @return {Object} no return
       */ $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "handleItemMouseEnter", function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            });
            /**
       * The handler of mouse leaving a scatter
       * @return {Object} no return
       */ $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "handleItemMouseLeave", function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            });
            /**
       * The handler of mouse moving in chart
       * @param  {React.MouseEvent} e        Event object
       * @return {void} no return
       */ $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "handleMouseMove", function(e) {
                e.persist();
                _this.throttleTriggeredAfterMouseMove(e);
            });
            /**
       * The handler if mouse leaving chart
       * @param {Object} e Event object
       * @return {Null} no return
       */ $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "handleMouseLeave", function(e) {
                _this.throttleTriggeredAfterMouseMove.cancel();
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                var onMouseLeave = _this.props.onMouseLeave;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "handleOuterEvent", function(e) {
                var eventName = (0, $fa0843e4e64def56$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($d0c0e0e0987fd69b$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(event)) {
                    var _mouse;
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    event((_mouse = mouse) !== null && _mouse !== void 0 ? _mouse : {}, e);
                }
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "handleClick", function(e) {
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    var onClick = _this.props.onClick;
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(onClick)) onClick(_nextState2, e);
                }
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "handleMouseDown", function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "handleMouseUp", function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "handleTouchMove", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.throttleTriggeredAfterMouseMove(e.changedTouches[0]);
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "handleTouchStart", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "handleTouchEnd", function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "triggerSyncEvent", function(data) {
                if (_this.props.syncId !== undefined) (0, $219cd27da47b8e04$export$9bcdfe5f29bb33).emit((0, $219cd27da47b8e04$export$ff9a08f6d0c38b8f), _this.props.syncId, data, _this.eventEmitterSymbol);
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "applySyncEvent", function(data) {
                var _this$props = _this.props, layout = _this$props.layout, syncMethod = _this$props.syncMethod;
                var updateId = _this.state.updateId;
                var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                if (data.dataStartIndex !== undefined || data.dataEndIndex !== undefined) _this.setState($93a80a75167ace33$var$_objectSpread({
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex
                }, updateStateOfAxisMapsOffsetAndStackGroups({
                    props: _this.props,
                    dataStartIndex: dataStartIndex,
                    dataEndIndex: dataEndIndex,
                    updateId: updateId
                }, _this.state)));
                else if (data.activeTooltipIndex !== undefined) {
                    var chartX = data.chartX, chartY = data.chartY;
                    var activeTooltipIndex = data.activeTooltipIndex;
                    var _this$state2 = _this.state, offset = _this$state2.offset, tooltipTicks = _this$state2.tooltipTicks;
                    if (!offset) return;
                    if (typeof syncMethod === "function") // Call a callback function. If there is an application specific algorithm
                    activeTooltipIndex = syncMethod(tooltipTicks, data);
                    else if (syncMethod === "value") {
                        // Set activeTooltipIndex to the index with the same value as data.activeLabel
                        // For loop instead of findIndex because the latter is very slow in some browsers
                        activeTooltipIndex = -1; // in case we cannot find the element
                        for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                            activeTooltipIndex = i;
                            break;
                        }
                    }
                    var viewBox = $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    });
                    // When a categorical chart is combined with another chart, the value of chartX
                    // and chartY may beyond the boundaries.
                    var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                    var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                    var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                    var activePayload = $93a80a75167ace33$var$getTooltipContent(_this.state, _this.props.data, activeTooltipIndex);
                    var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                        x: layout === "horizontal" ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                        y: layout === "horizontal" ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                    } : $93a80a75167ace33$var$originCoordinate;
                    _this.setState($93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, data), {}, {
                        activeLabel: activeLabel,
                        activeCoordinate: activeCoordinate,
                        activePayload: activePayload,
                        activeTooltipIndex: activeTooltipIndex
                    }));
                } else _this.setState(data);
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "renderCursor", function(element) {
                var _element$props$active;
                var _this$state3 = _this.state, isTooltipActive = _this$state3.isTooltipActive, activeCoordinate = _this$state3.activeCoordinate, activePayload = _this$state3.activePayload, offset = _this$state3.offset, activeTooltipIndex = _this$state3.activeTooltipIndex, tooltipAxisBandSize = _this$state3.tooltipAxisBandSize;
                var tooltipEventType = _this.getTooltipEventType();
                // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
                var isActive = (_element$props$active = element.props.active) !== null && _element$props$active !== void 0 ? _element$props$active : isTooltipActive;
                var layout = _this.props.layout;
                var key = element.key || "_recharts-cursor";
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $dcbc75b63b08d3f9$export$b6a79797ad180576), {
                    key: key,
                    activeCoordinate: activeCoordinate,
                    activePayload: activePayload,
                    activeTooltipIndex: activeTooltipIndex,
                    chartName: chartName,
                    element: element,
                    isActive: isActive,
                    layout: layout,
                    offset: offset,
                    tooltipAxisBandSize: tooltipAxisBandSize,
                    tooltipEventType: tooltipEventType
                });
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "renderPolarAxis", function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($d0c0e0e0987fd69b$exports)))(element, "type.axisType");
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($d0c0e0e0987fd69b$exports)))(_this.state, "".concat(axisType, "Map"));
                var axisOption = axisMap && axisMap[element.props["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $fgmOP.cloneElement)(element, $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, axisOption), {}, {
                    className: (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)(axisType, axisOption.className),
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $467312b86c271c9f$export$c829ee42daf7f66d)(axisOption, true)
                }));
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "renderPolarGrid", function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, $e6d37abae86076b3$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $e6d37abae86076b3$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $fgmOP.cloneElement)(element, {
                    polarAngles: Array.isArray(polarAngles) ? polarAngles : (0, $467312b86c271c9f$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: Array.isArray(polarRadius) ? polarRadius : (0, $467312b86c271c9f$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || "polar-grid",
                    radialLines: radialLines
                });
            });
            /**
       * Draw legend
       * @return {ReactElement}            The instance of Legend
       */ $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "renderLegend", function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $c77276502bcbf93e$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $93a80a75167ace33$var$_objectWithoutProperties(props, $93a80a75167ace33$var$_excluded);
                return /*#__PURE__*/ (0, $fgmOP.cloneElement)(item, $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            });
            /**
       * Draw Tooltip
       * @return {ReactElement}  The instance of Tooltip
       */ $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "renderTooltip", function() {
                var _tooltipItem$props$ac;
                var _this$props3 = _this.props, children = _this$props3.children, accessibilityLayer = _this$props3.accessibilityLayer;
                var tooltipItem = (0, $fa0843e4e64def56$export$64c61536a2b72e0f)(children, (0, $745d4834f0c300ba$export$28c660c63b792dea));
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                // The user can set isActive on the Tooltip,
                // and we respect the user to enable customisation.
                // The Tooltip is active if the user has set isActive, or if the tooltip is active due to a mouse event.
                var isActive = (_tooltipItem$props$ac = tooltipItem.props.active) !== null && _tooltipItem$props$ac !== void 0 ? _tooltipItem$props$ac : isTooltipActive;
                return /*#__PURE__*/ (0, $fgmOP.cloneElement)(tooltipItem, {
                    viewBox: $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isActive,
                    label: activeLabel,
                    payload: isActive ? activePayload : [],
                    coordinate: activeCoordinate,
                    accessibilityLayer: accessibilityLayer
                });
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "renderBrush", function(element) {
                var _this$props4 = _this.props, margin = _this$props4.margin, data = _this$props4.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId;
                // TODO: update brush when children update
                return /*#__PURE__*/ (0, $fgmOP.cloneElement)(element, {
                    key: element.key || "_recharts-brush",
                    onChange: (0, $467312b86c271c9f$export$760ec406ba47bace)(_this.handleBrushChange, element.props.onChange),
                    data: data,
                    x: (0, $e6d37abae86076b3$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $e6d37abae86076b3$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $e6d37abae86076b3$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "renderReferenceElement", function(element, displayName, index) {
                if (!element) return null;
                var _assertThisInitialize = $93a80a75167ace33$var$_assertThisInitialized(_this), clipPathId = _assertThisInitialize.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var _element$props2 = element.props, xAxisId = _element$props2.xAxisId, yAxisId = _element$props2.yAxisId;
                return /*#__PURE__*/ (0, $fgmOP.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "renderActivePoints", function(_ref10) {
                var item = _ref10.item, activePoint = _ref10.activePoint, basePoint = _ref10.basePoint, childIndex = _ref10.childIndex, isRange = _ref10.isRange;
                var result = [];
                var key = item.props.key;
                var _item$item$props = item.item.props, activeDot = _item$item$props.activeDot, dataKey = _item$item$props.dataKey;
                var dotProps = $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $467312b86c271c9f$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: "#fff",
                    payload: activePoint.payload,
                    value: activePoint.value,
                    key: "".concat(key, "-activePoint-").concat(childIndex)
                }, (0, $fa0843e4e64def56$export$d697c39a2985a4c)(activeDot, false)), (0, $9fee8beacafd8fde$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y,
                    key: "".concat(key, "-basePoint-").concat(childIndex)
                })));
                else if (isRange) result.push(null);
                return result;
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "renderGraphicChild", function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $fa0843e4e64def56$export$64c61536a2b72e0f)(children, (0, $745d4834f0c300ba$export$28c660c63b792dea));
                var _item$props2 = item.props, points = _item$props2.points, isRange = _item$props2.isRange, baseLine = _item$props2.baseLine;
                var _item$item$props2 = item.item.props, activeDot = _item$item$props2.activeDot, hide = _item$item$props2.hide, activeBar = _item$item$props2.activeBar, activeShape = _item$item$props2.activeShape;
                var hasActive = Boolean(!hide && isTooltipActive && tooltipItem && (activeDot || activeBar || activeShape));
                var itemEvents = {};
                if (tooltipEventType !== "axis" && tooltipItem && tooltipItem.props.trigger === "click") itemEvents = {
                    onClick: (0, $467312b86c271c9f$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onClick)
                };
                else if (tooltipEventType !== "axis") itemEvents = {
                    onMouseLeave: (0, $467312b86c271c9f$export$760ec406ba47bace)(_this.handleItemMouseLeave, element.props.onMouseLeave),
                    onMouseEnter: (0, $467312b86c271c9f$export$760ec406ba47bace)(_this.handleItemMouseEnter, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $fgmOP.cloneElement)(element, $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === "function" ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    if (activeTooltipIndex >= 0) {
                        var activePoint, basePoint;
                        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                            // number transform to string
                            var specifiedKey = typeof tooltipAxis.dataKey === "function" ? findWithPayload : "payload.".concat(tooltipAxis.dataKey.toString());
                            activePoint = (0, $e6d37abae86076b3$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                            basePoint = isRange && baseLine && (0, $e6d37abae86076b3$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                        } else {
                            activePoint = points === null || points === void 0 ? void 0 : points[activeTooltipIndex];
                            basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                        }
                        if (activeShape || activeBar) {
                            var activeIndex = element.props.activeIndex !== undefined ? element.props.activeIndex : activeTooltipIndex;
                            return [
                                /*#__PURE__*/ (0, $fgmOP.cloneElement)(element, $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, item.props), itemEvents), {}, {
                                    activeIndex: activeIndex
                                })),
                                null,
                                null
                            ];
                        }
                        if (!(0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(activePoint)) return [
                            graphicalItem
                        ].concat($93a80a75167ace33$var$_toConsumableArray(_this.renderActivePoints({
                            item: item,
                            activePoint: activePoint,
                            basePoint: basePoint,
                            childIndex: activeTooltipIndex,
                            isRange: isRange
                        })));
                    } else {
                        var _this$getItemByXY;
                        /**
             * We hit this block if consumer uses a Tooltip without XAxis and/or YAxis.
             * In which case, this.state.activeTooltipIndex never gets set
             * because the mouse events that trigger that value getting set never get trigged without the axis components.
             *
             * An example usage case is a FunnelChart
             */ var _ref11 = (_this$getItemByXY = _this.getItemByXY(_this.state.activeCoordinate)) !== null && _this$getItemByXY !== void 0 ? _this$getItemByXY : {
                            graphicalItem: graphicalItem
                        }, _ref11$graphicalItem = _ref11.graphicalItem, _ref11$graphicalItem$ = _ref11$graphicalItem.item, xyItem = _ref11$graphicalItem$ === void 0 ? element : _ref11$graphicalItem$, childIndex = _ref11$graphicalItem.childIndex;
                        var elementProps = $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, item.props), itemEvents), {}, {
                            activeIndex: childIndex
                        });
                        return [
                            /*#__PURE__*/ (0, $fgmOP.cloneElement)(xyItem, elementProps),
                            null,
                            null
                        ];
                    }
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "renderCustomized", function(element, displayName, index) {
                return /*#__PURE__*/ (0, $fgmOP.cloneElement)(element, $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            });
            $93a80a75167ace33$var$_defineProperty($93a80a75167ace33$var$_assertThisInitialized(_this), "renderMap", {
                CartesianGrid: {
                    handler: $93a80a75167ace33$var$renderAsIs,
                    once: true
                },
                ReferenceArea: {
                    handler: _this.renderReferenceElement
                },
                ReferenceLine: {
                    handler: $93a80a75167ace33$var$renderAsIs
                },
                ReferenceDot: {
                    handler: _this.renderReferenceElement
                },
                XAxis: {
                    handler: $93a80a75167ace33$var$renderAsIs
                },
                YAxis: {
                    handler: $93a80a75167ace33$var$renderAsIs
                },
                Brush: {
                    handler: _this.renderBrush,
                    once: true
                },
                Bar: {
                    handler: _this.renderGraphicChild
                },
                Line: {
                    handler: _this.renderGraphicChild
                },
                Area: {
                    handler: _this.renderGraphicChild
                },
                Radar: {
                    handler: _this.renderGraphicChild
                },
                RadialBar: {
                    handler: _this.renderGraphicChild
                },
                Scatter: {
                    handler: _this.renderGraphicChild
                },
                Pie: {
                    handler: _this.renderGraphicChild
                },
                Funnel: {
                    handler: _this.renderGraphicChild
                },
                Tooltip: {
                    handler: _this.renderCursor,
                    once: true
                },
                PolarGrid: {
                    handler: _this.renderPolarGrid,
                    once: true
                },
                PolarAngleAxis: {
                    handler: _this.renderPolarAxis
                },
                PolarRadiusAxis: {
                    handler: _this.renderPolarAxis
                },
                Customized: {
                    handler: _this.renderCustomized
                }
            });
            _this.clipPathId = "".concat((_props$id = _props.id) !== null && _props$id !== void 0 ? _props$id : (0, $e6d37abae86076b3$export$8b15d37bc3f197d4)("recharts"), "-clip");
            // trigger 60fps
            _this.throttleTriggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($f1dee9cd6a2dde8d$exports)))(_this.triggeredAfterMouseMove, (_props$throttleDelay = _props.throttleDelay) !== null && _props$throttleDelay !== void 0 ? _props$throttleDelay : 1000 / 60);
            _this.state = {};
            return _this;
        }
        $93a80a75167ace33$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this$props$margin$le, _this$props$margin$to;
                    this.addListener();
                    this.accessibilityManager.setDetails({
                        container: this.container,
                        offset: {
                            left: (_this$props$margin$le = this.props.margin.left) !== null && _this$props$margin$le !== void 0 ? _this$props$margin$le : 0,
                            top: (_this$props$margin$to = this.props.margin.top) !== null && _this$props$margin$to !== void 0 ? _this$props$margin$to : 0
                        },
                        coordinateList: this.state.tooltipTicks,
                        mouseHandlerCallback: this.triggeredAfterMouseMove,
                        layout: this.props.layout
                    });
                    this.displayDefaultTooltip();
                }
            },
            {
                key: "displayDefaultTooltip",
                value: function displayDefaultTooltip() {
                    var _this$props5 = this.props, children = _this$props5.children, data = _this$props5.data, height = _this$props5.height, layout = _this$props5.layout;
                    var tooltipElem = (0, $fa0843e4e64def56$export$64c61536a2b72e0f)(children, (0, $745d4834f0c300ba$export$28c660c63b792dea));
                    // If the chart doesn't include a <Tooltip /> element, there's no tooltip to display
                    if (!tooltipElem) return;
                    var defaultIndex = tooltipElem.props.defaultIndex;
                    // Protect against runtime errors
                    if (typeof defaultIndex !== "number" || defaultIndex < 0 || defaultIndex > this.state.tooltipTicks.length) return;
                    var activeLabel = this.state.tooltipTicks[defaultIndex] && this.state.tooltipTicks[defaultIndex].value;
                    var activePayload = $93a80a75167ace33$var$getTooltipContent(this.state, data, defaultIndex, activeLabel);
                    var independentAxisCoord = this.state.tooltipTicks[defaultIndex].coordinate;
                    var dependentAxisCoord = (this.state.offset.top + height) / 2;
                    var isHorizontal = layout === "horizontal";
                    var activeCoordinate = isHorizontal ? {
                        x: independentAxisCoord,
                        y: dependentAxisCoord
                    } : {
                        y: independentAxisCoord,
                        x: dependentAxisCoord
                    };
                    // Unlike other chart types, scatter plot's tooltip positions rely on both X and Y coordinates. Only the scatter plot
                    // element knows its own Y coordinates.
                    // If there's a scatter plot, we'll want to grab that element for an interrogation.
                    var scatterPlotElement = this.state.formattedGraphicalItems.find(function(_ref12) {
                        var item = _ref12.item;
                        return item.type.name === "Scatter";
                    });
                    if (scatterPlotElement) {
                        activeCoordinate = $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, activeCoordinate), scatterPlotElement.props.points[defaultIndex].tooltipPosition);
                        activePayload = scatterPlotElement.props.points[defaultIndex].tooltipPayload;
                    }
                    var nextState = {
                        activeTooltipIndex: defaultIndex,
                        isTooltipActive: true,
                        activeLabel: activeLabel,
                        activePayload: activePayload,
                        activeCoordinate: activeCoordinate
                    };
                    this.setState(nextState);
                    this.renderCursor(tooltipElem);
                    // Make sure that anyone who keyboard-only users who tab to the chart will start their
                    // cursors at defaultIndex
                    this.accessibilityManager.setIndex(defaultIndex);
                }
            },
            {
                key: "getSnapshotBeforeUpdate",
                value: function getSnapshotBeforeUpdate(prevProps, prevState) {
                    if (!this.props.accessibilityLayer) return null;
                    if (this.state.tooltipTicks !== prevState.tooltipTicks) this.accessibilityManager.setDetails({
                        coordinateList: this.state.tooltipTicks
                    });
                    if (this.props.layout !== prevProps.layout) this.accessibilityManager.setDetails({
                        layout: this.props.layout
                    });
                    if (this.props.margin !== prevProps.margin) {
                        var _this$props$margin$le2, _this$props$margin$to2;
                        this.accessibilityManager.setDetails({
                            offset: {
                                left: (_this$props$margin$le2 = this.props.margin.left) !== null && _this$props$margin$le2 !== void 0 ? _this$props$margin$le2 : 0,
                                top: (_this$props$margin$to2 = this.props.margin.top) !== null && _this$props$margin$to2 !== void 0 ? _this$props$margin$to2 : 0
                            }
                        });
                    }
                    // Something has to be returned for getSnapshotBeforeUpdate
                    return null;
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // Check to see if the Tooltip updated. If so, re-check default tooltip position
                    if (!(0, $fa0843e4e64def56$export$acdc716e08572f94)([
                        (0, $fa0843e4e64def56$export$64c61536a2b72e0f)(prevProps.children, (0, $745d4834f0c300ba$export$28c660c63b792dea))
                    ], [
                        (0, $fa0843e4e64def56$export$64c61536a2b72e0f)(this.props.children, (0, $745d4834f0c300ba$export$28c660c63b792dea))
                    ])) this.displayDefaultTooltip();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.removeListener();
                    this.throttleTriggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $fa0843e4e64def56$export$64c61536a2b72e0f)(this.props.children, (0, $745d4834f0c300ba$export$28c660c63b792dea));
                    if (tooltipItem && typeof tooltipItem.props.shared === "boolean") {
                        var eventType = tooltipItem.props.shared ? "axis" : "item";
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var element = this.container;
                    var boundingRect = element.getBoundingClientRect();
                    var containerOffset = (0, $b283dcf1f7838ffe$export$622cea445a1c5b7d)(boundingRect);
                    var e = {
                        chartX: Math.round(event.pageX - containerOffset.left),
                        chartY: Math.round(event.pageY - containerOffset.top)
                    };
                    var scale = boundingRect.width / element.offsetWidth || 1;
                    var rangeObj = this.inRange(e.chartX, e.chartY, scale);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    if (tooltipEventType !== "axis" && xAxisMap && yAxisMap) {
                        var xScale = (0, $e6d37abae86076b3$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $e6d37abae86076b3$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        });
                    }
                    var toolTipData = $93a80a75167ace33$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (toolTipData) return $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
                    var layout = this.props.layout;
                    var scaledX = x / scale, scaledY = y / scale;
                    if (layout === "horizontal" || layout === "vertical") {
                        var offset = this.state.offset;
                        var isInRange = scaledX >= offset.left && scaledX <= offset.left + offset.width && scaledY >= offset.top && scaledY <= offset.top + offset.height;
                        return isInRange ? {
                            x: scaledX,
                            y: scaledY
                        } : null;
                    }
                    var _this$state10 = this.state, angleAxisMap = _this$state10.angleAxisMap, radiusAxisMap = _this$state10.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $e6d37abae86076b3$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $edd20ed1082bc6c5$export$e85a2bf8cd31c504)({
                            x: scaledX,
                            y: scaledY
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $fa0843e4e64def56$export$64c61536a2b72e0f)(children, (0, $745d4834f0c300ba$export$28c660c63b792dea));
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === "axis") {
                        if (tooltipItem.props.trigger === "click") tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd
                        };
                    }
                    // @ts-expect-error adaptEventHandlers expects DOM Event but generateCategoricalChart works with React UIEvents
                    var outerEvents = (0, $9fee8beacafd8fde$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $219cd27da47b8e04$export$9bcdfe5f29bb33).on((0, $219cd27da47b8e04$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $219cd27da47b8e04$export$9bcdfe5f29bb33).removeListener((0, $219cd27da47b8e04$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $fa0843e4e64def56$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = $93a80a75167ace33$var$_slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, res), {}, $93a80a75167ace33$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = $93a80a75167ace33$var$_slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, res), {}, $93a80a75167ace33$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 || (_this$state$xAxisMap = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap === void 0 ? void 0 : _this$state$xAxisMap.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 || (_this$state$yAxisMap = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap === void 0 ? void 0 : _this$state$yAxisMap.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var _this$state11 = this.state, formattedGraphicalItems = _this$state11.formattedGraphicalItems, activeItem = _this$state11.activeItem;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemDisplayName = (0, $fa0843e4e64def56$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === "Bar") {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $a461e5a23755aeba$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === "RadialBar") {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $edd20ed1082bc6c5$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        } else if ((0, $6430c30b8465b77b$export$4b83e8415af38a18)(graphicalItem, activeItem) || (0, $6430c30b8465b77b$export$f722d7e63cc07b)(graphicalItem, activeItem) || (0, $6430c30b8465b77b$export$f62b21bcfd1a733e)(graphicalItem, activeItem)) {
                            var activeIndex = (0, $6430c30b8465b77b$export$bd5d63c57ca4468)({
                                graphicalItem: graphicalItem,
                                activeTooltipItem: activeItem,
                                itemData: item.props.data
                            });
                            var childIndex = item.props.activeIndex === undefined ? activeIndex : item.props.activeIndex;
                            return {
                                graphicalItem: $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, graphicalItem), {}, {
                                    childIndex: childIndex
                                }),
                                payload: (0, $6430c30b8465b77b$export$f62b21bcfd1a733e)(graphicalItem, activeItem) ? item.props.data[activeIndex] : graphicalItem.props.data[activeIndex]
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    if (!(0, $fa0843e4e64def56$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, title = _this$props6.title, desc = _this$props6.desc, others = $93a80a75167ace33$var$_objectWithoutProperties(_this$props6, $93a80a75167ace33$var$_excluded2);
                    var attrs = (0, $fa0843e4e64def56$export$d697c39a2985a4c)(others, false);
                    // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $bf7c628d5130940b$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $2a6ed8f50f2d8df8$export$7b92b459e668cb21), $93a80a75167ace33$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc
                    }), this.renderClipPath(), (0, $fa0843e4e64def56$export$a98d6da55570cb82)(children, this.renderMap)));
                    if (this.props.accessibilityLayer) {
                        var _this$props$tabIndex, _this$props$role;
                        // Set tabIndex to 0 by default (can be overwritten)
                        attrs.tabIndex = (_this$props$tabIndex = this.props.tabIndex) !== null && _this$props$tabIndex !== void 0 ? _this$props$tabIndex : 0;
                        // Set role to img by default (can be overwritten)
                        attrs.role = (_this$props$role = this.props.role) !== null && _this$props$role !== void 0 ? _this$props$role : "application";
                        attrs.onKeyDown = function(e) {
                            _this2.accessibilityManager.keyboardEvent(e);
                        // 'onKeyDown' is not currently a supported prop that can be passed through
                        // if it's added, this should be added: this.props.onKeyDown(e);
                        };
                        attrs.onFocus = function() {
                            _this2.accessibilityManager.focus();
                        // 'onFocus' is not currently a supported prop that can be passed through
                        // if it's added, the focus event should be forwarded to the prop
                        };
                    }
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $bf7c628d5130940b$export$e22c0f72c980af5a), {
                        state: this.state,
                        width: this.props.width,
                        height: this.props.height,
                        clipPathId: this.clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", $93a80a75167ace33$var$_extends({
                        className: (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-wrapper", className),
                        style: $93a80a75167ace33$var$_objectSpread({
                            position: "relative",
                            cursor: "default",
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this2.container = node;
                        }
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $2a6ed8f50f2d8df8$export$7b92b459e668cb21), $93a80a75167ace33$var$_extends({}, attrs, {
                        width: width,
                        height: height,
                        title: title,
                        desc: desc,
                        style: $93a80a75167ace33$var$FULL_WIDTH_AND_HEIGHT
                    }), this.renderClipPath(), (0, $fa0843e4e64def56$export$a98d6da55570cb82)(children, this.renderMap)), this.renderLegend(), this.renderTooltip()));
                }
            }
        ]);
        return CategoricalChartWrapper;
    }((0, $fgmOP.Component)), $93a80a75167ace33$var$_defineProperty(_CategoricalChartWrapper, "displayName", chartName), $93a80a75167ace33$var$_defineProperty(_CategoricalChartWrapper, "defaultProps", $93a80a75167ace33$var$_objectSpread({
        layout: "horizontal",
        stackOffset: "none",
        barCategoryGap: "10%",
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: "index"
    }, defaultProps)), $93a80a75167ace33$var$_defineProperty(_CategoricalChartWrapper, "getDerivedStateFromProps", function(nextProps, prevState) {
        var dataKey = nextProps.dataKey, data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        var dataStartIndex = prevState.dataStartIndex, dataEndIndex = prevState.dataEndIndex;
        if (prevState.updateId === undefined) {
            var defaultState = $93a80a75167ace33$export$e5182fb58612e577(nextProps);
            return $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (dataKey !== prevState.prevDataKey || data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $6d132e2dc77fb074$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $93a80a75167ace33$export$e5182fb58612e577(nextProps);
            // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, $93a80a75167ace33$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($93a80a75167ace33$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevDataKey: dataKey,
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $fa0843e4e64def56$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            var _brush$props$startInd, _brush$props, _brush$props$endIndex, _brush$props2;
            // specifically check for Brush - if it exists and the start and end indexes are different, re-render with the new ones
            var brush = (0, $fa0843e4e64def56$export$64c61536a2b72e0f)(children, (0, $2462b1ef157bd0f4$export$59bc2e3533b384a0));
            var startIndex = brush ? (_brush$props$startInd = (_brush$props = brush.props) === null || _brush$props === void 0 ? void 0 : _brush$props.startIndex) !== null && _brush$props$startInd !== void 0 ? _brush$props$startInd : dataStartIndex : dataStartIndex;
            var endIndex = brush ? (_brush$props$endIndex = (_brush$props2 = brush.props) === null || _brush$props2 === void 0 ? void 0 : _brush$props2.endIndex) !== null && _brush$props$endIndex !== void 0 ? _brush$props$endIndex : dataEndIndex : dataEndIndex;
            var hasDifferentStartOrEndIndex = startIndex !== dataStartIndex || endIndex !== dataEndIndex;
            // update configuration in children
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($1fb33066f3baf75f$exports)))(data);
            var newUpdateId = hasGlobalData && !hasDifferentStartOrEndIndex ? prevState.updateId : prevState.updateId + 1;
            return $93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($93a80a75167ace33$var$_objectSpread($93a80a75167ace33$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            }), prevState)), {}, {
                prevChildren: children,
                dataStartIndex: startIndex,
                dataEndIndex: endIndex
            });
        }
        return null;
    }), $93a80a75167ace33$var$_defineProperty(_CategoricalChartWrapper, "renderActiveDot", function(option, props) {
        var dot;
        if (/*#__PURE__*/ (0, $fgmOP.isValidElement)(option)) dot = /*#__PURE__*/ (0, $fgmOP.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($ef0be999ea46011c$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $1698e123872278b0$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $c94f1401bbf8ca2c$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: props.key
        }, dot);
    }), _CategoricalChartWrapper;
};




var $fgmOP = parcelRequire("fgmOP");




function $b9352750c7c8c986$var$_extends() {
    $b9352750c7c8c986$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $b9352750c7c8c986$var$_extends.apply(this, arguments);
}
var $b9352750c7c8c986$export$ea77231de273b52d = function XAxis(_ref) {
    var xAxisId = _ref.xAxisId;
    var width = (0, $bf7c628d5130940b$export$8854f7ece606854b)();
    var height = (0, $bf7c628d5130940b$export$369ae257969c6f9f)();
    var axisOptions = (0, $bf7c628d5130940b$export$54f54805c81085c5)(xAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $a9c8dc1516444688$export$bdd99f2cdf352bae), $b9352750c7c8c986$var$_extends({}, axisOptions, {
        className: (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $467312b86c271c9f$export$c829ee42daf7f66d)(axis, true);
        }
    })));
};
$b9352750c7c8c986$export$ea77231de273b52d.displayName = "XAxis";
$b9352750c7c8c986$export$ea77231de273b52d.defaultProps = {
    allowDecimals: true,
    hide: false,
    orientation: "bottom",
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: "category",
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false,
    allowDuplicatedCategory: true
};



var $fgmOP = parcelRequire("fgmOP");




function $5a4b7783b430e2f4$var$_extends() {
    $5a4b7783b430e2f4$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5a4b7783b430e2f4$var$_extends.apply(this, arguments);
}
var $5a4b7783b430e2f4$export$f96c4024c52de8f4 = function YAxis(_ref) {
    var yAxisId = _ref.yAxisId;
    var width = (0, $bf7c628d5130940b$export$8854f7ece606854b)();
    var height = (0, $bf7c628d5130940b$export$369ae257969c6f9f)();
    var axisOptions = (0, $bf7c628d5130940b$export$6f8958021ad81c20)(yAxisId);
    if (axisOptions == null) return null;
    return(/*#__PURE__*/ // @ts-expect-error the axisOptions type is not exactly what CartesianAxis is expecting.
    (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $a9c8dc1516444688$export$bdd99f2cdf352bae), $5a4b7783b430e2f4$var$_extends({}, axisOptions, {
        className: (0, $ea61c8427271ba9b$export$2e2bcd8739ae039)("recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType), axisOptions.className),
        viewBox: {
            x: 0,
            y: 0,
            width: width,
            height: height
        },
        ticksGenerator: function ticksGenerator(axis) {
            return (0, $467312b86c271c9f$export$c829ee42daf7f66d)(axis, true);
        }
    })));
};
$5a4b7783b430e2f4$export$f96c4024c52de8f4.displayName = "YAxis";
$5a4b7783b430e2f4$export$f96c4024c52de8f4.defaultProps = {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: "left",
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: "number",
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false
};



var $ed2e9ea2f41253e7$export$54d0e8420ac838ac = (0, $93a80a75167ace33$export$77871aede60e6838)({
    chartName: "LineChart",
    GraphicalChild: (0, $ce2e58c9d73cd4fc$export$17d680238e50603e),
    axisComponents: [
        {
            axisType: "xAxis",
            AxisComp: (0, $b9352750c7c8c986$export$ea77231de273b52d)
        },
        {
            axisType: "yAxis",
            AxisComp: (0, $5a4b7783b430e2f4$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $8f9440c92078f509$export$ece7de1383db5ac)
});


var $5c45267555efbb8f$exports = {};
$5c45267555efbb8f$exports = "query settlementsTotals($years:[Int]){settlementsTotals(years:$years){period isComplete isApproved products{productId EXTERNAL INTERNAL}}}";










var $fgmOP = parcelRequire("fgmOP");

var $jPPOv = parcelRequire("jPPOv");




var $3ab394edcd89558b$var$_excluded = [
    "kind",
    "minimizable",
    "size",
    "iconSize",
    "bodyHtml",
    "closeButtonText",
    "links",
    "children",
    "onOpen",
    "onClose",
    "isOpen",
    "scrollTo",
    "minimizedText",
    "className",
    "hideIcon"
];
function $3ab394edcd89558b$var$_extends() {
    $3ab394edcd89558b$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3ab394edcd89558b$var$_extends.apply(this, arguments);
}
function $3ab394edcd89558b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $3ab394edcd89558b$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $3ab394edcd89558b$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $3ab394edcd89558b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Status: *finished*.
 * Category: Notifications
 */ var $3ab394edcd89558b$var$Alert = function Alert(_ref) {
    var _classnames;
    var _ref$kind = _ref.kind, kind = _ref$kind === void 0 ? "positive" : _ref$kind, minimizable = _ref.minimizable, size = _ref.size, _ref$iconSize = _ref.iconSize, iconSize = _ref$iconSize === void 0 ? "small" : _ref$iconSize, bodyHtml = _ref.bodyHtml, _ref$closeButtonText = _ref.closeButtonText, closeButtonText = _ref$closeButtonText === void 0 ? "LUKK" : _ref$closeButtonText, _ref$links = _ref.links, links = _ref$links === void 0 ? [] : _ref$links, children = _ref.children, onOpen = _ref.onOpen, onClose = _ref.onClose, isOpen = _ref.isOpen, _ref$scrollTo = _ref.scrollTo, scrollTo = _ref$scrollTo === void 0 ? false : _ref$scrollTo, minimizedText = _ref.minimizedText, className = _ref.className, hideIcon = _ref.hideIcon, rest = $3ab394edcd89558b$var$_objectWithoutProperties(_ref, $3ab394edcd89558b$var$_excluded);
    var alertRef = (0, $fgmOP.useRef)();
    var positiveAlert = kind === "positive";
    (0, $fgmOP.useEffect)(function() {
        if (scrollTo) alertRef.current.scrollIntoView({
            behavior: "smooth",
            block: "start"
        });
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", $3ab394edcd89558b$var$_extends({
        ref: alertRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($da078a8a2d208f2b$exports)))("alert", (_classnames = {}, $3ab394edcd89558b$var$_defineProperty(_classnames, className, className), $3ab394edcd89558b$var$_defineProperty(_classnames, "alert--".concat(kind), kind), $3ab394edcd89558b$var$_defineProperty(_classnames, "alert--".concat(size), size), $3ab394edcd89558b$var$_defineProperty(_classnames, "alert--minimizable", minimizable), $3ab394edcd89558b$var$_defineProperty(_classnames, "alert--minimized", minimizable && !isOpen), _classnames)),
        role: "alert"
    }, rest), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "alert__content"
    }, !hideIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "alert__icon-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $2edc691f96482cbe$export$f04a61298a47a40f), {
        icon: positiveAlert ? "check-mark-circle" : "info",
        style: {
            color: positiveAlert ? (0, $c750dd4eaae8b86c$export$8f45430ccf837300).green700 : (0, $c750dd4eaae8b86c$export$8f45430ccf837300).black,
            width: iconSize === "small" ? "1.5rem" : "2.5rem",
            height: iconSize === "small" ? "1.5rem" : "2.5rem",
            marginRight: iconSize === "small" ? "0.5rem" : "1rem"
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("div", {
        className: "alert__text-container"
    }, children ? children : bodyHtml, links.length > 0 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("ul", {
        className: "list list--links list--black"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($c21c2d450eef15f5$exports)))(links, function(link, i) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("li", {
            key: i,
            className: "list__item"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("a", {
            className: "list__link",
            href: link.url,
            target: "_self"
        }, link.text));
    })) : null)), minimizable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("button", {
        onClick: onClose,
        className: "alert__close"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("span", {
        className: "alert__close-text"
    }, closeButtonText), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement((0, $2edc691f96482cbe$export$f04a61298a47a40f), {
        icon: "close",
        className: "box__close-icon",
        style: {
            width: "1.7rem",
            height: "1.7rem",
            position: "relative",
            top: "-0.3rem"
        }
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createElement("button", {
        onClick: onOpen,
        className: "alert__expand"
    }, minimizedText));
};
$3ab394edcd89558b$var$Alert.propTypes = {
    closeButtonText: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    kind: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).oneOf([
        "positive",
        "negative",
        "info",
        "warning"
    ]),
    size: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).oneOf([
        "large",
        "large-with-borders"
    ]),
    onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func,
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).func,
    isOpen: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    scrollTo: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    minimizedText: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
    links: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).shape({
        text: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string,
        url: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).string
    })),
    hideIcon: (0, (/*@__PURE__*/$parcel$interopDefault($jPPOv))).bool,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).ReactNode
};
var $3ab394edcd89558b$export$2e2bcd8739ae039 = $3ab394edcd89558b$var$Alert;


parcelRequire("fgmOP");

const $c2d6f6ec67e3af8a$export$a2f8a18483889e2a = (props)=>{
    const { incompleteDate: incompleteDate, unapprovedDate: unapprovedDate } = props;
    return incompleteDate || unapprovedDate ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
        className: "pending__info--container",
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3ab394edcd89558b$export$2e2bcd8739ae039), {
            kind: "warning",
            children: incompleteDate ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("p", {
                children: [
                    "The totals report for ",
                    (0, $f5d0c2a7498ff49b$exports.dates).monthNames[parseInt(incompleteDate.month) - 1],
                    " ",
                    incompleteDate.year,
                    " is pending and might show incomplete numbers until",
                    " ",
                    (0, $f5d0c2a7498ff49b$exports.dates).monthNames[parseInt((0, $f5d0c2a7498ff49b$exports.dates).nextMonthMm(incompleteDate.month)) - 1],
                    " 3",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("sup", {
                        children: "rd"
                    }),
                    " when settlements are finalized."
                ]
            }) : unapprovedDate && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("p", {
                children: [
                    "The totals report for ",
                    (0, $f5d0c2a7498ff49b$exports.dates).monthNames[parseInt(unapprovedDate.month) - 1],
                    " ",
                    unapprovedDate.year,
                    " is unapproved and may be adjusted before being approved."
                ]
            })
        })
    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {});
};


const $d5eb60b5609136dd$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReportMonthlyUsageGraph", "INFO");
const $d5eb60b5609136dd$var$colors = [
    (0, $c750dd4eaae8b86c$export$8f45430ccf837300).corePurple500,
    (0, $c750dd4eaae8b86c$export$8f45430ccf837300).green500,
    (0, $c750dd4eaae8b86c$export$8f45430ccf837300).red500,
    (0, $c750dd4eaae8b86c$export$8f45430ccf837300).orange500,
    (0, $c750dd4eaae8b86c$export$8f45430ccf837300).blue500
];
const $d5eb60b5609136dd$var$getYearFromDataKey = (dataKey)=>dataKey.split(".")[0];
const $d5eb60b5609136dd$var$CustomTooltip = (props)=>{
    $d5eb60b5609136dd$var$log.debug("custom tooltip props", props);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: "tooltip__wrapper",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h5", {
                className: "heading--level-4 tooltip__heading",
                children: props.label
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("table", {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("tbody", {
                    children: props.payload?.map((row)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("tr", {
                            className: "tooltip__row",
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                        className: "tooltip__circle",
                                        style: {
                                            backgroundColor: row.stroke
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("td", {
                                    children: [
                                        $d5eb60b5609136dd$var$getYearFromDataKey(row.name),
                                        ":"
                                    ]
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("td", {
                                    className: "rightText tooltip__value",
                                    children: (0, $f5d0c2a7498ff49b$exports.format).currency(Number(row.value), "", false)
                                })
                            ]
                        }, row.name))
                })
            })
        ]
    });
};
const $d5eb60b5609136dd$export$a47fbd4a6f4486ca = ({ years: years, contractType: contractType, productType: productType, onClick: onClick, className: className })=>{
    const { currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    years = years.slice().sort().reverse();
    const { loading: loading, data: { settlementsTotals: settlementsTotals } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($5c45267555efbb8f$exports)))), {
        skip: !currentUserBrand,
        variables: {
            years: years
        }
    });
    $d5eb60b5609136dd$var$log.debug("props", settlementsTotals);
    const onGraphClick = (nextState)=>{
        $d5eb60b5609136dd$var$log.debug("onClick", nextState);
        if (nextState && nextState.activeLabel) onClick((0, $f5d0c2a7498ff49b$exports.dates).monthMm(nextState.activeLabel));
    };
    const [notComplete, setNotComplete] = (0, $fgmOP.useState)();
    const [notApproved, setNotApproved] = (0, $fgmOP.useState)();
    const data = (0, $fgmOP.useMemo)(()=>{
        let dataMap = {};
        setNotComplete(undefined);
        setNotApproved(undefined);
        settlementsTotals?.forEach((monthTotal)=>{
            const monthMm = monthTotal.period.substring(4, 6);
            const month = (0, $f5d0c2a7498ff49b$exports.format).monthName(monthMm);
            const year = monthTotal.period.substring(0, 4);
            if (!monthTotal.isComplete) setNotComplete({
                month: monthMm,
                year: year
            });
            if (!monthTotal.isApproved) setNotApproved({
                month: monthMm,
                year: year
            });
            monthTotal.products.forEach((product)=>{
                dataMap[month] = {
                    ...dataMap[month],
                    [monthTotal.period.substring(0, 4)]: {
                        ...dataMap[month] ? dataMap[month][monthTotal.period.substring(0, 4)] : {},
                        [product.productId]: {
                            internal: product.INTERNAL,
                            external: product.EXTERNAL,
                            all: product.INTERNAL + product.EXTERNAL
                        }
                    }
                };
            });
        });
        return Object.keys(dataMap).map((key)=>({
                ...dataMap[key],
                month: key
            }));
    }, [
        settlementsTotals
    ]);
    $d5eb60b5609136dd$var$log.debug("data", data);
    const lineProps = {
        type: "monotone",
        strokeWidth: 2,
        dot: {
            strokeDasharray: "",
            strokeWidth: 4,
            r: 0.5
        },
        isAnimationActive: false
    };
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            !!years.length && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c2d6f6ec67e3af8a$export$a2f8a18483889e2a), {
                incompleteDate: notComplete,
                unapprovedDate: notApproved
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("SettlementTotalsGraph", className),
                style: {
                    width: "900px",
                    height: "600px"
                },
                children: loading ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : !settlementsTotals || settlementsTotals.isEmpty() || !years.length ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                    description: `No settlement data`
                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ed2e9ea2f41253e7$export$54d0e8420ac838ac), {
                    width: 900,
                    height: 600,
                    data: data,
                    margin: {
                        top: 5,
                        right: 0,
                        left: 0,
                        bottom: 5
                    },
                    onClick: onGraphClick,
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $620b095cfe971036$export$6440e27b9f186856), {
                            strokeDasharray: "3 3",
                            vertical: false
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $b9352750c7c8c986$export$ea77231de273b52d), {
                            dataKey: "month",
                            allowDuplicatedCategory: false,
                            fontSize: 10,
                            padding: {
                                left: 25,
                                right: 25
                            }
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5a4b7783b430e2f4$export$f96c4024c52de8f4), {
                            fontSize: 10,
                            tickCount: 8,
                            tickFormatter: (value)=>(0, $f5d0c2a7498ff49b$exports.format).currency(Number(value), ""),
                            tick: {
                                width: 100
                            }
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $745d4834f0c300ba$export$28c660c63b792dea), {
                            animationDuration: 100,
                            formatter: (value, name)=>[
                                    (0, $f5d0c2a7498ff49b$exports.format).currency(Number(value), ""),
                                    $d5eb60b5609136dd$var$getYearFromDataKey(name.toString())
                                ],
                            wrapperStyle: {
                                outline: "none"
                            },
                            contentStyle: {
                                alignItems: "end"
                            },
                            content: $d5eb60b5609136dd$var$CustomTooltip
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c217c6640e254c03$export$ed247974535929c7), {
                            layout: "vertical",
                            align: "right",
                            verticalAlign: "top",
                            height: 36,
                            iconType: "plainline",
                            formatter: $d5eb60b5609136dd$var$getYearFromDataKey
                        }),
                        years.map((year, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ce2e58c9d73cd4fc$export$17d680238e50603e), {
                                    ...lineProps,
                                    dataKey: year + "." + productType.toUpperCase() + "." + contractType.toLowerCase(),
                                    strokeDasharray: "",
                                    stroke: $d5eb60b5609136dd$var$colors[i]
                                }, year + "." + productType.toLowerCase() + "." + contractType.toLowerCase())
                            }, year + "Fragment"))
                    ]
                })
            })
        ]
    });
};


const $2d1801b788225f03$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReportMontlyUsage", "INFO");
const { ALL: $2d1801b788225f03$var$ALL, contractTypes: $2d1801b788225f03$var$contractTypes, EXTERNAL_CONTRACT_TYPE: $2d1801b788225f03$var$EXTERNAL_CONTRACT_TYPE, INTERNAL_CONTRACT_TYPE: $2d1801b788225f03$var$INTERNAL_CONTRACT_TYPE } = (0, $f5d0c2a7498ff49b$exports.constants);
const { monthMm: $2d1801b788225f03$var$monthMm, dateOfLastDayOfPreviousMonth: $2d1801b788225f03$var$dateOfLastDayOfPreviousMonth } = (0, $f5d0c2a7498ff49b$exports.dates);
const $2d1801b788225f03$var$lastMonthDate = $2d1801b788225f03$var$dateOfLastDayOfPreviousMonth();
const $2d1801b788225f03$export$3de6ab98c3d7b76c = (props)=>{
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)({
        isEditing: true,
        useUrlParams: true,
        preferenceFieldNames: [
            "years"
        ],
        initialEntity: {
            years: [
                $2d1801b788225f03$var$lastMonthDate.getFullYear().toString()
            ],
            month: $2d1801b788225f03$var$monthMm($2d1801b788225f03$var$lastMonthDate),
            contractType: "ALL",
            productType: "ALL"
        }
    });
    const { entity: entity, entityAs: entityAs, onChange: onChange } = formState;
    const { years: years, month: month, contractType: contractType, productType: productType } = entityAs();
    $2d1801b788225f03$var$log.debug("entity", {
        entity: entity
    });
    const { productTypes: productTypes, isDirectChargeRange: isDirectChargeRange } = (0, $98effcf86fafb9fb$export$75025970e7082eca)();
    const { currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const filteredProductTypes = (0, $fgmOP.useMemo)(()=>productTypes.filter(({ brandId: brandId, id: id })=>currentUserBrand?.id === brandId && !isDirectChargeRange(id)), [
        currentUserBrand,
        productTypes
    ]);
    const onSettlementTotalsGraphClick = (month)=>{
        $2d1801b788225f03$var$log.debug("onSettlementTotalsGraphClick", {
            month: month
        });
        onChange("month")(month);
    };
    const onYearsChange = (value)=>{
        if (value.isEmpty()) formState.putError("years", "Atleast one year has to be selected.");
    };
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Monthly Totals"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "monthly-usage"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("SettlementMonthTotal", props.className),
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "years",
                                    label: "Years",
                                    options: (0, $f5d0c2a7498ff49b$exports.dates).yearsFrom(2019).map((y)=>y.toString()),
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi,
                                    onChangeAlso: onYearsChange
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "contractType",
                                    label: "Contract Types",
                                    options: [
                                        {
                                            id: $2d1801b788225f03$var$ALL,
                                            name: "All contracts"
                                        },
                                        ...$2d1801b788225f03$var$contractTypes
                                    ],
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                    tip: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                        className: "bold",
                                                        children: $2d1801b788225f03$var$EXTERNAL_CONTRACT_TYPE
                                                    }),
                                                    " contract which will be invoiced"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                        className: "bold",
                                                        children: $2d1801b788225f03$var$INTERNAL_CONTRACT_TYPE
                                                    }),
                                                    " contract do NOT get invoiced"
                                                ]
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "productType",
                                    label: "Service Types",
                                    options: [
                                        {
                                            id: $2d1801b788225f03$var$ALL,
                                            name: "All products"
                                        },
                                        ...filteredProductTypes
                                    ],
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {})
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d5eb60b5609136dd$export$a47fbd4a6f4486ca), {
                years: years.map((year)=>parseInt(year)),
                contractType: contractType,
                productType: productType,
                onClick: onSettlementTotalsGraphClick,
                className: "marginBottom"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("SettlementMonthTotal", props.className),
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "month",
                                    label: "Month",
                                    options: (0, $f5d0c2a7498ff49b$exports.dates).monthOptionValues,
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $e9e63b6d29d70b21$export$542967381b9f19e9), {
                        years: years,
                        month: month,
                        contractType: contractType,
                        productType: productType
                    })
                ]
            })
        ]
    });
};




parcelRequire("fgmOP");








const $4a3012764b872bbb$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReportOverview");
const $4a3012764b872bbb$export$7a668e7f089ce03d = (props)=>{
    const { hasPermission: hasPermission, isTelia: isTelia, isCustomer: isCustomer } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const { currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    $4a3012764b872bbb$var$log.debug("props", {
        hasPermission: hasPermission,
        isTelia: isTelia,
        isCustomer: isCustomer
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("Overview", props.className),
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Overview"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "overview"
            }),
            isTelia() && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $e7ded3c00eb49c59$export$237d44eeb6e90e79), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "graph",
                        title: "Monthly usage",
                        link: formatWithBrand($e9a95c61c800ecd2$export$3e394bc3bb4fc12b)
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "document-xls",
                        title: "Detailed statistics",
                        link: formatWithBrand($e9a95c61c800ecd2$export$1e42e92685e98be9)
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "chat",
                        title: "Detailed messages",
                        link: formatWithBrand($e9a95c61c800ecd2$export$7c824b2ea5505a8e)
                    }),
                    currentUserBrand?.id === "TELIA_NO" && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "money",
                        title: "Charging & Billing",
                        link: formatWithBrand($e9a95c61c800ecd2$export$f4198c574b87b640)
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "calendar",
                        title: "Access number history",
                        link: formatWithBrand($e9a95c61c800ecd2$export$7724472b45e16f3c)
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "security",
                        title: `Reserved SenderID`,
                        link: formatWithBrand($e9a95c61c800ecd2$export$cf334011f04d66bd)
                    })
                ]
            }),
            isCustomer() && hasPermission((0, $ca0941499cca84bb$export$4576703433079908)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $e7ded3c00eb49c59$export$237d44eeb6e90e79), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "document-xls",
                        title: "Detailed statistics",
                        link: formatWithBrand($e9a95c61c800ecd2$export$1e42e92685e98be9)
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "chat",
                        title: "Detailed messages",
                        link: formatWithBrand($e9a95c61c800ecd2$export$7c824b2ea5505a8e)
                    })
                ]
            })
        ]
    });
};



parcelRequire("fgmOP");







var $ff9mn = parcelRequire("ff9mn");



var $fgmOP = parcelRequire("fgmOP");









const $0ef84b1f77d23be2$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReservedOas", "INFO");
const $0ef84b1f77d23be2$export$8147eadf7a0656f7 = {
    ALPHANUM: {
        id: "ALPHANUM",
        name: "Lowercase alphanumeric text",
        description: "Text match for lowercase alphanumeric string",
        icon: "spell-check"
    },
    NUMBER: {
        id: "NUMBER",
        name: "Phone with country code",
        description: "Phone number match including country code prefix",
        match: /^\+{1}[\d]+$/,
        icon: "roaming"
    },
    SHORTCODE: {
        id: "SHORTCODE",
        name: "Short number",
        description: "Short code match of 3 or 6 digit code",
        match: /^(\d{3,6}){1}$/,
        icon: "smartphone"
    }
};
const { activeStatus: $0ef84b1f77d23be2$var$activeStatus } = (0, $f5d0c2a7498ff49b$exports.period);
const $0ef84b1f77d23be2$export$c9b0ebc05e3e420a = ", ";
const $0ef84b1f77d23be2$export$da8945421f81f838 = (comaSeparatedIds)=>comaSeparatedIds?.split($0ef84b1f77d23be2$export$c9b0ebc05e3e420a).map((id)=>id.trim()).filter((id)=>id.length > 0) || [];
const $0ef84b1f77d23be2$export$41cd538078e4842a = ()=>{
    const { hasPermission: hasPermission, currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { getCompanyNameByProductId: getCompanyNameByProductId, getAccessNumberByProductId: getAccessNumberByProductId, getCustomerIdByProductId: getCustomerIdByProductId } = (0, $24ef8762983c02cb$export$4c0ac5f906c0b8d6)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const { data: { reservedOas: reservedOas } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($cb40802b0ad9775f$exports)))), {
        variables: {
            countryId: currentUserBrand?.countryId
        },
        skip: !currentUserBrand
    });
    const filteredReservedOas = (0, $fgmOP.useMemo)(()=>(reservedOas || []).map(({ allowedProductIds: allowedProductIds, ...reservedOa })=>{
            const sortedAllowedProducts = allowedProductIds?.map((productId)=>({
                    productId: productId,
                    accessNumber: getAccessNumberByProductId(productId)
                })).sort((0, $ff9mn.withAccessNumbersSortComparator));
            return {
                ...reservedOa,
                allowedProductIds: allowedProductIds,
                companyName: reservedOa.ownerProductId ? getCompanyNameByProductId(reservedOa.ownerProductId) : undefined,
                customerId: reservedOa.ownerProductId ? getCustomerIdByProductId(reservedOa.ownerProductId) : undefined,
                allowedProducts: sortedAllowedProducts,
                accessNumber: sortedAllowedProducts?.head()?.accessNumber,
                activeStatus: $0ef84b1f77d23be2$var$activeStatus(reservedOa)
            };
        }), [
        reservedOas,
        getCompanyNameByProductId
    ]);
    const [sortedReservedOas, getThSortableProps] = (0, $c1364c3d18563e9b$export$2e2bcd8739ae039).useThSortable(filteredReservedOas, 3, [], {
        // @ts-ignore: special comparators not well defined
        accessNumber: (0, $ff9mn.accessNumbersSortComparator)
    });
    $0ef84b1f77d23be2$var$log.debug("ReservedOasFc", {
        reservedOas: reservedOas
    });
    const { THead: THead, Tr: Tr, ThSortable: ThSortable, TBody: TBody, Td: Td } = (0, $c1364c3d18563e9b$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: sortedReservedOas && !sortedReservedOas.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039), {
            clickable: false,
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(THead, {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)(Tr, {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(ThSortable, {
                                ...getThSortableProps("senderId"),
                                className: "leftText",
                                children: "SenderID"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(ThSortable, {
                                ...getThSortableProps("oaFormatClassifier"),
                                className: "centerText minWidth",
                                children: "Class"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(ThSortable, {
                                ...getThSortableProps("effect"),
                                children: "Effect"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(ThSortable, {
                                ...getThSortableProps("companyName"),
                                children: "Customer"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(ThSortable, {
                                ...getThSortableProps("ownerProductId"),
                                children: "Service"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(ThSortable, {
                                ...getThSortableProps("accessNumber"),
                                children: "Allowed short numbers"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(ThSortable, {
                                ...getThSortableProps("startDate"),
                                children: "Start Date"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(ThSortable, {
                                ...getThSortableProps("endDate"),
                                children: "End Date"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(ThSortable, {
                                ...getThSortableProps("activeStatus"),
                                children: "Active Status"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(TBody, {
                    children: sortedReservedOas?.map(({ companyName: reservedOaCompanyName, customerId: reservedOaCustomerId, allowedProducts: reservedOaAllowedProducts, accessNumber: accessNumber, activeStatus: activeStatus, startDate: startDate, endDate: endDate, ...reservedOa }, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)(Tr, {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                    className: "code",
                                    style: {
                                        textAlign: "left"
                                    },
                                    children: reservedOa.senderId
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                    className: "code minWidth",
                                    style: {
                                        textAlign: "left"
                                    },
                                    children: reservedOa.oaFormatClassifier && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                        icon: $0ef84b1f77d23be2$export$8147eadf7a0656f7[reservedOa.oaFormatClassifier].icon,
                                        info: $0ef84b1f77d23be2$export$8147eadf7a0656f7[reservedOa.oaFormatClassifier].name
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))(reservedOa.effect !== "ALLOW" && "redText"),
                                    children: reservedOa.effect === "ALLOW" ? "Allow" : "Block"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                        disabled: !reservedOa.ownerProductId
                                    }),
                                    children: reservedOa.ownerProductId ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                                        to: formatWithBrand($e9a95c61c800ecd2$export$80abc9f9ce9de04c, reservedOaCustomerId),
                                        children: reservedOaCompanyName || "???"
                                    }) : "System"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                        disabled: !reservedOa.ownerProductId
                                    }),
                                    children: reservedOa.ownerProductId ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                                        to: formatWithBrand($e9a95c61c800ecd2$export$a08784a3004fa57e, reservedOa.ownerProductId),
                                        children: reservedOa.ownerProductId
                                    }) : "System"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                        disabled: !reservedOaAllowedProducts?.length
                                    }),
                                    children: reservedOaAllowedProducts?.map(({ productId: productId, accessNumber: accessNumber }, index, all)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                                            children: [
                                                hasPermission((0, $ca0941499cca84bb$export$5baf0ad38a5e4791)) ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$a6c7ac8248d6e38a), {
                                                    to: formatWithBrand($e9a95c61c800ecd2$export$a08784a3004fa57e, productId),
                                                    children: accessNumber || "???"
                                                }) : accessNumber || "???",
                                                index < all.length - 1 && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                    children: ", "
                                                })
                                            ]
                                        }, index)) || "na"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                        disabled: !startDate
                                    }),
                                    children: startDate ? (0, $f5d0c2a7498ff49b$exports.format).date(startDate) : "no start"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                        disabled: !endDate
                                    }),
                                    children: endDate ? (0, $f5d0c2a7498ff49b$exports.format).date(endDate) : "no end"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(Td, {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))(activeStatus.toLowerCase() + "Period"),
                                    children: activeStatus
                                })
                            ]
                        }, i))
                })
            ]
        }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
            children: "There are no reserved SenderIDs"
        })
    });
};


const $eaff5f2ba4515a40$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReservedOas", "INFO");
const $eaff5f2ba4515a40$export$16512c21d780f520 = ()=>{
    $eaff5f2ba4515a40$var$log.debug("ReportReservedOasFc");
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Reserved SenderID"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "reserved-senderid"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $0ef84b1f77d23be2$export$41cd538078e4842a), {})
        ]
    });
};



parcelRequire("fgmOP");















var $fgmOP = parcelRequire("fgmOP");
var $58c3235d6ad37128$exports = {};
$58c3235d6ad37128$exports = "query blockedSenderIds($startDate:Date$endDate:Date$status:[ID]){blockedSenderIds(startDate:$startDate endDate:$endDate status:$status){...blockedSenderIdsFragment}}fragment blockedSenderIdsFragment on BlockedSenderId{date status accessNumber senderId customerId messages segments}";


















var $fgmOP = parcelRequire("fgmOP");

const $74557fad2715a9eb$export$640aba733f4f58a5 = ()=>{
    const convertToCsvString = (data)=>{
        return [
            data.header,
            ...data.content
        ].map((line)=>line.join(";")).join("\r\n");
    };
    const downloadAsCsv = (options)=>{
        const csv = convertToCsvString(options);
        const blob = new Blob([
            csv
        ], {
            type: "text/csv;charset=utf-8;"
        });
        const link = document.createElement("a");
        if (link.download !== undefined) {
            // support HTML5 download attribute
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", options.filename);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };
    return {
        convertToCsvString: convertToCsvString,
        downloadAsCsv: downloadAsCsv
    };
};




var $fgmOP = parcelRequire("fgmOP");
var $1769774ed24eb0c0$exports = {};
$1769774ed24eb0c0$exports = "query operators{operators{...operatorFragment}}fragment operatorFragment on Operator{id codes}";



const $177d8c49139b7c11$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("useOperators", "INFO");
const $177d8c49139b7c11$export$e0f51e86622d7cf9 = ()=>{
    const { loading: loading, data: { operators: operators } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($1769774ed24eb0c0$exports)))));
    const onNetCodes = (0, $fgmOP.useMemo)(()=>operators?.flatMap(({ codes: codes })=>codes).sort() || [], [
        operators
    ]);
    const netTypeFromOperatorCode = (code)=>{
        if (!code || Number.isNaN(parseInt(code))) return "Foreign";
        if (onNetCodes?.includes(parseInt(code))) return "On net";
        return "Off net";
    };
    const netTypeFromTrafficFee = (trafficFeeType)=>{
        if (trafficFeeType === "HOME") return "On net";
        if (trafficFeeType === "DOMESTIC") return "Off net";
        return "Foreign";
    };
    const useOperatorsHook = {
        loading: loading,
        operators: operators,
        onNetCodes: onNetCodes,
        netTypeFromOperatorCode: netTypeFromOperatorCode,
        netTypeFromTrafficFee: netTypeFromTrafficFee
    };
    $177d8c49139b7c11$var$log.debug("render", useOperatorsHook);
    return useOperatorsHook;
};






const $63ec6831458493c1$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReportStatisticsTable", "INFO");
const $63ec6831458493c1$export$a8c8bada5d85e82 = (props)=>{
    const { loading: loading, groupBy: groupBy, statistics: statistics } = props;
    const { netTypeFromOperatorCode: netTypeFromOperatorCode, netTypeFromTrafficFee: netTypeFromTrafficFee } = (0, $177d8c49139b7c11$export$e0f51e86622d7cf9)();
    const { downloadAsCsv: downloadAsCsv } = (0, $74557fad2715a9eb$export$640aba733f4f58a5)();
    const groupedStatistics = (0, $fgmOP.useMemo)(()=>$63ec6831458493c1$export$a5e87d33624cc9f4(statistics, groupBy), [
        statistics,
        groupBy,
        netTypeFromOperatorCode,
        netTypeFromTrafficFee
    ]);
    const [sortedStatistics, getThSortableProps] = (0, $c1364c3d18563e9b$export$2e2bcd8739ae039).useThSortable(groupedStatistics || [], 3, [], (0, $c8112e20ecbc0ea7$export$3754e0b777cdd23e));
    $63ec6831458493c1$var$log.debug("sortedStatistics", {
        sortedStatistics: sortedStatistics
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
            className: "marginTop",
            children: !loading && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).THead, {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Tr, {
                                    children: [
                                        groupBy.includes("date") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("date"),
                                            children: "Date"
                                        }),
                                        groupBy.includes("month") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("month"),
                                            children: "Date"
                                        }),
                                        groupBy.includes("customerName") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("customerName"),
                                            className: "noWrap",
                                            children: "Customer"
                                        }),
                                        groupBy.includes("contractId") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("contractId"),
                                            children: "Contract"
                                        }),
                                        groupBy.includes("senderId") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("senderId"),
                                            className: "noWrap",
                                            children: "Sender ID"
                                        }),
                                        groupBy.includes("accessNumber") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("accessNumber"),
                                            className: "noWrap",
                                            children: "Access Nr."
                                        }),
                                        groupBy.includes("contractType") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("contractType"),
                                            children: "Cnt. Type"
                                        }),
                                        groupBy.includes("productType") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("productType"),
                                            className: "noWrap",
                                            children: "Service Type"
                                        }),
                                        groupBy.includes("messageType") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("messageType"),
                                            children: "Msg. Type"
                                        }),
                                        groupBy.includes("resolution") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("resolution"),
                                            children: "Resolution"
                                        }),
                                        groupBy.includes("status") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("status"),
                                            children: "Status"
                                        }),
                                        groupBy.includes("operatorCode") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("operatorCode"),
                                            className: "noWrap",
                                            children: "MNO"
                                        }),
                                        groupBy.includes("netType") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("netType"),
                                            children: "Net"
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("messages"),
                                            children: "Messages"
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).ThSortable, {
                                            ...getThSortableProps("segments"),
                                            children: "Segments"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).TBody, {
                                children: sortedStatistics && sortedStatistics.map((statistic, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Tr, {
                                        children: [
                                            groupBy.includes("date") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                className: "noWrap",
                                                children: statistic.date
                                            }),
                                            groupBy.includes("month") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                className: "noWrap",
                                                children: statistic.month
                                            }),
                                            groupBy.includes("customerName") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: statistic.customerName
                                            }),
                                            groupBy.includes("contractId") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: statistic.contractId
                                            }),
                                            groupBy.includes("senderId") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: statistic.senderId
                                            }),
                                            groupBy.includes("accessNumber") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: statistic.accessNumber
                                            }),
                                            groupBy.includes("contractType") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: statistic.contractType
                                            }),
                                            groupBy.includes("productType") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: statistic.productType
                                            }),
                                            groupBy.includes("messageType") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: statistic.messageType
                                            }),
                                            groupBy.includes("resolution") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: [
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))([
                                                            "Expired",
                                                            "Unknown"
                                                        ].includes(statistic.resolution || "") ? "greyText" : statistic.resolution === "Rejected" ? "redText" : statistic.resolution === "Delivered" ? "greenText" : undefined),
                                                        children: statistic.resolution
                                                    }),
                                                    statistic.resolution === "Unknown" && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $acf38b6c25932409$export$2e2bcd8739ae039), {
                                                        text: "Legacy 'MT Sent' statistics data where the resolution is Unknown."
                                                    })
                                                ]
                                            }),
                                            groupBy.includes("status") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1ef65d6ab92c771d$export$2e2bcd8739ae039), {
                                                    status: statistic.status
                                                })
                                            }),
                                            groupBy.includes("operatorCode") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                className: "noWrap",
                                                children: statistic.operatorCode
                                            }),
                                            groupBy.includes("netType") && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                children: statistic.netType
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                className: "noWrap",
                                                children: (0, $f5d0c2a7498ff49b$exports.format).integer(statistic.messages)
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039).Td, {
                                                className: "noWrap",
                                                children: (0, $f5d0c2a7498ff49b$exports.format).integer(statistic.segments)
                                            })
                                        ]
                                    }, i))
                            })
                        ]
                    }),
                    statistics && statistics.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                        children: "No statistics found"
                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                        text: "Download as CSV",
                        onClick: ()=>downloadAsCsv({
                                ...$63ec6831458493c1$export$6bc57a0db0ac9eb3(sortedStatistics, groupBy),
                                filename: "report.csv"
                            })
                    })
                ]
            })
        })
    });
};
const $63ec6831458493c1$export$6bc57a0db0ac9eb3 = (statistics, groupBy)=>{
    const header = [];
    groupBy.includes("date") && header.push("Date");
    groupBy.includes("month") && header.push("Date");
    groupBy.includes("customerName") && header.push("Customer");
    groupBy.includes("contractId") && header.push("Contract");
    groupBy.includes("senderId") && header.push("Sender ID");
    groupBy.includes("accessNumber") && header.push("Access Nr");
    groupBy.includes("contractType") && header.push("Contract Type");
    groupBy.includes("productType") && header.push("Service Type");
    groupBy.includes("messageType") && header.push("Message Type");
    groupBy.includes("resolution") && header.push("Resolution");
    groupBy.includes("status") && header.push("Status");
    groupBy.includes("operatorCode") && header.push("MNO");
    groupBy.includes("netType") && header.push("Net");
    header.push("Messages", "Segments");
    const content = statistics.map((statistic)=>{
        const statsRow = [];
        groupBy.includes("date") && statsRow.push(statistic.date);
        groupBy.includes("month") && statsRow.push(statistic.month);
        groupBy.includes("customerName") && statsRow.push(statistic.customerName);
        groupBy.includes("contractId") && statsRow.push(statistic.contractId);
        groupBy.includes("senderId") && statsRow.push(statistic.senderId);
        groupBy.includes("accessNumber") && statsRow.push(statistic.accessNumber);
        groupBy.includes("contractType") && statsRow.push(statistic.contractType);
        groupBy.includes("productType") && statsRow.push(statistic.productType);
        groupBy.includes("messageType") && statsRow.push(statistic.messageType);
        groupBy.includes("resolution") && statsRow.push(statistic.resolution);
        groupBy.includes("status") && statsRow.push(statistic.status);
        groupBy.includes("operatorCode") && statsRow.push(statistic.operatorCode);
        groupBy.includes("netType") && statsRow.push(statistic.netType);
        statsRow.push(statistic.messages || 0, statistic.segments || 0);
        return statsRow;
    });
    return {
        header: header,
        content: content
    };
};
const $63ec6831458493c1$export$a5e87d33624cc9f4 = (statistics, groupBy)=>{
    const statsFields = [
        "messages",
        "segments",
        ...groupBy
    ];
    statsFields.includes("month") && statsFields.remove("date");
    $63ec6831458493c1$var$log.debug("statsFields", statsFields);
    const simplifiedStats = statistics.clone().map(({ ...s })=>{
        Object.keys(s).filter((f)=>!statsFields.includes(f)).forEach((f)=>delete s[f]);
        return s;
    });
    $63ec6831458493c1$var$log.debug("simplifiedStats", simplifiedStats);
    const groupedStatistics = simplifiedStats.reduce((res, { messages: messages, segments: segments, ...s })=>{
        const comboId = (0, (/*@__PURE__*/$parcel$interopDefault($3f999be1dfb2831f$exports))).stringify(Object.keys({
            ...s
        }).filter((f)=>groupBy.includes(f)).sort()//  FIXME: any
        .reduce((partial, key)=>{
            partial[key] = ({
                ...s
            })[key];
            return partial;
        }, {}));
        const partialS = res[comboId];
        if (!partialS) res[comboId] = {
            ...s,
            messages: messages,
            segments: segments
        };
        else res[comboId] = {
            ...s,
            messages: messages + partialS.messages,
            segments: segments + partialS.segments
        };
        return res;
    }, {});
    return Object.values(groupedStatistics);
};


const $8bbab09254f3d32f$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReportSenderIDStatistics", "INFO");
const $8bbab09254f3d32f$export$bd103764cce81b6d = (props)=>{
    const formStateOptions = {
        isEditing: true,
        useUrlParams: true,
        preferenceFieldNames: [
            "startDate",
            "endDate"
        ]
    };
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)(formStateOptions);
    const { entity: entity, isEditing: isEditing, putError: putError, onChange: onChange, onSaved: onSaved, onCancel: onCancel, onEdit: onEdit } = formState;
    const { statusCodes: statusCodes } = (0, $b5925f5d8efa7340$export$7ddd8c51b496162d)();
    const { getName: getCustomerName } = (0, $8d8d8b3d38044bbe$export$d27d8317adc3c298)();
    const senderIdStatusCodes = (0, $fgmOP.useMemo)(()=>statusCodes.filter(({ id: id })=>id === "9501" || id === "9502"), [
        statusCodes
    ]);
    const [fetch, { loading: loading, data: { blockedSenderIds: blockedSenderIds } = {} }] = (0, $6ccde90cf8233047$export$fd83eea6ecd2d8fa)((0, $d155419fd10bd2b6$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($58c3235d6ad37128$exports)))), {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only"
    });
    const fetchStatistics = ()=>{
        const parameters = entity || {};
        if (!(0, $f5d0c2a7498ff49b$exports.period).isValid(parameters)) {
            putError("startDate", "Invalid search period");
            putError("endDate", "Invalid search period");
            return;
        }
        if (!(Array.isArray(parameters?.status) && parameters.status.length > 0)) {
            putError("status", "Please select at least one status");
            return;
        }
        $8bbab09254f3d32f$var$log.info("Fetch statistics", {
            parameters: parameters
        });
        entity ? onSaved(entity) : onCancel();
        fetch({
            variables: {
                ...parameters
            }
        });
    };
    const enrichedStatistics = (0, $fgmOP.useMemo)(()=>blockedSenderIds?.map(({ date: date, customerId: customerId, status: status, senderId: senderId, accessNumber: accessNumber, messages: messages, segments: segments })=>({
                date: date,
                month: date.substring(0, 7),
                customerId: customerId,
                customerName: getCustomerName(customerId),
                status: status,
                senderId: senderId,
                accessNumber: accessNumber,
                messages: messages,
                segments: segments
            })), [
        blockedSenderIds
    ]);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "senderid-statistics"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                className: "noMarginTop",
                children: "This report shows the number of messages with an originating address that has been blocked either by a reserved or blocked Sender ID policy."
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $2e4c8094e1930e9a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "startDate",
                                    label: "From date",
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date,
                                    defaultValue: "since ever"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "endDate",
                                    label: "To date",
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date,
                                    defaultValue: entity.inheritsEndDate ? entity.endDate : "no end"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: "status",
                            label: "Status",
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi,
                            options: senderIdStatusCodes
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            size: (0, $6c2490027a2e159e$export$2e5aae5cf40e4ee1),
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                id: "fetchStatistics",
                                children: isEditing ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    onClick: fetchStatistics,
                                    text: "Fetch statistics",
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary,
                                    className: "marginTop"
                                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    onClick: onEdit,
                                    text: "Edit search",
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.normal,
                                    className: "marginTop"
                                })
                            })
                        })
                    }),
                    !isEditing && blockedSenderIds && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        label: "Date grouping",
                                        formState: formState,
                                        entityFieldId: "dateGrouping",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi,
                                        isEditing: true,
                                        onChangeAlso: (dateGrouping)=>{
                                            // If 'date' is unchecked also uncheck 'month'
                                            if (!dateGrouping.includes("date")) onChange("dateGrouping")([]);
                                        },
                                        options: entity?.dateGrouping && entity.dateGrouping.includes("date") ? [
                                            {
                                                id: "date",
                                                name: "Date"
                                            },
                                            {
                                                id: "month",
                                                name: "Month"
                                            }
                                        ] : [
                                            {
                                                id: "date",
                                                name: "Date"
                                            }
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        label: "Service grouping",
                                        formState: formState,
                                        entityFieldId: "serviceGrouping",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi,
                                        isEditing: true,
                                        options: [
                                            {
                                                id: "customerName",
                                                name: "Customer"
                                            },
                                            {
                                                id: "accessNumber",
                                                name: "Access Number"
                                            }
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    label: "SenderID grouping",
                                    formState: formState,
                                    entityFieldId: "senderIdGrouping",
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi,
                                    isEditing: true,
                                    options: [
                                        {
                                            id: "senderId",
                                            name: "Sender ID"
                                        },
                                        {
                                            id: "status",
                                            name: "Status"
                                        }
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}),
            !isEditing && enrichedStatistics && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $63ec6831458493c1$export$a8c8bada5d85e82), {
                loading: loading,
                statistics: enrichedStatistics,
                groupBy: entity && [].concat(entity.dateGrouping?.includes("month") ? [
                    ...entity.dateGrouping
                ].remove("date") : entity.dateGrouping, entity.serviceGrouping, entity.senderIdGrouping)
            })
        ]
    });
};






var $l8GLF = parcelRequire("l8GLF");




var $fgmOP = parcelRequire("fgmOP");
var $0db9fdc1518475a0$exports = {};
$0db9fdc1518475a0$exports = "query usedSenderIds($startDate:Date$endDate:Date$senderId:ID$groupPeriod:GroupPeriod$caseSensitive:Boolean){usedSenderIds(startDate:$startDate endDate:$endDate senderId:$senderId groupPeriod:$groupPeriod caseSensitive:$caseSensitive){...usedSenderIdsFragment}}fragment usedSenderIdsFragment on UsedSenderId{date accessNumber amount senderId customerId}";













const $fd7ee02dea53b99d$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReportUsedSenderIds", "INFO");
const { THead: $fd7ee02dea53b99d$var$THead, TBody: $fd7ee02dea53b99d$var$TBody, Tr: $fd7ee02dea53b99d$var$Tr, Td: $fd7ee02dea53b99d$var$Td, ThSortable: $fd7ee02dea53b99d$var$ThSortable } = (0, $c1364c3d18563e9b$export$2e2bcd8739ae039);
const $fd7ee02dea53b99d$export$bd9e8565a9a37dd5 = ()=>{
    const { getName: getName } = (0, $8d8d8b3d38044bbe$export$d27d8317adc3c298)();
    const { downloadAsCsv: downloadAsCsv } = (0, $74557fad2715a9eb$export$640aba733f4f58a5)();
    const formStateOptions = {
        isEditing: true,
        useUrlParams: true,
        preferenceFieldNames: [
            "startDate",
            "endDate",
            "groupPeriod",
            "caseSensitive"
        ]
    };
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)({
        ...formStateOptions,
        validators: {
            senderId: {
                onValidate: (senderId)=>!!senderId,
                error: "Sender Id is required"
            },
            startDate: [
                {
                    onValidate: (startDate)=>!!(startDate && !(0, $f5d0c2a7498ff49b$exports.period).isFuture({
                            startDate: startDate.toString()
                        })),
                    error: "From date must be in the past"
                },
                {
                    onValidate: (startDate)=>!!(startDate && (0, $f5d0c2a7498ff49b$exports.period).isWithinMonths(startDate?.toString(), 6)),
                    error: "From date must be within 6 months"
                },
                {
                    onValidate: (startDate)=>!!startDate,
                    error: "From date is required"
                }
            ],
            groupPeriod: {
                onValidate: (groupPeriod)=>!!groupPeriod,
                error: "Aggregate by is required"
            }
        }
    });
    const { entity: entity, putError: putError, onSaved: onSaved, isEditing: isEditing, onEdit: onEdit, onCancel: onCancel, subEntityAt: subEntityAt } = formState;
    const [fetch, { loading: loading, data: { usedSenderIds: usedSenderIds } = {} }] = (0, $6ccde90cf8233047$export$fd83eea6ecd2d8fa)((0, $d155419fd10bd2b6$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($0db9fdc1518475a0$exports)))), {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only"
    });
    const fetchStatistics = ()=>{
        if (!formState.validate()) return;
        const parameters = entity || {};
        if (!(0, $f5d0c2a7498ff49b$exports.period).isValid(parameters)) {
            putError("startDate", "Invalid search period");
            putError("endDate", "Invalid search period");
            return;
        }
        entity ? onSaved(entity) : onCancel();
        fetch({
            variables: {
                ...parameters
            }
        });
    };
    const enrichedStatistics = (0, $fgmOP.useMemo)(()=>usedSenderIds?.map((stat)=>({
                ...stat,
                customerName: getName(stat.customerId),
                date: (0, $f5d0c2a7498ff49b$exports.dates).formatGroupPeriodDate(stat.date, subEntityAt("groupPeriod"))
            })) || [], [
        usedSenderIds
    ]);
    const [sortedStatistics, getThSortableProps] = (0, $a129443168ef7da6$exports.useThSortable)(enrichedStatistics);
    $fd7ee02dea53b99d$var$log.debug("render", {
        loading: loading,
        usedSenderIds: usedSenderIds,
        enrichedStatistics: enrichedStatistics,
        sortedStatistics: sortedStatistics
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "used-senderid-statistics"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                className: "noMarginTop",
                children: "This report shows the number of messages that has been sent with a certain Sender ID during the specified time period."
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $a82309880227f2e9$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "startDate",
                                    label: "From date",
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "endDate",
                                    label: "To date",
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "senderId",
                                    label: "Sender ID",
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).input
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "groupPeriod",
                                    label: "Aggregate by",
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                    tip: "The number of sent messages in the report will be grouped by the selected period.",
                                    options: [
                                        {
                                            id: (0, $l8GLF.GroupPeriod).DAY,
                                            name: "Day"
                                        },
                                        {
                                            id: (0, $l8GLF.GroupPeriod).WEEK,
                                            name: "Week"
                                        },
                                        {
                                            id: (0, $l8GLF.GroupPeriod).MONTH,
                                            name: "Month"
                                        },
                                        {
                                            id: (0, $l8GLF.GroupPeriod).QUARTER,
                                            name: "Quarter"
                                        }
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                    formState: formState,
                                    entityFieldId: "caseSensitive",
                                    label: "Case sensitive search",
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox,
                                    tip: "Case sensitive: Only exact SenderID matches will be returned."
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    onClick: isEditing ? fetchStatistics : onEdit,
                                    text: isEditing ? "Fetch used Sender Ids" : "Edit search",
                                    kind: isEditing ? (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary : (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.normal,
                                    className: "marginTop"
                                })
                            })
                        })
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}),
            !loading && !isEditing && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    (!subEntityAt("endDate") || (0, $f5d0c2a7498ff49b$exports.dates).isTodayOrFuture(subEntityAt("endDate"))) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        className: "pending__info--container marginTop",
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3ab394edcd89558b$export$2e2bcd8739ae039), {
                            kind: "warning",
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                                children: "The search period includes the current day, it might take up to 24 hours before these numbers are accurate."
                            })
                        })
                    }),
                    sortedStatistics.length === 0 ? usedSenderIds !== undefined && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $dd22cd0dae287e6b$export$2e2bcd8739ae039), {
                        children: [
                            "No messages found with Sender ID: '",
                            entity.senderId?.toString(),
                            "'"
                        ]
                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($fd7ee02dea53b99d$var$THead, {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)($fd7ee02dea53b99d$var$Tr, {
                                            children: [
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)($fd7ee02dea53b99d$var$ThSortable, {
                                                    ...getThSortableProps("date"),
                                                    children: [
                                                        "Period",
                                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $acf38b6c25932409$export$2e2bcd8739ae039), {
                                                            text: "Period is based on UTC",
                                                            className: "marginLeft noTooltipPadding"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($fd7ee02dea53b99d$var$ThSortable, {
                                                    ...getThSortableProps("customerName"),
                                                    children: "Customer"
                                                }),
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($fd7ee02dea53b99d$var$ThSortable, {
                                                    ...getThSortableProps("accessNumber"),
                                                    children: "Access Number"
                                                }),
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($fd7ee02dea53b99d$var$ThSortable, {
                                                    ...getThSortableProps("amount"),
                                                    children: "Messages"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($fd7ee02dea53b99d$var$TBody, {
                                        children: sortedStatistics.map(({ date: date, customerName: customerName, accessNumber: accessNumber, amount: amount })=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)($fd7ee02dea53b99d$var$Tr, {
                                                children: [
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($fd7ee02dea53b99d$var$Td, {
                                                        children: date
                                                    }),
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($fd7ee02dea53b99d$var$Td, {
                                                        children: customerName
                                                    }),
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($fd7ee02dea53b99d$var$Td, {
                                                        children: accessNumber
                                                    }),
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($fd7ee02dea53b99d$var$Td, {
                                                        children: (0, $f5d0c2a7498ff49b$exports.format).integer(amount)
                                                    })
                                                ]
                                            }, date + customerName + accessNumber))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                text: "Download as CSV",
                                onClick: ()=>downloadAsCsv({
                                        header: [
                                            "Period",
                                            "Customer",
                                            "Access Number",
                                            "Messages"
                                        ],
                                        content: sortedStatistics.map(({ date: date, customerName: customerName, accessNumber: accessNumber, amount: amount })=>[
                                                date,
                                                customerName,
                                                accessNumber,
                                                amount
                                            ]),
                                        filename: "used-sender-ids.csv"
                                    })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};


const $2f1ef4a39180a07e$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReportSenderId", "INFO");
const $2f1ef4a39180a07e$export$bc8936c6e1be4a43 = (props)=>{
    const { hasPermission: hasPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const subPath = $e9a95c61c800ecd2$export$e8c60b88aa54a6db($e9a95c61c800ecd2$export$2661b74b9fa118a);
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const { pathname: pathname } = (0, $dfdceb7c36fce96f$export$45d76561a5302f2b)();
    const usedSenderIdsPath = formatWithBrand($e9a95c61c800ecd2$export$af0ee86b91bc7146);
    const blockedSenderIdsPath = formatWithBrand($e9a95c61c800ecd2$export$92f2be0243b986ba);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                        size: (0, $6c2490027a2e159e$export$95dbfef2e4b1962b),
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                            subtitle: "Detailed Sender IDs"
                        })
                    }),
                    hasPermission((0, $ca0941499cca84bb$export$5baf0ad38a5e4791)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ecc4226f40c1c037$export$fb4216da1f591b95), {
                            ...pathname === usedSenderIdsPath && {
                                active: "left"
                            },
                            ...pathname === blockedSenderIdsPath && {
                                active: "right"
                            },
                            leftLabel: "Used SenderIDs",
                            rightLabel: "Blocked SenderIDs",
                            leftOnClickHandler: ()=>navigate(usedSenderIdsPath, {
                                    replace: true
                                }),
                            rightOnClickHandler: ()=>navigate(blockedSenderIdsPath, {
                                    replace: true
                                })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $dfdceb7c36fce96f$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                        index: true,
                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$444b3ab0cb9aec40), {
                            replace: true,
                            to: usedSenderIdsPath
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                        path: subPath($e9a95c61c800ecd2$export$af0ee86b91bc7146),
                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $fd7ee02dea53b99d$export$bd9e8565a9a37dd5), {})
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                        path: subPath($e9a95c61c800ecd2$export$92f2be0243b986ba),
                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $8bbab09254f3d32f$export$bd103764cce81b6d), {})
                    })
                ]
            })
        ]
    });
};








var $fgmOP = parcelRequire("fgmOP");

var $bede86af72a7699c$exports = {};
$bede86af72a7699c$exports = "query statistics($accessNumber:AccessNumberString$contractId:ID$contractType:ContractTypeEnum$customerId:ID$endDate:Date$messageTypes:[ID]$resolutions:[ID]$status:Int$isCustomer:Boolean$operatorCode:ID$productType:ID$startDate:Date){statistics(accessNumber:$accessNumber contractId:$contractId contractType:$contractType customerId:$customerId endDate:$endDate messageTypes:$messageTypes resolutions:$resolutions status:$status isCustomer:$isCustomer operatorCode:$operatorCode productType:$productType startDate:$startDate){...statisticFragment}}fragment statisticFragment on Statistic{accessNumber contractId contractType customerId date messageType messages operatorCode trafficFeeType productType segments resolution status}";












var $l8GLF = parcelRequire("l8GLF");








const { contractTypes: $1f16b4c693b204c1$var$contractTypes, EXTERNAL_CONTRACT_TYPE: $1f16b4c693b204c1$var$EXTERNAL_CONTRACT_TYPE, INTERNAL_CONTRACT_TYPE: $1f16b4c693b204c1$var$INTERNAL_CONTRACT_TYPE } = (0, $f5d0c2a7498ff49b$exports.constants);
const $1f16b4c693b204c1$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReportDeliveryStatistics", "DEBUG");
const { isValid: $1f16b4c693b204c1$var$isValid } = (0, $f5d0c2a7498ff49b$exports.period);
const $1f16b4c693b204c1$var$isRejectedSenderId = (status)=>status === "9501" || status === "9502";
const $1f16b4c693b204c1$export$8f1133ad421addd0 = (props)=>{
    const { user: user, isTelia: isTelia, isCustomer: isCustomer, currentUserBrand: currentUserBrand, customerId: customerId } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { statusCodes: statusCodes } = (0, $b5925f5d8efa7340$export$7ddd8c51b496162d)();
    const { messageTypeDictionary: messageTypeDictionary, getMessageTypeCompactName: getMessageTypeCompactName } = (0, $e0ee09abd75b1062$export$609535ef038a9b3f)();
    const formStateOptions = {
        isEditing: true,
        useUrlParams: true,
        preferenceFieldNames: [
            "startDate",
            "endDate",
            "productType",
            "messageTypes",
            "resolutions",
            "customerId"
        ],
        fixedFields: isCustomer() ? {
            customerId: customerId
        } : {}
    };
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)(formStateOptions);
    const { entity: entity, isEditing: isEditing, onSaved: onSaved, onCancel: onCancel, onEdit: onEdit, onChange: onChange, clearErrors: clearErrors, putError: putError } = formState;
    const { loading: loadingCustomers, customerOverviews: customerOverviews, getName: getName } = (0, $8d8d8b3d38044bbe$export$d27d8317adc3c298)();
    const { getName: getProductTypeName, getBrandProductTypes: getBrandProductTypes } = (0, $98effcf86fafb9fb$export$75025970e7082eca)();
    const { netTypeFromOperatorCode: netTypeFromOperatorCode, netTypeFromTrafficFee: netTypeFromTrafficFee } = (0, $177d8c49139b7c11$export$e0f51e86622d7cf9)();
    const { customerName: customerName } = (0, $6fadca55099b66d6$export$dd46433206d0b2d9)();
    const { loading: loadingCustomer, error: error, data: { customer: customer } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($dad67faa2a055d78$exports)))), {
        skip: !(isCustomer() || entity.customerId),
        variables: {
            customerId: user && isCustomer() ? customerId : entity.customerId
        }
    });
    const productTypes = (0, $fgmOP.useMemo)(()=>currentUserBrand && getBrandProductTypes(currentUserBrand?.id), [
        currentUserBrand?.id,
        getBrandProductTypes
    ]);
    const getCustomerName = (0, $fgmOP.useCallback)((id)=>isCustomer() ? customerName || id : getName(id), [
        isCustomer,
        customerName,
        getName
    ]);
    const getResolutionName = (resolutionId)=>{
        const resolution = (0, $f5d0c2a7498ff49b$exports.model).resolutions.find((modelResolution)=>modelResolution.id === resolutionId);
        return resolution ? resolution.name : !resolutionId ? "Unknown" : resolutionId;
    };
    const editStatistics = ()=>{
        onEdit();
    };
    const [fetch, { loading: loading, data: { statistics: statistics } = {} }] = (0, $6ccde90cf8233047$export$fd83eea6ecd2d8fa)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($bede86af72a7699c$exports)))), {
        notifyOnNetworkStatusChange: true,
        fetchPolicy: "network-only"
    });
    const fetchStatistics = ()=>{
        const parameters = entity || {};
        clearErrors();
        if (!parameters?.startDate) {
            putError("startDate", "Start date is required");
            return;
        }
        if (!parameters?.endDate) {
            putError("endDate", "End date is required");
            return;
        }
        if (!$1f16b4c693b204c1$var$isValid(parameters)) {
            putError("startDate", "Invalid search period");
            putError("endDate", "Invalid search period");
            return;
        }
        if (!parameters?.messageTypes?.length) {
            putError("messageTypes", "Please select at least one Message Type");
            return;
        }
        if (!parameters?.resolutions?.length) {
            putError("resolutions", "Please select at least one Resolution");
            return;
        }
        $1f16b4c693b204c1$var$log.info("Fetch statistics", parameters);
        entity ? onSaved(entity) : onCancel();
        fetch({
            variables: {
                customerId: user && isCustomer() ? customerId : null,
                ...parameters,
                status: parameters.status ? parseInt(parameters.status) : undefined,
                isCustomer: isCustomer()
            }
        });
    };
    const enrichStatistics = (0, $fgmOP.useCallback)((statistics)=>{
        return statistics?.map(({ date: date, operatorCode: operatorCode, trafficFeeType: trafficFeeType, productType: productType, messageType: messageType, resolution: resolution, status: status, customerId: customerId, contractType: contractType, ...s })=>({
                ...s,
                date: date,
                customerId: customerId,
                operatorCode: operatorCode,
                month: date.substring(0, 7),
                netType: currentUserBrand?.id === "TELIA_NO" ? netTypeFromOperatorCode(operatorCode) : netTypeFromTrafficFee(trafficFeeType),
                customerName: getCustomerName(customerId),
                productType: getProductTypeName(productType),
                messageType: messageType ? getMessageTypeCompactName(messageType) : "",
                resolution: getResolutionName(resolution),
                status: status,
                contractType: (0, $f5d0c2a7498ff49b$exports.constants).contractTypeName(contractType)
            })) || [];
    }, [
        netTypeFromOperatorCode,
        getCustomerName,
        getProductTypeName
    ]);
    const enrichedStatistics = (0, $fgmOP.useMemo)(()=>enrichStatistics(statistics), [
        statistics
    ]);
    $1f16b4c693b204c1$var$log.debug("render", {
        loading: loading,
        statistics: statistics,
        enrichedStatistics: enrichedStatistics,
        isEditing: isEditing
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Detailed Statistics"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "delivery-statistics"
            }),
            entity && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $2e4c8094e1930e9a$export$2e2bcd8739ae039), {
                onSubmit: fetchStatistics,
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "startDate",
                                        label: "From date",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date,
                                        defaultValue: "since ever"
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "endDate",
                                        label: "To date",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date,
                                        defaultValue: entity.inheritsEndDate ? entity.endDate : "no end"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "productType",
                                        label: "Service Type",
                                        isNullable: true,
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                        options: productTypes
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "messageTypes",
                                        label: "Message Types",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi,
                                        options: messageTypeDictionary,
                                        isEditing: isEditing,
                                        tip: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                            className: "paddingLeft",
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("li", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                                className: "bold",
                                                                children: "Mobile Terminated:"
                                                            }),
                                                            " sent TO mobile"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("li", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                                className: "bold",
                                                                children: "Mobile Originated:"
                                                            }),
                                                            " sent FROM mobile"
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "resolutions",
                                        label: "Resolutions",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi,
                                        isEditing: isEditing && !formState.subEntityAt("status"),
                                        options: (0, $f5d0c2a7498ff49b$exports.model).resolutions,
                                        tip: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                            className: "paddingLeft",
                                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("ul", {
                                                children: [
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("li", {
                                                        children: "Delivered - Message was successfully delivered (status: 200)"
                                                    }),
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("li", {
                                                        children: "Rejected - Message was internally rejected by Telia Bulk Messaging Cloud (status: 9XXX)"
                                                    }),
                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("li", {
                                                        children: "Expired - Message could not be delivered (status: 9999)"
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: [
                                    isTelia() && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "status",
                                        label: "Status",
                                        isNullable: true,
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                        options: statusCodes,
                                        onChangeAlso: (status)=>{
                                            if (status === undefined || status === null) return;
                                            const resolutions = status === "200" ? [
                                                (0, $l8GLF.ResolutionId).Delivered
                                            ] : status === "9999" ? [
                                                (0, $l8GLF.ResolutionId).Expired
                                            ] : [
                                                (0, $l8GLF.ResolutionId).Rejected
                                            ];
                                            onChange("resolutions")(resolutions);
                                            if ($1f16b4c693b204c1$var$isRejectedSenderId(status)) onChange("messageTypes")([
                                                "SMS_MT"
                                            ]);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "contractType",
                                        label: "Contract Type",
                                        options: $1f16b4c693b204c1$var$contractTypes,
                                        isNullable: true,
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                        tip: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("ul", {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("noMargin", "noPadding"),
                                            children: [
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("li", {
                                                    children: [
                                                        $1f16b4c693b204c1$var$EXTERNAL_CONTRACT_TYPE,
                                                        " contract get invoiced"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("li", {
                                                    children: [
                                                        $1f16b4c693b204c1$var$INTERNAL_CONTRACT_TYPE,
                                                        " contract do NOT get invoiced"
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    isTelia() && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "customerId",
                                        label: "Customer",
                                        options: customerOverviews,
                                        isNullable: true,
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                        isDisabled: loadingCustomers,
                                        onChangeAlso: ()=>onChange("contractId")(null)
                                    }),
                                    isCustomer() && user && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                        label: "Customer",
                                        value: customerName,
                                        isDisabled: true
                                    }),
                                    !user && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "customerId",
                                        label: "Customer",
                                        isDisabled: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: [
                                    !user ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                        isEditing: false,
                                        isDisabled: true,
                                        label: "Contract",
                                        placeholder: "Loading user..."
                                    }) : isTelia() && !entity.customerId ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                        isEditing: false,
                                        isDisabled: true,
                                        label: "Contract",
                                        placeholder: "Select customer"
                                    }) : !loadingCustomer && customer ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "contractId",
                                        label: "Contract",
                                        options: customer.contracts,
                                        isNullable: true,
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                        isDisabled: !customer.contracts
                                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                        isEditing: false,
                                        isDisabled: true,
                                        label: "Contract",
                                        placeholder: loading ? "Loading contracts..." : error ? "Something went wrong" : "",
                                        error: error && error.message
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        formState: formState,
                                        entityFieldId: "accessNumber",
                                        label: "Access Number",
                                        placeholder: "all access numbers"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            size: (0, $6c2490027a2e159e$export$2e5aae5cf40e4ee1),
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                id: "fetchStatistics",
                                children: isEditing ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    onClick: fetchStatistics,
                                    text: "Fetch statistics",
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary,
                                    className: "marginTop"
                                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    onClick: editStatistics,
                                    text: "Edit search",
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.normal,
                                    className: "marginTop"
                                })
                            })
                        })
                    }),
                    !isEditing && statistics && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                size: (0, $6c2490027a2e159e$export$2e5aae5cf40e4ee1),
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        label: "Date grouping",
                                        formState: formState,
                                        entityFieldId: "dateGrouping",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi,
                                        onChangeAlso: (dateGrouping)=>{
                                            // If 'date' is unchecked also uncheck 'month'
                                            if (!dateGrouping.includes("date")) onChange("dateGrouping")([]);
                                        },
                                        options: entity?.dateGrouping && entity.dateGrouping.includes("date") ? [
                                            {
                                                id: "date",
                                                name: "Date"
                                            },
                                            {
                                                id: "month",
                                                name: "Month"
                                            }
                                        ] : [
                                            {
                                                id: "date",
                                                name: "Date"
                                            }
                                        ],
                                        className: "noWrap",
                                        isEditing: true
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        label: "Service grouping",
                                        formState: formState,
                                        entityFieldId: "productGrouping",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi,
                                        options: [
                                            {
                                                id: "customerName",
                                                name: "Customer"
                                            },
                                            {
                                                id: "contractId",
                                                name: "Contract"
                                            },
                                            {
                                                id: "accessNumber",
                                                name: "Access Nr"
                                            }
                                        ],
                                        className: "noWrap",
                                        isEditing: true
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                size: (0, $6c2490027a2e159e$export$2e5aae5cf40e4ee1),
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        label: "Types grouping",
                                        formState: formState,
                                        entityFieldId: "typesGrouping",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi,
                                        options: [
                                            {
                                                id: "contractType",
                                                name: "Contract type"
                                            },
                                            {
                                                id: "productType",
                                                name: "Service Type"
                                            },
                                            {
                                                id: "messageType",
                                                name: "Message Types"
                                            }
                                        ],
                                        className: "noWrap",
                                        isEditing: true
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                        label: "Delivery grouping",
                                        formState: formState,
                                        entityFieldId: "deliveryGrouping",
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi,
                                        options: [
                                            {
                                                id: "operatorCode",
                                                name: "MNO"
                                            },
                                            {
                                                id: "netType",
                                                name: "Net",
                                                tip: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                                    className: "paddingLeft",
                                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("ul", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                                        className: "bold",
                                                                        children: "On Net:"
                                                                    }),
                                                                    " domestic traffic on operators owned by Telia"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                                        className: "bold",
                                                                        children: "Off Net:"
                                                                    }),
                                                                    " domestic traffic on operators not owned by Telia"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("li", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                                                        className: "bold",
                                                                        children: "Foreign:"
                                                                    }),
                                                                    " off net traffic on unknown operators"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            },
                                            {
                                                id: "resolution",
                                                name: "Resolution"
                                            },
                                            {
                                                id: "status",
                                                name: "Status"
                                            }
                                        ],
                                        className: "noWrap",
                                        isEditing: true
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            loading && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}),
            !isEditing && enrichedStatistics && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $63ec6831458493c1$export$a8c8bada5d85e82), {
                loading: loading,
                statistics: enrichedStatistics,
                groupBy: entity && [].concat(entity.dateGrouping?.includes("month") ? [
                    ...entity.dateGrouping
                ].remove("date") : entity.dateGrouping, entity.productGrouping, entity.typesGrouping, entity.deliveryGrouping)
            })
        ]
    });
};


const $c1bef258c4da3159$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ReportMain", "INFO");
const $c1bef258c4da3159$export$31d3110523b60403 = (props)=>{
    const { user: user, isTelia: isTelia, isCustomer: isCustomer } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { pathname: pathname } = (0, $dfdceb7c36fce96f$export$45d76561a5302f2b)();
    const subPath = $e9a95c61c800ecd2$export$e8c60b88aa54a6db($e9a95c61c800ecd2$export$e3d31417f21c1ce7);
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const { currentUserBrand: currentUserBrand, hasPermission: hasPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    $c1bef258c4da3159$var$log.debug("render", {
        user: user,
        isTelia: isTelia,
        isCustomer: isCustomer
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $02b201edbdb8a3c4$export$2e2bcd8739ae039), {
                title: "Report"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$729687bd6e83ee94), {
                        ariaLabel: "Report submenu",
                        children: user && isTelia() && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                    link: formatWithBrand($e9a95c61c800ecd2$export$d6a5a8cee06963f7),
                                    text: "Overview"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                    link: formatWithBrand($e9a95c61c800ecd2$export$3e394bc3bb4fc12b),
                                    text: "Monthly Usage"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                    link: formatWithBrand($e9a95c61c800ecd2$export$1e42e92685e98be9),
                                    text: "Statistics"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                    link: formatWithBrand($e9a95c61c800ecd2$export$7c824b2ea5505a8e),
                                    text: "Messages"
                                }),
                                hasPermission((0, $ca0941499cca84bb$export$5baf0ad38a5e4791)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                    link: formatWithBrand($e9a95c61c800ecd2$export$2661b74b9fa118a),
                                    text: "Sender IDs"
                                }),
                                currentUserBrand?.id === "TELIA_NO" && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                    link: formatWithBrand($e9a95c61c800ecd2$export$f4198c574b87b640),
                                    text: "Charging & Billing"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                    link: formatWithBrand($e9a95c61c800ecd2$export$7724472b45e16f3c),
                                    text: "Access Number History"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                    link: formatWithBrand($e9a95c61c800ecd2$export$cf334011f04d66bd),
                                    text: "Reserved Sender ID"
                                })
                            ]
                        }) || user && isCustomer() && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                    link: formatWithBrand($e9a95c61c800ecd2$export$d6a5a8cee06963f7),
                                    text: "Overview"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                    link: formatWithBrand($e9a95c61c800ecd2$export$1e42e92685e98be9),
                                    text: "Statistics"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                    link: formatWithBrand($e9a95c61c800ecd2$export$7c824b2ea5505a8e),
                                    text: "Messages"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $b60bd97a1f982072$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $dfdceb7c36fce96f$export$3565eb3d00ca5a74), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    index: true,
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$444b3ab0cb9aec40), {
                                        replace: true,
                                        to: formatWithBrand($e9a95c61c800ecd2$export$d6a5a8cee06963f7)
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$d6a5a8cee06963f7),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $4a3012764b872bbb$export$7a668e7f089ce03d), {})
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$3e394bc3bb4fc12b),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $2d1801b788225f03$export$3de6ab98c3d7b76c), {})
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$1e42e92685e98be9),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1f16b4c693b204c1$export$8f1133ad421addd0), {})
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$2661b74b9fa118a) + "/*",
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $2f1ef4a39180a07e$export$bc8936c6e1be4a43), {})
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$164d2bdecc76515),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $f57b83959ccfdbdd$export$362d466733da547f), {})
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$7c824b2ea5505a8e),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $25eaf8efe0e88ab0$export$810b79139e0bdb1b), {})
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$f4198c574b87b640),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $abcc0b9b07b77c66$export$6533858383d32124), {
                                        isDisplayed: currentUserBrand?.id === "TELIA_NO",
                                        navigateTo: formatWithBrand($e9a95c61c800ecd2$export$d6a5a8cee06963f7),
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $eafd33fda0492bba$export$c78c2239403a0e35), {})
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$7724472b45e16f3c),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $df05ffef410ba120$export$6fc06777f4868863), {})
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$cf334011f04d66bd),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $eaff5f2ba4515a40$export$16512c21d780f520), {})
                                })
                            ]
                        })
                    }, pathname)
                ]
            })
        ]
    });
};





var $fgmOP = parcelRequire("fgmOP");

var $0d614288a75b5405$exports = {};
$0d614288a75b5405$exports = "query pendingSettlements{pendingSettlements{...settlementFragment}}fragment settlementFragment on Settlement{date id state stateAction{action comment}yearMonth currencyCode isComplete customer{...customerMinimalFragment}contract{...contractNoDatesFragment}summary{...settlementSummaryFragment}productTypeSummaries{...settlementProductTypeSummaryFragment}adjustments{comment price feeCategory{productTypeId feeId}}productDetails{productDetailId productId productTypeId total fees{...productFeeFragment}}}fragment contractNoDatesFragment on Contract{id name type invoiceIncludeVat invoiceReference invoiceCustomerEmail invoiceAccountId h2SystemId comment}fragment customerMinimalFragment on Customer{id company{id name organizationNumber countryId brandId}}fragment settlementSummaryFragment on SettlementSummary{settlementTotal adjustmentTotal totalExclVat vat vatPercentage totalInclVat}fragment settlementProductTypeSummaryFragment on SettlementProductTypeSummary{productTypeId fees{...productFeeFragment}total}fragment productFeeFragment on ProductFee{feeId type quantity fee total}fragment productFeeFragment on ProductFee{feeId type quantity fee total}";


var $3f3c28c2c91e1995$exports = {};
$3f3c28c2c91e1995$exports = "query readyForApprovalSettlements{readyForApprovalSettlements{...settlementFragment}}fragment settlementFragment on Settlement{date id state stateAction{action comment}yearMonth currencyCode isComplete customer{...customerMinimalFragment}contract{...contractNoDatesFragment}summary{...settlementSummaryFragment}productTypeSummaries{...settlementProductTypeSummaryFragment}adjustments{comment price feeCategory{productTypeId feeId}}productDetails{productDetailId productId productTypeId total fees{...productFeeFragment}}}fragment contractNoDatesFragment on Contract{id name type invoiceIncludeVat invoiceReference invoiceCustomerEmail invoiceAccountId h2SystemId comment}fragment customerMinimalFragment on Customer{id company{id name organizationNumber countryId brandId}}fragment settlementSummaryFragment on SettlementSummary{settlementTotal adjustmentTotal totalExclVat vat vatPercentage totalInclVat}fragment settlementProductTypeSummaryFragment on SettlementProductTypeSummary{productTypeId fees{...productFeeFragment}total}fragment productFeeFragment on ProductFee{feeId type quantity fee total}fragment productFeeFragment on ProductFee{feeId type quantity fee total}";















var $fgmOP = parcelRequire("fgmOP");
















var $fgmOP = parcelRequire("fgmOP");



const $c9fff916b271bacd$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SettlementTotalSum", "INFO");
const $c9fff916b271bacd$export$cdafcd0add419653 = (settlements)=>{
    $c9fff916b271bacd$var$log.debug("Calculating total");
    return settlements?.reduce(([total, adjustmentTotal], settlement)=>[
            total + settlement.summary.totalExclVat,
            adjustmentTotal + settlement.summary.adjustmentTotal
        ], [
        0,
        0
    ]) || [
        0,
        0
    ];
};
const $c9fff916b271bacd$export$8b9342b4cd8d6177 = ({ settlements: settlements })=>{
    const { currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const [total, adjustmentTotal] = (0, $fgmOP.useMemo)(()=>{
        return $c9fff916b271bacd$export$cdafcd0add419653(settlements);
    }, [
        settlements
    ]);
    $c9fff916b271bacd$var$log.debug("render", {
        total: total,
        adjustmentTotal: adjustmentTotal
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
        className: "settlement__total__sum",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                className: "settlement__total__sum--value",
                children: (0, $f5d0c2a7498ff49b$exports.format).currency(total, currentUserBrand?.currencyCode, true, true)
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                className: "settlement__total__sum--label",
                children: " in total, including "
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                className: "settlement__total__sum--value darkPurpleText",
                children: (0, $f5d0c2a7498ff49b$exports.format).currency(adjustmentTotal, currentUserBrand?.currencyCode, true, true)
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                className: "settlement__total__sum--label",
                children: " in adjustments"
            })
        ]
    });
};



parcelRequire("fgmOP");



const $3ccd76db342453d3$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SettlementPendingLine");
const $3ccd76db342453d3$export$e00a315f72abde21 = (props)=>{
    const { settlement: settlement } = props;
    // log.debug('settlement', settlement);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: "settlement__name",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                className: "settlement__name__contract",
                children: [
                    " ",
                    (0, $f5d0c2a7498ff49b$exports.format).integer(settlement.summary.totalExclVat),
                    ",- ",
                    (0, $f5d0c2a7498ff49b$exports.format).yearMonth(settlement.yearMonth)
                ]
            }),
            settlement.customer.company.name,
            " (",
            settlement.contract.id,
            ")"
        ]
    });
};


const $61e94c27064c2643$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SettlementArchive", "INFO");
const { monthOptionValues: $61e94c27064c2643$var$monthOptionValues, dateOfLastDayOfPreviousMonth: $61e94c27064c2643$var$dateOfLastDayOfPreviousMonth, monthMm: $61e94c27064c2643$var$monthMm } = (0, $f5d0c2a7498ff49b$exports.dates);
const $61e94c27064c2643$var$lastMonthDate = $61e94c27064c2643$var$dateOfLastDayOfPreviousMonth();
const $61e94c27064c2643$var$initialYear = "" + $61e94c27064c2643$var$lastMonthDate.getFullYear();
const $61e94c27064c2643$var$initialMonth = $61e94c27064c2643$var$monthMm($61e94c27064c2643$var$lastMonthDate);
const $61e94c27064c2643$export$2f871929f445e8e = ()=>{
    const [year, setYear] = (0, $fgmOP.useState)($61e94c27064c2643$var$initialYear);
    const [month, setMonth] = (0, $fgmOP.useState)($61e94c27064c2643$var$initialMonth);
    const { currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { loading: loading, data: { settlements: unfilteredSettlements } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($7c56a23b568b6925$exports)))), {
        skip: !currentUserBrand,
        variables: {
            year: parseInt(year),
            month: parseInt(month)
        }
    });
    (0, $c3440150448da8b8$export$1c72fe480f599e97)([
        {
            query: "settlements",
            isLoading: loading
        }
    ]);
    const settlements = (0, $fgmOP.useMemo)(()=>unfilteredSettlements?.filter((settlement)=>settlement.state === "APPROVED"), [
        unfilteredSettlements
    ]);
    $61e94c27064c2643$var$log.debug("props", {
        year: year,
        month: month,
        loading: loading,
        settlements: settlements,
        monthOptionValues: $61e94c27064c2643$var$monthOptionValues,
        lastMonthDate: $61e94c27064c2643$var$lastMonthDate,
        initialYear: $61e94c27064c2643$var$initialYear,
        initialMonth: $61e94c27064c2643$var$initialMonth
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                children: [
                    "Approved settlements archive ",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c9fff916b271bacd$export$8b9342b4cd8d6177), {
                        settlements: settlements
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "archive"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("SettlementArchive"),
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    value: "" + year,
                                    isEditing: true,
                                    options: (0, $f5d0c2a7498ff49b$exports.dates).years.map((y)=>"" + y),
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                    onChange: (year)=>setYear(year)
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    value: "" + month,
                                    isEditing: true,
                                    options: $61e94c27064c2643$var$monthOptionValues,
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                    onChange: (month)=>setMonth(month)
                                })
                            ]
                        })
                    }),
                    //  TODO: refresh same month search  ---   download CSV file
                    !settlements || settlements.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                        description: `No approved settlements for this month`
                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $22dbb5b4c09ac376$export$1266ff14c7754c00), {
                        multipleOpen: true,
                        initialAllOpen: false,
                        children: settlements.map((settlement)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $cb8470b63aea6339$export$2e2bcd8739ae039), {
                                id: settlement.id,
                                header: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3ccd76db342453d3$export$e00a315f72abde21), {
                                    settlement: settlement
                                }),
                                content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ede1d69ade64ddbb$export$e957498a727fb850), {
                                    settlementId: settlement.id,
                                    customerId: settlement.customer.id
                                })
                            }, settlement.id))
                    })
                ]
            })
        ]
    });
};




parcelRequire("fgmOP");






const $8426a2c0dc6b0908$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SettlementOverview", "INFO");
const $8426a2c0dc6b0908$export$144948fdc8348bc = (props)=>{
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    $8426a2c0dc6b0908$var$log.debug("props", props);
    const { pendingSettlementsCount: pendingSettlementsCount, readyForApprovalSettlementsCount: readyForApprovalSettlementsCount } = props;
    const titlePending = `${pendingSettlementsCount === undefined ? "Loading" : pendingSettlementsCount > 0 ? pendingSettlementsCount : "No"} Pending`;
    const titleReadyForApproval = `${readyForApprovalSettlementsCount === undefined ? "Loading" : readyForApprovalSettlementsCount > 0 ? readyForApprovalSettlementsCount : "No"} Ready For Approval`;
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("Overview", props.className),
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Overview"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "overview"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $e7ded3c00eb49c59$export$237d44eeb6e90e79), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "question",
                        title: titlePending,
                        warning: !!pendingSettlementsCount,
                        link: formatWithBrand($e9a95c61c800ecd2$export$ce951e24bd42e768)
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "security",
                        title: titleReadyForApproval,
                        warning: !!readyForApprovalSettlementsCount,
                        link: formatWithBrand($e9a95c61c800ecd2$export$54f17f3347a024b8)
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "folder",
                        title: "Archive",
                        link: formatWithBrand($e9a95c61c800ecd2$export$daea0807b252124c)
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6d5c205a2e0d9b54$export$5eec21ae6681837e), {
                        icon: "search",
                        title: "Search",
                        link: formatWithBrand($e9a95c61c800ecd2$export$771b78d26c6d9748)
                    })
                ]
            })
        ]
    });
};






var $fgmOP = parcelRequire("fgmOP");
var $5ff194fbb5c00013$exports = {};
$5ff194fbb5c00013$exports = "mutation acceptSettlement($id:ID!){acceptSettlement(id:$id){...settlementFragment}}fragment settlementFragment on Settlement{date id state stateAction{action comment}yearMonth currencyCode isComplete customer{...customerMinimalFragment}contract{...contractNoDatesFragment}summary{...settlementSummaryFragment}productTypeSummaries{...settlementProductTypeSummaryFragment}adjustments{comment price feeCategory{productTypeId feeId}}productDetails{productDetailId productId productTypeId total fees{...productFeeFragment}}}fragment contractNoDatesFragment on Contract{id name type invoiceIncludeVat invoiceReference invoiceCustomerEmail invoiceAccountId h2SystemId comment}fragment customerMinimalFragment on Customer{id company{id name organizationNumber countryId brandId}}fragment settlementSummaryFragment on SettlementSummary{settlementTotal adjustmentTotal totalExclVat vat vatPercentage totalInclVat}fragment settlementProductTypeSummaryFragment on SettlementProductTypeSummary{productTypeId fees{...productFeeFragment}total}fragment productFeeFragment on ProductFee{feeId type quantity fee total}fragment productFeeFragment on ProductFee{feeId type quantity fee total}";


var $36fac483fbfafa6c$exports = {};
$36fac483fbfafa6c$exports = "mutation generateSettlements($year:Int$month:Int){generateSettlements(year:$year month:$month){year month}}";





















var $fgmOP = parcelRequire("fgmOP");



const { THead: $1cc29ec20a6757d5$var$THead, Th: $1cc29ec20a6757d5$var$Th, Tr: $1cc29ec20a6757d5$var$Tr, ThSortable: $1cc29ec20a6757d5$var$ThSortable, TBody: $1cc29ec20a6757d5$var$TBody, Td: $1cc29ec20a6757d5$var$Td } = (0, $c1364c3d18563e9b$export$2e2bcd8739ae039);
const $1cc29ec20a6757d5$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SettlementTable", "INFO");
const $1cc29ec20a6757d5$export$5de7bf55e34a321d = (props)=>{
    const { settlements: settlements, onShowSettlement: onShowSettlement, isSelected: isSelected, onSelectId: onSelectId } = props;
    const enrichedSettlements = (0, $fgmOP.useMemo)(()=>settlements?.map((s)=>({
                customerName: s.customer.company.name,
                total: s.summary.totalExclVat,
                adjustmentTotal: s.summary.adjustmentTotal,
                contractId: s.contract.id,
                type: s.contract.type,
                ...s
            })), [
        settlements
    ]);
    const [sortedSettlements, getThSortableProps] = (0, $c1364c3d18563e9b$export$2e2bcd8739ae039).useThSortable(enrichedSettlements || [], 3, []);
    $1cc29ec20a6757d5$var$log.debug("render");
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $c1364c3d18563e9b$export$2e2bcd8739ae039), {
        clickable: true,
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($1cc29ec20a6757d5$var$THead, {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)($1cc29ec20a6757d5$var$Tr, {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($1cc29ec20a6757d5$var$Th, {
                            className: "minWidth",
                            children: " "
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($1cc29ec20a6757d5$var$ThSortable, {
                            ...getThSortableProps("customerName"),
                            children: "Customer"
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($1cc29ec20a6757d5$var$ThSortable, {
                            ...getThSortableProps("total"),
                            className: "right",
                            children: "Total"
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($1cc29ec20a6757d5$var$ThSortable, {
                            ...getThSortableProps("adjustmentTotal"),
                            className: "right",
                            children: "Adjustments"
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($1cc29ec20a6757d5$var$ThSortable, {
                            ...getThSortableProps("yearMonth"),
                            className: "right",
                            children: "Period"
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($1cc29ec20a6757d5$var$ThSortable, {
                            ...getThSortableProps("id"),
                            className: "right",
                            children: "Sett. ID"
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($1cc29ec20a6757d5$var$ThSortable, {
                            ...getThSortableProps("contractId"),
                            className: "right",
                            children: "Contract ID"
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($1cc29ec20a6757d5$var$ThSortable, {
                            ...getThSortableProps("type"),
                            className: "right minWidth",
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                                info: "Contract Type: internal | external",
                                icon: "business",
                                className: "Icon--small"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($1cc29ec20a6757d5$var$TBody, {
                children: sortedSettlements.map((settlement, i)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)($1cc29ec20a6757d5$var$Tr, {
                        className: settlement.summary.adjustmentTotal !== 0 ? "darkPurpleText" : "",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($1cc29ec20a6757d5$var$Td, {
                                className: "minWidth",
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    type: "_field_type_checkbox",
                                    value: isSelected(settlement.id),
                                    onChange: onSelectId && onSelectId(settlement.id),
                                    isEditing: true,
                                    isDisabled: !onSelectId
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($1cc29ec20a6757d5$var$Td, {
                                className: "noWrap",
                                onClick: ()=>onShowSettlement(settlement),
                                children: settlement.customerName
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($1cc29ec20a6757d5$var$Td, {
                                className: "right",
                                onClick: ()=>onShowSettlement(settlement),
                                children: (0, $f5d0c2a7498ff49b$exports.format).decimal(settlement.total, false)
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($1cc29ec20a6757d5$var$Td, {
                                className: "right",
                                onClick: ()=>onShowSettlement(settlement),
                                children: (0, $f5d0c2a7498ff49b$exports.format).decimal(settlement.adjustmentTotal, false)
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($1cc29ec20a6757d5$var$Td, {
                                className: "right",
                                onClick: ()=>onShowSettlement(settlement),
                                children: (0, $f5d0c2a7498ff49b$exports.format).yearMonth(settlement.yearMonth)
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($1cc29ec20a6757d5$var$Td, {
                                className: "right",
                                onClick: ()=>onShowSettlement(settlement),
                                children: settlement.id
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)($1cc29ec20a6757d5$var$Td, {
                                className: "right",
                                onClick: ()=>onShowSettlement(settlement),
                                children: [
                                    settlement.contractId,
                                    " ",
                                    settlement.contract.name
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)($1cc29ec20a6757d5$var$Td, {
                                className: "right minWidth",
                                onClick: ()=>onShowSettlement(settlement),
                                children: settlement.type.substring(0, 3)
                            })
                        ]
                    }, i))
            })
        ]
    });
};






var $fgmOP = parcelRequire("fgmOP");












const $0905e0ef1c0b38f0$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("PendingSettlement", "INFO");
const $0905e0ef1c0b38f0$export$636a9648a4ec0e1 = (props)=>{
    const { settlement: settlement } = props;
    const [showPerProductDetails, setShowPerProductDetails] = (0, $fgmOP.useState)(false);
    const [isAdjusting, setIsAdjusting] = (0, $fgmOP.useState)(false);
    const [rejectComment, setRejectComment] = (0, $fgmOP.useState)();
    const isRejecting = rejectComment !== undefined;
    const { hasPermission: hasPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    $0905e0ef1c0b38f0$var$log.debug({
        isRejecting: isRejecting,
        rejectComment: rejectComment
    });
    const adjustmentInputRef = (0, $fgmOP.useRef)();
    (0, $fgmOP.useEffect)(()=>{
        $0905e0ef1c0b38f0$var$log.debug("useEffect adjustmentInputRef?.current", adjustmentInputRef?.current);
        adjustmentInputRef?.current?.focus();
    }, [
        adjustmentInputRef
    ]);
    const onShowPerProductDetailsToggle = ()=>{
        setShowPerProductDetails((prevState)=>!prevState);
    };
    const onStartRejecting = ()=>{
        setRejectComment("");
    };
    const onCancelRejecting = ()=>{
        setRejectComment(undefined);
    };
    const onChangeRejectComment = (value)=>{
        setRejectComment(value);
    };
    const onConfirmRejection = ()=>{
        if (!rejectComment) $0905e0ef1c0b38f0$var$log.error("Cannot reject a settlement without a comment");
        else {
            props.onReject && props.onReject(rejectComment);
            setRejectComment(undefined);
        }
    };
    if (!settlement) return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
        description: "No settlement found"
    });
    const { state: state, stateAction: stateAction } = settlement;
    const approved = state === "APPROVED";
    const rejected = stateAction && stateAction.action === "REJECT";
    // const adjustments = isAdjusting ? this.state.adjustments : settlementAdjustments;
    // const adjustments = this.state.adjustments;
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("settlement", {
            "settlement--pending": !approved
        }, {
            "settlement--adjusting": isAdjusting
        }),
        children: [
            state === "PENDING" ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("section", {
                className: "settlement__approval",
                children: hasPermission((0, $ca0941499cca84bb$export$230c8d0b320c75d5)) && props.onAccept ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                    description: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                            children: [
                                !isAdjusting ? "Review the settlement before acceptance." : "Adjusting settlement...",
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                    className: "settlement__show_details__button",
                                    onClick: onShowPerProductDetailsToggle,
                                    children: showPerProductDetails ? "Hide" : "Show"
                                }),
                                " ",
                                "details."
                            ]
                        })
                    }),
                    buttons: !isAdjusting ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                text: "Accept",
                                onClick: props.onAccept,
                                isDisabled: !props.onAccept,
                                kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                text: "Adjust",
                                onClick: ()=>setIsAdjusting(true)
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                            text: "Cancel Adjustments",
                            onClick: ()=>setIsAdjusting(false),
                            kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel
                        })
                    })
                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                    description: `This settlement hasn't been accepted for approval yet`
                })
            }) : state === "READY_FOR_APPROVAL" && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("section", {
                className: "settlement__approval",
                children: hasPermission((0, $ca0941499cca84bb$export$5391912c22b803f7)) ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                    description: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                            children: [
                                !isAdjusting ? "Review the settlement before approval." : "Adjusting settlement...",
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                    className: "settlement__show_details__button",
                                    onClick: onShowPerProductDetailsToggle,
                                    children: showPerProductDetails ? "Hide" : "Show"
                                }),
                                " ",
                                "details."
                            ]
                        })
                    }),
                    buttons: !isRejecting ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                text: "Approve & invoice",
                                onClick: props.onApprove,
                                isDisabled: !props.onApprove,
                                kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                text: "Reject",
                                onClick: onStartRejecting,
                                isDisabled: !props.onReject,
                                kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.negative
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                text: "Reject",
                                onClick: onConfirmRejection,
                                isDisabled: !props.onReject,
                                kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.negative
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                text: "Cancel",
                                onClick: onCancelRejecting,
                                kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                    description: `This settlement hasn't been approved yet`
                })
            }),
            (rejected || isRejecting) && //  @ts-ignore
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3ab394edcd89558b$export$2e2bcd8739ae039), {
                kind: "negative",
                children: isRejecting ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                        size: (0, $6c2490027a2e159e$export$2e5aae5cf40e4ee1),
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).textarea,
                            isEditing: true,
                            placeholder: "Write here the rejection reason",
                            label: "Reject",
                            value: rejectComment,
                            onChange: onChangeRejectComment
                        })
                    })
                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                                className: "bold",
                                children: "REJECTED: "
                            }),
                            stateAction?.comment
                        ]
                    })
                })
            }),
            settlement.productTypeSummaries && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $4085a222edcc7ccc$export$75d15c67158151c7), {
                productTypeSummaries: settlement.productTypeSummaries
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $494bc68b634056b7$export$3686548213ca73ed), {
                settlement: settlement,
                onShowPerProductDetailsToggle: onShowPerProductDetailsToggle,
                showPerProductDetails: showPerProductDetails
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d8d058783023d092$export$3db4720934042bea), {
                adjustments: settlement.adjustments,
                settlement: settlement,
                isAdjusting: isAdjusting,
                onDoneAdjusting: ()=>{
                    setIsAdjusting(false);
                }
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $eefead8bfd0d9ad2$export$a6fce5eecaef430), {
                settlement: settlement,
                showVat: false
            })
        ]
    });
};



const $088ea0c5cfbc2f70$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SettlementPendingList", "INFO");
const $088ea0c5cfbc2f70$export$c3850165f79ac7e9 = ({ pendingSettlements: pendingSettlements, onUpdateSettlement: onUpdateSettlement, loading: loading })=>{
    (0, $c3440150448da8b8$export$1c72fe480f599e97)([
        {
            query: "pendingSettlements",
            isLoading: loading
        }
    ]);
    const { selectedIds: selectedIds, onSelectId: onSelectId, onSelectAll: onSelectAll, isSelected: isSelected, areAllSelected: areAllSelected } = (0, $843993963127ec3e$export$1c9b7756eccadc96)([]);
    const [showAcceptSelectedDialog, setShowAcceptSelectedDialog] = (0, $fgmOP.useState)(false);
    const { hasAnyPermission: hasAnyPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const canAdjust = hasAnyPermission((0, $ca0941499cca84bb$export$230c8d0b320c75d5));
    const { showModal: showModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const onShowSettlement = (settlement)=>{
        $088ea0c5cfbc2f70$var$log.debug("onShowSettlement", settlement.id);
        showModal({
            title: `${settlement.id} ${settlement.customer.company.name}`,
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $0905e0ef1c0b38f0$export$636a9648a4ec0e1), {
                settlement: settlement,
                onAccept: ()=>onAcceptSettlement(settlement.id)
            })
        });
    };
    const onApproveSelected = ()=>{
        setShowAcceptSelectedDialog(true);
    };
    const onCancelApproveSelected = ()=>{
        setShowAcceptSelectedDialog(false);
    };
    const onConfirmApproveSelected = ()=>{
        $088ea0c5cfbc2f70$var$log.info(`onConfirmApproveSelected: ${selectedIds.length} Settlements`);
        setShowAcceptSelectedDialog(false);
        selectedIds.forEach((settlementId)=>onAcceptSettlement(settlementId));
    };
    const acceptSettlement = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($5ff194fbb5c00013$exports)))));
    const onAcceptSettlement = (id)=>{
        $088ea0c5cfbc2f70$var$log.debug(`onAcceptSettlement`, id);
        acceptSettlement({
            loadingText: `Accepting settlement ${id}...`,
            successText: `Settlement ${id} accepted`,
            variables: {
                id: id
            },
            update: (proxy, { data: data })=>{
                const { acceptSettlement: acceptSettlement } = data || {};
                $088ea0c5cfbc2f70$var$log.info("acceptSettlementMutate update", acceptSettlement);
                // Update the pending settlements lists in cache
                acceptSettlement && onUpdateSettlement(acceptSettlement);
            }
        }).then(({ data: data })=>{
            const { acceptSettlement: acceptSettlement } = data || {
                acceptSettlement: undefined
            };
            $088ea0c5cfbc2f70$var$log.debug("acceptSettlementMutate resolved", acceptSettlement);
            acceptSettlement && onSelectId(acceptSettlement.id)(false);
            return acceptSettlement;
        });
    };
    const generateSettlements = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($36fac483fbfafa6c$exports)))));
    const onGenerateSettlements = ()=>{
        $088ea0c5cfbc2f70$var$log.debug("onGenerateSettlements");
        generateSettlements({
            loadingText: "Requesting settlements generation...",
            successText: "Settlements generation accepted",
            variables: {}
        }).then(({ data: data })=>{
            const { year: year, month: month } = data || {
                year: undefined,
                month: undefined
            };
            $088ea0c5cfbc2f70$var$log.debug("generateSettlementsMutate resolved", {
                year: year,
                month: month
            });
            return {
                year: year,
                month: month
            };
        });
    };
    $088ea0c5cfbc2f70$var$log.debug("render");
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: [
            showAcceptSelectedDialog && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $7f3b80d7462309dd$export$2e2bcd8739ae039), {
                name: "accept-settlements",
                heading: "Accept selected settlements",
                submitText: "Accept",
                submitKind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary,
                onSubmit: onConfirmApproveSelected,
                closeText: "Cancel",
                onClose: onCancelApproveSelected,
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("p", {
                    children: [
                        "Are you sure you want to ACCEPT ",
                        selectedIds && selectedIds.length,
                        " settlements?"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                children: [
                    "Pending Settlements ",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c9fff916b271bacd$export$8b9342b4cd8d6177), {
                        settlements: pendingSettlements
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "pending"
            }),
            !pendingSettlements || pendingSettlements.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                description: "No pending settlements to be approved",
                buttons: canAdjust && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                    text: "Generate Settlements",
                    onClick: onGenerateSettlements
                })
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    canAdjust && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        className: "pending-settlements__approve-all-form",
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox,
                                        isEditing: true,
                                        label: "Select all",
                                        value: areAllSelected(pendingSettlements),
                                        onChange: onSelectAll(pendingSettlements)
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                        kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary,
                                        text: `Accept selected (${selectedIds.length})`,
                                        onClick: onApproveSelected,
                                        isDisabled: selectedIds.isEmpty()
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1cc29ec20a6757d5$export$5de7bf55e34a321d), {
                        settlements: pendingSettlements,
                        onShowSettlement: onShowSettlement,
                        isSelected: isSelected,
                        onSelectId: canAdjust ? onSelectId : undefined
                    })
                ]
            })
        ]
    });
};






var $fgmOP = parcelRequire("fgmOP");
var $594dd639c02621c6$exports = {};
$594dd639c02621c6$exports = "mutation approveSettlement($id:ID!){approveSettlement(id:$id){...settlementFragment}}fragment settlementFragment on Settlement{date id state stateAction{action comment}yearMonth currencyCode isComplete customer{...customerMinimalFragment}contract{...contractNoDatesFragment}summary{...settlementSummaryFragment}productTypeSummaries{...settlementProductTypeSummaryFragment}adjustments{comment price feeCategory{productTypeId feeId}}productDetails{productDetailId productId productTypeId total fees{...productFeeFragment}}}fragment contractNoDatesFragment on Contract{id name type invoiceIncludeVat invoiceReference invoiceCustomerEmail invoiceAccountId h2SystemId comment}fragment customerMinimalFragment on Customer{id company{id name organizationNumber countryId brandId}}fragment settlementSummaryFragment on SettlementSummary{settlementTotal adjustmentTotal totalExclVat vat vatPercentage totalInclVat}fragment settlementProductTypeSummaryFragment on SettlementProductTypeSummary{productTypeId fees{...productFeeFragment}total}fragment productFeeFragment on ProductFee{feeId type quantity fee total}fragment productFeeFragment on ProductFee{feeId type quantity fee total}";


var $9d4bac3b876963c0$exports = {};
$9d4bac3b876963c0$exports = "mutation rejectSettlement($id:ID!$comment:String){rejectSettlement(id:$id comment:$comment){...settlementFragment}}fragment settlementFragment on Settlement{date id state stateAction{action comment}yearMonth currencyCode isComplete customer{...customerMinimalFragment}contract{...contractNoDatesFragment}summary{...settlementSummaryFragment}productTypeSummaries{...settlementProductTypeSummaryFragment}adjustments{comment price feeCategory{productTypeId feeId}}productDetails{productDetailId productId productTypeId total fees{...productFeeFragment}}}fragment contractNoDatesFragment on Contract{id name type invoiceIncludeVat invoiceReference invoiceCustomerEmail invoiceAccountId h2SystemId comment}fragment customerMinimalFragment on Customer{id company{id name organizationNumber countryId brandId}}fragment settlementSummaryFragment on SettlementSummary{settlementTotal adjustmentTotal totalExclVat vat vatPercentage totalInclVat}fragment settlementProductTypeSummaryFragment on SettlementProductTypeSummary{productTypeId fees{...productFeeFragment}total}fragment productFeeFragment on ProductFee{feeId type quantity fee total}fragment productFeeFragment on ProductFee{feeId type quantity fee total}";




















const $5a2c3e151bb2c343$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SettlementReadyForApprovalList", "INFO");
const $5a2c3e151bb2c343$export$52ca176ec17246c9 = ({ loading: loading, onUpdateSettlement: onUpdateSettlement, readyForApprovalSettlements: readyForApprovalSettlements })=>{
    (0, $c3440150448da8b8$export$1c72fe480f599e97)([
        {
            query: "readyForApprovalSettlements",
            isLoading: loading
        }
    ]);
    const { selectedIds: selectedIds, onSelectId: onSelectId, onSelectAll: onSelectAll, isSelected: isSelected, areAllSelected: areAllSelected } = (0, $843993963127ec3e$export$1c9b7756eccadc96)([]);
    const [showApproveSelectedDialog, setShowApproveSelectedDialog] = (0, $fgmOP.useState)(false);
    const { hasAnyPermission: hasAnyPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const canApprove = hasAnyPermission((0, $ca0941499cca84bb$export$5391912c22b803f7));
    const { showModal: showModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const onShowSettlement = (settlement)=>{
        $5a2c3e151bb2c343$var$log.debug("onShowSettlement", settlement.id);
        showModal({
            title: `${settlement.id} ${settlement.customer.company.name}`,
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $0905e0ef1c0b38f0$export$636a9648a4ec0e1), {
                settlement: settlement,
                onApprove: onApprove(settlement.id),
                onReject: onReject(settlement.id)
            })
        });
    };
    const onApproveSelected = ()=>{
        setShowApproveSelectedDialog(true);
    };
    const onCancelApproveSelected = ()=>{
        setShowApproveSelectedDialog(false);
    };
    const onConfirmApproveSelected = ()=>{
        $5a2c3e151bb2c343$var$log.info(`onConfirmApproveSelected ${selectedIds.length} Settlements`);
        setShowApproveSelectedDialog(false);
        selectedIds.forEach((settlementId)=>approveSettlement(settlementId));
    };
    const onApprove = (settlementId)=>()=>{
            $5a2c3e151bb2c343$var$log.debug(`onApprove Settlement`, settlementId);
            // setState({hiddenSettlements: state.hiddenSettlements.cloneToggle(settlementId)});
            approveSettlement(settlementId);
        };
    const approveSettlementHook = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($594dd639c02621c6$exports)))));
    const approveSettlement = (id)=>{
        $5a2c3e151bb2c343$var$log.debug(`Approving Settlement `, id);
        approveSettlementHook({
            loadingText: "Approving settlement...",
            successText: "Settlement approved",
            variables: {
                id: id
            },
            update: (proxy, { data: data })=>{
                const { approveSettlement: approveSettlement } = data || {};
                $5a2c3e151bb2c343$var$log.info("approveSettlementMutation update", approveSettlement);
                approveSettlement && onUpdateSettlement(approveSettlement);
            }
        }).then(({ data: data })=>{
            const { approveSettlement: approveSettlement } = data || {
                approveSettlement: undefined
            };
            $5a2c3e151bb2c343$var$log.debug("approveSettlementMutate resolved", approveSettlement);
            approveSettlement && onSelectId(approveSettlement.id)(false);
            return approveSettlement;
        });
    };
    const rejectSettlementHook = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($9d4bac3b876963c0$exports)))));
    const rejectSettlement = (id, comment)=>{
        $5a2c3e151bb2c343$var$log.debug(`Rejecting Settlement `, id);
        rejectSettlementHook({
            loadingText: "Rejecting settlement...",
            successText: "Settlement rejected",
            variables: {
                id: id,
                comment: comment
            },
            update: (proxy, { data: data })=>{
                const { rejectSettlement: rejectSettlement } = data || {};
                $5a2c3e151bb2c343$var$log.info("rejectSettlementMutation update", rejectSettlement);
                rejectSettlement && onUpdateSettlement(rejectSettlement);
            }
        }).then(({ data: data })=>{
            const { rejectSettlement: rejectSettlement } = data || {
                rejectSettlement: undefined
            };
            $5a2c3e151bb2c343$var$log.debug("rejectSettlementMutate resolved", rejectSettlement);
            rejectSettlement && onSelectId(rejectSettlement.id)(false);
            return rejectSettlement;
        });
    };
    const onReject = (settlementId)=>(comment)=>{
            // setState({hiddenSettlements: state.hiddenSettlements.cloneToggle(settlementId)});
            rejectSettlement(settlementId, comment);
        };
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: [
            showApproveSelectedDialog && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $7f3b80d7462309dd$export$2e2bcd8739ae039), {
                name: "approve-settlements",
                heading: "Approve & invoice selected settlements",
                submitText: "Approve",
                submitKind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary,
                onSubmit: onConfirmApproveSelected,
                closeText: "Cancel",
                onClose: onCancelApproveSelected,
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("p", {
                    children: [
                        "Are you sure you want to APPROVE ",
                        selectedIds && selectedIds.length,
                        " settlements?"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                children: [
                    "Ready For Approval Settlements ",
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c9fff916b271bacd$export$8b9342b4cd8d6177), {
                        settlements: readyForApprovalSettlements
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "ready-for-approval"
            }),
            !readyForApprovalSettlements || readyForApprovalSettlements.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                description: "No settlements ready for approval"
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    canApprove && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        className: "pending-settlements__approve-all-form",
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox,
                                        isEditing: true,
                                        label: "Select all",
                                        value: areAllSelected(readyForApprovalSettlements),
                                        onChange: onSelectAll(readyForApprovalSettlements)
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                        kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary,
                                        text: `Approve & invoice selected (${selectedIds.length})`,
                                        onClick: onApproveSelected,
                                        isDisabled: selectedIds.isEmpty()
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1cc29ec20a6757d5$export$5de7bf55e34a321d), {
                        settlements: readyForApprovalSettlements,
                        onShowSettlement: onShowSettlement,
                        isSelected: isSelected,
                        onSelectId: canApprove ? onSelectId : undefined
                    })
                ]
            })
        ]
    });
};






var $fgmOP = parcelRequire("fgmOP");
















const $cdadd7e792b579af$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SettlementSearch", "INFO");
const $cdadd7e792b579af$export$ed415943276d18b4 = (props)=>{
    const { settlementId: settlementId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const [searchString, setSearchString] = (0, $fgmOP.useState)(settlementId);
    const [search, { data: data, loading: loading, error: error }] = (0, $6ccde90cf8233047$export$fd83eea6ecd2d8fa)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($0fe803a534c2ebd1$exports)))));
    const { settlement: settlement } = data || {};
    const searchInputRef = (0, $fgmOP.useRef)();
    (0, $fgmOP.useEffect)(()=>{
        searchInputRef?.current?.focus();
    }, [
        searchInputRef.current
    ]);
    (0, $fgmOP.useEffect)(()=>{
        settlementId && !settlementId.isEmpty() && search({
            variables: {
                id: searchString
            }
        });
    }, [
        settlementId
    ]);
    const onSearch = ()=>{
        $cdadd7e792b579af$var$log.debug("onSearch", searchString);
        navigate(formatWithBrand($e9a95c61c800ecd2$export$8184fd48ec411db6, searchString));
    };
    $cdadd7e792b579af$var$log.debug("render", {
        settlementId: settlementId,
        searchString: searchString,
        loading: loading,
        data: data,
        error: error
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Search",
                showLoading: false
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "search"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $2e4c8094e1930e9a$export$2e2bcd8739ae039), {
                onSubmit: onSearch,
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).input,
                                isEditing: true,
                                placeholder: "settlement number",
                                icon: "search",
                                onChange: (value)=>{
                                    setSearchString(value || "");
                                },
                                value: searchString,
                                inputRef: searchInputRef
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary,
                                    text: "Search",
                                    onClick: onSearch
                                })
                            })
                        })
                    ]
                })
            }),
            loading ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : error ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $25d390e04dd0ffc0$export$2e2bcd8739ae039), {
                text: `Couldn't find settlement number: ${searchString}`
            }) : settlement === undefined ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dd22cd0dae287e6b$export$17e5a9408a16e37a), {
                description: `Introduce the settlement number and click SEARCH`
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ede1d69ade64ddbb$export$e957498a727fb850), {
                settlementId: settlement.id,
                customerId: settlement.customer.id
            })
        ]
    });
};


const $937d189e5cd22c3e$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SettlementMain", "INFO");
const $937d189e5cd22c3e$var$pendingSettlementsQueryGql = (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($0d614288a75b5405$exports))));
const $937d189e5cd22c3e$var$readyForApprovalSettlementsQueryGql = (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($3f3c28c2c91e1995$exports))));
const $937d189e5cd22c3e$export$7927449317d07e5c = (props)=>{
    $937d189e5cd22c3e$var$log.debug("render", props);
    const apolloClient = (0, $7626a5aec6f1579a$export$eb9a56e7a29e494)();
    const { currentUserBrand: currentUserBrand } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const subPath = $e9a95c61c800ecd2$export$e8c60b88aa54a6db($e9a95c61c800ecd2$export$257fa15708996d38);
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const { loading: loadingPending, data: { pendingSettlements: unfilteredPendingSettlements } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)($937d189e5cd22c3e$var$pendingSettlementsQueryGql, {
        skip: !currentUserBrand
    });
    const pendingSettlements = (0, $fgmOP.useMemo)(()=>unfilteredPendingSettlements?.filter(({ isComplete: isComplete })=>isComplete), [
        unfilteredPendingSettlements
    ]);
    $937d189e5cd22c3e$var$log.debug("pendingSettlements", {
        pendingSettlements: pendingSettlements
    });
    const { loading: loadingReadyForApproval, data: { readyForApprovalSettlements: unfilteredReadyForApprovalSettlements } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)($937d189e5cd22c3e$var$readyForApprovalSettlementsQueryGql, {
        skip: !currentUserBrand
    });
    const readyForApprovalSettlements = (0, $fgmOP.useMemo)(()=>unfilteredReadyForApprovalSettlements?.filter(({ isComplete: isComplete })=>isComplete), [
        unfilteredReadyForApprovalSettlements
    ]);
    const onUpdateSettlement = (settlement)=>{
        $937d189e5cd22c3e$var$log.info("onUpdateSettlement", settlement);
        //  Update settlement
        apolloClient.writeQuery({
            query: (0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($0fe803a534c2ebd1$exports)))),
            data: {
                settlement: settlement
            },
            variables: {
                id: settlement.id,
                customerId: settlement.customer.id
            }
        });
        //  Update pending settlements list
        const pendingSettlementsData = apolloClient.readQuery({
            query: $937d189e5cd22c3e$var$pendingSettlementsQueryGql
        });
        let pendingSettlements = pendingSettlementsData?.pendingSettlements.filter(({ state: state, isComplete: isComplete })=>state === "PENDING" && isComplete) || [];
        if (settlement.state === "PENDING") pendingSettlements = [
            settlement,
            ...pendingSettlements
        ];
        apolloClient.writeQuery({
            query: $937d189e5cd22c3e$var$pendingSettlementsQueryGql,
            data: {
                pendingSettlements: pendingSettlements
            }
        });
        //  Update readyForApproval settlements list
        const readyForApprovalSettlementsData = apolloClient.readQuery({
            query: $937d189e5cd22c3e$var$readyForApprovalSettlementsQueryGql,
            variables: {
                brandId: currentUserBrand?.id
            }
        });
        let readyForApprovalSettlements = readyForApprovalSettlementsData?.readyForApprovalSettlements.filter(({ state: state, isComplete: isComplete })=>state === "READY_FOR_APPROVAL" && isComplete) || [];
        if (settlement.state === "READY_FOR_APPROVAL") readyForApprovalSettlements.push(settlement);
        apolloClient.writeQuery({
            query: $937d189e5cd22c3e$var$readyForApprovalSettlementsQueryGql,
            variables: {
                brandId: currentUserBrand?.id
            },
            data: {
                readyForApprovalSettlements: readyForApprovalSettlements
            }
        });
    };
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $02b201edbdb8a3c4$export$2e2bcd8739ae039), {
                title: "Settlement"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bbc56e5aa7afa1c4$export$729687bd6e83ee94), {
                        ariaLabel: "Settlement submenu",
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$463ad4d82c57d375),
                                text: "Overview"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$ce951e24bd42e768),
                                text: `Pending`,
                                badge: pendingSettlements && pendingSettlements.length && pendingSettlements.length > 0 ? pendingSettlements.length : null
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$54f17f3347a024b8),
                                text: "Ready For Approval",
                                badge: readyForApprovalSettlements && readyForApprovalSettlements.length && readyForApprovalSettlements.length > 0 ? readyForApprovalSettlements.length : null
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$daea0807b252124c),
                                text: "Archive"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bbc56e5aa7afa1c4$export$b1233990f455934d), {
                                link: formatWithBrand($e9a95c61c800ecd2$export$771b78d26c6d9748),
                                text: "Search"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $b60bd97a1f982072$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $dfdceb7c36fce96f$export$3565eb3d00ca5a74), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    index: true,
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$444b3ab0cb9aec40), {
                                        to: formatWithBrand($e9a95c61c800ecd2$export$463ad4d82c57d375)
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$463ad4d82c57d375),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $8426a2c0dc6b0908$export$144948fdc8348bc), {
                                        pendingSettlementsCount: pendingSettlements?.length,
                                        readyForApprovalSettlementsCount: readyForApprovalSettlements?.length
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$ce951e24bd42e768),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $088ea0c5cfbc2f70$export$c3850165f79ac7e9), {
                                        pendingSettlements: pendingSettlements,
                                        onUpdateSettlement: onUpdateSettlement,
                                        loading: loadingPending
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$54f17f3347a024b8),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5a2c3e151bb2c343$export$52ca176ec17246c9), {
                                        readyForApprovalSettlements: readyForApprovalSettlements,
                                        onUpdateSettlement: onUpdateSettlement,
                                        loading: loadingReadyForApproval
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$daea0807b252124c),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $61e94c27064c2643$export$2f871929f445e8e), {})
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$8184fd48ec411db6),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $cdadd7e792b579af$export$ed415943276d18b4), {})
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                    path: subPath($e9a95c61c800ecd2$export$771b78d26c6d9748),
                                    element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $cdadd7e792b579af$export$ed415943276d18b4), {})
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};



parcelRequire("fgmOP");




var $1e58b2c968e9b0f8$exports = {};
$1e58b2c968e9b0f8$exports = "query mfaConfig{mfaConfig}";


const $2b8aae9faaad2758$export$2be8f315b327112e = ()=>{
    const { loading: loading, data: { mfaConfig: mfaConfig } = {} } = (0, $f72ec353e2162d59$export$dd0a697e1782aedd)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($1e58b2c968e9b0f8$exports)))));
    return {
        loading: loading,
        mfaConfig: mfaConfig,
        isMfaEnabled: mfaConfig === "ON" || mfaConfig === "OPTIONAL"
    };
};













var $fgmOP = parcelRequire("fgmOP");
var $caadf6fb30d3b925$exports = {};
$caadf6fb30d3b925$exports = "query customerUsers($customerId:ID){customerUsers(customerId:$customerId){...userFragment}}fragment userFragment on User{id cognitoId firstName lastName phone email description permissions type userAccessStatusType customerId comment roles rolesMap{resource roles permissions}isSSOUser mfaOptions{sms{enabled phone}app{enabled}}}";













const $a75ae18ee5070016$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ImpersonateUser", "INFO");
const $a75ae18ee5070016$export$a0a9e641e89cc209 = ()=>{
    const [customer, setCustomer] = (0, $fgmOP.useState)();
    const { user: user, isImpersonating: isImpersonating, currentUserBrand: currentUserBrand, setImpersonatedUser: setImpersonatedUser, currentBrandRoles: currentBrandRoles } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { getCustomerOverview: getCustomerOverview, customerOverviews: customerOverviews } = (0, $8d8d8b3d38044bbe$export$d27d8317adc3c298)({
        skipQuery: !currentUserBrand
    });
    const [fetchCustomerUsers, { loading: loading, data: { customerUsers: customerUsers } = {} }] = (0, $6ccde90cf8233047$export$fd83eea6ecd2d8fa)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($caadf6fb30d3b925$exports)))), {
        notifyOnNetworkStatusChange: true
    });
    (0, $fgmOP.useEffect)(()=>{
        customer && fetchCustomerUsers({
            variables: {
                customerId: customer.id
            }
        });
    }, [
        customer
    ]);
    const [fetchFullCustomerUser] = (0, $6ccde90cf8233047$export$fd83eea6ecd2d8fa)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($06a51a6eb4e11bab$exports)))), {
        fetchPolicy: "no-cache"
    });
    const onImpersonate = (user)=>{
        fetchFullCustomerUser({
            variables: {
                userId: user.id
            },
            onCompleted: ({ user: user })=>{
                $a75ae18ee5070016$var$log.debug("User to impersonate:", {
                    user: user
                });
                setImpersonatedUser(user);
            }
        });
    };
    $a75ae18ee5070016$var$log.debug("render", {
        user: user,
        isImpersonating: isImpersonating
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: isImpersonating ? "Viewing Telia Bulk Messaging Web as:" : "View Telia Bulk Messaging Web as a Customer User"
            }),
            isImpersonating ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $2e4c8094e1930e9a$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                        label: "Firstname",
                                        value: user?.firstName
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                        label: "Lastname",
                                        value: user?.lastName
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "Email",
                                    value: user?.email
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "Mobile",
                                    value: user?.phone
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "Role",
                                    value: currentBrandRoles,
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi,
                                    options: currentBrandRoles
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                        text: "Stop impersonating",
                                        onClick: ()=>{
                                            setImpersonatedUser(undefined);
                                        }
                                    })
                                })
                            })
                        })
                    ]
                })
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    !currentUserBrand && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3ab394edcd89558b$export$2e2bcd8739ae039), {
                        className: "inlineBlock",
                        kind: "warning",
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                            children: "To impersonate a user, first you have to select a brand"
                        })
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                    label: "Customer",
                                    isEditing: true,
                                    isDisabled: !currentUserBrand,
                                    type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                    options: customerOverviews,
                                    value: customer?.id,
                                    onChange: (customerId)=>setCustomer(getCustomerOverview(customerId))
                                })
                            })
                        })
                    }),
                    loading && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}),
                    customer && customerUsers && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c25b1426f30dd551$export$f61ed0586120f3c), {
                        users: customerUsers,
                        onSelectUser: onImpersonate,
                        customerId: customer?.id
                    })
                ]
            })
        ]
    });
};






var $l8GLF = parcelRequire("l8GLF");


var $fgmOP = parcelRequire("fgmOP");















const $538192cf057e043b$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("LoginInfo", "INFO");
const $538192cf057e043b$export$38c429987e42f36d = (props)=>{
    const { user: user, realUser: realUser, logout: logout, currentBrandRealUserRoles: currentBrandRealUserRoles, refetch: refetch } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { getRole: getRole } = (0, $3b1b6b64a4bd4f9b$export$a884b22cb22f8e99)();
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)({
        initialEntity: realUser,
        isEditing: false
    });
    const { entityAs: entityAs, isEditing: isEditing, entity: entityFormState, onEdit: onEdit, onCancel: onCancel, onChange: onChange } = formState;
    const entity = isEditing ? entityFormState : realUser;
    const saveUser = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($d2756dbba47edf22$exports)))));
    const onSave = ()=>{
        const user = (0, $6afa790c69fae185$export$f5cac05ac3bf56d8)(entityAs());
        saveUser({
            variables: {
                user: user
            },
            loadingText: "Updating info",
            successText: "Info updated"
        }).then(({ data: data })=>{
            const { saveUser: saveUser } = data || {
                saveUser: undefined
            };
            $538192cf057e043b$var$log.debug("saveUser resolved", {
                saveUser: saveUser
            });
            saveUser && formState.onSaved((0, $f6ff28847e6675c5$export$232f37f9a0fc548e)(saveUser));
            refetch();
        });
    };
    const { showModal: showModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const onChangePassword = ()=>{
        showModal({
            title: "Change Password",
            content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("span", {
                children: "To change your password use the 'forgot your password?' feature of the login form."
            }),
            confirmText: "Go to 'Forgot your password?'",
            onConfirm: ()=>window.location.href = (0, $f5d0c2a7498ff49b$exports.urlPaths).CHANGE_PASSWORD
        });
    };
    return !entity ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $2e4c8094e1930e9a$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "firstName",
                                label: "Firstname"
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                formState: formState,
                                entityFieldId: "lastName",
                                label: "Lastname"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                            formState: formState,
                            entityFieldId: "email",
                            label: "Email",
                            isEditing: false
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $8e2421cb37be9d76$export$7eda936955feae4d), {
                            formState: formState
                        })
                    })
                }),
                realUser?.userAccessStatusType === (0, $l8GLF.UserAccessStatusType).REJECTED || realUser?.userAccessStatusType === (0, $l8GLF.UserAccessStatusType).PENDING ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                    className: "pending__info--container",
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3ab394edcd89558b$export$2e2bcd8739ae039), {
                        kind: "warning",
                        children: realUser.userAccessStatusType === (0, $l8GLF.UserAccessStatusType).PENDING ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("p", {
                            children: [
                                "Your account is ",
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("b", {
                                    children: "pending"
                                }),
                                " and waiting approval from a Telia admin. Once your account is approved you will be able to access Telia Bulk Messaging Web."
                            ]
                        }) : realUser?.userAccessStatusType === (0, $l8GLF.UserAccessStatusType).REJECTED && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("p", {
                            children: [
                                "Your account has been ",
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("b", {
                                    children: "rejected"
                                }),
                                " by a Telia admin. Please contact",
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("a", {
                                    className: "link text_inline",
                                    href: "mailto:cpa-support@telia.no",
                                    children: "cpa-support@telia.no"
                                }),
                                "if you think this was a mistake."
                            ]
                        })
                    })
                }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                        children: !currentBrandRealUserRoles.isEmpty() ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                            value: currentBrandRealUserRoles,
                            label: "Role",
                            isEditing: false,
                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi,
                            options: currentBrandRealUserRoles.map((roleId)=>getRole(roleId) || roleId)
                        }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                            defaultValue: "No roles",
                            label: "Role",
                            isEditing: false
                        })
                    })
                }),
                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                        children: !isEditing ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    text: "Logout",
                                    onClick: logout
                                }),
                                realUser?.isSSOUser === false && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    text: "Change Password",
                                    onClick: onChangePassword
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    text: "Edit profile",
                                    onClick: onEdit,
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel
                                })
                            ]
                        }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    text: "Save",
                                    onClick: onSave,
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    text: "Cancel",
                                    onClick: onCancel,
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};






var $fgmOP = parcelRequire("fgmOP");








parcelRequire("fgmOP");


const $b0e83c339339f15d$export$543eb5c88cab994e = ({ isConfigured: isConfigured, title: title, subtitle: subtitle, rightElement: rightElement })=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("mfa--option--row__wrapper", isConfigured ? "mfa--option--row__configured" : "mfa--option--row__unconfigured"),
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ef5f892b79fbbbd8$export$f04a61298a47a40f), {
                icon: isConfigured ? "check-circle-filled" : "alert-filled",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("mfa--option--row__icon", "vertical-align-bottom", isConfigured ? "greenText" : "orangeText")
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "mfa--option--row__title",
                children: title
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "mfa--option--row__subtitle",
                children: subtitle
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                className: "mfa--option--row__action",
                children: rightElement
            })
        ]
    });
};



parcelRequire("fgmOP");




var $fgmOP = parcelRequire("fgmOP");




var $fgmOP = parcelRequire("fgmOP");
var $425a098d2c8b7133$exports = {};
$425a098d2c8b7133$exports = "mutation verifyPassword($password:String!){verifyPassword(password:$password){verified}}";









const $2fd4d118e1e0011e$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("VerifyPassword", "INFO");
const $2fd4d118e1e0011e$export$13072451887058c9 = ({ onVerified: onVerified, onCancel: onCancel })=>{
    const [loading, setLoading] = (0, $fgmOP.useState)(false);
    const verifyPassword = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($425a098d2c8b7133$exports)))));
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)({
        isEditing: true,
        initialEntity: {
            password: ""
        }
    });
    const onVerifyPassword = ()=>{
        setLoading(true);
        verifyPassword({
            variables: {
                password: formState.entity.password?.toString() || ""
            }
        }).then(({ data: data })=>{
            setLoading(false);
            if (data?.verifyPassword) onVerified();
        });
    };
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: "password",
                        label: "Enter your password",
                        type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).password,
                        autocomplete: "off"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        children: loading ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary,
                                    onClick: onVerifyPassword,
                                    text: "Continue"
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel,
                                    onClick: onCancel,
                                    text: "Cancel"
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};


const $1e11cbe1111c1a70$export$1512d990affd4def = ({ children: children, onCancel: onCancel })=>{
    const [isVerified, setIsVerified] = (0, $fgmOP.useState)(false);
    return isVerified ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: children
    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $2fd4d118e1e0011e$export$13072451887058c9), {
        onVerified: ()=>setIsVerified(true),
        onCancel: ()=>{
            setIsVerified(false);
            onCancel();
        }
    });
};







var $fgmOP = parcelRequire("fgmOP");
var $d61585176f1b8c0c$exports = {};
$d61585176f1b8c0c$exports = "mutation associateSoftwareToken{associateSoftwareToken{secretCode}}";


var $227226d1d449f476$exports = {};
$227226d1d449f476$exports = "mutation verifySoftwareToken($userCode:String!$deviceName:String){verifySoftwareToken(userCode:$userCode deviceName:$deviceName){verified}}";














var $fgmOP = parcelRequire("fgmOP");
var $1a4dbb0208e3e8a3$exports = {};
"use strict";
Object.defineProperty($1a4dbb0208e3e8a3$exports, "__esModule", {
    value: true
});
$1a4dbb0208e3e8a3$exports.QRCode = undefined;
var $1a4dbb0208e3e8a3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $e551d0020787b97d$exports = {};
var $a8d0bef41b829e34$exports = {};
var $c6486596ddb39e65$exports = {};
$c6486596ddb39e65$exports = {
    MODE_NUMBER: 1,
    MODE_ALPHA_NUM: 2,
    MODE_8BIT_BYTE: 4,
    MODE_KANJI: 8
};


function $a8d0bef41b829e34$var$QR8bitByte(data) {
    this.mode = $c6486596ddb39e65$exports.MODE_8BIT_BYTE;
    this.data = data;
}
$a8d0bef41b829e34$var$QR8bitByte.prototype = {
    getLength: function(buffer) {
        return this.data.length;
    },
    write: function(buffer) {
        for(var i = 0; i < this.data.length; i++)// not JIS ...
        buffer.put(this.data.charCodeAt(i), 8);
    }
};
$a8d0bef41b829e34$exports = $a8d0bef41b829e34$var$QR8bitByte;


var $feaa951e076c4c9d$exports = {};
// ErrorCorrectLevel
var $8b92eaefe49dc832$exports = {};
$8b92eaefe49dc832$exports = {
    L: 1,
    M: 0,
    Q: 3,
    H: 2
};


function $feaa951e076c4c9d$var$QRRSBlock(totalCount, dataCount) {
    this.totalCount = totalCount;
    this.dataCount = dataCount;
}
$feaa951e076c4c9d$var$QRRSBlock.RS_BLOCK_TABLE = [
    // L
    // M
    // Q
    // H
    // 1
    [
        1,
        26,
        19
    ],
    [
        1,
        26,
        16
    ],
    [
        1,
        26,
        13
    ],
    [
        1,
        26,
        9
    ],
    // 2
    [
        1,
        44,
        34
    ],
    [
        1,
        44,
        28
    ],
    [
        1,
        44,
        22
    ],
    [
        1,
        44,
        16
    ],
    // 3
    [
        1,
        70,
        55
    ],
    [
        1,
        70,
        44
    ],
    [
        2,
        35,
        17
    ],
    [
        2,
        35,
        13
    ],
    // 4		
    [
        1,
        100,
        80
    ],
    [
        2,
        50,
        32
    ],
    [
        2,
        50,
        24
    ],
    [
        4,
        25,
        9
    ],
    // 5
    [
        1,
        134,
        108
    ],
    [
        2,
        67,
        43
    ],
    [
        2,
        33,
        15,
        2,
        34,
        16
    ],
    [
        2,
        33,
        11,
        2,
        34,
        12
    ],
    // 6
    [
        2,
        86,
        68
    ],
    [
        4,
        43,
        27
    ],
    [
        4,
        43,
        19
    ],
    [
        4,
        43,
        15
    ],
    // 7		
    [
        2,
        98,
        78
    ],
    [
        4,
        49,
        31
    ],
    [
        2,
        32,
        14,
        4,
        33,
        15
    ],
    [
        4,
        39,
        13,
        1,
        40,
        14
    ],
    // 8
    [
        2,
        121,
        97
    ],
    [
        2,
        60,
        38,
        2,
        61,
        39
    ],
    [
        4,
        40,
        18,
        2,
        41,
        19
    ],
    [
        4,
        40,
        14,
        2,
        41,
        15
    ],
    // 9
    [
        2,
        146,
        116
    ],
    [
        3,
        58,
        36,
        2,
        59,
        37
    ],
    [
        4,
        36,
        16,
        4,
        37,
        17
    ],
    [
        4,
        36,
        12,
        4,
        37,
        13
    ],
    // 10		
    [
        2,
        86,
        68,
        2,
        87,
        69
    ],
    [
        4,
        69,
        43,
        1,
        70,
        44
    ],
    [
        6,
        43,
        19,
        2,
        44,
        20
    ],
    [
        6,
        43,
        15,
        2,
        44,
        16
    ],
    // 11
    [
        4,
        101,
        81
    ],
    [
        1,
        80,
        50,
        4,
        81,
        51
    ],
    [
        4,
        50,
        22,
        4,
        51,
        23
    ],
    [
        3,
        36,
        12,
        8,
        37,
        13
    ],
    // 12
    [
        2,
        116,
        92,
        2,
        117,
        93
    ],
    [
        6,
        58,
        36,
        2,
        59,
        37
    ],
    [
        4,
        46,
        20,
        6,
        47,
        21
    ],
    [
        7,
        42,
        14,
        4,
        43,
        15
    ],
    // 13
    [
        4,
        133,
        107
    ],
    [
        8,
        59,
        37,
        1,
        60,
        38
    ],
    [
        8,
        44,
        20,
        4,
        45,
        21
    ],
    [
        12,
        33,
        11,
        4,
        34,
        12
    ],
    // 14
    [
        3,
        145,
        115,
        1,
        146,
        116
    ],
    [
        4,
        64,
        40,
        5,
        65,
        41
    ],
    [
        11,
        36,
        16,
        5,
        37,
        17
    ],
    [
        11,
        36,
        12,
        5,
        37,
        13
    ],
    // 15
    [
        5,
        109,
        87,
        1,
        110,
        88
    ],
    [
        5,
        65,
        41,
        5,
        66,
        42
    ],
    [
        5,
        54,
        24,
        7,
        55,
        25
    ],
    [
        11,
        36,
        12
    ],
    // 16
    [
        5,
        122,
        98,
        1,
        123,
        99
    ],
    [
        7,
        73,
        45,
        3,
        74,
        46
    ],
    [
        15,
        43,
        19,
        2,
        44,
        20
    ],
    [
        3,
        45,
        15,
        13,
        46,
        16
    ],
    // 17
    [
        1,
        135,
        107,
        5,
        136,
        108
    ],
    [
        10,
        74,
        46,
        1,
        75,
        47
    ],
    [
        1,
        50,
        22,
        15,
        51,
        23
    ],
    [
        2,
        42,
        14,
        17,
        43,
        15
    ],
    // 18
    [
        5,
        150,
        120,
        1,
        151,
        121
    ],
    [
        9,
        69,
        43,
        4,
        70,
        44
    ],
    [
        17,
        50,
        22,
        1,
        51,
        23
    ],
    [
        2,
        42,
        14,
        19,
        43,
        15
    ],
    // 19
    [
        3,
        141,
        113,
        4,
        142,
        114
    ],
    [
        3,
        70,
        44,
        11,
        71,
        45
    ],
    [
        17,
        47,
        21,
        4,
        48,
        22
    ],
    [
        9,
        39,
        13,
        16,
        40,
        14
    ],
    // 20
    [
        3,
        135,
        107,
        5,
        136,
        108
    ],
    [
        3,
        67,
        41,
        13,
        68,
        42
    ],
    [
        15,
        54,
        24,
        5,
        55,
        25
    ],
    [
        15,
        43,
        15,
        10,
        44,
        16
    ],
    // 21
    [
        4,
        144,
        116,
        4,
        145,
        117
    ],
    [
        17,
        68,
        42
    ],
    [
        17,
        50,
        22,
        6,
        51,
        23
    ],
    [
        19,
        46,
        16,
        6,
        47,
        17
    ],
    // 22
    [
        2,
        139,
        111,
        7,
        140,
        112
    ],
    [
        17,
        74,
        46
    ],
    [
        7,
        54,
        24,
        16,
        55,
        25
    ],
    [
        34,
        37,
        13
    ],
    // 23
    [
        4,
        151,
        121,
        5,
        152,
        122
    ],
    [
        4,
        75,
        47,
        14,
        76,
        48
    ],
    [
        11,
        54,
        24,
        14,
        55,
        25
    ],
    [
        16,
        45,
        15,
        14,
        46,
        16
    ],
    // 24
    [
        6,
        147,
        117,
        4,
        148,
        118
    ],
    [
        6,
        73,
        45,
        14,
        74,
        46
    ],
    [
        11,
        54,
        24,
        16,
        55,
        25
    ],
    [
        30,
        46,
        16,
        2,
        47,
        17
    ],
    // 25
    [
        8,
        132,
        106,
        4,
        133,
        107
    ],
    [
        8,
        75,
        47,
        13,
        76,
        48
    ],
    [
        7,
        54,
        24,
        22,
        55,
        25
    ],
    [
        22,
        45,
        15,
        13,
        46,
        16
    ],
    // 26
    [
        10,
        142,
        114,
        2,
        143,
        115
    ],
    [
        19,
        74,
        46,
        4,
        75,
        47
    ],
    [
        28,
        50,
        22,
        6,
        51,
        23
    ],
    [
        33,
        46,
        16,
        4,
        47,
        17
    ],
    // 27
    [
        8,
        152,
        122,
        4,
        153,
        123
    ],
    [
        22,
        73,
        45,
        3,
        74,
        46
    ],
    [
        8,
        53,
        23,
        26,
        54,
        24
    ],
    [
        12,
        45,
        15,
        28,
        46,
        16
    ],
    // 28
    [
        3,
        147,
        117,
        10,
        148,
        118
    ],
    [
        3,
        73,
        45,
        23,
        74,
        46
    ],
    [
        4,
        54,
        24,
        31,
        55,
        25
    ],
    [
        11,
        45,
        15,
        31,
        46,
        16
    ],
    // 29
    [
        7,
        146,
        116,
        7,
        147,
        117
    ],
    [
        21,
        73,
        45,
        7,
        74,
        46
    ],
    [
        1,
        53,
        23,
        37,
        54,
        24
    ],
    [
        19,
        45,
        15,
        26,
        46,
        16
    ],
    // 30
    [
        5,
        145,
        115,
        10,
        146,
        116
    ],
    [
        19,
        75,
        47,
        10,
        76,
        48
    ],
    [
        15,
        54,
        24,
        25,
        55,
        25
    ],
    [
        23,
        45,
        15,
        25,
        46,
        16
    ],
    // 31
    [
        13,
        145,
        115,
        3,
        146,
        116
    ],
    [
        2,
        74,
        46,
        29,
        75,
        47
    ],
    [
        42,
        54,
        24,
        1,
        55,
        25
    ],
    [
        23,
        45,
        15,
        28,
        46,
        16
    ],
    // 32
    [
        17,
        145,
        115
    ],
    [
        10,
        74,
        46,
        23,
        75,
        47
    ],
    [
        10,
        54,
        24,
        35,
        55,
        25
    ],
    [
        19,
        45,
        15,
        35,
        46,
        16
    ],
    // 33
    [
        17,
        145,
        115,
        1,
        146,
        116
    ],
    [
        14,
        74,
        46,
        21,
        75,
        47
    ],
    [
        29,
        54,
        24,
        19,
        55,
        25
    ],
    [
        11,
        45,
        15,
        46,
        46,
        16
    ],
    // 34
    [
        13,
        145,
        115,
        6,
        146,
        116
    ],
    [
        14,
        74,
        46,
        23,
        75,
        47
    ],
    [
        44,
        54,
        24,
        7,
        55,
        25
    ],
    [
        59,
        46,
        16,
        1,
        47,
        17
    ],
    // 35
    [
        12,
        151,
        121,
        7,
        152,
        122
    ],
    [
        12,
        75,
        47,
        26,
        76,
        48
    ],
    [
        39,
        54,
        24,
        14,
        55,
        25
    ],
    [
        22,
        45,
        15,
        41,
        46,
        16
    ],
    // 36
    [
        6,
        151,
        121,
        14,
        152,
        122
    ],
    [
        6,
        75,
        47,
        34,
        76,
        48
    ],
    [
        46,
        54,
        24,
        10,
        55,
        25
    ],
    [
        2,
        45,
        15,
        64,
        46,
        16
    ],
    // 37
    [
        17,
        152,
        122,
        4,
        153,
        123
    ],
    [
        29,
        74,
        46,
        14,
        75,
        47
    ],
    [
        49,
        54,
        24,
        10,
        55,
        25
    ],
    [
        24,
        45,
        15,
        46,
        46,
        16
    ],
    // 38
    [
        4,
        152,
        122,
        18,
        153,
        123
    ],
    [
        13,
        74,
        46,
        32,
        75,
        47
    ],
    [
        48,
        54,
        24,
        14,
        55,
        25
    ],
    [
        42,
        45,
        15,
        32,
        46,
        16
    ],
    // 39
    [
        20,
        147,
        117,
        4,
        148,
        118
    ],
    [
        40,
        75,
        47,
        7,
        76,
        48
    ],
    [
        43,
        54,
        24,
        22,
        55,
        25
    ],
    [
        10,
        45,
        15,
        67,
        46,
        16
    ],
    // 40
    [
        19,
        148,
        118,
        6,
        149,
        119
    ],
    [
        18,
        75,
        47,
        31,
        76,
        48
    ],
    [
        34,
        54,
        24,
        34,
        55,
        25
    ],
    [
        20,
        45,
        15,
        61,
        46,
        16
    ]
];
$feaa951e076c4c9d$var$QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
    var rsBlock = $feaa951e076c4c9d$var$QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
    if (rsBlock == undefined) throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
    var length = rsBlock.length / 3;
    var list = new Array();
    for(var i = 0; i < length; i++){
        var count = rsBlock[i * 3 + 0];
        var totalCount = rsBlock[i * 3 + 1];
        var dataCount = rsBlock[i * 3 + 2];
        for(var j = 0; j < count; j++)list.push(new $feaa951e076c4c9d$var$QRRSBlock(totalCount, dataCount));
    }
    return list;
};
$feaa951e076c4c9d$var$QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {
    switch(errorCorrectLevel){
        case $8b92eaefe49dc832$exports.L:
            return $feaa951e076c4c9d$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
        case $8b92eaefe49dc832$exports.M:
            return $feaa951e076c4c9d$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
        case $8b92eaefe49dc832$exports.Q:
            return $feaa951e076c4c9d$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
        case $8b92eaefe49dc832$exports.H:
            return $feaa951e076c4c9d$var$QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$feaa951e076c4c9d$exports = $feaa951e076c4c9d$var$QRRSBlock;


var $53cf936bbf7c0899$exports = {};
function $53cf936bbf7c0899$var$QRBitBuffer() {
    this.buffer = new Array();
    this.length = 0;
}
$53cf936bbf7c0899$var$QRBitBuffer.prototype = {
    get: function(index) {
        var bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) == 1;
    },
    put: function(num, length) {
        for(var i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) == 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        var bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$53cf936bbf7c0899$exports = $53cf936bbf7c0899$var$QRBitBuffer;


var $f27811fcd4cf5f7c$exports = {};

var $8d278f21e72dac4a$exports = {};
var $13e16bbe12027121$exports = {};
var $13e16bbe12027121$var$QRMath = {
    glog: function(n) {
        if (n < 1) throw new Error("glog(" + n + ")");
        return $13e16bbe12027121$var$QRMath.LOG_TABLE[n];
    },
    gexp: function(n) {
        while(n < 0)n += 255;
        while(n >= 256)n -= 255;
        return $13e16bbe12027121$var$QRMath.EXP_TABLE[n];
    },
    EXP_TABLE: new Array(256),
    LOG_TABLE: new Array(256)
};
for(var $13e16bbe12027121$var$i = 0; $13e16bbe12027121$var$i < 8; $13e16bbe12027121$var$i++)$13e16bbe12027121$var$QRMath.EXP_TABLE[$13e16bbe12027121$var$i] = 1 << $13e16bbe12027121$var$i;
for(var $13e16bbe12027121$var$i = 8; $13e16bbe12027121$var$i < 256; $13e16bbe12027121$var$i++)$13e16bbe12027121$var$QRMath.EXP_TABLE[$13e16bbe12027121$var$i] = $13e16bbe12027121$var$QRMath.EXP_TABLE[$13e16bbe12027121$var$i - 4] ^ $13e16bbe12027121$var$QRMath.EXP_TABLE[$13e16bbe12027121$var$i - 5] ^ $13e16bbe12027121$var$QRMath.EXP_TABLE[$13e16bbe12027121$var$i - 6] ^ $13e16bbe12027121$var$QRMath.EXP_TABLE[$13e16bbe12027121$var$i - 8];
for(var $13e16bbe12027121$var$i = 0; $13e16bbe12027121$var$i < 255; $13e16bbe12027121$var$i++)$13e16bbe12027121$var$QRMath.LOG_TABLE[$13e16bbe12027121$var$QRMath.EXP_TABLE[$13e16bbe12027121$var$i]] = $13e16bbe12027121$var$i;
$13e16bbe12027121$exports = $13e16bbe12027121$var$QRMath;


function $8d278f21e72dac4a$var$QRPolynomial(num, shift) {
    if (num.length == undefined) throw new Error(num.length + "/" + shift);
    var offset = 0;
    while(offset < num.length && num[offset] == 0)offset++;
    this.num = new Array(num.length - offset + shift);
    for(var i = 0; i < num.length - offset; i++)this.num[i] = num[i + offset];
}
$8d278f21e72dac4a$var$QRPolynomial.prototype = {
    get: function(index) {
        return this.num[index];
    },
    getLength: function() {
        return this.num.length;
    },
    multiply: function(e) {
        var num = new Array(this.getLength() + e.getLength() - 1);
        for(var i = 0; i < this.getLength(); i++)for(var j = 0; j < e.getLength(); j++)num[i + j] ^= $13e16bbe12027121$exports.gexp($13e16bbe12027121$exports.glog(this.get(i)) + $13e16bbe12027121$exports.glog(e.get(j)));
        return new $8d278f21e72dac4a$var$QRPolynomial(num, 0);
    },
    mod: function(e) {
        if (this.getLength() - e.getLength() < 0) return this;
        var ratio = $13e16bbe12027121$exports.glog(this.get(0)) - $13e16bbe12027121$exports.glog(e.get(0));
        var num = new Array(this.getLength());
        for(var i = 0; i < this.getLength(); i++)num[i] = this.get(i);
        for(var i = 0; i < e.getLength(); i++)num[i] ^= $13e16bbe12027121$exports.gexp($13e16bbe12027121$exports.glog(e.get(i)) + ratio);
        // recursive call
        return new $8d278f21e72dac4a$var$QRPolynomial(num, 0).mod(e);
    }
};
$8d278f21e72dac4a$exports = $8d278f21e72dac4a$var$QRPolynomial;



var $f27811fcd4cf5f7c$var$QRMaskPattern = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
var $f27811fcd4cf5f7c$var$QRUtil = {
    PATTERN_POSITION_TABLE: [
        [],
        [
            6,
            18
        ],
        [
            6,
            22
        ],
        [
            6,
            26
        ],
        [
            6,
            30
        ],
        [
            6,
            34
        ],
        [
            6,
            22,
            38
        ],
        [
            6,
            24,
            42
        ],
        [
            6,
            26,
            46
        ],
        [
            6,
            28,
            50
        ],
        [
            6,
            30,
            54
        ],
        [
            6,
            32,
            58
        ],
        [
            6,
            34,
            62
        ],
        [
            6,
            26,
            46,
            66
        ],
        [
            6,
            26,
            48,
            70
        ],
        [
            6,
            26,
            50,
            74
        ],
        [
            6,
            30,
            54,
            78
        ],
        [
            6,
            30,
            56,
            82
        ],
        [
            6,
            30,
            58,
            86
        ],
        [
            6,
            34,
            62,
            90
        ],
        [
            6,
            28,
            50,
            72,
            94
        ],
        [
            6,
            26,
            50,
            74,
            98
        ],
        [
            6,
            30,
            54,
            78,
            102
        ],
        [
            6,
            28,
            54,
            80,
            106
        ],
        [
            6,
            32,
            58,
            84,
            110
        ],
        [
            6,
            30,
            58,
            86,
            114
        ],
        [
            6,
            34,
            62,
            90,
            118
        ],
        [
            6,
            26,
            50,
            74,
            98,
            122
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126
        ],
        [
            6,
            26,
            52,
            78,
            104,
            130
        ],
        [
            6,
            30,
            56,
            82,
            108,
            134
        ],
        [
            6,
            34,
            60,
            86,
            112,
            138
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142
        ],
        [
            6,
            34,
            62,
            90,
            118,
            146
        ],
        [
            6,
            30,
            54,
            78,
            102,
            126,
            150
        ],
        [
            6,
            24,
            50,
            76,
            102,
            128,
            154
        ],
        [
            6,
            28,
            54,
            80,
            106,
            132,
            158
        ],
        [
            6,
            32,
            58,
            84,
            110,
            136,
            162
        ],
        [
            6,
            26,
            54,
            82,
            110,
            138,
            166
        ],
        [
            6,
            30,
            58,
            86,
            114,
            142,
            170
        ]
    ],
    G15: 1335,
    G18: 7973,
    G15_MASK: 21522,
    getBCHTypeInfo: function(data) {
        var d = data << 10;
        while($f27811fcd4cf5f7c$var$QRUtil.getBCHDigit(d) - $f27811fcd4cf5f7c$var$QRUtil.getBCHDigit($f27811fcd4cf5f7c$var$QRUtil.G15) >= 0)d ^= $f27811fcd4cf5f7c$var$QRUtil.G15 << $f27811fcd4cf5f7c$var$QRUtil.getBCHDigit(d) - $f27811fcd4cf5f7c$var$QRUtil.getBCHDigit($f27811fcd4cf5f7c$var$QRUtil.G15);
        return (data << 10 | d) ^ $f27811fcd4cf5f7c$var$QRUtil.G15_MASK;
    },
    getBCHTypeNumber: function(data) {
        var d = data << 12;
        while($f27811fcd4cf5f7c$var$QRUtil.getBCHDigit(d) - $f27811fcd4cf5f7c$var$QRUtil.getBCHDigit($f27811fcd4cf5f7c$var$QRUtil.G18) >= 0)d ^= $f27811fcd4cf5f7c$var$QRUtil.G18 << $f27811fcd4cf5f7c$var$QRUtil.getBCHDigit(d) - $f27811fcd4cf5f7c$var$QRUtil.getBCHDigit($f27811fcd4cf5f7c$var$QRUtil.G18);
        return data << 12 | d;
    },
    getBCHDigit: function(data) {
        var digit = 0;
        while(data != 0){
            digit++;
            data >>>= 1;
        }
        return digit;
    },
    getPatternPosition: function(typeNumber) {
        return $f27811fcd4cf5f7c$var$QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },
    getMask: function(maskPattern, i, j) {
        switch(maskPattern){
            case $f27811fcd4cf5f7c$var$QRMaskPattern.PATTERN000:
                return (i + j) % 2 == 0;
            case $f27811fcd4cf5f7c$var$QRMaskPattern.PATTERN001:
                return i % 2 == 0;
            case $f27811fcd4cf5f7c$var$QRMaskPattern.PATTERN010:
                return j % 3 == 0;
            case $f27811fcd4cf5f7c$var$QRMaskPattern.PATTERN011:
                return (i + j) % 3 == 0;
            case $f27811fcd4cf5f7c$var$QRMaskPattern.PATTERN100:
                return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 == 0;
            case $f27811fcd4cf5f7c$var$QRMaskPattern.PATTERN101:
                return i * j % 2 + i * j % 3 == 0;
            case $f27811fcd4cf5f7c$var$QRMaskPattern.PATTERN110:
                return (i * j % 2 + i * j % 3) % 2 == 0;
            case $f27811fcd4cf5f7c$var$QRMaskPattern.PATTERN111:
                return (i * j % 3 + (i + j) % 2) % 2 == 0;
            default:
                throw new Error("bad maskPattern:" + maskPattern);
        }
    },
    getErrorCorrectPolynomial: function(errorCorrectLength) {
        var a = new $8d278f21e72dac4a$exports([
            1
        ], 0);
        for(var i = 0; i < errorCorrectLength; i++)a = a.multiply(new $8d278f21e72dac4a$exports([
            1,
            $13e16bbe12027121$exports.gexp(i)
        ], 0));
        return a;
    },
    getLengthInBits: function(mode, type) {
        if (1 <= type && type < 10) // 1 - 9
        switch(mode){
            case $c6486596ddb39e65$exports.MODE_NUMBER:
                return 10;
            case $c6486596ddb39e65$exports.MODE_ALPHA_NUM:
                return 9;
            case $c6486596ddb39e65$exports.MODE_8BIT_BYTE:
                return 8;
            case $c6486596ddb39e65$exports.MODE_KANJI:
                return 8;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 27) // 10 - 26
        switch(mode){
            case $c6486596ddb39e65$exports.MODE_NUMBER:
                return 12;
            case $c6486596ddb39e65$exports.MODE_ALPHA_NUM:
                return 11;
            case $c6486596ddb39e65$exports.MODE_8BIT_BYTE:
                return 16;
            case $c6486596ddb39e65$exports.MODE_KANJI:
                return 10;
            default:
                throw new Error("mode:" + mode);
        }
        else if (type < 41) // 27 - 40
        switch(mode){
            case $c6486596ddb39e65$exports.MODE_NUMBER:
                return 14;
            case $c6486596ddb39e65$exports.MODE_ALPHA_NUM:
                return 13;
            case $c6486596ddb39e65$exports.MODE_8BIT_BYTE:
                return 16;
            case $c6486596ddb39e65$exports.MODE_KANJI:
                return 12;
            default:
                throw new Error("mode:" + mode);
        }
        else throw new Error("type:" + type);
    },
    getLostPoint: function(qrCode) {
        var moduleCount = qrCode.getModuleCount();
        var lostPoint = 0;
        // LEVEL1
        for(var row = 0; row < moduleCount; row++)for(var col = 0; col < moduleCount; col++){
            var sameCount = 0;
            var dark = qrCode.isDark(row, col);
            for(var r = -1; r <= 1; r++){
                if (row + r < 0 || moduleCount <= row + r) continue;
                for(var c = -1; c <= 1; c++){
                    if (col + c < 0 || moduleCount <= col + c) continue;
                    if (r == 0 && c == 0) continue;
                    if (dark == qrCode.isDark(row + r, col + c)) sameCount++;
                }
            }
            if (sameCount > 5) lostPoint += 3 + sameCount - 5;
        }
        // LEVEL2
        for(var row = 0; row < moduleCount - 1; row++)for(var col = 0; col < moduleCount - 1; col++){
            var count = 0;
            if (qrCode.isDark(row, col)) count++;
            if (qrCode.isDark(row + 1, col)) count++;
            if (qrCode.isDark(row, col + 1)) count++;
            if (qrCode.isDark(row + 1, col + 1)) count++;
            if (count == 0 || count == 4) lostPoint += 3;
        }
        // LEVEL3
        for(var row = 0; row < moduleCount; row++){
            for(var col = 0; col < moduleCount - 6; col++)if (qrCode.isDark(row, col) && !qrCode.isDark(row, col + 1) && qrCode.isDark(row, col + 2) && qrCode.isDark(row, col + 3) && qrCode.isDark(row, col + 4) && !qrCode.isDark(row, col + 5) && qrCode.isDark(row, col + 6)) lostPoint += 40;
        }
        for(var col = 0; col < moduleCount; col++){
            for(var row = 0; row < moduleCount - 6; row++)if (qrCode.isDark(row, col) && !qrCode.isDark(row + 1, col) && qrCode.isDark(row + 2, col) && qrCode.isDark(row + 3, col) && qrCode.isDark(row + 4, col) && !qrCode.isDark(row + 5, col) && qrCode.isDark(row + 6, col)) lostPoint += 40;
        }
        // LEVEL4
        var darkCount = 0;
        for(var col = 0; col < moduleCount; col++){
            for(var row = 0; row < moduleCount; row++)if (qrCode.isDark(row, col)) darkCount++;
        }
        var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
        lostPoint += ratio * 10;
        return lostPoint;
    }
};
$f27811fcd4cf5f7c$exports = $f27811fcd4cf5f7c$var$QRUtil;



function $e551d0020787b97d$var$QRCode(typeNumber, errorCorrectLevel) {
    this.typeNumber = typeNumber;
    this.errorCorrectLevel = errorCorrectLevel;
    this.modules = null;
    this.moduleCount = 0;
    this.dataCache = null;
    this.dataList = [];
}
// for client side minification
var $e551d0020787b97d$var$proto = $e551d0020787b97d$var$QRCode.prototype;
$e551d0020787b97d$var$proto.addData = function(data) {
    var newData = new $a8d0bef41b829e34$exports(data);
    this.dataList.push(newData);
    this.dataCache = null;
};
$e551d0020787b97d$var$proto.isDark = function(row, col) {
    if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) throw new Error(row + "," + col);
    return this.modules[row][col];
};
$e551d0020787b97d$var$proto.getModuleCount = function() {
    return this.moduleCount;
};
$e551d0020787b97d$var$proto.make = function() {
    // Calculate automatically typeNumber if provided is < 1
    if (this.typeNumber < 1) {
        var typeNumber = 1;
        for(typeNumber = 1; typeNumber < 40; typeNumber++){
            var rsBlocks = $feaa951e076c4c9d$exports.getRSBlocks(typeNumber, this.errorCorrectLevel);
            var buffer = new $53cf936bbf7c0899$exports();
            var totalDataCount = 0;
            for(var i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
            for(var i = 0; i < this.dataList.length; i++){
                var data = this.dataList[i];
                buffer.put(data.mode, 4);
                buffer.put(data.getLength(), $f27811fcd4cf5f7c$exports.getLengthInBits(data.mode, typeNumber));
                data.write(buffer);
            }
            if (buffer.getLengthInBits() <= totalDataCount * 8) break;
        }
        this.typeNumber = typeNumber;
    }
    this.makeImpl(false, this.getBestMaskPattern());
};
$e551d0020787b97d$var$proto.makeImpl = function(test, maskPattern) {
    this.moduleCount = this.typeNumber * 4 + 17;
    this.modules = new Array(this.moduleCount);
    for(var row = 0; row < this.moduleCount; row++){
        this.modules[row] = new Array(this.moduleCount);
        for(var col = 0; col < this.moduleCount; col++)this.modules[row][col] = null; //(col + row) % 3;
    }
    this.setupPositionProbePattern(0, 0);
    this.setupPositionProbePattern(this.moduleCount - 7, 0);
    this.setupPositionProbePattern(0, this.moduleCount - 7);
    this.setupPositionAdjustPattern();
    this.setupTimingPattern();
    this.setupTypeInfo(test, maskPattern);
    if (this.typeNumber >= 7) this.setupTypeNumber(test);
    if (this.dataCache == null) this.dataCache = $e551d0020787b97d$var$QRCode.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
    this.mapData(this.dataCache, maskPattern);
};
$e551d0020787b97d$var$proto.setupPositionProbePattern = function(row, col) {
    for(var r = -1; r <= 7; r++){
        if (row + r <= -1 || this.moduleCount <= row + r) continue;
        for(var c = -1; c <= 7; c++){
            if (col + c <= -1 || this.moduleCount <= col + c) continue;
            if (0 <= r && r <= 6 && (c == 0 || c == 6) || 0 <= c && c <= 6 && (r == 0 || r == 6) || 2 <= r && r <= 4 && 2 <= c && c <= 4) this.modules[row + r][col + c] = true;
            else this.modules[row + r][col + c] = false;
        }
    }
};
$e551d0020787b97d$var$proto.getBestMaskPattern = function() {
    var minLostPoint = 0;
    var pattern = 0;
    for(var i = 0; i < 8; i++){
        this.makeImpl(true, i);
        var lostPoint = $f27811fcd4cf5f7c$exports.getLostPoint(this);
        if (i == 0 || minLostPoint > lostPoint) {
            minLostPoint = lostPoint;
            pattern = i;
        }
    }
    return pattern;
};
$e551d0020787b97d$var$proto.createMovieClip = function(target_mc, instance_name, depth) {
    var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
    var cs = 1;
    this.make();
    for(var row = 0; row < this.modules.length; row++){
        var y = row * cs;
        for(var col = 0; col < this.modules[row].length; col++){
            var x = col * cs;
            var dark = this.modules[row][col];
            if (dark) {
                qr_mc.beginFill(0, 100);
                qr_mc.moveTo(x, y);
                qr_mc.lineTo(x + cs, y);
                qr_mc.lineTo(x + cs, y + cs);
                qr_mc.lineTo(x, y + cs);
                qr_mc.endFill();
            }
        }
    }
    return qr_mc;
};
$e551d0020787b97d$var$proto.setupTimingPattern = function() {
    for(var r = 8; r < this.moduleCount - 8; r++){
        if (this.modules[r][6] != null) continue;
        this.modules[r][6] = r % 2 == 0;
    }
    for(var c = 8; c < this.moduleCount - 8; c++){
        if (this.modules[6][c] != null) continue;
        this.modules[6][c] = c % 2 == 0;
    }
};
$e551d0020787b97d$var$proto.setupPositionAdjustPattern = function() {
    var pos = $f27811fcd4cf5f7c$exports.getPatternPosition(this.typeNumber);
    for(var i = 0; i < pos.length; i++)for(var j = 0; j < pos.length; j++){
        var row = pos[i];
        var col = pos[j];
        if (this.modules[row][col] != null) continue;
        for(var r = -2; r <= 2; r++){
            for(var c = -2; c <= 2; c++)if (r == -2 || r == 2 || c == -2 || c == 2 || r == 0 && c == 0) this.modules[row + r][col + c] = true;
            else this.modules[row + r][col + c] = false;
        }
    }
};
$e551d0020787b97d$var$proto.setupTypeNumber = function(test) {
    var bits = $f27811fcd4cf5f7c$exports.getBCHTypeNumber(this.typeNumber);
    for(var i = 0; i < 18; i++){
        var mod = !test && (bits >> i & 1) == 1;
        this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
    }
    for(var i = 0; i < 18; i++){
        var mod = !test && (bits >> i & 1) == 1;
        this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
    }
};
$e551d0020787b97d$var$proto.setupTypeInfo = function(test, maskPattern) {
    var data = this.errorCorrectLevel << 3 | maskPattern;
    var bits = $f27811fcd4cf5f7c$exports.getBCHTypeInfo(data);
    // vertical		
    for(var i = 0; i < 15; i++){
        var mod = !test && (bits >> i & 1) == 1;
        if (i < 6) this.modules[i][8] = mod;
        else if (i < 8) this.modules[i + 1][8] = mod;
        else this.modules[this.moduleCount - 15 + i][8] = mod;
    }
    // horizontal
    for(var i = 0; i < 15; i++){
        var mod = !test && (bits >> i & 1) == 1;
        if (i < 8) this.modules[8][this.moduleCount - i - 1] = mod;
        else if (i < 9) this.modules[8][15 - i - 1 + 1] = mod;
        else this.modules[8][15 - i - 1] = mod;
    }
    // fixed module
    this.modules[this.moduleCount - 8][8] = !test;
};
$e551d0020787b97d$var$proto.mapData = function(data, maskPattern) {
    var inc = -1;
    var row = this.moduleCount - 1;
    var bitIndex = 7;
    var byteIndex = 0;
    for(var col = this.moduleCount - 1; col > 0; col -= 2){
        if (col == 6) col--;
        while(true){
            for(var c = 0; c < 2; c++)if (this.modules[row][col - c] == null) {
                var dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) == 1;
                var mask = $f27811fcd4cf5f7c$exports.getMask(maskPattern, row, col - c);
                if (mask) dark = !dark;
                this.modules[row][col - c] = dark;
                bitIndex--;
                if (bitIndex == -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || this.moduleCount <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
};
$e551d0020787b97d$var$QRCode.PAD0 = 0xEC;
$e551d0020787b97d$var$QRCode.PAD1 = 0x11;
$e551d0020787b97d$var$QRCode.createData = function(typeNumber, errorCorrectLevel, dataList) {
    var rsBlocks = $feaa951e076c4c9d$exports.getRSBlocks(typeNumber, errorCorrectLevel);
    var buffer = new $53cf936bbf7c0899$exports();
    for(var i = 0; i < dataList.length; i++){
        var data = dataList[i];
        buffer.put(data.mode, 4);
        buffer.put(data.getLength(), $f27811fcd4cf5f7c$exports.getLengthInBits(data.mode, typeNumber));
        data.write(buffer);
    }
    // calc num max data.
    var totalDataCount = 0;
    for(var i = 0; i < rsBlocks.length; i++)totalDataCount += rsBlocks[i].dataCount;
    if (buffer.getLengthInBits() > totalDataCount * 8) throw new Error("code length overflow. (" + buffer.getLengthInBits() + ">" + totalDataCount * 8 + ")");
    // end code
    if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) buffer.put(0, 4);
    // padding
    while(buffer.getLengthInBits() % 8 != 0)buffer.putBit(false);
    // padding
    while(true){
        if (buffer.getLengthInBits() >= totalDataCount * 8) break;
        buffer.put($e551d0020787b97d$var$QRCode.PAD0, 8);
        if (buffer.getLengthInBits() >= totalDataCount * 8) break;
        buffer.put($e551d0020787b97d$var$QRCode.PAD1, 8);
    }
    return $e551d0020787b97d$var$QRCode.createBytes(buffer, rsBlocks);
};
$e551d0020787b97d$var$QRCode.createBytes = function(buffer, rsBlocks) {
    var offset = 0;
    var maxDcCount = 0;
    var maxEcCount = 0;
    var dcdata = new Array(rsBlocks.length);
    var ecdata = new Array(rsBlocks.length);
    for(var r = 0; r < rsBlocks.length; r++){
        var dcCount = rsBlocks[r].dataCount;
        var ecCount = rsBlocks[r].totalCount - dcCount;
        maxDcCount = Math.max(maxDcCount, dcCount);
        maxEcCount = Math.max(maxEcCount, ecCount);
        dcdata[r] = new Array(dcCount);
        for(var i = 0; i < dcdata[r].length; i++)dcdata[r][i] = 0xff & buffer.buffer[i + offset];
        offset += dcCount;
        var rsPoly = $f27811fcd4cf5f7c$exports.getErrorCorrectPolynomial(ecCount);
        var rawPoly = new $8d278f21e72dac4a$exports(dcdata[r], rsPoly.getLength() - 1);
        var modPoly = rawPoly.mod(rsPoly);
        ecdata[r] = new Array(rsPoly.getLength() - 1);
        for(var i = 0; i < ecdata[r].length; i++){
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
            ecdata[r][i] = modIndex >= 0 ? modPoly.get(modIndex) : 0;
        }
    }
    var totalCodeCount = 0;
    for(var i = 0; i < rsBlocks.length; i++)totalCodeCount += rsBlocks[i].totalCount;
    var data = new Array(totalCodeCount);
    var index = 0;
    for(var i = 0; i < maxDcCount; i++){
        for(var r = 0; r < rsBlocks.length; r++)if (i < dcdata[r].length) data[index++] = dcdata[r][i];
    }
    for(var i = 0; i < maxEcCount; i++){
        for(var r = 0; r < rsBlocks.length; r++)if (i < ecdata[r].length) data[index++] = ecdata[r][i];
    }
    return data;
};
$e551d0020787b97d$exports = $e551d0020787b97d$var$QRCode;


var $1a4dbb0208e3e8a3$var$_QRCode2 = $1a4dbb0208e3e8a3$var$_interopRequireDefault($e551d0020787b97d$exports);

var $1a4dbb0208e3e8a3$var$_ErrorCorrectLevel2 = $1a4dbb0208e3e8a3$var$_interopRequireDefault($8b92eaefe49dc832$exports);

var $jPPOv = parcelRequire("jPPOv");
var $1a4dbb0208e3e8a3$var$_propTypes2 = $1a4dbb0208e3e8a3$var$_interopRequireDefault($jPPOv);

var $fgmOP = parcelRequire("fgmOP");
var $1a4dbb0208e3e8a3$var$_react2 = $1a4dbb0208e3e8a3$var$_interopRequireDefault($fgmOP);
var $875541f8e4c62d9b$exports = {};
"use strict";
Object.defineProperty($875541f8e4c62d9b$exports, "__esModule", {
    value: true
});
var $875541f8e4c62d9b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $jPPOv = parcelRequire("jPPOv");
var $875541f8e4c62d9b$var$_propTypes2 = $875541f8e4c62d9b$var$_interopRequireDefault($jPPOv);

var $fgmOP = parcelRequire("fgmOP");
var $875541f8e4c62d9b$var$_react2 = $875541f8e4c62d9b$var$_interopRequireDefault($fgmOP);
function $875541f8e4c62d9b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $875541f8e4c62d9b$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $875541f8e4c62d9b$var$propTypes = {
    bgColor: $875541f8e4c62d9b$var$_propTypes2.default.oneOfType([
        $875541f8e4c62d9b$var$_propTypes2.default.object,
        $875541f8e4c62d9b$var$_propTypes2.default.string
    ]).isRequired,
    bgD: $875541f8e4c62d9b$var$_propTypes2.default.string.isRequired,
    fgColor: $875541f8e4c62d9b$var$_propTypes2.default.oneOfType([
        $875541f8e4c62d9b$var$_propTypes2.default.object,
        $875541f8e4c62d9b$var$_propTypes2.default.string
    ]).isRequired,
    fgD: $875541f8e4c62d9b$var$_propTypes2.default.string.isRequired,
    size: $875541f8e4c62d9b$var$_propTypes2.default.number.isRequired,
    title: $875541f8e4c62d9b$var$_propTypes2.default.string,
    viewBoxSize: $875541f8e4c62d9b$var$_propTypes2.default.number.isRequired,
    xmlns: $875541f8e4c62d9b$var$_propTypes2.default.string
};
var $875541f8e4c62d9b$var$defaultProps = {
    title: undefined,
    xmlns: "http://www.w3.org/2000/svg"
};
var $875541f8e4c62d9b$var$QRCodeSvg = (0, $fgmOP.forwardRef)(function(_ref, ref) {
    var bgColor = _ref.bgColor, bgD = _ref.bgD, fgD = _ref.fgD, fgColor = _ref.fgColor, size = _ref.size, title = _ref.title, viewBoxSize = _ref.viewBoxSize, props = $875541f8e4c62d9b$var$_objectWithoutProperties(_ref, [
        "bgColor",
        "bgD",
        "fgD",
        "fgColor",
        "size",
        "title",
        "viewBoxSize"
    ]);
    return $875541f8e4c62d9b$var$_react2.default.createElement("svg", $875541f8e4c62d9b$var$_extends({}, props, {
        height: size,
        ref: ref,
        viewBox: "0 0 " + viewBoxSize + " " + viewBoxSize,
        width: size
    }), title ? $875541f8e4c62d9b$var$_react2.default.createElement("title", null, title) : null, $875541f8e4c62d9b$var$_react2.default.createElement("path", {
        d: bgD,
        fill: bgColor
    }), $875541f8e4c62d9b$var$_react2.default.createElement("path", {
        d: fgD,
        fill: fgColor
    }));
});
$875541f8e4c62d9b$var$QRCodeSvg.displayName = "QRCodeSvg";
$875541f8e4c62d9b$var$QRCodeSvg.propTypes = $875541f8e4c62d9b$var$propTypes;
$875541f8e4c62d9b$var$QRCodeSvg.defaultProps = $875541f8e4c62d9b$var$defaultProps;
$875541f8e4c62d9b$exports.default = $875541f8e4c62d9b$var$QRCodeSvg;


var $1a4dbb0208e3e8a3$var$_QRCodeSvg2 = $1a4dbb0208e3e8a3$var$_interopRequireDefault($875541f8e4c62d9b$exports);
function $1a4dbb0208e3e8a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $1a4dbb0208e3e8a3$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
} // A `qr.js` doesn't handle error level of zero (M) so we need to do it right, thus the deep require.
var $1a4dbb0208e3e8a3$var$propTypes = {
    bgColor: $1a4dbb0208e3e8a3$var$_propTypes2.default.oneOfType([
        $1a4dbb0208e3e8a3$var$_propTypes2.default.object,
        $1a4dbb0208e3e8a3$var$_propTypes2.default.string
    ]),
    fgColor: $1a4dbb0208e3e8a3$var$_propTypes2.default.oneOfType([
        $1a4dbb0208e3e8a3$var$_propTypes2.default.object,
        $1a4dbb0208e3e8a3$var$_propTypes2.default.string
    ]),
    level: $1a4dbb0208e3e8a3$var$_propTypes2.default.string,
    size: $1a4dbb0208e3e8a3$var$_propTypes2.default.number,
    value: $1a4dbb0208e3e8a3$var$_propTypes2.default.string.isRequired
};
var $1a4dbb0208e3e8a3$var$defaultProps = {
    bgColor: "#FFFFFF",
    fgColor: "#000000",
    level: "L",
    size: 256
};
var $1a4dbb0208e3e8a3$var$QRCode = (0, $fgmOP.forwardRef)(function(_ref, ref) {
    var bgColor = _ref.bgColor, fgColor = _ref.fgColor, level = _ref.level, size = _ref.size, value = _ref.value, props = $1a4dbb0208e3e8a3$var$_objectWithoutProperties(_ref, [
        "bgColor",
        "fgColor",
        "level",
        "size",
        "value"
    ]);
    // Use type === -1 to automatically pick the best type.
    var qrcode = new $1a4dbb0208e3e8a3$var$_QRCode2.default(-1, $1a4dbb0208e3e8a3$var$_ErrorCorrectLevel2.default[level]);
    qrcode.addData(value);
    qrcode.make();
    var cells = qrcode.modules;
    return $1a4dbb0208e3e8a3$var$_react2.default.createElement($1a4dbb0208e3e8a3$var$_QRCodeSvg2.default, $1a4dbb0208e3e8a3$var$_extends({}, props, {
        bgColor: bgColor,
        bgD: cells.map(function(row, rowIndex) {
            return row.map(function(cell, cellIndex) {
                return !cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
            }).join(" ");
        }).join(" "),
        fgColor: fgColor,
        fgD: cells.map(function(row, rowIndex) {
            return row.map(function(cell, cellIndex) {
                return cell ? "M " + cellIndex + " " + rowIndex + " l 1 0 0 1 -1 0 Z" : "";
            }).join(" ");
        }).join(" "),
        ref: ref,
        size: size,
        viewBoxSize: cells.length
    }));
});
$1a4dbb0208e3e8a3$exports.QRCode = $1a4dbb0208e3e8a3$var$QRCode;
$1a4dbb0208e3e8a3$var$QRCode.displayName = "QRCode";
$1a4dbb0208e3e8a3$var$QRCode.propTypes = $1a4dbb0208e3e8a3$var$propTypes;
$1a4dbb0208e3e8a3$var$QRCode.defaultProps = $1a4dbb0208e3e8a3$var$defaultProps;
$1a4dbb0208e3e8a3$exports.default = $1a4dbb0208e3e8a3$var$QRCode;







const $82948426466f197e$export$d06c4a6f120e8891 = ({ secretCode: secretCode })=>{
    const { realUser: realUser } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const [showSecretCode, setShowSecretCode] = (0, $fgmOP.useState)(false);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                            className: "mfa--qr--code__wrapper",
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                    style: {
                                        height: "auto",
                                        margin: "0 auto",
                                        maxWidth: "128",
                                        width: "100%"
                                    },
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1a4dbb0208e3e8a3$exports))), {
                                        size: 128,
                                        value: `otpauth://totp/Telia Bulk Messaging Web${(0, $ce151254b700f66a$export$1cfdf9a01e3f7773)() ? "" : " - Stage"}:${realUser?.email}?secret=${secretCode}`,
                                        style: {
                                            height: "auto",
                                            maxWidth: "100%",
                                            width: "100%"
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    text: `${showSecretCode ? "Hide" : "Show"} secret key`,
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.link,
                                    onClick: ()=>setShowSecretCode(!showSecretCode)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {})
                    ]
                })
            }),
            showSecretCode && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("p", {
                            children: [
                                "Secret Key:",
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("span", {
                                    className: "mfa--setup--secret--key__value",
                                    children: [
                                        " ",
                                        secretCode
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};


const $f2ee7dc282f78142$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("MfaAppEditForm", "INFO");
const $f2ee7dc282f78142$export$dd4009344bef9c96 = ({ onClose: onClose })=>{
    const [loading, setLoading] = (0, $fgmOP.useState)(false);
    const { realUser: realUser, refetch: refetch } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const associateSoftwareToken = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($d61585176f1b8c0c$exports)))));
    const verifySoftwareToken = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($227226d1d449f476$exports)))));
    const [secretCode, setSecretCode] = (0, $fgmOP.useState)();
    (0, $fgmOP.useEffect)(()=>{
        associateSoftwareToken().then(({ data: data })=>{
            setSecretCode(data?.associateSoftwareToken.secretCode);
        });
    }, []);
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)({
        isEditing: true
    });
    const { entityAs: entityAs, putError: putError } = formState;
    const onConfirm = async ()=>{
        setLoading(true);
        const { userCode: userCode, deviceName: deviceName } = entityAs();
        if (!userCode) {
            putError("usercode", "Please enter a one time code from your authenticator app.");
            return;
        }
        const response = await verifySoftwareToken({
            successText: "Authenticator app added",
            variables: {
                userCode: userCode,
                deviceName: deviceName
            }
        });
        if (response.data?.verifySoftwareToken?.verified) {
            await refetch();
            onClose();
        }
        setLoading(false);
    };
    return !secretCode ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {})
            })
        })
    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                        className: "noMarginTop",
                        children: "Scan the QR code below using your authenticator app. Alternatively you can enter the secret key manually in your authenticator app."
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $82948426466f197e$export$d06c4a6f120e8891), {
                secretCode: secretCode
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: "deviceName",
                        label: "Friendly Device Name - Optional",
                        placeholder: `${(0, $f5d0c2a7498ff49b$exports.format).possessiveForm(realUser?.firstName)} phone`,
                        tip: `A name for your MFA device, for example "${(0, $f5d0c2a7498ff49b$exports.format).possessiveForm(realUser?.firstName)} phone".`
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        formState: formState,
                        entityFieldId: "userCode",
                        label: "Enter a code from your authenticator app",
                        placeholder: "000000"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        children: loading ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    text: "Confirm",
                                    onClick: onConfirm,
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    text: "Cancel",
                                    onClick: onClose,
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};


const $68f6447044e04392$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("MfaAppEdit", "INFO");
const $68f6447044e04392$export$8094e7a5b5d18703 = ({ isConfigured: isConfigured, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
        className: "form-group",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                title: `${isConfigured ? "Reset" : "Setup"} Authenticator App`
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1e11cbe1111c1a70$export$1512d990affd4def), {
                    onCancel: onClose,
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $f2ee7dc282f78142$export$dd4009344bef9c96), {
                        onClose: onClose
                    })
                })
            })
        ]
    });
};



parcelRequire("fgmOP");






var $fgmOP = parcelRequire("fgmOP");

var $fdb660416ec03038$exports = {};
$fdb660416ec03038$exports = "mutation saveMfaPhoneNumber($phone:String!){saveMfaPhoneNumber(phone:$phone){phone verified}}";


var $240995c2d809a34d$exports = {};
$240995c2d809a34d$exports = "mutation verifyMfaPhoneNumber($code:String!){verifyMfaPhoneNumber(code:$code)}";











const $9bea24eb2b0f3e3a$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("MfaSmsEditForm", "DEBUG");
var $9bea24eb2b0f3e3a$var$EditState;
(function(EditState) {
    EditState[EditState["ENTER_NUMBER"] = 0] = "ENTER_NUMBER";
    EditState[EditState["VERIFY"] = 1] = "VERIFY";
})($9bea24eb2b0f3e3a$var$EditState || ($9bea24eb2b0f3e3a$var$EditState = {}));
const $9bea24eb2b0f3e3a$export$372286af4dcb37f1 = ({ onClose: onClose })=>{
    const { realUser: realUser, refetch: refetch } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const [loading, setLoading] = (0, $fgmOP.useState)(false);
    const saveMfaPhoneNumber = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($fdb660416ec03038$exports)))));
    const verifyMfaPhoneNumber = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$2e2bcd8739ae039)((0, (/*@__PURE__*/$parcel$interopDefault($240995c2d809a34d$exports)))));
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)({
        isEditing: true
    });
    const { entityAs: entityAs, putError: putError } = formState;
    const onSendCode = async ()=>{
        const { mfaPhone: mfaPhone } = entityAs();
        if (!mfaPhone) {
            putError("mfaPhone", "Please enter a phone number");
            return;
        }
        if (realUser?.mfaOptions?.sms.enabled && mfaPhone === realUser?.mfaOptions?.sms.phone) {
            putError("mfaPhone", "This number is the same as your current configuration. Please enter a new phone number.");
            return;
        }
        setLoading(true);
        const { data: data } = await saveMfaPhoneNumber({
            variables: {
                phone: mfaPhone
            }
        });
        if (!data?.saveMfaPhoneNumber.verified && data?.saveMfaPhoneNumber.phone) onSent(data?.saveMfaPhoneNumber.phone);
        else if (data?.saveMfaPhoneNumber.verified === true) {
            (0, $4983ed7d9d06375d$export$b410431fab84fa58).success("Phone number already verified.", {
                autoClose: 2500
            });
            await refetch();
            onClose();
        }
        setLoading(false);
    };
    const [sentTo, setSentTo] = (0, $fgmOP.useState)();
    const [state, setState] = (0, $fgmOP.useState)(0);
    const onSent = (to)=>{
        setState(1);
        setSentTo(to);
    };
    const onVerify = async ()=>{
        setLoading(true);
        const { code: code } = entityAs();
        if (!code) {
            putError("code", "Please enter your authentication code.");
            return;
        }
        const { data: data } = await verifyMfaPhoneNumber({
            successText: "Phone number updated",
            variables: {
                code: code
            }
        });
        if (data?.verifyMfaPhoneNumber) {
            await refetch();
            onClose();
        }
        setLoading(false);
    };
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            state === 1 && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("p", {
                        className: "noMarginTop",
                        children: [
                            "We have sent an authentication code by SMS to ",
                            sentTo,
                            ". Please enter the code below to verify your number."
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: state === 0 ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $8e2421cb37be9d76$export$7eda936955feae4d), {
                        label: "Phone number",
                        formState: formState,
                        entityFieldId: "mfaPhone"
                    }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                        label: "Enter authentication code",
                        formState: formState,
                        entityFieldId: "code",
                        placeholder: "000000"
                    })
                })
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                        children: loading ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    text: state === 0 ? "Send Code" : "Update number",
                                    onClick: state === 0 ? onSendCode : onVerify,
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                    text: "Cancel",
                                    onClick: onClose,
                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};


const $54c4db19f550cb6f$export$a10e6cf61ee95818 = ({ isAdded: isAdded, onClose: onClose })=>{
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("section", {
        className: "form-group",
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c65faac65c1ca170$export$2e2bcd8739ae039), {
                title: `${isAdded ? "Edit" : "Add"} MFA phone number`
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1e11cbe1111c1a70$export$1512d990affd4def), {
                    onCancel: onClose,
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9bea24eb2b0f3e3a$export$372286af4dcb37f1), {
                        onClose: onClose
                    })
                })
            })
        ]
    });
};


const $fcda5457412eb931$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("MfaInfo", "INFO");
const $fcda5457412eb931$export$9c5bcd9a18290ca = ()=>{
    const { realUser: realUser } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const [showAppEdit, setShowAppEdit] = (0, $fgmOP.useState)(false);
    const [showSmsEdit, setShowSmsEdit] = (0, $fgmOP.useState)(false);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $2edc691f96482cbe$export$f04a61298a47a40f), {
                        icon: "security",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))("blueText", "vertical-align-bottom")
                    }),
                    "Multi-factor Authentication"
                ]
            }),
            !showSmsEdit ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $b0e83c339339f15d$export$543eb5c88cab994e), {
                        isConfigured: !!realUser?.mfaOptions?.sms.enabled,
                        title: "SMS",
                        rightElement: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                            text: !!realUser?.mfaOptions?.sms.enabled ? "Edit" : "Add",
                            onClick: ()=>setShowSmsEdit(true),
                            kind: !!realUser?.mfaOptions?.sms.enabled ? (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.normal : (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary
                        })
                    })
                })
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $54c4db19f550cb6f$export$a10e6cf61ee95818), {
                isAdded: !!realUser?.mfaOptions?.sms.enabled,
                onClose: ()=>setShowSmsEdit(false)
            }),
            !showAppEdit ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $b0e83c339339f15d$export$543eb5c88cab994e), {
                        isConfigured: !!realUser?.mfaOptions?.app.enabled,
                        title: "Authenticator app",
                        rightElement: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                            text: !!realUser?.mfaOptions?.app.enabled ? "Reset" : "Add",
                            onClick: ()=>setShowAppEdit(true),
                            kind: !!realUser?.mfaOptions?.app.enabled ? (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.normal : (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary
                        })
                    })
                })
            }) : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $68f6447044e04392$export$8094e7a5b5d18703), {
                isConfigured: !!realUser?.mfaOptions?.app.enabled,
                onClose: ()=>setShowAppEdit(false)
            })
        ]
    });
};


const $4694ee00a1536bcb$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("MyPage");
const $4694ee00a1536bcb$export$d4415139ac509692 = ()=>{
    const { loadingUser: loadingUser, user: user, hasRealUserPermission: hasRealUserPermission } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const { isMfaEnabled: isMfaEnabled } = (0, $2b8aae9faaad2758$export$2be8f315b327112e)();
    $4694ee00a1536bcb$var$log.debug("render", {
        loadingUser: loadingUser,
        user: user,
        isMfaEnabled: isMfaEnabled
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $02b201edbdb8a3c4$export$2e2bcd8739ae039), {
                title: "Login Info"
            }),
            loadingUser ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {}) : !user ? /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$444b3ab0cb9aec40), {
                to: $e9a95c61c800ecd2$export$a7c5707626fc90f
            }) // Redirect to home if user is not logged in
             : /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                        page: "profile"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $538192cf057e043b$export$38c429987e42f36d), {}),
                    isMfaEnabled && !user?.isSSOUser && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $fcda5457412eb931$export$9c5bcd9a18290ca), {}),
                    hasRealUserPermission((0, $ca0941499cca84bb$export$3bccc9c7f40c5944)) && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $a75ae18ee5070016$export$a0a9e641e89cc209), {})
                ]
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("p", {
                className: "marginTop greyText",
                children: [
                    "Version ",
                    (0, $23ce4363775f3dc0$exports.version)
                ]
            })
        ]
    });
};





parcelRequire("fgmOP");
var $53a8029868ca60e7$exports = {};
$53a8029868ca60e7$exports = "mutation requestAccess($user:RequestAccessInput){requestAccess(user:$user){...userFragment}}fragment userFragment on User{id cognitoId firstName lastName phone email description permissions type userAccessStatusType customerId comment roles rolesMap{resource roles permissions}isSSOUser mfaOptions{sms{enabled phone}app{enabled}}}";











const $b62acf8d39a5fde5$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("RequestAccess", "INFO");
const $b62acf8d39a5fde5$export$1d2aed8298752ccc = ()=>{
    const { loadingUser: loadingUser, realUser: realUser, hasRealUserPermission: hasRealUserPermission, logout: logout } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)({
        isEditing: true,
        initialEntity: realUser
    });
    const requestAccess = (0, $6cbfdbba46e9faf5$export$f2b4a60791265356)((0, $d155419fd10bd2b6$export$72e4926bf8358653)((0, (/*@__PURE__*/$parcel$interopDefault($53a8029868ca60e7$exports)))));
    const onRequest = ()=>{
        const { firstName: firstName, lastName: lastName, email: email, phone: phone, description: description } = formState.entityAs();
        requestAccess({
            loadingText: "Requesting access...",
            successText: "Access requested",
            variables: {
                user: {
                    firstName: firstName,
                    lastName: lastName,
                    email: email,
                    phone: phone,
                    description: description || ""
                }
            },
            update: (proxy, { data: data })=>{
                // Force reload to refetch user
                window.location.href = $e9a95c61c800ecd2$export$ff09b90989b21a8;
            }
        });
    };
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                subtitle: "Request Access to Telia Bulk Messaging Web"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "request-access"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                children: "To get access to Telia Bulk Messaging Web please enter your information as well as specify a reason to get access and what role you will fulfill."
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $2e4c8094e1930e9a$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ab8010b3a2c3a452$export$1409e1ddd63aa01b), {
                        formState: formState
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                text: "Request Access",
                                kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary,
                                onClick: onRequest
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                text: "Back to Startpage",
                                kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.cancel,
                                onClick: logout
                            })
                        ]
                    })
                ]
            })
        ]
    });
};





var $l8GLF = parcelRequire("l8GLF");
const $f549842215bcb7a8$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("App", "INFO");
const $f549842215bcb7a8$export$a46e88afcd7e1319 = (_)=>{
    const location = (0, $dfdceb7c36fce96f$export$45d76561a5302f2b)();
    const { formatWithBrand: formatWithBrand } = $e9a95c61c800ecd2$export$680db29e9b4883e6();
    const { user: user } = (0, $4ef4d658949bf0e9$export$23bbbc4533528f03)();
    const LoginFc = ()=>{
        (0, $fgmOP.useEffect)(()=>{
            const loginUri = `${(0, $f5d0c2a7498ff49b$exports.urlPaths).LOGIN}${location.search}`;
            $f549842215bcb7a8$var$log.info("Redirect browser (backend GET) to: ", loginUri);
            window.location.href = loginUri; /*hit the backend*/ 
        });
        return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $d7d83d70b2cd6f85$export$2e2bcd8739ae039), {});
    };
    $f549842215bcb7a8$var$log.debug("render", location);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9a89c88ae55065be$export$a68d8bfe77b35dab), {}),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $0dc584b94bbc2102$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $557d7e86a7a00a80$export$2e2bcd8739ae039), {
                size: "large",
                className: "form--compact",
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $b60bd97a1f982072$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $dfdceb7c36fce96f$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $25887dbff4a0e1e1$export$c4b3fb0689333860), {}),
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: $e9a95c61c800ecd2$export$ebba33cd31d6b30c,
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$444b3ab0cb9aec40), {
                                            replace: true,
                                            to: formatWithBrand($e9a95c61c800ecd2$export$5410ffbe3babddcb)
                                        })
                                    }),
                                    [
                                        $e9a95c61c800ecd2$export$a08784a3004fa57e,
                                        $e9a95c61c800ecd2$export$844e157d47c2ab60
                                    ].map((path)=>/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                            path: path,
                                            element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6cd30cb5db77b431$export$9539337f23792ff0), {})
                                        }, path)),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: $e9a95c61c800ecd2$export$5410ffbe3babddcb,
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $28bcf080945e3814$export$ab18d90c247c65f4), {})
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: $e9a95c61c800ecd2$export$80abc9f9ce9de04c + "/*",
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $8e40c2561f1c547f$export$371eacf23b8ce55b), {})
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: $e9a95c61c800ecd2$export$257fa15708996d38 + "/*",
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $937d189e5cd22c3e$export$7927449317d07e5c), {})
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: $e9a95c61c800ecd2$export$e3d31417f21c1ce7 + "/*",
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c1bef258c4da3159$export$31d3110523b60403), {})
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                        path: $e9a95c61c800ecd2$export$2793f93164573ad + "/*",
                                        element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b38e0598fd01d43$export$1985a9f1ec98aaa5), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                path: $e9a95c61c800ecd2$export$6b504632b4cea2e8 + "/*",
                                element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $8169138e1cbfd71d$export$22c59631e6c46e5a), {})
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                path: $e9a95c61c800ecd2$export$b2e11634d600f33e,
                                element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $1779cb5c0b7a93cf$export$c7a1df07a9ed91ad), {})
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                path: $e9a95c61c800ecd2$export$ff09b90989b21a8,
                                element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $4694ee00a1536bcb$export$d4415139ac509692), {})
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                path: $e9a95c61c800ecd2$export$eed606b4351295d7,
                                element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)(LoginFc, {})
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                path: $e9a95c61c800ecd2$export$c71c29f33fa7576a,
                                element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $f79b987821d4b4ca$export$c6c17a9b4d06c1), {})
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                path: $e9a95c61c800ecd2$export$212905122e5ccd9e,
                                element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c4840f1b64d4c34e$export$1ee4848b33ad558a), {})
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                path: $e9a95c61c800ecd2$export$a7c5707626fc90f,
                                element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $2570513f2d07519e$export$6715b713e0327f9f), {})
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                path: $e9a95c61c800ecd2$export$9b5625cb178fcc5d,
                                element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $abcc0b9b07b77c66$export$6533858383d32124), {
                                    isDisplayed: !user || user.userAccessStatusType === (0, $l8GLF.UserAccessStatusType).APPLYING,
                                    navigateTo: $e9a95c61c800ecd2$export$a7c5707626fc90f,
                                    children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $b62acf8d39a5fde5$export$1d2aed8298752ccc), {})
                                })
                            })
                        ]
                    })
                }, location.pathname)
            })
        ]
    });
};





function $a68a73fcce1c801b$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $a68a73fcce1c801b$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a68a73fcce1c801b$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a68a73fcce1c801b$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a68a73fcce1c801b$var$_arrayLikeToArray(o, minLen);
}
function $a68a73fcce1c801b$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a68a73fcce1c801b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $a68a73fcce1c801b$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $a68a73fcce1c801b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $a68a73fcce1c801b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// === Symbol Support ===
var $a68a73fcce1c801b$var$hasSymbols = function() {
    return typeof Symbol === "function";
};
var $a68a73fcce1c801b$var$hasSymbol = function(name) {
    return $a68a73fcce1c801b$var$hasSymbols() && Boolean(Symbol[name]);
};
var $a68a73fcce1c801b$var$getSymbol = function(name) {
    return $a68a73fcce1c801b$var$hasSymbol(name) ? Symbol[name] : "@@" + name;
};
if ($a68a73fcce1c801b$var$hasSymbols() && !$a68a73fcce1c801b$var$hasSymbol("observable")) Symbol.observable = Symbol("observable");
var $a68a73fcce1c801b$var$SymbolIterator = $a68a73fcce1c801b$var$getSymbol("iterator");
var $a68a73fcce1c801b$var$SymbolObservable = $a68a73fcce1c801b$var$getSymbol("observable");
var $a68a73fcce1c801b$var$SymbolSpecies = $a68a73fcce1c801b$var$getSymbol("species"); // === Abstract Operations ===
function $a68a73fcce1c801b$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== "function") throw new TypeError(value + " is not a function");
    return value;
}
function $a68a73fcce1c801b$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$a68a73fcce1c801b$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $a68a73fcce1c801b$export$77cea355fa80b5f4;
}
function $a68a73fcce1c801b$var$isObservable(x) {
    return x instanceof $a68a73fcce1c801b$export$77cea355fa80b5f4; // SPEC: Brand check
}
function $a68a73fcce1c801b$var$hostReportError(e) {
    if ($a68a73fcce1c801b$var$hostReportError.log) $a68a73fcce1c801b$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $a68a73fcce1c801b$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $a68a73fcce1c801b$var$hostReportError(e);
        }
    });
}
function $a68a73fcce1c801b$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === "function") cleanup();
        else {
            var unsubscribe = $a68a73fcce1c801b$var$getMethod(cleanup, "unsubscribe");
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $a68a73fcce1c801b$var$hostReportError(e);
    }
}
function $a68a73fcce1c801b$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = "closed";
}
function $a68a73fcce1c801b$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = "ready";
    for(var i = 0; i < queue.length; ++i){
        $a68a73fcce1c801b$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === "closed") break;
    }
}
function $a68a73fcce1c801b$var$notifySubscription(subscription, type, value) {
    subscription._state = "running";
    var observer = subscription._observer;
    try {
        var m = $a68a73fcce1c801b$var$getMethod(observer, type);
        switch(type){
            case "next":
                if (m) m.call(observer, value);
                break;
            case "error":
                $a68a73fcce1c801b$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case "complete":
                $a68a73fcce1c801b$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $a68a73fcce1c801b$var$hostReportError(e);
    }
    if (subscription._state === "closed") $a68a73fcce1c801b$var$cleanupSubscription(subscription);
    else if (subscription._state === "running") subscription._state = "ready";
}
function $a68a73fcce1c801b$var$onNotify(subscription, type, value) {
    if (subscription._state === "closed") return;
    if (subscription._state === "buffering") {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== "ready") {
        subscription._state = "buffering";
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $a68a73fcce1c801b$var$enqueue(function() {
            return $a68a73fcce1c801b$var$flushSubscription(subscription);
        });
        return;
    }
    $a68a73fcce1c801b$var$notifySubscription(subscription, type, value);
}
var $a68a73fcce1c801b$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = "initializing";
        var subscriptionObserver = new $a68a73fcce1c801b$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === "initializing") this._state = "ready";
    }
    var _proto = Subscription.prototype;
    _proto.unsubscribe = function unsubscribe() {
        if (this._state !== "closed") {
            $a68a73fcce1c801b$var$closeSubscription(this);
            $a68a73fcce1c801b$var$cleanupSubscription(this);
        }
    };
    $a68a73fcce1c801b$var$_createClass(Subscription, [
        {
            key: "closed",
            get: function() {
                return this._state === "closed";
            }
        }
    ]);
    return Subscription;
}();
var $a68a73fcce1c801b$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    var _proto2 = SubscriptionObserver.prototype;
    _proto2.next = function next(value) {
        $a68a73fcce1c801b$var$onNotify(this._subscription, "next", value);
    };
    _proto2.error = function error(value) {
        $a68a73fcce1c801b$var$onNotify(this._subscription, "error", value);
    };
    _proto2.complete = function complete() {
        $a68a73fcce1c801b$var$onNotify(this._subscription, "complete");
    };
    $a68a73fcce1c801b$var$_createClass(SubscriptionObserver, [
        {
            key: "closed",
            get: function() {
                return this._subscription._state === "closed";
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $a68a73fcce1c801b$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        if (!(this instanceof Observable)) throw new TypeError("Observable cannot be called as a function");
        if (typeof subscriber !== "function") throw new TypeError("Observable initializer must be a function");
        this._subscriber = subscriber;
    }
    var _proto3 = Observable.prototype;
    _proto3.subscribe = function subscribe(observer) {
        if (typeof observer !== "object" || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new $a68a73fcce1c801b$var$Subscription(observer, this._subscriber);
    };
    _proto3.forEach = function forEach(fn) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (typeof fn !== "function") {
                reject(new TypeError(fn + " is not a function"));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            var subscription = _this.subscribe({
                next: function(value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    _proto3.map = function map(fn) {
        var _this2 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $a68a73fcce1c801b$var$getSpecies(this);
        return new C(function(observer) {
            return _this2.subscribe({
                next: function(value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.filter = function filter(fn) {
        var _this3 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $a68a73fcce1c801b$var$getSpecies(this);
        return new C(function(observer) {
            return _this3.subscribe({
                next: function(value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.reduce = function reduce(fn) {
        var _this4 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $a68a73fcce1c801b$var$getSpecies(this);
        var hasSeed = arguments.length > 1;
        var hasValue = false;
        var seed = arguments[1];
        var acc = seed;
        return new C(function(observer) {
            return _this4.subscribe({
                next: function(value) {
                    var first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError("Cannot reduce an empty sequence"));
                    observer.next(acc);
                    observer.complete();
                }
            });
        });
    };
    _proto3.concat = function concat() {
        var _this5 = this;
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
        var C = $a68a73fcce1c801b$var$getSpecies(this);
        return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next: function(v) {
                        observer.next(v);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(_this5);
            return function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    };
    _proto3.flatMap = function flatMap(fn) {
        var _this6 = this;
        if (typeof fn !== "function") throw new TypeError(fn + " is not a function");
        var C = $a68a73fcce1c801b$var$getSpecies(this);
        return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
                next: function(value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    var inner = C.from(value).subscribe({
                        next: function(value) {
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            var i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return function() {
                subscriptions.forEach(function(s) {
                    return s.unsubscribe();
                });
                outer.unsubscribe();
            };
        });
    };
    _proto3[$a68a73fcce1c801b$var$SymbolObservable] = function() {
        return this;
    };
    Observable.from = function from(x) {
        var C = typeof this === "function" ? this : Observable;
        if (x == null) throw new TypeError(x + " is not an object");
        var method = $a68a73fcce1c801b$var$getMethod(x, $a68a73fcce1c801b$var$SymbolObservable);
        if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + " is not an object");
            if ($a68a73fcce1c801b$var$isObservable(observable) && observable.constructor === C) return observable;
            return new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        if ($a68a73fcce1c801b$var$hasSymbol("iterator")) {
            method = $a68a73fcce1c801b$var$getMethod(x, $a68a73fcce1c801b$var$SymbolIterator);
            if (method) return new C(function(observer) {
                $a68a73fcce1c801b$var$enqueue(function() {
                    if (observer.closed) return;
                    for(var _iterator = $a68a73fcce1c801b$var$_createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;){
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C(function(observer) {
            $a68a73fcce1c801b$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + " is not observable");
    };
    Observable.of = function of() {
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        var C = typeof this === "function" ? this : Observable;
        return new C(function(observer) {
            $a68a73fcce1c801b$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    };
    $a68a73fcce1c801b$var$_createClass(Observable, null, [
        {
            key: $a68a73fcce1c801b$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
if ($a68a73fcce1c801b$var$hasSymbols()) Object.defineProperty($a68a73fcce1c801b$export$77cea355fa80b5f4, Symbol("extensions"), {
    value: {
        symbol: $a68a73fcce1c801b$var$SymbolObservable,
        hostReportError: $a68a73fcce1c801b$var$hostReportError
    },
    configurable: true
});


parcelRequire("iQvaa");
// The zen-observable package defines Observable.prototype[Symbol.observable]
// when Symbol is supported, but RxJS interop depends on also setting this fake
// '@@observable' string as a polyfill for Symbol.observable.
var $34a698a74d54a7de$var$prototype = (0, $a68a73fcce1c801b$export$77cea355fa80b5f4).prototype;
var $34a698a74d54a7de$var$fakeObsSymbol = "@@observable";
if (!$34a698a74d54a7de$var$prototype[$34a698a74d54a7de$var$fakeObsSymbol]) // @ts-expect-error
$34a698a74d54a7de$var$prototype[$34a698a74d54a7de$var$fakeObsSymbol] = function() {
    return this;
};



function $2fcf941a6c0dc784$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, starting);
    var setContext = function(next) {
        if (typeof next === "function") context = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, context), next(context));
        else context = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, context), next);
    };
    var getContext = function() {
        return (0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, context);
    };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    return operation;
}


function $8c077bba39ad0833$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    // Best guess at an operation name
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== "string" ? (0, $d34613b28fb40239$export$41bca9dc6871dd4e)(transformedOperation.query) || undefined : "";
    return transformedOperation;
}


function $7c30dba9bd50fcf6$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context"
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw (0, $57583217334b5278$export$3991762405098ea)(43, key);
    }
    return operation;
}


function $e7fcb7cc7e563d46$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, $a68a73fcce1c801b$export$77cea355fa80b5f4).of();
}
function $e7fcb7cc7e563d46$var$toLink(handler) {
    return typeof handler === "function" ? new $e7fcb7cc7e563d46$export$2fed3d61f740bc7f(handler) : handler;
}
function $e7fcb7cc7e563d46$var$isTerminating(link) {
    return link.request.length <= 1;
}
var $e7fcb7cc7e563d46$export$2fed3d61f740bc7f = /** @class */ function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, $a68a73fcce1c801b$export$77cea355fa80b5f4).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map($e7fcb7cc7e563d46$var$toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = $e7fcb7cc7e563d46$var$toLink(left);
        var rightLink = $e7fcb7cc7e563d46$var$toLink(right || new ApolloLink($e7fcb7cc7e563d46$var$passthrough));
        var ret;
        if ($e7fcb7cc7e563d46$var$isTerminating(leftLink) && $e7fcb7cc7e563d46$var$isTerminating(rightLink)) ret = new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, $a68a73fcce1c801b$export$77cea355fa80b5f4).of() : rightLink.request(operation) || (0, $a68a73fcce1c801b$export$77cea355fa80b5f4).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, $a68a73fcce1c801b$export$77cea355fa80b5f4).of() : rightLink.request(operation, forward) || (0, $a68a73fcce1c801b$export$77cea355fa80b5f4).of();
        });
        return Object.assign(ret, {
            left: leftLink,
            right: rightLink
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, $2fcf941a6c0dc784$export$f29bedd62f56fcb2)(operation.context, (0, $8c077bba39ad0833$export$4f3f7df1b558c729)((0, $7c30dba9bd50fcf6$export$a92a48117d546c9)(operation)))) || (0, $a68a73fcce1c801b$export$77cea355fa80b5f4).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = $e7fcb7cc7e563d46$var$toLink(first);
        if ($e7fcb7cc7e563d46$var$isTerminating(firstLink)) {
            globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).warn(35, firstLink);
            return firstLink;
        }
        var nextLink = $e7fcb7cc7e563d46$var$toLink(second);
        var ret;
        if ($e7fcb7cc7e563d46$var$isTerminating(nextLink)) ret = new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, $a68a73fcce1c801b$export$77cea355fa80b5f4).of();
            }) || (0, $a68a73fcce1c801b$export$77cea355fa80b5f4).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, $a68a73fcce1c801b$export$77cea355fa80b5f4).of();
            }) || (0, $a68a73fcce1c801b$export$77cea355fa80b5f4).of();
        });
        return Object.assign(ret, {
            left: firstLink,
            right: nextLink
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink($e7fcb7cc7e563d46$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw (0, $57583217334b5278$export$3991762405098ea)(36);
    };
    ApolloLink.prototype.onError = function(error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            // Returning false indicates that observer.error does not need to be
            // called again, since it was already called (on the previous line).
            // Calling observer.error again would not cause any real problems,
            // since only the first call matters, but custom onError functions
            // might have other reasons for wanting to prevent the default
            // behavior by returning false.
            return false;
        }
        // Throw errors will be passed to observer.error.
        throw error;
    };
    ApolloLink.prototype.setOnError = function(fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();


var $fc0c11c3044842d0$export$51396ec711da548b = (0, $e7fcb7cc7e563d46$export$2fed3d61f740bc7f).execute;













const $b5d0850d22ba2059$export$a89c95c098ac2a58 = Object.freeze({});
function $b5d0850d22ba2059$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $74a6e38a6e060a30$export$4fcd777a40ccf407)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $addc2f9aaa51cfa5$export$a84bdc57c5122798)))enterLeaveMap.set(kind, $b5d0850d22ba2059$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $74a6e38a6e060a30$export$8ee0fc9ee280b4ee)(node) || (0, $7df4851cf7a690ac$export$b6cb5906f04696c8)(false, `Invalid AST Node: ${(0, $3ce4887891173cd9$export$9dec5d1b3b6a130d)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $b5d0850d22ba2059$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $74a6e38a6e060a30$export$8ee0fc9ee280b4ee)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $b5d0850d22ba2059$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $addc2f9aaa51cfa5$export$a84bdc57c5122798))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $b5d0850d22ba2059$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $b5d0850d22ba2059$export$a89c95c098ac2a58) skipping[i] = $b5d0850d22ba2059$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $b5d0850d22ba2059$export$a89c95c098ac2a58) skipping[i] = $b5d0850d22ba2059$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $b5d0850d22ba2059$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === "object") // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === "function") // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $b5d0850d22ba2059$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $b5d0850d22ba2059$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}


function $d474a5d9bfbef507$export$3dc388a5f013b4a5(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) return true;
    return $d474a5d9bfbef507$export$b7bdffb7e6f1ef53(directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue = variables && variables[ifArgument.value.name.value];
            (0, $57583217334b5278$export$f5708dca728d7177)(evaledValue !== void 0, 67, directive.name.value);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function $d474a5d9bfbef507$export$1b217de6ce18b9a(root) {
    var names = [];
    (0, $b5d0850d22ba2059$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
var $d474a5d9bfbef507$export$528b5e7d8ba07fbf = function(names, root) {
    return $d474a5d9bfbef507$export$2dafb573e282fe8d(names, root, false);
};
var $d474a5d9bfbef507$export$ad1b63b26c1a9b76 = function(names, root) {
    return $d474a5d9bfbef507$export$2dafb573e282fe8d(names, root, true);
};
function $d474a5d9bfbef507$export$2dafb573e282fe8d(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0, $b5d0850d22ba2059$export$bf638b60ea8b89b7)(root, {
        Directive: function(node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) return 0, $b5d0850d22ba2059$export$a89c95c098ac2a58;
        }
    });
    // If we found all the names, nameSet will be empty. If we only care about
    // finding some of them, the < condition is sufficient.
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function $d474a5d9bfbef507$export$8d1e9e5bbfa5d09a(document) {
    return document && $d474a5d9bfbef507$export$2dafb573e282fe8d([
        "client",
        "export"
    ], document, true);
}
function $d474a5d9bfbef507$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function $d474a5d9bfbef507$export$b7bdffb7e6f1ef53(directives) {
    var result = [];
    if (directives && directives.length) directives.forEach(function(directive) {
        if (!$d474a5d9bfbef507$var$isInclusionDirective(directive)) return;
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $57583217334b5278$export$f5708dca728d7177)(directiveArguments && directiveArguments.length === 1, 68, directiveName);
        var ifArgument = directiveArguments[0];
        (0, $57583217334b5278$export$f5708dca728d7177)(ifArgument.name && ifArgument.name.value === "if", 69, directiveName);
        var ifValue = ifArgument.value;
        // means it has to be a variable value if this is a valid @skip or @include directive
        (0, $57583217334b5278$export$f5708dca728d7177)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 70, directiveName);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}








var $99a4544cb26a0024$var$TYPENAME_FIELD = {
    kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).FIELD,
    name: {
        kind: (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).NAME,
        value: "__typename"
    }
};
function $99a4544cb26a0024$var$isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function(selection) {
        return selection.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).FRAGMENT_SPREAD && $99a4544cb26a0024$var$isEmpty(fragmentMap[selection.name.value], fragmentMap);
    });
}
function $99a4544cb26a0024$var$nullIfDocIsEmpty(doc) {
    return $99a4544cb26a0024$var$isEmpty((0, $d34613b28fb40239$export$7a5b1fa979d2c158)(doc) || (0, $d34613b28fb40239$export$772111caef41b3f5)(doc), (0, $73d0a56999265e6c$export$193789b4c8246dd4)((0, $d34613b28fb40239$export$5320a7ba9466a3df)(doc))) ? null : doc;
}
function $99a4544cb26a0024$var$getDirectiveMatcher(configs) {
    var names = new Map();
    var tests = new Map();
    configs.forEach(function(directive) {
        if (directive) {
            if (directive.name) names.set(directive.name, directive);
            else if (directive.test) tests.set(directive.test, directive);
        }
    });
    return function(directive) {
        var config = names.get(directive.name.value);
        if (!config && tests.size) tests.forEach(function(testConfig, test) {
            if (test(directive)) config = testConfig;
        });
        return config;
    };
}
function $99a4544cb26a0024$var$makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) key = defaultKey;
        var inUse = map.get(key);
        if (!inUse) map.set(key, inUse = {
            // Variable and fragment spread names used directly within this
            // operation or fragment definition, as identified by key. These sets
            // will be populated during the first traversal of the document in
            // removeDirectivesFromDocument below.
            variables: new Set(),
            fragmentSpreads: new Set()
        });
        return inUse;
    };
}
function $99a4544cb26a0024$export$e5ae0530da5fe96c(directives, doc) {
    (0, $d34613b28fb40239$export$a7d0d8111d2386df)(doc);
    // Passing empty strings to makeInUseGetterFunction means we handle anonymous
    // operations as if their names were "". Anonymous fragment definitions are
    // not supposed to be possible, but the same default naming strategy seems
    // appropriate for that case as well.
    var getInUseByOperationName = $99a4544cb26a0024$var$makeInUseGetterFunction("");
    var getInUseByFragmentName = $99a4544cb26a0024$var$makeInUseGetterFunction("");
    var getInUse = function(ancestors) {
        for(var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p){
            if ((0, $93b6d5db950815ab$export$43bee75e5e14138e)(ancestor)) continue;
            if (ancestor.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).OPERATION_DEFINITION) // If an operation is anonymous, we use the empty string as its key.
            return getInUseByOperationName(ancestor.name && ancestor.name.value);
            if (ancestor.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).FRAGMENT_DEFINITION) return getInUseByFragmentName(ancestor.name.value);
        }
        globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).error(83);
        return null;
    };
    var operationCount = 0;
    for(var i = doc.definitions.length - 1; i >= 0; --i)if (doc.definitions[i].kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).OPERATION_DEFINITION) ++operationCount;
    var directiveMatcher = $99a4544cb26a0024$var$getDirectiveMatcher(directives);
    var shouldRemoveField = function(nodeDirectives) {
        return (0, $93b6d5db950815ab$export$d307f5934e447d0e)(nodeDirectives) && nodeDirectives.map(directiveMatcher).some(function(config) {
            return config && config.remove;
        });
    };
    var originalFragmentDefsByPath = new Map();
    // Any time the first traversal of the document below makes a change like
    // removing a fragment (by returning null), this variable should be set to
    // true. Once it becomes true, it should never be set to false again. If this
    // variable remains false throughout the traversal, then we can return the
    // original doc immediately without any modifications.
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function(node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        }
    };
    var docWithoutDirectiveSubtrees = (0, $b5d0850d22ba2059$export$bf638b60ea8b89b7)(doc, {
        // These two AST node types share the same implementation, defined above.
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function() {
                // VariableDefinition nodes do not count as variables in use, though
                // they do contain Variable nodes that might be visited below. To avoid
                // counting variable declarations as usages, we skip visiting the
                // contents of this VariableDefinition node by returning false.
                return false;
            }
        },
        Variable: {
            enter: function(node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) inUse.variables.add(node.name.value);
            }
        },
        FragmentSpread: {
            enter: function(node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) inUse.fragmentSpreads.add(node.name.value);
            // We might like to remove this FragmentSpread by returning null here if
            // the corresponding FragmentDefinition node is also going to be removed
            // by the logic below, but we can't control the relative order of those
            // events, so we have to postpone the removal of dangling FragmentSpread
            // nodes until after the current visit of the document has finished.
            }
        },
        FragmentDefinition: {
            enter: function(node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function(node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) // If the FragmentNode received by this leave function is identical to
                // the one received by the corresponding enter function (above), then
                // the visitor must not have made any changes within this
                // FragmentDefinition node. This fragment definition may still be
                // removed if there are no ...spread references to it, but it won't be
                // removed just because it has only a __typename field.
                return node;
                if (// This logic applies only if the document contains one or more
                // operations, since removing all fragments from a document containing
                // only fragments makes the document useless.
                operationCount > 0 && node.selectionSet.selections.every(function(selection) {
                    return selection.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).FIELD && selection.name.value === "__typename";
                })) {
                    // This is a somewhat opinionated choice: if a FragmentDefinition ends
                    // up having no fields other than __typename, we remove the whole
                    // fragment definition, and later prune ...spread references to it.
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        },
        Directive: {
            leave: function(node) {
                // If a matching directive is found, remove the directive itself. Note
                // that this does not remove the target (field, argument, etc) of the
                // directive, but only the directive itself.
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        }
    });
    if (!firstVisitMadeChanges) // If our first pass did not change anything about the document, then there
    // is no cleanup we need to do, and we can return the original doc.
    return doc;
    // Utility for making sure inUse.transitiveVars is recursively populated.
    // Because this logic assumes inUse.fragmentSpreads has been completely
    // populated and inUse.removed has been set if appropriate,
    // populateTransitiveVars must be called after that information has been
    // collected by the first traversal of the document.
    var populateTransitiveVars = function(inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) inUse.fragmentSpreads.forEach(function(childFragmentName) {
                populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function(varName) {
                    inUse.transitiveVars.add(varName);
                });
            });
        }
        return inUse;
    };
    // Since we've been keeping track of fragment spreads used by particular
    // operations and fragment definitions, we now need to compute the set of all
    // spreads used (transitively) by any operations in the document.
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function(def) {
        if (def.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).OPERATION_DEFINITION) populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
        else if (def.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
        // definitions count as usages of their own fragment names. This heuristic
        // prevents accidentally removing all fragment definitions from the
        // document just because it contains no operations that use the fragments.
        operationCount === 0 && !getInUseByFragmentName(def.name.value).removed) allFragmentNamesUsed.add(def.name.value);
    });
    // Now that we have added all fragment spreads used by operations to the
    // allFragmentNamesUsed set, we can complete the set by transitively adding
    // all fragment spreads used by those fragments, and so on.
    allFragmentNamesUsed.forEach(function(fragmentName) {
        // Once all the childFragmentName strings added here have been seen already,
        // the top-level allFragmentNamesUsed.forEach loop will terminate.
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function(fragmentName) {
        return !!// A fragment definition will be removed if there are no spreads that refer
        // to it, or the fragment was explicitly removed because it had no fields
        // other than __typename.
        (!allFragmentNamesUsed.has(fragmentName) || getInUseByFragmentName(fragmentName).removed);
    };
    var enterVisitor = {
        enter: function(node) {
            if (fragmentWillBeRemoved(node.name.value)) return null;
        }
    };
    return $99a4544cb26a0024$var$nullIfDocIsEmpty((0, $b5d0850d22ba2059$export$bf638b60ea8b89b7)(docWithoutDirectiveSubtrees, {
        // If the fragment is going to be removed, then leaving any dangling
        // FragmentSpread nodes with the same name would be a mistake.
        FragmentSpread: enterVisitor,
        // This is where the fragment definition is actually removed.
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function(node) {
                // Upon leaving each operation in the depth-first AST traversal, prune
                // any variables that are declared by the operation but unused within.
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(// If an operation is anonymous, we use the empty string as its key.
                    getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    // According to the GraphQL spec, all variables declared by an
                    // operation must either be used by that operation or used by some
                    // fragment included transitively into that operation:
                    // https://spec.graphql.org/draft/#sec-All-Variables-Used
                    //
                    // To stay on the right side of this validation rule, if/when we
                    // remove the last $var references from an operation or its fragments,
                    // we must also remove the corresponding $var declaration from the
                    // enclosing operation. This pruning applies only to operations and
                    // not fragment definitions, at the moment. Fragments may be able to
                    // declare variables eventually, but today they can only consume them.
                    if (usedVariableNames_1.size < node.variableDefinitions.length) return (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return usedVariableNames_1.has(varDef.variable.name.value);
                        })
                    });
                }
            }
        }
    }));
}
var $99a4544cb26a0024$export$43b332f87950a467 = Object.assign(function(doc) {
    return (0, $b5d0850d22ba2059$export$bf638b60ea8b89b7)(doc, {
        SelectionSet: {
            enter: function(node, _key, parent) {
                // Don't add __typename to OperationDefinitions.
                if (parent && parent.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).OPERATION_DEFINITION) return;
                // No changes if no selections.
                var selections = node.selections;
                if (!selections) return;
                // If selections already have a __typename, or are part of an
                // introspection query, do nothing.
                var skip = selections.some(function(selection) {
                    return (0, $4ab7359740364a58$export$fb56ad75dd311c12)(selection) && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
                });
                if (skip) return;
                // If this SelectionSet is @export-ed as an input variable, it should
                // not have a __typename field (see issue #4691).
                var field = parent;
                if ((0, $4ab7359740364a58$export$fb56ad75dd311c12)(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === "export";
                })) return;
                // Create and return a new SelectionSet with a __typename Field.
                return (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, node), {
                    selections: (0, $e2e041e4a1657497$export$1216008129fb82ed)((0, $e2e041e4a1657497$export$1216008129fb82ed)([], selections, true), [
                        $99a4544cb26a0024$var$TYPENAME_FIELD
                    ], false)
                });
            }
        }
    });
}, {
    added: function(field) {
        return field === $99a4544cb26a0024$var$TYPENAME_FIELD;
    }
});
var $99a4544cb26a0024$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) {
            if (!directive.arguments || !directive.arguments.some(function(arg) {
                return arg.name.value === "key";
            })) globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).warn(84);
        }
        return willRemove;
    }
};
function $99a4544cb26a0024$export$74985f3324559867(doc) {
    return $99a4544cb26a0024$export$e5ae0530da5fe96c([
        $99a4544cb26a0024$var$connectionRemoveConfig
    ], (0, $d34613b28fb40239$export$a7d0d8111d2386df)(doc));
}
function $99a4544cb26a0024$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return !!selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $99a4544cb26a0024$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $99a4544cb26a0024$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!(0, $4ab7359740364a58$export$fb56ad75dd311c12)(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($99a4544cb26a0024$var$getDirectiveMatcher(directives)) || nestedCheck && $99a4544cb26a0024$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $99a4544cb26a0024$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).VARIABLE && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $99a4544cb26a0024$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $99a4544cb26a0024$var$getArgumentMatcher(config);
    return $99a4544cb26a0024$var$nullIfDocIsEmpty((0, $b5d0850d22ba2059$export$bf638b60ea8b89b7)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, node), {
                    // Remove matching top level variables definitions.
                    variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    }) : []
                });
            }
        },
        Field: {
            enter: function(node) {
                // If `remove` is set to true for an argument, and an argument match
                // is found for a field, remove the field as well.
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                // Remove all matching arguments.
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $99a4544cb26a0024$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $99a4544cb26a0024$var$nullIfDocIsEmpty((0, $b5d0850d22ba2059$export$bf638b60ea8b89b7)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $99a4544cb26a0024$export$57c368c23873f32b(document) {
    var definition = (0, $d34613b28fb40239$export$f431198736b7f96d)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") // Already a query, so return the existing document.
    return document;
    // Build a new query using the selection set of the main operation.
    var modifiedDoc = (0, $b5d0850d22ba2059$export$bf638b60ea8b89b7)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, node), {
                    operation: "query"
                });
            }
        }
    });
    return modifiedDoc;
}
function $99a4544cb26a0024$export$8eae69e876ee321e(document) {
    (0, $d34613b28fb40239$export$a7d0d8111d2386df)(document);
    var modifiedDoc = $99a4544cb26a0024$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === "client";
            },
            remove: true
        }
    ], document);
    return modifiedDoc;
}



var $48bc349aae83039c$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = (0, $57583217334b5278$export$3991762405098ea)(39, label, e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};


var $d146137b5964a9a5$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === "function") return fallbackURI(operation);
    else return fallbackURI || "/graphql";
};



/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/index.ts
 */ 
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/async.ts
 */ function $5f93c238d1a3842f$export$2e2bcd8739ae039(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
        next: function() {
            return iterator.next();
        }
    }, _a[Symbol.asyncIterator] = function() {
        return this;
    }, _a;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/nodeStream.ts
 */ 
function $04c33f7f5da7d45d$export$2e2bcd8739ae039(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error) return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) return shiftedArr[0]({
                value: chunk,
                done: false
            });
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[0]({
                value: undefined,
                done: true
            });
        });
        !cleanup || cleanup();
    }
    cleanup = function() {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function(resolve, reject) {
            if (error) return reject(error);
            if (data.length) return resolve({
                value: data.shift(),
                done: false
            });
            if (done) return resolve({
                value: undefined,
                done: true
            });
            waiting.push([
                resolve,
                reject
            ]);
        });
    }
    var iterator = {
        next: function() {
            return getNext();
        }
    };
    if (0, $9865fa0c1163b711$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/promise.ts
 */ 
function $3991fb2672d2725b$export$2e2bcd8739ae039(promise) {
    var resolved = false;
    var iterator = {
        next: function() {
            if (resolved) return Promise.resolve({
                value: undefined,
                done: true
            });
            resolved = true;
            return new Promise(function(resolve, reject) {
                promise.then(function(value) {
                    resolve({
                        value: value,
                        done: false
                    });
                }).catch(reject);
            });
        }
    };
    if (0, $9865fa0c1163b711$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/reader.ts
 */ 
function $a3ae42d8121880b4$export$2e2bcd8739ae039(reader) {
    var iterator = {
        next: function() {
            return reader.read();
        }
    };
    if (0, $9865fa0c1163b711$export$c34f882e9f1c1637) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}


function $4dd5b2adc602d048$var$isNodeResponse(value) {
    return !!value.body;
}
function $4dd5b2adc602d048$var$isReadableStream(value) {
    return !!value.getReader;
}
function $4dd5b2adc602d048$var$isAsyncIterableIterator(value) {
    return !!((0, $9865fa0c1163b711$export$c34f882e9f1c1637) && value[Symbol.asyncIterator]);
}
function $4dd5b2adc602d048$var$isStreamableBlob(value) {
    return !!value.stream;
}
function $4dd5b2adc602d048$var$isBlob(value) {
    return !!value.arrayBuffer;
}
function $4dd5b2adc602d048$var$isNodeReadableStream(value) {
    return !!value.pipe;
}
function $4dd5b2adc602d048$export$7e4ac9ed9577f145(response) {
    var body = response;
    if ($4dd5b2adc602d048$var$isNodeResponse(response)) body = response.body;
    if ($4dd5b2adc602d048$var$isAsyncIterableIterator(body)) return (0, $5f93c238d1a3842f$export$2e2bcd8739ae039)(body);
    if ($4dd5b2adc602d048$var$isReadableStream(body)) return (0, $a3ae42d8121880b4$export$2e2bcd8739ae039)(body.getReader());
    // this errors without casting to ReadableStream<T>
    // because Blob.stream() returns a NodeJS ReadableStream
    if ($4dd5b2adc602d048$var$isStreamableBlob(body)) return (0, $a3ae42d8121880b4$export$2e2bcd8739ae039)(body.stream().getReader());
    if ($4dd5b2adc602d048$var$isBlob(body)) return (0, $3991fb2672d2725b$export$2e2bcd8739ae039)(body.arrayBuffer());
    if ($4dd5b2adc602d048$var$isNodeReadableStream(body)) return (0, $04c33f7f5da7d45d$export$2e2bcd8739ae039)(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}


var $6e607a927c51df55$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};







var $f042fd543798b697$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $f042fd543798b697$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $f042fd543798b697$export$160070228be94b08(sources);
}
function $f042fd543798b697$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new $f042fd543798b697$export$509e11c221f576c0();
        for(var i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}
var $f042fd543798b697$var$defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
var $f042fd543798b697$export$509e11c221f576c0 = /** @class */ function() {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) reconciler = $f042fd543798b697$var$defaultReconciler;
        this.reconciler = reconciler;
        this.isObject = (0, $a5b286f532530da9$export$417207af72fad9c9);
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function(target, source) {
        var _this = this;
        var context = [];
        for(var _i = 2; _i < arguments.length; _i++)context[_i - 2] = arguments[_i];
        if ((0, $a5b286f532530da9$export$417207af72fad9c9)(source) && (0, $a5b286f532530da9$export$417207af72fad9c9)(target)) {
            Object.keys(source).forEach(function(sourceKey) {
                if ($f042fd543798b697$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0, $e2e041e4a1657497$export$1216008129fb82ed)([
                            target,
                            source,
                            sourceKey
                        ], context, false));
                        // A well-implemented reconciler may return targetValue to indicate
                        // the merge changed nothing about the structure of the target.
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    // If there is no collision, the target can safely share memory with
                    // the source, and the recursion can terminate here.
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        // If source (or target) is not an object, let source replace target.
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function(value) {
        if ((0, $a5b286f532530da9$export$417207af72fad9c9)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) value = value.slice(0);
                else value = (0, $e2e041e4a1657497$export$18ce0697a983be9b)({
                    __proto__: Object.getPrototypeOf(value)
                }, value);
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}();


function $2b0bc46d60dcff8e$export$879767c5cdf33cb3(value) {
    return "incremental" in value;
}
function $2b0bc46d60dcff8e$export$6c17a45d8c64ff02(value) {
    return "hasNext" in value && "data" in value;
}
function $2b0bc46d60dcff8e$export$f90dc0a3531b8b83(value) {
    return $2b0bc46d60dcff8e$export$879767c5cdf33cb3(value) || $2b0bc46d60dcff8e$export$6c17a45d8c64ff02(value);
}
function $2b0bc46d60dcff8e$export$3f32b6369f408f33(value) {
    return (0, $a5b286f532530da9$export$417207af72fad9c9)(value) && "payload" in value;
}
function $2b0bc46d60dcff8e$export$9a905f57d6393874(prevResult, result) {
    var mergedData = prevResult;
    var merger = new (0, $f042fd543798b697$export$509e11c221f576c0)();
    if ($2b0bc46d60dcff8e$export$879767c5cdf33cb3(result) && (0, $93b6d5db950815ab$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(_a) {
        var data = _a.data, path = _a.path;
        for(var i = path.length - 1; i >= 0; --i){
            var key = path[i];
            var isNumericKey = !isNaN(+key);
            var parent_1 = isNumericKey ? [] : {};
            parent_1[key] = data;
            data = parent_1;
        }
        mergedData = merger.merge(mergedData, data);
    });
    return mergedData;
}


var $f3a74a0dda3972cf$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $f3a74a0dda3972cf$export$ccb60864026baf09(response, nextValue) {
    return (0, $e2e041e4a1657497$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _a, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
        var _b, _c;
        var _d;
        return (0, $e2e041e4a1657497$export$67ebef60e6f28a6)(this, function(_e) {
            switch(_e.label){
                case 0:
                    if (TextDecoder === undefined) throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    decoder = new TextDecoder("utf-8");
                    contentType = (_d = response.headers) === null || _d === void 0 ? void 0 : _d.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-";
                    boundary = "\r\n--".concat(boundaryVal);
                    buffer = "";
                    iterator = (0, $4dd5b2adc602d048$export$7e4ac9ed9577f145)(response);
                    running = true;
                    _e.label = 1;
                case 1:
                    if (!running) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        iterator.next()
                    ];
                case 2:
                    _a = _e.sent(), value = _a.value, done = _a.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    searchFrom = buffer.length - boundary.length + 1;
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary, searchFrom);
                    while(bi > -1){
                        message = void 0;
                        _b = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length)
                        ], message = _b[0], buffer = _b[1];
                        i = message.indexOf("\r\n\r\n");
                        headers = $f3a74a0dda3972cf$export$eea2c1c5e1a37e50(message.slice(0, i));
                        contentType_1 = headers["content-type"];
                        if (contentType_1 && contentType_1.toLowerCase().indexOf("application/json") === -1) throw new Error("Unsupported patch content type: application/json is required.");
                        body = message.slice(i);
                        if (body) {
                            result = $f3a74a0dda3972cf$export$759bcb35b0d1bf81(response, body);
                            if (Object.keys(result).length > 1 || "data" in result || "incremental" in result || "errors" in result || "payload" in result) {
                                if ((0, $2b0bc46d60dcff8e$export$3f32b6369f408f33)(result)) {
                                    next = {};
                                    if ("payload" in result) {
                                        if (Object.keys(result).length === 1 && result.payload === null) return [
                                            2 /*return*/ 
                                        ];
                                        next = (0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, result.payload);
                                    }
                                    if ("errors" in result) next = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, next), {
                                        extensions: (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, "extensions" in next ? next.extensions : null), (_c = {}, _c[0, $9eab3cada5a2feb5$export$4995664c1b49842e] = result.errors, _c))
                                    });
                                    nextValue(next);
                                } else // for the last chunk with only `hasNext: false`
                                // we don't need to call observer.next as there is no data/errors
                                nextValue(result);
                            } else if (// If the chunk contains only a "hasNext: false", we can call
                            // observer.complete() immediately.
                            Object.keys(result).length === 1 && "hasNext" in result && !result.hasNext) return [
                                2 /*return*/ 
                            ];
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $f3a74a0dda3972cf$export$eea2c1c5e1a37e50(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function(line) {
        var i = line.indexOf(":");
        if (i > -1) {
            // normalize headers to lowercase
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function $f3a74a0dda3972cf$export$759bcb35b0d1bf81(response, bodyText) {
    if (response.status >= 300) {
        // Network error
        var getResult = function() {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                return bodyText;
            }
        };
        (0, $6e607a927c51df55$export$c33ef9219f27efd7)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    } catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function $f3a74a0dda3972cf$export$d3da1ecaf1206c58(err, observer) {
    // if it is a network error, BUT there is graphql result info fire
    // the next observer before calling error this gives apollo-client
    // (and react-apollo) the `graphqlErrors` and `networkErrors` to
    // pass to UI this should only happen if we *also* have data as
    // part of the response key per the spec
    if (err.result && err.result.errors && err.result.data) // if we don't call next, the UI can only show networkError
    // because AC didn't get any graphqlErrors this is graphql
    // execution result info (i.e errors and possibly data) this is
    // because there is no formal spec how errors should translate to
    // http status codes. So an auth error (401) could have both data
    // from a public field, errors from a private field, and a status
    // of 401
    // {
    //  user { // this will have errors
    //    firstName
    //  }
    //  products { // this is public so will have data
    //    cost
    //  }
    // }
    //
    // the result of above *could* look like this:
    // {
    //   data: { products: [{ cost: "$10" }] },
    //   errors: [{
    //      message: 'your session has timed out',
    //      path: []
    //   }]
    // }
    // status code of above would be a 401
    // in the UI you want to show data where you can, errors as data where you can
    // and use correct http status codes
    observer.next(err.result);
    observer.error(err);
}
function $f3a74a0dda3972cf$export$d4051215bea0639f(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            return $f3a74a0dda3972cf$export$759bcb35b0d1bf81(response, bodyText);
        }).then(function(result) {
            if (!Array.isArray(result) && !$f3a74a0dda3972cf$var$hasOwnProperty.call(result, "data") && !$f3a74a0dda3972cf$var$hasOwnProperty.call(result, "errors")) // Data error
            (0, $6e607a927c51df55$export$c33ef9219f27efd7)(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName, "'."));
            return result;
        });
    };
}



var $c7274adfa65ff538$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === "undefined") throw (0, $57583217334b5278$export$3991762405098ea)(37);
};




/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $a2d8d3fc4bda92fc$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($a2d8d3fc4bda92fc$var$escapedRegExp, $a2d8d3fc4bda92fc$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $a2d8d3fc4bda92fc$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $a2d8d3fc4bda92fc$var$escapedReplacer(str) {
    return $a2d8d3fc4bda92fc$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $a2d8d3fc4bda92fc$var$escapeSequences = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    "\\b",
    "\\t",
    "\\n",
    "\\u000B",
    "\\f",
    "\\r",
    "\\u000E",
    "\\u000F",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001A",
    "\\u001B",
    "\\u001C",
    "\\u001D",
    "\\u001E",
    "\\u001F",
    "",
    "",
    '\\"',
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\\\",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "\\u007F",
    "\\u0080",
    "\\u0081",
    "\\u0082",
    "\\u0083",
    "\\u0084",
    "\\u0085",
    "\\u0086",
    "\\u0087",
    "\\u0088",
    "\\u0089",
    "\\u008A",
    "\\u008B",
    "\\u008C",
    "\\u008D",
    "\\u008E",
    "\\u008F",
    "\\u0090",
    "\\u0091",
    "\\u0092",
    "\\u0093",
    "\\u0094",
    "\\u0095",
    "\\u0096",
    "\\u0097",
    "\\u0098",
    "\\u0099",
    "\\u009A",
    "\\u009B",
    "\\u009C",
    "\\u009D",
    "\\u009E",
    "\\u009F"
];



function $85d4a1c182545124$export$c2d084dc44961371(ast) {
    return (0, $b5d0850d22ba2059$export$bf638b60ea8b89b7)(ast, $85d4a1c182545124$var$printDocASTReducer);
}
const $85d4a1c182545124$var$MAX_LINE_LENGTH = 80;
const $85d4a1c182545124$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>"$" + node.name
    },
    // Document
    Document: {
        leave: (node)=>$85d4a1c182545124$var$join(node.definitions, "\n\n")
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $85d4a1c182545124$var$wrap("(", $85d4a1c182545124$var$join(node.variableDefinitions, ", "), ")");
            const prefix = $85d4a1c182545124$var$join([
                node.operation,
                $85d4a1c182545124$var$join([
                    node.name,
                    varDefs
                ]),
                $85d4a1c182545124$var$join(node.directives, " ")
            ], " "); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === "query" ? "" : prefix + " ") + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ": " + type + $85d4a1c182545124$var$wrap(" = ", defaultValue) + $85d4a1c182545124$var$wrap(" ", $85d4a1c182545124$var$join(directives, " "))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$85d4a1c182545124$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $85d4a1c182545124$var$wrap("", alias, ": ") + name;
            let argsLine = prefix + $85d4a1c182545124$var$wrap("(", $85d4a1c182545124$var$join(args, ", "), ")");
            if (argsLine.length > $85d4a1c182545124$var$MAX_LINE_LENGTH) argsLine = prefix + $85d4a1c182545124$var$wrap("(\n", $85d4a1c182545124$var$indent($85d4a1c182545124$var$join(args, "\n")), "\n)");
            return $85d4a1c182545124$var$join([
                argsLine,
                $85d4a1c182545124$var$join(directives, " "),
                selectionSet
            ], " ");
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>"..." + name + $85d4a1c182545124$var$wrap(" ", $85d4a1c182545124$var$join(directives, " "))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$85d4a1c182545124$var$join([
                "...",
                $85d4a1c182545124$var$wrap("on ", typeCondition),
                $85d4a1c182545124$var$join(directives, " "),
                selectionSet
            ], " ")
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$85d4a1c182545124$var$wrap("(", $85d4a1c182545124$var$join(variableDefinitions, ", "), ")")} ` + `on ${typeCondition} ${$85d4a1c182545124$var$wrap("", $85d4a1c182545124$var$join(directives, " "), " ")}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $793319546472cc8f$export$adb6ca997eeb1f45)(value) : (0, $a2d8d3fc4bda92fc$export$3cdec7cf614a0ecc)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? "true" : "false"
    },
    NullValue: {
        leave: ()=>"null"
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>"[" + $85d4a1c182545124$var$join(values, ", ") + "]"
    },
    ObjectValue: {
        leave: ({ fields: fields })=>"{" + $85d4a1c182545124$var$join(fields, ", ") + "}"
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ": " + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>"@" + name + $85d4a1c182545124$var$wrap("(", $85d4a1c182545124$var$join(args, ", "), ")")
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>"[" + type + "]"
    },
    NonNullType: {
        leave: ({ type: type })=>type + "!"
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$85d4a1c182545124$var$wrap("", description, "\n") + $85d4a1c182545124$var$join([
                "schema",
                $85d4a1c182545124$var$join(directives, " "),
                $85d4a1c182545124$var$block(operationTypes)
            ], " ")
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ": " + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$85d4a1c182545124$var$wrap("", description, "\n") + $85d4a1c182545124$var$join([
                "scalar",
                name,
                $85d4a1c182545124$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$85d4a1c182545124$var$wrap("", description, "\n") + $85d4a1c182545124$var$join([
                "type",
                name,
                $85d4a1c182545124$var$wrap("implements ", $85d4a1c182545124$var$join(interfaces, " & ")),
                $85d4a1c182545124$var$join(directives, " "),
                $85d4a1c182545124$var$block(fields)
            ], " ")
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$85d4a1c182545124$var$wrap("", description, "\n") + name + ($85d4a1c182545124$var$hasMultilineItems(args) ? $85d4a1c182545124$var$wrap("(\n", $85d4a1c182545124$var$indent($85d4a1c182545124$var$join(args, "\n")), "\n)") : $85d4a1c182545124$var$wrap("(", $85d4a1c182545124$var$join(args, ", "), ")")) + ": " + type + $85d4a1c182545124$var$wrap(" ", $85d4a1c182545124$var$join(directives, " "))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$85d4a1c182545124$var$wrap("", description, "\n") + $85d4a1c182545124$var$join([
                name + ": " + type,
                $85d4a1c182545124$var$wrap("= ", defaultValue),
                $85d4a1c182545124$var$join(directives, " ")
            ], " ")
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$85d4a1c182545124$var$wrap("", description, "\n") + $85d4a1c182545124$var$join([
                "interface",
                name,
                $85d4a1c182545124$var$wrap("implements ", $85d4a1c182545124$var$join(interfaces, " & ")),
                $85d4a1c182545124$var$join(directives, " "),
                $85d4a1c182545124$var$block(fields)
            ], " ")
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$85d4a1c182545124$var$wrap("", description, "\n") + $85d4a1c182545124$var$join([
                "union",
                name,
                $85d4a1c182545124$var$join(directives, " "),
                $85d4a1c182545124$var$wrap("= ", $85d4a1c182545124$var$join(types, " | "))
            ], " ")
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$85d4a1c182545124$var$wrap("", description, "\n") + $85d4a1c182545124$var$join([
                "enum",
                name,
                $85d4a1c182545124$var$join(directives, " "),
                $85d4a1c182545124$var$block(values)
            ], " ")
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$85d4a1c182545124$var$wrap("", description, "\n") + $85d4a1c182545124$var$join([
                name,
                $85d4a1c182545124$var$join(directives, " ")
            ], " ")
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$85d4a1c182545124$var$wrap("", description, "\n") + $85d4a1c182545124$var$join([
                "input",
                name,
                $85d4a1c182545124$var$join(directives, " "),
                $85d4a1c182545124$var$block(fields)
            ], " ")
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$85d4a1c182545124$var$wrap("", description, "\n") + "directive @" + name + ($85d4a1c182545124$var$hasMultilineItems(args) ? $85d4a1c182545124$var$wrap("(\n", $85d4a1c182545124$var$indent($85d4a1c182545124$var$join(args, "\n")), "\n)") : $85d4a1c182545124$var$wrap("(", $85d4a1c182545124$var$join(args, ", "), ")")) + (repeatable ? " repeatable" : "") + " on " + $85d4a1c182545124$var$join(locations, " | ")
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$85d4a1c182545124$var$join([
                "extend schema",
                $85d4a1c182545124$var$join(directives, " "),
                $85d4a1c182545124$var$block(operationTypes)
            ], " ")
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$85d4a1c182545124$var$join([
                "extend scalar",
                name,
                $85d4a1c182545124$var$join(directives, " ")
            ], " ")
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$85d4a1c182545124$var$join([
                "extend type",
                name,
                $85d4a1c182545124$var$wrap("implements ", $85d4a1c182545124$var$join(interfaces, " & ")),
                $85d4a1c182545124$var$join(directives, " "),
                $85d4a1c182545124$var$block(fields)
            ], " ")
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$85d4a1c182545124$var$join([
                "extend interface",
                name,
                $85d4a1c182545124$var$wrap("implements ", $85d4a1c182545124$var$join(interfaces, " & ")),
                $85d4a1c182545124$var$join(directives, " "),
                $85d4a1c182545124$var$block(fields)
            ], " ")
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$85d4a1c182545124$var$join([
                "extend union",
                name,
                $85d4a1c182545124$var$join(directives, " "),
                $85d4a1c182545124$var$wrap("= ", $85d4a1c182545124$var$join(types, " | "))
            ], " ")
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$85d4a1c182545124$var$join([
                "extend enum",
                name,
                $85d4a1c182545124$var$join(directives, " "),
                $85d4a1c182545124$var$block(values)
            ], " ")
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$85d4a1c182545124$var$join([
                "extend input",
                name,
                $85d4a1c182545124$var$join(directives, " "),
                $85d4a1c182545124$var$block(fields)
            ], " ")
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $85d4a1c182545124$var$join(maybeArray, separator = "") {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : "";
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $85d4a1c182545124$var$block(array) {
    return $85d4a1c182545124$var$wrap("{\n", $85d4a1c182545124$var$indent($85d4a1c182545124$var$join(array, "\n")), "\n}");
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $85d4a1c182545124$var$wrap(start, maybeString, end = "") {
    return maybeString != null && maybeString !== "" ? start + maybeString + end : "";
}
function $85d4a1c182545124$var$indent(str) {
    return $85d4a1c182545124$var$wrap("  ", str.replace(/\n/g, "\n  "));
}
function $85d4a1c182545124$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes("\n"))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}




var $faf63d297e5a9103$var$printCache;
var $faf63d297e5a9103$export$c2d084dc44961371 = Object.assign(function(ast) {
    var result = $faf63d297e5a9103$var$printCache.get(ast);
    if (!result) {
        result = (0, $85d4a1c182545124$export$c2d084dc44961371)(ast);
        $faf63d297e5a9103$var$printCache.set(ast, result);
    }
    return result;
}, {
    reset: function() {
        $faf63d297e5a9103$var$printCache = new (0, $df1718e4a0eb4d0a$export$8dbad6f439bb2331)((0, $e8270474df1c6a9d$export$f29926b23b28936b).print || 2000 /* defaultCacheSizes.print */ );
    }
});
$faf63d297e5a9103$export$c2d084dc44961371.reset();
if (globalThis.__DEV__ !== false) (0, $19eefe0273f1ef83$export$a8fcd406d9e37621)("print", function() {
    return $faf63d297e5a9103$var$printCache ? $faf63d297e5a9103$var$printCache.size : 0;
});


var $badf507bd4891af4$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false
};
var $badf507bd4891af4$var$defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: "*/*",
    // The content-type header describes the type of the body of the request, and
    // so it typically only is sent with requests that actually have bodies. One
    // could imagine that Apollo Client would remove this header when constructing
    // a GET request (which has no body), but we historically have not done that.
    // This means that browsers will preflight all Apollo Client requests (even
    // GET requests). Apollo Server's CSRF prevention feature (introduced in
    // AS3.7) takes advantage of this fact and does not block requests with this
    // header. If you want to drop this header from GET requests, then you should
    // probably replace it with a `apollo-require-preflight` header, or servers
    // with CSRF prevention enabled might block your GET request. See
    // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
    // for more details.
    "content-type": "application/json"
};
var $badf507bd4891af4$var$defaultOptions = {
    method: "POST"
};
var $badf507bd4891af4$export$dd86f00dc866e75d = {
    http: $badf507bd4891af4$var$defaultHttpOptions,
    headers: $badf507bd4891af4$var$defaultHeaders,
    options: $badf507bd4891af4$var$defaultOptions
};
var $badf507bd4891af4$export$e88934976ca4fd65 = function(ast, printer) {
    return printer(ast);
};
function $badf507bd4891af4$export$a00ebfd5f1eebfb1(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    configs.unshift(fallbackConfig);
    return $badf507bd4891af4$export$12d90ccf75844275.apply(void 0, (0, $e2e041e4a1657497$export$1216008129fb82ed)([
        operation,
        $badf507bd4891af4$export$e88934976ca4fd65
    ], configs, false));
}
function $badf507bd4891af4$export$12d90ccf75844275(operation, printer) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = {};
    var http = {};
    configs.forEach(function(config) {
        options = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options), config.options), {
            headers: (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options.headers), config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, http), config.http);
    });
    if (options.headers) options.headers = $badf507bd4891af4$var$removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    //The body depends on the http options
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery) body.query = printer(query, (0, $faf63d297e5a9103$export$c2d084dc44961371));
    return {
        options: options,
        body: body
    };
}
// Remove potential duplicate header names, preserving last (by insertion order).
// This is done to prevent unintentionally duplicating a header instead of
// overwriting it (See #8447 and #8449).
function $badf507bd4891af4$var$removeDuplicateHeaders(headers, preserveHeaderCase) {
    // If we're not preserving the case, just remove duplicates w/ normalization.
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = Object.create(null);
        Object.keys(Object(headers)).forEach(function(name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    // If we are preserving the case, remove duplicates w/ normalization,
    // preserving the original name.
    // This allows for non-http-spec-compliant servers that expect intentionally
    // capitalized header names (See #6741).
    var headerData = Object.create(null);
    Object.keys(Object(headers)).forEach(function(name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name]
        };
    });
    var normalizedHeaders = Object.create(null);
    Object.keys(headerData).forEach(function(name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}



function $278825098685bd29$export$fb82bb094b6f76b5(chosenURI, body) {
    // Implement the standard HTTP GET serialization, plus 'extensions'. Note
    // the extra level of JSON serialization!
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ("query" in body) addQueryParam("query", body.query);
    if (body.operationName) addQueryParam("operationName", body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $48bc349aae83039c$export$5f8e80ac52052e28)(body.variables, "Variables map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $48bc349aae83039c$export$5f8e80ac52052e28)(body.extensions, "Extensions map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    // Reconstruct the URI with added query params.
    // XXX This assumes that the URI is well-formed and that it doesn't
    //     already contain any of these query params. We could instead use the
    //     URL API and take a polyfill (whatwg-url@6) for older browsers that
    //     don't support URLSearchParams. Note that some browsers (and
    //     versions of whatwg-url) support URL but not URLSearchParams!
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return {
        newURI: newURI
    };
}




function $04beb3d0ea5d062f$export$de246493ae27fe3f(variables, query) {
    var result = (0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, variables);
    var unusedNames = new Set(Object.keys(variables));
    (0, $b5d0850d22ba2059$export$bf638b60ea8b89b7)(query, {
        Variable: function(node, _key, parent) {
            // A variable type definition at the top level of a query is not
            // enough to silence server-side errors about the variable being
            // unused, so variable definitions do not count as usage.
            // https://spec.graphql.org/draft/#sec-All-Variables-Used
            if (parent && parent.kind !== "VariableDefinition") unusedNames.delete(node.name.value);
        }
    });
    unusedNames.forEach(function(name) {
        delete result[name];
    });
    return result;
}


function $4d58e71cc5a3c724$export$4fd972edbe7450d3(errorValue) {
    return new (0, $a68a73fcce1c801b$export$77cea355fa80b5f4)(function(observer) {
        observer.error(errorValue);
    });
}


var $2d83690f92484335$var$backupFetch = (0, $dd134a40a587301b$export$f8b8b9ce72e9ccbf)(function() {
    return fetch;
});
var $2d83690f92484335$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, // use default global fetch if nothing passed in
    preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? (0, $badf507bd4891af4$export$e88934976ca4fd65) : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0, $e2e041e4a1657497$export$3c9a16f847548506)(linkOptions, [
        "uri",
        "fetch",
        "print",
        "includeExtensions",
        "preserveHeaderCase",
        "useGETForQueries",
        "includeUnusedVariables"
    ]);
    if (globalThis.__DEV__ !== false) // Make sure at least one of preferredFetch, window.fetch, or backupFetch is
    // defined, so requests won't fail at runtime.
    (0, $c7274adfa65ff538$export$8423f0cd3773115e)(preferredFetch || $2d83690f92484335$var$backupFetch);
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions,
            preserveHeaderCase: preserveHeaderCase
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $e7fcb7cc7e563d46$export$2fed3d61f740bc7f)(function(operation) {
        var chosenURI = (0, $d146137b5964a9a5$export$63ccc2571850f81a)(operation, uri);
        var context = operation.getContext();
        // `apollographql-client-*` headers are automatically set if a
        // `clientAwareness` object is found in the context. These headers are
        // set first, followed by the rest of the headers pulled from
        // `context.headers`. If desired, `apollographql-client-*` headers set by
        // the `clientAwareness` object can be overridden by
        // `apollographql-client-*` headers set in `context.headers`.
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders["apollographql-client-name"] = name_1;
            if (version) clientAwarenessHeaders["apollographql-client-version"] = version;
        }
        var contextHeaders = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        if ((0, $d474a5d9bfbef507$export$2dafb573e282fe8d)([
            "client"
        ], operation.query)) {
            var transformedQuery = (0, $99a4544cb26a0024$export$8eae69e876ee321e)(operation.query);
            if (!transformedQuery) return (0, $4d58e71cc5a3c724$export$4fd972edbe7450d3)(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
            operation.query = transformedQuery;
        }
        //uses fallback, link, and then context to build options
        var _b = (0, $badf507bd4891af4$export$12d90ccf75844275)(operation, print, (0, $badf507bd4891af4$export$dd86f00dc866e75d), linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) body.variables = (0, $04beb3d0ea5d062f$export$de246493ae27fe3f)(body.variables, operation.query);
        var controller;
        if (!options.signal && typeof AbortController !== "undefined") {
            controller = new AbortController();
            options.signal = controller.signal;
        }
        // If requested, set method to GET if there are no mutations.
        var definitionIsMutation = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        var definitionIsSubscription = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "subscription";
        };
        var isSubscription = definitionIsSubscription((0, $d34613b28fb40239$export$f431198736b7f96d)(operation.query));
        // does not match custom directives beginning with @defer
        var hasDefer = (0, $d474a5d9bfbef507$export$2dafb573e282fe8d)([
            "defer"
        ], operation.query);
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = "GET";
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            // Omit defer-specific headers if the user attempts to defer a selection
            // set on a subscription and log a warning.
            if (isSubscription && hasDefer) globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).warn(38);
            if (isSubscription) acceptHeader += "boundary=graphql;subscriptionSpec=1.0,application/json";
            else if (hasDefer) acceptHeader += "deferSpec=20220824,application/json";
            options.headers.accept = acceptHeader;
        }
        if (options.method === "GET") {
            var _c = (0, $278825098685bd29$export$fb82bb094b6f76b5)(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
            if (parseError) return (0, $4d58e71cc5a3c724$export$4fd972edbe7450d3)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $48bc349aae83039c$export$5f8e80ac52052e28)(body, "Payload");
        } catch (parseError) {
            return (0, $4d58e71cc5a3c724$export$4fd972edbe7450d3)(parseError);
        }
        return new (0, $a68a73fcce1c801b$export$77cea355fa80b5f4)(function(observer) {
            // Prefer linkOptions.fetch (preferredFetch) if provided, and otherwise
            // fall back to the *current* global window.fetch function (see issue
            // #7832), or (if all else fails) the backupFetch function we saved when
            // this module was first evaluated. This last option protects against the
            // removal of window.fetch, which is unlikely but not impossible.
            var currentFetch = preferredFetch || (0, $dd134a40a587301b$export$f8b8b9ce72e9ccbf)(function() {
                return fetch;
            }) || $2d83690f92484335$var$backupFetch;
            var observerNext = observer.next.bind(observer);
            currentFetch(chosenURI, options).then(function(response) {
                var _a;
                operation.setContext({
                    response: response
                });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) return (0, $f3a74a0dda3972cf$export$ccb60864026baf09)(response, observerNext);
                else return (0, $f3a74a0dda3972cf$export$d4051215bea0639f)(operation)(response).then(observerNext);
            }).then(function() {
                controller = undefined;
                observer.complete();
            }).catch(function(err) {
                controller = undefined;
                (0, $f3a74a0dda3972cf$export$d3da1ecaf1206c58)(err, observer);
            });
            return function() {
                // XXX support canceling this request
                // https://developers.google.com/web/updates/2017/09/abortable-fetch
                if (controller) controller.abort();
            };
        });
    });
};


var $dd7c24ed2c98b3d2$export$f4bbf1aec241cc1 = /** @class */ function(_super) {
    (0, $e2e041e4a1657497$export$a8ba968b8961cb8a)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, (0, $2d83690f92484335$export$95180a16573d6675)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}((0, $e7fcb7cc7e563d46$export$2fed3d61f740bc7f));







function $f4e2d5e8d6701548$export$707ee4c4c95d39e3(observable, mapFn, catchFn) {
    return new (0, $a68a73fcce1c801b$export$77cea355fa80b5f4)(function(observer) {
        var promiseQueue = {
            // Normally we would initialize promiseQueue to Promise.resolve(), but
            // in this case, for backwards compatibility, we need to be careful to
            // invoke the first callback synchronously.
            then: function(callback) {
                return new Promise(function(resolve) {
                    return resolve(callback());
                });
            }
        };
        function makeCallback(examiner, key) {
            return function(arg) {
                if (examiner) {
                    var both = function() {
                        // If the observer is closed, we don't want to continue calling the
                        // mapping function - it's result will be swallowed anyways.
                        return observer.closed ? /* will be swallowed */ 0 : examiner(arg);
                    };
                    promiseQueue = promiseQueue.then(both, both).then(function(result) {
                        return observer.next(result);
                    }, function(error) {
                        return observer.error(error);
                    });
                } else observer[key](arg);
            };
        }
        var handler = {
            next: makeCallback(mapFn, "next"),
            error: makeCallback(catchFn, "error"),
            complete: function() {
                // no need to reassign `promiseQueue`, after `observer.complete`,
                // the observer will be closed and short-circuit everything anyways
                /*promiseQueue = */ promiseQueue.then(function() {
                    return observer.complete();
                });
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}



function $835c76846b374893$export$9f6c99ae166dbeca(observers, method, argument) {
    // In case observers is modified during iteration, we need to commit to the
    // original elements, which also provides an opportunity to filter them down
    // to just the observers with the given method.
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}




function $396a08d71b4f97f5$export$33c8bd820eece9b2(subclass) {
    function set(key) {
        // Object.defineProperty is necessary because the Symbol.species
        // property is a getter by default in modern JS environments, so we
        // can't assign to it with a normal assignment expression.
        Object.defineProperty(subclass, key, {
            value: (0, $a68a73fcce1c801b$export$77cea355fa80b5f4)
        });
    }
    if ((0, $9865fa0c1163b711$export$23ba675b4b838b92) && Symbol.species) set(Symbol.species);
    // The "@@species" string is used as a fake Symbol.species value in some
    // polyfill systems (including the SymbolSpecies variable used by
    // zen-observable), so we should set it as well, to be safe.
    set("@@species");
    return subclass;
}


function $e6c0cda17ebd3d4e$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// A Concast<T> observable concatenates the given sources into a single
// non-overlapping sequence of Ts, automatically unwrapping any promises,
// and broadcasts the T elements of that sequence to any number of
// subscribers, all without creating a bunch of intermediary Observable
// wrapper objects.
//
// Even though any number of observers can subscribe to the Concast, each
// source observable is guaranteed to receive at most one subscribe call,
// and the results are multicast to all observers.
//
// In addition to broadcasting every next/error message to this.observers,
// the Concast stores the most recent message using this.latest, so any
// new observers can immediately receive the latest message, even if it
// was originally delivered in the past. This behavior means we can assume
// every active observer in this.observers has received the same most
// recent message.
//
// With the exception of this.latest replay, a Concast is a "hot"
// observable in the sense that it does not replay past results from the
// beginning of time for each new observer.
//
// Could we have used some existing RxJS class instead? Concast<T> is
// similar to a BehaviorSubject<T>, because it is multicast and redelivers
// the latest next/error message to new subscribers. Unlike Subject<T>,
// Concast<T> does not expose an Observer<T> interface (this.handlers is
// intentionally private), since Concast<T> gets its inputs from the
// concatenated sources. If we ever switch to RxJS, there may be some
// value in reusing their code, but for now we use zen-observable, which
// does not contain any Subject implementations.
var $e6c0cda17ebd3d4e$export$ae0cf2ec7a6fa78e = /** @class */ function(_super) {
    (0, $e2e041e4a1657497$export$a8ba968b8961cb8a)(Concast, _super);
    // Not only can the individual elements of the iterable be promises, but
    // also the iterable itself can be wrapped in a promise.
    function Concast(sources) {
        var _this = _super.call(this, function(observer) {
            _this.addObserver(observer);
            return function() {
                return _this.removeObserver(observer);
            };
        }) || this;
        // Active observers receiving broadcast messages. Thanks to this.latest,
        // we can assume all observers in this Set have received the same most
        // recent message, though possibly at different times in the past.
        _this.observers = new Set();
        _this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        // Bound handler functions that can be reused for every internal
        // subscription.
        _this.handlers = {
            next: function(result) {
                if (_this.sub !== null) {
                    _this.latest = [
                        "next",
                        result
                    ];
                    _this.notify("next", result);
                    (0, $835c76846b374893$export$9f6c99ae166dbeca)(_this.observers, "next", result);
                }
            },
            error: function(error) {
                var sub = _this.sub;
                if (sub !== null) {
                    // Delay unsubscribing from the underlying subscription slightly,
                    // so that immediately subscribing another observer can keep the
                    // subscription active.
                    if (sub) setTimeout(function() {
                        return sub.unsubscribe();
                    });
                    _this.sub = null;
                    _this.latest = [
                        "error",
                        error
                    ];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0, $835c76846b374893$export$9f6c99ae166dbeca)(_this.observers, "error", error);
                }
            },
            complete: function() {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    // If complete is called before concast.start, this.sources may be
                    // undefined, so we use a default value of [] for sources. That works
                    // here because it falls into the if (!value) {...} block, which
                    // appropriately terminates the Concast, even if this.sources might
                    // eventually have been initialized to a non-empty array.
                    var value = sources.shift();
                    if (!value) {
                        if (sub) setTimeout(function() {
                            return sub.unsubscribe();
                        });
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") _this.resolve(_this.latest[1]);
                        else _this.resolve();
                        _this.notify("complete");
                        // We do not store this.latest = ["complete"], because doing so
                        // discards useful information about the previous next (or
                        // error) message. Instead, if new observers subscribe after
                        // this Concast has completed, they will receive the final
                        // 'next' message (unless there was an error) immediately
                        // followed by a 'complete' message (see addObserver).
                        (0, $835c76846b374893$export$9f6c99ae166dbeca)(_this.observers, "complete");
                    } else if ($e6c0cda17ebd3d4e$var$isPromiseLike(value)) value.then(function(obs) {
                        return _this.sub = obs.subscribe(_this.handlers);
                    }, _this.handlers.error);
                    else _this.sub = value.subscribe(_this.handlers);
                }
            }
        };
        _this.nextResultListeners = new Set();
        // A public way to abort observation and broadcast.
        _this.cancel = function(reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        // Suppress rejection warnings for this.promise, since it's perfectly
        // acceptable to pay no attention to this.promise if you're consuming
        // the results through the normal observable API.
        _this.promise.catch(function(_) {});
        // If someone accidentally tries to create a Concast using a subscriber
        // function, recover by creating an Observable from that subscriber and
        // using it as the source.
        if (typeof sources === "function") sources = [
            new (0, $a68a73fcce1c801b$export$77cea355fa80b5f4)(sources)
        ];
        if ($e6c0cda17ebd3d4e$var$isPromiseLike(sources)) sources.then(function(iterable) {
            return _this.start(iterable);
        }, _this.handlers.error);
        else _this.start(sources);
        return _this;
    }
    Concast.prototype.start = function(sources) {
        if (this.sub !== void 0) return;
        // In practice, sources is most often simply an Array of observables.
        // TODO Consider using sources[Symbol.iterator]() to take advantage
        // of the laziness of non-Array iterables.
        this.sources = Array.from(sources);
        // Calling this.handlers.complete() kicks off consumption of the first
        // source observable. It's tempting to do this step lazily in
        // addObserver, but this.promise can be accessed without calling
        // addObserver, so consumption needs to begin eagerly.
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function(observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) method.call(observer, this.latest[1]);
            // If the subscription is already closed, and the last message was
            // a 'next' message, simulate delivery of the final 'complete'
            // message again.
            if (this.sub === null && nextOrError === "next" && observer.complete) observer.complete();
        }
    };
    Concast.prototype.addObserver = function(observer) {
        if (!this.observers.has(observer)) {
            // Immediately deliver the most recent message, so we can always
            // be sure all observers have the latest information.
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function(observer) {
        if (this.observers.delete(observer) && this.observers.size < 1) // In case there are still any listeners in this.nextResultListeners, and
        // no error or completion has been broadcast yet, make sure those
        // observers have a chance to run and then remove themselves from
        // this.observers.
        this.handlers.complete();
    };
    Concast.prototype.notify = function(method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            // Replacing this.nextResultListeners first ensures it does not grow while
            // we are iterating over it, potentially leading to infinite loops.
            this.nextResultListeners = new Set();
            nextResultListeners.forEach(function(listener) {
                return listener(method, arg);
            });
        }
    };
    // We need a way to run callbacks just *before* the next result (or error or
    // completion) is delivered by this Concast, so we can be sure any code that
    // runs as a result of delivering that result/error observes the effects of
    // running the callback(s). It was tempting to reuse the Observer type instead
    // of introducing NextResultListener, but that messes with the sizing and
    // maintenance of this.observers, and ends up being more code overall.
    Concast.prototype.beforeNext = function(callback) {
        var called = false;
        this.nextResultListeners.add(function(method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}((0, $a68a73fcce1c801b$export$77cea355fa80b5f4));
// Necessary because the Concast constructor has a different signature
// than the Observable constructor.
(0, $396a08d71b4f97f5$export$33c8bd820eece9b2)($e6c0cda17ebd3d4e$export$ae0cf2ec7a6fa78e);

// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const $26d4e625bb2590d6$var$defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: $26d4e625bb2590d6$var$forEach, slice: $26d4e625bb2590d6$var$slice } = Array.prototype;
const { hasOwnProperty: $26d4e625bb2590d6$var$hasOwnProperty } = Object.prototype;
class $26d4e625bb2590d6$export$73571c50d0f2507e {
    constructor(weakness = true, makeData = $26d4e625bb2590d6$var$defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup() {
        return this.lookupArray(arguments);
    }
    lookupArray(array) {
        let node = this;
        $26d4e625bb2590d6$var$forEach.call(array, (key)=>node = node.getChildTrie(key));
        return $26d4e625bb2590d6$var$hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData($26d4e625bb2590d6$var$slice.call(array));
    }
    peek() {
        return this.peekArray(arguments);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = node.mapFor(array[i], false);
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    remove() {
        return this.removeArray(arguments);
    }
    removeArray(array) {
        let data;
        if (array.length) {
            const head = array[0];
            const map = this.mapFor(head, false);
            const child = map && map.get(head);
            if (child) {
                data = child.removeArray($26d4e625bb2590d6$var$slice.call(array, 1));
                if (!child.data && !child.weak && !(child.strong && child.strong.size)) map.delete(head);
            }
        } else {
            data = this.data;
            delete this.data;
        }
        return data;
    }
    getChildTrie(key) {
        const map = this.mapFor(key, true);
        let child = map.get(key);
        if (!child) map.set(key, child = new $26d4e625bb2590d6$export$73571c50d0f2507e(this.weakness, this.makeData));
        return child;
    }
    mapFor(key, create) {
        return this.weakness && $26d4e625bb2590d6$var$isObjRef(key) ? this.weak || (create ? this.weak = new WeakMap : void 0) : this.strong || (create ? this.strong = new Map : void 0);
    }
}
function $26d4e625bb2590d6$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}






// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const $1263e7775bb86276$var$defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: $1263e7775bb86276$var$forEach, slice: $1263e7775bb86276$var$slice } = Array.prototype;
const { hasOwnProperty: $1263e7775bb86276$var$hasOwnProperty } = Object.prototype;
class $1263e7775bb86276$export$73571c50d0f2507e {
    constructor(weakness = true, makeData = $1263e7775bb86276$var$defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup(...array) {
        return this.lookupArray(array);
    }
    lookupArray(array) {
        let node = this;
        $1263e7775bb86276$var$forEach.call(array, (key)=>node = node.getChildTrie(key));
        return $1263e7775bb86276$var$hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData($1263e7775bb86276$var$slice.call(array));
    }
    peek(...array) {
        return this.peekArray(array);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = this.weakness && $1263e7775bb86276$var$isObjRef(array[i]) ? node.weak : node.strong;
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    getChildTrie(key) {
        const map = this.weakness && $1263e7775bb86276$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        let child = map.get(key);
        if (!child) map.set(key, child = new $1263e7775bb86276$export$73571c50d0f2507e(this.weakness, this.makeData));
        return child;
    }
}
function $1263e7775bb86276$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}



// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let $c3407b7f6169ee6c$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const $c3407b7f6169ee6c$var$MISSING_VALUE = {};
let $c3407b7f6169ee6c$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const $c3407b7f6169ee6c$var$makeSlotClass = ()=>class Slot {
        constructor(){
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $c3407b7f6169ee6c$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        hasValue() {
            for(let context = $c3407b7f6169ee6c$var$currentContext; context; context = context.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === $c3407b7f6169ee6c$var$MISSING_VALUE) break;
                if (context !== $c3407b7f6169ee6c$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $c3407b7f6169ee6c$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($c3407b7f6169ee6c$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $c3407b7f6169ee6c$var$currentContext.slots[this.id] = $c3407b7f6169ee6c$var$MISSING_VALUE;
            return false;
        }
        getValue() {
            if (this.hasValue()) return $c3407b7f6169ee6c$var$currentContext.slots[this.id];
        }
        withValue(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            const slots = {
                __proto__: null,
                [this.id]: value
            };
            const parent = $c3407b7f6169ee6c$var$currentContext;
            $c3407b7f6169ee6c$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $c3407b7f6169ee6c$var$currentContext = parent;
            }
        }
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        static bind(callback) {
            const context = $c3407b7f6169ee6c$var$currentContext;
            return function() {
                const saved = $c3407b7f6169ee6c$var$currentContext;
                try {
                    $c3407b7f6169ee6c$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $c3407b7f6169ee6c$var$currentContext = saved;
                }
            };
        }
        // Immediately run a callback function without any captured context.
        static noContext(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($c3407b7f6169ee6c$var$currentContext) {
                const saved = $c3407b7f6169ee6c$var$currentContext;
                try {
                    $c3407b7f6169ee6c$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $c3407b7f6169ee6c$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        }
    };
function $c3407b7f6169ee6c$var$maybe(fn) {
    try {
        return fn();
    } catch (ignored) {}
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const $c3407b7f6169ee6c$var$globalKey = "@wry/context:Slot";
const $c3407b7f6169ee6c$var$host = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
$c3407b7f6169ee6c$var$maybe(()=>globalThis) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
$c3407b7f6169ee6c$var$maybe(()=>$parcel$global) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const $c3407b7f6169ee6c$var$globalHost = $c3407b7f6169ee6c$var$host;
const $c3407b7f6169ee6c$export$8c6ed5c666ac1360 = $c3407b7f6169ee6c$var$globalHost[$c3407b7f6169ee6c$var$globalKey] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[$c3407b7f6169ee6c$var$globalKey] || function(Slot) {
    try {
        Object.defineProperty($c3407b7f6169ee6c$var$globalHost, $c3407b7f6169ee6c$var$globalKey, {
            value: Slot,
            enumerable: false,
            writable: false,
            // When it was possible for globalHost to be the Array constructor (a
            // legacy Slot dedup strategy), it was important for the property to be
            // configurable:true so it could be deleted. That does not seem to be as
            // important when globalHost is the global object, but I don't want to
            // cause similar problems again, and configurable:true seems safest.
            // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
            configurable: true
        });
    } finally{
        return Slot;
    }
}($c3407b7f6169ee6c$var$makeSlotClass());


const { bind: $7cb6c6c7a735781d$export$2385a24977818dd0, noContext: $7cb6c6c7a735781d$export$9fa6f2e300a97f8 } = (0, $c3407b7f6169ee6c$export$8c6ed5c666ac1360);
function $7cb6c6c7a735781d$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($7cb6c6c7a735781d$export$2385a24977818dd0(callback), delay);
}
function $7cb6c6c7a735781d$export$d5d7536e965c82da(genFn) {
    return function() {
        const gen = genFn.apply(this, arguments);
        const boundNext = $7cb6c6c7a735781d$export$2385a24977818dd0(gen.next);
        const boundThrow = $7cb6c6c7a735781d$export$2385a24977818dd0(gen.throw);
        return new Promise((resolve, reject)=>{
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if ($7cb6c6c7a735781d$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            const invokeNext = (value)=>invoke(boundNext, value);
            const invokeThrow = (error)=>invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function $7cb6c6c7a735781d$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const $7cb6c6c7a735781d$var$wrappedFibers = [];
function $7cb6c6c7a735781d$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($7cb6c6c7a735781d$var$wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method)=>{
            const fn = obj[method];
            obj[method] = function() {
                return $7cb6c6c7a735781d$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $7cb6c6c7a735781d$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}


const $336db772839be787$export$11fa9682b6ba79b1 = new (0, $c3407b7f6169ee6c$export$8c6ed5c666ac1360)();
function $336db772839be787$export$d906efd39458576(fn) {
    return $336db772839be787$export$11fa9682b6ba79b1.withValue(void 0, fn);
}


const { hasOwnProperty: $0cd2867e55704a6c$export$5a15a386532a5ea4 } = Object.prototype;
const $0cd2867e55704a6c$export$1eb72f2488cedd93 = Array.from || function(set) {
    const array = [];
    set.forEach((item)=>array.push(item));
    return array;
};
function $0cd2867e55704a6c$export$50527b97338c0f71(entryOrDep) {
    const { unsubscribe: unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}


const $28eefe249e335cec$var$emptySetPool = [];
const $28eefe249e335cec$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $28eefe249e335cec$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $28eefe249e335cec$var$valueIs(a, b) {
    const len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $28eefe249e335cec$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $28eefe249e335cec$var$valueCopy(value) {
    return value.slice(0);
}
class $28eefe249e335cec$export$3bb977b3ba9d3b59 {
    constructor(fn){
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++$28eefe249e335cec$export$3bb977b3ba9d3b59.count;
    }
    peek() {
        if (this.value.length === 1 && !$28eefe249e335cec$var$mightBeDirty(this)) {
            $28eefe249e335cec$var$rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        $28eefe249e335cec$var$assert(!this.recomputing, "already recomputing");
        $28eefe249e335cec$var$rememberParent(this);
        return $28eefe249e335cec$var$mightBeDirty(this) ? $28eefe249e335cec$var$reallyRecompute(this, args) : $28eefe249e335cec$var$valueGet(this.value);
    }
    setDirty() {
        if (this.dirty) return;
        this.dirty = true;
        $28eefe249e335cec$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        (0, $0cd2867e55704a6c$export$50527b97338c0f71)(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        $28eefe249e335cec$var$forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        $28eefe249e335cec$var$eachParent(this, (parent, child)=>{
            parent.setDirty();
            $28eefe249e335cec$var$forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $28eefe249e335cec$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            (0, $0cd2867e55704a6c$export$1eb72f2488cedd93)(this.deps).forEach((dep)=>dep.delete(this));
            this.deps.clear();
            $28eefe249e335cec$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
}
$28eefe249e335cec$export$3bb977b3ba9d3b59.count = 0;
function $28eefe249e335cec$var$rememberParent(child) {
    const parent = (0, $336db772839be787$export$11fa9682b6ba79b1).getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($28eefe249e335cec$var$mightBeDirty(child)) $28eefe249e335cec$var$reportDirtyChild(parent, child);
        else $28eefe249e335cec$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $28eefe249e335cec$var$reallyRecompute(entry, args) {
    $28eefe249e335cec$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    (0, $336db772839be787$export$11fa9682b6ba79b1).withValue(entry, $28eefe249e335cec$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($28eefe249e335cec$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $28eefe249e335cec$var$setClean(entry);
    return $28eefe249e335cec$var$valueGet(entry.value);
}
function $28eefe249e335cec$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    const { normalizeResult: normalizeResult } = entry;
    let oldValueCopy;
    if (normalizeResult && entry.value.length === 1) oldValueCopy = $28eefe249e335cec$var$valueCopy(entry.value);
    // Make entry.value an empty array, representing an unknown value.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
        // If we have a viable oldValueCopy to compare with the (successfully
        // recomputed) new entry.value, and they are not already === identical, give
        // normalizeResult a chance to pick/choose/reuse parts of oldValueCopy[0]
        // and/or entry.value[0] to determine the final cached entry.value.
        if (normalizeResult && oldValueCopy && !$28eefe249e335cec$var$valueIs(oldValueCopy, entry.value)) try {
            entry.value[0] = normalizeResult(entry.value[0], oldValueCopy[0]);
        } catch (_a) {
        // If normalizeResult throws, just use the newer value, rather than
        // saving the exception as entry.value[1].
        }
    } catch (e) {
        // If entry.fn throws, entry.value will hold that exception.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $28eefe249e335cec$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $28eefe249e335cec$var$setClean(entry) {
    entry.dirty = false;
    if ($28eefe249e335cec$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $28eefe249e335cec$var$reportClean(entry);
}
function $28eefe249e335cec$var$reportDirty(child) {
    $28eefe249e335cec$var$eachParent(child, $28eefe249e335cec$var$reportDirtyChild);
}
function $28eefe249e335cec$var$reportClean(child) {
    $28eefe249e335cec$var$eachParent(child, $28eefe249e335cec$var$reportCleanChild);
}
function $28eefe249e335cec$var$eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = (0, $0cd2867e55704a6c$export$1eb72f2488cedd93)(child.parents);
        for(let i = 0; i < parentCount; ++i)callback(parents[i], child);
    }
}
// Let a parent Entry know that one of its children may be dirty.
function $28eefe249e335cec$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $28eefe249e335cec$var$assert(parent.childValues.has(child));
    $28eefe249e335cec$var$assert($28eefe249e335cec$var$mightBeDirty(child));
    const parentWasClean = !$28eefe249e335cec$var$mightBeDirty(parent);
    if (!parent.dirtyChildren) parent.dirtyChildren = $28eefe249e335cec$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) $28eefe249e335cec$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $28eefe249e335cec$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $28eefe249e335cec$var$assert(parent.childValues.has(child));
    $28eefe249e335cec$var$assert(!$28eefe249e335cec$var$mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $28eefe249e335cec$var$valueCopy(child.value));
    else if (!$28eefe249e335cec$var$valueIs(childValue, child.value)) parent.setDirty();
    $28eefe249e335cec$var$removeDirtyChild(parent, child);
    if ($28eefe249e335cec$var$mightBeDirty(parent)) return;
    $28eefe249e335cec$var$reportClean(parent);
}
function $28eefe249e335cec$var$removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($28eefe249e335cec$var$emptySetPool.length < $28eefe249e335cec$var$POOL_TARGET_SIZE) $28eefe249e335cec$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $28eefe249e335cec$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach((_value, child)=>{
        $28eefe249e335cec$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $28eefe249e335cec$var$assert(parent.dirtyChildren === null);
}
function $28eefe249e335cec$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $28eefe249e335cec$var$removeDirtyChild(parent, child);
}
function $28eefe249e335cec$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        (0, $0cd2867e55704a6c$export$50527b97338c0f71)(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}





const $74dd560e5a3ee84c$var$EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true
};
function $74dd560e5a3ee84c$export$c723b7eff9d8f870(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = (0, $336db772839be787$export$11fa9682b6ba79b1).getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) depsByKey.set(key, dep = new Set);
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                (0, $0cd2867e55704a6c$export$50527b97338c0f71)(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = entryMethodName && (0, $0cd2867e55704a6c$export$5a15a386532a5ea4).call($74dd560e5a3ee84c$var$EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            (0, $0cd2867e55704a6c$export$1eb72f2488cedd93)(dep).forEach((entry)=>entry[m]());
            depsByKey.delete(key);
            (0, $0cd2867e55704a6c$export$50527b97338c0f71)(dep);
        }
    };
    return depend;
}


// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let $c16b91c3e0ba14ea$var$defaultKeyTrie;
function $c16b91c3e0ba14ea$export$cd3144f8dd136006(...args) {
    const trie = $c16b91c3e0ba14ea$var$defaultKeyTrie || ($c16b91c3e0ba14ea$var$defaultKeyTrie = new (0, $1263e7775bb86276$export$73571c50d0f2507e)(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
const $c16b91c3e0ba14ea$var$caches = new Set();
function $c16b91c3e0ba14ea$export$4997ffc0176396a6(originalFunction, { max: max = Math.pow(2, 16), keyArgs: keyArgs, makeCacheKey: makeCacheKey = $c16b91c3e0ba14ea$export$cd3144f8dd136006, normalizeResult: normalizeResult, subscribe: subscribe, cache: cacheOption = (0, $1f6a19d4ae0f8e0c$export$d3a0331d2c286dc8) } = Object.create(null)) {
    const cache = typeof cacheOption === "function" ? new cacheOption(max, (entry)=>entry.dispose()) : cacheOption;
    const optimistic = function() {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new (0, $28eefe249e335cec$export$3bb977b3ba9d3b59)(originalFunction));
            entry.normalizeResult = normalizeResult;
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = ()=>cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $c16b91c3e0ba14ea$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!(0, $336db772839be787$export$11fa9682b6ba79b1).hasValue()) {
            $c16b91c3e0ba14ea$var$caches.forEach((cache)=>cache.clean());
            $c16b91c3e0ba14ea$var$caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: ()=>cache.size,
        configurable: false,
        enumerable: false
    });
    Object.freeze(optimistic.options = {
        max: max,
        keyArgs: keyArgs,
        makeCacheKey: makeCacheKey,
        normalizeResult: normalizeResult,
        subscribe: subscribe,
        cache: cache
    });
    function dirtyKey(key) {
        const entry = key && cache.get(key);
        if (entry) entry.setDirty();
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = key && cache.get(key);
        if (entry) return entry.peek();
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return key ? cache.delete(key) : false;
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}



function $bbdf4b1635f5cf2f$var$identity(document) {
    return document;
}
var $bbdf4b1635f5cf2f$export$f887060e48e5dc1b = /** @class */ function() {
    function DocumentTransform(transform, options) {
        if (options === void 0) options = Object.create(null);
        this.resultCache = (0, $9865fa0c1163b711$export$7293b8a0b474028d) ? new WeakSet() : new Set();
        this.transform = transform;
        if (options.getCacheKey) // Override default `getCacheKey` function, which returns [document].
        this.getCacheKey = options.getCacheKey;
        this.cached = options.cache !== false;
        this.resetCache();
    }
    // This default implementation of getCacheKey can be overridden by providing
    // options.getCacheKey to the DocumentTransform constructor. In general, a
    // getCacheKey function may either return an array of keys (often including
    // the document) to be used as a cache key, or undefined to indicate the
    // transform for this document should not be cached.
    DocumentTransform.prototype.getCacheKey = function(document) {
        return [
            document
        ];
    };
    DocumentTransform.identity = function() {
        // No need to cache this transform since it just returns the document
        // unchanged. This should save a bit of memory that would otherwise be
        // needed to populate the `documentCache` of this transform.
        return new DocumentTransform($bbdf4b1635f5cf2f$var$identity, {
            cache: false
        });
    };
    DocumentTransform.split = function(predicate, left, right) {
        if (right === void 0) right = DocumentTransform.identity();
        return Object.assign(new DocumentTransform(function(document) {
            var documentTransform = predicate(document) ? left : right;
            return documentTransform.transformDocument(document);
        }, // Reasonably assume both `left` and `right` transforms handle their own caching
        {
            cache: false
        }), {
            left: left,
            right: right
        });
    };
    /**
     * Resets the internal cache of this transform, if it has one.
     */ DocumentTransform.prototype.resetCache = function() {
        var _this = this;
        if (this.cached) {
            var stableCacheKeys_1 = new (0, $26d4e625bb2590d6$export$73571c50d0f2507e)((0, $9865fa0c1163b711$export$772fbc04a0ad4ce9));
            this.performWork = (0, $c16b91c3e0ba14ea$export$4997ffc0176396a6)(DocumentTransform.prototype.performWork.bind(this), {
                makeCacheKey: function(document) {
                    var cacheKeys = _this.getCacheKey(document);
                    if (cacheKeys) {
                        (0, $57583217334b5278$export$f5708dca728d7177)(Array.isArray(cacheKeys), 66);
                        return stableCacheKeys_1.lookupArray(cacheKeys);
                    }
                },
                max: (0, $e8270474df1c6a9d$export$f29926b23b28936b)["documentTransform.cache"],
                cache: (0, $e043dec6e16a9988$export$87b462129af3b7d4)
            });
        }
    };
    DocumentTransform.prototype.performWork = function(document) {
        (0, $d34613b28fb40239$export$a7d0d8111d2386df)(document);
        return this.transform(document);
    };
    DocumentTransform.prototype.transformDocument = function(document) {
        // If a user passes an already transformed result back to this function,
        // immediately return it.
        if (this.resultCache.has(document)) return document;
        var transformedDocument = this.performWork(document);
        this.resultCache.add(transformedDocument);
        return transformedDocument;
    };
    DocumentTransform.prototype.concat = function(otherTransform) {
        var _this = this;
        return Object.assign(new DocumentTransform(function(document) {
            return otherTransform.transformDocument(_this.transformDocument(document));
        }, // Reasonably assume both transforms handle their own caching
        {
            cache: false
        }), {
            left: this,
            right: otherTransform
        });
    };
    return DocumentTransform;
}();



function $8019e8bf785fd372$export$b4df399e879e53ab(result) {
    var errors = $8019e8bf785fd372$export$a163557155188b6e(result);
    return (0, $93b6d5db950815ab$export$d307f5934e447d0e)(errors);
}
function $8019e8bf785fd372$export$a163557155188b6e(result) {
    var graphQLErrors = (0, $93b6d5db950815ab$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
    if ((0, $2b0bc46d60dcff8e$export$879767c5cdf33cb3)(result) && (0, $93b6d5db950815ab$export$d307f5934e447d0e)(result.incremental)) result.incremental.forEach(function(incrementalResult) {
        if (incrementalResult.errors) graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
    });
    return graphQLErrors;
}









var $3ee0e116c7dbafec$var$toString = Object.prototype.toString;
function $3ee0e116c7dbafec$export$629a2bd3f5a49ecc(value) {
    return $3ee0e116c7dbafec$var$cloneDeepHelper(value);
}
function $3ee0e116c7dbafec$var$cloneDeepHelper(val, seen) {
    switch($3ee0e116c7dbafec$var$toString.call(val)){
        case "[object Array]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $3ee0e116c7dbafec$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            // High fidelity polyfills of Object.create and Object.getPrototypeOf are
            // possible in all JS environments, so we will assume they exist/work.
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $3ee0e116c7dbafec$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}





function $c806bb02b099670b$export$5e40714c5ad44445(query, _a, _b, variables) {
    var aData = _a.data, aRest = (0, $e2e041e4a1657497$export$3c9a16f847548506)(_a, [
        "data"
    ]);
    var bData = _b.data, bRest = (0, $e2e041e4a1657497$export$3c9a16f847548506)(_b, [
        "data"
    ]);
    return (0, $9c119e23bb7e8c34$export$2e2bcd8739ae039)(aRest, bRest) && $c806bb02b099670b$var$equalBySelectionSet((0, $d34613b28fb40239$export$f431198736b7f96d)(query).selectionSet, aData, bData, {
        fragmentMap: (0, $73d0a56999265e6c$export$193789b4c8246dd4)((0, $d34613b28fb40239$export$5320a7ba9466a3df)(query)),
        variables: variables
    });
}
function $c806bb02b099670b$var$equalBySelectionSet(selectionSet, aResult, bResult, context) {
    if (aResult === bResult) return true;
    var seenSelections = new Set();
    // Returning true from this Array.prototype.every callback function skips the
    // current field/subtree. Returning false aborts the entire traversal
    // immediately, causing equalBySelectionSet to return false.
    return selectionSet.selections.every(function(selection) {
        // Avoid re-processing the same selection at the same level of recursion, in
        // case the same field gets included via multiple indirect fragment spreads.
        if (seenSelections.has(selection)) return true;
        seenSelections.add(selection);
        // Ignore @skip(if: true) and @include(if: false) fields.
        if (!(0, $d474a5d9bfbef507$export$3dc388a5f013b4a5)(selection, context.variables)) return true;
        // If the field or (named) fragment spread has a @nonreactive directive on
        // it, we don't care if it's different, so we pretend it's the same.
        if ($c806bb02b099670b$var$selectionHasNonreactiveDirective(selection)) return true;
        if ((0, $4ab7359740364a58$export$fb56ad75dd311c12)(selection)) {
            var resultKey = (0, $4ab7359740364a58$export$7d1ad22471852218)(selection);
            var aResultChild = aResult && aResult[resultKey];
            var bResultChild = bResult && bResult[resultKey];
            var childSelectionSet = selection.selectionSet;
            if (!childSelectionSet) // These are scalar values, so we can compare them with deep equal
            // without redoing the main recursive work.
            return (0, $9c119e23bb7e8c34$export$2e2bcd8739ae039)(aResultChild, bResultChild);
            var aChildIsArray = Array.isArray(aResultChild);
            var bChildIsArray = Array.isArray(bResultChild);
            if (aChildIsArray !== bChildIsArray) return false;
            if (aChildIsArray && bChildIsArray) {
                var length_1 = aResultChild.length;
                if (bResultChild.length !== length_1) return false;
                for(var i = 0; i < length_1; ++i){
                    if (!$c806bb02b099670b$var$equalBySelectionSet(childSelectionSet, aResultChild[i], bResultChild[i], context)) return false;
                }
                return true;
            }
            return $c806bb02b099670b$var$equalBySelectionSet(childSelectionSet, aResultChild, bResultChild, context);
        } else {
            var fragment = (0, $73d0a56999265e6c$export$f80bdb85f299186)(selection, context.fragmentMap);
            if (fragment) {
                // The fragment might === selection if it's an inline fragment, but
                // could be !== if it's a named fragment ...spread.
                if ($c806bb02b099670b$var$selectionHasNonreactiveDirective(fragment)) return true;
                return $c806bb02b099670b$var$equalBySelectionSet(fragment.selectionSet, // Notice that we reuse the same aResult and bResult values here,
                // since the fragment ...spread does not specify a field name, but
                // consists of multiple fields (within the fragment's selection set)
                // that should be applied to the current result value(s).
                aResult, bResult, context);
            }
        }
    });
}
function $c806bb02b099670b$var$selectionHasNonreactiveDirective(selection) {
    return !!selection.directives && selection.directives.some($c806bb02b099670b$var$directiveIsNonreactive);
}
function $c806bb02b099670b$var$directiveIsNonreactive(dir) {
    return dir.name.value === "nonreactive";
}


var $e65253b91ec210ab$var$assign = Object.assign, $e65253b91ec210ab$var$hasOwnProperty = Object.hasOwnProperty;
var $e65253b91ec210ab$export$6c1b56eac59c9584 = /** @class */ function(_super) {
    (0, $e2e041e4a1657497$export$a8ba968b8961cb8a)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function(observer) {
            // Zen Observable has its own error function, so in order to log correctly
            // we need to provide a custom error callback.
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = $e65253b91ec210ab$var$defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !_this.observers.size;
            _this.observers.add(observer);
            // Deliver most recent error or result.
            var last = _this.last;
            if (last && last.error) observer.error && observer.error(last.error);
            else if (last && last.result) observer.next && observer.next(last.result);
            // Initiate observation of this query if it hasn't been reported to
            // the QueryManager yet.
            if (first) // Blindly catching here prevents unhandled promise rejections,
            // and is safe because the ObservableQuery handles this error with
            // this.observer.error, so we're not just swallowing the error by
            // ignoring it here.
            _this.reobserve().catch(function() {});
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        // related classes
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        // active state
        _this.waitForOwnResult = $e65253b91ec210ab$var$skipCacheDataFor(options.fetchPolicy);
        _this.isTornDown = false;
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, // Make sure we don't store "standby" as the initialFetchPolicy.
        _f = options.initialFetchPolicy, // Make sure we don't store "standby" as the initialFetchPolicy.
        initialFetchPolicy = _f === void 0 ? fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy : _f;
        _this.options = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options), {
            // Remember the initial options.fetchPolicy so we can revert back to this
            // policy when variables change. This information can also be specified
            // (or overridden) by providing options.initialFetchPolicy explicitly.
            initialFetchPolicy: initialFetchPolicy,
            // This ensures this.options.fetchPolicy always has a string value, in
            // case options.fetchPolicy was not provided.
            fetchPolicy: fetchPolicy
        });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0, $d34613b28fb40239$export$7a5b1fa979d2c158)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        // The `query` computed property will always reflect the document transformed
        // by the last run query. `this.options.query` will always reflect the raw
        // untransformed query to ensure document transforms with runtime conditionals
        // are run on the original document.
        get: function() {
            return this.lastQuery || this.options.query;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        // Computed shorthand for this.options.variables, preserved for
        // backwards compatibility.
        /**
         * An object containing the variables that were provided for the query.
         */ get: function() {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            // TODO: this code doesn’t actually make sense insofar as the observer
            // will never exist in this.observers due how zen-observable wraps observables.
            // https://github.com/zenparsing/zen-observable/blob/master/src/Observable.js#L169
            var observer = {
                next: function(result) {
                    resolve(result);
                    // Stop the query within the QueryManager if we can before
                    // this function returns.
                    //
                    // We do this in order to prevent observers piling up within
                    // the QueryManager. Notice that we only fully unsubscribe
                    // from the subscription in a setTimeout(..., 0)  call. This call can
                    // actually be handled by the browser at a much later time. If queries
                    // are fired in the meantime, observers that should have been removed
                    // from the QueryManager will continue to fire, causing an unnecessary
                    // performance hit.
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    /** @internal */ ObservableQuery.prototype.resetDiff = function() {
        this.queryInfo.resetDiff();
    };
    ObservableQuery.prototype.getCurrentResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        // Use the last result as long as the variables match this.variables.
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus || lastResult && lastResult.networkStatus || (0, $d609460db1ab26e8$export$bd096ddbd246c79c).ready;
        var result = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, lastResult), {
            loading: (0, $d609460db1ab26e8$export$37509604341a3464)(networkStatus),
            networkStatus: networkStatus
        });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (// These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        $e65253b91ec210ab$var$skipCacheDataFor(fetchPolicy) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers) ;
        else if (this.waitForOwnResult) // This would usually be a part of `QueryInfo.getDiff()`.
        // which we skip in the waitForOwnResult case since we are not
        // interested in the diff.
        this.queryInfo["updateWatch"]();
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) result.data = diff.result;
            if ((0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(result.data, {})) result.data = void 0;
            if (diff.complete) {
                // Similar to setting result.partial to false, but taking advantage of the
                // falsiness of missing fields.
                delete result.partial;
                // If the diff is complete, and we're using a FetchPolicy that
                // terminates after a complete cache read, we can assume the next result
                // we receive will have NetworkStatus.ready and !loading.
                if (diff.complete && result.networkStatus === (0, $d609460db1ab26e8$export$bd096ddbd246c79c).loading && (fetchPolicy === "cache-first" || fetchPolicy === "cache-only")) {
                    result.networkStatus = (0, $d609460db1ab26e8$export$bd096ddbd246c79c).ready;
                    result.loading = false;
                }
            } else result.partial = true;
            if (globalThis.__DEV__ !== false && !diff.complete && !this.options.partialRefetch && !result.loading && !result.data && !result.error) $e65253b91ec210ab$export$b7e1973aacac3ae7(diff.missing);
        }
        if (saveAsLastResult) this.updateLastResult(result);
        return result;
    };
    // Compares newResult to the snapshot we took of this.lastResult when it was
    // first received.
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult, variables) {
        if (!this.last) return true;
        var resultIsDifferent = this.queryManager.getDocumentInfo(this.query).hasNonreactiveDirective ? !(0, $c806bb02b099670b$export$5e40714c5ad44445)(this.query, this.last.result, newResult, this.variables) : !(0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(this.last.result, newResult);
        return resultIsDifferent || variables && !(0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(this.last.variables, variables);
    };
    ObservableQuery.prototype.getLast = function(key, variablesMustMatch) {
        var last = this.last;
        if (last && last[key] && (!variablesMustMatch || (0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(last.variables, this.variables))) return last[key];
    };
    ObservableQuery.prototype.getLastResult = function(variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function(variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        this.queryManager.resetErrors(this.queryId);
    };
    /**
     * Update the variables of this observable query, and fetch the new results.
     * This method should be preferred over `setVariables` in most use cases.
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.refetch = function(variables) {
        var _a;
        var reobserveOptions = {
            // Always disable polling for refetches.
            pollInterval: 0
        };
        // Unless the provided fetchPolicy always consults the network
        // (no-cache, network-only, or cache-and-network), override it with
        // network-only to force the refetch for this fetchQuery call.
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === "cache-and-network") reobserveOptions.fetchPolicy = fetchPolicy;
        else if (fetchPolicy === "no-cache") reobserveOptions.fetchPolicy = "no-cache";
        else reobserveOptions.fetchPolicy = "network-only";
        if (globalThis.__DEV__ !== false && variables && $e65253b91ec210ab$var$hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0, $d34613b28fb40239$export$d96b2213c1b9d3a9)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function(v) {
                return v.variable.name.value === "variables";
            })) globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).warn(20, variables, ((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || queryDef);
        }
        if (variables && !(0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(this.options.variables, variables)) // Update the existing options with new variables
        reobserveOptions.variables = this.options.variables = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, this.options.variables), variables);
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, (0, $d609460db1ab26e8$export$bd096ddbd246c79c).refetch);
    };
    /**
     * A function that helps you fetch the next set of results for a [paginated list field](https://www.apollographql.com/docs/react/pagination/core-api/).
     */ ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, this.options), {
            query: this.options.query
        }), fetchMoreOptions), {
            variables: (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, this.options.variables), fetchMoreOptions.variables)
        })), {
            // The fetchMore request goes immediately to the network and does
            // not automatically write its result to the cache (hence no-cache
            // instead of network-only), because we allow the caller of
            // fetchMore to provide an updateQuery callback that determines how
            // the data gets written to the cache.
            fetchPolicy: "no-cache"
        });
        combinedOptions.query = this.transformDocument(combinedOptions.query);
        var qid = this.queryManager.generateQueryId();
        // If a temporary query is passed to `fetchMore`, we don't want to store
        // it as the last query result since it may be an optimized query for
        // pagination. We will however run the transforms on the original document
        // as well as the document passed in `fetchMoreOptions` to ensure the cache
        // uses the most up-to-date document which may rely on runtime conditionals.
        this.lastQuery = fetchMoreOptions.query ? this.transformDocument(this.options.query) : combinedOptions.query;
        // Simulate a loading result for the original query with
        // result.networkStatus === NetworkStatus.fetchMore.
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = (0, $d609460db1ab26e8$export$bd096ddbd246c79c).fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) this.observe();
        var updatedQuerySet = new Set();
        return this.queryManager.fetchQuery(qid, combinedOptions, (0, $d609460db1ab26e8$export$bd096ddbd246c79c).fetchMore).then(function(fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === (0, $d609460db1ab26e8$export$bd096ddbd246c79c).fetchMore) queryInfo.networkStatus = originalNetworkStatus;
            // Performing this cache update inside a cache.batch transaction ensures
            // any affected cache.watch watchers are notified at most once about any
            // updates. Most watchers will be using the QueryInfo class, which
            // responds to notifications by calling reobserveCacheFirst to deliver
            // fetchMore cache results back to this ObservableQuery.
            _this.queryManager.cache.batch({
                update: function(cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) cache.updateQuery({
                        query: _this.query,
                        variables: _this.variables,
                        returnPartialData: true,
                        optimistic: false
                    }, function(previous) {
                        return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables
                        });
                    });
                    else // If we're using a field policy instead of updateQuery, the only
                    // thing we need to do is write the new data to the cache using
                    // combinedOptions.variables (instead of this.variables, which is
                    // what this.updateQuery uses, because it works by abusing the
                    // original field value, keyed by the original variables).
                    cache.writeQuery({
                        query: combinedOptions.query,
                        variables: combinedOptions.variables,
                        data: fetchMoreResult.data
                    });
                },
                onWatchUpdated: function(watch) {
                    // Record the DocumentNode associated with any watched query whose
                    // data were updated by the cache writes above.
                    updatedQuerySet.add(watch.query);
                }
            });
            return fetchMoreResult;
        }).finally(function() {
            // In case the cache writes above did not generate a broadcast
            // notification (which would have been intercepted by onWatchUpdated),
            // likely because the written data were the same as what was already in
            // the cache, we still want fetchMore to deliver its final loading:false
            // result with the unchanged data.
            if (!updatedQuerySet.has(_this.query)) $e65253b91ec210ab$export$419171d60552792a(_this);
        });
    };
    // XXX the subscription variables are separate from the query variables.
    // if you want to update subscription variables, right now you have to do that separately,
    // and you can only do it by stopping the subscription and then subscribing again with new variables.
    /**
     * A function that enables you to execute a [subscription](https://www.apollographql.com/docs/react/data/subscriptions/), usually to subscribe to specific fields that were included in the query.
     *
     * This function returns _another_ function that you can call to terminate the subscription.
     */ ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).error(21, err);
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.silentSetOptions = function(newOptions) {
        var mergedOptions = (0, $9017e689666d6554$export$8e16b83750b44988)(this.options, newOptions || {});
        $e65253b91ec210ab$var$assign(this.options, mergedOptions);
    };
    /**
     * Update the variables of this observable query, and fetch the new results
     * if they've changed. Most users should prefer `refetch` instead of
     * `setVariables` in order to to be properly notified of results even when
     * they come from the cache.
     *
     * Note: the `next` callback will *not* fire if the variables have not changed
     * or if the result is coming from cache.
     *
     * Note: the promise will return the old results immediately if the variables
     * have not changed.
     *
     * Note: the promise will return null immediately if the query is not active
     * (there are no subscribers).
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.setVariables = function(variables) {
        if ((0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(this.variables, variables)) // If we have no observers, then we don't actually want to make a network
        // request. As soon as someone observes the query, the request will kick
        // off. For now, we just store any changes. (See #1077)
        return this.observers.size ? this.result() : Promise.resolve();
        this.options.variables = variables;
        // See comment above
        if (!this.observers.size) return Promise.resolve();
        return this.reobserve({
            // Reset options.fetchPolicy to its original value.
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables
        }, (0, $d609460db1ab26e8$export$bd096ddbd246c79c).setVariables);
    };
    /**
     * A function that enables you to update the query's cached result without executing a followup GraphQL operation.
     *
     * See [using updateQuery and updateFragment](https://www.apollographql.com/docs/react/caching/cache-interaction/#using-updatequery-and-updatefragment) for additional information.
     */ ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables
            });
            queryManager.broadcastQueries();
        }
    };
    /**
     * A function that instructs the query to begin re-executing at a specified interval (in milliseconds).
     */ ObservableQuery.prototype.startPolling = function(pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    /**
     * A function that instructs the query to stop polling after a previous call to `startPolling`.
     */ ObservableQuery.prototype.stopPolling = function() {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    // Update options.fetchPolicy according to options.nextFetchPolicy.
    ObservableQuery.prototype.applyNextFetchPolicy = function(reason, // It's possible to use this method to apply options.nextFetchPolicy to
    // options.fetchPolicy even if options !== this.options, though that happens
    // most often when the options are temporary, used for only one request and
    // then thrown away, so nextFetchPolicy may not end up mattering.
    options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") ;
            else if (typeof options.nextFetchPolicy === "function") // When someone chooses "cache-and-network" or "network-only" as their
            // initial FetchPolicy, they often do not want future cache updates to
            // trigger unconditional network requests, which is what repeatedly
            // applying the "cache-and-network" or "network-only" policies would
            // seem to imply. Instead, when the cache reports an update after the
            // initial network request, it may be desirable for subsequent network
            // requests to be triggered only if the cache result is incomplete. To
            // that end, the options.nextFetchPolicy option provides an easy way to
            // update options.fetchPolicy after the initial network request, without
            // having to call observableQuery.setOptions.
            options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                reason: reason,
                options: options,
                observable: this,
                initialFetchPolicy: initialFetchPolicy
            });
            else if (reason === "variables-changed") options.fetchPolicy = initialFetchPolicy;
            else options.fetchPolicy = options.nextFetchPolicy;
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function(options, newNetworkStatus, query) {
        // TODO Make sure we update the networkStatus (and infer fetchVariables)
        // before actually committing to the fetch.
        this.queryManager.setObservableQuery(this);
        return this.queryManager["fetchConcastWithInfo"](this.queryId, options, newNetworkStatus, query);
    };
    // Turns polling on or off based on this.options.pollInterval.
    ObservableQuery.prototype.updatePolling = function() {
        var _this = this;
        // Avoid polling in SSR mode
        if (this.queryManager.ssrMode) return;
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) return;
        (0, $57583217334b5278$export$f5708dca728d7177)(pollInterval, 22);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function() {
            var _a, _b;
            if (_this.pollingInfo) {
                if (!(0, $d609460db1ab26e8$export$37509604341a3464)(_this.queryInfo.networkStatus) && !((_b = (_a = _this.options).skipPollAttempt) === null || _b === void 0 ? void 0 : _b.call(_a))) _this.reobserve({
                    // Most fetchPolicy options don't make sense to use in a polling context, as
                    // users wouldn't want to be polling the cache directly. However, network-only and
                    // no-cache are both useful for when the user wants to control whether or not the
                    // polled results are written to the cache.
                    fetchPolicy: _this.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
                }, (0, $d609460db1ab26e8$export$bd096ddbd246c79c).poll).then(poll, poll);
                else poll();
            }
        };
        var poll = function() {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function(newResult, variables) {
        if (variables === void 0) variables = this.variables;
        var error = this.getLastError();
        // Preserve this.last.error unless the variables have changed.
        if (error && this.last && !(0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(variables, this.last.variables)) error = void 0;
        return this.last = (0, $e2e041e4a1657497$export$18ce0697a983be9b)({
            result: this.queryManager.assumeImmutableResults ? newResult : (0, $3ee0e116c7dbafec$export$629a2bd3f5a49ecc)(newResult),
            variables: variables
        }, error ? {
            error: error
        } : null);
    };
    ObservableQuery.prototype.reobserveAsConcast = function(newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        newNetworkStatus === (0, $d609460db1ab26e8$export$bd096ddbd246c79c).refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        newNetworkStatus === (0, $d609460db1ab26e8$export$bd096ddbd246c79c).fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        newNetworkStatus === (0, $d609460db1ab26e8$export$bd096ddbd246c79c).poll;
        // Save the old variables, since Object.assign may modify them below.
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0, $9017e689666d6554$export$8e16b83750b44988)(this.options, newOptions || {});
        var options = useDisposableConcast ? // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        mergedOptions : $e65253b91ec210ab$var$assign(this.options, mergedOptions);
        // Don't update options.query with the transformed query to avoid
        // overwriting this.options.query when we aren't using a disposable concast.
        // We want to ensure we can re-run the custom document transforms the next
        // time a request is made against the original query.
        var query = this.transformDocument(options.query);
        this.lastQuery = query;
        if (!useDisposableConcast) {
            // We can skip calling updatePolling if we're not changing this.options.
            this.updatePolling();
            // Reset options.fetchPolicy to its original value when variables change,
            // unless a new fetchPolicy was provided by newOptions.
            if (newOptions && newOptions.variables && !(0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(newOptions.variables, oldVariables) && // Don't mess with the fetchPolicy if it's currently "standby".
            options.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
            // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
            options.fetchPolicy === oldFetchPolicy) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) newNetworkStatus = (0, $d609460db1ab26e8$export$bd096ddbd246c79c).setVariables;
            }
        }
        this.waitForOwnResult && (this.waitForOwnResult = $e65253b91ec210ab$var$skipCacheDataFor(options.fetchPolicy));
        var finishWaitingForOwnResult = function() {
            if (_this.concast === concast) _this.waitForOwnResult = false;
        };
        var variables = options.variables && (0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options.variables);
        var _a = this.fetch(options, newNetworkStatus, query), concast = _a.concast, fromLink = _a.fromLink;
        var observer = {
            next: function(result) {
                if ((0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(_this.variables, variables)) {
                    finishWaitingForOwnResult();
                    _this.reportResult(result, variables);
                }
            },
            error: function(error) {
                if ((0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(_this.variables, variables)) {
                    finishWaitingForOwnResult();
                    _this.reportError(error, variables);
                }
            }
        };
        if (!useDisposableConcast && (fromLink || !this.concast)) {
            // We use the {add,remove}Observer methods directly to avoid wrapping
            // observer with an unnecessary SubscriptionObserver object.
            if (this.concast && this.observer) this.concast.removeObserver(this.observer);
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast;
    };
    ObservableQuery.prototype.reobserve = function(newOptions, newNetworkStatus) {
        return this.reobserveAsConcast(newOptions, newNetworkStatus).promise;
    };
    ObservableQuery.prototype.resubscribeAfterError = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // If `lastError` is set in the current when the subscription is re-created,
        // the subscription will immediately receive the error, which will
        // cause it to terminate again. To avoid this, we first clear
        // the last error/result from the `observableQuery` before re-starting
        // the subscription, and restore the last value afterwards so that the
        // subscription has a chance to stay open.
        var last = this.last;
        this.resetLastResults();
        var subscription = this.subscribe.apply(this, args);
        this.last = last;
        return subscription;
    };
    // (Re)deliver the current result to this.observers without applying fetch
    // policies or making network requests.
    ObservableQuery.prototype.observe = function() {
        this.reportResult(// Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function(result, variables) {
        var lastError = this.getLastError();
        var isDifferent = this.isDifferentFromLastResult(result, variables);
        // Update the last result even when isDifferentFromLastResult returns false,
        // because the query may be using the @nonreactive directive, and we want to
        // save the the latest version of any nonreactive subtrees (in case
        // getCurrentResult is called), even though we skip broadcasting changes.
        if (lastError || !result.partial || this.options.returnPartialData) this.updateLastResult(result, variables);
        if (lastError || isDifferent) (0, $835c76846b374893$export$9f6c99ae166dbeca)(this.observers, "next", result);
    };
    ObservableQuery.prototype.reportError = function(error, variables) {
        // Since we don't get the current result on errors, only the error, we
        // must mirror the updates that occur in QueryStore.markQueryError here
        var errorResult = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, this.getLastResult()), {
            error: error,
            errors: error.graphQLErrors,
            networkStatus: (0, $d609460db1ab26e8$export$bd096ddbd246c79c).error,
            loading: false
        });
        this.updateLastResult(errorResult, variables);
        (0, $835c76846b374893$export$9f6c99ae166dbeca)(this.observers, "error", this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function() {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        if (this.isTornDown) return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        // stop all active GraphQL subscriptions
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    ObservableQuery.prototype.transformDocument = function(document) {
        return this.queryManager.transform(document);
    };
    return ObservableQuery;
}((0, $a68a73fcce1c801b$export$77cea355fa80b5f4));
// Necessary because the ObservableQuery constructor has a different
// signature than the Observable constructor.
(0, $396a08d71b4f97f5$export$33c8bd820eece9b2)($e65253b91ec210ab$export$6c1b56eac59c9584);
function $e65253b91ec210ab$export$419171d60552792a(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") return obsQuery.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(currentFetchPolicy, context) {
            // Replace this nextFetchPolicy function in the options object with the
            // original this.options.nextFetchPolicy value.
            this.nextFetchPolicy = nextFetchPolicy;
            // If the original nextFetchPolicy value was a function, give it a
            // chance to decide what happens here.
            if (typeof this.nextFetchPolicy === "function") return this.nextFetchPolicy(currentFetchPolicy, context);
            // Otherwise go back to the original this.options.fetchPolicy.
            return fetchPolicy;
        }
    });
    return obsQuery.reobserve();
}
function $e65253b91ec210ab$var$defaultSubscriptionObserverErrorCallback(error) {
    globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).error(23, error.message, error.stack);
}
function $e65253b91ec210ab$export$b7e1973aacac3ae7(missing) {
    if (globalThis.__DEV__ !== false && missing) globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).debug(24, missing);
}
function $e65253b91ec210ab$var$skipCacheDataFor(fetchPolicy /* `undefined` would mean `"cache-first"` */ ) {
    return fetchPolicy === "network-only" || fetchPolicy === "no-cache" || fetchPolicy === "standby";
}






function $0b283aa4a13714aa$export$e7ecd7c16613ccfd(node) {
    return $0b283aa4a13714aa$export$4cedd8740794bd78(node) || $0b283aa4a13714aa$export$b05c7141ec7770ba(node) || $0b283aa4a13714aa$export$fbc18e88163d676d(node);
}
function $0b283aa4a13714aa$export$4cedd8740794bd78(node) {
    return node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).OPERATION_DEFINITION || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).FRAGMENT_DEFINITION;
}
function $0b283aa4a13714aa$export$65772b71e1d017ba(node) {
    return node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).FIELD || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).FRAGMENT_SPREAD || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).INLINE_FRAGMENT;
}
function $0b283aa4a13714aa$export$ab65b54ec7cbe9e4(node) {
    return node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).VARIABLE || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).INT || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).FLOAT || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).STRING || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).BOOLEAN || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).NULL || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).ENUM || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).LIST || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).OBJECT;
}
function $0b283aa4a13714aa$export$f95bfad9e6aea45f(node) {
    return $0b283aa4a13714aa$export$ab65b54ec7cbe9e4(node) && (node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).LIST ? node.values.some($0b283aa4a13714aa$export$f95bfad9e6aea45f) : node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).OBJECT ? node.fields.some((field)=>$0b283aa4a13714aa$export$f95bfad9e6aea45f(field.value)) : node.kind !== (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).VARIABLE);
}
function $0b283aa4a13714aa$export$26e8a4730f4310f4(node) {
    return node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).NAMED_TYPE || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).LIST_TYPE || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).NON_NULL_TYPE;
}
function $0b283aa4a13714aa$export$b05c7141ec7770ba(node) {
    return node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).SCHEMA_DEFINITION || $0b283aa4a13714aa$export$a3584bba04f5bfe0(node) || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).DIRECTIVE_DEFINITION;
}
function $0b283aa4a13714aa$export$a3584bba04f5bfe0(node) {
    return node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).SCALAR_TYPE_DEFINITION || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).OBJECT_TYPE_DEFINITION || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).INTERFACE_TYPE_DEFINITION || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).UNION_TYPE_DEFINITION || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).ENUM_TYPE_DEFINITION || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_DEFINITION;
}
function $0b283aa4a13714aa$export$fbc18e88163d676d(node) {
    return node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).SCHEMA_EXTENSION || $0b283aa4a13714aa$export$d7907721b241e11f(node);
}
function $0b283aa4a13714aa$export$d7907721b241e11f(node) {
    return node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).SCALAR_TYPE_EXTENSION || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).OBJECT_TYPE_EXTENSION || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).INTERFACE_TYPE_EXTENSION || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).UNION_TYPE_EXTENSION || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).ENUM_TYPE_EXTENSION || node.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).INPUT_OBJECT_TYPE_EXTENSION;
}




var $207419bb6b29c4ef$export$ac9723609f5c76c2 = new (0, $c3407b7f6169ee6c$export$8c6ed5c666ac1360)();
var $207419bb6b29c4ef$var$cacheInfoMap = new WeakMap();
function $207419bb6b29c4ef$var$getCacheInfo(cache) {
    var info = $207419bb6b29c4ef$var$cacheInfoMap.get(cache);
    if (!info) $207419bb6b29c4ef$var$cacheInfoMap.set(cache, info = {
        vars: new Set(),
        dep: (0, $74dd560e5a3ee84c$export$c723b7eff9d8f870)()
    });
    return info;
}
function $207419bb6b29c4ef$export$cbe12faed7725318(cache) {
    $207419bb6b29c4ef$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.forgetCache(cache);
    });
}
function $207419bb6b29c4ef$export$f342bdd61b3e9412(cache) {
    $207419bb6b29c4ef$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.attachCache(cache);
    });
}
function $207419bb6b29c4ef$export$5345c8ac69b4a9db(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function(newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function(cache) {
                    // Invalidate any fields with custom read functions that
                    // consumed this variable, so query results involving those
                    // fields will be recomputed the next time we read them.
                    $207419bb6b29c4ef$var$getCacheInfo(cache).dep.dirty(rv);
                    // Broadcast changes to any caches that have previously read
                    // from this variable.
                    $207419bb6b29c4ef$var$broadcast(cache);
                });
                // Finally, notify any listeners added via rv.onNextChange.
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function(listener) {
                    return listener(value);
                });
            }
        } else {
            // When reading from the variable, obtain the current cache from
            // context via cacheSlot. This isn't entirely foolproof, but it's
            // the same system that powers varDep.
            var cache = $207419bb6b29c4ef$export$ac9723609f5c76c2.getValue();
            if (cache) {
                attach(cache);
                $207419bb6b29c4ef$var$getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function(listener) {
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function(cache) {
        caches.add(cache);
        $207419bb6b29c4ef$var$getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function(cache) {
        return caches.delete(cache);
    };
    return rv;
}
function $207419bb6b29c4ef$var$broadcast(cache) {
    if (cache.broadcastWatches) cache.broadcastWatches();
}


var $6e5099943caf01e5$export$19901bcd339c3ded = /** @class */ function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $f042fd543798b697$export$dd702b3c8240390c)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $f042fd543798b697$export$dd702b3c8240390c)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    // Run local client resolvers against the incoming query and remote data.
    // Locally resolved field values are merged with the incoming remote data,
    // and returned. Note that locally resolved fields will overwrite
    // remote data using the same field name.
    LocalState.prototype.runResolvers = function(_a) {
        return (0, $e2e041e4a1657497$export$1050f835b63b671e)(this, arguments, void 0, function(_b) {
            var document = _b.document, remoteResult = _b.remoteResult, context = _b.context, variables = _b.variables, _c = _b.onlyRunForcedResolvers, onlyRunForcedResolvers = _c === void 0 ? false : _c;
            return (0, $e2e041e4a1657497$export$67ebef60e6f28a6)(this, function(_d) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2 /*return*/ ,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    // Client queries contain everything in the incoming document (if a @client
    // directive is found).
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $d474a5d9bfbef507$export$2dafb573e282fe8d)([
            "client"
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    // Server queries are stripped of all @client based selection sets.
    LocalState.prototype.serverQuery = function(document) {
        return (0, $99a4544cb26a0024$export$8eae69e876ee321e)(document);
    };
    LocalState.prototype.prepareContext = function(context) {
        var cache = this.cache;
        return (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, context), {
            cache: cache,
            // Getting an entry's cache key is useful for local state resolvers.
            getCacheKey: function(obj) {
                return cache.identify(obj);
            }
        });
    };
    // To support `@client @export(as: "someVar")` syntax, we'll first resolve
    // @client @export fields locally, then pass the resolved values back to be
    // used alongside the original operation variables.
    LocalState.prototype.addExportedVariables = function(document_1) {
        return (0, $e2e041e4a1657497$export$1050f835b63b671e)(this, arguments, void 0, function(document, variables, context) {
            if (variables === void 0) variables = {};
            if (context === void 0) context = {};
            return (0, $e2e041e4a1657497$export$67ebef60e6f28a6)(this, function(_a) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2 /*return*/ ,
                    (0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $b5d0850d22ba2059$export$bf638b60ea8b89b7)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === "client" && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === "always" && arg.value.kind === "BooleanValue" && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $b5d0850d22ba2059$export$a89c95c098ac2a58;
                    }
                }
            }
        });
        return forceResolvers;
    };
    // Query the cache and return matching data.
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $99a4544cb26a0024$export$57c368c23873f32b)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document_1, rootValue_1) {
        return (0, $e2e041e4a1657497$export$1050f835b63b671e)(this, arguments, void 0, function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            if (context === void 0) context = {};
            if (variables === void 0) variables = {};
            if (fragmentMatcher === void 0) fragmentMatcher = function() {
                return true;
            };
            if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
            return (0, $e2e041e4a1657497$export$67ebef60e6f28a6)(this, function(_b) {
                mainDefinition = (0, $d34613b28fb40239$export$f431198736b7f96d)(document);
                fragments = (0, $d34613b28fb40239$export$5320a7ba9466a3df)(document);
                fragmentMap = (0, $73d0a56999265e6c$export$193789b4c8246dd4)(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? definitionOperation.charAt(0).toUpperCase() + definitionOperation.slice(1) : "Query";
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                isClientFieldDescendant = false;
                return [
                    2 /*return*/ ,
                    this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0, $e2e041e4a1657497$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $e2e041e4a1657497$export$67ebef60e6f28a6)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $e2e041e4a1657497$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $e2e041e4a1657497$export$67ebef60e6f28a6)(this, function(_a) {
                            if (!isClientFieldDescendant && !execContext.selectionsToResolve.has(selection)) // Skip selections without @client directives
                            // (still processing if one of the ancestors or one of the child fields has @client directive)
                            return [
                                2 /*return*/ 
                            ];
                            if (!(0, $d474a5d9bfbef507$export$3dc388a5f013b4a5)(selection, variables)) // Skip this entirely.
                            return [
                                2 /*return*/ 
                            ];
                            if ((0, $4ab7359740364a58$export$fb56ad75dd311c12)(selection)) return [
                                2 /*return*/ ,
                                this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== "undefined") resultsToMerge.push((_a = {}, _a[(0, $4ab7359740364a58$export$7d1ad22471852218)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $4ab7359740364a58$export$22a1cdafaf27bcff)(selection)) fragment = selection;
                            else {
                                // This is a named fragment.
                                fragment = fragmentMap[selection.name.value];
                                (0, $57583217334b5278$export$f5708dca728d7177)(fragment, 18, selection.name.value);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2 /*return*/ ,
                                    this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                return [
                    2 /*return*/ ,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $f042fd543798b697$export$160070228be94b08)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, isClientFieldDescendant, rootValue, execContext) {
        return (0, $e2e041e4a1657497$export$1050f835b63b671e)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $e2e041e4a1657497$export$67ebef60e6f28a6)(this, function(_a) {
                if (!rootValue) return [
                    2 /*return*/ ,
                    null
                ];
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $4ab7359740364a58$export$7d1ad22471852218)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                // Usually all local resolvers are run when passing through here, but
                // if we've specifically identified that we only want to run forced
                // resolvers (that is, resolvers for fields marked with
                // `@client(always: true)`), then we'll skip running non-forced resolvers.
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(// In case the resolve function accesses reactive variables,
                        // set cacheSlot to the current cache instance.
                        (0, $207419bb6b29c4ef$export$ac9723609f5c76c2).withValue(this.cache, resolve, [
                            rootValue,
                            (0, $4ab7359740364a58$export$3f5a60fb6a781b4f)(field, variables),
                            execContext.context,
                            {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }
                        ]));
                    }
                }
                return [
                    2 /*return*/ ,
                    resultPromise.then(function(result) {
                        var _a, _b;
                        if (result === void 0) result = defaultResult;
                        // If an @export directive is associated with the current field, store
                        // the `as` export variable name and current result for later use.
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === "export" && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === "as" && arg.value.kind === "StringValue") execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        // Handle all scalar types here.
                        if (!field.selectionSet) return result;
                        // From here down, the field has a selection set, which means it's trying
                        // to query a GraphQLObjectType.
                        if (result == null) // Basically any field in a GraphQL response can be null, or missing
                        return result;
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function(d) {
                            return d.name.value === "client";
                        })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        // Returned value is an object, and the query has a sub-selection. Recurse.
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            // This is a nested array, recurse.
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            // This is an object, run the selection set on it.
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
        }));
    };
    // Collect selection nodes on paths from document root down to all @client directives.
    // This function takes into account transitive fragment spreads.
    // Complexity equals to a single `visit` over the full document.
    LocalState.prototype.collectSelectionsToResolve = function(mainDefinition, fragmentMap) {
        var isSingleASTNode = function(node) {
            return !Array.isArray(node);
        };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                (0, $b5d0850d22ba2059$export$bf638b60ea8b89b7)(definitionNode, {
                    Directive: function(node, _, __, ___, ancestors) {
                        if (node.name.value === "client") ancestors.forEach(function(node) {
                            if (isSingleASTNode(node) && (0, $0b283aa4a13714aa$export$65772b71e1d017ba)(node)) matches_1.add(node);
                        });
                    },
                    FragmentSpread: function(spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        (0, $57583217334b5278$export$f5708dca728d7177)(fragment, 19, spread.name.value);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            // Fragment for this spread contains @client directive (either directly or transitively)
                            // Collect selection nodes on paths from the root down to fields with the @client directive
                            ancestors.forEach(function(node) {
                                if (isSingleASTNode(node) && (0, $0b283aa4a13714aa$export$65772b71e1d017ba)(node)) matches_1.add(node);
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function(selection) {
                                matches_1.add(selection);
                            });
                        }
                    }
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}();







var $511ca01b3f7961fe$var$destructiveMethodCounts = new ((0, $9865fa0c1163b711$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
function $511ca01b3f7961fe$var$wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") // @ts-expect-error this is just too generic to be typed correctly
    cache[methodName] = function() {
        $511ca01b3f7961fe$var$destructiveMethodCounts.set(cache, // The %1e15 allows the count to wrap around to 0 safely every
        // quadrillion evictions, so there's no risk of overflow. To be
        // clear, this is more of a pedantic principle than something
        // that matters in any conceivable practical scenario.
        ($511ca01b3f7961fe$var$destructiveMethodCounts.get(cache) + 1) % 1e15);
        // @ts-expect-error this is just too generic to be typed correctly
        return original.apply(this, arguments);
    };
}
function $511ca01b3f7961fe$var$cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
// A QueryInfo object represents a single query managed by the
// QueryManager, which tracks all QueryInfo objects by queryId in its
// this.queries Map. QueryInfo objects store the latest results and errors
// for the given query, and are responsible for reporting those results to
// the corresponding ObservableQuery, via the QueryInfo.notify method.
// Results are reported asynchronously whenever setDiff marks the
// QueryInfo object as dirty, though a call to the QueryManager's
// broadcastQueries method may trigger the notification before it happens
// automatically. This class used to be a simple interface type without
// any field privacy or meaningful methods, which is why it still has so
// many public fields. The effort to lock down and simplify the QueryInfo
// interface is ongoing, and further improvements are welcome.
var $511ca01b3f7961fe$export$79a6120a39c90b6a = /** @class */ function() {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) queryId = queryManager.generateQueryId();
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        // Track how often cache.evict is called, since we want eviction to
        // override the feud-stopping logic in the markResult method, by
        // causing shouldWrite to return true. Wrapping the cache.evict method
        // is a bit of a hack, but it saves us from having to make eviction
        // counting an official part of the ApolloCache API.
        if (!$511ca01b3f7961fe$var$destructiveMethodCounts.has(cache)) {
            $511ca01b3f7961fe$var$destructiveMethodCounts.set(cache, 0);
            $511ca01b3f7961fe$var$wrapDestructiveCacheMethod(cache, "evict");
            $511ca01b3f7961fe$var$wrapDestructiveCacheMethod(cache, "modify");
            $511ca01b3f7961fe$var$wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function(query) {
        var networkStatus = query.networkStatus || (0, $d609460db1ab26e8$export$bd096ddbd246c79c).loading;
        if (this.variables && this.networkStatus !== (0, $d609460db1ab26e8$export$bd096ddbd246c79c).loading && !(0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(this.variables, query.variables)) networkStatus = (0, $d609460db1ab26e8$export$bd096ddbd246c79c).setVariables;
        if (!(0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(query.variables, this.variables)) this.lastDiff = void 0;
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus
        });
        if (query.observableQuery) this.setObservableQuery(query.observableQuery);
        if (query.lastRequestId) this.lastRequestId = query.lastRequestId;
        return this;
    };
    QueryInfo.prototype.reset = function() {
        $511ca01b3f7961fe$var$cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.resetDiff = function() {
        this.lastDiff = void 0;
    };
    QueryInfo.prototype.getDiff = function() {
        var options = this.getDiffOptions();
        if (this.lastDiff && (0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(options, this.lastDiff.options)) return this.lastDiff.diff;
        this.updateWatch(this.variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return {
            complete: false
        };
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function(diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions()
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function(variables) {
        var _a;
        if (variables === void 0) variables = this.variables;
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults
        };
    };
    QueryInfo.prototype.setDiff = function(diff) {
        var _this = this;
        var _a;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        // If we do not tolerate partial results, skip this update to prevent it
        // from being reported. This prevents a situtuation where a query that
        // errors and another succeeds with overlapping data does not report the
        // partial data result to the errored query.
        //
        // See https://github.com/apollographql/apollo-client/issues/11400 for more
        // information on this issue.
        if (diff && !diff.complete && !((_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.returnPartialData) && // In the case of a cache eviction, the diff will become partial so we
        // schedule a notification to send a network request (this.oqListener) to
        // go and fetch the missing data.
        !(oldDiff && oldDiff.complete)) return;
        this.updateLastDiff(diff);
        if (!this.dirty && !(0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) this.notifyTimeout = setTimeout(function() {
                return _this.notify();
            }, 0);
        }
    };
    QueryInfo.prototype.setObservableQuery = function(oq) {
        var _this = this;
        if (oq === this.observableQuery) return;
        if (this.oqListener) this.listeners.delete(this.oqListener);
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function() {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) // If this diff came from an optimistic transaction, deliver the
                // current cache data to the ObservableQuery, but don't perform a
                // reobservation, since oq.reobserveCacheFirst might make a network
                // request, and we never want to trigger network requests in the
                // middle of optimistic updates.
                oq["observe"]();
                else // Otherwise, make the ObservableQuery "reobserve" the latest data
                // using a temporary fetch policy of "cache-first", so complete cache
                // results have a chance to be delivered without triggering additional
                // network requests, even when options.fetchPolicy is "network-only"
                // or "cache-and-network". All other fetch policies are preserved by
                // this method, and are handled by calling oq.reobserve(). If this
                // reobservation is spurious, isDifferentFromLastResult still has a
                // chance to catch it before delivery to ObservableQuery subscribers.
                (0, $e65253b91ec210ab$export$419171d60552792a)(oq);
            });
        } else delete this.oqListener;
    };
    QueryInfo.prototype.notify = function() {
        var _this = this;
        $511ca01b3f7961fe$var$cancelNotifyTimeout(this);
        if (this.shouldNotify()) this.listeners.forEach(function(listener) {
            return listener(_this);
        });
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function() {
        if (!this.dirty || !this.listeners.size) return false;
        if ((0, $d609460db1ab26e8$export$37509604341a3464)(this.networkStatus) && this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" && fetchPolicy !== "cache-and-network") return false;
        }
        return true;
    };
    QueryInfo.prototype.stop = function() {
        if (!this.stopped) {
            this.stopped = true;
            // Cancel the pending notify timeout
            this.reset();
            this.cancel();
            // Revert back to the no-op version of cancel inherited from
            // QueryInfo.prototype.
            this.cancel = QueryInfo.prototype.cancel;
            var oq = this.observableQuery;
            if (oq) oq.stopPolling();
        }
    };
    // This method is a no-op by default, until/unless overridden by the
    // updateWatch method.
    QueryInfo.prototype.cancel = function() {};
    QueryInfo.prototype.updateWatch = function(variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return;
        var watchOptions = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, this.getDiffOptions(variables)), {
            watcher: this,
            callback: function(diff) {
                return _this.setDiff(diff);
            }
        });
        if (!this.lastWatch || !(0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function() {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function(result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite && // If cache.evict has been called since the last time we wrote this
        // data into the cache, there's a chance writing this result into
        // the cache will repair what was evicted.
        lastWrite.dmCount === $511ca01b3f7961fe$var$destructiveMethodCounts.get(this.cache) && (0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(variables, lastWrite.variables) && (0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function(result, document, options, cacheWriteBehavior) {
        var _this = this;
        var merger = new (0, $f042fd543798b697$export$509e11c221f576c0)();
        var graphQLErrors = (0, $93b6d5db950815ab$export$d307f5934e447d0e)(result.errors) ? result.errors.slice(0) : [];
        // Cancel the pending notify timeout (if it exists) to prevent extraneous network
        // requests. To allow future notify timeouts, diff and dirty are reset as well.
        this.reset();
        if ("incremental" in result && (0, $93b6d5db950815ab$export$d307f5934e447d0e)(result.incremental)) {
            var mergedData = (0, $2b0bc46d60dcff8e$export$9a905f57d6393874)(this.getDiff().result, result);
            result.data = mergedData;
        // Detect the first chunk of a deferred query and merge it with existing
        // cache data. This ensures a `cache-first` fetch policy that returns
        // partial cache data or a `cache-and-network` fetch policy that already
        // has full data in the cache does not complain when trying to merge the
        // initial deferred server data with existing cache data.
        } else if ("hasNext" in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === "no-cache") this.updateLastDiff({
            result: result.data,
            complete: true
        }, this.getDiffOptions(options.variables));
        else if (cacheWriteBehavior !== 0 /* CacheWriteBehavior.FORBID */ ) {
            if ($511ca01b3f7961fe$export$5f47a9fb9a521654(result, options.errorPolicy)) // Using a transaction here so we have a chance to read the result
            // back from the cache before the watch callback fires as a result
            // of writeQuery, so we can store the new diff quietly and ignore
            // it when we receive it redundantly from the watch callback.
            this.cache.performTransaction(function(cache) {
                if (_this.shouldWrite(result, options.variables)) {
                    cache.writeQuery({
                        query: document,
                        data: result.data,
                        variables: options.variables,
                        overwrite: cacheWriteBehavior === 1 /* CacheWriteBehavior.OVERWRITE */ 
                    });
                    _this.lastWrite = {
                        result: result,
                        variables: options.variables,
                        dmCount: $511ca01b3f7961fe$var$destructiveMethodCounts.get(_this.cache)
                    };
                } else // If result is the same as the last result we received from
                // the network (and the variables match too), avoid writing
                // result into the cache again. The wisdom of skipping this
                // cache write is far from obvious, since any cache write
                // could be the one that puts the cache back into a desired
                // state, fixing corruption or missing data. However, if we
                // always write every network result into the cache, we enable
                // feuds between queries competing to update the same data in
                // incompatible ways, which can lead to an endless cycle of
                // cache broadcasts and useless network requests. As with any
                // feud, eventually one side must step back from the brink,
                // letting the other side(s) have the last word(s). There may
                // be other points where we could break this cycle, such as
                // silencing the broadcast for cache.writeQuery (not a good
                // idea, since it just delays the feud a bit) or somehow
                // avoiding the network request that just happened (also bad,
                // because the server could return useful new data). All
                // options considered, skipping this cache write seems to be
                // the least damaging place to break the cycle, because it
                // reflects the intuition that we recently wrote this exact
                // result into the cache, so the cache *should* already/still
                // contain this data. If some other query has clobbered that
                // data in the meantime, that's too bad, but there will be no
                // winners if every query blindly reverts to its own version
                // of the data. This approach also gives the network a chance
                // to return new data, which will be written into the cache as
                // usual, notifying only those queries that are directly
                // affected by the cache updates, as usual. In the future, an
                // even more sophisticated cache could perhaps prevent or
                // mitigate the clobbering somehow, but that would make this
                // particular cache write even less important, and thus
                // skipping it would be even safer than it is today.
                if (_this.lastDiff && _this.lastDiff.diff.complete) {
                    // Reuse data from the last good (complete) diff that we
                    // received, when possible.
                    result.data = _this.lastDiff.diff.result;
                    return;
                }
                var diffOptions = _this.getDiffOptions(options.variables);
                var diff = cache.diff(diffOptions);
                // In case the QueryManager stops this QueryInfo before its
                // results are delivered, it's important to avoid restarting the
                // cache watch when markResult is called. We also avoid updating
                // the watch if we are writing a result that doesn't match the current
                // variables to avoid race conditions from broadcasting the wrong
                // result.
                if (!_this.stopped && (0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(_this.variables, options.variables)) // Any time we're about to update this.diff, we need to make
                // sure we've started watching the cache.
                _this.updateWatch(options.variables);
                // If we're allowed to write to the cache, and we can read a
                // complete result from the cache, update result.data to be the
                // result from the cache, rather than the raw network result.
                // Set without setDiff to avoid triggering a notify call, since
                // we have other ways of notifying for this result.
                _this.updateLastDiff(diff, diffOptions);
                if (diff.complete) result.data = diff.result;
            });
            else this.lastWrite = void 0;
        }
    };
    QueryInfo.prototype.markReady = function() {
        this.networkError = null;
        return this.networkStatus = (0, $d609460db1ab26e8$export$bd096ddbd246c79c).ready;
    };
    QueryInfo.prototype.markError = function(error) {
        this.networkStatus = (0, $d609460db1ab26e8$export$bd096ddbd246c79c).error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) this.graphQLErrors = error.graphQLErrors;
        if (error.networkError) this.networkError = error.networkError;
        return error;
    };
    return QueryInfo;
}();
function $511ca01b3f7961fe$export$5f47a9fb9a521654(result, errorPolicy) {
    if (errorPolicy === void 0) errorPolicy = "none";
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !(0, $8019e8bf785fd372$export$b4df399e879e53ab)(result);
    if (!writeWithErrors && ignoreErrors && result.data) writeWithErrors = true;
    return writeWithErrors;
}



var $f5fd269eab7d7902$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f5fd269eab7d7902$var$IGNORE = Object.create(null);
var $f5fd269eab7d7902$export$b986383a50b53ea4 = /** @class */ function() {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, defaultOptions = _a.defaultOptions, documentTransform = _a.documentTransform, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, _e = _a.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? !!cache.assumeImmutableResults : _e, defaultContext = _a.defaultContext;
        var _this = this;
        this.clientAwareness = {};
        // All the queries that the QueryManager is currently managing (not
        // including mutations and subscriptions).
        this.queries = new Map();
        // Maps from queryId strings to Promise rejection functions for
        // currently active queries and fetches.
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.fetchCancelFns = new Map();
        this.transformCache = new (0, $df1718e4a0eb4d0a$export$8dbad6f439bb2331)((0, $e8270474df1c6a9d$export$f29926b23b28936b)["queryManager.getDocumentInfo"] || 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ );
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.inFlightLinkObservables = new (0, $26d4e625bb2590d6$export$73571c50d0f2507e)(false);
        var defaultDocumentTransform = new (0, $bbdf4b1635f5cf2f$export$f887060e48e5dc1b)(function(document) {
            return _this.cache.transformDocument(document);
        }, // Allow the apollo cache to manage its own transform caches
        {
            cache: false
        });
        this.cache = cache;
        this.link = link;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new (0, $6e5099943caf01e5$export$19901bcd339c3ded)({
            cache: cache
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = assumeImmutableResults;
        this.documentTransform = documentTransform ? defaultDocumentTransform.concat(documentTransform)// The custom document transform may add new fragment spreads or new
        // field selections, so we want to give the cache a chance to run
        // again. For example, the InMemoryCache adds __typename to field
        // selections and fragments from the fragment registry.
        .concat(defaultDocumentTransform) : defaultDocumentTransform;
        this.defaultContext = defaultContext || Object.create(null);
        if (this.onBroadcast = onBroadcast) this.mutationStore = Object.create(null);
    }
    /**
     * Call this method to terminate any active query processes, making it safe
     * to dispose of this QueryManager instance.
     */ QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches((0, $57583217334b5278$export$3991762405098ea)(25));
    };
    QueryManager.prototype.cancelPendingFetches = function(error) {
        this.fetchCancelFns.forEach(function(cancel) {
            return cancel(error);
        });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function(_a) {
        return (0, $e2e041e4a1657497$export$1050f835b63b671e)(this, arguments, void 0, function(_b) {
            var mutationId, hasClientExports, mutationStoreValue, isOptimistic, self;
            var _c, _d;
            var mutation = _b.mutation, variables = _b.variables, optimisticResponse = _b.optimisticResponse, updateQueries = _b.updateQueries, _e = _b.refetchQueries, refetchQueries = _e === void 0 ? [] : _e, _f = _b.awaitRefetchQueries, awaitRefetchQueries = _f === void 0 ? false : _f, updateWithProxyFn = _b.update, onQueryUpdated = _b.onQueryUpdated, _g = _b.fetchPolicy, fetchPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.fetchPolicy) || "network-only" : _g, _h = _b.errorPolicy, errorPolicy = _h === void 0 ? ((_d = this.defaultOptions.mutate) === null || _d === void 0 ? void 0 : _d.errorPolicy) || "none" : _h, keepRootFields = _b.keepRootFields, context = _b.context;
            return (0, $e2e041e4a1657497$export$67ebef60e6f28a6)(this, function(_j) {
                switch(_j.label){
                    case 0:
                        (0, $57583217334b5278$export$f5708dca728d7177)(mutation, 26);
                        (0, $57583217334b5278$export$f5708dca728d7177)(fetchPolicy === "network-only" || fetchPolicy === "no-cache", 27);
                        mutationId = this.generateMutationId();
                        mutation = this.cache.transformForLink(this.transform(mutation));
                        hasClientExports = this.getDocumentInfo(mutation).hasClientExports;
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _j.sent();
                        _j.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore && (this.mutationStore[mutationId] = {
                            mutation: mutation,
                            variables: variables,
                            loading: true,
                            error: null
                        });
                        isOptimistic = optimisticResponse && this.markMutationOptimistic(optimisticResponse, {
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            fetchPolicy: fetchPolicy,
                            errorPolicy: errorPolicy,
                            context: context,
                            updateQueries: updateQueries,
                            update: updateWithProxyFn,
                            keepRootFields: keepRootFields
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                return (0, $f4e2d5e8d6701548$export$707ee4c4c95d39e3)(self.getObservableFromLink(mutation, (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, context), {
                                    optimisticResponse: isOptimistic ? optimisticResponse : void 0
                                }), variables, false), function(result) {
                                    if ((0, $8019e8bf785fd372$export$b4df399e879e53ab)(result) && errorPolicy === "none") throw new (0, $9eab3cada5a2feb5$export$26a337512320b8c6)({
                                        graphQLErrors: (0, $8019e8bf785fd372$export$a163557155188b6e)(result)
                                    });
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, result);
                                    if (typeof refetchQueries === "function") refetchQueries = refetchQueries(storeResult);
                                    if (errorPolicy === "ignore" && (0, $8019e8bf785fd372$export$b4df399e879e53ab)(storeResult)) delete storeResult.errors;
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: isOptimistic ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields
                                    });
                                }).subscribe({
                                    next: function(storeResult) {
                                        self.broadcastQueries();
                                        // Since mutations might receive multiple payloads from the
                                        // ApolloLink chain (e.g. when used with @defer),
                                        // we resolve with a SingleExecutionResult or after the final
                                        // ExecutionPatchResult has arrived and we have assembled the
                                        // multipart response into a single result.
                                        if (!("hasNext" in storeResult) || storeResult.hasNext === false) resolve(storeResult);
                                    },
                                    error: function(err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (isOptimistic) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        reject(err instanceof (0, $9eab3cada5a2feb5$export$26a337512320b8c6) ? err : new (0, $9eab3cada5a2feb5$export$26a337512320b8c6)({
                                            networkError: err
                                        }));
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function(mutation, cache) {
        var _this = this;
        if (cache === void 0) cache = this.cache;
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && (0, $511ca01b3f7961fe$export$5f47a9fb9a521654)(result, mutation.errorPolicy)) {
            if (!(0, $2b0bc46d60dcff8e$export$879767c5cdf33cb3)(result)) cacheWrites.push({
                result: result.data,
                dataId: "ROOT_MUTATION",
                query: mutation.document,
                variables: mutation.variables
            });
            if ((0, $2b0bc46d60dcff8e$export$879767c5cdf33cb3)(result) && (0, $93b6d5db950815ab$export$d307f5934e447d0e)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    // The cache complains if passed a mutation where it expects a
                    // query, so we transform mutations and subscriptions to queries
                    // (only once, thanks to this.transformCache).
                    query: this.getDocumentInfo(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true
                });
                var mergedData = void 0;
                if (diff.result) mergedData = (0, $2b0bc46d60dcff8e$export$9a905f57d6393874)(diff.result, result);
                if (typeof mergedData !== "undefined") {
                    // cast the ExecutionPatchResult to FetchResult here since
                    // ExecutionPatchResult never has `data` when returned from the server
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: "ROOT_MUTATION",
                        query: mutation.document,
                        variables: mutation.variables
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                var queryName = observableQuery && observableQuery.queryName;
                if (!queryName || !$f5fd269eab7d7902$var$hasOwnProperty.call(updateQueries_1, queryName)) return;
                var updater = updateQueries_1[queryName];
                var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                // Read the current query result from the store.
                var _c = cache.diff({
                    query: document,
                    variables: variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _c.result, complete = _c.complete;
                if (complete && currentQueryResult) {
                    // Run our reducer using the current query result and the mutation result.
                    var nextQueryResult = updater(currentQueryResult, {
                        mutationResult: result,
                        queryName: document && (0, $d34613b28fb40239$export$41bca9dc6871dd4e)(document) || void 0,
                        queryVariables: variables
                    });
                    // Write the modified result back into the store if we got a new result.
                    if (nextQueryResult) cacheWrites.push({
                        result: nextQueryResult,
                        dataId: "ROOT_QUERY",
                        query: document,
                        variables: variables
                    });
                }
            });
        }
        if (cacheWrites.length > 0 || (mutation.refetchQueries || "").length > 0 || mutation.update || mutation.onQueryUpdated || mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function(cache) {
                    if (!skipCache) cacheWrites.forEach(function(write) {
                        return cache.write(write);
                    });
                    // If the mutation has some writes associated with it then we need to
                    // apply those writes to the store by running this reducer again with
                    // a write action.
                    var update = mutation.update;
                    // Determine whether result is a SingleExecutionResult,
                    // or the final ExecutionPatchResult.
                    var isFinalResult = !(0, $2b0bc46d60dcff8e$export$f90dc0a3531b8b83)(result) || (0, $2b0bc46d60dcff8e$export$879767c5cdf33cb3)(result) && !result.hasNext;
                    if (update) {
                        if (!skipCache) {
                            // Re-read the ROOT_MUTATION data we just wrote into the cache
                            // (the first cache.write call in the cacheWrites.forEach loop
                            // above), so field read functions have a chance to run for
                            // fields within mutation result objects.
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                // The cache complains if passed a mutation where it expects a
                                // query, so we transform mutations and subscriptions to queries
                                // (only once, thanks to this.transformCache).
                                query: _this.getDocumentInfo(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true
                            });
                            if (diff.complete) {
                                result = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, result), {
                                    data: diff.result
                                });
                                if ("incremental" in result) delete result.incremental;
                                if ("hasNext" in result) delete result.hasNext;
                            }
                        }
                        // If we've received the whole response,
                        // either a SingleExecutionResult or the final ExecutionPatchResult,
                        // call the update function.
                        if (isFinalResult) update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables
                        });
                    }
                    // TODO Do this with cache.evict({ id: 'ROOT_MUTATION' }) but make it
                    // shallow to allow rolling back optimistic evictions.
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) cache.modify({
                        id: "ROOT_MUTATION",
                        fields: function(value, _a) {
                            var fieldName = _a.fieldName, DELETE = _a.DELETE;
                            return fieldName === "__typename" ? value : DELETE;
                        }
                    });
                },
                include: mutation.refetchQueries,
                // Write the final mutation.result to the root layer of the cache.
                optimistic: false,
                // Remove the corresponding optimistic layer at the same time as we
                // write the final non-optimistic result.
                removeOptimistic: mutation.removeOptimistic,
                // Let the caller of client.mutate optionally determine the refetching
                // behavior for watched queries after the mutation.update function runs.
                // If no onQueryUpdated function was provided for this mutation, pass
                // null instead of undefined to disable the default refetching behavior.
                onQueryUpdated: mutation.onQueryUpdated || null
            }).forEach(function(result) {
                return results_1.push(result);
            });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) // Returning a promise here makes the mutation await that promise, so we
            // include results in that promise's work if awaitRefetchQueries or an
            // onQueryUpdated function was specified.
            return Promise.all(results_1).then(function() {
                return result;
            });
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function(optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ? optimisticResponse(mutation.variables, {
            IGNORE: $f5fd269eab7d7902$var$IGNORE
        }) : optimisticResponse;
        if (data === $f5fd269eab7d7902$var$IGNORE) return false;
        this.cache.recordOptimisticTransaction(function(cache) {
            try {
                _this.markMutationResult((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, mutation), {
                    result: {
                        data: data
                    }
                }), cache);
            } catch (error) {
                globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).error(error);
            }
        }, mutation.mutationId);
        return true;
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, networkStatus) {
        return this.fetchConcastWithInfo(queryId, options, networkStatus).concast.promise;
    };
    QueryManager.prototype.getQueryStore = function() {
        var store = Object.create(null);
        this.queries.forEach(function(info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function(document) {
        return this.documentTransform.transformDocument(document);
    };
    QueryManager.prototype.getDocumentInfo = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cacheEntry = {
                // TODO These three calls (hasClientExports, shouldForceResolvers, and
                // usesNonreactiveDirective) are performing independent full traversals
                // of the transformed document. We should consider merging these
                // traversals into a single pass in the future, though the work is
                // cached after the first time.
                hasClientExports: (0, $d474a5d9bfbef507$export$8d1e9e5bbfa5d09a)(document),
                hasForcedResolvers: this.localState.shouldForceResolvers(document),
                hasNonreactiveDirective: (0, $d474a5d9bfbef507$export$2dafb573e282fe8d)([
                    "nonreactive"
                ], document),
                clientQuery: this.localState.clientQuery(document),
                serverQuery: (0, $99a4544cb26a0024$export$e5ae0530da5fe96c)([
                    {
                        name: "client",
                        remove: true
                    },
                    {
                        name: "connection"
                    },
                    {
                        name: "nonreactive"
                    }
                ], document),
                defaultVars: (0, $d34613b28fb40239$export$84c19026e616569e)((0, $d34613b28fb40239$export$7a5b1fa979d2c158)(document)),
                // Transform any mutation or subscription operations to query operations
                // so we can read/write them from/to the cache.
                asQuery: (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, document), {
                    definitions: document.definitions.map(function(def) {
                        if (def.kind === "OperationDefinition" && def.operation !== "query") return (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, def), {
                            operation: "query"
                        });
                        return def;
                    })
                })
            };
            transformCache.set(document, cacheEntry);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, this.getDocumentInfo(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options) {
        var query = this.transform(options.query);
        // assign variable default values if supplied
        // NOTE: We don't modify options.query here with the transformed query to
        // ensure observable.options.query is set to the raw untransformed query.
        options = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options), {
            variables: this.getVariables(query, options.variables)
        });
        if (typeof options.notifyOnNetworkStatusChange === "undefined") options.notifyOnNetworkStatusChange = false;
        var queryInfo = new (0, $511ca01b3f7961fe$export$79a6120a39c90b6a)(this);
        var observable = new (0, $e65253b91ec210ab$export$6c1b56eac59c9584)({
            queryManager: this,
            queryInfo: queryInfo,
            options: options
        });
        observable["lastQuery"] = query;
        this.queries.set(observable.queryId, queryInfo);
        // We give queryInfo the transformed query to ensure the first cache diff
        // uses the transformed query instead of the raw query
        queryInfo.init({
            document: query,
            observableQuery: observable,
            variables: observable.variables
        });
        return observable;
    };
    QueryManager.prototype.query = function(options, queryId) {
        var _this = this;
        if (queryId === void 0) queryId = this.generateQueryId();
        (0, $57583217334b5278$export$f5708dca728d7177)(options.query, 28);
        (0, $57583217334b5278$export$f5708dca728d7177)(options.query.kind === "Document", 29);
        (0, $57583217334b5278$export$f5708dca728d7177)(!options.returnPartialData, 30);
        (0, $57583217334b5278$export$f5708dca728d7177)(!options.pollInterval, 31);
        return this.fetchQuery(queryId, (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options), {
            query: this.transform(options.query)
        })).finally(function() {
            return _this.stopQuery(queryId);
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function(options) {
        if (options === void 0) options = {
            discardWatches: true
        };
        // Before we have sent the reset action to the store, we can no longer
        // rely on the results returned by in-flight requests since these may
        // depend on values that previously existed in the data portion of the
        // store. So, we cancel the promises and observers that we have issued
        // so far and not yet resolved (in the case of queries).
        this.cancelPendingFetches((0, $57583217334b5278$export$3991762405098ea)(32));
        this.queries.forEach(function(queryInfo) {
            if (queryInfo.observableQuery) // Set loading to true so listeners don't trigger unless they want
            // results with partial data.
            queryInfo.networkStatus = (0, $d609460db1ab26e8$export$bd096ddbd246c79c).loading;
            else queryInfo.stop();
        });
        if (this.mutationStore) this.mutationStore = Object.create(null);
        // begin removing data from the store
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function(include) {
        var _this = this;
        if (include === void 0) include = "active";
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) include.forEach(function(desc) {
            if (typeof desc === "string") queryNamesAndDocs.set(desc, false);
            else if ((0, $4ab7359740364a58$export$540432d49fcec6c9)(desc)) queryNamesAndDocs.set(_this.transform(desc), false);
            else if ((0, $a5b286f532530da9$export$417207af72fad9c9)(desc) && desc.query) legacyQueryOptions.add(desc);
        });
        this.queries.forEach(function(_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" || include === "active" && !oq.hasObservers()) return;
                if (include === "active" || queryName && queryNamesAndDocs.has(queryName) || document && queryNamesAndDocs.has(document)) {
                    queries.set(queryId, oq);
                    if (queryName) queryNamesAndDocs.set(queryName, true);
                    if (document) queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) legacyQueryOptions.forEach(function(options) {
            // We will be issuing a fresh network request for this query, so we
            // pre-allocate a new query ID here, using a special prefix to enable
            // cleaning up these temporary queries later, after fetching.
            var queryId = (0, $57915ec4a20ed3d0$export$d0c8ec0fe1b18b70)("legacyOneTimeQuery");
            var queryInfo = _this.getQuery(queryId).init({
                document: options.query,
                variables: options.variables
            });
            var oq = new (0, $e65253b91ec210ab$export$6c1b56eac59c9584)({
                queryManager: _this,
                queryInfo: queryInfo,
                options: (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options), {
                    fetchPolicy: "network-only"
                })
            });
            (0, $57583217334b5278$export$f5708dca728d7177)(oq.queryId === queryId);
            queryInfo.setObservableQuery(oq);
            queries.set(queryId, oq);
        });
        if (globalThis.__DEV__ !== false && queryNamesAndDocs.size) queryNamesAndDocs.forEach(function(included, nameOrDoc) {
            if (!included) globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).warn(typeof nameOrDoc === "string" ? 33 : 34, nameOrDoc);
        });
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function(observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby || fetchPolicy !== "standby" && fetchPolicy !== "cache-only") observableQueryPromises.push(observableQuery.refetch());
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function(observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, _b = _a.errorPolicy, errorPolicy = _b === void 0 ? "none" : _b, variables = _a.variables, _c = _a.context, context = _c === void 0 ? {} : _c;
        query = this.transform(query);
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, context, variables).map(function(result) {
                if (fetchPolicy !== "no-cache") {
                    // the subscription interface should handle not sending us results we no longer subscribe to.
                    // XXX I don't think we ever send in an object with errors, but we might in the future...
                    if ((0, $511ca01b3f7961fe$export$5f47a9fb9a521654)(result, errorPolicy)) _this.cache.write({
                        query: query,
                        result: result.data,
                        dataId: "ROOT_SUBSCRIPTION",
                        variables: variables
                    });
                    _this.broadcastQueries();
                }
                var hasErrors = (0, $8019e8bf785fd372$export$b4df399e879e53ab)(result);
                var hasProtocolErrors = (0, $9eab3cada5a2feb5$export$345f95cc6b6b9b0b)(result);
                if (hasErrors || hasProtocolErrors) {
                    var errors = {};
                    if (hasErrors) errors.graphQLErrors = result.errors;
                    if (hasProtocolErrors) errors.protocolErrors = result.extensions[0, $9eab3cada5a2feb5$export$4995664c1b49842e];
                    // `errorPolicy` is a mechanism for handling GraphQL errors, according
                    // to our documentation, so we throw protocol errors regardless of the
                    // set error policy.
                    if (errorPolicy === "none" || hasProtocolErrors) throw new (0, $9eab3cada5a2feb5$export$26a337512320b8c6)(errors);
                }
                if (errorPolicy === "ignore") delete result.errors;
                return result;
            });
        };
        if (this.getDocumentInfo(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new (0, $a68a73fcce1c801b$export$77cea355fa80b5f4)(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        // teardown all links
        // Both `QueryManager.fetchRequest` and `QueryManager.query` create separate promises
        // that each add their reject functions to fetchCancelFns.
        // A query created with `QueryManager.query()` could trigger a `QueryManager.fetchRequest`.
        // The same queryId could have two rejection fns for two promises
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function() {
        if (this.onBroadcast) this.onBroadcast();
        this.queries.forEach(function(info) {
            return info.notify();
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, // Prefer context.queryDeduplication if specified.
    deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication;
        var observable;
        var _b = this.getDocumentInfo(query), serverQuery = _b.serverQuery, clientQuery = _b.clientQuery;
        if (serverQuery) {
            var _c = this, inFlightLinkObservables_1 = _c.inFlightLinkObservables, link = _c.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $d34613b28fb40239$export$41bca9dc6871dd4e)(serverQuery) || void 0,
                context: this.prepareContext((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var printedServerQuery_1 = (0, $faf63d297e5a9103$export$c2d084dc44961371)(serverQuery);
                var varJson_1 = (0, $78b40fbe7ce5625c$export$88a0ad9b6f961b51)(variables);
                var entry = inFlightLinkObservables_1.lookup(printedServerQuery_1, varJson_1);
                observable = entry.observable;
                if (!observable) {
                    var concast = new (0, $e6c0cda17ebd3d4e$export$ae0cf2ec7a6fa78e)([
                        (0, $fc0c11c3044842d0$export$51396ec711da548b)(link, operation)
                    ]);
                    observable = entry.observable = concast;
                    concast.beforeNext(function() {
                        inFlightLinkObservables_1.remove(printedServerQuery_1, varJson_1);
                    });
                }
            } else observable = new (0, $e6c0cda17ebd3d4e$export$ae0cf2ec7a6fa78e)([
                (0, $fc0c11c3044842d0$export$51396ec711da548b)(link, operation)
            ]);
        } else {
            observable = new (0, $e6c0cda17ebd3d4e$export$ae0cf2ec7a6fa78e)([
                (0, $a68a73fcce1c801b$export$77cea355fa80b5f4).of({
                    data: {}
                })
            ]);
            context = this.prepareContext(context);
        }
        if (clientQuery) observable = (0, $f4e2d5e8d6701548$export$707ee4c4c95d39e3)(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function(queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        // Performing transformForLink here gives this.cache a chance to fill in
        // missing fragment definitions (for example) before sending this document
        // through the link chain.
        var linkDocument = this.cache.transformForLink(options.query);
        return (0, $f4e2d5e8d6701548$export$707ee4c4c95d39e3)(this.getObservableFromLink(linkDocument, options.context, options.variables), function(result) {
            var graphQLErrors = (0, $8019e8bf785fd372$export$a163557155188b6e)(result);
            var hasErrors = graphQLErrors.length > 0;
            // If we interrupted this request by calling getResultsFromLink again
            // with the same QueryInfo object, we ignore the old results.
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") // Throwing here effectively calls observer.error.
                throw queryInfo.markError(new (0, $9eab3cada5a2feb5$export$26a337512320b8c6)({
                    graphQLErrors: graphQLErrors
                }));
                // Use linkDocument rather than queryInfo.document so the
                // operation/fragments used to write the result are the same as the
                // ones used to obtain it from the link.
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: (0, $d609460db1ab26e8$export$bd096ddbd246c79c).ready
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = (0, $d609460db1ab26e8$export$bd096ddbd246c79c).error;
            }
            return aqr;
        }, function(networkError) {
            var error = (0, $9eab3cada5a2feb5$export$17f5e6bd290bb15d)(networkError) ? networkError : new (0, $9eab3cada5a2feb5$export$26a337512320b8c6)({
                networkError: networkError
            });
            // Avoid storing errors from older interrupted queries.
            if (requestId >= queryInfo.lastRequestId) queryInfo.markError(error);
            throw error;
        });
    };
    QueryManager.prototype.fetchConcastWithInfo = function(queryId, options, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus, query) {
        var _this = this;
        if (networkStatus === void 0) networkStatus = (0, $d609460db1ab26e8$export$bd096ddbd246c79c).loading;
        if (query === void 0) query = options.query;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context
        });
        var fromVariables = function(variables) {
            // Since normalized is always a fresh copy of options, it's safe to
            // modify its properties here, rather than creating yet another new
            // WatchQueryOptions object.
            normalized.variables = variables;
            var sourcesWithInfo = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (// If we're in standby, postpone advancing options.fetchPolicy using
            // applyNextFetchPolicy.
            normalized.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
            // this is another way to detect when nothing was done/fetched.
            sourcesWithInfo.sources.length > 0 && queryInfo.observableQuery) queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            return sourcesWithInfo;
        };
        // This cancel function needs to be set before the concast is created,
        // in case concast creation synchronously cancels the request.
        var cleanupCancelFn = function() {
            return _this.fetchCancelFns.delete(queryId);
        };
        this.fetchCancelFns.set(queryId, function(reason) {
            cleanupCancelFn();
            // This delay ensures the concast variable has been initialized.
            setTimeout(function() {
                return concast.cancel(reason);
            });
        });
        var concast, containsDataFromLink;
        // If the query has @export(as: ...) directives, then we need to
        // process those directives asynchronously. When there are no
        // @export directives (the common case), we deliberately avoid
        // wrapping the result of this.fetchQueryByPolicy in a Promise,
        // since the timing of result delivery is (unfortunately) important
        // for backwards compatibility. TODO This code could be simpler if
        // we deprecated and removed LocalState.
        if (this.getDocumentInfo(normalized.query).hasClientExports) {
            concast = new (0, $e6c0cda17ebd3d4e$export$ae0cf2ec7a6fa78e)(this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables).then(function(sourcesWithInfo) {
                return sourcesWithInfo.sources;
            }));
            // there is just no way we can synchronously get the *right* value here,
            // so we will assume `true`, which is the behaviour before the bug fix in
            // #10597. This means that bug is not fixed in that case, and is probably
            // un-fixable with reasonable effort for the edge case of @export as
            // directives.
            containsDataFromLink = true;
        } else {
            var sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            concast = new (0, $e6c0cda17ebd3d4e$export$ae0cf2ec7a6fa78e)(sourcesWithInfo.sources);
        }
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return {
            concast: concast,
            fromLink: containsDataFromLink
        };
    };
    QueryManager.prototype.refetchQueries = function(_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0, $57915ec4a20ed3d0$export$d0c8ec0fe1b18b70)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) this.getObservableQueries(include).forEach(function(oq, queryId) {
            includedQueriesById.set(queryId, {
                oq: oq,
                lastDiff: _this.getQuery(queryId).getDiff()
            });
        });
        var results = new Map();
        if (updateCache) this.cache.batch({
            update: updateCache,
            // Since you can perform any combination of cache reads and/or writes in
            // the cache.batch update function, its optimistic option can be either
            // a boolean or a string, representing three distinct modes of
            // operation:
            //
            // * false: read/write only the root layer
            // * true: read/write the topmost layer
            // * string: read/write a fresh optimistic layer with that ID string
            //
            // When typeof optimistic === "string", a new optimistic layer will be
            // temporarily created within cache.batch with that string as its ID. If
            // we then pass that same string as the removeOptimistic option, we can
            // make cache.batch immediately remove the optimistic layer after
            // running the updateCache function, triggering only one broadcast.
            //
            // However, the refetchQueries method accepts only true or false for its
            // optimistic option (not string). We interpret true to mean a temporary
            // optimistic layer should be created, to allow efficiently rolling back
            // the effect of the updateCache function, which involves passing a
            // string instead of true as the optimistic option to cache.batch, when
            // refetchQueries receives optimistic: true.
            //
            // In other words, we are deliberately not supporting the use case of
            // writing to an *existing* optimistic layer (using the refetchQueries
            // updateCache function), since that would potentially interfere with
            // other optimistic updates in progress. Instead, you can read/write
            // only the root layer by passing optimistic: false to refetchQueries,
            // or you can read/write a brand new optimistic layer that will be
            // automatically removed by passing optimistic: true.
            optimistic: optimistic && removeOptimistic || false,
            // The removeOptimistic option can also be provided by itself, even if
            // optimistic === false, to remove some previously-added optimistic
            // layer safely and efficiently, like we do in markMutationResult.
            //
            // If an explicit removeOptimistic string is provided with optimistic:
            // true, the removeOptimistic string will determine the ID of the
            // temporary optimistic layer, in case that ever matters.
            removeOptimistic: removeOptimistic,
            onWatchUpdated: function(watch, diff, lastDiff) {
                var oq = watch.watcher instanceof (0, $511ca01b3f7961fe$export$79a6120a39c90b6a) && watch.watcher.observableQuery;
                if (oq) {
                    if (onQueryUpdated) {
                        // Since we're about to handle this query now, remove it from
                        // includedQueriesById, in case it was added earlier because of
                        // options.include.
                        includedQueriesById.delete(oq.queryId);
                        var result = onQueryUpdated(oq, diff, lastDiff);
                        if (result === true) // The onQueryUpdated function requested the default refetching
                        // behavior by returning true.
                        result = oq.refetch();
                        // Record the result in the results Map, as long as onQueryUpdated
                        // did not return false to skip/ignore this result.
                        if (result !== false) results.set(oq, result);
                        // Allow the default cache broadcast to happen, except when
                        // onQueryUpdated returns false.
                        return result;
                    }
                    if (onQueryUpdated !== null) // If we don't have an onQueryUpdated function, and onQueryUpdated
                    // was not disabled by passing null, make sure this query is
                    // "included" like any other options.include-specified query.
                    includedQueriesById.set(oq.queryId, {
                        oq: oq,
                        lastDiff: lastDiff,
                        diff: diff
                    });
                }
            }
        });
        if (includedQueriesById.size) includedQueriesById.forEach(function(_a, queryId) {
            var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
            var result;
            // If onQueryUpdated is provided, we want to use it for all included
            // queries, even the QueryOptions ones.
            if (onQueryUpdated) {
                if (!diff) {
                    var info = oq["queryInfo"];
                    info.reset(); // Force info.getDiff() to read from cache.
                    diff = info.getDiff();
                }
                result = onQueryUpdated(oq, diff, lastDiff);
            }
            // Otherwise, we fall back to refetching.
            if (!onQueryUpdated || result === true) result = oq.refetch();
            if (result !== false) results.set(oq, result);
            if (queryId.indexOf("legacyOneTimeQuery") >= 0) _this.stopQueryNoBroadcast(queryId);
        });
        if (removeOptimistic) // In case no updateCache callback was provided (so cache.batch was not
        // called above, and thus did not already remove the optimistic layer),
        // remove it here. Since this is a no-op when the layer has already been
        // removed, we do it even if we called cache.batch above, since it's
        // possible this.cache is an instance of some ApolloCache subclass other
        // than InMemoryCache, and does not fully support the removeOptimistic
        // option for cache.batch.
        this.cache.removeOptimistic(removeOptimistic);
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function(queryInfo, _a, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: query,
            variables: variables,
            networkStatus: networkStatus
        });
        var readCache = function() {
            return queryInfo.getDiff();
        };
        var resultsFromCache = function(diff, networkStatus) {
            if (networkStatus === void 0) networkStatus = queryInfo.networkStatus || (0, $d609460db1ab26e8$export$bd096ddbd246c79c).loading;
            var data = diff.result;
            if (globalThis.__DEV__ !== false && !returnPartialData && !(0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(data, {})) (0, $e65253b91ec210ab$export$b7e1973aacac3ae7)(diff.missing);
            var fromData = function(data) {
                return (0, $a68a73fcce1c801b$export$77cea355fa80b5f4).of((0, $e2e041e4a1657497$export$18ce0697a983be9b)({
                    data: data,
                    loading: (0, $d609460db1ab26e8$export$37509604341a3464)(networkStatus),
                    networkStatus: networkStatus
                }, diff.complete ? null : {
                    partial: true
                }));
            };
            if (data && _this.getDocumentInfo(query).hasForcedResolvers) return _this.localState.runResolvers({
                document: query,
                remoteResult: {
                    data: data
                },
                context: context,
                variables: variables,
                onlyRunForcedResolvers: true
            }).then(function(resolved) {
                return fromData(resolved.data || void 0);
            });
            // Resolves https://github.com/apollographql/apollo-client/issues/10317.
            // If errorPolicy is 'none' and notifyOnNetworkStatusChange is true,
            // data was incorrectly returned from the cache on refetch:
            // if diff.missing exists, we should not return cache data.
            if (errorPolicy === "none" && networkStatus === (0, $d609460db1ab26e8$export$bd096ddbd246c79c).refetch && Array.isArray(diff.missing)) return fromData(void 0);
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 /* CacheWriteBehavior.FORBID */  : networkStatus === (0, $d609460db1ab26e8$export$bd096ddbd246c79c).refetch && refetchWritePolicy !== "merge" ? 1 /* CacheWriteBehavior.OVERWRITE */  : 2 /* CacheWriteBehavior.MERGE */ ;
        var resultsFromLink = function() {
            return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
                query: query,
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy
            });
        };
        var shouldNotify = notifyOnNetworkStatusChange && typeof oldNetworkStatus === "number" && oldNetworkStatus !== networkStatus && (0, $d609460db1ab26e8$export$37509604341a3464)(networkStatus);
        switch(fetchPolicy){
            default:
            case "cache-first":
                var diff = readCache();
                if (diff.complete) return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(diff, queryInfo.markReady())
                    ]
                };
                if (returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-and-network":
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-only":
                return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(readCache(), queryInfo.markReady())
                    ]
                };
            case "network-only":
                if (shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(readCache()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "no-cache":
                if (shouldNotify) return {
                    fromLink: true,
                    // Note that queryInfo.getDiff() for no-cache queries does not call
                    // cache.diff, but instead returns a { complete: false } stub result
                    // when there is no queryInfo.diff already defined.
                    sources: [
                        resultsFromCache(queryInfo.getDiff()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "standby":
                return {
                    fromLink: false,
                    sources: []
                };
        }
    };
    QueryManager.prototype.getQuery = function(queryId) {
        if (queryId && !this.queries.has(queryId)) this.queries.set(queryId, new (0, $511ca01b3f7961fe$export$79a6120a39c90b6a)(this, queryId));
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, this.defaultContext), newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    return QueryManager;
}();





var $5ebd77fa775a8993$var$hasSuggestedDevtools = false;
/**
 * This is the primary Apollo Client class. It is used to send GraphQL documents (i.e. queries
 * and mutations) to a GraphQL spec-compliant server over an `ApolloLink` instance,
 * receive results from the server and cache the results in a store. It also delivers updates
 * to GraphQL queries through `Observable` instances.
 */ var $5ebd77fa775a8993$export$13f5a5f0f1dbab88 = /** @class */ function() {
    /**
     * Constructs an instance of `ApolloClient`.
     *
     * @example
     * ```js
     * import { ApolloClient, InMemoryCache } from '@apollo/client';
     *
     * const cache = new InMemoryCache();
     *
     * const client = new ApolloClient({
     *   // Provide required constructor fields
     *   cache: cache,
     *   uri: 'http://localhost:4000/',
     *
     *   // Provide some optional constructor fields
     *   name: 'react-web-client',
     *   version: '1.3',
     *   queryDeduplication: false,
     *   defaultOptions: {
     *     watchQuery: {
     *       fetchPolicy: 'cache-and-network',
     *     },
     *   },
     * });
     * ```
     */ function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        if (!options.cache) throw (0, $57583217334b5278$export$3991762405098ea)(15);
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, documentTransform = options.documentTransform, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        _c = options.connectToDevTools, // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        connectToDevTools = _c === void 0 ? typeof window === "object" && !window.__APOLLO_CLIENT__ && globalThis.__DEV__ !== false : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, defaultContext = options.defaultContext, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? cache.assumeImmutableResults : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) link = uri ? new (0, $dd7c24ed2c98b3d2$export$f4bbf1aec241cc1)({
            uri: uri,
            credentials: credentials,
            headers: headers
        }) : (0, $e7fcb7cc7e563d46$export$2fed3d61f740bc7f).empty();
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        this.version = (0, $5fbd9c7a509ff0a3$export$83d89fbfd8236492);
        this.localState = new (0, $6e5099943caf01e5$export$19901bcd339c3ded)({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new (0, $f5fd269eab7d7902$export$b986383a50b53ea4)({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            defaultContext: defaultContext,
            documentTransform: documentTransform,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ? function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.getQueryStore(),
                        mutations: _this.queryManager.mutationStore || {}
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            } : void 0
        });
        if (connectToDevTools) this.connectToDevTools();
    }
    ApolloClient.prototype.connectToDevTools = function() {
        if (typeof window === "object") {
            var windowWithDevTools = window;
            var devtoolsSymbol = Symbol.for("apollo.devtools");
            (windowWithDevTools[devtoolsSymbol] = windowWithDevTools[devtoolsSymbol] || []).push(this);
            windowWithDevTools.__APOLLO_CLIENT__ = this;
        }
        /**
         * Suggest installing the devtools for developers who don't have them
         */ if (!$5ebd77fa775a8993$var$hasSuggestedDevtools && globalThis.__DEV__ !== false) {
            $5ebd77fa775a8993$var$hasSuggestedDevtools = true;
            setTimeout(function() {
                if (typeof window !== "undefined" && window.document && window.top === window.self && !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                    var nav = window.navigator;
                    var ua = nav && nav.userAgent;
                    var url = void 0;
                    if (typeof ua === "string") {
                        if (ua.indexOf("Chrome/") > -1) url = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                        else if (ua.indexOf("Firefox/") > -1) url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                    if (url) globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).log("Download the Apollo DevTools for a better development experience: %s", url);
                }
            }, 10000);
        }
    };
    Object.defineProperty(ApolloClient.prototype, "documentTransform", {
        /**
         * The `DocumentTransform` used to modify GraphQL documents before a request
         * is made. If a custom `DocumentTransform` is not provided, this will be the
         * default document transform.
         */ get: function() {
            return this.queryManager.documentTransform;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Call this method to terminate any active client processes, making it safe
     * to dispose of this `ApolloClient` instance.
     */ ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    /**
     * This watches the cache store of the query according to the options specified and
     * returns an `ObservableQuery`. We can subscribe to this `ObservableQuery` and
     * receive updated results through a GraphQL observer when the cache store changes.
     *
     * Note that this method is not an implementation of GraphQL subscriptions. Rather,
     * it uses Apollo's store in order to reactively deliver updates to your query results.
     *
     * For example, suppose you call watchQuery on a GraphQL query that fetches a person's
     * first and last name and this person has a particular object identifier, provided by
     * dataIdFromObject. Later, a different query fetches that same person's
     * first and last name and the first name has now changed. Then, any observers associated
     * with the results of the first query will be updated with a new result object.
     *
     * Note that if the cache does not change, the subscriber will *not* be notified.
     *
     * See [here](https://medium.com/apollo-stack/the-concepts-of-graphql-bc68bd819be3#.3mb0cbcmc) for
     * a description of store reactivity.
     */ ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $77f4ff3b2e7d3a15$export$235b7fc70b9fc359)(this.defaultOptions.watchQuery, options);
        // XXX Overwriting options is probably not the best way to do this long term...
        if (this.disableNetworkFetches && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) options = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.watchQuery(options);
    };
    /**
     * This resolves a single query according to the options specified and
     * returns a `Promise` which is either resolved with the resulting data
     * or rejected with an error.
     *
     * @param options - An object of type `QueryOptions` that allows us to
     * describe how this query should be treated e.g. whether it should hit the
     * server at all or just resolve from the cache, etc.
     */ ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $77f4ff3b2e7d3a15$export$235b7fc70b9fc359)(this.defaultOptions.query, options);
        (0, $57583217334b5278$export$f5708dca728d7177)(options.fetchPolicy !== "cache-and-network", 16);
        if (this.disableNetworkFetches && options.fetchPolicy === "network-only") options = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.query(options);
    };
    /**
     * This resolves a single mutation according to the options specified and returns a
     * Promise which is either resolved with the resulting data or rejected with an
     * error. In some cases both `data` and `errors` might be undefined, for example
     * when `errorPolicy` is set to `'ignore'`.
     *
     * It takes options as an object with the following keys and values:
     */ ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $77f4ff3b2e7d3a15$export$235b7fc70b9fc359)(this.defaultOptions.mutate, options);
        return this.queryManager.mutate(options);
    };
    /**
     * This subscribes to a graphql subscription according to the options specified and returns an
     * `Observable` which either emits received data or an error.
     */ ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL query without making a network request. This method will start at
     * the root query. To start at a specific id returned by `dataIdFromObject`
     * use `readFragment`.
     *
     * @param optimistic - Set to `true` to allow `readQuery` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL fragment without making a network request. This method will read a
     * GraphQL fragment from any arbitrary id that is currently cached, unlike
     * `readQuery` which will only read from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @param optimistic - Set to `true` to allow `readFragment` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    /**
     * Writes some data in the shape of the provided GraphQL query directly to
     * the store. This method will start at the root query. To start at a
     * specific id returned by `dataIdFromObject` then use `writeFragment`.
     */ ApolloClient.prototype.writeQuery = function(options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    /**
     * Writes some data in the shape of the provided GraphQL fragment directly to
     * the store. This method will write to a GraphQL fragment from any arbitrary
     * id that is currently cached, unlike `writeQuery` which will only write
     * from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are writing. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */ ApolloClient.prototype.writeFragment = function(options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $fc0c11c3044842d0$export$51396ec711da548b)(this.link, payload);
    };
    /**
     * Resets your entire store by clearing out your cache and then re-executing
     * all of your active queries. This makes it so that you may guarantee that
     * there is no data left in your store from a time before you called this
     * method.
     *
     * `resetStore()` is useful when your user just logged out. You’ve removed the
     * user session, and you now want to make sure that any references to data you
     * might have fetched while the user session was active is gone.
     *
     * It is important to remember that `resetStore()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: false
            });
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    /**
     * Remove all data from the store. Unlike `resetStore`, `clearStore` will
     * not refetch any active queries.
     */ ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: true
            });
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * reset. `onResetStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * cleared. `onClearStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Refetches all of your active queries.
     *
     * `reFetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `reFetchObservableQueries()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     */ ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    /**
     * Refetches specified active queries. Similar to "reFetchObservableQueries()" but with a specific list of queries.
     *
     * `refetchQueries()` is useful for use cases to imperatively refresh a selection of queries.
     *
     * It is important to remember that `refetchQueries()` *will* refetch specified active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.refetchQueries = function(options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function(result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        // In case you need the raw results immediately, without awaiting
        // Promise.all(results):
        result.queries = queries;
        result.results = results;
        // If you decide to ignore the result Promise because you're using
        // result.queries and result.results instead, you shouldn't have to worry
        // about preventing uncaught rejections for the Promise.all result.
        result.catch(function(error) {
            globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).debug(17, error);
        });
        return result;
    };
    /**
     * Get all currently active `ObservableQuery` objects, in a `Map` keyed by
     * query ID strings.
     *
     * An "active" query is one that has observers and a `fetchPolicy` other than
     * "standby" or "cache-only".
     *
     * You can include all `ObservableQuery` objects (including the inactive ones)
     * by passing "all" instead of "active", or you can include just a subset of
     * active queries by passing an array of query names or DocumentNode objects.
     */ ApolloClient.prototype.getObservableQueries = function(include) {
        if (include === void 0) include = "active";
        return this.queryManager.getObservableQueries(include);
    };
    /**
     * Exposes the cache's complete state, in a serializable format for later restoration.
     */ ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    /**
     * Replaces existing state in the cache (if any) with the values expressed by
     * `serializedState`.
     *
     * Called when hydrating a cache (server side rendering, or offline storage),
     * and also (potentially) during hot reloads.
     */ ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    /**
     * Add additional local resolvers.
     */ ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    /**
     * Set (override existing) local resolvers.
     */ ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    /**
     * Get all registered local resolvers.
     */ ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    /**
     * Set a custom local state fragment matcher.
     */ ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    /**
     * Define a new ApolloLink (or link chain) that Apollo Client will use.
     */ ApolloClient.prototype.setLink = function(newLink) {
        this.link = this.queryManager.link = newLink;
    };
    Object.defineProperty(ApolloClient.prototype, "defaultContext", {
        get: function() {
            return this.queryManager.defaultContext;
        },
        enumerable: false,
        configurable: true
    });
    return ApolloClient;
}();
if (globalThis.__DEV__ !== false) $5ebd77fa775a8993$export$13f5a5f0f1dbab88.prototype.getMemoryInternals = (0, $19eefe0273f1ef83$export$dfdba94ce46d2ea5);











var $e9895ec3a124ad39$export$5fc74f25506aa9c = /** @class */ function() {
    function ApolloCache() {
        this.assumeImmutableResults = false;
        // Make sure we compute the same (===) fragment query document every
        // time we receive the same fragment in readFragment.
        this.getFragmentDoc = (0, $c16b91c3e0ba14ea$export$4997ffc0176396a6)((0, $73d0a56999265e6c$export$abbf37c7cf644e41), {
            max: (0, $e8270474df1c6a9d$export$f29926b23b28936b)["cache.fragmentQueryDocuments"] || 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
            cache: (0, $e043dec6e16a9988$export$87b462129af3b7d4)
        });
    }
    // Transactional API
    // The batch method is intended to replace/subsume both performTransaction
    // and recordOptimisticTransaction, but performTransaction came first, so we
    // provide a default batch implementation that's just another way of calling
    // performTransaction. Subclasses of ApolloCache (such as InMemoryCache) can
    // override the batch method to do more interesting things with its options.
    ApolloCache.prototype.batch = function(options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic : options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function() {
            return updateResult = options.update(_this);
        }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function(transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    // Optional API
    // Called once per input document, allowing the cache to make static changes
    // to the query, such as adding __typename fields.
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    // Called before each ApolloLink request, allowing the cache to make dynamic
    // changes to the query, such as filling in missing fragment definitions.
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.identify = function(object) {
        return;
    };
    ApolloCache.prototype.gc = function() {
        return [];
    };
    ApolloCache.prototype.modify = function(options) {
        return false;
    };
    // DataProxy API
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options), {
            rootId: options.id || "ROOT_QUERY",
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options), {
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            rootId: options.id,
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.writeQuery = function(_a) {
        var id = _a.id, data = _a.data, options = (0, $e2e041e4a1657497$export$3c9a16f847548506)(_a, [
            "id",
            "data"
        ]);
        return this.write(Object.assign(options, {
            dataId: id || "ROOT_QUERY",
            result: data
        }));
    };
    ApolloCache.prototype.writeFragment = function(_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0, $e2e041e4a1657497$export$3c9a16f847548506)(_a, [
            "id",
            "data",
            "fragment",
            "fragmentName"
        ]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data
        }));
    };
    ApolloCache.prototype.updateQuery = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeQuery((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    ApolloCache.prototype.updateFragment = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeFragment((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    return ApolloCache;
}();
if (globalThis.__DEV__ !== false) $e9895ec3a124ad39$export$5fc74f25506aa9c.prototype.getMemoryInternals = (0, $19eefe0273f1ef83$export$e7ed438e82606689);



var $12b16d800985d695$export$257c68286583b0f9 = /** @class */ function(_super) {
    (0, $e2e041e4a1657497$export$a8ba968b8961cb8a)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        // 'Error' breaks prototype chain here
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for(var i = _this.path.length - 1; i >= 0; --i)_this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
        } else _this.missing = _this.path;
        // We're not using `Object.setPrototypeOf` here as it isn't fully supported
        // on Android (see issue #3236).
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error);















var $c918a5b399d12c45$export$b5a638e9b3fff9f3 = Object.prototype.hasOwnProperty;
function $c918a5b399d12c45$export$b931b78cbb3caf86(value) {
    return value === null || value === void 0;
}
function $c918a5b399d12c45$export$bd03c5a9c99d6bce(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) context.keyObject = !$c918a5b399d12c45$export$b931b78cbb3caf86(id) ? {
            id: id
        } : !$c918a5b399d12c45$export$b931b78cbb3caf86(_id) ? {
            _id: _id
        } : void 0;
        // If there is no object.id, fall back to object._id.
        if ($c918a5b399d12c45$export$b931b78cbb3caf86(id) && !$c918a5b399d12c45$export$b931b78cbb3caf86(_id)) id = _id;
        if (!$c918a5b399d12c45$export$b931b78cbb3caf86(id)) return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id));
    }
}
var $c918a5b399d12c45$var$defaultConfig = {
    dataIdFromObject: $c918a5b399d12c45$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    // Thanks to the shouldCanonizeResults helper, this should be the only line
    // you have to change to reenable canonization by default in the future.
    canonizeResults: false
};
function $c918a5b399d12c45$export$fa542f9ee3f7f4e2(config) {
    return (0, $9017e689666d6554$export$8e16b83750b44988)($c918a5b399d12c45$var$defaultConfig, config);
}
function $c918a5b399d12c45$export$3ac2a95fbd99c479(config) {
    var value = config.canonizeResults;
    return value === void 0 ? $c918a5b399d12c45$var$defaultConfig.canonizeResults : value;
}
function $c918a5b399d12c45$export$fdef206c83ff2c09(store, objectOrReference) {
    return (0, $4ab7359740364a58$export$fa99cac1c0883c47)(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}
var $c918a5b399d12c45$export$6ed54d4784f1ce28 = /^[_a-z][_0-9a-z]*/i;
function $c918a5b399d12c45$export$37874422037b6029(storeFieldName) {
    var match = storeFieldName.match($c918a5b399d12c45$export$6ed54d4784f1ce28);
    return match ? match[0] : storeFieldName;
}
function $c918a5b399d12c45$export$60bd1cbb09c1a4a2(selectionSet, result, variables) {
    if ((0, $a5b286f532530da9$export$417207af72fad9c9)(result)) return (0, $93b6d5db950815ab$export$43bee75e5e14138e)(result) ? result.every(function(item) {
        return $c918a5b399d12c45$export$60bd1cbb09c1a4a2(selectionSet, item, variables);
    }) : selectionSet.selections.every(function(field) {
        if ((0, $4ab7359740364a58$export$fb56ad75dd311c12)(field) && (0, $d474a5d9bfbef507$export$3dc388a5f013b4a5)(field, variables)) {
            var key = (0, $4ab7359740364a58$export$7d1ad22471852218)(field);
            return $c918a5b399d12c45$export$b5a638e9b3fff9f3.call(result, key) && (!field.selectionSet || $c918a5b399d12c45$export$60bd1cbb09c1a4a2(field.selectionSet, result[key], variables));
        }
        // If the selection has been skipped with @skip(true) or
        // @include(false), it should not count against the matching. If
        // the selection is not a field, it must be a fragment (inline or
        // named). We will determine if selectionSetMatchesResult for that
        // fragment when we get to it, so for now we return true.
        return true;
    });
    return false;
}
function $c918a5b399d12c45$export$4f39afca21bd938e(value) {
    return (0, $a5b286f532530da9$export$417207af72fad9c9)(value) && !(0, $4ab7359740364a58$export$fa99cac1c0883c47)(value) && !(0, $93b6d5db950815ab$export$43bee75e5e14138e)(value);
}
function $c918a5b399d12c45$export$b874a818f7a2fa6d() {
    return new (0, $f042fd543798b697$export$509e11c221f576c0)();
}
function $c918a5b399d12c45$export$3a33c00f0ae4a480(document, fragments) {
    // FragmentMap consisting only of fragments defined directly in document, not
    // including other fragments registered in the FragmentRegistry.
    var fragmentMap = (0, $73d0a56999265e6c$export$193789b4c8246dd4)((0, $d34613b28fb40239$export$5320a7ba9466a3df)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function(name) {
            var def = fragmentMap[name];
            if (!def && fragments) def = fragments.lookup(name);
            return def || null;
        }
    };
}


var $f18c94e51849b8c5$var$DELETE = Object.create(null);
var $f18c94e51849b8c5$var$delModifier = function() {
    return $f18c94e51849b8c5$var$DELETE;
};
var $f18c94e51849b8c5$var$INVALIDATE = Object.create(null);
var $f18c94e51849b8c5$export$cb507f57054c7321 = /** @class */ function() {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        // Maps root entity IDs to the number of times they have been retained, minus
        // the number of times they have been released. Retained entities keep other
        // entities they reference (even indirectly) from being garbage collected.
        this.rootIds = Object.create(null);
        // Lazily tracks { __ref: <dataId> } strings contained by this.data[dataId].
        this.refs = Object.create(null);
        // Bound function that can be passed around to provide easy access to fields
        // of Reference objects as well as ordinary objects.
        this.getFieldValue = function(objectOrReference, storeFieldName) {
            return (0, $7d98bd712ac3042c$export$7f9c177735b71f18)((0, $4ab7359740364a58$export$fa99cac1c0883c47)(objectOrReference) ? _this.get(objectOrReference.__ref, storeFieldName) : objectOrReference && objectOrReference[storeFieldName]);
        };
        // Returns true for non-normalized StoreObjects and non-dangling
        // References, indicating that readField(name, objOrRef) has a chance of
        // working. Useful for filtering out dangling references from lists.
        this.canRead = function(objOrRef) {
            return (0, $4ab7359740364a58$export$fa99cac1c0883c47)(objOrRef) ? _this.has(objOrRef.__ref) : typeof objOrRef === "object";
        };
        // Bound function that converts an id or an object with a __typename and
        // primary key fields to a Reference object. If called with a Reference object,
        // that same Reference object is returned. Pass true for mergeIntoStore to persist
        // an object into the store.
        this.toReference = function(objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") return (0, $4ab7359740364a58$export$634ae0e932e9be99)(objOrIdOrRef);
            if ((0, $4ab7359740364a58$export$fa99cac1c0883c47)(objOrIdOrRef)) return objOrIdOrRef;
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0, $4ab7359740364a58$export$634ae0e932e9be99)(id);
                if (mergeIntoStore) _this.merge(id, objOrIdOrRef);
                return ref;
            }
        };
    }
    // Although the EntityStore class is abstract, it contains concrete
    // implementations of the various NormalizedCache interface methods that
    // are inherited by the Root and Layer subclasses.
    EntityStore.prototype.toObject = function() {
        return (0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, this.data);
    };
    EntityStore.prototype.has = function(dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function(dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if ((0, $c918a5b399d12c45$export$b5a638e9b3fff9f3).call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && (0, $c918a5b399d12c45$export$b5a638e9b3fff9f3).call(storeObject, fieldName)) return storeObject[fieldName];
        }
        if (fieldName === "__typename" && (0, $c918a5b399d12c45$export$b5a638e9b3fff9f3).call(this.policies.rootTypenamesById, dataId)) return this.policies.rootTypenamesById[dataId];
        if (this instanceof $f18c94e51849b8c5$var$Layer) return this.parent.get(dataId, fieldName);
    };
    EntityStore.prototype.lookup = function(dataId, dependOnExistence) {
        // The has method (above) calls lookup with dependOnExistence = true, so
        // that it can later be invalidated when we add or remove a StoreObject for
        // this dataId. Any consumer who cares about the contents of the StoreObject
        // should not rely on this dependency, since the contents could change
        // without the object being added or removed.
        if (dependOnExistence) this.group.depend(dataId, "__exists");
        if ((0, $c918a5b399d12c45$export$b5a638e9b3fff9f3).call(this.data, dataId)) return this.data[dataId];
        if (this instanceof $f18c94e51849b8c5$var$Layer) return this.parent.lookup(dataId, dependOnExistence);
        if (this.policies.rootTypenamesById[dataId]) return Object.create(null);
    };
    EntityStore.prototype.merge = function(older, newer) {
        var _this = this;
        var dataId;
        // Convert unexpected references to ID strings.
        if ((0, $4ab7359740364a58$export$fa99cac1c0883c47)(older)) older = older.__ref;
        if ((0, $4ab7359740364a58$export$fa99cac1c0883c47)(newer)) newer = newer.__ref;
        var existing = typeof older === "string" ? this.lookup(dataId = older) : older;
        var incoming = typeof newer === "string" ? this.lookup(dataId = newer) : newer;
        // If newer was a string ID, but that ID was not defined in this store,
        // then there are no fields to be merged, so we're done.
        if (!incoming) return;
        (0, $57583217334b5278$export$f5708dca728d7177)(typeof dataId === "string", 1);
        var merged = new (0, $f042fd543798b697$export$509e11c221f576c0)($f18c94e51849b8c5$var$storeObjectReconciler).merge(existing, incoming);
        // Even if merged === existing, existing may have come from a lower
        // layer, so we always need to set this.data[dataId] on this level.
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                // If we added a new StoreObject where there was previously none, dirty
                // anything that depended on the existence of this dataId, such as the
                // EntityStore#has method.
                if (!existing) fieldsToDirty_1.__exists = 1;
                // Now invalidate dependents who called getFieldValue for any fields
                // that are changing as a result of this merge.
                Object.keys(incoming).forEach(function(storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        // Always dirty the full storeFieldName, which may include
                        // serialized arguments following the fieldName prefix.
                        fieldsToDirty_1[storeFieldName] = 1;
                        // Also dirty fieldNameFromStoreName(storeFieldName) if it's
                        // different from storeFieldName and this field does not have
                        // keyArgs configured, because that means the cache can't make
                        // any assumptions about how field values with the same field
                        // name but different arguments might be interrelated, so it
                        // must err on the side of invalidating all field values that
                        // share the same short fieldName, regardless of arguments.
                        var fieldName = (0, $c918a5b399d12c45$export$37874422037b6029)(storeFieldName);
                        if (fieldName !== storeFieldName && !_this.policies.hasKeyArgs(merged.__typename, fieldName)) fieldsToDirty_1[fieldName] = 1;
                        // If merged[storeFieldName] has become undefined, and this is the
                        // Root layer, actually delete the property from the merged object,
                        // which is guaranteed to have been created fresh in this method.
                        if (merged[storeFieldName] === void 0 && !(_this instanceof $f18c94e51849b8c5$var$Layer)) delete merged[storeFieldName];
                    }
                });
                if (fieldsToDirty_1.__typename && !(existing && existing.__typename) && // Since we return default root __typename strings
                // automatically from store.get, we don't need to dirty the
                // ROOT_QUERY.__typename field if merged.__typename is equal
                // to the default string (usually "Query").
                this.policies.rootTypenamesById[dataId] === merged.__typename) delete fieldsToDirty_1.__typename;
                Object.keys(fieldsToDirty_1).forEach(function(fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function(dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: $f18c94e51849b8c5$var$DELETE,
                INVALIDATE: $f18c94e51849b8c5$var$INVALIDATE,
                isReference: (0, $4ab7359740364a58$export$fa99cac1c0883c47),
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function(fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                        fieldName: fieldNameOrOptions,
                        from: from || (0, $4ab7359740364a58$export$634ae0e932e9be99)(dataId)
                    } : fieldNameOrOptions, {
                        store: _this
                    });
                }
            };
            Object.keys(storeObject).forEach(function(storeFieldName) {
                var fieldName = (0, $c918a5b399d12c45$export$37874422037b6029)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0) return;
                var modify = typeof fields === "function" ? fields : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === $f18c94e51849b8c5$var$delModifier ? $f18c94e51849b8c5$var$DELETE : modify((0, $7d98bd712ac3042c$export$7f9c177735b71f18)(fieldValue), (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, sharedDetails_1), {
                        fieldName: fieldName,
                        storeFieldName: storeFieldName,
                        storage: _this.getStorage(dataId, storeFieldName)
                    }));
                    if (newValue === $f18c94e51849b8c5$var$INVALIDATE) _this.group.dirty(dataId, storeFieldName);
                    else {
                        if (newValue === $f18c94e51849b8c5$var$DELETE) newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                            if (globalThis.__DEV__ !== false) {
                                var checkReference = function(ref) {
                                    if (_this.lookup(ref.__ref) === undefined) {
                                        globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).warn(2, ref);
                                        return true;
                                    }
                                };
                                if ((0, $4ab7359740364a58$export$fa99cac1c0883c47)(newValue)) checkReference(newValue);
                                else if (Array.isArray(newValue)) {
                                    // Warn about writing "mixed" arrays of Reference and non-Reference objects
                                    var seenReference = false;
                                    var someNonReference = void 0;
                                    for(var _i = 0, newValue_1 = newValue; _i < newValue_1.length; _i++){
                                        var value = newValue_1[_i];
                                        if ((0, $4ab7359740364a58$export$fa99cac1c0883c47)(value)) {
                                            seenReference = true;
                                            if (checkReference(value)) break;
                                        } else // Do not warn on primitive values, since those could never be represented
                                        // by a reference. This is a valid (albeit uncommon) use case.
                                        if (typeof value === "object" && !!value) {
                                            var id = _this.policies.identify(value)[0];
                                            // check if object could even be referenced, otherwise we are not interested in it for this warning
                                            if (id) someNonReference = value;
                                        }
                                        if (seenReference && someNonReference !== undefined) {
                                            globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).warn(3, someNonReference);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (fieldValue !== void 0) allDeleted_1 = false;
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof $f18c94e51849b8c5$var$Layer) this.data[dataId] = void 0;
                    else delete this.data[dataId];
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    // If called with only one argument, removes the entire entity
    // identified by dataId. If called with a fieldName as well, removes all
    // fields of that entity whose names match fieldName according to the
    // fieldNameFromStoreName helper function. If called with a fieldName
    // and variables, removes all fields of that entity whose names match fieldName
    // and whose arguments when cached exactly match the variables passed.
    EntityStore.prototype.delete = function(dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ? this.policies.getStoreFieldName({
                typename: typename,
                fieldName: fieldName,
                args: args
            }) : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {}, _a[storeFieldName] = $f18c94e51849b8c5$var$delModifier, _a) : $f18c94e51849b8c5$var$delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function(options, limit) {
        var evicted = false;
        if (options.id) {
            if ((0, $c918a5b399d12c45$export$b5a638e9b3fff9f3).call(this.data, options.id)) evicted = this.delete(options.id, options.fieldName, options.args);
            if (this instanceof $f18c94e51849b8c5$var$Layer && this !== limit) evicted = this.parent.evict(options, limit) || evicted;
            // Always invalidate the field to trigger rereading of watched
            // queries, even if no cache data was modified by the eviction,
            // because queries may depend on computed fields with custom read
            // functions, whose values are not stored in the EntityStore.
            if (options.fieldName || evicted) this.group.dirty(options.id, options.fieldName || "__exists");
        }
        return evicted;
    };
    EntityStore.prototype.clear = function() {
        this.replace(null);
    };
    EntityStore.prototype.extract = function() {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function(id) {
            if (!(0, $c918a5b399d12c45$export$b5a638e9b3fff9f3).call(_this.policies.rootTypenamesById, id)) extraRootIds.push(id);
        });
        if (extraRootIds.length) obj.__META = {
            extraRootIds: extraRootIds.sort()
        };
        return obj;
    };
    EntityStore.prototype.replace = function(newData) {
        var _this = this;
        Object.keys(this.data).forEach(function(dataId) {
            if (!(newData && (0, $c918a5b399d12c45$export$b5a638e9b3fff9f3).call(newData, dataId))) _this.delete(dataId);
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0, $e2e041e4a1657497$export$3c9a16f847548506)(newData, [
                "__META"
            ]);
            Object.keys(rest_1).forEach(function(dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) __META.extraRootIds.forEach(this.retain, this);
        }
    };
    EntityStore.prototype.retain = function(rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function(rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count) delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    // Return a Set<string> of all the ID strings that have been retained by
    // this layer/root *and* any layers/roots beneath it.
    EntityStore.prototype.getRootIdSet = function(ids) {
        if (ids === void 0) ids = new Set();
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof $f18c94e51849b8c5$var$Layer) this.parent.getRootIdSet(ids);
        else // Official singleton IDs like ROOT_QUERY and ROOT_MUTATION are
        // always considered roots for garbage collection, regardless of
        // their retainment counts in this.rootIds.
        Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        return ids;
    };
    // The goal of garbage collection is to remove IDs from the Root layer of the
    // store that are no longer reachable starting from any IDs that have been
    // explicitly retained (see retain and release, above). Returns an array of
    // dataId strings that were removed from the store.
    EntityStore.prototype.gc = function() {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function(id) {
            if ((0, $c918a5b399d12c45$export$b5a638e9b3fff9f3).call(snapshot, id)) {
                // Because we are iterating over an ECMAScript Set, the IDs we add here
                // will be visited in later iterations of the forEach loop only if they
                // were not previously contained by the Set.
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                // By removing IDs from the snapshot object here, we protect them from
                // getting removed from the root store layer below.
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while(root_1 instanceof $f18c94e51849b8c5$var$Layer)root_1 = root_1.parent;
            idsToRemove.forEach(function(id) {
                return root_1.delete(id);
            });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function(dataId) {
        if (!(0, $c918a5b399d12c45$export$b5a638e9b3fff9f3).call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root) return found_1;
            var workSet_1 = new Set([
                root
            ]);
            // Within the store, only arrays and objects can contain child entity
            // references, so we can prune the traversal using this predicate:
            workSet_1.forEach(function(obj) {
                if ((0, $4ab7359740364a58$export$fa99cac1c0883c47)(obj)) found_1[obj.__ref] = true;
                if ((0, $a5b286f532530da9$export$417207af72fad9c9)(obj)) Object.keys(obj).forEach(function(key) {
                    var child = obj[key];
                    // No need to add primitive values to the workSet, since they cannot
                    // contain reference objects.
                    if ((0, $a5b286f532530da9$export$417207af72fad9c9)(child)) workSet_1.add(child);
                });
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function() {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}();
// A single CacheGroup represents a set of one or more EntityStore objects,
// typically the Root store in a CacheGroup by itself, and all active Layer
// stores in a group together. A single EntityStore object belongs to only
// one CacheGroup, store.group. The CacheGroup is responsible for tracking
// dependencies, so store.group is helpful for generating unique keys for
// cached results that need to be invalidated when/if those dependencies
// change. If we used the EntityStore objects themselves as cache keys (that
// is, store rather than store.group), the cache would become unnecessarily
// fragmented by all the different Layer objects. Instead, the CacheGroup
// approach allows all optimistic Layer objects in the same linked list to
// belong to one CacheGroup, with the non-optimistic Root object belonging
// to another CacheGroup, allowing resultCaching dependencies to be tracked
// separately for optimistic and non-optimistic entity data.
var $f18c94e51849b8c5$var$CacheGroup = /** @class */ function() {
    function CacheGroup(caching, parent) {
        if (parent === void 0) parent = null;
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function() {
        this.d = this.caching ? (0, $74dd560e5a3ee84c$export$c723b7eff9d8f870)() : null;
        this.keyMaker = new (0, $26d4e625bb2590d6$export$73571c50d0f2507e)((0, $9865fa0c1163b711$export$772fbc04a0ad4ce9));
    };
    CacheGroup.prototype.depend = function(dataId, storeFieldName) {
        if (this.d) {
            this.d($f18c94e51849b8c5$var$makeDepKey(dataId, storeFieldName));
            var fieldName = (0, $c918a5b399d12c45$export$37874422037b6029)(storeFieldName);
            if (fieldName !== storeFieldName) // Fields with arguments that contribute extra identifying
            // information to the fieldName (thus forming the storeFieldName)
            // depend not only on the full storeFieldName but also on the
            // short fieldName, so the field can be invalidated using either
            // level of specificity.
            this.d($f18c94e51849b8c5$var$makeDepKey(dataId, fieldName));
            if (this.parent) this.parent.depend(dataId, storeFieldName);
        }
    };
    CacheGroup.prototype.dirty = function(dataId, storeFieldName) {
        if (this.d) this.d.dirty($f18c94e51849b8c5$var$makeDepKey(dataId, storeFieldName), // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        storeFieldName === "__exists" ? "forget" : "setDirty");
    };
    return CacheGroup;
}();
function $f18c94e51849b8c5$var$makeDepKey(dataId, storeFieldName) {
    // Since field names cannot have '#' characters in them, this method
    // of joining the field name and the ID should be unambiguous, and much
    // cheaper than JSON.stringify([dataId, fieldName]).
    return storeFieldName + "#" + dataId;
}
function $f18c94e51849b8c5$export$f8068a30967ddc18(store, entityId) {
    if ($f18c94e51849b8c5$export$488c0743feab3d61(store)) // We use this pseudo-field __exists elsewhere in the EntityStore code to
    // represent changes in the existence of the entity object identified by
    // entityId. This dependency gets reliably dirtied whenever an object with
    // this ID is deleted (or newly created) within this group, so any result
    // cache entries (for example, StoreReader#executeSelectionSet results) that
    // depend on __exists for this entityId will get dirtied as well, leading to
    // the eventual recomputation (instead of reuse) of those result objects the
    // next time someone reads them from the cache.
    store.group.depend(entityId, "__exists");
}
(function(EntityStore) {
    // Refer to this class as EntityStore.Root outside this namespace.
    var Root = /** @class */ function(_super) {
        (0, $e2e041e4a1657497$export$a8ba968b8961cb8a)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new $f18c94e51849b8c5$var$CacheGroup(resultCaching)) || this;
            _this.stump = new $f18c94e51849b8c5$var$Stump(_this);
            _this.storageTrie = new (0, $26d4e625bb2590d6$export$73571c50d0f2507e)((0, $9865fa0c1163b711$export$772fbc04a0ad4ce9));
            if (seed) _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function(layerId, replay) {
            // Adding an optimistic Layer on top of the Root actually adds the Layer
            // on top of the Stump, so the Stump always comes between the Root and
            // any Layer objects that we've added.
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function() {
            // Never remove the root layer.
            return this;
        };
        Root.prototype.getStorage = function() {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore);
    EntityStore.Root = Root;
})($f18c94e51849b8c5$export$cb507f57054c7321 || ($f18c94e51849b8c5$export$cb507f57054c7321 = {}));
// Not exported, since all Layer instances are created by the addLayer method
// of the EntityStore.Root class.
var $f18c94e51849b8c5$var$Layer = /** @class */ function(_super) {
    (0, $e2e041e4a1657497$export$a8ba968b8961cb8a)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function(layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function(layerId) {
        var _this = this;
        // Remove all instances of the given id, not just the first one.
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) // Dirty every ID we're removing. Technically we might be able to avoid
            // dirtying fields that have values in higher layers, but we don't have
            // easy access to higher layers here, and we're about to recreate those
            // layers anyway (see parent.addLayer below).
            Object.keys(this.data).forEach(function(dataId) {
                var ownStoreObject = _this.data[dataId];
                var parentStoreObject = parent["lookup"](dataId);
                if (!parentStoreObject) // The StoreObject identified by dataId was defined in this layer
                // but will be undefined in the parent layer, so we can delete the
                // whole entity using this.delete(dataId). Since we're about to
                // throw this layer away, the only goal of this deletion is to dirty
                // the removed fields.
                _this.delete(dataId);
                else if (!ownStoreObject) {
                    // This layer had an entry for dataId but it was undefined, which
                    // means the entity was deleted in this layer, and it's about to
                    // become undeleted when we remove this layer, so we need to dirty
                    // all fields that are about to be reexposed.
                    _this.group.dirty(dataId, "__exists");
                    Object.keys(parentStoreObject).forEach(function(storeFieldName) {
                        _this.group.dirty(dataId, storeFieldName);
                    });
                } else if (ownStoreObject !== parentStoreObject) // If ownStoreObject is not exactly the same as parentStoreObject,
                // dirty any fields whose values will change as a result of this
                // removal.
                Object.keys(ownStoreObject).forEach(function(storeFieldName) {
                    if (!(0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) _this.group.dirty(dataId, storeFieldName);
                });
            });
            return parent;
        }
        // No changes are necessary if the parent chain remains identical.
        if (parent === this.parent) return this;
        // Recreate this layer on top of the new parent.
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function() {
        return (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function(dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return (0, $c918a5b399d12c45$export$b5a638e9b3fff9f3).call(this.data, dataId) ? (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function() {
        var p = this.parent;
        while(p.parent)p = p.parent;
        return p.getStorage.apply(p, // @ts-expect-error
        arguments);
    };
    return Layer;
}($f18c94e51849b8c5$export$cb507f57054c7321);
// Represents a Layer permanently installed just above the Root, which allows
// reading optimistically (and registering optimistic dependencies) even when
// no optimistic layers are currently active. The stump.group CacheGroup object
// is shared by any/all Layer objects added on top of the Stump.
var $f18c94e51849b8c5$var$Stump = /** @class */ function(_super) {
    (0, $e2e041e4a1657497$export$a8ba968b8961cb8a)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function() {}, new $f18c94e51849b8c5$var$CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function() {
        // Never remove the Stump layer.
        return this;
    };
    Stump.prototype.merge = function(older, newer) {
        // We never want to write any data into the Stump, so we forward any merge
        // calls to the Root instead. Another option here would be to throw an
        // exception, but the toReference(object, true) function can sometimes
        // trigger Stump writes (which used to be Root writes, before the Stump
        // concept was introduced).
        return this.parent.merge(older, newer);
    };
    return Stump;
}($f18c94e51849b8c5$var$Layer);
function $f18c94e51849b8c5$var$storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    // Wherever there is a key collision, prefer the incoming value, unless
    // it is deeply equal to the existing value. It's worth checking deep
    // equality here (even though blindly returning incoming would be
    // logically correct) because preserving the referential identity of
    // existing data can prevent needless rereading and rerendering.
    return (0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function $f18c94e51849b8c5$export$488c0743feab3d61(store) {
    // When result caching is disabled, store.depend will be null.
    return !!(store instanceof $f18c94e51849b8c5$export$cb507f57054c7321 && store.group.caching);
}








function $2579b2ae3c8726cf$var$shallowCopy(value) {
    if ((0, $a5b286f532530da9$export$417207af72fad9c9)(value)) return (0, $93b6d5db950815ab$export$43bee75e5e14138e)(value) ? value.slice(0) : (0, $e2e041e4a1657497$export$18ce0697a983be9b)({
        __proto__: Object.getPrototypeOf(value)
    }, value);
    return value;
}
// When programmers talk about the "canonical form" of an object, they
// usually have the following meaning in mind, which I've copied from
// https://en.wiktionary.org/wiki/canonical_form:
//
// 1. A standard or normal presentation of a mathematical entity [or
//    object]. A canonical form is an element of a set of representatives
//    of equivalence classes of forms such that there is a function or
//    procedure which projects every element of each equivalence class
//    onto that one element, the canonical form of that equivalence
//    class. The canonical form is expected to be simpler than the rest of
//    the forms in some way.
//
// That's a long-winded way of saying any two objects that have the same
// canonical form may be considered equivalent, even if they are !==,
// which usually means the objects are structurally equivalent (deeply
// equal), but don't necessarily use the same memory.
//
// Like a literary or musical canon, this ObjectCanon class represents a
// collection of unique canonical items (JavaScript objects), with the
// important property that canon.admit(a) === canon.admit(b) if a and b
// are deeply equal to each other. In terms of the definition above, the
// canon.admit method is the "function or procedure which projects every"
// object "onto that one element, the canonical form."
//
// In the worst case, the canonicalization process may involve looking at
// every property in the provided object tree, so it takes the same order
// of time as deep equality checking. Fortunately, already-canonicalized
// objects are returned immediately from canon.admit, so the presence of
// canonical subtrees tends to speed up canonicalization.
//
// Since consumers of canonical objects can check for deep equality in
// constant time, canonicalizing cache results can massively improve the
// performance of application code that skips re-rendering unchanged
// results, such as "pure" UI components in a framework like React.
//
// Of course, since canonical objects may be shared widely between
// unrelated consumers, it's important to think of them as immutable, even
// though they are not actually frozen with Object.freeze in production,
// due to the extra performance overhead that comes with frozen objects.
//
// Custom scalar objects whose internal class name is neither Array nor
// Object can be included safely in the admitted tree, but they will not
// be replaced with a canonical version (to put it another way, they are
// assumed to be canonical already).
//
// If we ignore custom objects, no detection of cycles or repeated object
// references is currently required by the StoreReader class, since
// GraphQL result objects are JSON-serializable trees (and thus contain
// neither cycles nor repeated subtrees), so we can avoid the complexity
// of keeping track of objects we've already seen during the recursion of
// the admit method.
//
// In the future, we may consider adding additional cases to the switch
// statement to handle other common object types, such as "[object Date]"
// objects, as needed.
var $2579b2ae3c8726cf$export$c2e7fdd82233f4a4 = /** @class */ function() {
    function ObjectCanon() {
        // Set of all canonical objects this ObjectCanon has admitted, allowing
        // canon.admit to return previously-canonicalized objects immediately.
        this.known = new ((0, $9865fa0c1163b711$export$7293b8a0b474028d) ? WeakSet : Set)();
        // Efficient storage/lookup structure for canonical objects.
        this.pool = new (0, $26d4e625bb2590d6$export$73571c50d0f2507e)((0, $9865fa0c1163b711$export$772fbc04a0ad4ce9));
        // Make the ObjectCanon assume this value has already been
        // canonicalized.
        this.passes = new WeakMap();
        // Arrays that contain the same elements in a different order can share
        // the same SortedKeysInfo object, to save memory.
        this.keysByJSON = new Map();
        // This has to come last because it depends on keysByJSON.
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function(value) {
        return (0, $a5b286f532530da9$export$417207af72fad9c9)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function(value) {
        if ((0, $a5b286f532530da9$export$417207af72fad9c9)(value)) {
            var copy = $2579b2ae3c8726cf$var$shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function(value) {
        var _this = this;
        if ((0, $a5b286f532530da9$export$417207af72fad9c9)(value)) {
            var original = this.passes.get(value);
            if (original) return original;
            var proto = Object.getPrototypeOf(value);
            switch(proto){
                case Array.prototype:
                    if (this.known.has(value)) return value;
                    var array = value.map(this.admit, this);
                    // Arrays are looked up in the Trie using their recursively
                    // canonicalized elements, and the known version of the array is
                    // preserved as node.array.
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        // Since canonical arrays may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(array);
                    }
                    return node.array;
                case null:
                case Object.prototype:
                    if (this.known.has(value)) return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [
                        proto_1
                    ];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function(key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    // Objects are looked up in the Trie by their prototype (which
                    // is *not* recursively canonicalized), followed by a JSON
                    // representation of their (sorted) keys, followed by the
                    // sequence of recursively canonicalized values corresponding to
                    // those keys. To keep the final results unambiguous with other
                    // sequences (such as arrays that just happen to contain [proto,
                    // keys.json, value1, value2, ...]), the known version of the
                    // object is stored as node.object.
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function(key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        // Since canonical objects may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(obj_1);
                    }
                    return node.object;
            }
        }
        return value;
    };
    // It's worthwhile to cache the sorting of arrays of strings, since the
    // same initial unsorted arrays tend to be encountered many times.
    // Fortunately, we can reuse the Trie machinery to look up the sorted
    // arrays in linear time (which is faster than sorting large arrays).
    ObjectCanon.prototype.sortedKeys = function(obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) this.keysByJSON.set(json, node.keys = {
                sorted: keys,
                json: json
            });
        }
        return node.keys;
    };
    return ObjectCanon;
}();


function $612e16f6f135f03f$var$execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        // We split out this property so we can pass different values
        // independently without modifying options.context itself.
        options.context.canonizeResults
    ];
}
var $612e16f6f135f03f$export$628ef07ba8965f12 = /** @class */ function() {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new ((0, $9865fa0c1163b711$export$772fbc04a0ad4ce9) ? WeakMap : Map)();
        this.config = (0, $9017e689666d6554$export$8e16b83750b44988)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: (0, $c918a5b399d12c45$export$3ac2a95fbd99c479)(config)
        });
        this.canon = config.canon || new (0, $2579b2ae3c8726cf$export$c2e7fdd82233f4a4)();
        // memoized functions in this class will be "garbage-collected"
        // by recreating the whole `StoreReader` in
        // `InMemoryCache.resetResultsCache`
        // (triggered from `InMemoryCache.gc` with `resetResultCache: true`)
        this.executeSelectionSet = (0, $c16b91c3e0ba14ea$export$4997ffc0176396a6)(function(options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = $612e16f6f135f03f$var$execSelectionSetKeyArgs(options);
            // Negate this boolean option so we can find out if we've already read
            // this result using the other boolean value.
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) return (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, other), {
                    // If we previously read this result without canonizing it, we can
                    // reuse that result simply by canonizing it now.
                    result: _this.canon.admit(other.result)
                });
                // If we previously read this result with canonization enabled, we can
                // return that canonized result as-is.
                return other;
            }
            (0, $f18c94e51849b8c5$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            // Finally, if we didn't find any useful previous results, run the real
            // execSelectionSetImpl method with the given options.
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $e8270474df1c6a9d$export$f29926b23b28936b)["inMemoryCache.executeSelectionSet"] || 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
            keyArgs: $612e16f6f135f03f$var$execSelectionSetKeyArgs,
            // Note that the parameters of makeCacheKey are determined by the
            // array returned by keyArgs.
            makeCacheKey: function(selectionSet, parent, context, canonizeResults) {
                if ((0, $f18c94e51849b8c5$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(selectionSet, (0, $4ab7359740364a58$export$fa99cac1c0883c47)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
            }
        });
        this.executeSubSelectedArray = (0, $c16b91c3e0ba14ea$export$4997ffc0176396a6)(function(options) {
            (0, $f18c94e51849b8c5$export$f8068a30967ddc18)(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $e8270474df1c6a9d$export$f29926b23b28936b)["inMemoryCache.executeSubSelectedArray"] || 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ ,
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if ((0, $f18c94e51849b8c5$export$488c0743feab3d61)(context.store)) return context.store.makeCacheKey(field, array, context.varString);
            }
        });
    }
    StoreReader.prototype.resetCanon = function() {
        this.canon = new (0, $2579b2ae3c8726cf$export$c2e7fdd82233f4a4)();
    };
    /**
     * Given a store and a query, return as much of the result as possible and
     * identify if any data was missing from the store.
     */ StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? "ROOT_QUERY" : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, (0, $d34613b28fb40239$export$84c19026e616569e)((0, $d34613b28fb40239$export$d96b2213c1b9d3a9)(query))), variables);
        var rootRef = (0, $4ab7359740364a58$export$634ae0e932e9be99)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0, $d34613b28fb40239$export$f431198736b7f96d)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0, $e2e041e4a1657497$export$18ce0697a983be9b)({
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: (0, $78b40fbe7ce5625c$export$88a0ad9b6f961b51)(variables),
                canonizeResults: canonizeResults
            }, (0, $c918a5b399d12c45$export$3a33c00f0ae4a480)(query, this.config.fragments))
        });
        var missing;
        if (execResult.missing) {
            // For backwards compatibility we still report an array of
            // MissingFieldError objects, even though there will only ever be at most
            // one of them, now that all missing field error messages are grouped
            // together in the execResult.missing tree.
            missing = [
                new (0, $12b16d800985d695$export$257c68286583b0f9)($612e16f6f135f03f$var$firstMissing(execResult.missing), execResult.missing, query, variables)
            ];
            if (!returnPartialData) throw missing[0];
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing
        };
    };
    StoreReader.prototype.isFresh = function(result, parent, selectionSet, context) {
        if ((0, $f18c94e51849b8c5$export$488c0743feab3d61)(context.store) && this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, // If result is canonical, then it could only have been previously
            // cached by the canonizing version of executeSelectionSet, so we can
            // avoid checking both possibilities here.
            this.canon.isKnown(result));
            if (latest && result === latest.result) return true;
        }
        return false;
    };
    // Uncached version of executeSelectionSet.
    StoreReader.prototype.execSelectionSetImpl = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0, $4ab7359740364a58$export$fa99cac1c0883c47)(objectOrReference) && !context.policies.rootTypenamesById[objectOrReference.__ref] && !context.store.has(objectOrReference.__ref)) return {
            result: this.canon.empty,
            missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object")
        };
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new (0, $f042fd543798b697$export$509e11c221f576c0)();
        if (this.config.addTypename && typeof typename === "string" && !policies.rootIdsByTypename[typename]) // Ensure we always include a default value for the __typename
        // field, if we have one, and this.config.addTypename is true. Note
        // that this field can be overridden by other merged objects.
        objectsToMerge.push({
            __typename: typename
        });
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function(selection) {
            var _a, _b;
            // Omit fields with directives @skip(if: <truthy value>) or
            // @include(if: <falsy value>).
            if (!(0, $d474a5d9bfbef507$export$3dc388a5f013b4a5)(selection, variables)) return;
            if ((0, $4ab7359740364a58$export$fb56ad75dd311c12)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference
                }, context);
                var resultName = (0, $4ab7359740364a58$export$7d1ad22471852218)(selection);
                if (fieldValue === void 0) {
                    if (!(0, $99a4544cb26a0024$export$43b332f87950a467).added(selection)) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0, $4ab7359740364a58$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref + " object" : "object " + JSON.stringify(objectOrReference, null, 2)), _a));
                } else if ((0, $93b6d5db950815ab$export$43bee75e5e14138e)(fieldValue)) {
                    if (fieldValue.length > 0) fieldValue = handleMissing(_this.executeSubSelectedArray({
                        field: selection,
                        array: fieldValue,
                        enclosingRef: enclosingRef,
                        context: context
                    }), resultName);
                } else if (!selection.selectionSet) // If the field does not have a selection set, then we handle it
                // as a scalar value. To keep this.canon from canonicalizing
                // this value, we use this.canon.pass to wrap fieldValue in a
                // Pass object that this.canon.admit will later unwrap as-is.
                {
                    if (context.canonizeResults) fieldValue = _this.canon.pass(fieldValue);
                } else if (fieldValue != null) // In this case, because we know the field has a selection set,
                // it must be trying to query a GraphQLObjectType, which is why
                // fieldValue must be != null.
                fieldValue = handleMissing(_this.executeSelectionSet({
                    selectionSet: selection.selectionSet,
                    objectOrReference: fieldValue,
                    enclosingRef: (0, $4ab7359740364a58$export$fa99cac1c0883c47)(fieldValue) ? fieldValue : enclosingRef,
                    context: context
                }), resultName);
                if (fieldValue !== void 0) objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
            } else {
                var fragment = (0, $73d0a56999265e6c$export$f80bdb85f299186)(selection, context.lookupFragment);
                if (!fragment && selection.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw (0, $57583217334b5278$export$3991762405098ea)(9, selection.name.value);
                if (fragment && policies.fragmentMatches(fragment, typename)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        var result = (0, $f042fd543798b697$export$160070228be94b08)(objectsToMerge);
        var finalResult = {
            result: result,
            missing: missing
        };
        var frozen = context.canonizeResults ? this.canon.admit(finalResult) : (0, $7d98bd712ac3042c$export$7f9c177735b71f18)(finalResult);
        // Store this result with its selection set so that we can quickly
        // recognize it again in the StoreReader#isFresh method.
        if (frozen.result) this.knownResults.set(frozen.result, selectionSet);
        return frozen;
    };
    // Uncached version of executeSubSelectedArray.
    StoreReader.prototype.execSubSelectedArrayImpl = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new (0, $f042fd543798b697$export$509e11c221f576c0)();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            return childResult.result;
        }
        if (field.selectionSet) array = array.filter(context.store.canRead);
        array = array.map(function(item, i) {
            // null value in array
            if (item === null) return null;
            // This is a nested array, recurse
            if ((0, $93b6d5db950815ab$export$43bee75e5e14138e)(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                enclosingRef: enclosingRef,
                context: context
            }), i);
            // This is an object, run the selection set on it
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                objectOrReference: item,
                enclosingRef: (0, $4ab7359740364a58$export$fa99cac1c0883c47)(item) ? item : enclosingRef,
                context: context
            }), i);
            if (globalThis.__DEV__ !== false) $612e16f6f135f03f$var$assertSelectionSetForIdValue(context.store, field, item);
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $612e16f6f135f03f$var$firstMissing(tree) {
    try {
        JSON.stringify(tree, function(_, value) {
            if (typeof value === "string") throw value;
            return value;
        });
    } catch (result) {
        return result;
    }
}
function $612e16f6f135f03f$var$assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([
            fieldValue
        ]);
        workSet_1.forEach(function(value) {
            if ((0, $a5b286f532530da9$export$417207af72fad9c9)(value)) {
                (0, $57583217334b5278$export$f5708dca728d7177)(!(0, $4ab7359740364a58$export$fa99cac1c0883c47)(value), 10, (0, $c918a5b399d12c45$export$fdef206c83ff2c09)(store, value), field.name.value);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}

















// Mapping from JSON-encoded KeySpecifier strings to associated information.
var $bf5188fb46ed31f0$var$specifierInfoCache = Object.create(null);
function $bf5188fb46ed31f0$var$lookupSpecifierInfo(spec) {
    // It's safe to encode KeySpecifier arrays with JSON.stringify, since they're
    // just arrays of strings or nested KeySpecifier arrays, and the order of the
    // array elements is important (and suitably preserved by JSON.stringify).
    var cacheKey = JSON.stringify(spec);
    return $bf5188fb46ed31f0$var$specifierInfoCache[cacheKey] || ($bf5188fb46ed31f0$var$specifierInfoCache[cacheKey] = Object.create(null));
}
function $bf5188fb46ed31f0$export$f1953a0407594d2c(specifier) {
    var info = $bf5188fb46ed31f0$var$lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function(object, context) {
        var extract = function(from, key) {
            return context.readField(key, from);
        };
        var keyObject = context.keyObject = $bf5188fb46ed31f0$export$2db31da99613c21f(specifier, function(schemaKeyPath) {
            var extracted = $bf5188fb46ed31f0$export$e8f64f7a025887d3(context.storeObject, schemaKeyPath, // Using context.readField to extract paths from context.storeObject
            // allows the extraction to see through Reference objects and respect
            // custom read functions.
            extract);
            if (extracted === void 0 && object !== context.storeObject && (0, $c918a5b399d12c45$export$b5a638e9b3fff9f3).call(object, schemaKeyPath[0])) // If context.storeObject fails to provide a value for the requested
            // path, fall back to the raw result object, if it has a top-level key
            // matching the first key in the path (schemaKeyPath[0]). This allows
            // key fields included in the written data to be saved in the cache
            // even if they are not selected explicitly in context.selectionSet.
            // Not being mentioned by context.selectionSet is convenient here,
            // since it means these extra fields cannot be affected by field
            // aliasing, which is why we can use extractKey instead of
            // context.readField for this extraction.
            extracted = $bf5188fb46ed31f0$export$e8f64f7a025887d3(object, schemaKeyPath, $bf5188fb46ed31f0$var$extractKey);
            (0, $57583217334b5278$export$f5708dca728d7177)(extracted !== void 0, 4, schemaKeyPath.join("."), object);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function $bf5188fb46ed31f0$export$550737ee0cc371ac(specifier) {
    var info = $bf5188fb46ed31f0$var$lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function(args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = $bf5188fb46ed31f0$export$2db31da99613c21f(specifier, function(keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0, $93b6d5db950815ab$export$d307f5934e447d0e)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    // If the directive appears multiple times, only the first
                    // occurrence's arguments will be used. TODO Allow repetition?
                    // TODO Cache this work somehow, a la aliasMap?
                    var d = field.directives.find(function(d) {
                        return d.name.value === directiveName_1;
                    });
                    // Fortunately argumentsObjectFromField works for DirectiveNode!
                    var directiveArgs = d && (0, $4ab7359740364a58$export$3f5a60fb6a781b4f)(d, variables);
                    // For directives without arguments (d defined, but directiveArgs ===
                    // null), the presence or absence of the directive still counts as
                    // part of the field key, so we return null in those cases. If no
                    // directive with this name was found for this field (d undefined and
                    // thus directiveArgs undefined), we return undefined, which causes
                    // this value to be omitted from the key object returned by
                    // collectSpecifierPaths.
                    return directiveArgs && $bf5188fb46ed31f0$export$e8f64f7a025887d3(directiveArgs, // If keyPath.length === 1, this code calls extractKeyPath with an
                    // empty path, which works because it uses directiveArgs as the
                    // extracted value.
                    keyPath.slice(1));
                }
                // If the key started with @ but there was no corresponding directive,
                // we want to omit this value from the key object, not fall through to
                // treating @whatever as a normal argument name.
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && (0, $c918a5b399d12c45$export$b5a638e9b3fff9f3).call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return $bf5188fb46ed31f0$export$e8f64f7a025887d3(variables, varKeyPath);
                }
                // If the key started with $ but there was no corresponding variable, we
                // want to omit this value from the key object, not fall through to
                // treating $whatever as a normal argument name.
                return;
            }
            if (args) return $bf5188fb46ed31f0$export$e8f64f7a025887d3(args, keyPath);
        });
        var suffix = JSON.stringify(collected);
        // If no arguments were passed to this field, and it didn't have any other
        // field key contributions from directives or variables, hide the empty
        // :{} suffix from the field key. However, a field passed no arguments can
        // still end up with a non-empty :{...} suffix if its key configuration
        // refers to directives or variables.
        if (args || suffix !== "{}") fieldName += ":" + suffix;
        return fieldName;
    });
}
function $bf5188fb46ed31f0$export$2db31da99613c21f(specifier, extractor) {
    // For each path specified by specifier, invoke the extractor, and repeatedly
    // merge the results together, with appropriate ancestor context.
    var merger = new (0, $f042fd543798b697$export$509e11c221f576c0)();
    return $bf5188fb46ed31f0$export$eca459f173e85801(specifier).reduce(function(collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            // This path is not expected to contain array indexes, so the toMerge
            // reconstruction will not contain arrays. TODO Fix this?
            for(var i = path.length - 1; i >= 0; --i)toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function $bf5188fb46ed31f0$export$eca459f173e85801(spec) {
    var info = $bf5188fb46ed31f0$var$lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function(s, i) {
            if ((0, $93b6d5db950815ab$export$43bee75e5e14138e)(s)) {
                $bf5188fb46ed31f0$export$eca459f173e85801(s).forEach(function(p) {
                    return paths_1.push(currentPath_1.concat(p));
                });
                currentPath_1.length = 0;
            } else {
                currentPath_1.push(s);
                if (!(0, $93b6d5db950815ab$export$43bee75e5e14138e)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function $bf5188fb46ed31f0$var$extractKey(object, key) {
    return object[key];
}
function $bf5188fb46ed31f0$export$e8f64f7a025887d3(object, path, extract) {
    // For each key in path, extract the corresponding child property from obj,
    // flattening arrays if encountered (uncommon for keyFields and keyArgs, but
    // possible). The final result of path.reduce is normalized so unexpected leaf
    // objects have their keys safely sorted. That final result is difficult to
    // type as anything other than any. You're welcome to try to improve the
    // return type, but keep in mind extractKeyPath is not a public function
    // (exported only for testing), so the effort may not be worthwhile unless the
    // limited set of actual callers (see above) pass arguments that TypeScript
    // can statically type. If we know only that path is some array of strings
    // (and not, say, a specific tuple of statically known strings), any (or
    // possibly unknown) is the honest answer.
    extract = extract || $bf5188fb46ed31f0$var$extractKey;
    return $bf5188fb46ed31f0$var$normalize(path.reduce(function reducer(obj, key) {
        return (0, $93b6d5db950815ab$export$43bee75e5e14138e)(obj) ? obj.map(function(child) {
            return reducer(child, key);
        }) : obj && extract(obj, key);
    }, object));
}
function $bf5188fb46ed31f0$var$normalize(value) {
    // Usually the extracted value will be a scalar value, since most primary
    // key fields are scalar, but just in case we get an object or an array, we
    // need to do some normalization of the order of (nested) keys.
    if ((0, $a5b286f532530da9$export$417207af72fad9c9)(value)) {
        if ((0, $93b6d5db950815ab$export$43bee75e5e14138e)(value)) return value.map($bf5188fb46ed31f0$var$normalize);
        return $bf5188fb46ed31f0$export$2db31da99613c21f(Object.keys(value).sort(), function(path) {
            return $bf5188fb46ed31f0$export$e8f64f7a025887d3(value, path);
        });
    }
    return value;
}


function $5ac3cc847b730799$var$argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args : spec.field ? (0, $4ab7359740364a58$export$3f5a60fb6a781b4f)(spec.field, spec.variables) : null;
}
var $5ac3cc847b730799$var$nullKeyFieldsFn = function() {
    return void 0;
};
var $5ac3cc847b730799$var$simpleKeyArgsFn = function(_args, context) {
    return context.fieldName;
};
// These merge functions can be selected by specifying merge:true or
// merge:false in a field policy.
var $5ac3cc847b730799$var$mergeTrueFn = function(existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var $5ac3cc847b730799$var$mergeFalseFn = function(_, incoming) {
    return incoming;
};
var $5ac3cc847b730799$export$e9859ad90648930b = /** @class */ function() {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        // Map from subtype names to sets of supertype names. Note that this
        // representation inverts the structure of possibleTypes (whose keys are
        // supertypes and whose values are arrays of subtypes) because it tends
        // to be much more efficient to search upwards than downwards.
        this.supertypeMap = new Map();
        // Any fuzzy subtypes specified by possibleTypes will be converted to
        // RegExp objects and recorded here. Every key of this map can also be
        // found in supertypeMap. In many cases this Map will be empty, which
        // means no fuzzy subtype checking will happen in fragmentMatches.
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0, $e2e041e4a1657497$export$18ce0697a983be9b)({
            dataIdFromObject: (0, $c918a5b399d12c45$export$bd03c5a9c99d6bce)
        }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) this.addPossibleTypes(config.possibleTypes);
        if (config.typePolicies) this.addTypePolicies(config.typePolicies);
    }
    Policies.prototype.identify = function(object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename || ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        // It should be possible to write root Query fields with writeFragment,
        // using { __typename: "Query", ... } as the data, but it does not make
        // sense to allow the same identification behavior for the Mutation and
        // Subscription types, since application code should never be writing
        // directly to (or reading directly from) those root objects.
        if (typename === this.rootTypenamesById.ROOT_QUERY) return [
            "ROOT_QUERY"
        ];
        // Default context.storeObject to object if not otherwise provided.
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, partialContext), {
            typename: typename,
            storeObject: storeObject,
            readField: partialContext && partialContext.readField || function() {
                var options = $5ac3cc847b730799$export$1ad7a877581bdf2e(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables
                });
            }
        });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while(keyFn){
            var specifierOrId = keyFn((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, object), storeObject), context);
            if ((0, $93b6d5db950815ab$export$43bee75e5e14138e)(specifierOrId)) keyFn = (0, $bf5188fb46ed31f0$export$f1953a0407594d2c)(specifierOrId);
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [
            id,
            context.keyObject
        ] : [
            id
        ];
    };
    Policies.prototype.addTypePolicies = function(typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function(typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0, $e2e041e4a1657497$export$3c9a16f847548506)(_a, [
                "queryType",
                "mutationType",
                "subscriptionType"
            ]);
            // Though {query,mutation,subscription}Type configurations are rare,
            // it's important to call setRootTypename as early as possible,
            // since these configurations should apply consistently for the
            // entire lifetime of the cache. Also, since only one __typename can
            // qualify as one of these root types, these three properties cannot
            // be inherited, unlike the rest of the incoming properties. That
            // restriction is convenient, because the purpose of this.toBeAdded
            // is to delay the processing of type/field policies until the first
            // time they're used, allowing policies to be added in any order as
            // long as all relevant policies (including policies for supertypes)
            // have been added by the time a given policy is used for the first
            // time. In other words, since inheritance doesn't matter for these
            // properties, there's also no need to delay their processing using
            // the this.toBeAdded queue.
            if (queryType) _this.setRootTypename("Query", typename);
            if (mutationType) _this.setRootTypename("Mutation", typename);
            if (subscriptionType) _this.setRootTypename("Subscription", typename);
            if ((0, $c918a5b399d12c45$export$b5a638e9b3fff9f3).call(_this.toBeAdded, typename)) _this.toBeAdded[typename].push(incoming);
            else _this.toBeAdded[typename] = [
                incoming
            ];
        });
    };
    Policies.prototype.updateTypePolicy = function(typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge = typeof merge === "function" ? merge : merge === true ? $5ac3cc847b730799$var$mergeTrueFn : merge === false ? $5ac3cc847b730799$var$mergeFalseFn : existing.merge;
        }
        // Type policies can define merge functions, as an alternative to
        // using field policies to merge child objects.
        setMerge(existing, incoming.merge);
        existing.keyFn = // Pass false to disable normalization for this typename.
        keyFields === false ? $5ac3cc847b730799$var$nullKeyFieldsFn : (0, $93b6d5db950815ab$export$43bee75e5e14138e)(keyFields) ? (0, $bf5188fb46ed31f0$export$f1953a0407594d2c)(keyFields) : typeof keyFields === "function" ? keyFields : existing.keyFn;
        if (fields) Object.keys(fields).forEach(function(fieldName) {
            var existing = _this.getFieldPolicy(typename, fieldName, true);
            var incoming = fields[fieldName];
            if (typeof incoming === "function") existing.read = incoming;
            else {
                var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                existing.keyFn = // Pass false to disable argument-based differentiation of
                // field identities.
                keyArgs === false ? $5ac3cc847b730799$var$simpleKeyArgsFn : (0, $93b6d5db950815ab$export$43bee75e5e14138e)(keyArgs) ? (0, $bf5188fb46ed31f0$export$550737ee0cc371ac)(keyArgs) : typeof keyArgs === "function" ? keyArgs : existing.keyFn;
                if (typeof read === "function") existing.read = read;
                setMerge(existing, merge);
            }
            if (existing.read && existing.merge) // If we have both a read and a merge function, assume
            // keyArgs:false, because read and merge together can take
            // responsibility for interpreting arguments in and out. This
            // default assumption can always be overridden by specifying
            // keyArgs explicitly in the FieldPolicy.
            existing.keyFn = existing.keyFn || $5ac3cc847b730799$var$simpleKeyArgsFn;
        });
    };
    Policies.prototype.setRootTypename = function(which, typename) {
        if (typename === void 0) typename = which;
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            (0, $57583217334b5278$export$f5708dca728d7177)(!old || old === which, 5, which);
            // First, delete any old __typename associated with this rootId from
            // rootIdsByTypename.
            if (old) delete this.rootIdsByTypename[old];
            // Now make this the only __typename that maps to this rootId.
            this.rootIdsByTypename[typename] = rootId;
            // Finally, update the __typename associated with this rootId.
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function(possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function(supertype) {
            // Make sure all types have an entry in this.supertypeMap, even if
            // their supertype set is empty, so we can return false immediately
            // from policies.fragmentMatches for unknown supertypes.
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function(subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match((0, $c918a5b399d12c45$export$6ed54d4784f1ce28));
                if (!match || match[0] !== subtype) // TODO Don't interpret just any invalid typename as a RegExp.
                _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
            });
        });
    };
    Policies.prototype.getTypePolicy = function(typename) {
        var _this = this;
        if (!(0, $c918a5b399d12c45$export$b5a638e9b3fff9f3).call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            // When the TypePolicy for typename is first accessed, instead of
            // starting with an empty policy object, inherit any properties or
            // fields from the type policies of the supertypes of typename.
            //
            // Any properties or fields defined explicitly within the TypePolicy
            // for typename will take precedence, and if there are multiple
            // supertypes, the properties of policies whose types were added
            // later via addPossibleTypes will take precedence over those of
            // earlier supertypes. TODO Perhaps we should warn about these
            // conflicts in development, and recommend defining the property
            // explicitly in the subtype policy?
            //
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            //
            // Once the TypePolicy for typename has been accessed, its properties can
            // still be updated directly using addTypePolicies, but future changes to
            // inherited supertype policies will not be reflected in this subtype
            // policy, because this code runs at most once per typename.
            var supertypes_1 = this.supertypeMap.get(typename);
            if (!supertypes_1 && this.fuzzySubtypes.size) {
                // To make the inheritance logic work for unknown typename strings that
                // may have fuzzy supertypes, we give this typename an empty supertype
                // set and then populate it with any fuzzy supertypes that match.
                supertypes_1 = this.getSupertypeSet(typename, true);
                // This only works for typenames that are directly matched by a fuzzy
                // supertype. What if there is an intermediate chain of supertypes?
                // While possible, that situation can only be solved effectively by
                // specifying the intermediate relationships via possibleTypes, manually
                // and in a non-fuzzy way.
                this.fuzzySubtypes.forEach(function(regExp, fuzzy) {
                    if (regExp.test(typename)) {
                        // The fuzzy parameter is just the original string version of regExp
                        // (not a valid __typename string), but we can look up the
                        // associated supertype(s) in this.supertypeMap.
                        var fuzzySupertypes = _this.supertypeMap.get(fuzzy);
                        if (fuzzySupertypes) fuzzySupertypes.forEach(function(supertype) {
                            return supertypes_1.add(supertype);
                        });
                    }
                });
            }
            if (supertypes_1 && supertypes_1.size) supertypes_1.forEach(function(supertype) {
                var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0, $e2e041e4a1657497$export$3c9a16f847548506)(_a, [
                    "fields"
                ]);
                Object.assign(policy_1, rest);
                Object.assign(policy_1.fields, fields);
            });
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) // Merge the pending policies into this.typePolicies, in the order they
        // were originally passed to addTypePolicy.
        inbox.splice(0).forEach(function(policy) {
            _this.updateTypePolicy(typename, policy);
        });
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function(typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || createIfMissing && (fieldPolicies[fieldName] = Object.create(null));
        }
    };
    Policies.prototype.getSupertypeSet = function(subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) this.supertypeMap.set(subtype, supertypeSet = new Set());
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function(fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition) return true;
        // If the fragment has a type condition but the object we're matching
        // against does not have a __typename, the fragment cannot match.
        if (!typename) return false;
        var supertype = fragment.typeCondition.name.value;
        // Common case: fragment type condition and __typename are the same.
        if (typename === supertype) return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [
                typenameSupertypeSet
            ];
            var maybeEnqueue_1 = function(subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet && supertypeSet.size && workQueue_1.indexOf(supertypeSet) < 0) workQueue_1.push(supertypeSet);
            };
            // We need to check fuzzy subtypes only if we encountered fuzzy
            // subtype strings in addPossibleTypes, and only while writing to
            // the cache, since that's when selectionSetMatchesResult gives a
            // strong signal of fragment matching. The StoreReader class calls
            // policies.fragmentMatches without passing a result object, so
            // needToCheckFuzzySubtypes is always false while reading.
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            // It's important to keep evaluating workQueue.length each time through
            // the loop, because the queue can grow while we're iterating over it.
            for(var i = 0; i < workQueue_1.length; ++i){
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).warn(6, typename, supertype);
                        // Record positive results for faster future lookup.
                        // Unfortunately, we cannot safely cache negative results,
                        // because new possibleTypes data could always be added to the
                        // Policies class.
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes && // Start checking fuzzy subtypes only after exhausting all
                // non-fuzzy subtypes (after the final iteration of the loop).
                i === workQueue_1.length - 1 && // We could wait to compare fragment.selectionSet to result
                // after we verify the supertype, but this check is often less
                // expensive than that search, and we will have to do the
                // comparison anyway whenever we find a potential match.
                (0, $c918a5b399d12c45$export$60bd1cbb09c1a4a2)(fragment.selectionSet, result, variables)) {
                    // We don't always need to check fuzzy subtypes (if no result
                    // was provided, or !this.fuzzySubtypes.size), but, when we do,
                    // we only want to check them once.
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    // If we find any fuzzy subtypes that match typename, extend the
                    // workQueue to search through the supertypes of those fuzzy
                    // subtypes. Otherwise the for-loop will terminate and we'll
                    // return false below.
                    this.fuzzySubtypes.forEach(function(regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) maybeEnqueue_1(fuzzyString);
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function(fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables
            };
            var args = $5ac3cc847b730799$var$argsFromFieldSpecifier(fieldSpec);
            while(keyFn){
                var specifierOrString = keyFn(args, context);
                if ((0, $93b6d5db950815ab$export$43bee75e5e14138e)(specifierOrString)) keyFn = (0, $bf5188fb46ed31f0$export$550737ee0cc371ac)(specifierOrString);
                else {
                    // If the custom keyFn returns a falsy value, fall back to
                    // fieldName instead.
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) storeFieldName = fieldSpec.field ? (0, $4ab7359740364a58$export$54be8689c65f3b56)(fieldSpec.field, fieldSpec.variables) : (0, $4ab7359740364a58$export$3cdb6c178b88cabe)(fieldName, $5ac3cc847b730799$var$argsFromFieldSpecifier(fieldSpec));
        // Returning false from a keyArgs function is like configuring
        // keyArgs: false, but more dynamic.
        if (storeFieldName === false) return fieldName;
        // Make sure custom field names start with the actual field.name.value
        // of the field, so we can always figure out which properties of a
        // StoreObject correspond to which original field names.
        return fieldName === (0, $c918a5b399d12c45$export$37874422037b6029)(storeFieldName) ? storeFieldName : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function(options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference) return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField) return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename) options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0, $c918a5b399d12c45$export$37874422037b6029)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = $5ac3cc847b730799$var$makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0, $4ab7359740364a58$export$fa99cac1c0883c47)(objectOrReference) ? objectOrReference.__ref : objectOrReference, storeFieldName));
            // Call read(existing, readOptions) with cacheSlot holding this.cache.
            return (0, $207419bb6b29c4ef$export$ac9723609f5c76c2).withValue(this.cache, read, [
                existing,
                readOptions
            ]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function(parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function(existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === $5ac3cc847b730799$var$mergeTrueFn) // Instead of going to the trouble of creating a full
        // FieldFunctionOptions object and calling mergeTrueFn, we can
        // simply call mergeObjects, as mergeTrueFn would.
        return $5ac3cc847b730799$var$makeMergeObjectsFunction(context.store)(existing, incoming);
        if (merge === $5ac3cc847b730799$var$mergeFalseFn) // Likewise for mergeFalseFn, whose implementation is even simpler.
        return incoming;
        // If cache.writeQuery or cache.writeFragment was called with
        // options.overwrite set to true, we still call merge functions, but
        // the existing data is always undefined, so the merge function will
        // not attempt to combine the incoming data with the existing data.
        if (context.overwrite) existing = void 0;
        return merge(existing, incoming, $5ac3cc847b730799$var$makeFieldFunctionOptions(this, // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables
        }, context, storage || Object.create(null)));
    };
    return Policies;
}();
function $5ac3cc847b730799$var$makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0, $c918a5b399d12c45$export$37874422037b6029)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: $5ac3cc847b730799$var$argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: (0, $4ab7359740364a58$export$fa99cac1c0883c47),
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function() {
            return policies.readField($5ac3cc847b730799$export$1ad7a877581bdf2e(arguments, objectOrReference, variables), context);
        },
        mergeObjects: $5ac3cc847b730799$var$makeMergeObjectsFunction(context.store)
    };
}
function $5ac3cc847b730799$export$1ad7a877581bdf2e(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") options = {
        fieldName: fieldNameOrOptions,
        // Default to objectOrReference only when no second argument was
        // passed for the from parameter, not when undefined is explicitly
        // passed as the second argument.
        from: argc > 1 ? from : objectOrReference
    };
    else {
        options = (0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, fieldNameOrOptions);
        // Default to objectOrReference only when fieldNameOrOptions.from is
        // actually omitted, rather than just undefined.
        if (!(0, $c918a5b399d12c45$export$b5a638e9b3fff9f3).call(options, "from")) options.from = objectOrReference;
    }
    if (globalThis.__DEV__ !== false && options.from === void 0) globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).warn(7, (0, $c638aef376fe9021$export$f341b4883239463f)(Array.from(readFieldArgs)));
    if (void 0 === options.variables) options.variables = variables;
    return options;
}
function $5ac3cc847b730799$var$makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0, $93b6d5db950815ab$export$43bee75e5e14138e)(existing) || (0, $93b6d5db950815ab$export$43bee75e5e14138e)(incoming)) throw (0, $57583217334b5278$export$3991762405098ea)(8);
        // These dynamic checks are necessary because the parameters of a
        // custom merge function can easily have the any type, so the type
        // system cannot always enforce the StoreObject | Reference parameter
        // types of options.mergeObjects.
        if ((0, $a5b286f532530da9$export$417207af72fad9c9)(existing) && (0, $a5b286f532530da9$export$417207af72fad9c9)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) return incoming;
            if ((0, $4ab7359740364a58$export$fa99cac1c0883c47)(existing) && (0, $c918a5b399d12c45$export$4f39afca21bd938e)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // existing.__ref, preferring/overwriting any fields contributed by the
                // newer incoming StoreObject.
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0, $c918a5b399d12c45$export$4f39afca21bd938e)(existing) && (0, $4ab7359740364a58$export$fa99cac1c0883c47)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // incoming.__ref, taking fields from the older existing object only if
                // those fields are not already present in the newer StoreObject
                // identified by incoming.__ref.
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0, $c918a5b399d12c45$export$4f39afca21bd938e)(existing) && (0, $c918a5b399d12c45$export$4f39afca21bd938e)(incoming)) return (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, existing), incoming);
        }
        return incoming;
    };
}


// Since there are only four possible combinations of context.clientOnly and
// context.deferred values, we should need at most four "flavors" of any given
// WriteContext. To avoid creating multiple copies of the same context, we cache
// the contexts in the context.flavors Map (shared by all flavors) according to
// their clientOnly and deferred values (always in that order).
function $a635f3591bba39bb$var$getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) context.flavors.set(key, flavored = context.clientOnly === clientOnly && context.deferred === deferred ? context : (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, context), {
        clientOnly: clientOnly,
        deferred: deferred
    }));
    return flavored;
}
var $a635f3591bba39bb$export$eb8361c5d132fb8f = /** @class */ function() {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function(store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0, $d34613b28fb40239$export$7a5b1fa979d2c158)(query);
        var merger = (0, $c918a5b399d12c45$export$b874a818f7a2fa6d)();
        variables = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, (0, $d34613b28fb40239$export$84c19026e616569e)(operationDefinition)), variables);
        var context = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({
            store: store,
            written: Object.create(null),
            merge: function(existing, incoming) {
                return merger.merge(existing, incoming);
            },
            variables: variables,
            varString: (0, $78b40fbe7ce5625c$export$88a0ad9b6f961b51)(variables)
        }, (0, $c918a5b399d12c45$export$3a33c00f0ae4a480)(query, this.fragments)), {
            overwrite: !!overwrite,
            incomingById: new Map(),
            clientOnly: false,
            deferred: false,
            flavors: new Map()
        });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: {
                map: new Map()
            },
            context: context
        });
        if (!(0, $4ab7359740364a58$export$fa99cac1c0883c47)(ref)) throw (0, $57583217334b5278$export$3991762405098ea)(11, result);
        // So far, the store has not been modified, so now it's time to process
        // context.incomingById and merge those incoming fields into context.store.
        context.incomingById.forEach(function(_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0, $4ab7359740364a58$export$634ae0e932e9be99)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0, $4ab7359740364a58$export$fa99cac1c0883c47)(applied)) // Assume References returned by applyMerges have already been merged
                // into the store. See makeMergeObjectsFunction in policies.ts for an
                // example of how this can happen.
                return;
                // Otherwise, applyMerges returned a StoreObject, whose fields we should
                // merge into the store (see store.merge statement below).
                storeObject = applied;
            }
            if (globalThis.__DEV__ !== false && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function(field) {
                    if (field.selectionSet) fieldsWithSelectionSets_1[field.name.value] = true;
                });
                var hasSelectionSet_1 = function(storeFieldName) {
                    return fieldsWithSelectionSets_1[(0, $c918a5b399d12c45$export$37874422037b6029)(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function(storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function(storeFieldName) {
                    // If a merge function was defined for this field, trust that it
                    // did the right thing about (not) clobbering data. If the field
                    // has no selection set, it's a scalar field, so it doesn't need
                    // a merge function (even if it's an object, like JSON data).
                    if (hasSelectionSet_1(storeFieldName) && !hasMergeFunction_1(storeFieldName)) $a635f3591bba39bb$var$warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                });
            }
            store.merge(dataId, storeObject);
        });
        // Any IDs written explicitly to the cache will be retained as
        // reachable root IDs for garbage collection purposes. Although this
        // logic includes root IDs like ROOT_QUERY and ROOT_MUTATION, their
        // retainment counts are effectively ignored because cache.gc() always
        // includes them in its root ID set.
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function(_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, // This object allows processSelectionSet to report useful information
        // to its callers without explicitly returning that information.
        mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        // This variable will be repeatedly updated using context.merge to
        // accumulate all fields that need to be written into the store.
        var incoming = Object.create(null);
        // If typename was not passed in, infer it. Note that typename is
        // always passed in for tricky-to-infer cases such as "Query" for
        // ROOT_QUERY.
        var typename = dataId && policies.rootTypenamesById[dataId] || (0, $4ab7359740364a58$export$cf7bf7e4f289cc26)(result, selectionSet, context.fragmentMap) || dataId && context.store.get(dataId, "__typename");
        if ("string" === typeof typename) incoming.__typename = typename;
        // This readField function will be passed as context.readField in the
        // KeyFieldsContext object created within policies.identify (called below).
        // In addition to reading from the existing context.store (thanks to the
        // policies.readField(options, context) line at the very bottom), this
        // version of readField can read from Reference objects that are currently
        // pending in context.incomingById, which is important whenever keyFields
        // need to be extracted from a child object that processSelectionSet has
        // turned into a Reference.
        var readField = function() {
            var options = (0, $5ac3cc847b730799$export$1ad7a877581bdf2e)(arguments, incoming, context.variables);
            if ((0, $4ab7359740364a58$export$fa99cac1c0883c47)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options), {
                        from: info.storeObject
                    }), context);
                    if (result_1 !== void 0) return result_1;
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        context, typename).forEach(function(context, field) {
            var _a;
            var resultFieldKey = (0, $4ab7359740364a58$export$7d1ad22471852218)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables
                });
                var childTree = $a635f3591bba39bb$var$getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, // Reset context.clientOnly and context.deferred to their default
                // values before processing nested selection sets.
                field.selectionSet ? $a635f3591bba39bb$var$getContextFlavor(context, false, false) : context, childTree);
                // To determine if this field holds a child object with a merge function
                // defined in its type policy (see PR #7070), we need to figure out the
                // child object's __typename.
                var childTypename = void 0;
                // The field's value can be an object that has a __typename only if the
                // field has a selection set. Otherwise incomingValue is scalar.
                if (field.selectionSet && ((0, $4ab7359740364a58$export$fa99cac1c0883c47)(incomingValue) || (0, $c918a5b399d12c45$export$4f39afca21bd938e)(incomingValue))) childTypename = readField("__typename", incomingValue);
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) childTree.info = {
                    // TODO Check compatibility against any existing childTree.field?
                    field: field,
                    typename: typename,
                    merge: merge
                };
                else $a635f3591bba39bb$var$maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                incoming = context.merge(incoming, (_a = {}, _a[storeFieldName] = incomingValue, _a));
            } else if (globalThis.__DEV__ !== false && !context.clientOnly && !context.deferred && !(0, $99a4544cb26a0024$export$43b332f87950a467).added(field) && // If the field has a read function, it may be a synthetic field or
            // provide a default value, so its absence from the written data should
            // not be cause for alarm.
            !policies.getReadFunction(typename, field.name.value)) globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).error(12, (0, $4ab7359740364a58$export$7d1ad22471852218)(field), result);
        });
        // Identify the result object, even if dataId was already provided,
        // since we always need keyObject below.
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField
            }), id = _b[0], keyObject = _b[1];
            // If dataId was not provided, fall back to the id just generated by
            // policies.identify.
            dataId = dataId || id;
            // Write any key fields that were used during identification, even if
            // they were not mentioned in the original query.
            if (keyObject) // TODO Reverse the order of the arguments?
            incoming = context.merge(incoming, keyObject);
        } catch (e) {
            // If dataId was provided, tolerate failure of policies.identify.
            if (!dataId) throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0, $4ab7359740364a58$export$634ae0e932e9be99)(dataId);
            // Avoid processing the same entity object using the same selection
            // set more than once. We use an array instead of a Set since most
            // entity IDs will be written using only one selection set, so the
            // size of this array is likely to be very small, meaning indexOf is
            // likely to be faster than Set.prototype.has.
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0) return dataRef;
            sets.push(selectionSet);
            // If we're about to write a result object into the store, but we
            // happen to know that the exact same (===) result object would be
            // returned if we were to reread the result with the same inputs,
            // then we can skip the rest of the processSelectionSet work for
            // this object, and immediately return a Reference to it.
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) return dataRef;
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = $a635f3591bba39bb$var$mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function(field) {
                    return previous_1.fieldNodeSet.add(field);
                });
            } else context.incomingById.set(dataId, {
                storeObject: incoming,
                // Save a reference to mergeTree only if it is not empty, because
                // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
                // reused for entirely different parts of the result tree.
                mergeTree: $a635f3591bba39bb$var$mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                fieldNodeSet: fieldNodeSet
            });
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function(value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) // In development, we need to clone scalar values so that they can be
        // safely frozen with maybeDeepFreeze in readFromStore.ts. In production,
        // it's cheaper to store the scalar values directly in the cache.
        return globalThis.__DEV__ !== false ? (0, $3ee0e116c7dbafec$export$629a2bd3f5a49ecc)(value) : value;
        if ((0, $93b6d5db950815ab$export$43bee75e5e14138e)(value)) return value.map(function(item, i) {
            var value = _this.processFieldValue(item, field, context, $a635f3591bba39bb$var$getChildMergeTree(mergeTree, i));
            $a635f3591bba39bb$var$maybeRecycleChildMergeTree(mergeTree, i);
            return value;
        });
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree
        });
    };
    // Implements https://spec.graphql.org/draft/#sec-Field-Collection, but with
    // some additions for tracking @client and @defer directives.
    StoreWriter.prototype.flattenFields = function(selectionSet, result, context, typename) {
        if (typename === void 0) typename = (0, $4ab7359740364a58$export$cf7bf7e4f289cc26)(result, selectionSet, context.fragmentMap);
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new (0, $26d4e625bb2590d6$export$73571c50d0f2507e)(false); // No need for WeakMap, since limitingTrie does not escape.
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, // Because we take inheritedClientOnly and inheritedDeferred into
            // consideration here (in addition to selectionSet), it's possible for
            // the same selection set to be flattened more than once, if it appears
            // in the query with different @client and/or @directive configurations.
            inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited) return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function(selection) {
                if (!(0, $d474a5d9bfbef507$export$3dc388a5f013b4a5)(selection, context.variables)) return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (// Since the presence of @client or @defer on this field can only
                // cause clientOnly or deferred to become true, we can skip the
                // forEach loop if both clientOnly and deferred are already true.
                !(clientOnly && deferred) && (0, $93b6d5db950815ab$export$d307f5934e447d0e)(selection.directives)) selection.directives.forEach(function(dir) {
                    var name = dir.name.value;
                    if (name === "client") clientOnly = true;
                    if (name === "defer") {
                        var args = (0, $4ab7359740364a58$export$3f5a60fb6a781b4f)(dir, context.variables);
                        // The @defer directive takes an optional args.if boolean
                        // argument, similar to @include(if: boolean). Note that
                        // @defer(if: false) does not make context.deferred false, but
                        // instead behaves as if there was no @defer directive.
                        if (!args || args.if !== false) deferred = true;
                    // TODO In the future, we may want to record args.label using
                    // context.deferred, if a label is specified.
                    }
                });
                if ((0, $4ab7359740364a58$export$fb56ad75dd311c12)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        // If this field has been visited along another recursive path
                        // before, the final context should have clientOnly or deferred set
                        // to true only if *all* paths have the directive (hence the &&).
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, $a635f3591bba39bb$var$getContextFlavor(context, clientOnly, deferred));
                } else {
                    var fragment = (0, $73d0a56999265e6c$export$f80bdb85f299186)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === (0, $addc2f9aaa51cfa5$export$a84bdc57c5122798).FRAGMENT_SPREAD) throw (0, $57583217334b5278$export$3991762405098ea)(13, selection.name.value);
                    if (fragment && policies.fragmentMatches(fragment, typename, result, context.variables)) flatten(fragment.selectionSet, $a635f3591bba39bb$var$getContextFlavor(context, clientOnly, deferred));
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function(mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0, $4ab7359740364a58$export$fa99cac1c0883c47)(incoming)) {
            var e_1 = // Items in the same position in different arrays are not
            // necessarily related to each other, so when incoming is an array
            // we process its elements as if there was no existing data.
            !(0, $93b6d5db950815ab$export$43bee75e5e14138e)(incoming) && // Likewise, existing must be either a Reference or a StoreObject
            // in order for its fields to be safe to merge with the fields of
            // the incoming object.
            ((0, $4ab7359740364a58$export$fa99cac1c0883c47)(existing) || (0, $c918a5b399d12c45$export$4f39afca21bd938e)(existing)) ? existing : void 0;
            // This narrowing is implied by mergeTree.map.size > 0 and
            // !isReference(incoming), though TypeScript understandably cannot
            // hope to infer this type.
            var i_1 = incoming;
            // The options.storage objects provided to read and merge functions
            // are derived from the identity of the parent object plus a
            // sequence of storeFieldName strings/numbers identifying the nested
            // field name path of each field value to be merged.
            if (e_1 && !getStorageArgs) getStorageArgs = [
                (0, $4ab7359740364a58$export$fa99cac1c0883c47)(e_1) ? e_1.__ref : e_1
            ];
            // It's possible that applying merge functions to this subtree will
            // not change the incoming data, so this variable tracks the fields
            // that did change, so we can create a new incoming object when (and
            // only when) at least one incoming field has changed. We use a Map
            // to preserve the type of numeric keys.
            var changedFields_1;
            var getValue_1 = function(from, name) {
                return (0, $93b6d5db950815ab$export$43bee75e5e14138e)(from) ? typeof name === "number" ? from[name] : void 0 : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function(childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                // If we have no incoming data, leave any existing data untouched.
                if (void 0 === iVal) return;
                if (getStorageArgs) getStorageArgs.push(storeFieldName);
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map();
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) (0, $57583217334b5278$export$f5708dca728d7177)(getStorageArgs.pop() === storeFieldName);
            });
            if (changedFields_1) {
                // Shallow clone i so we can add changed fields to it.
                incoming = (0, $93b6d5db950815ab$export$43bee75e5e14138e)(i_1) ? i_1.slice(0) : (0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, i_1);
                changedFields_1.forEach(function(value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        return incoming;
    };
    return StoreWriter;
}();
var $a635f3591bba39bb$var$emptyMergeTreePool = [];
function $a635f3591bba39bb$var$getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) map.set(name, $a635f3591bba39bb$var$emptyMergeTreePool.pop() || {
        map: new Map()
    });
    return map.get(name);
}
function $a635f3591bba39bb$var$mergeMergeTrees(left, right) {
    if (left === right || !right || $a635f3591bba39bb$var$mergeTreeIsEmpty(right)) return left;
    if (!left || $a635f3591bba39bb$var$mergeTreeIsEmpty(left)) return right;
    var info = left.info && right.info ? (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map() : left.map.size ? left.map : right.map;
    var merged = {
        info: info,
        map: map
    };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function(leftTree, key) {
            merged.map.set(key, $a635f3591bba39bb$var$mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function(key) {
            merged.map.set(key, $a635f3591bba39bb$var$mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function $a635f3591bba39bb$var$mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function $a635f3591bba39bb$var$maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && $a635f3591bba39bb$var$mergeTreeIsEmpty(childTree)) {
        $a635f3591bba39bb$var$emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var $a635f3591bba39bb$var$warnings = new Set();
// Note that this function is unused in production, and thus should be
// pruned by any well-configured minifier.
function $a635f3591bba39bb$var$warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function(objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing) return;
    var incoming = getChild(incomingObj);
    if (!incoming) return;
    // It's always safe to replace a reference, since it refers to data
    // safely stored elsewhere.
    if ((0, $4ab7359740364a58$export$fa99cac1c0883c47)(existing)) return;
    // If the values are structurally equivalent, we do not need to worry
    // about incoming replacing existing.
    if ((0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(existing, incoming)) return;
    // If we're replacing every key of the existing object, then the
    // existing data would be overwritten even if the objects were
    // normalized, so warning would not be helpful here.
    if (Object.keys(existing).every(function(key) {
        return store.getFieldValue(incoming, key) !== void 0;
    })) return;
    var parentType = store.getFieldValue(existingRef, "__typename") || store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0, $c918a5b399d12c45$export$37874422037b6029)(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    // Avoid warning more than once for the same type and field name.
    if ($a635f3591bba39bb$var$warnings.has(typeDotName)) return;
    $a635f3591bba39bb$var$warnings.add(typeDotName);
    var childTypenames = [];
    // Arrays do not have __typename fields, and always need a custom merge
    // function, even if their elements are normalized entities.
    if (!(0, $93b6d5db950815ab$export$43bee75e5e14138e)(existing) && !(0, $93b6d5db950815ab$export$43bee75e5e14138e)(incoming)) [
        existing,
        incoming
    ].forEach(function(child) {
        var typename = store.getFieldValue(child, "__typename");
        if (typeof typename === "string" && !childTypenames.includes(typename)) childTypenames.push(typename);
    });
    globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).warn(14, fieldName, parentType, childTypenames.length ? "either ensure all objects of type " + childTypenames.join(" and ") + " have an ID or a custom merge function, or " : "", typeDotName, existing, incoming);
}







var $cf23e64ed83cc0a3$export$467265324939f47f = /** @class */ function(_super) {
    (0, $e2e041e4a1657497$export$a8ba968b8961cb8a)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.addTypenameTransform = new (0, $bbdf4b1635f5cf2f$export$f887060e48e5dc1b)((0, $99a4544cb26a0024$export$43b332f87950a467));
        // Override the default value, since InMemoryCache result objects are frozen
        // in development and expected to remain logically immutable in production.
        _this.assumeImmutableResults = true;
        _this.makeVar = (0, $207419bb6b29c4ef$export$5345c8ac69b4a9db);
        _this.txCount = 0;
        _this.config = (0, $c918a5b399d12c45$export$fa542f9ee3f7f4e2)(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new (0, $5ac3cc847b730799$export$e9859ad90648930b)({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function() {
        // Passing { resultCaching: false } in the InMemoryCache constructor options
        // will completely disable dependency tracking, which will improve memory
        // usage but worsen the performance of repeated reads.
        var rootStore = this.data = new (0, $f18c94e51849b8c5$export$cb507f57054c7321).Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching
        });
        // When no optimistic writes are currently active, cache.optimisticData ===
        // cache.data, so there are no additional layers on top of the actual data.
        // When an optimistic update happens, this.optimisticData will become a
        // linked list of EntityStore Layer objects that terminates with the
        // original this.data cache object.
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function(resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        // The StoreWriter is mostly stateless and so doesn't really need to be
        // reset, but it does need to have its writer.storeReader reference updated,
        // so it's simpler to update this.storeWriter as well.
        this.storeWriter = new (0, $a635f3591bba39bb$export$eb8361c5d132fb8f)(this, this.storeReader = new (0, $612e16f6f135f03f$export$628ef07ba8965f12)({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: (0, $c918a5b399d12c45$export$3ac2a95fbd99c479)(this.config),
            canon: resetResultIdentities ? void 0 : previousReader && previousReader.canon,
            fragments: fragments
        }), fragments);
        this.maybeBroadcastWatch = (0, $c16b91c3e0ba14ea$export$4997ffc0176396a6)(function(c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $e8270474df1c6a9d$export$f29926b23b28936b)["inMemoryCache.maybeBroadcastWatch"] || 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
            makeCacheKey: function(c) {
                // Return a cache key (thus enabling result caching) only if we're
                // currently using a data store that can track cache dependencies.
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if ((0, $f18c94e51849b8c5$export$488c0743feab3d61)(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, // Different watches can have the same query, optimistic
                    // status, rootId, and variables, but if their callbacks are
                    // different, the (identical) result needs to be delivered to
                    // each distinct callback. The easiest way to achieve that
                    // separation is to include c.callback in the cache key for
                    // maybeBroadcastWatch calls. See issue #5733.
                    c.callback, (0, $78b40fbe7ce5625c$export$88a0ad9b6f961b51)({
                        optimistic: optimistic,
                        id: id,
                        variables: variables
                    }));
                }
            }
        });
        // Since we have thrown away all the cached functions that depend on the
        // CacheGroup dependencies maintained by EntityStore, we should also reset
        // all CacheGroup dependency information.
        new Set([
            this.data.group,
            this.optimisticData.group
        ]).forEach(function(group) {
            return group.resetCaching();
        });
    };
    InMemoryCache.prototype.restore = function(data) {
        this.init();
        // Since calling this.init() discards/replaces the entire StoreReader, along
        // with the result caches it maintains, this.data.replace(data) won't have
        // to bother deleting the old data.
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function(options) {
        var // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        _a = options.returnPartialData, // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options), {
                store: options.optimistic ? this.optimisticData : this.data,
                config: this.config,
                returnPartialData: returnPartialData
            })).result || null;
        } catch (e) {
            if (e instanceof (0, $12b16d800985d695$export$257c68286583b0f9)) // Swallow MissingFieldError and return null, so callers do not need to
            // worry about catching "normal" exceptions resulting from incomplete
            // cache data. Unexpected errors will be re-thrown. If you need more
            // information about which fields were missing, use cache.diff instead,
            // and examine diffResult.missing.
            return null;
            throw e;
        }
    };
    InMemoryCache.prototype.write = function(options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.modify = function(options) {
        if ((0, $c918a5b399d12c45$export$b5a638e9b3fff9f3).call(options, "id") && !options.id) // To my knowledge, TypeScript does not currently provide a way to
        // enforce that an optional property?:type must *not* be undefined
        // when present. That ability would be useful here, because we want
        // options.id to default to ROOT_QUERY only when no options.id was
        // provided. If the caller attempts to pass options.id with a
        // falsy/undefined value (perhaps because cache.identify failed), we
        // should not assume the goal was to modify the ROOT_QUERY object.
        // We could throw, but it seems natural to return false to indicate
        // that nothing was modified.
        return false;
        var store = options.optimistic // Defaults to false.
         ? this.optimisticData : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.diff = function(options) {
        return this.storeReader.diffQueryAgainstStore((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options), {
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            config: this.config
        }));
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        if (!this.watches.size) // In case we previously called forgetCache(this) because
        // this.watches became empty (see below), reattach this cache to any
        // reactive variables on which it previously depended. It might seem
        // paradoxical that we're able to recall something we supposedly
        // forgot, but the point of calling forgetCache(this) is to silence
        // useless broadcasts while this.watches is empty, and to allow the
        // cache to be garbage collected. If, however, we manage to call
        // recallCache(this) here, this cache object must not have been
        // garbage collected yet, and should resume receiving updates from
        // reactive variables, now that it has a watcher to notify.
        (0, $207419bb6b29c4ef$export$f342bdd61b3e9412)(this);
        this.watches.add(watch);
        if (watch.immediate) this.maybeBroadcastWatch(watch);
        return function() {
            // Once we remove the last watch from this.watches, cache.broadcastWatches
            // no longer does anything, so we preemptively tell the reactive variable
            // system to exclude this cache from future broadcasts.
            if (_this.watches.delete(watch) && !_this.watches.size) (0, $207419bb6b29c4ef$export$cbe12faed7725318)(_this);
            // Remove this watch from the LRU cache managed by the
            // maybeBroadcastWatch OptimisticWrapperFunction, to prevent memory
            // leaks involving the closure of watch.callback.
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function(options) {
        var _a;
        (0, $78b40fbe7ce5625c$export$88a0ad9b6f961b51).reset();
        (0, $faf63d297e5a9103$export$c2d084dc44961371).reset();
        this.addTypenameTransform.resetCache();
        (_a = this.config.fragments) === null || _a === void 0 || _a.resetCaches();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) this.resetResultCache(options.resetResultIdentities);
            else if (options.resetResultIdentities) this.storeReader.resetCanon();
        }
        return ids;
    };
    // Call this method to ensure the given root ID remains in the cache after
    // garbage collection, along with its transitive child entities. Note that
    // the cache automatically retains all directly written entities. By default,
    // the retainment persists after optimistic updates are removed. Pass true
    // for the optimistic argument if you would prefer for the retainment to be
    // discarded when the top-most optimistic layer is removed. Returns the
    // resulting (non-negative) retainment count.
    InMemoryCache.prototype.retain = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    // Call this method to undo the effect of the retain method, above. Once the
    // retainment count falls to zero, the given ID will no longer be preserved
    // during garbage collection, though it may still be preserved by other safe
    // entities that refer to it. Returns the resulting (non-negative) retainment
    // count, in case that's useful.
    InMemoryCache.prototype.release = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    // Returns the canonical ID for a given StoreObject, obeying typePolicies
    // and keyFields (and dataIdFromObject, if you still use that). At minimum,
    // the object must contain a __typename and any primary key fields required
    // to identify entities of that type. If you pass a query result object, be
    // sure that none of the primary key fields have been renamed by aliasing.
    // If you pass a Reference object, its __ref ID string will be returned.
    InMemoryCache.prototype.identify = function(object) {
        if ((0, $4ab7359740364a58$export$fa99cac1c0883c47)(object)) return object.__ref;
        try {
            return this.policies.identify(object)[0];
        } catch (e) {
            globalThis.__DEV__ !== false && (0, $57583217334b5278$export$f5708dca728d7177).warn(e);
        }
    };
    InMemoryCache.prototype.evict = function(options) {
        if (!options.id) {
            if ((0, $c918a5b399d12c45$export$b5a638e9b3fff9f3).call(options, "id")) // See comment in modify method about why we return false when
            // options.id exists but is falsy/undefined.
            return false;
            options = (0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options), {
                id: "ROOT_QUERY"
            });
        }
        try {
            // It's unlikely that the eviction will end up invoking any other
            // cache update operations while it's running, but {in,de}crementing
            // this.txCount still seems like a good idea, for uniformity with
            // the other update methods.
            ++this.txCount;
            // Pass this.data as a limit on the depth of the eviction, so evictions
            // during optimistic updates (when this.data is temporarily set equal to
            // this.optimisticData) do not escape their optimistic Layer.
            return this.optimisticData.evict(options, this.data);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.reset = function(options) {
        var _this = this;
        this.init();
        (0, $78b40fbe7ce5625c$export$88a0ad9b6f961b51).reset();
        if (options && options.discardWatches) {
            // Similar to what happens in the unsubscribe function returned by
            // cache.watch, applied to all current watches.
            this.watches.forEach(function(watch) {
                return _this.maybeBroadcastWatch.forget(watch);
            });
            this.watches.clear();
            (0, $207419bb6b29c4ef$export$cbe12faed7725318)(this);
        } else // Calling this.init() above unblocks all maybeBroadcastWatch caching, so
        // this.broadcastWatches() triggers a broadcast to every current watcher
        // (letting them know their data is now missing). This default behavior is
        // convenient because it means the watches do not have to be manually
        // reestablished after resetting the cache. To prevent this broadcast and
        // cancel all watches, pass true for options.discardWatches.
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function(options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function(layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) _this.data = _this.optimisticData = layer;
            try {
                return updateResult = update(_this);
            } finally{
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) // If an options.onWatchUpdated callback is provided, we want to call it
        // with only the Cache.WatchOptions objects affected by options.update,
        // but there might be dirty watchers already waiting to be broadcast that
        // have nothing to do with the update. To prevent including those watchers
        // in the post-update broadcast, we perform this initial broadcast to
        // collect the dirty watchers, so we can re-dirty them later, after the
        // post-update broadcast, allowing them to receive their pending
        // broadcasts the next time broadcastWatches is called, just as they would
        // if we never called cache.batch.
        this.broadcastWatches((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options), {
            onWatchUpdated: function(watch) {
                alreadyDirty.add(watch);
                return false;
            }
        }));
        if (typeof optimistic === "string") // Note that there can be multiple layers with the same optimistic ID.
        // When removeOptimistic(id) is called for that id, all matching layers
        // will be removed, and the remaining layers will be reapplied.
        this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        else if (optimistic === false) // Ensure both this.data and this.optimisticData refer to the root
        // (non-optimistic) layer of the cache during the update. Note that
        // this.data could be a Layer if we are currently executing an optimistic
        // update function, but otherwise will always be an EntityStore.Root
        // instance.
        perform(this.data);
        else // Otherwise, leave this.data and this.optimisticData unchanged and run
        // the update with broadcast batching.
        perform();
        if (typeof removeOptimistic === "string") this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        // Note: if this.txCount > 0, then alreadyDirty.size === 0, so this code
        // takes the else branch and calls this.broadcastWatches(options), which
        // does nothing when this.txCount > 0.
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0, $e2e041e4a1657497$export$18ce0697a983be9b)((0, $e2e041e4a1657497$export$18ce0697a983be9b)({}, options), {
                onWatchUpdated: function(watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) // Since onWatchUpdated did not return false, this diff is
                    // about to be broadcast to watch.callback, so we don't need
                    // to re-dirty it with the other alreadyDirty watches below.
                    alreadyDirty.delete(watch);
                    return result;
                }
            }));
            // Silently re-dirty any watches that were already dirty before the update
            // was performed, and were not broadcast just now.
            if (alreadyDirty.size) alreadyDirty.forEach(function(watch) {
                return _this.maybeBroadcastWatch.dirty(watch);
            });
        } else // If alreadyDirty is empty or we don't have an onWatchUpdated
        // function, we don't need to go to the trouble of wrapping
        // options.onWatchUpdated.
        this.broadcastWatches(options);
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function(update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || optimisticId !== null
        });
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        return this.addTypenameToDocument(this.addFragmentsToDocument(document));
    };
    InMemoryCache.prototype.broadcastWatches = function(options) {
        var _this = this;
        if (!this.txCount) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c, options);
        });
    };
    InMemoryCache.prototype.addFragmentsToDocument = function(document) {
        var fragments = this.config.fragments;
        return fragments ? fragments.transform(document) : document;
    };
    InMemoryCache.prototype.addTypenameToDocument = function(document) {
        if (this.addTypename) return this.addTypenameTransform.transformDocument(document);
        return document;
    };
    // This method is wrapped by maybeBroadcastWatch, which is called by
    // broadcastWatches, so that we compute and broadcast results only when
    // the data that would be broadcast might have changed. It would be
    // simpler to check for changes after recomputing a result but before
    // broadcasting it, but this wrapping approach allows us to skip both
    // the recomputation and the broadcast, in most cases.
    InMemoryCache.prototype.broadcastWatch = function(c, options) {
        var lastDiff = c.lastDiff;
        // Both WatchOptions and DiffOptions extend ReadOptions, and DiffOptions
        // currently requires no additional properties, so we can use c (a
        // WatchOptions object) as DiffOptions, without having to allocate a new
        // object, and without having to enumerate the relevant properties (query,
        // variables, etc.) explicitly. There will be some additional properties
        // (lastDiff, callback, etc.), but cache.diff ignores them.
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") diff.fromOptimisticTransaction = true;
            if (options.onWatchUpdated && options.onWatchUpdated.call(this, c, diff, lastDiff) === false) // Returning false from the onWatchUpdated callback will prevent
            // calling c.callback(diff) for this watcher.
            return;
        }
        if (!lastDiff || !(0, $9c119e23bb7e8c34$export$411ce8e5a71e3069)(lastDiff.result, diff.result)) c.callback(c.lastDiff = diff, lastDiff);
    };
    return InMemoryCache;
}((0, $e9895ec3a124ad39$export$5fc74f25506aa9c));
if (globalThis.__DEV__ !== false) $cf23e64ed83cc0a3$export$467265324939f47f.prototype.getMemoryInternals = (0, $19eefe0273f1ef83$export$e95a5a2210e62466);










const $ac9ae759d65dfe6e$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("apolloLinkAuthorization", "INFO");
const $ac9ae759d65dfe6e$export$a82e343618591b1a = new (0, $e7fcb7cc7e563d46$export$2fed3d61f740bc7f)((operation, forward)=>{
    $ac9ae759d65dfe6e$var$log.debug("Apollo link");
    const addAuthorizationHeaderToContext = (context)=>{
        $ac9ae759d65dfe6e$var$log.debug("addAuthorizationHeaderToContext");
        const authToken = (0, $316b346137ed644b$export$9280a247c7e168bf).get((0, $316b346137ed644b$export$88ddfc12b1bd970));
        if (authToken) {
            $ac9ae759d65dfe6e$var$log.debug("Setting Bearer (..) Authorization http header", authToken.substring(0, 20) + "...");
            return {
                ...context,
                headers: {
                    ...context.headers,
                    Authorization: `Bearer ${authToken}`
                }
            };
        } else return context;
    };
    const parseResponseCustomAuthorizationHeaders = ()=>{
        $ac9ae759d65dfe6e$var$log.debug("parseResponseCustomAuthorizationHeaders");
        const context = operation.getContext();
        const { response: response } = context;
        if (response) {
            const { headers: headers } = response;
            if (headers) {
                const authToken = headers.get("x-token");
                if (authToken) {
                    if (authToken === "x-remove") {
                        $ac9ae759d65dfe6e$var$log.info(`Found 'x-remove' x-token response header`);
                        (0, $316b346137ed644b$export$9280a247c7e168bf).remove((0, $316b346137ed644b$export$88ddfc12b1bd970));
                    } else {
                        $ac9ae759d65dfe6e$var$log.debug("Found x-token response header");
                        (0, $316b346137ed644b$export$9280a247c7e168bf).set((0, $316b346137ed644b$export$88ddfc12b1bd970), authToken);
                    }
                }
            }
        }
    };
    operation.setContext(addAuthorizationHeaderToContext);
    const fetchResultObservable = forward(operation);
    return new (0, $a68a73fcce1c801b$export$77cea355fa80b5f4)((observer)=>{
        fetchResultObservable.subscribe((observerOrNext)=>{
            $ac9ae759d65dfe6e$var$log.debug("Observable observerOrNext", observerOrNext);
            observer.next(observerOrNext);
        }, (error)=>{
            $ac9ae759d65dfe6e$var$log.error("Observable error", error);
            observer.error(error);
        }, ()=>{
            $ac9ae759d65dfe6e$var$log.debug("Observable complete");
            parseResponseCustomAuthorizationHeaders();
            observer.complete();
        });
    });
});





function $8b60f33bd58d6811$export$2288787135a8f66e(errorHandler) {
    return new (0, $e7fcb7cc7e563d46$export$2fed3d61f740bc7f)(function(operation, forward) {
        return new (0, $a68a73fcce1c801b$export$77cea355fa80b5f4)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            //Network errors can return GraphQL errors on for example a 403
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        // disable the previous sub from calling complete on observable
                        // if retry is in flight.
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $8b60f33bd58d6811$export$d2c8415987899609 = /** @class */ function(_super) {
    (0, $e2e041e4a1657497$export$a8ba968b8961cb8a)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $8b60f33bd58d6811$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $e7fcb7cc7e563d46$export$2fed3d61f740bc7f));






const $737c6eaef77c535c$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("apolloLinkError");
const $737c6eaef77c535c$export$7ce9ff9d1835c619 = (apolloLinkErrorContextRef)=>(0, $8b60f33bd58d6811$export$2288787135a8f66e)(({ operation: operation, response: response, graphQLErrors: graphQLErrors, networkError: networkError })=>{
        graphQLErrors?.forEach((error)=>{
            const domainModelError = (0, $f2c18736b4a6993b$export$9498e69f47ffab36)(error);
            if ($737c6eaef77c535c$var$whiteListError(domainModelError)) {
                $737c6eaef77c535c$var$log.info(`White listed GraphQL Error`, error);
                return;
            }
            // TODO: some connection errors come as GraphQL errors, but are not DomainModelError
            if (domainModelError && (!domainModelError.status || domainModelError.status >= 500)) {
                $737c6eaef77c535c$var$log.error(`[GraphQL DomainModelError status >= 500]`);
                apolloLinkErrorContextRef.current?.showErrorDialog({
                    title: `${domainModelError.status} ${domainModelError.statusText}`,
                    content: `[${domainModelError.name}]: ${domainModelError.message} - [${domainModelError.method?.toUpperCase()}] ${domainModelError.url}`
                });
            } else $737c6eaef77c535c$var$log.info(`[GraphQL error]`, error);
            apolloLinkErrorContextRef.current?.showErrorToast(error.message);
        });
        if (networkError) {
            if ((0, $f2c18736b4a6993b$export$a7cbe72d7c4012af)(networkError)) {
                const { detail: detail, message: message, statusCode: statusCode, error: error } = typeof networkError.result === "object" ? networkError.result : {
                    ...networkError,
                    error: ""
                };
                if (networkError.statusCode === 401) {
                    //  TODO: return 200 from graphql endpoint with graphql Unauthenticated error
                    $737c6eaef77c535c$var$log.warn(`Got 401 unauthorized response from GraphQL endpoint`, networkError);
                    (0, $316b346137ed644b$export$9280a247c7e168bf).remove((0, $316b346137ed644b$export$88ddfc12b1bd970));
                    if (!(0, $e9a95c61c800ecd2$export$972a8c628b02b444).includes(window.location.pathname)) apolloLinkErrorContextRef.current?.showUnauthenticatedDialog(message);
                } else if (networkError.statusCode === 403) {
                    //  TODO: return 200 from graphql endpoint with graphql Forbidden error
                    $737c6eaef77c535c$var$log.warn(`Got 403 unauthorized response from GraphQL endpoint`, networkError);
                    apolloLinkErrorContextRef.current?.showErrorDialog({
                        title: `Forbidden`,
                        content: message
                    });
                } else if (networkError.result) {
                    $737c6eaef77c535c$var$log.error(`[Network error]: `, networkError.result);
                    apolloLinkErrorContextRef.current?.showErrorDialog({
                        title: `${statusCode} ${error}`,
                        content: message
                    });
                }
            } else {
                $737c6eaef77c535c$var$log.error(`[Network error]: `, networkError);
                apolloLinkErrorContextRef.current?.showErrorDialog({
                    title: `Network error`,
                    content: networkError.message
                });
            }
        }
    });
const $737c6eaef77c535c$var$whiteListError = (e)=>{
    return e && e.code === "FIELD_NOT_FOUND" && e.entity === "Product" && e.field === "technical";
};





const $3b4b4bb7ef4211aa$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("apolloLinkSentry", "INFO");
const $3b4b4bb7ef4211aa$var$apolloLinkSentry = new (0, $e7fcb7cc7e563d46$export$2fed3d61f740bc7f)((operation, forward)=>{
    const { operationName: operationName, variables: variables } = operation;
    $3b4b4bb7ef4211aa$var$log.debug("GraphQL request", {
        operationName: operationName,
        variables: variables
    });
    (0, $f6a2cb476a1b1720$export$efda9a273d7a036d)({
        category: "GraphQL",
        type: "GraphQL",
        message: `GraphQL ${operationName} operation`,
        data: {
            operationName: operationName,
            variables: variables
        },
        level: (0, $f6a2cb476a1b1720$export$918a9776c0a3cf27).fromString("info")
    });
    return forward(operation);
});
var $3b4b4bb7ef4211aa$export$2e2bcd8739ae039 = $3b4b4bb7ef4211aa$var$apolloLinkSentry;


const $9f918928b09cb001$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("apollo/client", "INFO");
const { protocol: $9f918928b09cb001$var$protocol, hostname: $9f918928b09cb001$var$hostname, port: $9f918928b09cb001$var$port } = window.location;
$9f918928b09cb001$var$log.info({
    protocol: $9f918928b09cb001$var$protocol,
    hostname: $9f918928b09cb001$var$hostname,
    port: $9f918928b09cb001$var$port,
    isLocalhost: (0, $ce151254b700f66a$export$ec8a6426516240fc)()
});
const $9f918928b09cb001$var$createHttpLink = ()=>{
    return new (0, $dd7c24ed2c98b3d2$export$f4bbf1aec241cc1)({
        uri: (0, $f5d0c2a7498ff49b$exports.urlPaths).GRAPHQL,
        fetch: $9f918928b09cb001$var$fetchWithBrandId
    });
};
const $9f918928b09cb001$var$fetchWithBrandId = (uri, options)=>{
    const serializedbrandId = (0, $316b346137ed644b$export$9280a247c7e168bf).get("brandId");
    const brandId = serializedbrandId ? JSON.parse(serializedbrandId) : "";
    return fetch(`${uri}?brandId=${brandId}`, options);
};
const $9f918928b09cb001$export$67100df7b1079985 = (apolloLinkErrorContextRef)=>new (0, $5ebd77fa775a8993$export$13f5a5f0f1dbab88)({
        link: (0, $e7fcb7cc7e563d46$export$2fed3d61f740bc7f).from([
            (0, $737c6eaef77c535c$export$7ce9ff9d1835c619)(apolloLinkErrorContextRef),
            (0, $ac9ae759d65dfe6e$export$a82e343618591b1a),
            (0, $3b4b4bb7ef4211aa$export$2e2bcd8739ae039),
            $9f918928b09cb001$var$createHttpLink()
        ]),
        headers: {
            // TODO: ( replace AuthenticationLink) authorization: localStorage.getItem('token') || '',
            "client-name": "CPA Web",
            "client-version": (0, $23ce4363775f3dc0$exports.version)
        },
        cache: new (0, $cf23e64ed83cc0a3$export$467265324939f47f)(),
        connectToDevTools: true,
        defaultOptions: {
            watchQuery: {
                fetchPolicy: "cache-and-network"
            }
        }
    });




parcelRequire("fgmOP");




const $a8fc586e4bd2fa06$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("SettlementPrint");
const $a8fc586e4bd2fa06$export$fa7bae9f9de7712c = ()=>{
    const { customerId: customerId, settlementId: settlementId } = (0, $dfdceb7c36fce96f$export$99eaa27ddbbb95ef)();
    $a8fc586e4bd2fa06$var$log.debug("render", {
        customerId: customerId,
        settlementId: settlementId
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $c08555a029d66447$export$40a70d7fc5397651), {
                page: "settlement-print"
            }),
            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ede1d69ade64ddbb$export$e957498a727fb850), {
                settlementId: settlementId,
                customerId: customerId,
                pdf: true
            }),
            ";"
        ]
    });
};






var $fgmOP = parcelRequire("fgmOP");








const $905e5e4ff5c23551$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("FieldShowroom", "INFO");
const $905e5e4ff5c23551$var$multiOptions = [
    "Checkbox A",
    {
        id: "B",
        name: "Checkbox B"
    },
    "Checkbox C"
];
const $905e5e4ff5c23551$var$selectTextOptions = [
    "Option A",
    "Option B",
    "Option C"
];
const $905e5e4ff5c23551$var$selectIdNameOptions = [
    {
        id: "A",
        name: "Option A"
    },
    {
        id: "B",
        name: "Option B"
    },
    {
        id: "C",
        name: "Option C"
    }
];
const $905e5e4ff5c23551$export$bc3213cc76e29a43 = ()=>{
    const formStateOptions = {
        isEditing: false
    };
    const formState = (0, $f6ff28847e6675c5$export$606f11b2eb45ecc6)(formStateOptions);
    const { isEditing: isEditing, entity: entity, onEdit: onEdit, onCancel: onCancel, onChange: onChange, initialEntity: initialEntity } = formState;
    const [formCompact, setFormCompact] = (0, $fgmOP.useState)(true);
    const [showBothStates, setShowBothStates] = (0, $fgmOP.useState)(true);
    const [disabled, setDisabled] = (0, $fgmOP.useState)(false);
    const [showError, setShowError] = (0, $fgmOP.useState)(false);
    const [showTip, setShowTip] = (0, $fgmOP.useState)(false);
    const tip = showTip ? "Tip on how to use this field" : undefined;
    const error = showError ? "Some error in this field" : undefined;
    $905e5e4ff5c23551$var$log.debug("render", formState);
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $557d7e86a7a00a80$export$2e2bcd8739ae039), {
        size: "large",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
            "form--compact": formCompact
        }),
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3aab005a822ef6ff$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).Fragment, {
                children: [
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $db47bfc18c452fea$export$2e2bcd8739ae039), {
                        subtitle: "Testing Fields"
                    }),
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $2e4c8094e1930e9a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                                onChange: (value)=>setShowBothStates(!!value),
                                                value: showBothStates,
                                                label: "Show both states",
                                                // type={FieldTypes.checkbox}
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox,
                                                isEditing: true
                                            }),
                                            entity && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                                    // style={showBothStates ? {} : {border: '1px solid'}}
                                                    type: "button",
                                                    isDisabled: showBothStates,
                                                    kind: (0, $5121558ae6eef82f$export$2e2bcd8739ae039).kinds.primary,
                                                    text: isEditing ? "Editing" : "Displaying",
                                                    onClick: ()=>isEditing ? onCancel() : onEdit()
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                            onChange: ()=>setFormCompact(!formCompact),
                                            value: formCompact,
                                            label: "Compact form",
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox,
                                            isEditing: true
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                                onChange: ()=>setShowTip(!showTip),
                                                value: showTip,
                                                label: "Show tips",
                                                // type={FieldTypes.checkbox}
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox,
                                                isEditing: true
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                                onChange: ()=>setShowError(!showError),
                                                value: showError,
                                                label: "Show errors",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox,
                                                isEditing: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6efccc49777c4c3d$export$a455218a85c89869), {
                                            onChange: ()=>setDisabled(!disabled),
                                            value: disabled,
                                            label: "Disabled",
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox,
                                            isEditing: true
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    entity && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $2e4c8094e1930e9a$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h4", {
                                            style: {
                                                borderBottom: "2px solid #990ae3",
                                                color: "#990ae3"
                                            },
                                            children: "No defaults"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h4", {
                                            style: {
                                                borderBottom: "2px solid #990ae3",
                                                color: "#990ae3"
                                            },
                                            children: "With default value"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h4", {
                                                style: {
                                                    borderBottom: "2px solid #990ae3",
                                                    color: "#990ae3"
                                                },
                                                children: showBothStates || isEditing ? "Editing" : "Displaying"
                                            }),
                                            showBothStates && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h4", {
                                                style: {
                                                    borderBottom: "2px solid #990ae3",
                                                    color: "#990ae3"
                                                },
                                                children: "Displaying"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h4", {
                                                style: {
                                                    borderBottom: "2px solid #990ae3",
                                                    color: "#990ae3"
                                                },
                                                children: showBothStates || isEditing ? "Editing" : "Displaying"
                                            }),
                                            showBothStates && /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("h4", {
                                                style: {
                                                    borderBottom: "2px solid #990ae3",
                                                    color: "#990ae3"
                                                },
                                                children: "Displaying"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "text",
                                                label: "Text",
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "text",
                                                label: "Text",
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "text",
                                                label: "Text",
                                                defaultValue: "Default text",
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "text",
                                                label: "Text",
                                                defaultValue: "Default text",
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "number",
                                                label: "Number",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).number,
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "number",
                                                label: "Number",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).number,
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "number",
                                                label: "Number",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).number,
                                                defaultValue: "9999",
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "number",
                                                label: "Number",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).number,
                                                defaultValue: "9999",
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "currency",
                                                label: "Currency",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).currency,
                                                currencyCode: "NOK",
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "currency",
                                                label: "Currency",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).currency,
                                                currencyCode: "NOK",
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "currency",
                                                label: "Currency",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).currency,
                                                currencyCode: "NOK",
                                                defaultValue: "9999.99",
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "currency",
                                                label: "Currency",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).currency,
                                                currencyCode: "NOK",
                                                defaultValue: "9999.99",
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "startDate",
                                                label: "Date",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date,
                                                // defaultValue={'since ever'}tip={tip}
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "startDate",
                                                label: "Date",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date,
                                                // defaultValue={'since ever'}
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "startDate",
                                                label: "Date",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date,
                                                defaultValue: "since ever",
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "startDate",
                                                label: "Date",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).date,
                                                defaultValue: "since ever",
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "time",
                                                label: "Time",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).time,
                                                // defaultValue={'all day'}tip={tip}
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "time",
                                                label: "Time",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).time,
                                                // defaultValue={'all day'}
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "time",
                                                label: "Time",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).time,
                                                defaultValue: "all day",
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "time",
                                                label: "Time",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).time,
                                                defaultValue: "all day",
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "password",
                                                label: "Password",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).password,
                                                // defaultValue="some password"tip={tip}
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "password",
                                                label: "Password",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).password,
                                                // defaultValue="some password"
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "password",
                                                label: "Password",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).password,
                                                defaultValue: "some password",
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "password",
                                                label: "Password",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).password,
                                                defaultValue: "some password",
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "duration",
                                                label: "Duration",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).duration,
                                                // defaultValue="some duration"tip={tip}
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "duration",
                                                label: "Duration",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).duration,
                                                // defaultValue="some duration"
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "duration",
                                                label: "Duration",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).duration,
                                                defaultValue: "PT30S",
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "duration",
                                                label: "Duration",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).duration,
                                                defaultValue: "PT30S",
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "productType",
                                                label: "Select {id,name} opts",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                options: $905e5e4ff5c23551$var$selectIdNameOptions,
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "productType",
                                                label: "Select {id,name} opts",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                options: $905e5e4ff5c23551$var$selectIdNameOptions,
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "productType",
                                                label: "Select {id,name} opts",
                                                defaultValue: "Default",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                options: $905e5e4ff5c23551$var$selectIdNameOptions,
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "productType",
                                                label: "Select {id,name} opts",
                                                defaultValue: "Default",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                options: $905e5e4ff5c23551$var$selectIdNameOptions,
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "selectSimple",
                                                label: "Select 'text' options",
                                                // defaultValue={'Default'}
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                options: $905e5e4ff5c23551$var$selectTextOptions,
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "selectSimple",
                                                label: "Select 'text' options",
                                                // defaultValue={'Default'}
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                options: $905e5e4ff5c23551$var$selectTextOptions,
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "selectSimple",
                                                label: "Select 'text' options",
                                                defaultValue: "Default",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                options: $905e5e4ff5c23551$var$selectTextOptions,
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "selectSimple",
                                                label: "Select 'text' options",
                                                defaultValue: "Default",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                options: $905e5e4ff5c23551$var$selectTextOptions,
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "selectNullable",
                                                label: "Nullable Select",
                                                // defaultValue={'Default'}
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                options: $905e5e4ff5c23551$var$selectTextOptions,
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled,
                                                isNullable: true
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "selectNullable",
                                                label: "Nullable Select",
                                                // defaultValue={'Default'}
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                options: $905e5e4ff5c23551$var$selectTextOptions,
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled,
                                                isNullable: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "selectNullable",
                                                label: "Nullable Select",
                                                defaultValue: "Default",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                options: $905e5e4ff5c23551$var$selectTextOptions,
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled,
                                                isNullable: true
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "selectNullable",
                                                label: "Nullable Select",
                                                defaultValue: "Default",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).select,
                                                options: $905e5e4ff5c23551$var$selectTextOptions,
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled,
                                                isNullable: true
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                            formState: formState,
                                            entityFieldId: "checkbox",
                                            label: "Checkbox",
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox,
                                            isEditing: showBothStates || isEditing,
                                            error: error,
                                            tip: tip,
                                            isDisabled: disabled
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                hidden: !showBothStates
                                            }),
                                            formState: formState,
                                            entityFieldId: "checkbox",
                                            label: "Checkbox",
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).checkbox,
                                            isEditing: false,
                                            error: error,
                                            tip: tip,
                                            isDisabled: disabled
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                            formState: formState,
                                            entityFieldId: "multi",
                                            label: "Event Types",
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi,
                                            options: $905e5e4ff5c23551$var$multiOptions,
                                            isEditing: showBothStates || isEditing,
                                            error: error,
                                            tip: tip,
                                            isDisabled: disabled
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                hidden: !showBothStates
                                            }),
                                            formState: formState,
                                            entityFieldId: "multi",
                                            label: "Event Types",
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).multi,
                                            options: $905e5e4ff5c23551$var$multiOptions,
                                            isEditing: false,
                                            error: error,
                                            tip: tip,
                                            isDisabled: disabled
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                            formState: formState,
                                            entityFieldId: "element",
                                            label: "Element",
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).element,
                                            value: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                                    text: "Button in field",
                                                    isDisabled: disabled,
                                                    onClick: ()=>{}
                                                })
                                            }),
                                            isEditing: showBothStates || isEditing,
                                            error: error,
                                            tip: tip,
                                            isDisabled: disabled
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                            className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                hidden: !showBothStates
                                            }),
                                            formState: formState,
                                            entityFieldId: "element",
                                            label: "Element",
                                            type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).element,
                                            value: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("div", {
                                                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5121558ae6eef82f$export$2e2bcd8739ae039), {
                                                    text: "Button in field",
                                                    isDisabled: true,
                                                    onClick: ()=>{}
                                                })
                                            }),
                                            isEditing: false,
                                            error: error,
                                            tip: tip,
                                            isDisabled: disabled
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $bf812ce6eef3f2fe$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "textarea",
                                                label: "Text area",
                                                // defaultValue="Default text"
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).textarea,
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "textarea",
                                                label: "Text area",
                                                // defaultValue="Default text"
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).textarea,
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $6c2490027a2e159e$export$2e2bcd8739ae039), {
                                        children: [
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                formState: formState,
                                                entityFieldId: "textarea",
                                                label: "Text area",
                                                defaultValue: "Default text",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).textarea,
                                                isEditing: showBothStates || isEditing,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            }),
                                            /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $93299ac43cf6f4bc$export$8b5c44f37504e5c3), {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($1a525afc32e731fd$exports)))({
                                                    hidden: !showBothStates
                                                }),
                                                formState: formState,
                                                entityFieldId: "textarea",
                                                label: "Text area",
                                                defaultValue: "Default text",
                                                type: (0, $6efccc49777c4c3d$export$6c2fadcd8bf80d96).textarea,
                                                isEditing: false,
                                                error: error,
                                                tip: tip,
                                                isDisabled: disabled
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};




var $fgmOP = parcelRequire("fgmOP");





const $3b177b5489e37349$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("ApolloLinkError", "INFO");
const $3b177b5489e37349$export$c6000a2137482fc2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createRef();
const $3b177b5489e37349$export$dd19f63bab4f5e34 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).createContext({
    showUnauthenticatedDialog: (title)=>{
        $3b177b5489e37349$var$log.debug("showUnauthenticatedDialog", title);
    },
    showErrorDialog: ({ title: title, content: content })=>{
        $3b177b5489e37349$var$log.debug("showErrorDialog", title, content);
    },
    showErrorToast: (message)=>{
        $3b177b5489e37349$var$log.debug(message);
    }
});
const $3b177b5489e37349$export$edd61d20234f49b6 = (props)=>{
    const { pathname: pathname, search: search } = (0, $dfdceb7c36fce96f$export$45d76561a5302f2b)();
    const navigate = (0, $dfdceb7c36fce96f$export$9770f232ac06a008)();
    const redirectPath = encodeURIComponent(pathname + search);
    const { showModal: showModal } = (0, $3e050b9d09f8075d$export$33ffd74ebf07f060)();
    const apolloLinkErrorContext = {
        showUnauthenticatedDialog: (title)=>{
            showModal({
                show: true,
                name: "Unauthenticated",
                title: title,
                content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                    children: "You need valid credentials to access Telia Bulk Messaging Web. Please login."
                }),
                confirmText: "Login",
                onConfirm: ()=>navigate(`${$e9a95c61c800ecd2$export$eed606b4351295d7}?redirectPath=${redirectPath}`)
            });
        },
        showErrorDialog: ({ title: title, content: content })=>{
            showModal({
                show: true,
                name: "apolloLinkError",
                title: title ? title : "Notice",
                content: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)("p", {
                    children: content
                }),
                confirmText: "Reload",
                onConfirm: ()=>location.reload()
            });
        },
        showErrorToast: (message)=>(0, $4983ed7d9d06375d$export$b410431fab84fa58).error(message)
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($fgmOP))).useImperativeHandle($3b177b5489e37349$export$c6000a2137482fc2, ()=>apolloLinkErrorContext);
    $3b177b5489e37349$var$log.debug("render", {
        apolloLinkErrorContextRef: $3b177b5489e37349$export$c6000a2137482fc2
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $ba93bb4fdbad5ba0$exports.Fragment), {
        children: props.children
    });
};






const $20df424a2aa4893a$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("Root", "INFO");
const $20df424a2aa4893a$export$8594e949f6f25007 = (props)=>{
    $20df424a2aa4893a$var$log.debug("render", {
        apolloLinkErrorContextRef: $3b177b5489e37349$export$c6000a2137482fc2
    });
    return /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $5cd6b9f7c34c2e6c$export$c16b04c8a9956446), {
        client: (0, $9f918928b09cb001$export$67100df7b1079985)((0, $3b177b5489e37349$export$c6000a2137482fc2)),
        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $b5055c1b5d5fd445$export$1ac37773422302f2), {
            children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $9fb784f5d8b1fb75$export$9ba4e89fdfa1fc54), {
                children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $4ef4d658949bf0e9$export$88f24fd8fcfab6ca), {
                    children: // @ts-ignore
                    /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $08c2f3412ed8b9d6$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $37eb07f38f554cfb$export$178405afcd8c5eb), {
                            children: [
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $3b177b5489e37349$export$edd61d20234f49b6), {}),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $4983ed7d9d06375d$export$f2815235e76a62b9), {
                                    hideProgressBar: true,
                                    autoClose: 8000
                                }),
                                /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsxs)((0, $dfdceb7c36fce96f$export$3565eb3d00ca5a74), {
                                    children: [
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                            path: "/fieldshowroom",
                                            element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $905e5e4ff5c23551$export$bc3213cc76e29a43), {})
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                            path: $e9a95c61c800ecd2$export$aca1887b2f6340cd,
                                            element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $a8fc586e4bd2fa06$export$fa7bae9f9de7712c), {})
                                        }),
                                        /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $dfdceb7c36fce96f$export$e7b0ac011bb776c6), {
                                            path: "*",
                                            element: /*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $f549842215bcb7a8$export$a46e88afcd7e1319), {})
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};






var $5fdae19e1117f068$export$882461b6382ed46c;
var $5fdae19e1117f068$export$757ceba2d55c277e;
"use strict";

var $5fdae19e1117f068$var$i;
$5fdae19e1117f068$export$882461b6382ed46c = $91d813eb41c8c85f$exports.createRoot;
$5fdae19e1117f068$export$757ceba2d55c277e = $91d813eb41c8c85f$exports.hydrateRoot;


const $77fd8bbc7bb18121$var$log = (0, $899042a575f441f5$export$29ce6c7518aa120)("index", "INFO");
0, $f5d0c2a7498ff49b$exports.utils;
(0, $316b346137ed644b$export$9280a247c7e168bf).init();
const $77fd8bbc7bb18121$var$sentryConfig = (0, $f6a2cb476a1b1720$export$f5ae3c4820871661)();
$77fd8bbc7bb18121$var$sentryConfig ? $77fd8bbc7bb18121$var$log.info("Initialized Sentry", $77fd8bbc7bb18121$var$sentryConfig) : $77fd8bbc7bb18121$var$log.info("Skipping Sentry initialization");
const $77fd8bbc7bb18121$var$render = (rootElement)=>(0, $5fdae19e1117f068$export$882461b6382ed46c)(document.getElementById("reactAppRootContainer")).render(rootElement);
$77fd8bbc7bb18121$var$render(/*#__PURE__*/ (0, $ba93bb4fdbad5ba0$exports.jsx)((0, $20df424a2aa4893a$export$8594e949f6f25007), {}));
if (null) null.accept(); //  Hot Module Replacement (HMR) for ParcelJs 2


//# sourceMappingURL=index.4c23147d.js.map
